
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49e2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49e2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3rK5c", function(module, exports) {
module.exports = new URL("marker-icon-2x.160d643f.png", import.meta.url).toString();

});

parcelRegister("5mw4y", function(module, exports) {
module.exports = new URL("marker-icon.3f7d3721.png", import.meta.url).toString();

});

parcelRegister("cKmJk", function(module, exports) {
module.exports = new URL("marker-shadow.8f26ed1f.png", import.meta.url).toString();

});

var $65d191346d2f0e85$exports = {};
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory($65d191346d2f0e85$exports);
})($65d191346d2f0e85$exports, function(exports1) {
    "use strict";
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!("_leaflet_id" in obj)) obj["_leaflet_id"] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, "options")) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + "=" + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf("?") === -1 ? "?" : "&") + params.join("&");
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error("No value provided for variable " + str);
            else if (typeof value === "function") value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window["webkit" + name] || window["moz" + name] || window["ms" + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed("RequestAnimationFrame") || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed("CancelAnimationFrame") || getPrefixed("CancelRequestAnimationFrame") || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== "prototype" && i !== "__super__") NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === "function" ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === "undefined" || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === "object") for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== "function") {
                console.warn("wrong listener type: " + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== "string") console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== "function") {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === "object") for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return "Point(" + formatNum(this.x) + ", " + formatNum(this.y) + ")";
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === "object" && "x" in x && "y" in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === "number" || "x" in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === "number" || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === "number" || obj instanceof LatLng || "lat" in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(",");
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error("Invalid LatLng object: (" + lat + ", " + lng + ")");
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return "LatLng(" + formatNum(this.lat, precision) + ", " + formatNum(this.lng, precision) + ")";
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== "object") {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === "object" && "lat" in a) return new LatLng(a.lat, "lng" in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: "EPSG:3857",
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: "EPSG:900913"
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS("http://www.w3.org/2000/svg", name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = "", i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? "L" : "M") + p.x + " " + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? "z" : "x" : "";
        }
        // SVG complains about empty path strings
        return str || "M0 0";
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = "ActiveXObject" in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = "msLaunchUri" in navigator && !("documentMode" in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains("webkit");
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains("android");
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains("android 2") || userAgentContains("android 3");
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains("Google") && webkitVer < 537 && !("AudioNode" in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains("chrome");
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains("gecko") && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains("safari");
    var phantom = userAgentContains("phantom");
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = "OTransition" in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf("Win") === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && "transition" in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = "MozPerspective" in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== "undefined" || userAgentContains("mobile");
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = "ontouchstart" in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, "passive", {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener("testPassiveEventSupport", falseFn, opts);
            window.removeEventListener("testPassiveEventSupport", falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement("canvas").getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate("svg").createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement("div");
        div.innerHTML = "<svg/>";
        return (div.firstChild && div.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement("div");
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = "url(#default#VML)";
            return shape && typeof shape.adj === "object";
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf("Mac") === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf("Linux") === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? "MSPointerDown" : "pointerdown";
    var POINTER_MOVE = Browser.msPointer ? "MSPointerMove" : "pointermove";
    var POINTER_UP = Browser.msPointer ? "MSPointerUp" : "pointerup";
    var POINTER_CANCEL = Browser.msPointer ? "MSPointerCancel" : "pointercancel";
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === "touchstart") _addPointerDocListener();
        if (!handle[type]) {
            console.warn("wrong event specified:", type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn("wrong event specified:", type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || "mouse")) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = "dblclick";
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener("dblclick", handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === "mouse" || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener("click", simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener("dblclick", handlers.dblclick);
        obj.removeEventListener("click", handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        "transform",
        "webkitTransform",
        "OTransform",
        "MozTransform",
        "msTransform"
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        "webkitTransition",
        "transition",
        "OTransition",
        "MozTransition",
        "msTransition"
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === "webkitTransition" || TRANSITION === "OTransition" ? TRANSITION + "End" : "transitionend";
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === "string" ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === "auto") && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === "auto" ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || "";
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp("(^|\\s)" + name + "(\\s|$)").test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + " " : "") + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((" " + getClass(el) + " ").replace(" " + name + " ", " ")));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ("opacity" in el.style) el.style.opacity = value;
        else if ("filter" in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = "DXImageTransform.Microsoft.Alpha";
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += " progid:" + filterName + "(opacity=" + value + ")";
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? "translate(" + pos.x + "px," + pos.y + "px)" : "translate3d(" + pos.x + "px," + pos.y + "px,0)") + (scale ? " scale(" + scale + ")" : "");
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + "px";
            el.style.top = point.y + "px";
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ("onselectstart" in document) {
        disableTextSelection = function() {
            on(window, "selectstart", preventDefault);
        };
        enableTextSelection = function() {
            off(window, "selectstart", preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            "userSelect",
            "WebkitUserSelect",
            "OUserSelect",
            "MozUserSelect",
            "msUserSelect"
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = "none";
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, "dragstart", preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, "dragstart", preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = "none";
        on(window, "keydown", restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, "keydown", restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === "object") for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = "_leaflet_events";
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === "object") for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        wheel: !("onwheel" in window) && "mousewheel"
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? "_" + stamp(context) : "");
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") handler = addDoubleTapListener(obj, handler);
        else if ("addEventListener" in obj) {
            if (type === "touchstart" || type === "touchmove" || type === "wheel" || type === "mousewheel") obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === "mouseenter" || type === "mouseleave") {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent("on" + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? "_" + stamp(context) : "");
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === "dblclick") removeDoubleTapListener(obj, handler);
        else if ("removeEventListener" in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent("on" + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, "wheel", stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, "mousedown touchstart dblclick contextmenu", stopPropagation);
        el["_leaflet_disable_click"] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire("start");
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire("step");
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire("end");
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === "number" ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error("Bounds are not valid.");
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire("moveend");
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    "step": this._onPanTransitionStep,
                    "end": this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire("movestart");
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, "leaflet-pan-anim");
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire("move").fire("moveend");
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens("moveend", this._panInsideMaxBounds)) this.off("moveend", this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on("moveend", this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire("zoomlevelschange");
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire("move");
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, "moveend"), 200);
                } else this.fire("moveend");
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire("resize", {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire("viewreset");
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!("geolocation" in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: "Geolocation not supported."
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? "permission denied" : c === 2 ? "position unavailable" : "timeout");
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire("locationerror", {
                code: c,
                message: "Geolocation error: " + message + "."
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === "number") data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire("locationfound", data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off("moveend", this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error("Map container is being reused by another instance");
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire("unload");
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = "leaflet-pane" + (name ? " leaflet-" + name.replace("Pane", "") + "-pane" : ""), pane = create$1("div", className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === "string" ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error("Map container not found.");
            else if (container._leaflet_id) throw new Error("Map container is already initialized.");
            on(container, "scroll", this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, "leaflet-container" + (Browser.touch ? " leaflet-touch" : "") + (Browser.retina ? " leaflet-retina" : "") + (Browser.ielt9 ? " leaflet-oldie" : "") + (Browser.safari ? " leaflet-safari" : "") + (this._fadeAnimated ? " leaflet-fade-anim" : ""));
            var position = getStyle(container, "position");
            if (position !== "absolute" && position !== "relative" && position !== "fixed" && position !== "sticky") container.style.position = "relative";
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane("mapPane", this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane("tilePane");
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane("overlayPane");
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane("shadowPane");
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane("markerPane");
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane("tooltipPane");
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane("popupPane");
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, "leaflet-zoom-hide");
                addClass(panes.shadowPane, "leaflet-zoom-hide");
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire("viewprereset");
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire("viewreset");
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire("load");
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire("zoomstart");
            if (!noMoveStart) this.fire("movestart");
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire("zoom", data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire("move", data);
            } else if (data && data.pinch) this.fire("zoom", data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire("zoomend");
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire("moveend");
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error("Set map center and zoom first.");
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, "resize", this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === "mouseout" || type === "mouseover", src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === "click" || type === "preclick") && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el["_leaflet_disable_click"]) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el["_leaflet_disable_events"] || e.type === "click" && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === "mousedown") // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            "click",
            "dblclick",
            "mouseover",
            "mouseout",
            "contextmenu"
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === "click") {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = "preclick";
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === "contextmenu") preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== "keypress" && e.type !== "keydown" && e.type !== "keyup") {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on("load", callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire("move");
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, "leaflet-pan-anim");
            this.fire("moveend");
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1("div", "leaflet-proxy leaflet-zoom-animated");
            this._panes.mapPane.appendChild(proxy);
            this.on("zoomanim", function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on("load moveend", this._animMoveEnd, this);
            this._on("unload", this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off("load moveend", this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf("transform") >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName("leaflet-zoom-animated").length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, "leaflet-zoom-anim");
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire("zoomanim", {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, "leaflet-zoom-anim");
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire("zoom");
            delete this._tempFireZoomEvent;
            this.fire("move");
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: "topright"
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, "leaflet-control");
            if (pos.indexOf("bottom") !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on("unload", this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off("unload", this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = "leaflet-", container = this._controlContainer = create$1("div", l + "control-container", this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + " " + l + hSide;
                corners[vSide + hSide] = create$1("div", className, container);
            }
            createCorner("top", "left");
            createCorner("top", "right");
            createCorner("bottom", "left");
            createCorner("bottom", "right");
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: "topright",
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on("add remove", this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off("zoomend", this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off("add remove", this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off("add remove", this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, "leaflet-control-layers-expanded");
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, "leaflet-control-layers-scrollbar");
                this._section.style.height = acceptableHeight + "px";
            } else removeClass(this._section, "leaflet-control-layers-scrollbar");
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, "leaflet-control-layers-expanded");
            return this;
        },
        _initLayout: function() {
            var className = "leaflet-control-layers", container = this._container = create$1("div", className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute("aria-haspopup", true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1("section", className + "-list");
            if (collapsed) {
                this._map.on("click", this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1("a", className + "-toggle", container);
            link.href = "#";
            link.title = "Layers";
            link.setAttribute("role", "button");
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1("div", className + "-base", section);
            this._separator = create$1("div", className + "-separator", section);
            this._overlaysList = create$1("div", className + "-overlays", section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on("add remove", this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? "" : "none";
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? "" : "none";
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === "add" ? "overlayadd" : "overlayremove" : e.type === "add" ? "baselayerchange" : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : "") + "/>";
            var radioFragment = document.createElement("div");
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement("label"), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement("input");
                input.type = "checkbox";
                input.className = "leaflet-control-layers-selector";
                input.defaultChecked = checked;
            } else input = this._createRadioElement("leaflet-base-layers_" + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, "click", this._onInputClick, this);
            var name = document.createElement("span");
            name.innerHTML = " " + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement("span");
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, "click", preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, "click", preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: "topleft",
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: "Zoom in",
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: "Zoom out"
        },
        onAdd: function(map) {
            var zoomName = "leaflet-control-zoom", container = create$1("div", zoomName + " leaflet-bar"), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + "-in", container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + "-out", container, this._zoomOut);
            this._updateDisabled();
            map.on("zoomend zoomlevelschange", this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off("zoomend zoomlevelschange", this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1("a", className, container);
            link.innerHTML = html;
            link.href = "#";
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute("role", "button");
            link.setAttribute("aria-label", title);
            disableClickPropagation(link);
            on(link, "click", stop);
            on(link, "click", fn, this);
            on(link, "click", this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = "leaflet-disabled";
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute("aria-disabled", "false");
            this._zoomOutButton.setAttribute("aria-disabled", "false");
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute("aria-disabled", "true");
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute("aria-disabled", "true");
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: "bottomleft",
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = "leaflet-control-scale", container = create$1("div", className), options = this.options;
            this._addScales(options, className + "-line", container);
            map.on(options.updateWhenIdle ? "moveend" : "move", this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1("div", className, container);
            if (options.imperial) this._iScale = create$1("div", className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + " m" : meters / 1000 + " km";
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + " mi", miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + " ft", feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + "px";
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + "").length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: "bottomright",
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + " " : "") + "Leaflet</a>"
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1("div", "leaflet-control-attribution");
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on("layeradd", this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off("layeradd", this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once("remove", function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(", "));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? "touchstart mousedown" : "mousedown";
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, "leaflet-zoom-anim")) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire("down");
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === "mousedown";
            on(document, mouseevent ? "mousemove" : "touchmove", this._onMove, this);
            on(document, mouseevent ? "mouseup" : "touchend touchcancel", this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire("dragstart");
                this._moved = true;
                addClass(document.body, "leaflet-dragging");
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, "leaflet-drag-target");
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire("predrag", e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire("drag", e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, "leaflet-dragging");
            if (this._lastTarget) {
                removeClass(this._lastTarget, "leaflet-drag-target");
                this._lastTarget = null;
            }
            off(document, "mousemove touchmove", this._onMove, this);
            off(document, "mouseup touchend touchcancel", this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire("dragend", {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== "object" && typeof latlngs[0][0] !== "undefined";
    }
    function _flat(latlngs) {
        console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead.");
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error("latlngs not passed");
        if (!isFlat(latlngs)) {
            console.warn("latlngs are not flat! Only the first ring will be used");
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: "EPSG:3395",
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: "EPSG:4326",
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: "overlayPane",
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once("remove", function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire("add");
            map.fire("layeradd", {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error("The provided object is not a Layer.");
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire("layerremove", {
                    layer: layer
                });
                layer.fire("remove");
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire("zoomlevelschange");
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === "number" ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke("setZIndex", zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire("layeradd", {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire("layerremove", {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke("setStyle", style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke("bringToFront");
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke("bringToBack");
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon("icon", oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon("shadow", oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === "icon") throw new Error("iconUrl not set in Icon options (see the docs).");
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === "IMG" ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + "Size"];
            if (typeof sizeOption === "number") sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === "shadow" && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = "leaflet-marker-" + name + " " + (options.className || "");
            if (anchor) {
                img.style.marginLeft = -anchor.x + "px";
                img.style.marginTop = -anchor.y + "px";
            }
            if (size) {
                img.style.width = size.x + "px";
                img.style.height = size.y + "px";
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement("img");
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + "RetinaUrl"] || this.options[name + "Url"];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: "marker-icon.png",
            iconRetinaUrl: "marker-icon-2x.png",
            shadowUrl: "marker-shadow.png",
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== "string") IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1("div", "leaflet-default-icon-path", document.body);
            var path = getStyle(el, "background-image") || getStyle(el, "backgroundImage"); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return "";
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, "leaflet-marker-draggable");
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, "leaflet-marker-draggable");
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire("movestart").fire("dragstart");
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire("move", e).fire("drag", e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire("moveend").fire("dragend", e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: "",
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: "Marker",
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: "markerPane",
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: "shadowPane",
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on("zoomanim", this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off("zoomanim", this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = "leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === "IMG") icon.alt = options.alt || "";
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = "0";
                icon.setAttribute("role", "button");
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, "focus", this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = "";
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, "focus", this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, "leaflet-interactive");
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: "#3388ff",
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: "round",
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: "round",
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: "evenodd",
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, "weight")) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire("move", {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === "number") // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error("Circle radius cannot be NaN");
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error("Must add layer to map before using getCenter()");
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === "function") style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === "Feature" ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case "Point":
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case "MultiPoint":
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case "LineString":
            case "MultiLineString":
                latlngs = coordsToLatLngs(coords, geometry.type === "LineString" ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case "Polygon":
            case "MultiPolygon":
                latlngs = coordsToLatLngs(coords, geometry.type === "Polygon" ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case "GeometryCollection":
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: "Feature",
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case "FeatureCollection":
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error("Invalid GeoJSON object.");
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === "Feature" || geojson.type === "FeatureCollection") return geojson;
        return {
            type: "Feature",
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: "Point",
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "LineString",
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? "Multi" : "") + "Polygon",
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: "MultiPoint",
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === "MultiPoint") return this.toMultiPoint(precision);
            var isGeometryCollection = type === "GeometryCollection", jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === "FeatureCollection") jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: "GeometryCollection"
            });
            return {
                type: "FeatureCollection",
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: "",
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: "",
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ""
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, "leaflet-interactive");
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "IMG";
            var img = this._image = wasElementSupplied ? this._url : create$1("img");
            addClass(img, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(img, "leaflet-zoom-animated");
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, "load");
            img.onerror = bind(this._overlayOnError, this, "error");
            if (this.options.crossOrigin || this.options.crossOrigin === "") img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + "px";
            image.style.height = size.y + "px";
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire("error");
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === "VIDEO";
            var vid = this._image = wasElementSupplied ? this._url : create$1("video");
            addClass(vid, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(vid, "leaflet-zoom-animated");
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, "load");
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName("source");
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, "objectFit")) vid.style["objectFit"] = "fill";
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1("source");
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, "leaflet-image-layer");
            if (this._zoomAnimated) addClass(el, "leaflet-zoom-animated");
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: "",
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ""
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, "leaflet-interactive");
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, "leaflet-interactive");
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = "hidden";
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = "";
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error("Unable to get source layer LatLng.");
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === "function" ? this._content(this._source || this) : this._content;
            if (typeof content === "string") node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire("contentupdate");
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + "px";
            this._container.style.left = left + "px";
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: "popupPane",
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ""
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire("popupopen", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire("popupopen", {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on("preclick", stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire("popupclose", {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire("popupclose", {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off("preclick", stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-popup", container = this._container = create$1("div", prefix + " " + (this.options.className || "") + " leaflet-zoom-animated");
            var wrapper = this._wrapper = create$1("div", prefix + "-content-wrapper", container);
            this._contentNode = create$1("div", prefix + "-content", wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, "contextmenu", stopPropagation);
            this._tipContainer = create$1("div", prefix + "-tip-container", container);
            this._tip = create$1("div", prefix + "-tip", this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1("a", prefix + "-close-button", container);
                closeButton.setAttribute("role", "button"); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute("aria-label", "Close popup");
                closeButton.href = "#close";
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, "click", function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = "";
            style.whiteSpace = "nowrap";
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + "px";
            style.whiteSpace = "";
            style.height = "";
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = "leaflet-popup-scrolled";
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + "px";
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, "marginBottom"), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire("autopanstart").panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: "tooltipPane",
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: "auto",
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire("tooltipopen", {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire("tooltipopen", {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire("tooltipclose", {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire("tooltipclose", {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = "leaflet-tooltip", className = prefix + " " + (this.options.className || "") + " leaflet-zoom-" + (this._zoomAnimated ? "animated" : "hide");
            this._contentNode = this._container = create$1("div", className);
            this._container.setAttribute("role", "tooltip");
            this._container.setAttribute("id", "leaflet-tooltip-" + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === "top") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === "bottom") {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === "center") {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === "right") {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === "left") {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = "right";
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = "left";
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, "leaflet-tooltip-right");
            removeClass(container, "leaflet-tooltip-left");
            removeClass(container, "leaflet-tooltip-top");
            removeClass(container, "leaflet-tooltip-bottom");
            addClass(container, "leaflet-tooltip-" + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? "off" : "on", events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) {
                on(el, "focus", function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, "blur", this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === "function" && layer.getElement();
            if (el) el.setAttribute("aria-describedby", this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once("moveend", function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: "leaflet-div-icon"
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === "DIV" ? oldIcon : document.createElement("div"), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : "";
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + "px " + -bgPos.y + "px";
            }
            this._setIconStyles(div, "icon");
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: "tilePane",
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: "",
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement("div");
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1("div", "leaflet-layer " + (this.options.className || ""));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1("div", "leaflet-tile-container leaflet-zoom-animated", this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error("Attempted to load an infinite number of tiles");
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire("loading");
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ":" + coords.y + ":" + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(":"), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire("tileunload", {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, "leaflet-tile");
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + "px";
            tile.style.height = tileSize.y + "px";
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire("tileloadstart", {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire("tileerror", {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, "leaflet-tile-loaded");
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire("tileload", {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire("load");
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: "abc",
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: "",
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === "string") options.subdomains = options.subdomains.split("");
            this.on("tileunload", this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement("img");
            on(tile, "load", bind(this._tileOnLoad, this, done, tile));
            on(tile, "error", bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === "") tile.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === "string") tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = "";
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? "@2x" : "",
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data["y"] = invertedY;
                data["-y"] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute("src") !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire("tileabort", {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute("src", emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute("src") === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: "WMS",
            request: "GetMap",
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: "",
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: "",
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: "image/jpeg",
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: "1.1.1"
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? "crs" : "srs";
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(","), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, "leaflet-zoom-animated");
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on("update", this._updatePaths, this);
        },
        onRemove: function() {
            this.off("update", this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement("canvas");
            on(container, "mousemove", this._onMouseMove, this);
            on(container, "click dblclick mousedown mouseup contextmenu", this._onClick, this);
            on(container, "mouseout", this._handleMouseOut, this);
            container["_leaflet_disable_events"] = true;
            this._ctx = container.getContext("2d");
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + "px";
            container.style.height = size.y + "px";
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire("update");
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === "string") {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? "lineTo" : "moveTo"](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || "evenodd");
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === "click" || e.type === "preclick") || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, "leaflet-interactive");
                this._fireEvent([
                    layer
                ], e, "mouseout");
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, "leaflet-interactive"); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, "mouseover");
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml");
            return function(name) {
                return document.createElement("<lvml:" + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement("<" + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1("div", "leaflet-vml-container");
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire("update");
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate("shape");
            addClass(container, "leaflet-vml-shape " + (this.options.className || ""));
            container.coordsize = "1 1";
            layer._path = vmlCreate("path");
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate("stroke");
                container.appendChild(stroke);
                stroke.weight = options.weight + "px";
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(" ") : options.dashArray.replace(/( *, *)/g, " ");
                else stroke.dashStyle = "";
                stroke.endcap = options.lineCap.replace("butt", "flat");
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate("fill");
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? "M0 0" : "AL " + p.x + "," + p.y + " " + r + "," + r2 + " 0," + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create("svg");
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute("pointer-events", "none");
            this._rootGroup = create("g");
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute("width", size.x);
                container.setAttribute("height", size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute("viewBox", [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(" "));
            this.fire("update");
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create("path");
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, "leaflet-interactive");
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute("stroke", options.color);
                path.setAttribute("stroke-opacity", options.opacity);
                path.setAttribute("stroke-width", options.weight);
                path.setAttribute("stroke-linecap", options.lineCap);
                path.setAttribute("stroke-linejoin", options.lineJoin);
                if (options.dashArray) path.setAttribute("stroke-dasharray", options.dashArray);
                else path.removeAttribute("stroke-dasharray");
                if (options.dashOffset) path.setAttribute("stroke-dashoffset", options.dashOffset);
                else path.removeAttribute("stroke-dashoffset");
            } else path.setAttribute("stroke", "none");
            if (options.fill) {
                path.setAttribute("fill", options.fillColor || options.color);
                path.setAttribute("fill-opacity", options.fillOpacity);
                path.setAttribute("fill-rule", options.fillRule || "evenodd");
            } else path.setAttribute("fill", "none");
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = "a" + r + "," + r2 + " 0 1,0 ";
            // drawing a circle with two half-arcs
            var d = layer._empty() ? "M0 0" : "M" + (p.x - r) + "," + p.y + arc + r * 2 + ",0 " + arc + -r * 2 + ",0 ";
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute("d", path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === "overlayPane" || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on("unload", this._destroy, this);
        },
        addHooks: function() {
            on(this._container, "mousedown", this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, "mousedown", this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1("div", "leaflet-zoom-box", this._container);
                addClass(this._container, "leaflet-crosshair");
                this._map.fire("boxzoomstart");
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + "px";
            this._box.style.height = size.y + "px";
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, "leaflet-crosshair");
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire("boxzoomend", {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook("addHandler", "boxZoom", BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on("dblclick", this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off("dblclick", this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === "center") map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook("addHandler", "doubleClickZoom", DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on("predrag", this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on("predrag", this._onPreDragWrap, this);
                    map.on("zoomend", this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, "leaflet-grab leaflet-touch-drag");
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-grab");
            removeClass(this._map._container, "leaflet-touch-drag");
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire("movestart").fire("dragstart");
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire("move", e).fire("drag", e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire("dragend", e);
            if (noInertia) map.fire("moveend");
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire("moveend");
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook("addHandler", "dragging", Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = "0";
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire("focus");
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire("blur");
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, "keydown", this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, "keydown", this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook("addHandler", "keyboard", Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, "wheel", this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, "wheel", this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === "center") map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook("addHandler", "scrollWheelZoom", ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, "touchstart", this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, "touchstart", this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, "touchend", preventDefault);
                on(document, "touchend touchcancel", this._cancelClickPrevent);
                this._simulateEvent("contextmenu", first);
            }, this), tapHoldDelay);
            on(document, "touchend touchcancel contextmenu", this._cancel, this);
            on(document, "touchmove", this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, "touchend", preventDefault);
            off(document, "touchend touchcancel", cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, "touchend touchcancel contextmenu", this._cancel, this);
            off(document, "touchmove", this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook("addHandler", "tapHold", TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, "leaflet-touch-zoom");
            on(this._map._container, "touchstart", this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, "leaflet-touch-zoom");
            off(this._map._container, "touchstart", this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== "center") this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, "touchmove", this._onTouchMove, this);
            on(document, "touchend touchcancel", this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === "center") {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, "touchmove", this._onTouchMove, this);
            off(document, "touchend touchcancel", this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook("addHandler", "touchZoom", TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});




function $037af788e64c11b5$export$1d678f4da02b91c9(series, data) {
    const minValues = {};
    const maxValues = {};
    const signature = data[0].replace(/"/g, "");
    //ga('send','pageview', {'dimension1': signature});
    const CaptureDateLine = data[1].replace(/"/g, "");
    const colonIndex = CaptureDateLine.indexOf(":");
    let dateString = CaptureDateLine.substr(colonIndex + 2);
    const dateComponents = dateString.split(" ");
    dateString = dateComponents[0] + " " + dateComponents[1] + " " + dateComponents[2] + " " + dateComponents[3] + " " + dateComponents[5];
    const startDate = new Date(dateString);
    while(data[0].indexOf("	") === -1)data.splice(0, 1);
    const headers = data[0].split("	");
    for(var i = 0; i < headers.length; i++){
        headers[i] = headers[i].trim();
        series[headers[i]] = [];
    }
    for(var i = 1; i < data.length; i++){
        const values = data[i].split("	");
        if (values.length < headers.length || Number.isNaN(Number.parseFloat(values[0]))) {
            console.log(data[i]);
            continue;
        }
        for(var j = 0; j < values.length; j++){
            let seriesName = headers[j];
            let dataPoint = Number(values[j]);
            // if(seriesName==="Time") {
            // 	let components=values[j].split('.')
            // 	dataPoint=new Date(startDate)
            // 	const seconds=Number(components[0])
            // 	let millis=Number(components[1])
            // 	if(seconds < 0) { 
            // 		millis=-millis
            // 	}
            // 	dataPoint.setSeconds(seconds);
            // 	dataPoint.setMilliseconds(millis);
            // }
            (0, $2a9f999bc54a0719$export$fcbd32bf643a4b8)(dataPoint, seriesName, maxValues, minValues);
            series[seriesName].push(dataPoint);
        }
    }
    series.XAxis = "Time";
    series.defaultSelections = [
        "RPM",
        "CLT",
        "IAT"
    ];
    series.headers = headers;
    series.maxValues = maxValues;
    series.minValues = minValues;
    return series;
}


const $2a9f999bc54a0719$export$16fe725363162b27 = {};
const $2a9f999bc54a0719$var$LogTypeEnum = {
    Unknown: 0,
    MSDroid: 1,
    Torque: 2,
    WiPy: 3,
    RealDash: 4,
    RPi: 5,
    GPX: 6
};
function $2a9f999bc54a0719$export$3ae43cdaeb063d33(file, updateUI) {
    const reader = new FileReader();
    reader.onload = function(e) {
        $2a9f999bc54a0719$var$processData(reader.result);
        // g?.destroy();
        // g = null;
        updateUI();
    // resetChart()
    // constructMap()
    };
    reader.readAsText(file);
}
function $2a9f999bc54a0719$var$processData(data) {
    const lines = data.split("\n");
    const dataSeries = $2a9f999bc54a0719$var$createSeries(lines);
    const latitudes = dataSeries[dataSeries.latKey || "Latitude"];
    const longitudes = dataSeries[dataSeries.lonKey || "Longitude"];
    $2a9f999bc54a0719$export$16fe725363162b27.lat = latitudes;
    $2a9f999bc54a0719$export$16fe725363162b27.lon = longitudes;
    $2a9f999bc54a0719$export$16fe725363162b27.dataSeries = dataSeries;
}
function $2a9f999bc54a0719$var$createSeries(data) {
    const series = {};
    series.logType = $2a9f999bc54a0719$var$ascertainLogType(data);
    switch(series.logType){
        case $2a9f999bc54a0719$var$LogTypeEnum.MSDroid:
            (0, $037af788e64c11b5$export$1d678f4da02b91c9)(series, data);
            break;
    }
    return series;
}
function $2a9f999bc54a0719$export$fcbd32bf643a4b8(value, key, maxValues, minValues) {
    if (!isNaN(value)) {
        if (maxValues[key] == undefined || maxValues[key] < value) maxValues[key] = value;
        if (minValues[key] == undefined || minValues[key] > value) minValues[key] = value;
    }
}
function $2a9f999bc54a0719$var$ascertainLogType(data) {
    if (data.length > 2) {
        if (data[1].indexOf("Capture Date") == 1) return $2a9f999bc54a0719$var$LogTypeEnum.MSDroid;
        if (data[0].indexOf("GPS Time, Device Time, Longitude, Latitude") == 0) return $2a9f999bc54a0719$var$LogTypeEnum.Torque;
        if (data[0].indexOf("Time,") == 0) return $2a9f999bc54a0719$var$LogTypeEnum.WiPy;
        if (data[0].indexOf("Time	Engine") == 0) return $2a9f999bc54a0719$var$LogTypeEnum.RealDash;
        if (data[0].indexOf("LogStart	") == 0) return $2a9f999bc54a0719$var$LogTypeEnum.RPi;
        if (data[0].indexOf("gpx.xsd") != -1) return $2a9f999bc54a0719$var$LogTypeEnum.GPX;
    }
    return $2a9f999bc54a0719$var$LogTypeEnum.Unknown;
}


delete (0, (/*@__PURE__*/$parcel$interopDefault($65d191346d2f0e85$exports))).Icon.Default.prototype._getIconUrl;



(0, (/*@__PURE__*/$parcel$interopDefault($65d191346d2f0e85$exports))).Icon.Default.mergeOptions({
    iconRetinaUrl: (parcelRequire("3rK5c")),
    iconUrl: (parcelRequire("5mw4y")),
    shadowUrl: (parcelRequire("cKmJk"))
});
const $892d7dc6dbc410a5$var$map = (0, (/*@__PURE__*/$parcel$interopDefault($65d191346d2f0e85$exports))).map("right");
const $892d7dc6dbc410a5$var$defaultCenter = [
    38.889269,
    -77.050176
];
const $892d7dc6dbc410a5$var$defaultZoom = 15;
const $892d7dc6dbc410a5$var$basemap = (0, (/*@__PURE__*/$parcel$interopDefault($65d191346d2f0e85$exports))).tileLayer("https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}", {
    attribution: "Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community"
});
const $892d7dc6dbc410a5$var$marker = (0, (/*@__PURE__*/$parcel$interopDefault($65d191346d2f0e85$exports))).marker($892d7dc6dbc410a5$var$defaultCenter);
$892d7dc6dbc410a5$var$map.setView($892d7dc6dbc410a5$var$defaultCenter, $892d7dc6dbc410a5$var$defaultZoom);
$892d7dc6dbc410a5$var$basemap.addTo($892d7dc6dbc410a5$var$map);
$892d7dc6dbc410a5$var$marker.addTo($892d7dc6dbc410a5$var$map);
addEventListener("IndexUpdate", (e)=>{
    if (!!(0, $2a9f999bc54a0719$export$16fe725363162b27) && !!(0, $2a9f999bc54a0719$export$16fe725363162b27).lat & !!(0, $2a9f999bc54a0719$export$16fe725363162b27).lon) {
        const lat = (0, $2a9f999bc54a0719$export$16fe725363162b27).lat[e.detail.dataIndex];
        const lon = (0, $2a9f999bc54a0719$export$16fe725363162b27).lon[e.detail.dataIndex];
        if (!isNaN(lat) && !isNaN(lon)) {
            $892d7dc6dbc410a5$var$map.panTo([
                lat,
                lon
            ]);
            $892d7dc6dbc410a5$var$marker.setLatLng([
                lat,
                lon
            ]);
        }
    }
});
console.log("map.js");


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $73ff38dc46896811$var$extendStatics = function(d, b) {
    $73ff38dc46896811$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $73ff38dc46896811$var$extendStatics(d, b);
};
function $73ff38dc46896811$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $73ff38dc46896811$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $73ff38dc46896811$export$18ce0697a983be9b = function() {
    $73ff38dc46896811$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $73ff38dc46896811$export$18ce0697a983be9b.apply(this, arguments);
};
function $73ff38dc46896811$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $73ff38dc46896811$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $73ff38dc46896811$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $73ff38dc46896811$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $73ff38dc46896811$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $73ff38dc46896811$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $73ff38dc46896811$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $73ff38dc46896811$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $73ff38dc46896811$export$45d3717a4c69092e(o, m, p);
}
function $73ff38dc46896811$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $73ff38dc46896811$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $73ff38dc46896811$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($73ff38dc46896811$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $73ff38dc46896811$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $73ff38dc46896811$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}
function $73ff38dc46896811$export$10c90e4f7922046c(v) {
    return this instanceof $73ff38dc46896811$export$10c90e4f7922046c ? (this.v = v, this) : new $73ff38dc46896811$export$10c90e4f7922046c(v);
}
function $73ff38dc46896811$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $73ff38dc46896811$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $73ff38dc46896811$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $73ff38dc46896811$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $73ff38dc46896811$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $73ff38dc46896811$export$19a8beecd37a4c45 === "function" ? $73ff38dc46896811$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $73ff38dc46896811$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $73ff38dc46896811$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $73ff38dc46896811$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $73ff38dc46896811$export$45d3717a4c69092e(result, mod, k);
    }
    $73ff38dc46896811$var$__setModuleDefault(result, mod);
    return result;
}
function $73ff38dc46896811$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $73ff38dc46896811$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $73ff38dc46896811$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}


var $6eba88f9eebe6af9$exports = {};

$parcel$export($6eba88f9eebe6af9$exports, "init", () => $6eba88f9eebe6af9$export$2cd8252107eb640b);
$parcel$export($6eba88f9eebe6af9$exports, "dispose", () => $6eba88f9eebe6af9$export$fcfbbcec2cb820d5);
$parcel$export($6eba88f9eebe6af9$exports, "disposeAll", () => $6eba88f9eebe6af9$export$825f692fb04800ef);
$parcel$export($6eba88f9eebe6af9$exports, "getInstance", () => $6eba88f9eebe6af9$export$8bedcca5bbd73999);
$parcel$export($6eba88f9eebe6af9$exports, "registerPainter", () => $6eba88f9eebe6af9$export$a3e793ccb11823a5);
$parcel$export($6eba88f9eebe6af9$exports, "getElementSSRData", () => $6eba88f9eebe6af9$export$dd7015a5412ca583);
$parcel$export($6eba88f9eebe6af9$exports, "registerSSRDataGetter", () => $6eba88f9eebe6af9$export$e7a09d7fe68a4f7);
$parcel$export($6eba88f9eebe6af9$exports, "version", () => $6eba88f9eebe6af9$export$83d89fbfd8236492);
/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/ var $ce6dd58693a21851$var$Browser = function() {
    function Browser() {
        this.firefox = false;
        this.ie = false;
        this.edge = false;
        this.newEdge = false;
        this.weChat = false;
    }
    return Browser;
}();
var $ce6dd58693a21851$var$Env = function() {
    function Env() {
        this.browser = new $ce6dd58693a21851$var$Browser();
        this.node = false;
        this.wxa = false;
        this.worker = false;
        this.svgSupported = false;
        this.touchEventsSupported = false;
        this.pointerEventsSupported = false;
        this.domSupported = false;
        this.transformSupported = false;
        this.transform3dSupported = false;
        this.hasGlobalWindow = typeof window !== "undefined";
    }
    return Env;
}();
var $ce6dd58693a21851$var$env = new $ce6dd58693a21851$var$Env();
if (typeof wx === "object" && typeof wx.getSystemInfoSync === "function") {
    $ce6dd58693a21851$var$env.wxa = true;
    $ce6dd58693a21851$var$env.touchEventsSupported = true;
} else if (typeof document === "undefined" && typeof self !== "undefined") $ce6dd58693a21851$var$env.worker = true;
else if (typeof navigator === "undefined" || navigator.userAgent.indexOf("Node.js") === 0) {
    $ce6dd58693a21851$var$env.node = true;
    $ce6dd58693a21851$var$env.svgSupported = true;
} else $ce6dd58693a21851$var$detect(navigator.userAgent, $ce6dd58693a21851$var$env);
function $ce6dd58693a21851$var$detect(ua, env) {
    var browser = env.browser;
    var firefox = ua.match(/Firefox\/([\d.]+)/);
    var ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/.+?rv:(([\d.]+))/);
    var edge = ua.match(/Edge?\/([\d.]+)/);
    var weChat = /micromessenger/i.test(ua);
    if (firefox) {
        browser.firefox = true;
        browser.version = firefox[1];
    }
    if (ie) {
        browser.ie = true;
        browser.version = ie[1];
    }
    if (edge) {
        browser.edge = true;
        browser.version = edge[1];
        browser.newEdge = +edge[1].split(".")[0] > 18;
    }
    if (weChat) browser.weChat = true;
    env.svgSupported = typeof SVGRect !== "undefined";
    env.touchEventsSupported = "ontouchstart" in window && !browser.ie && !browser.edge;
    env.pointerEventsSupported = "onpointerdown" in window && (browser.edge || browser.ie && +browser.version >= 11);
    env.domSupported = typeof document !== "undefined";
    var style = document.documentElement.style;
    env.transform3dSupported = (browser.ie && "transition" in style || browser.edge || "WebKitCSSMatrix" in window && "m11" in new WebKitCSSMatrix() || "MozPerspective" in style) && !("OTransition" in style);
    env.transformSupported = env.transform3dSupported || browser.ie && +browser.version >= 9;
}
var $ce6dd58693a21851$export$2e2bcd8739ae039 = $ce6dd58693a21851$var$env;


var $c6341dcc9d86826e$export$b1461457ea2c1179 = 12;
var $c6341dcc9d86826e$export$2653e0d5dd45b294 = "sans-serif";
var $c6341dcc9d86826e$export$7d7a232b6d2cc80c = $c6341dcc9d86826e$export$b1461457ea2c1179 + "px " + $c6341dcc9d86826e$export$2653e0d5dd45b294;
var $c6341dcc9d86826e$var$OFFSET = 20;
var $c6341dcc9d86826e$var$SCALE = 100;
var $c6341dcc9d86826e$var$defaultWidthMapStr = "007LLmW'55;N0500LLLLLLLLLL00NNNLzWW\\\\WQb\\0FWLg\\bWb\\WQ\\WrWWQ000CL5LLFLL0LL**F*gLLLL5F0LF\\FFF5.5N";
function $c6341dcc9d86826e$var$getTextWidthMap(mapStr) {
    var map = {};
    if (typeof JSON === "undefined") return map;
    for(var i = 0; i < mapStr.length; i++){
        var char = String.fromCharCode(i + 32);
        var size = (mapStr.charCodeAt(i) - $c6341dcc9d86826e$var$OFFSET) / $c6341dcc9d86826e$var$SCALE;
        map[char] = size;
    }
    return map;
}
var $c6341dcc9d86826e$export$69462fcc6bf851a4 = $c6341dcc9d86826e$var$getTextWidthMap($c6341dcc9d86826e$var$defaultWidthMapStr);
var $c6341dcc9d86826e$export$ef5e599365494451 = {
    createCanvas: function() {
        return typeof document !== "undefined" && document.createElement("canvas");
    },
    measureText: function() {
        var _ctx;
        var _cachedFont;
        return function(text, font) {
            if (!_ctx) {
                var canvas = $c6341dcc9d86826e$export$ef5e599365494451.createCanvas();
                _ctx = canvas && canvas.getContext("2d");
            }
            if (_ctx) {
                if (_cachedFont !== font) _cachedFont = _ctx.font = font || $c6341dcc9d86826e$export$7d7a232b6d2cc80c;
                return _ctx.measureText(text);
            } else {
                text = text || "";
                font = font || $c6341dcc9d86826e$export$7d7a232b6d2cc80c;
                var res = /(\d+)px/.exec(font);
                var fontSize = res && +res[1] || $c6341dcc9d86826e$export$b1461457ea2c1179;
                var width = 0;
                if (font.indexOf("mono") >= 0) width = fontSize * text.length;
                else for(var i = 0; i < text.length; i++){
                    var preCalcWidth = $c6341dcc9d86826e$export$69462fcc6bf851a4[text[i]];
                    width += preCalcWidth == null ? fontSize : preCalcWidth * fontSize;
                }
                return {
                    width: width
                };
            }
        };
    }(),
    loadImage: function(src, onload, onerror) {
        var image = new Image();
        image.onload = onload;
        image.onerror = onerror;
        image.src = src;
        return image;
    }
};
function $c6341dcc9d86826e$export$61bcfd79465c1b7c(newPlatformApis) {
    for(var key in $c6341dcc9d86826e$export$ef5e599365494451)if (newPlatformApis[key]) $c6341dcc9d86826e$export$ef5e599365494451[key] = newPlatformApis[key];
}


var $7a1bd9c2710fea0d$var$BUILTIN_OBJECT = $7a1bd9c2710fea0d$export$533b26079ad0b4b([
    "Function",
    "RegExp",
    "Date",
    "Error",
    "CanvasGradient",
    "CanvasPattern",
    "Image",
    "Canvas"
], function(obj, val) {
    obj["[object " + val + "]"] = true;
    return obj;
}, {});
var $7a1bd9c2710fea0d$var$TYPED_ARRAY = $7a1bd9c2710fea0d$export$533b26079ad0b4b([
    "Int8",
    "Uint8",
    "Uint8Clamped",
    "Int16",
    "Uint16",
    "Int32",
    "Uint32",
    "Float32",
    "Float64"
], function(obj, val) {
    obj["[object " + val + "Array]"] = true;
    return obj;
}, {});
var $7a1bd9c2710fea0d$var$objToString = Object.prototype.toString;
var $7a1bd9c2710fea0d$var$arrayProto = Array.prototype;
var $7a1bd9c2710fea0d$var$nativeForEach = $7a1bd9c2710fea0d$var$arrayProto.forEach;
var $7a1bd9c2710fea0d$var$nativeFilter = $7a1bd9c2710fea0d$var$arrayProto.filter;
var $7a1bd9c2710fea0d$var$nativeSlice = $7a1bd9c2710fea0d$var$arrayProto.slice;
var $7a1bd9c2710fea0d$var$nativeMap = $7a1bd9c2710fea0d$var$arrayProto.map;
var $7a1bd9c2710fea0d$var$ctorFunction = (function() {}).constructor;
var $7a1bd9c2710fea0d$var$protoFunction = $7a1bd9c2710fea0d$var$ctorFunction ? $7a1bd9c2710fea0d$var$ctorFunction.prototype : null;
var $7a1bd9c2710fea0d$var$protoKey = "__proto__";
var $7a1bd9c2710fea0d$var$idStart = 0x0907;
function $7a1bd9c2710fea0d$export$46e8f25c7328f77e() {
    return $7a1bd9c2710fea0d$var$idStart++;
}
function $7a1bd9c2710fea0d$export$58da9968c3170cb1() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (typeof console !== "undefined") console.error.apply(console, args);
}
function $7a1bd9c2710fea0d$export$9cd59f9826255e47(source) {
    if (source == null || typeof source !== "object") return source;
    var result = source;
    var typeStr = $7a1bd9c2710fea0d$var$objToString.call(source);
    if (typeStr === "[object Array]") {
        if (!$7a1bd9c2710fea0d$export$c3825b437cbdea5c(source)) {
            result = [];
            for(var i = 0, len = source.length; i < len; i++)result[i] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(source[i]);
        }
    } else if ($7a1bd9c2710fea0d$var$TYPED_ARRAY[typeStr]) {
        if (!$7a1bd9c2710fea0d$export$c3825b437cbdea5c(source)) {
            var Ctor = source.constructor;
            if (Ctor.from) result = Ctor.from(source);
            else {
                result = new Ctor(source.length);
                for(var i = 0, len = source.length; i < len; i++)result[i] = source[i];
            }
        }
    } else if (!$7a1bd9c2710fea0d$var$BUILTIN_OBJECT[typeStr] && !$7a1bd9c2710fea0d$export$c3825b437cbdea5c(source) && !$7a1bd9c2710fea0d$export$9f57505b7bd8dae(source)) {
        result = {};
        for(var key in source)if (source.hasOwnProperty(key) && key !== $7a1bd9c2710fea0d$var$protoKey) result[key] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(source[key]);
    }
    return result;
}
function $7a1bd9c2710fea0d$export$4950aa0f605343fb(target, source, overwrite) {
    if (!$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(source) || !$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(target)) return overwrite ? $7a1bd9c2710fea0d$export$9cd59f9826255e47(source) : target;
    for(var key in source)if (source.hasOwnProperty(key) && key !== $7a1bd9c2710fea0d$var$protoKey) {
        var targetProp = target[key];
        var sourceProp = source[key];
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(sourceProp) && $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(targetProp) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(sourceProp) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(targetProp) && !$7a1bd9c2710fea0d$export$9f57505b7bd8dae(sourceProp) && !$7a1bd9c2710fea0d$export$9f57505b7bd8dae(targetProp) && !$7a1bd9c2710fea0d$export$fa523b2c4941fd4f(sourceProp) && !$7a1bd9c2710fea0d$export$fa523b2c4941fd4f(targetProp) && !$7a1bd9c2710fea0d$export$c3825b437cbdea5c(sourceProp) && !$7a1bd9c2710fea0d$export$c3825b437cbdea5c(targetProp)) $7a1bd9c2710fea0d$export$4950aa0f605343fb(targetProp, sourceProp, overwrite);
        else if (overwrite || !(key in target)) target[key] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(source[key]);
    }
    return target;
}
function $7a1bd9c2710fea0d$export$18aef43295bbe906(targetAndSources, overwrite) {
    var result = targetAndSources[0];
    for(var i = 1, len = targetAndSources.length; i < len; i++)result = $7a1bd9c2710fea0d$export$4950aa0f605343fb(result, targetAndSources[i], overwrite);
    return result;
}
function $7a1bd9c2710fea0d$export$8b58be045bf06082(target, source) {
    if (Object.assign) Object.assign(target, source);
    else {
        for(var key in source)if (source.hasOwnProperty(key) && key !== $7a1bd9c2710fea0d$var$protoKey) target[key] = source[key];
    }
    return target;
}
function $7a1bd9c2710fea0d$export$ebe90cb607ad99e(target, source, overlay) {
    var keysArr = $7a1bd9c2710fea0d$export$ed97f33186d4b816(source);
    for(var i = 0; i < keysArr.length; i++){
        var key = keysArr[i];
        if (overlay ? source[key] != null : target[key] == null) target[key] = source[key];
    }
    return target;
}
var $7a1bd9c2710fea0d$export$cd3d1f114b139967 = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas;
function $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(array, value) {
    if (array) {
        if (array.indexOf) return array.indexOf(value);
        for(var i = 0, len = array.length; i < len; i++){
            if (array[i] === value) return i;
        }
    }
    return -1;
}
function $7a1bd9c2710fea0d$export$69f1b2dcda23c5f8(clazz, baseClazz) {
    var clazzPrototype = clazz.prototype;
    function F() {}
    F.prototype = baseClazz.prototype;
    clazz.prototype = new F();
    for(var prop in clazzPrototype)if (clazzPrototype.hasOwnProperty(prop)) clazz.prototype[prop] = clazzPrototype[prop];
    clazz.prototype.constructor = clazz;
    clazz.superClass = baseClazz;
}
function $7a1bd9c2710fea0d$export$e36fc9d62a853069(target, source, override) {
    target = "prototype" in target ? target.prototype : target;
    source = "prototype" in source ? source.prototype : source;
    if (Object.getOwnPropertyNames) {
        var keyList = Object.getOwnPropertyNames(source);
        for(var i = 0; i < keyList.length; i++){
            var key = keyList[i];
            if (key !== "constructor") {
                if (override ? source[key] != null : target[key] == null) target[key] = source[key];
            }
        }
    } else $7a1bd9c2710fea0d$export$ebe90cb607ad99e(target, source, override);
}
function $7a1bd9c2710fea0d$export$1e2f57719e155213(data) {
    if (!data) return false;
    if (typeof data === "string") return false;
    return typeof data.length === "number";
}
function $7a1bd9c2710fea0d$export$79b2f7037acddd43(arr, cb, context) {
    if (!(arr && cb)) return;
    if (arr.forEach && arr.forEach === $7a1bd9c2710fea0d$var$nativeForEach) arr.forEach(cb, context);
    else if (arr.length === +arr.length) for(var i = 0, len = arr.length; i < len; i++)cb.call(context, arr[i], i, arr);
    else {
        for(var key in arr)if (arr.hasOwnProperty(key)) cb.call(context, arr[key], key, arr);
    }
}
function $7a1bd9c2710fea0d$export$871de8747c9eaa88(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $7a1bd9c2710fea0d$export$58adb3bec8346d0f(arr);
    if (arr.map && arr.map === $7a1bd9c2710fea0d$var$nativeMap) return arr.map(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)result.push(cb.call(context, arr[i], i, arr));
        return result;
    }
}
function $7a1bd9c2710fea0d$export$533b26079ad0b4b(arr, cb, memo, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++)memo = cb.call(context, memo, arr[i], i, arr);
    return memo;
}
function $7a1bd9c2710fea0d$export$3dea766d36a8935f(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $7a1bd9c2710fea0d$export$58adb3bec8346d0f(arr);
    if (arr.filter && arr.filter === $7a1bd9c2710fea0d$var$nativeFilter) return arr.filter(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)if (cb.call(context, arr[i], i, arr)) result.push(arr[i]);
        return result;
    }
}
function $7a1bd9c2710fea0d$export$71aa6c912b956294(arr, cb, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++){
        if (cb.call(context, arr[i], i, arr)) return arr[i];
    }
}
function $7a1bd9c2710fea0d$export$ed97f33186d4b816(obj) {
    if (!obj) return [];
    if (Object.keys) return Object.keys(obj);
    var keyList = [];
    for(var key in obj)if (obj.hasOwnProperty(key)) keyList.push(key);
    return keyList;
}
function $7a1bd9c2710fea0d$var$bindPolyfill(func, context) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return function() {
        return func.apply(context, args.concat($7a1bd9c2710fea0d$var$nativeSlice.call(arguments)));
    };
}
var $7a1bd9c2710fea0d$export$2385a24977818dd0 = $7a1bd9c2710fea0d$var$protoFunction && $7a1bd9c2710fea0d$export$f6e2535fb5126e54($7a1bd9c2710fea0d$var$protoFunction.bind) ? $7a1bd9c2710fea0d$var$protoFunction.call.bind($7a1bd9c2710fea0d$var$protoFunction.bind) : $7a1bd9c2710fea0d$var$bindPolyfill;
function $7a1bd9c2710fea0d$export$c3095a23b368d1f2(func) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return function() {
        return func.apply(this, args.concat($7a1bd9c2710fea0d$var$nativeSlice.call(arguments)));
    };
}
function $7a1bd9c2710fea0d$export$43bee75e5e14138e(value) {
    if (Array.isArray) return Array.isArray(value);
    return $7a1bd9c2710fea0d$var$objToString.call(value) === "[object Array]";
}
function $7a1bd9c2710fea0d$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}
function $7a1bd9c2710fea0d$export$844ec244b1367d54(value) {
    return typeof value === "string";
}
function $7a1bd9c2710fea0d$export$29d0bb2a4e07b252(value) {
    return $7a1bd9c2710fea0d$var$objToString.call(value) === "[object String]";
}
function $7a1bd9c2710fea0d$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(value) {
    var type = typeof value;
    return type === "function" || !!value && type === "object";
}
function $7a1bd9c2710fea0d$export$fa523b2c4941fd4f(value) {
    return !!$7a1bd9c2710fea0d$var$BUILTIN_OBJECT[$7a1bd9c2710fea0d$var$objToString.call(value)];
}
function $7a1bd9c2710fea0d$export$b119cc7e1840e59c(value) {
    return !!$7a1bd9c2710fea0d$var$TYPED_ARRAY[$7a1bd9c2710fea0d$var$objToString.call(value)];
}
function $7a1bd9c2710fea0d$export$9f57505b7bd8dae(value) {
    return typeof value === "object" && typeof value.nodeType === "number" && typeof value.ownerDocument === "object";
}
function $7a1bd9c2710fea0d$export$fa2c283003ed971c(value) {
    return value.colorStops != null;
}
function $7a1bd9c2710fea0d$export$a49bbf3a55dcef7b(value) {
    return value.image != null;
}
function $7a1bd9c2710fea0d$export$49841c62b9eff15(value) {
    return $7a1bd9c2710fea0d$var$objToString.call(value) === "[object RegExp]";
}
function $7a1bd9c2710fea0d$export$7d667b9a0c48c975(value) {
    return value !== value;
}
function $7a1bd9c2710fea0d$export$8a4d17b6e8486e66() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    for(var i = 0, len = args.length; i < len; i++){
        if (args[i] != null) return args[i];
    }
}
function $7a1bd9c2710fea0d$export$995e01f2f5c9d030(value0, value1) {
    return value0 != null ? value0 : value1;
}
function $7a1bd9c2710fea0d$export$2e94551289abb95b(value0, value1, value2) {
    return value0 != null ? value0 : value1 != null ? value1 : value2;
}
function $7a1bd9c2710fea0d$export$58adb3bec8346d0f(arr) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $7a1bd9c2710fea0d$var$nativeSlice.apply(arr, args);
}
function $7a1bd9c2710fea0d$export$f3a38102c49f4268(val) {
    if (typeof val === "number") return [
        val,
        val,
        val,
        val
    ];
    var len = val.length;
    if (len === 2) return [
        val[0],
        val[1],
        val[0],
        val[1]
    ];
    else if (len === 3) return [
        val[0],
        val[1],
        val[2],
        val[1]
    ];
    return val;
}
function $7a1bd9c2710fea0d$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message);
}
function $7a1bd9c2710fea0d$export$87c2784dc9fc4ab(str) {
    if (str == null) return null;
    else if (typeof str.trim === "function") return str.trim();
    else return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
}
var $7a1bd9c2710fea0d$var$primitiveKey = "__ec_primitive__";
function $7a1bd9c2710fea0d$export$112e66431016387b(obj) {
    obj[$7a1bd9c2710fea0d$var$primitiveKey] = true;
}
function $7a1bd9c2710fea0d$export$c3825b437cbdea5c(obj) {
    return obj[$7a1bd9c2710fea0d$var$primitiveKey];
}
var $7a1bd9c2710fea0d$var$MapPolyfill = function() {
    function MapPolyfill() {
        this.data = {};
    }
    MapPolyfill.prototype["delete"] = function(key) {
        var existed = this.has(key);
        if (existed) delete this.data[key];
        return existed;
    };
    MapPolyfill.prototype.has = function(key) {
        return this.data.hasOwnProperty(key);
    };
    MapPolyfill.prototype.get = function(key) {
        return this.data[key];
    };
    MapPolyfill.prototype.set = function(key, value) {
        this.data[key] = value;
        return this;
    };
    MapPolyfill.prototype.keys = function() {
        return $7a1bd9c2710fea0d$export$ed97f33186d4b816(this.data);
    };
    MapPolyfill.prototype.forEach = function(callback) {
        var data = this.data;
        for(var key in data)if (data.hasOwnProperty(key)) callback(data[key], key);
    };
    return MapPolyfill;
}();
var $7a1bd9c2710fea0d$var$isNativeMapSupported = typeof Map === "function";
function $7a1bd9c2710fea0d$var$maybeNativeMap() {
    return $7a1bd9c2710fea0d$var$isNativeMapSupported ? new Map() : new $7a1bd9c2710fea0d$var$MapPolyfill();
}
var $7a1bd9c2710fea0d$export$60ef0b43d585640a = function() {
    function HashMap(obj) {
        var isArr = $7a1bd9c2710fea0d$export$43bee75e5e14138e(obj);
        this.data = $7a1bd9c2710fea0d$var$maybeNativeMap();
        var thisMap = this;
        obj instanceof HashMap ? obj.each(visit) : obj && $7a1bd9c2710fea0d$export$79b2f7037acddd43(obj, visit);
        function visit(value, key) {
            isArr ? thisMap.set(value, key) : thisMap.set(key, value);
        }
    }
    HashMap.prototype.hasKey = function(key) {
        return this.data.has(key);
    };
    HashMap.prototype.get = function(key) {
        return this.data.get(key);
    };
    HashMap.prototype.set = function(key, value) {
        this.data.set(key, value);
        return value;
    };
    HashMap.prototype.each = function(cb, context) {
        this.data.forEach(function(value, key) {
            cb.call(context, value, key);
        });
    };
    HashMap.prototype.keys = function() {
        var keys = this.data.keys();
        return $7a1bd9c2710fea0d$var$isNativeMapSupported ? Array.from(keys) : keys;
    };
    HashMap.prototype.removeKey = function(key) {
        this.data["delete"](key);
    };
    return HashMap;
}();
function $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4(obj) {
    return new $7a1bd9c2710fea0d$export$60ef0b43d585640a(obj);
}
function $7a1bd9c2710fea0d$export$4fd8af2c48c43416(a, b) {
    var newArray = new a.constructor(a.length + b.length);
    for(var i = 0; i < a.length; i++)newArray[i] = a[i];
    var offset = a.length;
    for(var i = 0; i < b.length; i++)newArray[i + offset] = b[i];
    return newArray;
}
function $7a1bd9c2710fea0d$export$79c7e160a7743efd(proto, properties) {
    var obj;
    if (Object.create) obj = Object.create(proto);
    else {
        var StyleCtor = function() {};
        StyleCtor.prototype = proto;
        obj = new StyleCtor();
    }
    if (properties) $7a1bd9c2710fea0d$export$8b58be045bf06082(obj, properties);
    return obj;
}
function $7a1bd9c2710fea0d$export$23a5d775868fdd2c(dom) {
    var domStyle = dom.style;
    domStyle.webkitUserSelect = "none";
    domStyle.userSelect = "none";
    domStyle.webkitTapHighlightColor = "rgba(0,0,0,0)";
    domStyle["-webkit-touch-callout"] = "none";
}
function $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3(own, prop) {
    return own.hasOwnProperty(prop);
}
function $7a1bd9c2710fea0d$export$8793edee2d425525() {}
var $7a1bd9c2710fea0d$export$bce8e055322a0ce6 = 180 / Math.PI;


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $995fbf2af591395d$var$extendStatics = function(d, b) {
    $995fbf2af591395d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $995fbf2af591395d$var$extendStatics(d, b);
};
function $995fbf2af591395d$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $995fbf2af591395d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $995fbf2af591395d$export$18ce0697a983be9b = function() {
    $995fbf2af591395d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $995fbf2af591395d$export$18ce0697a983be9b.apply(this, arguments);
};
function $995fbf2af591395d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $995fbf2af591395d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $995fbf2af591395d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $995fbf2af591395d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $995fbf2af591395d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $995fbf2af591395d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $995fbf2af591395d$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $995fbf2af591395d$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $995fbf2af591395d$export$45d3717a4c69092e(o, m, p);
}
function $995fbf2af591395d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $995fbf2af591395d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $995fbf2af591395d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($995fbf2af591395d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $995fbf2af591395d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $995fbf2af591395d$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}
function $995fbf2af591395d$export$10c90e4f7922046c(v) {
    return this instanceof $995fbf2af591395d$export$10c90e4f7922046c ? (this.v = v, this) : new $995fbf2af591395d$export$10c90e4f7922046c(v);
}
function $995fbf2af591395d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $995fbf2af591395d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $995fbf2af591395d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $995fbf2af591395d$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $995fbf2af591395d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $995fbf2af591395d$export$19a8beecd37a4c45 === "function" ? $995fbf2af591395d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $995fbf2af591395d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $995fbf2af591395d$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $995fbf2af591395d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $995fbf2af591395d$export$45d3717a4c69092e(result, mod, k);
    }
    $995fbf2af591395d$var$__setModuleDefault(result, mod);
    return result;
}
function $995fbf2af591395d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $995fbf2af591395d$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $995fbf2af591395d$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}



function $6de594cf8ac295ff$export$185802fd694ee1f5(x, y) {
    if (x == null) x = 0;
    if (y == null) y = 0;
    return [
        x,
        y
    ];
}
function $6de594cf8ac295ff$export$784d13d8ee351f07(out, v) {
    out[0] = v[0];
    out[1] = v[1];
    return out;
}
function $6de594cf8ac295ff$export$9cd59f9826255e47(v) {
    return [
        v[0],
        v[1]
    ];
}
function $6de594cf8ac295ff$export$adaa4cf7ef1b65be(out, a, b) {
    out[0] = a;
    out[1] = b;
    return out;
}
function $6de594cf8ac295ff$export$e16d8520af44a096(out, v1, v2) {
    out[0] = v1[0] + v2[0];
    out[1] = v1[1] + v2[1];
    return out;
}
function $6de594cf8ac295ff$export$19cedf1da84ba854(out, v1, v2, a) {
    out[0] = v1[0] + v2[0] * a;
    out[1] = v1[1] + v2[1] * a;
    return out;
}
function $6de594cf8ac295ff$export$f93b5905241a7cca(out, v1, v2) {
    out[0] = v1[0] - v2[0];
    out[1] = v1[1] - v2[1];
    return out;
}
function $6de594cf8ac295ff$export$fc1400facf92c78(v) {
    return Math.sqrt($6de594cf8ac295ff$export$48e33bc611e4c25a(v));
}
var $6de594cf8ac295ff$export$f24224f1c91d8156 = $6de594cf8ac295ff$export$fc1400facf92c78;
function $6de594cf8ac295ff$export$48e33bc611e4c25a(v) {
    return v[0] * v[0] + v[1] * v[1];
}
var $6de594cf8ac295ff$export$2f106540dd9a5136 = $6de594cf8ac295ff$export$48e33bc611e4c25a;
function $6de594cf8ac295ff$export$6e3a27864ab166fe(out, v1, v2) {
    out[0] = v1[0] * v2[0];
    out[1] = v1[1] * v2[1];
    return out;
}
function $6de594cf8ac295ff$export$159d9494db57879b(out, v1, v2) {
    out[0] = v1[0] / v2[0];
    out[1] = v1[1] / v2[1];
    return out;
}
function $6de594cf8ac295ff$export$94132a0e348806d4(v1, v2) {
    return v1[0] * v2[0] + v1[1] * v2[1];
}
function $6de594cf8ac295ff$export$dcdf75081b88279d(out, v, s) {
    out[0] = v[0] * s;
    out[1] = v[1] * s;
    return out;
}
function $6de594cf8ac295ff$export$a3295358bff77e(out, v) {
    var d = $6de594cf8ac295ff$export$fc1400facf92c78(v);
    if (d === 0) {
        out[0] = 0;
        out[1] = 0;
    } else {
        out[0] = v[0] / d;
        out[1] = v[1] / d;
    }
    return out;
}
function $6de594cf8ac295ff$export$9f17032d917177de(v1, v2) {
    return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}
var $6de594cf8ac295ff$export$6c4a311cc157c764 = $6de594cf8ac295ff$export$9f17032d917177de;
function $6de594cf8ac295ff$export$137c0a69d1ff4a79(v1, v2) {
    return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}
var $6de594cf8ac295ff$export$c68db45a034c13b0 = $6de594cf8ac295ff$export$137c0a69d1ff4a79;
function $6de594cf8ac295ff$export$aef51622e549b8b0(out, v) {
    out[0] = -v[0];
    out[1] = -v[1];
    return out;
}
function $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f(out, v1, v2, t) {
    out[0] = v1[0] + t * (v2[0] - v1[0]);
    out[1] = v1[1] + t * (v2[1] - v1[1]);
    return out;
}
function $6de594cf8ac295ff$export$9f9dcb98c894b623(out, v, m) {
    var x = v[0];
    var y = v[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $6de594cf8ac295ff$export$96ec731ed4dcb222(out, v1, v2) {
    out[0] = Math.min(v1[0], v2[0]);
    out[1] = Math.min(v1[1], v2[1]);
    return out;
}
function $6de594cf8ac295ff$export$8960430cfd85939f(out, v1, v2) {
    out[0] = Math.max(v1[0], v2[0]);
    out[1] = Math.max(v1[1], v2[1]);
    return out;
}


var $4e8ea7ab4b22b6b2$var$Param = function() {
    function Param(target, e) {
        this.target = target;
        this.topTarget = e && e.topTarget;
    }
    return Param;
}();
var $4e8ea7ab4b22b6b2$var$Draggable = function() {
    function Draggable(handler) {
        this.handler = handler;
        handler.on("mousedown", this._dragStart, this);
        handler.on("mousemove", this._drag, this);
        handler.on("mouseup", this._dragEnd, this);
    }
    Draggable.prototype._dragStart = function(e) {
        var draggingTarget = e.target;
        while(draggingTarget && !draggingTarget.draggable)draggingTarget = draggingTarget.parent || draggingTarget.__hostTarget;
        if (draggingTarget) {
            this._draggingTarget = draggingTarget;
            draggingTarget.dragging = true;
            this._x = e.offsetX;
            this._y = e.offsetY;
            this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(draggingTarget, e), "dragstart", e.event);
        }
    };
    Draggable.prototype._drag = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) {
            var x = e.offsetX;
            var y = e.offsetY;
            var dx = x - this._x;
            var dy = y - this._y;
            this._x = x;
            this._y = y;
            draggingTarget.drift(dx, dy, e);
            this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(draggingTarget, e), "drag", e.event);
            var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
            var lastDropTarget = this._dropTarget;
            this._dropTarget = dropTarget;
            if (draggingTarget !== dropTarget) {
                if (lastDropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(lastDropTarget, e), "dragleave", e.event);
                if (dropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(dropTarget, e), "dragenter", e.event);
            }
        }
    };
    Draggable.prototype._dragEnd = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) draggingTarget.dragging = false;
        this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(draggingTarget, e), "dragend", e.event);
        if (this._dropTarget) this.handler.dispatchToElement(new $4e8ea7ab4b22b6b2$var$Param(this._dropTarget, e), "drop", e.event);
        this._draggingTarget = null;
        this._dropTarget = null;
    };
    return Draggable;
}();
var $4e8ea7ab4b22b6b2$export$2e2bcd8739ae039 = $4e8ea7ab4b22b6b2$var$Draggable;


var $63441a86293f101f$var$Eventful = function() {
    function Eventful(eventProcessors) {
        if (eventProcessors) this._$eventProcessor = eventProcessors;
    }
    Eventful.prototype.on = function(event, query, handler, context) {
        if (!this._$handlers) this._$handlers = {};
        var _h = this._$handlers;
        if (typeof query === "function") {
            context = handler;
            handler = query;
            query = null;
        }
        if (!handler || !event) return this;
        var eventProcessor = this._$eventProcessor;
        if (query != null && eventProcessor && eventProcessor.normalizeQuery) query = eventProcessor.normalizeQuery(query);
        if (!_h[event]) _h[event] = [];
        for(var i = 0; i < _h[event].length; i++){
            if (_h[event][i].h === handler) return this;
        }
        var wrap = {
            h: handler,
            query: query,
            ctx: context || this,
            callAtLast: handler.zrEventfulCallAtLast
        };
        var lastIndex = _h[event].length - 1;
        var lastWrap = _h[event][lastIndex];
        lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
        return this;
    };
    Eventful.prototype.isSilent = function(eventName) {
        var _h = this._$handlers;
        return !_h || !_h[eventName] || !_h[eventName].length;
    };
    Eventful.prototype.off = function(eventType, handler) {
        var _h = this._$handlers;
        if (!_h) return this;
        if (!eventType) {
            this._$handlers = {};
            return this;
        }
        if (handler) {
            if (_h[eventType]) {
                var newList = [];
                for(var i = 0, l = _h[eventType].length; i < l; i++)if (_h[eventType][i].h !== handler) newList.push(_h[eventType][i]);
                _h[eventType] = newList;
            }
            if (_h[eventType] && _h[eventType].length === 0) delete _h[eventType];
        } else delete _h[eventType];
        return this;
    };
    Eventful.prototype.trigger = function(eventType) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[eventType];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(eventType, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(hItem.ctx);
                        break;
                    case 1:
                        hItem.h.call(hItem.ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(hItem.ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(hItem.ctx, args);
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(eventType);
        return this;
    };
    Eventful.prototype.triggerWithContext = function(type) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[type];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var ctx = args[argLen - 1];
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(ctx);
                        break;
                    case 1:
                        hItem.h.call(ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(ctx, args.slice(1, argLen - 1));
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
        return this;
    };
    return Eventful;
}();
var $63441a86293f101f$export$2e2bcd8739ae039 = $63441a86293f101f$var$Eventful;





var $a9b673cb651a68dc$var$LN2 = Math.log(2);
function $a9b673cb651a68dc$var$determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
    var cacheKey = rowMask + "-" + colMask;
    var fullRank = rows.length;
    if (detCache.hasOwnProperty(cacheKey)) return detCache[cacheKey];
    if (rank === 1) {
        var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / $a9b673cb651a68dc$var$LN2);
        return rows[rowStart][colStart];
    }
    var subRowMask = rowMask | 1 << rowStart;
    var subRowStart = rowStart + 1;
    while(rowMask & 1 << subRowStart)subRowStart++;
    var sum = 0;
    for(var j = 0, colLocalIdx = 0; j < fullRank; j++){
        var colTag = 1 << j;
        if (!(colTag & colMask)) {
            sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] * $a9b673cb651a68dc$var$determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
            colLocalIdx++;
        }
    }
    detCache[cacheKey] = sum;
    return sum;
}
function $a9b673cb651a68dc$export$fbdb2748a8171a7e(src, dest) {
    var mA = [
        [
            src[0],
            src[1],
            1,
            0,
            0,
            0,
            -dest[0] * src[0],
            -dest[0] * src[1]
        ],
        [
            0,
            0,
            0,
            src[0],
            src[1],
            1,
            -dest[1] * src[0],
            -dest[1] * src[1]
        ],
        [
            src[2],
            src[3],
            1,
            0,
            0,
            0,
            -dest[2] * src[2],
            -dest[2] * src[3]
        ],
        [
            0,
            0,
            0,
            src[2],
            src[3],
            1,
            -dest[3] * src[2],
            -dest[3] * src[3]
        ],
        [
            src[4],
            src[5],
            1,
            0,
            0,
            0,
            -dest[4] * src[4],
            -dest[4] * src[5]
        ],
        [
            0,
            0,
            0,
            src[4],
            src[5],
            1,
            -dest[5] * src[4],
            -dest[5] * src[5]
        ],
        [
            src[6],
            src[7],
            1,
            0,
            0,
            0,
            -dest[6] * src[6],
            -dest[6] * src[7]
        ],
        [
            0,
            0,
            0,
            src[6],
            src[7],
            1,
            -dest[7] * src[6],
            -dest[7] * src[7]
        ]
    ];
    var detCache = {};
    var det = $a9b673cb651a68dc$var$determinant(mA, 8, 0, 0, 0, detCache);
    if (det === 0) return;
    var vh = [];
    for(var i = 0; i < 8; i++)for(var j = 0; j < 8; j++){
        vh[j] == null && (vh[j] = 0);
        vh[j] += ((i + j) % 2 ? -1 : 1) * $a9b673cb651a68dc$var$determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
    }
    return function(out, srcPointX, srcPointY) {
        var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
        out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
        out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
    };
}


var $664e052f390bd76e$var$EVENT_SAVED_PROP = "___zrEVENTSAVED";
var $664e052f390bd76e$var$_calcOut = [];
function $664e052f390bd76e$export$8c5c02e118307e20(out, elFrom, elTarget, inX, inY) {
    return $664e052f390bd76e$export$1219648acc517df4($664e052f390bd76e$var$_calcOut, elFrom, inX, inY, true) && $664e052f390bd76e$export$1219648acc517df4(out, elTarget, $664e052f390bd76e$var$_calcOut[0], $664e052f390bd76e$var$_calcOut[1]);
}
function $664e052f390bd76e$export$1219648acc517df4(out, el, inX, inY, inverse) {
    if (el.getBoundingClientRect && (0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported && !$664e052f390bd76e$export$1b92e4fe606eff6d(el)) {
        var saved = el[$664e052f390bd76e$var$EVENT_SAVED_PROP] || (el[$664e052f390bd76e$var$EVENT_SAVED_PROP] = {});
        var markers = $664e052f390bd76e$var$prepareCoordMarkers(el, saved);
        var transformer = $664e052f390bd76e$var$preparePointerTransformer(markers, saved, inverse);
        if (transformer) {
            transformer(out, inX, inY);
            return true;
        }
    }
    return false;
}
function $664e052f390bd76e$var$prepareCoordMarkers(el, saved) {
    var markers = saved.markers;
    if (markers) return markers;
    markers = saved.markers = [];
    var propLR = [
        "left",
        "right"
    ];
    var propTB = [
        "top",
        "bottom"
    ];
    for(var i = 0; i < 4; i++){
        var marker = document.createElement("div");
        var stl = marker.style;
        var idxLR = i % 2;
        var idxTB = (i >> 1) % 2;
        stl.cssText = [
            "position: absolute",
            "visibility: hidden",
            "padding: 0",
            "margin: 0",
            "border-width: 0",
            "user-select: none",
            "width:0",
            "height:0",
            propLR[idxLR] + ":0",
            propTB[idxTB] + ":0",
            propLR[1 - idxLR] + ":auto",
            propTB[1 - idxTB] + ":auto",
            ""
        ].join("!important;");
        el.appendChild(marker);
        markers.push(marker);
    }
    return markers;
}
function $664e052f390bd76e$var$preparePointerTransformer(markers, saved, inverse) {
    var transformerName = inverse ? "invTrans" : "trans";
    var transformer = saved[transformerName];
    var oldSrcCoords = saved.srcCoords;
    var srcCoords = [];
    var destCoords = [];
    var oldCoordTheSame = true;
    for(var i = 0; i < 4; i++){
        var rect = markers[i].getBoundingClientRect();
        var ii = 2 * i;
        var x = rect.left;
        var y = rect.top;
        srcCoords.push(x, y);
        oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
        destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
    }
    return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? (0, $a9b673cb651a68dc$export$fbdb2748a8171a7e)(destCoords, srcCoords) : (0, $a9b673cb651a68dc$export$fbdb2748a8171a7e)(srcCoords, destCoords));
}
function $664e052f390bd76e$export$1b92e4fe606eff6d(el) {
    return el.nodeName.toUpperCase() === "CANVAS";
}
var $664e052f390bd76e$var$replaceReg = /([&<>"'])/g;
var $664e052f390bd76e$var$replaceMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
function $664e052f390bd76e$export$f9d6449b9af28dc1(source) {
    return source == null ? "" : (source + "").replace($664e052f390bd76e$var$replaceReg, function(str, c) {
        return $664e052f390bd76e$var$replaceMap[c];
    });
}


var $b3864a78637ff9ed$var$MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
var $b3864a78637ff9ed$var$_calcOut = [];
var $b3864a78637ff9ed$var$firefoxNotSupportOffsetXY = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).browser.firefox && +(0, $ce6dd58693a21851$export$2e2bcd8739ae039).browser.version.split(".")[0] < 39;
function $b3864a78637ff9ed$export$7d5fecde839eee88(el, e, out, calculate) {
    out = out || {};
    if (calculate) $b3864a78637ff9ed$var$calculateZrXY(el, e, out);
    else if ($b3864a78637ff9ed$var$firefoxNotSupportOffsetXY && e.layerX != null && e.layerX !== e.offsetX) {
        out.zrX = e.layerX;
        out.zrY = e.layerY;
    } else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
    } else $b3864a78637ff9ed$var$calculateZrXY(el, e, out);
    return out;
}
function $b3864a78637ff9ed$var$calculateZrXY(el, e, out) {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported && el.getBoundingClientRect) {
        var ex = e.clientX;
        var ey = e.clientY;
        if ((0, $664e052f390bd76e$export$1b92e4fe606eff6d)(el)) {
            var box = el.getBoundingClientRect();
            out.zrX = ex - box.left;
            out.zrY = ey - box.top;
            return;
        } else if ((0, $664e052f390bd76e$export$1219648acc517df4)($b3864a78637ff9ed$var$_calcOut, el, ex, ey)) {
            out.zrX = $b3864a78637ff9ed$var$_calcOut[0];
            out.zrY = $b3864a78637ff9ed$var$_calcOut[1];
            return;
        }
    }
    out.zrX = out.zrY = 0;
}
function $b3864a78637ff9ed$export$4abe0e945399ac1d(e) {
    return e || window.event;
}
function $b3864a78637ff9ed$export$40fadb093aebad71(el, e, calculate) {
    e = $b3864a78637ff9ed$export$4abe0e945399ac1d(e);
    if (e.zrX != null) return e;
    var eventType = e.type;
    var isTouch = eventType && eventType.indexOf("touch") >= 0;
    if (!isTouch) {
        $b3864a78637ff9ed$export$7d5fecde839eee88(el, e, e, calculate);
        var wheelDelta = $b3864a78637ff9ed$var$getWheelDeltaMayPolyfill(e);
        e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
    } else {
        var touch = eventType !== "touchend" ? e.targetTouches[0] : e.changedTouches[0];
        touch && $b3864a78637ff9ed$export$7d5fecde839eee88(el, touch, e, calculate);
    }
    var button = e.button;
    if (e.which == null && button !== undefined && $b3864a78637ff9ed$var$MOUSE_EVENT_REG.test(e.type)) e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
    return e;
}
function $b3864a78637ff9ed$var$getWheelDeltaMayPolyfill(e) {
    var rawWheelDelta = e.wheelDelta;
    if (rawWheelDelta) return rawWheelDelta;
    var deltaX = e.deltaX;
    var deltaY = e.deltaY;
    if (deltaX == null || deltaY == null) return rawWheelDelta;
    var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
    var sign = deltaY > 0 ? -1 : deltaY < 0 ? 1 : deltaX > 0 ? -1 : 1;
    return 3 * delta * sign;
}
function $b3864a78637ff9ed$export$3f65cefe8380dbea(el, name, handler, opt) {
    el.addEventListener(name, handler, opt);
}
function $b3864a78637ff9ed$export$8ff9f68337b520c0(el, name, handler, opt) {
    el.removeEventListener(name, handler, opt);
}
var $b3864a78637ff9ed$export$fa6813432f753b0d = function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
};
function $b3864a78637ff9ed$export$b7ae4cded3e71bd2(e) {
    return e.which === 2 || e.which === 3;
}



var $225ab5cf635fc62d$export$f7557d6f27e9503 = function() {
    function GestureMgr() {
        this._track = [];
    }
    GestureMgr.prototype.recognize = function(event, target, root) {
        this._doTrack(event, target, root);
        return this._recognize(event);
    };
    GestureMgr.prototype.clear = function() {
        this._track.length = 0;
        return this;
    };
    GestureMgr.prototype._doTrack = function(event, target, root) {
        var touches = event.touches;
        if (!touches) return;
        var trackItem = {
            points: [],
            touches: [],
            target: target,
            event: event
        };
        for(var i = 0, len = touches.length; i < len; i++){
            var touch = touches[i];
            var pos = $b3864a78637ff9ed$export$7d5fecde839eee88(root, touch, {});
            trackItem.points.push([
                pos.zrX,
                pos.zrY
            ]);
            trackItem.touches.push(touch);
        }
        this._track.push(trackItem);
    };
    GestureMgr.prototype._recognize = function(event) {
        for(var eventName in $225ab5cf635fc62d$var$recognizers)if ($225ab5cf635fc62d$var$recognizers.hasOwnProperty(eventName)) {
            var gestureInfo = $225ab5cf635fc62d$var$recognizers[eventName](this._track, event);
            if (gestureInfo) return gestureInfo;
        }
    };
    return GestureMgr;
}();
function $225ab5cf635fc62d$var$dist(pointPair) {
    var dx = pointPair[1][0] - pointPair[0][0];
    var dy = pointPair[1][1] - pointPair[0][1];
    return Math.sqrt(dx * dx + dy * dy);
}
function $225ab5cf635fc62d$var$center(pointPair) {
    return [
        (pointPair[0][0] + pointPair[1][0]) / 2,
        (pointPair[0][1] + pointPair[1][1]) / 2
    ];
}
var $225ab5cf635fc62d$var$recognizers = {
    pinch: function(tracks, event) {
        var trackLen = tracks.length;
        if (!trackLen) return;
        var pinchEnd = (tracks[trackLen - 1] || {}).points;
        var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
        if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
            var pinchScale = $225ab5cf635fc62d$var$dist(pinchEnd) / $225ab5cf635fc62d$var$dist(pinchPre);
            !isFinite(pinchScale) && (pinchScale = 1);
            event.pinchScale = pinchScale;
            var pinchCenter = $225ab5cf635fc62d$var$center(pinchEnd);
            event.pinchX = pinchCenter[0];
            event.pinchY = pinchCenter[1];
            return {
                type: "pinch",
                target: tracks[0].target,
                event: event
            };
        }
    }
};


function $f41ebb9dd60b55b4$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $f41ebb9dd60b55b4$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $f41ebb9dd60b55b4$export$784d13d8ee351f07(out, m) {
    out[0] = m[0];
    out[1] = m[1];
    out[2] = m[2];
    out[3] = m[3];
    out[4] = m[4];
    out[5] = m[5];
    return out;
}
function $f41ebb9dd60b55b4$export$6e3a27864ab166fe(out, m1, m2) {
    var out0 = m1[0] * m2[0] + m1[2] * m2[1];
    var out1 = m1[1] * m2[0] + m1[3] * m2[1];
    var out2 = m1[0] * m2[2] + m1[2] * m2[3];
    var out3 = m1[1] * m2[2] + m1[3] * m2[3];
    var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
    var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = out3;
    out[4] = out4;
    out[5] = out5;
    return out;
}
function $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(out, a, v) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4] + v[0];
    out[5] = a[5] + v[1];
    return out;
}
function $f41ebb9dd60b55b4$export$bb628a54ab399bc9(out, a, rad, pivot) {
    if (pivot === void 0) pivot = [
        0,
        0
    ];
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var st = Math.sin(rad);
    var ct = Math.cos(rad);
    out[0] = aa * ct + ab * st;
    out[1] = -aa * st + ab * ct;
    out[2] = ac * ct + ad * st;
    out[3] = -ac * st + ct * ad;
    out[4] = ct * (atx - pivot[0]) + st * (aty - pivot[1]) + pivot[0];
    out[5] = ct * (aty - pivot[1]) - st * (atx - pivot[0]) + pivot[1];
    return out;
}
function $f41ebb9dd60b55b4$export$dcdf75081b88279d(out, a, v) {
    var vx = v[0];
    var vy = v[1];
    out[0] = a[0] * vx;
    out[1] = a[1] * vy;
    out[2] = a[2] * vx;
    out[3] = a[3] * vy;
    out[4] = a[4] * vx;
    out[5] = a[5] * vy;
    return out;
}
function $f41ebb9dd60b55b4$export$6897c284b6f9f4dc(out, a) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
}
function $f41ebb9dd60b55b4$export$9cd59f9826255e47(a) {
    var b = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
    $f41ebb9dd60b55b4$export$784d13d8ee351f07(b, a);
    return b;
}


var $b887f038f104fe7e$var$Point = function() {
    function Point(x, y) {
        this.x = x || 0;
        this.y = y || 0;
    }
    Point.prototype.copy = function(other) {
        this.x = other.x;
        this.y = other.y;
        return this;
    };
    Point.prototype.clone = function() {
        return new Point(this.x, this.y);
    };
    Point.prototype.set = function(x, y) {
        this.x = x;
        this.y = y;
        return this;
    };
    Point.prototype.equal = function(other) {
        return other.x === this.x && other.y === this.y;
    };
    Point.prototype.add = function(other) {
        this.x += other.x;
        this.y += other.y;
        return this;
    };
    Point.prototype.scale = function(scalar) {
        this.x *= scalar;
        this.y *= scalar;
    };
    Point.prototype.scaleAndAdd = function(other, scalar) {
        this.x += other.x * scalar;
        this.y += other.y * scalar;
    };
    Point.prototype.sub = function(other) {
        this.x -= other.x;
        this.y -= other.y;
        return this;
    };
    Point.prototype.dot = function(other) {
        return this.x * other.x + this.y * other.y;
    };
    Point.prototype.len = function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    };
    Point.prototype.lenSquare = function() {
        return this.x * this.x + this.y * this.y;
    };
    Point.prototype.normalize = function() {
        var len = this.len();
        this.x /= len;
        this.y /= len;
        return this;
    };
    Point.prototype.distance = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Point.prototype.distanceSquare = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return dx * dx + dy * dy;
    };
    Point.prototype.negate = function() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    };
    Point.prototype.transform = function(m) {
        if (!m) return;
        var x = this.x;
        var y = this.y;
        this.x = m[0] * x + m[2] * y + m[4];
        this.y = m[1] * x + m[3] * y + m[5];
        return this;
    };
    Point.prototype.toArray = function(out) {
        out[0] = this.x;
        out[1] = this.y;
        return out;
    };
    Point.prototype.fromArray = function(input) {
        this.x = input[0];
        this.y = input[1];
    };
    Point.set = function(p, x, y) {
        p.x = x;
        p.y = y;
    };
    Point.copy = function(p, p2) {
        p.x = p2.x;
        p.y = p2.y;
    };
    Point.len = function(p) {
        return Math.sqrt(p.x * p.x + p.y * p.y);
    };
    Point.lenSquare = function(p) {
        return p.x * p.x + p.y * p.y;
    };
    Point.dot = function(p0, p1) {
        return p0.x * p1.x + p0.y * p1.y;
    };
    Point.add = function(out, p0, p1) {
        out.x = p0.x + p1.x;
        out.y = p0.y + p1.y;
    };
    Point.sub = function(out, p0, p1) {
        out.x = p0.x - p1.x;
        out.y = p0.y - p1.y;
    };
    Point.scale = function(out, p0, scalar) {
        out.x = p0.x * scalar;
        out.y = p0.y * scalar;
    };
    Point.scaleAndAdd = function(out, p0, p1, scalar) {
        out.x = p0.x + p1.x * scalar;
        out.y = p0.y + p1.y * scalar;
    };
    Point.lerp = function(out, p0, p1, t) {
        var onet = 1 - t;
        out.x = onet * p0.x + t * p1.x;
        out.y = onet * p0.y + t * p1.y;
    };
    return Point;
}();
var $b887f038f104fe7e$export$2e2bcd8739ae039 = $b887f038f104fe7e$var$Point;


var $1bebe7106c895823$var$mathMin = Math.min;
var $1bebe7106c895823$var$mathMax = Math.max;
var $1bebe7106c895823$var$lt = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$rb = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$lb = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$rt = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$minTv = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$maxTv = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $1bebe7106c895823$var$BoundingRect = function() {
    function BoundingRect(x, y, width, height) {
        if (width < 0) {
            x = x + width;
            width = -width;
        }
        if (height < 0) {
            y = y + height;
            height = -height;
        }
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    BoundingRect.prototype.union = function(other) {
        var x = $1bebe7106c895823$var$mathMin(other.x, this.x);
        var y = $1bebe7106c895823$var$mathMin(other.y, this.y);
        if (isFinite(this.x) && isFinite(this.width)) this.width = $1bebe7106c895823$var$mathMax(other.x + other.width, this.x + this.width) - x;
        else this.width = other.width;
        if (isFinite(this.y) && isFinite(this.height)) this.height = $1bebe7106c895823$var$mathMax(other.y + other.height, this.y + this.height) - y;
        else this.height = other.height;
        this.x = x;
        this.y = y;
    };
    BoundingRect.prototype.applyTransform = function(m) {
        BoundingRect.applyTransform(this, this, m);
    };
    BoundingRect.prototype.calculateTransform = function(b) {
        var a = this;
        var sx = b.width / a.width;
        var sy = b.height / a.height;
        var m = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
        $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
            -a.x,
            -a.y
        ]);
        $f41ebb9dd60b55b4$export$dcdf75081b88279d(m, m, [
            sx,
            sy
        ]);
        $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
            b.x,
            b.y
        ]);
        return m;
    };
    BoundingRect.prototype.intersect = function(b, mtv) {
        if (!b) return false;
        if (!(b instanceof BoundingRect)) b = BoundingRect.create(b);
        var a = this;
        var ax0 = a.x;
        var ax1 = a.x + a.width;
        var ay0 = a.y;
        var ay1 = a.y + a.height;
        var bx0 = b.x;
        var bx1 = b.x + b.width;
        var by0 = b.y;
        var by1 = b.y + b.height;
        var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
        if (mtv) {
            var dMin = Infinity;
            var dMax = 0;
            var d0 = Math.abs(ax1 - bx0);
            var d1 = Math.abs(bx1 - ax0);
            var d2 = Math.abs(ay1 - by0);
            var d3 = Math.abs(by1 - ay0);
            var dx = Math.min(d0, d1);
            var dy = Math.min(d2, d3);
            if (ax1 < bx0 || bx1 < ax0) {
                if (dx > dMax) {
                    dMax = dx;
                    if (d0 < d1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$maxTv, -d0, 0);
                    else (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$maxTv, d1, 0);
                }
            } else if (dx < dMin) {
                dMin = dx;
                if (d0 < d1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$minTv, d0, 0);
                else (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$minTv, -d1, 0);
            }
            if (ay1 < by0 || by1 < ay0) {
                if (dy > dMax) {
                    dMax = dy;
                    if (d2 < d3) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$maxTv, 0, -d2);
                    else (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$maxTv, 0, d3);
                }
            } else if (dx < dMin) {
                dMin = dx;
                if (d2 < d3) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$minTv, 0, d2);
                else (0, $b887f038f104fe7e$export$2e2bcd8739ae039).set($1bebe7106c895823$var$minTv, 0, -d3);
            }
        }
        if (mtv) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy(mtv, overlap ? $1bebe7106c895823$var$minTv : $1bebe7106c895823$var$maxTv);
        return overlap;
    };
    BoundingRect.prototype.contain = function(x, y) {
        var rect = this;
        return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
    };
    BoundingRect.prototype.clone = function() {
        return new BoundingRect(this.x, this.y, this.width, this.height);
    };
    BoundingRect.prototype.copy = function(other) {
        BoundingRect.copy(this, other);
    };
    BoundingRect.prototype.plain = function() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    };
    BoundingRect.prototype.isFinite = function() {
        return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
    };
    BoundingRect.prototype.isZero = function() {
        return this.width === 0 || this.height === 0;
    };
    BoundingRect.create = function(rect) {
        return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
    };
    BoundingRect.copy = function(target, source) {
        target.x = source.x;
        target.y = source.y;
        target.width = source.width;
        target.height = source.height;
    };
    BoundingRect.applyTransform = function(target, source, m) {
        if (!m) {
            if (target !== source) BoundingRect.copy(target, source);
            return;
        }
        if (m[1] < 1e-5 && m[1] > -0.00001 && m[2] < 1e-5 && m[2] > -0.00001) {
            var sx = m[0];
            var sy = m[3];
            var tx = m[4];
            var ty = m[5];
            target.x = source.x * sx + tx;
            target.y = source.y * sy + ty;
            target.width = source.width * sx;
            target.height = source.height * sy;
            if (target.width < 0) {
                target.x += target.width;
                target.width = -target.width;
            }
            if (target.height < 0) {
                target.y += target.height;
                target.height = -target.height;
            }
            return;
        }
        $1bebe7106c895823$var$lt.x = $1bebe7106c895823$var$lb.x = source.x;
        $1bebe7106c895823$var$lt.y = $1bebe7106c895823$var$rt.y = source.y;
        $1bebe7106c895823$var$rb.x = $1bebe7106c895823$var$rt.x = source.x + source.width;
        $1bebe7106c895823$var$rb.y = $1bebe7106c895823$var$lb.y = source.y + source.height;
        $1bebe7106c895823$var$lt.transform(m);
        $1bebe7106c895823$var$rt.transform(m);
        $1bebe7106c895823$var$rb.transform(m);
        $1bebe7106c895823$var$lb.transform(m);
        target.x = $1bebe7106c895823$var$mathMin($1bebe7106c895823$var$lt.x, $1bebe7106c895823$var$rb.x, $1bebe7106c895823$var$lb.x, $1bebe7106c895823$var$rt.x);
        target.y = $1bebe7106c895823$var$mathMin($1bebe7106c895823$var$lt.y, $1bebe7106c895823$var$rb.y, $1bebe7106c895823$var$lb.y, $1bebe7106c895823$var$rt.y);
        var maxX = $1bebe7106c895823$var$mathMax($1bebe7106c895823$var$lt.x, $1bebe7106c895823$var$rb.x, $1bebe7106c895823$var$lb.x, $1bebe7106c895823$var$rt.x);
        var maxY = $1bebe7106c895823$var$mathMax($1bebe7106c895823$var$lt.y, $1bebe7106c895823$var$rb.y, $1bebe7106c895823$var$lb.y, $1bebe7106c895823$var$rt.y);
        target.width = maxX - target.x;
        target.height = maxY - target.y;
    };
    return BoundingRect;
}();
var $1bebe7106c895823$export$2e2bcd8739ae039 = $1bebe7106c895823$var$BoundingRect;


var $b30f5d021af2ec5a$var$SILENT = "silent";
function $b30f5d021af2ec5a$var$makeEventPacket(eveType, targetInfo, event) {
    return {
        type: eveType,
        event: event,
        target: targetInfo.target,
        topTarget: targetInfo.topTarget,
        cancelBubble: false,
        offsetX: event.zrX,
        offsetY: event.zrY,
        gestureEvent: event.gestureEvent,
        pinchX: event.pinchX,
        pinchY: event.pinchY,
        pinchScale: event.pinchScale,
        wheelDelta: event.zrDelta,
        zrByTouch: event.zrByTouch,
        which: event.which,
        stop: $b30f5d021af2ec5a$var$stopEvent
    };
}
function $b30f5d021af2ec5a$var$stopEvent() {
    $b3864a78637ff9ed$export$fa6813432f753b0d(this.event);
}
var $b30f5d021af2ec5a$var$EmptyProxy = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(EmptyProxy, _super);
    function EmptyProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handler = null;
        return _this;
    }
    EmptyProxy.prototype.dispose = function() {};
    EmptyProxy.prototype.setCursor = function() {};
    return EmptyProxy;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $b30f5d021af2ec5a$var$HoveredResult = function() {
    function HoveredResult(x, y) {
        this.x = x;
        this.y = y;
    }
    return HoveredResult;
}();
var $b30f5d021af2ec5a$var$handlerNames = [
    "click",
    "dblclick",
    "mousewheel",
    "mouseout",
    "mouseup",
    "mousedown",
    "mousemove",
    "contextmenu"
];
var $b30f5d021af2ec5a$var$tmpRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $b30f5d021af2ec5a$var$Handler = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Handler, _super);
    function Handler(storage, painter, proxy, painterRoot, pointerSize) {
        var _this = _super.call(this) || this;
        _this._hovered = new $b30f5d021af2ec5a$var$HoveredResult(0, 0);
        _this.storage = storage;
        _this.painter = painter;
        _this.painterRoot = painterRoot;
        _this._pointerSize = pointerSize;
        proxy = proxy || new $b30f5d021af2ec5a$var$EmptyProxy();
        _this.proxy = null;
        _this.setHandlerProxy(proxy);
        _this._draggingMgr = new (0, $4e8ea7ab4b22b6b2$export$2e2bcd8739ae039)(_this);
        return _this;
    }
    Handler.prototype.setHandlerProxy = function(proxy) {
        if (this.proxy) this.proxy.dispose();
        if (proxy) {
            $7a1bd9c2710fea0d$export$79b2f7037acddd43($b30f5d021af2ec5a$var$handlerNames, function(name) {
                proxy.on && proxy.on(name, this[name], this);
            }, this);
            proxy.handler = this;
        }
        this.proxy = proxy;
    };
    Handler.prototype.mousemove = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $b30f5d021af2ec5a$var$isOutsideBoundary(this, x, y);
        var lastHovered = this._hovered;
        var lastHoveredTarget = lastHovered.target;
        if (lastHoveredTarget && !lastHoveredTarget.__zr) {
            lastHovered = this.findHover(lastHovered.x, lastHovered.y);
            lastHoveredTarget = lastHovered.target;
        }
        var hovered = this._hovered = isOutside ? new $b30f5d021af2ec5a$var$HoveredResult(x, y) : this.findHover(x, y);
        var hoveredTarget = hovered.target;
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : "default");
        if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(lastHovered, "mouseout", event);
        this.dispatchToElement(hovered, "mousemove", event);
        if (hoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(hovered, "mouseover", event);
    };
    Handler.prototype.mouseout = function(event) {
        var eventControl = event.zrEventControl;
        if (eventControl !== "only_globalout") this.dispatchToElement(this._hovered, "mouseout", event);
        if (eventControl !== "no_globalout") this.trigger("globalout", {
            type: "globalout",
            event: event
        });
    };
    Handler.prototype.resize = function() {
        this._hovered = new $b30f5d021af2ec5a$var$HoveredResult(0, 0);
    };
    Handler.prototype.dispatch = function(eventName, eventArgs) {
        var handler = this[eventName];
        handler && handler.call(this, eventArgs);
    };
    Handler.prototype.dispose = function() {
        this.proxy.dispose();
        this.storage = null;
        this.proxy = null;
        this.painter = null;
    };
    Handler.prototype.setCursorStyle = function(cursorStyle) {
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(cursorStyle);
    };
    Handler.prototype.dispatchToElement = function(targetInfo, eventName, event) {
        targetInfo = targetInfo || {};
        var el = targetInfo.target;
        if (el && el.silent) return;
        var eventKey = "on" + eventName;
        var eventPacket = $b30f5d021af2ec5a$var$makeEventPacket(eventName, targetInfo, event);
        while(el){
            el[eventKey] && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
            el.trigger(eventName, eventPacket);
            el = el.__hostTarget ? el.__hostTarget : el.parent;
            if (eventPacket.cancelBubble) break;
        }
        if (!eventPacket.cancelBubble) {
            this.trigger(eventName, eventPacket);
            if (this.painter && this.painter.eachOtherLayer) this.painter.eachOtherLayer(function(layer) {
                if (typeof layer[eventKey] === "function") layer[eventKey].call(layer, eventPacket);
                if (layer.trigger) layer.trigger(eventName, eventPacket);
            });
        }
    };
    Handler.prototype.findHover = function(x, y, exclude) {
        var list = this.storage.getDisplayList();
        var out = new $b30f5d021af2ec5a$var$HoveredResult(x, y);
        $b30f5d021af2ec5a$var$setHoverTarget(list, out, x, y, exclude);
        if (this._pointerSize && !out.target) {
            var candidates = [];
            var pointerSize = this._pointerSize;
            var targetSizeHalf = pointerSize / 2;
            var pointerRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x - targetSizeHalf, y - targetSizeHalf, pointerSize, pointerSize);
            for(var i = list.length - 1; i >= 0; i--){
                var el = list[i];
                if (el !== exclude && !el.ignore && !el.ignoreCoarsePointer && (!el.parent || !el.parent.ignoreCoarsePointer)) {
                    $b30f5d021af2ec5a$var$tmpRect.copy(el.getBoundingRect());
                    if (el.transform) $b30f5d021af2ec5a$var$tmpRect.applyTransform(el.transform);
                    if ($b30f5d021af2ec5a$var$tmpRect.intersect(pointerRect)) candidates.push(el);
                }
            }
            if (candidates.length) {
                var rStep = 4;
                var thetaStep = Math.PI / 12;
                var PI2 = Math.PI * 2;
                for(var r = 0; r < targetSizeHalf; r += rStep)for(var theta = 0; theta < PI2; theta += thetaStep){
                    var x1 = x + r * Math.cos(theta);
                    var y1 = y + r * Math.sin(theta);
                    $b30f5d021af2ec5a$var$setHoverTarget(candidates, out, x1, y1, exclude);
                    if (out.target) return out;
                }
            }
        }
        return out;
    };
    Handler.prototype.processGesture = function(event, stage) {
        if (!this._gestureMgr) this._gestureMgr = new (0, $225ab5cf635fc62d$export$f7557d6f27e9503)();
        var gestureMgr = this._gestureMgr;
        stage === "start" && gestureMgr.clear();
        var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
        stage === "end" && gestureMgr.clear();
        if (gestureInfo) {
            var type = gestureInfo.type;
            event.gestureEvent = type;
            var res = new $b30f5d021af2ec5a$var$HoveredResult();
            res.target = gestureInfo.target;
            this.dispatchToElement(res, type, gestureInfo.event);
        }
    };
    return Handler;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$79b2f7037acddd43([
    "click",
    "mousedown",
    "mouseup",
    "mousewheel",
    "dblclick",
    "contextmenu"
], function(name) {
    $b30f5d021af2ec5a$var$Handler.prototype[name] = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $b30f5d021af2ec5a$var$isOutsideBoundary(this, x, y);
        var hovered;
        var hoveredTarget;
        if (name !== "mouseup" || !isOutside) {
            hovered = this.findHover(x, y);
            hoveredTarget = hovered.target;
        }
        if (name === "mousedown") {
            this._downEl = hoveredTarget;
            this._downPoint = [
                event.zrX,
                event.zrY
            ];
            this._upEl = hoveredTarget;
        } else if (name === "mouseup") this._upEl = hoveredTarget;
        else if (name === "click") {
            if (this._downEl !== this._upEl || !this._downPoint || $6de594cf8ac295ff$export$6c4a311cc157c764(this._downPoint, [
                event.zrX,
                event.zrY
            ]) > 4) return;
            this._downPoint = null;
        }
        this.dispatchToElement(hovered, name, event);
    };
});
function $b30f5d021af2ec5a$var$isHover(displayable, x, y) {
    if (displayable[displayable.rectHover ? "rectContain" : "contain"](x, y)) {
        var el = displayable;
        var isSilent = void 0;
        var ignoreClip = false;
        while(el){
            if (el.ignoreClip) ignoreClip = true;
            if (!ignoreClip) {
                var clipPath = el.getClipPath();
                if (clipPath && !clipPath.contain(x, y)) return false;
            }
            if (el.silent) isSilent = true;
            var hostEl = el.__hostTarget;
            el = hostEl ? hostEl : el.parent;
        }
        return isSilent ? $b30f5d021af2ec5a$var$SILENT : true;
    }
    return false;
}
function $b30f5d021af2ec5a$var$setHoverTarget(list, out, x, y, exclude) {
    for(var i = list.length - 1; i >= 0; i--){
        var el = list[i];
        var hoverCheckResult = void 0;
        if (el !== exclude && !el.ignore && (hoverCheckResult = $b30f5d021af2ec5a$var$isHover(el, x, y))) {
            !out.topTarget && (out.topTarget = el);
            if (hoverCheckResult !== $b30f5d021af2ec5a$var$SILENT) {
                out.target = el;
                break;
            }
        }
    }
}
function $b30f5d021af2ec5a$var$isOutsideBoundary(handlerInstance, x, y) {
    var painter = handlerInstance.painter;
    return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
}
var $b30f5d021af2ec5a$export$2e2bcd8739ae039 = $b30f5d021af2ec5a$var$Handler;



var $97579a54749e4b24$var$DEFAULT_MIN_MERGE = 32;
var $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING = 7;
function $97579a54749e4b24$var$minRunLength(n) {
    var r = 0;
    while(n >= $97579a54749e4b24$var$DEFAULT_MIN_MERGE){
        r |= n & 1;
        n >>= 1;
    }
    return n + r;
}
function $97579a54749e4b24$var$makeAscendingRun(array, lo, hi, compare) {
    var runHi = lo + 1;
    if (runHi === hi) return 1;
    if (compare(array[runHi++], array[lo]) < 0) {
        while(runHi < hi && compare(array[runHi], array[runHi - 1]) < 0)runHi++;
        $97579a54749e4b24$var$reverseRun(array, lo, runHi);
    } else while(runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0)runHi++;
    return runHi - lo;
}
function $97579a54749e4b24$var$reverseRun(array, lo, hi) {
    hi--;
    while(lo < hi){
        var t = array[lo];
        array[lo++] = array[hi];
        array[hi--] = t;
    }
}
function $97579a54749e4b24$var$binaryInsertionSort(array, lo, hi, start, compare) {
    if (start === lo) start++;
    for(; start < hi; start++){
        var pivot = array[start];
        var left = lo;
        var right = start;
        var mid;
        while(left < right){
            mid = left + right >>> 1;
            if (compare(pivot, array[mid]) < 0) right = mid;
            else left = mid + 1;
        }
        var n = start - left;
        switch(n){
            case 3:
                array[left + 3] = array[left + 2];
            case 2:
                array[left + 2] = array[left + 1];
            case 1:
                array[left + 1] = array[left];
                break;
            default:
                while(n > 0){
                    array[left + n] = array[left + n - 1];
                    n--;
                }
        }
        array[left] = pivot;
    }
}
function $97579a54749e4b24$var$gallopLeft(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) > 0) {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) > 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    } else {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) <= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) > 0) lastOffset = m + 1;
        else offset = m;
    }
    return offset;
}
function $97579a54749e4b24$var$gallopRight(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) < 0) {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) < 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    } else {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) >= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) < 0) offset = m;
        else lastOffset = m + 1;
    }
    return offset;
}
function $97579a54749e4b24$var$TimSort(array, compare) {
    var minGallop = $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING;
    var runStart;
    var runLength;
    var stackSize = 0;
    var tmp = [];
    runStart = [];
    runLength = [];
    function pushRun(_runStart, _runLength) {
        runStart[stackSize] = _runStart;
        runLength[stackSize] = _runLength;
        stackSize += 1;
    }
    function mergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
                if (runLength[n - 1] < runLength[n + 1]) n--;
            } else if (runLength[n] > runLength[n + 1]) break;
            mergeAt(n);
        }
    }
    function forceMergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n > 0 && runLength[n - 1] < runLength[n + 1]) n--;
            mergeAt(n);
        }
    }
    function mergeAt(i) {
        var start1 = runStart[i];
        var length1 = runLength[i];
        var start2 = runStart[i + 1];
        var length2 = runLength[i + 1];
        runLength[i] = length1 + length2;
        if (i === stackSize - 3) {
            runStart[i + 1] = runStart[i + 2];
            runLength[i + 1] = runLength[i + 2];
        }
        stackSize--;
        var k = $97579a54749e4b24$var$gallopRight(array[start2], array, start1, length1, 0, compare);
        start1 += k;
        length1 -= k;
        if (length1 === 0) return;
        length2 = $97579a54749e4b24$var$gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
        if (length2 === 0) return;
        if (length1 <= length2) mergeLow(start1, length1, start2, length2);
        else mergeHigh(start1, length1, start2, length2);
    }
    function mergeLow(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length1; i++)tmp[i] = array[start1 + i];
        var cursor1 = 0;
        var cursor2 = start2;
        var dest = start1;
        array[dest++] = array[cursor2++];
        if (--length2 === 0) {
            for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
            return;
        }
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
            return;
        }
        var _minGallop = minGallop;
        var count1;
        var count2;
        var exit;
        while(true){
            count1 = 0;
            count2 = 0;
            exit = false;
            do if (compare(array[cursor2], tmp[cursor1]) < 0) {
                array[dest++] = array[cursor2++];
                count2++;
                count1 = 0;
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest++] = tmp[cursor1++];
                count1++;
                count2 = 0;
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = $97579a54749e4b24$var$gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                if (count1 !== 0) {
                    for(i = 0; i < count1; i++)array[dest + i] = tmp[cursor1 + i];
                    dest += count1;
                    cursor1 += count1;
                    length1 -= count1;
                    if (length1 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = array[cursor2++];
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
                count2 = $97579a54749e4b24$var$gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                if (count2 !== 0) {
                    for(i = 0; i < count2; i++)array[dest + i] = array[cursor2 + i];
                    dest += count2;
                    cursor2 += count2;
                    length2 -= count2;
                    if (length2 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = tmp[cursor1++];
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING || count2 >= $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        minGallop < 1 && (minGallop = 1);
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
        } else if (length1 === 0) throw new Error();
        else for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
    }
    function mergeHigh(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length2; i++)tmp[i] = array[start2 + i];
        var cursor1 = start1 + length1 - 1;
        var cursor2 = length2 - 1;
        var dest = start2 + length2 - 1;
        var customCursor = 0;
        var customDest = 0;
        array[dest--] = array[cursor1--];
        if (--length1 === 0) {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
            return;
        }
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
            return;
        }
        var _minGallop = minGallop;
        while(true){
            var count1 = 0;
            var count2 = 0;
            var exit = false;
            do if (compare(tmp[cursor2], array[cursor1]) < 0) {
                array[dest--] = array[cursor1--];
                count1++;
                count2 = 0;
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest--] = tmp[cursor2--];
                count2++;
                count1 = 0;
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = length1 - $97579a54749e4b24$var$gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                if (count1 !== 0) {
                    dest -= count1;
                    cursor1 -= count1;
                    length1 -= count1;
                    customDest = dest + 1;
                    customCursor = cursor1 + 1;
                    for(i = count1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                    if (length1 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = tmp[cursor2--];
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
                count2 = length2 - $97579a54749e4b24$var$gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                if (count2 !== 0) {
                    dest -= count2;
                    cursor2 -= count2;
                    length2 -= count2;
                    customDest = dest + 1;
                    customCursor = cursor2 + 1;
                    for(i = 0; i < count2; i++)array[customDest + i] = tmp[customCursor + i];
                    if (length2 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = array[cursor1--];
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING || count2 >= $97579a54749e4b24$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        if (minGallop < 1) minGallop = 1;
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
        } else if (length2 === 0) throw new Error();
        else {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
        }
    }
    return {
        mergeRuns: mergeRuns,
        forceMergeRuns: forceMergeRuns,
        pushRun: pushRun
    };
}
function $97579a54749e4b24$export$2e2bcd8739ae039(array, compare, lo, hi) {
    if (!lo) lo = 0;
    if (!hi) hi = array.length;
    var remaining = hi - lo;
    if (remaining < 2) return;
    var runLength = 0;
    if (remaining < $97579a54749e4b24$var$DEFAULT_MIN_MERGE) {
        runLength = $97579a54749e4b24$var$makeAscendingRun(array, lo, hi, compare);
        $97579a54749e4b24$var$binaryInsertionSort(array, lo, hi, lo + runLength, compare);
        return;
    }
    var ts = $97579a54749e4b24$var$TimSort(array, compare);
    var minRun = $97579a54749e4b24$var$minRunLength(remaining);
    do {
        runLength = $97579a54749e4b24$var$makeAscendingRun(array, lo, hi, compare);
        if (runLength < minRun) {
            var force = remaining;
            if (force > minRun) force = minRun;
            $97579a54749e4b24$var$binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
            runLength = force;
        }
        ts.pushRun(lo, runLength);
        ts.mergeRuns();
        remaining -= runLength;
        lo += runLength;
    }while (remaining !== 0);
    ts.forceMergeRuns();
}


var $ddf76b16f1246ba9$export$a7b6db622c6c7dbd = 1;
var $ddf76b16f1246ba9$export$ada8b2beb3d76671 = 2;
var $ddf76b16f1246ba9$export$f75fe89a33ebe115 = 4;


var $319574df0bc66e80$var$invalidZErrorLogged = false;
function $319574df0bc66e80$var$logInvalidZError() {
    if ($319574df0bc66e80$var$invalidZErrorLogged) return;
    $319574df0bc66e80$var$invalidZErrorLogged = true;
    console.warn("z / z2 / zlevel of displayable is invalid, which may cause unexpected errors");
}
function $319574df0bc66e80$var$shapeCompareFunc(a, b) {
    if (a.zlevel === b.zlevel) {
        if (a.z === b.z) return a.z2 - b.z2;
        return a.z - b.z;
    }
    return a.zlevel - b.zlevel;
}
var $319574df0bc66e80$var$Storage = function() {
    function Storage() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        this.displayableSortFunc = $319574df0bc66e80$var$shapeCompareFunc;
    }
    Storage.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._roots.length; i++)this._roots[i].traverse(cb, context);
    };
    Storage.prototype.getDisplayList = function(update, includeIgnore) {
        includeIgnore = includeIgnore || false;
        var displayList = this._displayList;
        if (update || !displayList.length) this.updateDisplayList(includeIgnore);
        return displayList;
    };
    Storage.prototype.updateDisplayList = function(includeIgnore) {
        this._displayListLen = 0;
        var roots = this._roots;
        var displayList = this._displayList;
        for(var i = 0, len = roots.length; i < len; i++)this._updateAndAddDisplayable(roots[i], null, includeIgnore);
        displayList.length = this._displayListLen;
        (0, $97579a54749e4b24$export$2e2bcd8739ae039)(displayList, $319574df0bc66e80$var$shapeCompareFunc);
    };
    Storage.prototype._updateAndAddDisplayable = function(el, clipPaths, includeIgnore) {
        if (el.ignore && !includeIgnore) return;
        el.beforeUpdate();
        el.update();
        el.afterUpdate();
        var userSetClipPath = el.getClipPath();
        if (el.ignoreClip) clipPaths = null;
        else if (userSetClipPath) {
            if (clipPaths) clipPaths = clipPaths.slice();
            else clipPaths = [];
            var currentClipPath = userSetClipPath;
            var parentClipPath = el;
            while(currentClipPath){
                currentClipPath.parent = parentClipPath;
                currentClipPath.updateTransform();
                clipPaths.push(currentClipPath);
                parentClipPath = currentClipPath;
                currentClipPath = currentClipPath.getClipPath();
            }
        }
        if (el.childrenRef) {
            var children = el.childrenRef();
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (el.__dirty) child.__dirty |= (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
                this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
            }
            el.__dirty = 0;
        } else {
            var disp = el;
            if (clipPaths && clipPaths.length) disp.__clipPaths = clipPaths;
            else if (disp.__clipPaths && disp.__clipPaths.length > 0) disp.__clipPaths = [];
            if (isNaN(disp.z)) {
                $319574df0bc66e80$var$logInvalidZError();
                disp.z = 0;
            }
            if (isNaN(disp.z2)) {
                $319574df0bc66e80$var$logInvalidZError();
                disp.z2 = 0;
            }
            if (isNaN(disp.zlevel)) {
                $319574df0bc66e80$var$logInvalidZError();
                disp.zlevel = 0;
            }
            this._displayList[this._displayListLen++] = disp;
        }
        var decalEl = el.getDecalElement && el.getDecalElement();
        if (decalEl) this._updateAndAddDisplayable(decalEl, clipPaths, includeIgnore);
        var textGuide = el.getTextGuideLine();
        if (textGuide) this._updateAndAddDisplayable(textGuide, clipPaths, includeIgnore);
        var textEl = el.getTextContent();
        if (textEl) this._updateAndAddDisplayable(textEl, clipPaths, includeIgnore);
    };
    Storage.prototype.addRoot = function(el) {
        if (el.__zr && el.__zr.storage === this) return;
        this._roots.push(el);
    };
    Storage.prototype.delRoot = function(el) {
        if (el instanceof Array) {
            for(var i = 0, l = el.length; i < l; i++)this.delRoot(el[i]);
            return;
        }
        var idx = $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(this._roots, el);
        if (idx >= 0) this._roots.splice(idx, 1);
    };
    Storage.prototype.delAllRoots = function() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        return;
    };
    Storage.prototype.getRoots = function() {
        return this._roots;
    };
    Storage.prototype.dispose = function() {
        this._displayList = null;
        this._roots = null;
    };
    return Storage;
}();
var $319574df0bc66e80$export$2e2bcd8739ae039 = $319574df0bc66e80$var$Storage;





var $731d42ad1858cd4c$var$requestAnimationFrame;
$731d42ad1858cd4c$var$requestAnimationFrame = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).hasGlobalWindow && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(func) {
    return setTimeout(func, 16);
};
var $731d42ad1858cd4c$export$2e2bcd8739ae039 = $731d42ad1858cd4c$var$requestAnimationFrame;


var $9668111025b0b56f$var$easingFuncs = {
    linear: function(k) {
        return k;
    },
    quadraticIn: function(k) {
        return k * k;
    },
    quadraticOut: function(k) {
        return k * (2 - k);
    },
    quadraticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k;
        return -0.5 * (--k * (k - 2) - 1);
    },
    cubicIn: function(k) {
        return k * k * k;
    },
    cubicOut: function(k) {
        return --k * k * k + 1;
    },
    cubicInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k;
        return 0.5 * ((k -= 2) * k * k + 2);
    },
    quarticIn: function(k) {
        return k * k * k * k;
    },
    quarticOut: function(k) {
        return 1 - --k * k * k * k;
    },
    quarticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k;
        return -0.5 * ((k -= 2) * k * k * k - 2);
    },
    quinticIn: function(k) {
        return k * k * k * k * k;
    },
    quinticOut: function(k) {
        return --k * k * k * k * k + 1;
    },
    quinticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
        return 0.5 * ((k -= 2) * k * k * k * k + 2);
    },
    sinusoidalIn: function(k) {
        return 1 - Math.cos(k * Math.PI / 2);
    },
    sinusoidalOut: function(k) {
        return Math.sin(k * Math.PI / 2);
    },
    sinusoidalInOut: function(k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    },
    exponentialIn: function(k) {
        return k === 0 ? 0 : Math.pow(1024, k - 1);
    },
    exponentialOut: function(k) {
        return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
    },
    exponentialInOut: function(k) {
        if (k === 0) return 0;
        if (k === 1) return 1;
        if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
        return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
    },
    circularIn: function(k) {
        return 1 - Math.sqrt(1 - k * k);
    },
    circularOut: function(k) {
        return Math.sqrt(1 - --k * k);
    },
    circularInOut: function(k) {
        if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
        return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
    },
    elasticIn: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
    },
    elasticOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
    },
    elasticInOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        if ((k *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
        return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
    },
    backIn: function(k) {
        var s = 1.70158;
        return k * k * ((s + 1) * k - s);
    },
    backOut: function(k) {
        var s = 1.70158;
        return --k * k * ((s + 1) * k + s) + 1;
    },
    backInOut: function(k) {
        var s = 2.5949095;
        if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
        return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
    },
    bounceIn: function(k) {
        return 1 - $9668111025b0b56f$var$easingFuncs.bounceOut(1 - k);
    },
    bounceOut: function(k) {
        if (k < 1 / 2.75) return 7.5625 * k * k;
        else if (k < 2 / 2.75) return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
        else if (k < 2.5 / 2.75) return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
        else return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    },
    bounceInOut: function(k) {
        if (k < 0.5) return $9668111025b0b56f$var$easingFuncs.bounceIn(k * 2) * 0.5;
        return $9668111025b0b56f$var$easingFuncs.bounceOut(k * 2 - 1) * 0.5 + 0.5;
    }
};
var $9668111025b0b56f$export$2e2bcd8739ae039 = $9668111025b0b56f$var$easingFuncs;




var $747cfc5611b57cea$var$mathPow = Math.pow;
var $747cfc5611b57cea$var$mathSqrt = Math.sqrt;
var $747cfc5611b57cea$var$EPSILON = 1e-8;
var $747cfc5611b57cea$var$EPSILON_NUMERIC = 1e-4;
var $747cfc5611b57cea$var$THREE_SQRT = $747cfc5611b57cea$var$mathSqrt(3);
var $747cfc5611b57cea$var$ONE_THIRD = 1 / 3;
var $747cfc5611b57cea$var$_v0 = (0, $6de594cf8ac295ff$export$185802fd694ee1f5)();
var $747cfc5611b57cea$var$_v1 = (0, $6de594cf8ac295ff$export$185802fd694ee1f5)();
var $747cfc5611b57cea$var$_v2 = (0, $6de594cf8ac295ff$export$185802fd694ee1f5)();
function $747cfc5611b57cea$var$isAroundZero(val) {
    return val > -$747cfc5611b57cea$var$EPSILON && val < $747cfc5611b57cea$var$EPSILON;
}
function $747cfc5611b57cea$var$isNotAroundZero(val) {
    return val > $747cfc5611b57cea$var$EPSILON || val < -$747cfc5611b57cea$var$EPSILON;
}
function $747cfc5611b57cea$export$547c21de482bbcb2(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
}
function $747cfc5611b57cea$export$55fce925c60b6271(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
}
function $747cfc5611b57cea$export$ca5d13faa10b167e(p0, p1, p2, p3, val, roots) {
    var a = p3 + 3 * (p1 - p2) - p0;
    var b = 3 * (p2 - p1 * 2 + p0);
    var c = 3 * (p1 - p0);
    var d = p0 - val;
    var A = b * b - 3 * a * c;
    var B = b * c - 9 * a * d;
    var C = c * c - 3 * b * d;
    var n = 0;
    if ($747cfc5611b57cea$var$isAroundZero(A) && $747cfc5611b57cea$var$isAroundZero(B)) {
        if ($747cfc5611b57cea$var$isAroundZero(b)) roots[0] = 0;
        else {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = B * B - 4 * A * C;
        if ($747cfc5611b57cea$var$isAroundZero(disc)) {
            var K = B / A;
            var t1 = -b / a + K;
            var t2 = -K / 2;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        } else if (disc > 0) {
            var discSqrt = $747cfc5611b57cea$var$mathSqrt(disc);
            var Y1 = A * b + 1.5 * a * (-B + discSqrt);
            var Y2 = A * b + 1.5 * a * (-B - discSqrt);
            if (Y1 < 0) Y1 = -$747cfc5611b57cea$var$mathPow(-Y1, $747cfc5611b57cea$var$ONE_THIRD);
            else Y1 = $747cfc5611b57cea$var$mathPow(Y1, $747cfc5611b57cea$var$ONE_THIRD);
            if (Y2 < 0) Y2 = -$747cfc5611b57cea$var$mathPow(-Y2, $747cfc5611b57cea$var$ONE_THIRD);
            else Y2 = $747cfc5611b57cea$var$mathPow(Y2, $747cfc5611b57cea$var$ONE_THIRD);
            var t1 = (-b - (Y1 + Y2)) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else {
            var T = (2 * A * b - 3 * a * B) / (2 * $747cfc5611b57cea$var$mathSqrt(A * A * A));
            var theta = Math.acos(T) / 3;
            var ASqrt = $747cfc5611b57cea$var$mathSqrt(A);
            var tmp = Math.cos(theta);
            var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
            var t2 = (-b + ASqrt * (tmp + $747cfc5611b57cea$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            var t3 = (-b + ASqrt * (tmp - $747cfc5611b57cea$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            if (t3 >= 0 && t3 <= 1) roots[n++] = t3;
        }
    }
    return n;
}
function $747cfc5611b57cea$export$df1a172f100d0457(p0, p1, p2, p3, extrema) {
    var b = 6 * p2 - 12 * p1 + 6 * p0;
    var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
    var c = 3 * p1 - 3 * p0;
    var n = 0;
    if ($747cfc5611b57cea$var$isAroundZero(a)) {
        if ($747cfc5611b57cea$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($747cfc5611b57cea$var$isAroundZero(disc)) extrema[0] = -b / (2 * a);
        else if (disc > 0) {
            var discSqrt = $747cfc5611b57cea$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
            if (t2 >= 0 && t2 <= 1) extrema[n++] = t2;
        }
    }
    return n;
}
function $747cfc5611b57cea$export$a2ee23a0567039da(p0, p1, p2, p3, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p23 = (p3 - p2) * t + p2;
    var p012 = (p12 - p01) * t + p01;
    var p123 = (p23 - p12) * t + p12;
    var p0123 = (p123 - p012) * t + p012;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p0123;
    out[4] = p0123;
    out[5] = p123;
    out[6] = p23;
    out[7] = p3;
}
function $747cfc5611b57cea$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    var prev;
    var next;
    var d1;
    var d2;
    $747cfc5611b57cea$var$_v0[0] = x;
    $747cfc5611b57cea$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $747cfc5611b57cea$var$_v1[0] = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, _t);
        $747cfc5611b57cea$var$_v1[1] = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, _t);
        d1 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v0, $747cfc5611b57cea$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $747cfc5611b57cea$var$EPSILON_NUMERIC) break;
        prev = t - interval;
        next = t + interval;
        $747cfc5611b57cea$var$_v1[0] = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, prev);
        $747cfc5611b57cea$var$_v1[1] = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, prev);
        d1 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v1, $747cfc5611b57cea$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $747cfc5611b57cea$var$_v2[0] = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, next);
            $747cfc5611b57cea$var$_v2[1] = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, next);
            d2 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v2, $747cfc5611b57cea$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        out[1] = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, t);
    }
    return $747cfc5611b57cea$var$mathSqrt(d);
}
function $747cfc5611b57cea$export$af1875d576f60d7c(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        var y = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}
function $747cfc5611b57cea$export$af17094a950f5073(p0, p1, p2, t) {
    var onet = 1 - t;
    return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
function $747cfc5611b57cea$export$7e161e77e6fff8cb(p0, p1, p2, t) {
    return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
function $747cfc5611b57cea$export$fd895ac7ee764967(p0, p1, p2, val, roots) {
    var a = p0 - 2 * p1 + p2;
    var b = 2 * (p1 - p0);
    var c = p0 - val;
    var n = 0;
    if ($747cfc5611b57cea$var$isAroundZero(a)) {
        if ($747cfc5611b57cea$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($747cfc5611b57cea$var$isAroundZero(disc)) {
            var t1 = -b / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else if (disc > 0) {
            var discSqrt = $747cfc5611b57cea$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        }
    }
    return n;
}
function $747cfc5611b57cea$export$752e1f8c6e7f7e11(p0, p1, p2) {
    var divider = p0 + p2 - 2 * p1;
    if (divider === 0) return 0.5;
    else return (p0 - p1) / divider;
}
function $747cfc5611b57cea$export$117c659e21a7a060(p0, p1, p2, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p012 = (p12 - p01) * t + p01;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p012;
    out[4] = p12;
    out[5] = p2;
}
function $747cfc5611b57cea$export$81915a594fe10dee(x0, y0, x1, y1, x2, y2, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    $747cfc5611b57cea$var$_v0[0] = x;
    $747cfc5611b57cea$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $747cfc5611b57cea$var$_v1[0] = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, _t);
        $747cfc5611b57cea$var$_v1[1] = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, _t);
        var d1 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v0, $747cfc5611b57cea$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $747cfc5611b57cea$var$EPSILON_NUMERIC) break;
        var prev = t - interval;
        var next = t + interval;
        $747cfc5611b57cea$var$_v1[0] = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, prev);
        $747cfc5611b57cea$var$_v1[1] = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, prev);
        var d1 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v1, $747cfc5611b57cea$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $747cfc5611b57cea$var$_v2[0] = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, next);
            $747cfc5611b57cea$var$_v2[1] = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, next);
            var d2 = (0, $6de594cf8ac295ff$export$c68db45a034c13b0)($747cfc5611b57cea$var$_v2, $747cfc5611b57cea$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, t);
        out[1] = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, t);
    }
    return $747cfc5611b57cea$var$mathSqrt(d);
}
function $747cfc5611b57cea$export$8a68adee46f3cf55(x0, y0, x1, y1, x2, y2, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, t);
        var y = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}



var $0aea98bda0b4be1f$var$regexp = /cubic-bezier\(([0-9,\.e ]+)\)/;
function $0aea98bda0b4be1f$export$ec0863d806fd857e(cubicEasingStr) {
    var cubic = cubicEasingStr && $0aea98bda0b4be1f$var$regexp.exec(cubicEasingStr);
    if (cubic) {
        var points = cubic[1].split(",");
        var a_1 = +(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(points[0]);
        var b_1 = +(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(points[1]);
        var c_1 = +(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(points[2]);
        var d_1 = +(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(points[3]);
        if (isNaN(a_1 + b_1 + c_1 + d_1)) return;
        var roots_1 = [];
        return function(p) {
            return p <= 0 ? 0 : p >= 1 ? 1 : (0, $747cfc5611b57cea$export$ca5d13faa10b167e)(0, a_1, c_1, 1, p, roots_1) && (0, $747cfc5611b57cea$export$547c21de482bbcb2)(0, b_1, d_1, 1, roots_1[0]);
        };
    }
}


var $00f1e1cb3568b9c5$var$Clip = function() {
    function Clip(opts) {
        this._inited = false;
        this._startTime = 0;
        this._pausedTime = 0;
        this._paused = false;
        this._life = opts.life || 1000;
        this._delay = opts.delay || 0;
        this.loop = opts.loop || false;
        this.onframe = opts.onframe || (0, $7a1bd9c2710fea0d$export$8793edee2d425525);
        this.ondestroy = opts.ondestroy || (0, $7a1bd9c2710fea0d$export$8793edee2d425525);
        this.onrestart = opts.onrestart || (0, $7a1bd9c2710fea0d$export$8793edee2d425525);
        opts.easing && this.setEasing(opts.easing);
    }
    Clip.prototype.step = function(globalTime, deltaTime) {
        if (!this._inited) {
            this._startTime = globalTime + this._delay;
            this._inited = true;
        }
        if (this._paused) {
            this._pausedTime += deltaTime;
            return;
        }
        var life = this._life;
        var elapsedTime = globalTime - this._startTime - this._pausedTime;
        var percent = elapsedTime / life;
        if (percent < 0) percent = 0;
        percent = Math.min(percent, 1);
        var easingFunc = this.easingFunc;
        var schedule = easingFunc ? easingFunc(percent) : percent;
        this.onframe(schedule);
        if (percent === 1) {
            if (this.loop) {
                var remainder = elapsedTime % life;
                this._startTime = globalTime - remainder;
                this._pausedTime = 0;
                this.onrestart();
            } else return true;
        }
        return false;
    };
    Clip.prototype.pause = function() {
        this._paused = true;
    };
    Clip.prototype.resume = function() {
        this._paused = false;
    };
    Clip.prototype.setEasing = function(easing) {
        this.easing = easing;
        this.easingFunc = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(easing) ? easing : (0, $9668111025b0b56f$export$2e2bcd8739ae039)[easing] || (0, $0aea98bda0b4be1f$export$ec0863d806fd857e)(easing);
    };
    return Clip;
}();
var $00f1e1cb3568b9c5$export$2e2bcd8739ae039 = $00f1e1cb3568b9c5$var$Clip;


var $2c037f5bda6341ca$exports = {};

$parcel$export($2c037f5bda6341ca$exports, "parse", () => $2c037f5bda6341ca$export$98e6a39c04603d36);
$parcel$export($2c037f5bda6341ca$exports, "lift", () => $2c037f5bda6341ca$export$590e8b2c435046d9);
$parcel$export($2c037f5bda6341ca$exports, "stringify", () => $2c037f5bda6341ca$export$fac44ee5b035f737);
$parcel$export($2c037f5bda6341ca$exports, "toHex", () => $2c037f5bda6341ca$export$7ea66e3774a60b67);
$parcel$export($2c037f5bda6341ca$exports, "fastLerp", () => $2c037f5bda6341ca$export$66cb3c0e9efc61c8);
$parcel$export($2c037f5bda6341ca$exports, "fastMapToColor", () => $2c037f5bda6341ca$export$daa5a65daad5df58);
$parcel$export($2c037f5bda6341ca$exports, "lerp", () => $2c037f5bda6341ca$export$3a89f8d6f6bf6c9f);
$parcel$export($2c037f5bda6341ca$exports, "mapToColor", () => $2c037f5bda6341ca$export$296e08242b78a3ec);
$parcel$export($2c037f5bda6341ca$exports, "modifyHSL", () => $2c037f5bda6341ca$export$d898ae866e27bf18);
$parcel$export($2c037f5bda6341ca$exports, "modifyAlpha", () => $2c037f5bda6341ca$export$ab4754bf42583a26);
$parcel$export($2c037f5bda6341ca$exports, "lum", () => $2c037f5bda6341ca$export$16c0ec21a6f9ef95);
$parcel$export($2c037f5bda6341ca$exports, "random", () => $2c037f5bda6341ca$export$4385e60b38654f68);
$parcel$export($2c037f5bda6341ca$exports, "liftColor", () => $2c037f5bda6341ca$export$2b47e247dfb87a73);
var $d91b0b6fc564d9c7$export$3bb977b3ba9d3b59 = function() {
    function Entry(val) {
        this.value = val;
    }
    return Entry;
}();
var $d91b0b6fc564d9c7$export$f0ef28713f767754 = function() {
    function LinkedList() {
        this._len = 0;
    }
    LinkedList.prototype.insert = function(val) {
        var entry = new $d91b0b6fc564d9c7$export$3bb977b3ba9d3b59(val);
        this.insertEntry(entry);
        return entry;
    };
    LinkedList.prototype.insertEntry = function(entry) {
        if (!this.head) this.head = this.tail = entry;
        else {
            this.tail.next = entry;
            entry.prev = this.tail;
            entry.next = null;
            this.tail = entry;
        }
        this._len++;
    };
    LinkedList.prototype.remove = function(entry) {
        var prev = entry.prev;
        var next = entry.next;
        if (prev) prev.next = next;
        else this.head = next;
        if (next) next.prev = prev;
        else this.tail = prev;
        entry.next = entry.prev = null;
        this._len--;
    };
    LinkedList.prototype.len = function() {
        return this._len;
    };
    LinkedList.prototype.clear = function() {
        this.head = this.tail = null;
        this._len = 0;
    };
    return LinkedList;
}();
var $d91b0b6fc564d9c7$var$LRU = function() {
    function LRU(maxSize) {
        this._list = new $d91b0b6fc564d9c7$export$f0ef28713f767754();
        this._maxSize = 10;
        this._map = {};
        this._maxSize = maxSize;
    }
    LRU.prototype.put = function(key, value) {
        var list = this._list;
        var map = this._map;
        var removed = null;
        if (map[key] == null) {
            var len = list.len();
            var entry = this._lastRemovedEntry;
            if (len >= this._maxSize && len > 0) {
                var leastUsedEntry = list.head;
                list.remove(leastUsedEntry);
                delete map[leastUsedEntry.key];
                removed = leastUsedEntry.value;
                this._lastRemovedEntry = leastUsedEntry;
            }
            if (entry) entry.value = value;
            else entry = new $d91b0b6fc564d9c7$export$3bb977b3ba9d3b59(value);
            entry.key = key;
            list.insertEntry(entry);
            map[key] = entry;
        }
        return removed;
    };
    LRU.prototype.get = function(key) {
        var entry = this._map[key];
        var list = this._list;
        if (entry != null) {
            if (entry !== list.tail) {
                list.remove(entry);
                list.insertEntry(entry);
            }
            return entry.value;
        }
    };
    LRU.prototype.clear = function() {
        this._list.clear();
        this._map = {};
    };
    LRU.prototype.len = function() {
        return this._list.len();
    };
    return LRU;
}();
var $d91b0b6fc564d9c7$export$2e2bcd8739ae039 = $d91b0b6fc564d9c7$var$LRU;



var $2c037f5bda6341ca$var$kCSSColorTable = {
    "transparent": [
        0,
        0,
        0,
        0
    ],
    "aliceblue": [
        240,
        248,
        255,
        1
    ],
    "antiquewhite": [
        250,
        235,
        215,
        1
    ],
    "aqua": [
        0,
        255,
        255,
        1
    ],
    "aquamarine": [
        127,
        255,
        212,
        1
    ],
    "azure": [
        240,
        255,
        255,
        1
    ],
    "beige": [
        245,
        245,
        220,
        1
    ],
    "bisque": [
        255,
        228,
        196,
        1
    ],
    "black": [
        0,
        0,
        0,
        1
    ],
    "blanchedalmond": [
        255,
        235,
        205,
        1
    ],
    "blue": [
        0,
        0,
        255,
        1
    ],
    "blueviolet": [
        138,
        43,
        226,
        1
    ],
    "brown": [
        165,
        42,
        42,
        1
    ],
    "burlywood": [
        222,
        184,
        135,
        1
    ],
    "cadetblue": [
        95,
        158,
        160,
        1
    ],
    "chartreuse": [
        127,
        255,
        0,
        1
    ],
    "chocolate": [
        210,
        105,
        30,
        1
    ],
    "coral": [
        255,
        127,
        80,
        1
    ],
    "cornflowerblue": [
        100,
        149,
        237,
        1
    ],
    "cornsilk": [
        255,
        248,
        220,
        1
    ],
    "crimson": [
        220,
        20,
        60,
        1
    ],
    "cyan": [
        0,
        255,
        255,
        1
    ],
    "darkblue": [
        0,
        0,
        139,
        1
    ],
    "darkcyan": [
        0,
        139,
        139,
        1
    ],
    "darkgoldenrod": [
        184,
        134,
        11,
        1
    ],
    "darkgray": [
        169,
        169,
        169,
        1
    ],
    "darkgreen": [
        0,
        100,
        0,
        1
    ],
    "darkgrey": [
        169,
        169,
        169,
        1
    ],
    "darkkhaki": [
        189,
        183,
        107,
        1
    ],
    "darkmagenta": [
        139,
        0,
        139,
        1
    ],
    "darkolivegreen": [
        85,
        107,
        47,
        1
    ],
    "darkorange": [
        255,
        140,
        0,
        1
    ],
    "darkorchid": [
        153,
        50,
        204,
        1
    ],
    "darkred": [
        139,
        0,
        0,
        1
    ],
    "darksalmon": [
        233,
        150,
        122,
        1
    ],
    "darkseagreen": [
        143,
        188,
        143,
        1
    ],
    "darkslateblue": [
        72,
        61,
        139,
        1
    ],
    "darkslategray": [
        47,
        79,
        79,
        1
    ],
    "darkslategrey": [
        47,
        79,
        79,
        1
    ],
    "darkturquoise": [
        0,
        206,
        209,
        1
    ],
    "darkviolet": [
        148,
        0,
        211,
        1
    ],
    "deeppink": [
        255,
        20,
        147,
        1
    ],
    "deepskyblue": [
        0,
        191,
        255,
        1
    ],
    "dimgray": [
        105,
        105,
        105,
        1
    ],
    "dimgrey": [
        105,
        105,
        105,
        1
    ],
    "dodgerblue": [
        30,
        144,
        255,
        1
    ],
    "firebrick": [
        178,
        34,
        34,
        1
    ],
    "floralwhite": [
        255,
        250,
        240,
        1
    ],
    "forestgreen": [
        34,
        139,
        34,
        1
    ],
    "fuchsia": [
        255,
        0,
        255,
        1
    ],
    "gainsboro": [
        220,
        220,
        220,
        1
    ],
    "ghostwhite": [
        248,
        248,
        255,
        1
    ],
    "gold": [
        255,
        215,
        0,
        1
    ],
    "goldenrod": [
        218,
        165,
        32,
        1
    ],
    "gray": [
        128,
        128,
        128,
        1
    ],
    "green": [
        0,
        128,
        0,
        1
    ],
    "greenyellow": [
        173,
        255,
        47,
        1
    ],
    "grey": [
        128,
        128,
        128,
        1
    ],
    "honeydew": [
        240,
        255,
        240,
        1
    ],
    "hotpink": [
        255,
        105,
        180,
        1
    ],
    "indianred": [
        205,
        92,
        92,
        1
    ],
    "indigo": [
        75,
        0,
        130,
        1
    ],
    "ivory": [
        255,
        255,
        240,
        1
    ],
    "khaki": [
        240,
        230,
        140,
        1
    ],
    "lavender": [
        230,
        230,
        250,
        1
    ],
    "lavenderblush": [
        255,
        240,
        245,
        1
    ],
    "lawngreen": [
        124,
        252,
        0,
        1
    ],
    "lemonchiffon": [
        255,
        250,
        205,
        1
    ],
    "lightblue": [
        173,
        216,
        230,
        1
    ],
    "lightcoral": [
        240,
        128,
        128,
        1
    ],
    "lightcyan": [
        224,
        255,
        255,
        1
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210,
        1
    ],
    "lightgray": [
        211,
        211,
        211,
        1
    ],
    "lightgreen": [
        144,
        238,
        144,
        1
    ],
    "lightgrey": [
        211,
        211,
        211,
        1
    ],
    "lightpink": [
        255,
        182,
        193,
        1
    ],
    "lightsalmon": [
        255,
        160,
        122,
        1
    ],
    "lightseagreen": [
        32,
        178,
        170,
        1
    ],
    "lightskyblue": [
        135,
        206,
        250,
        1
    ],
    "lightslategray": [
        119,
        136,
        153,
        1
    ],
    "lightslategrey": [
        119,
        136,
        153,
        1
    ],
    "lightsteelblue": [
        176,
        196,
        222,
        1
    ],
    "lightyellow": [
        255,
        255,
        224,
        1
    ],
    "lime": [
        0,
        255,
        0,
        1
    ],
    "limegreen": [
        50,
        205,
        50,
        1
    ],
    "linen": [
        250,
        240,
        230,
        1
    ],
    "magenta": [
        255,
        0,
        255,
        1
    ],
    "maroon": [
        128,
        0,
        0,
        1
    ],
    "mediumaquamarine": [
        102,
        205,
        170,
        1
    ],
    "mediumblue": [
        0,
        0,
        205,
        1
    ],
    "mediumorchid": [
        186,
        85,
        211,
        1
    ],
    "mediumpurple": [
        147,
        112,
        219,
        1
    ],
    "mediumseagreen": [
        60,
        179,
        113,
        1
    ],
    "mediumslateblue": [
        123,
        104,
        238,
        1
    ],
    "mediumspringgreen": [
        0,
        250,
        154,
        1
    ],
    "mediumturquoise": [
        72,
        209,
        204,
        1
    ],
    "mediumvioletred": [
        199,
        21,
        133,
        1
    ],
    "midnightblue": [
        25,
        25,
        112,
        1
    ],
    "mintcream": [
        245,
        255,
        250,
        1
    ],
    "mistyrose": [
        255,
        228,
        225,
        1
    ],
    "moccasin": [
        255,
        228,
        181,
        1
    ],
    "navajowhite": [
        255,
        222,
        173,
        1
    ],
    "navy": [
        0,
        0,
        128,
        1
    ],
    "oldlace": [
        253,
        245,
        230,
        1
    ],
    "olive": [
        128,
        128,
        0,
        1
    ],
    "olivedrab": [
        107,
        142,
        35,
        1
    ],
    "orange": [
        255,
        165,
        0,
        1
    ],
    "orangered": [
        255,
        69,
        0,
        1
    ],
    "orchid": [
        218,
        112,
        214,
        1
    ],
    "palegoldenrod": [
        238,
        232,
        170,
        1
    ],
    "palegreen": [
        152,
        251,
        152,
        1
    ],
    "paleturquoise": [
        175,
        238,
        238,
        1
    ],
    "palevioletred": [
        219,
        112,
        147,
        1
    ],
    "papayawhip": [
        255,
        239,
        213,
        1
    ],
    "peachpuff": [
        255,
        218,
        185,
        1
    ],
    "peru": [
        205,
        133,
        63,
        1
    ],
    "pink": [
        255,
        192,
        203,
        1
    ],
    "plum": [
        221,
        160,
        221,
        1
    ],
    "powderblue": [
        176,
        224,
        230,
        1
    ],
    "purple": [
        128,
        0,
        128,
        1
    ],
    "red": [
        255,
        0,
        0,
        1
    ],
    "rosybrown": [
        188,
        143,
        143,
        1
    ],
    "royalblue": [
        65,
        105,
        225,
        1
    ],
    "saddlebrown": [
        139,
        69,
        19,
        1
    ],
    "salmon": [
        250,
        128,
        114,
        1
    ],
    "sandybrown": [
        244,
        164,
        96,
        1
    ],
    "seagreen": [
        46,
        139,
        87,
        1
    ],
    "seashell": [
        255,
        245,
        238,
        1
    ],
    "sienna": [
        160,
        82,
        45,
        1
    ],
    "silver": [
        192,
        192,
        192,
        1
    ],
    "skyblue": [
        135,
        206,
        235,
        1
    ],
    "slateblue": [
        106,
        90,
        205,
        1
    ],
    "slategray": [
        112,
        128,
        144,
        1
    ],
    "slategrey": [
        112,
        128,
        144,
        1
    ],
    "snow": [
        255,
        250,
        250,
        1
    ],
    "springgreen": [
        0,
        255,
        127,
        1
    ],
    "steelblue": [
        70,
        130,
        180,
        1
    ],
    "tan": [
        210,
        180,
        140,
        1
    ],
    "teal": [
        0,
        128,
        128,
        1
    ],
    "thistle": [
        216,
        191,
        216,
        1
    ],
    "tomato": [
        255,
        99,
        71,
        1
    ],
    "turquoise": [
        64,
        224,
        208,
        1
    ],
    "violet": [
        238,
        130,
        238,
        1
    ],
    "wheat": [
        245,
        222,
        179,
        1
    ],
    "white": [
        255,
        255,
        255,
        1
    ],
    "whitesmoke": [
        245,
        245,
        245,
        1
    ],
    "yellow": [
        255,
        255,
        0,
        1
    ],
    "yellowgreen": [
        154,
        205,
        50,
        1
    ]
};
function $2c037f5bda6341ca$var$clampCssByte(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function $2c037f5bda6341ca$var$clampCssAngle(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 360 ? 360 : i;
}
function $2c037f5bda6341ca$var$clampCssFloat(f) {
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function $2c037f5bda6341ca$var$parseCssInt(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === "%") return $2c037f5bda6341ca$var$clampCssByte(parseFloat(str) / 100 * 255);
    return $2c037f5bda6341ca$var$clampCssByte(parseInt(str, 10));
}
function $2c037f5bda6341ca$var$parseCssFloat(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === "%") return $2c037f5bda6341ca$var$clampCssFloat(parseFloat(str) / 100);
    return $2c037f5bda6341ca$var$clampCssFloat(parseFloat(str));
}
function $2c037f5bda6341ca$var$cssHueToRgb(m1, m2, h) {
    if (h < 0) h += 1;
    else if (h > 1) h -= 1;
    if (h * 6 < 1) return m1 + (m2 - m1) * h * 6;
    if (h * 2 < 1) return m2;
    if (h * 3 < 2) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    return m1;
}
function $2c037f5bda6341ca$var$lerpNumber(a, b, p) {
    return a + (b - a) * p;
}
function $2c037f5bda6341ca$var$setRgba(out, r, g, b, a) {
    out[0] = r;
    out[1] = g;
    out[2] = b;
    out[3] = a;
    return out;
}
function $2c037f5bda6341ca$var$copyRgba(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
var $2c037f5bda6341ca$var$colorCache = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(20);
var $2c037f5bda6341ca$var$lastRemovedArr = null;
function $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr) {
    if ($2c037f5bda6341ca$var$lastRemovedArr) $2c037f5bda6341ca$var$copyRgba($2c037f5bda6341ca$var$lastRemovedArr, rgbaArr);
    $2c037f5bda6341ca$var$lastRemovedArr = $2c037f5bda6341ca$var$colorCache.put(colorStr, $2c037f5bda6341ca$var$lastRemovedArr || rgbaArr.slice());
}
function $2c037f5bda6341ca$export$98e6a39c04603d36(colorStr, rgbaArr) {
    if (!colorStr) return;
    rgbaArr = rgbaArr || [];
    var cached = $2c037f5bda6341ca$var$colorCache.get(colorStr);
    if (cached) return $2c037f5bda6341ca$var$copyRgba(rgbaArr, cached);
    colorStr = colorStr + "";
    var str = colorStr.replace(/ /g, "").toLowerCase();
    if (str in $2c037f5bda6341ca$var$kCSSColorTable) {
        $2c037f5bda6341ca$var$copyRgba(rgbaArr, $2c037f5bda6341ca$var$kCSSColorTable[str]);
        $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
        return rgbaArr;
    }
    var strLen = str.length;
    if (str.charAt(0) === "#") {
        if (strLen === 4 || strLen === 5) {
            var iv = parseInt(str.slice(1, 4), 16);
            if (!(iv >= 0 && iv <= 0xfff)) {
                $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $2c037f5bda6341ca$var$setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
            $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        } else if (strLen === 7 || strLen === 9) {
            var iv = parseInt(str.slice(1, 7), 16);
            if (!(iv >= 0 && iv <= 0xffffff)) {
                $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $2c037f5bda6341ca$var$setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
            $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        return;
    }
    var op = str.indexOf("(");
    var ep = str.indexOf(")");
    if (op !== -1 && ep + 1 === strLen) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(",");
        var alpha = 1;
        switch(fname){
            case "rgba":
                if (params.length !== 4) return params.length === 3 ? $2c037f5bda6341ca$var$setRgba(rgbaArr, +params[0], +params[1], +params[2], 1) : $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                alpha = $2c037f5bda6341ca$var$parseCssFloat(params.pop());
            case "rgb":
                if (params.length >= 3) {
                    $2c037f5bda6341ca$var$setRgba(rgbaArr, $2c037f5bda6341ca$var$parseCssInt(params[0]), $2c037f5bda6341ca$var$parseCssInt(params[1]), $2c037f5bda6341ca$var$parseCssInt(params[2]), params.length === 3 ? alpha : $2c037f5bda6341ca$var$parseCssFloat(params[3]));
                    $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                } else {
                    $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
            case "hsla":
                if (params.length !== 4) {
                    $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                params[3] = $2c037f5bda6341ca$var$parseCssFloat(params[3]);
                $2c037f5bda6341ca$var$hsla2rgba(params, rgbaArr);
                $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case "hsl":
                if (params.length !== 3) {
                    $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $2c037f5bda6341ca$var$hsla2rgba(params, rgbaArr);
                $2c037f5bda6341ca$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            default:
                return;
        }
    }
    $2c037f5bda6341ca$var$setRgba(rgbaArr, 0, 0, 0, 1);
    return;
}
function $2c037f5bda6341ca$var$hsla2rgba(hsla, rgba) {
    var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360;
    var s = $2c037f5bda6341ca$var$parseCssFloat(hsla[1]);
    var l = $2c037f5bda6341ca$var$parseCssFloat(hsla[2]);
    var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
    var m1 = l * 2 - m2;
    rgba = rgba || [];
    $2c037f5bda6341ca$var$setRgba(rgba, $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$cssHueToRgb(m1, m2, h + 1 / 3) * 255), $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$cssHueToRgb(m1, m2, h) * 255), $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
    if (hsla.length === 4) rgba[3] = hsla[3];
    return rgba;
}
function $2c037f5bda6341ca$var$rgba2hsla(rgba) {
    if (!rgba) return;
    var R = rgba[0] / 255;
    var G = rgba[1] / 255;
    var B = rgba[2] / 255;
    var vMin = Math.min(R, G, B);
    var vMax = Math.max(R, G, B);
    var delta = vMax - vMin;
    var L = (vMax + vMin) / 2;
    var H;
    var S;
    if (delta === 0) {
        H = 0;
        S = 0;
    } else {
        if (L < 0.5) S = delta / (vMax + vMin);
        else S = delta / (2 - vMax - vMin);
        var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
        var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
        var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
        if (R === vMax) H = deltaB - deltaG;
        else if (G === vMax) H = 1 / 3 + deltaR - deltaB;
        else if (B === vMax) H = 2 / 3 + deltaG - deltaR;
        if (H < 0) H += 1;
        if (H > 1) H -= 1;
    }
    var hsla = [
        H * 360,
        S,
        L
    ];
    if (rgba[3] != null) hsla.push(rgba[3]);
    return hsla;
}
function $2c037f5bda6341ca$export$590e8b2c435046d9(color, level) {
    var colorArr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    if (colorArr) {
        for(var i = 0; i < 3; i++){
            if (level < 0) colorArr[i] = colorArr[i] * (1 - level) | 0;
            else colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
            if (colorArr[i] > 255) colorArr[i] = 255;
            else if (colorArr[i] < 0) colorArr[i] = 0;
        }
        return $2c037f5bda6341ca$export$fac44ee5b035f737(colorArr, colorArr.length === 4 ? "rgba" : "rgb");
    }
}
function $2c037f5bda6341ca$export$7ea66e3774a60b67(color) {
    var colorArr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    if (colorArr) return (16777216 + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
}
function $2c037f5bda6341ca$export$66cb3c0e9efc61c8(normalizedValue, colors, out) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    out = out || [];
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = colors[leftIndex];
    var rightColor = colors[rightIndex];
    var dv = value - leftIndex;
    out[0] = $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[0], rightColor[0], dv));
    out[1] = $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[1], rightColor[1], dv));
    out[2] = $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[2], rightColor[2], dv));
    out[3] = $2c037f5bda6341ca$var$clampCssFloat($2c037f5bda6341ca$var$lerpNumber(leftColor[3], rightColor[3], dv));
    return out;
}
var $2c037f5bda6341ca$export$daa5a65daad5df58 = $2c037f5bda6341ca$export$66cb3c0e9efc61c8;
function $2c037f5bda6341ca$export$3a89f8d6f6bf6c9f(normalizedValue, colors, fullOutput) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = $2c037f5bda6341ca$export$98e6a39c04603d36(colors[leftIndex]);
    var rightColor = $2c037f5bda6341ca$export$98e6a39c04603d36(colors[rightIndex]);
    var dv = value - leftIndex;
    var color = $2c037f5bda6341ca$export$fac44ee5b035f737([
        $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[0], rightColor[0], dv)),
        $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[1], rightColor[1], dv)),
        $2c037f5bda6341ca$var$clampCssByte($2c037f5bda6341ca$var$lerpNumber(leftColor[2], rightColor[2], dv)),
        $2c037f5bda6341ca$var$clampCssFloat($2c037f5bda6341ca$var$lerpNumber(leftColor[3], rightColor[3], dv))
    ], "rgba");
    return fullOutput ? {
        color: color,
        leftIndex: leftIndex,
        rightIndex: rightIndex,
        value: value
    } : color;
}
var $2c037f5bda6341ca$export$296e08242b78a3ec = $2c037f5bda6341ca$export$3a89f8d6f6bf6c9f;
function $2c037f5bda6341ca$export$d898ae866e27bf18(color, h, s, l) {
    var colorArr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    if (color) {
        colorArr = $2c037f5bda6341ca$var$rgba2hsla(colorArr);
        h != null && (colorArr[0] = $2c037f5bda6341ca$var$clampCssAngle(h));
        s != null && (colorArr[1] = $2c037f5bda6341ca$var$parseCssFloat(s));
        l != null && (colorArr[2] = $2c037f5bda6341ca$var$parseCssFloat(l));
        return $2c037f5bda6341ca$export$fac44ee5b035f737($2c037f5bda6341ca$var$hsla2rgba(colorArr), "rgba");
    }
}
function $2c037f5bda6341ca$export$ab4754bf42583a26(color, alpha) {
    var colorArr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    if (colorArr && alpha != null) {
        colorArr[3] = $2c037f5bda6341ca$var$clampCssFloat(alpha);
        return $2c037f5bda6341ca$export$fac44ee5b035f737(colorArr, "rgba");
    }
}
function $2c037f5bda6341ca$export$fac44ee5b035f737(arrColor, type) {
    if (!arrColor || !arrColor.length) return;
    var colorStr = arrColor[0] + "," + arrColor[1] + "," + arrColor[2];
    if (type === "rgba" || type === "hsva" || type === "hsla") colorStr += "," + arrColor[3];
    return type + "(" + colorStr + ")";
}
function $2c037f5bda6341ca$export$16c0ec21a6f9ef95(color, backgroundLum) {
    var arr = $2c037f5bda6341ca$export$98e6a39c04603d36(color);
    return arr ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255 + (1 - arr[3]) * backgroundLum : 0;
}
function $2c037f5bda6341ca$export$4385e60b38654f68() {
    return $2c037f5bda6341ca$export$fac44ee5b035f737([
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255)
    ], "rgb");
}
var $2c037f5bda6341ca$var$liftedColorCache = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(100);
function $2c037f5bda6341ca$export$2b47e247dfb87a73(color) {
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(color)) {
        var liftedColor = $2c037f5bda6341ca$var$liftedColorCache.get(color);
        if (!liftedColor) {
            liftedColor = $2c037f5bda6341ca$export$590e8b2c435046d9(color, -0.1);
            $2c037f5bda6341ca$var$liftedColorCache.put(color, liftedColor);
        }
        return liftedColor;
    } else if ((0, $7a1bd9c2710fea0d$export$fa2c283003ed971c)(color)) {
        var ret = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, color);
        ret.colorStops = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(color.colorStops, function(stop) {
            return {
                offset: stop.offset,
                color: $2c037f5bda6341ca$export$590e8b2c435046d9(stop.color, -0.1)
            };
        });
        return ret;
    }
    return color;
}








/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $999d81abec723db8$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
var $999d81abec723db8$var$mathRound = Math.round;
function $999d81abec723db8$export$4cde5df63f53f473(color) {
    var opacity;
    if (!color || color === "transparent") color = "none";
    else if (typeof color === "string" && color.indexOf("rgba") > -1) {
        var arr = (0, $2c037f5bda6341ca$export$98e6a39c04603d36)(color);
        if (arr) {
            color = "rgb(" + arr[0] + "," + arr[1] + "," + arr[2] + ")";
            opacity = arr[3];
        }
    }
    return {
        color: color,
        opacity: opacity == null ? 1 : opacity
    };
}
var $999d81abec723db8$var$EPSILON = 1e-4;
function $999d81abec723db8$export$4701367f5b4de464(transform) {
    return transform < $999d81abec723db8$var$EPSILON && transform > -$999d81abec723db8$var$EPSILON;
}
function $999d81abec723db8$export$4b9074ac37ee5a23(transform) {
    return $999d81abec723db8$var$mathRound(transform * 1e3) / 1e3;
}
function $999d81abec723db8$export$52bfc6d3e2ff0fc2(transform) {
    return $999d81abec723db8$var$mathRound(transform * 1e4) / 1e4;
}
function $999d81abec723db8$export$19676ab5cb1de150(transform) {
    return $999d81abec723db8$var$mathRound(transform * 10) / 10;
}
function $999d81abec723db8$export$f29a4456cf56ff21(m) {
    return "matrix(" + $999d81abec723db8$export$4b9074ac37ee5a23(m[0]) + "," + $999d81abec723db8$export$4b9074ac37ee5a23(m[1]) + "," + $999d81abec723db8$export$4b9074ac37ee5a23(m[2]) + "," + $999d81abec723db8$export$4b9074ac37ee5a23(m[3]) + "," + $999d81abec723db8$export$52bfc6d3e2ff0fc2(m[4]) + "," + $999d81abec723db8$export$52bfc6d3e2ff0fc2(m[5]) + ")";
}
var $999d81abec723db8$export$4062150f0600d971 = {
    left: "start",
    right: "end",
    center: "middle",
    middle: "middle"
};
function $999d81abec723db8$export$bf7d6802d2badd9(y, lineHeight, textBaseline) {
    if (textBaseline === "top") y += lineHeight / 2;
    else if (textBaseline === "bottom") y -= lineHeight / 2;
    return y;
}
function $999d81abec723db8$export$c62076b3a966c94b(style) {
    return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY);
}
function $999d81abec723db8$export$9e4c657be710688a(displayable) {
    var style = displayable.style;
    var globalScale = displayable.getGlobalScale();
    return [
        style.shadowColor,
        (style.shadowBlur || 0).toFixed(2),
        (style.shadowOffsetX || 0).toFixed(2),
        (style.shadowOffsetY || 0).toFixed(2),
        globalScale[0],
        globalScale[1]
    ].join(",");
}
function $999d81abec723db8$export$8abc07640cab0527(clipPaths) {
    var key = [];
    if (clipPaths) for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        key.push(clipPath.id);
    }
    return key.join(",");
}
function $999d81abec723db8$export$2ade673ac4f85dfe(val) {
    return val && !!val.image;
}
function $999d81abec723db8$export$30352f47600a13cd(val) {
    return val && !!val.svgElement;
}
function $999d81abec723db8$export$41a28f5a000a9d0f(val) {
    return $999d81abec723db8$export$2ade673ac4f85dfe(val) || $999d81abec723db8$export$30352f47600a13cd(val);
}
function $999d81abec723db8$export$7d961bca9d3b47d0(val) {
    return val.type === "linear";
}
function $999d81abec723db8$export$2a9cca6692a0ce3a(val) {
    return val.type === "radial";
}
function $999d81abec723db8$export$545e02bbd5f8fe95(val) {
    return val && (val.type === "linear" || val.type === "radial");
}
function $999d81abec723db8$export$bb094196179998a5(id) {
    return "url(#" + id + ")";
}
function $999d81abec723db8$export$93fa1ae8a509371c(el) {
    var scale = el.getGlobalScale();
    var size = Math.max(scale[0], scale[1]);
    return Math.max(Math.ceil(Math.log(size) / Math.log(10)), 1);
}
function $999d81abec723db8$export$3fe07c0888ff6164(transform) {
    var x = transform.x || 0;
    var y = transform.y || 0;
    var rotation = (transform.rotation || 0) * (0, $7a1bd9c2710fea0d$export$bce8e055322a0ce6);
    var scaleX = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(transform.scaleX, 1);
    var scaleY = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(transform.scaleY, 1);
    var skewX = transform.skewX || 0;
    var skewY = transform.skewY || 0;
    var res = [];
    if (x || y) res.push("translate(" + x + "px," + y + "px)");
    if (rotation) res.push("rotate(" + rotation + ")");
    if (scaleX !== 1 || scaleY !== 1) res.push("scale(" + scaleX + "," + scaleY + ")");
    if (skewX || skewY) res.push("skew(" + $999d81abec723db8$var$mathRound(skewX * (0, $7a1bd9c2710fea0d$export$bce8e055322a0ce6)) + "deg, " + $999d81abec723db8$var$mathRound(skewY * (0, $7a1bd9c2710fea0d$export$bce8e055322a0ce6)) + "deg)");
    return res.join(" ");
}
var $999d81abec723db8$export$8fb536984ec8b4d7 = function() {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).hasGlobalWindow && (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(window.btoa)) return function(str) {
        return window.btoa(unescape(encodeURIComponent(str)));
    };
    if (typeof $999d81abec723db8$require$Buffer !== "undefined") return function(str) {
        return $999d81abec723db8$require$Buffer.from(str).toString("base64");
    };
    return function(str) {
        return null;
    };
}();


var $76d8a142a20276fc$var$arraySlice = Array.prototype.slice;
function $76d8a142a20276fc$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
function $76d8a142a20276fc$var$interpolate1DArray(out, p0, p1, percent) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = $76d8a142a20276fc$var$interpolateNumber(p0[i], p1[i], percent);
    return out;
}
function $76d8a142a20276fc$var$interpolate2DArray(out, p0, p1, percent) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = $76d8a142a20276fc$var$interpolateNumber(p0[i][j], p1[i][j], percent);
    }
    return out;
}
function $76d8a142a20276fc$var$add1DArray(out, p0, p1, sign) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = p0[i] + p1[i] * sign;
    return out;
}
function $76d8a142a20276fc$var$add2DArray(out, p0, p1, sign) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = p0[i][j] + p1[i][j] * sign;
    }
    return out;
}
function $76d8a142a20276fc$var$fillColorStops(val0, val1) {
    var len0 = val0.length;
    var len1 = val1.length;
    var shorterArr = len0 > len1 ? val1 : val0;
    var shorterLen = Math.min(len0, len1);
    var last = shorterArr[shorterLen - 1] || {
        color: [
            0,
            0,
            0,
            0
        ],
        offset: 0
    };
    for(var i = shorterLen; i < Math.max(len0, len1); i++)shorterArr.push({
        offset: last.offset,
        color: last.color.slice()
    });
}
function $76d8a142a20276fc$var$fillArray(val0, val1, arrDim) {
    var arr0 = val0;
    var arr1 = val1;
    if (!arr0.push || !arr1.push) return;
    var arr0Len = arr0.length;
    var arr1Len = arr1.length;
    if (arr0Len !== arr1Len) {
        var isPreviousLarger = arr0Len > arr1Len;
        if (isPreviousLarger) arr0.length = arr1Len;
        else for(var i = arr0Len; i < arr1Len; i++)arr0.push(arrDim === 1 ? arr1[i] : $76d8a142a20276fc$var$arraySlice.call(arr1[i]));
    }
    var len2 = arr0[0] && arr0[0].length;
    for(var i = 0; i < arr0.length; i++){
        if (arrDim === 1) {
            if (isNaN(arr0[i])) arr0[i] = arr1[i];
        } else {
            for(var j = 0; j < len2; j++)if (isNaN(arr0[i][j])) arr0[i][j] = arr1[i][j];
        }
    }
}
function $76d8a142a20276fc$export$c5e92b7f105af84e(value) {
    if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(value)) {
        var len = value.length;
        if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(value[0])) {
            var ret = [];
            for(var i = 0; i < len; i++)ret.push($76d8a142a20276fc$var$arraySlice.call(value[i]));
            return ret;
        }
        return $76d8a142a20276fc$var$arraySlice.call(value);
    }
    return value;
}
function $76d8a142a20276fc$var$rgba2String(rgba) {
    rgba[0] = Math.floor(rgba[0]) || 0;
    rgba[1] = Math.floor(rgba[1]) || 0;
    rgba[2] = Math.floor(rgba[2]) || 0;
    rgba[3] = rgba[3] == null ? 1 : rgba[3];
    return "rgba(" + rgba.join(",") + ")";
}
function $76d8a142a20276fc$var$guessArrayDim(value) {
    return (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(value && value[0]) ? 2 : 1;
}
var $76d8a142a20276fc$var$VALUE_TYPE_NUMBER = 0;
var $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY = 1;
var $76d8a142a20276fc$var$VALUE_TYPE_2D_ARRAY = 2;
var $76d8a142a20276fc$var$VALUE_TYPE_COLOR = 3;
var $76d8a142a20276fc$var$VALUE_TYPE_LINEAR_GRADIENT = 4;
var $76d8a142a20276fc$var$VALUE_TYPE_RADIAL_GRADIENT = 5;
var $76d8a142a20276fc$var$VALUE_TYPE_UNKOWN = 6;
function $76d8a142a20276fc$var$isGradientValueType(valType) {
    return valType === $76d8a142a20276fc$var$VALUE_TYPE_LINEAR_GRADIENT || valType === $76d8a142a20276fc$var$VALUE_TYPE_RADIAL_GRADIENT;
}
function $76d8a142a20276fc$var$isArrayValueType(valType) {
    return valType === $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY || valType === $76d8a142a20276fc$var$VALUE_TYPE_2D_ARRAY;
}
var $76d8a142a20276fc$var$tmpRgba = [
    0,
    0,
    0,
    0
];
var $76d8a142a20276fc$var$Track = function() {
    function Track(propName) {
        this.keyframes = [];
        this.discrete = false;
        this._invalid = false;
        this._needsSort = false;
        this._lastFr = 0;
        this._lastFrP = 0;
        this.propName = propName;
    }
    Track.prototype.isFinished = function() {
        return this._finished;
    };
    Track.prototype.setFinished = function() {
        this._finished = true;
        if (this._additiveTrack) this._additiveTrack.setFinished();
    };
    Track.prototype.needsAnimate = function() {
        return this.keyframes.length >= 1;
    };
    Track.prototype.getAdditiveTrack = function() {
        return this._additiveTrack;
    };
    Track.prototype.addKeyframe = function(time, rawValue, easing) {
        this._needsSort = true;
        var keyframes = this.keyframes;
        var len = keyframes.length;
        var discrete = false;
        var valType = $76d8a142a20276fc$var$VALUE_TYPE_UNKOWN;
        var value = rawValue;
        if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(rawValue)) {
            var arrayDim = $76d8a142a20276fc$var$guessArrayDim(rawValue);
            valType = arrayDim;
            if (arrayDim === 1 && !(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rawValue[0]) || arrayDim === 2 && !(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rawValue[0][0])) discrete = true;
        } else {
            if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rawValue) && !(0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(rawValue)) valType = $76d8a142a20276fc$var$VALUE_TYPE_NUMBER;
            else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(rawValue)) {
                if (!isNaN(+rawValue)) valType = $76d8a142a20276fc$var$VALUE_TYPE_NUMBER;
                else {
                    var colorArray = $2c037f5bda6341ca$export$98e6a39c04603d36(rawValue);
                    if (colorArray) {
                        value = colorArray;
                        valType = $76d8a142a20276fc$var$VALUE_TYPE_COLOR;
                    }
                }
            } else if ((0, $7a1bd9c2710fea0d$export$fa2c283003ed971c)(rawValue)) {
                var parsedGradient = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, value);
                parsedGradient.colorStops = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(rawValue.colorStops, function(colorStop) {
                    return {
                        offset: colorStop.offset,
                        color: $2c037f5bda6341ca$export$98e6a39c04603d36(colorStop.color)
                    };
                });
                if ((0, $999d81abec723db8$export$7d961bca9d3b47d0)(rawValue)) valType = $76d8a142a20276fc$var$VALUE_TYPE_LINEAR_GRADIENT;
                else if ((0, $999d81abec723db8$export$2a9cca6692a0ce3a)(rawValue)) valType = $76d8a142a20276fc$var$VALUE_TYPE_RADIAL_GRADIENT;
                value = parsedGradient;
            }
        }
        if (len === 0) this.valType = valType;
        else if (valType !== this.valType || valType === $76d8a142a20276fc$var$VALUE_TYPE_UNKOWN) discrete = true;
        this.discrete = this.discrete || discrete;
        var kf = {
            time: time,
            value: value,
            rawValue: rawValue,
            percent: 0
        };
        if (easing) {
            kf.easing = easing;
            kf.easingFunc = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(easing) ? easing : (0, $9668111025b0b56f$export$2e2bcd8739ae039)[easing] || (0, $0aea98bda0b4be1f$export$ec0863d806fd857e)(easing);
        }
        keyframes.push(kf);
        return kf;
    };
    Track.prototype.prepare = function(maxTime, additiveTrack) {
        var kfs = this.keyframes;
        if (this._needsSort) kfs.sort(function(a, b) {
            return a.time - b.time;
        });
        var valType = this.valType;
        var kfsLen = kfs.length;
        var lastKf = kfs[kfsLen - 1];
        var isDiscrete = this.discrete;
        var isArr = $76d8a142a20276fc$var$isArrayValueType(valType);
        var isGradient = $76d8a142a20276fc$var$isGradientValueType(valType);
        for(var i = 0; i < kfsLen; i++){
            var kf = kfs[i];
            var value = kf.value;
            var lastValue = lastKf.value;
            kf.percent = kf.time / maxTime;
            if (!isDiscrete) {
                if (isArr && i !== kfsLen - 1) $76d8a142a20276fc$var$fillArray(value, lastValue, valType);
                else if (isGradient) $76d8a142a20276fc$var$fillColorStops(value.colorStops, lastValue.colorStops);
            }
        }
        if (!isDiscrete && valType !== $76d8a142a20276fc$var$VALUE_TYPE_RADIAL_GRADIENT && additiveTrack && this.needsAnimate() && additiveTrack.needsAnimate() && valType === additiveTrack.valType && !additiveTrack._finished) {
            this._additiveTrack = additiveTrack;
            var startValue = kfs[0].value;
            for(var i = 0; i < kfsLen; i++){
                if (valType === $76d8a142a20276fc$var$VALUE_TYPE_NUMBER) kfs[i].additiveValue = kfs[i].value - startValue;
                else if (valType === $76d8a142a20276fc$var$VALUE_TYPE_COLOR) kfs[i].additiveValue = $76d8a142a20276fc$var$add1DArray([], kfs[i].value, startValue, -1);
                else if ($76d8a142a20276fc$var$isArrayValueType(valType)) kfs[i].additiveValue = valType === $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY ? $76d8a142a20276fc$var$add1DArray([], kfs[i].value, startValue, -1) : $76d8a142a20276fc$var$add2DArray([], kfs[i].value, startValue, -1);
            }
        }
    };
    Track.prototype.step = function(target, percent) {
        if (this._finished) return;
        if (this._additiveTrack && this._additiveTrack._finished) this._additiveTrack = null;
        var isAdditive = this._additiveTrack != null;
        var valueKey = isAdditive ? "additiveValue" : "value";
        var valType = this.valType;
        var keyframes = this.keyframes;
        var kfsNum = keyframes.length;
        var propName = this.propName;
        var isValueColor = valType === $76d8a142a20276fc$var$VALUE_TYPE_COLOR;
        var frameIdx;
        var lastFrame = this._lastFr;
        var mathMin = Math.min;
        var frame;
        var nextFrame;
        if (kfsNum === 1) frame = nextFrame = keyframes[0];
        else {
            if (percent < 0) frameIdx = 0;
            else if (percent < this._lastFrP) {
                var start = mathMin(lastFrame + 1, kfsNum - 1);
                for(frameIdx = start; frameIdx >= 0; frameIdx--){
                    if (keyframes[frameIdx].percent <= percent) break;
                }
                frameIdx = mathMin(frameIdx, kfsNum - 2);
            } else {
                for(frameIdx = lastFrame; frameIdx < kfsNum; frameIdx++){
                    if (keyframes[frameIdx].percent > percent) break;
                }
                frameIdx = mathMin(frameIdx - 1, kfsNum - 2);
            }
            nextFrame = keyframes[frameIdx + 1];
            frame = keyframes[frameIdx];
        }
        if (!(frame && nextFrame)) return;
        this._lastFr = frameIdx;
        this._lastFrP = percent;
        var interval = nextFrame.percent - frame.percent;
        var w = interval === 0 ? 1 : mathMin((percent - frame.percent) / interval, 1);
        if (nextFrame.easingFunc) w = nextFrame.easingFunc(w);
        var targetArr = isAdditive ? this._additiveValue : isValueColor ? $76d8a142a20276fc$var$tmpRgba : target[propName];
        if (($76d8a142a20276fc$var$isArrayValueType(valType) || isValueColor) && !targetArr) targetArr = this._additiveValue = [];
        if (this.discrete) target[propName] = w < 1 ? frame.rawValue : nextFrame.rawValue;
        else if ($76d8a142a20276fc$var$isArrayValueType(valType)) valType === $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY ? $76d8a142a20276fc$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w) : $76d8a142a20276fc$var$interpolate2DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
        else if ($76d8a142a20276fc$var$isGradientValueType(valType)) {
            var val = frame[valueKey];
            var nextVal_1 = nextFrame[valueKey];
            var isLinearGradient_1 = valType === $76d8a142a20276fc$var$VALUE_TYPE_LINEAR_GRADIENT;
            target[propName] = {
                type: isLinearGradient_1 ? "linear" : "radial",
                x: $76d8a142a20276fc$var$interpolateNumber(val.x, nextVal_1.x, w),
                y: $76d8a142a20276fc$var$interpolateNumber(val.y, nextVal_1.y, w),
                colorStops: (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(val.colorStops, function(colorStop, idx) {
                    var nextColorStop = nextVal_1.colorStops[idx];
                    return {
                        offset: $76d8a142a20276fc$var$interpolateNumber(colorStop.offset, nextColorStop.offset, w),
                        color: $76d8a142a20276fc$var$rgba2String($76d8a142a20276fc$var$interpolate1DArray([], colorStop.color, nextColorStop.color, w))
                    };
                }),
                global: nextVal_1.global
            };
            if (isLinearGradient_1) {
                target[propName].x2 = $76d8a142a20276fc$var$interpolateNumber(val.x2, nextVal_1.x2, w);
                target[propName].y2 = $76d8a142a20276fc$var$interpolateNumber(val.y2, nextVal_1.y2, w);
            } else target[propName].r = $76d8a142a20276fc$var$interpolateNumber(val.r, nextVal_1.r, w);
        } else if (isValueColor) {
            $76d8a142a20276fc$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
            if (!isAdditive) target[propName] = $76d8a142a20276fc$var$rgba2String(targetArr);
        } else {
            var value = $76d8a142a20276fc$var$interpolateNumber(frame[valueKey], nextFrame[valueKey], w);
            if (isAdditive) this._additiveValue = value;
            else target[propName] = value;
        }
        if (isAdditive) this._addToTarget(target);
    };
    Track.prototype._addToTarget = function(target) {
        var valType = this.valType;
        var propName = this.propName;
        var additiveValue = this._additiveValue;
        if (valType === $76d8a142a20276fc$var$VALUE_TYPE_NUMBER) target[propName] = target[propName] + additiveValue;
        else if (valType === $76d8a142a20276fc$var$VALUE_TYPE_COLOR) {
            $2c037f5bda6341ca$export$98e6a39c04603d36(target[propName], $76d8a142a20276fc$var$tmpRgba);
            $76d8a142a20276fc$var$add1DArray($76d8a142a20276fc$var$tmpRgba, $76d8a142a20276fc$var$tmpRgba, additiveValue, 1);
            target[propName] = $76d8a142a20276fc$var$rgba2String($76d8a142a20276fc$var$tmpRgba);
        } else if (valType === $76d8a142a20276fc$var$VALUE_TYPE_1D_ARRAY) $76d8a142a20276fc$var$add1DArray(target[propName], target[propName], additiveValue, 1);
        else if (valType === $76d8a142a20276fc$var$VALUE_TYPE_2D_ARRAY) $76d8a142a20276fc$var$add2DArray(target[propName], target[propName], additiveValue, 1);
    };
    return Track;
}();
var $76d8a142a20276fc$var$Animator = function() {
    function Animator(target, loop, allowDiscreteAnimation, additiveTo) {
        this._tracks = {};
        this._trackKeys = [];
        this._maxTime = 0;
        this._started = 0;
        this._clip = null;
        this._target = target;
        this._loop = loop;
        if (loop && additiveTo) {
            (0, $7a1bd9c2710fea0d$export$58da9968c3170cb1)("Can' use additive animation on looped animation.");
            return;
        }
        this._additiveAnimators = additiveTo;
        this._allowDiscrete = allowDiscreteAnimation;
    }
    Animator.prototype.getMaxTime = function() {
        return this._maxTime;
    };
    Animator.prototype.getDelay = function() {
        return this._delay;
    };
    Animator.prototype.getLoop = function() {
        return this._loop;
    };
    Animator.prototype.getTarget = function() {
        return this._target;
    };
    Animator.prototype.changeTarget = function(target) {
        this._target = target;
    };
    Animator.prototype.when = function(time, props, easing) {
        return this.whenWithKeys(time, props, (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(props), easing);
    };
    Animator.prototype.whenWithKeys = function(time, props, propNames, easing) {
        var tracks = this._tracks;
        for(var i = 0; i < propNames.length; i++){
            var propName = propNames[i];
            var track = tracks[propName];
            if (!track) {
                track = tracks[propName] = new $76d8a142a20276fc$var$Track(propName);
                var initialValue = void 0;
                var additiveTrack = this._getAdditiveTrack(propName);
                if (additiveTrack) {
                    var addtiveTrackKfs = additiveTrack.keyframes;
                    var lastFinalKf = addtiveTrackKfs[addtiveTrackKfs.length - 1];
                    initialValue = lastFinalKf && lastFinalKf.value;
                    if (additiveTrack.valType === $76d8a142a20276fc$var$VALUE_TYPE_COLOR && initialValue) initialValue = $76d8a142a20276fc$var$rgba2String(initialValue);
                } else initialValue = this._target[propName];
                if (initialValue == null) continue;
                if (time > 0) track.addKeyframe(0, $76d8a142a20276fc$export$c5e92b7f105af84e(initialValue), easing);
                this._trackKeys.push(propName);
            }
            track.addKeyframe(time, $76d8a142a20276fc$export$c5e92b7f105af84e(props[propName]), easing);
        }
        this._maxTime = Math.max(this._maxTime, time);
        return this;
    };
    Animator.prototype.pause = function() {
        this._clip.pause();
        this._paused = true;
    };
    Animator.prototype.resume = function() {
        this._clip.resume();
        this._paused = false;
    };
    Animator.prototype.isPaused = function() {
        return !!this._paused;
    };
    Animator.prototype.duration = function(duration) {
        this._maxTime = duration;
        this._force = true;
        return this;
    };
    Animator.prototype._doneCallback = function() {
        this._setTracksFinished();
        this._clip = null;
        var doneList = this._doneCbs;
        if (doneList) {
            var len = doneList.length;
            for(var i = 0; i < len; i++)doneList[i].call(this);
        }
    };
    Animator.prototype._abortedCallback = function() {
        this._setTracksFinished();
        var animation = this.animation;
        var abortedList = this._abortedCbs;
        if (animation) animation.removeClip(this._clip);
        this._clip = null;
        if (abortedList) for(var i = 0; i < abortedList.length; i++)abortedList[i].call(this);
    };
    Animator.prototype._setTracksFinished = function() {
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < tracksKeys.length; i++)tracks[tracksKeys[i]].setFinished();
    };
    Animator.prototype._getAdditiveTrack = function(trackName) {
        var additiveTrack;
        var additiveAnimators = this._additiveAnimators;
        if (additiveAnimators) for(var i = 0; i < additiveAnimators.length; i++){
            var track = additiveAnimators[i].getTrack(trackName);
            if (track) additiveTrack = track;
        }
        return additiveTrack;
    };
    Animator.prototype.start = function(easing) {
        if (this._started > 0) return;
        this._started = 1;
        var self = this;
        var tracks = [];
        var maxTime = this._maxTime || 0;
        for(var i = 0; i < this._trackKeys.length; i++){
            var propName = this._trackKeys[i];
            var track = this._tracks[propName];
            var additiveTrack = this._getAdditiveTrack(propName);
            var kfs = track.keyframes;
            var kfsNum = kfs.length;
            track.prepare(maxTime, additiveTrack);
            if (track.needsAnimate()) {
                if (!this._allowDiscrete && track.discrete) {
                    var lastKf = kfs[kfsNum - 1];
                    if (lastKf) self._target[track.propName] = lastKf.rawValue;
                    track.setFinished();
                } else tracks.push(track);
            }
        }
        if (tracks.length || this._force) {
            var clip = new (0, $00f1e1cb3568b9c5$export$2e2bcd8739ae039)({
                life: maxTime,
                loop: this._loop,
                delay: this._delay || 0,
                onframe: function(percent) {
                    self._started = 2;
                    var additiveAnimators = self._additiveAnimators;
                    if (additiveAnimators) {
                        var stillHasAdditiveAnimator = false;
                        for(var i = 0; i < additiveAnimators.length; i++)if (additiveAnimators[i]._clip) {
                            stillHasAdditiveAnimator = true;
                            break;
                        }
                        if (!stillHasAdditiveAnimator) self._additiveAnimators = null;
                    }
                    for(var i = 0; i < tracks.length; i++)tracks[i].step(self._target, percent);
                    var onframeList = self._onframeCbs;
                    if (onframeList) for(var i = 0; i < onframeList.length; i++)onframeList[i](self._target, percent);
                },
                ondestroy: function() {
                    self._doneCallback();
                }
            });
            this._clip = clip;
            if (this.animation) this.animation.addClip(clip);
            if (easing) clip.setEasing(easing);
        } else this._doneCallback();
        return this;
    };
    Animator.prototype.stop = function(forwardToLast) {
        if (!this._clip) return;
        var clip = this._clip;
        if (forwardToLast) clip.onframe(1);
        this._abortedCallback();
    };
    Animator.prototype.delay = function(time) {
        this._delay = time;
        return this;
    };
    Animator.prototype.during = function(cb) {
        if (cb) {
            if (!this._onframeCbs) this._onframeCbs = [];
            this._onframeCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.done = function(cb) {
        if (cb) {
            if (!this._doneCbs) this._doneCbs = [];
            this._doneCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.aborted = function(cb) {
        if (cb) {
            if (!this._abortedCbs) this._abortedCbs = [];
            this._abortedCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.getClip = function() {
        return this._clip;
    };
    Animator.prototype.getTrack = function(propName) {
        return this._tracks[propName];
    };
    Animator.prototype.getTracks = function() {
        var _this = this;
        return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(this._trackKeys, function(key) {
            return _this._tracks[key];
        });
    };
    Animator.prototype.stopTracks = function(propNames, forwardToLast) {
        if (!propNames.length || !this._clip) return true;
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < propNames.length; i++){
            var track = tracks[propNames[i]];
            if (track && !track.isFinished()) {
                if (forwardToLast) track.step(this._target, 1);
                else if (this._started === 1) track.step(this._target, 0);
                track.setFinished();
            }
        }
        var allAborted = true;
        for(var i = 0; i < tracksKeys.length; i++)if (!tracks[tracksKeys[i]].isFinished()) {
            allAborted = false;
            break;
        }
        if (allAborted) this._abortedCallback();
        return allAborted;
    };
    Animator.prototype.saveTo = function(target, trackKeys, firstOrLast) {
        if (!target) return;
        trackKeys = trackKeys || this._trackKeys;
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track || track.isFinished()) continue;
            var kfs = track.keyframes;
            var kf = kfs[firstOrLast ? 0 : kfs.length - 1];
            if (kf) target[propName] = $76d8a142a20276fc$export$c5e92b7f105af84e(kf.rawValue);
        }
    };
    Animator.prototype.__changeFinalValue = function(finalProps, trackKeys) {
        trackKeys = trackKeys || (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(finalProps);
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track) continue;
            var kfs = track.keyframes;
            if (kfs.length > 1) {
                var lastKf = kfs.pop();
                track.addKeyframe(lastKf.time, finalProps[propName]);
                track.prepare(this._maxTime, track.getAdditiveTrack());
            }
        }
    };
    return Animator;
}();
var $76d8a142a20276fc$export$2e2bcd8739ae039 = $76d8a142a20276fc$var$Animator;


function $fad434a4044c956a$export$1428f42a7de81803() {
    return new Date().getTime();
}
var $fad434a4044c956a$var$Animation = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Animation, _super);
    function Animation(opts) {
        var _this = _super.call(this) || this;
        _this._running = false;
        _this._time = 0;
        _this._pausedTime = 0;
        _this._pauseStart = 0;
        _this._paused = false;
        opts = opts || {};
        _this.stage = opts.stage || {};
        return _this;
    }
    Animation.prototype.addClip = function(clip) {
        if (clip.animation) this.removeClip(clip);
        if (!this._head) this._head = this._tail = clip;
        else {
            this._tail.next = clip;
            clip.prev = this._tail;
            clip.next = null;
            this._tail = clip;
        }
        clip.animation = this;
    };
    Animation.prototype.addAnimator = function(animator) {
        animator.animation = this;
        var clip = animator.getClip();
        if (clip) this.addClip(clip);
    };
    Animation.prototype.removeClip = function(clip) {
        if (!clip.animation) return;
        var prev = clip.prev;
        var next = clip.next;
        if (prev) prev.next = next;
        else this._head = next;
        if (next) next.prev = prev;
        else this._tail = prev;
        clip.next = clip.prev = clip.animation = null;
    };
    Animation.prototype.removeAnimator = function(animator) {
        var clip = animator.getClip();
        if (clip) this.removeClip(clip);
        animator.animation = null;
    };
    Animation.prototype.update = function(notTriggerFrameAndStageUpdate) {
        var time = $fad434a4044c956a$export$1428f42a7de81803() - this._pausedTime;
        var delta = time - this._time;
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            var finished = clip.step(time, delta);
            if (finished) {
                clip.ondestroy();
                this.removeClip(clip);
                clip = nextClip;
            } else clip = nextClip;
        }
        this._time = time;
        if (!notTriggerFrameAndStageUpdate) {
            this.trigger("frame", delta);
            this.stage.update && this.stage.update();
        }
    };
    Animation.prototype._startLoop = function() {
        var self = this;
        this._running = true;
        function step() {
            if (self._running) {
                (0, $731d42ad1858cd4c$export$2e2bcd8739ae039)(step);
                !self._paused && self.update();
            }
        }
        (0, $731d42ad1858cd4c$export$2e2bcd8739ae039)(step);
    };
    Animation.prototype.start = function() {
        if (this._running) return;
        this._time = $fad434a4044c956a$export$1428f42a7de81803();
        this._pausedTime = 0;
        this._startLoop();
    };
    Animation.prototype.stop = function() {
        this._running = false;
    };
    Animation.prototype.pause = function() {
        if (!this._paused) {
            this._pauseStart = $fad434a4044c956a$export$1428f42a7de81803();
            this._paused = true;
        }
    };
    Animation.prototype.resume = function() {
        if (this._paused) {
            this._pausedTime += $fad434a4044c956a$export$1428f42a7de81803() - this._pauseStart;
            this._paused = false;
        }
    };
    Animation.prototype.clear = function() {
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            clip.prev = clip.next = clip.animation = null;
            clip = nextClip;
        }
        this._head = this._tail = null;
    };
    Animation.prototype.isFinished = function() {
        return this._head == null;
    };
    Animation.prototype.animate = function(target, options) {
        options = options || {};
        this.start();
        var animator = new (0, $76d8a142a20276fc$export$2e2bcd8739ae039)(target, options.loop);
        this.addAnimator(animator);
        return animator;
    };
    return Animation;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $fad434a4044c956a$export$2e2bcd8739ae039 = $fad434a4044c956a$var$Animation;







var $c0dbbc6989260eee$var$TOUCH_CLICK_DELAY = 300;
var $c0dbbc6989260eee$var$globalEventSupported = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported;
var $c0dbbc6989260eee$var$localNativeListenerNames = function() {
    var mouseHandlerNames = [
        "click",
        "dblclick",
        "mousewheel",
        "wheel",
        "mouseout",
        "mouseup",
        "mousedown",
        "mousemove",
        "contextmenu"
    ];
    var touchHandlerNames = [
        "touchstart",
        "touchend",
        "touchmove"
    ];
    var pointerEventNameMap = {
        pointerdown: 1,
        pointerup: 1,
        pointermove: 1,
        pointerout: 1
    };
    var pointerHandlerNames = $7a1bd9c2710fea0d$export$871de8747c9eaa88(mouseHandlerNames, function(name) {
        var nm = name.replace("mouse", "pointer");
        return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
    });
    return {
        mouse: mouseHandlerNames,
        touch: touchHandlerNames,
        pointer: pointerHandlerNames
    };
}();
var $c0dbbc6989260eee$var$globalNativeListenerNames = {
    mouse: [
        "mousemove",
        "mouseup"
    ],
    pointer: [
        "pointermove",
        "pointerup"
    ]
};
var $c0dbbc6989260eee$var$wheelEventSupported = false;
function $c0dbbc6989260eee$var$isPointerFromTouch(event) {
    var pointerType = event.pointerType;
    return pointerType === "pen" || pointerType === "touch";
}
function $c0dbbc6989260eee$var$setTouchTimer(scope) {
    scope.touching = true;
    if (scope.touchTimer != null) {
        clearTimeout(scope.touchTimer);
        scope.touchTimer = null;
    }
    scope.touchTimer = setTimeout(function() {
        scope.touching = false;
        scope.touchTimer = null;
    }, 700);
}
function $c0dbbc6989260eee$var$markTouch(event) {
    event && (event.zrByTouch = true);
}
function $c0dbbc6989260eee$var$normalizeGlobalEvent(instance, event) {
    return (0, $b3864a78637ff9ed$export$40fadb093aebad71)(instance.dom, new $c0dbbc6989260eee$var$FakeGlobalEvent(instance, event), true);
}
function $c0dbbc6989260eee$var$isLocalEl(instance, el) {
    var elTmp = el;
    var isLocal = false;
    while(elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot))elTmp = elTmp.parentNode;
    return isLocal;
}
var $c0dbbc6989260eee$var$FakeGlobalEvent = function() {
    function FakeGlobalEvent(instance, event) {
        this.stopPropagation = $7a1bd9c2710fea0d$export$8793edee2d425525;
        this.stopImmediatePropagation = $7a1bd9c2710fea0d$export$8793edee2d425525;
        this.preventDefault = $7a1bd9c2710fea0d$export$8793edee2d425525;
        this.type = event.type;
        this.target = this.currentTarget = instance.dom;
        this.pointerType = event.pointerType;
        this.clientX = event.clientX;
        this.clientY = event.clientY;
    }
    return FakeGlobalEvent;
}();
var $c0dbbc6989260eee$var$localDOMHandlers = {
    mousedown: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.__mayPointerCapture = [
            event.zrX,
            event.zrY
        ];
        this.trigger("mousedown", event);
    },
    mousemove: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        var downPoint = this.__mayPointerCapture;
        if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) this.__togglePointerCapture(true);
        this.trigger("mousemove", event);
    },
    mouseup: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.__togglePointerCapture(false);
        this.trigger("mouseup", event);
    },
    mouseout: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        var element = event.toElement || event.relatedTarget;
        if (!$c0dbbc6989260eee$var$isLocalEl(this, element)) {
            if (this.__pointerCapturing) event.zrEventControl = "no_globalout";
            this.trigger("mouseout", event);
        }
    },
    wheel: function(event) {
        $c0dbbc6989260eee$var$wheelEventSupported = true;
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.trigger("mousewheel", event);
    },
    mousewheel: function(event) {
        if ($c0dbbc6989260eee$var$wheelEventSupported) return;
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.trigger("mousewheel", event);
    },
    touchstart: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        $c0dbbc6989260eee$var$markTouch(event);
        this.__lastTouchMoment = new Date();
        this.handler.processGesture(event, "start");
        $c0dbbc6989260eee$var$localDOMHandlers.mousemove.call(this, event);
        $c0dbbc6989260eee$var$localDOMHandlers.mousedown.call(this, event);
    },
    touchmove: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        $c0dbbc6989260eee$var$markTouch(event);
        this.handler.processGesture(event, "change");
        $c0dbbc6989260eee$var$localDOMHandlers.mousemove.call(this, event);
    },
    touchend: function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        $c0dbbc6989260eee$var$markTouch(event);
        this.handler.processGesture(event, "end");
        $c0dbbc6989260eee$var$localDOMHandlers.mouseup.call(this, event);
        if (+new Date() - +this.__lastTouchMoment < $c0dbbc6989260eee$var$TOUCH_CLICK_DELAY) $c0dbbc6989260eee$var$localDOMHandlers.click.call(this, event);
    },
    pointerdown: function(event) {
        $c0dbbc6989260eee$var$localDOMHandlers.mousedown.call(this, event);
    },
    pointermove: function(event) {
        if (!$c0dbbc6989260eee$var$isPointerFromTouch(event)) $c0dbbc6989260eee$var$localDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $c0dbbc6989260eee$var$localDOMHandlers.mouseup.call(this, event);
    },
    pointerout: function(event) {
        if (!$c0dbbc6989260eee$var$isPointerFromTouch(event)) $c0dbbc6989260eee$var$localDOMHandlers.mouseout.call(this, event);
    }
};
$7a1bd9c2710fea0d$export$79b2f7037acddd43([
    "click",
    "dblclick",
    "contextmenu"
], function(name) {
    $c0dbbc6989260eee$var$localDOMHandlers[name] = function(event) {
        event = (0, $b3864a78637ff9ed$export$40fadb093aebad71)(this.dom, event);
        this.trigger(name, event);
    };
});
var $c0dbbc6989260eee$var$globalDOMHandlers = {
    pointermove: function(event) {
        if (!$c0dbbc6989260eee$var$isPointerFromTouch(event)) $c0dbbc6989260eee$var$globalDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $c0dbbc6989260eee$var$globalDOMHandlers.mouseup.call(this, event);
    },
    mousemove: function(event) {
        this.trigger("mousemove", event);
    },
    mouseup: function(event) {
        var pointerCaptureReleasing = this.__pointerCapturing;
        this.__togglePointerCapture(false);
        this.trigger("mouseup", event);
        if (pointerCaptureReleasing) {
            event.zrEventControl = "only_globalout";
            this.trigger("mouseout", event);
        }
    }
};
function $c0dbbc6989260eee$var$mountLocalDOMEventListeners(instance, scope) {
    var domHandlers = scope.domHandlers;
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).pointerEventsSupported) $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$localNativeListenerNames.pointer, function(nativeEventName) {
        $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
            domHandlers[nativeEventName].call(instance, event);
        });
    });
    else {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).touchEventsSupported) $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$localNativeListenerNames.touch, function(nativeEventName) {
            $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                domHandlers[nativeEventName].call(instance, event);
                $c0dbbc6989260eee$var$setTouchTimer(scope);
            });
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$localNativeListenerNames.mouse, function(nativeEventName) {
            $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                event = (0, $b3864a78637ff9ed$export$4abe0e945399ac1d)(event);
                if (!scope.touching) domHandlers[nativeEventName].call(instance, event);
            });
        });
    }
}
function $c0dbbc6989260eee$var$mountGlobalDOMEventListeners(instance, scope) {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).pointerEventsSupported) $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$globalNativeListenerNames.pointer, mount);
    else if (!(0, $ce6dd58693a21851$export$2e2bcd8739ae039).touchEventsSupported) $7a1bd9c2710fea0d$export$79b2f7037acddd43($c0dbbc6989260eee$var$globalNativeListenerNames.mouse, mount);
    function mount(nativeEventName) {
        function nativeEventListener(event) {
            event = (0, $b3864a78637ff9ed$export$4abe0e945399ac1d)(event);
            if (!$c0dbbc6989260eee$var$isLocalEl(instance, event.target)) {
                event = $c0dbbc6989260eee$var$normalizeGlobalEvent(instance, event);
                scope.domHandlers[nativeEventName].call(instance, event);
            }
        }
        $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
            capture: true
        });
    }
}
function $c0dbbc6989260eee$var$mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
    scope.mounted[nativeEventName] = listener;
    scope.listenerOpts[nativeEventName] = opt;
    (0, $b3864a78637ff9ed$export$3f65cefe8380dbea)(scope.domTarget, nativeEventName, listener, opt);
}
function $c0dbbc6989260eee$var$unmountDOMEventListeners(scope) {
    var mounted = scope.mounted;
    for(var nativeEventName in mounted)if (mounted.hasOwnProperty(nativeEventName)) (0, $b3864a78637ff9ed$export$8ff9f68337b520c0)(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
    scope.mounted = {};
}
var $c0dbbc6989260eee$var$DOMHandlerScope = function() {
    function DOMHandlerScope(domTarget, domHandlers) {
        this.mounted = {};
        this.listenerOpts = {};
        this.touching = false;
        this.domTarget = domTarget;
        this.domHandlers = domHandlers;
    }
    return DOMHandlerScope;
}();
var $c0dbbc6989260eee$var$HandlerDomProxy = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(HandlerDomProxy, _super);
    function HandlerDomProxy(dom, painterRoot) {
        var _this = _super.call(this) || this;
        _this.__pointerCapturing = false;
        _this.dom = dom;
        _this.painterRoot = painterRoot;
        _this._localHandlerScope = new $c0dbbc6989260eee$var$DOMHandlerScope(dom, $c0dbbc6989260eee$var$localDOMHandlers);
        if ($c0dbbc6989260eee$var$globalEventSupported) _this._globalHandlerScope = new $c0dbbc6989260eee$var$DOMHandlerScope(document, $c0dbbc6989260eee$var$globalDOMHandlers);
        $c0dbbc6989260eee$var$mountLocalDOMEventListeners(_this, _this._localHandlerScope);
        return _this;
    }
    HandlerDomProxy.prototype.dispose = function() {
        $c0dbbc6989260eee$var$unmountDOMEventListeners(this._localHandlerScope);
        if ($c0dbbc6989260eee$var$globalEventSupported) $c0dbbc6989260eee$var$unmountDOMEventListeners(this._globalHandlerScope);
    };
    HandlerDomProxy.prototype.setCursor = function(cursorStyle) {
        this.dom.style && (this.dom.style.cursor = cursorStyle || "default");
    };
    HandlerDomProxy.prototype.__togglePointerCapture = function(isPointerCapturing) {
        this.__mayPointerCapture = null;
        if ($c0dbbc6989260eee$var$globalEventSupported && +this.__pointerCapturing ^ +isPointerCapturing) {
            this.__pointerCapturing = isPointerCapturing;
            var globalHandlerScope = this._globalHandlerScope;
            isPointerCapturing ? $c0dbbc6989260eee$var$mountGlobalDOMEventListeners(this, globalHandlerScope) : $c0dbbc6989260eee$var$unmountDOMEventListeners(globalHandlerScope);
        }
    };
    return HandlerDomProxy;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $c0dbbc6989260eee$export$2e2bcd8739ae039 = $c0dbbc6989260eee$var$HandlerDomProxy;




var $4b0cedd85979c776$var$dpr = 1;
if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).hasGlobalWindow) $4b0cedd85979c776$var$dpr = Math.max(window.devicePixelRatio || window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI || 1, 1);
var $4b0cedd85979c776$export$7cdcde344c85339c = 0;
var $4b0cedd85979c776$export$508f096bfcdaac40 = $4b0cedd85979c776$var$dpr;
var $4b0cedd85979c776$export$fd81e7ebc7dae256 = 0.4;
var $4b0cedd85979c776$export$f8ce94761f39398d = "#333";
var $4b0cedd85979c776$export$3c6e95f318c8369b = "#ccc";
var $4b0cedd85979c776$export$27682248795c3c6b = "#eee";






var $becf2d727f9cf450$var$mIdentity = $f41ebb9dd60b55b4$export$f0954fd7d5368655;
var $becf2d727f9cf450$var$EPSILON = 5e-5;
function $becf2d727f9cf450$var$isNotAroundZero(val) {
    return val > $becf2d727f9cf450$var$EPSILON || val < -$becf2d727f9cf450$var$EPSILON;
}
var $becf2d727f9cf450$var$scaleTmp = [];
var $becf2d727f9cf450$var$tmpTransform = [];
var $becf2d727f9cf450$var$originTransform = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
var $becf2d727f9cf450$var$abs = Math.abs;
var $becf2d727f9cf450$var$Transformable = function() {
    function Transformable() {}
    Transformable.prototype.getLocalTransform = function(m) {
        return Transformable.getLocalTransform(this, m);
    };
    Transformable.prototype.setPosition = function(arr) {
        this.x = arr[0];
        this.y = arr[1];
    };
    Transformable.prototype.setScale = function(arr) {
        this.scaleX = arr[0];
        this.scaleY = arr[1];
    };
    Transformable.prototype.setSkew = function(arr) {
        this.skewX = arr[0];
        this.skewY = arr[1];
    };
    Transformable.prototype.setOrigin = function(arr) {
        this.originX = arr[0];
        this.originY = arr[1];
    };
    Transformable.prototype.needLocalTransform = function() {
        return $becf2d727f9cf450$var$isNotAroundZero(this.rotation) || $becf2d727f9cf450$var$isNotAroundZero(this.x) || $becf2d727f9cf450$var$isNotAroundZero(this.y) || $becf2d727f9cf450$var$isNotAroundZero(this.scaleX - 1) || $becf2d727f9cf450$var$isNotAroundZero(this.scaleY - 1) || $becf2d727f9cf450$var$isNotAroundZero(this.skewX) || $becf2d727f9cf450$var$isNotAroundZero(this.skewY);
    };
    Transformable.prototype.updateTransform = function() {
        var parentTransform = this.parent && this.parent.transform;
        var needLocalTransform = this.needLocalTransform();
        var m = this.transform;
        if (!(needLocalTransform || parentTransform)) {
            if (m) {
                $becf2d727f9cf450$var$mIdentity(m);
                this.invTransform = null;
            }
            return;
        }
        m = m || $f41ebb9dd60b55b4$export$185802fd694ee1f5();
        if (needLocalTransform) this.getLocalTransform(m);
        else $becf2d727f9cf450$var$mIdentity(m);
        if (parentTransform) {
            if (needLocalTransform) $f41ebb9dd60b55b4$export$6e3a27864ab166fe(m, parentTransform, m);
            else $f41ebb9dd60b55b4$export$784d13d8ee351f07(m, parentTransform);
        }
        this.transform = m;
        this._resolveGlobalScaleRatio(m);
    };
    Transformable.prototype._resolveGlobalScaleRatio = function(m) {
        var globalScaleRatio = this.globalScaleRatio;
        if (globalScaleRatio != null && globalScaleRatio !== 1) {
            this.getGlobalScale($becf2d727f9cf450$var$scaleTmp);
            var relX = $becf2d727f9cf450$var$scaleTmp[0] < 0 ? -1 : 1;
            var relY = $becf2d727f9cf450$var$scaleTmp[1] < 0 ? -1 : 1;
            var sx = (($becf2d727f9cf450$var$scaleTmp[0] - relX) * globalScaleRatio + relX) / $becf2d727f9cf450$var$scaleTmp[0] || 0;
            var sy = (($becf2d727f9cf450$var$scaleTmp[1] - relY) * globalScaleRatio + relY) / $becf2d727f9cf450$var$scaleTmp[1] || 0;
            m[0] *= sx;
            m[1] *= sx;
            m[2] *= sy;
            m[3] *= sy;
        }
        this.invTransform = this.invTransform || $f41ebb9dd60b55b4$export$185802fd694ee1f5();
        $f41ebb9dd60b55b4$export$6897c284b6f9f4dc(this.invTransform, m);
    };
    Transformable.prototype.getComputedTransform = function() {
        var transformNode = this;
        var ancestors = [];
        while(transformNode){
            ancestors.push(transformNode);
            transformNode = transformNode.parent;
        }
        while(transformNode = ancestors.pop())transformNode.updateTransform();
        return this.transform;
    };
    Transformable.prototype.setLocalTransform = function(m) {
        if (!m) return;
        var sx = m[0] * m[0] + m[1] * m[1];
        var sy = m[2] * m[2] + m[3] * m[3];
        var rotation = Math.atan2(m[1], m[0]);
        var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
        sy = Math.sqrt(sy) * Math.cos(shearX);
        sx = Math.sqrt(sx);
        this.skewX = shearX;
        this.skewY = 0;
        this.rotation = -rotation;
        this.x = +m[4];
        this.y = +m[5];
        this.scaleX = sx;
        this.scaleY = sy;
        this.originX = 0;
        this.originY = 0;
    };
    Transformable.prototype.decomposeTransform = function() {
        if (!this.transform) return;
        var parent = this.parent;
        var m = this.transform;
        if (parent && parent.transform) {
            parent.invTransform = parent.invTransform || $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            $f41ebb9dd60b55b4$export$6e3a27864ab166fe($becf2d727f9cf450$var$tmpTransform, parent.invTransform, m);
            m = $becf2d727f9cf450$var$tmpTransform;
        }
        var ox = this.originX;
        var oy = this.originY;
        if (ox || oy) {
            $becf2d727f9cf450$var$originTransform[4] = ox;
            $becf2d727f9cf450$var$originTransform[5] = oy;
            $f41ebb9dd60b55b4$export$6e3a27864ab166fe($becf2d727f9cf450$var$tmpTransform, m, $becf2d727f9cf450$var$originTransform);
            $becf2d727f9cf450$var$tmpTransform[4] -= ox;
            $becf2d727f9cf450$var$tmpTransform[5] -= oy;
            m = $becf2d727f9cf450$var$tmpTransform;
        }
        this.setLocalTransform(m);
    };
    Transformable.prototype.getGlobalScale = function(out) {
        var m = this.transform;
        out = out || [];
        if (!m) {
            out[0] = 1;
            out[1] = 1;
            return out;
        }
        out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
        out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
        if (m[0] < 0) out[0] = -out[0];
        if (m[3] < 0) out[1] = -out[1];
        return out;
    };
    Transformable.prototype.transformCoordToLocal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var invTransform = this.invTransform;
        if (invTransform) $6de594cf8ac295ff$export$9f9dcb98c894b623(v2, v2, invTransform);
        return v2;
    };
    Transformable.prototype.transformCoordToGlobal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var transform = this.transform;
        if (transform) $6de594cf8ac295ff$export$9f9dcb98c894b623(v2, v2, transform);
        return v2;
    };
    Transformable.prototype.getLineScale = function() {
        var m = this.transform;
        return m && $becf2d727f9cf450$var$abs(m[0] - 1) > 1e-10 && $becf2d727f9cf450$var$abs(m[3] - 1) > 1e-10 ? Math.sqrt($becf2d727f9cf450$var$abs(m[0] * m[3] - m[2] * m[1])) : 1;
    };
    Transformable.prototype.copyTransform = function(source) {
        $becf2d727f9cf450$export$234b1c16dfa57d6a(this, source);
    };
    Transformable.getLocalTransform = function(target, m) {
        m = m || [];
        var ox = target.originX || 0;
        var oy = target.originY || 0;
        var sx = target.scaleX;
        var sy = target.scaleY;
        var ax = target.anchorX;
        var ay = target.anchorY;
        var rotation = target.rotation || 0;
        var x = target.x;
        var y = target.y;
        var skewX = target.skewX ? Math.tan(target.skewX) : 0;
        var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
        if (ox || oy || ax || ay) {
            var dx = ox + ax;
            var dy = oy + ay;
            m[4] = -dx * sx - skewX * dy * sy;
            m[5] = -dy * sy - skewY * dx * sx;
        } else m[4] = m[5] = 0;
        m[0] = sx;
        m[3] = sy;
        m[1] = skewY * sx;
        m[2] = skewX * sy;
        rotation && $f41ebb9dd60b55b4$export$bb628a54ab399bc9(m, m, rotation);
        m[4] += ox + x;
        m[5] += oy + y;
        return m;
    };
    Transformable.initDefaultProps = function() {
        var proto = Transformable.prototype;
        proto.scaleX = proto.scaleY = proto.globalScaleRatio = 1;
        proto.x = proto.y = proto.originX = proto.originY = proto.skewX = proto.skewY = proto.rotation = proto.anchorX = proto.anchorY = 0;
    }();
    return Transformable;
}();
var $becf2d727f9cf450$export$98ab6203ec3396e2 = [
    "x",
    "y",
    "originX",
    "originY",
    "anchorX",
    "anchorY",
    "rotation",
    "scaleX",
    "scaleY",
    "skewX",
    "skewY"
];
function $becf2d727f9cf450$export$234b1c16dfa57d6a(target, source) {
    for(var i = 0; i < $becf2d727f9cf450$export$98ab6203ec3396e2.length; i++){
        var propName = $becf2d727f9cf450$export$98ab6203ec3396e2[i];
        target[propName] = source[propName];
    }
}
var $becf2d727f9cf450$export$2e2bcd8739ae039 = $becf2d727f9cf450$var$Transformable;








var $6c308355c7107803$var$textWidthCache = {};
function $6c308355c7107803$export$3c49c185de0c2bfc(text, font) {
    font = font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
    var cacheOfFont = $6c308355c7107803$var$textWidthCache[font];
    if (!cacheOfFont) cacheOfFont = $6c308355c7107803$var$textWidthCache[font] = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(500);
    var width = cacheOfFont.get(text);
    if (width == null) {
        width = (0, $c6341dcc9d86826e$export$ef5e599365494451).measureText(text, font).width;
        cacheOfFont.put(text, width);
    }
    return width;
}
function $6c308355c7107803$export$85aabf24202fbe9b(text, font, textAlign, textBaseline) {
    var width = $6c308355c7107803$export$3c49c185de0c2bfc(text, font);
    var height = $6c308355c7107803$export$56204a27a2958a55(font);
    var x = $6c308355c7107803$export$eb5a525ef00ef9a4(0, width, textAlign);
    var y = $6c308355c7107803$export$bf7d6802d2badd9(0, height, textBaseline);
    var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
    return rect;
}
function $6c308355c7107803$export$c381147bfed79d9f(text, font, textAlign, textBaseline) {
    var textLines = ((text || "") + "").split("\n");
    var len = textLines.length;
    if (len === 1) return $6c308355c7107803$export$85aabf24202fbe9b(textLines[0], font, textAlign, textBaseline);
    else {
        var uniondRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
        for(var i = 0; i < textLines.length; i++){
            var rect = $6c308355c7107803$export$85aabf24202fbe9b(textLines[i], font, textAlign, textBaseline);
            i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
        }
        return uniondRect;
    }
}
function $6c308355c7107803$export$eb5a525ef00ef9a4(x, width, textAlign) {
    if (textAlign === "right") x -= width;
    else if (textAlign === "center") x -= width / 2;
    return x;
}
function $6c308355c7107803$export$bf7d6802d2badd9(y, height, verticalAlign) {
    if (verticalAlign === "middle") y -= height / 2;
    else if (verticalAlign === "bottom") y -= height;
    return y;
}
function $6c308355c7107803$export$56204a27a2958a55(font) {
    return $6c308355c7107803$export$3c49c185de0c2bfc("\u56FD", font);
}
function $6c308355c7107803$export$866cc30a33805630(text, font) {
    return (0, $c6341dcc9d86826e$export$ef5e599365494451).measureText(text, font);
}
function $6c308355c7107803$export$e8514cb5a5e2b40f(value, maxValue) {
    if (typeof value === "string") {
        if (value.lastIndexOf("%") >= 0) return parseFloat(value) / 100 * maxValue;
        return parseFloat(value);
    }
    return value;
}
function $6c308355c7107803$export$eee3603b512feab7(out, opts, rect) {
    var textPosition = opts.position || "inside";
    var distance = opts.distance != null ? opts.distance : 5;
    var height = rect.height;
    var width = rect.width;
    var halfHeight = height / 2;
    var x = rect.x;
    var y = rect.y;
    var textAlign = "left";
    var textVerticalAlign = "top";
    if (textPosition instanceof Array) {
        x += $6c308355c7107803$export$e8514cb5a5e2b40f(textPosition[0], rect.width);
        y += $6c308355c7107803$export$e8514cb5a5e2b40f(textPosition[1], rect.height);
        textAlign = null;
        textVerticalAlign = null;
    } else switch(textPosition){
        case "left":
            x -= distance;
            y += halfHeight;
            textAlign = "right";
            textVerticalAlign = "middle";
            break;
        case "right":
            x += distance + width;
            y += halfHeight;
            textVerticalAlign = "middle";
            break;
        case "top":
            x += width / 2;
            y -= distance;
            textAlign = "center";
            textVerticalAlign = "bottom";
            break;
        case "bottom":
            x += width / 2;
            y += height + distance;
            textAlign = "center";
            break;
        case "inside":
            x += width / 2;
            y += halfHeight;
            textAlign = "center";
            textVerticalAlign = "middle";
            break;
        case "insideLeft":
            x += distance;
            y += halfHeight;
            textVerticalAlign = "middle";
            break;
        case "insideRight":
            x += width - distance;
            y += halfHeight;
            textAlign = "right";
            textVerticalAlign = "middle";
            break;
        case "insideTop":
            x += width / 2;
            y += distance;
            textAlign = "center";
            break;
        case "insideBottom":
            x += width / 2;
            y += height - distance;
            textAlign = "center";
            textVerticalAlign = "bottom";
            break;
        case "insideTopLeft":
            x += distance;
            y += distance;
            break;
        case "insideTopRight":
            x += width - distance;
            y += distance;
            textAlign = "right";
            break;
        case "insideBottomLeft":
            x += distance;
            y += height - distance;
            textVerticalAlign = "bottom";
            break;
        case "insideBottomRight":
            x += width - distance;
            y += height - distance;
            textAlign = "right";
            textVerticalAlign = "bottom";
            break;
    }
    out = out || {};
    out.x = x;
    out.y = y;
    out.align = textAlign;
    out.verticalAlign = textVerticalAlign;
    return out;
}






var $4bb0f26b847654d5$export$97b5e845c7286801 = "__zr_normal__";
var $4bb0f26b847654d5$var$PRIMARY_STATES_KEYS = (0, $becf2d727f9cf450$export$98ab6203ec3396e2).concat([
    "ignore"
]);
var $4bb0f26b847654d5$var$DEFAULT_ANIMATABLE_MAP = (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)((0, $becf2d727f9cf450$export$98ab6203ec3396e2), function(obj, key) {
    obj[key] = true;
    return obj;
}, {
    ignore: false
});
var $4bb0f26b847654d5$var$tmpTextPosCalcRes = {};
var $4bb0f26b847654d5$var$tmpBoundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $4bb0f26b847654d5$var$Element = function() {
    function Element(props) {
        this.id = (0, $7a1bd9c2710fea0d$export$46e8f25c7328f77e)();
        this.animators = [];
        this.currentStates = [];
        this.states = {};
        this._init(props);
    }
    Element.prototype._init = function(props) {
        this.attr(props);
    };
    Element.prototype.drift = function(dx, dy, e) {
        switch(this.draggable){
            case "horizontal":
                dy = 0;
                break;
            case "vertical":
                dx = 0;
                break;
        }
        var m = this.transform;
        if (!m) m = this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        m[4] += dx;
        m[5] += dy;
        this.decomposeTransform();
        this.markRedraw();
    };
    Element.prototype.beforeUpdate = function() {};
    Element.prototype.afterUpdate = function() {};
    Element.prototype.update = function() {
        this.updateTransform();
        if (this.__dirty) this.updateInnerText();
    };
    Element.prototype.updateInnerText = function(forceUpdate) {
        var textEl = this._textContent;
        if (textEl && (!textEl.ignore || forceUpdate)) {
            if (!this.textConfig) this.textConfig = {};
            var textConfig = this.textConfig;
            var isLocal = textConfig.local;
            var innerTransformable = textEl.innerTransformable;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var textStyleChanged = false;
            innerTransformable.parent = isLocal ? this : null;
            var innerOrigin = false;
            innerTransformable.copyTransform(textEl);
            if (textConfig.position != null) {
                var layoutRect = $4bb0f26b847654d5$var$tmpBoundingRect;
                if (textConfig.layoutRect) layoutRect.copy(textConfig.layoutRect);
                else layoutRect.copy(this.getBoundingRect());
                if (!isLocal) layoutRect.applyTransform(this.transform);
                if (this.calculateTextPosition) this.calculateTextPosition($4bb0f26b847654d5$var$tmpTextPosCalcRes, textConfig, layoutRect);
                else (0, $6c308355c7107803$export$eee3603b512feab7)($4bb0f26b847654d5$var$tmpTextPosCalcRes, textConfig, layoutRect);
                innerTransformable.x = $4bb0f26b847654d5$var$tmpTextPosCalcRes.x;
                innerTransformable.y = $4bb0f26b847654d5$var$tmpTextPosCalcRes.y;
                textAlign = $4bb0f26b847654d5$var$tmpTextPosCalcRes.align;
                textVerticalAlign = $4bb0f26b847654d5$var$tmpTextPosCalcRes.verticalAlign;
                var textOrigin = textConfig.origin;
                if (textOrigin && textConfig.rotation != null) {
                    var relOriginX = void 0;
                    var relOriginY = void 0;
                    if (textOrigin === "center") {
                        relOriginX = layoutRect.width * 0.5;
                        relOriginY = layoutRect.height * 0.5;
                    } else {
                        relOriginX = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(textOrigin[0], layoutRect.width);
                        relOriginY = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(textOrigin[1], layoutRect.height);
                    }
                    innerOrigin = true;
                    innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
                    innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
                }
            }
            if (textConfig.rotation != null) innerTransformable.rotation = textConfig.rotation;
            var textOffset = textConfig.offset;
            if (textOffset) {
                innerTransformable.x += textOffset[0];
                innerTransformable.y += textOffset[1];
                if (!innerOrigin) {
                    innerTransformable.originX = -textOffset[0];
                    innerTransformable.originY = -textOffset[1];
                }
            }
            var isInside = textConfig.inside == null ? typeof textConfig.position === "string" && textConfig.position.indexOf("inside") >= 0 : textConfig.inside;
            var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
            var textFill = void 0;
            var textStroke = void 0;
            var autoStroke = void 0;
            if (isInside && this.canBeInsideText()) {
                textFill = textConfig.insideFill;
                textStroke = textConfig.insideStroke;
                if (textFill == null || textFill === "auto") textFill = this.getInsideTextFill();
                if (textStroke == null || textStroke === "auto") {
                    textStroke = this.getInsideTextStroke(textFill);
                    autoStroke = true;
                }
            } else {
                textFill = textConfig.outsideFill;
                textStroke = textConfig.outsideStroke;
                if (textFill == null || textFill === "auto") textFill = this.getOutsideFill();
                if (textStroke == null || textStroke === "auto") {
                    textStroke = this.getOutsideStroke(textFill);
                    autoStroke = true;
                }
            }
            textFill = textFill || "#000";
            if (textFill !== innerTextDefaultStyle.fill || textStroke !== innerTextDefaultStyle.stroke || autoStroke !== innerTextDefaultStyle.autoStroke || textAlign !== innerTextDefaultStyle.align || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
                textStyleChanged = true;
                innerTextDefaultStyle.fill = textFill;
                innerTextDefaultStyle.stroke = textStroke;
                innerTextDefaultStyle.autoStroke = autoStroke;
                innerTextDefaultStyle.align = textAlign;
                innerTextDefaultStyle.verticalAlign = textVerticalAlign;
                textEl.setDefaultTextStyle(innerTextDefaultStyle);
            }
            textEl.__dirty |= (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
            if (textStyleChanged) textEl.dirtyStyle(true);
        }
    };
    Element.prototype.canBeInsideText = function() {
        return true;
    };
    Element.prototype.getInsideTextFill = function() {
        return "#fff";
    };
    Element.prototype.getInsideTextStroke = function(textFill) {
        return "#000";
    };
    Element.prototype.getOutsideFill = function() {
        return this.__zr && this.__zr.isDarkMode() ? (0, $4b0cedd85979c776$export$3c6e95f318c8369b) : (0, $4b0cedd85979c776$export$f8ce94761f39398d);
    };
    Element.prototype.getOutsideStroke = function(textFill) {
        var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
        var colorArr = typeof backgroundColor === "string" && (0, $2c037f5bda6341ca$export$98e6a39c04603d36)(backgroundColor);
        if (!colorArr) colorArr = [
            255,
            255,
            255,
            1
        ];
        var alpha = colorArr[3];
        var isDark = this.__zr.isDarkMode();
        for(var i = 0; i < 3; i++)colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
        colorArr[3] = 1;
        return (0, $2c037f5bda6341ca$export$fac44ee5b035f737)(colorArr, "rgba");
    };
    Element.prototype.traverse = function(cb, context) {};
    Element.prototype.attrKV = function(key, value) {
        if (key === "textConfig") this.setTextConfig(value);
        else if (key === "textContent") this.setTextContent(value);
        else if (key === "clipPath") this.setClipPath(value);
        else if (key === "extra") {
            this.extra = this.extra || {};
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.extra, value);
        } else this[key] = value;
    };
    Element.prototype.hide = function() {
        this.ignore = true;
        this.markRedraw();
    };
    Element.prototype.show = function() {
        this.ignore = false;
        this.markRedraw();
    };
    Element.prototype.attr = function(keyOrObj, value) {
        if (typeof keyOrObj === "string") this.attrKV(keyOrObj, value);
        else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(keyOrObj)) {
            var obj = keyOrObj;
            var keysArr = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(obj);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                this.attrKV(key, keyOrObj[key]);
            }
        }
        this.markRedraw();
        return this;
    };
    Element.prototype.saveCurrentToNormalState = function(toState) {
        this._innerSaveToNormal(toState);
        var normalState = this._normalState;
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var fromStateTransition = animator.__fromStateTransition;
            if (animator.getLoop() || fromStateTransition && fromStateTransition !== $4bb0f26b847654d5$export$97b5e845c7286801) continue;
            var targetName = animator.targetName;
            var target = targetName ? normalState[targetName] : normalState;
            animator.saveTo(target);
        }
    };
    Element.prototype._innerSaveToNormal = function(toState) {
        var normalState = this._normalState;
        if (!normalState) normalState = this._normalState = {};
        if (toState.textConfig && !normalState.textConfig) normalState.textConfig = this.textConfig;
        this._savePrimaryToNormal(toState, normalState, $4bb0f26b847654d5$var$PRIMARY_STATES_KEYS);
    };
    Element.prototype._savePrimaryToNormal = function(toState, normalState, primaryKeys) {
        for(var i = 0; i < primaryKeys.length; i++){
            var key = primaryKeys[i];
            if (toState[key] != null && !(key in normalState)) normalState[key] = this[key];
        }
    };
    Element.prototype.hasState = function() {
        return this.currentStates.length > 0;
    };
    Element.prototype.getState = function(name) {
        return this.states[name];
    };
    Element.prototype.ensureState = function(name) {
        var states = this.states;
        if (!states[name]) states[name] = {};
        return states[name];
    };
    Element.prototype.clearStates = function(noAnimation) {
        this.useState($4bb0f26b847654d5$export$97b5e845c7286801, false, noAnimation);
    };
    Element.prototype.useState = function(stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
        var toNormalState = stateName === $4bb0f26b847654d5$export$97b5e845c7286801;
        var hasStates = this.hasState();
        if (!hasStates && toNormalState) return;
        var currentStates = this.currentStates;
        var animationCfg = this.stateTransition;
        if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) return;
        var state;
        if (this.stateProxy && !toNormalState) state = this.stateProxy(stateName);
        if (!state) state = this.states && this.states[stateName];
        if (!state && !toNormalState) {
            (0, $7a1bd9c2710fea0d$export$58da9968c3170cb1)("State " + stateName + " not exists.");
            return;
        }
        if (!toNormalState) this.saveCurrentToNormalState(state);
        var useHoverLayer = !!(state && state.hoverLayer || forceUseHoverLayer);
        if (useHoverLayer) this._toggleHoverLayerFlag(true);
        this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (textGuide) textGuide.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (toNormalState) {
            this.currentStates = [];
            this._normalState = {};
        } else if (!keepCurrentStates) this.currentStates = [
            stateName
        ];
        else this.currentStates.push(stateName);
        this._updateAnimationTargets();
        this.markRedraw();
        if (!useHoverLayer && this.__inHover) {
            this._toggleHoverLayerFlag(false);
            this.__dirty &= ~(0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        }
        return state;
    };
    Element.prototype.useStates = function(states, noAnimation, forceUseHoverLayer) {
        if (!states.length) this.clearStates();
        else {
            var stateObjects = [];
            var currentStates = this.currentStates;
            var len = states.length;
            var notChange = len === currentStates.length;
            if (notChange) {
                for(var i = 0; i < len; i++)if (states[i] !== currentStates[i]) {
                    notChange = false;
                    break;
                }
            }
            if (notChange) return;
            for(var i = 0; i < len; i++){
                var stateName = states[i];
                var stateObj = void 0;
                if (this.stateProxy) stateObj = this.stateProxy(stateName, states);
                if (!stateObj) stateObj = this.states[stateName];
                if (stateObj) stateObjects.push(stateObj);
            }
            var lastStateObj = stateObjects[len - 1];
            var useHoverLayer = !!(lastStateObj && lastStateObj.hoverLayer || forceUseHoverLayer);
            if (useHoverLayer) this._toggleHoverLayerFlag(true);
            var mergedState = this._mergeStates(stateObjects);
            var animationCfg = this.stateTransition;
            this.saveCurrentToNormalState(mergedState);
            this._applyStateObj(states.join(","), mergedState, this._normalState, false, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
            var textContent = this._textContent;
            var textGuide = this._textGuide;
            if (textContent) textContent.useStates(states, noAnimation, useHoverLayer);
            if (textGuide) textGuide.useStates(states, noAnimation, useHoverLayer);
            this._updateAnimationTargets();
            this.currentStates = states.slice();
            this.markRedraw();
            if (!useHoverLayer && this.__inHover) {
                this._toggleHoverLayerFlag(false);
                this.__dirty &= ~(0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
            }
        }
    };
    Element.prototype.isSilent = function() {
        var isSilent = this.silent;
        var ancestor = this.parent;
        while(!isSilent && ancestor){
            if (ancestor.silent) {
                isSilent = true;
                break;
            }
            ancestor = ancestor.parent;
        }
        return isSilent;
    };
    Element.prototype._updateAnimationTargets = function() {
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            if (animator.targetName) animator.changeTarget(this[animator.targetName]);
        }
    };
    Element.prototype.removeState = function(state) {
        var idx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(this.currentStates, state);
        if (idx >= 0) {
            var currentStates = this.currentStates.slice();
            currentStates.splice(idx, 1);
            this.useStates(currentStates);
        }
    };
    Element.prototype.replaceState = function(oldState, newState, forceAdd) {
        var currentStates = this.currentStates.slice();
        var idx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(currentStates, oldState);
        var newStateExists = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(currentStates, newState) >= 0;
        if (idx >= 0) {
            if (!newStateExists) currentStates[idx] = newState;
            else currentStates.splice(idx, 1);
        } else if (forceAdd && !newStateExists) currentStates.push(newState);
        this.useStates(currentStates);
    };
    Element.prototype.toggleState = function(state, enable) {
        if (enable) this.useState(state, true);
        else this.removeState(state);
    };
    Element.prototype._mergeStates = function(states) {
        var mergedState = {};
        var mergedTextConfig;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(mergedState, state);
            if (state.textConfig) {
                mergedTextConfig = mergedTextConfig || {};
                (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(mergedTextConfig, state.textConfig);
            }
        }
        if (mergedTextConfig) mergedState.textConfig = mergedTextConfig;
        return mergedState;
    };
    Element.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        var needsRestoreToNormal = !(state && keepCurrentStates);
        if (state && state.textConfig) {
            this.textConfig = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.textConfig, state.textConfig);
        } else if (needsRestoreToNormal) {
            if (normalState.textConfig) this.textConfig = normalState.textConfig;
        }
        var transitionTarget = {};
        var hasTransition = false;
        for(var i = 0; i < $4bb0f26b847654d5$var$PRIMARY_STATES_KEYS.length; i++){
            var key = $4bb0f26b847654d5$var$PRIMARY_STATES_KEYS[i];
            var propNeedsTransition = transition && $4bb0f26b847654d5$var$DEFAULT_ANIMATABLE_MAP[key];
            if (state && state[key] != null) {
                if (propNeedsTransition) {
                    hasTransition = true;
                    transitionTarget[key] = state[key];
                } else this[key] = state[key];
            } else if (needsRestoreToNormal) {
                if (normalState[key] != null) {
                    if (propNeedsTransition) {
                        hasTransition = true;
                        transitionTarget[key] = normalState[key];
                    } else this[key] = normalState[key];
                }
            }
        }
        if (!transition) for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var targetName = animator.targetName;
            if (!animator.getLoop()) animator.__changeFinalValue(targetName ? (state || normalState)[targetName] : state || normalState);
        }
        if (hasTransition) this._transitionState(stateName, transitionTarget, animationCfg);
    };
    Element.prototype._attachComponent = function(componentEl) {
        if (componentEl.__zr && !componentEl.__hostTarget) return;
        if (componentEl === this) return;
        var zr = this.__zr;
        if (zr) componentEl.addSelfToZr(zr);
        componentEl.__zr = zr;
        componentEl.__hostTarget = this;
    };
    Element.prototype._detachComponent = function(componentEl) {
        if (componentEl.__zr) componentEl.removeSelfFromZr(componentEl.__zr);
        componentEl.__zr = null;
        componentEl.__hostTarget = null;
    };
    Element.prototype.getClipPath = function() {
        return this._clipPath;
    };
    Element.prototype.setClipPath = function(clipPath) {
        if (this._clipPath && this._clipPath !== clipPath) this.removeClipPath();
        this._attachComponent(clipPath);
        this._clipPath = clipPath;
        this.markRedraw();
    };
    Element.prototype.removeClipPath = function() {
        var clipPath = this._clipPath;
        if (clipPath) {
            this._detachComponent(clipPath);
            this._clipPath = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextContent = function() {
        return this._textContent;
    };
    Element.prototype.setTextContent = function(textEl) {
        var previousTextContent = this._textContent;
        if (previousTextContent === textEl) return;
        if (previousTextContent && previousTextContent !== textEl) this.removeTextContent();
        textEl.innerTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
        this._attachComponent(textEl);
        this._textContent = textEl;
        this.markRedraw();
    };
    Element.prototype.setTextConfig = function(cfg) {
        if (!this.textConfig) this.textConfig = {};
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.textConfig, cfg);
        this.markRedraw();
    };
    Element.prototype.removeTextConfig = function() {
        this.textConfig = null;
        this.markRedraw();
    };
    Element.prototype.removeTextContent = function() {
        var textEl = this._textContent;
        if (textEl) {
            textEl.innerTransformable = null;
            this._detachComponent(textEl);
            this._textContent = null;
            this._innerTextDefaultStyle = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextGuideLine = function() {
        return this._textGuide;
    };
    Element.prototype.setTextGuideLine = function(guideLine) {
        if (this._textGuide && this._textGuide !== guideLine) this.removeTextGuideLine();
        this._attachComponent(guideLine);
        this._textGuide = guideLine;
        this.markRedraw();
    };
    Element.prototype.removeTextGuideLine = function() {
        var textGuide = this._textGuide;
        if (textGuide) {
            this._detachComponent(textGuide);
            this._textGuide = null;
            this.markRedraw();
        }
    };
    Element.prototype.markRedraw = function() {
        this.__dirty |= (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        var zr = this.__zr;
        if (zr) {
            if (this.__inHover) zr.refreshHover();
            else zr.refresh();
        }
        if (this.__hostTarget) this.__hostTarget.markRedraw();
    };
    Element.prototype.dirty = function() {
        this.markRedraw();
    };
    Element.prototype._toggleHoverLayerFlag = function(inHover) {
        this.__inHover = inHover;
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.__inHover = inHover;
        if (textGuide) textGuide.__inHover = inHover;
    };
    Element.prototype.addSelfToZr = function(zr) {
        if (this.__zr === zr) return;
        this.__zr = zr;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.addAnimator(animators[i]);
        if (this._clipPath) this._clipPath.addSelfToZr(zr);
        if (this._textContent) this._textContent.addSelfToZr(zr);
        if (this._textGuide) this._textGuide.addSelfToZr(zr);
    };
    Element.prototype.removeSelfFromZr = function(zr) {
        if (!this.__zr) return;
        this.__zr = null;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.removeAnimator(animators[i]);
        if (this._clipPath) this._clipPath.removeSelfFromZr(zr);
        if (this._textContent) this._textContent.removeSelfFromZr(zr);
        if (this._textGuide) this._textGuide.removeSelfFromZr(zr);
    };
    Element.prototype.animate = function(key, loop, allowDiscreteAnimation) {
        var target = key ? this[key] : this;
        var animator = new (0, $76d8a142a20276fc$export$2e2bcd8739ae039)(target, loop, allowDiscreteAnimation);
        key && (animator.targetName = key);
        this.addAnimator(animator, key);
        return animator;
    };
    Element.prototype.addAnimator = function(animator, key) {
        var zr = this.__zr;
        var el = this;
        animator.during(function() {
            el.updateDuringAnimation(key);
        }).done(function() {
            var animators = el.animators;
            var idx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(animators, animator);
            if (idx >= 0) animators.splice(idx, 1);
        });
        this.animators.push(animator);
        if (zr) zr.animation.addAnimator(animator);
        zr && zr.wakeUp();
    };
    Element.prototype.updateDuringAnimation = function(key) {
        this.markRedraw();
    };
    Element.prototype.stopAnimation = function(scope, forwardToLast) {
        var animators = this.animators;
        var len = animators.length;
        var leftAnimators = [];
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            if (!scope || scope === animator.scope) animator.stop(forwardToLast);
            else leftAnimators.push(animator);
        }
        this.animators = leftAnimators;
        return this;
    };
    Element.prototype.animateTo = function(target, cfg, animationProps) {
        $4bb0f26b847654d5$var$animateTo(this, target, cfg, animationProps);
    };
    Element.prototype.animateFrom = function(target, cfg, animationProps) {
        $4bb0f26b847654d5$var$animateTo(this, target, cfg, animationProps, true);
    };
    Element.prototype._transitionState = function(stateName, target, cfg, animationProps) {
        var animators = $4bb0f26b847654d5$var$animateTo(this, target, cfg, animationProps);
        for(var i = 0; i < animators.length; i++)animators[i].__fromStateTransition = stateName;
    };
    Element.prototype.getBoundingRect = function() {
        return null;
    };
    Element.prototype.getPaintRect = function() {
        return null;
    };
    Element.initDefaultProps = function() {
        var elProto = Element.prototype;
        elProto.type = "element";
        elProto.name = "";
        elProto.ignore = elProto.silent = elProto.isGroup = elProto.draggable = elProto.dragging = elProto.ignoreClip = elProto.__inHover = false;
        elProto.__dirty = (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        var logs = {};
        function logDeprecatedError(key, xKey, yKey) {
            if (!logs[key + xKey + yKey]) {
                console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
                logs[key + xKey + yKey] = true;
            }
        }
        function createLegacyProperty(key, privateKey, xKey, yKey) {
            Object.defineProperty(elProto, key, {
                get: function() {
                    if (!this[privateKey]) {
                        var pos = this[privateKey] = [];
                        enhanceArray(this, pos);
                    }
                    return this[privateKey];
                },
                set: function(pos) {
                    this[xKey] = pos[0];
                    this[yKey] = pos[1];
                    this[privateKey] = pos;
                    enhanceArray(this, pos);
                }
            });
            function enhanceArray(self, pos) {
                Object.defineProperty(pos, 0, {
                    get: function() {
                        return self[xKey];
                    },
                    set: function(val) {
                        self[xKey] = val;
                    }
                });
                Object.defineProperty(pos, 1, {
                    get: function() {
                        return self[yKey];
                    },
                    set: function(val) {
                        self[yKey] = val;
                    }
                });
            }
        }
        if (Object.defineProperty) {
            createLegacyProperty("position", "_legacyPos", "x", "y");
            createLegacyProperty("scale", "_legacyScale", "scaleX", "scaleY");
            createLegacyProperty("origin", "_legacyOrigin", "originX", "originY");
        }
    }();
    return Element;
}();
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($4bb0f26b847654d5$var$Element, (0, $63441a86293f101f$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($4bb0f26b847654d5$var$Element, (0, $becf2d727f9cf450$export$2e2bcd8739ae039));
function $4bb0f26b847654d5$var$animateTo(animatable, target, cfg, animationProps, reverse) {
    cfg = cfg || {};
    var animators = [];
    $4bb0f26b847654d5$var$animateToShallow(animatable, "", animatable, target, cfg, animationProps, animators, reverse);
    var finishCount = animators.length;
    var doneHappened = false;
    var cfgDone = cfg.done;
    var cfgAborted = cfg.aborted;
    var doneCb = function() {
        doneHappened = true;
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    var abortedCb = function() {
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    if (!finishCount) cfgDone && cfgDone();
    if (animators.length > 0 && cfg.during) animators[0].during(function(target, percent) {
        cfg.during(percent);
    });
    for(var i = 0; i < animators.length; i++){
        var animator = animators[i];
        if (doneCb) animator.done(doneCb);
        if (abortedCb) animator.aborted(abortedCb);
        if (cfg.force) animator.duration(cfg.duration);
        animator.start(cfg.easing);
    }
    return animators;
}
function $4bb0f26b847654d5$var$copyArrShallow(source, target, len) {
    for(var i = 0; i < len; i++)source[i] = target[i];
}
function $4bb0f26b847654d5$var$is2DArray(value) {
    return (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(value[0]);
}
function $4bb0f26b847654d5$var$copyValue(target, source, key) {
    if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(source[key])) {
        if (!(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(target[key])) target[key] = [];
        if ((0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(source[key])) {
            var len = source[key].length;
            if (target[key].length !== len) {
                target[key] = new source[key].constructor(len);
                $4bb0f26b847654d5$var$copyArrShallow(target[key], source[key], len);
            }
        } else {
            var sourceArr = source[key];
            var targetArr = target[key];
            var len0 = sourceArr.length;
            if ($4bb0f26b847654d5$var$is2DArray(sourceArr)) {
                var len1 = sourceArr[0].length;
                for(var i = 0; i < len0; i++)if (!targetArr[i]) targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
                else $4bb0f26b847654d5$var$copyArrShallow(targetArr[i], sourceArr[i], len1);
            } else $4bb0f26b847654d5$var$copyArrShallow(targetArr, sourceArr, len0);
            targetArr.length = sourceArr.length;
        }
    } else target[key] = source[key];
}
function $4bb0f26b847654d5$var$isValueSame(val1, val2) {
    return val1 === val2 || (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(val1) && (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(val2) && $4bb0f26b847654d5$var$is1DArraySame(val1, val2);
}
function $4bb0f26b847654d5$var$is1DArraySame(arr0, arr1) {
    var len = arr0.length;
    if (len !== arr1.length) return false;
    for(var i = 0; i < len; i++){
        if (arr0[i] !== arr1[i]) return false;
    }
    return true;
}
function $4bb0f26b847654d5$var$animateToShallow(animatable, topKey, animateObj, target, cfg, animationProps, animators, reverse) {
    var targetKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(target);
    var duration = cfg.duration;
    var delay = cfg.delay;
    var additive = cfg.additive;
    var setToFinal = cfg.setToFinal;
    var animateAll = !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(animationProps);
    var existsAnimators = animatable.animators;
    var animationKeys = [];
    for(var k = 0; k < targetKeys.length; k++){
        var innerKey = targetKeys[k];
        var targetVal = target[innerKey];
        if (targetVal != null && animateObj[innerKey] != null && (animateAll || animationProps[innerKey])) {
            if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(targetVal) && !(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(targetVal) && !(0, $7a1bd9c2710fea0d$export$fa2c283003ed971c)(targetVal)) {
                if (topKey) {
                    if (!reverse) {
                        animateObj[innerKey] = targetVal;
                        animatable.updateDuringAnimation(topKey);
                    }
                    continue;
                }
                $4bb0f26b847654d5$var$animateToShallow(animatable, innerKey, animateObj[innerKey], targetVal, cfg, animationProps && animationProps[innerKey], animators, reverse);
            } else animationKeys.push(innerKey);
        } else if (!reverse) {
            animateObj[innerKey] = targetVal;
            animatable.updateDuringAnimation(topKey);
            animationKeys.push(innerKey);
        }
    }
    var keyLen = animationKeys.length;
    if (!additive && keyLen) for(var i = 0; i < existsAnimators.length; i++){
        var animator = existsAnimators[i];
        if (animator.targetName === topKey) {
            var allAborted = animator.stopTracks(animationKeys);
            if (allAborted) {
                var idx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(existsAnimators, animator);
                existsAnimators.splice(idx, 1);
            }
        }
    }
    if (!cfg.force) {
        animationKeys = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(animationKeys, function(key) {
            return !$4bb0f26b847654d5$var$isValueSame(target[key], animateObj[key]);
        });
        keyLen = animationKeys.length;
    }
    if (keyLen > 0 || cfg.force && !animators.length) {
        var revertedSource = void 0;
        var reversedTarget = void 0;
        var sourceClone = void 0;
        if (reverse) {
            reversedTarget = {};
            if (setToFinal) revertedSource = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                reversedTarget[innerKey] = animateObj[innerKey];
                if (setToFinal) revertedSource[innerKey] = target[innerKey];
                else animateObj[innerKey] = target[innerKey];
            }
        } else if (setToFinal) {
            sourceClone = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                sourceClone[innerKey] = (0, $76d8a142a20276fc$export$c5e92b7f105af84e)(animateObj[innerKey]);
                $4bb0f26b847654d5$var$copyValue(animateObj, target, innerKey);
            }
        }
        var animator = new (0, $76d8a142a20276fc$export$2e2bcd8739ae039)(animateObj, false, false, additive ? (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(existsAnimators, function(animator) {
            return animator.targetName === topKey;
        }) : null);
        animator.targetName = topKey;
        if (cfg.scope) animator.scope = cfg.scope;
        if (setToFinal && revertedSource) animator.whenWithKeys(0, revertedSource, animationKeys);
        if (sourceClone) animator.whenWithKeys(0, sourceClone, animationKeys);
        animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animationKeys).delay(delay || 0);
        animatable.addAnimator(animator, topKey);
        animators.push(animator);
    }
}
var $4bb0f26b847654d5$export$2e2bcd8739ae039 = $4bb0f26b847654d5$var$Element;



var $7ef7583d8302ffce$var$Group = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Group, _super);
    function Group(opts) {
        var _this = _super.call(this) || this;
        _this.isGroup = true;
        _this._children = [];
        _this.attr(opts);
        return _this;
    }
    Group.prototype.childrenRef = function() {
        return this._children;
    };
    Group.prototype.children = function() {
        return this._children.slice();
    };
    Group.prototype.childAt = function(idx) {
        return this._children[idx];
    };
    Group.prototype.childOfName = function(name) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            if (children[i].name === name) return children[i];
        }
    };
    Group.prototype.childCount = function() {
        return this._children.length;
    };
    Group.prototype.add = function(child) {
        if (child) {
            if (child !== this && child.parent !== this) {
                this._children.push(child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.addBefore = function(child, nextSibling) {
        if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
            var children = this._children;
            var idx = children.indexOf(nextSibling);
            if (idx >= 0) {
                children.splice(idx, 0, child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.replace = function(oldChild, newChild) {
        var idx = $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(this._children, oldChild);
        if (idx >= 0) this.replaceAt(newChild, idx);
        return this;
    };
    Group.prototype.replaceAt = function(child, index) {
        var children = this._children;
        var old = children[index];
        if (child && child !== this && child.parent !== this && child !== old) {
            children[index] = child;
            old.parent = null;
            var zr = this.__zr;
            if (zr) old.removeSelfFromZr(zr);
            this._doAdd(child);
        }
        return this;
    };
    Group.prototype._doAdd = function(child) {
        if (child.parent) child.parent.remove(child);
        child.parent = this;
        var zr = this.__zr;
        if (zr && zr !== child.__zr) child.addSelfToZr(zr);
        zr && zr.refresh();
    };
    Group.prototype.remove = function(child) {
        var zr = this.__zr;
        var children = this._children;
        var idx = $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(children, child);
        if (idx < 0) return this;
        children.splice(idx, 1);
        child.parent = null;
        if (zr) child.removeSelfFromZr(zr);
        zr && zr.refresh();
        return this;
    };
    Group.prototype.removeAll = function() {
        var children = this._children;
        var zr = this.__zr;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (zr) child.removeSelfFromZr(zr);
            child.parent = null;
        }
        children.length = 0;
        return this;
    };
    Group.prototype.eachChild = function(cb, context) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            cb.call(context, child, i);
        }
        return this;
    };
    Group.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            var stopped = cb.call(context, child);
            if (child.isGroup && !stopped) child.traverse(cb, context);
        }
        return this;
    };
    Group.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.addSelfToZr(zr);
        }
    };
    Group.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.removeSelfFromZr(zr);
        }
    };
    Group.prototype.getBoundingRect = function(includeChildren) {
        var tmpRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
        var children = includeChildren || this._children;
        var tmpMat = [];
        var rect = null;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (child.ignore || child.invisible) continue;
            var childRect = child.getBoundingRect();
            var transform = child.getLocalTransform(tmpMat);
            if (transform) {
                (0, $1bebe7106c895823$export$2e2bcd8739ae039).applyTransform(tmpRect, childRect, transform);
                rect = rect || tmpRect.clone();
                rect.union(tmpRect);
            } else {
                rect = rect || childRect.clone();
                rect.union(childRect);
            }
        }
        return rect || tmpRect;
    };
    return Group;
}((0, $4bb0f26b847654d5$export$2e2bcd8739ae039));
$7ef7583d8302ffce$var$Group.prototype.type = "group";
var $7ef7583d8302ffce$export$2e2bcd8739ae039 = $7ef7583d8302ffce$var$Group;


var $6eba88f9eebe6af9$var$painterCtors = {};
var $6eba88f9eebe6af9$var$instances = {};
function $6eba88f9eebe6af9$var$delInstance(id) {
    delete $6eba88f9eebe6af9$var$instances[id];
}
function $6eba88f9eebe6af9$var$isDarkMode(backgroundColor) {
    if (!backgroundColor) return false;
    if (typeof backgroundColor === "string") return (0, $2c037f5bda6341ca$export$16c0ec21a6f9ef95)(backgroundColor, 1) < (0, $4b0cedd85979c776$export$fd81e7ebc7dae256);
    else if (backgroundColor.colorStops) {
        var colorStops = backgroundColor.colorStops;
        var totalLum = 0;
        var len = colorStops.length;
        for(var i = 0; i < len; i++)totalLum += (0, $2c037f5bda6341ca$export$16c0ec21a6f9ef95)(colorStops[i].color, 1);
        totalLum /= len;
        return totalLum < (0, $4b0cedd85979c776$export$fd81e7ebc7dae256);
    }
    return false;
}
var $6eba88f9eebe6af9$var$ZRender = function() {
    function ZRender(id, dom, opts) {
        var _this = this;
        this._sleepAfterStill = 10;
        this._stillFrameAccum = 0;
        this._needsRefresh = true;
        this._needsRefreshHover = true;
        this._darkMode = false;
        opts = opts || {};
        this.dom = dom;
        this.id = id;
        var storage = new (0, $319574df0bc66e80$export$2e2bcd8739ae039)();
        var rendererType = opts.renderer || "canvas";
        if (!$6eba88f9eebe6af9$var$painterCtors[rendererType]) rendererType = $7a1bd9c2710fea0d$export$ed97f33186d4b816($6eba88f9eebe6af9$var$painterCtors)[0];
        opts.useDirtyRect = opts.useDirtyRect == null ? false : opts.useDirtyRect;
        var painter = new $6eba88f9eebe6af9$var$painterCtors[rendererType](dom, storage, opts, id);
        var ssrMode = opts.ssr || painter.ssrOnly;
        this.storage = storage;
        this.painter = painter;
        var handlerProxy = !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).node && !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).worker && !ssrMode ? new (0, $c0dbbc6989260eee$export$2e2bcd8739ae039)(painter.getViewportRoot(), painter.root) : null;
        var useCoarsePointer = opts.useCoarsePointer;
        var usePointerSize = useCoarsePointer == null || useCoarsePointer === "auto" ? (0, $ce6dd58693a21851$export$2e2bcd8739ae039).touchEventsSupported : !!useCoarsePointer;
        var defaultPointerSize = 44;
        var pointerSize;
        if (usePointerSize) pointerSize = $7a1bd9c2710fea0d$export$995e01f2f5c9d030(opts.pointerSize, defaultPointerSize);
        this.handler = new (0, $b30f5d021af2ec5a$export$2e2bcd8739ae039)(storage, painter, handlerProxy, painter.root, pointerSize);
        this.animation = new (0, $fad434a4044c956a$export$2e2bcd8739ae039)({
            stage: {
                update: ssrMode ? null : function() {
                    return _this._flush(true);
                }
            }
        });
        if (!ssrMode) this.animation.start();
    }
    ZRender.prototype.add = function(el) {
        if (this._disposed || !el) return;
        this.storage.addRoot(el);
        el.addSelfToZr(this);
        this.refresh();
    };
    ZRender.prototype.remove = function(el) {
        if (this._disposed || !el) return;
        this.storage.delRoot(el);
        el.removeSelfFromZr(this);
        this.refresh();
    };
    ZRender.prototype.configLayer = function(zLevel, config) {
        if (this._disposed) return;
        if (this.painter.configLayer) this.painter.configLayer(zLevel, config);
        this.refresh();
    };
    ZRender.prototype.setBackgroundColor = function(backgroundColor) {
        if (this._disposed) return;
        if (this.painter.setBackgroundColor) this.painter.setBackgroundColor(backgroundColor);
        this.refresh();
        this._backgroundColor = backgroundColor;
        this._darkMode = $6eba88f9eebe6af9$var$isDarkMode(backgroundColor);
    };
    ZRender.prototype.getBackgroundColor = function() {
        return this._backgroundColor;
    };
    ZRender.prototype.setDarkMode = function(darkMode) {
        this._darkMode = darkMode;
    };
    ZRender.prototype.isDarkMode = function() {
        return this._darkMode;
    };
    ZRender.prototype.refreshImmediately = function(fromInside) {
        if (this._disposed) return;
        if (!fromInside) this.animation.update(true);
        this._needsRefresh = false;
        this.painter.refresh();
        this._needsRefresh = false;
    };
    ZRender.prototype.refresh = function() {
        if (this._disposed) return;
        this._needsRefresh = true;
        this.animation.start();
    };
    ZRender.prototype.flush = function() {
        if (this._disposed) return;
        this._flush(false);
    };
    ZRender.prototype._flush = function(fromInside) {
        var triggerRendered;
        var start = (0, $fad434a4044c956a$export$1428f42a7de81803)();
        if (this._needsRefresh) {
            triggerRendered = true;
            this.refreshImmediately(fromInside);
        }
        if (this._needsRefreshHover) {
            triggerRendered = true;
            this.refreshHoverImmediately();
        }
        var end = (0, $fad434a4044c956a$export$1428f42a7de81803)();
        if (triggerRendered) {
            this._stillFrameAccum = 0;
            this.trigger("rendered", {
                elapsedTime: end - start
            });
        } else if (this._sleepAfterStill > 0) {
            this._stillFrameAccum++;
            if (this._stillFrameAccum > this._sleepAfterStill) this.animation.stop();
        }
    };
    ZRender.prototype.setSleepAfterStill = function(stillFramesCount) {
        this._sleepAfterStill = stillFramesCount;
    };
    ZRender.prototype.wakeUp = function() {
        if (this._disposed) return;
        this.animation.start();
        this._stillFrameAccum = 0;
    };
    ZRender.prototype.refreshHover = function() {
        this._needsRefreshHover = true;
    };
    ZRender.prototype.refreshHoverImmediately = function() {
        if (this._disposed) return;
        this._needsRefreshHover = false;
        if (this.painter.refreshHover && this.painter.getType() === "canvas") this.painter.refreshHover();
    };
    ZRender.prototype.resize = function(opts) {
        if (this._disposed) return;
        opts = opts || {};
        this.painter.resize(opts.width, opts.height);
        this.handler.resize();
    };
    ZRender.prototype.clearAnimation = function() {
        if (this._disposed) return;
        this.animation.clear();
    };
    ZRender.prototype.getWidth = function() {
        if (this._disposed) return;
        return this.painter.getWidth();
    };
    ZRender.prototype.getHeight = function() {
        if (this._disposed) return;
        return this.painter.getHeight();
    };
    ZRender.prototype.setCursorStyle = function(cursorStyle) {
        if (this._disposed) return;
        this.handler.setCursorStyle(cursorStyle);
    };
    ZRender.prototype.findHover = function(x, y) {
        if (this._disposed) return;
        return this.handler.findHover(x, y);
    };
    ZRender.prototype.on = function(eventName, eventHandler, context) {
        if (!this._disposed) this.handler.on(eventName, eventHandler, context);
        return this;
    };
    ZRender.prototype.off = function(eventName, eventHandler) {
        if (this._disposed) return;
        this.handler.off(eventName, eventHandler);
    };
    ZRender.prototype.trigger = function(eventName, event) {
        if (this._disposed) return;
        this.handler.trigger(eventName, event);
    };
    ZRender.prototype.clear = function() {
        if (this._disposed) return;
        var roots = this.storage.getRoots();
        for(var i = 0; i < roots.length; i++)if (roots[i] instanceof (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)) roots[i].removeSelfFromZr(this);
        this.storage.delAllRoots();
        this.painter.clear();
    };
    ZRender.prototype.dispose = function() {
        if (this._disposed) return;
        this.animation.stop();
        this.clear();
        this.storage.dispose();
        this.painter.dispose();
        this.handler.dispose();
        this.animation = this.storage = this.painter = this.handler = null;
        this._disposed = true;
        $6eba88f9eebe6af9$var$delInstance(this.id);
    };
    return ZRender;
}();
function $6eba88f9eebe6af9$export$2cd8252107eb640b(dom, opts) {
    var zr = new $6eba88f9eebe6af9$var$ZRender($7a1bd9c2710fea0d$export$46e8f25c7328f77e(), dom, opts);
    $6eba88f9eebe6af9$var$instances[zr.id] = zr;
    return zr;
}
function $6eba88f9eebe6af9$export$fcfbbcec2cb820d5(zr) {
    zr.dispose();
}
function $6eba88f9eebe6af9$export$825f692fb04800ef() {
    for(var key in $6eba88f9eebe6af9$var$instances)if ($6eba88f9eebe6af9$var$instances.hasOwnProperty(key)) $6eba88f9eebe6af9$var$instances[key].dispose();
    $6eba88f9eebe6af9$var$instances = {};
}
function $6eba88f9eebe6af9$export$8bedcca5bbd73999(id) {
    return $6eba88f9eebe6af9$var$instances[id];
}
function $6eba88f9eebe6af9$export$a3e793ccb11823a5(name, Ctor) {
    $6eba88f9eebe6af9$var$painterCtors[name] = Ctor;
}
var $6eba88f9eebe6af9$var$ssrDataGetter;
function $6eba88f9eebe6af9$export$dd7015a5412ca583(el) {
    if (typeof $6eba88f9eebe6af9$var$ssrDataGetter === "function") return $6eba88f9eebe6af9$var$ssrDataGetter(el);
}
function $6eba88f9eebe6af9$export$e7a09d7fe68a4f7(getter) {
    $6eba88f9eebe6af9$var$ssrDataGetter = getter;
}
var $6eba88f9eebe6af9$export$83d89fbfd8236492 = "5.5.0";






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The method "quantile" was copied from "d3.js".
* (See more details in the comment of the method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $cfc1f3b422a3185f$var$RADIAN_EPSILON = 1e-4;
// Although chrome already enlarge this number to 100 for `toFixed`, but
// we sill follow the spec for compatibility.
var $cfc1f3b422a3185f$var$ROUND_SUPPORTED_PRECISION_MAX = 20;
function $cfc1f3b422a3185f$var$_trim(str) {
    return str.replace(/^\s+|\s+$/g, "");
}
function $cfc1f3b422a3185f$export$d3f68fbaa670562(val, domain, range, clamp) {
    var d0 = domain[0];
    var d1 = domain[1];
    var r0 = range[0];
    var r1 = range[1];
    var subDomain = d1 - d0;
    var subRange = r1 - r0;
    if (subDomain === 0) return subRange === 0 ? r0 : (r0 + r1) / 2;
    // Avoid accuracy problem in edge, such as
    // 146.39 - 62.83 === 83.55999999999999.
    // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
    // It is a little verbose for efficiency considering this method
    // is a hotspot.
    if (clamp) {
        if (subDomain > 0) {
            if (val <= d0) return r0;
            else if (val >= d1) return r1;
        } else {
            if (val >= d0) return r0;
            else if (val <= d1) return r1;
        }
    } else {
        if (val === d0) return r0;
        if (val === d1) return r1;
    }
    return (val - d0) / subDomain * subRange + r0;
}
function $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(percent, all) {
    switch(percent){
        case "center":
        case "middle":
            percent = "50%";
            break;
        case "left":
        case "top":
            percent = "0%";
            break;
        case "right":
        case "bottom":
            percent = "100%";
            break;
    }
    if ($7a1bd9c2710fea0d$export$844ec244b1367d54(percent)) {
        if ($cfc1f3b422a3185f$var$_trim(percent).match(/%$/)) return parseFloat(percent) / 100 * all;
        return parseFloat(percent);
    }
    return percent == null ? NaN : +percent;
}
function $cfc1f3b422a3185f$export$2077e0241d6afd3c(x, precision, returnStr) {
    if (precision == null) precision = 10;
    // Avoid range error
    precision = Math.min(Math.max(0, precision), $cfc1f3b422a3185f$var$ROUND_SUPPORTED_PRECISION_MAX);
    // PENDING: 1.005.toFixed(2) is '1.00' rather than '1.01'
    x = (+x).toFixed(precision);
    return returnStr ? x : +x;
}
function $cfc1f3b422a3185f$export$debe6e778e0a6d32(arr) {
    arr.sort(function(a, b) {
        return a - b;
    });
    return arr;
}
function $cfc1f3b422a3185f$export$e0c74b50bbd10f68(val) {
    val = +val;
    if (isNaN(val)) return 0;
    // It is much faster than methods converting number to string as follows
    //      let tmp = val.toString();
    //      return tmp.length - 1 - tmp.indexOf('.');
    // especially when precision is low
    // Notice:
    // (1) If the loop count is over about 20, it is slower than `getPrecisionSafe`.
    //     (see https://jsbench.me/2vkpcekkvw/1)
    // (2) If the val is less than for example 1e-15, the result may be incorrect.
    //     (see test/ut/spec/util/number.test.ts `getPrecision_equal_random`)
    if (val > 1e-14) {
        var e = 1;
        for(var i = 0; i < 15; i++, e *= 10){
            if (Math.round(val * e) / e === val) return i;
        }
    }
    return $cfc1f3b422a3185f$export$6d86ba4ca4984d31(val);
}
function $cfc1f3b422a3185f$export$6d86ba4ca4984d31(val) {
    // toLowerCase for: '3.4E-12'
    var str = val.toString().toLowerCase();
    // Consider scientific notation: '3.4e-12' '3.4e+12'
    var eIndex = str.indexOf("e");
    var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
    var significandPartLen = eIndex > 0 ? eIndex : str.length;
    var dotIndex = str.indexOf(".");
    var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
    return Math.max(0, decimalPartLen - exp);
}
function $cfc1f3b422a3185f$export$666260d9a2dda8a7(dataExtent, pixelExtent) {
    var log = Math.log;
    var LN10 = Math.LN10;
    var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
    var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10);
    // toFixed() digits argument must be between 0 and 20.
    var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
    return !isFinite(precision) ? 20 : precision;
}
function $cfc1f3b422a3185f$export$70cc11b075afeb90(valueList, idx, precision) {
    if (!valueList[idx]) return 0;
    var seats = $cfc1f3b422a3185f$export$222dabb13d5320df(valueList, precision);
    return seats[idx] || 0;
}
function $cfc1f3b422a3185f$export$222dabb13d5320df(valueList, precision) {
    var sum = $7a1bd9c2710fea0d$export$533b26079ad0b4b(valueList, function(acc, val) {
        return acc + (isNaN(val) ? 0 : val);
    }, 0);
    if (sum === 0) return [];
    var digits = Math.pow(10, precision);
    var votesPerQuota = $7a1bd9c2710fea0d$export$871de8747c9eaa88(valueList, function(val) {
        return (isNaN(val) ? 0 : val) / sum * digits * 100;
    });
    var targetSeats = digits * 100;
    var seats = $7a1bd9c2710fea0d$export$871de8747c9eaa88(votesPerQuota, function(votes) {
        // Assign automatic seats.
        return Math.floor(votes);
    });
    var currentSum = $7a1bd9c2710fea0d$export$533b26079ad0b4b(seats, function(acc, val) {
        return acc + val;
    }, 0);
    var remainder = $7a1bd9c2710fea0d$export$871de8747c9eaa88(votesPerQuota, function(votes, idx) {
        return votes - seats[idx];
    });
    // Has remainding votes.
    while(currentSum < targetSeats){
        // Find next largest remainder.
        var max = Number.NEGATIVE_INFINITY;
        var maxId = null;
        for(var i = 0, len = remainder.length; i < len; ++i)if (remainder[i] > max) {
            max = remainder[i];
            maxId = i;
        }
        // Add a vote to max remainder.
        ++seats[maxId];
        remainder[maxId] = 0;
        ++currentSum;
    }
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(seats, function(seat) {
        return seat / digits;
    });
}
function $cfc1f3b422a3185f$export$d3389a301c3a5706(val0, val1) {
    var maxPrecision = Math.max($cfc1f3b422a3185f$export$e0c74b50bbd10f68(val0), $cfc1f3b422a3185f$export$e0c74b50bbd10f68(val1));
    // const multiplier = Math.pow(10, maxPrecision);
    // return (Math.round(val0 * multiplier) + Math.round(val1 * multiplier)) / multiplier;
    var sum = val0 + val1;
    // // PENDING: support more?
    return maxPrecision > $cfc1f3b422a3185f$var$ROUND_SUPPORTED_PRECISION_MAX ? sum : $cfc1f3b422a3185f$export$2077e0241d6afd3c(sum, maxPrecision);
}
var $cfc1f3b422a3185f$export$18510406f204a1b9 = 9007199254740991;
function $cfc1f3b422a3185f$export$2ca6dd70a288b1c3(radian) {
    var pi2 = Math.PI * 2;
    return (radian % pi2 + pi2) % pi2;
}
function $cfc1f3b422a3185f$export$d1df570aea2868f(val) {
    return val > -$cfc1f3b422a3185f$var$RADIAN_EPSILON && val < $cfc1f3b422a3185f$var$RADIAN_EPSILON;
}
// eslint-disable-next-line
var $cfc1f3b422a3185f$var$TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
function $cfc1f3b422a3185f$export$6b862160d295c8e(value) {
    if (value instanceof Date) return value;
    else if ($7a1bd9c2710fea0d$export$844ec244b1367d54(value)) {
        // Different browsers parse date in different way, so we parse it manually.
        // Some other issues:
        // new Date('1970-01-01') is UTC,
        // new Date('1970/01/01') and new Date('1970-1-01') is local.
        // See issue #3623
        var match = $cfc1f3b422a3185f$var$TIME_REG.exec(value);
        if (!match) // return Invalid Date.
        return new Date(NaN);
        // Use local time when no timezone offset is specified.
        if (!match[8]) // match[n] can only be string or undefined.
        // But take care of '12' + 1 => '121'.
        return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
        else {
            var hour = +match[4] || 0;
            if (match[8].toUpperCase() !== "Z") hour -= +match[8].slice(0, 3);
            return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
        }
    } else if (value == null) return new Date(NaN);
    return new Date(Math.round(value));
}
function $cfc1f3b422a3185f$export$82dd68b83a44b253(val) {
    return Math.pow(10, $cfc1f3b422a3185f$export$97256a17b20a0c24(val));
}
function $cfc1f3b422a3185f$export$97256a17b20a0c24(val) {
    if (val === 0) return 0;
    var exp = Math.floor(Math.log(val) / Math.LN10);
    /**
   * exp is expected to be the rounded-down result of the base-10 log of val.
   * But due to the precision loss with Math.log(val), we need to restore it
   * using 10^exp to make sure we can get val back from exp. #11249
   */ if (val / Math.pow(10, exp) >= 10) exp++;
    return exp;
}
function $cfc1f3b422a3185f$export$7a695fe44258210b(val, round) {
    var exponent = $cfc1f3b422a3185f$export$97256a17b20a0c24(val);
    var exp10 = Math.pow(10, exponent);
    var f = val / exp10; // 1 <= f < 10
    var nf;
    if (round) {
        if (f < 1.5) nf = 1;
        else if (f < 2.5) nf = 2;
        else if (f < 4) nf = 3;
        else if (f < 7) nf = 5;
        else nf = 10;
    } else {
        if (f < 1) nf = 1;
        else if (f < 2) nf = 2;
        else if (f < 3) nf = 3;
        else if (f < 5) nf = 5;
        else nf = 10;
    }
    val = nf * exp10;
    // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
    // 20 is the uppper bound of toFixed.
    return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
}
function $cfc1f3b422a3185f$export$651fb4afdb6caa4b(ascArr, p) {
    var H = (ascArr.length - 1) * p + 1;
    var h = Math.floor(H);
    var v = +ascArr[h - 1];
    var e = H - h;
    return e ? v + e * (ascArr[h] - v) : v;
}
function $cfc1f3b422a3185f$export$12f7386070bc380a(list) {
    list.sort(function(a, b) {
        return littleThan(a, b, 0) ? -1 : 1;
    });
    var curr = -Infinity;
    var currClose = 1;
    for(var i = 0; i < list.length;){
        var interval = list[i].interval;
        var close_1 = list[i].close;
        for(var lg = 0; lg < 2; lg++){
            if (interval[lg] <= curr) {
                interval[lg] = curr;
                close_1[lg] = !lg ? 1 - currClose : 1;
            }
            curr = interval[lg];
            currClose = close_1[lg];
        }
        if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) list.splice(i, 1);
        else i++;
    }
    return list;
    function littleThan(a, b, lg) {
        return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
    }
}
function $cfc1f3b422a3185f$export$8b4007b942b45a96(val) {
    var valFloat = parseFloat(val);
    return valFloat == val // eslint-disable-line eqeqeq
     && (valFloat !== 0 || !$7a1bd9c2710fea0d$export$844ec244b1367d54(val) || val.indexOf("x") <= 0 // For case ' 0x0 '.
    ) ? valFloat : NaN;
}
function $cfc1f3b422a3185f$export$e90fb89750dba83f(val) {
    return !isNaN($cfc1f3b422a3185f$export$8b4007b942b45a96(val));
}
function $cfc1f3b422a3185f$export$474d2ec9aa44a22() {
    return Math.round(Math.random() * 9);
}
function $cfc1f3b422a3185f$export$a368fd580c0d0fe4(a, b) {
    if (b === 0) return a;
    return $cfc1f3b422a3185f$export$a368fd580c0d0fe4(b, a % b);
}
function $cfc1f3b422a3185f$export$680a45b749323f49(a, b) {
    if (a == null) return b;
    if (b == null) return a;
    return a * b / $cfc1f3b422a3185f$export$a368fd580c0d0fe4(a, b);
}



function $76d619f648247e6d$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */ var $76d619f648247e6d$var$DUMMY_COMPONENT_NAME_PREFIX = "series\0";
var $76d619f648247e6d$var$INTERNAL_COMPONENT_ID_PREFIX = "\0_ec_\0";
function $76d619f648247e6d$export$4f07b212a02c8051(value) {
    return value instanceof Array ? value : value == null ? [] : [
        value
    ];
}
function $76d619f648247e6d$export$abdcc6a26372f94b(opt, key, subOpts) {
    // Caution: performance sensitive.
    if (opt) {
        opt[key] = opt[key] || {};
        opt.emphasis = opt.emphasis || {};
        opt.emphasis[key] = opt.emphasis[key] || {};
        // Default emphasis option from normal
        for(var i = 0, len = subOpts.length; i < len; i++){
            var subOptName = subOpts[i];
            if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) opt.emphasis[key][subOptName] = opt[key][subOptName];
        }
    }
}
var $76d619f648247e6d$export$df45610347a602ad = [
    "fontStyle",
    "fontWeight",
    "fontSize",
    "fontFamily",
    "rich",
    "tag",
    "color",
    "textBorderColor",
    "textBorderWidth",
    "width",
    "height",
    "lineHeight",
    "align",
    "verticalAlign",
    "baseline",
    "shadowColor",
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY",
    "textShadowColor",
    "textShadowBlur",
    "textShadowOffsetX",
    "textShadowOffsetY",
    "backgroundColor",
    "borderColor",
    "borderWidth",
    "borderRadius",
    "padding"
];
function $76d619f648247e6d$export$2c944e12edb48d4b(dataItem) {
    return (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dataItem) && !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
}
function $76d619f648247e6d$export$3e1a543f33ef6883(dataItem) {
    return (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dataItem) && !(dataItem instanceof Array);
// // markLine data can be array
// && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
function $76d619f648247e6d$export$574f818966e4da87(existings, newCmptOptions, mode) {
    var isNormalMergeMode = mode === "normalMerge";
    var isReplaceMergeMode = mode === "replaceMerge";
    var isReplaceAllMode = mode === "replaceAll";
    existings = existings || [];
    newCmptOptions = (newCmptOptions || []).slice();
    var existingIdIdxMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    // Validate id and name on user input option.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(cmptOption)) {
            newCmptOptions[index] = null;
            return;
        }
    });
    var result = $76d619f648247e6d$var$prepareResult(existings, existingIdIdxMap, mode);
    if (isNormalMergeMode || isReplaceMergeMode) $76d619f648247e6d$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions);
    if (isNormalMergeMode) $76d619f648247e6d$var$mappingByName(result, newCmptOptions);
    if (isNormalMergeMode || isReplaceMergeMode) $76d619f648247e6d$var$mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
    else if (isReplaceAllMode) $76d619f648247e6d$var$mappingInReplaceAllMode(result, newCmptOptions);
    $76d619f648247e6d$var$makeIdAndName(result);
    // The array `result` MUST NOT contain elided items, otherwise the
    // forEach will omit those items and result in incorrect result.
    return result;
}
function $76d619f648247e6d$var$prepareResult(existings, existingIdIdxMap, mode) {
    var result = [];
    if (mode === "replaceAll") return result;
    // Do not use native `map` to in case that the array `existings`
    // contains elided items, which will be omitted.
    for(var index = 0; index < existings.length; index++){
        var existing = existings[index];
        // Because of replaceMerge, `existing` may be null/undefined.
        if (existing && existing.id != null) existingIdIdxMap.set(existing.id, index);
        // For non-internal-componnets:
        //     Mode "normalMerge": all existings kept.
        //     Mode "replaceMerge": all existing removed unless mapped by id.
        // For internal-components:
        //     go with "replaceMerge" approach in both mode.
        result.push({
            existing: mode === "replaceMerge" || $76d619f648247e6d$export$feece3e7d52a102b(existing) ? null : existing,
            newOption: null,
            keyInfo: null,
            brandNew: null
        });
    }
    return result;
}
function $76d619f648247e6d$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
    // Mapping by id if specified.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.id == null) return;
        var optionId = $76d619f648247e6d$var$makeComparableKey(cmptOption.id);
        var existingIdx = existingIdIdxMap.get(optionId);
        if (existingIdx != null) {
            var resultItem = result[existingIdx];
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
            resultItem.newOption = cmptOption;
            // In both mode, if id matched, new option will be merged to
            // the existings rather than creating new component model.
            resultItem.existing = existings[existingIdx];
            newCmptOptions[index] = null;
        }
    });
}
function $76d619f648247e6d$var$mappingByName(result, newCmptOptions) {
    // Mapping by name if specified.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.name == null) return;
        for(var i = 0; i < result.length; i++){
            var existing = result[i].existing;
            if (!result[i].newOption // Consider name: two map to one.
             && existing && (existing.id == null || cmptOption.id == null) && !$76d619f648247e6d$export$feece3e7d52a102b(cmptOption) && !$76d619f648247e6d$export$feece3e7d52a102b(existing) && $76d619f648247e6d$var$keyExistAndEqual("name", existing, cmptOption)) {
                result[i].newOption = cmptOption;
                newCmptOptions[index] = null;
                return;
            }
        }
    });
}
function $76d619f648247e6d$var$mappingByIndex(result, newCmptOptions, brandNew) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption) {
        if (!cmptOption) return;
        // Find the first place that not mapped by id and not internal component (consider the "hole").
        var resultItem;
        var nextIdx = 0;
        while(// Be `!resultItem` only when `nextIdx >= result.length`.
        (resultItem = result[nextIdx]) && (resultItem.newOption || $76d619f648247e6d$export$feece3e7d52a102b(resultItem.existing) || // In mode "replaceMerge", here no not-mapped-non-internal-existing.
        resultItem.existing && cmptOption.id != null && !$76d619f648247e6d$var$keyExistAndEqual("id", cmptOption, resultItem.existing)))nextIdx++;
        if (resultItem) {
            resultItem.newOption = cmptOption;
            resultItem.brandNew = brandNew;
        } else result.push({
            newOption: cmptOption,
            brandNew: brandNew,
            existing: null,
            keyInfo: null
        });
        nextIdx++;
    });
}
function $76d619f648247e6d$var$mappingInReplaceAllMode(result, newCmptOptions) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption) {
        // The feature "reproduce" requires "hole" will also reproduced
        // in case that component index referring are broken.
        result.push({
            newOption: cmptOption,
            brandNew: true,
            existing: null,
            keyInfo: null
        });
    });
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 */ function $76d619f648247e6d$var$makeIdAndName(mapResult) {
    // We use this id to hash component models and view instances
    // in echarts. id can be specified by user, or auto generated.
    // The id generation rule ensures new view instance are able
    // to mapped to old instance when setOption are called in
    // no-merge mode. So we generate model id by name and plus
    // type in view id.
    // name can be duplicated among components, which is convenient
    // to specify multi components (like series) by one name.
    // Ensure that each id is distinct.
    var idMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mapResult, function(item) {
        var existing = item.existing;
        existing && idMap.set(existing.id, item);
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mapResult, function(item) {
        var opt = item.newOption;
        // Force ensure id not duplicated.
        (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, "id duplicates: " + (opt && opt.id));
        opt && opt.id != null && idMap.set(opt.id, item);
        !item.keyInfo && (item.keyInfo = {});
    });
    // Make name and id.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mapResult, function(item, index) {
        var existing = item.existing;
        var opt = item.newOption;
        var keyInfo = item.keyInfo;
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(opt)) return;
        // Name can be overwritten. Consider case: axis.name = '20km'.
        // But id generated by name will not be changed, which affect
        // only in that case: setOption with 'not merge mode' and view
        // instance will be recreated, which can be accepted.
        keyInfo.name = opt.name != null ? $76d619f648247e6d$var$makeComparableKey(opt.name) : existing ? existing.name : $76d619f648247e6d$var$DUMMY_COMPONENT_NAME_PREFIX + index;
        if (existing) keyInfo.id = $76d619f648247e6d$var$makeComparableKey(existing.id);
        else if (opt.id != null) keyInfo.id = $76d619f648247e6d$var$makeComparableKey(opt.id);
        else {
            // Consider this situatoin:
            //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
            //  optionB [{..}, {name: 'a'}, {name: 'a'}]
            // Series with the same name between optionA and optionB
            // should be mapped.
            var idNum = 0;
            do keyInfo.id = "\0" + keyInfo.name + "\0" + idNum++;
            while (idMap.get(keyInfo.id));
        }
        idMap.set(keyInfo.id, item);
    });
}
function $76d619f648247e6d$var$keyExistAndEqual(attr, obj1, obj2) {
    var key1 = $76d619f648247e6d$export$fb1a222ba5dd6e51(obj1[attr], null);
    var key2 = $76d619f648247e6d$export$fb1a222ba5dd6e51(obj2[attr], null);
    // See `MappingExistingItem`. `id` and `name` trade string equals to number.
    return key1 != null && key2 != null && key1 === key2;
}
/**
 * @return return null if not exist.
 */ function $76d619f648247e6d$var$makeComparableKey(val) {
    return $76d619f648247e6d$export$fb1a222ba5dd6e51(val, "");
}
function $76d619f648247e6d$export$fb1a222ba5dd6e51(idOrName, defaultValue) {
    if (idOrName == null) return defaultValue;
    return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(idOrName) ? idOrName : (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(idOrName) || (0, $7a1bd9c2710fea0d$export$29d0bb2a4e07b252)(idOrName) ? idOrName + "" : defaultValue;
}
function $76d619f648247e6d$var$warnInvalidateIdOrName(idOrName) {}
function $76d619f648247e6d$var$isValidIdOrName(idOrName) {
    return (0, $7a1bd9c2710fea0d$export$29d0bb2a4e07b252)(idOrName) || (0, $cfc1f3b422a3185f$export$e90fb89750dba83f)(idOrName);
}
function $76d619f648247e6d$export$beae19a2652b3368(componentModel) {
    var name = componentModel.name;
    // Is specified when `indexOf` get -1 or > 0.
    return !!(name && name.indexOf($76d619f648247e6d$var$DUMMY_COMPONENT_NAME_PREFIX));
}
function $76d619f648247e6d$export$feece3e7d52a102b(cmptOption) {
    return cmptOption && cmptOption.id != null && $76d619f648247e6d$var$makeComparableKey(cmptOption.id).indexOf($76d619f648247e6d$var$INTERNAL_COMPONENT_ID_PREFIX) === 0;
}
function $76d619f648247e6d$export$1753133c42e665e8(idSuffix) {
    return $76d619f648247e6d$var$INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
}
function $76d619f648247e6d$export$5ac61aca2ba0282d(mappingResult, mainType, componentModelCtor) {
    // Set mainType and complete subType.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mappingResult, function(item) {
        var newOption = item.newOption;
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(newOption)) {
            item.keyInfo.mainType = mainType;
            item.keyInfo.subType = $76d619f648247e6d$var$determineSubType(mainType, newOption, item.existing, componentModelCtor);
        }
    });
}
function $76d619f648247e6d$var$determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
    var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType : componentModelCtor.determineSubType(mainType, newCmptOption);
    // tooltip, markline, markpoint may always has no subType
    return subType;
}
function $76d619f648247e6d$export$6d12cabb0c9bf8e3(batchA, batchB) {
    var mapA = {};
    var mapB = {};
    makeMap(batchA || [], mapA);
    makeMap(batchB || [], mapB, mapA);
    return [
        mapToArray(mapA),
        mapToArray(mapB)
    ];
    function makeMap(sourceBatch, map, otherMap) {
        for(var i = 0, len = sourceBatch.length; i < len; i++){
            var seriesId = $76d619f648247e6d$export$fb1a222ba5dd6e51(sourceBatch[i].seriesId, null);
            if (seriesId == null) return;
            var dataIndices = $76d619f648247e6d$export$4f07b212a02c8051(sourceBatch[i].dataIndex);
            var otherDataIndices = otherMap && otherMap[seriesId];
            for(var j = 0, lenj = dataIndices.length; j < lenj; j++){
                var dataIndex = dataIndices[j];
                if (otherDataIndices && otherDataIndices[dataIndex]) otherDataIndices[dataIndex] = null;
                else (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
            }
        }
    }
    function mapToArray(map, isData) {
        var result = [];
        for(var i in map)if (map.hasOwnProperty(i) && map[i] != null) {
            if (isData) result.push(+i);
            else {
                var dataIndices = mapToArray(map[i], true);
                dataIndices.length && result.push({
                    seriesId: i,
                    dataIndex: dataIndices
                });
            }
        }
        return result;
    }
}
function $76d619f648247e6d$export$42b26cae8b8d10(data, payload) {
    if (payload.dataIndexInside != null) return payload.dataIndexInside;
    else if (payload.dataIndex != null) return (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(payload.dataIndex) ? (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(payload.dataIndex, function(value) {
        return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
    else if (payload.name != null) return (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(payload.name) ? (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(payload.name, function(value) {
        return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
}
function $76d619f648247e6d$export$64df9f8d92ae083f() {
    var key = "__ec_inner_" + $76d619f648247e6d$var$innerUniqueIndex++;
    return function(hostObj) {
        return hostObj[key] || (hostObj[key] = {});
    };
}
var $76d619f648247e6d$var$innerUniqueIndex = (0, $cfc1f3b422a3185f$export$474d2ec9aa44a22)();
function $76d619f648247e6d$export$95de80076abac814(ecModel, finderInput, opt) {
    var _a = $76d619f648247e6d$export$fe600815775d9400(finderInput, opt), mainTypeSpecified = _a.mainTypeSpecified, queryOptionMap = _a.queryOptionMap, others = _a.others;
    var result = others;
    var defaultMainType = opt ? opt.defaultMainType : null;
    if (!mainTypeSpecified && defaultMainType) queryOptionMap.set(defaultMainType, {});
    queryOptionMap.each(function(queryOption, mainType) {
        var queryResult = $76d619f648247e6d$export$dc741340f7e5f186(ecModel, mainType, queryOption, {
            useDefault: defaultMainType === mainType,
            enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
            enableNone: opt && opt.enableNone != null ? opt.enableNone : true
        });
        result[mainType + "Models"] = queryResult.models;
        result[mainType + "Model"] = queryResult.models[0];
    });
    return result;
}
function $76d619f648247e6d$export$fe600815775d9400(finderInput, opt) {
    var finder;
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(finderInput)) {
        var obj = {};
        obj[finderInput + "Index"] = 0;
        finder = obj;
    } else finder = finderInput;
    var queryOptionMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var others = {};
    var mainTypeSpecified = false;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(finder, function(value, key) {
        // Exclude 'dataIndex' and other illgal keys.
        if (key === "dataIndex" || key === "dataIndexInside") {
            others[key] = value;
            return;
        }
        var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
        var mainType = parsedKey[1];
        var queryType = (parsedKey[2] || "").toLowerCase();
        if (!mainType || !queryType || opt && opt.includeMainTypes && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(opt.includeMainTypes, mainType) < 0) return;
        mainTypeSpecified = mainTypeSpecified || !!mainType;
        var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
        queryOption[queryType] = value;
    });
    return {
        mainTypeSpecified: mainTypeSpecified,
        queryOptionMap: queryOptionMap,
        others: others
    };
}
var $76d619f648247e6d$export$f076738ec84e693c = {
    useDefault: true,
    enableAll: false,
    enableNone: false
};
var $76d619f648247e6d$export$48d598924ce4892c = {
    useDefault: false,
    enableAll: true,
    enableNone: true
};
function $76d619f648247e6d$export$dc741340f7e5f186(ecModel, mainType, userOption, opt) {
    opt = opt || $76d619f648247e6d$export$f076738ec84e693c;
    var indexOption = userOption.index;
    var idOption = userOption.id;
    var nameOption = userOption.name;
    var result = {
        models: null,
        specified: indexOption != null || idOption != null || nameOption != null
    };
    if (!result.specified) {
        // Use the first as default if `useDefault`.
        var firstCmpt = void 0;
        result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [
            firstCmpt
        ] : [];
        return result;
    }
    if (indexOption === "none" || indexOption === false) {
        (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(opt.enableNone, '`"none"` or `false` is not a valid value on index option.');
        result.models = [];
        return result;
    }
    // `queryComponents` will return all components if
    // both all of index/id/name are null/undefined.
    if (indexOption === "all") {
        (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(opt.enableAll, '`"all"` is not a valid value on index option.');
        indexOption = idOption = nameOption = null;
    }
    result.models = ecModel.queryComponents({
        mainType: mainType,
        index: indexOption,
        id: idOption,
        name: nameOption
    });
    return result;
}
function $76d619f648247e6d$export$9fec4d97f1922e0b(dom, key, value) {
    dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
}
function $76d619f648247e6d$export$735ee1799fd02602(dom, key) {
    return dom.getAttribute ? dom.getAttribute(key) : dom[key];
}
function $76d619f648247e6d$export$cc0a17a5d27b4e17(renderModeOption) {
    if (renderModeOption === "auto") // Using html when `document` exists, use richText otherwise
    return (0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported ? "html" : "richText";
    else return renderModeOption || "html";
}
function $76d619f648247e6d$export$7ab5bda43e13168f(array, getKey // return key
) {
    var buckets = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var keys = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(array, function(item) {
        var key = getKey(item);
        (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
    });
    return {
        keys: keys,
        buckets: buckets
    };
}
function $76d619f648247e6d$export$bd0439821a1869f3(data, precision, sourceValue, targetValue, percent) {
    var isAutoPrecision = precision == null || precision === "auto";
    if (targetValue == null) return targetValue;
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(targetValue)) {
        var value = $76d619f648247e6d$var$interpolateNumber(sourceValue || 0, targetValue, percent);
        return (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(value, isAutoPrecision ? Math.max((0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(sourceValue || 0), (0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(targetValue)) : precision);
    } else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(targetValue)) return percent < 1 ? sourceValue : targetValue;
    else {
        var interpolated = [];
        var leftArr = sourceValue;
        var rightArr = targetValue;
        var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);
        for(var i = 0; i < length_1; ++i){
            var info = data.getDimensionInfo(i);
            // Don't interpolate ordinal dims
            if (info && info.type === "ordinal") // In init, there is no `sourceValue`, but should better not to get undefined result.
            interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
            else {
                var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
                var rightVal = rightArr[i];
                var value = $76d619f648247e6d$var$interpolateNumber(leftVal, rightVal, percent);
                interpolated[i] = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(value, isAutoPrecision ? Math.max((0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(leftVal), (0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(rightVal)) : precision);
            }
        }
        return interpolated;
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $cd5f95cf03b4e3e7$var$TYPE_DELIMITER = ".";
var $cd5f95cf03b4e3e7$var$IS_CONTAINER = "___EC__COMPONENT__CONTAINER___";
var $cd5f95cf03b4e3e7$var$IS_EXTENDED_CLASS = "___EC__EXTENDED_CLASS___";
function $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentType) {
    var ret = {
        main: "",
        sub: ""
    };
    if (componentType) {
        var typeArr = componentType.split($cd5f95cf03b4e3e7$var$TYPE_DELIMITER);
        ret.main = typeArr[0] || "";
        ret.sub = typeArr[1] || "";
    }
    return ret;
}
/**
 * @public
 */ function $cd5f95cf03b4e3e7$var$checkClassType(componentType) {
    $7a1bd9c2710fea0d$export$a7a9523472993e97(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}
function $cd5f95cf03b4e3e7$export$4f3b818f3dd2d182(clz) {
    return !!(clz && clz[$cd5f95cf03b4e3e7$var$IS_EXTENDED_CLASS]);
}
function $cd5f95cf03b4e3e7$export$cd4c3a4dca301c70(rootClz, mandatoryMethods) {
    rootClz.$constructor = rootClz; // FIXME: not necessary?
    rootClz.extend = function(proto) {
        var superClass = this;
        var ExtendedClass;
        if ($cd5f95cf03b4e3e7$var$isESClass(superClass)) ExtendedClass = /** @class */ function(_super) {
            (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(class_1, _super);
            function class_1() {
                return _super.apply(this, arguments) || this;
            }
            return class_1;
        }(superClass);
        else {
            // For backward compat, we both support ts class inheritance and this
            // "extend" approach.
            // The constructor should keep the same behavior as ts class inheritance:
            // If this constructor/$constructor is not declared, auto invoke the super
            // constructor.
            // If this constructor/$constructor is declared, it is responsible for
            // calling the super constructor.
            ExtendedClass = function() {
                (proto.$constructor || superClass).apply(this, arguments);
            };
            $7a1bd9c2710fea0d$export$69f1b2dcda23c5f8(ExtendedClass, this);
        }
        $7a1bd9c2710fea0d$export$8b58be045bf06082(ExtendedClass.prototype, proto);
        ExtendedClass[$cd5f95cf03b4e3e7$var$IS_EXTENDED_CLASS] = true;
        ExtendedClass.extend = this.extend;
        ExtendedClass.superCall = $cd5f95cf03b4e3e7$var$superCall;
        ExtendedClass.superApply = $cd5f95cf03b4e3e7$var$superApply;
        ExtendedClass.superClass = superClass;
        return ExtendedClass;
    };
}
function $cd5f95cf03b4e3e7$var$isESClass(fn) {
    return $7a1bd9c2710fea0d$export$f6e2535fb5126e54(fn) && /^class\s/.test(Function.prototype.toString.call(fn));
}
function $cd5f95cf03b4e3e7$export$c9c2d87774f1275d(SubClz, SupperClz) {
    SubClz.extend = SupperClz.extend;
}
// A random offset.
var $cd5f95cf03b4e3e7$var$classBase = Math.round(Math.random() * 10);
function $cd5f95cf03b4e3e7$export$e1aac4552ae82081(target) {
    var classAttr = [
        "__\0is_clz",
        $cd5f95cf03b4e3e7$var$classBase++
    ].join("_");
    target.prototype[classAttr] = true;
    target.isInstance = function(obj) {
        return !!(obj && obj[classAttr]);
    };
}
// superCall should have class info, which can not be fetched from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, does not override method f,
// then when method of class C is called, dead loop occurred.
function $cd5f95cf03b4e3e7$var$superCall(context, methodName) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return this.superClass.prototype[methodName].apply(context, args);
}
function $cd5f95cf03b4e3e7$var$superApply(context, methodName, args) {
    return this.superClass.prototype[methodName].apply(context, args);
}
function $cd5f95cf03b4e3e7$export$241315e45585454d(target) {
    /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'a'
   *     or Object.<subKey, componentClass>, when componentType is 'a.b'
   */ var storage = {};
    target.registerClass = function(clz) {
        // `type` should not be a "instance member".
        // If using TS class, should better declared as `static type = 'series.pie'`.
        // otherwise users have to mount `type` on prototype manually.
        // For backward compat and enable instance visit type via `this.type`,
        // we still support fetch `type` from prototype.
        var componentFullType = clz.type || clz.prototype.type;
        if (componentFullType) {
            $cd5f95cf03b4e3e7$var$checkClassType(componentFullType);
            // If only static type declared, we assign it to prototype mandatorily.
            clz.prototype.type = componentFullType;
            var componentTypeInfo = $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentFullType);
            if (!componentTypeInfo.sub) storage[componentTypeInfo.main] = clz;
            else if (componentTypeInfo.sub !== $cd5f95cf03b4e3e7$var$IS_CONTAINER) {
                var container = makeContainer(componentTypeInfo);
                container[componentTypeInfo.sub] = clz;
            }
        }
        return clz;
    };
    target.getClass = function(mainType, subType, throwWhenNotFound) {
        var clz = storage[mainType];
        if (clz && clz[$cd5f95cf03b4e3e7$var$IS_CONTAINER]) clz = subType ? clz[subType] : null;
        if (throwWhenNotFound && !clz) throw new Error(!subType ? mainType + "." + "type should be specified." : "Component " + mainType + "." + (subType || "") + " is used but not imported.");
        return clz;
    };
    target.getClassesByMainType = function(componentType) {
        var componentTypeInfo = $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentType);
        var result = [];
        var obj = storage[componentTypeInfo.main];
        if (obj && obj[$cd5f95cf03b4e3e7$var$IS_CONTAINER]) $7a1bd9c2710fea0d$export$79b2f7037acddd43(obj, function(o, type) {
            type !== $cd5f95cf03b4e3e7$var$IS_CONTAINER && result.push(o);
        });
        else result.push(obj);
        return result;
    };
    target.hasClass = function(componentType) {
        // Just consider componentType.main.
        var componentTypeInfo = $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentType);
        return !!storage[componentTypeInfo.main];
    };
    /**
   * @return Like ['aa', 'bb'], but can not be ['aa.xx']
   */ target.getAllClassMainTypes = function() {
        var types = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(storage, function(obj, type) {
            types.push(type);
        });
        return types;
    };
    /**
   * If a main type is container and has sub types
   */ target.hasSubTypes = function(componentType) {
        var componentTypeInfo = $cd5f95cf03b4e3e7$export$fbe18865d303bf01(componentType);
        var obj = storage[componentTypeInfo.main];
        return obj && obj[$cd5f95cf03b4e3e7$var$IS_CONTAINER];
    };
    function makeContainer(componentTypeInfo) {
        var container = storage[componentTypeInfo.main];
        if (!container || !container[$cd5f95cf03b4e3e7$var$IS_CONTAINER]) {
            container = storage[componentTypeInfo.main] = {};
            container[$cd5f95cf03b4e3e7$var$IS_CONTAINER] = true;
        }
        return container;
    }
} // /**
 //  * @param {string|Array.<string>} properties
 //  */
 // export function setReadOnly(obj, properties) {
 // FIXME It seems broken in IE8 simulation of IE11
 // if (!zrUtil.isArray(properties)) {
 //     properties = properties != null ? [properties] : [];
 // }
 // zrUtil.each(properties, function (prop) {
 //     let value = obj[prop];
 //     Object.defineProperty
 //         && Object.defineProperty(obj, prop, {
 //             value: value, writable: false
 //         });
 //     zrUtil.isArray(obj[prop])
 //         && Object.freeze
 //         && Object.freeze(obj[prop]);
 // });
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Parse shadow style
// TODO Only shallow path support

function $06542048a26d4d91$export$2e2bcd8739ae039(properties, ignoreParent) {
    // Normalize
    for(var i = 0; i < properties.length; i++)if (!properties[i][1]) properties[i][1] = properties[i][0];
    ignoreParent = ignoreParent || false;
    return function(model, excludes, includes) {
        var style = {};
        for(var i = 0; i < properties.length; i++){
            var propName = properties[i][1];
            if (excludes && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(excludes, propName) >= 0 || includes && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(includes, propName) < 0) continue;
            var val = model.getShallow(propName, ignoreParent);
            if (val != null) style[properties[i][0]] = val;
        }
        // TODO Text or image?
        return style;
    };
}


var $cb2a96727da5284d$export$52de6e304d934d85 = [
    [
        "fill",
        "color"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "opacity"
    ],
    [
        "shadowColor"
    ]
];
var $cb2a96727da5284d$var$getAreaStyle = (0, $06542048a26d4d91$export$2e2bcd8739ae039)($cb2a96727da5284d$export$52de6e304d934d85);
var $cb2a96727da5284d$export$a3a0ed7e2dd84c9e = /** @class */ function() {
    function AreaStyleMixin() {}
    AreaStyleMixin.prototype.getAreaStyle = function(excludes, includes) {
        return $cb2a96727da5284d$var$getAreaStyle(this, excludes, includes);
    };
    return AreaStyleMixin;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $a53bd598adfb7ebe$var$globalImageCache = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(50);
function $a53bd598adfb7ebe$export$1b614f30ac2c8867(newImageOrSrc) {
    if (typeof newImageOrSrc === "string") {
        var cachedImgObj = $a53bd598adfb7ebe$var$globalImageCache.get(newImageOrSrc);
        return cachedImgObj && cachedImgObj.image;
    } else return newImageOrSrc;
}
function $a53bd598adfb7ebe$export$46c791b69ff9a0f(newImageOrSrc, image, hostEl, onload, cbPayload) {
    if (!newImageOrSrc) return image;
    else if (typeof newImageOrSrc === "string") {
        if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) return image;
        var cachedImgObj = $a53bd598adfb7ebe$var$globalImageCache.get(newImageOrSrc);
        var pendingWrap = {
            hostEl: hostEl,
            cb: onload,
            cbPayload: cbPayload
        };
        if (cachedImgObj) {
            image = cachedImgObj.image;
            !$a53bd598adfb7ebe$export$37ca7dd901d0236d(image) && cachedImgObj.pending.push(pendingWrap);
        } else {
            image = (0, $c6341dcc9d86826e$export$ef5e599365494451).loadImage(newImageOrSrc, $a53bd598adfb7ebe$var$imageOnLoad, $a53bd598adfb7ebe$var$imageOnLoad);
            image.__zrImageSrc = newImageOrSrc;
            $a53bd598adfb7ebe$var$globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
                image: image,
                pending: [
                    pendingWrap
                ]
            });
        }
        return image;
    } else return newImageOrSrc;
}
function $a53bd598adfb7ebe$var$imageOnLoad() {
    var cachedImgObj = this.__cachedImgObj;
    this.onload = this.onerror = this.__cachedImgObj = null;
    for(var i = 0; i < cachedImgObj.pending.length; i++){
        var pendingWrap = cachedImgObj.pending[i];
        var cb = pendingWrap.cb;
        cb && cb(this, pendingWrap.cbPayload);
        pendingWrap.hostEl.dirty();
    }
    cachedImgObj.pending.length = 0;
}
function $a53bd598adfb7ebe$export$37ca7dd901d0236d(image) {
    return image && image.width && image.height;
}




var $64fa9b3825ba2dec$var$STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
function $64fa9b3825ba2dec$export$59a943b34a82e690(text, containerWidth, font, ellipsis, options) {
    if (!containerWidth) return "";
    var textLines = (text + "").split("\n");
    options = $64fa9b3825ba2dec$var$prepareTruncateOptions(containerWidth, font, ellipsis, options);
    for(var i = 0, len = textLines.length; i < len; i++)textLines[i] = $64fa9b3825ba2dec$var$truncateSingleLine(textLines[i], options);
    return textLines.join("\n");
}
function $64fa9b3825ba2dec$var$prepareTruncateOptions(containerWidth, font, ellipsis, options) {
    options = options || {};
    var preparedOpts = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, options);
    preparedOpts.font = font;
    ellipsis = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(ellipsis, "...");
    preparedOpts.maxIterations = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(options.maxIterations, 2);
    var minChar = preparedOpts.minChar = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(options.minChar, 0);
    preparedOpts.cnCharWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)("\u56FD", font);
    var ascCharWidth = preparedOpts.ascCharWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)("a", font);
    preparedOpts.placeholder = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(options.placeholder, "");
    var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
    for(var i = 0; i < minChar && contentWidth >= ascCharWidth; i++)contentWidth -= ascCharWidth;
    var ellipsisWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(ellipsis, font);
    if (ellipsisWidth > contentWidth) {
        ellipsis = "";
        ellipsisWidth = 0;
    }
    contentWidth = containerWidth - ellipsisWidth;
    preparedOpts.ellipsis = ellipsis;
    preparedOpts.ellipsisWidth = ellipsisWidth;
    preparedOpts.contentWidth = contentWidth;
    preparedOpts.containerWidth = containerWidth;
    return preparedOpts;
}
function $64fa9b3825ba2dec$var$truncateSingleLine(textLine, options) {
    var containerWidth = options.containerWidth;
    var font = options.font;
    var contentWidth = options.contentWidth;
    if (!containerWidth) return "";
    var lineWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(textLine, font);
    if (lineWidth <= containerWidth) return textLine;
    for(var j = 0;; j++){
        if (lineWidth <= contentWidth || j >= options.maxIterations) {
            textLine += options.ellipsis;
            break;
        }
        var subLength = j === 0 ? $64fa9b3825ba2dec$var$estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
        textLine = textLine.substr(0, subLength);
        lineWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(textLine, font);
    }
    if (textLine === "") textLine = options.placeholder;
    return textLine;
}
function $64fa9b3825ba2dec$var$estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
    var width = 0;
    var i = 0;
    for(var len = text.length; i < len && width < contentWidth; i++){
        var charCode = text.charCodeAt(i);
        width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
    }
    return i;
}
function $64fa9b3825ba2dec$export$5772575e34ef80f9(text, style) {
    text != null && (text += "");
    var overflow = style.overflow;
    var padding = style.padding;
    var font = style.font;
    var truncate = overflow === "truncate";
    var calculatedLineHeight = (0, $6c308355c7107803$export$56204a27a2958a55)(font);
    var lineHeight = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(style.lineHeight, calculatedLineHeight);
    var bgColorDrawn = !!style.backgroundColor;
    var truncateLineOverflow = style.lineOverflow === "truncate";
    var width = style.width;
    var lines;
    if (width != null && (overflow === "break" || overflow === "breakAll")) lines = text ? $64fa9b3825ba2dec$var$wrapText(text, style.font, width, overflow === "breakAll", 0).lines : [];
    else lines = text ? text.split("\n") : [];
    var contentHeight = lines.length * lineHeight;
    var height = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(style.height, contentHeight);
    if (contentHeight > height && truncateLineOverflow) {
        var lineCount = Math.floor(height / lineHeight);
        lines = lines.slice(0, lineCount);
    }
    if (text && truncate && width != null) {
        var options = $64fa9b3825ba2dec$var$prepareTruncateOptions(width, font, style.ellipsis, {
            minChar: style.truncateMinChar,
            placeholder: style.placeholder
        });
        for(var i = 0; i < lines.length; i++)lines[i] = $64fa9b3825ba2dec$var$truncateSingleLine(lines[i], options);
    }
    var outerHeight = height;
    var contentWidth = 0;
    for(var i = 0; i < lines.length; i++)contentWidth = Math.max((0, $6c308355c7107803$export$3c49c185de0c2bfc)(lines[i], font), contentWidth);
    if (width == null) width = contentWidth;
    var outerWidth = contentWidth;
    if (padding) {
        outerHeight += padding[0] + padding[2];
        outerWidth += padding[1] + padding[3];
        width += padding[1] + padding[3];
    }
    if (bgColorDrawn) outerWidth = width;
    return {
        lines: lines,
        height: height,
        outerWidth: outerWidth,
        outerHeight: outerHeight,
        lineHeight: lineHeight,
        calculatedLineHeight: calculatedLineHeight,
        contentWidth: contentWidth,
        contentHeight: contentHeight,
        width: width
    };
}
var $64fa9b3825ba2dec$var$RichTextToken = function() {
    function RichTextToken() {}
    return RichTextToken;
}();
var $64fa9b3825ba2dec$var$RichTextLine = function() {
    function RichTextLine(tokens) {
        this.tokens = [];
        if (tokens) this.tokens = tokens;
    }
    return RichTextLine;
}();
var $64fa9b3825ba2dec$export$ca607d3c98caaf7e = function() {
    function RichTextContentBlock() {
        this.width = 0;
        this.height = 0;
        this.contentWidth = 0;
        this.contentHeight = 0;
        this.outerWidth = 0;
        this.outerHeight = 0;
        this.lines = [];
    }
    return RichTextContentBlock;
}();
function $64fa9b3825ba2dec$export$15ec9472ff2d721(text, style) {
    var contentBlock = new $64fa9b3825ba2dec$export$ca607d3c98caaf7e();
    text != null && (text += "");
    if (!text) return contentBlock;
    var topWidth = style.width;
    var topHeight = style.height;
    var overflow = style.overflow;
    var wrapInfo = (overflow === "break" || overflow === "breakAll") && topWidth != null ? {
        width: topWidth,
        accumWidth: 0,
        breakAll: overflow === "breakAll"
    } : null;
    var lastIndex = $64fa9b3825ba2dec$var$STYLE_REG.lastIndex = 0;
    var result;
    while((result = $64fa9b3825ba2dec$var$STYLE_REG.exec(text)) != null){
        var matchedIndex = result.index;
        if (matchedIndex > lastIndex) $64fa9b3825ba2dec$var$pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
        $64fa9b3825ba2dec$var$pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
        lastIndex = $64fa9b3825ba2dec$var$STYLE_REG.lastIndex;
    }
    if (lastIndex < text.length) $64fa9b3825ba2dec$var$pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
    var pendingList = [];
    var calculatedHeight = 0;
    var calculatedWidth = 0;
    var stlPadding = style.padding;
    var truncate = overflow === "truncate";
    var truncateLine = style.lineOverflow === "truncate";
    function finishLine(line, lineWidth, lineHeight) {
        line.width = lineWidth;
        line.lineHeight = lineHeight;
        calculatedHeight += lineHeight;
        calculatedWidth = Math.max(calculatedWidth, lineWidth);
    }
    outer: for(var i = 0; i < contentBlock.lines.length; i++){
        var line = contentBlock.lines[i];
        var lineHeight = 0;
        var lineWidth = 0;
        for(var j = 0; j < line.tokens.length; j++){
            var token = line.tokens[j];
            var tokenStyle = token.styleName && style.rich[token.styleName] || {};
            var textPadding = token.textPadding = tokenStyle.padding;
            var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
            var font = token.font = tokenStyle.font || style.font;
            token.contentHeight = (0, $6c308355c7107803$export$56204a27a2958a55)(font);
            var tokenHeight = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(tokenStyle.height, token.contentHeight);
            token.innerHeight = tokenHeight;
            textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
            token.height = tokenHeight;
            token.lineHeight = (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
            token.align = tokenStyle && tokenStyle.align || style.align;
            token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || "middle";
            if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
                if (j > 0) {
                    line.tokens = line.tokens.slice(0, j);
                    finishLine(line, lineWidth, lineHeight);
                    contentBlock.lines = contentBlock.lines.slice(0, i + 1);
                } else contentBlock.lines = contentBlock.lines.slice(0, i);
                break outer;
            }
            var styleTokenWidth = tokenStyle.width;
            var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === "auto";
            if (typeof styleTokenWidth === "string" && styleTokenWidth.charAt(styleTokenWidth.length - 1) === "%") {
                token.percentWidth = styleTokenWidth;
                pendingList.push(token);
                token.contentWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(token.text, font);
            } else {
                if (tokenWidthNotSpecified) {
                    var textBackgroundColor = tokenStyle.backgroundColor;
                    var bgImg = textBackgroundColor && textBackgroundColor.image;
                    if (bgImg) {
                        bgImg = $a53bd598adfb7ebe$export$1b614f30ac2c8867(bgImg);
                        if ($a53bd598adfb7ebe$export$37ca7dd901d0236d(bgImg)) token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
                    }
                }
                var remainTruncWidth = truncate && topWidth != null ? topWidth - lineWidth : null;
                if (remainTruncWidth != null && remainTruncWidth < token.width) {
                    if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
                        token.text = "";
                        token.width = token.contentWidth = 0;
                    } else {
                        token.text = $64fa9b3825ba2dec$export$59a943b34a82e690(token.text, remainTruncWidth - paddingH, font, style.ellipsis, {
                            minChar: style.truncateMinChar
                        });
                        token.width = token.contentWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(token.text, font);
                    }
                } else token.contentWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(token.text, font);
            }
            token.width += paddingH;
            lineWidth += token.width;
            tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
        }
        finishLine(line, lineWidth, lineHeight);
    }
    contentBlock.outerWidth = contentBlock.width = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(topWidth, calculatedWidth);
    contentBlock.outerHeight = contentBlock.height = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(topHeight, calculatedHeight);
    contentBlock.contentHeight = calculatedHeight;
    contentBlock.contentWidth = calculatedWidth;
    if (stlPadding) {
        contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
        contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
    }
    for(var i = 0; i < pendingList.length; i++){
        var token = pendingList[i];
        var percentWidth = token.percentWidth;
        token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
    }
    return contentBlock;
}
function $64fa9b3825ba2dec$var$pushTokens(block, str, style, wrapInfo, styleName) {
    var isEmptyStr = str === "";
    var tokenStyle = styleName && style.rich[styleName] || {};
    var lines = block.lines;
    var font = tokenStyle.font || style.font;
    var newLine = false;
    var strLines;
    var linesWidths;
    if (wrapInfo) {
        var tokenPadding = tokenStyle.padding;
        var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
        if (tokenStyle.width != null && tokenStyle.width !== "auto") {
            var outerWidth_1 = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
            if (lines.length > 0) {
                if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
                    strLines = str.split("\n");
                    newLine = true;
                }
            }
            wrapInfo.accumWidth = outerWidth_1;
        } else {
            var res = $64fa9b3825ba2dec$var$wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
            wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
            linesWidths = res.linesWidths;
            strLines = res.lines;
        }
    } else strLines = str.split("\n");
    for(var i = 0; i < strLines.length; i++){
        var text = strLines[i];
        var token = new $64fa9b3825ba2dec$var$RichTextToken();
        token.styleName = styleName;
        token.text = text;
        token.isLineHolder = !text && !isEmptyStr;
        if (typeof tokenStyle.width === "number") token.width = tokenStyle.width;
        else token.width = linesWidths ? linesWidths[i] : (0, $6c308355c7107803$export$3c49c185de0c2bfc)(text, font);
        if (!i && !newLine) {
            var tokens = (lines[lines.length - 1] || (lines[0] = new $64fa9b3825ba2dec$var$RichTextLine())).tokens;
            var tokensLen = tokens.length;
            tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : (text || !tokensLen || isEmptyStr) && tokens.push(token);
        } else lines.push(new $64fa9b3825ba2dec$var$RichTextLine([
            token
        ]));
    }
}
function $64fa9b3825ba2dec$var$isAlphabeticLetter(ch) {
    var code = ch.charCodeAt(0);
    return code >= 0x20 && code <= 0x24F || code >= 0x370 && code <= 0x10FF || code >= 0x1200 && code <= 0x13FF || code >= 0x1E00 && code <= 0x206F;
}
var $64fa9b3825ba2dec$var$breakCharMap = (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)(",&?/;] ".split(""), function(obj, ch) {
    obj[ch] = true;
    return obj;
}, {});
function $64fa9b3825ba2dec$var$isWordBreakChar(ch) {
    if ($64fa9b3825ba2dec$var$isAlphabeticLetter(ch)) {
        if ($64fa9b3825ba2dec$var$breakCharMap[ch]) return true;
        return false;
    }
    return true;
}
function $64fa9b3825ba2dec$var$wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
    var lines = [];
    var linesWidths = [];
    var line = "";
    var currentWord = "";
    var currentWordWidth = 0;
    var accumWidth = 0;
    for(var i = 0; i < text.length; i++){
        var ch = text.charAt(i);
        if (ch === "\n") {
            if (currentWord) {
                line += currentWord;
                accumWidth += currentWordWidth;
            }
            lines.push(line);
            linesWidths.push(accumWidth);
            line = "";
            currentWord = "";
            currentWordWidth = 0;
            accumWidth = 0;
            continue;
        }
        var chWidth = (0, $6c308355c7107803$export$3c49c185de0c2bfc)(ch, font);
        var inWord = isBreakAll ? false : !$64fa9b3825ba2dec$var$isWordBreakChar(ch);
        if (!lines.length ? lastAccumWidth + accumWidth + chWidth > lineWidth : accumWidth + chWidth > lineWidth) {
            if (!accumWidth) {
                if (inWord) {
                    lines.push(currentWord);
                    linesWidths.push(currentWordWidth);
                    currentWord = ch;
                    currentWordWidth = chWidth;
                } else {
                    lines.push(ch);
                    linesWidths.push(chWidth);
                }
            } else if (line || currentWord) {
                if (inWord) {
                    if (!line) {
                        line = currentWord;
                        currentWord = "";
                        currentWordWidth = 0;
                        accumWidth = currentWordWidth;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth - currentWordWidth);
                    currentWord += ch;
                    currentWordWidth += chWidth;
                    line = "";
                    accumWidth = currentWordWidth;
                } else {
                    if (currentWord) {
                        line += currentWord;
                        currentWord = "";
                        currentWordWidth = 0;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth);
                    line = ch;
                    accumWidth = chWidth;
                }
            }
            continue;
        }
        accumWidth += chWidth;
        if (inWord) {
            currentWord += ch;
            currentWordWidth += chWidth;
        } else {
            if (currentWord) {
                line += currentWord;
                currentWord = "";
                currentWordWidth = 0;
            }
            line += ch;
        }
    }
    if (!lines.length && !line) {
        line = text;
        currentWord = "";
        currentWordWidth = 0;
    }
    if (currentWord) line += currentWord;
    if (line) {
        lines.push(line);
        linesWidths.push(accumWidth);
    }
    if (lines.length === 1) accumWidth += lastAccumWidth;
    return {
        accumWidth: accumWidth,
        lines: lines,
        linesWidths: linesWidths
    };
}








var $56206a6cb4666931$var$STYLE_MAGIC_KEY = "__zr_style_" + Math.round(Math.random() * 10);
var $56206a6cb4666931$export$737672163db00fe3 = {
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: "#000",
    opacity: 1,
    blend: "source-over"
};
var $56206a6cb4666931$export$9908943fb57fbe51 = {
    style: {
        shadowBlur: true,
        shadowOffsetX: true,
        shadowOffsetY: true,
        shadowColor: true,
        opacity: true
    }
};
$56206a6cb4666931$export$737672163db00fe3[$56206a6cb4666931$var$STYLE_MAGIC_KEY] = true;
var $56206a6cb4666931$var$PRIMARY_STATES_KEYS = [
    "z",
    "z2",
    "invisible"
];
var $56206a6cb4666931$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER = [
    "invisible"
];
var $56206a6cb4666931$var$Displayable = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Displayable, _super);
    function Displayable(props) {
        return _super.call(this, props) || this;
    }
    Displayable.prototype._init = function(props) {
        var keysArr = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(props);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            if (key === "style") this.useStyle(props[key]);
            else _super.prototype.attrKV.call(this, key, props[key]);
        }
        if (!this.style) this.useStyle({});
    };
    Displayable.prototype.beforeBrush = function() {};
    Displayable.prototype.afterBrush = function() {};
    Displayable.prototype.innerBeforeBrush = function() {};
    Displayable.prototype.innerAfterBrush = function() {};
    Displayable.prototype.shouldBePainted = function(viewWidth, viewHeight, considerClipPath, considerAncestors) {
        var m = this.transform;
        if (this.ignore || this.invisible || this.style.opacity === 0 || this.culling && $56206a6cb4666931$var$isDisplayableCulled(this, viewWidth, viewHeight) || m && !m[0] && !m[3]) return false;
        if (considerClipPath && this.__clipPaths) for(var i = 0; i < this.__clipPaths.length; ++i){
            if (this.__clipPaths[i].isZeroArea()) return false;
        }
        if (considerAncestors && this.parent) {
            var parent_1 = this.parent;
            while(parent_1){
                if (parent_1.ignore) return false;
                parent_1 = parent_1.parent;
            }
        }
        return true;
    };
    Displayable.prototype.contain = function(x, y) {
        return this.rectContain(x, y);
    };
    Displayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    Displayable.prototype.rectContain = function(x, y) {
        var coord = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        return rect.contain(coord[0], coord[1]);
    };
    Displayable.prototype.getPaintRect = function() {
        var rect = this._paintRect;
        if (!this._paintRect || this.__dirty) {
            var transform = this.transform;
            var elRect = this.getBoundingRect();
            var style = this.style;
            var shadowSize = style.shadowBlur || 0;
            var shadowOffsetX = style.shadowOffsetX || 0;
            var shadowOffsetY = style.shadowOffsetY || 0;
            rect = this._paintRect || (this._paintRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0));
            if (transform) (0, $1bebe7106c895823$export$2e2bcd8739ae039).applyTransform(rect, elRect, transform);
            else rect.copy(elRect);
            if (shadowSize || shadowOffsetX || shadowOffsetY) {
                rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
                rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
                rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
                rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
            }
            var tolerance = this.dirtyRectTolerance;
            if (!rect.isZero()) {
                rect.x = Math.floor(rect.x - tolerance);
                rect.y = Math.floor(rect.y - tolerance);
                rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
                rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
            }
        }
        return rect;
    };
    Displayable.prototype.setPrevPaintRect = function(paintRect) {
        if (paintRect) {
            this._prevPaintRect = this._prevPaintRect || new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
            this._prevPaintRect.copy(paintRect);
        } else this._prevPaintRect = null;
    };
    Displayable.prototype.getPrevPaintRect = function() {
        return this._prevPaintRect;
    };
    Displayable.prototype.animateStyle = function(loop) {
        return this.animate("style", loop);
    };
    Displayable.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === "style") this.dirtyStyle();
        else this.markRedraw();
    };
    Displayable.prototype.attrKV = function(key, value) {
        if (key !== "style") _super.prototype.attrKV.call(this, key, value);
        else if (!this.style) this.useStyle(value);
        else this.setStyle(value);
    };
    Displayable.prototype.setStyle = function(keyOrObj, value) {
        if (typeof keyOrObj === "string") this.style[keyOrObj] = value;
        else (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.style, keyOrObj);
        this.dirtyStyle();
        return this;
    };
    Displayable.prototype.dirtyStyle = function(notRedraw) {
        if (!notRedraw) this.markRedraw();
        this.__dirty |= (0, $ddf76b16f1246ba9$export$ada8b2beb3d76671);
        if (this._rect) this._rect = null;
    };
    Displayable.prototype.dirty = function() {
        this.dirtyStyle();
    };
    Displayable.prototype.styleChanged = function() {
        return !!(this.__dirty & (0, $ddf76b16f1246ba9$export$ada8b2beb3d76671));
    };
    Displayable.prototype.styleUpdated = function() {
        this.__dirty &= ~(0, $ddf76b16f1246ba9$export$ada8b2beb3d76671);
    };
    Displayable.prototype.createStyle = function(obj) {
        return (0, $7a1bd9c2710fea0d$export$79c7e160a7743efd)($56206a6cb4666931$export$737672163db00fe3, obj);
    };
    Displayable.prototype.useStyle = function(obj) {
        if (!obj[$56206a6cb4666931$var$STYLE_MAGIC_KEY]) obj = this.createStyle(obj);
        if (this.__inHover) this.__hoverStyle = obj;
        else this.style = obj;
        this.dirtyStyle();
    };
    Displayable.prototype.isStyleObject = function(obj) {
        return obj[$56206a6cb4666931$var$STYLE_MAGIC_KEY];
    };
    Displayable.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.style && !normalState.style) normalState.style = this._mergeStyle(this.createStyle(), this.style);
        this._savePrimaryToNormal(toState, normalState, $56206a6cb4666931$var$PRIMARY_STATES_KEYS);
    };
    Displayable.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetStyle;
        if (state && state.style) {
            if (transition) {
                if (keepCurrentStates) targetStyle = state.style;
                else {
                    targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
                    this._mergeStyle(targetStyle, state.style);
                }
            } else {
                targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
                this._mergeStyle(targetStyle, state.style);
            }
        } else if (needsRestoreToNormal) targetStyle = normalState.style;
        if (targetStyle) {
            if (transition) {
                var sourceStyle = this.style;
                this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
                if (needsRestoreToNormal) {
                    var changedKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(sourceStyle);
                    for(var i = 0; i < changedKeys.length; i++){
                        var key = changedKeys[i];
                        if (key in targetStyle) {
                            targetStyle[key] = targetStyle[key];
                            this.style[key] = sourceStyle[key];
                        }
                    }
                }
                var targetKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(targetStyle);
                for(var i = 0; i < targetKeys.length; i++){
                    var key = targetKeys[i];
                    this.style[key] = this.style[key];
                }
                this._transitionState(stateName, {
                    style: targetStyle
                }, animationCfg, this.getAnimationStyleProps());
            } else this.useStyle(targetStyle);
        }
        var statesKeys = this.__inHover ? $56206a6cb4666931$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER : $56206a6cb4666931$var$PRIMARY_STATES_KEYS;
        for(var i = 0; i < statesKeys.length; i++){
            var key = statesKeys[i];
            if (state && state[key] != null) this[key] = state[key];
            else if (needsRestoreToNormal) {
                if (normalState[key] != null) this[key] = normalState[key];
            }
        }
    };
    Displayable.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedStyle;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.style) {
                mergedStyle = mergedStyle || {};
                this._mergeStyle(mergedStyle, state.style);
            }
        }
        if (mergedStyle) mergedState.style = mergedStyle;
        return mergedState;
    };
    Displayable.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetStyle, sourceStyle);
        return targetStyle;
    };
    Displayable.prototype.getAnimationStyleProps = function() {
        return $56206a6cb4666931$export$9908943fb57fbe51;
    };
    Displayable.initDefaultProps = function() {
        var dispProto = Displayable.prototype;
        dispProto.type = "displayable";
        dispProto.invisible = false;
        dispProto.z = 0;
        dispProto.z2 = 0;
        dispProto.zlevel = 0;
        dispProto.culling = false;
        dispProto.cursor = "pointer";
        dispProto.rectHover = false;
        dispProto.incremental = false;
        dispProto._rect = null;
        dispProto.dirtyRectTolerance = 0;
        dispProto.__dirty = (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) | (0, $ddf76b16f1246ba9$export$ada8b2beb3d76671);
    }();
    return Displayable;
}((0, $4bb0f26b847654d5$export$2e2bcd8739ae039));
var $56206a6cb4666931$var$tmpRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $56206a6cb4666931$var$viewRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
function $56206a6cb4666931$var$isDisplayableCulled(el, width, height) {
    $56206a6cb4666931$var$tmpRect.copy(el.getBoundingRect());
    if (el.transform) $56206a6cb4666931$var$tmpRect.applyTransform(el.transform);
    $56206a6cb4666931$var$viewRect.width = width;
    $56206a6cb4666931$var$viewRect.height = height;
    return !$56206a6cb4666931$var$tmpRect.intersect($56206a6cb4666931$var$viewRect);
}
var $56206a6cb4666931$export$2e2bcd8739ae039 = $56206a6cb4666931$var$Displayable;










var $af3aab2435198f82$var$mathMin = Math.min;
var $af3aab2435198f82$var$mathMax = Math.max;
var $af3aab2435198f82$var$mathSin = Math.sin;
var $af3aab2435198f82$var$mathCos = Math.cos;
var $af3aab2435198f82$var$PI2 = Math.PI * 2;
var $af3aab2435198f82$var$start = $6de594cf8ac295ff$export$185802fd694ee1f5();
var $af3aab2435198f82$var$end = $6de594cf8ac295ff$export$185802fd694ee1f5();
var $af3aab2435198f82$var$extremity = $6de594cf8ac295ff$export$185802fd694ee1f5();
function $af3aab2435198f82$export$188c3cd07b4129dd(points, min, max) {
    if (points.length === 0) return;
    var p = points[0];
    var left = p[0];
    var right = p[0];
    var top = p[1];
    var bottom = p[1];
    for(var i = 1; i < points.length; i++){
        p = points[i];
        left = $af3aab2435198f82$var$mathMin(left, p[0]);
        right = $af3aab2435198f82$var$mathMax(right, p[0]);
        top = $af3aab2435198f82$var$mathMin(top, p[1]);
        bottom = $af3aab2435198f82$var$mathMax(bottom, p[1]);
    }
    min[0] = left;
    min[1] = top;
    max[0] = right;
    max[1] = bottom;
}
function $af3aab2435198f82$export$d2b1491e4450bf2c(x0, y0, x1, y1, min, max) {
    min[0] = $af3aab2435198f82$var$mathMin(x0, x1);
    min[1] = $af3aab2435198f82$var$mathMin(y0, y1);
    max[0] = $af3aab2435198f82$var$mathMax(x0, x1);
    max[1] = $af3aab2435198f82$var$mathMax(y0, y1);
}
var $af3aab2435198f82$var$xDim = [];
var $af3aab2435198f82$var$yDim = [];
function $af3aab2435198f82$export$c1bc6be456bb6609(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
    var cubicExtrema = $747cfc5611b57cea$export$df1a172f100d0457;
    var cubicAt = $747cfc5611b57cea$export$547c21de482bbcb2;
    var n = cubicExtrema(x0, x1, x2, x3, $af3aab2435198f82$var$xDim);
    min[0] = Infinity;
    min[1] = Infinity;
    max[0] = -Infinity;
    max[1] = -Infinity;
    for(var i = 0; i < n; i++){
        var x = cubicAt(x0, x1, x2, x3, $af3aab2435198f82$var$xDim[i]);
        min[0] = $af3aab2435198f82$var$mathMin(x, min[0]);
        max[0] = $af3aab2435198f82$var$mathMax(x, max[0]);
    }
    n = cubicExtrema(y0, y1, y2, y3, $af3aab2435198f82$var$yDim);
    for(var i = 0; i < n; i++){
        var y = cubicAt(y0, y1, y2, y3, $af3aab2435198f82$var$yDim[i]);
        min[1] = $af3aab2435198f82$var$mathMin(y, min[1]);
        max[1] = $af3aab2435198f82$var$mathMax(y, max[1]);
    }
    min[0] = $af3aab2435198f82$var$mathMin(x0, min[0]);
    max[0] = $af3aab2435198f82$var$mathMax(x0, max[0]);
    min[0] = $af3aab2435198f82$var$mathMin(x3, min[0]);
    max[0] = $af3aab2435198f82$var$mathMax(x3, max[0]);
    min[1] = $af3aab2435198f82$var$mathMin(y0, min[1]);
    max[1] = $af3aab2435198f82$var$mathMax(y0, max[1]);
    min[1] = $af3aab2435198f82$var$mathMin(y3, min[1]);
    max[1] = $af3aab2435198f82$var$mathMax(y3, max[1]);
}
function $af3aab2435198f82$export$16fbe795323a1f4c(x0, y0, x1, y1, x2, y2, min, max) {
    var quadraticExtremum = $747cfc5611b57cea$export$752e1f8c6e7f7e11;
    var quadraticAt = $747cfc5611b57cea$export$af17094a950f5073;
    var tx = $af3aab2435198f82$var$mathMax($af3aab2435198f82$var$mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
    var ty = $af3aab2435198f82$var$mathMax($af3aab2435198f82$var$mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
    var x = quadraticAt(x0, x1, x2, tx);
    var y = quadraticAt(y0, y1, y2, ty);
    min[0] = $af3aab2435198f82$var$mathMin(x0, x2, x);
    min[1] = $af3aab2435198f82$var$mathMin(y0, y2, y);
    max[0] = $af3aab2435198f82$var$mathMax(x0, x2, x);
    max[1] = $af3aab2435198f82$var$mathMax(y0, y2, y);
}
function $af3aab2435198f82$export$161c8bb0e1d9ef49(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
    var vec2Min = $6de594cf8ac295ff$export$96ec731ed4dcb222;
    var vec2Max = $6de594cf8ac295ff$export$8960430cfd85939f;
    var diff = Math.abs(startAngle - endAngle);
    if (diff % $af3aab2435198f82$var$PI2 < 1e-4 && diff > 1e-4) {
        min[0] = x - rx;
        min[1] = y - ry;
        max[0] = x + rx;
        max[1] = y + ry;
        return;
    }
    $af3aab2435198f82$var$start[0] = $af3aab2435198f82$var$mathCos(startAngle) * rx + x;
    $af3aab2435198f82$var$start[1] = $af3aab2435198f82$var$mathSin(startAngle) * ry + y;
    $af3aab2435198f82$var$end[0] = $af3aab2435198f82$var$mathCos(endAngle) * rx + x;
    $af3aab2435198f82$var$end[1] = $af3aab2435198f82$var$mathSin(endAngle) * ry + y;
    vec2Min(min, $af3aab2435198f82$var$start, $af3aab2435198f82$var$end);
    vec2Max(max, $af3aab2435198f82$var$start, $af3aab2435198f82$var$end);
    startAngle = startAngle % $af3aab2435198f82$var$PI2;
    if (startAngle < 0) startAngle = startAngle + $af3aab2435198f82$var$PI2;
    endAngle = endAngle % $af3aab2435198f82$var$PI2;
    if (endAngle < 0) endAngle = endAngle + $af3aab2435198f82$var$PI2;
    if (startAngle > endAngle && !anticlockwise) endAngle += $af3aab2435198f82$var$PI2;
    else if (startAngle < endAngle && anticlockwise) startAngle += $af3aab2435198f82$var$PI2;
    if (anticlockwise) {
        var tmp = endAngle;
        endAngle = startAngle;
        startAngle = tmp;
    }
    for(var angle = 0; angle < endAngle; angle += Math.PI / 2)if (angle > startAngle) {
        $af3aab2435198f82$var$extremity[0] = $af3aab2435198f82$var$mathCos(angle) * rx + x;
        $af3aab2435198f82$var$extremity[1] = $af3aab2435198f82$var$mathSin(angle) * ry + y;
        vec2Min(min, $af3aab2435198f82$var$extremity, min);
        vec2Max(max, $af3aab2435198f82$var$extremity, max);
    }
}



var $20ebe2448f123f2e$var$CMD = {
    M: 1,
    L: 2,
    C: 3,
    Q: 4,
    A: 5,
    Z: 6,
    R: 7
};
var $20ebe2448f123f2e$var$tmpOutX = [];
var $20ebe2448f123f2e$var$tmpOutY = [];
var $20ebe2448f123f2e$var$min = [];
var $20ebe2448f123f2e$var$max = [];
var $20ebe2448f123f2e$var$min2 = [];
var $20ebe2448f123f2e$var$max2 = [];
var $20ebe2448f123f2e$var$mathMin = Math.min;
var $20ebe2448f123f2e$var$mathMax = Math.max;
var $20ebe2448f123f2e$var$mathCos = Math.cos;
var $20ebe2448f123f2e$var$mathSin = Math.sin;
var $20ebe2448f123f2e$var$mathAbs = Math.abs;
var $20ebe2448f123f2e$var$PI = Math.PI;
var $20ebe2448f123f2e$var$PI2 = $20ebe2448f123f2e$var$PI * 2;
var $20ebe2448f123f2e$var$hasTypedArray = typeof Float32Array !== "undefined";
var $20ebe2448f123f2e$var$tmpAngles = [];
function $20ebe2448f123f2e$var$modPI2(radian) {
    var n = Math.round(radian / $20ebe2448f123f2e$var$PI * 1e8) / 1e8;
    return n % 2 * $20ebe2448f123f2e$var$PI;
}
function $20ebe2448f123f2e$export$bc668021e937022a(angles, anticlockwise) {
    var newStartAngle = $20ebe2448f123f2e$var$modPI2(angles[0]);
    if (newStartAngle < 0) newStartAngle += $20ebe2448f123f2e$var$PI2;
    var delta = newStartAngle - angles[0];
    var newEndAngle = angles[1];
    newEndAngle += delta;
    if (!anticlockwise && newEndAngle - newStartAngle >= $20ebe2448f123f2e$var$PI2) newEndAngle = newStartAngle + $20ebe2448f123f2e$var$PI2;
    else if (anticlockwise && newStartAngle - newEndAngle >= $20ebe2448f123f2e$var$PI2) newEndAngle = newStartAngle - $20ebe2448f123f2e$var$PI2;
    else if (!anticlockwise && newStartAngle > newEndAngle) newEndAngle = newStartAngle + ($20ebe2448f123f2e$var$PI2 - $20ebe2448f123f2e$var$modPI2(newStartAngle - newEndAngle));
    else if (anticlockwise && newStartAngle < newEndAngle) newEndAngle = newStartAngle - ($20ebe2448f123f2e$var$PI2 - $20ebe2448f123f2e$var$modPI2(newEndAngle - newStartAngle));
    angles[0] = newStartAngle;
    angles[1] = newEndAngle;
}
var $20ebe2448f123f2e$var$PathProxy = function() {
    function PathProxy(notSaveData) {
        this.dpr = 1;
        this._xi = 0;
        this._yi = 0;
        this._x0 = 0;
        this._y0 = 0;
        this._len = 0;
        if (notSaveData) this._saveData = false;
        if (this._saveData) this.data = [];
    }
    PathProxy.prototype.increaseVersion = function() {
        this._version++;
    };
    PathProxy.prototype.getVersion = function() {
        return this._version;
    };
    PathProxy.prototype.setScale = function(sx, sy, segmentIgnoreThreshold) {
        segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
        if (segmentIgnoreThreshold > 0) {
            this._ux = $20ebe2448f123f2e$var$mathAbs(segmentIgnoreThreshold / (0, $4b0cedd85979c776$export$508f096bfcdaac40) / sx) || 0;
            this._uy = $20ebe2448f123f2e$var$mathAbs(segmentIgnoreThreshold / (0, $4b0cedd85979c776$export$508f096bfcdaac40) / sy) || 0;
        }
    };
    PathProxy.prototype.setDPR = function(dpr) {
        this.dpr = dpr;
    };
    PathProxy.prototype.setContext = function(ctx) {
        this._ctx = ctx;
    };
    PathProxy.prototype.getContext = function() {
        return this._ctx;
    };
    PathProxy.prototype.beginPath = function() {
        this._ctx && this._ctx.beginPath();
        this.reset();
        return this;
    };
    PathProxy.prototype.reset = function() {
        if (this._saveData) this._len = 0;
        if (this._pathSegLen) {
            this._pathSegLen = null;
            this._pathLen = 0;
        }
        this._version++;
    };
    PathProxy.prototype.moveTo = function(x, y) {
        this._drawPendingPt();
        this.addData($20ebe2448f123f2e$var$CMD.M, x, y);
        this._ctx && this._ctx.moveTo(x, y);
        this._x0 = x;
        this._y0 = y;
        this._xi = x;
        this._yi = y;
        return this;
    };
    PathProxy.prototype.lineTo = function(x, y) {
        var dx = $20ebe2448f123f2e$var$mathAbs(x - this._xi);
        var dy = $20ebe2448f123f2e$var$mathAbs(y - this._yi);
        var exceedUnit = dx > this._ux || dy > this._uy;
        this.addData($20ebe2448f123f2e$var$CMD.L, x, y);
        if (this._ctx && exceedUnit) this._ctx.lineTo(x, y);
        if (exceedUnit) {
            this._xi = x;
            this._yi = y;
            this._pendingPtDist = 0;
        } else {
            var d2 = dx * dx + dy * dy;
            if (d2 > this._pendingPtDist) {
                this._pendingPtX = x;
                this._pendingPtY = y;
                this._pendingPtDist = d2;
            }
        }
        return this;
    };
    PathProxy.prototype.bezierCurveTo = function(x1, y1, x2, y2, x3, y3) {
        this._drawPendingPt();
        this.addData($20ebe2448f123f2e$var$CMD.C, x1, y1, x2, y2, x3, y3);
        if (this._ctx) this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
        this._xi = x3;
        this._yi = y3;
        return this;
    };
    PathProxy.prototype.quadraticCurveTo = function(x1, y1, x2, y2) {
        this._drawPendingPt();
        this.addData($20ebe2448f123f2e$var$CMD.Q, x1, y1, x2, y2);
        if (this._ctx) this._ctx.quadraticCurveTo(x1, y1, x2, y2);
        this._xi = x2;
        this._yi = y2;
        return this;
    };
    PathProxy.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this._drawPendingPt();
        $20ebe2448f123f2e$var$tmpAngles[0] = startAngle;
        $20ebe2448f123f2e$var$tmpAngles[1] = endAngle;
        $20ebe2448f123f2e$export$bc668021e937022a($20ebe2448f123f2e$var$tmpAngles, anticlockwise);
        startAngle = $20ebe2448f123f2e$var$tmpAngles[0];
        endAngle = $20ebe2448f123f2e$var$tmpAngles[1];
        var delta = endAngle - startAngle;
        this.addData($20ebe2448f123f2e$var$CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
        this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
        this._xi = $20ebe2448f123f2e$var$mathCos(endAngle) * r + cx;
        this._yi = $20ebe2448f123f2e$var$mathSin(endAngle) * r + cy;
        return this;
    };
    PathProxy.prototype.arcTo = function(x1, y1, x2, y2, radius) {
        this._drawPendingPt();
        if (this._ctx) this._ctx.arcTo(x1, y1, x2, y2, radius);
        return this;
    };
    PathProxy.prototype.rect = function(x, y, w, h) {
        this._drawPendingPt();
        this._ctx && this._ctx.rect(x, y, w, h);
        this.addData($20ebe2448f123f2e$var$CMD.R, x, y, w, h);
        return this;
    };
    PathProxy.prototype.closePath = function() {
        this._drawPendingPt();
        this.addData($20ebe2448f123f2e$var$CMD.Z);
        var ctx = this._ctx;
        var x0 = this._x0;
        var y0 = this._y0;
        if (ctx) ctx.closePath();
        this._xi = x0;
        this._yi = y0;
        return this;
    };
    PathProxy.prototype.fill = function(ctx) {
        ctx && ctx.fill();
        this.toStatic();
    };
    PathProxy.prototype.stroke = function(ctx) {
        ctx && ctx.stroke();
        this.toStatic();
    };
    PathProxy.prototype.len = function() {
        return this._len;
    };
    PathProxy.prototype.setData = function(data) {
        var len = data.length;
        if (!(this.data && this.data.length === len) && $20ebe2448f123f2e$var$hasTypedArray) this.data = new Float32Array(len);
        for(var i = 0; i < len; i++)this.data[i] = data[i];
        this._len = len;
    };
    PathProxy.prototype.appendPath = function(path) {
        if (!(path instanceof Array)) path = [
            path
        ];
        var len = path.length;
        var appendSize = 0;
        var offset = this._len;
        for(var i = 0; i < len; i++)appendSize += path[i].len();
        if ($20ebe2448f123f2e$var$hasTypedArray && this.data instanceof Float32Array) this.data = new Float32Array(offset + appendSize);
        for(var i = 0; i < len; i++){
            var appendPathData = path[i].data;
            for(var k = 0; k < appendPathData.length; k++)this.data[offset++] = appendPathData[k];
        }
        this._len = offset;
    };
    PathProxy.prototype.addData = function(cmd, a, b, c, d, e, f, g, h) {
        if (!this._saveData) return;
        var data = this.data;
        if (this._len + arguments.length > data.length) {
            this._expandData();
            data = this.data;
        }
        for(var i = 0; i < arguments.length; i++)data[this._len++] = arguments[i];
    };
    PathProxy.prototype._drawPendingPt = function() {
        if (this._pendingPtDist > 0) {
            this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
            this._pendingPtDist = 0;
        }
    };
    PathProxy.prototype._expandData = function() {
        if (!(this.data instanceof Array)) {
            var newData = [];
            for(var i = 0; i < this._len; i++)newData[i] = this.data[i];
            this.data = newData;
        }
    };
    PathProxy.prototype.toStatic = function() {
        if (!this._saveData) return;
        this._drawPendingPt();
        var data = this.data;
        if (data instanceof Array) {
            data.length = this._len;
            if ($20ebe2448f123f2e$var$hasTypedArray && this._len > 11) this.data = new Float32Array(data);
        }
    };
    PathProxy.prototype.getBoundingRect = function() {
        $20ebe2448f123f2e$var$min[0] = $20ebe2448f123f2e$var$min[1] = $20ebe2448f123f2e$var$min2[0] = $20ebe2448f123f2e$var$min2[1] = Number.MAX_VALUE;
        $20ebe2448f123f2e$var$max[0] = $20ebe2448f123f2e$var$max[1] = $20ebe2448f123f2e$var$max2[0] = $20ebe2448f123f2e$var$max2[1] = -Number.MAX_VALUE;
        var data = this.data;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var i;
        for(i = 0; i < this._len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch(cmd){
                case $20ebe2448f123f2e$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    $20ebe2448f123f2e$var$min2[0] = x0;
                    $20ebe2448f123f2e$var$min2[1] = y0;
                    $20ebe2448f123f2e$var$max2[0] = x0;
                    $20ebe2448f123f2e$var$max2[1] = y0;
                    break;
                case $20ebe2448f123f2e$var$CMD.L:
                    (0, $af3aab2435198f82$export$d2b1491e4450bf2c)(xi, yi, data[i], data[i + 1], $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $20ebe2448f123f2e$var$CMD.C:
                    (0, $af3aab2435198f82$export$c1bc6be456bb6609)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $20ebe2448f123f2e$var$CMD.Q:
                    (0, $af3aab2435198f82$export$16fbe795323a1f4c)(xi, yi, data[i++], data[i++], data[i], data[i + 1], $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $20ebe2448f123f2e$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var endAngle = data[i++] + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = $20ebe2448f123f2e$var$mathCos(startAngle) * rx + cx;
                        y0 = $20ebe2448f123f2e$var$mathSin(startAngle) * ry + cy;
                    }
                    (0, $af3aab2435198f82$export$161c8bb0e1d9ef49)(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    xi = $20ebe2448f123f2e$var$mathCos(endAngle) * rx + cx;
                    yi = $20ebe2448f123f2e$var$mathSin(endAngle) * ry + cy;
                    break;
                case $20ebe2448f123f2e$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    (0, $af3aab2435198f82$export$d2b1491e4450bf2c)(x0, y0, x0 + width, y0 + height, $20ebe2448f123f2e$var$min2, $20ebe2448f123f2e$var$max2);
                    break;
                case $20ebe2448f123f2e$var$CMD.Z:
                    xi = x0;
                    yi = y0;
                    break;
            }
            $6de594cf8ac295ff$export$96ec731ed4dcb222($20ebe2448f123f2e$var$min, $20ebe2448f123f2e$var$min, $20ebe2448f123f2e$var$min2);
            $6de594cf8ac295ff$export$8960430cfd85939f($20ebe2448f123f2e$var$max, $20ebe2448f123f2e$var$max, $20ebe2448f123f2e$var$max2);
        }
        if (i === 0) $20ebe2448f123f2e$var$min[0] = $20ebe2448f123f2e$var$min[1] = $20ebe2448f123f2e$var$max[0] = $20ebe2448f123f2e$var$max[1] = 0;
        return new (0, $1bebe7106c895823$export$2e2bcd8739ae039)($20ebe2448f123f2e$var$min[0], $20ebe2448f123f2e$var$min[1], $20ebe2448f123f2e$var$max[0] - $20ebe2448f123f2e$var$min[0], $20ebe2448f123f2e$var$max[1] - $20ebe2448f123f2e$var$min[1]);
    };
    PathProxy.prototype._calculateLength = function() {
        var data = this.data;
        var len = this._len;
        var ux = this._ux;
        var uy = this._uy;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        if (!this._pathSegLen) this._pathSegLen = [];
        var pathSegLen = this._pathSegLen;
        var pathTotalLen = 0;
        var segCount = 0;
        for(var i = 0; i < len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            var l = -1;
            switch(cmd){
                case $20ebe2448f123f2e$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    break;
                case $20ebe2448f123f2e$var$CMD.L:
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var dx = x2 - xi;
                    var dy = y2 - yi;
                    if ($20ebe2448f123f2e$var$mathAbs(dx) > ux || $20ebe2448f123f2e$var$mathAbs(dy) > uy || i === len - 1) {
                        l = Math.sqrt(dx * dx + dy * dy);
                        xi = x2;
                        yi = y2;
                    }
                    break;
                case $20ebe2448f123f2e$var$CMD.C:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var x3 = data[i++];
                    var y3 = data[i++];
                    l = (0, $747cfc5611b57cea$export$af1875d576f60d7c)(xi, yi, x1, y1, x2, y2, x3, y3, 10);
                    xi = x3;
                    yi = y3;
                    break;
                case $20ebe2448f123f2e$var$CMD.Q:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    l = (0, $747cfc5611b57cea$export$8a68adee46f3cf55)(xi, yi, x1, y1, x2, y2, 10);
                    xi = x2;
                    yi = y2;
                    break;
                case $20ebe2448f123f2e$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var delta = data[i++];
                    var endAngle = delta + startAngle;
                    i += 1;
                    if (isFirst) {
                        x0 = $20ebe2448f123f2e$var$mathCos(startAngle) * rx + cx;
                        y0 = $20ebe2448f123f2e$var$mathSin(startAngle) * ry + cy;
                    }
                    l = $20ebe2448f123f2e$var$mathMax(rx, ry) * $20ebe2448f123f2e$var$mathMin($20ebe2448f123f2e$var$PI2, Math.abs(delta));
                    xi = $20ebe2448f123f2e$var$mathCos(endAngle) * rx + cx;
                    yi = $20ebe2448f123f2e$var$mathSin(endAngle) * ry + cy;
                    break;
                case $20ebe2448f123f2e$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    l = width * 2 + height * 2;
                    break;
                case $20ebe2448f123f2e$var$CMD.Z:
                    var dx = x0 - xi;
                    var dy = y0 - yi;
                    l = Math.sqrt(dx * dx + dy * dy);
                    xi = x0;
                    yi = y0;
                    break;
            }
            if (l >= 0) {
                pathSegLen[segCount++] = l;
                pathTotalLen += l;
            }
        }
        this._pathLen = pathTotalLen;
        return pathTotalLen;
    };
    PathProxy.prototype.rebuildPath = function(ctx, percent) {
        var d = this.data;
        var ux = this._ux;
        var uy = this._uy;
        var len = this._len;
        var x0;
        var y0;
        var xi;
        var yi;
        var x;
        var y;
        var drawPart = percent < 1;
        var pathSegLen;
        var pathTotalLen;
        var accumLength = 0;
        var segCount = 0;
        var displayedLength;
        var pendingPtDist = 0;
        var pendingPtX;
        var pendingPtY;
        if (drawPart) {
            if (!this._pathSegLen) this._calculateLength();
            pathSegLen = this._pathSegLen;
            pathTotalLen = this._pathLen;
            displayedLength = percent * pathTotalLen;
            if (!displayedLength) return;
        }
        lo: for(var i = 0; i < len;){
            var cmd = d[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = d[i];
                yi = d[i + 1];
                x0 = xi;
                y0 = yi;
            }
            if (cmd !== $20ebe2448f123f2e$var$CMD.L && pendingPtDist > 0) {
                ctx.lineTo(pendingPtX, pendingPtY);
                pendingPtDist = 0;
            }
            switch(cmd){
                case $20ebe2448f123f2e$var$CMD.M:
                    x0 = xi = d[i++];
                    y0 = yi = d[i++];
                    ctx.moveTo(xi, yi);
                    break;
                case $20ebe2448f123f2e$var$CMD.L:
                    x = d[i++];
                    y = d[i++];
                    var dx = $20ebe2448f123f2e$var$mathAbs(x - xi);
                    var dy = $20ebe2448f123f2e$var$mathAbs(y - yi);
                    if (dx > ux || dy > uy) {
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.lineTo(x, y);
                        xi = x;
                        yi = y;
                        pendingPtDist = 0;
                    } else {
                        var d2 = dx * dx + dy * dy;
                        if (d2 > pendingPtDist) {
                            pendingPtX = x;
                            pendingPtY = y;
                            pendingPtDist = d2;
                        }
                    }
                    break;
                case $20ebe2448f123f2e$var$CMD.C:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    var x3 = d[i++];
                    var y3 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $747cfc5611b57cea$export$a2ee23a0567039da)(xi, x1, x2, x3, t, $20ebe2448f123f2e$var$tmpOutX);
                            (0, $747cfc5611b57cea$export$a2ee23a0567039da)(yi, y1, y2, y3, t, $20ebe2448f123f2e$var$tmpOutY);
                            ctx.bezierCurveTo($20ebe2448f123f2e$var$tmpOutX[1], $20ebe2448f123f2e$var$tmpOutY[1], $20ebe2448f123f2e$var$tmpOutX[2], $20ebe2448f123f2e$var$tmpOutY[2], $20ebe2448f123f2e$var$tmpOutX[3], $20ebe2448f123f2e$var$tmpOutY[3]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    xi = x3;
                    yi = y3;
                    break;
                case $20ebe2448f123f2e$var$CMD.Q:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $747cfc5611b57cea$export$117c659e21a7a060)(xi, x1, x2, t, $20ebe2448f123f2e$var$tmpOutX);
                            (0, $747cfc5611b57cea$export$117c659e21a7a060)(yi, y1, y2, t, $20ebe2448f123f2e$var$tmpOutY);
                            ctx.quadraticCurveTo($20ebe2448f123f2e$var$tmpOutX[1], $20ebe2448f123f2e$var$tmpOutY[1], $20ebe2448f123f2e$var$tmpOutX[2], $20ebe2448f123f2e$var$tmpOutY[2]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.quadraticCurveTo(x1, y1, x2, y2);
                    xi = x2;
                    yi = y2;
                    break;
                case $20ebe2448f123f2e$var$CMD.A:
                    var cx = d[i++];
                    var cy = d[i++];
                    var rx = d[i++];
                    var ry = d[i++];
                    var startAngle = d[i++];
                    var delta = d[i++];
                    var psi = d[i++];
                    var anticlockwise = !d[i++];
                    var r = rx > ry ? rx : ry;
                    var isEllipse = $20ebe2448f123f2e$var$mathAbs(rx - ry) > 1e-3;
                    var endAngle = startAngle + delta;
                    var breakBuild = false;
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            endAngle = startAngle + delta * (displayedLength - accumLength) / l;
                            breakBuild = true;
                        }
                        accumLength += l;
                    }
                    if (isEllipse && ctx.ellipse) ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
                    else ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
                    if (breakBuild) break lo;
                    if (isFirst) {
                        x0 = $20ebe2448f123f2e$var$mathCos(startAngle) * rx + cx;
                        y0 = $20ebe2448f123f2e$var$mathSin(startAngle) * ry + cy;
                    }
                    xi = $20ebe2448f123f2e$var$mathCos(endAngle) * rx + cx;
                    yi = $20ebe2448f123f2e$var$mathSin(endAngle) * ry + cy;
                    break;
                case $20ebe2448f123f2e$var$CMD.R:
                    x0 = xi = d[i];
                    y0 = yi = d[i + 1];
                    x = d[i++];
                    y = d[i++];
                    var width = d[i++];
                    var height = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var d_1 = displayedLength - accumLength;
                            ctx.moveTo(x, y);
                            ctx.lineTo(x + $20ebe2448f123f2e$var$mathMin(d_1, width), y);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x + width, y + $20ebe2448f123f2e$var$mathMin(d_1, height));
                            d_1 -= height;
                            if (d_1 > 0) ctx.lineTo(x + $20ebe2448f123f2e$var$mathMax(width - d_1, 0), y + height);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x, y + $20ebe2448f123f2e$var$mathMax(height - d_1, 0));
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.rect(x, y, width, height);
                    break;
                case $20ebe2448f123f2e$var$CMD.Z:
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.closePath();
                    xi = x0;
                    yi = y0;
            }
        }
    };
    PathProxy.prototype.clone = function() {
        var newProxy = new PathProxy();
        var data = this.data;
        newProxy.data = data.slice ? data.slice() : Array.prototype.slice.call(data);
        newProxy._len = this._len;
        return newProxy;
    };
    PathProxy.CMD = $20ebe2448f123f2e$var$CMD;
    PathProxy.initDefaultProps = function() {
        var proto = PathProxy.prototype;
        proto._saveData = true;
        proto._ux = 0;
        proto._uy = 0;
        proto._pendingPtDist = 0;
        proto._version = 0;
    }();
    return PathProxy;
}();
var $20ebe2448f123f2e$export$2e2bcd8739ae039 = $20ebe2448f123f2e$var$PathProxy;



function $beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    var _a = 0;
    var _b = x0;
    if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) return false;
    if (x0 !== x1) {
        _a = (y0 - y1) / (x0 - x1);
        _b = (x0 * y1 - x1 * y0) / (x0 - x1);
    } else return Math.abs(x - x0) <= _l / 2;
    var tmp = _a * x - y + _b;
    var _s = tmp * tmp / (_a * _a + 1);
    return _s <= _l / 2 * _l / 2;
}



function $e22e0fd22a005e8a$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) return false;
    var d = $747cfc5611b57cea$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
    return d <= _l / 2;
}



function $a1d80a5bf05b597b$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) return false;
    var d = (0, $747cfc5611b57cea$export$81915a594fe10dee)(x0, y0, x1, y1, x2, y2, x, y, null);
    return d <= _l / 2;
}


var $b44a8536c7214e4f$var$PI2 = Math.PI * 2;
function $b44a8536c7214e4f$export$d44861331f213635(angle) {
    angle %= $b44a8536c7214e4f$var$PI2;
    if (angle < 0) angle += $b44a8536c7214e4f$var$PI2;
    return angle;
}


var $6e9b0f2fe4e39376$var$PI2 = Math.PI * 2;
function $6e9b0f2fe4e39376$export$8d36b1b5d19157c5(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    if (d - _l > r || d + _l < r) return false;
    if (Math.abs(startAngle - endAngle) % $6e9b0f2fe4e39376$var$PI2 < 1e-4) return true;
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(endAngle);
        endAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(tmp);
    } else {
        startAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(startAngle);
        endAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $6e9b0f2fe4e39376$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $6e9b0f2fe4e39376$var$PI2;
    return angle >= startAngle && angle <= endAngle || angle + $6e9b0f2fe4e39376$var$PI2 >= startAngle && angle + $6e9b0f2fe4e39376$var$PI2 <= endAngle;
}



function $e1acc0b10546155f$export$2e2bcd8739ae039(x0, y0, x1, y1, x, y) {
    if (y > y0 && y > y1 || y < y0 && y < y1) return 0;
    if (y1 === y0) return 0;
    var t = (y - y0) / (y1 - y0);
    var dir = y1 < y0 ? 1 : -1;
    if (t === 1 || t === 0) dir = y1 < y0 ? 0.5 : -0.5;
    var x_ = t * (x1 - x0) + x0;
    return x_ === x ? Infinity : x_ > x ? dir : 0;
}


var $347a114fcc5254ff$var$CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
var $347a114fcc5254ff$var$PI2 = Math.PI * 2;
var $347a114fcc5254ff$var$EPSILON = 1e-4;
function $347a114fcc5254ff$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $347a114fcc5254ff$var$EPSILON;
}
var $347a114fcc5254ff$var$roots = [
    -1,
    -1,
    -1
];
var $347a114fcc5254ff$var$extrema = [
    -1,
    -1
];
function $347a114fcc5254ff$var$swapExtrema() {
    var tmp = $347a114fcc5254ff$var$extrema[0];
    $347a114fcc5254ff$var$extrema[0] = $347a114fcc5254ff$var$extrema[1];
    $347a114fcc5254ff$var$extrema[1] = tmp;
}
function $347a114fcc5254ff$var$windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
    if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) return 0;
    var nRoots = $747cfc5611b57cea$export$ca5d13faa10b167e(y0, y1, y2, y3, y, $347a114fcc5254ff$var$roots);
    if (nRoots === 0) return 0;
    else {
        var w = 0;
        var nExtrema = -1;
        var y0_ = void 0;
        var y1_ = void 0;
        for(var i = 0; i < nRoots; i++){
            var t = $347a114fcc5254ff$var$roots[i];
            var unit = t === 0 || t === 1 ? 0.5 : 1;
            var x_ = $747cfc5611b57cea$export$547c21de482bbcb2(x0, x1, x2, x3, t);
            if (x_ < x) continue;
            if (nExtrema < 0) {
                nExtrema = $747cfc5611b57cea$export$df1a172f100d0457(y0, y1, y2, y3, $347a114fcc5254ff$var$extrema);
                if ($347a114fcc5254ff$var$extrema[1] < $347a114fcc5254ff$var$extrema[0] && nExtrema > 1) $347a114fcc5254ff$var$swapExtrema();
                y0_ = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, $347a114fcc5254ff$var$extrema[0]);
                if (nExtrema > 1) y1_ = $747cfc5611b57cea$export$547c21de482bbcb2(y0, y1, y2, y3, $347a114fcc5254ff$var$extrema[1]);
            }
            if (nExtrema === 2) {
                if (t < $347a114fcc5254ff$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                else if (t < $347a114fcc5254ff$var$extrema[1]) w += y1_ < y0_ ? unit : -unit;
                else w += y3 < y1_ ? unit : -unit;
            } else if (t < $347a114fcc5254ff$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
            else w += y3 < y0_ ? unit : -unit;
        }
        return w;
    }
}
function $347a114fcc5254ff$var$windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
    if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) return 0;
    var nRoots = $747cfc5611b57cea$export$fd895ac7ee764967(y0, y1, y2, y, $347a114fcc5254ff$var$roots);
    if (nRoots === 0) return 0;
    else {
        var t = $747cfc5611b57cea$export$752e1f8c6e7f7e11(y0, y1, y2);
        if (t >= 0 && t <= 1) {
            var w = 0;
            var y_ = $747cfc5611b57cea$export$af17094a950f5073(y0, y1, y2, t);
            for(var i = 0; i < nRoots; i++){
                var unit = $347a114fcc5254ff$var$roots[i] === 0 || $347a114fcc5254ff$var$roots[i] === 1 ? 0.5 : 1;
                var x_ = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, $347a114fcc5254ff$var$roots[i]);
                if (x_ < x) continue;
                if ($347a114fcc5254ff$var$roots[i] < t) w += y_ < y0 ? unit : -unit;
                else w += y2 < y_ ? unit : -unit;
            }
            return w;
        } else {
            var unit = $347a114fcc5254ff$var$roots[0] === 0 || $347a114fcc5254ff$var$roots[0] === 1 ? 0.5 : 1;
            var x_ = $747cfc5611b57cea$export$af17094a950f5073(x0, x1, x2, $347a114fcc5254ff$var$roots[0]);
            if (x_ < x) return 0;
            return y2 < y0 ? unit : -unit;
        }
    }
}
function $347a114fcc5254ff$var$windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
    y -= cy;
    if (y > r || y < -r) return 0;
    var tmp = Math.sqrt(r * r - y * y);
    $347a114fcc5254ff$var$roots[0] = -tmp;
    $347a114fcc5254ff$var$roots[1] = tmp;
    var dTheta = Math.abs(startAngle - endAngle);
    if (dTheta < 1e-4) return 0;
    if (dTheta >= $347a114fcc5254ff$var$PI2 - 1e-4) {
        startAngle = 0;
        endAngle = $347a114fcc5254ff$var$PI2;
        var dir = anticlockwise ? 1 : -1;
        if (x >= $347a114fcc5254ff$var$roots[0] + cx && x <= $347a114fcc5254ff$var$roots[1] + cx) return dir;
        else return 0;
    }
    if (startAngle > endAngle) {
        var tmp_1 = startAngle;
        startAngle = endAngle;
        endAngle = tmp_1;
    }
    if (startAngle < 0) {
        startAngle += $347a114fcc5254ff$var$PI2;
        endAngle += $347a114fcc5254ff$var$PI2;
    }
    var w = 0;
    for(var i = 0; i < 2; i++){
        var x_ = $347a114fcc5254ff$var$roots[i];
        if (x_ + cx > x) {
            var angle = Math.atan2(y, x_);
            var dir = anticlockwise ? 1 : -1;
            if (angle < 0) angle = $347a114fcc5254ff$var$PI2 + angle;
            if (angle >= startAngle && angle <= endAngle || angle + $347a114fcc5254ff$var$PI2 >= startAngle && angle + $347a114fcc5254ff$var$PI2 <= endAngle) {
                if (angle > Math.PI / 2 && angle < Math.PI * 1.5) dir = -dir;
                w += dir;
            }
        }
    }
    return w;
}
function $347a114fcc5254ff$var$containPath(path, lineWidth, isStroke, x, y) {
    var data = path.data;
    var len = path.len();
    var w = 0;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (cmd === $347a114fcc5254ff$var$CMD.M && i > 1) {
            if (!isStroke) w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y);
        }
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        switch(cmd){
            case $347a114fcc5254ff$var$CMD.M:
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $347a114fcc5254ff$var$CMD.L:
                if (isStroke) {
                    if ($beafddd7270f4bea$export$8d36b1b5d19157c5(xi, yi, data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $347a114fcc5254ff$var$CMD.C:
                if (isStroke) {
                    if ($e22e0fd22a005e8a$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $347a114fcc5254ff$var$windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $347a114fcc5254ff$var$CMD.Q:
                if (isStroke) {
                    if ($a1d80a5bf05b597b$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $347a114fcc5254ff$var$windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $347a114fcc5254ff$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                if (!isFirst) w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, x1, y1, x, y);
                else {
                    x0 = x1;
                    y0 = y1;
                }
                var _x = (x - cx) * ry / rx + cx;
                if (isStroke) {
                    if ($6e9b0f2fe4e39376$export$8d36b1b5d19157c5(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) return true;
                } else w += $347a114fcc5254ff$var$windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $347a114fcc5254ff$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                x1 = x0 + width;
                y1 = y0 + height;
                if (isStroke) {
                    if ($beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y0, x1, y0, lineWidth, x, y) || $beafddd7270f4bea$export$8d36b1b5d19157c5(x1, y0, x1, y1, lineWidth, x, y) || $beafddd7270f4bea$export$8d36b1b5d19157c5(x1, y1, x0, y1, lineWidth, x, y) || $beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y1, x0, y0, lineWidth, x, y)) return true;
                } else {
                    w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(x1, y0, x1, y1, x, y);
                    w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(x0, y1, x0, y0, x, y);
                }
                break;
            case $347a114fcc5254ff$var$CMD.Z:
                if (isStroke) {
                    if ($beafddd7270f4bea$export$8d36b1b5d19157c5(xi, yi, x0, y0, lineWidth, x, y)) return true;
                } else w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (!isStroke && !$347a114fcc5254ff$var$isAroundEqual(yi, y0)) w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y) || 0;
    return w !== 0;
}
function $347a114fcc5254ff$export$8893e2b90ba10d92(pathProxy, x, y) {
    return $347a114fcc5254ff$var$containPath(pathProxy, 0, false, x, y);
}
function $347a114fcc5254ff$export$8d36b1b5d19157c5(pathProxy, lineWidth, x, y) {
    return $347a114fcc5254ff$var$containPath(pathProxy, lineWidth, true, x, y);
}







var $b02ffe7acd508c08$export$deade517576e293a = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
    fill: "#000",
    stroke: null,
    strokePercent: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    lineDashOffset: 0,
    lineWidth: 1,
    lineCap: "butt",
    miterLimit: 10,
    strokeNoScale: false,
    strokeFirst: false
}, (0, $56206a6cb4666931$export$737672163db00fe3));
var $b02ffe7acd508c08$export$71bb6c3c6862c6a5 = {
    style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        fill: true,
        stroke: true,
        strokePercent: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineDashOffset: true,
        lineWidth: true,
        miterLimit: true
    }, (0, $56206a6cb4666931$export$9908943fb57fbe51).style)
};
var $b02ffe7acd508c08$var$pathCopyParams = (0, $becf2d727f9cf450$export$98ab6203ec3396e2).concat([
    "invisible",
    "culling",
    "z",
    "z2",
    "zlevel",
    "parent"
]);
var $b02ffe7acd508c08$var$Path = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Path, _super);
    function Path(opts) {
        return _super.call(this, opts) || this;
    }
    Path.prototype.update = function() {
        var _this = this;
        _super.prototype.update.call(this);
        var style = this.style;
        if (style.decal) {
            var decalEl = this._decalEl = this._decalEl || new Path();
            if (decalEl.buildPath === Path.prototype.buildPath) decalEl.buildPath = function(ctx) {
                _this.buildPath(ctx, _this.shape);
            };
            decalEl.silent = true;
            var decalElStyle = decalEl.style;
            for(var key in style)if (decalElStyle[key] !== style[key]) decalElStyle[key] = style[key];
            decalElStyle.fill = style.fill ? style.decal : null;
            decalElStyle.decal = null;
            decalElStyle.shadowColor = null;
            style.strokeFirst && (decalElStyle.stroke = null);
            for(var i = 0; i < $b02ffe7acd508c08$var$pathCopyParams.length; ++i)decalEl[$b02ffe7acd508c08$var$pathCopyParams[i]] = this[$b02ffe7acd508c08$var$pathCopyParams[i]];
            decalEl.__dirty |= (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        } else if (this._decalEl) this._decalEl = null;
    };
    Path.prototype.getDecalElement = function() {
        return this._decalEl;
    };
    Path.prototype._init = function(props) {
        var keysArr = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(props);
        this.shape = this.getDefaultShape();
        var defaultStyle = this.getDefaultStyle();
        if (defaultStyle) this.useStyle(defaultStyle);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            var value = props[key];
            if (key === "style") {
                if (!this.style) this.useStyle(value);
                else (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.style, value);
            } else if (key === "shape") (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(this.shape, value);
            else _super.prototype.attrKV.call(this, key, value);
        }
        if (!this.style) this.useStyle({});
    };
    Path.prototype.getDefaultStyle = function() {
        return null;
    };
    Path.prototype.getDefaultShape = function() {
        return {};
    };
    Path.prototype.canBeInsideText = function() {
        return this.hasFill();
    };
    Path.prototype.getInsideTextFill = function() {
        var pathFill = this.style.fill;
        if (pathFill !== "none") {
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(pathFill)) {
                var fillLum = (0, $2c037f5bda6341ca$export$16c0ec21a6f9ef95)(pathFill, 0);
                if (fillLum > 0.5) return 0, $4b0cedd85979c776$export$f8ce94761f39398d;
                else if (fillLum > 0.2) return 0, $4b0cedd85979c776$export$27682248795c3c6b;
                return 0, $4b0cedd85979c776$export$3c6e95f318c8369b;
            } else if (pathFill) return 0, $4b0cedd85979c776$export$3c6e95f318c8369b;
        }
        return 0, $4b0cedd85979c776$export$f8ce94761f39398d;
    };
    Path.prototype.getInsideTextStroke = function(textFill) {
        var pathFill = this.style.fill;
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(pathFill)) {
            var zr = this.__zr;
            var isDarkMode = !!(zr && zr.isDarkMode());
            var isDarkLabel = (0, $2c037f5bda6341ca$export$16c0ec21a6f9ef95)(textFill, 0) < (0, $4b0cedd85979c776$export$fd81e7ebc7dae256);
            if (isDarkMode === isDarkLabel) return pathFill;
        }
    };
    Path.prototype.buildPath = function(ctx, shapeCfg, inBatch) {};
    Path.prototype.pathUpdated = function() {
        this.__dirty &= ~(0, $ddf76b16f1246ba9$export$f75fe89a33ebe115);
    };
    Path.prototype.getUpdatedPathProxy = function(inBatch) {
        !this.path && this.createPathProxy();
        this.path.beginPath();
        this.buildPath(this.path, this.shape, inBatch);
        return this.path;
    };
    Path.prototype.createPathProxy = function() {
        this.path = new (0, $20ebe2448f123f2e$export$2e2bcd8739ae039)(false);
    };
    Path.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return !(stroke == null || stroke === "none" || !(style.lineWidth > 0));
    };
    Path.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== "none";
    };
    Path.prototype.getBoundingRect = function() {
        var rect = this._rect;
        var style = this.style;
        var needsUpdateRect = !rect;
        if (needsUpdateRect) {
            var firstInvoke = false;
            if (!this.path) {
                firstInvoke = true;
                this.createPathProxy();
            }
            var path = this.path;
            if (firstInvoke || this.__dirty & (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115)) {
                path.beginPath();
                this.buildPath(path, this.shape, false);
                this.pathUpdated();
            }
            rect = path.getBoundingRect();
        }
        this._rect = rect;
        if (this.hasStroke() && this.path && this.path.len() > 0) {
            var rectStroke = this._rectStroke || (this._rectStroke = rect.clone());
            if (this.__dirty || needsUpdateRect) {
                rectStroke.copy(rect);
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                var w = style.lineWidth;
                if (!this.hasFill()) {
                    var strokeContainThreshold = this.strokeContainThreshold;
                    w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
                }
                if (lineScale > 1e-10) {
                    rectStroke.width += w / lineScale;
                    rectStroke.height += w / lineScale;
                    rectStroke.x -= w / lineScale / 2;
                    rectStroke.y -= w / lineScale / 2;
                }
            }
            return rectStroke;
        }
        return rect;
    };
    Path.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        var style = this.style;
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            var pathProxy = this.path;
            if (this.hasStroke()) {
                var lineWidth = style.lineWidth;
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                if (lineScale > 1e-10) {
                    if (!this.hasFill()) lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                    if ($347a114fcc5254ff$export$8d36b1b5d19157c5(pathProxy, lineWidth / lineScale, x, y)) return true;
                }
            }
            if (this.hasFill()) return $347a114fcc5254ff$export$8893e2b90ba10d92(pathProxy, x, y);
        }
        return false;
    };
    Path.prototype.dirtyShape = function() {
        this.__dirty |= (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115);
        if (this._rect) this._rect = null;
        if (this._decalEl) this._decalEl.dirtyShape();
        this.markRedraw();
    };
    Path.prototype.dirty = function() {
        this.dirtyStyle();
        this.dirtyShape();
    };
    Path.prototype.animateShape = function(loop) {
        return this.animate("shape", loop);
    };
    Path.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === "style") this.dirtyStyle();
        else if (targetKey === "shape") this.dirtyShape();
        else this.markRedraw();
    };
    Path.prototype.attrKV = function(key, value) {
        if (key === "shape") this.setShape(value);
        else _super.prototype.attrKV.call(this, key, value);
    };
    Path.prototype.setShape = function(keyOrObj, value) {
        var shape = this.shape;
        if (!shape) shape = this.shape = {};
        if (typeof keyOrObj === "string") shape[keyOrObj] = value;
        else (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(shape, keyOrObj);
        this.dirtyShape();
        return this;
    };
    Path.prototype.shapeChanged = function() {
        return !!(this.__dirty & (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115));
    };
    Path.prototype.createStyle = function(obj) {
        return (0, $7a1bd9c2710fea0d$export$79c7e160a7743efd)($b02ffe7acd508c08$export$deade517576e293a, obj);
    };
    Path.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.shape && !normalState.shape) normalState.shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, this.shape);
    };
    Path.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetShape;
        if (state && state.shape) {
            if (transition) {
                if (keepCurrentStates) targetShape = state.shape;
                else {
                    targetShape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, normalState.shape);
                    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetShape, state.shape);
                }
            } else {
                targetShape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, keepCurrentStates ? this.shape : normalState.shape);
                (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetShape, state.shape);
            }
        } else if (needsRestoreToNormal) targetShape = normalState.shape;
        if (targetShape) {
            if (transition) {
                this.shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, this.shape);
                var targetShapePrimaryProps = {};
                var shapeKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(targetShape);
                for(var i = 0; i < shapeKeys.length; i++){
                    var key = shapeKeys[i];
                    if (typeof targetShape[key] === "object") this.shape[key] = targetShape[key];
                    else targetShapePrimaryProps[key] = targetShape[key];
                }
                this._transitionState(stateName, {
                    shape: targetShapePrimaryProps
                }, animationCfg);
            } else {
                this.shape = targetShape;
                this.dirtyShape();
            }
        }
    };
    Path.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedShape;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.shape) {
                mergedShape = mergedShape || {};
                this._mergeStyle(mergedShape, state.shape);
            }
        }
        if (mergedShape) mergedState.shape = mergedShape;
        return mergedState;
    };
    Path.prototype.getAnimationStyleProps = function() {
        return $b02ffe7acd508c08$export$71bb6c3c6862c6a5;
    };
    Path.prototype.isZeroArea = function() {
        return false;
    };
    Path.extend = function(defaultProps) {
        var Sub = function(_super) {
            (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Sub, _super);
            function Sub(opts) {
                var _this = _super.call(this, opts) || this;
                defaultProps.init && defaultProps.init.call(_this, opts);
                return _this;
            }
            Sub.prototype.getDefaultStyle = function() {
                return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(defaultProps.style);
            };
            Sub.prototype.getDefaultShape = function() {
                return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(defaultProps.shape);
            };
            return Sub;
        }(Path);
        for(var key in defaultProps)if (typeof defaultProps[key] === "function") Sub.prototype[key] = defaultProps[key];
        return Sub;
    };
    Path.initDefaultProps = function() {
        var pathProto = Path.prototype;
        pathProto.type = "path";
        pathProto.strokeContainThreshold = 5;
        pathProto.segmentIgnoreThreshold = 0;
        pathProto.subPixelOptimize = false;
        pathProto.autoBatch = false;
        pathProto.__dirty = (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) | (0, $ddf76b16f1246ba9$export$ada8b2beb3d76671) | (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115);
    }();
    return Path;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
var $b02ffe7acd508c08$export$2e2bcd8739ae039 = $b02ffe7acd508c08$var$Path;




var $c9d5c769fe2f591f$export$5fbb6d98091bcb56 = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
    strokeFirst: true,
    font: (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c),
    x: 0,
    y: 0,
    textAlign: "left",
    textBaseline: "top",
    miterLimit: 2
}, (0, $b02ffe7acd508c08$export$deade517576e293a));
var $c9d5c769fe2f591f$var$TSpan = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(TSpan, _super);
    function TSpan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TSpan.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return stroke != null && stroke !== "none" && style.lineWidth > 0;
    };
    TSpan.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== "none";
    };
    TSpan.prototype.createStyle = function(obj) {
        return (0, $7a1bd9c2710fea0d$export$79c7e160a7743efd)($c9d5c769fe2f591f$export$5fbb6d98091bcb56, obj);
    };
    TSpan.prototype.setBoundingRect = function(rect) {
        this._rect = rect;
    };
    TSpan.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) {
            var text = style.text;
            text != null ? text += "" : text = "";
            var rect = (0, $6c308355c7107803$export$c381147bfed79d9f)(text, style.font, style.textAlign, style.textBaseline);
            rect.x += style.x || 0;
            rect.y += style.y || 0;
            if (this.hasStroke()) {
                var w = style.lineWidth;
                rect.x -= w / 2;
                rect.y -= w / 2;
                rect.width += w;
                rect.height += w;
            }
            this._rect = rect;
        }
        return this._rect;
    };
    TSpan.initDefaultProps = function() {
        var tspanProto = TSpan.prototype;
        tspanProto.dirtyRectTolerance = 10;
    }();
    return TSpan;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
$c9d5c769fe2f591f$var$TSpan.prototype.type = "tspan";
var $c9d5c769fe2f591f$export$2e2bcd8739ae039 = $c9d5c769fe2f591f$var$TSpan;








var $86adec94217b86c6$export$8993f922aeeac642 = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
    x: 0,
    y: 0
}, (0, $56206a6cb4666931$export$737672163db00fe3));
var $86adec94217b86c6$export$4aba8ad70847a488 = {
    style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        x: true,
        y: true,
        width: true,
        height: true,
        sx: true,
        sy: true,
        sWidth: true,
        sHeight: true
    }, (0, $56206a6cb4666931$export$9908943fb57fbe51).style)
};
function $86adec94217b86c6$var$isImageLike(source) {
    return !!(source && typeof source !== "string" && source.width && source.height);
}
var $86adec94217b86c6$var$ZRImage = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(ZRImage, _super);
    function ZRImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZRImage.prototype.createStyle = function(obj) {
        return (0, $7a1bd9c2710fea0d$export$79c7e160a7743efd)($86adec94217b86c6$export$8993f922aeeac642, obj);
    };
    ZRImage.prototype._getSize = function(dim) {
        var style = this.style;
        var size = style[dim];
        if (size != null) return size;
        var imageSource = $86adec94217b86c6$var$isImageLike(style.image) ? style.image : this.__image;
        if (!imageSource) return 0;
        var otherDim = dim === "width" ? "height" : "width";
        var otherDimSize = style[otherDim];
        if (otherDimSize == null) return imageSource[dim];
        else return imageSource[dim] / imageSource[otherDim] * otherDimSize;
    };
    ZRImage.prototype.getWidth = function() {
        return this._getSize("width");
    };
    ZRImage.prototype.getHeight = function() {
        return this._getSize("height");
    };
    ZRImage.prototype.getAnimationStyleProps = function() {
        return $86adec94217b86c6$export$4aba8ad70847a488;
    };
    ZRImage.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) this._rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
        return this._rect;
    };
    return ZRImage;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
$86adec94217b86c6$var$ZRImage.prototype.type = "image";
var $86adec94217b86c6$export$2e2bcd8739ae039 = $86adec94217b86c6$var$ZRImage;




function $a351e275fffc3a77$export$5cc7f731b5937e99(ctx, shape) {
    var x = shape.x;
    var y = shape.y;
    var width = shape.width;
    var height = shape.height;
    var r = shape.r;
    var r1;
    var r2;
    var r3;
    var r4;
    if (width < 0) {
        x = x + width;
        width = -width;
    }
    if (height < 0) {
        y = y + height;
        height = -height;
    }
    if (typeof r === "number") r1 = r2 = r3 = r4 = r;
    else if (r instanceof Array) {
        if (r.length === 1) r1 = r2 = r3 = r4 = r[0];
        else if (r.length === 2) {
            r1 = r3 = r[0];
            r2 = r4 = r[1];
        } else if (r.length === 3) {
            r1 = r[0];
            r2 = r4 = r[1];
            r3 = r[2];
        } else {
            r1 = r[0];
            r2 = r[1];
            r3 = r[2];
            r4 = r[3];
        }
    } else r1 = r2 = r3 = r4 = 0;
    var total;
    if (r1 + r2 > width) {
        total = r1 + r2;
        r1 *= width / total;
        r2 *= width / total;
    }
    if (r3 + r4 > width) {
        total = r3 + r4;
        r3 *= width / total;
        r4 *= width / total;
    }
    if (r2 + r3 > height) {
        total = r2 + r3;
        r2 *= height / total;
        r3 *= height / total;
    }
    if (r1 + r4 > height) {
        total = r1 + r4;
        r1 *= height / total;
        r4 *= height / total;
    }
    ctx.moveTo(x + r1, y);
    ctx.lineTo(x + width - r2, y);
    r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
    ctx.lineTo(x + width, y + height - r3);
    r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
    ctx.lineTo(x + r4, y + height);
    r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
    ctx.lineTo(x, y + r1);
    r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
}


var $4d5544821af8d796$var$round = Math.round;
function $4d5544821af8d796$export$8b4b620d7f4aad1b(outputShape, inputShape, style) {
    if (!inputShape) return;
    var x1 = inputShape.x1;
    var x2 = inputShape.x2;
    var y1 = inputShape.y1;
    var y2 = inputShape.y2;
    outputShape.x1 = x1;
    outputShape.x2 = x2;
    outputShape.y1 = y1;
    outputShape.y2 = y2;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    if ($4d5544821af8d796$var$round(x1 * 2) === $4d5544821af8d796$var$round(x2 * 2)) outputShape.x1 = outputShape.x2 = $4d5544821af8d796$export$72c4fd4c1b8fcb10(x1, lineWidth, true);
    if ($4d5544821af8d796$var$round(y1 * 2) === $4d5544821af8d796$var$round(y2 * 2)) outputShape.y1 = outputShape.y2 = $4d5544821af8d796$export$72c4fd4c1b8fcb10(y1, lineWidth, true);
    return outputShape;
}
function $4d5544821af8d796$export$60e2aa74957d0b9d(outputShape, inputShape, style) {
    if (!inputShape) return;
    var originX = inputShape.x;
    var originY = inputShape.y;
    var originWidth = inputShape.width;
    var originHeight = inputShape.height;
    outputShape.x = originX;
    outputShape.y = originY;
    outputShape.width = originWidth;
    outputShape.height = originHeight;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    outputShape.x = $4d5544821af8d796$export$72c4fd4c1b8fcb10(originX, lineWidth, true);
    outputShape.y = $4d5544821af8d796$export$72c4fd4c1b8fcb10(originY, lineWidth, true);
    outputShape.width = Math.max($4d5544821af8d796$export$72c4fd4c1b8fcb10(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
    outputShape.height = Math.max($4d5544821af8d796$export$72c4fd4c1b8fcb10(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
    return outputShape;
}
function $4d5544821af8d796$export$72c4fd4c1b8fcb10(position, lineWidth, positiveOrNegative) {
    if (!lineWidth) return position;
    var doubledPosition = $4d5544821af8d796$var$round(position * 2);
    return (doubledPosition + $4d5544821af8d796$var$round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}


var $419e5ff2f303755e$export$51140d6b71bb4ed5 = function() {
    function RectShape() {
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
    }
    return RectShape;
}();
var $419e5ff2f303755e$var$subPixelOptimizeOutputShape = {};
var $419e5ff2f303755e$var$Rect = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Rect, _super);
    function Rect(opts) {
        return _super.call(this, opts) || this;
    }
    Rect.prototype.getDefaultShape = function() {
        return new $419e5ff2f303755e$export$51140d6b71bb4ed5();
    };
    Rect.prototype.buildPath = function(ctx, shape) {
        var x;
        var y;
        var width;
        var height;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $4d5544821af8d796$export$60e2aa74957d0b9d)($419e5ff2f303755e$var$subPixelOptimizeOutputShape, shape, this.style);
            x = optimizedShape.x;
            y = optimizedShape.y;
            width = optimizedShape.width;
            height = optimizedShape.height;
            optimizedShape.r = shape.r;
            shape = optimizedShape;
        } else {
            x = shape.x;
            y = shape.y;
            width = shape.width;
            height = shape.height;
        }
        if (!shape.r) ctx.rect(x, y, width, height);
        else $a351e275fffc3a77$export$5cc7f731b5937e99(ctx, shape);
    };
    Rect.prototype.isZeroArea = function() {
        return !this.shape.width || !this.shape.height;
    };
    return Rect;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$419e5ff2f303755e$var$Rect.prototype.type = "rect";
var $419e5ff2f303755e$export$2e2bcd8739ae039 = $419e5ff2f303755e$var$Rect;





var $fe885cc21795562b$var$DEFAULT_RICH_TEXT_COLOR = {
    fill: "#000"
};
var $fe885cc21795562b$var$DEFAULT_STROKE_LINE_WIDTH = 2;
var $fe885cc21795562b$export$21aaaa0607ee0e2b = {
    style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        fill: true,
        stroke: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineWidth: true,
        fontSize: true,
        lineHeight: true,
        width: true,
        height: true,
        textShadowColor: true,
        textShadowBlur: true,
        textShadowOffsetX: true,
        textShadowOffsetY: true,
        backgroundColor: true,
        padding: true,
        borderColor: true,
        borderWidth: true,
        borderRadius: true
    }, (0, $56206a6cb4666931$export$9908943fb57fbe51).style)
};
var $fe885cc21795562b$var$ZRText = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(ZRText, _super);
    function ZRText(opts) {
        var _this = _super.call(this) || this;
        _this.type = "text";
        _this._children = [];
        _this._defaultStyle = $fe885cc21795562b$var$DEFAULT_RICH_TEXT_COLOR;
        _this.attr(opts);
        return _this;
    }
    ZRText.prototype.childrenRef = function() {
        return this._children;
    };
    ZRText.prototype.update = function() {
        _super.prototype.update.call(this);
        if (this.styleChanged()) this._updateSubTexts();
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.zlevel = this.zlevel;
            child.z = this.z;
            child.z2 = this.z2;
            child.culling = this.culling;
            child.cursor = this.cursor;
            child.invisible = this.invisible;
        }
    };
    ZRText.prototype.updateTransform = function() {
        var innerTransformable = this.innerTransformable;
        if (innerTransformable) {
            innerTransformable.updateTransform();
            if (innerTransformable.transform) this.transform = innerTransformable.transform;
        } else _super.prototype.updateTransform.call(this);
    };
    ZRText.prototype.getLocalTransform = function(m) {
        var innerTransformable = this.innerTransformable;
        return innerTransformable ? innerTransformable.getLocalTransform(m) : _super.prototype.getLocalTransform.call(this, m);
    };
    ZRText.prototype.getComputedTransform = function() {
        if (this.__hostTarget) {
            this.__hostTarget.getComputedTransform();
            this.__hostTarget.updateInnerText(true);
        }
        return _super.prototype.getComputedTransform.call(this);
    };
    ZRText.prototype._updateSubTexts = function() {
        this._childCursor = 0;
        $fe885cc21795562b$export$176336068cc5371f(this.style);
        this.style.rich ? this._updateRichTexts() : this._updatePlainTexts();
        this._children.length = this._childCursor;
        this.styleUpdated();
    };
    ZRText.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = zr;
    };
    ZRText.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = null;
    };
    ZRText.prototype.getBoundingRect = function() {
        if (this.styleChanged()) this._updateSubTexts();
        if (!this._rect) {
            var tmpRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
            var children = this._children;
            var tmpMat = [];
            var rect = null;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                var childRect = child.getBoundingRect();
                var transform = child.getLocalTransform(tmpMat);
                if (transform) {
                    tmpRect.copy(childRect);
                    tmpRect.applyTransform(transform);
                    rect = rect || tmpRect.clone();
                    rect.union(tmpRect);
                } else {
                    rect = rect || childRect.clone();
                    rect.union(childRect);
                }
            }
            this._rect = rect || tmpRect;
        }
        return this._rect;
    };
    ZRText.prototype.setDefaultTextStyle = function(defaultTextStyle) {
        this._defaultStyle = defaultTextStyle || $fe885cc21795562b$var$DEFAULT_RICH_TEXT_COLOR;
    };
    ZRText.prototype.setTextContent = function(textContent) {};
    ZRText.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        if (!sourceStyle) return targetStyle;
        var sourceRich = sourceStyle.rich;
        var targetRich = targetStyle.rich || sourceRich && {};
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetStyle, sourceStyle);
        if (sourceRich && targetRich) {
            this._mergeRich(targetRich, sourceRich);
            targetStyle.rich = targetRich;
        } else if (targetRich) targetStyle.rich = targetRich;
        return targetStyle;
    };
    ZRText.prototype._mergeRich = function(targetRich, sourceRich) {
        var richNames = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(sourceRich);
        for(var i = 0; i < richNames.length; i++){
            var richName = richNames[i];
            targetRich[richName] = targetRich[richName] || {};
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(targetRich[richName], sourceRich[richName]);
        }
    };
    ZRText.prototype.getAnimationStyleProps = function() {
        return $fe885cc21795562b$export$21aaaa0607ee0e2b;
    };
    ZRText.prototype._getOrCreateChild = function(Ctor) {
        var child = this._children[this._childCursor];
        if (!child || !(child instanceof Ctor)) child = new Ctor();
        this._children[this._childCursor++] = child;
        child.__zr = this.__zr;
        child.parent = this;
        return child;
    };
    ZRText.prototype._updatePlainTexts = function() {
        var style = this.style;
        var textFont = style.font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
        var textPadding = style.padding;
        var text = $fe885cc21795562b$var$getStyleText(style);
        var contentBlock = (0, $64fa9b3825ba2dec$export$5772575e34ef80f9)(text, style);
        var needDrawBg = $fe885cc21795562b$var$needDrawBackground(style);
        var bgColorDrawn = !!style.backgroundColor;
        var outerHeight = contentBlock.outerHeight;
        var outerWidth = contentBlock.outerWidth;
        var contentWidth = contentBlock.contentWidth;
        var textLines = contentBlock.lines;
        var lineHeight = contentBlock.lineHeight;
        var defaultStyle = this._defaultStyle;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var textAlign = style.align || defaultStyle.align || "left";
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || "top";
        var textX = baseX;
        var textY = (0, $6c308355c7107803$export$bf7d6802d2badd9)(baseY, contentBlock.contentHeight, verticalAlign);
        if (needDrawBg || textPadding) {
            var boxX = (0, $6c308355c7107803$export$eb5a525ef00ef9a4)(baseX, outerWidth, textAlign);
            var boxY = (0, $6c308355c7107803$export$bf7d6802d2badd9)(baseY, outerHeight, verticalAlign);
            needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        }
        textY += lineHeight / 2;
        if (textPadding) {
            textX = $fe885cc21795562b$var$getTextXForPadding(baseX, textAlign, textPadding);
            if (verticalAlign === "top") textY += textPadding[0];
            else if (verticalAlign === "bottom") textY -= textPadding[2];
        }
        var defaultLineWidth = 0;
        var useDefaultFill = false;
        var textFill = $fe885cc21795562b$var$getFill("fill" in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $fe885cc21795562b$var$getStroke("stroke" in style ? style.stroke : !bgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $fe885cc21795562b$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
        var hasShadow = style.textShadowBlur > 0;
        var fixedBoundingRect = style.width != null && (style.overflow === "truncate" || style.overflow === "break" || style.overflow === "breakAll");
        var calculatedLineHeight = contentBlock.calculatedLineHeight;
        for(var i = 0; i < textLines.length; i++){
            var el = this._getOrCreateChild((0, $c9d5c769fe2f591f$export$2e2bcd8739ae039));
            var subElStyle = el.createStyle();
            el.useStyle(subElStyle);
            subElStyle.text = textLines[i];
            subElStyle.x = textX;
            subElStyle.y = textY;
            if (textAlign) subElStyle.textAlign = textAlign;
            subElStyle.textBaseline = "middle";
            subElStyle.opacity = style.opacity;
            subElStyle.strokeFirst = true;
            if (hasShadow) {
                subElStyle.shadowBlur = style.textShadowBlur || 0;
                subElStyle.shadowColor = style.textShadowColor || "transparent";
                subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
                subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
            }
            subElStyle.stroke = textStroke;
            subElStyle.fill = textFill;
            if (textStroke) {
                subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
                subElStyle.lineDash = style.lineDash;
                subElStyle.lineDashOffset = style.lineDashOffset || 0;
            }
            subElStyle.font = textFont;
            $fe885cc21795562b$var$setSeparateFont(subElStyle, style);
            textY += lineHeight;
            if (fixedBoundingRect) el.setBoundingRect(new (0, $1bebe7106c895823$export$2e2bcd8739ae039)((0, $6c308355c7107803$export$eb5a525ef00ef9a4)(subElStyle.x, style.width, subElStyle.textAlign), (0, $6c308355c7107803$export$bf7d6802d2badd9)(subElStyle.y, calculatedLineHeight, subElStyle.textBaseline), contentWidth, calculatedLineHeight));
        }
    };
    ZRText.prototype._updateRichTexts = function() {
        var style = this.style;
        var text = $fe885cc21795562b$var$getStyleText(style);
        var contentBlock = (0, $64fa9b3825ba2dec$export$15ec9472ff2d721)(text, style);
        var contentWidth = contentBlock.width;
        var outerWidth = contentBlock.outerWidth;
        var outerHeight = contentBlock.outerHeight;
        var textPadding = style.padding;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var defaultStyle = this._defaultStyle;
        var textAlign = style.align || defaultStyle.align;
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
        var boxX = (0, $6c308355c7107803$export$eb5a525ef00ef9a4)(baseX, outerWidth, textAlign);
        var boxY = (0, $6c308355c7107803$export$bf7d6802d2badd9)(baseY, outerHeight, verticalAlign);
        var xLeft = boxX;
        var lineTop = boxY;
        if (textPadding) {
            xLeft += textPadding[3];
            lineTop += textPadding[0];
        }
        var xRight = xLeft + contentWidth;
        if ($fe885cc21795562b$var$needDrawBackground(style)) this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        var bgColorDrawn = !!style.backgroundColor;
        for(var i = 0; i < contentBlock.lines.length; i++){
            var line = contentBlock.lines[i];
            var tokens = line.tokens;
            var tokenCount = tokens.length;
            var lineHeight = line.lineHeight;
            var remainedWidth = line.width;
            var leftIndex = 0;
            var lineXLeft = xLeft;
            var lineXRight = xRight;
            var rightIndex = tokenCount - 1;
            var token = void 0;
            while(leftIndex < tokenCount && (token = tokens[leftIndex], !token.align || token.align === "left")){
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft, "left", bgColorDrawn);
                remainedWidth -= token.width;
                lineXLeft += token.width;
                leftIndex++;
            }
            while(rightIndex >= 0 && (token = tokens[rightIndex], token.align === "right")){
                this._placeToken(token, style, lineHeight, lineTop, lineXRight, "right", bgColorDrawn);
                remainedWidth -= token.width;
                lineXRight -= token.width;
                rightIndex--;
            }
            lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
            while(leftIndex <= rightIndex){
                token = tokens[leftIndex];
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, "center", bgColorDrawn);
                lineXLeft += token.width;
                leftIndex++;
            }
            lineTop += lineHeight;
        }
    };
    ZRText.prototype._placeToken = function(token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
        var tokenStyle = style.rich[token.styleName] || {};
        tokenStyle.text = token.text;
        var verticalAlign = token.verticalAlign;
        var y = lineTop + lineHeight / 2;
        if (verticalAlign === "top") y = lineTop + token.height / 2;
        else if (verticalAlign === "bottom") y = lineTop + lineHeight - token.height / 2;
        var needDrawBg = !token.isLineHolder && $fe885cc21795562b$var$needDrawBackground(tokenStyle);
        needDrawBg && this._renderBackground(tokenStyle, style, textAlign === "right" ? x - token.width : textAlign === "center" ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
        var bgColorDrawn = !!tokenStyle.backgroundColor;
        var textPadding = token.textPadding;
        if (textPadding) {
            x = $fe885cc21795562b$var$getTextXForPadding(x, textAlign, textPadding);
            y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
        }
        var el = this._getOrCreateChild((0, $c9d5c769fe2f591f$export$2e2bcd8739ae039));
        var subElStyle = el.createStyle();
        el.useStyle(subElStyle);
        var defaultStyle = this._defaultStyle;
        var useDefaultFill = false;
        var defaultLineWidth = 0;
        var textFill = $fe885cc21795562b$var$getFill("fill" in tokenStyle ? tokenStyle.fill : "fill" in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $fe885cc21795562b$var$getStroke("stroke" in tokenStyle ? tokenStyle.stroke : "stroke" in style ? style.stroke : !bgColorDrawn && !parentBgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $fe885cc21795562b$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
        var hasShadow = tokenStyle.textShadowBlur > 0 || style.textShadowBlur > 0;
        subElStyle.text = token.text;
        subElStyle.x = x;
        subElStyle.y = y;
        if (hasShadow) {
            subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
            subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || "transparent";
            subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
            subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
        }
        subElStyle.textAlign = textAlign;
        subElStyle.textBaseline = "middle";
        subElStyle.font = token.font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
        subElStyle.opacity = (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(tokenStyle.opacity, style.opacity, 1);
        $fe885cc21795562b$var$setSeparateFont(subElStyle, tokenStyle);
        if (textStroke) {
            subElStyle.lineWidth = (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
            subElStyle.lineDash = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(tokenStyle.lineDash, style.lineDash);
            subElStyle.lineDashOffset = style.lineDashOffset || 0;
            subElStyle.stroke = textStroke;
        }
        if (textFill) subElStyle.fill = textFill;
        var textWidth = token.contentWidth;
        var textHeight = token.contentHeight;
        el.setBoundingRect(new (0, $1bebe7106c895823$export$2e2bcd8739ae039)((0, $6c308355c7107803$export$eb5a525ef00ef9a4)(subElStyle.x, textWidth, subElStyle.textAlign), (0, $6c308355c7107803$export$bf7d6802d2badd9)(subElStyle.y, textHeight, subElStyle.textBaseline), textWidth, textHeight));
    };
    ZRText.prototype._renderBackground = function(style, topStyle, x, y, width, height) {
        var textBackgroundColor = style.backgroundColor;
        var textBorderWidth = style.borderWidth;
        var textBorderColor = style.borderColor;
        var isImageBg = textBackgroundColor && textBackgroundColor.image;
        var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
        var textBorderRadius = style.borderRadius;
        var self = this;
        var rectEl;
        var imgEl;
        if (isPlainOrGradientBg || style.lineHeight || textBorderWidth && textBorderColor) {
            rectEl = this._getOrCreateChild((0, $419e5ff2f303755e$export$2e2bcd8739ae039));
            rectEl.useStyle(rectEl.createStyle());
            rectEl.style.fill = null;
            var rectShape = rectEl.shape;
            rectShape.x = x;
            rectShape.y = y;
            rectShape.width = width;
            rectShape.height = height;
            rectShape.r = textBorderRadius;
            rectEl.dirtyShape();
        }
        if (isPlainOrGradientBg) {
            var rectStyle = rectEl.style;
            rectStyle.fill = textBackgroundColor || null;
            rectStyle.fillOpacity = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(style.fillOpacity, 1);
        } else if (isImageBg) {
            imgEl = this._getOrCreateChild((0, $86adec94217b86c6$export$2e2bcd8739ae039));
            imgEl.onload = function() {
                self.dirtyStyle();
            };
            var imgStyle = imgEl.style;
            imgStyle.image = textBackgroundColor.image;
            imgStyle.x = x;
            imgStyle.y = y;
            imgStyle.width = width;
            imgStyle.height = height;
        }
        if (textBorderWidth && textBorderColor) {
            var rectStyle = rectEl.style;
            rectStyle.lineWidth = textBorderWidth;
            rectStyle.stroke = textBorderColor;
            rectStyle.strokeOpacity = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(style.strokeOpacity, 1);
            rectStyle.lineDash = style.borderDash;
            rectStyle.lineDashOffset = style.borderDashOffset || 0;
            rectEl.strokeContainThreshold = 0;
            if (rectEl.hasFill() && rectEl.hasStroke()) {
                rectStyle.strokeFirst = true;
                rectStyle.lineWidth *= 2;
            }
        }
        var commonStyle = (rectEl || imgEl).style;
        commonStyle.shadowBlur = style.shadowBlur || 0;
        commonStyle.shadowColor = style.shadowColor || "transparent";
        commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
        commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
        commonStyle.opacity = (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(style.opacity, topStyle.opacity, 1);
    };
    ZRText.makeFont = function(style) {
        var font = "";
        if ($fe885cc21795562b$export$4685c95d5118e76a(style)) font = [
            style.fontStyle,
            style.fontWeight,
            $fe885cc21795562b$export$51b066d9cfc2578e(style.fontSize),
            style.fontFamily || "sans-serif"
        ].join(" ");
        return font && (0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(font) || style.textFont || style.font;
    };
    return ZRText;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
var $fe885cc21795562b$var$VALID_TEXT_ALIGN = {
    left: true,
    right: 1,
    center: 1
};
var $fe885cc21795562b$var$VALID_TEXT_VERTICAL_ALIGN = {
    top: 1,
    bottom: 1,
    middle: 1
};
var $fe885cc21795562b$var$FONT_PARTS = [
    "fontStyle",
    "fontWeight",
    "fontSize",
    "fontFamily"
];
function $fe885cc21795562b$export$51b066d9cfc2578e(fontSize) {
    if (typeof fontSize === "string" && (fontSize.indexOf("px") !== -1 || fontSize.indexOf("rem") !== -1 || fontSize.indexOf("em") !== -1)) return fontSize;
    else if (!isNaN(+fontSize)) return fontSize + "px";
    else return (0, $c6341dcc9d86826e$export$b1461457ea2c1179) + "px";
}
function $fe885cc21795562b$var$setSeparateFont(targetStyle, sourceStyle) {
    for(var i = 0; i < $fe885cc21795562b$var$FONT_PARTS.length; i++){
        var fontProp = $fe885cc21795562b$var$FONT_PARTS[i];
        var val = sourceStyle[fontProp];
        if (val != null) targetStyle[fontProp] = val;
    }
}
function $fe885cc21795562b$export$4685c95d5118e76a(style) {
    return style.fontSize != null || style.fontFamily || style.fontWeight;
}
function $fe885cc21795562b$export$176336068cc5371f(style) {
    $fe885cc21795562b$var$normalizeStyle(style);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(style.rich, $fe885cc21795562b$var$normalizeStyle);
    return style;
}
function $fe885cc21795562b$var$normalizeStyle(style) {
    if (style) {
        style.font = $fe885cc21795562b$var$ZRText.makeFont(style);
        var textAlign = style.align;
        textAlign === "middle" && (textAlign = "center");
        style.align = textAlign == null || $fe885cc21795562b$var$VALID_TEXT_ALIGN[textAlign] ? textAlign : "left";
        var verticalAlign = style.verticalAlign;
        verticalAlign === "center" && (verticalAlign = "middle");
        style.verticalAlign = verticalAlign == null || $fe885cc21795562b$var$VALID_TEXT_VERTICAL_ALIGN[verticalAlign] ? verticalAlign : "top";
        var textPadding = style.padding;
        if (textPadding) style.padding = (0, $7a1bd9c2710fea0d$export$f3a38102c49f4268)(style.padding);
    }
}
function $fe885cc21795562b$var$getStroke(stroke, lineWidth) {
    return stroke == null || lineWidth <= 0 || stroke === "transparent" || stroke === "none" ? null : stroke.image || stroke.colorStops ? "#000" : stroke;
}
function $fe885cc21795562b$var$getFill(fill) {
    return fill == null || fill === "none" ? null : fill.image || fill.colorStops ? "#000" : fill;
}
function $fe885cc21795562b$var$getTextXForPadding(x, textAlign, textPadding) {
    return textAlign === "right" ? x - textPadding[1] : textAlign === "center" ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
function $fe885cc21795562b$var$getStyleText(style) {
    var text = style.text;
    text != null && (text += "");
    return text;
}
function $fe885cc21795562b$var$needDrawBackground(style) {
    return !!(style.backgroundColor || style.lineHeight || style.borderWidth && style.borderColor);
}
var $fe885cc21795562b$export$2e2bcd8739ae039 = $fe885cc21795562b$var$ZRText;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $b1983a2fffd47d56$export$b1c39b2bacd1ddc2 = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $b1983a2fffd47d56$export$30d6736ebb8e18d5 = function(seriesIndex, dataType, dataIdx, el) {
    if (el) {
        var ecData = $b1983a2fffd47d56$export$b1c39b2bacd1ddc2(el);
        // Add data index and series index for indexing the data by element
        // Useful in tooltip
        ecData.dataIndex = dataIdx;
        ecData.dataType = dataType;
        ecData.seriesIndex = seriesIndex;
        ecData.ssrType = "chart";
        // TODO: not store dataIndex on children.
        if (el.type === "group") el.traverse(function(child) {
            var childECData = $b1983a2fffd47d56$export$b1c39b2bacd1ddc2(child);
            childECData.seriesIndex = seriesIndex;
            childECData.dataIndex = dataIdx;
            childECData.dataType = dataType;
            childECData.ssrType = "chart";
        });
    }
};






// Reserve 0 as default.
var $2bf82c0980125b62$var$_highlightNextDigit = 1;
var $2bf82c0980125b62$var$_highlightKeyMap = {};
var $2bf82c0980125b62$var$getSavedStates = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $2bf82c0980125b62$var$getComponentStates = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $2bf82c0980125b62$export$5542daa30722333e = 0;
var $2bf82c0980125b62$export$1307d6a87d56baa = 1;
var $2bf82c0980125b62$export$f0f2bee145debb31 = 2;
var $2bf82c0980125b62$export$151308dceb52d5b = [
    "emphasis",
    "blur",
    "select"
];
var $2bf82c0980125b62$export$57ee5306b85ad7d5 = [
    "normal",
    "emphasis",
    "blur",
    "select"
];
var $2bf82c0980125b62$export$1cb9fc6ed5b9836c = 10;
var $2bf82c0980125b62$export$3a2f97d39514bbc = 9;
var $2bf82c0980125b62$export$df035d873a9de64f = "highlight";
var $2bf82c0980125b62$export$f8a2f7807cc185ea = "downplay";
var $2bf82c0980125b62$export$89616263e7d38fe9 = "select";
var $2bf82c0980125b62$export$7636ad95c0f68a79 = "unselect";
var $2bf82c0980125b62$export$1e90ed8a25542516 = "toggleSelect";
function $2bf82c0980125b62$var$hasFillOrStroke(fillOrStroke) {
    return fillOrStroke != null && fillOrStroke !== "none";
}
function $2bf82c0980125b62$var$doChangeHoverState(el, stateName, hoverStateEnum) {
    if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) el.onHoverStateChange(stateName);
    el.hoverState = hoverStateEnum;
}
function $2bf82c0980125b62$var$singleEnterEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    $2bf82c0980125b62$var$doChangeHoverState(el, "emphasis", $2bf82c0980125b62$export$f0f2bee145debb31);
}
function $2bf82c0980125b62$var$singleLeaveEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    if (el.hoverState === $2bf82c0980125b62$export$f0f2bee145debb31) $2bf82c0980125b62$var$doChangeHoverState(el, "normal", $2bf82c0980125b62$export$5542daa30722333e);
}
function $2bf82c0980125b62$var$singleEnterBlur(el) {
    $2bf82c0980125b62$var$doChangeHoverState(el, "blur", $2bf82c0980125b62$export$1307d6a87d56baa);
}
function $2bf82c0980125b62$var$singleLeaveBlur(el) {
    if (el.hoverState === $2bf82c0980125b62$export$1307d6a87d56baa) $2bf82c0980125b62$var$doChangeHoverState(el, "normal", $2bf82c0980125b62$export$5542daa30722333e);
}
function $2bf82c0980125b62$var$singleEnterSelect(el) {
    el.selected = true;
}
function $2bf82c0980125b62$var$singleLeaveSelect(el) {
    el.selected = false;
}
function $2bf82c0980125b62$var$updateElementState(el, updater, commonParam) {
    updater(el, commonParam);
}
function $2bf82c0980125b62$var$traverseUpdateState(el, updater, commonParam) {
    $2bf82c0980125b62$var$updateElementState(el, updater, commonParam);
    el.isGroup && el.traverse(function(child) {
        $2bf82c0980125b62$var$updateElementState(child, updater, commonParam);
    });
}
function $2bf82c0980125b62$export$868ba38adffa9e39(el, stateName) {
    switch(stateName){
        case "emphasis":
            el.hoverState = $2bf82c0980125b62$export$f0f2bee145debb31;
            break;
        case "normal":
            el.hoverState = $2bf82c0980125b62$export$5542daa30722333e;
            break;
        case "blur":
            el.hoverState = $2bf82c0980125b62$export$1307d6a87d56baa;
            break;
        case "select":
            el.selected = true;
    }
}
function $2bf82c0980125b62$export$35330f949342a669(el) {
    if (el.isGroup) el.traverse(function(child) {
        child.clearStates();
    });
    else el.clearStates();
}
function $2bf82c0980125b62$var$getFromStateStyle(el, props, toStateName, defaultValue) {
    var style = el.style;
    var fromState = {};
    for(var i = 0; i < props.length; i++){
        var propName = props[i];
        var val = style[propName];
        fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
    }
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.__fromStateTransition && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === "style") animator.saveTo(fromState, props);
    }
    return fromState;
}
function $2bf82c0980125b62$var$createEmphasisDefaultState(el, stateName, targetStates, state) {
    var hasSelect = targetStates && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(targetStates, "select") >= 0;
    var cloned = false;
    if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) {
        var store = $2bf82c0980125b62$var$getSavedStates(el);
        var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
        var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;
        if ($2bf82c0980125b62$var$hasFillOrStroke(fromFill) || $2bf82c0980125b62$var$hasFillOrStroke(fromStroke)) {
            state = state || {};
            var emphasisStyle = state.style || {};
            // inherit case
            if (emphasisStyle.fill === "inherit") {
                cloned = true;
                state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
                emphasisStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, emphasisStyle);
                emphasisStyle.fill = fromFill;
            } else if (!$2bf82c0980125b62$var$hasFillOrStroke(emphasisStyle.fill) && $2bf82c0980125b62$var$hasFillOrStroke(fromFill)) {
                cloned = true;
                // Not modify the original value.
                state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
                emphasisStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, emphasisStyle);
                // Already being applied 'emphasis'. DON'T lift color multiple times.
                emphasisStyle.fill = (0, $2c037f5bda6341ca$export$2b47e247dfb87a73)(fromFill);
            } else if (!$2bf82c0980125b62$var$hasFillOrStroke(emphasisStyle.stroke) && $2bf82c0980125b62$var$hasFillOrStroke(fromStroke)) {
                if (!cloned) {
                    state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
                    emphasisStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, emphasisStyle);
                }
                emphasisStyle.stroke = (0, $2c037f5bda6341ca$export$2b47e247dfb87a73)(fromStroke);
            }
            state.style = emphasisStyle;
        }
    }
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            if (!cloned) state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
            var z2EmphasisLift = el.z2EmphasisLift;
            state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : $2bf82c0980125b62$export$1cb9fc6ed5b9836c);
        }
    }
    return state;
}
function $2bf82c0980125b62$var$createSelectDefaultState(el, stateName, state) {
    // const hasSelect = indexOf(el.currentStates, stateName) >= 0;
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
            var z2SelectLift = el.z2SelectLift;
            state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : $2bf82c0980125b62$export$3a2f97d39514bbc);
        }
    }
    return state;
}
function $2bf82c0980125b62$var$createBlurDefaultState(el, stateName, state) {
    var hasBlur = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(el.currentStates, stateName) >= 0;
    var currentOpacity = el.style.opacity;
    var fromState = !hasBlur ? $2bf82c0980125b62$var$getFromStateStyle(el, [
        "opacity"
    ], stateName, {
        opacity: 1
    }) : null;
    state = state || {};
    var blurStyle = state.style || {};
    if (blurStyle.opacity == null) {
        // clone state
        state = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, state);
        blurStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            // Already being applied 'emphasis'. DON'T mul opacity multiple times.
            opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
        }, blurStyle);
        state.style = blurStyle;
    }
    return state;
}
function $2bf82c0980125b62$var$elementStateProxy(stateName, targetStates) {
    var state = this.states[stateName];
    if (this.style) {
        if (stateName === "emphasis") return $2bf82c0980125b62$var$createEmphasisDefaultState(this, stateName, targetStates, state);
        else if (stateName === "blur") return $2bf82c0980125b62$var$createBlurDefaultState(this, stateName, state);
        else if (stateName === "select") return $2bf82c0980125b62$var$createSelectDefaultState(this, stateName, state);
    }
    return state;
}
function $2bf82c0980125b62$export$20f39bbe322fb9ab(el) {
    el.stateProxy = $2bf82c0980125b62$var$elementStateProxy;
    var textContent = el.getTextContent();
    var textGuide = el.getTextGuideLine();
    if (textContent) textContent.stateProxy = $2bf82c0980125b62$var$elementStateProxy;
    if (textGuide) textGuide.stateProxy = $2bf82c0980125b62$var$elementStateProxy;
}
function $2bf82c0980125b62$export$d899507e2598e4ae(el, e) {
    !$2bf82c0980125b62$var$shouldSilent(el, e) && !el.__highByOuter && $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleEnterEmphasis);
}
function $2bf82c0980125b62$export$784cba1f7fe58cca(el, e) {
    !$2bf82c0980125b62$var$shouldSilent(el, e) && !el.__highByOuter && $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleLeaveEmphasis);
}
function $2bf82c0980125b62$export$b2d02638cc34c042(el, highlightDigit) {
    el.__highByOuter |= 1 << (highlightDigit || 0);
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleEnterEmphasis);
}
function $2bf82c0980125b62$export$11be6f716239ac55(el, highlightDigit) {
    !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleLeaveEmphasis);
}
function $2bf82c0980125b62$export$207f9cb3e1099375(el) {
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleEnterBlur);
}
function $2bf82c0980125b62$export$fd4a9ec75456d3c1(el) {
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleLeaveBlur);
}
function $2bf82c0980125b62$export$252d028dda8ef765(el) {
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleEnterSelect);
}
function $2bf82c0980125b62$export$ea9a904bd6e32bd3(el) {
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$var$singleLeaveSelect);
}
function $2bf82c0980125b62$var$shouldSilent(el, e) {
    return el.__highDownSilentOnTouch && e.zrByTouch;
}
function $2bf82c0980125b62$export$b2a593c7b5243584(api) {
    var model = api.getModel();
    var leaveBlurredSeries = [];
    var allComponentViews = [];
    model.eachComponent(function(componentType, componentModel) {
        var componentStates = $2bf82c0980125b62$var$getComponentStates(componentModel);
        var isSeries = componentType === "series";
        var view = isSeries ? api.getViewOfSeriesModel(componentModel) : api.getViewOfComponentModel(componentModel);
        !isSeries && allComponentViews.push(view);
        if (componentStates.isBlured) {
            // Leave blur anyway
            view.group.traverse(function(child) {
                $2bf82c0980125b62$var$singleLeaveBlur(child);
            });
            isSeries && leaveBlurredSeries.push(componentModel);
        }
        componentStates.isBlured = false;
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(allComponentViews, function(view) {
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(leaveBlurredSeries, false, model);
    });
}
function $2bf82c0980125b62$export$7d399e067d6552e3(targetSeriesIndex, focus, blurScope, api) {
    var ecModel = api.getModel();
    blurScope = blurScope || "coordinateSystem";
    function leaveBlurOfIndices(data, dataIndices) {
        for(var i = 0; i < dataIndices.length; i++){
            var itemEl = data.getItemGraphicEl(dataIndices[i]);
            itemEl && $2bf82c0980125b62$export$fd4a9ec75456d3c1(itemEl);
        }
    }
    if (targetSeriesIndex == null) return;
    if (!focus || focus === "none") return;
    var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
    var targetCoordSys = targetSeriesModel.coordinateSystem;
    if (targetCoordSys && targetCoordSys.master) targetCoordSys = targetCoordSys.master;
    var blurredSeries = [];
    ecModel.eachSeries(function(seriesModel) {
        var sameSeries = targetSeriesModel === seriesModel;
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.master) coordSys = coordSys.master;
        var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries; // If there is no coordinate system. use sameSeries instead.
        if (!// Not blur other series if blurScope series
        (blurScope === "series" && !sameSeries || blurScope === "coordinateSystem" && !sameCoordSys || focus === "series" && sameSeries)) {
            var view = api.getViewOfSeriesModel(seriesModel);
            view.group.traverse(function(child) {
                // For the elements that have been triggered by other components,
                // and are still required to be highlighted,
                // because the current is directly forced to blur the element,
                // it will cause the focus self to be unable to highlight, so skip the blur of this element.
                if (child.__highByOuter && sameSeries && focus === "self") return;
                $2bf82c0980125b62$var$singleEnterBlur(child);
            });
            if ((0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(focus)) leaveBlurOfIndices(seriesModel.getData(), focus);
            else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(focus)) {
                var dataTypes = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(focus);
                for(var d = 0; d < dataTypes.length; d++)leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
            }
            blurredSeries.push(seriesModel);
            $2bf82c0980125b62$var$getComponentStates(seriesModel).isBlured = true;
        }
    });
    ecModel.eachComponent(function(componentType, componentModel) {
        if (componentType === "series") return;
        var view = api.getViewOfComponentModel(componentModel);
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(blurredSeries, true, ecModel);
    });
}
function $2bf82c0980125b62$export$569da03256c8a55f(componentMainType, componentIndex, api) {
    if (componentMainType == null || componentIndex == null) return;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return;
    $2bf82c0980125b62$var$getComponentStates(componentModel).isBlured = true;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.focusBlurEnabled) return;
    view.group.traverse(function(child) {
        $2bf82c0980125b62$var$singleEnterBlur(child);
    });
}
function $2bf82c0980125b62$export$64f1fd4daefef21b(seriesModel, payload, api) {
    var seriesIndex = seriesModel.seriesIndex;
    var data = seriesModel.getData(payload.dataType);
    if (!data) return;
    var dataIndex = (0, $76d619f648247e6d$export$42b26cae8b8d10)(data, payload);
    // Pick the first one if there is multiple/none exists.
    dataIndex = ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dataIndex) ? dataIndex[0] : dataIndex) || 0;
    var el = data.getItemGraphicEl(dataIndex);
    if (!el) {
        var count = data.count();
        var current = 0;
        // If data on dataIndex is NaN.
        while(!el && current < count)el = data.getItemGraphicEl(current++);
    }
    if (el) {
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
        $2bf82c0980125b62$export$7d399e067d6552e3(seriesIndex, ecData.focus, ecData.blurScope, api);
    } else {
        // If there is no element put on the data. Try getting it from raw option
        // TODO Should put it on seriesModel?
        var focus_1 = seriesModel.get([
            "emphasis",
            "focus"
        ]);
        var blurScope = seriesModel.get([
            "emphasis",
            "blurScope"
        ]);
        if (focus_1 != null) $2bf82c0980125b62$export$7d399e067d6552e3(seriesIndex, focus_1, blurScope, api);
    }
}
function $2bf82c0980125b62$export$f31a644ccca0ef23(componentMainType, componentIndex, name, api) {
    var ret = {
        focusSelf: false,
        dispatchers: null
    };
    if (componentMainType == null || componentMainType === "series" || componentIndex == null || name == null) return ret;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return ret;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.findHighDownDispatchers) return ret;
    var dispatchers = view.findHighDownDispatchers(name);
    // At presnet, the component (like Geo) only blur inside itself.
    // So we do not use `blurScope` in component.
    var focusSelf;
    for(var i = 0; i < dispatchers.length; i++)if ((0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatchers[i]).focus === "self") {
        focusSelf = true;
        break;
    }
    return {
        focusSelf: focusSelf,
        dispatchers: dispatchers
    };
}
function $2bf82c0980125b62$export$416765b6198234ff(dispatcher, e, api) {
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatcher);
    var _a = $2bf82c0980125b62$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api), dispatchers = _a.dispatchers, focusSelf = _a.focusSelf;
    // If `findHighDownDispatchers` is supported on the component,
    // highlight/downplay elements with the same name.
    if (dispatchers) {
        if (focusSelf) $2bf82c0980125b62$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
            return $2bf82c0980125b62$export$d899507e2598e4ae(dispatcher, e);
        });
    } else {
        // Try blur all in the related series. Then emphasis the hoverred.
        // TODO. progressive mode.
        $2bf82c0980125b62$export$7d399e067d6552e3(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);
        if (ecData.focus === "self") $2bf82c0980125b62$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        // Other than series, component that not support `findHighDownDispatcher` will
        // also use it. But in this case, highlight/downplay are only supported in
        // mouse hover but not in dispatchAction.
        $2bf82c0980125b62$export$d899507e2598e4ae(dispatcher, e);
    }
}
function $2bf82c0980125b62$export$bb1c7b62436282a(dispatcher, e, api) {
    $2bf82c0980125b62$export$b2a593c7b5243584(api);
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatcher);
    var dispatchers = $2bf82c0980125b62$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;
    if (dispatchers) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
        return $2bf82c0980125b62$export$784cba1f7fe58cca(dispatcher, e);
    });
    else $2bf82c0980125b62$export$784cba1f7fe58cca(dispatcher, e);
}
function $2bf82c0980125b62$export$1c7d489f62372d73(seriesModel, payload, api) {
    if (!$2bf82c0980125b62$export$72aea10e60e45351(payload)) return;
    var dataType = payload.dataType;
    var data = seriesModel.getData(dataType);
    var dataIndex = (0, $76d619f648247e6d$export$42b26cae8b8d10)(data, payload);
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dataIndex)) dataIndex = [
        dataIndex
    ];
    seriesModel[payload.type === $2bf82c0980125b62$export$1e90ed8a25542516 ? "toggleSelect" : payload.type === $2bf82c0980125b62$export$89616263e7d38fe9 ? "select" : "unselect"](dataIndex, dataType);
}
function $2bf82c0980125b62$export$e4ea08ef52e0a73(seriesModel) {
    var allData = seriesModel.getAllData();
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(allData, function(_a) {
        var data = _a.data, type = _a.type;
        data.eachItemGraphicEl(function(el, idx) {
            seriesModel.isSelected(idx, type) ? $2bf82c0980125b62$export$252d028dda8ef765(el) : $2bf82c0980125b62$export$ea9a904bd6e32bd3(el);
        });
    });
}
function $2bf82c0980125b62$export$c529643b619af6b3(ecModel) {
    var ret = [];
    ecModel.eachSeries(function(seriesModel) {
        var allData = seriesModel.getAllData();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(allData, function(_a) {
            var data = _a.data, type = _a.type;
            var dataIndices = seriesModel.getSelectedDataIndices();
            if (dataIndices.length > 0) {
                var item = {
                    dataIndex: dataIndices,
                    seriesIndex: seriesModel.seriesIndex
                };
                if (type != null) item.dataType = type;
                ret.push(item);
            }
        });
    });
    return ret;
}
function $2bf82c0980125b62$export$5f393df0b5aee2e7(el, focus, blurScope) {
    $2bf82c0980125b62$export$9ba15aea1e048d48(el, true);
    $2bf82c0980125b62$var$traverseUpdateState(el, $2bf82c0980125b62$export$20f39bbe322fb9ab);
    $2bf82c0980125b62$export$24972466b2b62ac2(el, focus, blurScope);
}
function $2bf82c0980125b62$export$912cae7b47c8e437(el) {
    $2bf82c0980125b62$export$9ba15aea1e048d48(el, false);
}
function $2bf82c0980125b62$export$e51187539ff11209(el, focus, blurScope, isDisabled) {
    isDisabled ? $2bf82c0980125b62$export$912cae7b47c8e437(el) : $2bf82c0980125b62$export$5f393df0b5aee2e7(el, focus, blurScope);
}
function $2bf82c0980125b62$export$24972466b2b62ac2(el, focus, blurScope) {
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
    if (focus != null) {
        // TODO dataIndex may be set after this function. This check is not useful.
        // if (ecData.dataIndex == null) {
        //     if (__DEV__) {
        //         console.warn('focus can only been set on element with dataIndex');
        //     }
        // }
        // else {
        ecData.focus = focus;
        ecData.blurScope = blurScope;
    // }
    } else if (ecData.focus) ecData.focus = null;
}
var $2bf82c0980125b62$var$OTHER_STATES = [
    "emphasis",
    "blur",
    "select"
];
var $2bf82c0980125b62$var$defaultStyleGetterMap = {
    itemStyle: "getItemStyle",
    lineStyle: "getLineStyle",
    areaStyle: "getAreaStyle"
};
function $2bf82c0980125b62$export$48b68047d330bbc9(el, itemModel, styleType, // default itemStyle
getter) {
    styleType = styleType || "itemStyle";
    for(var i = 0; i < $2bf82c0980125b62$var$OTHER_STATES.length; i++){
        var stateName = $2bf82c0980125b62$var$OTHER_STATES[i];
        var model = itemModel.getModel([
            stateName,
            styleType
        ]);
        var state = el.ensureState(stateName);
        // Let it throw error if getterType is not found.
        state.style = getter ? getter(model) : model[$2bf82c0980125b62$var$defaultStyleGetterMap[styleType]]();
    }
}
function $2bf82c0980125b62$export$9ba15aea1e048d48(el, asDispatcher) {
    var disable = asDispatcher === false;
    var extendedEl = el;
    // Make `highDownSilentOnTouch` and `onStateChange` only work after
    // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
    if (el.highDownSilentOnTouch) extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
    // Simple optimize, since this method might be
    // called for each elements of a group in some cases.
    if (!disable || extendedEl.__highDownDispatcher) {
        // Emphasis, normal can be triggered manually by API or other components like hover link.
        // el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent);
        // Also keep previous record.
        extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
        extendedEl.__highDownDispatcher = !disable;
    }
}
function $2bf82c0980125b62$export$77d1445f699c58b5(el) {
    return !!(el && el.__highDownDispatcher);
}
function $2bf82c0980125b62$export$4da05a9639f01954(el, componentModel, componentHighDownName) {
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
    ecData.componentMainType = componentModel.mainType;
    ecData.componentIndex = componentModel.componentIndex;
    ecData.componentHighDownName = componentHighDownName;
}
function $2bf82c0980125b62$export$824af40eb714530d(highlightKey) {
    var highlightDigit = $2bf82c0980125b62$var$_highlightKeyMap[highlightKey];
    if (highlightDigit == null && $2bf82c0980125b62$var$_highlightNextDigit <= 32) highlightDigit = $2bf82c0980125b62$var$_highlightKeyMap[highlightKey] = $2bf82c0980125b62$var$_highlightNextDigit++;
    return highlightDigit;
}
function $2bf82c0980125b62$export$72aea10e60e45351(payload) {
    var payloadType = payload.type;
    return payloadType === $2bf82c0980125b62$export$89616263e7d38fe9 || payloadType === $2bf82c0980125b62$export$7636ad95c0f68a79 || payloadType === $2bf82c0980125b62$export$1e90ed8a25542516;
}
function $2bf82c0980125b62$export$aebe71265c1b77bf(payload) {
    var payloadType = payload.type;
    return payloadType === $2bf82c0980125b62$export$df035d873a9de64f || payloadType === $2bf82c0980125b62$export$f8a2f7807cc185ea;
}
function $2bf82c0980125b62$export$9fe78019e6f395b6(el) {
    var store = $2bf82c0980125b62$var$getSavedStates(el);
    store.normalFill = el.style.fill;
    store.normalStroke = el.style.stroke;
    var selectState = el.states.select || {};
    store.selectFill = selectState.style && selectState.style.fill || null;
    store.selectStroke = selectState.style && selectState.style.stroke || null;
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $8b353638fbedfefa$export$ae7433df314f6ec3 = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $8b353638fbedfefa$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, // Extra opts can override the option in animatable model.
extraOpts, // TODO It's only for pictorial bar now.
extraDelayParams) {
    var animationPayload;
    // Check if there is global animation configuration from dataZoom/resize can override the config in option.
    // If animation is enabled. Will use this animation config in payload.
    // If animation is disabled. Just ignore it.
    if (animatableModel && animatableModel.ecModel) {
        var updatePayload = animatableModel.ecModel.getUpdatePayload();
        animationPayload = updatePayload && updatePayload.animation;
    }
    var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
    var isUpdate = animationType === "update";
    if (animationEnabled) {
        var duration = void 0;
        var easing = void 0;
        var delay = void 0;
        if (extraOpts) {
            duration = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(extraOpts.duration, 200);
            easing = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(extraOpts.easing, "cubicOut");
            delay = 0;
        } else {
            duration = animatableModel.getShallow(isUpdate ? "animationDurationUpdate" : "animationDuration");
            easing = animatableModel.getShallow(isUpdate ? "animationEasingUpdate" : "animationEasing");
            delay = animatableModel.getShallow(isUpdate ? "animationDelayUpdate" : "animationDelay");
        }
        // animation from payload has highest priority.
        if (animationPayload) {
            animationPayload.duration != null && (duration = animationPayload.duration);
            animationPayload.easing != null && (easing = animationPayload.easing);
            animationPayload.delay != null && (delay = animationPayload.delay);
        }
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(delay)) delay = delay(dataIndex, extraDelayParams);
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(duration)) duration = duration(dataIndex);
        var config = {
            duration: duration || 0,
            delay: delay,
            easing: easing
        };
        return config;
    } else return null;
}
function $8b353638fbedfefa$var$animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
    var isFrom = false;
    var removeOpt;
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(dataIndex)) {
        during = cb;
        cb = dataIndex;
        dataIndex = null;
    } else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dataIndex)) {
        cb = dataIndex.cb;
        during = dataIndex.during;
        isFrom = dataIndex.isFrom;
        removeOpt = dataIndex.removeOpt;
        dataIndex = dataIndex.dataIndex;
    }
    var isRemove = animationType === "leave";
    if (!isRemove) // Must stop the remove animation.
    el.stopAnimation("leave");
    var animationConfig = $8b353638fbedfefa$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
    if (animationConfig && animationConfig.duration > 0) {
        var duration = animationConfig.duration;
        var animationDelay = animationConfig.delay;
        var animationEasing = animationConfig.easing;
        var animateConfig = {
            duration: duration,
            delay: animationDelay || 0,
            easing: animationEasing,
            done: cb,
            force: !!cb || !!during,
            // Set to final state in update/init animation.
            // So the post processing based on the path shape can be done correctly.
            setToFinal: !isRemove,
            scope: animationType,
            during: during
        };
        isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
    } else {
        el.stopAnimation();
        // If `isFrom`, the props is the "from" props.
        !isFrom && el.attr(props);
        // Call during at least once.
        during && during(1);
        cb && cb();
    }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */ function $8b353638fbedfefa$export$c8dce3c08436e91e(el, props, // TODO: TYPE AnimatableModel
animatableModel, dataIndex, cb, during) {
    $8b353638fbedfefa$var$animateOrSetProps("update", el, props, animatableModel, dataIndex, cb, during);
}
function $8b353638fbedfefa$export$a121566aadcfe021(el, props, animatableModel, dataIndex, cb, during) {
    $8b353638fbedfefa$var$animateOrSetProps("enter", el, props, animatableModel, dataIndex, cb, during);
}
function $8b353638fbedfefa$export$5b89d4b643713034(el) {
    if (!el.__zr) return true;
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.scope === "leave") return true;
    }
    return false;
}
function $8b353638fbedfefa$export$f883456a56996078(el, props, animatableModel, dataIndex, cb, during) {
    // Don't do remove animation twice.
    if ($8b353638fbedfefa$export$5b89d4b643713034(el)) return;
    $8b353638fbedfefa$var$animateOrSetProps("leave", el, props, animatableModel, dataIndex, cb, during);
}
function $8b353638fbedfefa$var$fadeOutDisplayable(el, animatableModel, dataIndex, done) {
    el.removeTextContent();
    el.removeTextGuideLine();
    $8b353638fbedfefa$export$f883456a56996078(el, {
        style: {
            opacity: 0
        }
    }, animatableModel, dataIndex, done);
}
function $8b353638fbedfefa$export$6d0fd725cb4aee8a(el, animatableModel, dataIndex) {
    function doRemove() {
        el.parent && el.parent.remove(el);
    }
    // Hide label and labelLine first
    // TODO Also use fade out animation?
    if (!el.isGroup) $8b353638fbedfefa$var$fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
    else el.traverse(function(disp) {
        if (!disp.isGroup) // Can invoke doRemove multiple times.
        $8b353638fbedfefa$var$fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
    });
}
function $8b353638fbedfefa$export$bca7290a9faf0ec9(el) {
    $8b353638fbedfefa$export$ae7433df314f6ec3(el).oldStyle = el.style;
}
function $8b353638fbedfefa$export$ccb1f1e4d2fa86ac(el) {
    return $8b353638fbedfefa$export$ae7433df314f6ec3(el).oldStyle;
}

var $5b455ae6f843ac47$exports = {};

$parcel$export($5b455ae6f843ac47$exports, "extendShape", () => $5b455ae6f843ac47$export$d0d5398c9d612037);
$parcel$export($5b455ae6f843ac47$exports, "extendPath", () => $5b455ae6f843ac47$export$53b54a3137026af0);
$parcel$export($5b455ae6f843ac47$exports, "registerShape", () => $5b455ae6f843ac47$export$2b95b62e3aaf6fdd);
$parcel$export($5b455ae6f843ac47$exports, "getShapeClass", () => $5b455ae6f843ac47$export$51df4b5565a58189);
$parcel$export($5b455ae6f843ac47$exports, "makePath", () => $5b455ae6f843ac47$export$aa9bab72412f5613);
$parcel$export($5b455ae6f843ac47$exports, "resizePath", () => $5b455ae6f843ac47$export$566dbf1c62b04fc7);
$parcel$export($5b455ae6f843ac47$exports, "makeImage", () => $5b455ae6f843ac47$export$7a2bdede98851ac5);
$parcel$export($5b455ae6f843ac47$exports, "mergePath", () => $5b455ae6f843ac47$export$7b1dd269fbc4e903);
$parcel$export($5b455ae6f843ac47$exports, "subPixelOptimizeLine", () => $5b455ae6f843ac47$export$8b4b620d7f4aad1b);
$parcel$export($5b455ae6f843ac47$exports, "subPixelOptimizeRect", () => $5b455ae6f843ac47$export$60e2aa74957d0b9d);
$parcel$export($5b455ae6f843ac47$exports, "subPixelOptimize", () => $5b455ae6f843ac47$export$72c4fd4c1b8fcb10);
$parcel$export($5b455ae6f843ac47$exports, "getTransform", () => $5b455ae6f843ac47$export$fce0c6cfca85ed96);
$parcel$export($5b455ae6f843ac47$exports, "applyTransform", () => $5b455ae6f843ac47$export$9f9dcb98c894b623);
$parcel$export($5b455ae6f843ac47$exports, "transformDirection", () => $5b455ae6f843ac47$export$fff94e9792354cfa);
$parcel$export($5b455ae6f843ac47$exports, "groupTransition", () => $5b455ae6f843ac47$export$64fcab7860c216ae);
$parcel$export($5b455ae6f843ac47$exports, "clipPointsByRect", () => $5b455ae6f843ac47$export$e2f409471bbbc1dc);
$parcel$export($5b455ae6f843ac47$exports, "clipRectByRect", () => $5b455ae6f843ac47$export$d0d3709202b8b2a);
$parcel$export($5b455ae6f843ac47$exports, "createIcon", () => $5b455ae6f843ac47$export$274edc73af1ae9c8);
$parcel$export($5b455ae6f843ac47$exports, "linePolygonIntersect", () => $5b455ae6f843ac47$export$4f47c855a5e9ae9);
$parcel$export($5b455ae6f843ac47$exports, "lineLineIntersect", () => $5b455ae6f843ac47$export$6c0a70ea1d8d158b);
$parcel$export($5b455ae6f843ac47$exports, "setTooltipConfig", () => $5b455ae6f843ac47$export$fc6410d97fab306c);
$parcel$export($5b455ae6f843ac47$exports, "traverseElements", () => $5b455ae6f843ac47$export$3e564442729bf048);
$parcel$export($5b455ae6f843ac47$exports, "updateProps", () => $8b353638fbedfefa$export$c8dce3c08436e91e);
$parcel$export($5b455ae6f843ac47$exports, "initProps", () => $8b353638fbedfefa$export$a121566aadcfe021);
$parcel$export($5b455ae6f843ac47$exports, "removeElement", () => $8b353638fbedfefa$export$f883456a56996078);
$parcel$export($5b455ae6f843ac47$exports, "removeElementWithFadeOut", () => $8b353638fbedfefa$export$6d0fd725cb4aee8a);
$parcel$export($5b455ae6f843ac47$exports, "isElementRemoved", () => $8b353638fbedfefa$export$5b89d4b643713034);
$parcel$export($5b455ae6f843ac47$exports, "Group", () => $7ef7583d8302ffce$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Image", () => $86adec94217b86c6$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Text", () => $fe885cc21795562b$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Circle", () => $1e68d8727773abb7$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Ellipse", () => $4a809f055a7e524c$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Sector", () => $a3e1dec0a3875b49$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Ring", () => $9da0cbfd3f86fdc1$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Polygon", () => $51acf033123e1a30$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Polyline", () => $d28119f30e6bb670$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Rect", () => $419e5ff2f303755e$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Line", () => $7a316ae5ceff7b27$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "BezierCurve", () => $6c7800c49630e431$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Arc", () => $2b5c23eb3597b84a$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "IncrementalDisplayable", () => $ee829f116f003981$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "CompoundPath", () => $e152f3dbf8fba6e2$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "LinearGradient", () => $cf44c01491b58e53$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "RadialGradient", () => $cd2ee2ba32bb26c3$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "BoundingRect", () => $1bebe7106c895823$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "OrientedBoundingRect", () => $f9793b4d8aade116$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Point", () => $b887f038f104fe7e$export$2e2bcd8739ae039);
$parcel$export($5b455ae6f843ac47$exports, "Path", () => $b02ffe7acd508c08$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $07911aacc70e67cc$var$CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
var $07911aacc70e67cc$var$points = [
    [],
    [],
    []
];
var $07911aacc70e67cc$var$mathSqrt = Math.sqrt;
var $07911aacc70e67cc$var$mathAtan2 = Math.atan2;
function $07911aacc70e67cc$export$2e2bcd8739ae039(path, m) {
    if (!m) return;
    var data = path.data;
    var len = path.len();
    var cmd;
    var nPoint;
    var i;
    var j;
    var k;
    var p;
    var M = $07911aacc70e67cc$var$CMD.M;
    var C = $07911aacc70e67cc$var$CMD.C;
    var L = $07911aacc70e67cc$var$CMD.L;
    var R = $07911aacc70e67cc$var$CMD.R;
    var A = $07911aacc70e67cc$var$CMD.A;
    var Q = $07911aacc70e67cc$var$CMD.Q;
    for(i = 0, j = 0; i < len;){
        cmd = data[i++];
        j = i;
        nPoint = 0;
        switch(cmd){
            case M:
                nPoint = 1;
                break;
            case L:
                nPoint = 1;
                break;
            case C:
                nPoint = 3;
                break;
            case Q:
                nPoint = 2;
                break;
            case A:
                var x = m[4];
                var y = m[5];
                var sx = $07911aacc70e67cc$var$mathSqrt(m[0] * m[0] + m[1] * m[1]);
                var sy = $07911aacc70e67cc$var$mathSqrt(m[2] * m[2] + m[3] * m[3]);
                var angle = $07911aacc70e67cc$var$mathAtan2(-m[1] / sy, m[0] / sx);
                data[i] *= sx;
                data[i++] += x;
                data[i] *= sy;
                data[i++] += y;
                data[i++] *= sx;
                data[i++] *= sy;
                data[i++] += angle;
                data[i++] += angle;
                i += 2;
                j = i;
                break;
            case R:
                p[0] = data[i++];
                p[1] = data[i++];
                (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
                p[0] += data[i++];
                p[1] += data[i++];
                (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
        }
        for(k = 0; k < nPoint; k++){
            var p_1 = $07911aacc70e67cc$var$points[k];
            p_1[0] = data[i++];
            p_1[1] = data[i++];
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(p_1, p_1, m);
            data[j++] = p_1[0];
            data[j++] = p_1[1];
        }
    }
    path.increaseVersion();
}



var $15b38920672b9006$var$mathSqrt = Math.sqrt;
var $15b38920672b9006$var$mathSin = Math.sin;
var $15b38920672b9006$var$mathCos = Math.cos;
var $15b38920672b9006$var$PI = Math.PI;
function $15b38920672b9006$var$vMag(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
}
function $15b38920672b9006$var$vRatio(u, v) {
    return (u[0] * v[0] + u[1] * v[1]) / ($15b38920672b9006$var$vMag(u) * $15b38920672b9006$var$vMag(v));
}
function $15b38920672b9006$var$vAngle(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos($15b38920672b9006$var$vRatio(u, v));
}
function $15b38920672b9006$var$processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
    var psi = psiDeg * ($15b38920672b9006$var$PI / 180.0);
    var xp = $15b38920672b9006$var$mathCos(psi) * (x1 - x2) / 2.0 + $15b38920672b9006$var$mathSin(psi) * (y1 - y2) / 2.0;
    var yp = -1 * $15b38920672b9006$var$mathSin(psi) * (x1 - x2) / 2.0 + $15b38920672b9006$var$mathCos(psi) * (y1 - y2) / 2.0;
    var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
    if (lambda > 1) {
        rx *= $15b38920672b9006$var$mathSqrt(lambda);
        ry *= $15b38920672b9006$var$mathSqrt(lambda);
    }
    var f = (fa === fs ? -1 : 1) * $15b38920672b9006$var$mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
    var cxp = f * rx * yp / ry;
    var cyp = f * -ry * xp / rx;
    var cx = (x1 + x2) / 2.0 + $15b38920672b9006$var$mathCos(psi) * cxp - $15b38920672b9006$var$mathSin(psi) * cyp;
    var cy = (y1 + y2) / 2.0 + $15b38920672b9006$var$mathSin(psi) * cxp + $15b38920672b9006$var$mathCos(psi) * cyp;
    var theta = $15b38920672b9006$var$vAngle([
        1,
        0
    ], [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ]);
    var u = [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ];
    var v = [
        (-1 * xp - cxp) / rx,
        (-1 * yp - cyp) / ry
    ];
    var dTheta = $15b38920672b9006$var$vAngle(u, v);
    if ($15b38920672b9006$var$vRatio(u, v) <= -1) dTheta = $15b38920672b9006$var$PI;
    if ($15b38920672b9006$var$vRatio(u, v) >= 1) dTheta = 0;
    if (dTheta < 0) {
        var n = Math.round(dTheta / $15b38920672b9006$var$PI * 1e6) / 1e6;
        dTheta = $15b38920672b9006$var$PI * 2 + n % 2 * $15b38920672b9006$var$PI;
    }
    path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}
var $15b38920672b9006$var$commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
var $15b38920672b9006$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $15b38920672b9006$var$createPathProxyFromString(data) {
    var path = new (0, $20ebe2448f123f2e$export$2e2bcd8739ae039)();
    if (!data) return path;
    var cpx = 0;
    var cpy = 0;
    var subpathX = cpx;
    var subpathY = cpy;
    var prevCmd;
    var CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
    var cmdList = data.match($15b38920672b9006$var$commandReg);
    if (!cmdList) return path;
    for(var l = 0; l < cmdList.length; l++){
        var cmdText = cmdList[l];
        var cmdStr = cmdText.charAt(0);
        var cmd = void 0;
        var p = cmdText.match($15b38920672b9006$var$numberReg) || [];
        var pLen = p.length;
        for(var i = 0; i < pLen; i++)p[i] = parseFloat(p[i]);
        var off = 0;
        while(off < pLen){
            var ctlPtx = void 0;
            var ctlPty = void 0;
            var rx = void 0;
            var ry = void 0;
            var psi = void 0;
            var fa = void 0;
            var fs = void 0;
            var x1 = cpx;
            var y1 = cpy;
            var len = void 0;
            var pathData = void 0;
            switch(cmdStr){
                case "l":
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "L":
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "m":
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = "l";
                    break;
                case "M":
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = "L";
                    break;
                case "h":
                    cpx += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "H":
                    cpx = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "v":
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "V":
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case "C":
                    cmd = CMD.C;
                    path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                    cpx = p[off - 2];
                    cpy = p[off - 1];
                    break;
                case "c":
                    cmd = CMD.C;
                    path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                    cpx += p[off - 2];
                    cpy += p[off - 1];
                    break;
                case "S":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case "s":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = cpx + p[off++];
                    y1 = cpy + p[off++];
                    cpx += p[off++];
                    cpy += p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case "Q":
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case "q":
                    x1 = p[off++] + cpx;
                    y1 = p[off++] + cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case "T":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case "t":
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case "A":
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.A;
                    $15b38920672b9006$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
                case "a":
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.A;
                    $15b38920672b9006$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
            }
        }
        if (cmdStr === "z" || cmdStr === "Z") {
            cmd = CMD.Z;
            path.addData(cmd);
            cpx = subpathX;
            cpy = subpathY;
        }
        prevCmd = cmd;
    }
    path.toStatic();
    return path;
}
var $15b38920672b9006$var$SVGPath = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(SVGPath, _super);
    function SVGPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGPath.prototype.applyTransform = function(m) {};
    return SVGPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $15b38920672b9006$var$isPathProxy(path) {
    return path.setData != null;
}
function $15b38920672b9006$var$createPathOptions(str, opts) {
    var pathProxy = $15b38920672b9006$var$createPathProxyFromString(str);
    var innerOpts = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, opts);
    innerOpts.buildPath = function(path) {
        if ($15b38920672b9006$var$isPathProxy(path)) {
            path.setData(pathProxy.data);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        } else {
            var ctx = path;
            pathProxy.rebuildPath(ctx, 1);
        }
    };
    innerOpts.applyTransform = function(m) {
        (0, $07911aacc70e67cc$export$2e2bcd8739ae039)(pathProxy, m);
        this.dirtyShape();
    };
    return innerOpts;
}
function $15b38920672b9006$export$ae5b259626f00aeb(str, opts) {
    return new $15b38920672b9006$var$SVGPath($15b38920672b9006$var$createPathOptions(str, opts));
}
function $15b38920672b9006$export$68e3a51ba2ed417c(str, defaultOpts) {
    var innerOpts = $15b38920672b9006$var$createPathOptions(str, defaultOpts);
    var Sub = function(_super) {
        (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Sub, _super);
        function Sub(opts) {
            var _this = _super.call(this, opts) || this;
            _this.applyTransform = innerOpts.applyTransform;
            _this.buildPath = innerOpts.buildPath;
            return _this;
        }
        return Sub;
    }($15b38920672b9006$var$SVGPath);
    return Sub;
}
function $15b38920672b9006$export$7b1dd269fbc4e903(pathEls, opts) {
    var pathList = [];
    var len = pathEls.length;
    for(var i = 0; i < len; i++){
        var pathEl = pathEls[i];
        pathList.push(pathEl.getUpdatedPathProxy(true));
    }
    var pathBundle = new (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)(opts);
    pathBundle.createPathProxy();
    pathBundle.buildPath = function(path) {
        if ($15b38920672b9006$var$isPathProxy(path)) {
            path.appendPath(pathList);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        }
    };
    return pathBundle;
}
function $15b38920672b9006$export$18711d956bf1c3eb(sourcePath, opts) {
    opts = opts || {};
    var path = new (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)();
    if (sourcePath.shape) path.setShape(sourcePath.shape);
    path.setStyle(sourcePath.style);
    if (opts.bakeTransform) (0, $07911aacc70e67cc$export$2e2bcd8739ae039)(path.path, sourcePath.getComputedTransform());
    else if (opts.toLocal) path.setLocalTransform(sourcePath.getComputedTransform());
    else path.copyTransform(sourcePath);
    path.buildPath = sourcePath.buildPath;
    path.applyTransform = path.applyTransform;
    path.z = sourcePath.z;
    path.z2 = sourcePath.z2;
    path.zlevel = sourcePath.zlevel;
    return path;
}











var $1e68d8727773abb7$export$2c0b65c9c7b57845 = function() {
    function CircleShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
    }
    return CircleShape;
}();
var $1e68d8727773abb7$var$Circle = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Circle, _super);
    function Circle(opts) {
        return _super.call(this, opts) || this;
    }
    Circle.prototype.getDefaultShape = function() {
        return new $1e68d8727773abb7$export$2c0b65c9c7b57845();
    };
    Circle.prototype.buildPath = function(ctx, shape) {
        ctx.moveTo(shape.cx + shape.r, shape.cy);
        ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
    };
    return Circle;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$1e68d8727773abb7$var$Circle.prototype.type = "circle";
var $1e68d8727773abb7$export$2e2bcd8739ae039 = $1e68d8727773abb7$var$Circle;




var $4a809f055a7e524c$export$817919dfe2806d31 = function() {
    function EllipseShape() {
        this.cx = 0;
        this.cy = 0;
        this.rx = 0;
        this.ry = 0;
    }
    return EllipseShape;
}();
var $4a809f055a7e524c$var$Ellipse = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Ellipse, _super);
    function Ellipse(opts) {
        return _super.call(this, opts) || this;
    }
    Ellipse.prototype.getDefaultShape = function() {
        return new $4a809f055a7e524c$export$817919dfe2806d31();
    };
    Ellipse.prototype.buildPath = function(ctx, shape) {
        var k = 0.5522848;
        var x = shape.cx;
        var y = shape.cy;
        var a = shape.rx;
        var b = shape.ry;
        var ox = a * k;
        var oy = b * k;
        ctx.moveTo(x - a, y);
        ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
        ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
        ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
        ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
        ctx.closePath();
    };
    return Ellipse;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$4a809f055a7e524c$var$Ellipse.prototype.type = "ellipse";
var $4a809f055a7e524c$export$2e2bcd8739ae039 = $4a809f055a7e524c$var$Ellipse;





var $a2aa1e91473aa9ab$var$PI = Math.PI;
var $a2aa1e91473aa9ab$var$PI2 = $a2aa1e91473aa9ab$var$PI * 2;
var $a2aa1e91473aa9ab$var$mathSin = Math.sin;
var $a2aa1e91473aa9ab$var$mathCos = Math.cos;
var $a2aa1e91473aa9ab$var$mathACos = Math.acos;
var $a2aa1e91473aa9ab$var$mathATan2 = Math.atan2;
var $a2aa1e91473aa9ab$var$mathAbs = Math.abs;
var $a2aa1e91473aa9ab$var$mathSqrt = Math.sqrt;
var $a2aa1e91473aa9ab$var$mathMax = Math.max;
var $a2aa1e91473aa9ab$var$mathMin = Math.min;
var $a2aa1e91473aa9ab$var$e = 1e-4;
function $a2aa1e91473aa9ab$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var dx10 = x1 - x0;
    var dy10 = y1 - y0;
    var dx32 = x3 - x2;
    var dy32 = y3 - y2;
    var t = dy32 * dx10 - dx32 * dy10;
    if (t * t < $a2aa1e91473aa9ab$var$e) return;
    t = (dx32 * (y0 - y2) - dy32 * (x0 - x2)) / t;
    return [
        x0 + t * dx10,
        y0 + t * dy10
    ];
}
function $a2aa1e91473aa9ab$var$computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
    var x01 = x0 - x1;
    var y01 = y0 - y1;
    var lo = (clockwise ? cr : -cr) / $a2aa1e91473aa9ab$var$mathSqrt(x01 * x01 + y01 * y01);
    var ox = lo * y01;
    var oy = -lo * x01;
    var x11 = x0 + ox;
    var y11 = y0 + oy;
    var x10 = x1 + ox;
    var y10 = y1 + oy;
    var x00 = (x11 + x10) / 2;
    var y00 = (y11 + y10) / 2;
    var dx = x10 - x11;
    var dy = y10 - y11;
    var d2 = dx * dx + dy * dy;
    var r = radius - cr;
    var s = x11 * y10 - x10 * y11;
    var d = (dy < 0 ? -1 : 1) * $a2aa1e91473aa9ab$var$mathSqrt($a2aa1e91473aa9ab$var$mathMax(0, r * r * d2 - s * s));
    var cx0 = (s * dy - dx * d) / d2;
    var cy0 = (-s * dx - dy * d) / d2;
    var cx1 = (s * dy + dx * d) / d2;
    var cy1 = (-s * dx + dy * d) / d2;
    var dx0 = cx0 - x00;
    var dy0 = cy0 - y00;
    var dx1 = cx1 - x00;
    var dy1 = cy1 - y00;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
        cx0 = cx1;
        cy0 = cy1;
    }
    return {
        cx: cx0,
        cy: cy0,
        x0: -ox,
        y0: -oy,
        x1: cx0 * (radius / r - 1),
        y1: cy0 * (radius / r - 1)
    };
}
function $a2aa1e91473aa9ab$var$normalizeCornerRadius(cr) {
    var arr;
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(cr)) {
        var len = cr.length;
        if (!len) return cr;
        if (len === 1) arr = [
            cr[0],
            cr[0],
            0,
            0
        ];
        else if (len === 2) arr = [
            cr[0],
            cr[0],
            cr[1],
            cr[1]
        ];
        else if (len === 3) arr = cr.concat(cr[2]);
        else arr = cr;
    } else arr = [
        cr,
        cr,
        cr,
        cr
    ];
    return arr;
}
function $a2aa1e91473aa9ab$export$5cc7f731b5937e99(ctx, shape) {
    var _a;
    var radius = $a2aa1e91473aa9ab$var$mathMax(shape.r, 0);
    var innerRadius = $a2aa1e91473aa9ab$var$mathMax(shape.r0 || 0, 0);
    var hasRadius = radius > 0;
    var hasInnerRadius = innerRadius > 0;
    if (!hasRadius && !hasInnerRadius) return;
    if (!hasRadius) {
        radius = innerRadius;
        innerRadius = 0;
    }
    if (innerRadius > radius) {
        var tmp = radius;
        radius = innerRadius;
        innerRadius = tmp;
    }
    var startAngle = shape.startAngle, endAngle = shape.endAngle;
    if (isNaN(startAngle) || isNaN(endAngle)) return;
    var cx = shape.cx, cy = shape.cy;
    var clockwise = !!shape.clockwise;
    var arc = $a2aa1e91473aa9ab$var$mathAbs(endAngle - startAngle);
    var mod = arc > $a2aa1e91473aa9ab$var$PI2 && arc % $a2aa1e91473aa9ab$var$PI2;
    mod > $a2aa1e91473aa9ab$var$e && (arc = mod);
    if (!(radius > $a2aa1e91473aa9ab$var$e)) ctx.moveTo(cx, cy);
    else if (arc > $a2aa1e91473aa9ab$var$PI2 - $a2aa1e91473aa9ab$var$e) {
        ctx.moveTo(cx + radius * $a2aa1e91473aa9ab$var$mathCos(startAngle), cy + radius * $a2aa1e91473aa9ab$var$mathSin(startAngle));
        ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        if (innerRadius > $a2aa1e91473aa9ab$var$e) {
            ctx.moveTo(cx + innerRadius * $a2aa1e91473aa9ab$var$mathCos(endAngle), cy + innerRadius * $a2aa1e91473aa9ab$var$mathSin(endAngle));
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    } else {
        var icrStart = void 0;
        var icrEnd = void 0;
        var ocrStart = void 0;
        var ocrEnd = void 0;
        var ocrs = void 0;
        var ocre = void 0;
        var icrs = void 0;
        var icre = void 0;
        var ocrMax = void 0;
        var icrMax = void 0;
        var limitedOcrMax = void 0;
        var limitedIcrMax = void 0;
        var xre = void 0;
        var yre = void 0;
        var xirs = void 0;
        var yirs = void 0;
        var xrs = radius * $a2aa1e91473aa9ab$var$mathCos(startAngle);
        var yrs = radius * $a2aa1e91473aa9ab$var$mathSin(startAngle);
        var xire = innerRadius * $a2aa1e91473aa9ab$var$mathCos(endAngle);
        var yire = innerRadius * $a2aa1e91473aa9ab$var$mathSin(endAngle);
        var hasArc = arc > $a2aa1e91473aa9ab$var$e;
        if (hasArc) {
            var cornerRadius = shape.cornerRadius;
            if (cornerRadius) _a = $a2aa1e91473aa9ab$var$normalizeCornerRadius(cornerRadius), icrStart = _a[0], icrEnd = _a[1], ocrStart = _a[2], ocrEnd = _a[3];
            var halfRd = $a2aa1e91473aa9ab$var$mathAbs(radius - innerRadius) / 2;
            ocrs = $a2aa1e91473aa9ab$var$mathMin(halfRd, ocrStart);
            ocre = $a2aa1e91473aa9ab$var$mathMin(halfRd, ocrEnd);
            icrs = $a2aa1e91473aa9ab$var$mathMin(halfRd, icrStart);
            icre = $a2aa1e91473aa9ab$var$mathMin(halfRd, icrEnd);
            limitedOcrMax = ocrMax = $a2aa1e91473aa9ab$var$mathMax(ocrs, ocre);
            limitedIcrMax = icrMax = $a2aa1e91473aa9ab$var$mathMax(icrs, icre);
            if (ocrMax > $a2aa1e91473aa9ab$var$e || icrMax > $a2aa1e91473aa9ab$var$e) {
                xre = radius * $a2aa1e91473aa9ab$var$mathCos(endAngle);
                yre = radius * $a2aa1e91473aa9ab$var$mathSin(endAngle);
                xirs = innerRadius * $a2aa1e91473aa9ab$var$mathCos(startAngle);
                yirs = innerRadius * $a2aa1e91473aa9ab$var$mathSin(startAngle);
                if (arc < $a2aa1e91473aa9ab$var$PI) {
                    var it_1 = $a2aa1e91473aa9ab$var$intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                    if (it_1) {
                        var x0 = xrs - it_1[0];
                        var y0 = yrs - it_1[1];
                        var x1 = xre - it_1[0];
                        var y1 = yre - it_1[1];
                        var a = 1 / $a2aa1e91473aa9ab$var$mathSin($a2aa1e91473aa9ab$var$mathACos((x0 * x1 + y0 * y1) / ($a2aa1e91473aa9ab$var$mathSqrt(x0 * x0 + y0 * y0) * $a2aa1e91473aa9ab$var$mathSqrt(x1 * x1 + y1 * y1))) / 2);
                        var b = $a2aa1e91473aa9ab$var$mathSqrt(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
                        limitedOcrMax = $a2aa1e91473aa9ab$var$mathMin(ocrMax, (radius - b) / (a + 1));
                        limitedIcrMax = $a2aa1e91473aa9ab$var$mathMin(icrMax, (innerRadius - b) / (a - 1));
                    }
                }
            }
        }
        if (!hasArc) ctx.moveTo(cx + xrs, cy + yrs);
        else if (limitedOcrMax > $a2aa1e91473aa9ab$var$e) {
            var crStart = $a2aa1e91473aa9ab$var$mathMin(ocrStart, limitedOcrMax);
            var crEnd = $a2aa1e91473aa9ab$var$mathMin(ocrEnd, limitedOcrMax);
            var ct0 = $a2aa1e91473aa9ab$var$computeCornerTangents(xirs, yirs, xrs, yrs, radius, crStart, clockwise);
            var ct1 = $a2aa1e91473aa9ab$var$computeCornerTangents(xre, yre, xire, yire, radius, crEnd, clockwise);
            ctx.moveTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedOcrMax < ocrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedOcrMax, $a2aa1e91473aa9ab$var$mathATan2(ct0.y0, ct0.x0), $a2aa1e91473aa9ab$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crStart > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crStart, $a2aa1e91473aa9ab$var$mathATan2(ct0.y0, ct0.x0), $a2aa1e91473aa9ab$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, radius, $a2aa1e91473aa9ab$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $a2aa1e91473aa9ab$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), !clockwise);
                crEnd > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crEnd, $a2aa1e91473aa9ab$var$mathATan2(ct1.y1, ct1.x1), $a2aa1e91473aa9ab$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.moveTo(cx + xrs, cy + yrs);
            ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        }
        if (!(innerRadius > $a2aa1e91473aa9ab$var$e) || !hasArc) ctx.lineTo(cx + xire, cy + yire);
        else if (limitedIcrMax > $a2aa1e91473aa9ab$var$e) {
            var crStart = $a2aa1e91473aa9ab$var$mathMin(icrStart, limitedIcrMax);
            var crEnd = $a2aa1e91473aa9ab$var$mathMin(icrEnd, limitedIcrMax);
            var ct0 = $a2aa1e91473aa9ab$var$computeCornerTangents(xire, yire, xre, yre, innerRadius, -crEnd, clockwise);
            var ct1 = $a2aa1e91473aa9ab$var$computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -crStart, clockwise);
            ctx.lineTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedIcrMax < icrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedIcrMax, $a2aa1e91473aa9ab$var$mathATan2(ct0.y0, ct0.x0), $a2aa1e91473aa9ab$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crEnd > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crEnd, $a2aa1e91473aa9ab$var$mathATan2(ct0.y0, ct0.x0), $a2aa1e91473aa9ab$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, innerRadius, $a2aa1e91473aa9ab$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $a2aa1e91473aa9ab$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), clockwise);
                crStart > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crStart, $a2aa1e91473aa9ab$var$mathATan2(ct1.y1, ct1.x1), $a2aa1e91473aa9ab$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.lineTo(cx + xire, cy + yire);
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    }
    ctx.closePath();
}


var $a3e1dec0a3875b49$export$98af62de8a972c99 = function() {
    function SectorShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
        this.cornerRadius = 0;
    }
    return SectorShape;
}();
var $a3e1dec0a3875b49$var$Sector = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Sector, _super);
    function Sector(opts) {
        return _super.call(this, opts) || this;
    }
    Sector.prototype.getDefaultShape = function() {
        return new $a3e1dec0a3875b49$export$98af62de8a972c99();
    };
    Sector.prototype.buildPath = function(ctx, shape) {
        $a2aa1e91473aa9ab$export$5cc7f731b5937e99(ctx, shape);
    };
    Sector.prototype.isZeroArea = function() {
        return this.shape.startAngle === this.shape.endAngle || this.shape.r === this.shape.r0;
    };
    return Sector;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$a3e1dec0a3875b49$var$Sector.prototype.type = "sector";
var $a3e1dec0a3875b49$export$2e2bcd8739ae039 = $a3e1dec0a3875b49$var$Sector;




var $9da0cbfd3f86fdc1$export$4a506b3cd4ea73db = function() {
    function RingShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.r0 = 0;
    }
    return RingShape;
}();
var $9da0cbfd3f86fdc1$var$Ring = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Ring, _super);
    function Ring(opts) {
        return _super.call(this, opts) || this;
    }
    Ring.prototype.getDefaultShape = function() {
        return new $9da0cbfd3f86fdc1$export$4a506b3cd4ea73db();
    };
    Ring.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var PI2 = Math.PI * 2;
        ctx.moveTo(x + shape.r, y);
        ctx.arc(x, y, shape.r, 0, PI2, false);
        ctx.moveTo(x + shape.r0, y);
        ctx.arc(x, y, shape.r0, 0, PI2, true);
    };
    return Ring;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$9da0cbfd3f86fdc1$var$Ring.prototype.type = "ring";
var $9da0cbfd3f86fdc1$export$2e2bcd8739ae039 = $9da0cbfd3f86fdc1$var$Ring;





function $de6f6db626660fc1$export$2e2bcd8739ae039(points, smooth, isLoop, constraint) {
    var cps = [];
    var v = [];
    var v1 = [];
    var v2 = [];
    var prevPoint;
    var nextPoint;
    var min;
    var max;
    if (constraint) {
        min = [
            Infinity,
            Infinity
        ];
        max = [
            -Infinity,
            -Infinity
        ];
        for(var i = 0, len = points.length; i < len; i++){
            (0, $6de594cf8ac295ff$export$96ec731ed4dcb222)(min, min, points[i]);
            (0, $6de594cf8ac295ff$export$8960430cfd85939f)(max, max, points[i]);
        }
        (0, $6de594cf8ac295ff$export$96ec731ed4dcb222)(min, min, constraint[0]);
        (0, $6de594cf8ac295ff$export$8960430cfd85939f)(max, max, constraint[1]);
    }
    for(var i = 0, len = points.length; i < len; i++){
        var point = points[i];
        if (isLoop) {
            prevPoint = points[i ? i - 1 : len - 1];
            nextPoint = points[(i + 1) % len];
        } else if (i === 0 || i === len - 1) {
            cps.push((0, $6de594cf8ac295ff$export$9cd59f9826255e47)(points[i]));
            continue;
        } else {
            prevPoint = points[i - 1];
            nextPoint = points[i + 1];
        }
        (0, $6de594cf8ac295ff$export$f93b5905241a7cca)(v, nextPoint, prevPoint);
        (0, $6de594cf8ac295ff$export$dcdf75081b88279d)(v, v, smooth);
        var d0 = (0, $6de594cf8ac295ff$export$9f17032d917177de)(point, prevPoint);
        var d1 = (0, $6de594cf8ac295ff$export$9f17032d917177de)(point, nextPoint);
        var sum = d0 + d1;
        if (sum !== 0) {
            d0 /= sum;
            d1 /= sum;
        }
        (0, $6de594cf8ac295ff$export$dcdf75081b88279d)(v1, v, -d0);
        (0, $6de594cf8ac295ff$export$dcdf75081b88279d)(v2, v, d1);
        var cp0 = (0, $6de594cf8ac295ff$export$e16d8520af44a096)([], point, v1);
        var cp1 = (0, $6de594cf8ac295ff$export$e16d8520af44a096)([], point, v2);
        if (constraint) {
            (0, $6de594cf8ac295ff$export$8960430cfd85939f)(cp0, cp0, min);
            (0, $6de594cf8ac295ff$export$96ec731ed4dcb222)(cp0, cp0, max);
            (0, $6de594cf8ac295ff$export$8960430cfd85939f)(cp1, cp1, min);
            (0, $6de594cf8ac295ff$export$96ec731ed4dcb222)(cp1, cp1, max);
        }
        cps.push(cp0);
        cps.push(cp1);
    }
    if (isLoop) cps.push(cps.shift());
    return cps;
}


function $68ae9e1c9ba70ac1$export$5cc7f731b5937e99(ctx, shape, closePath) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (points && points.length >= 2) {
        if (smooth) {
            var controlPoints = (0, $de6f6db626660fc1$export$2e2bcd8739ae039)(points, smooth, closePath, shape.smoothConstraint);
            ctx.moveTo(points[0][0], points[0][1]);
            var len = points.length;
            for(var i = 0; i < (closePath ? len : len - 1); i++){
                var cp1 = controlPoints[i * 2];
                var cp2 = controlPoints[i * 2 + 1];
                var p = points[(i + 1) % len];
                ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
            }
        } else {
            ctx.moveTo(points[0][0], points[0][1]);
            for(var i = 1, l = points.length; i < l; i++)ctx.lineTo(points[i][0], points[i][1]);
        }
        closePath && ctx.closePath();
    }
}


var $51acf033123e1a30$export$a34d87b9aaeedd46 = function() {
    function PolygonShape() {
        this.points = null;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolygonShape;
}();
var $51acf033123e1a30$var$Polygon = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Polygon, _super);
    function Polygon(opts) {
        return _super.call(this, opts) || this;
    }
    Polygon.prototype.getDefaultShape = function() {
        return new $51acf033123e1a30$export$a34d87b9aaeedd46();
    };
    Polygon.prototype.buildPath = function(ctx, shape) {
        $68ae9e1c9ba70ac1$export$5cc7f731b5937e99(ctx, shape, true);
    };
    return Polygon;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$51acf033123e1a30$var$Polygon.prototype.type = "polygon";
var $51acf033123e1a30$export$2e2bcd8739ae039 = $51acf033123e1a30$var$Polygon;





var $d28119f30e6bb670$export$e9e5cc3985e19d11 = function() {
    function PolylineShape() {
        this.points = null;
        this.percent = 1;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolylineShape;
}();
var $d28119f30e6bb670$var$Polyline = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Polyline, _super);
    function Polyline(opts) {
        return _super.call(this, opts) || this;
    }
    Polyline.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    Polyline.prototype.getDefaultShape = function() {
        return new $d28119f30e6bb670$export$e9e5cc3985e19d11();
    };
    Polyline.prototype.buildPath = function(ctx, shape) {
        $68ae9e1c9ba70ac1$export$5cc7f731b5937e99(ctx, shape, false);
    };
    return Polyline;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$d28119f30e6bb670$var$Polyline.prototype.type = "polyline";
var $d28119f30e6bb670$export$2e2bcd8739ae039 = $d28119f30e6bb670$var$Polyline;






var $7a316ae5ceff7b27$var$subPixelOptimizeOutputShape = {};
var $7a316ae5ceff7b27$export$64b674d0815308 = function() {
    function LineShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return LineShape;
}();
var $7a316ae5ceff7b27$var$Line = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Line, _super);
    function Line(opts) {
        return _super.call(this, opts) || this;
    }
    Line.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    Line.prototype.getDefaultShape = function() {
        return new $7a316ae5ceff7b27$export$64b674d0815308();
    };
    Line.prototype.buildPath = function(ctx, shape) {
        var x1;
        var y1;
        var x2;
        var y2;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $4d5544821af8d796$export$8b4b620d7f4aad1b)($7a316ae5ceff7b27$var$subPixelOptimizeOutputShape, shape, this.style);
            x1 = optimizedShape.x1;
            y1 = optimizedShape.y1;
            x2 = optimizedShape.x2;
            y2 = optimizedShape.y2;
        } else {
            x1 = shape.x1;
            y1 = shape.y1;
            x2 = shape.x2;
            y2 = shape.y2;
        }
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (percent < 1) {
            x2 = x1 * (1 - percent) + x2 * percent;
            y2 = y1 * (1 - percent) + y2 * percent;
        }
        ctx.lineTo(x2, y2);
    };
    Line.prototype.pointAt = function(p) {
        var shape = this.shape;
        return [
            shape.x1 * (1 - p) + shape.x2 * p,
            shape.y1 * (1 - p) + shape.y2 * p
        ];
    };
    return Line;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$7a316ae5ceff7b27$var$Line.prototype.type = "line";
var $7a316ae5ceff7b27$export$2e2bcd8739ae039 = $7a316ae5ceff7b27$var$Line;






var $6c7800c49630e431$var$out = [];
var $6c7800c49630e431$export$e10089729fef29aa = function() {
    function BezierCurveShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.percent = 1;
    }
    return BezierCurveShape;
}();
function $6c7800c49630e431$var$someVectorAt(shape, t, isTangent) {
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    if (cpx2 != null || cpy2 != null) return [
        (isTangent ? (0, $747cfc5611b57cea$export$55fce925c60b6271) : (0, $747cfc5611b57cea$export$547c21de482bbcb2))(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
        (isTangent ? (0, $747cfc5611b57cea$export$55fce925c60b6271) : (0, $747cfc5611b57cea$export$547c21de482bbcb2))(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
    ];
    else return [
        (isTangent ? (0, $747cfc5611b57cea$export$7e161e77e6fff8cb) : (0, $747cfc5611b57cea$export$af17094a950f5073))(shape.x1, shape.cpx1, shape.x2, t),
        (isTangent ? (0, $747cfc5611b57cea$export$7e161e77e6fff8cb) : (0, $747cfc5611b57cea$export$af17094a950f5073))(shape.y1, shape.cpy1, shape.y2, t)
    ];
}
var $6c7800c49630e431$var$BezierCurve = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(BezierCurve, _super);
    function BezierCurve(opts) {
        return _super.call(this, opts) || this;
    }
    BezierCurve.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    BezierCurve.prototype.getDefaultShape = function() {
        return new $6c7800c49630e431$export$e10089729fef29aa();
    };
    BezierCurve.prototype.buildPath = function(ctx, shape) {
        var x1 = shape.x1;
        var y1 = shape.y1;
        var x2 = shape.x2;
        var y2 = shape.y2;
        var cpx1 = shape.cpx1;
        var cpy1 = shape.cpy1;
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (cpx2 == null || cpy2 == null) {
            if (percent < 1) {
                (0, $747cfc5611b57cea$export$117c659e21a7a060)(x1, cpx1, x2, percent, $6c7800c49630e431$var$out);
                cpx1 = $6c7800c49630e431$var$out[1];
                x2 = $6c7800c49630e431$var$out[2];
                (0, $747cfc5611b57cea$export$117c659e21a7a060)(y1, cpy1, y2, percent, $6c7800c49630e431$var$out);
                cpy1 = $6c7800c49630e431$var$out[1];
                y2 = $6c7800c49630e431$var$out[2];
            }
            ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
        } else {
            if (percent < 1) {
                (0, $747cfc5611b57cea$export$a2ee23a0567039da)(x1, cpx1, cpx2, x2, percent, $6c7800c49630e431$var$out);
                cpx1 = $6c7800c49630e431$var$out[1];
                cpx2 = $6c7800c49630e431$var$out[2];
                x2 = $6c7800c49630e431$var$out[3];
                (0, $747cfc5611b57cea$export$a2ee23a0567039da)(y1, cpy1, cpy2, y2, percent, $6c7800c49630e431$var$out);
                cpy1 = $6c7800c49630e431$var$out[1];
                cpy2 = $6c7800c49630e431$var$out[2];
                y2 = $6c7800c49630e431$var$out[3];
            }
            ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
        }
    };
    BezierCurve.prototype.pointAt = function(t) {
        return $6c7800c49630e431$var$someVectorAt(this.shape, t, false);
    };
    BezierCurve.prototype.tangentAt = function(t) {
        var p = $6c7800c49630e431$var$someVectorAt(this.shape, t, true);
        return $6de594cf8ac295ff$export$a3295358bff77e(p, p);
    };
    return BezierCurve;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$6c7800c49630e431$var$BezierCurve.prototype.type = "bezier-curve";
var $6c7800c49630e431$export$2e2bcd8739ae039 = $6c7800c49630e431$var$BezierCurve;




var $2b5c23eb3597b84a$export$a259dbdc51948277 = function() {
    function ArcShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return ArcShape;
}();
var $2b5c23eb3597b84a$var$Arc = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Arc, _super);
    function Arc(opts) {
        return _super.call(this, opts) || this;
    }
    Arc.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    Arc.prototype.getDefaultShape = function() {
        return new $2b5c23eb3597b84a$export$a259dbdc51948277();
    };
    Arc.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r = Math.max(shape.r, 0);
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitX = Math.cos(startAngle);
        var unitY = Math.sin(startAngle);
        ctx.moveTo(unitX * r + x, unitY * r + y);
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    };
    return Arc;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
$2b5c23eb3597b84a$var$Arc.prototype.type = "arc";
var $2b5c23eb3597b84a$export$2e2bcd8739ae039 = $2b5c23eb3597b84a$var$Arc;




var $e152f3dbf8fba6e2$var$CompoundPath = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(CompoundPath, _super);
    function CompoundPath() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "compound";
        return _this;
    }
    CompoundPath.prototype._updatePathDirty = function() {
        var paths = this.shape.paths;
        var dirtyPath = this.shapeChanged();
        for(var i = 0; i < paths.length; i++)dirtyPath = dirtyPath || paths[i].shapeChanged();
        if (dirtyPath) this.dirtyShape();
    };
    CompoundPath.prototype.beforeBrush = function() {
        this._updatePathDirty();
        var paths = this.shape.paths || [];
        var scale = this.getGlobalScale();
        for(var i = 0; i < paths.length; i++){
            if (!paths[i].path) paths[i].createPathProxy();
            paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
        }
    };
    CompoundPath.prototype.buildPath = function(ctx, shape) {
        var paths = shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].buildPath(ctx, paths[i].shape, true);
    };
    CompoundPath.prototype.afterBrush = function() {
        var paths = this.shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].pathUpdated();
    };
    CompoundPath.prototype.getBoundingRect = function() {
        this._updatePathDirty.call(this);
        return (0, $b02ffe7acd508c08$export$2e2bcd8739ae039).prototype.getBoundingRect.call(this);
    };
    return CompoundPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $e152f3dbf8fba6e2$export$2e2bcd8739ae039 = $e152f3dbf8fba6e2$var$CompoundPath;



var $8273248bf9338d40$var$Gradient = function() {
    function Gradient(colorStops) {
        this.colorStops = colorStops || [];
    }
    Gradient.prototype.addColorStop = function(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: color
        });
    };
    return Gradient;
}();
var $8273248bf9338d40$export$2e2bcd8739ae039 = $8273248bf9338d40$var$Gradient;


var $cf44c01491b58e53$var$LinearGradient = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(LinearGradient, _super);
    function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0 : x;
        _this.y = y == null ? 0 : y;
        _this.x2 = x2 == null ? 1 : x2;
        _this.y2 = y2 == null ? 0 : y2;
        _this.type = "linear";
        _this.global = globalCoord || false;
        return _this;
    }
    return LinearGradient;
}((0, $8273248bf9338d40$export$2e2bcd8739ae039));
var $cf44c01491b58e53$export$2e2bcd8739ae039 = $cf44c01491b58e53$var$LinearGradient;




var $cd2ee2ba32bb26c3$var$RadialGradient = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(RadialGradient, _super);
    function RadialGradient(x, y, r, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0.5 : x;
        _this.y = y == null ? 0.5 : y;
        _this.r = r == null ? 0.5 : r;
        _this.type = "radial";
        _this.global = globalCoord || false;
        return _this;
    }
    return RadialGradient;
}((0, $8273248bf9338d40$export$2e2bcd8739ae039));
var $cd2ee2ba32bb26c3$export$2e2bcd8739ae039 = $cd2ee2ba32bb26c3$var$RadialGradient;




var $f9793b4d8aade116$var$extent = [
    0,
    0
];
var $f9793b4d8aade116$var$extent2 = [
    0,
    0
];
var $f9793b4d8aade116$var$minTv = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f9793b4d8aade116$var$maxTv = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f9793b4d8aade116$var$OrientedBoundingRect = function() {
    function OrientedBoundingRect(rect, transform) {
        this._corners = [];
        this._axes = [];
        this._origin = [
            0,
            0
        ];
        for(var i = 0; i < 4; i++)this._corners[i] = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
        for(var i = 0; i < 2; i++)this._axes[i] = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
        if (rect) this.fromBoundingRect(rect, transform);
    }
    OrientedBoundingRect.prototype.fromBoundingRect = function(rect, transform) {
        var corners = this._corners;
        var axes = this._axes;
        var x = rect.x;
        var y = rect.y;
        var x2 = x + rect.width;
        var y2 = y + rect.height;
        corners[0].set(x, y);
        corners[1].set(x2, y);
        corners[2].set(x2, y2);
        corners[3].set(x, y2);
        if (transform) for(var i = 0; i < 4; i++)corners[i].transform(transform);
        (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub(axes[0], corners[1], corners[0]);
        (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub(axes[1], corners[3], corners[0]);
        axes[0].normalize();
        axes[1].normalize();
        for(var i = 0; i < 2; i++)this._origin[i] = axes[i].dot(corners[0]);
    };
    OrientedBoundingRect.prototype.intersect = function(other, mtv) {
        var overlapped = true;
        var noMtv = !mtv;
        $f9793b4d8aade116$var$minTv.set(Infinity, Infinity);
        $f9793b4d8aade116$var$maxTv.set(0, 0);
        if (!this._intersectCheckOneSide(this, other, $f9793b4d8aade116$var$minTv, $f9793b4d8aade116$var$maxTv, noMtv, 1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!this._intersectCheckOneSide(other, this, $f9793b4d8aade116$var$minTv, $f9793b4d8aade116$var$maxTv, noMtv, -1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!noMtv) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy(mtv, overlapped ? $f9793b4d8aade116$var$minTv : $f9793b4d8aade116$var$maxTv);
        return overlapped;
    };
    OrientedBoundingRect.prototype._intersectCheckOneSide = function(self, other, minTv, maxTv, noMtv, inverse) {
        var overlapped = true;
        for(var i = 0; i < 2; i++){
            var axis = this._axes[i];
            this._getProjMinMaxOnAxis(i, self._corners, $f9793b4d8aade116$var$extent);
            this._getProjMinMaxOnAxis(i, other._corners, $f9793b4d8aade116$var$extent2);
            if ($f9793b4d8aade116$var$extent[1] < $f9793b4d8aade116$var$extent2[0] || $f9793b4d8aade116$var$extent[0] > $f9793b4d8aade116$var$extent2[1]) {
                overlapped = false;
                if (noMtv) return overlapped;
                var dist0 = Math.abs($f9793b4d8aade116$var$extent2[0] - $f9793b4d8aade116$var$extent[1]);
                var dist1 = Math.abs($f9793b4d8aade116$var$extent[0] - $f9793b4d8aade116$var$extent2[1]);
                if (Math.min(dist0, dist1) > maxTv.len()) {
                    if (dist0 < dist1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scale(maxTv, axis, -dist0 * inverse);
                    else (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scale(maxTv, axis, dist1 * inverse);
                }
            } else if (minTv) {
                var dist0 = Math.abs($f9793b4d8aade116$var$extent2[0] - $f9793b4d8aade116$var$extent[1]);
                var dist1 = Math.abs($f9793b4d8aade116$var$extent[0] - $f9793b4d8aade116$var$extent2[1]);
                if (Math.min(dist0, dist1) < minTv.len()) {
                    if (dist0 < dist1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scale(minTv, axis, dist0 * inverse);
                    else (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scale(minTv, axis, -dist1 * inverse);
                }
            }
        }
        return overlapped;
    };
    OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function(dim, corners, out) {
        var axis = this._axes[dim];
        var origin = this._origin;
        var proj = corners[0].dot(axis) + origin[dim];
        var min = proj;
        var max = proj;
        for(var i = 1; i < corners.length; i++){
            var proj_1 = corners[i].dot(axis) + origin[dim];
            min = Math.min(proj_1, min);
            max = Math.max(proj_1, max);
        }
        out[0] = min;
        out[1] = max;
    };
    return OrientedBoundingRect;
}();
var $f9793b4d8aade116$export$2e2bcd8739ae039 = $f9793b4d8aade116$var$OrientedBoundingRect;






var $ee829f116f003981$var$m = [];
var $ee829f116f003981$var$IncrementalDisplayable = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(IncrementalDisplayable, _super);
    function IncrementalDisplayable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notClear = true;
        _this.incremental = true;
        _this._displayables = [];
        _this._temporaryDisplayables = [];
        _this._cursor = 0;
        return _this;
    }
    IncrementalDisplayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    IncrementalDisplayable.prototype.useStyle = function() {
        this.style = {};
    };
    IncrementalDisplayable.prototype.getCursor = function() {
        return this._cursor;
    };
    IncrementalDisplayable.prototype.innerAfterBrush = function() {
        this._cursor = this._displayables.length;
    };
    IncrementalDisplayable.prototype.clearDisplaybles = function() {
        this._displayables = [];
        this._temporaryDisplayables = [];
        this._cursor = 0;
        this.markRedraw();
        this.notClear = false;
    };
    IncrementalDisplayable.prototype.clearTemporalDisplayables = function() {
        this._temporaryDisplayables = [];
    };
    IncrementalDisplayable.prototype.addDisplayable = function(displayable, notPersistent) {
        if (notPersistent) this._temporaryDisplayables.push(displayable);
        else this._displayables.push(displayable);
        this.markRedraw();
    };
    IncrementalDisplayable.prototype.addDisplayables = function(displayables, notPersistent) {
        notPersistent = notPersistent || false;
        for(var i = 0; i < displayables.length; i++)this.addDisplayable(displayables[i], notPersistent);
    };
    IncrementalDisplayable.prototype.getDisplayables = function() {
        return this._displayables;
    };
    IncrementalDisplayable.prototype.getTemporalDisplayables = function() {
        return this._temporaryDisplayables;
    };
    IncrementalDisplayable.prototype.eachPendingDisplayable = function(cb) {
        for(var i = this._cursor; i < this._displayables.length; i++)cb && cb(this._displayables[i]);
        for(var i = 0; i < this._temporaryDisplayables.length; i++)cb && cb(this._temporaryDisplayables[i]);
    };
    IncrementalDisplayable.prototype.update = function() {
        this.updateTransform();
        for(var i = this._cursor; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
        for(var i = 0; i < this._temporaryDisplayables.length; i++){
            var displayable = this._temporaryDisplayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
    };
    IncrementalDisplayable.prototype.getBoundingRect = function() {
        if (!this._rect) {
            var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(Infinity, Infinity, -Infinity, -Infinity);
            for(var i = 0; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                var childRect = displayable.getBoundingRect().clone();
                if (displayable.needLocalTransform()) childRect.applyTransform(displayable.getLocalTransform($ee829f116f003981$var$m));
                rect.union(childRect);
            }
            this._rect = rect;
        }
        return this._rect;
    };
    IncrementalDisplayable.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        if (rect.contain(localPos[0], localPos[1])) for(var i = 0; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            if (displayable.contain(x, y)) return true;
        }
        return false;
    };
    return IncrementalDisplayable;
}((0, $56206a6cb4666931$export$2e2bcd8739ae039));
var $ee829f116f003981$export$2e2bcd8739ae039 = $ee829f116f003981$var$IncrementalDisplayable;






var $5b455ae6f843ac47$var$mathMax = Math.max;
var $5b455ae6f843ac47$var$mathMin = Math.min;
var $5b455ae6f843ac47$var$_customShapeMap = {};
function $5b455ae6f843ac47$export$d0d5398c9d612037(opts) {
    return (0, $b02ffe7acd508c08$export$2e2bcd8739ae039).extend(opts);
}
var $5b455ae6f843ac47$var$extendPathFromString = $15b38920672b9006$export$68e3a51ba2ed417c;
function $5b455ae6f843ac47$export$53b54a3137026af0(pathData, opts) {
    return $5b455ae6f843ac47$var$extendPathFromString(pathData, opts);
}
function $5b455ae6f843ac47$export$2b95b62e3aaf6fdd(name, ShapeClass) {
    $5b455ae6f843ac47$var$_customShapeMap[name] = ShapeClass;
}
function $5b455ae6f843ac47$export$51df4b5565a58189(name) {
    if ($5b455ae6f843ac47$var$_customShapeMap.hasOwnProperty(name)) return $5b455ae6f843ac47$var$_customShapeMap[name];
}
function $5b455ae6f843ac47$export$aa9bab72412f5613(pathData, opts, rect, layout) {
    var path = $15b38920672b9006$export$ae5b259626f00aeb(pathData, opts);
    if (rect) {
        if (layout === "center") rect = $5b455ae6f843ac47$var$centerGraphic(rect, path.getBoundingRect());
        $5b455ae6f843ac47$export$566dbf1c62b04fc7(path, rect);
    }
    return path;
}
function $5b455ae6f843ac47$export$7a2bdede98851ac5(imageUrl, rect, layout) {
    var zrImg = new (0, $86adec94217b86c6$export$2e2bcd8739ae039)({
        style: {
            image: imageUrl,
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        onload: function(img) {
            if (layout === "center") {
                var boundingRect = {
                    width: img.width,
                    height: img.height
                };
                zrImg.setStyle($5b455ae6f843ac47$var$centerGraphic(rect, boundingRect));
            }
        }
    });
    return zrImg;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  rect         element local bounding box
 * @param  boundingRect constraint bounding box
 * @return element position containing x, y, width, and height
 */ function $5b455ae6f843ac47$var$centerGraphic(rect, boundingRect) {
    // Set rect to center, keep width / height ratio.
    var aspect = boundingRect.width / boundingRect.height;
    var width = rect.height * aspect;
    var height;
    if (width <= rect.width) height = rect.height;
    else {
        width = rect.width;
        height = width / aspect;
    }
    var cx = rect.x + rect.width / 2;
    var cy = rect.y + rect.height / 2;
    return {
        x: cx - width / 2,
        y: cy - height / 2,
        width: width,
        height: height
    };
}
var $5b455ae6f843ac47$export$7b1dd269fbc4e903 = $15b38920672b9006$export$7b1dd269fbc4e903;
function $5b455ae6f843ac47$export$566dbf1c62b04fc7(path, rect) {
    if (!path.applyTransform) return;
    var pathRect = path.getBoundingRect();
    var m = pathRect.calculateTransform(rect);
    path.applyTransform(m);
}
function $5b455ae6f843ac47$export$8b4b620d7f4aad1b(shape, lineWidth) {
    $4d5544821af8d796$export$8b4b620d7f4aad1b(shape, shape, {
        lineWidth: lineWidth
    });
    return shape;
}
function $5b455ae6f843ac47$export$60e2aa74957d0b9d(param) {
    $4d5544821af8d796$export$60e2aa74957d0b9d(param.shape, param.shape, param.style);
    return param;
}
var $5b455ae6f843ac47$export$72c4fd4c1b8fcb10 = $4d5544821af8d796$export$72c4fd4c1b8fcb10;
function $5b455ae6f843ac47$export$fce0c6cfca85ed96(target, ancestor) {
    var mat = $f41ebb9dd60b55b4$export$f0954fd7d5368655([]);
    while(target && target !== ancestor){
        $f41ebb9dd60b55b4$export$6e3a27864ab166fe(mat, target.getLocalTransform(), mat);
        target = target.parent;
    }
    return mat;
}
function $5b455ae6f843ac47$export$9f9dcb98c894b623(target, transform, invert) {
    if (transform && !(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(transform)) transform = (0, $becf2d727f9cf450$export$2e2bcd8739ae039).getLocalTransform(transform);
    if (invert) transform = $f41ebb9dd60b55b4$export$6897c284b6f9f4dc([], transform);
    return $6de594cf8ac295ff$export$9f9dcb98c894b623([], target, transform);
}
function $5b455ae6f843ac47$export$fff94e9792354cfa(direction, transform, invert) {
    // Pick a base, ensure that transform result will not be (0, 0).
    var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
    var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
    var vertex = [
        direction === "left" ? -hBase : direction === "right" ? hBase : 0,
        direction === "top" ? -vBase : direction === "bottom" ? vBase : 0
    ];
    vertex = $5b455ae6f843ac47$export$9f9dcb98c894b623(vertex, transform, invert);
    return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? "right" : "left" : vertex[1] > 0 ? "bottom" : "top";
}
function $5b455ae6f843ac47$var$isNotGroup(el) {
    return !el.isGroup;
}
function $5b455ae6f843ac47$var$isPath(el) {
    return el.shape != null;
}
function $5b455ae6f843ac47$export$64fcab7860c216ae(g1, g2, animatableModel) {
    if (!g1 || !g2) return;
    function getElMap(g) {
        var elMap = {};
        g.traverse(function(el) {
            if ($5b455ae6f843ac47$var$isNotGroup(el) && el.anid) elMap[el.anid] = el;
        });
        return elMap;
    }
    function getAnimatableProps(el) {
        var obj = {
            x: el.x,
            y: el.y,
            rotation: el.rotation
        };
        if ($5b455ae6f843ac47$var$isPath(el)) obj.shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, el.shape);
        return obj;
    }
    var elMap1 = getElMap(g1);
    g2.traverse(function(el) {
        if ($5b455ae6f843ac47$var$isNotGroup(el) && el.anid) {
            var oldEl = elMap1[el.anid];
            if (oldEl) {
                var newProp = getAnimatableProps(el);
                el.attr(getAnimatableProps(oldEl));
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(el, newProp, animatableModel, (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).dataIndex);
            }
        }
    });
}
function $5b455ae6f843ac47$export$e2f409471bbbc1dc(points, rect) {
    // FIXME: This way might be incorrect when graphic clipped by a corner
    // and when element has a border.
    return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(points, function(point) {
        var x = point[0];
        x = $5b455ae6f843ac47$var$mathMax(x, rect.x);
        x = $5b455ae6f843ac47$var$mathMin(x, rect.x + rect.width);
        var y = point[1];
        y = $5b455ae6f843ac47$var$mathMax(y, rect.y);
        y = $5b455ae6f843ac47$var$mathMin(y, rect.y + rect.height);
        return [
            x,
            y
        ];
    });
}
function $5b455ae6f843ac47$export$d0d3709202b8b2a(targetRect, rect) {
    var x = $5b455ae6f843ac47$var$mathMax(targetRect.x, rect.x);
    var x2 = $5b455ae6f843ac47$var$mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
    var y = $5b455ae6f843ac47$var$mathMax(targetRect.y, rect.y);
    var y2 = $5b455ae6f843ac47$var$mathMin(targetRect.y + targetRect.height, rect.y + rect.height);
    // If the total rect is cliped, nothing, including the border,
    // should be painted. So return undefined.
    if (x2 >= x && y2 >= y) return {
        x: x,
        y: y,
        width: x2 - x,
        height: y2 - y
    };
}
function $5b455ae6f843ac47$export$274edc73af1ae9c8(iconStr, // Support 'image://' or 'path://' or direct svg path.
opt, rect) {
    var innerOpts = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
        rectHover: true
    }, opt);
    var style = innerOpts.style = {
        strokeNoScale: true
    };
    rect = rect || {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    };
    if (iconStr) return iconStr.indexOf("image://") === 0 ? (style.image = iconStr.slice(8), (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(style, rect), new (0, $86adec94217b86c6$export$2e2bcd8739ae039)(innerOpts)) : $5b455ae6f843ac47$export$aa9bab72412f5613(iconStr.replace("path://", ""), innerOpts, rect, "center");
}
function $5b455ae6f843ac47$export$4f47c855a5e9ae9(a1x, a1y, a2x, a2y, points) {
    for(var i = 0, p2 = points[points.length - 1]; i < points.length; i++){
        var p = points[i];
        if ($5b455ae6f843ac47$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) return true;
        p2 = p;
    }
}
function $5b455ae6f843ac47$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y;
    // `vec_m` and `vec_n` are parallel iff
    //     existing `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
    var nmCrossProduct = $5b455ae6f843ac47$var$crossProduct2d(nx, ny, mx, my);
    if ($5b455ae6f843ac47$var$nearZero(nmCrossProduct)) return false;
    // `vec_m` and `vec_n` are intersect iff
    //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
    //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
    //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var q = $5b455ae6f843ac47$var$crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
    if (q < 0 || q > 1) return false;
    var p = $5b455ae6f843ac47$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return false;
    return true;
}
/**
 * Cross product of 2-dimension vector.
 */ function $5b455ae6f843ac47$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $5b455ae6f843ac47$var$nearZero(val) {
    return val <= 1e-6 && val >= -0.000001;
}
function $5b455ae6f843ac47$export$fc6410d97fab306c(opt) {
    var itemTooltipOption = opt.itemTooltipOption;
    var componentModel = opt.componentModel;
    var itemName = opt.itemName;
    var itemTooltipOptionObj = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(itemTooltipOption) ? {
        formatter: itemTooltipOption
    } : itemTooltipOption;
    var mainType = componentModel.mainType;
    var componentIndex = componentModel.componentIndex;
    var formatterParams = {
        componentType: mainType,
        name: itemName,
        $vars: [
            "name"
        ]
    };
    formatterParams[mainType + "Index"] = componentIndex;
    var formatterParamsExtra = opt.formatterParamsExtra;
    if (formatterParamsExtra) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(formatterParamsExtra), function(key) {
        if (!(0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(formatterParams, key)) {
            formatterParams[key] = formatterParamsExtra[key];
            formatterParams.$vars.push(key);
        }
    });
    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(opt.el);
    ecData.componentMainType = mainType;
    ecData.componentIndex = componentIndex;
    ecData.tooltipConfig = {
        name: itemName,
        option: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            content: itemName,
            formatterParams: formatterParams
        }, itemTooltipOptionObj)
    };
}
function $5b455ae6f843ac47$var$traverseElement(el, cb) {
    var stopped;
    // TODO
    // Polyfill for fixing zrender group traverse don't visit it's root issue.
    if (el.isGroup) stopped = cb(el);
    if (!stopped) el.traverse(cb);
}
function $5b455ae6f843ac47$export$3e564442729bf048(els, cb) {
    if (els) {
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(els)) for(var i = 0; i < els.length; i++)$5b455ae6f843ac47$var$traverseElement(els[i], cb);
        else $5b455ae6f843ac47$var$traverseElement(els, cb);
    }
}
// Register built-in shapes. These shapes might be overwritten
// by users, although we do not recommend that.
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("circle", (0, $1e68d8727773abb7$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("ellipse", (0, $4a809f055a7e524c$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("sector", (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("ring", (0, $9da0cbfd3f86fdc1$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("polygon", (0, $51acf033123e1a30$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("polyline", (0, $d28119f30e6bb670$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("rect", (0, $419e5ff2f303755e$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("line", (0, $7a316ae5ceff7b27$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("bezierCurve", (0, $6c7800c49630e431$export$2e2bcd8739ae039));
$5b455ae6f843ac47$export$2b95b62e3aaf6fdd("arc", (0, $2b5c23eb3597b84a$export$2e2bcd8739ae039));


var $6800dfcb6e1e2a44$var$EMPTY_OBJ = {};
function $6800dfcb6e1e2a44$export$b533918394a58529(label, labelTexts) {
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
        var text = labelTexts[stateName];
        var state = label.ensureState(stateName);
        state.style = state.style || {};
        state.style.text = text;
    }
    var oldStates = label.currentStates.slice();
    label.clearStates(true);
    label.setStyle({
        text: labelTexts.normal
    });
    label.useStates(oldStates, true);
}
function $6800dfcb6e1e2a44$var$getLabelText(opt, stateModels, interpolatedValue) {
    var labelFetcher = opt.labelFetcher;
    var labelDataIndex = opt.labelDataIndex;
    var labelDimIndex = opt.labelDimIndex;
    var normalModel = stateModels.normal;
    var baseText;
    if (labelFetcher) baseText = labelFetcher.getFormattedLabel(labelDataIndex, "normal", null, labelDimIndex, normalModel && normalModel.get("formatter"), interpolatedValue != null ? {
        interpolatedValue: interpolatedValue
    } : null);
    if (baseText == null) baseText = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
    var statesText = {
        normal: baseText
    };
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
        var stateModel = stateModels[stateName];
        statesText[stateName] = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get("formatter")) : null, baseText);
    }
    return statesText;
}
function $6800dfcb6e1e2a44$export$9a13992917966657(targetEl, labelStatesModels, opt, stateSpecified) {
    opt = opt || $6800dfcb6e1e2a44$var$EMPTY_OBJ;
    var isSetOnText = targetEl instanceof (0, $fe885cc21795562b$export$2e2bcd8739ae039);
    var needsCreateText = false;
    for(var i = 0; i < (0, $2bf82c0980125b62$export$57ee5306b85ad7d5).length; i++){
        var stateModel = labelStatesModels[(0, $2bf82c0980125b62$export$57ee5306b85ad7d5)[i]];
        if (stateModel && stateModel.getShallow("show")) {
            needsCreateText = true;
            break;
        }
    }
    var textContent = isSetOnText ? targetEl : targetEl.getTextContent();
    if (needsCreateText) {
        if (!isSetOnText) {
            // Reuse the previous
            if (!textContent) {
                textContent = new (0, $fe885cc21795562b$export$2e2bcd8739ae039)();
                targetEl.setTextContent(textContent);
            }
            // Use same state proxy
            if (targetEl.stateProxy) textContent.stateProxy = targetEl.stateProxy;
        }
        var labelStatesTexts = $6800dfcb6e1e2a44$var$getLabelText(opt, labelStatesModels);
        var normalModel = labelStatesModels.normal;
        var showNormal = !!normalModel.getShallow("show");
        var normalStyle = $6800dfcb6e1e2a44$export$f8998c3d0a13de59(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
        normalStyle.text = labelStatesTexts.normal;
        if (!isSetOnText) // Always create new
        targetEl.setTextConfig($6800dfcb6e1e2a44$export$e149afab8df6e053(normalModel, opt, false));
        for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
            var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
            var stateModel = labelStatesModels[stateName];
            if (stateModel) {
                var stateObj = textContent.ensureState(stateName);
                var stateShow = !!(0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(stateModel.getShallow("show"), showNormal);
                if (stateShow !== showNormal) stateObj.ignore = !stateShow;
                stateObj.style = $6800dfcb6e1e2a44$export$f8998c3d0a13de59(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
                stateObj.style.text = labelStatesTexts[stateName];
                if (!isSetOnText) {
                    var targetElEmphasisState = targetEl.ensureState(stateName);
                    targetElEmphasisState.textConfig = $6800dfcb6e1e2a44$export$e149afab8df6e053(stateModel, opt, true);
                }
            }
        }
        // PENDING: if there is many requirements that emphasis position
        // need to be different from normal position, we might consider
        // auto silent is those cases.
        textContent.silent = !!normalModel.getShallow("silent");
        // Keep x and y
        if (textContent.style.x != null) normalStyle.x = textContent.style.x;
        if (textContent.style.y != null) normalStyle.y = textContent.style.y;
        textContent.ignore = !showNormal;
        // Always create new style.
        textContent.useStyle(normalStyle);
        textContent.dirty();
        if (opt.enableTextSetter) $6800dfcb6e1e2a44$export$f62786d3261ab0f4(textContent).setLabelText = function(interpolatedValue) {
            var labelStatesTexts = $6800dfcb6e1e2a44$var$getLabelText(opt, labelStatesModels, interpolatedValue);
            $6800dfcb6e1e2a44$export$b533918394a58529(textContent, labelStatesTexts);
        };
    } else if (textContent) // Not display rich text.
    textContent.ignore = true;
    targetEl.dirty();
}
function $6800dfcb6e1e2a44$export$9739a32674be5893(itemModel, labelName) {
    labelName = labelName || "label";
    var statesModels = {
        normal: itemModel.getModel(labelName)
    };
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelName
        ]);
    }
    return statesModels;
}
function $6800dfcb6e1e2a44$export$f8998c3d0a13de59(textStyleModel, specifiedTextStyle, // Fixed style in the code. Can't be set by model.
opt, isNotNormal, isAttached // If text is attached on an element. If so, auto color will handling in zrender.
) {
    var textStyle = {};
    $6800dfcb6e1e2a44$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
    specifiedTextStyle && (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(textStyle, specifiedTextStyle);
    // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
    return textStyle;
}
function $6800dfcb6e1e2a44$export$e149afab8df6e053(textStyleModel, opt, isNotNormal) {
    opt = opt || {};
    var textConfig = {};
    var labelPosition;
    var labelRotate = textStyleModel.getShallow("rotate");
    var labelDistance = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow("distance"), isNotNormal ? null : 5);
    var labelOffset = textStyleModel.getShallow("offset");
    labelPosition = textStyleModel.getShallow("position") || (isNotNormal ? null : "inside");
    // 'outside' is not a valid zr textPostion value, but used
    // in bar series, and magric type should be considered.
    labelPosition === "outside" && (labelPosition = opt.defaultOutsidePosition || "top");
    if (labelPosition != null) textConfig.position = labelPosition;
    if (labelOffset != null) textConfig.offset = labelOffset;
    if (labelRotate != null) {
        labelRotate *= Math.PI / 180;
        textConfig.rotation = labelRotate;
    }
    if (labelDistance != null) textConfig.distance = labelDistance;
    // fill and auto is determined by the color of path fill if it's not specified by developers.
    textConfig.outsideFill = textStyleModel.get("color") === "inherit" ? opt.inheritColor || null : "auto";
    return textConfig;
}
/**
 * The uniform entry of set text style, that is, retrieve style definitions
 * from `model` and set to `textStyle` object.
 *
 * Never in merge mode, but in overwrite mode, that is, all of the text style
 * properties will be set. (Consider the states of normal and emphasis and
 * default value can be adopted, merge would make the logic too complicated
 * to manage.)
 */ function $6800dfcb6e1e2a44$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
    // Consider there will be abnormal when merge hover style to normal style if given default value.
    opt = opt || $6800dfcb6e1e2a44$var$EMPTY_OBJ;
    var ecModel = textStyleModel.ecModel;
    var globalTextStyle = ecModel && ecModel.option.textStyle;
    // Consider case:
    // {
    //     data: [{
    //         value: 12,
    //         label: {
    //             rich: {
    //                 // no 'a' here but using parent 'a'.
    //             }
    //         }
    //     }],
    //     rich: {
    //         a: { ... }
    //     }
    // }
    var richItemNames = $6800dfcb6e1e2a44$var$getRichItemNames(textStyleModel);
    var richResult;
    if (richItemNames) {
        richResult = {};
        for(var name_1 in richItemNames)if (richItemNames.hasOwnProperty(name_1)) {
            // Cascade is supported in rich.
            var richTextStyle = textStyleModel.getModel([
                "rich",
                name_1
            ]);
            // In rich, never `disableBox`.
            // FIXME: consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
            // the default color `'blue'` will not be adopted if no color declared in `rich`.
            // That might confuses users. So probably we should put `textStyleModel` as the
            // root ancestor of the `richTextStyle`. But that would be a break change.
            $6800dfcb6e1e2a44$var$setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, opt, isNotNormal, isAttached, false, true);
        }
    }
    if (richResult) textStyle.rich = richResult;
    var overflow = textStyleModel.get("overflow");
    if (overflow) textStyle.overflow = overflow;
    var margin = textStyleModel.get("minMargin");
    if (margin != null) textStyle.margin = margin;
    $6800dfcb6e1e2a44$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, true, false);
}
// Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }
// TODO TextStyleModel
function $6800dfcb6e1e2a44$var$getRichItemNames(textStyleModel) {
    // Use object to remove duplicated names.
    var richItemNameMap;
    while(textStyleModel && textStyleModel !== textStyleModel.ecModel){
        var rich = (textStyleModel.option || $6800dfcb6e1e2a44$var$EMPTY_OBJ).rich;
        if (rich) {
            richItemNameMap = richItemNameMap || {};
            var richKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(rich);
            for(var i = 0; i < richKeys.length; i++){
                var richKey = richKeys[i];
                richItemNameMap[richKey] = 1;
            }
        }
        textStyleModel = textStyleModel.parentModel;
    }
    return richItemNameMap;
}
var $6800dfcb6e1e2a44$var$TEXT_PROPS_WITH_GLOBAL = [
    "fontStyle",
    "fontWeight",
    "fontSize",
    "fontFamily",
    "textShadowColor",
    "textShadowBlur",
    "textShadowOffsetX",
    "textShadowOffsetY"
];
var $6800dfcb6e1e2a44$var$TEXT_PROPS_SELF = [
    "align",
    "lineHeight",
    "width",
    "height",
    "tag",
    "verticalAlign",
    "ellipsis"
];
var $6800dfcb6e1e2a44$var$TEXT_PROPS_BOX = [
    "padding",
    "borderWidth",
    "borderRadius",
    "borderDashOffset",
    "backgroundColor",
    "borderColor",
    "shadowColor",
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY"
];
function $6800dfcb6e1e2a44$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, isBlock, inRich) {
    // In merge mode, default value should not be given.
    globalTextStyle = !isNotNormal && globalTextStyle || $6800dfcb6e1e2a44$var$EMPTY_OBJ;
    var inheritColor = opt && opt.inheritColor;
    var fillColor = textStyleModel.getShallow("color");
    var strokeColor = textStyleModel.getShallow("textBorderColor");
    var opacity = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow("opacity"), globalTextStyle.opacity);
    if (fillColor === "inherit" || fillColor === "auto") {
        if (inheritColor) fillColor = inheritColor;
        else fillColor = null;
    }
    if (strokeColor === "inherit" || strokeColor === "auto") {
        if (inheritColor) strokeColor = inheritColor;
        else strokeColor = null;
    }
    if (!isAttached) {
        // Only use default global textStyle.color if text is individual.
        // Otherwise it will use the strategy of attached text color because text may be on a path.
        fillColor = fillColor || globalTextStyle.color;
        strokeColor = strokeColor || globalTextStyle.textBorderColor;
    }
    if (fillColor != null) textStyle.fill = fillColor;
    if (strokeColor != null) textStyle.stroke = strokeColor;
    var textBorderWidth = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow("textBorderWidth"), globalTextStyle.textBorderWidth);
    if (textBorderWidth != null) textStyle.lineWidth = textBorderWidth;
    var textBorderType = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow("textBorderType"), globalTextStyle.textBorderType);
    if (textBorderType != null) textStyle.lineDash = textBorderType;
    var textBorderDashOffset = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow("textBorderDashOffset"), globalTextStyle.textBorderDashOffset);
    if (textBorderDashOffset != null) textStyle.lineDashOffset = textBorderDashOffset;
    if (!isNotNormal && opacity == null && !inRich) opacity = opt && opt.defaultOpacity;
    if (opacity != null) textStyle.opacity = opacity;
    // TODO
    if (!isNotNormal && !isAttached) // Set default finally.
    {
        if (textStyle.fill == null && opt.inheritColor) textStyle.fill = opt.inheritColor;
    }
    // Do not use `getFont` here, because merge should be supported, where
    // part of these properties may be changed in emphasis style, and the
    // others should remain their original value got from normal style.
    for(var i = 0; i < $6800dfcb6e1e2a44$var$TEXT_PROPS_WITH_GLOBAL.length; i++){
        var key = $6800dfcb6e1e2a44$var$TEXT_PROPS_WITH_GLOBAL[i];
        var val = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textStyleModel.getShallow(key), globalTextStyle[key]);
        if (val != null) textStyle[key] = val;
    }
    for(var i = 0; i < $6800dfcb6e1e2a44$var$TEXT_PROPS_SELF.length; i++){
        var key = $6800dfcb6e1e2a44$var$TEXT_PROPS_SELF[i];
        var val = textStyleModel.getShallow(key);
        if (val != null) textStyle[key] = val;
    }
    if (textStyle.verticalAlign == null) {
        var baseline = textStyleModel.getShallow("baseline");
        if (baseline != null) textStyle.verticalAlign = baseline;
    }
    if (!isBlock || !opt.disableBox) {
        for(var i = 0; i < $6800dfcb6e1e2a44$var$TEXT_PROPS_BOX.length; i++){
            var key = $6800dfcb6e1e2a44$var$TEXT_PROPS_BOX[i];
            var val = textStyleModel.getShallow(key);
            if (val != null) textStyle[key] = val;
        }
        var borderType = textStyleModel.getShallow("borderType");
        if (borderType != null) textStyle.borderDash = borderType;
        if ((textStyle.backgroundColor === "auto" || textStyle.backgroundColor === "inherit") && inheritColor) textStyle.backgroundColor = inheritColor;
        if ((textStyle.borderColor === "auto" || textStyle.borderColor === "inherit") && inheritColor) textStyle.borderColor = inheritColor;
    }
}
function $6800dfcb6e1e2a44$export$155316a870a9d61e(opt, ecModel) {
    var gTextStyleModel = ecModel && ecModel.getModel("textStyle");
    return (0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)([
        // FIXME in node-canvas fontWeight is before fontStyle
        opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow("fontStyle") || "",
        opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow("fontWeight") || "",
        (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow("fontSize") || 12) + "px",
        opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow("fontFamily") || "sans-serif"
    ].join(" "));
}
var $6800dfcb6e1e2a44$export$f62786d3261ab0f4 = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $6800dfcb6e1e2a44$export$7bdbceaf9ab378f2(label, labelStatesModels, value, getDefaultText) {
    if (!label) return;
    var obj = $6800dfcb6e1e2a44$export$f62786d3261ab0f4(label);
    obj.prevValue = obj.value;
    obj.value = value;
    var normalLabelModel = labelStatesModels.normal;
    obj.valueAnimation = normalLabelModel.get("valueAnimation");
    if (obj.valueAnimation) {
        obj.precision = normalLabelModel.get("precision");
        obj.defaultInterpolatedText = getDefaultText;
        obj.statesModels = labelStatesModels;
    }
}
function $6800dfcb6e1e2a44$export$dd6101605f5c186(textEl, dataIndex, data, animatableModel, labelFetcher) {
    var labelInnerStore = $6800dfcb6e1e2a44$export$f62786d3261ab0f4(textEl);
    if (!labelInnerStore.valueAnimation || labelInnerStore.prevValue === labelInnerStore.value) // Value not changed, no new label animation
    return;
    var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText;
    // Consider the case that being animating, do not use the `obj.value`,
    // Otherwise it will jump to the `obj.value` when this new animation started.
    var currValue = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
    var targetValue = labelInnerStore.value;
    function during(percent) {
        var interpolated = (0, $76d619f648247e6d$export$bd0439821a1869f3)(data, labelInnerStore.precision, currValue, targetValue, percent);
        labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
        var labelText = $6800dfcb6e1e2a44$var$getLabelText({
            labelDataIndex: dataIndex,
            labelFetcher: labelFetcher,
            defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ""
        }, labelInnerStore.statesModels, interpolated);
        $6800dfcb6e1e2a44$export$b533918394a58529(textEl, labelText);
    }
    textEl.percent = 0;
    (labelInnerStore.prevValue == null ? (0, $8b353638fbedfefa$export$a121566aadcfe021) : (0, $8b353638fbedfefa$export$c8dce3c08436e91e))(textEl, {
        // percent is used to prevent animation from being aborted #15916
        percent: 1
    }, animatableModel, dataIndex, null, during);
}



var $a8b74de3c15b55c3$var$PATH_COLOR = [
    "textStyle",
    "color"
];
var $a8b74de3c15b55c3$var$textStyleParams = [
    "fontStyle",
    "fontWeight",
    "fontSize",
    "fontFamily",
    "padding",
    "lineHeight",
    "rich",
    "width",
    "height",
    "overflow"
];
// TODO Performance improvement?
var $a8b74de3c15b55c3$var$tmpText = new (0, $fe885cc21795562b$export$2e2bcd8739ae039)();
var $a8b74de3c15b55c3$var$TextStyleMixin = /** @class */ function() {
    function TextStyleMixin() {}
    /**
   * Get color property or get color from option.textStyle.color
   */ // TODO Callback
    TextStyleMixin.prototype.getTextColor = function(isEmphasis) {
        var ecModel = this.ecModel;
        return this.getShallow("color") || (!isEmphasis && ecModel ? ecModel.get($a8b74de3c15b55c3$var$PATH_COLOR) : null);
    };
    /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */ TextStyleMixin.prototype.getFont = function() {
        return (0, $6800dfcb6e1e2a44$export$155316a870a9d61e)({
            fontStyle: this.getShallow("fontStyle"),
            fontWeight: this.getShallow("fontWeight"),
            fontSize: this.getShallow("fontSize"),
            fontFamily: this.getShallow("fontFamily")
        }, this.ecModel);
    };
    TextStyleMixin.prototype.getTextRect = function(text) {
        var style = {
            text: text,
            verticalAlign: this.getShallow("verticalAlign") || this.getShallow("baseline")
        };
        for(var i = 0; i < $a8b74de3c15b55c3$var$textStyleParams.length; i++)style[$a8b74de3c15b55c3$var$textStyleParams[i]] = this.getShallow($a8b74de3c15b55c3$var$textStyleParams[i]);
        $a8b74de3c15b55c3$var$tmpText.useStyle(style);
        $a8b74de3c15b55c3$var$tmpText.update();
        return $a8b74de3c15b55c3$var$tmpText.getBoundingRect();
    };
    return TextStyleMixin;
}();
var $a8b74de3c15b55c3$export$2e2bcd8739ae039 = $a8b74de3c15b55c3$var$TextStyleMixin;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $9c5206e1bd69e88f$export$9f34de5b59222949 = [
    [
        "lineWidth",
        "width"
    ],
    [
        "stroke",
        "color"
    ],
    [
        "opacity"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "shadowColor"
    ],
    [
        "lineDash",
        "type"
    ],
    [
        "lineDashOffset",
        "dashOffset"
    ],
    [
        "lineCap",
        "cap"
    ],
    [
        "lineJoin",
        "join"
    ],
    [
        "miterLimit"
    ]
];
var $9c5206e1bd69e88f$var$getLineStyle = (0, $06542048a26d4d91$export$2e2bcd8739ae039)($9c5206e1bd69e88f$export$9f34de5b59222949);
var $9c5206e1bd69e88f$export$91eeeeed4a69a7e7 = /** @class */ function() {
    function LineStyleMixin() {}
    LineStyleMixin.prototype.getLineStyle = function(excludes) {
        return $9c5206e1bd69e88f$var$getLineStyle(this, excludes);
    };
    return LineStyleMixin;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $c42afdfd2f0ddc96$export$ffb0bba5dde0130b = [
    [
        "fill",
        "color"
    ],
    [
        "stroke",
        "borderColor"
    ],
    [
        "lineWidth",
        "borderWidth"
    ],
    [
        "opacity"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "shadowColor"
    ],
    [
        "lineDash",
        "borderType"
    ],
    [
        "lineDashOffset",
        "borderDashOffset"
    ],
    [
        "lineCap",
        "borderCap"
    ],
    [
        "lineJoin",
        "borderJoin"
    ],
    [
        "miterLimit",
        "borderMiterLimit"
    ]
];
var $c42afdfd2f0ddc96$var$getItemStyle = (0, $06542048a26d4d91$export$2e2bcd8739ae039)($c42afdfd2f0ddc96$export$ffb0bba5dde0130b);
var $c42afdfd2f0ddc96$export$e4f01e48d6fda412 = /** @class */ function() {
    function ItemStyleMixin() {}
    ItemStyleMixin.prototype.getItemStyle = function(excludes, includes) {
        return $c42afdfd2f0ddc96$var$getItemStyle(this, excludes, includes);
    };
    return ItemStyleMixin;
}();



var $6818646a97528290$var$Model = /** @class */ function() {
    function Model(option, parentModel, ecModel) {
        this.parentModel = parentModel;
        this.ecModel = ecModel;
        this.option = option;
    // Simple optimization
    // if (this.init) {
    //     if (arguments.length <= 4) {
    //         this.init(option, parentModel, ecModel, extraOpt);
    //     }
    //     else {
    //         this.init.apply(this, arguments);
    //     }
    // }
    }
    Model.prototype.init = function(option, parentModel, ecModel) {
        var rest = [];
        for(var _i = 3; _i < arguments.length; _i++)rest[_i - 3] = arguments[_i];
    };
    /**
   * Merge the input option to me.
   */ Model.prototype.mergeOption = function(option, ecModel) {
        (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(this.option, option, true);
    };
    // `path` can be 'a.b.c', so the return value type have to be `ModelOption`
    // TODO: TYPE strict key check?
    // get(path: string | string[], ignoreParent?: boolean): ModelOption;
    Model.prototype.get = function(path, ignoreParent) {
        if (path == null) return this.option;
        return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
    };
    Model.prototype.getShallow = function(key, ignoreParent) {
        var option = this.option;
        var val = option == null ? option : option[key];
        if (val == null && !ignoreParent) {
            var parentModel = this.parentModel;
            if (parentModel) // FIXME:TS do not know how to make it works
            val = parentModel.getShallow(key);
        }
        return val;
    };
    // `path` can be 'a.b.c', so the return value type have to be `Model<ModelOption>`
    // getModel(path: string | string[], parentModel?: Model): Model;
    // TODO 'a.b.c' is deprecated
    Model.prototype.getModel = function(path, parentModel) {
        var hasPath = path != null;
        var pathFinal = hasPath ? this.parsePath(path) : null;
        var obj = hasPath ? this._doGet(pathFinal) : this.option;
        parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
        return new Model(obj, parentModel, this.ecModel);
    };
    /**
   * If model has option
   */ Model.prototype.isEmpty = function() {
        return this.option == null;
    };
    Model.prototype.restoreData = function() {};
    // Pending
    Model.prototype.clone = function() {
        var Ctor = this.constructor;
        return new Ctor((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(this.option));
    };
    // setReadOnly(properties): void {
    // clazzUtil.setReadOnly(this, properties);
    // }
    // If path is null/undefined, return null/undefined.
    Model.prototype.parsePath = function(path) {
        if (typeof path === "string") return path.split(".");
        return path;
    };
    // Resolve path for parent. Perhaps useful when parent use a different property.
    // Default to be a identity resolver.
    // Can be modified to a different resolver.
    Model.prototype.resolveParentPath = function(path) {
        return path;
    };
    // FIXME:TS check whether put this method here
    Model.prototype.isAnimationEnabled = function() {
        if (!(0, $ce6dd58693a21851$export$2e2bcd8739ae039).node && this.option) {
            if (this.option.animation != null) return !!this.option.animation;
            else if (this.parentModel) return this.parentModel.isAnimationEnabled();
        }
    };
    Model.prototype._doGet = function(pathArr, parentModel) {
        var obj = this.option;
        if (!pathArr) return obj;
        for(var i = 0; i < pathArr.length; i++){
            // Ignore empty
            if (!pathArr[i]) continue;
            // obj could be number/string/... (like 0)
            obj = obj && typeof obj === "object" ? obj[pathArr[i]] : null;
            if (obj == null) break;
        }
        if (obj == null && parentModel) obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
        return obj;
    };
    return Model;
}();
// Enable Model.extend.
(0, $cd5f95cf03b4e3e7$export$cd4c3a4dca301c70)($6818646a97528290$var$Model);
(0, $cd5f95cf03b4e3e7$export$e1aac4552ae82081)($6818646a97528290$var$Model);
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($6818646a97528290$var$Model, (0, $9c5206e1bd69e88f$export$91eeeeed4a69a7e7));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($6818646a97528290$var$Model, (0, $c42afdfd2f0ddc96$export$e4f01e48d6fda412));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($6818646a97528290$var$Model, (0, $cb2a96727da5284d$export$a3a0ed7e2dd84c9e));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($6818646a97528290$var$Model, (0, $a8b74de3c15b55c3$export$2e2bcd8739ae039));
var $6818646a97528290$export$2e2bcd8739ae039 = $6818646a97528290$var$Model;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


// A random offset
var $5370df662b2caf37$var$base = Math.round(Math.random() * 10);
function $5370df662b2caf37$export$6d2b3473b0986646(type) {
    // Considering the case of crossing js context,
    // use Math.random to make id as unique as possible.
    return [
        type || "",
        $5370df662b2caf37$var$base++
    ].join("_");
}
function $5370df662b2caf37$export$b9faf30b7d655a6f(target) {
    var subTypeDefaulters = {};
    target.registerSubTypeDefaulter = function(componentType, defaulter) {
        var componentTypeInfo = (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(componentType);
        subTypeDefaulters[componentTypeInfo.main] = defaulter;
    };
    target.determineSubType = function(componentType, option) {
        var type = option.type;
        if (!type) {
            var componentTypeMain = (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(componentType).main;
            if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) type = subTypeDefaulters[componentTypeMain](option);
        }
        return type;
    };
}
function $5370df662b2caf37$export$ce592d345a3ec040(entity, dependencyGetter) {
    /**
   * @param targetNameList Target Component type list.
   *                       Can be ['aa', 'bb', 'aa.xx']
   * @param fullNameList By which we can build dependency graph.
   * @param callback Params: componentType, dependencies.
   * @param context Scope of callback.
   */ entity.topologicalTravel = function(targetNameList, fullNameList, callback, context) {
        if (!targetNameList.length) return;
        var result = makeDepndencyGraph(fullNameList);
        var graph = result.graph;
        var noEntryList = result.noEntryList;
        var targetNameSet = {};
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(targetNameList, function(name) {
            targetNameSet[name] = true;
        });
        while(noEntryList.length){
            var currComponentType = noEntryList.pop();
            var currVertex = graph[currComponentType];
            var isInTargetNameSet = !!targetNameSet[currComponentType];
            if (isInTargetNameSet) {
                callback.call(context, currComponentType, currVertex.originalDeps.slice());
                delete targetNameSet[currComponentType];
            }
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
        }
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(targetNameSet, function() {
            var errMsg = "";
            throw new Error(errMsg);
        });
        function removeEdge(succComponentType) {
            graph[succComponentType].entryCount--;
            if (graph[succComponentType].entryCount === 0) noEntryList.push(succComponentType);
        }
        // Consider this case: legend depends on series, and we call
        // chart.setOption({series: [...]}), where only series is in option.
        // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
        // not be called, but only sereis.mergeOption is called. Thus legend
        // have no chance to update its local record about series (like which
        // name of series is available in legend).
        function removeEdgeAndAdd(succComponentType) {
            targetNameSet[succComponentType] = true;
            removeEdge(succComponentType);
        }
    };
    function makeDepndencyGraph(fullNameList) {
        var graph = {};
        var noEntryList = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(fullNameList, function(name) {
            var thisItem = createDependencyGraphItem(graph, name);
            var originalDeps = thisItem.originalDeps = dependencyGetter(name);
            var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
            thisItem.entryCount = availableDeps.length;
            if (thisItem.entryCount === 0) noEntryList.push(name);
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(availableDeps, function(dependentName) {
                if ($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(thisItem.predecessor, dependentName) < 0) thisItem.predecessor.push(dependentName);
                var thatItem = createDependencyGraphItem(graph, dependentName);
                if ($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(thatItem.successor, dependentName) < 0) thatItem.successor.push(name);
            });
        });
        return {
            graph: graph,
            noEntryList: noEntryList
        };
    }
    function createDependencyGraphItem(graph, name) {
        if (!graph[name]) graph[name] = {
            predecessor: [],
            successor: []
        };
        return graph[name];
    }
    function getAvailableDependencies(originalDeps, fullNameList) {
        var availableDeps = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(originalDeps, function(dep) {
            $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(fullNameList, dep) >= 0 && availableDeps.push(dep);
        });
        return availableDeps;
    }
}
function $5370df662b2caf37$export$68acc510e46fef2(superOption, subOption) {
    // See also `model/Component.ts#getDefaultOption`
    return $7a1bd9c2710fea0d$export$4950aa0f605343fb($7a1bd9c2710fea0d$export$4950aa0f605343fb({}, superOption, true), subOption, true);
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Layout helpers for each component positioning



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ /**
 * Language: English.
 */ var $af0c4f5df0270dd8$export$2e2bcd8739ae039 = {
    time: {
        month: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        monthAbbr: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        dayOfWeek: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        dayOfWeekAbbr: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ]
    },
    legend: {
        selector: {
            all: "All",
            inverse: "Inv"
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: "Box Select",
                polygon: "Lasso Select",
                lineX: "Horizontally Select",
                lineY: "Vertically Select",
                keep: "Keep Selections",
                clear: "Clear Selections"
            }
        },
        dataView: {
            title: "Data View",
            lang: [
                "Data View",
                "Close",
                "Refresh"
            ]
        },
        dataZoom: {
            title: {
                zoom: "Zoom",
                back: "Zoom Reset"
            }
        },
        magicType: {
            title: {
                line: "Switch to Line Chart",
                bar: "Switch to Bar Chart",
                stack: "Stack",
                tiled: "Tile"
            }
        },
        restore: {
            title: "Restore"
        },
        saveAsImage: {
            title: "Save as Image",
            lang: [
                "Right Click to Save Image"
            ]
        }
    },
    series: {
        typeNames: {
            pie: "Pie chart",
            bar: "Bar chart",
            line: "Line chart",
            scatter: "Scatter plot",
            effectScatter: "Ripple scatter plot",
            radar: "Radar chart",
            tree: "Tree",
            treemap: "Treemap",
            boxplot: "Boxplot",
            candlestick: "Candlestick",
            k: "K line chart",
            heatmap: "Heat map",
            map: "Map",
            parallel: "Parallel coordinate map",
            lines: "Line graph",
            graph: "Relationship graph",
            sankey: "Sankey diagram",
            funnel: "Funnel chart",
            gauge: "Gauge",
            pictorialBar: "Pictorial bar",
            themeRiver: "Theme River Map",
            sunburst: "Sunburst",
            custom: "Custom chart",
            chart: "Chart"
        }
    },
    aria: {
        general: {
            withTitle: 'This is a chart about "{title}"',
            withoutTitle: "This is a chart"
        },
        series: {
            single: {
                prefix: "",
                withName: " with type {seriesType} named {seriesName}.",
                withoutName: " with type {seriesType}."
            },
            multiple: {
                prefix: ". It consists of {seriesCount} series count.",
                withName: " The {seriesId} series is a {seriesType} representing {seriesName}.",
                withoutName: " The {seriesId} series is a {seriesType}.",
                separator: {
                    middle: "",
                    end: ""
                }
            }
        },
        data: {
            allData: "The data is as follows: ",
            partialData: "The first {displayCnt} items are: ",
            withName: "the data for {name} is {value}",
            withoutName: "{value}",
            separator: {
                middle: ", ",
                end: ". "
            }
        }
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ var $b3a62bfb11b19829$export$2e2bcd8739ae039 = {
    time: {
        month: [
            "\u4E00\u6708",
            "\u4E8C\u6708",
            "\u4E09\u6708",
            "\u56DB\u6708",
            "\u4E94\u6708",
            "\u516D\u6708",
            "\u4E03\u6708",
            "\u516B\u6708",
            "\u4E5D\u6708",
            "\u5341\u6708",
            "\u5341\u4E00\u6708",
            "\u5341\u4E8C\u6708"
        ],
        monthAbbr: [
            "1\u6708",
            "2\u6708",
            "3\u6708",
            "4\u6708",
            "5\u6708",
            "6\u6708",
            "7\u6708",
            "8\u6708",
            "9\u6708",
            "10\u6708",
            "11\u6708",
            "12\u6708"
        ],
        dayOfWeek: [
            "\u661F\u671F\u65E5",
            "\u661F\u671F\u4E00",
            "\u661F\u671F\u4E8C",
            "\u661F\u671F\u4E09",
            "\u661F\u671F\u56DB",
            "\u661F\u671F\u4E94",
            "\u661F\u671F\u516D"
        ],
        dayOfWeekAbbr: [
            "\u65E5",
            "\u4E00",
            "\u4E8C",
            "\u4E09",
            "\u56DB",
            "\u4E94",
            "\u516D"
        ]
    },
    legend: {
        selector: {
            all: "\u5168\u9009",
            inverse: "\u53CD\u9009"
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: "\u77E9\u5F62\u9009\u62E9",
                polygon: "\u5708\u9009",
                lineX: "\u6A2A\u5411\u9009\u62E9",
                lineY: "\u7EB5\u5411\u9009\u62E9",
                keep: "\u4FDD\u6301\u9009\u62E9",
                clear: "\u6E05\u9664\u9009\u62E9"
            }
        },
        dataView: {
            title: "\u6570\u636E\u89C6\u56FE",
            lang: [
                "\u6570\u636E\u89C6\u56FE",
                "\u5173\u95ED",
                "\u5237\u65B0"
            ]
        },
        dataZoom: {
            title: {
                zoom: "\u533A\u57DF\u7F29\u653E",
                back: "\u533A\u57DF\u7F29\u653E\u8FD8\u539F"
            }
        },
        magicType: {
            title: {
                line: "\u5207\u6362\u4E3A\u6298\u7EBF\u56FE",
                bar: "\u5207\u6362\u4E3A\u67F1\u72B6\u56FE",
                stack: "\u5207\u6362\u4E3A\u5806\u53E0",
                tiled: "\u5207\u6362\u4E3A\u5E73\u94FA"
            }
        },
        restore: {
            title: "\u8FD8\u539F"
        },
        saveAsImage: {
            title: "\u4FDD\u5B58\u4E3A\u56FE\u7247",
            lang: [
                "\u53F3\u952E\u53E6\u5B58\u4E3A\u56FE\u7247"
            ]
        }
    },
    series: {
        typeNames: {
            pie: "\u997C\u56FE",
            bar: "\u67F1\u72B6\u56FE",
            line: "\u6298\u7EBF\u56FE",
            scatter: "\u6563\u70B9\u56FE",
            effectScatter: "\u6D9F\u6F2A\u6563\u70B9\u56FE",
            radar: "\u96F7\u8FBE\u56FE",
            tree: "\u6811\u56FE",
            treemap: "\u77E9\u5F62\u6811\u56FE",
            boxplot: "\u7BB1\u578B\u56FE",
            candlestick: "K\u7EBF\u56FE",
            k: "K\u7EBF\u56FE",
            heatmap: "\u70ED\u529B\u56FE",
            map: "\u5730\u56FE",
            parallel: "\u5E73\u884C\u5750\u6807\u56FE",
            lines: "\u7EBF\u56FE",
            graph: "\u5173\u7CFB\u56FE",
            sankey: "\u6851\u57FA\u56FE",
            funnel: "\u6F0F\u6597\u56FE",
            gauge: "\u4EEA\u8868\u76D8\u56FE",
            pictorialBar: "\u8C61\u5F62\u67F1\u56FE",
            themeRiver: "\u4E3B\u9898\u6CB3\u6D41\u56FE",
            sunburst: "\u65ED\u65E5\u56FE",
            custom: "\u81EA\u5B9A\u4E49\u56FE\u8868",
            chart: "\u56FE\u8868"
        }
    },
    aria: {
        general: {
            withTitle: "\u8FD9\u662F\u4E00\u4E2A\u5173\u4E8E\u201C{title}\u201D\u7684\u56FE\u8868\u3002",
            withoutTitle: "\u8FD9\u662F\u4E00\u4E2A\u56FE\u8868\uFF0C"
        },
        series: {
            single: {
                prefix: "",
                withName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\uFF0C\u8868\u793A{seriesName}\u3002",
                withoutName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\u3002"
            },
            multiple: {
                prefix: "\u5B83\u7531{seriesCount}\u4E2A\u56FE\u8868\u7CFB\u5217\u7EC4\u6210\u3002",
                withName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A\u8868\u793A{seriesName}\u7684{seriesType}\uFF0C",
                withoutName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A{seriesType}\uFF0C",
                separator: {
                    middle: "\uFF1B",
                    end: "\u3002"
                }
            }
        },
        data: {
            allData: "\u5176\u6570\u636E\u662F\u2014\u2014",
            partialData: "\u5176\u4E2D\uFF0C\u524D{displayCnt}\u9879\u662F\u2014\u2014",
            withName: "{name}\u7684\u6570\u636E\u662F{value}",
            withoutName: "{value}",
            separator: {
                middle: "\uFF0C",
                end: ""
            }
        }
    }
};



var $9b0a1ef4bcc91e7d$var$LOCALE_ZH = "ZH";
var $9b0a1ef4bcc91e7d$var$LOCALE_EN = "EN";
var $9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE = $9b0a1ef4bcc91e7d$var$LOCALE_EN;
var $9b0a1ef4bcc91e7d$var$localeStorage = {};
var $9b0a1ef4bcc91e7d$var$localeModels = {};
var $9b0a1ef4bcc91e7d$export$9a2147b3808d4c6b = !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported ? $9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE : function() {
    var langStr = /* eslint-disable-next-line */ (document.documentElement.lang || navigator.language || navigator.browserLanguage || $9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE).toUpperCase();
    return langStr.indexOf($9b0a1ef4bcc91e7d$var$LOCALE_ZH) > -1 ? $9b0a1ef4bcc91e7d$var$LOCALE_ZH : $9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE;
}();
function $9b0a1ef4bcc91e7d$export$bab6a7822cc1e2cd(locale, localeObj) {
    locale = locale.toUpperCase();
    $9b0a1ef4bcc91e7d$var$localeModels[locale] = new (0, $6818646a97528290$export$2e2bcd8739ae039)(localeObj);
    $9b0a1ef4bcc91e7d$var$localeStorage[locale] = localeObj;
}
function $9b0a1ef4bcc91e7d$export$ddc371781a6af754(locale) {
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(locale)) {
        var localeObj = $9b0a1ef4bcc91e7d$var$localeStorage[locale.toUpperCase()] || {};
        if (locale === $9b0a1ef4bcc91e7d$var$LOCALE_ZH || locale === $9b0a1ef4bcc91e7d$var$LOCALE_EN) return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(localeObj);
        else return (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(localeObj), (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)($9b0a1ef4bcc91e7d$var$localeStorage[$9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE]), false);
    } else return (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(locale), (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)($9b0a1ef4bcc91e7d$var$localeStorage[$9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE]), false);
}
function $9b0a1ef4bcc91e7d$export$37cc638e0e11865f(lang) {
    return $9b0a1ef4bcc91e7d$var$localeModels[lang];
}
function $9b0a1ef4bcc91e7d$export$1188f179b2597821() {
    return $9b0a1ef4bcc91e7d$var$localeModels[$9b0a1ef4bcc91e7d$var$DEFAULT_LOCALE];
}
// Default locale
$9b0a1ef4bcc91e7d$export$bab6a7822cc1e2cd($9b0a1ef4bcc91e7d$var$LOCALE_EN, (0, $af0c4f5df0270dd8$export$2e2bcd8739ae039));
$9b0a1ef4bcc91e7d$export$bab6a7822cc1e2cd($9b0a1ef4bcc91e7d$var$LOCALE_ZH, (0, $b3a62bfb11b19829$export$2e2bcd8739ae039));



var $0ae0381fb3fd176f$export$32c0454ceff7f92d = 1000;
var $0ae0381fb3fd176f$export$35acaebf644db34e = $0ae0381fb3fd176f$export$32c0454ceff7f92d * 60;
var $0ae0381fb3fd176f$export$82541edf19e5e3b0 = $0ae0381fb3fd176f$export$35acaebf644db34e * 60;
var $0ae0381fb3fd176f$export$a97a1358cbb650ab = $0ae0381fb3fd176f$export$82541edf19e5e3b0 * 24;
var $0ae0381fb3fd176f$export$99cafda57477293d = $0ae0381fb3fd176f$export$a97a1358cbb650ab * 365;
var $0ae0381fb3fd176f$export$f7854271ddbda64e = {
    year: "{yyyy}",
    month: "{MMM}",
    day: "{d}",
    hour: "{HH}:{mm}",
    minute: "{HH}:{mm}",
    second: "{HH}:{mm}:{ss}",
    millisecond: "{HH}:{mm}:{ss} {SSS}",
    none: "{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}"
};
var $0ae0381fb3fd176f$var$fullDayFormatter = "{yyyy}-{MM}-{dd}";
var $0ae0381fb3fd176f$export$445bdbd8d2334e40 = {
    year: "{yyyy}",
    month: "{yyyy}-{MM}",
    day: $0ae0381fb3fd176f$var$fullDayFormatter,
    hour: $0ae0381fb3fd176f$var$fullDayFormatter + " " + $0ae0381fb3fd176f$export$f7854271ddbda64e.hour,
    minute: $0ae0381fb3fd176f$var$fullDayFormatter + " " + $0ae0381fb3fd176f$export$f7854271ddbda64e.minute,
    second: $0ae0381fb3fd176f$var$fullDayFormatter + " " + $0ae0381fb3fd176f$export$f7854271ddbda64e.second,
    millisecond: $0ae0381fb3fd176f$export$f7854271ddbda64e.none
};
var $0ae0381fb3fd176f$export$87100da04d711986 = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
];
var $0ae0381fb3fd176f$export$833c398a55654bb7 = [
    "year",
    "half-year",
    "quarter",
    "month",
    "week",
    "half-week",
    "day",
    "half-day",
    "quarter-day",
    "hour",
    "minute",
    "second",
    "millisecond"
];
function $0ae0381fb3fd176f$export$5d04458e2a6c373e(str, len) {
    str += "";
    return "0000".substr(0, len - str.length) + str;
}
function $0ae0381fb3fd176f$export$1da4b91a25d7e1c8(timeUnit) {
    switch(timeUnit){
        case "half-year":
        case "quarter":
            return "month";
        case "week":
        case "half-week":
            return "day";
        case "half-day":
        case "quarter-day":
            return "hour";
        default:
            // year, minutes, second, milliseconds
            return timeUnit;
    }
}
function $0ae0381fb3fd176f$export$beb5920b69c13da(timeUnit) {
    return timeUnit === $0ae0381fb3fd176f$export$1da4b91a25d7e1c8(timeUnit);
}
function $0ae0381fb3fd176f$export$124c820721c4f66b(timeUnit) {
    switch(timeUnit){
        case "year":
        case "month":
            return "day";
        case "millisecond":
            return "millisecond";
        default:
            // Also for day, hour, minute, second
            return "second";
    }
}
function $0ae0381fb3fd176f$export$d9468344d3651243(// Note: The result based on `isUTC` are totally different, which can not be just simply
// substituted by the result without `isUTC`. So we make the param `isUTC` mandatory.
time, template, isUTC, lang) {
    var date = $cfc1f3b422a3185f$export$6b862160d295c8e(time);
    var y = date[$0ae0381fb3fd176f$export$8d046fefed9a548e(isUTC)]();
    var M = date[$0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC)]() + 1;
    var q = Math.floor((M - 1) / 3) + 1;
    var d = date[$0ae0381fb3fd176f$export$4189e6cbc9753260(isUTC)]();
    var e = date["get" + (isUTC ? "UTC" : "") + "Day"]();
    var H = date[$0ae0381fb3fd176f$export$8b40b55b3c06cbe2(isUTC)]();
    var h = (H - 1) % 12 + 1;
    var m = date[$0ae0381fb3fd176f$export$8807847c5c71eded(isUTC)]();
    var s = date[$0ae0381fb3fd176f$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$0ae0381fb3fd176f$export$312207a92d041116(isUTC)]();
    var localeModel = lang instanceof (0, $6818646a97528290$export$2e2bcd8739ae039) ? lang : (0, $9b0a1ef4bcc91e7d$export$37cc638e0e11865f)(lang || (0, $9b0a1ef4bcc91e7d$export$9a2147b3808d4c6b)) || (0, $9b0a1ef4bcc91e7d$export$1188f179b2597821)();
    var timeModel = localeModel.getModel("time");
    var month = timeModel.get("month");
    var monthAbbr = timeModel.get("monthAbbr");
    var dayOfWeek = timeModel.get("dayOfWeek");
    var dayOfWeekAbbr = timeModel.get("dayOfWeekAbbr");
    return (template || "").replace(/{yyyy}/g, y + "").replace(/{yy}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(y % 100 + "", 2)).replace(/{Q}/g, q + "").replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(M, 2)).replace(/{M}/g, M + "").replace(/{dd}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(d, 2)).replace(/{d}/g, d + "").replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + "").replace(/{HH}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(H, 2)).replace(/{H}/g, H + "").replace(/{hh}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(h + "", 2)).replace(/{h}/g, h + "").replace(/{mm}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(m, 2)).replace(/{m}/g, m + "").replace(/{ss}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(s, 2)).replace(/{s}/g, s + "").replace(/{SSS}/g, $0ae0381fb3fd176f$export$5d04458e2a6c373e(S, 3)).replace(/{S}/g, S + "");
}
function $0ae0381fb3fd176f$export$fe777b6293828b5d(tick, idx, formatter, lang, isUTC) {
    var template = null;
    if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) // Single formatter for all units at all levels
    template = formatter;
    else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) // Callback formatter
    template = formatter(tick.value, idx, {
        level: tick.level
    });
    else {
        var defaults = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, $0ae0381fb3fd176f$export$f7854271ddbda64e);
        if (tick.level > 0) for(var i = 0; i < $0ae0381fb3fd176f$export$87100da04d711986.length; ++i)defaults[$0ae0381fb3fd176f$export$87100da04d711986[i]] = "{primary|" + defaults[$0ae0381fb3fd176f$export$87100da04d711986[i]] + "}";
        var mergedFormatter = formatter ? formatter.inherit === false ? formatter // Use formatter with bigger units
         : $7a1bd9c2710fea0d$export$ebe90cb607ad99e(formatter, defaults) : defaults;
        var unit = $0ae0381fb3fd176f$export$4dfb0417ad6555b7(tick.value, isUTC);
        if (mergedFormatter[unit]) template = mergedFormatter[unit];
        else if (mergedFormatter.inherit) {
            // Unit formatter is not defined and should inherit from bigger units
            var targetId = $0ae0381fb3fd176f$export$833c398a55654bb7.indexOf(unit);
            for(var i = targetId - 1; i >= 0; --i)if (mergedFormatter[unit]) {
                template = mergedFormatter[unit];
                break;
            }
            template = template || defaults.none;
        }
        if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(template)) {
            var levelId = tick.level == null ? 0 : tick.level >= 0 ? tick.level : template.length + tick.level;
            levelId = Math.min(levelId, template.length - 1);
            template = template[levelId];
        }
    }
    return $0ae0381fb3fd176f$export$d9468344d3651243(new Date(tick.value), template, isUTC, lang);
}
function $0ae0381fb3fd176f$export$4dfb0417ad6555b7(value, isUTC) {
    var date = $cfc1f3b422a3185f$export$6b862160d295c8e(value);
    var M = date[$0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC)]() + 1;
    var d = date[$0ae0381fb3fd176f$export$4189e6cbc9753260(isUTC)]();
    var h = date[$0ae0381fb3fd176f$export$8b40b55b3c06cbe2(isUTC)]();
    var m = date[$0ae0381fb3fd176f$export$8807847c5c71eded(isUTC)]();
    var s = date[$0ae0381fb3fd176f$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$0ae0381fb3fd176f$export$312207a92d041116(isUTC)]();
    var isSecond = S === 0;
    var isMinute = isSecond && s === 0;
    var isHour = isMinute && m === 0;
    var isDay = isHour && h === 0;
    var isMonth = isDay && d === 1;
    var isYear = isMonth && M === 1;
    if (isYear) return "year";
    else if (isMonth) return "month";
    else if (isDay) return "day";
    else if (isHour) return "hour";
    else if (isMinute) return "minute";
    else if (isSecond) return "second";
    else return "millisecond";
}
function $0ae0381fb3fd176f$export$e04e41a1e24ffd3f(value, unit, isUTC) {
    var date = $7a1bd9c2710fea0d$export$7e4aa119212bc614(value) ? $cfc1f3b422a3185f$export$6b862160d295c8e(value) : value;
    unit = unit || $0ae0381fb3fd176f$export$4dfb0417ad6555b7(value, isUTC);
    switch(unit){
        case "year":
            return date[$0ae0381fb3fd176f$export$8d046fefed9a548e(isUTC)]();
        case "half-year":
            return date[$0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC)]() >= 6 ? 1 : 0;
        case "quarter":
            return Math.floor((date[$0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC)]() + 1) / 4);
        case "month":
            return date[$0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC)]();
        case "day":
            return date[$0ae0381fb3fd176f$export$4189e6cbc9753260(isUTC)]();
        case "half-day":
            return date[$0ae0381fb3fd176f$export$8b40b55b3c06cbe2(isUTC)]() / 24;
        case "hour":
            return date[$0ae0381fb3fd176f$export$8b40b55b3c06cbe2(isUTC)]();
        case "minute":
            return date[$0ae0381fb3fd176f$export$8807847c5c71eded(isUTC)]();
        case "second":
            return date[$0ae0381fb3fd176f$export$8f49e73e2eebd168(isUTC)]();
        case "millisecond":
            return date[$0ae0381fb3fd176f$export$312207a92d041116(isUTC)]();
    }
}
function $0ae0381fb3fd176f$export$8d046fefed9a548e(isUTC) {
    return isUTC ? "getUTCFullYear" : "getFullYear";
}
function $0ae0381fb3fd176f$export$5c242a801a23eec7(isUTC) {
    return isUTC ? "getUTCMonth" : "getMonth";
}
function $0ae0381fb3fd176f$export$4189e6cbc9753260(isUTC) {
    return isUTC ? "getUTCDate" : "getDate";
}
function $0ae0381fb3fd176f$export$8b40b55b3c06cbe2(isUTC) {
    return isUTC ? "getUTCHours" : "getHours";
}
function $0ae0381fb3fd176f$export$8807847c5c71eded(isUTC) {
    return isUTC ? "getUTCMinutes" : "getMinutes";
}
function $0ae0381fb3fd176f$export$8f49e73e2eebd168(isUTC) {
    return isUTC ? "getUTCSeconds" : "getSeconds";
}
function $0ae0381fb3fd176f$export$312207a92d041116(isUTC) {
    return isUTC ? "getUTCMilliseconds" : "getMilliseconds";
}
function $0ae0381fb3fd176f$export$43fbeac90913b151(isUTC) {
    return isUTC ? "setUTCFullYear" : "setFullYear";
}
function $0ae0381fb3fd176f$export$233f59998ed71c09(isUTC) {
    return isUTC ? "setUTCMonth" : "setMonth";
}
function $0ae0381fb3fd176f$export$82fd379a67f37fa0(isUTC) {
    return isUTC ? "setUTCDate" : "setDate";
}
function $0ae0381fb3fd176f$export$b6f943e8d23c15bb(isUTC) {
    return isUTC ? "setUTCHours" : "setHours";
}
function $0ae0381fb3fd176f$export$50303078793fc7d(isUTC) {
    return isUTC ? "setUTCMinutes" : "setMinutes";
}
function $0ae0381fb3fd176f$export$a4a908acda9c3118(isUTC) {
    return isUTC ? "setUTCSeconds" : "setSeconds";
}
function $0ae0381fb3fd176f$export$c047afab75f6d84(isUTC) {
    return isUTC ? "setUTCMilliseconds" : "setMilliseconds";
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $f626ce0db1e76fe5$export$372ffda650a6e70d(text, font, align, verticalAlign, padding, rich, truncate, lineHeight) {
    var textEl = new (0, $fe885cc21795562b$export$2e2bcd8739ae039)({
        style: {
            text: text,
            font: font,
            align: align,
            verticalAlign: verticalAlign,
            padding: padding,
            rich: rich,
            overflow: truncate ? "truncate" : null,
            lineHeight: lineHeight
        }
    });
    return textEl.getBoundingRect();
}


function $c84c9521536c601a$export$b6fe44657ce35c42(x) {
    if (!(0, $cfc1f3b422a3185f$export$e90fb89750dba83f)(x)) return $7a1bd9c2710fea0d$export$844ec244b1367d54(x) ? x : "-";
    var parts = (x + "").split(".");
    return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, "$1,") + (parts.length > 1 ? "." + parts[1] : "");
}
function $c84c9521536c601a$export$86f54f62aa7a7514(str, upperCaseFirst) {
    str = (str || "").toLowerCase().replace(/-(.)/g, function(match, group1) {
        return group1.toUpperCase();
    });
    if (upperCaseFirst && str) str = str.charAt(0).toUpperCase() + str.slice(1);
    return str;
}
var $c84c9521536c601a$export$f3a38102c49f4268 = $7a1bd9c2710fea0d$export$f3a38102c49f4268;
function $c84c9521536c601a$export$3cd8db88714decfc(value, valueType, useUTC) {
    var USER_READABLE_DEFUALT_TIME_PATTERN = "{yyyy}-{MM}-{dd} {HH}:{mm}:{ss}";
    function stringToUserReadable(str) {
        return str && $7a1bd9c2710fea0d$export$87c2784dc9fc4ab(str) ? str : "-";
    }
    function isNumberUserReadable(num) {
        return !!(num != null && !isNaN(num) && isFinite(num));
    }
    var isTypeTime = valueType === "time";
    var isValueDate = value instanceof Date;
    if (isTypeTime || isValueDate) {
        var date = isTypeTime ? (0, $cfc1f3b422a3185f$export$6b862160d295c8e)(value) : value;
        if (!isNaN(+date)) return (0, $0ae0381fb3fd176f$export$d9468344d3651243)(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
        else if (isValueDate) return "-";
    // In other cases, continue to try to display the value in the following code.
    }
    if (valueType === "ordinal") return $7a1bd9c2710fea0d$export$29d0bb2a4e07b252(value) ? stringToUserReadable(value) : $7a1bd9c2710fea0d$export$7e4aa119212bc614(value) ? isNumberUserReadable(value) ? value + "" : "-" : "-";
    // By default.
    var numericResult = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(value);
    return isNumberUserReadable(numericResult) ? $c84c9521536c601a$export$b6fe44657ce35c42(numericResult) : $7a1bd9c2710fea0d$export$29d0bb2a4e07b252(value) ? stringToUserReadable(value) : typeof value === "boolean" ? value + "" : "-";
}
var $c84c9521536c601a$var$TPL_VAR_ALIAS = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g"
];
var $c84c9521536c601a$var$wrapVar = function(varName, seriesIdx) {
    return "{" + varName + (seriesIdx == null ? "" : seriesIdx) + "}";
};
function $c84c9521536c601a$export$2028496a35766e41(tpl, paramsList, encode) {
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(paramsList)) paramsList = [
        paramsList
    ];
    var seriesLen = paramsList.length;
    if (!seriesLen) return "";
    var $vars = paramsList[0].$vars || [];
    for(var i = 0; i < $vars.length; i++){
        var alias = $c84c9521536c601a$var$TPL_VAR_ALIAS[i];
        tpl = tpl.replace($c84c9521536c601a$var$wrapVar(alias), $c84c9521536c601a$var$wrapVar(alias, 0));
    }
    for(var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++)for(var k = 0; k < $vars.length; k++){
        var val = paramsList[seriesIdx][$vars[k]];
        tpl = tpl.replace($c84c9521536c601a$var$wrapVar($c84c9521536c601a$var$TPL_VAR_ALIAS[k], seriesIdx), encode ? (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(val) : val);
    }
    return tpl;
}
function $c84c9521536c601a$export$2fa08233ee42f8e1(tpl, param, encode) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(param, function(value, key) {
        tpl = tpl.replace("{" + key + "}", encode ? (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(value) : value);
    });
    return tpl;
}
function $c84c9521536c601a$export$1987a3dbdf3c45ca(inOpt, extraCssText) {
    var opt = $7a1bd9c2710fea0d$export$844ec244b1367d54(inOpt) ? {
        color: inOpt,
        extraCssText: extraCssText
    } : inOpt || {};
    var color = opt.color;
    var type = opt.type;
    extraCssText = opt.extraCssText;
    var renderMode = opt.renderMode || "html";
    if (!color) return "";
    if (renderMode === "html") return type === "subItem" ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(color) + ";" + (extraCssText || "") + '"></span>' : '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(color) + ";" + (extraCssText || "") + '"></span>';
    else {
        // Should better not to auto generate style name by auto-increment number here.
        // Because this util is usually called in tooltip formatter, which is probably
        // called repeatedly when mouse move and the auto-increment number increases fast.
        // Users can make their own style name by theirselves, make it unique and readable.
        var markerId = opt.markerId || "markerX";
        return {
            renderMode: renderMode,
            content: "{" + markerId + "|}  ",
            style: type === "subItem" ? {
                width: 4,
                height: 4,
                borderRadius: 2,
                backgroundColor: color
            } : {
                width: 10,
                height: 10,
                borderRadius: 5,
                backgroundColor: color
            }
        };
    }
}
function $c84c9521536c601a$export$3203edd9e5edd663(tpl, value, isUTC) {
    if (tpl === "week" || tpl === "month" || tpl === "quarter" || tpl === "half-year" || tpl === "year") tpl = "MM-dd\nyyyy";
    var date = (0, $cfc1f3b422a3185f$export$6b862160d295c8e)(value);
    var getUTC = isUTC ? "getUTC" : "get";
    var y = date[getUTC + "FullYear"]();
    var M = date[getUTC + "Month"]() + 1;
    var d = date[getUTC + "Date"]();
    var h = date[getUTC + "Hours"]();
    var m = date[getUTC + "Minutes"]();
    var s = date[getUTC + "Seconds"]();
    var S = date[getUTC + "Milliseconds"]();
    tpl = tpl.replace("MM", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(M, 2)).replace("M", M).replace("yyyy", y).replace("yy", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(y % 100 + "", 2)).replace("dd", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(d, 2)).replace("d", d).replace("hh", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(h, 2)).replace("h", h).replace("mm", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(m, 2)).replace("m", m).replace("ss", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(s, 2)).replace("s", s).replace("SSS", (0, $0ae0381fb3fd176f$export$5d04458e2a6c373e)(S, 3));
    return tpl;
}
function $c84c9521536c601a$export$38a1e7552f497c0e(str) {
    return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}
function $c84c9521536c601a$export$cda04d03233e5555(color, defaultColor) {
    defaultColor = defaultColor || "transparent";
    return $7a1bd9c2710fea0d$export$844ec244b1367d54(color) ? color : $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
}
function $c84c9521536c601a$export$13e13f9b96dbe8fa(link, target) {
    /* global window */ if (target === "_blank" || target === "blank") {
        var blank = window.open();
        blank.opener = null;
        blank.location.href = link;
    } else window.open(link, target);
}


var $93b9bc7f22ac7369$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $93b9bc7f22ac7369$export$a9aa2cc018afbed = [
    "left",
    "right",
    "top",
    "bottom",
    "width",
    "height"
];
var $93b9bc7f22ac7369$export$d7fd4338c7b20804 = [
    [
        "width",
        "left",
        "right"
    ],
    [
        "height",
        "top",
        "bottom"
    ]
];
function $93b9bc7f22ac7369$var$boxLayout(orient, group, gap, maxWidth, maxHeight) {
    var x = 0;
    var y = 0;
    if (maxWidth == null) maxWidth = Infinity;
    if (maxHeight == null) maxHeight = Infinity;
    var currentLineMaxSize = 0;
    group.eachChild(function(child, idx) {
        var rect = child.getBoundingRect();
        var nextChild = group.childAt(idx + 1);
        var nextChildRect = nextChild && nextChild.getBoundingRect();
        var nextX;
        var nextY;
        if (orient === "horizontal") {
            var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
            nextX = x + moveX;
            // Wrap when width exceeds maxWidth or meet a `newline` group
            // FIXME compare before adding gap?
            if (nextX > maxWidth || child.newline) {
                x = 0;
                nextX = moveX;
                y += currentLineMaxSize + gap;
                currentLineMaxSize = rect.height;
            } else // FIXME: consider rect.y is not `0`?
            currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
        } else {
            var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
            nextY = y + moveY;
            // Wrap when width exceeds maxHeight or meet a `newline` group
            if (nextY > maxHeight || child.newline) {
                x += currentLineMaxSize + gap;
                y = 0;
                nextY = moveY;
                currentLineMaxSize = rect.width;
            } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
        }
        if (child.newline) return;
        child.x = x;
        child.y = y;
        child.markRedraw();
        orient === "horizontal" ? x = nextX + gap : y = nextY + gap;
    });
}
var $93b9bc7f22ac7369$export$827f4ee28efc37 = $93b9bc7f22ac7369$var$boxLayout;
var $93b9bc7f22ac7369$export$be20d9158c17374c = $7a1bd9c2710fea0d$export$c3095a23b368d1f2($93b9bc7f22ac7369$var$boxLayout, "vertical");
var $93b9bc7f22ac7369$export$ae65a483d943e7a7 = $7a1bd9c2710fea0d$export$c3095a23b368d1f2($93b9bc7f22ac7369$var$boxLayout, "horizontal");
function $93b9bc7f22ac7369$export$145a8938a85a22b1(positionInfo, containerRect, margin) {
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var x = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.left, containerWidth);
    var y = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.top, containerHeight);
    var x2 = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.right, containerWidth);
    var y2 = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.bottom, containerHeight);
    (isNaN(x) || isNaN(parseFloat(positionInfo.left))) && (x = 0);
    (isNaN(x2) || isNaN(parseFloat(positionInfo.right))) && (x2 = containerWidth);
    (isNaN(y) || isNaN(parseFloat(positionInfo.top))) && (y = 0);
    (isNaN(y2) || isNaN(parseFloat(positionInfo.bottom))) && (y2 = containerHeight);
    margin = $c84c9521536c601a$export$f3a38102c49f4268(margin || 0);
    return {
        width: Math.max(x2 - x - margin[1] - margin[3], 0),
        height: Math.max(y2 - y - margin[0] - margin[2], 0)
    };
}
function $93b9bc7f22ac7369$export$4517a5ca639a7293(positionInfo, containerRect, margin) {
    margin = $c84c9521536c601a$export$f3a38102c49f4268(margin || 0);
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var left = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.left, containerWidth);
    var top = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.top, containerHeight);
    var right = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.right, containerWidth);
    var bottom = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.bottom, containerHeight);
    var width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.width, containerWidth);
    var height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionInfo.height, containerHeight);
    var verticalMargin = margin[2] + margin[0];
    var horizontalMargin = margin[1] + margin[3];
    var aspect = positionInfo.aspect;
    // If width is not specified, calculate width from left and right
    if (isNaN(width)) width = containerWidth - right - horizontalMargin - left;
    if (isNaN(height)) height = containerHeight - bottom - verticalMargin - top;
    if (aspect != null) {
        // If width and height are not given
        // 1. Graph should not exceeds the container
        // 2. Aspect must be keeped
        // 3. Graph should take the space as more as possible
        // FIXME
        // Margin is not considered, because there is no case that both
        // using margin and aspect so far.
        if (isNaN(width) && isNaN(height)) {
            if (aspect > containerWidth / containerHeight) width = containerWidth * 0.8;
            else height = containerHeight * 0.8;
        }
        // Calculate width or height with given aspect
        if (isNaN(width)) width = aspect * height;
        if (isNaN(height)) height = width / aspect;
    }
    // If left is not specified, calculate left from right and width
    if (isNaN(left)) left = containerWidth - right - width - horizontalMargin;
    if (isNaN(top)) top = containerHeight - bottom - height - verticalMargin;
    // Align left and top
    switch(positionInfo.left || positionInfo.right){
        case "center":
            left = containerWidth / 2 - width / 2 - margin[3];
            break;
        case "right":
            left = containerWidth - width - horizontalMargin;
            break;
    }
    switch(positionInfo.top || positionInfo.bottom){
        case "middle":
        case "center":
            top = containerHeight / 2 - height / 2 - margin[0];
            break;
        case "bottom":
            top = containerHeight - height - verticalMargin;
            break;
    }
    // If something is wrong and left, top, width, height are calculated as NaN
    left = left || 0;
    top = top || 0;
    if (isNaN(width)) // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
    if (isNaN(height)) // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
    var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(left + margin[3], top + margin[0], width, height);
    rect.margin = margin;
    return rect;
}
function $93b9bc7f22ac7369$export$74054bd96b5eeef1(el, positionInfo, containerRect, margin, opt, out) {
    var h = !opt || !opt.hv || opt.hv[0];
    var v = !opt || !opt.hv || opt.hv[1];
    var boundingMode = opt && opt.boundingMode || "all";
    out = out || el;
    out.x = el.x;
    out.y = el.y;
    if (!h && !v) return false;
    var rect;
    if (boundingMode === "raw") rect = el.type === "group" ? new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
    else {
        rect = el.getBoundingRect();
        if (el.needLocalTransform()) {
            var transform = el.getLocalTransform();
            // Notice: raw rect may be inner object of el,
            // which should not be modified.
            rect = rect.clone();
            rect.applyTransform(transform);
        }
    }
    // The real width and height can not be specified but calculated by the given el.
    var layoutRect = $93b9bc7f22ac7369$export$4517a5ca639a7293($7a1bd9c2710fea0d$export$ebe90cb607ad99e({
        width: rect.width,
        height: rect.height
    }, positionInfo), containerRect, margin);
    // Because 'tranlate' is the last step in transform
    // (see zrender/core/Transformable#getLocalTransform),
    // we can just only modify el.position to get final result.
    var dx = h ? layoutRect.x - rect.x : 0;
    var dy = v ? layoutRect.y - rect.y : 0;
    if (boundingMode === "raw") {
        out.x = dx;
        out.y = dy;
    } else {
        out.x += dx;
        out.y += dy;
    }
    if (out === el) el.markRedraw();
    return true;
}
function $93b9bc7f22ac7369$export$7ede609e8ebc9650(option, hvIdx) {
    return option[$93b9bc7f22ac7369$export$d7fd4338c7b20804[hvIdx][0]] != null || option[$93b9bc7f22ac7369$export$d7fd4338c7b20804[hvIdx][1]] != null && option[$93b9bc7f22ac7369$export$d7fd4338c7b20804[hvIdx][2]] != null;
}
function $93b9bc7f22ac7369$export$3968a28a7cbd6063(ins) {
    var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
    return $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(layoutMode) ? layoutMode : layoutMode ? {
        type: layoutMode
    } : null;
}
function $93b9bc7f22ac7369$export$1754cb91f16ca028(targetOption, newOption, opt) {
    var ignoreSize = opt && opt.ignoreSize;
    !$7a1bd9c2710fea0d$export$43bee75e5e14138e(ignoreSize) && (ignoreSize = [
        ignoreSize,
        ignoreSize
    ]);
    var hResult = merge($93b9bc7f22ac7369$export$d7fd4338c7b20804[0], 0);
    var vResult = merge($93b9bc7f22ac7369$export$d7fd4338c7b20804[1], 1);
    copy($93b9bc7f22ac7369$export$d7fd4338c7b20804[0], targetOption, hResult);
    copy($93b9bc7f22ac7369$export$d7fd4338c7b20804[1], targetOption, vResult);
    function merge(names, hvIdx) {
        var newParams = {};
        var newValueCount = 0;
        var merged = {};
        var mergedValueCount = 0;
        var enoughParamNumber = 2;
        $93b9bc7f22ac7369$var$each(names, function(name) {
            merged[name] = targetOption[name];
        });
        $93b9bc7f22ac7369$var$each(names, function(name) {
            // Consider case: newOption.width is null, which is
            // set by user for removing width setting.
            hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
            hasValue(newParams, name) && newValueCount++;
            hasValue(merged, name) && mergedValueCount++;
        });
        if (ignoreSize[hvIdx]) {
            // Only one of left/right is premitted to exist.
            if (hasValue(newOption, names[1])) merged[names[2]] = null;
            else if (hasValue(newOption, names[2])) merged[names[1]] = null;
            return merged;
        }
        // Case: newOption: {width: ..., right: ...},
        // or targetOption: {right: ...} and newOption: {width: ...},
        // There is no conflict when merged only has params count
        // little than enoughParamNumber.
        if (mergedValueCount === enoughParamNumber || !newValueCount) return merged;
        else if (newValueCount >= enoughParamNumber) return newParams;
        else {
            // Chose another param from targetOption by priority.
            for(var i = 0; i < names.length; i++){
                var name_1 = names[i];
                if (!hasProp(newParams, name_1) && hasProp(targetOption, name_1)) {
                    newParams[name_1] = targetOption[name_1];
                    break;
                }
            }
            return newParams;
        }
    }
    function hasProp(obj, name) {
        return obj.hasOwnProperty(name);
    }
    function hasValue(obj, name) {
        return obj[name] != null && obj[name] !== "auto";
    }
    function copy(names, target, source) {
        $93b9bc7f22ac7369$var$each(names, function(name) {
            target[name] = source[name];
        });
    }
}
function $93b9bc7f22ac7369$export$4b0d20af19c9875e(source) {
    return $93b9bc7f22ac7369$export$7438999faea9b6cc({}, source);
}
function $93b9bc7f22ac7369$export$7438999faea9b6cc(target, source) {
    source && target && $93b9bc7f22ac7369$var$each($93b9bc7f22ac7369$export$a9aa2cc018afbed, function(name) {
        source.hasOwnProperty(name) && (target[name] = source[name]);
    });
    return target;
}


var $116d65051f61bdfe$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $116d65051f61bdfe$var$ComponentModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ComponentModel, _super);
    function ComponentModel(option, parentModel, ecModel) {
        var _this = _super.call(this, option, parentModel, ecModel) || this;
        _this.uid = $5370df662b2caf37$export$6d2b3473b0986646("ec_cpt_model");
        return _this;
    }
    ComponentModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    ComponentModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = $93b9bc7f22ac7369$export$3968a28a7cbd6063(this);
        var inputPositionParams = layoutMode ? $93b9bc7f22ac7369$export$4b0d20af19c9875e(option) : {};
        var themeModel = ecModel.getTheme();
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(option, themeModel.get(this.mainType));
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(option, this.getDefaultOption());
        if (layoutMode) $93b9bc7f22ac7369$export$1754cb91f16ca028(option, inputPositionParams, layoutMode);
    };
    ComponentModel.prototype.mergeOption = function(option, ecModel) {
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(this.option, option, true);
        var layoutMode = $93b9bc7f22ac7369$export$3968a28a7cbd6063(this);
        if (layoutMode) $93b9bc7f22ac7369$export$1754cb91f16ca028(this.option, option, layoutMode);
    };
    /**
   * Called immediately after `init` or `mergeOption` of this instance called.
   */ ComponentModel.prototype.optionUpdated = function(newCptOption, isInit) {};
    /**
   * [How to declare defaultOption]:
   *
   * (A) If using class declaration in typescript (since echarts 5):
   * ```ts
   * import {ComponentOption} from '../model/option.js';
   * export interface XxxOption extends ComponentOption {
   *     aaa: number
   * }
   * export class XxxModel extends Component {
   *     static type = 'xxx';
   *     static defaultOption: XxxOption = {
   *         aaa: 123
   *     }
   * }
   * Component.registerClass(XxxModel);
   * ```
   * ```ts
   * import {inheritDefaultOption} from '../util/component.js';
   * import {XxxModel, XxxOption} from './XxxModel.js';
   * export interface XxxSubOption extends XxxOption {
   *     bbb: number
   * }
   * class XxxSubModel extends XxxModel {
   *     static defaultOption: XxxSubOption = inheritDefaultOption(XxxModel.defaultOption, {
   *         bbb: 456
   *     })
   *     fn() {
   *         let opt = this.getDefaultOption();
   *         // opt is {aaa: 123, bbb: 456}
   *     }
   * }
   * ```
   *
   * (B) If using class extend (previous approach in echarts 3 & 4):
   * ```js
   * let XxxComponent = Component.extend({
   *     defaultOption: {
   *         xx: 123
   *     }
   * })
   * ```
   * ```js
   * let XxxSubComponent = XxxComponent.extend({
   *     defaultOption: {
   *         yy: 456
   *     },
   *     fn: function () {
   *         let opt = this.getDefaultOption();
   *         // opt is {xx: 123, yy: 456}
   *     }
   * })
   * ```
   */ ComponentModel.prototype.getDefaultOption = function() {
        var ctor = this.constructor;
        // If using class declaration, it is different to travel super class
        // in legacy env and auto merge defaultOption. So if using class
        // declaration, defaultOption should be merged manually.
        if (!(0, $cd5f95cf03b4e3e7$export$4f3b818f3dd2d182)(ctor)) // When using ts class, defaultOption must be declared as static.
        return ctor.defaultOption;
        // FIXME: remove this approach?
        var fields = $116d65051f61bdfe$var$inner(this);
        if (!fields.defaultOption) {
            var optList = [];
            var clz = ctor;
            while(clz){
                var opt = clz.prototype.defaultOption;
                opt && optList.push(opt);
                clz = clz.superClass;
            }
            var defaultOption = {};
            for(var i = optList.length - 1; i >= 0; i--)defaultOption = $7a1bd9c2710fea0d$export$4950aa0f605343fb(defaultOption, optList[i], true);
            fields.defaultOption = defaultOption;
        }
        return fields.defaultOption;
    };
    /**
   * Notice: always force to input param `useDefault` in case that forget to consider it.
   * The same behavior as `modelUtil.parseFinder`.
   *
   * @param useDefault In many cases like series refer axis and axis refer grid,
   *        If axis index / axis id not specified, use the first target as default.
   *        In other cases like dataZoom refer axis, if not specified, measn no refer.
   */ ComponentModel.prototype.getReferringComponents = function(mainType, opt) {
        var indexKey = mainType + "Index";
        var idKey = mainType + "Id";
        return (0, $76d619f648247e6d$export$dc741340f7e5f186)(this.ecModel, mainType, {
            index: this.get(indexKey, true),
            id: this.get(idKey, true)
        }, opt);
    };
    ComponentModel.prototype.getBoxLayoutParams = function() {
        // Consider itself having box layout configs.
        var boxLayoutModel = this;
        return {
            left: boxLayoutModel.get("left"),
            top: boxLayoutModel.get("top"),
            right: boxLayoutModel.get("right"),
            bottom: boxLayoutModel.get("bottom"),
            width: boxLayoutModel.get("width"),
            height: boxLayoutModel.get("height")
        };
    };
    /**
   * Get key for zlevel.
   * If developers don't configure zlevel. We will assign zlevel to series based on the key.
   * For example, lines with trail effect and progressive series will in an individual zlevel.
   */ ComponentModel.prototype.getZLevelKey = function() {
        return "";
    };
    ComponentModel.prototype.setZLevel = function(zlevel) {
        this.option.zlevel = zlevel;
    };
    ComponentModel.protoInitialize = function() {
        var proto = ComponentModel.prototype;
        proto.type = "component";
        proto.id = "";
        proto.name = "";
        proto.mainType = "";
        proto.subType = "";
        proto.componentIndex = 0;
    }();
    return ComponentModel;
}((0, $6818646a97528290$export$2e2bcd8739ae039));
(0, $cd5f95cf03b4e3e7$export$c9c2d87774f1275d)($116d65051f61bdfe$var$ComponentModel, (0, $6818646a97528290$export$2e2bcd8739ae039));
(0, $cd5f95cf03b4e3e7$export$241315e45585454d)($116d65051f61bdfe$var$ComponentModel);
$5370df662b2caf37$export$b9faf30b7d655a6f($116d65051f61bdfe$var$ComponentModel);
$5370df662b2caf37$export$ce592d345a3ec040($116d65051f61bdfe$var$ComponentModel, $116d65051f61bdfe$var$getDependencies);
function $116d65051f61bdfe$var$getDependencies(componentType) {
    var deps = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43($116d65051f61bdfe$var$ComponentModel.getClassesByMainType(componentType), function(clz) {
        deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
    });
    // Ensure main type.
    deps = $7a1bd9c2710fea0d$export$871de8747c9eaa88(deps, function(type) {
        return (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(type).main;
    });
    // Hack dataset for convenience.
    if (componentType !== "dataset" && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(deps, "dataset") <= 0) deps.unshift("dataset");
    return deps;
}
var $116d65051f61bdfe$export$2e2bcd8739ae039 = $116d65051f61bdfe$var$ComponentModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $2d7ac35b3b3d57e3$var$platform = "";
// Navigator not exists in node
if (typeof navigator !== "undefined") /* global navigator */ $2d7ac35b3b3d57e3$var$platform = navigator.platform || "";
var $2d7ac35b3b3d57e3$var$decalColor = "rgba(0, 0, 0, 0.2)";
var $2d7ac35b3b3d57e3$export$2e2bcd8739ae039 = {
    darkMode: "auto",
    // backgroundColor: 'rgba(0,0,0,0)',
    colorBy: "series",
    color: [
        "#5470c6",
        "#91cc75",
        "#fac858",
        "#ee6666",
        "#73c0de",
        "#3ba272",
        "#fc8452",
        "#9a60b4",
        "#ea7ccc"
    ],
    gradientColor: [
        "#f6efa6",
        "#d88273",
        "#bf444c"
    ],
    aria: {
        decal: {
            decals: [
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        2,
                        5
                    ],
                    symbolSize: 1,
                    rotation: Math.PI / 6
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    symbol: "circle",
                    dashArrayX: [
                        [
                            8,
                            8
                        ],
                        [
                            0,
                            8,
                            8,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ],
                    symbolSize: 0.8
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        4,
                        3
                    ],
                    rotation: -Math.PI / 4
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    dashArrayX: [
                        [
                            6,
                            6
                        ],
                        [
                            0,
                            6,
                            6,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ]
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    dashArrayX: [
                        [
                            1,
                            0
                        ],
                        [
                            1,
                            6
                        ]
                    ],
                    dashArrayY: [
                        1,
                        0,
                        6,
                        0
                    ],
                    rotation: Math.PI / 4
                },
                {
                    color: $2d7ac35b3b3d57e3$var$decalColor,
                    symbol: "triangle",
                    dashArrayX: [
                        [
                            9,
                            9
                        ],
                        [
                            0,
                            9,
                            9,
                            0
                        ]
                    ],
                    dashArrayY: [
                        7,
                        2
                    ],
                    symbolSize: 0.75
                }
            ]
        }
    },
    // If xAxis and yAxis declared, grid is created by default.
    // grid: {},
    textStyle: {
        // color: '#000',
        // decoration: 'none',
        // PENDING
        fontFamily: $2d7ac35b3b3d57e3$var$platform.match(/^Win/) ? "Microsoft YaHei" : "sans-serif",
        // fontFamily: 'Arial, Verdana, sans-serif',
        fontSize: 12,
        fontStyle: "normal",
        fontWeight: "normal"
    },
    // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
    // Default is source-over
    blendMode: null,
    stateAnimation: {
        duration: 300,
        easing: "cubicOut"
    },
    animation: "auto",
    animationDuration: 1000,
    animationDurationUpdate: 500,
    animationEasing: "cubicInOut",
    animationEasingUpdate: "cubicInOut",
    animationThreshold: 2000,
    // Configuration for progressive/incremental rendering
    progressiveThreshold: 3000,
    progressive: 400,
    // Threshold of if use single hover layer to optimize.
    // It is recommended that `hoverLayerThreshold` is equivalent to or less than
    // `progressiveThreshold`, otherwise hover will cause restart of progressive,
    // which is unexpected.
    // see example <echarts/test/heatmap-large.html>.
    hoverLayerThreshold: 3000,
    // See: module:echarts/scale/Time
    useUTC: false
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $cab29724515ce2b8$export$cd51b5ca77f6f0e4 = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)([
    "tooltip",
    "label",
    "itemName",
    "itemId",
    "itemGroupId",
    "itemChildGroupId",
    "seriesName"
]);
var $cab29724515ce2b8$export$2823037fb9d8f0c6 = "original";
var $cab29724515ce2b8$export$fcd62ebf51387903 = "arrayRows";
var $cab29724515ce2b8$export$703ae8a2d83f441 = "objectRows";
var $cab29724515ce2b8$export$6a32b42c754a3cb8 = "keyedColumns";
var $cab29724515ce2b8$export$a918cb016a382d45 = "typedArray";
var $cab29724515ce2b8$export$c78f1330778d30d = "unknown";
var $cab29724515ce2b8$export$7b3f3c6551b4949b = "column";
var $cab29724515ce2b8$export$d55da1467cdf7804 = "row";


var $7dc6cdfd7450ef29$export$328749e9c5b40760 = {
    Must: 1,
    Might: 2,
    Not: 3 // Other cases
};
var $7dc6cdfd7450ef29$var$innerGlobalModel = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $7dc6cdfd7450ef29$export$b30cdea50aa00e6(ecModel) {
    // `datasetMap` is used to make default encode.
    $7dc6cdfd7450ef29$var$innerGlobalModel(ecModel).datasetMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
}
function $7dc6cdfd7450ef29$export$37682b8fdd2e83d(coordDimensions, seriesModel, source) {
    var encode = {};
    var datasetModel = $7dc6cdfd7450ef29$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel || !coordDimensions) return encode;
    var encodeItemName = [];
    var encodeSeriesName = [];
    var ecModel = seriesModel.ecModel;
    var datasetMap = $7dc6cdfd7450ef29$var$innerGlobalModel(ecModel).datasetMap;
    var key = datasetModel.uid + "_" + source.seriesLayoutBy;
    var baseCategoryDimIndex;
    var categoryWayValueDimStart;
    coordDimensions = coordDimensions.slice();
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordDimensions, function(coordDimInfoLoose, coordDimIdx) {
        var coordDimInfo = (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
            name: coordDimInfoLoose
        };
        if (coordDimInfo.type === "ordinal" && baseCategoryDimIndex == null) {
            baseCategoryDimIndex = coordDimIdx;
            categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
        }
        encode[coordDimInfo.name] = [];
    });
    var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
        categoryWayDim: categoryWayValueDimStart,
        valueWayDim: 0
    });
    // TODO
    // Auto detect first time axis and do arrangement.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordDimensions, function(coordDimInfo, coordDimIdx) {
        var coordDimName = coordDimInfo.name;
        var count = getDataDimCountOnCoordDim(coordDimInfo);
        // In value way.
        if (baseCategoryDimIndex == null) {
            var start = datasetRecord.valueWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.valueWayDim += count;
        // ??? TODO give a better default series name rule?
        // especially when encode x y specified.
        // consider: when multiple series share one dimension
        // category axis, series name should better use
        // the other dimension name. On the other hand, use
        // both dimensions name.
        } else if (baseCategoryDimIndex === coordDimIdx) {
            pushDim(encode[coordDimName], 0, count);
            pushDim(encodeItemName, 0, count);
        } else {
            var start = datasetRecord.categoryWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.categoryWayDim += count;
        }
    });
    function pushDim(dimIdxArr, idxFrom, idxCount) {
        for(var i = 0; i < idxCount; i++)dimIdxArr.push(idxFrom + i);
    }
    function getDataDimCountOnCoordDim(coordDimInfo) {
        var dimsDef = coordDimInfo.dimsDef;
        return dimsDef ? dimsDef.length : 1;
    }
    encodeItemName.length && (encode.itemName = encodeItemName);
    encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
    return encode;
}
function $7dc6cdfd7450ef29$export$60b8a57d1f2fed26(seriesModel, source, dimCount) {
    var encode = {};
    var datasetModel = $7dc6cdfd7450ef29$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel) return encode;
    var sourceFormat = source.sourceFormat;
    var dimensionsDefine = source.dimensionsDefine;
    var potentialNameDimIndex;
    if (sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441) || sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8)) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dimensionsDefine, function(dim, idx) {
        if (((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dim) ? dim.name : dim) === "name") potentialNameDimIndex = idx;
    });
    var idxResult = function() {
        var idxRes0 = {};
        var idxRes1 = {};
        var guessRecords = [];
        // 5 is an experience value.
        for(var i = 0, len = Math.min(5, dimCount); i < len; i++){
            var guessResult = $7dc6cdfd7450ef29$var$doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
            guessRecords.push(guessResult);
            var isPureNumber = guessResult === $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
            // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
            // and then find a name dim with the priority:
            // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
            if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) idxRes0.v = i;
            if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === $7dc6cdfd7450ef29$export$328749e9c5b40760.Not) idxRes0.n = i;
            if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== $7dc6cdfd7450ef29$export$328749e9c5b40760.Not) return idxRes0;
            // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
            // find the first BE_ORDINAL.Might as the value dim,
            // and then find a name dim with the priority:
            // "other dim" > "the value dim itself".
            // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
            // treated as number.
            if (!isPureNumber) {
                if (guessResult === $7dc6cdfd7450ef29$export$328749e9c5b40760.Might && idxRes1.v == null && i !== potentialNameDimIndex) idxRes1.v = i;
                if (idxRes1.n == null || idxRes1.n === idxRes1.v) idxRes1.n = i;
            }
        }
        function fulfilled(idxResult) {
            return idxResult.v != null && idxResult.n != null;
        }
        return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
    }();
    if (idxResult) {
        encode.value = [
            idxResult.v
        ];
        // `potentialNameDimIndex` has highest priority.
        var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n;
        // By default, label uses itemName in charts.
        // So we don't set encodeLabel here.
        encode.itemName = [
            nameDimIndex
        ];
        encode.seriesName = [
            nameDimIndex
        ];
    }
    return encode;
}
function $7dc6cdfd7450ef29$export$8da66f73a1eda454(seriesModel) {
    // Caution: consider the scenario:
    // A dataset is declared and a series is not expected to use the dataset,
    // and at the beginning `setOption({series: { noData })` (just prepare other
    // option but no data), then `setOption({series: {data: [...]}); In this case,
    // the user should set an empty array to avoid that dataset is used by default.
    var thisData = seriesModel.get("data", true);
    if (!thisData) return (0, $76d619f648247e6d$export$dc741340f7e5f186)(seriesModel.ecModel, "dataset", {
        index: seriesModel.get("datasetIndex", true),
        id: seriesModel.get("datasetId", true)
    }, (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
}
function $7dc6cdfd7450ef29$export$397ba553479711e7(datasetModel) {
    // Only these attributes declared, we by default reference to `datasetIndex: 0`.
    // Otherwise, no reference.
    if (!datasetModel.get("transform", true) && !datasetModel.get("fromTransformResult", true)) return [];
    return (0, $76d619f648247e6d$export$dc741340f7e5f186)(datasetModel.ecModel, "dataset", {
        index: datasetModel.get("fromDatasetIndex", true),
        id: datasetModel.get("fromDatasetId", true)
    }, (0, $76d619f648247e6d$export$f076738ec84e693c)).models;
}
function $7dc6cdfd7450ef29$export$c51adf1a2be01b9c(source, dimIndex) {
    return $7dc6cdfd7450ef29$var$doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
}
// dimIndex may be overflow source data.
// return {BE_ORDINAL}
function $7dc6cdfd7450ef29$var$doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
    var result;
    // Experience value.
    var maxLoop = 5;
    if ((0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data)) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
    // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
    // always exists in source.
    var dimName;
    var dimType;
    if (dimensionsDefine) {
        var dimDefItem = dimensionsDefine[dimIndex];
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dimDefItem)) {
            dimName = dimDefItem.name;
            dimType = dimDefItem.type;
        } else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(dimDefItem)) dimName = dimDefItem;
    }
    if (dimType != null) return dimType === "ordinal" ? $7dc6cdfd7450ef29$export$328749e9c5b40760.Must : $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
    if (sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903)) {
        var dataArrayRows = data;
        if (seriesLayoutBy === (0, $cab29724515ce2b8$export$d55da1467cdf7804)) {
            var sample = dataArrayRows[dimIndex];
            for(var i = 0; i < (sample || []).length && i < maxLoop; i++){
                if ((result = detectValue(sample[startIndex + i])) != null) return result;
            }
        } else for(var i = 0; i < dataArrayRows.length && i < maxLoop; i++){
            var row = dataArrayRows[startIndex + i];
            if (row && (result = detectValue(row[dimIndex])) != null) return result;
        }
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441)) {
        var dataObjectRows = data;
        if (!dimName) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
        for(var i = 0; i < dataObjectRows.length && i < maxLoop; i++){
            var item = dataObjectRows[i];
            if (item && (result = detectValue(item[dimName])) != null) return result;
        }
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8)) {
        var dataKeyedColumns = data;
        if (!dimName) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
        var sample = dataKeyedColumns[dimName];
        if (!sample || (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(sample)) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
        for(var i = 0; i < sample.length && i < maxLoop; i++){
            if ((result = detectValue(sample[i])) != null) return result;
        }
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)) {
        var dataOriginal = data;
        for(var i = 0; i < dataOriginal.length && i < maxLoop; i++){
            var item = dataOriginal[i];
            var val = (0, $76d619f648247e6d$export$2c944e12edb48d4b)(item);
            if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(val)) return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
            if ((result = detectValue(val[dimIndex])) != null) return result;
        }
    }
    function detectValue(val) {
        var beStr = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val);
        // Consider usage convenience, '1', '2' will be treated as "number".
        // `isFinit('')` get `true`.
        if (val != null && isFinite(val) && val !== "") return beStr ? $7dc6cdfd7450ef29$export$328749e9c5b40760.Might : $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
        else if (beStr && val !== "-") return $7dc6cdfd7450ef29$export$328749e9c5b40760.Must;
    }
    return $7dc6cdfd7450ef29$export$328749e9c5b40760.Not;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $a625fe571efb4064$var$internalOptionCreatorMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
function $a625fe571efb4064$export$5a90be4668898d38(mainType, creator) {
    (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)($a625fe571efb4064$var$internalOptionCreatorMap.get(mainType) == null && creator);
    $a625fe571efb4064$var$internalOptionCreatorMap.set(mainType, creator);
}
function $a625fe571efb4064$export$c713a6a3b43f401d(ecModel, mainType, newCmptOptionList) {
    var internalOptionCreator = $a625fe571efb4064$var$internalOptionCreatorMap.get(mainType);
    if (!internalOptionCreator) return newCmptOptionList;
    var internalOptions = internalOptionCreator(ecModel);
    if (!internalOptions) return newCmptOptionList;
    var i;
    return newCmptOptionList.concat(internalOptions);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $e7fbd47751ca3c28$var$innerColor = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $e7fbd47751ca3c28$var$innerDecal = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $e7fbd47751ca3c28$export$55a3c39e852b90f4 = /** @class */ function() {
    function PaletteMixin() {}
    PaletteMixin.prototype.getColorFromPalette = function(name, scope, requestNum) {
        var defaultPalette = (0, $76d619f648247e6d$export$4f07b212a02c8051)(this.get("color", true));
        var layeredPalette = this.get("colorLayer", true);
        return $e7fbd47751ca3c28$var$getFromPalette(this, $e7fbd47751ca3c28$var$innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
    };
    PaletteMixin.prototype.clearColorPalette = function() {
        $e7fbd47751ca3c28$var$clearPalette(this, $e7fbd47751ca3c28$var$innerColor);
    };
    return PaletteMixin;
}();
function $e7fbd47751ca3c28$export$e4d892222945a227(ecModel, name, scope, requestNum) {
    var defaultDecals = (0, $76d619f648247e6d$export$4f07b212a02c8051)(ecModel.get([
        "aria",
        "decal",
        "decals"
    ]));
    return $e7fbd47751ca3c28$var$getFromPalette(ecModel, $e7fbd47751ca3c28$var$innerDecal, defaultDecals, null, name, scope, requestNum);
}
function $e7fbd47751ca3c28$var$getNearestPalette(palettes, requestColorNum) {
    var paletteNum = palettes.length;
    // TODO palettes must be in order
    for(var i = 0; i < paletteNum; i++){
        if (palettes[i].length > requestColorNum) return palettes[i];
    }
    return palettes[paletteNum - 1];
}
/**
 * @param name MUST NOT be null/undefined. Otherwise call this function
 *             twise with the same parameters will get different result.
 * @param scope default this.
 * @return Can be null/undefined
 */ function $e7fbd47751ca3c28$var$getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
    scope = scope || that;
    var scopeFields = inner(scope);
    var paletteIdx = scopeFields.paletteIdx || 0;
    var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {};
    // Use `hasOwnProperty` to avoid conflict with Object.prototype.
    if (paletteNameMap.hasOwnProperty(name)) return paletteNameMap[name];
    var palette = requestNum == null || !layeredPalette ? defaultPalette : $e7fbd47751ca3c28$var$getNearestPalette(layeredPalette, requestNum);
    // In case can't find in layered color palette.
    palette = palette || defaultPalette;
    if (!palette || !palette.length) return;
    var pickedPaletteItem = palette[paletteIdx];
    if (name) paletteNameMap[name] = pickedPaletteItem;
    scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
    return pickedPaletteItem;
}
function $e7fbd47751ca3c28$var$clearPalette(that, inner) {
    inner(that).paletteIdx = 0;
    inner(that).paletteNameMap = {};
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $84bc7667c27ccedc$var$ECHARTS_PREFIX = "[ECharts] ";
var $84bc7667c27ccedc$var$storedLogs = {};
var $84bc7667c27ccedc$var$hasConsole = typeof console !== "undefined" && console.warn && console.log;
function $84bc7667c27ccedc$var$outputLog(type, str, onlyOnce) {
    if ($84bc7667c27ccedc$var$hasConsole) {
        if (onlyOnce) {
            if ($84bc7667c27ccedc$var$storedLogs[str]) return;
            $84bc7667c27ccedc$var$storedLogs[str] = true;
        }
        // eslint-disable-next-line
        console[type]($84bc7667c27ccedc$var$ECHARTS_PREFIX + str);
    }
}
function $84bc7667c27ccedc$export$bef1f36f5486a6a3(str, onlyOnce) {
    $84bc7667c27ccedc$var$outputLog("log", str, onlyOnce);
}
function $84bc7667c27ccedc$export$c106dd0671a0fc2d(str, onlyOnce) {
    $84bc7667c27ccedc$var$outputLog("warn", str, onlyOnce);
}
function $84bc7667c27ccedc$export$a3bc9b8ed74fc(str, onlyOnce) {
    $84bc7667c27ccedc$var$outputLog("error", str, onlyOnce);
}
function $84bc7667c27ccedc$export$4a9c0b74eb885aa1(str) {}
function $84bc7667c27ccedc$export$bbd91d66002c4ea6(oldOpt, newOpt, scope) {}
function $84bc7667c27ccedc$export$a68bb8b222a6bd43() {
    var hintInfo = [];
    for(var _i = 0; _i < arguments.length; _i++)hintInfo[_i] = arguments[_i];
    var msg = "";
    var makePrintableStringIfPossible_1;
    return msg;
}
function $84bc7667c27ccedc$export$8bf7aba4a9e09055(msg) {
    throw new Error(msg);
}


// -----------------------
// Internal method names:
// -----------------------
var $51f6ef0dd9546916$var$reCreateSeriesIndices;
var $51f6ef0dd9546916$var$assertSeriesInitialized;
var $51f6ef0dd9546916$var$initBase;
var $51f6ef0dd9546916$var$OPTION_INNER_KEY = "\0_ec_inner";
var $51f6ef0dd9546916$var$OPTION_INNER_VALUE = 1;
var $51f6ef0dd9546916$var$BUITIN_COMPONENTS_MAP = {
    grid: "GridComponent",
    polar: "PolarComponent",
    geo: "GeoComponent",
    singleAxis: "SingleAxisComponent",
    parallel: "ParallelComponent",
    calendar: "CalendarComponent",
    graphic: "GraphicComponent",
    toolbox: "ToolboxComponent",
    tooltip: "TooltipComponent",
    axisPointer: "AxisPointerComponent",
    brush: "BrushComponent",
    title: "TitleComponent",
    timeline: "TimelineComponent",
    markPoint: "MarkPointComponent",
    markLine: "MarkLineComponent",
    markArea: "MarkAreaComponent",
    legend: "LegendComponent",
    dataZoom: "DataZoomComponent",
    visualMap: "VisualMapComponent",
    // aria: 'AriaComponent',
    // dataset: 'DatasetComponent',
    // Dependencies
    xAxis: "GridComponent",
    yAxis: "GridComponent",
    angleAxis: "PolarComponent",
    radiusAxis: "PolarComponent"
};
var $51f6ef0dd9546916$var$BUILTIN_CHARTS_MAP = {
    line: "LineChart",
    bar: "BarChart",
    pie: "PieChart",
    scatter: "ScatterChart",
    radar: "RadarChart",
    map: "MapChart",
    tree: "TreeChart",
    treemap: "TreemapChart",
    graph: "GraphChart",
    gauge: "GaugeChart",
    funnel: "FunnelChart",
    parallel: "ParallelChart",
    sankey: "SankeyChart",
    boxplot: "BoxplotChart",
    candlestick: "CandlestickChart",
    effectScatter: "EffectScatterChart",
    lines: "LinesChart",
    heatmap: "HeatmapChart",
    pictorialBar: "PictorialBarChart",
    themeRiver: "ThemeRiverChart",
    sunburst: "SunburstChart",
    custom: "CustomChart"
};
var $51f6ef0dd9546916$var$componetsMissingLogPrinted = {};
function $51f6ef0dd9546916$var$checkMissingComponents(option) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(option, function(componentOption, mainType) {
        if (!(0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(mainType)) {
            var componentImportName = $51f6ef0dd9546916$var$BUITIN_COMPONENTS_MAP[mainType];
            if (componentImportName && !$51f6ef0dd9546916$var$componetsMissingLogPrinted[componentImportName]) {
                (0, $84bc7667c27ccedc$export$a3bc9b8ed74fc)("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
                $51f6ef0dd9546916$var$componetsMissingLogPrinted[componentImportName] = true;
            }
        }
    });
}
var $51f6ef0dd9546916$var$GlobalModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GlobalModel, _super);
    function GlobalModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalModel.prototype.init = function(option, parentModel, ecModel, theme, locale, optionManager) {
        theme = theme || {};
        this.option = null; // Mark as not initialized.
        this._theme = new (0, $6818646a97528290$export$2e2bcd8739ae039)(theme);
        this._locale = new (0, $6818646a97528290$export$2e2bcd8739ae039)(locale);
        this._optionManager = optionManager;
    };
    GlobalModel.prototype.setOption = function(option, opts, optionPreprocessorFuncs) {
        var innerOpt = $51f6ef0dd9546916$var$normalizeSetOptionInput(opts);
        this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);
        this._resetOption(null, innerOpt);
    };
    /**
   * @param type null/undefined: reset all.
   *        'recreate': force recreate all.
   *        'timeline': only reset timeline option
   *        'media': only reset media query option
   * @return Whether option changed.
   */ GlobalModel.prototype.resetOption = function(type, opt) {
        return this._resetOption(type, $51f6ef0dd9546916$var$normalizeSetOptionInput(opt));
    };
    GlobalModel.prototype._resetOption = function(type, opt) {
        var optionChanged = false;
        var optionManager = this._optionManager;
        if (!type || type === "recreate") {
            var baseOption = optionManager.mountOption(type === "recreate");
            if (!this.option || type === "recreate") $51f6ef0dd9546916$var$initBase(this, baseOption);
            else {
                this.restoreData();
                this._mergeOption(baseOption, opt);
            }
            optionChanged = true;
        }
        if (type === "timeline" || type === "media") this.restoreData();
        // By design, if `setOption(option2)` at the second time, and `option2` is a `ECUnitOption`,
        // it should better not have the same props with `MediaUnit['option']`.
        // Because either `option2` or `MediaUnit['option']` will be always merged to "current option"
        // rather than original "baseOption". If they both override a prop, the result might be
        // unexpected when media state changed after `setOption` called.
        // If we really need to modify a props in each `MediaUnit['option']`, use the full version
        // (`{baseOption, media}`) in `setOption`.
        // For `timeline`, the case is the same.
        if (!type || type === "recreate" || type === "timeline") {
            var timelineOption = optionManager.getTimelineOption(this);
            if (timelineOption) {
                optionChanged = true;
                this._mergeOption(timelineOption, opt);
            }
        }
        if (!type || type === "recreate" || type === "media") {
            var mediaOptions = optionManager.getMediaOption(this);
            if (mediaOptions.length) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mediaOptions, function(mediaOption) {
                optionChanged = true;
                this._mergeOption(mediaOption, opt);
            }, this);
        }
        return optionChanged;
    };
    GlobalModel.prototype.mergeOption = function(option) {
        this._mergeOption(option, null);
    };
    GlobalModel.prototype._mergeOption = function(newOption, opt) {
        var option = this.option;
        var componentsMap = this._componentsMap;
        var componentsCount = this._componentsCount;
        var newCmptTypes = [];
        var newCmptTypeMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
        (0, $7dc6cdfd7450ef29$export$b30cdea50aa00e6)(this);
        // If no component class, merge directly.
        // For example: color, animaiton options, etc.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newOption, function(componentOption, mainType) {
            if (componentOption == null) return;
            if (!(0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(mainType)) // globalSettingTask.dirty();
            option[mainType] = option[mainType] == null ? (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(componentOption) : (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(option[mainType], componentOption, true);
            else if (mainType) {
                newCmptTypes.push(mainType);
                newCmptTypeMap.set(mainType, true);
            }
        });
        if (replaceMergeMainTypeMap) // If there is a mainType `xxx` in `replaceMerge` but not declared in option,
        // we trade it as it is declared in option as `{xxx: []}`. Because:
        // (1) for normal merge, `{xxx: null/undefined}` are the same meaning as `{xxx: []}`.
        // (2) some preprocessor may convert some of `{xxx: null/undefined}` to `{xxx: []}`.
        replaceMergeMainTypeMap.each(function(val, mainTypeInReplaceMerge) {
            if ((0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
                newCmptTypes.push(mainTypeInReplaceMerge);
                newCmptTypeMap.set(mainTypeInReplaceMerge, true);
            }
        });
        (0, $116d65051f61bdfe$export$2e2bcd8739ae039).topologicalTravel(newCmptTypes, (0, $116d65051f61bdfe$export$2e2bcd8739ae039).getAllClassMainTypes(), visitComponent, this);
        function visitComponent(mainType) {
            var newCmptOptionList = (0, $a625fe571efb4064$export$c713a6a3b43f401d)(this, mainType, $76d619f648247e6d$export$4f07b212a02c8051(newOption[mainType]));
            var oldCmptList = componentsMap.get(mainType);
            var mergeMode = // `!oldCmptList` means init. See the comment in `mappingToExists`
            !oldCmptList ? "replaceAll" : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? "replaceMerge" : "normalMerge";
            var mappingResult = $76d619f648247e6d$export$574f818966e4da87(oldCmptList, newCmptOptionList, mergeMode);
            // Set mainType and complete subType.
            $76d619f648247e6d$export$5ac61aca2ba0282d(mappingResult, mainType, (0, $116d65051f61bdfe$export$2e2bcd8739ae039));
            // Empty it before the travel, in order to prevent `this._componentsMap`
            // from being used in the `init`/`mergeOption`/`optionUpdated` of some
            // components, which is probably incorrect logic.
            option[mainType] = null;
            componentsMap.set(mainType, null);
            componentsCount.set(mainType, 0);
            var optionsByMainType = [];
            var cmptsByMainType = [];
            var cmptsCountByMainType = 0;
            var tooltipExists;
            var tooltipWarningLogged;
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mappingResult, function(resultItem, index) {
                var componentModel = resultItem.existing;
                var newCmptOption = resultItem.newOption;
                if (!newCmptOption) {
                    if (componentModel) {
                        // Consider where is no new option and should be merged using {},
                        // see removeEdgeAndAdd in topologicalTravel and
                        // ComponentModel.getAllClassMainTypes.
                        componentModel.mergeOption({}, this);
                        componentModel.optionUpdated({}, false);
                    }
                } else {
                    var isSeriesType = mainType === "series";
                    var ComponentModelClass = (0, $116d65051f61bdfe$export$2e2bcd8739ae039).getClass(mainType, resultItem.keyInfo.subType, !isSeriesType // Give a more detailed warn later if series don't exists
                    );
                    if (!ComponentModelClass) {
                        var subType, seriesImportName;
                        return;
                    }
                    // TODO Before multiple tooltips get supported, we do this check to avoid unexpected exception.
                    if (mainType === "tooltip") {
                        if (tooltipExists) return;
                        tooltipExists = true;
                    }
                    if (componentModel && componentModel.constructor === ComponentModelClass) {
                        componentModel.name = resultItem.keyInfo.name;
                        // componentModel.settingTask && componentModel.settingTask.dirty();
                        componentModel.mergeOption(newCmptOption, this);
                        componentModel.optionUpdated(newCmptOption, false);
                    } else {
                        // PENDING Global as parent ?
                        var extraOpt = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                            componentIndex: index
                        }, resultItem.keyInfo);
                        componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt);
                        // Assign `keyInfo`
                        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(componentModel, extraOpt);
                        if (resultItem.brandNew) componentModel.__requireNewView = true;
                        componentModel.init(newCmptOption, this, this);
                        // Call optionUpdated after init.
                        // newCmptOption has been used as componentModel.option
                        // and may be merged with theme and default, so pass null
                        // to avoid confusion.
                        componentModel.optionUpdated(null, true);
                    }
                }
                if (componentModel) {
                    optionsByMainType.push(componentModel.option);
                    cmptsByMainType.push(componentModel);
                    cmptsCountByMainType++;
                } else {
                    // Always do assign to avoid elided item in array.
                    optionsByMainType.push(void 0);
                    cmptsByMainType.push(void 0);
                }
            }, this);
            option[mainType] = optionsByMainType;
            componentsMap.set(mainType, cmptsByMainType);
            componentsCount.set(mainType, cmptsCountByMainType);
            // Backup series for filtering.
            if (mainType === "series") $51f6ef0dd9546916$var$reCreateSeriesIndices(this);
        }
        // If no series declared, ensure `_seriesIndices` initialized.
        if (!this._seriesIndices) $51f6ef0dd9546916$var$reCreateSeriesIndices(this);
    };
    /**
   * Get option for output (cloned option and inner info removed)
   */ GlobalModel.prototype.getOption = function() {
        var option = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(this.option);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(option, function(optInMainType, mainType) {
            if ((0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(mainType)) {
                var opts = $76d619f648247e6d$export$4f07b212a02c8051(optInMainType);
                // Inner cmpts need to be removed.
                // Inner cmpts might not be at last since ec5.0, but still
                // compatible for users: if inner cmpt at last, splice the returned array.
                var realLen = opts.length;
                var metNonInner = false;
                for(var i = realLen - 1; i >= 0; i--)// Remove options with inner id.
                if (opts[i] && !$76d619f648247e6d$export$feece3e7d52a102b(opts[i])) metNonInner = true;
                else {
                    opts[i] = null;
                    !metNonInner && realLen--;
                }
                opts.length = realLen;
                option[mainType] = opts;
            }
        });
        delete option[$51f6ef0dd9546916$var$OPTION_INNER_KEY];
        return option;
    };
    GlobalModel.prototype.getTheme = function() {
        return this._theme;
    };
    GlobalModel.prototype.getLocaleModel = function() {
        return this._locale;
    };
    GlobalModel.prototype.setUpdatePayload = function(payload) {
        this._payload = payload;
    };
    GlobalModel.prototype.getUpdatePayload = function() {
        return this._payload;
    };
    /**
   * @param idx If not specified, return the first one.
   */ GlobalModel.prototype.getComponent = function(mainType, idx) {
        var list = this._componentsMap.get(mainType);
        if (list) {
            var cmpt = list[idx || 0];
            if (cmpt) return cmpt;
            else if (idx == null) for(var i = 0; i < list.length; i++){
                if (list[i]) return list[i];
            }
        }
    };
    /**
   * @return Never be null/undefined.
   */ GlobalModel.prototype.queryComponents = function(condition) {
        var mainType = condition.mainType;
        if (!mainType) return [];
        var index = condition.index;
        var id = condition.id;
        var name = condition.name;
        var cmpts = this._componentsMap.get(mainType);
        if (!cmpts || !cmpts.length) return [];
        var result;
        if (index != null) {
            result = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($76d619f648247e6d$export$4f07b212a02c8051(index), function(idx) {
                cmpts[idx] && result.push(cmpts[idx]);
            });
        } else if (id != null) result = $51f6ef0dd9546916$var$queryByIdOrName("id", id, cmpts);
        else if (name != null) result = $51f6ef0dd9546916$var$queryByIdOrName("name", name, cmpts);
        else // Return all non-empty components in that mainType
        result = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return !!cmpt;
        });
        return $51f6ef0dd9546916$var$filterBySubType(result, condition);
    };
    /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * let result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series',
   *     filter: function (model, index) {...}}
   * );
   * // result like [component0, componnet1, ...]
   */ GlobalModel.prototype.findComponents = function(condition) {
        var query = condition.query;
        var mainType = condition.mainType;
        var queryCond = getQueryCond(query);
        var result = queryCond ? this.queryComponents(queryCond) : (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(this._componentsMap.get(mainType), function(cmpt) {
            return !!cmpt;
        });
        return doFilter($51f6ef0dd9546916$var$filterBySubType(result, condition));
        function getQueryCond(q) {
            var indexAttr = mainType + "Index";
            var idAttr = mainType + "Id";
            var nameAttr = mainType + "Name";
            return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
                mainType: mainType,
                // subType will be filtered finally.
                index: q[indexAttr],
                id: q[idAttr],
                name: q[nameAttr]
            } : null;
        }
        function doFilter(res) {
            return condition.filter ? (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(res, condition.filter) : res;
        }
    };
    GlobalModel.prototype.eachComponent = function(mainType, cb, context) {
        var componentsMap = this._componentsMap;
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(mainType)) {
            var ctxForAll_1 = cb;
            var cbForAll_1 = mainType;
            componentsMap.each(function(cmpts, componentType) {
                for(var i = 0; cmpts && i < cmpts.length; i++){
                    var cmpt = cmpts[i];
                    cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
                }
            });
        } else {
            var cmpts = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(mainType) ? componentsMap.get(mainType) : (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(mainType) ? this.findComponents(mainType) : null;
            for(var i = 0; cmpts && i < cmpts.length; i++){
                var cmpt = cmpts[i];
                cmpt && cb.call(context, cmpt, cmpt.componentIndex);
            }
        }
    };
    /**
   * Get series list before filtered by name.
   */ GlobalModel.prototype.getSeriesByName = function(name) {
        var nameStr = $76d619f648247e6d$export$fb1a222ba5dd6e51(name, null);
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(this._componentsMap.get("series"), function(oneSeries) {
            return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
        });
    };
    /**
   * Get series list before filtered by index.
   */ GlobalModel.prototype.getSeriesByIndex = function(seriesIndex) {
        return this._componentsMap.get("series")[seriesIndex];
    };
    /**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   */ GlobalModel.prototype.getSeriesByType = function(subType) {
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(this._componentsMap.get("series"), function(oneSeries) {
            return !!oneSeries && oneSeries.subType === subType;
        });
    };
    /**
   * Get all series before filtered.
   */ GlobalModel.prototype.getSeries = function() {
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(this._componentsMap.get("series"), function(oneSeries) {
            return !!oneSeries;
        });
    };
    /**
   * Count series before filtered.
   */ GlobalModel.prototype.getSeriesCount = function() {
        return this._componentsCount.get("series");
    };
    /**
   * After filtering, series may be different
   * from raw series.
   */ GlobalModel.prototype.eachSeries = function(cb, context) {
        $51f6ef0dd9546916$var$assertSeriesInitialized(this);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get("series")[rawSeriesIndex];
            cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered.
   *
   * @param {Function} cb
   * @param {*} context
   */ GlobalModel.prototype.eachRawSeries = function(cb, context) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._componentsMap.get("series"), function(series) {
            series && cb.call(context, series, series.componentIndex);
        });
    };
    /**
   * After filtering, series may be different.
   * from raw series.
   */ GlobalModel.prototype.eachSeriesByType = function(subType, cb, context) {
        $51f6ef0dd9546916$var$assertSeriesInitialized(this);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get("series")[rawSeriesIndex];
            if (series.subType === subType) cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered of given type.
   */ GlobalModel.prototype.eachRawSeriesByType = function(subType, cb, context) {
        return (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this.getSeriesByType(subType), cb, context);
    };
    GlobalModel.prototype.isSeriesFiltered = function(seriesModel) {
        $51f6ef0dd9546916$var$assertSeriesInitialized(this);
        return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
    };
    GlobalModel.prototype.getCurrentSeriesIndices = function() {
        return (this._seriesIndices || []).slice();
    };
    GlobalModel.prototype.filterSeries = function(cb, context) {
        $51f6ef0dd9546916$var$assertSeriesInitialized(this);
        var newSeriesIndices = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._seriesIndices, function(seriesRawIdx) {
            var series = this._componentsMap.get("series")[seriesRawIdx];
            cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
        }, this);
        this._seriesIndices = newSeriesIndices;
        this._seriesIndicesMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)(newSeriesIndices);
    };
    GlobalModel.prototype.restoreData = function(payload) {
        $51f6ef0dd9546916$var$reCreateSeriesIndices(this);
        var componentsMap = this._componentsMap;
        var componentTypes = [];
        componentsMap.each(function(components, componentType) {
            if ((0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(componentType)) componentTypes.push(componentType);
        });
        (0, $116d65051f61bdfe$export$2e2bcd8739ae039).topologicalTravel(componentTypes, (0, $116d65051f61bdfe$export$2e2bcd8739ae039).getAllClassMainTypes(), function(componentType) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(componentsMap.get(componentType), function(component) {
                if (component && (componentType !== "series" || !$51f6ef0dd9546916$var$isNotTargetSeries(component, payload))) component.restoreData();
            });
        });
    };
    GlobalModel.internalField = function() {
        $51f6ef0dd9546916$var$reCreateSeriesIndices = function(ecModel) {
            var seriesIndices = ecModel._seriesIndices = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ecModel._componentsMap.get("series"), function(series) {
                // series may have been removed by `replaceMerge`.
                series && seriesIndices.push(series.componentIndex);
            });
            ecModel._seriesIndicesMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)(seriesIndices);
        };
        $51f6ef0dd9546916$var$assertSeriesInitialized = function(ecModel) {};
        $51f6ef0dd9546916$var$initBase = function(ecModel, baseOption) {
            // Using OPTION_INNER_KEY to mark that this option cannot be used outside,
            // i.e. `chart.setOption(chart.getModel().option);` is forbidden.
            ecModel.option = {};
            ecModel.option[$51f6ef0dd9546916$var$OPTION_INNER_KEY] = $51f6ef0dd9546916$var$OPTION_INNER_VALUE;
            // Init with series: [], in case of calling findSeries method
            // before series initialized.
            ecModel._componentsMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)({
                series: []
            });
            ecModel._componentsCount = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
            // If user spefied `option.aria`, aria will be enable. This detection should be
            // performed before theme and globalDefault merge.
            var airaOption = baseOption.aria;
            if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(airaOption) && airaOption.enabled == null) airaOption.enabled = true;
            $51f6ef0dd9546916$var$mergeTheme(baseOption, ecModel._theme.option);
            // TODO Needs clone when merging to the unexisted property
            (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(baseOption, (0, $2d7ac35b3b3d57e3$export$2e2bcd8739ae039), false);
            ecModel._mergeOption(baseOption, null);
        };
    }();
    return GlobalModel;
}((0, $6818646a97528290$export$2e2bcd8739ae039));
function $51f6ef0dd9546916$var$isNotTargetSeries(seriesModel, payload) {
    if (payload) {
        var index = payload.seriesIndex;
        var id = payload.seriesId;
        var name_1 = payload.seriesName;
        return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
    }
}
function $51f6ef0dd9546916$var$mergeTheme(option, theme) {
    // PENDING
    // NOT use `colorLayer` in theme if option has `color`
    var notMergeColorLayer = option.color && !option.colorLayer;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(theme, function(themeItem, name) {
        if (name === "colorLayer" && notMergeColorLayer) return;
        // If it is component model mainType, the model handles that merge later.
        // otherwise, merge them here.
        if (!(0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(name)) {
            if (typeof themeItem === "object") option[name] = !option[name] ? (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(themeItem) : (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(option[name], themeItem, false);
            else if (option[name] == null) option[name] = themeItem;
        }
    });
}
function $51f6ef0dd9546916$var$queryByIdOrName(attr, idOrName, cmpts) {
    // Here is a break from echarts4: string and number are
    // treated as equal.
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(idOrName)) {
        var keyMap_1 = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(idOrName, function(idOrNameItem) {
            if (idOrNameItem != null) {
                var idName = $76d619f648247e6d$export$fb1a222ba5dd6e51(idOrNameItem, null);
                idName != null && keyMap_1.set(idOrNameItem, true);
            }
        });
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return cmpt && keyMap_1.get(cmpt[attr]);
        });
    } else {
        var idName_1 = $76d619f648247e6d$export$fb1a222ba5dd6e51(idOrName, null);
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return cmpt && idName_1 != null && cmpt[attr] === idName_1;
        });
    }
}
function $51f6ef0dd9546916$var$filterBySubType(components, condition) {
    // Using hasOwnProperty for restrict. Consider
    // subType is undefined in user payload.
    return condition.hasOwnProperty("subType") ? (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(components, function(cmpt) {
        return cmpt && cmpt.subType === condition.subType;
    }) : components;
}
function $51f6ef0dd9546916$var$normalizeSetOptionInput(opts) {
    var replaceMergeMainTypeMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    opts && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($76d619f648247e6d$export$4f07b212a02c8051(opts.replaceMerge), function(mainType) {
        replaceMergeMainTypeMap.set(mainType, true);
    });
    return {
        replaceMergeMainTypeMap: replaceMergeMainTypeMap
    };
}
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($51f6ef0dd9546916$var$GlobalModel, (0, $e7fbd47751ca3c28$export$55a3c39e852b90f4));
var $51f6ef0dd9546916$export$2e2bcd8739ae039 = $51f6ef0dd9546916$var$GlobalModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $a6d7e6163195660e$var$availableMethods = [
    "getDom",
    "getZr",
    "getWidth",
    "getHeight",
    "getDevicePixelRatio",
    "dispatchAction",
    "isSSR",
    "isDisposed",
    "on",
    "off",
    "getDataURL",
    "getConnectedDataURL",
    // 'getModel',
    "getOption",
    // 'getViewOfComponentModel',
    // 'getViewOfSeriesModel',
    "getId",
    "updateLabelLayout"
];
var $a6d7e6163195660e$var$ExtensionAPI = /** @class */ function() {
    function ExtensionAPI(ecInstance) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($a6d7e6163195660e$var$availableMethods, function(methodName) {
            this[methodName] = $7a1bd9c2710fea0d$export$2385a24977818dd0(ecInstance[methodName], ecInstance);
        }, this);
    }
    return ExtensionAPI;
}();
var $a6d7e6163195660e$export$2e2bcd8739ae039 = $a6d7e6163195660e$var$ExtensionAPI;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $70c3ede7d3b64757$var$coordinateSystemCreators = {};
var $70c3ede7d3b64757$var$CoordinateSystemManager = /** @class */ function() {
    function CoordinateSystemManager() {
        this._coordinateSystems = [];
    }
    CoordinateSystemManager.prototype.create = function(ecModel, api) {
        var coordinateSystems = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($70c3ede7d3b64757$var$coordinateSystemCreators, function(creator, type) {
            var list = creator.create(ecModel, api);
            coordinateSystems = coordinateSystems.concat(list || []);
        });
        this._coordinateSystems = coordinateSystems;
    };
    CoordinateSystemManager.prototype.update = function(ecModel, api) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._coordinateSystems, function(coordSys) {
            coordSys.update && coordSys.update(ecModel, api);
        });
    };
    CoordinateSystemManager.prototype.getCoordinateSystems = function() {
        return this._coordinateSystems.slice();
    };
    CoordinateSystemManager.register = function(type, creator) {
        $70c3ede7d3b64757$var$coordinateSystemCreators[type] = creator;
    };
    CoordinateSystemManager.get = function(type) {
        return $70c3ede7d3b64757$var$coordinateSystemCreators[type];
    };
    return CoordinateSystemManager;
}();
var $70c3ede7d3b64757$export$2e2bcd8739ae039 = $70c3ede7d3b64757$var$CoordinateSystemManager;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $bf4c0a9077b4e970$var$QUERY_REG = /^(min|max)?(.+)$/;
// Key: mainType
// type FakeComponentsMap = HashMap<(MappingExistingItem & { subType: string })[]>;
/**
 * TERM EXPLANATIONS:
 * See `ECOption` and `ECUnitOption` in `src/util/types.ts`.
 */ var $bf4c0a9077b4e970$var$OptionManager = /** @class */ function() {
    // timeline.notMerge is not supported in ec3. Firstly there is rearly
    // case that notMerge is needed. Secondly supporting 'notMerge' requires
    // rawOption cloned and backuped when timeline changed, which does no
    // good to performance. What's more, that both timeline and setOption
    // method supply 'notMerge' brings complex and some problems.
    // Consider this case:
    // (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
    // (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
    function OptionManager(api) {
        this._timelineOptions = [];
        this._mediaList = [];
        /**
     * -1, means default.
     * empty means no media.
     */ this._currentMediaIndices = [];
        this._api = api;
    }
    OptionManager.prototype.setOption = function(rawOption, optionPreprocessorFuncs, opt) {
        if (rawOption) {
            // That set dat primitive is dangerous if user reuse the data when setOption again.
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(rawOption.series), function(series) {
                series && series.data && (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(series.data) && (0, $7a1bd9c2710fea0d$export$112e66431016387b)(series.data);
            });
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(rawOption.dataset), function(dataset) {
                dataset && dataset.source && (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(dataset.source) && (0, $7a1bd9c2710fea0d$export$112e66431016387b)(dataset.source);
            });
        }
        // Caution: some series modify option data, if do not clone,
        // it should ensure that the repeat modify correctly
        // (create a new object when modify itself).
        rawOption = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(rawOption);
        // FIXME
        // If some property is set in timeline options or media option but
        // not set in baseOption, a warning should be given.
        var optionBackup = this._optionBackup;
        var newParsedOption = $bf4c0a9077b4e970$var$parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
        this._newBaseOption = newParsedOption.baseOption;
        // For setOption at second time (using merge mode);
        if (optionBackup) {
            // FIXME
            // the restore merge solution is essentially incorrect.
            // the mapping can not be 100% consistent with ecModel, which probably brings
            // potential bug!
            // The first merge is delayed, because in most cases, users do not call `setOption` twice.
            // let fakeCmptsMap = this._fakeCmptsMap;
            // if (!fakeCmptsMap) {
            //     fakeCmptsMap = this._fakeCmptsMap = createHashMap();
            //     mergeToBackupOption(fakeCmptsMap, null, optionBackup.baseOption, null);
            // }
            // mergeToBackupOption(
            //     fakeCmptsMap, optionBackup.baseOption, newParsedOption.baseOption, opt
            // );
            // For simplicity, timeline options and media options do not support merge,
            // that is, if you `setOption` twice and both has timeline options, the latter
            // timeline options will not be merged to the former, but just substitute them.
            if (newParsedOption.timelineOptions.length) optionBackup.timelineOptions = newParsedOption.timelineOptions;
            if (newParsedOption.mediaList.length) optionBackup.mediaList = newParsedOption.mediaList;
            if (newParsedOption.mediaDefault) optionBackup.mediaDefault = newParsedOption.mediaDefault;
        } else this._optionBackup = newParsedOption;
    };
    OptionManager.prototype.mountOption = function(isRecreate) {
        var optionBackup = this._optionBackup;
        this._timelineOptions = optionBackup.timelineOptions;
        this._mediaList = optionBackup.mediaList;
        this._mediaDefault = optionBackup.mediaDefault;
        this._currentMediaIndices = [];
        return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(isRecreate ? optionBackup.baseOption : this._newBaseOption);
    };
    OptionManager.prototype.getTimelineOption = function(ecModel) {
        var option;
        var timelineOptions = this._timelineOptions;
        if (timelineOptions.length) {
            // getTimelineOption can only be called after ecModel inited,
            // so we can get currentIndex from timelineModel.
            var timelineModel = ecModel.getComponent("timeline");
            if (timelineModel) option = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(// FIXME:TS as TimelineModel or quivlant interface
            timelineOptions[timelineModel.getCurrentIndex()]);
        }
        return option;
    };
    OptionManager.prototype.getMediaOption = function(ecModel) {
        var ecWidth = this._api.getWidth();
        var ecHeight = this._api.getHeight();
        var mediaList = this._mediaList;
        var mediaDefault = this._mediaDefault;
        var indices = [];
        var result = [];
        // No media defined.
        if (!mediaList.length && !mediaDefault) return result;
        // Multi media may be applied, the latter defined media has higher priority.
        for(var i = 0, len = mediaList.length; i < len; i++)if ($bf4c0a9077b4e970$var$applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) indices.push(i);
        // FIXME
        // Whether mediaDefault should force users to provide? Otherwise
        // the change by media query can not be recorvered.
        if (!indices.length && mediaDefault) indices = [
            -1
        ];
        if (indices.length && !$bf4c0a9077b4e970$var$indicesEquals(indices, this._currentMediaIndices)) result = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(indices, function(index) {
            return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(index === -1 ? mediaDefault.option : mediaList[index].option);
        });
        // Otherwise return nothing.
        this._currentMediaIndices = indices;
        return result;
    };
    return OptionManager;
}();
/**
 * [RAW_OPTION_PATTERNS]
 * (Note: "series: []" represents all other props in `ECUnitOption`)
 *
 * (1) No prop "baseOption" declared:
 * Root option is used as "baseOption" (except prop "options" and "media").
 * ```js
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 * };
 * option = {
 *     series: [],
 *     media: {},
 * };
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 *     media: {},
 * }
 * ```
 *
 * (2) Prop "baseOption" declared:
 * If "baseOption" declared, `ECUnitOption` props can only be declared
 * inside "baseOption" except prop "timeline" (compat ec2).
 * ```js
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 * };
 * option = {
 *     baseOption: {
 *         series: [],
 *     },
 *     media: []
 * };
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 *     media: []
 * };
 * option = {
 *     // ec3 compat ec2: allow (only) `timeline` declared
 *     // outside baseOption. Keep this setting for compat.
 *     timeline: {},
 *     baseOption: {
 *         series: [],
 *     },
 *     options: [],
 *     media: []
 * };
 * ```
 */ function $bf4c0a9077b4e970$var$parseRawOption(// `rawOption` May be modified
rawOption, optionPreprocessorFuncs, isNew) {
    var mediaList = [];
    var mediaDefault;
    var baseOption;
    var declaredBaseOption = rawOption.baseOption;
    // Compatible with ec2, [RAW_OPTION_PATTERNS] above.
    var timelineOnRoot = rawOption.timeline;
    var timelineOptionsOnRoot = rawOption.options;
    var mediaOnRoot = rawOption.media;
    var hasMedia = !!rawOption.media;
    var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);
    if (declaredBaseOption) {
        baseOption = declaredBaseOption;
        // For merge option.
        if (!baseOption.timeline) baseOption.timeline = timelineOnRoot;
    } else {
        if (hasTimeline || hasMedia) rawOption.options = rawOption.media = null;
        baseOption = rawOption;
    }
    if (hasMedia) {
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(mediaOnRoot)) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mediaOnRoot, function(singleMedia) {
            if (singleMedia && singleMedia.option) {
                if (singleMedia.query) mediaList.push(singleMedia);
                else if (!mediaDefault) // Use the first media default.
                mediaDefault = singleMedia;
            }
        });
    }
    doPreprocess(baseOption);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(timelineOptionsOnRoot, function(option) {
        return doPreprocess(option);
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mediaList, function(media) {
        return doPreprocess(media.option);
    });
    function doPreprocess(option) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(optionPreprocessorFuncs, function(preProcess) {
            preProcess(option, isNew);
        });
    }
    return {
        baseOption: baseOption,
        timelineOptions: timelineOptionsOnRoot || [],
        mediaDefault: mediaDefault,
        mediaList: mediaList
    };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */ function $bf4c0a9077b4e970$var$applyMediaQuery(query, ecWidth, ecHeight) {
    var realMap = {
        width: ecWidth,
        height: ecHeight,
        aspectratio: ecWidth / ecHeight // lower case for convenience.
    };
    var applicable = true;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(query, function(value, attr) {
        var matched = attr.match($bf4c0a9077b4e970$var$QUERY_REG);
        if (!matched || !matched[1] || !matched[2]) return;
        var operator = matched[1];
        var realAttr = matched[2].toLowerCase();
        if (!$bf4c0a9077b4e970$var$compare(realMap[realAttr], value, operator)) applicable = false;
    });
    return applicable;
}
function $bf4c0a9077b4e970$var$compare(real, expect, operator) {
    if (operator === "min") return real >= expect;
    else if (operator === "max") return real <= expect;
    else // Equals
    return real === expect;
}
function $bf4c0a9077b4e970$var$indicesEquals(indices1, indices2) {
    // indices is always order by asc and has only finite number.
    return indices1.join(",") === indices2.join(",");
}
var /**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handles its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performance expensive)
 *
 * FIXME: A possible solution:
 * Add a extra level of model for each component model. The inheritance chain would be:
 * ecModel <- componentModel <- componentActionModel <- dataItemModel
 * And all of the actions can only modify the `componentActionModel` rather than
 * `componentModel`. `setOption` will only modify the `ecModel` and `componentModel`.
 * When "resotre" action triggered, model from `componentActionModel` will be discarded
 * instead of recreating the "ecModel" from the "_optionBackup".
 */ // function mergeToBackupOption(
//     fakeCmptsMap: FakeComponentsMap,
//     // `tarOption` Can be null/undefined, means init
//     tarOption: ECUnitOption,
//     newOption: ECUnitOption,
//     // Can be null/undefined
//     opt: InnerSetOptionOpts
// ): void {
//     newOption = newOption || {} as ECUnitOption;
//     const notInit = !!tarOption;
//     each(newOption, function (newOptsInMainType, mainType) {
//         if (newOptsInMainType == null) {
//             return;
//         }
//         if (!ComponentModel.hasClass(mainType)) {
//             if (tarOption) {
//                 tarOption[mainType] = merge(tarOption[mainType], newOptsInMainType, true);
//             }
//         }
//         else {
//             const oldTarOptsInMainType = notInit ? normalizeToArray(tarOption[mainType]) : null;
//             const oldFakeCmptsInMainType = fakeCmptsMap.get(mainType) || [];
//             const resultTarOptsInMainType = notInit ? (tarOption[mainType] = [] as ComponentOption[]) : null;
//             const resultFakeCmptsInMainType = fakeCmptsMap.set(mainType, []);
//             const mappingResult = mappingToExists(
//                 oldFakeCmptsInMainType,
//                 normalizeToArray(newOptsInMainType),
//                 (opt && opt.replaceMergeMainTypeMap.get(mainType)) ? 'replaceMerge' : 'normalMerge'
//             );
//             setComponentTypeToKeyInfo(mappingResult, mainType, ComponentModel as ComponentModelConstructor);
//             each(mappingResult, function (resultItem, index) {
//                 // The same logic as `Global.ts#_mergeOption`.
//                 let fakeCmpt = resultItem.existing;
//                 const newOption = resultItem.newOption;
//                 const keyInfo = resultItem.keyInfo;
//                 let fakeCmptOpt;
//                 if (!newOption) {
//                     fakeCmptOpt = oldTarOptsInMainType[index];
//                 }
//                 else {
//                     if (fakeCmpt && fakeCmpt.subType === keyInfo.subType) {
//                         fakeCmpt.name = keyInfo.name;
//                         if (notInit) {
//                             fakeCmptOpt = merge(oldTarOptsInMainType[index], newOption, true);
//                         }
//                     }
//                     else {
//                         fakeCmpt = extend({}, keyInfo);
//                         if (notInit) {
//                             fakeCmptOpt = clone(newOption);
//                         }
//                     }
//                 }
//                 if (fakeCmpt) {
//                     notInit && resultTarOptsInMainType.push(fakeCmptOpt);
//                     resultFakeCmptsInMainType.push(fakeCmpt);
//                 }
//                 else {
//                     notInit && resultTarOptsInMainType.push(void 0);
//                     resultFakeCmptsInMainType.push(void 0);
//                 }
//             });
//         }
//     });
// }
$bf4c0a9077b4e970$export$2e2bcd8739ae039 = $bf4c0a9077b4e970$var$OptionManager;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $621cc5e1b758ea39$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $621cc5e1b758ea39$var$isObject = $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a;
var $621cc5e1b758ea39$var$POSSIBLE_STYLES = [
    "areaStyle",
    "lineStyle",
    "nodeStyle",
    "linkStyle",
    "chordStyle",
    "label",
    "labelLine"
];
function $621cc5e1b758ea39$var$compatEC2ItemStyle(opt) {
    var itemStyleOpt = opt && opt.itemStyle;
    if (!itemStyleOpt) return;
    for(var i = 0, len = $621cc5e1b758ea39$var$POSSIBLE_STYLES.length; i < len; i++){
        var styleName = $621cc5e1b758ea39$var$POSSIBLE_STYLES[i];
        var normalItemStyleOpt = itemStyleOpt.normal;
        var emphasisItemStyleOpt = itemStyleOpt.emphasis;
        if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].normal) opt[styleName].normal = normalItemStyleOpt[styleName];
            else $7a1bd9c2710fea0d$export$4950aa0f605343fb(opt[styleName].normal, normalItemStyleOpt[styleName]);
            normalItemStyleOpt[styleName] = null;
        }
        if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].emphasis) opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
            else $7a1bd9c2710fea0d$export$4950aa0f605343fb(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
            emphasisItemStyleOpt[styleName] = null;
        }
    }
}
function $621cc5e1b758ea39$var$convertNormalEmphasis(opt, optType, useExtend) {
    if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
        var normalOpt = opt[optType].normal;
        var emphasisOpt = opt[optType].emphasis;
        if (normalOpt) {
            // Timeline controlStyle has other properties besides normal and emphasis
            if (useExtend) {
                opt[optType].normal = opt[optType].emphasis = null;
                $7a1bd9c2710fea0d$export$ebe90cb607ad99e(opt[optType], normalOpt);
            } else opt[optType] = normalOpt;
        }
        if (emphasisOpt) {
            opt.emphasis = opt.emphasis || {};
            opt.emphasis[optType] = emphasisOpt;
            // Also compat the case user mix the style and focus together in ec3 style
            // for example: { itemStyle: { normal: {}, emphasis: {focus, shadowBlur} } }
            if (emphasisOpt.focus) opt.emphasis.focus = emphasisOpt.focus;
            if (emphasisOpt.blurScope) opt.emphasis.blurScope = emphasisOpt.blurScope;
        }
    }
}
function $621cc5e1b758ea39$var$removeEC3NormalStatus(opt) {
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "itemStyle");
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "lineStyle");
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "areaStyle");
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "label");
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "labelLine");
    // treemap
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "upperLabel");
    // graph
    $621cc5e1b758ea39$var$convertNormalEmphasis(opt, "edgeLabel");
}
function $621cc5e1b758ea39$var$compatTextStyle(opt, propName) {
    // Check whether is not object (string\null\undefined ...)
    var labelOptSingle = $621cc5e1b758ea39$var$isObject(opt) && opt[propName];
    var textStyle = $621cc5e1b758ea39$var$isObject(labelOptSingle) && labelOptSingle.textStyle;
    if (textStyle) for(var i = 0, len = $76d619f648247e6d$export$df45610347a602ad.length; i < len; i++){
        var textPropName = $76d619f648247e6d$export$df45610347a602ad[i];
        if (textStyle.hasOwnProperty(textPropName)) labelOptSingle[textPropName] = textStyle[textPropName];
    }
}
function $621cc5e1b758ea39$var$compatEC3CommonStyles(opt) {
    if (opt) {
        $621cc5e1b758ea39$var$removeEC3NormalStatus(opt);
        $621cc5e1b758ea39$var$compatTextStyle(opt, "label");
        opt.emphasis && $621cc5e1b758ea39$var$compatTextStyle(opt.emphasis, "label");
    }
}
function $621cc5e1b758ea39$var$processSeries(seriesOpt) {
    if (!$621cc5e1b758ea39$var$isObject(seriesOpt)) return;
    $621cc5e1b758ea39$var$compatEC2ItemStyle(seriesOpt);
    $621cc5e1b758ea39$var$removeEC3NormalStatus(seriesOpt);
    $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, "label");
    // treemap
    $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, "upperLabel");
    // graph
    $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, "edgeLabel");
    if (seriesOpt.emphasis) {
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt.emphasis, "label");
        // treemap
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt.emphasis, "upperLabel");
        // graph
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt.emphasis, "edgeLabel");
    }
    var markPoint = seriesOpt.markPoint;
    if (markPoint) {
        $621cc5e1b758ea39$var$compatEC2ItemStyle(markPoint);
        $621cc5e1b758ea39$var$compatEC3CommonStyles(markPoint);
    }
    var markLine = seriesOpt.markLine;
    if (markLine) {
        $621cc5e1b758ea39$var$compatEC2ItemStyle(markLine);
        $621cc5e1b758ea39$var$compatEC3CommonStyles(markLine);
    }
    var markArea = seriesOpt.markArea;
    if (markArea) $621cc5e1b758ea39$var$compatEC3CommonStyles(markArea);
    var data = seriesOpt.data;
    // Break with ec3: if `setOption` again, there may be no `type` in option,
    // then the backward compat based on option type will not be performed.
    if (seriesOpt.type === "graph") {
        data = data || seriesOpt.nodes;
        var edgeData = seriesOpt.links || seriesOpt.edges;
        if (edgeData && !$7a1bd9c2710fea0d$export$b119cc7e1840e59c(edgeData)) for(var i = 0; i < edgeData.length; i++)$621cc5e1b758ea39$var$compatEC3CommonStyles(edgeData[i]);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(seriesOpt.categories, function(opt) {
            $621cc5e1b758ea39$var$removeEC3NormalStatus(opt);
        });
    }
    if (data && !$7a1bd9c2710fea0d$export$b119cc7e1840e59c(data)) for(var i = 0; i < data.length; i++)$621cc5e1b758ea39$var$compatEC3CommonStyles(data[i]);
    // mark point data
    markPoint = seriesOpt.markPoint;
    if (markPoint && markPoint.data) {
        var mpData = markPoint.data;
        for(var i = 0; i < mpData.length; i++)$621cc5e1b758ea39$var$compatEC3CommonStyles(mpData[i]);
    }
    // mark line data
    markLine = seriesOpt.markLine;
    if (markLine && markLine.data) {
        var mlData = markLine.data;
        for(var i = 0; i < mlData.length; i++)if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(mlData[i])) {
            $621cc5e1b758ea39$var$compatEC3CommonStyles(mlData[i][0]);
            $621cc5e1b758ea39$var$compatEC3CommonStyles(mlData[i][1]);
        } else $621cc5e1b758ea39$var$compatEC3CommonStyles(mlData[i]);
    }
    // Series
    if (seriesOpt.type === "gauge") {
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, "axisLabel");
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, "title");
        $621cc5e1b758ea39$var$compatTextStyle(seriesOpt, "detail");
    } else if (seriesOpt.type === "treemap") {
        $621cc5e1b758ea39$var$convertNormalEmphasis(seriesOpt.breadcrumb, "itemStyle");
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(seriesOpt.levels, function(opt) {
            $621cc5e1b758ea39$var$removeEC3NormalStatus(opt);
        });
    } else if (seriesOpt.type === "tree") $621cc5e1b758ea39$var$removeEC3NormalStatus(seriesOpt.leaves);
// sunburst starts from ec4, so it does not need to compat levels.
}
function $621cc5e1b758ea39$var$toArr(o) {
    return $7a1bd9c2710fea0d$export$43bee75e5e14138e(o) ? o : o ? [
        o
    ] : [];
}
function $621cc5e1b758ea39$var$toObj(o) {
    return ($7a1bd9c2710fea0d$export$43bee75e5e14138e(o) ? o[0] : o) || {};
}
function $621cc5e1b758ea39$export$2e2bcd8739ae039(option, isTheme) {
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.series), function(seriesOpt) {
        $621cc5e1b758ea39$var$isObject(seriesOpt) && $621cc5e1b758ea39$var$processSeries(seriesOpt);
    });
    var axes = [
        "xAxis",
        "yAxis",
        "radiusAxis",
        "angleAxis",
        "singleAxis",
        "parallelAxis",
        "radar"
    ];
    isTheme && axes.push("valueAxis", "categoryAxis", "logAxis", "timeAxis");
    $621cc5e1b758ea39$var$each(axes, function(axisName) {
        $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option[axisName]), function(axisOpt) {
            if (axisOpt) {
                $621cc5e1b758ea39$var$compatTextStyle(axisOpt, "axisLabel");
                $621cc5e1b758ea39$var$compatTextStyle(axisOpt.axisPointer, "label");
            }
        });
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.parallel), function(parallelOpt) {
        var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
        $621cc5e1b758ea39$var$compatTextStyle(parallelAxisDefault, "axisLabel");
        $621cc5e1b758ea39$var$compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, "label");
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.calendar), function(calendarOpt) {
        $621cc5e1b758ea39$var$convertNormalEmphasis(calendarOpt, "itemStyle");
        $621cc5e1b758ea39$var$compatTextStyle(calendarOpt, "dayLabel");
        $621cc5e1b758ea39$var$compatTextStyle(calendarOpt, "monthLabel");
        $621cc5e1b758ea39$var$compatTextStyle(calendarOpt, "yearLabel");
    });
    // radar.name.textStyle
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.radar), function(radarOpt) {
        $621cc5e1b758ea39$var$compatTextStyle(radarOpt, "name");
        // Use axisName instead of name because component has name property
        if (radarOpt.name && radarOpt.axisName == null) {
            radarOpt.axisName = radarOpt.name;
            delete radarOpt.name;
        }
        if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
            radarOpt.axisNameGap = radarOpt.nameGap;
            delete radarOpt.nameGap;
        }
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.geo), function(geoOpt) {
        if ($621cc5e1b758ea39$var$isObject(geoOpt)) {
            $621cc5e1b758ea39$var$compatEC3CommonStyles(geoOpt);
            $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(geoOpt.regions), function(regionObj) {
                $621cc5e1b758ea39$var$compatEC3CommonStyles(regionObj);
            });
        }
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.timeline), function(timelineOpt) {
        $621cc5e1b758ea39$var$compatEC3CommonStyles(timelineOpt);
        $621cc5e1b758ea39$var$convertNormalEmphasis(timelineOpt, "label");
        $621cc5e1b758ea39$var$convertNormalEmphasis(timelineOpt, "itemStyle");
        $621cc5e1b758ea39$var$convertNormalEmphasis(timelineOpt, "controlStyle", true);
        var data = timelineOpt.data;
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(data) && $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(item) {
            if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(item)) {
                $621cc5e1b758ea39$var$convertNormalEmphasis(item, "label");
                $621cc5e1b758ea39$var$convertNormalEmphasis(item, "itemStyle");
            }
        });
    });
    $621cc5e1b758ea39$var$each($621cc5e1b758ea39$var$toArr(option.toolbox), function(toolboxOpt) {
        $621cc5e1b758ea39$var$convertNormalEmphasis(toolboxOpt, "iconStyle");
        $621cc5e1b758ea39$var$each(toolboxOpt.feature, function(featureOpt) {
            $621cc5e1b758ea39$var$convertNormalEmphasis(featureOpt, "iconStyle");
        });
    });
    $621cc5e1b758ea39$var$compatTextStyle($621cc5e1b758ea39$var$toObj(option.axisPointer), "label");
    $621cc5e1b758ea39$var$compatTextStyle($621cc5e1b758ea39$var$toObj(option.tooltip).axisPointer, "label");
// Clean logs
// storedLogs = {};
}




function $c4489ebdf95633b6$var$get(opt, path) {
    var pathArr = path.split(",");
    var obj = opt;
    for(var i = 0; i < pathArr.length; i++){
        obj = obj && obj[pathArr[i]];
        if (obj == null) break;
    }
    return obj;
}
function $c4489ebdf95633b6$var$set(opt, path, val, overwrite) {
    var pathArr = path.split(",");
    var obj = opt;
    var key;
    var i = 0;
    for(; i < pathArr.length - 1; i++){
        key = pathArr[i];
        if (obj[key] == null) obj[key] = {};
        obj = obj[key];
    }
    if (overwrite || obj[pathArr[i]] == null) obj[pathArr[i]] = val;
}
function $c4489ebdf95633b6$var$compatLayoutProperties(option) {
    option && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($c4489ebdf95633b6$var$LAYOUT_PROPERTIES, function(prop) {
        if (prop[0] in option && !(prop[1] in option)) option[prop[1]] = option[prop[0]];
    });
}
var $c4489ebdf95633b6$var$LAYOUT_PROPERTIES = [
    [
        "x",
        "left"
    ],
    [
        "y",
        "top"
    ],
    [
        "x2",
        "right"
    ],
    [
        "y2",
        "bottom"
    ]
];
var $c4489ebdf95633b6$var$COMPATITABLE_COMPONENTS = [
    "grid",
    "geo",
    "parallel",
    "legend",
    "toolbox",
    "title",
    "visualMap",
    "dataZoom",
    "timeline"
];
var $c4489ebdf95633b6$var$BAR_ITEM_STYLE_MAP = [
    [
        "borderRadius",
        "barBorderRadius"
    ],
    [
        "borderColor",
        "barBorderColor"
    ],
    [
        "borderWidth",
        "barBorderWidth"
    ]
];
function $c4489ebdf95633b6$var$compatBarItemStyle(option) {
    var itemStyle = option && option.itemStyle;
    if (itemStyle) for(var i = 0; i < $c4489ebdf95633b6$var$BAR_ITEM_STYLE_MAP.length; i++){
        var oldName = $c4489ebdf95633b6$var$BAR_ITEM_STYLE_MAP[i][1];
        var newName = $c4489ebdf95633b6$var$BAR_ITEM_STYLE_MAP[i][0];
        if (itemStyle[oldName] != null) itemStyle[newName] = itemStyle[oldName];
    }
}
function $c4489ebdf95633b6$var$compatPieLabel(option) {
    if (!option) return;
    if (option.alignTo === "edge" && option.margin != null && option.edgeDistance == null) option.edgeDistance = option.margin;
}
function $c4489ebdf95633b6$var$compatSunburstState(option) {
    if (!option) return;
    if (option.downplay && !option.blur) option.blur = option.downplay;
}
function $c4489ebdf95633b6$var$compatGraphFocus(option) {
    if (!option) return;
    if (option.focusNodeAdjacency != null) {
        option.emphasis = option.emphasis || {};
        if (option.emphasis.focus == null) option.emphasis.focus = "adjacency";
    }
}
function $c4489ebdf95633b6$var$traverseTree(data, cb) {
    if (data) for(var i = 0; i < data.length; i++){
        cb(data[i]);
        data[i] && $c4489ebdf95633b6$var$traverseTree(data[i].children, cb);
    }
}
function $c4489ebdf95633b6$export$2e2bcd8739ae039(option, isTheme) {
    (0, $621cc5e1b758ea39$export$2e2bcd8739ae039)(option, isTheme);
    // Make sure series array for model initialization.
    option.series = (0, $76d619f648247e6d$export$4f07b212a02c8051)(option.series);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(option.series, function(seriesOpt) {
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(seriesOpt)) return;
        var seriesType = seriesOpt.type;
        if (seriesType === "line") {
            if (seriesOpt.clipOverflow != null) seriesOpt.clip = seriesOpt.clipOverflow;
        } else if (seriesType === "pie" || seriesType === "gauge") {
            if (seriesOpt.clockWise != null) seriesOpt.clockwise = seriesOpt.clockWise;
            $c4489ebdf95633b6$var$compatPieLabel(seriesOpt.label);
            var data = seriesOpt.data;
            if (data && !(0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data)) for(var i = 0; i < data.length; i++)$c4489ebdf95633b6$var$compatPieLabel(data[i]);
            if (seriesOpt.hoverOffset != null) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                seriesOpt.emphasis.scaleSize = null;
            }
        } else if (seriesType === "gauge") {
            var pointerColor = $c4489ebdf95633b6$var$get(seriesOpt, "pointer.color");
            pointerColor != null && $c4489ebdf95633b6$var$set(seriesOpt, "itemStyle.color", pointerColor);
        } else if (seriesType === "bar") {
            $c4489ebdf95633b6$var$compatBarItemStyle(seriesOpt);
            $c4489ebdf95633b6$var$compatBarItemStyle(seriesOpt.backgroundStyle);
            $c4489ebdf95633b6$var$compatBarItemStyle(seriesOpt.emphasis);
            var data = seriesOpt.data;
            if (data && !(0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data)) {
                for(var i = 0; i < data.length; i++)if (typeof data[i] === "object") {
                    $c4489ebdf95633b6$var$compatBarItemStyle(data[i]);
                    $c4489ebdf95633b6$var$compatBarItemStyle(data[i] && data[i].emphasis);
                }
            }
        } else if (seriesType === "sunburst") {
            var highlightPolicy = seriesOpt.highlightPolicy;
            if (highlightPolicy) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                if (!seriesOpt.emphasis.focus) seriesOpt.emphasis.focus = highlightPolicy;
            }
            $c4489ebdf95633b6$var$compatSunburstState(seriesOpt);
            $c4489ebdf95633b6$var$traverseTree(seriesOpt.data, $c4489ebdf95633b6$var$compatSunburstState);
        } else if (seriesType === "graph" || seriesType === "sankey") $c4489ebdf95633b6$var$compatGraphFocus(seriesOpt);
        else if (seriesType === "map") {
            if (seriesOpt.mapType && !seriesOpt.map) seriesOpt.map = seriesOpt.mapType;
            if (seriesOpt.mapLocation) (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(seriesOpt, seriesOpt.mapLocation);
        }
        if (seriesOpt.hoverAnimation != null) {
            seriesOpt.emphasis = seriesOpt.emphasis || {};
            if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
        }
        $c4489ebdf95633b6$var$compatLayoutProperties(seriesOpt);
    });
    // dataRange has changed to visualMap
    if (option.dataRange) option.visualMap = option.dataRange;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($c4489ebdf95633b6$var$COMPATITABLE_COMPONENTS, function(componentName) {
        var options = option[componentName];
        if (options) {
            if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(options)) options = [
                options
            ];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(options, function(option) {
                $c4489ebdf95633b6$var$compatLayoutProperties(option);
            });
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $92eb0b43a1e7607a$export$2e2bcd8739ae039(ecModel) {
    var stackInfoMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    ecModel.eachSeries(function(seriesModel) {
        var stack = seriesModel.get("stack");
        // Compatible: when `stack` is set as '', do not stack.
        if (stack) {
            var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
            var data = seriesModel.getData();
            var stackInfo = {
                // Used for calculate axis extent automatically.
                // TODO: Type getCalculationInfo return more specific type?
                stackResultDimension: data.getCalculationInfo("stackResultDimension"),
                stackedOverDimension: data.getCalculationInfo("stackedOverDimension"),
                stackedDimension: data.getCalculationInfo("stackedDimension"),
                stackedByDimension: data.getCalculationInfo("stackedByDimension"),
                isStackedByIndex: data.getCalculationInfo("isStackedByIndex"),
                data: data,
                seriesModel: seriesModel
            };
            // If stacked on axis that do not support data stack.
            if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) return;
            stackInfoList.length && data.setCalculationInfo("stackedOnSeries", stackInfoList[stackInfoList.length - 1].seriesModel);
            stackInfoList.push(stackInfo);
        }
    });
    stackInfoMap.each($92eb0b43a1e7607a$var$calculateStack);
}
function $92eb0b43a1e7607a$var$calculateStack(stackInfoList) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stackInfoList, function(targetStackInfo, idxInStack) {
        var resultVal = [];
        var resultNaN = [
            NaN,
            NaN
        ];
        var dims = [
            targetStackInfo.stackResultDimension,
            targetStackInfo.stackedOverDimension
        ];
        var targetData = targetStackInfo.data;
        var isStackedByIndex = targetStackInfo.isStackedByIndex;
        var stackStrategy = targetStackInfo.seriesModel.get("stackStrategy") || "samesign";
        // Should not write on raw data, because stack series model list changes
        // depending on legend selection.
        targetData.modify(dims, function(v0, v1, dataIndex) {
            var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex);
            // Consider `connectNulls` of line area, if value is NaN, stackedOver
            // should also be NaN, to draw a appropriate belt area.
            if (isNaN(sum)) return resultNaN;
            var byValue;
            var stackedDataRawIndex;
            if (isStackedByIndex) stackedDataRawIndex = targetData.getRawIndex(dataIndex);
            else byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
            // If stackOver is NaN, chart view will render point on value start.
            var stackedOver = NaN;
            for(var j = idxInStack - 1; j >= 0; j--){
                var stackInfo = stackInfoList[j];
                // Has been optimized by inverted indices on `stackedByDimension`.
                if (!isStackedByIndex) stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
                if (stackedDataRawIndex >= 0) {
                    var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex);
                    // Considering positive stack, negative stack and empty data
                    if (stackStrategy === "all" // single stack group
                     || stackStrategy === "positive" && val > 0 || stackStrategy === "negative" && val < 0 || stackStrategy === "samesign" && sum >= 0 && val > 0 // All positive stack
                     || stackStrategy === "samesign" && sum <= 0 && val < 0 // All negative stack
                    ) {
                        // The sum has to be very small to be affected by the
                        // floating arithmetic problem. An incorrect result will probably
                        // cause axis min/max to be filtered incorrectly.
                        sum = (0, $cfc1f3b422a3185f$export$d3389a301c3a5706)(sum, val);
                        stackedOver = val;
                        break;
                    }
                }
            }
            resultVal[0] = sum;
            resultVal[1] = stackedOver;
            return resultVal;
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



// @inner
var $99e22f5c2aa5094b$var$SourceImpl = /** @class */ function() {
    function SourceImpl(fields) {
        this.data = fields.data || (fields.sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8) ? {} : []);
        this.sourceFormat = fields.sourceFormat || (0, $cab29724515ce2b8$export$c78f1330778d30d);
        // Visit config
        this.seriesLayoutBy = fields.seriesLayoutBy || (0, $cab29724515ce2b8$export$7b3f3c6551b4949b);
        this.startIndex = fields.startIndex || 0;
        this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
        this.metaRawOption = fields.metaRawOption;
        var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;
        if (dimensionsDefine) for(var i = 0; i < dimensionsDefine.length; i++){
            var dim = dimensionsDefine[i];
            if (dim.type == null) {
                if ((0, $7dc6cdfd7450ef29$export$c51adf1a2be01b9c)(this, i) === (0, $7dc6cdfd7450ef29$export$328749e9c5b40760).Must) dim.type = "ordinal";
            }
        }
    }
    return SourceImpl;
}();
function $99e22f5c2aa5094b$export$22b808bc02a60488(val) {
    return val instanceof $99e22f5c2aa5094b$var$SourceImpl;
}
function $99e22f5c2aa5094b$export$1921362e86c73c88(sourceData, thisMetaRawOption, // can be null. If not provided, auto detect it from `sourceData`.
sourceFormat) {
    sourceFormat = sourceFormat || $99e22f5c2aa5094b$export$52a469afa4653e57(sourceData);
    var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
    var determined = $99e22f5c2aa5094b$var$determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
    var source = new $99e22f5c2aa5094b$var$SourceImpl({
        data: sourceData,
        sourceFormat: sourceFormat,
        seriesLayoutBy: seriesLayoutBy,
        dimensionsDefine: determined.dimensionsDefine,
        startIndex: determined.startIndex,
        dimensionsDetectedCount: determined.dimensionsDetectedCount,
        metaRawOption: (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(thisMetaRawOption)
    });
    return source;
}
function $99e22f5c2aa5094b$export$75aef3f97c0a5edf(data) {
    return new $99e22f5c2aa5094b$var$SourceImpl({
        data: data,
        sourceFormat: (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data) ? (0, $cab29724515ce2b8$export$a918cb016a382d45) : (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)
    });
}
function $99e22f5c2aa5094b$export$e0365e7e3555ddd4(source) {
    return new $99e22f5c2aa5094b$var$SourceImpl({
        data: source.data,
        sourceFormat: source.sourceFormat,
        seriesLayoutBy: source.seriesLayoutBy,
        dimensionsDefine: (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(source.dimensionsDefine),
        startIndex: source.startIndex,
        dimensionsDetectedCount: source.dimensionsDetectedCount
    });
}
function $99e22f5c2aa5094b$export$52a469afa4653e57(data) {
    var sourceFormat = (0, $cab29724515ce2b8$export$c78f1330778d30d);
    if ((0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data)) sourceFormat = (0, $cab29724515ce2b8$export$a918cb016a382d45);
    else if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(data)) {
        // FIXME Whether tolerate null in top level array?
        if (data.length === 0) sourceFormat = (0, $cab29724515ce2b8$export$fcd62ebf51387903);
        for(var i = 0, len = data.length; i < len; i++){
            var item = data[i];
            if (item == null) continue;
            else if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(item) || (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(item)) {
                sourceFormat = (0, $cab29724515ce2b8$export$fcd62ebf51387903);
                break;
            } else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(item)) {
                sourceFormat = (0, $cab29724515ce2b8$export$703ae8a2d83f441);
                break;
            }
        }
    } else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(data)) {
        for(var key in data)if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(data, key) && (0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(data[key])) {
            sourceFormat = (0, $cab29724515ce2b8$export$6a32b42c754a3cb8);
            break;
        }
    }
    return sourceFormat;
}
/**
 * Determine the source definitions from data standalone dimensions definitions
 * are not specified.
 */ function $99e22f5c2aa5094b$var$determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, // standalone raw dimensions definition, like:
// {
//     dimensions: ['aa', 'bb', { name: 'cc', type: 'time' }]
// }
// in `dataset` or `series`
dimensionsDefine) {
    var dimensionsDetectedCount;
    var startIndex;
    // PENDING: Could data be null/undefined here?
    // currently, if `dataset.source` not specified, error thrown.
    // if `series.data` not specified, nothing rendered without error thrown.
    // Should test these cases.
    if (!data) return {
        dimensionsDefine: $99e22f5c2aa5094b$var$normalizeDimensionsOption(dimensionsDefine),
        startIndex: startIndex,
        dimensionsDetectedCount: dimensionsDetectedCount
    };
    if (sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903)) {
        var dataArrayRows = data;
        // Rule: Most of the first line are string: it is header.
        // Caution: consider a line with 5 string and 1 number,
        // it still can not be sure it is a head, because the
        // 5 string may be 5 values of category columns.
        if (sourceHeader === "auto" || sourceHeader == null) $99e22f5c2aa5094b$var$arrayRowsTravelFirst(function(val) {
            // '-' is regarded as null/undefined.
            if (val != null && val !== "-") {
                if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val)) startIndex == null && (startIndex = 1);
                else startIndex = 0;
            }
        // 10 is an experience number, avoid long loop.
        }, seriesLayoutBy, dataArrayRows, 10);
        else startIndex = (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
        if (!dimensionsDefine && startIndex === 1) {
            dimensionsDefine = [];
            $99e22f5c2aa5094b$var$arrayRowsTravelFirst(function(val, index) {
                dimensionsDefine[index] = val != null ? val + "" : "";
            }, seriesLayoutBy, dataArrayRows, Infinity);
        }
        dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === (0, $cab29724515ce2b8$export$d55da1467cdf7804) ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441)) {
        if (!dimensionsDefine) dimensionsDefine = $99e22f5c2aa5094b$var$objectRowsCollectDimensions(data);
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8)) {
        if (!dimensionsDefine) {
            dimensionsDefine = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(data, function(colArr, key) {
                dimensionsDefine.push(key);
            });
        }
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)) {
        var value0 = (0, $76d619f648247e6d$export$2c944e12edb48d4b)(data[0]);
        dimensionsDetectedCount = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(value0) && value0.length || 1;
    }
    return {
        startIndex: startIndex,
        dimensionsDefine: $99e22f5c2aa5094b$var$normalizeDimensionsOption(dimensionsDefine),
        dimensionsDetectedCount: dimensionsDetectedCount
    };
}
function $99e22f5c2aa5094b$var$objectRowsCollectDimensions(data) {
    var firstIndex = 0;
    var obj;
    while(firstIndex < data.length && !(obj = data[firstIndex++])); // jshint ignore: line
    if (obj) return (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(obj);
}
// Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefined or string.
function $99e22f5c2aa5094b$var$normalizeDimensionsOption(dimensionsDefine) {
    if (!dimensionsDefine) // The meaning of null/undefined is different from empty array.
    return;
    var nameMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dimensionsDefine, function(rawItem, index) {
        rawItem = (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(rawItem) ? rawItem : {
            name: rawItem
        };
        // Other fields will be discarded.
        var item = {
            name: rawItem.name,
            displayName: rawItem.displayName,
            type: rawItem.type
        };
        // User can set null in dimensions.
        // We don't auto specify name, otherwise a given name may
        // cause it to be referred unexpectedly.
        if (item.name == null) return item;
        // Also consider number form like 2012.
        item.name += "";
        // User may also specify displayName.
        // displayName will always exists except user not
        // specified or dim name is not specified or detected.
        // (A auto generated dim name will not be used as
        // displayName).
        if (item.displayName == null) item.displayName = item.name;
        var exist = nameMap.get(item.name);
        if (!exist) nameMap.set(item.name, {
            count: 1
        });
        else item.name += "-" + exist.count++;
        return item;
    });
}
function $99e22f5c2aa5094b$var$arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
    if (seriesLayoutBy === (0, $cab29724515ce2b8$export$d55da1467cdf7804)) for(var i = 0; i < data.length && i < maxLoop; i++)cb(data[i] ? data[i][0] : null, i);
    else {
        var value0 = data[0] || [];
        for(var i = 0; i < value0.length && i < maxLoop; i++)cb(value0[i], i);
    }
}
function $99e22f5c2aa5094b$export$8911336b527f8517(source) {
    var sourceFormat = source.sourceFormat;
    return sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441) || sourceFormat === (0, $cab29724515ce2b8$export$6a32b42c754a3cb8);
}



var $8ffb0d67e9446edb$var$_a, $8ffb0d67e9446edb$var$_b, $8ffb0d67e9446edb$var$_c;
var $8ffb0d67e9446edb$var$providerMethods;
var $8ffb0d67e9446edb$var$mountMethods;
/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */ var $8ffb0d67e9446edb$export$b900d7c4c3952a40 = /** @class */ function() {
    function DefaultDataProvider(sourceParam, dimSize) {
        // let source: Source;
        var source = !(0, $99e22f5c2aa5094b$export$22b808bc02a60488)(sourceParam) ? (0, $99e22f5c2aa5094b$export$75aef3f97c0a5edf)(sourceParam) : sourceParam;
        // declare source is Source;
        this._source = source;
        var data = this._data = source.data;
        // Typed array. TODO IE10+?
        if (source.sourceFormat === (0, $cab29724515ce2b8$export$a918cb016a382d45)) {
            this._offset = 0;
            this._dimSize = dimSize;
            this._data = data;
        }
        $8ffb0d67e9446edb$var$mountMethods(this, data, source);
    }
    DefaultDataProvider.prototype.getSource = function() {
        return this._source;
    };
    DefaultDataProvider.prototype.count = function() {
        return 0;
    };
    DefaultDataProvider.prototype.getItem = function(idx, out) {
        return;
    };
    DefaultDataProvider.prototype.appendData = function(newData) {};
    DefaultDataProvider.prototype.clean = function() {};
    DefaultDataProvider.protoInitialize = function() {
        // PENDING: To avoid potential incompat (e.g., prototype
        // is visited somewhere), still init them on prototype.
        var proto = DefaultDataProvider.prototype;
        proto.pure = false;
        proto.persistent = true;
    }();
    DefaultDataProvider.internalField = function() {
        var _a;
        $8ffb0d67e9446edb$var$mountMethods = function(provider, data, source) {
            var sourceFormat = source.sourceFormat;
            var seriesLayoutBy = source.seriesLayoutBy;
            var startIndex = source.startIndex;
            var dimsDef = source.dimensionsDefine;
            var methods = $8ffb0d67e9446edb$var$providerMethods[$8ffb0d67e9446edb$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(provider, methods);
            if (sourceFormat === (0, $cab29724515ce2b8$export$a918cb016a382d45)) {
                provider.getItem = getItemForTypedArray;
                provider.count = countForTypedArray;
                provider.fillStorage = fillStorageForTypedArray;
            } else {
                var rawItemGetter = $8ffb0d67e9446edb$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy);
                provider.getItem = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(rawItemGetter, null, data, startIndex, dimsDef);
                var rawCounter = $8ffb0d67e9446edb$export$803742e832f4b52c(sourceFormat, seriesLayoutBy);
                provider.count = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(rawCounter, null, data, startIndex, dimsDef);
            }
        };
        var getItemForTypedArray = function(idx, out) {
            idx = idx - this._offset;
            out = out || [];
            var data = this._data;
            var dimSize = this._dimSize;
            var offset = dimSize * idx;
            for(var i = 0; i < dimSize; i++)out[i] = data[offset + i];
            return out;
        };
        var fillStorageForTypedArray = function(start, end, storage, extent) {
            var data = this._data;
            var dimSize = this._dimSize;
            for(var dim = 0; dim < dimSize; dim++){
                var dimExtent = extent[dim];
                var min = dimExtent[0] == null ? Infinity : dimExtent[0];
                var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
                var count = end - start;
                var arr = storage[dim];
                for(var i = 0; i < count; i++){
                    // appendData with TypedArray will always do replace in provider.
                    var val = data[i * dimSize + dim];
                    arr[start + i] = val;
                    val < min && (min = val);
                    val > max && (max = val);
                }
                dimExtent[0] = min;
                dimExtent[1] = max;
            }
        };
        var countForTypedArray = function() {
            return this._data ? this._data.length / this._dimSize : 0;
        };
        $8ffb0d67e9446edb$var$providerMethods = (_a = {}, _a[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$d55da1467cdf7804)] = {
            pure: true,
            appendData: function() {
                throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
            }
        }, _a[0, $cab29724515ce2b8$export$703ae8a2d83f441] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[0, $cab29724515ce2b8$export$6a32b42c754a3cb8] = {
            pure: true,
            appendData: function(newData) {
                var data = this._data;
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newData, function(newCol, key) {
                    var oldCol = data[key] || (data[key] = []);
                    for(var i = 0; i < (newCol || []).length; i++)oldCol.push(newCol[i]);
                });
            }
        }, _a[0, $cab29724515ce2b8$export$2823037fb9d8f0c6] = {
            appendData: appendDataSimply
        }, _a[0, $cab29724515ce2b8$export$a918cb016a382d45] = {
            persistent: false,
            pure: true,
            appendData: function(newData) {
                this._data = newData;
            },
            // Clean self if data is already used.
            clean: function() {
                // PENDING
                this._offset += this.count();
                this._data = null;
            }
        }, _a);
        function appendDataSimply(newData) {
            for(var i = 0; i < newData.length; i++)this._data.push(newData[i]);
        }
    }();
    return DefaultDataProvider;
}();
var $8ffb0d67e9446edb$var$getItemSimply = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx];
};
var $8ffb0d67e9446edb$var$rawSourceItemGetterMap = ($8ffb0d67e9446edb$var$_a = {}, $8ffb0d67e9446edb$var$_a[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)] = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx + startIndex];
}, $8ffb0d67e9446edb$var$_a[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$d55da1467cdf7804)] = function(rawData, startIndex, dimsDef, idx, out) {
    idx += startIndex;
    var item = out || [];
    var data = rawData;
    for(var i = 0; i < data.length; i++){
        var row = data[i];
        item[i] = row ? row[idx] : null;
    }
    return item;
}, $8ffb0d67e9446edb$var$_a[0, $cab29724515ce2b8$export$703ae8a2d83f441] = $8ffb0d67e9446edb$var$getItemSimply, $8ffb0d67e9446edb$var$_a[0, $cab29724515ce2b8$export$6a32b42c754a3cb8] = function(rawData, startIndex, dimsDef, idx, out) {
    var item = out || [];
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        var col = rawData[dimName];
        item[i] = col ? col[idx] : null;
    }
    return item;
}, $8ffb0d67e9446edb$var$_a[0, $cab29724515ce2b8$export$2823037fb9d8f0c6] = $8ffb0d67e9446edb$var$getItemSimply, $8ffb0d67e9446edb$var$_a);
function $8ffb0d67e9446edb$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy) {
    var method = $8ffb0d67e9446edb$var$rawSourceItemGetterMap[$8ffb0d67e9446edb$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $8ffb0d67e9446edb$var$countSimply = function(rawData, startIndex, dimsDef) {
    return rawData.length;
};
var $8ffb0d67e9446edb$var$rawSourceDataCounterMap = ($8ffb0d67e9446edb$var$_b = {}, $8ffb0d67e9446edb$var$_b[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)] = function(rawData, startIndex, dimsDef) {
    return Math.max(0, rawData.length - startIndex);
}, $8ffb0d67e9446edb$var$_b[(0, $cab29724515ce2b8$export$fcd62ebf51387903) + "_" + (0, $cab29724515ce2b8$export$d55da1467cdf7804)] = function(rawData, startIndex, dimsDef) {
    var row = rawData[0];
    return row ? Math.max(0, row.length - startIndex) : 0;
}, $8ffb0d67e9446edb$var$_b[0, $cab29724515ce2b8$export$703ae8a2d83f441] = $8ffb0d67e9446edb$var$countSimply, $8ffb0d67e9446edb$var$_b[0, $cab29724515ce2b8$export$6a32b42c754a3cb8] = function(rawData, startIndex, dimsDef) {
    var dimName = dimsDef[0].name;
    var col = rawData[dimName];
    return col ? col.length : 0;
}, $8ffb0d67e9446edb$var$_b[0, $cab29724515ce2b8$export$2823037fb9d8f0c6] = $8ffb0d67e9446edb$var$countSimply, $8ffb0d67e9446edb$var$_b);
function $8ffb0d67e9446edb$export$803742e832f4b52c(sourceFormat, seriesLayoutBy) {
    var method = $8ffb0d67e9446edb$var$rawSourceDataCounterMap[$8ffb0d67e9446edb$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $8ffb0d67e9446edb$var$getRawValueSimply = function(dataItem, dimIndex, property) {
    return dataItem[dimIndex];
};
var $8ffb0d67e9446edb$var$rawSourceValueGetterMap = ($8ffb0d67e9446edb$var$_c = {}, $8ffb0d67e9446edb$var$_c[0, $cab29724515ce2b8$export$fcd62ebf51387903] = $8ffb0d67e9446edb$var$getRawValueSimply, $8ffb0d67e9446edb$var$_c[0, $cab29724515ce2b8$export$703ae8a2d83f441] = function(dataItem, dimIndex, property) {
    return dataItem[property];
}, $8ffb0d67e9446edb$var$_c[0, $cab29724515ce2b8$export$6a32b42c754a3cb8] = $8ffb0d67e9446edb$var$getRawValueSimply, $8ffb0d67e9446edb$var$_c[0, $cab29724515ce2b8$export$2823037fb9d8f0c6] = function(dataItem, dimIndex, property) {
    // FIXME: In some case (markpoint in geo (geo-map.html)),
    // dataItem is {coord: [...]}
    var value = (0, $76d619f648247e6d$export$2c944e12edb48d4b)(dataItem);
    return !(value instanceof Array) ? value : value[dimIndex];
}, $8ffb0d67e9446edb$var$_c[0, $cab29724515ce2b8$export$a918cb016a382d45] = $8ffb0d67e9446edb$var$getRawValueSimply, $8ffb0d67e9446edb$var$_c);
function $8ffb0d67e9446edb$export$1752de8084789a14(sourceFormat) {
    var method = $8ffb0d67e9446edb$var$rawSourceValueGetterMap[sourceFormat];
    return method;
}
function $8ffb0d67e9446edb$var$getMethodMapKey(sourceFormat, seriesLayoutBy) {
    return sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903) ? sourceFormat + "_" + seriesLayoutBy : sourceFormat;
}
function $8ffb0d67e9446edb$export$cde9373da9aad801(data, dataIndex, // If dimIndex is null/undefined, return OptionDataItem.
// Otherwise, return OptionDataValue.
dim) {
    if (!data) return;
    // Consider data may be not persistent.
    var dataItem = data.getRawDataItem(dataIndex);
    if (dataItem == null) return;
    var store = data.getStore();
    var sourceFormat = store.getSource().sourceFormat;
    if (dim != null) {
        var dimIndex = data.getDimensionIndex(dim);
        var property = store.getDimensionProperty(dimIndex);
        return $8ffb0d67e9446edb$export$1752de8084789a14(sourceFormat)(dataItem, dimIndex, property);
    } else {
        var result = dataItem;
        if (sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)) result = (0, $76d619f648247e6d$export$2c944e12edb48d4b)(dataItem);
        return result;
    }
}
function $8ffb0d67e9446edb$export$c8ae9e77e0ddc42a(data, dataIndex, attr) {
    if (!data) return;
    var sourceFormat = data.getStore().getSource().sourceFormat;
    if (sourceFormat !== (0, $cab29724515ce2b8$export$2823037fb9d8f0c6) && sourceFormat !== (0, $cab29724515ce2b8$export$703ae8a2d83f441)) return;
    var dataItem = data.getRawDataItem(dataIndex);
    if (sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6) && !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dataItem)) dataItem = null;
    if (dataItem) return dataItem[attr];
}




var $655dd6075cc63601$var$DIMENSION_LABEL_REG = /\{@(.+?)\}/g;
var $655dd6075cc63601$export$f23396ae04ea95a7 = /** @class */ function() {
    function DataFormatMixin() {}
    /**
   * Get params for formatter
   */ DataFormatMixin.prototype.getDataParams = function(dataIndex, dataType) {
        var data = this.getData(dataType);
        var rawValue = this.getRawValue(dataIndex, dataType);
        var rawDataIndex = data.getRawIndex(dataIndex);
        var name = data.getName(dataIndex);
        var itemOpt = data.getRawDataItem(dataIndex);
        var style = data.getItemVisual(dataIndex, "style");
        var color = style && style[data.getItemVisual(dataIndex, "drawType") || "fill"];
        var borderColor = style && style.stroke;
        var mainType = this.mainType;
        var isSeries = mainType === "series";
        var userOutput = data.userOutput && data.userOutput.get();
        return {
            componentType: mainType,
            componentSubType: this.subType,
            componentIndex: this.componentIndex,
            seriesType: isSeries ? this.subType : null,
            seriesIndex: this.seriesIndex,
            seriesId: isSeries ? this.id : null,
            seriesName: isSeries ? this.name : null,
            name: name,
            dataIndex: rawDataIndex,
            data: itemOpt,
            dataType: dataType,
            value: rawValue,
            color: color,
            borderColor: borderColor,
            dimensionNames: userOutput ? userOutput.fullDimensions : null,
            encode: userOutput ? userOutput.encode : null,
            // Param name list for mapping `a`, `b`, `c`, `d`, `e`
            $vars: [
                "seriesName",
                "name",
                "value"
            ]
        };
    };
    /**
   * Format label
   * @param dataIndex
   * @param status 'normal' by default
   * @param dataType
   * @param labelDimIndex Only used in some chart that
   *        use formatter in different dimensions, like radar.
   * @param formatter Formatter given outside.
   * @return return null/undefined if no formatter
   */ DataFormatMixin.prototype.getFormattedLabel = function(dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
        status = status || "normal";
        var data = this.getData(dataType);
        var params = this.getDataParams(dataIndex, dataType);
        if (extendParams) params.value = extendParams.interpolatedValue;
        if (labelDimIndex != null && $7a1bd9c2710fea0d$export$43bee75e5e14138e(params.value)) params.value = params.value[labelDimIndex];
        if (!formatter) {
            var itemModel = data.getItemModel(dataIndex);
            // @ts-ignore
            formatter = itemModel.get(status === "normal" ? [
                "label",
                "formatter"
            ] : [
                status,
                "label",
                "formatter"
            ]);
        }
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) {
            params.status = status;
            params.dimensionIndex = labelDimIndex;
            return formatter(params);
        } else if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) {
            var str = (0, $c84c9521536c601a$export$2028496a35766e41)(formatter, params);
            // Support 'aaa{@[3]}bbb{@product}ccc'.
            // Do not support '}' in dim name util have to.
            return str.replace($655dd6075cc63601$var$DIMENSION_LABEL_REG, function(origin, dimStr) {
                var len = dimStr.length;
                var dimLoose = dimStr;
                if (dimLoose.charAt(0) === "[" && dimLoose.charAt(len - 1) === "]") dimLoose = +dimLoose.slice(1, len - 1); // Also support: '[]' => 0
                var val = (0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, dimLoose);
                if (extendParams && $7a1bd9c2710fea0d$export$43bee75e5e14138e(extendParams.interpolatedValue)) {
                    var dimIndex = data.getDimensionIndex(dimLoose);
                    if (dimIndex >= 0) val = extendParams.interpolatedValue[dimIndex];
                }
                return val != null ? val + "" : "";
            });
        }
    };
    /**
   * Get raw value in option
   */ DataFormatMixin.prototype.getRawValue = function(idx, dataType) {
        return (0, $8ffb0d67e9446edb$export$cde9373da9aad801)(this.getData(dataType), idx);
    };
    /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {string} [dataType]
   */ DataFormatMixin.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // Empty function
        return;
    };
    return DataFormatMixin;
}();
function $655dd6075cc63601$export$2d16fa82a50c4741(result) {
    var markupText;
    // let markers: Dictionary<ColorString>;
    var markupFragment;
    if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(result)) {
        if (result.type) markupFragment = result;
    } else markupText = result;
    return {
        text: markupText,
        // markers: markers || markersExisting,
        frag: markupFragment
    };
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $4d16404c851dcec6$export$f7292ab7796be73c(define) {
    return new $4d16404c851dcec6$export$2dea7024bcdd7731(define);
}
var $4d16404c851dcec6$export$2dea7024bcdd7731 = /** @class */ function() {
    function Task(define) {
        define = define || {};
        this._reset = define.reset;
        this._plan = define.plan;
        this._count = define.count;
        this._onDirty = define.onDirty;
        this._dirty = true;
    }
    /**
   * @param step Specified step.
   * @param skip Skip customer perform call.
   * @param modBy Sampling window size.
   * @param modDataCount Sampling count.
   * @return whether unfinished.
   */ Task.prototype.perform = function(performArgs) {
        var upTask = this._upstream;
        var skip = performArgs && performArgs.skip;
        // TODO some refactor.
        // Pull data. Must pull data each time, because context.data
        // may be updated by Series.setData.
        if (this._dirty && upTask) {
            var context = this.context;
            context.data = context.outputData = upTask.context.outputData;
        }
        if (this.__pipeline) this.__pipeline.currentTask = this;
        var planResult;
        if (this._plan && !skip) planResult = this._plan(this.context);
        // Support sharding by mod, which changes the render sequence and makes the rendered graphic
        // elements uniformed distributed when progress, especially when moving or zooming.
        var lastModBy = normalizeModBy(this._modBy);
        var lastModDataCount = this._modDataCount || 0;
        var modBy = normalizeModBy(performArgs && performArgs.modBy);
        var modDataCount = performArgs && performArgs.modDataCount || 0;
        if (lastModBy !== modBy || lastModDataCount !== modDataCount) planResult = "reset";
        function normalizeModBy(val) {
            !(val >= 1) && (val = 1); // jshint ignore:line
            return val;
        }
        var forceFirstProgress;
        if (this._dirty || planResult === "reset") {
            this._dirty = false;
            forceFirstProgress = this._doReset(skip);
        }
        this._modBy = modBy;
        this._modDataCount = modDataCount;
        var step = performArgs && performArgs.step;
        if (upTask) this._dueEnd = upTask._outputDueEnd;
        else this._dueEnd = this._count ? this._count(this.context) : Infinity;
        // Note: Stubs, that its host overall task let it has progress, has progress.
        // If no progress, pass index from upstream to downstream each time plan called.
        if (this._progress) {
            var start = this._dueIndex;
            var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
            if (!skip && (forceFirstProgress || start < end)) {
                var progress = this._progress;
                if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(progress)) for(var i = 0; i < progress.length; i++)this._doProgress(progress[i], start, end, modBy, modDataCount);
                else this._doProgress(progress, start, end, modBy, modDataCount);
            }
            this._dueIndex = end;
            // If no `outputDueEnd`, assume that output data and
            // input data is the same, so use `dueIndex` as `outputDueEnd`.
            var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
            this._outputDueEnd = outputDueEnd;
        } else // (1) Some overall task has no progress.
        // (2) Stubs, that its host overall task do not let it has progress, has no progress.
        // This should always be performed so it can be passed to downstream.
        this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
        return this.unfinished();
    };
    Task.prototype.dirty = function() {
        this._dirty = true;
        this._onDirty && this._onDirty(this.context);
    };
    Task.prototype._doProgress = function(progress, start, end, modBy, modDataCount) {
        $4d16404c851dcec6$var$iterator.reset(start, end, modBy, modDataCount);
        this._callingProgress = progress;
        this._callingProgress({
            start: start,
            end: end,
            count: end - start,
            next: $4d16404c851dcec6$var$iterator.next
        }, this.context);
    };
    Task.prototype._doReset = function(skip) {
        this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
        this._settedOutputEnd = null;
        var progress;
        var forceFirstProgress;
        if (!skip && this._reset) {
            progress = this._reset(this.context);
            if (progress && progress.progress) {
                forceFirstProgress = progress.forceFirstProgress;
                progress = progress.progress;
            }
            // To simplify no progress checking, array must has item.
            if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(progress) && !progress.length) progress = null;
        }
        this._progress = progress;
        this._modBy = this._modDataCount = null;
        var downstream = this._downstream;
        downstream && downstream.dirty();
        return forceFirstProgress;
    };
    Task.prototype.unfinished = function() {
        return this._progress && this._dueIndex < this._dueEnd;
    };
    /**
   * @param downTask The downstream task.
   * @return The downstream task.
   */ Task.prototype.pipe = function(downTask) {
        // If already downstream, do not dirty downTask.
        if (this._downstream !== downTask || this._dirty) {
            this._downstream = downTask;
            downTask._upstream = this;
            downTask.dirty();
        }
    };
    Task.prototype.dispose = function() {
        if (this._disposed) return;
        this._upstream && (this._upstream._downstream = null);
        this._downstream && (this._downstream._upstream = null);
        this._dirty = false;
        this._disposed = true;
    };
    Task.prototype.getUpstream = function() {
        return this._upstream;
    };
    Task.prototype.getDownstream = function() {
        return this._downstream;
    };
    Task.prototype.setOutputEnd = function(end) {
        // This only happens in dataTask, dataZoom, map, currently.
        // where dataZoom do not set end each time, but only set
        // when reset. So we should record the set end, in case
        // that the stub of dataZoom perform again and earse the
        // set end by upstream.
        this._outputDueEnd = this._settedOutputEnd = end;
    };
    return Task;
}();
var $4d16404c851dcec6$var$iterator = function() {
    var end;
    var current;
    var modBy;
    var modDataCount;
    var winCount;
    var it = {
        reset: function(s, e, sStep, sCount) {
            current = s;
            end = e;
            modBy = sStep;
            modDataCount = sCount;
            winCount = Math.ceil(modDataCount / modBy);
            it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
        }
    };
    return it;
    function sequentialNext() {
        return current < end ? current++ : null;
    }
    function modNext() {
        var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
        var result = current >= end ? null : dataIndex < modDataCount ? dataIndex : current;
        current++;
        return result;
    }
}(); // -----------------------------------------------------------------------------
 // For stream debug (Should be commented out after used!)
 // @usage: printTask(this, 'begin');
 // @usage: printTask(this, null, {someExtraProp});
 // @usage: Use `__idxInPipeline` as conditional breakpiont.
 //
 // window.printTask = function (task: any, prefix: string, extra: { [key: string]: unknown }): void {
 //     window.ecTaskUID == null && (window.ecTaskUID = 0);
 //     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
 //     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
 //     let props = [];
 //     if (task.__pipeline) {
 //         let val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
 //         props.push({text: '__idxInPipeline/total', value: val});
 //     } else {
 //         let stubCount = 0;
 //         task.agentStubMap.each(() => stubCount++);
 //         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
 //     }
 //     props.push({text: 'uid', value: task.uidDebug});
 //     if (task.__pipeline) {
 //         props.push({text: 'pipelineId', value: task.__pipeline.id});
 //         task.agent && props.push(
 //             {text: 'stubFor', value: task.agent.uidDebug}
 //         );
 //     }
 //     props.push(
 //         {text: 'dirty', value: task._dirty},
 //         {text: 'dueIndex', value: task._dueIndex},
 //         {text: 'dueEnd', value: task._dueEnd},
 //         {text: 'outputDueEnd', value: task._outputDueEnd}
 //     );
 //     if (extra) {
 //         Object.keys(extra).forEach(key => {
 //             props.push({text: key, value: extra[key]});
 //         });
 //     }
 //     let args = ['color: blue'];
 //     let msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
 //         args.push('color: green', 'color: red'),
 //         `${item.text}: %c${item.value}`
 //     )).join('%c, ');
 //     console.log.apply(console, [msg].concat(args));
 //     // console.log(this);
 // };
 // window.printPipeline = function (task: any, prefix: string) {
 //     const pipeline = task.__pipeline;
 //     let currTask = pipeline.head;
 //     while (currTask) {
 //         window.printTask(currTask, prefix);
 //         currTask = currTask._downstream;
 //     }
 // };
 // window.showChain = function (chainHeadTask) {
 //     var chain = [];
 //     var task = chainHeadTask;
 //     while (task) {
 //         chain.push({
 //             task: task,
 //             up: task._upstream,
 //             down: task._downstream,
 //             idxInPipeline: task.__idxInPipeline
 //         });
 //         task = task._downstream;
 //     }
 //     return chain;
 // };
 // window.findTaskInChain = function (task, chainHeadTask) {
 //     let chain = window.showChain(chainHeadTask);
 //     let result = [];
 //     for (let i = 0; i < chain.length; i++) {
 //         let chainItem = chain[i];
 //         if (chainItem.task === task) {
 //             result.push(i);
 //         }
 //     }
 //     return result;
 // };
 // window.printChainAEachInChainB = function (chainHeadTaskA, chainHeadTaskB) {
 //     let chainA = window.showChain(chainHeadTaskA);
 //     for (let i = 0; i < chainA.length; i++) {
 //         console.log('chainAIdx:', i, 'inChainB:', window.findTaskInChain(chainA[i].task, chainHeadTaskB));
 //     }
 // };



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $40ab59f44b7d2db6$export$cc7175145baad076(value, // For high performance, do not omit the second param.
opt) {
    // Performance sensitive.
    var dimType = opt && opt.type;
    if (dimType === "ordinal") // If given value is a category string
    return value;
    if (dimType === "time" && !(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(value) && value != null && value !== "-") value = +(0, $cfc1f3b422a3185f$export$6b862160d295c8e)(value);
    // dimType defaults 'number'.
    // If dimType is not ordinal and value is null or undefined or NaN or '-',
    // parse to NaN.
    // number-like string (like ' 123 ') can be converted to a number.
    // where null/undefined or other string will be converted to NaN.
    return value == null || value === "" ? NaN : +value;
}
var $40ab59f44b7d2db6$var$valueParserMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)({
    "number": function(val) {
        // Do not use `numericToNumber` here. We have `numericToNumber` by default.
        // Here the number parser can have loose rule:
        // enable to cut suffix: "120px" => 120, "14%" => 14.
        return parseFloat(val);
    },
    "time": function(val) {
        // return timestamp.
        return +(0, $cfc1f3b422a3185f$export$6b862160d295c8e)(val);
    },
    "trim": function(val) {
        return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val) ? (0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(val) : val;
    }
});
function $40ab59f44b7d2db6$export$c88237b7c265b36b(type) {
    return $40ab59f44b7d2db6$var$valueParserMap.get(type);
}
var $40ab59f44b7d2db6$var$ORDER_COMPARISON_OP_MAP = {
    lt: function(lval, rval) {
        return lval < rval;
    },
    lte: function(lval, rval) {
        return lval <= rval;
    },
    gt: function(lval, rval) {
        return lval > rval;
    },
    gte: function(lval, rval) {
        return lval >= rval;
    }
};
var $40ab59f44b7d2db6$var$FilterOrderComparator = /** @class */ function() {
    function FilterOrderComparator(op, rval) {
        if (!(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rval)) {
            var errMsg = "";
            (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        }
        this._opFn = $40ab59f44b7d2db6$var$ORDER_COMPARISON_OP_MAP[op];
        this._rvalFloat = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(rval);
    }
    // Performance sensitive.
    FilterOrderComparator.prototype.evaluate = function(lval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        return (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(lval) ? this._opFn(lval, this._rvalFloat) : this._opFn((0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(lval), this._rvalFloat);
    };
    return FilterOrderComparator;
}();
var $40ab59f44b7d2db6$export$ed75a5d7b0144167 = /** @class */ function() {
    /**
   * @param order by default: 'asc'
   * @param incomparable by default: Always on the tail.
   *        That is, if 'asc' => 'max', if 'desc' => 'min'
   *        See the definition of "incomparable" in [SORT_COMPARISON_RULE].
   */ function SortOrderComparator(order, incomparable) {
        var isDesc = order === "desc";
        this._resultLT = isDesc ? 1 : -1;
        if (incomparable == null) incomparable = isDesc ? "min" : "max";
        this._incomparable = incomparable === "min" ? -Infinity : Infinity;
    }
    // See [SORT_COMPARISON_RULE].
    // Performance sensitive.
    SortOrderComparator.prototype.evaluate = function(lval, rval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        var lvalFloat = (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(lval) ? lval : (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(lval);
        var rvalFloat = (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rval) ? rval : (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(rval);
        var lvalNotNumeric = isNaN(lvalFloat);
        var rvalNotNumeric = isNaN(rvalFloat);
        if (lvalNotNumeric) lvalFloat = this._incomparable;
        if (rvalNotNumeric) rvalFloat = this._incomparable;
        if (lvalNotNumeric && rvalNotNumeric) {
            var lvalIsStr = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(lval);
            var rvalIsStr = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(rval);
            if (lvalIsStr) lvalFloat = rvalIsStr ? lval : 0;
            if (rvalIsStr) rvalFloat = lvalIsStr ? rval : 0;
        }
        return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
    };
    return SortOrderComparator;
}();
var $40ab59f44b7d2db6$var$FilterEqualityComparator = /** @class */ function() {
    function FilterEqualityComparator(isEq, rval) {
        this._rval = rval;
        this._isEQ = isEq;
        this._rvalTypeof = typeof rval;
        this._rvalFloat = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(rval);
    }
    // Performance sensitive.
    FilterEqualityComparator.prototype.evaluate = function(lval) {
        var eqResult = lval === this._rval;
        if (!eqResult) {
            var lvalTypeof = typeof lval;
            if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === "number" || this._rvalTypeof === "number")) eqResult = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(lval) === this._rvalFloat;
        }
        return this._isEQ ? eqResult : !eqResult;
    };
    return FilterEqualityComparator;
}();
function $40ab59f44b7d2db6$export$f2644c3485f94c4e(op, rval) {
    return op === "eq" || op === "ne" ? new $40ab59f44b7d2db6$var$FilterEqualityComparator(op === "eq", rval) : (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($40ab59f44b7d2db6$var$ORDER_COMPARISON_OP_MAP, op) ? new $40ab59f44b7d2db6$var$FilterOrderComparator(op, rval) : null;
}




/**
 * TODO: disable writable.
 * This structure will be exposed to users.
 */ var $523dedd0a2328c06$export$ffc19e40a21f08eb = /** @class */ function() {
    function ExternalSource() {}
    ExternalSource.prototype.getRawData = function() {
        // Only built-in transform available.
        throw new Error("not supported");
    };
    ExternalSource.prototype.getRawDataItem = function(dataIndex) {
        // Only built-in transform available.
        throw new Error("not supported");
    };
    ExternalSource.prototype.cloneRawData = function() {
        return;
    };
    /**
   * @return If dimension not found, return null/undefined.
   */ ExternalSource.prototype.getDimensionInfo = function(dim) {
        return;
    };
    /**
   * dimensions defined if and only if either:
   * (a) dataset.dimensions are declared.
   * (b) dataset data include dimensions definitions in data (detected or via specified `sourceHeader`).
   * If dimensions are defined, `dimensionInfoAll` is corresponding to
   * the defined dimensions.
   * Otherwise, `dimensionInfoAll` is determined by data columns.
   * @return Always return an array (even empty array).
   */ ExternalSource.prototype.cloneAllDimensionInfo = function() {
        return;
    };
    ExternalSource.prototype.count = function() {
        return;
    };
    /**
   * Only support by dimension index.
   * No need to support by dimension name in transform function,
   * because transform function is not case-specific, no need to use name literally.
   */ ExternalSource.prototype.retrieveValue = function(dataIndex, dimIndex) {
        return;
    };
    ExternalSource.prototype.retrieveValueFromItem = function(dataItem, dimIndex) {
        return;
    };
    ExternalSource.prototype.convertValue = function(rawVal, dimInfo) {
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(rawVal, dimInfo);
    };
    return ExternalSource;
}();
function $523dedd0a2328c06$var$createExternalSource(internalSource, externalTransform) {
    var extSource = new $523dedd0a2328c06$export$ffc19e40a21f08eb();
    var data = internalSource.data;
    var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
    var sourceHeaderCount = internalSource.startIndex;
    var errMsg = "";
    if (internalSource.seriesLayoutBy !== (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    // [MEMO]
    // Create a new dimensions structure for exposing.
    // Do not expose all dimension info to users directly.
    // Because the dimension is probably auto detected from data and not might reliable.
    // Should not lead the transformers to think that is reliable and return it.
    // See [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
    var dimensions = [];
    var dimsByName = {};
    var dimsDef = internalSource.dimensionsDefine;
    if (dimsDef) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dimsDef, function(dimDef, idx) {
        var name = dimDef.name;
        var dimDefExt = {
            index: idx,
            name: name,
            displayName: dimDef.displayName
        };
        dimensions.push(dimDefExt);
        // Users probably do not specify dimension name. For simplicity, data transform
        // does not generate dimension name.
        if (name != null) {
            // Dimension name should not be duplicated.
            // For simplicity, data transform forbids name duplication, do not generate
            // new name like module `completeDimensions.ts` did, but just tell users.
            var errMsg_1 = "";
            if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(dimsByName, name)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg_1);
            dimsByName[name] = dimDefExt;
        }
    });
    else for(var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++)// Do not generete name or anything others. The consequence process in
    // `transform` or `series` probably have there own name generation strategry.
    dimensions.push({
        index: i
    });
    // Implement public methods:
    var rawItemGetter = (0, $8ffb0d67e9446edb$export$92c8ea8642b3957d)(sourceFormat, (0, $cab29724515ce2b8$export$7b3f3c6551b4949b));
    if (externalTransform.__isBuiltIn) {
        extSource.getRawDataItem = function(dataIndex) {
            return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        };
        extSource.getRawData = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($523dedd0a2328c06$var$getRawData, null, internalSource);
    }
    extSource.cloneRawData = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($523dedd0a2328c06$var$cloneRawData, null, internalSource);
    var rawCounter = (0, $8ffb0d67e9446edb$export$803742e832f4b52c)(sourceFormat, (0, $cab29724515ce2b8$export$7b3f3c6551b4949b));
    extSource.count = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(rawCounter, null, data, sourceHeaderCount, dimensions);
    var rawValueGetter = (0, $8ffb0d67e9446edb$export$1752de8084789a14)(sourceFormat);
    extSource.retrieveValue = function(dataIndex, dimIndex) {
        var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        return retrieveValueFromItem(rawItem, dimIndex);
    };
    var retrieveValueFromItem = extSource.retrieveValueFromItem = function(dataItem, dimIndex) {
        if (dataItem == null) return;
        var dimDef = dimensions[dimIndex];
        // When `dimIndex` is `null`, `rawValueGetter` return the whole item.
        if (dimDef) return rawValueGetter(dataItem, dimIndex, dimDef.name);
    };
    extSource.getDimensionInfo = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($523dedd0a2328c06$var$getDimensionInfo, null, dimensions, dimsByName);
    extSource.cloneAllDimensionInfo = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($523dedd0a2328c06$var$cloneAllDimensionInfo, null, dimensions);
    return extSource;
}
function $523dedd0a2328c06$var$getRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    if (!$523dedd0a2328c06$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = "";
        (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    }
    return upstream.data;
}
function $523dedd0a2328c06$var$cloneRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    var data = upstream.data;
    if (!$523dedd0a2328c06$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = "";
        (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    }
    if (sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push(data[i].slice());
        return result;
    } else if (sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, data[i]));
        return result;
    }
}
function $523dedd0a2328c06$var$getDimensionInfo(dimensions, dimsByName, dim) {
    if (dim == null) return;
    // Keep the same logic as `List::getDimension` did.
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dim) || !isNaN(dim) && !(0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(dimsByName, dim)) return dimensions[dim];
    else if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(dimsByName, dim)) return dimsByName[dim];
}
function $523dedd0a2328c06$var$cloneAllDimensionInfo(dimensions) {
    return (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(dimensions);
}
var $523dedd0a2328c06$var$externalTransformMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
function $523dedd0a2328c06$export$92c96c6d8b255b7d(externalTransform) {
    externalTransform = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(externalTransform);
    var type = externalTransform.type;
    var errMsg = "";
    if (!type) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var typeParsed = type.split(":");
    if (typeParsed.length !== 2) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    // Namespace 'echarts:xxx' is official namespace, where the transforms should
    // be called directly via 'xxx' rather than 'echarts:xxx'.
    var isBuiltIn = false;
    if (typeParsed[0] === "echarts") {
        type = typeParsed[1];
        isBuiltIn = true;
    }
    externalTransform.__isBuiltIn = isBuiltIn;
    $523dedd0a2328c06$var$externalTransformMap.set(type, externalTransform);
}
function $523dedd0a2328c06$export$42a68f09db16803f(rawTransOption, sourceList, infoForPrint) {
    var pipedTransOption = (0, $76d619f648247e6d$export$4f07b212a02c8051)(rawTransOption);
    var pipeLen = pipedTransOption.length;
    var errMsg = "";
    if (!pipeLen) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    for(var i = 0, len = pipeLen; i < len; i++){
        var transOption = pipedTransOption[i];
        sourceList = $523dedd0a2328c06$var$applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i);
        // piped transform only support single input, except the fist one.
        // piped transform only support single output, except the last one.
        if (i !== len - 1) sourceList.length = Math.max(sourceList.length, 1);
    }
    return sourceList;
}
function $523dedd0a2328c06$var$applySingleDataTransform(transOption, upSourceList, infoForPrint, // If `pipeIndex` is null/undefined, no piped transform.
pipeIndex) {
    var errMsg = "";
    if (!upSourceList.length) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(transOption)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var transType = transOption.type;
    var externalTransform = $523dedd0a2328c06$var$externalTransformMap.get(transType);
    if (!externalTransform) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    // Prepare source
    var extUpSourceList = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(upSourceList, function(upSource) {
        return $523dedd0a2328c06$var$createExternalSource(upSource, externalTransform);
    });
    var resultList = (0, $76d619f648247e6d$export$4f07b212a02c8051)(externalTransform.transform({
        upstream: extUpSourceList[0],
        upstreamList: extUpSourceList,
        config: (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(transOption.config)
    }));
    var printStrArr;
    return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(resultList, function(result, resultIndex) {
        var errMsg = "";
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(result)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        if (!result.data) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        var sourceFormat = (0, $99e22f5c2aa5094b$export$52a469afa4653e57)(result.data);
        if (!$523dedd0a2328c06$var$isSupportedSourceFormat(sourceFormat)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        var resultMetaRawOption;
        var firstUpSource = upSourceList[0];
        /**
     * Intuitively, the end users known the content of the original `dataset.source`,
     * calucating the transform result in mind.
     * Suppose the original `dataset.source` is:
     * ```js
     * [
     *     ['product', '2012', '2013', '2014', '2015'],
     *     ['AAA', 41.1, 30.4, 65.1, 53.3],
     *     ['BBB', 86.5, 92.1, 85.7, 83.1],
     *     ['CCC', 24.1, 67.2, 79.5, 86.4]
     * ]
     * ```
     * The dimension info have to be detected from the source data.
     * Some of the transformers (like filter, sort) will follow the dimension info
     * of upstream, while others use new dimensions (like aggregate).
     * Transformer can output a field `dimensions` to define the its own output dimensions.
     * We also allow transformers to ignore the output `dimensions` field, and
     * inherit the upstream dimensions definition. It can reduce the burden of handling
     * dimensions in transformers.
     *
     * See also [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
     */ if (firstUpSource && resultIndex === 0 && !result.dimensions) {
            var startIndex = firstUpSource.startIndex;
            // We copy the header of upstream to the result, because:
            // (1) The returned data always does not contain header line and can not be used
            // as dimension-detection. In this case we can not use "detected dimensions" of
            // upstream directly, because it might be detected based on different `seriesLayoutBy`.
            // (2) We should support that the series read the upstream source in `seriesLayoutBy: 'row'`.
            // So the original detected header should be add to the result, otherwise they can not be read.
            if (startIndex) result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
            resultMetaRawOption = {
                seriesLayoutBy: (0, $cab29724515ce2b8$export$7b3f3c6551b4949b),
                sourceHeader: startIndex,
                dimensions: firstUpSource.metaRawOption.dimensions
            };
        } else resultMetaRawOption = {
            seriesLayoutBy: (0, $cab29724515ce2b8$export$7b3f3c6551b4949b),
            sourceHeader: 0,
            dimensions: result.dimensions
        };
        return (0, $99e22f5c2aa5094b$export$1921362e86c73c88)(result.data, resultMetaRawOption, null);
    });
}
function $523dedd0a2328c06$var$isSupportedSourceFormat(sourceFormat) {
    return sourceFormat === (0, $cab29724515ce2b8$export$fcd62ebf51387903) || sourceFormat === (0, $cab29724515ce2b8$export$703ae8a2d83f441);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $370e5aa482d8420b$var$UNDEFINED = "undefined";
var $370e5aa482d8420b$export$859a1fa4f1106aa0 = typeof Uint32Array === $370e5aa482d8420b$var$UNDEFINED ? Array : Uint32Array;
var $370e5aa482d8420b$export$78cf73566f32c185 = typeof Uint16Array === $370e5aa482d8420b$var$UNDEFINED ? Array : Uint16Array;
var $370e5aa482d8420b$export$b60d945128546f53 = typeof Int32Array === $370e5aa482d8420b$var$UNDEFINED ? Array : Int32Array;
var $370e5aa482d8420b$export$365b104db51a490a = typeof Float64Array === $370e5aa482d8420b$var$UNDEFINED ? Array : Float64Array;
/**
 * Multi dimensional data store
 */ var $370e5aa482d8420b$var$dataCtors = {
    "float": $370e5aa482d8420b$export$365b104db51a490a,
    "int": $370e5aa482d8420b$export$b60d945128546f53,
    // Ordinal data type can be string or int
    "ordinal": Array,
    "number": Array,
    "time": $370e5aa482d8420b$export$365b104db51a490a
};
var $370e5aa482d8420b$var$defaultDimValueGetters;
function $370e5aa482d8420b$var$getIndicesCtor(rawCount) {
    // The possible max value in this._indicies is always this._rawCount despite of filtering.
    return rawCount > 65535 ? $370e5aa482d8420b$export$859a1fa4f1106aa0 : $370e5aa482d8420b$export$78cf73566f32c185;
}
function $370e5aa482d8420b$var$getInitialExtent() {
    return [
        Infinity,
        -Infinity
    ];
}
function $370e5aa482d8420b$var$cloneChunk(originalChunk) {
    var Ctor = originalChunk.constructor;
    // Only shallow clone is enough when Array.
    return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
}
function $370e5aa482d8420b$var$prepareStore(store, dimIdx, dimType, end, append) {
    var DataCtor = $370e5aa482d8420b$var$dataCtors[dimType || "float"];
    if (append) {
        var oldStore = store[dimIdx];
        var oldLen = oldStore && oldStore.length;
        if (!(oldLen === end)) {
            var newStore = new DataCtor(end);
            // The cost of the copy is probably inconsiderable
            // within the initial chunkSize.
            for(var j = 0; j < oldLen; j++)newStore[j] = oldStore[j];
            store[dimIdx] = newStore;
        }
    } else store[dimIdx] = new DataCtor(end);
}
/**
 * Basically, DataStore API keep immutable.
 */ var $370e5aa482d8420b$var$DataStore = /** @class */ function() {
    function DataStore() {
        this._chunks = [];
        // It will not be calculated until needed.
        this._rawExtent = [];
        this._extent = [];
        this._count = 0;
        this._rawCount = 0;
        this._calcDimNameToIdx = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    }
    /**
   * Initialize from data
   */ DataStore.prototype.initData = function(provider, inputDimensions, dimValueGetter) {
        this._provider = provider;
        // Clear
        this._chunks = [];
        this._indices = null;
        this.getRawIndex = this._getRawIdxIdentity;
        var source = provider.getSource();
        var defaultGetter = this.defaultDimValueGetter = $370e5aa482d8420b$var$defaultDimValueGetters[source.sourceFormat];
        // Default dim value getter
        this._dimValueGetter = dimValueGetter || defaultGetter;
        // Reset raw extent.
        this._rawExtent = [];
        var willRetrieveDataByName = (0, $99e22f5c2aa5094b$export$8911336b527f8517)(source);
        this._dimensions = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(inputDimensions, function(dim) {
            return {
                // Only pick these two props. Not leak other properties like orderMeta.
                type: dim.type,
                property: dim.property
            };
        });
        this._initDataFromProvider(0, provider.count());
    };
    DataStore.prototype.getProvider = function() {
        return this._provider;
    };
    /**
   * Caution: even when a `source` instance owned by a series, the created data store
   * may still be shared by different sereis (the source hash does not use all `source`
   * props, see `sourceManager`). In this case, the `source` props that are not used in
   * hash (like `source.dimensionDefine`) probably only belongs to a certain series and
   * thus should not be fetch here.
   */ DataStore.prototype.getSource = function() {
        return this._provider.getSource();
    };
    /**
   * @caution Only used in dataStack.
   */ DataStore.prototype.ensureCalculationDimension = function(dimName, type) {
        var calcDimNameToIdx = this._calcDimNameToIdx;
        var dimensions = this._dimensions;
        var calcDimIdx = calcDimNameToIdx.get(dimName);
        if (calcDimIdx != null) {
            if (dimensions[calcDimIdx].type === type) return calcDimIdx;
        } else calcDimIdx = dimensions.length;
        dimensions[calcDimIdx] = {
            type: type
        };
        calcDimNameToIdx.set(dimName, calcDimIdx);
        this._chunks[calcDimIdx] = new $370e5aa482d8420b$var$dataCtors[type || "float"](this._rawCount);
        this._rawExtent[calcDimIdx] = $370e5aa482d8420b$var$getInitialExtent();
        return calcDimIdx;
    };
    DataStore.prototype.collectOrdinalMeta = function(dimIdx, ordinalMeta) {
        var chunk = this._chunks[dimIdx];
        var dim = this._dimensions[dimIdx];
        var rawExtents = this._rawExtent;
        var offset = dim.ordinalOffset || 0;
        var len = chunk.length;
        if (offset === 0) // We need to reset the rawExtent if collect is from start.
        // Because this dimension may be guessed as number and calcuating a wrong extent.
        rawExtents[dimIdx] = $370e5aa482d8420b$var$getInitialExtent();
        var dimRawExtent = rawExtents[dimIdx];
        // Parse from previous data offset. len may be changed after appendData
        for(var i = offset; i < len; i++){
            var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);
            if (!isNaN(val)) {
                dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
                dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
            }
        }
        dim.ordinalMeta = ordinalMeta;
        dim.ordinalOffset = len;
        dim.type = "ordinal"; // Force to be ordinal
    };
    DataStore.prototype.getOrdinalMeta = function(dimIdx) {
        var dimInfo = this._dimensions[dimIdx];
        var ordinalMeta = dimInfo.ordinalMeta;
        return ordinalMeta;
    };
    DataStore.prototype.getDimensionProperty = function(dimIndex) {
        var item = this._dimensions[dimIndex];
        return item && item.property;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ DataStore.prototype.appendData = function(data) {
        var provider = this._provider;
        var start = this.count();
        provider.appendData(data);
        var end = provider.count();
        if (!provider.persistent) end += start;
        if (start < end) this._initDataFromProvider(start, end, true);
        return [
            start,
            end
        ];
    };
    DataStore.prototype.appendValues = function(values, minFillLen) {
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var start = this.count();
        var end = start + Math.max(values.length, minFillLen || 0);
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            $370e5aa482d8420b$var$prepareStore(chunks, i, dim.type, end, true);
        }
        var emptyDataItem = [];
        for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            // Store the data by dimensions
            for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                var dim = dimensions[dimIdx];
                var val = $370e5aa482d8420b$var$defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
                chunks[dimIdx][idx] = val;
                var dimRawExtent = rawExtent[dimIdx];
                val < dimRawExtent[0] && (dimRawExtent[0] = val);
                val > dimRawExtent[1] && (dimRawExtent[1] = val);
            }
        }
        this._rawCount = this._count = end;
        return {
            start: start,
            end: end
        };
    };
    DataStore.prototype._initDataFromProvider = function(start, end, append) {
        var provider = this._provider;
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var dimNames = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dimensions, function(dim) {
            return dim.property;
        });
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            if (!rawExtent[i]) rawExtent[i] = $370e5aa482d8420b$var$getInitialExtent();
            $370e5aa482d8420b$var$prepareStore(chunks, i, dim.type, end, append);
        }
        if (provider.fillStorage) provider.fillStorage(start, end, chunks, rawExtent);
        else {
            var dataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                dataItem = provider.getItem(idx, dataItem);
                // Each data item is value
                // [1, 2]
                // 2
                // Bar chart, line chart which uses category axis
                // only gives the 'y' value. 'x' value is the indices of category
                // Use a tempValue to normalize the value to be a (x, y) value
                // Store the data by dimensions
                for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                    var dimStorage = chunks[dimIdx];
                    // PENDING NULL is empty or zero
                    var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);
                    dimStorage[idx] = val;
                    var dimRawExtent = rawExtent[dimIdx];
                    val < dimRawExtent[0] && (dimRawExtent[0] = val);
                    val > dimRawExtent[1] && (dimRawExtent[1] = val);
                }
            }
        }
        if (!provider.persistent && provider.clean) // Clean unused data if data source is typed array.
        provider.clean();
        this._rawCount = this._count = end;
        // Reset data extent
        this._extent = [];
    };
    DataStore.prototype.count = function() {
        return this._count;
    };
    /**
   * Get value. Return NaN if idx is out of range.
   */ DataStore.prototype.get = function(dim, idx) {
        if (!(idx >= 0 && idx < this._count)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
    };
    DataStore.prototype.getValues = function(dimensions, idx) {
        var values = [];
        var dimArr = [];
        if (idx == null) {
            idx = dimensions;
            // TODO get all from store?
            dimensions = [];
            // All dimensions
            for(var i = 0; i < this._dimensions.length; i++)dimArr.push(i);
        } else dimArr = dimensions;
        for(var i = 0, len = dimArr.length; i < len; i++)values.push(this.get(dimArr[i], idx));
        return values;
    };
    /**
   * @param dim concrete dim
   */ DataStore.prototype.getByRawIndex = function(dim, rawIdx) {
        if (!(rawIdx >= 0 && rawIdx < this._rawCount)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[rawIdx] : NaN;
    };
    /**
   * Get sum of data in one dimension
   */ DataStore.prototype.getSum = function(dim) {
        var dimData = this._chunks[dim];
        var sum = 0;
        if (dimData) for(var i = 0, len = this.count(); i < len; i++){
            var value = this.get(dim, i);
            if (!isNaN(value)) sum += value;
        }
        return sum;
    };
    /**
   * Get median of data in one dimension
   */ DataStore.prototype.getMedian = function(dim) {
        var dimDataArray = [];
        // map all data of one dimension
        this.each([
            dim
        ], function(val) {
            if (!isNaN(val)) dimDataArray.push(val);
        });
        // TODO
        // Use quick select?
        var sortedDimDataArray = dimDataArray.sort(function(a, b) {
            return a - b;
        });
        var len = this.count();
        // calculate median
        return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
    };
    /**
   * Retrieve the index with given raw data index.
   */ DataStore.prototype.indexOfRawIndex = function(rawIndex) {
        if (rawIndex >= this._rawCount || rawIndex < 0) return -1;
        if (!this._indices) return rawIndex;
        // Indices are ascending
        var indices = this._indices;
        // If rawIndex === dataIndex
        var rawDataIndex = indices[rawIndex];
        if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) return rawIndex;
        var left = 0;
        var right = this._count - 1;
        while(left <= right){
            var mid = (left + right) / 2 | 0;
            if (indices[mid] < rawIndex) left = mid + 1;
            else if (indices[mid] > rawIndex) right = mid - 1;
            else return mid;
        }
        return -1;
    };
    /**
   * Retrieve the index of nearest value.
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices have
   *         the same value, they are put to the result.
   */ DataStore.prototype.indicesOfNearest = function(dim, value, maxDistance) {
        var chunks = this._chunks;
        var dimData = chunks[dim];
        var nearestIndices = [];
        if (!dimData) return nearestIndices;
        if (maxDistance == null) maxDistance = Infinity;
        var minDist = Infinity;
        var minDiff = -1;
        var nearestIndicesLen = 0;
        // Check the test case of `test/ut/spec/data/SeriesData.js`.
        for(var i = 0, len = this.count(); i < len; i++){
            var dataIndex = this.getRawIndex(i);
            var diff = value - dimData[dataIndex];
            var dist = Math.abs(diff);
            if (dist <= maxDistance) {
                // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
                // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
                // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
                // So we choose the one that `diff >= 0` in this case.
                // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
                // should be push to `nearestIndices`.
                if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
                    minDist = dist;
                    minDiff = diff;
                    nearestIndicesLen = 0;
                }
                if (diff === minDiff) nearestIndices[nearestIndicesLen++] = i;
            }
        }
        nearestIndices.length = nearestIndicesLen;
        return nearestIndices;
    };
    DataStore.prototype.getIndices = function() {
        var newIndices;
        var indices = this._indices;
        if (indices) {
            var Ctor = indices.constructor;
            var thisCount = this._count;
            // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
            if (Ctor === Array) {
                newIndices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)newIndices[i] = indices[i];
            } else newIndices = new Ctor(indices.buffer, 0, thisCount);
        } else {
            var Ctor = $370e5aa482d8420b$var$getIndicesCtor(this._rawCount);
            newIndices = new Ctor(this.count());
            for(var i = 0; i < newIndices.length; i++)newIndices[i] = i;
        }
        return newIndices;
    };
    /**
   * Data filter.
   */ DataStore.prototype.filter = function(dims, cb) {
        if (!this._count) return this;
        var newStore = this.clone();
        var count = newStore.count();
        var Ctor = $370e5aa482d8420b$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(count);
        var value = [];
        var dimSize = dims.length;
        var offset = 0;
        var dim0 = dims[0];
        var chunks = newStore._chunks;
        for(var i = 0; i < count; i++){
            var keep = void 0;
            var rawIdx = newStore.getRawIndex(i);
            // Simple optimization
            if (dimSize === 0) keep = cb(i);
            else if (dimSize === 1) {
                var val = chunks[dim0][rawIdx];
                keep = cb(val, i);
            } else {
                var k = 0;
                for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                value[k] = i;
                keep = cb.apply(null, value);
            }
            if (keep) newIndices[offset++] = rawIdx;
        }
        // Set indices after filtered.
        if (offset < count) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ DataStore.prototype.selectRange = function(range) {
        var newStore = this.clone();
        var len = newStore._count;
        if (!len) return this;
        var dims = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(range);
        var dimSize = dims.length;
        if (!dimSize) return this;
        var originalCount = newStore.count();
        var Ctor = $370e5aa482d8420b$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(originalCount);
        var offset = 0;
        var dim0 = dims[0];
        var min = range[dim0][0];
        var max = range[dim0][1];
        var storeArr = newStore._chunks;
        var quickFinished = false;
        if (!newStore._indices) {
            // Extreme optimization for common case. About 2x faster in chrome.
            var idx = 0;
            if (dimSize === 1) {
                var dimStorage = storeArr[dims[0]];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    // NaN will not be filtered. Consider the case, in line chart, empty
                    // value indicates the line should be broken. But for the case like
                    // scatter plot, a data item with empty value will not be rendered,
                    // but the axis extent may be effected if some other dim of the data
                    // item has value. Fortunately it is not a significant negative effect.
                    if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            } else if (dimSize === 2) {
                var dimStorage = storeArr[dims[0]];
                var dimStorage2 = storeArr[dims[1]];
                var min2 = range[dims[1]][0];
                var max2 = range[dims[1]][1];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    var val2 = dimStorage2[i];
                    // Do not filter NaN, see comment above.
                    if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            }
        }
        if (!quickFinished) {
            if (dimSize === 1) for(var i = 0; i < originalCount; i++){
                var rawIndex = newStore.getRawIndex(i);
                var val = storeArr[dims[0]][rawIndex];
                // Do not filter NaN, see comment above.
                if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = rawIndex;
            }
            else for(var i = 0; i < originalCount; i++){
                var keep = true;
                var rawIndex = newStore.getRawIndex(i);
                for(var k = 0; k < dimSize; k++){
                    var dimk = dims[k];
                    var val = storeArr[dimk][rawIndex];
                    // Do not filter NaN, see comment above.
                    if (val < range[dimk][0] || val > range[dimk][1]) keep = false;
                }
                if (keep) newIndices[offset++] = newStore.getRawIndex(i);
            }
        }
        // Set indices after filtered.
        if (offset < originalCount) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    // /**
    //  * Data mapping to a plain array
    //  */
    // mapArray(dims: DimensionIndex[], cb: MapArrayCb): any[] {
    //     const result: any[] = [];
    //     this.each(dims, function () {
    //         result.push(cb && (cb as MapArrayCb).apply(null, arguments));
    //     });
    //     return result;
    // }
    /**
   * Data mapping to a new List with given dimensions
   */ DataStore.prototype.map = function(dims, cb) {
        // TODO only clone picked chunks.
        var target = this.clone(dims);
        this._updateDims(target, dims, cb);
        return target;
    };
    /**
   * @caution Danger!! Only used in dataStack.
   */ DataStore.prototype.modify = function(dims, cb) {
        this._updateDims(this, dims, cb);
    };
    DataStore.prototype._updateDims = function(target, dims, cb) {
        var targetChunks = target._chunks;
        var tmpRetValue = [];
        var dimSize = dims.length;
        var dataCount = target.count();
        var values = [];
        var rawExtent = target._rawExtent;
        for(var i = 0; i < dims.length; i++)rawExtent[dims[i]] = $370e5aa482d8420b$var$getInitialExtent();
        for(var dataIndex = 0; dataIndex < dataCount; dataIndex++){
            var rawIndex = target.getRawIndex(dataIndex);
            for(var k = 0; k < dimSize; k++)values[k] = targetChunks[dims[k]][rawIndex];
            values[dimSize] = dataIndex;
            var retValue = cb && cb.apply(null, values);
            if (retValue != null) {
                // a number or string (in oridinal dimension)?
                if (typeof retValue !== "object") {
                    tmpRetValue[0] = retValue;
                    retValue = tmpRetValue;
                }
                for(var i = 0; i < retValue.length; i++){
                    var dim = dims[i];
                    var val = retValue[i];
                    var rawExtentOnDim = rawExtent[dim];
                    var dimStore = targetChunks[dim];
                    if (dimStore) dimStore[rawIndex] = val;
                    if (val < rawExtentOnDim[0]) rawExtentOnDim[0] = val;
                    if (val > rawExtentOnDim[1]) rawExtentOnDim[1] = val;
                }
            }
        }
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ DataStore.prototype.lttbDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        var sampledIndex = 0;
        var frameSize = Math.floor(1 / rate);
        var currentRawIndex = this.getRawIndex(0);
        var maxArea;
        var area;
        var nextRawIndex;
        var newIndices = new ($370e5aa482d8420b$var$getIndicesCtor(this._rawCount))(Math.min((Math.ceil(len / frameSize) + 2) * 2, len));
        // First frame use the first data.
        newIndices[sampledIndex++] = currentRawIndex;
        for(var i = 1; i < len - 1; i += frameSize){
            var nextFrameStart = Math.min(i + frameSize, len - 1);
            var nextFrameEnd = Math.min(i + frameSize * 2, len);
            var avgX = (nextFrameEnd + nextFrameStart) / 2;
            var avgY = 0;
            for(var idx = nextFrameStart; idx < nextFrameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) continue;
                avgY += y;
            }
            avgY /= nextFrameEnd - nextFrameStart;
            var frameStart = i;
            var frameEnd = Math.min(i + frameSize, len);
            var pointAX = i - 1;
            var pointAY = dimStore[currentRawIndex];
            maxArea = -1;
            nextRawIndex = frameStart;
            var firstNaNIndex = -1;
            var countNaN = 0;
            // Find a point from current frame that construct a triangle with largest area with previous selected point
            // And the average of next frame.
            for(var idx = frameStart; idx < frameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) {
                    countNaN++;
                    if (firstNaNIndex < 0) firstNaNIndex = rawIndex;
                    continue;
                }
                // Calculate triangle area over three buckets
                area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));
                if (area > maxArea) {
                    maxArea = area;
                    nextRawIndex = rawIndex; // Next a is this b
                }
            }
            if (countNaN > 0 && countNaN < frameEnd - frameStart) {
                // Append first NaN point in every bucket.
                // It is necessary to ensure the correct order of indices.
                newIndices[sampledIndex++] = Math.min(firstNaNIndex, nextRawIndex);
                nextRawIndex = Math.max(firstNaNIndex, nextRawIndex);
            }
            newIndices[sampledIndex++] = nextRawIndex;
            currentRawIndex = nextRawIndex; // This a is the next a (chosen b)
        }
        // First frame use the last data.
        newIndices[sampledIndex++] = this.getRawIndex(len - 1);
        target._count = sampledIndex;
        target._indices = newIndices;
        target.getRawIndex = this._getRawIdx;
        return target;
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ DataStore.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var target = this.clone([
            dimension
        ], true);
        var targetStorage = target._chunks;
        var frameValues = [];
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[dimension];
        var len = this.count();
        var rawExtentOnDim = target._rawExtent[dimension] = $370e5aa482d8420b$var$getInitialExtent();
        var newIndices = new ($370e5aa482d8420b$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            // Last frame
            if (frameSize > len - i) {
                frameSize = len - i;
                frameValues.length = frameSize;
            }
            for(var k = 0; k < frameSize; k++){
                var dataIdx = this.getRawIndex(i + k);
                frameValues[k] = dimStore[dataIdx];
            }
            var value = sampleValue(frameValues);
            var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
            // Only write value on the filtered data
            dimStore[sampleFrameIdx] = value;
            if (value < rawExtentOnDim[0]) rawExtentOnDim[0] = value;
            if (value > rawExtentOnDim[1]) rawExtentOnDim[1] = value;
            newIndices[offset++] = sampleFrameIdx;
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Data iteration
   * @param ctx default this
   * @example
   *  list.each('x', function (x, idx) {});
   *  list.each(['x', 'y'], function (x, y, idx) {});
   *  list.each(function (idx) {})
   */ DataStore.prototype.each = function(dims, cb) {
        if (!this._count) return;
        var dimSize = dims.length;
        var chunks = this._chunks;
        for(var i = 0, len = this.count(); i < len; i++){
            var rawIdx = this.getRawIndex(i);
            // Simple optimization
            switch(dimSize){
                case 0:
                    cb(i);
                    break;
                case 1:
                    cb(chunks[dims[0]][rawIdx], i);
                    break;
                case 2:
                    cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
                    break;
                default:
                    var k = 0;
                    var value = [];
                    for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                    // Index
                    value[k] = i;
                    cb.apply(null, value);
            }
        }
    };
    /**
   * Get extent of data in one dimension
   */ DataStore.prototype.getDataExtent = function(dim) {
        // Make sure use concrete dim as cache name.
        var dimData = this._chunks[dim];
        var initialExtent = $370e5aa482d8420b$var$getInitialExtent();
        if (!dimData) return initialExtent;
        // Make more strict checkings to ensure hitting cache.
        var currEnd = this.count();
        // Consider the most cases when using data zoom, `getDataExtent`
        // happened before filtering. We cache raw extent, which is not
        // necessary to be cleared and recalculated when restore data.
        var useRaw = !this._indices;
        var dimExtent;
        if (useRaw) return this._rawExtent[dim].slice();
        dimExtent = this._extent[dim];
        if (dimExtent) return dimExtent.slice();
        dimExtent = initialExtent;
        var min = dimExtent[0];
        var max = dimExtent[1];
        for(var i = 0; i < currEnd; i++){
            var rawIdx = this.getRawIndex(i);
            var value = dimData[rawIdx];
            value < min && (min = value);
            value > max && (max = value);
        }
        dimExtent = [
            min,
            max
        ];
        this._extent[dim] = dimExtent;
        return dimExtent;
    };
    /**
   * Get raw data item
   */ DataStore.prototype.getRawDataItem = function(idx) {
        var rawIdx = this.getRawIndex(idx);
        if (!this._provider.persistent) {
            var val = [];
            var chunks = this._chunks;
            for(var i = 0; i < chunks.length; i++)val.push(chunks[i][rawIdx]);
            return val;
        } else return this._provider.getItem(rawIdx);
    };
    /**
   * Clone shallow.
   *
   * @param clonedDims Determine which dims to clone. Will share the data if not specified.
   */ DataStore.prototype.clone = function(clonedDims, ignoreIndices) {
        var target = new DataStore();
        var chunks = this._chunks;
        var clonedDimsMap = clonedDims && (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)(clonedDims, function(obj, dimIdx) {
            obj[dimIdx] = true;
            return obj;
        }, {});
        if (clonedDimsMap) for(var i = 0; i < chunks.length; i++)// Not clone if dim is not picked.
        target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : $370e5aa482d8420b$var$cloneChunk(chunks[i]);
        else target._chunks = chunks;
        this._copyCommonProps(target);
        if (!ignoreIndices) target._indices = this._cloneIndices();
        target._updateGetRawIdx();
        return target;
    };
    DataStore.prototype._copyCommonProps = function(target) {
        target._count = this._count;
        target._rawCount = this._rawCount;
        target._provider = this._provider;
        target._dimensions = this._dimensions;
        target._extent = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(this._extent);
        target._rawExtent = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(this._rawExtent);
    };
    DataStore.prototype._cloneIndices = function() {
        if (this._indices) {
            var Ctor = this._indices.constructor;
            var indices = void 0;
            if (Ctor === Array) {
                var thisCount = this._indices.length;
                indices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)indices[i] = this._indices[i];
            } else indices = new Ctor(this._indices);
            return indices;
        }
        return null;
    };
    DataStore.prototype._getRawIdxIdentity = function(idx) {
        return idx;
    };
    DataStore.prototype._getRawIdx = function(idx) {
        if (idx < this._count && idx >= 0) return this._indices[idx];
        return -1;
    };
    DataStore.prototype._updateGetRawIdx = function() {
        this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
    };
    DataStore.internalField = function() {
        function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
            return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(dataItem[dimIndex], this._dimensions[dimIndex]);
        }
        $370e5aa482d8420b$var$defaultDimValueGetters = {
            arrayRows: getDimValueSimply,
            objectRows: function(dataItem, property, dataIndex, dimIndex) {
                return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(dataItem[property], this._dimensions[dimIndex]);
            },
            keyedColumns: getDimValueSimply,
            original: function(dataItem, property, dataIndex, dimIndex) {
                // Performance sensitive, do not use modelUtil.getDataItemValue.
                // If dataItem is an plain object with no value field, the let `value`
                // will be assigned with the object, but it will be tread correctly
                // in the `convertValue`.
                var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
                return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(value instanceof Array ? value[dimIndex] : value, this._dimensions[dimIndex]);
            },
            typedArray: function(dataItem, property, dataIndex, dimIndex) {
                return dataItem[dimIndex];
            }
        };
    }();
    return DataStore;
}();
var $370e5aa482d8420b$export$2e2bcd8739ae039 = $370e5aa482d8420b$var$DataStore;



/**
 * [REQUIREMENT_MEMO]:
 * (0) `metaRawOption` means `dimensions`/`sourceHeader`/`seriesLayoutBy` in raw option.
 * (1) Keep support the feature: `metaRawOption` can be specified both on `series` and
 * `root-dataset`. Them on `series` has higher priority.
 * (2) Do not support to set `metaRawOption` on a `non-root-dataset`, because it might
 * confuse users: whether those props indicate how to visit the upstream source or visit
 * the transform result source, and some transforms has nothing to do with these props,
 * and some transforms might have multiple upstream.
 * (3) Transforms should specify `metaRawOption` in each output, just like they can be
 * declared in `root-dataset`.
 * (4) At present only support visit source in `SERIES_LAYOUT_BY_COLUMN` in transforms.
 * That is for reducing complexity in transforms.
 * PENDING: Whether to provide transposition transform?
 *
 * [IMPLEMENTAION_MEMO]:
 * "sourceVisitConfig" are calculated from `metaRawOption` and `data`.
 * They will not be calculated until `source` is about to be visited (to prevent from
 * duplicate calcuation). `source` is visited only in series and input to transforms.
 *
 * [DIMENSION_INHERIT_RULE]:
 * By default the dimensions are inherited from ancestors, unless a transform return
 * a new dimensions definition.
 * Consider the case:
 * ```js
 * dataset: [{
 *     source: [ ['Product', 'Sales', 'Prise'], ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * dataset: [{
 *     dimension: ['Product', 'Sales', 'Prise'],
 *     source: [ ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * ```
 * The two types of option should have the same behavior after transform.
 *
 *
 * [SCENARIO]:
 * (1) Provide source data directly:
 * ```js
 * series: {
 *     encode: {...},
 *     dimensions: [...]
 *     seriesLayoutBy: 'row',
 *     data: [[...]]
 * }
 * ```
 * (2) Series refer to dataset.
 * ```js
 * series: [{
 *     encode: {...}
 *     // Ignore datasetIndex means `datasetIndex: 0`
 *     // and the dimensions defination in dataset is used
 * }, {
 *     encode: {...},
 *     seriesLayoutBy: 'column',
 *     datasetIndex: 1
 * }]
 * ```
 * (3) dataset transform
 * ```js
 * dataset: [{
 *     source: [...]
 * }, {
 *     source: [...]
 * }, {
 *     // By default from 0.
 *     transform: { type: 'filter', config: {...} }
 * }, {
 *     // Piped.
 *     transform: [
 *         { type: 'filter', config: {...} },
 *         { type: 'sort', config: {...} }
 *     ]
 * }, {
 *     id: 'regressionData',
 *     fromDatasetIndex: 1,
 *     // Third-party transform
 *     transform: { type: 'ecStat:regression', config: {...} }
 * }, {
 *     // retrieve the extra result.
 *     id: 'regressionFormula',
 *     fromDatasetId: 'regressionData',
 *     fromTransformResult: 1
 * }]
 * ```
 */ var $1c87d176de397e7e$export$af4db9ec7e200ea2 = /** @class */ function() {
    function SourceManager(sourceHost) {
        // Cached source. Do not repeat calculating if not dirty.
        this._sourceList = [];
        this._storeList = [];
        // version sign of each upstream source manager.
        this._upstreamSignList = [];
        this._versionSignBase = 0;
        this._dirty = true;
        this._sourceHost = sourceHost;
    }
    /**
   * Mark dirty.
   */ SourceManager.prototype.dirty = function() {
        this._setLocalSource([], []);
        this._storeList = [];
        this._dirty = true;
    };
    SourceManager.prototype._setLocalSource = function(sourceList, upstreamSignList) {
        this._sourceList = sourceList;
        this._upstreamSignList = upstreamSignList;
        this._versionSignBase++;
        if (this._versionSignBase > 9e10) this._versionSignBase = 0;
    };
    /**
   * For detecting whether the upstream source is dirty, so that
   * the local cached source (in `_sourceList`) should be discarded.
   */ SourceManager.prototype._getVersionSign = function() {
        return this._sourceHost.uid + "_" + this._versionSignBase;
    };
    /**
   * Always return a source instance. Otherwise throw error.
   */ SourceManager.prototype.prepareSource = function() {
        // For the case that call `setOption` multiple time but no data changed,
        // cache the result source to prevent from repeating transform.
        if (this._isDirty()) {
            this._createSource();
            this._dirty = false;
        }
    };
    SourceManager.prototype._createSource = function() {
        this._setLocalSource([], []);
        var sourceHost = this._sourceHost;
        var upSourceMgrList = this._getUpstreamSourceManagers();
        var hasUpstream = !!upSourceMgrList.length;
        var resultSourceList;
        var upstreamSignList;
        if ($1c87d176de397e7e$var$isSeries(sourceHost)) {
            var seriesModel = sourceHost;
            var data = void 0;
            var sourceFormat = void 0;
            var upSource = void 0;
            // Has upstream dataset
            if (hasUpstream) {
                var upSourceMgr = upSourceMgrList[0];
                upSourceMgr.prepareSource();
                upSource = upSourceMgr.getSource();
                data = upSource.data;
                sourceFormat = upSource.sourceFormat;
                upstreamSignList = [
                    upSourceMgr._getVersionSign()
                ];
            } else {
                data = seriesModel.get("data", true);
                sourceFormat = (0, $7a1bd9c2710fea0d$export$b119cc7e1840e59c)(data) ? (0, $cab29724515ce2b8$export$a918cb016a382d45) : (0, $cab29724515ce2b8$export$2823037fb9d8f0c6);
                upstreamSignList = [];
            }
            // See [REQUIREMENT_MEMO], merge settings on series and parent dataset if it is root.
            var newMetaRawOption = this._getSourceMetaRawOption() || {};
            var upMetaRawOption = upSource && upSource.metaRawOption || {};
            var seriesLayoutBy = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
            var sourceHeader = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader);
            // Note here we should not use `upSource.dimensionsDefine`. Consider the case:
            // `upSource.dimensionsDefine` is detected by `seriesLayoutBy: 'column'`,
            // but series need `seriesLayoutBy: 'row'`.
            var dimensions = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(newMetaRawOption.dimensions, upMetaRawOption.dimensions);
            // We share source with dataset as much as possible
            // to avoid extra memory cost of high dimensional data.
            var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
            resultSourceList = needsCreateSource ? [
                (0, $99e22f5c2aa5094b$export$1921362e86c73c88)(data, {
                    seriesLayoutBy: seriesLayoutBy,
                    sourceHeader: sourceHeader,
                    dimensions: dimensions
                }, sourceFormat)
            ] : [];
        } else {
            var datasetModel = sourceHost;
            // Has upstream dataset.
            if (hasUpstream) {
                var result = this._applyTransform(upSourceMgrList);
                resultSourceList = result.sourceList;
                upstreamSignList = result.upstreamSignList;
            } else {
                var sourceData = datasetModel.get("source", true);
                resultSourceList = [
                    (0, $99e22f5c2aa5094b$export$1921362e86c73c88)(sourceData, this._getSourceMetaRawOption(), null)
                ];
                upstreamSignList = [];
            }
        }
        this._setLocalSource(resultSourceList, upstreamSignList);
    };
    SourceManager.prototype._applyTransform = function(upMgrList) {
        var datasetModel = this._sourceHost;
        var transformOption = datasetModel.get("transform", true);
        var fromTransformResult = datasetModel.get("fromTransformResult", true);
        if (fromTransformResult != null) {
            var errMsg = "";
            if (upMgrList.length !== 1) $1c87d176de397e7e$var$doThrow(errMsg);
        }
        var sourceList;
        var upSourceList = [];
        var upstreamSignList = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(upMgrList, function(upMgr) {
            upMgr.prepareSource();
            var upSource = upMgr.getSource(fromTransformResult || 0);
            var errMsg = "";
            if (fromTransformResult != null && !upSource) $1c87d176de397e7e$var$doThrow(errMsg);
            upSourceList.push(upSource);
            upstreamSignList.push(upMgr._getVersionSign());
        });
        if (transformOption) sourceList = (0, $523dedd0a2328c06$export$42a68f09db16803f)(transformOption, upSourceList, {
            datasetIndex: datasetModel.componentIndex
        });
        else if (fromTransformResult != null) sourceList = [
            (0, $99e22f5c2aa5094b$export$e0365e7e3555ddd4)(upSourceList[0])
        ];
        return {
            sourceList: sourceList,
            upstreamSignList: upstreamSignList
        };
    };
    SourceManager.prototype._isDirty = function() {
        if (this._dirty) return true;
        // All sourceList is from the some upstream.
        var upSourceMgrList = this._getUpstreamSourceManagers();
        for(var i = 0; i < upSourceMgrList.length; i++){
            var upSrcMgr = upSourceMgrList[i];
            if (// Consider the case that there is ancestor diry, call it recursively.
            // The performance is probably not an issue because usually the chain is not long.
            upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) return true;
        }
    };
    /**
   * @param sourceIndex By default 0, means "main source".
   *                    In most cases there is only one source.
   */ SourceManager.prototype.getSource = function(sourceIndex) {
        sourceIndex = sourceIndex || 0;
        var source = this._sourceList[sourceIndex];
        if (!source) {
            // Series may share source instance with dataset.
            var upSourceMgrList = this._getUpstreamSourceManagers();
            return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
        }
        return source;
    };
    /**
   *
   * Get a data store which can be shared across series.
   * Only available for series.
   *
   * @param seriesDimRequest Dimensions that are generated in series.
   *        Should have been sorted by `storeDimIndex` asc.
   */ SourceManager.prototype.getSharedDataStore = function(seriesDimRequest) {
        var schema = seriesDimRequest.makeStoreSchema();
        return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
    };
    SourceManager.prototype._innerGetDataStore = function(storeDims, seriesSource, sourceReadKey) {
        // TODO Can use other sourceIndex?
        var sourceIndex = 0;
        var storeList = this._storeList;
        var cachedStoreMap = storeList[sourceIndex];
        if (!cachedStoreMap) cachedStoreMap = storeList[sourceIndex] = {};
        var cachedStore = cachedStoreMap[sourceReadKey];
        if (!cachedStore) {
            var upSourceMgr = this._getUpstreamSourceManagers()[0];
            if ($1c87d176de397e7e$var$isSeries(this._sourceHost) && upSourceMgr) cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
            else {
                cachedStore = new (0, $370e5aa482d8420b$export$2e2bcd8739ae039)();
                // Always create store from source of series.
                cachedStore.initData(new (0, $8ffb0d67e9446edb$export$b900d7c4c3952a40)(seriesSource, storeDims.length), storeDims);
            }
            cachedStoreMap[sourceReadKey] = cachedStore;
        }
        return cachedStore;
    };
    /**
   * PENDING: Is it fast enough?
   * If no upstream, return empty array.
   */ SourceManager.prototype._getUpstreamSourceManagers = function() {
        // Always get the relationship from the raw option.
        // Do not cache the link of the dependency graph, so that
        // there is no need to update them when change happens.
        var sourceHost = this._sourceHost;
        if ($1c87d176de397e7e$var$isSeries(sourceHost)) {
            var datasetModel = (0, $7dc6cdfd7450ef29$export$8da66f73a1eda454)(sourceHost);
            return !datasetModel ? [] : [
                datasetModel.getSourceManager()
            ];
        } else return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7dc6cdfd7450ef29$export$397ba553479711e7)(sourceHost), function(datasetModel) {
            return datasetModel.getSourceManager();
        });
    };
    SourceManager.prototype._getSourceMetaRawOption = function() {
        var sourceHost = this._sourceHost;
        var seriesLayoutBy;
        var sourceHeader;
        var dimensions;
        if ($1c87d176de397e7e$var$isSeries(sourceHost)) {
            seriesLayoutBy = sourceHost.get("seriesLayoutBy", true);
            sourceHeader = sourceHost.get("sourceHeader", true);
            dimensions = sourceHost.get("dimensions", true);
        } else if (!this._getUpstreamSourceManagers().length) {
            var model = sourceHost;
            seriesLayoutBy = model.get("seriesLayoutBy", true);
            sourceHeader = model.get("sourceHeader", true);
            dimensions = model.get("dimensions", true);
        }
        return {
            seriesLayoutBy: seriesLayoutBy,
            sourceHeader: sourceHeader,
            dimensions: dimensions
        };
    };
    return SourceManager;
}();
function $1c87d176de397e7e$export$9451f4e9047441ec(datasetModel) {
    var transformOption = datasetModel.option.transform;
    transformOption && (0, $7a1bd9c2710fea0d$export$112e66431016387b)(datasetModel.option.transform);
}
function $1c87d176de397e7e$var$isSeries(sourceHost) {
    // Avoid circular dependency with Series.ts
    return sourceHost.mainType === "series";
}
function $1c87d176de397e7e$var$doThrow(errMsg) {
    throw new Error(errMsg);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $d5ab84c08d6657ec$var$TOOLTIP_LINE_HEIGHT_CSS = "line-height:1";
// TODO: more textStyle option
function $d5ab84c08d6657ec$var$getTooltipTextStyle(textStyle, renderMode) {
    var nameFontColor = textStyle.color || "#6e7079";
    var nameFontSize = textStyle.fontSize || 12;
    var nameFontWeight = textStyle.fontWeight || "400";
    var valueFontColor = textStyle.color || "#464646";
    var valueFontSize = textStyle.fontSize || 14;
    var valueFontWeight = textStyle.fontWeight || "900";
    if (renderMode === "html") // `textStyle` is probably from user input, should be encoded to reduce security risk.
    return {
        // eslint-disable-next-line max-len
        nameStyle: "font-size:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(nameFontSize + "") + "px;color:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(nameFontColor) + ";font-weight:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(nameFontWeight + ""),
        // eslint-disable-next-line max-len
        valueStyle: "font-size:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(valueFontSize + "") + "px;color:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(valueFontColor) + ";font-weight:" + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(valueFontWeight + "")
    };
    else return {
        nameStyle: {
            fontSize: nameFontSize,
            fill: nameFontColor,
            fontWeight: nameFontWeight
        },
        valueStyle: {
            fontSize: valueFontSize,
            fill: valueFontColor,
            fontWeight: valueFontWeight
        }
    };
}
// See `TooltipMarkupLayoutIntent['innerGapLevel']`.
// (value from UI design)
var $d5ab84c08d6657ec$var$HTML_GAPS = [
    0,
    10,
    20,
    30
];
var $d5ab84c08d6657ec$var$RICH_TEXT_GAPS = [
    "",
    "\n",
    "\n\n",
    "\n\n\n"
];
function $d5ab84c08d6657ec$export$cf63b23ce77d1921(type, option) {
    option.type = type;
    return option;
}
function $d5ab84c08d6657ec$var$isSectionFragment(frag) {
    return frag.type === "section";
}
function $d5ab84c08d6657ec$var$getBuilder(frag) {
    return $d5ab84c08d6657ec$var$isSectionFragment(frag) ? $d5ab84c08d6657ec$var$buildSection : $d5ab84c08d6657ec$var$buildNameValue;
}
function $d5ab84c08d6657ec$var$getBlockGapLevel(frag) {
    if ($d5ab84c08d6657ec$var$isSectionFragment(frag)) {
        var gapLevel_1 = 0;
        var subBlockLen = frag.blocks.length;
        var hasInnerGap_1 = subBlockLen > 1 || subBlockLen > 0 && !frag.noHeader;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(frag.blocks, function(subBlock) {
            var subGapLevel = $d5ab84c08d6657ec$var$getBlockGapLevel(subBlock);
            // If the some of the sub-blocks have some gaps (like 10px) inside, this block
            // should use a larger gap (like 20px) to distinguish those sub-blocks.
            if (subGapLevel >= gapLevel_1) gapLevel_1 = subGapLevel + +(hasInnerGap_1 && // 0 always can not be readable gap level.
            (!subGapLevel || $d5ab84c08d6657ec$var$isSectionFragment(subBlock) && !subBlock.noHeader));
        });
        return gapLevel_1;
    }
    return 0;
}
function $d5ab84c08d6657ec$var$buildSection(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var noHeader = fragment.noHeader;
    var gaps = $d5ab84c08d6657ec$var$getGap($d5ab84c08d6657ec$var$getBlockGapLevel(fragment));
    var subMarkupTextList = [];
    var subBlocks = fragment.blocks || [];
    (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!subBlocks || (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(subBlocks));
    subBlocks = subBlocks || [];
    var orderMode = ctx.orderMode;
    if (fragment.sortBlocks && orderMode) {
        subBlocks = subBlocks.slice();
        var orderMap = {
            valueAsc: "asc",
            valueDesc: "desc"
        };
        if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(orderMap, orderMode)) {
            var comparator_1 = new (0, $40ab59f44b7d2db6$export$ed75a5d7b0144167)(orderMap[orderMode], null);
            subBlocks.sort(function(a, b) {
                return comparator_1.evaluate(a.sortParam, b.sortParam);
            });
        } else if (orderMode === "seriesDesc") subBlocks.reverse();
    }
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(subBlocks, function(subBlock, idx) {
        var valueFormatter = fragment.valueFormatter;
        var subMarkupText = $d5ab84c08d6657ec$var$getBuilder(subBlock)(// Inherit valueFormatter
        valueFormatter ? (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, ctx), {
            valueFormatter: valueFormatter
        }) : ctx, subBlock, idx > 0 ? gaps.html : 0, toolTipTextStyle);
        subMarkupText != null && subMarkupTextList.push(subMarkupText);
    });
    var subMarkupText = ctx.renderMode === "richText" ? subMarkupTextList.join(gaps.richText) : $d5ab84c08d6657ec$var$wrapBlockHTML(subMarkupTextList.join(""), noHeader ? topMarginForOuterGap : gaps.html);
    if (noHeader) return subMarkupText;
    var displayableHeader = (0, $c84c9521536c601a$export$3cd8db88714decfc)(fragment.header, "ordinal", ctx.useUTC);
    var nameStyle = $d5ab84c08d6657ec$var$getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;
    if (ctx.renderMode === "richText") return $d5ab84c08d6657ec$var$wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
    else return $d5ab84c08d6657ec$var$wrapBlockHTML('<div style="' + nameStyle + ";" + $d5ab84c08d6657ec$var$TOOLTIP_LINE_HEIGHT_CSS + ';">' + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(displayableHeader) + "</div>" + subMarkupText, topMarginForOuterGap);
}
function $d5ab84c08d6657ec$var$buildNameValue(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var renderMode = ctx.renderMode;
    var noName = fragment.noName;
    var noValue = fragment.noValue;
    var noMarker = !fragment.markerType;
    var name = fragment.name;
    var useUTC = ctx.useUTC;
    var valueFormatter = fragment.valueFormatter || ctx.valueFormatter || function(value) {
        value = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(value) ? value : [
            value
        ];
        return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(value, function(val, idx) {
            return (0, $c84c9521536c601a$export$3cd8db88714decfc)(val, (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
        });
    };
    if (noName && noValue) return;
    var markerStr = noMarker ? "" : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || "#333", renderMode);
    var readableName = noName ? "" : (0, $c84c9521536c601a$export$3cd8db88714decfc)(name, "ordinal", useUTC);
    var valueTypeOption = fragment.valueType;
    var readableValueList = noValue ? [] : valueFormatter(fragment.value, fragment.dataIndex);
    var valueAlignRight = !noMarker || !noName;
    // It little weird if only value next to marker but far from marker.
    var valueCloseToMarker = !noMarker && noName;
    var _a = $d5ab84c08d6657ec$var$getTooltipTextStyle(toolTipTextStyle, renderMode), nameStyle = _a.nameStyle, valueStyle = _a.valueStyle;
    return renderMode === "richText" ? (noMarker ? "" : markerStr) + (noName ? "" : $d5ab84c08d6657ec$var$wrapInlineNameRichText(ctx, readableName, nameStyle)) + (noValue ? "" : $d5ab84c08d6657ec$var$wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : $d5ab84c08d6657ec$var$wrapBlockHTML((noMarker ? "" : markerStr) + (noName ? "" : $d5ab84c08d6657ec$var$wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? "" : $d5ab84c08d6657ec$var$wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
}
function $d5ab84c08d6657ec$export$6969ffb02c1cb49a(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
    if (!fragment) return;
    var builder = $d5ab84c08d6657ec$var$getBuilder(fragment);
    var ctx = {
        useUTC: useUTC,
        renderMode: renderMode,
        orderMode: orderMode,
        markupStyleCreator: markupStyleCreator,
        valueFormatter: fragment.valueFormatter
    };
    return builder(ctx, fragment, 0, toolTipTextStyle);
}
function $d5ab84c08d6657ec$var$getGap(gapLevel) {
    return {
        html: $d5ab84c08d6657ec$var$HTML_GAPS[gapLevel],
        richText: $d5ab84c08d6657ec$var$RICH_TEXT_GAPS[gapLevel]
    };
}
function $d5ab84c08d6657ec$var$wrapBlockHTML(encodedContent, topGap) {
    var clearfix = '<div style="clear:both"></div>';
    var marginCSS = "margin: " + topGap + "px 0 0";
    return '<div style="' + marginCSS + ";" + $d5ab84c08d6657ec$var$TOOLTIP_LINE_HEIGHT_CSS + ';">' + encodedContent + clearfix + "</div>";
}
function $d5ab84c08d6657ec$var$wrapInlineNameHTML(name, leftHasMarker, style) {
    var marginCss = leftHasMarker ? "margin-left:2px" : "";
    return '<span style="' + style + ";" + marginCss + '">' + (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(name) + "</span>";
}
function $d5ab84c08d6657ec$var$wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
    // Do not too close to marker, considering there are multiple values separated by spaces.
    var paddingStr = valueCloseToMarker ? "10px" : "20px";
    var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : "";
    valueList = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(valueList) ? valueList : [
        valueList
    ];
    return '<span style="' + alignCSS + ";" + style + '">' + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(valueList, function(value) {
        return (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(value);
    }).join("&nbsp;&nbsp;") + "</span>";
}
function $d5ab84c08d6657ec$var$wrapInlineNameRichText(ctx, name, style) {
    return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
}
function $d5ab84c08d6657ec$var$wrapInlineValueRichText(ctx, values, alignRight, valueCloseToMarker, style) {
    var styles = [
        style
    ];
    var paddingLeft = valueCloseToMarker ? 10 : 20;
    alignRight && styles.push({
        padding: [
            0,
            0,
            0,
            paddingLeft
        ],
        align: "right"
    });
    // Value has commas inside, so use '  ' as delimiter for multiple values.
    return ctx.markupStyleCreator.wrapRichTextStyle((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(values) ? values.join("  ") : values, styles);
}
function $d5ab84c08d6657ec$export$ea15628039c0fa93(series, dataIndex) {
    var style = series.getData().getItemVisual(dataIndex, "style");
    var color = style[series.visualDrawType];
    return (0, $c84c9521536c601a$export$cda04d03233e5555)(color);
}
function $d5ab84c08d6657ec$export$3048212c802df496(model, renderMode) {
    var padding = model.get("padding");
    return padding != null ? padding : renderMode === "richText" ? [
        8,
        10
    ] : 10;
}
/**
 * The major feature is generate styles for `renderMode: 'richText'`.
 * But it also serves `renderMode: 'html'` to provide
 * "renderMode-independent" API.
 */ var $d5ab84c08d6657ec$export$2fba3afbcdcf3e18 = /** @class */ function() {
    function TooltipMarkupStyleCreator() {
        this.richTextStyles = {};
        // Notice that "generate a style name" usually happens repeatedly when mouse is moving and
        // a tooltip is displayed. So we put the `_nextStyleNameId` as a member of each creator
        // rather than static shared by all creators (which will cause it increase to fast).
        this._nextStyleNameId = (0, $cfc1f3b422a3185f$export$474d2ec9aa44a22)();
    }
    TooltipMarkupStyleCreator.prototype._generateStyleName = function() {
        return "__EC_aUTo_" + this._nextStyleNameId++;
    };
    TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function(markerType, colorStr, renderMode) {
        var markerId = renderMode === "richText" ? this._generateStyleName() : null;
        var marker = (0, $c84c9521536c601a$export$1987a3dbdf3c45ca)({
            color: colorStr,
            type: markerType,
            renderMode: renderMode,
            markerId: markerId
        });
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(marker)) return marker;
        else {
            this.richTextStyles[markerId] = marker.style;
            return marker.content;
        }
    };
    /**
   * @usage
   * ```ts
   * const styledText = markupStyleCreator.wrapRichTextStyle([
   *     // The styles will be auto merged.
   *     {
   *         fontSize: 12,
   *         color: 'blue'
   *     },
   *     {
   *         padding: 20
   *     }
   * ]);
   * ```
   */ TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function(text, styles) {
        var finalStl = {};
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(styles)) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(styles, function(stl) {
            return (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(finalStl, stl);
        });
        else (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(finalStl, styles);
        var styleName = this._generateStyleName();
        this.richTextStyles[styleName] = finalStl;
        return "{" + styleName + "|" + text + "}";
    };
    return TooltipMarkupStyleCreator;
}();




function $b0d4c63a14430ca1$export$3a110b9fb5c88b34(opt) {
    var series = opt.series;
    var dataIndex = opt.dataIndex;
    var multipleSeries = opt.multipleSeries;
    var data = series.getData();
    var tooltipDims = data.mapDimensionsAll("defaultedTooltip");
    var tooltipDimLen = tooltipDims.length;
    var value = series.getRawValue(dataIndex);
    var isValueArr = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(value);
    var markerColor = (0, $d5ab84c08d6657ec$export$ea15628039c0fa93)(series, dataIndex);
    // Complicated rule for pretty tooltip.
    var inlineValue;
    var inlineValueType;
    var subBlocks;
    var sortParam;
    if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
        var formatArrResult = $b0d4c63a14430ca1$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
        inlineValue = formatArrResult.inlineValues;
        inlineValueType = formatArrResult.inlineValueTypes;
        subBlocks = formatArrResult.blocks;
        // Only support tooltip sort by the first inline value. It's enough in most cases.
        sortParam = formatArrResult.inlineValues[0];
    } else if (tooltipDimLen) {
        var dimInfo = data.getDimensionInfo(tooltipDims[0]);
        sortParam = inlineValue = (0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, tooltipDims[0]);
        inlineValueType = dimInfo.type;
    } else sortParam = inlineValue = isValueArr ? value[0] : value;
    // Do not show generated series name. It might not be readable.
    var seriesNameSpecified = (0, $76d619f648247e6d$export$beae19a2652b3368)(series);
    var seriesName = seriesNameSpecified && series.name || "";
    var itemName = data.getName(dataIndex);
    var inlineName = multipleSeries ? seriesName : itemName;
    return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("section", {
        header: seriesName,
        // When series name is not specified, do not show a header line with only '-'.
        // This case always happens in tooltip.trigger: 'item'.
        noHeader: multipleSeries || !seriesNameSpecified,
        sortParam: sortParam,
        blocks: [
            (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                markerType: "item",
                markerColor: markerColor,
                // Do not mix display seriesName and itemName in one tooltip,
                // which might confuses users.
                name: inlineName,
                // name dimension might be auto assigned, where the name might
                // be not readable. So we check trim here.
                noName: !(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(inlineName),
                value: inlineValue,
                valueType: inlineValueType,
                dataIndex: dataIndex
            })
        ].concat(subBlocks || [])
    });
}
function $b0d4c63a14430ca1$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
    // check: category-no-encode-has-axis-data in dataset.html
    var data = series.getData();
    var isValueMultipleLine = (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)(value, function(isValueMultipleLine, val, idx) {
        var dimItem = data.getDimensionInfo(idx);
        return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
    }, false);
    var inlineValues = [];
    var inlineValueTypes = [];
    var blocks = [];
    tooltipDims.length ? (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(tooltipDims, function(dim) {
        setEachItem((0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, dim), dim);
    }) : (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(value, setEachItem);
    function setEachItem(val, dim) {
        var dimInfo = data.getDimensionInfo(dim);
        // If `dimInfo.tooltip` is not set, show tooltip.
        if (!dimInfo || dimInfo.otherDims.tooltip === false) return;
        if (isValueMultipleLine) blocks.push((0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
            markerType: "subItem",
            markerColor: colorStr,
            name: dimInfo.displayName,
            value: val,
            valueType: dimInfo.type
        }));
        else {
            inlineValues.push(val);
            inlineValueTypes.push(dimInfo.type);
        }
    }
    return {
        inlineValues: inlineValues,
        inlineValueTypes: inlineValueTypes,
        blocks: blocks
    };
}


var $7c10febb2cdef0d8$var$inner = $76d619f648247e6d$export$64df9f8d92ae083f();
function $7c10febb2cdef0d8$var$getSelectionKey(data, dataIndex) {
    return data.getName(dataIndex) || data.getId(dataIndex);
}
var $7c10febb2cdef0d8$export$e960441116ae2799 = "__universalTransitionEnabled";
var $7c10febb2cdef0d8$var$SeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SeriesModel, _super);
    function SeriesModel() {
        // [Caution]: Because this class or desecendants can be used as `XXX.extend(subProto)`,
        // the class members must not be initialized in constructor or declaration place.
        // Otherwise there is bad case:
        //   class A {xxx = 1;}
        //   enableClassExtend(A);
        //   class B extends A {}
        //   var C = B.extend({xxx: 5});
        //   var c = new C();
        //   console.log(c.xxx); // expect 5 but always 1.
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // ---------------------------------------
        // Props about data selection
        // ---------------------------------------
        _this._selectedDataIndicesMap = {};
        return _this;
    }
    SeriesModel.prototype.init = function(option, parentModel, ecModel) {
        this.seriesIndex = this.componentIndex;
        this.dataTask = (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
            count: $7c10febb2cdef0d8$var$dataTaskCount,
            reset: $7c10febb2cdef0d8$var$dataTaskReset
        });
        this.dataTask.context = {
            model: this
        };
        this.mergeDefaultAndTheme(option, ecModel);
        var sourceManager = $7c10febb2cdef0d8$var$inner(this).sourceManager = new (0, $1c87d176de397e7e$export$af4db9ec7e200ea2)(this);
        sourceManager.prepareSource();
        var data = this.getInitialData(option, ecModel);
        $7c10febb2cdef0d8$var$wrapData(data, this);
        this.dataTask.context.data = data;
        $7c10febb2cdef0d8$var$inner(this).dataBeforeProcessed = data;
        // If we reverse the order (make data firstly, and then make
        // dataBeforeProcessed by cloneShallow), cloneShallow will
        // cause data.graph.data !== data when using
        // module:echarts/data/Graph or module:echarts/data/Tree.
        // See module:echarts/data/helper/linkSeriesData
        // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
        // init or merge stage, because the data can be restored. So we do not `restoreData`
        // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
        // Call `seriesModel.getRawData()` instead.
        // this.restoreData();
        $7c10febb2cdef0d8$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    /**
   * Util for merge default and theme to option
   */ SeriesModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = (0, $93b9bc7f22ac7369$export$3968a28a7cbd6063)(this);
        var inputPositionParams = layoutMode ? (0, $93b9bc7f22ac7369$export$4b0d20af19c9875e)(option) : {};
        // Backward compat: using subType on theme.
        // But if name duplicate between series subType
        // (for example: parallel) add component mainType,
        // add suffix 'Series'.
        var themeSubType = this.subType;
        if ((0, $116d65051f61bdfe$export$2e2bcd8739ae039).hasClass(themeSubType)) themeSubType += "Series";
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(option, ecModel.getTheme().get(this.subType));
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(option, this.getDefaultOption());
        // Default label emphasis `show`
        $76d619f648247e6d$export$abdcc6a26372f94b(option, "label", [
            "show"
        ]);
        this.fillDataTextStyle(option.data);
        if (layoutMode) (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(option, inputPositionParams, layoutMode);
    };
    SeriesModel.prototype.mergeOption = function(newSeriesOption, ecModel) {
        // this.settingTask.dirty();
        newSeriesOption = $7a1bd9c2710fea0d$export$4950aa0f605343fb(this.option, newSeriesOption, true);
        this.fillDataTextStyle(newSeriesOption.data);
        var layoutMode = (0, $93b9bc7f22ac7369$export$3968a28a7cbd6063)(this);
        if (layoutMode) (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(this.option, newSeriesOption, layoutMode);
        var sourceManager = $7c10febb2cdef0d8$var$inner(this).sourceManager;
        sourceManager.dirty();
        sourceManager.prepareSource();
        var data = this.getInitialData(newSeriesOption, ecModel);
        $7c10febb2cdef0d8$var$wrapData(data, this);
        this.dataTask.dirty();
        this.dataTask.context.data = data;
        $7c10febb2cdef0d8$var$inner(this).dataBeforeProcessed = data;
        $7c10febb2cdef0d8$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    SeriesModel.prototype.fillDataTextStyle = function(data) {
        // Default data label emphasis `show`
        // FIXME Tree structure data ?
        // FIXME Performance ?
        if (data && !$7a1bd9c2710fea0d$export$b119cc7e1840e59c(data)) {
            var props = [
                "show"
            ];
            for(var i = 0; i < data.length; i++)if (data[i] && data[i].label) $76d619f648247e6d$export$abdcc6a26372f94b(data[i], "label", props);
        }
    };
    /**
   * Init a data structure from data related option in series
   * Must be overridden.
   */ SeriesModel.prototype.getInitialData = function(option, ecModel) {
        return;
    };
    /**
   * Append data to list
   */ SeriesModel.prototype.appendData = function(params) {
        // FIXME ???
        // (1) If data from dataset, forbidden append.
        // (2) support append data of dataset.
        var data = this.getRawData();
        data.appendData(params.data);
    };
    /**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   */ SeriesModel.prototype.getData = function(dataType) {
        var task = $7c10febb2cdef0d8$var$getCurrentTask(this);
        if (task) {
            var data = task.context.data;
            return dataType == null ? data : data.getLinkedData(dataType);
        } else // When series is not alive (that may happen when click toolbox
        // restore or setOption with not merge mode), series data may
        // be still need to judge animation or something when graphic
        // elements want to know whether fade out.
        return $7c10febb2cdef0d8$var$inner(this).data;
    };
    SeriesModel.prototype.getAllData = function() {
        var mainData = this.getData();
        return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [
            {
                data: mainData
            }
        ];
    };
    SeriesModel.prototype.setData = function(data) {
        var task = $7c10febb2cdef0d8$var$getCurrentTask(this);
        if (task) {
            var context = task.context;
            // Consider case: filter, data sample.
            // FIXME:TS never used, so comment it
            // if (context.data !== data && task.modifyOutputEnd) {
            //     task.setOutputEnd(data.count());
            // }
            context.outputData = data;
            // Caution: setData should update context.data,
            // Because getData may be called multiply in a
            // single stage and expect to get the data just
            // set. (For example, AxisProxy, x y both call
            // getData and setDate sequentially).
            // So the context.data should be fetched from
            // upstream each time when a stage starts to be
            // performed.
            if (task !== this.dataTask) context.data = data;
        }
        $7c10febb2cdef0d8$var$inner(this).data = data;
    };
    SeriesModel.prototype.getEncode = function() {
        var encode = this.get("encode", true);
        if (encode) return $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4(encode);
    };
    SeriesModel.prototype.getSourceManager = function() {
        return $7c10febb2cdef0d8$var$inner(this).sourceManager;
    };
    SeriesModel.prototype.getSource = function() {
        return this.getSourceManager().getSource();
    };
    /**
   * Get data before processed
   */ SeriesModel.prototype.getRawData = function() {
        return $7c10febb2cdef0d8$var$inner(this).dataBeforeProcessed;
    };
    SeriesModel.prototype.getColorBy = function() {
        var colorBy = this.get("colorBy");
        return colorBy || "series";
    };
    SeriesModel.prototype.isColorBySeries = function() {
        return this.getColorBy() === "series";
    };
    /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overridden for some chart.
   * @return {type} description
   */ SeriesModel.prototype.getBaseAxis = function() {
        var coordSys = this.coordinateSystem;
        // @ts-ignore
        return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
    };
    /**
   * Default tooltip formatter
   *
   * @param dataIndex
   * @param multipleSeries
   * @param dataType
   * @param renderMode valid values: 'html'(by default) and 'richText'.
   *        'html' is used for rendering tooltip in extra DOM form, and the result
   *        string is used as DOM HTML content.
   *        'richText' is used for rendering tooltip in rich text form, for those where
   *        DOM operation is not supported.
   * @return formatted tooltip with `html` and `markers`
   *        Notice: The override method can also return string
   */ SeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        return (0, $b0d4c63a14430ca1$export$3a110b9fb5c88b34)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
    };
    SeriesModel.prototype.isAnimationEnabled = function() {
        var ecModel = this.ecModel;
        // Disable animation if using echarts in node but not give ssr flag.
        // In ssr mode, renderToString will generate svg with css animation.
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node && !(ecModel && ecModel.ssr)) return false;
        var animationEnabled = this.getShallow("animation");
        if (animationEnabled) {
            if (this.getData().count() > this.getShallow("animationThreshold")) animationEnabled = false;
        }
        return !!animationEnabled;
    };
    SeriesModel.prototype.restoreData = function() {
        this.dataTask.dirty();
    };
    SeriesModel.prototype.getColorFromPalette = function(name, scope, requestColorNum) {
        var ecModel = this.ecModel;
        // PENDING
        var color = (0, $e7fbd47751ca3c28$export$55a3c39e852b90f4).prototype.getColorFromPalette.call(this, name, scope, requestColorNum);
        if (!color) color = ecModel.getColorFromPalette(name, scope, requestColorNum);
        return color;
    };
    /**
   * Use `data.mapDimensionsAll(coordDim)` instead.
   * @deprecated
   */ SeriesModel.prototype.coordDimToDataDim = function(coordDim) {
        return this.getRawData().mapDimensionsAll(coordDim);
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressive = function() {
        return this.get("progressive");
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressiveThreshold = function() {
        return this.get("progressiveThreshold");
    };
    // PENGING If selectedMode is null ?
    SeriesModel.prototype.select = function(innerDataIndices, dataType) {
        this._innerSelect(this.getData(dataType), innerDataIndices);
    };
    SeriesModel.prototype.unselect = function(innerDataIndices, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return;
        var selectedMode = this.option.selectedMode;
        var data = this.getData(dataType);
        if (selectedMode === "series" || selectedMap === "all") {
            this.option.selectedMap = {};
            this._selectedDataIndicesMap = {};
            return;
        }
        for(var i = 0; i < innerDataIndices.length; i++){
            var dataIndex = innerDataIndices[i];
            var nameOrId = $7c10febb2cdef0d8$var$getSelectionKey(data, dataIndex);
            selectedMap[nameOrId] = false;
            this._selectedDataIndicesMap[nameOrId] = -1;
        }
    };
    SeriesModel.prototype.toggleSelect = function(innerDataIndices, dataType) {
        var tmpArr = [];
        for(var i = 0; i < innerDataIndices.length; i++){
            tmpArr[0] = innerDataIndices[i];
            this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
        }
    };
    SeriesModel.prototype.getSelectedDataIndices = function() {
        if (this.option.selectedMap === "all") return [].slice.call(this.getData().getIndices());
        var selectedDataIndicesMap = this._selectedDataIndicesMap;
        var nameOrIds = $7a1bd9c2710fea0d$export$ed97f33186d4b816(selectedDataIndicesMap);
        var dataIndices = [];
        for(var i = 0; i < nameOrIds.length; i++){
            var dataIndex = selectedDataIndicesMap[nameOrIds[i]];
            if (dataIndex >= 0) dataIndices.push(dataIndex);
        }
        return dataIndices;
    };
    SeriesModel.prototype.isSelected = function(dataIndex, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return false;
        var data = this.getData(dataType);
        return (selectedMap === "all" || selectedMap[$7c10febb2cdef0d8$var$getSelectionKey(data, dataIndex)]) && !data.getItemModel(dataIndex).get([
            "select",
            "disabled"
        ]);
    };
    SeriesModel.prototype.isUniversalTransitionEnabled = function() {
        if (this[$7c10febb2cdef0d8$export$e960441116ae2799]) return true;
        var universalTransitionOpt = this.option.universalTransition;
        // Quick reject
        if (!universalTransitionOpt) return false;
        if (universalTransitionOpt === true) return true;
        // Can be simply 'universalTransition: true'
        return universalTransitionOpt && universalTransitionOpt.enabled;
    };
    SeriesModel.prototype._innerSelect = function(data, innerDataIndices) {
        var _a, _b;
        var option = this.option;
        var selectedMode = option.selectedMode;
        var len = innerDataIndices.length;
        if (!selectedMode || !len) return;
        if (selectedMode === "series") option.selectedMap = "all";
        else if (selectedMode === "multiple") {
            if (!$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(option.selectedMap)) option.selectedMap = {};
            var selectedMap = option.selectedMap;
            for(var i = 0; i < len; i++){
                var dataIndex = innerDataIndices[i];
                // TODO different types of data share same object.
                var nameOrId = $7c10febb2cdef0d8$var$getSelectionKey(data, dataIndex);
                selectedMap[nameOrId] = true;
                this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
            }
        } else if (selectedMode === "single" || selectedMode === true) {
            var lastDataIndex = innerDataIndices[len - 1];
            var nameOrId = $7c10febb2cdef0d8$var$getSelectionKey(data, lastDataIndex);
            option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
            this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
        }
    };
    SeriesModel.prototype._initSelectedMapFromData = function(data) {
        // Ignore select info in data if selectedMap exists.
        // NOTE It's only for legacy usage. edge data is not supported.
        if (this.option.selectedMap) return;
        var dataIndices = [];
        if (data.hasItemOption) data.each(function(idx) {
            var rawItem = data.getRawDataItem(idx);
            if (rawItem && rawItem.selected) dataIndices.push(idx);
        });
        if (dataIndices.length > 0) this._innerSelect(data, dataIndices);
    };
    // /**
    //  * @see {module:echarts/stream/Scheduler}
    //  */
    // abstract pipeTask: null
    SeriesModel.registerClass = function(clz) {
        return (0, $116d65051f61bdfe$export$2e2bcd8739ae039).registerClass(clz);
    };
    SeriesModel.protoInitialize = function() {
        var proto = SeriesModel.prototype;
        proto.type = "series.__base__";
        proto.seriesIndex = 0;
        proto.ignoreStyleOnData = false;
        proto.hasSymbolVisual = false;
        proto.defaultSymbol = "circle";
        // Make sure the values can be accessed!
        proto.visualStyleAccessPath = "itemStyle";
        proto.visualDrawType = "fill";
    }();
    return SeriesModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($7c10febb2cdef0d8$var$SeriesModel, (0, $655dd6075cc63601$export$f23396ae04ea95a7));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($7c10febb2cdef0d8$var$SeriesModel, (0, $e7fbd47751ca3c28$export$55a3c39e852b90f4));
(0, $cd5f95cf03b4e3e7$export$c9c2d87774f1275d)($7c10febb2cdef0d8$var$SeriesModel, (0, $116d65051f61bdfe$export$2e2bcd8739ae039));
/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */ function $7c10febb2cdef0d8$var$autoSeriesName(seriesModel) {
    // User specified name has higher priority, otherwise it may cause
    // series can not be queried unexpectedly.
    var name = seriesModel.name;
    if (!$76d619f648247e6d$export$beae19a2652b3368(seriesModel)) seriesModel.name = $7c10febb2cdef0d8$var$getSeriesAutoName(seriesModel) || name;
}
function $7c10febb2cdef0d8$var$getSeriesAutoName(seriesModel) {
    var data = seriesModel.getRawData();
    var dataDims = data.mapDimensionsAll("seriesName");
    var nameArr = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(dataDims, function(dataDim) {
        var dimInfo = data.getDimensionInfo(dataDim);
        dimInfo.displayName && nameArr.push(dimInfo.displayName);
    });
    return nameArr.join(" ");
}
function $7c10febb2cdef0d8$var$dataTaskCount(context) {
    return context.model.getRawData().count();
}
function $7c10febb2cdef0d8$var$dataTaskReset(context) {
    var seriesModel = context.model;
    seriesModel.setData(seriesModel.getRawData().cloneShallow());
    return $7c10febb2cdef0d8$var$dataTaskProgress;
}
function $7c10febb2cdef0d8$var$dataTaskProgress(param, context) {
    // Avoid repeat cloneShallow when data just created in reset.
    if (context.outputData && param.end > context.outputData.count()) context.model.getRawData().cloneShallow(context.outputData);
}
// TODO refactor
function $7c10febb2cdef0d8$var$wrapData(data, seriesModel) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43($7a1bd9c2710fea0d$export$4fd8af2c48c43416(data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function(methodName) {
        data.wrapMethod(methodName, $7a1bd9c2710fea0d$export$c3095a23b368d1f2($7c10febb2cdef0d8$var$onDataChange, seriesModel));
    });
}
function $7c10febb2cdef0d8$var$onDataChange(seriesModel, newList) {
    var task = $7c10febb2cdef0d8$var$getCurrentTask(seriesModel);
    if (task) // Consider case: filter, selectRange
    task.setOutputEnd((newList || this).count());
    return newList;
}
function $7c10febb2cdef0d8$var$getCurrentTask(seriesModel) {
    var scheduler = (seriesModel.ecModel || {}).scheduler;
    var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
    if (pipeline) {
        // When pipline finished, the currrentTask keep the last
        // task (renderTask).
        var task = pipeline.currentTask;
        if (task) {
            var agentStubMap = task.agentStubMap;
            if (agentStubMap) task = agentStubMap.get(seriesModel.uid);
        }
        return task;
    }
}
var $7c10febb2cdef0d8$export$2e2bcd8739ae039 = $7c10febb2cdef0d8$var$SeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $737c88aa0711f65a$var$ComponentView = /** @class */ function() {
    function ComponentView() {
        this.group = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        this.uid = $5370df662b2caf37$export$6d2b3473b0986646("viewComponent");
    }
    ComponentView.prototype.init = function(ecModel, api) {};
    ComponentView.prototype.render = function(model, ecModel, api, payload) {};
    ComponentView.prototype.dispose = function(ecModel, api) {};
    ComponentView.prototype.updateView = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateLayout = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateVisual = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    /**
   * Hook for toggle blur target series.
   * Can be used in marker for blur or leave blur the markers
   */ ComponentView.prototype.toggleBlurSeries = function(seriesModels, isBlur, ecModel) {
    // Do nothing;
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ComponentView.prototype.eachRendered = function(cb) {
        var group = this.group;
        if (group) group.traverse(cb);
    };
    return ComponentView;
}();
$cd5f95cf03b4e3e7$export$cd4c3a4dca301c70($737c88aa0711f65a$var$ComponentView);
$cd5f95cf03b4e3e7$export$241315e45585454d($737c88aa0711f65a$var$ComponentView);
var $737c88aa0711f65a$export$2e2bcd8739ae039 = $737c88aa0711f65a$var$ComponentView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $cd70075c57b35175$export$2e2bcd8739ae039() {
    var inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
    return function(seriesModel) {
        var fields = inner(seriesModel);
        var pipelineContext = seriesModel.pipelineContext;
        var originalLarge = !!fields.large;
        var originalProgressive = !!fields.progressiveRender;
        // FIXME: if the planner works on a filtered series, `pipelineContext` does not
        // exists. See #11611 . Probably we need to modify this structure, see the comment
        // on `performRawSeries` in `Schedular.js`.
        var large = fields.large = !!(pipelineContext && pipelineContext.large);
        var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
        return !!(originalLarge !== large || originalProgressive !== progressive) && "reset";
    };
}




var $0dc5061053e23cd3$var$inner = $76d619f648247e6d$export$64df9f8d92ae083f();
var $0dc5061053e23cd3$var$renderPlanner = (0, $cd70075c57b35175$export$2e2bcd8739ae039)();
var $0dc5061053e23cd3$var$ChartView = /** @class */ function() {
    function ChartView() {
        this.group = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        this.uid = $5370df662b2caf37$export$6d2b3473b0986646("viewChart");
        this.renderTask = (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
            plan: $0dc5061053e23cd3$var$renderTaskPlan,
            reset: $0dc5061053e23cd3$var$renderTaskReset
        });
        this.renderTask.context = {
            view: this
        };
    }
    ChartView.prototype.init = function(ecModel, api) {};
    ChartView.prototype.render = function(seriesModel, ecModel, api, payload) {};
    /**
   * Highlight series or specified data item.
   */ ChartView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $0dc5061053e23cd3$var$toggleHighlight(data, payload, "emphasis");
    };
    /**
   * Downplay series or specified data item.
   */ ChartView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $0dc5061053e23cd3$var$toggleHighlight(data, payload, "normal");
    };
    /**
   * Remove self.
   */ ChartView.prototype.remove = function(ecModel, api) {
        this.group.removeAll();
    };
    /**
   * Dispose self.
   */ ChartView.prototype.dispose = function(ecModel, api) {};
    ChartView.prototype.updateView = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    // FIXME never used?
    ChartView.prototype.updateLayout = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    // FIXME never used?
    ChartView.prototype.updateVisual = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ChartView.prototype.eachRendered = function(cb) {
        (0, $5b455ae6f843ac47$export$3e564442729bf048)(this.group, cb);
    };
    ChartView.markUpdateMethod = function(payload, methodName) {
        $0dc5061053e23cd3$var$inner(payload).updateMethod = methodName;
    };
    ChartView.protoInitialize = function() {
        var proto = ChartView.prototype;
        proto.type = "chart";
    }();
    return ChartView;
}();
/**
 * Set state of single element
 */ function $0dc5061053e23cd3$var$elSetState(el, state, highlightDigit) {
    if (el && (0, $2bf82c0980125b62$export$77d1445f699c58b5)(el)) (state === "emphasis" ? (0, $2bf82c0980125b62$export$b2d02638cc34c042) : (0, $2bf82c0980125b62$export$11be6f716239ac55))(el, highlightDigit);
}
function $0dc5061053e23cd3$var$toggleHighlight(data, payload, state) {
    var dataIndex = $76d619f648247e6d$export$42b26cae8b8d10(data, payload);
    var highlightDigit = payload && payload.highlightKey != null ? (0, $2bf82c0980125b62$export$824af40eb714530d)(payload.highlightKey) : null;
    if (dataIndex != null) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($76d619f648247e6d$export$4f07b212a02c8051(dataIndex), function(dataIdx) {
        $0dc5061053e23cd3$var$elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
    });
    else data.eachItemGraphicEl(function(el) {
        $0dc5061053e23cd3$var$elSetState(el, state, highlightDigit);
    });
}
$cd5f95cf03b4e3e7$export$cd4c3a4dca301c70($0dc5061053e23cd3$var$ChartView, [
    "dispose"
]);
$cd5f95cf03b4e3e7$export$241315e45585454d($0dc5061053e23cd3$var$ChartView);
function $0dc5061053e23cd3$var$renderTaskPlan(context) {
    return $0dc5061053e23cd3$var$renderPlanner(context.model);
}
function $0dc5061053e23cd3$var$renderTaskReset(context) {
    var seriesModel = context.model;
    var ecModel = context.ecModel;
    var api = context.api;
    var payload = context.payload;
    // FIXME: remove updateView updateVisual
    var progressiveRender = seriesModel.pipelineContext.progressiveRender;
    var view = context.view;
    var updateMethod = payload && $0dc5061053e23cd3$var$inner(payload).updateMethod;
    var methodName = progressiveRender ? "incrementalPrepareRender" : updateMethod && view[updateMethod] ? updateMethod : "render";
    if (methodName !== "render") view[methodName](seriesModel, ecModel, api, payload);
    return $0dc5061053e23cd3$var$progressMethodMap[methodName];
}
var $0dc5061053e23cd3$var$progressMethodMap = {
    incrementalPrepareRender: {
        progress: function(params, context) {
            context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
        }
    },
    render: {
        // Put view.render in `progress` to support appendData. But in this case
        // view.render should not be called in reset, otherwise it will be called
        // twise. Use `forceFirstProgress` to make sure that view.render is called
        // in any cases.
        forceFirstProgress: true,
        progress: function(params, context) {
            context.view.render(context.model, context.ecModel, context.api, context.payload);
        }
    }
};
var $0dc5061053e23cd3$export$2e2bcd8739ae039 = $0dc5061053e23cd3$var$ChartView;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $c98659a9437a3d2e$var$ORIGIN_METHOD = "\0__throttleOriginMethod";
var $c98659a9437a3d2e$var$RATE = "\0__throttleRate";
var $c98659a9437a3d2e$var$THROTTLE_TYPE = "\0__throttleType";
function $c98659a9437a3d2e$export$de363e709c412c8a(fn, delay, debounce) {
    var currCall;
    var lastCall = 0;
    var lastExec = 0;
    var timer = null;
    var diff;
    var scope;
    var args;
    var debounceNextCall;
    delay = delay || 0;
    function exec() {
        lastExec = new Date().getTime();
        timer = null;
        fn.apply(scope, args || []);
    }
    var cb = function() {
        var cbArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)cbArgs[_i] = arguments[_i];
        currCall = new Date().getTime();
        scope = this;
        args = cbArgs;
        var thisDelay = debounceNextCall || delay;
        var thisDebounce = debounceNextCall || debounce;
        debounceNextCall = null;
        diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
        clearTimeout(timer);
        // Here we should make sure that: the `exec` SHOULD NOT be called later
        // than a new call of `cb`, that is, preserving the command order. Consider
        // calculating "scale rate" when roaming as an example. When a call of `cb`
        // happens, either the `exec` is called dierectly, or the call is delayed.
        // But the delayed call should never be later than next call of `cb`. Under
        // this assurance, we can simply update view state each time `dispatchAction`
        // triggered by user roaming, but not need to add extra code to avoid the
        // state being "rolled-back".
        if (thisDebounce) timer = setTimeout(exec, thisDelay);
        else if (diff >= 0) exec();
        else timer = setTimeout(exec, -diff);
        lastCall = currCall;
    };
    /**
   * Clear throttle.
   * @public
   */ cb.clear = function() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };
    /**
   * Enable debounce once.
   */ cb.debounceNextCall = function(debounceDelay) {
        debounceNextCall = debounceDelay;
    };
    return cb;
}
function $c98659a9437a3d2e$export$958e3e1a02eac4b6(obj, fnAttr, rate, throttleType) {
    var fn = obj[fnAttr];
    if (!fn) return;
    var originFn = fn[$c98659a9437a3d2e$var$ORIGIN_METHOD] || fn;
    var lastThrottleType = fn[$c98659a9437a3d2e$var$THROTTLE_TYPE];
    var lastRate = fn[$c98659a9437a3d2e$var$RATE];
    if (lastRate !== rate || lastThrottleType !== throttleType) {
        if (rate == null || !throttleType) return obj[fnAttr] = originFn;
        fn = obj[fnAttr] = $c98659a9437a3d2e$export$de363e709c412c8a(originFn, rate, throttleType === "debounce");
        fn[$c98659a9437a3d2e$var$ORIGIN_METHOD] = originFn;
        fn[$c98659a9437a3d2e$var$THROTTLE_TYPE] = throttleType;
        fn[$c98659a9437a3d2e$var$RATE] = rate;
    }
    return fn;
}
function $c98659a9437a3d2e$export$42ffd38884aecdac(obj, fnAttr) {
    var fn = obj[fnAttr];
    if (fn && fn[$c98659a9437a3d2e$var$ORIGIN_METHOD]) {
        // Clear throttle
        fn.clear && fn.clear();
        obj[fnAttr] = fn[$c98659a9437a3d2e$var$ORIGIN_METHOD];
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $a617f62dd17b10f1$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $a617f62dd17b10f1$var$defaultStyleMappers = {
    itemStyle: (0, $06542048a26d4d91$export$2e2bcd8739ae039)((0, $c42afdfd2f0ddc96$export$ffb0bba5dde0130b), true),
    lineStyle: (0, $06542048a26d4d91$export$2e2bcd8739ae039)((0, $9c5206e1bd69e88f$export$9f34de5b59222949), true)
};
var $a617f62dd17b10f1$var$defaultColorKey = {
    lineStyle: "stroke",
    itemStyle: "fill"
};
function $a617f62dd17b10f1$var$getStyleMapper(seriesModel, stylePath) {
    var styleMapper = seriesModel.visualStyleMapper || $a617f62dd17b10f1$var$defaultStyleMappers[stylePath];
    if (!styleMapper) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return $a617f62dd17b10f1$var$defaultStyleMappers.itemStyle;
    }
    return styleMapper;
}
function $a617f62dd17b10f1$var$getDefaultColorKey(seriesModel, stylePath) {
    // return defaultColorKey[stylePath] ||
    var colorKey = seriesModel.visualDrawType || $a617f62dd17b10f1$var$defaultColorKey[stylePath];
    if (!colorKey) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return "fill";
    }
    return colorKey;
}
var $a617f62dd17b10f1$export$7ce4d65f9b69240 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || "itemStyle";
        // Set in itemStyle
        var styleModel = seriesModel.getModel(stylePath);
        var getStyle = $a617f62dd17b10f1$var$getStyleMapper(seriesModel, stylePath);
        var globalStyle = getStyle(styleModel);
        var decalOption = styleModel.getShallow("decal");
        if (decalOption) {
            data.setVisual("decal", decalOption);
            decalOption.dirty = true;
        }
        // TODO
        var colorKey = $a617f62dd17b10f1$var$getDefaultColorKey(seriesModel, stylePath);
        var color = globalStyle[colorKey];
        // TODO style callback
        var colorCallback = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(color) ? color : null;
        var hasAutoColor = globalStyle.fill === "auto" || globalStyle.stroke === "auto";
        // Get from color palette by default.
        if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
            // Note: If some series has color specified (e.g., by itemStyle.color), we DO NOT
            // make it effect palette. Because some scenarios users need to make some series
            // transparent or as background, which should better not effect the palette.
            var colorPalette = seriesModel.getColorFromPalette(// TODO series count changed.
            seriesModel.name, null, ecModel.getSeriesCount());
            if (!globalStyle[colorKey]) {
                globalStyle[colorKey] = colorPalette;
                data.setVisual("colorFromPalette", true);
            }
            globalStyle.fill = globalStyle.fill === "auto" || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(globalStyle.fill) ? colorPalette : globalStyle.fill;
            globalStyle.stroke = globalStyle.stroke === "auto" || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(globalStyle.stroke) ? colorPalette : globalStyle.stroke;
        }
        data.setVisual("style", globalStyle);
        data.setVisual("drawType", colorKey);
        // Only visible series has each data be visual encoded
        if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
            data.setVisual("colorFromPalette", false);
            return {
                dataEach: function(data, idx) {
                    var dataParams = seriesModel.getDataParams(idx);
                    var itemStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, globalStyle);
                    itemStyle[colorKey] = colorCallback(dataParams);
                    data.setItemVisual(idx, "style", itemStyle);
                }
            };
        }
    }
};
var $a617f62dd17b10f1$var$sharedModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)();
var $a617f62dd17b10f1$export$f7dcb66a065003d1 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (seriesModel.ignoreStyleOnData || ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || "itemStyle";
        // Set in itemStyle
        var getStyle = $a617f62dd17b10f1$var$getStyleMapper(seriesModel, stylePath);
        var colorKey = data.getVisual("drawType");
        return {
            dataEach: data.hasItemOption ? function(data, idx) {
                // Not use getItemModel for performance considuration
                var rawItem = data.getRawDataItem(idx);
                if (rawItem && rawItem[stylePath]) {
                    $a617f62dd17b10f1$var$sharedModel.option = rawItem[stylePath];
                    var style = getStyle($a617f62dd17b10f1$var$sharedModel);
                    var existsStyle = data.ensureUniqueItemVisual(idx, "style");
                    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
                    if ($a617f62dd17b10f1$var$sharedModel.option.decal) {
                        data.setItemVisual(idx, "decal", $a617f62dd17b10f1$var$sharedModel.option.decal);
                        $a617f62dd17b10f1$var$sharedModel.option.decal.dirty = true;
                    }
                    if (colorKey in style) data.setItemVisual(idx, "colorFromPalette", false);
                }
            } : null
        };
    }
};
// Pick color from palette for the data which has not been set with color yet.
// Note: do not support stream rendering. No such cases yet.
var $a617f62dd17b10f1$export$cf9758b0d6dc0aa9 = {
    performRawSeries: true,
    overallReset: function(ecModel) {
        // Each type of series uses one scope.
        // Pie and funnel are using different scopes.
        var paletteScopeGroupByType = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        ecModel.eachSeries(function(seriesModel) {
            var colorBy = seriesModel.getColorBy();
            if (seriesModel.isColorBySeries()) return;
            var key = seriesModel.type + "-" + colorBy;
            var colorScope = paletteScopeGroupByType.get(key);
            if (!colorScope) {
                colorScope = {};
                paletteScopeGroupByType.set(key, colorScope);
            }
            $a617f62dd17b10f1$var$inner(seriesModel).scope = colorScope;
        });
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.isColorBySeries() || ecModel.isSeriesFiltered(seriesModel)) return;
            var dataAll = seriesModel.getRawData();
            var idxMap = {};
            var data = seriesModel.getData();
            var colorScope = $a617f62dd17b10f1$var$inner(seriesModel).scope;
            var stylePath = seriesModel.visualStyleAccessPath || "itemStyle";
            var colorKey = $a617f62dd17b10f1$var$getDefaultColorKey(seriesModel, stylePath);
            data.each(function(idx) {
                var rawIdx = data.getRawIndex(idx);
                idxMap[rawIdx] = idx;
            });
            // Iterate on data before filtered. To make sure color from palette can be
            // Consistent when toggling legend.
            dataAll.each(function(rawIdx) {
                var idx = idxMap[rawIdx];
                var fromPalette = data.getItemVisual(idx, "colorFromPalette");
                // Get color from palette for each data only when the color is inherited from series color, which is
                // also picked from color palette. So following situation is not in the case:
                // 1. series.itemStyle.color is set
                // 2. color is encoded by visualMap
                if (fromPalette) {
                    var itemStyle = data.ensureUniqueItemVisual(idx, "style");
                    var name_1 = dataAll.getName(rawIdx) || rawIdx + "";
                    var dataCount = dataAll.count();
                    itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
                }
            });
        });
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $f23f99c31dceac8f$var$PI = Math.PI;
function $f23f99c31dceac8f$export$2e2bcd8739ae039(api, opts) {
    opts = opts || {};
    $7a1bd9c2710fea0d$export$ebe90cb607ad99e(opts, {
        text: "loading",
        textColor: "#000",
        fontSize: 12,
        fontWeight: "normal",
        fontStyle: "normal",
        fontFamily: "sans-serif",
        maskColor: "rgba(255, 255, 255, 0.8)",
        showSpinner: true,
        color: "#5470c6",
        spinnerRadius: 10,
        lineWidth: 5,
        zlevel: 0
    });
    var group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    var mask = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        style: {
            fill: opts.maskColor
        },
        zlevel: opts.zlevel,
        z: 10000
    });
    group.add(mask);
    var textContent = new $fe885cc21795562b$export$2e2bcd8739ae039({
        style: {
            text: opts.text,
            fill: opts.textColor,
            fontSize: opts.fontSize,
            fontWeight: opts.fontWeight,
            fontStyle: opts.fontStyle,
            fontFamily: opts.fontFamily
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    var labelRect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        style: {
            fill: "none"
        },
        textContent: textContent,
        textConfig: {
            position: "right",
            distance: 10
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    group.add(labelRect);
    var arc;
    if (opts.showSpinner) {
        arc = new $2b5c23eb3597b84a$export$2e2bcd8739ae039({
            shape: {
                startAngle: -$f23f99c31dceac8f$var$PI / 2,
                endAngle: -$f23f99c31dceac8f$var$PI / 2 + 0.1,
                r: opts.spinnerRadius
            },
            style: {
                stroke: opts.color,
                lineCap: "round",
                lineWidth: opts.lineWidth
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        arc.animateShape(true).when(1000, {
            endAngle: $f23f99c31dceac8f$var$PI * 3 / 2
        }).start("circularInOut");
        arc.animateShape(true).when(1000, {
            startAngle: $f23f99c31dceac8f$var$PI * 3 / 2
        }).delay(300).start("circularInOut");
        group.add(arc);
    }
    // Inject resize
    group.resize = function() {
        var textWidth = textContent.getBoundingRect().width;
        var r = opts.showSpinner ? opts.spinnerRadius : 0;
        // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
        // textDistance needs to be calculated when both animation and text exist
        var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2) + (opts.showSpinner ? 0 : textWidth / 2) + (textWidth ? 0 : r);
        var cy = api.getHeight() / 2;
        opts.showSpinner && arc.setShape({
            cx: cx,
            cy: cy
        });
        labelRect.setShape({
            x: cx - r,
            y: cy - r,
            width: r * 2,
            height: r * 2
        });
        mask.setShape({
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        });
    };
    group.resize();
    return group;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $94ae4e8744638a8a$var$Scheduler = /** @class */ function() {
    function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
        // key: handlerUID
        this._stageTaskMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        this.ecInstance = ecInstance;
        this.api = api;
        // Fix current processors in case that in some rear cases that
        // processors might be registered after echarts instance created.
        // Register processors incrementally for a echarts instance is
        // not supported by this stream architecture.
        dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
        visualHandlers = this._visualHandlers = visualHandlers.slice();
        this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
    }
    Scheduler.prototype.restoreData = function(ecModel, payload) {
        // TODO: Only restore needed series and components, but not all components.
        // Currently `restoreData` of all of the series and component will be called.
        // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
        // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
        // and some components like coordinate system, axes, dataZoom, visualMap only
        // need their target series refresh.
        // (1) If we are implementing this feature some day, we should consider these cases:
        // if a data processor depends on a component (e.g., dataZoomProcessor depends
        // on the settings of `dataZoom`), it should be re-performed if the component
        // is modified by `setOption`.
        // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
        // it should be re-performed when the result array of `getTargetSeries` changed.
        // We use `dependencies` to cover these issues.
        // (3) How to update target series when coordinate system related components modified.
        // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
        // and this case all of the tasks will be set as dirty.
        ecModel.restoreData(payload);
        // Theoretically an overall task not only depends on each of its target series, but also
        // depends on all of the series.
        // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
        // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
        // that the overall task is set as dirty and to be performed, otherwise it probably cause
        // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
        // probably cause state chaos (consider `dataZoomProcessor`).
        this._stageTaskMap.each(function(taskRecord) {
            var overallTask = taskRecord.overallTask;
            overallTask && overallTask.dirty();
        });
    };
    // If seriesModel provided, incremental threshold is check by series data.
    Scheduler.prototype.getPerformArgs = function(task, isBlock) {
        // For overall task
        if (!task.__pipeline) return;
        var pipeline = this._pipelineMap.get(task.__pipeline.id);
        var pCtx = pipeline.context;
        var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
        var step = incremental ? pipeline.step : null;
        var modDataCount = pCtx && pCtx.modDataCount;
        var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
        return {
            step: step,
            modBy: modBy,
            modDataCount: modDataCount
        };
    };
    Scheduler.prototype.getPipeline = function(pipelineId) {
        return this._pipelineMap.get(pipelineId);
    };
    /**
   * Current, progressive rendering starts from visual and layout.
   * Always detect render mode in the same stage, avoiding that incorrect
   * detection caused by data filtering.
   * Caution:
   * `updateStreamModes` use `seriesModel.getData()`.
   */ Scheduler.prototype.updateStreamModes = function(seriesModel, view) {
        var pipeline = this._pipelineMap.get(seriesModel.uid);
        var data = seriesModel.getData();
        var dataLen = data.count();
        // `progressiveRender` means that can render progressively in each
        // animation frame. Note that some types of series do not provide
        // `view.incrementalPrepareRender` but support `chart.appendData`. We
        // use the term `incremental` but not `progressive` to describe the
        // case that `chart.appendData`.
        var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
        var large = seriesModel.get("large") && dataLen >= seriesModel.get("largeThreshold");
        // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
        // see `test/candlestick-large3.html`
        var modDataCount = seriesModel.get("progressiveChunkMode") === "mod" ? dataLen : null;
        seriesModel.pipelineContext = pipeline.context = {
            progressiveRender: progressiveRender,
            modDataCount: modDataCount,
            large: large
        };
    };
    Scheduler.prototype.restorePipelines = function(ecModel) {
        var scheduler = this;
        var pipelineMap = scheduler._pipelineMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        ecModel.eachSeries(function(seriesModel) {
            var progressive = seriesModel.getProgressive();
            var pipelineId = seriesModel.uid;
            pipelineMap.set(pipelineId, {
                id: pipelineId,
                head: null,
                tail: null,
                threshold: seriesModel.getProgressiveThreshold(),
                progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
                blockIndex: -1,
                step: Math.round(progressive || 700),
                count: 0
            });
            scheduler._pipe(seriesModel, seriesModel.dataTask);
        });
    };
    Scheduler.prototype.prepareStageTasks = function() {
        var stageTaskMap = this._stageTaskMap;
        var ecModel = this.api.getModel();
        var api = this.api;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._allHandlers, function(handler) {
            var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
            var errMsg = "";
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!(handler.reset && handler.overallReset), errMsg);
            handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
            handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
        }, this);
    };
    Scheduler.prototype.prepareView = function(view, model, ecModel, api) {
        var renderTask = view.renderTask;
        var context = renderTask.context;
        context.model = model;
        context.ecModel = ecModel;
        context.api = api;
        renderTask.__block = !view.incrementalPrepareRender;
        this._pipe(model, renderTask);
    };
    Scheduler.prototype.performDataProcessorTasks = function(ecModel, payload) {
        // If we do not use `block` here, it should be considered when to update modes.
        this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
            block: true
        });
    };
    Scheduler.prototype.performVisualTasks = function(ecModel, payload, opt) {
        this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
    };
    Scheduler.prototype._performStageTasks = function(stageHandlers, ecModel, payload, opt) {
        opt = opt || {};
        var unfinished = false;
        var scheduler = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stageHandlers, function(stageHandler, idx) {
            if (opt.visualType && opt.visualType !== stageHandler.visualType) return;
            var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
            var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
            var overallTask = stageHandlerRecord.overallTask;
            if (overallTask) {
                var overallNeedDirty_1;
                var agentStubMap = overallTask.agentStubMap;
                agentStubMap.each(function(stub) {
                    if (needSetDirty(opt, stub)) {
                        stub.dirty();
                        overallNeedDirty_1 = true;
                    }
                });
                overallNeedDirty_1 && overallTask.dirty();
                scheduler.updatePayload(overallTask, payload);
                var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block);
                // Execute stubs firstly, which may set the overall task dirty,
                // then execute the overall task. And stub will call seriesModel.setData,
                // which ensures that in the overallTask seriesModel.getData() will not
                // return incorrect data.
                agentStubMap.each(function(stub) {
                    stub.perform(performArgs_1);
                });
                if (overallTask.perform(performArgs_1)) unfinished = true;
            } else if (seriesTaskMap) seriesTaskMap.each(function(task, pipelineId) {
                if (needSetDirty(opt, task)) task.dirty();
                var performArgs = scheduler.getPerformArgs(task, opt.block);
                // FIXME
                // if intending to declare `performRawSeries` in handlers, only
                // stream-independent (specifically, data item independent) operations can be
                // performed. Because if a series is filtered, most of the tasks will not
                // be performed. A stream-dependent operation probably cause wrong biz logic.
                // Perhaps we should not provide a separate callback for this case instead
                // of providing the config `performRawSeries`. The stream-dependent operations
                // and stream-independent operations should better not be mixed.
                performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
                scheduler.updatePayload(task, payload);
                if (task.perform(performArgs)) unfinished = true;
            });
        });
        function needSetDirty(opt, task) {
            return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
        }
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.performSeriesTasks = function(ecModel) {
        var unfinished;
        ecModel.eachSeries(function(seriesModel) {
            // Progress to the end for dataInit and dataRestore.
            unfinished = seriesModel.dataTask.perform() || unfinished;
        });
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.plan = function() {
        // Travel pipelines, check block.
        this._pipelineMap.each(function(pipeline) {
            var task = pipeline.tail;
            do {
                if (task.__block) {
                    pipeline.blockIndex = task.__idxInPipeline;
                    break;
                }
                task = task.getUpstream();
            }while (task);
        });
    };
    Scheduler.prototype.updatePayload = function(task, payload) {
        payload !== "remain" && (task.context.payload = payload);
    };
    Scheduler.prototype._createSeriesStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
        // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
        // it works but it may cause other irrelevant charts blocked.
        if (stageHandler.createOnAllSeries) ecModel.eachRawSeries(create);
        else if (seriesType) ecModel.eachRawSeriesByType(seriesType, create);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(create);
        function create(seriesModel) {
            var pipelineId = seriesModel.uid;
            // Init tasks for each seriesModel only once.
            // Reuse original task instance.
            var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
                plan: $94ae4e8744638a8a$var$seriesTaskPlan,
                reset: $94ae4e8744638a8a$var$seriesTaskReset,
                count: $94ae4e8744638a8a$var$seriesTaskCount
            }));
            task.context = {
                model: seriesModel,
                ecModel: ecModel,
                api: api,
                // PENDING: `useClearVisual` not used?
                useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
                plan: stageHandler.plan,
                reset: stageHandler.reset,
                scheduler: scheduler
            };
            scheduler._pipe(seriesModel, task);
        }
    };
    Scheduler.prototype._createOverallStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask || (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
            reset: $94ae4e8744638a8a$var$overallTaskReset
        });
        overallTask.context = {
            ecModel: ecModel,
            api: api,
            overallReset: stageHandler.overallReset,
            scheduler: scheduler
        };
        var oldAgentStubMap = overallTask.agentStubMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newAgentStubMap = overallTask.agentStubMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        var overallProgress = true;
        var shouldOverallTaskDirty = false;
        // FIXME:TS never used, so comment it
        // let modifyOutputEnd = stageHandler.modifyOutputEnd;
        // An overall task with seriesType detected or has `getTargetSeries`, we add
        // stub in each pipelines, it will set the overall task dirty when the pipeline
        // progress. Moreover, to avoid call the overall task each frame (too frequent),
        // we set the pipeline block.
        var errMsg = "";
        (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(!stageHandler.createOnAllSeries, errMsg);
        if (seriesType) ecModel.eachRawSeriesByType(seriesType, createStub);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(createStub);
        else {
            overallProgress = false;
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ecModel.getSeries(), createStub);
        }
        function createStub(seriesModel) {
            var pipelineId = seriesModel.uid;
            var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || // When the result of `getTargetSeries` changed, the overallTask
            // should be set as dirty and re-performed.
            (shouldOverallTaskDirty = true, (0, $4d16404c851dcec6$export$f7292ab7796be73c)({
                reset: $94ae4e8744638a8a$var$stubReset,
                onDirty: $94ae4e8744638a8a$var$stubOnDirty
            })));
            stub.context = {
                model: seriesModel,
                overallProgress: overallProgress
            };
            stub.agent = overallTask;
            stub.__block = overallProgress;
            scheduler._pipe(seriesModel, stub);
        }
        if (shouldOverallTaskDirty) overallTask.dirty();
    };
    Scheduler.prototype._pipe = function(seriesModel, task) {
        var pipelineId = seriesModel.uid;
        var pipeline = this._pipelineMap.get(pipelineId);
        !pipeline.head && (pipeline.head = task);
        pipeline.tail && pipeline.tail.pipe(task);
        pipeline.tail = task;
        task.__idxInPipeline = pipeline.count++;
        task.__pipeline = pipeline;
    };
    Scheduler.wrapStageHandler = function(stageHandler, visualType) {
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(stageHandler)) stageHandler = {
            overallReset: stageHandler,
            seriesType: $94ae4e8744638a8a$var$detectSeriseType(stageHandler)
        };
        stageHandler.uid = (0, $5370df662b2caf37$export$6d2b3473b0986646)("stageHandler");
        visualType && (stageHandler.visualType = visualType);
        return stageHandler;
    };
    return Scheduler;
}();
function $94ae4e8744638a8a$var$overallTaskReset(context) {
    context.overallReset(context.ecModel, context.api, context.payload);
}
function $94ae4e8744638a8a$var$stubReset(context) {
    return context.overallProgress && $94ae4e8744638a8a$var$stubProgress;
}
function $94ae4e8744638a8a$var$stubProgress() {
    this.agent.dirty();
    this.getDownstream().dirty();
}
function $94ae4e8744638a8a$var$stubOnDirty() {
    this.agent && this.agent.dirty();
}
function $94ae4e8744638a8a$var$seriesTaskPlan(context) {
    return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
}
function $94ae4e8744638a8a$var$seriesTaskReset(context) {
    if (context.useClearVisual) context.data.clearAllVisual();
    var resetDefines = context.resetDefines = (0, $76d619f648247e6d$export$4f07b212a02c8051)(context.reset(context.model, context.ecModel, context.api, context.payload));
    return resetDefines.length > 1 ? (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(resetDefines, function(v, idx) {
        return $94ae4e8744638a8a$var$makeSeriesTaskProgress(idx);
    }) : $94ae4e8744638a8a$var$singleSeriesTaskProgress;
}
var $94ae4e8744638a8a$var$singleSeriesTaskProgress = $94ae4e8744638a8a$var$makeSeriesTaskProgress(0);
function $94ae4e8744638a8a$var$makeSeriesTaskProgress(resetDefineIdx) {
    return function(params, context) {
        var data = context.data;
        var resetDefine = context.resetDefines[resetDefineIdx];
        if (resetDefine && resetDefine.dataEach) for(var i = params.start; i < params.end; i++)resetDefine.dataEach(data, i);
        else if (resetDefine && resetDefine.progress) resetDefine.progress(params, data);
    };
}
function $94ae4e8744638a8a$var$seriesTaskCount(context) {
    return context.data.count();
}
/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */ function $94ae4e8744638a8a$var$detectSeriseType(legacyFunc) {
    $94ae4e8744638a8a$var$seriesType = null;
    try {
        // Assume there is no async when calling `eachSeriesByType`.
        legacyFunc($94ae4e8744638a8a$var$ecModelMock, $94ae4e8744638a8a$var$apiMock);
    } catch (e) {}
    return $94ae4e8744638a8a$var$seriesType;
}
var $94ae4e8744638a8a$var$ecModelMock = {};
var $94ae4e8744638a8a$var$apiMock = {};
var $94ae4e8744638a8a$var$seriesType;
$94ae4e8744638a8a$var$mockMethods($94ae4e8744638a8a$var$ecModelMock, (0, $51f6ef0dd9546916$export$2e2bcd8739ae039));
$94ae4e8744638a8a$var$mockMethods($94ae4e8744638a8a$var$apiMock, (0, $a6d7e6163195660e$export$2e2bcd8739ae039));
$94ae4e8744638a8a$var$ecModelMock.eachSeriesByType = $94ae4e8744638a8a$var$ecModelMock.eachRawSeriesByType = function(type) {
    $94ae4e8744638a8a$var$seriesType = type;
};
$94ae4e8744638a8a$var$ecModelMock.eachComponent = function(cond) {
    if (cond.mainType === "series" && cond.subType) $94ae4e8744638a8a$var$seriesType = cond.subType;
};
function $94ae4e8744638a8a$var$mockMethods(target, Clz) {
    /* eslint-disable */ for(var name_1 in Clz.prototype)// Do not use hasOwnProperty
    target[name_1] = (0, $7a1bd9c2710fea0d$export$8793edee2d425525);
/* eslint-enable */ }
var $94ae4e8744638a8a$export$2e2bcd8739ae039 = $94ae4e8744638a8a$var$Scheduler;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $0e5dbddd76825050$var$colorAll = [
    "#37A2DA",
    "#32C5E9",
    "#67E0E3",
    "#9FE6B8",
    "#FFDB5C",
    "#ff9f7f",
    "#fb7293",
    "#E062AE",
    "#E690D1",
    "#e7bcf3",
    "#9d96f5",
    "#8378EA",
    "#96BFFF"
];
var $0e5dbddd76825050$export$2e2bcd8739ae039 = {
    color: $0e5dbddd76825050$var$colorAll,
    colorLayer: [
        [
            "#37A2DA",
            "#ffd85c",
            "#fd7b5f"
        ],
        [
            "#37A2DA",
            "#67E0E3",
            "#FFDB5C",
            "#ff9f7f",
            "#E062AE",
            "#9d96f5"
        ],
        [
            "#37A2DA",
            "#32C5E9",
            "#9FE6B8",
            "#FFDB5C",
            "#ff9f7f",
            "#fb7293",
            "#e7bcf3",
            "#8378EA",
            "#96BFFF"
        ],
        $0e5dbddd76825050$var$colorAll
    ]
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $985c98ffd51c6ff6$var$contrastColor = "#B9B8CE";
var $985c98ffd51c6ff6$var$backgroundColor = "#100C2A";
var $985c98ffd51c6ff6$var$axisCommon = function() {
    return {
        axisLine: {
            lineStyle: {
                color: $985c98ffd51c6ff6$var$contrastColor
            }
        },
        splitLine: {
            lineStyle: {
                color: "#484753"
            }
        },
        splitArea: {
            areaStyle: {
                color: [
                    "rgba(255,255,255,0.02)",
                    "rgba(255,255,255,0.05)"
                ]
            }
        },
        minorSplitLine: {
            lineStyle: {
                color: "#20203B"
            }
        }
    };
};
var $985c98ffd51c6ff6$var$colorPalette = [
    "#4992ff",
    "#7cffb2",
    "#fddd60",
    "#ff6e76",
    "#58d9f9",
    "#05c091",
    "#ff8a45",
    "#8d48e3",
    "#dd79ff"
];
var $985c98ffd51c6ff6$var$theme = {
    darkMode: true,
    color: $985c98ffd51c6ff6$var$colorPalette,
    backgroundColor: $985c98ffd51c6ff6$var$backgroundColor,
    axisPointer: {
        lineStyle: {
            color: "#817f91"
        },
        crossStyle: {
            color: "#817f91"
        },
        label: {
            // TODO Contrast of label backgorundColor
            color: "#fff"
        }
    },
    legend: {
        textStyle: {
            color: $985c98ffd51c6ff6$var$contrastColor
        }
    },
    textStyle: {
        color: $985c98ffd51c6ff6$var$contrastColor
    },
    title: {
        textStyle: {
            color: "#EEF1FA"
        },
        subtextStyle: {
            color: "#B9B8CE"
        }
    },
    toolbox: {
        iconStyle: {
            borderColor: $985c98ffd51c6ff6$var$contrastColor
        }
    },
    dataZoom: {
        borderColor: "#71708A",
        textStyle: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        brushStyle: {
            color: "rgba(135,163,206,0.3)"
        },
        handleStyle: {
            color: "#353450",
            borderColor: "#C5CBE3"
        },
        moveHandleStyle: {
            color: "#B0B6C3",
            opacity: 0.3
        },
        fillerColor: "rgba(135,163,206,0.2)",
        emphasis: {
            handleStyle: {
                borderColor: "#91B7F2",
                color: "#4D587D"
            },
            moveHandleStyle: {
                color: "#636D9A",
                opacity: 0.7
            }
        },
        dataBackground: {
            lineStyle: {
                color: "#71708A",
                width: 1
            },
            areaStyle: {
                color: "#71708A"
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: "#87A3CE"
            },
            areaStyle: {
                color: "#87A3CE"
            }
        }
    },
    visualMap: {
        textStyle: {
            color: $985c98ffd51c6ff6$var$contrastColor
        }
    },
    timeline: {
        lineStyle: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        label: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        controlStyle: {
            color: $985c98ffd51c6ff6$var$contrastColor,
            borderColor: $985c98ffd51c6ff6$var$contrastColor
        }
    },
    calendar: {
        itemStyle: {
            color: $985c98ffd51c6ff6$var$backgroundColor
        },
        dayLabel: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        monthLabel: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        yearLabel: {
            color: $985c98ffd51c6ff6$var$contrastColor
        }
    },
    timeAxis: $985c98ffd51c6ff6$var$axisCommon(),
    logAxis: $985c98ffd51c6ff6$var$axisCommon(),
    valueAxis: $985c98ffd51c6ff6$var$axisCommon(),
    categoryAxis: $985c98ffd51c6ff6$var$axisCommon(),
    line: {
        symbol: "circle"
    },
    graph: {
        color: $985c98ffd51c6ff6$var$colorPalette
    },
    gauge: {
        title: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        axisLine: {
            lineStyle: {
                color: [
                    [
                        1,
                        "rgba(207,212,219,0.2)"
                    ]
                ]
            }
        },
        axisLabel: {
            color: $985c98ffd51c6ff6$var$contrastColor
        },
        detail: {
            color: "#EEF1FA"
        }
    },
    candlestick: {
        itemStyle: {
            color: "#f64e56",
            color0: "#54ea92",
            borderColor: "#f64e56",
            borderColor0: "#54ea92"
        }
    }
};
$985c98ffd51c6ff6$var$theme.categoryAxis.splitLine.show = false;
var $985c98ffd51c6ff6$export$2e2bcd8739ae039 = $985c98ffd51c6ff6$var$theme;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Usage of query:
 * `chart.on('click', query, handler);`
 * The `query` can be:
 * + The component type query string, only `mainType` or `mainType.subType`,
 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
 * + The component query object, like:
 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
 * + The data query object, like:
 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
 * + The other query object (cmponent customized query), like:
 *   `{element: 'some'}` (only available in custom series).
 *
 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
 * same as there is no such prop in the `query` object.
 */ var $82d62ed69f6abce3$export$d0fd09f950257b52 = /** @class */ function() {
    function ECEventProcessor() {}
    ECEventProcessor.prototype.normalizeQuery = function(query) {
        var cptQuery = {};
        var dataQuery = {};
        var otherQuery = {};
        // `query` is `mainType` or `mainType.subType` of component.
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(query)) {
            var condCptType = (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(query);
            // `.main` and `.sub` may be ''.
            cptQuery.mainType = condCptType.main || null;
            cptQuery.subType = condCptType.sub || null;
        } else {
            // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
            // can not be used in `compomentModel.filterForExposedEvent`.
            var suffixes_1 = [
                "Index",
                "Name",
                "Id"
            ];
            var dataKeys_1 = {
                name: 1,
                dataIndex: 1,
                dataType: 1
            };
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(query, function(val, key) {
                var reserved = false;
                for(var i = 0; i < suffixes_1.length; i++){
                    var propSuffix = suffixes_1[i];
                    var suffixPos = key.lastIndexOf(propSuffix);
                    if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
                        var mainType = key.slice(0, suffixPos);
                        // Consider `dataIndex`.
                        if (mainType !== "data") {
                            cptQuery.mainType = mainType;
                            cptQuery[propSuffix.toLowerCase()] = val;
                            reserved = true;
                        }
                    }
                }
                if (dataKeys_1.hasOwnProperty(key)) {
                    dataQuery[key] = val;
                    reserved = true;
                }
                if (!reserved) otherQuery[key] = val;
            });
        }
        return {
            cptQuery: cptQuery,
            dataQuery: dataQuery,
            otherQuery: otherQuery
        };
    };
    ECEventProcessor.prototype.filter = function(eventType, query) {
        // They should be assigned before each trigger call.
        var eventInfo = this.eventInfo;
        if (!eventInfo) return true;
        var targetEl = eventInfo.targetEl;
        var packedEvent = eventInfo.packedEvent;
        var model = eventInfo.model;
        var view = eventInfo.view;
        // For event like 'globalout'.
        if (!model || !view) return true;
        var cptQuery = query.cptQuery;
        var dataQuery = query.dataQuery;
        return check(cptQuery, model, "mainType") && check(cptQuery, model, "subType") && check(cptQuery, model, "index", "componentIndex") && check(cptQuery, model, "name") && check(cptQuery, model, "id") && check(dataQuery, packedEvent, "name") && check(dataQuery, packedEvent, "dataIndex") && check(dataQuery, packedEvent, "dataType") && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
        function check(query, host, prop, propOnHost) {
            return query[prop] == null || host[propOnHost || prop] === query[prop];
        }
    };
    ECEventProcessor.prototype.afterTrigger = function() {
        // Make sure the eventInfo won't be used in next trigger.
        this.eventInfo = null;
    };
    return ECEventProcessor;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $f8e1f1a448782588$var$SYMBOL_PROPS_WITH_CB = [
    "symbol",
    "symbolSize",
    "symbolRotate",
    "symbolOffset"
];
var $f8e1f1a448782588$var$SYMBOL_PROPS = $f8e1f1a448782588$var$SYMBOL_PROPS_WITH_CB.concat([
    "symbolKeepAspect"
]);
// Encoding visual for all series include which is filtered for legend drawing
var $f8e1f1a448782588$export$144ac3beded415d9 = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        if (seriesModel.legendIcon) data.setVisual("legendIcon", seriesModel.legendIcon);
        if (!seriesModel.hasSymbolVisual) return;
        var symbolOptions = {};
        var symbolOptionsCb = {};
        var hasCallback = false;
        for(var i = 0; i < $f8e1f1a448782588$var$SYMBOL_PROPS_WITH_CB.length; i++){
            var symbolPropName = $f8e1f1a448782588$var$SYMBOL_PROPS_WITH_CB[i];
            var val = seriesModel.get(symbolPropName);
            if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(val)) {
                hasCallback = true;
                symbolOptionsCb[symbolPropName] = val;
            } else symbolOptions[symbolPropName] = val;
        }
        symbolOptions.symbol = symbolOptions.symbol || seriesModel.defaultSymbol;
        data.setVisual((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            legendIcon: seriesModel.legendIcon || symbolOptions.symbol,
            symbolKeepAspect: seriesModel.get("symbolKeepAspect")
        }, symbolOptions));
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var symbolPropsCb = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(symbolOptionsCb);
        function dataEach(data, idx) {
            var rawValue = seriesModel.getRawValue(idx);
            var params = seriesModel.getDataParams(idx);
            for(var i = 0; i < symbolPropsCb.length; i++){
                var symbolPropName = symbolPropsCb[i];
                data.setItemVisual(idx, symbolPropName, symbolOptionsCb[symbolPropName](rawValue, params));
            }
        }
        return {
            dataEach: hasCallback ? dataEach : null
        };
    }
};
var $f8e1f1a448782588$export$435b956f7f1071fb = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (!seriesModel.hasSymbolVisual) return;
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            for(var i = 0; i < $f8e1f1a448782588$var$SYMBOL_PROPS.length; i++){
                var symbolPropName = $f8e1f1a448782588$var$SYMBOL_PROPS[i];
                var val = itemModel.getShallow(symbolPropName, true);
                if (val != null) data.setItemVisual(idx, symbolPropName, val);
            }
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $ea13f1ab2169d82d$export$91d919a86b2df624(data, dataIndex, key) {
    switch(key){
        case "color":
            var style = data.getItemVisual(dataIndex, "style");
            return style[data.getVisual("drawType")];
        case "opacity":
            return data.getItemVisual(dataIndex, "style").opacity;
        case "symbol":
        case "symbolSize":
        case "liftZ":
            return data.getItemVisual(dataIndex, key);
        default:
    }
}
function $ea13f1ab2169d82d$export$d76e333a86ea1a2(data, key) {
    switch(key){
        case "color":
            var style = data.getVisual("style");
            return style[data.getVisual("drawType")];
        case "opacity":
            return data.getVisual("style").opacity;
        case "symbol":
        case "symbolSize":
        case "liftZ":
            return data.getVisual(key);
        default:
    }
}
function $ea13f1ab2169d82d$export$3aab879e9d0e7c75(data, dataIndex, key, value) {
    switch(key){
        case "color":
            // Make sure not sharing style object.
            var style = data.ensureUniqueItemVisual(dataIndex, "style");
            style[data.getVisual("drawType")] = value;
            // Mark the color has been changed, not from palette anymore
            data.setItemVisual(dataIndex, "colorFromPalette", false);
            break;
        case "opacity":
            data.ensureUniqueItemVisual(dataIndex, "style").opacity = value;
            break;
        case "symbol":
        case "symbolSize":
        case "liftZ":
            data.setItemVisual(dataIndex, key, value);
            break;
        default:
    }
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $e855ccf7eff48bce$export$62942ba95693dbfc(seriesType, ecRegisterAction) {
    function getSeriesIndices(ecModel, payload) {
        var seriesIndices = [];
        ecModel.eachComponent({
            mainType: "series",
            subType: seriesType,
            query: payload
        }, function(seriesModel) {
            seriesIndices.push(seriesModel.seriesIndex);
        });
        return seriesIndices;
    }
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        [
            seriesType + "ToggleSelect",
            "toggleSelect"
        ],
        [
            seriesType + "Select",
            "select"
        ],
        [
            seriesType + "UnSelect",
            "unselect"
        ]
    ], function(eventsMap) {
        ecRegisterAction(eventsMap[0], function(payload, ecModel, api) {
            payload = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, payload);
            api.dispatchAction((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(payload, {
                type: eventsMap[1],
                seriesIndex: getSeriesIndices(ecModel, payload)
            }));
        });
    });
}
function $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
    var legacyEventName = type + eventPostfix;
    if (!ecIns.isSilent(legacyEventName)) ecModel.eachComponent({
        mainType: "series",
        subType: "pie"
    }, function(seriesModel) {
        var seriesIndex = seriesModel.seriesIndex;
        var selectedMap = seriesModel.option.selectedMap;
        var selected = payload.selected;
        for(var i = 0; i < selected.length; i++)if (selected[i].seriesIndex === seriesIndex) {
            var data = seriesModel.getData();
            var dataIndex = (0, $76d619f648247e6d$export$42b26cae8b8d10)(data, payload.fromActionPayload);
            ecIns.trigger(legacyEventName, {
                type: legacyEventName,
                seriesId: seriesModel.id,
                name: (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
                selected: (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(selectedMap) ? selectedMap : (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, selectedMap)
            });
        }
    });
}
function $e855ccf7eff48bce$export$2575c83262e49d0c(messageCenter, ecIns, api) {
    messageCenter.on("selectchanged", function(params) {
        var ecModel = api.getModel();
        if (params.isFromClick) {
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents("map", "selectchanged", ecIns, ecModel, params);
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents("pie", "selectchanged", ecIns, ecModel, params);
        } else if (params.fromAction === "select") {
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents("map", "selected", ecIns, ecModel, params);
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents("pie", "selected", ecIns, ecModel, params);
        } else if (params.fromAction === "unselect") {
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents("map", "unselected", ecIns, ecModel, params);
            $e855ccf7eff48bce$var$handleSeriesLegacySelectEvents("pie", "unselected", ecIns, ecModel, params);
        }
    });
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $808c5a2823518f68$export$8a4fca9e04eb4df6(target, det, returnFirstMatch) {
    var found;
    while(target){
        if (det(target)) {
            found = target;
            if (returnFirstMatch) break;
        }
        target = target.__hostTarget || target.parent;
    }
    return found;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $56aadf5b08ec1b47$var$wmUniqueIndex = Math.round(Math.random() * 9);
var $56aadf5b08ec1b47$var$supportDefineProperty = typeof Object.defineProperty === "function";
var $56aadf5b08ec1b47$var$WeakMap = function() {
    function WeakMap() {
        this._id = "__ec_inner_" + $56aadf5b08ec1b47$var$wmUniqueIndex++;
    }
    WeakMap.prototype.get = function(key) {
        return this._guard(key)[this._id];
    };
    WeakMap.prototype.set = function(key, value) {
        var target = this._guard(key);
        if ($56aadf5b08ec1b47$var$supportDefineProperty) Object.defineProperty(target, this._id, {
            value: value,
            enumerable: false,
            configurable: true
        });
        else target[this._id] = value;
        return this;
    };
    WeakMap.prototype["delete"] = function(key) {
        if (this.has(key)) {
            delete this._guard(key)[this._id];
            return true;
        }
        return false;
    };
    WeakMap.prototype.has = function(key) {
        return !!this._guard(key)[this._id];
    };
    WeakMap.prototype._guard = function(key) {
        if (key !== Object(key)) throw TypeError("Value of WeakMap is not a non-null object.");
        return key;
    };
    return WeakMap;
}();
var $56aadf5b08ec1b47$export$2e2bcd8739ae039 = $56aadf5b08ec1b47$var$WeakMap;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Symbol factory





/**
 * Triangle shape
 * @inner
 */ var $5370466dadc978d7$var$Triangle = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: "triangle",
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy + height);
        path.lineTo(cx - width, cy + height);
        path.closePath();
    }
});
/**
 * Diamond shape
 * @inner
 */ var $5370466dadc978d7$var$Diamond = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: "diamond",
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy);
        path.lineTo(cx, cy + height);
        path.lineTo(cx - width, cy);
        path.closePath();
    }
});
/**
 * Pin shape
 * @inner
 */ var $5370466dadc978d7$var$Pin = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: "pin",
    shape: {
        // x, y on the cusp
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var x = shape.x;
        var y = shape.y;
        var w = shape.width / 5 * 3;
        // Height must be larger than width
        var h = Math.max(w, shape.height);
        var r = w / 2;
        // Dist on y with tangent point and circle center
        var dy = r * r / (h - r);
        var cy = y - h + r + dy;
        var angle = Math.asin(dy / r);
        // Dist on x with tangent point and circle center
        var dx = Math.cos(angle) * r;
        var tanX = Math.sin(angle);
        var tanY = Math.cos(angle);
        var cpLen = r * 0.6;
        var cpLen2 = r * 0.7;
        path.moveTo(x - dx, cy + dy);
        path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
        path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
        path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
        path.closePath();
    }
});
/**
 * Arrow shape
 * @inner
 */ var $5370466dadc978d7$var$Arrow = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: "arrow",
    shape: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(ctx, shape) {
        var height = shape.height;
        var width = shape.width;
        var x = shape.x;
        var y = shape.y;
        var dx = width / 3 * 2;
        ctx.moveTo(x, y);
        ctx.lineTo(x + dx, y + height);
        ctx.lineTo(x, y + height / 4 * 3);
        ctx.lineTo(x - dx, y + height);
        ctx.lineTo(x, y);
        ctx.closePath();
    }
});
/**
 * Map of path constructors
 */ // TODO Use function to build symbol path.
var $5370466dadc978d7$var$symbolCtors = {
    line: $7a316ae5ceff7b27$export$2e2bcd8739ae039,
    rect: $419e5ff2f303755e$export$2e2bcd8739ae039,
    roundRect: $419e5ff2f303755e$export$2e2bcd8739ae039,
    square: $419e5ff2f303755e$export$2e2bcd8739ae039,
    circle: $1e68d8727773abb7$export$2e2bcd8739ae039,
    diamond: $5370466dadc978d7$var$Diamond,
    pin: $5370466dadc978d7$var$Pin,
    arrow: $5370466dadc978d7$var$Arrow,
    triangle: $5370466dadc978d7$var$Triangle
};
var $5370466dadc978d7$var$symbolShapeMakers = {
    line: function(x, y, w, h, shape) {
        shape.x1 = x;
        shape.y1 = y + h / 2;
        shape.x2 = x + w;
        shape.y2 = y + h / 2;
    },
    rect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
    },
    roundRect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
        shape.r = Math.min(w, h) / 4;
    },
    square: function(x, y, w, h, shape) {
        var size = Math.min(w, h);
        shape.x = x;
        shape.y = y;
        shape.width = size;
        shape.height = size;
    },
    circle: function(x, y, w, h, shape) {
        // Put circle in the center of square
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.r = Math.min(w, h) / 2;
    },
    diamond: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    pin: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    arrow: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    triangle: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    }
};
var $5370466dadc978d7$export$33fc3b478d332725 = {};
(0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($5370466dadc978d7$var$symbolCtors, function(Ctor, name) {
    $5370466dadc978d7$export$33fc3b478d332725[name] = new Ctor();
});
var $5370466dadc978d7$var$SymbolClz = $b02ffe7acd508c08$export$2e2bcd8739ae039.extend({
    type: "symbol",
    shape: {
        symbolType: "",
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    calculateTextPosition: function(out, config, rect) {
        var res = (0, $6c308355c7107803$export$eee3603b512feab7)(out, config, rect);
        var shape = this.shape;
        if (shape && shape.symbolType === "pin" && config.position === "inside") res.y = rect.y + rect.height * 0.4;
        return res;
    },
    buildPath: function(ctx, shape, inBundle) {
        var symbolType = shape.symbolType;
        if (symbolType !== "none") {
            var proxySymbol = $5370466dadc978d7$export$33fc3b478d332725[symbolType];
            if (!proxySymbol) {
                // Default rect
                symbolType = "rect";
                proxySymbol = $5370466dadc978d7$export$33fc3b478d332725[symbolType];
            }
            $5370466dadc978d7$var$symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
            proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
        }
    }
});
// Provide setColor helper method to avoid determine if set the fill or stroke outside
function $5370466dadc978d7$var$symbolPathSetColor(color, innerColor) {
    if (this.type !== "image") {
        var symbolStyle = this.style;
        if (this.__isEmptyBrush) {
            symbolStyle.stroke = color;
            symbolStyle.fill = innerColor || "#fff";
            // TODO Same width with lineStyle in LineView
            symbolStyle.lineWidth = 2;
        } else if (this.shape.symbolType === "line") symbolStyle.stroke = color;
        else symbolStyle.fill = color;
        this.markRedraw();
    }
}
function $5370466dadc978d7$export$af050e04da3a02e8(symbolType, x, y, w, h, color, // whether to keep the ratio of w/h,
keepAspect) {
    // TODO Support image object, DynamicImage.
    var isEmpty = symbolType.indexOf("empty") === 0;
    if (isEmpty) symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
    var symbolPath;
    if (symbolType.indexOf("image://") === 0) symbolPath = $5b455ae6f843ac47$export$7a2bdede98851ac5(symbolType.slice(8), new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, w, h), keepAspect ? "center" : "cover");
    else if (symbolType.indexOf("path://") === 0) symbolPath = $5b455ae6f843ac47$export$aa9bab72412f5613(symbolType.slice(7), {}, new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, w, h), keepAspect ? "center" : "cover");
    else symbolPath = new $5370466dadc978d7$var$SymbolClz({
        shape: {
            symbolType: symbolType,
            x: x,
            y: y,
            width: w,
            height: h
        }
    });
    symbolPath.__isEmptyBrush = isEmpty;
    // TODO Should deprecate setColor
    symbolPath.setColor = $5370466dadc978d7$var$symbolPathSetColor;
    if (color) symbolPath.setColor(color);
    return symbolPath;
}
function $5370466dadc978d7$export$a84524f03e8e8dfb(symbolSize) {
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolSize)) symbolSize = [
        +symbolSize,
        +symbolSize
    ];
    return [
        symbolSize[0] || 0,
        symbolSize[1] || 0
    ];
}
function $5370466dadc978d7$export$e3e292895c033f6d(symbolOffset, symbolSize) {
    if (symbolOffset == null) return;
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolOffset)) symbolOffset = [
        symbolOffset,
        symbolOffset
    ];
    return [
        (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(symbolOffset[0], symbolSize[0]) || 0,
        (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)((0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0
    ];
}





function $d76b6507633b3c44$var$isSafeNum(num) {
    return isFinite(num);
}
function $d76b6507633b3c44$export$235c7ac50fe1db0a(ctx, obj, rect) {
    var x = obj.x == null ? 0 : obj.x;
    var x2 = obj.x2 == null ? 1 : obj.x2;
    var y = obj.y == null ? 0 : obj.y;
    var y2 = obj.y2 == null ? 0 : obj.y2;
    if (!obj.global) {
        x = x * rect.width + rect.x;
        x2 = x2 * rect.width + rect.x;
        y = y * rect.height + rect.y;
        y2 = y2 * rect.height + rect.y;
    }
    x = $d76b6507633b3c44$var$isSafeNum(x) ? x : 0;
    x2 = $d76b6507633b3c44$var$isSafeNum(x2) ? x2 : 1;
    y = $d76b6507633b3c44$var$isSafeNum(y) ? y : 0;
    y2 = $d76b6507633b3c44$var$isSafeNum(y2) ? y2 : 0;
    var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
    return canvasGradient;
}
function $d76b6507633b3c44$export$57f098206d57a443(ctx, obj, rect) {
    var width = rect.width;
    var height = rect.height;
    var min = Math.min(width, height);
    var x = obj.x == null ? 0.5 : obj.x;
    var y = obj.y == null ? 0.5 : obj.y;
    var r = obj.r == null ? 0.5 : obj.r;
    if (!obj.global) {
        x = x * width + rect.x;
        y = y * height + rect.y;
        r = r * min;
    }
    x = $d76b6507633b3c44$var$isSafeNum(x) ? x : 0.5;
    y = $d76b6507633b3c44$var$isSafeNum(y) ? y : 0.5;
    r = r >= 0 && $d76b6507633b3c44$var$isSafeNum(r) ? r : 0.5;
    var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
    return canvasGradient;
}
function $d76b6507633b3c44$export$3dab6afd018d48c7(ctx, obj, rect) {
    var canvasGradient = obj.type === "radial" ? $d76b6507633b3c44$export$57f098206d57a443(ctx, obj, rect) : $d76b6507633b3c44$export$235c7ac50fe1db0a(ctx, obj, rect);
    var colorStops = obj.colorStops;
    for(var i = 0; i < colorStops.length; i++)canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    return canvasGradient;
}
function $d76b6507633b3c44$export$beeddc5150cb2e83(clipPaths, prevClipPaths) {
    if (clipPaths === prevClipPaths || !clipPaths && !prevClipPaths) return false;
    if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) return true;
    for(var i = 0; i < clipPaths.length; i++){
        if (clipPaths[i] !== prevClipPaths[i]) return true;
    }
    return false;
}
function $d76b6507633b3c44$var$parseInt10(val) {
    return parseInt(val, 10);
}
function $d76b6507633b3c44$export$31b21d0167753bb4(root, whIdx, opts) {
    var wh = [
        "width",
        "height"
    ][whIdx];
    var cwh = [
        "clientWidth",
        "clientHeight"
    ][whIdx];
    var plt = [
        "paddingLeft",
        "paddingTop"
    ][whIdx];
    var prb = [
        "paddingRight",
        "paddingBottom"
    ][whIdx];
    if (opts[wh] != null && opts[wh] !== "auto") return parseFloat(opts[wh]);
    var stl = document.defaultView.getComputedStyle(root);
    return (root[cwh] || $d76b6507633b3c44$var$parseInt10(stl[wh]) || $d76b6507633b3c44$var$parseInt10(root.style[wh])) - ($d76b6507633b3c44$var$parseInt10(stl[plt]) || 0) - ($d76b6507633b3c44$var$parseInt10(stl[prb]) || 0) | 0;
}







function $21ab8baf7c1f083c$export$9efb2ae8a603855d(lineType, lineWidth) {
    if (!lineType || lineType === "solid" || !(lineWidth > 0)) return null;
    return lineType === "dashed" ? [
        4 * lineWidth,
        2 * lineWidth
    ] : lineType === "dotted" ? [
        lineWidth
    ] : (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(lineType) ? [
        lineType
    ] : (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(lineType) ? lineType : null;
}
function $21ab8baf7c1f083c$export$9d315911f153b3b2(el) {
    var style = el.style;
    var lineDash = style.lineDash && style.lineWidth > 0 && $21ab8baf7c1f083c$export$9efb2ae8a603855d(style.lineDash, style.lineWidth);
    var lineDashOffset = style.lineDashOffset;
    if (lineDash) {
        var lineScale_1 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
        if (lineScale_1 && lineScale_1 !== 1) {
            lineDash = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(lineDash, function(rawVal) {
                return rawVal / lineScale_1;
            });
            lineDashOffset /= lineScale_1;
        }
    }
    return [
        lineDash,
        lineDashOffset
    ];
}




var $4f71e35e4552e3dd$var$pathProxyForDraw = new (0, $20ebe2448f123f2e$export$2e2bcd8739ae039)(true);
function $4f71e35e4552e3dd$var$styleHasStroke(style) {
    var stroke = style.stroke;
    return !(stroke == null || stroke === "none" || !(style.lineWidth > 0));
}
function $4f71e35e4552e3dd$var$isValidStrokeFillStyle(strokeOrFill) {
    return typeof strokeOrFill === "string" && strokeOrFill !== "none";
}
function $4f71e35e4552e3dd$var$styleHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== "none";
}
function $4f71e35e4552e3dd$var$doFillPath(ctx, style) {
    if (style.fillOpacity != null && style.fillOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.fillOpacity * style.opacity;
        ctx.fill();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.fill();
}
function $4f71e35e4552e3dd$var$doStrokePath(ctx, style) {
    if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.strokeOpacity * style.opacity;
        ctx.stroke();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.stroke();
}
function $4f71e35e4552e3dd$export$8eb5db6b7bc27903(ctx, pattern, el) {
    var image = (0, $a53bd598adfb7ebe$export$46c791b69ff9a0f)(pattern.image, pattern.__image, el);
    if ((0, $a53bd598adfb7ebe$export$37ca7dd901d0236d)(image)) {
        var canvasPattern = ctx.createPattern(image, pattern.repeat || "repeat");
        if (typeof DOMMatrix === "function" && canvasPattern && canvasPattern.setTransform) {
            var matrix = new DOMMatrix();
            matrix.translateSelf(pattern.x || 0, pattern.y || 0);
            matrix.rotateSelf(0, 0, (pattern.rotation || 0) * (0, $7a1bd9c2710fea0d$export$bce8e055322a0ce6));
            matrix.scaleSelf(pattern.scaleX || 1, pattern.scaleY || 1);
            canvasPattern.setTransform(matrix);
        }
        return canvasPattern;
    }
}
function $4f71e35e4552e3dd$var$brushPath(ctx, el, style, inBatch) {
    var _a;
    var hasStroke = $4f71e35e4552e3dd$var$styleHasStroke(style);
    var hasFill = $4f71e35e4552e3dd$var$styleHasFill(style);
    var strokePercent = style.strokePercent;
    var strokePart = strokePercent < 1;
    var firstDraw = !el.path;
    if ((!el.silent || strokePart) && firstDraw) el.createPathProxy();
    var path = el.path || $4f71e35e4552e3dd$var$pathProxyForDraw;
    var dirtyFlag = el.__dirty;
    if (!inBatch) {
        var fill = style.fill;
        var stroke = style.stroke;
        var hasFillGradient = hasFill && !!fill.colorStops;
        var hasStrokeGradient = hasStroke && !!stroke.colorStops;
        var hasFillPattern = hasFill && !!fill.image;
        var hasStrokePattern = hasStroke && !!stroke.image;
        var fillGradient = void 0;
        var strokeGradient = void 0;
        var fillPattern = void 0;
        var strokePattern = void 0;
        var rect = void 0;
        if (hasFillGradient || hasStrokeGradient) rect = el.getBoundingRect();
        if (hasFillGradient) {
            fillGradient = dirtyFlag ? (0, $d76b6507633b3c44$export$3dab6afd018d48c7)(ctx, fill, rect) : el.__canvasFillGradient;
            el.__canvasFillGradient = fillGradient;
        }
        if (hasStrokeGradient) {
            strokeGradient = dirtyFlag ? (0, $d76b6507633b3c44$export$3dab6afd018d48c7)(ctx, stroke, rect) : el.__canvasStrokeGradient;
            el.__canvasStrokeGradient = strokeGradient;
        }
        if (hasFillPattern) {
            fillPattern = dirtyFlag || !el.__canvasFillPattern ? $4f71e35e4552e3dd$export$8eb5db6b7bc27903(ctx, fill, el) : el.__canvasFillPattern;
            el.__canvasFillPattern = fillPattern;
        }
        if (hasStrokePattern) {
            strokePattern = dirtyFlag || !el.__canvasStrokePattern ? $4f71e35e4552e3dd$export$8eb5db6b7bc27903(ctx, stroke, el) : el.__canvasStrokePattern;
            el.__canvasStrokePattern = fillPattern;
        }
        if (hasFillGradient) ctx.fillStyle = fillGradient;
        else if (hasFillPattern) {
            if (fillPattern) ctx.fillStyle = fillPattern;
            else hasFill = false;
        }
        if (hasStrokeGradient) ctx.strokeStyle = strokeGradient;
        else if (hasStrokePattern) {
            if (strokePattern) ctx.strokeStyle = strokePattern;
            else hasStroke = false;
        }
    }
    var scale = el.getGlobalScale();
    path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
    var lineDash;
    var lineDashOffset;
    if (ctx.setLineDash && style.lineDash) _a = (0, $21ab8baf7c1f083c$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
    var needsRebuild = true;
    if (firstDraw || dirtyFlag & (0, $ddf76b16f1246ba9$export$f75fe89a33ebe115)) {
        path.setDPR(ctx.dpr);
        if (strokePart) path.setContext(null);
        else {
            path.setContext(ctx);
            needsRebuild = false;
        }
        path.reset();
        el.buildPath(path, el.shape, inBatch);
        path.toStatic();
        el.pathUpdated();
    }
    if (needsRebuild) path.rebuildPath(ctx, strokePart ? strokePercent : 1);
    if (lineDash) {
        ctx.setLineDash(lineDash);
        ctx.lineDashOffset = lineDashOffset;
    }
    if (!inBatch) {
        if (style.strokeFirst) {
            if (hasStroke) $4f71e35e4552e3dd$var$doStrokePath(ctx, style);
            if (hasFill) $4f71e35e4552e3dd$var$doFillPath(ctx, style);
        } else {
            if (hasFill) $4f71e35e4552e3dd$var$doFillPath(ctx, style);
            if (hasStroke) $4f71e35e4552e3dd$var$doStrokePath(ctx, style);
        }
    }
    if (lineDash) ctx.setLineDash([]);
}
function $4f71e35e4552e3dd$var$brushImage(ctx, el, style) {
    var image = el.__image = (0, $a53bd598adfb7ebe$export$46c791b69ff9a0f)(style.image, el.__image, el, el.onload);
    if (!image || !(0, $a53bd598adfb7ebe$export$37ca7dd901d0236d)(image)) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var width = el.getWidth();
    var height = el.getHeight();
    var aspect = image.width / image.height;
    if (width == null && height != null) width = height * aspect;
    else if (height == null && width != null) height = width / aspect;
    else if (width == null && height == null) {
        width = image.width;
        height = image.height;
    }
    if (style.sWidth && style.sHeight) {
        var sx = style.sx || 0;
        var sy = style.sy || 0;
        ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    } else if (style.sx && style.sy) {
        var sx = style.sx;
        var sy = style.sy;
        var sWidth = width - sx;
        var sHeight = height - sy;
        ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    } else ctx.drawImage(image, x, y, width, height);
}
function $4f71e35e4552e3dd$var$brushText(ctx, el, style) {
    var _a;
    var text = style.text;
    text != null && (text += "");
    if (text) {
        ctx.font = style.font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
        ctx.textAlign = style.textAlign;
        ctx.textBaseline = style.textBaseline;
        var lineDash = void 0;
        var lineDashOffset = void 0;
        if (ctx.setLineDash && style.lineDash) _a = (0, $21ab8baf7c1f083c$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
        if (lineDash) {
            ctx.setLineDash(lineDash);
            ctx.lineDashOffset = lineDashOffset;
        }
        if (style.strokeFirst) {
            if ($4f71e35e4552e3dd$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
            if ($4f71e35e4552e3dd$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
        } else {
            if ($4f71e35e4552e3dd$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
            if ($4f71e35e4552e3dd$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
        }
        if (lineDash) ctx.setLineDash([]);
    }
}
var $4f71e35e4552e3dd$var$SHADOW_NUMBER_PROPS = [
    "shadowBlur",
    "shadowOffsetX",
    "shadowOffsetY"
];
var $4f71e35e4552e3dd$var$STROKE_PROPS = [
    [
        "lineCap",
        "butt"
    ],
    [
        "lineJoin",
        "miter"
    ],
    [
        "miterLimit",
        10
    ]
];
function $4f71e35e4552e3dd$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
    var styleChanged = false;
    if (!forceSetAll) {
        prevStyle = prevStyle || {};
        if (style === prevStyle) return false;
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
        styleChanged = true;
        var opacity = Math.max(Math.min(style.opacity, 1), 0);
        ctx.globalAlpha = isNaN(opacity) ? (0, $56206a6cb4666931$export$737672163db00fe3).opacity : opacity;
    }
    if (forceSetAll || style.blend !== prevStyle.blend) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalCompositeOperation = style.blend || (0, $56206a6cb4666931$export$737672163db00fe3).blend;
    }
    for(var i = 0; i < $4f71e35e4552e3dd$var$SHADOW_NUMBER_PROPS.length; i++){
        var propName = $4f71e35e4552e3dd$var$SHADOW_NUMBER_PROPS[i];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = ctx.dpr * (style[propName] || 0);
        }
    }
    if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.shadowColor = style.shadowColor || (0, $56206a6cb4666931$export$737672163db00fe3).shadowColor;
    }
    return styleChanged;
}
function $4f71e35e4552e3dd$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
    var style = $4f71e35e4552e3dd$var$getStyle(el, scope.inHover);
    var prevStyle = forceSetAll ? null : prevEl && $4f71e35e4552e3dd$var$getStyle(prevEl, scope.inHover) || {};
    if (style === prevStyle) return false;
    var styleChanged = $4f71e35e4552e3dd$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
    if (forceSetAll || style.fill !== prevStyle.fill) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $4f71e35e4552e3dd$var$isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
    }
    if (forceSetAll || style.stroke !== prevStyle.stroke) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $4f71e35e4552e3dd$var$isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }
    if (el.hasStroke()) {
        var lineWidth = style.lineWidth;
        var newLineWidth = lineWidth / (style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1);
        if (ctx.lineWidth !== newLineWidth) {
            if (!styleChanged) {
                $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.lineWidth = newLineWidth;
        }
    }
    for(var i = 0; i < $4f71e35e4552e3dd$var$STROKE_PROPS.length; i++){
        var prop = $4f71e35e4552e3dd$var$STROKE_PROPS[i];
        var propName = prop[0];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = style[propName] || prop[1];
        }
    }
    return styleChanged;
}
function $4f71e35e4552e3dd$var$bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
    return $4f71e35e4552e3dd$var$bindCommonProps(ctx, $4f71e35e4552e3dd$var$getStyle(el, scope.inHover), prevEl && $4f71e35e4552e3dd$var$getStyle(prevEl, scope.inHover), forceSetAll, scope);
}
function $4f71e35e4552e3dd$var$setContextTransform(ctx, el) {
    var m = el.transform;
    var dpr = ctx.dpr || 1;
    if (m) ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
    else ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
}
function $4f71e35e4552e3dd$var$updateClipStatus(clipPaths, ctx, scope) {
    var allClipped = false;
    for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        allClipped = allClipped || clipPath.isZeroArea();
        $4f71e35e4552e3dd$var$setContextTransform(ctx, clipPath);
        ctx.beginPath();
        clipPath.buildPath(ctx, clipPath.shape);
        ctx.clip();
    }
    scope.allClipped = allClipped;
}
function $4f71e35e4552e3dd$var$isTransformChanged(m0, m1) {
    if (m0 && m1) return m0[0] !== m1[0] || m0[1] !== m1[1] || m0[2] !== m1[2] || m0[3] !== m1[3] || m0[4] !== m1[4] || m0[5] !== m1[5];
    else if (!m0 && !m1) return false;
    return true;
}
var $4f71e35e4552e3dd$var$DRAW_TYPE_PATH = 1;
var $4f71e35e4552e3dd$var$DRAW_TYPE_IMAGE = 2;
var $4f71e35e4552e3dd$var$DRAW_TYPE_TEXT = 3;
var $4f71e35e4552e3dd$var$DRAW_TYPE_INCREMENTAL = 4;
function $4f71e35e4552e3dd$var$canPathBatch(style) {
    var hasFill = $4f71e35e4552e3dd$var$styleHasFill(style);
    var hasStroke = $4f71e35e4552e3dd$var$styleHasStroke(style);
    return !(style.lineDash || !(+hasFill ^ +hasStroke) || hasFill && typeof style.fill !== "string" || hasStroke && typeof style.stroke !== "string" || style.strokePercent < 1 || style.strokeOpacity < 1 || style.fillOpacity < 1);
}
function $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope) {
    scope.batchFill && ctx.fill();
    scope.batchStroke && ctx.stroke();
    scope.batchFill = "";
    scope.batchStroke = "";
}
function $4f71e35e4552e3dd$var$getStyle(el, inHover) {
    return inHover ? el.__hoverStyle || el.style : el.style;
}
function $4f71e35e4552e3dd$export$567881adfc3eb7f3(ctx, el) {
    $4f71e35e4552e3dd$export$da5d6544e8c27bc1(ctx, el, {
        inHover: false,
        viewWidth: 0,
        viewHeight: 0
    }, true);
}
function $4f71e35e4552e3dd$export$da5d6544e8c27bc1(ctx, el, scope, isLast) {
    var m = el.transform;
    if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
        el.__dirty &= ~(0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd);
        el.__isRendered = false;
        return;
    }
    var clipPaths = el.__clipPaths;
    var prevElClipPaths = scope.prevElClipPaths;
    var forceSetTransform = false;
    var forceSetStyle = false;
    if (!prevElClipPaths || (0, $d76b6507633b3c44$export$beeddc5150cb2e83)(clipPaths, prevElClipPaths)) {
        if (prevElClipPaths && prevElClipPaths.length) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            ctx.restore();
            forceSetStyle = forceSetTransform = true;
            scope.prevElClipPaths = null;
            scope.allClipped = false;
            scope.prevEl = null;
        }
        if (clipPaths && clipPaths.length) {
            $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
            ctx.save();
            $4f71e35e4552e3dd$var$updateClipStatus(clipPaths, ctx, scope);
            forceSetTransform = true;
        }
        scope.prevElClipPaths = clipPaths;
    }
    if (scope.allClipped) {
        el.__isRendered = false;
        return;
    }
    el.beforeBrush && el.beforeBrush();
    el.innerBeforeBrush();
    var prevEl = scope.prevEl;
    if (!prevEl) forceSetStyle = forceSetTransform = true;
    var canBatchPath = el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039) && el.autoBatch && $4f71e35e4552e3dd$var$canPathBatch(el.style);
    if (forceSetTransform || $4f71e35e4552e3dd$var$isTransformChanged(m, prevEl.transform)) {
        $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
        $4f71e35e4552e3dd$var$setContextTransform(ctx, el);
    } else if (!canBatchPath) $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
    var style = $4f71e35e4552e3dd$var$getStyle(el, scope.inHover);
    if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) {
        if (scope.lastDrawType !== $4f71e35e4552e3dd$var$DRAW_TYPE_PATH) {
            forceSetStyle = true;
            scope.lastDrawType = $4f71e35e4552e3dd$var$DRAW_TYPE_PATH;
        }
        $4f71e35e4552e3dd$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
        if (!canBatchPath || !scope.batchFill && !scope.batchStroke) ctx.beginPath();
        $4f71e35e4552e3dd$var$brushPath(ctx, el, style, canBatchPath);
        if (canBatchPath) {
            scope.batchFill = style.fill || "";
            scope.batchStroke = style.stroke || "";
        }
    } else {
        if (el instanceof (0, $c9d5c769fe2f591f$export$2e2bcd8739ae039)) {
            if (scope.lastDrawType !== $4f71e35e4552e3dd$var$DRAW_TYPE_TEXT) {
                forceSetStyle = true;
                scope.lastDrawType = $4f71e35e4552e3dd$var$DRAW_TYPE_TEXT;
            }
            $4f71e35e4552e3dd$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
            $4f71e35e4552e3dd$var$brushText(ctx, el, style);
        } else if (el instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
            if (scope.lastDrawType !== $4f71e35e4552e3dd$var$DRAW_TYPE_IMAGE) {
                forceSetStyle = true;
                scope.lastDrawType = $4f71e35e4552e3dd$var$DRAW_TYPE_IMAGE;
            }
            $4f71e35e4552e3dd$var$bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
            $4f71e35e4552e3dd$var$brushImage(ctx, el, style);
        } else if (el.getTemporalDisplayables) {
            if (scope.lastDrawType !== $4f71e35e4552e3dd$var$DRAW_TYPE_INCREMENTAL) {
                forceSetStyle = true;
                scope.lastDrawType = $4f71e35e4552e3dd$var$DRAW_TYPE_INCREMENTAL;
            }
            $4f71e35e4552e3dd$var$brushIncremental(ctx, el, scope);
        }
    }
    if (canBatchPath && isLast) $4f71e35e4552e3dd$var$flushPathDrawn(ctx, scope);
    el.innerAfterBrush();
    el.afterBrush && el.afterBrush();
    scope.prevEl = el;
    el.__dirty = 0;
    el.__isRendered = true;
}
function $4f71e35e4552e3dd$var$brushIncremental(ctx, el, scope) {
    var displayables = el.getDisplayables();
    var temporalDisplayables = el.getTemporalDisplayables();
    ctx.save();
    var innerScope = {
        prevElClipPaths: null,
        prevEl: null,
        allClipped: false,
        viewWidth: scope.viewWidth,
        viewHeight: scope.viewHeight,
        inHover: scope.inHover
    };
    var i;
    var len;
    for(i = el.getCursor(), len = displayables.length; i < len; i++){
        var displayable = displayables[i];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $4f71e35e4552e3dd$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i === len - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    for(var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++){
        var displayable = temporalDisplayables[i_1];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $4f71e35e4552e3dd$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i_1 === len_1 - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    el.clearTemporalDisplayables();
    el.notClear = true;
    ctx.restore();
}



var $c6d646aacd243427$var$decalMap = new (0, $56aadf5b08ec1b47$export$2e2bcd8739ae039)();
var $c6d646aacd243427$var$decalCache = new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(100);
var $c6d646aacd243427$var$decalKeys = [
    "symbol",
    "symbolSize",
    "symbolKeepAspect",
    "color",
    "backgroundColor",
    "dashArrayX",
    "dashArrayY",
    "maxTileWidth",
    "maxTileHeight"
];
function $c6d646aacd243427$export$a3ba048e1a648972(decalObject, api) {
    if (decalObject === "none") return null;
    var dpr = api.getDevicePixelRatio();
    var zr = api.getZr();
    var isSVG = zr.painter.type === "svg";
    if (decalObject.dirty) $c6d646aacd243427$var$decalMap["delete"](decalObject);
    var oldPattern = $c6d646aacd243427$var$decalMap.get(decalObject);
    if (oldPattern) return oldPattern;
    var decalOpt = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(decalObject, {
        symbol: "rect",
        symbolSize: 1,
        symbolKeepAspect: true,
        color: "rgba(0, 0, 0, 0.2)",
        backgroundColor: null,
        dashArrayX: 5,
        dashArrayY: 5,
        rotation: 0,
        maxTileWidth: 512,
        maxTileHeight: 512
    });
    if (decalOpt.backgroundColor === "none") decalOpt.backgroundColor = null;
    var pattern = {
        repeat: "repeat"
    };
    setPatternnSource(pattern);
    pattern.rotation = decalOpt.rotation;
    pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
    $c6d646aacd243427$var$decalMap.set(decalObject, pattern);
    decalObject.dirty = false;
    return pattern;
    function setPatternnSource(pattern) {
        var keys = [
            dpr
        ];
        var isValidKey = true;
        for(var i = 0; i < $c6d646aacd243427$var$decalKeys.length; ++i){
            var value = decalOpt[$c6d646aacd243427$var$decalKeys[i]];
            if (value != null && !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(value) && !(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(value) && !(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(value) && typeof value !== "boolean") {
                isValidKey = false;
                break;
            }
            keys.push(value);
        }
        var cacheKey;
        if (isValidKey) {
            cacheKey = keys.join(",") + (isSVG ? "-svg" : "");
            var cache = $c6d646aacd243427$var$decalCache.get(cacheKey);
            if (cache) isSVG ? pattern.svgElement = cache : pattern.image = cache;
        }
        var dashArrayX = $c6d646aacd243427$var$normalizeDashArrayX(decalOpt.dashArrayX);
        var dashArrayY = $c6d646aacd243427$var$normalizeDashArrayY(decalOpt.dashArrayY);
        var symbolArray = $c6d646aacd243427$var$normalizeSymbolArray(decalOpt.symbol);
        var lineBlockLengthsX = $c6d646aacd243427$var$getLineBlockLengthX(dashArrayX);
        var lineBlockLengthY = $c6d646aacd243427$var$getLineBlockLengthY(dashArrayY);
        var canvas = !isSVG && (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas();
        var svgRoot = isSVG && {
            tag: "g",
            attrs: {},
            key: "dcl",
            children: []
        };
        var pSize = getPatternSize();
        var ctx;
        if (canvas) {
            canvas.width = pSize.width * dpr;
            canvas.height = pSize.height * dpr;
            ctx = canvas.getContext("2d");
        }
        brushDecal();
        if (isValidKey) $c6d646aacd243427$var$decalCache.put(cacheKey, canvas || svgRoot);
        pattern.image = canvas;
        pattern.svgElement = svgRoot;
        pattern.svgWidth = pSize.width;
        pattern.svgHeight = pSize.height;
        /**
     * Get minimum length that can make a repeatable pattern.
     *
     * @return {Object} pattern width and height
     */ function getPatternSize() {
            /**
       * For example, if dash is [[3, 2], [2, 1]] for X, it looks like
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * So the minimum length of X is 15,
       * which is the least common multiple of `3 + 2` and `2 + 1`
       * |---  ---  ---  |---  --- ...
       * |-- -- -- -- -- |-- -- -- ...
       */ var width = 1;
            for(var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i)width = (0, $cfc1f3b422a3185f$export$680a45b749323f49)(width, lineBlockLengthsX[i]);
            var symbolRepeats = 1;
            for(var i = 0, xlen = symbolArray.length; i < xlen; ++i)symbolRepeats = (0, $cfc1f3b422a3185f$export$680a45b749323f49)(symbolRepeats, symbolArray[i].length);
            width *= symbolRepeats;
            var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;
            var warn;
            return {
                width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
                height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
            };
        }
        function brushDecal() {
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                if (decalOpt.backgroundColor) {
                    ctx.fillStyle = decalOpt.backgroundColor;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                }
            }
            var ySum = 0;
            for(var i = 0; i < dashArrayY.length; ++i)ySum += dashArrayY[i];
            if (ySum <= 0) // dashArrayY is 0, draw nothing
            return;
            var y = -lineBlockLengthY;
            var yId = 0;
            var yIdTotal = 0;
            var xId0 = 0;
            while(y < pSize.height){
                if (yId % 2 === 0) {
                    var symbolYId = yIdTotal / 2 % symbolArray.length;
                    var x = 0;
                    var xId1 = 0;
                    var xId1Total = 0;
                    while(x < pSize.width * 2){
                        var xSum = 0;
                        for(var i = 0; i < dashArrayX[xId0].length; ++i)xSum += dashArrayX[xId0][i];
                        if (xSum <= 0) break;
                        // E.g., [15, 5, 20, 5] draws only for 15 and 20
                        if (xId1 % 2 === 0) {
                            var size = (1 - decalOpt.symbolSize) * 0.5;
                            var left = x + dashArrayX[xId0][xId1] * size;
                            var top_1 = y + dashArrayY[yId] * size;
                            var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
                            var height = dashArrayY[yId] * decalOpt.symbolSize;
                            var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
                            brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
                        }
                        x += dashArrayX[xId0][xId1];
                        ++xId1Total;
                        ++xId1;
                        if (xId1 === dashArrayX[xId0].length) xId1 = 0;
                    }
                    ++xId0;
                    if (xId0 === dashArrayX.length) xId0 = 0;
                }
                y += dashArrayY[yId];
                ++yIdTotal;
                ++yId;
                if (yId === dashArrayY.length) yId = 0;
            }
            function brushSymbol(x, y, width, height, symbolType) {
                var scale = isSVG ? 1 : dpr;
                var symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);
                if (isSVG) {
                    var symbolVNode = zr.painter.renderOneToVNode(symbol);
                    if (symbolVNode) svgRoot.children.push(symbolVNode);
                } else // Paint to canvas for all other renderers.
                (0, $4f71e35e4552e3dd$export$567881adfc3eb7f3)(ctx, symbol);
            }
        }
    }
}
/**
 * Convert symbol array into normalized array
 *
 * @param {string | (string | string[])[]} symbol symbol input
 * @return {string[][]} normolized symbol array
 */ function $c6d646aacd243427$var$normalizeSymbolArray(symbol) {
    if (!symbol || symbol.length === 0) return [
        [
            "rect"
        ]
    ];
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(symbol)) return [
        [
            symbol
        ]
    ];
    var isAllString = true;
    for(var i = 0; i < symbol.length; ++i)if (!(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(symbol[i])) {
        isAllString = false;
        break;
    }
    if (isAllString) return $c6d646aacd243427$var$normalizeSymbolArray([
        symbol
    ]);
    var result = [];
    for(var i = 0; i < symbol.length; ++i)if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(symbol[i])) result.push([
        symbol[i]
    ]);
    else result.push(symbol[i]);
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayX} dash dash input
 * @return {number[][]} normolized dash array
 */ function $c6d646aacd243427$var$normalizeDashArrayX(dash) {
    if (!dash || dash.length === 0) return [
        [
            0,
            0
        ]
    ];
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dash)) {
        var dashValue = Math.ceil(dash);
        return [
            [
                dashValue,
                dashValue
            ]
        ];
    }
    /**
   * [20, 5] should be normalized into [[20, 5]],
   * while [20, [5, 10]] should be normalized into [[20, 20], [5, 10]]
   */ var isAllNumber = true;
    for(var i = 0; i < dash.length; ++i)if (!(0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dash[i])) {
        isAllNumber = false;
        break;
    }
    if (isAllNumber) return $c6d646aacd243427$var$normalizeDashArrayX([
        dash
    ]);
    var result = [];
    for(var i = 0; i < dash.length; ++i)if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dash[i])) {
        var dashValue = Math.ceil(dash[i]);
        result.push([
            dashValue,
            dashValue
        ]);
    } else {
        var dashValue = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dash[i], function(n) {
            return Math.ceil(n);
        });
        if (dashValue.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
        // so normalize it to be [4, 2, 1, 4, 2, 1]
        result.push(dashValue.concat(dashValue));
        else result.push(dashValue);
    }
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayY} dash dash input
 * @return {number[]} normolized dash array
 */ function $c6d646aacd243427$var$normalizeDashArrayY(dash) {
    if (!dash || typeof dash === "object" && dash.length === 0) return [
        0,
        0
    ];
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(dash)) {
        var dashValue_1 = Math.ceil(dash);
        return [
            dashValue_1,
            dashValue_1
        ];
    }
    var dashValue = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dash, function(n) {
        return Math.ceil(n);
    });
    return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
}
/**
 * Get block length of each line. A block is the length of dash line and space.
 * For example, a line with [4, 1] has a dash line of 4 and a space of 1 after
 * that, so the block length of this line is 5.
 *
 * @param {number[][]} dash dash array of X or Y
 * @return {number[]} block length of each line
 */ function $c6d646aacd243427$var$getLineBlockLengthX(dash) {
    return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dash, function(line) {
        return $c6d646aacd243427$var$getLineBlockLengthY(line);
    });
}
function $c6d646aacd243427$var$getLineBlockLengthY(dash) {
    var blockLength = 0;
    for(var i = 0; i < dash.length; ++i)blockLength += dash[i];
    if (dash.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
    // So total length is (4 + 2 + 1) * 2
    return blockLength * 2;
    return blockLength;
}


function $d82adaf1a5a5cfeb$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachRawSeries(function(seriesModel) {
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        if (data.hasItemVisual()) data.each(function(idx) {
            var decal = data.getItemVisual(idx, "decal");
            if (decal) {
                var itemStyle = data.ensureUniqueItemVisual(idx, "style");
                itemStyle.decal = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decal, api);
            }
        });
        var decal = data.getVisual("decal");
        if (decal) {
            var style = data.getVisual("style");
            style.decal = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decal, api);
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $8022924a3c5c0bb5$var$lifecycle = new (0, $63441a86293f101f$export$2e2bcd8739ae039)();
var $8022924a3c5c0bb5$export$2e2bcd8739ae039 = $8022924a3c5c0bb5$var$lifecycle;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// Implementation of exported APIs. For example registerMap, getMap.
// The implementations will be registered when installing the component.
// Avoid these code being bundled to the core module.
var $f773aa0508c1d920$var$implsStore = {};
function $f773aa0508c1d920$export$9b808fd12256ddd3(name, impl) {
    $f773aa0508c1d920$var$implsStore[name] = impl;
}
function $f773aa0508c1d920$export$73333eb8a09d5f61(name) {
    return $f773aa0508c1d920$var$implsStore[name];
}


var $4d59907f44a2d0ad$export$83d89fbfd8236492 = "5.5.0";
var $4d59907f44a2d0ad$export$b74ff737e0e298b5 = {
    zrender: "5.5.0"
};
var $4d59907f44a2d0ad$var$TEST_FRAME_REMAIN_TIME = 1;
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_SERIES_FILTER = 800;
// Some data processors depends on the stack result dimension (to calculate data extent).
// So data stack stage should be in front of data processing stage.
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_DATASTACK = 900;
// "Data filter" will block the stream, so it should be
// put at the beginning of data processing.
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_FILTER = 1000;
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_DEFAULT = 2000;
var $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_STATISTIC = 5000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_LAYOUT = 1000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_GLOBAL = 2000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART = 3000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_COMPONENT = 4000;
// Visual property in data. Greater than `PRIORITY_VISUAL_COMPONENT` to enable to
// overwrite the viusal result of component (like `visualMap`)
// using data item specific setting (like itemStyle.xxx on data item)
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500;
// Greater than `PRIORITY_VISUAL_CHART_DATA_CUSTOM` to enable to layout based on
// visual result like `symbolSize`.
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_BRUSH = 5000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_ARIA = 6000;
var $4d59907f44a2d0ad$var$PRIORITY_VISUAL_DECAL = 7000;
var $4d59907f44a2d0ad$export$bb34f3538ba26c7e = {
    PROCESSOR: {
        FILTER: $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_FILTER,
        SERIES_FILTER: $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_SERIES_FILTER,
        STATISTIC: $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_STATISTIC
    },
    VISUAL: {
        LAYOUT: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_LAYOUT,
        PROGRESSIVE_LAYOUT: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
        GLOBAL: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_GLOBAL,
        CHART: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART,
        POST_CHART_LAYOUT: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_POST_CHART_LAYOUT,
        COMPONENT: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_COMPONENT,
        BRUSH: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_BRUSH,
        CHART_ITEM: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM,
        ARIA: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_ARIA,
        DECAL: $4d59907f44a2d0ad$var$PRIORITY_VISUAL_DECAL
    }
};
// Main process have three entries: `setOption`, `dispatchAction` and `resize`,
// where they must not be invoked nestedly, except the only case: invoke
// dispatchAction with updateMethod "none" in main process.
// This flag is used to carry out this rule.
// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
var $4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY = "__flagInMainProcess";
var $4d59907f44a2d0ad$var$PENDING_UPDATE = "__pendingUpdate";
var $4d59907f44a2d0ad$var$STATUS_NEEDS_UPDATE_KEY = "__needsUpdateStatus";
var $4d59907f44a2d0ad$var$ACTION_REG = /^[a-zA-Z0-9_]+$/;
var $4d59907f44a2d0ad$var$CONNECT_STATUS_KEY = "__connectUpdateStatus";
var $4d59907f44a2d0ad$var$CONNECT_STATUS_PENDING = 0;
var $4d59907f44a2d0ad$var$CONNECT_STATUS_UPDATING = 1;
var $4d59907f44a2d0ad$var$CONNECT_STATUS_UPDATED = 2;
function $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseECharts(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.isDisposed()) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        return $4d59907f44a2d0ad$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseMessageCenter(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $4d59907f44a2d0ad$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $4d59907f44a2d0ad$var$toLowercaseNameAndCallEventful(host, method, args) {
    // `args[0]` is event name. Event name is all lowercase.
    args[0] = args[0] && args[0].toLowerCase();
    return (0, $63441a86293f101f$export$2e2bcd8739ae039).prototype[method].apply(host, args);
}
var $4d59907f44a2d0ad$var$MessageCenter = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MessageCenter, _super);
    function MessageCenter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MessageCenter;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $4d59907f44a2d0ad$var$messageCenterProto = $4d59907f44a2d0ad$var$MessageCenter.prototype;
$4d59907f44a2d0ad$var$messageCenterProto.on = $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseMessageCenter("on");
$4d59907f44a2d0ad$var$messageCenterProto.off = $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseMessageCenter("off");
// ---------------------------------------
// Internal method names for class ECharts
// ---------------------------------------
var $4d59907f44a2d0ad$var$prepare;
var $4d59907f44a2d0ad$var$prepareView;
var $4d59907f44a2d0ad$var$updateDirectly;
var $4d59907f44a2d0ad$var$updateMethods;
var $4d59907f44a2d0ad$var$doConvertPixel;
var $4d59907f44a2d0ad$var$updateStreamModes;
var $4d59907f44a2d0ad$var$doDispatchAction;
var $4d59907f44a2d0ad$var$flushPendingActions;
var $4d59907f44a2d0ad$var$triggerUpdatedEvent;
var $4d59907f44a2d0ad$var$bindRenderedEvent;
var $4d59907f44a2d0ad$var$bindMouseEvent;
var $4d59907f44a2d0ad$var$render;
var $4d59907f44a2d0ad$var$renderComponents;
var $4d59907f44a2d0ad$var$renderSeries;
var $4d59907f44a2d0ad$var$createExtensionAPI;
var $4d59907f44a2d0ad$var$enableConnect;
var $4d59907f44a2d0ad$var$markStatusToUpdate;
var $4d59907f44a2d0ad$var$applyChangedStates;
var $4d59907f44a2d0ad$var$ECharts = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ECharts, _super);
    function ECharts(dom, // Theme name or themeOption.
    theme, opts) {
        var _this = _super.call(this, new (0, $82d62ed69f6abce3$export$d0fd09f950257b52)()) || this;
        _this._chartsViews = [];
        _this._chartsMap = {};
        _this._componentsViews = [];
        _this._componentsMap = {};
        // Can't dispatch action during rendering procedure
        _this._pendingActions = [];
        opts = opts || {};
        // Get theme by name
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(theme)) theme = $4d59907f44a2d0ad$var$themeStorage[theme];
        _this._dom = dom;
        var defaultRenderer = "canvas";
        var defaultCoarsePointer = "auto";
        var defaultUseDirtyRect = false;
        var root;
        if (opts.ssr) $6eba88f9eebe6af9$export$e7a09d7fe68a4f7(function(el) {
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
            var dataIndex = ecData.dataIndex;
            if (dataIndex == null) return;
            var hashMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
            hashMap.set("series_index", ecData.seriesIndex);
            hashMap.set("data_index", dataIndex);
            ecData.ssrType && hashMap.set("ssr_type", ecData.ssrType);
            return hashMap;
        });
        var zr = _this._zr = $6eba88f9eebe6af9$export$2cd8252107eb640b(dom, {
            renderer: opts.renderer || defaultRenderer,
            devicePixelRatio: opts.devicePixelRatio,
            width: opts.width,
            height: opts.height,
            ssr: opts.ssr,
            useDirtyRect: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.useDirtyRect, defaultUseDirtyRect),
            useCoarsePointer: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.useCoarsePointer, defaultCoarsePointer),
            pointerSize: opts.pointerSize
        });
        _this._ssr = opts.ssr;
        // Expect 60 fps.
        _this._throttledZrFlush = (0, $c98659a9437a3d2e$export$de363e709c412c8a)((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(zr.flush, zr), 17);
        theme = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(theme);
        theme && (0, $c4489ebdf95633b6$export$2e2bcd8739ae039)(theme, true);
        _this._theme = theme;
        _this._locale = (0, $9b0a1ef4bcc91e7d$export$ddc371781a6af754)(opts.locale || (0, $9b0a1ef4bcc91e7d$export$9a2147b3808d4c6b));
        _this._coordSysMgr = new (0, $70c3ede7d3b64757$export$2e2bcd8739ae039)();
        var api = _this._api = $4d59907f44a2d0ad$var$createExtensionAPI(_this);
        // Sort on demand
        function prioritySortFunc(a, b) {
            return a.__prio - b.__prio;
        }
        (0, $97579a54749e4b24$export$2e2bcd8739ae039)($4d59907f44a2d0ad$var$visualFuncs, prioritySortFunc);
        (0, $97579a54749e4b24$export$2e2bcd8739ae039)($4d59907f44a2d0ad$var$dataProcessorFuncs, prioritySortFunc);
        _this._scheduler = new (0, $94ae4e8744638a8a$export$2e2bcd8739ae039)(_this, api, $4d59907f44a2d0ad$var$dataProcessorFuncs, $4d59907f44a2d0ad$var$visualFuncs);
        _this._messageCenter = new $4d59907f44a2d0ad$var$MessageCenter();
        // Init mouse events
        _this._initEvents();
        // In case some people write `window.onresize = chart.resize`
        _this.resize = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this.resize, _this);
        zr.animation.on("frame", _this._onframe, _this);
        $4d59907f44a2d0ad$var$bindRenderedEvent(zr, _this);
        $4d59907f44a2d0ad$var$bindMouseEvent(zr, _this);
        // ECharts instance can be used as value.
        (0, $7a1bd9c2710fea0d$export$112e66431016387b)(_this);
        return _this;
    }
    ECharts.prototype._onframe = function() {
        if (this._disposed) return;
        $4d59907f44a2d0ad$var$applyChangedStates(this);
        var scheduler = this._scheduler;
        // Lazy update
        if (this[$4d59907f44a2d0ad$var$PENDING_UPDATE]) {
            var silent = this[$4d59907f44a2d0ad$var$PENDING_UPDATE].silent;
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = true;
            try {
                $4d59907f44a2d0ad$var$prepare(this);
                $4d59907f44a2d0ad$var$updateMethods.update.call(this, null, this[$4d59907f44a2d0ad$var$PENDING_UPDATE].updateParams);
            } catch (e) {
                this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
                this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
                throw e;
            }
            // At present, in each frame, zrender performs:
            //   (1) animation step forward.
            //   (2) trigger('frame') (where this `_onframe` is called)
            //   (3) zrender flush (render).
            // If we do nothing here, since we use `setToFinal: true`, the step (3) above
            // will render the final state of the elements before the real animation started.
            this._zr.flush();
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
            $4d59907f44a2d0ad$var$flushPendingActions.call(this, silent);
            $4d59907f44a2d0ad$var$triggerUpdatedEvent.call(this, silent);
        } else if (scheduler.unfinished) {
            // Stream progress.
            var remainTime = $4d59907f44a2d0ad$var$TEST_FRAME_REMAIN_TIME;
            var ecModel = this._model;
            var api = this._api;
            scheduler.unfinished = false;
            do {
                var startTime = +new Date();
                scheduler.performSeriesTasks(ecModel);
                // Currently dataProcessorFuncs do not check threshold.
                scheduler.performDataProcessorTasks(ecModel);
                $4d59907f44a2d0ad$var$updateStreamModes(this, ecModel);
                // Do not update coordinate system here. Because that coord system update in
                // each frame is not a good user experience. So we follow the rule that
                // the extent of the coordinate system is determined in the first frame (the
                // frame is executed immediately after task reset.
                // this._coordSysMgr.update(ecModel, api);
                // console.log('--- ec frame visual ---', remainTime);
                scheduler.performVisualTasks(ecModel);
                $4d59907f44a2d0ad$var$renderSeries(this, this._model, api, "remain", {});
                remainTime -= +new Date() - startTime;
            }while (remainTime > 0 && scheduler.unfinished);
            // Call flush explicitly for trigger finished event.
            if (!scheduler.unfinished) this._zr.flush();
        // Else, zr flushing be ensue within the same frame,
        // because zr flushing is after onframe event.
        }
    };
    ECharts.prototype.getDom = function() {
        return this._dom;
    };
    ECharts.prototype.getId = function() {
        return this.id;
    };
    ECharts.prototype.getZr = function() {
        return this._zr;
    };
    ECharts.prototype.isSSR = function() {
        return this._ssr;
    };
    /* eslint-disable-next-line */ ECharts.prototype.setOption = function(option, notMerge, lazyUpdate) {
        if (this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY]) return;
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        var silent;
        var replaceMerge;
        var transitionOpt;
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(notMerge)) {
            lazyUpdate = notMerge.lazyUpdate;
            silent = notMerge.silent;
            replaceMerge = notMerge.replaceMerge;
            transitionOpt = notMerge.transition;
            notMerge = notMerge.notMerge;
        }
        this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = true;
        if (!this._model || notMerge) {
            var optionManager = new (0, $bf4c0a9077b4e970$export$2e2bcd8739ae039)(this._api);
            var theme = this._theme;
            var ecModel = this._model = new (0, $51f6ef0dd9546916$export$2e2bcd8739ae039)();
            ecModel.scheduler = this._scheduler;
            ecModel.ssr = this._ssr;
            ecModel.init(null, null, null, theme, this._locale, optionManager);
        }
        this._model.setOption(option, {
            replaceMerge: replaceMerge
        }, $4d59907f44a2d0ad$var$optionPreprocessorFuncs);
        var updateParams = {
            seriesTransition: transitionOpt,
            optionChanged: true
        };
        if (lazyUpdate) {
            this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = {
                silent: silent,
                updateParams: updateParams
            };
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            // `setOption(option, {lazyMode: true})` may be called when zrender has been slept.
            // It should wake it up to make sure zrender start to render at the next frame.
            this.getZr().wakeUp();
        } else {
            try {
                $4d59907f44a2d0ad$var$prepare(this);
                $4d59907f44a2d0ad$var$updateMethods.update.call(this, null, updateParams);
            } catch (e) {
                this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
                this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
                throw e;
            }
            // Ensure zr refresh sychronously, and then pixel in canvas can be
            // fetched after `setOption`.
            if (!this._ssr) // not use flush when using ssr mode.
            this._zr.flush();
            this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            $4d59907f44a2d0ad$var$flushPendingActions.call(this, silent);
            $4d59907f44a2d0ad$var$triggerUpdatedEvent.call(this, silent);
        }
    };
    /**
   * @deprecated
   */ ECharts.prototype.setTheme = function() {
        (0, $84bc7667c27ccedc$export$4a9c0b74eb885aa1)("ECharts#setTheme() is DEPRECATED in ECharts 3.0");
    };
    // We don't want developers to use getModel directly.
    ECharts.prototype.getModel = function() {
        return this._model;
    };
    ECharts.prototype.getOption = function() {
        return this._model && this._model.getOption();
    };
    ECharts.prototype.getWidth = function() {
        return this._zr.getWidth();
    };
    ECharts.prototype.getHeight = function() {
        return this._zr.getHeight();
    };
    ECharts.prototype.getDevicePixelRatio = function() {
        return this._zr.painter.dpr || (0, $ce6dd58693a21851$export$2e2bcd8739ae039).hasGlobalWindow && window.devicePixelRatio || 1;
    };
    /**
   * Get canvas which has all thing rendered
   * @deprecated Use renderToCanvas instead.
   */ ECharts.prototype.getRenderedCanvas = function(opts) {
        return this.renderToCanvas(opts);
    };
    ECharts.prototype.renderToCanvas = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.getRenderedCanvas({
            backgroundColor: opts.backgroundColor || this._model.get("backgroundColor"),
            pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
        });
    };
    ECharts.prototype.renderToSVGString = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.renderToString({
            useViewBox: opts.useViewBox
        });
    };
    /**
   * Get svg data url
   */ ECharts.prototype.getSvgDataURL = function() {
        if (!(0, $ce6dd58693a21851$export$2e2bcd8739ae039).svgSupported) return;
        var zr = this._zr;
        var list = zr.storage.getDisplayList();
        // Stop animations
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(list, function(el) {
            el.stopAnimation(null, true);
        });
        return zr.painter.toDataURL();
    };
    ECharts.prototype.getDataURL = function(opts) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        opts = opts || {};
        var excludeComponents = opts.excludeComponents;
        var ecModel = this._model;
        var excludesComponentViews = [];
        var self = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(excludeComponents, function(componentType) {
            ecModel.eachComponent({
                mainType: componentType
            }, function(component) {
                var view = self._componentsMap[component.__viewId];
                if (!view.group.ignore) {
                    excludesComponentViews.push(view);
                    view.group.ignore = true;
                }
            });
        });
        var url = this._zr.painter.getType() === "svg" ? this.getSvgDataURL() : this.renderToCanvas(opts).toDataURL("image/" + (opts && opts.type || "png"));
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(excludesComponentViews, function(view) {
            view.group.ignore = false;
        });
        return url;
    };
    ECharts.prototype.getConnectedDataURL = function(opts) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        var isSvg = opts.type === "svg";
        var groupId = this.group;
        var mathMin = Math.min;
        var mathMax = Math.max;
        var MAX_NUMBER = Infinity;
        if ($4d59907f44a2d0ad$var$connectedGroups[groupId]) {
            var left_1 = MAX_NUMBER;
            var top_1 = MAX_NUMBER;
            var right_1 = -MAX_NUMBER;
            var bottom_1 = -MAX_NUMBER;
            var canvasList_1 = [];
            var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$instances, function(chart, id) {
                if (chart.group === groupId) {
                    var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.renderToCanvas((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(opts));
                    var boundingRect = chart.getDom().getBoundingClientRect();
                    left_1 = mathMin(boundingRect.left, left_1);
                    top_1 = mathMin(boundingRect.top, top_1);
                    right_1 = mathMax(boundingRect.right, right_1);
                    bottom_1 = mathMax(boundingRect.bottom, bottom_1);
                    canvasList_1.push({
                        dom: canvas,
                        left: boundingRect.left,
                        top: boundingRect.top
                    });
                }
            });
            left_1 *= dpr_1;
            top_1 *= dpr_1;
            right_1 *= dpr_1;
            bottom_1 *= dpr_1;
            var width = right_1 - left_1;
            var height = bottom_1 - top_1;
            var targetCanvas = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas();
            var zr_1 = $6eba88f9eebe6af9$export$2cd8252107eb640b(targetCanvas, {
                renderer: isSvg ? "svg" : "canvas"
            });
            zr_1.resize({
                width: width,
                height: height
            });
            if (isSvg) {
                var content_1 = "";
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(canvasList_1, function(item) {
                    var x = item.left - left_1;
                    var y = item.top - top_1;
                    content_1 += '<g transform="translate(' + x + "," + y + ')">' + item.dom + "</g>";
                });
                zr_1.painter.getSvgRoot().innerHTML = content_1;
                if (opts.connectedBackgroundColor) zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
                zr_1.refreshImmediately();
                return zr_1.painter.toDataURL();
            } else {
                // Background between the charts
                if (opts.connectedBackgroundColor) zr_1.add(new $419e5ff2f303755e$export$2e2bcd8739ae039({
                    shape: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    },
                    style: {
                        fill: opts.connectedBackgroundColor
                    }
                }));
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(canvasList_1, function(item) {
                    var img = new $86adec94217b86c6$export$2e2bcd8739ae039({
                        style: {
                            x: item.left * dpr_1 - left_1,
                            y: item.top * dpr_1 - top_1,
                            image: item.dom
                        }
                    });
                    zr_1.add(img);
                });
                zr_1.refreshImmediately();
                return targetCanvas.toDataURL("image/" + (opts && opts.type || "png"));
            }
        } else return this.getDataURL(opts);
    };
    ECharts.prototype.convertToPixel = function(finder, value) {
        return $4d59907f44a2d0ad$var$doConvertPixel(this, "convertToPixel", finder, value);
    };
    ECharts.prototype.convertFromPixel = function(finder, value) {
        return $4d59907f44a2d0ad$var$doConvertPixel(this, "convertFromPixel", finder, value);
    };
    /**
   * Is the specified coordinate systems or components contain the given pixel point.
   * @param {Array|number} value
   * @return {boolean} result
   */ ECharts.prototype.containPixel = function(finder, value) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        var result;
        var findResult = $76d619f648247e6d$export$95de80076abac814(ecModel, finder);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(findResult, function(models, key) {
            key.indexOf("Models") >= 0 && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(models, function(model) {
                var coordSys = model.coordinateSystem;
                if (coordSys && coordSys.containPoint) result = result || !!coordSys.containPoint(value);
                else if (key === "seriesModels") {
                    var view = this._chartsMap[model.__viewId];
                    if (view && view.containPoint) result = result || view.containPoint(value, model);
                }
            }, this);
        }, this);
        return !!result;
    };
    /**
   * Get visual from series or data.
   * @param finder
   *        If string, e.g., 'series', means {seriesIndex: 0}.
   *        If Object, could contain some of these properties below:
   *        {
   *            seriesIndex / seriesId / seriesName,
   *            dataIndex / dataIndexInside
   *        }
   *        If dataIndex is not specified, series visual will be fetched,
   *        but not data item visual.
   *        If all of seriesIndex, seriesId, seriesName are not specified,
   *        visual will be fetched from first series.
   * @param visualType 'color', 'symbol', 'symbolSize'
   */ ECharts.prototype.getVisual = function(finder, visualType) {
        var ecModel = this._model;
        var parsedFinder = $76d619f648247e6d$export$95de80076abac814(ecModel, finder, {
            defaultMainType: "series"
        });
        var seriesModel = parsedFinder.seriesModel;
        var data = seriesModel.getData();
        var dataIndexInside = parsedFinder.hasOwnProperty("dataIndexInside") ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty("dataIndex") ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
        return dataIndexInside != null ? (0, $ea13f1ab2169d82d$export$91d919a86b2df624)(data, dataIndexInside, visualType) : (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(data, visualType);
    };
    /**
   * Get view of corresponding component model
   */ ECharts.prototype.getViewOfComponentModel = function(componentModel) {
        return this._componentsMap[componentModel.__viewId];
    };
    /**
   * Get view of corresponding series model
   */ ECharts.prototype.getViewOfSeriesModel = function(seriesModel) {
        return this._chartsMap[seriesModel.__viewId];
    };
    ECharts.prototype._initEvents = function() {
        var _this = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$MOUSE_EVENT_NAMES, function(eveName) {
            var handler = function(e) {
                var ecModel = _this.getModel();
                var el = e.target;
                var params;
                var isGlobalOut = eveName === "globalout";
                // no e.target when 'globalout'.
                if (isGlobalOut) params = {};
                else el && (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, function(parent) {
                    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(parent);
                    if (ecData && ecData.dataIndex != null) {
                        var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
                        params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType, el) || {};
                        return true;
                    } else if (ecData.eventData) {
                        params = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, ecData.eventData);
                        return true;
                    }
                }, true);
                // Contract: if params prepared in mouse event,
                // these properties must be specified:
                // {
                //    componentType: string (component main type)
                //    componentIndex: number
                // }
                // Otherwise event query can not work.
                if (params) {
                    var componentType = params.componentType;
                    var componentIndex = params.componentIndex;
                    // Special handling for historic reason: when trigger by
                    // markLine/markPoint/markArea, the componentType is
                    // 'markLine'/'markPoint'/'markArea', but we should better
                    // enable them to be queried by seriesIndex, since their
                    // option is set in each series.
                    if (componentType === "markLine" || componentType === "markPoint" || componentType === "markArea") {
                        componentType = "series";
                        componentIndex = params.seriesIndex;
                    }
                    var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
                    var view = model && _this[model.mainType === "series" ? "_chartsMap" : "_componentsMap"][model.__viewId];
                    params.event = e;
                    params.type = eveName;
                    _this._$eventProcessor.eventInfo = {
                        targetEl: el,
                        packedEvent: params,
                        model: model,
                        view: view
                    };
                    _this.trigger(eveName, params);
                }
            };
            // Consider that some component (like tooltip, brush, ...)
            // register zr event handler, but user event handler might
            // do anything, such as call `setOption` or `dispatchAction`,
            // which probably update any of the content and probably
            // cause problem if it is called previous other inner handlers.
            handler.zrEventfulCallAtLast = true;
            _this._zr.on(eveName, handler, _this);
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$eventActionMap, function(actionType, eventType) {
            _this._messageCenter.on(eventType, function(event) {
                this.trigger(eventType, event);
            }, _this);
        });
        // Extra events
        // TODO register?
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            "selectchanged"
        ], function(eventType) {
            _this._messageCenter.on(eventType, function(event) {
                this.trigger(eventType, event);
            }, _this);
        });
        (0, $e855ccf7eff48bce$export$2575c83262e49d0c)(this._messageCenter, this, this._api);
    };
    ECharts.prototype.isDisposed = function() {
        return this._disposed;
    };
    ECharts.prototype.clear = function() {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        this.setOption({
            series: []
        }, true);
    };
    ECharts.prototype.dispose = function() {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        this._disposed = true;
        var dom = this.getDom();
        if (dom) $76d619f648247e6d$export$9fec4d97f1922e0b(this.getDom(), $4d59907f44a2d0ad$var$DOM_ATTRIBUTE_KEY, "");
        var chart = this;
        var api = chart._api;
        var ecModel = chart._model;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(chart._componentsViews, function(component) {
            component.dispose(ecModel, api);
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(chart._chartsViews, function(chart) {
            chart.dispose(ecModel, api);
        });
        // Dispose after all views disposed
        chart._zr.dispose();
        // Set properties to null.
        // To reduce the memory cost in case the top code still holds this instance unexpectedly.
        chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
        delete $4d59907f44a2d0ad$var$instances[chart.id];
    };
    /**
   * Resize the chart
   */ ECharts.prototype.resize = function(opts) {
        if (this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY]) return;
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        this._zr.resize(opts);
        var ecModel = this._model;
        // Resize loading effect
        this._loadingFX && this._loadingFX.resize();
        if (!ecModel) return;
        var needPrepare = ecModel.resetOption("media");
        var silent = opts && opts.silent;
        // There is some real cases that:
        // chart.setOption(option, { lazyUpdate: true });
        // chart.resize();
        if (this[$4d59907f44a2d0ad$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$4d59907f44a2d0ad$var$PENDING_UPDATE].silent;
            needPrepare = true;
            this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
        }
        this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = true;
        try {
            needPrepare && $4d59907f44a2d0ad$var$prepare(this);
            $4d59907f44a2d0ad$var$updateMethods.update.call(this, {
                type: "resize",
                animation: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                    // Disable animation
                    duration: 0
                }, opts && opts.animation)
            });
        } catch (e) {
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            throw e;
        }
        this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
        $4d59907f44a2d0ad$var$flushPendingActions.call(this, silent);
        $4d59907f44a2d0ad$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.showLoading = function(name, cfg) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(name)) {
            cfg = name;
            name = "";
        }
        name = name || "default";
        this.hideLoading();
        if (!$4d59907f44a2d0ad$var$loadingEffects[name]) return;
        var el = $4d59907f44a2d0ad$var$loadingEffects[name](this._api, cfg);
        var zr = this._zr;
        this._loadingFX = el;
        zr.add(el);
    };
    /**
   * Hide loading effect
   */ ECharts.prototype.hideLoading = function() {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        this._loadingFX && this._zr.remove(this._loadingFX);
        this._loadingFX = null;
    };
    ECharts.prototype.makeActionFromEvent = function(eventObj) {
        var payload = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, eventObj);
        payload.type = $4d59907f44a2d0ad$var$eventActionMap[eventObj.type];
        return payload;
    };
    /**
   * @param opt If pass boolean, means opt.silent
   * @param opt.silent Default `false`. Whether trigger events.
   * @param opt.flush Default `undefined`.
   *        true: Flush immediately, and then pixel in canvas can be fetched
   *            immediately. Caution: it might affect performance.
   *        false: Not flush.
   *        undefined: Auto decide whether perform flush.
   */ ECharts.prototype.dispatchAction = function(payload, opt) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        if (!(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(opt)) opt = {
            silent: !!opt
        };
        if (!$4d59907f44a2d0ad$var$actions[payload.type]) return;
        // Avoid dispatch action before setOption. Especially in `connect`.
        if (!this._model) return;
        // May dispatchAction in rendering procedure
        if (this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY]) {
            this._pendingActions.push(payload);
            return;
        }
        var silent = opt.silent;
        $4d59907f44a2d0ad$var$doDispatchAction.call(this, payload, silent);
        var flush = opt.flush;
        if (flush) this._zr.flush();
        else if (flush !== false && (0, $ce6dd58693a21851$export$2e2bcd8739ae039).browser.weChat) // In WeChat embedded browser, `requestAnimationFrame` and `setInterval`
        // hang when sliding page (on touch event), which cause that zr does not
        // refresh until user interaction finished, which is not expected.
        // But `dispatchAction` may be called too frequently when pan on touch
        // screen, which impacts performance if do not throttle them.
        this._throttledZrFlush();
        $4d59907f44a2d0ad$var$flushPendingActions.call(this, silent);
        $4d59907f44a2d0ad$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.updateLabelLayout = function() {
        (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("series:layoutlabels", this._model, this._api, {
            // Not adding series labels.
            // TODO
            updatedSeries: []
        });
    };
    ECharts.prototype.appendData = function(params) {
        if (this._disposed) {
            $4d59907f44a2d0ad$var$disposedWarning(this.id);
            return;
        }
        var seriesIndex = params.seriesIndex;
        var ecModel = this.getModel();
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        seriesModel.appendData(params);
        // Note: `appendData` does not support that update extent of coordinate
        // system, util some scenario require that. In the expected usage of
        // `appendData`, the initial extent of coordinate system should better
        // be fixed by axis `min`/`max` setting or initial data, otherwise if
        // the extent changed while `appendData`, the location of the painted
        // graphic elements have to be changed, which make the usage of
        // `appendData` meaningless.
        this._scheduler.unfinished = true;
        this.getZr().wakeUp();
    };
    // A work around for no `internal` modifier in ts yet but
    // need to strictly hide private methods to JS users.
    ECharts.internalField = function() {
        $4d59907f44a2d0ad$var$prepare = function(ecIns) {
            var scheduler = ecIns._scheduler;
            scheduler.restorePipelines(ecIns._model);
            scheduler.prepareStageTasks();
            $4d59907f44a2d0ad$var$prepareView(ecIns, true);
            $4d59907f44a2d0ad$var$prepareView(ecIns, false);
            scheduler.plan();
        };
        /**
     * Prepare view instances of charts and components
     */ $4d59907f44a2d0ad$var$prepareView = function(ecIns, isComponent) {
            var ecModel = ecIns._model;
            var scheduler = ecIns._scheduler;
            var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
            var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
            var zr = ecIns._zr;
            var api = ecIns._api;
            for(var i = 0; i < viewList.length; i++)viewList[i].__alive = false;
            isComponent ? ecModel.eachComponent(function(componentType, model) {
                componentType !== "series" && doPrepare(model);
            }) : ecModel.eachSeries(doPrepare);
            function doPrepare(model) {
                // By default view will be reused if possible for the case that `setOption` with "notMerge"
                // mode and need to enable transition animation. (Usually, when they have the same id, or
                // especially no id but have the same type & name & index. See the `model.id` generation
                // rule in `makeIdAndName` and `viewId` generation rule here).
                // But in `replaceMerge` mode, this feature should be able to disabled when it is clear that
                // the new model has nothing to do with the old model.
                var requireNewView = model.__requireNewView;
                // This command should not work twice.
                model.__requireNewView = false;
                // Consider: id same and type changed.
                var viewId = "_ec_" + model.id + "_" + model.type;
                var view = !requireNewView && viewMap[viewId];
                if (!view) {
                    var classType = (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(model.type);
                    var Clazz = isComponent ? (0, $737c88aa0711f65a$export$2e2bcd8739ae039).getClass(classType.main, classType.sub) : // FIXME:TS
                    // (ChartView as ChartViewConstructor).getClass('series', classType.sub)
                    // For backward compat, still support a chart type declared as only subType
                    // like "liquidfill", but recommend "series.liquidfill"
                    // But need a base class to make a type series.
                    (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).getClass(classType.sub);
                    view = new Clazz();
                    view.init(ecModel, api);
                    viewMap[viewId] = view;
                    viewList.push(view);
                    zr.add(view.group);
                }
                model.__viewId = view.__id = viewId;
                view.__alive = true;
                view.__model = model;
                view.group.__ecComponentInfo = {
                    mainType: model.mainType,
                    index: model.componentIndex
                };
                !isComponent && scheduler.prepareView(view, model, ecModel, api);
            }
            for(var i = 0; i < viewList.length;){
                var view = viewList[i];
                if (!view.__alive) {
                    !isComponent && view.renderTask.dispose();
                    zr.remove(view.group);
                    view.dispose(ecModel, api);
                    viewList.splice(i, 1);
                    if (viewMap[view.__id] === view) delete viewMap[view.__id];
                    view.__id = view.group.__ecComponentInfo = null;
                } else i++;
            }
        };
        $4d59907f44a2d0ad$var$updateDirectly = function(ecIns, method, payload, mainType, subType) {
            var ecModel = ecIns._model;
            ecModel.setUpdatePayload(payload);
            // broadcast
            if (!mainType) {
                // FIXME
                // Chart will not be update directly here, except set dirty.
                // But there is no such scenario now.
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
                return;
            }
            var query = {};
            query[mainType + "Id"] = payload[mainType + "Id"];
            query[mainType + "Index"] = payload[mainType + "Index"];
            query[mainType + "Name"] = payload[mainType + "Name"];
            var condition = {
                mainType: mainType,
                query: query
            };
            subType && (condition.subType = subType); // subType may be '' by parseClassType;
            var excludeSeriesId = payload.excludeSeriesId;
            var excludeSeriesIdMap;
            if (excludeSeriesId != null) {
                excludeSeriesIdMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($76d619f648247e6d$export$4f07b212a02c8051(excludeSeriesId), function(id) {
                    var modelId = $76d619f648247e6d$export$fb1a222ba5dd6e51(id, null);
                    if (modelId != null) excludeSeriesIdMap.set(modelId, true);
                });
            }
            // If dispatchAction before setOption, do nothing.
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                if ((0, $2bf82c0980125b62$export$aebe71265c1b77bf)(payload)) {
                    if (model instanceof (0, $7c10febb2cdef0d8$export$2e2bcd8739ae039)) {
                        if (payload.type === (0, $2bf82c0980125b62$export$df035d873a9de64f) && !payload.notBlur && !model.get([
                            "emphasis",
                            "disabled"
                        ])) (0, $2bf82c0980125b62$export$64f1fd4daefef21b)(model, payload, ecIns._api);
                    } else {
                        var _a = (0, $2bf82c0980125b62$export$f31a644ccca0ef23)(model.mainType, model.componentIndex, payload.name, ecIns._api), focusSelf = _a.focusSelf, dispatchers = _a.dispatchers;
                        if (payload.type === (0, $2bf82c0980125b62$export$df035d873a9de64f) && focusSelf && !payload.notBlur) (0, $2bf82c0980125b62$export$569da03256c8a55f)(model.mainType, model.componentIndex, ecIns._api);
                        // PENDING:
                        // Whether to put this "enter emphasis" code in `ComponentView`,
                        // which will be the same as `ChartView` but might be not necessary
                        // and will be far from this logic.
                        if (dispatchers) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
                            payload.type === (0, $2bf82c0980125b62$export$df035d873a9de64f) ? (0, $2bf82c0980125b62$export$b2d02638cc34c042)(dispatcher) : (0, $2bf82c0980125b62$export$11be6f716239ac55)(dispatcher);
                        });
                    }
                } else if ((0, $2bf82c0980125b62$export$72aea10e60e45351)(payload)) // TODO geo
                {
                    if (model instanceof (0, $7c10febb2cdef0d8$export$2e2bcd8739ae039)) {
                        (0, $2bf82c0980125b62$export$1c7d489f62372d73)(model, payload, ecIns._api);
                        (0, $2bf82c0980125b62$export$e4ea08ef52e0a73)(model);
                        $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                    }
                }
            }, ecIns);
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                callView(ecIns[mainType === "series" ? "_chartsMap" : "_componentsMap"][model.__viewId]);
            }, ecIns);
            function callView(view) {
                view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
            }
        };
        $4d59907f44a2d0ad$var$updateMethods = {
            prepareAndUpdate: function(payload) {
                $4d59907f44a2d0ad$var$prepare(this);
                $4d59907f44a2d0ad$var$updateMethods.update.call(this, payload, {
                    // Needs to mark option changed if newOption is given.
                    // It's from MagicType.
                    // TODO If use a separate flag optionChanged in payload?
                    optionChanged: payload.newOption != null
                });
            },
            update: function(payload, updateParams) {
                var ecModel = this._model;
                var api = this._api;
                var zr = this._zr;
                var coordSysMgr = this._coordSysMgr;
                var scheduler = this._scheduler;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                scheduler.restoreData(ecModel, payload);
                scheduler.performSeriesTasks(ecModel);
                // TODO
                // Save total ecModel here for undo/redo (after restoring data and before processing data).
                // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
                // Create new coordinate system each update
                // In LineView may save the old coordinate system and use it to get the original point.
                coordSysMgr.create(ecModel, api);
                scheduler.performDataProcessorTasks(ecModel, payload);
                // Current stream render is not supported in data process. So we can update
                // stream modes after data processing, where the filtered data is used to
                // determine whether to use progressive rendering.
                $4d59907f44a2d0ad$var$updateStreamModes(this, ecModel);
                // We update stream modes before coordinate system updated, then the modes info
                // can be fetched when coord sys updating (consider the barGrid extent fix). But
                // the drawback is the full coord info can not be fetched. Fortunately this full
                // coord is not required in stream mode updater currently.
                coordSysMgr.update(ecModel, api);
                clearColorPalette(ecModel);
                scheduler.performVisualTasks(ecModel, payload);
                $4d59907f44a2d0ad$var$render(this, ecModel, api, payload, updateParams);
                // Set background
                var backgroundColor = ecModel.get("backgroundColor") || "transparent";
                var darkMode = ecModel.get("darkMode");
                zr.setBackgroundColor(backgroundColor);
                // Force set dark mode.
                if (darkMode != null && darkMode !== "auto") zr.setDarkMode(darkMode);
                (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("afterupdate", ecModel, api);
            },
            updateTransform: function(payload) {
                var _this = this;
                var ecModel = this._model;
                var api = this._api;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // ChartView.markUpdateMethod(payload, 'updateTransform');
                var componentDirtyList = [];
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType === "series") return;
                    var componentView = _this.getViewOfComponentModel(componentModel);
                    if (componentView && componentView.__alive) {
                        if (componentView.updateTransform) {
                            var result = componentView.updateTransform(componentModel, ecModel, api, payload);
                            result && result.update && componentDirtyList.push(componentView);
                        } else componentDirtyList.push(componentView);
                    }
                });
                var seriesDirtyMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    if (chartView.updateTransform) {
                        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
                        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
                    } else seriesDirtyMap.set(seriesModel.uid, 1);
                });
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true,
                    dirtyMap: seriesDirtyMap
                });
                // Currently, not call render of components. Geo render cost a lot.
                // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
                $4d59907f44a2d0ad$var$renderSeries(this, ecModel, api, payload, {}, seriesDirtyMap);
                (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("afterupdate", ecModel, api);
            },
            updateView: function(payload) {
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).markUpdateMethod(payload, "updateView");
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true
                });
                $4d59907f44a2d0ad$var$render(this, ecModel, this._api, payload, {});
                (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("afterupdate", ecModel, this._api);
            },
            updateVisual: function(payload) {
                // updateMethods.update.call(this, payload);
                var _this = this;
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // clear all visual
                ecModel.eachSeries(function(seriesModel) {
                    seriesModel.getData().clearAllVisual();
                });
                // Perform visual
                (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).markUpdateMethod(payload, "updateVisual");
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    visualType: "visual",
                    setDirty: true
                });
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType !== "series") {
                        var componentView = _this.getViewOfComponentModel(componentModel);
                        componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
                    }
                });
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
                });
                (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("afterupdate", ecModel, this._api);
            },
            updateLayout: function(payload) {
                $4d59907f44a2d0ad$var$updateMethods.update.call(this, payload);
            }
        };
        $4d59907f44a2d0ad$var$doConvertPixel = function(ecIns, methodName, finder, value) {
            if (ecIns._disposed) {
                $4d59907f44a2d0ad$var$disposedWarning(ecIns.id);
                return;
            }
            var ecModel = ecIns._model;
            var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();
            var result;
            var parsedFinder = $76d619f648247e6d$export$95de80076abac814(ecModel, finder);
            for(var i = 0; i < coordSysList.length; i++){
                var coordSys = coordSysList[i];
                if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value)) != null) return result;
            }
        };
        $4d59907f44a2d0ad$var$updateStreamModes = function(ecIns, ecModel) {
            var chartsMap = ecIns._chartsMap;
            var scheduler = ecIns._scheduler;
            ecModel.eachSeries(function(seriesModel) {
                scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
            });
        };
        $4d59907f44a2d0ad$var$doDispatchAction = function(payload, silent) {
            var _this = this;
            var ecModel = this.getModel();
            var payloadType = payload.type;
            var escapeConnect = payload.escapeConnect;
            var actionWrap = $4d59907f44a2d0ad$var$actions[payloadType];
            var actionInfo = actionWrap.actionInfo;
            var cptTypeTmp = (actionInfo.update || "update").split(":");
            var updateMethod = cptTypeTmp.pop();
            var cptType = cptTypeTmp[0] != null && (0, $cd5f95cf03b4e3e7$export$fbe18865d303bf01)(cptTypeTmp[0]);
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = true;
            var payloads = [
                payload
            ];
            var batched = false;
            // Batch action
            if (payload.batch) {
                batched = true;
                payloads = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(payload.batch, function(item) {
                    item = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, item), payload);
                    item.batch = null;
                    return item;
                });
            }
            var eventObjBatch = [];
            var eventObj;
            var isSelectChange = (0, $2bf82c0980125b62$export$72aea10e60e45351)(payload);
            var isHighDown = (0, $2bf82c0980125b62$export$aebe71265c1b77bf)(payload);
            // Only leave blur once if there are multiple batches.
            if (isHighDown) (0, $2bf82c0980125b62$export$b2a593c7b5243584)(this._api);
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(payloads, function(batchItem) {
                // Action can specify the event by return it.
                eventObj = actionWrap.action(batchItem, _this._model, _this._api);
                // Emit event outside
                eventObj = eventObj || (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, batchItem);
                // Convert type to eventType
                eventObj.type = actionInfo.event || eventObj.type;
                eventObjBatch.push(eventObj);
                // light update does not perform data process, layout and visual.
                if (isHighDown) {
                    var _a = $76d619f648247e6d$export$fe600815775d9400(payload), queryOptionMap = _a.queryOptionMap, mainTypeSpecified = _a.mainTypeSpecified;
                    var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : "series";
                    $4d59907f44a2d0ad$var$updateDirectly(_this, updateMethod, batchItem, componentMainType);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(_this);
                } else if (isSelectChange) {
                    // At present `dispatchAction({ type: 'select', ... })` is not supported on components.
                    // geo still use 'geoselect'.
                    $4d59907f44a2d0ad$var$updateDirectly(_this, updateMethod, batchItem, "series");
                    $4d59907f44a2d0ad$var$markStatusToUpdate(_this);
                } else if (cptType) $4d59907f44a2d0ad$var$updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
            });
            if (updateMethod !== "none" && !isHighDown && !isSelectChange && !cptType) try {
                // Still dirty
                if (this[$4d59907f44a2d0ad$var$PENDING_UPDATE]) {
                    $4d59907f44a2d0ad$var$prepare(this);
                    $4d59907f44a2d0ad$var$updateMethods.update.call(this, payload);
                    this[$4d59907f44a2d0ad$var$PENDING_UPDATE] = null;
                } else $4d59907f44a2d0ad$var$updateMethods[updateMethod].call(this, payload);
            } catch (e) {
                this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
                throw e;
            }
            // Follow the rule of action batch
            if (batched) eventObj = {
                type: actionInfo.event || payloadType,
                escapeConnect: escapeConnect,
                batch: eventObjBatch
            };
            else eventObj = eventObjBatch[0];
            this[$4d59907f44a2d0ad$var$IN_MAIN_PROCESS_KEY] = false;
            if (!silent) {
                var messageCenter = this._messageCenter;
                messageCenter.trigger(eventObj.type, eventObj);
                // Extra triggered 'selectchanged' event
                if (isSelectChange) {
                    var newObj = {
                        type: "selectchanged",
                        escapeConnect: escapeConnect,
                        selected: (0, $2bf82c0980125b62$export$c529643b619af6b3)(ecModel),
                        isFromClick: payload.isFromClick || false,
                        fromAction: payload.type,
                        fromActionPayload: payload
                    };
                    messageCenter.trigger(newObj.type, newObj);
                }
            }
        };
        $4d59907f44a2d0ad$var$flushPendingActions = function(silent) {
            var pendingActions = this._pendingActions;
            while(pendingActions.length){
                var payload = pendingActions.shift();
                $4d59907f44a2d0ad$var$doDispatchAction.call(this, payload, silent);
            }
        };
        $4d59907f44a2d0ad$var$triggerUpdatedEvent = function(silent) {
            !silent && this.trigger("updated");
        };
        /**
     * Event `rendered` is triggered when zr
     * rendered. It is useful for realtime
     * snapshot (reflect animation).
     *
     * Event `finished` is triggered when:
     * (1) zrender rendering finished.
     * (2) initial animation finished.
     * (3) progressive rendering finished.
     * (4) no pending action.
     * (5) no delayed setOption needs to be processed.
     */ $4d59907f44a2d0ad$var$bindRenderedEvent = function(zr, ecIns) {
            zr.on("rendered", function(params) {
                ecIns.trigger("rendered", params);
                // The `finished` event should not be triggered repeatedly,
                // so it should only be triggered when rendering indeed happens
                // in zrender. (Consider the case that dipatchAction is keep
                // triggering when mouse move).
                if (// Although zr is dirty if initial animation is not finished
                // and this checking is called on frame, we also check
                // animation finished for robustness.
                zr.animation.isFinished() && !ecIns[$4d59907f44a2d0ad$var$PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) ecIns.trigger("finished");
            });
        };
        $4d59907f44a2d0ad$var$bindMouseEvent = function(zr, ecIns) {
            zr.on("mouseover", function(e) {
                var el = e.target;
                var dispatcher = (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, (0, $2bf82c0980125b62$export$77d1445f699c58b5));
                if (dispatcher) {
                    (0, $2bf82c0980125b62$export$416765b6198234ff)(dispatcher, e, ecIns._api);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                }
            }).on("mouseout", function(e) {
                var el = e.target;
                var dispatcher = (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, (0, $2bf82c0980125b62$export$77d1445f699c58b5));
                if (dispatcher) {
                    (0, $2bf82c0980125b62$export$bb1c7b62436282a)(dispatcher, e, ecIns._api);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                }
            }).on("click", function(e) {
                var el = e.target;
                var dispatcher = (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, function(target) {
                    return (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(target).dataIndex != null;
                }, true);
                if (dispatcher) {
                    var actionType = dispatcher.selected ? "unselect" : "select";
                    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatcher);
                    ecIns._api.dispatchAction({
                        type: actionType,
                        dataType: ecData.dataType,
                        dataIndexInside: ecData.dataIndex,
                        seriesIndex: ecData.seriesIndex,
                        isFromClick: true
                    });
                }
            });
        };
        function clearColorPalette(ecModel) {
            ecModel.clearColorPalette();
            ecModel.eachSeries(function(seriesModel) {
                seriesModel.clearColorPalette();
            });
        }
        // Allocate zlevels for series and components
        function allocateZlevels(ecModel) {
            var componentZLevels = [];
            var seriesZLevels = [];
            var hasSeparateZLevel = false;
            ecModel.eachComponent(function(componentType, componentModel) {
                var zlevel = componentModel.get("zlevel") || 0;
                var z = componentModel.get("z") || 0;
                var zlevelKey = componentModel.getZLevelKey();
                hasSeparateZLevel = hasSeparateZLevel || !!zlevelKey;
                (componentType === "series" ? seriesZLevels : componentZLevels).push({
                    zlevel: zlevel,
                    z: z,
                    idx: componentModel.componentIndex,
                    type: componentType,
                    key: zlevelKey
                });
            });
            if (hasSeparateZLevel) {
                // Series after component
                var zLevels = componentZLevels.concat(seriesZLevels);
                var lastSeriesZLevel_1;
                var lastSeriesKey_1;
                (0, $97579a54749e4b24$export$2e2bcd8739ae039)(zLevels, function(a, b) {
                    if (a.zlevel === b.zlevel) return a.z - b.z;
                    return a.zlevel - b.zlevel;
                });
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(zLevels, function(item) {
                    var componentModel = ecModel.getComponent(item.type, item.idx);
                    var zlevel = item.zlevel;
                    var key = item.key;
                    if (lastSeriesZLevel_1 != null) zlevel = Math.max(lastSeriesZLevel_1, zlevel);
                    if (key) {
                        if (zlevel === lastSeriesZLevel_1 && key !== lastSeriesKey_1) zlevel++;
                        lastSeriesKey_1 = key;
                    } else if (lastSeriesKey_1) {
                        if (zlevel === lastSeriesZLevel_1) zlevel++;
                        lastSeriesKey_1 = "";
                    }
                    lastSeriesZLevel_1 = zlevel;
                    componentModel.setZLevel(zlevel);
                });
            }
        }
        $4d59907f44a2d0ad$var$render = function(ecIns, ecModel, api, payload, updateParams) {
            allocateZlevels(ecModel);
            $4d59907f44a2d0ad$var$renderComponents(ecIns, ecModel, api, payload, updateParams);
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ecIns._chartsViews, function(chart) {
                chart.__alive = false;
            });
            $4d59907f44a2d0ad$var$renderSeries(ecIns, ecModel, api, payload, updateParams);
            // Remove groups of unrendered charts
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ecIns._chartsViews, function(chart) {
                if (!chart.__alive) chart.remove(ecModel, api);
            });
        };
        $4d59907f44a2d0ad$var$renderComponents = function(ecIns, ecModel, api, payload, updateParams, dirtyList) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dirtyList || ecIns._componentsViews, function(componentView) {
                var componentModel = componentView.__model;
                clearStates(componentModel, componentView);
                componentView.render(componentModel, ecModel, api, payload);
                updateZ(componentModel, componentView);
                updateStates(componentModel, componentView);
            });
        };
        /**
     * Render each chart and component
     */ $4d59907f44a2d0ad$var$renderSeries = function(ecIns, ecModel, api, payload, updateParams, dirtyMap) {
            // Render all charts
            var scheduler = ecIns._scheduler;
            updateParams = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(updateParams || {}, {
                updatedSeries: ecModel.getSeries()
            });
            // TODO progressive?
            (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("series:beforeupdate", ecModel, api, updateParams);
            var unfinished = false;
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                chartView.__alive = true;
                var renderTask = chartView.renderTask;
                scheduler.updatePayload(renderTask, payload);
                // TODO states on marker.
                clearStates(seriesModel, chartView);
                if (dirtyMap && dirtyMap.get(seriesModel.uid)) renderTask.dirty();
                if (renderTask.perform(scheduler.getPerformArgs(renderTask))) unfinished = true;
                chartView.group.silent = !!seriesModel.get("silent");
                // Should not call markRedraw on group, because it will disable zrender
                // incremental render (always render from the __startIndex each frame)
                // chartView.group.markRedraw();
                updateBlend(seriesModel, chartView);
                (0, $2bf82c0980125b62$export$e4ea08ef52e0a73)(seriesModel);
            });
            scheduler.unfinished = unfinished || scheduler.unfinished;
            (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("series:layoutlabels", ecModel, api, updateParams);
            // transition after label is layouted.
            (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("series:transition", ecModel, api, updateParams);
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                // Update Z after labels updated. Before applying states.
                updateZ(seriesModel, chartView);
                // NOTE: Update states after label is updated.
                // label should be in normal status when layouting.
                updateStates(seriesModel, chartView);
            });
            // If use hover layer
            updateHoverLayerStatus(ecIns, ecModel);
            (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("series:afterupdate", ecModel, api, updateParams);
        };
        $4d59907f44a2d0ad$var$markStatusToUpdate = function(ecIns) {
            ecIns[$4d59907f44a2d0ad$var$STATUS_NEEDS_UPDATE_KEY] = true;
            // Wake up zrender if it's sleep. Let it update states in the next frame.
            ecIns.getZr().wakeUp();
        };
        $4d59907f44a2d0ad$var$applyChangedStates = function(ecIns) {
            if (!ecIns[$4d59907f44a2d0ad$var$STATUS_NEEDS_UPDATE_KEY]) return;
            ecIns.getZr().storage.traverse(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($8b353638fbedfefa$export$5b89d4b643713034(el)) return;
                applyElementStates(el);
            });
            ecIns[$4d59907f44a2d0ad$var$STATUS_NEEDS_UPDATE_KEY] = false;
        };
        function applyElementStates(el) {
            var newStates = [];
            var oldStates = el.currentStates;
            // Keep other states.
            for(var i = 0; i < oldStates.length; i++){
                var stateName = oldStates[i];
                if (!(stateName === "emphasis" || stateName === "blur" || stateName === "select")) newStates.push(stateName);
            }
            // Only use states when it's exists.
            if (el.selected && el.states.select) newStates.push("select");
            if (el.hoverState === (0, $2bf82c0980125b62$export$f0f2bee145debb31) && el.states.emphasis) newStates.push("emphasis");
            else if (el.hoverState === (0, $2bf82c0980125b62$export$1307d6a87d56baa) && el.states.blur) newStates.push("blur");
            el.useStates(newStates);
        }
        function updateHoverLayerStatus(ecIns, ecModel) {
            var zr = ecIns._zr;
            var storage = zr.storage;
            var elCount = 0;
            storage.traverse(function(el) {
                if (!el.isGroup) elCount++;
            });
            if (elCount > ecModel.get("hoverLayerThreshold") && !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).node && !(0, $ce6dd58693a21851$export$2e2bcd8739ae039).worker) ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.preventUsingHoverLayer) return;
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                if (chartView.__alive) chartView.eachRendered(function(el) {
                    if (el.states.emphasis) el.states.emphasis.hoverLayer = true;
                });
            });
        }
        /**
     * Update chart and blend.
     */ function updateBlend(seriesModel, chartView) {
            var blendMode = seriesModel.get("blendMode") || null;
            chartView.eachRendered(function(el) {
                // FIXME marker and other components
                if (!el.isGroup) // DON'T mark the element dirty. In case element is incremental and don't want to rerender.
                el.style.blend = blendMode;
            });
        }
        function updateZ(model, view) {
            if (model.preventAutoZ) return;
            var z = model.get("z") || 0;
            var zlevel = model.get("zlevel") || 0;
            // Set z and zlevel
            view.eachRendered(function(el) {
                doUpdateZ(el, z, zlevel, -Infinity);
                // Don't traverse the children because it has been traversed in _updateZ.
                return true;
            });
        }
        function doUpdateZ(el, z, zlevel, maxZ2) {
            // Group may also have textContent
            var label = el.getTextContent();
            var labelLine = el.getTextGuideLine();
            var isGroup = el.isGroup;
            if (isGroup) {
                // set z & zlevel of children elements of Group
                var children = el.childrenRef();
                for(var i = 0; i < children.length; i++)maxZ2 = Math.max(doUpdateZ(children[i], z, zlevel, maxZ2), maxZ2);
            } else {
                // not Group
                el.z = z;
                el.zlevel = zlevel;
                maxZ2 = Math.max(el.z2, maxZ2);
            }
            // always set z and zlevel if label/labelLine exists
            if (label) {
                label.z = z;
                label.zlevel = zlevel;
                // lift z2 of text content
                // TODO if el.emphasis.z2 is spcefied, what about textContent.
                isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
            }
            if (labelLine) {
                var textGuideLineConfig = el.textGuideLineConfig;
                labelLine.z = z;
                labelLine.zlevel = zlevel;
                isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
            }
            return maxZ2;
        }
        // Clear states without animation.
        // TODO States on component.
        function clearStates(model, view) {
            view.eachRendered(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($8b353638fbedfefa$export$5b89d4b643713034(el)) return;
                var textContent = el.getTextContent();
                var textGuide = el.getTextGuideLine();
                if (el.stateTransition) el.stateTransition = null;
                if (textContent && textContent.stateTransition) textContent.stateTransition = null;
                if (textGuide && textGuide.stateTransition) textGuide.stateTransition = null;
                // TODO If el is incremental.
                if (el.hasState()) {
                    el.prevStates = el.currentStates;
                    el.clearStates();
                } else if (el.prevStates) el.prevStates = null;
            });
        }
        function updateStates(model, view) {
            var stateAnimationModel = model.getModel("stateAnimation");
            var enableAnimation = model.isAnimationEnabled();
            var duration = stateAnimationModel.get("duration");
            var stateTransition = duration > 0 ? {
                duration: duration,
                delay: stateAnimationModel.get("delay"),
                easing: stateAnimationModel.get("easing")
            } : null;
            view.eachRendered(function(el) {
                if (el.states && el.states.emphasis) {
                    // Not applied on removed elements, it may still in fading.
                    if ($8b353638fbedfefa$export$5b89d4b643713034(el)) return;
                    if (el instanceof $b02ffe7acd508c08$export$2e2bcd8739ae039) (0, $2bf82c0980125b62$export$9fe78019e6f395b6)(el);
                    // Only updated on changed element. In case element is incremental and don't want to rerender.
                    // TODO, a more proper way?
                    if (el.__dirty) {
                        var prevStates = el.prevStates;
                        // Restore states without animation
                        if (prevStates) el.useStates(prevStates);
                    }
                    // Update state transition and enable animation again.
                    if (enableAnimation) {
                        el.stateTransition = stateTransition;
                        var textContent = el.getTextContent();
                        var textGuide = el.getTextGuideLine();
                        // TODO Is it necessary to animate label?
                        if (textContent) textContent.stateTransition = stateTransition;
                        if (textGuide) textGuide.stateTransition = stateTransition;
                    }
                    // Use highlighted and selected flag to toggle states.
                    if (el.__dirty) applyElementStates(el);
                }
            });
        }
        $4d59907f44a2d0ad$var$createExtensionAPI = function(ecIns) {
            return new /** @class */ (function(_super) {
                (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(class_1, _super);
                function class_1() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                class_1.prototype.getCoordinateSystems = function() {
                    return ecIns._coordSysMgr.getCoordinateSystems();
                };
                class_1.prototype.getComponentByElement = function(el) {
                    while(el){
                        var modelInfo = el.__ecComponentInfo;
                        if (modelInfo != null) return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
                        el = el.parent;
                    }
                };
                class_1.prototype.enterEmphasis = function(el, highlightDigit) {
                    (0, $2bf82c0980125b62$export$b2d02638cc34c042)(el, highlightDigit);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveEmphasis = function(el, highlightDigit) {
                    (0, $2bf82c0980125b62$export$11be6f716239ac55)(el, highlightDigit);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterBlur = function(el) {
                    (0, $2bf82c0980125b62$export$207f9cb3e1099375)(el);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveBlur = function(el) {
                    (0, $2bf82c0980125b62$export$fd4a9ec75456d3c1)(el);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterSelect = function(el) {
                    (0, $2bf82c0980125b62$export$252d028dda8ef765)(el);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveSelect = function(el) {
                    (0, $2bf82c0980125b62$export$ea9a904bd6e32bd3)(el);
                    $4d59907f44a2d0ad$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.getModel = function() {
                    return ecIns.getModel();
                };
                class_1.prototype.getViewOfComponentModel = function(componentModel) {
                    return ecIns.getViewOfComponentModel(componentModel);
                };
                class_1.prototype.getViewOfSeriesModel = function(seriesModel) {
                    return ecIns.getViewOfSeriesModel(seriesModel);
                };
                return class_1;
            }((0, $a6d7e6163195660e$export$2e2bcd8739ae039)))(ecIns);
        };
        $4d59907f44a2d0ad$var$enableConnect = function(chart) {
            function updateConnectedChartsStatus(charts, status) {
                for(var i = 0; i < charts.length; i++){
                    var otherChart = charts[i];
                    otherChart[$4d59907f44a2d0ad$var$CONNECT_STATUS_KEY] = status;
                }
            }
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$eventActionMap, function(actionType, eventType) {
                chart._messageCenter.on(eventType, function(event) {
                    if ($4d59907f44a2d0ad$var$connectedGroups[chart.group] && chart[$4d59907f44a2d0ad$var$CONNECT_STATUS_KEY] !== $4d59907f44a2d0ad$var$CONNECT_STATUS_PENDING) {
                        if (event && event.escapeConnect) return;
                        var action_1 = chart.makeActionFromEvent(event);
                        var otherCharts_1 = [];
                        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4d59907f44a2d0ad$var$instances, function(otherChart) {
                            if (otherChart !== chart && otherChart.group === chart.group) otherCharts_1.push(otherChart);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $4d59907f44a2d0ad$var$CONNECT_STATUS_PENDING);
                        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(otherCharts_1, function(otherChart) {
                            if (otherChart[$4d59907f44a2d0ad$var$CONNECT_STATUS_KEY] !== $4d59907f44a2d0ad$var$CONNECT_STATUS_UPDATING) otherChart.dispatchAction(action_1);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $4d59907f44a2d0ad$var$CONNECT_STATUS_UPDATED);
                    }
                });
            });
        };
    }();
    return ECharts;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $4d59907f44a2d0ad$var$echartsProto = $4d59907f44a2d0ad$var$ECharts.prototype;
$4d59907f44a2d0ad$var$echartsProto.on = $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseECharts("on");
$4d59907f44a2d0ad$var$echartsProto.off = $4d59907f44a2d0ad$var$createRegisterEventWithLowercaseECharts("off");
/**
 * @deprecated
 */ // @ts-ignore
$4d59907f44a2d0ad$var$echartsProto.one = function(eventName, cb, ctx) {
    var self = this;
    (0, $84bc7667c27ccedc$export$4a9c0b74eb885aa1)("ECharts#one is deprecated.");
    function wrapped() {
        var args2 = [];
        for(var _i = 0; _i < arguments.length; _i++)args2[_i] = arguments[_i];
        cb && cb.apply && cb.apply(this, args2);
        // @ts-ignore
        self.off(eventName, wrapped);
    }
    // @ts-ignore
    this.on.call(this, eventName, wrapped, ctx);
};
var $4d59907f44a2d0ad$var$MOUSE_EVENT_NAMES = [
    "click",
    "dblclick",
    "mouseover",
    "mouseout",
    "mousemove",
    "mousedown",
    "mouseup",
    "globalout",
    "contextmenu"
];
function $4d59907f44a2d0ad$var$disposedWarning(id) {}
var $4d59907f44a2d0ad$var$actions = {};
/**
 * Map eventType to actionType
 */ var $4d59907f44a2d0ad$var$eventActionMap = {};
var $4d59907f44a2d0ad$var$dataProcessorFuncs = [];
var $4d59907f44a2d0ad$var$optionPreprocessorFuncs = [];
var $4d59907f44a2d0ad$var$visualFuncs = [];
var $4d59907f44a2d0ad$var$themeStorage = {};
var $4d59907f44a2d0ad$var$loadingEffects = {};
var $4d59907f44a2d0ad$var$instances = {};
var $4d59907f44a2d0ad$var$connectedGroups = {};
var $4d59907f44a2d0ad$var$idBase = +new Date() - 0;
var $4d59907f44a2d0ad$var$groupIdBase = +new Date() - 0;
var $4d59907f44a2d0ad$var$DOM_ATTRIBUTE_KEY = "_echarts_instance_";
function $4d59907f44a2d0ad$export$2cd8252107eb640b(dom, theme, opts) {
    var isClient = !(opts && opts.ssr);
    if (isClient) {
        var existInstance = $4d59907f44a2d0ad$export$33b6fbccd4f643f8(dom);
        if (existInstance) return existInstance;
    }
    var chart = new $4d59907f44a2d0ad$var$ECharts(dom, theme, opts);
    chart.id = "ec_" + $4d59907f44a2d0ad$var$idBase++;
    $4d59907f44a2d0ad$var$instances[chart.id] = chart;
    isClient && $76d619f648247e6d$export$9fec4d97f1922e0b(dom, $4d59907f44a2d0ad$var$DOM_ATTRIBUTE_KEY, chart.id);
    $4d59907f44a2d0ad$var$enableConnect(chart);
    (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).trigger("afterinit", chart);
    return chart;
}
function $4d59907f44a2d0ad$export$64605811ab45167f(groupId) {
    // Is array of charts
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(groupId)) {
        var charts = groupId;
        groupId = null;
        // If any chart has group
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(charts, function(chart) {
            if (chart.group != null) groupId = chart.group;
        });
        groupId = groupId || "g_" + $4d59907f44a2d0ad$var$groupIdBase++;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(charts, function(chart) {
            chart.group = groupId;
        });
    }
    $4d59907f44a2d0ad$var$connectedGroups[groupId] = true;
    return groupId;
}
function $4d59907f44a2d0ad$export$37dfea93db2e14ed(groupId) {
    $4d59907f44a2d0ad$var$connectedGroups[groupId] = false;
}
var $4d59907f44a2d0ad$export$87cd6834112ecb52 = $4d59907f44a2d0ad$export$37dfea93db2e14ed;
function $4d59907f44a2d0ad$export$fcfbbcec2cb820d5(chart) {
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(chart)) chart = $4d59907f44a2d0ad$var$instances[chart];
    else if (!(chart instanceof $4d59907f44a2d0ad$var$ECharts)) // Try to treat as dom
    chart = $4d59907f44a2d0ad$export$33b6fbccd4f643f8(chart);
    if (chart instanceof $4d59907f44a2d0ad$var$ECharts && !chart.isDisposed()) chart.dispose();
}
function $4d59907f44a2d0ad$export$33b6fbccd4f643f8(dom) {
    return $4d59907f44a2d0ad$var$instances[$76d619f648247e6d$export$735ee1799fd02602(dom, $4d59907f44a2d0ad$var$DOM_ATTRIBUTE_KEY)];
}
function $4d59907f44a2d0ad$export$89b4be35062c4a3f(key) {
    return $4d59907f44a2d0ad$var$instances[key];
}
function $4d59907f44a2d0ad$export$f9c59eed5de5ff80(name, theme) {
    $4d59907f44a2d0ad$var$themeStorage[name] = theme;
}
function $4d59907f44a2d0ad$export$77095792a057b768(preprocessorFunc) {
    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($4d59907f44a2d0ad$var$optionPreprocessorFuncs, preprocessorFunc) < 0) $4d59907f44a2d0ad$var$optionPreprocessorFuncs.push(preprocessorFunc);
}
function $4d59907f44a2d0ad$export$d575e6557ac1729f(priority, processor) {
    $4d59907f44a2d0ad$var$normalizeRegister($4d59907f44a2d0ad$var$dataProcessorFuncs, priority, processor, $4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_DEFAULT);
}
function $4d59907f44a2d0ad$export$c8c249911ee8c1ed(postInitFunc) {
    $4d59907f44a2d0ad$export$c9ec4b5faef04865("afterinit", postInitFunc);
}
function $4d59907f44a2d0ad$export$99560909c18c76bb(postUpdateFunc) {
    $4d59907f44a2d0ad$export$c9ec4b5faef04865("afterupdate", postUpdateFunc);
}
function $4d59907f44a2d0ad$export$c9ec4b5faef04865(name, cb) {
    (0, $8022924a3c5c0bb5$export$2e2bcd8739ae039).on(name, cb);
}
function $4d59907f44a2d0ad$export$408c24786cd729c6(actionInfo, eventName, action) {
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(eventName)) {
        action = eventName;
        eventName = "";
    }
    var actionType = (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(actionInfo) ? actionInfo.type : [
        actionInfo,
        actionInfo = {
            event: eventName
        }
    ][0];
    // Event name is all lowercase
    actionInfo.event = (actionInfo.event || actionType).toLowerCase();
    eventName = actionInfo.event;
    if ($4d59907f44a2d0ad$var$eventActionMap[eventName]) // Already registered.
    return;
    // Validate action type and event name.
    (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)($4d59907f44a2d0ad$var$ACTION_REG.test(actionType) && $4d59907f44a2d0ad$var$ACTION_REG.test(eventName));
    if (!$4d59907f44a2d0ad$var$actions[actionType]) $4d59907f44a2d0ad$var$actions[actionType] = {
        action: action,
        actionInfo: actionInfo
    };
    $4d59907f44a2d0ad$var$eventActionMap[eventName] = actionType;
}
function $4d59907f44a2d0ad$export$1dd5e025a8a37dd(type, coordSysCreator) {
    (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).register(type, coordSysCreator);
}
function $4d59907f44a2d0ad$export$fc2638719e4159b9(type) {
    var coordSysCreator = (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).get(type);
    if (coordSysCreator) return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
}
function $4d59907f44a2d0ad$export$d768f97700ca6bea(priority, layoutTask) {
    $4d59907f44a2d0ad$var$normalizeRegister($4d59907f44a2d0ad$var$visualFuncs, priority, layoutTask, $4d59907f44a2d0ad$var$PRIORITY_VISUAL_LAYOUT, "layout");
}
function $4d59907f44a2d0ad$export$5f32c1eb94c381bb(priority, visualTask) {
    $4d59907f44a2d0ad$var$normalizeRegister($4d59907f44a2d0ad$var$visualFuncs, priority, visualTask, $4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART, "visual");
}
var $4d59907f44a2d0ad$var$registeredTasks = [];
function $4d59907f44a2d0ad$var$normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(priority) || (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(priority)) {
        fn = priority;
        priority = defaultPriority;
    }
    // Already registered
    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($4d59907f44a2d0ad$var$registeredTasks, fn) >= 0) return;
    $4d59907f44a2d0ad$var$registeredTasks.push(fn);
    var stageHandler = (0, $94ae4e8744638a8a$export$2e2bcd8739ae039).wrapStageHandler(fn, visualType);
    stageHandler.__prio = priority;
    stageHandler.__raw = fn;
    targetList.push(stageHandler);
}
function $4d59907f44a2d0ad$export$e06b68a82007c015(name, loadingFx) {
    $4d59907f44a2d0ad$var$loadingEffects[name] = loadingFx;
}
function $4d59907f44a2d0ad$export$10425ea7a243b114(creator) {
    (0, $c6341dcc9d86826e$export$61bcfd79465c1b7c)({
        createCanvas: creator
    });
}
function $4d59907f44a2d0ad$export$d456de060be2dba1(mapName, geoJson, specialAreas) {
    var registerMap = (0, $f773aa0508c1d920$export$73333eb8a09d5f61)("registerMap");
    registerMap && registerMap(mapName, geoJson, specialAreas);
}
function $4d59907f44a2d0ad$export$b8586192aead8a7e(mapName) {
    var getMap = (0, $f773aa0508c1d920$export$73333eb8a09d5f61)("getMap");
    return getMap && getMap(mapName);
}
var $4d59907f44a2d0ad$export$f01d71dd0389d7e4 = (0, $523dedd0a2328c06$export$92c96c6d8b255b7d);
/**
 * Globa dispatchAction to a specified chart instance.
 */ // export function dispatchAction(payload: { chartId: string } & Payload, opt?: Parameters<ECharts['dispatchAction']>[1]) {
//     if (!payload || !payload.chartId) {
//         // Must have chartId to find chart
//         return;
//     }
//     const chart = instances[payload.chartId];
//     if (chart) {
//         chart.dispatchAction(payload, opt);
//     }
// }
// Builtin global visual
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_GLOBAL, (0, $a617f62dd17b10f1$export$7ce4d65f9b69240));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $a617f62dd17b10f1$export$f7dcb66a065003d1));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $a617f62dd17b10f1$export$cf9758b0d6dc0aa9));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_GLOBAL, (0, $f8e1f1a448782588$export$144ac3beded415d9));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $f8e1f1a448782588$export$435b956f7f1071fb));
$4d59907f44a2d0ad$export$5f32c1eb94c381bb($4d59907f44a2d0ad$var$PRIORITY_VISUAL_DECAL, (0, $d82adaf1a5a5cfeb$export$2e2bcd8739ae039));
$4d59907f44a2d0ad$export$77095792a057b768((0, $c4489ebdf95633b6$export$2e2bcd8739ae039));
$4d59907f44a2d0ad$export$d575e6557ac1729f($4d59907f44a2d0ad$var$PRIORITY_PROCESSOR_DATASTACK, (0, $92eb0b43a1e7607a$export$2e2bcd8739ae039));
$4d59907f44a2d0ad$export$e06b68a82007c015("default", (0, $f23f99c31dceac8f$export$2e2bcd8739ae039));
// Default actions
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$df035d873a9de64f),
    event: (0, $2bf82c0980125b62$export$df035d873a9de64f),
    update: (0, $2bf82c0980125b62$export$df035d873a9de64f)
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$f8a2f7807cc185ea),
    event: (0, $2bf82c0980125b62$export$f8a2f7807cc185ea),
    update: (0, $2bf82c0980125b62$export$f8a2f7807cc185ea)
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$89616263e7d38fe9),
    event: (0, $2bf82c0980125b62$export$89616263e7d38fe9),
    update: (0, $2bf82c0980125b62$export$89616263e7d38fe9)
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$7636ad95c0f68a79),
    event: (0, $2bf82c0980125b62$export$7636ad95c0f68a79),
    update: (0, $2bf82c0980125b62$export$7636ad95c0f68a79)
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: (0, $2bf82c0980125b62$export$1e90ed8a25542516),
    event: (0, $2bf82c0980125b62$export$1e90ed8a25542516),
    update: (0, $2bf82c0980125b62$export$1e90ed8a25542516)
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
// Default theme
$4d59907f44a2d0ad$export$f9c59eed5de5ff80("light", (0, $0e5dbddd76825050$export$2e2bcd8739ae039));
$4d59907f44a2d0ad$export$f9c59eed5de5ff80("dark", (0, $985c98ffd51c6ff6$export$2e2bcd8739ae039));
var $4d59907f44a2d0ad$export$73cae5e090579589 = {};









var $d657479d857c7ab3$var$extensions = [];
var $d657479d857c7ab3$var$extensionRegisters = {
    registerPreprocessor: (0, $4d59907f44a2d0ad$export$77095792a057b768),
    registerProcessor: (0, $4d59907f44a2d0ad$export$d575e6557ac1729f),
    registerPostInit: (0, $4d59907f44a2d0ad$export$c8c249911ee8c1ed),
    registerPostUpdate: (0, $4d59907f44a2d0ad$export$99560909c18c76bb),
    registerUpdateLifecycle: (0, $4d59907f44a2d0ad$export$c9ec4b5faef04865),
    registerAction: (0, $4d59907f44a2d0ad$export$408c24786cd729c6),
    registerCoordinateSystem: (0, $4d59907f44a2d0ad$export$1dd5e025a8a37dd),
    registerLayout: (0, $4d59907f44a2d0ad$export$d768f97700ca6bea),
    registerVisual: (0, $4d59907f44a2d0ad$export$5f32c1eb94c381bb),
    registerTransform: (0, $4d59907f44a2d0ad$export$f01d71dd0389d7e4),
    registerLoading: (0, $4d59907f44a2d0ad$export$e06b68a82007c015),
    registerMap: (0, $4d59907f44a2d0ad$export$d456de060be2dba1),
    registerImpl: (0, $f773aa0508c1d920$export$9b808fd12256ddd3),
    PRIORITY: (0, $4d59907f44a2d0ad$export$bb34f3538ba26c7e),
    ComponentModel: (0, $116d65051f61bdfe$export$2e2bcd8739ae039),
    ComponentView: (0, $737c88aa0711f65a$export$2e2bcd8739ae039),
    SeriesModel: (0, $7c10febb2cdef0d8$export$2e2bcd8739ae039),
    ChartView: (0, $0dc5061053e23cd3$export$2e2bcd8739ae039),
    // TODO Use ComponentModel and SeriesModel instead of Constructor
    registerComponentModel: function(ComponentModelClass) {
        (0, $116d65051f61bdfe$export$2e2bcd8739ae039).registerClass(ComponentModelClass);
    },
    registerComponentView: function(ComponentViewClass) {
        (0, $737c88aa0711f65a$export$2e2bcd8739ae039).registerClass(ComponentViewClass);
    },
    registerSeriesModel: function(SeriesModelClass) {
        (0, $7c10febb2cdef0d8$export$2e2bcd8739ae039).registerClass(SeriesModelClass);
    },
    registerChartView: function(ChartViewClass) {
        (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).registerClass(ChartViewClass);
    },
    registerSubTypeDefaulter: function(componentType, defaulter) {
        (0, $116d65051f61bdfe$export$2e2bcd8739ae039).registerSubTypeDefaulter(componentType, defaulter);
    },
    registerPainter: function(painterType, PainterCtor) {
        (0, $6eba88f9eebe6af9$export$a3e793ccb11823a5)(painterType, PainterCtor);
    }
};
function $d657479d857c7ab3$export$1f96ae73734a86cc(ext) {
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(ext)) {
        // use([ChartLine, ChartBar]);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ext, function(singleExt) {
            $d657479d857c7ab3$export$1f96ae73734a86cc(singleExt);
        });
        return;
    }
    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($d657479d857c7ab3$var$extensions, ext) >= 0) return;
    $d657479d857c7ab3$var$extensions.push(ext);
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(ext)) ext = {
        install: ext
    };
    ext.install($d657479d857c7ab3$var$extensionRegisters);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 










function $f88637d76300101e$var$createDom(id, painter, dpr) {
    var newDom = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas();
    var width = painter.getWidth();
    var height = painter.getHeight();
    var newDomStyle = newDom.style;
    if (newDomStyle) {
        newDomStyle.position = "absolute";
        newDomStyle.left = "0";
        newDomStyle.top = "0";
        newDomStyle.width = width + "px";
        newDomStyle.height = height + "px";
        newDom.setAttribute("data-zr-dom-id", id);
    }
    newDom.width = width * dpr;
    newDom.height = height * dpr;
    return newDom;
}
var $f88637d76300101e$var$Layer = function(_super) {
    (0, $995fbf2af591395d$export$a8ba968b8961cb8a)(Layer, _super);
    function Layer(id, painter, dpr) {
        var _this = _super.call(this) || this;
        _this.motionBlur = false;
        _this.lastFrameAlpha = 0.7;
        _this.dpr = 1;
        _this.virtual = false;
        _this.config = {};
        _this.incremental = false;
        _this.zlevel = 0;
        _this.maxRepaintRectCount = 5;
        _this.__dirty = true;
        _this.__firstTimePaint = true;
        _this.__used = false;
        _this.__drawIndex = 0;
        _this.__startIndex = 0;
        _this.__endIndex = 0;
        _this.__prevStartIndex = null;
        _this.__prevEndIndex = null;
        var dom;
        dpr = dpr || (0, $4b0cedd85979c776$export$508f096bfcdaac40);
        if (typeof id === "string") dom = $f88637d76300101e$var$createDom(id, painter, dpr);
        else if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(id)) {
            dom = id;
            id = dom.id;
        }
        _this.id = id;
        _this.dom = dom;
        var domStyle = dom.style;
        if (domStyle) {
            $7a1bd9c2710fea0d$export$23a5d775868fdd2c(dom);
            dom.onselectstart = function() {
                return false;
            };
            domStyle.padding = "0";
            domStyle.margin = "0";
            domStyle.borderWidth = "0";
        }
        _this.painter = painter;
        _this.dpr = dpr;
        return _this;
    }
    Layer.prototype.getElementCount = function() {
        return this.__endIndex - this.__startIndex;
    };
    Layer.prototype.afterBrush = function() {
        this.__prevStartIndex = this.__startIndex;
        this.__prevEndIndex = this.__endIndex;
    };
    Layer.prototype.initContext = function() {
        this.ctx = this.dom.getContext("2d");
        this.ctx.dpr = this.dpr;
    };
    Layer.prototype.setUnpainted = function() {
        this.__firstTimePaint = true;
    };
    Layer.prototype.createBackBuffer = function() {
        var dpr = this.dpr;
        this.domBack = $f88637d76300101e$var$createDom("back-" + this.id, this.painter, dpr);
        this.ctxBack = this.domBack.getContext("2d");
        if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
    };
    Layer.prototype.createRepaintRects = function(displayList, prevList, viewWidth, viewHeight) {
        if (this.__firstTimePaint) {
            this.__firstTimePaint = false;
            return null;
        }
        var mergedRepaintRects = [];
        var maxRepaintRectCount = this.maxRepaintRectCount;
        var full = false;
        var pendingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
        function addRectToMergePool(rect) {
            if (!rect.isFinite() || rect.isZero()) return;
            if (mergedRepaintRects.length === 0) {
                var boundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
                boundingRect.copy(rect);
                mergedRepaintRects.push(boundingRect);
            } else {
                var isMerged = false;
                var minDeltaArea = Infinity;
                var bestRectToMergeIdx = 0;
                for(var i = 0; i < mergedRepaintRects.length; ++i){
                    var mergedRect = mergedRepaintRects[i];
                    if (mergedRect.intersect(rect)) {
                        var pendingRect_1 = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
                        pendingRect_1.copy(mergedRect);
                        pendingRect_1.union(rect);
                        mergedRepaintRects[i] = pendingRect_1;
                        isMerged = true;
                        break;
                    } else if (full) {
                        pendingRect.copy(rect);
                        pendingRect.union(mergedRect);
                        var aArea = rect.width * rect.height;
                        var bArea = mergedRect.width * mergedRect.height;
                        var pendingArea = pendingRect.width * pendingRect.height;
                        var deltaArea = pendingArea - aArea - bArea;
                        if (deltaArea < minDeltaArea) {
                            minDeltaArea = deltaArea;
                            bestRectToMergeIdx = i;
                        }
                    }
                }
                if (full) {
                    mergedRepaintRects[bestRectToMergeIdx].union(rect);
                    isMerged = true;
                }
                if (!isMerged) {
                    var boundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
                    boundingRect.copy(rect);
                    mergedRepaintRects.push(boundingRect);
                }
                if (!full) full = mergedRepaintRects.length >= maxRepaintRectCount;
            }
        }
        for(var i = this.__startIndex; i < this.__endIndex; ++i){
            var el = displayList[i];
            if (el) {
                var shouldPaint = el.shouldBePainted(viewWidth, viewHeight, true, true);
                var prevRect = el.__isRendered && (el.__dirty & (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) || !shouldPaint) ? el.getPrevPaintRect() : null;
                if (prevRect) addRectToMergePool(prevRect);
                var curRect = shouldPaint && (el.__dirty & (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) || !el.__isRendered) ? el.getPaintRect() : null;
                if (curRect) addRectToMergePool(curRect);
            }
        }
        for(var i = this.__prevStartIndex; i < this.__prevEndIndex; ++i){
            var el = prevList[i];
            var shouldPaint = el && el.shouldBePainted(viewWidth, viewHeight, true, true);
            if (el && (!shouldPaint || !el.__zr) && el.__isRendered) {
                var prevRect = el.getPrevPaintRect();
                if (prevRect) addRectToMergePool(prevRect);
            }
        }
        var hasIntersections;
        do {
            hasIntersections = false;
            for(var i = 0; i < mergedRepaintRects.length;){
                if (mergedRepaintRects[i].isZero()) {
                    mergedRepaintRects.splice(i, 1);
                    continue;
                }
                for(var j = i + 1; j < mergedRepaintRects.length;)if (mergedRepaintRects[i].intersect(mergedRepaintRects[j])) {
                    hasIntersections = true;
                    mergedRepaintRects[i].union(mergedRepaintRects[j]);
                    mergedRepaintRects.splice(j, 1);
                } else j++;
                i++;
            }
        }while (hasIntersections);
        this._paintRects = mergedRepaintRects;
        return mergedRepaintRects;
    };
    Layer.prototype.debugGetPaintRects = function() {
        return (this._paintRects || []).slice();
    };
    Layer.prototype.resize = function(width, height) {
        var dpr = this.dpr;
        var dom = this.dom;
        var domStyle = dom.style;
        var domBack = this.domBack;
        if (domStyle) {
            domStyle.width = width + "px";
            domStyle.height = height + "px";
        }
        dom.width = width * dpr;
        dom.height = height * dpr;
        if (domBack) {
            domBack.width = width * dpr;
            domBack.height = height * dpr;
            if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
        }
    };
    Layer.prototype.clear = function(clearAll, clearColor, repaintRects) {
        var dom = this.dom;
        var ctx = this.ctx;
        var width = dom.width;
        var height = dom.height;
        clearColor = clearColor || this.clearColor;
        var haveMotionBLur = this.motionBlur && !clearAll;
        var lastFrameAlpha = this.lastFrameAlpha;
        var dpr = this.dpr;
        var self = this;
        if (haveMotionBLur) {
            if (!this.domBack) this.createBackBuffer();
            this.ctxBack.globalCompositeOperation = "copy";
            this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
        }
        var domBack = this.domBack;
        function doClear(x, y, width, height) {
            ctx.clearRect(x, y, width, height);
            if (clearColor && clearColor !== "transparent") {
                var clearColorGradientOrPattern = void 0;
                if ($7a1bd9c2710fea0d$export$fa2c283003ed971c(clearColor)) {
                    var shouldCache = clearColor.global || clearColor.__width === width && clearColor.__height === height;
                    clearColorGradientOrPattern = shouldCache && clearColor.__canvasGradient || (0, $d76b6507633b3c44$export$3dab6afd018d48c7)(ctx, clearColor, {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    });
                    clearColor.__canvasGradient = clearColorGradientOrPattern;
                    clearColor.__width = width;
                    clearColor.__height = height;
                } else if ($7a1bd9c2710fea0d$export$a49bbf3a55dcef7b(clearColor)) {
                    clearColor.scaleX = clearColor.scaleX || dpr;
                    clearColor.scaleY = clearColor.scaleY || dpr;
                    clearColorGradientOrPattern = (0, $4f71e35e4552e3dd$export$8eb5db6b7bc27903)(ctx, clearColor, {
                        dirty: function() {
                            self.setUnpainted();
                            self.painter.refresh();
                        }
                    });
                }
                ctx.save();
                ctx.fillStyle = clearColorGradientOrPattern || clearColor;
                ctx.fillRect(x, y, width, height);
                ctx.restore();
            }
            if (haveMotionBLur) {
                ctx.save();
                ctx.globalAlpha = lastFrameAlpha;
                ctx.drawImage(domBack, x, y, width, height);
                ctx.restore();
            }
        }
        if (!repaintRects || haveMotionBLur) doClear(0, 0, width, height);
        else if (repaintRects.length) $7a1bd9c2710fea0d$export$79b2f7037acddd43(repaintRects, function(rect) {
            doClear(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
        });
    };
    return Layer;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
var $f88637d76300101e$export$2e2bcd8739ae039 = $f88637d76300101e$var$Layer;







var $19d742a3d88cea2b$var$HOVER_LAYER_ZLEVEL = 1e5;
var $19d742a3d88cea2b$var$CANVAS_ZLEVEL = 314159;
var $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC = 0.01;
var $19d742a3d88cea2b$var$INCREMENTAL_INC = 0.001;
function $19d742a3d88cea2b$var$isLayerValid(layer) {
    if (!layer) return false;
    if (layer.__builtin__) return true;
    if (typeof layer.resize !== "function" || typeof layer.refresh !== "function") return false;
    return true;
}
function $19d742a3d88cea2b$var$createRoot(width, height) {
    var domRoot = document.createElement("div");
    domRoot.style.cssText = [
        "position:relative",
        "width:" + width + "px",
        "height:" + height + "px",
        "padding:0",
        "margin:0",
        "border-width:0"
    ].join(";") + ";";
    return domRoot;
}
var $19d742a3d88cea2b$var$CanvasPainter = function() {
    function CanvasPainter(root, storage, opts, id) {
        this.type = "canvas";
        this._zlevelList = [];
        this._prevDisplayList = [];
        this._layers = {};
        this._layerConfig = {};
        this._needsManuallyCompositing = false;
        this.type = "canvas";
        var singleCanvas = !root.nodeName || root.nodeName.toUpperCase() === "CANVAS";
        this._opts = opts = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, opts || {});
        this.dpr = opts.devicePixelRatio || (0, $4b0cedd85979c776$export$508f096bfcdaac40);
        this._singleCanvas = singleCanvas;
        this.root = root;
        var rootStyle = root.style;
        if (rootStyle) {
            $7a1bd9c2710fea0d$export$23a5d775868fdd2c(root);
            root.innerHTML = "";
        }
        this.storage = storage;
        var zlevelList = this._zlevelList;
        this._prevDisplayList = [];
        var layers = this._layers;
        if (!singleCanvas) {
            this._width = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 0, opts);
            this._height = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 1, opts);
            var domRoot = this._domRoot = $19d742a3d88cea2b$var$createRoot(this._width, this._height);
            root.appendChild(domRoot);
        } else {
            var rootCanvas = root;
            var width = rootCanvas.width;
            var height = rootCanvas.height;
            if (opts.width != null) width = opts.width;
            if (opts.height != null) height = opts.height;
            this.dpr = opts.devicePixelRatio || 1;
            rootCanvas.width = width * this.dpr;
            rootCanvas.height = height * this.dpr;
            this._width = width;
            this._height = height;
            var mainLayer = new (0, $f88637d76300101e$export$2e2bcd8739ae039)(rootCanvas, this, this.dpr);
            mainLayer.__builtin__ = true;
            mainLayer.initContext();
            layers[$19d742a3d88cea2b$var$CANVAS_ZLEVEL] = mainLayer;
            mainLayer.zlevel = $19d742a3d88cea2b$var$CANVAS_ZLEVEL;
            zlevelList.push($19d742a3d88cea2b$var$CANVAS_ZLEVEL);
            this._domRoot = root;
        }
    }
    CanvasPainter.prototype.getType = function() {
        return "canvas";
    };
    CanvasPainter.prototype.isSingleCanvas = function() {
        return this._singleCanvas;
    };
    CanvasPainter.prototype.getViewportRoot = function() {
        return this._domRoot;
    };
    CanvasPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    CanvasPainter.prototype.refresh = function(paintAll) {
        var list = this.storage.getDisplayList(true);
        var prevList = this._prevDisplayList;
        var zlevelList = this._zlevelList;
        this._redrawId = Math.random();
        this._paintList(list, prevList, paintAll, this._redrawId);
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__ && layer.refresh) {
                var clearColor = i === 0 ? this._backgroundColor : null;
                layer.refresh(clearColor);
            }
        }
        if (this._opts.useDirtyRect) this._prevDisplayList = list.slice();
        return this;
    };
    CanvasPainter.prototype.refreshHover = function() {
        this._paintHoverList(this.storage.getDisplayList(false));
    };
    CanvasPainter.prototype._paintHoverList = function(list) {
        var len = list.length;
        var hoverLayer = this._hoverlayer;
        hoverLayer && hoverLayer.clear();
        if (!len) return;
        var scope = {
            inHover: true,
            viewWidth: this._width,
            viewHeight: this._height
        };
        var ctx;
        for(var i = 0; i < len; i++){
            var el = list[i];
            if (el.__inHover) {
                if (!hoverLayer) hoverLayer = this._hoverlayer = this.getLayer($19d742a3d88cea2b$var$HOVER_LAYER_ZLEVEL);
                if (!ctx) {
                    ctx = hoverLayer.ctx;
                    ctx.save();
                }
                (0, $4f71e35e4552e3dd$export$da5d6544e8c27bc1)(ctx, el, scope, i === len - 1);
            }
        }
        if (ctx) ctx.restore();
    };
    CanvasPainter.prototype.getHoverLayer = function() {
        return this.getLayer($19d742a3d88cea2b$var$HOVER_LAYER_ZLEVEL);
    };
    CanvasPainter.prototype.paintOne = function(ctx, el) {
        (0, $4f71e35e4552e3dd$export$567881adfc3eb7f3)(ctx, el);
    };
    CanvasPainter.prototype._paintList = function(list, prevList, paintAll, redrawId) {
        if (this._redrawId !== redrawId) return;
        paintAll = paintAll || false;
        this._updateLayerStatus(list);
        var _a = this._doPaintList(list, prevList, paintAll), finished = _a.finished, needsRefreshHover = _a.needsRefreshHover;
        if (this._needsManuallyCompositing) this._compositeManually();
        if (needsRefreshHover) this._paintHoverList(list);
        if (!finished) {
            var self_1 = this;
            (0, $731d42ad1858cd4c$export$2e2bcd8739ae039)(function() {
                self_1._paintList(list, prevList, paintAll, redrawId);
            });
        } else this.eachLayer(function(layer) {
            layer.afterBrush && layer.afterBrush();
        });
    };
    CanvasPainter.prototype._compositeManually = function() {
        var ctx = this.getLayer($19d742a3d88cea2b$var$CANVAS_ZLEVEL).ctx;
        var width = this._domRoot.width;
        var height = this._domRoot.height;
        ctx.clearRect(0, 0, width, height);
        this.eachBuiltinLayer(function(layer) {
            if (layer.virtual) ctx.drawImage(layer.dom, 0, 0, width, height);
        });
    };
    CanvasPainter.prototype._doPaintList = function(list, prevList, paintAll) {
        var _this = this;
        var layerList = [];
        var useDirtyRect = this._opts.useDirtyRect;
        for(var zi = 0; zi < this._zlevelList.length; zi++){
            var zlevel = this._zlevelList[zi];
            var layer = this._layers[zlevel];
            if (layer.__builtin__ && layer !== this._hoverlayer && (layer.__dirty || paintAll)) layerList.push(layer);
        }
        var finished = true;
        var needsRefreshHover = false;
        var _loop_1 = function(k) {
            var layer = layerList[k];
            var ctx = layer.ctx;
            var repaintRects = useDirtyRect && layer.createRepaintRects(list, prevList, this_1._width, this_1._height);
            var start = paintAll ? layer.__startIndex : layer.__drawIndex;
            var useTimer = !paintAll && layer.incremental && Date.now;
            var startTime = useTimer && Date.now();
            var clearColor = layer.zlevel === this_1._zlevelList[0] ? this_1._backgroundColor : null;
            if (layer.__startIndex === layer.__endIndex) layer.clear(false, clearColor, repaintRects);
            else if (start === layer.__startIndex) {
                var firstEl = list[start];
                if (!firstEl.incremental || !firstEl.notClear || paintAll) layer.clear(false, clearColor, repaintRects);
            }
            if (start === -1) {
                console.error("For some unknown reason. drawIndex is -1");
                start = layer.__startIndex;
            }
            var i;
            var repaint = function(repaintRect) {
                var scope = {
                    inHover: false,
                    allClipped: false,
                    prevEl: null,
                    viewWidth: _this._width,
                    viewHeight: _this._height
                };
                for(i = start; i < layer.__endIndex; i++){
                    var el = list[i];
                    if (el.__inHover) needsRefreshHover = true;
                    _this._doPaintEl(el, layer, useDirtyRect, repaintRect, scope, i === layer.__endIndex - 1);
                    if (useTimer) {
                        var dTime = Date.now() - startTime;
                        if (dTime > 15) break;
                    }
                }
                if (scope.prevElClipPaths) ctx.restore();
            };
            if (repaintRects) {
                if (repaintRects.length === 0) i = layer.__endIndex;
                else {
                    var dpr = this_1.dpr;
                    for(var r = 0; r < repaintRects.length; ++r){
                        var rect = repaintRects[r];
                        ctx.save();
                        ctx.beginPath();
                        ctx.rect(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
                        ctx.clip();
                        repaint(rect);
                        ctx.restore();
                    }
                }
            } else {
                ctx.save();
                repaint();
                ctx.restore();
            }
            layer.__drawIndex = i;
            if (layer.__drawIndex < layer.__endIndex) finished = false;
        };
        var this_1 = this;
        for(var k = 0; k < layerList.length; k++)_loop_1(k);
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).wxa) $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._layers, function(layer) {
            if (layer && layer.ctx && layer.ctx.draw) layer.ctx.draw();
        });
        return {
            finished: finished,
            needsRefreshHover: needsRefreshHover
        };
    };
    CanvasPainter.prototype._doPaintEl = function(el, currentLayer, useDirtyRect, repaintRect, scope, isLast) {
        var ctx = currentLayer.ctx;
        if (useDirtyRect) {
            var paintRect = el.getPaintRect();
            if (!repaintRect || paintRect && paintRect.intersect(repaintRect)) {
                (0, $4f71e35e4552e3dd$export$da5d6544e8c27bc1)(ctx, el, scope, isLast);
                el.setPrevPaintRect(paintRect);
            }
        } else (0, $4f71e35e4552e3dd$export$da5d6544e8c27bc1)(ctx, el, scope, isLast);
    };
    CanvasPainter.prototype.getLayer = function(zlevel, virtual) {
        if (this._singleCanvas && !this._needsManuallyCompositing) zlevel = $19d742a3d88cea2b$var$CANVAS_ZLEVEL;
        var layer = this._layers[zlevel];
        if (!layer) {
            layer = new (0, $f88637d76300101e$export$2e2bcd8739ae039)("zr_" + zlevel, this, this.dpr);
            layer.zlevel = zlevel;
            layer.__builtin__ = true;
            if (this._layerConfig[zlevel]) $7a1bd9c2710fea0d$export$4950aa0f605343fb(layer, this._layerConfig[zlevel], true);
            else if (this._layerConfig[zlevel - $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC]) $7a1bd9c2710fea0d$export$4950aa0f605343fb(layer, this._layerConfig[zlevel - $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC], true);
            if (virtual) layer.virtual = virtual;
            this.insertLayer(zlevel, layer);
            layer.initContext();
        }
        return layer;
    };
    CanvasPainter.prototype.insertLayer = function(zlevel, layer) {
        var layersMap = this._layers;
        var zlevelList = this._zlevelList;
        var len = zlevelList.length;
        var domRoot = this._domRoot;
        var prevLayer = null;
        var i = -1;
        if (layersMap[zlevel]) return;
        if (!$19d742a3d88cea2b$var$isLayerValid(layer)) return;
        if (len > 0 && zlevel > zlevelList[0]) {
            for(i = 0; i < len - 1; i++){
                if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) break;
            }
            prevLayer = layersMap[zlevelList[i]];
        }
        zlevelList.splice(i + 1, 0, zlevel);
        layersMap[zlevel] = layer;
        if (!layer.virtual) {
            if (prevLayer) {
                var prevDom = prevLayer.dom;
                if (prevDom.nextSibling) domRoot.insertBefore(layer.dom, prevDom.nextSibling);
                else domRoot.appendChild(layer.dom);
            } else if (domRoot.firstChild) domRoot.insertBefore(layer.dom, domRoot.firstChild);
            else domRoot.appendChild(layer.dom);
        }
        layer.painter || (layer.painter = this);
    };
    CanvasPainter.prototype.eachLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            cb.call(context, this._layers[z], z);
        }
    };
    CanvasPainter.prototype.eachBuiltinLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (layer.__builtin__) cb.call(context, layer, z);
        }
    };
    CanvasPainter.prototype.eachOtherLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__) cb.call(context, layer, z);
        }
    };
    CanvasPainter.prototype.getLayers = function() {
        return this._layers;
    };
    CanvasPainter.prototype._updateLayerStatus = function(list) {
        this.eachBuiltinLayer(function(layer, z) {
            layer.__dirty = layer.__used = false;
        });
        function updatePrevLayer(idx) {
            if (prevLayer) {
                if (prevLayer.__endIndex !== idx) prevLayer.__dirty = true;
                prevLayer.__endIndex = idx;
            }
        }
        if (this._singleCanvas) for(var i_1 = 1; i_1 < list.length; i_1++){
            var el = list[i_1];
            if (el.zlevel !== list[i_1 - 1].zlevel || el.incremental) {
                this._needsManuallyCompositing = true;
                break;
            }
        }
        var prevLayer = null;
        var incrementalLayerCount = 0;
        var prevZlevel;
        var i;
        for(i = 0; i < list.length; i++){
            var el = list[i];
            var zlevel = el.zlevel;
            var layer = void 0;
            if (prevZlevel !== zlevel) {
                prevZlevel = zlevel;
                incrementalLayerCount = 0;
            }
            if (el.incremental) {
                layer = this.getLayer(zlevel + $19d742a3d88cea2b$var$INCREMENTAL_INC, this._needsManuallyCompositing);
                layer.incremental = true;
                incrementalLayerCount = 1;
            } else layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
            if (!layer.__builtin__) $7a1bd9c2710fea0d$export$58da9968c3170cb1("ZLevel " + zlevel + " has been used by unkown layer " + layer.id);
            if (layer !== prevLayer) {
                layer.__used = true;
                if (layer.__startIndex !== i) layer.__dirty = true;
                layer.__startIndex = i;
                if (!layer.incremental) layer.__drawIndex = i;
                else layer.__drawIndex = -1;
                updatePrevLayer(i);
                prevLayer = layer;
            }
            if (el.__dirty & (0, $ddf76b16f1246ba9$export$a7b6db622c6c7dbd) && !el.__inHover) {
                layer.__dirty = true;
                if (layer.incremental && layer.__drawIndex < 0) layer.__drawIndex = i;
            }
        }
        updatePrevLayer(i);
        this.eachBuiltinLayer(function(layer, z) {
            if (!layer.__used && layer.getElementCount() > 0) {
                layer.__dirty = true;
                layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
            }
            if (layer.__dirty && layer.__drawIndex < 0) layer.__drawIndex = layer.__startIndex;
        });
    };
    CanvasPainter.prototype.clear = function() {
        this.eachBuiltinLayer(this._clearLayer);
        return this;
    };
    CanvasPainter.prototype._clearLayer = function(layer) {
        layer.clear();
    };
    CanvasPainter.prototype.setBackgroundColor = function(backgroundColor) {
        this._backgroundColor = backgroundColor;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._layers, function(layer) {
            layer.setUnpainted();
        });
    };
    CanvasPainter.prototype.configLayer = function(zlevel, config) {
        if (config) {
            var layerConfig = this._layerConfig;
            if (!layerConfig[zlevel]) layerConfig[zlevel] = config;
            else $7a1bd9c2710fea0d$export$4950aa0f605343fb(layerConfig[zlevel], config, true);
            for(var i = 0; i < this._zlevelList.length; i++){
                var _zlevel = this._zlevelList[i];
                if (_zlevel === zlevel || _zlevel === zlevel + $19d742a3d88cea2b$var$EL_AFTER_INCREMENTAL_INC) {
                    var layer = this._layers[_zlevel];
                    $7a1bd9c2710fea0d$export$4950aa0f605343fb(layer, layerConfig[zlevel], true);
                }
            }
        }
    };
    CanvasPainter.prototype.delLayer = function(zlevel) {
        var layers = this._layers;
        var zlevelList = this._zlevelList;
        var layer = layers[zlevel];
        if (!layer) return;
        layer.dom.parentNode.removeChild(layer.dom);
        delete layers[zlevel];
        zlevelList.splice($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(zlevelList, zlevel), 1);
    };
    CanvasPainter.prototype.resize = function(width, height) {
        if (!this._domRoot.style) {
            if (width == null || height == null) return;
            this._width = width;
            this._height = height;
            this.getLayer($19d742a3d88cea2b$var$CANVAS_ZLEVEL).resize(width, height);
        } else {
            var domRoot = this._domRoot;
            domRoot.style.display = "none";
            var opts = this._opts;
            var root = this.root;
            width != null && (opts.width = width);
            height != null && (opts.height = height);
            width = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 0, opts);
            height = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 1, opts);
            domRoot.style.display = "";
            if (this._width !== width || height !== this._height) {
                domRoot.style.width = width + "px";
                domRoot.style.height = height + "px";
                for(var id in this._layers)if (this._layers.hasOwnProperty(id)) this._layers[id].resize(width, height);
                this.refresh(true);
            }
            this._width = width;
            this._height = height;
        }
        return this;
    };
    CanvasPainter.prototype.clearLayer = function(zlevel) {
        var layer = this._layers[zlevel];
        if (layer) layer.clear();
    };
    CanvasPainter.prototype.dispose = function() {
        this.root.innerHTML = "";
        this.root = this.storage = this._domRoot = this._layers = null;
    };
    CanvasPainter.prototype.getRenderedCanvas = function(opts) {
        opts = opts || {};
        if (this._singleCanvas && !this._compositeManually) return this._layers[$19d742a3d88cea2b$var$CANVAS_ZLEVEL].dom;
        var imageLayer = new (0, $f88637d76300101e$export$2e2bcd8739ae039)("image", this, opts.pixelRatio || this.dpr);
        imageLayer.initContext();
        imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);
        var ctx = imageLayer.ctx;
        if (opts.pixelRatio <= this.dpr) {
            this.refresh();
            var width_1 = imageLayer.dom.width;
            var height_1 = imageLayer.dom.height;
            this.eachLayer(function(layer) {
                if (layer.__builtin__) ctx.drawImage(layer.dom, 0, 0, width_1, height_1);
                else if (layer.renderToCanvas) {
                    ctx.save();
                    layer.renderToCanvas(ctx);
                    ctx.restore();
                }
            });
        } else {
            var scope = {
                inHover: false,
                viewWidth: this._width,
                viewHeight: this._height
            };
            var displayList = this.storage.getDisplayList(true);
            for(var i = 0, len = displayList.length; i < len; i++){
                var el = displayList[i];
                (0, $4f71e35e4552e3dd$export$da5d6544e8c27bc1)(ctx, el, scope, i === len - 1);
            }
        }
        return imageLayer.dom;
    };
    CanvasPainter.prototype.getWidth = function() {
        return this._width;
    };
    CanvasPainter.prototype.getHeight = function() {
        return this._height;
    };
    return CanvasPainter;
}();
var $19d742a3d88cea2b$export$2e2bcd8739ae039 = $19d742a3d88cea2b$var$CanvasPainter;


function $e792bf2f67d76098$export$4b3e715f166fdd78(registers) {
    registers.registerPainter("canvas", (0, $19d742a3d88cea2b$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $c8b2ce72d2349eb5$var$mathSin = Math.sin;
var $c8b2ce72d2349eb5$var$mathCos = Math.cos;
var $c8b2ce72d2349eb5$var$PI = Math.PI;
var $c8b2ce72d2349eb5$var$PI2 = Math.PI * 2;
var $c8b2ce72d2349eb5$var$degree = 180 / $c8b2ce72d2349eb5$var$PI;
var $c8b2ce72d2349eb5$var$SVGPathRebuilder = function() {
    function SVGPathRebuilder() {}
    SVGPathRebuilder.prototype.reset = function(precision) {
        this._start = true;
        this._d = [];
        this._str = "";
        this._p = Math.pow(10, precision || 4);
    };
    SVGPathRebuilder.prototype.moveTo = function(x, y) {
        this._add("M", x, y);
    };
    SVGPathRebuilder.prototype.lineTo = function(x, y) {
        this._add("L", x, y);
    };
    SVGPathRebuilder.prototype.bezierCurveTo = function(x, y, x2, y2, x3, y3) {
        this._add("C", x, y, x2, y2, x3, y3);
    };
    SVGPathRebuilder.prototype.quadraticCurveTo = function(x, y, x2, y2) {
        this._add("Q", x, y, x2, y2);
    };
    SVGPathRebuilder.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this.ellipse(cx, cy, r, r, 0, startAngle, endAngle, anticlockwise);
    };
    SVGPathRebuilder.prototype.ellipse = function(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise) {
        var dTheta = endAngle - startAngle;
        var clockwise = !anticlockwise;
        var dThetaPositive = Math.abs(dTheta);
        var isCircle = (0, $999d81abec723db8$export$4701367f5b4de464)(dThetaPositive - $c8b2ce72d2349eb5$var$PI2) || (clockwise ? dTheta >= $c8b2ce72d2349eb5$var$PI2 : -dTheta >= $c8b2ce72d2349eb5$var$PI2);
        var unifiedTheta = dTheta > 0 ? dTheta % $c8b2ce72d2349eb5$var$PI2 : dTheta % $c8b2ce72d2349eb5$var$PI2 + $c8b2ce72d2349eb5$var$PI2;
        var large = false;
        if (isCircle) large = true;
        else if ((0, $999d81abec723db8$export$4701367f5b4de464)(dThetaPositive)) large = false;
        else large = unifiedTheta >= $c8b2ce72d2349eb5$var$PI === !!clockwise;
        var x0 = cx + rx * $c8b2ce72d2349eb5$var$mathCos(startAngle);
        var y0 = cy + ry * $c8b2ce72d2349eb5$var$mathSin(startAngle);
        if (this._start) this._add("M", x0, y0);
        var xRot = Math.round(psi * $c8b2ce72d2349eb5$var$degree);
        if (isCircle) {
            var p = 1 / this._p;
            var dTheta_1 = (clockwise ? 1 : -1) * ($c8b2ce72d2349eb5$var$PI2 - p);
            this._add("A", rx, ry, xRot, 1, +clockwise, cx + rx * $c8b2ce72d2349eb5$var$mathCos(startAngle + dTheta_1), cy + ry * $c8b2ce72d2349eb5$var$mathSin(startAngle + dTheta_1));
            if (p > 1e-2) this._add("A", rx, ry, xRot, 0, +clockwise, x0, y0);
        } else {
            var x = cx + rx * $c8b2ce72d2349eb5$var$mathCos(endAngle);
            var y = cy + ry * $c8b2ce72d2349eb5$var$mathSin(endAngle);
            this._add("A", rx, ry, xRot, +large, +clockwise, x, y);
        }
    };
    SVGPathRebuilder.prototype.rect = function(x, y, w, h) {
        this._add("M", x, y);
        this._add("l", w, 0);
        this._add("l", 0, h);
        this._add("l", -w, 0);
        this._add("Z");
    };
    SVGPathRebuilder.prototype.closePath = function() {
        if (this._d.length > 0) this._add("Z");
    };
    SVGPathRebuilder.prototype._add = function(cmd, a, b, c, d, e, f, g, h) {
        var vals = [];
        var p = this._p;
        for(var i = 1; i < arguments.length; i++){
            var val = arguments[i];
            if (isNaN(val)) {
                this._invalid = true;
                return;
            }
            vals.push(Math.round(val * p) / p);
        }
        this._d.push(cmd + vals.join(" "));
        this._start = cmd === "Z";
    };
    SVGPathRebuilder.prototype.generateStr = function() {
        this._str = this._invalid ? "" : this._d.join("");
        this._d = [];
    };
    SVGPathRebuilder.prototype.getStr = function() {
        return this._str;
    };
    return SVGPathRebuilder;
}();
var $c8b2ce72d2349eb5$export$2e2bcd8739ae039 = $c8b2ce72d2349eb5$var$SVGPathRebuilder;







var $6f6b3090476bfa7b$var$NONE = "none";
var $6f6b3090476bfa7b$var$mathRound = Math.round;
function $6f6b3090476bfa7b$var$pathHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== $6f6b3090476bfa7b$var$NONE;
}
function $6f6b3090476bfa7b$var$pathHasStroke(style) {
    var stroke = style.stroke;
    return stroke != null && stroke !== $6f6b3090476bfa7b$var$NONE;
}
var $6f6b3090476bfa7b$var$strokeProps = [
    "lineCap",
    "miterLimit",
    "lineJoin"
];
var $6f6b3090476bfa7b$var$svgStrokeProps = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)($6f6b3090476bfa7b$var$strokeProps, function(prop) {
    return "stroke-" + prop.toLowerCase();
});
function $6f6b3090476bfa7b$export$2e2bcd8739ae039(updateAttr, style, el, forceUpdate) {
    var opacity = style.opacity == null ? 1 : style.opacity;
    if (el instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
        updateAttr("opacity", opacity);
        return;
    }
    if ($6f6b3090476bfa7b$var$pathHasFill(style)) {
        var fill = (0, $999d81abec723db8$export$4cde5df63f53f473)(style.fill);
        updateAttr("fill", fill.color);
        var fillOpacity = style.fillOpacity != null ? style.fillOpacity * fill.opacity * opacity : fill.opacity * opacity;
        if (forceUpdate || fillOpacity < 1) updateAttr("fill-opacity", fillOpacity);
    } else updateAttr("fill", $6f6b3090476bfa7b$var$NONE);
    if ($6f6b3090476bfa7b$var$pathHasStroke(style)) {
        var stroke = (0, $999d81abec723db8$export$4cde5df63f53f473)(style.stroke);
        updateAttr("stroke", stroke.color);
        var strokeScale = style.strokeNoScale ? el.getLineScale() : 1;
        var strokeWidth = strokeScale ? (style.lineWidth || 0) / strokeScale : 0;
        var strokeOpacity = style.strokeOpacity != null ? style.strokeOpacity * stroke.opacity * opacity : stroke.opacity * opacity;
        var strokeFirst = style.strokeFirst;
        if (forceUpdate || strokeWidth !== 1) updateAttr("stroke-width", strokeWidth);
        if (forceUpdate || strokeFirst) updateAttr("paint-order", strokeFirst ? "stroke" : "fill");
        if (forceUpdate || strokeOpacity < 1) updateAttr("stroke-opacity", strokeOpacity);
        if (style.lineDash) {
            var _a = (0, $21ab8baf7c1f083c$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
            if (lineDash) {
                lineDashOffset = $6f6b3090476bfa7b$var$mathRound(lineDashOffset || 0);
                updateAttr("stroke-dasharray", lineDash.join(","));
                if (lineDashOffset || forceUpdate) updateAttr("stroke-dashoffset", lineDashOffset);
            }
        } else if (forceUpdate) updateAttr("stroke-dasharray", $6f6b3090476bfa7b$var$NONE);
        for(var i = 0; i < $6f6b3090476bfa7b$var$strokeProps.length; i++){
            var propName = $6f6b3090476bfa7b$var$strokeProps[i];
            if (forceUpdate || style[propName] !== (0, $b02ffe7acd508c08$export$deade517576e293a)[propName]) {
                var val = style[propName] || (0, $b02ffe7acd508c08$export$deade517576e293a)[propName];
                val && updateAttr($6f6b3090476bfa7b$var$svgStrokeProps[i], val);
            }
        }
    } else if (forceUpdate) updateAttr("stroke", $6f6b3090476bfa7b$var$NONE);
}




var $f6ad3c9e333d7ffc$export$a690ad4c9a38f86e = "http://www.w3.org/2000/svg";
var $f6ad3c9e333d7ffc$export$b22c6da1792ecec8 = "http://www.w3.org/1999/xlink";
var $f6ad3c9e333d7ffc$export$fac09d762d15fa3b = "http://www.w3.org/2000/xmlns/";
var $f6ad3c9e333d7ffc$export$ad4c4fdecd3b4156 = "http://www.w3.org/XML/1998/namespace";
var $f6ad3c9e333d7ffc$export$d3f79611f155197c = "ecmeta_";
function $f6ad3c9e333d7ffc$export$c8a8987d4410bf2d(name) {
    return document.createElementNS($f6ad3c9e333d7ffc$export$a690ad4c9a38f86e, name);
}
function $f6ad3c9e333d7ffc$export$bf5c4cf060303d58(tag, key, attrs, children, text) {
    return {
        tag: tag,
        attrs: attrs || {},
        children: children,
        text: text,
        key: key
    };
}
function $f6ad3c9e333d7ffc$var$createElementOpen(name, attrs) {
    var attrsStr = [];
    if (attrs) for(var key in attrs){
        var val = attrs[key];
        var part = key;
        if (val === false) continue;
        else if (val !== true && val != null) part += '="' + val + '"';
        attrsStr.push(part);
    }
    return "<" + name + " " + attrsStr.join(" ") + ">";
}
function $f6ad3c9e333d7ffc$var$createElementClose(name) {
    return "</" + name + ">";
}
function $f6ad3c9e333d7ffc$export$f5c4a9a0e027f2b(el, opts) {
    opts = opts || {};
    var S = opts.newline ? "\n" : "";
    function convertElToString(el) {
        var children = el.children, tag = el.tag, attrs = el.attrs, text = el.text;
        return $f6ad3c9e333d7ffc$var$createElementOpen(tag, attrs) + (tag !== "style" ? (0, $664e052f390bd76e$export$f9d6449b9af28dc1)(text) : text || "") + (children ? "" + S + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(children, function(child) {
            return convertElToString(child);
        }).join(S) + S : "") + $f6ad3c9e333d7ffc$var$createElementClose(tag);
    }
    return convertElToString(el);
}
function $f6ad3c9e333d7ffc$export$e2b4f3597c7a7dcb(selectorNodes, animationNodes, opts) {
    opts = opts || {};
    var S = opts.newline ? "\n" : "";
    var bracketBegin = " {" + S;
    var bracketEnd = S + "}";
    var selectors = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(selectorNodes), function(className) {
        return className + bracketBegin + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(selectorNodes[className]), function(attrName) {
            return attrName + ":" + selectorNodes[className][attrName] + ";";
        }).join(S) + bracketEnd;
    }).join(S);
    var animations = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(animationNodes), function(animationName) {
        return "@keyframes " + animationName + bracketBegin + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(animationNodes[animationName]), function(percent) {
            return percent + bracketBegin + (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(animationNodes[animationName][percent]), function(attrName) {
                var val = animationNodes[animationName][percent][attrName];
                if (attrName === "d") val = 'path("' + val + '")';
                return attrName + ":" + val + ";";
            }).join(S) + bracketEnd;
        }).join(S) + bracketEnd;
    }).join(S);
    if (!selectors && !animations) return "";
    return [
        "<![CDATA[",
        selectors,
        animations,
        "]]>"
    ].join(S);
}
function $f6ad3c9e333d7ffc$export$96fee5f38ed01741(zrId) {
    return {
        zrId: zrId,
        shadowCache: {},
        patternCache: {},
        gradientCache: {},
        clipPathCache: {},
        defs: {},
        cssNodes: {},
        cssAnims: {},
        cssStyleCache: {},
        cssAnimIdx: 0,
        shadowIdx: 0,
        gradientIdx: 0,
        patternIdx: 0,
        clipPathIdx: 0
    };
}
function $f6ad3c9e333d7ffc$export$5529a6aad332ee75(width, height, children, useViewBox) {
    return $f6ad3c9e333d7ffc$export$bf5c4cf060303d58("svg", "root", {
        "width": width,
        "height": height,
        "xmlns": $f6ad3c9e333d7ffc$export$a690ad4c9a38f86e,
        "xmlns:xlink": $f6ad3c9e333d7ffc$export$b22c6da1792ecec8,
        "version": "1.1",
        "baseProfile": "full",
        "viewBox": useViewBox ? "0 0 " + width + " " + height : false
    }, children);
}












var $849cb89161be4359$var$cssClassIdx = 0;
function $849cb89161be4359$export$9c80c36b7367fb56() {
    return $849cb89161be4359$var$cssClassIdx++;
}


var $a85a6a2869494a29$export$54ee1847795bcf37 = {
    cubicIn: "0.32,0,0.67,0",
    cubicOut: "0.33,1,0.68,1",
    cubicInOut: "0.65,0,0.35,1",
    quadraticIn: "0.11,0,0.5,0",
    quadraticOut: "0.5,1,0.89,1",
    quadraticInOut: "0.45,0,0.55,1",
    quarticIn: "0.5,0,0.75,0",
    quarticOut: "0.25,1,0.5,1",
    quarticInOut: "0.76,0,0.24,1",
    quinticIn: "0.64,0,0.78,0",
    quinticOut: "0.22,1,0.36,1",
    quinticInOut: "0.83,0,0.17,1",
    sinusoidalIn: "0.12,0,0.39,0",
    sinusoidalOut: "0.61,1,0.88,1",
    sinusoidalInOut: "0.37,0,0.63,1",
    exponentialIn: "0.7,0,0.84,0",
    exponentialOut: "0.16,1,0.3,1",
    exponentialInOut: "0.87,0,0.13,1",
    circularIn: "0.55,0,1,0.45",
    circularOut: "0,0.55,0.45,1",
    circularInOut: "0.85,0,0.15,1"
};
var $a85a6a2869494a29$var$transformOriginKey = "transform-origin";
function $a85a6a2869494a29$var$buildPathString(el, kfShape, path) {
    var shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, el.shape);
    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(shape, kfShape);
    el.buildPath(path, shape);
    var svgPathBuilder = new (0, $c8b2ce72d2349eb5$export$2e2bcd8739ae039)();
    svgPathBuilder.reset((0, $999d81abec723db8$export$93fa1ae8a509371c)(el));
    path.rebuildPath(svgPathBuilder, 1);
    svgPathBuilder.generateStr();
    return svgPathBuilder.getStr();
}
function $a85a6a2869494a29$var$setTransformOrigin(target, transform) {
    var originX = transform.originX, originY = transform.originY;
    if (originX || originY) target[$a85a6a2869494a29$var$transformOriginKey] = originX + "px " + originY + "px";
}
var $a85a6a2869494a29$export$f0dede2064ee89d7 = {
    fill: "fill",
    opacity: "opacity",
    lineWidth: "stroke-width",
    lineDashOffset: "stroke-dashoffset"
};
function $a85a6a2869494a29$var$addAnimation(cssAnim, scope) {
    var animationName = scope.zrId + "-ani-" + scope.cssAnimIdx++;
    scope.cssAnims[animationName] = cssAnim;
    return animationName;
}
function $a85a6a2869494a29$var$createCompoundPathCSSAnimation(el, attrs, scope) {
    var paths = el.shape.paths;
    var composedAnim = {};
    var cssAnimationCfg;
    var cssAnimationName;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(paths, function(path) {
        var subScope = (0, $f6ad3c9e333d7ffc$export$96fee5f38ed01741)(scope.zrId);
        subScope.animation = true;
        $a85a6a2869494a29$export$dc9722e37397d426(path, {}, subScope, true);
        var cssAnims = subScope.cssAnims;
        var cssNodes = subScope.cssNodes;
        var animNames = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(cssAnims);
        var len = animNames.length;
        if (!len) return;
        cssAnimationName = animNames[len - 1];
        var lastAnim = cssAnims[cssAnimationName];
        for(var percent in lastAnim){
            var kf = lastAnim[percent];
            composedAnim[percent] = composedAnim[percent] || {
                d: ""
            };
            composedAnim[percent].d += kf.d || "";
        }
        for(var className in cssNodes){
            var val = cssNodes[className].animation;
            if (val.indexOf(cssAnimationName) >= 0) cssAnimationCfg = val;
        }
    });
    if (!cssAnimationCfg) return;
    attrs.d = false;
    var animationName = $a85a6a2869494a29$var$addAnimation(composedAnim, scope);
    return cssAnimationCfg.replace(cssAnimationName, animationName);
}
function $a85a6a2869494a29$var$getEasingFunc(easing) {
    return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(easing) ? $a85a6a2869494a29$export$54ee1847795bcf37[easing] ? "cubic-bezier(" + $a85a6a2869494a29$export$54ee1847795bcf37[easing] + ")" : (0, $0aea98bda0b4be1f$export$ec0863d806fd857e)(easing) ? easing : "" : "";
}
function $a85a6a2869494a29$export$dc9722e37397d426(el, attrs, scope, onlyShape) {
    var animators = el.animators;
    var len = animators.length;
    var cssAnimations = [];
    if (el instanceof (0, $e152f3dbf8fba6e2$export$2e2bcd8739ae039)) {
        var animationCfg = $a85a6a2869494a29$var$createCompoundPathCSSAnimation(el, attrs, scope);
        if (animationCfg) cssAnimations.push(animationCfg);
        else if (!len) return;
    } else if (!len) return;
    var groupAnimators = {};
    for(var i = 0; i < len; i++){
        var animator = animators[i];
        var cfgArr = [
            animator.getMaxTime() / 1000 + "s"
        ];
        var easing = $a85a6a2869494a29$var$getEasingFunc(animator.getClip().easing);
        var delay = animator.getDelay();
        if (easing) cfgArr.push(easing);
        else cfgArr.push("linear");
        if (delay) cfgArr.push(delay / 1000 + "s");
        if (animator.getLoop()) cfgArr.push("infinite");
        var cfg = cfgArr.join(" ");
        groupAnimators[cfg] = groupAnimators[cfg] || [
            cfg,
            []
        ];
        groupAnimators[cfg][1].push(animator);
    }
    function createSingleCSSAnimation(groupAnimator) {
        var animators = groupAnimator[1];
        var len = animators.length;
        var transformKfs = {};
        var shapeKfs = {};
        var finalKfs = {};
        var animationTimingFunctionAttrName = "animation-timing-function";
        function saveAnimatorTrackToCssKfs(animator, cssKfs, toCssAttrName) {
            var tracks = animator.getTracks();
            var maxTime = animator.getMaxTime();
            for(var k = 0; k < tracks.length; k++){
                var track = tracks[k];
                if (track.needsAnimate()) {
                    var kfs = track.keyframes;
                    var attrName = track.propName;
                    toCssAttrName && (attrName = toCssAttrName(attrName));
                    if (attrName) for(var i = 0; i < kfs.length; i++){
                        var kf = kfs[i];
                        var percent = Math.round(kf.time / maxTime * 100) + "%";
                        var kfEasing = $a85a6a2869494a29$var$getEasingFunc(kf.easing);
                        var rawValue = kf.rawValue;
                        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(rawValue) || (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rawValue)) {
                            cssKfs[percent] = cssKfs[percent] || {};
                            cssKfs[percent][attrName] = kf.rawValue;
                            if (kfEasing) cssKfs[percent][animationTimingFunctionAttrName] = kfEasing;
                        }
                    }
                }
            }
        }
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (!targetProp) !onlyShape && saveAnimatorTrackToCssKfs(animator, transformKfs);
            else if (targetProp === "shape") saveAnimatorTrackToCssKfs(animator, shapeKfs);
        }
        for(var percent in transformKfs){
            var transform = {};
            (0, $becf2d727f9cf450$export$234b1c16dfa57d6a)(transform, el);
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(transform, transformKfs[percent]);
            var str = (0, $999d81abec723db8$export$3fe07c0888ff6164)(transform);
            var timingFunction = transformKfs[percent][animationTimingFunctionAttrName];
            finalKfs[percent] = str ? {
                transform: str
            } : {};
            $a85a6a2869494a29$var$setTransformOrigin(finalKfs[percent], transform);
            if (timingFunction) finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
        }
        var path;
        var canAnimateShape = true;
        for(var percent in shapeKfs){
            finalKfs[percent] = finalKfs[percent] || {};
            var isFirst = !path;
            var timingFunction = shapeKfs[percent][animationTimingFunctionAttrName];
            if (isFirst) path = new (0, $20ebe2448f123f2e$export$2e2bcd8739ae039)();
            var len_1 = path.len();
            path.reset();
            finalKfs[percent].d = $a85a6a2869494a29$var$buildPathString(el, shapeKfs[percent], path);
            var newLen = path.len();
            if (!isFirst && len_1 !== newLen) {
                canAnimateShape = false;
                break;
            }
            if (timingFunction) finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
        }
        if (!canAnimateShape) for(var percent in finalKfs)delete finalKfs[percent].d;
        if (!onlyShape) for(var i = 0; i < len; i++){
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (targetProp === "style") saveAnimatorTrackToCssKfs(animator, finalKfs, function(propName) {
                return $a85a6a2869494a29$export$f0dede2064ee89d7[propName];
            });
        }
        var percents = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(finalKfs);
        var allTransformOriginSame = true;
        var transformOrigin;
        for(var i = 1; i < percents.length; i++){
            var p0 = percents[i - 1];
            var p1 = percents[i];
            if (finalKfs[p0][$a85a6a2869494a29$var$transformOriginKey] !== finalKfs[p1][$a85a6a2869494a29$var$transformOriginKey]) {
                allTransformOriginSame = false;
                break;
            }
            transformOrigin = finalKfs[p0][$a85a6a2869494a29$var$transformOriginKey];
        }
        if (allTransformOriginSame && transformOrigin) {
            for(var percent in finalKfs)if (finalKfs[percent][$a85a6a2869494a29$var$transformOriginKey]) delete finalKfs[percent][$a85a6a2869494a29$var$transformOriginKey];
            attrs[$a85a6a2869494a29$var$transformOriginKey] = transformOrigin;
        }
        if ((0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(percents, function(percent) {
            return (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(finalKfs[percent]).length > 0;
        }).length) {
            var animationName = $a85a6a2869494a29$var$addAnimation(finalKfs, scope);
            return animationName + " " + groupAnimator[0] + " both";
        }
    }
    for(var key in groupAnimators){
        var animationCfg = createSingleCSSAnimation(groupAnimators[key]);
        if (animationCfg) cssAnimations.push(animationCfg);
    }
    if (cssAnimations.length) {
        var className = scope.zrId + "-cls-" + (0, $849cb89161be4359$export$9c80c36b7367fb56)();
        scope.cssNodes["." + className] = {
            animation: cssAnimations.join(",")
        };
        attrs["class"] = className;
    }
}






function $05e38a5f94c3c427$export$b4c8f742d3cb22ba(el, attrs, scope) {
    if (!el.ignore) {
        if (el.isSilent()) {
            var style = {
                "pointer-events": "none"
            };
            $05e38a5f94c3c427$var$setClassAttribute(style, attrs, scope, true);
        } else {
            var emphasisStyle = el.states.emphasis && el.states.emphasis.style ? el.states.emphasis.style : {};
            var fill = emphasisStyle.fill;
            if (!fill) {
                var normalFill = el.style && el.style.fill;
                var selectFill = el.states.select && el.states.select.style && el.states.select.style.fill;
                var fromFill = el.currentStates.indexOf("select") >= 0 ? selectFill || normalFill : normalFill;
                if (fromFill) fill = (0, $2c037f5bda6341ca$export$2b47e247dfb87a73)(fromFill);
            }
            var lineWidth = emphasisStyle.lineWidth;
            if (lineWidth) {
                var scaleX = !emphasisStyle.strokeNoScale && el.transform ? el.transform[0] : 1;
                lineWidth = lineWidth / scaleX;
            }
            var style = {
                cursor: "pointer"
            };
            if (fill) style.fill = fill;
            if (emphasisStyle.stroke) style.stroke = emphasisStyle.stroke;
            if (lineWidth) style["stroke-width"] = lineWidth;
            $05e38a5f94c3c427$var$setClassAttribute(style, attrs, scope, true);
        }
    }
}
function $05e38a5f94c3c427$var$setClassAttribute(style, attrs, scope, withHover) {
    var styleKey = JSON.stringify(style);
    var className = scope.cssStyleCache[styleKey];
    if (!className) {
        className = scope.zrId + "-cls-" + (0, $849cb89161be4359$export$9c80c36b7367fb56)();
        scope.cssStyleCache[styleKey] = className;
        scope.cssNodes["." + className + (withHover ? ":hover" : "")] = style;
    }
    attrs["class"] = attrs["class"] ? attrs["class"] + " " + className : className;
}



var $5a7f1b53a6723dcf$var$round = Math.round;
function $5a7f1b53a6723dcf$var$isImageLike(val) {
    return val && (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val.src);
}
function $5a7f1b53a6723dcf$var$isCanvasLike(val) {
    return val && (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(val.toDataURL);
}
function $5a7f1b53a6723dcf$var$setStyleAttrs(attrs, style, el, scope) {
    (0, $6f6b3090476bfa7b$export$2e2bcd8739ae039)(function(key, val) {
        var isFillStroke = key === "fill" || key === "stroke";
        if (isFillStroke && (0, $999d81abec723db8$export$545e02bbd5f8fe95)(val)) $5a7f1b53a6723dcf$export$afaa8352c6a43a44(style, attrs, key, scope);
        else if (isFillStroke && (0, $999d81abec723db8$export$41a28f5a000a9d0f)(val)) $5a7f1b53a6723dcf$export$faed90dbedc3b6d5(el, attrs, key, scope);
        else if (isFillStroke && val === "none") attrs[key] = "transparent";
        else attrs[key] = val;
    }, style, el, false);
    $5a7f1b53a6723dcf$var$setShadow(el, attrs, scope);
}
function $5a7f1b53a6723dcf$var$setMetaData(attrs, el) {
    var metaData = (0, $6eba88f9eebe6af9$export$dd7015a5412ca583)(el);
    if (metaData) {
        metaData.each(function(val, key) {
            val != null && (attrs[((0, $f6ad3c9e333d7ffc$export$d3f79611f155197c) + key).toLowerCase()] = val + "");
        });
        if (el.isSilent()) attrs[(0, $f6ad3c9e333d7ffc$export$d3f79611f155197c) + "silent"] = "true";
    }
}
function $5a7f1b53a6723dcf$var$noRotateScale(m) {
    return (0, $999d81abec723db8$export$4701367f5b4de464)(m[0] - 1) && (0, $999d81abec723db8$export$4701367f5b4de464)(m[1]) && (0, $999d81abec723db8$export$4701367f5b4de464)(m[2]) && (0, $999d81abec723db8$export$4701367f5b4de464)(m[3] - 1);
}
function $5a7f1b53a6723dcf$var$noTranslate(m) {
    return (0, $999d81abec723db8$export$4701367f5b4de464)(m[4]) && (0, $999d81abec723db8$export$4701367f5b4de464)(m[5]);
}
function $5a7f1b53a6723dcf$var$setTransform(attrs, m, compress) {
    if (m && !($5a7f1b53a6723dcf$var$noTranslate(m) && $5a7f1b53a6723dcf$var$noRotateScale(m))) {
        var mul = compress ? 10 : 1e4;
        attrs.transform = $5a7f1b53a6723dcf$var$noRotateScale(m) ? "translate(" + $5a7f1b53a6723dcf$var$round(m[4] * mul) / mul + " " + $5a7f1b53a6723dcf$var$round(m[5] * mul) / mul + ")" : (0, $999d81abec723db8$export$f29a4456cf56ff21)(m);
    }
}
function $5a7f1b53a6723dcf$var$convertPolyShape(shape, attrs, mul) {
    var points = shape.points;
    var strArr = [];
    for(var i = 0; i < points.length; i++){
        strArr.push($5a7f1b53a6723dcf$var$round(points[i][0] * mul) / mul);
        strArr.push($5a7f1b53a6723dcf$var$round(points[i][1] * mul) / mul);
    }
    attrs.points = strArr.join(" ");
}
function $5a7f1b53a6723dcf$var$validatePolyShape(shape) {
    return !shape.smooth;
}
function $5a7f1b53a6723dcf$var$createAttrsConvert(desc) {
    var normalizedDesc = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(desc, function(item) {
        return typeof item === "string" ? [
            item,
            item
        ] : item;
    });
    return function(shape, attrs, mul) {
        for(var i = 0; i < normalizedDesc.length; i++){
            var item = normalizedDesc[i];
            var val = shape[item[0]];
            if (val != null) attrs[item[1]] = $5a7f1b53a6723dcf$var$round(val * mul) / mul;
        }
    };
}
var $5a7f1b53a6723dcf$var$builtinShapesDef = {
    circle: [
        $5a7f1b53a6723dcf$var$createAttrsConvert([
            "cx",
            "cy",
            "r"
        ])
    ],
    polyline: [
        $5a7f1b53a6723dcf$var$convertPolyShape,
        $5a7f1b53a6723dcf$var$validatePolyShape
    ],
    polygon: [
        $5a7f1b53a6723dcf$var$convertPolyShape,
        $5a7f1b53a6723dcf$var$validatePolyShape
    ]
};
function $5a7f1b53a6723dcf$var$hasShapeAnimation(el) {
    var animators = el.animators;
    for(var i = 0; i < animators.length; i++){
        if (animators[i].targetName === "shape") return true;
    }
    return false;
}
function $5a7f1b53a6723dcf$export$1dc017d31b76c55b(el, scope) {
    var style = el.style;
    var shape = el.shape;
    var builtinShpDef = $5a7f1b53a6723dcf$var$builtinShapesDef[el.type];
    var attrs = {};
    var needsAnimate = scope.animation;
    var svgElType = "path";
    var strokePercent = el.style.strokePercent;
    var precision = scope.compress && (0, $999d81abec723db8$export$93fa1ae8a509371c)(el) || 4;
    if (builtinShpDef && !scope.willUpdate && !(builtinShpDef[1] && !builtinShpDef[1](shape)) && !(needsAnimate && $5a7f1b53a6723dcf$var$hasShapeAnimation(el)) && !(strokePercent < 1)) {
        svgElType = el.type;
        var mul = Math.pow(10, precision);
        builtinShpDef[0](shape, attrs, mul);
    } else {
        var needBuildPath = !el.path || el.shapeChanged();
        if (!el.path) el.createPathProxy();
        var path = el.path;
        if (needBuildPath) {
            path.beginPath();
            el.buildPath(path, el.shape);
            el.pathUpdated();
        }
        var pathVersion = path.getVersion();
        var elExt = el;
        var svgPathBuilder = elExt.__svgPathBuilder;
        if (elExt.__svgPathVersion !== pathVersion || !svgPathBuilder || strokePercent !== elExt.__svgPathStrokePercent) {
            if (!svgPathBuilder) svgPathBuilder = elExt.__svgPathBuilder = new (0, $c8b2ce72d2349eb5$export$2e2bcd8739ae039)();
            svgPathBuilder.reset(precision);
            path.rebuildPath(svgPathBuilder, strokePercent);
            svgPathBuilder.generateStr();
            elExt.__svgPathVersion = pathVersion;
            elExt.__svgPathStrokePercent = strokePercent;
        }
        attrs.d = svgPathBuilder.getStr();
    }
    $5a7f1b53a6723dcf$var$setTransform(attrs, el.transform);
    $5a7f1b53a6723dcf$var$setStyleAttrs(attrs, style, el, scope);
    $5a7f1b53a6723dcf$var$setMetaData(attrs, el);
    scope.animation && (0, $a85a6a2869494a29$export$dc9722e37397d426)(el, attrs, scope);
    scope.emphasis && (0, $05e38a5f94c3c427$export$b4c8f742d3cb22ba)(el, attrs, scope);
    return (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)(svgElType, el.id + "", attrs);
}
function $5a7f1b53a6723dcf$export$a35ef46dc8240635(el, scope) {
    var style = el.style;
    var image = style.image;
    if (image && !(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(image)) {
        if ($5a7f1b53a6723dcf$var$isImageLike(image)) image = image.src;
        else if ($5a7f1b53a6723dcf$var$isCanvasLike(image)) image = image.toDataURL();
    }
    if (!image) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var dw = style.width;
    var dh = style.height;
    var attrs = {
        href: image,
        width: dw,
        height: dh
    };
    if (x) attrs.x = x;
    if (y) attrs.y = y;
    $5a7f1b53a6723dcf$var$setTransform(attrs, el.transform);
    $5a7f1b53a6723dcf$var$setStyleAttrs(attrs, style, el, scope);
    $5a7f1b53a6723dcf$var$setMetaData(attrs, el);
    scope.animation && (0, $a85a6a2869494a29$export$dc9722e37397d426)(el, attrs, scope);
    return (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("image", el.id + "", attrs);
}
function $5a7f1b53a6723dcf$export$d506f5385e62a84a(el, scope) {
    var style = el.style;
    var text = style.text;
    text != null && (text += "");
    if (!text || isNaN(style.x) || isNaN(style.y)) return;
    var font = style.font || (0, $c6341dcc9d86826e$export$7d7a232b6d2cc80c);
    var x = style.x || 0;
    var y = (0, $999d81abec723db8$export$bf7d6802d2badd9)(style.y || 0, (0, $6c308355c7107803$export$56204a27a2958a55)(font), style.textBaseline);
    var textAlign = (0, $999d81abec723db8$export$4062150f0600d971)[style.textAlign] || style.textAlign;
    var attrs = {
        "dominant-baseline": "central",
        "text-anchor": textAlign
    };
    if ((0, $fe885cc21795562b$export$4685c95d5118e76a)(style)) {
        var separatedFontStr = "";
        var fontStyle = style.fontStyle;
        var fontSize = (0, $fe885cc21795562b$export$51b066d9cfc2578e)(style.fontSize);
        if (!parseFloat(fontSize)) return;
        var fontFamily = style.fontFamily || (0, $c6341dcc9d86826e$export$2653e0d5dd45b294);
        var fontWeight = style.fontWeight;
        separatedFontStr += "font-size:" + fontSize + ";font-family:" + fontFamily + ";";
        if (fontStyle && fontStyle !== "normal") separatedFontStr += "font-style:" + fontStyle + ";";
        if (fontWeight && fontWeight !== "normal") separatedFontStr += "font-weight:" + fontWeight + ";";
        attrs.style = separatedFontStr;
    } else attrs.style = "font: " + font;
    if (text.match(/\s/)) attrs["xml:space"] = "preserve";
    if (x) attrs.x = x;
    if (y) attrs.y = y;
    $5a7f1b53a6723dcf$var$setTransform(attrs, el.transform);
    $5a7f1b53a6723dcf$var$setStyleAttrs(attrs, style, el, scope);
    $5a7f1b53a6723dcf$var$setMetaData(attrs, el);
    scope.animation && (0, $a85a6a2869494a29$export$dc9722e37397d426)(el, attrs, scope);
    return (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("text", el.id + "", attrs, undefined, text);
}
function $5a7f1b53a6723dcf$export$da5d6544e8c27bc1(el, scope) {
    if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) return $5a7f1b53a6723dcf$export$1dc017d31b76c55b(el, scope);
    else if (el instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) return $5a7f1b53a6723dcf$export$a35ef46dc8240635(el, scope);
    else if (el instanceof (0, $c9d5c769fe2f591f$export$2e2bcd8739ae039)) return $5a7f1b53a6723dcf$export$d506f5385e62a84a(el, scope);
}
function $5a7f1b53a6723dcf$var$setShadow(el, attrs, scope) {
    var style = el.style;
    if ((0, $999d81abec723db8$export$c62076b3a966c94b)(style)) {
        var shadowKey = (0, $999d81abec723db8$export$9e4c657be710688a)(el);
        var shadowCache = scope.shadowCache;
        var shadowId = shadowCache[shadowKey];
        if (!shadowId) {
            var globalScale = el.getGlobalScale();
            var scaleX = globalScale[0];
            var scaleY = globalScale[1];
            if (!scaleX || !scaleY) return;
            var offsetX = style.shadowOffsetX || 0;
            var offsetY = style.shadowOffsetY || 0;
            var blur_1 = style.shadowBlur;
            var _a = (0, $999d81abec723db8$export$4cde5df63f53f473)(style.shadowColor), opacity = _a.opacity, color = _a.color;
            var stdDx = blur_1 / 2 / scaleX;
            var stdDy = blur_1 / 2 / scaleY;
            var stdDeviation = stdDx + " " + stdDy;
            shadowId = scope.zrId + "-s" + scope.shadowIdx++;
            scope.defs[shadowId] = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("filter", shadowId, {
                "id": shadowId,
                "x": "-100%",
                "y": "-100%",
                "width": "300%",
                "height": "300%"
            }, [
                (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("feDropShadow", "", {
                    "dx": offsetX / scaleX,
                    "dy": offsetY / scaleY,
                    "stdDeviation": stdDeviation,
                    "flood-color": color,
                    "flood-opacity": opacity
                })
            ]);
            shadowCache[shadowKey] = shadowId;
        }
        attrs.filter = (0, $999d81abec723db8$export$bb094196179998a5)(shadowId);
    }
}
function $5a7f1b53a6723dcf$export$afaa8352c6a43a44(style, attrs, target, scope) {
    var val = style[target];
    var gradientTag;
    var gradientAttrs = {
        "gradientUnits": val.global ? "userSpaceOnUse" : "objectBoundingBox"
    };
    if ((0, $999d81abec723db8$export$7d961bca9d3b47d0)(val)) {
        gradientTag = "linearGradient";
        gradientAttrs.x1 = val.x;
        gradientAttrs.y1 = val.y;
        gradientAttrs.x2 = val.x2;
        gradientAttrs.y2 = val.y2;
    } else if ((0, $999d81abec723db8$export$2a9cca6692a0ce3a)(val)) {
        gradientTag = "radialGradient";
        gradientAttrs.cx = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(val.x, 0.5);
        gradientAttrs.cy = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(val.y, 0.5);
        gradientAttrs.r = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(val.r, 0.5);
    } else return;
    var colors = val.colorStops;
    var colorStops = [];
    for(var i = 0, len = colors.length; i < len; ++i){
        var offset = (0, $999d81abec723db8$export$52bfc6d3e2ff0fc2)(colors[i].offset) * 100 + "%";
        var stopColor = colors[i].color;
        var _a = (0, $999d81abec723db8$export$4cde5df63f53f473)(stopColor), color = _a.color, opacity = _a.opacity;
        var stopsAttrs = {
            "offset": offset
        };
        stopsAttrs["stop-color"] = color;
        if (opacity < 1) stopsAttrs["stop-opacity"] = opacity;
        colorStops.push((0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("stop", i + "", stopsAttrs));
    }
    var gradientVNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)(gradientTag, "", gradientAttrs, colorStops);
    var gradientKey = (0, $f6ad3c9e333d7ffc$export$f5c4a9a0e027f2b)(gradientVNode);
    var gradientCache = scope.gradientCache;
    var gradientId = gradientCache[gradientKey];
    if (!gradientId) {
        gradientId = scope.zrId + "-g" + scope.gradientIdx++;
        gradientCache[gradientKey] = gradientId;
        gradientAttrs.id = gradientId;
        scope.defs[gradientId] = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)(gradientTag, gradientId, gradientAttrs, colorStops);
    }
    attrs[target] = (0, $999d81abec723db8$export$bb094196179998a5)(gradientId);
}
function $5a7f1b53a6723dcf$export$faed90dbedc3b6d5(el, attrs, target, scope) {
    var val = el.style[target];
    var boundingRect = el.getBoundingRect();
    var patternAttrs = {};
    var repeat = val.repeat;
    var noRepeat = repeat === "no-repeat";
    var repeatX = repeat === "repeat-x";
    var repeatY = repeat === "repeat-y";
    var child;
    if ((0, $999d81abec723db8$export$2ade673ac4f85dfe)(val)) {
        var imageWidth_1 = val.imageWidth;
        var imageHeight_1 = val.imageHeight;
        var imageSrc = void 0;
        var patternImage = val.image;
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(patternImage)) imageSrc = patternImage;
        else if ($5a7f1b53a6723dcf$var$isImageLike(patternImage)) imageSrc = patternImage.src;
        else if ($5a7f1b53a6723dcf$var$isCanvasLike(patternImage)) imageSrc = patternImage.toDataURL();
        if (typeof Image === "undefined") {
            var errMsg = "Image width/height must been given explictly in svg-ssr renderer.";
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(imageWidth_1, errMsg);
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(imageHeight_1, errMsg);
        } else if (imageWidth_1 == null || imageHeight_1 == null) {
            var setSizeToVNode_1 = function(vNode, img) {
                if (vNode) {
                    var svgEl = vNode.elm;
                    var width = imageWidth_1 || img.width;
                    var height = imageHeight_1 || img.height;
                    if (vNode.tag === "pattern") {
                        if (repeatX) {
                            height = 1;
                            width /= boundingRect.width;
                        } else if (repeatY) {
                            width = 1;
                            height /= boundingRect.height;
                        }
                    }
                    vNode.attrs.width = width;
                    vNode.attrs.height = height;
                    if (svgEl) {
                        svgEl.setAttribute("width", width);
                        svgEl.setAttribute("height", height);
                    }
                }
            };
            var createdImage = (0, $a53bd598adfb7ebe$export$46c791b69ff9a0f)(imageSrc, null, el, function(img) {
                noRepeat || setSizeToVNode_1(patternVNode, img);
                setSizeToVNode_1(child, img);
            });
            if (createdImage && createdImage.width && createdImage.height) {
                imageWidth_1 = imageWidth_1 || createdImage.width;
                imageHeight_1 = imageHeight_1 || createdImage.height;
            }
        }
        child = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("image", "img", {
            href: imageSrc,
            width: imageWidth_1,
            height: imageHeight_1
        });
        patternAttrs.width = imageWidth_1;
        patternAttrs.height = imageHeight_1;
    } else if (val.svgElement) {
        child = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(val.svgElement);
        patternAttrs.width = val.svgWidth;
        patternAttrs.height = val.svgHeight;
    }
    if (!child) return;
    var patternWidth;
    var patternHeight;
    if (noRepeat) patternWidth = patternHeight = 1;
    else if (repeatX) {
        patternHeight = 1;
        patternWidth = patternAttrs.width / boundingRect.width;
    } else if (repeatY) {
        patternWidth = 1;
        patternHeight = patternAttrs.height / boundingRect.height;
    } else patternAttrs.patternUnits = "userSpaceOnUse";
    if (patternWidth != null && !isNaN(patternWidth)) patternAttrs.width = patternWidth;
    if (patternHeight != null && !isNaN(patternHeight)) patternAttrs.height = patternHeight;
    var patternTransform = (0, $999d81abec723db8$export$3fe07c0888ff6164)(val);
    patternTransform && (patternAttrs.patternTransform = patternTransform);
    var patternVNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("pattern", "", patternAttrs, [
        child
    ]);
    var patternKey = (0, $f6ad3c9e333d7ffc$export$f5c4a9a0e027f2b)(patternVNode);
    var patternCache = scope.patternCache;
    var patternId = patternCache[patternKey];
    if (!patternId) {
        patternId = scope.zrId + "-p" + scope.patternIdx++;
        patternCache[patternKey] = patternId;
        patternAttrs.id = patternId;
        patternVNode = scope.defs[patternId] = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("pattern", patternId, patternAttrs, [
            child
        ]);
    }
    attrs[target] = (0, $999d81abec723db8$export$bb094196179998a5)(patternId);
}
function $5a7f1b53a6723dcf$export$8f1d80b445d4fc(clipPath, attrs, scope) {
    var clipPathCache = scope.clipPathCache, defs = scope.defs;
    var clipPathId = clipPathCache[clipPath.id];
    if (!clipPathId) {
        clipPathId = scope.zrId + "-c" + scope.clipPathIdx++;
        var clipPathAttrs = {
            id: clipPathId
        };
        clipPathCache[clipPath.id] = clipPathId;
        defs[clipPathId] = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("clipPath", clipPathId, clipPathAttrs, [
            $5a7f1b53a6723dcf$export$1dc017d31b76c55b(clipPath, scope)
        ]);
    }
    attrs["clip-path"] = (0, $999d81abec723db8$export$bb094196179998a5)(clipPathId);
}







function $a4f5b07c584c2741$export$b2ce9ad90858ed7a(text) {
    return document.createTextNode(text);
}
function $a4f5b07c584c2741$export$2a15b079e3f46654(text) {
    return document.createComment(text);
}
function $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function $a4f5b07c584c2741$export$7ae609f7af59e4f7(node, child) {
    node.removeChild(child);
}
function $a4f5b07c584c2741$export$1b8e57c9ea42f1d2(node, child) {
    node.appendChild(child);
}
function $a4f5b07c584c2741$export$b54be7ce267a037b(node) {
    return node.parentNode;
}
function $a4f5b07c584c2741$export$335219007e689d29(node) {
    return node.nextSibling;
}
function $a4f5b07c584c2741$export$45e0b80f1e500bd4(elm) {
    return elm.tagName;
}
function $a4f5b07c584c2741$export$94b0296cab6203e(node, text) {
    node.textContent = text;
}
function $a4f5b07c584c2741$export$132e79e4118a78e0(node) {
    return node.textContent;
}
function $a4f5b07c584c2741$export$45a5e7f76e0caa8d(node) {
    return node.nodeType === 1;
}
function $a4f5b07c584c2741$export$1879817ac5c922b7(node) {
    return node.nodeType === 3;
}
function $a4f5b07c584c2741$export$3ab01370f5e64ac8(node) {
    return node.nodeType === 8;
}


var $57ac702d7860318b$var$colonChar = 58;
var $57ac702d7860318b$var$xChar = 120;
var $57ac702d7860318b$var$emptyNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("", "");
function $57ac702d7860318b$var$isUndef(s) {
    return s === undefined;
}
function $57ac702d7860318b$var$isDef(s) {
    return s !== undefined;
}
function $57ac702d7860318b$var$createKeyToOldIdx(children, beginIdx, endIdx) {
    var map = {};
    for(var i = beginIdx; i <= endIdx; ++i){
        var key = children[i].key;
        if (key !== undefined) map[key] = i;
    }
    return map;
}
function $57ac702d7860318b$var$sameVnode(vnode1, vnode2) {
    var isSameKey = vnode1.key === vnode2.key;
    var isSameTag = vnode1.tag === vnode2.tag;
    return isSameTag && isSameKey;
}
function $57ac702d7860318b$var$createElm(vnode) {
    var i;
    var children = vnode.children;
    var tag = vnode.tag;
    if ($57ac702d7860318b$var$isDef(tag)) {
        var elm = vnode.elm = (0, $f6ad3c9e333d7ffc$export$c8a8987d4410bf2d)(tag);
        $57ac702d7860318b$export$277dcc6f06048f24($57ac702d7860318b$var$emptyNode, vnode);
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(children)) for(i = 0; i < children.length; ++i){
            var ch = children[i];
            if (ch != null) $a4f5b07c584c2741$export$1b8e57c9ea42f1d2(elm, $57ac702d7860318b$var$createElm(ch));
        }
        else if ($57ac702d7860318b$var$isDef(vnode.text) && !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(vnode.text)) $a4f5b07c584c2741$export$1b8e57c9ea42f1d2(elm, $a4f5b07c584c2741$export$b2ce9ad90858ed7a(vnode.text));
    } else vnode.elm = $a4f5b07c584c2741$export$b2ce9ad90858ed7a(vnode.text);
    return vnode.elm;
}
function $57ac702d7860318b$var$addVnodes(parentElm, before, vnodes, startIdx, endIdx) {
    for(; startIdx <= endIdx; ++startIdx){
        var ch = vnodes[startIdx];
        if (ch != null) $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, $57ac702d7860318b$var$createElm(ch), before);
    }
}
function $57ac702d7860318b$var$removeVnodes(parentElm, vnodes, startIdx, endIdx) {
    for(; startIdx <= endIdx; ++startIdx){
        var ch = vnodes[startIdx];
        if (ch != null) {
            if ($57ac702d7860318b$var$isDef(ch.tag)) {
                var parent_1 = $a4f5b07c584c2741$export$b54be7ce267a037b(ch.elm);
                $a4f5b07c584c2741$export$7ae609f7af59e4f7(parent_1, ch.elm);
            } else $a4f5b07c584c2741$export$7ae609f7af59e4f7(parentElm, ch.elm);
        }
    }
}
function $57ac702d7860318b$export$277dcc6f06048f24(oldVnode, vnode) {
    var key;
    var elm = vnode.elm;
    var oldAttrs = oldVnode && oldVnode.attrs || {};
    var attrs = vnode.attrs || {};
    if (oldAttrs === attrs) return;
    for(key in attrs){
        var cur = attrs[key];
        var old = oldAttrs[key];
        if (old !== cur) {
            if (cur === true) elm.setAttribute(key, "");
            else if (cur === false) elm.removeAttribute(key);
            else {
                if (key === "style") elm.style.cssText = cur;
                else if (key.charCodeAt(0) !== $57ac702d7860318b$var$xChar) elm.setAttribute(key, cur);
                else if (key === "xmlns:xlink" || key === "xmlns") elm.setAttributeNS((0, $f6ad3c9e333d7ffc$export$fac09d762d15fa3b), key, cur);
                else if (key.charCodeAt(3) === $57ac702d7860318b$var$colonChar) elm.setAttributeNS((0, $f6ad3c9e333d7ffc$export$ad4c4fdecd3b4156), key, cur);
                else if (key.charCodeAt(5) === $57ac702d7860318b$var$colonChar) elm.setAttributeNS((0, $f6ad3c9e333d7ffc$export$b22c6da1792ecec8), key, cur);
                else elm.setAttribute(key, cur);
            }
        }
    }
    for(key in oldAttrs)if (!(key in attrs)) elm.removeAttribute(key);
}
function $57ac702d7860318b$var$updateChildren(parentElm, oldCh, newCh) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx;
    var idxInOld;
    var elmToMove;
    var before;
    while(oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx){
        if (oldStartVnode == null) oldStartVnode = oldCh[++oldStartIdx];
        else if (oldEndVnode == null) oldEndVnode = oldCh[--oldEndIdx];
        else if (newStartVnode == null) newStartVnode = newCh[++newStartIdx];
        else if (newEndVnode == null) newEndVnode = newCh[--newEndIdx];
        else if ($57ac702d7860318b$var$sameVnode(oldStartVnode, newStartVnode)) {
            $57ac702d7860318b$var$patchVnode(oldStartVnode, newStartVnode);
            oldStartVnode = oldCh[++oldStartIdx];
            newStartVnode = newCh[++newStartIdx];
        } else if ($57ac702d7860318b$var$sameVnode(oldEndVnode, newEndVnode)) {
            $57ac702d7860318b$var$patchVnode(oldEndVnode, newEndVnode);
            oldEndVnode = oldCh[--oldEndIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($57ac702d7860318b$var$sameVnode(oldStartVnode, newEndVnode)) {
            $57ac702d7860318b$var$patchVnode(oldStartVnode, newEndVnode);
            $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, oldStartVnode.elm, $a4f5b07c584c2741$export$335219007e689d29(oldEndVnode.elm));
            oldStartVnode = oldCh[++oldStartIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($57ac702d7860318b$var$sameVnode(oldEndVnode, newStartVnode)) {
            $57ac702d7860318b$var$patchVnode(oldEndVnode, newStartVnode);
            $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, oldEndVnode.elm, oldStartVnode.elm);
            oldEndVnode = oldCh[--oldEndIdx];
            newStartVnode = newCh[++newStartIdx];
        } else {
            if ($57ac702d7860318b$var$isUndef(oldKeyToIdx)) oldKeyToIdx = $57ac702d7860318b$var$createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
            idxInOld = oldKeyToIdx[newStartVnode.key];
            if ($57ac702d7860318b$var$isUndef(idxInOld)) $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, $57ac702d7860318b$var$createElm(newStartVnode), oldStartVnode.elm);
            else {
                elmToMove = oldCh[idxInOld];
                if (elmToMove.tag !== newStartVnode.tag) $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, $57ac702d7860318b$var$createElm(newStartVnode), oldStartVnode.elm);
                else {
                    $57ac702d7860318b$var$patchVnode(elmToMove, newStartVnode);
                    oldCh[idxInOld] = undefined;
                    $a4f5b07c584c2741$export$86b68c7dbeb53c22(parentElm, elmToMove.elm, oldStartVnode.elm);
                }
            }
            newStartVnode = newCh[++newStartIdx];
        }
    }
    if (oldStartIdx <= oldEndIdx || newStartIdx <= newEndIdx) {
        if (oldStartIdx > oldEndIdx) {
            before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
            $57ac702d7860318b$var$addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx);
        } else $57ac702d7860318b$var$removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
}
function $57ac702d7860318b$var$patchVnode(oldVnode, vnode) {
    var elm = vnode.elm = oldVnode.elm;
    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (oldVnode === vnode) return;
    $57ac702d7860318b$export$277dcc6f06048f24(oldVnode, vnode);
    if ($57ac702d7860318b$var$isUndef(vnode.text)) {
        if ($57ac702d7860318b$var$isDef(oldCh) && $57ac702d7860318b$var$isDef(ch)) {
            if (oldCh !== ch) $57ac702d7860318b$var$updateChildren(elm, oldCh, ch);
        } else if ($57ac702d7860318b$var$isDef(ch)) {
            if ($57ac702d7860318b$var$isDef(oldVnode.text)) $a4f5b07c584c2741$export$94b0296cab6203e(elm, "");
            $57ac702d7860318b$var$addVnodes(elm, null, ch, 0, ch.length - 1);
        } else if ($57ac702d7860318b$var$isDef(oldCh)) $57ac702d7860318b$var$removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        else if ($57ac702d7860318b$var$isDef(oldVnode.text)) $a4f5b07c584c2741$export$94b0296cab6203e(elm, "");
    } else if (oldVnode.text !== vnode.text) {
        if ($57ac702d7860318b$var$isDef(oldCh)) $57ac702d7860318b$var$removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        $a4f5b07c584c2741$export$94b0296cab6203e(elm, vnode.text);
    }
}
function $57ac702d7860318b$export$2e2bcd8739ae039(oldVnode, vnode) {
    if ($57ac702d7860318b$var$sameVnode(oldVnode, vnode)) $57ac702d7860318b$var$patchVnode(oldVnode, vnode);
    else {
        var elm = oldVnode.elm;
        var parent_2 = $a4f5b07c584c2741$export$b54be7ce267a037b(elm);
        $57ac702d7860318b$var$createElm(vnode);
        if (parent_2 !== null) {
            $a4f5b07c584c2741$export$86b68c7dbeb53c22(parent_2, vnode.elm, $a4f5b07c584c2741$export$335219007e689d29(elm));
            $57ac702d7860318b$var$removeVnodes(parent_2, [
                oldVnode
            ], 0, 0);
        }
    }
    return vnode;
}



var $c7b90ea532fd792a$var$svgId = 0;
var $c7b90ea532fd792a$var$SVGPainter = function() {
    function SVGPainter(root, storage, opts) {
        this.type = "svg";
        this.refreshHover = $c7b90ea532fd792a$var$createMethodNotSupport("refreshHover");
        this.configLayer = $c7b90ea532fd792a$var$createMethodNotSupport("configLayer");
        this.storage = storage;
        this._opts = opts = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, opts);
        this.root = root;
        this._id = "zr" + $c7b90ea532fd792a$var$svgId++;
        this._oldVNode = (0, $f6ad3c9e333d7ffc$export$5529a6aad332ee75)(opts.width, opts.height);
        if (root && !opts.ssr) {
            var viewport = this._viewport = document.createElement("div");
            viewport.style.cssText = "position:relative;overflow:hidden";
            var svgDom = this._svgDom = this._oldVNode.elm = (0, $f6ad3c9e333d7ffc$export$c8a8987d4410bf2d)("svg");
            (0, $57ac702d7860318b$export$277dcc6f06048f24)(null, this._oldVNode);
            viewport.appendChild(svgDom);
            root.appendChild(viewport);
        }
        this.resize(opts.width, opts.height);
    }
    SVGPainter.prototype.getType = function() {
        return this.type;
    };
    SVGPainter.prototype.getViewportRoot = function() {
        return this._viewport;
    };
    SVGPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    SVGPainter.prototype.getSvgDom = function() {
        return this._svgDom;
    };
    SVGPainter.prototype.refresh = function() {
        if (this.root) {
            var vnode = this.renderToVNode({
                willUpdate: true
            });
            vnode.attrs.style = "position:absolute;left:0;top:0;user-select:none";
            (0, $57ac702d7860318b$export$2e2bcd8739ae039)(this._oldVNode, vnode);
            this._oldVNode = vnode;
        }
    };
    SVGPainter.prototype.renderOneToVNode = function(el) {
        return (0, $5a7f1b53a6723dcf$export$da5d6544e8c27bc1)(el, (0, $f6ad3c9e333d7ffc$export$96fee5f38ed01741)(this._id));
    };
    SVGPainter.prototype.renderToVNode = function(opts) {
        opts = opts || {};
        var list = this.storage.getDisplayList(true);
        var width = this._width;
        var height = this._height;
        var scope = (0, $f6ad3c9e333d7ffc$export$96fee5f38ed01741)(this._id);
        scope.animation = opts.animation;
        scope.willUpdate = opts.willUpdate;
        scope.compress = opts.compress;
        scope.emphasis = opts.emphasis;
        var children = [];
        var bgVNode = this._bgVNode = $c7b90ea532fd792a$var$createBackgroundVNode(width, height, this._backgroundColor, scope);
        bgVNode && children.push(bgVNode);
        var mainVNode = !opts.compress ? this._mainVNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("g", "main", {}, []) : null;
        this._paintList(list, scope, mainVNode ? mainVNode.children : children);
        mainVNode && children.push(mainVNode);
        var defs = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(scope.defs), function(id) {
            return scope.defs[id];
        });
        if (defs.length) children.push((0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("defs", "defs", {}, defs));
        if (opts.animation) {
            var animationCssStr = (0, $f6ad3c9e333d7ffc$export$e2b4f3597c7a7dcb)(scope.cssNodes, scope.cssAnims, {
                newline: true
            });
            if (animationCssStr) {
                var styleNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("style", "stl", {}, [], animationCssStr);
                children.push(styleNode);
            }
        }
        return (0, $f6ad3c9e333d7ffc$export$5529a6aad332ee75)(width, height, children, opts.useViewBox);
    };
    SVGPainter.prototype.renderToString = function(opts) {
        opts = opts || {};
        return (0, $f6ad3c9e333d7ffc$export$f5c4a9a0e027f2b)(this.renderToVNode({
            animation: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.cssAnimation, true),
            emphasis: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.cssEmphasis, true),
            willUpdate: false,
            compress: true,
            useViewBox: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(opts.useViewBox, true)
        }), {
            newline: true
        });
    };
    SVGPainter.prototype.setBackgroundColor = function(backgroundColor) {
        this._backgroundColor = backgroundColor;
    };
    SVGPainter.prototype.getSvgRoot = function() {
        return this._mainVNode && this._mainVNode.elm;
    };
    SVGPainter.prototype._paintList = function(list, scope, out) {
        var listLen = list.length;
        var clipPathsGroupsStack = [];
        var clipPathsGroupsStackDepth = 0;
        var currentClipPathGroup;
        var prevClipPaths;
        var clipGroupNodeIdx = 0;
        for(var i = 0; i < listLen; i++){
            var displayable = list[i];
            if (!displayable.invisible) {
                var clipPaths = displayable.__clipPaths;
                var len = clipPaths && clipPaths.length || 0;
                var prevLen = prevClipPaths && prevClipPaths.length || 0;
                var lca = void 0;
                for(lca = Math.max(len - 1, prevLen - 1); lca >= 0; lca--){
                    if (clipPaths && prevClipPaths && clipPaths[lca] === prevClipPaths[lca]) break;
                }
                for(var i_1 = prevLen - 1; i_1 > lca; i_1--){
                    clipPathsGroupsStackDepth--;
                    currentClipPathGroup = clipPathsGroupsStack[clipPathsGroupsStackDepth - 1];
                }
                for(var i_2 = lca + 1; i_2 < len; i_2++){
                    var groupAttrs = {};
                    (0, $5a7f1b53a6723dcf$export$8f1d80b445d4fc)(clipPaths[i_2], groupAttrs, scope);
                    var g = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("g", "clip-g-" + clipGroupNodeIdx++, groupAttrs, []);
                    (currentClipPathGroup ? currentClipPathGroup.children : out).push(g);
                    clipPathsGroupsStack[clipPathsGroupsStackDepth++] = g;
                    currentClipPathGroup = g;
                }
                prevClipPaths = clipPaths;
                var ret = (0, $5a7f1b53a6723dcf$export$da5d6544e8c27bc1)(displayable, scope);
                if (ret) (currentClipPathGroup ? currentClipPathGroup.children : out).push(ret);
            }
        }
    };
    SVGPainter.prototype.resize = function(width, height) {
        var opts = this._opts;
        var root = this.root;
        var viewport = this._viewport;
        width != null && (opts.width = width);
        height != null && (opts.height = height);
        if (root && viewport) {
            viewport.style.display = "none";
            width = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 0, opts);
            height = (0, $d76b6507633b3c44$export$31b21d0167753bb4)(root, 1, opts);
            viewport.style.display = "";
        }
        if (this._width !== width || this._height !== height) {
            this._width = width;
            this._height = height;
            if (viewport) {
                var viewportStyle = viewport.style;
                viewportStyle.width = width + "px";
                viewportStyle.height = height + "px";
            }
            if (!(0, $999d81abec723db8$export$41a28f5a000a9d0f)(this._backgroundColor)) {
                var svgDom = this._svgDom;
                if (svgDom) {
                    svgDom.setAttribute("width", width);
                    svgDom.setAttribute("height", height);
                }
                var bgEl = this._bgVNode && this._bgVNode.elm;
                if (bgEl) {
                    bgEl.setAttribute("width", width);
                    bgEl.setAttribute("height", height);
                }
            } else this.refresh();
        }
    };
    SVGPainter.prototype.getWidth = function() {
        return this._width;
    };
    SVGPainter.prototype.getHeight = function() {
        return this._height;
    };
    SVGPainter.prototype.dispose = function() {
        if (this.root) this.root.innerHTML = "";
        this._svgDom = this._viewport = this.storage = this._oldVNode = this._bgVNode = this._mainVNode = null;
    };
    SVGPainter.prototype.clear = function() {
        if (this._svgDom) this._svgDom.innerHTML = null;
        this._oldVNode = null;
    };
    SVGPainter.prototype.toDataURL = function(base64) {
        var str = this.renderToString();
        var prefix = "data:image/svg+xml;";
        if (base64) {
            str = (0, $999d81abec723db8$export$8fb536984ec8b4d7)(str);
            return str && prefix + "base64," + str;
        }
        return prefix + "charset=UTF-8," + encodeURIComponent(str);
    };
    return SVGPainter;
}();
function $c7b90ea532fd792a$var$createMethodNotSupport(method) {
    return function() {};
}
function $c7b90ea532fd792a$var$createBackgroundVNode(width, height, backgroundColor, scope) {
    var bgVNode;
    if (backgroundColor && backgroundColor !== "none") {
        bgVNode = (0, $f6ad3c9e333d7ffc$export$bf5c4cf060303d58)("rect", "bg", {
            width: width,
            height: height,
            x: "0",
            y: "0"
        });
        if ((0, $999d81abec723db8$export$545e02bbd5f8fe95)(backgroundColor)) (0, $5a7f1b53a6723dcf$export$afaa8352c6a43a44)({
            fill: backgroundColor
        }, bgVNode.attrs, "fill", scope);
        else if ((0, $999d81abec723db8$export$41a28f5a000a9d0f)(backgroundColor)) (0, $5a7f1b53a6723dcf$export$faed90dbedc3b6d5)({
            style: {
                fill: backgroundColor
            },
            dirty: (0, $7a1bd9c2710fea0d$export$8793edee2d425525),
            getBoundingRect: function() {
                return {
                    width: width,
                    height: height
                };
            }
        }, bgVNode.attrs, "fill", scope);
        else {
            var _a = (0, $999d81abec723db8$export$4cde5df63f53f473)(backgroundColor), color = _a.color, opacity = _a.opacity;
            bgVNode.attrs.fill = color;
            opacity < 1 && (bgVNode.attrs["fill-opacity"] = opacity);
        }
    }
    return bgVNode;
}
var $c7b90ea532fd792a$export$2e2bcd8739ae039 = $c7b90ea532fd792a$var$SVGPainter;


function $8d8c6eb926bbdd0e$export$4b3e715f166fdd78(registers) {
    registers.registerPainter("svg", (0, $c7b90ea532fd792a$export$2e2bcd8739ae039));
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $85b723b311a86ffc$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $85b723b311a86ffc$var$dimTypeShort = {
    float: "f",
    int: "i",
    ordinal: "o",
    number: "n",
    time: "t"
};
/**
 * Represents the dimension requirement of a series.
 *
 * NOTICE:
 * When there are too many dimensions in dataset and many series, only the used dimensions
 * (i.e., used by coord sys and declared in `series.encode`) are add to `dimensionDefineList`.
 * But users may query data by other unused dimension names.
 * In this case, users can only query data if and only if they have defined dimension names
 * via ec option, so we provide `getDimensionIndexFromSource`, which only query them from
 * `source` dimensions.
 */ var $85b723b311a86ffc$export$a1ef064685775f3e = /** @class */ function() {
    function SeriesDataSchema(opt) {
        this.dimensions = opt.dimensions;
        this._dimOmitted = opt.dimensionOmitted;
        this.source = opt.source;
        this._fullDimCount = opt.fullDimensionCount;
        this._updateDimOmitted(opt.dimensionOmitted);
    }
    SeriesDataSchema.prototype.isDimensionOmitted = function() {
        return this._dimOmitted;
    };
    SeriesDataSchema.prototype._updateDimOmitted = function(dimensionOmitted) {
        this._dimOmitted = dimensionOmitted;
        if (!dimensionOmitted) return;
        if (!this._dimNameMap) this._dimNameMap = $85b723b311a86ffc$export$be39ae17310c33f7(this.source);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Get index by user defined dimension name (i.e., not internal generate name).
   * That is, get index from `dimensionsDefine`.
   * If no `dimensionsDefine`, or no name get, return -1.
   */ SeriesDataSchema.prototype.getSourceDimensionIndex = function(dimName) {
        return (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(this._dimNameMap.get(dimName), -1);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Notice: may return `null`/`undefined` if user not specify dimension names.
   */ SeriesDataSchema.prototype.getSourceDimension = function(dimIndex) {
        var dimensionsDefine = this.source.dimensionsDefine;
        if (dimensionsDefine) return dimensionsDefine[dimIndex];
    };
    SeriesDataSchema.prototype.makeStoreSchema = function() {
        var dimCount = this._fullDimCount;
        var willRetrieveDataByName = (0, $99e22f5c2aa5094b$export$8911336b527f8517)(this.source);
        var makeHashStrict = !$85b723b311a86ffc$export$238b87930d825d87(dimCount);
        // If source don't have dimensions or series don't omit unsed dimensions.
        // Generate from seriesDimList directly
        var dimHash = "";
        var dims = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++){
            var property = void 0;
            var type = void 0;
            var ordinalMeta = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                property = willRetrieveDataByName ? seriesDimDef.name : null;
                type = seriesDimDef.type;
                ordinalMeta = seriesDimDef.ordinalMeta;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) {
                    property = willRetrieveDataByName ? sourceDimDef.name : null;
                    type = sourceDimDef.type;
                }
            }
            dims.push({
                property: property,
                type: type,
                ordinalMeta: ordinalMeta
            });
            // If retrieving data by index,
            //   use <index, type, ordinalMeta> to determine whether data can be shared.
            //   (Because in this case there might be no dimension name defined in dataset, but indices always exists).
            //   (Indices are always 0, 1, 2, ..., so we can ignore them to shorten the hash).
            // Otherwise if retrieving data by property name (like `data: [{aa: 123, bb: 765}, ...]`),
            //   use <property, type, ordinalMeta> in hash.
            if (willRetrieveDataByName && property != null && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) dimHash += makeHashStrict ? property.replace(/\`/g, "`1").replace(/\$/g, "`2") : property;
            dimHash += "$";
            dimHash += $85b723b311a86ffc$var$dimTypeShort[type] || "f";
            if (ordinalMeta) dimHash += ordinalMeta.uid;
            dimHash += "$";
        }
        // Source from endpoint(usually series) will be read differently
        // when seriesLayoutBy or startIndex(which is affected by sourceHeader) are different.
        // So we use this three props as key.
        var source = this.source;
        var hash = [
            source.seriesLayoutBy,
            source.startIndex,
            dimHash
        ].join("$$");
        return {
            dimensions: dims,
            hash: hash
        };
    };
    SeriesDataSchema.prototype.makeOutputDimensionNames = function() {
        var result = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++){
            var name_1 = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                if (!seriesDimDef.isCalculationCoord) name_1 = seriesDimDef.name;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) name_1 = sourceDimDef.name;
            }
            result.push(name_1);
        }
        return result;
    };
    SeriesDataSchema.prototype.appendCalculationDimension = function(dimDef) {
        this.dimensions.push(dimDef);
        dimDef.isCalculationCoord = true;
        this._fullDimCount++;
        // If append dimension on a data store, consider the store
        // might be shared by different series, series dimensions not
        // really map to store dimensions.
        this._updateDimOmitted(true);
    };
    return SeriesDataSchema;
}();
function $85b723b311a86ffc$export$fafbc856132a3a0e(schema) {
    return schema instanceof $85b723b311a86ffc$export$a1ef064685775f3e;
}
function $85b723b311a86ffc$export$a477f5bebfd07944(dimsDef) {
    var dataDimNameMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    for(var i = 0; i < (dimsDef || []).length; i++){
        var dimDefItemRaw = dimsDef[i];
        var userDimName = (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;
        if (userDimName != null && dataDimNameMap.get(userDimName) == null) dataDimNameMap.set(userDimName, i);
    }
    return dataDimNameMap;
}
function $85b723b311a86ffc$export$be39ae17310c33f7(source) {
    var innerSource = $85b723b311a86ffc$var$inner(source);
    return innerSource.dimNameMap || (innerSource.dimNameMap = $85b723b311a86ffc$export$a477f5bebfd07944(source.dimensionsDefine));
}
function $85b723b311a86ffc$export$238b87930d825d87(dimCount) {
    return dimCount > 30;
}


function $efdd976e4917927c$export$f2165f9e8499b278(seriesModel, dimensionsInput, opt) {
    opt = opt || {};
    var byIndex = opt.byIndex;
    var stackedCoordDimension = opt.stackedCoordDimension;
    var dimensionDefineList;
    var schema;
    var store;
    if ($efdd976e4917927c$var$isLegacyDimensionsInput(dimensionsInput)) dimensionDefineList = dimensionsInput;
    else {
        schema = dimensionsInput.schema;
        dimensionDefineList = schema.dimensions;
        store = dimensionsInput.store;
    }
    // Compatibal: when `stack` is set as '', do not stack.
    var mayStack = !!(seriesModel && seriesModel.get("stack"));
    var stackedByDimInfo;
    var stackedDimInfo;
    var stackResultDimension;
    var stackedOverDimension;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo, index) {
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(dimensionInfo)) dimensionDefineList[index] = dimensionInfo = {
            name: dimensionInfo
        };
        if (mayStack && !dimensionInfo.isExtraCoord) {
            // Find the first ordinal dimension as the stackedByDimInfo.
            if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) stackedByDimInfo = dimensionInfo;
            // Find the first stackable dimension as the stackedDimInfo.
            if (!stackedDimInfo && dimensionInfo.type !== "ordinal" && dimensionInfo.type !== "time" && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) stackedDimInfo = dimensionInfo;
        }
    });
    if (stackedDimInfo && !byIndex && !stackedByDimInfo) // Compatible with previous design, value axis (time axis) only stack by index.
    // It may make sense if the user provides elaborately constructed data.
    byIndex = true;
    // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
    // That put stack logic in List is for using conveniently in echarts extensions, but it
    // might not be a good way.
    if (stackedDimInfo) {
        // Use a weird name that not duplicated with other names.
        // Also need to use seriesModel.id as postfix because different
        // series may share same data store. The stack dimension needs to be distinguished.
        stackResultDimension = "__\0ecstackresult_" + seriesModel.id;
        stackedOverDimension = "__\0ecstackedover_" + seriesModel.id;
        // Create inverted index to fast query index by value.
        if (stackedByDimInfo) stackedByDimInfo.createInvertedIndices = true;
        var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
        var stackedDimType = stackedDimInfo.type;
        var stackedDimCoordIndex_1 = 0;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo) {
            if (dimensionInfo.coordDim === stackedDimCoordDim_1) stackedDimCoordIndex_1++;
        });
        var stackedOverDimensionDefine = {
            name: stackResultDimension,
            coordDim: stackedDimCoordDim_1,
            coordDimIndex: stackedDimCoordIndex_1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length
        };
        var stackResultDimensionDefine = {
            name: stackedOverDimension,
            // This dimension contains stack base (generally, 0), so do not set it as
            // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
            coordDim: stackedOverDimension,
            coordDimIndex: stackedDimCoordIndex_1 + 1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length + 1
        };
        if (schema) {
            if (store) {
                stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
                stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
            }
            schema.appendCalculationDimension(stackedOverDimensionDefine);
            schema.appendCalculationDimension(stackResultDimensionDefine);
        } else {
            dimensionDefineList.push(stackedOverDimensionDefine);
            dimensionDefineList.push(stackResultDimensionDefine);
        }
    }
    return {
        stackedDimension: stackedDimInfo && stackedDimInfo.name,
        stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
        isStackedByIndex: byIndex,
        stackedOverDimension: stackedOverDimension,
        stackResultDimension: stackResultDimension
    };
}
function $efdd976e4917927c$var$isLegacyDimensionsInput(dimensionsInput) {
    return !(0, $85b723b311a86ffc$export$fafbc856132a3a0e)(dimensionsInput.schema);
}
function $efdd976e4917927c$export$1dedc39359ae35c(data, stackedDim) {
    // Each single series only maps to one pair of axis. So we do not need to
    // check stackByDim, whatever stacked by a dimension or stacked by index.
    return !!stackedDim && stackedDim === data.getCalculationInfo("stackedDimension");
}
function $efdd976e4917927c$export$909db2be4938fbdf(data, targetDim) {
    return $efdd976e4917927c$export$1dedc39359ae35c(data, targetDim) ? data.getCalculationInfo("stackResultDimension") : targetDim;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/* global Float32Array */ var $5cd50afac93e9148$var$supportFloat32Array = typeof Float32Array !== "undefined";
var $5cd50afac93e9148$var$Float32ArrayCtor = !$5cd50afac93e9148$var$supportFloat32Array ? Array : Float32Array;
function $5cd50afac93e9148$export$21d2298f3f56bbaf(arg) {
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(arg)) // Return self directly if don't support TypedArray.
    return $5cd50afac93e9148$var$supportFloat32Array ? new Float32Array(arg) : arg;
    // Else is number
    return new $5cd50afac93e9148$var$Float32ArrayCtor(arg);
}


var $361c48dd900de28f$var$STACK_PREFIX = "__ec_stack_";
function $361c48dd900de28f$var$getSeriesStackId(seriesModel) {
    return seriesModel.get("stack") || $361c48dd900de28f$var$STACK_PREFIX + seriesModel.seriesIndex;
}
function $361c48dd900de28f$var$getAxisKey(axis) {
    return axis.dim + axis.index;
}
function $361c48dd900de28f$export$658df087977b9e84(opt) {
    var params = [];
    var baseAxis = opt.axis;
    var axisKey = "axis0";
    if (baseAxis.type !== "category") return;
    var bandWidth = baseAxis.getBandWidth();
    for(var i = 0; i < opt.count || 0; i++)params.push((0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        bandWidth: bandWidth,
        axisKey: axisKey,
        stackId: $361c48dd900de28f$var$STACK_PREFIX + i
    }, opt));
    var widthAndOffsets = $361c48dd900de28f$var$doCalBarWidthAndOffset(params);
    var result = [];
    for(var i = 0; i < opt.count; i++){
        var item = widthAndOffsets[axisKey][$361c48dd900de28f$var$STACK_PREFIX + i];
        item.offsetCenter = item.offset + item.width / 2;
        result.push(item);
    }
    return result;
}
function $361c48dd900de28f$export$efbd0c3f5ab0d5e4(seriesType, ecModel) {
    var seriesModels = [];
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        // Check series coordinate, do layout for cartesian2d only
        if ($361c48dd900de28f$var$isOnCartesian(seriesModel)) seriesModels.push(seriesModel);
    });
    return seriesModels;
}
/**
 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
 * values.
 * This works for time axes, value axes, and log axes.
 * For a single time axis, return value is in the form like
 * {'x_0': [1000000]}.
 * The value of 1000000 is in milliseconds.
 */ function $361c48dd900de28f$var$getValueAxesMinGaps(barSeries) {
    /**
   * Map from axis.index to values.
   * For a single time axis, axisValues is in the form like
   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
   * Items in axisValues[x], e.g. 1495555200000, are time values of all
   * series.
   */ var axisValues = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        if (baseAxis.type !== "time" && baseAxis.type !== "value") return;
        var data = seriesModel.getData();
        var key = baseAxis.dim + "_" + baseAxis.index;
        var dimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
        var store = data.getStore();
        for(var i = 0, cnt = store.count(); i < cnt; ++i){
            var value = store.get(dimIdx, i);
            if (!axisValues[key]) // No previous data for the axis
            axisValues[key] = [
                value
            ];
            else // No value in previous series
            axisValues[key].push(value);
        // Ignore duplicated time values in the same axis
        }
    });
    var axisMinGaps = {};
    for(var key in axisValues)if (axisValues.hasOwnProperty(key)) {
        var valuesInAxis = axisValues[key];
        if (valuesInAxis) {
            // Sort axis values into ascending order to calculate gaps
            valuesInAxis.sort(function(a, b) {
                return a - b;
            });
            var min = null;
            for(var j = 1; j < valuesInAxis.length; ++j){
                var delta = valuesInAxis[j] - valuesInAxis[j - 1];
                if (delta > 0) // Ignore 0 delta because they are of the same axis value
                min = min === null ? delta : Math.min(min, delta);
            }
            // Set to null if only have one data
            axisMinGaps[key] = min;
        }
    }
    return axisMinGaps;
}
function $361c48dd900de28f$export$20769dafc84e0299(barSeries) {
    var axisMinGaps = $361c48dd900de28f$var$getValueAxesMinGaps(barSeries);
    var seriesInfoList = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var axisExtent = baseAxis.getExtent();
        var bandWidth;
        if (baseAxis.type === "category") bandWidth = baseAxis.getBandWidth();
        else if (baseAxis.type === "value" || baseAxis.type === "time") {
            var key = baseAxis.dim + "_" + baseAxis.index;
            var minGap = axisMinGaps[key];
            var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
            var scale = baseAxis.scale.getExtent();
            var scaleSpan = Math.abs(scale[1] - scale[0]);
            bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
        } else {
            var data = seriesModel.getData();
            bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
        }
        var barWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("barWidth"), bandWidth);
        var barMaxWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("barMaxWidth"), bandWidth);
        var barMinWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(// barMinWidth by default is 0.5 / 1 in cartesian. Because in value axis,
        // the auto-calculated bar width might be less than 0.5 / 1.
        seriesModel.get("barMinWidth") || ($361c48dd900de28f$var$isInLargeMode(seriesModel) ? 0.5 : 1), bandWidth);
        var barGap = seriesModel.get("barGap");
        var barCategoryGap = seriesModel.get("barCategoryGap");
        seriesInfoList.push({
            bandWidth: bandWidth,
            barWidth: barWidth,
            barMaxWidth: barMaxWidth,
            barMinWidth: barMinWidth,
            barGap: barGap,
            barCategoryGap: barCategoryGap,
            axisKey: $361c48dd900de28f$var$getAxisKey(baseAxis),
            stackId: $361c48dd900de28f$var$getSeriesStackId(seriesModel)
        });
    });
    return $361c48dd900de28f$var$doCalBarWidthAndOffset(seriesInfoList);
}
function $361c48dd900de28f$var$doCalBarWidthAndOffset(seriesInfoList) {
    // Columns info on each category axis. Key is cartesian name
    var columnsMap = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(seriesInfoList, function(seriesInfo, idx) {
        var axisKey = seriesInfo.axisKey;
        var bandWidth = seriesInfo.bandWidth;
        var columnsOnAxis = columnsMap[axisKey] || {
            bandWidth: bandWidth,
            remainedWidth: bandWidth,
            autoWidthCount: 0,
            categoryGap: null,
            gap: "20%",
            stacks: {}
        };
        var stacks = columnsOnAxis.stacks;
        columnsMap[axisKey] = columnsOnAxis;
        var stackId = seriesInfo.stackId;
        if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
        stacks[stackId] = stacks[stackId] || {
            width: 0,
            maxWidth: 0
        };
        // Caution: In a single coordinate system, these barGrid attributes
        // will be shared by series. Consider that they have default values,
        // only the attributes set on the last series will work.
        // Do not change this fact unless there will be a break change.
        var barWidth = seriesInfo.barWidth;
        if (barWidth && !stacks[stackId].width) {
            // See #6312, do not restrict width.
            stacks[stackId].width = barWidth;
            barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
            columnsOnAxis.remainedWidth -= barWidth;
        }
        var barMaxWidth = seriesInfo.barMaxWidth;
        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
        var barMinWidth = seriesInfo.barMinWidth;
        barMinWidth && (stacks[stackId].minWidth = barMinWidth);
        var barGap = seriesInfo.barGap;
        barGap != null && (columnsOnAxis.gap = barGap);
        var barCategoryGap = seriesInfo.barCategoryGap;
        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
    });
    var result = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(columnsMap, function(columnsOnAxis, coordSysName) {
        result[coordSysName] = {};
        var stacks = columnsOnAxis.stacks;
        var bandWidth = columnsOnAxis.bandWidth;
        var categoryGapPercent = columnsOnAxis.categoryGap;
        if (categoryGapPercent == null) {
            var columnCount = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(stacks).length;
            // More columns in one group
            // the spaces between group is smaller. Or the column will be too thin.
            categoryGapPercent = Math.max(35 - columnCount * 4, 15) + "%";
        }
        var categoryGap = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(categoryGapPercent, bandWidth);
        var barGapPercent = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(columnsOnAxis.gap, 1);
        var remainedWidth = columnsOnAxis.remainedWidth;
        var autoWidthCount = columnsOnAxis.autoWidthCount;
        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        // Find if any auto calculated bar exceeded maxBarWidth
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stacks, function(column) {
            var maxWidth = column.maxWidth;
            var minWidth = column.minWidth;
            if (!column.width) {
                var finalWidth = autoWidth;
                if (maxWidth && maxWidth < finalWidth) finalWidth = Math.min(maxWidth, remainedWidth);
                // `minWidth` has higher priority. `minWidth` decide that whether the
                // bar is able to be visible. So `minWidth` should not be restricted
                // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
                // the extreme cases for `value` axis, bars are allowed to overlap
                // with each other if `minWidth` specified.
                if (minWidth && minWidth > finalWidth) finalWidth = minWidth;
                if (finalWidth !== autoWidth) {
                    column.width = finalWidth;
                    remainedWidth -= finalWidth + barGapPercent * finalWidth;
                    autoWidthCount--;
                }
            } else {
                // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
                // CSS does. Because barWidth can be a percent value, where
                // `barMaxWidth` can be used to restrict the final width.
                var finalWidth = column.width;
                if (maxWidth) finalWidth = Math.min(finalWidth, maxWidth);
                // `minWidth` has higher priority, as described above
                if (minWidth) finalWidth = Math.max(finalWidth, minWidth);
                column.width = finalWidth;
                remainedWidth -= finalWidth + barGapPercent * finalWidth;
                autoWidthCount--;
            }
        });
        // Recalculate width again
        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        var widthSum = 0;
        var lastColumn;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stacks, function(column, idx) {
            if (!column.width) column.width = autoWidth;
            lastColumn = column;
            widthSum += column.width * (1 + barGapPercent);
        });
        if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
        var offset = -widthSum / 2;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(stacks, function(column, stackId) {
            result[coordSysName][stackId] = result[coordSysName][stackId] || {
                bandWidth: bandWidth,
                offset: offset,
                width: column.width
            };
            offset += column.width * (1 + barGapPercent);
        });
    });
    return result;
}
function $361c48dd900de28f$export$35920bb6556da1c2(barWidthAndOffset, axis, seriesModel) {
    if (barWidthAndOffset && axis) {
        var result = barWidthAndOffset[$361c48dd900de28f$var$getAxisKey(axis)];
        if (result != null && seriesModel != null) return result[$361c48dd900de28f$var$getSeriesStackId(seriesModel)];
        return result;
    }
}
function $361c48dd900de28f$export$b3219800bda33a1f(seriesType, ecModel) {
    var seriesModels = $361c48dd900de28f$export$efbd0c3f5ab0d5e4(seriesType, ecModel);
    var barWidthAndOffset = $361c48dd900de28f$export$20769dafc84e0299(seriesModels);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(seriesModels, function(seriesModel) {
        var data = seriesModel.getData();
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var stackId = $361c48dd900de28f$var$getSeriesStackId(seriesModel);
        var columnLayoutInfo = barWidthAndOffset[$361c48dd900de28f$var$getAxisKey(baseAxis)][stackId];
        var columnOffset = columnLayoutInfo.offset;
        var columnWidth = columnLayoutInfo.width;
        data.setLayout({
            bandWidth: columnLayoutInfo.bandWidth,
            offset: columnOffset,
            size: columnWidth
        });
    });
}
function $361c48dd900de28f$export$16e8685758531cb6(seriesType) {
    return {
        seriesType: seriesType,
        plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
        reset: function(seriesModel) {
            if (!$361c48dd900de28f$var$isOnCartesian(seriesModel)) return;
            var data = seriesModel.getData();
            var cartesian = seriesModel.coordinateSystem;
            var baseAxis = cartesian.getBaseAxis();
            var valueAxis = cartesian.getOtherAxis(baseAxis);
            var valueDimIdx = data.getDimensionIndex(data.mapDimension(valueAxis.dim));
            var baseDimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
            var drawBackground = seriesModel.get("showBackground", true);
            var valueDim = data.mapDimension(valueAxis.dim);
            var stackResultDim = data.getCalculationInfo("stackResultDimension");
            var stacked = (0, $efdd976e4917927c$export$1dedc39359ae35c)(data, valueDim) && !!data.getCalculationInfo("stackedOnSeries");
            var isValueAxisH = valueAxis.isHorizontal();
            var valueAxisStart = $361c48dd900de28f$var$getValueAxisStart(baseAxis, valueAxis);
            var isLarge = $361c48dd900de28f$var$isInLargeMode(seriesModel);
            var barMinHeight = seriesModel.get("barMinHeight") || 0;
            var stackedDimIdx = stackResultDim && data.getDimensionIndex(stackResultDim);
            // Layout info.
            var columnWidth = data.getLayout("size");
            var columnOffset = data.getLayout("offset");
            return {
                progress: function(params, data) {
                    var count = params.count;
                    var largePoints = isLarge && (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(count * 3);
                    var largeBackgroundPoints = isLarge && drawBackground && (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(count * 3);
                    var largeDataIndices = isLarge && (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(count);
                    var coordLayout = cartesian.master.getRect();
                    var bgSize = isValueAxisH ? coordLayout.width : coordLayout.height;
                    var dataIndex;
                    var store = data.getStore();
                    var idxOffset = 0;
                    while((dataIndex = params.next()) != null){
                        var value = store.get(stacked ? stackedDimIdx : valueDimIdx, dataIndex);
                        var baseValue = store.get(baseDimIdx, dataIndex);
                        var baseCoord = valueAxisStart;
                        var startValue = void 0;
                        // Because of the barMinHeight, we can not use the value in
                        // stackResultDimension directly.
                        if (stacked) startValue = +value - store.get(valueDimIdx, dataIndex);
                        var x = void 0;
                        var y = void 0;
                        var width = void 0;
                        var height = void 0;
                        if (isValueAxisH) {
                            var coord = cartesian.dataToPoint([
                                value,
                                baseValue
                            ]);
                            if (stacked) {
                                var startCoord = cartesian.dataToPoint([
                                    startValue,
                                    baseValue
                                ]);
                                baseCoord = startCoord[0];
                            }
                            x = baseCoord;
                            y = coord[1] + columnOffset;
                            width = coord[0] - baseCoord;
                            height = columnWidth;
                            if (Math.abs(width) < barMinHeight) width = (width < 0 ? -1 : 1) * barMinHeight;
                        } else {
                            var coord = cartesian.dataToPoint([
                                baseValue,
                                value
                            ]);
                            if (stacked) {
                                var startCoord = cartesian.dataToPoint([
                                    baseValue,
                                    startValue
                                ]);
                                baseCoord = startCoord[1];
                            }
                            x = coord[0] + columnOffset;
                            y = baseCoord;
                            width = columnWidth;
                            height = coord[1] - baseCoord;
                            if (Math.abs(height) < barMinHeight) // Include zero to has a positive bar
                            height = (height <= 0 ? -1 : 1) * barMinHeight;
                        }
                        if (!isLarge) data.setItemLayout(dataIndex, {
                            x: x,
                            y: y,
                            width: width,
                            height: height
                        });
                        else {
                            largePoints[idxOffset] = x;
                            largePoints[idxOffset + 1] = y;
                            largePoints[idxOffset + 2] = isValueAxisH ? width : height;
                            if (largeBackgroundPoints) {
                                largeBackgroundPoints[idxOffset] = isValueAxisH ? coordLayout.x : x;
                                largeBackgroundPoints[idxOffset + 1] = isValueAxisH ? y : coordLayout.y;
                                largeBackgroundPoints[idxOffset + 2] = bgSize;
                            }
                            largeDataIndices[dataIndex] = dataIndex;
                        }
                        idxOffset += 3;
                    }
                    if (isLarge) data.setLayout({
                        largePoints: largePoints,
                        largeDataIndices: largeDataIndices,
                        largeBackgroundPoints: largeBackgroundPoints,
                        valueAxisHorizontal: isValueAxisH
                    });
                }
            };
        }
    };
}
function $361c48dd900de28f$var$isOnCartesian(seriesModel) {
    return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === "cartesian2d";
}
function $361c48dd900de28f$var$isInLargeMode(seriesModel) {
    return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
}
// See cases in `test/bar-start.html` and `#7412`, `#8747`.
function $361c48dd900de28f$var$getValueAxisStart(baseAxis, valueAxis) {
    return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === "log" ? 1 : 0));
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $3a37e5b80322a871$var$samplers = {
    average: function(frame) {
        var sum = 0;
        var count = 0;
        for(var i = 0; i < frame.length; i++)if (!isNaN(frame[i])) {
            sum += frame[i];
            count++;
        }
        // Return NaN if count is 0
        return count === 0 ? NaN : sum / count;
    },
    sum: function(frame) {
        var sum = 0;
        for(var i = 0; i < frame.length; i++)// Ignore NaN
        sum += frame[i] || 0;
        return sum;
    },
    max: function(frame) {
        var max = -Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] > max && (max = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(max) ? max : NaN;
    },
    min: function(frame) {
        var min = Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] < min && (min = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(min) ? min : NaN;
    },
    minmax: function(frame) {
        var turningPointAbsoluteValue = -Infinity;
        var turningPointOriginalValue = -Infinity;
        for(var i = 0; i < frame.length; i++){
            var originalValue = frame[i];
            var absoluteValue = Math.abs(originalValue);
            if (absoluteValue > turningPointAbsoluteValue) {
                turningPointAbsoluteValue = absoluteValue;
                turningPointOriginalValue = originalValue;
            }
        }
        return isFinite(turningPointOriginalValue) ? turningPointOriginalValue : NaN;
    },
    // TODO
    // Median
    nearest: function(frame) {
        return frame[0];
    }
};
var $3a37e5b80322a871$var$indexSampler = function(frame) {
    return Math.round(frame.length / 2);
};
function $3a37e5b80322a871$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        // FIXME:TS never used, so comment it
        // modifyOutputEnd: true,
        reset: function(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            var sampling = seriesModel.get("sampling");
            var coordSys = seriesModel.coordinateSystem;
            var count = data.count();
            // Only cartesian2d support down sampling. Disable it when there is few data.
            if (count > 10 && coordSys.type === "cartesian2d" && sampling) {
                var baseAxis = coordSys.getBaseAxis();
                var valueAxis = coordSys.getOtherAxis(baseAxis);
                var extent = baseAxis.getExtent();
                var dpr = api.getDevicePixelRatio();
                // Coordinste system has been resized
                var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
                var rate = Math.round(count / size);
                if (isFinite(rate) && rate > 1) {
                    if (sampling === "lttb") seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    var sampler = void 0;
                    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(sampling)) sampler = $3a37e5b80322a871$var$samplers[sampling];
                    else if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(sampling)) sampler = sampling;
                    if (sampler) // Only support sample the first dim mapped from value axis.
                    seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, $3a37e5b80322a871$var$indexSampler));
                }
            }
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Int32Array */ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $306d1c87baff8a10$var$dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
    return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
}
function $306d1c87baff8a10$var$defaultKeyGetter(item) {
    return item;
}
var $306d1c87baff8a10$var$DataDiffer = /** @class */ function() {
    /**
   * @param context Can be visited by this.context in callback.
   */ function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, // By default: 'oneToOne'.
    diffMode) {
        this._old = oldArr;
        this._new = newArr;
        this._oldKeyGetter = oldKeyGetter || $306d1c87baff8a10$var$defaultKeyGetter;
        this._newKeyGetter = newKeyGetter || $306d1c87baff8a10$var$defaultKeyGetter;
        // Visible in callback via `this.context`;
        this.context = context;
        this._diffModeMultiple = diffMode === "multiple";
    }
    /**
   * Callback function when add a data
   */ DataDiffer.prototype.add = function(func) {
        this._add = func;
        return this;
    };
    /**
   * Callback function when update a data
   */ DataDiffer.prototype.update = function(func) {
        this._update = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToOne = function(func) {
        this._updateManyToOne = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateOneToMany = function(func) {
        this._updateOneToMany = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToMany = function(func) {
        this._updateManyToMany = func;
        return this;
    };
    /**
   * Callback function when remove a data
   */ DataDiffer.prototype.remove = function(func) {
        this._remove = func;
        return this;
    };
    DataDiffer.prototype.execute = function() {
        this[this._diffModeMultiple ? "_executeMultiple" : "_executeOneToOne"]();
    };
    DataDiffer.prototype._executeOneToOne = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var newDataIndexMap = {};
        var oldDataKeyArr = new Array(oldArr.length);
        var newDataKeyArr = new Array(newArr.length);
        this._initIndexMap(oldArr, null, oldDataKeyArr, "_oldKeyGetter");
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, "_newKeyGetter");
        for(var i = 0; i < oldArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var newIdxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(newIdxMapVal);
            // idx can never be empty array here. see 'set null' logic below.
            if (newIdxMapValLen > 1) {
                // Consider there is duplicate key (for example, use dataItem.name as key).
                // We should make sure every item in newArr and oldArr can be visited.
                var newIdx = newIdxMapVal.shift();
                if (newIdxMapVal.length === 1) newDataIndexMap[oldKey] = newIdxMapVal[0];
                this._update && this._update(newIdx, i);
            } else if (newIdxMapValLen === 1) {
                newDataIndexMap[oldKey] = null;
                this._update && this._update(newIdxMapVal, i);
            } else this._remove && this._remove(i);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    /**
   * For example, consider the case:
   * oldData: [o0, o1, o2, o3, o4, o5, o6, o7],
   * newData: [n0, n1, n2, n3, n4, n5, n6, n7, n8],
   * Where:
   *     o0, o1, n0 has key 'a' (many to one)
   *     o5, n4, n5, n6 has key 'b' (one to many)
   *     o2, n1 has key 'c' (one to one)
   *     n2, n3 has key 'd' (add)
   *     o3, o4 has key 'e' (remove)
   *     o6, o7, n7, n8 has key 'f' (many to many, treated as add and remove)
   * Then:
   *     (The order of the following directives are not ensured.)
   *     this._updateManyToOne(n0, [o0, o1]);
   *     this._updateOneToMany([n4, n5, n6], o5);
   *     this._update(n1, o2);
   *     this._remove(o3);
   *     this._remove(o4);
   *     this._remove(o6);
   *     this._remove(o7);
   *     this._add(n2);
   *     this._add(n3);
   *     this._add(n7);
   *     this._add(n8);
   */ DataDiffer.prototype._executeMultiple = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var oldDataIndexMap = {};
        var newDataIndexMap = {};
        var oldDataKeyArr = [];
        var newDataKeyArr = [];
        this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, "_oldKeyGetter");
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, "_newKeyGetter");
        for(var i = 0; i < oldDataKeyArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var oldIdxMapVal = oldDataIndexMap[oldKey];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var oldIdxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(oldIdxMapVal);
            var newIdxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(newIdxMapVal);
            if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
                this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
                this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
                this._update && this._update(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
                this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1) for(var i_1 = 0; i_1 < oldIdxMapValLen; i_1++)this._remove && this._remove(oldIdxMapVal[i_1]);
            else this._remove && this._remove(oldIdxMapVal);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    DataDiffer.prototype._performRestAdd = function(newDataKeyArr, newDataIndexMap) {
        for(var i = 0; i < newDataKeyArr.length; i++){
            var newKey = newDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[newKey];
            var idxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(newIdxMapVal);
            if (idxMapValLen > 1) for(var j = 0; j < idxMapValLen; j++)this._add && this._add(newIdxMapVal[j]);
            else if (idxMapValLen === 1) this._add && this._add(newIdxMapVal);
            // Support both `newDataKeyArr` are duplication removed or not removed.
            newDataIndexMap[newKey] = null;
        }
    };
    DataDiffer.prototype._initIndexMap = function(arr, // Can be null.
    map, // In 'byKey', the output `keyArr` is duplication removed.
    // In 'byIndex', the output `keyArr` is not duplication removed and
    //     its indices are accurately corresponding to `arr`.
    keyArr, keyGetterName) {
        var cbModeMultiple = this._diffModeMultiple;
        for(var i = 0; i < arr.length; i++){
            // Add prefix to avoid conflict with Object.prototype.
            var key = "_ec_" + this[keyGetterName](arr[i], i);
            if (!cbModeMultiple) keyArr[i] = key;
            if (!map) continue;
            var idxMapVal = map[key];
            var idxMapValLen = $306d1c87baff8a10$var$dataIndexMapValueLength(idxMapVal);
            if (idxMapValLen === 0) {
                // Simple optimize: in most cases, one index has one key,
                // do not need array.
                map[key] = i;
                if (cbModeMultiple) keyArr.push(key);
            } else if (idxMapValLen === 1) map[key] = [
                idxMapVal,
                i
            ];
            else idxMapVal.push(i);
        }
    };
    return DataDiffer;
}();
var $306d1c87baff8a10$export$2e2bcd8739ae039 = $306d1c87baff8a10$var$DataDiffer;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $18085de91ae59d03$var$DimensionUserOuput = /** @class */ function() {
    function DimensionUserOuput(encode, dimRequest) {
        this._encode = encode;
        this._schema = dimRequest;
    }
    DimensionUserOuput.prototype.get = function() {
        return {
            // Do not generate full dimension name until fist used.
            fullDimensions: this._getFullDimensionNames(),
            encode: this._encode
        };
    };
    /**
   * Get all data store dimension names.
   * Theoretically a series data store is defined both by series and used dataset (if any).
   * If some dimensions are omitted for performance reason in `this.dimensions`,
   * the dimension name may not be auto-generated if user does not specify a dimension name.
   * In this case, the dimension name is `null`/`undefined`.
   */ DimensionUserOuput.prototype._getFullDimensionNames = function() {
        if (!this._cachedDimNames) this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
        return this._cachedDimNames;
    };
    return DimensionUserOuput;
}();
function $18085de91ae59d03$export$505a22c3734846f1(data, schema) {
    var summary = {};
    var encode = summary.encode = {};
    var notExtraCoordDimMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var defaultedLabel = [];
    var defaultedTooltip = [];
    var userOutputEncode = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(data.dimensions, function(dimName) {
        var dimItem = data.getDimensionInfo(dimName);
        var coordDim = dimItem.coordDim;
        if (coordDim) {
            var coordDimIndex = dimItem.coordDimIndex;
            $18085de91ae59d03$var$getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
            if (!dimItem.isExtraCoord) {
                notExtraCoordDimMap.set(coordDim, 1);
                // Use the last coord dim (and label friendly) as default label,
                // because when dataset is used, it is hard to guess which dimension
                // can be value dimension. If both show x, y on label is not look good,
                // and conventionally y axis is focused more.
                if ($18085de91ae59d03$var$mayLabelDimType(dimItem.type)) defaultedLabel[0] = dimName;
                // User output encode do not contain generated coords.
                // And it only has index. User can use index to retrieve value from the raw item array.
                $18085de91ae59d03$var$getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
            }
            if (dimItem.defaultTooltip) defaultedTooltip.push(dimName);
        }
        (0, $cab29724515ce2b8$export$cd51b5ca77f6f0e4).each(function(v, otherDim) {
            var encodeArr = $18085de91ae59d03$var$getOrCreateEncodeArr(encode, otherDim);
            var dimIndex = dimItem.otherDims[otherDim];
            if (dimIndex != null && dimIndex !== false) encodeArr[dimIndex] = dimItem.name;
        });
    });
    var dataDimsOnCoord = [];
    var encodeFirstDimNotExtra = {};
    notExtraCoordDimMap.each(function(v, coordDim) {
        var dimArr = encode[coordDim];
        encodeFirstDimNotExtra[coordDim] = dimArr[0];
        // Not necessary to remove duplicate, because a data
        // dim canot on more than one coordDim.
        dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
    });
    summary.dataDimsOnCoord = dataDimsOnCoord;
    summary.dataDimIndicesOnCoord = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dataDimsOnCoord, function(dimName) {
        return data.getDimensionInfo(dimName).storeDimIndex;
    });
    summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
    var encodeLabel = encode.label;
    // FIXME `encode.label` is not recommended, because formatter cannot be set
    // in this way. Use label.formatter instead. Maybe remove this approach someday.
    if (encodeLabel && encodeLabel.length) defaultedLabel = encodeLabel.slice();
    var encodeTooltip = encode.tooltip;
    if (encodeTooltip && encodeTooltip.length) defaultedTooltip = encodeTooltip.slice();
    else if (!defaultedTooltip.length) defaultedTooltip = defaultedLabel.slice();
    encode.defaultedLabel = defaultedLabel;
    encode.defaultedTooltip = defaultedTooltip;
    summary.userOutput = new $18085de91ae59d03$var$DimensionUserOuput(userOutputEncode, schema);
    return summary;
}
function $18085de91ae59d03$var$getOrCreateEncodeArr(encode, dim) {
    if (!encode.hasOwnProperty(dim)) encode[dim] = [];
    return encode[dim];
}
function $18085de91ae59d03$export$af1622903e71278e(axisType) {
    return axisType === "category" ? "ordinal" : axisType === "time" ? "time" : "float";
}
function $18085de91ae59d03$var$mayLabelDimType(dimType) {
    // In most cases, ordinal and time do not suitable for label.
    // Ordinal info can be displayed on axis. Time is too long.
    return !(dimType === "ordinal" || dimType === "time");
} // function findTheLastDimMayLabel(data) {
 //     // Get last value dim
 //     let dimensions = data.dimensions.slice();
 //     let valueType;
 //     let valueDim;
 //     while (dimensions.length && (
 //         valueDim = dimensions.pop(),
 //         valueType = data.getDimensionInfo(valueDim).type,
 //         valueType === 'ordinal' || valueType === 'time'
 //     )) {} // jshint ignore:line
 //     return valueDim;
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $5e233867ea3713e7$var$SeriesDimensionDefine = /** @class */ function() {
    /**
   * @param opt All of the fields will be shallow copied.
   */ function SeriesDimensionDefine(opt) {
        /**
     * The format of `otherDims` is:
     * ```js
     * {
     *     tooltip?: number
     *     label?: number
     *     itemName?: number
     *     seriesName?: number
     * }
     * ```
     *
     * A `series.encode` can specified these fields:
     * ```js
     * encode: {
     *     // "3, 1, 5" is the index of data dimension.
     *     tooltip: [3, 1, 5],
     *     label: [0, 3],
     *     ...
     * }
     * ```
     * `otherDims` is the parse result of the `series.encode` above, like:
     * ```js
     * // Suppose the index of this data dimension is `3`.
     * this.otherDims = {
     *     // `3` is at the index `0` of the `encode.tooltip`
     *     tooltip: 0,
     *     // `3` is at the index `1` of the `encode.label`
     *     label: 1
     * };
     * ```
     *
     * This prop should never be `null`/`undefined` after initialized.
     */ this.otherDims = {};
        if (opt != null) $7a1bd9c2710fea0d$export$8b58be045bf06082(this, opt);
    }
    return SeriesDimensionDefine;
}();
var $5e233867ea3713e7$export$2e2bcd8739ae039 = $5e233867ea3713e7$var$SeriesDimensionDefine;








var $0ab0556b819346fd$var$isObject = $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a;
var $0ab0556b819346fd$var$map = $7a1bd9c2710fea0d$export$871de8747c9eaa88;
var $0ab0556b819346fd$var$CtorInt32Array = typeof Int32Array === "undefined" ? Array : Int32Array;
// Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird update animation.
var $0ab0556b819346fd$var$ID_PREFIX = "e\0\0";
var $0ab0556b819346fd$var$INDEX_NOT_FOUND = -1;
// type SeriesDimensionIndex = DimensionIndex;
var $0ab0556b819346fd$var$TRANSFERABLE_PROPERTIES = [
    "hasItemOption",
    "_nameList",
    "_idList",
    "_invertedIndicesMap",
    "_dimSummary",
    "userOutput",
    "_rawData",
    "_dimValueGetter",
    "_nameDimIdx",
    "_idDimIdx",
    "_nameRepeatCount"
];
var $0ab0556b819346fd$var$CLONE_PROPERTIES = [
    "_approximateExtent"
];
// -----------------------------
// Internal method declarations:
// -----------------------------
var $0ab0556b819346fd$var$prepareInvertedIndex;
var $0ab0556b819346fd$var$getId;
var $0ab0556b819346fd$var$getIdNameFromStore;
var $0ab0556b819346fd$var$normalizeDimensions;
var $0ab0556b819346fd$var$transferProperties;
var $0ab0556b819346fd$var$cloneListForMapAndSample;
var $0ab0556b819346fd$var$makeIdFromName;
var $0ab0556b819346fd$var$SeriesData = /** @class */ function() {
    /**
   * @param dimensionsInput.dimensions
   *        For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
   *        Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
   */ function SeriesData(dimensionsInput, hostModel) {
        this.type = "list";
        this._dimOmitted = false;
        this._nameList = [];
        this._idList = [];
        // Models of data option is stored sparse for optimizing memory cost
        // Never used yet (not used yet).
        // private _optionModels: Model[] = [];
        // Global visual properties after visual coding
        this._visual = {};
        // Global layout properties.
        this._layout = {};
        // Item visual properties after visual coding
        this._itemVisuals = [];
        // Item layout properties after layout
        this._itemLayouts = [];
        // Graphic elements
        this._graphicEls = [];
        // key: dim, value: extent
        this._approximateExtent = {};
        this._calculationInfo = {};
        // Having detected that there is data item is non primitive type
        // (in type `OptionDataItemObject`).
        // Like `data: [ { value: xx, itemStyle: {...} }, ...]`
        // At present it only happen in `SOURCE_FORMAT_ORIGINAL`.
        this.hasItemOption = false;
        // Methods that create a new list based on this list should be listed here.
        // Notice that those method should `RETURN` the new list.
        this.TRANSFERABLE_METHODS = [
            "cloneShallow",
            "downSample",
            "lttbDownSample",
            "map"
        ];
        // Methods that change indices of this list should be listed here.
        this.CHANGABLE_METHODS = [
            "filterSelf",
            "selectRange"
        ];
        this.DOWNSAMPLE_METHODS = [
            "downSample",
            "lttbDownSample"
        ];
        var dimensions;
        var assignStoreDimIdx = false;
        if ((0, $85b723b311a86ffc$export$fafbc856132a3a0e)(dimensionsInput)) {
            dimensions = dimensionsInput.dimensions;
            this._dimOmitted = dimensionsInput.isDimensionOmitted();
            this._schema = dimensionsInput;
        } else {
            assignStoreDimIdx = true;
            dimensions = dimensionsInput;
        }
        dimensions = dimensions || [
            "x",
            "y"
        ];
        var dimensionInfos = {};
        var dimensionNames = [];
        var invertedIndicesMap = {};
        var needsHasOwn = false;
        var emptyObj = {};
        for(var i = 0; i < dimensions.length; i++){
            // Use the original dimensions[i], where other flag props may exists.
            var dimInfoInput = dimensions[i];
            var dimensionInfo = $7a1bd9c2710fea0d$export$844ec244b1367d54(dimInfoInput) ? new (0, $5e233867ea3713e7$export$2e2bcd8739ae039)({
                name: dimInfoInput
            }) : !(dimInfoInput instanceof (0, $5e233867ea3713e7$export$2e2bcd8739ae039)) ? new (0, $5e233867ea3713e7$export$2e2bcd8739ae039)(dimInfoInput) : dimInfoInput;
            var dimensionName = dimensionInfo.name;
            dimensionInfo.type = dimensionInfo.type || "float";
            if (!dimensionInfo.coordDim) {
                dimensionInfo.coordDim = dimensionName;
                dimensionInfo.coordDimIndex = 0;
            }
            var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
            dimensionNames.push(dimensionName);
            dimensionInfos[dimensionName] = dimensionInfo;
            if (emptyObj[dimensionName] != null) needsHasOwn = true;
            if (dimensionInfo.createInvertedIndices) invertedIndicesMap[dimensionName] = [];
            if (otherDims.itemName === 0) this._nameDimIdx = i;
            if (otherDims.itemId === 0) this._idDimIdx = i;
            if (assignStoreDimIdx) dimensionInfo.storeDimIndex = i;
        }
        this.dimensions = dimensionNames;
        this._dimInfos = dimensionInfos;
        this._initGetDimensionInfo(needsHasOwn);
        this.hostModel = hostModel;
        this._invertedIndicesMap = invertedIndicesMap;
        if (this._dimOmitted) {
            var dimIdxToName_1 = this._dimIdxToName = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(dimensionNames, function(dimName) {
                dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
            });
        }
    }
    /**
   *
   * Get concrete dimension name by dimension name or dimension index.
   * If input a dimension name, do not validate whether the dimension name exits.
   *
   * @caution
   * @param dim Must make sure the dimension is `SeriesDimensionLoose`.
   * Because only those dimensions will have auto-generated dimension names if not
   * have a user-specified name, and other dimensions will get a return of null/undefined.
   *
   * @notice Because of this reason, should better use `getDimensionIndex` instead, for examples:
   * ```js
   * const val = data.getStore().get(data.getDimensionIndex(dim), dataIdx);
   * ```
   *
   * @return Concrete dim name.
   */ SeriesData.prototype.getDimension = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx == null) return dim;
        dimIdx = dim;
        if (!this._dimOmitted) return this.dimensions[dimIdx];
        // Retrieve from series dimension definition because it probably contains
        // generated dimension name (like 'x', 'y').
        var dimName = this._dimIdxToName.get(dimIdx);
        if (dimName != null) return dimName;
        var sourceDimDef = this._schema.getSourceDimension(dimIdx);
        if (sourceDimDef) return sourceDimDef.name;
    };
    /**
   * Get dimension index in data store. Return -1 if not found.
   * Can be used to index value from getRawValue.
   */ SeriesData.prototype.getDimensionIndex = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx != null) return dimIdx;
        if (dim == null) return -1;
        var dimInfo = this._getDimInfo(dim);
        return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
    };
    /**
   * The meanings of the input parameter `dim`:
   *
   * + If dim is a number (e.g., `1`), it means the index of the dimension.
   *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
   * + If dim is a number-like string (e.g., `"1"`):
   *     + If there is the same concrete dim name defined in `series.dimensions` or `dataset.dimensions`,
   *        it means that concrete name.
   *     + If not, it will be converted to a number, which means the index of the dimension.
   *        (why? because of the backward compatibility. We have been tolerating number-like string in
   *        dimension setting, although now it seems that it is not a good idea.)
   *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
   *     if no dimension name is defined as `"1"`.
   * + If dim is a not-number-like string, it means the concrete dim name.
   *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
   *   or customized in `dimensions` property of option like `"age"`.
   *
   * @return recognized `DimensionIndex`. Otherwise return null/undefined (means that dim is `DimensionName`).
   */ SeriesData.prototype._recognizeDimIndex = function(dim) {
        if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(dim) || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) return +dim;
    };
    SeriesData.prototype._getStoreDimIndex = function(dim) {
        var dimIdx = this.getDimensionIndex(dim);
        return dimIdx;
    };
    /**
   * Get type and calculation info of particular dimension
   * @param dim
   *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
   *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
   */ SeriesData.prototype.getDimensionInfo = function(dim) {
        // Do not clone, because there may be categories in dimInfo.
        return this._getDimInfo(this.getDimension(dim));
    };
    SeriesData.prototype._initGetDimensionInfo = function(needsHasOwn) {
        var dimensionInfos = this._dimInfos;
        this._getDimInfo = needsHasOwn ? function(dimName) {
            return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
        } : function(dimName) {
            return dimensionInfos[dimName];
        };
    };
    /**
   * concrete dimension name list on coord.
   */ SeriesData.prototype.getDimensionsOnCoord = function() {
        return this._dimSummary.dataDimsOnCoord.slice();
    };
    SeriesData.prototype.mapDimension = function(coordDim, idx) {
        var dimensionsSummary = this._dimSummary;
        if (idx == null) return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
        var dims = dimensionsSummary.encode[coordDim];
        return dims ? dims[idx] : null;
    };
    SeriesData.prototype.mapDimensionsAll = function(coordDim) {
        var dimensionsSummary = this._dimSummary;
        var dims = dimensionsSummary.encode[coordDim];
        return (dims || []).slice();
    };
    SeriesData.prototype.getStore = function() {
        return this._store;
    };
    /**
   * Initialize from data
   * @param data source or data or data store.
   * @param nameList The name of a datum is used on data diff and
   *        default label/tooltip.
   *        A name can be specified in encode.itemName,
   *        or dataItem.name (only for series option data),
   *        or provided in nameList from outside.
   */ SeriesData.prototype.initData = function(data, nameList, dimValueGetter) {
        var _this = this;
        var store;
        if (data instanceof (0, $370e5aa482d8420b$export$2e2bcd8739ae039)) store = data;
        if (!store) {
            var dimensions = this.dimensions;
            var provider = (0, $99e22f5c2aa5094b$export$22b808bc02a60488)(data) || $7a1bd9c2710fea0d$export$1e2f57719e155213(data) ? new (0, $8ffb0d67e9446edb$export$b900d7c4c3952a40)(data, dimensions.length) : data;
            store = new (0, $370e5aa482d8420b$export$2e2bcd8739ae039)();
            var dimensionInfos = $0ab0556b819346fd$var$map(dimensions, function(dimName) {
                return {
                    type: _this._dimInfos[dimName].type,
                    property: dimName
                };
            });
            store.initData(provider, dimensionInfos, dimValueGetter);
        }
        this._store = store;
        // Reset
        this._nameList = (nameList || []).slice();
        this._idList = [];
        this._nameRepeatCount = {};
        this._doInit(0, store.count());
        // Cache summary info for fast visit. See "dimensionHelper".
        // Needs to be initialized after store is prepared.
        this._dimSummary = (0, $18085de91ae59d03$export$505a22c3734846f1)(this, this._schema);
        this.userOutput = this._dimSummary.userOutput;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ SeriesData.prototype.appendData = function(data) {
        var range = this._store.appendData(data);
        this._doInit(range[0], range[1]);
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   * This method does not modify `rawData` (`dataProvider`), but only
   * add values to store.
   *
   * The final count will be increased by `Math.max(values.length, names.length)`.
   *
   * @param values That is the SourceType: 'arrayRows', like
   *        [
   *            [12, 33, 44],
   *            [NaN, 43, 1],
   *            ['-', 'asdf', 0]
   *        ]
   *        Each item is exactly corresponding to a dimension.
   */ SeriesData.prototype.appendValues = function(values, names) {
        var _a = this._store.appendValues(values, names.length), start = _a.start, end = _a.end;
        var shouldMakeIdFromName = this._shouldMakeIdFromName();
        this._updateOrdinalMeta();
        if (names) for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            this._nameList[idx] = names[sourceIdx];
            if (shouldMakeIdFromName) $0ab0556b819346fd$var$makeIdFromName(this, idx);
        }
    };
    SeriesData.prototype._updateOrdinalMeta = function() {
        var store = this._store;
        var dimensions = this.dimensions;
        for(var i = 0; i < dimensions.length; i++){
            var dimInfo = this._dimInfos[dimensions[i]];
            if (dimInfo.ordinalMeta) store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
        }
    };
    SeriesData.prototype._shouldMakeIdFromName = function() {
        var provider = this._store.getProvider();
        return this._idDimIdx == null && provider.getSource().sourceFormat !== (0, $cab29724515ce2b8$export$a918cb016a382d45) && !provider.fillStorage;
    };
    SeriesData.prototype._doInit = function(start, end) {
        if (start >= end) return;
        var store = this._store;
        var provider = store.getProvider();
        this._updateOrdinalMeta();
        var nameList = this._nameList;
        var idList = this._idList;
        var sourceFormat = provider.getSource().sourceFormat;
        var isFormatOriginal = sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6);
        // Each data item is value
        // [1, 2]
        // 2
        // Bar chart, line chart which uses category axis
        // only gives the 'y' value. 'x' value is the indices of category
        // Use a tempValue to normalize the value to be a (x, y) value
        // If dataItem is {name: ...} or {id: ...}, it has highest priority.
        // This kind of ids and names are always stored `_nameList` and `_idList`.
        if (isFormatOriginal && !provider.pure) {
            var sharedDataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                var dataItem = provider.getItem(idx, sharedDataItem);
                if (!this.hasItemOption && (0, $76d619f648247e6d$export$3e1a543f33ef6883)(dataItem)) this.hasItemOption = true;
                if (dataItem) {
                    var itemName = dataItem.name;
                    if (nameList[idx] == null && itemName != null) nameList[idx] = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(itemName, null);
                    var itemId = dataItem.id;
                    if (idList[idx] == null && itemId != null) idList[idx] = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(itemId, null);
                }
            }
        }
        if (this._shouldMakeIdFromName()) for(var idx = start; idx < end; idx++)$0ab0556b819346fd$var$makeIdFromName(this, idx);
        $0ab0556b819346fd$var$prepareInvertedIndex(this);
    };
    /**
   * PENDING: In fact currently this function is only used to short-circuit
   * the calling of `scale.unionExtentFromData` when data have been filtered by modules
   * like "dataZoom". `scale.unionExtentFromData` is used to calculate data extent for series on
   * an axis, but if a "axis related data filter module" is used, the extent of the axis have
   * been fixed and no need to calling `scale.unionExtentFromData` actually.
   * But if we add "custom data filter" in future, which is not "axis related", this method may
   * be still needed.
   *
   * Optimize for the scenario that data is filtered by a given extent.
   * Consider that if data amount is more than hundreds of thousand,
   * extent calculation will cost more than 10ms and the cache will
   * be erased because of the filtering.
   */ SeriesData.prototype.getApproximateExtent = function(dim) {
        return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    /**
   * Calculate extent on a filtered data might be time consuming.
   * Approximate extent is only used for: calculate extent of filtered data outside.
   */ SeriesData.prototype.setApproximateExtent = function(extent, dim) {
        dim = this.getDimension(dim);
        this._approximateExtent[dim] = extent.slice();
    };
    SeriesData.prototype.getCalculationInfo = function(key) {
        return this._calculationInfo[key];
    };
    SeriesData.prototype.setCalculationInfo = function(key, value) {
        $0ab0556b819346fd$var$isObject(key) ? $7a1bd9c2710fea0d$export$8b58be045bf06082(this._calculationInfo, key) : this._calculationInfo[key] = value;
    };
    /**
   * @return Never be null/undefined. `number` will be converted to string. Because:
   * In most cases, name is used in display, where returning a string is more convenient.
   * In other cases, name is used in query (see `indexOfName`), where we can keep the
   * rule that name `2` equals to name `'2'`.
   */ SeriesData.prototype.getName = function(idx) {
        var rawIndex = this.getRawIndex(idx);
        var name = this._nameList[rawIndex];
        if (name == null && this._nameDimIdx != null) name = $0ab0556b819346fd$var$getIdNameFromStore(this, this._nameDimIdx, rawIndex);
        if (name == null) name = "";
        return name;
    };
    SeriesData.prototype._getCategory = function(dimIdx, idx) {
        var ordinal = this._store.get(dimIdx, idx);
        var ordinalMeta = this._store.getOrdinalMeta(dimIdx);
        if (ordinalMeta) return ordinalMeta.categories[ordinal];
        return ordinal;
    };
    /**
   * @return Never null/undefined. `number` will be converted to string. Because:
   * In all cases having encountered at present, id is used in making diff comparison, which
   * are usually based on hash map. We can keep the rule that the internal id are always string
   * (treat `2` is the same as `'2'`) to make the related logic simple.
   */ SeriesData.prototype.getId = function(idx) {
        return $0ab0556b819346fd$var$getId(this, this.getRawIndex(idx));
    };
    SeriesData.prototype.count = function() {
        return this._store.count();
    };
    /**
   * Get value. Return NaN if idx is out of range.
   *
   * @notice Should better to use `data.getStore().get(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.get = function(dim, idx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.get(dimInfo.storeDimIndex, idx);
    };
    /**
   * @notice Should better to use `data.getStore().getByRawIndex(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.getByRawIndex = function(dim, rawIdx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
    };
    SeriesData.prototype.getIndices = function() {
        return this._store.getIndices();
    };
    SeriesData.prototype.getDataExtent = function(dim) {
        return this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getSum = function(dim) {
        return this._store.getSum(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getMedian = function(dim) {
        return this._store.getMedian(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getValues = function(dimensions, idx) {
        var _this = this;
        var store = this._store;
        return $7a1bd9c2710fea0d$export$43bee75e5e14138e(dimensions) ? store.getValues($0ab0556b819346fd$var$map(dimensions, function(dim) {
            return _this._getStoreDimIndex(dim);
        }), idx) : store.getValues(dimensions);
    };
    /**
   * If value is NaN. Including '-'
   * Only check the coord dimensions.
   */ SeriesData.prototype.hasValue = function(idx) {
        var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;
        for(var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++){
            // Ordinal type originally can be string or number.
            // But when an ordinal type is used on coord, it can
            // not be string but only number. So we can also use isNaN.
            if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) return false;
        }
        return true;
    };
    /**
   * Retrieve the index with given name
   */ SeriesData.prototype.indexOfName = function(name) {
        for(var i = 0, len = this._store.count(); i < len; i++){
            if (this.getName(i) === name) return i;
        }
        return -1;
    };
    SeriesData.prototype.getRawIndex = function(idx) {
        return this._store.getRawIndex(idx);
    };
    SeriesData.prototype.indexOfRawIndex = function(rawIndex) {
        return this._store.indexOfRawIndex(rawIndex);
    };
    /**
   * Only support the dimension which inverted index created.
   * Do not support other cases until required.
   * @param dim concrete dim
   * @param value ordinal index
   * @return rawIndex
   */ SeriesData.prototype.rawIndexOf = function(dim, value) {
        var invertedIndices = dim && this._invertedIndicesMap[dim];
        var rawIndex = invertedIndices[value];
        if (rawIndex == null || isNaN(rawIndex)) return $0ab0556b819346fd$var$INDEX_NOT_FOUND;
        return rawIndex;
    };
    /**
   * Retrieve the index of nearest value
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */ SeriesData.prototype.indicesOfNearest = function(dim, value, maxDistance) {
        return this._store.indicesOfNearest(this._getStoreDimIndex(dim), value, maxDistance);
    };
    SeriesData.prototype.each = function(dims, cb, ctx) {
        "use strict";
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $0ab0556b819346fd$var$map($0ab0556b819346fd$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store.each(dimIndices, fCtx ? $7a1bd9c2710fea0d$export$2385a24977818dd0(cb, fCtx) : cb);
    };
    SeriesData.prototype.filterSelf = function(dims, cb, ctx) {
        "use strict";
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $0ab0556b819346fd$var$map($0ab0556b819346fd$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store = this._store.filter(dimIndices, fCtx ? $7a1bd9c2710fea0d$export$2385a24977818dd0(cb, fCtx) : cb);
        return this;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ SeriesData.prototype.selectRange = function(range) {
        "use strict";
        var _this = this;
        var innerRange = {};
        var dims = $7a1bd9c2710fea0d$export$ed97f33186d4b816(range);
        var dimIndices = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(dims, function(dim) {
            var dimIdx = _this._getStoreDimIndex(dim);
            innerRange[dimIdx] = range[dim];
            dimIndices.push(dimIdx);
        });
        this._store = this._store.selectRange(innerRange);
        return this;
    };
    /* eslint-enable max-len */ SeriesData.prototype.mapArray = function(dims, cb, ctx) {
        "use strict";
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        ctx = ctx || this;
        var result = [];
        this.each(dims, function() {
            result.push(cb && cb.apply(this, arguments));
        }, ctx);
        return result;
    };
    SeriesData.prototype.map = function(dims, cb, ctx, ctxCompat) {
        "use strict";
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $0ab0556b819346fd$var$map($0ab0556b819346fd$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        var list = $0ab0556b819346fd$var$cloneListForMapAndSample(this);
        list._store = this._store.map(dimIndices, fCtx ? $7a1bd9c2710fea0d$export$2385a24977818dd0(cb, fCtx) : cb);
        return list;
    };
    SeriesData.prototype.modify = function(dims, cb, ctx, ctxCompat) {
        var _this = this;
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $0ab0556b819346fd$var$map($0ab0556b819346fd$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        // If do shallow clone here, if there are too many stacked series,
        // it still cost lots of memory, because `_store.dimensions` are not shared.
        // We should consider there probably be shallow clone happen in each series
        // in consequent filter/map.
        this._store.modify(dimIndices, fCtx ? $7a1bd9c2710fea0d$export$2385a24977818dd0(cb, fCtx) : cb);
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ SeriesData.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var list = $0ab0556b819346fd$var$cloneListForMapAndSample(this);
        list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
        return list;
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ SeriesData.prototype.lttbDownSample = function(valueDimension, rate) {
        var list = $0ab0556b819346fd$var$cloneListForMapAndSample(this);
        list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    SeriesData.prototype.getRawDataItem = function(idx) {
        return this._store.getRawDataItem(idx);
    };
    /**
   * Get model of one data item.
   */ // TODO: Type of data item
    SeriesData.prototype.getItemModel = function(idx) {
        var hostModel = this.hostModel;
        var dataItem = this.getRawDataItem(idx);
        return new (0, $6818646a97528290$export$2e2bcd8739ae039)(dataItem, hostModel, hostModel && hostModel.ecModel);
    };
    /**
   * Create a data differ
   */ SeriesData.prototype.diff = function(otherList) {
        var thisList = this;
        return new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function(idx) {
            return $0ab0556b819346fd$var$getId(otherList, idx);
        }, function(idx) {
            return $0ab0556b819346fd$var$getId(thisList, idx);
        });
    };
    /**
   * Get visual property.
   */ SeriesData.prototype.getVisual = function(key) {
        var visual = this._visual;
        return visual && visual[key];
    };
    SeriesData.prototype.setVisual = function(kvObj, val) {
        this._visual = this._visual || {};
        if ($0ab0556b819346fd$var$isObject(kvObj)) $7a1bd9c2710fea0d$export$8b58be045bf06082(this._visual, kvObj);
        else this._visual[kvObj] = val;
    };
    /**
   * Get visual property of single data item
   */ // eslint-disable-next-line
    SeriesData.prototype.getItemVisual = function(idx, key) {
        var itemVisual = this._itemVisuals[idx];
        var val = itemVisual && itemVisual[key];
        if (val == null) // Use global visual property
        return this.getVisual(key);
        return val;
    };
    /**
   * If exists visual property of single data item
   */ SeriesData.prototype.hasItemVisual = function() {
        return this._itemVisuals.length > 0;
    };
    /**
   * Make sure itemVisual property is unique
   */ // TODO: use key to save visual to reduce memory.
    SeriesData.prototype.ensureUniqueItemVisual = function(idx, key) {
        var itemVisuals = this._itemVisuals;
        var itemVisual = itemVisuals[idx];
        if (!itemVisual) itemVisual = itemVisuals[idx] = {};
        var val = itemVisual[key];
        if (val == null) {
            val = this.getVisual(key);
            // TODO Performance?
            if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(val)) val = val.slice();
            else if ($0ab0556b819346fd$var$isObject(val)) val = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, val);
            itemVisual[key] = val;
        }
        return val;
    };
    // eslint-disable-next-line
    SeriesData.prototype.setItemVisual = function(idx, key, value) {
        var itemVisual = this._itemVisuals[idx] || {};
        this._itemVisuals[idx] = itemVisual;
        if ($0ab0556b819346fd$var$isObject(key)) $7a1bd9c2710fea0d$export$8b58be045bf06082(itemVisual, key);
        else itemVisual[key] = value;
    };
    /**
   * Clear itemVisuals and list visual.
   */ SeriesData.prototype.clearAllVisual = function() {
        this._visual = {};
        this._itemVisuals = [];
    };
    SeriesData.prototype.setLayout = function(key, val) {
        $0ab0556b819346fd$var$isObject(key) ? $7a1bd9c2710fea0d$export$8b58be045bf06082(this._layout, key) : this._layout[key] = val;
    };
    /**
   * Get layout property.
   */ SeriesData.prototype.getLayout = function(key) {
        return this._layout[key];
    };
    /**
   * Get layout of single data item
   */ SeriesData.prototype.getItemLayout = function(idx) {
        return this._itemLayouts[idx];
    };
    /**
   * Set layout of single data item
   */ SeriesData.prototype.setItemLayout = function(idx, layout, merge) {
        this._itemLayouts[idx] = merge ? $7a1bd9c2710fea0d$export$8b58be045bf06082(this._itemLayouts[idx] || {}, layout) : layout;
    };
    /**
   * Clear all layout of single data item
   */ SeriesData.prototype.clearItemLayouts = function() {
        this._itemLayouts.length = 0;
    };
    /**
   * Set graphic element relative to data. It can be set as null
   */ SeriesData.prototype.setItemGraphicEl = function(idx, el) {
        var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
        (0, $b1983a2fffd47d56$export$30d6736ebb8e18d5)(seriesIndex, this.dataType, idx, el);
        this._graphicEls[idx] = el;
    };
    SeriesData.prototype.getItemGraphicEl = function(idx) {
        return this._graphicEls[idx];
    };
    SeriesData.prototype.eachItemGraphicEl = function(cb, context) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._graphicEls, function(el, idx) {
            if (el) cb && cb.call(context, el, idx);
        });
    };
    /**
   * Shallow clone a new list except visual and layout properties, and graph elements.
   * New list only change the indices.
   */ SeriesData.prototype.cloneShallow = function(list) {
        if (!list) list = new SeriesData(this._schema ? this._schema : $0ab0556b819346fd$var$map(this.dimensions, this._getDimInfo, this), this.hostModel);
        $0ab0556b819346fd$var$transferProperties(list, this);
        list._store = this._store;
        return list;
    };
    /**
   * Wrap some method to add more feature
   */ SeriesData.prototype.wrapMethod = function(methodName, injectFunction) {
        var originalMethod = this[methodName];
        if (!$7a1bd9c2710fea0d$export$f6e2535fb5126e54(originalMethod)) return;
        this.__wrappedMethods = this.__wrappedMethods || [];
        this.__wrappedMethods.push(methodName);
        this[methodName] = function() {
            var res = originalMethod.apply(this, arguments);
            return injectFunction.apply(this, [
                res
            ].concat($7a1bd9c2710fea0d$export$58adb3bec8346d0f(arguments)));
        };
    };
    // ----------------------------------------------------------
    // A work around for internal method visiting private member.
    // ----------------------------------------------------------
    SeriesData.internalField = function() {
        $0ab0556b819346fd$var$prepareInvertedIndex = function(data) {
            var invertedIndicesMap = data._invertedIndicesMap;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(invertedIndicesMap, function(invertedIndices, dim) {
                var dimInfo = data._dimInfos[dim];
                // Currently, only dimensions that has ordinalMeta can create inverted indices.
                var ordinalMeta = dimInfo.ordinalMeta;
                var store = data._store;
                if (ordinalMeta) {
                    invertedIndices = invertedIndicesMap[dim] = new $0ab0556b819346fd$var$CtorInt32Array(ordinalMeta.categories.length);
                    // The default value of TypedArray is 0. To avoid miss
                    // mapping to 0, we should set it as INDEX_NOT_FOUND.
                    for(var i = 0; i < invertedIndices.length; i++)invertedIndices[i] = $0ab0556b819346fd$var$INDEX_NOT_FOUND;
                    for(var i = 0; i < store.count(); i++)// Only support the case that all values are distinct.
                    invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
                }
            });
        };
        $0ab0556b819346fd$var$getIdNameFromStore = function(data, dimIdx, idx) {
            return (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(data._getCategory(dimIdx, idx), null);
        };
        /**
     * @see the comment of `List['getId']`.
     */ $0ab0556b819346fd$var$getId = function(data, rawIndex) {
            var id = data._idList[rawIndex];
            if (id == null && data._idDimIdx != null) id = $0ab0556b819346fd$var$getIdNameFromStore(data, data._idDimIdx, rawIndex);
            if (id == null) id = $0ab0556b819346fd$var$ID_PREFIX + rawIndex;
            return id;
        };
        $0ab0556b819346fd$var$normalizeDimensions = function(dimensions) {
            if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(dimensions)) dimensions = dimensions != null ? [
                dimensions
            ] : [];
            return dimensions;
        };
        /**
     * Data in excludeDimensions is copied, otherwise transferred.
     */ $0ab0556b819346fd$var$cloneListForMapAndSample = function(original) {
            var list = new SeriesData(original._schema ? original._schema : $0ab0556b819346fd$var$map(original.dimensions, original._getDimInfo, original), original.hostModel);
            // FIXME If needs stackedOn, value may already been stacked
            $0ab0556b819346fd$var$transferProperties(list, original);
            return list;
        };
        $0ab0556b819346fd$var$transferProperties = function(target, source) {
            $7a1bd9c2710fea0d$export$79b2f7037acddd43($0ab0556b819346fd$var$TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function(propName) {
                if (source.hasOwnProperty(propName)) target[propName] = source[propName];
            });
            target.__wrappedMethods = source.__wrappedMethods;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43($0ab0556b819346fd$var$CLONE_PROPERTIES, function(propName) {
                target[propName] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(source[propName]);
            });
            target._calculationInfo = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, source._calculationInfo);
        };
        $0ab0556b819346fd$var$makeIdFromName = function(data, idx) {
            var nameList = data._nameList;
            var idList = data._idList;
            var nameDimIdx = data._nameDimIdx;
            var idDimIdx = data._idDimIdx;
            var name = nameList[idx];
            var id = idList[idx];
            if (name == null && nameDimIdx != null) nameList[idx] = name = $0ab0556b819346fd$var$getIdNameFromStore(data, nameDimIdx, idx);
            if (id == null && idDimIdx != null) idList[idx] = id = $0ab0556b819346fd$var$getIdNameFromStore(data, idDimIdx, idx);
            if (id == null && name != null) {
                var nameRepeatCount = data._nameRepeatCount;
                var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
                id = name;
                if (nmCnt > 1) id += "__ec__" + nmCnt;
                idList[idx] = id;
            }
        };
    }();
    return SeriesData;
}();
var $0ab0556b819346fd$export$2e2bcd8739ae039 = $0ab0556b819346fd$var$SeriesData;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







function $a27631012b7b377c$export$8066c1b52b2e9504(source, opt) {
    return $a27631012b7b377c$export$2e2bcd8739ae039(source, opt).dimensions;
}
function $a27631012b7b377c$export$2e2bcd8739ae039(// TODO: TYPE completeDimensions type
source, opt) {
    if (!(0, $99e22f5c2aa5094b$export$22b808bc02a60488)(source)) source = (0, $99e22f5c2aa5094b$export$75aef3f97c0a5edf)(source);
    opt = opt || {};
    var sysDims = opt.coordDimensions || [];
    var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
    var coordDimNameMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var resultList = [];
    var dimCount = $a27631012b7b377c$var$getDimCount(source, sysDims, dimsDef, opt.dimensionsCount);
    // Try to ignore unused dimensions if sharing a high dimension datastore
    // 30 is an experience value.
    var omitUnusedDimensions = opt.canOmitUnusedDimensions && (0, $85b723b311a86ffc$export$238b87930d825d87)(dimCount);
    var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
    var dataDimNameMap = isUsingSourceDimensionsDef ? (0, $85b723b311a86ffc$export$be39ae17310c33f7)(source) : (0, $85b723b311a86ffc$export$a477f5bebfd07944)(dimsDef);
    var encodeDef = opt.encodeDefine;
    if (!encodeDef && opt.encodeDefaulter) encodeDef = opt.encodeDefaulter(source, dimCount);
    var encodeDefMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)(encodeDef);
    var indicesMap = new (0, $370e5aa482d8420b$export$b60d945128546f53)(dimCount);
    for(var i = 0; i < indicesMap.length; i++)indicesMap[i] = -1;
    function getResultItem(dimIdx) {
        var idx = indicesMap[dimIdx];
        if (idx < 0) {
            var dimDefItemRaw = dimsDef[dimIdx];
            var dimDefItem = (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(dimDefItemRaw) ? dimDefItemRaw : {
                name: dimDefItemRaw
            };
            var resultItem = new (0, $5e233867ea3713e7$export$2e2bcd8739ae039)();
            var userDimName = dimDefItem.name;
            if (userDimName != null && dataDimNameMap.get(userDimName) != null) // Only if `series.dimensions` is defined in option
            // displayName, will be set, and dimension will be displayed vertically in
            // tooltip by default.
            resultItem.name = resultItem.displayName = userDimName;
            dimDefItem.type != null && (resultItem.type = dimDefItem.type);
            dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
            var newIdx = resultList.length;
            indicesMap[dimIdx] = newIdx;
            resultItem.storeDimIndex = dimIdx;
            resultList.push(resultItem);
            return resultItem;
        }
        return resultList[idx];
    }
    if (!omitUnusedDimensions) for(var i = 0; i < dimCount; i++)getResultItem(i);
    // Set `coordDim` and `coordDimIndex` by `encodeDefMap` and normalize `encodeDefMap`.
    encodeDefMap.each(function(dataDimsRaw, coordDim) {
        var dataDims = (0, $76d619f648247e6d$export$4f07b212a02c8051)(dataDimsRaw).slice();
        // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
        // `{encode: {x: -1, y: 1}}`. Should not filter anything in
        // this case.
        if (dataDims.length === 1 && !(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(dataDims[0]) && dataDims[0] < 0) {
            encodeDefMap.set(coordDim, false);
            return;
        }
        var validDataDims = encodeDefMap.set(coordDim, []);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataDims, function(resultDimIdxOrName, idx) {
            // The input resultDimIdx can be dim name or index.
            var resultDimIdx = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;
            if (resultDimIdx != null && resultDimIdx < dimCount) {
                validDataDims[idx] = resultDimIdx;
                applyDim(getResultItem(resultDimIdx), coordDim, idx);
            }
        });
    });
    // Apply templates and default order from `sysDims`.
    var availDimIdx = 0;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(sysDims, function(sysDimItemRaw) {
        var coordDim;
        var sysDimItemDimsDef;
        var sysDimItemOtherDims;
        var sysDimItem;
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(sysDimItemRaw)) {
            coordDim = sysDimItemRaw;
            sysDimItem = {};
        } else {
            sysDimItem = sysDimItemRaw;
            coordDim = sysDimItem.name;
            var ordinalMeta = sysDimItem.ordinalMeta;
            sysDimItem.ordinalMeta = null;
            sysDimItem = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, sysDimItem);
            sysDimItem.ordinalMeta = ordinalMeta;
            // `coordDimIndex` should not be set directly.
            sysDimItemDimsDef = sysDimItem.dimsDef;
            sysDimItemOtherDims = sysDimItem.otherDims;
            sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
        }
        var dataDims = encodeDefMap.get(coordDim);
        // negative resultDimIdx means no need to mapping.
        if (dataDims === false) return;
        dataDims = (0, $76d619f648247e6d$export$4f07b212a02c8051)(dataDims);
        // dimensions provides default dim sequences.
        if (!dataDims.length) for(var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++){
            while(availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null)availDimIdx++;
            availDimIdx < dimCount && dataDims.push(availDimIdx++);
        }
        // Apply templates.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataDims, function(resultDimIdx, coordDimIndex) {
            var resultItem = getResultItem(resultDimIdx);
            // Coordinate system has a higher priority on dim type than source.
            if (isUsingSourceDimensionsDef && sysDimItem.type != null) resultItem.type = sysDimItem.type;
            applyDim((0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(resultItem, sysDimItem), coordDim, coordDimIndex);
            if (resultItem.name == null && sysDimItemDimsDef) {
                var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
                !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
                    name: sysDimItemDimsDefItem
                });
                resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
                resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
            }
            // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
            sysDimItemOtherDims && (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(resultItem.otherDims, sysDimItemOtherDims);
        });
    });
    function applyDim(resultItem, coordDim, coordDimIndex) {
        if ((0, $cab29724515ce2b8$export$cd51b5ca77f6f0e4).get(coordDim) != null) resultItem.otherDims[coordDim] = coordDimIndex;
        else {
            resultItem.coordDim = coordDim;
            resultItem.coordDimIndex = coordDimIndex;
            coordDimNameMap.set(coordDim, true);
        }
    }
    // Make sure the first extra dim is 'value'.
    var generateCoord = opt.generateCoord;
    var generateCoordCount = opt.generateCoordCount;
    var fromZero = generateCoordCount != null;
    generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
    var extra = generateCoord || "value";
    function ifNoNameFillWithCoordName(resultItem) {
        if (resultItem.name == null) // Duplication will be removed in the next step.
        resultItem.name = resultItem.coordDim;
    }
    // Set dim `name` and other `coordDim` and other props.
    if (!omitUnusedDimensions) for(var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++){
        var resultItem = getResultItem(resultDimIdx);
        var coordDim = resultItem.coordDim;
        if (coordDim == null) {
            // TODO no need to generate coordDim for isExtraCoord?
            resultItem.coordDim = $a27631012b7b377c$var$genCoordDimName(extra, coordDimNameMap, fromZero);
            resultItem.coordDimIndex = 0;
            // Series specified generateCoord is using out.
            if (!generateCoord || generateCoordCount <= 0) resultItem.isExtraCoord = true;
            generateCoordCount--;
        }
        ifNoNameFillWithCoordName(resultItem);
        if (resultItem.type == null && ((0, $7dc6cdfd7450ef29$export$c51adf1a2be01b9c)(source, resultDimIdx) === (0, $7dc6cdfd7450ef29$export$328749e9c5b40760).Must || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) resultItem.type = "ordinal";
    }
    else {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(resultList, function(resultItem) {
            // PENDING: guessOrdinal or let user specify type: 'ordinal' manually?
            ifNoNameFillWithCoordName(resultItem);
        });
        // Sort dimensions: there are some rule that use the last dim as label,
        // and for some latter travel process easier.
        resultList.sort(function(item0, item1) {
            return item0.storeDimIndex - item1.storeDimIndex;
        });
    }
    $a27631012b7b377c$var$removeDuplication(resultList);
    return new (0, $85b723b311a86ffc$export$a1ef064685775f3e)({
        source: source,
        dimensions: resultList,
        fullDimensionCount: dimCount,
        dimensionOmitted: omitUnusedDimensions
    });
}
function $a27631012b7b377c$var$removeDuplication(result) {
    var duplicationMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    for(var i = 0; i < result.length; i++){
        var dim = result[i];
        var dimOriginalName = dim.name;
        var count = duplicationMap.get(dimOriginalName) || 0;
        if (count > 0) // Starts from 0.
        dim.name = dimOriginalName + (count - 1);
        count++;
        duplicationMap.set(dimOriginalName, count);
    }
}
// ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calculate bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in data store?
function $a27631012b7b377c$var$getDimCount(source, sysDims, dimsDef, optDimCount) {
    // Note that the result dimCount should not small than columns count
    // of data, otherwise `dataDimNameMap` checking will be incorrect.
    var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(sysDims, function(sysDimItem) {
        var sysDimItemDimsDef;
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
    });
    return dimCount;
}
function $a27631012b7b377c$var$genCoordDimName(name, map, fromZero) {
    if (fromZero || map.hasKey(name)) {
        var i = 0;
        while(map.hasKey(name + i))i++;
        name += i;
    }
    map.set(name, true);
    return name;
}





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Helper for model references.
 * There are many manners to refer axis/coordSys.
 */ // TODO
// merge relevant logic to this file?
// check: "modelHelper" of tooltip and "BrushTargetManager".


/**
 * @class
 * For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // The index of the first category axis in `coordSysDims`.
 *     // `null/undefined` means no category axis exists.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */ var $a97e3a3e4c0c9c28$var$CoordSysInfo = /** @class */ function() {
    function CoordSysInfo(coordSysName) {
        this.coordSysDims = [];
        this.axisMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        this.categoryAxisMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        this.coordSysName = coordSysName;
    }
    return CoordSysInfo;
}();
function $a97e3a3e4c0c9c28$export$f2befeb2f4933656(seriesModel) {
    var coordSysName = seriesModel.get("coordinateSystem");
    var result = new $a97e3a3e4c0c9c28$var$CoordSysInfo(coordSysName);
    var fetch = $a97e3a3e4c0c9c28$var$fetchers[coordSysName];
    if (fetch) {
        fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
        return result;
    }
}
var $a97e3a3e4c0c9c28$var$fetchers = {
    cartesian2d: function(seriesModel, result, axisMap, categoryAxisMap) {
        var xAxisModel = seriesModel.getReferringComponents("xAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var yAxisModel = seriesModel.getReferringComponents("yAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            "x",
            "y"
        ];
        axisMap.set("x", xAxisModel);
        axisMap.set("y", yAxisModel);
        if ($a97e3a3e4c0c9c28$var$isCategory(xAxisModel)) {
            categoryAxisMap.set("x", xAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($a97e3a3e4c0c9c28$var$isCategory(yAxisModel)) {
            categoryAxisMap.set("y", yAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    singleAxis: function(seriesModel, result, axisMap, categoryAxisMap) {
        var singleAxisModel = seriesModel.getReferringComponents("singleAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            "single"
        ];
        axisMap.set("single", singleAxisModel);
        if ($a97e3a3e4c0c9c28$var$isCategory(singleAxisModel)) {
            categoryAxisMap.set("single", singleAxisModel);
            result.firstCategoryDimIndex = 0;
        }
    },
    polar: function(seriesModel, result, axisMap, categoryAxisMap) {
        var polarModel = seriesModel.getReferringComponents("polar", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var radiusAxisModel = polarModel.findAxisModel("radiusAxis");
        var angleAxisModel = polarModel.findAxisModel("angleAxis");
        result.coordSysDims = [
            "radius",
            "angle"
        ];
        axisMap.set("radius", radiusAxisModel);
        axisMap.set("angle", angleAxisModel);
        if ($a97e3a3e4c0c9c28$var$isCategory(radiusAxisModel)) {
            categoryAxisMap.set("radius", radiusAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($a97e3a3e4c0c9c28$var$isCategory(angleAxisModel)) {
            categoryAxisMap.set("angle", angleAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    geo: function(seriesModel, result, axisMap, categoryAxisMap) {
        result.coordSysDims = [
            "lng",
            "lat"
        ];
    },
    parallel: function(seriesModel, result, axisMap, categoryAxisMap) {
        var ecModel = seriesModel.ecModel;
        var parallelModel = ecModel.getComponent("parallel", seriesModel.get("parallelIndex"));
        var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(parallelModel.parallelAxisIndex, function(axisIndex, index) {
            var axisModel = ecModel.getComponent("parallelAxis", axisIndex);
            var axisDim = coordSysDims[index];
            axisMap.set(axisDim, axisModel);
            if ($a97e3a3e4c0c9c28$var$isCategory(axisModel)) {
                categoryAxisMap.set(axisDim, axisModel);
                if (result.firstCategoryDimIndex == null) result.firstCategoryDimIndex = index;
            }
        });
    }
};
function $a97e3a3e4c0c9c28$var$isCategory(axisModel) {
    return axisModel.get("type") === "category";
}






function $8afdec5f59c90781$var$getCoordSysDimDefs(seriesModel, coordSysInfo) {
    var coordSysName = seriesModel.get("coordinateSystem");
    var registeredCoordSys = (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).get(coordSysName);
    var coordSysDimDefs;
    if (coordSysInfo && coordSysInfo.coordSysDims) coordSysDimDefs = $7a1bd9c2710fea0d$export$871de8747c9eaa88(coordSysInfo.coordSysDims, function(dim) {
        var dimInfo = {
            name: dim
        };
        var axisModel = coordSysInfo.axisMap.get(dim);
        if (axisModel) {
            var axisType = axisModel.get("type");
            dimInfo.type = (0, $18085de91ae59d03$export$af1622903e71278e)(axisType);
        }
        return dimInfo;
    });
    if (!coordSysDimDefs) // Get dimensions from registered coordinate system
    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || [
        "x",
        "y"
    ];
    return coordSysDimDefs;
}
function $8afdec5f59c90781$var$injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
    var firstCategoryDimIndex;
    var hasNameEncode;
    coordSysInfo && $7a1bd9c2710fea0d$export$79b2f7037acddd43(dimInfoList, function(dimInfo, dimIndex) {
        var coordDim = dimInfo.coordDim;
        var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
        if (categoryAxisModel) {
            if (firstCategoryDimIndex == null) firstCategoryDimIndex = dimIndex;
            dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
            if (createInvertedIndices) dimInfo.createInvertedIndices = true;
        }
        if (dimInfo.otherDims.itemName != null) hasNameEncode = true;
    });
    if (!hasNameEncode && firstCategoryDimIndex != null) dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
    return firstCategoryDimIndex;
}
/**
 * Caution: there are side effects to `sourceManager` in this method.
 * Should better only be called in `Series['getInitialData']`.
 */ function $8afdec5f59c90781$var$createSeriesData(sourceRaw, seriesModel, opt) {
    opt = opt || {};
    var sourceManager = seriesModel.getSourceManager();
    var source;
    var isOriginalSource = false;
    if (sourceRaw) {
        isOriginalSource = true;
        source = (0, $99e22f5c2aa5094b$export$75aef3f97c0a5edf)(sourceRaw);
    } else {
        source = sourceManager.getSource();
        // Is series.data. not dataset.
        isOriginalSource = source.sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6);
    }
    var coordSysInfo = (0, $a97e3a3e4c0c9c28$export$f2befeb2f4933656)(seriesModel);
    var coordSysDimDefs = $8afdec5f59c90781$var$getCoordSysDimDefs(seriesModel, coordSysInfo);
    var useEncodeDefaulter = opt.useEncodeDefaulter;
    var encodeDefaulter = $7a1bd9c2710fea0d$export$f6e2535fb5126e54(useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$37682b8fdd2e83d), coordSysDimDefs, seriesModel) : null;
    var createDimensionOptions = {
        coordDimensions: coordSysDimDefs,
        generateCoord: opt.generateCoord,
        encodeDefine: seriesModel.getEncode(),
        encodeDefaulter: encodeDefaulter,
        canOmitUnusedDimensions: !isOriginalSource
    };
    var schema = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(source, createDimensionOptions);
    var firstCategoryDimIndex = $8afdec5f59c90781$var$injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
    var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
    var stackCalculationInfo = (0, $efdd976e4917927c$export$f2165f9e8499b278)(seriesModel, {
        schema: schema,
        store: store
    });
    var data = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(schema, seriesModel);
    data.setCalculationInfo(stackCalculationInfo);
    var dimValueGetter = firstCategoryDimIndex != null && $8afdec5f59c90781$var$isNeedCompleteOrdinalData(source) ? function(itemOpt, dimName, dataIndex, dimIndex) {
        // Use dataIndex as ordinal value in categoryAxis
        return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
    } : null;
    data.hasItemOption = false;
    data.initData(// Try to reuse the data store in sourceManager if using dataset.
    isOriginalSource ? source : store, null, dimValueGetter);
    return data;
}
function $8afdec5f59c90781$var$isNeedCompleteOrdinalData(source) {
    if (source.sourceFormat === (0, $cab29724515ce2b8$export$2823037fb9d8f0c6)) {
        var sampleItem = $8afdec5f59c90781$var$firstDataNotNull(source.data || []);
        return !$7a1bd9c2710fea0d$export$43bee75e5e14138e((0, $76d619f648247e6d$export$2c944e12edb48d4b)(sampleItem));
    }
}
function $8afdec5f59c90781$var$firstDataNotNull(arr) {
    var i = 0;
    while(i < arr.length && arr[i] == null)i++;
    return arr[i];
}
var $8afdec5f59c90781$export$2e2bcd8739ae039 = $8afdec5f59c90781$var$createSeriesData;



var $b508252f98157abf$var$BaseBarSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BaseBarSeriesModel, _super);
    function BaseBarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BaseBarSeriesModel.type;
        return _this;
    }
    BaseBarSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    BaseBarSeriesModel.prototype.getMarkerPosition = function(value, dims, startingAtTick) {
        var coordSys = this.coordinateSystem;
        if (coordSys && coordSys.clampData) {
            // PENDING if clamp ?
            var clampData_1 = coordSys.clampData(value);
            var pt_1 = coordSys.dataToPoint(clampData_1);
            if (startingAtTick) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSys.getAxes(), function(axis, idx) {
                // If axis type is category, use tick coords instead
                if (axis.type === "category" && dims != null) {
                    var tickCoords = axis.getTicksCoords();
                    var alignTicksWithLabel = axis.getTickModel().get("alignWithLabel");
                    var targetTickId = clampData_1[idx];
                    // The index of rightmost tick of markArea is 1 larger than x1/y1 index
                    var isEnd = dims[idx] === "x1" || dims[idx] === "y1";
                    if (isEnd && !alignTicksWithLabel) targetTickId += 1;
                    // The only contains one tick, tickCoords is
                    // like [{coord: 0, tickValue: 0}, {coord: 0}]
                    // to the length should always be larger than 1
                    if (tickCoords.length < 2) return;
                    else if (tickCoords.length === 2) {
                        // The left value and right value of the axis are
                        // the same. coord is 0 in both items. Use the max
                        // value of the axis as the coord
                        pt_1[idx] = axis.toGlobalCoord(axis.getExtent()[isEnd ? 1 : 0]);
                        return;
                    }
                    var leftCoord = void 0;
                    var coord = void 0;
                    var stepTickValue = 1;
                    for(var i = 0; i < tickCoords.length; i++){
                        var tickCoord = tickCoords[i].coord;
                        // The last item of tickCoords doesn't contain
                        // tickValue
                        var tickValue = i === tickCoords.length - 1 ? tickCoords[i - 1].tickValue + stepTickValue : tickCoords[i].tickValue;
                        if (tickValue === targetTickId) {
                            coord = tickCoord;
                            break;
                        } else if (tickValue < targetTickId) leftCoord = tickCoord;
                        else if (leftCoord != null && tickValue > targetTickId) {
                            coord = (tickCoord + leftCoord) / 2;
                            break;
                        }
                        if (i === 1) // Here we assume the step of category axes is
                        // the same
                        stepTickValue = tickValue - tickCoords[0].tickValue;
                    }
                    if (coord == null) {
                        if (!leftCoord) // targetTickId is smaller than all tick ids in the
                        // visible area, use the leftmost tick coord
                        coord = tickCoords[0].coord;
                        else if (leftCoord) // targetTickId is larger than all tick ids in the
                        // visible area, use the rightmost tick coord
                        coord = tickCoords[tickCoords.length - 1].coord;
                    }
                    pt_1[idx] = axis.toGlobalCoord(coord);
                }
            });
            else {
                var data = this.getData();
                var offset = data.getLayout("offset");
                var size = data.getLayout("size");
                var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
                pt_1[offsetIndex] += offset + size / 2;
            }
            return pt_1;
        }
        return [
            NaN,
            NaN
        ];
    };
    BaseBarSeriesModel.type = "series.__base_bar__";
    BaseBarSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "cartesian2d",
        legendHoverLink: true,
        // stack: null
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        barMinHeight: 0,
        barMinAngle: 0,
        // cursor: null,
        large: false,
        largeThreshold: 400,
        progressive: 3e3,
        progressiveChunkMode: "mod"
    };
    return BaseBarSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
(0, $7c10febb2cdef0d8$export$2e2bcd8739ae039).registerClass($b508252f98157abf$var$BaseBarSeriesModel);
var $b508252f98157abf$export$2e2bcd8739ae039 = $b508252f98157abf$var$BaseBarSeriesModel;




var $1db8e2e676cae702$var$BarSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BarSeriesModel, _super);
    function BarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BarSeriesModel.type;
        return _this;
    }
    BarSeriesModel.prototype.getInitialData = function() {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true,
            createInvertedIndices: !!this.get("realtimeSort", true) || null
        });
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressive = function() {
        // Do not support progressive in normal mode.
        return this.get("large") ? this.get("progressive") : false;
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressiveThreshold = function() {
        // Do not support progressive in normal mode.
        var progressiveThreshold = this.get("progressiveThreshold");
        var largeThreshold = this.get("largeThreshold");
        if (largeThreshold > progressiveThreshold) progressiveThreshold = largeThreshold;
        return progressiveThreshold;
    };
    BarSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.rect(data.getItemLayout(dataIndex));
    };
    BarSeriesModel.type = "series.bar";
    BarSeriesModel.dependencies = [
        "grid",
        "polar"
    ];
    BarSeriesModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $b508252f98157abf$export$2e2bcd8739ae039).defaultOption, {
        // If clipped
        // Only available on cartesian2d
        clip: true,
        roundCap: false,
        showBackground: false,
        backgroundStyle: {
            color: "rgba(180, 180, 180, 0.2)",
            borderColor: null,
            borderWidth: 0,
            borderType: "solid",
            borderRadius: 0,
            shadowBlur: 0,
            shadowColor: null,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1
        },
        select: {
            itemStyle: {
                borderColor: "#212121"
            }
        },
        realtimeSort: false
    });
    return BarSeriesModel;
}((0, $b508252f98157abf$export$2e2bcd8739ae039));
var $1db8e2e676cae702$export$2e2bcd8739ae039 = $1db8e2e676cae702$var$BarSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $0e2cc04b3aaad400$export$83958787eb658d14(cartesian, hasAnimation, seriesModel, done, during) {
    var rect = cartesian.getArea();
    var x = rect.x;
    var y = rect.y;
    var width = rect.width;
    var height = rect.height;
    var lineWidth = seriesModel.get([
        "lineStyle",
        "width"
    ]) || 2;
    // Expand the clip path a bit to avoid the border is clipped and looks thinner
    x -= lineWidth / 2;
    y -= lineWidth / 2;
    width += lineWidth;
    height += lineWidth;
    // fix: https://github.com/apache/incubator-echarts/issues/11369
    width = Math.ceil(width);
    if (x !== Math.floor(x)) {
        x = Math.floor(x);
        // if no extra 1px on `width`, it will still be clipped since `x` is floored
        width++;
    }
    var clipPath = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    });
    if (hasAnimation) {
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var isAxisInversed = baseAxis.inverse;
        if (isHorizontal) {
            if (isAxisInversed) clipPath.shape.x += width;
            clipPath.shape.width = 0;
        } else {
            if (!isAxisInversed) clipPath.shape.y += height;
            clipPath.shape.height = 0;
        }
        var duringCb = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(during) ? function(percent) {
            during(percent, clipPath);
        } : null;
        $8b353638fbedfefa$export$a121566aadcfe021(clipPath, {
            shape: {
                width: width,
                height: height,
                x: x,
                y: y
            }
        }, seriesModel, null, done, duringCb);
    }
    return clipPath;
}
function $0e2cc04b3aaad400$export$13dc2b2230df3cb5(polar, hasAnimation, seriesModel) {
    var sectorArea = polar.getArea();
    // Avoid float number rounding error for symbol on the edge of axis extent.
    var r0 = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(sectorArea.r0, 1);
    var r = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(sectorArea.r, 1);
    var clipPath = new $a3e1dec0a3875b49$export$2e2bcd8739ae039({
        shape: {
            cx: (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(polar.cx, 1),
            cy: (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(polar.cy, 1),
            r0: r0,
            r: r,
            startAngle: sectorArea.startAngle,
            endAngle: sectorArea.endAngle,
            clockwise: sectorArea.clockwise
        }
    });
    if (hasAnimation) {
        var isRadial = polar.getBaseAxis().dim === "angle";
        if (isRadial) clipPath.shape.endAngle = sectorArea.startAngle;
        else clipPath.shape.r = r0;
        $8b353638fbedfefa$export$a121566aadcfe021(clipPath, {
            shape: {
                endAngle: sectorArea.endAngle,
                r: r
            }
        }, seriesModel);
    }
    return clipPath;
}
function $0e2cc04b3aaad400$export$e0fe5081209d01c9(coordSys, hasAnimation, seriesModel, done, during) {
    if (!coordSys) return null;
    else if (coordSys.type === "polar") return $0e2cc04b3aaad400$export$13dc2b2230df3cb5(coordSys, hasAnimation, seriesModel);
    else if (coordSys.type === "cartesian2d") return $0e2cc04b3aaad400$export$83958787eb658d14(coordSys, hasAnimation, seriesModel, done, during);
    return null;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Sausage: similar to sector, but have half circle on both sides
 */ var $9674946a7a7df213$var$SausageShape = /** @class */ function() {
    function SausageShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return SausageShape;
}();
var $9674946a7a7df213$var$SausagePath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SausagePath, _super);
    function SausagePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "sausage";
        return _this;
    }
    SausagePath.prototype.getDefaultShape = function() {
        return new $9674946a7a7df213$var$SausageShape();
    };
    SausagePath.prototype.buildPath = function(ctx, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var r0 = Math.max(shape.r0 || 0, 0);
        var r = Math.max(shape.r, 0);
        var dr = (r - r0) * 0.5;
        var rCenter = r0 + dr;
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var PI2 = Math.PI * 2;
        var lessThanCircle = clockwise ? endAngle - startAngle < PI2 : startAngle - endAngle < PI2;
        if (!lessThanCircle) // Normalize angles
        startAngle = endAngle - (clockwise ? PI2 : -PI2);
        var unitStartX = Math.cos(startAngle);
        var unitStartY = Math.sin(startAngle);
        var unitEndX = Math.cos(endAngle);
        var unitEndY = Math.sin(endAngle);
        if (lessThanCircle) {
            ctx.moveTo(unitStartX * r0 + cx, unitStartY * r0 + cy);
            ctx.arc(unitStartX * rCenter + cx, unitStartY * rCenter + cy, dr, -Math.PI + startAngle, startAngle, !clockwise);
        } else ctx.moveTo(unitStartX * r + cx, unitStartY * r + cy);
        ctx.arc(cx, cy, r, startAngle, endAngle, !clockwise);
        ctx.arc(unitEndX * rCenter + cx, unitEndY * rCenter + cy, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);
        if (r0 !== 0) ctx.arc(cx, cy, r0, endAngle, startAngle, clockwise);
    // ctx.closePath();
    };
    return SausagePath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $9674946a7a7df213$export$2e2bcd8739ae039 = $9674946a7a7df213$var$SausagePath;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $3fea949f0512eb55$export$8567506e6336616(coordSys, type) {
    return coordSys.type === type;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $b2475f850d3c0bc2$export$5ff20667590927ed(data, dataIndex) {
    var labelDims = data.mapDimensionsAll("defaultedLabel");
    var len = labelDims.length;
    // Simple optimization (in lots of cases, label dims length is 1)
    if (len === 1) {
        var rawVal = (0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, labelDims[0]);
        return rawVal != null ? rawVal + "" : null;
    } else if (len) {
        var vals = [];
        for(var i = 0; i < labelDims.length; i++)vals.push((0, $8ffb0d67e9446edb$export$cde9373da9aad801)(data, dataIndex, labelDims[i]));
        return vals.join(" ");
    }
}
function $b2475f850d3c0bc2$export$5f84815e91ca6775(data, interpolatedValue) {
    var labelDims = data.mapDimensionsAll("defaultedLabel");
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(interpolatedValue)) return interpolatedValue + "";
    var vals = [];
    for(var i = 0; i < labelDims.length; i++){
        var dimIndex = data.getDimensionIndex(labelDims[i]);
        if (dimIndex >= 0) vals.push(interpolatedValue[dimIndex]);
    }
    return vals.join(" ");
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $5e4aaa173c31cda6$export$359a1e2d210ed734(positionMapping, opts) {
    opts = opts || {};
    var isRoundCap = opts.isRoundCap;
    return function(out, opts, boundingRect) {
        var textPosition = opts.position;
        if (!textPosition || textPosition instanceof Array) return (0, $6c308355c7107803$export$eee3603b512feab7)(out, opts, boundingRect);
        var mappedSectorPosition = positionMapping(textPosition);
        var distance = opts.distance != null ? opts.distance : 5;
        var sector = this.shape;
        var cx = sector.cx;
        var cy = sector.cy;
        var r = sector.r;
        var r0 = sector.r0;
        var middleR = (r + r0) / 2;
        var startAngle = sector.startAngle;
        var endAngle = sector.endAngle;
        var middleAngle = (startAngle + endAngle) / 2;
        var extraDist = isRoundCap ? Math.abs(r - r0) / 2 : 0;
        var mathCos = Math.cos;
        var mathSin = Math.sin;
        // base position: top-left
        var x = cx + r * mathCos(startAngle);
        var y = cy + r * mathSin(startAngle);
        var textAlign = "left";
        var textVerticalAlign = "top";
        switch(mappedSectorPosition){
            case "startArc":
                x = cx + (r0 - distance) * mathCos(middleAngle);
                y = cy + (r0 - distance) * mathSin(middleAngle);
                textAlign = "center";
                textVerticalAlign = "top";
                break;
            case "insideStartArc":
                x = cx + (r0 + distance) * mathCos(middleAngle);
                y = cy + (r0 + distance) * mathSin(middleAngle);
                textAlign = "center";
                textVerticalAlign = "bottom";
                break;
            case "startAngle":
                x = cx + middleR * mathCos(startAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceX(startAngle, distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceY(startAngle, distance + extraDist, false);
                textAlign = "right";
                textVerticalAlign = "middle";
                break;
            case "insideStartAngle":
                x = cx + middleR * mathCos(startAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceX(startAngle, -distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceY(startAngle, -distance + extraDist, false);
                textAlign = "left";
                textVerticalAlign = "middle";
                break;
            case "middle":
                x = cx + middleR * mathCos(middleAngle);
                y = cy + middleR * mathSin(middleAngle);
                textAlign = "center";
                textVerticalAlign = "middle";
                break;
            case "endArc":
                x = cx + (r + distance) * mathCos(middleAngle);
                y = cy + (r + distance) * mathSin(middleAngle);
                textAlign = "center";
                textVerticalAlign = "bottom";
                break;
            case "insideEndArc":
                x = cx + (r - distance) * mathCos(middleAngle);
                y = cy + (r - distance) * mathSin(middleAngle);
                textAlign = "center";
                textVerticalAlign = "top";
                break;
            case "endAngle":
                x = cx + middleR * mathCos(endAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceX(endAngle, distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceY(endAngle, distance + extraDist, true);
                textAlign = "left";
                textVerticalAlign = "middle";
                break;
            case "insideEndAngle":
                x = cx + middleR * mathCos(endAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceX(endAngle, -distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $5e4aaa173c31cda6$var$adjustAngleDistanceY(endAngle, -distance + extraDist, true);
                textAlign = "right";
                textVerticalAlign = "middle";
                break;
            default:
                return (0, $6c308355c7107803$export$eee3603b512feab7)(out, opts, boundingRect);
        }
        out = out || {};
        out.x = x;
        out.y = y;
        out.align = textAlign;
        out.verticalAlign = textVerticalAlign;
        return out;
    };
}
function $5e4aaa173c31cda6$export$672ce504c0db395a(sector, textPosition, positionMapping, rotateType) {
    if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rotateType)) {
        // user-set rotation
        sector.setTextConfig({
            rotation: rotateType
        });
        return;
    } else if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(textPosition)) {
        // user-set position, use 0 as auto rotation
        sector.setTextConfig({
            rotation: 0
        });
        return;
    }
    var shape = sector.shape;
    var startAngle = shape.clockwise ? shape.startAngle : shape.endAngle;
    var endAngle = shape.clockwise ? shape.endAngle : shape.startAngle;
    var middleAngle = (startAngle + endAngle) / 2;
    var anchorAngle;
    var mappedSectorPosition = positionMapping(textPosition);
    switch(mappedSectorPosition){
        case "startArc":
        case "insideStartArc":
        case "middle":
        case "insideEndArc":
        case "endArc":
            anchorAngle = middleAngle;
            break;
        case "startAngle":
        case "insideStartAngle":
            anchorAngle = startAngle;
            break;
        case "endAngle":
        case "insideEndAngle":
            anchorAngle = endAngle;
            break;
        default:
            sector.setTextConfig({
                rotation: 0
            });
            return;
    }
    var rotate = Math.PI * 1.5 - anchorAngle;
    /**
   * TODO: labels with rotate > Math.PI / 2 should be rotate another
   * half round flipped to increase readability. However, only middle
   * position supports this for now, because in other positions, the
   * anchor point is not at the center of the text, so the positions
   * after rotating is not as expected.
   */ if (mappedSectorPosition === "middle" && rotate > Math.PI / 2 && rotate < Math.PI * 1.5) rotate -= Math.PI;
    sector.setTextConfig({
        rotation: rotate
    });
}
function $5e4aaa173c31cda6$var$adjustAngleDistanceX(angle, distance, isEnd) {
    return distance * Math.sin(angle) * (isEnd ? -1 : 1);
}
function $5e4aaa173c31cda6$var$adjustAngleDistanceY(angle, distance, isEnd) {
    return distance * Math.cos(angle) * (isEnd ? 1 : -1);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $9491a9b96e203579$export$b395eeeb2ad7cce5(model, shape, zeroIfNull) {
    var cornerRadius = model.get("borderRadius");
    if (cornerRadius == null) return zeroIfNull ? {
        cornerRadius: 0
    } : null;
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(cornerRadius)) cornerRadius = [
        cornerRadius,
        cornerRadius,
        cornerRadius,
        cornerRadius
    ];
    var dr = Math.abs(shape.r || 0 - shape.r0 || 0);
    return {
        cornerRadius: (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(cornerRadius, function(cr) {
            return (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(cr, dr);
        })
    };
}


var $0b120d76f26c920d$var$mathMax = Math.max;
var $0b120d76f26c920d$var$mathMin = Math.min;
function $0b120d76f26c920d$var$getClipArea(coord, data) {
    var coordSysClipArea = coord.getArea && coord.getArea();
    if ((0, $3fea949f0512eb55$export$8567506e6336616)(coord, "cartesian2d")) {
        var baseAxis = coord.getBaseAxis();
        // When boundaryGap is false or using time axis. bar may exceed the grid.
        // We should not clip this part.
        // See test/bar2.html
        if (baseAxis.type !== "category" || !baseAxis.onBand) {
            var expandWidth = data.getLayout("bandWidth");
            if (baseAxis.isHorizontal()) {
                coordSysClipArea.x -= expandWidth;
                coordSysClipArea.width += expandWidth * 2;
            } else {
                coordSysClipArea.y -= expandWidth;
                coordSysClipArea.height += expandWidth * 2;
            }
        }
    }
    return coordSysClipArea;
}
var $0b120d76f26c920d$var$BarView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BarView, _super);
    function BarView() {
        var _this = _super.call(this) || this;
        _this.type = BarView.type;
        _this._isFirstFrame = true;
        return _this;
    }
    BarView.prototype.render = function(seriesModel, ecModel, api, payload) {
        this._model = seriesModel;
        this._removeOnRenderedListener(api);
        this._updateDrawMode(seriesModel);
        var coordinateSystemType = seriesModel.get("coordinateSystem");
        if (coordinateSystemType === "cartesian2d" || coordinateSystemType === "polar") {
            // Clear previously rendered progressive elements.
            this._progressiveEls = null;
            this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api, payload);
        }
    };
    BarView.prototype.incrementalPrepareRender = function(seriesModel) {
        this._clear();
        this._updateDrawMode(seriesModel);
        // incremental also need to clip, otherwise might be overlow.
        // But must not set clip in each frame, otherwise all of the children will be marked redraw.
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype.incrementalRender = function(params, seriesModel) {
        // Reset
        this._progressiveEls = [];
        // Do not support progressive in normal mode.
        this._incrementalRenderLarge(params, seriesModel);
    };
    BarView.prototype.eachRendered = function(cb) {
        (0, $5b455ae6f843ac47$export$3e564442729bf048)(this._progressiveEls || this.group, cb);
    };
    BarView.prototype._updateDrawMode = function(seriesModel) {
        var isLargeDraw = seriesModel.pipelineContext.large;
        if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
            this._isLargeDraw = isLargeDraw;
            this._clear();
        }
    };
    BarView.prototype._renderNormal = function(seriesModel, ecModel, api, payload) {
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        var coord = seriesModel.coordinateSystem;
        var baseAxis = coord.getBaseAxis();
        var isHorizontalOrRadial;
        if (coord.type === "cartesian2d") isHorizontalOrRadial = baseAxis.isHorizontal();
        else if (coord.type === "polar") isHorizontalOrRadial = baseAxis.dim === "angle";
        var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
        var realtimeSortCfg = $0b120d76f26c920d$var$shouldRealtimeSort(seriesModel, coord);
        if (realtimeSortCfg) this._enableRealtimeSort(realtimeSortCfg, data, api);
        var needsClip = seriesModel.get("clip", true) || realtimeSortCfg;
        var coordSysClipArea = $0b120d76f26c920d$var$getClipArea(coord, data);
        // If there is clipPath created in large mode. Remove it.
        group.removeClipPath();
        // We don't use clipPath in normal mode because we needs a perfect animation
        // And don't want the label are clipped.
        var roundCap = seriesModel.get("roundCap", true);
        var drawBackground = seriesModel.get("showBackground", true);
        var backgroundModel = seriesModel.getModel("backgroundStyle");
        var barBorderRadius = backgroundModel.get("borderRadius") || 0;
        var bgEls = [];
        var oldBgEls = this._backgroundEls;
        var isInitSort = payload && payload.isInitSort;
        var isChangeOrder = payload && payload.type === "changeAxisOrder";
        function createBackground(dataIndex) {
            var bgLayout = $0b120d76f26c920d$var$getLayout[coord.type](data, dataIndex);
            var bgEl = $0b120d76f26c920d$var$createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
            bgEl.useStyle(backgroundModel.getItemStyle());
            // Only cartesian2d support borderRadius.
            if (coord.type === "cartesian2d") bgEl.setShape("r", barBorderRadius);
            else bgEl.setShape("cornerRadius", barBorderRadius);
            bgEls[dataIndex] = bgEl;
            return bgEl;
        }
        data.diff(oldData).add(function(dataIndex) {
            var itemModel = data.getItemModel(dataIndex);
            var layout = $0b120d76f26c920d$var$getLayout[coord.type](data, dataIndex, itemModel);
            if (drawBackground) createBackground(dataIndex);
            // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".
            if (!data.hasValue(dataIndex) || !$0b120d76f26c920d$var$isValidLayout[coord.type](layout)) return;
            var isClipped = false;
            if (needsClip) // Clip will modify the layout params.
            // And return a boolean to determine if the shape are fully clipped.
            isClipped = $0b120d76f26c920d$var$clip[coord.type](coordSysClipArea, layout);
            var el = $0b120d76f26c920d$var$elementCreator[coord.type](seriesModel, data, dataIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, false, roundCap);
            if (realtimeSortCfg) /**
         * Force label animation because even if the element is
         * ignored because it's clipped, it may not be clipped after
         * changing order. Then, if not using forceLabelAnimation,
         * the label animation was never started, in which case,
         * the label will be the final value and doesn't have label
         * animation.
         */ el.forceLabelAnimation = true;
            $0b120d76f26c920d$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === "polar");
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $0b120d76f26c920d$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, dataIndex, isHorizontalOrRadial, false, false);
            else (0, $8b353638fbedfefa$export$a121566aadcfe021)(el, {
                shape: layout
            }, seriesModel, dataIndex);
            data.setItemGraphicEl(dataIndex, el);
            group.add(el);
            el.ignore = isClipped;
        }).update(function(newIndex, oldIndex) {
            var itemModel = data.getItemModel(newIndex);
            var layout = $0b120d76f26c920d$var$getLayout[coord.type](data, newIndex, itemModel);
            if (drawBackground) {
                var bgEl = void 0;
                if (oldBgEls.length === 0) bgEl = createBackground(oldIndex);
                else {
                    bgEl = oldBgEls[oldIndex];
                    bgEl.useStyle(backgroundModel.getItemStyle());
                    // Only cartesian2d support borderRadius.
                    if (coord.type === "cartesian2d") bgEl.setShape("r", barBorderRadius);
                    else bgEl.setShape("cornerRadius", barBorderRadius);
                    bgEls[newIndex] = bgEl;
                }
                var bgLayout = $0b120d76f26c920d$var$getLayout[coord.type](data, newIndex);
                var shape = $0b120d76f26c920d$var$createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(bgEl, {
                    shape: shape
                }, animationModel, newIndex);
            }
            var el = oldData.getItemGraphicEl(oldIndex);
            if (!data.hasValue(newIndex) || !$0b120d76f26c920d$var$isValidLayout[coord.type](layout)) {
                group.remove(el);
                return;
            }
            var isClipped = false;
            if (needsClip) {
                isClipped = $0b120d76f26c920d$var$clip[coord.type](coordSysClipArea, layout);
                if (isClipped) group.remove(el);
            }
            if (!el) el = $0b120d76f26c920d$var$elementCreator[coord.type](seriesModel, data, newIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, !!el, roundCap);
            else (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(el);
            if (realtimeSortCfg) el.forceLabelAnimation = true;
            if (isChangeOrder) {
                var textEl = el.getTextContent();
                if (textEl) {
                    var labelInnerStore = (0, $6800dfcb6e1e2a44$export$f62786d3261ab0f4)(textEl);
                    if (labelInnerStore.prevValue != null) /**
             * Set preValue to be value so that no new label
             * should be started, otherwise, it will take a full
             * `animationDurationUpdate` time to finish the
             * animation, which is not expected.
             */ labelInnerStore.prevValue = labelInnerStore.value;
                }
            } else $0b120d76f26c920d$var$updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === "polar");
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $0b120d76f26c920d$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, newIndex, isHorizontalOrRadial, true, isChangeOrder);
            else (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(el, {
                shape: layout
            }, seriesModel, newIndex, null);
            data.setItemGraphicEl(newIndex, el);
            el.ignore = isClipped;
            group.add(el);
        }).remove(function(dataIndex) {
            var el = oldData.getItemGraphicEl(dataIndex);
            el && (0, $8b353638fbedfefa$export$6d0fd725cb4aee8a)(el, seriesModel, dataIndex);
        }).execute();
        var bgGroup = this._backgroundGroup || (this._backgroundGroup = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)());
        bgGroup.removeAll();
        for(var i = 0; i < bgEls.length; ++i)bgGroup.add(bgEls[i]);
        group.add(bgGroup);
        this._backgroundEls = bgEls;
        this._data = data;
    };
    BarView.prototype._renderLarge = function(seriesModel, ecModel, api) {
        this._clear();
        $0b120d76f26c920d$var$createLarge(seriesModel, this.group);
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype._incrementalRenderLarge = function(params, seriesModel) {
        this._removeBackground();
        $0b120d76f26c920d$var$createLarge(seriesModel, this.group, this._progressiveEls, true);
    };
    BarView.prototype._updateLargeClip = function(seriesModel) {
        // Use clipPath in large mode.
        var clipPath = seriesModel.get("clip", true) && (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel);
        var group = this.group;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
    };
    BarView.prototype._enableRealtimeSort = function(realtimeSortCfg, data, api) {
        var _this = this;
        // If no data in the first frame, wait for data to initSort
        if (!data.count()) return;
        var baseAxis = realtimeSortCfg.baseAxis;
        if (this._isFirstFrame) {
            this._dispatchInitSort(data, realtimeSortCfg, api);
            this._isFirstFrame = false;
        } else {
            var orderMapping_1 = function(idx) {
                var el = data.getItemGraphicEl(idx);
                var shape = el && el.shape;
                return shape && // The result should be consistent with the initial sort by data value.
                // Do not support the case that both positive and negative exist.
                Math.abs(baseAxis.isHorizontal() ? shape.height : shape.width) || 0;
            };
            this._onRendered = function() {
                _this._updateSortWithinSameData(data, orderMapping_1, baseAxis, api);
            };
            api.getZr().on("rendered", this._onRendered);
        }
    };
    BarView.prototype._dataSort = function(data, baseAxis, orderMapping) {
        var info = [];
        data.each(data.mapDimension(baseAxis.dim), function(ordinalNumber, dataIdx) {
            var mappedValue = orderMapping(dataIdx);
            mappedValue = mappedValue == null ? NaN : mappedValue;
            info.push({
                dataIndex: dataIdx,
                mappedValue: mappedValue,
                ordinalNumber: ordinalNumber
            });
        });
        info.sort(function(a, b) {
            // If NaN, it will be treated as min val.
            return b.mappedValue - a.mappedValue;
        });
        return {
            ordinalNumbers: (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(info, function(item) {
                return item.ordinalNumber;
            })
        };
    };
    BarView.prototype._isOrderChangedWithinSameData = function(data, orderMapping, baseAxis) {
        var scale = baseAxis.scale;
        var ordinalDataDim = data.mapDimension(baseAxis.dim);
        var lastValue = Number.MAX_VALUE;
        for(var tickNum = 0, len = scale.getOrdinalMeta().categories.length; tickNum < len; ++tickNum){
            var rawIdx = data.rawIndexOf(ordinalDataDim, scale.getRawOrdinalNumber(tickNum));
            var value = rawIdx < 0 ? Number.MIN_VALUE : orderMapping(data.indexOfRawIndex(rawIdx));
            if (value > lastValue) return true;
            lastValue = value;
        }
        return false;
    };
    /*
   * Consider the case when A and B changed order, whose representing
   * bars are both out of sight, we don't wish to trigger reorder action
   * as long as the order in the view doesn't change.
   */ BarView.prototype._isOrderDifferentInView = function(orderInfo, baseAxis) {
        var scale = baseAxis.scale;
        var extent = scale.getExtent();
        var tickNum = Math.max(0, extent[0]);
        var tickMax = Math.min(extent[1], scale.getOrdinalMeta().categories.length - 1);
        for(; tickNum <= tickMax; ++tickNum){
            if (orderInfo.ordinalNumbers[tickNum] !== scale.getRawOrdinalNumber(tickNum)) return true;
        }
    };
    BarView.prototype._updateSortWithinSameData = function(data, orderMapping, baseAxis, api) {
        if (!this._isOrderChangedWithinSameData(data, orderMapping, baseAxis)) return;
        var sortInfo = this._dataSort(data, baseAxis, orderMapping);
        if (this._isOrderDifferentInView(sortInfo, baseAxis)) {
            this._removeOnRenderedListener(api);
            api.dispatchAction({
                type: "changeAxisOrder",
                componentType: baseAxis.dim + "Axis",
                axisId: baseAxis.index,
                sortInfo: sortInfo
            });
        }
    };
    BarView.prototype._dispatchInitSort = function(data, realtimeSortCfg, api) {
        var baseAxis = realtimeSortCfg.baseAxis;
        var sortResult = this._dataSort(data, baseAxis, function(dataIdx) {
            return data.get(data.mapDimension(realtimeSortCfg.otherAxis.dim), dataIdx);
        });
        api.dispatchAction({
            type: "changeAxisOrder",
            componentType: baseAxis.dim + "Axis",
            isInitSort: true,
            axisId: baseAxis.index,
            sortInfo: sortResult
        });
    };
    BarView.prototype.remove = function(ecModel, api) {
        this._clear(this._model);
        this._removeOnRenderedListener(api);
    };
    BarView.prototype.dispose = function(ecModel, api) {
        this._removeOnRenderedListener(api);
    };
    BarView.prototype._removeOnRenderedListener = function(api) {
        if (this._onRendered) {
            api.getZr().off("rendered", this._onRendered);
            this._onRendered = null;
        }
    };
    BarView.prototype._clear = function(model) {
        var group = this.group;
        var data = this._data;
        if (model && model.isAnimationEnabled() && data && !this._isLargeDraw) {
            this._removeBackground();
            this._backgroundEls = [];
            data.eachItemGraphicEl(function(el) {
                (0, $8b353638fbedfefa$export$6d0fd725cb4aee8a)(el, model, (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).dataIndex);
            });
        } else group.removeAll();
        this._data = null;
        this._isFirstFrame = true;
    };
    BarView.prototype._removeBackground = function() {
        this.group.remove(this._backgroundGroup);
        this._backgroundGroup = null;
    };
    BarView.type = "bar";
    return BarView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $0b120d76f26c920d$var$clip = {
    cartesian2d: function(coordSysBoundingRect, layout) {
        var signWidth = layout.width < 0 ? -1 : 1;
        var signHeight = layout.height < 0 ? -1 : 1;
        // Needs positive width and height
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        var coordSysX2 = coordSysBoundingRect.x + coordSysBoundingRect.width;
        var coordSysY2 = coordSysBoundingRect.y + coordSysBoundingRect.height;
        var x = $0b120d76f26c920d$var$mathMax(layout.x, coordSysBoundingRect.x);
        var x2 = $0b120d76f26c920d$var$mathMin(layout.x + layout.width, coordSysX2);
        var y = $0b120d76f26c920d$var$mathMax(layout.y, coordSysBoundingRect.y);
        var y2 = $0b120d76f26c920d$var$mathMin(layout.y + layout.height, coordSysY2);
        var xClipped = x2 < x;
        var yClipped = y2 < y;
        // When xClipped or yClipped, the element will be marked as `ignore`.
        // But we should also place the element at the edge of the coord sys bounding rect.
        // Because if data changed and the bar shows again, its transition animation
        // will begin at this place.
        layout.x = xClipped && x > coordSysX2 ? x2 : x;
        layout.y = yClipped && y > coordSysY2 ? y2 : y;
        layout.width = xClipped ? 0 : x2 - x;
        layout.height = yClipped ? 0 : y2 - y;
        // Reverse back
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        return xClipped || yClipped;
    },
    polar: function(coordSysClipArea, layout) {
        var signR = layout.r0 <= layout.r ? 1 : -1;
        // Make sure r is larger than r0
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        var r = $0b120d76f26c920d$var$mathMin(layout.r, coordSysClipArea.r);
        var r0 = $0b120d76f26c920d$var$mathMax(layout.r0, coordSysClipArea.r0);
        layout.r = r;
        layout.r0 = r0;
        var clipped = r - r0 < 0;
        // Reverse back
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        return clipped;
    }
};
var $0b120d76f26c920d$var$elementCreator = {
    cartesian2d: function(seriesModel, data, newIndex, layout, isHorizontal, animationModel, axisModel, isUpdate, roundCap) {
        var rect = new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            shape: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, layout),
            z2: 1
        });
        rect.__dataIndex = newIndex;
        rect.name = "item";
        if (animationModel) {
            var rectShape = rect.shape;
            var animateProperty = isHorizontal ? "height" : "width";
            rectShape[animateProperty] = 0;
        }
        return rect;
    },
    polar: function(seriesModel, data, newIndex, layout, isRadial, animationModel, axisModel, isUpdate, roundCap) {
        var ShapeClass = !isRadial && roundCap ? (0, $9674946a7a7df213$export$2e2bcd8739ae039) : (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039);
        var sector = new ShapeClass({
            shape: layout,
            z2: 1
        });
        sector.name = "item";
        var positionMap = $0b120d76f26c920d$var$createPolarPositionMapping(isRadial);
        sector.calculateTextPosition = (0, $5e4aaa173c31cda6$export$359a1e2d210ed734)(positionMap, {
            isRoundCap: ShapeClass === (0, $9674946a7a7df213$export$2e2bcd8739ae039)
        });
        // Animation
        if (animationModel) {
            var sectorShape = sector.shape;
            var animateProperty = isRadial ? "r" : "endAngle";
            var animateTarget = {};
            sectorShape[animateProperty] = isRadial ? layout.r0 : layout.startAngle;
            animateTarget[animateProperty] = layout[animateProperty];
            (isUpdate ? (0, $8b353638fbedfefa$export$c8dce3c08436e91e) : (0, $8b353638fbedfefa$export$a121566aadcfe021))(sector, {
                shape: animateTarget
            }, animationModel);
        }
        return sector;
    }
};
function $0b120d76f26c920d$var$shouldRealtimeSort(seriesModel, coordSys) {
    var realtimeSortOption = seriesModel.get("realtimeSort", true);
    var baseAxis = coordSys.getBaseAxis();
    if (realtimeSortOption && baseAxis.type === "category" && coordSys.type === "cartesian2d") return {
        baseAxis: baseAxis,
        otherAxis: coordSys.getOtherAxis(baseAxis)
    };
}
function $0b120d76f26c920d$var$updateRealtimeAnimation(realtimeSortCfg, seriesAnimationModel, el, layout, newIndex, isHorizontal, isUpdate, isChangeOrder) {
    var seriesTarget;
    var axisTarget;
    if (isHorizontal) {
        axisTarget = {
            x: layout.x,
            width: layout.width
        };
        seriesTarget = {
            y: layout.y,
            height: layout.height
        };
    } else {
        axisTarget = {
            y: layout.y,
            height: layout.height
        };
        seriesTarget = {
            x: layout.x,
            width: layout.width
        };
    }
    if (!isChangeOrder) // Keep the original growth animation if only axis order changed.
    // Not start a new animation.
    (isUpdate ? (0, $8b353638fbedfefa$export$c8dce3c08436e91e) : (0, $8b353638fbedfefa$export$a121566aadcfe021))(el, {
        shape: seriesTarget
    }, seriesAnimationModel, newIndex, null);
    var axisAnimationModel = seriesAnimationModel ? realtimeSortCfg.baseAxis.model : null;
    (isUpdate ? (0, $8b353638fbedfefa$export$c8dce3c08436e91e) : (0, $8b353638fbedfefa$export$a121566aadcfe021))(el, {
        shape: axisTarget
    }, axisAnimationModel, newIndex);
}
function $0b120d76f26c920d$var$checkPropertiesNotValid(obj, props) {
    for(var i = 0; i < props.length; i++){
        if (!isFinite(obj[props[i]])) return true;
    }
    return false;
}
var $0b120d76f26c920d$var$rectPropties = [
    "x",
    "y",
    "width",
    "height"
];
var $0b120d76f26c920d$var$polarPropties = [
    "cx",
    "cy",
    "r",
    "startAngle",
    "endAngle"
];
var $0b120d76f26c920d$var$isValidLayout = {
    cartesian2d: function(layout) {
        return !$0b120d76f26c920d$var$checkPropertiesNotValid(layout, $0b120d76f26c920d$var$rectPropties);
    },
    polar: function(layout) {
        return !$0b120d76f26c920d$var$checkPropertiesNotValid(layout, $0b120d76f26c920d$var$polarPropties);
    }
};
var $0b120d76f26c920d$var$getLayout = {
    // itemModel is only used to get borderWidth, which is not needed
    // when calculating bar background layout.
    cartesian2d: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        var fixedLineWidth = itemModel ? $0b120d76f26c920d$var$getLineWidth(itemModel, layout) : 0;
        // fix layout with lineWidth
        var signX = layout.width > 0 ? 1 : -1;
        var signY = layout.height > 0 ? 1 : -1;
        return {
            x: layout.x + signX * fixedLineWidth / 2,
            y: layout.y + signY * fixedLineWidth / 2,
            width: layout.width - signX * fixedLineWidth,
            height: layout.height - signY * fixedLineWidth
        };
    },
    polar: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        return {
            cx: layout.cx,
            cy: layout.cy,
            r0: layout.r0,
            r: layout.r,
            startAngle: layout.startAngle,
            endAngle: layout.endAngle,
            clockwise: layout.clockwise
        };
    }
};
function $0b120d76f26c920d$var$isZeroOnPolar(layout) {
    return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
}
function $0b120d76f26c920d$var$createPolarPositionMapping(isRadial) {
    return function(isRadial) {
        var arcOrAngle = isRadial ? "Arc" : "Angle";
        return function(position) {
            switch(position){
                case "start":
                case "insideStart":
                case "end":
                case "insideEnd":
                    return position + arcOrAngle;
                default:
                    return position;
            }
        };
    }(isRadial);
}
function $0b120d76f26c920d$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, isPolar) {
    var style = data.getItemVisual(dataIndex, "style");
    if (!isPolar) {
        var borderRadius = itemModel.get([
            "itemStyle",
            "borderRadius"
        ]) || 0;
        el.setShape("r", borderRadius);
    } else if (!seriesModel.get("roundCap")) {
        var sectorShape = el.shape;
        var cornerRadius = (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel("itemStyle"), sectorShape, true);
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(sectorShape, cornerRadius);
        el.setShape(sectorShape);
    }
    el.useStyle(style);
    var cursorStyle = itemModel.getShallow("cursor");
    cursorStyle && el.attr("cursor", cursorStyle);
    var labelPositionOutside = isPolar ? isHorizontalOrRadial ? layout.r >= layout.r0 ? "endArc" : "startArc" : layout.endAngle >= layout.startAngle ? "endAngle" : "startAngle" : isHorizontalOrRadial ? layout.height >= 0 ? "bottom" : "top" : layout.width >= 0 ? "right" : "left";
    var labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel);
    (0, $6800dfcb6e1e2a44$export$9a13992917966657)(el, labelStatesModels, {
        labelFetcher: seriesModel,
        labelDataIndex: dataIndex,
        defaultText: (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(seriesModel.getData(), dataIndex),
        inheritColor: style.fill,
        defaultOpacity: style.opacity,
        defaultOutsidePosition: labelPositionOutside
    });
    var label = el.getTextContent();
    if (isPolar && label) {
        var position = itemModel.get([
            "label",
            "position"
        ]);
        el.textConfig.inside = position === "middle" ? true : null;
        (0, $5e4aaa173c31cda6$export$672ce504c0db395a)(el, position === "outside" ? labelPositionOutside : position, $0b120d76f26c920d$var$createPolarPositionMapping(isHorizontalOrRadial), itemModel.get([
            "label",
            "rotate"
        ]));
    }
    (0, $6800dfcb6e1e2a44$export$7bdbceaf9ab378f2)(label, labelStatesModels, seriesModel.getRawValue(dataIndex), function(value) {
        return (0, $b2475f850d3c0bc2$export$5f84815e91ca6775)(data, value);
    });
    var emphasisModel = itemModel.getModel([
        "emphasis"
    ]);
    (0, $2bf82c0980125b62$export$e51187539ff11209)(el, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(el, itemModel);
    if ($0b120d76f26c920d$var$isZeroOnPolar(layout)) {
        el.style.fill = "none";
        el.style.stroke = "none";
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(el.states, function(state) {
            if (state.style) state.style.fill = state.style.stroke = "none";
        });
    }
}
// In case width or height are too small.
function $0b120d76f26c920d$var$getLineWidth(itemModel, rawLayout) {
    // Has no border.
    var borderColor = itemModel.get([
        "itemStyle",
        "borderColor"
    ]);
    if (!borderColor || borderColor === "none") return 0;
    var lineWidth = itemModel.get([
        "itemStyle",
        "borderWidth"
    ]) || 0;
    // width or height may be NaN for empty data
    var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
    var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
    return Math.min(lineWidth, width, height);
}
var $0b120d76f26c920d$var$LagePathShape = /** @class */ function() {
    function LagePathShape() {}
    return LagePathShape;
}();
var $0b120d76f26c920d$var$LargePath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LargePath, _super);
    function LargePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "largeBar";
        return _this;
    }
    LargePath.prototype.getDefaultShape = function() {
        return new $0b120d76f26c920d$var$LagePathShape();
    };
    LargePath.prototype.buildPath = function(ctx, shape) {
        // Drawing lines is more efficient than drawing
        // a whole line or drawing rects.
        var points = shape.points;
        var baseDimIdx = this.baseDimIdx;
        var valueDimIdx = 1 - this.baseDimIdx;
        var startPoint = [];
        var size = [];
        var barWidth = this.barWidth;
        for(var i = 0; i < points.length; i += 3){
            size[baseDimIdx] = barWidth;
            size[valueDimIdx] = points[i + 2];
            startPoint[baseDimIdx] = points[i + baseDimIdx];
            startPoint[valueDimIdx] = points[i + valueDimIdx];
            ctx.rect(startPoint[0], startPoint[1], size[0], size[1]);
        }
    };
    return LargePath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $0b120d76f26c920d$var$createLarge(seriesModel, group, progressiveEls, incremental) {
    // TODO support polar
    var data = seriesModel.getData();
    var baseDimIdx = data.getLayout("valueAxisHorizontal") ? 1 : 0;
    var largeDataIndices = data.getLayout("largeDataIndices");
    var barWidth = data.getLayout("size");
    var backgroundModel = seriesModel.getModel("backgroundStyle");
    var bgPoints = data.getLayout("largeBackgroundPoints");
    if (bgPoints) {
        var bgEl = new $0b120d76f26c920d$var$LargePath({
            shape: {
                points: bgPoints
            },
            incremental: !!incremental,
            silent: true,
            z2: 0
        });
        bgEl.baseDimIdx = baseDimIdx;
        bgEl.largeDataIndices = largeDataIndices;
        bgEl.barWidth = barWidth;
        bgEl.useStyle(backgroundModel.getItemStyle());
        group.add(bgEl);
        progressiveEls && progressiveEls.push(bgEl);
    }
    var el = new $0b120d76f26c920d$var$LargePath({
        shape: {
            points: data.getLayout("largePoints")
        },
        incremental: !!incremental,
        ignoreCoarsePointer: true,
        z2: 1
    });
    el.baseDimIdx = baseDimIdx;
    el.largeDataIndices = largeDataIndices;
    el.barWidth = barWidth;
    group.add(el);
    el.useStyle(data.getVisual("style"));
    // Enable tooltip and user mouse/touch event handlers.
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).seriesIndex = seriesModel.seriesIndex;
    if (!seriesModel.get("silent")) {
        el.on("mousedown", $0b120d76f26c920d$var$largePathUpdateDataIndex);
        el.on("mousemove", $0b120d76f26c920d$var$largePathUpdateDataIndex);
    }
    progressiveEls && progressiveEls.push(el);
}
// Use throttle to avoid frequently traverse to find dataIndex.
var $0b120d76f26c920d$var$largePathUpdateDataIndex = (0, $c98659a9437a3d2e$export$de363e709c412c8a)(function(event) {
    var largePath = this;
    var dataIndex = $0b120d76f26c920d$var$largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(largePath).dataIndex = dataIndex >= 0 ? dataIndex : null;
}, 30, false);
function $0b120d76f26c920d$var$largePathFindDataIndex(largePath, x, y) {
    var baseDimIdx = largePath.baseDimIdx;
    var valueDimIdx = 1 - baseDimIdx;
    var points = largePath.shape.points;
    var largeDataIndices = largePath.largeDataIndices;
    var startPoint = [];
    var size = [];
    var barWidth = largePath.barWidth;
    for(var i = 0, len = points.length / 3; i < len; i++){
        var ii = i * 3;
        size[baseDimIdx] = barWidth;
        size[valueDimIdx] = points[ii + 2];
        startPoint[baseDimIdx] = points[ii + baseDimIdx];
        startPoint[valueDimIdx] = points[ii + valueDimIdx];
        if (size[valueDimIdx] < 0) {
            startPoint[valueDimIdx] += size[valueDimIdx];
            size[valueDimIdx] = -size[valueDimIdx];
        }
        if (x >= startPoint[0] && x <= startPoint[0] + size[0] && y >= startPoint[1] && y <= startPoint[1] + size[1]) return largeDataIndices[i];
    }
    return -1;
}
function $0b120d76f26c920d$var$createBackgroundShape(isHorizontalOrRadial, layout, coord) {
    if ((0, $3fea949f0512eb55$export$8567506e6336616)(coord, "cartesian2d")) {
        var rectShape = layout;
        var coordLayout = coord.getArea();
        return {
            x: isHorizontalOrRadial ? rectShape.x : coordLayout.x,
            y: isHorizontalOrRadial ? coordLayout.y : rectShape.y,
            width: isHorizontalOrRadial ? rectShape.width : coordLayout.width,
            height: isHorizontalOrRadial ? coordLayout.height : rectShape.height
        };
    } else {
        var coordLayout = coord.getArea();
        var sectorShape = layout;
        return {
            cx: coordLayout.cx,
            cy: coordLayout.cy,
            r0: isHorizontalOrRadial ? coordLayout.r0 : sectorShape.r0,
            r: isHorizontalOrRadial ? coordLayout.r : sectorShape.r,
            startAngle: isHorizontalOrRadial ? sectorShape.startAngle : 0,
            endAngle: isHorizontalOrRadial ? sectorShape.endAngle : Math.PI * 2
        };
    }
}
function $0b120d76f26c920d$var$createBackgroundEl(coord, isHorizontalOrRadial, layout) {
    var ElementClz = coord.type === "polar" ? (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039) : (0, $419e5ff2f303755e$export$2e2bcd8739ae039);
    return new ElementClz({
        shape: $0b120d76f26c920d$var$createBackgroundShape(isHorizontalOrRadial, layout, coord),
        silent: true,
        z2: 0
    });
}
var $0b120d76f26c920d$export$2e2bcd8739ae039 = $0b120d76f26c920d$var$BarView;


function $4bb56d1f08552ff4$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $0b120d76f26c920d$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $1db8e2e676cae702$export$2e2bcd8739ae039));
    registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $361c48dd900de28f$export$b3219800bda33a1f), "bar"));
    // Do layout after other overall layout, which can prepare some information.
    registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, (0, $361c48dd900de28f$export$16e8685758531cb6)("bar"));
    // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $3a37e5b80322a871$export$2e2bcd8739ae039)("bar"));
    /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */ registers.registerAction({
        type: "changeAxisOrder",
        event: "changeAxisOrder",
        update: "update"
    }, function(payload, ecModel) {
        var componentType = payload.componentType || "series";
        ecModel.eachComponent({
            mainType: componentType,
            query: payload
        }, function(componentModel) {
            if (payload.sortInfo) componentModel.axis.setCategorySortInfo(payload.sortInfo);
        });
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $7e5c3511527c9907$export$2e2bcd8739ae039(seriesModel, opt, nameList) {
    opt = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(opt) && {
        coordDimensions: opt
    } || (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
        encodeDefine: seriesModel.getEncode()
    }, opt);
    var source = seriesModel.getSource();
    var dimensions = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(source, opt).dimensions;
    var list = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dimensions, seriesModel);
    list.initData(source, nameList);
    return list;
}





var $29bc1fc21a5243a6$export$ccfed902f8630510 = /** @class */ function() {
    function WhiskerBoxCommonMixin() {}
    /**
   * @override
   */ WhiskerBoxCommonMixin.prototype.getInitialData = function(option, ecModel) {
        // When both types of xAxis and yAxis are 'value', layout is
        // needed to be specified by user. Otherwise, layout can be
        // judged by which axis is category.
        var ordinalMeta;
        var xAxisModel = ecModel.getComponent("xAxis", this.get("xAxisIndex"));
        var yAxisModel = ecModel.getComponent("yAxis", this.get("yAxisIndex"));
        var xAxisType = xAxisModel.get("type");
        var yAxisType = yAxisModel.get("type");
        var addOrdinal;
        // FIXME
        // Consider time axis.
        if (xAxisType === "category") {
            option.layout = "horizontal";
            ordinalMeta = xAxisModel.getOrdinalMeta();
            addOrdinal = true;
        } else if (yAxisType === "category") {
            option.layout = "vertical";
            ordinalMeta = yAxisModel.getOrdinalMeta();
            addOrdinal = true;
        } else option.layout = option.layout || "horizontal";
        var coordDims = [
            "x",
            "y"
        ];
        var baseAxisDimIndex = option.layout === "horizontal" ? 0 : 1;
        var baseAxisDim = this._baseAxisDim = coordDims[baseAxisDimIndex];
        var otherAxisDim = coordDims[1 - baseAxisDimIndex];
        var axisModels = [
            xAxisModel,
            yAxisModel
        ];
        var baseAxisType = axisModels[baseAxisDimIndex].get("type");
        var otherAxisType = axisModels[1 - baseAxisDimIndex].get("type");
        var data = option.data;
        // Clone a new data for next setOption({}) usage.
        // Avoid modifying current data will affect further update.
        if (data && addOrdinal) {
            var newOptionData_1 = [];
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(item, index) {
                var newItem;
                if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(item)) {
                    newItem = item.slice();
                    // Modify current using data.
                    item.unshift(index);
                } else if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(item.value)) {
                    newItem = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, item);
                    newItem.value = newItem.value.slice();
                    // Modify current using data.
                    item.value.unshift(index);
                } else newItem = item;
                newOptionData_1.push(newItem);
            });
            option.data = newOptionData_1;
        }
        var defaultValueDimensions = this.defaultValueDimensions;
        var coordDimensions = [
            {
                name: baseAxisDim,
                type: (0, $18085de91ae59d03$export$af1622903e71278e)(baseAxisType),
                ordinalMeta: ordinalMeta,
                otherDims: {
                    tooltip: false,
                    itemName: 0
                },
                dimsDef: [
                    "base"
                ]
            },
            {
                name: otherAxisDim,
                type: (0, $18085de91ae59d03$export$af1622903e71278e)(otherAxisType),
                dimsDef: defaultValueDimensions.slice()
            }
        ];
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            coordDimensions: coordDimensions,
            dimensionsCount: defaultValueDimensions.length + 1,
            encodeDefaulter: $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$37682b8fdd2e83d), coordDimensions, this)
        });
    };
    /**
   * If horizontal, base axis is x, otherwise y.
   * @override
   */ WhiskerBoxCommonMixin.prototype.getBaseAxis = function() {
        var dim = this._baseAxisDim;
        return this.ecModel.getComponent(dim + "Axis", this.get(dim + "AxisIndex")).axis;
    };
    return WhiskerBoxCommonMixin;
}();



var $de6da9192b0ee4cb$var$BoxplotSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BoxplotSeriesModel, _super);
    function BoxplotSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BoxplotSeriesModel.type;
        // TODO
        // box width represents group size, so dimension should have 'size'.
        /**
     * @see <https://en.wikipedia.org/wiki/Box_plot>
     * The meanings of 'min' and 'max' depend on user,
     * and echarts do not need to know it.
     * @readOnly
     */ _this.defaultValueDimensions = [
            {
                name: "min",
                defaultTooltip: true
            },
            {
                name: "Q1",
                defaultTooltip: true
            },
            {
                name: "median",
                defaultTooltip: true
            },
            {
                name: "Q3",
                defaultTooltip: true
            },
            {
                name: "max",
                defaultTooltip: true
            }
        ];
        _this.visualDrawType = "stroke";
        return _this;
    }
    BoxplotSeriesModel.type = "series.boxplot";
    BoxplotSeriesModel.dependencies = [
        "xAxis",
        "yAxis",
        "grid"
    ];
    BoxplotSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "cartesian2d",
        legendHoverLink: true,
        layout: null,
        boxWidth: [
            7,
            50
        ],
        itemStyle: {
            color: "#fff",
            borderWidth: 1
        },
        emphasis: {
            scale: true,
            itemStyle: {
                borderWidth: 2,
                shadowBlur: 5,
                shadowOffsetX: 1,
                shadowOffsetY: 1,
                shadowColor: "rgba(0,0,0,0.2)"
            }
        },
        animationDuration: 800
    };
    return BoxplotSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($de6da9192b0ee4cb$var$BoxplotSeriesModel, (0, $29bc1fc21a5243a6$export$ccfed902f8630510), true);
var $de6da9192b0ee4cb$export$2e2bcd8739ae039 = $de6da9192b0ee4cb$var$BoxplotSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $4f6c4593265afb0c$var$BoxplotView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BoxplotView, _super);
    function BoxplotView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BoxplotView.type;
        return _this;
    }
    BoxplotView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var group = this.group;
        var oldData = this._data;
        // There is no old data only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!this._data) group.removeAll();
        var constDim = seriesModel.get("layout") === "horizontal" ? 1 : 0;
        data.diff(oldData).add(function(newIdx) {
            if (data.hasValue(newIdx)) {
                var itemLayout = data.getItemLayout(newIdx);
                var symbolEl = $4f6c4593265afb0c$var$createNormalBox(itemLayout, data, newIdx, constDim, true);
                data.setItemGraphicEl(newIdx, symbolEl);
                group.add(symbolEl);
            }
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            // Empty data
            if (!data.hasValue(newIdx)) {
                group.remove(symbolEl);
                return;
            }
            var itemLayout = data.getItemLayout(newIdx);
            if (!symbolEl) symbolEl = $4f6c4593265afb0c$var$createNormalBox(itemLayout, data, newIdx, constDim);
            else {
                (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(symbolEl);
                $4f6c4593265afb0c$var$updateNormalBoxData(itemLayout, symbolEl, data, newIdx);
            }
            group.add(symbolEl);
            data.setItemGraphicEl(newIdx, symbolEl);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && group.remove(el);
        }).execute();
        this._data = data;
    };
    BoxplotView.prototype.remove = function(ecModel) {
        var group = this.group;
        var data = this._data;
        this._data = null;
        data && data.eachItemGraphicEl(function(el) {
            el && group.remove(el);
        });
    };
    BoxplotView.type = "boxplot";
    return BoxplotView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $4f6c4593265afb0c$var$BoxPathShape = /** @class */ function() {
    function BoxPathShape() {}
    return BoxPathShape;
}();
var $4f6c4593265afb0c$var$BoxPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BoxPath, _super);
    function BoxPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "boxplotBoxPath";
        return _this;
    }
    BoxPath.prototype.getDefaultShape = function() {
        return new $4f6c4593265afb0c$var$BoxPathShape();
    };
    BoxPath.prototype.buildPath = function(ctx, shape) {
        var ends = shape.points;
        var i = 0;
        ctx.moveTo(ends[i][0], ends[i][1]);
        i++;
        for(; i < 4; i++)ctx.lineTo(ends[i][0], ends[i][1]);
        ctx.closePath();
        for(; i < ends.length; i++){
            ctx.moveTo(ends[i][0], ends[i][1]);
            i++;
            ctx.lineTo(ends[i][0], ends[i][1]);
        }
    };
    return BoxPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $4f6c4593265afb0c$var$createNormalBox(itemLayout, data, dataIndex, constDim, isInit) {
    var ends = itemLayout.ends;
    var el = new $4f6c4593265afb0c$var$BoxPath({
        shape: {
            points: isInit ? $4f6c4593265afb0c$var$transInit(ends, constDim, itemLayout) : ends
        }
    });
    $4f6c4593265afb0c$var$updateNormalBoxData(itemLayout, el, data, dataIndex, isInit);
    return el;
}
function $4f6c4593265afb0c$var$updateNormalBoxData(itemLayout, el, data, dataIndex, isInit) {
    var seriesModel = data.hostModel;
    var updateMethod = $5b455ae6f843ac47$exports[isInit ? "initProps" : "updateProps"];
    updateMethod(el, {
        shape: {
            points: itemLayout.ends
        }
    }, seriesModel, dataIndex);
    el.useStyle(data.getItemVisual(dataIndex, "style"));
    el.style.strokeNoScale = true;
    el.z2 = 100;
    var itemModel = data.getItemModel(dataIndex);
    var emphasisModel = itemModel.getModel("emphasis");
    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(el, itemModel);
    (0, $2bf82c0980125b62$export$e51187539ff11209)(el, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
}
function $4f6c4593265afb0c$var$transInit(points, dim, itemLayout) {
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(points, function(point) {
        point = point.slice();
        point[dim] = itemLayout.initBaseline;
        return point;
    });
}
var $4f6c4593265afb0c$export$2e2bcd8739ae039 = $4f6c4593265afb0c$var$BoxplotView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $aa15a3e67343392c$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
function $aa15a3e67343392c$export$2e2bcd8739ae039(ecModel) {
    var groupResult = $aa15a3e67343392c$var$groupSeriesByAxis(ecModel);
    $aa15a3e67343392c$var$each(groupResult, function(groupItem) {
        var seriesModels = groupItem.seriesModels;
        if (!seriesModels.length) return;
        $aa15a3e67343392c$var$calculateBase(groupItem);
        $aa15a3e67343392c$var$each(seriesModels, function(seriesModel, idx) {
            $aa15a3e67343392c$var$layoutSingleSeries(seriesModel, groupItem.boxOffsetList[idx], groupItem.boxWidthList[idx]);
        });
    });
}
/**
 * Group series by axis.
 */ function $aa15a3e67343392c$var$groupSeriesByAxis(ecModel) {
    var result = [];
    var axisList = [];
    ecModel.eachSeriesByType("boxplot", function(seriesModel) {
        var baseAxis = seriesModel.getBaseAxis();
        var idx = $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(axisList, baseAxis);
        if (idx < 0) {
            idx = axisList.length;
            axisList[idx] = baseAxis;
            result[idx] = {
                axis: baseAxis,
                seriesModels: []
            };
        }
        result[idx].seriesModels.push(seriesModel);
    });
    return result;
}
/**
 * Calculate offset and box width for each series.
 */ function $aa15a3e67343392c$var$calculateBase(groupItem) {
    var baseAxis = groupItem.axis;
    var seriesModels = groupItem.seriesModels;
    var seriesCount = seriesModels.length;
    var boxWidthList = groupItem.boxWidthList = [];
    var boxOffsetList = groupItem.boxOffsetList = [];
    var boundList = [];
    var bandWidth;
    if (baseAxis.type === "category") bandWidth = baseAxis.getBandWidth();
    else {
        var maxDataCount_1 = 0;
        $aa15a3e67343392c$var$each(seriesModels, function(seriesModel) {
            maxDataCount_1 = Math.max(maxDataCount_1, seriesModel.getData().count());
        });
        var extent = baseAxis.getExtent();
        bandWidth = Math.abs(extent[1] - extent[0]) / maxDataCount_1;
    }
    $aa15a3e67343392c$var$each(seriesModels, function(seriesModel) {
        var boxWidthBound = seriesModel.get("boxWidth");
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(boxWidthBound)) boxWidthBound = [
            boxWidthBound,
            boxWidthBound
        ];
        boundList.push([
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(boxWidthBound[0], bandWidth) || 0,
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(boxWidthBound[1], bandWidth) || 0
        ]);
    });
    var availableWidth = bandWidth * 0.8 - 2;
    var boxGap = availableWidth / seriesCount * 0.3;
    var boxWidth = (availableWidth - boxGap * (seriesCount - 1)) / seriesCount;
    var base = boxWidth / 2 - availableWidth / 2;
    $aa15a3e67343392c$var$each(seriesModels, function(seriesModel, idx) {
        boxOffsetList.push(base);
        base += boxGap + boxWidth;
        boxWidthList.push(Math.min(Math.max(boxWidth, boundList[idx][0]), boundList[idx][1]));
    });
}
/**
 * Calculate points location for each series.
 */ function $aa15a3e67343392c$var$layoutSingleSeries(seriesModel, offset, boxWidth) {
    var coordSys = seriesModel.coordinateSystem;
    var data = seriesModel.getData();
    var halfWidth = boxWidth / 2;
    var cDimIdx = seriesModel.get("layout") === "horizontal" ? 0 : 1;
    var vDimIdx = 1 - cDimIdx;
    var coordDims = [
        "x",
        "y"
    ];
    var cDim = data.mapDimension(coordDims[cDimIdx]);
    var vDims = data.mapDimensionsAll(coordDims[vDimIdx]);
    if (cDim == null || vDims.length < 5) return;
    for(var dataIndex = 0; dataIndex < data.count(); dataIndex++){
        var axisDimVal = data.get(cDim, dataIndex);
        var median = getPoint(axisDimVal, vDims[2], dataIndex);
        var end1 = getPoint(axisDimVal, vDims[0], dataIndex);
        var end2 = getPoint(axisDimVal, vDims[1], dataIndex);
        var end4 = getPoint(axisDimVal, vDims[3], dataIndex);
        var end5 = getPoint(axisDimVal, vDims[4], dataIndex);
        var ends = [];
        addBodyEnd(ends, end2, false);
        addBodyEnd(ends, end4, true);
        ends.push(end1, end2, end5, end4);
        layEndLine(ends, end1);
        layEndLine(ends, end5);
        layEndLine(ends, median);
        data.setItemLayout(dataIndex, {
            initBaseline: median[vDimIdx],
            ends: ends
        });
    }
    function getPoint(axisDimVal, dim, dataIndex) {
        var val = data.get(dim, dataIndex);
        var p = [];
        p[cDimIdx] = axisDimVal;
        p[vDimIdx] = val;
        var point;
        if (isNaN(axisDimVal) || isNaN(val)) point = [
            NaN,
            NaN
        ];
        else {
            point = coordSys.dataToPoint(p);
            point[cDimIdx] += offset;
        }
        return point;
    }
    function addBodyEnd(ends, point, start) {
        var point1 = point.slice();
        var point2 = point.slice();
        point1[cDimIdx] += halfWidth;
        point2[cDimIdx] -= halfWidth;
        start ? ends.push(point1, point2) : ends.push(point2, point1);
    }
    function layEndLine(ends, endCenter) {
        var from = endCenter.slice();
        var to = endCenter.slice();
        from[cDimIdx] -= halfWidth;
        to[cDimIdx] += halfWidth;
        ends.push(from, to);
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $a9247e275753b379$export$2e2bcd8739ae039(rawData, opt) {
    opt = opt || {};
    var boxData = [];
    var outliers = [];
    var boundIQR = opt.boundIQR;
    var useExtreme = boundIQR === "none" || boundIQR === 0;
    for(var i = 0; i < rawData.length; i++){
        var ascList = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)(rawData[i].slice());
        var Q1 = (0, $cfc1f3b422a3185f$export$651fb4afdb6caa4b)(ascList, 0.25);
        var Q2 = (0, $cfc1f3b422a3185f$export$651fb4afdb6caa4b)(ascList, 0.5);
        var Q3 = (0, $cfc1f3b422a3185f$export$651fb4afdb6caa4b)(ascList, 0.75);
        var min = ascList[0];
        var max = ascList[ascList.length - 1];
        var bound = (boundIQR == null ? 1.5 : boundIQR) * (Q3 - Q1);
        var low = useExtreme ? min : Math.max(min, Q1 - bound);
        var high = useExtreme ? max : Math.min(max, Q3 + bound);
        var itemNameFormatter = opt.itemNameFormatter;
        var itemName = (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(itemNameFormatter) ? itemNameFormatter({
            value: i
        }) : (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(itemNameFormatter) ? itemNameFormatter.replace("{value}", i + "") : i + "";
        boxData.push([
            itemName,
            low,
            Q1,
            Q2,
            Q3,
            high
        ]);
        for(var j = 0; j < ascList.length; j++){
            var dataItem = ascList[j];
            if (dataItem < low || dataItem > high) {
                var outlier = [
                    itemName,
                    dataItem
                ];
                outliers.push(outlier);
            }
        }
    }
    return {
        boxData: boxData,
        outliers: outliers
    };
}




var $9203fc6e2b112614$export$e0915fae26dedefc = {
    type: "echarts:boxplot",
    transform: function transform(params) {
        var upstream = params.upstream;
        if (upstream.sourceFormat !== (0, $cab29724515ce2b8$export$fcd62ebf51387903)) {
            var errMsg = "";
            (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        }
        var result = (0, $a9247e275753b379$export$2e2bcd8739ae039)(upstream.getRawData(), params.config);
        return [
            {
                dimensions: [
                    "ItemName",
                    "Low",
                    "Q1",
                    "Q2",
                    "Q3",
                    "High"
                ],
                data: result.boxData
            },
            {
                data: result.outliers
            }
        ];
    }
};


function $0fd6296850ce3099$export$4b3e715f166fdd78(registers) {
    registers.registerSeriesModel((0, $de6da9192b0ee4cb$export$2e2bcd8739ae039));
    registers.registerChartView((0, $4f6c4593265afb0c$export$2e2bcd8739ae039));
    registers.registerLayout((0, $aa15a3e67343392c$export$2e2bcd8739ae039));
    registers.registerTransform((0, $9203fc6e2b112614$export$e0915fae26dedefc));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $74dcd5b9be05016d$var$SKIP_PROPS = [
    "color",
    "borderColor"
];
var $74dcd5b9be05016d$var$CandlestickView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CandlestickView, _super);
    function CandlestickView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CandlestickView.type;
        return _this;
    }
    CandlestickView.prototype.render = function(seriesModel, ecModel, api) {
        // If there is clipPath created in large mode. Remove it.
        this.group.removeClipPath();
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        this._updateDrawMode(seriesModel);
        this._isLargeDraw ? this._renderLarge(seriesModel) : this._renderNormal(seriesModel);
    };
    CandlestickView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        this._clear();
        this._updateDrawMode(seriesModel);
    };
    CandlestickView.prototype.incrementalRender = function(params, seriesModel, ecModel, api) {
        this._progressiveEls = [];
        this._isLargeDraw ? this._incrementalRenderLarge(params, seriesModel) : this._incrementalRenderNormal(params, seriesModel);
    };
    CandlestickView.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    CandlestickView.prototype._updateDrawMode = function(seriesModel) {
        var isLargeDraw = seriesModel.pipelineContext.large;
        if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
            this._isLargeDraw = isLargeDraw;
            this._clear();
        }
    };
    CandlestickView.prototype._renderNormal = function(seriesModel) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        var isSimpleBox = data.getLayout("isSimpleBox");
        var needsClip = seriesModel.get("clip", true);
        var coord = seriesModel.coordinateSystem;
        var clipArea = coord.getArea && coord.getArea();
        // There is no old data only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!this._data) group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            if (data.hasValue(newIdx)) {
                var itemLayout = data.getItemLayout(newIdx);
                if (needsClip && $74dcd5b9be05016d$var$isNormalBoxClipped(clipArea, itemLayout)) return;
                var el = $74dcd5b9be05016d$var$createNormalBox(itemLayout, newIdx, true);
                $8b353638fbedfefa$export$a121566aadcfe021(el, {
                    shape: {
                        points: itemLayout.ends
                    }
                }, seriesModel, newIdx);
                $74dcd5b9be05016d$var$setBoxCommon(el, data, newIdx, isSimpleBox);
                group.add(el);
                data.setItemGraphicEl(newIdx, el);
            }
        }).update(function(newIdx, oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            // Empty data
            if (!data.hasValue(newIdx)) {
                group.remove(el);
                return;
            }
            var itemLayout = data.getItemLayout(newIdx);
            if (needsClip && $74dcd5b9be05016d$var$isNormalBoxClipped(clipArea, itemLayout)) {
                group.remove(el);
                return;
            }
            if (!el) el = $74dcd5b9be05016d$var$createNormalBox(itemLayout, newIdx);
            else {
                $8b353638fbedfefa$export$c8dce3c08436e91e(el, {
                    shape: {
                        points: itemLayout.ends
                    }
                }, seriesModel, newIdx);
                (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(el);
            }
            $74dcd5b9be05016d$var$setBoxCommon(el, data, newIdx, isSimpleBox);
            group.add(el);
            data.setItemGraphicEl(newIdx, el);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && group.remove(el);
        }).execute();
        this._data = data;
    };
    CandlestickView.prototype._renderLarge = function(seriesModel) {
        this._clear();
        $74dcd5b9be05016d$var$createLarge(seriesModel, this.group);
        var clipPath = seriesModel.get("clip", true) ? (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel) : null;
        if (clipPath) this.group.setClipPath(clipPath);
        else this.group.removeClipPath();
    };
    CandlestickView.prototype._incrementalRenderNormal = function(params, seriesModel) {
        var data = seriesModel.getData();
        var isSimpleBox = data.getLayout("isSimpleBox");
        var dataIndex;
        while((dataIndex = params.next()) != null){
            var itemLayout = data.getItemLayout(dataIndex);
            var el = $74dcd5b9be05016d$var$createNormalBox(itemLayout, dataIndex);
            $74dcd5b9be05016d$var$setBoxCommon(el, data, dataIndex, isSimpleBox);
            el.incremental = true;
            this.group.add(el);
            this._progressiveEls.push(el);
        }
    };
    CandlestickView.prototype._incrementalRenderLarge = function(params, seriesModel) {
        $74dcd5b9be05016d$var$createLarge(seriesModel, this.group, this._progressiveEls, true);
    };
    CandlestickView.prototype.remove = function(ecModel) {
        this._clear();
    };
    CandlestickView.prototype._clear = function() {
        this.group.removeAll();
        this._data = null;
    };
    CandlestickView.type = "candlestick";
    return CandlestickView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $74dcd5b9be05016d$var$NormalBoxPathShape = /** @class */ function() {
    function NormalBoxPathShape() {}
    return NormalBoxPathShape;
}();
var $74dcd5b9be05016d$var$NormalBoxPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(NormalBoxPath, _super);
    function NormalBoxPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "normalCandlestickBox";
        return _this;
    }
    NormalBoxPath.prototype.getDefaultShape = function() {
        return new $74dcd5b9be05016d$var$NormalBoxPathShape();
    };
    NormalBoxPath.prototype.buildPath = function(ctx, shape) {
        var ends = shape.points;
        if (this.__simpleBox) {
            ctx.moveTo(ends[4][0], ends[4][1]);
            ctx.lineTo(ends[6][0], ends[6][1]);
        } else {
            ctx.moveTo(ends[0][0], ends[0][1]);
            ctx.lineTo(ends[1][0], ends[1][1]);
            ctx.lineTo(ends[2][0], ends[2][1]);
            ctx.lineTo(ends[3][0], ends[3][1]);
            ctx.closePath();
            ctx.moveTo(ends[4][0], ends[4][1]);
            ctx.lineTo(ends[5][0], ends[5][1]);
            ctx.moveTo(ends[6][0], ends[6][1]);
            ctx.lineTo(ends[7][0], ends[7][1]);
        }
    };
    return NormalBoxPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $74dcd5b9be05016d$var$createNormalBox(itemLayout, dataIndex, isInit) {
    var ends = itemLayout.ends;
    return new $74dcd5b9be05016d$var$NormalBoxPath({
        shape: {
            points: isInit ? $74dcd5b9be05016d$var$transInit(ends, itemLayout) : ends
        },
        z2: 100
    });
}
function $74dcd5b9be05016d$var$isNormalBoxClipped(clipArea, itemLayout) {
    var clipped = true;
    for(var i = 0; i < itemLayout.ends.length; i++)// If any point are in the region.
    if (clipArea.contain(itemLayout.ends[i][0], itemLayout.ends[i][1])) {
        clipped = false;
        break;
    }
    return clipped;
}
function $74dcd5b9be05016d$var$setBoxCommon(el, data, dataIndex, isSimpleBox) {
    var itemModel = data.getItemModel(dataIndex);
    el.useStyle(data.getItemVisual(dataIndex, "style"));
    el.style.strokeNoScale = true;
    el.__simpleBox = isSimpleBox;
    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(el, itemModel);
}
function $74dcd5b9be05016d$var$transInit(points, itemLayout) {
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(points, function(point) {
        point = point.slice();
        point[1] = itemLayout.initBaseline;
        return point;
    });
}
var $74dcd5b9be05016d$var$LargeBoxPathShape = /** @class */ function() {
    function LargeBoxPathShape() {}
    return LargeBoxPathShape;
}();
var $74dcd5b9be05016d$var$LargeBoxPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LargeBoxPath, _super);
    function LargeBoxPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "largeCandlestickBox";
        return _this;
    }
    LargeBoxPath.prototype.getDefaultShape = function() {
        return new $74dcd5b9be05016d$var$LargeBoxPathShape();
    };
    LargeBoxPath.prototype.buildPath = function(ctx, shape) {
        // Drawing lines is more efficient than drawing
        // a whole line or drawing rects.
        var points = shape.points;
        for(var i = 0; i < points.length;)if (this.__sign === points[i++]) {
            var x = points[i++];
            ctx.moveTo(x, points[i++]);
            ctx.lineTo(x, points[i++]);
        } else i += 3;
    };
    return LargeBoxPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
function $74dcd5b9be05016d$var$createLarge(seriesModel, group, progressiveEls, incremental) {
    var data = seriesModel.getData();
    var largePoints = data.getLayout("largePoints");
    var elP = new $74dcd5b9be05016d$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: 1,
        ignoreCoarsePointer: true
    });
    group.add(elP);
    var elN = new $74dcd5b9be05016d$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: -1,
        ignoreCoarsePointer: true
    });
    group.add(elN);
    var elDoji = new $74dcd5b9be05016d$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: 0,
        ignoreCoarsePointer: true
    });
    group.add(elDoji);
    $74dcd5b9be05016d$var$setLargeStyle(1, elP, seriesModel, data);
    $74dcd5b9be05016d$var$setLargeStyle(-1, elN, seriesModel, data);
    $74dcd5b9be05016d$var$setLargeStyle(0, elDoji, seriesModel, data);
    if (incremental) {
        elP.incremental = true;
        elN.incremental = true;
    }
    if (progressiveEls) progressiveEls.push(elP, elN);
}
function $74dcd5b9be05016d$var$setLargeStyle(sign, el, seriesModel, data) {
    // TODO put in visual?
    var borderColor = seriesModel.get([
        "itemStyle",
        sign > 0 ? "borderColor" : "borderColor0"
    ]) || seriesModel.get([
        "itemStyle",
        sign > 0 ? "color" : "color0"
    ]);
    if (sign === 0) borderColor = seriesModel.get([
        "itemStyle",
        "borderColorDoji"
    ]);
    // Color must be excluded.
    // Because symbol provide setColor individually to set fill and stroke
    var itemStyle = seriesModel.getModel("itemStyle").getItemStyle($74dcd5b9be05016d$var$SKIP_PROPS);
    el.useStyle(itemStyle);
    el.style.fill = null;
    el.style.stroke = borderColor;
}
var $74dcd5b9be05016d$export$2e2bcd8739ae039 = $74dcd5b9be05016d$var$CandlestickView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $b79b80243e209954$var$CandlestickSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CandlestickSeriesModel, _super);
    function CandlestickSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CandlestickSeriesModel.type;
        _this.defaultValueDimensions = [
            {
                name: "open",
                defaultTooltip: true
            },
            {
                name: "close",
                defaultTooltip: true
            },
            {
                name: "lowest",
                defaultTooltip: true
            },
            {
                name: "highest",
                defaultTooltip: true
            }
        ];
        return _this;
    }
    /**
   * Get dimension for shadow in dataZoom
   * @return dimension name
   */ CandlestickSeriesModel.prototype.getShadowDim = function() {
        return "open";
    };
    CandlestickSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        var itemLayout = data.getItemLayout(dataIndex);
        return itemLayout && selectors.rect(itemLayout.brushRect);
    };
    CandlestickSeriesModel.type = "series.candlestick";
    CandlestickSeriesModel.dependencies = [
        "xAxis",
        "yAxis",
        "grid"
    ];
    CandlestickSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "cartesian2d",
        legendHoverLink: true,
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        layout: null,
        clip: true,
        itemStyle: {
            color: "#eb5454",
            color0: "#47b262",
            borderColor: "#eb5454",
            borderColor0: "#47b262",
            borderColorDoji: null,
            // borderColor: '#d24040',
            // borderColor0: '#398f4f',
            borderWidth: 1
        },
        emphasis: {
            scale: true,
            itemStyle: {
                borderWidth: 2
            }
        },
        barMaxWidth: null,
        barMinWidth: null,
        barWidth: null,
        large: true,
        largeThreshold: 600,
        progressive: 3e3,
        progressiveThreshold: 1e4,
        progressiveChunkMode: "mod",
        animationEasing: "linear",
        animationDuration: 300
    };
    return CandlestickSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($b79b80243e209954$var$CandlestickSeriesModel, (0, $29bc1fc21a5243a6$export$ccfed902f8630510), true);
var $b79b80243e209954$export$2e2bcd8739ae039 = $b79b80243e209954$var$CandlestickSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $55263b38adc138a7$export$2e2bcd8739ae039(option) {
    if (!option || !$7a1bd9c2710fea0d$export$43bee75e5e14138e(option.series)) return;
    // Translate 'k' to 'candlestick'.
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(option.series, function(seriesItem) {
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(seriesItem) && seriesItem.type === "k") seriesItem.type = "candlestick";
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $f31d4ab399bcabcc$var$positiveBorderColorQuery = [
    "itemStyle",
    "borderColor"
];
var $f31d4ab399bcabcc$var$negativeBorderColorQuery = [
    "itemStyle",
    "borderColor0"
];
var $f31d4ab399bcabcc$var$dojiBorderColorQuery = [
    "itemStyle",
    "borderColorDoji"
];
var $f31d4ab399bcabcc$var$positiveColorQuery = [
    "itemStyle",
    "color"
];
var $f31d4ab399bcabcc$var$negativeColorQuery = [
    "itemStyle",
    "color0"
];
var $f31d4ab399bcabcc$var$candlestickVisual = {
    seriesType: "candlestick",
    plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        function getColor(sign, model) {
            return model.get(sign > 0 ? $f31d4ab399bcabcc$var$positiveColorQuery : $f31d4ab399bcabcc$var$negativeColorQuery);
        }
        function getBorderColor(sign, model) {
            return model.get(sign === 0 ? $f31d4ab399bcabcc$var$dojiBorderColorQuery : sign > 0 ? $f31d4ab399bcabcc$var$positiveBorderColorQuery : $f31d4ab399bcabcc$var$negativeBorderColorQuery);
        }
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var isLargeRender = seriesModel.pipelineContext.large;
        return !isLargeRender && {
            progress: function(params, data) {
                var dataIndex;
                while((dataIndex = params.next()) != null){
                    var itemModel = data.getItemModel(dataIndex);
                    var sign = data.getItemLayout(dataIndex).sign;
                    var style = itemModel.getItemStyle();
                    style.fill = getColor(sign, itemModel);
                    style.stroke = getBorderColor(sign, itemModel) || style.fill;
                    var existsStyle = data.ensureUniqueItemVisual(dataIndex, "style");
                    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
                }
            }
        };
    }
};
var $f31d4ab399bcabcc$export$2e2bcd8739ae039 = $f31d4ab399bcabcc$var$candlestickVisual;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $a4e49046f9f1fd8b$var$candlestickLayout = {
    seriesType: "candlestick",
    plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
    reset: function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var data = seriesModel.getData();
        var candleWidth = $a4e49046f9f1fd8b$var$calculateCandleWidth(seriesModel, data);
        var cDimIdx = 0;
        var vDimIdx = 1;
        var coordDims = [
            "x",
            "y"
        ];
        var cDimI = data.getDimensionIndex(data.mapDimension(coordDims[cDimIdx]));
        var vDimsI = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(data.mapDimensionsAll(coordDims[vDimIdx]), data.getDimensionIndex, data);
        var openDimI = vDimsI[0];
        var closeDimI = vDimsI[1];
        var lowestDimI = vDimsI[2];
        var highestDimI = vDimsI[3];
        data.setLayout({
            candleWidth: candleWidth,
            // The value is experimented visually.
            isSimpleBox: candleWidth <= 1.3
        });
        if (cDimI < 0 || vDimsI.length < 4) return;
        return {
            progress: seriesModel.pipelineContext.large ? largeProgress : normalProgress
        };
        function normalProgress(params, data) {
            var dataIndex;
            var store = data.getStore();
            while((dataIndex = params.next()) != null){
                var axisDimVal = store.get(cDimI, dataIndex);
                var openVal = store.get(openDimI, dataIndex);
                var closeVal = store.get(closeDimI, dataIndex);
                var lowestVal = store.get(lowestDimI, dataIndex);
                var highestVal = store.get(highestDimI, dataIndex);
                var ocLow = Math.min(openVal, closeVal);
                var ocHigh = Math.max(openVal, closeVal);
                var ocLowPoint = getPoint(ocLow, axisDimVal);
                var ocHighPoint = getPoint(ocHigh, axisDimVal);
                var lowestPoint = getPoint(lowestVal, axisDimVal);
                var highestPoint = getPoint(highestVal, axisDimVal);
                var ends = [];
                addBodyEnd(ends, ocHighPoint, 0);
                addBodyEnd(ends, ocLowPoint, 1);
                ends.push(subPixelOptimizePoint(highestPoint), subPixelOptimizePoint(ocHighPoint), subPixelOptimizePoint(lowestPoint), subPixelOptimizePoint(ocLowPoint));
                var itemModel = data.getItemModel(dataIndex);
                var hasDojiColor = !!itemModel.get([
                    "itemStyle",
                    "borderColorDoji"
                ]);
                data.setItemLayout(dataIndex, {
                    sign: $a4e49046f9f1fd8b$var$getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor),
                    initBaseline: openVal > closeVal ? ocHighPoint[vDimIdx] : ocLowPoint[vDimIdx],
                    ends: ends,
                    brushRect: makeBrushRect(lowestVal, highestVal, axisDimVal)
                });
            }
            function getPoint(val, axisDimVal) {
                var p = [];
                p[cDimIdx] = axisDimVal;
                p[vDimIdx] = val;
                return isNaN(axisDimVal) || isNaN(val) ? [
                    NaN,
                    NaN
                ] : coordSys.dataToPoint(p);
            }
            function addBodyEnd(ends, point, start) {
                var point1 = point.slice();
                var point2 = point.slice();
                point1[cDimIdx] = (0, $5b455ae6f843ac47$export$72c4fd4c1b8fcb10)(point1[cDimIdx] + candleWidth / 2, 1, false);
                point2[cDimIdx] = (0, $5b455ae6f843ac47$export$72c4fd4c1b8fcb10)(point2[cDimIdx] - candleWidth / 2, 1, true);
                start ? ends.push(point1, point2) : ends.push(point2, point1);
            }
            function makeBrushRect(lowestVal, highestVal, axisDimVal) {
                var pmin = getPoint(lowestVal, axisDimVal);
                var pmax = getPoint(highestVal, axisDimVal);
                pmin[cDimIdx] -= candleWidth / 2;
                pmax[cDimIdx] -= candleWidth / 2;
                return {
                    x: pmin[0],
                    y: pmin[1],
                    width: vDimIdx ? candleWidth : pmax[0] - pmin[0],
                    height: vDimIdx ? pmax[1] - pmin[1] : candleWidth
                };
            }
            function subPixelOptimizePoint(point) {
                point[cDimIdx] = (0, $5b455ae6f843ac47$export$72c4fd4c1b8fcb10)(point[cDimIdx], 1);
                return point;
            }
        }
        function largeProgress(params, data) {
            // Structure: [sign, x, yhigh, ylow, sign, x, yhigh, ylow, ...]
            var points = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(params.count * 4);
            var offset = 0;
            var point;
            var tmpIn = [];
            var tmpOut = [];
            var dataIndex;
            var store = data.getStore();
            var hasDojiColor = !!seriesModel.get([
                "itemStyle",
                "borderColorDoji"
            ]);
            while((dataIndex = params.next()) != null){
                var axisDimVal = store.get(cDimI, dataIndex);
                var openVal = store.get(openDimI, dataIndex);
                var closeVal = store.get(closeDimI, dataIndex);
                var lowestVal = store.get(lowestDimI, dataIndex);
                var highestVal = store.get(highestDimI, dataIndex);
                if (isNaN(axisDimVal) || isNaN(lowestVal) || isNaN(highestVal)) {
                    points[offset++] = NaN;
                    offset += 3;
                    continue;
                }
                points[offset++] = $a4e49046f9f1fd8b$var$getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor);
                tmpIn[cDimIdx] = axisDimVal;
                tmpIn[vDimIdx] = lowestVal;
                point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                points[offset++] = point ? point[0] : NaN;
                points[offset++] = point ? point[1] : NaN;
                tmpIn[vDimIdx] = highestVal;
                point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                points[offset++] = point ? point[1] : NaN;
            }
            data.setLayout("largePoints", points);
        }
    }
};
/**
 * Get the sign of a single data.
 *
 * @returns 0 for doji with hasDojiColor: true,
 *          1 for positive,
 *          -1 for negative.
 */ function $a4e49046f9f1fd8b$var$getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor) {
    var sign;
    if (openVal > closeVal) sign = -1;
    else if (openVal < closeVal) sign = 1;
    else sign = hasDojiColor ? 0 : dataIndex > 0 ? store.get(closeDimI, dataIndex - 1) <= closeVal ? 1 : -1 : 1;
    return sign;
}
function $a4e49046f9f1fd8b$var$calculateCandleWidth(seriesModel, data) {
    var baseAxis = seriesModel.getBaseAxis();
    var extent;
    var bandWidth = baseAxis.type === "category" ? baseAxis.getBandWidth() : (extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / data.count());
    var barMaxWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)((0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(seriesModel.get("barMaxWidth"), bandWidth), bandWidth);
    var barMinWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)((0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(seriesModel.get("barMinWidth"), 1), bandWidth);
    var barWidth = seriesModel.get("barWidth");
    return barWidth != null ? (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(barWidth, bandWidth) : Math.max(Math.min(bandWidth / 2, barMaxWidth), barMinWidth);
}
var $a4e49046f9f1fd8b$export$2e2bcd8739ae039 = $a4e49046f9f1fd8b$var$candlestickLayout;


function $21999577dfdc5807$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $74dcd5b9be05016d$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $b79b80243e209954$export$2e2bcd8739ae039));
    registers.registerPreprocessor((0, $55263b38adc138a7$export$2e2bcd8739ae039));
    registers.registerVisual((0, $f31d4ab399bcabcc$export$2e2bcd8739ae039));
    registers.registerLayout((0, $a4e49046f9f1fd8b$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $fef28dd8967d3f1b$export$84369c8e2229fa7f = {
    color: "fill",
    borderColor: "stroke"
};
var $fef28dd8967d3f1b$export$734d775a14929701 = {
    symbol: 1,
    symbolSize: 1,
    symbolKeepAspect: 1,
    legendIcon: 1,
    visualMeta: 1,
    liftZ: 1,
    decal: 1
};
var $fef28dd8967d3f1b$export$dd5c3cc86073562f = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $fef28dd8967d3f1b$var$CustomSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CustomSeriesModel, _super);
    function CustomSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CustomSeriesModel.type;
        return _this;
    }
    CustomSeriesModel.prototype.optionUpdated = function() {
        this.currentZLevel = this.get("zlevel", true);
        this.currentZ = this.get("z", true);
    };
    CustomSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this);
    };
    CustomSeriesModel.prototype.getDataParams = function(dataIndex, dataType, el) {
        var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);
        el && (params.info = $fef28dd8967d3f1b$export$dd5c3cc86073562f(el).info);
        return params;
    };
    CustomSeriesModel.type = "series.custom";
    CustomSeriesModel.dependencies = [
        "grid",
        "polar",
        "geo",
        "singleAxis",
        "calendar"
    ];
    CustomSeriesModel.defaultOption = {
        coordinateSystem: "cartesian2d",
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        // Custom series will not clip by default.
        // Some case will use custom series to draw label
        // For example https://echarts.apache.org/examples/en/editor.html?c=custom-gantt-flight
        clip: false
    };
    return CustomSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $fef28dd8967d3f1b$export$2e2bcd8739ae039 = $fef28dd8967d3f1b$var$CustomSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $eb5b87553d7c5e15$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    dataItem = dataItem || [
        0,
        0
    ];
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88([
        "x",
        "y"
    ], function(dim, dimIdx) {
        var axis = this.getAxis(dim);
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        return axis.type === "category" ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
    }, this);
}
function $eb5b87553d7c5e15$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.master.getRect();
    return {
        coordSys: {
            // The name exposed to user is always 'cartesian2d' but not 'grid'.
            type: "cartesian2d",
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        api: {
            coord: function(data) {
                // do not provide "out" param
                return coordSys.dataToPoint(data);
            },
            size: $7a1bd9c2710fea0d$export$2385a24977818dd0($eb5b87553d7c5e15$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $db94904ae7a63a7b$var$dataToCoordSize(dataSize, dataItem) {
    dataItem = dataItem || [
        0,
        0
    ];
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88([
        0,
        1
    ], function(dimIdx) {
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        var p1 = [];
        var p2 = [];
        p1[dimIdx] = val - halfSize;
        p2[dimIdx] = val + halfSize;
        p1[1 - dimIdx] = p2[1 - dimIdx] = dataItem[1 - dimIdx];
        return Math.abs(this.dataToPoint(p1)[dimIdx] - this.dataToPoint(p2)[dimIdx]);
    }, this);
}
function $db94904ae7a63a7b$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getBoundingRect();
    return {
        coordSys: {
            type: "geo",
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
            zoom: coordSys.getZoom()
        },
        api: {
            coord: function(data) {
                // do not provide "out" and noRoam param,
                // Compatible with this usage:
                // echarts.util.map(item.points, api.coord)
                return coordSys.dataToPoint(data);
            },
            size: $7a1bd9c2710fea0d$export$2385a24977818dd0($db94904ae7a63a7b$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $4af7f8b40c63338e$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    var axis = this.getAxis();
    var val = dataItem instanceof Array ? dataItem[0] : dataItem;
    var halfSize = (dataSize instanceof Array ? dataSize[0] : dataSize) / 2;
    return axis.type === "category" ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
}
function $4af7f8b40c63338e$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getRect();
    return {
        coordSys: {
            type: "singleAxis",
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        api: {
            coord: function(val) {
                // do not provide "out" param
                return coordSys.dataToPoint(val);
            },
            size: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($4af7f8b40c63338e$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// import AngleAxis from './AngleAxis.js';
function $5542da7477183ee1$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    dataItem = dataItem || [
        0,
        0
    ];
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88([
        "Radius",
        "Angle"
    ], function(dim, dimIdx) {
        var getterName = "get" + dim + "Axis";
        // TODO: TYPE Check Angle Axis
        var axis = this[getterName]();
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        var result = axis.type === "category" ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
        if (dim === "Angle") result = result * Math.PI / 180;
        return result;
    }, this);
}
function $5542da7477183ee1$export$2e2bcd8739ae039(coordSys) {
    var radiusAxis = coordSys.getRadiusAxis();
    var angleAxis = coordSys.getAngleAxis();
    var radius = radiusAxis.getExtent();
    radius[0] > radius[1] && radius.reverse();
    return {
        coordSys: {
            type: "polar",
            cx: coordSys.cx,
            cy: coordSys.cy,
            r: radius[1],
            r0: radius[0]
        },
        api: {
            coord: function(data) {
                var radius = radiusAxis.dataToRadius(data[0]);
                var angle = angleAxis.dataToAngle(data[1]);
                var coord = coordSys.coordToPoint([
                    radius,
                    angle
                ]);
                coord.push(radius, angle * Math.PI / 180);
                return coord;
            },
            size: $7a1bd9c2710fea0d$export$2385a24977818dd0($5542da7477183ee1$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $07a38220d20058fb$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getRect();
    var rangeInfo = coordSys.getRangeInfo();
    return {
        coordSys: {
            type: "calendar",
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
            cellWidth: coordSys.getCellWidth(),
            cellHeight: coordSys.getCellHeight(),
            rangeInfo: {
                start: rangeInfo.start,
                end: rangeInfo.end,
                weeks: rangeInfo.weeks,
                dayCount: rangeInfo.allDay
            }
        },
        api: {
            coord: function(data, clamp) {
                return coordSys.dataToPoint(data, clamp);
            }
        }
    };
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $daa53642c3afcc30$var$deprecatedLogs = {};
function $daa53642c3afcc30$export$3b868abde5eae7d1(style, elType, hasOwnTextContentOption, hasOwnTextConfig) {
    // Since echarts5, `RectText` is separated from its host element and style.text
    // does not exist any more. The compat work brings some extra burden on performance.
    // So we provide:
    // `legacy: true` force make compat.
    // `legacy: false`, force do not compat.
    // `legacy` not set: auto detect whether legacy.
    //     But in this case we do not compat (difficult to detect and rare case):
    //     Becuse custom series and graphic component support "merge", users may firstly
    //     only set `textStrokeWidth` style or secondly only set `text`.
    return style && (style.legacy || style.legacy !== false && !hasOwnTextContentOption && !hasOwnTextConfig && elType !== "tspan" && (elType === "text" || (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(style, "text")));
}
function $daa53642c3afcc30$export$7748133eaaa8aecc(hostStyle, elType, isNormal) {
    var srcStyle = hostStyle;
    var textConfig;
    var textContent;
    var textContentStyle;
    if (elType === "text") textContentStyle = srcStyle;
    else {
        textContentStyle = {};
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "text") && (textContentStyle.text = srcStyle.text);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "rich") && (textContentStyle.rich = srcStyle.rich);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textFill") && (textContentStyle.fill = srcStyle.textFill);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textStroke") && (textContentStyle.stroke = srcStyle.textStroke);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "fontFamily") && (textContentStyle.fontFamily = srcStyle.fontFamily);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "fontSize") && (textContentStyle.fontSize = srcStyle.fontSize);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "fontStyle") && (textContentStyle.fontStyle = srcStyle.fontStyle);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "fontWeight") && (textContentStyle.fontWeight = srcStyle.fontWeight);
        textContent = {
            type: "text",
            style: textContentStyle,
            // ec4 does not support rectText trigger.
            // And when text position is different in normal and emphasis
            // => hover text trigger emphasis;
            // => text position changed, leave mouse pointer immediately;
            // That might cause incorrect state.
            silent: true
        };
        textConfig = {};
        var hasOwnPos = (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textPosition");
        if (isNormal) textConfig.position = hasOwnPos ? srcStyle.textPosition : "inside";
        else hasOwnPos && (textConfig.position = srcStyle.textPosition);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textPosition") && (textConfig.position = srcStyle.textPosition);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textOffset") && (textConfig.offset = srcStyle.textOffset);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textRotation") && (textConfig.rotation = srcStyle.textRotation);
        (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(srcStyle, "textDistance") && (textConfig.distance = srcStyle.textDistance);
    }
    $daa53642c3afcc30$var$convertEC4CompatibleRichItem(textContentStyle, hostStyle);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(textContentStyle.rich, function(richItem) {
        $daa53642c3afcc30$var$convertEC4CompatibleRichItem(richItem, richItem);
    });
    return {
        textConfig: textConfig,
        textContent: textContent
    };
}
/**
 * The result will be set to `out`.
 */ function $daa53642c3afcc30$var$convertEC4CompatibleRichItem(out, richItem) {
    if (!richItem) return;
    // (1) For simplicity, make textXXX properties (deprecated since ec5) has
    // higher priority. For example, consider in ec4 `borderColor: 5, textBorderColor: 10`
    // on a rect means `borderColor: 4` on the rect and `borderColor: 10` on an attached
    // richText in ec5.
    // (2) `out === richItem` if and only if `out` is text el or rich item.
    // So we can overwrite existing props in `out` since textXXX has higher priority.
    richItem.font = richItem.textFont || richItem.font;
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textStrokeWidth") && (out.lineWidth = richItem.textStrokeWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textAlign") && (out.align = richItem.textAlign);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textVerticalAlign") && (out.verticalAlign = richItem.textVerticalAlign);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textLineHeight") && (out.lineHeight = richItem.textLineHeight);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textWidth") && (out.width = richItem.textWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textHeight") && (out.height = richItem.textHeight);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBackgroundColor") && (out.backgroundColor = richItem.textBackgroundColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textPadding") && (out.padding = richItem.textPadding);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBorderColor") && (out.borderColor = richItem.textBorderColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBorderWidth") && (out.borderWidth = richItem.textBorderWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBorderRadius") && (out.borderRadius = richItem.textBorderRadius);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBoxShadowColor") && (out.shadowColor = richItem.textBoxShadowColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBoxShadowBlur") && (out.shadowBlur = richItem.textBoxShadowBlur);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBoxShadowOffsetX") && (out.shadowOffsetX = richItem.textBoxShadowOffsetX);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textBoxShadowOffsetY") && (out.shadowOffsetY = richItem.textBoxShadowOffsetY);
}
function $daa53642c3afcc30$export$b8ddb75bd1b9b791(itemStl, txStl, txCfg) {
    var out = itemStl;
    // See `custom.ts`, a trick to set extra `textPosition` firstly.
    out.textPosition = out.textPosition || txCfg.position || "inside";
    txCfg.offset != null && (out.textOffset = txCfg.offset);
    txCfg.rotation != null && (out.textRotation = txCfg.rotation);
    txCfg.distance != null && (out.textDistance = txCfg.distance);
    var isInside = out.textPosition.indexOf("inside") >= 0;
    var hostFill = itemStl.fill || "#000";
    $daa53642c3afcc30$var$convertToEC4RichItem(out, txStl);
    var textFillNotSet = out.textFill == null;
    if (isInside) {
        if (textFillNotSet) {
            out.textFill = txCfg.insideFill || "#fff";
            !out.textStroke && txCfg.insideStroke && (out.textStroke = txCfg.insideStroke);
            !out.textStroke && (out.textStroke = hostFill);
            out.textStrokeWidth == null && (out.textStrokeWidth = 2);
        }
    } else {
        if (textFillNotSet) out.textFill = itemStl.fill || txCfg.outsideFill || "#000";
        !out.textStroke && txCfg.outsideStroke && (out.textStroke = txCfg.outsideStroke);
    }
    out.text = txStl.text;
    out.rich = txStl.rich;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(txStl.rich, function(richItem) {
        $daa53642c3afcc30$var$convertToEC4RichItem(richItem, richItem);
    });
    return out;
}
function $daa53642c3afcc30$var$convertToEC4RichItem(out, richItem) {
    if (!richItem) return;
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "fill") && (out.textFill = richItem.fill);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "stroke") && (out.textStroke = richItem.fill);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "lineWidth") && (out.textStrokeWidth = richItem.lineWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "font") && (out.font = richItem.font);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "fontStyle") && (out.fontStyle = richItem.fontStyle);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "fontWeight") && (out.fontWeight = richItem.fontWeight);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "fontSize") && (out.fontSize = richItem.fontSize);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "fontFamily") && (out.fontFamily = richItem.fontFamily);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "align") && (out.textAlign = richItem.align);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "verticalAlign") && (out.textVerticalAlign = richItem.verticalAlign);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "lineHeight") && (out.textLineHeight = richItem.lineHeight);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "width") && (out.textWidth = richItem.width);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "height") && (out.textHeight = richItem.height);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "backgroundColor") && (out.textBackgroundColor = richItem.backgroundColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "padding") && (out.textPadding = richItem.padding);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "borderColor") && (out.textBorderColor = richItem.borderColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "borderWidth") && (out.textBorderWidth = richItem.borderWidth);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "borderRadius") && (out.textBorderRadius = richItem.borderRadius);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "shadowColor") && (out.textBoxShadowColor = richItem.shadowColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "shadowBlur") && (out.textBoxShadowBlur = richItem.shadowBlur);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "shadowOffsetX") && (out.textBoxShadowOffsetX = richItem.shadowOffsetX);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "shadowOffsetY") && (out.textBoxShadowOffsetY = richItem.shadowOffsetY);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textShadowColor") && (out.textShadowColor = richItem.textShadowColor);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textShadowBlur") && (out.textShadowBlur = richItem.textShadowBlur);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textShadowOffsetX") && (out.textShadowOffsetX = richItem.textShadowOffsetX);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(richItem, "textShadowOffsetY") && (out.textShadowOffsetY = richItem.textShadowOffsetY);
}
function $daa53642c3afcc30$export$606a5c06d13e04b6(deprecated, insteadApproach) {
    var key;
}





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS_MAP = {
    position: [
        "x",
        "y"
    ],
    scale: [
        "scaleX",
        "scaleY"
    ],
    origin: [
        "originX",
        "originY"
    ]
};
var $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)($7c104376a000308e$var$LEGACY_TRANSFORM_PROPS_MAP);
var $7c104376a000308e$var$TRANSFORM_PROPS_MAP = (0, $7a1bd9c2710fea0d$export$533b26079ad0b4b)((0, $becf2d727f9cf450$export$98ab6203ec3396e2), function(obj, key) {
    obj[key] = 1;
    return obj;
}, {});
var $7c104376a000308e$var$transformPropNamesStr = (0, $becf2d727f9cf450$export$98ab6203ec3396e2).join(", ");
var $7c104376a000308e$export$9a911ad86e905b13 = [
    "",
    "style",
    "shape",
    "extra"
];
var $7c104376a000308e$var$transitionInnerStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $7c104376a000308e$var$getElementAnimationConfig(animationType, el, elOption, parentModel, dataIndex) {
    var animationProp = animationType + "Animation";
    var config = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)(animationType, parentModel, dataIndex) || {};
    var userDuring = $7c104376a000308e$var$transitionInnerStore(el).userDuring;
    // Only set when duration is > 0 and it's need to be animated.
    if (config.duration > 0) {
        // For simplicity, if during not specified, the previous during will not work any more.
        config.during = userDuring ? (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($7c104376a000308e$var$duringCall, {
            el: el,
            userDuring: userDuring
        }) : null;
        config.setToFinal = true;
        config.scope = animationType;
    }
    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(config, elOption[animationProp]);
    return config;
}
function $7c104376a000308e$export$4342b281b9b5d77e(el, elOption, animatableModel, opts) {
    opts = opts || {};
    var dataIndex = opts.dataIndex, isInit = opts.isInit, clearStyle = opts.clearStyle;
    var hasAnimation = animatableModel.isAnimationEnabled();
    // Save the meta info for further morphing. Like apply on the sub morphing elements.
    var store = $7c104376a000308e$var$transitionInnerStore(el);
    var styleOpt = elOption.style;
    store.userDuring = elOption.during;
    var transFromProps = {};
    var propsToSet = {};
    $7c104376a000308e$var$prepareTransformAllPropsFinal(el, elOption, propsToSet);
    $7c104376a000308e$var$prepareShapeOrExtraAllPropsFinal("shape", elOption, propsToSet);
    $7c104376a000308e$var$prepareShapeOrExtraAllPropsFinal("extra", elOption, propsToSet);
    if (!isInit && hasAnimation) {
        $7c104376a000308e$var$prepareTransformTransitionFrom(el, elOption, transFromProps);
        $7c104376a000308e$var$prepareShapeOrExtraTransitionFrom("shape", el, elOption, transFromProps);
        $7c104376a000308e$var$prepareShapeOrExtraTransitionFrom("extra", el, elOption, transFromProps);
        $7c104376a000308e$var$prepareStyleTransitionFrom(el, elOption, styleOpt, transFromProps);
    }
    propsToSet.style = styleOpt;
    $7c104376a000308e$var$applyPropsDirectly(el, propsToSet, clearStyle);
    $7c104376a000308e$var$applyMiscProps(el, elOption);
    if (hasAnimation) {
        if (isInit) {
            var enterFromProps_1 = {};
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($7c104376a000308e$export$9a911ad86e905b13, function(propName) {
                var prop = propName ? elOption[propName] : elOption;
                if (prop && prop.enterFrom) {
                    if (propName) enterFromProps_1[propName] = enterFromProps_1[propName] || {};
                    (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(propName ? enterFromProps_1[propName] : enterFromProps_1, prop.enterFrom);
                }
            });
            var config = $7c104376a000308e$var$getElementAnimationConfig("enter", el, elOption, animatableModel, dataIndex);
            if (config.duration > 0) el.animateFrom(enterFromProps_1, config);
        } else $7c104376a000308e$var$applyPropsTransition(el, elOption, dataIndex || 0, animatableModel, transFromProps);
    }
    // Store leave to be used in leave transition.
    $7c104376a000308e$export$a6f11bb1cb100e2a(el, elOption);
    styleOpt ? el.dirty() : el.markRedraw();
}
function $7c104376a000308e$export$a6f11bb1cb100e2a(el, elOption) {
    // Try merge to previous set leaveTo
    var leaveToProps = $7c104376a000308e$var$transitionInnerStore(el).leaveToProps;
    for(var i = 0; i < $7c104376a000308e$export$9a911ad86e905b13.length; i++){
        var propName = $7c104376a000308e$export$9a911ad86e905b13[i];
        var prop = propName ? elOption[propName] : elOption;
        if (prop && prop.leaveTo) {
            if (!leaveToProps) leaveToProps = $7c104376a000308e$var$transitionInnerStore(el).leaveToProps = {};
            if (propName) leaveToProps[propName] = leaveToProps[propName] || {};
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(propName ? leaveToProps[propName] : leaveToProps, prop.leaveTo);
        }
    }
}
function $7c104376a000308e$export$15575b6d82d35bb3(el, elOption, animatableModel, onRemove) {
    if (el) {
        var parent_1 = el.parent;
        var leaveToProps = $7c104376a000308e$var$transitionInnerStore(el).leaveToProps;
        if (leaveToProps) {
            // TODO TODO use leave after leaveAnimation in series is introduced
            // TODO Data index?
            var config = $7c104376a000308e$var$getElementAnimationConfig("update", el, elOption, animatableModel, 0);
            config.done = function() {
                parent_1.remove(el);
                onRemove && onRemove();
            };
            el.animateTo(leaveToProps, config);
        } else {
            parent_1.remove(el);
            onRemove && onRemove();
        }
    }
}
function $7c104376a000308e$export$6f3361b4b8d7a8ba(transition) {
    return transition === "all";
}
function $7c104376a000308e$var$applyPropsDirectly(el, // Can be null/undefined
allPropsFinal, clearStyle) {
    var styleOpt = allPropsFinal.style;
    if (!el.isGroup && styleOpt) {
        if (clearStyle) {
            el.useStyle({});
            // When style object changed, how to trade the existing animation?
            // It is probably complicated and not needed to cover all the cases.
            // But still need consider the case:
            // (1) When using init animation on `style.opacity`, and before the animation
            //     ended users triggers an update by mousewhel. At that time the init
            //     animation should better be continued rather than terminated.
            //     So after `useStyle` called, we should change the animation target manually
            //     to continue the effect of the init animation.
            // (2) PENDING: If the previous animation targeted at a `val1`, and currently we need
            //     to update the value to `val2` and no animation declared, should be terminate
            //     the previous animation or just modify the target of the animation?
            //     Therotically That will happen not only on `style` but also on `shape` and
            //     `transfrom` props. But we haven't handle this case at present yet.
            // (3) PENDING: Is it proper to visit `animators` and `targetName`?
            var animators = el.animators;
            for(var i = 0; i < animators.length; i++){
                var animator = animators[i];
                // targetName is the "topKey".
                if (animator.targetName === "style") animator.changeTarget(el.style);
            }
        }
        el.setStyle(styleOpt);
    }
    if (allPropsFinal) {
        // Not set style here.
        allPropsFinal.style = null;
        // Set el to the final state firstly.
        allPropsFinal && el.attr(allPropsFinal);
        allPropsFinal.style = styleOpt;
    }
}
function $7c104376a000308e$var$applyPropsTransition(el, elOption, dataIndex, model, // Can be null/undefined
transFromProps) {
    if (transFromProps) {
        var config = $7c104376a000308e$var$getElementAnimationConfig("update", el, elOption, model, dataIndex);
        if (config.duration > 0) el.animateFrom(transFromProps, config);
    }
}
function $7c104376a000308e$var$applyMiscProps(el, elOption) {
    // Merge by default.
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, "silent") && (el.silent = elOption.silent);
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, "ignore") && (el.ignore = elOption.ignore);
    if (el instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, "invisible") && (el.invisible = elOption.invisible);
    if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, "autoBatch") && (el.autoBatch = elOption.autoBatch);
}
// Use it to avoid it be exposed to user.
var $7c104376a000308e$var$tmpDuringScope = {};
var $7c104376a000308e$var$transitionDuringAPI = {
    // Usually other props do not need to be changed in animation during.
    setTransform: function(key, val) {
        $7c104376a000308e$var$tmpDuringScope.el[key] = val;
        return this;
    },
    getTransform: function(key) {
        return $7c104376a000308e$var$tmpDuringScope.el[key];
    },
    setShape: function(key, val) {
        var el = $7c104376a000308e$var$tmpDuringScope.el;
        var shape = el.shape || (el.shape = {});
        shape[key] = val;
        el.dirtyShape && el.dirtyShape();
        return this;
    },
    getShape: function(key) {
        var shape = $7c104376a000308e$var$tmpDuringScope.el.shape;
        if (shape) return shape[key];
    },
    setStyle: function(key, val) {
        var el = $7c104376a000308e$var$tmpDuringScope.el;
        var style = el.style;
        if (style) {
            style[key] = val;
            el.dirtyStyle && el.dirtyStyle();
        }
        return this;
    },
    getStyle: function(key) {
        var style = $7c104376a000308e$var$tmpDuringScope.el.style;
        if (style) return style[key];
    },
    setExtra: function(key, val) {
        var extra = $7c104376a000308e$var$tmpDuringScope.el.extra || ($7c104376a000308e$var$tmpDuringScope.el.extra = {});
        extra[key] = val;
        return this;
    },
    getExtra: function(key) {
        var extra = $7c104376a000308e$var$tmpDuringScope.el.extra;
        if (extra) return extra[key];
    }
};
function $7c104376a000308e$var$assertNotReserved(key) {}
function $7c104376a000308e$var$duringCall() {
    // Do not provide "percent" until some requirements come.
    // Because consider thies case:
    // enterFrom: {x: 100, y: 30}, transition: 'x'.
    // And enter duration is different from update duration.
    // Thus it might be confused about the meaning of "percent" in during callback.
    var scope = this;
    var el = scope.el;
    if (!el) return;
    // If el is remove from zr by reason like legend, during still need to called,
    // because el will be added back to zr and the prop value should not be incorrect.
    var latestUserDuring = $7c104376a000308e$var$transitionInnerStore(el).userDuring;
    var scopeUserDuring = scope.userDuring;
    // Ensured a during is only called once in each animation frame.
    // If a during is called multiple times in one frame, maybe some users' calculation logic
    // might be wrong (not sure whether this usage exists).
    // The case of a during might be called twice can be: by default there is a animator for
    // 'x', 'y' when init. Before the init animation finished, call `setOption` to start
    // another animators for 'style'/'shape'/'extra'.
    if (latestUserDuring !== scopeUserDuring) {
        // release
        scope.el = scope.userDuring = null;
        return;
    }
    $7c104376a000308e$var$tmpDuringScope.el = el;
    // Give no `this` to user in "during" calling.
    scopeUserDuring($7c104376a000308e$var$transitionDuringAPI);
// FIXME: if in future meet the case that some prop will be both modified in `during` and `state`,
// consider the issue that the prop might be incorrect when return to "normal" state.
}
function $7c104376a000308e$var$prepareShapeOrExtraTransitionFrom(mainAttr, fromEl, elOption, transFromProps) {
    var attrOpt = elOption[mainAttr];
    if (!attrOpt) return;
    var elPropsInAttr = fromEl[mainAttr];
    var transFromPropsInAttr;
    if (elPropsInAttr) {
        var transition = elOption.transition;
        var attrTransition = attrOpt.transition;
        if (attrTransition) {
            !transFromPropsInAttr && (transFromPropsInAttr = transFromProps[mainAttr] = {});
            if ($7c104376a000308e$export$6f3361b4b8d7a8ba(attrTransition)) (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(transFromPropsInAttr, elPropsInAttr);
            else {
                var transitionKeys = (0, $76d619f648247e6d$export$4f07b212a02c8051)(attrTransition);
                for(var i = 0; i < transitionKeys.length; i++){
                    var key = transitionKeys[i];
                    var elVal = elPropsInAttr[key];
                    transFromPropsInAttr[key] = elVal;
                }
            }
        } else if ($7c104376a000308e$export$6f3361b4b8d7a8ba(transition) || (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(transition, mainAttr) >= 0) {
            !transFromPropsInAttr && (transFromPropsInAttr = transFromProps[mainAttr] = {});
            var elPropsInAttrKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(elPropsInAttr);
            for(var i = 0; i < elPropsInAttrKeys.length; i++){
                var key = elPropsInAttrKeys[i];
                var elVal = elPropsInAttr[key];
                if ($7c104376a000308e$var$isNonStyleTransitionEnabled(attrOpt[key], elVal)) transFromPropsInAttr[key] = elVal;
            }
        }
    }
}
function $7c104376a000308e$var$prepareShapeOrExtraAllPropsFinal(mainAttr, elOption, allProps) {
    var attrOpt = elOption[mainAttr];
    if (!attrOpt) return;
    var allPropsInAttr = allProps[mainAttr] = {};
    var keysInAttr = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(attrOpt);
    for(var i = 0; i < keysInAttr.length; i++){
        var key = keysInAttr[i];
        // To avoid share one object with different element, and
        // to avoid user modify the object inexpectedly, have to clone.
        allPropsInAttr[key] = (0, $76d8a142a20276fc$export$c5e92b7f105af84e)(attrOpt[key]);
    }
}
function $7c104376a000308e$var$prepareTransformTransitionFrom(el, elOption, transFromProps) {
    var transition = elOption.transition;
    var transitionKeys = $7c104376a000308e$export$6f3361b4b8d7a8ba(transition) ? (0, $becf2d727f9cf450$export$98ab6203ec3396e2) : (0, $76d619f648247e6d$export$4f07b212a02c8051)(transition || []);
    for(var i = 0; i < transitionKeys.length; i++){
        var key = transitionKeys[i];
        if (key === "style" || key === "shape" || key === "extra") continue;
        var elVal = el[key];
        // Do not clone, animator will perform that clone.
        transFromProps[key] = elVal;
    }
}
function $7c104376a000308e$var$prepareTransformAllPropsFinal(el, elOption, allProps) {
    for(var i = 0; i < $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS.length; i++){
        var legacyName = $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS[i];
        var xyName = $7c104376a000308e$var$LEGACY_TRANSFORM_PROPS_MAP[legacyName];
        var legacyArr = elOption[legacyName];
        if (legacyArr) {
            allProps[xyName[0]] = legacyArr[0];
            allProps[xyName[1]] = legacyArr[1];
        }
    }
    for(var i = 0; i < (0, $becf2d727f9cf450$export$98ab6203ec3396e2).length; i++){
        var key = (0, $becf2d727f9cf450$export$98ab6203ec3396e2)[i];
        if (elOption[key] != null) allProps[key] = elOption[key];
    }
}
function $7c104376a000308e$var$prepareStyleTransitionFrom(fromEl, elOption, styleOpt, transFromProps) {
    if (!styleOpt) return;
    var fromElStyle = fromEl.style;
    var transFromStyleProps;
    if (fromElStyle) {
        var styleTransition = styleOpt.transition;
        var elTransition = elOption.transition;
        if (styleTransition && !$7c104376a000308e$export$6f3361b4b8d7a8ba(styleTransition)) {
            var transitionKeys = (0, $76d619f648247e6d$export$4f07b212a02c8051)(styleTransition);
            !transFromStyleProps && (transFromStyleProps = transFromProps.style = {});
            for(var i = 0; i < transitionKeys.length; i++){
                var key = transitionKeys[i];
                var elVal = fromElStyle[key];
                // Do not clone, see `checkNonStyleTansitionRefer`.
                transFromStyleProps[key] = elVal;
            }
        } else if (fromEl.getAnimationStyleProps && ($7c104376a000308e$export$6f3361b4b8d7a8ba(elTransition) || $7c104376a000308e$export$6f3361b4b8d7a8ba(styleTransition) || (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(elTransition, "style") >= 0)) {
            var animationProps = fromEl.getAnimationStyleProps();
            var animationStyleProps = animationProps ? animationProps.style : null;
            if (animationStyleProps) {
                !transFromStyleProps && (transFromStyleProps = transFromProps.style = {});
                var styleKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(styleOpt);
                for(var i = 0; i < styleKeys.length; i++){
                    var key = styleKeys[i];
                    if (animationStyleProps[key]) {
                        var elVal = fromElStyle[key];
                        transFromStyleProps[key] = elVal;
                    }
                }
            }
        }
    }
}
function $7c104376a000308e$var$isNonStyleTransitionEnabled(optVal, elVal) {
    // The same as `checkNonStyleTansitionRefer`.
    return !(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(optVal) ? optVal != null && isFinite(optVal) : optVal !== elVal;
}
var $7c104376a000308e$var$checkTransformPropRefer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $ab8d73690f09fb6d$var$getStateToRestore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $ab8d73690f09fb6d$var$KEYFRAME_EXCLUDE_KEYS = [
    "percent",
    "easing",
    "shape",
    "style",
    "extra"
];
function $ab8d73690f09fb6d$export$9e5c70edf1ec0cb4(el) {
    // Stop previous keyframe animation.
    el.stopAnimation("keyframe");
    // Restore
    el.attr($ab8d73690f09fb6d$var$getStateToRestore(el));
}
function $ab8d73690f09fb6d$export$b0aa6a5f01693fa4(el, animationOpts, animatableModel) {
    if (!animatableModel.isAnimationEnabled() || !animationOpts) return;
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(animationOpts)) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(animationOpts, function(singleAnimationOpts) {
            $ab8d73690f09fb6d$export$b0aa6a5f01693fa4(el, singleAnimationOpts, animatableModel);
        });
        return;
    }
    var keyframes = animationOpts.keyframes;
    var duration = animationOpts.duration;
    if (animatableModel && duration == null) {
        // Default to use duration of config.
        // NOTE: animation config from payload will be ignored because they are mainly for transitions.
        var config = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)("enter", animatableModel, 0);
        duration = config && config.duration;
    }
    if (!keyframes || !duration) return;
    var stateToRestore = $ab8d73690f09fb6d$var$getStateToRestore(el);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $7c104376a000308e$export$9a911ad86e905b13), function(targetPropName) {
        if (targetPropName && !el[targetPropName]) return;
        var animator;
        var endFrameIsSet = false;
        // Sort keyframes by percent.
        keyframes.sort(function(a, b) {
            return a.percent - b.percent;
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(keyframes, function(kf) {
            // Stop current animation.
            var animators = el.animators;
            var kfValues = targetPropName ? kf[targetPropName] : kf;
            if (!kfValues) return;
            var propKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(kfValues);
            if (!targetPropName) // PENDING performance?
            propKeys = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(propKeys, function(key) {
                return (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($ab8d73690f09fb6d$var$KEYFRAME_EXCLUDE_KEYS, key) < 0;
            });
            if (!propKeys.length) return;
            if (!animator) {
                animator = el.animate(targetPropName, animationOpts.loop, true);
                animator.scope = "keyframe";
            }
            for(var i = 0; i < animators.length; i++)// Stop all other animation that is not keyframe.
            if (animators[i] !== animator && animators[i].targetName === animator.targetName) animators[i].stopTracks(propKeys);
            targetPropName && (stateToRestore[targetPropName] = stateToRestore[targetPropName] || {});
            var savedTarget = targetPropName ? stateToRestore[targetPropName] : stateToRestore;
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(propKeys, function(key) {
                // Save original value.
                savedTarget[key] = ((targetPropName ? el[targetPropName] : el) || {})[key];
            });
            animator.whenWithKeys(duration * kf.percent, kfValues, propKeys, kf.easing);
        });
        if (!animator) return;
        animator.delay(animationOpts.delay || 0).duration(duration).start(animationOpts.easing);
    });
}


var $590d5f44e94a6803$var$EMPHASIS = "emphasis";
var $590d5f44e94a6803$var$NORMAL = "normal";
var $590d5f44e94a6803$var$BLUR = "blur";
var $590d5f44e94a6803$var$SELECT = "select";
var $590d5f44e94a6803$var$STATES = [
    $590d5f44e94a6803$var$NORMAL,
    $590d5f44e94a6803$var$EMPHASIS,
    $590d5f44e94a6803$var$BLUR,
    $590d5f44e94a6803$var$SELECT
];
var $590d5f44e94a6803$var$PATH_ITEM_STYLE = {
    normal: [
        "itemStyle"
    ],
    emphasis: [
        $590d5f44e94a6803$var$EMPHASIS,
        "itemStyle"
    ],
    blur: [
        $590d5f44e94a6803$var$BLUR,
        "itemStyle"
    ],
    select: [
        $590d5f44e94a6803$var$SELECT,
        "itemStyle"
    ]
};
var $590d5f44e94a6803$var$PATH_LABEL = {
    normal: [
        "label"
    ],
    emphasis: [
        $590d5f44e94a6803$var$EMPHASIS,
        "label"
    ],
    blur: [
        $590d5f44e94a6803$var$BLUR,
        "label"
    ],
    select: [
        $590d5f44e94a6803$var$SELECT,
        "label"
    ]
};
var $590d5f44e94a6803$var$DEFAULT_TRANSITION = [
    "x",
    "y"
];
// Use prefix to avoid index to be the same as el.name,
// which will cause weird update animation.
var $590d5f44e94a6803$var$GROUP_DIFF_PREFIX = "e\0\0";
var $590d5f44e94a6803$var$attachedTxInfoTmp = {
    normal: {},
    emphasis: {},
    blur: {},
    select: {}
};
/**
 * To reduce total package size of each coordinate systems, the modules `prepareCustom`
 * of each coordinate systems are not required by each coordinate systems directly, but
 * required by the module `custom`.
 *
 * prepareInfoForCustomSeries {Function}: optional
 *     @return {Object} {coordSys: {...}, api: {
 *         coord: function (data, clamp) {}, // return point in global.
 *         size: function (dataSize, dataItem) {} // return size of each axis in coordSys.
 *     }}
 */ var $590d5f44e94a6803$var$prepareCustoms = {
    cartesian2d: (0, $eb5b87553d7c5e15$export$2e2bcd8739ae039),
    geo: (0, $db94904ae7a63a7b$export$2e2bcd8739ae039),
    single: (0, $4af7f8b40c63338e$export$2e2bcd8739ae039),
    polar: (0, $5542da7477183ee1$export$2e2bcd8739ae039),
    calendar: (0, $07a38220d20058fb$export$2e2bcd8739ae039)
};
function $590d5f44e94a6803$var$isPath(el) {
    return el instanceof $b02ffe7acd508c08$export$2e2bcd8739ae039;
}
function $590d5f44e94a6803$var$isDisplayable(el) {
    return el instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039);
}
function $590d5f44e94a6803$var$copyElement(sourceEl, targetEl) {
    targetEl.copyTransform(sourceEl);
    if ($590d5f44e94a6803$var$isDisplayable(targetEl) && $590d5f44e94a6803$var$isDisplayable(sourceEl)) {
        targetEl.setStyle(sourceEl.style);
        targetEl.z = sourceEl.z;
        targetEl.z2 = sourceEl.z2;
        targetEl.zlevel = sourceEl.zlevel;
        targetEl.invisible = sourceEl.invisible;
        targetEl.ignore = sourceEl.ignore;
        if ($590d5f44e94a6803$var$isPath(targetEl) && $590d5f44e94a6803$var$isPath(sourceEl)) targetEl.setShape(sourceEl.shape);
    }
}
var $590d5f44e94a6803$var$CustomChartView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CustomChartView, _super);
    function CustomChartView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CustomChartView.type;
        return _this;
    }
    CustomChartView.prototype.render = function(customSeries, ecModel, api, payload) {
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        var oldData = this._data;
        var data = customSeries.getData();
        var group = this.group;
        var renderItem = $590d5f44e94a6803$var$makeRenderItem(customSeries, data, ecModel, api);
        if (!oldData) // Previous render is incremental render or first render.
        // Needs remove the incremental rendered elements.
        group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            $590d5f44e94a6803$var$createOrUpdateItem(api, null, newIdx, renderItem(newIdx, payload), customSeries, group, data);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && (0, $7c104376a000308e$export$15575b6d82d35bb3)(el, (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).option, customSeries);
        }).update(function(newIdx, oldIdx) {
            var oldEl = oldData.getItemGraphicEl(oldIdx);
            $590d5f44e94a6803$var$createOrUpdateItem(api, oldEl, newIdx, renderItem(newIdx, payload), customSeries, group, data);
        }).execute();
        // Do clipping
        var clipPath = customSeries.get("clip", true) ? (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(customSeries.coordinateSystem, false, customSeries) : null;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
        this._data = data;
    };
    CustomChartView.prototype.incrementalPrepareRender = function(customSeries, ecModel, api) {
        this.group.removeAll();
        this._data = null;
    };
    CustomChartView.prototype.incrementalRender = function(params, customSeries, ecModel, api, payload) {
        var data = customSeries.getData();
        var renderItem = $590d5f44e94a6803$var$makeRenderItem(customSeries, data, ecModel, api);
        var progressiveEls = this._progressiveEls = [];
        function setIncrementalAndHoverLayer(el) {
            if (!el.isGroup) {
                el.incremental = true;
                el.ensureState("emphasis").hoverLayer = true;
            }
        }
        for(var idx = params.start; idx < params.end; idx++){
            var el = $590d5f44e94a6803$var$createOrUpdateItem(null, null, idx, renderItem(idx, payload), customSeries, this.group, data);
            if (el) {
                el.traverse(setIncrementalAndHoverLayer);
                progressiveEls.push(el);
            }
        }
    };
    CustomChartView.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    CustomChartView.prototype.filterForExposedEvent = function(eventType, query, targetEl, packedEvent) {
        var elementName = query.element;
        if (elementName == null || targetEl.name === elementName) return true;
        // Enable to give a name on a group made by `renderItem`, and listen
        // events that are triggered by its descendents.
        while((targetEl = targetEl.__hostTarget || targetEl.parent) && targetEl !== this.group){
            if (targetEl.name === elementName) return true;
        }
        return false;
    };
    CustomChartView.type = "custom";
    return CustomChartView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $590d5f44e94a6803$export$2e2bcd8739ae039 = $590d5f44e94a6803$var$CustomChartView;
function $590d5f44e94a6803$var$createEl(elOption) {
    var graphicType = elOption.type;
    var el;
    // Those graphic elements are not shapes. They should not be
    // overwritten by users, so do them first.
    if (graphicType === "path") {
        var shape = elOption.shape;
        // Using pathRect brings convenience to users sacle svg path.
        var pathRect = shape.width != null && shape.height != null ? {
            x: shape.x || 0,
            y: shape.y || 0,
            width: shape.width,
            height: shape.height
        } : null;
        var pathData = $590d5f44e94a6803$var$getPathData(shape);
        // Path is also used for icon, so layout 'center' by default.
        el = $5b455ae6f843ac47$export$aa9bab72412f5613(pathData, null, pathRect, shape.layout || "center");
        (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).customPathData = pathData;
    } else if (graphicType === "image") {
        el = new $86adec94217b86c6$export$2e2bcd8739ae039({});
        (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).customImagePath = elOption.style.image;
    } else if (graphicType === "text") el = new $fe885cc21795562b$export$2e2bcd8739ae039({});
    else if (graphicType === "group") el = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    else if (graphicType === "compoundPath") throw new Error('"compoundPath" is not supported yet.');
    else {
        var Clz = $5b455ae6f843ac47$export$51df4b5565a58189(graphicType);
        if (!Clz) {
            var errMsg = "";
            (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        }
        el = new Clz();
    }
    (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).customGraphicType = graphicType;
    el.name = elOption.name;
    // Compat ec4: the default z2 lift is 1. If changing the number,
    // some cases probably be broken: hierarchy layout along z, like circle packing,
    // where emphasis only intending to modify color/border rather than lift z2.
    el.z2EmphasisLift = 1;
    el.z2SelectLift = 1;
    return el;
}
function $590d5f44e94a6803$var$updateElNormal(// Can be null/undefined
api, el, dataIndex, elOption, attachedTxInfo, seriesModel, isInit) {
    // Stop and restore before update any other attributes.
    (0, $ab8d73690f09fb6d$export$9e5c70edf1ec0cb4)(el);
    var txCfgOpt = attachedTxInfo && attachedTxInfo.normal.cfg;
    if (txCfgOpt) // PENDING: whether use user object directly rather than clone?
    // TODO:5.0 textConfig transition animation?
    el.setTextConfig(txCfgOpt);
    // Default transition ['x', 'y']
    if (elOption && elOption.transition == null) elOption.transition = $590d5f44e94a6803$var$DEFAULT_TRANSITION;
    // Do some normalization on style.
    var styleOpt = elOption && elOption.style;
    if (styleOpt) {
        if (el.type === "text") {
            var textOptionStyle = styleOpt;
            // Compatible with ec4: if `textFill` or `textStroke` exists use them.
            (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(textOptionStyle, "textFill") && (textOptionStyle.fill = textOptionStyle.textFill);
            (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(textOptionStyle, "textStroke") && (textOptionStyle.stroke = textOptionStyle.textStroke);
        }
        var decalPattern = void 0;
        var decalObj = $590d5f44e94a6803$var$isPath(el) ? styleOpt.decal : null;
        if (api && decalObj) {
            decalObj.dirty = true;
            decalPattern = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decalObj, api);
        }
        // Always overwrite in case user specify this prop.
        styleOpt.__decalPattern = decalPattern;
    }
    if ($590d5f44e94a6803$var$isDisplayable(el)) {
        if (styleOpt) {
            var decalPattern = styleOpt.__decalPattern;
            if (decalPattern) styleOpt.decal = decalPattern;
        }
    }
    (0, $7c104376a000308e$export$4342b281b9b5d77e)(el, elOption, seriesModel, {
        dataIndex: dataIndex,
        isInit: isInit,
        clearStyle: true
    });
    (0, $ab8d73690f09fb6d$export$b0aa6a5f01693fa4)(el, elOption.keyframeAnimation, seriesModel);
}
function $590d5f44e94a6803$var$updateElOnState(state, el, elStateOpt, styleOpt, attachedTxInfo) {
    var elDisplayable = el.isGroup ? null : el;
    var txCfgOpt = attachedTxInfo && attachedTxInfo[state].cfg;
    // PENDING:5.0 support customize scale change and transition animation?
    if (elDisplayable) {
        // By default support auto lift color when hover whether `emphasis` specified.
        var stateObj = elDisplayable.ensureState(state);
        if (styleOpt === false) {
            var existingEmphasisState = elDisplayable.getState(state);
            if (existingEmphasisState) existingEmphasisState.style = null;
        } else // style is needed to enable default emphasis.
        stateObj.style = styleOpt || null;
        // If `elOption.styleEmphasis` or `elOption.emphasis.style` is `false`,
        // remove hover style.
        // If `elOption.textConfig` or `elOption.emphasis.textConfig` is null/undefined, it does not
        // make sense. So for simplicity, we do not ditinguish `hasOwnProperty` and null/undefined.
        if (txCfgOpt) stateObj.textConfig = txCfgOpt;
        (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(elDisplayable);
    }
}
function $590d5f44e94a6803$var$updateZ(el, elOption, seriesModel) {
    // Group not support textContent and not support z yet.
    if (el.isGroup) return;
    var elDisplayable = el;
    var currentZ = seriesModel.currentZ;
    var currentZLevel = seriesModel.currentZLevel;
    // Always erase.
    elDisplayable.z = currentZ;
    elDisplayable.zlevel = currentZLevel;
    // z2 must not be null/undefined, otherwise sort error may occur.
    var optZ2 = elOption.z2;
    optZ2 != null && (elDisplayable.z2 = optZ2 || 0);
    for(var i = 0; i < $590d5f44e94a6803$var$STATES.length; i++)$590d5f44e94a6803$var$updateZForEachState(elDisplayable, elOption, $590d5f44e94a6803$var$STATES[i]);
}
function $590d5f44e94a6803$var$updateZForEachState(elDisplayable, elOption, state) {
    var isNormal = state === $590d5f44e94a6803$var$NORMAL;
    var elStateOpt = isNormal ? elOption : $590d5f44e94a6803$var$retrieveStateOption(elOption, state);
    var optZ2 = elStateOpt ? elStateOpt.z2 : null;
    var stateObj;
    if (optZ2 != null) {
        // Do not `ensureState` until required.
        stateObj = isNormal ? elDisplayable : elDisplayable.ensureState(state);
        stateObj.z2 = optZ2 || 0;
    }
}
function $590d5f44e94a6803$var$makeRenderItem(customSeries, data, ecModel, api) {
    var renderItem = customSeries.get("renderItem");
    var coordSys = customSeries.coordinateSystem;
    var prepareResult = {};
    if (coordSys) // `coordSys.prepareCustoms` is used for external coord sys like bmap.
    prepareResult = coordSys.prepareCustoms ? coordSys.prepareCustoms(coordSys) : $590d5f44e94a6803$var$prepareCustoms[coordSys.type](coordSys);
    var userAPI = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        getWidth: api.getWidth,
        getHeight: api.getHeight,
        getZr: api.getZr,
        getDevicePixelRatio: api.getDevicePixelRatio,
        value: value,
        style: style,
        ordinalRawValue: ordinalRawValue,
        styleEmphasis: styleEmphasis,
        visual: visual,
        barLayout: barLayout,
        currentSeriesIndices: currentSeriesIndices,
        font: font
    }, prepareResult.api || {});
    var userParams = {
        // The life cycle of context: current round of rendering.
        // The global life cycle is probably not necessary, because
        // user can store global status by themselves.
        context: {},
        seriesId: customSeries.id,
        seriesName: customSeries.name,
        seriesIndex: customSeries.seriesIndex,
        coordSys: prepareResult.coordSys,
        dataInsideLength: data.count(),
        encode: $590d5f44e94a6803$var$wrapEncodeDef(customSeries.getData())
    };
    // If someday intending to refactor them to a class, should consider do not
    // break change: currently these attribute member are encapsulated in a closure
    // so that do not need to force user to call these method with a scope.
    // Do not support call `api` asynchronously without dataIndexInside input.
    var currDataIndexInside;
    var currItemModel;
    var currItemStyleModels = {};
    var currLabelModels = {};
    var seriesItemStyleModels = {};
    var seriesLabelModels = {};
    for(var i = 0; i < $590d5f44e94a6803$var$STATES.length; i++){
        var stateName = $590d5f44e94a6803$var$STATES[i];
        seriesItemStyleModels[stateName] = customSeries.getModel($590d5f44e94a6803$var$PATH_ITEM_STYLE[stateName]);
        seriesLabelModels[stateName] = customSeries.getModel($590d5f44e94a6803$var$PATH_LABEL[stateName]);
    }
    function getItemModel(dataIndexInside) {
        return dataIndexInside === currDataIndexInside ? currItemModel || (currItemModel = data.getItemModel(dataIndexInside)) : data.getItemModel(dataIndexInside);
    }
    function getItemStyleModel(dataIndexInside, state) {
        return !data.hasItemOption ? seriesItemStyleModels[state] : dataIndexInside === currDataIndexInside ? currItemStyleModels[state] || (currItemStyleModels[state] = getItemModel(dataIndexInside).getModel($590d5f44e94a6803$var$PATH_ITEM_STYLE[state])) : getItemModel(dataIndexInside).getModel($590d5f44e94a6803$var$PATH_ITEM_STYLE[state]);
    }
    function getLabelModel(dataIndexInside, state) {
        return !data.hasItemOption ? seriesLabelModels[state] : dataIndexInside === currDataIndexInside ? currLabelModels[state] || (currLabelModels[state] = getItemModel(dataIndexInside).getModel($590d5f44e94a6803$var$PATH_LABEL[state])) : getItemModel(dataIndexInside).getModel($590d5f44e94a6803$var$PATH_LABEL[state]);
    }
    return function(dataIndexInside, payload) {
        currDataIndexInside = dataIndexInside;
        currItemModel = null;
        currItemStyleModels = {};
        currLabelModels = {};
        return renderItem && renderItem((0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            dataIndexInside: dataIndexInside,
            dataIndex: data.getRawIndex(dataIndexInside),
            // Can be used for optimization when zoom or roam.
            actionType: payload ? payload.type : null
        }, userParams), userAPI);
    };
    /**
   * @public
   * @param dim by default 0.
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function value(dim, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        return data.getStore().get(data.getDimensionIndex(dim || 0), dataIndexInside);
    }
    /**
   * @public
   * @param dim by default 0.
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function ordinalRawValue(dim, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        dim = dim || 0;
        var dimInfo = data.getDimensionInfo(dim);
        if (!dimInfo) {
            var dimIndex = data.getDimensionIndex(dim);
            return dimIndex >= 0 ? data.getStore().get(dimIndex, dataIndexInside) : undefined;
        }
        var val = data.get(dimInfo.name, dataIndexInside);
        var ordinalMeta = dimInfo && dimInfo.ordinalMeta;
        return ordinalMeta ? ordinalMeta.categories[val] : val;
    }
    /**
   * @deprecated The original intention of `api.style` is enable to set itemStyle
   * like other series. But it is not necessary and not easy to give a strict definition
   * of what it returns. And since echarts5 it needs to be make compat work. So
   * deprecates it since echarts5.
   *
   * By default, `visual` is applied to style (to support visualMap).
   * `visual.color` is applied at `fill`. If user want apply visual.color on `stroke`,
   * it can be implemented as:
   * `api.style({stroke: api.visual('color'), fill: null})`;
   *
   * [Compat]: since ec5, RectText has been separated from its hosts el.
   * so `api.style()` will only return the style from `itemStyle` but not handle `label`
   * any more. But `series.label` config is never published in doc.
   * We still compat it in `api.style()`. But not encourage to use it and will still not
   * to pulish it to doc.
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function style(userProps, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        var style = data.getItemVisual(dataIndexInside, "style");
        var visualColor = style && style.fill;
        var opacity = style && style.opacity;
        var itemStyle = getItemStyleModel(dataIndexInside, $590d5f44e94a6803$var$NORMAL).getItemStyle();
        visualColor != null && (itemStyle.fill = visualColor);
        opacity != null && (itemStyle.opacity = opacity);
        var opt = {
            inheritColor: (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(visualColor) ? visualColor : "#000"
        };
        var labelModel = getLabelModel(dataIndexInside, $590d5f44e94a6803$var$NORMAL);
        // Now that the feature of "auto adjust text fill/stroke" has been migrated to zrender
        // since ec5, we should set `isAttached` as `false` here and make compat in
        // `convertToEC4StyleForCustomSerise`.
        var textStyle = $6800dfcb6e1e2a44$export$f8998c3d0a13de59(labelModel, null, opt, false, true);
        textStyle.text = labelModel.getShallow("show") ? (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(customSeries.getFormattedLabel(dataIndexInside, $590d5f44e94a6803$var$NORMAL), (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(data, dataIndexInside)) : null;
        var textConfig = $6800dfcb6e1e2a44$export$e149afab8df6e053(labelModel, opt, false);
        preFetchFromExtra(userProps, itemStyle);
        itemStyle = (0, $daa53642c3afcc30$export$b8ddb75bd1b9b791)(itemStyle, textStyle, textConfig);
        userProps && applyUserPropsAfter(itemStyle, userProps);
        itemStyle.legacy = true;
        return itemStyle;
    }
    /**
   * @deprecated The reason see `api.style()`
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function styleEmphasis(userProps, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        var itemStyle = getItemStyleModel(dataIndexInside, $590d5f44e94a6803$var$EMPHASIS).getItemStyle();
        var labelModel = getLabelModel(dataIndexInside, $590d5f44e94a6803$var$EMPHASIS);
        var textStyle = $6800dfcb6e1e2a44$export$f8998c3d0a13de59(labelModel, null, null, true, true);
        textStyle.text = labelModel.getShallow("show") ? (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(customSeries.getFormattedLabel(dataIndexInside, $590d5f44e94a6803$var$EMPHASIS), customSeries.getFormattedLabel(dataIndexInside, $590d5f44e94a6803$var$NORMAL), (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(data, dataIndexInside)) : null;
        var textConfig = $6800dfcb6e1e2a44$export$e149afab8df6e053(labelModel, null, true);
        preFetchFromExtra(userProps, itemStyle);
        itemStyle = (0, $daa53642c3afcc30$export$b8ddb75bd1b9b791)(itemStyle, textStyle, textConfig);
        userProps && applyUserPropsAfter(itemStyle, userProps);
        itemStyle.legacy = true;
        return itemStyle;
    }
    function applyUserPropsAfter(itemStyle, extra) {
        for(var key in extra)if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(extra, key)) itemStyle[key] = extra[key];
    }
    function preFetchFromExtra(extra, itemStyle) {
        // A trick to retrieve those props firstly, which are used to
        // apply auto inside fill/stroke in `convertToEC4StyleForCustomSerise`.
        // (It's not reasonable but only for a degree of compat)
        if (extra) {
            extra.textFill && (itemStyle.textFill = extra.textFill);
            extra.textPosition && (itemStyle.textPosition = extra.textPosition);
        }
    }
    /**
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function visual(visualType, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)((0, $fef28dd8967d3f1b$export$84369c8e2229fa7f), visualType)) {
            var style_1 = data.getItemVisual(dataIndexInside, "style");
            return style_1 ? style_1[(0, $fef28dd8967d3f1b$export$84369c8e2229fa7f)[visualType]] : null;
        }
        // Only support these visuals. Other visual might be inner tricky
        // for performance (like `style`), do not expose to users.
        if ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)((0, $fef28dd8967d3f1b$export$734d775a14929701), visualType)) return data.getItemVisual(dataIndexInside, visualType);
    }
    /**
   * @public
   * @return If not support, return undefined.
   */ function barLayout(opt) {
        if (coordSys.type === "cartesian2d") {
            var baseAxis = coordSys.getBaseAxis();
            return (0, $361c48dd900de28f$export$658df087977b9e84)((0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                axis: baseAxis
            }, opt));
        }
    }
    /**
   * @public
   */ function currentSeriesIndices() {
        return ecModel.getCurrentSeriesIndices();
    }
    /**
   * @public
   * @return font string
   */ function font(opt) {
        return $6800dfcb6e1e2a44$export$155316a870a9d61e(opt, ecModel);
    }
}
function $590d5f44e94a6803$var$wrapEncodeDef(data) {
    var encodeDef = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(data.dimensions, function(dimName) {
        var dimInfo = data.getDimensionInfo(dimName);
        if (!dimInfo.isExtraCoord) {
            var coordDim = dimInfo.coordDim;
            var dataDims = encodeDef[coordDim] = encodeDef[coordDim] || [];
            dataDims[dimInfo.coordDimIndex] = data.getDimensionIndex(dimName);
        }
    });
    return encodeDef;
}
function $590d5f44e94a6803$var$createOrUpdateItem(api, existsEl, dataIndex, elOption, seriesModel, group, data) {
    // [Rule]
    // If `renderItem` returns `null`/`undefined`/`false`, remove the previous el if existing.
    //     (It seems that violate the "merge" principle, but most of users probably intuitively
    //     regard "return;" as "show nothing element whatever", so make a exception to meet the
    //     most cases.)
    // The rule or "merge" see [STRATEGY_MERGE].
    // If `elOption` is `null`/`undefined`/`false` (when `renderItem` returns nothing).
    if (!elOption) {
        group.remove(existsEl);
        return;
    }
    var el = $590d5f44e94a6803$var$doCreateOrUpdateEl(api, existsEl, dataIndex, elOption, seriesModel, group);
    el && data.setItemGraphicEl(dataIndex, el);
    el && (0, $2bf82c0980125b62$export$e51187539ff11209)(el, elOption.focus, elOption.blurScope, elOption.emphasisDisabled);
    return el;
}
function $590d5f44e94a6803$var$doCreateOrUpdateEl(api, existsEl, dataIndex, elOption, seriesModel, group) {
    var toBeReplacedIdx = -1;
    var oldEl = existsEl;
    if (existsEl && $590d5f44e94a6803$var$doesElNeedRecreate(existsEl, elOption, seriesModel)) {
        // Should keep at the original index, otherwise "merge by index" will be incorrect.
        toBeReplacedIdx = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(group.childrenRef(), existsEl);
        existsEl = null;
    }
    var isInit = !existsEl;
    var el = existsEl;
    if (!el) {
        el = $590d5f44e94a6803$var$createEl(elOption);
        if (oldEl) $590d5f44e94a6803$var$copyElement(oldEl, el);
    } else // FIMXE:NEXT unified clearState?
    // If in some case the performance issue arised, consider
    // do not clearState but update cached normal state directly.
    el.clearStates();
    // Need to set morph: false explictly to disable automatically morphing.
    if (elOption.morph === false) el.disableMorphing = true;
    else if (el.disableMorphing) el.disableMorphing = false;
    $590d5f44e94a6803$var$attachedTxInfoTmp.normal.cfg = $590d5f44e94a6803$var$attachedTxInfoTmp.normal.conOpt = $590d5f44e94a6803$var$attachedTxInfoTmp.emphasis.cfg = $590d5f44e94a6803$var$attachedTxInfoTmp.emphasis.conOpt = $590d5f44e94a6803$var$attachedTxInfoTmp.blur.cfg = $590d5f44e94a6803$var$attachedTxInfoTmp.blur.conOpt = $590d5f44e94a6803$var$attachedTxInfoTmp.select.cfg = $590d5f44e94a6803$var$attachedTxInfoTmp.select.conOpt = null;
    $590d5f44e94a6803$var$attachedTxInfoTmp.isLegacy = false;
    $590d5f44e94a6803$var$doCreateOrUpdateAttachedTx(el, dataIndex, elOption, seriesModel, isInit, $590d5f44e94a6803$var$attachedTxInfoTmp);
    $590d5f44e94a6803$var$doCreateOrUpdateClipPath(el, dataIndex, elOption, seriesModel, isInit);
    $590d5f44e94a6803$var$updateElNormal(api, el, dataIndex, elOption, $590d5f44e94a6803$var$attachedTxInfoTmp, seriesModel, isInit);
    // `elOption.info` enables user to mount some info on
    // elements and use them in event handlers.
    // Update them only when user specified, otherwise, remain.
    (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOption, "info") && ((0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el).info = elOption.info);
    for(var i = 0; i < $590d5f44e94a6803$var$STATES.length; i++){
        var stateName = $590d5f44e94a6803$var$STATES[i];
        if (stateName !== $590d5f44e94a6803$var$NORMAL) {
            var otherStateOpt = $590d5f44e94a6803$var$retrieveStateOption(elOption, stateName);
            var otherStyleOpt = $590d5f44e94a6803$var$retrieveStyleOptionOnState(elOption, otherStateOpt, stateName);
            $590d5f44e94a6803$var$updateElOnState(stateName, el, otherStateOpt, otherStyleOpt, $590d5f44e94a6803$var$attachedTxInfoTmp);
        }
    }
    $590d5f44e94a6803$var$updateZ(el, elOption, seriesModel);
    if (elOption.type === "group") $590d5f44e94a6803$var$mergeChildren(api, el, dataIndex, elOption, seriesModel);
    if (toBeReplacedIdx >= 0) group.replaceAt(el, toBeReplacedIdx);
    else group.add(el);
    return el;
}
// `el` must not be null/undefined.
function $590d5f44e94a6803$var$doesElNeedRecreate(el, elOption, seriesModel) {
    var elInner = (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(el);
    var elOptionType = elOption.type;
    var elOptionShape = elOption.shape;
    var elOptionStyle = elOption.style;
    return(// Always create new if universal transition is enabled.
    // Because we do transition after render. It needs to know what old element is. Replacement will loose it.
    seriesModel.isUniversalTransitionEnabled() || elOptionType != null && elOptionType !== elInner.customGraphicType || elOptionType === "path" && $590d5f44e94a6803$var$hasOwnPathData(elOptionShape) && $590d5f44e94a6803$var$getPathData(elOptionShape) !== elInner.customPathData || elOptionType === "image" && (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(elOptionStyle, "image") && elOptionStyle.image !== elInner.customImagePath);
}
function $590d5f44e94a6803$var$doCreateOrUpdateClipPath(el, dataIndex, elOption, seriesModel, isInit) {
    // Based on the "merge" principle, if no clipPath provided,
    // do nothing. The exists clip will be totally removed only if
    // `el.clipPath` is `false`. Otherwise it will be merged/replaced.
    var clipPathOpt = elOption.clipPath;
    if (clipPathOpt === false) {
        if (el && el.getClipPath()) el.removeClipPath();
    } else if (clipPathOpt) {
        var clipPath = el.getClipPath();
        if (clipPath && $590d5f44e94a6803$var$doesElNeedRecreate(clipPath, clipPathOpt, seriesModel)) clipPath = null;
        if (!clipPath) {
            clipPath = $590d5f44e94a6803$var$createEl(clipPathOpt);
            el.setClipPath(clipPath);
        }
        $590d5f44e94a6803$var$updateElNormal(null, clipPath, dataIndex, clipPathOpt, null, seriesModel, isInit);
    }
// If not define `clipPath` in option, do nothing unnecessary.
}
function $590d5f44e94a6803$var$doCreateOrUpdateAttachedTx(el, dataIndex, elOption, seriesModel, isInit, attachedTxInfo) {
    // Group does not support textContent temporarily until necessary.
    if (el.isGroup) return;
    // Normal must be called before emphasis, for `isLegacy` detection.
    $590d5f44e94a6803$var$processTxInfo(elOption, null, attachedTxInfo);
    $590d5f44e94a6803$var$processTxInfo(elOption, $590d5f44e94a6803$var$EMPHASIS, attachedTxInfo);
    // If `elOption.textConfig` or `elOption.textContent` is null/undefined, it does not make sense.
    // So for simplicity, if "elOption hasOwnProperty of them but be null/undefined", we do not
    // trade them as set to null to el.
    // Especially:
    // `elOption.textContent: false` means remove textContent.
    // `elOption.textContent.emphasis.style: false` means remove the style from emphasis state.
    var txConOptNormal = attachedTxInfo.normal.conOpt;
    var txConOptEmphasis = attachedTxInfo.emphasis.conOpt;
    var txConOptBlur = attachedTxInfo.blur.conOpt;
    var txConOptSelect = attachedTxInfo.select.conOpt;
    if (txConOptNormal != null || txConOptEmphasis != null || txConOptSelect != null || txConOptBlur != null) {
        var textContent = el.getTextContent();
        if (txConOptNormal === false) textContent && el.removeTextContent();
        else {
            txConOptNormal = attachedTxInfo.normal.conOpt = txConOptNormal || {
                type: "text"
            };
            if (!textContent) {
                textContent = $590d5f44e94a6803$var$createEl(txConOptNormal);
                el.setTextContent(textContent);
            } else // If in some case the performance issue arised, consider
            // do not clearState but update cached normal state directly.
            textContent.clearStates();
            $590d5f44e94a6803$var$updateElNormal(null, textContent, dataIndex, txConOptNormal, null, seriesModel, isInit);
            var txConStlOptNormal = txConOptNormal && txConOptNormal.style;
            for(var i = 0; i < $590d5f44e94a6803$var$STATES.length; i++){
                var stateName = $590d5f44e94a6803$var$STATES[i];
                if (stateName !== $590d5f44e94a6803$var$NORMAL) {
                    var txConOptOtherState = attachedTxInfo[stateName].conOpt;
                    $590d5f44e94a6803$var$updateElOnState(stateName, textContent, txConOptOtherState, $590d5f44e94a6803$var$retrieveStyleOptionOnState(txConOptNormal, txConOptOtherState, stateName), null);
                }
            }
            txConStlOptNormal ? textContent.dirty() : textContent.markRedraw();
        }
    }
}
function $590d5f44e94a6803$var$processTxInfo(elOption, state, attachedTxInfo) {
    var stateOpt = !state ? elOption : $590d5f44e94a6803$var$retrieveStateOption(elOption, state);
    var styleOpt = !state ? elOption.style : $590d5f44e94a6803$var$retrieveStyleOptionOnState(elOption, stateOpt, $590d5f44e94a6803$var$EMPHASIS);
    var elType = elOption.type;
    var txCfg = stateOpt ? stateOpt.textConfig : null;
    var txConOptNormal = elOption.textContent;
    var txConOpt = !txConOptNormal ? null : !state ? txConOptNormal : $590d5f44e94a6803$var$retrieveStateOption(txConOptNormal, state);
    if (styleOpt && // Because emphasis style has little info to detect legacy,
    // if normal is legacy, emphasis is trade as legacy.
    (attachedTxInfo.isLegacy || (0, $daa53642c3afcc30$export$3b868abde5eae7d1)(styleOpt, elType, !!txCfg, !!txConOpt))) {
        attachedTxInfo.isLegacy = true;
        var convertResult = (0, $daa53642c3afcc30$export$7748133eaaa8aecc)(styleOpt, elType, !state);
        // Explicitly specified `textConfig` and `textContent` has higher priority than
        // the ones generated by legacy style. Otherwise if users use them and `api.style`
        // at the same time, they not both work and hardly to known why.
        if (!txCfg && convertResult.textConfig) txCfg = convertResult.textConfig;
        if (!txConOpt && convertResult.textContent) txConOpt = convertResult.textContent;
    }
    if (!state && txConOpt) {
        var txConOptNormal_1 = txConOpt;
        // `textContent: {type: 'text'}`, the "type" is easy to be missing. So we tolerate it.
        !txConOptNormal_1.type && (txConOptNormal_1.type = "text");
    }
    var info = !state ? attachedTxInfo.normal : attachedTxInfo[state];
    info.cfg = txCfg;
    info.conOpt = txConOpt;
}
function $590d5f44e94a6803$var$retrieveStateOption(elOption, state) {
    return !state ? elOption : elOption ? elOption[state] : null;
}
function $590d5f44e94a6803$var$retrieveStyleOptionOnState(stateOptionNormal, stateOption, state) {
    var style = stateOption && stateOption.style;
    if (style == null && state === $590d5f44e94a6803$var$EMPHASIS && stateOptionNormal) style = stateOptionNormal.styleEmphasis;
    return style;
}
// Usage:
// (1) By default, `elOption.$mergeChildren` is `'byIndex'`, which indicates
//     that the existing children will not be removed, and enables the feature
//     that update some of the props of some of the children simply by construct
//     the returned children of `renderItem` like:
//     `var children = group.children = []; children[3] = {opacity: 0.5};`
// (2) If `elOption.$mergeChildren` is `'byName'`, add/update/remove children
//     by child.name. But that might be lower performance.
// (3) If `elOption.$mergeChildren` is `false`, the existing children will be
//     replaced totally.
// (4) If `!elOption.children`, following the "merge" principle, nothing will
//     happen.
// (5) If `elOption.$mergeChildren` is not `false` neither `'byName'` and the
//     `el` is a group, and if any of the new child is null, it means to remove
//     the element at the same index, if exists. On the other hand, if the new
//     child is and empty object `{}`, it means to keep the element not changed.
//
// For implementation simpleness, do not provide a direct way to remove single
// child (otherwise the total indices of the children array have to be modified).
// User can remove a single child by setting its `ignore` to `true`.
function $590d5f44e94a6803$var$mergeChildren(api, el, dataIndex, elOption, seriesModel) {
    var newChildren = elOption.children;
    var newLen = newChildren ? newChildren.length : 0;
    var mergeChildren = elOption.$mergeChildren;
    // `diffChildrenByName` has been deprecated.
    var byName = mergeChildren === "byName" || elOption.diffChildrenByName;
    var notMerge = mergeChildren === false;
    // For better performance on roam update, only enter if necessary.
    if (!newLen && !byName && !notMerge) return;
    if (byName) {
        $590d5f44e94a6803$var$diffGroupChildren({
            api: api,
            oldChildren: el.children() || [],
            newChildren: newChildren || [],
            dataIndex: dataIndex,
            seriesModel: seriesModel,
            group: el
        });
        return;
    }
    notMerge && el.removeAll();
    // Mapping children of a group simply by index, which
    // might be better performance.
    var index = 0;
    for(; index < newLen; index++){
        var newChild = newChildren[index];
        var oldChild = el.childAt(index);
        if (newChild) {
            if (newChild.ignore == null) // The old child is set to be ignored if null (see comments
            // below). So we need to set ignore to be false back.
            newChild.ignore = false;
            $590d5f44e94a6803$var$doCreateOrUpdateEl(api, oldChild, dataIndex, newChild, seriesModel, el);
        } else // If the new element option is null, it means to remove the old
        // element. But we cannot really remove the element from the group
        // directly, because the element order may not be stable when this
        // element is added back. So we set the element to be ignored.
        oldChild.ignore = true;
    }
    for(var i = el.childCount() - 1; i >= index; i--){
        var child = el.childAt(i);
        $590d5f44e94a6803$var$removeChildFromGroup(el, child, seriesModel);
    }
}
function $590d5f44e94a6803$var$removeChildFromGroup(group, child, seriesModel) {
    // Do not support leave elements that are not mentioned in the latest
    // `renderItem` return. Otherwise users may not have a clear and simple
    // concept that how to control all of the elements.
    child && (0, $7c104376a000308e$export$15575b6d82d35bb3)(child, (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(group).option, seriesModel);
}
function $590d5f44e94a6803$var$diffGroupChildren(context) {
    new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(context.oldChildren, context.newChildren, $590d5f44e94a6803$var$getKey, $590d5f44e94a6803$var$getKey, context).add($590d5f44e94a6803$var$processAddUpdate).update($590d5f44e94a6803$var$processAddUpdate).remove($590d5f44e94a6803$var$processRemove).execute();
}
function $590d5f44e94a6803$var$getKey(item, idx) {
    var name = item && item.name;
    return name != null ? name : $590d5f44e94a6803$var$GROUP_DIFF_PREFIX + idx;
}
function $590d5f44e94a6803$var$processAddUpdate(newIndex, oldIndex) {
    var context = this.context;
    var childOption = newIndex != null ? context.newChildren[newIndex] : null;
    var child = oldIndex != null ? context.oldChildren[oldIndex] : null;
    $590d5f44e94a6803$var$doCreateOrUpdateEl(context.api, child, context.dataIndex, childOption, context.seriesModel, context.group);
}
function $590d5f44e94a6803$var$processRemove(oldIndex) {
    var context = this.context;
    var child = context.oldChildren[oldIndex];
    child && (0, $7c104376a000308e$export$15575b6d82d35bb3)(child, (0, $fef28dd8967d3f1b$export$dd5c3cc86073562f)(child).option, context.seriesModel);
}
/**
 * @return SVG Path data.
 */ function $590d5f44e94a6803$var$getPathData(shape) {
    // "d" follows the SVG convention.
    return shape && (shape.pathData || shape.d);
}
function $590d5f44e94a6803$var$hasOwnPathData(shape) {
    return shape && ((0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(shape, "pathData") || (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(shape, "d"));
}


function $3fd02cf8c6a1578a$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $590d5f44e94a6803$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $fef28dd8967d3f1b$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









var $b1d9c3e17ccace80$var$Symbol = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(Symbol, _super);
    function Symbol(data, idx, seriesScope, opts) {
        var _this = _super.call(this) || this;
        _this.updateData(data, idx, seriesScope, opts);
        return _this;
    }
    Symbol.prototype._createSymbol = function(symbolType, data, idx, symbolSize, keepAspect) {
        // Remove paths created before
        this.removeAll();
        // let symbolPath = createSymbol(
        //     symbolType, -0.5, -0.5, 1, 1, color
        // );
        // If width/height are set too small (e.g., set to 1) on ios10
        // and macOS Sierra, a circle stroke become a rect, no matter what
        // the scale is set. So we set width/height as 2. See #4150.
        var symbolPath = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, -1, -1, 2, 2, null, keepAspect);
        symbolPath.attr({
            z2: 100,
            culling: true,
            scaleX: symbolSize[0] / 2,
            scaleY: symbolSize[1] / 2
        });
        // Rewrite drift method
        symbolPath.drift = $b1d9c3e17ccace80$var$driftSymbol;
        this._symbolType = symbolType;
        this.add(symbolPath);
    };
    /**
   * Stop animation
   * @param {boolean} toLastFrame
   */ Symbol.prototype.stopSymbolAnimation = function(toLastFrame) {
        this.childAt(0).stopAnimation(null, toLastFrame);
    };
    Symbol.prototype.getSymbolType = function() {
        return this._symbolType;
    };
    /**
   * FIXME:
   * Caution: This method breaks the encapsulation of this module,
   * but it indeed brings convenience. So do not use the method
   * unless you detailedly know all the implements of `Symbol`,
   * especially animation.
   *
   * Get symbol path element.
   */ Symbol.prototype.getSymbolPath = function() {
        return this.childAt(0);
    };
    /**
   * Highlight symbol
   */ Symbol.prototype.highlight = function() {
        (0, $2bf82c0980125b62$export$b2d02638cc34c042)(this.childAt(0));
    };
    /**
   * Downplay symbol
   */ Symbol.prototype.downplay = function() {
        (0, $2bf82c0980125b62$export$11be6f716239ac55)(this.childAt(0));
    };
    /**
   * @param {number} zlevel
   * @param {number} z
   */ Symbol.prototype.setZ = function(zlevel, z) {
        var symbolPath = this.childAt(0);
        symbolPath.zlevel = zlevel;
        symbolPath.z = z;
    };
    Symbol.prototype.setDraggable = function(draggable, hasCursorOption) {
        var symbolPath = this.childAt(0);
        symbolPath.draggable = draggable;
        symbolPath.cursor = !hasCursorOption && draggable ? "move" : symbolPath.cursor;
    };
    /**
   * Update symbol properties
   */ Symbol.prototype.updateData = function(data, idx, seriesScope, opts) {
        this.silent = false;
        var symbolType = data.getItemVisual(idx, "symbol") || "circle";
        var seriesModel = data.hostModel;
        var symbolSize = Symbol.getSymbolSize(data, idx);
        var isInit = symbolType !== this._symbolType;
        var disableAnimation = opts && opts.disableAnimation;
        if (isInit) {
            var keepAspect = data.getItemVisual(idx, "symbolKeepAspect");
            this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
        } else {
            var symbolPath = this.childAt(0);
            symbolPath.silent = false;
            var target = {
                scaleX: symbolSize[0] / 2,
                scaleY: symbolSize[1] / 2
            };
            disableAnimation ? symbolPath.attr(target) : $8b353638fbedfefa$export$c8dce3c08436e91e(symbolPath, target, seriesModel, idx);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(symbolPath);
        }
        this._updateCommon(data, idx, symbolSize, seriesScope, opts);
        if (isInit) {
            var symbolPath = this.childAt(0);
            if (!disableAnimation) {
                var target = {
                    scaleX: this._sizeX,
                    scaleY: this._sizeY,
                    style: {
                        // Always fadeIn. Because it has fadeOut animation when symbol is removed..
                        opacity: symbolPath.style.opacity
                    }
                };
                symbolPath.scaleX = symbolPath.scaleY = 0;
                symbolPath.style.opacity = 0;
                $8b353638fbedfefa$export$a121566aadcfe021(symbolPath, target, seriesModel, idx);
            }
        }
        if (disableAnimation) // Must stop leave transition manually if don't call initProps or updateProps.
        this.childAt(0).stopAnimation("leave");
    };
    Symbol.prototype._updateCommon = function(data, idx, symbolSize, seriesScope, opts) {
        var symbolPath = this.childAt(0);
        var seriesModel = data.hostModel;
        var emphasisItemStyle;
        var blurItemStyle;
        var selectItemStyle;
        var focus;
        var blurScope;
        var emphasisDisabled;
        var labelStatesModels;
        var hoverScale;
        var cursorStyle;
        if (seriesScope) {
            emphasisItemStyle = seriesScope.emphasisItemStyle;
            blurItemStyle = seriesScope.blurItemStyle;
            selectItemStyle = seriesScope.selectItemStyle;
            focus = seriesScope.focus;
            blurScope = seriesScope.blurScope;
            labelStatesModels = seriesScope.labelStatesModels;
            hoverScale = seriesScope.hoverScale;
            cursorStyle = seriesScope.cursorStyle;
            emphasisDisabled = seriesScope.emphasisDisabled;
        }
        if (!seriesScope || data.hasItemOption) {
            var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx);
            var emphasisModel = itemModel.getModel("emphasis");
            emphasisItemStyle = emphasisModel.getModel("itemStyle").getItemStyle();
            selectItemStyle = itemModel.getModel([
                "select",
                "itemStyle"
            ]).getItemStyle();
            blurItemStyle = itemModel.getModel([
                "blur",
                "itemStyle"
            ]).getItemStyle();
            focus = emphasisModel.get("focus");
            blurScope = emphasisModel.get("blurScope");
            emphasisDisabled = emphasisModel.get("disabled");
            labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel);
            hoverScale = emphasisModel.getShallow("scale");
            cursorStyle = itemModel.getShallow("cursor");
        }
        var symbolRotate = data.getItemVisual(idx, "symbolRotate");
        symbolPath.attr("rotation", (symbolRotate || 0) * Math.PI / 180 || 0);
        var symbolOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(data.getItemVisual(idx, "symbolOffset"), symbolSize);
        if (symbolOffset) {
            symbolPath.x = symbolOffset[0];
            symbolPath.y = symbolOffset[1];
        }
        cursorStyle && symbolPath.attr("cursor", cursorStyle);
        var symbolStyle = data.getItemVisual(idx, "style");
        var visualColor = symbolStyle.fill;
        if (symbolPath instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
            var pathStyle = symbolPath.style;
            symbolPath.useStyle((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                // TODO other properties like x, y ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, symbolStyle));
        } else {
            if (symbolPath.__isEmptyBrush) // fill and stroke will be swapped if it's empty.
            // So we cloned a new style to avoid it affecting the original style in visual storage.
            // TODO Better implementation. No empty logic!
            symbolPath.useStyle((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, symbolStyle));
            else symbolPath.useStyle(symbolStyle);
            // Disable decal because symbol scale will been applied on the decal.
            symbolPath.style.decal = null;
            symbolPath.setColor(visualColor, opts && opts.symbolInnerColor);
            symbolPath.style.strokeNoScale = true;
        }
        var liftZ = data.getItemVisual(idx, "liftZ");
        var z2Origin = this._z2;
        if (liftZ != null) {
            if (z2Origin == null) {
                this._z2 = symbolPath.z2;
                symbolPath.z2 += liftZ;
            }
        } else if (z2Origin != null) {
            symbolPath.z2 = z2Origin;
            this._z2 = null;
        }
        var useNameLabel = opts && opts.useNameLabel;
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(symbolPath, labelStatesModels, {
            labelFetcher: seriesModel,
            labelDataIndex: idx,
            defaultText: getLabelDefaultText,
            inheritColor: visualColor,
            defaultOpacity: symbolStyle.opacity
        });
        // Do not execute util needed.
        function getLabelDefaultText(idx) {
            return useNameLabel ? data.getName(idx) : (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(data, idx);
        }
        this._sizeX = symbolSize[0] / 2;
        this._sizeY = symbolSize[1] / 2;
        var emphasisState = symbolPath.ensureState("emphasis");
        emphasisState.style = emphasisItemStyle;
        symbolPath.ensureState("select").style = selectItemStyle;
        symbolPath.ensureState("blur").style = blurItemStyle;
        // null / undefined / true means to use default strategy.
        // 0 / false / negative number / NaN / Infinity means no scale.
        var scaleRatio = hoverScale == null || hoverScale === true ? Math.max(1.1, 3 / this._sizeY) : isFinite(hoverScale) && hoverScale > 0 ? +hoverScale : 1;
        // always set scale to allow resetting
        emphasisState.scaleX = this._sizeX * scaleRatio;
        emphasisState.scaleY = this._sizeY * scaleRatio;
        this.setSymbolScale(1);
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, focus, blurScope, emphasisDisabled);
    };
    Symbol.prototype.setSymbolScale = function(scale) {
        this.scaleX = this.scaleY = scale;
    };
    Symbol.prototype.fadeOut = function(cb, seriesModel, opt) {
        var symbolPath = this.childAt(0);
        var dataIndex = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(this).dataIndex;
        var animationOpt = opt && opt.animation;
        // Avoid mistaken hover when fading out
        this.silent = symbolPath.silent = true;
        // Not show text when animating
        if (opt && opt.fadeLabel) {
            var textContent = symbolPath.getTextContent();
            if (textContent) $8b353638fbedfefa$export$f883456a56996078(textContent, {
                style: {
                    opacity: 0
                }
            }, seriesModel, {
                dataIndex: dataIndex,
                removeOpt: animationOpt,
                cb: function() {
                    symbolPath.removeTextContent();
                }
            });
        } else symbolPath.removeTextContent();
        $8b353638fbedfefa$export$f883456a56996078(symbolPath, {
            style: {
                opacity: 0
            },
            scaleX: 0,
            scaleY: 0
        }, seriesModel, {
            dataIndex: dataIndex,
            cb: cb,
            removeOpt: animationOpt
        });
    };
    Symbol.getSymbolSize = function(data, idx) {
        return (0, $5370466dadc978d7$export$a84524f03e8e8dfb)(data.getItemVisual(idx, "symbolSize"));
    };
    return Symbol;
}($7ef7583d8302ffce$export$2e2bcd8739ae039);
function $b1d9c3e17ccace80$var$driftSymbol(dx, dy) {
    this.parent.drift(dx, dy);
}
var $b1d9c3e17ccace80$export$2e2bcd8739ae039 = $b1d9c3e17ccace80$var$Symbol;




function $fedf62268297fcbb$var$symbolNeedsDraw(data, point, idx, opt) {
    return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx)) && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, "symbol") !== "none";
}
function $fedf62268297fcbb$var$normalizeUpdateOpt(opt) {
    if (opt != null && !(0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(opt)) opt = {
        isIgnore: opt
    };
    return opt || {};
}
function $fedf62268297fcbb$var$makeSeriesScope(data) {
    var seriesModel = data.hostModel;
    var emphasisModel = seriesModel.getModel("emphasis");
    return {
        emphasisItemStyle: emphasisModel.getModel("itemStyle").getItemStyle(),
        blurItemStyle: seriesModel.getModel([
            "blur",
            "itemStyle"
        ]).getItemStyle(),
        selectItemStyle: seriesModel.getModel([
            "select",
            "itemStyle"
        ]).getItemStyle(),
        focus: emphasisModel.get("focus"),
        blurScope: emphasisModel.get("blurScope"),
        emphasisDisabled: emphasisModel.get("disabled"),
        hoverScale: emphasisModel.get("scale"),
        labelStatesModels: (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(seriesModel),
        cursorStyle: seriesModel.get("cursor")
    };
}
var $fedf62268297fcbb$var$SymbolDraw = /** @class */ function() {
    function SymbolDraw(SymbolCtor) {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this._SymbolCtor = SymbolCtor || (0, $b1d9c3e17ccace80$export$2e2bcd8739ae039);
    }
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.updateData = function(data, opt) {
        // Remove progressive els.
        this._progressiveEls = null;
        opt = $fedf62268297fcbb$var$normalizeUpdateOpt(opt);
        var group = this.group;
        var seriesModel = data.hostModel;
        var oldData = this._data;
        var SymbolCtor = this._SymbolCtor;
        var disableAnimation = opt.disableAnimation;
        var seriesScope = $fedf62268297fcbb$var$makeSeriesScope(data);
        var symbolUpdateOpt = {
            disableAnimation: disableAnimation
        };
        var getSymbolPoint = opt.getSymbolPoint || function(idx) {
            return data.getItemLayout(idx);
        };
        // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldData) group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            var point = getSymbolPoint(newIdx);
            if ($fedf62268297fcbb$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                var symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
                data.setItemGraphicEl(newIdx, symbolEl);
                group.add(symbolEl);
            }
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            var point = getSymbolPoint(newIdx);
            if (!$fedf62268297fcbb$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                group.remove(symbolEl);
                return;
            }
            var newSymbolType = data.getItemVisual(newIdx, "symbol") || "circle";
            var oldSymbolType = symbolEl && symbolEl.getSymbolType && symbolEl.getSymbolType();
            if (!symbolEl || oldSymbolType && oldSymbolType !== newSymbolType) {
                group.remove(symbolEl);
                symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
            } else {
                symbolEl.updateData(data, newIdx, seriesScope, symbolUpdateOpt);
                var target = {
                    x: point[0],
                    y: point[1]
                };
                disableAnimation ? symbolEl.attr(target) : $8b353638fbedfefa$export$c8dce3c08436e91e(symbolEl, target, seriesModel);
            }
            // Add back
            group.add(symbolEl);
            data.setItemGraphicEl(newIdx, symbolEl);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && el.fadeOut(function() {
                group.remove(el);
            }, seriesModel);
        }).execute();
        this._getSymbolPoint = getSymbolPoint;
        this._data = data;
    };
    SymbolDraw.prototype.updateLayout = function() {
        var _this = this;
        var data = this._data;
        if (data) // Not use animation
        data.eachItemGraphicEl(function(el, idx) {
            var point = _this._getSymbolPoint(idx);
            el.setPosition(point);
            el.markRedraw();
        });
    };
    SymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
        this._seriesScope = $fedf62268297fcbb$var$makeSeriesScope(data);
        this._data = null;
        this.group.removeAll();
    };
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
        // Clear
        this._progressiveEls = [];
        opt = $fedf62268297fcbb$var$normalizeUpdateOpt(opt);
        function updateIncrementalAndHover(el) {
            if (!el.isGroup) {
                el.incremental = true;
                el.ensureState("emphasis").hoverLayer = true;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var point = data.getItemLayout(idx);
            if ($fedf62268297fcbb$var$symbolNeedsDraw(data, point, idx, opt)) {
                var el = new this._SymbolCtor(data, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                el.setPosition(point);
                this.group.add(el);
                data.setItemGraphicEl(idx, el);
                this._progressiveEls.push(el);
            }
        }
    };
    SymbolDraw.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    SymbolDraw.prototype.remove = function(enableAnimation) {
        var group = this.group;
        var data = this._data;
        // Incremental model do not have this._data.
        if (data && enableAnimation) data.eachItemGraphicEl(function(el) {
            el.fadeOut(function() {
                group.remove(el);
            }, data.hostModel);
        });
        else group.removeAll();
    };
    return SymbolDraw;
}();
var $fedf62268297fcbb$export$2e2bcd8739ae039 = $fedf62268297fcbb$var$SymbolDraw;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




function $fa583301cd9a2f5a$var$updateRipplePath(rippleGroup, effectCfg) {
    var color = effectCfg.rippleEffectColor || effectCfg.color;
    rippleGroup.eachChild(function(ripplePath) {
        ripplePath.attr({
            z: effectCfg.z,
            zlevel: effectCfg.zlevel,
            style: {
                stroke: effectCfg.brushType === "stroke" ? color : null,
                fill: effectCfg.brushType === "fill" ? color : null
            }
        });
    });
}
var $fa583301cd9a2f5a$var$EffectSymbol = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(EffectSymbol, _super);
    function EffectSymbol(data, idx) {
        var _this = _super.call(this) || this;
        var symbol = new (0, $b1d9c3e17ccace80$export$2e2bcd8739ae039)(data, idx);
        var rippleGroup = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        _this.add(symbol);
        _this.add(rippleGroup);
        _this.updateData(data, idx);
        return _this;
    }
    EffectSymbol.prototype.stopEffectAnimation = function() {
        this.childAt(1).removeAll();
    };
    EffectSymbol.prototype.startEffectAnimation = function(effectCfg) {
        var symbolType = effectCfg.symbolType;
        var color = effectCfg.color;
        var rippleNumber = effectCfg.rippleNumber;
        var rippleGroup = this.childAt(1);
        for(var i = 0; i < rippleNumber; i++){
            // If width/height are set too small (e.g., set to 1) on ios10
            // and macOS Sierra, a circle stroke become a rect, no matter what
            // the scale is set. So we set width/height as 2. See #4136.
            var ripplePath = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, -1, -1, 2, 2, color);
            ripplePath.attr({
                style: {
                    strokeNoScale: true
                },
                z2: 99,
                silent: true,
                scaleX: 0.5,
                scaleY: 0.5
            });
            var delay = -i / rippleNumber * effectCfg.period + effectCfg.effectOffset;
            ripplePath.animate("", true).when(effectCfg.period, {
                scaleX: effectCfg.rippleScale / 2,
                scaleY: effectCfg.rippleScale / 2
            }).delay(delay).start();
            ripplePath.animateStyle(true).when(effectCfg.period, {
                opacity: 0
            }).delay(delay).start();
            rippleGroup.add(ripplePath);
        }
        $fa583301cd9a2f5a$var$updateRipplePath(rippleGroup, effectCfg);
    };
    /**
   * Update effect symbol
   */ EffectSymbol.prototype.updateEffectAnimation = function(effectCfg) {
        var oldEffectCfg = this._effectCfg;
        var rippleGroup = this.childAt(1);
        // Must reinitialize effect if following configuration changed
        var DIFFICULT_PROPS = [
            "symbolType",
            "period",
            "rippleScale",
            "rippleNumber"
        ];
        for(var i = 0; i < DIFFICULT_PROPS.length; i++){
            var propName = DIFFICULT_PROPS[i];
            if (oldEffectCfg[propName] !== effectCfg[propName]) {
                this.stopEffectAnimation();
                this.startEffectAnimation(effectCfg);
                return;
            }
        }
        $fa583301cd9a2f5a$var$updateRipplePath(rippleGroup, effectCfg);
    };
    /**
   * Highlight symbol
   */ EffectSymbol.prototype.highlight = function() {
        (0, $2bf82c0980125b62$export$b2d02638cc34c042)(this);
    };
    /**
   * Downplay symbol
   */ EffectSymbol.prototype.downplay = function() {
        (0, $2bf82c0980125b62$export$11be6f716239ac55)(this);
    };
    EffectSymbol.prototype.getSymbolType = function() {
        var symbol = this.childAt(0);
        return symbol && symbol.getSymbolType();
    };
    /**
   * Update symbol properties
   */ EffectSymbol.prototype.updateData = function(data, idx) {
        var _this = this;
        var seriesModel = data.hostModel;
        this.childAt(0).updateData(data, idx);
        var rippleGroup = this.childAt(1);
        var itemModel = data.getItemModel(idx);
        var symbolType = data.getItemVisual(idx, "symbol");
        var symbolSize = (0, $5370466dadc978d7$export$a84524f03e8e8dfb)(data.getItemVisual(idx, "symbolSize"));
        var symbolStyle = data.getItemVisual(idx, "style");
        var color = symbolStyle && symbolStyle.fill;
        var emphasisModel = itemModel.getModel("emphasis");
        rippleGroup.setScale(symbolSize);
        rippleGroup.traverse(function(ripplePath) {
            ripplePath.setStyle("fill", color);
        });
        var symbolOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(data.getItemVisual(idx, "symbolOffset"), symbolSize);
        if (symbolOffset) {
            rippleGroup.x = symbolOffset[0];
            rippleGroup.y = symbolOffset[1];
        }
        var symbolRotate = data.getItemVisual(idx, "symbolRotate");
        rippleGroup.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
        var effectCfg = {};
        effectCfg.showEffectOn = seriesModel.get("showEffectOn");
        effectCfg.rippleScale = itemModel.get([
            "rippleEffect",
            "scale"
        ]);
        effectCfg.brushType = itemModel.get([
            "rippleEffect",
            "brushType"
        ]);
        effectCfg.period = itemModel.get([
            "rippleEffect",
            "period"
        ]) * 1000;
        effectCfg.effectOffset = idx / data.count();
        effectCfg.z = seriesModel.getShallow("z") || 0;
        effectCfg.zlevel = seriesModel.getShallow("zlevel") || 0;
        effectCfg.symbolType = symbolType;
        effectCfg.color = color;
        effectCfg.rippleEffectColor = itemModel.get([
            "rippleEffect",
            "color"
        ]);
        effectCfg.rippleNumber = itemModel.get([
            "rippleEffect",
            "number"
        ]);
        if (effectCfg.showEffectOn === "render") {
            this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
            this._effectCfg = effectCfg;
        } else {
            // Not keep old effect config
            this._effectCfg = null;
            this.stopEffectAnimation();
            this.onHoverStateChange = function(toState) {
                if (toState === "emphasis") {
                    if (effectCfg.showEffectOn !== "render") _this.startEffectAnimation(effectCfg);
                } else if (toState === "normal") {
                    if (effectCfg.showEffectOn !== "render") _this.stopEffectAnimation();
                }
            };
        }
        this._effectCfg = effectCfg;
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    };
    EffectSymbol.prototype.fadeOut = function(cb) {
        cb && cb();
    };
    return EffectSymbol;
}((0, $7ef7583d8302ffce$export$2e2bcd8739ae039));
var $fa583301cd9a2f5a$export$2e2bcd8739ae039 = $fa583301cd9a2f5a$var$EffectSymbol;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



function $73b014aa594ea652$export$2e2bcd8739ae039(seriesType, forceStoreInTypedArray) {
    return {
        seriesType: seriesType,
        plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            var coordSys = seriesModel.coordinateSystem;
            var pipelineContext = seriesModel.pipelineContext;
            var useTypedArray = forceStoreInTypedArray || pipelineContext.large;
            if (!coordSys) return;
            var dims = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys.dimensions, function(dim) {
                return data.mapDimension(dim);
            }).slice(0, 2);
            var dimLen = dims.length;
            var stackResultDim = data.getCalculationInfo("stackResultDimension");
            if ((0, $efdd976e4917927c$export$1dedc39359ae35c)(data, dims[0])) dims[0] = stackResultDim;
            if ((0, $efdd976e4917927c$export$1dedc39359ae35c)(data, dims[1])) dims[1] = stackResultDim;
            var store = data.getStore();
            var dimIdx0 = data.getDimensionIndex(dims[0]);
            var dimIdx1 = data.getDimensionIndex(dims[1]);
            return dimLen && {
                progress: function(params, data) {
                    var segCount = params.end - params.start;
                    var points = useTypedArray && (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(segCount * dimLen);
                    var tmpIn = [];
                    var tmpOut = [];
                    for(var i = params.start, offset = 0; i < params.end; i++){
                        var point = void 0;
                        if (dimLen === 1) {
                            var x = store.get(dimIdx0, i);
                            // NOTE: Make sure the second parameter is null to use default strategy.
                            point = coordSys.dataToPoint(x, null, tmpOut);
                        } else {
                            tmpIn[0] = store.get(dimIdx0, i);
                            tmpIn[1] = store.get(dimIdx1, i);
                            // Let coordinate system to handle the NaN data.
                            point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                        }
                        if (useTypedArray) {
                            points[offset++] = point[0];
                            points[offset++] = point[1];
                        } else data.setItemLayout(i, point.slice());
                    }
                    useTypedArray && data.setLayout("points", points);
                }
            };
        }
    };
}



var $41934e1dad128ad0$var$EffectScatterView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(EffectScatterView, _super);
    function EffectScatterView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = EffectScatterView.type;
        return _this;
    }
    EffectScatterView.prototype.init = function() {
        this._symbolDraw = new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)((0, $fa583301cd9a2f5a$export$2e2bcd8739ae039));
    };
    EffectScatterView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var effectSymbolDraw = this._symbolDraw;
        effectSymbolDraw.updateData(data, {
            clipShape: this._getClipShape(seriesModel)
        });
        this.group.add(effectSymbolDraw.group);
    };
    EffectScatterView.prototype._getClipShape = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
        return seriesModel.get("clip", true) ? clipArea : null;
    };
    EffectScatterView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        this.group.dirty();
        var res = (0, $73b014aa594ea652$export$2e2bcd8739ae039)("").reset(seriesModel, ecModel, api);
        if (res.progress) res.progress({
            start: 0,
            end: data.count(),
            count: data.count()
        }, data);
        this._symbolDraw.updateLayout();
    };
    EffectScatterView.prototype._updateGroupTransform = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.getRoamTransform) {
            this.group.transform = $f41ebb9dd60b55b4$export$9cd59f9826255e47(coordSys.getRoamTransform());
            this.group.decomposeTransform();
        }
    };
    EffectScatterView.prototype.remove = function(ecModel, api) {
        this._symbolDraw && this._symbolDraw.remove(true);
    };
    EffectScatterView.type = "effectScatter";
    return EffectScatterView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $41934e1dad128ad0$export$2e2bcd8739ae039 = $41934e1dad128ad0$var$EffectScatterView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $719c2a408bc8b7bb$var$EffectScatterSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(EffectScatterSeriesModel, _super);
    function EffectScatterSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = EffectScatterSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    EffectScatterSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    EffectScatterSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.point(data.getItemLayout(dataIndex));
    };
    EffectScatterSeriesModel.type = "series.effectScatter";
    EffectScatterSeriesModel.dependencies = [
        "grid",
        "polar"
    ];
    EffectScatterSeriesModel.defaultOption = {
        coordinateSystem: "cartesian2d",
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        effectType: "ripple",
        progressive: 0,
        // When to show the effect, option: 'render'|'emphasis'
        showEffectOn: "render",
        clip: true,
        // Ripple effect config
        rippleEffect: {
            period: 4,
            // Scale of ripple
            scale: 2.5,
            // Brush type can be fill or stroke
            brushType: "fill",
            // Ripple number
            number: 3
        },
        universalTransition: {
            divideShape: "clone"
        },
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // Polar coordinate system
        // polarIndex: 0,
        // Geo coordinate system
        // geoIndex: 0,
        // symbol: null,        // 图形类型
        symbolSize: 10 // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
    };
    return EffectScatterSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $719c2a408bc8b7bb$export$2e2bcd8739ae039 = $719c2a408bc8b7bb$var$EffectScatterSeriesModel;



function $a0fd335cdafe9e6e$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $41934e1dad128ad0$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $719c2a408bc8b7bb$export$2e2bcd8739ae039));
    registers.registerLayout((0, $73b014aa594ea652$export$2e2bcd8739ae039)("effectScatter"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $f4eb87a228be297f$var$PI2 = Math.PI * 2;
var $f4eb87a228be297f$var$CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
var $f4eb87a228be297f$var$DEFAULT_SEARCH_SPACE = [
    "top",
    "right",
    "bottom",
    "left"
];
function $f4eb87a228be297f$var$getCandidateAnchor(pos, distance, rect, outPt, outDir) {
    var width = rect.width;
    var height = rect.height;
    switch(pos){
        case "top":
            outPt.set(rect.x + width / 2, rect.y - distance);
            outDir.set(0, -1);
            break;
        case "bottom":
            outPt.set(rect.x + width / 2, rect.y + height + distance);
            outDir.set(0, 1);
            break;
        case "left":
            outPt.set(rect.x - distance, rect.y + height / 2);
            outDir.set(-1, 0);
            break;
        case "right":
            outPt.set(rect.x + width + distance, rect.y + height / 2);
            outDir.set(1, 0);
            break;
    }
}
function $f4eb87a228be297f$var$projectPointToArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y, out) {
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    x /= d;
    y /= d;
    // Intersect point.
    var ox = x * r + cx;
    var oy = y * r + cy;
    if (Math.abs(startAngle - endAngle) % $f4eb87a228be297f$var$PI2 < 1e-4) {
        // Is a circle
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(endAngle);
        endAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(tmp);
    } else {
        startAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(startAngle);
        endAngle = (0, $b44a8536c7214e4f$export$d44861331f213635)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $f4eb87a228be297f$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $f4eb87a228be297f$var$PI2;
    if (angle >= startAngle && angle <= endAngle || angle + $f4eb87a228be297f$var$PI2 >= startAngle && angle + $f4eb87a228be297f$var$PI2 <= endAngle) {
        // Project point is on the arc.
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    var x1 = r * Math.cos(startAngle) + cx;
    var y1 = r * Math.sin(startAngle) + cy;
    var x2 = r * Math.cos(endAngle) + cx;
    var y2 = r * Math.sin(endAngle) + cy;
    var d1 = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
    var d2 = (x2 - x) * (x2 - x) + (y2 - y) * (y2 - y);
    if (d1 < d2) {
        out[0] = x1;
        out[1] = y1;
        return Math.sqrt(d1);
    } else {
        out[0] = x2;
        out[1] = y2;
        return Math.sqrt(d2);
    }
}
function $f4eb87a228be297f$var$projectPointToLine(x1, y1, x2, y2, x, y, out, limitToEnds) {
    var dx = x - x1;
    var dy = y - y1;
    var dx1 = x2 - x1;
    var dy1 = y2 - y1;
    var lineLen = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    dx1 /= lineLen;
    dy1 /= lineLen;
    // dot product
    var projectedLen = dx * dx1 + dy * dy1;
    var t = projectedLen / lineLen;
    if (limitToEnds) t = Math.min(Math.max(t, 0), 1);
    t *= lineLen;
    var ox = out[0] = x1 + t * dx1;
    var oy = out[1] = y1 + t * dy1;
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
function $f4eb87a228be297f$var$projectPointToRect(x1, y1, width, height, x, y, out) {
    if (width < 0) {
        x1 = x1 + width;
        width = -width;
    }
    if (height < 0) {
        y1 = y1 + height;
        height = -height;
    }
    var x2 = x1 + width;
    var y2 = y1 + height;
    var ox = out[0] = Math.min(Math.max(x, x1), x2);
    var oy = out[1] = Math.min(Math.max(y, y1), y2);
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
var $f4eb87a228be297f$var$tmpPt = [];
function $f4eb87a228be297f$var$nearestPointOnRect(pt, rect, out) {
    var dist = $f4eb87a228be297f$var$projectPointToRect(rect.x, rect.y, rect.width, rect.height, pt.x, pt.y, $f4eb87a228be297f$var$tmpPt);
    out.set($f4eb87a228be297f$var$tmpPt[0], $f4eb87a228be297f$var$tmpPt[1]);
    return dist;
}
/**
 * Calculate min distance corresponding point.
 * This method won't evaluate if point is in the path.
 */ function $f4eb87a228be297f$var$nearestPointOnPath(pt, path, out) {
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    var minDist = Infinity;
    var data = path.data;
    var x = pt.x;
    var y = pt.y;
    for(var i = 0; i < data.length;){
        var cmd = data[i++];
        if (i === 1) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        var d = minDist;
        switch(cmd){
            case $f4eb87a228be297f$var$CMD.M:
                // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
                // 在 closePath 的时候使用
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $f4eb87a228be297f$var$CMD.L:
                d = $f4eb87a228be297f$var$projectPointToLine(xi, yi, data[i], data[i + 1], x, y, $f4eb87a228be297f$var$tmpPt, true);
                xi = data[i++];
                yi = data[i++];
                break;
            case $f4eb87a228be297f$var$CMD.C:
                d = (0, $747cfc5611b57cea$export$dbaa3801d1284367)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y, $f4eb87a228be297f$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $f4eb87a228be297f$var$CMD.Q:
                d = (0, $747cfc5611b57cea$export$81915a594fe10dee)(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y, $f4eb87a228be297f$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $f4eb87a228be297f$var$CMD.A:
                // TODO Arc 判断的开销比较大
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                // TODO Arc 旋转
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                // 不是直接使用 arc 命令
                if (i <= 1) {
                    // 第一个命令起点还未定义
                    x0 = x1;
                    y0 = y1;
                }
                // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
                var _x = (x - cx) * ry / rx + cx;
                d = $f4eb87a228be297f$var$projectPointToArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y, $f4eb87a228be297f$var$tmpPt);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $f4eb87a228be297f$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                d = $f4eb87a228be297f$var$projectPointToRect(x0, y0, width, height, x, y, $f4eb87a228be297f$var$tmpPt);
                break;
            case $f4eb87a228be297f$var$CMD.Z:
                d = $f4eb87a228be297f$var$projectPointToLine(xi, yi, x0, y0, x, y, $f4eb87a228be297f$var$tmpPt, true);
                xi = x0;
                yi = y0;
                break;
        }
        if (d < minDist) {
            minDist = d;
            out.set($f4eb87a228be297f$var$tmpPt[0], $f4eb87a228be297f$var$tmpPt[1]);
        }
    }
    return minDist;
}
// Temporal variable for intermediate usage.
var $f4eb87a228be297f$var$pt0 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f4eb87a228be297f$var$pt1 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f4eb87a228be297f$var$pt2 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f4eb87a228be297f$var$dir = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
var $f4eb87a228be297f$var$dir2 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
function $f4eb87a228be297f$export$cc93ba643cd97d83(target, labelLineModel) {
    if (!target) return;
    var labelLine = target.getTextGuideLine();
    var label = target.getTextContent();
    // Needs to create text guide in each charts.
    if (!(label && labelLine)) return;
    var labelGuideConfig = target.textGuideLineConfig || {};
    var points = [
        [
            0,
            0
        ],
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    var searchSpace = labelGuideConfig.candidates || $f4eb87a228be297f$var$DEFAULT_SEARCH_SPACE;
    var labelRect = label.getBoundingRect().clone();
    labelRect.applyTransform(label.getComputedTransform());
    var minDist = Infinity;
    var anchorPoint = labelGuideConfig.anchor;
    var targetTransform = target.getComputedTransform();
    var targetInversedTransform = targetTransform && (0, $f41ebb9dd60b55b4$export$6897c284b6f9f4dc)([], targetTransform);
    var len = labelLineModel.get("length2") || 0;
    if (anchorPoint) $f4eb87a228be297f$var$pt2.copy(anchorPoint);
    for(var i = 0; i < searchSpace.length; i++){
        var candidate = searchSpace[i];
        $f4eb87a228be297f$var$getCandidateAnchor(candidate, 0, labelRect, $f4eb87a228be297f$var$pt0, $f4eb87a228be297f$var$dir);
        (0, $b887f038f104fe7e$export$2e2bcd8739ae039).scaleAndAdd($f4eb87a228be297f$var$pt1, $f4eb87a228be297f$var$pt0, $f4eb87a228be297f$var$dir, len);
        // Transform to target coord space.
        $f4eb87a228be297f$var$pt1.transform(targetInversedTransform);
        // Note: getBoundingRect will ensure the `path` being created.
        var boundingRect = target.getBoundingRect();
        var dist = anchorPoint ? anchorPoint.distance($f4eb87a228be297f$var$pt1) : target instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039) ? $f4eb87a228be297f$var$nearestPointOnPath($f4eb87a228be297f$var$pt1, target.path, $f4eb87a228be297f$var$pt2) : $f4eb87a228be297f$var$nearestPointOnRect($f4eb87a228be297f$var$pt1, boundingRect, $f4eb87a228be297f$var$pt2);
        // TODO pt2 is in the path
        if (dist < minDist) {
            minDist = dist;
            // Transform back to global space.
            $f4eb87a228be297f$var$pt1.transform(targetTransform);
            $f4eb87a228be297f$var$pt2.transform(targetTransform);
            $f4eb87a228be297f$var$pt2.toArray(points[0]);
            $f4eb87a228be297f$var$pt1.toArray(points[1]);
            $f4eb87a228be297f$var$pt0.toArray(points[2]);
        }
    }
    $f4eb87a228be297f$export$ac52062003fbe6a(points, labelLineModel.get("minTurnAngle"));
    labelLine.setShape({
        points: points
    });
}
// Temporal variable for the limitTurnAngle function
var $f4eb87a228be297f$var$tmpArr = [];
var $f4eb87a228be297f$var$tmpProjPoint = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
function $f4eb87a228be297f$export$ac52062003fbe6a(linePoints, minTurnAngle) {
    if (!(minTurnAngle <= 180 && minTurnAngle > 0)) return;
    minTurnAngle = minTurnAngle / 180 * Math.PI;
    // The line points can be
    //      /pt1----pt2 (label)
    //     /
    // pt0/
    $f4eb87a228be297f$var$pt0.fromArray(linePoints[0]);
    $f4eb87a228be297f$var$pt1.fromArray(linePoints[1]);
    $f4eb87a228be297f$var$pt2.fromArray(linePoints[2]);
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub($f4eb87a228be297f$var$dir, $f4eb87a228be297f$var$pt0, $f4eb87a228be297f$var$pt1);
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub($f4eb87a228be297f$var$dir2, $f4eb87a228be297f$var$pt2, $f4eb87a228be297f$var$pt1);
    var len1 = $f4eb87a228be297f$var$dir.len();
    var len2 = $f4eb87a228be297f$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $f4eb87a228be297f$var$dir.scale(1 / len1);
    $f4eb87a228be297f$var$dir2.scale(1 / len2);
    var angleCos = $f4eb87a228be297f$var$dir.dot($f4eb87a228be297f$var$dir2);
    var minTurnAngleCos = Math.cos(minTurnAngle);
    if (minTurnAngleCos < angleCos) {
        // Smaller than minTurnAngle
        // Calculate project point of pt0 on pt1-pt2
        var d = $f4eb87a228be297f$var$projectPointToLine($f4eb87a228be297f$var$pt1.x, $f4eb87a228be297f$var$pt1.y, $f4eb87a228be297f$var$pt2.x, $f4eb87a228be297f$var$pt2.y, $f4eb87a228be297f$var$pt0.x, $f4eb87a228be297f$var$pt0.y, $f4eb87a228be297f$var$tmpArr, false);
        $f4eb87a228be297f$var$tmpProjPoint.fromArray($f4eb87a228be297f$var$tmpArr);
        // Calculate new projected length with limited minTurnAngle and get the new connect point
        $f4eb87a228be297f$var$tmpProjPoint.scaleAndAdd($f4eb87a228be297f$var$dir2, d / Math.tan(Math.PI - minTurnAngle));
        // Limit the new calculated connect point between pt1 and pt2.
        var t = $f4eb87a228be297f$var$pt2.x !== $f4eb87a228be297f$var$pt1.x ? ($f4eb87a228be297f$var$tmpProjPoint.x - $f4eb87a228be297f$var$pt1.x) / ($f4eb87a228be297f$var$pt2.x - $f4eb87a228be297f$var$pt1.x) : ($f4eb87a228be297f$var$tmpProjPoint.y - $f4eb87a228be297f$var$pt1.y) / ($f4eb87a228be297f$var$pt2.y - $f4eb87a228be297f$var$pt1.y);
        if (isNaN(t)) return;
        if (t < 0) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt1);
        else if (t > 1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt2);
        $f4eb87a228be297f$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $f4eb87a228be297f$export$973e1fdb2708f71b(linePoints, surfaceNormal, maxSurfaceAngle) {
    if (!(maxSurfaceAngle <= 180 && maxSurfaceAngle > 0)) return;
    maxSurfaceAngle = maxSurfaceAngle / 180 * Math.PI;
    $f4eb87a228be297f$var$pt0.fromArray(linePoints[0]);
    $f4eb87a228be297f$var$pt1.fromArray(linePoints[1]);
    $f4eb87a228be297f$var$pt2.fromArray(linePoints[2]);
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub($f4eb87a228be297f$var$dir, $f4eb87a228be297f$var$pt1, $f4eb87a228be297f$var$pt0);
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub($f4eb87a228be297f$var$dir2, $f4eb87a228be297f$var$pt2, $f4eb87a228be297f$var$pt1);
    var len1 = $f4eb87a228be297f$var$dir.len();
    var len2 = $f4eb87a228be297f$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $f4eb87a228be297f$var$dir.scale(1 / len1);
    $f4eb87a228be297f$var$dir2.scale(1 / len2);
    var angleCos = $f4eb87a228be297f$var$dir.dot(surfaceNormal);
    var maxSurfaceAngleCos = Math.cos(maxSurfaceAngle);
    if (angleCos < maxSurfaceAngleCos) {
        // Calculate project point of pt0 on pt1-pt2
        var d = $f4eb87a228be297f$var$projectPointToLine($f4eb87a228be297f$var$pt1.x, $f4eb87a228be297f$var$pt1.y, $f4eb87a228be297f$var$pt2.x, $f4eb87a228be297f$var$pt2.y, $f4eb87a228be297f$var$pt0.x, $f4eb87a228be297f$var$pt0.y, $f4eb87a228be297f$var$tmpArr, false);
        $f4eb87a228be297f$var$tmpProjPoint.fromArray($f4eb87a228be297f$var$tmpArr);
        var HALF_PI = Math.PI / 2;
        var angle2 = Math.acos($f4eb87a228be297f$var$dir2.dot(surfaceNormal));
        var newAngle = HALF_PI + angle2 - maxSurfaceAngle;
        if (newAngle >= HALF_PI) // parallel
        (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt2);
        else {
            // Calculate new projected length with limited minTurnAngle and get the new connect point
            $f4eb87a228be297f$var$tmpProjPoint.scaleAndAdd($f4eb87a228be297f$var$dir2, d / Math.tan(Math.PI / 2 - newAngle));
            // Limit the new calculated connect point between pt1 and pt2.
            var t = $f4eb87a228be297f$var$pt2.x !== $f4eb87a228be297f$var$pt1.x ? ($f4eb87a228be297f$var$tmpProjPoint.x - $f4eb87a228be297f$var$pt1.x) / ($f4eb87a228be297f$var$pt2.x - $f4eb87a228be297f$var$pt1.x) : ($f4eb87a228be297f$var$tmpProjPoint.y - $f4eb87a228be297f$var$pt1.y) / ($f4eb87a228be297f$var$pt2.y - $f4eb87a228be297f$var$pt1.y);
            if (isNaN(t)) return;
            if (t < 0) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt1);
            else if (t > 1) (0, $b887f038f104fe7e$export$2e2bcd8739ae039).copy($f4eb87a228be297f$var$tmpProjPoint, $f4eb87a228be297f$var$pt2);
        }
        $f4eb87a228be297f$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $f4eb87a228be297f$var$setLabelLineState(labelLine, ignore, stateName, stateModel) {
    var isNormal = stateName === "normal";
    var stateObj = isNormal ? labelLine : labelLine.ensureState(stateName);
    // Make sure display.
    stateObj.ignore = ignore;
    // Set smooth
    var smooth = stateModel.get("smooth");
    if (smooth && smooth === true) smooth = 0.3;
    stateObj.shape = stateObj.shape || {};
    if (smooth > 0) stateObj.shape.smooth = smooth;
    var styleObj = stateModel.getModel("lineStyle").getLineStyle();
    isNormal ? labelLine.useStyle(styleObj) : stateObj.style = styleObj;
}
function $f4eb87a228be297f$var$buildLabelLinePath(path, shape) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (!points) return;
    path.moveTo(points[0][0], points[0][1]);
    if (smooth > 0 && points.length >= 3) {
        var len1 = $6de594cf8ac295ff$export$6c4a311cc157c764(points[0], points[1]);
        var len2 = $6de594cf8ac295ff$export$6c4a311cc157c764(points[1], points[2]);
        if (!len1 || !len2) {
            path.lineTo(points[1][0], points[1][1]);
            path.lineTo(points[2][0], points[2][1]);
            return;
        }
        var moveLen = Math.min(len1, len2) * smooth;
        var midPoint0 = $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f([], points[1], points[0], moveLen / len1);
        var midPoint2 = $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f([], points[1], points[2], moveLen / len2);
        var midPoint1 = $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f([], midPoint0, midPoint2, 0.5);
        path.bezierCurveTo(midPoint0[0], midPoint0[1], midPoint0[0], midPoint0[1], midPoint1[0], midPoint1[1]);
        path.bezierCurveTo(midPoint2[0], midPoint2[1], midPoint2[0], midPoint2[1], points[2][0], points[2][1]);
    } else for(var i = 1; i < points.length; i++)path.lineTo(points[i][0], points[i][1]);
}
function $f4eb87a228be297f$export$c09e0b0574bdd2dc(targetEl, statesModels, defaultStyle) {
    var labelLine = targetEl.getTextGuideLine();
    var label = targetEl.getTextContent();
    if (!label) {
        // Not show label line if there is no label.
        if (labelLine) targetEl.removeTextGuideLine();
        return;
    }
    var normalModel = statesModels.normal;
    var showNormal = normalModel.get("show");
    var labelIgnoreNormal = label.ignore;
    for(var i = 0; i < (0, $2bf82c0980125b62$export$57ee5306b85ad7d5).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$57ee5306b85ad7d5)[i];
        var stateModel = statesModels[stateName];
        var isNormal = stateName === "normal";
        if (stateModel) {
            var stateShow = stateModel.get("show");
            var isLabelIgnored = isNormal ? labelIgnoreNormal : (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(label.states[stateName] && label.states[stateName].ignore, labelIgnoreNormal);
            if (isLabelIgnored // Not show when label is not shown in this state.
             || !(0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(stateShow, showNormal) // Use normal state by default if not set.
            ) {
                var stateObj = isNormal ? labelLine : labelLine && labelLine.states[stateName];
                if (stateObj) stateObj.ignore = true;
                if (!!labelLine) $f4eb87a228be297f$var$setLabelLineState(labelLine, true, stateName, stateModel);
                continue;
            }
            // Create labelLine if not exists
            if (!labelLine) {
                labelLine = new (0, $d28119f30e6bb670$export$2e2bcd8739ae039)();
                targetEl.setTextGuideLine(labelLine);
                // Reset state of normal because it's new created.
                // NOTE: NORMAL should always been the first!
                if (!isNormal && (labelIgnoreNormal || !showNormal)) $f4eb87a228be297f$var$setLabelLineState(labelLine, true, "normal", statesModels.normal);
                // Use same state proxy.
                if (targetEl.stateProxy) labelLine.stateProxy = targetEl.stateProxy;
            }
            $f4eb87a228be297f$var$setLabelLineState(labelLine, false, stateName, stateModel);
        }
    }
    if (labelLine) {
        (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(labelLine.style, defaultStyle);
        // Not fill.
        labelLine.style.fill = null;
        var showAbove = normalModel.get("showAbove");
        var labelLineConfig = targetEl.textGuideLineConfig = targetEl.textGuideLineConfig || {};
        labelLineConfig.showAbove = showAbove || false;
        // Custom the buildPath.
        labelLine.buildPath = $f4eb87a228be297f$var$buildLabelLinePath;
    }
}
function $f4eb87a228be297f$export$2979fdbf5ebce521(itemModel, labelLineName) {
    labelLineName = labelLineName || "labelLine";
    var statesModels = {
        normal: itemModel.getModel(labelLineName)
    };
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelLineName
        ]);
    }
    return statesModels;
}




var $a34a81cc5e14c818$var$opacityAccessPath = [
    "itemStyle",
    "opacity"
];
/**
 * Piece of pie including Sector, Label, LabelLine
 */ var $a34a81cc5e14c818$var$FunnelPiece = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(FunnelPiece, _super);
    function FunnelPiece(data, idx) {
        var _this = _super.call(this) || this;
        var polygon = _this;
        var labelLine = new $d28119f30e6bb670$export$2e2bcd8739ae039();
        var text = new $fe885cc21795562b$export$2e2bcd8739ae039();
        polygon.setTextContent(text);
        _this.setTextGuideLine(labelLine);
        _this.updateData(data, idx, true);
        return _this;
    }
    FunnelPiece.prototype.updateData = function(data, idx, firstCreate) {
        var polygon = this;
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var layout = data.getItemLayout(idx);
        var emphasisModel = itemModel.getModel("emphasis");
        var opacity = itemModel.get($a34a81cc5e14c818$var$opacityAccessPath);
        opacity = opacity == null ? 1 : opacity;
        if (!firstCreate) (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(polygon);
        // Update common style
        polygon.useStyle(data.getItemVisual(idx, "style"));
        polygon.style.lineJoin = "round";
        if (firstCreate) {
            polygon.setShape({
                points: layout.points
            });
            polygon.style.opacity = 0;
            $8b353638fbedfefa$export$a121566aadcfe021(polygon, {
                style: {
                    opacity: opacity
                }
            }, seriesModel, idx);
        } else $8b353638fbedfefa$export$c8dce3c08436e91e(polygon, {
            style: {
                opacity: opacity
            },
            shape: {
                points: layout.points
            }
        }, seriesModel, idx);
        (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, itemModel);
        this._updateLabel(data, idx);
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    };
    FunnelPiece.prototype._updateLabel = function(data, idx) {
        var polygon = this;
        var labelLine = this.getTextGuideLine();
        var labelText = polygon.getTextContent();
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var layout = data.getItemLayout(idx);
        var labelLayout = layout.label;
        var style = data.getItemVisual(idx, "style");
        var visualColor = style.fill;
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(// position will not be used in setLabelStyle
        labelText, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
            labelFetcher: data.hostModel,
            labelDataIndex: idx,
            defaultOpacity: style.opacity,
            defaultText: data.getName(idx)
        }, {
            normal: {
                align: labelLayout.textAlign,
                verticalAlign: labelLayout.verticalAlign
            }
        });
        polygon.setTextConfig({
            local: true,
            inside: !!labelLayout.inside,
            insideStroke: visualColor,
            // insideFill: 'auto',
            outsideFill: visualColor
        });
        var linePoints = labelLayout.linePoints;
        labelLine.setShape({
            points: linePoints
        });
        polygon.textGuideLineConfig = {
            anchor: linePoints ? new $b887f038f104fe7e$export$2e2bcd8739ae039(linePoints[0][0], linePoints[0][1]) : null
        };
        // Make sure update style on labelText after setLabelStyle.
        // Because setLabelStyle will replace a new style on it.
        $8b353638fbedfefa$export$c8dce3c08436e91e(labelText, {
            style: {
                x: labelLayout.x,
                y: labelLayout.y
            }
        }, seriesModel, idx);
        labelText.attr({
            rotation: labelLayout.rotation,
            originX: labelLayout.x,
            originY: labelLayout.y,
            z2: 10
        });
        (0, $f4eb87a228be297f$export$c09e0b0574bdd2dc)(polygon, (0, $f4eb87a228be297f$export$2979fdbf5ebce521)(itemModel), {
            // Default use item visual color
            stroke: visualColor
        });
    };
    return FunnelPiece;
}($51acf033123e1a30$export$2e2bcd8739ae039);
var $a34a81cc5e14c818$var$FunnelView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(FunnelView, _super);
    function FunnelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = FunnelView.type;
        _this.ignoreLabelLineUpdate = true;
        return _this;
    }
    FunnelView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        data.diff(oldData).add(function(idx) {
            var funnelPiece = new $a34a81cc5e14c818$var$FunnelPiece(data, idx);
            data.setItemGraphicEl(idx, funnelPiece);
            group.add(funnelPiece);
        }).update(function(newIdx, oldIdx) {
            var piece = oldData.getItemGraphicEl(oldIdx);
            piece.updateData(data, newIdx);
            group.add(piece);
            data.setItemGraphicEl(newIdx, piece);
        }).remove(function(idx) {
            var piece = oldData.getItemGraphicEl(idx);
            $8b353638fbedfefa$export$6d0fd725cb4aee8a(piece, seriesModel, idx);
        }).execute();
        this._data = data;
    };
    FunnelView.prototype.remove = function() {
        this.group.removeAll();
        this._data = null;
    };
    FunnelView.prototype.dispose = function() {};
    FunnelView.type = "funnel";
    return FunnelView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $a34a81cc5e14c818$export$2e2bcd8739ae039 = $a34a81cc5e14c818$var$FunnelView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * LegendVisualProvider is an bridge that pick encoded color from data and
 * provide to the legend component.
 */ var $cf24728fc17c4ab6$var$LegendVisualProvider = /** @class */ function() {
    function LegendVisualProvider(// Function to get data after filtered. It stores all the encoding info
    getDataWithEncodedVisual, // Function to get raw data before filtered.
    getRawData) {
        this._getDataWithEncodedVisual = getDataWithEncodedVisual;
        this._getRawData = getRawData;
    }
    LegendVisualProvider.prototype.getAllNames = function() {
        var rawData = this._getRawData();
        // We find the name from the raw data. In case it's filtered by the legend component.
        // Normally, the name can be found in rawData, but can't be found in filtered data will display as gray.
        return rawData.mapArray(rawData.getName);
    };
    LegendVisualProvider.prototype.containName = function(name) {
        var rawData = this._getRawData();
        return rawData.indexOfName(name) >= 0;
    };
    LegendVisualProvider.prototype.indexOfName = function(name) {
        // Only get data when necessary.
        // Because LegendVisualProvider constructor may be new in the stage that data is not prepared yet.
        // Invoking Series#getData immediately will throw an error.
        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
        return dataWithEncodedVisual.indexOfName(name);
    };
    LegendVisualProvider.prototype.getItemVisual = function(dataIndex, key) {
        // Get encoded visual properties from final filtered data.
        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
        return dataWithEncodedVisual.getItemVisual(dataIndex, key);
    };
    return LegendVisualProvider;
}();
var $cf24728fc17c4ab6$export$2e2bcd8739ae039 = $cf24728fc17c4ab6$var$LegendVisualProvider;



var $3ac6efc4b95638aa$var$FunnelSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(FunnelSeriesModel, _super);
    function FunnelSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = FunnelSeriesModel.type;
        return _this;
    }
    FunnelSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)($7a1bd9c2710fea0d$export$2385a24977818dd0(this.getData, this), $7a1bd9c2710fea0d$export$2385a24977818dd0(this.getRawData, this));
        // Extend labelLine emphasis
        this._defaultLabelLine(option);
    };
    FunnelSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            coordDimensions: [
                "value"
            ],
            encodeDefaulter: $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$60b8a57d1f2fed26), this)
        });
    };
    FunnelSeriesModel.prototype._defaultLabelLine = function(option) {
        // Extend labelLine emphasis
        (0, $76d619f648247e6d$export$abdcc6a26372f94b)(option, "labelLine", [
            "show"
        ]);
        var labelLineNormalOpt = option.labelLine;
        var labelLineEmphasisOpt = option.emphasis.labelLine;
        // Not show label line if `label.normal.show = false`
        labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
        labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
    };
    // Overwrite
    FunnelSeriesModel.prototype.getDataParams = function(dataIndex) {
        var data = this.getData();
        var params = _super.prototype.getDataParams.call(this, dataIndex);
        var valueDim = data.mapDimension("value");
        var sum = data.getSum(valueDim);
        // Percent is 0 if sum is 0
        params.percent = !sum ? 0 : +(data.get(valueDim, dataIndex) / sum * 100).toFixed(2);
        params.$vars.push("percent");
        return params;
    };
    FunnelSeriesModel.type = "series.funnel";
    FunnelSeriesModel.defaultOption = {
        // zlevel: 0,                  // 一级层叠
        z: 2,
        legendHoverLink: true,
        colorBy: "data",
        left: 80,
        top: 60,
        right: 80,
        bottom: 60,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        // 默认取数据最小最大值
        // min: 0,
        // max: 100,
        minSize: "0%",
        maxSize: "100%",
        sort: "descending",
        orient: "vertical",
        gap: 0,
        funnelAlign: "center",
        label: {
            show: true,
            position: "outer"
        },
        labelLine: {
            show: true,
            length: 20,
            lineStyle: {
                // color: 各异,
                width: 1
            }
        },
        itemStyle: {
            // color: 各异,
            borderColor: "#fff",
            borderWidth: 1
        },
        emphasis: {
            label: {
                show: true
            }
        },
        select: {
            itemStyle: {
                borderColor: "#212121"
            }
        }
    };
    return FunnelSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $3ac6efc4b95638aa$export$2e2bcd8739ae039 = $3ac6efc4b95638aa$var$FunnelSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $4e9f9ac9332ed124$var$getViewRect(seriesModel, api) {
    return $93b9bc7f22ac7369$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $4e9f9ac9332ed124$var$getSortedIndices(data, sort) {
    var valueDim = data.mapDimension("value");
    var valueArr = data.mapArray(valueDim, function(val) {
        return val;
    });
    var indices = [];
    var isAscending = sort === "ascending";
    for(var i = 0, len = data.count(); i < len; i++)indices[i] = i;
    // Add custom sortable function & none sortable opetion by "options.sort"
    if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(sort)) indices.sort(sort);
    else if (sort !== "none") indices.sort(function(a, b) {
        return isAscending ? valueArr[a] - valueArr[b] : valueArr[b] - valueArr[a];
    });
    return indices;
}
function $4e9f9ac9332ed124$var$labelLayout(data) {
    var seriesModel = data.hostModel;
    var orient = seriesModel.get("orient");
    data.each(function(idx) {
        var itemModel = data.getItemModel(idx);
        var labelModel = itemModel.getModel("label");
        var labelPosition = labelModel.get("position");
        var labelLineModel = itemModel.getModel("labelLine");
        var layout = data.getItemLayout(idx);
        var points = layout.points;
        var isLabelInside = labelPosition === "inner" || labelPosition === "inside" || labelPosition === "center" || labelPosition === "insideLeft" || labelPosition === "insideRight";
        var textAlign;
        var textX;
        var textY;
        var linePoints;
        if (isLabelInside) {
            if (labelPosition === "insideLeft") {
                textX = (points[0][0] + points[3][0]) / 2 + 5;
                textY = (points[0][1] + points[3][1]) / 2;
                textAlign = "left";
            } else if (labelPosition === "insideRight") {
                textX = (points[1][0] + points[2][0]) / 2 - 5;
                textY = (points[1][1] + points[2][1]) / 2;
                textAlign = "right";
            } else {
                textX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4;
                textY = (points[0][1] + points[1][1] + points[2][1] + points[3][1]) / 4;
                textAlign = "center";
            }
            linePoints = [
                [
                    textX,
                    textY
                ],
                [
                    textX,
                    textY
                ]
            ];
        } else {
            var x1 = void 0;
            var y1 = void 0;
            var x2 = void 0;
            var y2 = void 0;
            var labelLineLen = labelLineModel.get("length");
            if (labelPosition === "left") {
                // Left side
                x1 = (points[3][0] + points[0][0]) / 2;
                y1 = (points[3][1] + points[0][1]) / 2;
                x2 = x1 - labelLineLen;
                textX = x2 - 5;
                textAlign = "right";
            } else if (labelPosition === "right") {
                // Right side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                x2 = x1 + labelLineLen;
                textX = x2 + 5;
                textAlign = "left";
            } else if (labelPosition === "top") {
                // Top side
                x1 = (points[3][0] + points[0][0]) / 2;
                y1 = (points[3][1] + points[0][1]) / 2;
                y2 = y1 - labelLineLen;
                textY = y2 - 5;
                textAlign = "center";
            } else if (labelPosition === "bottom") {
                // Bottom side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                y2 = y1 + labelLineLen;
                textY = y2 + 5;
                textAlign = "center";
            } else if (labelPosition === "rightTop") {
                // RightTop side
                x1 = orient === "horizontal" ? points[3][0] : points[1][0];
                y1 = orient === "horizontal" ? points[3][1] : points[1][1];
                if (orient === "horizontal") {
                    y2 = y1 - labelLineLen;
                    textY = y2 - 5;
                    textAlign = "center";
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = "top";
                }
            } else if (labelPosition === "rightBottom") {
                // RightBottom side
                x1 = points[2][0];
                y1 = points[2][1];
                if (orient === "horizontal") {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = "center";
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = "bottom";
                }
            } else if (labelPosition === "leftTop") {
                // LeftTop side
                x1 = points[0][0];
                y1 = orient === "horizontal" ? points[0][1] : points[1][1];
                if (orient === "horizontal") {
                    y2 = y1 - labelLineLen;
                    textY = y2 - 5;
                    textAlign = "center";
                } else {
                    x2 = x1 - labelLineLen;
                    textX = x2 - 5;
                    textAlign = "right";
                }
            } else if (labelPosition === "leftBottom") {
                // LeftBottom side
                x1 = orient === "horizontal" ? points[1][0] : points[3][0];
                y1 = orient === "horizontal" ? points[1][1] : points[2][1];
                if (orient === "horizontal") {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = "center";
                } else {
                    x2 = x1 - labelLineLen;
                    textX = x2 - 5;
                    textAlign = "right";
                }
            } else {
                // Right side or Bottom side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                if (orient === "horizontal") {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = "center";
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = "left";
                }
            }
            if (orient === "horizontal") {
                x2 = x1;
                textX = x2;
            } else {
                y2 = y1;
                textY = y2;
            }
            linePoints = [
                [
                    x1,
                    y1
                ],
                [
                    x2,
                    y2
                ]
            ];
        }
        layout.label = {
            linePoints: linePoints,
            x: textX,
            y: textY,
            verticalAlign: "middle",
            textAlign: textAlign,
            inside: isLabelInside
        };
    });
}
function $4e9f9ac9332ed124$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType("funnel", function(seriesModel) {
        var data = seriesModel.getData();
        var valueDim = data.mapDimension("value");
        var sort = seriesModel.get("sort");
        var viewRect = $4e9f9ac9332ed124$var$getViewRect(seriesModel, api);
        var orient = seriesModel.get("orient");
        var viewWidth = viewRect.width;
        var viewHeight = viewRect.height;
        var indices = $4e9f9ac9332ed124$var$getSortedIndices(data, sort);
        var x = viewRect.x;
        var y = viewRect.y;
        var sizeExtent = orient === "horizontal" ? [
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("minSize"), viewHeight),
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("maxSize"), viewHeight)
        ] : [
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("minSize"), viewWidth),
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("maxSize"), viewWidth)
        ];
        var dataExtent = data.getDataExtent(valueDim);
        var min = seriesModel.get("min");
        var max = seriesModel.get("max");
        if (min == null) min = Math.min(dataExtent[0], 0);
        if (max == null) max = dataExtent[1];
        var funnelAlign = seriesModel.get("funnelAlign");
        var gap = seriesModel.get("gap");
        var viewSize = orient === "horizontal" ? viewWidth : viewHeight;
        var itemSize = (viewSize - gap * (data.count() - 1)) / data.count();
        var getLinePoints = function(idx, offset) {
            // End point index is data.count() and we assign it 0
            if (orient === "horizontal") {
                var val_1 = data.get(valueDim, idx) || 0;
                var itemHeight = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val_1, [
                    min,
                    max
                ], sizeExtent, true);
                var y0 = void 0;
                switch(funnelAlign){
                    case "top":
                        y0 = y;
                        break;
                    case "center":
                        y0 = y + (viewHeight - itemHeight) / 2;
                        break;
                    case "bottom":
                        y0 = y + (viewHeight - itemHeight);
                        break;
                }
                return [
                    [
                        offset,
                        y0
                    ],
                    [
                        offset,
                        y0 + itemHeight
                    ]
                ];
            }
            var val = data.get(valueDim, idx) || 0;
            var itemWidth = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, [
                min,
                max
            ], sizeExtent, true);
            var x0;
            switch(funnelAlign){
                case "left":
                    x0 = x;
                    break;
                case "center":
                    x0 = x + (viewWidth - itemWidth) / 2;
                    break;
                case "right":
                    x0 = x + viewWidth - itemWidth;
                    break;
            }
            return [
                [
                    x0,
                    offset
                ],
                [
                    x0 + itemWidth,
                    offset
                ]
            ];
        };
        if (sort === "ascending") {
            // From bottom to top
            itemSize = -itemSize;
            gap = -gap;
            if (orient === "horizontal") x += viewWidth;
            else y += viewHeight;
            indices = indices.reverse();
        }
        for(var i = 0; i < indices.length; i++){
            var idx = indices[i];
            var nextIdx = indices[i + 1];
            var itemModel = data.getItemModel(idx);
            if (orient === "horizontal") {
                var width = itemModel.get([
                    "itemStyle",
                    "width"
                ]);
                if (width == null) width = itemSize;
                else {
                    width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(width, viewWidth);
                    if (sort === "ascending") width = -width;
                }
                var start = getLinePoints(idx, x);
                var end = getLinePoints(nextIdx, x + width);
                x += width + gap;
                data.setItemLayout(idx, {
                    points: start.concat(end.slice().reverse())
                });
            } else {
                var height = itemModel.get([
                    "itemStyle",
                    "height"
                ]);
                if (height == null) height = itemSize;
                else {
                    height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(height, viewHeight);
                    if (sort === "ascending") height = -height;
                }
                var start = getLinePoints(idx, y);
                var end = getLinePoints(nextIdx, y + height);
                y += height + gap;
                data.setItemLayout(idx, {
                    points: start.concat(end.slice().reverse())
                });
            }
        }
        $4e9f9ac9332ed124$var$labelLayout(data);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $e11a533bf70b759c$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        reset: function(seriesModel, ecModel) {
            var legendModels = ecModel.findComponents({
                mainType: "legend"
            });
            if (!legendModels || !legendModels.length) return;
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                var name = data.getName(idx);
                // If in any legend component the status is not selected.
                for(var i = 0; i < legendModels.length; i++){
                    // @ts-ignore FIXME: LegendModel
                    if (!legendModels[i].isSelected(name)) return false;
                }
                return true;
            });
        }
    };
}


function $2bdc3734cdc2f6c8$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $a34a81cc5e14c818$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $3ac6efc4b95638aa$export$2e2bcd8739ae039));
    registers.registerLayout((0, $4e9f9ac9332ed124$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $e11a533bf70b759c$export$2e2bcd8739ae039)("funnel"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $ea4af8acc4ea1022$var$PointerShape = /** @class */ function() {
    function PointerShape() {
        this.angle = 0;
        this.width = 10;
        this.r = 10;
        this.x = 0;
        this.y = 0;
    }
    return PointerShape;
}();
var $ea4af8acc4ea1022$var$PointerPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PointerPath, _super);
    function PointerPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "pointer";
        return _this;
    }
    PointerPath.prototype.getDefaultShape = function() {
        return new $ea4af8acc4ea1022$var$PointerShape();
    };
    PointerPath.prototype.buildPath = function(ctx, shape) {
        var mathCos = Math.cos;
        var mathSin = Math.sin;
        var r = shape.r;
        var width = shape.width;
        var angle = shape.angle;
        var x = shape.x - mathCos(angle) * width * (width >= r / 3 ? 1 : 2);
        var y = shape.y - mathSin(angle) * width * (width >= r / 3 ? 1 : 2);
        angle = shape.angle - Math.PI / 2;
        ctx.moveTo(x, y);
        ctx.lineTo(shape.x + mathCos(angle) * width, shape.y + mathSin(angle) * width);
        ctx.lineTo(shape.x + mathCos(shape.angle) * r, shape.y + mathSin(shape.angle) * r);
        ctx.lineTo(shape.x - mathCos(angle) * width, shape.y - mathSin(angle) * width);
        ctx.lineTo(x, y);
    };
    return PointerPath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $ea4af8acc4ea1022$export$2e2bcd8739ae039 = $ea4af8acc4ea1022$var$PointerPath;













function $f677de6b1db15bcf$var$parsePosition(seriesModel, api) {
    var center = seriesModel.get("center");
    var width = api.getWidth();
    var height = api.getHeight();
    var size = Math.min(width, height);
    var cx = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[0], api.getWidth());
    var cy = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[1], api.getHeight());
    var r = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("radius"), size / 2);
    return {
        cx: cx,
        cy: cy,
        r: r
    };
}
function $f677de6b1db15bcf$var$formatLabel(value, labelFormatter) {
    var label = value == null ? "" : value + "";
    if (labelFormatter) {
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(labelFormatter)) label = labelFormatter.replace("{value}", label);
        else if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(labelFormatter)) label = labelFormatter(value);
    }
    return label;
}
var $f677de6b1db15bcf$var$GaugeView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GaugeView, _super);
    function GaugeView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GaugeView.type;
        return _this;
    }
    GaugeView.prototype.render = function(seriesModel, ecModel, api) {
        this.group.removeAll();
        var colorList = seriesModel.get([
            "axisLine",
            "lineStyle",
            "color"
        ]);
        var posInfo = $f677de6b1db15bcf$var$parsePosition(seriesModel, api);
        this._renderMain(seriesModel, ecModel, api, colorList, posInfo);
        this._data = seriesModel.getData();
    };
    GaugeView.prototype.dispose = function() {};
    GaugeView.prototype._renderMain = function(seriesModel, ecModel, api, colorList, posInfo) {
        var group = this.group;
        var clockwise = seriesModel.get("clockwise");
        var startAngle = -seriesModel.get("startAngle") / 180 * Math.PI;
        var endAngle = -seriesModel.get("endAngle") / 180 * Math.PI;
        var axisLineModel = seriesModel.getModel("axisLine");
        var roundCap = axisLineModel.get("roundCap");
        var MainPath = roundCap ? (0, $9674946a7a7df213$export$2e2bcd8739ae039) : $a3e1dec0a3875b49$export$2e2bcd8739ae039;
        var showAxis = axisLineModel.get("show");
        var lineStyleModel = axisLineModel.getModel("lineStyle");
        var axisLineWidth = lineStyleModel.get("width");
        var angles = [
            startAngle,
            endAngle
        ];
        (0, $20ebe2448f123f2e$export$bc668021e937022a)(angles, !clockwise);
        startAngle = angles[0];
        endAngle = angles[1];
        var angleRangeSpan = endAngle - startAngle;
        var prevEndAngle = startAngle;
        var sectors = [];
        for(var i = 0; showAxis && i < colorList.length; i++){
            // Clamp
            var percent = Math.min(Math.max(colorList[i][0], 0), 1);
            endAngle = startAngle + angleRangeSpan * percent;
            var sector = new MainPath({
                shape: {
                    startAngle: prevEndAngle,
                    endAngle: endAngle,
                    cx: posInfo.cx,
                    cy: posInfo.cy,
                    clockwise: clockwise,
                    r0: posInfo.r - axisLineWidth,
                    r: posInfo.r
                },
                silent: true
            });
            sector.setStyle({
                fill: colorList[i][1]
            });
            sector.setStyle(lineStyleModel.getLineStyle(// Because we use sector to simulate arc
            // so the properties for stroking are useless
            [
                "color",
                "width"
            ]));
            sectors.push(sector);
            prevEndAngle = endAngle;
        }
        sectors.reverse();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(sectors, function(sector) {
            return group.add(sector);
        });
        var getColor = function(percent) {
            // Less than 0
            if (percent <= 0) return colorList[0][1];
            var i;
            for(i = 0; i < colorList.length; i++){
                if (colorList[i][0] >= percent && (i === 0 ? 0 : colorList[i - 1][0]) < percent) return colorList[i][1];
            }
            // More than 1
            return colorList[i - 1][1];
        };
        this._renderTicks(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth);
        this._renderTitleAndDetail(seriesModel, ecModel, api, getColor, posInfo);
        this._renderAnchor(seriesModel, posInfo);
        this._renderPointer(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth);
    };
    GaugeView.prototype._renderTicks = function(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth) {
        var group = this.group;
        var cx = posInfo.cx;
        var cy = posInfo.cy;
        var r = posInfo.r;
        var minVal = +seriesModel.get("min");
        var maxVal = +seriesModel.get("max");
        var splitLineModel = seriesModel.getModel("splitLine");
        var tickModel = seriesModel.getModel("axisTick");
        var labelModel = seriesModel.getModel("axisLabel");
        var splitNumber = seriesModel.get("splitNumber");
        var subSplitNumber = tickModel.get("splitNumber");
        var splitLineLen = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(splitLineModel.get("length"), r);
        var tickLen = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(tickModel.get("length"), r);
        var angle = startAngle;
        var step = (endAngle - startAngle) / splitNumber;
        var subStep = step / subSplitNumber;
        var splitLineStyle = splitLineModel.getModel("lineStyle").getLineStyle();
        var tickLineStyle = tickModel.getModel("lineStyle").getLineStyle();
        var splitLineDistance = splitLineModel.get("distance");
        var unitX;
        var unitY;
        for(var i = 0; i <= splitNumber; i++){
            unitX = Math.cos(angle);
            unitY = Math.sin(angle);
            // Split line
            if (splitLineModel.get("show")) {
                var distance = splitLineDistance ? splitLineDistance + axisLineWidth : axisLineWidth;
                var splitLine = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                    shape: {
                        x1: unitX * (r - distance) + cx,
                        y1: unitY * (r - distance) + cy,
                        x2: unitX * (r - splitLineLen - distance) + cx,
                        y2: unitY * (r - splitLineLen - distance) + cy
                    },
                    style: splitLineStyle,
                    silent: true
                });
                if (splitLineStyle.stroke === "auto") splitLine.setStyle({
                    stroke: getColor(i / splitNumber)
                });
                group.add(splitLine);
            }
            // Label
            if (labelModel.get("show")) {
                var distance = labelModel.get("distance") + splitLineDistance;
                var label = $f677de6b1db15bcf$var$formatLabel((0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(i / splitNumber * (maxVal - minVal) + minVal), labelModel.get("formatter"));
                var autoColor = getColor(i / splitNumber);
                var textStyleX = unitX * (r - splitLineLen - distance) + cx;
                var textStyleY = unitY * (r - splitLineLen - distance) + cy;
                var rotateType = labelModel.get("rotate");
                var rotate = 0;
                if (rotateType === "radial") {
                    rotate = -angle + 2 * Math.PI;
                    if (rotate > Math.PI / 2) rotate += Math.PI;
                } else if (rotateType === "tangential") rotate = -angle - Math.PI / 2;
                else if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rotateType)) rotate = rotateType * Math.PI / 180;
                if (rotate === 0) group.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelModel, {
                        text: label,
                        x: textStyleX,
                        y: textStyleY,
                        verticalAlign: unitY < -0.8 ? "top" : unitY > 0.8 ? "bottom" : "middle",
                        align: unitX < -0.4 ? "left" : unitX > 0.4 ? "right" : "center"
                    }, {
                        inheritColor: autoColor
                    }),
                    silent: true
                }));
                else group.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelModel, {
                        text: label,
                        x: textStyleX,
                        y: textStyleY,
                        verticalAlign: "middle",
                        align: "center"
                    }, {
                        inheritColor: autoColor
                    }),
                    silent: true,
                    originX: textStyleX,
                    originY: textStyleY,
                    rotation: rotate
                }));
            }
            // Axis tick
            if (tickModel.get("show") && i !== splitNumber) {
                var distance = tickModel.get("distance");
                distance = distance ? distance + axisLineWidth : axisLineWidth;
                for(var j = 0; j <= subSplitNumber; j++){
                    unitX = Math.cos(angle);
                    unitY = Math.sin(angle);
                    var tickLine = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                        shape: {
                            x1: unitX * (r - distance) + cx,
                            y1: unitY * (r - distance) + cy,
                            x2: unitX * (r - tickLen - distance) + cx,
                            y2: unitY * (r - tickLen - distance) + cy
                        },
                        silent: true,
                        style: tickLineStyle
                    });
                    if (tickLineStyle.stroke === "auto") tickLine.setStyle({
                        stroke: getColor((i + j / subSplitNumber) / splitNumber)
                    });
                    group.add(tickLine);
                    angle += subStep;
                }
                angle -= subStep;
            } else angle += step;
        }
    };
    GaugeView.prototype._renderPointer = function(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth) {
        var group = this.group;
        var oldData = this._data;
        var oldProgressData = this._progressEls;
        var progressList = [];
        var showPointer = seriesModel.get([
            "pointer",
            "show"
        ]);
        var progressModel = seriesModel.getModel("progress");
        var showProgress = progressModel.get("show");
        var data = seriesModel.getData();
        var valueDim = data.mapDimension("value");
        var minVal = +seriesModel.get("min");
        var maxVal = +seriesModel.get("max");
        var valueExtent = [
            minVal,
            maxVal
        ];
        var angleExtent = [
            startAngle,
            endAngle
        ];
        function createPointer(idx, angle) {
            var itemModel = data.getItemModel(idx);
            var pointerModel = itemModel.getModel("pointer");
            var pointerWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(pointerModel.get("width"), posInfo.r);
            var pointerLength = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(pointerModel.get("length"), posInfo.r);
            var pointerStr = seriesModel.get([
                "pointer",
                "icon"
            ]);
            var pointerOffset = pointerModel.get("offsetCenter");
            var pointerOffsetX = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(pointerOffset[0], posInfo.r);
            var pointerOffsetY = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(pointerOffset[1], posInfo.r);
            var pointerKeepAspect = pointerModel.get("keepAspect");
            var pointer;
            // not exist icon type will be set 'rect'
            if (pointerStr) pointer = (0, $5370466dadc978d7$export$af050e04da3a02e8)(pointerStr, pointerOffsetX - pointerWidth / 2, pointerOffsetY - pointerLength, pointerWidth, pointerLength, null, pointerKeepAspect);
            else pointer = new (0, $ea4af8acc4ea1022$export$2e2bcd8739ae039)({
                shape: {
                    angle: -Math.PI / 2,
                    width: pointerWidth,
                    r: pointerLength,
                    x: pointerOffsetX,
                    y: pointerOffsetY
                }
            });
            pointer.rotation = -(angle + Math.PI / 2);
            pointer.x = posInfo.cx;
            pointer.y = posInfo.cy;
            return pointer;
        }
        function createProgress(idx, endAngle) {
            var roundCap = progressModel.get("roundCap");
            var ProgressPath = roundCap ? (0, $9674946a7a7df213$export$2e2bcd8739ae039) : $a3e1dec0a3875b49$export$2e2bcd8739ae039;
            var isOverlap = progressModel.get("overlap");
            var progressWidth = isOverlap ? progressModel.get("width") : axisLineWidth / data.count();
            var r0 = isOverlap ? posInfo.r - progressWidth : posInfo.r - (idx + 1) * progressWidth;
            var r = isOverlap ? posInfo.r : posInfo.r - idx * progressWidth;
            var progress = new ProgressPath({
                shape: {
                    startAngle: startAngle,
                    endAngle: endAngle,
                    cx: posInfo.cx,
                    cy: posInfo.cy,
                    clockwise: clockwise,
                    r0: r0,
                    r: r
                }
            });
            isOverlap && (progress.z2 = maxVal - data.get(valueDim, idx) % maxVal);
            return progress;
        }
        if (showProgress || showPointer) {
            data.diff(oldData).add(function(idx) {
                var val = data.get(valueDim, idx);
                if (showPointer) {
                    var pointer = createPointer(idx, startAngle);
                    // TODO hide pointer on NaN value?
                    $8b353638fbedfefa$export$a121566aadcfe021(pointer, {
                        rotation: -((isNaN(+val) ? angleExtent[0] : (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, valueExtent, angleExtent, true)) + Math.PI / 2)
                    }, seriesModel);
                    group.add(pointer);
                    data.setItemGraphicEl(idx, pointer);
                }
                if (showProgress) {
                    var progress = createProgress(idx, startAngle);
                    var isClip = progressModel.get("clip");
                    $8b353638fbedfefa$export$a121566aadcfe021(progress, {
                        shape: {
                            endAngle: (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, valueExtent, angleExtent, isClip)
                        }
                    }, seriesModel);
                    group.add(progress);
                    // Add data index and series index for indexing the data by element
                    // Useful in tooltip
                    (0, $b1983a2fffd47d56$export$30d6736ebb8e18d5)(seriesModel.seriesIndex, data.dataType, idx, progress);
                    progressList[idx] = progress;
                }
            }).update(function(newIdx, oldIdx) {
                var val = data.get(valueDim, newIdx);
                if (showPointer) {
                    var previousPointer = oldData.getItemGraphicEl(oldIdx);
                    var previousRotate = previousPointer ? previousPointer.rotation : startAngle;
                    var pointer = createPointer(newIdx, previousRotate);
                    pointer.rotation = previousRotate;
                    $8b353638fbedfefa$export$c8dce3c08436e91e(pointer, {
                        rotation: -((isNaN(+val) ? angleExtent[0] : (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, valueExtent, angleExtent, true)) + Math.PI / 2)
                    }, seriesModel);
                    group.add(pointer);
                    data.setItemGraphicEl(newIdx, pointer);
                }
                if (showProgress) {
                    var previousProgress = oldProgressData[oldIdx];
                    var previousEndAngle = previousProgress ? previousProgress.shape.endAngle : startAngle;
                    var progress = createProgress(newIdx, previousEndAngle);
                    var isClip = progressModel.get("clip");
                    $8b353638fbedfefa$export$c8dce3c08436e91e(progress, {
                        shape: {
                            endAngle: (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(val, valueExtent, angleExtent, isClip)
                        }
                    }, seriesModel);
                    group.add(progress);
                    // Add data index and series index for indexing the data by element
                    // Useful in tooltip
                    (0, $b1983a2fffd47d56$export$30d6736ebb8e18d5)(seriesModel.seriesIndex, data.dataType, newIdx, progress);
                    progressList[newIdx] = progress;
                }
            }).execute();
            data.each(function(idx) {
                var itemModel = data.getItemModel(idx);
                var emphasisModel = itemModel.getModel("emphasis");
                var focus = emphasisModel.get("focus");
                var blurScope = emphasisModel.get("blurScope");
                var emphasisDisabled = emphasisModel.get("disabled");
                if (showPointer) {
                    var pointer = data.getItemGraphicEl(idx);
                    var symbolStyle = data.getItemVisual(idx, "style");
                    var visualColor = symbolStyle.fill;
                    if (pointer instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
                        var pathStyle = pointer.style;
                        pointer.useStyle((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                            image: pathStyle.image,
                            x: pathStyle.x,
                            y: pathStyle.y,
                            width: pathStyle.width,
                            height: pathStyle.height
                        }, symbolStyle));
                    } else {
                        pointer.useStyle(symbolStyle);
                        pointer.type !== "pointer" && pointer.setColor(visualColor);
                    }
                    pointer.setStyle(itemModel.getModel([
                        "pointer",
                        "itemStyle"
                    ]).getItemStyle());
                    if (pointer.style.fill === "auto") pointer.setStyle("fill", getColor((0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(data.get(valueDim, idx), valueExtent, [
                        0,
                        1
                    ], true)));
                    pointer.z2EmphasisLift = 0;
                    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(pointer, itemModel);
                    (0, $2bf82c0980125b62$export$e51187539ff11209)(pointer, focus, blurScope, emphasisDisabled);
                }
                if (showProgress) {
                    var progress = progressList[idx];
                    progress.useStyle(data.getItemVisual(idx, "style"));
                    progress.setStyle(itemModel.getModel([
                        "progress",
                        "itemStyle"
                    ]).getItemStyle());
                    progress.z2EmphasisLift = 0;
                    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(progress, itemModel);
                    (0, $2bf82c0980125b62$export$e51187539ff11209)(progress, focus, blurScope, emphasisDisabled);
                }
            });
            this._progressEls = progressList;
        }
    };
    GaugeView.prototype._renderAnchor = function(seriesModel, posInfo) {
        var anchorModel = seriesModel.getModel("anchor");
        var showAnchor = anchorModel.get("show");
        if (showAnchor) {
            var anchorSize = anchorModel.get("size");
            var anchorType = anchorModel.get("icon");
            var offsetCenter = anchorModel.get("offsetCenter");
            var anchorKeepAspect = anchorModel.get("keepAspect");
            var anchor = (0, $5370466dadc978d7$export$af050e04da3a02e8)(anchorType, posInfo.cx - anchorSize / 2 + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(offsetCenter[0], posInfo.r), posInfo.cy - anchorSize / 2 + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(offsetCenter[1], posInfo.r), anchorSize, anchorSize, null, anchorKeepAspect);
            anchor.z2 = anchorModel.get("showAbove") ? 1 : 0;
            anchor.setStyle(anchorModel.getModel("itemStyle").getItemStyle());
            this.group.add(anchor);
        }
    };
    GaugeView.prototype._renderTitleAndDetail = function(seriesModel, ecModel, api, getColor, posInfo) {
        var _this = this;
        var data = seriesModel.getData();
        var valueDim = data.mapDimension("value");
        var minVal = +seriesModel.get("min");
        var maxVal = +seriesModel.get("max");
        var contentGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        var newTitleEls = [];
        var newDetailEls = [];
        var hasAnimation = seriesModel.isAnimationEnabled();
        var showPointerAbove = seriesModel.get([
            "pointer",
            "showAbove"
        ]);
        data.diff(this._data).add(function(idx) {
            newTitleEls[idx] = new $fe885cc21795562b$export$2e2bcd8739ae039({
                silent: true
            });
            newDetailEls[idx] = new $fe885cc21795562b$export$2e2bcd8739ae039({
                silent: true
            });
        }).update(function(idx, oldIdx) {
            newTitleEls[idx] = _this._titleEls[oldIdx];
            newDetailEls[idx] = _this._detailEls[oldIdx];
        }).execute();
        data.each(function(idx) {
            var itemModel = data.getItemModel(idx);
            var value = data.get(valueDim, idx);
            var itemGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
            var autoColor = getColor((0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, [
                minVal,
                maxVal
            ], [
                0,
                1
            ], true));
            var itemTitleModel = itemModel.getModel("title");
            if (itemTitleModel.get("show")) {
                var titleOffsetCenter = itemTitleModel.get("offsetCenter");
                var titleX = posInfo.cx + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(titleOffsetCenter[0], posInfo.r);
                var titleY = posInfo.cy + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(titleOffsetCenter[1], posInfo.r);
                var labelEl = newTitleEls[idx];
                labelEl.attr({
                    z2: showPointerAbove ? 0 : 2,
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(itemTitleModel, {
                        x: titleX,
                        y: titleY,
                        text: data.getName(idx),
                        align: "center",
                        verticalAlign: "middle"
                    }, {
                        inheritColor: autoColor
                    })
                });
                itemGroup.add(labelEl);
            }
            var itemDetailModel = itemModel.getModel("detail");
            if (itemDetailModel.get("show")) {
                var detailOffsetCenter = itemDetailModel.get("offsetCenter");
                var detailX = posInfo.cx + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(detailOffsetCenter[0], posInfo.r);
                var detailY = posInfo.cy + (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(detailOffsetCenter[1], posInfo.r);
                var width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(itemDetailModel.get("width"), posInfo.r);
                var height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(itemDetailModel.get("height"), posInfo.r);
                var detailColor = seriesModel.get([
                    "progress",
                    "show"
                ]) ? data.getItemVisual(idx, "style").fill : autoColor;
                var labelEl = newDetailEls[idx];
                var formatter_1 = itemDetailModel.get("formatter");
                labelEl.attr({
                    z2: showPointerAbove ? 0 : 2,
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(itemDetailModel, {
                        x: detailX,
                        y: detailY,
                        text: $f677de6b1db15bcf$var$formatLabel(value, formatter_1),
                        width: isNaN(width) ? null : width,
                        height: isNaN(height) ? null : height,
                        align: "center",
                        verticalAlign: "middle"
                    }, {
                        inheritColor: detailColor
                    })
                });
                (0, $6800dfcb6e1e2a44$export$7bdbceaf9ab378f2)(labelEl, {
                    normal: itemDetailModel
                }, value, function(value) {
                    return $f677de6b1db15bcf$var$formatLabel(value, formatter_1);
                });
                hasAnimation && (0, $6800dfcb6e1e2a44$export$dd6101605f5c186)(labelEl, idx, data, seriesModel, {
                    getFormattedLabel: function(labelDataIndex, status, dataType, labelDimIndex, fmt, extendParams) {
                        return $f677de6b1db15bcf$var$formatLabel(extendParams ? extendParams.interpolatedValue : value, formatter_1);
                    }
                });
                itemGroup.add(labelEl);
            }
            contentGroup.add(itemGroup);
        });
        this.group.add(contentGroup);
        this._titleEls = newTitleEls;
        this._detailEls = newDetailEls;
    };
    GaugeView.type = "gauge";
    return GaugeView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $f677de6b1db15bcf$export$2e2bcd8739ae039 = $f677de6b1db15bcf$var$GaugeView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $059503c83684127e$var$GaugeSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GaugeSeriesModel, _super);
    function GaugeSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GaugeSeriesModel.type;
        _this.visualStyleAccessPath = "itemStyle";
        return _this;
    }
    GaugeSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, [
            "value"
        ]);
    };
    GaugeSeriesModel.type = "series.gauge";
    GaugeSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        colorBy: "data",
        // 默认全局居中
        center: [
            "50%",
            "50%"
        ],
        legendHoverLink: true,
        radius: "75%",
        startAngle: 225,
        endAngle: -45,
        clockwise: true,
        // 最小值
        min: 0,
        // 最大值
        max: 100,
        // 分割段数，默认为10
        splitNumber: 10,
        // 坐标轴线
        axisLine: {
            // 默认显示，属性show控制显示与否
            show: true,
            roundCap: false,
            lineStyle: {
                color: [
                    [
                        1,
                        "#E6EBF8"
                    ]
                ],
                width: 10
            }
        },
        // 坐标轴线
        progress: {
            // 默认显示，属性show控制显示与否
            show: false,
            overlap: true,
            width: 10,
            roundCap: false,
            clip: true
        },
        // 分隔线
        splitLine: {
            // 默认显示，属性show控制显示与否
            show: true,
            // 属性length控制线长
            length: 10,
            distance: 10,
            // 属性lineStyle（详见lineStyle）控制线条样式
            lineStyle: {
                color: "#63677A",
                width: 3,
                type: "solid"
            }
        },
        // 坐标轴小标记
        axisTick: {
            // 属性show控制显示与否，默认不显示
            show: true,
            // 每份split细分多少段
            splitNumber: 5,
            // 属性length控制线长
            length: 6,
            distance: 10,
            // 属性lineStyle控制线条样式
            lineStyle: {
                color: "#63677A",
                width: 1,
                type: "solid"
            }
        },
        axisLabel: {
            show: true,
            distance: 15,
            // formatter: null,
            color: "#464646",
            fontSize: 12,
            rotate: 0
        },
        pointer: {
            icon: null,
            offsetCenter: [
                0,
                0
            ],
            show: true,
            showAbove: true,
            length: "60%",
            width: 6,
            keepAspect: false
        },
        anchor: {
            show: false,
            showAbove: false,
            size: 6,
            icon: "circle",
            offsetCenter: [
                0,
                0
            ],
            keepAspect: false,
            itemStyle: {
                color: "#fff",
                borderWidth: 0,
                borderColor: "#5470c6"
            }
        },
        title: {
            show: true,
            // x, y，单位px
            offsetCenter: [
                0,
                "20%"
            ],
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: "#464646",
            fontSize: 16,
            valueAnimation: false
        },
        detail: {
            show: true,
            backgroundColor: "rgba(0,0,0,0)",
            borderWidth: 0,
            borderColor: "#ccc",
            width: 100,
            height: null,
            padding: [
                5,
                10
            ],
            // x, y，单位px
            offsetCenter: [
                0,
                "40%"
            ],
            // formatter: null,
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: "#464646",
            fontSize: 30,
            fontWeight: "bold",
            lineHeight: 30,
            valueAnimation: false
        }
    };
    return GaugeSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $059503c83684127e$export$2e2bcd8739ae039 = $059503c83684127e$var$GaugeSeriesModel;


function $bf7cb565bb1d2308$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $f677de6b1db15bcf$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $059503c83684127e$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $23b43ea6be789dc3$export$2e2bcd8739ae039(ecModel) {
    var legendModels = ecModel.findComponents({
        mainType: "legend"
    });
    if (!legendModels || !legendModels.length) return;
    ecModel.eachSeriesByType("graph", function(graphSeries) {
        var categoriesData = graphSeries.getCategoriesData();
        var graph = graphSeries.getGraph();
        var data = graph.data;
        var categoryNames = categoriesData.mapArray(categoriesData.getName);
        data.filterSelf(function(idx) {
            var model = data.getItemModel(idx);
            var category = model.getShallow("category");
            if (category != null) {
                if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(category)) category = categoryNames[category];
                // If in any legend component the status is not selected.
                for(var i = 0; i < legendModels.length; i++){
                    if (!legendModels[i].isSelected(category)) return false;
                }
            }
            return true;
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $2c7d64c9b3613d6b$export$2e2bcd8739ae039(ecModel) {
    var paletteScope = {};
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        var categoriesData = seriesModel.getCategoriesData();
        var data = seriesModel.getData();
        var categoryNameIdxMap = {};
        categoriesData.each(function(idx) {
            var name = categoriesData.getName(idx);
            // Add prefix to avoid conflict with Object.prototype.
            categoryNameIdxMap["ec-" + name] = idx;
            var itemModel = categoriesData.getItemModel(idx);
            var style = itemModel.getModel("itemStyle").getItemStyle();
            if (!style.fill) // Get color from palette.
            style.fill = seriesModel.getColorFromPalette(name, paletteScope);
            categoriesData.setItemVisual(idx, "style", style);
            var symbolVisualList = [
                "symbol",
                "symbolSize",
                "symbolKeepAspect"
            ];
            for(var i = 0; i < symbolVisualList.length; i++){
                var symbolVisual = itemModel.getShallow(symbolVisualList[i], true);
                if (symbolVisual != null) categoriesData.setItemVisual(idx, symbolVisualList[i], symbolVisual);
            }
        });
        // Assign category color to visual
        if (categoriesData.count()) data.each(function(idx) {
            var model = data.getItemModel(idx);
            var categoryIdx = model.getShallow("category");
            if (categoryIdx != null) {
                if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(categoryIdx)) categoryIdx = categoryNameIdxMap["ec-" + categoryIdx];
                var categoryStyle = categoriesData.getItemVisual(categoryIdx, "style");
                var style = data.ensureUniqueItemVisual(idx, "style");
                (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(style, categoryStyle);
                var visualList = [
                    "symbol",
                    "symbolSize",
                    "symbolKeepAspect"
                ];
                for(var i = 0; i < visualList.length; i++)data.setItemVisual(idx, visualList[i], categoriesData.getItemVisual(categoryIdx, visualList[i]));
            }
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $11ee0a103a25747c$var$normalize(a) {
    if (!(a instanceof Array)) a = [
        a,
        a
    ];
    return a;
}
function $11ee0a103a25747c$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        var graph = seriesModel.getGraph();
        var edgeData = seriesModel.getEdgeData();
        var symbolType = $11ee0a103a25747c$var$normalize(seriesModel.get("edgeSymbol"));
        var symbolSize = $11ee0a103a25747c$var$normalize(seriesModel.get("edgeSymbolSize"));
        // const colorQuery = ['lineStyle', 'color'] as const;
        // const opacityQuery = ['lineStyle', 'opacity'] as const;
        edgeData.setVisual("fromSymbol", symbolType && symbolType[0]);
        edgeData.setVisual("toSymbol", symbolType && symbolType[1]);
        edgeData.setVisual("fromSymbolSize", symbolSize && symbolSize[0]);
        edgeData.setVisual("toSymbolSize", symbolSize && symbolSize[1]);
        edgeData.setVisual("style", seriesModel.getModel("lineStyle").getLineStyle());
        edgeData.each(function(idx) {
            var itemModel = edgeData.getItemModel(idx);
            var edge = graph.getEdgeByIndex(idx);
            var symbolType = $11ee0a103a25747c$var$normalize(itemModel.getShallow("symbol", true));
            var symbolSize = $11ee0a103a25747c$var$normalize(itemModel.getShallow("symbolSize", true));
            // Edge visual must after node visual
            var style = itemModel.getModel("lineStyle").getLineStyle();
            var existsStyle = edgeData.ensureUniqueItemVisual(idx, "style");
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
            switch(existsStyle.stroke){
                case "source":
                    var nodeStyle = edge.node1.getVisual("style");
                    existsStyle.stroke = nodeStyle && nodeStyle.fill;
                    break;
                case "target":
                    var nodeStyle = edge.node2.getVisual("style");
                    existsStyle.stroke = nodeStyle && nodeStyle.fill;
                    break;
            }
            symbolType[0] && edge.setVisual("fromSymbol", symbolType[0]);
            symbolType[1] && edge.setVisual("toSymbol", symbolType[1]);
            symbolSize[0] && edge.setVisual("fromSymbolSize", symbolSize[0]);
            symbolSize[1] && edge.setVisual("toSymbolSize", symbolSize[1]);
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

var $0425a00d02ade69a$var$KEY_DELIMITER = "-->";
/**
 * params handler
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {*}
 */ var $0425a00d02ade69a$var$getAutoCurvenessParams = function(seriesModel) {
    return seriesModel.get("autoCurveness") || null;
};
/**
 * Generate a list of edge curvatures, 20 is the default
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @param {number} appendLength
 * @return  20 => [0, -0.2, 0.2, -0.4, 0.4, -0.6, 0.6, -0.8, 0.8, -1, 1, -1.2, 1.2, -1.4, 1.4, -1.6, 1.6, -1.8, 1.8, -2]
 */ var $0425a00d02ade69a$var$createCurveness = function(seriesModel, appendLength) {
    var autoCurvenessParmas = $0425a00d02ade69a$var$getAutoCurvenessParams(seriesModel);
    var length = 20;
    var curvenessList = [];
    // handler the function set
    if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(autoCurvenessParmas)) length = autoCurvenessParmas;
    else if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(autoCurvenessParmas)) {
        seriesModel.__curvenessList = autoCurvenessParmas;
        return;
    }
    // append length
    if (appendLength > length) length = appendLength;
    // make sure the length is even
    var len = length % 2 ? length + 2 : length + 3;
    curvenessList = [];
    for(var i = 0; i < len; i++)curvenessList.push((i % 2 ? i + 1 : i) / 10 * (i % 2 ? -1 : 1));
    seriesModel.__curvenessList = curvenessList;
};
/**
 * Create different cache key data in the positive and negative directions, in order to set the curvature later
 * @param {number|string|module:echarts/data/Graph.Node} n1
 * @param {number|string|module:echarts/data/Graph.Node} n2
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {string} key
 */ var $0425a00d02ade69a$var$getKeyOfEdges = function(n1, n2, seriesModel) {
    var source = [
        n1.id,
        n1.dataIndex
    ].join(".");
    var target = [
        n2.id,
        n2.dataIndex
    ].join(".");
    return [
        seriesModel.uid,
        source,
        target
    ].join($0425a00d02ade69a$var$KEY_DELIMITER);
};
/**
 * get opposite key
 * @param {string} key
 * @returns {string}
 */ var $0425a00d02ade69a$var$getOppositeKey = function(key) {
    var keys = key.split($0425a00d02ade69a$var$KEY_DELIMITER);
    return [
        keys[0],
        keys[2],
        keys[1]
    ].join($0425a00d02ade69a$var$KEY_DELIMITER);
};
/**
 * get edgeMap with key
 * @param edge
 * @param {module:echarts/model/SeriesModel} seriesModel
 */ var $0425a00d02ade69a$var$getEdgeFromMap = function(edge, seriesModel) {
    var key = $0425a00d02ade69a$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel);
    return seriesModel.__edgeMap[key];
};
/**
 * calculate all cases total length
 * @param edge
 * @param seriesModel
 * @returns {number}
 */ var $0425a00d02ade69a$var$getTotalLengthBetweenNodes = function(edge, seriesModel) {
    var len = $0425a00d02ade69a$var$getEdgeMapLengthWithKey($0425a00d02ade69a$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel), seriesModel);
    var lenV = $0425a00d02ade69a$var$getEdgeMapLengthWithKey($0425a00d02ade69a$var$getKeyOfEdges(edge.node2, edge.node1, seriesModel), seriesModel);
    return len + lenV;
};
/**
 *
 * @param key
 */ var $0425a00d02ade69a$var$getEdgeMapLengthWithKey = function(key, seriesModel) {
    var edgeMap = seriesModel.__edgeMap;
    return edgeMap[key] ? edgeMap[key].length : 0;
};
function $0425a00d02ade69a$export$4f05389c1f2934b8(seriesModel) {
    if (!$0425a00d02ade69a$var$getAutoCurvenessParams(seriesModel)) return;
    seriesModel.__curvenessList = [];
    seriesModel.__edgeMap = {};
    // calc the array of curveness List
    $0425a00d02ade69a$var$createCurveness(seriesModel);
}
function $0425a00d02ade69a$export$c47b549eed9a7311(n1, n2, seriesModel, index) {
    if (!$0425a00d02ade69a$var$getAutoCurvenessParams(seriesModel)) return;
    var key = $0425a00d02ade69a$var$getKeyOfEdges(n1, n2, seriesModel);
    var edgeMap = seriesModel.__edgeMap;
    var oppositeEdges = edgeMap[$0425a00d02ade69a$var$getOppositeKey(key)];
    // set direction
    if (edgeMap[key] && !oppositeEdges) edgeMap[key].isForward = true;
    else if (oppositeEdges && edgeMap[key]) {
        oppositeEdges.isForward = true;
        edgeMap[key].isForward = false;
    }
    edgeMap[key] = edgeMap[key] || [];
    edgeMap[key].push(index);
}
function $0425a00d02ade69a$export$7e88123f7f1f62da(edge, seriesModel, index, needReverse) {
    var autoCurvenessParams = $0425a00d02ade69a$var$getAutoCurvenessParams(seriesModel);
    var isArrayParam = $7a1bd9c2710fea0d$export$43bee75e5e14138e(autoCurvenessParams);
    if (!autoCurvenessParams) return null;
    var edgeArray = $0425a00d02ade69a$var$getEdgeFromMap(edge, seriesModel);
    if (!edgeArray) return null;
    var edgeIndex = -1;
    for(var i = 0; i < edgeArray.length; i++)if (edgeArray[i] === index) {
        edgeIndex = i;
        break;
    }
    // if totalLen is Longer createCurveness
    var totalLen = $0425a00d02ade69a$var$getTotalLengthBetweenNodes(edge, seriesModel);
    $0425a00d02ade69a$var$createCurveness(seriesModel, totalLen);
    edge.lineStyle = edge.lineStyle || {};
    // if is opposite edge, must set curvenss to opposite number
    var curKey = $0425a00d02ade69a$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel);
    var curvenessList = seriesModel.__curvenessList;
    // if pass array no need parity
    var parityCorrection = isArrayParam ? 0 : totalLen % 2 ? 0 : 1;
    if (!edgeArray.isForward) {
        // the opposite edge show outside
        var oppositeKey = $0425a00d02ade69a$var$getOppositeKey(curKey);
        var len = $0425a00d02ade69a$var$getEdgeMapLengthWithKey(oppositeKey, seriesModel);
        var resValue = curvenessList[edgeIndex + len + parityCorrection];
        // isNeedReverse, simple, force type need reverse the curveness in the junction of the forword and the opposite
        if (needReverse) {
            // set as array may make the parity handle with the len of opposite
            if (isArrayParam) {
                if (autoCurvenessParams && autoCurvenessParams[0] === 0) return (len + parityCorrection) % 2 ? resValue : -resValue;
                else return ((len % 2 ? 0 : 1) + parityCorrection) % 2 ? resValue : -resValue;
            } else return (len + parityCorrection) % 2 ? resValue : -resValue;
        } else return curvenessList[edgeIndex + len + parityCorrection];
    } else return curvenessList[parityCorrection + edgeIndex];
}


function $159cad03c3625d06$export$6d7efb25f4dcb4db(seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys && coordSys.type !== "view") return;
    var graph = seriesModel.getGraph();
    graph.eachNode(function(node) {
        var model = node.getModel();
        node.setLayout([
            +model.get("x"),
            +model.get("y")
        ]);
    });
    $159cad03c3625d06$export$a25b52345bee32aa(graph, seriesModel);
}
function $159cad03c3625d06$export$a25b52345bee32aa(graph, seriesModel) {
    graph.eachEdge(function(edge, index) {
        var curveness = $7a1bd9c2710fea0d$export$2e94551289abb95b(edge.getModel().get([
            "lineStyle",
            "curveness"
        ]), -(0, $0425a00d02ade69a$export$7e88123f7f1f62da)(edge, seriesModel, index, true), 0);
        var p1 = $6de594cf8ac295ff$export$9cd59f9826255e47(edge.node1.getLayout());
        var p2 = $6de594cf8ac295ff$export$9cd59f9826255e47(edge.node2.getLayout());
        var points = [
            p1,
            p2
        ];
        if (+curveness) points.push([
            (p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * curveness,
            (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * curveness
        ]);
        edge.setLayout(points);
    });
}


function $35717df2daa24f5d$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        var layout = seriesModel.get("layout");
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.type !== "view") {
            var data_1 = seriesModel.getData();
            var dimensions_1 = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSys.dimensions, function(coordDim) {
                dimensions_1 = dimensions_1.concat(data_1.mapDimensionsAll(coordDim));
            });
            for(var dataIndex = 0; dataIndex < data_1.count(); dataIndex++){
                var value = [];
                var hasValue = false;
                for(var i = 0; i < dimensions_1.length; i++){
                    var val = data_1.get(dimensions_1[i], dataIndex);
                    if (!isNaN(val)) hasValue = true;
                    value.push(val);
                }
                if (hasValue) data_1.setItemLayout(dataIndex, coordSys.dataToPoint(value));
                else // Also {Array.<number>}, not undefined to avoid if...else... statement
                data_1.setItemLayout(dataIndex, [
                    NaN,
                    NaN
                ]);
            }
            (0, $159cad03c3625d06$export$a25b52345bee32aa)(data_1.graph, seriesModel);
        } else if (!layout || layout === "none") (0, $159cad03c3625d06$export$6d7efb25f4dcb4db)(seriesModel);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7(seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys.type !== "view") return 1;
    var nodeScaleRatio = seriesModel.option.nodeScaleRatio;
    var groupZoom = coordSys.scaleX;
    // Scale node when zoom changes
    var roamZoom = coordSys.getZoom();
    var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
    return nodeScale / groupZoom;
}
function $ad8b4f94f577d55a$export$8d4a06d3facd414b(node) {
    var symbolSize = node.getVisual("symbolSize");
    if (symbolSize instanceof Array) symbolSize = (symbolSize[0] + symbolSize[1]) / 2;
    return +symbolSize;
}




var $484ee97adf82b508$var$PI = Math.PI;
var $484ee97adf82b508$var$_symbolRadiansHalf = [];
function $484ee97adf82b508$export$cbfed6ae5cab3dae(seriesModel, basedOn, draggingNode, pointer) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys && coordSys.type !== "view") return;
    var rect = coordSys.getBoundingRect();
    var nodeData = seriesModel.getData();
    var graph = nodeData.graph;
    var cx = rect.width / 2 + rect.x;
    var cy = rect.height / 2 + rect.y;
    var r = Math.min(rect.width, rect.height) / 2;
    var count = nodeData.count();
    nodeData.setLayout({
        cx: cx,
        cy: cy
    });
    if (!count) return;
    if (draggingNode) {
        var _a = coordSys.pointToData(pointer), tempX = _a[0], tempY = _a[1];
        var v = [
            tempX - cx,
            tempY - cy
        ];
        $6de594cf8ac295ff$export$a3295358bff77e(v, v);
        $6de594cf8ac295ff$export$dcdf75081b88279d(v, v, r);
        draggingNode.setLayout([
            cx + v[0],
            cy + v[1]
        ], true);
        var circularRotateLabel = seriesModel.get([
            "circular",
            "rotateLabel"
        ]);
        $484ee97adf82b508$export$c768377a6a0a9ab8(draggingNode, circularRotateLabel, cx, cy);
    }
    $484ee97adf82b508$var$_layoutNodesBasedOn[basedOn](seriesModel, graph, nodeData, r, cx, cy, count);
    graph.eachEdge(function(edge, index) {
        var curveness = $7a1bd9c2710fea0d$export$2e94551289abb95b(edge.getModel().get([
            "lineStyle",
            "curveness"
        ]), (0, $0425a00d02ade69a$export$7e88123f7f1f62da)(edge, seriesModel, index), 0);
        var p1 = $6de594cf8ac295ff$export$9cd59f9826255e47(edge.node1.getLayout());
        var p2 = $6de594cf8ac295ff$export$9cd59f9826255e47(edge.node2.getLayout());
        var cp1;
        var x12 = (p1[0] + p2[0]) / 2;
        var y12 = (p1[1] + p2[1]) / 2;
        if (+curveness) {
            curveness *= 3;
            cp1 = [
                cx * curveness + x12 * (1 - curveness),
                cy * curveness + y12 * (1 - curveness)
            ];
        }
        edge.setLayout([
            p1,
            p2,
            cp1
        ]);
    });
}
var $484ee97adf82b508$var$_layoutNodesBasedOn = {
    value: function(seriesModel, graph, nodeData, r, cx, cy, count) {
        var angle = 0;
        var sum = nodeData.getSum("value");
        var unitAngle = Math.PI * 2 / (sum || count);
        graph.eachNode(function(node) {
            var value = node.getValue("value");
            var radianHalf = unitAngle * (sum ? value : 1) / 2;
            angle += radianHalf;
            node.setLayout([
                r * Math.cos(angle) + cx,
                r * Math.sin(angle) + cy
            ]);
            angle += radianHalf;
        });
    },
    symbolSize: function(seriesModel, graph, nodeData, r, cx, cy, count) {
        var sumRadian = 0;
        $484ee97adf82b508$var$_symbolRadiansHalf.length = count;
        var nodeScale = (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel);
        graph.eachNode(function(node) {
            var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(node);
            // Normally this case will not happen, but we still add
            // some the defensive code (2px is an arbitrary value).
            isNaN(symbolSize) && (symbolSize = 2);
            symbolSize < 0 && (symbolSize = 0);
            symbolSize *= nodeScale;
            var symbolRadianHalf = Math.asin(symbolSize / 2 / r);
            // when `symbolSize / 2` is bigger than `r`.
            isNaN(symbolRadianHalf) && (symbolRadianHalf = $484ee97adf82b508$var$PI / 2);
            $484ee97adf82b508$var$_symbolRadiansHalf[node.dataIndex] = symbolRadianHalf;
            sumRadian += symbolRadianHalf * 2;
        });
        var halfRemainRadian = (2 * $484ee97adf82b508$var$PI - sumRadian) / count / 2;
        var angle = 0;
        graph.eachNode(function(node) {
            var radianHalf = halfRemainRadian + $484ee97adf82b508$var$_symbolRadiansHalf[node.dataIndex];
            angle += radianHalf;
            // init circular layout for
            // 1. layout undefined node
            // 2. not fixed node
            (!node.getLayout() || !node.getLayout().fixed) && node.setLayout([
                r * Math.cos(angle) + cx,
                r * Math.sin(angle) + cy
            ]);
            angle += radianHalf;
        });
    }
};
function $484ee97adf82b508$export$c768377a6a0a9ab8(node, circularRotateLabel, cx, cy) {
    var el = node.getGraphicEl();
    // need to check if el exists. '-' value may not create node element.
    if (!el) return;
    var nodeModel = node.getModel();
    var labelRotate = nodeModel.get([
        "label",
        "rotate"
    ]) || 0;
    var symbolPath = el.getSymbolPath();
    if (circularRotateLabel) {
        var pos = node.getLayout();
        var rad = Math.atan2(pos[1] - cy, pos[0] - cx);
        if (rad < 0) rad = Math.PI * 2 + rad;
        var isLeft = pos[0] < cx;
        if (isLeft) rad = rad - Math.PI;
        var textPosition = isLeft ? "left" : "right";
        symbolPath.setTextConfig({
            rotation: -rad,
            position: textPosition,
            origin: "center"
        });
        var emphasisState = symbolPath.ensureState("emphasis");
        $7a1bd9c2710fea0d$export$8b58be045bf06082(emphasisState.textConfig || (emphasisState.textConfig = {}), {
            position: textPosition
        });
    } else symbolPath.setTextConfig({
        rotation: labelRotate *= Math.PI / 180
    });
}


function $3c017b875f1b19fb$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        if (seriesModel.get("layout") === "circular") (0, $484ee97adf82b508$export$cbfed6ae5cab3dae)(seriesModel, "symbolSize");
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* Some formulas were originally copied from "d3.js" with some
* modifications made for this project.
* (See more details in the comment of the method "step" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $b2cd6170c8983d43$var$scaleAndAdd = $6de594cf8ac295ff$export$19cedf1da84ba854;
function $b2cd6170c8983d43$export$100e93b4853dcbde(inNodes, inEdges, opts) {
    var nodes = inNodes;
    var edges = inEdges;
    var rect = opts.rect;
    var width = rect.width;
    var height = rect.height;
    var center = [
        rect.x + width / 2,
        rect.y + height / 2
    ];
    // let scale = opts.scale || 1;
    var gravity = opts.gravity == null ? 0.1 : opts.gravity;
    // for (let i = 0; i < edges.length; i++) {
    //     let e = edges[i];
    //     let n1 = e.n1;
    //     let n2 = e.n2;
    //     n1.edges = n1.edges || [];
    //     n2.edges = n2.edges || [];
    //     n1.edges.push(e);
    //     n2.edges.push(e);
    // }
    // Init position
    for(var i = 0; i < nodes.length; i++){
        var n = nodes[i];
        if (!n.p) n.p = $6de594cf8ac295ff$export$185802fd694ee1f5(width * (Math.random() - 0.5) + center[0], height * (Math.random() - 0.5) + center[1]);
        n.pp = $6de594cf8ac295ff$export$9cd59f9826255e47(n.p);
        n.edges = null;
    }
    // Formula in 'Graph Drawing by Force-directed Placement'
    // let k = scale * Math.sqrt(width * height / nodes.length);
    // let k2 = k * k;
    var initialFriction = opts.friction == null ? 0.6 : opts.friction;
    var friction = initialFriction;
    var beforeStepCallback;
    var afterStepCallback;
    return {
        warmUp: function() {
            friction = initialFriction * 0.8;
        },
        setFixed: function(idx) {
            nodes[idx].fixed = true;
        },
        setUnfixed: function(idx) {
            nodes[idx].fixed = false;
        },
        /**
     * Before step hook
     */ beforeStep: function(cb) {
            beforeStepCallback = cb;
        },
        /**
     * After step hook
     */ afterStep: function(cb) {
            afterStepCallback = cb;
        },
        /**
     * Some formulas were originally copied from "d3.js"
     * https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/layout/force.js
     * with some modifications made for this project.
     * See the license statement at the head of this file.
     */ step: function(cb) {
            beforeStepCallback && beforeStepCallback(nodes, edges);
            var v12 = [];
            var nLen = nodes.length;
            for(var i = 0; i < edges.length; i++){
                var e = edges[i];
                if (e.ignoreForceLayout) continue;
                var n1 = e.n1;
                var n2 = e.n2;
                $6de594cf8ac295ff$export$f93b5905241a7cca(v12, n2.p, n1.p);
                var d = $6de594cf8ac295ff$export$fc1400facf92c78(v12) - e.d;
                var w = n2.w / (n1.w + n2.w);
                if (isNaN(w)) w = 0;
                $6de594cf8ac295ff$export$a3295358bff77e(v12, v12);
                !n1.fixed && $b2cd6170c8983d43$var$scaleAndAdd(n1.p, n1.p, v12, w * d * friction);
                !n2.fixed && $b2cd6170c8983d43$var$scaleAndAdd(n2.p, n2.p, v12, -(1 - w) * d * friction);
            }
            // Gravity
            for(var i = 0; i < nLen; i++){
                var n = nodes[i];
                if (!n.fixed) {
                    $6de594cf8ac295ff$export$f93b5905241a7cca(v12, center, n.p);
                    // let d = vec2.len(v12);
                    // vec2.scale(v12, v12, 1 / d);
                    // let gravityFactor = gravity;
                    $b2cd6170c8983d43$var$scaleAndAdd(n.p, n.p, v12, gravity * friction);
                }
            }
            // Repulsive
            // PENDING
            for(var i = 0; i < nLen; i++){
                var n1 = nodes[i];
                for(var j = i + 1; j < nLen; j++){
                    var n2 = nodes[j];
                    $6de594cf8ac295ff$export$f93b5905241a7cca(v12, n2.p, n1.p);
                    var d = $6de594cf8ac295ff$export$fc1400facf92c78(v12);
                    if (d === 0) {
                        // Random repulse
                        $6de594cf8ac295ff$export$adaa4cf7ef1b65be(v12, Math.random() - 0.5, Math.random() - 0.5);
                        d = 1;
                    }
                    var repFact = (n1.rep + n2.rep) / d / d;
                    !n1.fixed && $b2cd6170c8983d43$var$scaleAndAdd(n1.pp, n1.pp, v12, repFact);
                    !n2.fixed && $b2cd6170c8983d43$var$scaleAndAdd(n2.pp, n2.pp, v12, -repFact);
                }
            }
            var v = [];
            for(var i = 0; i < nLen; i++){
                var n = nodes[i];
                if (!n.fixed) {
                    $6de594cf8ac295ff$export$f93b5905241a7cca(v, n.p, n.pp);
                    $b2cd6170c8983d43$var$scaleAndAdd(n.p, n.p, v, friction);
                    $6de594cf8ac295ff$export$784d13d8ee351f07(n.pp, n.p);
                }
            }
            friction = friction * 0.992;
            var finished = friction < 0.01;
            afterStepCallback && afterStepCallback(nodes, edges, finished);
            cb && cb(finished);
        }
    };
}








function $cd6209901c0041df$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType("graph", function(graphSeries) {
        var coordSys = graphSeries.coordinateSystem;
        if (coordSys && coordSys.type !== "view") return;
        if (graphSeries.get("layout") === "force") {
            var preservedPoints_1 = graphSeries.preservedPoints || {};
            var graph_1 = graphSeries.getGraph();
            var nodeData_1 = graph_1.data;
            var edgeData = graph_1.edgeData;
            var forceModel = graphSeries.getModel("force");
            var initLayout = forceModel.get("initLayout");
            if (graphSeries.preservedPoints) nodeData_1.each(function(idx) {
                var id = nodeData_1.getId(idx);
                nodeData_1.setItemLayout(idx, preservedPoints_1[id] || [
                    NaN,
                    NaN
                ]);
            });
            else if (!initLayout || initLayout === "none") (0, $159cad03c3625d06$export$6d7efb25f4dcb4db)(graphSeries);
            else if (initLayout === "circular") (0, $484ee97adf82b508$export$cbfed6ae5cab3dae)(graphSeries, "value");
            var nodeDataExtent_1 = nodeData_1.getDataExtent("value");
            var edgeDataExtent_1 = edgeData.getDataExtent("value");
            // let edgeDataExtent = edgeData.getDataExtent('value');
            var repulsion = forceModel.get("repulsion");
            var edgeLength = forceModel.get("edgeLength");
            var repulsionArr_1 = $7a1bd9c2710fea0d$export$43bee75e5e14138e(repulsion) ? repulsion : [
                repulsion,
                repulsion
            ];
            var edgeLengthArr_1 = $7a1bd9c2710fea0d$export$43bee75e5e14138e(edgeLength) ? edgeLength : [
                edgeLength,
                edgeLength
            ];
            // Larger value has smaller length
            edgeLengthArr_1 = [
                edgeLengthArr_1[1],
                edgeLengthArr_1[0]
            ];
            var nodes_1 = nodeData_1.mapArray("value", function(value, idx) {
                var point = nodeData_1.getItemLayout(idx);
                var rep = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, nodeDataExtent_1, repulsionArr_1);
                if (isNaN(rep)) rep = (repulsionArr_1[0] + repulsionArr_1[1]) / 2;
                return {
                    w: rep,
                    rep: rep,
                    fixed: nodeData_1.getItemModel(idx).get("fixed"),
                    p: !point || isNaN(point[0]) || isNaN(point[1]) ? null : point
                };
            });
            var edges = edgeData.mapArray("value", function(value, idx) {
                var edge = graph_1.getEdgeByIndex(idx);
                var d = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, edgeDataExtent_1, edgeLengthArr_1);
                if (isNaN(d)) d = (edgeLengthArr_1[0] + edgeLengthArr_1[1]) / 2;
                var edgeModel = edge.getModel();
                var curveness = $7a1bd9c2710fea0d$export$2e94551289abb95b(edge.getModel().get([
                    "lineStyle",
                    "curveness"
                ]), -(0, $0425a00d02ade69a$export$7e88123f7f1f62da)(edge, graphSeries, idx, true), 0);
                return {
                    n1: nodes_1[edge.node1.dataIndex],
                    n2: nodes_1[edge.node2.dataIndex],
                    d: d,
                    curveness: curveness,
                    ignoreForceLayout: edgeModel.get("ignoreForceLayout")
                };
            });
            // let coordSys = graphSeries.coordinateSystem;
            var rect = coordSys.getBoundingRect();
            var forceInstance = (0, $b2cd6170c8983d43$export$100e93b4853dcbde)(nodes_1, edges, {
                rect: rect,
                gravity: forceModel.get("gravity"),
                friction: forceModel.get("friction")
            });
            forceInstance.beforeStep(function(nodes, edges) {
                for(var i = 0, l = nodes.length; i < l; i++)if (nodes[i].fixed) // Write back to layout instance
                $6de594cf8ac295ff$export$784d13d8ee351f07(nodes[i].p, graph_1.getNodeByIndex(i).getLayout());
            });
            forceInstance.afterStep(function(nodes, edges, stopped) {
                for(var i = 0, l = nodes.length; i < l; i++){
                    if (!nodes[i].fixed) graph_1.getNodeByIndex(i).setLayout(nodes[i].p);
                    preservedPoints_1[nodeData_1.getId(i)] = nodes[i].p;
                }
                for(var i = 0, l = edges.length; i < l; i++){
                    var e = edges[i];
                    var edge = graph_1.getEdgeByIndex(i);
                    var p1 = e.n1.p;
                    var p2 = e.n2.p;
                    var points = edge.getLayout();
                    points = points ? points.slice() : [];
                    points[0] = points[0] || [];
                    points[1] = points[1] || [];
                    $6de594cf8ac295ff$export$784d13d8ee351f07(points[0], p1);
                    $6de594cf8ac295ff$export$784d13d8ee351f07(points[1], p2);
                    if (+e.curveness) points[2] = [
                        (p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * e.curveness,
                        (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * e.curveness
                    ];
                    edge.setLayout(points);
                }
            });
            graphSeries.forceLayout = forceInstance;
            graphSeries.preservedPoints = preservedPoints_1;
            // Step to get the layout
            forceInstance.step();
        } else // Remove prev injected forceLayout instance
        graphSeries.forceLayout = null;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME Where to create the simple view coordinate system
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $4a92e7570d47c1fe$var$v2ApplyTransform = $6de594cf8ac295ff$export$9f9dcb98c894b623;
var $4a92e7570d47c1fe$var$View = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(View, _super);
    function View(name) {
        var _this = _super.call(this) || this;
        _this.type = "view";
        _this.dimensions = [
            "x",
            "y"
        ];
        /**
     * Represents the transform brought by roam/zoom.
     * If `View['_viewRect']` applies roam transform,
     * we can get the final displayed rect.
     */ _this._roamTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
        /**
     * Represents the transform from `View['_rect']` to `View['_viewRect']`.
     */ _this._rawTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
        _this.name = name;
        return _this;
    }
    View.prototype.setBoundingRect = function(x, y, width, height) {
        this._rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
        return this._rect;
    };
    /**
   * @return {module:zrender/core/BoundingRect}
   */ View.prototype.getBoundingRect = function() {
        return this._rect;
    };
    View.prototype.setViewRect = function(x, y, width, height) {
        this._transformTo(x, y, width, height);
        this._viewRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
    };
    /**
   * Transformed to particular position and size
   */ View.prototype._transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var rawTransform = this._rawTransformable;
        rawTransform.transform = rect.calculateTransform(new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height));
        var rawParent = rawTransform.parent;
        rawTransform.parent = null;
        rawTransform.decomposeTransform();
        rawTransform.parent = rawParent;
        this._updateTransform();
    };
    /**
   * Set center of view
   */ View.prototype.setCenter = function(centerCoord, api) {
        if (!centerCoord) return;
        this._center = [
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(centerCoord[0], api.getWidth()),
            (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(centerCoord[1], api.getHeight())
        ];
        this._updateCenterAndZoom();
    };
    View.prototype.setZoom = function(zoom) {
        zoom = zoom || 1;
        var zoomLimit = this.zoomLimit;
        if (zoomLimit) {
            if (zoomLimit.max != null) zoom = Math.min(zoomLimit.max, zoom);
            if (zoomLimit.min != null) zoom = Math.max(zoomLimit.min, zoom);
        }
        this._zoom = zoom;
        this._updateCenterAndZoom();
    };
    /**
   * Get default center without roam
   */ View.prototype.getDefaultCenter = function() {
        // Rect before any transform
        var rawRect = this.getBoundingRect();
        var cx = rawRect.x + rawRect.width / 2;
        var cy = rawRect.y + rawRect.height / 2;
        return [
            cx,
            cy
        ];
    };
    View.prototype.getCenter = function() {
        return this._center || this.getDefaultCenter();
    };
    View.prototype.getZoom = function() {
        return this._zoom || 1;
    };
    View.prototype.getRoamTransform = function() {
        return this._roamTransformable.getLocalTransform();
    };
    /**
   * Remove roam
   */ View.prototype._updateCenterAndZoom = function() {
        // Must update after view transform updated
        var rawTransformMatrix = this._rawTransformable.getLocalTransform();
        var roamTransform = this._roamTransformable;
        var defaultCenter = this.getDefaultCenter();
        var center = this.getCenter();
        var zoom = this.getZoom();
        center = $6de594cf8ac295ff$export$9f9dcb98c894b623([], center, rawTransformMatrix);
        defaultCenter = $6de594cf8ac295ff$export$9f9dcb98c894b623([], defaultCenter, rawTransformMatrix);
        roamTransform.originX = center[0];
        roamTransform.originY = center[1];
        roamTransform.x = defaultCenter[0] - center[0];
        roamTransform.y = defaultCenter[1] - center[1];
        roamTransform.scaleX = roamTransform.scaleY = zoom;
        this._updateTransform();
    };
    /**
   * Update transform props on `this` based on the current
   * `this._roamTransformable` and `this._rawTransformable`.
   */ View.prototype._updateTransform = function() {
        var roamTransformable = this._roamTransformable;
        var rawTransformable = this._rawTransformable;
        rawTransformable.parent = roamTransformable;
        roamTransformable.updateTransform();
        rawTransformable.updateTransform();
        $f41ebb9dd60b55b4$export$784d13d8ee351f07(this.transform || (this.transform = []), rawTransformable.transform || $f41ebb9dd60b55b4$export$185802fd694ee1f5());
        this._rawTransform = rawTransformable.getLocalTransform();
        this.invTransform = this.invTransform || [];
        $f41ebb9dd60b55b4$export$6897c284b6f9f4dc(this.invTransform, this.transform);
        this.decomposeTransform();
    };
    View.prototype.getTransformInfo = function() {
        var rawTransformable = this._rawTransformable;
        var roamTransformable = this._roamTransformable;
        // Because roamTransformabel has `originX/originY` modified,
        // but the caller of `getTransformInfo` can not handle `originX/originY`,
        // so need to recalculate them.
        var dummyTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
        dummyTransformable.transform = roamTransformable.transform;
        dummyTransformable.decomposeTransform();
        return {
            roam: {
                x: dummyTransformable.x,
                y: dummyTransformable.y,
                scaleX: dummyTransformable.scaleX,
                scaleY: dummyTransformable.scaleY
            },
            raw: {
                x: rawTransformable.x,
                y: rawTransformable.y,
                scaleX: rawTransformable.scaleX,
                scaleY: rawTransformable.scaleY
            }
        };
    };
    View.prototype.getViewRect = function() {
        return this._viewRect;
    };
    /**
   * Get view rect after roam transform
   */ View.prototype.getViewRectAfterRoam = function() {
        var rect = this.getBoundingRect().clone();
        rect.applyTransform(this.transform);
        return rect;
    };
    /**
   * Convert a single (lon, lat) data item to (x, y) point.
   */ View.prototype.dataToPoint = function(data, noRoam, out) {
        var transform = noRoam ? this._rawTransform : this.transform;
        out = out || [];
        return transform ? $4a92e7570d47c1fe$var$v2ApplyTransform(out, data, transform) : $6de594cf8ac295ff$export$784d13d8ee351f07(out, data);
    };
    /**
   * Convert a (x, y) point to (lon, lat) data
   */ View.prototype.pointToData = function(point) {
        var invTransform = this.invTransform;
        return invTransform ? $4a92e7570d47c1fe$var$v2ApplyTransform([], point, invTransform) : [
            point[0],
            point[1]
        ];
    };
    View.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $4a92e7570d47c1fe$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value) : null;
    };
    View.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $4a92e7570d47c1fe$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel) : null;
    };
    /**
   * @implements
   */ View.prototype.containPoint = function(point) {
        return this.getViewRectAfterRoam().contain(point[0], point[1]);
    };
    View.dimensions = [
        "x",
        "y"
    ];
    return View;
}((0, $becf2d727f9cf450$export$2e2bcd8739ae039));
function $4a92e7570d47c1fe$var$getCoordSys(finder) {
    var seriesModel = finder.seriesModel;
    return seriesModel ? seriesModel.coordinateSystem : null; // e.g., graph.
}
var $4a92e7570d47c1fe$export$2e2bcd8739ae039 = $4a92e7570d47c1fe$var$View;





function $8491beaca48712b9$var$getViewRect(seriesModel, api, aspect) {
    var option = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(seriesModel.getBoxLayoutParams(), {
        aspect: aspect
    });
    return (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(option, {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $8491beaca48712b9$export$2e2bcd8739ae039(ecModel, api) {
    var viewList = [];
    ecModel.eachSeriesByType("graph", function(seriesModel) {
        var coordSysType = seriesModel.get("coordinateSystem");
        if (!coordSysType || coordSysType === "view") {
            var data_1 = seriesModel.getData();
            var positions = data_1.mapArray(function(idx) {
                var itemModel = data_1.getItemModel(idx);
                return [
                    +itemModel.get("x"),
                    +itemModel.get("y")
                ];
            });
            var min = [];
            var max = [];
            $af3aab2435198f82$export$188c3cd07b4129dd(positions, min, max);
            // If width or height is 0
            if (max[0] - min[0] === 0) {
                max[0] += 1;
                min[0] -= 1;
            }
            if (max[1] - min[1] === 0) {
                max[1] += 1;
                min[1] -= 1;
            }
            var aspect = (max[0] - min[0]) / (max[1] - min[1]);
            // FIXME If get view rect after data processed?
            var viewRect = $8491beaca48712b9$var$getViewRect(seriesModel, api, aspect);
            // Position may be NaN, use view rect instead
            if (isNaN(aspect)) {
                min = [
                    viewRect.x,
                    viewRect.y
                ];
                max = [
                    viewRect.x + viewRect.width,
                    viewRect.y + viewRect.height
                ];
            }
            var bbWidth = max[0] - min[0];
            var bbHeight = max[1] - min[1];
            var viewWidth = viewRect.width;
            var viewHeight = viewRect.height;
            var viewCoordSys = seriesModel.coordinateSystem = new (0, $4a92e7570d47c1fe$export$2e2bcd8739ae039)();
            viewCoordSys.zoomLimit = seriesModel.get("scaleLimit");
            viewCoordSys.setBoundingRect(min[0], min[1], bbWidth, bbHeight);
            viewCoordSys.setViewRect(viewRect.x, viewRect.y, viewWidth, viewHeight);
            // Update roam info
            viewCoordSys.setCenter(seriesModel.get("center"), api);
            viewCoordSys.setZoom(seriesModel.get("zoom"));
            viewList.push(viewCoordSys);
        }
    });
    return viewList;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $ab7bf64951ce094b$var$straightLineProto = $7a316ae5ceff7b27$export$2e2bcd8739ae039.prototype;
var $ab7bf64951ce094b$var$bezierCurveProto = $6c7800c49630e431$export$2e2bcd8739ae039.prototype;
var $ab7bf64951ce094b$var$StraightLineShape = /** @class */ function() {
    function StraightLineShape() {
        // Start point
        this.x1 = 0;
        this.y1 = 0;
        // End point
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return StraightLineShape;
}();
var $ab7bf64951ce094b$var$CurveShape = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CurveShape, _super);
    function CurveShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CurveShape;
}($ab7bf64951ce094b$var$StraightLineShape);
function $ab7bf64951ce094b$var$isStraightLine(shape) {
    return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
}
var $ab7bf64951ce094b$var$ECLinePath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ECLinePath, _super);
    function ECLinePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "ec-line";
        return _this;
    }
    ECLinePath.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    ECLinePath.prototype.getDefaultShape = function() {
        return new $ab7bf64951ce094b$var$StraightLineShape();
    };
    ECLinePath.prototype.buildPath = function(ctx, shape) {
        if ($ab7bf64951ce094b$var$isStraightLine(shape)) $ab7bf64951ce094b$var$straightLineProto.buildPath.call(this, ctx, shape);
        else $ab7bf64951ce094b$var$bezierCurveProto.buildPath.call(this, ctx, shape);
    };
    ECLinePath.prototype.pointAt = function(t) {
        if ($ab7bf64951ce094b$var$isStraightLine(this.shape)) return $ab7bf64951ce094b$var$straightLineProto.pointAt.call(this, t);
        else return $ab7bf64951ce094b$var$bezierCurveProto.pointAt.call(this, t);
    };
    ECLinePath.prototype.tangentAt = function(t) {
        var shape = this.shape;
        var p = $ab7bf64951ce094b$var$isStraightLine(shape) ? [
            shape.x2 - shape.x1,
            shape.y2 - shape.y1
        ] : $ab7bf64951ce094b$var$bezierCurveProto.tangentAt.call(this, t);
        return $6de594cf8ac295ff$export$a3295358bff77e(p, p);
    };
    return ECLinePath;
}($b02ffe7acd508c08$export$2e2bcd8739ae039);
var $ab7bf64951ce094b$export$2e2bcd8739ae039 = $ab7bf64951ce094b$var$ECLinePath;






var $9e0b5f801ab5090c$var$SYMBOL_CATEGORIES = [
    "fromSymbol",
    "toSymbol"
];
function $9e0b5f801ab5090c$var$makeSymbolTypeKey(symbolCategory) {
    return "_" + symbolCategory + "Type";
}
function $9e0b5f801ab5090c$var$makeSymbolTypeValue(name, lineData, idx) {
    var symbolType = lineData.getItemVisual(idx, name);
    if (!symbolType || symbolType === "none") return symbolType;
    var symbolSize = lineData.getItemVisual(idx, name + "Size");
    var symbolRotate = lineData.getItemVisual(idx, name + "Rotate");
    var symbolOffset = lineData.getItemVisual(idx, name + "Offset");
    var symbolKeepAspect = lineData.getItemVisual(idx, name + "KeepAspect");
    var symbolSizeArr = $5370466dadc978d7$export$a84524f03e8e8dfb(symbolSize);
    var symbolOffsetArr = $5370466dadc978d7$export$e3e292895c033f6d(symbolOffset || 0, symbolSizeArr);
    return symbolType + symbolSizeArr + symbolOffsetArr + (symbolRotate || "") + (symbolKeepAspect || "");
}
/**
 * @inner
 */ function $9e0b5f801ab5090c$var$createSymbol(name, lineData, idx) {
    var symbolType = lineData.getItemVisual(idx, name);
    if (!symbolType || symbolType === "none") return;
    var symbolSize = lineData.getItemVisual(idx, name + "Size");
    var symbolRotate = lineData.getItemVisual(idx, name + "Rotate");
    var symbolOffset = lineData.getItemVisual(idx, name + "Offset");
    var symbolKeepAspect = lineData.getItemVisual(idx, name + "KeepAspect");
    var symbolSizeArr = $5370466dadc978d7$export$a84524f03e8e8dfb(symbolSize);
    var symbolOffsetArr = $5370466dadc978d7$export$e3e292895c033f6d(symbolOffset || 0, symbolSizeArr);
    var symbolPath = $5370466dadc978d7$export$af050e04da3a02e8(symbolType, -symbolSizeArr[0] / 2 + symbolOffsetArr[0], -symbolSizeArr[1] / 2 + symbolOffsetArr[1], symbolSizeArr[0], symbolSizeArr[1], null, symbolKeepAspect);
    symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
    symbolPath.name = name;
    return symbolPath;
}
function $9e0b5f801ab5090c$var$createLine(points) {
    var line = new (0, $ab7bf64951ce094b$export$2e2bcd8739ae039)({
        name: "line",
        subPixelOptimize: true
    });
    $9e0b5f801ab5090c$var$setLinePoints(line.shape, points);
    return line;
}
function $9e0b5f801ab5090c$var$setLinePoints(targetShape, points) {
    targetShape.x1 = points[0][0];
    targetShape.y1 = points[0][1];
    targetShape.x2 = points[1][0];
    targetShape.y2 = points[1][1];
    targetShape.percent = 1;
    var cp1 = points[2];
    if (cp1) {
        targetShape.cpx1 = cp1[0];
        targetShape.cpy1 = cp1[1];
    } else {
        targetShape.cpx1 = NaN;
        targetShape.cpy1 = NaN;
    }
}
var $9e0b5f801ab5090c$var$Line = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(Line, _super);
    function Line(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this._createLine(lineData, idx, seriesScope);
        return _this;
    }
    Line.prototype._createLine = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var linePoints = lineData.getItemLayout(idx);
        var line = $9e0b5f801ab5090c$var$createLine(linePoints);
        line.shape.percent = 0;
        $8b353638fbedfefa$export$a121566aadcfe021(line, {
            shape: {
                percent: 1
            }
        }, seriesModel, idx);
        this.add(line);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($9e0b5f801ab5090c$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbol = $9e0b5f801ab5090c$var$createSymbol(symbolCategory, lineData, idx);
            // symbols must added after line to make sure
            // it will be updated after line#update.
            // Or symbol position and rotation update in line#beforeUpdate will be one frame slow
            this.add(symbol);
            this[$9e0b5f801ab5090c$var$makeSymbolTypeKey(symbolCategory)] = $9e0b5f801ab5090c$var$makeSymbolTypeValue(symbolCategory, lineData, idx);
        }, this);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    // TODO More strict on the List type in parameters?
    Line.prototype.updateData = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childOfName("line");
        var linePoints = lineData.getItemLayout(idx);
        var target = {
            shape: {}
        };
        $9e0b5f801ab5090c$var$setLinePoints(target.shape, linePoints);
        $8b353638fbedfefa$export$c8dce3c08436e91e(line, target, seriesModel, idx);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($9e0b5f801ab5090c$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbolType = $9e0b5f801ab5090c$var$makeSymbolTypeValue(symbolCategory, lineData, idx);
            var key = $9e0b5f801ab5090c$var$makeSymbolTypeKey(symbolCategory);
            // Symbol changed
            if (this[key] !== symbolType) {
                this.remove(this.childOfName(symbolCategory));
                var symbol = $9e0b5f801ab5090c$var$createSymbol(symbolCategory, lineData, idx);
                this.add(symbol);
            }
            this[key] = symbolType;
        }, this);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Line.prototype.getLinePath = function() {
        return this.childAt(0);
    };
    Line.prototype._updateCommonStl = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childOfName("line");
        var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
        var blurLineStyle = seriesScope && seriesScope.blurLineStyle;
        var selectLineStyle = seriesScope && seriesScope.selectLineStyle;
        var labelStatesModels = seriesScope && seriesScope.labelStatesModels;
        var emphasisDisabled = seriesScope && seriesScope.emphasisDisabled;
        var focus = seriesScope && seriesScope.focus;
        var blurScope = seriesScope && seriesScope.blurScope;
        // Optimization for large dataset
        if (!seriesScope || lineData.hasItemOption) {
            var itemModel = lineData.getItemModel(idx);
            var emphasisModel = itemModel.getModel("emphasis");
            emphasisLineStyle = emphasisModel.getModel("lineStyle").getLineStyle();
            blurLineStyle = itemModel.getModel([
                "blur",
                "lineStyle"
            ]).getLineStyle();
            selectLineStyle = itemModel.getModel([
                "select",
                "lineStyle"
            ]).getLineStyle();
            emphasisDisabled = emphasisModel.get("disabled");
            focus = emphasisModel.get("focus");
            blurScope = emphasisModel.get("blurScope");
            labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel);
        }
        var lineStyle = lineData.getItemVisual(idx, "style");
        var visualColor = lineStyle.stroke;
        line.useStyle(lineStyle);
        line.style.fill = null;
        line.style.strokeNoScale = true;
        line.ensureState("emphasis").style = emphasisLineStyle;
        line.ensureState("blur").style = blurLineStyle;
        line.ensureState("select").style = selectLineStyle;
        // Update symbol
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($9e0b5f801ab5090c$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbol = this.childOfName(symbolCategory);
            if (symbol) {
                // Share opacity and color with line.
                symbol.setColor(visualColor);
                symbol.style.opacity = lineStyle.opacity;
                for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
                    var stateName = (0, $2bf82c0980125b62$export$151308dceb52d5b)[i];
                    var lineState = line.getState(stateName);
                    if (lineState) {
                        var lineStateStyle = lineState.style || {};
                        var state = symbol.ensureState(stateName);
                        var stateStyle = state.style || (state.style = {});
                        if (lineStateStyle.stroke != null) stateStyle[symbol.__isEmptyBrush ? "stroke" : "fill"] = lineStateStyle.stroke;
                        if (lineStateStyle.opacity != null) stateStyle.opacity = lineStateStyle.opacity;
                    }
                }
                symbol.markRedraw();
            }
        }, this);
        var rawVal = seriesModel.getRawValue(idx);
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(this, labelStatesModels, {
            labelDataIndex: idx,
            labelFetcher: {
                getFormattedLabel: function(dataIndex, stateName) {
                    return seriesModel.getFormattedLabel(dataIndex, stateName, lineData.dataType);
                }
            },
            inheritColor: visualColor || "#000",
            defaultOpacity: lineStyle.opacity,
            defaultText: (rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(rawVal) : rawVal) + ""
        });
        var label = this.getTextContent();
        // Always set `textStyle` even if `normalStyle.text` is null, because default
        // values have to be set on `normalStyle`.
        if (label) {
            var labelNormalModel = labelStatesModels.normal;
            label.__align = label.style.align;
            label.__verticalAlign = label.style.verticalAlign;
            // 'start', 'middle', 'end'
            label.__position = labelNormalModel.get("position") || "middle";
            var distance = labelNormalModel.get("distance");
            if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(distance)) distance = [
                distance,
                distance
            ];
            label.__labelDistance = distance;
        }
        this.setTextConfig({
            position: null,
            local: true,
            inside: false // Can't be inside for stroke element.
        });
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, focus, blurScope, emphasisDisabled);
    };
    Line.prototype.highlight = function() {
        (0, $2bf82c0980125b62$export$b2d02638cc34c042)(this);
    };
    Line.prototype.downplay = function() {
        (0, $2bf82c0980125b62$export$11be6f716239ac55)(this);
    };
    Line.prototype.updateLayout = function(lineData, idx) {
        this.setLinePoints(lineData.getItemLayout(idx));
    };
    Line.prototype.setLinePoints = function(points) {
        var linePath = this.childOfName("line");
        $9e0b5f801ab5090c$var$setLinePoints(linePath.shape, points);
        linePath.dirty();
    };
    Line.prototype.beforeUpdate = function() {
        var lineGroup = this;
        var symbolFrom = lineGroup.childOfName("fromSymbol");
        var symbolTo = lineGroup.childOfName("toSymbol");
        var label = lineGroup.getTextContent();
        // Quick reject
        if (!symbolFrom && !symbolTo && (!label || label.ignore)) return;
        var invScale = 1;
        var parentNode = this.parent;
        while(parentNode){
            if (parentNode.scaleX) invScale /= parentNode.scaleX;
            parentNode = parentNode.parent;
        }
        var line = lineGroup.childOfName("line");
        // If line not changed
        // FIXME Parent scale changed
        if (!this.__dirty && !line.__dirty) return;
        var percent = line.shape.percent;
        var fromPos = line.pointAt(0);
        var toPos = line.pointAt(percent);
        var d = $6de594cf8ac295ff$export$f93b5905241a7cca([], toPos, fromPos);
        $6de594cf8ac295ff$export$a3295358bff77e(d, d);
        function setSymbolRotation(symbol, percent) {
            // Fix #12388
            // when symbol is set to be 'arrow' in markLine,
            // symbolRotate value will be ignored, and compulsively use tangent angle.
            // rotate by default if symbol rotation is not specified
            var specifiedRotation = symbol.__specifiedRotation;
            if (specifiedRotation == null) {
                var tangent = line.tangentAt(percent);
                symbol.attr("rotation", (percent === 1 ? -1 : 1) * Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
            } else symbol.attr("rotation", specifiedRotation);
        }
        if (symbolFrom) {
            symbolFrom.setPosition(fromPos);
            setSymbolRotation(symbolFrom, 0);
            symbolFrom.scaleX = symbolFrom.scaleY = invScale * percent;
            symbolFrom.markRedraw();
        }
        if (symbolTo) {
            symbolTo.setPosition(toPos);
            setSymbolRotation(symbolTo, 1);
            symbolTo.scaleX = symbolTo.scaleY = invScale * percent;
            symbolTo.markRedraw();
        }
        if (label && !label.ignore) {
            label.x = label.y = 0;
            label.originX = label.originY = 0;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var distance = label.__labelDistance;
            var distanceX = distance[0] * invScale;
            var distanceY = distance[1] * invScale;
            var halfPercent = percent / 2;
            var tangent = line.tangentAt(halfPercent);
            var n = [
                tangent[1],
                -tangent[0]
            ];
            var cp = line.pointAt(halfPercent);
            if (n[1] > 0) {
                n[0] = -n[0];
                n[1] = -n[1];
            }
            var dir = tangent[0] < 0 ? -1 : 1;
            if (label.__position !== "start" && label.__position !== "end") {
                var rotation = -Math.atan2(tangent[1], tangent[0]);
                if (toPos[0] < fromPos[0]) rotation = Math.PI + rotation;
                label.rotation = rotation;
            }
            var dy = void 0;
            switch(label.__position){
                case "insideStartTop":
                case "insideMiddleTop":
                case "insideEndTop":
                case "middle":
                    dy = -distanceY;
                    textVerticalAlign = "bottom";
                    break;
                case "insideStartBottom":
                case "insideMiddleBottom":
                case "insideEndBottom":
                    dy = distanceY;
                    textVerticalAlign = "top";
                    break;
                default:
                    dy = 0;
                    textVerticalAlign = "middle";
            }
            switch(label.__position){
                case "end":
                    label.x = d[0] * distanceX + toPos[0];
                    label.y = d[1] * distanceY + toPos[1];
                    textAlign = d[0] > 0.8 ? "left" : d[0] < -0.8 ? "right" : "center";
                    textVerticalAlign = d[1] > 0.8 ? "top" : d[1] < -0.8 ? "bottom" : "middle";
                    break;
                case "start":
                    label.x = -d[0] * distanceX + fromPos[0];
                    label.y = -d[1] * distanceY + fromPos[1];
                    textAlign = d[0] > 0.8 ? "right" : d[0] < -0.8 ? "left" : "center";
                    textVerticalAlign = d[1] > 0.8 ? "bottom" : d[1] < -0.8 ? "top" : "middle";
                    break;
                case "insideStartTop":
                case "insideStart":
                case "insideStartBottom":
                    label.x = distanceX * dir + fromPos[0];
                    label.y = fromPos[1] + dy;
                    textAlign = tangent[0] < 0 ? "right" : "left";
                    label.originX = -distanceX * dir;
                    label.originY = -dy;
                    break;
                case "insideMiddleTop":
                case "insideMiddle":
                case "insideMiddleBottom":
                case "middle":
                    label.x = cp[0];
                    label.y = cp[1] + dy;
                    textAlign = "center";
                    label.originY = -dy;
                    break;
                case "insideEndTop":
                case "insideEnd":
                case "insideEndBottom":
                    label.x = -distanceX * dir + toPos[0];
                    label.y = toPos[1] + dy;
                    textAlign = tangent[0] >= 0 ? "right" : "left";
                    label.originX = distanceX * dir;
                    label.originY = -dy;
                    break;
            }
            label.scaleX = label.scaleY = invScale;
            label.setStyle({
                // Use the user specified text align and baseline first
                verticalAlign: label.__verticalAlign || textVerticalAlign,
                align: label.__align || textAlign
            });
        }
    };
    return Line;
}($7ef7583d8302ffce$export$2e2bcd8739ae039);
var $9e0b5f801ab5090c$export$2e2bcd8739ae039 = $9e0b5f801ab5090c$var$Line;



var $a2fd63a0fc11274a$var$LineDraw = /** @class */ function() {
    function LineDraw(LineCtor) {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this._LineCtor = LineCtor || (0, $9e0b5f801ab5090c$export$2e2bcd8739ae039);
    }
    LineDraw.prototype.updateData = function(lineData) {
        var _this = this;
        // Remove progressive els.
        this._progressiveEls = null;
        var lineDraw = this;
        var group = lineDraw.group;
        var oldLineData = lineDraw._lineData;
        lineDraw._lineData = lineData;
        // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldLineData) group.removeAll();
        var seriesScope = $a2fd63a0fc11274a$var$makeSeriesScope(lineData);
        lineData.diff(oldLineData).add(function(idx) {
            _this._doAdd(lineData, idx, seriesScope);
        }).update(function(newIdx, oldIdx) {
            _this._doUpdate(oldLineData, lineData, oldIdx, newIdx, seriesScope);
        }).remove(function(idx) {
            group.remove(oldLineData.getItemGraphicEl(idx));
        }).execute();
    };
    LineDraw.prototype.updateLayout = function() {
        var lineData = this._lineData;
        // Do not support update layout in incremental mode.
        if (!lineData) return;
        lineData.eachItemGraphicEl(function(el, idx) {
            el.updateLayout(lineData, idx);
        }, this);
    };
    LineDraw.prototype.incrementalPrepareUpdate = function(lineData) {
        this._seriesScope = $a2fd63a0fc11274a$var$makeSeriesScope(lineData);
        this._lineData = null;
        this.group.removeAll();
    };
    LineDraw.prototype.incrementalUpdate = function(taskParams, lineData) {
        this._progressiveEls = [];
        function updateIncrementalAndHover(el) {
            if (!el.isGroup && !$a2fd63a0fc11274a$var$isEffectObject(el)) {
                el.incremental = true;
                el.ensureState("emphasis").hoverLayer = true;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var itemLayout = lineData.getItemLayout(idx);
            if ($a2fd63a0fc11274a$var$lineNeedsDraw(itemLayout)) {
                var el = new this._LineCtor(lineData, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                this.group.add(el);
                lineData.setItemGraphicEl(idx, el);
                this._progressiveEls.push(el);
            }
        }
    };
    LineDraw.prototype.remove = function() {
        this.group.removeAll();
    };
    LineDraw.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    LineDraw.prototype._doAdd = function(lineData, idx, seriesScope) {
        var itemLayout = lineData.getItemLayout(idx);
        if (!$a2fd63a0fc11274a$var$lineNeedsDraw(itemLayout)) return;
        var el = new this._LineCtor(lineData, idx, seriesScope);
        lineData.setItemGraphicEl(idx, el);
        this.group.add(el);
    };
    LineDraw.prototype._doUpdate = function(oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
        var itemEl = oldLineData.getItemGraphicEl(oldIdx);
        if (!$a2fd63a0fc11274a$var$lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
            this.group.remove(itemEl);
            return;
        }
        if (!itemEl) itemEl = new this._LineCtor(newLineData, newIdx, seriesScope);
        else itemEl.updateData(newLineData, newIdx, seriesScope);
        newLineData.setItemGraphicEl(newIdx, itemEl);
        this.group.add(itemEl);
    };
    return LineDraw;
}();
function $a2fd63a0fc11274a$var$isEffectObject(el) {
    return el.animators && el.animators.length > 0;
}
function $a2fd63a0fc11274a$var$makeSeriesScope(lineData) {
    var hostModel = lineData.hostModel;
    var emphasisModel = hostModel.getModel("emphasis");
    return {
        lineStyle: hostModel.getModel("lineStyle").getLineStyle(),
        emphasisLineStyle: emphasisModel.getModel([
            "lineStyle"
        ]).getLineStyle(),
        blurLineStyle: hostModel.getModel([
            "blur",
            "lineStyle"
        ]).getLineStyle(),
        selectLineStyle: hostModel.getModel([
            "select",
            "lineStyle"
        ]).getLineStyle(),
        emphasisDisabled: emphasisModel.get("disabled"),
        blurScope: emphasisModel.get("blurScope"),
        focus: emphasisModel.get("focus"),
        labelStatesModels: (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(hostModel)
    };
}
function $a2fd63a0fc11274a$var$isPointNaN(pt) {
    return isNaN(pt[0]) || isNaN(pt[1]);
}
function $a2fd63a0fc11274a$var$lineNeedsDraw(pts) {
    return pts && !$a2fd63a0fc11274a$var$isPointNaN(pts[0]) && !$a2fd63a0fc11274a$var$isPointNaN(pts[1]);
}
var $a2fd63a0fc11274a$export$2e2bcd8739ae039 = $a2fd63a0fc11274a$var$LineDraw;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck


var $befd6a34b30d3f54$var$ATTR = "\0_ec_interaction_mutex";
function $befd6a34b30d3f54$export$b7df5d561049483a(zr, resourceKey, userKey) {
    var store = $befd6a34b30d3f54$var$getStore(zr);
    store[resourceKey] = userKey;
}
function $befd6a34b30d3f54$export$23d3fad09dc44362(zr, resourceKey, userKey) {
    var store = $befd6a34b30d3f54$var$getStore(zr);
    var uKey = store[resourceKey];
    if (uKey === userKey) store[resourceKey] = null;
}
function $befd6a34b30d3f54$export$5623cba512bc9470(zr, resourceKey) {
    return !!$befd6a34b30d3f54$var$getStore(zr)[resourceKey];
}
function $befd6a34b30d3f54$var$getStore(zr) {
    return zr[$befd6a34b30d3f54$var$ATTR] || (zr[$befd6a34b30d3f54$var$ATTR] = {});
}
/**
 * payload: {
 *     type: 'takeGlobalCursor',
 *     key: 'dataZoomSelect', or 'brush', or ...,
 *         If no userKey, release global cursor.
 * }
 */ // TODO: SELF REGISTERED.
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: "takeGlobalCursor",
    event: "globalCursorTaken",
    update: "update"
}, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));



var $15927f329deeab51$var$RoamController = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RoamController, _super);
    function RoamController(zr) {
        var _this = _super.call(this) || this;
        _this._zr = zr;
        // Avoid two roamController bind the same handler
        var mousedownHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._mousedownHandler, _this);
        var mousemoveHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._mousemoveHandler, _this);
        var mouseupHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._mouseupHandler, _this);
        var mousewheelHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._mousewheelHandler, _this);
        var pinchHandler = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._pinchHandler, _this);
        /**
     * Notice: only enable needed types. For example, if 'zoom'
     * is not needed, 'zoom' should not be enabled, otherwise
     * default mousewheel behaviour (scroll page) will be disabled.
     */ _this.enable = function(controlType, opt) {
            // Disable previous first
            this.disable();
            this._opt = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(opt) || {}, {
                zoomOnMouseWheel: true,
                moveOnMouseMove: true,
                // By default, wheel do not trigger move.
                moveOnMouseWheel: false,
                preventDefaultMouseMove: true
            });
            if (controlType == null) controlType = true;
            if (controlType === true || controlType === "move" || controlType === "pan") {
                zr.on("mousedown", mousedownHandler);
                zr.on("mousemove", mousemoveHandler);
                zr.on("mouseup", mouseupHandler);
            }
            if (controlType === true || controlType === "scale" || controlType === "zoom") {
                zr.on("mousewheel", mousewheelHandler);
                zr.on("pinch", pinchHandler);
            }
        };
        _this.disable = function() {
            zr.off("mousedown", mousedownHandler);
            zr.off("mousemove", mousemoveHandler);
            zr.off("mouseup", mouseupHandler);
            zr.off("mousewheel", mousewheelHandler);
            zr.off("pinch", pinchHandler);
        };
        return _this;
    }
    RoamController.prototype.isDragging = function() {
        return this._dragging;
    };
    RoamController.prototype.isPinching = function() {
        return this._pinching;
    };
    RoamController.prototype.setPointerChecker = function(pointerChecker) {
        this.pointerChecker = pointerChecker;
    };
    RoamController.prototype.dispose = function() {
        this.disable();
    };
    RoamController.prototype._mousedownHandler = function(e) {
        if ($b3864a78637ff9ed$export$b7ae4cded3e71bd2(e)) return;
        var el = e.target;
        while(el){
            if (el.draggable) return;
            // check if host is draggable
            el = el.__hostTarget || el.parent;
        }
        var x = e.offsetX;
        var y = e.offsetY;
        // Only check on mosedown, but not mousemove.
        // Mouse can be out of target when mouse moving.
        if (this.pointerChecker && this.pointerChecker(e, x, y)) {
            this._x = x;
            this._y = y;
            this._dragging = true;
        }
    };
    RoamController.prototype._mousemoveHandler = function(e) {
        if (!this._dragging || !$15927f329deeab51$var$isAvailableBehavior("moveOnMouseMove", e, this._opt) || e.gestureEvent === "pinch" || $befd6a34b30d3f54$export$5623cba512bc9470(this._zr, "globalPan")) return;
        var x = e.offsetX;
        var y = e.offsetY;
        var oldX = this._x;
        var oldY = this._y;
        var dx = x - oldX;
        var dy = y - oldY;
        this._x = x;
        this._y = y;
        this._opt.preventDefaultMouseMove && $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
        $15927f329deeab51$var$trigger(this, "pan", "moveOnMouseMove", e, {
            dx: dx,
            dy: dy,
            oldX: oldX,
            oldY: oldY,
            newX: x,
            newY: y,
            isAvailableBehavior: null
        });
    };
    RoamController.prototype._mouseupHandler = function(e) {
        if (!$b3864a78637ff9ed$export$b7ae4cded3e71bd2(e)) this._dragging = false;
    };
    RoamController.prototype._mousewheelHandler = function(e) {
        var shouldZoom = $15927f329deeab51$var$isAvailableBehavior("zoomOnMouseWheel", e, this._opt);
        var shouldMove = $15927f329deeab51$var$isAvailableBehavior("moveOnMouseWheel", e, this._opt);
        var wheelDelta = e.wheelDelta;
        var absWheelDeltaDelta = Math.abs(wheelDelta);
        var originX = e.offsetX;
        var originY = e.offsetY;
        // wheelDelta maybe -0 in chrome mac.
        if (wheelDelta === 0 || !shouldZoom && !shouldMove) return;
        // If both `shouldZoom` and `shouldMove` is true, trigger
        // their event both, and the final behavior is determined
        // by event listener themselves.
        if (shouldZoom) {
            // Convenience:
            // Mac and VM Windows on Mac: scroll up: zoom out.
            // Windows: scroll up: zoom in.
            // FIXME: Should do more test in different environment.
            // wheelDelta is too complicated in difference nvironment
            // (https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel),
            // although it has been normallized by zrender.
            // wheelDelta of mouse wheel is bigger than touch pad.
            var factor = absWheelDeltaDelta > 3 ? 1.4 : absWheelDeltaDelta > 1 ? 1.2 : 1.1;
            var scale = wheelDelta > 0 ? factor : 1 / factor;
            $15927f329deeab51$var$checkPointerAndTrigger(this, "zoom", "zoomOnMouseWheel", e, {
                scale: scale,
                originX: originX,
                originY: originY,
                isAvailableBehavior: null
            });
        }
        if (shouldMove) {
            // FIXME: Should do more test in different environment.
            var absDelta = Math.abs(wheelDelta);
            // wheelDelta of mouse wheel is bigger than touch pad.
            var scrollDelta = (wheelDelta > 0 ? 1 : -1) * (absDelta > 3 ? 0.4 : absDelta > 1 ? 0.15 : 0.05);
            $15927f329deeab51$var$checkPointerAndTrigger(this, "scrollMove", "moveOnMouseWheel", e, {
                scrollDelta: scrollDelta,
                originX: originX,
                originY: originY,
                isAvailableBehavior: null
            });
        }
    };
    RoamController.prototype._pinchHandler = function(e) {
        if ($befd6a34b30d3f54$export$5623cba512bc9470(this._zr, "globalPan")) return;
        var scale = e.pinchScale > 1 ? 1.1 : 1 / 1.1;
        $15927f329deeab51$var$checkPointerAndTrigger(this, "zoom", null, e, {
            scale: scale,
            originX: e.pinchX,
            originY: e.pinchY,
            isAvailableBehavior: null
        });
    };
    return RoamController;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
function $15927f329deeab51$var$checkPointerAndTrigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
    if (controller.pointerChecker && controller.pointerChecker(e, contollerEvent.originX, contollerEvent.originY)) {
        // When mouse is out of roamController rect,
        // default befavoius should not be be disabled, otherwise
        // page sliding is disabled, contrary to expectation.
        $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
        $15927f329deeab51$var$trigger(controller, eventName, behaviorToCheck, e, contollerEvent);
    }
}
function $15927f329deeab51$var$trigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
    // Also provide behavior checker for event listener, for some case that
    // multiple components share one listener.
    contollerEvent.isAvailableBehavior = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($15927f329deeab51$var$isAvailableBehavior, null, behaviorToCheck, e);
    // TODO should not have type issue.
    controller.trigger(eventName, contollerEvent);
}
// settings: {
//     zoomOnMouseWheel
//     moveOnMouseMove
//     moveOnMouseWheel
// }
// The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
function $15927f329deeab51$var$isAvailableBehavior(behaviorToCheck, e, settings) {
    var setting = settings[behaviorToCheck];
    return !behaviorToCheck || setting && (!(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(setting) || e.event[setting + "Key"]);
}
var $15927f329deeab51$export$2e2bcd8739ae039 = $15927f329deeab51$var$RoamController;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * For geo and graph.
 */ function $35fd859fd545c4be$export$1e6abcd98caba733(controllerHost, dx, dy) {
    var target = controllerHost.target;
    target.x += dx;
    target.y += dy;
    target.dirty();
}
function $35fd859fd545c4be$export$29b3c66d30a4866(controllerHost, zoomDelta, zoomX, zoomY) {
    var target = controllerHost.target;
    var zoomLimit = controllerHost.zoomLimit;
    var newZoom = controllerHost.zoom = controllerHost.zoom || 1;
    newZoom *= zoomDelta;
    if (zoomLimit) {
        var zoomMin = zoomLimit.min || 0;
        var zoomMax = zoomLimit.max || Infinity;
        newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
    }
    var zoomScale = newZoom / controllerHost.zoom;
    controllerHost.zoom = newZoom;
    // Keep the mouse center when scaling
    target.x -= (zoomX - target.x) * (zoomScale - 1);
    target.y -= (zoomY - target.y) * (zoomScale - 1);
    target.scaleX *= zoomScale;
    target.scaleY *= zoomScale;
    target.dirty();
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $bee256db41541054$var$IRRELEVANT_EXCLUDES = {
    "axisPointer": 1,
    "tooltip": 1,
    "brush": 1
};
function $bee256db41541054$export$8a33eacb690eac07(e, api, targetCoordSysModel) {
    var model = api.getComponentByElement(e.topTarget);
    // If model is axisModel, it works only if it is injected with coordinateSystem.
    var coordSys = model && model.coordinateSystem;
    return model && model !== targetCoordSysModel && !$bee256db41541054$var$IRRELEVANT_EXCLUDES.hasOwnProperty(model.mainType) && coordSys && coordSys.model !== targetCoordSysModel;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $197126bedfb0a68b$var$v1 = [];
var $197126bedfb0a68b$var$v2 = [];
var $197126bedfb0a68b$var$v3 = [];
var $197126bedfb0a68b$var$quadraticAt = $747cfc5611b57cea$export$af17094a950f5073;
var $197126bedfb0a68b$var$v2DistSquare = $6de594cf8ac295ff$export$c68db45a034c13b0;
var $197126bedfb0a68b$var$mathAbs = Math.abs;
function $197126bedfb0a68b$var$intersectCurveCircle(curvePoints, center, radius) {
    var p0 = curvePoints[0];
    var p1 = curvePoints[1];
    var p2 = curvePoints[2];
    var d = Infinity;
    var t;
    var radiusSquare = radius * radius;
    var interval = 0.1;
    for(var _t = 0.1; _t <= 0.9; _t += 0.1){
        $197126bedfb0a68b$var$v1[0] = $197126bedfb0a68b$var$quadraticAt(p0[0], p1[0], p2[0], _t);
        $197126bedfb0a68b$var$v1[1] = $197126bedfb0a68b$var$quadraticAt(p0[1], p1[1], p2[1], _t);
        var diff = $197126bedfb0a68b$var$mathAbs($197126bedfb0a68b$var$v2DistSquare($197126bedfb0a68b$var$v1, center) - radiusSquare);
        if (diff < d) {
            d = diff;
            t = _t;
        }
    }
    // Assume the segment is monotone，Find root through Bisection method
    // At most 32 iteration
    for(var i = 0; i < 32; i++){
        // let prev = t - interval;
        var next = t + interval;
        // v1[0] = quadraticAt(p0[0], p1[0], p2[0], prev);
        // v1[1] = quadraticAt(p0[1], p1[1], p2[1], prev);
        $197126bedfb0a68b$var$v2[0] = $197126bedfb0a68b$var$quadraticAt(p0[0], p1[0], p2[0], t);
        $197126bedfb0a68b$var$v2[1] = $197126bedfb0a68b$var$quadraticAt(p0[1], p1[1], p2[1], t);
        $197126bedfb0a68b$var$v3[0] = $197126bedfb0a68b$var$quadraticAt(p0[0], p1[0], p2[0], next);
        $197126bedfb0a68b$var$v3[1] = $197126bedfb0a68b$var$quadraticAt(p0[1], p1[1], p2[1], next);
        var diff = $197126bedfb0a68b$var$v2DistSquare($197126bedfb0a68b$var$v2, center) - radiusSquare;
        if ($197126bedfb0a68b$var$mathAbs(diff) < 1e-2) break;
        // let prevDiff = v2DistSquare(v1, center) - radiusSquare;
        var nextDiff = $197126bedfb0a68b$var$v2DistSquare($197126bedfb0a68b$var$v3, center) - radiusSquare;
        interval /= 2;
        if (diff < 0) {
            if (nextDiff >= 0) t = t + interval;
            else t = t - interval;
        } else if (nextDiff >= 0) t = t - interval;
        else t = t + interval;
    }
    return t;
}
function $197126bedfb0a68b$export$2e2bcd8739ae039(graph, scale) {
    var tmp0 = [];
    var quadraticSubdivide = $747cfc5611b57cea$export$117c659e21a7a060;
    var pts = [
        [],
        [],
        []
    ];
    var pts2 = [
        [],
        []
    ];
    var v = [];
    scale /= 2;
    graph.eachEdge(function(edge, idx) {
        var linePoints = edge.getLayout();
        var fromSymbol = edge.getVisual("fromSymbol");
        var toSymbol = edge.getVisual("toSymbol");
        if (!linePoints.__original) {
            linePoints.__original = [
                $6de594cf8ac295ff$export$9cd59f9826255e47(linePoints[0]),
                $6de594cf8ac295ff$export$9cd59f9826255e47(linePoints[1])
            ];
            if (linePoints[2]) linePoints.__original.push($6de594cf8ac295ff$export$9cd59f9826255e47(linePoints[2]));
        }
        var originalPoints = linePoints.__original;
        // Quadratic curve
        if (linePoints[2] != null) {
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts[0], originalPoints[0]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts[1], originalPoints[2]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts[2], originalPoints[1]);
            if (fromSymbol && fromSymbol !== "none") {
                var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(edge.node1);
                var t = $197126bedfb0a68b$var$intersectCurveCircle(pts, originalPoints[0], symbolSize * scale);
                // Subdivide and get the second
                quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
                pts[0][0] = tmp0[3];
                pts[1][0] = tmp0[4];
                quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
                pts[0][1] = tmp0[3];
                pts[1][1] = tmp0[4];
            }
            if (toSymbol && toSymbol !== "none") {
                var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(edge.node2);
                var t = $197126bedfb0a68b$var$intersectCurveCircle(pts, originalPoints[1], symbolSize * scale);
                // Subdivide and get the first
                quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
                pts[1][0] = tmp0[1];
                pts[2][0] = tmp0[2];
                quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
                pts[1][1] = tmp0[1];
                pts[2][1] = tmp0[2];
            }
            // Copy back to layout
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[0], pts[0]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[1], pts[2]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[2], pts[1]);
        } else {
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts2[0], originalPoints[0]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(pts2[1], originalPoints[1]);
            $6de594cf8ac295ff$export$f93b5905241a7cca(v, pts2[1], pts2[0]);
            $6de594cf8ac295ff$export$a3295358bff77e(v, v);
            if (fromSymbol && fromSymbol !== "none") {
                var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(edge.node1);
                $6de594cf8ac295ff$export$19cedf1da84ba854(pts2[0], pts2[0], v, symbolSize * scale);
            }
            if (toSymbol && toSymbol !== "none") {
                var symbolSize = (0, $ad8b4f94f577d55a$export$8d4a06d3facd414b)(edge.node2);
                $6de594cf8ac295ff$export$19cedf1da84ba854(pts2[1], pts2[1], v, -symbolSize * scale);
            }
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[0], pts2[0]);
            $6de594cf8ac295ff$export$784d13d8ee351f07(linePoints[1], pts2[1]);
        }
    });
}







function $65490d05ca8b2521$var$isViewCoordSys(coordSys) {
    return coordSys.type === "view";
}
var $65490d05ca8b2521$var$GraphView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GraphView, _super);
    function GraphView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphView.type;
        return _this;
    }
    GraphView.prototype.init = function(ecModel, api) {
        var symbolDraw = new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)();
        var lineDraw = new (0, $a2fd63a0fc11274a$export$2e2bcd8739ae039)();
        var group = this.group;
        this._controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
        this._controllerHost = {
            target: group
        };
        group.add(symbolDraw.group);
        group.add(lineDraw.group);
        this._symbolDraw = symbolDraw;
        this._lineDraw = lineDraw;
        this._firstRender = true;
    };
    GraphView.prototype.render = function(seriesModel, ecModel, api) {
        var _this = this;
        var coordSys = seriesModel.coordinateSystem;
        this._model = seriesModel;
        var symbolDraw = this._symbolDraw;
        var lineDraw = this._lineDraw;
        var group = this.group;
        if ($65490d05ca8b2521$var$isViewCoordSys(coordSys)) {
            var groupNewProp = {
                x: coordSys.x,
                y: coordSys.y,
                scaleX: coordSys.scaleX,
                scaleY: coordSys.scaleY
            };
            if (this._firstRender) group.attr(groupNewProp);
            else $8b353638fbedfefa$export$c8dce3c08436e91e(group, groupNewProp, seriesModel);
        }
        // Fix edge contact point with node
        (0, $197126bedfb0a68b$export$2e2bcd8739ae039)(seriesModel.getGraph(), (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel));
        var data = seriesModel.getData();
        symbolDraw.updateData(data);
        var edgeData = seriesModel.getEdgeData();
        // TODO: TYPE
        lineDraw.updateData(edgeData);
        this._updateNodeAndLinkScale();
        this._updateController(seriesModel, ecModel, api);
        clearTimeout(this._layoutTimeout);
        var forceLayout = seriesModel.forceLayout;
        var layoutAnimation = seriesModel.get([
            "force",
            "layoutAnimation"
        ]);
        if (forceLayout) this._startForceLayoutIteration(forceLayout, layoutAnimation);
        var layout = seriesModel.get("layout");
        data.graph.eachNode(function(node) {
            var idx = node.dataIndex;
            var el = node.getGraphicEl();
            var itemModel = node.getModel();
            if (!el) return;
            // Update draggable
            el.off("drag").off("dragend");
            var draggable = itemModel.get("draggable");
            if (draggable) el.on("drag", function(e) {
                switch(layout){
                    case "force":
                        forceLayout.warmUp();
                        !_this._layouting && _this._startForceLayoutIteration(forceLayout, layoutAnimation);
                        forceLayout.setFixed(idx);
                        // Write position back to layout
                        data.setItemLayout(idx, [
                            el.x,
                            el.y
                        ]);
                        break;
                    case "circular":
                        data.setItemLayout(idx, [
                            el.x,
                            el.y
                        ]);
                        // mark node fixed
                        node.setLayout({
                            fixed: true
                        }, true);
                        // recalculate circular layout
                        (0, $484ee97adf82b508$export$cbfed6ae5cab3dae)(seriesModel, "symbolSize", node, [
                            e.offsetX,
                            e.offsetY
                        ]);
                        _this.updateLayout(seriesModel);
                        break;
                    case "none":
                    default:
                        data.setItemLayout(idx, [
                            el.x,
                            el.y
                        ]);
                        // update edge
                        (0, $159cad03c3625d06$export$a25b52345bee32aa)(seriesModel.getGraph(), seriesModel);
                        _this.updateLayout(seriesModel);
                        break;
                }
            }).on("dragend", function() {
                if (forceLayout) forceLayout.setUnfixed(idx);
            });
            el.setDraggable(draggable, !!itemModel.get("cursor"));
            var focus = itemModel.get([
                "emphasis",
                "focus"
            ]);
            if (focus === "adjacency") (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).focus = node.getAdjacentDataIndices();
        });
        data.graph.eachEdge(function(edge) {
            var el = edge.getGraphicEl();
            var focus = edge.getModel().get([
                "emphasis",
                "focus"
            ]);
            if (!el) return;
            if (focus === "adjacency") (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).focus = {
                edge: [
                    edge.dataIndex
                ],
                node: [
                    edge.node1.dataIndex,
                    edge.node2.dataIndex
                ]
            };
        });
        var circularRotateLabel = seriesModel.get("layout") === "circular" && seriesModel.get([
            "circular",
            "rotateLabel"
        ]);
        var cx = data.getLayout("cx");
        var cy = data.getLayout("cy");
        data.graph.eachNode(function(node) {
            (0, $484ee97adf82b508$export$c768377a6a0a9ab8)(node, circularRotateLabel, cx, cy);
        });
        this._firstRender = false;
    };
    GraphView.prototype.dispose = function() {
        this.remove();
        this._controller && this._controller.dispose();
        this._controllerHost = null;
    };
    GraphView.prototype._startForceLayoutIteration = function(forceLayout, layoutAnimation) {
        var self = this;
        (function step() {
            forceLayout.step(function(stopped) {
                self.updateLayout(self._model);
                (self._layouting = !stopped) && (layoutAnimation ? self._layoutTimeout = setTimeout(step, 16) : step());
            });
        })();
    };
    GraphView.prototype._updateController = function(seriesModel, ecModel, api) {
        var _this = this;
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        var group = this.group;
        controller.setPointerChecker(function(e, x, y) {
            var rect = group.getBoundingRect();
            rect.applyTransform(group.transform);
            return rect.contain(x, y) && !(0, $bee256db41541054$export$8a33eacb690eac07)(e, api, seriesModel);
        });
        if (!$65490d05ca8b2521$var$isViewCoordSys(seriesModel.coordinateSystem)) {
            controller.disable();
            return;
        }
        controller.enable(seriesModel.get("roam"));
        controllerHost.zoomLimit = seriesModel.get("scaleLimit");
        controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
        controller.off("pan").off("zoom").on("pan", function(e) {
            $35fd859fd545c4be$export$1e6abcd98caba733(controllerHost, e.dx, e.dy);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: "graphRoam",
                dx: e.dx,
                dy: e.dy
            });
        }).on("zoom", function(e) {
            $35fd859fd545c4be$export$29b3c66d30a4866(controllerHost, e.scale, e.originX, e.originY);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: "graphRoam",
                zoom: e.scale,
                originX: e.originX,
                originY: e.originY
            });
            _this._updateNodeAndLinkScale();
            (0, $197126bedfb0a68b$export$2e2bcd8739ae039)(seriesModel.getGraph(), (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel));
            _this._lineDraw.updateLayout();
            // Only update label layout on zoom
            api.updateLabelLayout();
        });
    };
    GraphView.prototype._updateNodeAndLinkScale = function() {
        var seriesModel = this._model;
        var data = seriesModel.getData();
        var nodeScale = (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel);
        data.eachItemGraphicEl(function(el, idx) {
            el && el.setSymbolScale(nodeScale);
        });
    };
    GraphView.prototype.updateLayout = function(seriesModel) {
        (0, $197126bedfb0a68b$export$2e2bcd8739ae039)(seriesModel.getGraph(), (0, $ad8b4f94f577d55a$export$e2aa0fb9ed198ba7)(seriesModel));
        this._symbolDraw.updateLayout();
        this._lineDraw.updateLayout();
    };
    GraphView.prototype.remove = function() {
        clearTimeout(this._layoutTimeout);
        this._layouting = false;
        this._layoutTimeout = null;
        this._symbolDraw && this._symbolDraw.remove();
        this._lineDraw && this._lineDraw.remove();
    };
    GraphView.type = "graph";
    return GraphView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $65490d05ca8b2521$export$2e2bcd8739ae039 = $65490d05ca8b2521$var$GraphView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// id may be function name of Object, add a prefix to avoid this problem.
function $7e67f74238c90217$var$generateNodeKey(id) {
    return "_EC_" + id;
}
var $7e67f74238c90217$var$Graph = /** @class */ function() {
    function Graph(directed) {
        this.type = "graph";
        this.nodes = [];
        this.edges = [];
        this._nodesMap = {};
        /**
     * @type {Object.<string, module:echarts/data/Graph.Edge>}
     * @private
     */ this._edgesMap = {};
        this._directed = directed || false;
    }
    /**
   * If is directed graph
   */ Graph.prototype.isDirected = function() {
        return this._directed;
    };
    /**
   * Add a new node
   */ Graph.prototype.addNode = function(id, dataIndex) {
        id = id == null ? "" + dataIndex : "" + id;
        var nodesMap = this._nodesMap;
        if (nodesMap[$7e67f74238c90217$var$generateNodeKey(id)]) return;
        var node = new $7e67f74238c90217$export$32866653dfc29d0d(id, dataIndex);
        node.hostGraph = this;
        this.nodes.push(node);
        nodesMap[$7e67f74238c90217$var$generateNodeKey(id)] = node;
        return node;
    };
    /**
   * Get node by data index
   */ Graph.prototype.getNodeByIndex = function(dataIndex) {
        var rawIdx = this.data.getRawIndex(dataIndex);
        return this.nodes[rawIdx];
    };
    /**
   * Get node by id
   */ Graph.prototype.getNodeById = function(id) {
        return this._nodesMap[$7e67f74238c90217$var$generateNodeKey(id)];
    };
    /**
   * Add a new edge
   */ Graph.prototype.addEdge = function(n1, n2, dataIndex) {
        var nodesMap = this._nodesMap;
        var edgesMap = this._edgesMap;
        // PENDING
        if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(n1)) n1 = this.nodes[n1];
        if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(n2)) n2 = this.nodes[n2];
        if (!(n1 instanceof $7e67f74238c90217$export$32866653dfc29d0d)) n1 = nodesMap[$7e67f74238c90217$var$generateNodeKey(n1)];
        if (!(n2 instanceof $7e67f74238c90217$export$32866653dfc29d0d)) n2 = nodesMap[$7e67f74238c90217$var$generateNodeKey(n2)];
        if (!n1 || !n2) return;
        var key = n1.id + "-" + n2.id;
        var edge = new $7e67f74238c90217$export$87f150720cc8d165(n1, n2, dataIndex);
        edge.hostGraph = this;
        if (this._directed) {
            n1.outEdges.push(edge);
            n2.inEdges.push(edge);
        }
        n1.edges.push(edge);
        if (n1 !== n2) n2.edges.push(edge);
        this.edges.push(edge);
        edgesMap[key] = edge;
        return edge;
    };
    /**
   * Get edge by data index
   */ Graph.prototype.getEdgeByIndex = function(dataIndex) {
        var rawIdx = this.edgeData.getRawIndex(dataIndex);
        return this.edges[rawIdx];
    };
    /**
   * Get edge by two linked nodes
   */ Graph.prototype.getEdge = function(n1, n2) {
        if (n1 instanceof $7e67f74238c90217$export$32866653dfc29d0d) n1 = n1.id;
        if (n2 instanceof $7e67f74238c90217$export$32866653dfc29d0d) n2 = n2.id;
        var edgesMap = this._edgesMap;
        if (this._directed) return edgesMap[n1 + "-" + n2];
        else return edgesMap[n1 + "-" + n2] || edgesMap[n2 + "-" + n1];
    };
    /**
   * Iterate all nodes
   */ Graph.prototype.eachNode = function(cb, context) {
        var nodes = this.nodes;
        var len = nodes.length;
        for(var i = 0; i < len; i++)if (nodes[i].dataIndex >= 0) cb.call(context, nodes[i], i);
    };
    /**
   * Iterate all edges
   */ Graph.prototype.eachEdge = function(cb, context) {
        var edges = this.edges;
        var len = edges.length;
        for(var i = 0; i < len; i++)if (edges[i].dataIndex >= 0 && edges[i].node1.dataIndex >= 0 && edges[i].node2.dataIndex >= 0) cb.call(context, edges[i], i);
    };
    /**
   * Breadth first traverse
   * Return true to stop traversing
   */ Graph.prototype.breadthFirstTraverse = function(cb, startNode, direction, context) {
        if (!(startNode instanceof $7e67f74238c90217$export$32866653dfc29d0d)) startNode = this._nodesMap[$7e67f74238c90217$var$generateNodeKey(startNode)];
        if (!startNode) return;
        var edgeType = direction === "out" ? "outEdges" : direction === "in" ? "inEdges" : "edges";
        for(var i = 0; i < this.nodes.length; i++)this.nodes[i].__visited = false;
        if (cb.call(context, startNode, null)) return;
        var queue = [
            startNode
        ];
        while(queue.length){
            var currentNode = queue.shift();
            var edges = currentNode[edgeType];
            for(var i = 0; i < edges.length; i++){
                var e = edges[i];
                var otherNode = e.node1 === currentNode ? e.node2 : e.node1;
                if (!otherNode.__visited) {
                    if (cb.call(context, otherNode, currentNode)) // Stop traversing
                    return;
                    queue.push(otherNode);
                    otherNode.__visited = true;
                }
            }
        }
    };
    // TODO
    // depthFirstTraverse(
    //     cb, startNode, direction, context
    // ) {
    // };
    // Filter update
    Graph.prototype.update = function() {
        var data = this.data;
        var edgeData = this.edgeData;
        var nodes = this.nodes;
        var edges = this.edges;
        for(var i = 0, len = nodes.length; i < len; i++)nodes[i].dataIndex = -1;
        for(var i = 0, len = data.count(); i < len; i++)nodes[data.getRawIndex(i)].dataIndex = i;
        edgeData.filterSelf(function(idx) {
            var edge = edges[edgeData.getRawIndex(idx)];
            return edge.node1.dataIndex >= 0 && edge.node2.dataIndex >= 0;
        });
        // Update edge
        for(var i = 0, len = edges.length; i < len; i++)edges[i].dataIndex = -1;
        for(var i = 0, len = edgeData.count(); i < len; i++)edges[edgeData.getRawIndex(i)].dataIndex = i;
    };
    /**
   * @return {module:echarts/data/Graph}
   */ Graph.prototype.clone = function() {
        var graph = new Graph(this._directed);
        var nodes = this.nodes;
        var edges = this.edges;
        for(var i = 0; i < nodes.length; i++)graph.addNode(nodes[i].id, nodes[i].dataIndex);
        for(var i = 0; i < edges.length; i++){
            var e = edges[i];
            graph.addEdge(e.node1.id, e.node2.id, e.dataIndex);
        }
        return graph;
    };
    return Graph;
}();
var $7e67f74238c90217$export$32866653dfc29d0d = /** @class */ function() {
    function GraphNode(id, dataIndex) {
        this.inEdges = [];
        this.outEdges = [];
        this.edges = [];
        this.dataIndex = -1;
        this.id = id == null ? "" : id;
        this.dataIndex = dataIndex == null ? -1 : dataIndex;
    }
    /**
   * @return {number}
   */ GraphNode.prototype.degree = function() {
        return this.edges.length;
    };
    /**
   * @return {number}
   */ GraphNode.prototype.inDegree = function() {
        return this.inEdges.length;
    };
    /**
  * @return {number}
  */ GraphNode.prototype.outDegree = function() {
        return this.outEdges.length;
    };
    GraphNode.prototype.getModel = function(path) {
        if (this.dataIndex < 0) return;
        var graph = this.hostGraph;
        var itemModel = graph.data.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    };
    GraphNode.prototype.getAdjacentDataIndices = function() {
        var dataIndices = {
            edge: [],
            node: []
        };
        for(var i = 0; i < this.edges.length; i++){
            var adjacentEdge = this.edges[i];
            if (adjacentEdge.dataIndex < 0) continue;
            dataIndices.edge.push(adjacentEdge.dataIndex);
            dataIndices.node.push(adjacentEdge.node1.dataIndex, adjacentEdge.node2.dataIndex);
        }
        return dataIndices;
    };
    GraphNode.prototype.getTrajectoryDataIndices = function() {
        var connectedEdgesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var connectedNodesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        for(var i = 0; i < this.edges.length; i++){
            var adjacentEdge = this.edges[i];
            if (adjacentEdge.dataIndex < 0) continue;
            connectedEdgesMap.set(adjacentEdge.dataIndex, true);
            var sourceNodesQueue = [
                adjacentEdge.node1
            ];
            var targetNodesQueue = [
                adjacentEdge.node2
            ];
            var nodeIteratorIndex = 0;
            while(nodeIteratorIndex < sourceNodesQueue.length){
                var sourceNode = sourceNodesQueue[nodeIteratorIndex];
                nodeIteratorIndex++;
                connectedNodesMap.set(sourceNode.dataIndex, true);
                for(var j = 0; j < sourceNode.inEdges.length; j++){
                    connectedEdgesMap.set(sourceNode.inEdges[j].dataIndex, true);
                    sourceNodesQueue.push(sourceNode.inEdges[j].node1);
                }
            }
            nodeIteratorIndex = 0;
            while(nodeIteratorIndex < targetNodesQueue.length){
                var targetNode = targetNodesQueue[nodeIteratorIndex];
                nodeIteratorIndex++;
                connectedNodesMap.set(targetNode.dataIndex, true);
                for(var j = 0; j < targetNode.outEdges.length; j++){
                    connectedEdgesMap.set(targetNode.outEdges[j].dataIndex, true);
                    targetNodesQueue.push(targetNode.outEdges[j].node2);
                }
            }
        }
        return {
            edge: connectedEdgesMap.keys(),
            node: connectedNodesMap.keys()
        };
    };
    return GraphNode;
}();
var $7e67f74238c90217$export$87f150720cc8d165 = /** @class */ function() {
    function GraphEdge(n1, n2, dataIndex) {
        this.dataIndex = -1;
        this.node1 = n1;
        this.node2 = n2;
        this.dataIndex = dataIndex == null ? -1 : dataIndex;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    GraphEdge.prototype.getModel = function(path) {
        if (this.dataIndex < 0) return;
        var graph = this.hostGraph;
        var itemModel = graph.edgeData.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    };
    GraphEdge.prototype.getAdjacentDataIndices = function() {
        return {
            edge: [
                this.dataIndex
            ],
            node: [
                this.node1.dataIndex,
                this.node2.dataIndex
            ]
        };
    };
    GraphEdge.prototype.getTrajectoryDataIndices = function() {
        var connectedEdgesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var connectedNodesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        connectedEdgesMap.set(this.dataIndex, true);
        var sourceNodes = [
            this.node1
        ];
        var targetNodes = [
            this.node2
        ];
        var nodeIteratorIndex = 0;
        while(nodeIteratorIndex < sourceNodes.length){
            var sourceNode = sourceNodes[nodeIteratorIndex];
            nodeIteratorIndex++;
            connectedNodesMap.set(sourceNode.dataIndex, true);
            for(var j = 0; j < sourceNode.inEdges.length; j++){
                connectedEdgesMap.set(sourceNode.inEdges[j].dataIndex, true);
                sourceNodes.push(sourceNode.inEdges[j].node1);
            }
        }
        nodeIteratorIndex = 0;
        while(nodeIteratorIndex < targetNodes.length){
            var targetNode = targetNodes[nodeIteratorIndex];
            nodeIteratorIndex++;
            connectedNodesMap.set(targetNode.dataIndex, true);
            for(var j = 0; j < targetNode.outEdges.length; j++){
                connectedEdgesMap.set(targetNode.outEdges[j].dataIndex, true);
                targetNodes.push(targetNode.outEdges[j].node2);
            }
        }
        return {
            edge: connectedEdgesMap.keys(),
            node: connectedNodesMap.keys()
        };
    };
    return GraphEdge;
}();
function $7e67f74238c90217$var$createGraphDataProxyMixin(hostName, dataName) {
    return {
        /**
     * @param Default 'value'. can be 'a', 'b', 'c', 'd', 'e'.
     */ getValue: function(dimension) {
            var data = this[hostName][dataName];
            return data.getStore().get(data.getDimensionIndex(dimension || "value"), this.dataIndex);
        },
        // TODO: TYPE stricter type.
        setVisual: function(key, value) {
            this.dataIndex >= 0 && this[hostName][dataName].setItemVisual(this.dataIndex, key, value);
        },
        getVisual: function(key) {
            return this[hostName][dataName].getItemVisual(this.dataIndex, key);
        },
        setLayout: function(layout, merge) {
            this.dataIndex >= 0 && this[hostName][dataName].setItemLayout(this.dataIndex, layout, merge);
        },
        getLayout: function() {
            return this[hostName][dataName].getItemLayout(this.dataIndex);
        },
        getGraphicEl: function() {
            return this[hostName][dataName].getItemGraphicEl(this.dataIndex);
        },
        getRawIndex: function() {
            return this[hostName][dataName].getRawIndex(this.dataIndex);
        }
    };
}
$7a1bd9c2710fea0d$export$e36fc9d62a853069($7e67f74238c90217$export$32866653dfc29d0d, $7e67f74238c90217$var$createGraphDataProxyMixin("hostGraph", "data"));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($7e67f74238c90217$export$87f150720cc8d165, $7e67f74238c90217$var$createGraphDataProxyMixin("hostGraph", "edgeData"));
var $7e67f74238c90217$export$2e2bcd8739ae039 = $7e67f74238c90217$var$Graph;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Link lists and struct (graph or tree)
 */ 

var $4a8451eb7786c849$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $4a8451eb7786c849$var$linkSeriesData(opt) {
    var mainData = opt.mainData;
    var datas = opt.datas;
    if (!datas) {
        datas = {
            main: mainData
        };
        opt.datasAttr = {
            main: "data"
        };
    }
    opt.datas = opt.mainData = null;
    $4a8451eb7786c849$var$linkAll(mainData, datas, opt);
    // Porxy data original methods.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(datas, function(data) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mainData.TRANSFERABLE_METHODS, function(methodName) {
            data.wrapMethod(methodName, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($4a8451eb7786c849$var$transferInjection, opt));
        });
    });
    // Beyond transfer, additional features should be added to `cloneShallow`.
    mainData.wrapMethod("cloneShallow", (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($4a8451eb7786c849$var$cloneShallowInjection, opt));
    // Only mainData trigger change, because struct.update may trigger
    // another changable methods, which may bring about dead lock.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(mainData.CHANGABLE_METHODS, function(methodName) {
        mainData.wrapMethod(methodName, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($4a8451eb7786c849$var$changeInjection, opt));
    });
    // Make sure datas contains mainData.
    (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(datas[mainData.dataType] === mainData);
}
function $4a8451eb7786c849$var$transferInjection(opt, res) {
    if ($4a8451eb7786c849$var$isMainData(this)) {
        // Transfer datas to new main data.
        var datas = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, $4a8451eb7786c849$var$inner(this).datas);
        datas[this.dataType] = res;
        $4a8451eb7786c849$var$linkAll(res, datas, opt);
    } else // Modify the reference in main data to point newData.
    $4a8451eb7786c849$var$linkSingle(res, this.dataType, $4a8451eb7786c849$var$inner(this).mainData, opt);
    return res;
}
function $4a8451eb7786c849$var$changeInjection(opt, res) {
    opt.struct && opt.struct.update();
    return res;
}
function $4a8451eb7786c849$var$cloneShallowInjection(opt, res) {
    // cloneShallow, which brings about some fragilities, may be inappropriate
    // to be exposed as an API. So for implementation simplicity we can make
    // the restriction that cloneShallow of not-mainData should not be invoked
    // outside, but only be invoked here.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($4a8451eb7786c849$var$inner(res).datas, function(data, dataType) {
        data !== res && $4a8451eb7786c849$var$linkSingle(data.cloneShallow(), dataType, res, opt);
    });
    return res;
}
/**
 * Supplement method to List.
 *
 * @public
 * @param [dataType] If not specified, return mainData.
 */ function $4a8451eb7786c849$var$getLinkedData(dataType) {
    var mainData = $4a8451eb7786c849$var$inner(this).mainData;
    return dataType == null || mainData == null ? mainData : $4a8451eb7786c849$var$inner(mainData).datas[dataType];
}
/**
 * Get list of all linked data
 */ function $4a8451eb7786c849$var$getLinkedDataAll() {
    var mainData = $4a8451eb7786c849$var$inner(this).mainData;
    return mainData == null ? [
        {
            data: mainData
        }
    ] : (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)($4a8451eb7786c849$var$inner(mainData).datas), function(type) {
        return {
            type: type,
            data: $4a8451eb7786c849$var$inner(mainData).datas[type]
        };
    });
}
function $4a8451eb7786c849$var$isMainData(data) {
    return $4a8451eb7786c849$var$inner(data).mainData === data;
}
function $4a8451eb7786c849$var$linkAll(mainData, datas, opt) {
    $4a8451eb7786c849$var$inner(mainData).datas = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(datas, function(data, dataType) {
        $4a8451eb7786c849$var$linkSingle(data, dataType, mainData, opt);
    });
}
function $4a8451eb7786c849$var$linkSingle(data, dataType, mainData, opt) {
    $4a8451eb7786c849$var$inner(mainData).datas[dataType] = data;
    $4a8451eb7786c849$var$inner(data).mainData = mainData;
    data.dataType = dataType;
    if (opt.struct) {
        data[opt.structAttr] = opt.struct;
        opt.struct[opt.datasAttr[dataType]] = data;
    }
    // Supplement method.
    data.getLinkedData = $4a8451eb7786c849$var$getLinkedData;
    data.getLinkedDataAll = $4a8451eb7786c849$var$getLinkedDataAll;
}
var $4a8451eb7786c849$export$2e2bcd8739ae039 = $4a8451eb7786c849$var$linkSeriesData;






function $09eb5d193a1ecbce$export$2e2bcd8739ae039(nodes, edges, seriesModel, directed, beforeLink) {
    // ??? TODO
    // support dataset?
    var graph = new (0, $7e67f74238c90217$export$2e2bcd8739ae039)(directed);
    for(var i = 0; i < nodes.length; i++)graph.addNode($7a1bd9c2710fea0d$export$8a4d17b6e8486e66(// Id, name, dataIndex
    nodes[i].id, nodes[i].name, i), i);
    var linkNameList = [];
    var validEdges = [];
    var linkCount = 0;
    for(var i = 0; i < edges.length; i++){
        var link = edges[i];
        var source = link.source;
        var target = link.target;
        // addEdge may fail when source or target not exists
        if (graph.addEdge(source, target, linkCount)) {
            validEdges.push(link);
            linkNameList.push($7a1bd9c2710fea0d$export$8a4d17b6e8486e66((0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(link.id, null), source + " > " + target));
            linkCount++;
        }
    }
    var coordSys = seriesModel.get("coordinateSystem");
    var nodeData;
    if (coordSys === "cartesian2d" || coordSys === "polar") nodeData = (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(nodes, seriesModel);
    else {
        var coordSysCtor = (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).get(coordSys);
        var coordDimensions = coordSysCtor ? coordSysCtor.dimensions || [] : [];
        // FIXME: Some geo do not need `value` dimenson, whereas `calendar` needs
        // `value` dimension, but graph need `value` dimension. It's better to
        // uniform this behavior.
        if ($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(coordDimensions, "value") < 0) coordDimensions.concat([
            "value"
        ]);
        var dimensions = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(nodes, {
            coordDimensions: coordDimensions,
            encodeDefine: seriesModel.getEncode()
        }).dimensions;
        nodeData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dimensions, seriesModel);
        nodeData.initData(nodes);
    }
    var edgeData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([
        "value"
    ], seriesModel);
    edgeData.initData(validEdges, linkNameList);
    beforeLink && beforeLink(nodeData, edgeData);
    (0, $4a8451eb7786c849$export$2e2bcd8739ae039)({
        mainData: nodeData,
        struct: graph,
        structAttr: "graph",
        datas: {
            node: nodeData,
            edge: edgeData
        },
        datasAttr: {
            node: "data",
            edge: "edgeData"
        }
    });
    // Update dataIndex of nodes and edges because invalid edge may be removed
    graph.update();
    return graph;
}







var $6c5e3b756b0e9560$var$GraphSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GraphSeriesModel, _super);
    function GraphSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    GraphSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        var self = this;
        function getCategoriesData() {
            return self._categoriesData;
        }
        // Provide data for legend select
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)(getCategoriesData, getCategoriesData);
        this.fillDataTextStyle(option.edges || option.links);
        this._updateCategoriesData();
    };
    GraphSeriesModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        this.fillDataTextStyle(option.edges || option.links);
        this._updateCategoriesData();
    };
    GraphSeriesModel.prototype.mergeDefaultAndTheme = function(option) {
        _super.prototype.mergeDefaultAndTheme.apply(this, arguments);
        (0, $76d619f648247e6d$export$abdcc6a26372f94b)(option, "edgeLabel", [
            "show"
        ]);
    };
    GraphSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var edges = option.edges || option.links || [];
        var nodes = option.data || option.nodes || [];
        var self = this;
        if (nodes && edges) {
            // auto curveness
            (0, $0425a00d02ade69a$export$4f05389c1f2934b8)(this);
            var graph = (0, $09eb5d193a1ecbce$export$2e2bcd8739ae039)(nodes, edges, this, true, beforeLink);
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(graph.edges, function(edge) {
                (0, $0425a00d02ade69a$export$c47b549eed9a7311)(edge.node1, edge.node2, this, edge.dataIndex);
            }, this);
            return graph.data;
        }
        function beforeLink(nodeData, edgeData) {
            // Overwrite nodeData.getItemModel to
            nodeData.wrapMethod("getItemModel", function(model) {
                var categoriesModels = self._categoriesModels;
                var categoryIdx = model.getShallow("category");
                var categoryModel = categoriesModels[categoryIdx];
                if (categoryModel) {
                    categoryModel.parentModel = model.parentModel;
                    model.parentModel = categoryModel;
                }
                return model;
            });
            // TODO Inherit resolveParentPath by default in Model#getModel?
            var oldGetModel = (0, $6818646a97528290$export$2e2bcd8739ae039).prototype.getModel;
            function newGetModel(path, parentModel) {
                var model = oldGetModel.call(this, path, parentModel);
                model.resolveParentPath = resolveParentPath;
                return model;
            }
            edgeData.wrapMethod("getItemModel", function(model) {
                model.resolveParentPath = resolveParentPath;
                model.getModel = newGetModel;
                return model;
            });
            function resolveParentPath(pathArr) {
                if (pathArr && (pathArr[0] === "label" || pathArr[1] === "label")) {
                    var newPathArr = pathArr.slice();
                    if (pathArr[0] === "label") newPathArr[0] = "edgeLabel";
                    else if (pathArr[1] === "label") newPathArr[1] = "edgeLabel";
                    return newPathArr;
                }
                return pathArr;
            }
        }
    };
    GraphSeriesModel.prototype.getGraph = function() {
        return this.getData().graph;
    };
    GraphSeriesModel.prototype.getEdgeData = function() {
        return this.getGraph().edgeData;
    };
    GraphSeriesModel.prototype.getCategoriesData = function() {
        return this._categoriesData;
    };
    GraphSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        if (dataType === "edge") {
            var nodeData = this.getData();
            var params = this.getDataParams(dataIndex, dataType);
            var edge = nodeData.graph.getEdgeByIndex(dataIndex);
            var sourceName = nodeData.getName(edge.node1.dataIndex);
            var targetName = nodeData.getName(edge.node2.dataIndex);
            var nameArr = [];
            sourceName != null && nameArr.push(sourceName);
            targetName != null && nameArr.push(targetName);
            return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                name: nameArr.join(" > "),
                value: params.value,
                noValue: params.value == null
            });
        }
        // dataType === 'node' or empty
        var nodeMarkup = (0, $b0d4c63a14430ca1$export$3a110b9fb5c88b34)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
        return nodeMarkup;
    };
    GraphSeriesModel.prototype._updateCategoriesData = function() {
        var categories = $7a1bd9c2710fea0d$export$871de8747c9eaa88(this.option.categories || [], function(category) {
            // Data must has value
            return category.value != null ? category : $7a1bd9c2710fea0d$export$8b58be045bf06082({
                value: 0
            }, category);
        });
        var categoriesData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([
            "value"
        ], this);
        categoriesData.initData(categories);
        this._categoriesData = categoriesData;
        this._categoriesModels = categoriesData.mapArray(function(idx) {
            return categoriesData.getItemModel(idx);
        });
    };
    GraphSeriesModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    GraphSeriesModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    GraphSeriesModel.prototype.isAnimationEnabled = function() {
        return _super.prototype.isAnimationEnabled.call(this) && !(this.get("layout") === "force" && this.get([
            "force",
            "layoutAnimation"
        ]));
    };
    GraphSeriesModel.type = "series.graph";
    GraphSeriesModel.dependencies = [
        "grid",
        "polar",
        "geo",
        "singleAxis",
        "calendar"
    ];
    GraphSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "view",
        // Default option for all coordinate systems
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // polarIndex: 0,
        // geoIndex: 0,
        legendHoverLink: true,
        layout: null,
        // Configuration of circular layout
        circular: {
            rotateLabel: false
        },
        // Configuration of force directed layout
        force: {
            initLayout: null,
            // Node repulsion. Can be an array to represent range.
            repulsion: [
                0,
                50
            ],
            gravity: 0.1,
            // Initial friction
            friction: 0.6,
            // Edge length. Can be an array to represent range.
            edgeLength: 30,
            layoutAnimation: true
        },
        left: "center",
        top: "center",
        // right: null,
        // bottom: null,
        // width: '80%',
        // height: '80%',
        symbol: "circle",
        symbolSize: 10,
        edgeSymbol: [
            "none",
            "none"
        ],
        edgeSymbolSize: 10,
        edgeLabel: {
            position: "middle",
            distance: 5
        },
        draggable: false,
        roam: false,
        // Default on center of graph
        center: null,
        zoom: 1,
        // Symbol size scale ratio in roam
        nodeScaleRatio: 0.6,
        // cursor: null,
        // categories: [],
        // data: []
        // Or
        // nodes: []
        //
        // links: []
        // Or
        // edges: []
        label: {
            show: false,
            formatter: "{b}"
        },
        itemStyle: {},
        lineStyle: {
            color: "#aaa",
            width: 1,
            opacity: 0.5
        },
        emphasis: {
            scale: true,
            label: {
                show: true
            }
        },
        select: {
            itemStyle: {
                borderColor: "#212121"
            }
        }
    };
    return GraphSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $6c5e3b756b0e9560$export$2e2bcd8739ae039 = $6c5e3b756b0e9560$var$GraphSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $799fe5cfb5042219$var$getCenterCoord(view, point) {
    // Use projected coord as center because it's linear.
    return view.pointToProjected ? view.pointToProjected(point) : view.pointToData(point);
}
function $799fe5cfb5042219$export$797ecc50d262ebd8(view, payload, zoomLimit, api) {
    var previousZoom = view.getZoom();
    var center = view.getCenter();
    var zoom = payload.zoom;
    var point = view.projectedToPoint ? view.projectedToPoint(center) : view.dataToPoint(center);
    if (payload.dx != null && payload.dy != null) {
        point[0] -= payload.dx;
        point[1] -= payload.dy;
        view.setCenter($799fe5cfb5042219$var$getCenterCoord(view, point), api);
    }
    if (zoom != null) {
        if (zoomLimit) {
            var zoomMin = zoomLimit.min || 0;
            var zoomMax = zoomLimit.max || Infinity;
            zoom = Math.max(Math.min(previousZoom * zoom, zoomMax), zoomMin) / previousZoom;
        }
        // Zoom on given point(originX, originY)
        view.scaleX *= zoom;
        view.scaleY *= zoom;
        var fixX = (payload.originX - view.x) * (zoom - 1);
        var fixY = (payload.originY - view.y) * (zoom - 1);
        view.x -= fixX;
        view.y -= fixY;
        view.updateTransform();
        // Get the new center
        view.setCenter($799fe5cfb5042219$var$getCenterCoord(view, point), api);
        view.setZoom(zoom * previousZoom);
    }
    return {
        center: view.getCenter(),
        zoom: view.getZoom()
    };
}



var $b48bd73bf5d69641$var$actionInfo = {
    type: "graphRoam",
    event: "graphRoam",
    update: "none"
};
function $b48bd73bf5d69641$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $65490d05ca8b2521$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $6c5e3b756b0e9560$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $23b43ea6be789dc3$export$2e2bcd8739ae039));
    registers.registerVisual((0, $2c7d64c9b3613d6b$export$2e2bcd8739ae039));
    registers.registerVisual((0, $11ee0a103a25747c$export$2e2bcd8739ae039));
    registers.registerLayout((0, $35717df2daa24f5d$export$2e2bcd8739ae039));
    registers.registerLayout(registers.PRIORITY.VISUAL.POST_CHART_LAYOUT, (0, $3c017b875f1b19fb$export$2e2bcd8739ae039));
    registers.registerLayout((0, $cd6209901c0041df$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("graphView", {
        dimensions: (0, $4a92e7570d47c1fe$export$2e2bcd8739ae039).dimensions,
        create: (0, $8491beaca48712b9$export$2e2bcd8739ae039)
    });
    // Register legacy focus actions
    registers.registerAction({
        type: "focusNodeAdjacency",
        event: "focusNodeAdjacency",
        update: "series:focusNodeAdjacency"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    registers.registerAction({
        type: "unfocusNodeAdjacency",
        event: "unfocusNodeAdjacency",
        update: "series:unfocusNodeAdjacency"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    // Register roam action.
    registers.registerAction($b48bd73bf5d69641$var$actionInfo, function(payload, ecModel, api) {
        ecModel.eachComponent({
            mainType: "series",
            query: payload
        }, function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            var res = (0, $799fe5cfb5042219$export$797ecc50d262ebd8)(coordSys, payload, undefined, api);
            seriesModel.setCenter && seriesModel.setCenter(res.center);
            seriesModel.setZoom && seriesModel.setZoom(res.zoom);
        });
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Uint8ClampedArray */ 
var $e72df59f80933534$var$GRADIENT_LEVELS = 256;
var $e72df59f80933534$var$HeatmapLayer = /** @class */ function() {
    function HeatmapLayer() {
        this.blurSize = 30;
        this.pointSize = 20;
        this.maxOpacity = 1;
        this.minOpacity = 0;
        this._gradientPixels = {
            inRange: null,
            outOfRange: null
        };
        var canvas = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas();
        this.canvas = canvas;
    }
    /**
   * Renders Heatmap and returns the rendered canvas
   * @param data array of data, each has x, y, value
   * @param width canvas width
   * @param height canvas height
   */ HeatmapLayer.prototype.update = function(data, width, height, normalize, colorFunc, isInRange) {
        var brush = this._getBrush();
        var gradientInRange = this._getGradient(colorFunc, "inRange");
        var gradientOutOfRange = this._getGradient(colorFunc, "outOfRange");
        var r = this.pointSize + this.blurSize;
        var canvas = this.canvas;
        var ctx = canvas.getContext("2d");
        var len = data.length;
        canvas.width = width;
        canvas.height = height;
        for(var i = 0; i < len; ++i){
            var p = data[i];
            var x = p[0];
            var y = p[1];
            var value = p[2];
            // calculate alpha using value
            var alpha = normalize(value);
            // draw with the circle brush with alpha
            ctx.globalAlpha = alpha;
            ctx.drawImage(brush, x - r, y - r);
        }
        if (!canvas.width || !canvas.height) // Avoid "Uncaught DOMException: Failed to execute 'getImageData' on
        // 'CanvasRenderingContext2D': The source height is 0."
        return canvas;
        // colorize the canvas using alpha value and set with gradient
        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var pixels = imageData.data;
        var offset = 0;
        var pixelLen = pixels.length;
        var minOpacity = this.minOpacity;
        var maxOpacity = this.maxOpacity;
        var diffOpacity = maxOpacity - minOpacity;
        while(offset < pixelLen){
            var alpha = pixels[offset + 3] / 256;
            var gradientOffset = Math.floor(alpha * ($e72df59f80933534$var$GRADIENT_LEVELS - 1)) * 4;
            // Simple optimize to ignore the empty data
            if (alpha > 0) {
                var gradient = isInRange(alpha) ? gradientInRange : gradientOutOfRange;
                // Any alpha > 0 will be mapped to [minOpacity, maxOpacity]
                alpha > 0 && (alpha = alpha * diffOpacity + minOpacity);
                pixels[offset++] = gradient[gradientOffset];
                pixels[offset++] = gradient[gradientOffset + 1];
                pixels[offset++] = gradient[gradientOffset + 2];
                pixels[offset++] = gradient[gradientOffset + 3] * alpha * 256;
            } else offset += 4;
        }
        ctx.putImageData(imageData, 0, 0);
        return canvas;
    };
    /**
   * get canvas of a black circle brush used for canvas to draw later
   */ HeatmapLayer.prototype._getBrush = function() {
        var brushCanvas = this._brushCanvas || (this._brushCanvas = (0, $c6341dcc9d86826e$export$ef5e599365494451).createCanvas());
        // set brush size
        var r = this.pointSize + this.blurSize;
        var d = r * 2;
        brushCanvas.width = d;
        brushCanvas.height = d;
        var ctx = brushCanvas.getContext("2d");
        ctx.clearRect(0, 0, d, d);
        // in order to render shadow without the distinct circle,
        // draw the distinct circle in an invisible place,
        // and use shadowOffset to draw shadow in the center of the canvas
        ctx.shadowOffsetX = d;
        ctx.shadowBlur = this.blurSize;
        // draw the shadow in black, and use alpha and shadow blur to generate
        // color in color map
        ctx.shadowColor = "#000";
        // draw circle in the left to the canvas
        ctx.beginPath();
        ctx.arc(-r, r, this.pointSize, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        return brushCanvas;
    };
    /**
   * get gradient color map
   * @private
   */ HeatmapLayer.prototype._getGradient = function(colorFunc, state) {
        var gradientPixels = this._gradientPixels;
        var pixelsSingleState = gradientPixels[state] || (gradientPixels[state] = new Uint8ClampedArray(1024));
        var color = [
            0,
            0,
            0,
            0
        ];
        var off = 0;
        for(var i = 0; i < 256; i++){
            colorFunc[state](i / 255, true, color);
            pixelsSingleState[off++] = color[0];
            pixelsSingleState[off++] = color[1];
            pixelsSingleState[off++] = color[2];
            pixelsSingleState[off++] = color[3];
        }
        return pixelsSingleState;
    };
    return HeatmapLayer;
}();
var $e72df59f80933534$export$2e2bcd8739ae039 = $e72df59f80933534$var$HeatmapLayer;






function $62f45dd0b06f949c$var$getIsInPiecewiseRange(dataExtent, pieceList, selected) {
    var dataSpan = dataExtent[1] - dataExtent[0];
    pieceList = $7a1bd9c2710fea0d$export$871de8747c9eaa88(pieceList, function(piece) {
        return {
            interval: [
                (piece.interval[0] - dataExtent[0]) / dataSpan,
                (piece.interval[1] - dataExtent[0]) / dataSpan
            ]
        };
    });
    var len = pieceList.length;
    var lastIndex = 0;
    return function(val) {
        var i;
        // Try to find in the location of the last found
        for(i = lastIndex; i < len; i++){
            var interval = pieceList[i].interval;
            if (interval[0] <= val && val <= interval[1]) {
                lastIndex = i;
                break;
            }
        }
        if (i === len) // Not found, back interation
        for(i = lastIndex - 1; i >= 0; i--){
            var interval = pieceList[i].interval;
            if (interval[0] <= val && val <= interval[1]) {
                lastIndex = i;
                break;
            }
        }
        return i >= 0 && i < len && selected[i];
    };
}
function $62f45dd0b06f949c$var$getIsInContinuousRange(dataExtent, range) {
    var dataSpan = dataExtent[1] - dataExtent[0];
    range = [
        (range[0] - dataExtent[0]) / dataSpan,
        (range[1] - dataExtent[0]) / dataSpan
    ];
    return function(val) {
        return val >= range[0] && val <= range[1];
    };
}
function $62f45dd0b06f949c$var$isGeoCoordSys(coordSys) {
    var dimensions = coordSys.dimensions;
    // Not use coordSys.type === 'geo' because coordSys maybe extended
    return dimensions[0] === "lng" && dimensions[1] === "lat";
}
var $62f45dd0b06f949c$var$HeatmapView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(HeatmapView, _super);
    function HeatmapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = HeatmapView.type;
        return _this;
    }
    HeatmapView.prototype.render = function(seriesModel, ecModel, api) {
        var visualMapOfThisSeries;
        ecModel.eachComponent("visualMap", function(visualMap) {
            visualMap.eachTargetSeries(function(targetSeries) {
                if (targetSeries === seriesModel) visualMapOfThisSeries = visualMap;
            });
        });
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        this.group.removeAll();
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys.type === "cartesian2d" || coordSys.type === "calendar") this._renderOnCartesianAndCalendar(seriesModel, api, 0, seriesModel.getData().count());
        else if ($62f45dd0b06f949c$var$isGeoCoordSys(coordSys)) this._renderOnGeo(coordSys, seriesModel, visualMapOfThisSeries, api);
    };
    HeatmapView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        this.group.removeAll();
    };
    HeatmapView.prototype.incrementalRender = function(params, seriesModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys) {
            // geo does not support incremental rendering?
            if ($62f45dd0b06f949c$var$isGeoCoordSys(coordSys)) this.render(seriesModel, ecModel, api);
            else {
                this._progressiveEls = [];
                this._renderOnCartesianAndCalendar(seriesModel, api, params.start, params.end, true);
            }
        }
    };
    HeatmapView.prototype.eachRendered = function(cb) {
        $5b455ae6f843ac47$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    HeatmapView.prototype._renderOnCartesianAndCalendar = function(seriesModel, api, start, end, incremental) {
        var coordSys = seriesModel.coordinateSystem;
        var isCartesian2d = (0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, "cartesian2d");
        var width;
        var height;
        var xAxisExtent;
        var yAxisExtent;
        if (isCartesian2d) {
            var xAxis = coordSys.getAxis("x");
            var yAxis = coordSys.getAxis("y");
            // add 0.5px to avoid the gaps
            width = xAxis.getBandWidth() + .5;
            height = yAxis.getBandWidth() + .5;
            xAxisExtent = xAxis.scale.getExtent();
            yAxisExtent = yAxis.scale.getExtent();
        }
        var group = this.group;
        var data = seriesModel.getData();
        var emphasisStyle = seriesModel.getModel([
            "emphasis",
            "itemStyle"
        ]).getItemStyle();
        var blurStyle = seriesModel.getModel([
            "blur",
            "itemStyle"
        ]).getItemStyle();
        var selectStyle = seriesModel.getModel([
            "select",
            "itemStyle"
        ]).getItemStyle();
        var borderRadius = seriesModel.get([
            "itemStyle",
            "borderRadius"
        ]);
        var labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(seriesModel);
        var emphasisModel = seriesModel.getModel("emphasis");
        var focus = emphasisModel.get("focus");
        var blurScope = emphasisModel.get("blurScope");
        var emphasisDisabled = emphasisModel.get("disabled");
        var dataDims = isCartesian2d ? [
            data.mapDimension("x"),
            data.mapDimension("y"),
            data.mapDimension("value")
        ] : [
            data.mapDimension("time"),
            data.mapDimension("value")
        ];
        for(var idx = start; idx < end; idx++){
            var rect = void 0;
            var style = data.getItemVisual(idx, "style");
            if (isCartesian2d) {
                var dataDimX = data.get(dataDims[0], idx);
                var dataDimY = data.get(dataDims[1], idx);
                // Ignore empty data and out of extent data
                if (isNaN(data.get(dataDims[2], idx)) || isNaN(dataDimX) || isNaN(dataDimY) || dataDimX < xAxisExtent[0] || dataDimX > xAxisExtent[1] || dataDimY < yAxisExtent[0] || dataDimY > yAxisExtent[1]) continue;
                var point = coordSys.dataToPoint([
                    dataDimX,
                    dataDimY
                ]);
                rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                    shape: {
                        x: point[0] - width / 2,
                        y: point[1] - height / 2,
                        width: width,
                        height: height
                    },
                    style: style
                });
            } else {
                // Ignore empty data
                if (isNaN(data.get(dataDims[1], idx))) continue;
                rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                    z2: 1,
                    shape: coordSys.dataToRect([
                        data.get(dataDims[0], idx)
                    ]).contentShape,
                    style: style
                });
            }
            // Optimization for large dataset
            if (data.hasItemOption) {
                var itemModel = data.getItemModel(idx);
                var emphasisModel_1 = itemModel.getModel("emphasis");
                emphasisStyle = emphasisModel_1.getModel("itemStyle").getItemStyle();
                blurStyle = itemModel.getModel([
                    "blur",
                    "itemStyle"
                ]).getItemStyle();
                selectStyle = itemModel.getModel([
                    "select",
                    "itemStyle"
                ]).getItemStyle();
                // Each item value struct in the data would be firstly
                // {
                //     itemStyle: { borderRadius: [30, 30] },
                //     value: [2022, 02, 22]
                // }
                borderRadius = itemModel.get([
                    "itemStyle",
                    "borderRadius"
                ]);
                focus = emphasisModel_1.get("focus");
                blurScope = emphasisModel_1.get("blurScope");
                emphasisDisabled = emphasisModel_1.get("disabled");
                labelStatesModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel);
            }
            rect.shape.r = borderRadius;
            var rawValue = seriesModel.getRawValue(idx);
            var defaultText = "-";
            if (rawValue && rawValue[2] != null) defaultText = rawValue[2] + "";
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(rect, labelStatesModels, {
                labelFetcher: seriesModel,
                labelDataIndex: idx,
                defaultOpacity: style.opacity,
                defaultText: defaultText
            });
            rect.ensureState("emphasis").style = emphasisStyle;
            rect.ensureState("blur").style = blurStyle;
            rect.ensureState("select").style = selectStyle;
            (0, $2bf82c0980125b62$export$e51187539ff11209)(rect, focus, blurScope, emphasisDisabled);
            rect.incremental = incremental;
            // PENDING
            if (incremental) // Rect must use hover layer if it's incremental.
            rect.states.emphasis.hoverLayer = true;
            group.add(rect);
            data.setItemGraphicEl(idx, rect);
            if (this._progressiveEls) this._progressiveEls.push(rect);
        }
    };
    HeatmapView.prototype._renderOnGeo = function(geo, seriesModel, visualMapModel, api) {
        var inRangeVisuals = visualMapModel.targetVisuals.inRange;
        var outOfRangeVisuals = visualMapModel.targetVisuals.outOfRange;
        // if (!visualMapping) {
        //     throw new Error('Data range must have color visuals');
        // }
        var data = seriesModel.getData();
        var hmLayer = this._hmLayer || this._hmLayer || new (0, $e72df59f80933534$export$2e2bcd8739ae039)();
        hmLayer.blurSize = seriesModel.get("blurSize");
        hmLayer.pointSize = seriesModel.get("pointSize");
        hmLayer.minOpacity = seriesModel.get("minOpacity");
        hmLayer.maxOpacity = seriesModel.get("maxOpacity");
        var rect = geo.getViewRect().clone();
        var roamTransform = geo.getRoamTransform();
        rect.applyTransform(roamTransform);
        // Clamp on viewport
        var x = Math.max(rect.x, 0);
        var y = Math.max(rect.y, 0);
        var x2 = Math.min(rect.width + rect.x, api.getWidth());
        var y2 = Math.min(rect.height + rect.y, api.getHeight());
        var width = x2 - x;
        var height = y2 - y;
        var dims = [
            data.mapDimension("lng"),
            data.mapDimension("lat"),
            data.mapDimension("value")
        ];
        var points = data.mapArray(dims, function(lng, lat, value) {
            var pt = geo.dataToPoint([
                lng,
                lat
            ]);
            pt[0] -= x;
            pt[1] -= y;
            pt.push(value);
            return pt;
        });
        var dataExtent = visualMapModel.getExtent();
        var isInRange = visualMapModel.type === "visualMap.continuous" ? $62f45dd0b06f949c$var$getIsInContinuousRange(dataExtent, visualMapModel.option.range) : $62f45dd0b06f949c$var$getIsInPiecewiseRange(dataExtent, visualMapModel.getPieceList(), visualMapModel.option.selected);
        hmLayer.update(points, width, height, inRangeVisuals.color.getNormalizer(), {
            inRange: inRangeVisuals.color.getColorMapper(),
            outOfRange: outOfRangeVisuals.color.getColorMapper()
        }, isInRange);
        var img = new $86adec94217b86c6$export$2e2bcd8739ae039({
            style: {
                width: width,
                height: height,
                x: x,
                y: y,
                image: hmLayer.canvas
            },
            silent: true
        });
        this.group.add(img);
    };
    HeatmapView.type = "heatmap";
    return HeatmapView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $62f45dd0b06f949c$export$2e2bcd8739ae039 = $62f45dd0b06f949c$var$HeatmapView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $4b84759fb7a8174c$var$HeatmapSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(HeatmapSeriesModel, _super);
    function HeatmapSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = HeatmapSeriesModel.type;
        return _this;
    }
    HeatmapSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            generateCoord: "value"
        });
    };
    HeatmapSeriesModel.prototype.preventIncremental = function() {
        var coordSysCreator = (0, $70c3ede7d3b64757$export$2e2bcd8739ae039).get(this.get("coordinateSystem"));
        if (coordSysCreator && coordSysCreator.dimensions) return coordSysCreator.dimensions[0] === "lng" && coordSysCreator.dimensions[1] === "lat";
    };
    HeatmapSeriesModel.type = "series.heatmap";
    HeatmapSeriesModel.dependencies = [
        "grid",
        "geo",
        "calendar"
    ];
    HeatmapSeriesModel.defaultOption = {
        coordinateSystem: "cartesian2d",
        // zlevel: 0,
        z: 2,
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // Geo coordinate system
        geoIndex: 0,
        blurSize: 30,
        pointSize: 20,
        maxOpacity: 1,
        minOpacity: 0,
        select: {
            itemStyle: {
                borderColor: "#212121"
            }
        }
    };
    return HeatmapSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $4b84759fb7a8174c$export$2e2bcd8739ae039 = $4b84759fb7a8174c$var$HeatmapSeriesModel;


function $c53e84d38e53ec61$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $62f45dd0b06f949c$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $4b84759fb7a8174c$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $04f9db15b0fa1cf8$var$LineSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LineSeriesModel, _super);
    function LineSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LineSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    LineSeriesModel.prototype.getInitialData = function(option) {
        var coordSys;
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    LineSeriesModel.prototype.getLegendIcon = function(opt) {
        var group = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        var line = (0, $5370466dadc978d7$export$af050e04da3a02e8)("line", 0, opt.itemHeight / 2, opt.itemWidth, 0, opt.lineStyle.stroke, false);
        group.add(line);
        line.setStyle(opt.lineStyle);
        var visualType = this.getData().getVisual("symbol");
        var visualRotate = this.getData().getVisual("symbolRotate");
        var symbolType = visualType === "none" ? "circle" : visualType;
        // Symbol size is 80% when there is a line
        var size = opt.itemHeight * 0.8;
        var symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, (opt.itemWidth - size) / 2, (opt.itemHeight - size) / 2, size, size, opt.itemStyle.fill);
        group.add(symbol);
        symbol.setStyle(opt.itemStyle);
        var symbolRotate = opt.iconRotate === "inherit" ? visualRotate : opt.iconRotate || 0;
        symbol.rotation = symbolRotate * Math.PI / 180;
        symbol.setOrigin([
            opt.itemWidth / 2,
            opt.itemHeight / 2
        ]);
        if (symbolType.indexOf("empty") > -1) {
            symbol.style.stroke = symbol.style.fill;
            symbol.style.fill = "#fff";
            symbol.style.lineWidth = 2;
        }
        return group;
    };
    LineSeriesModel.type = "series.line";
    LineSeriesModel.dependencies = [
        "grid",
        "polar"
    ];
    LineSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 3,
        coordinateSystem: "cartesian2d",
        legendHoverLink: true,
        clip: true,
        label: {
            position: "top"
        },
        // itemStyle: {
        // },
        endLabel: {
            show: false,
            valueAnimation: true,
            distance: 8
        },
        lineStyle: {
            width: 2,
            type: "solid"
        },
        emphasis: {
            scale: true
        },
        // areaStyle: {
        // origin of areaStyle. Valid values:
        // `'auto'/null/undefined`: from axisLine to data
        // `'start'`: from min to data
        // `'end'`: from data to max
        // origin: 'auto'
        // },
        // false, 'start', 'end', 'middle'
        step: false,
        // Disabled if step is true
        smooth: false,
        smoothMonotone: null,
        symbol: "emptyCircle",
        symbolSize: 4,
        symbolRotate: null,
        showSymbol: true,
        // `false`: follow the label interval strategy.
        // `true`: show all symbols.
        // `'auto'`: If possible, show all symbols, otherwise
        //           follow the label interval strategy.
        showAllSymbol: "auto",
        // Whether to connect break point.
        connectNulls: false,
        // Sampling for large data. Can be: 'average', 'max', 'min', 'sum', 'lttb'.
        sampling: "none",
        animationEasing: "linear",
        // Disable progressive
        progressive: 0,
        hoverLayerThreshold: Infinity,
        universalTransition: {
            divideShape: "clone"
        },
        triggerLineEvent: false
    };
    return LineSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $04f9db15b0fa1cf8$export$2e2bcd8739ae039 = $04f9db15b0fa1cf8$var$LineSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $af63fd8cd32fb271$export$b488a529581b37e(coordSys, data, valueOrigin) {
    var baseAxis = coordSys.getBaseAxis();
    var valueAxis = coordSys.getOtherAxis(baseAxis);
    var valueStart = $af63fd8cd32fb271$var$getValueStart(valueAxis, valueOrigin);
    var baseAxisDim = baseAxis.dim;
    var valueAxisDim = valueAxis.dim;
    var valueDim = data.mapDimension(valueAxisDim);
    var baseDim = data.mapDimension(baseAxisDim);
    var baseDataOffset = valueAxisDim === "x" || valueAxisDim === "radius" ? 1 : 0;
    var dims = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys.dimensions, function(coordDim) {
        return data.mapDimension(coordDim);
    });
    var stacked = false;
    var stackResultDim = data.getCalculationInfo("stackResultDimension");
    if ((0, $efdd976e4917927c$export$1dedc39359ae35c)(data, dims[0])) {
        // jshint ignore:line
        stacked = true;
        dims[0] = stackResultDim;
    }
    if ((0, $efdd976e4917927c$export$1dedc39359ae35c)(data, dims[1])) {
        // jshint ignore:line
        stacked = true;
        dims[1] = stackResultDim;
    }
    return {
        dataDimsForPoint: dims,
        valueStart: valueStart,
        valueAxisDim: valueAxisDim,
        baseAxisDim: baseAxisDim,
        stacked: !!stacked,
        valueDim: valueDim,
        baseDim: baseDim,
        baseDataOffset: baseDataOffset,
        stackedOverDimension: data.getCalculationInfo("stackedOverDimension")
    };
}
function $af63fd8cd32fb271$var$getValueStart(valueAxis, valueOrigin) {
    var valueStart = 0;
    var extent = valueAxis.scale.getExtent();
    if (valueOrigin === "start") valueStart = extent[0];
    else if (valueOrigin === "end") valueStart = extent[1];
    else if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(valueOrigin) && !isNaN(valueOrigin)) valueStart = valueOrigin;
    else {
        // Both positive
        if (extent[0] > 0) valueStart = extent[0];
        else if (extent[1] < 0) valueStart = extent[1];
    // If is one positive, and one negative, onZero shall be true
    }
    return valueStart;
}
function $af63fd8cd32fb271$export$c1601aa630e7b5f8(dataCoordInfo, coordSys, data, idx) {
    var value = NaN;
    if (dataCoordInfo.stacked) value = data.get(data.getCalculationInfo("stackedOverDimension"), idx);
    if (isNaN(value)) value = dataCoordInfo.valueStart;
    var baseDataOffset = dataCoordInfo.baseDataOffset;
    var stackedData = [];
    stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
    stackedData[1 - baseDataOffset] = value;
    return coordSys.dataToPoint(stackedData);
}



function $b022c65e2d67ded9$var$diffData(oldData, newData) {
    var diffResult = [];
    newData.diff(oldData).add(function(idx) {
        diffResult.push({
            cmd: "+",
            idx: idx
        });
    }).update(function(newIdx, oldIdx) {
        diffResult.push({
            cmd: "=",
            idx: oldIdx,
            idx1: newIdx
        });
    }).remove(function(idx) {
        diffResult.push({
            cmd: "-",
            idx: idx
        });
    }).execute();
    return diffResult;
}
function $b022c65e2d67ded9$export$2e2bcd8739ae039(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
    var diff = $b022c65e2d67ded9$var$diffData(oldData, newData);
    // let newIdList = newData.mapArray(newData.getId);
    // let oldIdList = oldData.mapArray(oldData.getId);
    // convertToIntId(newIdList, oldIdList);
    // // FIXME One data ?
    // diff = arrayDiff(oldIdList, newIdList);
    var currPoints = [];
    var nextPoints = [];
    // Points for stacking base line
    var currStackedPoints = [];
    var nextStackedPoints = [];
    var status = [];
    var sortedIndices = [];
    var rawIndices = [];
    var newDataOldCoordInfo = (0, $af63fd8cd32fb271$export$b488a529581b37e)(oldCoordSys, newData, oldValueOrigin);
    // const oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);
    var oldPoints = oldData.getLayout("points") || [];
    var newPoints = newData.getLayout("points") || [];
    for(var i = 0; i < diff.length; i++){
        var diffItem = diff[i];
        var pointAdded = true;
        var oldIdx2 = void 0;
        var newIdx2 = void 0;
        // FIXME, animation is not so perfect when dataZoom window moves fast
        // Which is in case remvoing or add more than one data in the tail or head
        switch(diffItem.cmd){
            case "=":
                oldIdx2 = diffItem.idx * 2;
                newIdx2 = diffItem.idx1 * 2;
                var currentX = oldPoints[oldIdx2];
                var currentY = oldPoints[oldIdx2 + 1];
                var nextX = newPoints[newIdx2];
                var nextY = newPoints[newIdx2 + 1];
                // If previous data is NaN, use next point directly
                if (isNaN(currentX) || isNaN(currentY)) {
                    currentX = nextX;
                    currentY = nextY;
                }
                currPoints.push(currentX, currentY);
                nextPoints.push(nextX, nextY);
                currStackedPoints.push(oldStackedOnPoints[oldIdx2], oldStackedOnPoints[oldIdx2 + 1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(diffItem.idx1));
                break;
            case "+":
                var newIdx = diffItem.idx;
                var newDataDimsForPoint = newDataOldCoordInfo.dataDimsForPoint;
                var oldPt = oldCoordSys.dataToPoint([
                    newData.get(newDataDimsForPoint[0], newIdx),
                    newData.get(newDataDimsForPoint[1], newIdx)
                ]);
                newIdx2 = newIdx * 2;
                currPoints.push(oldPt[0], oldPt[1]);
                nextPoints.push(newPoints[newIdx2], newPoints[newIdx2 + 1]);
                var stackedOnPoint = (0, $af63fd8cd32fb271$export$c1601aa630e7b5f8)(newDataOldCoordInfo, oldCoordSys, newData, newIdx);
                currStackedPoints.push(stackedOnPoint[0], stackedOnPoint[1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(newIdx));
                break;
            case "-":
                pointAdded = false;
        }
        // Original indices
        if (pointAdded) {
            status.push(diffItem);
            sortedIndices.push(sortedIndices.length);
        }
    }
    // Diff result may be crossed if all items are changed
    // Sort by data index
    sortedIndices.sort(function(a, b) {
        return rawIndices[a] - rawIndices[b];
    });
    var len = currPoints.length;
    var sortedCurrPoints = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len);
    var sortedNextPoints = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len);
    var sortedCurrStackedPoints = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len);
    var sortedNextStackedPoints = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len);
    var sortedStatus = [];
    for(var i = 0; i < sortedIndices.length; i++){
        var idx = sortedIndices[i];
        var i2 = i * 2;
        var idx2 = idx * 2;
        sortedCurrPoints[i2] = currPoints[idx2];
        sortedCurrPoints[i2 + 1] = currPoints[idx2 + 1];
        sortedNextPoints[i2] = nextPoints[idx2];
        sortedNextPoints[i2 + 1] = nextPoints[idx2 + 1];
        sortedCurrStackedPoints[i2] = currStackedPoints[idx2];
        sortedCurrStackedPoints[i2 + 1] = currStackedPoints[idx2 + 1];
        sortedNextStackedPoints[i2] = nextStackedPoints[idx2];
        sortedNextStackedPoints[i2 + 1] = nextStackedPoints[idx2 + 1];
        sortedStatus[i] = status[idx];
    }
    return {
        current: sortedCurrPoints,
        next: sortedNextPoints,
        stackedOnCurrent: sortedCurrStackedPoints,
        stackedOnNext: sortedNextStackedPoints,
        status: sortedStatus
    };
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $5c417e1ed90142c5$var$mathMin = Math.min;
var $5c417e1ed90142c5$var$mathMax = Math.max;
function $5c417e1ed90142c5$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
/**
 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
 * situations. This should be used when points are non-monotone neither in x or
 * y dimension.
 */ function $5c417e1ed90142c5$var$drawSegment(ctx, points, start, segLen, allLen, dir, smooth, smoothMonotone, connectNulls) {
    var prevX;
    var prevY;
    var cpx0;
    var cpy0;
    var cpx1;
    var cpy1;
    var idx = start;
    var k = 0;
    for(; k < segLen; k++){
        var x = points[idx * 2];
        var y = points[idx * 2 + 1];
        if (idx >= allLen || idx < 0) break;
        if ($5c417e1ed90142c5$var$isPointNull(x, y)) {
            if (connectNulls) {
                idx += dir;
                continue;
            }
            break;
        }
        if (idx === start) {
            ctx[dir > 0 ? "moveTo" : "lineTo"](x, y);
            cpx0 = x;
            cpy0 = y;
        } else {
            var dx = x - prevX;
            var dy = y - prevY;
            // Ignore tiny segment.
            if (dx * dx + dy * dy < 0.5) {
                idx += dir;
                continue;
            }
            if (smooth > 0) {
                var nextIdx = idx + dir;
                var nextX = points[nextIdx * 2];
                var nextY = points[nextIdx * 2 + 1];
                // Ignore duplicate point
                while(nextX === x && nextY === y && k < segLen){
                    k++;
                    nextIdx += dir;
                    idx += dir;
                    nextX = points[nextIdx * 2];
                    nextY = points[nextIdx * 2 + 1];
                    x = points[idx * 2];
                    y = points[idx * 2 + 1];
                    dx = x - prevX;
                    dy = y - prevY;
                }
                var tmpK = k + 1;
                if (connectNulls) // Find next point not null
                while($5c417e1ed90142c5$var$isPointNull(nextX, nextY) && tmpK < segLen){
                    tmpK++;
                    nextIdx += dir;
                    nextX = points[nextIdx * 2];
                    nextY = points[nextIdx * 2 + 1];
                }
                var ratioNextSeg = 0.5;
                var vx = 0;
                var vy = 0;
                var nextCpx0 = void 0;
                var nextCpy0 = void 0;
                // Is last point
                if (tmpK >= segLen || $5c417e1ed90142c5$var$isPointNull(nextX, nextY)) {
                    cpx1 = x;
                    cpy1 = y;
                } else {
                    vx = nextX - prevX;
                    vy = nextY - prevY;
                    var dx0 = x - prevX;
                    var dx1 = nextX - x;
                    var dy0 = y - prevY;
                    var dy1 = nextY - y;
                    var lenPrevSeg = void 0;
                    var lenNextSeg = void 0;
                    if (smoothMonotone === "x") {
                        lenPrevSeg = Math.abs(dx0);
                        lenNextSeg = Math.abs(dx1);
                        var dir_1 = vx > 0 ? 1 : -1;
                        cpx1 = x - dir_1 * lenPrevSeg * smooth;
                        cpy1 = y;
                        nextCpx0 = x + dir_1 * lenNextSeg * smooth;
                        nextCpy0 = y;
                    } else if (smoothMonotone === "y") {
                        lenPrevSeg = Math.abs(dy0);
                        lenNextSeg = Math.abs(dy1);
                        var dir_2 = vy > 0 ? 1 : -1;
                        cpx1 = x;
                        cpy1 = y - dir_2 * lenPrevSeg * smooth;
                        nextCpx0 = x;
                        nextCpy0 = y + dir_2 * lenNextSeg * smooth;
                    } else {
                        lenPrevSeg = Math.sqrt(dx0 * dx0 + dy0 * dy0);
                        lenNextSeg = Math.sqrt(dx1 * dx1 + dy1 * dy1);
                        // Use ratio of seg length
                        ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
                        cpx1 = x - vx * smooth * (1 - ratioNextSeg);
                        cpy1 = y - vy * smooth * (1 - ratioNextSeg);
                        // cp0 of next segment
                        nextCpx0 = x + vx * smooth * ratioNextSeg;
                        nextCpy0 = y + vy * smooth * ratioNextSeg;
                        // Smooth constraint between point and next point.
                        // Avoid exceeding extreme after smoothing.
                        nextCpx0 = $5c417e1ed90142c5$var$mathMin(nextCpx0, $5c417e1ed90142c5$var$mathMax(nextX, x));
                        nextCpy0 = $5c417e1ed90142c5$var$mathMin(nextCpy0, $5c417e1ed90142c5$var$mathMax(nextY, y));
                        nextCpx0 = $5c417e1ed90142c5$var$mathMax(nextCpx0, $5c417e1ed90142c5$var$mathMin(nextX, x));
                        nextCpy0 = $5c417e1ed90142c5$var$mathMax(nextCpy0, $5c417e1ed90142c5$var$mathMin(nextY, y));
                        // Reclaculate cp1 based on the adjusted cp0 of next seg.
                        vx = nextCpx0 - x;
                        vy = nextCpy0 - y;
                        cpx1 = x - vx * lenPrevSeg / lenNextSeg;
                        cpy1 = y - vy * lenPrevSeg / lenNextSeg;
                        // Smooth constraint between point and prev point.
                        // Avoid exceeding extreme after smoothing.
                        cpx1 = $5c417e1ed90142c5$var$mathMin(cpx1, $5c417e1ed90142c5$var$mathMax(prevX, x));
                        cpy1 = $5c417e1ed90142c5$var$mathMin(cpy1, $5c417e1ed90142c5$var$mathMax(prevY, y));
                        cpx1 = $5c417e1ed90142c5$var$mathMax(cpx1, $5c417e1ed90142c5$var$mathMin(prevX, x));
                        cpy1 = $5c417e1ed90142c5$var$mathMax(cpy1, $5c417e1ed90142c5$var$mathMin(prevY, y));
                        // Adjust next cp0 again.
                        vx = x - cpx1;
                        vy = y - cpy1;
                        nextCpx0 = x + vx * lenNextSeg / lenPrevSeg;
                        nextCpy0 = y + vy * lenNextSeg / lenPrevSeg;
                    }
                }
                ctx.bezierCurveTo(cpx0, cpy0, cpx1, cpy1, x, y);
                cpx0 = nextCpx0;
                cpy0 = nextCpy0;
            } else ctx.lineTo(x, y);
        }
        prevX = x;
        prevY = y;
        idx += dir;
    }
    return k;
}
var $5c417e1ed90142c5$var$ECPolylineShape = /** @class */ function() {
    function ECPolylineShape() {
        this.smooth = 0;
        this.smoothConstraint = true;
    }
    return ECPolylineShape;
}();
var $5c417e1ed90142c5$export$bf7c0585b8f7d00f = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ECPolyline, _super);
    function ECPolyline(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "ec-polyline";
        return _this;
    }
    ECPolyline.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    ECPolyline.prototype.getDefaultShape = function() {
        return new $5c417e1ed90142c5$var$ECPolylineShape();
    };
    ECPolyline.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var i = 0;
        var len = points.length / 2;
        // const result = getBoundingBox(points, shape.smoothConstraint);
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$5c417e1ed90142c5$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$5c417e1ed90142c5$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len)i += $5c417e1ed90142c5$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
    };
    ECPolyline.prototype.getPointOn = function(xOrY, dim) {
        if (!this.path) {
            this.createPathProxy();
            this.buildPath(this.path, this.shape);
        }
        var path = this.path;
        var data = path.data;
        var CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
        var x0;
        var y0;
        var isDimX = dim === "x";
        var roots = [];
        for(var i = 0; i < data.length;){
            var cmd = data[i++];
            var x = void 0;
            var y = void 0;
            var x2 = void 0;
            var y2 = void 0;
            var x3 = void 0;
            var y3 = void 0;
            var t = void 0;
            switch(cmd){
                case CMD.M:
                    x0 = data[i++];
                    y0 = data[i++];
                    break;
                case CMD.L:
                    x = data[i++];
                    y = data[i++];
                    t = isDimX ? (xOrY - x0) / (x - x0) : (xOrY - y0) / (y - y0);
                    if (t <= 1 && t >= 0) {
                        var val = isDimX ? (y - y0) * t + y0 : (x - x0) * t + x0;
                        return isDimX ? [
                            xOrY,
                            val
                        ] : [
                            val,
                            xOrY
                        ];
                    }
                    x0 = x;
                    y0 = y;
                    break;
                case CMD.C:
                    x = data[i++];
                    y = data[i++];
                    x2 = data[i++];
                    y2 = data[i++];
                    x3 = data[i++];
                    y3 = data[i++];
                    var nRoot = isDimX ? (0, $747cfc5611b57cea$export$ca5d13faa10b167e)(x0, x, x2, x3, xOrY, roots) : (0, $747cfc5611b57cea$export$ca5d13faa10b167e)(y0, y, y2, y3, xOrY, roots);
                    if (nRoot > 0) for(var i_1 = 0; i_1 < nRoot; i_1++){
                        var t_1 = roots[i_1];
                        if (t_1 <= 1 && t_1 >= 0) {
                            var val = isDimX ? (0, $747cfc5611b57cea$export$547c21de482bbcb2)(y0, y, y2, y3, t_1) : (0, $747cfc5611b57cea$export$547c21de482bbcb2)(x0, x, x2, x3, t_1);
                            return isDimX ? [
                                xOrY,
                                val
                            ] : [
                                val,
                                xOrY
                            ];
                        }
                    }
                    x0 = x3;
                    y0 = y3;
                    break;
            }
        }
    };
    return ECPolyline;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $5c417e1ed90142c5$var$ECPolygonShape = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ECPolygonShape, _super);
    function ECPolygonShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ECPolygonShape;
}($5c417e1ed90142c5$var$ECPolylineShape);
var $5c417e1ed90142c5$export$6042a400d113f2bd = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ECPolygon, _super);
    function ECPolygon(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = "ec-polygon";
        return _this;
    }
    ECPolygon.prototype.getDefaultShape = function() {
        return new $5c417e1ed90142c5$var$ECPolygonShape();
    };
    ECPolygon.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var stackedOnPoints = shape.stackedOnPoints;
        var i = 0;
        var len = points.length / 2;
        var smoothMonotone = shape.smoothMonotone;
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$5c417e1ed90142c5$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$5c417e1ed90142c5$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len){
            var k = $5c417e1ed90142c5$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, smoothMonotone, shape.connectNulls);
            $5c417e1ed90142c5$var$drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
            i += k + 1;
            ctx.closePath();
        }
    };
    return ECPolygon;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));













function $ada57dad04d4bbf5$var$isPointsSame(points1, points2) {
    if (points1.length !== points2.length) return;
    for(var i = 0; i < points1.length; i++){
        if (points1[i] !== points2[i]) return;
    }
    return true;
}
function $ada57dad04d4bbf5$var$bboxFromPoints(points) {
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    for(var i = 0; i < points.length;){
        var x = points[i++];
        var y = points[i++];
        if (!isNaN(x)) {
            minX = Math.min(x, minX);
            maxX = Math.max(x, maxX);
        }
        if (!isNaN(y)) {
            minY = Math.min(y, minY);
            maxY = Math.max(y, maxY);
        }
    }
    return [
        [
            minX,
            minY
        ],
        [
            maxX,
            maxY
        ]
    ];
}
function $ada57dad04d4bbf5$var$getBoundingDiff(points1, points2) {
    var _a = $ada57dad04d4bbf5$var$bboxFromPoints(points1), min1 = _a[0], max1 = _a[1];
    var _b = $ada57dad04d4bbf5$var$bboxFromPoints(points2), min2 = _b[0], max2 = _b[1];
    // Get a max value from each corner of two boundings.
    return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
}
function $ada57dad04d4bbf5$var$getSmooth(smooth) {
    return $7a1bd9c2710fea0d$export$7e4aa119212bc614(smooth) ? smooth : smooth ? 0.5 : 0;
}
function $ada57dad04d4bbf5$var$getStackedOnPoints(coordSys, data, dataCoordInfo) {
    if (!dataCoordInfo.valueDim) return [];
    var len = data.count();
    var points = (0, $5cd50afac93e9148$export$21d2298f3f56bbaf)(len * 2);
    for(var idx = 0; idx < len; idx++){
        var pt = (0, $af63fd8cd32fb271$export$c1601aa630e7b5f8)(dataCoordInfo, coordSys, data, idx);
        points[idx * 2] = pt[0];
        points[idx * 2 + 1] = pt[1];
    }
    return points;
}
function $ada57dad04d4bbf5$var$turnPointsIntoStep(points, coordSys, stepTurnAt, connectNulls) {
    var baseAxis = coordSys.getBaseAxis();
    var baseIndex = baseAxis.dim === "x" || baseAxis.dim === "radius" ? 0 : 1;
    var stepPoints = [];
    var i = 0;
    var stepPt = [];
    var pt = [];
    var nextPt = [];
    var filteredPoints = [];
    if (connectNulls) {
        for(i = 0; i < points.length; i += 2)if (!isNaN(points[i]) && !isNaN(points[i + 1])) filteredPoints.push(points[i], points[i + 1]);
        points = filteredPoints;
    }
    for(i = 0; i < points.length - 2; i += 2){
        nextPt[0] = points[i + 2];
        nextPt[1] = points[i + 3];
        pt[0] = points[i];
        pt[1] = points[i + 1];
        stepPoints.push(pt[0], pt[1]);
        switch(stepTurnAt){
            case "end":
                stepPt[baseIndex] = nextPt[baseIndex];
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                break;
            case "middle":
                var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
                var stepPt2 = [];
                stepPt[baseIndex] = stepPt2[baseIndex] = middle;
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                stepPoints.push(stepPt2[0], stepPt2[1]);
                break;
            default:
                // default is start
                stepPt[baseIndex] = pt[baseIndex];
                stepPt[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
        }
    }
    // Last points
    stepPoints.push(points[i++], points[i++]);
    return stepPoints;
}
/**
 * Clip color stops to edge. Avoid creating too large gradients.
 * Which may lead to blurry when GPU acceleration is enabled. See #15680
 *
 * The stops has been sorted from small to large.
 */ function $ada57dad04d4bbf5$var$clipColorStops(colorStops, maxSize) {
    var newColorStops = [];
    var len = colorStops.length;
    // coord will always < 0 in prevOutOfRangeColorStop.
    var prevOutOfRangeColorStop;
    var prevInRangeColorStop;
    function lerpStop(stop0, stop1, clippedCoord) {
        var coord0 = stop0.coord;
        var p = (clippedCoord - coord0) / (stop1.coord - coord0);
        var color = (0, $2c037f5bda6341ca$export$3a89f8d6f6bf6c9f)(p, [
            stop0.color,
            stop1.color
        ]);
        return {
            coord: clippedCoord,
            color: color
        };
    }
    for(var i = 0; i < len; i++){
        var stop_1 = colorStops[i];
        var coord = stop_1.coord;
        if (coord < 0) prevOutOfRangeColorStop = stop_1;
        else if (coord > maxSize) {
            if (prevInRangeColorStop) newColorStops.push(lerpStop(prevInRangeColorStop, stop_1, maxSize));
            else if (prevOutOfRangeColorStop) // If there are two stops and coord range is between these two stops
            newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0), lerpStop(prevOutOfRangeColorStop, stop_1, maxSize));
            break;
        } else {
            if (prevOutOfRangeColorStop) {
                newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0));
                // Reset
                prevOutOfRangeColorStop = null;
            }
            newColorStops.push(stop_1);
            prevInRangeColorStop = stop_1;
        }
    }
    return newColorStops;
}
function $ada57dad04d4bbf5$var$getVisualGradient(data, coordSys, api) {
    var visualMetaList = data.getVisual("visualMeta");
    if (!visualMetaList || !visualMetaList.length || !data.count()) // When data.count() is 0, gradient range can not be calculated.
    return;
    if (coordSys.type !== "cartesian2d") return;
    var coordDim;
    var visualMeta;
    for(var i = visualMetaList.length - 1; i >= 0; i--){
        var dimInfo = data.getDimensionInfo(visualMetaList[i].dimension);
        coordDim = dimInfo && dimInfo.coordDim;
        // Can only be x or y
        if (coordDim === "x" || coordDim === "y") {
            visualMeta = visualMetaList[i];
            break;
        }
    }
    if (!visualMeta) return;
    // If the area to be rendered is bigger than area defined by LinearGradient,
    // the canvas spec prescribes that the color of the first stop and the last
    // stop should be used. But if two stops are added at offset 0, in effect
    // browsers use the color of the second stop to render area outside
    // LinearGradient. So we can only infinitesimally extend area defined in
    // LinearGradient to render `outerColors`.
    var axis = coordSys.getAxis(coordDim);
    // dataToCoord mapping may not be linear, but must be monotonic.
    var colorStops = $7a1bd9c2710fea0d$export$871de8747c9eaa88(visualMeta.stops, function(stop) {
        // offset will be calculated later.
        return {
            coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
            color: stop.color
        };
    });
    var stopLen = colorStops.length;
    var outerColors = visualMeta.outerColors.slice();
    if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
        colorStops.reverse();
        outerColors.reverse();
    }
    var colorStopsInRange = $ada57dad04d4bbf5$var$clipColorStops(colorStops, coordDim === "x" ? api.getWidth() : api.getHeight());
    var inRangeStopLen = colorStopsInRange.length;
    if (!inRangeStopLen && stopLen) // All stops are out of range. All will be the same color.
    return colorStops[0].coord < 0 ? outerColors[1] ? outerColors[1] : colorStops[stopLen - 1].color : outerColors[0] ? outerColors[0] : colorStops[0].color;
    var tinyExtent = 10; // Arbitrary value: 10px
    var minCoord = colorStopsInRange[0].coord - tinyExtent;
    var maxCoord = colorStopsInRange[inRangeStopLen - 1].coord + tinyExtent;
    var coordSpan = maxCoord - minCoord;
    if (coordSpan < 1e-3) return "transparent";
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(colorStopsInRange, function(stop) {
        stop.offset = (stop.coord - minCoord) / coordSpan;
    });
    colorStopsInRange.push({
        // NOTE: inRangeStopLen may still be 0 if stoplen is zero.
        offset: inRangeStopLen ? colorStopsInRange[inRangeStopLen - 1].offset : 0.5,
        color: outerColors[1] || "transparent"
    });
    colorStopsInRange.unshift({
        offset: inRangeStopLen ? colorStopsInRange[0].offset : 0.5,
        color: outerColors[0] || "transparent"
    });
    var gradient = new $cf44c01491b58e53$export$2e2bcd8739ae039(0, 0, 0, 0, colorStopsInRange, true);
    gradient[coordDim] = minCoord;
    gradient[coordDim + "2"] = maxCoord;
    return gradient;
}
function $ada57dad04d4bbf5$var$getIsIgnoreFunc(seriesModel, data, coordSys) {
    var showAllSymbol = seriesModel.get("showAllSymbol");
    var isAuto = showAllSymbol === "auto";
    if (showAllSymbol && !isAuto) return;
    var categoryAxis = coordSys.getAxesByScale("ordinal")[0];
    if (!categoryAxis) return;
    // Note that category label interval strategy might bring some weird effect
    // in some scenario: users may wonder why some of the symbols are not
    // displayed. So we show all symbols as possible as we can.
    if (isAuto && $ada57dad04d4bbf5$var$canShowAllSymbolForCategory(categoryAxis, data)) return;
    // Otherwise follow the label interval strategy on category axis.
    var categoryDataDim = data.mapDimension(categoryAxis.dim);
    var labelMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(categoryAxis.getViewLabels(), function(labelItem) {
        var ordinalNumber = categoryAxis.scale.getRawOrdinalNumber(labelItem.tickValue);
        labelMap[ordinalNumber] = 1;
    });
    return function(dataIndex) {
        return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
    };
}
function $ada57dad04d4bbf5$var$canShowAllSymbolForCategory(categoryAxis, data) {
    // In most cases, line is monotonous on category axis, and the label size
    // is close with each other. So we check the symbol size and some of the
    // label size alone with the category axis to estimate whether all symbol
    // can be shown without overlap.
    var axisExtent = categoryAxis.getExtent();
    var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
    isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
    // Sampling some points, max 5.
    var dataLen = data.count();
    var step = Math.max(1, Math.round(dataLen / 5));
    for(var dataIndex = 0; dataIndex < dataLen; dataIndex += step){
        if ((0, $b1d9c3e17ccace80$export$2e2bcd8739ae039).getSymbolSize(data, dataIndex)[categoryAxis.isHorizontal() ? 1 : 0] * 1.5 > availSize) return false;
    }
    return true;
}
function $ada57dad04d4bbf5$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
function $ada57dad04d4bbf5$var$getLastIndexNotNull(points) {
    var len = points.length / 2;
    for(; len > 0; len--){
        if (!$ada57dad04d4bbf5$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
    }
    return len - 1;
}
function $ada57dad04d4bbf5$var$getPointAtIndex(points, idx) {
    return [
        points[idx * 2],
        points[idx * 2 + 1]
    ];
}
function $ada57dad04d4bbf5$var$getIndexRange(points, xOrY, dim) {
    var len = points.length / 2;
    var dimIdx = dim === "x" ? 0 : 1;
    var a;
    var b;
    var prevIndex = 0;
    var nextIndex = -1;
    for(var i = 0; i < len; i++){
        b = points[i * 2 + dimIdx];
        if (isNaN(b) || isNaN(points[i * 2 + 1 - dimIdx])) continue;
        if (i === 0) {
            a = b;
            continue;
        }
        if (a <= xOrY && b >= xOrY || a >= xOrY && b <= xOrY) {
            nextIndex = i;
            break;
        }
        prevIndex = i;
        a = b;
    }
    return {
        range: [
            prevIndex,
            nextIndex
        ],
        t: (xOrY - a) / (b - a)
    };
}
function $ada57dad04d4bbf5$var$anyStateShowEndLabel(seriesModel) {
    if (seriesModel.get([
        "endLabel",
        "show"
    ])) return true;
    for(var i = 0; i < (0, $2bf82c0980125b62$export$151308dceb52d5b).length; i++){
        if (seriesModel.get([
            (0, $2bf82c0980125b62$export$151308dceb52d5b)[i],
            "endLabel",
            "show"
        ])) return true;
    }
    return false;
}
function $ada57dad04d4bbf5$var$createLineClipPath(lineView, coordSys, hasAnimation, seriesModel) {
    if ((0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, "cartesian2d")) {
        var endLabelModel_1 = seriesModel.getModel("endLabel");
        var valueAnimation_1 = endLabelModel_1.get("valueAnimation");
        var data_1 = seriesModel.getData();
        var labelAnimationRecord_1 = {
            lastFrameIndex: 0
        };
        var during = $ada57dad04d4bbf5$var$anyStateShowEndLabel(seriesModel) ? function(percent, clipRect) {
            lineView._endLabelOnDuring(percent, clipRect, data_1, labelAnimationRecord_1, valueAnimation_1, endLabelModel_1, coordSys);
        } : null;
        var isHorizontal = coordSys.getBaseAxis().isHorizontal();
        var clipPath = (0, $0e2cc04b3aaad400$export$83958787eb658d14)(coordSys, hasAnimation, seriesModel, function() {
            var endLabel = lineView._endLabel;
            if (endLabel && hasAnimation) {
                if (labelAnimationRecord_1.originalX != null) endLabel.attr({
                    x: labelAnimationRecord_1.originalX,
                    y: labelAnimationRecord_1.originalY
                });
            }
        }, during);
        // Expand clip shape to avoid clipping when line value exceeds axis
        if (!seriesModel.get("clip", true)) {
            var rectShape = clipPath.shape;
            var expandSize = Math.max(rectShape.width, rectShape.height);
            if (isHorizontal) {
                rectShape.y -= expandSize;
                rectShape.height += expandSize * 2;
            } else {
                rectShape.x -= expandSize;
                rectShape.width += expandSize * 2;
            }
        }
        // Set to the final frame. To make sure label layout is right.
        if (during) during(1, clipPath);
        return clipPath;
    } else return (0, $0e2cc04b3aaad400$export$13dc2b2230df3cb5)(coordSys, hasAnimation, seriesModel);
}
function $ada57dad04d4bbf5$var$getEndLabelStateSpecified(endLabelModel, coordSys) {
    var baseAxis = coordSys.getBaseAxis();
    var isHorizontal = baseAxis.isHorizontal();
    var isBaseInversed = baseAxis.inverse;
    var align = isHorizontal ? isBaseInversed ? "right" : "left" : "center";
    var verticalAlign = isHorizontal ? "middle" : isBaseInversed ? "top" : "bottom";
    return {
        normal: {
            align: endLabelModel.get("align") || align,
            verticalAlign: endLabelModel.get("verticalAlign") || verticalAlign
        }
    };
}
var $ada57dad04d4bbf5$var$LineView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LineView, _super);
    function LineView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LineView.prototype.init = function() {
        var lineGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        var symbolDraw = new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)();
        this.group.add(symbolDraw.group);
        this._symbolDraw = symbolDraw;
        this._lineGroup = lineGroup;
    };
    LineView.prototype.render = function(seriesModel, ecModel, api) {
        var _this = this;
        var coordSys = seriesModel.coordinateSystem;
        var group = this.group;
        var data = seriesModel.getData();
        var lineStyleModel = seriesModel.getModel("lineStyle");
        var areaStyleModel = seriesModel.getModel("areaStyle");
        var points = data.getLayout("points") || [];
        var isCoordSysPolar = coordSys.type === "polar";
        var prevCoordSys = this._coordSys;
        var symbolDraw = this._symbolDraw;
        var polyline = this._polyline;
        var polygon = this._polygon;
        var lineGroup = this._lineGroup;
        var hasAnimation = !ecModel.ssr && seriesModel.get("animation");
        var isAreaChart = !areaStyleModel.isEmpty();
        var valueOrigin = areaStyleModel.get("origin");
        var dataCoordInfo = (0, $af63fd8cd32fb271$export$b488a529581b37e)(coordSys, data, valueOrigin);
        var stackedOnPoints = isAreaChart && $ada57dad04d4bbf5$var$getStackedOnPoints(coordSys, data, dataCoordInfo);
        var showSymbol = seriesModel.get("showSymbol");
        var connectNulls = seriesModel.get("connectNulls");
        var isIgnoreFunc = showSymbol && !isCoordSysPolar && $ada57dad04d4bbf5$var$getIsIgnoreFunc(seriesModel, data, coordSys);
        // Remove temporary symbols
        var oldData = this._data;
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        // Remove previous created symbols if showSymbol changed to false
        if (!showSymbol) symbolDraw.remove();
        group.add(lineGroup);
        // FIXME step not support polar
        var step = !isCoordSysPolar ? seriesModel.get("step") : false;
        var clipShapeForSymbol;
        if (coordSys && coordSys.getArea && seriesModel.get("clip", true)) {
            clipShapeForSymbol = coordSys.getArea();
            // Avoid float number rounding error for symbol on the edge of axis extent.
            // See #7913 and `test/dataZoom-clip.html`.
            if (clipShapeForSymbol.width != null) {
                clipShapeForSymbol.x -= 0.1;
                clipShapeForSymbol.y -= 0.1;
                clipShapeForSymbol.width += 0.2;
                clipShapeForSymbol.height += 0.2;
            } else if (clipShapeForSymbol.r0) {
                clipShapeForSymbol.r0 -= 0.5;
                clipShapeForSymbol.r += 0.5;
            }
        }
        this._clipShapeForSymbol = clipShapeForSymbol;
        var visualColor = $ada57dad04d4bbf5$var$getVisualGradient(data, coordSys, api) || data.getVisual("style")[data.getVisual("drawType")];
        // Initialization animation or coordinate system changed
        if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            });
            hasAnimation && this._initSymbolLabelAnimation(data, coordSys, clipShapeForSymbol);
            if (step) {
                // TODO If stacked series is not step
                points = $ada57dad04d4bbf5$var$turnPointsIntoStep(points, coordSys, step, connectNulls);
                if (stackedOnPoints) stackedOnPoints = $ada57dad04d4bbf5$var$turnPointsIntoStep(stackedOnPoints, coordSys, step, connectNulls);
            }
            polyline = this._newPolyline(points);
            if (isAreaChart) polygon = this._newPolygon(points, stackedOnPoints);
            else if (polygon) {
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            }
            // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $c84c9521536c601a$export$cda04d03233e5555)(visualColor));
            lineGroup.setClipPath($ada57dad04d4bbf5$var$createLineClipPath(this, coordSys, true, seriesModel));
        } else {
            if (isAreaChart && !polygon) // If areaStyle is added
            polygon = this._newPolygon(points, stackedOnPoints);
            else if (polygon && !isAreaChart) {
                // If areaStyle is removed
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            }
            // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $c84c9521536c601a$export$cda04d03233e5555)(visualColor));
            // Update clipPath
            var oldClipPath = lineGroup.getClipPath();
            if (oldClipPath) {
                var newClipPath = $ada57dad04d4bbf5$var$createLineClipPath(this, coordSys, false, seriesModel);
                $8b353638fbedfefa$export$a121566aadcfe021(oldClipPath, {
                    shape: newClipPath.shape
                }, seriesModel);
            } else lineGroup.setClipPath($ada57dad04d4bbf5$var$createLineClipPath(this, coordSys, true, seriesModel));
            // Always update, or it is wrong in the case turning on legend
            // because points are not changed.
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            });
            // In the case data zoom triggered refreshing frequently
            // Data may not change if line has a category axis. So it should animate nothing.
            if (!$ada57dad04d4bbf5$var$isPointsSame(this._stackedOnPoints, stackedOnPoints) || !$ada57dad04d4bbf5$var$isPointsSame(this._points, points)) {
                if (hasAnimation) this._doUpdateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls);
                else {
                    // Not do it in update with animation
                    if (step) {
                        // TODO If stacked series is not step
                        points = $ada57dad04d4bbf5$var$turnPointsIntoStep(points, coordSys, step, connectNulls);
                        if (stackedOnPoints) stackedOnPoints = $ada57dad04d4bbf5$var$turnPointsIntoStep(stackedOnPoints, coordSys, step, connectNulls);
                    }
                    polyline.setShape({
                        points: points
                    });
                    polygon && polygon.setShape({
                        points: points,
                        stackedOnPoints: stackedOnPoints
                    });
                }
            }
        }
        var emphasisModel = seriesModel.getModel("emphasis");
        var focus = emphasisModel.get("focus");
        var blurScope = emphasisModel.get("blurScope");
        var emphasisDisabled = emphasisModel.get("disabled");
        polyline.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e(// Use color in lineStyle first
        lineStyleModel.getLineStyle(), {
            fill: "none",
            stroke: visualColor,
            lineJoin: "bevel"
        }));
        (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polyline, seriesModel, "lineStyle");
        if (polyline.style.lineWidth > 0 && seriesModel.get([
            "emphasis",
            "lineStyle",
            "width"
        ]) === "bolder") {
            var emphasisLineStyle = polyline.getState("emphasis").style;
            emphasisLineStyle.lineWidth = +polyline.style.lineWidth + 1;
        }
        // Needs seriesIndex for focus
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(polyline).seriesIndex = seriesModel.seriesIndex;
        (0, $2bf82c0980125b62$export$e51187539ff11209)(polyline, focus, blurScope, emphasisDisabled);
        var smooth = $ada57dad04d4bbf5$var$getSmooth(seriesModel.get("smooth"));
        var smoothMonotone = seriesModel.get("smoothMonotone");
        polyline.setShape({
            smooth: smooth,
            smoothMonotone: smoothMonotone,
            connectNulls: connectNulls
        });
        if (polygon) {
            var stackedOnSeries = data.getCalculationInfo("stackedOnSeries");
            var stackedOnSmooth = 0;
            polygon.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e(areaStyleModel.getAreaStyle(), {
                fill: visualColor,
                opacity: 0.7,
                lineJoin: "bevel",
                decal: data.getVisual("style").decal
            }));
            if (stackedOnSeries) stackedOnSmooth = $ada57dad04d4bbf5$var$getSmooth(stackedOnSeries.get("smooth"));
            polygon.setShape({
                smooth: smooth,
                stackedOnSmooth: stackedOnSmooth,
                smoothMonotone: smoothMonotone,
                connectNulls: connectNulls
            });
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, seriesModel, "areaStyle");
            // Needs seriesIndex for focus
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(polygon).seriesIndex = seriesModel.seriesIndex;
            (0, $2bf82c0980125b62$export$e51187539ff11209)(polygon, focus, blurScope, emphasisDisabled);
        }
        var changePolyState = function(toState) {
            _this._changePolyState(toState);
        };
        data.eachItemGraphicEl(function(el) {
            // Switch polyline / polygon state if element changed its state.
            el && (el.onHoverStateChange = changePolyState);
        });
        this._polyline.onHoverStateChange = changePolyState;
        this._data = data;
        // Save the coordinate system for transition animation when data changed
        this._coordSys = coordSys;
        this._stackedOnPoints = stackedOnPoints;
        this._points = points;
        this._step = step;
        this._valueOrigin = valueOrigin;
        if (seriesModel.get("triggerLineEvent")) {
            this.packEventData(seriesModel, polyline);
            polygon && this.packEventData(seriesModel, polygon);
        }
    };
    LineView.prototype.packEventData = function(seriesModel, el) {
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).eventData = {
            componentType: "series",
            componentSubType: "line",
            componentIndex: seriesModel.componentIndex,
            seriesIndex: seriesModel.seriesIndex,
            seriesName: seriesModel.name,
            seriesType: "line"
        };
    };
    LineView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $76d619f648247e6d$export$42b26cae8b8d10(data, payload);
        this._changePolyState("emphasis");
        if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
            var points = data.getLayout("points");
            var symbol = data.getItemGraphicEl(dataIndex);
            if (!symbol) {
                // Create a temporary symbol if it is not exists
                var x = points[dataIndex * 2];
                var y = points[dataIndex * 2 + 1];
                if (isNaN(x) || isNaN(y)) // Null data
                return;
                // fix #11360: shouldn't draw symbol outside clipShapeForSymbol
                if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(x, y)) return;
                var zlevel = seriesModel.get("zlevel") || 0;
                var z = seriesModel.get("z") || 0;
                symbol = new (0, $b1d9c3e17ccace80$export$2e2bcd8739ae039)(data, dataIndex);
                symbol.x = x;
                symbol.y = y;
                symbol.setZ(zlevel, z);
                // ensure label text of the temporary symbol is in front of line and area polygon
                var symbolLabel = symbol.getSymbolPath().getTextContent();
                if (symbolLabel) {
                    symbolLabel.zlevel = zlevel;
                    symbolLabel.z = z;
                    symbolLabel.z2 = this._polyline.z2 + 1;
                }
                symbol.__temp = true;
                data.setItemGraphicEl(dataIndex, symbol);
                // Stop scale animation
                symbol.stopSymbolAnimation(true);
                this.group.add(symbol);
            }
            symbol.highlight();
        } else // Highlight whole series
        (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).prototype.highlight.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $76d619f648247e6d$export$42b26cae8b8d10(data, payload);
        this._changePolyState("normal");
        if (dataIndex != null && dataIndex >= 0) {
            var symbol = data.getItemGraphicEl(dataIndex);
            if (symbol) {
                if (symbol.__temp) {
                    data.setItemGraphicEl(dataIndex, null);
                    this.group.remove(symbol);
                } else symbol.downplay();
            }
        } else // FIXME
        // can not downplay completely.
        // Downplay whole series
        (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).prototype.downplay.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype._changePolyState = function(toState) {
        var polygon = this._polygon;
        (0, $2bf82c0980125b62$export$868ba38adffa9e39)(this._polyline, toState);
        polygon && (0, $2bf82c0980125b62$export$868ba38adffa9e39)(polygon, toState);
    };
    LineView.prototype._newPolyline = function(points) {
        var polyline = this._polyline;
        // Remove previous created polyline
        if (polyline) this._lineGroup.remove(polyline);
        polyline = new (0, $5c417e1ed90142c5$export$bf7c0585b8f7d00f)({
            shape: {
                points: points
            },
            segmentIgnoreThreshold: 2,
            z2: 10
        });
        this._lineGroup.add(polyline);
        this._polyline = polyline;
        return polyline;
    };
    LineView.prototype._newPolygon = function(points, stackedOnPoints) {
        var polygon = this._polygon;
        // Remove previous created polygon
        if (polygon) this._lineGroup.remove(polygon);
        polygon = new (0, $5c417e1ed90142c5$export$6042a400d113f2bd)({
            shape: {
                points: points,
                stackedOnPoints: stackedOnPoints
            },
            segmentIgnoreThreshold: 2
        });
        this._lineGroup.add(polygon);
        this._polygon = polygon;
        return polygon;
    };
    LineView.prototype._initSymbolLabelAnimation = function(data, coordSys, clipShape) {
        var isHorizontalOrRadial;
        var isCoordSysPolar;
        var baseAxis = coordSys.getBaseAxis();
        var isAxisInverse = baseAxis.inverse;
        if (coordSys.type === "cartesian2d") {
            isHorizontalOrRadial = baseAxis.isHorizontal();
            isCoordSysPolar = false;
        } else if (coordSys.type === "polar") {
            isHorizontalOrRadial = baseAxis.dim === "angle";
            isCoordSysPolar = true;
        }
        var seriesModel = data.hostModel;
        var seriesDuration = seriesModel.get("animationDuration");
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesDuration)) seriesDuration = seriesDuration(null);
        var seriesDelay = seriesModel.get("animationDelay") || 0;
        var seriesDelayValue = $7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesDelay) ? seriesDelay(null) : seriesDelay;
        data.eachItemGraphicEl(function(symbol, idx) {
            var el = symbol;
            if (el) {
                var point = [
                    symbol.x,
                    symbol.y
                ];
                var start = void 0;
                var end = void 0;
                var current = void 0;
                if (clipShape) {
                    if (isCoordSysPolar) {
                        var polarClip = clipShape;
                        var coord = coordSys.pointToCoord(point);
                        if (isHorizontalOrRadial) {
                            start = polarClip.startAngle;
                            end = polarClip.endAngle;
                            current = -coord[1] / 180 * Math.PI;
                        } else {
                            start = polarClip.r0;
                            end = polarClip.r;
                            current = coord[0];
                        }
                    } else {
                        var gridClip = clipShape;
                        if (isHorizontalOrRadial) {
                            start = gridClip.x;
                            end = gridClip.x + gridClip.width;
                            current = symbol.x;
                        } else {
                            start = gridClip.y + gridClip.height;
                            end = gridClip.y;
                            current = symbol.y;
                        }
                    }
                }
                var ratio = end === start ? 0 : (current - start) / (end - start);
                if (isAxisInverse) ratio = 1 - ratio;
                var delay = $7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesDelay) ? seriesDelay(idx) : seriesDuration * ratio + seriesDelayValue;
                var symbolPath = el.getSymbolPath();
                var text = symbolPath.getTextContent();
                el.attr({
                    scaleX: 0,
                    scaleY: 0
                });
                el.animateTo({
                    scaleX: 1,
                    scaleY: 1
                }, {
                    duration: 200,
                    setToFinal: true,
                    delay: delay
                });
                if (text) text.animateFrom({
                    style: {
                        opacity: 0
                    }
                }, {
                    duration: 300,
                    delay: delay
                });
                symbolPath.disableLabelAnimation = true;
            }
        });
    };
    LineView.prototype._initOrUpdateEndLabel = function(seriesModel, coordSys, inheritColor) {
        var endLabelModel = seriesModel.getModel("endLabel");
        if ($ada57dad04d4bbf5$var$anyStateShowEndLabel(seriesModel)) {
            var data_2 = seriesModel.getData();
            var polyline = this._polyline;
            // series may be filtered.
            var points = data_2.getLayout("points");
            if (!points) {
                polyline.removeTextContent();
                this._endLabel = null;
                return;
            }
            var endLabel = this._endLabel;
            if (!endLabel) {
                endLabel = this._endLabel = new $fe885cc21795562b$export$2e2bcd8739ae039({
                    z2: 200 // should be higher than item symbol
                });
                endLabel.ignoreClip = true;
                polyline.setTextContent(this._endLabel);
                polyline.disableLabelAnimation = true;
            }
            // Find last non-NaN data to display data
            var dataIndex = $ada57dad04d4bbf5$var$getLastIndexNotNull(points);
            if (dataIndex >= 0) {
                (0, $6800dfcb6e1e2a44$export$9a13992917966657)(polyline, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(seriesModel, "endLabel"), {
                    inheritColor: inheritColor,
                    labelFetcher: seriesModel,
                    labelDataIndex: dataIndex,
                    defaultText: function(dataIndex, opt, interpolatedValue) {
                        return interpolatedValue != null ? (0, $b2475f850d3c0bc2$export$5f84815e91ca6775)(data_2, interpolatedValue) : (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(data_2, dataIndex);
                    },
                    enableTextSetter: true
                }, $ada57dad04d4bbf5$var$getEndLabelStateSpecified(endLabelModel, coordSys));
                polyline.textConfig.position = null;
            }
        } else if (this._endLabel) {
            this._polyline.removeTextContent();
            this._endLabel = null;
        }
    };
    LineView.prototype._endLabelOnDuring = function(percent, clipRect, data, animationRecord, valueAnimation, endLabelModel, coordSys) {
        var endLabel = this._endLabel;
        var polyline = this._polyline;
        if (endLabel) {
            // NOTE: Don't remove percent < 1. percent === 1 means the first frame during render.
            // The label is not prepared at this time.
            if (percent < 1 && animationRecord.originalX == null) {
                animationRecord.originalX = endLabel.x;
                animationRecord.originalY = endLabel.y;
            }
            var points = data.getLayout("points");
            var seriesModel = data.hostModel;
            var connectNulls = seriesModel.get("connectNulls");
            var precision = endLabelModel.get("precision");
            var distance = endLabelModel.get("distance") || 0;
            var baseAxis = coordSys.getBaseAxis();
            var isHorizontal = baseAxis.isHorizontal();
            var isBaseInversed = baseAxis.inverse;
            var clipShape = clipRect.shape;
            var xOrY = isBaseInversed ? isHorizontal ? clipShape.x : clipShape.y + clipShape.height : isHorizontal ? clipShape.x + clipShape.width : clipShape.y;
            var distanceX = (isHorizontal ? distance : 0) * (isBaseInversed ? -1 : 1);
            var distanceY = (isHorizontal ? 0 : -distance) * (isBaseInversed ? -1 : 1);
            var dim = isHorizontal ? "x" : "y";
            var dataIndexRange = $ada57dad04d4bbf5$var$getIndexRange(points, xOrY, dim);
            var indices = dataIndexRange.range;
            var diff = indices[1] - indices[0];
            var value = void 0;
            if (diff >= 1) {
                // diff > 1 && connectNulls, which is on the null data.
                if (diff > 1 && !connectNulls) {
                    var pt = $ada57dad04d4bbf5$var$getPointAtIndex(points, indices[0]);
                    endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    valueAnimation && (value = seriesModel.getRawValue(indices[0]));
                } else {
                    var pt = polyline.getPointOn(xOrY, dim);
                    pt && endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    var startValue = seriesModel.getRawValue(indices[0]);
                    var endValue = seriesModel.getRawValue(indices[1]);
                    valueAnimation && (value = $76d619f648247e6d$export$bd0439821a1869f3(data, precision, startValue, endValue, dataIndexRange.t));
                }
                animationRecord.lastFrameIndex = indices[0];
            } else {
                // If diff <= 0, which is the range is not found(Include NaN)
                // Choose the first point or last point.
                var idx = percent === 1 || animationRecord.lastFrameIndex > 0 ? indices[0] : 0;
                var pt = $ada57dad04d4bbf5$var$getPointAtIndex(points, idx);
                valueAnimation && (value = seriesModel.getRawValue(idx));
                endLabel.attr({
                    x: pt[0] + distanceX,
                    y: pt[1] + distanceY
                });
            }
            if (valueAnimation) {
                var inner = (0, $6800dfcb6e1e2a44$export$f62786d3261ab0f4)(endLabel);
                if (typeof inner.setLabelText === "function") inner.setLabelText(value);
            }
        }
    };
    /**
   * @private
   */ // FIXME Two value axis
    LineView.prototype._doUpdateAnimation = function(data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls) {
        var polyline = this._polyline;
        var polygon = this._polygon;
        var seriesModel = data.hostModel;
        var diff = (0, $b022c65e2d67ded9$export$2e2bcd8739ae039)(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
        var current = diff.current;
        var stackedOnCurrent = diff.stackedOnCurrent;
        var next = diff.next;
        var stackedOnNext = diff.stackedOnNext;
        if (step) {
            // TODO If stacked series is not step
            current = $ada57dad04d4bbf5$var$turnPointsIntoStep(diff.current, coordSys, step, connectNulls);
            stackedOnCurrent = $ada57dad04d4bbf5$var$turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step, connectNulls);
            next = $ada57dad04d4bbf5$var$turnPointsIntoStep(diff.next, coordSys, step, connectNulls);
            stackedOnNext = $ada57dad04d4bbf5$var$turnPointsIntoStep(diff.stackedOnNext, coordSys, step, connectNulls);
        }
        // Don't apply animation if diff is large.
        // For better result and avoid memory explosion problems like
        // https://github.com/apache/incubator-echarts/issues/12229
        if ($ada57dad04d4bbf5$var$getBoundingDiff(current, next) > 3000 || polygon && $ada57dad04d4bbf5$var$getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
            polyline.stopAnimation();
            polyline.setShape({
                points: next
            });
            if (polygon) {
                polygon.stopAnimation();
                polygon.setShape({
                    points: next,
                    stackedOnPoints: stackedOnNext
                });
            }
            return;
        }
        polyline.shape.__points = diff.current;
        polyline.shape.points = current;
        var target = {
            shape: {
                points: next
            }
        };
        // Also animate the original points.
        // If points reference is changed when turning into step line.
        if (diff.current !== current) target.shape.__points = diff.next;
        // Stop previous animation.
        polyline.stopAnimation();
        $8b353638fbedfefa$export$c8dce3c08436e91e(polyline, target, seriesModel);
        if (polygon) {
            polygon.setShape({
                // Reuse the points with polyline.
                points: current,
                stackedOnPoints: stackedOnCurrent
            });
            polygon.stopAnimation();
            $8b353638fbedfefa$export$c8dce3c08436e91e(polygon, {
                shape: {
                    stackedOnPoints: stackedOnNext
                }
            }, seriesModel);
            // If use attr directly in updateProps.
            if (polyline.shape.points !== polygon.shape.points) polygon.shape.points = polyline.shape.points;
        }
        var updatedDataInfo = [];
        var diffStatus = diff.status;
        for(var i = 0; i < diffStatus.length; i++){
            var cmd = diffStatus[i].cmd;
            if (cmd === "=") {
                var el = data.getItemGraphicEl(diffStatus[i].idx1);
                if (el) updatedDataInfo.push({
                    el: el,
                    ptIdx: i // Index of points
                });
            }
        }
        if (polyline.animators && polyline.animators.length) polyline.animators[0].during(function() {
            polygon && polygon.dirtyShape();
            var points = polyline.shape.__points;
            for(var i = 0; i < updatedDataInfo.length; i++){
                var el = updatedDataInfo[i].el;
                var offset = updatedDataInfo[i].ptIdx * 2;
                el.x = points[offset];
                el.y = points[offset + 1];
                el.markRedraw();
            }
        });
    };
    LineView.prototype.remove = function(ecModel) {
        var group = this.group;
        var oldData = this._data;
        this._lineGroup.removeAll();
        this._symbolDraw.remove(true);
        // Remove temporary created elements when highlighting
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._endLabel = this._data = null;
    };
    LineView.type = "line";
    return LineView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $ada57dad04d4bbf5$export$2e2bcd8739ae039 = $ada57dad04d4bbf5$var$LineView;




function $9c1bfdc9a4f78f2d$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $ada57dad04d4bbf5$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $04f9db15b0fa1cf8$export$2e2bcd8739ae039));
    registers.registerLayout((0, $73b014aa594ea652$export$2e2bcd8739ae039)("line", true));
    registers.registerVisual({
        seriesType: "line",
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            // Visual coding for legend
            var lineStyle = seriesModel.getModel("lineStyle").getLineStyle();
            if (lineStyle && !lineStyle.stroke) // Fill in visual should be palette color if
            // has color callback
            lineStyle.stroke = data.getVisual("style").fill;
            data.setVisual("legendLineStyle", lineStyle);
        }
    });
    // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $3a37e5b80322a871$export$2e2bcd8739ae039)("line"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $ac4f44aacfb7dba9$var$EffectLine = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(EffectLine, _super);
    function EffectLine(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this.add(_this.createLine(lineData, idx, seriesScope));
        _this._updateEffectSymbol(lineData, idx);
        return _this;
    }
    EffectLine.prototype.createLine = function(lineData, idx, seriesScope) {
        return new (0, $9e0b5f801ab5090c$export$2e2bcd8739ae039)(lineData, idx, seriesScope);
    };
    EffectLine.prototype._updateEffectSymbol = function(lineData, idx) {
        var itemModel = lineData.getItemModel(idx);
        var effectModel = itemModel.getModel("effect");
        var size = effectModel.get("symbolSize");
        var symbolType = effectModel.get("symbol");
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(size)) size = [
            size,
            size
        ];
        var lineStyle = lineData.getItemVisual(idx, "style");
        var color = effectModel.get("color") || lineStyle && lineStyle.stroke;
        var symbol = this.childAt(1);
        if (this._symbolType !== symbolType) {
            // Remove previous
            this.remove(symbol);
            symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, -0.5, -0.5, 1, 1, color);
            symbol.z2 = 100;
            symbol.culling = true;
            this.add(symbol);
        }
        // Symbol may be removed if loop is false
        if (!symbol) return;
        // Shadow color is same with color in default
        symbol.setStyle("shadowColor", color);
        symbol.setStyle(effectModel.getItemStyle([
            "color"
        ]));
        symbol.scaleX = size[0];
        symbol.scaleY = size[1];
        symbol.setColor(color);
        this._symbolType = symbolType;
        this._symbolScale = size;
        this._updateEffectAnimation(lineData, effectModel, idx);
    };
    EffectLine.prototype._updateEffectAnimation = function(lineData, effectModel, idx) {
        var symbol = this.childAt(1);
        if (!symbol) return;
        var points = lineData.getItemLayout(idx);
        var period = effectModel.get("period") * 1000;
        var loop = effectModel.get("loop");
        var roundTrip = effectModel.get("roundTrip");
        var constantSpeed = effectModel.get("constantSpeed");
        var delayExpr = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66(effectModel.get("delay"), function(idx) {
            return idx / lineData.count() * period / 3;
        });
        // Ignore when updating
        symbol.ignore = true;
        this._updateAnimationPoints(symbol, points);
        if (constantSpeed > 0) period = this._getLineLength(symbol) / constantSpeed * 1000;
        if (period !== this._period || loop !== this._loop || roundTrip !== this._roundTrip) {
            symbol.stopAnimation();
            var delayNum = void 0;
            if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(delayExpr)) delayNum = delayExpr(idx);
            else delayNum = delayExpr;
            if (symbol.__t > 0) delayNum = -period * symbol.__t;
            this._animateSymbol(symbol, period, delayNum, loop, roundTrip);
        }
        this._period = period;
        this._loop = loop;
        this._roundTrip = roundTrip;
    };
    EffectLine.prototype._animateSymbol = function(symbol, period, delayNum, loop, roundTrip) {
        if (period > 0) {
            symbol.__t = 0;
            var self_1 = this;
            var animator = symbol.animate("", loop).when(roundTrip ? period * 2 : period, {
                __t: roundTrip ? 2 : 1
            }).delay(delayNum).during(function() {
                self_1._updateSymbolPosition(symbol);
            });
            if (!loop) animator.done(function() {
                self_1.remove(symbol);
            });
            animator.start();
        }
    };
    EffectLine.prototype._getLineLength = function(symbol) {
        // Not so accurate
        return $6de594cf8ac295ff$export$6c4a311cc157c764(symbol.__p1, symbol.__cp1) + $6de594cf8ac295ff$export$6c4a311cc157c764(symbol.__cp1, symbol.__p2);
    };
    EffectLine.prototype._updateAnimationPoints = function(symbol, points) {
        symbol.__p1 = points[0];
        symbol.__p2 = points[1];
        symbol.__cp1 = points[2] || [
            (points[0][0] + points[1][0]) / 2,
            (points[0][1] + points[1][1]) / 2
        ];
    };
    EffectLine.prototype.updateData = function(lineData, idx, seriesScope) {
        this.childAt(0).updateData(lineData, idx, seriesScope);
        this._updateEffectSymbol(lineData, idx);
    };
    EffectLine.prototype._updateSymbolPosition = function(symbol) {
        var p1 = symbol.__p1;
        var p2 = symbol.__p2;
        var cp1 = symbol.__cp1;
        var t = symbol.__t < 1 ? symbol.__t : 2 - symbol.__t;
        var pos = [
            symbol.x,
            symbol.y
        ];
        var lastPos = pos.slice();
        var quadraticAt = $747cfc5611b57cea$export$af17094a950f5073;
        var quadraticDerivativeAt = $747cfc5611b57cea$export$7e161e77e6fff8cb;
        pos[0] = quadraticAt(p1[0], cp1[0], p2[0], t);
        pos[1] = quadraticAt(p1[1], cp1[1], p2[1], t);
        // Tangent
        var tx = symbol.__t < 1 ? quadraticDerivativeAt(p1[0], cp1[0], p2[0], t) : quadraticDerivativeAt(p2[0], cp1[0], p1[0], 1 - t);
        var ty = symbol.__t < 1 ? quadraticDerivativeAt(p1[1], cp1[1], p2[1], t) : quadraticDerivativeAt(p2[1], cp1[1], p1[1], 1 - t);
        symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
        // enable continuity trail for 'line', 'rect', 'roundRect' symbolType
        if (this._symbolType === "line" || this._symbolType === "rect" || this._symbolType === "roundRect") {
            if (symbol.__lastT !== undefined && symbol.__lastT < symbol.__t) {
                symbol.scaleY = $6de594cf8ac295ff$export$6c4a311cc157c764(lastPos, pos) * 1.05;
                // make sure the last segment render within endPoint
                if (t === 1) {
                    pos[0] = lastPos[0] + (pos[0] - lastPos[0]) / 2;
                    pos[1] = lastPos[1] + (pos[1] - lastPos[1]) / 2;
                }
            } else if (symbol.__lastT === 1) // After first loop, symbol.__t does NOT start with 0, so connect p1 to pos directly.
            symbol.scaleY = 2 * $6de594cf8ac295ff$export$6c4a311cc157c764(p1, pos);
            else symbol.scaleY = this._symbolScale[1];
        }
        symbol.__lastT = symbol.__t;
        symbol.ignore = false;
        symbol.x = pos[0];
        symbol.y = pos[1];
    };
    EffectLine.prototype.updateLayout = function(lineData, idx) {
        this.childAt(0).updateLayout(lineData, idx);
        var effectModel = lineData.getItemModel(idx).getModel("effect");
        this._updateEffectAnimation(lineData, effectModel, idx);
    };
    return EffectLine;
}($7ef7583d8302ffce$export$2e2bcd8739ae039);
var $ac4f44aacfb7dba9$export$2e2bcd8739ae039 = $ac4f44aacfb7dba9$var$EffectLine;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $bdfe7b18bcde1955$var$Polyline = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(Polyline, _super);
    function Polyline(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this._createPolyline(lineData, idx, seriesScope);
        return _this;
    }
    Polyline.prototype._createPolyline = function(lineData, idx, seriesScope) {
        // let seriesModel = lineData.hostModel;
        var points = lineData.getItemLayout(idx);
        var line = new $d28119f30e6bb670$export$2e2bcd8739ae039({
            shape: {
                points: points
            }
        });
        this.add(line);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Polyline.prototype.updateData = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childAt(0);
        var target = {
            shape: {
                points: lineData.getItemLayout(idx)
            }
        };
        $8b353638fbedfefa$export$c8dce3c08436e91e(line, target, seriesModel, idx);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Polyline.prototype._updateCommonStl = function(lineData, idx, seriesScope) {
        var line = this.childAt(0);
        var itemModel = lineData.getItemModel(idx);
        var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
        var focus = seriesScope && seriesScope.focus;
        var blurScope = seriesScope && seriesScope.blurScope;
        var emphasisDisabled = seriesScope && seriesScope.emphasisDisabled;
        if (!seriesScope || lineData.hasItemOption) {
            var emphasisModel = itemModel.getModel("emphasis");
            emphasisLineStyle = emphasisModel.getModel("lineStyle").getLineStyle();
            emphasisDisabled = emphasisModel.get("disabled");
            focus = emphasisModel.get("focus");
            blurScope = emphasisModel.get("blurScope");
        }
        line.useStyle(lineData.getItemVisual(idx, "style"));
        line.style.fill = null;
        line.style.strokeNoScale = true;
        var lineEmphasisState = line.ensureState("emphasis");
        lineEmphasisState.style = emphasisLineStyle;
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, focus, blurScope, emphasisDisabled);
    };
    Polyline.prototype.updateLayout = function(lineData, idx) {
        var polyline = this.childAt(0);
        polyline.setShape("points", lineData.getItemLayout(idx));
    };
    return Polyline;
}($7ef7583d8302ffce$export$2e2bcd8739ae039);
var $bdfe7b18bcde1955$export$2e2bcd8739ae039 = $bdfe7b18bcde1955$var$Polyline;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $a16373b7bc6b0508$var$EffectPolyline = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(EffectPolyline, _super);
    function EffectPolyline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._lastFrame = 0;
        _this._lastFramePercent = 0;
        return _this;
    }
    // Override
    EffectPolyline.prototype.createLine = function(lineData, idx, seriesScope) {
        return new (0, $bdfe7b18bcde1955$export$2e2bcd8739ae039)(lineData, idx, seriesScope);
    };
    // Override
    EffectPolyline.prototype._updateAnimationPoints = function(symbol, points) {
        this._points = points;
        var accLenArr = [
            0
        ];
        var len = 0;
        for(var i = 1; i < points.length; i++){
            var p1 = points[i - 1];
            var p2 = points[i];
            len += $6de594cf8ac295ff$export$6c4a311cc157c764(p1, p2);
            accLenArr.push(len);
        }
        if (len === 0) {
            this._length = 0;
            return;
        }
        for(var i = 0; i < accLenArr.length; i++)accLenArr[i] /= len;
        this._offsets = accLenArr;
        this._length = len;
    };
    // Override
    EffectPolyline.prototype._getLineLength = function() {
        return this._length;
    };
    // Override
    EffectPolyline.prototype._updateSymbolPosition = function(symbol) {
        var t = symbol.__t < 1 ? symbol.__t : 2 - symbol.__t;
        var points = this._points;
        var offsets = this._offsets;
        var len = points.length;
        if (!offsets) // Has length 0
        return;
        var lastFrame = this._lastFrame;
        var frame;
        if (t < this._lastFramePercent) {
            // Start from the next frame
            // PENDING start from lastFrame ?
            var start = Math.min(lastFrame + 1, len - 1);
            for(frame = start; frame >= 0; frame--){
                if (offsets[frame] <= t) break;
            }
            // PENDING really need to do this ?
            frame = Math.min(frame, len - 2);
        } else {
            for(frame = lastFrame; frame < len; frame++){
                if (offsets[frame] > t) break;
            }
            frame = Math.min(frame - 1, len - 2);
        }
        var p = (t - offsets[frame]) / (offsets[frame + 1] - offsets[frame]);
        var p0 = points[frame];
        var p1 = points[frame + 1];
        symbol.x = p0[0] * (1 - p) + p * p1[0];
        symbol.y = p0[1] * (1 - p) + p * p1[1];
        var tx = symbol.__t < 1 ? p1[0] - p0[0] : p0[0] - p1[0];
        var ty = symbol.__t < 1 ? p1[1] - p0[1] : p0[1] - p1[1];
        symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
        this._lastFrame = frame;
        this._lastFramePercent = t;
        symbol.ignore = false;
    };
    return EffectPolyline;
}((0, $ac4f44aacfb7dba9$export$2e2bcd8739ae039));
var $a16373b7bc6b0508$export$2e2bcd8739ae039 = $a16373b7bc6b0508$var$EffectPolyline;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $2f5f63360e8576db$var$LargeLinesPathShape = /** @class */ function() {
    function LargeLinesPathShape() {
        this.polyline = false;
        this.curveness = 0;
        this.segs = [];
    }
    return LargeLinesPathShape;
}();
var $2f5f63360e8576db$var$LargeLinesPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LargeLinesPath, _super);
    function LargeLinesPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this._off = 0;
        _this.hoverDataIdx = -1;
        return _this;
    }
    LargeLinesPath.prototype.reset = function() {
        this.notClear = false;
        this._off = 0;
    };
    LargeLinesPath.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    LargeLinesPath.prototype.getDefaultShape = function() {
        return new $2f5f63360e8576db$var$LargeLinesPathShape();
    };
    LargeLinesPath.prototype.buildPath = function(ctx, shape) {
        var segs = shape.segs;
        var curveness = shape.curveness;
        var i;
        if (shape.polyline) for(i = this._off; i < segs.length;){
            var count = segs[i++];
            if (count > 0) {
                ctx.moveTo(segs[i++], segs[i++]);
                for(var k = 1; k < count; k++)ctx.lineTo(segs[i++], segs[i++]);
            }
        }
        else for(i = this._off; i < segs.length;){
            var x0 = segs[i++];
            var y0 = segs[i++];
            var x1 = segs[i++];
            var y1 = segs[i++];
            ctx.moveTo(x0, y0);
            if (curveness > 0) {
                var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
                var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
                ctx.quadraticCurveTo(x2, y2, x1, y1);
            } else ctx.lineTo(x1, y1);
        }
        if (this.incremental) {
            this._off = i;
            this.notClear = true;
        }
    };
    LargeLinesPath.prototype.findDataIndex = function(x, y) {
        var shape = this.shape;
        var segs = shape.segs;
        var curveness = shape.curveness;
        var lineWidth = this.style.lineWidth;
        if (shape.polyline) {
            var dataIndex = 0;
            for(var i = 0; i < segs.length;){
                var count = segs[i++];
                if (count > 0) {
                    var x0 = segs[i++];
                    var y0 = segs[i++];
                    for(var k = 1; k < count; k++){
                        var x1 = segs[i++];
                        var y1 = segs[i++];
                        if ($beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y)) return dataIndex;
                    }
                }
                dataIndex++;
            }
        } else {
            var dataIndex = 0;
            for(var i = 0; i < segs.length;){
                var x0 = segs[i++];
                var y0 = segs[i++];
                var x1 = segs[i++];
                var y1 = segs[i++];
                if (curveness > 0) {
                    var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
                    var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
                    if ($a1d80a5bf05b597b$export$8d36b1b5d19157c5(x0, y0, x2, y2, x1, y1, lineWidth, x, y)) return dataIndex;
                } else {
                    if ($beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y)) return dataIndex;
                }
                dataIndex++;
            }
        }
        return -1;
    };
    LargeLinesPath.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            // Cache found data index.
            var dataIdx = this.hoverDataIdx = this.findDataIndex(x, y);
            return dataIdx >= 0;
        }
        this.hoverDataIdx = -1;
        return false;
    };
    LargeLinesPath.prototype.getBoundingRect = function() {
        // Ignore stroke for large symbol draw.
        var rect = this._rect;
        if (!rect) {
            var shape = this.shape;
            var points = shape.segs;
            var minX = Infinity;
            var minY = Infinity;
            var maxX = -Infinity;
            var maxY = -Infinity;
            for(var i = 0; i < points.length;){
                var x = points[i++];
                var y = points[i++];
                minX = Math.min(x, minX);
                maxX = Math.max(x, maxX);
                minY = Math.min(y, minY);
                maxY = Math.max(y, maxY);
            }
            rect = this._rect = new $1bebe7106c895823$export$2e2bcd8739ae039(minX, minY, maxX, maxY);
        }
        return rect;
    };
    return LargeLinesPath;
}($b02ffe7acd508c08$export$2e2bcd8739ae039);
var $2f5f63360e8576db$var$LargeLineDraw = /** @class */ function() {
    function LargeLineDraw() {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    }
    /**
   * Update symbols draw by new data
   */ LargeLineDraw.prototype.updateData = function(data) {
        this._clear();
        var lineEl = this._create();
        lineEl.setShape({
            segs: data.getLayout("linesPoints")
        });
        this._setCommon(lineEl, data);
    };
    /**
   * @override
   */ LargeLineDraw.prototype.incrementalPrepareUpdate = function(data) {
        this.group.removeAll();
        this._clear();
    };
    /**
   * @override
   */ LargeLineDraw.prototype.incrementalUpdate = function(taskParams, data) {
        var lastAdded = this._newAdded[0];
        var linePoints = data.getLayout("linesPoints");
        var oldSegs = lastAdded && lastAdded.shape.segs;
        // Merging the exists. Each element has 1e4 points.
        // Consider the performance balance between too much elements and too much points in one shape(may affect hover optimization)
        if (oldSegs && oldSegs.length < 2e4) {
            var oldLen = oldSegs.length;
            var newSegs = new Float32Array(oldLen + linePoints.length);
            // Concat two array
            newSegs.set(oldSegs);
            newSegs.set(linePoints, oldLen);
            lastAdded.setShape({
                segs: newSegs
            });
        } else {
            // Clear
            this._newAdded = [];
            var lineEl = this._create();
            lineEl.incremental = true;
            lineEl.setShape({
                segs: linePoints
            });
            this._setCommon(lineEl, data);
            lineEl.__startIndex = taskParams.start;
        }
    };
    /**
   * @override
   */ LargeLineDraw.prototype.remove = function() {
        this._clear();
    };
    LargeLineDraw.prototype.eachRendered = function(cb) {
        this._newAdded[0] && cb(this._newAdded[0]);
    };
    LargeLineDraw.prototype._create = function() {
        var lineEl = new $2f5f63360e8576db$var$LargeLinesPath({
            cursor: "default",
            ignoreCoarsePointer: true
        });
        this._newAdded.push(lineEl);
        this.group.add(lineEl);
        return lineEl;
    };
    LargeLineDraw.prototype._setCommon = function(lineEl, data, isIncremental) {
        var hostModel = data.hostModel;
        lineEl.setShape({
            polyline: hostModel.get("polyline"),
            curveness: hostModel.get([
                "lineStyle",
                "curveness"
            ])
        });
        lineEl.useStyle(hostModel.getModel("lineStyle").getLineStyle());
        lineEl.style.strokeNoScale = true;
        var style = data.getVisual("style");
        if (style && style.stroke) lineEl.setStyle("stroke", style.stroke);
        lineEl.setStyle("fill", null);
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(lineEl);
        // Enable tooltip
        // PENDING May have performance issue when path is extremely large
        ecData.seriesIndex = hostModel.seriesIndex;
        lineEl.on("mousemove", function(e) {
            ecData.dataIndex = null;
            var dataIndex = lineEl.hoverDataIdx;
            if (dataIndex > 0) // Provide dataIndex for tooltip
            ecData.dataIndex = dataIndex + lineEl.__startIndex;
        });
    };
    LargeLineDraw.prototype._clear = function() {
        this._newAdded = [];
        this.group.removeAll();
    };
    return LargeLineDraw;
}();
var $2f5f63360e8576db$export$2e2bcd8739ae039 = $2f5f63360e8576db$var$LargeLineDraw;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Float32Array */ 

var $e702d3171e9448b0$var$linesLayout = {
    seriesType: "lines",
    plan: (0, $cd70075c57b35175$export$2e2bcd8739ae039)(),
    reset: function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (!coordSys) return;
        var isPolyline = seriesModel.get("polyline");
        var isLarge = seriesModel.pipelineContext.large;
        return {
            progress: function(params, lineData) {
                var lineCoords = [];
                if (isLarge) {
                    var points = void 0;
                    var segCount = params.end - params.start;
                    if (isPolyline) {
                        var totalCoordsCount = 0;
                        for(var i = params.start; i < params.end; i++)totalCoordsCount += seriesModel.getLineCoordsCount(i);
                        points = new Float32Array(segCount + totalCoordsCount * 2);
                    } else points = new Float32Array(segCount * 4);
                    var offset = 0;
                    var pt = [];
                    for(var i = params.start; i < params.end; i++){
                        var len = seriesModel.getLineCoords(i, lineCoords);
                        if (isPolyline) points[offset++] = len;
                        for(var k = 0; k < len; k++){
                            pt = coordSys.dataToPoint(lineCoords[k], false, pt);
                            points[offset++] = pt[0];
                            points[offset++] = pt[1];
                        }
                    }
                    lineData.setLayout("linesPoints", points);
                } else for(var i = params.start; i < params.end; i++){
                    var itemModel = lineData.getItemModel(i);
                    var len = seriesModel.getLineCoords(i, lineCoords);
                    var pts = [];
                    if (isPolyline) for(var j = 0; j < len; j++)pts.push(coordSys.dataToPoint(lineCoords[j]));
                    else {
                        pts[0] = coordSys.dataToPoint(lineCoords[0]);
                        pts[1] = coordSys.dataToPoint(lineCoords[1]);
                        var curveness = itemModel.get([
                            "lineStyle",
                            "curveness"
                        ]);
                        if (+curveness) pts[2] = [
                            (pts[0][0] + pts[1][0]) / 2 - (pts[0][1] - pts[1][1]) * curveness,
                            (pts[0][1] + pts[1][1]) / 2 - (pts[1][0] - pts[0][0]) * curveness
                        ];
                    }
                    lineData.setItemLayout(i, pts);
                }
            }
        };
    }
};
var $e702d3171e9448b0$export$2e2bcd8739ae039 = $e702d3171e9448b0$var$linesLayout;




var $cefff1aea7415b28$var$LinesView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LinesView, _super);
    function LinesView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LinesView.type;
        return _this;
    }
    LinesView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var lineDraw = this._updateLineDraw(data, seriesModel);
        var zlevel = seriesModel.get("zlevel");
        var trailLength = seriesModel.get([
            "effect",
            "trailLength"
        ]);
        var zr = api.getZr();
        // Avoid the drag cause ghost shadow
        // FIXME Better way ?
        // SVG doesn't support
        var isSvg = zr.painter.getType() === "svg";
        if (!isSvg) zr.painter.getLayer(zlevel).clear(true);
        // Config layer with motion blur
        if (this._lastZlevel != null && !isSvg) zr.configLayer(this._lastZlevel, {
            motionBlur: false
        });
        if (this._showEffect(seriesModel) && trailLength > 0) {
            if (!isSvg) zr.configLayer(zlevel, {
                motionBlur: true,
                lastFrameAlpha: Math.max(Math.min(trailLength / 10 + 0.9, 1), 0)
            });
        }
        lineDraw.updateData(data);
        var clipPath = seriesModel.get("clip", true) && (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel);
        if (clipPath) this.group.setClipPath(clipPath);
        else this.group.removeClipPath();
        this._lastZlevel = zlevel;
        this._finished = true;
    };
    LinesView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var lineDraw = this._updateLineDraw(data, seriesModel);
        lineDraw.incrementalPrepareUpdate(data);
        this._clearLayer(api);
        this._finished = false;
    };
    LinesView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        this._lineDraw.incrementalUpdate(taskParams, seriesModel.getData());
        this._finished = taskParams.end === seriesModel.getData().count();
    };
    LinesView.prototype.eachRendered = function(cb) {
        this._lineDraw && this._lineDraw.eachRendered(cb);
    };
    LinesView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var pipelineContext = seriesModel.pipelineContext;
        if (!this._finished || pipelineContext.large || pipelineContext.progressiveRender) // TODO Don't have to do update in large mode. Only do it when there are millions of data.
        return {
            update: true
        };
        else {
            // TODO Use same logic with ScatterView.
            // Manually update layout
            var res = (0, $e702d3171e9448b0$export$2e2bcd8739ae039).reset(seriesModel, ecModel, api);
            if (res.progress) res.progress({
                start: 0,
                end: data.count(),
                count: data.count()
            }, data);
            // Not in large mode
            this._lineDraw.updateLayout();
            this._clearLayer(api);
        }
    };
    LinesView.prototype._updateLineDraw = function(data, seriesModel) {
        var lineDraw = this._lineDraw;
        var hasEffect = this._showEffect(seriesModel);
        var isPolyline = !!seriesModel.get("polyline");
        var pipelineContext = seriesModel.pipelineContext;
        var isLargeDraw = pipelineContext.large;
        if (!lineDraw || hasEffect !== this._hasEffet || isPolyline !== this._isPolyline || isLargeDraw !== this._isLargeDraw) {
            if (lineDraw) lineDraw.remove();
            lineDraw = this._lineDraw = isLargeDraw ? new (0, $2f5f63360e8576db$export$2e2bcd8739ae039)() : new (0, $a2fd63a0fc11274a$export$2e2bcd8739ae039)(isPolyline ? hasEffect ? (0, $a16373b7bc6b0508$export$2e2bcd8739ae039) : (0, $bdfe7b18bcde1955$export$2e2bcd8739ae039) : hasEffect ? (0, $ac4f44aacfb7dba9$export$2e2bcd8739ae039) : (0, $9e0b5f801ab5090c$export$2e2bcd8739ae039));
            this._hasEffet = hasEffect;
            this._isPolyline = isPolyline;
            this._isLargeDraw = isLargeDraw;
        }
        this.group.add(lineDraw.group);
        return lineDraw;
    };
    LinesView.prototype._showEffect = function(seriesModel) {
        return !!seriesModel.get([
            "effect",
            "show"
        ]);
    };
    LinesView.prototype._clearLayer = function(api) {
        // Not use motion when dragging or zooming
        var zr = api.getZr();
        var isSvg = zr.painter.getType() === "svg";
        if (!isSvg && this._lastZlevel != null) zr.painter.getLayer(this._lastZlevel).clear(true);
    };
    LinesView.prototype.remove = function(ecModel, api) {
        this._lineDraw && this._lineDraw.remove();
        this._lineDraw = null;
        // Clear motion when lineDraw is removed
        this._clearLayer(api);
    };
    LinesView.prototype.dispose = function(ecModel, api) {
        this.remove(ecModel, api);
    };
    LinesView.type = "lines";
    return LinesView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $cefff1aea7415b28$export$2e2bcd8739ae039 = $cefff1aea7415b28$var$LinesView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $7abeccdc5e740e42$var$Uint32Arr = typeof Uint32Array === "undefined" ? Array : Uint32Array;
var $7abeccdc5e740e42$var$Float64Arr = typeof Float64Array === "undefined" ? Array : Float64Array;
function $7abeccdc5e740e42$var$compatEc2(seriesOpt) {
    var data = seriesOpt.data;
    if (data && data[0] && data[0][0] && data[0][0].coord) seriesOpt.data = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(data, function(itemOpt) {
        var coords = [
            itemOpt[0].coord,
            itemOpt[1].coord
        ];
        var target = {
            coords: coords
        };
        if (itemOpt[0].name) target.fromName = itemOpt[0].name;
        if (itemOpt[1].name) target.toName = itemOpt[1].name;
        return (0, $7a1bd9c2710fea0d$export$18aef43295bbe906)([
            target,
            itemOpt[0],
            itemOpt[1]
        ]);
    });
}
var $7abeccdc5e740e42$var$LinesSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LinesSeriesModel, _super);
    function LinesSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LinesSeriesModel.type;
        _this.visualStyleAccessPath = "lineStyle";
        _this.visualDrawType = "stroke";
        return _this;
    }
    LinesSeriesModel.prototype.init = function(option) {
        // The input data may be null/undefined.
        option.data = option.data || [];
        // Not using preprocessor because mergeOption may not have series.type
        $7abeccdc5e740e42$var$compatEc2(option);
        var result = this._processFlatCoordsArray(option.data);
        this._flatCoords = result.flatCoords;
        this._flatCoordsOffset = result.flatCoordsOffset;
        if (result.flatCoords) option.data = new Float32Array(result.count);
        _super.prototype.init.apply(this, arguments);
    };
    LinesSeriesModel.prototype.mergeOption = function(option) {
        $7abeccdc5e740e42$var$compatEc2(option);
        if (option.data) {
            // Only update when have option data to merge.
            var result = this._processFlatCoordsArray(option.data);
            this._flatCoords = result.flatCoords;
            this._flatCoordsOffset = result.flatCoordsOffset;
            if (result.flatCoords) option.data = new Float32Array(result.count);
        }
        _super.prototype.mergeOption.apply(this, arguments);
    };
    LinesSeriesModel.prototype.appendData = function(params) {
        var result = this._processFlatCoordsArray(params.data);
        if (result.flatCoords) {
            if (!this._flatCoords) {
                this._flatCoords = result.flatCoords;
                this._flatCoordsOffset = result.flatCoordsOffset;
            } else {
                this._flatCoords = (0, $7a1bd9c2710fea0d$export$4fd8af2c48c43416)(this._flatCoords, result.flatCoords);
                this._flatCoordsOffset = (0, $7a1bd9c2710fea0d$export$4fd8af2c48c43416)(this._flatCoordsOffset, result.flatCoordsOffset);
            }
            params.data = new Float32Array(result.count);
        }
        this.getRawData().appendData(params.data);
    };
    LinesSeriesModel.prototype._getCoordsFromItemModel = function(idx) {
        var itemModel = this.getData().getItemModel(idx);
        var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.getShallow("coords");
        return coords;
    };
    LinesSeriesModel.prototype.getLineCoordsCount = function(idx) {
        if (this._flatCoordsOffset) return this._flatCoordsOffset[idx * 2 + 1];
        else return this._getCoordsFromItemModel(idx).length;
    };
    LinesSeriesModel.prototype.getLineCoords = function(idx, out) {
        if (this._flatCoordsOffset) {
            var offset = this._flatCoordsOffset[idx * 2];
            var len = this._flatCoordsOffset[idx * 2 + 1];
            for(var i = 0; i < len; i++){
                out[i] = out[i] || [];
                out[i][0] = this._flatCoords[offset + i * 2];
                out[i][1] = this._flatCoords[offset + i * 2 + 1];
            }
            return len;
        } else {
            var coords = this._getCoordsFromItemModel(idx);
            for(var i = 0; i < coords.length; i++){
                out[i] = out[i] || [];
                out[i][0] = coords[i][0];
                out[i][1] = coords[i][1];
            }
            return coords.length;
        }
    };
    LinesSeriesModel.prototype._processFlatCoordsArray = function(data) {
        var startOffset = 0;
        if (this._flatCoords) startOffset = this._flatCoords.length;
        // Stored as a typed array. In format
        // Points Count(2) | x | y | x | y | Points Count(3) | x |  y | x | y | x | y |
        if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(data[0])) {
            var len = data.length;
            // Store offset and len of each segment
            var coordsOffsetAndLenStorage = new $7abeccdc5e740e42$var$Uint32Arr(len);
            var coordsStorage = new $7abeccdc5e740e42$var$Float64Arr(len);
            var coordsCursor = 0;
            var offsetCursor = 0;
            var dataCount = 0;
            for(var i = 0; i < len;){
                dataCount++;
                var count = data[i++];
                // Offset
                coordsOffsetAndLenStorage[offsetCursor++] = coordsCursor + startOffset;
                // Len
                coordsOffsetAndLenStorage[offsetCursor++] = count;
                for(var k = 0; k < count; k++){
                    var x = data[i++];
                    var y = data[i++];
                    coordsStorage[coordsCursor++] = x;
                    coordsStorage[coordsCursor++] = y;
                }
            }
            return {
                flatCoordsOffset: new Uint32Array(coordsOffsetAndLenStorage.buffer, 0, offsetCursor),
                flatCoords: coordsStorage,
                count: dataCount
            };
        }
        return {
            flatCoordsOffset: null,
            flatCoords: null,
            count: data.length
        };
    };
    LinesSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var CoordSys;
        var lineData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([
            "value"
        ], this);
        lineData.hasItemOption = false;
        lineData.initData(option.data, [], function(dataItem, dimName, dataIndex, dimIndex) {
            // dataItem is simply coords
            if (dataItem instanceof Array) return NaN;
            else {
                lineData.hasItemOption = true;
                var value = dataItem.value;
                if (value != null) return value instanceof Array ? value[dimIndex] : value;
            }
        });
        return lineData;
    };
    LinesSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var itemModel = data.getItemModel(dataIndex);
        var name = itemModel.get("name");
        if (name) return name;
        var fromName = itemModel.get("fromName");
        var toName = itemModel.get("toName");
        var nameArr = [];
        fromName != null && nameArr.push(fromName);
        toName != null && nameArr.push(toName);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
            name: nameArr.join(" > ")
        });
    };
    LinesSeriesModel.prototype.preventIncremental = function() {
        return !!this.get([
            "effect",
            "show"
        ]);
    };
    LinesSeriesModel.prototype.getProgressive = function() {
        var progressive = this.option.progressive;
        if (progressive == null) return this.option.large ? 1e4 : this.get("progressive");
        return progressive;
    };
    LinesSeriesModel.prototype.getProgressiveThreshold = function() {
        var progressiveThreshold = this.option.progressiveThreshold;
        if (progressiveThreshold == null) return this.option.large ? 2e4 : this.get("progressiveThreshold");
        return progressiveThreshold;
    };
    LinesSeriesModel.prototype.getZLevelKey = function() {
        var effectModel = this.getModel("effect");
        var trailLength = effectModel.get("trailLength");
        return this.getData().count() > this.getProgressiveThreshold() ? this.id : effectModel.get("show") && trailLength > 0 ? trailLength + "" : "";
    };
    LinesSeriesModel.type = "series.lines";
    LinesSeriesModel.dependencies = [
        "grid",
        "polar",
        "geo",
        "calendar"
    ];
    LinesSeriesModel.defaultOption = {
        coordinateSystem: "geo",
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        // Cartesian coordinate system
        xAxisIndex: 0,
        yAxisIndex: 0,
        symbol: [
            "none",
            "none"
        ],
        symbolSize: [
            10,
            10
        ],
        // Geo coordinate system
        geoIndex: 0,
        effect: {
            show: false,
            period: 4,
            constantSpeed: 0,
            symbol: "circle",
            symbolSize: 3,
            loop: true,
            trailLength: 0.2
        },
        large: false,
        // Available when large is true
        largeThreshold: 2000,
        polyline: false,
        clip: true,
        label: {
            show: false,
            position: "end"
        },
        lineStyle: {
            opacity: 0.5
        }
    };
    return LinesSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $7abeccdc5e740e42$export$2e2bcd8739ae039 = $7abeccdc5e740e42$var$LinesSeriesModel;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $111ea02a392b95a6$var$normalize(a) {
    if (!(a instanceof Array)) a = [
        a,
        a
    ];
    return a;
}
var $111ea02a392b95a6$var$linesVisual = {
    seriesType: "lines",
    reset: function(seriesModel) {
        var symbolType = $111ea02a392b95a6$var$normalize(seriesModel.get("symbol"));
        var symbolSize = $111ea02a392b95a6$var$normalize(seriesModel.get("symbolSize"));
        var data = seriesModel.getData();
        data.setVisual("fromSymbol", symbolType && symbolType[0]);
        data.setVisual("toSymbol", symbolType && symbolType[1]);
        data.setVisual("fromSymbolSize", symbolSize && symbolSize[0]);
        data.setVisual("toSymbolSize", symbolSize && symbolSize[1]);
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            var symbolType = $111ea02a392b95a6$var$normalize(itemModel.getShallow("symbol", true));
            var symbolSize = $111ea02a392b95a6$var$normalize(itemModel.getShallow("symbolSize", true));
            symbolType[0] && data.setItemVisual(idx, "fromSymbol", symbolType[0]);
            symbolType[1] && data.setItemVisual(idx, "toSymbol", symbolType[1]);
            symbolSize[0] && data.setItemVisual(idx, "fromSymbolSize", symbolSize[0]);
            symbolSize[1] && data.setItemVisual(idx, "toSymbolSize", symbolSize[1]);
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};
var $111ea02a392b95a6$export$2e2bcd8739ae039 = $111ea02a392b95a6$var$linesVisual;


function $52dd2448928cc7d8$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $cefff1aea7415b28$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $7abeccdc5e740e42$export$2e2bcd8739ae039));
    registers.registerLayout((0, $e702d3171e9448b0$export$2e2bcd8739ae039));
    registers.registerVisual((0, $111ea02a392b95a6$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 














function $6d3db85dae3a1192$export$eacefc55fad2867e(svg) {
    if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(svg)) {
        var parser = new DOMParser();
        svg = parser.parseFromString(svg, "text/xml");
    }
    var svgNode = svg;
    if (svgNode.nodeType === 9) svgNode = svgNode.firstChild;
    while(svgNode.nodeName.toLowerCase() !== "svg" || svgNode.nodeType !== 1)svgNode = svgNode.nextSibling;
    return svgNode;
}


var $ccaaa4a85c480645$var$nodeParsers;
var $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP = {
    "fill": "fill",
    "stroke": "stroke",
    "stroke-width": "lineWidth",
    "opacity": "opacity",
    "fill-opacity": "fillOpacity",
    "stroke-opacity": "strokeOpacity",
    "stroke-dasharray": "lineDash",
    "stroke-dashoffset": "lineDashOffset",
    "stroke-linecap": "lineCap",
    "stroke-linejoin": "lineJoin",
    "stroke-miterlimit": "miterLimit",
    "font-family": "fontFamily",
    "font-size": "fontSize",
    "font-style": "fontStyle",
    "font-weight": "fontWeight",
    "text-anchor": "textAlign",
    "visibility": "visibility",
    "display": "display"
};
var $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)($ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP);
var $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP = {
    "alignment-baseline": "textBaseline",
    "stop-color": "stopColor"
};
var $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)($ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP);
var $ccaaa4a85c480645$var$SVGParser = function() {
    function SVGParser() {
        this._defs = {};
        this._root = null;
    }
    SVGParser.prototype.parse = function(xml, opt) {
        opt = opt || {};
        var svg = (0, $6d3db85dae3a1192$export$eacefc55fad2867e)(xml);
        this._defsUsePending = [];
        var root = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        this._root = root;
        var named = [];
        var viewBox = svg.getAttribute("viewBox") || "";
        var width = parseFloat(svg.getAttribute("width") || opt.width);
        var height = parseFloat(svg.getAttribute("height") || opt.height);
        isNaN(width) && (width = null);
        isNaN(height) && (height = null);
        $ccaaa4a85c480645$var$parseAttributes(svg, root, null, true, false);
        var child = svg.firstChild;
        while(child){
            this._parseNode(child, root, named, null, false, false);
            child = child.nextSibling;
        }
        $ccaaa4a85c480645$var$applyDefs(this._defs, this._defsUsePending);
        this._defsUsePending = [];
        var viewBoxRect;
        var viewBoxTransform;
        if (viewBox) {
            var viewBoxArr = $ccaaa4a85c480645$var$splitNumberSequence(viewBox);
            if (viewBoxArr.length >= 4) viewBoxRect = {
                x: parseFloat(viewBoxArr[0] || 0),
                y: parseFloat(viewBoxArr[1] || 0),
                width: parseFloat(viewBoxArr[2]),
                height: parseFloat(viewBoxArr[3])
            };
        }
        if (viewBoxRect && width != null && height != null) {
            viewBoxTransform = $ccaaa4a85c480645$export$3e2db4420f14f50f(viewBoxRect, {
                x: 0,
                y: 0,
                width: width,
                height: height
            });
            if (!opt.ignoreViewBox) {
                var elRoot = root;
                root = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
                root.add(elRoot);
                elRoot.scaleX = elRoot.scaleY = viewBoxTransform.scale;
                elRoot.x = viewBoxTransform.x;
                elRoot.y = viewBoxTransform.y;
            }
        }
        if (!opt.ignoreRootClip && width != null && height != null) root.setClipPath(new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            shape: {
                x: 0,
                y: 0,
                width: width,
                height: height
            }
        }));
        return {
            root: root,
            width: width,
            height: height,
            viewBoxRect: viewBoxRect,
            viewBoxTransform: viewBoxTransform,
            named: named
        };
    };
    SVGParser.prototype._parseNode = function(xmlNode, parentGroup, named, namedFrom, isInDefs, isInText) {
        var nodeName = xmlNode.nodeName.toLowerCase();
        var el;
        var namedFromForSub = namedFrom;
        if (nodeName === "defs") isInDefs = true;
        if (nodeName === "text") isInText = true;
        if (nodeName === "defs" || nodeName === "switch") el = parentGroup;
        else {
            if (!isInDefs) {
                var parser_1 = $ccaaa4a85c480645$var$nodeParsers[nodeName];
                if (parser_1 && (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($ccaaa4a85c480645$var$nodeParsers, nodeName)) {
                    el = parser_1.call(this, xmlNode, parentGroup);
                    var nameAttr = xmlNode.getAttribute("name");
                    if (nameAttr) {
                        var newNamed = {
                            name: nameAttr,
                            namedFrom: null,
                            svgNodeTagLower: nodeName,
                            el: el
                        };
                        named.push(newNamed);
                        if (nodeName === "g") namedFromForSub = newNamed;
                    } else if (namedFrom) named.push({
                        name: namedFrom.name,
                        namedFrom: namedFrom,
                        svgNodeTagLower: nodeName,
                        el: el
                    });
                    parentGroup.add(el);
                }
            }
            var parser = $ccaaa4a85c480645$var$paintServerParsers[nodeName];
            if (parser && (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($ccaaa4a85c480645$var$paintServerParsers, nodeName)) {
                var def = parser.call(this, xmlNode);
                var id = xmlNode.getAttribute("id");
                if (id) this._defs[id] = def;
            }
        }
        if (el && el.isGroup) {
            var child = xmlNode.firstChild;
            while(child){
                if (child.nodeType === 1) this._parseNode(child, el, named, namedFromForSub, isInDefs, isInText);
                else if (child.nodeType === 3 && isInText) this._parseText(child, el);
                child = child.nextSibling;
            }
        }
    };
    SVGParser.prototype._parseText = function(xmlNode, parentGroup) {
        var text = new (0, $c9d5c769fe2f591f$export$2e2bcd8739ae039)({
            style: {
                text: xmlNode.textContent
            },
            silent: true,
            x: this._textX || 0,
            y: this._textY || 0
        });
        $ccaaa4a85c480645$var$inheritStyle(parentGroup, text);
        $ccaaa4a85c480645$var$parseAttributes(xmlNode, text, this._defsUsePending, false, false);
        $ccaaa4a85c480645$var$applyTextAlignment(text, parentGroup);
        var textStyle = text.style;
        var fontSize = textStyle.fontSize;
        if (fontSize && fontSize < 9) {
            textStyle.fontSize = 9;
            text.scaleX *= fontSize / 9;
            text.scaleY *= fontSize / 9;
        }
        var font = (textStyle.fontSize || textStyle.fontFamily) && [
            textStyle.fontStyle,
            textStyle.fontWeight,
            (textStyle.fontSize || 12) + "px",
            textStyle.fontFamily || "sans-serif"
        ].join(" ");
        textStyle.font = font;
        var rect = text.getBoundingRect();
        this._textX += rect.width;
        parentGroup.add(text);
        return text;
    };
    SVGParser.internalField = function() {
        $ccaaa4a85c480645$var$nodeParsers = {
            "g": function(xmlNode, parentGroup) {
                var g = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, g);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, g, this._defsUsePending, false, false);
                return g;
            },
            "rect": function(xmlNode, parentGroup) {
                var rect = new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, rect);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, rect, this._defsUsePending, false, false);
                rect.setShape({
                    x: parseFloat(xmlNode.getAttribute("x") || "0"),
                    y: parseFloat(xmlNode.getAttribute("y") || "0"),
                    width: parseFloat(xmlNode.getAttribute("width") || "0"),
                    height: parseFloat(xmlNode.getAttribute("height") || "0")
                });
                rect.silent = true;
                return rect;
            },
            "circle": function(xmlNode, parentGroup) {
                var circle = new (0, $1e68d8727773abb7$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, circle);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, circle, this._defsUsePending, false, false);
                circle.setShape({
                    cx: parseFloat(xmlNode.getAttribute("cx") || "0"),
                    cy: parseFloat(xmlNode.getAttribute("cy") || "0"),
                    r: parseFloat(xmlNode.getAttribute("r") || "0")
                });
                circle.silent = true;
                return circle;
            },
            "line": function(xmlNode, parentGroup) {
                var line = new (0, $7a316ae5ceff7b27$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, line);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, line, this._defsUsePending, false, false);
                line.setShape({
                    x1: parseFloat(xmlNode.getAttribute("x1") || "0"),
                    y1: parseFloat(xmlNode.getAttribute("y1") || "0"),
                    x2: parseFloat(xmlNode.getAttribute("x2") || "0"),
                    y2: parseFloat(xmlNode.getAttribute("y2") || "0")
                });
                line.silent = true;
                return line;
            },
            "ellipse": function(xmlNode, parentGroup) {
                var ellipse = new (0, $4a809f055a7e524c$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, ellipse);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, ellipse, this._defsUsePending, false, false);
                ellipse.setShape({
                    cx: parseFloat(xmlNode.getAttribute("cx") || "0"),
                    cy: parseFloat(xmlNode.getAttribute("cy") || "0"),
                    rx: parseFloat(xmlNode.getAttribute("rx") || "0"),
                    ry: parseFloat(xmlNode.getAttribute("ry") || "0")
                });
                ellipse.silent = true;
                return ellipse;
            },
            "polygon": function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute("points");
                var pointsArr;
                if (pointsStr) pointsArr = $ccaaa4a85c480645$var$parsePoints(pointsStr);
                var polygon = new (0, $51acf033123e1a30$export$2e2bcd8739ae039)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, polygon);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, polygon, this._defsUsePending, false, false);
                return polygon;
            },
            "polyline": function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute("points");
                var pointsArr;
                if (pointsStr) pointsArr = $ccaaa4a85c480645$var$parsePoints(pointsStr);
                var polyline = new (0, $d28119f30e6bb670$export$2e2bcd8739ae039)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, polyline);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, polyline, this._defsUsePending, false, false);
                return polyline;
            },
            "image": function(xmlNode, parentGroup) {
                var img = new (0, $86adec94217b86c6$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, img);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, img, this._defsUsePending, false, false);
                img.setStyle({
                    image: xmlNode.getAttribute("xlink:href") || xmlNode.getAttribute("href"),
                    x: +xmlNode.getAttribute("x"),
                    y: +xmlNode.getAttribute("y"),
                    width: +xmlNode.getAttribute("width"),
                    height: +xmlNode.getAttribute("height")
                });
                img.silent = true;
                return img;
            },
            "text": function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute("x") || "0";
                var y = xmlNode.getAttribute("y") || "0";
                var dx = xmlNode.getAttribute("dx") || "0";
                var dy = xmlNode.getAttribute("dy") || "0";
                this._textX = parseFloat(x) + parseFloat(dx);
                this._textY = parseFloat(y) + parseFloat(dy);
                var g = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, g);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                return g;
            },
            "tspan": function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute("x");
                var y = xmlNode.getAttribute("y");
                if (x != null) this._textX = parseFloat(x);
                if (y != null) this._textY = parseFloat(y);
                var dx = xmlNode.getAttribute("dx") || "0";
                var dy = xmlNode.getAttribute("dy") || "0";
                var g = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, g);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                this._textX += parseFloat(dx);
                this._textY += parseFloat(dy);
                return g;
            },
            "path": function(xmlNode, parentGroup) {
                var d = xmlNode.getAttribute("d") || "";
                var path = (0, $15b38920672b9006$export$ae5b259626f00aeb)(d);
                $ccaaa4a85c480645$var$inheritStyle(parentGroup, path);
                $ccaaa4a85c480645$var$parseAttributes(xmlNode, path, this._defsUsePending, false, false);
                path.silent = true;
                return path;
            }
        };
    }();
    return SVGParser;
}();
var $ccaaa4a85c480645$var$paintServerParsers = {
    "lineargradient": function(xmlNode) {
        var x1 = parseInt(xmlNode.getAttribute("x1") || "0", 10);
        var y1 = parseInt(xmlNode.getAttribute("y1") || "0", 10);
        var x2 = parseInt(xmlNode.getAttribute("x2") || "10", 10);
        var y2 = parseInt(xmlNode.getAttribute("y2") || "0", 10);
        var gradient = new (0, $cf44c01491b58e53$export$2e2bcd8739ae039)(x1, y1, x2, y2);
        $ccaaa4a85c480645$var$parsePaintServerUnit(xmlNode, gradient);
        $ccaaa4a85c480645$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    },
    "radialgradient": function(xmlNode) {
        var cx = parseInt(xmlNode.getAttribute("cx") || "0", 10);
        var cy = parseInt(xmlNode.getAttribute("cy") || "0", 10);
        var r = parseInt(xmlNode.getAttribute("r") || "0", 10);
        var gradient = new (0, $cd2ee2ba32bb26c3$export$2e2bcd8739ae039)(cx, cy, r);
        $ccaaa4a85c480645$var$parsePaintServerUnit(xmlNode, gradient);
        $ccaaa4a85c480645$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    }
};
function $ccaaa4a85c480645$var$parsePaintServerUnit(xmlNode, gradient) {
    var gradientUnits = xmlNode.getAttribute("gradientUnits");
    if (gradientUnits === "userSpaceOnUse") gradient.global = true;
}
function $ccaaa4a85c480645$var$parseGradientColorStops(xmlNode, gradient) {
    var stop = xmlNode.firstChild;
    while(stop){
        if (stop.nodeType === 1 && stop.nodeName.toLocaleLowerCase() === "stop") {
            var offsetStr = stop.getAttribute("offset");
            var offset = void 0;
            if (offsetStr && offsetStr.indexOf("%") > 0) offset = parseInt(offsetStr, 10) / 100;
            else if (offsetStr) offset = parseFloat(offsetStr);
            else offset = 0;
            var styleVals = {};
            $ccaaa4a85c480645$var$parseInlineStyle(stop, styleVals, styleVals);
            var stopColor = styleVals.stopColor || stop.getAttribute("stop-color") || "#000000";
            gradient.colorStops.push({
                offset: offset,
                color: stopColor
            });
        }
        stop = stop.nextSibling;
    }
}
function $ccaaa4a85c480645$var$inheritStyle(parent, child) {
    if (parent && parent.__inheritedStyle) {
        if (!child.__inheritedStyle) child.__inheritedStyle = {};
        (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(child.__inheritedStyle, parent.__inheritedStyle);
    }
}
function $ccaaa4a85c480645$var$parsePoints(pointsString) {
    var list = $ccaaa4a85c480645$var$splitNumberSequence(pointsString);
    var points = [];
    for(var i = 0; i < list.length; i += 2){
        var x = parseFloat(list[i]);
        var y = parseFloat(list[i + 1]);
        points.push([
            x,
            y
        ]);
    }
    return points;
}
function $ccaaa4a85c480645$var$parseAttributes(xmlNode, el, defsUsePending, onlyInlineStyle, isTextGroup) {
    var disp = el;
    var inheritedStyle = disp.__inheritedStyle = disp.__inheritedStyle || {};
    var selfStyle = {};
    if (xmlNode.nodeType === 1) {
        $ccaaa4a85c480645$var$parseTransformAttribute(xmlNode, el);
        $ccaaa4a85c480645$var$parseInlineStyle(xmlNode, inheritedStyle, selfStyle);
        if (!onlyInlineStyle) $ccaaa4a85c480645$var$parseAttributeStyle(xmlNode, inheritedStyle, selfStyle);
    }
    disp.style = disp.style || {};
    if (inheritedStyle.fill != null) disp.style.fill = $ccaaa4a85c480645$var$getFillStrokeStyle(disp, "fill", inheritedStyle.fill, defsUsePending);
    if (inheritedStyle.stroke != null) disp.style.stroke = $ccaaa4a85c480645$var$getFillStrokeStyle(disp, "stroke", inheritedStyle.stroke, defsUsePending);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "lineWidth",
        "opacity",
        "fillOpacity",
        "strokeOpacity",
        "miterLimit",
        "fontSize"
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = parseFloat(inheritedStyle[propName]);
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "lineDashOffset",
        "lineCap",
        "lineJoin",
        "fontWeight",
        "fontFamily",
        "fontStyle",
        "textAlign"
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = inheritedStyle[propName];
    });
    if (isTextGroup) disp.__selfStyle = selfStyle;
    if (inheritedStyle.lineDash) disp.style.lineDash = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)($ccaaa4a85c480645$var$splitNumberSequence(inheritedStyle.lineDash), function(str) {
        return parseFloat(str);
    });
    if (inheritedStyle.visibility === "hidden" || inheritedStyle.visibility === "collapse") disp.invisible = true;
    if (inheritedStyle.display === "none") disp.ignore = true;
}
function $ccaaa4a85c480645$var$applyTextAlignment(text, parentGroup) {
    var parentSelfStyle = parentGroup.__selfStyle;
    if (parentSelfStyle) {
        var textBaseline = parentSelfStyle.textBaseline;
        var zrTextBaseline = textBaseline;
        if (!textBaseline || textBaseline === "auto") zrTextBaseline = "alphabetic";
        else if (textBaseline === "baseline") zrTextBaseline = "alphabetic";
        else if (textBaseline === "before-edge" || textBaseline === "text-before-edge") zrTextBaseline = "top";
        else if (textBaseline === "after-edge" || textBaseline === "text-after-edge") zrTextBaseline = "bottom";
        else if (textBaseline === "central" || textBaseline === "mathematical") zrTextBaseline = "middle";
        text.style.textBaseline = zrTextBaseline;
    }
    var parentInheritedStyle = parentGroup.__inheritedStyle;
    if (parentInheritedStyle) {
        var textAlign = parentInheritedStyle.textAlign;
        var zrTextAlign = textAlign;
        if (textAlign) {
            if (textAlign === "middle") zrTextAlign = "center";
            text.style.textAlign = zrTextAlign;
        }
    }
}
var $ccaaa4a85c480645$var$urlRegex = /^url\(\s*#(.*?)\)/;
function $ccaaa4a85c480645$var$getFillStrokeStyle(el, method, str, defsUsePending) {
    var urlMatch = str && str.match($ccaaa4a85c480645$var$urlRegex);
    if (urlMatch) {
        var url = (0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(urlMatch[1]);
        defsUsePending.push([
            el,
            method,
            url
        ]);
        return;
    }
    if (str === "none") str = null;
    return str;
}
function $ccaaa4a85c480645$var$applyDefs(defs, defsUsePending) {
    for(var i = 0; i < defsUsePending.length; i++){
        var item = defsUsePending[i];
        item[0].style[item[1]] = defs[item[2]];
    }
}
var $ccaaa4a85c480645$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $ccaaa4a85c480645$var$splitNumberSequence(rawStr) {
    return rawStr.match($ccaaa4a85c480645$var$numberReg) || [];
}
var $ccaaa4a85c480645$var$transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.eE,]*)\)/g;
var $ccaaa4a85c480645$var$DEGREE_TO_ANGLE = Math.PI / 180;
function $ccaaa4a85c480645$var$parseTransformAttribute(xmlNode, node) {
    var transform = xmlNode.getAttribute("transform");
    if (transform) {
        transform = transform.replace(/,/g, " ");
        var transformOps_1 = [];
        var mt = null;
        transform.replace($ccaaa4a85c480645$var$transformRegex, function(str, type, value) {
            transformOps_1.push(type, value);
            return "";
        });
        for(var i = transformOps_1.length - 1; i > 0; i -= 2){
            var value = transformOps_1[i];
            var type = transformOps_1[i - 1];
            var valueArr = $ccaaa4a85c480645$var$splitNumberSequence(value);
            mt = mt || $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            switch(type){
                case "translate":
                    $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || "0")
                    ]);
                    break;
                case "scale":
                    $f41ebb9dd60b55b4$export$dcdf75081b88279d(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || valueArr[0])
                    ]);
                    break;
                case "rotate":
                    $f41ebb9dd60b55b4$export$bb628a54ab399bc9(mt, mt, -parseFloat(valueArr[0]) * $ccaaa4a85c480645$var$DEGREE_TO_ANGLE, [
                        parseFloat(valueArr[1] || "0"),
                        parseFloat(valueArr[2] || "0")
                    ]);
                    break;
                case "skewX":
                    var sx = Math.tan(parseFloat(valueArr[0]) * $ccaaa4a85c480645$var$DEGREE_TO_ANGLE);
                    $f41ebb9dd60b55b4$export$6e3a27864ab166fe(mt, [
                        1,
                        0,
                        sx,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case "skewY":
                    var sy = Math.tan(parseFloat(valueArr[0]) * $ccaaa4a85c480645$var$DEGREE_TO_ANGLE);
                    $f41ebb9dd60b55b4$export$6e3a27864ab166fe(mt, [
                        1,
                        sy,
                        0,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case "matrix":
                    mt[0] = parseFloat(valueArr[0]);
                    mt[1] = parseFloat(valueArr[1]);
                    mt[2] = parseFloat(valueArr[2]);
                    mt[3] = parseFloat(valueArr[3]);
                    mt[4] = parseFloat(valueArr[4]);
                    mt[5] = parseFloat(valueArr[5]);
                    break;
            }
        }
        node.setLocalTransform(mt);
    }
}
var $ccaaa4a85c480645$var$styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
function $ccaaa4a85c480645$var$parseInlineStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    var style = xmlNode.getAttribute("style");
    if (!style) return;
    $ccaaa4a85c480645$var$styleRegex.lastIndex = 0;
    var styleRegResult;
    while((styleRegResult = $ccaaa4a85c480645$var$styleRegex.exec(style)) != null){
        var svgStlAttr = styleRegResult[1];
        var zrInheritableStlAttr = (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrInheritableStlAttr) inheritableStyleResult[zrInheritableStlAttr] = styleRegResult[2];
        var zrSelfStlAttr = (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrSelfStlAttr) selfStyleResult[zrSelfStlAttr] = styleRegResult[2];
    }
}
function $ccaaa4a85c480645$var$parseAttributeStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    for(var i = 0; i < $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) inheritableStyleResult[$ccaaa4a85c480645$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
    for(var i = 0; i < $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) selfStyleResult[$ccaaa4a85c480645$var$SELF_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
}
function $ccaaa4a85c480645$export$3e2db4420f14f50f(viewBoxRect, boundingRect) {
    var scaleX = boundingRect.width / viewBoxRect.width;
    var scaleY = boundingRect.height / viewBoxRect.height;
    var scale = Math.min(scaleX, scaleY);
    return {
        scale: scale,
        x: -(viewBoxRect.x + viewBoxRect.width / 2) * scale + (boundingRect.x + boundingRect.width / 2),
        y: -(viewBoxRect.y + viewBoxRect.height / 2) * scale + (boundingRect.y + boundingRect.height / 2)
    };
}
function $ccaaa4a85c480645$export$1919f5101c220601(xml, opt) {
    var parser = new $ccaaa4a85c480645$var$SVGParser();
    return parser.parse(xml, opt);
}







/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $b4726ec5f917394d$var$EPSILON = 1e-8;
function $b4726ec5f917394d$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $b4726ec5f917394d$var$EPSILON;
}
function $b4726ec5f917394d$export$8893e2b90ba10d92(points, x, y) {
    var w = 0;
    var p = points[0];
    if (!p) return false;
    for(var i = 1; i < points.length; i++){
        var p2 = points[i];
        w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(p[0], p[1], p2[0], p2[1], x, y);
        p = p2;
    }
    var p0 = points[0];
    if (!$b4726ec5f917394d$var$isAroundEqual(p[0], p0[0]) || !$b4726ec5f917394d$var$isAroundEqual(p[1], p0[1])) w += (0, $e1acc0b10546155f$export$2e2bcd8739ae039)(p[0], p[1], p0[0], p0[1], x, y);
    return w !== 0;
}




var $00e94d08c93517b6$var$TMP_TRANSFORM = [];
function $00e94d08c93517b6$var$transformPoints(points, transform) {
    for(var p = 0; p < points.length; p++)$6de594cf8ac295ff$export$9f9dcb98c894b623(points[p], points[p], transform);
}
function $00e94d08c93517b6$var$updateBBoxFromPoints(points, min, max, projection) {
    for(var i = 0; i < points.length; i++){
        var p = points[i];
        if (projection) // projection may return null point.
        p = projection.project(p);
        if (p && isFinite(p[0]) && isFinite(p[1])) {
            $6de594cf8ac295ff$export$96ec731ed4dcb222(min, min, p);
            $6de594cf8ac295ff$export$8960430cfd85939f(max, max, p);
        }
    }
}
function $00e94d08c93517b6$var$centroid(points) {
    var signedArea = 0;
    var cx = 0;
    var cy = 0;
    var len = points.length;
    var x0 = points[len - 1][0];
    var y0 = points[len - 1][1];
    // Polygon should been closed.
    for(var i = 0; i < len; i++){
        var x1 = points[i][0];
        var y1 = points[i][1];
        var a = x0 * y1 - x1 * y0;
        signedArea += a;
        cx += (x0 + x1) * a;
        cy += (y0 + y1) * a;
        x0 = x1;
        y0 = y1;
    }
    return signedArea ? [
        cx / signedArea / 3,
        cy / signedArea / 3,
        signedArea
    ] : [
        points[0][0] || 0,
        points[0][1] || 0
    ];
}
var $00e94d08c93517b6$export$b1f97c3099fc6872 = /** @class */ function() {
    function Region(name) {
        this.name = name;
    }
    Region.prototype.setCenter = function(center) {
        this._center = center;
    };
    /**
   * Get center point in data unit. That is,
   * for GeoJSONRegion, the unit is lat/lng,
   * for GeoSVGRegion, the unit is SVG local coord.
   */ Region.prototype.getCenter = function() {
        var center = this._center;
        if (!center) // In most cases there are no need to calculate this center.
        // So calculate only when called.
        center = this._center = this.calcCenter();
        return center;
    };
    return Region;
}();
var $00e94d08c93517b6$export$91e20b0f72443753 = /** @class */ function() {
    function GeoJSONPolygonGeometry(exterior, interiors) {
        this.type = "polygon";
        this.exterior = exterior;
        this.interiors = interiors;
    }
    return GeoJSONPolygonGeometry;
}();
var $00e94d08c93517b6$export$335807c9e785d92c = /** @class */ function() {
    function GeoJSONLineStringGeometry(points) {
        this.type = "linestring";
        this.points = points;
    }
    return GeoJSONLineStringGeometry;
}();
var $00e94d08c93517b6$export$ee84fcb463f24b3d = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GeoJSONRegion, _super);
    function GeoJSONRegion(name, geometries, cp) {
        var _this = _super.call(this, name) || this;
        _this.type = "geoJSON";
        _this.geometries = geometries;
        _this._center = cp && [
            cp[0],
            cp[1]
        ];
        return _this;
    }
    GeoJSONRegion.prototype.calcCenter = function() {
        var geometries = this.geometries;
        var largestGeo;
        var largestGeoSize = 0;
        for(var i = 0; i < geometries.length; i++){
            var geo = geometries[i];
            var exterior = geo.exterior;
            // Simple trick to use points count instead of polygon area as region size.
            // Ignore linestring
            var size = exterior && exterior.length;
            if (size > largestGeoSize) {
                largestGeo = geo;
                largestGeoSize = size;
            }
        }
        if (largestGeo) return $00e94d08c93517b6$var$centroid(largestGeo.exterior);
        // from bounding rect by default.
        var rect = this.getBoundingRect();
        return [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    };
    GeoJSONRegion.prototype.getBoundingRect = function(projection) {
        var rect = this._rect;
        // Always recalculate if using projection.
        if (rect && !projection) return rect;
        var min = [
            Infinity,
            Infinity
        ];
        var max = [
            -Infinity,
            -Infinity
        ];
        var geometries = this.geometries;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geometries, function(geo) {
            if (geo.type === "polygon") // Doesn't consider hole
            $00e94d08c93517b6$var$updateBBoxFromPoints(geo.exterior, min, max, projection);
            else (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geo.points, function(points) {
                $00e94d08c93517b6$var$updateBBoxFromPoints(points, min, max, projection);
            });
        });
        // Normalie invalid bounding.
        if (!(isFinite(min[0]) && isFinite(min[1]) && isFinite(max[0]) && isFinite(max[1]))) min[0] = min[1] = max[0] = max[1] = 0;
        rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
        if (!projection) this._rect = rect;
        return rect;
    };
    GeoJSONRegion.prototype.contain = function(coord) {
        var rect = this.getBoundingRect();
        var geometries = this.geometries;
        if (!rect.contain(coord[0], coord[1])) return false;
        loopGeo: for(var i = 0, len = geometries.length; i < len; i++){
            var geo = geometries[i];
            // Only support polygon.
            if (geo.type !== "polygon") continue;
            var exterior = geo.exterior;
            var interiors = geo.interiors;
            if ($b4726ec5f917394d$export$8893e2b90ba10d92(exterior, coord[0], coord[1])) {
                // Not in the region if point is in the hole.
                for(var k = 0; k < (interiors ? interiors.length : 0); k++){
                    if ($b4726ec5f917394d$export$8893e2b90ba10d92(interiors[k], coord[0], coord[1])) continue loopGeo;
                }
                return true;
            }
        }
        return false;
    };
    /**
   * Transform the raw coords to target bounding.
   * @param x
   * @param y
   * @param width
   * @param height
   */ GeoJSONRegion.prototype.transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var aspect = rect.width / rect.height;
        if (!width) width = aspect * height;
        else if (!height) height = width / aspect;
        var target = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
        var transform = rect.calculateTransform(target);
        var geometries = this.geometries;
        for(var i = 0; i < geometries.length; i++){
            var geo = geometries[i];
            if (geo.type === "polygon") {
                $00e94d08c93517b6$var$transformPoints(geo.exterior, transform);
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geo.interiors, function(interior) {
                    $00e94d08c93517b6$var$transformPoints(interior, transform);
                });
            } else (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geo.points, function(points) {
                $00e94d08c93517b6$var$transformPoints(points, transform);
            });
        }
        rect = this._rect;
        rect.copy(target);
        // Update center
        this._center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    };
    GeoJSONRegion.prototype.cloneShallow = function(name) {
        name == null && (name = this.name);
        var newRegion = new GeoJSONRegion(name, this.geometries, this._center);
        newRegion._rect = this._rect;
        newRegion.transformTo = null; // Simply avoid to be called.
        return newRegion;
    };
    return GeoJSONRegion;
}($00e94d08c93517b6$export$b1f97c3099fc6872);
var $00e94d08c93517b6$export$5f3d89e7254f3e69 = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GeoSVGRegion, _super);
    function GeoSVGRegion(name, elOnlyForCalculate) {
        var _this = _super.call(this, name) || this;
        _this.type = "geoSVG";
        _this._elOnlyForCalculate = elOnlyForCalculate;
        return _this;
    }
    GeoSVGRegion.prototype.calcCenter = function() {
        var el = this._elOnlyForCalculate;
        var rect = el.getBoundingRect();
        var center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
        var mat = $f41ebb9dd60b55b4$export$f0954fd7d5368655($00e94d08c93517b6$var$TMP_TRANSFORM);
        var target = el;
        while(target && !target.isGeoSVGGraphicRoot){
            $f41ebb9dd60b55b4$export$6e3a27864ab166fe(mat, target.getLocalTransform(), mat);
            target = target.parent;
        }
        $f41ebb9dd60b55b4$export$6897c284b6f9f4dc(mat, mat);
        $6de594cf8ac295ff$export$9f9dcb98c894b623(center, center, mat);
        return center;
    };
    return GeoSVGRegion;
}($00e94d08c93517b6$export$b1f97c3099fc6872);


/**
 * "region available" means that: enable users to set attribute `name="xxx"` on those tags
 * to make it be a region.
 * 1. region styles and its label styles can be defined in echarts opton:
 * ```js
 * geo: {
 *     regions: [{
 *         name: 'xxx',
 *         itemStyle: { ... },
 *         label: { ... }
 *     }, {
 *         ...
 *     },
 *     ...]
 * };
 * ```
 * 2. name can be duplicated in different SVG tag. All of the tags with the same name share
 * a region option. For exampel if there are two <path> representing two lung lobes. They have
 * no common parents but both of them need to display label "lung" inside.
 */ var $decc9bf1380d61c0$var$REGION_AVAILABLE_SVG_TAG_MAP = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)([
    "rect",
    "circle",
    "line",
    "ellipse",
    "polygon",
    "polyline",
    "path",
    // <text> <tspan> are also enabled because some SVG might paint text itself,
    // but still need to trigger events or tooltip.
    "text",
    "tspan",
    // <g> is also enabled because this case: if multiple tags share one name
    // and need label displayed, every tags will display the name, which is not
    // expected. So we can put them into a <g name="xxx">. Thereby only one label
    // displayed and located based on the bounding rect of the <g>.
    "g"
]);
var $decc9bf1380d61c0$export$be52c950efae1f84 = /** @class */ function() {
    function GeoSVGResource(mapName, svg) {
        this.type = "geoSVG";
        // All used graphics. key: hostKey, value: root
        this._usedGraphicMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        // All unused graphics.
        this._freedGraphics = [];
        this._mapName = mapName;
        // Only perform parse to XML object here, which might be time
        // consiming for large SVG.
        // Although convert XML to zrender element is also time consiming,
        // if we do it here, the clone of zrender elements has to be
        // required. So we do it once for each geo instance, util real
        // performance issues call for optimizing it.
        this._parsedXML = (0, $6d3db85dae3a1192$export$eacefc55fad2867e)(svg);
    }
    GeoSVGResource.prototype.load = function() {
        // In the "load" stage, graphic need to be built to
        // get boundingRect for geo coordinate system.
        var firstGraphic = this._firstGraphic;
        // Create the return data structure only when first graphic created.
        // Because they will be used in geo coordinate system update stage,
        // and `regions` will be mounted at `geo` coordinate system,
        // in which there is no "view" info, so that it should better not to
        // make references to graphic elements.
        if (!firstGraphic) {
            firstGraphic = this._firstGraphic = this._buildGraphic(this._parsedXML);
            this._freedGraphics.push(firstGraphic);
            this._boundingRect = this._firstGraphic.boundingRect.clone();
            // PENDING: `nameMap` will not be supported until some real requirement come.
            // if (nameMap) {
            //     named = applyNameMap(named, nameMap);
            // }
            var _a = $decc9bf1380d61c0$var$createRegions(firstGraphic.named), regions = _a.regions, regionsMap = _a.regionsMap;
            this._regions = regions;
            this._regionsMap = regionsMap;
        }
        return {
            boundingRect: this._boundingRect,
            regions: this._regions,
            regionsMap: this._regionsMap
        };
    };
    GeoSVGResource.prototype._buildGraphic = function(svgXML) {
        var result;
        var rootFromParse;
        try {
            result = svgXML && (0, $ccaaa4a85c480645$export$1919f5101c220601)(svgXML, {
                ignoreViewBox: true,
                ignoreRootClip: true
            }) || {};
            rootFromParse = result.root;
            (0, $7a1bd9c2710fea0d$export$a7a9523472993e97)(rootFromParse != null);
        } catch (e) {
            throw new Error("Invalid svg format\n" + e.message);
        }
        // Note: we keep the covenant that the root has no transform. So always add an extra root.
        var root = new (0, $7ef7583d8302ffce$export$2e2bcd8739ae039)();
        root.add(rootFromParse);
        root.isGeoSVGGraphicRoot = true;
        // [THE_RULE_OF_VIEWPORT_AND_VIEWBOX]
        //
        // Consider: `<svg width="..." height="..." viewBox="...">`
        // - the `width/height` we call it `svgWidth/svgHeight` for short.
        // - `(0, 0, svgWidth, svgHeight)` defines the viewport of the SVG, or say,
        //   "viewport boundingRect", or `boundingRect` for short.
        // - `viewBox` defines the transform from the real content ot the viewport.
        //   `viewBox` has the same unit as the content of SVG.
        //   If `viewBox` exists, a transform is defined, so the unit of `svgWidth/svgHeight` become
        //   different from the content of SVG. Otherwise, they are the same.
        //
        // If both `svgWidth/svgHeight/viewBox` are specified in a SVG file, the transform rule will be:
        // 0. `boundingRect` is `(0, 0, svgWidth, svgHeight)`. Set it to Geo['_rect'] (View['_rect']).
        // 1. Make a transform from `viewBox` to `boundingRect`.
        //    Note: only support `preserveAspectRatio 'xMidYMid'` here. That is, this transform will preserve
        //    the aspect ratio.
        // 2. Make a transform from boundingRect to Geo['_viewRect'] (View['_viewRect'])
        //    (`Geo`/`View` will do this job).
        //    Note: this transform might not preserve aspect radio, which depending on how users specify
        //    viewRect in echarts option (e.g., `geo.left/top/width/height` will not preserve aspect ratio,
        //    but `geo.layoutCenter/layoutSize` will preserve aspect ratio).
        //
        // If `svgWidth/svgHeight` not specified, we use `viewBox` as the `boundingRect` to make the SVG
        // layout look good.
        //
        // If neither `svgWidth/svgHeight` nor `viewBox` are not specified, we calculate the boundingRect
        // of the SVG content and use them to make SVG layout look good.
        var svgWidth = result.width;
        var svgHeight = result.height;
        var viewBoxRect = result.viewBoxRect;
        var boundingRect = this._boundingRect;
        if (!boundingRect) {
            var bRectX = void 0;
            var bRectY = void 0;
            var bRectWidth = void 0;
            var bRectHeight = void 0;
            if (svgWidth != null) {
                bRectX = 0;
                bRectWidth = svgWidth;
            } else if (viewBoxRect) {
                bRectX = viewBoxRect.x;
                bRectWidth = viewBoxRect.width;
            }
            if (svgHeight != null) {
                bRectY = 0;
                bRectHeight = svgHeight;
            } else if (viewBoxRect) {
                bRectY = viewBoxRect.y;
                bRectHeight = viewBoxRect.height;
            }
            // If both viewBox and svgWidth/svgHeight not specified,
            // we have to determine how to layout those element to make them look good.
            if (bRectX == null || bRectY == null) {
                var calculatedBoundingRect = rootFromParse.getBoundingRect();
                if (bRectX == null) {
                    bRectX = calculatedBoundingRect.x;
                    bRectWidth = calculatedBoundingRect.width;
                }
                if (bRectY == null) {
                    bRectY = calculatedBoundingRect.y;
                    bRectHeight = calculatedBoundingRect.height;
                }
            }
            boundingRect = this._boundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(bRectX, bRectY, bRectWidth, bRectHeight);
        }
        if (viewBoxRect) {
            var viewBoxTransform = (0, $ccaaa4a85c480645$export$3e2db4420f14f50f)(viewBoxRect, boundingRect);
            // Only support `preserveAspectRatio 'xMidYMid'`
            rootFromParse.scaleX = rootFromParse.scaleY = viewBoxTransform.scale;
            rootFromParse.x = viewBoxTransform.x;
            rootFromParse.y = viewBoxTransform.y;
        }
        // SVG needs to clip based on `viewBox`. And some SVG files really rely on this feature.
        // They do not strictly confine all of the content inside a display rect, but deliberately
        // use a `viewBox` to define a displayable rect.
        // PENDING:
        // The drawback of the `setClipPath` here is: the region label (genereted by echarts) near the
        // edge might also be clipped, because region labels are put as `textContent` of the SVG path.
        root.setClipPath(new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            shape: boundingRect.plain()
        }));
        var named = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(result.named, function(namedItem) {
            if ($decc9bf1380d61c0$var$REGION_AVAILABLE_SVG_TAG_MAP.get(namedItem.svgNodeTagLower) != null) {
                named.push(namedItem);
                $decc9bf1380d61c0$var$setSilent(namedItem.el);
            }
        });
        return {
            root: root,
            boundingRect: boundingRect,
            named: named
        };
    };
    /**
   * Consider:
   * (1) One graphic element can not be shared by different `geoView` running simultaneously.
   *     Notice, also need to consider multiple echarts instances share a `mapRecord`.
   * (2) Converting SVG to graphic elements is time consuming.
   * (3) In the current architecture, `load` should be called frequently to get boundingRect,
   *     and it is called without view info.
   * So we maintain graphic elements in this module, and enables `view` to use/return these
   * graphics from/to the pool with it's uid.
   */ GeoSVGResource.prototype.useGraphic = function(hostKey /* , nameMap: NameMap */ ) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) return svgGraphic;
        svgGraphic = this._freedGraphics.pop() || this._buildGraphic(this._parsedXML);
        usedRootMap.set(hostKey, svgGraphic);
        // PENDING: `nameMap` will not be supported until some real requirement come.
        // `nameMap` can only be obtained from echarts option.
        // The original `named` must not be modified.
        // if (nameMap) {
        //     svgGraphic = extend({}, svgGraphic);
        //     svgGraphic.named = applyNameMap(svgGraphic.named, nameMap);
        // }
        return svgGraphic;
    };
    GeoSVGResource.prototype.freeGraphic = function(hostKey) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) {
            usedRootMap.removeKey(hostKey);
            this._freedGraphics.push(svgGraphic);
        }
    };
    return GeoSVGResource;
}();
function $decc9bf1380d61c0$var$setSilent(el) {
    // Only named element has silent: false, other elements should
    // act as background and has no user interaction.
    el.silent = false;
    // text|tspan will be converted to group.
    if (el.isGroup) el.traverse(function(child) {
        child.silent = false;
    });
}
function $decc9bf1380d61c0$var$createRegions(named) {
    var regions = [];
    var regionsMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    // Create resions only for the first graphic.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(named, function(namedItem) {
        // Region has feature to calculate center for tooltip or other features.
        // If there is a <g name="xxx">, the center should be the center of the
        // bounding rect of the g.
        if (namedItem.namedFrom != null) return;
        var region = new (0, $00e94d08c93517b6$export$5f3d89e7254f3e69)(namedItem.name, namedItem.el);
        // PENDING: if `nameMap` supported, this region can not be mounted on
        // `this`, but can only be created each time `load()` called.
        regions.push(region);
        // PENDING: if multiple tag named with the same name, only one will be
        // found by `_regionsMap`. `_regionsMap` is used to find a coordinate
        // by name. We use `region.getCenter()` as the coordinate.
        regionsMap.set(namedItem.name, region);
    });
    return {
        regions: regions,
        regionsMap: regionsMap
    };
} // PENDING: `nameMap` will not be supported until some real requirement come.
 // /**
 //  * Use the alias in geoNameMap.
 //  * The input `named` must not be modified.
 //  */
 // function applyNameMap(
 //     named: GeoSVGGraphicRecord['named'],
 //     nameMap: NameMap
 // ): GeoSVGGraphicRecord['named'] {
 //     const result = [] as GeoSVGGraphicRecord['named'];
 //     for (let i = 0; i < named.length; i++) {
 //         let regionGraphic = named[i];
 //         const name = regionGraphic.name;
 //         if (nameMap && nameMap.hasOwnProperty(name)) {
 //             regionGraphic = extend({}, regionGraphic);
 //             regionGraphic.name = name;
 //         }
 //         result.push(regionGraphic);
 //     }
 //     return result;
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parse and decode geo json
 */ 

function $1a1de70a2b6a5dc5$var$decode(json) {
    if (!json.UTF8Encoding) return json;
    var jsonCompressed = json;
    var encodeScale = jsonCompressed.UTF8Scale;
    if (encodeScale == null) encodeScale = 1024;
    var features = jsonCompressed.features;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(features, function(feature) {
        var geometry = feature.geometry;
        var encodeOffsets = geometry.encodeOffsets;
        var coordinates = geometry.coordinates;
        // Geometry may be appeded manually in the script after json loaded.
        // In this case this geometry is usually not encoded.
        if (!encodeOffsets) return;
        switch(geometry.type){
            case "LineString":
                geometry.coordinates = $1a1de70a2b6a5dc5$var$decodeRing(coordinates, encodeOffsets, encodeScale);
                break;
            case "Polygon":
                $1a1de70a2b6a5dc5$var$decodeRings(coordinates, encodeOffsets, encodeScale);
                break;
            case "MultiLineString":
                $1a1de70a2b6a5dc5$var$decodeRings(coordinates, encodeOffsets, encodeScale);
                break;
            case "MultiPolygon":
                $7a1bd9c2710fea0d$export$79b2f7037acddd43(coordinates, function(rings, idx) {
                    return $1a1de70a2b6a5dc5$var$decodeRings(rings, encodeOffsets[idx], encodeScale);
                });
        }
    });
    // Has been decoded
    jsonCompressed.UTF8Encoding = false;
    return jsonCompressed;
}
function $1a1de70a2b6a5dc5$var$decodeRings(rings, encodeOffsets, encodeScale) {
    for(var c = 0; c < rings.length; c++)rings[c] = $1a1de70a2b6a5dc5$var$decodeRing(rings[c], encodeOffsets[c], encodeScale);
}
function $1a1de70a2b6a5dc5$var$decodeRing(coordinate, encodeOffsets, encodeScale) {
    var result = [];
    var prevX = encodeOffsets[0];
    var prevY = encodeOffsets[1];
    for(var i = 0; i < coordinate.length; i += 2){
        var x = coordinate.charCodeAt(i) - 64;
        var y = coordinate.charCodeAt(i + 1) - 64;
        // ZigZag decoding
        x = x >> 1 ^ -(x & 1);
        y = y >> 1 ^ -(y & 1);
        // Delta deocding
        x += prevX;
        y += prevY;
        prevX = x;
        prevY = y;
        // Dequantize
        result.push([
            x / encodeScale,
            y / encodeScale
        ]);
    }
    return result;
}
function $1a1de70a2b6a5dc5$export$2e2bcd8739ae039(geoJson, nameProperty) {
    geoJson = $1a1de70a2b6a5dc5$var$decode(geoJson);
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88($7a1bd9c2710fea0d$export$3dea766d36a8935f(geoJson.features, function(featureObj) {
        // Output of mapshaper may have geometry null
        return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
    }), function(featureObj) {
        var properties = featureObj.properties;
        var geo = featureObj.geometry;
        var geometries = [];
        switch(geo.type){
            case "Polygon":
                var coordinates = geo.coordinates;
                // According to the GeoJSON specification.
                // First must be exterior, and the rest are all interior(holes).
                geometries.push(new (0, $00e94d08c93517b6$export$91e20b0f72443753)(coordinates[0], coordinates.slice(1)));
                break;
            case "MultiPolygon":
                $7a1bd9c2710fea0d$export$79b2f7037acddd43(geo.coordinates, function(item) {
                    if (item[0]) geometries.push(new (0, $00e94d08c93517b6$export$91e20b0f72443753)(item[0], item.slice(1)));
                });
                break;
            case "LineString":
                geometries.push(new (0, $00e94d08c93517b6$export$335807c9e785d92c)([
                    geo.coordinates
                ]));
                break;
            case "MultiLineString":
                geometries.push(new (0, $00e94d08c93517b6$export$335807c9e785d92c)(geo.coordinates));
        }
        var region = new (0, $00e94d08c93517b6$export$ee84fcb463f24b3d)(properties[nameProperty || "name"], geometries, properties.cp);
        region.properties = properties;
        return region;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 南海诸岛


var $616ae7a19aad52f4$var$geoCoord = [
    126,
    25
];
var $616ae7a19aad52f4$var$nanhaiName = "\u5357\u6D77\u8BF8\u5C9B";
var $616ae7a19aad52f4$var$points = [
    [
        [
            0,
            3.5
        ],
        [
            7,
            11.2
        ],
        [
            15,
            11.9
        ],
        [
            30,
            7
        ],
        [
            42,
            0.7
        ],
        [
            52,
            0.7
        ],
        [
            56,
            7.7
        ],
        [
            59,
            0.7
        ],
        [
            64,
            0.7
        ],
        [
            64,
            0
        ],
        [
            5,
            0
        ],
        [
            0,
            3.5
        ]
    ],
    [
        [
            13,
            16.1
        ],
        [
            19,
            14.7
        ],
        [
            16,
            21.7
        ],
        [
            11,
            23.1
        ],
        [
            13,
            16.1
        ]
    ],
    [
        [
            12,
            32.2
        ],
        [
            14,
            38.5
        ],
        [
            15,
            38.5
        ],
        [
            13,
            32.2
        ],
        [
            12,
            32.2
        ]
    ],
    [
        [
            16,
            47.6
        ],
        [
            12,
            53.2
        ],
        [
            13,
            53.2
        ],
        [
            18,
            47.6
        ],
        [
            16,
            47.6
        ]
    ],
    [
        [
            6,
            64.4
        ],
        [
            8,
            70
        ],
        [
            9,
            70
        ],
        [
            8,
            64.4
        ],
        [
            6,
            64.4
        ]
    ],
    [
        [
            23,
            82.6
        ],
        [
            29,
            79.8
        ],
        [
            30,
            79.8
        ],
        [
            25,
            82.6
        ],
        [
            23,
            82.6
        ]
    ],
    [
        [
            37,
            70.7
        ],
        [
            43,
            62.3
        ],
        [
            44,
            62.3
        ],
        [
            39,
            70.7
        ],
        [
            37,
            70.7
        ]
    ],
    [
        [
            48,
            51.1
        ],
        [
            51,
            45.5
        ],
        [
            53,
            45.5
        ],
        [
            50,
            51.1
        ],
        [
            48,
            51.1
        ]
    ],
    [
        [
            51,
            35
        ],
        [
            51,
            28.7
        ],
        [
            53,
            28.7
        ],
        [
            53,
            35
        ],
        [
            51,
            35
        ]
    ],
    [
        [
            52,
            22.4
        ],
        [
            55,
            17.5
        ],
        [
            56,
            17.5
        ],
        [
            53,
            22.4
        ],
        [
            52,
            22.4
        ]
    ],
    [
        [
            58,
            12.6
        ],
        [
            62,
            7
        ],
        [
            63,
            7
        ],
        [
            60,
            12.6
        ],
        [
            58,
            12.6
        ]
    ],
    [
        [
            0,
            3.5
        ],
        [
            0,
            93.1
        ],
        [
            64,
            93.1
        ],
        [
            64,
            0
        ],
        [
            63,
            0
        ],
        [
            63,
            92.4
        ],
        [
            1,
            92.4
        ],
        [
            1,
            3.5
        ],
        [
            0,
            3.5
        ]
    ]
];
for(var $616ae7a19aad52f4$var$i = 0; $616ae7a19aad52f4$var$i < $616ae7a19aad52f4$var$points.length; $616ae7a19aad52f4$var$i++)for(var $616ae7a19aad52f4$var$k = 0; $616ae7a19aad52f4$var$k < $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i].length; $616ae7a19aad52f4$var$k++){
    $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i][$616ae7a19aad52f4$var$k][0] /= 10.5;
    $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i][$616ae7a19aad52f4$var$k][1] /= -14;
    $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i][$616ae7a19aad52f4$var$k][0] += $616ae7a19aad52f4$var$geoCoord[0];
    $616ae7a19aad52f4$var$points[$616ae7a19aad52f4$var$i][$616ae7a19aad52f4$var$k][1] += $616ae7a19aad52f4$var$geoCoord[1];
}
function $616ae7a19aad52f4$export$2e2bcd8739ae039(mapType, regions) {
    if (mapType === "china") {
        for(var i = 0; i < regions.length; i++){
            // Already exists.
            if (regions[i].name === $616ae7a19aad52f4$var$nanhaiName) return;
        }
        regions.push(new (0, $00e94d08c93517b6$export$ee84fcb463f24b3d)($616ae7a19aad52f4$var$nanhaiName, $7a1bd9c2710fea0d$export$871de8747c9eaa88($616ae7a19aad52f4$var$points, function(exterior) {
            return {
                type: "polygon",
                exterior: exterior
            };
        }), $616ae7a19aad52f4$var$geoCoord));
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $280c32529827bd03$var$coordsOffsetMap = {
    "\u5357\u6D77\u8BF8\u5C9B": [
        32,
        80
    ],
    // 全国
    "\u5E7F\u4E1C": [
        0,
        -10
    ],
    "\u9999\u6E2F": [
        10,
        5
    ],
    "\u6FB3\u95E8": [
        -10,
        10
    ],
    // '北京': [-10, 0],
    "\u5929\u6D25": [
        5,
        5
    ]
};
function $280c32529827bd03$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === "china") {
        var coordFix = $280c32529827bd03$var$coordsOffsetMap[region.name];
        if (coordFix) {
            var cp = region.getCenter();
            cp[0] += coordFix[0] / 10.5;
            cp[1] += -coordFix[1] / 14;
            region.setCenter(cp);
        }
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 钓鱼岛
// let Region = require('../Region');
// let zrUtil = require('zrender/lib/core/util');
// let geoCoord = [126, 25];
var $5b04f3878acd754e$var$points = [
    [
        [
            123.45165252685547,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.73527164402261
        ]
    ]
];
function $5b04f3878acd754e$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === "china" && region.name === "\u53F0\u6E7E") region.geometries.push({
        type: "polygon",
        exterior: $5b04f3878acd754e$var$points[0]
    });
}



var $ca9a35044b20ba4d$var$DEFAULT_NAME_PROPERTY = "name";
var $ca9a35044b20ba4d$export$859cf85c67f2df51 = /** @class */ function() {
    function GeoJSONResource(mapName, geoJSON, specialAreas) {
        this.type = "geoJSON";
        this._parsedMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        this._mapName = mapName;
        this._specialAreas = specialAreas;
        // PENDING: delay the parse to the first usage to rapid up the FMP?
        this._geoJSON = $ca9a35044b20ba4d$var$parseInput(geoJSON);
    }
    /**
   * @param nameMap can be null/undefined
   * @param nameProperty can be null/undefined
   */ GeoJSONResource.prototype.load = function(nameMap, nameProperty) {
        nameProperty = nameProperty || $ca9a35044b20ba4d$var$DEFAULT_NAME_PROPERTY;
        var parsed = this._parsedMap.get(nameProperty);
        if (!parsed) {
            var rawRegions = this._parseToRegions(nameProperty);
            parsed = this._parsedMap.set(nameProperty, {
                regions: rawRegions,
                boundingRect: $ca9a35044b20ba4d$var$calculateBoundingRect(rawRegions)
            });
        }
        var regionsMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var finalRegions = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(parsed.regions, function(region) {
            var regionName = region.name;
            // Try use the alias in geoNameMap
            if (nameMap && (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(nameMap, regionName)) region = region.cloneShallow(regionName = nameMap[regionName]);
            finalRegions.push(region);
            regionsMap.set(regionName, region);
        });
        return {
            regions: finalRegions,
            boundingRect: parsed.boundingRect || new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0),
            regionsMap: regionsMap
        };
    };
    GeoJSONResource.prototype._parseToRegions = function(nameProperty) {
        var mapName = this._mapName;
        var geoJSON = this._geoJSON;
        var rawRegions;
        // https://jsperf.com/try-catch-performance-overhead
        try {
            rawRegions = geoJSON ? (0, $1a1de70a2b6a5dc5$export$2e2bcd8739ae039)(geoJSON, nameProperty) : [];
        } catch (e) {
            throw new Error("Invalid geoJson format\n" + e.message);
        }
        (0, $616ae7a19aad52f4$export$2e2bcd8739ae039)(mapName, rawRegions);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(rawRegions, function(region) {
            var regionName = region.name;
            (0, $280c32529827bd03$export$2e2bcd8739ae039)(mapName, region);
            (0, $5b04f3878acd754e$export$2e2bcd8739ae039)(mapName, region);
            // Some area like Alaska in USA map needs to be tansformed
            // to look better
            var specialArea = this._specialAreas && this._specialAreas[regionName];
            if (specialArea) region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
        }, this);
        return rawRegions;
    };
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ GeoJSONResource.prototype.getMapForUser = function() {
        return {
            // For backward compatibility, use geoJson
            // PENDING: it has been returning them without clone.
            // do we need to avoid outsite modification?
            geoJson: this._geoJSON,
            geoJSON: this._geoJSON,
            specialAreas: this._specialAreas
        };
    };
    return GeoJSONResource;
}();
function $ca9a35044b20ba4d$var$calculateBoundingRect(regions) {
    var rect;
    for(var i = 0; i < regions.length; i++){
        var regionRect = regions[i].getBoundingRect();
        rect = rect || regionRect.clone();
        rect.union(regionRect);
    }
    return rect;
}
function $ca9a35044b20ba4d$var$parseInput(source) {
    return !(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(source) ? source : typeof JSON !== "undefined" && JSON.parse ? JSON.parse(source) : new Function("return (" + source + ");")();
}


var $09550a1229dcb4ad$var$storage = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
var $09550a1229dcb4ad$export$2e2bcd8739ae039 = {
    /**
   * Compatible with previous `echarts.registerMap`.
   *
   * @usage
   * ```js
   *
   * echarts.registerMap('USA', geoJson, specialAreas);
   *
   * echarts.registerMap('USA', {
   *     geoJson: geoJson,
   *     specialAreas: {...}
   * });
   * echarts.registerMap('USA', {
   *     geoJSON: geoJson,
   *     specialAreas: {...}
   * });
   *
   * echarts.registerMap('airport', {
   *     svg: svg
   * }
   * ```
   *
   * Note:
   * Do not support that register multiple geoJSON or SVG
   * one map name. Because different geoJSON and SVG have
   * different unit. It's not easy to make sure how those
   * units are mapping/normalize.
   * If intending to use multiple geoJSON or SVG, we can
   * use multiple geo coordinate system.
   */ registerMap: function(mapName, rawDef, rawSpecialAreas) {
        if (rawDef.svg) {
            var resource = new (0, $decc9bf1380d61c0$export$be52c950efae1f84)(mapName, rawDef.svg);
            $09550a1229dcb4ad$var$storage.set(mapName, resource);
        } else {
            // Recommend:
            //     echarts.registerMap('eu', { geoJSON: xxx, specialAreas: xxx });
            // Backward compatibility:
            //     echarts.registerMap('eu', geoJSON, specialAreas);
            //     echarts.registerMap('eu', { geoJson: xxx, specialAreas: xxx });
            var geoJSON = rawDef.geoJson || rawDef.geoJSON;
            if (geoJSON && !rawDef.features) rawSpecialAreas = rawDef.specialAreas;
            else geoJSON = rawDef;
            var resource = new (0, $ca9a35044b20ba4d$export$859cf85c67f2df51)(mapName, geoJSON, rawSpecialAreas);
            $09550a1229dcb4ad$var$storage.set(mapName, resource);
        }
    },
    getGeoResource: function(mapName) {
        return $09550a1229dcb4ad$var$storage.get(mapName);
    },
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ getMapForUser: function(mapName) {
        var resource = $09550a1229dcb4ad$var$storage.get(mapName);
        // Do not support return SVG until some real requirement come.
        return resource && resource.type === "geoJSON" && resource.getMapForUser();
    },
    load: function(mapName, nameMap, nameProperty) {
        var resource = $09550a1229dcb4ad$var$storage.get(mapName);
        if (!resource) return;
        return resource.load(nameMap, nameProperty);
    }
};








/**
 * Only these tags enable use `itemStyle` if they are named in SVG.
 * Other tags like <text> <tspan> <image> might not suitable for `itemStyle`.
 * They will not be considered to be styled until some requirements come.
 */ var $ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAGS = [
    "rect",
    "circle",
    "line",
    "ellipse",
    "polygon",
    "polyline",
    "path"
];
var $ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAG_MAP = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4($ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAGS);
var $ad029c27e0f2a7ab$var$STATE_TRIGGER_TAG_MAP = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4($ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAGS.concat([
    "g"
]));
var $ad029c27e0f2a7ab$var$LABEL_HOST_MAP = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4($ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAGS.concat([
    "g"
]));
var $ad029c27e0f2a7ab$var$mapLabelRaw = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $ad029c27e0f2a7ab$var$getFixedItemStyle(model) {
    var itemStyle = model.getItemStyle();
    var areaColor = model.get("areaColor");
    // If user want the color not to be changed when hover,
    // they should both set areaColor and color to be null.
    if (areaColor != null) itemStyle.fill = areaColor;
    return itemStyle;
}
// Only stroke can be used for line.
// Using fill in style if stroke not exits.
// TODO Not sure yet. Perhaps a separate `lineStyle`?
function $ad029c27e0f2a7ab$var$fixLineStyle(styleHost) {
    var style = styleHost.style;
    if (style) {
        style.stroke = style.stroke || style.fill;
        style.fill = null;
    }
}
var $ad029c27e0f2a7ab$var$MapDraw = /** @class */ function() {
    function MapDraw(api) {
        var group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this.uid = (0, $5370df662b2caf37$export$6d2b3473b0986646)("ec_map_draw");
        this._controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
        this._controllerHost = {
            target: group
        };
        this.group = group;
        group.add(this._regionsGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039());
        group.add(this._svgGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039());
    }
    MapDraw.prototype.draw = function(mapOrGeoModel, ecModel, api, fromView, payload) {
        var isGeo = mapOrGeoModel.mainType === "geo";
        // Map series has data. GEO model that controlled by map series
        // will be assigned with map data. Other GEO model has no data.
        var data = mapOrGeoModel.getData && mapOrGeoModel.getData();
        isGeo && ecModel.eachComponent({
            mainType: "series",
            subType: "map"
        }, function(mapSeries) {
            if (!data && mapSeries.getHostGeoModel() === mapOrGeoModel) data = mapSeries.getData();
        });
        var geo = mapOrGeoModel.coordinateSystem;
        var regionsGroup = this._regionsGroup;
        var group = this.group;
        var transformInfo = geo.getTransformInfo();
        var transformInfoRaw = transformInfo.raw;
        var transformInfoRoam = transformInfo.roam;
        // No animation when first draw or in action
        var isFirstDraw = !regionsGroup.childAt(0) || payload;
        if (isFirstDraw) {
            group.x = transformInfoRoam.x;
            group.y = transformInfoRoam.y;
            group.scaleX = transformInfoRoam.scaleX;
            group.scaleY = transformInfoRoam.scaleY;
            group.dirty();
        } else $8b353638fbedfefa$export$c8dce3c08436e91e(group, transformInfoRoam, mapOrGeoModel);
        var isVisualEncodedByVisualMap = data && data.getVisual("visualMeta") && data.getVisual("visualMeta").length > 0;
        var viewBuildCtx = {
            api: api,
            geo: geo,
            mapOrGeoModel: mapOrGeoModel,
            data: data,
            isVisualEncodedByVisualMap: isVisualEncodedByVisualMap,
            isGeo: isGeo,
            transformInfoRaw: transformInfoRaw
        };
        if (geo.resourceType === "geoJSON") this._buildGeoJSON(viewBuildCtx);
        else if (geo.resourceType === "geoSVG") this._buildSVG(viewBuildCtx);
        this._updateController(mapOrGeoModel, ecModel, api);
        this._updateMapSelectHandler(mapOrGeoModel, regionsGroup, api, fromView);
    };
    MapDraw.prototype._buildGeoJSON = function(viewBuildCtx) {
        var regionsGroupByName = this._regionsGroupByName = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var regionsInfoByName = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var regionsGroup = this._regionsGroup;
        var transformInfoRaw = viewBuildCtx.transformInfoRaw;
        var mapOrGeoModel = viewBuildCtx.mapOrGeoModel;
        var data = viewBuildCtx.data;
        var projection = viewBuildCtx.geo.projection;
        var projectionStream = projection && projection.stream;
        function transformPoint(point, project) {
            if (project) // projection may return null point.
            point = project(point);
            return point && [
                point[0] * transformInfoRaw.scaleX + transformInfoRaw.x,
                point[1] * transformInfoRaw.scaleY + transformInfoRaw.y
            ];
        }
        function transformPolygonPoints(inPoints) {
            var outPoints = [];
            // If projectionStream is provided. Use it instead of single point project.
            var project = !projectionStream && projection && projection.project;
            for(var i = 0; i < inPoints.length; ++i){
                var newPt = transformPoint(inPoints[i], project);
                newPt && outPoints.push(newPt);
            }
            return outPoints;
        }
        function getPolyShape(points) {
            return {
                shape: {
                    points: transformPolygonPoints(points)
                }
            };
        }
        regionsGroup.removeAll();
        // Only when the resource is GeoJSON, there is `geo.regions`.
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(viewBuildCtx.geo.regions, function(region) {
            var regionName = region.name;
            // Consider in GeoJson properties.name may be duplicated, for example,
            // there is multiple region named "United Kindom" or "France" (so many
            // colonies). And it is not appropriate to merge them in geo, which
            // will make them share the same label and bring trouble in label
            // location calculation.
            var regionGroup = regionsGroupByName.get(regionName);
            var _a = regionsInfoByName.get(regionName) || {}, dataIdx = _a.dataIdx, regionModel = _a.regionModel;
            if (!regionGroup) {
                regionGroup = regionsGroupByName.set(regionName, new $7ef7583d8302ffce$export$2e2bcd8739ae039());
                regionsGroup.add(regionGroup);
                dataIdx = data ? data.indexOfName(regionName) : null;
                regionModel = viewBuildCtx.isGeo ? mapOrGeoModel.getRegionModel(regionName) : data ? data.getItemModel(dataIdx) : null;
                regionsInfoByName.set(regionName, {
                    dataIdx: dataIdx,
                    regionModel: regionModel
                });
            }
            var polygonSubpaths = [];
            var polylineSubpaths = [];
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(region.geometries, function(geometry) {
                // Polygon and MultiPolygon
                if (geometry.type === "polygon") {
                    var polys = [
                        geometry.exterior
                    ].concat(geometry.interiors || []);
                    if (projectionStream) polys = $ad029c27e0f2a7ab$var$projectPolys(polys, projectionStream);
                    $7a1bd9c2710fea0d$export$79b2f7037acddd43(polys, function(poly) {
                        polygonSubpaths.push(new $51acf033123e1a30$export$2e2bcd8739ae039(getPolyShape(poly)));
                    });
                } else {
                    var points = geometry.points;
                    if (projectionStream) points = $ad029c27e0f2a7ab$var$projectPolys(points, projectionStream, true);
                    $7a1bd9c2710fea0d$export$79b2f7037acddd43(points, function(points) {
                        polylineSubpaths.push(new $d28119f30e6bb670$export$2e2bcd8739ae039(getPolyShape(points)));
                    });
                }
            });
            var centerPt = transformPoint(region.getCenter(), projection && projection.project);
            function createCompoundPath(subpaths, isLine) {
                if (!subpaths.length) return;
                var compoundPath = new $e152f3dbf8fba6e2$export$2e2bcd8739ae039({
                    culling: true,
                    segmentIgnoreThreshold: 1,
                    shape: {
                        paths: subpaths
                    }
                });
                regionGroup.add(compoundPath);
                $ad029c27e0f2a7ab$var$applyOptionStyleForRegion(viewBuildCtx, compoundPath, dataIdx, regionModel);
                $ad029c27e0f2a7ab$var$resetLabelForRegion(viewBuildCtx, compoundPath, regionName, regionModel, mapOrGeoModel, dataIdx, centerPt);
                if (isLine) {
                    $ad029c27e0f2a7ab$var$fixLineStyle(compoundPath);
                    $7a1bd9c2710fea0d$export$79b2f7037acddd43(compoundPath.states, $ad029c27e0f2a7ab$var$fixLineStyle);
                }
            }
            createCompoundPath(polygonSubpaths);
            createCompoundPath(polylineSubpaths, true);
        });
        // Ensure children have been added to `regionGroup` before calling them.
        regionsGroupByName.each(function(regionGroup, regionName) {
            var _a = regionsInfoByName.get(regionName), dataIdx = _a.dataIdx, regionModel = _a.regionModel;
            $ad029c27e0f2a7ab$var$resetEventTriggerForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel, dataIdx);
            $ad029c27e0f2a7ab$var$resetTooltipForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel);
            $ad029c27e0f2a7ab$var$resetStateTriggerForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel);
        }, this);
    };
    MapDraw.prototype._buildSVG = function(viewBuildCtx) {
        var mapName = viewBuildCtx.geo.map;
        var transformInfoRaw = viewBuildCtx.transformInfoRaw;
        this._svgGroup.x = transformInfoRaw.x;
        this._svgGroup.y = transformInfoRaw.y;
        this._svgGroup.scaleX = transformInfoRaw.scaleX;
        this._svgGroup.scaleY = transformInfoRaw.scaleY;
        if (this._svgResourceChanged(mapName)) {
            this._freeSVG();
            this._useSVG(mapName);
        }
        var svgDispatcherMap = this._svgDispatcherMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var focusSelf = false;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._svgGraphicRecord.named, function(namedItem) {
            // Note that we also allow different elements have the same name.
            // For example, a glyph of a city and the label of the city have
            // the same name and their tooltip info can be defined in a single
            // region option.
            var regionName = namedItem.name;
            var mapOrGeoModel = viewBuildCtx.mapOrGeoModel;
            var data = viewBuildCtx.data;
            var svgNodeTagLower = namedItem.svgNodeTagLower;
            var el = namedItem.el;
            var dataIdx = data ? data.indexOfName(regionName) : null;
            var regionModel = mapOrGeoModel.getRegionModel(regionName);
            if ($ad029c27e0f2a7ab$var$OPTION_STYLE_ENABLED_TAG_MAP.get(svgNodeTagLower) != null && el instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) $ad029c27e0f2a7ab$var$applyOptionStyleForRegion(viewBuildCtx, el, dataIdx, regionModel);
            if (el instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) el.culling = true;
            // We do not know how the SVG like so we'd better not to change z2.
            // Otherwise it might bring some unexpected result. For example,
            // an area hovered that make some inner city can not be clicked.
            el.z2EmphasisLift = 0;
            // If self named:
            if (!namedItem.namedFrom) {
                // label should batter to be displayed based on the center of <g>
                // if it is named rather than displayed on each child.
                if ($ad029c27e0f2a7ab$var$LABEL_HOST_MAP.get(svgNodeTagLower) != null) $ad029c27e0f2a7ab$var$resetLabelForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, dataIdx, null);
                $ad029c27e0f2a7ab$var$resetEventTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, dataIdx);
                $ad029c27e0f2a7ab$var$resetTooltipForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel);
                if ($ad029c27e0f2a7ab$var$STATE_TRIGGER_TAG_MAP.get(svgNodeTagLower) != null) {
                    var focus_1 = $ad029c27e0f2a7ab$var$resetStateTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel);
                    if (focus_1 === "self") focusSelf = true;
                    var els = svgDispatcherMap.get(regionName) || svgDispatcherMap.set(regionName, []);
                    els.push(el);
                }
            }
        }, this);
        this._enableBlurEntireSVG(focusSelf, viewBuildCtx);
    };
    MapDraw.prototype._enableBlurEntireSVG = function(focusSelf, viewBuildCtx) {
        // It's a little complicated to support blurring the entire geoSVG in series-map.
        // So do not support it until some requirements come.
        // At present, in series-map, only regions can be blurred.
        if (focusSelf && viewBuildCtx.isGeo) {
            var blurStyle = viewBuildCtx.mapOrGeoModel.getModel([
                "blur",
                "itemStyle"
            ]).getItemStyle();
            // Only support `opacity` here. Because not sure that other props are suitable for
            // all of the elements generated by SVG (especially for Text/TSpan/Image/... ).
            var opacity_1 = blurStyle.opacity;
            this._svgGraphicRecord.root.traverse(function(el) {
                if (!el.isGroup) {
                    // PENDING: clear those settings to SVG elements when `_freeSVG`.
                    // (Currently it happen not to be needed.)
                    (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(el);
                    var style = el.ensureState("blur").style || {};
                    // Do not overwrite the region style that already set from region option.
                    if (style.opacity == null && opacity_1 != null) style.opacity = opacity_1;
                    // If `ensureState('blur').style = {}`, there will be default opacity.
                    // Enable `stateTransition` (animation).
                    el.ensureState("emphasis");
                }
            });
        }
    };
    MapDraw.prototype.remove = function() {
        this._regionsGroup.removeAll();
        this._regionsGroupByName = null;
        this._svgGroup.removeAll();
        this._freeSVG();
        this._controller.dispose();
        this._controllerHost = null;
    };
    MapDraw.prototype.findHighDownDispatchers = function(name, geoModel) {
        if (name == null) return [];
        var geo = geoModel.coordinateSystem;
        if (geo.resourceType === "geoJSON") {
            var regionsGroupByName = this._regionsGroupByName;
            if (regionsGroupByName) {
                var regionGroup = regionsGroupByName.get(name);
                return regionGroup ? [
                    regionGroup
                ] : [];
            }
        } else if (geo.resourceType === "geoSVG") return this._svgDispatcherMap && this._svgDispatcherMap.get(name) || [];
    };
    MapDraw.prototype._svgResourceChanged = function(mapName) {
        return this._svgMapName !== mapName;
    };
    MapDraw.prototype._useSVG = function(mapName) {
        var resource = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getGeoResource(mapName);
        if (resource && resource.type === "geoSVG") {
            var svgGraphic = resource.useGraphic(this.uid);
            this._svgGroup.add(svgGraphic.root);
            this._svgGraphicRecord = svgGraphic;
            this._svgMapName = mapName;
        }
    };
    MapDraw.prototype._freeSVG = function() {
        var mapName = this._svgMapName;
        if (mapName == null) return;
        var resource = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getGeoResource(mapName);
        if (resource && resource.type === "geoSVG") resource.freeGraphic(this.uid);
        this._svgGraphicRecord = null;
        this._svgDispatcherMap = null;
        this._svgGroup.removeAll();
        this._svgMapName = null;
    };
    MapDraw.prototype._updateController = function(mapOrGeoModel, ecModel, api) {
        var geo = mapOrGeoModel.coordinateSystem;
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        // @ts-ignore FIXME:TS
        controllerHost.zoomLimit = mapOrGeoModel.get("scaleLimit");
        controllerHost.zoom = geo.getZoom();
        // roamType is will be set default true if it is null
        // @ts-ignore FIXME:TS
        controller.enable(mapOrGeoModel.get("roam") || false);
        var mainType = mapOrGeoModel.mainType;
        function makeActionBase() {
            var action = {
                type: "geoRoam",
                componentType: mainType
            };
            action[mainType + "Id"] = mapOrGeoModel.id;
            return action;
        }
        controller.off("pan").on("pan", function(e) {
            this._mouseDownFlag = false;
            $35fd859fd545c4be$export$1e6abcd98caba733(controllerHost, e.dx, e.dy);
            api.dispatchAction($7a1bd9c2710fea0d$export$8b58be045bf06082(makeActionBase(), {
                dx: e.dx,
                dy: e.dy,
                animation: {
                    duration: 0
                }
            }));
        }, this);
        controller.off("zoom").on("zoom", function(e) {
            this._mouseDownFlag = false;
            $35fd859fd545c4be$export$29b3c66d30a4866(controllerHost, e.scale, e.originX, e.originY);
            api.dispatchAction($7a1bd9c2710fea0d$export$8b58be045bf06082(makeActionBase(), {
                zoom: e.scale,
                originX: e.originX,
                originY: e.originY,
                animation: {
                    duration: 0
                }
            }));
        }, this);
        controller.setPointerChecker(function(e, x, y) {
            return geo.containPoint([
                x,
                y
            ]) && !(0, $bee256db41541054$export$8a33eacb690eac07)(e, api, mapOrGeoModel);
        });
    };
    /**
   * FIXME: this is a temporarily workaround.
   * When `geoRoam` the elements need to be reset in `MapView['render']`, because the props like
   * `ignore` might have been modified by `LabelManager`, and `LabelManager#addLabelsOfSeries`
   * will subsequently cache `defaultAttr` like `ignore`. If do not do this reset, the modified
   * props will have no chance to be restored.
   * Note: This reset should be after `clearStates` in `renderSeries` because `useStates` in
   * `renderSeries` will cache the modified `ignore` to `el._normalState`.
   * TODO:
   * Use clone/immutable in `LabelManager`?
   */ MapDraw.prototype.resetForLabelLayout = function() {
        this.group.traverse(function(el) {
            var label = el.getTextContent();
            if (label) label.ignore = $ad029c27e0f2a7ab$var$mapLabelRaw(label).ignore;
        });
    };
    MapDraw.prototype._updateMapSelectHandler = function(mapOrGeoModel, regionsGroup, api, fromView) {
        var mapDraw = this;
        regionsGroup.off("mousedown");
        regionsGroup.off("click");
        // @ts-ignore FIXME:TS resolve type conflict
        if (mapOrGeoModel.get("selectedMode")) {
            regionsGroup.on("mousedown", function() {
                mapDraw._mouseDownFlag = true;
            });
            regionsGroup.on("click", function(e) {
                if (!mapDraw._mouseDownFlag) return;
                mapDraw._mouseDownFlag = false;
            });
        }
    };
    return MapDraw;
}();
function $ad029c27e0f2a7ab$var$applyOptionStyleForRegion(viewBuildCtx, el, dataIndex, regionModel) {
    // All of the path are using `itemStyle`, because
    // (1) Some SVG also use fill on polyline (The different between
    // polyline and polygon is "open" or "close" but not fill or not).
    // (2) For the common props like opacity, if some use itemStyle
    // and some use `lineStyle`, it might confuse users.
    // (3) Most SVG use <path>, where can not detect whether to draw a "line"
    // or a filled shape, so use `itemStyle` for <path>.
    var normalStyleModel = regionModel.getModel("itemStyle");
    var emphasisStyleModel = regionModel.getModel([
        "emphasis",
        "itemStyle"
    ]);
    var blurStyleModel = regionModel.getModel([
        "blur",
        "itemStyle"
    ]);
    var selectStyleModel = regionModel.getModel([
        "select",
        "itemStyle"
    ]);
    // NOTE: DON'T use 'style' in visual when drawing map.
    // This component is used for drawing underlying map for both geo component and map series.
    var normalStyle = $ad029c27e0f2a7ab$var$getFixedItemStyle(normalStyleModel);
    var emphasisStyle = $ad029c27e0f2a7ab$var$getFixedItemStyle(emphasisStyleModel);
    var selectStyle = $ad029c27e0f2a7ab$var$getFixedItemStyle(selectStyleModel);
    var blurStyle = $ad029c27e0f2a7ab$var$getFixedItemStyle(blurStyleModel);
    // Update the itemStyle if has data visual
    var data = viewBuildCtx.data;
    if (data) {
        // Only visual color of each item will be used. It can be encoded by visualMap
        // But visual color of series is used in symbol drawing
        // Visual color for each series is for the symbol draw
        var style = data.getItemVisual(dataIndex, "style");
        var decal = data.getItemVisual(dataIndex, "decal");
        if (viewBuildCtx.isVisualEncodedByVisualMap && style.fill) normalStyle.fill = style.fill;
        if (decal) normalStyle.decal = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decal, viewBuildCtx.api);
    }
    // SVG text, tspan and image can be named but not supporeted
    // to be styled by region option yet.
    el.setStyle(normalStyle);
    el.style.strokeNoScale = true;
    el.ensureState("emphasis").style = emphasisStyle;
    el.ensureState("select").style = selectStyle;
    el.ensureState("blur").style = blurStyle;
    // Enable blur
    (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(el);
}
function $ad029c27e0f2a7ab$var$resetLabelForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, // Exist only if `viewBuildCtx.data` exists.
dataIdx, // If labelXY not provided, use `textConfig.position: 'inside'`
labelXY) {
    var data = viewBuildCtx.data;
    var isGeo = viewBuildCtx.isGeo;
    var isDataNaN = data && isNaN(data.get(data.mapDimension("value"), dataIdx));
    var itemLayout = data && data.getItemLayout(dataIdx);
    // In the following cases label will be drawn
    // 1. In map series and data value is NaN
    // 2. In geo component
    // 3. Region has no series legendIcon, which will be add a showLabel flag in mapSymbolLayout
    if (isGeo || isDataNaN || itemLayout && itemLayout.showLabel) {
        var query = !isGeo ? dataIdx : regionName;
        var labelFetcher = void 0;
        // Consider dataIdx not found.
        if (!data || dataIdx >= 0) labelFetcher = mapOrGeoModel;
        var specifiedTextOpt = labelXY ? {
            normal: {
                align: "center",
                verticalAlign: "middle"
            }
        } : null;
        // Caveat: must be called after `setDefaultStateProxy(el);` called.
        // because textContent will be assign with `el.stateProxy` inside.
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(el, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(regionModel), {
            labelFetcher: labelFetcher,
            labelDataIndex: query,
            defaultText: regionName
        }, specifiedTextOpt);
        var textEl = el.getTextContent();
        if (textEl) {
            $ad029c27e0f2a7ab$var$mapLabelRaw(textEl).ignore = textEl.ignore;
            if (el.textConfig && labelXY) {
                // Compute a relative offset based on the el bounding rect.
                var rect = el.getBoundingRect().clone();
                // Need to make sure the percent position base on the same rect in normal and
                // emphasis state. Otherwise if using boundingRect of el, but the emphasis state
                // has borderWidth (even 0.5px), the text position will be changed obviously
                // if the position is very big like ['1234%', '1345%'].
                el.textConfig.layoutRect = rect;
                el.textConfig.position = [
                    (labelXY[0] - rect.x) / rect.width * 100 + "%",
                    (labelXY[1] - rect.y) / rect.height * 100 + "%"
                ];
            }
        }
        // PENDING:
        // If labelLayout is enabled (test/label-layout.html), el.dataIndex should be specified.
        // But el.dataIndex is also used to determine whether user event should be triggered,
        // where el.seriesIndex or el.dataModel must be specified. At present for a single el
        // there is not case that "only label layout enabled but user event disabled", so here
        // we depends `resetEventTriggerForRegion` to do the job of setting `el.dataIndex`.
        el.disableLabelAnimation = true;
    } else {
        el.removeTextContent();
        el.removeTextConfig();
        el.disableLabelAnimation = null;
    }
}
function $ad029c27e0f2a7ab$var$resetEventTriggerForRegion(viewBuildCtx, eventTrigger, regionName, regionModel, mapOrGeoModel, // Exist only if `viewBuildCtx.data` exists.
dataIdx) {
    // setItemGraphicEl, setHoverStyle after all polygons and labels
    // are added to the regionGroup
    if (viewBuildCtx.data) // FIXME: when series-map use a SVG map, and there are duplicated name specified
    // on different SVG elements, after `data.setItemGraphicEl(...)`:
    // (1) all of them will be mounted with `dataIndex`, `seriesIndex`, so that tooltip
    // can be triggered only mouse hover. That's correct.
    // (2) only the last element will be kept in `data`, so that if trigger tooltip
    // by `dispatchAction`, only the last one can be found and triggered. That might be
    // not correct. We will fix it in future if anyone demanding that.
    viewBuildCtx.data.setItemGraphicEl(dataIdx, eventTrigger);
    else // Package custom mouse event for geo component
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(eventTrigger).eventData = {
        componentType: "geo",
        componentIndex: mapOrGeoModel.componentIndex,
        geoIndex: mapOrGeoModel.componentIndex,
        name: regionName,
        region: regionModel && regionModel.option || {}
    };
}
function $ad029c27e0f2a7ab$var$resetTooltipForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel) {
    if (!viewBuildCtx.data) $5b455ae6f843ac47$export$fc6410d97fab306c({
        el: el,
        componentModel: mapOrGeoModel,
        itemName: regionName,
        // @ts-ignore FIXME:TS fix the "compatible with each other"?
        itemTooltipOption: regionModel.get("tooltip")
    });
}
function $ad029c27e0f2a7ab$var$resetStateTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel) {
    // @ts-ignore FIXME:TS fix the "compatible with each other"?
    el.highDownSilentOnTouch = !!mapOrGeoModel.get("selectedMode");
    // @ts-ignore FIXME:TS fix the "compatible with each other"?
    var emphasisModel = regionModel.getModel("emphasis");
    var focus = emphasisModel.get("focus");
    (0, $2bf82c0980125b62$export$e51187539ff11209)(el, focus, emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    if (viewBuildCtx.isGeo) (0, $2bf82c0980125b62$export$4da05a9639f01954)(el, mapOrGeoModel, regionName);
    return focus;
}
function $ad029c27e0f2a7ab$var$projectPolys(rings, // Polygons include exterior and interiors. Or polylines.
createStream, isLine) {
    var polygons = [];
    var curPoly;
    function startPolygon() {
        curPoly = [];
    }
    function endPolygon() {
        if (curPoly.length) {
            polygons.push(curPoly);
            curPoly = [];
        }
    }
    var stream = createStream({
        polygonStart: startPolygon,
        polygonEnd: endPolygon,
        lineStart: startPolygon,
        lineEnd: endPolygon,
        point: function(x, y) {
            // May have NaN values from stream.
            if (isFinite(x) && isFinite(y)) curPoly.push([
                x,
                y
            ]);
        },
        sphere: function() {}
    });
    !isLine && stream.polygonStart();
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(rings, function(ring) {
        stream.lineStart();
        for(var i = 0; i < ring.length; i++)stream.point(ring[i][0], ring[i][1]);
        stream.lineEnd();
    });
    !isLine && stream.polygonEnd();
    return polygons;
}
var $ad029c27e0f2a7ab$export$2e2bcd8739ae039 // @ts-ignore FIXME:TS fix the "compatible with each other"?
 = $ad029c27e0f2a7ab$var$MapDraw;





var $1c3add93106395a4$var$MapView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MapView, _super);
    function MapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MapView.type;
        return _this;
    }
    MapView.prototype.render = function(mapModel, ecModel, api, payload) {
        // Not render if it is an toggleSelect action from self
        if (payload && payload.type === "mapToggleSelect" && payload.from === this.uid) return;
        var group = this.group;
        group.removeAll();
        if (mapModel.getHostGeoModel()) return;
        if (this._mapDraw && payload && payload.type === "geoRoam") this._mapDraw.resetForLabelLayout();
        // Not update map if it is an roam action from self
        if (!(payload && payload.type === "geoRoam" && payload.componentType === "series" && payload.seriesId === mapModel.id)) {
            if (mapModel.needsDrawMap) {
                var mapDraw = this._mapDraw || new (0, $ad029c27e0f2a7ab$export$2e2bcd8739ae039)(api);
                group.add(mapDraw.group);
                mapDraw.draw(mapModel, ecModel, api, this, payload);
                this._mapDraw = mapDraw;
            } else {
                // Remove drawn map
                this._mapDraw && this._mapDraw.remove();
                this._mapDraw = null;
            }
        } else {
            var mapDraw = this._mapDraw;
            mapDraw && group.add(mapDraw.group);
        }
        mapModel.get("showLegendSymbol") && ecModel.getComponent("legend") && this._renderSymbols(mapModel, ecModel, api);
    };
    MapView.prototype.remove = function() {
        this._mapDraw && this._mapDraw.remove();
        this._mapDraw = null;
        this.group.removeAll();
    };
    MapView.prototype.dispose = function() {
        this._mapDraw && this._mapDraw.remove();
        this._mapDraw = null;
    };
    MapView.prototype._renderSymbols = function(mapModel, ecModel, api) {
        var originalData = mapModel.originalData;
        var group = this.group;
        originalData.each(originalData.mapDimension("value"), function(value, originalDataIndex) {
            if (isNaN(value)) return;
            var layout = originalData.getItemLayout(originalDataIndex);
            if (!layout || !layout.point) // Not exists in map
            return;
            var point = layout.point;
            var offset = layout.offset;
            var circle = new $1e68d8727773abb7$export$2e2bcd8739ae039({
                style: {
                    // Because the special of map draw.
                    // Which needs statistic of multiple series and draw on one map.
                    // And each series also need a symbol with legend color
                    //
                    // Layout and visual are put one the different data
                    // TODO
                    fill: mapModel.getData().getVisual("style").fill
                },
                shape: {
                    cx: point[0] + offset * 9,
                    cy: point[1],
                    r: 3
                },
                silent: true,
                // Do not overlap the first series, on which labels are displayed.
                z2: 8 + (!offset ? (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) + 1 : 0)
            });
            // Only the series that has the first value on the same region is in charge of rendering the label.
            // But consider the case:
            // series: [
            //     {id: 'X', type: 'map', map: 'm', {data: [{name: 'A', value: 11}, {name: 'B', {value: 22}]},
            //     {id: 'Y', type: 'map', map: 'm', {data: [{name: 'A', value: 21}, {name: 'C', {value: 33}]}
            // ]
            // The offset `0` of item `A` is at series `X`, but of item `C` is at series `Y`.
            // For backward compatibility, we follow the rule that render label `A` by the
            // settings on series `X` but render label `C` by the settings on series `Y`.
            if (!offset) {
                var fullData = mapModel.mainSeries.getData();
                var name_1 = originalData.getName(originalDataIndex);
                var fullIndex_1 = fullData.indexOfName(name_1);
                var itemModel = originalData.getItemModel(originalDataIndex);
                var labelModel = itemModel.getModel("label");
                var regionGroup = fullData.getItemGraphicEl(fullIndex_1);
                // `getFormattedLabel` needs to use `getData` inside. Here
                // `mapModel.getData()` is shallow cloned from `mainSeries.getData()`.
                // FIXME
                // If this is not the `mainSeries`, the item model (like label formatter)
                // set on original data item will never get. But it has been working
                // like that from the beginning, and this scenario is rarely encountered.
                // So it won't be fixed until we have to.
                (0, $6800dfcb6e1e2a44$export$9a13992917966657)(circle, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
                    labelFetcher: {
                        getFormattedLabel: function(idx, state) {
                            return mapModel.getFormattedLabel(fullIndex_1, state);
                        }
                    },
                    defaultText: name_1
                });
                circle.disableLabelAnimation = true;
                if (!labelModel.get("position")) circle.setTextConfig({
                    position: "bottom"
                });
                regionGroup.onHoverStateChange = function(toState) {
                    (0, $2bf82c0980125b62$export$868ba38adffa9e39)(circle, toState);
                };
            }
            group.add(circle);
        });
    };
    MapView.type = "map";
    return MapView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $1c3add93106395a4$export$2e2bcd8739ae039 = $1c3add93106395a4$var$MapView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $f2f4aa5429e1d3d3$var$MapSeries = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MapSeries, _super);
    function MapSeries() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MapSeries.type;
        // Only first map series of same mapType will drawMap.
        _this.needsDrawMap = false;
        // Group of all map series with same mapType
        _this.seriesGroup = [];
        _this.getTooltipPosition = function(dataIndex) {
            if (dataIndex != null) {
                var name_1 = this.getData().getName(dataIndex);
                var geo = this.coordinateSystem;
                var region = geo.getRegion(name_1);
                return region && geo.dataToPoint(region.getCenter());
            }
        };
        return _this;
    }
    MapSeries.prototype.getInitialData = function(option) {
        var data = (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            coordDimensions: [
                "value"
            ],
            encodeDefaulter: $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$60b8a57d1f2fed26), this)
        });
        var dataNameMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var toAppendNames = [];
        for(var i = 0, len = data.count(); i < len; i++){
            var name_2 = data.getName(i);
            dataNameMap.set(name_2, true);
        }
        var geoSource = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).load(this.getMapType(), this.option.nameMap, this.option.nameProperty);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(geoSource.regions, function(region) {
            var name = region.name;
            if (!dataNameMap.get(name)) toAppendNames.push(name);
        });
        // Complete data with missing regions. The consequent processes (like visual
        // map and render) can not be performed without a "full data". For example,
        // find `dataIndex` by name.
        data.appendValues([], toAppendNames);
        return data;
    };
    /**
   * If no host geo model, return null, which means using a
   * inner exclusive geo model.
   */ MapSeries.prototype.getHostGeoModel = function() {
        var geoIndex = this.option.geoIndex;
        return geoIndex != null ? this.ecModel.getComponent("geo", geoIndex) : null;
    };
    MapSeries.prototype.getMapType = function() {
        return (this.getHostGeoModel() || this).option.map;
    };
    // _fillOption(option, mapName) {
    // Shallow clone
    // option = zrUtil.extend({}, option);
    // option.data = geoCreator.getFilledRegions(option.data, mapName, option.nameMap);
    // return option;
    // }
    MapSeries.prototype.getRawValue = function(dataIndex) {
        // Use value stored in data instead because it is calculated from multiple series
        // FIXME Provide all value of multiple series ?
        var data = this.getData();
        return data.get(data.mapDimension("value"), dataIndex);
    };
    /**
   * Get model of region
   */ MapSeries.prototype.getRegionModel = function(regionName) {
        var data = this.getData();
        return data.getItemModel(data.indexOfName(regionName));
    };
    /**
   * Map tooltip formatter
   */ MapSeries.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // FIXME orignalData and data is a bit confusing
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var name = data.getName(dataIndex);
        var seriesGroup = this.seriesGroup;
        var seriesNames = [];
        for(var i = 0; i < seriesGroup.length; i++){
            var otherIndex = seriesGroup[i].originalData.indexOfName(name);
            var valueDim = data.mapDimension("value");
            if (!isNaN(seriesGroup[i].originalData.get(valueDim, otherIndex))) seriesNames.push(seriesGroup[i].name);
        }
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("section", {
            header: seriesNames.join(", "),
            noHeader: !seriesNames.length,
            blocks: [
                (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                    name: name,
                    value: value
                })
            ]
        });
    };
    MapSeries.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    MapSeries.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    MapSeries.prototype.getLegendIcon = function(opt) {
        var iconType = opt.icon || "roundRect";
        var icon = (0, $5370466dadc978d7$export$af050e04da3a02e8)(iconType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill);
        icon.setStyle(opt.itemStyle);
        // Map do not use itemStyle.borderWidth as border width
        icon.style.stroke = "none";
        // No rotation because no series visual symbol for map
        if (iconType.indexOf("empty") > -1) {
            icon.style.stroke = icon.style.fill;
            icon.style.fill = "#fff";
            icon.style.lineWidth = 2;
        }
        return icon;
    };
    MapSeries.type = "series.map";
    MapSeries.dependencies = [
        "geo"
    ];
    MapSeries.layoutMode = "box";
    MapSeries.defaultOption = {
        // 一级层叠
        // zlevel: 0,
        // 二级层叠
        z: 2,
        coordinateSystem: "geo",
        // map should be explicitly specified since ec3.
        map: "",
        // If `geoIndex` is not specified, a exclusive geo will be
        // created. Otherwise use the specified geo component, and
        // `map` and `mapType` are ignored.
        // geoIndex: 0,
        // 'center' | 'left' | 'right' | 'x%' | {number}
        left: "center",
        // 'center' | 'top' | 'bottom' | 'x%' | {number}
        top: "center",
        // right
        // bottom
        // width:
        // height
        // Aspect is width / height. Inited to be geoJson bbox aspect
        // This parameter is used for scale this aspect
        // Default value:
        // for geoSVG source: 1,
        // for geoJSON source: 0.75.
        aspectScale: null,
        // Layout with center and size
        // If you want to put map in a fixed size box with right aspect ratio
        // This two properties may be more convenient.
        // layoutCenter: [50%, 50%]
        // layoutSize: 100
        showLegendSymbol: true,
        // Define left-top, right-bottom coords to control view
        // For example, [ [180, 90], [-180, -90] ],
        // higher priority than center and zoom
        boundingCoords: null,
        // Default on center of map
        center: null,
        zoom: 1,
        scaleLimit: null,
        selectedMode: true,
        label: {
            show: false,
            color: "#000"
        },
        // scaleLimit: null,
        itemStyle: {
            borderWidth: 0.5,
            borderColor: "#444",
            areaColor: "#eee"
        },
        emphasis: {
            label: {
                show: true,
                color: "rgb(100,0,0)"
            },
            itemStyle: {
                areaColor: "rgba(255,215,0,0.8)"
            }
        },
        select: {
            label: {
                show: true,
                color: "rgb(100,0,0)"
            },
            itemStyle: {
                color: "rgba(255,215,0,0.8)"
            }
        },
        nameProperty: "name"
    };
    return MapSeries;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $f2f4aa5429e1d3d3$export$2e2bcd8739ae039 = $f2f4aa5429e1d3d3$var$MapSeries;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// FIXME 公用？
function $5e3d42588445ae72$var$dataStatistics(datas, statisticType) {
    var dataNameMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(datas, function(data) {
        data.each(data.mapDimension("value"), function(value, idx) {
            // Add prefix to avoid conflict with Object.prototype.
            var mapKey = "ec-" + data.getName(idx);
            dataNameMap[mapKey] = dataNameMap[mapKey] || [];
            if (!isNaN(value)) dataNameMap[mapKey].push(value);
        });
    });
    return datas[0].map(datas[0].mapDimension("value"), function(value, idx) {
        var mapKey = "ec-" + datas[0].getName(idx);
        var sum = 0;
        var min = Infinity;
        var max = -Infinity;
        var len = dataNameMap[mapKey].length;
        for(var i = 0; i < len; i++){
            min = Math.min(min, dataNameMap[mapKey][i]);
            max = Math.max(max, dataNameMap[mapKey][i]);
            sum += dataNameMap[mapKey][i];
        }
        var result;
        if (statisticType === "min") result = min;
        else if (statisticType === "max") result = max;
        else if (statisticType === "average") result = sum / len;
        else result = sum;
        return len === 0 ? NaN : result;
    });
}
function $5e3d42588445ae72$export$2e2bcd8739ae039(ecModel) {
    var seriesGroups = {};
    ecModel.eachSeriesByType("map", function(seriesModel) {
        var hostGeoModel = seriesModel.getHostGeoModel();
        var key = hostGeoModel ? "o" + hostGeoModel.id : "i" + seriesModel.getMapType();
        (seriesGroups[key] = seriesGroups[key] || []).push(seriesModel);
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(seriesGroups, function(seriesList, key) {
        var data = $5e3d42588445ae72$var$dataStatistics($7a1bd9c2710fea0d$export$871de8747c9eaa88(seriesList, function(seriesModel) {
            return seriesModel.getData();
        }), seriesList[0].get("mapValueCalculation"));
        for(var i = 0; i < seriesList.length; i++)seriesList[i].originalData = seriesList[i].getData();
        // FIXME Put where?
        for(var i = 0; i < seriesList.length; i++){
            seriesList[i].seriesGroup = seriesList;
            seriesList[i].needsDrawMap = i === 0 && !seriesList[i].getHostGeoModel();
            seriesList[i].setData(data.cloneShallow());
            seriesList[i].mainSeries = seriesList[0];
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $53e61890435fb2d8$export$2e2bcd8739ae039(ecModel) {
    var processedMapType = {};
    ecModel.eachSeriesByType("map", function(mapSeries) {
        var mapType = mapSeries.getMapType();
        if (mapSeries.getHostGeoModel() || processedMapType[mapType]) return;
        var mapSymbolOffsets = {};
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(mapSeries.seriesGroup, function(subMapSeries) {
            var geo = subMapSeries.coordinateSystem;
            var data = subMapSeries.originalData;
            if (subMapSeries.get("showLegendSymbol") && ecModel.getComponent("legend")) data.each(data.mapDimension("value"), function(value, idx) {
                var name = data.getName(idx);
                var region = geo.getRegion(name);
                // If input series.data is [11, 22, '-'/null/undefined, 44],
                // it will be filled with NaN: [11, 22, NaN, 44] and NaN will
                // not be drawn. So here must validate if value is NaN.
                if (!region || isNaN(value)) return;
                var offset = mapSymbolOffsets[name] || 0;
                var point = geo.dataToPoint(region.getCenter());
                mapSymbolOffsets[name] = offset + 1;
                data.setItemLayout(idx, {
                    point: point,
                    offset: offset
                });
            });
        });
        // Show label of those region not has legendIcon (which is offset 0)
        var data = mapSeries.getData();
        data.each(function(idx) {
            var name = data.getName(idx);
            var layout = data.getItemLayout(idx) || {};
            layout.showLabel = !mapSymbolOffsets[name];
            data.setItemLayout(idx, layout);
        });
        processedMapType[mapType] = true;
    });
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $e67116e61e57a131$var$GEO_DEFAULT_PARAMS = {
    "geoJSON": {
        aspectScale: 0.75,
        invertLongitute: true
    },
    "geoSVG": {
        aspectScale: 1,
        invertLongitute: false
    }
};
var $e67116e61e57a131$export$10dbc57975912e0f = [
    "lng",
    "lat"
];
var $e67116e61e57a131$var$Geo = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(Geo, _super);
    function Geo(name, map, opt) {
        var _this = _super.call(this, name) || this;
        _this.dimensions = $e67116e61e57a131$export$10dbc57975912e0f;
        _this.type = "geo";
        // Only store specified name coord via `addGeoCoord`.
        _this._nameCoordMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        _this.map = map;
        var projection = opt.projection;
        var source = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).load(map, opt.nameMap, opt.nameProperty);
        var resource = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getGeoResource(map);
        var resourceType = _this.resourceType = resource ? resource.type : null;
        var regions = _this.regions = source.regions;
        var defaultParams = $e67116e61e57a131$var$GEO_DEFAULT_PARAMS[resource.type];
        _this._regionsMap = source.regionsMap;
        _this.regions = source.regions;
        _this.projection = projection;
        var boundingRect;
        if (projection) // Can't reuse the raw bounding rect
        for(var i = 0; i < regions.length; i++){
            var regionRect = regions[i].getBoundingRect(projection);
            boundingRect = boundingRect || regionRect.clone();
            boundingRect.union(regionRect);
        }
        else boundingRect = source.boundingRect;
        _this.setBoundingRect(boundingRect.x, boundingRect.y, boundingRect.width, boundingRect.height);
        // aspectScale and invertLongitute actually is the parameters default raw projection.
        // So we ignore them if projection is given.
        // Ignore default aspect scale if projection exits.
        _this.aspectScale = projection ? 1 : $7a1bd9c2710fea0d$export$995e01f2f5c9d030(opt.aspectScale, defaultParams.aspectScale);
        // Not invert longitude if projection exits.
        _this._invertLongitute = projection ? false : defaultParams.invertLongitute;
        return _this;
    }
    Geo.prototype._transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var invertLongitute = this._invertLongitute;
        rect = rect.clone();
        if (invertLongitute) // Longitude is inverted.
        rect.y = -rect.y - rect.height;
        var rawTransformable = this._rawTransformable;
        rawTransformable.transform = rect.calculateTransform(new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height));
        var rawParent = rawTransformable.parent;
        rawTransformable.parent = null;
        rawTransformable.decomposeTransform();
        rawTransformable.parent = rawParent;
        if (invertLongitute) rawTransformable.scaleY = -rawTransformable.scaleY;
        this._updateTransform();
    };
    Geo.prototype.getRegion = function(name) {
        return this._regionsMap.get(name);
    };
    Geo.prototype.getRegionByCoord = function(coord) {
        var regions = this.regions;
        for(var i = 0; i < regions.length; i++){
            var region = regions[i];
            if (region.type === "geoJSON" && region.contain(coord)) return regions[i];
        }
    };
    /**
   * Add geoCoord for indexing by name
   */ Geo.prototype.addGeoCoord = function(name, geoCoord) {
        this._nameCoordMap.set(name, geoCoord);
    };
    /**
   * Get geoCoord by name
   */ Geo.prototype.getGeoCoord = function(name) {
        var region = this._regionsMap.get(name);
        // Calculate center only on demand.
        return this._nameCoordMap.get(name) || region && region.getCenter();
    };
    Geo.prototype.dataToPoint = function(data, noRoam, out) {
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(data)) // Map area name to geoCoord
        data = this.getGeoCoord(data);
        if (data) {
            var projection = this.projection;
            if (projection) // projection may return null point.
            data = projection.project(data);
            return data && this.projectedToPoint(data, noRoam, out);
        }
    };
    Geo.prototype.pointToData = function(point) {
        var projection = this.projection;
        if (projection) // projection may return null point.
        point = projection.unproject(point);
        return point && this.pointToProjected(point);
    };
    /**
   * Point to projected data. Same with pointToData when projection is used.
   */ Geo.prototype.pointToProjected = function(point) {
        return _super.prototype.pointToData.call(this, point);
    };
    Geo.prototype.projectedToPoint = function(projected, noRoam, out) {
        return _super.prototype.dataToPoint.call(this, projected, noRoam, out);
    };
    Geo.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $e67116e61e57a131$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value) : null;
    };
    Geo.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $e67116e61e57a131$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel) : null;
    };
    return Geo;
}((0, $4a92e7570d47c1fe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($e67116e61e57a131$var$Geo, (0, $4a92e7570d47c1fe$export$2e2bcd8739ae039));
function $e67116e61e57a131$var$getCoordSys(finder) {
    var geoModel = finder.geoModel;
    var seriesModel = finder.seriesModel;
    return geoModel ? geoModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem // For map series.
     || (seriesModel.getReferringComponents("geo", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0] || {}).coordinateSystem : null;
}
var $e67116e61e57a131$export$2e2bcd8739ae039 = $e67116e61e57a131$var$Geo;






/**
 * Resize method bound to the geo
 */ function $303164fe3ecc2dc5$var$resizeGeo(geoModel, api) {
    var boundingCoords = geoModel.get("boundingCoords");
    if (boundingCoords != null) {
        var leftTop_1 = boundingCoords[0];
        var rightBottom_1 = boundingCoords[1];
        if (!(isFinite(leftTop_1[0]) && isFinite(leftTop_1[1]) && isFinite(rightBottom_1[0]) && isFinite(rightBottom_1[1]))) ;
        else {
            // Sample around the lng/lat rect and use projection to calculate actual bounding rect.
            var projection_1 = this.projection;
            if (projection_1) {
                var xMin = leftTop_1[0];
                var yMin = leftTop_1[1];
                var xMax = rightBottom_1[0];
                var yMax = rightBottom_1[1];
                leftTop_1 = [
                    Infinity,
                    Infinity
                ];
                rightBottom_1 = [
                    -Infinity,
                    -Infinity
                ];
                // TODO better way?
                var sampleLine = function(x0, y0, x1, y1) {
                    var dx = x1 - x0;
                    var dy = y1 - y0;
                    for(var i = 0; i <= 100; i++){
                        var p = i / 100;
                        var pt = projection_1.project([
                            x0 + dx * p,
                            y0 + dy * p
                        ]);
                        $6de594cf8ac295ff$export$96ec731ed4dcb222(leftTop_1, leftTop_1, pt);
                        $6de594cf8ac295ff$export$8960430cfd85939f(rightBottom_1, rightBottom_1, pt);
                    }
                };
                // Top
                sampleLine(xMin, yMin, xMax, yMin);
                // Right
                sampleLine(xMax, yMin, xMax, yMax);
                // Bottom
                sampleLine(xMax, yMax, xMin, yMax);
                // Left
                sampleLine(xMin, yMax, xMax, yMin);
            }
            this.setBoundingRect(leftTop_1[0], leftTop_1[1], rightBottom_1[0] - leftTop_1[0], rightBottom_1[1] - leftTop_1[1]);
        }
    }
    var rect = this.getBoundingRect();
    var centerOption = geoModel.get("layoutCenter");
    var sizeOption = geoModel.get("layoutSize");
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    var aspect = rect.width / rect.height * this.aspectScale;
    var useCenterAndSize = false;
    var center;
    var size;
    if (centerOption && sizeOption) {
        center = [
            $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(centerOption[0], viewWidth),
            $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(centerOption[1], viewHeight)
        ];
        size = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(sizeOption, Math.min(viewWidth, viewHeight));
        if (!isNaN(center[0]) && !isNaN(center[1]) && !isNaN(size)) useCenterAndSize = true;
    }
    var viewRect;
    if (useCenterAndSize) {
        viewRect = {};
        if (aspect > 1) {
            // Width is same with size
            viewRect.width = size;
            viewRect.height = size / aspect;
        } else {
            viewRect.height = size;
            viewRect.width = size * aspect;
        }
        viewRect.y = center[1] - viewRect.height / 2;
        viewRect.x = center[0] - viewRect.width / 2;
    } else {
        // Use left/top/width/height
        var boxLayoutOption = geoModel.getBoxLayoutParams();
        boxLayoutOption.aspect = aspect;
        viewRect = $93b9bc7f22ac7369$export$4517a5ca639a7293(boxLayoutOption, {
            width: viewWidth,
            height: viewHeight
        });
    }
    this.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
    this.setCenter(geoModel.get("center"), api);
    this.setZoom(geoModel.get("zoom"));
}
// Back compat for ECharts2, where the coord map is set on map series:
// {type: 'map', geoCoord: {'cityA': [116.46,39.92], 'cityA': [119.12,24.61]}},
function $303164fe3ecc2dc5$var$setGeoCoords(geo, model) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(model.get("geoCoord"), function(geoCoord, name) {
        geo.addGeoCoord(name, geoCoord);
    });
}
var $303164fe3ecc2dc5$var$GeoCreator = /** @class */ function() {
    function GeoCreator() {
        // For deciding which dimensions to use when creating list data
        this.dimensions = (0, $e67116e61e57a131$export$10dbc57975912e0f);
    }
    GeoCreator.prototype.create = function(ecModel, api) {
        var geoList = [];
        function getCommonGeoProperties(model) {
            return {
                nameProperty: model.get("nameProperty"),
                aspectScale: model.get("aspectScale"),
                projection: model.get("projection")
            };
        }
        // FIXME Create each time may be slow
        ecModel.eachComponent("geo", function(geoModel, idx) {
            var mapName = geoModel.get("map");
            var geo = new (0, $e67116e61e57a131$export$2e2bcd8739ae039)(mapName + idx, mapName, $7a1bd9c2710fea0d$export$8b58be045bf06082({
                nameMap: geoModel.get("nameMap")
            }, getCommonGeoProperties(geoModel)));
            geo.zoomLimit = geoModel.get("scaleLimit");
            geoList.push(geo);
            // setGeoCoords(geo, geoModel);
            geoModel.coordinateSystem = geo;
            geo.model = geoModel;
            // Inject resize method
            geo.resize = $303164fe3ecc2dc5$var$resizeGeo;
            geo.resize(geoModel, api);
        });
        ecModel.eachSeries(function(seriesModel) {
            var coordSys = seriesModel.get("coordinateSystem");
            if (coordSys === "geo") {
                var geoIndex = seriesModel.get("geoIndex") || 0;
                seriesModel.coordinateSystem = geoList[geoIndex];
            }
        });
        // If has map series
        var mapModelGroupBySeries = {};
        ecModel.eachSeriesByType("map", function(seriesModel) {
            if (!seriesModel.getHostGeoModel()) {
                var mapType = seriesModel.getMapType();
                mapModelGroupBySeries[mapType] = mapModelGroupBySeries[mapType] || [];
                mapModelGroupBySeries[mapType].push(seriesModel);
            }
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(mapModelGroupBySeries, function(mapSeries, mapType) {
            var nameMapList = $7a1bd9c2710fea0d$export$871de8747c9eaa88(mapSeries, function(singleMapSeries) {
                return singleMapSeries.get("nameMap");
            });
            var geo = new (0, $e67116e61e57a131$export$2e2bcd8739ae039)(mapType, mapType, $7a1bd9c2710fea0d$export$8b58be045bf06082({
                nameMap: $7a1bd9c2710fea0d$export$18aef43295bbe906(nameMapList)
            }, getCommonGeoProperties(mapSeries[0])));
            geo.zoomLimit = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66.apply(null, $7a1bd9c2710fea0d$export$871de8747c9eaa88(mapSeries, function(singleMapSeries) {
                return singleMapSeries.get("scaleLimit");
            }));
            geoList.push(geo);
            // Inject resize method
            geo.resize = $303164fe3ecc2dc5$var$resizeGeo;
            geo.resize(mapSeries[0], api);
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(mapSeries, function(singleMapSeries) {
                singleMapSeries.coordinateSystem = geo;
                $303164fe3ecc2dc5$var$setGeoCoords(geo, singleMapSeries);
            });
        });
        return geoList;
    };
    /**
   * Fill given regions array
   */ GeoCreator.prototype.getFilledRegions = function(originRegionArr, mapName, nameMap, nameProperty) {
        // Not use the original
        var regionsArr = (originRegionArr || []).slice();
        var dataNameMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        for(var i = 0; i < regionsArr.length; i++)dataNameMap.set(regionsArr[i].name, regionsArr[i]);
        var source = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).load(mapName, nameMap, nameProperty);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(source.regions, function(region) {
            var name = region.name;
            !dataNameMap.get(name) && regionsArr.push({
                name: name
            });
        });
        return regionsArr;
    };
    return GeoCreator;
}();
var $303164fe3ecc2dc5$var$geoCreator = new $303164fe3ecc2dc5$var$GeoCreator();
var $303164fe3ecc2dc5$export$2e2bcd8739ae039 = $303164fe3ecc2dc5$var$geoCreator;



var $4ff027656cc71ef0$var$GeoModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GeoModel, _super);
    function GeoModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GeoModel.type;
        return _this;
    }
    GeoModel.prototype.init = function(option, parentModel, ecModel) {
        var source = (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getGeoResource(option.map);
        if (source && source.type === "geoJSON") {
            var itemStyle = option.itemStyle = option.itemStyle || {};
            if (!("color" in itemStyle)) itemStyle.color = "#eee";
        }
        this.mergeDefaultAndTheme(option, ecModel);
        // Default label emphasis `show`
        $76d619f648247e6d$export$abdcc6a26372f94b(option, "label", [
            "show"
        ]);
    };
    GeoModel.prototype.optionUpdated = function() {
        var _this = this;
        var option = this.option;
        option.regions = (0, $303164fe3ecc2dc5$export$2e2bcd8739ae039).getFilledRegions(option.regions, option.map, option.nameMap, option.nameProperty);
        var selectedMap = {};
        this._optionModelMap = $7a1bd9c2710fea0d$export$533b26079ad0b4b(option.regions || [], function(optionModelMap, regionOpt) {
            var regionName = regionOpt.name;
            if (regionName) {
                optionModelMap.set(regionName, new (0, $6818646a97528290$export$2e2bcd8739ae039)(regionOpt, _this, _this.ecModel));
                if (regionOpt.selected) selectedMap[regionName] = true;
            }
            return optionModelMap;
        }, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4());
        if (!option.selectedMap) option.selectedMap = selectedMap;
    };
    /**
   * Get model of region.
   */ GeoModel.prototype.getRegionModel = function(name) {
        return this._optionModelMap.get(name) || new (0, $6818646a97528290$export$2e2bcd8739ae039)(null, this, this.ecModel);
    };
    /**
   * Format label
   * @param name Region name
   */ GeoModel.prototype.getFormattedLabel = function(name, status) {
        var regionModel = this.getRegionModel(name);
        var formatter = status === "normal" ? regionModel.get([
            "label",
            "formatter"
        ]) : regionModel.get([
            "emphasis",
            "label",
            "formatter"
        ]);
        var params = {
            name: name
        };
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) {
            params.status = status;
            return formatter(params);
        } else if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) return formatter.replace("{a}", name != null ? name : "");
    };
    GeoModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    GeoModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    // PENGING If selectedMode is null ?
    GeoModel.prototype.select = function(name) {
        var option = this.option;
        var selectedMode = option.selectedMode;
        if (!selectedMode) return;
        if (selectedMode !== "multiple") option.selectedMap = null;
        var selectedMap = option.selectedMap || (option.selectedMap = {});
        selectedMap[name] = true;
    };
    GeoModel.prototype.unSelect = function(name) {
        var selectedMap = this.option.selectedMap;
        if (selectedMap) selectedMap[name] = false;
    };
    GeoModel.prototype.toggleSelected = function(name) {
        this[this.isSelected(name) ? "unSelect" : "select"](name);
    };
    GeoModel.prototype.isSelected = function(name) {
        var selectedMap = this.option.selectedMap;
        return !!(selectedMap && selectedMap[name]);
    };
    GeoModel.type = "geo";
    GeoModel.layoutMode = "box";
    GeoModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        show: true,
        left: "center",
        top: "center",
        // Default value:
        // for geoSVG source: 1,
        // for geoJSON source: 0.75.
        aspectScale: null,
        // /// Layout with center and size
        // If you want to put map in a fixed size box with right aspect ratio
        // This two properties may be more convenient
        // layoutCenter: [50%, 50%]
        // layoutSize: 100
        silent: false,
        // Map type
        map: "",
        // Define left-top, right-bottom coords to control view
        // For example, [ [180, 90], [-180, -90] ]
        boundingCoords: null,
        // Default on center of map
        center: null,
        zoom: 1,
        scaleLimit: null,
        // selectedMode: false
        label: {
            show: false,
            color: "#000"
        },
        itemStyle: {
            borderWidth: 0.5,
            borderColor: "#444"
        },
        emphasis: {
            label: {
                show: true,
                color: "rgb(100,0,0)"
            },
            itemStyle: {
                color: "rgba(255,215,0,0.8)"
            }
        },
        select: {
            label: {
                show: true,
                color: "rgb(100,0,0)"
            },
            itemStyle: {
                color: "rgba(255,215,0,0.8)"
            }
        },
        regions: []
    };
    return GeoModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $4ff027656cc71ef0$export$2e2bcd8739ae039 = $4ff027656cc71ef0$var$GeoModel;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $26ced9bb0cf549b8$var$GeoView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GeoView, _super);
    function GeoView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GeoView.type;
        _this.focusBlurEnabled = true;
        return _this;
    }
    GeoView.prototype.init = function(ecModel, api) {
        this._api = api;
    };
    GeoView.prototype.render = function(geoModel, ecModel, api, payload) {
        this._model = geoModel;
        if (!geoModel.get("show")) {
            this._mapDraw && this._mapDraw.remove();
            this._mapDraw = null;
            return;
        }
        if (!this._mapDraw) this._mapDraw = new (0, $ad029c27e0f2a7ab$export$2e2bcd8739ae039)(api);
        var mapDraw = this._mapDraw;
        mapDraw.draw(geoModel, ecModel, api, this, payload);
        mapDraw.group.on("click", this._handleRegionClick, this);
        mapDraw.group.silent = geoModel.get("silent");
        this.group.add(mapDraw.group);
        this.updateSelectStatus(geoModel, ecModel, api);
    };
    GeoView.prototype._handleRegionClick = function(e) {
        var eventData;
        (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(e.target, function(current) {
            return (eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(current).eventData) != null;
        }, true);
        if (eventData) this._api.dispatchAction({
            type: "geoToggleSelect",
            geoId: this._model.id,
            name: eventData.name
        });
    };
    GeoView.prototype.updateSelectStatus = function(model, ecModel, api) {
        var _this = this;
        this._mapDraw.group.traverse(function(node) {
            var eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(node).eventData;
            if (eventData) {
                _this._model.isSelected(eventData.name) ? api.enterSelect(node) : api.leaveSelect(node);
                // No need to traverse children.
                return true;
            }
        });
    };
    GeoView.prototype.findHighDownDispatchers = function(name) {
        return this._mapDraw && this._mapDraw.findHighDownDispatchers(name, this._model);
    };
    GeoView.prototype.dispose = function() {
        this._mapDraw && this._mapDraw.remove();
    };
    GeoView.type = "geo";
    return GeoView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $26ced9bb0cf549b8$export$2e2bcd8739ae039 = $26ced9bb0cf549b8$var$GeoView;



function $8082b8b129488d44$var$registerMap(mapName, geoJson, specialAreas) {
    (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).registerMap(mapName, geoJson, specialAreas);
}
function $8082b8b129488d44$export$4b3e715f166fdd78(registers) {
    registers.registerCoordinateSystem("geo", (0, $303164fe3ecc2dc5$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $4ff027656cc71ef0$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $26ced9bb0cf549b8$export$2e2bcd8739ae039));
    registers.registerImpl("registerMap", $8082b8b129488d44$var$registerMap);
    registers.registerImpl("getMap", function(mapName) {
        return (0, $09550a1229dcb4ad$export$2e2bcd8739ae039).getMapForUser(mapName);
    });
    function makeAction(method, actionInfo) {
        actionInfo.update = "geo:updateSelectStatus";
        registers.registerAction(actionInfo, function(payload, ecModel) {
            var selected = {};
            var allSelected = [];
            ecModel.eachComponent({
                mainType: "geo",
                query: payload
            }, function(geoModel) {
                geoModel[method](payload.name);
                var geo = geoModel.coordinateSystem;
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(geo.regions, function(region) {
                    selected[region.name] = geoModel.isSelected(region.name) || false;
                });
                // Notice: there might be duplicated name in different regions.
                var names = [];
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(selected, function(v, name) {
                    selected[name] && names.push(name);
                });
                allSelected.push({
                    geoIndex: geoModel.componentIndex,
                    // Use singular, the same naming convention as the event `selectchanged`.
                    name: names
                });
            });
            return {
                selected: selected,
                allSelected: allSelected,
                name: payload.name
            };
        });
    }
    makeAction("toggleSelected", {
        type: "geoToggleSelect",
        event: "geoselectchanged"
    });
    makeAction("select", {
        type: "geoSelect",
        event: "geoselected"
    });
    makeAction("unSelect", {
        type: "geoUnSelect",
        event: "geounselected"
    });
    /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */ registers.registerAction({
        type: "geoRoam",
        event: "geoRoam",
        update: "updateTransform"
    }, function(payload, ecModel, api) {
        var componentType = payload.componentType || "series";
        ecModel.eachComponent({
            mainType: componentType,
            query: payload
        }, function(componentModel) {
            var geo = componentModel.coordinateSystem;
            if (geo.type !== "geo") return;
            var res = (0, $799fe5cfb5042219$export$797ecc50d262ebd8)(geo, payload, componentModel.get("scaleLimit"), api);
            componentModel.setCenter && componentModel.setCenter(res.center);
            componentModel.setZoom && componentModel.setZoom(res.zoom);
            // All map series with same `map` use the same geo coordinate system
            // So the center and zoom must be in sync. Include the series not selected by legend
            if (componentType === "series") (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(componentModel.seriesGroup, function(seriesModel) {
                seriesModel.setCenter(res.center);
                seriesModel.setZoom(res.zoom);
            });
        });
    });
}


function $6c94070aa7d5e098$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $8082b8b129488d44$export$4b3e715f166fdd78));
    registers.registerChartView((0, $1c3add93106395a4$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $f2f4aa5429e1d3d3$export$2e2bcd8739ae039));
    registers.registerLayout((0, $53e61890435fb2d8$export$2e2bcd8739ae039));
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $5e3d42588445ae72$export$2e2bcd8739ae039));
    (0, $e855ccf7eff48bce$export$62942ba95693dbfc)("map", registers.registerAction);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $9e57680b9c04f083$var$DEFAULT_SMOOTH = 0.3;
var $9e57680b9c04f083$var$ParallelView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelView, _super);
    function ParallelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelView.type;
        _this._dataGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        _this._initialized = false;
        return _this;
    }
    ParallelView.prototype.init = function() {
        this.group.add(this._dataGroup);
    };
    /**
   * @override
   */ ParallelView.prototype.render = function(seriesModel, ecModel, api, payload) {
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        var dataGroup = this._dataGroup;
        var data = seriesModel.getData();
        var oldData = this._data;
        var coordSys = seriesModel.coordinateSystem;
        var dimensions = coordSys.dimensions;
        var seriesScope = $9e57680b9c04f083$var$makeSeriesScope(seriesModel);
        data.diff(oldData).add(add).update(update).remove(remove).execute();
        function add(newDataIndex) {
            var line = $9e57680b9c04f083$var$addEl(data, dataGroup, newDataIndex, dimensions, coordSys);
            $9e57680b9c04f083$var$updateElCommon(line, data, newDataIndex, seriesScope);
        }
        function update(newDataIndex, oldDataIndex) {
            var line = oldData.getItemGraphicEl(oldDataIndex);
            var points = $9e57680b9c04f083$var$createLinePoints(data, newDataIndex, dimensions, coordSys);
            data.setItemGraphicEl(newDataIndex, line);
            $8b353638fbedfefa$export$c8dce3c08436e91e(line, {
                shape: {
                    points: points
                }
            }, seriesModel, newDataIndex);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(line);
            $9e57680b9c04f083$var$updateElCommon(line, data, newDataIndex, seriesScope);
        }
        function remove(oldDataIndex) {
            var line = oldData.getItemGraphicEl(oldDataIndex);
            dataGroup.remove(line);
        }
        // First create
        if (!this._initialized) {
            this._initialized = true;
            var clipPath = $9e57680b9c04f083$var$createGridClipShape(coordSys, seriesModel, function() {
                // Callback will be invoked immediately if there is no animation
                setTimeout(function() {
                    dataGroup.removeClipPath();
                });
            });
            dataGroup.setClipPath(clipPath);
        }
        this._data = data;
    };
    ParallelView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        this._initialized = true;
        this._data = null;
        this._dataGroup.removeAll();
    };
    ParallelView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        var data = seriesModel.getData();
        var coordSys = seriesModel.coordinateSystem;
        var dimensions = coordSys.dimensions;
        var seriesScope = $9e57680b9c04f083$var$makeSeriesScope(seriesModel);
        var progressiveEls = this._progressiveEls = [];
        for(var dataIndex = taskParams.start; dataIndex < taskParams.end; dataIndex++){
            var line = $9e57680b9c04f083$var$addEl(data, this._dataGroup, dataIndex, dimensions, coordSys);
            line.incremental = true;
            $9e57680b9c04f083$var$updateElCommon(line, data, dataIndex, seriesScope);
            progressiveEls.push(line);
        }
    };
    ParallelView.prototype.remove = function() {
        this._dataGroup && this._dataGroup.removeAll();
        this._data = null;
    };
    ParallelView.type = "parallel";
    return ParallelView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
function $9e57680b9c04f083$var$createGridClipShape(coordSys, seriesModel, cb) {
    var parallelModel = coordSys.model;
    var rect = coordSys.getRect();
    var rectEl = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        }
    });
    var dim = parallelModel.get("layout") === "horizontal" ? "width" : "height";
    rectEl.setShape(dim, 0);
    $8b353638fbedfefa$export$a121566aadcfe021(rectEl, {
        shape: {
            width: rect.width,
            height: rect.height
        }
    }, seriesModel, cb);
    return rectEl;
}
function $9e57680b9c04f083$var$createLinePoints(data, dataIndex, dimensions, coordSys) {
    var points = [];
    for(var i = 0; i < dimensions.length; i++){
        var dimName = dimensions[i];
        var value = data.get(data.mapDimension(dimName), dataIndex);
        if (!$9e57680b9c04f083$var$isEmptyValue(value, coordSys.getAxis(dimName).type)) points.push(coordSys.dataToPoint(value, dimName));
    }
    return points;
}
function $9e57680b9c04f083$var$addEl(data, dataGroup, dataIndex, dimensions, coordSys) {
    var points = $9e57680b9c04f083$var$createLinePoints(data, dataIndex, dimensions, coordSys);
    var line = new $d28119f30e6bb670$export$2e2bcd8739ae039({
        shape: {
            points: points
        },
        // silent: true,
        z2: 10
    });
    dataGroup.add(line);
    data.setItemGraphicEl(dataIndex, line);
    return line;
}
function $9e57680b9c04f083$var$makeSeriesScope(seriesModel) {
    var smooth = seriesModel.get("smooth", true);
    smooth === true && (smooth = $9e57680b9c04f083$var$DEFAULT_SMOOTH);
    smooth = (0, $cfc1f3b422a3185f$export$8b4007b942b45a96)(smooth);
    (0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(smooth) && (smooth = 0);
    return {
        smooth: smooth
    };
}
function $9e57680b9c04f083$var$updateElCommon(el, data, dataIndex, seriesScope) {
    el.useStyle(data.getItemVisual(dataIndex, "style"));
    el.style.fill = null;
    el.setShape("smooth", seriesScope.smooth);
    var itemModel = data.getItemModel(dataIndex);
    var emphasisModel = itemModel.getModel("emphasis");
    (0, $2bf82c0980125b62$export$48b68047d330bbc9)(el, itemModel, "lineStyle");
    (0, $2bf82c0980125b62$export$e51187539ff11209)(el, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
}
// function simpleDiff(oldData, newData, dimensions) {
//     let oldLen;
//     if (!oldData
//         || !oldData.__plProgressive
//         || (oldLen = oldData.count()) !== newData.count()
//     ) {
//         return true;
//     }
//     let dimLen = dimensions.length;
//     for (let i = 0; i < oldLen; i++) {
//         for (let j = 0; j < dimLen; j++) {
//             if (oldData.get(dimensions[j], i) !== newData.get(dimensions[j], i)) {
//                 return true;
//             }
//         }
//     }
//     return false;
// }
// FIXME put in common util?
function $9e57680b9c04f083$var$isEmptyValue(val, axisType) {
    return axisType === "category" ? val == null : val == null || isNaN(val); // axisType === 'value'
}
var $9e57680b9c04f083$export$2e2bcd8739ae039 = $9e57680b9c04f083$var$ParallelView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $5d63691998e05817$var$ParallelSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelSeriesModel, _super);
    function ParallelSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelSeriesModel.type;
        _this.visualStyleAccessPath = "lineStyle";
        _this.visualDrawType = "stroke";
        return _this;
    }
    ParallelSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($5d63691998e05817$var$makeDefaultEncode, null, this)
        });
    };
    /**
   * User can get data raw indices on 'axisAreaSelected' event received.
   *
   * @return Raw indices
   */ ParallelSeriesModel.prototype.getRawIndicesByActiveState = function(activeState) {
        var coordSys = this.coordinateSystem;
        var data = this.getData();
        var indices = [];
        coordSys.eachActiveState(data, function(theActiveState, dataIndex) {
            if (activeState === theActiveState) indices.push(data.getRawIndex(dataIndex));
        });
        return indices;
    };
    ParallelSeriesModel.type = "series.parallel";
    ParallelSeriesModel.dependencies = [
        "parallel"
    ];
    ParallelSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "parallel",
        parallelIndex: 0,
        label: {
            show: false
        },
        inactiveOpacity: 0.05,
        activeOpacity: 1,
        lineStyle: {
            width: 1,
            opacity: 0.45,
            type: "solid"
        },
        emphasis: {
            label: {
                show: false
            }
        },
        progressive: 500,
        smooth: false,
        animationEasing: "linear"
    };
    return ParallelSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
function $5d63691998e05817$var$makeDefaultEncode(seriesModel) {
    // The mapping of parallelAxis dimension to data dimension can
    // be specified in parallelAxis.option.dim. For example, if
    // parallelAxis.option.dim is 'dim3', it mapping to the third
    // dimension of data. But `data.encode` has higher priority.
    // Moreover, parallelModel.dimension should not be regarded as data
    // dimensions. Consider dimensions = ['dim4', 'dim2', 'dim6'];
    var parallelModel = seriesModel.ecModel.getComponent("parallel", seriesModel.get("parallelIndex"));
    if (!parallelModel) return;
    var encodeDefine = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(parallelModel.dimensions, function(axisDim) {
        var dataDimIndex = $5d63691998e05817$var$convertDimNameToNumber(axisDim);
        encodeDefine[axisDim] = dataDimIndex;
    });
    return encodeDefine;
}
function $5d63691998e05817$var$convertDimNameToNumber(dimName) {
    return +dimName.replace("dim", "");
}
var $5d63691998e05817$export$2e2bcd8739ae039 = $5d63691998e05817$var$ParallelSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $8148e21d655f67c8$var$opacityAccessPath = [
    "lineStyle",
    "opacity"
];
var $8148e21d655f67c8$var$parallelVisual = {
    seriesType: "parallel",
    reset: function(seriesModel, ecModel) {
        var coordSys = seriesModel.coordinateSystem;
        var opacityMap = {
            normal: seriesModel.get([
                "lineStyle",
                "opacity"
            ]),
            active: seriesModel.get("activeOpacity"),
            inactive: seriesModel.get("inactiveOpacity")
        };
        return {
            progress: function(params, data) {
                coordSys.eachActiveState(data, function(activeState, dataIndex) {
                    var opacity = opacityMap[activeState];
                    if (activeState === "normal" && data.hasItemOption) {
                        var itemOpacity = data.getItemModel(dataIndex).get($8148e21d655f67c8$var$opacityAccessPath, true);
                        itemOpacity != null && (opacity = itemOpacity);
                    }
                    var existsStyle = data.ensureUniqueItemVisual(dataIndex, "style");
                    existsStyle.opacity = opacity;
                }, params.start, params.end);
            }
        };
    }
};
var $8148e21d655f67c8$export$2e2bcd8739ae039 = $8148e21d655f67c8$var$parallelVisual;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $30173db3404062fa$export$2e2bcd8739ae039(option) {
    $30173db3404062fa$var$createParallelIfNeeded(option);
    $30173db3404062fa$var$mergeAxisOptionFromParallel(option);
}
/**
 * Create a parallel coordinate if not exists.
 * @inner
 */ function $30173db3404062fa$var$createParallelIfNeeded(option) {
    if (option.parallel) return;
    var hasParallelSeries = false;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(option.series, function(seriesOpt) {
        if (seriesOpt && seriesOpt.type === "parallel") hasParallelSeries = true;
    });
    if (hasParallelSeries) option.parallel = [
        {}
    ];
}
/**
 * Merge aixs definition from parallel option (if exists) to axis option.
 * @inner
 */ function $30173db3404062fa$var$mergeAxisOptionFromParallel(option) {
    var axes = $76d619f648247e6d$export$4f07b212a02c8051(option.parallelAxis);
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(axes, function(axisOption) {
        if (!$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(axisOption)) return;
        var parallelIndex = axisOption.parallelIndex || 0;
        var parallelOption = $76d619f648247e6d$export$4f07b212a02c8051(option.parallel)[parallelIndex];
        if (parallelOption && parallelOption.parallelAxisDefault) $7a1bd9c2710fea0d$export$4950aa0f605343fb(axisOption, parallelOption.parallelAxisDefault, false);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $ccce4513d4baec6a$var$CLICK_THRESHOLD = 5; // > 4
var $ccce4513d4baec6a$var$ParallelView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelView, _super);
    function ParallelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelView.type;
        return _this;
    }
    ParallelView.prototype.render = function(parallelModel, ecModel, api) {
        this._model = parallelModel;
        this._api = api;
        if (!this._handlers) {
            this._handlers = {};
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($ccce4513d4baec6a$var$handlers, function(handler, eventName) {
                api.getZr().on(eventName, this._handlers[eventName] = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(handler, this));
            }, this);
        }
        (0, $c98659a9437a3d2e$export$958e3e1a02eac4b6)(this, "_throttledDispatchExpand", parallelModel.get("axisExpandRate"), "fixRate");
    };
    ParallelView.prototype.dispose = function(ecModel, api) {
        (0, $c98659a9437a3d2e$export$42ffd38884aecdac)(this, "_throttledDispatchExpand");
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._handlers, function(handler, eventName) {
            api.getZr().off(eventName, handler);
        });
        this._handlers = null;
    };
    /**
   * @internal
   * @param {Object} [opt] If null, cancel the last action triggering for debounce.
   */ ParallelView.prototype._throttledDispatchExpand = function(opt) {
        this._dispatchExpand(opt);
    };
    /**
   * @internal
   */ ParallelView.prototype._dispatchExpand = function(opt) {
        opt && this._api.dispatchAction((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            type: "parallelAxisExpand"
        }, opt));
    };
    ParallelView.type = "parallel";
    return ParallelView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $ccce4513d4baec6a$var$handlers = {
    mousedown: function(e) {
        if ($ccce4513d4baec6a$var$checkTrigger(this, "click")) this._mouseDownPoint = [
            e.offsetX,
            e.offsetY
        ];
    },
    mouseup: function(e) {
        var mouseDownPoint = this._mouseDownPoint;
        if ($ccce4513d4baec6a$var$checkTrigger(this, "click") && mouseDownPoint) {
            var point = [
                e.offsetX,
                e.offsetY
            ];
            var dist = Math.pow(mouseDownPoint[0] - point[0], 2) + Math.pow(mouseDownPoint[1] - point[1], 2);
            if (dist > $ccce4513d4baec6a$var$CLICK_THRESHOLD) return;
            var result = this._model.coordinateSystem.getSlidedAxisExpandWindow([
                e.offsetX,
                e.offsetY
            ]);
            result.behavior !== "none" && this._dispatchExpand({
                axisExpandWindow: result.axisExpandWindow
            });
        }
        this._mouseDownPoint = null;
    },
    mousemove: function(e) {
        // Should do nothing when brushing.
        if (this._mouseDownPoint || !$ccce4513d4baec6a$var$checkTrigger(this, "mousemove")) return;
        var model = this._model;
        var result = model.coordinateSystem.getSlidedAxisExpandWindow([
            e.offsetX,
            e.offsetY
        ]);
        var behavior = result.behavior;
        behavior === "jump" && this._throttledDispatchExpand.debounceNextCall(model.get("axisExpandDebounce"));
        this._throttledDispatchExpand(behavior === "none" ? null // Cancel the last trigger, in case that mouse slide out of the area quickly.
         : {
            axisExpandWindow: result.axisExpandWindow,
            // Jumping uses animation, and sliding suppresses animation.
            animation: behavior === "jump" ? null : {
                duration: 0 // Disable animation.
            }
        });
    }
};
function $ccce4513d4baec6a$var$checkTrigger(view, triggerOn) {
    var model = view._model;
    return model.get("axisExpandable") && model.get("axisExpandTriggerOn") === triggerOn;
}
var $ccce4513d4baec6a$export$2e2bcd8739ae039 = $ccce4513d4baec6a$var$ParallelView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $a14d8e1511adaa1e$var$ParallelModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelModel, _super);
    function ParallelModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelModel.type;
        return _this;
    }
    ParallelModel.prototype.init = function() {
        _super.prototype.init.apply(this, arguments);
        this.mergeOption({});
    };
    ParallelModel.prototype.mergeOption = function(newOption) {
        var thisOption = this.option;
        newOption && $7a1bd9c2710fea0d$export$4950aa0f605343fb(thisOption, newOption, true);
        this._initDimensions();
    };
    /**
   * Whether series or axis is in this coordinate system.
   */ ParallelModel.prototype.contains = function(model, ecModel) {
        var parallelIndex = model.get("parallelIndex");
        return parallelIndex != null && ecModel.getComponent("parallel", parallelIndex) === this;
    };
    ParallelModel.prototype.setAxisExpand = function(opt) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            "axisExpandable",
            "axisExpandCenter",
            "axisExpandCount",
            "axisExpandWidth",
            "axisExpandWindow"
        ], function(name) {
            if (opt.hasOwnProperty(name)) // @ts-ignore FIXME: why "never" inferred in this.option[name]?
            this.option[name] = opt[name];
        }, this);
    };
    ParallelModel.prototype._initDimensions = function() {
        var dimensions = this.dimensions = [];
        var parallelAxisIndex = this.parallelAxisIndex = [];
        var axisModels = $7a1bd9c2710fea0d$export$3dea766d36a8935f(this.ecModel.queryComponents({
            mainType: "parallelAxis"
        }), function(axisModel) {
            // Can not use this.contains here, because
            // initialization has not been completed yet.
            return (axisModel.get("parallelIndex") || 0) === this.componentIndex;
        }, this);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(axisModels, function(axisModel) {
            dimensions.push("dim" + axisModel.get("dim"));
            parallelAxisIndex.push(axisModel.componentIndex);
        });
    };
    ParallelModel.type = "parallel";
    ParallelModel.dependencies = [
        "parallelAxis"
    ];
    ParallelModel.layoutMode = "box";
    ParallelModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        left: 80,
        top: 60,
        right: 80,
        bottom: 60,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        layout: "horizontal",
        // FIXME
        // naming?
        axisExpandable: false,
        axisExpandCenter: null,
        axisExpandCount: 0,
        axisExpandWidth: 50,
        axisExpandRate: 17,
        axisExpandDebounce: 50,
        // [out, in, jumpTarget]. In percentage. If use [null, 0.05], null means full.
        // Do not doc to user until necessary.
        axisExpandSlideTriggerArea: [
            -0.15,
            0.05,
            0.4
        ],
        axisExpandTriggerOn: "click",
        parallelAxisDefault: null
    };
    return ParallelModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $a14d8e1511adaa1e$export$2e2bcd8739ae039 = $a14d8e1511adaa1e$var$ParallelModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parallel coordinate system creater.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parallel Coordinates
 * <https://en.wikipedia.org/wiki/Parallel_coordinates>
 */ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1754de95b9b9c398$var$Scale = /** @class */ function() {
    function Scale(setting) {
        this._setting = setting || {};
        this._extent = [
            Infinity,
            -Infinity
        ];
    }
    Scale.prototype.getSetting = function(name) {
        return this._setting[name];
    };
    /**
   * Set extent from data
   */ Scale.prototype.unionExtent = function(other) {
        var extent = this._extent;
        other[0] < extent[0] && (extent[0] = other[0]);
        other[1] > extent[1] && (extent[1] = other[1]);
    // not setExtent because in log axis it may transformed to power
    // this.setExtent(extent[0], extent[1]);
    };
    /**
   * Set extent from data
   */ Scale.prototype.unionExtentFromData = function(data, dim) {
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * Get extent
   *
   * Extent is always in increase order.
   */ Scale.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Set extent
   */ Scale.prototype.setExtent = function(start, end) {
        var thisExtent = this._extent;
        if (!isNaN(start)) thisExtent[0] = start;
        if (!isNaN(end)) thisExtent[1] = end;
    };
    /**
   * If value is in extent range
   */ Scale.prototype.isInExtentRange = function(value) {
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.isBlank = function() {
        return this._isBlank;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.setBlank = function(isBlank) {
        this._isBlank = isBlank;
    };
    return Scale;
}();
$cd5f95cf03b4e3e7$export$241315e45585454d($1754de95b9b9c398$var$Scale);
var $1754de95b9b9c398$export$2e2bcd8739ae039 = $1754de95b9b9c398$var$Scale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $57fe7cbbaae9fab0$var$uidBase = 0;
var $57fe7cbbaae9fab0$var$OrdinalMeta = /** @class */ function() {
    function OrdinalMeta(opt) {
        this.categories = opt.categories || [];
        this._needCollect = opt.needCollect;
        this._deduplication = opt.deduplication;
        this.uid = ++$57fe7cbbaae9fab0$var$uidBase;
    }
    OrdinalMeta.createByAxisModel = function(axisModel) {
        var option = axisModel.option;
        var data = option.data;
        var categories = data && (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(data, $57fe7cbbaae9fab0$var$getName);
        return new OrdinalMeta({
            categories: categories,
            needCollect: !categories,
            // deduplication is default in axis.
            deduplication: option.dedplication !== false
        });
    };
    OrdinalMeta.prototype.getOrdinal = function(category) {
        // @ts-ignore
        return this._getOrCreateMap().get(category);
    };
    /**
   * @return The ordinal. If not found, return NaN.
   */ OrdinalMeta.prototype.parseAndCollect = function(category) {
        var index;
        var needCollect = this._needCollect;
        // The value of category dim can be the index of the given category set.
        // This feature is only supported when !needCollect, because we should
        // consider a common case: a value is 2017, which is a number but is
        // expected to be tread as a category. This case usually happen in dataset,
        // where it happent to be no need of the index feature.
        if (!(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(category) && !needCollect) return category;
        // Optimize for the scenario:
        // category is ['2012-01-01', '2012-01-02', ...], where the input
        // data has been ensured not duplicate and is large data.
        // Notice, if a dataset dimension provide categroies, usually echarts
        // should remove duplication except user tell echarts dont do that
        // (set axis.deduplication = false), because echarts do not know whether
        // the values in the category dimension has duplication (consider the
        // parallel-aqi example)
        if (needCollect && !this._deduplication) {
            index = this.categories.length;
            this.categories[index] = category;
            return index;
        }
        var map = this._getOrCreateMap();
        // @ts-ignore
        index = map.get(category);
        if (index == null) {
            if (needCollect) {
                index = this.categories.length;
                this.categories[index] = category;
                // @ts-ignore
                map.set(category, index);
            } else index = NaN;
        }
        return index;
    };
    // Consider big data, do not create map until needed.
    OrdinalMeta.prototype._getOrCreateMap = function() {
        return this._map || (this._map = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)(this.categories));
    };
    return OrdinalMeta;
}();
function $57fe7cbbaae9fab0$var$getName(obj) {
    if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(obj) && obj.value != null) return obj.value;
    else return obj + "";
}
var $57fe7cbbaae9fab0$export$2e2bcd8739ae039 = $57fe7cbbaae9fab0$var$OrdinalMeta;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $60f7f1f3e3996637$export$a8a5b03ea14764df(val) {
    var exp10 = Math.pow(10, (0, $cfc1f3b422a3185f$export$97256a17b20a0c24)(Math.abs(val)));
    var f = Math.abs(val / exp10);
    return f === 0 || f === 1 || f === 2 || f === 3 || f === 5;
}
function $60f7f1f3e3996637$export$dfc8cd28ed7b22a0(scale) {
    return scale.type === "interval" || scale.type === "log";
}
function $60f7f1f3e3996637$export$eeea879a611eb991(extent, splitNumber, minInterval, maxInterval) {
    var result = {};
    var span = extent[1] - extent[0];
    var interval = result.interval = (0, $cfc1f3b422a3185f$export$7a695fe44258210b)(span / splitNumber, true);
    if (minInterval != null && interval < minInterval) interval = result.interval = minInterval;
    if (maxInterval != null && interval > maxInterval) interval = result.interval = maxInterval;
    // Tow more digital for tick.
    var precision = result.intervalPrecision = $60f7f1f3e3996637$export$86a060b060d3d31a(interval);
    // Niced extent inside original extent
    var niceTickExtent = result.niceTickExtent = [
        (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(Math.ceil(extent[0] / interval) * interval, precision),
        (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(Math.floor(extent[1] / interval) * interval, precision)
    ];
    $60f7f1f3e3996637$export$624b8c8c438031ad(niceTickExtent, extent);
    return result;
}
function $60f7f1f3e3996637$export$f39031e8422f329d(interval) {
    var exp10 = Math.pow(10, (0, $cfc1f3b422a3185f$export$97256a17b20a0c24)(interval));
    // Increase interval
    var f = interval / exp10;
    if (!f) f = 1;
    else if (f === 2) f = 3;
    else if (f === 3) f = 5;
    else // f is 1 or 5
    f *= 2;
    return (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(f * exp10);
}
function $60f7f1f3e3996637$export$86a060b060d3d31a(interval) {
    // Tow more digital for tick.
    return (0, $cfc1f3b422a3185f$export$e0c74b50bbd10f68)(interval) + 2;
}
function $60f7f1f3e3996637$var$clamp(niceTickExtent, idx, extent) {
    niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
}
function $60f7f1f3e3996637$export$624b8c8c438031ad(niceTickExtent, extent) {
    !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
    !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
    $60f7f1f3e3996637$var$clamp(niceTickExtent, 0, extent);
    $60f7f1f3e3996637$var$clamp(niceTickExtent, 1, extent);
    if (niceTickExtent[0] > niceTickExtent[1]) niceTickExtent[0] = niceTickExtent[1];
}
function $60f7f1f3e3996637$export$8893e2b90ba10d92(val, extent) {
    return val >= extent[0] && val <= extent[1];
}
function $60f7f1f3e3996637$export$a3295358bff77e(val, extent) {
    if (extent[1] === extent[0]) return 0.5;
    return (val - extent[0]) / (extent[1] - extent[0]);
}
function $60f7f1f3e3996637$export$dcdf75081b88279d(val, extent) {
    return val * (extent[1] - extent[0]) + extent[0];
}



var $6e82606ec775d365$var$OrdinalScale = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(OrdinalScale, _super);
    function OrdinalScale(setting) {
        var _this = _super.call(this, setting) || this;
        _this.type = "ordinal";
        var ordinalMeta = _this.getSetting("ordinalMeta");
        // Caution: Should not use instanceof, consider ec-extensions using
        // import approach to get OrdinalMeta class.
        if (!ordinalMeta) ordinalMeta = new (0, $57fe7cbbaae9fab0$export$2e2bcd8739ae039)({});
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(ordinalMeta)) ordinalMeta = new (0, $57fe7cbbaae9fab0$export$2e2bcd8739ae039)({
            categories: (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(ordinalMeta, function(item) {
                return (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(item) ? item.value : item;
            })
        });
        _this._ordinalMeta = ordinalMeta;
        _this._extent = _this.getSetting("extent") || [
            0,
            ordinalMeta.categories.length - 1
        ];
        return _this;
    }
    OrdinalScale.prototype.parse = function(val) {
        // Caution: Math.round(null) will return `0` rather than `NaN`
        if (val == null) return NaN;
        return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(val) ? this._ordinalMeta.getOrdinal(val) : Math.round(val);
    };
    OrdinalScale.prototype.contain = function(rank) {
        rank = this.parse(rank);
        return $60f7f1f3e3996637$export$8893e2b90ba10d92(rank, this._extent) && this._ordinalMeta.categories[rank] != null;
    };
    /**
   * Normalize given rank or name to linear [0, 1]
   * @param val raw ordinal number.
   * @return normalized value in [0, 1].
   */ OrdinalScale.prototype.normalize = function(val) {
        val = this._getTickNumber(this.parse(val));
        return $60f7f1f3e3996637$export$a3295358bff77e(val, this._extent);
    };
    /**
   * @param val normalized value in [0, 1].
   * @return raw ordinal number.
   */ OrdinalScale.prototype.scale = function(val) {
        val = Math.round($60f7f1f3e3996637$export$dcdf75081b88279d(val, this._extent));
        return this.getRawOrdinalNumber(val);
    };
    OrdinalScale.prototype.getTicks = function() {
        var ticks = [];
        var extent = this._extent;
        var rank = extent[0];
        while(rank <= extent[1]){
            ticks.push({
                value: rank
            });
            rank++;
        }
        return ticks;
    };
    OrdinalScale.prototype.getMinorTicks = function(splitNumber) {
        // Not support.
        return;
    };
    /**
   * @see `Ordinal['_ordinalNumbersByTick']`
   */ OrdinalScale.prototype.setSortInfo = function(info) {
        if (info == null) {
            this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
            return;
        }
        var infoOrdinalNumbers = info.ordinalNumbers;
        var ordinalsByTick = this._ordinalNumbersByTick = [];
        var ticksByOrdinal = this._ticksByOrdinalNumber = [];
        // Unnecessary support negative tick in `realtimeSort`.
        var tickNum = 0;
        var allCategoryLen = this._ordinalMeta.categories.length;
        for(var len = Math.min(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum){
            var ordinalNumber = infoOrdinalNumbers[tickNum];
            ordinalsByTick[tickNum] = ordinalNumber;
            ticksByOrdinal[ordinalNumber] = tickNum;
        }
        // Handle that `series.data` only covers part of the `axis.category.data`.
        var unusedOrdinal = 0;
        for(; tickNum < allCategoryLen; ++tickNum){
            while(ticksByOrdinal[unusedOrdinal] != null)unusedOrdinal++;
            ordinalsByTick.push(unusedOrdinal);
            ticksByOrdinal[unusedOrdinal] = tickNum;
        }
    };
    OrdinalScale.prototype._getTickNumber = function(ordinal) {
        var ticksByOrdinalNumber = this._ticksByOrdinalNumber;
        // also support ordinal out of range of `ordinalMeta.categories.length`,
        // where ordinal numbers are used as tick value directly.
        return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
    };
    /**
   * @usage
   * ```js
   * const ordinalNumber = ordinalScale.getRawOrdinalNumber(tickVal);
   *
   * // case0
   * const rawOrdinalValue = axisModel.getCategories()[ordinalNumber];
   * // case1
   * const rawOrdinalValue = this._ordinalMeta.categories[ordinalNumber];
   * // case2
   * const coord = axis.dataToCoord(ordinalNumber);
   * ```
   *
   * @param {OrdinalNumber} tickNumber index of display
   */ OrdinalScale.prototype.getRawOrdinalNumber = function(tickNumber) {
        var ordinalNumbersByTick = this._ordinalNumbersByTick;
        // tickNumber may be out of range, e.g., when axis max is larger than `ordinalMeta.categories.length`.,
        // where ordinal numbers are used as tick value directly.
        return ordinalNumbersByTick && tickNumber >= 0 && tickNumber < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickNumber] : tickNumber;
    };
    /**
   * Get item on tick
   */ OrdinalScale.prototype.getLabel = function(tick) {
        if (!this.isBlank()) {
            var ordinalNumber = this.getRawOrdinalNumber(tick.value);
            var cateogry = this._ordinalMeta.categories[ordinalNumber];
            // Note that if no data, ordinalMeta.categories is an empty array.
            // Return empty if it's not exist.
            return cateogry == null ? "" : cateogry + "";
        }
    };
    OrdinalScale.prototype.count = function() {
        return this._extent[1] - this._extent[0] + 1;
    };
    OrdinalScale.prototype.unionExtentFromData = function(data, dim) {
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * @override
   * If value is in extent range
   */ OrdinalScale.prototype.isInExtentRange = function(value) {
        value = this._getTickNumber(value);
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    OrdinalScale.prototype.getOrdinalMeta = function() {
        return this._ordinalMeta;
    };
    OrdinalScale.prototype.calcNiceTicks = function() {};
    OrdinalScale.prototype.calcNiceExtent = function() {};
    OrdinalScale.type = "ordinal";
    return OrdinalScale;
}((0, $1754de95b9b9c398$export$2e2bcd8739ae039));
(0, $1754de95b9b9c398$export$2e2bcd8739ae039).registerClass($6e82606ec775d365$var$OrdinalScale);
var $6e82606ec775d365$export$2e2bcd8739ae039 = $6e82606ec775d365$var$OrdinalScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $dddb89ade16db3d5$var$roundNumber = $cfc1f3b422a3185f$export$2077e0241d6afd3c;
var $dddb89ade16db3d5$var$IntervalScale = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(IntervalScale, _super);
    function IntervalScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "interval";
        // Step is calculated in adjustExtent.
        _this._interval = 0;
        _this._intervalPrecision = 2;
        return _this;
    }
    IntervalScale.prototype.parse = function(val) {
        return val;
    };
    IntervalScale.prototype.contain = function(val) {
        return $60f7f1f3e3996637$export$8893e2b90ba10d92(val, this._extent);
    };
    IntervalScale.prototype.normalize = function(val) {
        return $60f7f1f3e3996637$export$a3295358bff77e(val, this._extent);
    };
    IntervalScale.prototype.scale = function(val) {
        return $60f7f1f3e3996637$export$dcdf75081b88279d(val, this._extent);
    };
    IntervalScale.prototype.setExtent = function(start, end) {
        var thisExtent = this._extent;
        // start,end may be a Number like '25',so...
        if (!isNaN(start)) thisExtent[0] = parseFloat(start);
        if (!isNaN(end)) thisExtent[1] = parseFloat(end);
    };
    IntervalScale.prototype.unionExtent = function(other) {
        var extent = this._extent;
        other[0] < extent[0] && (extent[0] = other[0]);
        other[1] > extent[1] && (extent[1] = other[1]);
        // unionExtent may called by it's sub classes
        this.setExtent(extent[0], extent[1]);
    };
    IntervalScale.prototype.getInterval = function() {
        return this._interval;
    };
    IntervalScale.prototype.setInterval = function(interval) {
        this._interval = interval;
        // Dropped auto calculated niceExtent and use user-set extent.
        // We assume user wants to set both interval, min, max to get a better result.
        this._niceExtent = this._extent.slice();
        this._intervalPrecision = $60f7f1f3e3996637$export$86a060b060d3d31a(interval);
    };
    /**
   * @param expandToNicedExtent Whether expand the ticks to niced extent.
   */ IntervalScale.prototype.getTicks = function(expandToNicedExtent) {
        var interval = this._interval;
        var extent = this._extent;
        var niceTickExtent = this._niceExtent;
        var intervalPrecision = this._intervalPrecision;
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        // Consider this case: using dataZoom toolbox, zoom and zoom.
        var safeLimit = 10000;
        if (extent[0] < niceTickExtent[0]) {
            if (expandToNicedExtent) ticks.push({
                value: $dddb89ade16db3d5$var$roundNumber(niceTickExtent[0] - interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[0]
            });
        }
        var tick = niceTickExtent[0];
        while(tick <= niceTickExtent[1]){
            ticks.push({
                value: tick
            });
            // Avoid rounding error
            tick = $dddb89ade16db3d5$var$roundNumber(tick + interval, intervalPrecision);
            if (tick === ticks[ticks.length - 1].value) break;
            if (ticks.length > safeLimit) return [];
        }
        // Consider this case: the last item of ticks is smaller
        // than niceTickExtent[1] and niceTickExtent[1] === extent[1].
        var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceTickExtent[1];
        if (extent[1] > lastNiceTick) {
            if (expandToNicedExtent) ticks.push({
                value: $dddb89ade16db3d5$var$roundNumber(lastNiceTick + interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[1]
            });
        }
        return ticks;
    };
    IntervalScale.prototype.getMinorTicks = function(splitNumber) {
        var ticks = this.getTicks(true);
        var minorTicks = [];
        var extent = this.getExtent();
        for(var i = 1; i < ticks.length; i++){
            var nextTick = ticks[i];
            var prevTick = ticks[i - 1];
            var count = 0;
            var minorTicksGroup = [];
            var interval = nextTick.value - prevTick.value;
            var minorInterval = interval / splitNumber;
            while(count < splitNumber - 1){
                var minorTick = $dddb89ade16db3d5$var$roundNumber(prevTick.value + (count + 1) * minorInterval);
                // For the first and last interval. The count may be less than splitNumber.
                if (minorTick > extent[0] && minorTick < extent[1]) minorTicksGroup.push(minorTick);
                count++;
            }
            minorTicks.push(minorTicksGroup);
        }
        return minorTicks;
    };
    /**
   * @param opt.precision If 'auto', use nice presision.
   * @param opt.pad returns 1.50 but not 1.5 if precision is 2.
   */ IntervalScale.prototype.getLabel = function(data, opt) {
        if (data == null) return "";
        var precision = opt && opt.precision;
        if (precision == null) precision = $cfc1f3b422a3185f$export$e0c74b50bbd10f68(data.value) || 0;
        else if (precision === "auto") // Should be more precise then tick.
        precision = this._intervalPrecision;
        // (1) If `precision` is set, 12.005 should be display as '12.00500'.
        // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
        var dataNum = $dddb89ade16db3d5$var$roundNumber(data.value, precision, true);
        return $c84c9521536c601a$export$b6fe44657ce35c42(dataNum);
    };
    /**
   * @param splitNumber By default `5`.
   */ IntervalScale.prototype.calcNiceTicks = function(splitNumber, minInterval, maxInterval) {
        splitNumber = splitNumber || 5;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        if (!isFinite(span)) return;
        // User may set axis min 0 and data are all negative
        // FIXME If it needs to reverse ?
        if (span < 0) {
            span = -span;
            extent.reverse();
        }
        var result = $60f7f1f3e3996637$export$eeea879a611eb991(extent, splitNumber, minInterval, maxInterval);
        this._intervalPrecision = result.intervalPrecision;
        this._interval = result.interval;
        this._niceExtent = result.niceTickExtent;
    };
    IntervalScale.prototype.calcNiceExtent = function(opt) {
        var extent = this._extent;
        // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            if (extent[0] !== 0) {
                // Expand extent
                // Note that extents can be both negative. See #13154
                var expandSize = Math.abs(extent[0]);
                // In the fowllowing case
                //      Axis has been fixed max 100
                //      Plus data are all 100 and axis extent are [100, 100].
                // Extend to the both side will cause expanded max is larger than fixed max.
                // So only expand to the smaller side.
                if (!opt.fixMax) {
                    extent[1] += expandSize / 2;
                    extent[0] -= expandSize / 2;
                } else extent[0] -= expandSize / 2;
            } else extent[1] = 1;
        }
        var span = extent[1] - extent[0];
        // If there are no data and extent are [Infinity, -Infinity]
        if (!isFinite(span)) {
            extent[0] = 0;
            extent[1] = 1;
        }
        this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
        // let extent = this._extent;
        var interval = this._interval;
        if (!opt.fixMin) extent[0] = $dddb89ade16db3d5$var$roundNumber(Math.floor(extent[0] / interval) * interval);
        if (!opt.fixMax) extent[1] = $dddb89ade16db3d5$var$roundNumber(Math.ceil(extent[1] / interval) * interval);
    };
    IntervalScale.prototype.setNiceExtent = function(min, max) {
        this._niceExtent = [
            min,
            max
        ];
    };
    IntervalScale.type = "interval";
    return IntervalScale;
}((0, $1754de95b9b9c398$export$2e2bcd8739ae039));
(0, $1754de95b9b9c398$export$2e2bcd8739ae039).registerClass($dddb89ade16db3d5$var$IntervalScale);
var $dddb89ade16db3d5$export$2e2bcd8739ae039 = $dddb89ade16db3d5$var$IntervalScale;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







// FIXME 公用？
var $7729d7ac367e621c$var$bisect = function(a, x, lo, hi) {
    while(lo < hi){
        var mid = lo + hi >>> 1;
        if (a[mid][1] < x) lo = mid + 1;
        else hi = mid;
    }
    return lo;
};
var $7729d7ac367e621c$var$TimeScale = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TimeScale, _super);
    function TimeScale(settings) {
        var _this = _super.call(this, settings) || this;
        _this.type = "time";
        return _this;
    }
    /**
   * Get label is mainly for other components like dataZoom, tooltip.
   */ TimeScale.prototype.getLabel = function(tick) {
        var useUTC = this.getSetting("useUTC");
        return (0, $0ae0381fb3fd176f$export$d9468344d3651243)(tick.value, (0, $0ae0381fb3fd176f$export$445bdbd8d2334e40)[(0, $0ae0381fb3fd176f$export$124c820721c4f66b)((0, $0ae0381fb3fd176f$export$1da4b91a25d7e1c8)(this._minLevelUnit))] || (0, $0ae0381fb3fd176f$export$445bdbd8d2334e40).second, useUTC, this.getSetting("locale"));
    };
    TimeScale.prototype.getFormattedLabel = function(tick, idx, labelFormatter) {
        var isUTC = this.getSetting("useUTC");
        var lang = this.getSetting("locale");
        return (0, $0ae0381fb3fd176f$export$fe777b6293828b5d)(tick, idx, labelFormatter, lang, isUTC);
    };
    /**
   * @override
   */ TimeScale.prototype.getTicks = function() {
        var interval = this._interval;
        var extent = this._extent;
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        ticks.push({
            value: extent[0],
            level: 0
        });
        var useUTC = this.getSetting("useUTC");
        var innerTicks = $7729d7ac367e621c$var$getIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent);
        ticks = ticks.concat(innerTicks);
        ticks.push({
            value: extent[1],
            level: 0
        });
        return ticks;
    };
    TimeScale.prototype.calcNiceExtent = function(opt) {
        var extent = this._extent;
        // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            // Expand extent
            extent[0] -= (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
            extent[1] += (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
        }
        // If there are no data and extent are [Infinity, -Infinity]
        if (extent[1] === -Infinity && extent[0] === Infinity) {
            var d = new Date();
            extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
            extent[0] = extent[1] - (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
        }
        this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
    };
    TimeScale.prototype.calcNiceTicks = function(approxTickNum, minInterval, maxInterval) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        this._approxInterval = span / approxTickNum;
        if (minInterval != null && this._approxInterval < minInterval) this._approxInterval = minInterval;
        if (maxInterval != null && this._approxInterval > maxInterval) this._approxInterval = maxInterval;
        var scaleIntervalsLen = $7729d7ac367e621c$var$scaleIntervals.length;
        var idx = Math.min($7729d7ac367e621c$var$bisect($7729d7ac367e621c$var$scaleIntervals, this._approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1);
        // Interval that can be used to calculate ticks
        this._interval = $7729d7ac367e621c$var$scaleIntervals[idx][1];
        // Min level used when picking ticks from top down.
        // We check one more level to avoid the ticks are to sparse in some case.
        this._minLevelUnit = $7729d7ac367e621c$var$scaleIntervals[Math.max(idx - 1, 0)][0];
    };
    TimeScale.prototype.parse = function(val) {
        // val might be float.
        return (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(val) ? val : +$cfc1f3b422a3185f$export$6b862160d295c8e(val);
    };
    TimeScale.prototype.contain = function(val) {
        return $60f7f1f3e3996637$export$8893e2b90ba10d92(this.parse(val), this._extent);
    };
    TimeScale.prototype.normalize = function(val) {
        return $60f7f1f3e3996637$export$a3295358bff77e(this.parse(val), this._extent);
    };
    TimeScale.prototype.scale = function(val) {
        return $60f7f1f3e3996637$export$dcdf75081b88279d(val, this._extent);
    };
    TimeScale.type = "time";
    return TimeScale;
}((0, $dddb89ade16db3d5$export$2e2bcd8739ae039));
/**
 * This implementation was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ var $7729d7ac367e621c$var$scaleIntervals = [
    // Format                           interval
    [
        "second",
        (0, $0ae0381fb3fd176f$export$32c0454ceff7f92d)
    ],
    [
        "minute",
        (0, $0ae0381fb3fd176f$export$35acaebf644db34e)
    ],
    [
        "hour",
        (0, $0ae0381fb3fd176f$export$82541edf19e5e3b0)
    ],
    [
        "quarter-day",
        (0, $0ae0381fb3fd176f$export$82541edf19e5e3b0) * 6
    ],
    [
        "half-day",
        (0, $0ae0381fb3fd176f$export$82541edf19e5e3b0) * 12
    ],
    [
        "day",
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 1.2
    ],
    [
        "half-week",
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 3.5
    ],
    [
        "week",
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 7
    ],
    [
        "month",
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 31
    ],
    [
        "quarter",
        (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) * 95
    ],
    [
        "half-year",
        (0, $0ae0381fb3fd176f$export$99cafda57477293d) / 2
    ],
    [
        "year",
        (0, $0ae0381fb3fd176f$export$99cafda57477293d)
    ] // 1Y
];
function $7729d7ac367e621c$var$isUnitValueSame(unit, valueA, valueB, isUTC) {
    var dateA = $cfc1f3b422a3185f$export$6b862160d295c8e(valueA);
    var dateB = $cfc1f3b422a3185f$export$6b862160d295c8e(valueB);
    var isSame = function(unit) {
        return (0, $0ae0381fb3fd176f$export$e04e41a1e24ffd3f)(dateA, unit, isUTC) === (0, $0ae0381fb3fd176f$export$e04e41a1e24ffd3f)(dateB, unit, isUTC);
    };
    var isSameYear = function() {
        return isSame("year");
    };
    // const isSameHalfYear = () => isSameYear() && isSame('half-year');
    // const isSameQuater = () => isSameYear() && isSame('quarter');
    var isSameMonth = function() {
        return isSameYear() && isSame("month");
    };
    var isSameDay = function() {
        return isSameMonth() && isSame("day");
    };
    // const isSameHalfDay = () => isSameDay() && isSame('half-day');
    var isSameHour = function() {
        return isSameDay() && isSame("hour");
    };
    var isSameMinute = function() {
        return isSameHour() && isSame("minute");
    };
    var isSameSecond = function() {
        return isSameMinute() && isSame("second");
    };
    var isSameMilliSecond = function() {
        return isSameSecond() && isSame("millisecond");
    };
    switch(unit){
        case "year":
            return isSameYear();
        case "month":
            return isSameMonth();
        case "day":
            return isSameDay();
        case "hour":
            return isSameHour();
        case "minute":
            return isSameMinute();
        case "second":
            return isSameSecond();
        case "millisecond":
            return isSameMilliSecond();
    }
}
// const primaryUnitGetters = {
//     year: fullYearGetterName(),
//     month: monthGetterName(),
//     day: dateGetterName(),
//     hour: hoursGetterName(),
//     minute: minutesGetterName(),
//     second: secondsGetterName(),
//     millisecond: millisecondsGetterName()
// };
// const primaryUnitUTCGetters = {
//     year: fullYearGetterName(true),
//     month: monthGetterName(true),
//     day: dateGetterName(true),
//     hour: hoursGetterName(true),
//     minute: minutesGetterName(true),
//     second: secondsGetterName(true),
//     millisecond: millisecondsGetterName(true)
// };
// function moveTick(date: Date, unitName: TimeUnit, step: number, isUTC: boolean) {
//     step = step || 1;
//     switch (getPrimaryTimeUnit(unitName)) {
//         case 'year':
//             date[fullYearSetterName(isUTC)](date[fullYearGetterName(isUTC)]() + step);
//             break;
//         case 'month':
//             date[monthSetterName(isUTC)](date[monthGetterName(isUTC)]() + step);
//             break;
//         case 'day':
//             date[dateSetterName(isUTC)](date[dateGetterName(isUTC)]() + step);
//             break;
//         case 'hour':
//             date[hoursSetterName(isUTC)](date[hoursGetterName(isUTC)]() + step);
//             break;
//         case 'minute':
//             date[minutesSetterName(isUTC)](date[minutesGetterName(isUTC)]() + step);
//             break;
//         case 'second':
//             date[secondsSetterName(isUTC)](date[secondsGetterName(isUTC)]() + step);
//             break;
//         case 'millisecond':
//             date[millisecondsSetterName(isUTC)](date[millisecondsGetterName(isUTC)]() + step);
//             break;
//     }
//     return date.getTime();
// }
// const DATE_INTERVALS = [[8, 7.5], [4, 3.5], [2, 1.5]];
// const MONTH_INTERVALS = [[6, 5.5], [3, 2.5], [2, 1.5]];
// const MINUTES_SECONDS_INTERVALS = [[30, 30], [20, 20], [15, 15], [10, 10], [5, 5], [2, 2]];
function $7729d7ac367e621c$var$getDateInterval(approxInterval, daysInMonth) {
    approxInterval /= (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
    return approxInterval > 16 ? 16 : approxInterval > 7.5 ? 7 // TODO week 7 or day 8?
     : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
}
function $7729d7ac367e621c$var$getMonthInterval(approxInterval) {
    var APPROX_ONE_MONTH = 30 * (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab);
    approxInterval /= APPROX_ONE_MONTH;
    return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
}
function $7729d7ac367e621c$var$getHourInterval(approxInterval) {
    approxInterval /= (0, $0ae0381fb3fd176f$export$82541edf19e5e3b0);
    return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
}
function $7729d7ac367e621c$var$getMinutesAndSecondsInterval(approxInterval, isMinutes) {
    approxInterval /= isMinutes ? (0, $0ae0381fb3fd176f$export$35acaebf644db34e) : (0, $0ae0381fb3fd176f$export$32c0454ceff7f92d);
    return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
}
function $7729d7ac367e621c$var$getMillisecondsInterval(approxInterval) {
    return $cfc1f3b422a3185f$export$7a695fe44258210b(approxInterval, true);
}
function $7729d7ac367e621c$var$getFirstTimestampOfUnit(date, unitName, isUTC) {
    var outDate = new Date(date);
    switch((0, $0ae0381fb3fd176f$export$1da4b91a25d7e1c8)(unitName)){
        case "year":
        case "month":
            outDate[(0, $0ae0381fb3fd176f$export$233f59998ed71c09)(isUTC)](0);
        case "day":
            outDate[(0, $0ae0381fb3fd176f$export$82fd379a67f37fa0)(isUTC)](1);
        case "hour":
            outDate[(0, $0ae0381fb3fd176f$export$b6f943e8d23c15bb)(isUTC)](0);
        case "minute":
            outDate[(0, $0ae0381fb3fd176f$export$50303078793fc7d)(isUTC)](0);
        case "second":
            outDate[(0, $0ae0381fb3fd176f$export$a4a908acda9c3118)(isUTC)](0);
            outDate[(0, $0ae0381fb3fd176f$export$c047afab75f6d84)(isUTC)](0);
    }
    return outDate.getTime();
}
function $7729d7ac367e621c$var$getIntervalTicks(bottomUnitName, approxInterval, isUTC, extent) {
    var safeLimit = 10000;
    var unitNames = (0, $0ae0381fb3fd176f$export$833c398a55654bb7);
    var iter = 0;
    function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
        var date = new Date(minTimestamp);
        var dateTime = minTimestamp;
        var d = date[getMethodName]();
        // if (isDate) {
        //     d -= 1; // Starts with 0;   PENDING
        // }
        while(dateTime < maxTimestamp && dateTime <= extent[1]){
            out.push({
                value: dateTime
            });
            d += interval;
            date[setMethodName](d);
            dateTime = date.getTime();
        }
        // This extra tick is for calcuating ticks of next level. Will not been added to the final result
        out.push({
            value: dateTime,
            notAdd: true
        });
    }
    function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
        var newAddedTicks = [];
        var isFirstLevel = !lastLevelTicks.length;
        if ($7729d7ac367e621c$var$isUnitValueSame((0, $0ae0381fb3fd176f$export$1da4b91a25d7e1c8)(unitName), extent[0], extent[1], isUTC)) return;
        if (isFirstLevel) lastLevelTicks = [
            {
                // TODO Optimize. Not include so may ticks.
                value: $7729d7ac367e621c$var$getFirstTimestampOfUnit(new Date(extent[0]), unitName, isUTC)
            },
            {
                value: extent[1]
            }
        ];
        for(var i = 0; i < lastLevelTicks.length - 1; i++){
            var startTick = lastLevelTicks[i].value;
            var endTick = lastLevelTicks[i + 1].value;
            if (startTick === endTick) continue;
            var interval = void 0;
            var getterName = void 0;
            var setterName = void 0;
            var isDate = false;
            switch(unitName){
                case "year":
                    interval = Math.max(1, Math.round(approxInterval / (0, $0ae0381fb3fd176f$export$a97a1358cbb650ab) / 365));
                    getterName = (0, $0ae0381fb3fd176f$export$8d046fefed9a548e)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$43fbeac90913b151)(isUTC);
                    break;
                case "half-year":
                case "quarter":
                case "month":
                    interval = $7729d7ac367e621c$var$getMonthInterval(approxInterval);
                    getterName = (0, $0ae0381fb3fd176f$export$5c242a801a23eec7)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$233f59998ed71c09)(isUTC);
                    break;
                case "week":
                case "half-week":
                case "day":
                    interval = $7729d7ac367e621c$var$getDateInterval(approxInterval, 31); // Use 32 days and let interval been 16
                    getterName = (0, $0ae0381fb3fd176f$export$4189e6cbc9753260)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$82fd379a67f37fa0)(isUTC);
                    isDate = true;
                    break;
                case "half-day":
                case "quarter-day":
                case "hour":
                    interval = $7729d7ac367e621c$var$getHourInterval(approxInterval);
                    getterName = (0, $0ae0381fb3fd176f$export$8b40b55b3c06cbe2)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$b6f943e8d23c15bb)(isUTC);
                    break;
                case "minute":
                    interval = $7729d7ac367e621c$var$getMinutesAndSecondsInterval(approxInterval, true);
                    getterName = (0, $0ae0381fb3fd176f$export$8807847c5c71eded)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$50303078793fc7d)(isUTC);
                    break;
                case "second":
                    interval = $7729d7ac367e621c$var$getMinutesAndSecondsInterval(approxInterval, false);
                    getterName = (0, $0ae0381fb3fd176f$export$8f49e73e2eebd168)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$a4a908acda9c3118)(isUTC);
                    break;
                case "millisecond":
                    interval = $7729d7ac367e621c$var$getMillisecondsInterval(approxInterval);
                    getterName = (0, $0ae0381fb3fd176f$export$312207a92d041116)(isUTC);
                    setterName = (0, $0ae0381fb3fd176f$export$c047afab75f6d84)(isUTC);
                    break;
            }
            addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);
            if (unitName === "year" && levelTicks.length > 1 && i === 0) // Add nearest years to the left extent.
            levelTicks.unshift({
                value: levelTicks[0].value - interval
            });
        }
        for(var i = 0; i < newAddedTicks.length; i++)levelTicks.push(newAddedTicks[i]);
        // newAddedTicks.length && console.log(unitName, newAddedTicks);
        return newAddedTicks;
    }
    var levelsTicks = [];
    var currentLevelTicks = [];
    var tickCount = 0;
    var lastLevelTickCount = 0;
    for(var i = 0; i < unitNames.length && iter++ < safeLimit; ++i){
        var primaryTimeUnit = (0, $0ae0381fb3fd176f$export$1da4b91a25d7e1c8)(unitNames[i]);
        if (!(0, $0ae0381fb3fd176f$export$beb5920b69c13da)(unitNames[i])) continue;
        addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
        var nextPrimaryTimeUnit = unitNames[i + 1] ? (0, $0ae0381fb3fd176f$export$1da4b91a25d7e1c8)(unitNames[i + 1]) : null;
        if (primaryTimeUnit !== nextPrimaryTimeUnit) {
            if (currentLevelTicks.length) {
                lastLevelTickCount = tickCount;
                // Remove the duplicate so the tick count can be precisely.
                currentLevelTicks.sort(function(a, b) {
                    return a.value - b.value;
                });
                var levelTicksRemoveDuplicated = [];
                for(var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1){
                    var tickValue = currentLevelTicks[i_1].value;
                    if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
                        levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);
                        if (tickValue >= extent[0] && tickValue <= extent[1]) tickCount++;
                    }
                }
                var targetTickNum = (extent[1] - extent[0]) / approxInterval;
                // Added too much in this level and not too less in last level
                if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) break;
                // Only treat primary time unit as one level.
                levelsTicks.push(levelTicksRemoveDuplicated);
                if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) break;
            }
            // Reset if next unitName is primary
            currentLevelTicks = [];
        }
    }
    var levelsTicksInExtent = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(levelsTicks, function(levelTicks) {
        return (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(levelTicks, function(tick) {
            return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
        });
    }), function(levelTicks) {
        return levelTicks.length > 0;
    });
    var ticks = [];
    var maxLevel = levelsTicksInExtent.length - 1;
    for(var i = 0; i < levelsTicksInExtent.length; ++i){
        var levelTicks = levelsTicksInExtent[i];
        for(var k = 0; k < levelTicks.length; ++k)ticks.push({
            value: levelTicks[k].value,
            level: maxLevel - i
        });
    }
    ticks.sort(function(a, b) {
        return a.value - b.value;
    });
    // Remove duplicates
    var result = [];
    for(var i = 0; i < ticks.length; ++i)if (i === 0 || ticks[i].value !== ticks[i - 1].value) result.push(ticks[i]);
    return result;
}
(0, $1754de95b9b9c398$export$2e2bcd8739ae039).registerClass($7729d7ac367e621c$var$TimeScale);
var $7729d7ac367e621c$export$2e2bcd8739ae039 = $7729d7ac367e621c$var$TimeScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $ae24d1f3a7f905fc$var$scaleProto = (0, $1754de95b9b9c398$export$2e2bcd8739ae039).prototype;
// FIXME:TS refactor: not good to call it directly with `this`?
var $ae24d1f3a7f905fc$var$intervalScaleProto = (0, $dddb89ade16db3d5$export$2e2bcd8739ae039).prototype;
var $ae24d1f3a7f905fc$var$roundingErrorFix = $cfc1f3b422a3185f$export$2077e0241d6afd3c;
var $ae24d1f3a7f905fc$var$mathFloor = Math.floor;
var $ae24d1f3a7f905fc$var$mathCeil = Math.ceil;
var $ae24d1f3a7f905fc$var$mathPow = Math.pow;
var $ae24d1f3a7f905fc$var$mathLog = Math.log;
var $ae24d1f3a7f905fc$var$LogScale = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LogScale, _super);
    function LogScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "log";
        _this.base = 10;
        _this._originalScale = new (0, $dddb89ade16db3d5$export$2e2bcd8739ae039)();
        // FIXME:TS actually used by `IntervalScale`
        _this._interval = 0;
        return _this;
    }
    /**
   * @param Whether expand the ticks to niced extent.
   */ LogScale.prototype.getTicks = function(expandToNicedExtent) {
        var originalScale = this._originalScale;
        var extent = this._extent;
        var originalExtent = originalScale.getExtent();
        var ticks = $ae24d1f3a7f905fc$var$intervalScaleProto.getTicks.call(this, expandToNicedExtent);
        return $7a1bd9c2710fea0d$export$871de8747c9eaa88(ticks, function(tick) {
            var val = tick.value;
            var powVal = $cfc1f3b422a3185f$export$2077e0241d6afd3c($ae24d1f3a7f905fc$var$mathPow(this.base, val));
            // Fix #4158
            powVal = val === extent[0] && this._fixMin ? $ae24d1f3a7f905fc$var$fixRoundingError(powVal, originalExtent[0]) : powVal;
            powVal = val === extent[1] && this._fixMax ? $ae24d1f3a7f905fc$var$fixRoundingError(powVal, originalExtent[1]) : powVal;
            return {
                value: powVal
            };
        }, this);
    };
    LogScale.prototype.setExtent = function(start, end) {
        var base = $ae24d1f3a7f905fc$var$mathLog(this.base);
        // log(-Infinity) is NaN, so safe guard here
        start = $ae24d1f3a7f905fc$var$mathLog(Math.max(0, start)) / base;
        end = $ae24d1f3a7f905fc$var$mathLog(Math.max(0, end)) / base;
        $ae24d1f3a7f905fc$var$intervalScaleProto.setExtent.call(this, start, end);
    };
    /**
   * @return {number} end
   */ LogScale.prototype.getExtent = function() {
        var base = this.base;
        var extent = $ae24d1f3a7f905fc$var$scaleProto.getExtent.call(this);
        extent[0] = $ae24d1f3a7f905fc$var$mathPow(base, extent[0]);
        extent[1] = $ae24d1f3a7f905fc$var$mathPow(base, extent[1]);
        // Fix #4158
        var originalScale = this._originalScale;
        var originalExtent = originalScale.getExtent();
        this._fixMin && (extent[0] = $ae24d1f3a7f905fc$var$fixRoundingError(extent[0], originalExtent[0]));
        this._fixMax && (extent[1] = $ae24d1f3a7f905fc$var$fixRoundingError(extent[1], originalExtent[1]));
        return extent;
    };
    LogScale.prototype.unionExtent = function(extent) {
        this._originalScale.unionExtent(extent);
        var base = this.base;
        extent[0] = $ae24d1f3a7f905fc$var$mathLog(extent[0]) / $ae24d1f3a7f905fc$var$mathLog(base);
        extent[1] = $ae24d1f3a7f905fc$var$mathLog(extent[1]) / $ae24d1f3a7f905fc$var$mathLog(base);
        $ae24d1f3a7f905fc$var$scaleProto.unionExtent.call(this, extent);
    };
    LogScale.prototype.unionExtentFromData = function(data, dim) {
        // TODO
        // filter value that <= 0
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * Update interval and extent of intervals for nice ticks
   * @param approxTickNum default 10 Given approx tick number
   */ LogScale.prototype.calcNiceTicks = function(approxTickNum) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        if (span === Infinity || span <= 0) return;
        var interval = $cfc1f3b422a3185f$export$82dd68b83a44b253(span);
        var err = approxTickNum / span * interval;
        // Filter ticks to get closer to the desired count.
        if (err <= 0.5) interval *= 10;
        // Interval should be integer
        while(!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0)interval *= 10;
        var niceExtent = [
            $cfc1f3b422a3185f$export$2077e0241d6afd3c($ae24d1f3a7f905fc$var$mathCeil(extent[0] / interval) * interval),
            $cfc1f3b422a3185f$export$2077e0241d6afd3c($ae24d1f3a7f905fc$var$mathFloor(extent[1] / interval) * interval)
        ];
        this._interval = interval;
        this._niceExtent = niceExtent;
    };
    LogScale.prototype.calcNiceExtent = function(opt) {
        $ae24d1f3a7f905fc$var$intervalScaleProto.calcNiceExtent.call(this, opt);
        this._fixMin = opt.fixMin;
        this._fixMax = opt.fixMax;
    };
    LogScale.prototype.parse = function(val) {
        return val;
    };
    LogScale.prototype.contain = function(val) {
        val = $ae24d1f3a7f905fc$var$mathLog(val) / $ae24d1f3a7f905fc$var$mathLog(this.base);
        return $60f7f1f3e3996637$export$8893e2b90ba10d92(val, this._extent);
    };
    LogScale.prototype.normalize = function(val) {
        val = $ae24d1f3a7f905fc$var$mathLog(val) / $ae24d1f3a7f905fc$var$mathLog(this.base);
        return $60f7f1f3e3996637$export$a3295358bff77e(val, this._extent);
    };
    LogScale.prototype.scale = function(val) {
        val = $60f7f1f3e3996637$export$dcdf75081b88279d(val, this._extent);
        return $ae24d1f3a7f905fc$var$mathPow(this.base, val);
    };
    LogScale.type = "log";
    return LogScale;
}((0, $1754de95b9b9c398$export$2e2bcd8739ae039));
var $ae24d1f3a7f905fc$var$proto = $ae24d1f3a7f905fc$var$LogScale.prototype;
$ae24d1f3a7f905fc$var$proto.getMinorTicks = $ae24d1f3a7f905fc$var$intervalScaleProto.getMinorTicks;
$ae24d1f3a7f905fc$var$proto.getLabel = $ae24d1f3a7f905fc$var$intervalScaleProto.getLabel;
function $ae24d1f3a7f905fc$var$fixRoundingError(val, originalVal) {
    return $ae24d1f3a7f905fc$var$roundingErrorFix(val, $cfc1f3b422a3185f$export$e0c74b50bbd10f68(originalVal));
}
(0, $1754de95b9b9c398$export$2e2bcd8739ae039).registerClass($ae24d1f3a7f905fc$var$LogScale);
var $ae24d1f3a7f905fc$export$2e2bcd8739ae039 = $ae24d1f3a7f905fc$var$LogScale;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $483be9695e74220c$export$c35454f678e99c82 = /** @class */ function() {
    function ScaleRawExtentInfo(scale, model, // Usually: data extent from all series on this axis.
    originalExtent) {
        this._prepareParams(scale, model, originalExtent);
    }
    /**
   * Parameters depending on outside (like model, user callback)
   * are prepared and fixed here.
   */ ScaleRawExtentInfo.prototype._prepareParams = function(scale, model, // Usually: data extent from all series on this axis.
    dataExtent) {
        if (dataExtent[1] < dataExtent[0]) dataExtent = [
            NaN,
            NaN
        ];
        this._dataMin = dataExtent[0];
        this._dataMax = dataExtent[1];
        var isOrdinal = this._isOrdinal = scale.type === "ordinal";
        this._needCrossZero = scale.type === "interval" && model.getNeedCrossZero && model.getNeedCrossZero();
        var modelMinRaw = this._modelMinRaw = model.get("min", true);
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(modelMinRaw)) // This callback always provides users the full data extent (before data is filtered).
        this._modelMinNum = $483be9695e74220c$export$d02f2e65dfc3c2b(scale, modelMinRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMinRaw !== "dataMin") this._modelMinNum = $483be9695e74220c$export$d02f2e65dfc3c2b(scale, modelMinRaw);
        var modelMaxRaw = this._modelMaxRaw = model.get("max", true);
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(modelMaxRaw)) // This callback always provides users the full data extent (before data is filtered).
        this._modelMaxNum = $483be9695e74220c$export$d02f2e65dfc3c2b(scale, modelMaxRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMaxRaw !== "dataMax") this._modelMaxNum = $483be9695e74220c$export$d02f2e65dfc3c2b(scale, modelMaxRaw);
        if (isOrdinal) // FIXME: there is a flaw here: if there is no "block" data processor like `dataZoom`,
        // and progressive rendering is using, here the category result might just only contain
        // the processed chunk rather than the entire result.
        this._axisDataLen = model.getCategories().length;
        else {
            var boundaryGap = model.get("boundaryGap");
            var boundaryGapArr = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(boundaryGap) ? boundaryGap : [
                boundaryGap || 0,
                boundaryGap || 0
            ];
            if (typeof boundaryGapArr[0] === "boolean" || typeof boundaryGapArr[1] === "boolean") this._boundaryGapInner = [
                0,
                0
            ];
            else this._boundaryGapInner = [
                (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(boundaryGapArr[0], 1),
                (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(boundaryGapArr[1], 1)
            ];
        }
    };
    /**
   * Calculate extent by prepared parameters.
   * This method has no external dependency and can be called duplicatedly,
   * getting the same result.
   * If parameters changed, should call this method to recalcuate.
   */ ScaleRawExtentInfo.prototype.calculate = function() {
        // Notice: When min/max is not set (that is, when there are null/undefined,
        // which is the most common case), these cases should be ensured:
        // (1) For 'ordinal', show all axis.data.
        // (2) For others:
        //      + `boundaryGap` is applied (if min/max set, boundaryGap is
        //      disabled).
        //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
        //      be the result that originalExtent enlarged by boundaryGap.
        // (3) If no data, it should be ensured that `scale.setBlank` is set.
        var isOrdinal = this._isOrdinal;
        var dataMin = this._dataMin;
        var dataMax = this._dataMax;
        var axisDataLen = this._axisDataLen;
        var boundaryGapInner = this._boundaryGapInner;
        var span = !isOrdinal ? dataMax - dataMin || Math.abs(dataMin) : null;
        // Currently if a `'value'` axis model min is specified as 'dataMin'/'dataMax',
        // `boundaryGap` will not be used. It's the different from specifying as `null`/`undefined`.
        var min = this._modelMinRaw === "dataMin" ? dataMin : this._modelMinNum;
        var max = this._modelMaxRaw === "dataMax" ? dataMax : this._modelMaxNum;
        // If `_modelMinNum`/`_modelMaxNum` is `null`/`undefined`, should not be fixed.
        var minFixed = min != null;
        var maxFixed = max != null;
        if (min == null) min = isOrdinal ? axisDataLen ? 0 : NaN : dataMin - boundaryGapInner[0] * span;
        if (max == null) max = isOrdinal ? axisDataLen ? axisDataLen - 1 : NaN : dataMax + boundaryGapInner[1] * span;
        (min == null || !isFinite(min)) && (min = NaN);
        (max == null || !isFinite(max)) && (max = NaN);
        var isBlank = (0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(min) || (0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(max) || isOrdinal && !axisDataLen;
        // If data extent modified, need to recalculated to ensure cross zero.
        if (this._needCrossZero) {
            // Axis is over zero and min is not set
            if (min > 0 && max > 0 && !minFixed) min = 0;
            // Axis is under zero and max is not set
            if (min < 0 && max < 0 && !maxFixed) max = 0;
        // PENDING:
        // When `needCrossZero` and all data is positive/negative, should it be ensured
        // that the results processed by boundaryGap are positive/negative?
        // If so, here `minFixed`/`maxFixed` need to be set.
        }
        var determinedMin = this._determinedMin;
        var determinedMax = this._determinedMax;
        if (determinedMin != null) {
            min = determinedMin;
            minFixed = true;
        }
        if (determinedMax != null) {
            max = determinedMax;
            maxFixed = true;
        }
        // Ensure min/max be finite number or NaN here. (not to be null/undefined)
        // `NaN` means min/max axis is blank.
        return {
            min: min,
            max: max,
            minFixed: minFixed,
            maxFixed: maxFixed,
            isBlank: isBlank
        };
    };
    ScaleRawExtentInfo.prototype.modifyDataMinMax = function(minMaxName, val) {
        this[$483be9695e74220c$var$DATA_MIN_MAX_ATTR[minMaxName]] = val;
    };
    ScaleRawExtentInfo.prototype.setDeterminedMinMax = function(minMaxName, val) {
        var attr = $483be9695e74220c$var$DETERMINED_MIN_MAX_ATTR[minMaxName];
        this[attr] = val;
    };
    ScaleRawExtentInfo.prototype.freeze = function() {
        // @ts-ignore
        this.frozen = true;
    };
    return ScaleRawExtentInfo;
}();
var $483be9695e74220c$var$DETERMINED_MIN_MAX_ATTR = {
    min: "_determinedMin",
    max: "_determinedMax"
};
var $483be9695e74220c$var$DATA_MIN_MAX_ATTR = {
    min: "_dataMin",
    max: "_dataMax"
};
function $483be9695e74220c$export$5c3dbcbeb9ce7f5a(scale, model, // Usually: data extent from all series on this axis.
originalExtent) {
    // Do not permit to recreate.
    var rawExtentInfo = scale.rawExtentInfo;
    if (rawExtentInfo) return rawExtentInfo;
    rawExtentInfo = new $483be9695e74220c$export$c35454f678e99c82(scale, model, originalExtent);
    // @ts-ignore
    scale.rawExtentInfo = rawExtentInfo;
    return rawExtentInfo;
}
function $483be9695e74220c$export$d02f2e65dfc3c2b(scale, minMax) {
    return minMax == null ? null : (0, $7a1bd9c2710fea0d$export$7d667b9a0c48c975)(minMax) ? NaN : scale.parse(minMax);
}


function $2d646e51cc34f840$export$9c0ba8df7eb7b328(scale, model) {
    var scaleType = scale.type;
    var rawExtentResult = (0, $483be9695e74220c$export$5c3dbcbeb9ce7f5a)(scale, model, scale.getExtent()).calculate();
    scale.setBlank(rawExtentResult.isBlank);
    var min = rawExtentResult.min;
    var max = rawExtentResult.max;
    // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
    // is base axis
    // FIXME
    // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
    // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
    //     Should not depend on series type `bar`?
    // (3) Fix that might overlap when using dataZoom.
    // (4) Consider other chart types using `barGrid`?
    // See #6728, #4862, `test/bar-overflow-time-plot.html`
    var ecModel = model.ecModel;
    if (ecModel && scaleType === "time" /* || scaleType === 'interval' */ ) {
        var barSeriesModels = (0, $361c48dd900de28f$export$efbd0c3f5ab0d5e4)("bar", ecModel);
        var isBaseAxisAndHasBarSeries_1 = false;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(barSeriesModels, function(seriesModel) {
            isBaseAxisAndHasBarSeries_1 = isBaseAxisAndHasBarSeries_1 || seriesModel.getBaseAxis() === model.axis;
        });
        if (isBaseAxisAndHasBarSeries_1) {
            // Calculate placement of bars on axis. TODO should be decoupled
            // with barLayout
            var barWidthAndOffset = (0, $361c48dd900de28f$export$20769dafc84e0299)(barSeriesModels);
            // Adjust axis min and max to account for overflow
            var adjustedScale = $2d646e51cc34f840$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset);
            min = adjustedScale.min;
            max = adjustedScale.max;
        }
    }
    return {
        extent: [
            min,
            max
        ],
        // "fix" means "fixed", the value should not be
        // changed in the subsequent steps.
        fixMin: rawExtentResult.minFixed,
        fixMax: rawExtentResult.maxFixed
    };
}
function $2d646e51cc34f840$var$adjustScaleForOverflow(min, max, model, // Only support cartesian coord yet.
barWidthAndOffset) {
    // Get Axis Length
    var axisExtent = model.axis.getExtent();
    var axisLength = axisExtent[1] - axisExtent[0];
    // Get bars on current base axis and calculate min and max overflow
    var barsOnCurrentAxis = (0, $361c48dd900de28f$export$35920bb6556da1c2)(barWidthAndOffset, model.axis);
    if (barsOnCurrentAxis === undefined) return {
        min: min,
        max: max
    };
    var minOverflow = Infinity;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(barsOnCurrentAxis, function(item) {
        minOverflow = Math.min(item.offset, minOverflow);
    });
    var maxOverflow = -Infinity;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(barsOnCurrentAxis, function(item) {
        maxOverflow = Math.max(item.offset + item.width, maxOverflow);
    });
    minOverflow = Math.abs(minOverflow);
    maxOverflow = Math.abs(maxOverflow);
    var totalOverFlow = minOverflow + maxOverflow;
    // Calculate required buffer based on old range and overflow
    var oldRange = max - min;
    var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
    var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
    max += overflowBuffer * (maxOverflow / totalOverFlow);
    min -= overflowBuffer * (minOverflow / totalOverFlow);
    return {
        min: min,
        max: max
    };
}
function $2d646e51cc34f840$export$51f3e70a54405d5a(scale, inModel) {
    var model = inModel;
    var extentInfo = $2d646e51cc34f840$export$9c0ba8df7eb7b328(scale, model);
    var extent = extentInfo.extent;
    var splitNumber = model.get("splitNumber");
    if (scale instanceof (0, $ae24d1f3a7f905fc$export$2e2bcd8739ae039)) scale.base = model.get("logBase");
    var scaleType = scale.type;
    var interval = model.get("interval");
    var isIntervalOrTime = scaleType === "interval" || scaleType === "time";
    scale.setExtent(extent[0], extent[1]);
    scale.calcNiceExtent({
        splitNumber: splitNumber,
        fixMin: extentInfo.fixMin,
        fixMax: extentInfo.fixMax,
        minInterval: isIntervalOrTime ? model.get("minInterval") : null,
        maxInterval: isIntervalOrTime ? model.get("maxInterval") : null
    });
    // If some one specified the min, max. And the default calculated interval
    // is not good enough. He can specify the interval. It is often appeared
    // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
    // to be 60.
    // FIXME
    if (interval != null) scale.setInterval && scale.setInterval(interval);
}
function $2d646e51cc34f840$export$8941c4cacdc8f5a5(model, axisType) {
    axisType = axisType || model.get("type");
    if (axisType) switch(axisType){
        // Buildin scale
        case "category":
            return new (0, $6e82606ec775d365$export$2e2bcd8739ae039)({
                ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
                extent: [
                    Infinity,
                    -Infinity
                ]
            });
        case "time":
            return new (0, $7729d7ac367e621c$export$2e2bcd8739ae039)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get("useUTC")
            });
        default:
            // case 'value'/'interval', 'log', or others.
            return new ((0, $1754de95b9b9c398$export$2e2bcd8739ae039).getClass(axisType) || (0, $dddb89ade16db3d5$export$2e2bcd8739ae039))();
    }
}
function $2d646e51cc34f840$export$3eac36a69f37d52(axis) {
    var dataExtent = axis.scale.getExtent();
    var min = dataExtent[0];
    var max = dataExtent[1];
    return !(min > 0 && max > 0 || min < 0 && max < 0);
}
function $2d646e51cc34f840$export$742f19a75415b2ae(axis) {
    var labelFormatter = axis.getLabelModel().get("formatter");
    var categoryTickStart = axis.type === "category" ? axis.scale.getExtent()[0] : null;
    if (axis.scale.type === "time") return function(tpl) {
        return function(tick, idx) {
            return axis.scale.getFormattedLabel(tick, idx, tpl);
        };
    }(labelFormatter);
    else if ($7a1bd9c2710fea0d$export$844ec244b1367d54(labelFormatter)) return function(tpl) {
        return function(tick) {
            // For category axis, get raw value; for numeric axis,
            // get formatted label like '1,333,444'.
            var label = axis.scale.getLabel(tick);
            var text = tpl.replace("{value}", label != null ? label : "");
            return text;
        };
    }(labelFormatter);
    else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(labelFormatter)) return function(cb) {
        return function(tick, idx) {
            // The original intention of `idx` is "the index of the tick in all ticks".
            // But the previous implementation of category axis do not consider the
            // `axisLabel.interval`, which cause that, for example, the `interval` is
            // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
            // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
            // the definition here for back compatibility.
            if (categoryTickStart != null) idx = tick.value - categoryTickStart;
            return cb($2d646e51cc34f840$export$a5a32f324c1fa457(axis, tick), idx, tick.level != null ? {
                level: tick.level
            } : null);
        };
    }(labelFormatter);
    else return function(tick) {
        return axis.scale.getLabel(tick);
    };
}
function $2d646e51cc34f840$export$a5a32f324c1fa457(axis, tick) {
    // In category axis with data zoom, tick is not the original
    // index of axis.data. So tick should not be exposed to user
    // in category axis.
    return axis.type === "category" ? axis.scale.getLabel(tick) : tick.value;
}
function $2d646e51cc34f840$export$fef1c7f0af0b48d(axis) {
    var axisModel = axis.model;
    var scale = axis.scale;
    if (!axisModel.get([
        "axisLabel",
        "show"
    ]) || scale.isBlank()) return;
    var realNumberScaleTicks;
    var tickCount;
    var categoryScaleExtent = scale.getExtent();
    // Optimize for large category data, avoid call `getTicks()`.
    if (scale instanceof (0, $6e82606ec775d365$export$2e2bcd8739ae039)) tickCount = scale.count();
    else {
        realNumberScaleTicks = scale.getTicks();
        tickCount = realNumberScaleTicks.length;
    }
    var axisLabelModel = axis.getLabelModel();
    var labelFormatter = $2d646e51cc34f840$export$742f19a75415b2ae(axis);
    var rect;
    var step = 1;
    // Simple optimization for large amount of labels
    if (tickCount > 40) step = Math.ceil(tickCount / 40);
    for(var i = 0; i < tickCount; i += step){
        var tick = realNumberScaleTicks ? realNumberScaleTicks[i] : {
            value: categoryScaleExtent[0] + i
        };
        var label = labelFormatter(tick, i);
        var unrotatedSingleRect = axisLabelModel.getTextRect(label);
        var singleRect = $2d646e51cc34f840$var$rotateTextRect(unrotatedSingleRect, axisLabelModel.get("rotate") || 0);
        rect ? rect.union(singleRect) : rect = singleRect;
    }
    return rect;
}
function $2d646e51cc34f840$var$rotateTextRect(textRect, rotate) {
    var rotateRadians = rotate * Math.PI / 180;
    var beforeWidth = textRect.width;
    var beforeHeight = textRect.height;
    var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
    var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
    var rotatedRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(textRect.x, textRect.y, afterWidth, afterHeight);
    return rotatedRect;
}
function $2d646e51cc34f840$export$6d0bc2429155c088(model) {
    var interval = model.get("interval");
    return interval == null ? "auto" : interval;
}
function $2d646e51cc34f840$export$c2911c025243d6a6(axis) {
    return axis.type === "category" && $2d646e51cc34f840$export$6d0bc2429155c088(axis.getLabelModel()) === 0;
}
function $2d646e51cc34f840$export$e4cf30b1e74cd69d(data, axisDim) {
    // Remove duplicated dat dimensions caused by `getStackedDimension`.
    var dataDimMap = {};
    // Currently `mapDimensionsAll` will contain stack result dimension ('__\0ecstackresult').
    // PENDING: is it reasonable? Do we need to remove the original dim from "coord dim" since
    // there has been stacked result dim?
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(data.mapDimensionsAll(axisDim), function(dataDim) {
        // For example, the extent of the original dimension
        // is [0.1, 0.5], the extent of the `stackResultDimension`
        // is [7, 9], the final extent should NOT include [0.1, 0.5],
        // because there is no graphic corresponding to [0.1, 0.5].
        // See the case in `test/area-stack.html` `main1`, where area line
        // stack needs `yAxis` not start from 0.
        dataDimMap[(0, $efdd976e4917927c$export$909db2be4938fbdf)(data, dataDim)] = true;
    });
    return $7a1bd9c2710fea0d$export$ed97f33186d4b816(dataDimMap);
}
function $2d646e51cc34f840$export$635fe7f20d0f4c70(dataExtent, data, axisDim) {
    if (data) $7a1bd9c2710fea0d$export$79b2f7037acddd43($2d646e51cc34f840$export$e4cf30b1e74cd69d(data, axisDim), function(dim) {
        var seriesExtent = data.getApproximateExtent(dim);
        seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
        seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $6a439e51dccdc432$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $6a439e51dccdc432$export$10216ebd3e3e485e(axis) {
    // Only ordinal scale support tick interval
    return axis.type === "category" ? $6a439e51dccdc432$var$makeCategoryLabels(axis) : $6a439e51dccdc432$var$makeRealNumberLabels(axis);
}
function $6a439e51dccdc432$export$7cccf6836ae8323c(axis, tickModel) {
    // Only ordinal scale support tick interval
    return axis.type === "category" ? $6a439e51dccdc432$var$makeCategoryTicks(axis, tickModel) : {
        ticks: $7a1bd9c2710fea0d$export$871de8747c9eaa88(axis.scale.getTicks(), function(tick) {
            return tick.value;
        })
    };
}
function $6a439e51dccdc432$var$makeCategoryLabels(axis) {
    var labelModel = axis.getLabelModel();
    var result = $6a439e51dccdc432$var$makeCategoryLabelsActually(axis, labelModel);
    return !labelModel.get("show") || axis.scale.isBlank() ? {
        labels: [],
        labelCategoryInterval: result.labelCategoryInterval
    } : result;
}
function $6a439e51dccdc432$var$makeCategoryLabelsActually(axis, labelModel) {
    var labelsCache = $6a439e51dccdc432$var$getListCache(axis, "labels");
    var optionLabelInterval = (0, $2d646e51cc34f840$export$6d0bc2429155c088)(labelModel);
    var result = $6a439e51dccdc432$var$listCacheGet(labelsCache, optionLabelInterval);
    if (result) return result;
    var labels;
    var numericLabelInterval;
    if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(optionLabelInterval)) labels = $6a439e51dccdc432$var$makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
    else {
        numericLabelInterval = optionLabelInterval === "auto" ? $6a439e51dccdc432$var$makeAutoCategoryInterval(axis) : optionLabelInterval;
        labels = $6a439e51dccdc432$var$makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
    }
    // Cache to avoid calling interval function repeatedly.
    return $6a439e51dccdc432$var$listCacheSet(labelsCache, optionLabelInterval, {
        labels: labels,
        labelCategoryInterval: numericLabelInterval
    });
}
function $6a439e51dccdc432$var$makeCategoryTicks(axis, tickModel) {
    var ticksCache = $6a439e51dccdc432$var$getListCache(axis, "ticks");
    var optionTickInterval = (0, $2d646e51cc34f840$export$6d0bc2429155c088)(tickModel);
    var result = $6a439e51dccdc432$var$listCacheGet(ticksCache, optionTickInterval);
    if (result) return result;
    var ticks;
    var tickCategoryInterval;
    // Optimize for the case that large category data and no label displayed,
    // we should not return all ticks.
    if (!tickModel.get("show") || axis.scale.isBlank()) ticks = [];
    if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(optionTickInterval)) ticks = $6a439e51dccdc432$var$makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
    else if (optionTickInterval === "auto") {
        var labelsResult = $6a439e51dccdc432$var$makeCategoryLabelsActually(axis, axis.getLabelModel());
        tickCategoryInterval = labelsResult.labelCategoryInterval;
        ticks = $7a1bd9c2710fea0d$export$871de8747c9eaa88(labelsResult.labels, function(labelItem) {
            return labelItem.tickValue;
        });
    } else {
        tickCategoryInterval = optionTickInterval;
        ticks = $6a439e51dccdc432$var$makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
    }
    // Cache to avoid calling interval function repeatedly.
    return $6a439e51dccdc432$var$listCacheSet(ticksCache, optionTickInterval, {
        ticks: ticks,
        tickCategoryInterval: tickCategoryInterval
    });
}
function $6a439e51dccdc432$var$makeRealNumberLabels(axis) {
    var ticks = axis.scale.getTicks();
    var labelFormatter = (0, $2d646e51cc34f840$export$742f19a75415b2ae)(axis);
    return {
        labels: $7a1bd9c2710fea0d$export$871de8747c9eaa88(ticks, function(tick, idx) {
            return {
                level: tick.level,
                formattedLabel: labelFormatter(tick, idx),
                rawLabel: axis.scale.getLabel(tick),
                tickValue: tick.value
            };
        })
    };
}
function $6a439e51dccdc432$var$getListCache(axis, prop) {
    // Because key can be a function, and cache size always is small, we use array cache.
    return $6a439e51dccdc432$var$inner(axis)[prop] || ($6a439e51dccdc432$var$inner(axis)[prop] = []);
}
function $6a439e51dccdc432$var$listCacheGet(cache, key) {
    for(var i = 0; i < cache.length; i++){
        if (cache[i].key === key) return cache[i].value;
    }
}
function $6a439e51dccdc432$var$listCacheSet(cache, key, value) {
    cache.push({
        key: key,
        value: value
    });
    return value;
}
function $6a439e51dccdc432$var$makeAutoCategoryInterval(axis) {
    var result = $6a439e51dccdc432$var$inner(axis).autoInterval;
    return result != null ? result : $6a439e51dccdc432$var$inner(axis).autoInterval = axis.calculateCategoryInterval();
}
function $6a439e51dccdc432$export$9ea1d3f146a5a65f(axis) {
    var params = $6a439e51dccdc432$var$fetchAutoCategoryIntervalCalculationParams(axis);
    var labelFormatter = (0, $2d646e51cc34f840$export$742f19a75415b2ae)(axis);
    var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    // Providing this method is for optimization:
    // avoid generating a long array by `getTicks`
    // in large category data case.
    var tickCount = ordinalScale.count();
    if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
    var step = 1;
    // Simple optimization. Empirical value: tick count should less than 40.
    if (tickCount > 40) step = Math.max(1, Math.floor(tickCount / 40));
    var tickValue = ordinalExtent[0];
    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
    var unitW = Math.abs(unitSpan * Math.cos(rotation));
    var unitH = Math.abs(unitSpan * Math.sin(rotation));
    var maxW = 0;
    var maxH = 0;
    // Caution: Performance sensitive for large category data.
    // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
    for(; tickValue <= ordinalExtent[1]; tickValue += step){
        var width = 0;
        var height = 0;
        // Not precise, do not consider align and vertical align
        // and each distance from axis line yet.
        var rect = $6c308355c7107803$export$c381147bfed79d9f(labelFormatter({
            value: tickValue
        }), params.font, "center", "top");
        // Magic number
        width = rect.width * 1.3;
        height = rect.height * 1.3;
        // Min size, void long loop.
        maxW = Math.max(maxW, width, 7);
        maxH = Math.max(maxH, height, 7);
    }
    var dw = maxW / unitW;
    var dh = maxH / unitH;
    // 0/0 is NaN, 1/0 is Infinity.
    isNaN(dw) && (dw = Infinity);
    isNaN(dh) && (dh = Infinity);
    var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
    var cache = $6a439e51dccdc432$var$inner(axis.model);
    var axisExtent = axis.getExtent();
    var lastAutoInterval = cache.lastAutoInterval;
    var lastTickCount = cache.lastTickCount;
    // Use cache to keep interval stable while moving zoom window,
    // otherwise the calculated interval might jitter when the zoom
    // window size is close to the interval-changing size.
    // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
    // The jitter will cause that sometimes the displayed labels are
    // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 && lastAutoInterval > interval && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) interval = lastAutoInterval;
    else {
        cache.lastTickCount = tickCount;
        cache.lastAutoInterval = interval;
        cache.axisExtent0 = axisExtent[0];
        cache.axisExtent1 = axisExtent[1];
    }
    return interval;
}
function $6a439e51dccdc432$var$fetchAutoCategoryIntervalCalculationParams(axis) {
    var labelModel = axis.getLabelModel();
    return {
        axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
        labelRotate: labelModel.get("rotate") || 0,
        font: labelModel.getFont()
    };
}
function $6a439e51dccdc432$var$makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
    var labelFormatter = (0, $2d646e51cc34f840$export$742f19a75415b2ae)(axis);
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    var labelModel = axis.getLabelModel();
    var result = [];
    // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...
    var step = Math.max((categoryInterval || 0) + 1, 1);
    var startTick = ordinalExtent[0];
    var tickCount = ordinalScale.count();
    // Calculate start tick based on zero if possible to keep label consistent
    // while zooming and moving while interval > 0. Otherwise the selection
    // of displayable ticks and symbols probably keep changing.
    // 3 is empirical value.
    if (startTick !== 0 && step > 1 && tickCount / step > 2) startTick = Math.round(Math.ceil(startTick / step) * step);
    // (1) Only add min max label here but leave overlap checking
    // to render stage, which also ensure the returned list
    // suitable for splitLine and splitArea rendering.
    // (2) Scales except category always contain min max label so
    // do not need to perform this process.
    var showAllLabel = (0, $2d646e51cc34f840$export$c2911c025243d6a6)(axis);
    var includeMinLabel = labelModel.get("showMinLabel") || showAllLabel;
    var includeMaxLabel = labelModel.get("showMaxLabel") || showAllLabel;
    if (includeMinLabel && startTick !== ordinalExtent[0]) addItem(ordinalExtent[0]);
    // Optimize: avoid generating large array by `ordinalScale.getTicks()`.
    var tickValue = startTick;
    for(; tickValue <= ordinalExtent[1]; tickValue += step)addItem(tickValue);
    if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) addItem(ordinalExtent[1]);
    function addItem(tickValue) {
        var tickObj = {
            value: tickValue
        };
        result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tickObj),
            rawLabel: ordinalScale.getLabel(tickObj),
            tickValue: tickValue
        });
    }
    return result;
}
function $6a439e51dccdc432$var$makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
    var ordinalScale = axis.scale;
    var labelFormatter = (0, $2d646e51cc34f840$export$742f19a75415b2ae)(axis);
    var result = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(ordinalScale.getTicks(), function(tick) {
        var rawLabel = ordinalScale.getLabel(tick);
        var tickValue = tick.value;
        if (categoryInterval(tick.value, rawLabel)) result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tick),
            rawLabel: rawLabel,
            tickValue: tickValue
        });
    });
    return result;
}


var $c2b1efffe5ae3f42$var$NORMALIZED_EXTENT = [
    0,
    1
];
/**
 * Base class of Axis.
 */ var $c2b1efffe5ae3f42$var$Axis = /** @class */ function() {
    function Axis(dim, scale, extent) {
        this.onBand = false;
        this.inverse = false;
        this.dim = dim;
        this.scale = scale;
        this._extent = extent || [
            0,
            0
        ];
    }
    /**
   * If axis extent contain given coord
   */ Axis.prototype.contain = function(coord) {
        var extent = this._extent;
        var min = Math.min(extent[0], extent[1]);
        var max = Math.max(extent[0], extent[1]);
        return coord >= min && coord <= max;
    };
    /**
   * If axis extent contain given data
   */ Axis.prototype.containData = function(data) {
        return this.scale.contain(data);
    };
    /**
   * Get coord extent.
   */ Axis.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Get precision used for formatting
   */ Axis.prototype.getPixelPrecision = function(dataExtent) {
        return (0, $cfc1f3b422a3185f$export$666260d9a2dda8a7)(dataExtent || this.scale.getExtent(), this._extent);
    };
    /**
   * Set coord extent
   */ Axis.prototype.setExtent = function(start, end) {
        var extent = this._extent;
        extent[0] = start;
        extent[1] = end;
    };
    /**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   */ Axis.prototype.dataToCoord = function(data, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        data = scale.normalize(data);
        if (this.onBand && scale.type === "ordinal") {
            extent = extent.slice();
            $c2b1efffe5ae3f42$var$fixExtentWithBands(extent, scale.count());
        }
        return (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(data, $c2b1efffe5ae3f42$var$NORMALIZED_EXTENT, extent, clamp);
    };
    /**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   */ Axis.prototype.coordToData = function(coord, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        if (this.onBand && scale.type === "ordinal") {
            extent = extent.slice();
            $c2b1efffe5ae3f42$var$fixExtentWithBands(extent, scale.count());
        }
        var t = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(coord, extent, $c2b1efffe5ae3f42$var$NORMALIZED_EXTENT, clamp);
        return this.scale.scale(t);
    };
    /**
   * Convert pixel point to data in axis
   */ Axis.prototype.pointToData = function(point, clamp) {
        // Should be implemented in derived class if necessary.
        return;
    };
    /**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param opt.tickModel default: axis.model.getModel('axisTick')
   * @param opt.clamp If `true`, the first and the last
   *        tick must be at the axis end points. Otherwise, clip ticks
   *        that outside the axis extent.
   */ Axis.prototype.getTicksCoords = function(opt) {
        opt = opt || {};
        var tickModel = opt.tickModel || this.getTickModel();
        var result = (0, $6a439e51dccdc432$export$7cccf6836ae8323c)(this, tickModel);
        var ticks = result.ticks;
        var ticksCoords = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(ticks, function(tickVal) {
            return {
                coord: this.dataToCoord(this.scale.type === "ordinal" ? this.scale.getRawOrdinalNumber(tickVal) : tickVal),
                tickValue: tickVal
            };
        }, this);
        var alignWithLabel = tickModel.get("alignWithLabel");
        $c2b1efffe5ae3f42$var$fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
        return ticksCoords;
    };
    Axis.prototype.getMinorTicksCoords = function() {
        if (this.scale.type === "ordinal") // Category axis doesn't support minor ticks
        return [];
        var minorTickModel = this.model.getModel("minorTick");
        var splitNumber = minorTickModel.get("splitNumber");
        // Protection.
        if (!(splitNumber > 0 && splitNumber < 100)) splitNumber = 5;
        var minorTicks = this.scale.getMinorTicks(splitNumber);
        var minorTicksCoords = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(minorTicks, function(minorTicksGroup) {
            return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(minorTicksGroup, function(minorTick) {
                return {
                    coord: this.dataToCoord(minorTick),
                    tickValue: minorTick
                };
            }, this);
        }, this);
        return minorTicksCoords;
    };
    Axis.prototype.getViewLabels = function() {
        return (0, $6a439e51dccdc432$export$10216ebd3e3e485e)(this).labels;
    };
    Axis.prototype.getLabelModel = function() {
        return this.model.getModel("axisLabel");
    };
    /**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overridden to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   */ Axis.prototype.getTickModel = function() {
        return this.model.getModel("axisTick");
    };
    /**
   * Get width of band
   */ Axis.prototype.getBandWidth = function() {
        var axisExtent = this._extent;
        var dataExtent = this.scale.getExtent();
        var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0);
        // Fix #2728, avoid NaN when only one data.
        len === 0 && (len = 1);
        var size = Math.abs(axisExtent[1] - axisExtent[0]);
        return Math.abs(size) / len;
    };
    /**
   * Only be called in category axis.
   * Can be overridden, consider other axes like in 3D.
   * @return Auto interval for cateogry axis tick and label
   */ Axis.prototype.calculateCategoryInterval = function() {
        return (0, $6a439e51dccdc432$export$9ea1d3f146a5a65f)(this);
    };
    return Axis;
}();
function $c2b1efffe5ae3f42$var$fixExtentWithBands(extent, nTick) {
    var size = extent[1] - extent[0];
    var len = nTick;
    var margin = size / len / 2;
    extent[0] += margin;
    extent[1] -= margin;
}
// If axis has labels [1, 2, 3, 4]. Bands on the axis are
// |---1---|---2---|---3---|---4---|.
// So the displayed ticks and splitLine/splitArea should between
// each data item, otherwise cause misleading (e.g., split tow bars
// of a single data item when there are two bar series).
// Also consider if tickCategoryInterval > 0 and onBand, ticks and
// splitLine/spliteArea should layout appropriately corresponding
// to displayed labels. (So we should not use `getBandWidth` in this
// case).
function $c2b1efffe5ae3f42$var$fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
    var ticksLen = ticksCoords.length;
    if (!axis.onBand || alignWithLabel || !ticksLen) return;
    var axisExtent = axis.getExtent();
    var last;
    var diffSize;
    if (ticksLen === 1) {
        ticksCoords[0].coord = axisExtent[0];
        last = ticksCoords[1] = {
            coord: axisExtent[1]
        };
    } else {
        var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
        var shift_1 = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ticksCoords, function(ticksItem) {
            ticksItem.coord -= shift_1 / 2;
        });
        var dataExtent = axis.scale.getExtent();
        diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
        last = {
            coord: ticksCoords[ticksLen - 1].coord + shift_1 * diffSize
        };
        ticksCoords.push(last);
    }
    var inverse = axisExtent[0] > axisExtent[1];
    // Handling clamp.
    if (littleThan(ticksCoords[0].coord, axisExtent[0])) clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
    if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) ticksCoords.unshift({
        coord: axisExtent[0]
    });
    if (littleThan(axisExtent[1], last.coord)) clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
    if (clamp && littleThan(last.coord, axisExtent[1])) ticksCoords.push({
        coord: axisExtent[1]
    });
    function littleThan(a, b) {
        // Avoid rounding error cause calculated tick coord different with extent.
        // It may cause an extra unnecessary tick added.
        a = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(a);
        b = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(b);
        return inverse ? a > b : a < b;
    }
}
var $c2b1efffe5ae3f42$export$2e2bcd8739ae039 = $c2b1efffe5ae3f42$var$Axis;


var $ec1c8727611588c2$var$ParallelAxis = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelAxis, _super);
    function ParallelAxis(dim, scale, coordExtent, axisType, axisIndex) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        _this.type = axisType || "value";
        _this.axisIndex = axisIndex;
        return _this;
    }
    ParallelAxis.prototype.isHorizontal = function() {
        return this.coordinateSystem.getModel().get("layout") !== "horizontal";
    };
    return ParallelAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $ec1c8727611588c2$export$2e2bcd8739ae039 = $ec1c8727611588c2$var$ParallelAxis;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Calculate slider move result.
 * Usage:
 * (1) If both handle0 and handle1 are needed to be moved, set minSpan the same as
 * maxSpan and the same as `Math.abs(handleEnd[1] - handleEnds[0])`.
 * (2) If handle0 is forbidden to cross handle1, set minSpan as `0`.
 *
 * @param delta Move length.
 * @param handleEnds handleEnds[0] can be bigger then handleEnds[1].
 *              handleEnds will be modified in this method.
 * @param extent handleEnds is restricted by extent.
 *              extent[0] should less or equals than extent[1].
 * @param handleIndex Can be 'all', means that both move the two handleEnds.
 * @param minSpan The range of dataZoom can not be smaller than that.
 *              If not set, handle0 and cross handle1. If set as a non-negative
 *              number (including `0`), handles will push each other when reaching
 *              the minSpan.
 * @param maxSpan The range of dataZoom can not be larger than that.
 * @return The input handleEnds.
 */ function $00a8003b34293330$export$2e2bcd8739ae039(delta, handleEnds, extent, handleIndex, minSpan, maxSpan) {
    delta = delta || 0;
    var extentSpan = extent[1] - extent[0];
    // Notice maxSpan and minSpan can be null/undefined.
    if (minSpan != null) minSpan = $00a8003b34293330$var$restrict(minSpan, [
        0,
        extentSpan
    ]);
    if (maxSpan != null) maxSpan = Math.max(maxSpan, minSpan != null ? minSpan : 0);
    if (handleIndex === "all") {
        var handleSpan = Math.abs(handleEnds[1] - handleEnds[0]);
        handleSpan = $00a8003b34293330$var$restrict(handleSpan, [
            0,
            extentSpan
        ]);
        minSpan = maxSpan = $00a8003b34293330$var$restrict(handleSpan, [
            minSpan,
            maxSpan
        ]);
        handleIndex = 0;
    }
    handleEnds[0] = $00a8003b34293330$var$restrict(handleEnds[0], extent);
    handleEnds[1] = $00a8003b34293330$var$restrict(handleEnds[1], extent);
    var originalDistSign = $00a8003b34293330$var$getSpanSign(handleEnds, handleIndex);
    handleEnds[handleIndex] += delta;
    // Restrict in extent.
    var extentMinSpan = minSpan || 0;
    var realExtent = extent.slice();
    originalDistSign.sign < 0 ? realExtent[0] += extentMinSpan : realExtent[1] -= extentMinSpan;
    handleEnds[handleIndex] = $00a8003b34293330$var$restrict(handleEnds[handleIndex], realExtent);
    // Expand span.
    var currDistSign;
    currDistSign = $00a8003b34293330$var$getSpanSign(handleEnds, handleIndex);
    if (minSpan != null && (currDistSign.sign !== originalDistSign.sign || currDistSign.span < minSpan)) // If minSpan exists, 'cross' is forbidden.
    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + originalDistSign.sign * minSpan;
    // Shrink span.
    currDistSign = $00a8003b34293330$var$getSpanSign(handleEnds, handleIndex);
    if (maxSpan != null && currDistSign.span > maxSpan) handleEnds[1 - handleIndex] = handleEnds[handleIndex] + currDistSign.sign * maxSpan;
    return handleEnds;
}
function $00a8003b34293330$var$getSpanSign(handleEnds, handleIndex) {
    var dist = handleEnds[handleIndex] - handleEnds[1 - handleIndex];
    // If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
    // is at left of handleEnds[1] for non-cross case.
    return {
        span: Math.abs(dist),
        sign: dist > 0 ? -1 : dist < 0 ? 1 : handleIndex ? -1 : 1
    };
}
function $00a8003b34293330$var$restrict(value, extend) {
    return Math.min(extend[1] != null ? extend[1] : Infinity, Math.max(extend[0] != null ? extend[0] : -Infinity, value));
}


var $a26a2212b9c3ac89$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $a26a2212b9c3ac89$var$mathMin = Math.min;
var $a26a2212b9c3ac89$var$mathMax = Math.max;
var $a26a2212b9c3ac89$var$mathFloor = Math.floor;
var $a26a2212b9c3ac89$var$mathCeil = Math.ceil;
var $a26a2212b9c3ac89$var$round = $cfc1f3b422a3185f$export$2077e0241d6afd3c;
var $a26a2212b9c3ac89$var$PI = Math.PI;
var $a26a2212b9c3ac89$var$Parallel = /** @class */ function() {
    function Parallel(parallelModel, ecModel, api) {
        this.type = "parallel";
        /**
     * key: dimension
     */ this._axesMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        /**
     * key: dimension
     * value: {position: [], rotation, }
     */ this._axesLayout = {};
        this.dimensions = parallelModel.dimensions;
        this._model = parallelModel;
        this._init(parallelModel, ecModel, api);
    }
    Parallel.prototype._init = function(parallelModel, ecModel, api) {
        var dimensions = parallelModel.dimensions;
        var parallelAxisIndex = parallelModel.parallelAxisIndex;
        $a26a2212b9c3ac89$var$each(dimensions, function(dim, idx) {
            var axisIndex = parallelAxisIndex[idx];
            var axisModel = ecModel.getComponent("parallelAxis", axisIndex);
            var axis = this._axesMap.set(dim, new (0, $ec1c8727611588c2$export$2e2bcd8739ae039)(dim, $2d646e51cc34f840$export$8941c4cacdc8f5a5(axisModel), [
                0,
                0
            ], axisModel.get("type"), axisIndex));
            var isCategory = axis.type === "category";
            axis.onBand = isCategory && axisModel.get("boundaryGap");
            axis.inverse = axisModel.get("inverse");
            // Injection
            axisModel.axis = axis;
            axis.model = axisModel;
            axis.coordinateSystem = axisModel.coordinateSystem = this;
        }, this);
    };
    /**
   * Update axis scale after data processed
   */ Parallel.prototype.update = function(ecModel, api) {
        this._updateAxesFromSeries(this._model, ecModel);
    };
    Parallel.prototype.containPoint = function(point) {
        var layoutInfo = this._makeLayoutInfo();
        var axisBase = layoutInfo.axisBase;
        var layoutBase = layoutInfo.layoutBase;
        var pixelDimIndex = layoutInfo.pixelDimIndex;
        var pAxis = point[1 - pixelDimIndex];
        var pLayout = point[pixelDimIndex];
        return pAxis >= axisBase && pAxis <= axisBase + layoutInfo.axisLength && pLayout >= layoutBase && pLayout <= layoutBase + layoutInfo.layoutLength;
    };
    Parallel.prototype.getModel = function() {
        return this._model;
    };
    /**
   * Update properties from series
   */ Parallel.prototype._updateAxesFromSeries = function(parallelModel, ecModel) {
        ecModel.eachSeries(function(seriesModel) {
            if (!parallelModel.contains(seriesModel, ecModel)) return;
            var data = seriesModel.getData();
            $a26a2212b9c3ac89$var$each(this.dimensions, function(dim) {
                var axis = this._axesMap.get(dim);
                axis.scale.unionExtentFromData(data, data.mapDimension(dim));
                $2d646e51cc34f840$export$51f3e70a54405d5a(axis.scale, axis.model);
            }, this);
        }, this);
    };
    /**
   * Resize the parallel coordinate system.
   */ Parallel.prototype.resize = function(parallelModel, api) {
        this._rect = $93b9bc7f22ac7369$export$4517a5ca639a7293(parallelModel.getBoxLayoutParams(), {
            width: api.getWidth(),
            height: api.getHeight()
        });
        this._layoutAxes();
    };
    Parallel.prototype.getRect = function() {
        return this._rect;
    };
    Parallel.prototype._makeLayoutInfo = function() {
        var parallelModel = this._model;
        var rect = this._rect;
        var xy = [
            "x",
            "y"
        ];
        var wh = [
            "width",
            "height"
        ];
        var layout = parallelModel.get("layout");
        var pixelDimIndex = layout === "horizontal" ? 0 : 1;
        var layoutLength = rect[wh[pixelDimIndex]];
        var layoutExtent = [
            0,
            layoutLength
        ];
        var axisCount = this.dimensions.length;
        var axisExpandWidth = $a26a2212b9c3ac89$var$restrict(parallelModel.get("axisExpandWidth"), layoutExtent);
        var axisExpandCount = $a26a2212b9c3ac89$var$restrict(parallelModel.get("axisExpandCount") || 0, [
            0,
            axisCount
        ]);
        var axisExpandable = parallelModel.get("axisExpandable") && axisCount > 3 && axisCount > axisExpandCount && axisExpandCount > 1 && axisExpandWidth > 0 && layoutLength > 0;
        // `axisExpandWindow` is According to the coordinates of [0, axisExpandLength],
        // for sake of consider the case that axisCollapseWidth is 0 (when screen is narrow),
        // where collapsed axes should be overlapped.
        var axisExpandWindow = parallelModel.get("axisExpandWindow");
        var winSize;
        if (!axisExpandWindow) {
            winSize = $a26a2212b9c3ac89$var$restrict(axisExpandWidth * (axisExpandCount - 1), layoutExtent);
            var axisExpandCenter = parallelModel.get("axisExpandCenter") || $a26a2212b9c3ac89$var$mathFloor(axisCount / 2);
            axisExpandWindow = [
                axisExpandWidth * axisExpandCenter - winSize / 2
            ];
            axisExpandWindow[1] = axisExpandWindow[0] + winSize;
        } else {
            winSize = $a26a2212b9c3ac89$var$restrict(axisExpandWindow[1] - axisExpandWindow[0], layoutExtent);
            axisExpandWindow[1] = axisExpandWindow[0] + winSize;
        }
        var axisCollapseWidth = (layoutLength - winSize) / (axisCount - axisExpandCount);
        // Avoid axisCollapseWidth is too small.
        axisCollapseWidth < 3 && (axisCollapseWidth = 0);
        // Find the first and last indices > ewin[0] and < ewin[1].
        var winInnerIndices = [
            $a26a2212b9c3ac89$var$mathFloor($a26a2212b9c3ac89$var$round(axisExpandWindow[0] / axisExpandWidth, 1)) + 1,
            $a26a2212b9c3ac89$var$mathCeil($a26a2212b9c3ac89$var$round(axisExpandWindow[1] / axisExpandWidth, 1)) - 1
        ];
        // Pos in ec coordinates.
        var axisExpandWindow0Pos = axisCollapseWidth / axisExpandWidth * axisExpandWindow[0];
        return {
            layout: layout,
            pixelDimIndex: pixelDimIndex,
            layoutBase: rect[xy[pixelDimIndex]],
            layoutLength: layoutLength,
            axisBase: rect[xy[1 - pixelDimIndex]],
            axisLength: rect[wh[1 - pixelDimIndex]],
            axisExpandable: axisExpandable,
            axisExpandWidth: axisExpandWidth,
            axisCollapseWidth: axisCollapseWidth,
            axisExpandWindow: axisExpandWindow,
            axisCount: axisCount,
            winInnerIndices: winInnerIndices,
            axisExpandWindow0Pos: axisExpandWindow0Pos
        };
    };
    Parallel.prototype._layoutAxes = function() {
        var rect = this._rect;
        var axes = this._axesMap;
        var dimensions = this.dimensions;
        var layoutInfo = this._makeLayoutInfo();
        var layout = layoutInfo.layout;
        axes.each(function(axis) {
            var axisExtent = [
                0,
                layoutInfo.axisLength
            ];
            var idx = axis.inverse ? 1 : 0;
            axis.setExtent(axisExtent[idx], axisExtent[1 - idx]);
        });
        $a26a2212b9c3ac89$var$each(dimensions, function(dim, idx) {
            var posInfo = (layoutInfo.axisExpandable ? $a26a2212b9c3ac89$var$layoutAxisWithExpand : $a26a2212b9c3ac89$var$layoutAxisWithoutExpand)(idx, layoutInfo);
            var positionTable = {
                horizontal: {
                    x: posInfo.position,
                    y: layoutInfo.axisLength
                },
                vertical: {
                    x: 0,
                    y: posInfo.position
                }
            };
            var rotationTable = {
                horizontal: $a26a2212b9c3ac89$var$PI / 2,
                vertical: 0
            };
            var position = [
                positionTable[layout].x + rect.x,
                positionTable[layout].y + rect.y
            ];
            var rotation = rotationTable[layout];
            var transform = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            $f41ebb9dd60b55b4$export$bb628a54ab399bc9(transform, transform, rotation);
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(transform, transform, position);
            // TODO
            // tick layout info
            // TODO
            // update dimensions info based on axis order.
            this._axesLayout[dim] = {
                position: position,
                rotation: rotation,
                transform: transform,
                axisNameAvailableWidth: posInfo.axisNameAvailableWidth,
                axisLabelShow: posInfo.axisLabelShow,
                nameTruncateMaxWidth: posInfo.nameTruncateMaxWidth,
                tickDirection: 1,
                labelDirection: 1
            };
        }, this);
    };
    /**
   * Get axis by dim.
   */ Parallel.prototype.getAxis = function(dim) {
        return this._axesMap.get(dim);
    };
    /**
   * Convert a dim value of a single item of series data to Point.
   */ Parallel.prototype.dataToPoint = function(value, dim) {
        return this.axisCoordToPoint(this._axesMap.get(dim).dataToCoord(value), dim);
    };
    /**
   * Travel data for one time, get activeState of each data item.
   * @param start the start dataIndex that travel from.
   * @param end the next dataIndex of the last dataIndex will be travel.
   */ Parallel.prototype.eachActiveState = function(data, callback, start, end) {
        start == null && (start = 0);
        end == null && (end = data.count());
        var axesMap = this._axesMap;
        var dimensions = this.dimensions;
        var dataDimensions = [];
        var axisModels = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(dimensions, function(axisDim) {
            dataDimensions.push(data.mapDimension(axisDim));
            axisModels.push(axesMap.get(axisDim).model);
        });
        var hasActiveSet = this.hasAxisBrushed();
        for(var dataIndex = start; dataIndex < end; dataIndex++){
            var activeState = void 0;
            if (!hasActiveSet) activeState = "normal";
            else {
                activeState = "active";
                var values = data.getValues(dataDimensions, dataIndex);
                for(var j = 0, lenj = dimensions.length; j < lenj; j++){
                    var state = axisModels[j].getActiveState(values[j]);
                    if (state === "inactive") {
                        activeState = "inactive";
                        break;
                    }
                }
            }
            callback(activeState, dataIndex);
        }
    };
    /**
   * Whether has any activeSet.
   */ Parallel.prototype.hasAxisBrushed = function() {
        var dimensions = this.dimensions;
        var axesMap = this._axesMap;
        var hasActiveSet = false;
        for(var j = 0, lenj = dimensions.length; j < lenj; j++)if (axesMap.get(dimensions[j]).model.getActiveState() !== "normal") hasActiveSet = true;
        return hasActiveSet;
    };
    /**
   * Convert coords of each axis to Point.
   *  Return point. For example: [10, 20]
   */ Parallel.prototype.axisCoordToPoint = function(coord, dim) {
        var axisLayout = this._axesLayout[dim];
        return $5b455ae6f843ac47$export$9f9dcb98c894b623([
            coord,
            0
        ], axisLayout.transform);
    };
    /**
   * Get axis layout.
   */ Parallel.prototype.getAxisLayout = function(dim) {
        return $7a1bd9c2710fea0d$export$9cd59f9826255e47(this._axesLayout[dim]);
    };
    /**
   * @return {Object} {axisExpandWindow, delta, behavior: 'jump' | 'slide' | 'none'}.
   */ Parallel.prototype.getSlidedAxisExpandWindow = function(point) {
        var layoutInfo = this._makeLayoutInfo();
        var pixelDimIndex = layoutInfo.pixelDimIndex;
        var axisExpandWindow = layoutInfo.axisExpandWindow.slice();
        var winSize = axisExpandWindow[1] - axisExpandWindow[0];
        var extent = [
            0,
            layoutInfo.axisExpandWidth * (layoutInfo.axisCount - 1)
        ];
        // Out of the area of coordinate system.
        if (!this.containPoint(point)) return {
            behavior: "none",
            axisExpandWindow: axisExpandWindow
        };
        // Convert the point from global to expand coordinates.
        var pointCoord = point[pixelDimIndex] - layoutInfo.layoutBase - layoutInfo.axisExpandWindow0Pos;
        // For dragging operation convenience, the window should not be
        // slided when mouse is the center area of the window.
        var delta;
        var behavior = "slide";
        var axisCollapseWidth = layoutInfo.axisCollapseWidth;
        var triggerArea = this._model.get("axisExpandSlideTriggerArea");
        // But consider touch device, jump is necessary.
        var useJump = triggerArea[0] != null;
        if (axisCollapseWidth) {
            if (useJump && axisCollapseWidth && pointCoord < winSize * triggerArea[0]) {
                behavior = "jump";
                delta = pointCoord - winSize * triggerArea[2];
            } else if (useJump && axisCollapseWidth && pointCoord > winSize * (1 - triggerArea[0])) {
                behavior = "jump";
                delta = pointCoord - winSize * (1 - triggerArea[2]);
            } else (delta = pointCoord - winSize * triggerArea[1]) >= 0 && (delta = pointCoord - winSize * (1 - triggerArea[1])) <= 0 && (delta = 0);
            delta *= layoutInfo.axisExpandWidth / axisCollapseWidth;
            delta ? (0, $00a8003b34293330$export$2e2bcd8739ae039)(delta, axisExpandWindow, extent, "all") : behavior = "none";
        } else {
            var winSize2 = axisExpandWindow[1] - axisExpandWindow[0];
            var pos = extent[1] * pointCoord / winSize2;
            axisExpandWindow = [
                $a26a2212b9c3ac89$var$mathMax(0, pos - winSize2 / 2)
            ];
            axisExpandWindow[1] = $a26a2212b9c3ac89$var$mathMin(extent[1], axisExpandWindow[0] + winSize2);
            axisExpandWindow[0] = axisExpandWindow[1] - winSize2;
        }
        return {
            axisExpandWindow: axisExpandWindow,
            behavior: behavior
        };
    };
    return Parallel;
}();
function $a26a2212b9c3ac89$var$restrict(len, extent) {
    return $a26a2212b9c3ac89$var$mathMin($a26a2212b9c3ac89$var$mathMax(len, extent[0]), extent[1]);
}
function $a26a2212b9c3ac89$var$layoutAxisWithoutExpand(axisIndex, layoutInfo) {
    var step = layoutInfo.layoutLength / (layoutInfo.axisCount - 1);
    return {
        position: step * axisIndex,
        axisNameAvailableWidth: step,
        axisLabelShow: true
    };
}
function $a26a2212b9c3ac89$var$layoutAxisWithExpand(axisIndex, layoutInfo) {
    var layoutLength = layoutInfo.layoutLength;
    var axisExpandWidth = layoutInfo.axisExpandWidth;
    var axisCount = layoutInfo.axisCount;
    var axisCollapseWidth = layoutInfo.axisCollapseWidth;
    var winInnerIndices = layoutInfo.winInnerIndices;
    var position;
    var axisNameAvailableWidth = axisCollapseWidth;
    var axisLabelShow = false;
    var nameTruncateMaxWidth;
    if (axisIndex < winInnerIndices[0]) {
        position = axisIndex * axisCollapseWidth;
        nameTruncateMaxWidth = axisCollapseWidth;
    } else if (axisIndex <= winInnerIndices[1]) {
        position = layoutInfo.axisExpandWindow0Pos + axisIndex * axisExpandWidth - layoutInfo.axisExpandWindow[0];
        axisNameAvailableWidth = axisExpandWidth;
        axisLabelShow = true;
    } else {
        position = layoutLength - (axisCount - 1 - axisIndex) * axisCollapseWidth;
        nameTruncateMaxWidth = axisCollapseWidth;
    }
    return {
        position: position,
        axisNameAvailableWidth: axisNameAvailableWidth,
        axisLabelShow: axisLabelShow,
        nameTruncateMaxWidth: nameTruncateMaxWidth
    };
}
var $a26a2212b9c3ac89$export$2e2bcd8739ae039 = $a26a2212b9c3ac89$var$Parallel;



function $88531590cdbcfc26$var$createParallelCoordSys(ecModel, api) {
    var coordSysList = [];
    ecModel.eachComponent("parallel", function(parallelModel, idx) {
        var coordSys = new (0, $a26a2212b9c3ac89$export$2e2bcd8739ae039)(parallelModel, ecModel, api);
        coordSys.name = "parallel_" + idx;
        coordSys.resize(parallelModel, api);
        parallelModel.coordinateSystem = coordSys;
        coordSys.model = parallelModel;
        coordSysList.push(coordSys);
    });
    // Inject the coordinateSystems into seriesModel
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.get("coordinateSystem") === "parallel") {
            var parallelModel = seriesModel.getReferringComponents("parallel", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
            seriesModel.coordinateSystem = parallelModel.coordinateSystem;
        }
    });
    return coordSysList;
}
var $88531590cdbcfc26$var$parallelCoordSysCreator = {
    create: $88531590cdbcfc26$var$createParallelCoordSys
};
var $88531590cdbcfc26$export$2e2bcd8739ae039 = $88531590cdbcfc26$var$parallelCoordSysCreator;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ad861b9162f24222$var$defaultOption = {
    show: true,
    // zlevel: 0,
    z: 0,
    // Inverse the axis.
    inverse: false,
    // Axis name displayed.
    name: "",
    // 'start' | 'middle' | 'end'
    nameLocation: "end",
    // By degree. By default auto rotate by nameLocation.
    nameRotate: null,
    nameTruncate: {
        maxWidth: null,
        ellipsis: "...",
        placeholder: "."
    },
    // Use global text style by default.
    nameTextStyle: {},
    // The gap between axisName and axisLine.
    nameGap: 15,
    // Default `false` to support tooltip.
    silent: false,
    // Default `false` to avoid legacy user event listener fail.
    triggerEvent: false,
    tooltip: {
        show: false
    },
    axisPointer: {},
    axisLine: {
        show: true,
        onZero: true,
        onZeroAxisIndex: null,
        lineStyle: {
            color: "#6E7079",
            width: 1,
            type: "solid"
        },
        // The arrow at both ends the the axis.
        symbol: [
            "none",
            "none"
        ],
        symbolSize: [
            10,
            15
        ]
    },
    axisTick: {
        show: true,
        // Whether axisTick is inside the grid or outside the grid.
        inside: false,
        // The length of axisTick.
        length: 5,
        lineStyle: {
            width: 1
        }
    },
    axisLabel: {
        show: true,
        // Whether axisLabel is inside the grid or outside the grid.
        inside: false,
        rotate: 0,
        // true | false | null/undefined (auto)
        showMinLabel: null,
        // true | false | null/undefined (auto)
        showMaxLabel: null,
        margin: 8,
        // formatter: null,
        fontSize: 12
    },
    splitLine: {
        show: true,
        lineStyle: {
            color: [
                "#E0E6F1"
            ],
            width: 1,
            type: "solid"
        }
    },
    splitArea: {
        show: false,
        areaStyle: {
            color: [
                "rgba(250,250,250,0.2)",
                "rgba(210,219,238,0.2)"
            ]
        }
    }
};
var $ad861b9162f24222$var$categoryAxis = $7a1bd9c2710fea0d$export$4950aa0f605343fb({
    // The gap at both ends of the axis. For categoryAxis, boolean.
    boundaryGap: true,
    // Set false to faster category collection.
    deduplication: null,
    // splitArea: {
    // show: false
    // },
    splitLine: {
        show: false
    },
    axisTick: {
        // If tick is align with label when boundaryGap is true
        alignWithLabel: false,
        interval: "auto"
    },
    axisLabel: {
        interval: "auto"
    }
}, $ad861b9162f24222$var$defaultOption);
var $ad861b9162f24222$var$valueAxis = $7a1bd9c2710fea0d$export$4950aa0f605343fb({
    boundaryGap: [
        0,
        0
    ],
    axisLine: {
        // Not shown when other axis is categoryAxis in cartesian
        show: "auto"
    },
    axisTick: {
        // Not shown when other axis is categoryAxis in cartesian
        show: "auto"
    },
    // TODO
    // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
    splitNumber: 5,
    minorTick: {
        // Minor tick, not available for cateogry axis.
        show: false,
        // Split number of minor ticks. The value should be in range of (0, 100)
        splitNumber: 5,
        // Length of minor tick
        length: 3,
        // Line style
        lineStyle: {
        }
    },
    minorSplitLine: {
        show: false,
        lineStyle: {
            color: "#F4F7FD",
            width: 1
        }
    }
}, $ad861b9162f24222$var$defaultOption);
var $ad861b9162f24222$var$timeAxis = $7a1bd9c2710fea0d$export$4950aa0f605343fb({
    splitNumber: 6,
    axisLabel: {
        // To eliminate labels that are not nice
        showMinLabel: false,
        showMaxLabel: false,
        rich: {
            primary: {
                fontWeight: "bold"
            }
        }
    },
    splitLine: {
        show: false
    }
}, $ad861b9162f24222$var$valueAxis);
var $ad861b9162f24222$var$logAxis = $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
    logBase: 10
}, $ad861b9162f24222$var$valueAxis);
var $ad861b9162f24222$export$2e2bcd8739ae039 = {
    category: $ad861b9162f24222$var$categoryAxis,
    value: $ad861b9162f24222$var$valueAxis,
    time: $ad861b9162f24222$var$timeAxis,
    log: $ad861b9162f24222$var$logAxis
};




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $5dc621cc2f35ccb4$export$2e0057d176d6f690 = {
    value: 1,
    category: 1,
    time: 1,
    log: 1
};



function $c5c4c85259d60abe$export$2e2bcd8739ae039(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $5dc621cc2f35ccb4$export$2e0057d176d6f690), function(v, axisType) {
        var defaultOption = (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)({}, (0, $ad861b9162f24222$export$2e2bcd8739ae039)[axisType], true), extraDefaultOption, true);
        var AxisModel = /** @class */ function(_super) {
            (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AxisModel, _super);
            function AxisModel() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.type = axisName + "Axis." + axisType;
                return _this;
            }
            AxisModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
                var layoutMode = (0, $93b9bc7f22ac7369$export$3968a28a7cbd6063)(this);
                var inputPositionParams = layoutMode ? (0, $93b9bc7f22ac7369$export$4b0d20af19c9875e)(option) : {};
                var themeModel = ecModel.getTheme();
                (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(option, themeModel.get(axisType + "Axis"));
                (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(option, this.getDefaultOption());
                option.type = $c5c4c85259d60abe$var$getAxisType(option);
                if (layoutMode) (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(option, inputPositionParams, layoutMode);
            };
            AxisModel.prototype.optionUpdated = function() {
                var thisOption = this.option;
                if (thisOption.type === "category") this.__ordinalMeta = (0, $57fe7cbbaae9fab0$export$2e2bcd8739ae039).createByAxisModel(this);
            };
            /**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */ AxisModel.prototype.getCategories = function(rawData) {
                var option = this.option;
                // FIXME
                // warning if called before all of 'getInitailData' finished.
                if (option.type === "category") {
                    if (rawData) return option.data;
                    return this.__ordinalMeta.categories;
                }
            };
            AxisModel.prototype.getOrdinalMeta = function() {
                return this.__ordinalMeta;
            };
            AxisModel.type = axisName + "Axis." + axisType;
            AxisModel.defaultOption = defaultOption;
            return AxisModel;
        }(BaseAxisModelClass);
        registers.registerComponentModel(AxisModel);
    });
    registers.registerSubTypeDefaulter(axisName + "Axis", $c5c4c85259d60abe$var$getAxisType);
}
function $c5c4c85259d60abe$var$getAxisType(option) {
    // Default axis with data is category axis
    return option.type || (option.data ? "category" : "value");
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
var $3449fd4c0590d99e$export$5c54b224726edb5a = /** @class */ function() {
    function AxisModelCommonMixin() {}
    AxisModelCommonMixin.prototype.getNeedCrossZero = function() {
        var option = this.option;
        return !option.scale;
    };
    /**
   * Should be implemented by each axis model if necessary.
   * @return coordinate system model
   */ AxisModelCommonMixin.prototype.getCoordSysModel = function() {
        return;
    };
    return AxisModelCommonMixin;
}();


var $839a50fcb1c6f44b$var$ParallelAxisModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelAxisModel, _super);
    function ParallelAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelAxisModel.type;
        /**
     * @readOnly
     */ _this.activeIntervals = [];
        return _this;
    }
    ParallelAxisModel.prototype.getAreaSelectStyle = function() {
        return (0, $06542048a26d4d91$export$2e2bcd8739ae039)([
            [
                "fill",
                "color"
            ],
            [
                "lineWidth",
                "borderWidth"
            ],
            [
                "stroke",
                "borderColor"
            ],
            [
                "width",
                "width"
            ],
            [
                "opacity",
                "opacity"
            ]
        ])(this.getModel("areaSelectStyle"));
    };
    /**
   * The code of this feature is put on AxisModel but not ParallelAxis,
   * because axisModel can be alive after echarts updating but instance of
   * ParallelAxis having been disposed. this._activeInterval should be kept
   * when action dispatched (i.e. legend click).
   *
   * @param intervals `interval.length === 0` means set all active.
   */ ParallelAxisModel.prototype.setActiveIntervals = function(intervals) {
        var activeIntervals = this.activeIntervals = $7a1bd9c2710fea0d$export$9cd59f9826255e47(intervals);
        // Normalize
        if (activeIntervals) for(var i = activeIntervals.length - 1; i >= 0; i--)$cfc1f3b422a3185f$export$debe6e778e0a6d32(activeIntervals[i]);
    };
    /**
   * @param value When only attempting detect whether 'no activeIntervals set',
   *        `value` is not needed to be input.
   */ ParallelAxisModel.prototype.getActiveState = function(value) {
        var activeIntervals = this.activeIntervals;
        if (!activeIntervals.length) return "normal";
        if (value == null || isNaN(+value)) return "inactive";
        // Simple optimization
        if (activeIntervals.length === 1) {
            var interval = activeIntervals[0];
            if (interval[0] <= value && value <= interval[1]) return "active";
        } else for(var i = 0, len = activeIntervals.length; i < len; i++){
            if (activeIntervals[i][0] <= value && value <= activeIntervals[i][1]) return "active";
        }
        return "inactive";
    };
    return ParallelAxisModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($839a50fcb1c6f44b$var$ParallelAxisModel, (0, $3449fd4c0590d99e$export$5c54b224726edb5a));
var $839a50fcb1c6f44b$export$2e2bcd8739ae039 = $839a50fcb1c6f44b$var$ParallelAxisModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $11dac7a73f36cc2c$export$6c403cad1ae3e239(input) {
    var list = [];
    for(var i = 0; i < input.length; i++){
        var rawItem = input[i];
        if (rawItem.defaultAttr.ignore) continue;
        var label = rawItem.label;
        var transform = label.getComputedTransform();
        // NOTE: Get bounding rect after getComputedTransform, or label may not been updated by the host el.
        var localRect = label.getBoundingRect();
        var isAxisAligned = !transform || transform[1] < 1e-5 && transform[2] < 1e-5;
        var minMargin = label.style.margin || 0;
        var globalRect = localRect.clone();
        globalRect.applyTransform(transform);
        globalRect.x -= minMargin / 2;
        globalRect.y -= minMargin / 2;
        globalRect.width += minMargin;
        globalRect.height += minMargin;
        var obb = isAxisAligned ? new (0, $f9793b4d8aade116$export$2e2bcd8739ae039)(localRect, transform) : null;
        list.push({
            label: label,
            labelLine: rawItem.labelLine,
            rect: globalRect,
            localRect: localRect,
            obb: obb,
            priority: rawItem.priority,
            defaultAttr: rawItem.defaultAttr,
            layoutOption: rawItem.computedLayoutOption,
            axisAligned: isAxisAligned,
            transform: transform
        });
    }
    return list;
}
function $11dac7a73f36cc2c$var$shiftLayout(list, xyDim, sizeDim, minBound, maxBound, balanceShift) {
    var len = list.length;
    if (len < 2) return;
    list.sort(function(a, b) {
        return a.rect[xyDim] - b.rect[xyDim];
    });
    var lastPos = 0;
    var delta;
    var adjusted = false;
    var shifts = [];
    var totalShifts = 0;
    for(var i = 0; i < len; i++){
        var item = list[i];
        var rect = item.rect;
        delta = rect[xyDim] - lastPos;
        if (delta < 0) {
            // shiftForward(i, len, -delta);
            rect[xyDim] -= delta;
            item.label[xyDim] -= delta;
            adjusted = true;
        }
        var shift = Math.max(-delta, 0);
        shifts.push(shift);
        totalShifts += shift;
        lastPos = rect[xyDim] + rect[sizeDim];
    }
    if (totalShifts > 0 && balanceShift) // Shift back to make the distribution more equally.
    shiftList(-totalShifts / len, 0, len);
    // TODO bleedMargin?
    var first = list[0];
    var last = list[len - 1];
    var minGap;
    var maxGap;
    updateMinMaxGap();
    // If ends exceed two bounds, squeeze at most 80%, then take the gap of two bounds.
    minGap < 0 && squeezeGaps(-minGap, 0.8);
    maxGap < 0 && squeezeGaps(maxGap, 0.8);
    updateMinMaxGap();
    takeBoundsGap(minGap, maxGap, 1);
    takeBoundsGap(maxGap, minGap, -1);
    // Handle bailout when there is not enough space.
    updateMinMaxGap();
    if (minGap < 0) squeezeWhenBailout(-minGap);
    if (maxGap < 0) squeezeWhenBailout(maxGap);
    function updateMinMaxGap() {
        minGap = first.rect[xyDim] - minBound;
        maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
    }
    function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
        if (gapThisBound < 0) {
            // Move from other gap if can.
            var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);
            if (moveFromMaxGap > 0) {
                shiftList(moveFromMaxGap * moveDir, 0, len);
                var remained = moveFromMaxGap + gapThisBound;
                if (remained < 0) squeezeGaps(-remained * moveDir, 1);
            } else squeezeGaps(-gapThisBound * moveDir, 1);
        }
    }
    function shiftList(delta, start, end) {
        if (delta !== 0) adjusted = true;
        for(var i = start; i < end; i++){
            var item = list[i];
            var rect = item.rect;
            rect[xyDim] += delta;
            item.label[xyDim] += delta;
        }
    }
    // Squeeze gaps if the labels exceed margin.
    function squeezeGaps(delta, maxSqeezePercent) {
        var gaps = [];
        var totalGaps = 0;
        for(var i = 1; i < len; i++){
            var prevItemRect = list[i - 1].rect;
            var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
            gaps.push(gap);
            totalGaps += gap;
        }
        if (!totalGaps) return;
        var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);
        if (delta > 0) for(var i = 0; i < len - 1; i++){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i] * squeezePercent;
            // Forward
            shiftList(movement, 0, i + 1);
        }
        else // Backward
        for(var i = len - 1; i > 0; i--){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i - 1] * squeezePercent;
            shiftList(-movement, i, len);
        }
    }
    /**
   * Squeeze to allow overlap if there is no more space available.
   * Let other overlapping strategy like hideOverlap do the job instead of keep exceeding the bounds.
   */ function squeezeWhenBailout(delta) {
        var dir = delta < 0 ? -1 : 1;
        delta = Math.abs(delta);
        var moveForEachLabel = Math.ceil(delta / (len - 1));
        for(var i = 0; i < len - 1; i++){
            if (dir > 0) // Forward
            shiftList(moveForEachLabel, 0, i + 1);
            else // Backward
            shiftList(-moveForEachLabel, len - i - 1, len);
            delta -= moveForEachLabel;
            if (delta <= 0) return;
        }
    }
    return adjusted;
}
function $11dac7a73f36cc2c$export$b6b2b07f8ed32bd6(list, leftBound, rightBound, // If average the shifts on all labels and add them to 0
// TODO: Not sure if should enable it.
// Pros: The angle of lines will distribute more equally
// Cons: In some layout. It may not what user wanted. like in pie. the label of last sector is usually changed unexpectedly.
balanceShift) {
    return $11dac7a73f36cc2c$var$shiftLayout(list, "x", "width", leftBound, rightBound, balanceShift);
}
function $11dac7a73f36cc2c$export$118c25e0932528e4(list, topBound, bottomBound, // If average the shifts on all labels and add them to 0
balanceShift) {
    return $11dac7a73f36cc2c$var$shiftLayout(list, "y", "height", topBound, bottomBound, balanceShift);
}
function $11dac7a73f36cc2c$export$8ce774e164a49410(labelList) {
    var displayedLabels = [];
    // TODO, render overflow visible first, put in the displayedLabels.
    labelList.sort(function(a, b) {
        return b.priority - a.priority;
    });
    var globalRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, 0, 0);
    function hideEl(el) {
        if (!el.ignore) {
            // Show on emphasis.
            var emphasisState = el.ensureState("emphasis");
            if (emphasisState.ignore == null) emphasisState.ignore = false;
        }
        el.ignore = true;
    }
    for(var i = 0; i < labelList.length; i++){
        var labelItem = labelList[i];
        var isAxisAligned = labelItem.axisAligned;
        var localRect = labelItem.localRect;
        var transform = labelItem.transform;
        var label = labelItem.label;
        var labelLine = labelItem.labelLine;
        globalRect.copy(labelItem.rect);
        // Add a threshold because layout may be aligned precisely.
        globalRect.width -= 0.1;
        globalRect.height -= 0.1;
        globalRect.x += 0.05;
        globalRect.y += 0.05;
        var obb = labelItem.obb;
        var overlapped = false;
        for(var j = 0; j < displayedLabels.length; j++){
            var existsTextCfg = displayedLabels[j];
            // Fast rejection.
            if (!globalRect.intersect(existsTextCfg.rect)) continue;
            if (isAxisAligned && existsTextCfg.axisAligned) {
                // Is overlapped
                overlapped = true;
                break;
            }
            if (!existsTextCfg.obb) // If self is not axis aligned. But other is.
            existsTextCfg.obb = new (0, $f9793b4d8aade116$export$2e2bcd8739ae039)(existsTextCfg.localRect, existsTextCfg.transform);
            if (!obb) // If self is axis aligned. But other is not.
            obb = new (0, $f9793b4d8aade116$export$2e2bcd8739ae039)(localRect, transform);
            if (obb.intersect(existsTextCfg.obb)) {
                overlapped = true;
                break;
            }
        }
        // TODO Callback to determine if this overlap should be handled?
        if (overlapped) {
            hideEl(label);
            labelLine && hideEl(labelLine);
        } else {
            label.attr("ignore", labelItem.defaultAttr.ignore);
            labelLine && labelLine.attr("ignore", labelItem.defaultAttr.labelGuideIgnore);
            displayedLabels.push(labelItem);
        }
    }
}


var $dfe15f745e1c3c2b$var$PI = Math.PI;
/**
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
 * for example: (0, 0) ------------> (0, 50)
 *
 * nameDirection or tickDirection or labelDirection is 1 means tick
 * or label is below the standard axis, whereas is -1 means above
 * the standard axis. labelOffset means offset between label and axis,
 * which is useful when 'onZero', where axisLabel is in the grid and
 * label in outside grid.
 *
 * Tips: like always,
 * positive rotation represents anticlockwise, and negative rotation
 * represents clockwise.
 * The direction of position coordinate is the same as the direction
 * of screen coordinate.
 *
 * Do not need to consider axis 'inverse', which is auto processed by
 * axis extent.
 */ var $dfe15f745e1c3c2b$var$AxisBuilder = /** @class */ function() {
    function AxisBuilder(axisModel, opt) {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this.opt = opt;
        this.axisModel = axisModel;
        // Default value
        (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(opt, {
            labelOffset: 0,
            nameDirection: 1,
            tickDirection: 1,
            labelDirection: 1,
            silent: true,
            handleAutoShown: function() {
                return true;
            }
        });
        // FIXME Not use a separate text group?
        var transformGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039({
            x: opt.position[0],
            y: opt.position[1],
            rotation: opt.rotation
        });
        // this.group.add(transformGroup);
        // this._transformGroup = transformGroup;
        transformGroup.updateTransform();
        this._transformGroup = transformGroup;
    }
    AxisBuilder.prototype.hasBuilder = function(name) {
        return !!$dfe15f745e1c3c2b$var$builders[name];
    };
    AxisBuilder.prototype.add = function(name) {
        $dfe15f745e1c3c2b$var$builders[name](this.opt, this.axisModel, this.group, this._transformGroup);
    };
    AxisBuilder.prototype.getGroup = function() {
        return this.group;
    };
    AxisBuilder.innerTextLayout = function(axisRotation, textRotation, direction) {
        var rotationDiff = (0, $cfc1f3b422a3185f$export$2ca6dd70a288b1c3)(textRotation - axisRotation);
        var textAlign;
        var textVerticalAlign;
        if ((0, $cfc1f3b422a3185f$export$d1df570aea2868f)(rotationDiff)) {
            // Label is parallel with axis line.
            textVerticalAlign = direction > 0 ? "top" : "bottom";
            textAlign = "center";
        } else if ((0, $cfc1f3b422a3185f$export$d1df570aea2868f)(rotationDiff - $dfe15f745e1c3c2b$var$PI)) {
            // Label is inverse parallel with axis line.
            textVerticalAlign = direction > 0 ? "bottom" : "top";
            textAlign = "center";
        } else {
            textVerticalAlign = "middle";
            if (rotationDiff > 0 && rotationDiff < $dfe15f745e1c3c2b$var$PI) textAlign = direction > 0 ? "right" : "left";
            else textAlign = direction > 0 ? "left" : "right";
        }
        return {
            rotation: rotationDiff,
            textAlign: textAlign,
            textVerticalAlign: textVerticalAlign
        };
    };
    AxisBuilder.makeAxisEventDataBase = function(axisModel) {
        var eventData = {
            componentType: axisModel.mainType,
            componentIndex: axisModel.componentIndex
        };
        eventData[axisModel.mainType + "Index"] = axisModel.componentIndex;
        return eventData;
    };
    AxisBuilder.isLabelSilent = function(axisModel) {
        var tooltipOpt = axisModel.get("tooltip");
        return axisModel.get("silent") || !(axisModel.get("triggerEvent") || tooltipOpt && tooltipOpt.show);
    };
    return AxisBuilder;
}();
var $dfe15f745e1c3c2b$var$builders = {
    axisLine: function(opt, axisModel, group, transformGroup) {
        var shown = axisModel.get([
            "axisLine",
            "show"
        ]);
        if (shown === "auto" && opt.handleAutoShown) shown = opt.handleAutoShown("axisLine");
        if (!shown) return;
        var extent = axisModel.axis.getExtent();
        var matrix = transformGroup.transform;
        var pt1 = [
            extent[0],
            0
        ];
        var pt2 = [
            extent[1],
            0
        ];
        var inverse = pt1[0] > pt2[0];
        if (matrix) {
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(pt1, pt1, matrix);
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(pt2, pt2, matrix);
        }
        var lineStyle = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            lineCap: "round"
        }, axisModel.getModel([
            "axisLine",
            "lineStyle"
        ]).getLineStyle());
        var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: lineStyle,
            strokeContainThreshold: opt.strokeContainThreshold || 5,
            silent: true,
            z2: 1
        });
        $5b455ae6f843ac47$export$8b4b620d7f4aad1b(line.shape, line.style.lineWidth);
        line.anid = "line";
        group.add(line);
        var arrows = axisModel.get([
            "axisLine",
            "symbol"
        ]);
        if (arrows != null) {
            var arrowSize = axisModel.get([
                "axisLine",
                "symbolSize"
            ]);
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(arrows)) // Use the same arrow for start and end point
            arrows = [
                arrows,
                arrows
            ];
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(arrowSize) || (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(arrowSize)) // Use the same size for width and height
            arrowSize = [
                arrowSize,
                arrowSize
            ];
            var arrowOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(axisModel.get([
                "axisLine",
                "symbolOffset"
            ]) || 0, arrowSize);
            var symbolWidth_1 = arrowSize[0];
            var symbolHeight_1 = arrowSize[1];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
                {
                    rotate: opt.rotation + Math.PI / 2,
                    offset: arrowOffset[0],
                    r: 0
                },
                {
                    rotate: opt.rotation - Math.PI / 2,
                    offset: arrowOffset[1],
                    r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
                }
            ], function(point, index) {
                if (arrows[index] !== "none" && arrows[index] != null) {
                    var symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true);
                    // Calculate arrow position with offset
                    var r = point.r + point.offset;
                    var pt = inverse ? pt2 : pt1;
                    symbol.attr({
                        rotation: point.rotate,
                        x: pt[0] + r * Math.cos(opt.rotation),
                        y: pt[1] - r * Math.sin(opt.rotation),
                        silent: true,
                        z2: 11
                    });
                    group.add(symbol);
                }
            });
        }
    },
    axisTickLabel: function(opt, axisModel, group, transformGroup) {
        var ticksEls = $dfe15f745e1c3c2b$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt);
        var labelEls = $dfe15f745e1c3c2b$var$buildAxisLabel(group, transformGroup, axisModel, opt);
        $dfe15f745e1c3c2b$var$fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
        $dfe15f745e1c3c2b$var$buildAxisMinorTicks(group, transformGroup, axisModel, opt.tickDirection);
        // This bit fixes the label overlap issue for the time chart.
        // See https://github.com/apache/echarts/issues/14266 for more.
        if (axisModel.get([
            "axisLabel",
            "hideOverlap"
        ])) {
            var labelList = (0, $11dac7a73f36cc2c$export$6c403cad1ae3e239)((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(labelEls, function(label) {
                return {
                    label: label,
                    priority: label.z2,
                    defaultAttr: {
                        ignore: label.ignore
                    }
                };
            }));
            (0, $11dac7a73f36cc2c$export$8ce774e164a49410)(labelList);
        }
    },
    axisName: function(opt, axisModel, group, transformGroup) {
        var name = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(opt.axisName, axisModel.get("name"));
        if (!name) return;
        var nameLocation = axisModel.get("nameLocation");
        var nameDirection = opt.nameDirection;
        var textStyleModel = axisModel.getModel("nameTextStyle");
        var gap = axisModel.get("nameGap") || 0;
        var extent = axisModel.axis.getExtent();
        var gapSignal = extent[0] > extent[1] ? -1 : 1;
        var pos = [
            nameLocation === "start" ? extent[0] - gapSignal * gap : nameLocation === "end" ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2,
            // Reuse labelOffset.
            $dfe15f745e1c3c2b$var$isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0
        ];
        var labelLayout;
        var nameRotation = axisModel.get("nameRotate");
        if (nameRotation != null) nameRotation = nameRotation * $dfe15f745e1c3c2b$var$PI / 180; // To radian.
        var axisNameAvailableWidth;
        if ($dfe15f745e1c3c2b$var$isNameLocationCenter(nameLocation)) labelLayout = $dfe15f745e1c3c2b$var$AxisBuilder.innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, // Adapt to axis.
        nameDirection);
        else {
            labelLayout = $dfe15f745e1c3c2b$var$endTextLayout(opt.rotation, nameLocation, nameRotation || 0, extent);
            axisNameAvailableWidth = opt.axisNameAvailableWidth;
            if (axisNameAvailableWidth != null) {
                axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
                !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
            }
        }
        var textFont = textStyleModel.getFont();
        var truncateOpt = axisModel.get("nameTruncate", true) || {};
        var ellipsis = truncateOpt.ellipsis;
        var maxWidth = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
        var textEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
            x: pos[0],
            y: pos[1],
            rotation: labelLayout.rotation,
            silent: $dfe15f745e1c3c2b$var$AxisBuilder.isLabelSilent(axisModel),
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                text: name,
                font: textFont,
                overflow: "truncate",
                width: maxWidth,
                ellipsis: ellipsis,
                fill: textStyleModel.getTextColor() || axisModel.get([
                    "axisLine",
                    "lineStyle",
                    "color"
                ]),
                align: textStyleModel.get("align") || labelLayout.textAlign,
                verticalAlign: textStyleModel.get("verticalAlign") || labelLayout.textVerticalAlign
            }),
            z2: 1
        });
        $5b455ae6f843ac47$export$fc6410d97fab306c({
            el: textEl,
            componentModel: axisModel,
            itemName: name
        });
        textEl.__fullText = name;
        // Id for animation
        textEl.anid = "name";
        if (axisModel.get("triggerEvent")) {
            var eventData = $dfe15f745e1c3c2b$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = "axisName";
            eventData.name = name;
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
        }
        // FIXME
        transformGroup.add(textEl);
        textEl.updateTransform();
        group.add(textEl);
        textEl.decomposeTransform();
    }
};
function $dfe15f745e1c3c2b$var$endTextLayout(rotation, textPosition, textRotate, extent) {
    var rotationDiff = (0, $cfc1f3b422a3185f$export$2ca6dd70a288b1c3)(textRotate - rotation);
    var textAlign;
    var textVerticalAlign;
    var inverse = extent[0] > extent[1];
    var onLeft = textPosition === "start" && !inverse || textPosition !== "start" && inverse;
    if ((0, $cfc1f3b422a3185f$export$d1df570aea2868f)(rotationDiff - $dfe15f745e1c3c2b$var$PI / 2)) {
        textVerticalAlign = onLeft ? "bottom" : "top";
        textAlign = "center";
    } else if ((0, $cfc1f3b422a3185f$export$d1df570aea2868f)(rotationDiff - $dfe15f745e1c3c2b$var$PI * 1.5)) {
        textVerticalAlign = onLeft ? "top" : "bottom";
        textAlign = "center";
    } else {
        textVerticalAlign = "middle";
        if (rotationDiff < $dfe15f745e1c3c2b$var$PI * 1.5 && rotationDiff > $dfe15f745e1c3c2b$var$PI / 2) textAlign = onLeft ? "left" : "right";
        else textAlign = onLeft ? "right" : "left";
    }
    return {
        rotation: rotationDiff,
        textAlign: textAlign,
        textVerticalAlign: textVerticalAlign
    };
}
function $dfe15f745e1c3c2b$var$fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
    if ((0, $2d646e51cc34f840$export$c2911c025243d6a6)(axisModel.axis)) return;
    // If min or max are user set, we need to check
    // If the tick on min(max) are overlap on their neighbour tick
    // If they are overlapped, we need to hide the min(max) tick label
    var showMinLabel = axisModel.get([
        "axisLabel",
        "showMinLabel"
    ]);
    var showMaxLabel = axisModel.get([
        "axisLabel",
        "showMaxLabel"
    ]);
    // FIXME
    // Have not consider onBand yet, where tick els is more than label els.
    labelEls = labelEls || [];
    tickEls = tickEls || [];
    var firstLabel = labelEls[0];
    var nextLabel = labelEls[1];
    var lastLabel = labelEls[labelEls.length - 1];
    var prevLabel = labelEls[labelEls.length - 2];
    var firstTick = tickEls[0];
    var nextTick = tickEls[1];
    var lastTick = tickEls[tickEls.length - 1];
    var prevTick = tickEls[tickEls.length - 2];
    if (showMinLabel === false) {
        $dfe15f745e1c3c2b$var$ignoreEl(firstLabel);
        $dfe15f745e1c3c2b$var$ignoreEl(firstTick);
    } else if ($dfe15f745e1c3c2b$var$isTwoLabelOverlapped(firstLabel, nextLabel)) {
        if (showMinLabel) {
            $dfe15f745e1c3c2b$var$ignoreEl(nextLabel);
            $dfe15f745e1c3c2b$var$ignoreEl(nextTick);
        } else {
            $dfe15f745e1c3c2b$var$ignoreEl(firstLabel);
            $dfe15f745e1c3c2b$var$ignoreEl(firstTick);
        }
    }
    if (showMaxLabel === false) {
        $dfe15f745e1c3c2b$var$ignoreEl(lastLabel);
        $dfe15f745e1c3c2b$var$ignoreEl(lastTick);
    } else if ($dfe15f745e1c3c2b$var$isTwoLabelOverlapped(prevLabel, lastLabel)) {
        if (showMaxLabel) {
            $dfe15f745e1c3c2b$var$ignoreEl(prevLabel);
            $dfe15f745e1c3c2b$var$ignoreEl(prevTick);
        } else {
            $dfe15f745e1c3c2b$var$ignoreEl(lastLabel);
            $dfe15f745e1c3c2b$var$ignoreEl(lastTick);
        }
    }
}
function $dfe15f745e1c3c2b$var$ignoreEl(el) {
    el && (el.ignore = true);
}
function $dfe15f745e1c3c2b$var$isTwoLabelOverlapped(current, next) {
    // current and next has the same rotation.
    var firstRect = current && current.getBoundingRect().clone();
    var nextRect = next && next.getBoundingRect().clone();
    if (!firstRect || !nextRect) return;
    // When checking intersect of two rotated labels, we use mRotationBack
    // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.
    var mRotationBack = $f41ebb9dd60b55b4$export$f0954fd7d5368655([]);
    $f41ebb9dd60b55b4$export$bb628a54ab399bc9(mRotationBack, mRotationBack, -current.rotation);
    firstRect.applyTransform($f41ebb9dd60b55b4$export$6e3a27864ab166fe([], mRotationBack, current.getLocalTransform()));
    nextRect.applyTransform($f41ebb9dd60b55b4$export$6e3a27864ab166fe([], mRotationBack, next.getLocalTransform()));
    return firstRect.intersect(nextRect);
}
function $dfe15f745e1c3c2b$var$isNameLocationCenter(nameLocation) {
    return nameLocation === "middle" || nameLocation === "center";
}
function $dfe15f745e1c3c2b$var$createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
    var tickEls = [];
    var pt1 = [];
    var pt2 = [];
    for(var i = 0; i < ticksCoords.length; i++){
        var tickCoord = ticksCoords[i].coord;
        pt1[0] = tickCoord;
        pt1[1] = 0;
        pt2[0] = tickCoord;
        pt2[1] = tickEndCoord;
        if (tickTransform) {
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(pt1, pt1, tickTransform);
            (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(pt2, pt2, tickTransform);
        }
        // Tick line, Not use group transform to have better line draw
        var tickEl = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: tickLineStyle,
            z2: 2,
            autoBatch: true,
            silent: true
        });
        $5b455ae6f843ac47$export$8b4b620d7f4aad1b(tickEl.shape, tickEl.style.lineWidth);
        tickEl.anid = anidPrefix + "_" + ticksCoords[i].tickValue;
        tickEls.push(tickEl);
    }
    return tickEls;
}
function $dfe15f745e1c3c2b$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt) {
    var axis = axisModel.axis;
    var tickModel = axisModel.getModel("axisTick");
    var shown = tickModel.get("show");
    if (shown === "auto" && opt.handleAutoShown) shown = opt.handleAutoShown("axisTick");
    if (!shown || axis.scale.isBlank()) return;
    var lineStyleModel = tickModel.getModel("lineStyle");
    var tickEndCoord = opt.tickDirection * tickModel.get("length");
    var ticksCoords = axis.getTicksCoords();
    var ticksEls = $dfe15f745e1c3c2b$var$createTicks(ticksCoords, transformGroup.transform, tickEndCoord, (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(lineStyleModel.getLineStyle(), {
        stroke: axisModel.get([
            "axisLine",
            "lineStyle",
            "color"
        ])
    }), "ticks");
    for(var i = 0; i < ticksEls.length; i++)group.add(ticksEls[i]);
    return ticksEls;
}
function $dfe15f745e1c3c2b$var$buildAxisMinorTicks(group, transformGroup, axisModel, tickDirection) {
    var axis = axisModel.axis;
    var minorTickModel = axisModel.getModel("minorTick");
    if (!minorTickModel.get("show") || axis.scale.isBlank()) return;
    var minorTicksCoords = axis.getMinorTicksCoords();
    if (!minorTicksCoords.length) return;
    var lineStyleModel = minorTickModel.getModel("lineStyle");
    var tickEndCoord = tickDirection * minorTickModel.get("length");
    var minorTickLineStyle = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(lineStyleModel.getLineStyle(), (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(axisModel.getModel("axisTick").getLineStyle(), {
        stroke: axisModel.get([
            "axisLine",
            "lineStyle",
            "color"
        ])
    }));
    for(var i = 0; i < minorTicksCoords.length; i++){
        var minorTicksEls = $dfe15f745e1c3c2b$var$createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, "minorticks_" + i);
        for(var k = 0; k < minorTicksEls.length; k++)group.add(minorTicksEls[k]);
    }
}
function $dfe15f745e1c3c2b$var$buildAxisLabel(group, transformGroup, axisModel, opt) {
    var axis = axisModel.axis;
    var show = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(opt.axisLabelShow, axisModel.get([
        "axisLabel",
        "show"
    ]));
    if (!show || axis.scale.isBlank()) return;
    var labelModel = axisModel.getModel("axisLabel");
    var labelMargin = labelModel.get("margin");
    var labels = axis.getViewLabels();
    // Special label rotate.
    var labelRotation = ((0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(opt.labelRotate, labelModel.get("rotate")) || 0) * $dfe15f745e1c3c2b$var$PI / 180;
    var labelLayout = $dfe15f745e1c3c2b$var$AxisBuilder.innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
    var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
    var labelEls = [];
    var silent = $dfe15f745e1c3c2b$var$AxisBuilder.isLabelSilent(axisModel);
    var triggerEvent = axisModel.get("triggerEvent");
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(labels, function(labelItem, index) {
        var tickValue = axis.scale.type === "ordinal" ? axis.scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
        var formattedLabel = labelItem.formattedLabel;
        var rawLabel = labelItem.rawLabel;
        var itemLabelModel = labelModel;
        if (rawCategoryData && rawCategoryData[tickValue]) {
            var rawCategoryItem = rawCategoryData[tickValue];
            if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(rawCategoryItem) && rawCategoryItem.textStyle) itemLabelModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
        }
        var textColor = itemLabelModel.getTextColor() || axisModel.get([
            "axisLine",
            "lineStyle",
            "color"
        ]);
        var tickCoord = axis.dataToCoord(tickValue);
        var align = itemLabelModel.getShallow("align", true) || labelLayout.textAlign;
        var alignMin = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemLabelModel.getShallow("alignMinLabel", true), align);
        var alignMax = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemLabelModel.getShallow("alignMaxLabel", true), align);
        var verticalAlign = itemLabelModel.getShallow("verticalAlign", true) || itemLabelModel.getShallow("baseline", true) || labelLayout.textVerticalAlign;
        var verticalAlignMin = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemLabelModel.getShallow("verticalAlignMinLabel", true), verticalAlign);
        var verticalAlignMax = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemLabelModel.getShallow("verticalAlignMaxLabel", true), verticalAlign);
        var textEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
            x: tickCoord,
            y: opt.labelOffset + opt.labelDirection * labelMargin,
            rotation: labelLayout.rotation,
            silent: silent,
            z2: 10 + (labelItem.level || 0),
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(itemLabelModel, {
                text: formattedLabel,
                align: index === 0 ? alignMin : index === labels.length - 1 ? alignMax : align,
                verticalAlign: index === 0 ? verticalAlignMin : index === labels.length - 1 ? verticalAlignMax : verticalAlign,
                fill: (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(textColor) ? textColor(// (1) In category axis with data zoom, tick is not the original
                // index of axis.data. So tick should not be exposed to user
                // in category axis.
                // (2) Compatible with previous version, which always use formatted label as
                // input. But in interval scale the formatted label is like '223,445', which
                // maked user replace ','. So we modify it to return original val but remain
                // it as 'string' to avoid error in replacing.
                axis.type === "category" ? rawLabel : axis.type === "value" ? tickValue + "" : tickValue, index) : textColor
            })
        });
        textEl.anid = "label_" + tickValue;
        // Pack data for mouse event
        if (triggerEvent) {
            var eventData = $dfe15f745e1c3c2b$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = "axisLabel";
            eventData.value = rawLabel;
            eventData.tickIndex = index;
            if (axis.type === "category") eventData.dataIndex = tickValue;
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
        }
        // FIXME
        transformGroup.add(textEl);
        textEl.updateTransform();
        labelEls.push(textEl);
        group.add(textEl);
        textEl.decomposeTransform();
    });
    return labelEls;
}
var $dfe15f745e1c3c2b$export$2e2bcd8739ae039 = $dfe15f745e1c3c2b$var$AxisBuilder;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL = true;
var $91342d1cfa622c5a$var$mathMin = Math.min;
var $91342d1cfa622c5a$var$mathMax = Math.max;
var $91342d1cfa622c5a$var$mathPow = Math.pow;
var $91342d1cfa622c5a$var$COVER_Z = 10000;
var $91342d1cfa622c5a$var$UNSELECT_THRESHOLD = 6;
var $91342d1cfa622c5a$var$MIN_RESIZE_LINE_WIDTH = 6;
var $91342d1cfa622c5a$var$MUTEX_RESOURCE_KEY = "globalPan";
var $91342d1cfa622c5a$var$DIRECTION_MAP = {
    w: [
        0,
        0
    ],
    e: [
        0,
        1
    ],
    n: [
        1,
        0
    ],
    s: [
        1,
        1
    ]
};
var $91342d1cfa622c5a$var$CURSOR_MAP = {
    w: "ew",
    e: "ew",
    n: "ns",
    s: "ns",
    ne: "nesw",
    sw: "nesw",
    nw: "nwse",
    se: "nwse"
};
var $91342d1cfa622c5a$var$DEFAULT_BRUSH_OPT = {
    brushStyle: {
        lineWidth: 2,
        stroke: "rgba(210,219,238,0.3)",
        fill: "#D2DBEE"
    },
    transformable: true,
    brushMode: "single",
    removeOnClick: false
};
var $91342d1cfa622c5a$var$baseUID = 0;
/**
 * params:
 *     areas: Array.<Array>, coord relates to container group,
 *                             If no container specified, to global.
 *     opt {
 *         isEnd: boolean,
 *         removeOnClick: boolean
 *     }
 */ var $91342d1cfa622c5a$var$BrushController = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BrushController, _super);
    function BrushController(zr) {
        var _this = _super.call(this) || this;
        /**
     * @internal
     */ _this._track = [];
        /**
     * @internal
     */ _this._covers = [];
        _this._handlers = {};
        _this._zr = zr;
        _this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        _this._uid = "brushController_" + $91342d1cfa622c5a$var$baseUID++;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($91342d1cfa622c5a$var$pointerHandlers, function(handler, eventName) {
            this._handlers[eventName] = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(handler, this);
        }, _this);
        return _this;
    }
    /**
   * If set to `false`, select disabled.
   */ BrushController.prototype.enableBrush = function(brushOption) {
        this._brushType && this._doDisableBrush();
        brushOption.brushType && this._doEnableBrush(brushOption);
        return this;
    };
    BrushController.prototype._doEnableBrush = function(brushOption) {
        var zr = this._zr;
        // Consider roam, which takes globalPan too.
        if (!this._enableGlobalPan) $befd6a34b30d3f54$export$b7df5d561049483a(zr, $91342d1cfa622c5a$var$MUTEX_RESOURCE_KEY, this._uid);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._handlers, function(handler, eventName) {
            zr.on(eventName, handler);
        });
        this._brushType = brushOption.brushType;
        this._brushOption = (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)($91342d1cfa622c5a$var$DEFAULT_BRUSH_OPT), brushOption, true);
    };
    BrushController.prototype._doDisableBrush = function() {
        var zr = this._zr;
        $befd6a34b30d3f54$export$23d3fad09dc44362(zr, $91342d1cfa622c5a$var$MUTEX_RESOURCE_KEY, this._uid);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._handlers, function(handler, eventName) {
            zr.off(eventName, handler);
        });
        this._brushType = this._brushOption = null;
    };
    /**
   * @param panelOpts If not pass, it is global brush.
   */ BrushController.prototype.setPanels = function(panelOpts) {
        if (panelOpts && panelOpts.length) {
            var panels_1 = this._panels = {};
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(panelOpts, function(panelOpts) {
                panels_1[panelOpts.panelId] = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(panelOpts);
            });
        } else this._panels = null;
        return this;
    };
    BrushController.prototype.mount = function(opt) {
        opt = opt || {};
        this._enableGlobalPan = opt.enableGlobalPan;
        var thisGroup = this.group;
        this._zr.add(thisGroup);
        thisGroup.attr({
            x: opt.x || 0,
            y: opt.y || 0,
            rotation: opt.rotation || 0,
            scaleX: opt.scaleX || 1,
            scaleY: opt.scaleY || 1
        });
        this._transform = thisGroup.getLocalTransform();
        return this;
    };
    // eachCover(cb, context): void {
    //     each(this._covers, cb, context);
    // }
    /**
   * Update covers.
   * @param coverConfigList
   *        If coverConfigList is null/undefined, all covers removed.
   */ BrushController.prototype.updateCovers = function(coverConfigList) {
        coverConfigList = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coverConfigList, function(coverConfig) {
            return (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)((0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)($91342d1cfa622c5a$var$DEFAULT_BRUSH_OPT), coverConfig, true);
        });
        var tmpIdPrefix = "\0-brush-index-";
        var oldCovers = this._covers;
        var newCovers = this._covers = [];
        var controller = this;
        var creatingCover = this._creatingCover;
        new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldCovers, coverConfigList, oldGetKey, getKey).add(addOrUpdate).update(addOrUpdate).remove(remove).execute();
        return this;
        function getKey(brushOption, index) {
            return (brushOption.id != null ? brushOption.id : tmpIdPrefix + index) + "-" + brushOption.brushType;
        }
        function oldGetKey(cover, index) {
            return getKey(cover.__brushOption, index);
        }
        function addOrUpdate(newIndex, oldIndex) {
            var newBrushInternal = coverConfigList[newIndex];
            // Consider setOption in event listener of brushSelect,
            // where updating cover when creating should be forbidden.
            if (oldIndex != null && oldCovers[oldIndex] === creatingCover) newCovers[newIndex] = oldCovers[oldIndex];
            else {
                var cover = newCovers[newIndex] = oldIndex != null ? (oldCovers[oldIndex].__brushOption = newBrushInternal, oldCovers[oldIndex]) : $91342d1cfa622c5a$var$endCreating(controller, $91342d1cfa622c5a$var$createCover(controller, newBrushInternal));
                $91342d1cfa622c5a$var$updateCoverAfterCreation(controller, cover);
            }
        }
        function remove(oldIndex) {
            if (oldCovers[oldIndex] !== creatingCover) controller.group.remove(oldCovers[oldIndex]);
        }
    };
    BrushController.prototype.unmount = function() {
        this.enableBrush(false);
        // container may 'removeAll' outside.
        $91342d1cfa622c5a$var$clearCovers(this);
        this._zr.remove(this.group);
        return this;
    };
    BrushController.prototype.dispose = function() {
        this.unmount();
        this.off();
    };
    return BrushController;
}((0, $63441a86293f101f$export$2e2bcd8739ae039));
function $91342d1cfa622c5a$var$createCover(controller, brushOption) {
    var cover = $91342d1cfa622c5a$var$coverRenderers[brushOption.brushType].createCover(controller, brushOption);
    cover.__brushOption = brushOption;
    $91342d1cfa622c5a$var$updateZ(cover, brushOption);
    controller.group.add(cover);
    return cover;
}
function $91342d1cfa622c5a$var$endCreating(controller, creatingCover) {
    var coverRenderer = $91342d1cfa622c5a$var$getCoverRenderer(creatingCover);
    if (coverRenderer.endCreating) {
        coverRenderer.endCreating(controller, creatingCover);
        $91342d1cfa622c5a$var$updateZ(creatingCover, creatingCover.__brushOption);
    }
    return creatingCover;
}
function $91342d1cfa622c5a$var$updateCoverShape(controller, cover) {
    var brushOption = cover.__brushOption;
    $91342d1cfa622c5a$var$getCoverRenderer(cover).updateCoverShape(controller, cover, brushOption.range, brushOption);
}
function $91342d1cfa622c5a$var$updateZ(cover, brushOption) {
    var z = brushOption.z;
    z == null && (z = $91342d1cfa622c5a$var$COVER_Z);
    cover.traverse(function(el) {
        el.z = z;
        el.z2 = z; // Consider in given container.
    });
}
function $91342d1cfa622c5a$var$updateCoverAfterCreation(controller, cover) {
    $91342d1cfa622c5a$var$getCoverRenderer(cover).updateCommon(controller, cover);
    $91342d1cfa622c5a$var$updateCoverShape(controller, cover);
}
function $91342d1cfa622c5a$var$getCoverRenderer(cover) {
    return $91342d1cfa622c5a$var$coverRenderers[cover.__brushOption.brushType];
}
// return target panel or `true` (means global panel)
function $91342d1cfa622c5a$var$getPanelByPoint(controller, e, localCursorPoint) {
    var panels = controller._panels;
    if (!panels) return $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL; // Global panel
    var panel;
    var transform = controller._transform;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(panels, function(pn) {
        pn.isTargetByCursor(e, localCursorPoint, transform) && (panel = pn);
    });
    return panel;
}
// Return a panel or true
function $91342d1cfa622c5a$var$getPanelByCover(controller, cover) {
    var panels = controller._panels;
    if (!panels) return $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL; // Global panel
    var panelId = cover.__brushOption.panelId;
    // User may give cover without coord sys info,
    // which is then treated as global panel.
    return panelId != null ? panels[panelId] : $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL;
}
function $91342d1cfa622c5a$var$clearCovers(controller) {
    var covers = controller._covers;
    var originalLength = covers.length;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(covers, function(cover) {
        controller.group.remove(cover);
    }, controller);
    covers.length = 0;
    return !!originalLength;
}
function $91342d1cfa622c5a$var$trigger(controller, opt) {
    var areas = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(controller._covers, function(cover) {
        var brushOption = cover.__brushOption;
        var range = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(brushOption.range);
        return {
            brushType: brushOption.brushType,
            panelId: brushOption.panelId,
            range: range
        };
    });
    controller.trigger("brush", {
        areas: areas,
        isEnd: !!opt.isEnd,
        removeOnClick: !!opt.removeOnClick
    });
}
function $91342d1cfa622c5a$var$shouldShowCover(controller) {
    var track = controller._track;
    if (!track.length) return false;
    var p2 = track[track.length - 1];
    var p1 = track[0];
    var dx = p2[0] - p1[0];
    var dy = p2[1] - p1[1];
    var dist = $91342d1cfa622c5a$var$mathPow(dx * dx + dy * dy, 0.5);
    return dist > $91342d1cfa622c5a$var$UNSELECT_THRESHOLD;
}
function $91342d1cfa622c5a$var$getTrackEnds(track) {
    var tail = track.length - 1;
    tail < 0 && (tail = 0);
    return [
        track[0],
        track[tail]
    ];
}
function $91342d1cfa622c5a$var$createBaseRectCover(rectRangeConverter, controller, brushOption, edgeNameSequences) {
    var cover = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    cover.add(new $419e5ff2f303755e$export$2e2bcd8739ae039({
        name: "main",
        style: $91342d1cfa622c5a$var$makeStyle(brushOption),
        silent: true,
        draggable: true,
        cursor: "move",
        drift: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$driftRect, rectRangeConverter, controller, cover, [
            "n",
            "s",
            "w",
            "e"
        ]),
        ondragend: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$trigger, controller, {
            isEnd: true
        })
    }));
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(edgeNameSequences, function(nameSequence) {
        cover.add(new $419e5ff2f303755e$export$2e2bcd8739ae039({
            name: nameSequence.join(""),
            style: {
                opacity: 0
            },
            draggable: true,
            silent: true,
            invisible: true,
            drift: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$driftRect, rectRangeConverter, controller, cover, nameSequence),
            ondragend: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$trigger, controller, {
                isEnd: true
            })
        }));
    });
    return cover;
}
function $91342d1cfa622c5a$var$updateBaseRect(controller, cover, localRange, brushOption) {
    var lineWidth = brushOption.brushStyle.lineWidth || 0;
    var handleSize = $91342d1cfa622c5a$var$mathMax(lineWidth, $91342d1cfa622c5a$var$MIN_RESIZE_LINE_WIDTH);
    var x = localRange[0][0];
    var y = localRange[1][0];
    var xa = x - lineWidth / 2;
    var ya = y - lineWidth / 2;
    var x2 = localRange[0][1];
    var y2 = localRange[1][1];
    var x2a = x2 - handleSize + lineWidth / 2;
    var y2a = y2 - handleSize + lineWidth / 2;
    var width = x2 - x;
    var height = y2 - y;
    var widtha = width + lineWidth;
    var heighta = height + lineWidth;
    $91342d1cfa622c5a$var$updateRectShape(controller, cover, "main", x, y, width, height);
    if (brushOption.transformable) {
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "w", xa, ya, handleSize, heighta);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "e", x2a, ya, handleSize, heighta);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "n", xa, ya, widtha, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "s", xa, y2a, widtha, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "nw", xa, ya, handleSize, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "ne", x2a, ya, handleSize, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "sw", xa, y2a, handleSize, handleSize);
        $91342d1cfa622c5a$var$updateRectShape(controller, cover, "se", x2a, y2a, handleSize, handleSize);
    }
}
function $91342d1cfa622c5a$var$updateCommon(controller, cover) {
    var brushOption = cover.__brushOption;
    var transformable = brushOption.transformable;
    var mainEl = cover.childAt(0);
    mainEl.useStyle($91342d1cfa622c5a$var$makeStyle(brushOption));
    mainEl.attr({
        silent: !transformable,
        cursor: transformable ? "move" : "default"
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        [
            "w"
        ],
        [
            "e"
        ],
        [
            "n"
        ],
        [
            "s"
        ],
        [
            "s",
            "e"
        ],
        [
            "s",
            "w"
        ],
        [
            "n",
            "e"
        ],
        [
            "n",
            "w"
        ]
    ], function(nameSequence) {
        var el = cover.childOfName(nameSequence.join(""));
        var globalDir = nameSequence.length === 1 ? $91342d1cfa622c5a$var$getGlobalDirection1(controller, nameSequence[0]) : $91342d1cfa622c5a$var$getGlobalDirection2(controller, nameSequence);
        el && el.attr({
            silent: !transformable,
            invisible: !transformable,
            cursor: transformable ? $91342d1cfa622c5a$var$CURSOR_MAP[globalDir] + "-resize" : null
        });
    });
}
function $91342d1cfa622c5a$var$updateRectShape(controller, cover, name, x, y, w, h) {
    var el = cover.childOfName(name);
    el && el.setShape($91342d1cfa622c5a$var$pointsToRect($91342d1cfa622c5a$var$clipByPanel(controller, cover, [
        [
            x,
            y
        ],
        [
            x + w,
            y + h
        ]
    ])));
}
function $91342d1cfa622c5a$var$makeStyle(brushOption) {
    return (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        strokeNoScale: true
    }, brushOption.brushStyle);
}
function $91342d1cfa622c5a$var$formatRectRange(x, y, x2, y2) {
    var min = [
        $91342d1cfa622c5a$var$mathMin(x, x2),
        $91342d1cfa622c5a$var$mathMin(y, y2)
    ];
    var max = [
        $91342d1cfa622c5a$var$mathMax(x, x2),
        $91342d1cfa622c5a$var$mathMax(y, y2)
    ];
    return [
        [
            min[0],
            max[0]
        ],
        [
            min[1],
            max[1]
        ] // y range
    ];
}
function $91342d1cfa622c5a$var$getTransform(controller) {
    return $5b455ae6f843ac47$export$fce0c6cfca85ed96(controller.group);
}
function $91342d1cfa622c5a$var$getGlobalDirection1(controller, localDirName) {
    var map = {
        w: "left",
        e: "right",
        n: "top",
        s: "bottom"
    };
    var inverseMap = {
        left: "w",
        right: "e",
        top: "n",
        bottom: "s"
    };
    var dir = $5b455ae6f843ac47$export$fff94e9792354cfa(map[localDirName], $91342d1cfa622c5a$var$getTransform(controller));
    return inverseMap[dir];
}
function $91342d1cfa622c5a$var$getGlobalDirection2(controller, localDirNameSeq) {
    var globalDir = [
        $91342d1cfa622c5a$var$getGlobalDirection1(controller, localDirNameSeq[0]),
        $91342d1cfa622c5a$var$getGlobalDirection1(controller, localDirNameSeq[1])
    ];
    (globalDir[0] === "e" || globalDir[0] === "w") && globalDir.reverse();
    return globalDir.join("");
}
function $91342d1cfa622c5a$var$driftRect(rectRangeConverter, controller, cover, dirNameSequence, dx, dy) {
    var brushOption = cover.__brushOption;
    var rectRange = rectRangeConverter.toRectRange(brushOption.range);
    var localDelta = $91342d1cfa622c5a$var$toLocalDelta(controller, dx, dy);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dirNameSequence, function(dirName) {
        var ind = $91342d1cfa622c5a$var$DIRECTION_MAP[dirName];
        rectRange[ind[0]][ind[1]] += localDelta[ind[0]];
    });
    brushOption.range = rectRangeConverter.fromRectRange($91342d1cfa622c5a$var$formatRectRange(rectRange[0][0], rectRange[1][0], rectRange[0][1], rectRange[1][1]));
    $91342d1cfa622c5a$var$updateCoverAfterCreation(controller, cover);
    $91342d1cfa622c5a$var$trigger(controller, {
        isEnd: false
    });
}
function $91342d1cfa622c5a$var$driftPolygon(controller, cover, dx, dy) {
    var range = cover.__brushOption.range;
    var localDelta = $91342d1cfa622c5a$var$toLocalDelta(controller, dx, dy);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(range, function(point) {
        point[0] += localDelta[0];
        point[1] += localDelta[1];
    });
    $91342d1cfa622c5a$var$updateCoverAfterCreation(controller, cover);
    $91342d1cfa622c5a$var$trigger(controller, {
        isEnd: false
    });
}
function $91342d1cfa622c5a$var$toLocalDelta(controller, dx, dy) {
    var thisGroup = controller.group;
    var localD = thisGroup.transformCoordToLocal(dx, dy);
    var localZero = thisGroup.transformCoordToLocal(0, 0);
    return [
        localD[0] - localZero[0],
        localD[1] - localZero[1]
    ];
}
function $91342d1cfa622c5a$var$clipByPanel(controller, cover, data) {
    var panel = $91342d1cfa622c5a$var$getPanelByCover(controller, cover);
    return panel && panel !== $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL ? panel.clipPath(data, controller._transform) : (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(data);
}
function $91342d1cfa622c5a$var$pointsToRect(points) {
    var xmin = $91342d1cfa622c5a$var$mathMin(points[0][0], points[1][0]);
    var ymin = $91342d1cfa622c5a$var$mathMin(points[0][1], points[1][1]);
    var xmax = $91342d1cfa622c5a$var$mathMax(points[0][0], points[1][0]);
    var ymax = $91342d1cfa622c5a$var$mathMax(points[0][1], points[1][1]);
    return {
        x: xmin,
        y: ymin,
        width: xmax - xmin,
        height: ymax - ymin
    };
}
function $91342d1cfa622c5a$var$resetCursor(controller, e, localCursorPoint) {
    if (// Check active
    !controller._brushType || $91342d1cfa622c5a$var$isOutsideZrArea(controller, e.offsetX, e.offsetY)) return;
    var zr = controller._zr;
    var covers = controller._covers;
    var currPanel = $91342d1cfa622c5a$var$getPanelByPoint(controller, e, localCursorPoint);
    // Check whether in covers.
    if (!controller._dragging) for(var i = 0; i < covers.length; i++){
        var brushOption = covers[i].__brushOption;
        if (currPanel && (currPanel === $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL || brushOption.panelId === currPanel.panelId) && $91342d1cfa622c5a$var$coverRenderers[brushOption.brushType].contain(covers[i], localCursorPoint[0], localCursorPoint[1])) // Use cursor style set on cover.
        return;
    }
    currPanel && zr.setCursorStyle("crosshair");
}
function $91342d1cfa622c5a$var$preventDefault(e) {
    var rawE = e.event;
    rawE.preventDefault && rawE.preventDefault();
}
function $91342d1cfa622c5a$var$mainShapeContain(cover, x, y) {
    return cover.childOfName("main").contain(x, y);
}
function $91342d1cfa622c5a$var$updateCoverByMouse(controller, e, localCursorPoint, isEnd) {
    var creatingCover = controller._creatingCover;
    var panel = controller._creatingPanel;
    var thisBrushOption = controller._brushOption;
    var eventParams;
    controller._track.push(localCursorPoint.slice());
    if ($91342d1cfa622c5a$var$shouldShowCover(controller) || creatingCover) {
        if (panel && !creatingCover) {
            thisBrushOption.brushMode === "single" && $91342d1cfa622c5a$var$clearCovers(controller);
            var brushOption = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(thisBrushOption);
            brushOption.brushType = $91342d1cfa622c5a$var$determineBrushType(brushOption.brushType, panel);
            brushOption.panelId = panel === $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL ? null : panel.panelId;
            creatingCover = controller._creatingCover = $91342d1cfa622c5a$var$createCover(controller, brushOption);
            controller._covers.push(creatingCover);
        }
        if (creatingCover) {
            var coverRenderer = $91342d1cfa622c5a$var$coverRenderers[$91342d1cfa622c5a$var$determineBrushType(controller._brushType, panel)];
            var coverBrushOption = creatingCover.__brushOption;
            coverBrushOption.range = coverRenderer.getCreatingRange($91342d1cfa622c5a$var$clipByPanel(controller, creatingCover, controller._track));
            if (isEnd) {
                $91342d1cfa622c5a$var$endCreating(controller, creatingCover);
                coverRenderer.updateCommon(controller, creatingCover);
            }
            $91342d1cfa622c5a$var$updateCoverShape(controller, creatingCover);
            eventParams = {
                isEnd: isEnd
            };
        }
    } else if (isEnd && thisBrushOption.brushMode === "single" && thisBrushOption.removeOnClick) // Help user to remove covers easily, only by a tiny drag, in 'single' mode.
    // But a single click do not clear covers, because user may have casual
    // clicks (for example, click on other component and do not expect covers
    // disappear).
    // Only some cover removed, trigger action, but not every click trigger action.
    {
        if ($91342d1cfa622c5a$var$getPanelByPoint(controller, e, localCursorPoint) && $91342d1cfa622c5a$var$clearCovers(controller)) eventParams = {
            isEnd: isEnd,
            removeOnClick: true
        };
    }
    return eventParams;
}
function $91342d1cfa622c5a$var$determineBrushType(brushType, panel) {
    if (brushType === "auto") return panel.defaultBrushType;
    return brushType;
}
var $91342d1cfa622c5a$var$pointerHandlers = {
    mousedown: function(e) {
        if (this._dragging) // In case some browser do not support globalOut,
        // and release mouse out side the browser.
        $91342d1cfa622c5a$var$handleDragEnd(this, e);
        else if (!e.target || !e.target.draggable) {
            $91342d1cfa622c5a$var$preventDefault(e);
            var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
            this._creatingCover = null;
            var panel = this._creatingPanel = $91342d1cfa622c5a$var$getPanelByPoint(this, e, localCursorPoint);
            if (panel) {
                this._dragging = true;
                this._track = [
                    localCursorPoint.slice()
                ];
            }
        }
    },
    mousemove: function(e) {
        var x = e.offsetX;
        var y = e.offsetY;
        var localCursorPoint = this.group.transformCoordToLocal(x, y);
        $91342d1cfa622c5a$var$resetCursor(this, e, localCursorPoint);
        if (this._dragging) {
            $91342d1cfa622c5a$var$preventDefault(e);
            var eventParams = $91342d1cfa622c5a$var$updateCoverByMouse(this, e, localCursorPoint, false);
            eventParams && $91342d1cfa622c5a$var$trigger(this, eventParams);
        }
    },
    mouseup: function(e) {
        $91342d1cfa622c5a$var$handleDragEnd(this, e);
    }
};
function $91342d1cfa622c5a$var$handleDragEnd(controller, e) {
    if (controller._dragging) {
        $91342d1cfa622c5a$var$preventDefault(e);
        var x = e.offsetX;
        var y = e.offsetY;
        var localCursorPoint = controller.group.transformCoordToLocal(x, y);
        var eventParams = $91342d1cfa622c5a$var$updateCoverByMouse(controller, e, localCursorPoint, true);
        controller._dragging = false;
        controller._track = [];
        controller._creatingCover = null;
        // trigger event should be at final, after procedure will be nested.
        eventParams && $91342d1cfa622c5a$var$trigger(controller, eventParams);
    }
}
function $91342d1cfa622c5a$var$isOutsideZrArea(controller, x, y) {
    var zr = controller._zr;
    return x < 0 || x > zr.getWidth() || y < 0 || y > zr.getHeight();
}
/**
 * key: brushType
 */ var $91342d1cfa622c5a$var$coverRenderers = {
    lineX: $91342d1cfa622c5a$var$getLineRenderer(0),
    lineY: $91342d1cfa622c5a$var$getLineRenderer(1),
    rect: {
        createCover: function(controller, brushOption) {
            function returnInput(range) {
                return range;
            }
            return $91342d1cfa622c5a$var$createBaseRectCover({
                toRectRange: returnInput,
                fromRectRange: returnInput
            }, controller, brushOption, [
                [
                    "w"
                ],
                [
                    "e"
                ],
                [
                    "n"
                ],
                [
                    "s"
                ],
                [
                    "s",
                    "e"
                ],
                [
                    "s",
                    "w"
                ],
                [
                    "n",
                    "e"
                ],
                [
                    "n",
                    "w"
                ]
            ]);
        },
        getCreatingRange: function(localTrack) {
            var ends = $91342d1cfa622c5a$var$getTrackEnds(localTrack);
            return $91342d1cfa622c5a$var$formatRectRange(ends[1][0], ends[1][1], ends[0][0], ends[0][1]);
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            $91342d1cfa622c5a$var$updateBaseRect(controller, cover, localRange, brushOption);
        },
        updateCommon: $91342d1cfa622c5a$var$updateCommon,
        contain: $91342d1cfa622c5a$var$mainShapeContain
    },
    polygon: {
        createCover: function(controller, brushOption) {
            var cover = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
            // Do not use graphic.Polygon because graphic.Polyline do not close the
            // border of the shape when drawing, which is a better experience for user.
            cover.add(new $d28119f30e6bb670$export$2e2bcd8739ae039({
                name: "main",
                style: $91342d1cfa622c5a$var$makeStyle(brushOption),
                silent: true
            }));
            return cover;
        },
        getCreatingRange: function(localTrack) {
            return localTrack;
        },
        endCreating: function(controller, cover) {
            cover.remove(cover.childAt(0));
            // Use graphic.Polygon close the shape.
            cover.add(new $51acf033123e1a30$export$2e2bcd8739ae039({
                name: "main",
                draggable: true,
                drift: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$driftPolygon, controller, cover),
                ondragend: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($91342d1cfa622c5a$var$trigger, controller, {
                    isEnd: true
                })
            }));
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            cover.childAt(0).setShape({
                points: $91342d1cfa622c5a$var$clipByPanel(controller, cover, localRange)
            });
        },
        updateCommon: $91342d1cfa622c5a$var$updateCommon,
        contain: $91342d1cfa622c5a$var$mainShapeContain
    }
};
function $91342d1cfa622c5a$var$getLineRenderer(xyIndex) {
    return {
        createCover: function(controller, brushOption) {
            return $91342d1cfa622c5a$var$createBaseRectCover({
                toRectRange: function(range) {
                    var rectRange = [
                        range,
                        [
                            0,
                            100
                        ]
                    ];
                    xyIndex && rectRange.reverse();
                    return rectRange;
                },
                fromRectRange: function(rectRange) {
                    return rectRange[xyIndex];
                }
            }, controller, brushOption, [
                [
                    [
                        "w"
                    ],
                    [
                        "e"
                    ]
                ],
                [
                    [
                        "n"
                    ],
                    [
                        "s"
                    ]
                ]
            ][xyIndex]);
        },
        getCreatingRange: function(localTrack) {
            var ends = $91342d1cfa622c5a$var$getTrackEnds(localTrack);
            var min = $91342d1cfa622c5a$var$mathMin(ends[0][xyIndex], ends[1][xyIndex]);
            var max = $91342d1cfa622c5a$var$mathMax(ends[0][xyIndex], ends[1][xyIndex]);
            return [
                min,
                max
            ];
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            var otherExtent;
            // If brushWidth not specified, fit the panel.
            var panel = $91342d1cfa622c5a$var$getPanelByCover(controller, cover);
            if (panel !== $91342d1cfa622c5a$var$BRUSH_PANEL_GLOBAL && panel.getLinearBrushOtherExtent) otherExtent = panel.getLinearBrushOtherExtent(xyIndex);
            else {
                var zr = controller._zr;
                otherExtent = [
                    0,
                    [
                        zr.getWidth(),
                        zr.getHeight()
                    ][1 - xyIndex]
                ];
            }
            var rectRange = [
                localRange,
                otherExtent
            ];
            xyIndex && rectRange.reverse();
            $91342d1cfa622c5a$var$updateBaseRect(controller, cover, rectRange, brushOption);
        },
        updateCommon: $91342d1cfa622c5a$var$updateCommon,
        contain: $91342d1cfa622c5a$var$mainShapeContain
    };
}
var $91342d1cfa622c5a$export$2e2bcd8739ae039 = $91342d1cfa622c5a$var$BrushController;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $d9c171f7dfe1f12f$export$fee17964a62a87a7(rect) {
    rect = $d9c171f7dfe1f12f$var$normalizeRect(rect);
    return function(localPoints) {
        return $5b455ae6f843ac47$export$e2f409471bbbc1dc(localPoints, rect);
    };
}
function $d9c171f7dfe1f12f$export$7280070e90fad7a0(rect, specifiedXYIndex) {
    rect = $d9c171f7dfe1f12f$var$normalizeRect(rect);
    return function(xyIndex) {
        var idx = specifiedXYIndex != null ? specifiedXYIndex : xyIndex;
        var brushWidth = idx ? rect.width : rect.height;
        var base = idx ? rect.x : rect.y;
        return [
            base,
            base + (brushWidth || 0)
        ];
    };
}
function $d9c171f7dfe1f12f$export$e63e66b3b18aa99f(rect, api, targetModel) {
    var boundingRect = $d9c171f7dfe1f12f$var$normalizeRect(rect);
    return function(e, localCursorPoint) {
        return boundingRect.contain(localCursorPoint[0], localCursorPoint[1]) && !(0, $bee256db41541054$export$8a33eacb690eac07)(e, api, targetModel);
    };
}
// Consider width/height is negative.
function $d9c171f7dfe1f12f$var$normalizeRect(rect) {
    return (0, $1bebe7106c895823$export$2e2bcd8739ae039).create(rect);
}




var $90a4a8a0234865c7$var$elementList = [
    "axisLine",
    "axisTickLabel",
    "axisName"
];
var $90a4a8a0234865c7$var$ParallelAxisView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ParallelAxisView, _super);
    function ParallelAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelAxisView.type;
        return _this;
    }
    ParallelAxisView.prototype.init = function(ecModel, api) {
        _super.prototype.init.apply(this, arguments);
        (this._brushController = new (0, $91342d1cfa622c5a$export$2e2bcd8739ae039)(api.getZr())).on("brush", $7a1bd9c2710fea0d$export$2385a24977818dd0(this._onBrush, this));
    };
    ParallelAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        if ($90a4a8a0234865c7$var$fromAxisAreaSelect(axisModel, ecModel, payload)) return;
        this.axisModel = axisModel;
        this.api = api;
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this.group.add(this._axisGroup);
        if (!axisModel.get("show")) return;
        var coordSysModel = $90a4a8a0234865c7$var$getCoordSysModel(axisModel, ecModel);
        var coordSys = coordSysModel.coordinateSystem;
        var areaSelectStyle = axisModel.getAreaSelectStyle();
        var areaWidth = areaSelectStyle.width;
        var dim = axisModel.axis.dim;
        var axisLayout = coordSys.getAxisLayout(dim);
        var builderOpt = $7a1bd9c2710fea0d$export$8b58be045bf06082({
            strokeContainThreshold: areaWidth
        }, axisLayout);
        var axisBuilder = new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(axisModel, builderOpt);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($90a4a8a0234865c7$var$elementList, axisBuilder.add, axisBuilder);
        this._axisGroup.add(axisBuilder.getGroup());
        this._refreshBrushController(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api);
        $5b455ae6f843ac47$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
    };
    // /**
    //  * @override
    //  */
    // updateVisual(axisModel, ecModel, api, payload) {
    //     this._brushController && this._brushController
    //         .updateCovers(getCoverInfoList(axisModel));
    // }
    ParallelAxisView.prototype._refreshBrushController = function(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api) {
        // After filtering, axis may change, select area needs to be update.
        var extent = axisModel.axis.getExtent();
        var extentLen = extent[1] - extent[0];
        var extra = Math.min(30, Math.abs(extentLen) * 0.1); // Arbitrary value.
        // width/height might be negative, which will be
        // normalized in BoundingRect.
        var rect = $1bebe7106c895823$export$2e2bcd8739ae039.create({
            x: extent[0],
            y: -areaWidth / 2,
            width: extentLen,
            height: areaWidth
        });
        rect.x -= extra;
        rect.width += 2 * extra;
        this._brushController.mount({
            enableGlobalPan: true,
            rotation: builderOpt.rotation,
            x: builderOpt.position[0],
            y: builderOpt.position[1]
        }).setPanels([
            {
                panelId: "pl",
                clipPath: $d9c171f7dfe1f12f$export$fee17964a62a87a7(rect),
                isTargetByCursor: $d9c171f7dfe1f12f$export$e63e66b3b18aa99f(rect, api, coordSysModel),
                getLinearBrushOtherExtent: $d9c171f7dfe1f12f$export$7280070e90fad7a0(rect, 0)
            }
        ]).enableBrush({
            brushType: "lineX",
            brushStyle: areaSelectStyle,
            removeOnClick: true
        }).updateCovers($90a4a8a0234865c7$var$getCoverInfoList(axisModel));
    };
    ParallelAxisView.prototype._onBrush = function(eventParam) {
        var coverInfoList = eventParam.areas;
        // Do not cache these object, because the mey be changed.
        var axisModel = this.axisModel;
        var axis = axisModel.axis;
        var intervals = $7a1bd9c2710fea0d$export$871de8747c9eaa88(coverInfoList, function(coverInfo) {
            return [
                axis.coordToData(coverInfo.range[0], true),
                axis.coordToData(coverInfo.range[1], true)
            ];
        });
        // If realtime is true, action is not dispatched on drag end, because
        // the drag end emits the same params with the last drag move event,
        // and may have some delay when using touch pad.
        if (!axisModel.option.realtime === eventParam.isEnd || eventParam.removeOnClick) // jshint ignore:line
        this.api.dispatchAction({
            type: "axisAreaSelect",
            parallelAxisId: axisModel.id,
            intervals: intervals
        });
    };
    ParallelAxisView.prototype.dispose = function() {
        this._brushController.dispose();
    };
    ParallelAxisView.type = "parallelAxis";
    return ParallelAxisView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $90a4a8a0234865c7$var$fromAxisAreaSelect(axisModel, ecModel, payload) {
    return payload && payload.type === "axisAreaSelect" && ecModel.findComponents({
        mainType: "parallelAxis",
        query: payload
    })[0] === axisModel;
}
function $90a4a8a0234865c7$var$getCoverInfoList(axisModel) {
    var axis = axisModel.axis;
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(axisModel.activeIntervals, function(interval) {
        return {
            brushType: "lineX",
            panelId: "pl",
            range: [
                axis.dataToCoord(interval[0], true),
                axis.dataToCoord(interval[1], true)
            ]
        };
    });
}
function $90a4a8a0234865c7$var$getCoordSysModel(axisModel, ecModel) {
    return ecModel.getComponent("parallel", axisModel.get("parallelIndex"));
}
var $90a4a8a0234865c7$export$2e2bcd8739ae039 = $90a4a8a0234865c7$var$ParallelAxisView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $1c10e648a7cc8028$var$actionInfo = {
    type: "axisAreaSelect",
    event: "axisAreaSelected"
};
function $1c10e648a7cc8028$export$a97c1e0aa84f4f71(registers) {
    registers.registerAction($1c10e648a7cc8028$var$actionInfo, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "parallelAxis",
            query: payload
        }, function(parallelAxisModel) {
            parallelAxisModel.axis.model.setActiveIntervals(payload.intervals);
        });
    });
    /**
   * @payload
   */ registers.registerAction("parallelAxisExpand", function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "parallel",
            query: payload
        }, function(parallelModel) {
            parallelModel.setAxisExpand(payload);
        });
    });
}


var $462857bad733a944$var$defaultAxisOption = {
    type: "value",
    areaSelectStyle: {
        width: 20,
        borderWidth: 1,
        borderColor: "rgba(160,197,232)",
        color: "rgba(160,197,232)",
        opacity: 0.3
    },
    realtime: true,
    z: 10
};
function $462857bad733a944$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView((0, $ccce4513d4baec6a$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $a14d8e1511adaa1e$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("parallel", (0, $88531590cdbcfc26$export$2e2bcd8739ae039));
    registers.registerPreprocessor((0, $30173db3404062fa$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $839a50fcb1c6f44b$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $90a4a8a0234865c7$export$2e2bcd8739ae039));
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, "parallel", (0, $839a50fcb1c6f44b$export$2e2bcd8739ae039), $462857bad733a944$var$defaultAxisOption);
    (0, $1c10e648a7cc8028$export$a97c1e0aa84f4f71)(registers);
}


function $4d1dc874f9d8653d$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $462857bad733a944$export$4b3e715f166fdd78));
    registers.registerChartView((0, $9e57680b9c04f083$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $5d63691998e05817$export$2e2bcd8739ae039));
    registers.registerVisual(registers.PRIORITY.VISUAL.BRUSH, (0, $8148e21d655f67c8$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 











var $55a0f29f32f7b1c4$var$BAR_BORDER_WIDTH_QUERY = [
    "itemStyle",
    "borderWidth"
];
// index: +isHorizontal
var $55a0f29f32f7b1c4$var$LAYOUT_ATTRS = [
    {
        xy: "x",
        wh: "width",
        index: 0,
        posDesc: [
            "left",
            "right"
        ]
    },
    {
        xy: "y",
        wh: "height",
        index: 1,
        posDesc: [
            "top",
            "bottom"
        ]
    }
];
var $55a0f29f32f7b1c4$var$pathForLineWidth = new $5b455ae6f843ac47$exports.Circle();
var $55a0f29f32f7b1c4$var$PictorialBarView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PictorialBarView, _super);
    function PictorialBarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PictorialBarView.type;
        return _this;
    }
    PictorialBarView.prototype.render = function(seriesModel, ecModel, api) {
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var coordSysRect = cartesian.master.getRect();
        var opt = {
            ecSize: {
                width: api.getWidth(),
                height: api.getHeight()
            },
            seriesModel: seriesModel,
            coordSys: cartesian,
            coordSysExtent: [
                [
                    coordSysRect.x,
                    coordSysRect.x + coordSysRect.width
                ],
                [
                    coordSysRect.y,
                    coordSysRect.y + coordSysRect.height
                ]
            ],
            isHorizontal: isHorizontal,
            valueDim: $55a0f29f32f7b1c4$var$LAYOUT_ATTRS[+isHorizontal],
            categoryDim: $55a0f29f32f7b1c4$var$LAYOUT_ATTRS[1 - +isHorizontal]
        };
        data.diff(oldData).add(function(dataIndex) {
            if (!data.hasValue(dataIndex)) return;
            var itemModel = $55a0f29f32f7b1c4$var$getItemModel(data, dataIndex);
            var symbolMeta = $55a0f29f32f7b1c4$var$getSymbolMeta(data, dataIndex, itemModel, opt);
            var bar = $55a0f29f32f7b1c4$var$createBar(data, opt, symbolMeta);
            data.setItemGraphicEl(dataIndex, bar);
            group.add(bar);
            $55a0f29f32f7b1c4$var$updateCommon(bar, opt, symbolMeta);
        }).update(function(newIndex, oldIndex) {
            var bar = oldData.getItemGraphicEl(oldIndex);
            if (!data.hasValue(newIndex)) {
                group.remove(bar);
                return;
            }
            var itemModel = $55a0f29f32f7b1c4$var$getItemModel(data, newIndex);
            var symbolMeta = $55a0f29f32f7b1c4$var$getSymbolMeta(data, newIndex, itemModel, opt);
            var pictorialShapeStr = $55a0f29f32f7b1c4$var$getShapeStr(data, symbolMeta);
            if (bar && pictorialShapeStr !== bar.__pictorialShapeStr) {
                group.remove(bar);
                data.setItemGraphicEl(newIndex, null);
                bar = null;
            }
            if (bar) $55a0f29f32f7b1c4$var$updateBar(bar, opt, symbolMeta);
            else bar = $55a0f29f32f7b1c4$var$createBar(data, opt, symbolMeta, true);
            data.setItemGraphicEl(newIndex, bar);
            bar.__pictorialSymbolMeta = symbolMeta;
            // Add back
            group.add(bar);
            $55a0f29f32f7b1c4$var$updateCommon(bar, opt, symbolMeta);
        }).remove(function(dataIndex) {
            var bar = oldData.getItemGraphicEl(dataIndex);
            bar && $55a0f29f32f7b1c4$var$removeBar(oldData, dataIndex, bar.__pictorialSymbolMeta.animationModel, bar);
        }).execute();
        // Do clipping
        var clipPath = seriesModel.get("clip", true) ? (0, $0e2cc04b3aaad400$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel) : null;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
        this._data = data;
        return this.group;
    };
    PictorialBarView.prototype.remove = function(ecModel, api) {
        var group = this.group;
        var data = this._data;
        if (ecModel.get("animation")) {
            if (data) data.eachItemGraphicEl(function(bar) {
                $55a0f29f32f7b1c4$var$removeBar(data, (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(bar).dataIndex, ecModel, bar);
            });
        } else group.removeAll();
    };
    PictorialBarView.type = "pictorialBar";
    return PictorialBarView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
// Set or calculate default value about symbol, and calculate layout info.
function $55a0f29f32f7b1c4$var$getSymbolMeta(data, dataIndex, itemModel, opt) {
    var layout = data.getItemLayout(dataIndex);
    var symbolRepeat = itemModel.get("symbolRepeat");
    var symbolClip = itemModel.get("symbolClip");
    var symbolPosition = itemModel.get("symbolPosition") || "start";
    var symbolRotate = itemModel.get("symbolRotate");
    var rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
    var symbolPatternSize = itemModel.get("symbolPatternSize") || 2;
    var isAnimationEnabled = itemModel.isAnimationEnabled();
    var symbolMeta = {
        dataIndex: dataIndex,
        layout: layout,
        itemModel: itemModel,
        symbolType: data.getItemVisual(dataIndex, "symbol") || "circle",
        style: data.getItemVisual(dataIndex, "style"),
        symbolClip: symbolClip,
        symbolRepeat: symbolRepeat,
        symbolRepeatDirection: itemModel.get("symbolRepeatDirection"),
        symbolPatternSize: symbolPatternSize,
        rotation: rotation,
        animationModel: isAnimationEnabled ? itemModel : null,
        hoverScale: isAnimationEnabled && itemModel.get([
            "emphasis",
            "scale"
        ]),
        z2: itemModel.getShallow("z", true) || 0
    };
    $55a0f29f32f7b1c4$var$prepareBarLength(itemModel, symbolRepeat, layout, opt, symbolMeta);
    $55a0f29f32f7b1c4$var$prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, symbolMeta.boundingLength, symbolMeta.pxSign, symbolPatternSize, opt, symbolMeta);
    $55a0f29f32f7b1c4$var$prepareLineWidth(itemModel, symbolMeta.symbolScale, rotation, opt, symbolMeta);
    var symbolSize = symbolMeta.symbolSize;
    var symbolOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(itemModel.get("symbolOffset"), symbolSize);
    $55a0f29f32f7b1c4$var$prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, symbolMeta.valueLineWidth, symbolMeta.boundingLength, symbolMeta.repeatCutLength, opt, symbolMeta);
    return symbolMeta;
}
// bar length can be negative.
function $55a0f29f32f7b1c4$var$prepareBarLength(itemModel, symbolRepeat, layout, opt, outputSymbolMeta) {
    var valueDim = opt.valueDim;
    var symbolBoundingData = itemModel.get("symbolBoundingData");
    var valueAxis = opt.coordSys.getOtherAxis(opt.coordSys.getBaseAxis());
    var zeroPx = valueAxis.toGlobalCoord(valueAxis.dataToCoord(0));
    var pxSignIdx = 1 - +(layout[valueDim.wh] <= 0);
    var boundingLength;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(symbolBoundingData)) {
        var symbolBoundingExtent = [
            $55a0f29f32f7b1c4$var$convertToCoordOnAxis(valueAxis, symbolBoundingData[0]) - zeroPx,
            $55a0f29f32f7b1c4$var$convertToCoordOnAxis(valueAxis, symbolBoundingData[1]) - zeroPx
        ];
        symbolBoundingExtent[1] < symbolBoundingExtent[0] && symbolBoundingExtent.reverse();
        boundingLength = symbolBoundingExtent[pxSignIdx];
    } else if (symbolBoundingData != null) boundingLength = $55a0f29f32f7b1c4$var$convertToCoordOnAxis(valueAxis, symbolBoundingData) - zeroPx;
    else if (symbolRepeat) boundingLength = opt.coordSysExtent[valueDim.index][pxSignIdx] - zeroPx;
    else boundingLength = layout[valueDim.wh];
    outputSymbolMeta.boundingLength = boundingLength;
    if (symbolRepeat) outputSymbolMeta.repeatCutLength = layout[valueDim.wh];
    // if 'pxSign' means sign of pixel,  it can't be zero, or symbolScale will be zero
    // and when borderWidth be settled, the actual linewidth will be NaN
    outputSymbolMeta.pxSign = boundingLength > 0 ? 1 : -1;
}
function $55a0f29f32f7b1c4$var$convertToCoordOnAxis(axis, value) {
    return axis.toGlobalCoord(axis.dataToCoord(axis.scale.parse(value)));
}
// Support ['100%', '100%']
function $55a0f29f32f7b1c4$var$prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, boundingLength, pxSign, symbolPatternSize, opt, outputSymbolMeta) {
    var valueDim = opt.valueDim;
    var categoryDim = opt.categoryDim;
    var categorySize = Math.abs(layout[categoryDim.wh]);
    var symbolSize = data.getItemVisual(dataIndex, "symbolSize");
    var parsedSymbolSize;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(symbolSize)) parsedSymbolSize = symbolSize.slice();
    else if (symbolSize == null) // will parse to number below
    parsedSymbolSize = [
        "100%",
        "100%"
    ];
    else parsedSymbolSize = [
        symbolSize,
        symbolSize
    ];
    // Note: percentage symbolSize (like '100%') do not consider lineWidth, because it is
    // to complicated to calculate real percent value if considering scaled lineWidth.
    // So the actual size will bigger than layout size if lineWidth is bigger than zero,
    // which can be tolerated in pictorial chart.
    parsedSymbolSize[categoryDim.index] = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(parsedSymbolSize[categoryDim.index], categorySize);
    parsedSymbolSize[valueDim.index] = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(parsedSymbolSize[valueDim.index], symbolRepeat ? categorySize : Math.abs(boundingLength));
    outputSymbolMeta.symbolSize = parsedSymbolSize;
    // If x or y is less than zero, show reversed shape.
    var symbolScale = outputSymbolMeta.symbolScale = [
        parsedSymbolSize[0] / symbolPatternSize,
        parsedSymbolSize[1] / symbolPatternSize
    ];
    // Follow convention, 'right' and 'top' is the normal scale.
    symbolScale[valueDim.index] *= (opt.isHorizontal ? -1 : 1) * pxSign;
}
function $55a0f29f32f7b1c4$var$prepareLineWidth(itemModel, symbolScale, rotation, opt, outputSymbolMeta) {
    // In symbols are drawn with scale, so do not need to care about the case that width
    // or height are too small. But symbol use strokeNoScale, where acture lineWidth should
    // be calculated.
    var valueLineWidth = itemModel.get($55a0f29f32f7b1c4$var$BAR_BORDER_WIDTH_QUERY) || 0;
    if (valueLineWidth) {
        $55a0f29f32f7b1c4$var$pathForLineWidth.attr({
            scaleX: symbolScale[0],
            scaleY: symbolScale[1],
            rotation: rotation
        });
        $55a0f29f32f7b1c4$var$pathForLineWidth.updateTransform();
        valueLineWidth /= $55a0f29f32f7b1c4$var$pathForLineWidth.getLineScale();
        valueLineWidth *= symbolScale[opt.valueDim.index];
    }
    outputSymbolMeta.valueLineWidth = valueLineWidth || 0;
}
function $55a0f29f32f7b1c4$var$prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, valueLineWidth, boundingLength, repeatCutLength, opt, outputSymbolMeta) {
    var categoryDim = opt.categoryDim;
    var valueDim = opt.valueDim;
    var pxSign = outputSymbolMeta.pxSign;
    var unitLength = Math.max(symbolSize[valueDim.index] + valueLineWidth, 0);
    var pathLen = unitLength;
    // Note: rotation will not effect the layout of symbols, because user may
    // want symbols to rotate on its center, which should not be translated
    // when rotating.
    if (symbolRepeat) {
        var absBoundingLength = Math.abs(boundingLength);
        var symbolMargin = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66(itemModel.get("symbolMargin"), "15%") + "";
        var hasEndGap = false;
        if (symbolMargin.lastIndexOf("!") === symbolMargin.length - 1) {
            hasEndGap = true;
            symbolMargin = symbolMargin.slice(0, symbolMargin.length - 1);
        }
        var symbolMarginNumeric = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(symbolMargin, symbolSize[valueDim.index]);
        var uLenWithMargin = Math.max(unitLength + symbolMarginNumeric * 2, 0);
        // When symbol margin is less than 0, margin at both ends will be subtracted
        // to ensure that all of the symbols will not be overflow the given area.
        var endFix = hasEndGap ? 0 : symbolMarginNumeric * 2;
        // Both final repeatTimes and final symbolMarginNumeric area calculated based on
        // boundingLength.
        var repeatSpecified = (0, $cfc1f3b422a3185f$export$e90fb89750dba83f)(symbolRepeat);
        var repeatTimes = repeatSpecified ? symbolRepeat : $55a0f29f32f7b1c4$var$toIntTimes((absBoundingLength + endFix) / uLenWithMargin);
        // Adjust calculate margin, to ensure each symbol is displayed
        // entirely in the given layout area.
        var mDiff = absBoundingLength - repeatTimes * unitLength;
        symbolMarginNumeric = mDiff / 2 / (hasEndGap ? repeatTimes : Math.max(repeatTimes - 1, 1));
        uLenWithMargin = unitLength + symbolMarginNumeric * 2;
        endFix = hasEndGap ? 0 : symbolMarginNumeric * 2;
        // Update repeatTimes when not all symbol will be shown.
        if (!repeatSpecified && symbolRepeat !== "fixed") repeatTimes = repeatCutLength ? $55a0f29f32f7b1c4$var$toIntTimes((Math.abs(repeatCutLength) + endFix) / uLenWithMargin) : 0;
        pathLen = repeatTimes * uLenWithMargin - endFix;
        outputSymbolMeta.repeatTimes = repeatTimes;
        outputSymbolMeta.symbolMargin = symbolMarginNumeric;
    }
    var sizeFix = pxSign * (pathLen / 2);
    var pathPosition = outputSymbolMeta.pathPosition = [];
    pathPosition[categoryDim.index] = layout[categoryDim.wh] / 2;
    pathPosition[valueDim.index] = symbolPosition === "start" ? sizeFix : symbolPosition === "end" ? boundingLength - sizeFix : boundingLength / 2; // 'center'
    if (symbolOffset) {
        pathPosition[0] += symbolOffset[0];
        pathPosition[1] += symbolOffset[1];
    }
    var bundlePosition = outputSymbolMeta.bundlePosition = [];
    bundlePosition[categoryDim.index] = layout[categoryDim.xy];
    bundlePosition[valueDim.index] = layout[valueDim.xy];
    var barRectShape = outputSymbolMeta.barRectShape = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, layout);
    barRectShape[valueDim.wh] = pxSign * Math.max(Math.abs(layout[valueDim.wh]), Math.abs(pathPosition[valueDim.index] + sizeFix));
    barRectShape[categoryDim.wh] = layout[categoryDim.wh];
    var clipShape = outputSymbolMeta.clipShape = {};
    // Consider that symbol may be overflow layout rect.
    clipShape[categoryDim.xy] = -layout[categoryDim.xy];
    clipShape[categoryDim.wh] = opt.ecSize[categoryDim.wh];
    clipShape[valueDim.xy] = 0;
    clipShape[valueDim.wh] = layout[valueDim.wh];
}
function $55a0f29f32f7b1c4$var$createPath(symbolMeta) {
    var symbolPatternSize = symbolMeta.symbolPatternSize;
    var path = (0, $5370466dadc978d7$export$af050e04da3a02e8)(// Consider texture img, make a big size.
    symbolMeta.symbolType, -symbolPatternSize / 2, -symbolPatternSize / 2, symbolPatternSize, symbolPatternSize);
    path.attr({
        culling: true
    });
    path.type !== "image" && path.setStyle({
        strokeNoScale: true
    });
    return path;
}
function $55a0f29f32f7b1c4$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta, isUpdate) {
    var bundle = bar.__pictorialBundle;
    var symbolSize = symbolMeta.symbolSize;
    var valueLineWidth = symbolMeta.valueLineWidth;
    var pathPosition = symbolMeta.pathPosition;
    var valueDim = opt.valueDim;
    var repeatTimes = symbolMeta.repeatTimes || 0;
    var index = 0;
    var unit = symbolSize[opt.valueDim.index] + valueLineWidth + symbolMeta.symbolMargin * 2;
    $55a0f29f32f7b1c4$var$eachPath(bar, function(path) {
        path.__pictorialAnimationIndex = index;
        path.__pictorialRepeatTimes = repeatTimes;
        if (index < repeatTimes) $55a0f29f32f7b1c4$var$updateAttr(path, null, makeTarget(index), symbolMeta, isUpdate);
        else $55a0f29f32f7b1c4$var$updateAttr(path, null, {
            scaleX: 0,
            scaleY: 0
        }, symbolMeta, isUpdate, function() {
            bundle.remove(path);
        });
        // updateHoverAnimation(path, symbolMeta);
        index++;
    });
    for(; index < repeatTimes; index++){
        var path = $55a0f29f32f7b1c4$var$createPath(symbolMeta);
        path.__pictorialAnimationIndex = index;
        path.__pictorialRepeatTimes = repeatTimes;
        bundle.add(path);
        var target = makeTarget(index);
        $55a0f29f32f7b1c4$var$updateAttr(path, {
            x: target.x,
            y: target.y,
            scaleX: 0,
            scaleY: 0
        }, {
            scaleX: target.scaleX,
            scaleY: target.scaleY,
            rotation: target.rotation
        }, symbolMeta, isUpdate);
    }
    function makeTarget(index) {
        var position = pathPosition.slice();
        // (start && pxSign > 0) || (end && pxSign < 0): i = repeatTimes - index
        // Otherwise: i = index;
        var pxSign = symbolMeta.pxSign;
        var i = index;
        if (symbolMeta.symbolRepeatDirection === "start" ? pxSign > 0 : pxSign < 0) i = repeatTimes - 1 - index;
        position[valueDim.index] = unit * (i - repeatTimes / 2 + 0.5) + pathPosition[valueDim.index];
        return {
            x: position[0],
            y: position[1],
            scaleX: symbolMeta.symbolScale[0],
            scaleY: symbolMeta.symbolScale[1],
            rotation: symbolMeta.rotation
        };
    }
}
function $55a0f29f32f7b1c4$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta, isUpdate) {
    var bundle = bar.__pictorialBundle;
    var mainPath = bar.__pictorialMainPath;
    if (!mainPath) {
        mainPath = bar.__pictorialMainPath = $55a0f29f32f7b1c4$var$createPath(symbolMeta);
        bundle.add(mainPath);
        $55a0f29f32f7b1c4$var$updateAttr(mainPath, {
            x: symbolMeta.pathPosition[0],
            y: symbolMeta.pathPosition[1],
            scaleX: 0,
            scaleY: 0,
            rotation: symbolMeta.rotation
        }, {
            scaleX: symbolMeta.symbolScale[0],
            scaleY: symbolMeta.symbolScale[1]
        }, symbolMeta, isUpdate);
    } else $55a0f29f32f7b1c4$var$updateAttr(mainPath, null, {
        x: symbolMeta.pathPosition[0],
        y: symbolMeta.pathPosition[1],
        scaleX: symbolMeta.symbolScale[0],
        scaleY: symbolMeta.symbolScale[1],
        rotation: symbolMeta.rotation
    }, symbolMeta, isUpdate);
}
// bar rect is used for label.
function $55a0f29f32f7b1c4$var$createOrUpdateBarRect(bar, symbolMeta, isUpdate) {
    var rectShape = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, symbolMeta.barRectShape);
    var barRect = bar.__pictorialBarRect;
    if (!barRect) {
        barRect = bar.__pictorialBarRect = new $5b455ae6f843ac47$exports.Rect({
            z2: 2,
            shape: rectShape,
            silent: true,
            style: {
                stroke: "transparent",
                fill: "transparent",
                lineWidth: 0
            }
        });
        barRect.disableMorphing = true;
        bar.add(barRect);
    } else $55a0f29f32f7b1c4$var$updateAttr(barRect, null, {
        shape: rectShape
    }, symbolMeta, isUpdate);
}
function $55a0f29f32f7b1c4$var$createOrUpdateClip(bar, opt, symbolMeta, isUpdate) {
    // If not clip, symbol will be remove and rebuilt.
    if (symbolMeta.symbolClip) {
        var clipPath = bar.__pictorialClipPath;
        var clipShape = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, symbolMeta.clipShape);
        var valueDim = opt.valueDim;
        var animationModel = symbolMeta.animationModel;
        var dataIndex = symbolMeta.dataIndex;
        if (clipPath) $5b455ae6f843ac47$exports.updateProps(clipPath, {
            shape: clipShape
        }, animationModel, dataIndex);
        else {
            clipShape[valueDim.wh] = 0;
            clipPath = new $5b455ae6f843ac47$exports.Rect({
                shape: clipShape
            });
            bar.__pictorialBundle.setClipPath(clipPath);
            bar.__pictorialClipPath = clipPath;
            var target = {};
            target[valueDim.wh] = symbolMeta.clipShape[valueDim.wh];
            $5b455ae6f843ac47$exports[isUpdate ? "updateProps" : "initProps"](clipPath, {
                shape: target
            }, animationModel, dataIndex);
        }
    }
}
function $55a0f29f32f7b1c4$var$getItemModel(data, dataIndex) {
    var itemModel = data.getItemModel(dataIndex);
    itemModel.getAnimationDelayParams = $55a0f29f32f7b1c4$var$getAnimationDelayParams;
    itemModel.isAnimationEnabled = $55a0f29f32f7b1c4$var$isAnimationEnabled;
    return itemModel;
}
function $55a0f29f32f7b1c4$var$getAnimationDelayParams(path) {
    // The order is the same as the z-order, see `symbolRepeatDiretion`.
    return {
        index: path.__pictorialAnimationIndex,
        count: path.__pictorialRepeatTimes
    };
}
function $55a0f29f32f7b1c4$var$isAnimationEnabled() {
    // `animation` prop can be set on itemModel in pictorial bar chart.
    return this.parentModel.isAnimationEnabled() && !!this.getShallow("animation");
}
function $55a0f29f32f7b1c4$var$createBar(data, opt, symbolMeta, isUpdate) {
    // bar is the main element for each data.
    var bar = new $5b455ae6f843ac47$exports.Group();
    // bundle is used for location and clip.
    var bundle = new $5b455ae6f843ac47$exports.Group();
    bar.add(bundle);
    bar.__pictorialBundle = bundle;
    bundle.x = symbolMeta.bundlePosition[0];
    bundle.y = symbolMeta.bundlePosition[1];
    if (symbolMeta.symbolRepeat) $55a0f29f32f7b1c4$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta);
    else $55a0f29f32f7b1c4$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta);
    $55a0f29f32f7b1c4$var$createOrUpdateBarRect(bar, symbolMeta, isUpdate);
    $55a0f29f32f7b1c4$var$createOrUpdateClip(bar, opt, symbolMeta, isUpdate);
    bar.__pictorialShapeStr = $55a0f29f32f7b1c4$var$getShapeStr(data, symbolMeta);
    bar.__pictorialSymbolMeta = symbolMeta;
    return bar;
}
function $55a0f29f32f7b1c4$var$updateBar(bar, opt, symbolMeta) {
    var animationModel = symbolMeta.animationModel;
    var dataIndex = symbolMeta.dataIndex;
    var bundle = bar.__pictorialBundle;
    $5b455ae6f843ac47$exports.updateProps(bundle, {
        x: symbolMeta.bundlePosition[0],
        y: symbolMeta.bundlePosition[1]
    }, animationModel, dataIndex);
    if (symbolMeta.symbolRepeat) $55a0f29f32f7b1c4$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta, true);
    else $55a0f29f32f7b1c4$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta, true);
    $55a0f29f32f7b1c4$var$createOrUpdateBarRect(bar, symbolMeta, true);
    $55a0f29f32f7b1c4$var$createOrUpdateClip(bar, opt, symbolMeta, true);
}
function $55a0f29f32f7b1c4$var$removeBar(data, dataIndex, animationModel, bar) {
    // Not show text when animating
    var labelRect = bar.__pictorialBarRect;
    labelRect && labelRect.removeTextContent();
    var paths = [];
    $55a0f29f32f7b1c4$var$eachPath(bar, function(path) {
        paths.push(path);
    });
    bar.__pictorialMainPath && paths.push(bar.__pictorialMainPath);
    // I do not find proper remove animation for clip yet.
    bar.__pictorialClipPath && (animationModel = null);
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(paths, function(path) {
        $5b455ae6f843ac47$exports.removeElement(path, {
            scaleX: 0,
            scaleY: 0
        }, animationModel, dataIndex, function() {
            bar.parent && bar.parent.remove(bar);
        });
    });
    data.setItemGraphicEl(dataIndex, null);
}
function $55a0f29f32f7b1c4$var$getShapeStr(data, symbolMeta) {
    return [
        data.getItemVisual(symbolMeta.dataIndex, "symbol") || "none",
        !!symbolMeta.symbolRepeat,
        !!symbolMeta.symbolClip
    ].join(":");
}
function $55a0f29f32f7b1c4$var$eachPath(bar, cb, context) {
    // Do not use Group#eachChild, because it do not support remove.
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(bar.__pictorialBundle.children(), function(el) {
        el !== bar.__pictorialBarRect && cb.call(context, el);
    });
}
function $55a0f29f32f7b1c4$var$updateAttr(el, immediateAttrs, animationAttrs, symbolMeta, isUpdate, cb) {
    immediateAttrs && el.attr(immediateAttrs);
    // when symbolCip used, only clip path has init animation, otherwise it would be weird effect.
    if (symbolMeta.symbolClip && !isUpdate) animationAttrs && el.attr(animationAttrs);
    else animationAttrs && $5b455ae6f843ac47$exports[isUpdate ? "updateProps" : "initProps"](el, animationAttrs, symbolMeta.animationModel, symbolMeta.dataIndex, cb);
}
function $55a0f29f32f7b1c4$var$updateCommon(bar, opt, symbolMeta) {
    var dataIndex = symbolMeta.dataIndex;
    var itemModel = symbolMeta.itemModel;
    // Color must be excluded.
    // Because symbol provide setColor individually to set fill and stroke
    var emphasisModel = itemModel.getModel("emphasis");
    var emphasisStyle = emphasisModel.getModel("itemStyle").getItemStyle();
    var blurStyle = itemModel.getModel([
        "blur",
        "itemStyle"
    ]).getItemStyle();
    var selectStyle = itemModel.getModel([
        "select",
        "itemStyle"
    ]).getItemStyle();
    var cursorStyle = itemModel.getShallow("cursor");
    var focus = emphasisModel.get("focus");
    var blurScope = emphasisModel.get("blurScope");
    var hoverScale = emphasisModel.get("scale");
    $55a0f29f32f7b1c4$var$eachPath(bar, function(path) {
        if (path instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
            var pathStyle = path.style;
            path.useStyle($7a1bd9c2710fea0d$export$8b58be045bf06082({
                // TODO other properties like dx, dy ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, symbolMeta.style));
        } else path.useStyle(symbolMeta.style);
        var emphasisState = path.ensureState("emphasis");
        emphasisState.style = emphasisStyle;
        if (hoverScale) {
            // NOTE: Must after scale is set after updateAttr
            emphasisState.scaleX = path.scaleX * 1.1;
            emphasisState.scaleY = path.scaleY * 1.1;
        }
        path.ensureState("blur").style = blurStyle;
        path.ensureState("select").style = selectStyle;
        cursorStyle && (path.cursor = cursorStyle);
        path.z2 = symbolMeta.z2;
    });
    var barPositionOutside = opt.valueDim.posDesc[+(symbolMeta.boundingLength > 0)];
    var barRect = bar.__pictorialBarRect;
    barRect.ignoreClip = true;
    (0, $6800dfcb6e1e2a44$export$9a13992917966657)(barRect, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
        labelFetcher: opt.seriesModel,
        labelDataIndex: dataIndex,
        defaultText: (0, $b2475f850d3c0bc2$export$5ff20667590927ed)(opt.seriesModel.getData(), dataIndex),
        inheritColor: symbolMeta.style.fill,
        defaultOpacity: symbolMeta.style.opacity,
        defaultOutsidePosition: barPositionOutside
    });
    (0, $2bf82c0980125b62$export$e51187539ff11209)(bar, focus, blurScope, emphasisModel.get("disabled"));
}
function $55a0f29f32f7b1c4$var$toIntTimes(times) {
    var roundedTimes = Math.round(times);
    // Escapse accurate error
    return Math.abs(times - roundedTimes) < 1e-4 ? roundedTimes : Math.ceil(times);
}
var $55a0f29f32f7b1c4$export$2e2bcd8739ae039 = $55a0f29f32f7b1c4$var$PictorialBarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $eb46f662d47de4a6$var$PictorialBarSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PictorialBarSeriesModel, _super);
    function PictorialBarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PictorialBarSeriesModel.type;
        _this.hasSymbolVisual = true;
        _this.defaultSymbol = "roundRect";
        return _this;
    }
    PictorialBarSeriesModel.prototype.getInitialData = function(option) {
        // Disable stack.
        option.stack = null;
        return _super.prototype.getInitialData.apply(this, arguments);
    };
    PictorialBarSeriesModel.type = "series.pictorialBar";
    PictorialBarSeriesModel.dependencies = [
        "grid"
    ];
    PictorialBarSeriesModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $b508252f98157abf$export$2e2bcd8739ae039).defaultOption, {
        symbol: "circle",
        symbolSize: null,
        symbolRotate: null,
        symbolPosition: null,
        symbolOffset: null,
        symbolMargin: null,
        symbolRepeat: false,
        symbolRepeatDirection: "end",
        symbolClip: false,
        symbolBoundingData: null,
        symbolPatternSize: 400,
        barGap: "-100%",
        // Pictorial bar do not clip by default because in many cases
        // xAxis and yAxis are not displayed and it's expected not to clip
        clip: false,
        // z can be set in data item, which is z2 actually.
        // Disable progressive
        progressive: 0,
        emphasis: {
            // By default pictorialBar do not hover scale. Hover scale is not suitable
            // for the case that both has foreground and background.
            scale: false
        },
        select: {
            itemStyle: {
                borderColor: "#212121"
            }
        }
    });
    return PictorialBarSeriesModel;
}((0, $b508252f98157abf$export$2e2bcd8739ae039));
var $eb46f662d47de4a6$export$2e2bcd8739ae039 = $eb46f662d47de4a6$var$PictorialBarSeriesModel;




function $7e25595b74be81a3$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $55a0f29f32f7b1c4$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $eb46f662d47de4a6$export$2e2bcd8739ae039));
    registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $361c48dd900de28f$export$b3219800bda33a1f), "pictorialBar"));
    // Do layout after other overall layout, which can prepare some information.
    registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, (0, $361c48dd900de28f$export$16e8685758531cb6)("pictorialBar"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $21576fcf4c669316$var$PI2 = Math.PI * 2;
var $21576fcf4c669316$var$RADIAN = Math.PI / 180;
function $21576fcf4c669316$var$getViewRect(seriesModel, api) {
    return $93b9bc7f22ac7369$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $21576fcf4c669316$export$2a0d4d5b12383eb9(seriesModel, api) {
    var viewRect = $21576fcf4c669316$var$getViewRect(seriesModel, api);
    // center can be string or number when coordinateSystem is specified
    var center = seriesModel.get("center");
    var radius = seriesModel.get("radius");
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(radius)) radius = [
        0,
        radius
    ];
    var width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(viewRect.width, api.getWidth());
    var height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(viewRect.height, api.getHeight());
    var size = Math.min(width, height);
    var r0 = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[0], size / 2);
    var r = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[1], size / 2);
    var cx;
    var cy;
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys) {
        // percentage is not allowed when coordinate system is specified
        var point = coordSys.dataToPoint(center);
        cx = point[0] || 0;
        cy = point[1] || 0;
    } else {
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(center)) center = [
            center,
            center
        ];
        cx = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[0], width) + viewRect.x;
        cy = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[1], height) + viewRect.y;
    }
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r
    };
}
function $21576fcf4c669316$export$2e2bcd8739ae039(seriesType, ecModel, api) {
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        var data = seriesModel.getData();
        var valueDim = data.mapDimension("value");
        var viewRect = $21576fcf4c669316$var$getViewRect(seriesModel, api);
        var _a = $21576fcf4c669316$export$2a0d4d5b12383eb9(seriesModel, api), cx = _a.cx, cy = _a.cy, r = _a.r, r0 = _a.r0;
        var startAngle = -seriesModel.get("startAngle") * $21576fcf4c669316$var$RADIAN;
        var endAngle = seriesModel.get("endAngle");
        var padAngle = seriesModel.get("padAngle") * $21576fcf4c669316$var$RADIAN;
        endAngle = endAngle === "auto" ? startAngle - $21576fcf4c669316$var$PI2 : -endAngle * $21576fcf4c669316$var$RADIAN;
        var minAngle = seriesModel.get("minAngle") * $21576fcf4c669316$var$RADIAN;
        var minAndPadAngle = minAngle + padAngle;
        var validDataCount = 0;
        data.each(valueDim, function(value) {
            !isNaN(value) && validDataCount++;
        });
        var sum = data.getSum(valueDim);
        // Sum may be 0
        var unitRadian = Math.PI / (sum || validDataCount) * 2;
        var clockwise = seriesModel.get("clockwise");
        var roseType = seriesModel.get("roseType");
        var stillShowZeroSum = seriesModel.get("stillShowZeroSum");
        // [0...max]
        var extent = data.getDataExtent(valueDim);
        extent[0] = 0;
        var dir = clockwise ? 1 : -1;
        var angles = [
            startAngle,
            endAngle
        ];
        var halfPadAngle = dir * padAngle / 2;
        (0, $20ebe2448f123f2e$export$bc668021e937022a)(angles, !clockwise);
        startAngle = angles[0], endAngle = angles[1];
        var angleRange = Math.abs(endAngle - startAngle);
        // In the case some sector angle is smaller than minAngle
        var restAngle = angleRange;
        var valueSumLargerThanMinAngle = 0;
        var currentAngle = startAngle;
        data.setLayout({
            viewRect: viewRect,
            r: r
        });
        data.each(valueDim, function(value, idx) {
            var angle;
            if (isNaN(value)) {
                data.setItemLayout(idx, {
                    angle: NaN,
                    startAngle: NaN,
                    endAngle: NaN,
                    clockwise: clockwise,
                    cx: cx,
                    cy: cy,
                    r0: r0,
                    r: roseType ? NaN : r
                });
                return;
            }
            // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？
            if (roseType !== "area") angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
            else angle = angleRange / validDataCount;
            if (angle < minAndPadAngle) {
                angle = minAndPadAngle;
                restAngle -= minAndPadAngle;
            } else valueSumLargerThanMinAngle += value;
            var endAngle = currentAngle + dir * angle;
            // calculate display angle
            var actualStartAngle = 0;
            var actualEndAngle = 0;
            if (padAngle > angle) {
                actualStartAngle = currentAngle + dir * angle / 2;
                actualEndAngle = actualStartAngle;
            } else {
                actualStartAngle = currentAngle + halfPadAngle;
                actualEndAngle = endAngle - halfPadAngle;
            }
            data.setItemLayout(idx, {
                angle: angle,
                startAngle: actualStartAngle,
                endAngle: actualEndAngle,
                clockwise: clockwise,
                cx: cx,
                cy: cy,
                r0: r0,
                r: roseType ? (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, extent, [
                    r0,
                    r
                ]) : r
            });
            currentAngle = endAngle;
        });
        // Some sector is constrained by minAngle and padAngle
        // Rest sectors needs recalculate angle
        if (restAngle < $21576fcf4c669316$var$PI2 && validDataCount) {
            // Average the angle if rest angle is not enough after all angles is
            // Constrained by minAngle and padAngle
            if (restAngle <= 1e-3) {
                var angle_1 = angleRange / validDataCount;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout_1 = data.getItemLayout(idx);
                        layout_1.angle = angle_1;
                        var actualStartAngle = 0;
                        var actualEndAngle = 0;
                        if (angle_1 < padAngle) {
                            actualStartAngle = startAngle + dir * (idx + 0.5) * angle_1;
                            actualEndAngle = actualStartAngle;
                        } else {
                            actualStartAngle = startAngle + dir * idx * angle_1 + halfPadAngle;
                            actualEndAngle = startAngle + dir * (idx + 1) * angle_1 - halfPadAngle;
                        }
                        layout_1.startAngle = actualStartAngle;
                        layout_1.endAngle = actualEndAngle;
                    }
                });
            } else {
                unitRadian = restAngle / valueSumLargerThanMinAngle;
                currentAngle = startAngle;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout_2 = data.getItemLayout(idx);
                        var angle = layout_2.angle === minAndPadAngle ? minAndPadAngle : value * unitRadian;
                        var actualStartAngle = 0;
                        var actualEndAngle = 0;
                        if (angle < padAngle) {
                            actualStartAngle = currentAngle + dir * angle / 2;
                            actualEndAngle = actualStartAngle;
                        } else {
                            actualStartAngle = currentAngle + halfPadAngle;
                            actualEndAngle = currentAngle + dir * angle - halfPadAngle;
                        }
                        layout_2.startAngle = actualStartAngle;
                        layout_2.endAngle = actualEndAngle;
                        currentAngle += dir * angle;
                    }
                });
            }
        }
    });
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME emphasis label position is not same with normal label position





var $4b109d23b790ee9a$var$RADIAN = Math.PI / 180;
function $4b109d23b790ee9a$var$adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight, viewLeft, viewTop, farthestX) {
    if (list.length < 2) return;
    function recalculateXOnSemiToAlignOnEllipseCurve(semi) {
        var rB = semi.rB;
        var rB2 = rB * rB;
        for(var i = 0; i < semi.list.length; i++){
            var item = semi.list[i];
            var dy = Math.abs(item.label.y - cy);
            // horizontal r is always same with original r because x is not changed.
            var rA = r + item.len;
            var rA2 = rA * rA;
            // Use ellipse implicit function to calculate x
            var dx = Math.sqrt((1 - Math.abs(dy * dy / rB2)) * rA2);
            var newX = cx + (dx + item.len2) * dir;
            var deltaX = newX - item.label.x;
            var newTargetWidth = item.targetTextWidth - deltaX * dir;
            // text x is changed, so need to recalculate width.
            $4b109d23b790ee9a$var$constrainTextWidth(item, newTargetWidth, true);
            item.label.x = newX;
        }
    }
    // Adjust X based on the shifted y. Make tight labels aligned on an ellipse curve.
    function recalculateX(items) {
        // Extremes of
        var topSemi = {
            list: [],
            maxY: 0
        };
        var bottomSemi = {
            list: [],
            maxY: 0
        };
        for(var i = 0; i < items.length; i++){
            if (items[i].labelAlignTo !== "none") continue;
            var item = items[i];
            var semi = item.label.y > cy ? bottomSemi : topSemi;
            var dy = Math.abs(item.label.y - cy);
            if (dy >= semi.maxY) {
                var dx = item.label.x - cx - item.len2 * dir;
                // horizontal r is always same with original r because x is not changed.
                var rA = r + item.len;
                // Canculate rB based on the topest / bottemest label.
                var rB = Math.abs(dx) < rA ? Math.sqrt(dy * dy / (1 - dx * dx / rA / rA)) : rA;
                semi.rB = rB;
                semi.maxY = dy;
            }
            semi.list.push(item);
        }
        recalculateXOnSemiToAlignOnEllipseCurve(topSemi);
        recalculateXOnSemiToAlignOnEllipseCurve(bottomSemi);
    }
    var len = list.length;
    for(var i = 0; i < len; i++)if (list[i].position === "outer" && list[i].labelAlignTo === "labelLine") {
        var dx = list[i].label.x - farthestX;
        list[i].linePoints[1][0] += dx;
        list[i].label.x = farthestX;
    }
    if ((0, $11dac7a73f36cc2c$export$118c25e0932528e4)(list, viewTop, viewTop + viewHeight)) recalculateX(list);
}
function $4b109d23b790ee9a$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop) {
    var leftList = [];
    var rightList = [];
    var leftmostX = Number.MAX_VALUE;
    var rightmostX = -Number.MAX_VALUE;
    for(var i = 0; i < labelLayoutList.length; i++){
        var label = labelLayoutList[i].label;
        if ($4b109d23b790ee9a$var$isPositionCenter(labelLayoutList[i])) continue;
        if (label.x < cx) {
            leftmostX = Math.min(leftmostX, label.x);
            leftList.push(labelLayoutList[i]);
        } else {
            rightmostX = Math.max(rightmostX, label.x);
            rightList.push(labelLayoutList[i]);
        }
    }
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        if (!$4b109d23b790ee9a$var$isPositionCenter(layout) && layout.linePoints) {
            if (layout.labelStyleWidth != null) continue;
            var label = layout.label;
            var linePoints = layout.linePoints;
            var targetTextWidth = void 0;
            if (layout.labelAlignTo === "edge") {
                if (label.x < cx) targetTextWidth = linePoints[2][0] - layout.labelDistance - viewLeft - layout.edgeDistance;
                else targetTextWidth = viewLeft + viewWidth - layout.edgeDistance - linePoints[2][0] - layout.labelDistance;
            } else if (layout.labelAlignTo === "labelLine") {
                if (label.x < cx) targetTextWidth = leftmostX - viewLeft - layout.bleedMargin;
                else targetTextWidth = viewLeft + viewWidth - rightmostX - layout.bleedMargin;
            } else if (label.x < cx) targetTextWidth = label.x - viewLeft - layout.bleedMargin;
            else targetTextWidth = viewLeft + viewWidth - label.x - layout.bleedMargin;
            layout.targetTextWidth = targetTextWidth;
            $4b109d23b790ee9a$var$constrainTextWidth(layout, targetTextWidth);
        }
    }
    $4b109d23b790ee9a$var$adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight, viewLeft, viewTop, rightmostX);
    $4b109d23b790ee9a$var$adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight, viewLeft, viewTop, leftmostX);
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        if (!$4b109d23b790ee9a$var$isPositionCenter(layout) && layout.linePoints) {
            var label = layout.label;
            var linePoints = layout.linePoints;
            var isAlignToEdge = layout.labelAlignTo === "edge";
            var padding = label.style.padding;
            var paddingH = padding ? padding[1] + padding[3] : 0;
            // textRect.width already contains paddingH if bgColor is set
            var extraPaddingH = label.style.backgroundColor ? 0 : paddingH;
            var realTextWidth = layout.rect.width + extraPaddingH;
            var dist = linePoints[1][0] - linePoints[2][0];
            if (isAlignToEdge) {
                if (label.x < cx) linePoints[2][0] = viewLeft + layout.edgeDistance + realTextWidth + layout.labelDistance;
                else linePoints[2][0] = viewLeft + viewWidth - layout.edgeDistance - realTextWidth - layout.labelDistance;
            } else {
                if (label.x < cx) linePoints[2][0] = label.x + layout.labelDistance;
                else linePoints[2][0] = label.x - layout.labelDistance;
                linePoints[1][0] = linePoints[2][0] + dist;
            }
            linePoints[1][1] = linePoints[2][1] = label.y;
        }
    }
}
/**
 * Set max width of each label, and then wrap each label to the max width.
 *
 * @param layout label layout
 * @param availableWidth max width for the label to display
 * @param forceRecalculate recaculate the text layout even if the current width
 * is smaller than `availableWidth`. This is useful when the text was previously
 * wrapped by calling `constrainTextWidth` but now `availableWidth` changed, in
 * which case, previous wrapping should be redo.
 */ function $4b109d23b790ee9a$var$constrainTextWidth(layout, availableWidth, forceRecalculate) {
    if (forceRecalculate === void 0) forceRecalculate = false;
    if (layout.labelStyleWidth != null) // User-defined style.width has the highest priority.
    return;
    var label = layout.label;
    var style = label.style;
    var textRect = layout.rect;
    var bgColor = style.backgroundColor;
    var padding = style.padding;
    var paddingH = padding ? padding[1] + padding[3] : 0;
    var overflow = style.overflow;
    // textRect.width already contains paddingH if bgColor is set
    var oldOuterWidth = textRect.width + (bgColor ? 0 : paddingH);
    if (availableWidth < oldOuterWidth || forceRecalculate) {
        var oldHeight = textRect.height;
        if (overflow && overflow.match("break")) {
            // Temporarily set background to be null to calculate
            // the bounding box without background.
            label.setStyle("backgroundColor", null);
            // Set constraining width
            label.setStyle("width", availableWidth - paddingH);
            // This is the real bounding box of the text without padding.
            var innerRect = label.getBoundingRect();
            label.setStyle("width", Math.ceil(innerRect.width));
            label.setStyle("backgroundColor", bgColor);
        } else {
            var availableInnerWidth = availableWidth - paddingH;
            var newWidth = availableWidth < oldOuterWidth ? availableInnerWidth : // Current available width is enough, but the text may have
            // already been wrapped with a smaller available width.
            forceRecalculate ? availableInnerWidth > layout.unconstrainedWidth ? null : availableInnerWidth : null;
            label.setStyle("width", newWidth);
        }
        var newRect = label.getBoundingRect();
        textRect.width = newRect.width;
        var margin = (label.style.margin || 0) + 2.1;
        textRect.height = newRect.height + margin;
        textRect.y -= (textRect.height - oldHeight) / 2;
    }
}
function $4b109d23b790ee9a$var$isPositionCenter(sectorShape) {
    // Not change x for center label
    return sectorShape.position === "center";
}
function $4b109d23b790ee9a$export$2e2bcd8739ae039(seriesModel) {
    var data = seriesModel.getData();
    var labelLayoutList = [];
    var cx;
    var cy;
    var hasLabelRotate = false;
    var minShowLabelRadian = (seriesModel.get("minShowLabelAngle") || 0) * $4b109d23b790ee9a$var$RADIAN;
    var viewRect = data.getLayout("viewRect");
    var r = data.getLayout("r");
    var viewWidth = viewRect.width;
    var viewLeft = viewRect.x;
    var viewTop = viewRect.y;
    var viewHeight = viewRect.height;
    function setNotShow(el) {
        el.ignore = true;
    }
    function isLabelShown(label) {
        if (!label.ignore) return true;
        for(var key in label.states){
            if (label.states[key].ignore === false) return true;
        }
        return false;
    }
    data.each(function(idx) {
        var sector = data.getItemGraphicEl(idx);
        var sectorShape = sector.shape;
        var label = sector.getTextContent();
        var labelLine = sector.getTextGuideLine();
        var itemModel = data.getItemModel(idx);
        var labelModel = itemModel.getModel("label");
        // Use position in normal or emphasis
        var labelPosition = labelModel.get("position") || itemModel.get([
            "emphasis",
            "label",
            "position"
        ]);
        var labelDistance = labelModel.get("distanceToLabelLine");
        var labelAlignTo = labelModel.get("alignTo");
        var edgeDistance = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(labelModel.get("edgeDistance"), viewWidth);
        var bleedMargin = labelModel.get("bleedMargin");
        var labelLineModel = itemModel.getModel("labelLine");
        var labelLineLen = labelLineModel.get("length");
        labelLineLen = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(labelLineLen, viewWidth);
        var labelLineLen2 = labelLineModel.get("length2");
        labelLineLen2 = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(labelLineLen2, viewWidth);
        if (Math.abs(sectorShape.endAngle - sectorShape.startAngle) < minShowLabelRadian) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(label.states, setNotShow);
            label.ignore = true;
            if (labelLine) {
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(labelLine.states, setNotShow);
                labelLine.ignore = true;
            }
            return;
        }
        if (!isLabelShown(label)) return;
        var midAngle = (sectorShape.startAngle + sectorShape.endAngle) / 2;
        var nx = Math.cos(midAngle);
        var ny = Math.sin(midAngle);
        var textX;
        var textY;
        var linePoints;
        var textAlign;
        cx = sectorShape.cx;
        cy = sectorShape.cy;
        var isLabelInside = labelPosition === "inside" || labelPosition === "inner";
        if (labelPosition === "center") {
            textX = sectorShape.cx;
            textY = sectorShape.cy;
            textAlign = "center";
        } else {
            var x1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * nx : sectorShape.r * nx) + cx;
            var y1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * ny : sectorShape.r * ny) + cy;
            textX = x1 + nx * 3;
            textY = y1 + ny * 3;
            if (!isLabelInside) {
                // For roseType
                var x2 = x1 + nx * (labelLineLen + r - sectorShape.r);
                var y2 = y1 + ny * (labelLineLen + r - sectorShape.r);
                var x3 = x2 + (nx < 0 ? -1 : 1) * labelLineLen2;
                var y3 = y2;
                if (labelAlignTo === "edge") // Adjust textX because text align of edge is opposite
                textX = nx < 0 ? viewLeft + edgeDistance : viewLeft + viewWidth - edgeDistance;
                else textX = x3 + (nx < 0 ? -labelDistance : labelDistance);
                textY = y3;
                linePoints = [
                    [
                        x1,
                        y1
                    ],
                    [
                        x2,
                        y2
                    ],
                    [
                        x3,
                        y3
                    ]
                ];
            }
            textAlign = isLabelInside ? "center" : labelAlignTo === "edge" ? nx > 0 ? "right" : "left" : nx > 0 ? "left" : "right";
        }
        var PI = Math.PI;
        var labelRotate = 0;
        var rotate = labelModel.get("rotate");
        if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(rotate)) labelRotate = rotate * (PI / 180);
        else if (labelPosition === "center") labelRotate = 0;
        else if (rotate === "radial" || rotate === true) {
            var radialAngle = nx < 0 ? -midAngle + PI : -midAngle;
            labelRotate = radialAngle;
        } else if (rotate === "tangential" && labelPosition !== "outside" && labelPosition !== "outer") {
            var rad = Math.atan2(nx, ny);
            if (rad < 0) rad = PI * 2 + rad;
            var isDown = ny > 0;
            if (isDown) rad = PI + rad;
            labelRotate = rad - PI;
        }
        hasLabelRotate = !!labelRotate;
        label.x = textX;
        label.y = textY;
        label.rotation = labelRotate;
        label.setStyle({
            verticalAlign: "middle"
        });
        // Not sectorShape the inside label
        if (!isLabelInside) {
            var textRect = label.getBoundingRect().clone();
            textRect.applyTransform(label.getComputedTransform());
            // Text has a default 1px stroke. Exclude this.
            var margin = (label.style.margin || 0) + 2.1;
            textRect.y -= margin / 2;
            textRect.height += margin;
            labelLayoutList.push({
                label: label,
                labelLine: labelLine,
                position: labelPosition,
                len: labelLineLen,
                len2: labelLineLen2,
                minTurnAngle: labelLineModel.get("minTurnAngle"),
                maxSurfaceAngle: labelLineModel.get("maxSurfaceAngle"),
                surfaceNormal: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(nx, ny),
                linePoints: linePoints,
                textAlign: textAlign,
                labelDistance: labelDistance,
                labelAlignTo: labelAlignTo,
                edgeDistance: edgeDistance,
                bleedMargin: bleedMargin,
                rect: textRect,
                unconstrainedWidth: textRect.width,
                labelStyleWidth: label.style.width
            });
        } else {
            label.setStyle({
                align: textAlign
            });
            var selectState = label.states.select;
            if (selectState) {
                selectState.x += label.x;
                selectState.y += label.y;
            }
        }
        sector.setTextConfig({
            inside: isLabelInside
        });
    });
    if (!hasLabelRotate && seriesModel.get("avoidLabelOverlap")) $4b109d23b790ee9a$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop);
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        var label = layout.label;
        var labelLine = layout.labelLine;
        var notShowLabel = isNaN(label.x) || isNaN(label.y);
        if (label) {
            label.setStyle({
                align: layout.textAlign
            });
            if (notShowLabel) {
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(label.states, setNotShow);
                label.ignore = true;
            }
            var selectState = label.states.select;
            if (selectState) {
                selectState.x += label.x;
                selectState.y += label.y;
            }
        }
        if (labelLine) {
            var linePoints = layout.linePoints;
            if (notShowLabel || !linePoints) {
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(labelLine.states, setNotShow);
                labelLine.ignore = true;
            } else {
                (0, $f4eb87a228be297f$export$ac52062003fbe6a)(linePoints, layout.minTurnAngle);
                (0, $f4eb87a228be297f$export$973e1fdb2708f71b)(linePoints, layout.surfaceNormal, layout.maxSurfaceAngle);
                labelLine.setShape({
                    points: linePoints
                });
                // Set the anchor to the midpoint of sector
                label.__hostTarget.textGuideLineConfig = {
                    anchor: new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(linePoints[0][0], linePoints[0][1])
                };
            }
        }
    }
}







/**
 * Piece of pie including Sector, Label, LabelLine
 */ var $773d25f97e67400e$var$PiePiece = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PiePiece, _super);
    function PiePiece(data, idx, startAngle) {
        var _this = _super.call(this) || this;
        _this.z2 = 2;
        var text = new $fe885cc21795562b$export$2e2bcd8739ae039();
        _this.setTextContent(text);
        _this.updateData(data, idx, startAngle, true);
        return _this;
    }
    PiePiece.prototype.updateData = function(data, idx, startAngle, firstCreate) {
        var sector = this;
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var emphasisModel = itemModel.getModel("emphasis");
        var layout = data.getItemLayout(idx);
        // cornerRadius & innerCornerRadius doesn't exist in the item layout. Use `0` if null value is specified.
        // see `setItemLayout` in `pieLayout.ts`.
        var sectorShape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel("itemStyle"), layout, true), layout);
        // Ignore NaN data.
        if (isNaN(sectorShape.startAngle)) {
            // Use NaN shape to avoid drawing shape.
            sector.setShape(sectorShape);
            return;
        }
        if (firstCreate) {
            sector.setShape(sectorShape);
            var animationType = seriesModel.getShallow("animationType");
            if (seriesModel.ecModel.ssr) {
                // Use scale animation in SSR mode(opacity?)
                // Because CSS SVG animation doesn't support very customized shape animation.
                $8b353638fbedfefa$export$a121566aadcfe021(sector, {
                    scaleX: 0,
                    scaleY: 0
                }, seriesModel, {
                    dataIndex: idx,
                    isFrom: true
                });
                sector.originX = sectorShape.cx;
                sector.originY = sectorShape.cy;
            } else if (animationType === "scale") {
                sector.shape.r = layout.r0;
                $8b353638fbedfefa$export$a121566aadcfe021(sector, {
                    shape: {
                        r: layout.r
                    }
                }, seriesModel, idx);
            } else if (startAngle != null) {
                sector.setShape({
                    startAngle: startAngle,
                    endAngle: startAngle
                });
                $8b353638fbedfefa$export$a121566aadcfe021(sector, {
                    shape: {
                        startAngle: layout.startAngle,
                        endAngle: layout.endAngle
                    }
                }, seriesModel, idx);
            } else {
                sector.shape.endAngle = layout.startAngle;
                $8b353638fbedfefa$export$c8dce3c08436e91e(sector, {
                    shape: {
                        endAngle: layout.endAngle
                    }
                }, seriesModel, idx);
            }
        } else {
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(sector);
            // Transition animation from the old shape
            $8b353638fbedfefa$export$c8dce3c08436e91e(sector, {
                shape: sectorShape
            }, seriesModel, idx);
        }
        sector.useStyle(data.getItemVisual(idx, "style"));
        (0, $2bf82c0980125b62$export$48b68047d330bbc9)(sector, itemModel);
        var midAngle = (layout.startAngle + layout.endAngle) / 2;
        var offset = seriesModel.get("selectedOffset");
        var dx = Math.cos(midAngle) * offset;
        var dy = Math.sin(midAngle) * offset;
        var cursorStyle = itemModel.getShallow("cursor");
        cursorStyle && sector.attr("cursor", cursorStyle);
        this._updateLabel(seriesModel, data, idx);
        sector.ensureState("emphasis").shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            r: layout.r + (emphasisModel.get("scale") ? emphasisModel.get("scaleSize") || 0 : 0)
        }, (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(emphasisModel.getModel("itemStyle"), layout));
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(sector.ensureState("select"), {
            x: dx,
            y: dy,
            shape: (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel([
                "select",
                "itemStyle"
            ]), layout)
        });
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(sector.ensureState("blur"), {
            shape: (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel([
                "blur",
                "itemStyle"
            ]), layout)
        });
        var labelLine = sector.getTextGuideLine();
        var labelText = sector.getTextContent();
        labelLine && (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(labelLine.ensureState("select"), {
            x: dx,
            y: dy
        });
        // TODO: needs dx, dy in zrender?
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(labelText.ensureState("select"), {
            x: dx,
            y: dy
        });
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    };
    PiePiece.prototype._updateLabel = function(seriesModel, data, idx) {
        var sector = this;
        var itemModel = data.getItemModel(idx);
        var labelLineModel = itemModel.getModel("labelLine");
        var style = data.getItemVisual(idx, "style");
        var visualColor = style && style.fill;
        var visualOpacity = style && style.opacity;
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(sector, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
            labelFetcher: data.hostModel,
            labelDataIndex: idx,
            inheritColor: visualColor,
            defaultOpacity: visualOpacity,
            defaultText: seriesModel.getFormattedLabel(idx, "normal") || data.getName(idx)
        });
        var labelText = sector.getTextContent();
        // Set textConfig on sector.
        sector.setTextConfig({
            // reset position, rotation
            position: null,
            rotation: null
        });
        // Make sure update style on labelText after setLabelStyle.
        // Because setLabelStyle will replace a new style on it.
        labelText.attr({
            z2: 10
        });
        var labelPosition = seriesModel.get([
            "label",
            "position"
        ]);
        if (labelPosition !== "outside" && labelPosition !== "outer") sector.removeTextGuideLine();
        else {
            var polyline = this.getTextGuideLine();
            if (!polyline) {
                polyline = new $d28119f30e6bb670$export$2e2bcd8739ae039();
                this.setTextGuideLine(polyline);
            }
            // Default use item visual color
            (0, $f4eb87a228be297f$export$c09e0b0574bdd2dc)(this, (0, $f4eb87a228be297f$export$2979fdbf5ebce521)(itemModel), {
                stroke: visualColor,
                opacity: (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(labelLineModel.get([
                    "lineStyle",
                    "opacity"
                ]), visualOpacity, 1)
            });
        }
    };
    return PiePiece;
}($a3e1dec0a3875b49$export$2e2bcd8739ae039);
// Pie view
var $773d25f97e67400e$var$PieView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PieView, _super);
    function PieView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ignoreLabelLineUpdate = true;
        return _this;
    }
    PieView.prototype.render = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        var startAngle;
        // First render
        if (!oldData && data.count() > 0) {
            var shape = data.getItemLayout(0);
            for(var s = 1; isNaN(shape && shape.startAngle) && s < data.count(); ++s)shape = data.getItemLayout(s);
            if (shape) startAngle = shape.startAngle;
        }
        // remove empty-circle if it exists
        if (this._emptyCircleSector) group.remove(this._emptyCircleSector);
        // when all data are filtered, show lightgray empty circle
        if (data.count() === 0 && seriesModel.get("showEmptyCircle")) {
            var sector = new $a3e1dec0a3875b49$export$2e2bcd8739ae039({
                shape: (0, $21576fcf4c669316$export$2a0d4d5b12383eb9)(seriesModel, api)
            });
            sector.useStyle(seriesModel.getModel("emptyCircleStyle").getItemStyle());
            this._emptyCircleSector = sector;
            group.add(sector);
        }
        data.diff(oldData).add(function(idx) {
            var piePiece = new $773d25f97e67400e$var$PiePiece(data, idx, startAngle);
            data.setItemGraphicEl(idx, piePiece);
            group.add(piePiece);
        }).update(function(newIdx, oldIdx) {
            var piePiece = oldData.getItemGraphicEl(oldIdx);
            piePiece.updateData(data, newIdx, startAngle);
            piePiece.off("click");
            group.add(piePiece);
            data.setItemGraphicEl(newIdx, piePiece);
        }).remove(function(idx) {
            var piePiece = oldData.getItemGraphicEl(idx);
            $8b353638fbedfefa$export$6d0fd725cb4aee8a(piePiece, seriesModel, idx);
        }).execute();
        (0, $4b109d23b790ee9a$export$2e2bcd8739ae039)(seriesModel);
        // Always use initial animation.
        if (seriesModel.get("animationTypeUpdate") !== "expansion") this._data = data;
    };
    PieView.prototype.dispose = function() {};
    PieView.prototype.containPoint = function(point, seriesModel) {
        var data = seriesModel.getData();
        var itemLayout = data.getItemLayout(0);
        if (itemLayout) {
            var dx = point[0] - itemLayout.cx;
            var dy = point[1] - itemLayout.cy;
            var radius = Math.sqrt(dx * dx + dy * dy);
            return radius <= itemLayout.r && radius >= itemLayout.r0;
        }
    };
    PieView.type = "pie";
    return PieView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $773d25f97e67400e$export$2e2bcd8739ae039 = $773d25f97e67400e$var$PieView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $9de67b16c98ecc62$var$innerData = $76d619f648247e6d$export$64df9f8d92ae083f();
var $9de67b16c98ecc62$var$PieSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PieSeriesModel, _super);
    function PieSeriesModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @overwrite
   */ PieSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)($7a1bd9c2710fea0d$export$2385a24977818dd0(this.getData, this), $7a1bd9c2710fea0d$export$2385a24977818dd0(this.getRawData, this));
        this._defaultLabelLine(option);
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.mergeOption = function() {
        _super.prototype.mergeOption.apply(this, arguments);
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.getInitialData = function() {
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            coordDimensions: [
                "value"
            ],
            encodeDefaulter: $7a1bd9c2710fea0d$export$c3095a23b368d1f2((0, $7dc6cdfd7450ef29$export$60b8a57d1f2fed26), this)
        });
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.getDataParams = function(dataIndex) {
        var data = this.getData();
        // update seats when data is changed
        var dataInner = $9de67b16c98ecc62$var$innerData(data);
        var seats = dataInner.seats;
        if (!seats) {
            var valueList_1 = [];
            data.each(data.mapDimension("value"), function(value) {
                valueList_1.push(value);
            });
            seats = dataInner.seats = (0, $cfc1f3b422a3185f$export$222dabb13d5320df)(valueList_1, data.hostModel.get("percentPrecision"));
        }
        var params = _super.prototype.getDataParams.call(this, dataIndex);
        // seats may be empty when sum is 0
        params.percent = seats[dataIndex] || 0;
        params.$vars.push("percent");
        return params;
    };
    PieSeriesModel.prototype._defaultLabelLine = function(option) {
        // Extend labelLine emphasis
        $76d619f648247e6d$export$abdcc6a26372f94b(option, "labelLine", [
            "show"
        ]);
        var labelLineNormalOpt = option.labelLine;
        var labelLineEmphasisOpt = option.emphasis.labelLine;
        // Not show label line if `label.normal.show = false`
        labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
        labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
    };
    PieSeriesModel.type = "series.pie";
    PieSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        colorBy: "data",
        // 默认全局居中
        center: [
            "50%",
            "50%"
        ],
        radius: [
            0,
            "75%"
        ],
        // 默认顺时针
        clockwise: true,
        startAngle: 90,
        endAngle: "auto",
        padAngle: 0,
        // 最小角度改为0
        minAngle: 0,
        // If the angle of a sector less than `minShowLabelAngle`,
        // the label will not be displayed.
        minShowLabelAngle: 0,
        // 选中时扇区偏移量
        selectedOffset: 10,
        // 选择模式，默认关闭，可选single，multiple
        // selectedMode: false,
        // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
        // roseType: null,
        percentPrecision: 2,
        // If still show when all data zero.
        stillShowZeroSum: true,
        // cursor: null,
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        width: null,
        height: null,
        label: {
            // color: 'inherit',
            // If rotate around circle
            rotate: 0,
            show: true,
            overflow: "truncate",
            // 'outer', 'inside', 'center'
            position: "outer",
            // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
            alignTo: "none",
            // Closest distance between label and chart edge.
            // Works only position is 'outer' and alignTo is 'edge'.
            edgeDistance: "25%",
            // Works only position is 'outer' and alignTo is not 'edge'.
            bleedMargin: 10,
            // Distance between text and label line.
            distanceToLabelLine: 5
        },
        // Enabled when label.normal.position is 'outer'
        labelLine: {
            show: true,
            // 引导线两段中的第一段长度
            length: 15,
            // 引导线两段中的第二段长度
            length2: 15,
            smooth: false,
            minTurnAngle: 90,
            maxSurfaceAngle: 90,
            lineStyle: {
                // color: 各异,
                width: 1,
                type: "solid"
            }
        },
        itemStyle: {
            borderWidth: 1,
            borderJoin: "round"
        },
        showEmptyCircle: true,
        emptyCircleStyle: {
            color: "lightgray",
            opacity: 1
        },
        labelLayout: {
            // Hide the overlapped label.
            hideOverlap: true
        },
        emphasis: {
            scale: true,
            scaleSize: 5
        },
        // If use strategy to avoid label overlapping
        avoidLabelOverlap: true,
        // Animation type. Valid values: expansion, scale
        animationType: "expansion",
        animationDuration: 1000,
        // Animation type when update. Valid values: transition, expansion
        animationTypeUpdate: "transition",
        animationEasingUpdate: "cubicInOut",
        animationDurationUpdate: 500,
        animationEasing: "cubicInOut"
    };
    return PieSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $9de67b16c98ecc62$export$2e2bcd8739ae039 = $9de67b16c98ecc62$var$PieSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $10dfc09d63e54240$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                // handle negative value condition
                var valueDim = data.mapDimension("value");
                var curValue = data.get(valueDim, idx);
                if ((0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(curValue) && !isNaN(curValue) && curValue < 0) return false;
                return true;
            });
        }
    };
}


function $6b7ead9b40180cba$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $773d25f97e67400e$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $9de67b16c98ecc62$export$2e2bcd8739ae039));
    (0, $e855ccf7eff48bce$export$62942ba95693dbfc)("pie", registers.registerAction);
    registers.registerLayout((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $21576fcf4c669316$export$2e2bcd8739ae039), "pie"));
    registers.registerProcessor((0, $e11a533bf70b759c$export$2e2bcd8739ae039)("pie"));
    registers.registerProcessor((0, $10dfc09d63e54240$export$2e2bcd8739ae039)("pie"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $bec68b02ebcf9063$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType("radar", function(seriesModel) {
        var data = seriesModel.getData();
        var points = [];
        var coordSys = seriesModel.coordinateSystem;
        if (!coordSys) return;
        var axes = coordSys.getIndicatorAxes();
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(axes, function(axis, axisIndex) {
            data.each(data.mapDimension(axes[axisIndex].dim), function(val, dataIndex) {
                points[dataIndex] = points[dataIndex] || [];
                var point = coordSys.dataToPoint(val, axisIndex);
                points[dataIndex][axisIndex] = $bec68b02ebcf9063$var$isValidPoint(point) ? point : $bec68b02ebcf9063$var$getValueMissingPoint(coordSys);
            });
        });
        // Close polygon
        data.each(function(idx) {
            // TODO
            // Is it appropriate to connect to the next data when some data is missing?
            // Or, should trade it like `connectNull` in line chart?
            var firstPoint = $7a1bd9c2710fea0d$export$71aa6c912b956294(points[idx], function(point) {
                return $bec68b02ebcf9063$var$isValidPoint(point);
            }) || $bec68b02ebcf9063$var$getValueMissingPoint(coordSys);
            // Copy the first actual point to the end of the array
            points[idx].push(firstPoint.slice());
            data.setItemLayout(idx, points[idx]);
        });
    });
}
function $bec68b02ebcf9063$var$isValidPoint(point) {
    return !isNaN(point[0]) && !isNaN(point[1]);
}
function $bec68b02ebcf9063$var$getValueMissingPoint(coordSys) {
    // It is error-prone to input [NaN, NaN] into polygon, polygon.
    // (probably cause problem when refreshing or animating)
    return [
        coordSys.cx,
        coordSys.cy
    ];
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck
// Backward compat for radar chart in 2

function $506480c8f28f74be$export$2e2bcd8739ae039(option) {
    var polarOptArr = option.polar;
    if (polarOptArr) {
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(polarOptArr)) polarOptArr = [
            polarOptArr
        ];
        var polarNotRadar_1 = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(polarOptArr, function(polarOpt, idx) {
            if (polarOpt.indicator) {
                if (polarOpt.type && !polarOpt.shape) polarOpt.shape = polarOpt.type;
                option.radar = option.radar || [];
                if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(option.radar)) option.radar = [
                    option.radar
                ];
                option.radar.push(polarOpt);
            } else polarNotRadar_1.push(polarOpt);
        });
        option.polar = polarNotRadar_1;
    }
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(option.series, function(seriesOpt) {
        if (seriesOpt && seriesOpt.type === "radar" && seriesOpt.polarIndex) seriesOpt.radarIndex = seriesOpt.polarIndex;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $1fc9e69f4602cced$var$RadarView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadarView, _super);
    function RadarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarView.type;
        return _this;
    }
    RadarView.prototype.render = function(seriesModel, ecModel, api) {
        var polar = seriesModel.coordinateSystem;
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        function createSymbol(data, idx) {
            var symbolType = data.getItemVisual(idx, "symbol") || "circle";
            if (symbolType === "none") return;
            var symbolSize = $5370466dadc978d7$export$a84524f03e8e8dfb(data.getItemVisual(idx, "symbolSize"));
            var symbolPath = $5370466dadc978d7$export$af050e04da3a02e8(symbolType, -1, -1, 2, 2);
            var symbolRotate = data.getItemVisual(idx, "symbolRotate") || 0;
            symbolPath.attr({
                style: {
                    strokeNoScale: true
                },
                z2: 100,
                scaleX: symbolSize[0] / 2,
                scaleY: symbolSize[1] / 2,
                rotation: symbolRotate * Math.PI / 180 || 0
            });
            return symbolPath;
        }
        function updateSymbols(oldPoints, newPoints, symbolGroup, data, idx, isInit) {
            // Simply rerender all
            symbolGroup.removeAll();
            for(var i = 0; i < newPoints.length - 1; i++){
                var symbolPath = createSymbol(data, idx);
                if (symbolPath) {
                    symbolPath.__dimIdx = i;
                    if (oldPoints[i]) {
                        symbolPath.setPosition(oldPoints[i]);
                        $5b455ae6f843ac47$exports[isInit ? "initProps" : "updateProps"](symbolPath, {
                            x: newPoints[i][0],
                            y: newPoints[i][1]
                        }, seriesModel, idx);
                    } else symbolPath.setPosition(newPoints[i]);
                    symbolGroup.add(symbolPath);
                }
            }
        }
        function getInitialPoints(points) {
            return $7a1bd9c2710fea0d$export$871de8747c9eaa88(points, function(pt) {
                return [
                    polar.cx,
                    polar.cy
                ];
            });
        }
        data.diff(oldData).add(function(idx) {
            var points = data.getItemLayout(idx);
            if (!points) return;
            var polygon = new $5b455ae6f843ac47$exports.Polygon();
            var polyline = new $5b455ae6f843ac47$exports.Polyline();
            var target = {
                shape: {
                    points: points
                }
            };
            polygon.shape.points = getInitialPoints(points);
            polyline.shape.points = getInitialPoints(points);
            $5b455ae6f843ac47$exports.initProps(polygon, target, seriesModel, idx);
            $5b455ae6f843ac47$exports.initProps(polyline, target, seriesModel, idx);
            var itemGroup = new $5b455ae6f843ac47$exports.Group();
            var symbolGroup = new $5b455ae6f843ac47$exports.Group();
            itemGroup.add(polyline);
            itemGroup.add(polygon);
            itemGroup.add(symbolGroup);
            updateSymbols(polyline.shape.points, points, symbolGroup, data, idx, true);
            data.setItemGraphicEl(idx, itemGroup);
        }).update(function(newIdx, oldIdx) {
            var itemGroup = oldData.getItemGraphicEl(oldIdx);
            var polyline = itemGroup.childAt(0);
            var polygon = itemGroup.childAt(1);
            var symbolGroup = itemGroup.childAt(2);
            var target = {
                shape: {
                    points: data.getItemLayout(newIdx)
                }
            };
            if (!target.shape.points) return;
            updateSymbols(polyline.shape.points, target.shape.points, symbolGroup, data, newIdx, false);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(polygon);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(polyline);
            $5b455ae6f843ac47$exports.updateProps(polyline, target, seriesModel);
            $5b455ae6f843ac47$exports.updateProps(polygon, target, seriesModel);
            data.setItemGraphicEl(newIdx, itemGroup);
        }).remove(function(idx) {
            group.remove(oldData.getItemGraphicEl(idx));
        }).execute();
        data.eachItemGraphicEl(function(itemGroup, idx) {
            var itemModel = data.getItemModel(idx);
            var polyline = itemGroup.childAt(0);
            var polygon = itemGroup.childAt(1);
            var symbolGroup = itemGroup.childAt(2);
            // Radar uses the visual encoded from itemStyle.
            var itemStyle = data.getItemVisual(idx, "style");
            var color = itemStyle.fill;
            group.add(itemGroup);
            polyline.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e(itemModel.getModel("lineStyle").getLineStyle(), {
                fill: "none",
                stroke: color
            }));
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polyline, itemModel, "lineStyle");
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, itemModel, "areaStyle");
            var areaStyleModel = itemModel.getModel("areaStyle");
            var polygonIgnore = areaStyleModel.isEmpty() && areaStyleModel.parentModel.isEmpty();
            polygon.ignore = polygonIgnore;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43([
                "emphasis",
                "select",
                "blur"
            ], function(stateName) {
                var stateModel = itemModel.getModel([
                    stateName,
                    "areaStyle"
                ]);
                var stateIgnore = stateModel.isEmpty() && stateModel.parentModel.isEmpty();
                // Won't be ignore if normal state is not ignore.
                polygon.ensureState(stateName).ignore = stateIgnore && polygonIgnore;
            });
            polygon.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e(areaStyleModel.getAreaStyle(), {
                fill: color,
                opacity: 0.7,
                decal: itemStyle.decal
            }));
            var emphasisModel = itemModel.getModel("emphasis");
            var itemHoverStyle = emphasisModel.getModel("itemStyle").getItemStyle();
            symbolGroup.eachChild(function(symbolPath) {
                if (symbolPath instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
                    var pathStyle = symbolPath.style;
                    symbolPath.useStyle($7a1bd9c2710fea0d$export$8b58be045bf06082({
                        // TODO other properties like x, y ?
                        image: pathStyle.image,
                        x: pathStyle.x,
                        y: pathStyle.y,
                        width: pathStyle.width,
                        height: pathStyle.height
                    }, itemStyle));
                } else {
                    symbolPath.useStyle(itemStyle);
                    symbolPath.setColor(color);
                    symbolPath.style.strokeNoScale = true;
                }
                var pathEmphasisState = symbolPath.ensureState("emphasis");
                pathEmphasisState.style = $7a1bd9c2710fea0d$export$9cd59f9826255e47(itemHoverStyle);
                var defaultText = data.getStore().get(data.getDimensionIndex(symbolPath.__dimIdx), idx);
                (defaultText == null || isNaN(defaultText)) && (defaultText = "");
                (0, $6800dfcb6e1e2a44$export$9a13992917966657)(symbolPath, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
                    labelFetcher: data.hostModel,
                    labelDataIndex: idx,
                    labelDimIndex: symbolPath.__dimIdx,
                    defaultText: defaultText,
                    inheritColor: color,
                    defaultOpacity: itemStyle.opacity
                });
            });
            (0, $2bf82c0980125b62$export$e51187539ff11209)(itemGroup, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
        });
        this._data = data;
    };
    RadarView.prototype.remove = function() {
        this.group.removeAll();
        this._data = null;
    };
    RadarView.type = "radar";
    return RadarView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $1fc9e69f4602cced$export$2e2bcd8739ae039 = $1fc9e69f4602cced$var$RadarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $3895e6b103877b59$var$RadarSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadarSeriesModel, _super);
    function RadarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    // Overwrite
    RadarSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)($7a1bd9c2710fea0d$export$2385a24977818dd0(this.getData, this), $7a1bd9c2710fea0d$export$2385a24977818dd0(this.getRawData, this));
    };
    RadarSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $7e5c3511527c9907$export$2e2bcd8739ae039)(this, {
            generateCoord: "indicator_",
            generateCoordCount: Infinity
        });
    };
    RadarSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var coordSys = this.coordinateSystem;
        var indicatorAxes = coordSys.getIndicatorAxes();
        var name = this.getData().getName(dataIndex);
        var nameToDisplay = name === "" ? this.name : name;
        var markerColor = (0, $d5ab84c08d6657ec$export$ea15628039c0fa93)(this, dataIndex);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("section", {
            header: nameToDisplay,
            sortBlocks: true,
            blocks: $7a1bd9c2710fea0d$export$871de8747c9eaa88(indicatorAxes, function(axis) {
                var val = data.get(data.mapDimension(axis.dim), dataIndex);
                return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                    markerType: "subItem",
                    markerColor: markerColor,
                    name: axis.name,
                    value: val,
                    sortParam: val
                });
            })
        });
    };
    RadarSeriesModel.prototype.getTooltipPosition = function(dataIndex) {
        if (dataIndex != null) {
            var data_1 = this.getData();
            var coordSys = this.coordinateSystem;
            var values = data_1.getValues($7a1bd9c2710fea0d$export$871de8747c9eaa88(coordSys.dimensions, function(dim) {
                return data_1.mapDimension(dim);
            }), dataIndex);
            for(var i = 0, len = values.length; i < len; i++)if (!isNaN(values[i])) {
                var indicatorAxes = coordSys.getIndicatorAxes();
                return coordSys.coordToPoint(indicatorAxes[i].dataToCoord(values[i]), i);
            }
        }
    };
    RadarSeriesModel.type = "series.radar";
    RadarSeriesModel.dependencies = [
        "radar"
    ];
    RadarSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        colorBy: "data",
        coordinateSystem: "radar",
        legendHoverLink: true,
        radarIndex: 0,
        lineStyle: {
            width: 2,
            type: "solid",
            join: "round"
        },
        label: {
            position: "top"
        },
        // areaStyle: {
        // },
        // itemStyle: {}
        symbolSize: 8
    };
    return RadarSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $3895e6b103877b59$export$2e2bcd8739ae039 = $3895e6b103877b59$var$RadarSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $19c8b0d3f7411edb$var$valueAxisDefault = (0, $ad861b9162f24222$export$2e2bcd8739ae039).value;
function $19c8b0d3f7411edb$var$defaultsShow(opt, show) {
    return $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
        show: show
    }, opt);
}
var $19c8b0d3f7411edb$var$RadarModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadarModel, _super);
    function RadarModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarModel.type;
        return _this;
    }
    RadarModel.prototype.optionUpdated = function() {
        var boundaryGap = this.get("boundaryGap");
        var splitNumber = this.get("splitNumber");
        var scale = this.get("scale");
        var axisLine = this.get("axisLine");
        var axisTick = this.get("axisTick");
        // let axisType = this.get('axisType');
        var axisLabel = this.get("axisLabel");
        var nameTextStyle = this.get("axisName");
        var showName = this.get([
            "axisName",
            "show"
        ]);
        var nameFormatter = this.get([
            "axisName",
            "formatter"
        ]);
        var nameGap = this.get("axisNameGap");
        var triggerEvent = this.get("triggerEvent");
        var indicatorModels = $7a1bd9c2710fea0d$export$871de8747c9eaa88(this.get("indicator") || [], function(indicatorOpt) {
            // PENDING
            if (indicatorOpt.max != null && indicatorOpt.max > 0 && !indicatorOpt.min) indicatorOpt.min = 0;
            else if (indicatorOpt.min != null && indicatorOpt.min < 0 && !indicatorOpt.max) indicatorOpt.max = 0;
            var iNameTextStyle = nameTextStyle;
            if (indicatorOpt.color != null) iNameTextStyle = $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                color: indicatorOpt.color
            }, nameTextStyle);
            // Use same configuration
            var innerIndicatorOpt = $7a1bd9c2710fea0d$export$4950aa0f605343fb($7a1bd9c2710fea0d$export$9cd59f9826255e47(indicatorOpt), {
                boundaryGap: boundaryGap,
                splitNumber: splitNumber,
                scale: scale,
                axisLine: axisLine,
                axisTick: axisTick,
                // axisType: axisType,
                axisLabel: axisLabel,
                // Compatible with 2 and use text
                name: indicatorOpt.text,
                showName: showName,
                nameLocation: "end",
                nameGap: nameGap,
                // min: 0,
                nameTextStyle: iNameTextStyle,
                triggerEvent: triggerEvent
            }, false);
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(nameFormatter)) {
                var indName = innerIndicatorOpt.name;
                innerIndicatorOpt.name = nameFormatter.replace("{value}", indName != null ? indName : "");
            } else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(nameFormatter)) innerIndicatorOpt.name = nameFormatter(innerIndicatorOpt.name, innerIndicatorOpt);
            var model = new (0, $6818646a97528290$export$2e2bcd8739ae039)(innerIndicatorOpt, null, this.ecModel);
            $7a1bd9c2710fea0d$export$e36fc9d62a853069(model, (0, $3449fd4c0590d99e$export$5c54b224726edb5a).prototype);
            // For triggerEvent.
            model.mainType = "radar";
            model.componentIndex = this.componentIndex;
            return model;
        }, this);
        this._indicatorModels = indicatorModels;
    };
    RadarModel.prototype.getIndicatorModels = function() {
        return this._indicatorModels;
    };
    RadarModel.type = "radar";
    RadarModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        center: [
            "50%",
            "50%"
        ],
        radius: "75%",
        startAngle: 90,
        axisName: {
            show: true
        },
        boundaryGap: [
            0,
            0
        ],
        splitNumber: 5,
        axisNameGap: 15,
        scale: false,
        // Polygon or circle
        shape: "polygon",
        axisLine: $7a1bd9c2710fea0d$export$4950aa0f605343fb({
            lineStyle: {
                color: "#bbb"
            }
        }, $19c8b0d3f7411edb$var$valueAxisDefault.axisLine),
        axisLabel: $19c8b0d3f7411edb$var$defaultsShow($19c8b0d3f7411edb$var$valueAxisDefault.axisLabel, false),
        axisTick: $19c8b0d3f7411edb$var$defaultsShow($19c8b0d3f7411edb$var$valueAxisDefault.axisTick, false),
        // axisType: 'value',
        splitLine: $19c8b0d3f7411edb$var$defaultsShow($19c8b0d3f7411edb$var$valueAxisDefault.splitLine, true),
        splitArea: $19c8b0d3f7411edb$var$defaultsShow($19c8b0d3f7411edb$var$valueAxisDefault.splitArea, true),
        // {text, min, max}
        indicator: []
    };
    return RadarModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $19c8b0d3f7411edb$export$2e2bcd8739ae039 = $19c8b0d3f7411edb$var$RadarModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $9604af4c260571a1$var$axisBuilderAttrs = [
    "axisLine",
    "axisTickLabel",
    "axisName"
];
var $9604af4c260571a1$var$RadarView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadarView, _super);
    function RadarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarView.type;
        return _this;
    }
    RadarView.prototype.render = function(radarModel, ecModel, api) {
        var group = this.group;
        group.removeAll();
        this._buildAxes(radarModel);
        this._buildSplitLineAndArea(radarModel);
    };
    RadarView.prototype._buildAxes = function(radarModel) {
        var radar = radarModel.coordinateSystem;
        var indicatorAxes = radar.getIndicatorAxes();
        var axisBuilders = $7a1bd9c2710fea0d$export$871de8747c9eaa88(indicatorAxes, function(indicatorAxis) {
            var axisName = indicatorAxis.model.get("showName") ? indicatorAxis.name : ""; // hide name
            var axisBuilder = new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(indicatorAxis.model, {
                axisName: axisName,
                position: [
                    radar.cx,
                    radar.cy
                ],
                rotation: indicatorAxis.angle,
                labelDirection: -1,
                tickDirection: -1,
                nameDirection: 1
            });
            return axisBuilder;
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(axisBuilders, function(axisBuilder) {
            $7a1bd9c2710fea0d$export$79b2f7037acddd43($9604af4c260571a1$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
            this.group.add(axisBuilder.getGroup());
        }, this);
    };
    RadarView.prototype._buildSplitLineAndArea = function(radarModel) {
        var radar = radarModel.coordinateSystem;
        var indicatorAxes = radar.getIndicatorAxes();
        if (!indicatorAxes.length) return;
        var shape = radarModel.get("shape");
        var splitLineModel = radarModel.getModel("splitLine");
        var splitAreaModel = radarModel.getModel("splitArea");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var areaStyleModel = splitAreaModel.getModel("areaStyle");
        var showSplitLine = splitLineModel.get("show");
        var showSplitArea = splitAreaModel.get("show");
        var splitLineColors = lineStyleModel.get("color");
        var splitAreaColors = areaStyleModel.get("color");
        var splitLineColorsArr = $7a1bd9c2710fea0d$export$43bee75e5e14138e(splitLineColors) ? splitLineColors : [
            splitLineColors
        ];
        var splitAreaColorsArr = $7a1bd9c2710fea0d$export$43bee75e5e14138e(splitAreaColors) ? splitAreaColors : [
            splitAreaColors
        ];
        var splitLines = [];
        var splitAreas = [];
        function getColorIndex(areaOrLine, areaOrLineColorList, idx) {
            var colorIndex = idx % areaOrLineColorList.length;
            areaOrLine[colorIndex] = areaOrLine[colorIndex] || [];
            return colorIndex;
        }
        if (shape === "circle") {
            var ticksRadius = indicatorAxes[0].getTicksCoords();
            var cx = radar.cx;
            var cy = radar.cy;
            for(var i = 0; i < ticksRadius.length; i++){
                if (showSplitLine) {
                    var colorIndex = getColorIndex(splitLines, splitLineColorsArr, i);
                    splitLines[colorIndex].push(new $1e68d8727773abb7$export$2e2bcd8739ae039({
                        shape: {
                            cx: cx,
                            cy: cy,
                            r: ticksRadius[i].coord
                        }
                    }));
                }
                if (showSplitArea && i < ticksRadius.length - 1) {
                    var colorIndex = getColorIndex(splitAreas, splitAreaColorsArr, i);
                    splitAreas[colorIndex].push(new $9da0cbfd3f86fdc1$export$2e2bcd8739ae039({
                        shape: {
                            cx: cx,
                            cy: cy,
                            r0: ticksRadius[i].coord,
                            r: ticksRadius[i + 1].coord
                        }
                    }));
                }
            }
        } else {
            var realSplitNumber_1;
            var axesTicksPoints = $7a1bd9c2710fea0d$export$871de8747c9eaa88(indicatorAxes, function(indicatorAxis, idx) {
                var ticksCoords = indicatorAxis.getTicksCoords();
                realSplitNumber_1 = realSplitNumber_1 == null ? ticksCoords.length - 1 : Math.min(ticksCoords.length - 1, realSplitNumber_1);
                return $7a1bd9c2710fea0d$export$871de8747c9eaa88(ticksCoords, function(tickCoord) {
                    return radar.coordToPoint(tickCoord.coord, idx);
                });
            });
            var prevPoints = [];
            for(var i = 0; i <= realSplitNumber_1; i++){
                var points = [];
                for(var j = 0; j < indicatorAxes.length; j++)points.push(axesTicksPoints[j][i]);
                // Close
                if (points[0]) points.push(points[0].slice());
                if (showSplitLine) {
                    var colorIndex = getColorIndex(splitLines, splitLineColorsArr, i);
                    splitLines[colorIndex].push(new $d28119f30e6bb670$export$2e2bcd8739ae039({
                        shape: {
                            points: points
                        }
                    }));
                }
                if (showSplitArea && prevPoints) {
                    var colorIndex = getColorIndex(splitAreas, splitAreaColorsArr, i - 1);
                    splitAreas[colorIndex].push(new $51acf033123e1a30$export$2e2bcd8739ae039({
                        shape: {
                            points: points.concat(prevPoints)
                        }
                    }));
                }
                prevPoints = points.slice().reverse();
            }
        }
        var lineStyle = lineStyleModel.getLineStyle();
        var areaStyle = areaStyleModel.getAreaStyle();
        // Add splitArea before splitLine
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(splitAreas, function(splitAreas, idx) {
            this.group.add($5b455ae6f843ac47$export$7b1dd269fbc4e903(splitAreas, {
                style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                    stroke: "none",
                    fill: splitAreaColorsArr[idx % splitAreaColorsArr.length]
                }, areaStyle),
                silent: true
            }));
        }, this);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(splitLines, function(splitLines, idx) {
            this.group.add($5b455ae6f843ac47$export$7b1dd269fbc4e903(splitLines, {
                style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                    fill: "none",
                    stroke: splitLineColorsArr[idx % splitLineColorsArr.length]
                }, lineStyle),
                silent: true
            }));
        }, this);
    };
    RadarView.type = "radar";
    return RadarView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $9604af4c260571a1$export$2e2bcd8739ae039 = $9604af4c260571a1$var$RadarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO clockwise
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $5d6acabddf826472$var$IndicatorAxis = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(IndicatorAxis, _super);
    function IndicatorAxis(dim, scale, radiusExtent) {
        var _this = _super.call(this, dim, scale, radiusExtent) || this;
        _this.type = "value";
        _this.angle = 0;
        _this.name = "";
        return _this;
    }
    return IndicatorAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $5d6acabddf826472$export$2e2bcd8739ae039 = $5d6acabddf826472$var$IndicatorAxis;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $0591b52263f31374$var$mathLog = Math.log;
function $0591b52263f31374$export$c0b3be0e9eb0c2d9(scale, axisModel, alignToScale) {
    var intervalScaleProto = (0, $dddb89ade16db3d5$export$2e2bcd8739ae039).prototype;
    // NOTE: There is a precondition for log scale  here:
    // In log scale we store _interval and _extent of exponent value.
    // So if we use the method of InternalScale to set/get these data.
    // It process the exponent value, which is linear and what we want here.
    var alignToTicks = intervalScaleProto.getTicks.call(alignToScale);
    var alignToNicedTicks = intervalScaleProto.getTicks.call(alignToScale, true);
    var alignToSplitNumber = alignToTicks.length - 1;
    var alignToInterval = intervalScaleProto.getInterval.call(alignToScale);
    var scaleExtent = (0, $2d646e51cc34f840$export$9c0ba8df7eb7b328)(scale, axisModel);
    var rawExtent = scaleExtent.extent;
    var isMinFixed = scaleExtent.fixMin;
    var isMaxFixed = scaleExtent.fixMax;
    if (scale.type === "log") {
        var logBase = $0591b52263f31374$var$mathLog(scale.base);
        rawExtent = [
            $0591b52263f31374$var$mathLog(rawExtent[0]) / logBase,
            $0591b52263f31374$var$mathLog(rawExtent[1]) / logBase
        ];
    }
    scale.setExtent(rawExtent[0], rawExtent[1]);
    scale.calcNiceExtent({
        splitNumber: alignToSplitNumber,
        fixMin: isMinFixed,
        fixMax: isMaxFixed
    });
    var extent = intervalScaleProto.getExtent.call(scale);
    // Need to update the rawExtent.
    // Because value in rawExtent may be not parsed. e.g. 'dataMin', 'dataMax'
    if (isMinFixed) rawExtent[0] = extent[0];
    if (isMaxFixed) rawExtent[1] = extent[1];
    var interval = intervalScaleProto.getInterval.call(scale);
    var min = rawExtent[0];
    var max = rawExtent[1];
    if (isMinFixed && isMaxFixed) // User set min, max, divide to get new interval
    interval = (max - min) / alignToSplitNumber;
    else if (isMinFixed) {
        max = rawExtent[0] + interval * alignToSplitNumber;
        // User set min, expand extent on the other side
        while(max < rawExtent[1] && isFinite(max) && isFinite(rawExtent[1])){
            interval = (0, $60f7f1f3e3996637$export$f39031e8422f329d)(interval);
            max = rawExtent[0] + interval * alignToSplitNumber;
        }
    } else if (isMaxFixed) {
        // User set max, expand extent on the other side
        min = rawExtent[1] - interval * alignToSplitNumber;
        while(min > rawExtent[0] && isFinite(min) && isFinite(rawExtent[0])){
            interval = (0, $60f7f1f3e3996637$export$f39031e8422f329d)(interval);
            min = rawExtent[1] - interval * alignToSplitNumber;
        }
    } else {
        var nicedSplitNumber = scale.getTicks().length - 1;
        if (nicedSplitNumber > alignToSplitNumber) interval = (0, $60f7f1f3e3996637$export$f39031e8422f329d)(interval);
        var range = interval * alignToSplitNumber;
        max = Math.ceil(rawExtent[1] / interval) * interval;
        min = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(max - range);
        // Not change the result that crossing zero.
        if (min < 0 && rawExtent[0] >= 0) {
            min = 0;
            max = (0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(range);
        } else if (max > 0 && rawExtent[1] <= 0) {
            max = 0;
            min = -(0, $cfc1f3b422a3185f$export$2077e0241d6afd3c)(range);
        }
    }
    // Adjust min, max based on the extent of alignTo. When min or max is set in alignTo scale
    var t0 = (alignToTicks[0].value - alignToNicedTicks[0].value) / alignToInterval;
    var t1 = (alignToTicks[alignToSplitNumber].value - alignToNicedTicks[alignToSplitNumber].value) / alignToInterval;
    // NOTE: Must in setExtent -> setInterval -> setNiceExtent order.
    intervalScaleProto.setExtent.call(scale, min + interval * t0, max + interval * t1);
    intervalScaleProto.setInterval.call(scale, interval);
    if (t0 || t1) intervalScaleProto.setNiceExtent.call(scale, min + interval, max - interval);
    var ticks;
}


var $11c0ac35da5ff3e8$var$Radar = /** @class */ function() {
    function Radar(radarModel, ecModel, api) {
        /**
     *
     * Radar dimensions
     */ this.dimensions = [];
        this._model = radarModel;
        this._indicatorAxes = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(radarModel.getIndicatorModels(), function(indicatorModel, idx) {
            var dim = "indicator_" + idx;
            var indicatorAxis = new (0, $5d6acabddf826472$export$2e2bcd8739ae039)(dim, new (0, $dddb89ade16db3d5$export$2e2bcd8739ae039)());
            indicatorAxis.name = indicatorModel.get("name");
            // Inject model and axis
            indicatorAxis.model = indicatorModel;
            indicatorModel.axis = indicatorAxis;
            this.dimensions.push(dim);
            return indicatorAxis;
        }, this);
        this.resize(radarModel, api);
    }
    Radar.prototype.getIndicatorAxes = function() {
        return this._indicatorAxes;
    };
    Radar.prototype.dataToPoint = function(value, indicatorIndex) {
        var indicatorAxis = this._indicatorAxes[indicatorIndex];
        return this.coordToPoint(indicatorAxis.dataToCoord(value), indicatorIndex);
    };
    // TODO: API should be coordToPoint([coord, indicatorIndex])
    Radar.prototype.coordToPoint = function(coord, indicatorIndex) {
        var indicatorAxis = this._indicatorAxes[indicatorIndex];
        var angle = indicatorAxis.angle;
        var x = this.cx + coord * Math.cos(angle);
        var y = this.cy - coord * Math.sin(angle);
        return [
            x,
            y
        ];
    };
    Radar.prototype.pointToData = function(pt) {
        var dx = pt[0] - this.cx;
        var dy = pt[1] - this.cy;
        var radius = Math.sqrt(dx * dx + dy * dy);
        dx /= radius;
        dy /= radius;
        var radian = Math.atan2(-dy, dx);
        // Find the closest angle
        // FIXME index can calculated directly
        var minRadianDiff = Infinity;
        var closestAxis;
        var closestAxisIdx = -1;
        for(var i = 0; i < this._indicatorAxes.length; i++){
            var indicatorAxis = this._indicatorAxes[i];
            var diff = Math.abs(radian - indicatorAxis.angle);
            if (diff < minRadianDiff) {
                closestAxis = indicatorAxis;
                closestAxisIdx = i;
                minRadianDiff = diff;
            }
        }
        return [
            closestAxisIdx,
            +(closestAxis && closestAxis.coordToData(radius))
        ];
    };
    Radar.prototype.resize = function(radarModel, api) {
        var center = radarModel.get("center");
        var viewWidth = api.getWidth();
        var viewHeight = api.getHeight();
        var viewSize = Math.min(viewWidth, viewHeight) / 2;
        this.cx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(center[0], viewWidth);
        this.cy = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(center[1], viewHeight);
        this.startAngle = radarModel.get("startAngle") * Math.PI / 180;
        // radius may be single value like `20`, `'80%'`, or array like `[10, '80%']`
        var radius = radarModel.get("radius");
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(radius) || (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(radius)) radius = [
            0,
            radius
        ];
        this.r0 = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(radius[0], viewSize);
        this.r = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(radius[1], viewSize);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._indicatorAxes, function(indicatorAxis, idx) {
            indicatorAxis.setExtent(this.r0, this.r);
            var angle = this.startAngle + idx * Math.PI * 2 / this._indicatorAxes.length;
            // Normalize to [-PI, PI]
            angle = Math.atan2(Math.sin(angle), Math.cos(angle));
            indicatorAxis.angle = angle;
        }, this);
    };
    Radar.prototype.update = function(ecModel, api) {
        var indicatorAxes = this._indicatorAxes;
        var radarModel = this._model;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(indicatorAxes, function(indicatorAxis) {
            indicatorAxis.scale.setExtent(Infinity, -Infinity);
        });
        ecModel.eachSeriesByType("radar", function(radarSeries, idx) {
            if (radarSeries.get("coordinateSystem") !== "radar" || ecModel.getComponent("radar", radarSeries.get("radarIndex")) !== radarModel) return;
            var data = radarSeries.getData();
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(indicatorAxes, function(indicatorAxis) {
                indicatorAxis.scale.unionExtentFromData(data, data.mapDimension(indicatorAxis.dim));
            });
        }, this);
        var splitNumber = radarModel.get("splitNumber");
        var dummyScale = new (0, $dddb89ade16db3d5$export$2e2bcd8739ae039)();
        dummyScale.setExtent(0, splitNumber);
        dummyScale.setInterval(1);
        // Force all the axis fixing the maxSplitNumber.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(indicatorAxes, function(indicatorAxis, idx) {
            (0, $0591b52263f31374$export$c0b3be0e9eb0c2d9)(indicatorAxis.scale, indicatorAxis.model, dummyScale);
        });
    };
    Radar.prototype.convertToPixel = function(ecModel, finder, value) {
        console.warn("Not implemented.");
        return null;
    };
    Radar.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        console.warn("Not implemented.");
        return null;
    };
    Radar.prototype.containPoint = function(point) {
        console.warn("Not implemented.");
        return false;
    };
    Radar.create = function(ecModel, api) {
        var radarList = [];
        ecModel.eachComponent("radar", function(radarModel) {
            var radar = new Radar(radarModel, ecModel, api);
            radarList.push(radar);
            radarModel.coordinateSystem = radar;
        });
        ecModel.eachSeriesByType("radar", function(radarSeries) {
            if (radarSeries.get("coordinateSystem") === "radar") // Inject coordinate system
            // @ts-ignore
            radarSeries.coordinateSystem = radarList[radarSeries.get("radarIndex") || 0];
        });
        return radarList;
    };
    /**
   * Radar dimensions is based on the data
   */ Radar.dimensions = [];
    return Radar;
}();
var $11c0ac35da5ff3e8$export$2e2bcd8739ae039 = $11c0ac35da5ff3e8$var$Radar;


function $82e3ee94e7369a99$export$4b3e715f166fdd78(registers) {
    registers.registerCoordinateSystem("radar", (0, $11c0ac35da5ff3e8$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $19c8b0d3f7411edb$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $9604af4c260571a1$export$2e2bcd8739ae039));
    registers.registerVisual({
        seriesType: "radar",
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            // itemVisual symbol is for selected data
            data.each(function(idx) {
                data.setItemVisual(idx, "legendIcon", "roundRect");
            });
            // visual is for unselected data
            data.setVisual("legendIcon", "roundRect");
        }
    });
}


function $a8120efef8bcaaa0$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $82e3ee94e7369a99$export$4b3e715f166fdd78));
    registers.registerChartView((0, $1fc9e69f4602cced$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $3895e6b103877b59$export$2e2bcd8739ae039));
    registers.registerLayout((0, $bec68b02ebcf9063$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $e11a533bf70b759c$export$2e2bcd8739ae039)("radar"));
    registers.registerPreprocessor((0, $506480c8f28f74be$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $58364a2c82b0ec77$var$SankeyPathShape = /** @class */ function() {
    function SankeyPathShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.cpx2 = 0;
        this.cpy2 = 0;
        this.extent = 0;
    }
    return SankeyPathShape;
}();
var $58364a2c82b0ec77$var$SankeyPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SankeyPath, _super);
    function SankeyPath(opts) {
        return _super.call(this, opts) || this;
    }
    SankeyPath.prototype.getDefaultShape = function() {
        return new $58364a2c82b0ec77$var$SankeyPathShape();
    };
    SankeyPath.prototype.buildPath = function(ctx, shape) {
        var extent = shape.extent;
        ctx.moveTo(shape.x1, shape.y1);
        ctx.bezierCurveTo(shape.cpx1, shape.cpy1, shape.cpx2, shape.cpy2, shape.x2, shape.y2);
        if (shape.orient === "vertical") {
            ctx.lineTo(shape.x2 + extent, shape.y2);
            ctx.bezierCurveTo(shape.cpx2 + extent, shape.cpy2, shape.cpx1 + extent, shape.cpy1, shape.x1 + extent, shape.y1);
        } else {
            ctx.lineTo(shape.x2, shape.y2 + extent);
            ctx.bezierCurveTo(shape.cpx2, shape.cpy2 + extent, shape.cpx1, shape.cpy1 + extent, shape.x1, shape.y1 + extent);
        }
        ctx.closePath();
    };
    SankeyPath.prototype.highlight = function() {
        (0, $2bf82c0980125b62$export$b2d02638cc34c042)(this);
    };
    SankeyPath.prototype.downplay = function() {
        (0, $2bf82c0980125b62$export$11be6f716239ac55)(this);
    };
    return SankeyPath;
}($b02ffe7acd508c08$export$2e2bcd8739ae039);
var $58364a2c82b0ec77$var$SankeyView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SankeyView, _super);
    function SankeyView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SankeyView.type;
        _this._focusAdjacencyDisabled = false;
        return _this;
    }
    SankeyView.prototype.render = function(seriesModel, ecModel, api) {
        var sankeyView = this;
        var graph = seriesModel.getGraph();
        var group = this.group;
        var layoutInfo = seriesModel.layoutInfo;
        // view width
        var width = layoutInfo.width;
        // view height
        var height = layoutInfo.height;
        var nodeData = seriesModel.getData();
        var edgeData = seriesModel.getData("edge");
        var orient = seriesModel.get("orient");
        this._model = seriesModel;
        group.removeAll();
        group.x = layoutInfo.x;
        group.y = layoutInfo.y;
        // generate a bezire Curve for each edge
        graph.eachEdge(function(edge) {
            var curve = new $58364a2c82b0ec77$var$SankeyPath();
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(curve);
            ecData.dataIndex = edge.dataIndex;
            ecData.seriesIndex = seriesModel.seriesIndex;
            ecData.dataType = "edge";
            var edgeModel = edge.getModel();
            var lineStyleModel = edgeModel.getModel("lineStyle");
            var curvature = lineStyleModel.get("curveness");
            var n1Layout = edge.node1.getLayout();
            var node1Model = edge.node1.getModel();
            var dragX1 = node1Model.get("localX");
            var dragY1 = node1Model.get("localY");
            var n2Layout = edge.node2.getLayout();
            var node2Model = edge.node2.getModel();
            var dragX2 = node2Model.get("localX");
            var dragY2 = node2Model.get("localY");
            var edgeLayout = edge.getLayout();
            var x1;
            var y1;
            var x2;
            var y2;
            var cpx1;
            var cpy1;
            var cpx2;
            var cpy2;
            curve.shape.extent = Math.max(1, edgeLayout.dy);
            curve.shape.orient = orient;
            if (orient === "vertical") {
                x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + edgeLayout.sy;
                y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + n1Layout.dy;
                x2 = (dragX2 != null ? dragX2 * width : n2Layout.x) + edgeLayout.ty;
                y2 = dragY2 != null ? dragY2 * height : n2Layout.y;
                cpx1 = x1;
                cpy1 = y1 * (1 - curvature) + y2 * curvature;
                cpx2 = x2;
                cpy2 = y1 * curvature + y2 * (1 - curvature);
            } else {
                x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + n1Layout.dx;
                y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + edgeLayout.sy;
                x2 = dragX2 != null ? dragX2 * width : n2Layout.x;
                y2 = (dragY2 != null ? dragY2 * height : n2Layout.y) + edgeLayout.ty;
                cpx1 = x1 * (1 - curvature) + x2 * curvature;
                cpy1 = y1;
                cpx2 = x1 * curvature + x2 * (1 - curvature);
                cpy2 = y2;
            }
            curve.setShape({
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                cpx1: cpx1,
                cpy1: cpy1,
                cpx2: cpx2,
                cpy2: cpy2
            });
            curve.useStyle(lineStyleModel.getItemStyle());
            // Special color, use source node color or target node color
            $58364a2c82b0ec77$var$applyCurveStyle(curve.style, orient, edge);
            var defaultEdgeLabelText = "" + edgeModel.get("value");
            var edgeLabelStateModels = (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(edgeModel, "edgeLabel");
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(curve, edgeLabelStateModels, {
                labelFetcher: {
                    getFormattedLabel: function(dataIndex, stateName, dataType, labelDimIndex, formatter, extendParams) {
                        return seriesModel.getFormattedLabel(dataIndex, stateName, "edge", labelDimIndex, // ensure edgeLabel formatter is provided
                        // to prevent the inheritance from `label.formatter` of the series
                        (0, $7a1bd9c2710fea0d$export$2e94551289abb95b)(formatter, edgeLabelStateModels.normal && edgeLabelStateModels.normal.get("formatter"), defaultEdgeLabelText), extendParams);
                    }
                },
                labelDataIndex: edge.dataIndex,
                defaultText: defaultEdgeLabelText
            });
            curve.setTextConfig({
                position: "inside"
            });
            var emphasisModel = edgeModel.getModel("emphasis");
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(curve, edgeModel, "lineStyle", function(model) {
                var style = model.getItemStyle();
                $58364a2c82b0ec77$var$applyCurveStyle(style, orient, edge);
                return style;
            });
            group.add(curve);
            edgeData.setItemGraphicEl(edge.dataIndex, curve);
            var focus = emphasisModel.get("focus");
            (0, $2bf82c0980125b62$export$e51187539ff11209)(curve, focus === "adjacency" ? edge.getAdjacentDataIndices() : focus === "trajectory" ? edge.getTrajectoryDataIndices() : focus, emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
        });
        // Generate a rect for each node
        graph.eachNode(function(node) {
            var layout = node.getLayout();
            var itemModel = node.getModel();
            var dragX = itemModel.get("localX");
            var dragY = itemModel.get("localY");
            var emphasisModel = itemModel.getModel("emphasis");
            var rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                shape: {
                    x: dragX != null ? dragX * width : layout.x,
                    y: dragY != null ? dragY * height : layout.y,
                    width: layout.dx,
                    height: layout.dy
                },
                style: itemModel.getModel("itemStyle").getItemStyle(),
                z2: 10
            });
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(rect, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
                labelFetcher: {
                    getFormattedLabel: function(dataIndex, stateName) {
                        return seriesModel.getFormattedLabel(dataIndex, stateName, "node");
                    }
                },
                labelDataIndex: node.dataIndex,
                defaultText: node.id
            });
            rect.disableLabelAnimation = true;
            rect.setStyle("fill", node.getVisual("color"));
            rect.setStyle("decal", node.getVisual("style").decal);
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(rect, itemModel);
            group.add(rect);
            nodeData.setItemGraphicEl(node.dataIndex, rect);
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(rect).dataType = "node";
            var focus = emphasisModel.get("focus");
            (0, $2bf82c0980125b62$export$e51187539ff11209)(rect, focus === "adjacency" ? node.getAdjacentDataIndices() : focus === "trajectory" ? node.getTrajectoryDataIndices() : focus, emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
        });
        nodeData.eachItemGraphicEl(function(el, dataIndex) {
            var itemModel = nodeData.getItemModel(dataIndex);
            if (itemModel.get("draggable")) {
                el.drift = function(dx, dy) {
                    sankeyView._focusAdjacencyDisabled = true;
                    this.shape.x += dx;
                    this.shape.y += dy;
                    this.dirty();
                    api.dispatchAction({
                        type: "dragNode",
                        seriesId: seriesModel.id,
                        dataIndex: nodeData.getRawIndex(dataIndex),
                        localX: this.shape.x / width,
                        localY: this.shape.y / height
                    });
                };
                el.ondragend = function() {
                    sankeyView._focusAdjacencyDisabled = false;
                };
                el.draggable = true;
                el.cursor = "move";
            }
        });
        if (!this._data && seriesModel.isAnimationEnabled()) group.setClipPath($58364a2c82b0ec77$var$createGridClipShape(group.getBoundingRect(), seriesModel, function() {
            group.removeClipPath();
        }));
        this._data = seriesModel.getData();
    };
    SankeyView.prototype.dispose = function() {};
    SankeyView.type = "sankey";
    return SankeyView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
/**
 * Special color, use source node color or target node color
 * @param curveProps curve's style to parse
 * @param orient direction
 * @param edge current curve data
 */ function $58364a2c82b0ec77$var$applyCurveStyle(curveProps, orient, edge) {
    switch(curveProps.fill){
        case "source":
            curveProps.fill = edge.node1.getVisual("color");
            curveProps.decal = edge.node1.getVisual("style").decal;
            break;
        case "target":
            curveProps.fill = edge.node2.getVisual("color");
            curveProps.decal = edge.node2.getVisual("style").decal;
            break;
        case "gradient":
            var sourceColor = edge.node1.getVisual("color");
            var targetColor = edge.node2.getVisual("color");
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(sourceColor) && (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(targetColor)) curveProps.fill = new $cf44c01491b58e53$export$2e2bcd8739ae039(0, 0, +(orient === "horizontal"), +(orient === "vertical"), [
                {
                    color: sourceColor,
                    offset: 0
                },
                {
                    color: targetColor,
                    offset: 1
                }
            ]);
    }
}
// Add animation to the view
function $58364a2c82b0ec77$var$createGridClipShape(rect, seriesModel, cb) {
    var rectEl = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: rect.x - 10,
            y: rect.y - 10,
            width: 0,
            height: rect.height + 20
        }
    });
    $8b353638fbedfefa$export$a121566aadcfe021(rectEl, {
        shape: {
            width: rect.width + 20
        }
    }, seriesModel, cb);
    return rectEl;
}
var $58364a2c82b0ec77$export$2e2bcd8739ae039 = $58364a2c82b0ec77$var$SankeyView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $f213d63e219306d2$var$SankeySeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SankeySeriesModel, _super);
    function SankeySeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SankeySeriesModel.type;
        return _this;
    }
    /**
   * Init a graph data structure from data in option series
   */ SankeySeriesModel.prototype.getInitialData = function(option, ecModel) {
        var links = option.edges || option.links;
        var nodes = option.data || option.nodes;
        var levels = option.levels;
        this.levelModels = [];
        var levelModels = this.levelModels;
        for(var i = 0; i < levels.length; i++)if (levels[i].depth != null && levels[i].depth >= 0) levelModels[levels[i].depth] = new (0, $6818646a97528290$export$2e2bcd8739ae039)(levels[i], this, ecModel);
        if (nodes && links) {
            var graph = (0, $09eb5d193a1ecbce$export$2e2bcd8739ae039)(nodes, links, this, true, beforeLink);
            return graph.data;
        }
        function beforeLink(nodeData, edgeData) {
            nodeData.wrapMethod("getItemModel", function(model, idx) {
                var seriesModel = model.parentModel;
                var layout = seriesModel.getData().getItemLayout(idx);
                if (layout) {
                    var nodeDepth = layout.depth;
                    var levelModel = seriesModel.levelModels[nodeDepth];
                    if (levelModel) model.parentModel = levelModel;
                }
                return model;
            });
            edgeData.wrapMethod("getItemModel", function(model, idx) {
                var seriesModel = model.parentModel;
                var edge = seriesModel.getGraph().getEdgeByIndex(idx);
                var layout = edge.node1.getLayout();
                if (layout) {
                    var depth = layout.depth;
                    var levelModel = seriesModel.levelModels[depth];
                    if (levelModel) model.parentModel = levelModel;
                }
                return model;
            });
        }
    };
    SankeySeriesModel.prototype.setNodePosition = function(dataIndex, localPosition) {
        var nodes = this.option.data || this.option.nodes;
        var dataItem = nodes[dataIndex];
        dataItem.localX = localPosition[0];
        dataItem.localY = localPosition[1];
    };
    /**
   * Return the graphic data structure
   *
   * @return graphic data structure
   */ SankeySeriesModel.prototype.getGraph = function() {
        return this.getData().graph;
    };
    /**
   * Get edge data of graphic data structure
   *
   * @return data structure of list
   */ SankeySeriesModel.prototype.getEdgeData = function() {
        return this.getGraph().edgeData;
    };
    SankeySeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        function noValue(val) {
            return isNaN(val) || val == null;
        }
        // dataType === 'node' or empty do not show tooltip by default
        if (dataType === "edge") {
            var params = this.getDataParams(dataIndex, dataType);
            var rawDataOpt = params.data;
            var edgeValue = params.value;
            var edgeName = rawDataOpt.source + " -- " + rawDataOpt.target;
            return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                name: edgeName,
                value: edgeValue,
                noValue: noValue(edgeValue)
            });
        } else {
            var node = this.getGraph().getNodeByIndex(dataIndex);
            var value = node.getLayout().value;
            var name_1 = this.getDataParams(dataIndex, dataType).data.name;
            return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                name: name_1 != null ? name_1 + "" : null,
                value: value,
                noValue: noValue(value)
            });
        }
    };
    SankeySeriesModel.prototype.optionUpdated = function() {};
    // Override Series.getDataParams()
    SankeySeriesModel.prototype.getDataParams = function(dataIndex, dataType) {
        var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);
        if (params.value == null && dataType === "node") {
            var node = this.getGraph().getNodeByIndex(dataIndex);
            var nodeValue = node.getLayout().value;
            params.value = nodeValue;
        }
        return params;
    };
    SankeySeriesModel.type = "series.sankey";
    SankeySeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "view",
        left: "5%",
        top: "5%",
        right: "20%",
        bottom: "5%",
        orient: "horizontal",
        nodeWidth: 20,
        nodeGap: 8,
        draggable: true,
        layoutIterations: 32,
        label: {
            show: true,
            position: "right",
            fontSize: 12
        },
        edgeLabel: {
            show: false,
            fontSize: 12
        },
        levels: [],
        nodeAlign: "justify",
        lineStyle: {
            color: "#314656",
            opacity: 0.2,
            curveness: 0.5
        },
        emphasis: {
            label: {
                show: true
            },
            lineStyle: {
                opacity: 0.5
            }
        },
        select: {
            itemStyle: {
                borderColor: "#212121"
            }
        },
        animationEasing: "linear",
        animationDuration: 1000
    };
    return SankeySeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $f213d63e219306d2$export$2e2bcd8739ae039 = $f213d63e219306d2$var$SankeySeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $b2e36df99c285454$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType("sankey", function(seriesModel) {
        var nodeWidth = seriesModel.get("nodeWidth");
        var nodeGap = seriesModel.get("nodeGap");
        var layoutInfo = $b2e36df99c285454$var$getViewRect(seriesModel, api);
        seriesModel.layoutInfo = layoutInfo;
        var width = layoutInfo.width;
        var height = layoutInfo.height;
        var graph = seriesModel.getGraph();
        var nodes = graph.nodes;
        var edges = graph.edges;
        $b2e36df99c285454$var$computeNodeValues(nodes);
        var filteredNodes = $7a1bd9c2710fea0d$export$3dea766d36a8935f(nodes, function(node) {
            return node.getLayout().value === 0;
        });
        var iterations = filteredNodes.length !== 0 ? 0 : seriesModel.get("layoutIterations");
        var orient = seriesModel.get("orient");
        var nodeAlign = seriesModel.get("nodeAlign");
        $b2e36df99c285454$var$layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign);
    });
}
/**
 * Get the layout position of the whole view
 */ function $b2e36df99c285454$var$getViewRect(seriesModel, api) {
    return $93b9bc7f22ac7369$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $b2e36df99c285454$var$layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign) {
    $b2e36df99c285454$var$computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign);
    $b2e36df99c285454$var$computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient);
    $b2e36df99c285454$var$computeEdgeDepths(nodes, orient);
}
/**
 * Compute the value of each node by summing the associated edge's value
 */ function $b2e36df99c285454$var$computeNodeValues(nodes) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        var value1 = $b2e36df99c285454$var$sum(node.outEdges, $b2e36df99c285454$var$getEdgeValue);
        var value2 = $b2e36df99c285454$var$sum(node.inEdges, $b2e36df99c285454$var$getEdgeValue);
        var nodeRawValue = node.getValue() || 0;
        var value = Math.max(value1, value2, nodeRawValue);
        node.setLayout({
            value: value
        }, true);
    });
}
/**
 * Compute the x-position for each node.
 *
 * Here we use Kahn algorithm to detect cycle when we traverse
 * the node to computer the initial x position.
 */ function $b2e36df99c285454$var$computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign) {
    // Used to mark whether the edge is deleted. if it is deleted,
    // the value is 0, otherwise it is 1.
    var remainEdges = [];
    // Storage each node's indegree.
    var indegreeArr = [];
    // Used to storage the node with indegree is equal to 0.
    var zeroIndegrees = [];
    var nextTargetNode = [];
    var x = 0;
    // let kx = 0;
    for(var i = 0; i < edges.length; i++)remainEdges[i] = 1;
    for(var i = 0; i < nodes.length; i++){
        indegreeArr[i] = nodes[i].inEdges.length;
        if (indegreeArr[i] === 0) zeroIndegrees.push(nodes[i]);
    }
    var maxNodeDepth = -1;
    // Traversing nodes using topological sorting to calculate the
    // horizontal(if orient === 'horizontal') or vertical(if orient === 'vertical')
    // position of the nodes.
    while(zeroIndegrees.length){
        for(var idx = 0; idx < zeroIndegrees.length; idx++){
            var node = zeroIndegrees[idx];
            var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
            var isItemDepth = item.depth != null && item.depth >= 0;
            if (isItemDepth && item.depth > maxNodeDepth) maxNodeDepth = item.depth;
            node.setLayout({
                depth: isItemDepth ? item.depth : x
            }, true);
            orient === "vertical" ? node.setLayout({
                dy: nodeWidth
            }, true) : node.setLayout({
                dx: nodeWidth
            }, true);
            for(var edgeIdx = 0; edgeIdx < node.outEdges.length; edgeIdx++){
                var edge = node.outEdges[edgeIdx];
                var indexEdge = edges.indexOf(edge);
                remainEdges[indexEdge] = 0;
                var targetNode = edge.node2;
                var nodeIndex = nodes.indexOf(targetNode);
                if (--indegreeArr[nodeIndex] === 0 && nextTargetNode.indexOf(targetNode) < 0) nextTargetNode.push(targetNode);
            }
        }
        ++x;
        zeroIndegrees = nextTargetNode;
        nextTargetNode = [];
    }
    for(var i = 0; i < remainEdges.length; i++){
        if (remainEdges[i] === 1) throw new Error("Sankey is a DAG, the original data has cycle!");
    }
    var maxDepth = maxNodeDepth > x - 1 ? maxNodeDepth : x - 1;
    if (nodeAlign && nodeAlign !== "left") $b2e36df99c285454$var$adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth);
    var kx = orient === "vertical" ? (height - nodeWidth) / maxDepth : (width - nodeWidth) / maxDepth;
    $b2e36df99c285454$var$scaleNodeBreadths(nodes, kx, orient);
}
function $b2e36df99c285454$var$isNodeDepth(node) {
    var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
    return item.depth != null && item.depth >= 0;
}
function $b2e36df99c285454$var$adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth) {
    if (nodeAlign === "right") {
        var nextSourceNode = [];
        var remainNodes = nodes;
        var nodeHeight = 0;
        while(remainNodes.length){
            for(var i = 0; i < remainNodes.length; i++){
                var node = remainNodes[i];
                node.setLayout({
                    skNodeHeight: nodeHeight
                }, true);
                for(var j = 0; j < node.inEdges.length; j++){
                    var edge = node.inEdges[j];
                    if (nextSourceNode.indexOf(edge.node1) < 0) nextSourceNode.push(edge.node1);
                }
            }
            remainNodes = nextSourceNode;
            nextSourceNode = [];
            ++nodeHeight;
        }
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
            if (!$b2e36df99c285454$var$isNodeDepth(node)) node.setLayout({
                depth: Math.max(0, maxDepth - node.getLayout().skNodeHeight)
            }, true);
        });
    } else if (nodeAlign === "justify") $b2e36df99c285454$var$moveSinksRight(nodes, maxDepth);
}
/**
 * All the node without outEgdes are assigned maximum x-position and
 *     be aligned in the last column.
 *
 * @param nodes.  node of sankey view.
 * @param maxDepth.  use to assign to node without outEdges as x-position.
 */ function $b2e36df99c285454$var$moveSinksRight(nodes, maxDepth) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        if (!$b2e36df99c285454$var$isNodeDepth(node) && !node.outEdges.length) node.setLayout({
            depth: maxDepth
        }, true);
    });
}
/**
 * Scale node x-position to the width
 *
 * @param nodes  node of sankey view
 * @param kx   multiple used to scale nodes
 */ function $b2e36df99c285454$var$scaleNodeBreadths(nodes, kx, orient) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        var nodeDepth = node.getLayout().depth * kx;
        orient === "vertical" ? node.setLayout({
            y: nodeDepth
        }, true) : node.setLayout({
            x: nodeDepth
        }, true);
    });
}
/**
 * Using Gauss-Seidel iterations method to compute the node depth(y-position)
 *
 * @param nodes  node of sankey view
 * @param edges  edge of sankey view
 * @param height  the whole height of the area to draw the view
 * @param nodeGap  the vertical distance between two nodes
 *     in the same column.
 * @param iterations  the number of iterations for the algorithm
 */ function $b2e36df99c285454$var$computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient) {
    var nodesByBreadth = $b2e36df99c285454$var$prepareNodesByBreadth(nodes, orient);
    $b2e36df99c285454$var$initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient);
    $b2e36df99c285454$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
    for(var alpha = 1; iterations > 0; iterations--){
        // 0.99 is a experience parameter, ensure that each iterations of
        // changes as small as possible.
        alpha *= 0.99;
        $b2e36df99c285454$var$relaxRightToLeft(nodesByBreadth, alpha, orient);
        $b2e36df99c285454$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
        $b2e36df99c285454$var$relaxLeftToRight(nodesByBreadth, alpha, orient);
        $b2e36df99c285454$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
    }
}
function $b2e36df99c285454$var$prepareNodesByBreadth(nodes, orient) {
    var nodesByBreadth = [];
    var keyAttr = orient === "vertical" ? "y" : "x";
    var groupResult = (0, $76d619f648247e6d$export$7ab5bda43e13168f)(nodes, function(node) {
        return node.getLayout()[keyAttr];
    });
    groupResult.keys.sort(function(a, b) {
        return a - b;
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(groupResult.keys, function(key) {
        nodesByBreadth.push(groupResult.buckets.get(key));
    });
    return nodesByBreadth;
}
/**
 * Compute the original y-position for each node
 */ function $b2e36df99c285454$var$initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient) {
    var minKy = Infinity;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        var n = nodes.length;
        var sum = 0;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
            sum += node.getLayout().value;
        });
        var ky = orient === "vertical" ? (width - (n - 1) * nodeGap) / sum : (height - (n - 1) * nodeGap) / sum;
        if (ky < minKy) minKy = ky;
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node, i) {
            var nodeDy = node.getLayout().value * minKy;
            if (orient === "vertical") {
                node.setLayout({
                    x: i
                }, true);
                node.setLayout({
                    dx: nodeDy
                }, true);
            } else {
                node.setLayout({
                    y: i
                }, true);
                node.setLayout({
                    dy: nodeDy
                }, true);
            }
        });
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(edges, function(edge) {
        var edgeDy = +edge.getValue() * minKy;
        edge.setLayout({
            dy: edgeDy
        }, true);
    });
}
/**
 * Resolve the collision of initialized depth (y-position)
 */ function $b2e36df99c285454$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient) {
    var keyAttr = orient === "vertical" ? "x" : "y";
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        nodes.sort(function(a, b) {
            return a.getLayout()[keyAttr] - b.getLayout()[keyAttr];
        });
        var nodeX;
        var node;
        var dy;
        var y0 = 0;
        var n = nodes.length;
        var nodeDyAttr = orient === "vertical" ? "dx" : "dy";
        for(var i = 0; i < n; i++){
            node = nodes[i];
            dy = y0 - node.getLayout()[keyAttr];
            if (dy > 0) {
                nodeX = node.getLayout()[keyAttr] + dy;
                orient === "vertical" ? node.setLayout({
                    x: nodeX
                }, true) : node.setLayout({
                    y: nodeX
                }, true);
            }
            y0 = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap;
        }
        var viewWidth = orient === "vertical" ? width : height;
        // If the bottommost node goes outside the bounds, push it back up
        dy = y0 - nodeGap - viewWidth;
        if (dy > 0) {
            nodeX = node.getLayout()[keyAttr] - dy;
            orient === "vertical" ? node.setLayout({
                x: nodeX
            }, true) : node.setLayout({
                y: nodeX
            }, true);
            y0 = nodeX;
            for(var i = n - 2; i >= 0; --i){
                node = nodes[i];
                dy = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap - y0;
                if (dy > 0) {
                    nodeX = node.getLayout()[keyAttr] - dy;
                    orient === "vertical" ? node.setLayout({
                        x: nodeX
                    }, true) : node.setLayout({
                        y: nodeX
                    }, true);
                }
                y0 = node.getLayout()[keyAttr];
            }
        }
    });
}
/**
 * Change the y-position of the nodes, except most the right side nodes
 * @param nodesByBreadth
 * @param alpha  parameter used to adjust the nodes y-position
 */ function $b2e36df99c285454$var$relaxRightToLeft(nodesByBreadth, alpha, orient) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth.slice().reverse(), function(nodes) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
            if (node.outEdges.length) {
                var y = $b2e36df99c285454$var$sum(node.outEdges, $b2e36df99c285454$var$weightedTarget, orient) / $b2e36df99c285454$var$sum(node.outEdges, $b2e36df99c285454$var$getEdgeValue);
                if (isNaN(y)) {
                    var len = node.outEdges.length;
                    y = len ? $b2e36df99c285454$var$sum(node.outEdges, $b2e36df99c285454$var$centerTarget, orient) / len : 0;
                }
                if (orient === "vertical") {
                    var nodeX = node.getLayout().x + (y - $b2e36df99c285454$var$center(node, orient)) * alpha;
                    node.setLayout({
                        x: nodeX
                    }, true);
                } else {
                    var nodeY = node.getLayout().y + (y - $b2e36df99c285454$var$center(node, orient)) * alpha;
                    node.setLayout({
                        y: nodeY
                    }, true);
                }
            }
        });
    });
}
function $b2e36df99c285454$var$weightedTarget(edge, orient) {
    return $b2e36df99c285454$var$center(edge.node2, orient) * edge.getValue();
}
function $b2e36df99c285454$var$centerTarget(edge, orient) {
    return $b2e36df99c285454$var$center(edge.node2, orient);
}
function $b2e36df99c285454$var$weightedSource(edge, orient) {
    return $b2e36df99c285454$var$center(edge.node1, orient) * edge.getValue();
}
function $b2e36df99c285454$var$centerSource(edge, orient) {
    return $b2e36df99c285454$var$center(edge.node1, orient);
}
function $b2e36df99c285454$var$center(node, orient) {
    return orient === "vertical" ? node.getLayout().x + node.getLayout().dx / 2 : node.getLayout().y + node.getLayout().dy / 2;
}
function $b2e36df99c285454$var$getEdgeValue(edge) {
    return edge.getValue();
}
function $b2e36df99c285454$var$sum(array, cb, orient) {
    var sum = 0;
    var len = array.length;
    var i = -1;
    while(++i < len){
        var value = +cb(array[i], orient);
        if (!isNaN(value)) sum += value;
    }
    return sum;
}
/**
 * Change the y-position of the nodes, except most the left side nodes
 */ function $b2e36df99c285454$var$relaxLeftToRight(nodesByBreadth, alpha, orient) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
            if (node.inEdges.length) {
                var y = $b2e36df99c285454$var$sum(node.inEdges, $b2e36df99c285454$var$weightedSource, orient) / $b2e36df99c285454$var$sum(node.inEdges, $b2e36df99c285454$var$getEdgeValue);
                if (isNaN(y)) {
                    var len = node.inEdges.length;
                    y = len ? $b2e36df99c285454$var$sum(node.inEdges, $b2e36df99c285454$var$centerSource, orient) / len : 0;
                }
                if (orient === "vertical") {
                    var nodeX = node.getLayout().x + (y - $b2e36df99c285454$var$center(node, orient)) * alpha;
                    node.setLayout({
                        x: nodeX
                    }, true);
                } else {
                    var nodeY = node.getLayout().y + (y - $b2e36df99c285454$var$center(node, orient)) * alpha;
                    node.setLayout({
                        y: nodeY
                    }, true);
                }
            }
        });
    });
}
/**
 * Compute the depth(y-position) of each edge
 */ function $b2e36df99c285454$var$computeEdgeDepths(nodes, orient) {
    var keyAttr = orient === "vertical" ? "x" : "y";
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        node.outEdges.sort(function(a, b) {
            return a.node2.getLayout()[keyAttr] - b.node2.getLayout()[keyAttr];
        });
        node.inEdges.sort(function(a, b) {
            return a.node1.getLayout()[keyAttr] - b.node1.getLayout()[keyAttr];
        });
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
        var sy = 0;
        var ty = 0;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(node.outEdges, function(edge) {
            edge.setLayout({
                sy: sy
            }, true);
            sy += edge.getLayout().dy;
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(node.inEdges, function(edge) {
            edge.setLayout({
                ty: ty
            }, true);
            ty += edge.getLayout().dy;
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $7b50f502cfd189d5$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $7b50f502cfd189d5$var$isObject = $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a;
var $7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX = -1;
var $7b50f502cfd189d5$var$VisualMapping = /** @class */ function() {
    function VisualMapping(option) {
        var mappingMethod = option.mappingMethod;
        var visualType = option.type;
        var thisOption = this.option = $7a1bd9c2710fea0d$export$9cd59f9826255e47(option);
        this.type = visualType;
        this.mappingMethod = mappingMethod;
        this._normalizeData = $7b50f502cfd189d5$var$normalizers[mappingMethod];
        var visualHandler = VisualMapping.visualHandlers[visualType];
        this.applyVisual = visualHandler.applyVisual;
        this.getColorMapper = visualHandler.getColorMapper;
        this._normalizedToVisual = visualHandler._normalizedToVisual[mappingMethod];
        if (mappingMethod === "piecewise") {
            $7b50f502cfd189d5$var$normalizeVisualRange(thisOption);
            $7b50f502cfd189d5$var$preprocessForPiecewise(thisOption);
        } else if (mappingMethod === "category") thisOption.categories ? $7b50f502cfd189d5$var$preprocessForSpecifiedCategory(thisOption) : $7b50f502cfd189d5$var$normalizeVisualRange(thisOption, true);
        else {
            // mappingMethod === 'linear' or 'fixed'
            $7a1bd9c2710fea0d$export$a7a9523472993e97(mappingMethod !== "linear" || thisOption.dataExtent);
            $7b50f502cfd189d5$var$normalizeVisualRange(thisOption);
        }
    }
    VisualMapping.prototype.mapValueToVisual = function(value) {
        var normalized = this._normalizeData(value);
        return this._normalizedToVisual(normalized, value);
    };
    VisualMapping.prototype.getNormalizer = function() {
        return $7a1bd9c2710fea0d$export$2385a24977818dd0(this._normalizeData, this);
    };
    /**
   * List available visual types.
   *
   * @public
   * @return {Array.<string>}
   */ VisualMapping.listVisualTypes = function() {
        return $7a1bd9c2710fea0d$export$ed97f33186d4b816(VisualMapping.visualHandlers);
    };
    // /**
    //  * @public
    //  */
    // static addVisualHandler(name, handler) {
    //     visualHandlers[name] = handler;
    // }
    /**
   * @public
   */ VisualMapping.isValidType = function(visualType) {
        return VisualMapping.visualHandlers.hasOwnProperty(visualType);
    };
    /**
   * Convenient method.
   * Visual can be Object or Array or primary type.
   */ VisualMapping.eachVisual = function(visual, callback, context) {
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(visual)) $7a1bd9c2710fea0d$export$79b2f7037acddd43(visual, callback, context);
        else callback.call(context, visual);
    };
    VisualMapping.mapVisual = function(visual, callback, context) {
        var isPrimary;
        var newVisual = $7a1bd9c2710fea0d$export$43bee75e5e14138e(visual) ? [] : $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(visual) ? {} : (isPrimary = true, null);
        VisualMapping.eachVisual(visual, function(v, key) {
            var newVal = callback.call(context, v, key);
            isPrimary ? newVisual = newVal : newVisual[key] = newVal;
        });
        return newVisual;
    };
    /**
   * Retrieve visual properties from given object.
   */ VisualMapping.retrieveVisuals = function(obj) {
        var ret = {};
        var hasVisual;
        obj && $7b50f502cfd189d5$var$each(VisualMapping.visualHandlers, function(h, visualType) {
            if (obj.hasOwnProperty(visualType)) {
                ret[visualType] = obj[visualType];
                hasVisual = true;
            }
        });
        return hasVisual ? ret : null;
    };
    /**
   * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
   *
   * @public
   * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
   *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
   * @return {Array.<string>} Sorted visual types.
   */ VisualMapping.prepareVisualTypes = function(visualTypes) {
        if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(visualTypes)) visualTypes = visualTypes.slice();
        else if ($7b50f502cfd189d5$var$isObject(visualTypes)) {
            var types_1 = [];
            $7b50f502cfd189d5$var$each(visualTypes, function(item, type) {
                types_1.push(type);
            });
            visualTypes = types_1;
        } else return [];
        visualTypes.sort(function(type1, type2) {
            // color should be front of colorSaturation, colorAlpha, ...
            // symbol and symbolSize do not matter.
            return type2 === "color" && type1 !== "color" && type1.indexOf("color") === 0 ? 1 : -1;
        });
        return visualTypes;
    };
    /**
   * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
   * Other visuals are only depends on themself.
   */ VisualMapping.dependsOn = function(visualType1, visualType2) {
        return visualType2 === "color" ? !!(visualType1 && visualType1.indexOf(visualType2) === 0) : visualType1 === visualType2;
    };
    /**
   * @param value
   * @param pieceList [{value: ..., interval: [min, max]}, ...]
   *                         Always from small to big.
   * @param findClosestWhenOutside Default to be false
   * @return index
   */ VisualMapping.findPieceIndex = function(value, pieceList, findClosestWhenOutside) {
        var possibleI;
        var abs = Infinity;
        // value has the higher priority.
        for(var i = 0, len = pieceList.length; i < len; i++){
            var pieceValue = pieceList[i].value;
            if (pieceValue != null) {
                if (pieceValue === value || $7a1bd9c2710fea0d$export$844ec244b1367d54(pieceValue) && pieceValue === value + "") return i;
                findClosestWhenOutside && updatePossible(pieceValue, i);
            }
        }
        for(var i = 0, len = pieceList.length; i < len; i++){
            var piece = pieceList[i];
            var interval = piece.interval;
            var close_1 = piece.close;
            if (interval) {
                if (interval[0] === -Infinity) {
                    if ($7b50f502cfd189d5$var$littleThan(close_1[1], value, interval[1])) return i;
                } else if (interval[1] === Infinity) {
                    if ($7b50f502cfd189d5$var$littleThan(close_1[0], interval[0], value)) return i;
                } else if ($7b50f502cfd189d5$var$littleThan(close_1[0], interval[0], value) && $7b50f502cfd189d5$var$littleThan(close_1[1], value, interval[1])) return i;
                findClosestWhenOutside && updatePossible(interval[0], i);
                findClosestWhenOutside && updatePossible(interval[1], i);
            }
        }
        if (findClosestWhenOutside) return value === Infinity ? pieceList.length - 1 : value === -Infinity ? 0 : possibleI;
        function updatePossible(val, index) {
            var newAbs = Math.abs(val - value);
            if (newAbs < abs) {
                abs = newAbs;
                possibleI = index;
            }
        }
    };
    VisualMapping.visualHandlers = {
        color: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual("color"),
            getColorMapper: function() {
                var thisOption = this.option;
                return $7a1bd9c2710fea0d$export$2385a24977818dd0(thisOption.mappingMethod === "category" ? function(value, isNormalized) {
                    !isNormalized && (value = this._normalizeData(value));
                    return $7b50f502cfd189d5$var$doMapCategory.call(this, value);
                } : function(value, isNormalized, out) {
                    // If output rgb array
                    // which will be much faster and useful in pixel manipulation
                    var returnRGBArray = !!out;
                    !isNormalized && (value = this._normalizeData(value));
                    out = $2c037f5bda6341ca$export$66cb3c0e9efc61c8(value, thisOption.parsedVisual, out);
                    return returnRGBArray ? out : $2c037f5bda6341ca$export$fac44ee5b035f737(out, "rgba");
                }, this);
            },
            _normalizedToVisual: {
                linear: function(normalized) {
                    return $2c037f5bda6341ca$export$fac44ee5b035f737($2c037f5bda6341ca$export$66cb3c0e9efc61c8(normalized, this.option.parsedVisual), "rgba");
                },
                category: $7b50f502cfd189d5$var$doMapCategory,
                piecewise: function(normalized, value) {
                    var result = $7b50f502cfd189d5$var$getSpecifiedVisual.call(this, value);
                    if (result == null) result = $2c037f5bda6341ca$export$fac44ee5b035f737($2c037f5bda6341ca$export$66cb3c0e9efc61c8(normalized, this.option.parsedVisual), "rgba");
                    return result;
                },
                fixed: $7b50f502cfd189d5$var$doMapFixed
            }
        },
        colorHue: $7b50f502cfd189d5$var$makePartialColorVisualHandler(function(color, value) {
            return $2c037f5bda6341ca$export$d898ae866e27bf18(color, value);
        }),
        colorSaturation: $7b50f502cfd189d5$var$makePartialColorVisualHandler(function(color, value) {
            return $2c037f5bda6341ca$export$d898ae866e27bf18(color, null, value);
        }),
        colorLightness: $7b50f502cfd189d5$var$makePartialColorVisualHandler(function(color, value) {
            return $2c037f5bda6341ca$export$d898ae866e27bf18(color, null, null, value);
        }),
        colorAlpha: $7b50f502cfd189d5$var$makePartialColorVisualHandler(function(color, value) {
            return $2c037f5bda6341ca$export$ab4754bf42583a26(color, value);
        }),
        decal: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual("decal"),
            _normalizedToVisual: {
                linear: null,
                category: $7b50f502cfd189d5$var$doMapCategory,
                piecewise: null,
                fixed: null
            }
        },
        opacity: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual("opacity"),
            _normalizedToVisual: $7b50f502cfd189d5$var$createNormalizedToNumericVisual([
                0,
                1
            ])
        },
        liftZ: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual("liftZ"),
            _normalizedToVisual: {
                linear: $7b50f502cfd189d5$var$doMapFixed,
                category: $7b50f502cfd189d5$var$doMapFixed,
                piecewise: $7b50f502cfd189d5$var$doMapFixed,
                fixed: $7b50f502cfd189d5$var$doMapFixed
            }
        },
        symbol: {
            applyVisual: function(value, getter, setter) {
                var symbolCfg = this.mapValueToVisual(value);
                setter("symbol", symbolCfg);
            },
            _normalizedToVisual: {
                linear: $7b50f502cfd189d5$var$doMapToArray,
                category: $7b50f502cfd189d5$var$doMapCategory,
                piecewise: function(normalized, value) {
                    var result = $7b50f502cfd189d5$var$getSpecifiedVisual.call(this, value);
                    if (result == null) result = $7b50f502cfd189d5$var$doMapToArray.call(this, normalized);
                    return result;
                },
                fixed: $7b50f502cfd189d5$var$doMapFixed
            }
        },
        symbolSize: {
            applyVisual: $7b50f502cfd189d5$var$makeApplyVisual("symbolSize"),
            _normalizedToVisual: $7b50f502cfd189d5$var$createNormalizedToNumericVisual([
                0,
                1
            ])
        }
    };
    return VisualMapping;
}();
function $7b50f502cfd189d5$var$preprocessForPiecewise(thisOption) {
    var pieceList = thisOption.pieceList;
    thisOption.hasSpecialVisual = false;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(pieceList, function(piece, index) {
        piece.originIndex = index;
        // piece.visual is "result visual value" but not
        // a visual range, so it does not need to be normalized.
        if (piece.visual != null) thisOption.hasSpecialVisual = true;
    });
}
function $7b50f502cfd189d5$var$preprocessForSpecifiedCategory(thisOption) {
    // Hash categories.
    var categories = thisOption.categories;
    var categoryMap = thisOption.categoryMap = {};
    var visual = thisOption.visual;
    $7b50f502cfd189d5$var$each(categories, function(cate, index) {
        categoryMap[cate] = index;
    });
    // Process visual map input.
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(visual)) {
        var visualArr_1 = [];
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(visual)) $7b50f502cfd189d5$var$each(visual, function(v, cate) {
            var index = categoryMap[cate];
            visualArr_1[index != null ? index : $7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX] = v;
        });
        else // Is primary type, represents default visual.
        visualArr_1[$7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX] = visual;
        visual = $7b50f502cfd189d5$var$setVisualToOption(thisOption, visualArr_1);
    }
    // Remove categories that has no visual,
    // then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.
    for(var i = categories.length - 1; i >= 0; i--)if (visual[i] == null) {
        delete categoryMap[categories[i]];
        categories.pop();
    }
}
function $7b50f502cfd189d5$var$normalizeVisualRange(thisOption, isCategory) {
    var visual = thisOption.visual;
    var visualArr = [];
    if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(visual)) $7b50f502cfd189d5$var$each(visual, function(v) {
        visualArr.push(v);
    });
    else if (visual != null) visualArr.push(visual);
    var doNotNeedPair = {
        color: 1,
        symbol: 1
    };
    if (!isCategory && visualArr.length === 1 && !doNotNeedPair.hasOwnProperty(thisOption.type)) // Do not care visualArr.length === 0, which is illegal.
    visualArr[1] = visualArr[0];
    $7b50f502cfd189d5$var$setVisualToOption(thisOption, visualArr);
}
function $7b50f502cfd189d5$var$makePartialColorVisualHandler(applyValue) {
    return {
        applyVisual: function(value, getter, setter) {
            // Only used in HSL
            var colorChannel = this.mapValueToVisual(value);
            // Must not be array value
            setter("color", applyValue(getter("color"), colorChannel));
        },
        _normalizedToVisual: $7b50f502cfd189d5$var$createNormalizedToNumericVisual([
            0,
            1
        ])
    };
}
function $7b50f502cfd189d5$var$doMapToArray(normalized) {
    var visual = this.option.visual;
    return visual[Math.round((0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(normalized, [
        0,
        1
    ], [
        0,
        visual.length - 1
    ], true))] || {}; // TODO {}?
}
function $7b50f502cfd189d5$var$makeApplyVisual(visualType) {
    return function(value, getter, setter) {
        setter(visualType, this.mapValueToVisual(value));
    };
}
function $7b50f502cfd189d5$var$doMapCategory(normalized) {
    var visual = this.option.visual;
    return visual[this.option.loop && normalized !== $7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX ? normalized % visual.length : normalized];
}
function $7b50f502cfd189d5$var$doMapFixed() {
    // visual will be convert to array.
    return this.option.visual[0];
}
/**
 * Create mapped to numeric visual
 */ function $7b50f502cfd189d5$var$createNormalizedToNumericVisual(sourceExtent) {
    return {
        linear: function(normalized) {
            return (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(normalized, sourceExtent, this.option.visual, true);
        },
        category: $7b50f502cfd189d5$var$doMapCategory,
        piecewise: function(normalized, value) {
            var result = $7b50f502cfd189d5$var$getSpecifiedVisual.call(this, value);
            if (result == null) result = (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(normalized, sourceExtent, this.option.visual, true);
            return result;
        },
        fixed: $7b50f502cfd189d5$var$doMapFixed
    };
}
function $7b50f502cfd189d5$var$getSpecifiedVisual(value) {
    var thisOption = this.option;
    var pieceList = thisOption.pieceList;
    if (thisOption.hasSpecialVisual) {
        var pieceIndex = $7b50f502cfd189d5$var$VisualMapping.findPieceIndex(value, pieceList);
        var piece = pieceList[pieceIndex];
        if (piece && piece.visual) return piece.visual[this.type];
    }
}
function $7b50f502cfd189d5$var$setVisualToOption(thisOption, visualArr) {
    thisOption.visual = visualArr;
    if (thisOption.type === "color") thisOption.parsedVisual = $7a1bd9c2710fea0d$export$871de8747c9eaa88(visualArr, function(item) {
        var color = $2c037f5bda6341ca$export$98e6a39c04603d36(item);
        return color || [
            0,
            0,
            0,
            1
        ];
    });
    return visualArr;
}
/**
 * Normalizers by mapping methods.
 */ var $7b50f502cfd189d5$var$normalizers = {
    linear: function(value) {
        return (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, this.option.dataExtent, [
            0,
            1
        ], true);
    },
    piecewise: function(value) {
        var pieceList = this.option.pieceList;
        var pieceIndex = $7b50f502cfd189d5$var$VisualMapping.findPieceIndex(value, pieceList, true);
        if (pieceIndex != null) return (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(pieceIndex, [
            0,
            pieceList.length - 1
        ], [
            0,
            1
        ], true);
    },
    category: function(value) {
        var index = this.option.categories ? this.option.categoryMap[value] : value; // ordinal value
        return index == null ? $7b50f502cfd189d5$var$CATEGORY_DEFAULT_VISUAL_INDEX : index;
    },
    fixed: $7a1bd9c2710fea0d$export$8793edee2d425525
};
function $7b50f502cfd189d5$var$littleThan(close, a, b) {
    return close ? a <= b : a < b;
}
var $7b50f502cfd189d5$export$2e2bcd8739ae039 = $7b50f502cfd189d5$var$VisualMapping;


function $5379d5704c92d7dd$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType("sankey", function(seriesModel) {
        var graph = seriesModel.getGraph();
        var nodes = graph.nodes;
        var edges = graph.edges;
        if (nodes.length) {
            var minValue_1 = Infinity;
            var maxValue_1 = -Infinity;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
                var nodeValue = node.getLayout().value;
                if (nodeValue < minValue_1) minValue_1 = nodeValue;
                if (nodeValue > maxValue_1) maxValue_1 = nodeValue;
            });
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(nodes, function(node) {
                var mapping = new (0, $7b50f502cfd189d5$export$2e2bcd8739ae039)({
                    type: "color",
                    mappingMethod: "linear",
                    dataExtent: [
                        minValue_1,
                        maxValue_1
                    ],
                    visual: seriesModel.get("color")
                });
                var mapValueToColor = mapping.mapValueToVisual(node.getLayout().value);
                var customColor = node.getModel().get([
                    "itemStyle",
                    "color"
                ]);
                if (customColor != null) {
                    node.setVisual("color", customColor);
                    node.setVisual("style", {
                        fill: customColor
                    });
                } else {
                    node.setVisual("color", mapValueToColor);
                    node.setVisual("style", {
                        fill: mapValueToColor
                    });
                }
            });
        }
        if (edges.length) $7a1bd9c2710fea0d$export$79b2f7037acddd43(edges, function(edge) {
            var edgeStyle = edge.getModel().get("lineStyle");
            edge.setVisual("style", edgeStyle);
        });
    });
}


function $2439b31c49c21b38$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $58364a2c82b0ec77$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $f213d63e219306d2$export$2e2bcd8739ae039));
    registers.registerLayout((0, $b2e36df99c285454$export$2e2bcd8739ae039));
    registers.registerVisual((0, $5379d5704c92d7dd$export$2e2bcd8739ae039));
    registers.registerAction({
        type: "dragNode",
        event: "dragnode",
        // here can only use 'update' now, other value is not support in echarts.
        update: "update"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "series",
            subType: "sankey",
            query: payload
        }, function(seriesModel) {
            seriesModel.setNodePosition(payload.dataIndex, [
                payload.localX,
                payload.localY
            ]);
        });
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $00ab9646b588965f$var$ScatterSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ScatterSeriesModel, _super);
    function ScatterSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScatterSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    ScatterSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    ScatterSeriesModel.prototype.getProgressive = function() {
        var progressive = this.option.progressive;
        if (progressive == null) // PENDING
        return this.option.large ? 5e3 : this.get("progressive");
        return progressive;
    };
    ScatterSeriesModel.prototype.getProgressiveThreshold = function() {
        var progressiveThreshold = this.option.progressiveThreshold;
        if (progressiveThreshold == null) // PENDING
        return this.option.large ? 1e4 : this.get("progressiveThreshold");
        return progressiveThreshold;
    };
    ScatterSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.point(data.getItemLayout(dataIndex));
    };
    ScatterSeriesModel.prototype.getZLevelKey = function() {
        // Each progressive series has individual key.
        return this.getData().count() > this.getProgressiveThreshold() ? this.id : "";
    };
    ScatterSeriesModel.type = "series.scatter";
    ScatterSeriesModel.dependencies = [
        "grid",
        "polar",
        "geo",
        "singleAxis",
        "calendar"
    ];
    ScatterSeriesModel.defaultOption = {
        coordinateSystem: "cartesian2d",
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        symbolSize: 10,
        // symbolRotate: null,  // 图形旋转控制
        large: false,
        // Available when large is true
        largeThreshold: 2000,
        // cursor: null,
        itemStyle: {
            opacity: 0.8
        },
        emphasis: {
            scale: true
        },
        // If clip the overflow graphics
        // Works on cartesian / polar series
        clip: true,
        select: {
            itemStyle: {
                borderColor: "#212121"
            }
        },
        universalTransition: {
            divideShape: "clone"
        }
    };
    return ScatterSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $00ab9646b588965f$export$2e2bcd8739ae039 = $00ab9646b588965f$var$ScatterSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $69bbf770a3ca2c75$var$BOOST_SIZE_THRESHOLD = 4;
var $69bbf770a3ca2c75$var$LargeSymbolPathShape = /** @class */ function() {
    function LargeSymbolPathShape() {}
    return LargeSymbolPathShape;
}();
var $69bbf770a3ca2c75$var$LargeSymbolPath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LargeSymbolPath, _super);
    function LargeSymbolPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this._off = 0;
        _this.hoverDataIdx = -1;
        return _this;
    }
    LargeSymbolPath.prototype.getDefaultShape = function() {
        return new $69bbf770a3ca2c75$var$LargeSymbolPathShape();
    };
    LargeSymbolPath.prototype.reset = function() {
        this.notClear = false;
        this._off = 0;
    };
    LargeSymbolPath.prototype.buildPath = function(path, shape) {
        var points = shape.points;
        var size = shape.size;
        var symbolProxy = this.symbolProxy;
        var symbolProxyShape = symbolProxy.shape;
        var ctx = path.getContext ? path.getContext() : path;
        var canBoost = ctx && size[0] < $69bbf770a3ca2c75$var$BOOST_SIZE_THRESHOLD;
        var softClipShape = this.softClipShape;
        var i;
        // Do draw in afterBrush.
        if (canBoost) {
            this._ctx = ctx;
            return;
        }
        this._ctx = null;
        for(i = this._off; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (isNaN(x) || isNaN(y)) continue;
            if (softClipShape && !softClipShape.contain(x, y)) continue;
            symbolProxyShape.x = x - size[0] / 2;
            symbolProxyShape.y = y - size[1] / 2;
            symbolProxyShape.width = size[0];
            symbolProxyShape.height = size[1];
            symbolProxy.buildPath(path, symbolProxyShape, true);
        }
        if (this.incremental) {
            this._off = i;
            this.notClear = true;
        }
    };
    LargeSymbolPath.prototype.afterBrush = function() {
        var shape = this.shape;
        var points = shape.points;
        var size = shape.size;
        var ctx = this._ctx;
        var softClipShape = this.softClipShape;
        var i;
        if (!ctx) return;
        // PENDING If style or other canvas status changed?
        for(i = this._off; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (isNaN(x) || isNaN(y)) continue;
            if (softClipShape && !softClipShape.contain(x, y)) continue;
            // fillRect is faster than building a rect path and draw.
            // And it support light globalCompositeOperation.
            ctx.fillRect(x - size[0] / 2, y - size[1] / 2, size[0], size[1]);
        }
        if (this.incremental) {
            this._off = i;
            this.notClear = true;
        }
    };
    LargeSymbolPath.prototype.findDataIndex = function(x, y) {
        // TODO ???
        // Consider transform
        var shape = this.shape;
        var points = shape.points;
        var size = shape.size;
        var w = Math.max(size[0], 4);
        var h = Math.max(size[1], 4);
        // Not consider transform
        // Treat each element as a rect
        // top down traverse
        for(var idx = points.length / 2 - 1; idx >= 0; idx--){
            var i = idx * 2;
            var x0 = points[i] - w / 2;
            var y0 = points[i + 1] - h / 2;
            if (x >= x0 && y >= y0 && x <= x0 + w && y <= y0 + h) return idx;
        }
        return -1;
    };
    LargeSymbolPath.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            // Cache found data index.
            var dataIdx = this.hoverDataIdx = this.findDataIndex(x, y);
            return dataIdx >= 0;
        }
        this.hoverDataIdx = -1;
        return false;
    };
    LargeSymbolPath.prototype.getBoundingRect = function() {
        // Ignore stroke for large symbol draw.
        var rect = this._rect;
        if (!rect) {
            var shape = this.shape;
            var points = shape.points;
            var size = shape.size;
            var w = size[0];
            var h = size[1];
            var minX = Infinity;
            var minY = Infinity;
            var maxX = -Infinity;
            var maxY = -Infinity;
            for(var i = 0; i < points.length;){
                var x = points[i++];
                var y = points[i++];
                minX = Math.min(x, minX);
                maxX = Math.max(x, maxX);
                minY = Math.min(y, minY);
                maxY = Math.max(y, maxY);
            }
            rect = this._rect = new $1bebe7106c895823$export$2e2bcd8739ae039(minX - w / 2, minY - h / 2, maxX - minX + w, maxY - minY + h);
        }
        return rect;
    };
    return LargeSymbolPath;
}($b02ffe7acd508c08$export$2e2bcd8739ae039);
var $69bbf770a3ca2c75$var$LargeSymbolDraw = /** @class */ function() {
    function LargeSymbolDraw() {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
    }
    /**
   * Update symbols draw by new data
   */ LargeSymbolDraw.prototype.updateData = function(data, opt) {
        this._clear();
        var symbolEl = this._create();
        symbolEl.setShape({
            points: data.getLayout("points")
        });
        this._setCommon(symbolEl, data, opt);
    };
    LargeSymbolDraw.prototype.updateLayout = function(data) {
        var points = data.getLayout("points");
        this.group.eachChild(function(child) {
            if (child.startIndex != null) {
                var len = (child.endIndex - child.startIndex) * 2;
                var byteOffset = child.startIndex * 8;
                points = new Float32Array(points.buffer, byteOffset, len);
            }
            child.setShape("points", points);
            // Reset draw cursor.
            child.reset();
        });
    };
    LargeSymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
        this._clear();
    };
    LargeSymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
        var lastAdded = this._newAdded[0];
        var points = data.getLayout("points");
        var oldPoints = lastAdded && lastAdded.shape.points;
        // Merging the exists. Each element has 1e4 points.
        // Consider the performance balance between too much elements and too much points in one shape(may affect hover optimization)
        if (oldPoints && oldPoints.length < 2e4) {
            var oldLen = oldPoints.length;
            var newPoints = new Float32Array(oldLen + points.length);
            // Concat two array
            newPoints.set(oldPoints);
            newPoints.set(points, oldLen);
            // Update endIndex
            lastAdded.endIndex = taskParams.end;
            lastAdded.setShape({
                points: newPoints
            });
        } else {
            // Clear
            this._newAdded = [];
            var symbolEl = this._create();
            symbolEl.startIndex = taskParams.start;
            symbolEl.endIndex = taskParams.end;
            symbolEl.incremental = true;
            symbolEl.setShape({
                points: points
            });
            this._setCommon(symbolEl, data, opt);
        }
    };
    LargeSymbolDraw.prototype.eachRendered = function(cb) {
        this._newAdded[0] && cb(this._newAdded[0]);
    };
    LargeSymbolDraw.prototype._create = function() {
        var symbolEl = new $69bbf770a3ca2c75$var$LargeSymbolPath({
            cursor: "default"
        });
        symbolEl.ignoreCoarsePointer = true;
        this.group.add(symbolEl);
        this._newAdded.push(symbolEl);
        return symbolEl;
    };
    LargeSymbolDraw.prototype._setCommon = function(symbolEl, data, opt) {
        var hostModel = data.hostModel;
        opt = opt || {};
        var size = data.getVisual("symbolSize");
        symbolEl.setShape("size", size instanceof Array ? size : [
            size,
            size
        ]);
        symbolEl.softClipShape = opt.clipShape || null;
        // Create symbolProxy to build path for each data
        symbolEl.symbolProxy = (0, $5370466dadc978d7$export$af050e04da3a02e8)(data.getVisual("symbol"), 0, 0, 0, 0);
        // Use symbolProxy setColor method
        symbolEl.setColor = symbolEl.symbolProxy.setColor;
        var extrudeShadow = symbolEl.shape.size[0] < $69bbf770a3ca2c75$var$BOOST_SIZE_THRESHOLD;
        symbolEl.useStyle(// Draw shadow when doing fillRect is extremely slow.
        hostModel.getModel("itemStyle").getItemStyle(extrudeShadow ? [
            "color",
            "shadowBlur",
            "shadowColor"
        ] : [
            "color"
        ]));
        var globalStyle = data.getVisual("style");
        var visualColor = globalStyle && globalStyle.fill;
        if (visualColor) symbolEl.setColor(visualColor);
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(symbolEl);
        // Enable tooltip
        // PENDING May have performance issue when path is extremely large
        ecData.seriesIndex = hostModel.seriesIndex;
        symbolEl.on("mousemove", function(e) {
            ecData.dataIndex = null;
            var dataIndex = symbolEl.hoverDataIdx;
            if (dataIndex >= 0) // Provide dataIndex for tooltip
            ecData.dataIndex = dataIndex + (symbolEl.startIndex || 0);
        });
    };
    LargeSymbolDraw.prototype.remove = function() {
        this._clear();
    };
    LargeSymbolDraw.prototype._clear = function() {
        this._newAdded = [];
        this.group.removeAll();
    };
    return LargeSymbolDraw;
}();
var $69bbf770a3ca2c75$export$2e2bcd8739ae039 = $69bbf770a3ca2c75$var$LargeSymbolDraw;




var $c92a7ada0c69ef68$var$ScatterView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ScatterView, _super);
    function ScatterView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScatterView.type;
        return _this;
    }
    ScatterView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
        symbolDraw.updateData(data, {
            // TODO
            // If this parameter should be a shape or a bounding volume
            // shape will be more general.
            // But bounding volume like bounding rect will be much faster in the contain calculation
            clipShape: this._getClipShape(seriesModel)
        });
        this._finished = true;
    };
    ScatterView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
        symbolDraw.incrementalPrepareUpdate(data);
        this._finished = false;
    };
    ScatterView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        this._symbolDraw.incrementalUpdate(taskParams, seriesModel.getData(), {
            clipShape: this._getClipShape(seriesModel)
        });
        this._finished = taskParams.end === seriesModel.getData().count();
    };
    ScatterView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        // Must mark group dirty and make sure the incremental layer will be cleared
        // PENDING
        this.group.dirty();
        if (!this._finished || data.count() > 1e4) return {
            update: true
        };
        else {
            var res = (0, $73b014aa594ea652$export$2e2bcd8739ae039)("").reset(seriesModel, ecModel, api);
            if (res.progress) res.progress({
                start: 0,
                end: data.count(),
                count: data.count()
            }, data);
            this._symbolDraw.updateLayout(data);
        }
    };
    ScatterView.prototype.eachRendered = function(cb) {
        this._symbolDraw && this._symbolDraw.eachRendered(cb);
    };
    ScatterView.prototype._getClipShape = function(seriesModel) {
        if (!seriesModel.get("clip", true)) return;
        var coordSys = seriesModel.coordinateSystem;
        // PENDING make `0.1` configurable, for example, `clipTolerance`?
        return coordSys && coordSys.getArea && coordSys.getArea(.1);
    };
    ScatterView.prototype._updateSymbolDraw = function(data, seriesModel) {
        var symbolDraw = this._symbolDraw;
        var pipelineContext = seriesModel.pipelineContext;
        var isLargeDraw = pipelineContext.large;
        if (!symbolDraw || isLargeDraw !== this._isLargeDraw) {
            symbolDraw && symbolDraw.remove();
            symbolDraw = this._symbolDraw = isLargeDraw ? new (0, $69bbf770a3ca2c75$export$2e2bcd8739ae039)() : new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)();
            this._isLargeDraw = isLargeDraw;
            this.group.removeAll();
        }
        this.group.add(symbolDraw.group);
        return symbolDraw;
    };
    ScatterView.prototype.remove = function(ecModel, api) {
        this._symbolDraw && this._symbolDraw.remove(true);
        this._symbolDraw = null;
    };
    ScatterView.prototype.dispose = function() {};
    ScatterView.type = "scatter";
    return ScatterView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $c92a7ada0c69ef68$export$2e2bcd8739ae039 = $c92a7ada0c69ef68$var$ScatterView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $d67c268180aaad04$var$GridModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GridModel, _super);
    function GridModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridModel.type = "grid";
    GridModel.dependencies = [
        "xAxis",
        "yAxis"
    ];
    GridModel.layoutMode = "box";
    GridModel.defaultOption = {
        show: false,
        // zlevel: 0,
        z: 0,
        left: "10%",
        top: 60,
        right: "10%",
        bottom: 70,
        // If grid size contain label
        containLabel: false,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        backgroundColor: "rgba(0,0,0,0)",
        borderWidth: 1,
        borderColor: "#ccc"
    };
    return GridModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $d67c268180aaad04$export$2e2bcd8739ae039 = $d67c268180aaad04$var$GridModel;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $008426c98740266e$export$483dc37e6ad83a3c = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CartesianAxisModel, _super);
    function CartesianAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartesianAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents("grid", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
    };
    CartesianAxisModel.type = "cartesian2dAxis";
    return CartesianAxisModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($008426c98740266e$export$483dc37e6ad83a3c, (0, $3449fd4c0590d99e$export$5c54b224726edb5a));
var $008426c98740266e$export$2e2bcd8739ae039 = $008426c98740266e$export$483dc37e6ad83a3c;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $f0775b150bc00f28$var$Cartesian = /** @class */ function() {
    function Cartesian(name) {
        this.type = "cartesian";
        this._dimList = [];
        this._axes = {};
        this.name = name || "";
    }
    Cartesian.prototype.getAxis = function(dim) {
        return this._axes[dim];
    };
    Cartesian.prototype.getAxes = function() {
        return $7a1bd9c2710fea0d$export$871de8747c9eaa88(this._dimList, function(dim) {
            return this._axes[dim];
        }, this);
    };
    Cartesian.prototype.getAxesByScale = function(scaleType) {
        scaleType = scaleType.toLowerCase();
        return $7a1bd9c2710fea0d$export$3dea766d36a8935f(this.getAxes(), function(axis) {
            return axis.scale.type === scaleType;
        });
    };
    Cartesian.prototype.addAxis = function(axis) {
        var dim = axis.dim;
        this._axes[dim] = axis;
        this._dimList.push(dim);
    };
    return Cartesian;
}();
var $f0775b150bc00f28$export$2e2bcd8739ae039 = $f0775b150bc00f28$var$Cartesian;




var $6bea838ef63ff2bb$export$988a008d2b9120f4 = [
    "x",
    "y"
];
function $6bea838ef63ff2bb$var$canCalculateAffineTransform(scale) {
    return scale.type === "interval" || scale.type === "time";
}
var $6bea838ef63ff2bb$var$Cartesian2D = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(Cartesian2D, _super);
    function Cartesian2D() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "cartesian2d";
        _this.dimensions = $6bea838ef63ff2bb$export$988a008d2b9120f4;
        return _this;
    }
    /**
   * Calculate an affine transform matrix if two axes are time or value.
   * It's mainly for accelartion on the large time series data.
   */ Cartesian2D.prototype.calcAffineTransform = function() {
        this._transform = this._invTransform = null;
        var xAxisScale = this.getAxis("x").scale;
        var yAxisScale = this.getAxis("y").scale;
        if (!$6bea838ef63ff2bb$var$canCalculateAffineTransform(xAxisScale) || !$6bea838ef63ff2bb$var$canCalculateAffineTransform(yAxisScale)) return;
        var xScaleExtent = xAxisScale.getExtent();
        var yScaleExtent = yAxisScale.getExtent();
        var start = this.dataToPoint([
            xScaleExtent[0],
            yScaleExtent[0]
        ]);
        var end = this.dataToPoint([
            xScaleExtent[1],
            yScaleExtent[1]
        ]);
        var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
        var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];
        if (!xScaleSpan || !yScaleSpan) return;
        // Accelerate data to point calculation on the special large time series data.
        var scaleX = (end[0] - start[0]) / xScaleSpan;
        var scaleY = (end[1] - start[1]) / yScaleSpan;
        var translateX = start[0] - xScaleExtent[0] * scaleX;
        var translateY = start[1] - yScaleExtent[0] * scaleY;
        var m = this._transform = [
            scaleX,
            0,
            0,
            scaleY,
            translateX,
            translateY
        ];
        this._invTransform = (0, $f41ebb9dd60b55b4$export$6897c284b6f9f4dc)([], m);
    };
    /**
   * Base axis will be used on stacking.
   */ Cartesian2D.prototype.getBaseAxis = function() {
        return this.getAxesByScale("ordinal")[0] || this.getAxesByScale("time")[0] || this.getAxis("x");
    };
    Cartesian2D.prototype.containPoint = function(point) {
        var axisX = this.getAxis("x");
        var axisY = this.getAxis("y");
        return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
    };
    Cartesian2D.prototype.containData = function(data) {
        return this.getAxis("x").containData(data[0]) && this.getAxis("y").containData(data[1]);
    };
    Cartesian2D.prototype.containZone = function(data1, data2) {
        var zoneDiag1 = this.dataToPoint(data1);
        var zoneDiag2 = this.dataToPoint(data2);
        var area = this.getArea();
        var zone = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(zoneDiag1[0], zoneDiag1[1], zoneDiag2[0] - zoneDiag1[0], zoneDiag2[1] - zoneDiag1[1]);
        return area.intersect(zone);
    };
    Cartesian2D.prototype.dataToPoint = function(data, clamp, out) {
        out = out || [];
        var xVal = data[0];
        var yVal = data[1];
        // Fast path
        if (this._transform && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) return (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(out, data, this._transform);
        var xAxis = this.getAxis("x");
        var yAxis = this.getAxis("y");
        out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
        out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
        return out;
    };
    Cartesian2D.prototype.clampData = function(data, out) {
        var xScale = this.getAxis("x").scale;
        var yScale = this.getAxis("y").scale;
        var xAxisExtent = xScale.getExtent();
        var yAxisExtent = yScale.getExtent();
        var x = xScale.parse(data[0]);
        var y = yScale.parse(data[1]);
        out = out || [];
        out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
        out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
        return out;
    };
    Cartesian2D.prototype.pointToData = function(point, clamp) {
        var out = [];
        if (this._invTransform) return (0, $6de594cf8ac295ff$export$9f9dcb98c894b623)(out, point, this._invTransform);
        var xAxis = this.getAxis("x");
        var yAxis = this.getAxis("y");
        out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
        out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
        return out;
    };
    Cartesian2D.prototype.getOtherAxis = function(axis) {
        return this.getAxis(axis.dim === "x" ? "y" : "x");
    };
    /**
   * Get rect area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Cartesian2D.prototype.getArea = function(tolerance) {
        tolerance = tolerance || 0;
        var xExtent = this.getAxis("x").getGlobalExtent();
        var yExtent = this.getAxis("y").getGlobalExtent();
        var x = Math.min(xExtent[0], xExtent[1]) - tolerance;
        var y = Math.min(yExtent[0], yExtent[1]) - tolerance;
        var width = Math.max(xExtent[0], xExtent[1]) - x + tolerance;
        var height = Math.max(yExtent[0], yExtent[1]) - y + tolerance;
        return new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(x, y, width, height);
    };
    return Cartesian2D;
}((0, $f0775b150bc00f28$export$2e2bcd8739ae039));
var $6bea838ef63ff2bb$export$2e2bcd8739ae039 = $6bea838ef63ff2bb$var$Cartesian2D;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $23369073c2236a8d$var$Axis2D = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(Axis2D, _super);
    function Axis2D(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        /**
     * Index of axis, can be used as key
     * Injected outside.
     */ _this.index = 0;
        _this.type = axisType || "value";
        _this.position = position || "bottom";
        return _this;
    }
    Axis2D.prototype.isHorizontal = function() {
        var position = this.position;
        return position === "top" || position === "bottom";
    };
    /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */ Axis2D.prototype.getGlobalExtent = function(asc) {
        var ret = this.getExtent();
        ret[0] = this.toGlobalCoord(ret[0]);
        ret[1] = this.toGlobalCoord(ret[1]);
        asc && ret[0] > ret[1] && ret.reverse();
        return ret;
    };
    Axis2D.prototype.pointToData = function(point, clamp) {
        return this.coordToData(this.toLocalCoord(point[this.dim === "x" ? 0 : 1]), clamp);
    };
    /**
   * Set ordinalSortInfo
   * @param info new OrdinalSortInfo
   */ Axis2D.prototype.setCategorySortInfo = function(info) {
        if (this.type !== "category") return false;
        this.model.option.categorySortInfo = info;
        this.scale.setSortInfo(info);
    };
    return Axis2D;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $23369073c2236a8d$export$2e2bcd8739ae039 = $23369073c2236a8d$var$Axis2D;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $88c937c9bc0ca068$export$b3219800bda33a1f(gridModel, axisModel, opt) {
    opt = opt || {};
    var grid = gridModel.coordinateSystem;
    var axis = axisModel.axis;
    var layout = {};
    var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
    var rawAxisPosition = axis.position;
    var axisPosition = otherAxisOnZeroOf ? "onZero" : rawAxisPosition;
    var axisDim = axis.dim;
    var rect = grid.getRect();
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var idx = {
        left: 0,
        right: 1,
        top: 0,
        bottom: 1,
        onZero: 2
    };
    var axisOffset = axisModel.get("offset") || 0;
    var posBound = axisDim === "x" ? [
        rectBound[2] - axisOffset,
        rectBound[3] + axisOffset
    ] : [
        rectBound[0] - axisOffset,
        rectBound[1] + axisOffset
    ];
    if (otherAxisOnZeroOf) {
        var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
        posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
    }
    // Axis position
    layout.position = [
        axisDim === "y" ? posBound[idx[axisPosition]] : rectBound[0],
        axisDim === "x" ? posBound[idx[axisPosition]] : rectBound[3]
    ];
    // Axis rotation
    layout.rotation = Math.PI / 2 * (axisDim === "x" ? 0 : 1);
    // Tick and label direction, x y is axisDim
    var dirMap = {
        top: -1,
        bottom: 1,
        left: -1,
        right: 1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
    layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
    if (axisModel.get([
        "axisTick",
        "inside"
    ])) layout.tickDirection = -layout.tickDirection;
    if ($7a1bd9c2710fea0d$export$8a4d17b6e8486e66(opt.labelInside, axisModel.get([
        "axisLabel",
        "inside"
    ]))) layout.labelDirection = -layout.labelDirection;
    // Special label rotation
    var labelRotate = axisModel.get([
        "axisLabel",
        "rotate"
    ]);
    layout.labelRotate = axisPosition === "top" ? -labelRotate : labelRotate;
    // Over splitLine and splitArea
    layout.z2 = 1;
    return layout;
}
function $88c937c9bc0ca068$export$c2a0b77974c5e35d(seriesModel) {
    return seriesModel.get("coordinateSystem") === "cartesian2d";
}
function $88c937c9bc0ca068$export$8220131ac1d61d28(seriesModel) {
    var axisModelMap = {
        xAxisModel: null,
        yAxisModel: null
    };
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(axisModelMap, function(v, key) {
        var axisType = key.replace(/Model$/, "");
        var axisModel = seriesModel.getReferringComponents(axisType, (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        axisModelMap[key] = axisModel;
    });
    return axisModelMap;
}




var $8e1d1b12d8439742$var$Grid = /** @class */ function() {
    function Grid(gridModel, ecModel, api) {
        // FIXME:TS where used (different from registered type 'cartesian2d')?
        this.type = "grid";
        this._coordsMap = {};
        this._coordsList = [];
        this._axesMap = {};
        this._axesList = [];
        this.axisPointerEnabled = true;
        this.dimensions = (0, $6bea838ef63ff2bb$export$988a008d2b9120f4);
        this._initCartesian(gridModel, ecModel, api);
        this.model = gridModel;
    }
    Grid.prototype.getRect = function() {
        return this._rect;
    };
    Grid.prototype.update = function(ecModel, api) {
        var axesMap = this._axesMap;
        this._updateScale(ecModel, this.model);
        function updateAxisTicks(axes) {
            var alignTo;
            // Axis is added in order of axisIndex.
            var axesIndices = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(axes);
            var len = axesIndices.length;
            if (!len) return;
            var axisNeedsAlign = [];
            // Process once and calculate the ticks for those don't use alignTicks.
            for(var i = len - 1; i >= 0; i--){
                var idx = +axesIndices[i]; // Convert to number.
                var axis = axes[idx];
                var model = axis.model;
                var scale = axis.scale;
                if (// Only value and log axis without interval support alignTicks.
                (0, $60f7f1f3e3996637$export$dfc8cd28ed7b22a0)(scale) && model.get("alignTicks") && model.get("interval") == null) axisNeedsAlign.push(axis);
                else {
                    (0, $2d646e51cc34f840$export$51f3e70a54405d5a)(scale, model);
                    if ((0, $60f7f1f3e3996637$export$dfc8cd28ed7b22a0)(scale)) // Can only align to interval or log axis.
                    alignTo = axis;
                }
            }
            // All axes has set alignTicks. Pick the first one.
            // PENDING. Should we find the axis that both set interval, min, max and align to this one?
            if (axisNeedsAlign.length) {
                if (!alignTo) {
                    alignTo = axisNeedsAlign.pop();
                    (0, $2d646e51cc34f840$export$51f3e70a54405d5a)(alignTo.scale, alignTo.model);
                }
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisNeedsAlign, function(axis) {
                    (0, $0591b52263f31374$export$c0b3be0e9eb0c2d9)(axis.scale, axis.model, alignTo.scale);
                });
            }
        }
        updateAxisTicks(axesMap.x);
        updateAxisTicks(axesMap.y);
        // Key: axisDim_axisIndex, value: boolean, whether onZero target.
        var onZeroRecords = {};
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap.x, function(xAxis) {
            $8e1d1b12d8439742$var$fixAxisOnZero(axesMap, "y", xAxis, onZeroRecords);
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap.y, function(yAxis) {
            $8e1d1b12d8439742$var$fixAxisOnZero(axesMap, "x", yAxis, onZeroRecords);
        });
        // Resize again if containLabel is enabled
        // FIXME It may cause getting wrong grid size in data processing stage
        this.resize(this.model, api);
    };
    /**
   * Resize the grid
   */ Grid.prototype.resize = function(gridModel, api, ignoreContainLabel) {
        var boxLayoutParams = gridModel.getBoxLayoutParams();
        var isContainLabel = !ignoreContainLabel && gridModel.get("containLabel");
        var gridRect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(boxLayoutParams, {
            width: api.getWidth(),
            height: api.getHeight()
        });
        this._rect = gridRect;
        var axesList = this._axesList;
        adjustAxes();
        // Minus label size
        if (isContainLabel) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesList, function(axis) {
                if (!axis.model.get([
                    "axisLabel",
                    "inside"
                ])) {
                    var labelUnionRect = (0, $2d646e51cc34f840$export$fef1c7f0af0b48d)(axis);
                    if (labelUnionRect) {
                        var dim = axis.isHorizontal() ? "height" : "width";
                        var margin = axis.model.get([
                            "axisLabel",
                            "margin"
                        ]);
                        gridRect[dim] -= labelUnionRect[dim] + margin;
                        if (axis.position === "top") gridRect.y += labelUnionRect.height + margin;
                        else if (axis.position === "left") gridRect.x += labelUnionRect.width + margin;
                    }
                }
            });
            adjustAxes();
        }
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._coordsList, function(coord) {
            // Calculate affine matrix to accelerate the data to point transform.
            // If all the axes scales are time or value.
            coord.calcAffineTransform();
        });
        function adjustAxes() {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesList, function(axis) {
                var isHorizontal = axis.isHorizontal();
                var extent = isHorizontal ? [
                    0,
                    gridRect.width
                ] : [
                    0,
                    gridRect.height
                ];
                var idx = axis.inverse ? 1 : 0;
                axis.setExtent(extent[idx], extent[1 - idx]);
                $8e1d1b12d8439742$var$updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
            });
        }
    };
    Grid.prototype.getAxis = function(dim, axisIndex) {
        var axesMapOnDim = this._axesMap[dim];
        if (axesMapOnDim != null) return axesMapOnDim[axisIndex || 0];
    };
    Grid.prototype.getAxes = function() {
        return this._axesList.slice();
    };
    Grid.prototype.getCartesian = function(xAxisIndex, yAxisIndex) {
        if (xAxisIndex != null && yAxisIndex != null) {
            var key = "x" + xAxisIndex + "y" + yAxisIndex;
            return this._coordsMap[key];
        }
        if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(xAxisIndex)) {
            yAxisIndex = xAxisIndex.yAxisIndex;
            xAxisIndex = xAxisIndex.xAxisIndex;
        }
        for(var i = 0, coordList = this._coordsList; i < coordList.length; i++){
            if (coordList[i].getAxis("x").index === xAxisIndex || coordList[i].getAxis("y").index === yAxisIndex) return coordList[i];
        }
    };
    Grid.prototype.getCartesians = function() {
        return this._coordsList.slice();
    };
    /**
   * @implements
   */ Grid.prototype.convertToPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
    };
    /**
   * @implements
   */ Grid.prototype.convertFromPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
    };
    Grid.prototype._findConvertTarget = function(finder) {
        var seriesModel = finder.seriesModel;
        var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents("xAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents("yAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var gridModel = finder.gridModel;
        var coordsList = this._coordsList;
        var cartesian;
        var axis;
        if (seriesModel) {
            cartesian = seriesModel.coordinateSystem;
            (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(coordsList, cartesian) < 0 && (cartesian = null);
        } else if (xAxisModel && yAxisModel) cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        else if (xAxisModel) axis = this.getAxis("x", xAxisModel.componentIndex);
        else if (yAxisModel) axis = this.getAxis("y", yAxisModel.componentIndex);
        else if (gridModel) {
            var grid = gridModel.coordinateSystem;
            if (grid === this) cartesian = this._coordsList[0];
        }
        return {
            cartesian: cartesian,
            axis: axis
        };
    };
    /**
   * @implements
   */ Grid.prototype.containPoint = function(point) {
        var coord = this._coordsList[0];
        if (coord) return coord.containPoint(point);
    };
    /**
   * Initialize cartesian coordinate systems
   */ Grid.prototype._initCartesian = function(gridModel, ecModel, api) {
        var _this = this;
        var grid = this;
        var axisPositionUsed = {
            left: false,
            right: false,
            top: false,
            bottom: false
        };
        var axesMap = {
            x: {},
            y: {}
        };
        var axesCount = {
            x: 0,
            y: 0
        };
        // Create axis
        ecModel.eachComponent("xAxis", createAxisCreator("x"), this);
        ecModel.eachComponent("yAxis", createAxisCreator("y"), this);
        if (!axesCount.x || !axesCount.y) {
            // Roll back when there no either x or y axis
            this._axesMap = {};
            this._axesList = [];
            return;
        }
        this._axesMap = axesMap;
        // Create cartesian2d
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap.x, function(xAxis, xAxisIndex) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesMap.y, function(yAxis, yAxisIndex) {
                var key = "x" + xAxisIndex + "y" + yAxisIndex;
                var cartesian = new (0, $6bea838ef63ff2bb$export$2e2bcd8739ae039)(key);
                cartesian.master = _this;
                cartesian.model = gridModel;
                _this._coordsMap[key] = cartesian;
                _this._coordsList.push(cartesian);
                cartesian.addAxis(xAxis);
                cartesian.addAxis(yAxis);
            });
        });
        function createAxisCreator(dimName) {
            return function(axisModel, idx) {
                if (!$8e1d1b12d8439742$var$isAxisUsedInTheGrid(axisModel, gridModel)) return;
                var axisPosition = axisModel.get("position");
                if (dimName === "x") // Fix position
                {
                    if (axisPosition !== "top" && axisPosition !== "bottom") // Default bottom of X
                    axisPosition = axisPositionUsed.bottom ? "top" : "bottom";
                } else // Fix position
                if (axisPosition !== "left" && axisPosition !== "right") // Default left of Y
                axisPosition = axisPositionUsed.left ? "right" : "left";
                axisPositionUsed[axisPosition] = true;
                var axis = new (0, $23369073c2236a8d$export$2e2bcd8739ae039)(dimName, (0, $2d646e51cc34f840$export$8941c4cacdc8f5a5)(axisModel), [
                    0,
                    0
                ], axisModel.get("type"), axisPosition);
                var isCategory = axis.type === "category";
                axis.onBand = isCategory && axisModel.get("boundaryGap");
                axis.inverse = axisModel.get("inverse");
                // Inject axis into axisModel
                axisModel.axis = axis;
                // Inject axisModel into axis
                axis.model = axisModel;
                // Inject grid info axis
                axis.grid = grid;
                // Index of axis, can be used as key
                axis.index = idx;
                grid._axesList.push(axis);
                axesMap[dimName][idx] = axis;
                axesCount[dimName]++;
            };
        }
    };
    /**
   * Update cartesian properties from series.
   */ Grid.prototype._updateScale = function(ecModel, gridModel) {
        // Reset scale
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._axesList, function(axis) {
            axis.scale.setExtent(Infinity, -Infinity);
            if (axis.type === "category") {
                var categorySortInfo = axis.model.get("categorySortInfo");
                axis.scale.setSortInfo(categorySortInfo);
            }
        });
        ecModel.eachSeries(function(seriesModel) {
            if ((0, $88c937c9bc0ca068$export$c2a0b77974c5e35d)(seriesModel)) {
                var axesModelMap = (0, $88c937c9bc0ca068$export$8220131ac1d61d28)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                if (!$8e1d1b12d8439742$var$isAxisUsedInTheGrid(xAxisModel, gridModel) || !$8e1d1b12d8439742$var$isAxisUsedInTheGrid(yAxisModel, gridModel)) return;
                var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
                var data = seriesModel.getData();
                var xAxis = cartesian.getAxis("x");
                var yAxis = cartesian.getAxis("y");
                unionExtent(data, xAxis);
                unionExtent(data, yAxis);
            }
        }, this);
        function unionExtent(data, axis) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $2d646e51cc34f840$export$e4cf30b1e74cd69d)(data, axis.dim), function(dim) {
                axis.scale.unionExtentFromData(data, dim);
            });
        }
    };
    /**
   * @param dim 'x' or 'y' or 'auto' or null/undefined
   */ Grid.prototype.getTooltipAxes = function(dim) {
        var baseAxes = [];
        var otherAxes = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this.getCartesians(), function(cartesian) {
            var baseAxis = dim != null && dim !== "auto" ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
            var otherAxis = cartesian.getOtherAxis(baseAxis);
            (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
            (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
        });
        return {
            baseAxes: baseAxes,
            otherAxes: otherAxes
        };
    };
    Grid.create = function(ecModel, api) {
        var grids = [];
        ecModel.eachComponent("grid", function(gridModel, idx) {
            var grid = new Grid(gridModel, ecModel, api);
            grid.name = "grid_" + idx;
            // dataSampling requires axis extent, so resize
            // should be performed in create stage.
            grid.resize(gridModel, api, true);
            gridModel.coordinateSystem = grid;
            grids.push(grid);
        });
        // Inject the coordinateSystems into seriesModel
        ecModel.eachSeries(function(seriesModel) {
            if (!(0, $88c937c9bc0ca068$export$c2a0b77974c5e35d)(seriesModel)) return;
            var axesModelMap = (0, $88c937c9bc0ca068$export$8220131ac1d61d28)(seriesModel);
            var xAxisModel = axesModelMap.xAxisModel;
            var yAxisModel = axesModelMap.yAxisModel;
            var gridModel = xAxisModel.getCoordSysModel();
            var grid = gridModel.coordinateSystem;
            seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        });
        return grids;
    };
    // For deciding which dimensions to use when creating list data
    Grid.dimensions = (0, $6bea838ef63ff2bb$export$988a008d2b9120f4);
    return Grid;
}();
/**
 * Check if the axis is used in the specified grid.
 */ function $8e1d1b12d8439742$var$isAxisUsedInTheGrid(axisModel, gridModel) {
    return axisModel.getCoordSysModel() === gridModel;
}
function $8e1d1b12d8439742$var$fixAxisOnZero(axesMap, otherAxisDim, axis, // Key: see `getOnZeroRecordKey`
onZeroRecords) {
    axis.getAxesOnZeroOf = function() {
        // TODO: onZero of multiple axes.
        return otherAxisOnZeroOf ? [
            otherAxisOnZeroOf
        ] : [];
    };
    // onZero can not be enabled in these two situations:
    // 1. When any other axis is a category axis.
    // 2. When no axis is cross 0 point.
    var otherAxes = axesMap[otherAxisDim];
    var otherAxisOnZeroOf;
    var axisModel = axis.model;
    var onZero = axisModel.get([
        "axisLine",
        "onZero"
    ]);
    var onZeroAxisIndex = axisModel.get([
        "axisLine",
        "onZeroAxisIndex"
    ]);
    if (!onZero) return;
    // If target axis is specified.
    if (onZeroAxisIndex != null) {
        if ($8e1d1b12d8439742$var$canOnZeroToAxis(otherAxes[onZeroAxisIndex])) otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
    } else {
        // Find the first available other axis.
        for(var idx in otherAxes)if (otherAxes.hasOwnProperty(idx) && $8e1d1b12d8439742$var$canOnZeroToAxis(otherAxes[idx]) && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
            otherAxisOnZeroOf = otherAxes[idx];
            break;
        }
    }
    if (otherAxisOnZeroOf) onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
    function getOnZeroRecordKey(axis) {
        return axis.dim + "_" + axis.index;
    }
}
function $8e1d1b12d8439742$var$canOnZeroToAxis(axis) {
    return axis && axis.type !== "category" && axis.type !== "time" && (0, $2d646e51cc34f840$export$3eac36a69f37d52)(axis);
}
function $8e1d1b12d8439742$var$updateAxisTransform(axis, coordBase) {
    var axisExtent = axis.getExtent();
    var axisExtentSum = axisExtent[0] + axisExtent[1];
    // Fast transform
    axis.toGlobalCoord = axis.dim === "x" ? function(coord) {
        return coord + coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
    axis.toLocalCoord = axis.dim === "x" ? function(coord) {
        return coord - coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
}
var $8e1d1b12d8439742$export$2e2bcd8739ae039 = $8e1d1b12d8439742$var$Grid;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $84d826b9ba8bf009$export$bb44f104e3c54dae(ecModel, api) {
    var result = {
        /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      triggerEmphasis,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */ axesInfo: {},
        seriesInvolved: false,
        /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */ coordSysAxesInfo: {},
        coordSysMap: {}
    };
    $84d826b9ba8bf009$var$collectAxesInfo(result, ecModel, api);
    // Check seriesInvolved for performance, in case too many series in some chart.
    result.seriesInvolved && $84d826b9ba8bf009$var$collectSeriesInfo(result, ecModel);
    return result;
}
function $84d826b9ba8bf009$var$collectAxesInfo(result, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent("tooltip");
    var globalAxisPointerModel = ecModel.getComponent("axisPointer");
    // links can only be set on global.
    var linksOption = globalAxisPointerModel.get("link", true) || [];
    var linkGroups = [];
    // Collect axes info.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(api.getCoordinateSystems(), function(coordSys) {
        // Some coordinate system do not support axes, like geo.
        if (!coordSys.axisPointerEnabled) return;
        var coordSysKey = $84d826b9ba8bf009$export$d01b444bafb1a792(coordSys.model);
        var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
        result.coordSysMap[coordSysKey] = coordSys;
        // Set tooltip (like 'cross') is a convenient way to show axisPointer
        // for user. So we enable setting tooltip on coordSys model.
        var coordSysModel = coordSys.model;
        var baseTooltipModel = coordSysModel.getModel("tooltip", globalTooltipModel);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSys.getAxes(), (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(saveTooltipAxisInfo, false, null));
        // If axis tooltip used, choose tooltip axis for each coordSys.
        // Notice this case: coordSys is `grid` but not `cartesian2D` here.
        if (coordSys.getTooltipAxes && globalTooltipModel && baseTooltipModel.get("show")) {
            // Compatible with previous logic. But series.tooltip.trigger: 'axis'
            // or series.data[n].tooltip.trigger: 'axis' are not support any more.
            var triggerAxis = baseTooltipModel.get("trigger") === "axis";
            var cross = baseTooltipModel.get([
                "axisPointer",
                "type"
            ]) === "cross";
            var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get([
                "axisPointer",
                "axis"
            ]));
            if (triggerAxis || cross) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(tooltipAxes.baseAxes, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(saveTooltipAxisInfo, cross ? "cross" : true, triggerAxis));
            if (cross) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(tooltipAxes.otherAxes, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(saveTooltipAxisInfo, "cross", false));
        }
        // fromTooltip: true | false | 'cross'
        // triggerTooltip: true | false | null
        function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
            var axisPointerModel = axis.model.getModel("axisPointer", globalAxisPointerModel);
            var axisPointerShow = axisPointerModel.get("show");
            if (!axisPointerShow || axisPointerShow === "auto" && !fromTooltip && !$84d826b9ba8bf009$var$isHandleTrigger(axisPointerModel)) return;
            if (triggerTooltip == null) triggerTooltip = axisPointerModel.get("triggerTooltip");
            axisPointerModel = fromTooltip ? $84d826b9ba8bf009$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
            var snap = axisPointerModel.get("snap");
            var triggerEmphasis = axisPointerModel.get("triggerEmphasis");
            var axisKey = $84d826b9ba8bf009$export$d01b444bafb1a792(axis.model);
            var involveSeries = triggerTooltip || snap || axis.type === "category";
            // If result.axesInfo[key] exist, override it (tooltip has higher priority).
            var axisInfo = result.axesInfo[axisKey] = {
                key: axisKey,
                axis: axis,
                coordSys: coordSys,
                axisPointerModel: axisPointerModel,
                triggerTooltip: triggerTooltip,
                triggerEmphasis: triggerEmphasis,
                involveSeries: involveSeries,
                snap: snap,
                useHandle: $84d826b9ba8bf009$var$isHandleTrigger(axisPointerModel),
                seriesModels: [],
                linkGroup: null
            };
            axesInfoInCoordSys[axisKey] = axisInfo;
            result.seriesInvolved = result.seriesInvolved || involveSeries;
            var groupIndex = $84d826b9ba8bf009$var$getLinkGroupIndex(linksOption, axis);
            if (groupIndex != null) {
                var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
                    axesInfo: {}
                });
                linkGroup.axesInfo[axisKey] = axisInfo;
                linkGroup.mapper = linksOption[groupIndex].mapper;
                axisInfo.linkGroup = linkGroup;
            }
        }
    });
}
function $84d826b9ba8bf009$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
    var tooltipAxisPointerModel = baseTooltipModel.getModel("axisPointer");
    var fields = [
        "type",
        "snap",
        "lineStyle",
        "shadowStyle",
        "label",
        "animation",
        "animationDurationUpdate",
        "animationEasingUpdate",
        "z"
    ];
    var volatileOption = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(fields, function(field) {
        volatileOption[field] = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(tooltipAxisPointerModel.get(field));
    });
    // category axis do not auto snap, otherwise some tick that do not
    // has value can not be hovered. value/time/log axis default snap if
    // triggered from tooltip and trigger tooltip.
    volatileOption.snap = axis.type !== "category" && !!triggerTooltip;
    // Compatible with previous behavior, tooltip axis does not show label by default.
    // Only these properties can be overridden from tooltip to axisPointer.
    if (tooltipAxisPointerModel.get("type") === "cross") volatileOption.type = "line";
    var labelOption = volatileOption.label || (volatileOption.label = {});
    // Follow the convention, do not show label when triggered by tooltip by default.
    labelOption.show == null && (labelOption.show = false);
    if (fromTooltip === "cross") {
        // When 'cross', both axes show labels.
        var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get([
            "label",
            "show"
        ]);
        labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true;
        // If triggerTooltip, this is a base axis, which should better not use cross style
        // (cross style is dashed by default)
        if (!triggerTooltip) {
            var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get("crossStyle");
            crossStyle && (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(labelOption, crossStyle.textStyle);
        }
    }
    return axis.model.getModel("axisPointer", new (0, $6818646a97528290$export$2e2bcd8739ae039)(volatileOption, globalAxisPointerModel, ecModel));
}
function $84d826b9ba8bf009$var$collectSeriesInfo(result, ecModel) {
    // Prepare data for axis trigger
    ecModel.eachSeries(function(seriesModel) {
        // Notice this case: this coordSys is `cartesian2D` but not `grid`.
        var coordSys = seriesModel.coordinateSystem;
        var seriesTooltipTrigger = seriesModel.get([
            "tooltip",
            "trigger"
        ], true);
        var seriesTooltipShow = seriesModel.get([
            "tooltip",
            "show"
        ], true);
        if (!coordSys || seriesTooltipTrigger === "none" || seriesTooltipTrigger === false || seriesTooltipTrigger === "item" || seriesTooltipShow === false || seriesModel.get([
            "axisPointer",
            "show"
        ], true) === false) return;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(result.coordSysAxesInfo[$84d826b9ba8bf009$export$d01b444bafb1a792(coordSys.model)], function(axisInfo) {
            var axis = axisInfo.axis;
            if (coordSys.getAxis(axis.dim) === axis) {
                axisInfo.seriesModels.push(seriesModel);
                axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
                axisInfo.seriesDataCount += seriesModel.getData().count();
            }
        });
    });
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */ function $84d826b9ba8bf009$var$getLinkGroupIndex(linksOption, axis) {
    var axisModel = axis.model;
    var dim = axis.dim;
    for(var i = 0; i < linksOption.length; i++){
        var linkOption = linksOption[i] || {};
        if ($84d826b9ba8bf009$var$checkPropInLink(linkOption[dim + "AxisId"], axisModel.id) || $84d826b9ba8bf009$var$checkPropInLink(linkOption[dim + "AxisIndex"], axisModel.componentIndex) || $84d826b9ba8bf009$var$checkPropInLink(linkOption[dim + "AxisName"], axisModel.name)) return i;
    }
}
function $84d826b9ba8bf009$var$checkPropInLink(linkPropValue, axisPropValue) {
    return linkPropValue === "all" || (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(linkPropValue) && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}
function $84d826b9ba8bf009$export$f5ea32e3629d8043(axisModel) {
    var axisInfo = $84d826b9ba8bf009$export$bd39458db76002ab(axisModel);
    if (!axisInfo) return;
    var axisPointerModel = axisInfo.axisPointerModel;
    var scale = axisInfo.axis.scale;
    var option = axisPointerModel.option;
    var status = axisPointerModel.get("status");
    var value = axisPointerModel.get("value");
    // Parse init value for category and time axis.
    if (value != null) value = scale.parse(value);
    var useHandle = $84d826b9ba8bf009$var$isHandleTrigger(axisPointerModel);
    // If `handle` used, `axisPointer` will always be displayed, so value
    // and status should be initialized.
    if (status == null) option.status = useHandle ? "show" : "hide";
    var extent = scale.getExtent().slice();
    extent[0] > extent[1] && extent.reverse();
    if (// Pick a value on axis when initializing.
    value == null || value > extent[1]) // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
    if (value < extent[0]) value = extent[0];
    option.value = value;
    if (useHandle) option.status = axisInfo.axis.scale.isBlank() ? "hide" : "show";
}
function $84d826b9ba8bf009$export$bd39458db76002ab(axisModel) {
    var coordSysAxesInfo = (axisModel.ecModel.getComponent("axisPointer") || {}).coordSysAxesInfo;
    return coordSysAxesInfo && coordSysAxesInfo.axesInfo[$84d826b9ba8bf009$export$d01b444bafb1a792(axisModel)];
}
function $84d826b9ba8bf009$export$3b06fce3f68b734(axisModel) {
    var axisInfo = $84d826b9ba8bf009$export$bd39458db76002ab(axisModel);
    return axisInfo && axisInfo.axisPointerModel;
}
function $84d826b9ba8bf009$var$isHandleTrigger(axisPointerModel) {
    return !!axisPointerModel.get([
        "handle",
        "show"
    ]);
}
function $84d826b9ba8bf009$export$d01b444bafb1a792(model) {
    return model.type + "||" + model.id;
}



var $58c48a3ef1aa0746$var$axisPointerClazz = {};
/**
 * Base class of AxisView.
 */ var $58c48a3ef1aa0746$var$AxisView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AxisView, _super);
    function AxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisView.type;
        return _this;
    }
    /**
   * @override
   */ AxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        // FIXME
        // This process should proformed after coordinate systems updated
        // (axis scale updated), and should be performed each time update.
        // So put it here temporarily, although it is not appropriate to
        // put a model-writing procedure in `view`.
        this.axisPointerClass && $84d826b9ba8bf009$export$f5ea32e3629d8043(axisModel);
        _super.prototype.render.apply(this, arguments);
        this._doUpdateAxisPointerClass(axisModel, api, true);
    };
    /**
   * Action handler.
   */ AxisView.prototype.updateAxisPointer = function(axisModel, ecModel, api, payload) {
        this._doUpdateAxisPointerClass(axisModel, api, false);
    };
    /**
   * @override
   */ AxisView.prototype.remove = function(ecModel, api) {
        var axisPointer = this._axisPointer;
        axisPointer && axisPointer.remove(api);
    };
    /**
   * @override
   */ AxisView.prototype.dispose = function(ecModel, api) {
        this._disposeAxisPointer(api);
        _super.prototype.dispose.apply(this, arguments);
    };
    AxisView.prototype._doUpdateAxisPointerClass = function(axisModel, api, forceRender) {
        var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);
        if (!Clazz) return;
        var axisPointerModel = $84d826b9ba8bf009$export$3b06fce3f68b734(axisModel);
        axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
    };
    AxisView.prototype._disposeAxisPointer = function(api) {
        this._axisPointer && this._axisPointer.dispose(api);
        this._axisPointer = null;
    };
    AxisView.registerAxisPointerClass = function(type, clazz) {
        $58c48a3ef1aa0746$var$axisPointerClazz[type] = clazz;
    };
    AxisView.getAxisPointerClass = function(type) {
        return type && $58c48a3ef1aa0746$var$axisPointerClazz[type];
    };
    AxisView.type = "axis";
    return AxisView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $58c48a3ef1aa0746$export$2e2bcd8739ae039 = $58c48a3ef1aa0746$var$AxisView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $ff3096b1f24c33b6$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $ff3096b1f24c33b6$export$c80b7ef1527ec8c9(axisView, axisGroup, axisModel, gridModel) {
    var axis = axisModel.axis;
    if (axis.scale.isBlank()) return;
    // TODO: TYPE
    var splitAreaModel = axisModel.getModel("splitArea");
    var areaStyleModel = splitAreaModel.getModel("areaStyle");
    var areaColors = areaStyleModel.get("color");
    var gridRect = gridModel.coordinateSystem.getRect();
    var ticksCoords = axis.getTicksCoords({
        tickModel: splitAreaModel,
        clamp: true
    });
    if (!ticksCoords.length) return;
    // For Making appropriate splitArea animation, the color and anid
    // should be corresponding to previous one if possible.
    var areaColorsLen = areaColors.length;
    var lastSplitAreaColors = $ff3096b1f24c33b6$var$inner(axisView).splitAreaColors;
    var newSplitAreaColors = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
    var colorIndex = 0;
    if (lastSplitAreaColors) for(var i = 0; i < ticksCoords.length; i++){
        var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
        if (cIndex != null) {
            colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
            break;
        }
    }
    var prev = axis.toGlobalCoord(ticksCoords[0].coord);
    var areaStyle = areaStyleModel.getAreaStyle();
    areaColors = $7a1bd9c2710fea0d$export$43bee75e5e14138e(areaColors) ? areaColors : [
        areaColors
    ];
    for(var i = 1; i < ticksCoords.length; i++){
        var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
        var x = void 0;
        var y = void 0;
        var width = void 0;
        var height = void 0;
        if (axis.isHorizontal()) {
            x = prev;
            y = gridRect.y;
            width = tickCoord - x;
            height = gridRect.height;
            prev = x + width;
        } else {
            x = gridRect.x;
            y = prev;
            width = gridRect.width;
            height = tickCoord - y;
            prev = y + height;
        }
        var tickValue = ticksCoords[i - 1].tickValue;
        tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
        axisGroup.add(new $419e5ff2f303755e$export$2e2bcd8739ae039({
            anid: tickValue != null ? "area_" + tickValue : null,
            shape: {
                x: x,
                y: y,
                width: width,
                height: height
            },
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                fill: areaColors[colorIndex]
            }, areaStyle),
            autoBatch: true,
            silent: true
        }));
        colorIndex = (colorIndex + 1) % areaColorsLen;
    }
    $ff3096b1f24c33b6$var$inner(axisView).splitAreaColors = newSplitAreaColors;
}
function $ff3096b1f24c33b6$export$48ebf2d6ce8ad076(axisView) {
    $ff3096b1f24c33b6$var$inner(axisView).splitAreaColors = null;
}



var $c87c0ba584696283$var$axisBuilderAttrs = [
    "axisLine",
    "axisTickLabel",
    "axisName"
];
var $c87c0ba584696283$var$selfBuilderAttrs = [
    "splitArea",
    "splitLine",
    "minorSplitLine"
];
var $c87c0ba584696283$var$CartesianAxisView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CartesianAxisView, _super);
    function CartesianAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianAxisView.type;
        _this.axisPointerClass = "CartesianAxisPointer";
        return _this;
    }
    /**
   * @override
   */ CartesianAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this.group.add(this._axisGroup);
        if (!axisModel.get("show")) return;
        var gridModel = axisModel.getCoordSysModel();
        var layout = $88c937c9bc0ca068$export$b3219800bda33a1f(gridModel, axisModel);
        var axisBuilder = new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(axisModel, $7a1bd9c2710fea0d$export$8b58be045bf06082({
            handleAutoShown: function(elementType) {
                var cartesians = gridModel.coordinateSystem.getCartesians();
                for(var i = 0; i < cartesians.length; i++){
                    if ((0, $60f7f1f3e3996637$export$dfc8cd28ed7b22a0)(cartesians[i].getOtherAxis(axisModel.axis).scale)) // Still show axis tick or axisLine if other axis is value / log
                    return true;
                }
                // Not show axisTick or axisLine if other axis is category / time
                return false;
            }
        }, layout));
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($c87c0ba584696283$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
        this._axisGroup.add(axisBuilder.getGroup());
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($c87c0ba584696283$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                "show"
            ])) $c87c0ba584696283$var$axisElementBuilders[name](this, this._axisGroup, axisModel, gridModel);
        }, this);
        // THIS is a special case for bar racing chart.
        // Update the axis label from the natural initial layout to
        // sorted layout should has no animation.
        var isInitialSortFromBarRacing = payload && payload.type === "changeAxisOrder" && payload.isInitSort;
        if (!isInitialSortFromBarRacing) $5b455ae6f843ac47$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    CartesianAxisView.prototype.remove = function() {
        (0, $ff3096b1f24c33b6$export$48ebf2d6ce8ad076)(this);
    };
    CartesianAxisView.type = "cartesianAxis";
    return CartesianAxisView;
}((0, $58c48a3ef1aa0746$export$2e2bcd8739ae039));
var $c87c0ba584696283$var$axisElementBuilders = {
    splitLine: function(axisView, axisGroup, axisModel, gridModel) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel("splitLine");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var lineColors = lineStyleModel.get("color");
        lineColors = $7a1bd9c2710fea0d$export$43bee75e5e14138e(lineColors) ? lineColors : [
            lineColors
        ];
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel
        });
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < ticksCoords.length; i++){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var colorIndex = lineCount++ % lineColors.length;
            var tickValue = ticksCoords[i].tickValue;
            var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                anid: tickValue != null ? "line_" + ticksCoords[i].tickValue : null,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                    stroke: lineColors[colorIndex]
                }, lineStyle),
                silent: true
            });
            $5b455ae6f843ac47$export$8b4b620d7f4aad1b(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    minorSplitLine: function(axisView, axisGroup, axisModel, gridModel) {
        var axis = axisModel.axis;
        var minorSplitLineModel = axisModel.getModel("minorSplitLine");
        var lineStyleModel = minorSplitLineModel.getModel("lineStyle");
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var minorTicksCoords = axis.getMinorTicksCoords();
        if (!minorTicksCoords.length) return;
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++){
            var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                anid: "minor_line_" + minorTicksCoords[i][k].tickValue,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: lineStyle,
                silent: true
            });
            $5b455ae6f843ac47$export$8b4b620d7f4aad1b(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    splitArea: function(axisView, axisGroup, axisModel, gridModel) {
        (0, $ff3096b1f24c33b6$export$c80b7ef1527ec8c9)(axisView, axisGroup, axisModel, gridModel);
    }
};
var $c87c0ba584696283$export$b6d40cd875b8a1c8 = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CartesianXAxisView, _super);
    function CartesianXAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianXAxisView.type;
        return _this;
    }
    CartesianXAxisView.type = "xAxis";
    return CartesianXAxisView;
}($c87c0ba584696283$var$CartesianAxisView);
var $c87c0ba584696283$export$417e1bdd0616e0dc = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CartesianYAxisView, _super);
    function CartesianYAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $c87c0ba584696283$export$b6d40cd875b8a1c8.type;
        return _this;
    }
    CartesianYAxisView.type = "yAxis";
    return CartesianYAxisView;
}($c87c0ba584696283$var$CartesianAxisView);
var $c87c0ba584696283$export$2e2bcd8739ae039 = $c87c0ba584696283$var$CartesianAxisView;


// Grid view
var $1021478d6a16b0aa$var$GridView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GridView, _super);
    function GridView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "grid";
        return _this;
    }
    GridView.prototype.render = function(gridModel, ecModel) {
        this.group.removeAll();
        if (gridModel.get("show")) this.group.add(new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            shape: gridModel.coordinateSystem.getRect(),
            style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                fill: gridModel.get("backgroundColor")
            }, gridModel.getItemStyle()),
            silent: true,
            z2: -1
        }));
    };
    GridView.type = "grid";
    return GridView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $1021478d6a16b0aa$var$extraOption = {
    // gridIndex: 0,
    // gridId: '',
    offset: 0
};
function $1021478d6a16b0aa$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView($1021478d6a16b0aa$var$GridView);
    registers.registerComponentModel((0, $d67c268180aaad04$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("cartesian2d", (0, $8e1d1b12d8439742$export$2e2bcd8739ae039));
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, "x", (0, $008426c98740266e$export$483dc37e6ad83a3c), $1021478d6a16b0aa$var$extraOption);
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, "y", (0, $008426c98740266e$export$483dc37e6ad83a3c), $1021478d6a16b0aa$var$extraOption);
    registers.registerComponentView((0, $c87c0ba584696283$export$b6d40cd875b8a1c8));
    registers.registerComponentView((0, $c87c0ba584696283$export$417e1bdd0616e0dc));
    registers.registerPreprocessor(function(option) {
        // Only create grid when need
        if (option.xAxis && option.yAxis && !option.grid) option.grid = {};
    });
}



function $1214e5d7a4a6f990$export$4b3e715f166fdd78(registers) {
    // In case developer forget to include grid component
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $1021478d6a16b0aa$export$4b3e715f166fdd78));
    registers.registerSeriesModel((0, $00ab9646b588965f$export$2e2bcd8739ae039));
    registers.registerChartView((0, $c92a7ada0c69ef68$export$2e2bcd8739ae039));
    registers.registerLayout((0, $73b014aa594ea652$export$2e2bcd8739ae039)("scatter"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 










var $9b5b8a865cafa8ae$var$DEFAULT_SECTOR_Z = 2;
var $9b5b8a865cafa8ae$var$DEFAULT_TEXT_Z = 4;
/**
 * Sunburstce of Sunburst including Sector, Label, LabelLine
 */ var $9b5b8a865cafa8ae$var$SunburstPiece = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SunburstPiece, _super);
    function SunburstPiece(node, seriesModel, ecModel, api) {
        var _this = _super.call(this) || this;
        _this.z2 = $9b5b8a865cafa8ae$var$DEFAULT_SECTOR_Z;
        _this.textConfig = {
            inside: true
        };
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(_this).seriesIndex = seriesModel.seriesIndex;
        var text = new $fe885cc21795562b$export$2e2bcd8739ae039({
            z2: $9b5b8a865cafa8ae$var$DEFAULT_TEXT_Z,
            silent: node.getModel().get([
                "label",
                "silent"
            ])
        });
        _this.setTextContent(text);
        _this.updateData(true, node, seriesModel, ecModel, api);
        return _this;
    }
    SunburstPiece.prototype.updateData = function(firstCreate, node, // state: 'emphasis' | 'normal' | 'highlight' | 'downplay',
    seriesModel, ecModel, api) {
        this.node = node;
        node.piece = this;
        seriesModel = seriesModel || this._seriesModel;
        ecModel = ecModel || this._ecModel;
        var sector = this;
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(sector).dataIndex = node.dataIndex;
        var itemModel = node.getModel();
        var emphasisModel = itemModel.getModel("emphasis");
        var layout = node.getLayout();
        var sectorShape = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, layout);
        sectorShape.label = null;
        var normalStyle = node.getVisual("style");
        normalStyle.lineJoin = "bevel";
        var decal = node.getVisual("decal");
        if (decal) normalStyle.decal = (0, $c6d646aacd243427$export$a3ba048e1a648972)(decal, api);
        var cornerRadius = (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemModel.getModel("itemStyle"), sectorShape, true);
        $7a1bd9c2710fea0d$export$8b58be045bf06082(sectorShape, cornerRadius);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43((0, $2bf82c0980125b62$export$151308dceb52d5b), function(stateName) {
            var state = sector.ensureState(stateName);
            var itemStyleModel = itemModel.getModel([
                stateName,
                "itemStyle"
            ]);
            state.style = itemStyleModel.getItemStyle();
            // border radius
            var cornerRadius = (0, $9491a9b96e203579$export$b395eeeb2ad7cce5)(itemStyleModel, sectorShape);
            if (cornerRadius) state.shape = cornerRadius;
        });
        if (firstCreate) {
            sector.setShape(sectorShape);
            sector.shape.r = layout.r0;
            $8b353638fbedfefa$export$a121566aadcfe021(sector, {
                shape: {
                    r: layout.r
                }
            }, seriesModel, node.dataIndex);
        } else {
            // Disable animation for gradient since no interpolation method
            // is supported for gradient
            $8b353638fbedfefa$export$c8dce3c08436e91e(sector, {
                shape: sectorShape
            }, seriesModel);
            (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(sector);
        }
        sector.useStyle(normalStyle);
        this._updateLabel(seriesModel);
        var cursorStyle = itemModel.getShallow("cursor");
        cursorStyle && sector.attr("cursor", cursorStyle);
        this._seriesModel = seriesModel || this._seriesModel;
        this._ecModel = ecModel || this._ecModel;
        var focus = emphasisModel.get("focus");
        var focusOrIndices = focus === "ancestor" ? node.getAncestorsIndices() : focus === "descendant" ? node.getDescendantIndices() : focus;
        (0, $2bf82c0980125b62$export$e51187539ff11209)(this, focusOrIndices, emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
    };
    SunburstPiece.prototype._updateLabel = function(seriesModel) {
        var _this = this;
        var itemModel = this.node.getModel();
        var normalLabelModel = itemModel.getModel("label");
        var layout = this.node.getLayout();
        var angle = layout.endAngle - layout.startAngle;
        var midAngle = (layout.startAngle + layout.endAngle) / 2;
        var dx = Math.cos(midAngle);
        var dy = Math.sin(midAngle);
        var sector = this;
        var label = sector.getTextContent();
        var dataIndex = this.node.dataIndex;
        var labelMinAngle = normalLabelModel.get("minAngle") / 180 * Math.PI;
        var isNormalShown = normalLabelModel.get("show") && !(labelMinAngle != null && Math.abs(angle) < labelMinAngle);
        label.ignore = !isNormalShown;
        // TODO use setLabelStyle
        $7a1bd9c2710fea0d$export$79b2f7037acddd43((0, $2bf82c0980125b62$export$57ee5306b85ad7d5), function(stateName) {
            var labelStateModel = stateName === "normal" ? itemModel.getModel("label") : itemModel.getModel([
                stateName,
                "label"
            ]);
            var isNormal = stateName === "normal";
            var state = isNormal ? label : label.ensureState(stateName);
            var text = seriesModel.getFormattedLabel(dataIndex, stateName);
            if (isNormal) text = text || _this.node.name;
            state.style = (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelStateModel, {}, null, stateName !== "normal", true);
            if (text) state.style.text = text;
            // Not displaying text when angle is too small
            var isShown = labelStateModel.get("show");
            if (isShown != null && !isNormal) state.ignore = !isShown;
            var labelPosition = getLabelAttr(labelStateModel, "position");
            var sectorState = isNormal ? sector : sector.states[stateName];
            var labelColor = sectorState.style.fill;
            sectorState.textConfig = {
                outsideFill: labelStateModel.get("color") === "inherit" ? labelColor : null,
                inside: labelPosition !== "outside"
            };
            var r;
            var labelPadding = getLabelAttr(labelStateModel, "distance") || 0;
            var textAlign = getLabelAttr(labelStateModel, "align");
            var rotateType = getLabelAttr(labelStateModel, "rotate");
            var flipStartAngle = Math.PI * 0.5;
            var flipEndAngle = Math.PI * 1.5;
            var midAngleNormal = (0, $b44a8536c7214e4f$export$d44861331f213635)(rotateType === "tangential" ? Math.PI / 2 - midAngle : midAngle);
            // For text that is up-side down, rotate 180 degrees to make sure
            // it's readable
            var needsFlip = midAngleNormal > flipStartAngle && !(0, $cfc1f3b422a3185f$export$d1df570aea2868f)(midAngleNormal - flipStartAngle) && midAngleNormal < flipEndAngle;
            if (labelPosition === "outside") {
                r = layout.r + labelPadding;
                textAlign = needsFlip ? "right" : "left";
            } else {
                if (!textAlign || textAlign === "center") {
                    // Put label in the center if it's a circle
                    if (angle === 2 * Math.PI && layout.r0 === 0) r = 0;
                    else r = (layout.r + layout.r0) / 2;
                    textAlign = "center";
                } else if (textAlign === "left") {
                    r = layout.r0 + labelPadding;
                    textAlign = needsFlip ? "right" : "left";
                } else if (textAlign === "right") {
                    r = layout.r - labelPadding;
                    textAlign = needsFlip ? "left" : "right";
                }
            }
            state.style.align = textAlign;
            state.style.verticalAlign = getLabelAttr(labelStateModel, "verticalAlign") || "middle";
            state.x = r * dx + layout.cx;
            state.y = r * dy + layout.cy;
            var rotate = 0;
            if (rotateType === "radial") rotate = (0, $b44a8536c7214e4f$export$d44861331f213635)(-midAngle) + (needsFlip ? Math.PI : 0);
            else if (rotateType === "tangential") rotate = (0, $b44a8536c7214e4f$export$d44861331f213635)(Math.PI / 2 - midAngle) + (needsFlip ? Math.PI : 0);
            else if ($7a1bd9c2710fea0d$export$7e4aa119212bc614(rotateType)) rotate = rotateType * Math.PI / 180;
            state.rotation = (0, $b44a8536c7214e4f$export$d44861331f213635)(rotate);
        });
        function getLabelAttr(model, name) {
            var stateAttr = model.get(name);
            if (stateAttr == null) return normalLabelModel.get(name);
            return stateAttr;
        }
        label.dirtyStyle();
    };
    return SunburstPiece;
}($a3e1dec0a3875b49$export$2e2bcd8739ae039);
var $9b5b8a865cafa8ae$export$2e2bcd8739ae039 = $9b5b8a865cafa8ae$var$SunburstPiece;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $6341f66602946a06$export$c5445fa59c15dec4(payload, validPayloadTypes, seriesModel) {
    if (payload && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(validPayloadTypes, payload.type) >= 0) {
        var root = seriesModel.getData().tree.root;
        var targetNode = payload.targetNode;
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(targetNode)) targetNode = root.getNodeById(targetNode);
        if (targetNode && root.contains(targetNode)) return {
            node: targetNode
        };
        var targetNodeId = payload.targetNodeId;
        if (targetNodeId != null && (targetNode = root.getNodeById(targetNodeId))) return {
            node: targetNode
        };
    }
}
function $6341f66602946a06$export$6be31fe4499506f9(node) {
    var path = [];
    while(node){
        node = node.parentNode;
        node && path.push(node);
    }
    return path.reverse();
}
function $6341f66602946a06$export$df59de26c77b5bea(viewRoot, node) {
    var viewPath = $6341f66602946a06$export$6be31fe4499506f9(viewRoot);
    return $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(viewPath, node) >= 0;
}
function $6341f66602946a06$export$c5baa480d6ceb0a3(node, seriesModel) {
    var treePathInfo = [];
    while(node){
        var nodeDataIndex = node.dataIndex;
        treePathInfo.push({
            name: node.name,
            dataIndex: nodeDataIndex,
            value: seriesModel.getRawValue(nodeDataIndex)
        });
        node = node.parentNode;
    }
    treePathInfo.reverse();
    return treePathInfo;
}


var $aae4889dfc91fba0$export$b06afbbb40399c8b = "sunburstRootToNode";
var $aae4889dfc91fba0$var$HIGHLIGHT_ACTION = "sunburstHighlight";
var $aae4889dfc91fba0$var$UNHIGHLIGHT_ACTION = "sunburstUnhighlight";
function $aae4889dfc91fba0$export$d2def111ea616eb3(registers) {
    registers.registerAction({
        type: $aae4889dfc91fba0$export$b06afbbb40399c8b,
        update: "updateView"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "series",
            subType: "sunburst",
            query: payload
        }, handleRootToNode);
        function handleRootToNode(model, index) {
            var targetInfo = (0, $6341f66602946a06$export$c5445fa59c15dec4)(payload, [
                $aae4889dfc91fba0$export$b06afbbb40399c8b
            ], model);
            if (targetInfo) {
                var originViewRoot = model.getViewRoot();
                if (originViewRoot) payload.direction = (0, $6341f66602946a06$export$df59de26c77b5bea)(originViewRoot, targetInfo.node) ? "rollUp" : "drillDown";
                model.resetViewRoot(targetInfo.node);
            }
        }
    });
    registers.registerAction({
        type: $aae4889dfc91fba0$var$HIGHLIGHT_ACTION,
        update: "none"
    }, function(payload, ecModel, api) {
        // Clone
        payload = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, payload);
        ecModel.eachComponent({
            mainType: "series",
            subType: "sunburst",
            query: payload
        }, handleHighlight);
        function handleHighlight(model) {
            var targetInfo = (0, $6341f66602946a06$export$c5445fa59c15dec4)(payload, [
                $aae4889dfc91fba0$var$HIGHLIGHT_ACTION
            ], model);
            if (targetInfo) payload.dataIndex = targetInfo.node.dataIndex;
        }
        // Fast forward action
        api.dispatchAction((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(payload, {
            type: "highlight"
        }));
    });
    registers.registerAction({
        type: $aae4889dfc91fba0$var$UNHIGHLIGHT_ACTION,
        update: "updateView"
    }, function(payload, ecModel, api) {
        payload = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, payload);
        api.dispatchAction((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(payload, {
            type: "downplay"
        }));
    });
}



var $270cb27be00846ce$var$SunburstView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SunburstView, _super);
    function SunburstView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SunburstView.type;
        return _this;
    }
    SunburstView.prototype.render = function(seriesModel, ecModel, api, // @ts-ignore
    payload) {
        var self = this;
        this.seriesModel = seriesModel;
        this.api = api;
        this.ecModel = ecModel;
        var data = seriesModel.getData();
        var virtualRoot = data.tree.root;
        var newRoot = seriesModel.getViewRoot();
        var group = this.group;
        var renderLabelForZeroData = seriesModel.get("renderLabelForZeroData");
        var newChildren = [];
        newRoot.eachNode(function(node) {
            newChildren.push(node);
        });
        var oldChildren = this._oldChildren || [];
        dualTravel(newChildren, oldChildren);
        renderRollUp(virtualRoot, newRoot);
        this._initEvents();
        this._oldChildren = newChildren;
        function dualTravel(newChildren, oldChildren) {
            if (newChildren.length === 0 && oldChildren.length === 0) return;
            new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldChildren, newChildren, getKey, getKey).add(processNode).update(processNode).remove($7a1bd9c2710fea0d$export$c3095a23b368d1f2(processNode, null)).execute();
            function getKey(node) {
                return node.getId();
            }
            function processNode(newIdx, oldIdx) {
                var newNode = newIdx == null ? null : newChildren[newIdx];
                var oldNode = oldIdx == null ? null : oldChildren[oldIdx];
                doRenderNode(newNode, oldNode);
            }
        }
        function doRenderNode(newNode, oldNode) {
            if (!renderLabelForZeroData && newNode && !newNode.getValue()) // Not render data with value 0
            newNode = null;
            if (newNode !== virtualRoot && oldNode !== virtualRoot) {
                if (oldNode && oldNode.piece) {
                    if (newNode) {
                        // Update
                        oldNode.piece.updateData(false, newNode, seriesModel, ecModel, api);
                        // For tooltip
                        data.setItemGraphicEl(newNode.dataIndex, oldNode.piece);
                    } else // Remove
                    removeNode(oldNode);
                } else if (newNode) {
                    // Add
                    var piece = new (0, $9b5b8a865cafa8ae$export$2e2bcd8739ae039)(newNode, seriesModel, ecModel, api);
                    group.add(piece);
                    // For tooltip
                    data.setItemGraphicEl(newNode.dataIndex, piece);
                }
            }
        }
        function removeNode(node) {
            if (!node) return;
            if (node.piece) {
                group.remove(node.piece);
                node.piece = null;
            }
        }
        function renderRollUp(virtualRoot, viewRoot) {
            if (viewRoot.depth > 0) {
                // Render
                if (self.virtualPiece) // Update
                self.virtualPiece.updateData(false, virtualRoot, seriesModel, ecModel, api);
                else {
                    // Add
                    self.virtualPiece = new (0, $9b5b8a865cafa8ae$export$2e2bcd8739ae039)(virtualRoot, seriesModel, ecModel, api);
                    group.add(self.virtualPiece);
                }
                // TODO event scope
                viewRoot.piece.off("click");
                self.virtualPiece.on("click", function(e) {
                    self._rootToNode(viewRoot.parentNode);
                });
            } else if (self.virtualPiece) {
                // Remove
                group.remove(self.virtualPiece);
                self.virtualPiece = null;
            }
        }
    };
    /**
   * @private
   */ SunburstView.prototype._initEvents = function() {
        var _this = this;
        this.group.off("click");
        this.group.on("click", function(e) {
            var targetFound = false;
            var viewRoot = _this.seriesModel.getViewRoot();
            viewRoot.eachNode(function(node) {
                if (!targetFound && node.piece && node.piece === e.target) {
                    var nodeClick = node.getModel().get("nodeClick");
                    if (nodeClick === "rootToNode") _this._rootToNode(node);
                    else if (nodeClick === "link") {
                        var itemModel = node.getModel();
                        var link = itemModel.get("link");
                        if (link) {
                            var linkTarget = itemModel.get("target", true) || "_blank";
                            (0, $c84c9521536c601a$export$13e13f9b96dbe8fa)(link, linkTarget);
                        }
                    }
                    targetFound = true;
                }
            });
        });
    };
    /**
   * @private
   */ SunburstView.prototype._rootToNode = function(node) {
        if (node !== this.seriesModel.getViewRoot()) this.api.dispatchAction({
            type: (0, $aae4889dfc91fba0$export$b06afbbb40399c8b),
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: node
        });
    };
    /**
   * @implement
   */ SunburstView.prototype.containPoint = function(point, seriesModel) {
        var treeRoot = seriesModel.getData();
        var itemLayout = treeRoot.getItemLayout(0);
        if (itemLayout) {
            var dx = point[0] - itemLayout.cx;
            var dy = point[1] - itemLayout.cy;
            var radius = Math.sqrt(dx * dx + dy * dy);
            return radius <= itemLayout.r && radius >= itemLayout.r0;
        }
    };
    SunburstView.type = "sunburst";
    return SunburstView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
var $270cb27be00846ce$export$2e2bcd8739ae039 = $270cb27be00846ce$var$SunburstView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Tree data structure
 */ 




var $116fa5bb9335391f$export$2eba8ec3a333fdbb = /** @class */ function() {
    function TreeNode(name, hostTree) {
        this.depth = 0;
        this.height = 0;
        /**
     * Reference to list item.
     * Do not persistent dataIndex outside,
     * besause it may be changed by list.
     * If dataIndex -1,
     * this node is logical deleted (filtered) in list.
     */ this.dataIndex = -1;
        this.children = [];
        this.viewChildren = [];
        this.isExpand = false;
        this.name = name || "";
        this.hostTree = hostTree;
    }
    /**
   * The node is removed.
   */ TreeNode.prototype.isRemoved = function() {
        return this.dataIndex < 0;
    };
    TreeNode.prototype.eachNode = function(options, cb, context) {
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(options)) {
            context = cb;
            cb = options;
            options = null;
        }
        options = options || {};
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(options)) options = {
            order: options
        };
        var order = options.order || "preorder";
        var children = this[options.attr || "children"];
        var suppressVisitSub;
        order === "preorder" && (suppressVisitSub = cb.call(context, this));
        for(var i = 0; !suppressVisitSub && i < children.length; i++)children[i].eachNode(options, cb, context);
        order === "postorder" && cb.call(context, this);
    };
    /**
   * Update depth and height of this subtree.
   */ TreeNode.prototype.updateDepthAndHeight = function(depth) {
        var height = 0;
        this.depth = depth;
        for(var i = 0; i < this.children.length; i++){
            var child = this.children[i];
            child.updateDepthAndHeight(depth + 1);
            if (child.height > height) height = child.height;
        }
        this.height = height + 1;
    };
    TreeNode.prototype.getNodeById = function(id) {
        if (this.getId() === id) return this;
        for(var i = 0, children = this.children, len = children.length; i < len; i++){
            var res = children[i].getNodeById(id);
            if (res) return res;
        }
    };
    TreeNode.prototype.contains = function(node) {
        if (node === this) return true;
        for(var i = 0, children = this.children, len = children.length; i < len; i++){
            var res = children[i].contains(node);
            if (res) return res;
        }
    };
    /**
   * @param includeSelf Default false.
   * @return order: [root, child, grandchild, ...]
   */ TreeNode.prototype.getAncestors = function(includeSelf) {
        var ancestors = [];
        var node = includeSelf ? this : this.parentNode;
        while(node){
            ancestors.push(node);
            node = node.parentNode;
        }
        ancestors.reverse();
        return ancestors;
    };
    TreeNode.prototype.getAncestorsIndices = function() {
        var indices = [];
        var currNode = this;
        while(currNode){
            indices.push(currNode.dataIndex);
            currNode = currNode.parentNode;
        }
        indices.reverse();
        return indices;
    };
    TreeNode.prototype.getDescendantIndices = function() {
        var indices = [];
        this.eachNode(function(childNode) {
            indices.push(childNode.dataIndex);
        });
        return indices;
    };
    TreeNode.prototype.getValue = function(dimension) {
        var data = this.hostTree.data;
        return data.getStore().get(data.getDimensionIndex(dimension || "value"), this.dataIndex);
    };
    TreeNode.prototype.setLayout = function(layout, merge) {
        this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, layout, merge);
    };
    /**
   * @return {Object} layout
   */ TreeNode.prototype.getLayout = function() {
        return this.hostTree.data.getItemLayout(this.dataIndex);
    };
    // @depcrecated
    // getModel<T = unknown, S extends keyof T = keyof T>(path: S): Model<T[S]>
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    TreeNode.prototype.getModel = function(path) {
        if (this.dataIndex < 0) return;
        var hostTree = this.hostTree;
        var itemModel = hostTree.data.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    };
    // TODO: TYPE More specific model
    TreeNode.prototype.getLevelModel = function() {
        return (this.hostTree.levelModels || [])[this.depth];
    };
    TreeNode.prototype.setVisual = function(key, value) {
        this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, key, value);
    };
    /**
   * Get item visual
   * FIXME: make return type better
   */ TreeNode.prototype.getVisual = function(key) {
        return this.hostTree.data.getItemVisual(this.dataIndex, key);
    };
    TreeNode.prototype.getRawIndex = function() {
        return this.hostTree.data.getRawIndex(this.dataIndex);
    };
    TreeNode.prototype.getId = function() {
        return this.hostTree.data.getId(this.dataIndex);
    };
    /**
   * index in parent's children
   */ TreeNode.prototype.getChildIndex = function() {
        if (this.parentNode) {
            var children = this.parentNode.children;
            for(var i = 0; i < children.length; ++i){
                if (children[i] === this) return i;
            }
            return -1;
        }
        return -1;
    };
    /**
   * if this is an ancestor of another node
   *
   * @param node another node
   * @return if is ancestor
   */ TreeNode.prototype.isAncestorOf = function(node) {
        var parent = node.parentNode;
        while(parent){
            if (parent === this) return true;
            parent = parent.parentNode;
        }
        return false;
    };
    /**
   * if this is an descendant of another node
   *
   * @param node another node
   * @return if is descendant
   */ TreeNode.prototype.isDescendantOf = function(node) {
        return node !== this && node.isAncestorOf(this);
    };
    return TreeNode;
}();
var $116fa5bb9335391f$var$Tree = /** @class */ function() {
    function Tree(hostModel) {
        this.type = "tree";
        this._nodes = [];
        this.hostModel = hostModel;
    }
    Tree.prototype.eachNode = function(options, cb, context) {
        this.root.eachNode(options, cb, context);
    };
    Tree.prototype.getNodeByDataIndex = function(dataIndex) {
        var rawIndex = this.data.getRawIndex(dataIndex);
        return this._nodes[rawIndex];
    };
    Tree.prototype.getNodeById = function(name) {
        return this.root.getNodeById(name);
    };
    /**
   * Update item available by list,
   * when list has been performed options like 'filterSelf' or 'map'.
   */ Tree.prototype.update = function() {
        var data = this.data;
        var nodes = this._nodes;
        for(var i = 0, len = nodes.length; i < len; i++)nodes[i].dataIndex = -1;
        for(var i = 0, len = data.count(); i < len; i++)nodes[data.getRawIndex(i)].dataIndex = i;
    };
    /**
   * Clear all layouts
   */ Tree.prototype.clearLayouts = function() {
        this.data.clearItemLayouts();
    };
    /**
   * data node format:
   * {
   *     name: ...
   *     value: ...
   *     children: [
   *         {
   *             name: ...
   *             value: ...
   *             children: ...
   *         },
   *         ...
   *     ]
   * }
   */ Tree.createTree = function(dataRoot, hostModel, beforeLink) {
        var tree = new Tree(hostModel);
        var listData = [];
        var dimMax = 1;
        buildHierarchy(dataRoot);
        function buildHierarchy(dataNode, parentNode) {
            var value = dataNode.value;
            dimMax = Math.max(dimMax, $7a1bd9c2710fea0d$export$43bee75e5e14138e(value) ? value.length : 1);
            listData.push(dataNode);
            var node = new $116fa5bb9335391f$export$2eba8ec3a333fdbb((0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(dataNode.name, ""), tree);
            parentNode ? $116fa5bb9335391f$var$addChild(node, parentNode) : tree.root = node;
            tree._nodes.push(node);
            var children = dataNode.children;
            if (children) for(var i = 0; i < children.length; i++)buildHierarchy(children[i], node);
        }
        tree.root.updateDepthAndHeight(0);
        var dimensions = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(listData, {
            coordDimensions: [
                "value"
            ],
            dimensionsCount: dimMax
        }).dimensions;
        var list = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dimensions, hostModel);
        list.initData(listData);
        beforeLink && beforeLink(list);
        (0, $4a8451eb7786c849$export$2e2bcd8739ae039)({
            mainData: list,
            struct: tree,
            structAttr: "tree"
        });
        tree.update();
        return tree;
    };
    return Tree;
}();
/**
 * It is needed to consider the mess of 'list', 'hostModel' when creating a TreeNote,
 * so this function is not ready and not necessary to be public.
 */ function $116fa5bb9335391f$var$addChild(child, node) {
    var children = node.children;
    if (child.parentNode === node) return;
    children.push(child);
    child.parentNode = node;
}
var $116fa5bb9335391f$export$2e2bcd8739ae039 = $116fa5bb9335391f$var$Tree;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $a116b59e46d9072c$export$2e2bcd8739ae039(seriesModel) {
    var data = seriesModel.getData();
    var tree = data.tree;
    var decalPaletteScope = {};
    tree.eachNode(function(node) {
        // Use decal of level 1 node
        var current = node;
        while(current && current.depth > 1)current = current.parentNode;
        var decal = (0, $e7fbd47751ca3c28$export$e4d892222945a227)(seriesModel.ecModel, current.name || current.dataIndex + "", decalPaletteScope);
        node.setVisual("decal", decal);
    });
}


var $5204df39d5781117$var$SunburstSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SunburstSeriesModel, _super);
    function SunburstSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SunburstSeriesModel.type;
        _this.ignoreStyleOnData = true;
        return _this;
    }
    SunburstSeriesModel.prototype.getInitialData = function(option, ecModel) {
        // Create a virtual root.
        var root = {
            name: option.name,
            children: option.data
        };
        $5204df39d5781117$var$completeTreeValue(root);
        var levelModels = this._levelModels = $7a1bd9c2710fea0d$export$871de8747c9eaa88(option.levels || [], function(levelDefine) {
            return new (0, $6818646a97528290$export$2e2bcd8739ae039)(levelDefine, this, ecModel);
        }, this);
        // Make sure always a new tree is created when setOption,
        // in TreemapView, we check whether oldTree === newTree
        // to choose mappings approach among old shapes and new shapes.
        var tree = (0, $116fa5bb9335391f$export$2e2bcd8739ae039).createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod("getItemModel", function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                var levelModel = levelModels[node.depth];
                levelModel && (model.parentModel = levelModel);
                return model;
            });
        }
        return tree.data;
    };
    SunburstSeriesModel.prototype.optionUpdated = function() {
        this.resetViewRoot();
    };
    /*
   * @override
   */ SunburstSeriesModel.prototype.getDataParams = function(dataIndex) {
        var params = _super.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treePathInfo = (0, $6341f66602946a06$export$c5baa480d6ceb0a3)(node, this);
        return params;
    };
    SunburstSeriesModel.prototype.getLevelModel = function(node) {
        return this._levelModels && this._levelModels[node.depth];
    };
    SunburstSeriesModel.prototype.getViewRoot = function() {
        return this._viewRoot;
    };
    SunburstSeriesModel.prototype.resetViewRoot = function(viewRoot) {
        viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
        var root = this.getRawData().tree.root;
        if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) this._viewRoot = root;
    };
    SunburstSeriesModel.prototype.enableAriaDecal = function() {
        (0, $a116b59e46d9072c$export$2e2bcd8739ae039)(this);
    };
    SunburstSeriesModel.type = "series.sunburst";
    SunburstSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        // 默认全局居中
        center: [
            "50%",
            "50%"
        ],
        radius: [
            0,
            "75%"
        ],
        // 默认顺时针
        clockwise: true,
        startAngle: 90,
        // 最小角度改为0
        minAngle: 0,
        // If still show when all data zero.
        stillShowZeroSum: true,
        // 'rootToNode', 'link', or false
        nodeClick: "rootToNode",
        renderLabelForZeroData: false,
        label: {
            // could be: 'radial', 'tangential', or 'none'
            rotate: "radial",
            show: true,
            opacity: 1,
            // 'left' is for inner side of inside, and 'right' is for outer
            // side for inside
            align: "center",
            position: "inside",
            distance: 5,
            silent: true
        },
        itemStyle: {
            borderWidth: 1,
            borderColor: "white",
            borderType: "solid",
            shadowBlur: 0,
            shadowColor: "rgba(0, 0, 0, 0.2)",
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1
        },
        emphasis: {
            focus: "descendant"
        },
        blur: {
            itemStyle: {
                opacity: 0.2
            },
            label: {
                opacity: 0.1
            }
        },
        // Animation type can be expansion, scale.
        animationType: "expansion",
        animationDuration: 1000,
        animationDurationUpdate: 500,
        data: [],
        /**
     * Sort order.
     *
     * Valid values: 'desc', 'asc', null, or callback function.
     * 'desc' and 'asc' for descend and ascendant order;
     * null for not sorting;
     * example of callback function:
     * function(nodeA, nodeB) {
     *     return nodeA.getValue() - nodeB.getValue();
     * }
     */ sort: "desc"
    };
    return SunburstSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
function $5204df39d5781117$var$completeTreeValue(dataNode) {
    // Postorder travel tree.
    // If value of none-leaf node is not set,
    // calculate it by suming up the value of all children.
    var sum = 0;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(dataNode.children, function(child) {
        $5204df39d5781117$var$completeTreeValue(child);
        var childValue = child.value;
        // TODO First value of array must be a number
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(childValue) && (childValue = childValue[0]);
        sum += childValue;
    });
    var thisValue = dataNode.value;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(thisValue)) thisValue = thisValue[0];
    if (thisValue == null || isNaN(thisValue)) thisValue = sum;
    // Value should not less than 0.
    if (thisValue < 0) thisValue = 0;
    $7a1bd9c2710fea0d$export$43bee75e5e14138e(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}
var $5204df39d5781117$export$2e2bcd8739ae039 = $5204df39d5781117$var$SunburstSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

// let PI2 = Math.PI * 2;
var $2ac615e1f67ae37a$var$RADIAN = Math.PI / 180;
function $2ac615e1f67ae37a$export$2e2bcd8739ae039(seriesType, ecModel, api) {
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        var center = seriesModel.get("center");
        var radius = seriesModel.get("radius");
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(radius)) radius = [
            0,
            radius
        ];
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(center)) center = [
            center,
            center
        ];
        var width = api.getWidth();
        var height = api.getHeight();
        var size = Math.min(width, height);
        var cx = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[0], width);
        var cy = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[1], height);
        var r0 = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[0], size / 2);
        var r = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[1], size / 2);
        var startAngle = -seriesModel.get("startAngle") * $2ac615e1f67ae37a$var$RADIAN;
        var minAngle = seriesModel.get("minAngle") * $2ac615e1f67ae37a$var$RADIAN;
        var virtualRoot = seriesModel.getData().tree.root;
        var treeRoot = seriesModel.getViewRoot();
        var rootDepth = treeRoot.depth;
        var sort = seriesModel.get("sort");
        if (sort != null) $2ac615e1f67ae37a$var$initChildren(treeRoot, sort);
        var validDataCount = 0;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(treeRoot.children, function(child) {
            !isNaN(child.getValue()) && validDataCount++;
        });
        var sum = treeRoot.getValue();
        // Sum may be 0
        var unitRadian = Math.PI / (sum || validDataCount) * 2;
        var renderRollupNode = treeRoot.depth > 0;
        var levels = treeRoot.height - (renderRollupNode ? -1 : 1);
        var rPerLevel = (r - r0) / (levels || 1);
        var clockwise = seriesModel.get("clockwise");
        var stillShowZeroSum = seriesModel.get("stillShowZeroSum");
        // In the case some sector angle is smaller than minAngle
        // let restAngle = PI2;
        // let valueSumLargerThanMinAngle = 0;
        var dir = clockwise ? 1 : -1;
        /**
     * Render a tree
     * @return increased angle
     */ var renderNode = function(node, startAngle) {
            if (!node) return;
            var endAngle = startAngle;
            // Render self
            if (node !== virtualRoot) {
                // Tree node is virtual, so it doesn't need to be drawn
                var value = node.getValue();
                var angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
                if (angle < minAngle) angle = minAngle;
                // else {
                //     valueSumLargerThanMinAngle += value;
                // }
                endAngle = startAngle + dir * angle;
                var depth = node.depth - rootDepth - (renderRollupNode ? -1 : 1);
                var rStart = r0 + rPerLevel * depth;
                var rEnd = r0 + rPerLevel * (depth + 1);
                var levelModel = seriesModel.getLevelModel(node);
                if (levelModel) {
                    var r0_1 = levelModel.get("r0", true);
                    var r_1 = levelModel.get("r", true);
                    var radius_1 = levelModel.get("radius", true);
                    if (radius_1 != null) {
                        r0_1 = radius_1[0];
                        r_1 = radius_1[1];
                    }
                    r0_1 != null && (rStart = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(r0_1, size / 2));
                    r_1 != null && (rEnd = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(r_1, size / 2));
                }
                node.setLayout({
                    angle: angle,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    clockwise: clockwise,
                    cx: cx,
                    cy: cy,
                    r0: rStart,
                    r: rEnd
                });
            }
            // Render children
            if (node.children && node.children.length) {
                // currentAngle = startAngle;
                var siblingAngle_1 = 0;
                $7a1bd9c2710fea0d$export$79b2f7037acddd43(node.children, function(node) {
                    siblingAngle_1 += renderNode(node, startAngle + siblingAngle_1);
                });
            }
            return endAngle - startAngle;
        };
        // Virtual root node for roll up
        if (renderRollupNode) {
            var rStart = r0;
            var rEnd = r0 + rPerLevel;
            var angle = Math.PI * 2;
            virtualRoot.setLayout({
                angle: angle,
                startAngle: startAngle,
                endAngle: startAngle + angle,
                clockwise: clockwise,
                cx: cx,
                cy: cy,
                r0: rStart,
                r: rEnd
            });
        }
        renderNode(treeRoot, startAngle);
    });
}
/**
 * Init node children by order and update visual
 */ function $2ac615e1f67ae37a$var$initChildren(node, sortOrder) {
    var children = node.children || [];
    node.children = $2ac615e1f67ae37a$var$sort(children, sortOrder);
    // Init children recursively
    if (children.length) $7a1bd9c2710fea0d$export$79b2f7037acddd43(node.children, function(child) {
        $2ac615e1f67ae37a$var$initChildren(child, sortOrder);
    });
}
/**
 * Sort children nodes
 *
 * @param {TreeNode[]}               children children of node to be sorted
 * @param {string | function | null} sort sort method
 *                                   See SunburstSeries.js for details.
 */ function $2ac615e1f67ae37a$var$sort(children, sortOrder) {
    if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(sortOrder)) {
        var sortTargets = $7a1bd9c2710fea0d$export$871de8747c9eaa88(children, function(child, idx) {
            var value = child.getValue();
            return {
                params: {
                    depth: child.depth,
                    height: child.height,
                    dataIndex: child.dataIndex,
                    getValue: function() {
                        return value;
                    }
                },
                index: idx
            };
        });
        sortTargets.sort(function(a, b) {
            return sortOrder(a.params, b.params);
        });
        return $7a1bd9c2710fea0d$export$871de8747c9eaa88(sortTargets, function(target) {
            return children[target.index];
        });
    } else {
        var isAsc_1 = sortOrder === "asc";
        return children.sort(function(a, b) {
            var diff = (a.getValue() - b.getValue()) * (isAsc_1 ? 1 : -1);
            return diff === 0 ? (a.dataIndex - b.dataIndex) * (isAsc_1 ? -1 : 1) : diff;
        });
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $a3ad73d5b7f783f0$export$2e2bcd8739ae039(ecModel) {
    var paletteScope = {};
    // Default color strategy
    function pickColor(node, seriesModel, treeHeight) {
        // Choose color from palette based on the first level.
        var current = node;
        while(current && current.depth > 1)current = current.parentNode;
        var color = seriesModel.getColorFromPalette(current.name || current.dataIndex + "", paletteScope);
        if (node.depth > 1 && (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(color)) // Lighter on the deeper level.
        color = (0, $2c037f5bda6341ca$export$590e8b2c435046d9)(color, (node.depth - 1) / (treeHeight - 1) * 0.5);
        return color;
    }
    ecModel.eachSeriesByType("sunburst", function(seriesModel) {
        var data = seriesModel.getData();
        var tree = data.tree;
        tree.eachNode(function(node) {
            var model = node.getModel();
            var style = model.getModel("itemStyle").getItemStyle();
            if (!style.fill) style.fill = pickColor(node, seriesModel, tree.root.height);
            var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, "style");
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
        });
    });
}





function $b7341ef122ec790d$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $270cb27be00846ce$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $5204df39d5781117$export$2e2bcd8739ae039));
    registers.registerLayout((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $2ac615e1f67ae37a$export$2e2bcd8739ae039), "sunburst"));
    registers.registerProcessor((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $e11a533bf70b759c$export$2e2bcd8739ae039), "sunburst"));
    registers.registerVisual((0, $a3ad73d5b7f783f0$export$2e2bcd8739ae039));
    (0, $aae4889dfc91fba0$export$d2def111ea616eb3)(registers);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $91b53b7eca57e10b$var$ThemeRiverView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ThemeRiverView, _super);
    function ThemeRiverView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ThemeRiverView.type;
        _this._layers = [];
        return _this;
    }
    ThemeRiverView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var self = this;
        var group = this.group;
        var layersSeries = seriesModel.getLayerSeries();
        var layoutInfo = data.getLayout("layoutInfo");
        var rect = layoutInfo.rect;
        var boundaryGap = layoutInfo.boundaryGap;
        group.x = 0;
        group.y = rect.y + boundaryGap[0];
        function keyGetter(item) {
            return item.name;
        }
        var dataDiffer = new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(this._layersSeries || [], layersSeries, keyGetter, keyGetter);
        var newLayersGroups = [];
        dataDiffer.add((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(process, this, "add")).update((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(process, this, "update")).remove((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(process, this, "remove")).execute();
        function process(status, idx, oldIdx) {
            var oldLayersGroups = self._layers;
            if (status === "remove") {
                group.remove(oldLayersGroups[idx]);
                return;
            }
            var points0 = [];
            var points1 = [];
            var style;
            var indices = layersSeries[idx].indices;
            var j = 0;
            for(; j < indices.length; j++){
                var layout = data.getItemLayout(indices[j]);
                var x = layout.x;
                var y0 = layout.y0;
                var y = layout.y;
                points0.push(x, y0);
                points1.push(x, y0 + y);
                style = data.getItemVisual(indices[j], "style");
            }
            var polygon;
            var textLayout = data.getItemLayout(indices[0]);
            var labelModel = seriesModel.getModel("label");
            var margin = labelModel.get("margin");
            var emphasisModel = seriesModel.getModel("emphasis");
            if (status === "add") {
                var layerGroup = newLayersGroups[idx] = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
                polygon = new (0, $5c417e1ed90142c5$export$6042a400d113f2bd)({
                    shape: {
                        points: points0,
                        stackedOnPoints: points1,
                        smooth: 0.4,
                        stackedOnSmooth: 0.4,
                        smoothConstraint: false
                    },
                    z2: 0
                });
                layerGroup.add(polygon);
                group.add(layerGroup);
                if (seriesModel.isAnimationEnabled()) polygon.setClipPath($91b53b7eca57e10b$var$createGridClipShape(polygon.getBoundingRect(), seriesModel, function() {
                    polygon.removeClipPath();
                }));
            } else {
                var layerGroup = oldLayersGroups[oldIdx];
                polygon = layerGroup.childAt(0);
                group.add(layerGroup);
                newLayersGroups[idx] = layerGroup;
                $8b353638fbedfefa$export$c8dce3c08436e91e(polygon, {
                    shape: {
                        points: points0,
                        stackedOnPoints: points1
                    }
                }, seriesModel);
                (0, $8b353638fbedfefa$export$bca7290a9faf0ec9)(polygon);
            }
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(polygon, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(seriesModel), {
                labelDataIndex: indices[j - 1],
                defaultText: data.getName(indices[j - 1]),
                inheritColor: style.fill
            }, {
                normal: {
                    verticalAlign: "middle"
                }
            });
            polygon.setTextConfig({
                position: null,
                local: true
            });
            var labelEl = polygon.getTextContent();
            // TODO More label position options.
            if (labelEl) {
                labelEl.x = textLayout.x - margin;
                labelEl.y = textLayout.y0 + textLayout.y / 2;
            }
            polygon.useStyle(style);
            data.setItemGraphicEl(idx, polygon);
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, seriesModel);
            (0, $2bf82c0980125b62$export$e51187539ff11209)(polygon, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
        }
        this._layersSeries = layersSeries;
        this._layers = newLayersGroups;
    };
    ThemeRiverView.type = "themeRiver";
    return ThemeRiverView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
// add animation to the view
function $91b53b7eca57e10b$var$createGridClipShape(rect, seriesModel, cb) {
    var rectEl = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: rect.x - 10,
            y: rect.y - 10,
            width: 0,
            height: rect.height + 20
        }
    });
    $8b353638fbedfefa$export$a121566aadcfe021(rectEl, {
        shape: {
            x: rect.x - 50,
            width: rect.width + 100,
            height: rect.height + 20
        }
    }, seriesModel, cb);
    return rectEl;
}
var $91b53b7eca57e10b$export$2e2bcd8739ae039 = $91b53b7eca57e10b$var$ThemeRiverView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $5814c4cad54e1e96$var$DATA_NAME_INDEX = 2;
var $5814c4cad54e1e96$var$ThemeRiverSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ThemeRiverSeriesModel, _super);
    function ThemeRiverSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ThemeRiverSeriesModel.type;
        return _this;
    }
    /**
   * @override
   */ ThemeRiverSeriesModel.prototype.init = function(option) {
        // eslint-disable-next-line
        _super.prototype.init.apply(this, arguments);
        // Put this function here is for the sake of consistency of code style.
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $cf24728fc17c4ab6$export$2e2bcd8739ae039)($7a1bd9c2710fea0d$export$2385a24977818dd0(this.getData, this), $7a1bd9c2710fea0d$export$2385a24977818dd0(this.getRawData, this));
    };
    /**
   * If there is no value of a certain point in the time for some event,set it value to 0.
   *
   * @param {Array} data  initial data in the option
   * @return {Array}
   */ ThemeRiverSeriesModel.prototype.fixData = function(data) {
        var rawDataLength = data.length;
        /**
     * Make sure every layer data get the same keys.
     * The value index tells which layer has visited.
     * {
     *  2014/01/01: -1
     * }
     */ var timeValueKeys = {};
        // grouped data by name
        var groupResult = (0, $76d619f648247e6d$export$7ab5bda43e13168f)(data, function(item) {
            if (!timeValueKeys.hasOwnProperty(item[0] + "")) timeValueKeys[item[0] + ""] = -1;
            return item[2];
        });
        var layerData = [];
        groupResult.buckets.each(function(items, key) {
            layerData.push({
                name: key,
                dataList: items
            });
        });
        var layerNum = layerData.length;
        for(var k = 0; k < layerNum; ++k){
            var name_1 = layerData[k].name;
            for(var j = 0; j < layerData[k].dataList.length; ++j){
                var timeValue = layerData[k].dataList[j][0] + "";
                timeValueKeys[timeValue] = k;
            }
            for(var timeValue in timeValueKeys)if (timeValueKeys.hasOwnProperty(timeValue) && timeValueKeys[timeValue] !== k) {
                timeValueKeys[timeValue] = k;
                data[rawDataLength] = [
                    timeValue,
                    0,
                    name_1
                ];
                rawDataLength++;
            }
        }
        return data;
    };
    /**
   * @override
   * @param  option  the initial option that user gave
   * @param  ecModel  the model object for themeRiver option
   */ ThemeRiverSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var singleAxisModel = this.getReferringComponents("singleAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
        var axisType = singleAxisModel.get("type");
        // filter the data item with the value of label is undefined
        var filterData = $7a1bd9c2710fea0d$export$3dea766d36a8935f(option.data, function(dataItem) {
            return dataItem[2] !== undefined;
        });
        // ??? TODO design a stage to transfer data for themeRiver and lines?
        var data = this.fixData(filterData || []);
        var nameList = [];
        var nameMap = this.nameMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var count = 0;
        for(var i = 0; i < data.length; ++i){
            nameList.push(data[i][$5814c4cad54e1e96$var$DATA_NAME_INDEX]);
            if (!nameMap.get(data[i][$5814c4cad54e1e96$var$DATA_NAME_INDEX])) {
                nameMap.set(data[i][$5814c4cad54e1e96$var$DATA_NAME_INDEX], count);
                count++;
            }
        }
        var dimensions = (0, $a27631012b7b377c$export$2e2bcd8739ae039)(data, {
            coordDimensions: [
                "single"
            ],
            dimensionsDefine: [
                {
                    name: "time",
                    type: (0, $18085de91ae59d03$export$af1622903e71278e)(axisType)
                },
                {
                    name: "value",
                    type: "float"
                },
                {
                    name: "name",
                    type: "ordinal"
                }
            ],
            encodeDefine: {
                single: 0,
                value: 1,
                itemName: 2
            }
        }).dimensions;
        var list = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dimensions, this);
        list.initData(data);
        return list;
    };
    /**
   * The raw data is divided into multiple layers and each layer
   *     has same name.
   */ ThemeRiverSeriesModel.prototype.getLayerSeries = function() {
        var data = this.getData();
        var lenCount = data.count();
        var indexArr = [];
        for(var i = 0; i < lenCount; ++i)indexArr[i] = i;
        var timeDim = data.mapDimension("single");
        // data group by name
        var groupResult = (0, $76d619f648247e6d$export$7ab5bda43e13168f)(indexArr, function(index) {
            return data.get("name", index);
        });
        var layerSeries = [];
        groupResult.buckets.each(function(items, key) {
            items.sort(function(index1, index2) {
                return data.get(timeDim, index1) - data.get(timeDim, index2);
            });
            layerSeries.push({
                name: key,
                indices: items
            });
        });
        return layerSeries;
    };
    /**
   * Get data indices for show tooltip content
   */ ThemeRiverSeriesModel.prototype.getAxisTooltipData = function(dim, value, baseAxis) {
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(dim)) dim = dim ? [
            dim
        ] : [];
        var data = this.getData();
        var layerSeries = this.getLayerSeries();
        var indices = [];
        var layerNum = layerSeries.length;
        var nestestValue;
        for(var i = 0; i < layerNum; ++i){
            var minDist = Number.MAX_VALUE;
            var nearestIdx = -1;
            var pointNum = layerSeries[i].indices.length;
            for(var j = 0; j < pointNum; ++j){
                var theValue = data.get(dim[0], layerSeries[i].indices[j]);
                var dist = Math.abs(theValue - value);
                if (dist <= minDist) {
                    nestestValue = theValue;
                    minDist = dist;
                    nearestIdx = layerSeries[i].indices[j];
                }
            }
            indices.push(nearestIdx);
        }
        return {
            dataIndices: indices,
            nestestValue: nestestValue
        };
    };
    ThemeRiverSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var name = data.getName(dataIndex);
        var value = data.get(data.mapDimension("value"), dataIndex);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
            name: name,
            value: value
        });
    };
    ThemeRiverSeriesModel.type = "series.themeRiver";
    ThemeRiverSeriesModel.dependencies = [
        "singleAxis"
    ];
    ThemeRiverSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        colorBy: "data",
        coordinateSystem: "singleAxis",
        // gap in axis's orthogonal orientation
        boundaryGap: [
            "10%",
            "10%"
        ],
        // legendHoverLink: true,
        singleAxisIndex: 0,
        animationEasing: "linear",
        label: {
            margin: 4,
            show: true,
            position: "left",
            fontSize: 11
        },
        emphasis: {
            label: {
                show: true
            }
        }
    };
    return ThemeRiverSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $5814c4cad54e1e96$export$2e2bcd8739ae039 = $5814c4cad54e1e96$var$ThemeRiverSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $7dda345d99fef8ed$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType("themeRiver", function(seriesModel) {
        var data = seriesModel.getData();
        var single = seriesModel.coordinateSystem;
        var layoutInfo = {};
        // use the axis boundingRect for view
        var rect = single.getRect();
        layoutInfo.rect = rect;
        var boundaryGap = seriesModel.get("boundaryGap");
        var axis = single.getAxis();
        layoutInfo.boundaryGap = boundaryGap;
        if (axis.orient === "horizontal") {
            boundaryGap[0] = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(boundaryGap[0], rect.height);
            boundaryGap[1] = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(boundaryGap[1], rect.height);
            var height = rect.height - boundaryGap[0] - boundaryGap[1];
            $7dda345d99fef8ed$var$doThemeRiverLayout(data, seriesModel, height);
        } else {
            boundaryGap[0] = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(boundaryGap[0], rect.width);
            boundaryGap[1] = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(boundaryGap[1], rect.width);
            var width = rect.width - boundaryGap[0] - boundaryGap[1];
            $7dda345d99fef8ed$var$doThemeRiverLayout(data, seriesModel, width);
        }
        data.setLayout("layoutInfo", layoutInfo);
    });
}
/**
 * The layout information about themeriver
 *
 * @param data  data in the series
 * @param seriesModel  the model object of themeRiver series
 * @param height  value used to compute every series height
 */ function $7dda345d99fef8ed$var$doThemeRiverLayout(data, seriesModel, height) {
    if (!data.count()) return;
    var coordSys = seriesModel.coordinateSystem;
    // the data in each layer are organized into a series.
    var layerSeries = seriesModel.getLayerSeries();
    // the points in each layer.
    var timeDim = data.mapDimension("single");
    var valueDim = data.mapDimension("value");
    var layerPoints = $7a1bd9c2710fea0d$export$871de8747c9eaa88(layerSeries, function(singleLayer) {
        return $7a1bd9c2710fea0d$export$871de8747c9eaa88(singleLayer.indices, function(idx) {
            var pt = coordSys.dataToPoint(data.get(timeDim, idx));
            pt[1] = data.get(valueDim, idx);
            return pt;
        });
    });
    var base = $7dda345d99fef8ed$var$computeBaseline(layerPoints);
    var baseLine = base.y0;
    var ky = height / base.max;
    // set layout information for each item.
    var n = layerSeries.length;
    var m = layerSeries[0].indices.length;
    var baseY0;
    for(var j = 0; j < m; ++j){
        baseY0 = baseLine[j] * ky;
        data.setItemLayout(layerSeries[0].indices[j], {
            layerIndex: 0,
            x: layerPoints[0][j][0],
            y0: baseY0,
            y: layerPoints[0][j][1] * ky
        });
        for(var i = 1; i < n; ++i){
            baseY0 += layerPoints[i - 1][j][1] * ky;
            data.setItemLayout(layerSeries[i].indices[j], {
                layerIndex: i,
                x: layerPoints[i][j][0],
                y0: baseY0,
                y: layerPoints[i][j][1] * ky
            });
        }
    }
}
/**
 * Compute the baseLine of the rawdata
 * Inspired by Lee Byron's paper Stacked Graphs - Geometry & Aesthetics
 *
 * @param  data  the points in each layer
 */ function $7dda345d99fef8ed$var$computeBaseline(data) {
    var layerNum = data.length;
    var pointNum = data[0].length;
    var sums = [];
    var y0 = [];
    var max = 0;
    for(var i = 0; i < pointNum; ++i){
        var temp = 0;
        for(var j = 0; j < layerNum; ++j)temp += data[j][i][1];
        if (temp > max) max = temp;
        sums.push(temp);
    }
    for(var k = 0; k < pointNum; ++k)y0[k] = (max - sums[k]) / 2;
    max = 0;
    for(var l = 0; l < pointNum; ++l){
        var sum = sums[l] + y0[l];
        if (sum > max) max = sum;
    }
    return {
        y0: y0,
        max: max
    };
}



function $e883cd02390b2e6d$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $91b53b7eca57e10b$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $5814c4cad54e1e96$export$2e2bcd8739ae039));
    registers.registerLayout((0, $7dda345d99fef8ed$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $e11a533bf70b759c$export$2e2bcd8739ae039)("themeRiver"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The tree layoutHelper implementation was originally copied from
* "d3.js"(https://github.com/d3/d3-hierarchy) with
* some modifications made for this project.
* (see more details in the comment of the specific method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the licence of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ /**
 * @file The layout algorithm of node-link tree diagrams. Here we using Reingold-Tilford algorithm to drawing
 *       the tree.
 */ 
function $172d7581b75555e9$export$2cd8252107eb640b(inRoot) {
    var root = inRoot;
    root.hierNode = {
        defaultAncestor: null,
        ancestor: root,
        prelim: 0,
        modifier: 0,
        change: 0,
        shift: 0,
        i: 0,
        thread: null
    };
    var nodes = [
        root
    ];
    var node;
    var children;
    while(node = nodes.pop()){
        // jshint ignore:line
        children = node.children;
        if (node.isExpand && children.length) {
            var n = children.length;
            for(var i = n - 1; i >= 0; i--){
                var child = children[i];
                child.hierNode = {
                    defaultAncestor: null,
                    ancestor: child,
                    prelim: 0,
                    modifier: 0,
                    change: 0,
                    shift: 0,
                    i: i,
                    thread: null
                };
                nodes.push(child);
            }
        }
    }
}
function $172d7581b75555e9$export$f7eff93d75358a2c(node, separation) {
    var children = node.isExpand ? node.children : [];
    var siblings = node.parentNode.children;
    var subtreeW = node.hierNode.i ? siblings[node.hierNode.i - 1] : null;
    if (children.length) {
        $172d7581b75555e9$var$executeShifts(node);
        var midPoint = (children[0].hierNode.prelim + children[children.length - 1].hierNode.prelim) / 2;
        if (subtreeW) {
            node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
            node.hierNode.modifier = node.hierNode.prelim - midPoint;
        } else node.hierNode.prelim = midPoint;
    } else if (subtreeW) node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
    node.parentNode.hierNode.defaultAncestor = $172d7581b75555e9$var$apportion(node, subtreeW, node.parentNode.hierNode.defaultAncestor || siblings[0], separation);
}
function $172d7581b75555e9$export$39e6f19b1ce889be(node) {
    var nodeX = node.hierNode.prelim + node.parentNode.hierNode.modifier;
    node.setLayout({
        x: nodeX
    }, true);
    node.hierNode.modifier += node.parentNode.hierNode.modifier;
}
function $172d7581b75555e9$export$3bf720ece7bc7b2e(cb) {
    return arguments.length ? cb : $172d7581b75555e9$var$defaultSeparation;
}
function $172d7581b75555e9$export$60198ec123d36099(rad, r) {
    rad -= Math.PI / 2;
    return {
        x: r * Math.cos(rad),
        y: r * Math.sin(rad)
    };
}
function $172d7581b75555e9$export$c02eeb5f98d59b89(seriesModel, api) {
    return $93b9bc7f22ac7369$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
/**
 * All other shifts, applied to the smaller subtrees between w- and w+, are
 * performed by this function.
 *
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ function $172d7581b75555e9$var$executeShifts(node) {
    var children = node.children;
    var n = children.length;
    var shift = 0;
    var change = 0;
    while(--n >= 0){
        var child = children[n];
        child.hierNode.prelim += shift;
        child.hierNode.modifier += shift;
        change += child.hierNode.change;
        shift += child.hierNode.shift + change;
    }
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * The core of the algorithm. Here, a new subtree is combined with the
 * previous subtrees. Threads are used to traverse the inside and outside
 * contours of the left and right subtree up to the highest common level.
 * Whenever two nodes of the inside contours conflict, we compute the left
 * one of the greatest uncommon ancestors using the function nextAncestor()
 * and call moveSubtree() to shift the subtree and prepare the shifts of
 * smaller subtrees. Finally, we add a new thread (if necessary).
 */ function $172d7581b75555e9$var$apportion(subtreeV, subtreeW, ancestor, separation) {
    if (subtreeW) {
        var nodeOutRight = subtreeV;
        var nodeInRight = subtreeV;
        var nodeOutLeft = nodeInRight.parentNode.children[0];
        var nodeInLeft = subtreeW;
        var sumOutRight = nodeOutRight.hierNode.modifier;
        var sumInRight = nodeInRight.hierNode.modifier;
        var sumOutLeft = nodeOutLeft.hierNode.modifier;
        var sumInLeft = nodeInLeft.hierNode.modifier;
        while(nodeInLeft = $172d7581b75555e9$var$nextRight(nodeInLeft), nodeInRight = $172d7581b75555e9$var$nextLeft(nodeInRight), nodeInLeft && nodeInRight){
            nodeOutRight = $172d7581b75555e9$var$nextRight(nodeOutRight);
            nodeOutLeft = $172d7581b75555e9$var$nextLeft(nodeOutLeft);
            nodeOutRight.hierNode.ancestor = subtreeV;
            var shift = nodeInLeft.hierNode.prelim + sumInLeft - nodeInRight.hierNode.prelim - sumInRight + separation(nodeInLeft, nodeInRight);
            if (shift > 0) {
                $172d7581b75555e9$var$moveSubtree($172d7581b75555e9$var$nextAncestor(nodeInLeft, subtreeV, ancestor), subtreeV, shift);
                sumInRight += shift;
                sumOutRight += shift;
            }
            sumInLeft += nodeInLeft.hierNode.modifier;
            sumInRight += nodeInRight.hierNode.modifier;
            sumOutRight += nodeOutRight.hierNode.modifier;
            sumOutLeft += nodeOutLeft.hierNode.modifier;
        }
        if (nodeInLeft && !$172d7581b75555e9$var$nextRight(nodeOutRight)) {
            nodeOutRight.hierNode.thread = nodeInLeft;
            nodeOutRight.hierNode.modifier += sumInLeft - sumOutRight;
        }
        if (nodeInRight && !$172d7581b75555e9$var$nextLeft(nodeOutLeft)) {
            nodeOutLeft.hierNode.thread = nodeInRight;
            nodeOutLeft.hierNode.modifier += sumInRight - sumOutLeft;
            ancestor = subtreeV;
        }
    }
    return ancestor;
}
/**
 * This function is used to traverse the right contour of a subtree.
 * It returns the rightmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 */ function $172d7581b75555e9$var$nextRight(node) {
    var children = node.children;
    return children.length && node.isExpand ? children[children.length - 1] : node.hierNode.thread;
}
/**
 * This function is used to traverse the left contour of a subtree (or a subforest).
 * It returns the leftmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 */ function $172d7581b75555e9$var$nextLeft(node) {
    var children = node.children;
    return children.length && node.isExpand ? children[0] : node.hierNode.thread;
}
/**
 * If nodeInLeft’s ancestor is a sibling of node, returns nodeInLeft’s ancestor.
 * Otherwise, returns the specified ancestor.
 */ function $172d7581b75555e9$var$nextAncestor(nodeInLeft, node, ancestor) {
    return nodeInLeft.hierNode.ancestor.parentNode === node.parentNode ? nodeInLeft.hierNode.ancestor : ancestor;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * Shifts the current subtree rooted at wr.
 * This is done by increasing prelim(w+) and modifier(w+) by shift.
 */ function $172d7581b75555e9$var$moveSubtree(wl, wr, shift) {
    var change = shift / (wr.hierNode.i - wl.hierNode.i);
    wr.hierNode.change -= change;
    wr.hierNode.shift += shift;
    wr.hierNode.modifier += shift;
    wr.hierNode.prelim += shift;
    wl.hierNode.change += change;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ function $172d7581b75555e9$var$defaultSeparation(node1, node2) {
    return node1.parentNode === node2.parentNode ? 1 : 2;
}











var $c673dc2ab6ad4136$var$TreeEdgeShape = /** @class */ function() {
    function TreeEdgeShape() {
        this.parentPoint = [];
        this.childPoints = [];
    }
    return TreeEdgeShape;
}();
var $c673dc2ab6ad4136$var$TreePath = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TreePath, _super);
    function TreePath(opts) {
        return _super.call(this, opts) || this;
    }
    TreePath.prototype.getDefaultStyle = function() {
        return {
            stroke: "#000",
            fill: null
        };
    };
    TreePath.prototype.getDefaultShape = function() {
        return new $c673dc2ab6ad4136$var$TreeEdgeShape();
    };
    TreePath.prototype.buildPath = function(ctx, shape) {
        var childPoints = shape.childPoints;
        var childLen = childPoints.length;
        var parentPoint = shape.parentPoint;
        var firstChildPos = childPoints[0];
        var lastChildPos = childPoints[childLen - 1];
        if (childLen === 1) {
            ctx.moveTo(parentPoint[0], parentPoint[1]);
            ctx.lineTo(firstChildPos[0], firstChildPos[1]);
            return;
        }
        var orient = shape.orient;
        var forkDim = orient === "TB" || orient === "BT" ? 0 : 1;
        var otherDim = 1 - forkDim;
        var forkPosition = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(shape.forkPosition, 1);
        var tmpPoint = [];
        tmpPoint[forkDim] = parentPoint[forkDim];
        tmpPoint[otherDim] = parentPoint[otherDim] + (lastChildPos[otherDim] - parentPoint[otherDim]) * forkPosition;
        ctx.moveTo(parentPoint[0], parentPoint[1]);
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        ctx.moveTo(firstChildPos[0], firstChildPos[1]);
        tmpPoint[forkDim] = firstChildPos[forkDim];
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        tmpPoint[forkDim] = lastChildPos[forkDim];
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        ctx.lineTo(lastChildPos[0], lastChildPos[1]);
        for(var i = 1; i < childLen - 1; i++){
            var point = childPoints[i];
            ctx.moveTo(point[0], point[1]);
            tmpPoint[forkDim] = point[forkDim];
            ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        }
    };
    return TreePath;
}((0, $b02ffe7acd508c08$export$2e2bcd8739ae039));
var $c673dc2ab6ad4136$var$TreeView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TreeView, _super);
    function TreeView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TreeView.type;
        _this._mainGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        return _this;
    }
    TreeView.prototype.init = function(ecModel, api) {
        this._controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
        this._controllerHost = {
            target: this.group
        };
        this.group.add(this._mainGroup);
    };
    TreeView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var layoutInfo = seriesModel.layoutInfo;
        var group = this._mainGroup;
        var layout = seriesModel.get("layout");
        if (layout === "radial") {
            group.x = layoutInfo.x + layoutInfo.width / 2;
            group.y = layoutInfo.y + layoutInfo.height / 2;
        } else {
            group.x = layoutInfo.x;
            group.y = layoutInfo.y;
        }
        this._updateViewCoordSys(seriesModel, api);
        this._updateController(seriesModel, ecModel, api);
        var oldData = this._data;
        data.diff(oldData).add(function(newIdx) {
            if ($c673dc2ab6ad4136$var$symbolNeedsDraw(data, newIdx)) // Create node and edge
            $c673dc2ab6ad4136$var$updateNode(data, newIdx, null, group, seriesModel);
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            if (!$c673dc2ab6ad4136$var$symbolNeedsDraw(data, newIdx)) {
                symbolEl && $c673dc2ab6ad4136$var$removeNode(oldData, oldIdx, symbolEl, group, seriesModel);
                return;
            }
            // Update node and edge
            $c673dc2ab6ad4136$var$updateNode(data, newIdx, symbolEl, group, seriesModel);
        }).remove(function(oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            // When remove a collapsed node of subtree, since the collapsed
            // node haven't been initialized with a symbol element,
            // you can't found it's symbol element through index.
            // so if we want to remove the symbol element we should insure
            // that the symbol element is not null.
            if (symbolEl) $c673dc2ab6ad4136$var$removeNode(oldData, oldIdx, symbolEl, group, seriesModel);
        }).execute();
        this._nodeScaleRatio = seriesModel.get("nodeScaleRatio");
        this._updateNodeAndLinkScale(seriesModel);
        if (seriesModel.get("expandAndCollapse") === true) data.eachItemGraphicEl(function(el, dataIndex) {
            el.off("click").on("click", function() {
                api.dispatchAction({
                    type: "treeExpandAndCollapse",
                    seriesId: seriesModel.id,
                    dataIndex: dataIndex
                });
            });
        });
        this._data = data;
    };
    TreeView.prototype._updateViewCoordSys = function(seriesModel, api) {
        var data = seriesModel.getData();
        var points = [];
        data.each(function(idx) {
            var layout = data.getItemLayout(idx);
            if (layout && !isNaN(layout.x) && !isNaN(layout.y)) points.push([
                +layout.x,
                +layout.y
            ]);
        });
        var min = [];
        var max = [];
        $af3aab2435198f82$export$188c3cd07b4129dd(points, min, max);
        // If don't Store min max when collapse the root node after roam,
        // the root node will disappear.
        var oldMin = this._min;
        var oldMax = this._max;
        // If width or height is 0
        if (max[0] - min[0] === 0) {
            min[0] = oldMin ? oldMin[0] : min[0] - 1;
            max[0] = oldMax ? oldMax[0] : max[0] + 1;
        }
        if (max[1] - min[1] === 0) {
            min[1] = oldMin ? oldMin[1] : min[1] - 1;
            max[1] = oldMax ? oldMax[1] : max[1] + 1;
        }
        var viewCoordSys = seriesModel.coordinateSystem = new (0, $4a92e7570d47c1fe$export$2e2bcd8739ae039)();
        viewCoordSys.zoomLimit = seriesModel.get("scaleLimit");
        viewCoordSys.setBoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
        viewCoordSys.setCenter(seriesModel.get("center"), api);
        viewCoordSys.setZoom(seriesModel.get("zoom"));
        // Here we use viewCoordSys just for computing the 'position' and 'scale' of the group
        this.group.attr({
            x: viewCoordSys.x,
            y: viewCoordSys.y,
            scaleX: viewCoordSys.scaleX,
            scaleY: viewCoordSys.scaleY
        });
        this._min = min;
        this._max = max;
    };
    TreeView.prototype._updateController = function(seriesModel, ecModel, api) {
        var _this = this;
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        var group = this.group;
        controller.setPointerChecker(function(e, x, y) {
            var rect = group.getBoundingRect();
            rect.applyTransform(group.transform);
            return rect.contain(x, y) && !(0, $bee256db41541054$export$8a33eacb690eac07)(e, api, seriesModel);
        });
        controller.enable(seriesModel.get("roam"));
        controllerHost.zoomLimit = seriesModel.get("scaleLimit");
        controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
        controller.off("pan").off("zoom").on("pan", function(e) {
            $35fd859fd545c4be$export$1e6abcd98caba733(controllerHost, e.dx, e.dy);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: "treeRoam",
                dx: e.dx,
                dy: e.dy
            });
        }).on("zoom", function(e) {
            $35fd859fd545c4be$export$29b3c66d30a4866(controllerHost, e.scale, e.originX, e.originY);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: "treeRoam",
                zoom: e.scale,
                originX: e.originX,
                originY: e.originY
            });
            _this._updateNodeAndLinkScale(seriesModel);
            // Only update label layout on zoom
            api.updateLabelLayout();
        });
    };
    TreeView.prototype._updateNodeAndLinkScale = function(seriesModel) {
        var data = seriesModel.getData();
        var nodeScale = this._getNodeGlobalScale(seriesModel);
        data.eachItemGraphicEl(function(el, idx) {
            el.setSymbolScale(nodeScale);
        });
    };
    TreeView.prototype._getNodeGlobalScale = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys.type !== "view") return 1;
        var nodeScaleRatio = this._nodeScaleRatio;
        var groupZoom = coordSys.scaleX || 1;
        // Scale node when zoom changes
        var roamZoom = coordSys.getZoom();
        var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
        return nodeScale / groupZoom;
    };
    TreeView.prototype.dispose = function() {
        this._controller && this._controller.dispose();
        this._controllerHost = null;
    };
    TreeView.prototype.remove = function() {
        this._mainGroup.removeAll();
        this._data = null;
    };
    TreeView.type = "tree";
    return TreeView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
function $c673dc2ab6ad4136$var$symbolNeedsDraw(data, dataIndex) {
    var layout = data.getItemLayout(dataIndex);
    return layout && !isNaN(layout.x) && !isNaN(layout.y);
}
function $c673dc2ab6ad4136$var$updateNode(data, dataIndex, symbolEl, group, seriesModel) {
    var isInit = !symbolEl;
    var node = data.tree.getNodeByDataIndex(dataIndex);
    var itemModel = node.getModel();
    var visualColor = node.getVisual("style").fill;
    var symbolInnerColor = node.isExpand === false && node.children.length !== 0 ? visualColor : "#fff";
    var virtualRoot = data.tree.root;
    var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
    var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
    var sourceLayout = source.getLayout();
    var sourceOldLayout = sourceSymbolEl ? {
        x: sourceSymbolEl.__oldX,
        y: sourceSymbolEl.__oldY,
        rawX: sourceSymbolEl.__radialOldRawX,
        rawY: sourceSymbolEl.__radialOldRawY
    } : sourceLayout;
    var targetLayout = node.getLayout();
    if (isInit) {
        symbolEl = new (0, $b1d9c3e17ccace80$export$2e2bcd8739ae039)(data, dataIndex, null, {
            symbolInnerColor: symbolInnerColor,
            useNameLabel: true
        });
        symbolEl.x = sourceOldLayout.x;
        symbolEl.y = sourceOldLayout.y;
    } else symbolEl.updateData(data, dataIndex, null, {
        symbolInnerColor: symbolInnerColor,
        useNameLabel: true
    });
    symbolEl.__radialOldRawX = symbolEl.__radialRawX;
    symbolEl.__radialOldRawY = symbolEl.__radialRawY;
    symbolEl.__radialRawX = targetLayout.rawX;
    symbolEl.__radialRawY = targetLayout.rawY;
    group.add(symbolEl);
    data.setItemGraphicEl(dataIndex, symbolEl);
    symbolEl.__oldX = symbolEl.x;
    symbolEl.__oldY = symbolEl.y;
    $8b353638fbedfefa$export$c8dce3c08436e91e(symbolEl, {
        x: targetLayout.x,
        y: targetLayout.y
    }, seriesModel);
    var symbolPath = symbolEl.getSymbolPath();
    if (seriesModel.get("layout") === "radial") {
        var realRoot = virtualRoot.children[0];
        var rootLayout = realRoot.getLayout();
        var length_1 = realRoot.children.length;
        var rad = void 0;
        var isLeft = void 0;
        if (targetLayout.x === rootLayout.x && node.isExpand === true && realRoot.children.length) {
            var center = {
                x: (realRoot.children[0].getLayout().x + realRoot.children[length_1 - 1].getLayout().x) / 2,
                y: (realRoot.children[0].getLayout().y + realRoot.children[length_1 - 1].getLayout().y) / 2
            };
            rad = Math.atan2(center.y - rootLayout.y, center.x - rootLayout.x);
            if (rad < 0) rad = Math.PI * 2 + rad;
            isLeft = center.x < rootLayout.x;
            if (isLeft) rad = rad - Math.PI;
        } else {
            rad = Math.atan2(targetLayout.y - rootLayout.y, targetLayout.x - rootLayout.x);
            if (rad < 0) rad = Math.PI * 2 + rad;
            if (node.children.length === 0 || node.children.length !== 0 && node.isExpand === false) {
                isLeft = targetLayout.x < rootLayout.x;
                if (isLeft) rad = rad - Math.PI;
            } else {
                isLeft = targetLayout.x > rootLayout.x;
                if (!isLeft) rad = rad - Math.PI;
            }
        }
        var textPosition = isLeft ? "left" : "right";
        var normalLabelModel = itemModel.getModel("label");
        var rotate = normalLabelModel.get("rotate");
        var labelRotateRadian = rotate * (Math.PI / 180);
        var textContent = symbolPath.getTextContent();
        if (textContent) {
            symbolPath.setTextConfig({
                position: normalLabelModel.get("position") || textPosition,
                rotation: rotate == null ? -rad : labelRotateRadian,
                origin: "center"
            });
            textContent.setStyle("verticalAlign", "middle");
        }
    }
    // Handle status
    var focus = itemModel.get([
        "emphasis",
        "focus"
    ]);
    var focusDataIndices = focus === "relative" ? $7a1bd9c2710fea0d$export$4fd8af2c48c43416(node.getAncestorsIndices(), node.getDescendantIndices()) : focus === "ancestor" ? node.getAncestorsIndices() : focus === "descendant" ? node.getDescendantIndices() : null;
    if (focusDataIndices) // Modify the focus to data indices.
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(symbolEl).focus = focusDataIndices;
    $c673dc2ab6ad4136$var$drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group);
    if (symbolEl.__edge) symbolEl.onHoverStateChange = function(toState) {
        if (toState !== "blur") {
            // NOTE: Ensure the parent elements will been blurred firstly.
            // According to the return of getAncestorsIndices and getDescendantIndices
            // TODO: A bit tricky.
            var parentEl = node.parentNode && data.getItemGraphicEl(node.parentNode.dataIndex);
            if (!(parentEl && parentEl.hoverState === (0, $2bf82c0980125b62$export$1307d6a87d56baa))) (0, $2bf82c0980125b62$export$868ba38adffa9e39)(symbolEl.__edge, toState);
        }
    };
}
function $c673dc2ab6ad4136$var$drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group) {
    var itemModel = node.getModel();
    var edgeShape = seriesModel.get("edgeShape");
    var layout = seriesModel.get("layout");
    var orient = seriesModel.getOrient();
    var curvature = seriesModel.get([
        "lineStyle",
        "curveness"
    ]);
    var edgeForkPosition = seriesModel.get("edgeForkPosition");
    var lineStyle = itemModel.getModel("lineStyle").getLineStyle();
    var edge = symbolEl.__edge;
    // curve edge from node -> parent
    // polyline edge from node -> children
    if (edgeShape === "curve") {
        if (node.parentNode && node.parentNode !== virtualRoot) {
            if (!edge) edge = symbolEl.__edge = new $6c7800c49630e431$export$2e2bcd8739ae039({
                shape: $c673dc2ab6ad4136$var$getEdgeShape(layout, orient, curvature, sourceOldLayout, sourceOldLayout)
            });
            $8b353638fbedfefa$export$c8dce3c08436e91e(edge, {
                shape: $c673dc2ab6ad4136$var$getEdgeShape(layout, orient, curvature, sourceLayout, targetLayout)
            }, seriesModel);
        }
    } else if (edgeShape === "polyline") {
        if (layout === "orthogonal") {
            if (node !== virtualRoot && node.children && node.children.length !== 0 && node.isExpand === true) {
                var children = node.children;
                var childPoints = [];
                for(var i = 0; i < children.length; i++){
                    var childLayout = children[i].getLayout();
                    childPoints.push([
                        childLayout.x,
                        childLayout.y
                    ]);
                }
                if (!edge) edge = symbolEl.__edge = new $c673dc2ab6ad4136$var$TreePath({
                    shape: {
                        parentPoint: [
                            targetLayout.x,
                            targetLayout.y
                        ],
                        childPoints: [
                            [
                                targetLayout.x,
                                targetLayout.y
                            ]
                        ],
                        orient: orient,
                        forkPosition: edgeForkPosition
                    }
                });
                $8b353638fbedfefa$export$c8dce3c08436e91e(edge, {
                    shape: {
                        parentPoint: [
                            targetLayout.x,
                            targetLayout.y
                        ],
                        childPoints: childPoints
                    }
                }, seriesModel);
            }
        }
    }
    // show all edge when edgeShape is 'curve', filter node `isExpand` is false when edgeShape is 'polyline'
    if (edge && !(edgeShape === "polyline" && !node.isExpand)) {
        edge.useStyle($7a1bd9c2710fea0d$export$ebe90cb607ad99e({
            strokeNoScale: true,
            fill: null
        }, lineStyle));
        (0, $2bf82c0980125b62$export$48b68047d330bbc9)(edge, itemModel, "lineStyle");
        (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(edge);
        group.add(edge);
    }
}
function $c673dc2ab6ad4136$var$removeNodeEdge(node, data, group, seriesModel, removeAnimationOpt) {
    var virtualRoot = data.tree.root;
    var _a = $c673dc2ab6ad4136$var$getSourceNode(virtualRoot, node), source = _a.source, sourceLayout = _a.sourceLayout;
    var symbolEl = data.getItemGraphicEl(node.dataIndex);
    if (!symbolEl) return;
    var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
    var sourceEdge = sourceSymbolEl.__edge;
    // 1. when expand the sub tree, delete the children node should delete the edge of
    // the source at the same time. because the polyline edge shape is only owned by the source.
    // 2.when the node is the only children of the source, delete the node should delete the edge of
    // the source at the same time. the same reason as above.
    var edge = symbolEl.__edge || (source.isExpand === false || source.children.length === 1 ? sourceEdge : undefined);
    var edgeShape = seriesModel.get("edgeShape");
    var layoutOpt = seriesModel.get("layout");
    var orient = seriesModel.get("orient");
    var curvature = seriesModel.get([
        "lineStyle",
        "curveness"
    ]);
    if (edge) {
        if (edgeShape === "curve") $8b353638fbedfefa$export$f883456a56996078(edge, {
            shape: $c673dc2ab6ad4136$var$getEdgeShape(layoutOpt, orient, curvature, sourceLayout, sourceLayout),
            style: {
                opacity: 0
            }
        }, seriesModel, {
            cb: function() {
                group.remove(edge);
            },
            removeOpt: removeAnimationOpt
        });
        else if (edgeShape === "polyline" && seriesModel.get("layout") === "orthogonal") $8b353638fbedfefa$export$f883456a56996078(edge, {
            shape: {
                parentPoint: [
                    sourceLayout.x,
                    sourceLayout.y
                ],
                childPoints: [
                    [
                        sourceLayout.x,
                        sourceLayout.y
                    ]
                ]
            },
            style: {
                opacity: 0
            }
        }, seriesModel, {
            cb: function() {
                group.remove(edge);
            },
            removeOpt: removeAnimationOpt
        });
    }
}
function $c673dc2ab6ad4136$var$getSourceNode(virtualRoot, node) {
    var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
    var sourceLayout;
    while(sourceLayout = source.getLayout(), sourceLayout == null)source = source.parentNode === virtualRoot ? source : source.parentNode || source;
    return {
        source: source,
        sourceLayout: sourceLayout
    };
}
function $c673dc2ab6ad4136$var$removeNode(data, dataIndex, symbolEl, group, seriesModel) {
    var node = data.tree.getNodeByDataIndex(dataIndex);
    var virtualRoot = data.tree.root;
    var sourceLayout = $c673dc2ab6ad4136$var$getSourceNode(virtualRoot, node).sourceLayout;
    // Use same duration and easing with update to have more consistent animation.
    var removeAnimationOpt = {
        duration: seriesModel.get("animationDurationUpdate"),
        easing: seriesModel.get("animationEasingUpdate")
    };
    $8b353638fbedfefa$export$f883456a56996078(symbolEl, {
        x: sourceLayout.x + 1,
        y: sourceLayout.y + 1
    }, seriesModel, {
        cb: function() {
            group.remove(symbolEl);
            data.setItemGraphicEl(dataIndex, null);
        },
        removeOpt: removeAnimationOpt
    });
    symbolEl.fadeOut(null, data.hostModel, {
        fadeLabel: true,
        animation: removeAnimationOpt
    });
    // remove edge as parent node
    node.children.forEach(function(childNode) {
        $c673dc2ab6ad4136$var$removeNodeEdge(childNode, data, group, seriesModel, removeAnimationOpt);
    });
    // remove edge as child node
    $c673dc2ab6ad4136$var$removeNodeEdge(node, data, group, seriesModel, removeAnimationOpt);
}
function $c673dc2ab6ad4136$var$getEdgeShape(layoutOpt, orient, curvature, sourceLayout, targetLayout) {
    var cpx1;
    var cpy1;
    var cpx2;
    var cpy2;
    var x1;
    var x2;
    var y1;
    var y2;
    if (layoutOpt === "radial") {
        x1 = sourceLayout.rawX;
        y1 = sourceLayout.rawY;
        x2 = targetLayout.rawX;
        y2 = targetLayout.rawY;
        var radialCoor1 = (0, $172d7581b75555e9$export$60198ec123d36099)(x1, y1);
        var radialCoor2 = (0, $172d7581b75555e9$export$60198ec123d36099)(x1, y1 + (y2 - y1) * curvature);
        var radialCoor3 = (0, $172d7581b75555e9$export$60198ec123d36099)(x2, y2 + (y1 - y2) * curvature);
        var radialCoor4 = (0, $172d7581b75555e9$export$60198ec123d36099)(x2, y2);
        return {
            x1: radialCoor1.x || 0,
            y1: radialCoor1.y || 0,
            x2: radialCoor4.x || 0,
            y2: radialCoor4.y || 0,
            cpx1: radialCoor2.x || 0,
            cpy1: radialCoor2.y || 0,
            cpx2: radialCoor3.x || 0,
            cpy2: radialCoor3.y || 0
        };
    } else {
        x1 = sourceLayout.x;
        y1 = sourceLayout.y;
        x2 = targetLayout.x;
        y2 = targetLayout.y;
        if (orient === "LR" || orient === "RL") {
            cpx1 = x1 + (x2 - x1) * curvature;
            cpy1 = y1;
            cpx2 = x2 + (x1 - x2) * curvature;
            cpy2 = y2;
        }
        if (orient === "TB" || orient === "BT") {
            cpx1 = x1;
            cpy1 = y1 + (y2 - y1) * curvature;
            cpx2 = x2;
            cpy2 = y2 + (y1 - y2) * curvature;
        }
    }
    return {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        cpx1: cpx1,
        cpy1: cpy1,
        cpx2: cpx2,
        cpy2: cpy2
    };
}
var $c673dc2ab6ad4136$export$2e2bcd8739ae039 = $c673dc2ab6ad4136$var$TreeView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $908076d89767d409$var$TreeSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TreeSeriesModel, _super);
    function TreeSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasSymbolVisual = true;
        // Do it self.
        _this.ignoreStyleOnData = true;
        return _this;
    }
    /**
   * Init a tree data structure from data in option series
   */ TreeSeriesModel.prototype.getInitialData = function(option) {
        // create a virtual root
        var root = {
            name: option.name,
            children: option.data
        };
        var leaves = option.leaves || {};
        var leavesModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(leaves, this, this.ecModel);
        var tree = (0, $116fa5bb9335391f$export$2e2bcd8739ae039).createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod("getItemModel", function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                if (!(node && node.children.length && node.isExpand)) model.parentModel = leavesModel;
                return model;
            });
        }
        var treeDepth = 0;
        tree.eachNode("preorder", function(node) {
            if (node.depth > treeDepth) treeDepth = node.depth;
        });
        var expandAndCollapse = option.expandAndCollapse;
        var expandTreeDepth = expandAndCollapse && option.initialTreeDepth >= 0 ? option.initialTreeDepth : treeDepth;
        tree.root.eachNode("preorder", function(node) {
            var item = node.hostTree.data.getRawDataItem(node.dataIndex);
            // Add item.collapsed != null, because users can collapse node original in the series.data.
            node.isExpand = item && item.collapsed != null ? !item.collapsed : node.depth <= expandTreeDepth;
        });
        return tree.data;
    };
    /**
   * Make the configuration 'orient' backward compatibly, with 'horizontal = LR', 'vertical = TB'.
   * @returns {string} orient
   */ TreeSeriesModel.prototype.getOrient = function() {
        var orient = this.get("orient");
        if (orient === "horizontal") orient = "LR";
        else if (orient === "vertical") orient = "TB";
        return orient;
    };
    TreeSeriesModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    TreeSeriesModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    TreeSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var tree = this.getData().tree;
        var realRoot = tree.root.children[0];
        var node = tree.getNodeByDataIndex(dataIndex);
        var value = node.getValue();
        var name = node.name;
        while(node && node !== realRoot){
            name = node.parentNode.name + "." + name;
            node = node.parentNode;
        }
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
            name: name,
            value: value,
            noValue: isNaN(value) || value == null
        });
    };
    // Add tree path to tooltip param
    TreeSeriesModel.prototype.getDataParams = function(dataIndex) {
        var params = _super.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treeAncestors = (0, $6341f66602946a06$export$c5baa480d6ceb0a3)(node, this);
        params.collapsed = !node.isExpand;
        return params;
    };
    TreeSeriesModel.type = "series.tree";
    // can support the position parameters 'left', 'top','right','bottom', 'width',
    // 'height' in the setOption() with 'merge' mode normal.
    TreeSeriesModel.layoutMode = "box";
    TreeSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: "view",
        // the position of the whole view
        left: "12%",
        top: "12%",
        right: "12%",
        bottom: "12%",
        // the layout of the tree, two value can be selected, 'orthogonal' or 'radial'
        layout: "orthogonal",
        // value can be 'polyline'
        edgeShape: "curve",
        edgeForkPosition: "50%",
        // true | false | 'move' | 'scale', see module:component/helper/RoamController.
        roam: false,
        // Symbol size scale ratio in roam
        nodeScaleRatio: 0.4,
        // Default on center of graph
        center: null,
        zoom: 1,
        orient: "LR",
        symbol: "emptyCircle",
        symbolSize: 7,
        expandAndCollapse: true,
        initialTreeDepth: 2,
        lineStyle: {
            color: "#ccc",
            width: 1.5,
            curveness: 0.5
        },
        itemStyle: {
            color: "lightsteelblue",
            // borderColor: '#c23531',
            borderWidth: 1.5
        },
        label: {
            show: true
        },
        animationEasing: "linear",
        animationDuration: 700,
        animationDurationUpdate: 500
    };
    return TreeSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
var $908076d89767d409$export$2e2bcd8739ae039 = $908076d89767d409$var$TreeSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Traverse the tree from bottom to top and do something
 */ function $40241c7ef27c3238$export$bd961f70bc91ffb4(root, callback, separation) {
    var nodes = [
        root
    ];
    var next = [];
    var node;
    while(node = nodes.pop()){
        // jshint ignore:line
        next.push(node);
        if (node.isExpand) {
            var children = node.children;
            if (children.length) for(var i = 0; i < children.length; i++)nodes.push(children[i]);
        }
    }
    while(node = next.pop())// jshint ignore:line
    callback(node, separation);
}
/**
 * Traverse the tree from top to bottom and do something
 */ function $40241c7ef27c3238$export$32a66ec2b39acdac(root, callback) {
    var nodes = [
        root
    ];
    var node;
    while(node = nodes.pop()){
        // jshint ignore:line
        callback(node);
        if (node.isExpand) {
            var children = node.children;
            if (children.length) for(var i = children.length - 1; i >= 0; i--)nodes.push(children[i]);
        }
    }
}



function $121bf97d85edc8b9$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType("tree", function(seriesModel) {
        $121bf97d85edc8b9$var$commonLayout(seriesModel, api);
    });
}
function $121bf97d85edc8b9$var$commonLayout(seriesModel, api) {
    var layoutInfo = (0, $172d7581b75555e9$export$c02eeb5f98d59b89)(seriesModel, api);
    seriesModel.layoutInfo = layoutInfo;
    var layout = seriesModel.get("layout");
    var width = 0;
    var height = 0;
    var separation = null;
    if (layout === "radial") {
        width = 2 * Math.PI;
        height = Math.min(layoutInfo.height, layoutInfo.width) / 2;
        separation = (0, $172d7581b75555e9$export$3bf720ece7bc7b2e)(function(node1, node2) {
            return (node1.parentNode === node2.parentNode ? 1 : 2) / node1.depth;
        });
    } else {
        width = layoutInfo.width;
        height = layoutInfo.height;
        separation = (0, $172d7581b75555e9$export$3bf720ece7bc7b2e)();
    }
    var virtualRoot = seriesModel.getData().tree.root;
    var realRoot = virtualRoot.children[0];
    if (realRoot) {
        (0, $172d7581b75555e9$export$2cd8252107eb640b)(virtualRoot);
        (0, $40241c7ef27c3238$export$bd961f70bc91ffb4)(realRoot, (0, $172d7581b75555e9$export$f7eff93d75358a2c), separation);
        virtualRoot.hierNode.modifier = -realRoot.hierNode.prelim;
        (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, (0, $172d7581b75555e9$export$39e6f19b1ce889be));
        var left_1 = realRoot;
        var right_1 = realRoot;
        var bottom_1 = realRoot;
        (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, function(node) {
            var x = node.getLayout().x;
            if (x < left_1.getLayout().x) left_1 = node;
            if (x > right_1.getLayout().x) right_1 = node;
            if (node.depth > bottom_1.depth) bottom_1 = node;
        });
        var delta = left_1 === right_1 ? 1 : separation(left_1, right_1) / 2;
        var tx_1 = delta - left_1.getLayout().x;
        var kx_1 = 0;
        var ky_1 = 0;
        var coorX_1 = 0;
        var coorY_1 = 0;
        if (layout === "radial") {
            kx_1 = width / (right_1.getLayout().x + delta + tx_1);
            // here we use (node.depth - 1), bucause the real root's depth is 1
            ky_1 = height / (bottom_1.depth - 1 || 1);
            (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, function(node) {
                coorX_1 = (node.getLayout().x + tx_1) * kx_1;
                coorY_1 = (node.depth - 1) * ky_1;
                var finalCoor = (0, $172d7581b75555e9$export$60198ec123d36099)(coorX_1, coorY_1);
                node.setLayout({
                    x: finalCoor.x,
                    y: finalCoor.y,
                    rawX: coorX_1,
                    rawY: coorY_1
                }, true);
            });
        } else {
            var orient_1 = seriesModel.getOrient();
            if (orient_1 === "RL" || orient_1 === "LR") {
                ky_1 = height / (right_1.getLayout().x + delta + tx_1);
                kx_1 = width / (bottom_1.depth - 1 || 1);
                (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, function(node) {
                    coorY_1 = (node.getLayout().x + tx_1) * ky_1;
                    coorX_1 = orient_1 === "LR" ? (node.depth - 1) * kx_1 : width - (node.depth - 1) * kx_1;
                    node.setLayout({
                        x: coorX_1,
                        y: coorY_1
                    }, true);
                });
            } else if (orient_1 === "TB" || orient_1 === "BT") {
                kx_1 = width / (right_1.getLayout().x + delta + tx_1);
                ky_1 = height / (bottom_1.depth - 1 || 1);
                (0, $40241c7ef27c3238$export$32a66ec2b39acdac)(realRoot, function(node) {
                    coorX_1 = (node.getLayout().x + tx_1) * kx_1;
                    coorY_1 = orient_1 === "TB" ? (node.depth - 1) * ky_1 : height - (node.depth - 1) * ky_1;
                    node.setLayout({
                        x: coorX_1,
                        y: coorY_1
                    }, true);
                });
            }
        }
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $d90852cc2c74d10f$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType("tree", function(seriesModel) {
        var data = seriesModel.getData();
        var tree = data.tree;
        tree.eachNode(function(node) {
            var model = node.getModel();
            // TODO Optimize
            var style = model.getModel("itemStyle").getItemStyle();
            var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, "style");
            (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(existsStyle, style);
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $0f83bac2aba33cc4$export$83b6a0f4104bd4f4(registers) {
    registers.registerAction({
        type: "treeExpandAndCollapse",
        event: "treeExpandAndCollapse",
        update: "update"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "series",
            subType: "tree",
            query: payload
        }, function(seriesModel) {
            var dataIndex = payload.dataIndex;
            var tree = seriesModel.getData().tree;
            var node = tree.getNodeByDataIndex(dataIndex);
            node.isExpand = !node.isExpand;
        });
    });
    registers.registerAction({
        type: "treeRoam",
        event: "treeRoam",
        // Here we set 'none' instead of 'update', because roam action
        // just need to update the transform matrix without having to recalculate
        // the layout. So don't need to go through the whole update process, such
        // as 'dataPrcocess', 'coordSystemUpdate', 'layout' and so on.
        update: "none"
    }, function(payload, ecModel, api) {
        ecModel.eachComponent({
            mainType: "series",
            subType: "tree",
            query: payload
        }, function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            var res = (0, $799fe5cfb5042219$export$797ecc50d262ebd8)(coordSys, payload, undefined, api);
            seriesModel.setCenter && seriesModel.setCenter(res.center);
            seriesModel.setZoom && seriesModel.setZoom(res.zoom);
        });
    });
}


function $44a5d4d260c7de78$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $c673dc2ab6ad4136$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $908076d89767d409$export$2e2bcd8739ae039));
    registers.registerLayout((0, $121bf97d85edc8b9$export$2e2bcd8739ae039));
    registers.registerVisual((0, $d90852cc2c74d10f$export$2e2bcd8739ae039));
    (0, $0f83bac2aba33cc4$export$83b6a0f4104bd4f4)(registers);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $26d493e9cdfadb01$var$actionTypes = [
    "treemapZoomToNode",
    "treemapRender",
    "treemapMove"
];
function $26d493e9cdfadb01$export$1ad90fc3f3a8bbf9(registers) {
    for(var i = 0; i < $26d493e9cdfadb01$var$actionTypes.length; i++)registers.registerAction({
        type: $26d493e9cdfadb01$var$actionTypes[i],
        update: "updateView"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    registers.registerAction({
        type: "treemapRootToNode",
        update: "updateView"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "series",
            subType: "treemap",
            query: payload
        }, handleRootToNode);
        function handleRootToNode(model, index) {
            var types = [
                "treemapZoomToNode",
                "treemapRootToNode"
            ];
            var targetInfo = $6341f66602946a06$export$c5445fa59c15dec4(payload, types, model);
            if (targetInfo) {
                var originViewRoot = model.getViewRoot();
                if (originViewRoot) payload.direction = $6341f66602946a06$export$df59de26c77b5bea(originViewRoot, targetInfo.node) ? "rollUp" : "drillDown";
                model.resetViewRoot(targetInfo.node);
            }
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $10d079b37d9731a3$var$TreemapSeriesModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TreemapSeriesModel, _super);
    function TreemapSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TreemapSeriesModel.type;
        _this.preventUsingHoverLayer = true;
        return _this;
    }
    /**
   * @override
   */ TreemapSeriesModel.prototype.getInitialData = function(option, ecModel) {
        // Create a virtual root.
        var root = {
            name: option.name,
            children: option.data
        };
        $10d079b37d9731a3$var$completeTreeValue(root);
        var levels = option.levels || [];
        // Used in "visual priority" in `treemapVisual.js`.
        // This way is a little tricky, must satisfy the precondition:
        //   1. There is no `treeNode.getModel('itemStyle.xxx')` used.
        //   2. The `Model.prototype.getModel()` will not use any clone-like way.
        var designatedVisualItemStyle = this.designatedVisualItemStyle = {};
        var designatedVisualModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)({
            itemStyle: designatedVisualItemStyle
        }, this, ecModel);
        levels = option.levels = $10d079b37d9731a3$var$setDefault(levels, ecModel);
        var levelModels = $7a1bd9c2710fea0d$export$871de8747c9eaa88(levels || [], function(levelDefine) {
            return new (0, $6818646a97528290$export$2e2bcd8739ae039)(levelDefine, designatedVisualModel, ecModel);
        }, this);
        // Make sure always a new tree is created when setOption,
        // in TreemapView, we check whether oldTree === newTree
        // to choose mappings approach among old shapes and new shapes.
        var tree = (0, $116fa5bb9335391f$export$2e2bcd8739ae039).createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod("getItemModel", function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                var levelModel = node ? levelModels[node.depth] : null;
                // If no levelModel, we also need `designatedVisualModel`.
                model.parentModel = levelModel || designatedVisualModel;
                return model;
            });
        }
        return tree.data;
    };
    TreemapSeriesModel.prototype.optionUpdated = function() {
        this.resetViewRoot();
    };
    /**
   * @override
   * @param {number} dataIndex
   * @param {boolean} [mutipleSeries=false]
   */ TreemapSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var name = data.getName(dataIndex);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
            name: name,
            value: value
        });
    };
    /**
   * Add tree path to tooltip param
   *
   * @override
   * @param {number} dataIndex
   * @return {Object}
   */ TreemapSeriesModel.prototype.getDataParams = function(dataIndex) {
        var params = _super.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treeAncestors = (0, $6341f66602946a06$export$c5baa480d6ceb0a3)(node, this);
        // compatitable the previous code.
        params.treePathInfo = params.treeAncestors;
        return params;
    };
    /**
   * @public
   * @param {Object} layoutInfo {
   *                                x: containerGroup x
   *                                y: containerGroup y
   *                                width: containerGroup width
   *                                height: containerGroup height
   *                            }
   */ TreemapSeriesModel.prototype.setLayoutInfo = function(layoutInfo) {
        /**
     * @readOnly
     * @type {Object}
     */ this.layoutInfo = this.layoutInfo || {};
        $7a1bd9c2710fea0d$export$8b58be045bf06082(this.layoutInfo, layoutInfo);
    };
    /**
   * @param  {string} id
   * @return {number} index
   */ TreemapSeriesModel.prototype.mapIdToIndex = function(id) {
        // A feature is implemented:
        // index is monotone increasing with the sequence of
        // input id at the first time.
        // This feature can make sure that each data item and its
        // mapped color have the same index between data list and
        // color list at the beginning, which is useful for user
        // to adjust data-color mapping.
        /**
     * @private
     * @type {Object}
     */ var idIndexMap = this._idIndexMap;
        if (!idIndexMap) {
            idIndexMap = this._idIndexMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
            /**
       * @private
       * @type {number}
       */ this._idIndexMapCount = 0;
        }
        var index = idIndexMap.get(id);
        if (index == null) idIndexMap.set(id, index = this._idIndexMapCount++);
        return index;
    };
    TreemapSeriesModel.prototype.getViewRoot = function() {
        return this._viewRoot;
    };
    TreemapSeriesModel.prototype.resetViewRoot = function(viewRoot) {
        viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
        var root = this.getRawData().tree.root;
        if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) this._viewRoot = root;
    };
    TreemapSeriesModel.prototype.enableAriaDecal = function() {
        (0, $a116b59e46d9072c$export$2e2bcd8739ae039)(this);
    };
    TreemapSeriesModel.type = "series.treemap";
    TreemapSeriesModel.layoutMode = "box";
    TreemapSeriesModel.defaultOption = {
        // Disable progressive rendering
        progressive: 0,
        // size: ['80%', '80%'],            // deprecated, compatible with ec2.
        left: "center",
        top: "middle",
        width: "80%",
        height: "80%",
        sort: true,
        clipWindow: "origin",
        squareRatio: 0.5 * (1 + Math.sqrt(5)),
        leafDepth: null,
        drillDownIcon: "\u25B6",
        // to align specialized icon. ▷▶❒❐▼✚
        zoomToNodeRatio: 0.1024,
        roam: true,
        nodeClick: "zoomToNode",
        animation: true,
        animationDurationUpdate: 900,
        animationEasing: "quinticInOut",
        breadcrumb: {
            show: true,
            height: 22,
            left: "center",
            top: "bottom",
            // right
            // bottom
            emptyItemWidth: 25,
            itemStyle: {
                color: "rgba(0,0,0,0.7)",
                textStyle: {
                    color: "#fff"
                }
            },
            emphasis: {
                itemStyle: {
                    color: "rgba(0,0,0,0.9)" // '#5793f3',
                }
            }
        },
        label: {
            show: true,
            // Do not use textDistance, for ellipsis rect just the same as treemap node rect.
            distance: 0,
            padding: 5,
            position: "inside",
            // formatter: null,
            color: "#fff",
            overflow: "truncate"
        },
        upperLabel: {
            show: false,
            position: [
                0,
                "50%"
            ],
            height: 20,
            // formatter: null,
            // color: '#fff',
            overflow: "truncate",
            // align: null,
            verticalAlign: "middle"
        },
        itemStyle: {
            color: null,
            colorAlpha: null,
            colorSaturation: null,
            borderWidth: 0,
            gapWidth: 0,
            borderColor: "#fff",
            borderColorSaturation: null // If specified, borderColor will be ineffective, and the
        },
        emphasis: {
            upperLabel: {
                show: true,
                position: [
                    0,
                    "50%"
                ],
                overflow: "truncate",
                verticalAlign: "middle"
            }
        },
        visualDimension: 0,
        visualMin: null,
        visualMax: null,
        color: [],
        // level[n].color (if necessary).
        // + Specify color list of each level. level[0].color would be global
        // color list if not specified. (see method `setDefault`).
        // + But set as a empty array to forbid fetch color from global palette
        // when using nodeModel.get('color'), otherwise nodes on deep level
        // will always has color palette set and are not able to inherit color
        // from parent node.
        // + TreemapSeries.color can not be set as 'none', otherwise effect
        // legend color fetching (see seriesColor.js).
        colorAlpha: null,
        colorSaturation: null,
        colorMappingBy: "index",
        visibleMin: 10,
        // be rendered. Only works when sort is 'asc' or 'desc'.
        childrenVisibleMin: null,
        // grandchildren will not show.
        // Why grandchildren? If not grandchildren but children,
        // some siblings show children and some not,
        // the appearance may be mess and not consistent,
        levels: [] // Each item: {
    };
    return TreemapSeriesModel;
}((0, $7c10febb2cdef0d8$export$2e2bcd8739ae039));
/**
 * @param {Object} dataNode
 */ function $10d079b37d9731a3$var$completeTreeValue(dataNode) {
    // Postorder travel tree.
    // If value of none-leaf node is not set,
    // calculate it by suming up the value of all children.
    var sum = 0;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(dataNode.children, function(child) {
        $10d079b37d9731a3$var$completeTreeValue(child);
        var childValue = child.value;
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(childValue) && (childValue = childValue[0]);
        sum += childValue;
    });
    var thisValue = dataNode.value;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(thisValue)) thisValue = thisValue[0];
    if (thisValue == null || isNaN(thisValue)) thisValue = sum;
    // Value should not less than 0.
    if (thisValue < 0) thisValue = 0;
    $7a1bd9c2710fea0d$export$43bee75e5e14138e(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}
/**
 * set default to level configuration
 */ function $10d079b37d9731a3$var$setDefault(levels, ecModel) {
    var globalColorList = (0, $76d619f648247e6d$export$4f07b212a02c8051)(ecModel.get("color"));
    var globalDecalList = (0, $76d619f648247e6d$export$4f07b212a02c8051)(ecModel.get([
        "aria",
        "decal",
        "decals"
    ]));
    if (!globalColorList) return;
    levels = levels || [];
    var hasColorDefine;
    var hasDecalDefine;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(levels, function(levelDefine) {
        var model = new (0, $6818646a97528290$export$2e2bcd8739ae039)(levelDefine);
        var modelColor = model.get("color");
        var modelDecal = model.get("decal");
        if (model.get([
            "itemStyle",
            "color"
        ]) || modelColor && modelColor !== "none") hasColorDefine = true;
        if (model.get([
            "itemStyle",
            "decal"
        ]) || modelDecal && modelDecal !== "none") hasDecalDefine = true;
    });
    var level0 = levels[0] || (levels[0] = {});
    if (!hasColorDefine) level0.color = globalColorList.slice();
    if (!hasDecalDefine && globalDecalList) level0.decal = globalDecalList.slice();
    return levels;
}
var $10d079b37d9731a3$export$2e2bcd8739ae039 = $10d079b37d9731a3$var$TreemapSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $504a89857fe7780b$var$TEXT_PADDING = 8;
var $504a89857fe7780b$var$ITEM_GAP = 8;
var $504a89857fe7780b$var$ARRAY_LENGTH = 5;
var $504a89857fe7780b$var$Breadcrumb = /** @class */ function() {
    function Breadcrumb(containerGroup) {
        this.group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        containerGroup.add(this.group);
    }
    Breadcrumb.prototype.render = function(seriesModel, api, targetNode, onSelect) {
        var model = seriesModel.getModel("breadcrumb");
        var thisGroup = this.group;
        thisGroup.removeAll();
        if (!model.get("show") || !targetNode) return;
        var normalStyleModel = model.getModel("itemStyle");
        var emphasisModel = model.getModel("emphasis");
        var textStyleModel = normalStyleModel.getModel("textStyle");
        var emphasisTextStyleModel = emphasisModel.getModel([
            "itemStyle",
            "textStyle"
        ]);
        var layoutParam = {
            pos: {
                left: model.get("left"),
                right: model.get("right"),
                top: model.get("top"),
                bottom: model.get("bottom")
            },
            box: {
                width: api.getWidth(),
                height: api.getHeight()
            },
            emptyItemWidth: model.get("emptyItemWidth"),
            totalWidth: 0,
            renderList: []
        };
        this._prepare(targetNode, layoutParam, textStyleModel);
        this._renderContent(seriesModel, layoutParam, normalStyleModel, emphasisModel, textStyleModel, emphasisTextStyleModel, onSelect);
        $93b9bc7f22ac7369$export$74054bd96b5eeef1(thisGroup, layoutParam.pos, layoutParam.box);
    };
    /**
   * Prepare render list and total width
   * @private
   */ Breadcrumb.prototype._prepare = function(targetNode, layoutParam, textStyleModel) {
        for(var node = targetNode; node; node = node.parentNode){
            var text = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(node.getModel().get("name"), "");
            var textRect = textStyleModel.getTextRect(text);
            var itemWidth = Math.max(textRect.width + $504a89857fe7780b$var$TEXT_PADDING * 2, layoutParam.emptyItemWidth);
            layoutParam.totalWidth += itemWidth + $504a89857fe7780b$var$ITEM_GAP;
            layoutParam.renderList.push({
                node: node,
                text: text,
                width: itemWidth
            });
        }
    };
    /**
   * @private
   */ Breadcrumb.prototype._renderContent = function(seriesModel, layoutParam, normalStyleModel, emphasisModel, textStyleModel, emphasisTextStyleModel, onSelect) {
        // Start rendering.
        var lastX = 0;
        var emptyItemWidth = layoutParam.emptyItemWidth;
        var height = seriesModel.get([
            "breadcrumb",
            "height"
        ]);
        var availableSize = $93b9bc7f22ac7369$export$145a8938a85a22b1(layoutParam.pos, layoutParam.box);
        var totalWidth = layoutParam.totalWidth;
        var renderList = layoutParam.renderList;
        var emphasisItemStyle = emphasisModel.getModel("itemStyle").getItemStyle();
        for(var i = renderList.length - 1; i >= 0; i--){
            var item = renderList[i];
            var itemNode = item.node;
            var itemWidth = item.width;
            var text = item.text;
            // Hdie text and shorten width if necessary.
            if (totalWidth > availableSize.width) {
                totalWidth -= itemWidth - emptyItemWidth;
                itemWidth = emptyItemWidth;
                text = null;
            }
            var el = new $51acf033123e1a30$export$2e2bcd8739ae039({
                shape: {
                    points: $504a89857fe7780b$var$makeItemPoints(lastX, 0, itemWidth, height, i === renderList.length - 1, i === 0)
                },
                style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)(normalStyleModel.getItemStyle(), {
                    lineJoin: "bevel"
                }),
                textContent: new $fe885cc21795562b$export$2e2bcd8739ae039({
                    style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                        text: text
                    })
                }),
                textConfig: {
                    position: "inside"
                },
                z2: (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) * 1e4,
                onclick: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(onSelect, itemNode)
            });
            el.disableLabelAnimation = true;
            el.getTextContent().ensureState("emphasis").style = (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(emphasisTextStyleModel, {
                text: text
            });
            el.ensureState("emphasis").style = emphasisItemStyle;
            (0, $2bf82c0980125b62$export$e51187539ff11209)(el, emphasisModel.get("focus"), emphasisModel.get("blurScope"), emphasisModel.get("disabled"));
            this.group.add(el);
            $504a89857fe7780b$var$packEventData(el, seriesModel, itemNode);
            lastX += itemWidth + $504a89857fe7780b$var$ITEM_GAP;
        }
    };
    Breadcrumb.prototype.remove = function() {
        this.group.removeAll();
    };
    return Breadcrumb;
}();
function $504a89857fe7780b$var$makeItemPoints(x, y, itemWidth, itemHeight, head, tail) {
    var points = [
        [
            head ? x : x - $504a89857fe7780b$var$ARRAY_LENGTH,
            y
        ],
        [
            x + itemWidth,
            y
        ],
        [
            x + itemWidth,
            y + itemHeight
        ],
        [
            head ? x : x - $504a89857fe7780b$var$ARRAY_LENGTH,
            y + itemHeight
        ]
    ];
    !tail && points.splice(2, 0, [
        x + itemWidth + $504a89857fe7780b$var$ARRAY_LENGTH,
        y + itemHeight / 2
    ]);
    !head && points.push([
        x,
        y + itemHeight / 2
    ]);
    return points;
}
// Package custom mouse event.
function $504a89857fe7780b$var$packEventData(el, seriesModel, itemNode) {
    (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).eventData = {
        componentType: "series",
        componentSubType: "treemap",
        componentIndex: seriesModel.componentIndex,
        seriesIndex: seriesModel.seriesIndex,
        seriesName: seriesModel.name,
        seriesType: "treemap",
        selfType: "breadcrumb",
        nodeData: {
            dataIndex: itemNode && itemNode.dataIndex,
            name: itemNode && itemNode.name
        },
        treePathInfo: itemNode && (0, $6341f66602946a06$export$c5baa480d6ceb0a3)(itemNode, seriesModel)
    };
}
var $504a89857fe7780b$export$2e2bcd8739ae039 = $504a89857fe7780b$var$Breadcrumb;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Animate multiple elements with a single done-callback.
 *
 * @example
 *  animation
 *      .createWrap()
 *      .add(el1, {x: 10, y: 10})
 *      .add(el2, {shape: {width: 500}, style: {fill: 'red'}}, 400)
 *      .done(function () { // done })
 *      .start('cubicOut');
 */ var $d83d3d8d08e5712f$var$AnimationWrap = /** @class */ function() {
    function AnimationWrap() {
        this._storage = [];
        this._elExistsMap = {};
    }
    /**
   * Caution: a el can only be added once, otherwise 'done'
   * might not be called. This method checks this (by el.id),
   * suppresses adding and returns false when existing el found.
   *
   * @return Whether adding succeeded.
   */ AnimationWrap.prototype.add = function(el, target, duration, delay, easing) {
        if (this._elExistsMap[el.id]) return false;
        this._elExistsMap[el.id] = true;
        this._storage.push({
            el: el,
            target: target,
            duration: duration,
            delay: delay,
            easing: easing
        });
        return true;
    };
    /**
   * Only execute when animation done/aborted.
   */ AnimationWrap.prototype.finished = function(callback) {
        this._finishedCallback = callback;
        return this;
    };
    /**
   * Will stop exist animation firstly.
   */ AnimationWrap.prototype.start = function() {
        var _this = this;
        var count = this._storage.length;
        var checkTerminate = function() {
            count--;
            if (count <= 0) {
                // Guard.
                _this._storage.length = 0;
                _this._elExistsMap = {};
                _this._finishedCallback && _this._finishedCallback();
            }
        };
        for(var i = 0, len = this._storage.length; i < len; i++){
            var item = this._storage[i];
            item.el.animateTo(item.target, {
                duration: item.duration,
                delay: item.delay,
                easing: item.easing,
                setToFinal: true,
                done: checkTerminate,
                aborted: checkTerminate
            });
        }
        return this;
    };
    return AnimationWrap;
}();
function $d83d3d8d08e5712f$export$944643101ee10c7() {
    return new $d83d3d8d08e5712f$var$AnimationWrap();
}








var $ca67abe413e4c090$var$Group = $7ef7583d8302ffce$export$2e2bcd8739ae039;
var $ca67abe413e4c090$var$Rect = $419e5ff2f303755e$export$2e2bcd8739ae039;
var $ca67abe413e4c090$var$DRAG_THRESHOLD = 3;
var $ca67abe413e4c090$var$PATH_LABEL_NOAMAL = "label";
var $ca67abe413e4c090$var$PATH_UPPERLABEL_NORMAL = "upperLabel";
// Should larger than emphasis states lift z
var $ca67abe413e4c090$var$Z2_BASE = (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) * 10; // Should bigger than every z2.
var $ca67abe413e4c090$var$Z2_BG = (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) * 2;
var $ca67abe413e4c090$var$Z2_CONTENT = (0, $2bf82c0980125b62$export$1cb9fc6ed5b9836c) * 3;
var $ca67abe413e4c090$var$getStateItemStyle = (0, $06542048a26d4d91$export$2e2bcd8739ae039)([
    [
        "fill",
        "color"
    ],
    // `borderColor` and `borderWidth` has been occupied,
    // so use `stroke` to indicate the stroke of the rect.
    [
        "stroke",
        "strokeColor"
    ],
    [
        "lineWidth",
        "strokeWidth"
    ],
    [
        "shadowBlur"
    ],
    [
        "shadowOffsetX"
    ],
    [
        "shadowOffsetY"
    ],
    [
        "shadowColor"
    ]
]);
var $ca67abe413e4c090$var$getItemStyleNormal = function(model) {
    // Normal style props should include emphasis style props.
    var itemStyle = $ca67abe413e4c090$var$getStateItemStyle(model);
    // Clear styles set by emphasis.
    itemStyle.stroke = itemStyle.fill = itemStyle.lineWidth = null;
    return itemStyle;
};
var $ca67abe413e4c090$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $ca67abe413e4c090$var$TreemapView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TreemapView, _super);
    function TreemapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TreemapView.type;
        _this._state = "ready";
        _this._storage = $ca67abe413e4c090$var$createStorage();
        return _this;
    }
    /**
   * @override
   */ TreemapView.prototype.render = function(seriesModel, ecModel, api, payload) {
        var models = ecModel.findComponents({
            mainType: "series",
            subType: "treemap",
            query: payload
        });
        if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(models, seriesModel) < 0) return;
        this.seriesModel = seriesModel;
        this.api = api;
        this.ecModel = ecModel;
        var types = [
            "treemapZoomToNode",
            "treemapRootToNode"
        ];
        var targetInfo = $6341f66602946a06$export$c5445fa59c15dec4(payload, types, seriesModel);
        var payloadType = payload && payload.type;
        var layoutInfo = seriesModel.layoutInfo;
        var isInit = !this._oldTree;
        var thisStorage = this._storage;
        // Mark new root when action is treemapRootToNode.
        var reRoot = payloadType === "treemapRootToNode" && targetInfo && thisStorage ? {
            rootNodeGroup: thisStorage.nodeGroup[targetInfo.node.getRawIndex()],
            direction: payload.direction
        } : null;
        var containerGroup = this._giveContainerGroup(layoutInfo);
        var hasAnimation = seriesModel.get("animation");
        var renderResult = this._doRender(containerGroup, seriesModel, reRoot);
        hasAnimation && !isInit && (!payloadType || payloadType === "treemapZoomToNode" || payloadType === "treemapRootToNode") ? this._doAnimation(containerGroup, renderResult, seriesModel, reRoot) : renderResult.renderFinally();
        this._resetController(api);
        this._renderBreadcrumb(seriesModel, api, targetInfo);
    };
    TreemapView.prototype._giveContainerGroup = function(layoutInfo) {
        var containerGroup = this._containerGroup;
        if (!containerGroup) {
            // FIXME
            // 加一层containerGroup是为了clip，但是现在clip功能并没有实现。
            containerGroup = this._containerGroup = new $ca67abe413e4c090$var$Group();
            this._initEvents(containerGroup);
            this.group.add(containerGroup);
        }
        containerGroup.x = layoutInfo.x;
        containerGroup.y = layoutInfo.y;
        return containerGroup;
    };
    TreemapView.prototype._doRender = function(containerGroup, seriesModel, reRoot) {
        var thisTree = seriesModel.getData().tree;
        var oldTree = this._oldTree;
        // Clear last shape records.
        var lastsForAnimation = $ca67abe413e4c090$var$createStorage();
        var thisStorage = $ca67abe413e4c090$var$createStorage();
        var oldStorage = this._storage;
        var willInvisibleEls = [];
        function doRenderNode(thisNode, oldNode, parentGroup, depth) {
            return $ca67abe413e4c090$var$renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth);
        }
        // Notice: When thisTree and oldTree are the same tree (see list.cloneShallow),
        // the oldTree is actually losted, so we cannot find all of the old graphic
        // elements from tree. So we use this strategy: make element storage, move
        // from old storage to new storage, clear old storage.
        dualTravel(thisTree.root ? [
            thisTree.root
        ] : [], oldTree && oldTree.root ? [
            oldTree.root
        ] : [], containerGroup, thisTree === oldTree || !oldTree, 0);
        // Process all removing.
        var willDeleteEls = clearStorage(oldStorage);
        this._oldTree = thisTree;
        this._storage = thisStorage;
        return {
            lastsForAnimation: lastsForAnimation,
            willDeleteEls: willDeleteEls,
            renderFinally: renderFinally
        };
        function dualTravel(thisViewChildren, oldViewChildren, parentGroup, sameTree, depth) {
            // When 'render' is triggered by action,
            // 'this' and 'old' may be the same tree,
            // we use rawIndex in that case.
            if (sameTree) {
                oldViewChildren = thisViewChildren;
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(thisViewChildren, function(child, index) {
                    !child.isRemoved() && processNode(index, index);
                });
            } else new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldViewChildren, thisViewChildren, getKey, getKey).add(processNode).update(processNode).remove((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)(processNode, null)).execute();
            function getKey(node) {
                // Identify by name or raw index.
                return node.getId();
            }
            function processNode(newIndex, oldIndex) {
                var thisNode = newIndex != null ? thisViewChildren[newIndex] : null;
                var oldNode = oldIndex != null ? oldViewChildren[oldIndex] : null;
                var group = doRenderNode(thisNode, oldNode, parentGroup, depth);
                group && dualTravel(thisNode && thisNode.viewChildren || [], oldNode && oldNode.viewChildren || [], group, sameTree, depth + 1);
            }
        }
        function clearStorage(storage) {
            var willDeleteEls = $ca67abe413e4c090$var$createStorage();
            storage && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(storage, function(store, storageName) {
                var delEls = willDeleteEls[storageName];
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(store, function(el) {
                    el && (delEls.push(el), $ca67abe413e4c090$var$inner(el).willDelete = true);
                });
            });
            return willDeleteEls;
        }
        function renderFinally() {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(willDeleteEls, function(els) {
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(els, function(el) {
                    el.parent && el.parent.remove(el);
                });
            });
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(willInvisibleEls, function(el) {
                el.invisible = true;
                // Setting invisible is for optimizing, so no need to set dirty,
                // just mark as invisible.
                el.dirty();
            });
        }
    };
    TreemapView.prototype._doAnimation = function(containerGroup, renderResult, seriesModel, reRoot) {
        var durationOption = seriesModel.get("animationDurationUpdate");
        var easingOption = seriesModel.get("animationEasing");
        // TODO: do not support function until necessary.
        var duration = ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(durationOption) ? 0 : durationOption) || 0;
        var easing = ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(easingOption) ? null : easingOption) || "cubicOut";
        var animationWrap = $d83d3d8d08e5712f$export$944643101ee10c7();
        // Make delete animations.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(renderResult.willDeleteEls, function(store, storageName) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(store, function(el, rawIndex) {
                if (el.invisible) return;
                var parent = el.parent; // Always has parent, and parent is nodeGroup.
                var target;
                var innerStore = $ca67abe413e4c090$var$inner(parent);
                if (reRoot && reRoot.direction === "drillDown") target = parent === reRoot.rootNodeGroup ? {
                    shape: {
                        x: 0,
                        y: 0,
                        width: innerStore.nodeWidth,
                        height: innerStore.nodeHeight
                    },
                    style: {
                        opacity: 0
                    }
                } : {
                    style: {
                        opacity: 0
                    }
                };
                else {
                    var targetX = 0;
                    var targetY = 0;
                    if (!innerStore.willDelete) {
                        // Let node animate to right-bottom corner, cooperating with fadeout,
                        // which is appropriate for user understanding.
                        // Divided by 2 for reRoot rolling up effect.
                        targetX = innerStore.nodeWidth / 2;
                        targetY = innerStore.nodeHeight / 2;
                    }
                    target = storageName === "nodeGroup" ? {
                        x: targetX,
                        y: targetY,
                        style: {
                            opacity: 0
                        }
                    } : {
                        shape: {
                            x: targetX,
                            y: targetY,
                            width: 0,
                            height: 0
                        },
                        style: {
                            opacity: 0
                        }
                    };
                }
                // TODO: do not support delay until necessary.
                target && animationWrap.add(el, target, duration, 0, easing);
            });
        });
        // Make other animations
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._storage, function(store, storageName) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(store, function(el, rawIndex) {
                var last = renderResult.lastsForAnimation[storageName][rawIndex];
                var target = {};
                if (!last) return;
                if (el instanceof $7ef7583d8302ffce$export$2e2bcd8739ae039) {
                    if (last.oldX != null) {
                        target.x = el.x;
                        target.y = el.y;
                        el.x = last.oldX;
                        el.y = last.oldY;
                    }
                } else {
                    if (last.oldShape) {
                        target.shape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, el.shape);
                        el.setShape(last.oldShape);
                    }
                    if (last.fadein) {
                        el.setStyle("opacity", 0);
                        target.style = {
                            opacity: 1
                        };
                    } else if (el.style.opacity !== 1) target.style = {
                        opacity: 1
                    };
                }
                animationWrap.add(el, target, duration, 0, easing);
            });
        }, this);
        this._state = "animating";
        animationWrap.finished((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(function() {
            this._state = "ready";
            renderResult.renderFinally();
        }, this)).start();
    };
    TreemapView.prototype._resetController = function(api) {
        var controller = this._controller;
        // Init controller.
        if (!controller) {
            controller = this._controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
            controller.enable(this.seriesModel.get("roam"));
            controller.on("pan", (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onPan, this));
            controller.on("zoom", (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onZoom, this));
        }
        var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(0, 0, api.getWidth(), api.getHeight());
        controller.setPointerChecker(function(e, x, y) {
            return rect.contain(x, y);
        });
    };
    TreemapView.prototype._clearController = function() {
        var controller = this._controller;
        if (controller) {
            controller.dispose();
            controller = null;
        }
    };
    TreemapView.prototype._onPan = function(e) {
        if (this._state !== "animating" && (Math.abs(e.dx) > $ca67abe413e4c090$var$DRAG_THRESHOLD || Math.abs(e.dy) > $ca67abe413e4c090$var$DRAG_THRESHOLD)) {
            // These param must not be cached.
            var root = this.seriesModel.getData().tree.root;
            if (!root) return;
            var rootLayout = root.getLayout();
            if (!rootLayout) return;
            this.api.dispatchAction({
                type: "treemapMove",
                from: this.uid,
                seriesId: this.seriesModel.id,
                rootRect: {
                    x: rootLayout.x + e.dx,
                    y: rootLayout.y + e.dy,
                    width: rootLayout.width,
                    height: rootLayout.height
                }
            });
        }
    };
    TreemapView.prototype._onZoom = function(e) {
        var mouseX = e.originX;
        var mouseY = e.originY;
        if (this._state !== "animating") {
            // These param must not be cached.
            var root = this.seriesModel.getData().tree.root;
            if (!root) return;
            var rootLayout = root.getLayout();
            if (!rootLayout) return;
            var rect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(rootLayout.x, rootLayout.y, rootLayout.width, rootLayout.height);
            var layoutInfo = this.seriesModel.layoutInfo;
            // Transform mouse coord from global to containerGroup.
            mouseX -= layoutInfo.x;
            mouseY -= layoutInfo.y;
            // Scale root bounding rect.
            var m = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
                -mouseX,
                -mouseY
            ]);
            $f41ebb9dd60b55b4$export$dcdf75081b88279d(m, m, [
                e.scale,
                e.scale
            ]);
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
                mouseX,
                mouseY
            ]);
            rect.applyTransform(m);
            this.api.dispatchAction({
                type: "treemapRender",
                from: this.uid,
                seriesId: this.seriesModel.id,
                rootRect: {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                }
            });
        }
    };
    TreemapView.prototype._initEvents = function(containerGroup) {
        var _this = this;
        containerGroup.on("click", function(e) {
            if (_this._state !== "ready") return;
            var nodeClick = _this.seriesModel.get("nodeClick", true);
            if (!nodeClick) return;
            var targetInfo = _this.findTarget(e.offsetX, e.offsetY);
            if (!targetInfo) return;
            var node = targetInfo.node;
            if (node.getLayout().isLeafRoot) _this._rootToNode(targetInfo);
            else {
                if (nodeClick === "zoomToNode") _this._zoomToNode(targetInfo);
                else if (nodeClick === "link") {
                    var itemModel = node.hostTree.data.getItemModel(node.dataIndex);
                    var link = itemModel.get("link", true);
                    var linkTarget = itemModel.get("target", true) || "blank";
                    link && (0, $c84c9521536c601a$export$13e13f9b96dbe8fa)(link, linkTarget);
                }
            }
        }, this);
    };
    TreemapView.prototype._renderBreadcrumb = function(seriesModel, api, targetInfo) {
        var _this = this;
        if (!targetInfo) {
            targetInfo = seriesModel.get("leafDepth", true) != null ? {
                node: seriesModel.getViewRoot()
            } : this.findTarget(api.getWidth() / 2, api.getHeight() / 2);
            if (!targetInfo) targetInfo = {
                node: seriesModel.getData().tree.root
            };
        }
        (this._breadcrumb || (this._breadcrumb = new (0, $504a89857fe7780b$export$2e2bcd8739ae039)(this.group))).render(seriesModel, api, targetInfo.node, function(node) {
            if (_this._state !== "animating") $6341f66602946a06$export$df59de26c77b5bea(seriesModel.getViewRoot(), node) ? _this._rootToNode({
                node: node
            }) : _this._zoomToNode({
                node: node
            });
        });
    };
    /**
   * @override
   */ TreemapView.prototype.remove = function() {
        this._clearController();
        this._containerGroup && this._containerGroup.removeAll();
        this._storage = $ca67abe413e4c090$var$createStorage();
        this._state = "ready";
        this._breadcrumb && this._breadcrumb.remove();
    };
    TreemapView.prototype.dispose = function() {
        this._clearController();
    };
    TreemapView.prototype._zoomToNode = function(targetInfo) {
        this.api.dispatchAction({
            type: "treemapZoomToNode",
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: targetInfo.node
        });
    };
    TreemapView.prototype._rootToNode = function(targetInfo) {
        this.api.dispatchAction({
            type: "treemapRootToNode",
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: targetInfo.node
        });
    };
    /**
   * @public
   * @param {number} x Global coord x.
   * @param {number} y Global coord y.
   * @return {Object} info If not found, return undefined;
   * @return {number} info.node Target node.
   * @return {number} info.offsetX x refer to target node.
   * @return {number} info.offsetY y refer to target node.
   */ TreemapView.prototype.findTarget = function(x, y) {
        var targetInfo;
        var viewRoot = this.seriesModel.getViewRoot();
        viewRoot.eachNode({
            attr: "viewChildren",
            order: "preorder"
        }, function(node) {
            var bgEl = this._storage.background[node.getRawIndex()];
            // If invisible, there might be no element.
            if (bgEl) {
                var point = bgEl.transformCoordToLocal(x, y);
                var shape = bgEl.shape;
                // For performance consideration, don't use 'getBoundingRect'.
                if (shape.x <= point[0] && point[0] <= shape.x + shape.width && shape.y <= point[1] && point[1] <= shape.y + shape.height) targetInfo = {
                    node: node,
                    offsetX: point[0],
                    offsetY: point[1]
                };
                else return false; // Suppress visit subtree.
            }
        }, this);
        return targetInfo;
    };
    TreemapView.type = "treemap";
    return TreemapView;
}((0, $0dc5061053e23cd3$export$2e2bcd8739ae039));
/**
 * @inner
 */ function $ca67abe413e4c090$var$createStorage() {
    return {
        nodeGroup: [],
        background: [],
        content: []
    };
}
/**
 * @inner
 * @return Return undefined means do not travel further.
 */ function $ca67abe413e4c090$var$renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth) {
    // Whether under viewRoot.
    if (!thisNode) // Deleting nodes will be performed finally. This method just find
    // element from old storage, or create new element, set them to new
    // storage, and set styles.
    return;
    // -------------------------------------------------------------------
    // Start of closure variables available in "Procedures in renderNode".
    var thisLayout = thisNode.getLayout();
    var data = seriesModel.getData();
    var nodeModel = thisNode.getModel();
    // Only for enabling highlight/downplay. Clear firstly.
    // Because some node will not be rendered.
    data.setItemGraphicEl(thisNode.dataIndex, null);
    if (!thisLayout || !thisLayout.isInView) return;
    var thisWidth = thisLayout.width;
    var thisHeight = thisLayout.height;
    var borderWidth = thisLayout.borderWidth;
    var thisInvisible = thisLayout.invisible;
    var thisRawIndex = thisNode.getRawIndex();
    var oldRawIndex = oldNode && oldNode.getRawIndex();
    var thisViewChildren = thisNode.viewChildren;
    var upperHeight = thisLayout.upperHeight;
    var isParent = thisViewChildren && thisViewChildren.length;
    var itemStyleNormalModel = nodeModel.getModel("itemStyle");
    var itemStyleEmphasisModel = nodeModel.getModel([
        "emphasis",
        "itemStyle"
    ]);
    var itemStyleBlurModel = nodeModel.getModel([
        "blur",
        "itemStyle"
    ]);
    var itemStyleSelectModel = nodeModel.getModel([
        "select",
        "itemStyle"
    ]);
    var borderRadius = itemStyleNormalModel.get("borderRadius") || 0;
    // End of closure ariables available in "Procedures in renderNode".
    // -----------------------------------------------------------------
    // Node group
    var group = giveGraphic("nodeGroup", $ca67abe413e4c090$var$Group);
    if (!group) return;
    parentGroup.add(group);
    // x,y are not set when el is above view root.
    group.x = thisLayout.x || 0;
    group.y = thisLayout.y || 0;
    group.markRedraw();
    $ca67abe413e4c090$var$inner(group).nodeWidth = thisWidth;
    $ca67abe413e4c090$var$inner(group).nodeHeight = thisHeight;
    if (thisLayout.isAboveViewRoot) return group;
    // Background
    var bg = giveGraphic("background", $ca67abe413e4c090$var$Rect, depth, $ca67abe413e4c090$var$Z2_BG);
    bg && renderBackground(group, bg, isParent && thisLayout.upperLabelHeight);
    var emphasisModel = nodeModel.getModel("emphasis");
    var focus = emphasisModel.get("focus");
    var blurScope = emphasisModel.get("blurScope");
    var isDisabled = emphasisModel.get("disabled");
    var focusOrIndices = focus === "ancestor" ? thisNode.getAncestorsIndices() : focus === "descendant" ? thisNode.getDescendantIndices() : focus;
    // No children, render content.
    if (isParent) {
        // Because of the implementation about "traverse" in graphic hover style, we
        // can not set hover listener on the "group" of non-leaf node. Otherwise the
        // hover event from the descendents will be listenered.
        if ((0, $2bf82c0980125b62$export$77d1445f699c58b5)(group)) (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(group, false);
        if (bg) {
            (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(bg, !isDisabled);
            // Only for enabling highlight/downplay.
            data.setItemGraphicEl(thisNode.dataIndex, bg);
            (0, $2bf82c0980125b62$export$24972466b2b62ac2)(bg, focusOrIndices, blurScope);
        }
    } else {
        var content = giveGraphic("content", $ca67abe413e4c090$var$Rect, depth, $ca67abe413e4c090$var$Z2_CONTENT);
        content && renderContent(group, content);
        bg.disableMorphing = true;
        if (bg && (0, $2bf82c0980125b62$export$77d1445f699c58b5)(bg)) (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(bg, false);
        (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(group, !isDisabled);
        // Only for enabling highlight/downplay.
        data.setItemGraphicEl(thisNode.dataIndex, group);
        (0, $2bf82c0980125b62$export$24972466b2b62ac2)(group, focusOrIndices, blurScope);
    }
    return group;
    // ----------------------------
    // | Procedures in renderNode |
    // ----------------------------
    function renderBackground(group, bg, useUpperLabel) {
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(bg);
        // For tooltip.
        ecData.dataIndex = thisNode.dataIndex;
        ecData.seriesIndex = seriesModel.seriesIndex;
        bg.setShape({
            x: 0,
            y: 0,
            width: thisWidth,
            height: thisHeight,
            r: borderRadius
        });
        if (thisInvisible) // If invisible, do not set visual, otherwise the element will
        // change immediately before animation. We think it is OK to
        // remain its origin color when moving out of the view window.
        processInvisible(bg);
        else {
            bg.invisible = false;
            var style = thisNode.getVisual("style");
            var visualBorderColor = style.stroke;
            var normalStyle = $ca67abe413e4c090$var$getItemStyleNormal(itemStyleNormalModel);
            normalStyle.fill = visualBorderColor;
            var emphasisStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleEmphasisModel);
            emphasisStyle.fill = itemStyleEmphasisModel.get("borderColor");
            var blurStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleBlurModel);
            blurStyle.fill = itemStyleBlurModel.get("borderColor");
            var selectStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleSelectModel);
            selectStyle.fill = itemStyleSelectModel.get("borderColor");
            if (useUpperLabel) {
                var upperLabelWidth = thisWidth - 2 * borderWidth;
                prepareText(// PENDING: convert ZRColor to ColorString for text.
                bg, visualBorderColor, style.opacity, {
                    x: borderWidth,
                    y: 0,
                    width: upperLabelWidth,
                    height: upperHeight
                });
            } else bg.removeTextContent();
            bg.setStyle(normalStyle);
            bg.ensureState("emphasis").style = emphasisStyle;
            bg.ensureState("blur").style = blurStyle;
            bg.ensureState("select").style = selectStyle;
            (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(bg);
        }
        group.add(bg);
    }
    function renderContent(group, content) {
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(content);
        // For tooltip.
        ecData.dataIndex = thisNode.dataIndex;
        ecData.seriesIndex = seriesModel.seriesIndex;
        var contentWidth = Math.max(thisWidth - 2 * borderWidth, 0);
        var contentHeight = Math.max(thisHeight - 2 * borderWidth, 0);
        content.culling = true;
        content.setShape({
            x: borderWidth,
            y: borderWidth,
            width: contentWidth,
            height: contentHeight,
            r: borderRadius
        });
        if (thisInvisible) // If invisible, do not set visual, otherwise the element will
        // change immediately before animation. We think it is OK to
        // remain its origin color when moving out of the view window.
        processInvisible(content);
        else {
            content.invisible = false;
            var nodeStyle = thisNode.getVisual("style");
            var visualColor = nodeStyle.fill;
            var normalStyle = $ca67abe413e4c090$var$getItemStyleNormal(itemStyleNormalModel);
            normalStyle.fill = visualColor;
            normalStyle.decal = nodeStyle.decal;
            var emphasisStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleEmphasisModel);
            var blurStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleBlurModel);
            var selectStyle = $ca67abe413e4c090$var$getStateItemStyle(itemStyleSelectModel);
            // PENDING: convert ZRColor to ColorString for text.
            prepareText(content, visualColor, nodeStyle.opacity, null);
            content.setStyle(normalStyle);
            content.ensureState("emphasis").style = emphasisStyle;
            content.ensureState("blur").style = blurStyle;
            content.ensureState("select").style = selectStyle;
            (0, $2bf82c0980125b62$export$20f39bbe322fb9ab)(content);
        }
        group.add(content);
    }
    function processInvisible(element) {
        // Delay invisible setting utill animation finished,
        // avoid element vanish suddenly before animation.
        !element.invisible && willInvisibleEls.push(element);
    }
    function prepareText(rectEl, visualColor, visualOpacity, // Can be null/undefined
    upperLabelRect) {
        var normalLabelModel = nodeModel.getModel(upperLabelRect ? $ca67abe413e4c090$var$PATH_UPPERLABEL_NORMAL : $ca67abe413e4c090$var$PATH_LABEL_NOAMAL);
        var defaultText = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)(nodeModel.get("name"), null);
        var isShow = normalLabelModel.getShallow("show");
        (0, $6800dfcb6e1e2a44$export$9a13992917966657)(rectEl, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(nodeModel, upperLabelRect ? $ca67abe413e4c090$var$PATH_UPPERLABEL_NORMAL : $ca67abe413e4c090$var$PATH_LABEL_NOAMAL), {
            defaultText: isShow ? defaultText : null,
            inheritColor: visualColor,
            defaultOpacity: visualOpacity,
            labelFetcher: seriesModel,
            labelDataIndex: thisNode.dataIndex
        });
        var textEl = rectEl.getTextContent();
        if (!textEl) return;
        var textStyle = textEl.style;
        var textPadding = (0, $7a1bd9c2710fea0d$export$f3a38102c49f4268)(textStyle.padding || 0);
        if (upperLabelRect) {
            rectEl.setTextConfig({
                layoutRect: upperLabelRect
            });
            textEl.disableLabelLayout = true;
        }
        textEl.beforeUpdate = function() {
            var width = Math.max((upperLabelRect ? upperLabelRect.width : rectEl.shape.width) - textPadding[1] - textPadding[3], 0);
            var height = Math.max((upperLabelRect ? upperLabelRect.height : rectEl.shape.height) - textPadding[0] - textPadding[2], 0);
            if (textStyle.width !== width || textStyle.height !== height) textEl.setStyle({
                width: width,
                height: height
            });
        };
        textStyle.truncateMinChar = 2;
        textStyle.lineOverflow = "truncate";
        addDrillDownIcon(textStyle, upperLabelRect, thisLayout);
        var textEmphasisState = textEl.getState("emphasis");
        addDrillDownIcon(textEmphasisState ? textEmphasisState.style : null, upperLabelRect, thisLayout);
    }
    function addDrillDownIcon(style, upperLabelRect, thisLayout) {
        var text = style ? style.text : null;
        if (!upperLabelRect && thisLayout.isLeafRoot && text != null) {
            var iconChar = seriesModel.get("drillDownIcon", true);
            style.text = iconChar ? iconChar + " " + text : text;
        }
    }
    function giveGraphic(storageName, Ctor, depth, z) {
        var element = oldRawIndex != null && oldStorage[storageName][oldRawIndex];
        var lasts = lastsForAnimation[storageName];
        if (element) {
            // Remove from oldStorage
            oldStorage[storageName][oldRawIndex] = null;
            prepareAnimationWhenHasOld(lasts, element);
        } else if (!thisInvisible) {
            element = new Ctor();
            if (element instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) element.z2 = $ca67abe413e4c090$var$calculateZ2(depth, z);
            prepareAnimationWhenNoOld(lasts, element);
        }
        // Set to thisStorage
        return thisStorage[storageName][thisRawIndex] = element;
    }
    function prepareAnimationWhenHasOld(lasts, element) {
        var lastCfg = lasts[thisRawIndex] = {};
        if (element instanceof $ca67abe413e4c090$var$Group) {
            lastCfg.oldX = element.x;
            lastCfg.oldY = element.y;
        } else lastCfg.oldShape = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, element.shape);
    }
    // If a element is new, we need to find the animation start point carefully,
    // otherwise it will looks strange when 'zoomToNode'.
    function prepareAnimationWhenNoOld(lasts, element) {
        var lastCfg = lasts[thisRawIndex] = {};
        var parentNode = thisNode.parentNode;
        var isGroup = element instanceof $7ef7583d8302ffce$export$2e2bcd8739ae039;
        if (parentNode && (!reRoot || reRoot.direction === "drillDown")) {
            var parentOldX = 0;
            var parentOldY = 0;
            // New nodes appear from right-bottom corner in 'zoomToNode' animation.
            // For convenience, get old bounding rect from background.
            var parentOldBg = lastsForAnimation.background[parentNode.getRawIndex()];
            if (!reRoot && parentOldBg && parentOldBg.oldShape) {
                parentOldX = parentOldBg.oldShape.width;
                parentOldY = parentOldBg.oldShape.height;
            }
            // When no parent old shape found, its parent is new too,
            // so we can just use {x:0, y:0}.
            if (isGroup) {
                lastCfg.oldX = 0;
                lastCfg.oldY = parentOldY;
            } else lastCfg.oldShape = {
                x: parentOldX,
                y: parentOldY,
                width: 0,
                height: 0
            };
        }
        // Fade in, user can be aware that these nodes are new.
        lastCfg.fadein = !isGroup;
    }
}
// We cannot set all background with the same z, because the behaviour of
// drill down and roll up differ background creation sequence from tree
// hierarchy sequence, which cause lower background elements to overlap
// upper ones. So we calculate z based on depth.
// Moreover, we try to shrink down z interval to [0, 1] to avoid that
// treemap with large z overlaps other components.
function $ca67abe413e4c090$var$calculateZ2(depth, z2InLevel) {
    return depth * $ca67abe413e4c090$var$Z2_BASE + z2InLevel;
}
var $ca67abe413e4c090$export$2e2bcd8739ae039 = $ca67abe413e4c090$var$TreemapView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $e6cba72659c474bb$var$ITEM_STYLE_NORMAL = "itemStyle";
var $e6cba72659c474bb$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $e6cba72659c474bb$export$2e2bcd8739ae039 = {
    seriesType: "treemap",
    reset: function(seriesModel) {
        var tree = seriesModel.getData().tree;
        var root = tree.root;
        if (root.isRemoved()) return;
        $e6cba72659c474bb$var$travelTree(root, // Visual should calculate from tree root but not view root.
        {}, seriesModel.getViewRoot().getAncestors(), seriesModel);
    }
};
function $e6cba72659c474bb$var$travelTree(node, designatedVisual, viewRootAncestors, seriesModel) {
    var nodeModel = node.getModel();
    var nodeLayout = node.getLayout();
    var data = node.hostTree.data;
    // Optimize
    if (!nodeLayout || nodeLayout.invisible || !nodeLayout.isInView) return;
    var nodeItemStyleModel = nodeModel.getModel($e6cba72659c474bb$var$ITEM_STYLE_NORMAL);
    var visuals = $e6cba72659c474bb$var$buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel);
    var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, "style");
    // calculate border color
    var borderColor = nodeItemStyleModel.get("borderColor");
    var borderColorSaturation = nodeItemStyleModel.get("borderColorSaturation");
    var thisNodeColor;
    if (borderColorSaturation != null) {
        // For performance, do not always execute 'calculateColor'.
        thisNodeColor = $e6cba72659c474bb$var$calculateColor(visuals);
        borderColor = $e6cba72659c474bb$var$calculateBorderColor(borderColorSaturation, thisNodeColor);
    }
    existsStyle.stroke = borderColor;
    var viewChildren = node.viewChildren;
    if (!viewChildren || !viewChildren.length) {
        thisNodeColor = $e6cba72659c474bb$var$calculateColor(visuals);
        // Apply visual to this node.
        existsStyle.fill = thisNodeColor;
    } else {
        var mapping_1 = $e6cba72659c474bb$var$buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren);
        // Designate visual to children.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(viewChildren, function(child, index) {
            // If higher than viewRoot, only ancestors of viewRoot is needed to visit.
            if (child.depth >= viewRootAncestors.length || child === viewRootAncestors[child.depth]) {
                var childVisual = $e6cba72659c474bb$var$mapVisual(nodeModel, visuals, child, index, mapping_1, seriesModel);
                $e6cba72659c474bb$var$travelTree(child, childVisual, viewRootAncestors, seriesModel);
            }
        });
    }
}
function $e6cba72659c474bb$var$buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel) {
    var visuals = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, designatedVisual);
    var designatedVisualItemStyle = seriesModel.designatedVisualItemStyle;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "color",
        "colorAlpha",
        "colorSaturation"
    ], function(visualName) {
        // Priority: thisNode > thisLevel > parentNodeDesignated > seriesModel
        designatedVisualItemStyle[visualName] = designatedVisual[visualName];
        var val = nodeItemStyleModel.get(visualName);
        designatedVisualItemStyle[visualName] = null;
        val != null && (visuals[visualName] = val);
    });
    return visuals;
}
function $e6cba72659c474bb$var$calculateColor(visuals) {
    var color = $e6cba72659c474bb$var$getValueVisualDefine(visuals, "color");
    if (color) {
        var colorAlpha = $e6cba72659c474bb$var$getValueVisualDefine(visuals, "colorAlpha");
        var colorSaturation = $e6cba72659c474bb$var$getValueVisualDefine(visuals, "colorSaturation");
        if (colorSaturation) color = (0, $2c037f5bda6341ca$export$d898ae866e27bf18)(color, null, null, colorSaturation);
        if (colorAlpha) color = (0, $2c037f5bda6341ca$export$ab4754bf42583a26)(color, colorAlpha);
        return color;
    }
}
function $e6cba72659c474bb$var$calculateBorderColor(borderColorSaturation, thisNodeColor) {
    return thisNodeColor != null ? (0, $2c037f5bda6341ca$export$d898ae866e27bf18)(thisNodeColor, null, null, borderColorSaturation) : null;
}
function $e6cba72659c474bb$var$getValueVisualDefine(visuals, name) {
    var value = visuals[name];
    if (value != null && value !== "none") return value;
}
function $e6cba72659c474bb$var$buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren) {
    if (!viewChildren || !viewChildren.length) return;
    var rangeVisual = $e6cba72659c474bb$var$getRangeVisual(nodeModel, "color") || visuals.color != null && visuals.color !== "none" && ($e6cba72659c474bb$var$getRangeVisual(nodeModel, "colorAlpha") || $e6cba72659c474bb$var$getRangeVisual(nodeModel, "colorSaturation"));
    if (!rangeVisual) return;
    var visualMin = nodeModel.get("visualMin");
    var visualMax = nodeModel.get("visualMax");
    var dataExtent = nodeLayout.dataExtent.slice();
    visualMin != null && visualMin < dataExtent[0] && (dataExtent[0] = visualMin);
    visualMax != null && visualMax > dataExtent[1] && (dataExtent[1] = visualMax);
    var colorMappingBy = nodeModel.get("colorMappingBy");
    var opt = {
        type: rangeVisual.name,
        dataExtent: dataExtent,
        visual: rangeVisual.range
    };
    if (opt.type === "color" && (colorMappingBy === "index" || colorMappingBy === "id")) {
        opt.mappingMethod = "category";
        opt.loop = true;
    // categories is ordinal, so do not set opt.categories.
    } else opt.mappingMethod = "linear";
    var mapping = new (0, $7b50f502cfd189d5$export$2e2bcd8739ae039)(opt);
    $e6cba72659c474bb$var$inner(mapping).drColorMappingBy = colorMappingBy;
    return mapping;
}
// Notice: If we don't have the attribute 'colorRange', but only use
// attribute 'color' to represent both concepts of 'colorRange' and 'color',
// (It means 'colorRange' when 'color' is Array, means 'color' when not array),
// this problem will be encountered:
// If a level-1 node doesn't have children, and its siblings have children,
// and colorRange is set on level-1, then the node cannot be colored.
// So we separate 'colorRange' and 'color' to different attributes.
function $e6cba72659c474bb$var$getRangeVisual(nodeModel, name) {
    // 'colorRange', 'colorARange', 'colorSRange'.
    // If not exists on this node, fetch from levels and series.
    var range = nodeModel.get(name);
    return (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(range) && range.length ? {
        name: name,
        range: range
    } : null;
}
function $e6cba72659c474bb$var$mapVisual(nodeModel, visuals, child, index, mapping, seriesModel) {
    var childVisuals = (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, visuals);
    if (mapping) {
        // Only support color, colorAlpha, colorSaturation.
        var mappingType = mapping.type;
        var colorMappingBy = mappingType === "color" && $e6cba72659c474bb$var$inner(mapping).drColorMappingBy;
        var value = colorMappingBy === "index" ? index : colorMappingBy === "id" ? seriesModel.mapIdToIndex(child.getId()) : child.getValue(nodeModel.get("visualDimension"));
        childVisuals[mappingType] = mapping.mapValueToVisual(value);
    }
    return childVisuals;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The treemap layout implementation was originally copied from
* "d3.js" with some modifications made for this project.
* (See more details in the comment of the method "squarify" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 




var $2f13a432668907b0$var$mathMax = Math.max;
var $2f13a432668907b0$var$mathMin = Math.min;
var $2f13a432668907b0$var$retrieveValue = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66;
var $2f13a432668907b0$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $2f13a432668907b0$var$PATH_BORDER_WIDTH = [
    "itemStyle",
    "borderWidth"
];
var $2f13a432668907b0$var$PATH_GAP_WIDTH = [
    "itemStyle",
    "gapWidth"
];
var $2f13a432668907b0$var$PATH_UPPER_LABEL_SHOW = [
    "upperLabel",
    "show"
];
var $2f13a432668907b0$var$PATH_UPPER_LABEL_HEIGHT = [
    "upperLabel",
    "height"
];
var /**
 * @public
 */ $2f13a432668907b0$export$2e2bcd8739ae039 = {
    seriesType: "treemap",
    reset: function(seriesModel, ecModel, api, payload) {
        // Layout result in each node:
        // {x, y, width, height, area, borderWidth}
        var ecWidth = api.getWidth();
        var ecHeight = api.getHeight();
        var seriesOption = seriesModel.option;
        var layoutInfo = $93b9bc7f22ac7369$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
            width: api.getWidth(),
            height: api.getHeight()
        });
        var size = seriesOption.size || []; // Compatible with ec2.
        var containerWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)($2f13a432668907b0$var$retrieveValue(layoutInfo.width, size[0]), ecWidth);
        var containerHeight = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)($2f13a432668907b0$var$retrieveValue(layoutInfo.height, size[1]), ecHeight);
        // Fetch payload info.
        var payloadType = payload && payload.type;
        var types = [
            "treemapZoomToNode",
            "treemapRootToNode"
        ];
        var targetInfo = $6341f66602946a06$export$c5445fa59c15dec4(payload, types, seriesModel);
        var rootRect = payloadType === "treemapRender" || payloadType === "treemapMove" ? payload.rootRect : null;
        var viewRoot = seriesModel.getViewRoot();
        var viewAbovePath = $6341f66602946a06$export$6be31fe4499506f9(viewRoot);
        if (payloadType !== "treemapMove") {
            var rootSize = payloadType === "treemapZoomToNode" ? $2f13a432668907b0$var$estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) : rootRect ? [
                rootRect.width,
                rootRect.height
            ] : [
                containerWidth,
                containerHeight
            ];
            var sort_1 = seriesOption.sort;
            if (sort_1 && sort_1 !== "asc" && sort_1 !== "desc") // Default to be desc order.
            sort_1 = "desc";
            var options = {
                squareRatio: seriesOption.squareRatio,
                sort: sort_1,
                leafDepth: seriesOption.leafDepth
            };
            // layout should be cleared because using updateView but not update.
            viewRoot.hostTree.clearLayouts();
            // TODO
            // optimize: if out of view clip, do not layout.
            // But take care that if do not render node out of view clip,
            // how to calculate start po
            var viewRootLayout_1 = {
                x: 0,
                y: 0,
                width: rootSize[0],
                height: rootSize[1],
                area: rootSize[0] * rootSize[1]
            };
            viewRoot.setLayout(viewRootLayout_1);
            $2f13a432668907b0$var$squarify(viewRoot, options, false, 0);
            // Supplement layout.
            viewRootLayout_1 = viewRoot.getLayout();
            $2f13a432668907b0$var$each(viewAbovePath, function(node, index) {
                var childValue = (viewAbovePath[index + 1] || viewRoot).getValue();
                node.setLayout($7a1bd9c2710fea0d$export$8b58be045bf06082({
                    dataExtent: [
                        childValue,
                        childValue
                    ],
                    borderWidth: 0,
                    upperHeight: 0
                }, viewRootLayout_1));
            });
        }
        var treeRoot = seriesModel.getData().tree.root;
        treeRoot.setLayout($2f13a432668907b0$var$calculateRootPosition(layoutInfo, rootRect, targetInfo), true);
        seriesModel.setLayoutInfo(layoutInfo);
        // FIXME
        // 现在没有clip功能，暂时取ec高宽。
        $2f13a432668907b0$var$prunning(treeRoot, // Transform to base element coordinate system.
        new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(-layoutInfo.x, -layoutInfo.y, ecWidth, ecHeight), viewAbovePath, viewRoot, 0);
    }
};
/**
 * Layout treemap with squarify algorithm.
 * The original presentation of this algorithm
 * was made by Mark Bruls, Kees Huizing, and Jarke J. van Wijk
 * <https://graphics.ethz.ch/teaching/scivis_common/Literature/squarifiedTreeMaps.pdf>.
 * The implementation of this algorithm was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/layout/treemap.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * @protected
 * @param {module:echarts/data/Tree~TreeNode} node
 * @param {Object} options
 * @param {string} options.sort 'asc' or 'desc'
 * @param {number} options.squareRatio
 * @param {boolean} hideChildren
 * @param {number} depth
 */ function $2f13a432668907b0$var$squarify(node, options, hideChildren, depth) {
    var width;
    var height;
    if (node.isRemoved()) return;
    var thisLayout = node.getLayout();
    width = thisLayout.width;
    height = thisLayout.height;
    // Considering border and gap
    var nodeModel = node.getModel();
    var borderWidth = nodeModel.get($2f13a432668907b0$var$PATH_BORDER_WIDTH);
    var halfGapWidth = nodeModel.get($2f13a432668907b0$var$PATH_GAP_WIDTH) / 2;
    var upperLabelHeight = $2f13a432668907b0$var$getUpperLabelHeight(nodeModel);
    var upperHeight = Math.max(borderWidth, upperLabelHeight);
    var layoutOffset = borderWidth - halfGapWidth;
    var layoutOffsetUpper = upperHeight - halfGapWidth;
    node.setLayout({
        borderWidth: borderWidth,
        upperHeight: upperHeight,
        upperLabelHeight: upperLabelHeight
    }, true);
    width = $2f13a432668907b0$var$mathMax(width - 2 * layoutOffset, 0);
    height = $2f13a432668907b0$var$mathMax(height - layoutOffset - layoutOffsetUpper, 0);
    var totalArea = width * height;
    var viewChildren = $2f13a432668907b0$var$initChildren(node, nodeModel, totalArea, options, hideChildren, depth);
    if (!viewChildren.length) return;
    var rect = {
        x: layoutOffset,
        y: layoutOffsetUpper,
        width: width,
        height: height
    };
    var rowFixedLength = $2f13a432668907b0$var$mathMin(width, height);
    var best = Infinity; // the best row score so far
    var row = [];
    row.area = 0;
    for(var i = 0, len = viewChildren.length; i < len;){
        var child = viewChildren[i];
        row.push(child);
        row.area += child.getLayout().area;
        var score = $2f13a432668907b0$var$worst(row, rowFixedLength, options.squareRatio);
        // continue with this orientation
        if (score <= best) {
            i++;
            best = score;
        } else {
            row.area -= row.pop().getLayout().area;
            $2f13a432668907b0$var$position(row, rowFixedLength, rect, halfGapWidth, false);
            rowFixedLength = $2f13a432668907b0$var$mathMin(rect.width, rect.height);
            row.length = row.area = 0;
            best = Infinity;
        }
    }
    if (row.length) $2f13a432668907b0$var$position(row, rowFixedLength, rect, halfGapWidth, true);
    if (!hideChildren) {
        var childrenVisibleMin = nodeModel.get("childrenVisibleMin");
        if (childrenVisibleMin != null && totalArea < childrenVisibleMin) hideChildren = true;
    }
    for(var i = 0, len = viewChildren.length; i < len; i++)$2f13a432668907b0$var$squarify(viewChildren[i], options, hideChildren, depth + 1);
}
/**
 * Set area to each child, and calculate data extent for visual coding.
 */ function $2f13a432668907b0$var$initChildren(node, nodeModel, totalArea, options, hideChildren, depth) {
    var viewChildren = node.children || [];
    var orderBy = options.sort;
    orderBy !== "asc" && orderBy !== "desc" && (orderBy = null);
    var overLeafDepth = options.leafDepth != null && options.leafDepth <= depth;
    // leafDepth has higher priority.
    if (hideChildren && !overLeafDepth) return node.viewChildren = [];
    // Sort children, order by desc.
    viewChildren = $7a1bd9c2710fea0d$export$3dea766d36a8935f(viewChildren, function(child) {
        return !child.isRemoved();
    });
    $2f13a432668907b0$var$sort(viewChildren, orderBy);
    var info = $2f13a432668907b0$var$statistic(nodeModel, viewChildren, orderBy);
    if (info.sum === 0) return node.viewChildren = [];
    info.sum = $2f13a432668907b0$var$filterByThreshold(nodeModel, totalArea, info.sum, orderBy, viewChildren);
    if (info.sum === 0) return node.viewChildren = [];
    // Set area to each child.
    for(var i = 0, len = viewChildren.length; i < len; i++){
        var area = viewChildren[i].getValue() / info.sum * totalArea;
        // Do not use setLayout({...}, true), because it is needed to clear last layout.
        viewChildren[i].setLayout({
            area: area
        });
    }
    if (overLeafDepth) {
        viewChildren.length && node.setLayout({
            isLeafRoot: true
        }, true);
        viewChildren.length = 0;
    }
    node.viewChildren = viewChildren;
    node.setLayout({
        dataExtent: info.dataExtent
    }, true);
    return viewChildren;
}
/**
 * Consider 'visibleMin'. Modify viewChildren and get new sum.
 */ function $2f13a432668907b0$var$filterByThreshold(nodeModel, totalArea, sum, orderBy, orderedChildren) {
    // visibleMin is not supported yet when no option.sort.
    if (!orderBy) return sum;
    var visibleMin = nodeModel.get("visibleMin");
    var len = orderedChildren.length;
    var deletePoint = len;
    // Always travel from little value to big value.
    for(var i = len - 1; i >= 0; i--){
        var value = orderedChildren[orderBy === "asc" ? len - i - 1 : i].getValue();
        if (value / sum * totalArea < visibleMin) {
            deletePoint = i;
            sum -= value;
        }
    }
    orderBy === "asc" ? orderedChildren.splice(0, len - deletePoint) : orderedChildren.splice(deletePoint, len - deletePoint);
    return sum;
}
/**
 * Sort
 */ function $2f13a432668907b0$var$sort(viewChildren, orderBy) {
    if (orderBy) viewChildren.sort(function(a, b) {
        var diff = orderBy === "asc" ? a.getValue() - b.getValue() : b.getValue() - a.getValue();
        return diff === 0 ? orderBy === "asc" ? a.dataIndex - b.dataIndex : b.dataIndex - a.dataIndex : diff;
    });
    return viewChildren;
}
/**
 * Statistic
 */ function $2f13a432668907b0$var$statistic(nodeModel, children, orderBy) {
    // Calculate sum.
    var sum = 0;
    for(var i = 0, len = children.length; i < len; i++)sum += children[i].getValue();
    // Statistic data extent for latter visual coding.
    // Notice: data extent should be calculate based on raw children
    // but not filtered view children, otherwise visual mapping will not
    // be stable when zoom (where children is filtered by visibleMin).
    var dimension = nodeModel.get("visualDimension");
    var dataExtent;
    // The same as area dimension.
    if (!children || !children.length) dataExtent = [
        NaN,
        NaN
    ];
    else if (dimension === "value" && orderBy) {
        dataExtent = [
            children[children.length - 1].getValue(),
            children[0].getValue()
        ];
        orderBy === "asc" && dataExtent.reverse();
    } else {
        dataExtent = [
            Infinity,
            -Infinity
        ];
        $2f13a432668907b0$var$each(children, function(child) {
            var value = child.getValue(dimension);
            value < dataExtent[0] && (dataExtent[0] = value);
            value > dataExtent[1] && (dataExtent[1] = value);
        });
    }
    return {
        sum: sum,
        dataExtent: dataExtent
    };
}
/**
 * Computes the score for the specified row,
 * as the worst aspect ratio.
 */ function $2f13a432668907b0$var$worst(row, rowFixedLength, ratio) {
    var areaMax = 0;
    var areaMin = Infinity;
    for(var i = 0, area = void 0, len = row.length; i < len; i++){
        area = row[i].getLayout().area;
        if (area) {
            area < areaMin && (areaMin = area);
            area > areaMax && (areaMax = area);
        }
    }
    var squareArea = row.area * row.area;
    var f = rowFixedLength * rowFixedLength * ratio;
    return squareArea ? $2f13a432668907b0$var$mathMax(f * areaMax / squareArea, squareArea / (f * areaMin)) : Infinity;
}
/**
 * Positions the specified row of nodes. Modifies `rect`.
 */ function $2f13a432668907b0$var$position(row, rowFixedLength, rect, halfGapWidth, flush) {
    // When rowFixedLength === rect.width,
    // it is horizontal subdivision,
    // rowFixedLength is the width of the subdivision,
    // rowOtherLength is the height of the subdivision,
    // and nodes will be positioned from left to right.
    // wh[idx0WhenH] means: when horizontal,
    //      wh[idx0WhenH] => wh[0] => 'width'.
    //      xy[idx1WhenH] => xy[1] => 'y'.
    var idx0WhenH = rowFixedLength === rect.width ? 0 : 1;
    var idx1WhenH = 1 - idx0WhenH;
    var xy = [
        "x",
        "y"
    ];
    var wh = [
        "width",
        "height"
    ];
    var last = rect[xy[idx0WhenH]];
    var rowOtherLength = rowFixedLength ? row.area / rowFixedLength : 0;
    if (flush || rowOtherLength > rect[wh[idx1WhenH]]) rowOtherLength = rect[wh[idx1WhenH]]; // over+underflow
    for(var i = 0, rowLen = row.length; i < rowLen; i++){
        var node = row[i];
        var nodeLayout = {};
        var step = rowOtherLength ? node.getLayout().area / rowOtherLength : 0;
        var wh1 = nodeLayout[wh[idx1WhenH]] = $2f13a432668907b0$var$mathMax(rowOtherLength - 2 * halfGapWidth, 0);
        // We use Math.max/min to avoid negative width/height when considering gap width.
        var remain = rect[xy[idx0WhenH]] + rect[wh[idx0WhenH]] - last;
        var modWH = i === rowLen - 1 || remain < step ? remain : step;
        var wh0 = nodeLayout[wh[idx0WhenH]] = $2f13a432668907b0$var$mathMax(modWH - 2 * halfGapWidth, 0);
        nodeLayout[xy[idx1WhenH]] = rect[xy[idx1WhenH]] + $2f13a432668907b0$var$mathMin(halfGapWidth, wh1 / 2);
        nodeLayout[xy[idx0WhenH]] = last + $2f13a432668907b0$var$mathMin(halfGapWidth, wh0 / 2);
        last += modWH;
        node.setLayout(nodeLayout, true);
    }
    rect[xy[idx1WhenH]] += rowOtherLength;
    rect[wh[idx1WhenH]] -= rowOtherLength;
}
// Return [containerWidth, containerHeight] as default.
function $2f13a432668907b0$var$estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) {
    // If targetInfo.node exists, we zoom to the node,
    // so estimate whole width and height by target node.
    var currNode = (targetInfo || {}).node;
    var defaultSize = [
        containerWidth,
        containerHeight
    ];
    if (!currNode || currNode === viewRoot) return defaultSize;
    var parent;
    var viewArea = containerWidth * containerHeight;
    var area = viewArea * seriesModel.option.zoomToNodeRatio;
    while(parent = currNode.parentNode){
        // jshint ignore:line
        var sum = 0;
        var siblings = parent.children;
        for(var i = 0, len = siblings.length; i < len; i++)sum += siblings[i].getValue();
        var currNodeValue = currNode.getValue();
        if (currNodeValue === 0) return defaultSize;
        area *= sum / currNodeValue;
        // Considering border, suppose aspect ratio is 1.
        var parentModel = parent.getModel();
        var borderWidth = parentModel.get($2f13a432668907b0$var$PATH_BORDER_WIDTH);
        var upperHeight = Math.max(borderWidth, $2f13a432668907b0$var$getUpperLabelHeight(parentModel));
        area += 4 * borderWidth * borderWidth + (3 * borderWidth + upperHeight) * Math.pow(area, 0.5);
        area > (0, $cfc1f3b422a3185f$export$18510406f204a1b9) && (area = (0, $cfc1f3b422a3185f$export$18510406f204a1b9));
        currNode = parent;
    }
    area < viewArea && (area = viewArea);
    var scale = Math.pow(area / viewArea, 0.5);
    return [
        containerWidth * scale,
        containerHeight * scale
    ];
}
// Root position based on coord of containerGroup
function $2f13a432668907b0$var$calculateRootPosition(layoutInfo, rootRect, targetInfo) {
    if (rootRect) return {
        x: rootRect.x,
        y: rootRect.y
    };
    var defaultPosition = {
        x: 0,
        y: 0
    };
    if (!targetInfo) return defaultPosition;
    // If targetInfo is fetched by 'retrieveTargetInfo',
    // old tree and new tree are the same tree,
    // so the node still exists and we can visit it.
    var targetNode = targetInfo.node;
    var layout = targetNode.getLayout();
    if (!layout) return defaultPosition;
    // Transform coord from local to container.
    var targetCenter = [
        layout.width / 2,
        layout.height / 2
    ];
    var node = targetNode;
    while(node){
        var nodeLayout = node.getLayout();
        targetCenter[0] += nodeLayout.x;
        targetCenter[1] += nodeLayout.y;
        node = node.parentNode;
    }
    return {
        x: layoutInfo.width / 2 - targetCenter[0],
        y: layoutInfo.height / 2 - targetCenter[1]
    };
}
// Mark nodes visible for prunning when visual coding and rendering.
// Prunning depends on layout and root position, so we have to do it after layout.
function $2f13a432668907b0$var$prunning(node, clipRect, viewAbovePath, viewRoot, depth) {
    var nodeLayout = node.getLayout();
    var nodeInViewAbovePath = viewAbovePath[depth];
    var isAboveViewRoot = nodeInViewAbovePath && nodeInViewAbovePath === node;
    if (nodeInViewAbovePath && !isAboveViewRoot || depth === viewAbovePath.length && node !== viewRoot) return;
    node.setLayout({
        // isInView means: viewRoot sub tree + viewAbovePath
        isInView: true,
        // invisible only means: outside view clip so that the node can not
        // see but still layout for animation preparation but not render.
        invisible: !isAboveViewRoot && !clipRect.intersect(nodeLayout),
        isAboveViewRoot: isAboveViewRoot
    }, true);
    // Transform to child coordinate.
    var childClipRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(clipRect.x - nodeLayout.x, clipRect.y - nodeLayout.y, clipRect.width, clipRect.height);
    $2f13a432668907b0$var$each(node.viewChildren || [], function(child) {
        $2f13a432668907b0$var$prunning(child, childClipRect, viewAbovePath, viewRoot, depth + 1);
    });
}
function $2f13a432668907b0$var$getUpperLabelHeight(model) {
    return model.get($2f13a432668907b0$var$PATH_UPPER_LABEL_SHOW) ? model.get($2f13a432668907b0$var$PATH_UPPER_LABEL_HEIGHT) : 0;
}


function $330b7dc841112eff$export$4b3e715f166fdd78(registers) {
    registers.registerSeriesModel((0, $10d079b37d9731a3$export$2e2bcd8739ae039));
    registers.registerChartView((0, $ca67abe413e4c090$export$2e2bcd8739ae039));
    registers.registerVisual((0, $e6cba72659c474bb$export$2e2bcd8739ae039));
    registers.registerLayout((0, $2f13a432668907b0$export$2e2bcd8739ae039));
    (0, $26d493e9cdfadb01$export$1ad90fc3f3a8bbf9)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $98990baee36aa4ed$var$DEFAULT_OPTION = {
    label: {
        enabled: true
    },
    decal: {
        show: false
    }
};
var $98990baee36aa4ed$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $98990baee36aa4ed$var$decalPaletteScope = {};
function $98990baee36aa4ed$export$2e2bcd8739ae039(ecModel, api) {
    var ariaModel = ecModel.getModel("aria");
    // See "area enabled" detection code in `GlobalModel.ts`.
    if (!ariaModel.get("enabled")) return;
    var defaultOption = $7a1bd9c2710fea0d$export$9cd59f9826255e47($98990baee36aa4ed$var$DEFAULT_OPTION);
    $7a1bd9c2710fea0d$export$4950aa0f605343fb(defaultOption.label, ecModel.getLocaleModel().get("aria"), false);
    $7a1bd9c2710fea0d$export$4950aa0f605343fb(ariaModel.option, defaultOption, false);
    setDecal();
    setLabel();
    function setDecal() {
        var decalModel = ariaModel.getModel("decal");
        var useDecal = decalModel.get("show");
        if (useDecal) {
            // Each type of series use one scope.
            // Pie and funnel are using different scopes.
            var paletteScopeGroupByType_1 = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
            ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.isColorBySeries()) return;
                var decalScope = paletteScopeGroupByType_1.get(seriesModel.type);
                if (!decalScope) {
                    decalScope = {};
                    paletteScopeGroupByType_1.set(seriesModel.type, decalScope);
                }
                $98990baee36aa4ed$var$inner(seriesModel).scope = decalScope;
            });
            ecModel.eachRawSeries(function(seriesModel) {
                if (ecModel.isSeriesFiltered(seriesModel)) return;
                if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesModel.enableAriaDecal)) {
                    // Let series define how to use decal palette on data
                    seriesModel.enableAriaDecal();
                    return;
                }
                var data = seriesModel.getData();
                if (!seriesModel.isColorBySeries()) {
                    var dataAll_1 = seriesModel.getRawData();
                    var idxMap_1 = {};
                    var decalScope_1 = $98990baee36aa4ed$var$inner(seriesModel).scope;
                    data.each(function(idx) {
                        var rawIdx = data.getRawIndex(idx);
                        idxMap_1[rawIdx] = idx;
                    });
                    var dataCount_1 = dataAll_1.count();
                    dataAll_1.each(function(rawIdx) {
                        var idx = idxMap_1[rawIdx];
                        var name = dataAll_1.getName(rawIdx) || rawIdx + "";
                        var paletteDecal = (0, $e7fbd47751ca3c28$export$e4d892222945a227)(seriesModel.ecModel, name, decalScope_1, dataCount_1);
                        var specifiedDecal = data.getItemVisual(idx, "decal");
                        data.setItemVisual(idx, "decal", mergeDecal(specifiedDecal, paletteDecal));
                    });
                } else {
                    var paletteDecal = (0, $e7fbd47751ca3c28$export$e4d892222945a227)(seriesModel.ecModel, seriesModel.name, $98990baee36aa4ed$var$decalPaletteScope, ecModel.getSeriesCount());
                    var specifiedDecal = data.getVisual("decal");
                    data.setVisual("decal", mergeDecal(specifiedDecal, paletteDecal));
                }
                function mergeDecal(specifiedDecal, paletteDecal) {
                    // Merge decal from palette to decal from itemStyle.
                    // User do not need to specify all of the decal props.
                    var resultDecal = specifiedDecal ? $7a1bd9c2710fea0d$export$8b58be045bf06082($7a1bd9c2710fea0d$export$8b58be045bf06082({}, paletteDecal), specifiedDecal) : paletteDecal;
                    resultDecal.dirty = true;
                    return resultDecal;
                }
            });
        }
    }
    function setLabel() {
        var labelLocale = ecModel.getLocaleModel().get("aria");
        var labelModel = ariaModel.getModel("label");
        labelModel.option = $7a1bd9c2710fea0d$export$ebe90cb607ad99e(labelModel.option, labelLocale);
        if (!labelModel.get("enabled")) return;
        var dom = api.getZr().dom;
        if (labelModel.get("description")) {
            dom.setAttribute("aria-label", labelModel.get("description"));
            return;
        }
        var seriesCnt = ecModel.getSeriesCount();
        var maxDataCnt = labelModel.get([
            "data",
            "maxCount"
        ]) || 10;
        var maxSeriesCnt = labelModel.get([
            "series",
            "maxCount"
        ]) || 10;
        var displaySeriesCnt = Math.min(seriesCnt, maxSeriesCnt);
        var ariaLabel;
        if (seriesCnt < 1) // No series, no aria label
        return;
        else {
            var title = getTitle();
            if (title) {
                var withTitle = labelModel.get([
                    "general",
                    "withTitle"
                ]);
                ariaLabel = replace(withTitle, {
                    title: title
                });
            } else ariaLabel = labelModel.get([
                "general",
                "withoutTitle"
            ]);
            var seriesLabels_1 = [];
            var prefix = seriesCnt > 1 ? labelModel.get([
                "series",
                "multiple",
                "prefix"
            ]) : labelModel.get([
                "series",
                "single",
                "prefix"
            ]);
            ariaLabel += replace(prefix, {
                seriesCount: seriesCnt
            });
            ecModel.eachSeries(function(seriesModel, idx) {
                if (idx < displaySeriesCnt) {
                    var seriesLabel = void 0;
                    var seriesName = seriesModel.get("name");
                    var withName = seriesName ? "withName" : "withoutName";
                    seriesLabel = seriesCnt > 1 ? labelModel.get([
                        "series",
                        "multiple",
                        withName
                    ]) : labelModel.get([
                        "series",
                        "single",
                        withName
                    ]);
                    seriesLabel = replace(seriesLabel, {
                        seriesId: seriesModel.seriesIndex,
                        seriesName: seriesModel.get("name"),
                        seriesType: getSeriesTypeName(seriesModel.subType)
                    });
                    var data = seriesModel.getData();
                    if (data.count() > maxDataCnt) {
                        // Show part of data
                        var partialLabel = labelModel.get([
                            "data",
                            "partialData"
                        ]);
                        seriesLabel += replace(partialLabel, {
                            displayCnt: maxDataCnt
                        });
                    } else seriesLabel += labelModel.get([
                        "data",
                        "allData"
                    ]);
                    var middleSeparator_1 = labelModel.get([
                        "data",
                        "separator",
                        "middle"
                    ]);
                    var endSeparator_1 = labelModel.get([
                        "data",
                        "separator",
                        "end"
                    ]);
                    var dataLabels = [];
                    for(var i = 0; i < data.count(); i++)if (i < maxDataCnt) {
                        var name_1 = data.getName(i);
                        var value = data.getValues(i);
                        var dataLabel = labelModel.get([
                            "data",
                            name_1 ? "withName" : "withoutName"
                        ]);
                        dataLabels.push(replace(dataLabel, {
                            name: name_1,
                            value: value.join(middleSeparator_1)
                        }));
                    }
                    seriesLabel += dataLabels.join(middleSeparator_1) + endSeparator_1;
                    seriesLabels_1.push(seriesLabel);
                }
            });
            var separatorModel = labelModel.getModel([
                "series",
                "multiple",
                "separator"
            ]);
            var middleSeparator = separatorModel.get("middle");
            var endSeparator = separatorModel.get("end");
            ariaLabel += seriesLabels_1.join(middleSeparator) + endSeparator;
            dom.setAttribute("aria-label", ariaLabel);
        }
    }
    function replace(str, keyValues) {
        if (!$7a1bd9c2710fea0d$export$844ec244b1367d54(str)) return str;
        var result = str;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(keyValues, function(value, key) {
            result = result.replace(new RegExp("\\{\\s*" + key + "\\s*\\}", "g"), value);
        });
        return result;
    }
    function getTitle() {
        var title = ecModel.get("title");
        if (title && title.length) title = title[0];
        return title && title.text;
    }
    function getSeriesTypeName(type) {
        var typeNames = ecModel.getLocaleModel().get([
            "series",
            "typeNames"
        ]);
        return typeNames[type] || typeNames.chart;
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $6f6d6469de000c68$export$2e2bcd8739ae039(option) {
    if (!option || !option.aria) return;
    var aria = option.aria;
    // aria.show is deprecated and should use aria.enabled instead
    if (aria.show != null) aria.enabled = aria.show;
    aria.label = aria.label || {};
    // move description, general, series, data to be under aria.label
    $7a1bd9c2710fea0d$export$79b2f7037acddd43([
        "description",
        "general",
        "series",
        "data"
    ], function(name) {
        if (aria[name] != null) aria.label[name] = aria[name];
    });
}


function $772c09ed30d27c33$export$4b3e715f166fdd78(registers) {
    registers.registerPreprocessor((0, $6f6d6469de000c68$export$2e2bcd8739ae039));
    registers.registerVisual(registers.PRIORITY.VISUAL.ARIA, (0, $98990baee36aa4ed$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $a331d7a6c631e6d9$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $a331d7a6c631e6d9$var$clone = $7a1bd9c2710fea0d$export$9cd59f9826255e47;
var $a331d7a6c631e6d9$var$bind = $7a1bd9c2710fea0d$export$2385a24977818dd0;
/**
 * Base axis pointer class in 2D.
 */ var $a331d7a6c631e6d9$var$BaseAxisPointer = /** @class */ function() {
    function BaseAxisPointer() {
        this._dragging = false;
        /**
     * In px, arbitrary value. Do not set too small,
     * no animation is ok for most cases.
     */ this.animationThreshold = 15;
    }
    /**
   * @implement
   */ BaseAxisPointer.prototype.render = function(axisModel, axisPointerModel, api, forceRender) {
        var value = axisPointerModel.get("value");
        var status = axisPointerModel.get("status");
        // Bind them to `this`, not in closure, otherwise they will not
        // be replaced when user calling setOption in not merge mode.
        this._axisModel = axisModel;
        this._axisPointerModel = axisPointerModel;
        this._api = api;
        // Optimize: `render` will be called repeatedly during mouse move.
        // So it is power consuming if performing `render` each time,
        // especially on mobile device.
        if (!forceRender && this._lastValue === value && this._lastStatus === status) return;
        this._lastValue = value;
        this._lastStatus = status;
        var group = this._group;
        var handle = this._handle;
        if (!status || status === "hide") {
            // Do not clear here, for animation better.
            group && group.hide();
            handle && handle.hide();
            return;
        }
        group && group.show();
        handle && handle.show();
        // Otherwise status is 'show'
        var elOption = {};
        this.makeElOption(elOption, value, axisModel, axisPointerModel, api);
        // Enable change axis pointer type.
        var graphicKey = elOption.graphicKey;
        if (graphicKey !== this._lastGraphicKey) this.clear(api);
        this._lastGraphicKey = graphicKey;
        var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
        if (!group) {
            group = this._group = new $5b455ae6f843ac47$exports.Group();
            this.createPointerEl(group, elOption, axisModel, axisPointerModel);
            this.createLabelEl(group, elOption, axisModel, axisPointerModel);
            api.getZr().add(group);
        } else {
            var doUpdateProps = $7a1bd9c2710fea0d$export$c3095a23b368d1f2($a331d7a6c631e6d9$var$updateProps, axisPointerModel, moveAnimation);
            this.updatePointerEl(group, elOption, doUpdateProps);
            this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
        }
        $a331d7a6c631e6d9$var$updateMandatoryProps(group, axisPointerModel, true);
        this._renderHandle(value);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.remove = function(api) {
        this.clear(api);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.dispose = function(api) {
        this.clear(api);
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.determineAnimation = function(axisModel, axisPointerModel) {
        var animation = axisPointerModel.get("animation");
        var axis = axisModel.axis;
        var isCategoryAxis = axis.type === "category";
        var useSnap = axisPointerModel.get("snap");
        // Value axis without snap always do not snap.
        if (!useSnap && !isCategoryAxis) return false;
        if (animation === "auto" || animation == null) {
            var animationThreshold = this.animationThreshold;
            if (isCategoryAxis && axis.getBandWidth() > animationThreshold) return true;
            // It is important to auto animation when snap used. Consider if there is
            // a dataZoom, animation will be disabled when too many points exist, while
            // it will be enabled for better visual effect when little points exist.
            if (useSnap) {
                var seriesDataCount = $84d826b9ba8bf009$export$bd39458db76002ab(axisModel).seriesDataCount;
                var axisExtent = axis.getExtent();
                // Approximate band width
                return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
            }
            return false;
        }
        return animation === true;
    };
    /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */ BaseAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
    // Should be implemenented by sub-class.
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createPointerEl = function(group, elOption, axisModel, axisPointerModel) {
        var pointerOption = elOption.pointer;
        if (pointerOption) {
            var pointerEl = $a331d7a6c631e6d9$var$inner(group).pointerEl = new $5b455ae6f843ac47$exports[pointerOption.type]($a331d7a6c631e6d9$var$clone(elOption.pointer));
            group.add(pointerEl);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createLabelEl = function(group, elOption, axisModel, axisPointerModel) {
        if (elOption.label) {
            var labelEl = $a331d7a6c631e6d9$var$inner(group).labelEl = new $5b455ae6f843ac47$exports.Text($a331d7a6c631e6d9$var$clone(elOption.label));
            group.add(labelEl);
            $a331d7a6c631e6d9$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updatePointerEl = function(group, elOption, updateProps) {
        var pointerEl = $a331d7a6c631e6d9$var$inner(group).pointerEl;
        if (pointerEl && elOption.pointer) {
            pointerEl.setStyle(elOption.pointer.style);
            updateProps(pointerEl, {
                shape: elOption.pointer.shape
            });
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updateLabelEl = function(group, elOption, updateProps, axisPointerModel) {
        var labelEl = $a331d7a6c631e6d9$var$inner(group).labelEl;
        if (labelEl) {
            labelEl.setStyle(elOption.label.style);
            updateProps(labelEl, {
                // Consider text length change in vertical axis, animation should
                // be used on shape, otherwise the effect will be weird.
                // TODOTODO
                // shape: elOption.label.shape,
                x: elOption.label.x,
                y: elOption.label.y
            });
            $a331d7a6c631e6d9$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @private
   */ BaseAxisPointer.prototype._renderHandle = function(value) {
        if (this._dragging || !this.updateHandleTransform) return;
        var axisPointerModel = this._axisPointerModel;
        var zr = this._api.getZr();
        var handle = this._handle;
        var handleModel = axisPointerModel.getModel("handle");
        var status = axisPointerModel.get("status");
        if (!handleModel.get("show") || !status || status === "hide") {
            handle && zr.remove(handle);
            this._handle = null;
            return;
        }
        var isInit;
        if (!this._handle) {
            isInit = true;
            handle = this._handle = $5b455ae6f843ac47$exports.createIcon(handleModel.get("icon"), {
                cursor: "move",
                draggable: true,
                onmousemove: function(e) {
                    // For mobile device, prevent screen slider on the button.
                    $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
                },
                onmousedown: $a331d7a6c631e6d9$var$bind(this._onHandleDragMove, this, 0, 0),
                drift: $a331d7a6c631e6d9$var$bind(this._onHandleDragMove, this),
                ondragend: $a331d7a6c631e6d9$var$bind(this._onHandleDragEnd, this)
            });
            zr.add(handle);
        }
        $a331d7a6c631e6d9$var$updateMandatoryProps(handle, axisPointerModel, false);
        // update style
        handle.setStyle(handleModel.getItemStyle(null, [
            "color",
            "borderColor",
            "borderWidth",
            "opacity",
            "shadowColor",
            "shadowBlur",
            "shadowOffsetX",
            "shadowOffsetY"
        ]));
        // update position
        var handleSize = handleModel.get("size");
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(handleSize)) handleSize = [
            handleSize,
            handleSize
        ];
        handle.scaleX = handleSize[0] / 2;
        handle.scaleY = handleSize[1] / 2;
        $c98659a9437a3d2e$export$958e3e1a02eac4b6(this, "_doDispatchAxisPointer", handleModel.get("throttle") || 0, "fixRate");
        this._moveHandleToValue(value, isInit);
    };
    BaseAxisPointer.prototype._moveHandleToValue = function(value, isInit) {
        $a331d7a6c631e6d9$var$updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, $a331d7a6c631e6d9$var$getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
    };
    BaseAxisPointer.prototype._onHandleDragMove = function(dx, dy) {
        var handle = this._handle;
        if (!handle) return;
        this._dragging = true;
        // Persistent for throttle.
        var trans = this.updateHandleTransform($a331d7a6c631e6d9$var$getHandleTransProps(handle), [
            dx,
            dy
        ], this._axisModel, this._axisPointerModel);
        this._payloadInfo = trans;
        handle.stopAnimation();
        handle.attr($a331d7a6c631e6d9$var$getHandleTransProps(trans));
        $a331d7a6c631e6d9$var$inner(handle).lastProp = null;
        this._doDispatchAxisPointer();
    };
    /**
   * Throttled method.
   */ BaseAxisPointer.prototype._doDispatchAxisPointer = function() {
        var handle = this._handle;
        if (!handle) return;
        var payloadInfo = this._payloadInfo;
        var axisModel = this._axisModel;
        this._api.dispatchAction({
            type: "updateAxisPointer",
            x: payloadInfo.cursorPoint[0],
            y: payloadInfo.cursorPoint[1],
            tooltipOption: payloadInfo.tooltipOption,
            axesInfo: [
                {
                    axisDim: axisModel.axis.dim,
                    axisIndex: axisModel.componentIndex
                }
            ]
        });
    };
    BaseAxisPointer.prototype._onHandleDragEnd = function() {
        this._dragging = false;
        var handle = this._handle;
        if (!handle) return;
        var value = this._axisPointerModel.get("value");
        // Consider snap or categroy axis, handle may be not consistent with
        // axisPointer. So move handle to align the exact value position when
        // drag ended.
        this._moveHandleToValue(value);
        // For the effect: tooltip will be shown when finger holding on handle
        // button, and will be hidden after finger left handle button.
        this._api.dispatchAction({
            type: "hideTip"
        });
    };
    /**
   * @private
   */ BaseAxisPointer.prototype.clear = function(api) {
        this._lastValue = null;
        this._lastStatus = null;
        var zr = api.getZr();
        var group = this._group;
        var handle = this._handle;
        if (zr && group) {
            this._lastGraphicKey = null;
            group && zr.remove(group);
            handle && zr.remove(handle);
            this._group = null;
            this._handle = null;
            this._payloadInfo = null;
        }
        $c98659a9437a3d2e$export$42ffd38884aecdac(this, "_doDispatchAxisPointer");
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.doClear = function() {
    // Implemented by sub-class if necessary.
    };
    BaseAxisPointer.prototype.buildLabel = function(xy, wh, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x: xy[xDimIndex],
            y: xy[1 - xDimIndex],
            width: wh[xDimIndex],
            height: wh[1 - xDimIndex]
        };
    };
    return BaseAxisPointer;
}();
function $a331d7a6c631e6d9$var$updateProps(animationModel, moveAnimation, el, props) {
    // Animation optimize.
    if (!$a331d7a6c631e6d9$var$propsEqual($a331d7a6c631e6d9$var$inner(el).lastProp, props)) {
        $a331d7a6c631e6d9$var$inner(el).lastProp = props;
        moveAnimation ? $5b455ae6f843ac47$exports.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
    }
}
function $a331d7a6c631e6d9$var$propsEqual(lastProps, newProps) {
    if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(lastProps) && $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(newProps)) {
        var equals_1 = true;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(newProps, function(item, key) {
            equals_1 = equals_1 && $a331d7a6c631e6d9$var$propsEqual(lastProps[key], item);
        });
        return !!equals_1;
    } else return lastProps === newProps;
}
function $a331d7a6c631e6d9$var$updateLabelShowHide(labelEl, axisPointerModel) {
    labelEl[axisPointerModel.get([
        "label",
        "show"
    ]) ? "show" : "hide"]();
}
function $a331d7a6c631e6d9$var$getHandleTransProps(trans) {
    return {
        x: trans.x || 0,
        y: trans.y || 0,
        rotation: trans.rotation || 0
    };
}
function $a331d7a6c631e6d9$var$updateMandatoryProps(group, axisPointerModel, silent) {
    var z = axisPointerModel.get("z");
    var zlevel = axisPointerModel.get("zlevel");
    group && group.traverse(function(el) {
        if (el.type !== "group") {
            z != null && (el.z = z);
            zlevel != null && (el.zlevel = zlevel);
            el.silent = silent;
        }
    });
}
var $a331d7a6c631e6d9$export$2e2bcd8739ae039 = $a331d7a6c631e6d9$var$BaseAxisPointer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







function $51dec70890757374$export$b7fe459c7cc50060(axisPointerModel) {
    var axisPointerType = axisPointerModel.get("type");
    var styleModel = axisPointerModel.getModel(axisPointerType + "Style");
    var style;
    if (axisPointerType === "line") {
        style = styleModel.getLineStyle();
        style.fill = null;
    } else if (axisPointerType === "shadow") {
        style = styleModel.getAreaStyle();
        style.stroke = null;
    }
    return style;
}
function $51dec70890757374$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos) {
    var value = axisPointerModel.get("value");
    var text = $51dec70890757374$export$7cffee0f9aed39d0(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get("seriesDataIndices"), {
        precision: axisPointerModel.get([
            "label",
            "precision"
        ]),
        formatter: axisPointerModel.get([
            "label",
            "formatter"
        ])
    });
    var labelModel = axisPointerModel.getModel("label");
    var paddings = $c84c9521536c601a$export$f3a38102c49f4268(labelModel.get("padding") || 0);
    var font = labelModel.getFont();
    var textRect = $6c308355c7107803$export$c381147bfed79d9f(text, font);
    var position = labelPos.position;
    var width = textRect.width + paddings[1] + paddings[3];
    var height = textRect.height + paddings[0] + paddings[2];
    // Adjust by align.
    var align = labelPos.align;
    align === "right" && (position[0] -= width);
    align === "center" && (position[0] -= width / 2);
    var verticalAlign = labelPos.verticalAlign;
    verticalAlign === "bottom" && (position[1] -= height);
    verticalAlign === "middle" && (position[1] -= height / 2);
    // Not overflow ec container
    $51dec70890757374$var$confineInContainer(position, width, height, api);
    var bgColor = labelModel.get("backgroundColor");
    if (!bgColor || bgColor === "auto") bgColor = axisModel.get([
        "axisLine",
        "lineStyle",
        "color"
    ]);
    elOption.label = {
        // shape: {x: 0, y: 0, width: width, height: height, r: labelModel.get('borderRadius')},
        x: position[0],
        y: position[1],
        style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelModel, {
            text: text,
            font: font,
            fill: labelModel.getTextColor(),
            padding: paddings,
            backgroundColor: bgColor
        }),
        // Label should be over axisPointer.
        z2: 10
    };
}
// Do not overflow ec container
function $51dec70890757374$var$confineInContainer(position, width, height, api) {
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    position[0] = Math.min(position[0] + width, viewWidth) - width;
    position[1] = Math.min(position[1] + height, viewHeight) - height;
    position[0] = Math.max(position[0], 0);
    position[1] = Math.max(position[1], 0);
}
function $51dec70890757374$export$7cffee0f9aed39d0(value, axis, ecModel, seriesDataIndices, opt) {
    value = axis.scale.parse(value);
    var text = axis.scale.getLabel({
        value: value
    }, {
        // If `precision` is set, width can be fixed (like '12.00500'), which
        // helps to debounce when when moving label.
        precision: opt.precision
    });
    var formatter = opt.formatter;
    if (formatter) {
        var params_1 = {
            value: $2d646e51cc34f840$export$a5a32f324c1fa457(axis, {
                value: value
            }),
            axisDimension: axis.dim,
            axisIndex: axis.index,
            seriesData: []
        };
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(seriesDataIndices, function(idxItem) {
            var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
            var dataIndex = idxItem.dataIndexInside;
            var dataParams = series && series.getDataParams(dataIndex);
            dataParams && params_1.seriesData.push(dataParams);
        });
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) text = formatter.replace("{value}", text);
        else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) text = formatter(params_1);
    }
    return text;
}
function $51dec70890757374$export$4bb66440324c3a3d(axis, value, layoutInfo) {
    var transform = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
    $f41ebb9dd60b55b4$export$bb628a54ab399bc9(transform, transform, layoutInfo.rotation);
    $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(transform, transform, layoutInfo.position);
    return $5b455ae6f843ac47$export$9f9dcb98c894b623([
        axis.dataToCoord(value),
        (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)
    ], transform);
}
function $51dec70890757374$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
    // @ts-ignore
    var textLayout = (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039).innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
    layoutInfo.labelMargin = axisPointerModel.get([
        "label",
        "margin"
    ]);
    $51dec70890757374$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, {
        position: $51dec70890757374$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo),
        align: textLayout.textAlign,
        verticalAlign: textLayout.textVerticalAlign
    });
}
function $51dec70890757374$export$885fa0ad5a826207(p1, p2, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x1: p1[xDimIndex],
        y1: p1[1 - xDimIndex],
        x2: p2[xDimIndex],
        y2: p2[1 - xDimIndex]
    };
}
function $51dec70890757374$export$a8b35248bcc02756(xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x: xy[xDimIndex],
        y: xy[1 - xDimIndex],
        width: wh[xDimIndex],
        height: wh[1 - xDimIndex]
    };
}
function $51dec70890757374$export$b0cf82e7ebc0d7d0(cx, cy, r0, r, startAngle, endAngle) {
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r,
        startAngle: startAngle,
        endAngle: endAngle,
        clockwise: true
    };
}



var $044c80eefb03ac3d$var$CartesianAxisPointer = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CartesianAxisPointer, _super);
    function CartesianAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ CartesianAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisPointerType = axisPointerModel.get("type");
        var otherExtent = $044c80eefb03ac3d$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
        if (axisPointerType && axisPointerType !== "none") {
            var elStyle = $51dec70890757374$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $044c80eefb03ac3d$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $88c937c9bc0ca068$export$b3219800bda33a1f(grid.model, axisModel);
        $51dec70890757374$export$fd3eb3812211a173(// @ts-ignore
        value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $88c937c9bc0ca068$export$b3219800bda33a1f(axisModel.axis.grid.model, axisModel, {
            labelInside: false
        });
        // @ts-ignore
        layoutInfo.labelMargin = axisPointerModel.get([
            "handle",
            "margin"
        ]);
        var pos = $51dec70890757374$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo);
        return {
            x: pos[0],
            y: pos[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisExtent = axis.getGlobalExtent(true);
        var otherExtent = $044c80eefb03ac3d$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var dimIndex = axis.dim === "x" ? 0 : 1;
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex];
        // Make tooltip do not overlap axisPointer and in the middle of the grid.
        var tooltipOptions = [
            {
                verticalAlign: "middle"
            },
            {
                align: "center"
            }
        ];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: tooltipOptions[dimIndex]
        };
    };
    return CartesianAxisPointer;
}((0, $a331d7a6c631e6d9$export$2e2bcd8739ae039));
function $044c80eefb03ac3d$var$getCartesian(grid, axis) {
    var opt = {};
    opt[axis.dim + "AxisIndex"] = axis.index;
    return grid.getCartesian(opt);
}
var $044c80eefb03ac3d$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, otherExtent) {
        var targetShape = $51dec70890757374$export$885fa0ad5a826207([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $044c80eefb03ac3d$var$getAxisDimIndex(axis));
        return {
            type: "Line",
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, otherExtent) {
        var bandWidth = Math.max(1, axis.getBandWidth());
        var span = otherExtent[1] - otherExtent[0];
        return {
            type: "Rect",
            shape: $51dec70890757374$export$a8b35248bcc02756([
                pixelValue - bandWidth / 2,
                otherExtent[0]
            ], [
                bandWidth,
                span
            ], $044c80eefb03ac3d$var$getAxisDimIndex(axis))
        };
    }
};
function $044c80eefb03ac3d$var$getAxisDimIndex(axis) {
    return axis.dim === "x" ? 0 : 1;
}
var $044c80eefb03ac3d$export$2e2bcd8739ae039 = $044c80eefb03ac3d$var$CartesianAxisPointer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $f55b7040bd1041c6$var$AxisPointerModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AxisPointerModel, _super);
    function AxisPointerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerModel.type;
        return _this;
    }
    AxisPointerModel.type = "axisPointer";
    AxisPointerModel.defaultOption = {
        // 'auto' means that show when triggered by tooltip or handle.
        show: "auto",
        // zlevel: 0,
        z: 50,
        type: "line",
        // axispointer triggered by tootip determine snap automatically,
        // see `modelHelper`.
        snap: false,
        triggerTooltip: true,
        triggerEmphasis: true,
        value: null,
        status: null,
        link: [],
        // Do not set 'auto' here, otherwise global animation: false
        // will not effect at this axispointer.
        animation: null,
        animationDurationUpdate: 200,
        lineStyle: {
            color: "#B9BEC9",
            width: 1,
            type: "dashed"
        },
        shadowStyle: {
            color: "rgba(210,219,238,0.2)"
        },
        label: {
            show: true,
            formatter: null,
            precision: "auto",
            margin: 3,
            color: "#fff",
            padding: [
                5,
                7,
                5,
                7
            ],
            backgroundColor: "auto",
            borderColor: null,
            borderWidth: 0,
            borderRadius: 3
        },
        handle: {
            show: false,
            // eslint-disable-next-line
            icon: "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z",
            size: 45,
            // handle margin is from symbol center to axis, which is stable when circular move.
            margin: 50,
            // color: '#1b8bbd'
            // color: '#2f4554'
            color: "#333",
            shadowBlur: 3,
            shadowColor: "#aaa",
            shadowOffsetX: 0,
            shadowOffsetY: 2,
            // For mobile performance
            throttle: 40
        }
    };
    return AxisPointerModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $f55b7040bd1041c6$export$2e2bcd8739ae039 = $f55b7040bd1041c6$var$AxisPointerModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $84450f5aa7fbde00$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $84450f5aa7fbde00$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
function $84450f5aa7fbde00$export$6503ec6e8aabbaf(key, api, handler) {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node) return;
    var zr = api.getZr();
    $84450f5aa7fbde00$var$inner(zr).records || ($84450f5aa7fbde00$var$inner(zr).records = {});
    $84450f5aa7fbde00$var$initGlobalListeners(zr, api);
    var record = $84450f5aa7fbde00$var$inner(zr).records[key] || ($84450f5aa7fbde00$var$inner(zr).records[key] = {});
    record.handler = handler;
}
function $84450f5aa7fbde00$var$initGlobalListeners(zr, api) {
    if ($84450f5aa7fbde00$var$inner(zr).initialized) return;
    $84450f5aa7fbde00$var$inner(zr).initialized = true;
    useHandler("click", $7a1bd9c2710fea0d$export$c3095a23b368d1f2($84450f5aa7fbde00$var$doEnter, "click"));
    useHandler("mousemove", $7a1bd9c2710fea0d$export$c3095a23b368d1f2($84450f5aa7fbde00$var$doEnter, "mousemove"));
    // useHandler('mouseout', onLeave);
    useHandler("globalout", $84450f5aa7fbde00$var$onLeave);
    function useHandler(eventType, cb) {
        zr.on(eventType, function(e) {
            var dis = $84450f5aa7fbde00$var$makeDispatchAction(api);
            $84450f5aa7fbde00$var$each($84450f5aa7fbde00$var$inner(zr).records, function(record) {
                record && cb(record, e, dis.dispatchAction);
            });
            $84450f5aa7fbde00$var$dispatchTooltipFinally(dis.pendings, api);
        });
    }
}
function $84450f5aa7fbde00$var$dispatchTooltipFinally(pendings, api) {
    var showLen = pendings.showTip.length;
    var hideLen = pendings.hideTip.length;
    var actuallyPayload;
    if (showLen) actuallyPayload = pendings.showTip[showLen - 1];
    else if (hideLen) actuallyPayload = pendings.hideTip[hideLen - 1];
    if (actuallyPayload) {
        actuallyPayload.dispatchAction = null;
        api.dispatchAction(actuallyPayload);
    }
}
function $84450f5aa7fbde00$var$onLeave(record, e, dispatchAction) {
    record.handler("leave", null, dispatchAction);
}
function $84450f5aa7fbde00$var$doEnter(currTrigger, record, e, dispatchAction) {
    record.handler(currTrigger, e, dispatchAction);
}
function $84450f5aa7fbde00$var$makeDispatchAction(api) {
    var pendings = {
        showTip: [],
        hideTip: []
    };
    // FIXME
    // better approach?
    // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
    // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
    // So we have to add "final stage" to merge those dispatched actions.
    var dispatchAction = function(payload) {
        var pendingList = pendings[payload.type];
        if (pendingList) pendingList.push(payload);
        else {
            payload.dispatchAction = dispatchAction;
            api.dispatchAction(payload);
        }
    };
    return {
        dispatchAction: dispatchAction,
        pendings: pendings
    };
}
function $84450f5aa7fbde00$export$d07f55d4c15c0440(key, api) {
    if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node) return;
    var zr = api.getZr();
    var record = ($84450f5aa7fbde00$var$inner(zr).records || {})[key];
    if (record) $84450f5aa7fbde00$var$inner(zr).records[key] = null;
}



var $615cfe2d5ef5fcce$var$AxisPointerView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AxisPointerView, _super);
    function AxisPointerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerView.type;
        return _this;
    }
    AxisPointerView.prototype.render = function(globalAxisPointerModel, ecModel, api) {
        var globalTooltipModel = ecModel.getComponent("tooltip");
        var triggerOn = globalAxisPointerModel.get("triggerOn") || globalTooltipModel && globalTooltipModel.get("triggerOn") || "mousemove|click";
        // Register global listener in AxisPointerView to enable
        // AxisPointerView to be independent to Tooltip.
        $84450f5aa7fbde00$export$6503ec6e8aabbaf("axisPointer", api, function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== "none" && (currTrigger === "leave" || triggerOn.indexOf(currTrigger) >= 0)) dispatchAction({
                type: "updateAxisPointer",
                currTrigger: currTrigger,
                x: e && e.offsetX,
                y: e && e.offsetY
            });
        });
    };
    AxisPointerView.prototype.remove = function(ecModel, api) {
        $84450f5aa7fbde00$export$d07f55d4c15c0440("axisPointer", api);
    };
    AxisPointerView.prototype.dispose = function(ecModel, api) {
        $84450f5aa7fbde00$export$d07f55d4c15c0440("axisPointer", api);
    };
    AxisPointerView.type = "axisPointer";
    return AxisPointerView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $615cfe2d5ef5fcce$export$2e2bcd8739ae039 = $615cfe2d5ef5fcce$var$AxisPointerView;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $4cab5d8b3532dad5$export$2e2bcd8739ae039(finder, ecModel) {
    var point = [];
    var seriesIndex = finder.seriesIndex;
    var seriesModel;
    if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) return {
        point: []
    };
    var data = seriesModel.getData();
    var dataIndex = $76d619f648247e6d$export$42b26cae8b8d10(data, finder);
    if (dataIndex == null || dataIndex < 0 || $7a1bd9c2710fea0d$export$43bee75e5e14138e(dataIndex)) return {
        point: []
    };
    var el = data.getItemGraphicEl(dataIndex);
    var coordSys = seriesModel.coordinateSystem;
    if (seriesModel.getTooltipPosition) point = seriesModel.getTooltipPosition(dataIndex) || [];
    else if (coordSys && coordSys.dataToPoint) {
        if (finder.isStacked) {
            var baseAxis = coordSys.getBaseAxis();
            var valueAxis = coordSys.getOtherAxis(baseAxis);
            var valueAxisDim = valueAxis.dim;
            var baseAxisDim = baseAxis.dim;
            var baseDataOffset = valueAxisDim === "x" || valueAxisDim === "radius" ? 1 : 0;
            var baseDim = data.mapDimension(baseAxisDim);
            var stackedData = [];
            stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
            stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo("stackResultDimension"), dataIndex);
            point = coordSys.dataToPoint(stackedData) || [];
        } else point = coordSys.dataToPoint(data.getValues($7a1bd9c2710fea0d$export$871de8747c9eaa88(coordSys.dimensions, function(dim) {
            return data.mapDimension(dim);
        }), dataIndex)) || [];
    } else if (el) {
        // Use graphic bounding rect
        var rect = el.getBoundingRect().clone();
        rect.applyTransform(el.transform);
        point = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    }
    return {
        point: point,
        el: el
    };
}



var $1cb2191f8bc71b5b$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $1cb2191f8bc71b5b$export$2e2bcd8739ae039(payload, ecModel, api) {
    var currTrigger = payload.currTrigger;
    var point = [
        payload.x,
        payload.y
    ];
    var finder = payload;
    var dispatchAction = payload.dispatchAction || (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(api.dispatchAction, api);
    var coordSysAxesInfo = ecModel.getComponent("axisPointer").coordSysAxesInfo;
    // Pending
    // See #6121. But we are not able to reproduce it yet.
    if (!coordSysAxesInfo) return;
    if ($1cb2191f8bc71b5b$var$illegalPoint(point)) // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = (0, $4cab5d8b3532dad5$export$2e2bcd8739ae039)({
        seriesIndex: finder.seriesIndex,
        // Do not use dataIndexInside from other ec instance.
        // FIXME: auto detect it?
        dataIndex: finder.dataIndex
    }, ecModel).point;
    var isIllegalPoint = $1cb2191f8bc71b5b$var$illegalPoint(point);
    // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
    // Notice: In this case, it is difficult to get the `point` (which is necessary to show
    // tooltip, so if point is not given, we just use the point found by sample seriesIndex
    // and dataIndex.
    var inputAxesInfo = finder.axesInfo;
    var axesInfo = coordSysAxesInfo.axesInfo;
    var shouldHide = currTrigger === "leave" || $1cb2191f8bc71b5b$var$illegalPoint(point);
    var outputPayload = {};
    var showValueMap = {};
    var dataByCoordSys = {
        list: [],
        map: {}
    };
    var updaters = {
        showPointer: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($1cb2191f8bc71b5b$var$showPointer, showValueMap),
        showTooltip: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($1cb2191f8bc71b5b$var$showTooltip, dataByCoordSys)
    };
    // Process for triggered axes.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSysAxesInfo.coordSysMap, function(coordSys, coordSysKey) {
        // If a point given, it must be contained by the coordinate system.
        var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function(axisInfo, key) {
            var axis = axisInfo.axis;
            var inputAxisInfo = $1cb2191f8bc71b5b$var$findInputAxisInfo(inputAxesInfo, axisInfo);
            // If no inputAxesInfo, no axis is restricted.
            if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
                var val = inputAxisInfo && inputAxisInfo.value;
                if (val == null && !isIllegalPoint) val = axis.pointToData(point);
                val != null && $1cb2191f8bc71b5b$var$processOnAxis(axisInfo, val, updaters, false, outputPayload);
            }
        });
    });
    // Process for linked axes.
    var linkTriggers = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesInfo, function(tarAxisInfo, tarKey) {
        var linkGroup = tarAxisInfo.linkGroup;
        // If axis has been triggered in the previous stage, it should not be triggered by link.
        if (linkGroup && !showValueMap[tarKey]) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(linkGroup.axesInfo, function(srcAxisInfo, srcKey) {
            var srcValItem = showValueMap[srcKey];
            // If srcValItem exist, source axis is triggered, so link to target axis.
            if (srcAxisInfo !== tarAxisInfo && srcValItem) {
                var val = srcValItem.value;
                linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, $1cb2191f8bc71b5b$var$makeMapperParam(srcAxisInfo), $1cb2191f8bc71b5b$var$makeMapperParam(tarAxisInfo))));
                linkTriggers[tarAxisInfo.key] = val;
            }
        });
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(linkTriggers, function(val, tarKey) {
        $1cb2191f8bc71b5b$var$processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
    });
    $1cb2191f8bc71b5b$var$updateModelActually(showValueMap, axesInfo, outputPayload);
    $1cb2191f8bc71b5b$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
    $1cb2191f8bc71b5b$var$dispatchHighDownActually(axesInfo, dispatchAction, api);
    return outputPayload;
}
function $1cb2191f8bc71b5b$var$processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
    var axis = axisInfo.axis;
    if (axis.scale.isBlank() || !axis.containData(newValue)) return;
    if (!axisInfo.involveSeries) {
        updaters.showPointer(axisInfo, newValue);
        return;
    }
    // Heavy calculation. So put it after axis.containData checking.
    var payloadInfo = $1cb2191f8bc71b5b$var$buildPayloadsBySeries(newValue, axisInfo);
    var payloadBatch = payloadInfo.payloadBatch;
    var snapToValue = payloadInfo.snapToValue;
    // Fill content of event obj for echarts.connect.
    // By default use the first involved series data as a sample to connect.
    if (payloadBatch[0] && outputFinder.seriesIndex == null) (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)(outputFinder, payloadBatch[0]);
    // If no linkSource input, this process is for collecting link
    // target, where snap should not be accepted.
    if (!noSnap && axisInfo.snap) {
        if (axis.containData(snapToValue) && snapToValue != null) newValue = snapToValue;
    }
    updaters.showPointer(axisInfo, newValue, payloadBatch);
    // Tooltip should always be snapToValue, otherwise there will be
    // incorrect "axis value ~ series value" mapping displayed in tooltip.
    updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}
function $1cb2191f8bc71b5b$var$buildPayloadsBySeries(value, axisInfo) {
    var axis = axisInfo.axis;
    var dim = axis.dim;
    var snapToValue = value;
    var payloadBatch = [];
    var minDist = Number.MAX_VALUE;
    var minDiff = -1;
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisInfo.seriesModels, function(series, idx) {
        var dataDim = series.getData().mapDimensionsAll(dim);
        var seriesNestestValue;
        var dataIndices;
        if (series.getAxisTooltipData) {
            var result = series.getAxisTooltipData(dataDim, value, axis);
            dataIndices = result.dataIndices;
            seriesNestestValue = result.nestestValue;
        } else {
            dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
            // when data length is not same.
            // false,
            axis.type === "category" ? 0.5 : null);
            if (!dataIndices.length) return;
            seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
        }
        if (seriesNestestValue == null || !isFinite(seriesNestestValue)) return;
        var diff = value - seriesNestestValue;
        var dist = Math.abs(diff);
        // Consider category case
        if (dist <= minDist) {
            if (dist < minDist || diff >= 0 && minDiff < 0) {
                minDist = dist;
                minDiff = diff;
                snapToValue = seriesNestestValue;
                payloadBatch.length = 0;
            }
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataIndices, function(dataIndex) {
                payloadBatch.push({
                    seriesIndex: series.seriesIndex,
                    dataIndexInside: dataIndex,
                    dataIndex: series.getData().getRawIndex(dataIndex)
                });
            });
        }
    });
    return {
        payloadBatch: payloadBatch,
        snapToValue: snapToValue
    };
}
function $1cb2191f8bc71b5b$var$showPointer(showValueMap, axisInfo, value, payloadBatch) {
    showValueMap[axisInfo.key] = {
        value: value,
        payloadBatch: payloadBatch
    };
}
function $1cb2191f8bc71b5b$var$showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
    var payloadBatch = payloadInfo.payloadBatch;
    var axis = axisInfo.axis;
    var axisModel = axis.model;
    var axisPointerModel = axisInfo.axisPointerModel;
    // If no data, do not create anything in dataByCoordSys,
    // whose length will be used to judge whether dispatch action.
    if (!axisInfo.triggerTooltip || !payloadBatch.length) return;
    var coordSysModel = axisInfo.coordSys.model;
    var coordSysKey = $84d826b9ba8bf009$export$d01b444bafb1a792(coordSysModel);
    var coordSysItem = dataByCoordSys.map[coordSysKey];
    if (!coordSysItem) {
        coordSysItem = dataByCoordSys.map[coordSysKey] = {
            coordSysId: coordSysModel.id,
            coordSysIndex: coordSysModel.componentIndex,
            coordSysType: coordSysModel.type,
            coordSysMainType: coordSysModel.mainType,
            dataByAxis: []
        };
        dataByCoordSys.list.push(coordSysItem);
    }
    coordSysItem.dataByAxis.push({
        axisDim: axis.dim,
        axisIndex: axisModel.componentIndex,
        axisType: axisModel.type,
        axisId: axisModel.id,
        value: value,
        // Caustion: viewHelper.getValueLabel is actually on "view stage", which
        // depends that all models have been updated. So it should not be performed
        // here. Considering axisPointerModel used here is volatile, which is hard
        // to be retrieve in TooltipView, we prepare parameters here.
        valueLabelOpt: {
            precision: axisPointerModel.get([
                "label",
                "precision"
            ]),
            formatter: axisPointerModel.get([
                "label",
                "formatter"
            ])
        },
        seriesDataIndices: payloadBatch.slice()
    });
}
function $1cb2191f8bc71b5b$var$updateModelActually(showValueMap, axesInfo, outputPayload) {
    var outputAxesInfo = outputPayload.axesInfo = [];
    // Basic logic: If no 'show' required, 'hide' this axisPointer.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        var valItem = showValueMap[key];
        if (valItem) {
            !axisInfo.useHandle && (option.status = "show");
            option.value = valItem.value;
            // For label formatter param and highlight.
            option.seriesDataIndices = (valItem.payloadBatch || []).slice();
        } else // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = "hide");
        // If status is 'hide', should be no info in payload.
        option.status === "show" && outputAxesInfo.push({
            axisDim: axisInfo.axis.dim,
            axisIndex: axisInfo.axis.model.componentIndex,
            value: option.value
        });
    });
}
function $1cb2191f8bc71b5b$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
    // Basic logic: If no showTip required, hideTip will be dispatched.
    if ($1cb2191f8bc71b5b$var$illegalPoint(point) || !dataByCoordSys.list.length) {
        dispatchAction({
            type: "hideTip"
        });
        return;
    }
    // In most case only one axis (or event one series is used). It is
    // convenient to fetch payload.seriesIndex and payload.dataIndex
    // directly. So put the first seriesIndex and dataIndex of the first
    // axis on the payload.
    var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
    dispatchAction({
        type: "showTip",
        escapeConnect: true,
        x: point[0],
        y: point[1],
        tooltipOption: payload.tooltipOption,
        position: payload.position,
        dataIndexInside: sampleItem.dataIndexInside,
        dataIndex: sampleItem.dataIndex,
        seriesIndex: sampleItem.seriesIndex,
        dataByCoordSys: dataByCoordSys.list
    });
}
function $1cb2191f8bc71b5b$var$dispatchHighDownActually(axesInfo, dispatchAction, api) {
    // FIXME
    // highlight status modification should be a stage of main process?
    // (Consider confilct (e.g., legend and axisPointer) and setOption)
    var zr = api.getZr();
    var highDownKey = "axisPointerLastHighlights";
    var lastHighlights = $1cb2191f8bc71b5b$var$inner(zr)[highDownKey] || {};
    var newHighlights = $1cb2191f8bc71b5b$var$inner(zr)[highDownKey] = {};
    // Update highlight/downplay status according to axisPointer model.
    // Build hash map and remove duplicate incidentally.
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        option.status === "show" && axisInfo.triggerEmphasis && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(option.seriesDataIndices, function(batchItem) {
            var key = batchItem.seriesIndex + " | " + batchItem.dataIndex;
            newHighlights[key] = batchItem;
        });
    });
    // Diff.
    var toHighlight = [];
    var toDownplay = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastHighlights, function(batchItem, key) {
        !newHighlights[key] && toDownplay.push(batchItem);
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newHighlights, function(batchItem, key) {
        !lastHighlights[key] && toHighlight.push(batchItem);
    });
    toDownplay.length && api.dispatchAction({
        type: "downplay",
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toDownplay
    });
    toHighlight.length && api.dispatchAction({
        type: "highlight",
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toHighlight
    });
}
function $1cb2191f8bc71b5b$var$findInputAxisInfo(inputAxesInfo, axisInfo) {
    for(var i = 0; i < (inputAxesInfo || []).length; i++){
        var inputAxisInfo = inputAxesInfo[i];
        if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) return inputAxisInfo;
    }
}
function $1cb2191f8bc71b5b$var$makeMapperParam(axisInfo) {
    var axisModel = axisInfo.axis.model;
    var item = {};
    var dim = item.axisDim = axisInfo.axis.dim;
    item.axisIndex = item[dim + "AxisIndex"] = axisModel.componentIndex;
    item.axisName = item[dim + "AxisName"] = axisModel.name;
    item.axisId = item[dim + "AxisId"] = axisModel.id;
    return item;
}
function $1cb2191f8bc71b5b$var$illegalPoint(point) {
    return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}


function $589507869c21caa1$export$4b3e715f166fdd78(registers) {
    // CartesianAxisPointer is not supposed to be required here. But consider
    // echarts.simple.js and online build tooltip, which only require gridSimple,
    // CartesianAxisPointer should be able to required somewhere.
    (0, $58c48a3ef1aa0746$export$2e2bcd8739ae039).registerAxisPointerClass("CartesianAxisPointer", (0, $044c80eefb03ac3d$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $f55b7040bd1041c6$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $615cfe2d5ef5fcce$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(option) {
        // Always has a global axisPointerModel for default setting.
        if (option) {
            (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
            var link = option.axisPointer.link;
            // Normalize to array to avoid object mergin. But if link
            // is not set, remain null/undefined, otherwise it will
            // override existent link setting.
            if (link && !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(link)) option.axisPointer.link = [
                link
            ];
        }
    });
    // This process should proformed after coordinate systems created
    // and series data processed. So put it on statistic processing stage.
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, function(ecModel, api) {
        // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
        // allAxesInfo should be updated when setOption performed.
        ecModel.getComponent("axisPointer").coordSysAxesInfo = (0, $84d826b9ba8bf009$export$bb44f104e3c54dae)(ecModel, api);
    });
    // Broadcast to all views.
    registers.registerAction({
        type: "updateAxisPointer",
        event: "updateAxisPointer",
        update: ":updateAxisPointer"
    }, (0, $1cb2191f8bc71b5b$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $860dd9ca08385e85$var$DEFAULT_TOOLBOX_BTNS = [
    "rect",
    "polygon",
    "keep",
    "clear"
];
function $860dd9ca08385e85$export$2e2bcd8739ae039(option, isNew) {
    var brushComponents = (0, $76d619f648247e6d$export$4f07b212a02c8051)(option ? option.brush : []);
    if (!brushComponents.length) return;
    var brushComponentSpecifiedBtns = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(brushComponents, function(brushOpt) {
        var tbs = brushOpt.hasOwnProperty("toolbox") ? brushOpt.toolbox : [];
        if (tbs instanceof Array) brushComponentSpecifiedBtns = brushComponentSpecifiedBtns.concat(tbs);
    });
    var toolbox = option && option.toolbox;
    if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(toolbox)) toolbox = toolbox[0];
    if (!toolbox) {
        toolbox = {
            feature: {}
        };
        option.toolbox = [
            toolbox
        ];
    }
    var toolboxFeature = toolbox.feature || (toolbox.feature = {});
    var toolboxBrush = toolboxFeature.brush || (toolboxFeature.brush = {});
    var brushTypes = toolboxBrush.type || (toolboxBrush.type = []);
    brushTypes.push.apply(brushTypes, brushComponentSpecifiedBtns);
    $860dd9ca08385e85$var$removeDuplicate(brushTypes);
    if (isNew && !brushTypes.length) brushTypes.push.apply(brushTypes, $860dd9ca08385e85$var$DEFAULT_TOOLBOX_BTNS);
}
function $860dd9ca08385e85$var$removeDuplicate(arr) {
    var map = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(arr, function(val) {
        map[val] = 1;
    });
    arr.length = 0;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(map, function(flag, val) {
        arr.push(val);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @file Visual solution, for consistent option specification.
 */ 


var $87ea23222d1c134e$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
function $87ea23222d1c134e$var$hasKeys(obj) {
    if (obj) for(var name_1 in obj){
        if (obj.hasOwnProperty(name_1)) return true;
    }
}
function $87ea23222d1c134e$export$89974527642f24a0(option, stateList, supplementVisualOption) {
    var visualMappings = {};
    $87ea23222d1c134e$var$each(stateList, function(state) {
        var mappings = visualMappings[state] = createMappings();
        $87ea23222d1c134e$var$each(option[state], function(visualData, visualType) {
            if (!(0, $7b50f502cfd189d5$export$2e2bcd8739ae039).isValidType(visualType)) return;
            var mappingOption = {
                type: visualType,
                visual: visualData
            };
            supplementVisualOption && supplementVisualOption(mappingOption, state);
            mappings[visualType] = new (0, $7b50f502cfd189d5$export$2e2bcd8739ae039)(mappingOption);
            // Prepare a alpha for opacity, for some case that opacity
            // is not supported, such as rendering using gradient color.
            if (visualType === "opacity") {
                mappingOption = $7a1bd9c2710fea0d$export$9cd59f9826255e47(mappingOption);
                mappingOption.type = "colorAlpha";
                mappings.__hidden.__alphaForOpacity = new (0, $7b50f502cfd189d5$export$2e2bcd8739ae039)(mappingOption);
            }
        });
    });
    return visualMappings;
    function createMappings() {
        var Creater = function() {};
        // Make sure hidden fields will not be visited by
        // object iteration (with hasOwnProperty checking).
        Creater.prototype.__hidden = Creater.prototype;
        var obj = new Creater();
        return obj;
    }
}
function $87ea23222d1c134e$export$797d20c0a6de578f(thisOption, newOption, keys) {
    // Visual attributes merge is not supported, otherwise it
    // brings overcomplicated merge logic. See #2853. So if
    // newOption has anyone of these keys, all of these keys
    // will be reset. Otherwise, all keys remain.
    var has;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(keys, function(key) {
        if (newOption.hasOwnProperty(key) && $87ea23222d1c134e$var$hasKeys(newOption[key])) has = true;
    });
    has && $7a1bd9c2710fea0d$export$79b2f7037acddd43(keys, function(key) {
        if (newOption.hasOwnProperty(key) && $87ea23222d1c134e$var$hasKeys(newOption[key])) thisOption[key] = $7a1bd9c2710fea0d$export$9cd59f9826255e47(newOption[key]);
        else delete thisOption[key];
    });
}
function $87ea23222d1c134e$export$bb1ef43951d58629(stateList, visualMappings, data, getValueState, scope, dimension) {
    var visualTypesMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(stateList, function(state) {
        var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).prepareVisualTypes(visualMappings[state]);
        visualTypesMap[state] = visualTypes;
    });
    var dataIndex;
    function getVisual(key) {
        return (0, $ea13f1ab2169d82d$export$91d919a86b2df624)(data, dataIndex, key);
    }
    function setVisual(key, value) {
        (0, $ea13f1ab2169d82d$export$3aab879e9d0e7c75)(data, dataIndex, key, value);
    }
    if (dimension == null) data.each(eachItem);
    else data.each([
        dimension
    ], eachItem);
    function eachItem(valueOrIndex, index) {
        dataIndex = dimension == null ? valueOrIndex // First argument is index
         : index;
        var rawDataItem = data.getRawDataItem(dataIndex);
        // Consider performance
        // @ts-ignore
        if (rawDataItem && rawDataItem.visualMap === false) return;
        var valueState = getValueState.call(scope, valueOrIndex);
        var mappings = visualMappings[valueState];
        var visualTypes = visualTypesMap[valueState];
        for(var i = 0, len = visualTypes.length; i < len; i++){
            var type = visualTypes[i];
            mappings[type] && mappings[type].applyVisual(valueOrIndex, getVisual, setVisual);
        }
    }
}
function $87ea23222d1c134e$export$fc0ef8703cccf128(stateList, visualMappings, getValueState, dim) {
    var visualTypesMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(stateList, function(state) {
        var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).prepareVisualTypes(visualMappings[state]);
        visualTypesMap[state] = visualTypes;
    });
    return {
        progress: function progress(params, data) {
            var dimIndex;
            if (dim != null) dimIndex = data.getDimensionIndex(dim);
            function getVisual(key) {
                return (0, $ea13f1ab2169d82d$export$91d919a86b2df624)(data, dataIndex, key);
            }
            function setVisual(key, value) {
                (0, $ea13f1ab2169d82d$export$3aab879e9d0e7c75)(data, dataIndex, key, value);
            }
            var dataIndex;
            var store = data.getStore();
            while((dataIndex = params.next()) != null){
                var rawDataItem = data.getRawDataItem(dataIndex);
                // Consider performance
                // @ts-ignore
                if (rawDataItem && rawDataItem.visualMap === false) continue;
                var value = dim != null ? store.get(dimIndex, dataIndex) : dataIndex;
                var valueState = getValueState(value);
                var mappings = visualMappings[valueState];
                var visualTypes = visualTypesMap[valueState];
                for(var i = 0, len = visualTypes.length; i < len; i++){
                    var type = visualTypes[i];
                    mappings[type] && mappings[type].applyVisual(value, getVisual, setVisual);
                }
            }
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $431fae42b264171b$export$2225cfa0a999c142(area) {
    var brushType = area.brushType;
    // Do not use function binding or curry for performance.
    var selectors = {
        point: function(itemLayout) {
            return $431fae42b264171b$var$selector[brushType].point(itemLayout, selectors, area);
        },
        rect: function(itemLayout) {
            return $431fae42b264171b$var$selector[brushType].rect(itemLayout, selectors, area);
        }
    };
    return selectors;
}
var $431fae42b264171b$var$selector = {
    lineX: $431fae42b264171b$var$getLineSelectors(0),
    lineY: $431fae42b264171b$var$getLineSelectors(1),
    rect: {
        point: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]);
        },
        rect: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.intersect(itemLayout);
        }
    },
    polygon: {
        point: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]) && $b4726ec5f917394d$export$8893e2b90ba10d92(area.range, itemLayout[0], itemLayout[1]);
        },
        rect: function(itemLayout, selectors, area) {
            var points = area.range;
            if (!itemLayout || points.length <= 1) return false;
            var x = itemLayout.x;
            var y = itemLayout.y;
            var width = itemLayout.width;
            var height = itemLayout.height;
            var p = points[0];
            if ($b4726ec5f917394d$export$8893e2b90ba10d92(points, x, y) || $b4726ec5f917394d$export$8893e2b90ba10d92(points, x + width, y) || $b4726ec5f917394d$export$8893e2b90ba10d92(points, x, y + height) || $b4726ec5f917394d$export$8893e2b90ba10d92(points, x + width, y + height) || (0, $1bebe7106c895823$export$2e2bcd8739ae039).create(itemLayout).contain(p[0], p[1]) || (0, $5b455ae6f843ac47$export$4f47c855a5e9ae9)(x, y, x + width, y, points) || (0, $5b455ae6f843ac47$export$4f47c855a5e9ae9)(x, y, x, y + height, points) || (0, $5b455ae6f843ac47$export$4f47c855a5e9ae9)(x + width, y, x + width, y + height, points) || (0, $5b455ae6f843ac47$export$4f47c855a5e9ae9)(x, y + height, x + width, y + height, points)) return true;
        }
    }
};
function $431fae42b264171b$var$getLineSelectors(xyIndex) {
    var xy = [
        "x",
        "y"
    ];
    var wh = [
        "width",
        "height"
    ];
    return {
        point: function(itemLayout, selectors, area) {
            if (itemLayout) {
                var range = area.range;
                var p = itemLayout[xyIndex];
                return $431fae42b264171b$var$inLineRange(p, range);
            }
        },
        rect: function(itemLayout, selectors, area) {
            if (itemLayout) {
                var range = area.range;
                var layoutRange = [
                    itemLayout[xy[xyIndex]],
                    itemLayout[xy[xyIndex]] + itemLayout[wh[xyIndex]]
                ];
                layoutRange[1] < layoutRange[0] && layoutRange.reverse();
                return $431fae42b264171b$var$inLineRange(layoutRange[0], range) || $431fae42b264171b$var$inLineRange(layoutRange[1], range) || $431fae42b264171b$var$inLineRange(range[0], layoutRange) || $431fae42b264171b$var$inLineRange(range[1], layoutRange);
            }
        }
    };
}
function $431fae42b264171b$var$inLineRange(p, range) {
    return range[0] <= p && p <= range[1];
}
var $431fae42b264171b$export$2e2bcd8739ae039 = $431fae42b264171b$var$selector;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



// FIXME
// how to genarialize to more coordinate systems.
var $6213fed8aa63fab1$var$INCLUDE_FINDER_MAIN_TYPES = [
    "grid",
    "xAxis",
    "yAxis",
    "geo",
    "graph",
    "polar",
    "radiusAxis",
    "angleAxis",
    "bmap"
];
var $6213fed8aa63fab1$var$BrushTargetManager = /** @class */ function() {
    /**
   * @param finder contains Index/Id/Name of xAxis/yAxis/geo/grid
   *        Each can be {number|Array.<number>}. like: {xAxisIndex: [3, 4]}
   * @param opt.include include coordinate system types.
   */ function BrushTargetManager(finder, ecModel, opt) {
        var _this = this;
        this._targetInfoList = [];
        var foundCpts = $6213fed8aa63fab1$var$parseFinder(ecModel, finder);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)($6213fed8aa63fab1$var$targetInfoBuilders, function(builder, type) {
            if (!opt || !opt.include || (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(opt.include, type) >= 0) builder(foundCpts, _this._targetInfoList);
        });
    }
    BrushTargetManager.prototype.setOutputRanges = function(areas, ecModel) {
        this.matchOutputRanges(areas, ecModel, function(area, coordRange, coordSys) {
            (area.coordRanges || (area.coordRanges = [])).push(coordRange);
            // area.coordRange is the first of area.coordRanges
            if (!area.coordRange) {
                area.coordRange = coordRange;
                // In 'category' axis, coord to pixel is not reversible, so we can not
                // rebuild range by coordRange accrately, which may bring trouble when
                // brushing only one item. So we use __rangeOffset to rebuilding range
                // by coordRange. And this it only used in brush component so it is no
                // need to be adapted to coordRanges.
                var result = $6213fed8aa63fab1$var$coordConvert[area.brushType](0, coordSys, coordRange);
                area.__rangeOffset = {
                    offset: $6213fed8aa63fab1$var$diffProcessor[area.brushType](result.values, area.range, [
                        1,
                        1
                    ]),
                    xyMinMax: result.xyMinMax
                };
            }
        });
        return areas;
    };
    BrushTargetManager.prototype.matchOutputRanges = function(areas, ecModel, cb) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(areas, function(area) {
            var targetInfo = this.findTargetInfo(area, ecModel);
            if (targetInfo && targetInfo !== true) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(targetInfo.coordSyses, function(coordSys) {
                var result = $6213fed8aa63fab1$var$coordConvert[area.brushType](1, coordSys, area.range, true);
                cb(area, result.values, coordSys, ecModel);
            });
        }, this);
    };
    /**
   * the `areas` is `BrushModel.areas`.
   * Called in layout stage.
   * convert `area.coordRange` to global range and set panelId to `area.range`.
   */ BrushTargetManager.prototype.setInputRanges = function(areas, ecModel) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(areas, function(area) {
            var targetInfo = this.findTargetInfo(area, ecModel);
            area.range = area.range || [];
            // convert coordRange to global range and set panelId.
            if (targetInfo && targetInfo !== true) {
                area.panelId = targetInfo.panelId;
                // (1) area.range should always be calculate from coordRange but does
                // not keep its original value, for the sake of the dataZoom scenario,
                // where area.coordRange remains unchanged but area.range may be changed.
                // (2) Only support converting one coordRange to pixel range in brush
                // component. So do not consider `coordRanges`.
                // (3) About __rangeOffset, see comment above.
                var result = $6213fed8aa63fab1$var$coordConvert[area.brushType](0, targetInfo.coordSys, area.coordRange);
                var rangeOffset = area.__rangeOffset;
                area.range = rangeOffset ? $6213fed8aa63fab1$var$diffProcessor[area.brushType](result.values, rangeOffset.offset, $6213fed8aa63fab1$var$getScales(result.xyMinMax, rangeOffset.xyMinMax)) : result.values;
            }
        }, this);
    };
    BrushTargetManager.prototype.makePanelOpts = function(api, getDefaultBrushType) {
        return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(this._targetInfoList, function(targetInfo) {
            var rect = targetInfo.getPanelRect();
            return {
                panelId: targetInfo.panelId,
                defaultBrushType: getDefaultBrushType ? getDefaultBrushType(targetInfo) : null,
                clipPath: $d9c171f7dfe1f12f$export$fee17964a62a87a7(rect),
                isTargetByCursor: $d9c171f7dfe1f12f$export$e63e66b3b18aa99f(rect, api, targetInfo.coordSysModel),
                getLinearBrushOtherExtent: $d9c171f7dfe1f12f$export$7280070e90fad7a0(rect)
            };
        });
    };
    BrushTargetManager.prototype.controlSeries = function(area, seriesModel, ecModel) {
        // Check whether area is bound in coord, and series do not belong to that coord.
        // If do not do this check, some brush (like lineX) will controll all axes.
        var targetInfo = this.findTargetInfo(area, ecModel);
        return targetInfo === true || targetInfo && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(targetInfo.coordSyses, seriesModel.coordinateSystem) >= 0;
    };
    /**
   * If return Object, a coord found.
   * If return true, global found.
   * Otherwise nothing found.
   */ BrushTargetManager.prototype.findTargetInfo = function(area, ecModel) {
        var targetInfoList = this._targetInfoList;
        var foundCpts = $6213fed8aa63fab1$var$parseFinder(ecModel, area);
        for(var i = 0; i < targetInfoList.length; i++){
            var targetInfo = targetInfoList[i];
            var areaPanelId = area.panelId;
            if (areaPanelId) {
                if (targetInfo.panelId === areaPanelId) return targetInfo;
            } else for(var j = 0; j < $6213fed8aa63fab1$var$targetInfoMatchers.length; j++){
                if ($6213fed8aa63fab1$var$targetInfoMatchers[j](foundCpts, targetInfo)) return targetInfo;
            }
        }
        return true;
    };
    return BrushTargetManager;
}();
function $6213fed8aa63fab1$var$formatMinMax(minMax) {
    minMax[0] > minMax[1] && minMax.reverse();
    return minMax;
}
function $6213fed8aa63fab1$var$parseFinder(ecModel, finder) {
    return (0, $76d619f648247e6d$export$95de80076abac814)(ecModel, finder, {
        includeMainTypes: $6213fed8aa63fab1$var$INCLUDE_FINDER_MAIN_TYPES
    });
}
var $6213fed8aa63fab1$var$targetInfoBuilders = {
    grid: function(foundCpts, targetInfoList) {
        var xAxisModels = foundCpts.xAxisModels;
        var yAxisModels = foundCpts.yAxisModels;
        var gridModels = foundCpts.gridModels;
        // Remove duplicated.
        var gridModelMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var xAxesHas = {};
        var yAxesHas = {};
        if (!xAxisModels && !yAxisModels && !gridModels) return;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(xAxisModels, function(axisModel) {
            var gridModel = axisModel.axis.grid.model;
            gridModelMap.set(gridModel.id, gridModel);
            xAxesHas[gridModel.id] = true;
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(yAxisModels, function(axisModel) {
            var gridModel = axisModel.axis.grid.model;
            gridModelMap.set(gridModel.id, gridModel);
            yAxesHas[gridModel.id] = true;
        });
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(gridModels, function(gridModel) {
            gridModelMap.set(gridModel.id, gridModel);
            xAxesHas[gridModel.id] = true;
            yAxesHas[gridModel.id] = true;
        });
        gridModelMap.each(function(gridModel) {
            var grid = gridModel.coordinateSystem;
            var cartesians = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(grid.getCartesians(), function(cartesian, index) {
                if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(xAxisModels, cartesian.getAxis("x").model) >= 0 || (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(yAxisModels, cartesian.getAxis("y").model) >= 0) cartesians.push(cartesian);
            });
            targetInfoList.push({
                panelId: "grid--" + gridModel.id,
                gridModel: gridModel,
                coordSysModel: gridModel,
                // Use the first one as the representitive coordSys.
                coordSys: cartesians[0],
                coordSyses: cartesians,
                getPanelRect: $6213fed8aa63fab1$var$panelRectBuilders.grid,
                xAxisDeclared: xAxesHas[gridModel.id],
                yAxisDeclared: yAxesHas[gridModel.id]
            });
        });
    },
    geo: function(foundCpts, targetInfoList) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(foundCpts.geoModels, function(geoModel) {
            var coordSys = geoModel.coordinateSystem;
            targetInfoList.push({
                panelId: "geo--" + geoModel.id,
                geoModel: geoModel,
                coordSysModel: geoModel,
                coordSys: coordSys,
                coordSyses: [
                    coordSys
                ],
                getPanelRect: $6213fed8aa63fab1$var$panelRectBuilders.geo
            });
        });
    }
};
var $6213fed8aa63fab1$var$targetInfoMatchers = [
    // grid
    function(foundCpts, targetInfo) {
        var xAxisModel = foundCpts.xAxisModel;
        var yAxisModel = foundCpts.yAxisModel;
        var gridModel = foundCpts.gridModel;
        !gridModel && xAxisModel && (gridModel = xAxisModel.axis.grid.model);
        !gridModel && yAxisModel && (gridModel = yAxisModel.axis.grid.model);
        return gridModel && gridModel === targetInfo.gridModel;
    },
    // geo
    function(foundCpts, targetInfo) {
        var geoModel = foundCpts.geoModel;
        return geoModel && geoModel === targetInfo.geoModel;
    }
];
var $6213fed8aa63fab1$var$panelRectBuilders = {
    grid: function() {
        // grid is not Transformable.
        return this.coordSys.master.getRect().clone();
    },
    geo: function() {
        var coordSys = this.coordSys;
        var rect = coordSys.getBoundingRect().clone();
        // geo roam and zoom transform
        rect.applyTransform($5b455ae6f843ac47$export$fce0c6cfca85ed96(coordSys));
        return rect;
    }
};
var $6213fed8aa63fab1$var$coordConvert = {
    lineX: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6213fed8aa63fab1$var$axisConvert, 0),
    lineY: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6213fed8aa63fab1$var$axisConvert, 1),
    rect: function(to, coordSys, rangeOrCoordRange, clamp) {
        var xminymin = to ? coordSys.pointToData([
            rangeOrCoordRange[0][0],
            rangeOrCoordRange[1][0]
        ], clamp) : coordSys.dataToPoint([
            rangeOrCoordRange[0][0],
            rangeOrCoordRange[1][0]
        ], clamp);
        var xmaxymax = to ? coordSys.pointToData([
            rangeOrCoordRange[0][1],
            rangeOrCoordRange[1][1]
        ], clamp) : coordSys.dataToPoint([
            rangeOrCoordRange[0][1],
            rangeOrCoordRange[1][1]
        ], clamp);
        var values = [
            $6213fed8aa63fab1$var$formatMinMax([
                xminymin[0],
                xmaxymax[0]
            ]),
            $6213fed8aa63fab1$var$formatMinMax([
                xminymin[1],
                xmaxymax[1]
            ])
        ];
        return {
            values: values,
            xyMinMax: values
        };
    },
    polygon: function(to, coordSys, rangeOrCoordRange, clamp) {
        var xyMinMax = [
            [
                Infinity,
                -Infinity
            ],
            [
                Infinity,
                -Infinity
            ]
        ];
        var values = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(rangeOrCoordRange, function(item) {
            var p = to ? coordSys.pointToData(item, clamp) : coordSys.dataToPoint(item, clamp);
            xyMinMax[0][0] = Math.min(xyMinMax[0][0], p[0]);
            xyMinMax[1][0] = Math.min(xyMinMax[1][0], p[1]);
            xyMinMax[0][1] = Math.max(xyMinMax[0][1], p[0]);
            xyMinMax[1][1] = Math.max(xyMinMax[1][1], p[1]);
            return p;
        });
        return {
            values: values,
            xyMinMax: xyMinMax
        };
    }
};
function $6213fed8aa63fab1$var$axisConvert(axisNameIndex, to, coordSys, rangeOrCoordRange) {
    var axis = coordSys.getAxis([
        "x",
        "y"
    ][axisNameIndex]);
    var values = $6213fed8aa63fab1$var$formatMinMax((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)([
        0,
        1
    ], function(i) {
        return to ? axis.coordToData(axis.toLocalCoord(rangeOrCoordRange[i]), true) : axis.toGlobalCoord(axis.dataToCoord(rangeOrCoordRange[i]));
    }));
    var xyMinMax = [];
    xyMinMax[axisNameIndex] = values;
    xyMinMax[1 - axisNameIndex] = [
        NaN,
        NaN
    ];
    return {
        values: values,
        xyMinMax: xyMinMax
    };
}
var $6213fed8aa63fab1$var$diffProcessor = {
    lineX: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6213fed8aa63fab1$var$axisDiffProcessor, 0),
    lineY: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6213fed8aa63fab1$var$axisDiffProcessor, 1),
    rect: function(values, refer, scales) {
        return [
            [
                values[0][0] - scales[0] * refer[0][0],
                values[0][1] - scales[0] * refer[0][1]
            ],
            [
                values[1][0] - scales[1] * refer[1][0],
                values[1][1] - scales[1] * refer[1][1]
            ]
        ];
    },
    polygon: function(values, refer, scales) {
        return (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(values, function(item, idx) {
            return [
                item[0] - scales[0] * refer[idx][0],
                item[1] - scales[1] * refer[idx][1]
            ];
        });
    }
};
function $6213fed8aa63fab1$var$axisDiffProcessor(axisNameIndex, values, refer, scales) {
    return [
        values[0] - scales[axisNameIndex] * refer[0],
        values[1] - scales[axisNameIndex] * refer[1]
    ];
}
// We have to process scale caused by dataZoom manually,
// although it might be not accurate.
// Return [0~1, 0~1]
function $6213fed8aa63fab1$var$getScales(xyMinMaxCurr, xyMinMaxOrigin) {
    var sizeCurr = $6213fed8aa63fab1$var$getSize(xyMinMaxCurr);
    var sizeOrigin = $6213fed8aa63fab1$var$getSize(xyMinMaxOrigin);
    var scales = [
        sizeCurr[0] / sizeOrigin[0],
        sizeCurr[1] / sizeOrigin[1]
    ];
    isNaN(scales[0]) && (scales[0] = 1);
    isNaN(scales[1]) && (scales[1] = 1);
    return scales;
}
function $6213fed8aa63fab1$var$getSize(xyMinMax) {
    return xyMinMax ? [
        xyMinMax[0][1] - xyMinMax[0][0],
        xyMinMax[1][1] - xyMinMax[1][0]
    ] : [
        NaN,
        NaN
    ];
}
var $6213fed8aa63fab1$export$2e2bcd8739ae039 = $6213fed8aa63fab1$var$BrushTargetManager;


var $8c565e07fd43a6ee$var$STATE_LIST = [
    "inBrush",
    "outOfBrush"
];
var $8c565e07fd43a6ee$var$DISPATCH_METHOD = "__ecBrushSelect";
var $8c565e07fd43a6ee$var$DISPATCH_FLAG = "__ecInBrushSelectEvent";
function $8c565e07fd43a6ee$export$ead1205d8c0d8375(ecModel) {
    ecModel.eachComponent({
        mainType: "brush"
    }, function(brushModel) {
        var brushTargetManager = brushModel.brushTargetManager = new (0, $6213fed8aa63fab1$export$2e2bcd8739ae039)(brushModel.option, ecModel);
        brushTargetManager.setInputRanges(brushModel.areas, ecModel);
    });
}
function $8c565e07fd43a6ee$export$2e2bcd8739ae039(ecModel, api, payload) {
    var brushSelected = [];
    var throttleType;
    var throttleDelay;
    ecModel.eachComponent({
        mainType: "brush"
    }, function(brushModel) {
        payload && payload.type === "takeGlobalCursor" && brushModel.setBrushOption(payload.key === "brush" ? payload.brushOption : {
            brushType: false
        });
    });
    $8c565e07fd43a6ee$export$ead1205d8c0d8375(ecModel);
    ecModel.eachComponent({
        mainType: "brush"
    }, function(brushModel, brushIndex) {
        var thisBrushSelected = {
            brushId: brushModel.id,
            brushIndex: brushIndex,
            brushName: brushModel.name,
            areas: $7a1bd9c2710fea0d$export$9cd59f9826255e47(brushModel.areas),
            selected: []
        };
        // Every brush component exists in event params, convenient
        // for user to find by index.
        brushSelected.push(thisBrushSelected);
        var brushOption = brushModel.option;
        var brushLink = brushOption.brushLink;
        var linkedSeriesMap = [];
        var selectedDataIndexForLink = [];
        var rangeInfoBySeries = [];
        var hasBrushExists = false;
        if (!brushIndex) {
            // Only the first throttle setting works.
            throttleType = brushOption.throttleType;
            throttleDelay = brushOption.throttleDelay;
        }
        // Add boundingRect and selectors to range.
        var areas = $7a1bd9c2710fea0d$export$871de8747c9eaa88(brushModel.areas, function(area) {
            var builder = $8c565e07fd43a6ee$var$boundingRectBuilders[area.brushType];
            var selectableArea = $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                boundingRect: builder ? builder(area) : void 0
            }, area);
            selectableArea.selectors = (0, $431fae42b264171b$export$2225cfa0a999c142)(selectableArea);
            return selectableArea;
        });
        var visualMappings = $87ea23222d1c134e$export$89974527642f24a0(brushModel.option, $8c565e07fd43a6ee$var$STATE_LIST, function(mappingOption) {
            mappingOption.mappingMethod = "fixed";
        });
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(brushLink) && $7a1bd9c2710fea0d$export$79b2f7037acddd43(brushLink, function(seriesIndex) {
            linkedSeriesMap[seriesIndex] = 1;
        });
        function linkOthers(seriesIndex) {
            return brushLink === "all" || !!linkedSeriesMap[seriesIndex];
        }
        // If no supported brush or no brush on the series,
        // all visuals should be in original state.
        function brushed(rangeInfoList) {
            return !!rangeInfoList.length;
        }
        /**
     * Logic for each series: (If the logic has to be modified one day, do it carefully!)
     *
     * ( brushed ┬ && ┬hasBrushExist ┬ && linkOthers  ) => StepA: ┬record, ┬ StepB: ┬visualByRecord.
     *   !brushed┘    ├hasBrushExist ┤                            └nothing,┘        ├visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( !brushed  && ┬hasBrushExist ┬ && linkOthers  ) => StepA:  nothing,  StepB: ┬visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( brushed ┬ &&                     !linkOthers ) => StepA:  nothing,  StepB: ┬visualByCheck.
     *   !brushed┘                                                                  └nothing.
     * ( !brushed  &&                     !linkOthers ) => StepA:  nothing,  StepB:  nothing.
     */ // Step A
        ecModel.eachSeries(function(seriesModel, seriesIndex) {
            var rangeInfoList = rangeInfoBySeries[seriesIndex] = [];
            seriesModel.subType === "parallel" ? stepAParallel(seriesModel, seriesIndex) : stepAOthers(seriesModel, seriesIndex, rangeInfoList);
        });
        function stepAParallel(seriesModel, seriesIndex) {
            var coordSys = seriesModel.coordinateSystem;
            hasBrushExists = hasBrushExists || coordSys.hasAxisBrushed();
            linkOthers(seriesIndex) && coordSys.eachActiveState(seriesModel.getData(), function(activeState, dataIndex) {
                activeState === "active" && (selectedDataIndexForLink[dataIndex] = 1);
            });
        }
        function stepAOthers(seriesModel, seriesIndex, rangeInfoList) {
            if (!seriesModel.brushSelector || $8c565e07fd43a6ee$var$brushModelNotControll(brushModel, seriesIndex)) return;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(areas, function(area) {
                if (brushModel.brushTargetManager.controlSeries(area, seriesModel, ecModel)) rangeInfoList.push(area);
                hasBrushExists = hasBrushExists || brushed(rangeInfoList);
            });
            if (linkOthers(seriesIndex) && brushed(rangeInfoList)) {
                var data_1 = seriesModel.getData();
                data_1.each(function(dataIndex) {
                    if ($8c565e07fd43a6ee$var$checkInRange(seriesModel, rangeInfoList, data_1, dataIndex)) selectedDataIndexForLink[dataIndex] = 1;
                });
            }
        }
        // Step B
        ecModel.eachSeries(function(seriesModel, seriesIndex) {
            var seriesBrushSelected = {
                seriesId: seriesModel.id,
                seriesIndex: seriesIndex,
                seriesName: seriesModel.name,
                dataIndex: []
            };
            // Every series exists in event params, convenient
            // for user to find series by seriesIndex.
            thisBrushSelected.selected.push(seriesBrushSelected);
            var rangeInfoList = rangeInfoBySeries[seriesIndex];
            var data = seriesModel.getData();
            var getValueState = linkOthers(seriesIndex) ? function(dataIndex) {
                return selectedDataIndexForLink[dataIndex] ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), "inBrush") : "outOfBrush";
            } : function(dataIndex) {
                return $8c565e07fd43a6ee$var$checkInRange(seriesModel, rangeInfoList, data, dataIndex) ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), "inBrush") : "outOfBrush";
            };
            // If no supported brush or no brush, all visuals are in original state.
            (linkOthers(seriesIndex) ? hasBrushExists : brushed(rangeInfoList)) && $87ea23222d1c134e$export$bb1ef43951d58629($8c565e07fd43a6ee$var$STATE_LIST, visualMappings, data, getValueState);
        });
    });
    $8c565e07fd43a6ee$var$dispatchAction(api, throttleType, throttleDelay, brushSelected, payload);
}
function $8c565e07fd43a6ee$var$dispatchAction(api, throttleType, throttleDelay, brushSelected, payload) {
    // This event will not be triggered when `setOpion`, otherwise dead lock may
    // triggered when do `setOption` in event listener, which we do not find
    // satisfactory way to solve yet. Some considered resolutions:
    // (a) Diff with prevoius selected data ant only trigger event when changed.
    // But store previous data and diff precisely (i.e., not only by dataIndex, but
    // also detect value changes in selected data) might bring complexity or fragility.
    // (b) Use spectial param like `silent` to suppress event triggering.
    // But such kind of volatile param may be weird in `setOption`.
    if (!payload) return;
    var zr = api.getZr();
    if (zr[$8c565e07fd43a6ee$var$DISPATCH_FLAG]) return;
    if (!zr[$8c565e07fd43a6ee$var$DISPATCH_METHOD]) zr[$8c565e07fd43a6ee$var$DISPATCH_METHOD] = $8c565e07fd43a6ee$var$doDispatch;
    var fn = $c98659a9437a3d2e$export$958e3e1a02eac4b6(zr, $8c565e07fd43a6ee$var$DISPATCH_METHOD, throttleDelay, throttleType);
    fn(api, brushSelected);
}
function $8c565e07fd43a6ee$var$doDispatch(api, brushSelected) {
    if (!api.isDisposed()) {
        var zr = api.getZr();
        zr[$8c565e07fd43a6ee$var$DISPATCH_FLAG] = true;
        api.dispatchAction({
            type: "brushSelect",
            batch: brushSelected
        });
        zr[$8c565e07fd43a6ee$var$DISPATCH_FLAG] = false;
    }
}
function $8c565e07fd43a6ee$var$checkInRange(seriesModel, rangeInfoList, data, dataIndex) {
    for(var i = 0, len = rangeInfoList.length; i < len; i++){
        var area = rangeInfoList[i];
        if (seriesModel.brushSelector(dataIndex, data, area.selectors, area)) return true;
    }
}
function $8c565e07fd43a6ee$var$brushModelNotControll(brushModel, seriesIndex) {
    var seriesIndices = brushModel.option.seriesIndex;
    return seriesIndices != null && seriesIndices !== "all" && ($7a1bd9c2710fea0d$export$43bee75e5e14138e(seriesIndices) ? $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(seriesIndices, seriesIndex) < 0 : seriesIndex !== seriesIndices);
}
var $8c565e07fd43a6ee$var$boundingRectBuilders = {
    rect: function(area) {
        return $8c565e07fd43a6ee$var$getBoundingRectFromMinMax(area.range);
    },
    polygon: function(area) {
        var minMax;
        var range = area.range;
        for(var i = 0, len = range.length; i < len; i++){
            minMax = minMax || [
                [
                    Infinity,
                    -Infinity
                ],
                [
                    Infinity,
                    -Infinity
                ]
            ];
            var rg = range[i];
            rg[0] < minMax[0][0] && (minMax[0][0] = rg[0]);
            rg[0] > minMax[0][1] && (minMax[0][1] = rg[0]);
            rg[1] < minMax[1][0] && (minMax[1][0] = rg[1]);
            rg[1] > minMax[1][1] && (minMax[1][1] = rg[1]);
        }
        return minMax && $8c565e07fd43a6ee$var$getBoundingRectFromMinMax(minMax);
    }
};
function $8c565e07fd43a6ee$var$getBoundingRectFromMinMax(minMax) {
    return new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(minMax[0][0], minMax[1][0], minMax[0][1] - minMax[0][0], minMax[1][1] - minMax[1][0]);
}



var $b3094615d1ff0264$var$BrushView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BrushView, _super);
    function BrushView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BrushView.type;
        return _this;
    }
    BrushView.prototype.init = function(ecModel, api) {
        this.ecModel = ecModel;
        this.api = api;
        this.model;
        (this._brushController = new (0, $91342d1cfa622c5a$export$2e2bcd8739ae039)(api.getZr())).on("brush", $7a1bd9c2710fea0d$export$2385a24977818dd0(this._onBrush, this)).mount();
    };
    BrushView.prototype.render = function(brushModel, ecModel, api, payload) {
        this.model = brushModel;
        this._updateController(brushModel, ecModel, api, payload);
    };
    BrushView.prototype.updateTransform = function(brushModel, ecModel, api, payload) {
        // PENDING: `updateTransform` is a little tricky, whose layout need
        // to be calculate mandatorily and other stages will not be performed.
        // Take care the correctness of the logic. See #11754 .
        (0, $8c565e07fd43a6ee$export$ead1205d8c0d8375)(ecModel);
        this._updateController(brushModel, ecModel, api, payload);
    };
    BrushView.prototype.updateVisual = function(brushModel, ecModel, api, payload) {
        this.updateTransform(brushModel, ecModel, api, payload);
    };
    BrushView.prototype.updateView = function(brushModel, ecModel, api, payload) {
        this._updateController(brushModel, ecModel, api, payload);
    };
    BrushView.prototype._updateController = function(brushModel, ecModel, api, payload) {
        // Do not update controller when drawing.
        (!payload || payload.$from !== brushModel.id) && this._brushController.setPanels(brushModel.brushTargetManager.makePanelOpts(api)).enableBrush(brushModel.brushOption).updateCovers(brushModel.areas.slice());
    };
    // updateLayout: updateController,
    // updateVisual: updateController,
    BrushView.prototype.dispose = function() {
        this._brushController.dispose();
    };
    BrushView.prototype._onBrush = function(eventParam) {
        var modelId = this.model.id;
        var areas = this.model.brushTargetManager.setOutputRanges(eventParam.areas, this.ecModel);
        // Action is not dispatched on drag end, because the drag end
        // emits the same params with the last drag move event, and
        // may have some delay when using touch pad, which makes
        // animation not smooth (when using debounce).
        (!eventParam.isEnd || eventParam.removeOnClick) && this.api.dispatchAction({
            type: "brush",
            brushId: modelId,
            areas: $7a1bd9c2710fea0d$export$9cd59f9826255e47(areas),
            $from: modelId
        });
        eventParam.isEnd && this.api.dispatchAction({
            type: "brushEnd",
            brushId: modelId,
            areas: $7a1bd9c2710fea0d$export$9cd59f9826255e47(areas),
            $from: modelId
        });
    };
    BrushView.type = "brush";
    return BrushView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $b3094615d1ff0264$export$2e2bcd8739ae039 = $b3094615d1ff0264$var$BrushView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $c309289727ee7770$var$DEFAULT_OUT_OF_BRUSH_COLOR = "#ddd";
var $c309289727ee7770$var$BrushModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BrushModel, _super);
    function BrushModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BrushModel.type;
        /**
     * @readOnly
     */ _this.areas = [];
        /**
     * Current brush painting area settings.
     * @readOnly
     */ _this.brushOption = {};
        return _this;
    }
    BrushModel.prototype.optionUpdated = function(newOption, isInit) {
        var thisOption = this.option;
        !isInit && $87ea23222d1c134e$export$797d20c0a6de578f(thisOption, newOption, [
            "inBrush",
            "outOfBrush"
        ]);
        var inBrush = thisOption.inBrush = thisOption.inBrush || {};
        // Always give default visual, consider setOption at the second time.
        thisOption.outOfBrush = thisOption.outOfBrush || {
            color: $c309289727ee7770$var$DEFAULT_OUT_OF_BRUSH_COLOR
        };
        if (!inBrush.hasOwnProperty("liftZ")) // Bigger than the highlight z lift, otherwise it will
        // be effected by the highlight z when brush.
        inBrush.liftZ = 5;
    };
    /**
   * If `areas` is null/undefined, range state remain.
   */ BrushModel.prototype.setAreas = function(areas) {
        // If areas is null/undefined, range state remain.
        // This helps user to dispatchAction({type: 'brush'}) with no areas
        // set but just want to get the current brush select info from a `brush` event.
        if (!areas) return;
        this.areas = $7a1bd9c2710fea0d$export$871de8747c9eaa88(areas, function(area) {
            return $c309289727ee7770$var$generateBrushOption(this.option, area);
        }, this);
    };
    /**
   * Set the current painting brush option.
   */ BrushModel.prototype.setBrushOption = function(brushOption) {
        this.brushOption = $c309289727ee7770$var$generateBrushOption(this.option, brushOption);
        this.brushType = this.brushOption.brushType;
    };
    BrushModel.type = "brush";
    BrushModel.dependencies = [
        "geo",
        "grid",
        "xAxis",
        "yAxis",
        "parallel",
        "series"
    ];
    BrushModel.defaultOption = {
        seriesIndex: "all",
        brushType: "rect",
        brushMode: "single",
        transformable: true,
        brushStyle: {
            borderWidth: 1,
            color: "rgba(210,219,238,0.3)",
            borderColor: "#D2DBEE"
        },
        throttleType: "fixRate",
        throttleDelay: 0,
        removeOnClick: true,
        z: 10000
    };
    return BrushModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
function $c309289727ee7770$var$generateBrushOption(option, brushOption) {
    return $7a1bd9c2710fea0d$export$4950aa0f605343fb({
        brushType: option.brushType,
        brushMode: option.brushMode,
        transformable: option.transformable,
        brushStyle: new (0, $6818646a97528290$export$2e2bcd8739ae039)(option.brushStyle).getItemStyle(),
        removeOnClick: option.removeOnClick,
        z: option.z
    }, brushOption, true);
}
var $c309289727ee7770$export$2e2bcd8739ae039 = $c309289727ee7770$var$BrushModel;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ var $974ee7656e10f2d0$export$1426bfb1b0bcf539 = /** @class */ function() {
    function ToolboxFeature() {}
    return ToolboxFeature;
}();
var $974ee7656e10f2d0$var$features = {};
function $974ee7656e10f2d0$export$c6213a6f247cf906(name, ctor) {
    $974ee7656e10f2d0$var$features[name] = ctor;
}
function $974ee7656e10f2d0$export$bba2e7bbd72e62e1(name) {
    return $974ee7656e10f2d0$var$features[name];
}


var $0ea8e48a326f7b6d$var$ICON_TYPES = [
    "rect",
    "polygon",
    "lineX",
    "lineY",
    "keep",
    "clear"
];
var $0ea8e48a326f7b6d$var$BrushFeature = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(BrushFeature, _super);
    function BrushFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrushFeature.prototype.render = function(featureModel, ecModel, api) {
        var brushType;
        var brushMode;
        var isBrushed;
        ecModel.eachComponent({
            mainType: "brush"
        }, function(brushModel) {
            brushType = brushModel.brushType;
            brushMode = brushModel.brushOption.brushMode || "single";
            isBrushed = isBrushed || !!brushModel.areas.length;
        });
        this._brushType = brushType;
        this._brushMode = brushMode;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(featureModel.get("type", true), function(type) {
            featureModel.setIconStatus(type, (type === "keep" ? brushMode === "multiple" : type === "clear" ? isBrushed : type === brushType) ? "emphasis" : "normal");
        });
    };
    BrushFeature.prototype.updateView = function(featureModel, ecModel, api) {
        this.render(featureModel, ecModel, api);
    };
    BrushFeature.prototype.getIcons = function() {
        var model = this.model;
        var availableIcons = model.get("icon", true);
        var icons = {};
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(model.get("type", true), function(type) {
            if (availableIcons[type]) icons[type] = availableIcons[type];
        });
        return icons;
    };
    BrushFeature.prototype.onclick = function(ecModel, api, type) {
        var brushType = this._brushType;
        var brushMode = this._brushMode;
        if (type === "clear") {
            // Trigger parallel action firstly
            api.dispatchAction({
                type: "axisAreaSelect",
                intervals: []
            });
            api.dispatchAction({
                type: "brush",
                command: "clear",
                // Clear all areas of all brush components.
                areas: []
            });
        } else api.dispatchAction({
            type: "takeGlobalCursor",
            key: "brush",
            brushOption: {
                brushType: type === "keep" ? brushType : brushType === type ? false : type,
                brushMode: type === "keep" ? brushMode === "multiple" ? "single" : "multiple" : brushMode
            }
        });
    };
    BrushFeature.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            type: $0ea8e48a326f7b6d$var$ICON_TYPES.slice(),
            icon: {
                /* eslint-disable */ rect: "M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13",
                polygon: "M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2",
                lineX: "M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4",
                lineY: "M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4",
                keep: "M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z",
                clear: "M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2" // jshint ignore:line
            },
            // `rect`, `polygon`, `lineX`, `lineY`, `keep`, `clear`
            title: ecModel.getLocaleModel().get([
                "toolbox",
                "brush",
                "title"
            ])
        };
        return defaultOption;
    };
    return BrushFeature;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
var $0ea8e48a326f7b6d$export$2e2bcd8739ae039 = $0ea8e48a326f7b6d$var$BrushFeature;




function $e97a928e0b93a54f$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView((0, $b3094615d1ff0264$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $c309289727ee7770$export$2e2bcd8739ae039));
    registers.registerPreprocessor((0, $860dd9ca08385e85$export$2e2bcd8739ae039));
    registers.registerVisual(registers.PRIORITY.VISUAL.BRUSH, (0, $8c565e07fd43a6ee$export$2e2bcd8739ae039));
    registers.registerAction({
        type: "brush",
        event: "brush",
        update: "updateVisual"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "brush",
            query: payload
        }, function(brushModel) {
            brushModel.setAreas(payload.areas);
        });
    });
    /**
   * payload: {
   *      brushComponents: [
   *          {
   *              brushId,
   *              brushIndex,
   *              brushName,
   *              series: [
   *                  {
   *                      seriesId,
   *                      seriesIndex,
   *                      seriesName,
   *                      rawIndices: [21, 34, ...]
   *                  },
   *                  ...
   *              ]
   *          },
   *          ...
   *      ]
   * }
   */ registers.registerAction({
        type: "brushSelect",
        event: "brushSelected",
        update: "none"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    registers.registerAction({
        type: "brushEnd",
        event: "brushEnd",
        update: "none"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)("brush", (0, $0ea8e48a326f7b6d$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $795d2d92b1d02c70$var$CalendarModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CalendarModel, _super);
    function CalendarModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CalendarModel.type;
        return _this;
    }
    /**
   * @override
   */ CalendarModel.prototype.init = function(option, parentModel, ecModel) {
        var inputPositionParams = (0, $93b9bc7f22ac7369$export$4b0d20af19c9875e)(option);
        _super.prototype.init.apply(this, arguments);
        $795d2d92b1d02c70$var$mergeAndNormalizeLayoutParams(option, inputPositionParams);
    };
    /**
   * @override
   */ CalendarModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        $795d2d92b1d02c70$var$mergeAndNormalizeLayoutParams(this.option, option);
    };
    CalendarModel.prototype.getCellSize = function() {
        // Has been normalized
        return this.option.cellSize;
    };
    CalendarModel.type = "calendar";
    CalendarModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        left: 80,
        top: 60,
        cellSize: 20,
        // horizontal vertical
        orient: "horizontal",
        // month separate line style
        splitLine: {
            show: true,
            lineStyle: {
                color: "#000",
                width: 1,
                type: "solid"
            }
        },
        // rect style  temporarily unused emphasis
        itemStyle: {
            color: "#fff",
            borderWidth: 1,
            borderColor: "#ccc"
        },
        // week text style
        dayLabel: {
            show: true,
            firstDay: 0,
            // start end
            position: "start",
            margin: "50%",
            color: "#000"
        },
        // month text style
        monthLabel: {
            show: true,
            // start end
            position: "start",
            margin: 5,
            // center or left
            align: "center",
            formatter: null,
            color: "#000"
        },
        // year text style
        yearLabel: {
            show: true,
            // top bottom left right
            position: null,
            margin: 30,
            formatter: null,
            color: "#ccc",
            fontFamily: "sans-serif",
            fontWeight: "bolder",
            fontSize: 20
        }
    };
    return CalendarModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
function $795d2d92b1d02c70$var$mergeAndNormalizeLayoutParams(target, raw) {
    // Normalize cellSize
    var cellSize = target.cellSize;
    var cellSizeArr;
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(cellSize)) cellSizeArr = target.cellSize = [
        cellSize,
        cellSize
    ];
    else cellSizeArr = cellSize;
    if (cellSizeArr.length === 1) cellSizeArr[1] = cellSizeArr[0];
    var ignoreSize = $7a1bd9c2710fea0d$export$871de8747c9eaa88([
        0,
        1
    ], function(hvIdx) {
        // If user have set `width` or both `left` and `right`, cellSizeArr
        // will be automatically set to 'auto', otherwise the default
        // setting of cellSizeArr will make `width` setting not work.
        if ((0, $93b9bc7f22ac7369$export$7ede609e8ebc9650)(raw, hvIdx)) cellSizeArr[hvIdx] = "auto";
        return cellSizeArr[hvIdx] != null && cellSizeArr[hvIdx] !== "auto";
    });
    (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(target, raw, {
        type: "box",
        ignoreSize: ignoreSize
    });
}
var $795d2d92b1d02c70$export$2e2bcd8739ae039 = $795d2d92b1d02c70$var$CalendarModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $e6b2dc17a91ad4af$var$CalendarView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(CalendarView, _super);
    function CalendarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CalendarView.type;
        return _this;
    }
    CalendarView.prototype.render = function(calendarModel, ecModel, api) {
        var group = this.group;
        group.removeAll();
        var coordSys = calendarModel.coordinateSystem;
        // range info
        var rangeData = coordSys.getRangeInfo();
        var orient = coordSys.getOrient();
        // locale
        var localeModel = ecModel.getLocaleModel();
        this._renderDayRect(calendarModel, rangeData, group);
        // _renderLines must be called prior to following function
        this._renderLines(calendarModel, rangeData, orient, group);
        this._renderYearText(calendarModel, rangeData, orient, group);
        this._renderMonthText(calendarModel, localeModel, orient, group);
        this._renderWeekText(calendarModel, localeModel, rangeData, orient, group);
    };
    // render day rect
    CalendarView.prototype._renderDayRect = function(calendarModel, rangeData, group) {
        var coordSys = calendarModel.coordinateSystem;
        var itemRectStyleModel = calendarModel.getModel("itemStyle").getItemStyle();
        var sw = coordSys.getCellWidth();
        var sh = coordSys.getCellHeight();
        for(var i = rangeData.start.time; i <= rangeData.end.time; i = coordSys.getNextNDay(i, 1).time){
            var point = coordSys.dataToRect([
                i
            ], false).tl;
            // every rect
            var rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                shape: {
                    x: point[0],
                    y: point[1],
                    width: sw,
                    height: sh
                },
                cursor: "default",
                style: itemRectStyleModel
            });
            group.add(rect);
        }
    };
    // render separate line
    CalendarView.prototype._renderLines = function(calendarModel, rangeData, orient, group) {
        var self = this;
        var coordSys = calendarModel.coordinateSystem;
        var lineStyleModel = calendarModel.getModel([
            "splitLine",
            "lineStyle"
        ]).getLineStyle();
        var show = calendarModel.get([
            "splitLine",
            "show"
        ]);
        var lineWidth = lineStyleModel.lineWidth;
        this._tlpoints = [];
        this._blpoints = [];
        this._firstDayOfMonth = [];
        this._firstDayPoints = [];
        var firstDay = rangeData.start;
        for(var i = 0; firstDay.time <= rangeData.end.time; i++){
            addPoints(firstDay.formatedDate);
            if (i === 0) firstDay = coordSys.getDateInfo(rangeData.start.y + "-" + rangeData.start.m);
            var date = firstDay.date;
            date.setMonth(date.getMonth() + 1);
            firstDay = coordSys.getDateInfo(date);
        }
        addPoints(coordSys.getNextNDay(rangeData.end.time, 1).formatedDate);
        function addPoints(date) {
            self._firstDayOfMonth.push(coordSys.getDateInfo(date));
            self._firstDayPoints.push(coordSys.dataToRect([
                date
            ], false).tl);
            var points = self._getLinePointsOfOneWeek(calendarModel, date, orient);
            self._tlpoints.push(points[0]);
            self._blpoints.push(points[points.length - 1]);
            show && self._drawSplitline(points, lineStyleModel, group);
        }
        // render top/left line
        show && this._drawSplitline(self._getEdgesPoints(self._tlpoints, lineWidth, orient), lineStyleModel, group);
        // render bottom/right line
        show && this._drawSplitline(self._getEdgesPoints(self._blpoints, lineWidth, orient), lineStyleModel, group);
    };
    // get points at both ends
    CalendarView.prototype._getEdgesPoints = function(points, lineWidth, orient) {
        var rs = [
            points[0].slice(),
            points[points.length - 1].slice()
        ];
        var idx = orient === "horizontal" ? 0 : 1;
        // both ends of the line are extend half lineWidth
        rs[0][idx] = rs[0][idx] - lineWidth / 2;
        rs[1][idx] = rs[1][idx] + lineWidth / 2;
        return rs;
    };
    // render split line
    CalendarView.prototype._drawSplitline = function(points, lineStyle, group) {
        var poyline = new $d28119f30e6bb670$export$2e2bcd8739ae039({
            z2: 20,
            shape: {
                points: points
            },
            style: lineStyle
        });
        group.add(poyline);
    };
    // render month line of one week points
    CalendarView.prototype._getLinePointsOfOneWeek = function(calendarModel, date, orient) {
        var coordSys = calendarModel.coordinateSystem;
        var parsedDate = coordSys.getDateInfo(date);
        var points = [];
        for(var i = 0; i < 7; i++){
            var tmpD = coordSys.getNextNDay(parsedDate.time, i);
            var point = coordSys.dataToRect([
                tmpD.time
            ], false);
            points[2 * tmpD.day] = point.tl;
            points[2 * tmpD.day + 1] = point[orient === "horizontal" ? "bl" : "tr"];
        }
        return points;
    };
    CalendarView.prototype._formatterLabel = function(formatter, params) {
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(formatter) && formatter) return (0, $c84c9521536c601a$export$2fa08233ee42f8e1)(formatter, params);
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(formatter)) return formatter(params);
        return params.nameMap;
    };
    CalendarView.prototype._yearTextPositionControl = function(textEl, point, orient, position, margin) {
        var x = point[0];
        var y = point[1];
        var aligns = [
            "center",
            "bottom"
        ];
        if (position === "bottom") {
            y += margin;
            aligns = [
                "center",
                "top"
            ];
        } else if (position === "left") x -= margin;
        else if (position === "right") {
            x += margin;
            aligns = [
                "center",
                "top"
            ];
        } else // top
        y -= margin;
        var rotate = 0;
        if (position === "left" || position === "right") rotate = Math.PI / 2;
        return {
            rotation: rotate,
            x: x,
            y: y,
            style: {
                align: aligns[0],
                verticalAlign: aligns[1]
            }
        };
    };
    // render year
    CalendarView.prototype._renderYearText = function(calendarModel, rangeData, orient, group) {
        var yearLabel = calendarModel.getModel("yearLabel");
        if (!yearLabel.get("show")) return;
        var margin = yearLabel.get("margin");
        var pos = yearLabel.get("position");
        if (!pos) pos = orient !== "horizontal" ? "top" : "left";
        var points = [
            this._tlpoints[this._tlpoints.length - 1],
            this._blpoints[0]
        ];
        var xc = (points[0][0] + points[1][0]) / 2;
        var yc = (points[0][1] + points[1][1]) / 2;
        var idx = orient === "horizontal" ? 0 : 1;
        var posPoints = {
            top: [
                xc,
                points[idx][1]
            ],
            bottom: [
                xc,
                points[1 - idx][1]
            ],
            left: [
                points[1 - idx][0],
                yc
            ],
            right: [
                points[idx][0],
                yc
            ]
        };
        var name = rangeData.start.y;
        if (+rangeData.end.y > +rangeData.start.y) name = name + "-" + rangeData.end.y;
        var formatter = yearLabel.get("formatter");
        var params = {
            start: rangeData.start.y,
            end: rangeData.end.y,
            nameMap: name
        };
        var content = this._formatterLabel(formatter, params);
        var yearText = new $fe885cc21795562b$export$2e2bcd8739ae039({
            z2: 30,
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(yearLabel, {
                text: content
            })
        });
        yearText.attr(this._yearTextPositionControl(yearText, posPoints[pos], orient, pos, margin));
        group.add(yearText);
    };
    CalendarView.prototype._monthTextPositionControl = function(point, isCenter, orient, position, margin) {
        var align = "left";
        var vAlign = "top";
        var x = point[0];
        var y = point[1];
        if (orient === "horizontal") {
            y = y + margin;
            if (isCenter) align = "center";
            if (position === "start") vAlign = "bottom";
        } else {
            x = x + margin;
            if (isCenter) vAlign = "middle";
            if (position === "start") align = "right";
        }
        return {
            x: x,
            y: y,
            align: align,
            verticalAlign: vAlign
        };
    };
    // render month and year text
    CalendarView.prototype._renderMonthText = function(calendarModel, localeModel, orient, group) {
        var monthLabel = calendarModel.getModel("monthLabel");
        if (!monthLabel.get("show")) return;
        var nameMap = monthLabel.get("nameMap");
        var margin = monthLabel.get("margin");
        var pos = monthLabel.get("position");
        var align = monthLabel.get("align");
        var termPoints = [
            this._tlpoints,
            this._blpoints
        ];
        if (!nameMap || (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(nameMap)) {
            if (nameMap) // case-sensitive
            localeModel = (0, $9b0a1ef4bcc91e7d$export$37cc638e0e11865f)(nameMap) || localeModel;
            // PENDING
            // for ZH locale, original form is `一月` but current form is `1月`
            nameMap = localeModel.get([
                "time",
                "monthAbbr"
            ]) || [];
        }
        var idx = pos === "start" ? 0 : 1;
        var axis = orient === "horizontal" ? 0 : 1;
        margin = pos === "start" ? -margin : margin;
        var isCenter = align === "center";
        for(var i = 0; i < termPoints[idx].length - 1; i++){
            var tmp = termPoints[idx][i].slice();
            var firstDay = this._firstDayOfMonth[i];
            if (isCenter) {
                var firstDayPoints = this._firstDayPoints[i];
                tmp[axis] = (firstDayPoints[axis] + termPoints[0][i + 1][axis]) / 2;
            }
            var formatter = monthLabel.get("formatter");
            var name_1 = nameMap[+firstDay.m - 1];
            var params = {
                yyyy: firstDay.y,
                yy: (firstDay.y + "").slice(2),
                MM: firstDay.m,
                M: +firstDay.m,
                nameMap: name_1
            };
            var content = this._formatterLabel(formatter, params);
            var monthText = new $fe885cc21795562b$export$2e2bcd8739ae039({
                z2: 30,
                style: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(monthLabel, {
                    text: content
                }), this._monthTextPositionControl(tmp, isCenter, orient, pos, margin))
            });
            group.add(monthText);
        }
    };
    CalendarView.prototype._weekTextPositionControl = function(point, orient, position, margin, cellSize) {
        var align = "center";
        var vAlign = "middle";
        var x = point[0];
        var y = point[1];
        var isStart = position === "start";
        if (orient === "horizontal") {
            x = x + margin + (isStart ? 1 : -1) * cellSize[0] / 2;
            align = isStart ? "right" : "left";
        } else {
            y = y + margin + (isStart ? 1 : -1) * cellSize[1] / 2;
            vAlign = isStart ? "bottom" : "top";
        }
        return {
            x: x,
            y: y,
            align: align,
            verticalAlign: vAlign
        };
    };
    // render weeks
    CalendarView.prototype._renderWeekText = function(calendarModel, localeModel, rangeData, orient, group) {
        var dayLabel = calendarModel.getModel("dayLabel");
        if (!dayLabel.get("show")) return;
        var coordSys = calendarModel.coordinateSystem;
        var pos = dayLabel.get("position");
        var nameMap = dayLabel.get("nameMap");
        var margin = dayLabel.get("margin");
        var firstDayOfWeek = coordSys.getFirstDayOfWeek();
        if (!nameMap || (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(nameMap)) {
            if (nameMap) // case-sensitive
            localeModel = (0, $9b0a1ef4bcc91e7d$export$37cc638e0e11865f)(nameMap) || localeModel;
            // Use the first letter of `dayOfWeekAbbr` if `dayOfWeekShort` doesn't exist in the locale file
            var dayOfWeekShort = localeModel.get([
                "time",
                "dayOfWeekShort"
            ]);
            nameMap = dayOfWeekShort || (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(localeModel.get([
                "time",
                "dayOfWeekAbbr"
            ]), function(val) {
                return val[0];
            });
        }
        var start = coordSys.getNextNDay(rangeData.end.time, 7 - rangeData.lweek).time;
        var cellSize = [
            coordSys.getCellWidth(),
            coordSys.getCellHeight()
        ];
        margin = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(margin, Math.min(cellSize[1], cellSize[0]));
        if (pos === "start") {
            start = coordSys.getNextNDay(rangeData.start.time, -(7 + rangeData.fweek)).time;
            margin = -margin;
        }
        for(var i = 0; i < 7; i++){
            var tmpD = coordSys.getNextNDay(start, i);
            var point = coordSys.dataToRect([
                tmpD.time
            ], false).center;
            var day = i;
            day = Math.abs((i + firstDayOfWeek) % 7);
            var weekText = new $fe885cc21795562b$export$2e2bcd8739ae039({
                z2: 30,
                style: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(dayLabel, {
                    text: nameMap[day]
                }), this._weekTextPositionControl(point, orient, pos, margin, cellSize))
            });
            group.add(weekText);
        }
    };
    CalendarView.type = "calendar";
    return CalendarView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $e6b2dc17a91ad4af$export$2e2bcd8739ae039 = $e6b2dc17a91ad4af$var$CalendarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


// (24*60*60*1000)
var $be2279b8e0028cb2$var$PROXIMATE_ONE_DAY = 86400000;
var $be2279b8e0028cb2$var$Calendar = /** @class */ function() {
    function Calendar(calendarModel, ecModel, api) {
        this.type = "calendar";
        this.dimensions = Calendar.dimensions;
        // Required in createListFromData
        this.getDimensionsInfo = Calendar.getDimensionsInfo;
        this._model = calendarModel;
    }
    Calendar.getDimensionsInfo = function() {
        return [
            {
                name: "time",
                type: "time"
            },
            "value"
        ];
    };
    Calendar.prototype.getRangeInfo = function() {
        return this._rangeInfo;
    };
    Calendar.prototype.getModel = function() {
        return this._model;
    };
    Calendar.prototype.getRect = function() {
        return this._rect;
    };
    Calendar.prototype.getCellWidth = function() {
        return this._sw;
    };
    Calendar.prototype.getCellHeight = function() {
        return this._sh;
    };
    Calendar.prototype.getOrient = function() {
        return this._orient;
    };
    /**
   * getFirstDayOfWeek
   *
   * @example
   *     0 : start at Sunday
   *     1 : start at Monday
   *
   * @return {number}
   */ Calendar.prototype.getFirstDayOfWeek = function() {
        return this._firstDayOfWeek;
    };
    /**
   * get date info
   * }
   */ Calendar.prototype.getDateInfo = function(date) {
        date = $cfc1f3b422a3185f$export$6b862160d295c8e(date);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        var mStr = m < 10 ? "0" + m : "" + m;
        var d = date.getDate();
        var dStr = d < 10 ? "0" + d : "" + d;
        var day = date.getDay();
        day = Math.abs((day + 7 - this.getFirstDayOfWeek()) % 7);
        return {
            y: y + "",
            m: mStr,
            d: dStr,
            day: day,
            time: date.getTime(),
            formatedDate: y + "-" + mStr + "-" + dStr,
            date: date
        };
    };
    Calendar.prototype.getNextNDay = function(date, n) {
        n = n || 0;
        if (n === 0) return this.getDateInfo(date);
        date = new Date(this.getDateInfo(date).time);
        date.setDate(date.getDate() + n);
        return this.getDateInfo(date);
    };
    Calendar.prototype.update = function(ecModel, api) {
        this._firstDayOfWeek = +this._model.getModel("dayLabel").get("firstDay");
        this._orient = this._model.get("orient");
        this._lineWidth = this._model.getModel("itemStyle").getItemStyle().lineWidth || 0;
        this._rangeInfo = this._getRangeInfo(this._initRangeOption());
        var weeks = this._rangeInfo.weeks || 1;
        var whNames = [
            "width",
            "height"
        ];
        var cellSize = this._model.getCellSize().slice();
        var layoutParams = this._model.getBoxLayoutParams();
        var cellNumbers = this._orient === "horizontal" ? [
            weeks,
            7
        ] : [
            7,
            weeks
        ];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            0,
            1
        ], function(idx) {
            if (cellSizeSpecified(cellSize, idx)) layoutParams[whNames[idx]] = cellSize[idx] * cellNumbers[idx];
        });
        var whGlobal = {
            width: api.getWidth(),
            height: api.getHeight()
        };
        var calendarRect = this._rect = $93b9bc7f22ac7369$export$4517a5ca639a7293(layoutParams, whGlobal);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            0,
            1
        ], function(idx) {
            if (!cellSizeSpecified(cellSize, idx)) cellSize[idx] = calendarRect[whNames[idx]] / cellNumbers[idx];
        });
        function cellSizeSpecified(cellSize, idx) {
            return cellSize[idx] != null && cellSize[idx] !== "auto";
        }
        // Has been calculated out number.
        this._sw = cellSize[0];
        this._sh = cellSize[1];
    };
    /**
   * Convert a time data(time, value) item to (x, y) point.
   */ // TODO Clamp of calendar is not same with cartesian coordinate systems.
    // It will return NaN if data exceeds.
    Calendar.prototype.dataToPoint = function(data, clamp) {
        $7a1bd9c2710fea0d$export$43bee75e5e14138e(data) && (data = data[0]);
        clamp == null && (clamp = true);
        var dayInfo = this.getDateInfo(data);
        var range = this._rangeInfo;
        var date = dayInfo.formatedDate;
        // if not in range return [NaN, NaN]
        if (clamp && !(dayInfo.time >= range.start.time && dayInfo.time < range.end.time + $be2279b8e0028cb2$var$PROXIMATE_ONE_DAY)) return [
            NaN,
            NaN
        ];
        var week = dayInfo.day;
        var nthWeek = this._getRangeInfo([
            range.start.time,
            date
        ]).nthWeek;
        if (this._orient === "vertical") return [
            this._rect.x + week * this._sw + this._sw / 2,
            this._rect.y + nthWeek * this._sh + this._sh / 2
        ];
        return [
            this._rect.x + nthWeek * this._sw + this._sw / 2,
            this._rect.y + week * this._sh + this._sh / 2
        ];
    };
    /**
   * Convert a (x, y) point to time data
   */ Calendar.prototype.pointToData = function(point) {
        var date = this.pointToDate(point);
        return date && date.time;
    };
    /**
   * Convert a time date item to (x, y) four point.
   */ Calendar.prototype.dataToRect = function(data, clamp) {
        var point = this.dataToPoint(data, clamp);
        return {
            contentShape: {
                x: point[0] - (this._sw - this._lineWidth) / 2,
                y: point[1] - (this._sh - this._lineWidth) / 2,
                width: this._sw - this._lineWidth,
                height: this._sh - this._lineWidth
            },
            center: point,
            tl: [
                point[0] - this._sw / 2,
                point[1] - this._sh / 2
            ],
            tr: [
                point[0] + this._sw / 2,
                point[1] - this._sh / 2
            ],
            br: [
                point[0] + this._sw / 2,
                point[1] + this._sh / 2
            ],
            bl: [
                point[0] - this._sw / 2,
                point[1] + this._sh / 2
            ]
        };
    };
    /**
   * Convert a (x, y) point to time date
   *
   * @param  {Array} point point
   * @return {Object}       date
   */ Calendar.prototype.pointToDate = function(point) {
        var nthX = Math.floor((point[0] - this._rect.x) / this._sw) + 1;
        var nthY = Math.floor((point[1] - this._rect.y) / this._sh) + 1;
        var range = this._rangeInfo.range;
        if (this._orient === "vertical") return this._getDateByWeeksAndDay(nthY, nthX - 1, range);
        return this._getDateByWeeksAndDay(nthX, nthY - 1, range);
    };
    Calendar.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $be2279b8e0028cb2$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value) : null;
    };
    Calendar.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $be2279b8e0028cb2$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel) : null;
    };
    Calendar.prototype.containPoint = function(point) {
        console.warn("Not implemented.");
        return false;
    };
    /**
   * initRange
   * Normalize to an [start, end] array
   */ Calendar.prototype._initRangeOption = function() {
        var range = this._model.get("range");
        var normalizedRange;
        // Convert [1990] to 1990
        if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(range) && range.length === 1) range = range[0];
        if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(range)) {
            var rangeStr = range.toString();
            // One year.
            if (/^\d{4}$/.test(rangeStr)) normalizedRange = [
                rangeStr + "-01-01",
                rangeStr + "-12-31"
            ];
            // One month
            if (/^\d{4}[\/|-]\d{1,2}$/.test(rangeStr)) {
                var start = this.getDateInfo(rangeStr);
                var firstDay = start.date;
                firstDay.setMonth(firstDay.getMonth() + 1);
                var end = this.getNextNDay(firstDay, -1);
                normalizedRange = [
                    start.formatedDate,
                    end.formatedDate
                ];
            }
            // One day
            if (/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(rangeStr)) normalizedRange = [
                rangeStr,
                rangeStr
            ];
        } else normalizedRange = range;
        if (!normalizedRange) // Not handling it.
        return range;
        var tmp = this._getRangeInfo(normalizedRange);
        if (tmp.start.time > tmp.end.time) normalizedRange.reverse();
        return normalizedRange;
    };
    /**
   * range info
   *
   * @private
   * @param  {Array} range range ['2017-01-01', '2017-07-08']
   *  If range[0] > range[1], they will not be reversed.
   * @return {Object}       obj
   */ Calendar.prototype._getRangeInfo = function(range) {
        var parsedRange = [
            this.getDateInfo(range[0]),
            this.getDateInfo(range[1])
        ];
        var reversed;
        if (parsedRange[0].time > parsedRange[1].time) {
            reversed = true;
            parsedRange.reverse();
        }
        var allDay = Math.floor(parsedRange[1].time / $be2279b8e0028cb2$var$PROXIMATE_ONE_DAY) - Math.floor(parsedRange[0].time / $be2279b8e0028cb2$var$PROXIMATE_ONE_DAY) + 1;
        // Consider case1 (#11677 #10430):
        // Set the system timezone as "UK", set the range to `['2016-07-01', '2016-12-31']`
        // Consider case2:
        // Firstly set system timezone as "Time Zone: America/Toronto",
        // ```
        // let first = new Date(1478412000000 - 3600 * 1000 * 2.5);
        // let second = new Date(1478412000000);
        // let allDays = Math.floor(second / ONE_DAY) - Math.floor(first / ONE_DAY) + 1;
        // ```
        // will get wrong result because of DST. So we should fix it.
        var date = new Date(parsedRange[0].time);
        var startDateNum = date.getDate();
        var endDateNum = parsedRange[1].date.getDate();
        date.setDate(startDateNum + allDay - 1);
        // The bias can not over a month, so just compare date.
        var dateNum = date.getDate();
        if (dateNum !== endDateNum) {
            var sign = date.getTime() - parsedRange[1].time > 0 ? 1 : -1;
            while((dateNum = date.getDate()) !== endDateNum && (date.getTime() - parsedRange[1].time) * sign > 0){
                allDay -= sign;
                date.setDate(dateNum - sign);
            }
        }
        var weeks = Math.floor((allDay + parsedRange[0].day + 6) / 7);
        var nthWeek = reversed ? -weeks + 1 : weeks - 1;
        reversed && parsedRange.reverse();
        return {
            range: [
                parsedRange[0].formatedDate,
                parsedRange[1].formatedDate
            ],
            start: parsedRange[0],
            end: parsedRange[1],
            allDay: allDay,
            weeks: weeks,
            // From 0.
            nthWeek: nthWeek,
            fweek: parsedRange[0].day,
            lweek: parsedRange[1].day
        };
    };
    /**
   * get date by nthWeeks and week day in range
   *
   * @private
   * @param  {number} nthWeek the week
   * @param  {number} day   the week day
   * @param  {Array} range [d1, d2]
   * @return {Object}
   */ Calendar.prototype._getDateByWeeksAndDay = function(nthWeek, day, range) {
        var rangeInfo = this._getRangeInfo(range);
        if (nthWeek > rangeInfo.weeks || nthWeek === 0 && day < rangeInfo.fweek || nthWeek === rangeInfo.weeks && day > rangeInfo.lweek) return null;
        var nthDay = (nthWeek - 1) * 7 - rangeInfo.fweek + day;
        var date = new Date(rangeInfo.start.time);
        date.setDate(+rangeInfo.start.d + nthDay);
        return this.getDateInfo(date);
    };
    Calendar.create = function(ecModel, api) {
        var calendarList = [];
        ecModel.eachComponent("calendar", function(calendarModel) {
            var calendar = new Calendar(calendarModel, ecModel, api);
            calendarList.push(calendar);
            calendarModel.coordinateSystem = calendar;
        });
        ecModel.eachSeries(function(calendarSeries) {
            if (calendarSeries.get("coordinateSystem") === "calendar") // Inject coordinate system
            calendarSeries.coordinateSystem = calendarList[calendarSeries.get("calendarIndex") || 0];
        });
        return calendarList;
    };
    Calendar.dimensions = [
        "time",
        "value"
    ];
    return Calendar;
}();
function $be2279b8e0028cb2$var$getCoordSys(finder) {
    var calendarModel = finder.calendarModel;
    var seriesModel = finder.seriesModel;
    var coordSys = calendarModel ? calendarModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
    return coordSys;
}
var $be2279b8e0028cb2$export$2e2bcd8739ae039 = $be2279b8e0028cb2$var$Calendar;


function $c1c3b68ff9dcc3e7$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $795d2d92b1d02c70$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $e6b2dc17a91ad4af$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("calendar", (0, $be2279b8e0028cb2$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $afb70cea6fec4fe0$export$83e718f1c3c9edae = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(DatasetModel, _super);
    function DatasetModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "dataset";
        return _this;
    }
    DatasetModel.prototype.init = function(option, parentModel, ecModel) {
        _super.prototype.init.call(this, option, parentModel, ecModel);
        this._sourceManager = new (0, $1c87d176de397e7e$export$af4db9ec7e200ea2)(this);
        (0, $1c87d176de397e7e$export$9451f4e9047441ec)(this);
    };
    DatasetModel.prototype.mergeOption = function(newOption, ecModel) {
        _super.prototype.mergeOption.call(this, newOption, ecModel);
        (0, $1c87d176de397e7e$export$9451f4e9047441ec)(this);
    };
    DatasetModel.prototype.optionUpdated = function() {
        this._sourceManager.dirty();
    };
    DatasetModel.prototype.getSourceManager = function() {
        return this._sourceManager;
    };
    DatasetModel.type = "dataset";
    DatasetModel.defaultOption = {
        seriesLayoutBy: (0, $cab29724515ce2b8$export$7b3f3c6551b4949b)
    };
    return DatasetModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $afb70cea6fec4fe0$var$DatasetView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(DatasetView, _super);
    function DatasetView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "dataset";
        return _this;
    }
    DatasetView.type = "dataset";
    return DatasetView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $afb70cea6fec4fe0$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel($afb70cea6fec4fe0$export$83e718f1c3c9edae);
    registers.registerComponentView($afb70cea6fec4fe0$var$DatasetView);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $554cb472ba0e05d3$export$f25521e726513e83 = [
    "x",
    "y",
    "radius",
    "angle",
    "single"
];
// Supported coords.
// FIXME: polar has been broken (but rarely used).
var $554cb472ba0e05d3$var$SERIES_COORDS = [
    "cartesian2d",
    "polar",
    "singleAxis"
];
function $554cb472ba0e05d3$export$2d449d4adc0d2cfc(seriesModel) {
    var coordType = seriesModel.get("coordinateSystem");
    return (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($554cb472ba0e05d3$var$SERIES_COORDS, coordType) >= 0;
}
function $554cb472ba0e05d3$export$90855f7219399082(axisDim) {
    return axisDim + "Axis";
}
function $554cb472ba0e05d3$export$f9c16e110bf1e902(axisDim) {
    return axisDim + "AxisIndex";
}
function $554cb472ba0e05d3$export$fa8714b2310ddff9(axisDim) {
    return axisDim + "AxisId";
}
function $554cb472ba0e05d3$export$9e00b6c2b8b2e9a7(ecModel, payload) {
    // Key: `DataZoomAxisDimension`
    var axisRecords = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var effectedModels = [];
    // Key: uid of dataZoomModel
    var effectedModelMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    // Find the dataZooms specified by payload.
    ecModel.eachComponent({
        mainType: "dataZoom",
        query: payload
    }, function(dataZoomModel) {
        if (!effectedModelMap.get(dataZoomModel.uid)) addToEffected(dataZoomModel);
    });
    // Start from the given dataZoomModels, travel the graph to find
    // all of the linked dataZoom models.
    var foundNewLink;
    do {
        foundNewLink = false;
        ecModel.eachComponent("dataZoom", processSingle);
    }while (foundNewLink);
    function processSingle(dataZoomModel) {
        if (!effectedModelMap.get(dataZoomModel.uid) && isLinked(dataZoomModel)) {
            addToEffected(dataZoomModel);
            foundNewLink = true;
        }
    }
    function addToEffected(dataZoom) {
        effectedModelMap.set(dataZoom.uid, true);
        effectedModels.push(dataZoom);
        markAxisControlled(dataZoom);
    }
    function isLinked(dataZoomModel) {
        var isLink = false;
        dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
            var axisIdxArr = axisRecords.get(axisDim);
            if (axisIdxArr && axisIdxArr[axisIndex]) isLink = true;
        });
        return isLink;
    }
    function markAxisControlled(dataZoomModel) {
        dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
            (axisRecords.get(axisDim) || axisRecords.set(axisDim, []))[axisIndex] = true;
        });
    }
    return effectedModels;
}
function $554cb472ba0e05d3$export$b41173dee9da195b(dataZoomModel) {
    var ecModel = dataZoomModel.ecModel;
    var coordSysInfoWrap = {
        infoList: [],
        infoMap: (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)()
    };
    dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
        var axisModel = ecModel.getComponent($554cb472ba0e05d3$export$90855f7219399082(axisDim), axisIndex);
        if (!axisModel) return;
        var coordSysModel = axisModel.getCoordSysModel();
        if (!coordSysModel) return;
        var coordSysUid = coordSysModel.uid;
        var coordSysInfo = coordSysInfoWrap.infoMap.get(coordSysUid);
        if (!coordSysInfo) {
            coordSysInfo = {
                model: coordSysModel,
                axisModels: []
            };
            coordSysInfoWrap.infoList.push(coordSysInfo);
            coordSysInfoWrap.infoMap.set(coordSysUid, coordSysInfo);
        }
        coordSysInfo.axisModels.push(axisModel);
    });
    return coordSysInfoWrap;
}



var $41d57478d16bff21$var$DataZoomAxisInfo = /** @class */ function() {
    function DataZoomAxisInfo() {
        this.indexList = [];
        this.indexMap = [];
    }
    DataZoomAxisInfo.prototype.add = function(axisCmptIdx) {
        // Remove duplication.
        if (!this.indexMap[axisCmptIdx]) {
            this.indexList.push(axisCmptIdx);
            this.indexMap[axisCmptIdx] = true;
        }
    };
    return DataZoomAxisInfo;
}();
var $41d57478d16bff21$var$DataZoomModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(DataZoomModel, _super);
    function DataZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = DataZoomModel.type;
        _this._autoThrottle = true;
        _this._noTarget = true;
        /**
     * It is `[rangeModeForMin, rangeModeForMax]`.
     * The optional values for `rangeMode`:
     * + `'value'` mode: the axis extent will always be determined by
     *     `dataZoom.startValue` and `dataZoom.endValue`, despite
     *     how data like and how `axis.min` and `axis.max` are.
     * + `'percent'` mode: `100` represents 100% of the `[dMin, dMax]`,
     *     where `dMin` is `axis.min` if `axis.min` specified, otherwise `data.extent[0]`,
     *     and `dMax` is `axis.max` if `axis.max` specified, otherwise `data.extent[1]`.
     *     Axis extent will be determined by the result of the percent of `[dMin, dMax]`.
     *
     * For example, when users are using dynamic data (update data periodically via `setOption`),
     * if in `'value`' mode, the window will be kept in a fixed value range despite how
     * data are appended, while if in `'percent'` mode, whe window range will be changed alone with
     * the appended data (suppose `axis.min` and `axis.max` are not specified).
     */ _this._rangePropMode = [
            "percent",
            "percent"
        ];
        return _this;
    }
    DataZoomModel.prototype.init = function(option, parentModel, ecModel) {
        var inputRawOption = $41d57478d16bff21$var$retrieveRawOption(option);
        /**
     * Suppose a "main process" start at the point that model prepared (that is,
     * model initialized or merged or method called in `action`).
     * We should keep the `main process` idempotent, that is, given a set of values
     * on `option`, we get the same result.
     *
     * But sometimes, values on `option` will be updated for providing users
     * a "final calculated value" (`dataZoomProcessor` will do that). Those value
     * should not be the base/input of the `main process`.
     *
     * So in that case we should save and keep the input of the `main process`
     * separately, called `settledOption`.
     *
     * For example, consider the case:
     * (Step_1) brush zoom the grid by `toolbox.dataZoom`,
     *     where the original input `option.startValue`, `option.endValue` are earsed by
     *     calculated value.
     * (Step)2) click the legend to hide and show a series,
     *     where the new range is calculated by the earsed `startValue` and `endValue`,
     *     which brings incorrect result.
     */ this.settledOption = inputRawOption;
        this.mergeDefaultAndTheme(option, ecModel);
        this._doInit(inputRawOption);
    };
    DataZoomModel.prototype.mergeOption = function(newOption) {
        var inputRawOption = $41d57478d16bff21$var$retrieveRawOption(newOption);
        // FIX #2591
        (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(this.option, newOption, true);
        (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(this.settledOption, inputRawOption, true);
        this._doInit(inputRawOption);
    };
    DataZoomModel.prototype._doInit = function(inputRawOption) {
        var thisOption = this.option;
        this._setDefaultThrottle(inputRawOption);
        this._updateRangeUse(inputRawOption);
        var settledOption = this.settledOption;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            [
                "start",
                "startValue"
            ],
            [
                "end",
                "endValue"
            ]
        ], function(names, index) {
            // start/end has higher priority over startValue/endValue if they
            // both set, but we should make chart.setOption({endValue: 1000})
            // effective, rather than chart.setOption({endValue: 1000, end: null}).
            if (this._rangePropMode[index] === "value") thisOption[names[0]] = settledOption[names[0]] = null;
        // Otherwise do nothing and use the merge result.
        }, this);
        this._resetTarget();
    };
    DataZoomModel.prototype._resetTarget = function() {
        var optionOrient = this.get("orient", true);
        var targetAxisIndexMap = this._targetAxisInfoMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        var hasAxisSpecified = this._fillSpecifiedTargetAxis(targetAxisIndexMap);
        if (hasAxisSpecified) this._orient = optionOrient || this._makeAutoOrientByTargetAxis();
        else {
            this._orient = optionOrient || "horizontal";
            this._fillAutoTargetAxisByOrient(targetAxisIndexMap, this._orient);
        }
        this._noTarget = true;
        targetAxisIndexMap.each(function(axisInfo) {
            if (axisInfo.indexList.length) this._noTarget = false;
        }, this);
    };
    DataZoomModel.prototype._fillSpecifiedTargetAxis = function(targetAxisIndexMap) {
        var hasAxisSpecified = false;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $554cb472ba0e05d3$export$f25521e726513e83), function(axisDim) {
            var refering = this.getReferringComponents((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), (0, $76d619f648247e6d$export$48d598924ce4892c));
            // When user set axisIndex as a empty array, we think that user specify axisIndex
            // but do not want use auto mode. Because empty array may be encountered when
            // some error occurred.
            if (!refering.specified) return;
            hasAxisSpecified = true;
            var axisInfo = new $41d57478d16bff21$var$DataZoomAxisInfo();
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(refering.models, function(axisModel) {
                axisInfo.add(axisModel.componentIndex);
            });
            targetAxisIndexMap.set(axisDim, axisInfo);
        }, this);
        return hasAxisSpecified;
    };
    DataZoomModel.prototype._fillAutoTargetAxisByOrient = function(targetAxisIndexMap, orient) {
        var ecModel = this.ecModel;
        var needAuto = true;
        // Find axis that parallel to dataZoom as default.
        if (needAuto) {
            var axisDim = orient === "vertical" ? "y" : "x";
            var axisModels = ecModel.findComponents({
                mainType: axisDim + "Axis"
            });
            setParallelAxis(axisModels, axisDim);
        }
        // Find axis that parallel to dataZoom as default.
        if (needAuto) {
            var axisModels = ecModel.findComponents({
                mainType: "singleAxis",
                filter: function(axisModel) {
                    return axisModel.get("orient", true) === orient;
                }
            });
            setParallelAxis(axisModels, "single");
        }
        function setParallelAxis(axisModels, axisDim) {
            // At least use the first parallel axis as the target axis.
            var axisModel = axisModels[0];
            if (!axisModel) return;
            var axisInfo = new $41d57478d16bff21$var$DataZoomAxisInfo();
            axisInfo.add(axisModel.componentIndex);
            targetAxisIndexMap.set(axisDim, axisInfo);
            needAuto = false;
            // Find parallel axes in the same grid.
            if (axisDim === "x" || axisDim === "y") {
                var gridModel_1 = axisModel.getReferringComponents("grid", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
                gridModel_1 && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisModels, function(axModel) {
                    if (axisModel.componentIndex !== axModel.componentIndex && gridModel_1 === axModel.getReferringComponents("grid", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0]) axisInfo.add(axModel.componentIndex);
                });
            }
        }
        if (needAuto) // If no parallel axis, find the first category axis as default. (Also consider polar).
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $554cb472ba0e05d3$export$f25521e726513e83), function(axisDim) {
            if (!needAuto) return;
            var axisModels = ecModel.findComponents({
                mainType: (0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim),
                filter: function(axisModel) {
                    return axisModel.get("type", true) === "category";
                }
            });
            if (axisModels[0]) {
                var axisInfo = new $41d57478d16bff21$var$DataZoomAxisInfo();
                axisInfo.add(axisModels[0].componentIndex);
                targetAxisIndexMap.set(axisDim, axisInfo);
                needAuto = false;
            }
        }, this);
    };
    DataZoomModel.prototype._makeAutoOrientByTargetAxis = function() {
        var dim;
        // Find the first axis
        this.eachTargetAxis(function(axisDim) {
            !dim && (dim = axisDim);
        }, this);
        return dim === "y" ? "vertical" : "horizontal";
    };
    DataZoomModel.prototype._setDefaultThrottle = function(inputRawOption) {
        // When first time user set throttle, auto throttle ends.
        if (inputRawOption.hasOwnProperty("throttle")) this._autoThrottle = false;
        if (this._autoThrottle) {
            var globalOption = this.ecModel.option;
            this.option.throttle = globalOption.animation && globalOption.animationDurationUpdate > 0 ? 100 : 20;
        }
    };
    DataZoomModel.prototype._updateRangeUse = function(inputRawOption) {
        var rangePropMode = this._rangePropMode;
        var rangeModeInOption = this.get("rangeMode");
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            [
                "start",
                "startValue"
            ],
            [
                "end",
                "endValue"
            ]
        ], function(names, index) {
            var percentSpecified = inputRawOption[names[0]] != null;
            var valueSpecified = inputRawOption[names[1]] != null;
            if (percentSpecified && !valueSpecified) rangePropMode[index] = "percent";
            else if (!percentSpecified && valueSpecified) rangePropMode[index] = "value";
            else if (rangeModeInOption) rangePropMode[index] = rangeModeInOption[index];
            else if (percentSpecified) // percentSpecified && valueSpecified
            rangePropMode[index] = "percent";
        // else remain its original setting.
        });
    };
    DataZoomModel.prototype.noTarget = function() {
        return this._noTarget;
    };
    DataZoomModel.prototype.getFirstTargetAxisModel = function() {
        var firstAxisModel;
        this.eachTargetAxis(function(axisDim, axisIndex) {
            if (firstAxisModel == null) firstAxisModel = this.ecModel.getComponent((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), axisIndex);
        }, this);
        return firstAxisModel;
    };
    /**
   * @param {Function} callback param: axisModel, dimNames, axisIndex, dataZoomModel, ecModel
   */ DataZoomModel.prototype.eachTargetAxis = function(callback, context) {
        this._targetAxisInfoMap.each(function(axisInfo, axisDim) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisInfo.indexList, function(axisIndex) {
                callback.call(context, axisDim, axisIndex);
            });
        });
    };
    /**
   * @return If not found, return null/undefined.
   */ DataZoomModel.prototype.getAxisProxy = function(axisDim, axisIndex) {
        var axisModel = this.getAxisModel(axisDim, axisIndex);
        if (axisModel) return axisModel.__dzAxisProxy;
    };
    /**
   * @return If not found, return null/undefined.
   */ DataZoomModel.prototype.getAxisModel = function(axisDim, axisIndex) {
        var axisInfo = this._targetAxisInfoMap.get(axisDim);
        if (axisInfo && axisInfo.indexMap[axisIndex]) return this.ecModel.getComponent((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), axisIndex);
    };
    /**
   * If not specified, set to undefined.
   */ DataZoomModel.prototype.setRawRange = function(opt) {
        var thisOption = this.option;
        var settledOption = this.settledOption;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            [
                "start",
                "startValue"
            ],
            [
                "end",
                "endValue"
            ]
        ], function(names) {
            // Consider the pair <start, startValue>:
            // If one has value and the other one is `null/undefined`, we both set them
            // to `settledOption`. This strategy enables the feature to clear the original
            // value in `settledOption` to `null/undefined`.
            // But if both of them are `null/undefined`, we do not set them to `settledOption`
            // and keep `settledOption` with the original value. This strategy enables users to
            // only set <end or endValue> but not set <start or startValue> when calling
            // `dispatchAction`.
            // The pair <end, endValue> is treated in the same way.
            if (opt[names[0]] != null || opt[names[1]] != null) {
                thisOption[names[0]] = settledOption[names[0]] = opt[names[0]];
                thisOption[names[1]] = settledOption[names[1]] = opt[names[1]];
            }
        }, this);
        this._updateRangeUse(opt);
    };
    DataZoomModel.prototype.setCalculatedRange = function(opt) {
        var option = this.option;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            "start",
            "startValue",
            "end",
            "endValue"
        ], function(name) {
            option[name] = opt[name];
        });
    };
    DataZoomModel.prototype.getPercentRange = function() {
        var axisProxy = this.findRepresentativeAxisProxy();
        if (axisProxy) return axisProxy.getDataPercentWindow();
    };
    /**
   * For example, chart.getModel().getComponent('dataZoom').getValueRange('y', 0);
   *
   * @return [startValue, endValue] value can only be '-' or finite number.
   */ DataZoomModel.prototype.getValueRange = function(axisDim, axisIndex) {
        if (axisDim == null && axisIndex == null) {
            var axisProxy = this.findRepresentativeAxisProxy();
            if (axisProxy) return axisProxy.getDataValueWindow();
        } else return this.getAxisProxy(axisDim, axisIndex).getDataValueWindow();
    };
    /**
   * @param axisModel If axisModel given, find axisProxy
   *      corresponding to the axisModel
   */ DataZoomModel.prototype.findRepresentativeAxisProxy = function(axisModel) {
        if (axisModel) return axisModel.__dzAxisProxy;
        // Find the first hosted axisProxy
        var firstProxy;
        var axisDimList = this._targetAxisInfoMap.keys();
        for(var i = 0; i < axisDimList.length; i++){
            var axisDim = axisDimList[i];
            var axisInfo = this._targetAxisInfoMap.get(axisDim);
            for(var j = 0; j < axisInfo.indexList.length; j++){
                var proxy = this.getAxisProxy(axisDim, axisInfo.indexList[j]);
                if (proxy.hostedBy(this)) return proxy;
                if (!firstProxy) firstProxy = proxy;
            }
        }
        // If no hosted proxy found, still need to return a proxy.
        // This case always happens in toolbox dataZoom, where axes are all hosted by
        // other dataZooms.
        return firstProxy;
    };
    DataZoomModel.prototype.getRangePropMode = function() {
        return this._rangePropMode.slice();
    };
    DataZoomModel.prototype.getOrient = function() {
        return this._orient;
    };
    DataZoomModel.type = "dataZoom";
    DataZoomModel.dependencies = [
        "xAxis",
        "yAxis",
        "radiusAxis",
        "angleAxis",
        "singleAxis",
        "series",
        "toolbox"
    ];
    DataZoomModel.defaultOption = {
        // zlevel: 0,
        z: 4,
        filterMode: "filter",
        start: 0,
        end: 100
    };
    return DataZoomModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
/**
 * Retrieve those raw params from option, which will be cached separately,
 * because they will be overwritten by normalized/calculated values in the main
 * process.
 */ function $41d57478d16bff21$var$retrieveRawOption(option) {
    var ret = {};
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "start",
        "end",
        "startValue",
        "endValue",
        "throttle"
    ], function(name) {
        option.hasOwnProperty(name) && (ret[name] = option[name]);
    });
    return ret;
}
var $41d57478d16bff21$export$2e2bcd8739ae039 = $41d57478d16bff21$var$DataZoomModel;



var $6cccca1a1040a7a1$var$InsideZoomModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(InsideZoomModel, _super);
    function InsideZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = InsideZoomModel.type;
        return _this;
    }
    InsideZoomModel.type = "dataZoom.inside";
    InsideZoomModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $41d57478d16bff21$export$2e2bcd8739ae039).defaultOption, {
        disabled: false,
        zoomLock: false,
        zoomOnMouseWheel: true,
        moveOnMouseMove: true,
        moveOnMouseWheel: false,
        preventDefaultMouseMove: true
    });
    return InsideZoomModel;
}((0, $41d57478d16bff21$export$2e2bcd8739ae039));
var $6cccca1a1040a7a1$export$2e2bcd8739ae039 = $6cccca1a1040a7a1$var$InsideZoomModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $80d6a03162f25654$var$DataZoomView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(DataZoomView, _super);
    function DataZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = DataZoomView.type;
        return _this;
    }
    DataZoomView.prototype.render = function(dataZoomModel, ecModel, api, payload) {
        this.dataZoomModel = dataZoomModel;
        this.ecModel = ecModel;
        this.api = api;
    };
    DataZoomView.type = "dataZoom";
    return DataZoomView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $80d6a03162f25654$export$2e2bcd8739ae039 = $80d6a03162f25654$var$DataZoomView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Only create one roam controller for each coordinate system.
// one roam controller might be refered by two inside data zoom
// components (for example, one for x and one for y). When user
// pan or zoom, only dispatch one action for those data zoom
// components.





var $6379ab7b9c3fbfb6$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $6379ab7b9c3fbfb6$export$c499fdc26107c565(api, dataZoomModel, getRange) {
    $6379ab7b9c3fbfb6$var$inner(api).coordSysRecordMap.each(function(coordSysRecord) {
        var dzInfo = coordSysRecord.dataZoomInfoMap.get(dataZoomModel.uid);
        if (dzInfo) dzInfo.getRange = getRange;
    });
}
function $6379ab7b9c3fbfb6$export$d074fdbbb2bf218c(api, dataZoomModel) {
    var coordSysRecordMap = $6379ab7b9c3fbfb6$var$inner(api).coordSysRecordMap;
    var coordSysKeyArr = coordSysRecordMap.keys();
    for(var i = 0; i < coordSysKeyArr.length; i++){
        var coordSysKey = coordSysKeyArr[i];
        var coordSysRecord = coordSysRecordMap.get(coordSysKey);
        var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap;
        if (dataZoomInfoMap) {
            var dzUid = dataZoomModel.uid;
            var dzInfo = dataZoomInfoMap.get(dzUid);
            if (dzInfo) {
                dataZoomInfoMap.removeKey(dzUid);
                if (!dataZoomInfoMap.keys().length) $6379ab7b9c3fbfb6$var$disposeCoordSysRecord(coordSysRecordMap, coordSysRecord);
            }
        }
    }
}
function $6379ab7b9c3fbfb6$var$disposeCoordSysRecord(coordSysRecordMap, coordSysRecord) {
    if (coordSysRecord) {
        coordSysRecordMap.removeKey(coordSysRecord.model.uid);
        var controller = coordSysRecord.controller;
        controller && controller.dispose();
    }
}
function $6379ab7b9c3fbfb6$var$createCoordSysRecord(api, coordSysModel) {
    // These init props will never change after record created.
    var coordSysRecord = {
        model: coordSysModel,
        containsPoint: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6379ab7b9c3fbfb6$var$containsPoint, coordSysModel),
        dispatchAction: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($6379ab7b9c3fbfb6$var$dispatchAction, api),
        dataZoomInfoMap: null,
        controller: null
    };
    // Must not do anything depends on coordSysRecord outside the event handler here,
    // because coordSysRecord not completed yet.
    var controller = coordSysRecord.controller = new (0, $15927f329deeab51$export$2e2bcd8739ae039)(api.getZr());
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "pan",
        "zoom",
        "scrollMove"
    ], function(eventName) {
        controller.on(eventName, function(event) {
            var batch = [];
            coordSysRecord.dataZoomInfoMap.each(function(dzInfo) {
                // Check whether the behaviors (zoomOnMouseWheel, moveOnMouseMove,
                // moveOnMouseWheel, ...) enabled.
                if (!event.isAvailableBehavior(dzInfo.model.option)) return;
                var method = (dzInfo.getRange || {})[eventName];
                var range = method && method(dzInfo.dzReferCoordSysInfo, coordSysRecord.model.mainType, coordSysRecord.controller, event);
                !dzInfo.model.get("disabled", true) && range && batch.push({
                    dataZoomId: dzInfo.model.id,
                    start: range[0],
                    end: range[1]
                });
            });
            batch.length && coordSysRecord.dispatchAction(batch);
        });
    });
    return coordSysRecord;
}
/**
 * This action will be throttled.
 */ function $6379ab7b9c3fbfb6$var$dispatchAction(api, batch) {
    if (!api.isDisposed()) api.dispatchAction({
        type: "dataZoom",
        animation: {
            easing: "cubicOut",
            duration: 100
        },
        batch: batch
    });
}
function $6379ab7b9c3fbfb6$var$containsPoint(coordSysModel, e, x, y) {
    return coordSysModel.coordinateSystem.containPoint([
        x,
        y
    ]);
}
/**
 * Merge roamController settings when multiple dataZooms share one roamController.
 */ function $6379ab7b9c3fbfb6$var$mergeControllerParams(dataZoomInfoMap) {
    var controlType;
    // DO NOT use reserved word (true, false, undefined) as key literally. Even if encapsulated
    // as string, it is probably revert to reserved word by compress tool. See #7411.
    var prefix = "type_";
    var typePriority = {
        "type_true": 2,
        "type_move": 1,
        "type_false": 0,
        "type_undefined": -1
    };
    var preventDefaultMouseMove = true;
    dataZoomInfoMap.each(function(dataZoomInfo) {
        var dataZoomModel = dataZoomInfo.model;
        var oneType = dataZoomModel.get("disabled", true) ? false : dataZoomModel.get("zoomLock", true) ? "move" : true;
        if (typePriority[prefix + oneType] > typePriority[prefix + controlType]) controlType = oneType;
        // Prevent default move event by default. If one false, do not prevent. Otherwise
        // users may be confused why it does not work when multiple insideZooms exist.
        preventDefaultMouseMove = preventDefaultMouseMove && dataZoomModel.get("preventDefaultMouseMove", true);
    });
    return {
        controlType: controlType,
        opt: {
            // RoamController will enable all of these functionalities,
            // and the final behavior is determined by its event listener
            // provided by each inside zoom.
            zoomOnMouseWheel: true,
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
            preventDefaultMouseMove: !!preventDefaultMouseMove
        }
    };
}
function $6379ab7b9c3fbfb6$export$f3632ddafc9ea51e(registers) {
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.FILTER, function(ecModel, api) {
        var apiInner = $6379ab7b9c3fbfb6$var$inner(api);
        var coordSysRecordMap = apiInner.coordSysRecordMap || (apiInner.coordSysRecordMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)());
        coordSysRecordMap.each(function(coordSysRecord) {
            // `coordSysRecordMap` always exists (because it holds the `roam controller`, which should
            // better not re-create each time), but clear `dataZoomInfoMap` each round of the workflow.
            coordSysRecord.dataZoomInfoMap = null;
        });
        ecModel.eachComponent({
            mainType: "dataZoom",
            subType: "inside"
        }, function(dataZoomModel) {
            var dzReferCoordSysWrap = (0, $554cb472ba0e05d3$export$b41173dee9da195b)(dataZoomModel);
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dzReferCoordSysWrap.infoList, function(dzCoordSysInfo) {
                var coordSysUid = dzCoordSysInfo.model.uid;
                var coordSysRecord = coordSysRecordMap.get(coordSysUid) || coordSysRecordMap.set(coordSysUid, $6379ab7b9c3fbfb6$var$createCoordSysRecord(api, dzCoordSysInfo.model));
                var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap || (coordSysRecord.dataZoomInfoMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)());
                // Notice these props might be changed each time for a single dataZoomModel.
                dataZoomInfoMap.set(dataZoomModel.uid, {
                    dzReferCoordSysInfo: dzCoordSysInfo,
                    model: dataZoomModel,
                    getRange: null
                });
            });
        });
        // (1) Merge dataZoom settings for each coord sys and set to the roam controller.
        // (2) Clear coord sys if not refered by any dataZoom.
        coordSysRecordMap.each(function(coordSysRecord) {
            var controller = coordSysRecord.controller;
            var firstDzInfo;
            var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap;
            if (dataZoomInfoMap) {
                var firstDzKey = dataZoomInfoMap.keys()[0];
                if (firstDzKey != null) firstDzInfo = dataZoomInfoMap.get(firstDzKey);
            }
            if (!firstDzInfo) {
                $6379ab7b9c3fbfb6$var$disposeCoordSysRecord(coordSysRecordMap, coordSysRecord);
                return;
            }
            var controllerParams = $6379ab7b9c3fbfb6$var$mergeControllerParams(dataZoomInfoMap);
            controller.enable(controllerParams.controlType, controllerParams.opt);
            controller.setPointerChecker(coordSysRecord.containsPoint);
            $c98659a9437a3d2e$export$958e3e1a02eac4b6(coordSysRecord, "dispatchAction", firstDzInfo.model.get("throttle", true), "fixRate");
        });
    });
}



var $ad4d16a462c12aaf$var$InsideZoomView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(InsideZoomView, _super);
    function InsideZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = "dataZoom.inside";
        return _this;
    }
    InsideZoomView.prototype.render = function(dataZoomModel, ecModel, api) {
        _super.prototype.render.apply(this, arguments);
        if (dataZoomModel.noTarget()) {
            this._clear();
            return;
        }
        // Hence the `throttle` util ensures to preserve command order,
        // here simply updating range all the time will not cause missing
        // any of the the roam change.
        this.range = dataZoomModel.getPercentRange();
        // Reset controllers.
        $6379ab7b9c3fbfb6$export$c499fdc26107c565(api, dataZoomModel, {
            pan: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($ad4d16a462c12aaf$var$getRangeHandlers.pan, this),
            zoom: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($ad4d16a462c12aaf$var$getRangeHandlers.zoom, this),
            scrollMove: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)($ad4d16a462c12aaf$var$getRangeHandlers.scrollMove, this)
        });
    };
    InsideZoomView.prototype.dispose = function() {
        this._clear();
        _super.prototype.dispose.apply(this, arguments);
    };
    InsideZoomView.prototype._clear = function() {
        $6379ab7b9c3fbfb6$export$d074fdbbb2bf218c(this.api, this.dataZoomModel);
        this.range = null;
    };
    InsideZoomView.type = "dataZoom.inside";
    return InsideZoomView;
}((0, $80d6a03162f25654$export$2e2bcd8739ae039));
var $ad4d16a462c12aaf$var$getRangeHandlers = {
    zoom: function(coordSysInfo, coordSysMainType, controller, e) {
        var lastRange = this.range;
        var range = lastRange.slice();
        // Calculate transform by the first axis.
        var axisModel = coordSysInfo.axisModels[0];
        if (!axisModel) return;
        var directionInfo = $ad4d16a462c12aaf$var$getDirectionInfo[coordSysMainType](null, [
            e.originX,
            e.originY
        ], axisModel, controller, coordSysInfo);
        var percentPoint = (directionInfo.signal > 0 ? directionInfo.pixelStart + directionInfo.pixelLength - directionInfo.pixel : directionInfo.pixel - directionInfo.pixelStart) / directionInfo.pixelLength * (range[1] - range[0]) + range[0];
        var scale = Math.max(1 / e.scale, 0);
        range[0] = (range[0] - percentPoint) * scale + percentPoint;
        range[1] = (range[1] - percentPoint) * scale + percentPoint;
        // Restrict range.
        var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
        (0, $00a8003b34293330$export$2e2bcd8739ae039)(0, range, [
            0,
            100
        ], 0, minMaxSpan.minSpan, minMaxSpan.maxSpan);
        this.range = range;
        if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) return range;
    },
    pan: $ad4d16a462c12aaf$var$makeMover(function(range, axisModel, coordSysInfo, coordSysMainType, controller, e) {
        var directionInfo = $ad4d16a462c12aaf$var$getDirectionInfo[coordSysMainType]([
            e.oldX,
            e.oldY
        ], [
            e.newX,
            e.newY
        ], axisModel, controller, coordSysInfo);
        return directionInfo.signal * (range[1] - range[0]) * directionInfo.pixel / directionInfo.pixelLength;
    }),
    scrollMove: $ad4d16a462c12aaf$var$makeMover(function(range, axisModel, coordSysInfo, coordSysMainType, controller, e) {
        var directionInfo = $ad4d16a462c12aaf$var$getDirectionInfo[coordSysMainType]([
            0,
            0
        ], [
            e.scrollDelta,
            e.scrollDelta
        ], axisModel, controller, coordSysInfo);
        return directionInfo.signal * (range[1] - range[0]) * e.scrollDelta;
    })
};
function $ad4d16a462c12aaf$var$makeMover(getPercentDelta) {
    return function(coordSysInfo, coordSysMainType, controller, e) {
        var lastRange = this.range;
        var range = lastRange.slice();
        // Calculate transform by the first axis.
        var axisModel = coordSysInfo.axisModels[0];
        if (!axisModel) return;
        var percentDelta = getPercentDelta(range, axisModel, coordSysInfo, coordSysMainType, controller, e);
        (0, $00a8003b34293330$export$2e2bcd8739ae039)(percentDelta, range, [
            0,
            100
        ], "all");
        this.range = range;
        if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) return range;
    };
}
var $ad4d16a462c12aaf$var$getDirectionInfo = {
    grid: function(oldPoint, newPoint, axisModel, controller, coordSysInfo) {
        var axis = axisModel.axis;
        var ret = {};
        var rect = coordSysInfo.model.coordinateSystem.getRect();
        oldPoint = oldPoint || [
            0,
            0
        ];
        if (axis.dim === "x") {
            ret.pixel = newPoint[0] - oldPoint[0];
            ret.pixelLength = rect.width;
            ret.pixelStart = rect.x;
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // axis.dim === 'y'
            ret.pixel = newPoint[1] - oldPoint[1];
            ret.pixelLength = rect.height;
            ret.pixelStart = rect.y;
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    },
    polar: function(oldPoint, newPoint, axisModel, controller, coordSysInfo) {
        var axis = axisModel.axis;
        var ret = {};
        var polar = coordSysInfo.model.coordinateSystem;
        var radiusExtent = polar.getRadiusAxis().getExtent();
        var angleExtent = polar.getAngleAxis().getExtent();
        oldPoint = oldPoint ? polar.pointToCoord(oldPoint) : [
            0,
            0
        ];
        newPoint = polar.pointToCoord(newPoint);
        if (axisModel.mainType === "radiusAxis") {
            ret.pixel = newPoint[0] - oldPoint[0];
            // ret.pixelLength = Math.abs(radiusExtent[1] - radiusExtent[0]);
            // ret.pixelStart = Math.min(radiusExtent[0], radiusExtent[1]);
            ret.pixelLength = radiusExtent[1] - radiusExtent[0];
            ret.pixelStart = radiusExtent[0];
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // 'angleAxis'
            ret.pixel = newPoint[1] - oldPoint[1];
            // ret.pixelLength = Math.abs(angleExtent[1] - angleExtent[0]);
            // ret.pixelStart = Math.min(angleExtent[0], angleExtent[1]);
            ret.pixelLength = angleExtent[1] - angleExtent[0];
            ret.pixelStart = angleExtent[0];
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    },
    singleAxis: function(oldPoint, newPoint, axisModel, controller, coordSysInfo) {
        var axis = axisModel.axis;
        var rect = coordSysInfo.model.coordinateSystem.getRect();
        var ret = {};
        oldPoint = oldPoint || [
            0,
            0
        ];
        if (axis.orient === "horizontal") {
            ret.pixel = newPoint[0] - oldPoint[0];
            ret.pixelLength = rect.width;
            ret.pixelStart = rect.x;
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // 'vertical'
            ret.pixel = newPoint[1] - oldPoint[1];
            ret.pixelLength = rect.height;
            ret.pixelStart = rect.y;
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    }
};
var $ad4d16a462c12aaf$export$2e2bcd8739ae039 = $ad4d16a462c12aaf$var$InsideZoomView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $06639d6035d20694$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $06639d6035d20694$var$asc = $cfc1f3b422a3185f$export$debe6e778e0a6d32;
/**
 * Operate single axis.
 * One axis can only operated by one axis operator.
 * Different dataZoomModels may be defined to operate the same axis.
 * (i.e. 'inside' data zoom and 'slider' data zoom components)
 * So dataZoomModels share one axisProxy in that case.
 */ var $06639d6035d20694$var$AxisProxy = /** @class */ function() {
    function AxisProxy(dimName, axisIndex, dataZoomModel, ecModel) {
        this._dimName = dimName;
        this._axisIndex = axisIndex;
        this.ecModel = ecModel;
        this._dataZoomModel = dataZoomModel;
    // /**
    //  * @readOnly
    //  * @private
    //  */
    // this.hasSeriesStacked;
    }
    /**
   * Whether the axisProxy is hosted by dataZoomModel.
   */ AxisProxy.prototype.hostedBy = function(dataZoomModel) {
        return this._dataZoomModel === dataZoomModel;
    };
    /**
   * @return Value can only be NaN or finite value.
   */ AxisProxy.prototype.getDataValueWindow = function() {
        return this._valueWindow.slice();
    };
    /**
   * @return {Array.<number>}
   */ AxisProxy.prototype.getDataPercentWindow = function() {
        return this._percentWindow.slice();
    };
    AxisProxy.prototype.getTargetSeriesModels = function() {
        var seriesModels = [];
        this.ecModel.eachSeries(function(seriesModel) {
            if ((0, $554cb472ba0e05d3$export$2d449d4adc0d2cfc)(seriesModel)) {
                var axisMainType = (0, $554cb472ba0e05d3$export$90855f7219399082)(this._dimName);
                var axisModel = seriesModel.getReferringComponents(axisMainType, (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
                if (axisModel && this._axisIndex === axisModel.componentIndex) seriesModels.push(seriesModel);
            }
        }, this);
        return seriesModels;
    };
    AxisProxy.prototype.getAxisModel = function() {
        return this.ecModel.getComponent(this._dimName + "Axis", this._axisIndex);
    };
    AxisProxy.prototype.getMinMaxSpan = function() {
        return $7a1bd9c2710fea0d$export$9cd59f9826255e47(this._minMaxSpan);
    };
    /**
   * Only calculate by given range and this._dataExtent, do not change anything.
   */ AxisProxy.prototype.calculateDataWindow = function(opt) {
        var dataExtent = this._dataExtent;
        var axisModel = this.getAxisModel();
        var scale = axisModel.axis.scale;
        var rangePropMode = this._dataZoomModel.getRangePropMode();
        var percentExtent = [
            0,
            100
        ];
        var percentWindow = [];
        var valueWindow = [];
        var hasPropModeValue;
        $06639d6035d20694$var$each([
            "start",
            "end"
        ], function(prop, idx) {
            var boundPercent = opt[prop];
            var boundValue = opt[prop + "Value"];
            // Notice: dataZoom is based either on `percentProp` ('start', 'end') or
            // on `valueProp` ('startValue', 'endValue'). (They are based on the data extent
            // but not min/max of axis, which will be calculated by data window then).
            // The former one is suitable for cases that a dataZoom component controls multiple
            // axes with different unit or extent, and the latter one is suitable for accurate
            // zoom by pixel (e.g., in dataZoomSelect).
            // we use `getRangePropMode()` to mark which prop is used. `rangePropMode` is updated
            // only when setOption or dispatchAction, otherwise it remains its original value.
            // (Why not only record `percentProp` and always map to `valueProp`? Because
            // the map `valueProp` -> `percentProp` -> `valueProp` probably not the original
            // `valueProp`. consider two axes constrolled by one dataZoom. They have different
            // data extent. All of values that are overflow the `dataExtent` will be calculated
            // to percent '100%').
            if (rangePropMode[idx] === "percent") {
                boundPercent == null && (boundPercent = percentExtent[idx]);
                // Use scale.parse to math round for category or time axis.
                boundValue = scale.parse($cfc1f3b422a3185f$export$d3f68fbaa670562(boundPercent, percentExtent, dataExtent));
            } else {
                hasPropModeValue = true;
                boundValue = boundValue == null ? dataExtent[idx] : scale.parse(boundValue);
                // Calculating `percent` from `value` may be not accurate, because
                // This calculation can not be inversed, because all of values that
                // are overflow the `dataExtent` will be calculated to percent '100%'
                boundPercent = $cfc1f3b422a3185f$export$d3f68fbaa670562(boundValue, dataExtent, percentExtent);
            }
            // valueWindow[idx] = round(boundValue);
            // percentWindow[idx] = round(boundPercent);
            // fallback to extent start/end when parsed value or percent is invalid
            valueWindow[idx] = boundValue == null || isNaN(boundValue) ? dataExtent[idx] : boundValue;
            percentWindow[idx] = boundPercent == null || isNaN(boundPercent) ? percentExtent[idx] : boundPercent;
        });
        $06639d6035d20694$var$asc(valueWindow);
        $06639d6035d20694$var$asc(percentWindow);
        // The windows from user calling of `dispatchAction` might be out of the extent,
        // or do not obey the `min/maxSpan`, `min/maxValueSpan`. But we don't restrict window
        // by `zoomLock` here, because we see `zoomLock` just as a interaction constraint,
        // where API is able to initialize/modify the window size even though `zoomLock`
        // specified.
        var spans = this._minMaxSpan;
        hasPropModeValue ? restrictSet(valueWindow, percentWindow, dataExtent, percentExtent, false) : restrictSet(percentWindow, valueWindow, percentExtent, dataExtent, true);
        function restrictSet(fromWindow, toWindow, fromExtent, toExtent, toValue) {
            var suffix = toValue ? "Span" : "ValueSpan";
            (0, $00a8003b34293330$export$2e2bcd8739ae039)(0, fromWindow, fromExtent, "all", spans["min" + suffix], spans["max" + suffix]);
            for(var i = 0; i < 2; i++){
                toWindow[i] = $cfc1f3b422a3185f$export$d3f68fbaa670562(fromWindow[i], fromExtent, toExtent, true);
                toValue && (toWindow[i] = scale.parse(toWindow[i]));
            }
        }
        return {
            valueWindow: valueWindow,
            percentWindow: percentWindow
        };
    };
    /**
   * Notice: reset should not be called before series.restoreData() is called,
   * so it is recommended to be called in "process stage" but not "model init
   * stage".
   */ AxisProxy.prototype.reset = function(dataZoomModel) {
        if (dataZoomModel !== this._dataZoomModel) return;
        var targetSeries = this.getTargetSeriesModels();
        // Culculate data window and data extent, and record them.
        this._dataExtent = $06639d6035d20694$var$calculateDataExtent(this, this._dimName, targetSeries);
        // `calculateDataWindow` uses min/maxSpan.
        this._updateMinMaxSpan();
        var dataWindow = this.calculateDataWindow(dataZoomModel.settledOption);
        this._valueWindow = dataWindow.valueWindow;
        this._percentWindow = dataWindow.percentWindow;
        // Update axis setting then.
        this._setAxisModel();
    };
    AxisProxy.prototype.filterData = function(dataZoomModel, api) {
        if (dataZoomModel !== this._dataZoomModel) return;
        var axisDim = this._dimName;
        var seriesModels = this.getTargetSeriesModels();
        var filterMode = dataZoomModel.get("filterMode");
        var valueWindow = this._valueWindow;
        if (filterMode === "none") return;
        // FIXME
        // Toolbox may has dataZoom injected. And if there are stacked bar chart
        // with NaN data, NaN will be filtered and stack will be wrong.
        // So we need to force the mode to be set empty.
        // In fect, it is not a big deal that do not support filterMode-'filter'
        // when using toolbox#dataZoom, utill tooltip#dataZoom support "single axis
        // selection" some day, which might need "adapt to data extent on the
        // otherAxis", which is disabled by filterMode-'empty'.
        // But currently, stack has been fixed to based on value but not index,
        // so this is not an issue any more.
        // let otherAxisModel = this.getOtherAxisModel();
        // if (dataZoomModel.get('$fromToolbox')
        //     && otherAxisModel
        //     && otherAxisModel.hasSeriesStacked
        // ) {
        //     filterMode = 'empty';
        // }
        // TODO
        // filterMode 'weakFilter' and 'empty' is not optimized for huge data yet.
        $06639d6035d20694$var$each(seriesModels, function(seriesModel) {
            var seriesData = seriesModel.getData();
            var dataDims = seriesData.mapDimensionsAll(axisDim);
            if (!dataDims.length) return;
            if (filterMode === "weakFilter") {
                var store_1 = seriesData.getStore();
                var dataDimIndices_1 = $7a1bd9c2710fea0d$export$871de8747c9eaa88(dataDims, function(dim) {
                    return seriesData.getDimensionIndex(dim);
                }, seriesData);
                seriesData.filterSelf(function(dataIndex) {
                    var leftOut;
                    var rightOut;
                    var hasValue;
                    for(var i = 0; i < dataDims.length; i++){
                        var value = store_1.get(dataDimIndices_1[i], dataIndex);
                        var thisHasValue = !isNaN(value);
                        var thisLeftOut = value < valueWindow[0];
                        var thisRightOut = value > valueWindow[1];
                        if (thisHasValue && !thisLeftOut && !thisRightOut) return true;
                        thisHasValue && (hasValue = true);
                        thisLeftOut && (leftOut = true);
                        thisRightOut && (rightOut = true);
                    }
                    // If both left out and right out, do not filter.
                    return hasValue && leftOut && rightOut;
                });
            } else $06639d6035d20694$var$each(dataDims, function(dim) {
                if (filterMode === "empty") seriesModel.setData(seriesData = seriesData.map(dim, function(value) {
                    return !isInWindow(value) ? NaN : value;
                }));
                else {
                    var range = {};
                    range[dim] = valueWindow;
                    // console.time('select');
                    seriesData.selectRange(range);
                // console.timeEnd('select');
                }
            });
            $06639d6035d20694$var$each(dataDims, function(dim) {
                seriesData.setApproximateExtent(valueWindow, dim);
            });
        });
        function isInWindow(value) {
            return value >= valueWindow[0] && value <= valueWindow[1];
        }
    };
    AxisProxy.prototype._updateMinMaxSpan = function() {
        var minMaxSpan = this._minMaxSpan = {};
        var dataZoomModel = this._dataZoomModel;
        var dataExtent = this._dataExtent;
        $06639d6035d20694$var$each([
            "min",
            "max"
        ], function(minMax) {
            var percentSpan = dataZoomModel.get(minMax + "Span");
            var valueSpan = dataZoomModel.get(minMax + "ValueSpan");
            valueSpan != null && (valueSpan = this.getAxisModel().axis.scale.parse(valueSpan));
            // minValueSpan and maxValueSpan has higher priority than minSpan and maxSpan
            if (valueSpan != null) percentSpan = $cfc1f3b422a3185f$export$d3f68fbaa670562(dataExtent[0] + valueSpan, dataExtent, [
                0,
                100
            ], true);
            else if (percentSpan != null) valueSpan = $cfc1f3b422a3185f$export$d3f68fbaa670562(percentSpan, [
                0,
                100
            ], dataExtent, true) - dataExtent[0];
            minMaxSpan[minMax + "Span"] = percentSpan;
            minMaxSpan[minMax + "ValueSpan"] = valueSpan;
        }, this);
    };
    AxisProxy.prototype._setAxisModel = function() {
        var axisModel = this.getAxisModel();
        var percentWindow = this._percentWindow;
        var valueWindow = this._valueWindow;
        if (!percentWindow) return;
        // [0, 500]: arbitrary value, guess axis extent.
        var precision = $cfc1f3b422a3185f$export$666260d9a2dda8a7(valueWindow, [
            0,
            500
        ]);
        precision = Math.min(precision, 20);
        // For value axis, if min/max/scale are not set, we just use the extent obtained
        // by series data, which may be a little different from the extent calculated by
        // `axisHelper.getScaleExtent`. But the different just affects the experience a
        // little when zooming. So it will not be fixed until some users require it strongly.
        var rawExtentInfo = axisModel.axis.scale.rawExtentInfo;
        if (percentWindow[0] !== 0) rawExtentInfo.setDeterminedMinMax("min", +valueWindow[0].toFixed(precision));
        if (percentWindow[1] !== 100) rawExtentInfo.setDeterminedMinMax("max", +valueWindow[1].toFixed(precision));
        rawExtentInfo.freeze();
    };
    return AxisProxy;
}();
function $06639d6035d20694$var$calculateDataExtent(axisProxy, axisDim, seriesModels) {
    var dataExtent = [
        Infinity,
        -Infinity
    ];
    $06639d6035d20694$var$each(seriesModels, function(seriesModel) {
        (0, $2d646e51cc34f840$export$635fe7f20d0f4c70)(dataExtent, seriesModel.getData(), axisDim);
    });
    // It is important to get "consistent" extent when more then one axes is
    // controlled by a `dataZoom`, otherwise those axes will not be synchronized
    // when zooming. But it is difficult to know what is "consistent", considering
    // axes have different type or even different meanings (For example, two
    // time axes are used to compare data of the same date in different years).
    // So basically dataZoom just obtains extent by series.data (in category axis
    // extent can be obtained from axis.data).
    // Nevertheless, user can set min/max/scale on axes to make extent of axes
    // consistent.
    var axisModel = axisProxy.getAxisModel();
    var rawExtentResult = (0, $483be9695e74220c$export$5c3dbcbeb9ce7f5a)(axisModel.axis.scale, axisModel, dataExtent).calculate();
    return [
        rawExtentResult.min,
        rawExtentResult.max
    ];
}
var $06639d6035d20694$export$2e2bcd8739ae039 = $06639d6035d20694$var$AxisProxy;


var $e1090934575f11ee$var$dataZoomProcessor = {
    // `dataZoomProcessor` will only be performed in needed series. Consider if
    // there is a line series and a pie series, it is better not to update the
    // line series if only pie series is needed to be updated.
    getTargetSeries: function(ecModel) {
        function eachAxisModel(cb) {
            ecModel.eachComponent("dataZoom", function(dataZoomModel) {
                dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
                    var axisModel = ecModel.getComponent((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), axisIndex);
                    cb(axisDim, axisIndex, axisModel, dataZoomModel);
                });
            });
        }
        // FIXME: it brings side-effect to `getTargetSeries`.
        // Prepare axis proxies.
        eachAxisModel(function(axisDim, axisIndex, axisModel, dataZoomModel) {
            // dispose all last axis proxy, in case that some axis are deleted.
            axisModel.__dzAxisProxy = null;
        });
        var proxyList = [];
        eachAxisModel(function(axisDim, axisIndex, axisModel, dataZoomModel) {
            // Different dataZooms may constrol the same axis. In that case,
            // an axisProxy serves both of them.
            if (!axisModel.__dzAxisProxy) {
                // Use the first dataZoomModel as the main model of axisProxy.
                axisModel.__dzAxisProxy = new (0, $06639d6035d20694$export$2e2bcd8739ae039)(axisDim, axisIndex, dataZoomModel, ecModel);
                proxyList.push(axisModel.__dzAxisProxy);
            }
        });
        var seriesModelMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(proxyList, function(axisProxy) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisProxy.getTargetSeriesModels(), function(seriesModel) {
                seriesModelMap.set(seriesModel.uid, seriesModel);
            });
        });
        return seriesModelMap;
    },
    // Consider appendData, where filter should be performed. Because data process is
    // in block mode currently, it is not need to worry about that the overallProgress
    // execute every frame.
    overallReset: function(ecModel, api) {
        ecModel.eachComponent("dataZoom", function(dataZoomModel) {
            // We calculate window and reset axis here but not in model
            // init stage and not after action dispatch handler, because
            // reset should be called after seriesData.restoreData.
            dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
                dataZoomModel.getAxisProxy(axisDim, axisIndex).reset(dataZoomModel);
            });
            // Caution: data zoom filtering is order sensitive when using
            // percent range and no min/max/scale set on axis.
            // For example, we have dataZoom definition:
            // [
            //      {xAxisIndex: 0, start: 30, end: 70},
            //      {yAxisIndex: 0, start: 20, end: 80}
            // ]
            // In this case, [20, 80] of y-dataZoom should be based on data
            // that have filtered by x-dataZoom using range of [30, 70],
            // but should not be based on full raw data. Thus sliding
            // x-dataZoom will change both ranges of xAxis and yAxis,
            // while sliding y-dataZoom will only change the range of yAxis.
            // So we should filter x-axis after reset x-axis immediately,
            // and then reset y-axis and filter y-axis.
            dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
                dataZoomModel.getAxisProxy(axisDim, axisIndex).filterData(dataZoomModel, api);
            });
        });
        ecModel.eachComponent("dataZoom", function(dataZoomModel) {
            // Fullfill all of the range props so that user
            // is able to get them from chart.getOption().
            var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
            if (axisProxy) {
                var percentRange = axisProxy.getDataPercentWindow();
                var valueRange = axisProxy.getDataValueWindow();
                dataZoomModel.setCalculatedRange({
                    start: percentRange[0],
                    end: percentRange[1],
                    startValue: valueRange[0],
                    endValue: valueRange[1]
                });
            }
        });
    }
};
var $e1090934575f11ee$export$2e2bcd8739ae039 = $e1090934575f11ee$var$dataZoomProcessor;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $de61ff13130c6dae$export$2e2bcd8739ae039(registers) {
    registers.registerAction("dataZoom", function(payload, ecModel) {
        var effectedModels = (0, $554cb472ba0e05d3$export$9e00b6c2b8b2e9a7)(ecModel, payload);
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(effectedModels, function(dataZoomModel) {
            dataZoomModel.setRawRange({
                start: payload.start,
                end: payload.end,
                startValue: payload.startValue,
                endValue: payload.endValue
            });
        });
    });
}


var $8904ef10f452e35c$var$installed = false;
function $8904ef10f452e35c$export$2e2bcd8739ae039(registers) {
    if ($8904ef10f452e35c$var$installed) return;
    $8904ef10f452e35c$var$installed = true;
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.FILTER, (0, $e1090934575f11ee$export$2e2bcd8739ae039));
    (0, $de61ff13130c6dae$export$2e2bcd8739ae039)(registers);
    registers.registerSubTypeDefaulter("dataZoom", function() {
        // Default 'slider' when no type specified.
        return "slider";
    });
}


function $b5ee445cd897e37a$export$4b3e715f166fdd78(registers) {
    (0, $8904ef10f452e35c$export$2e2bcd8739ae039)(registers);
    registers.registerComponentModel((0, $6cccca1a1040a7a1$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $ad4d16a462c12aaf$export$2e2bcd8739ae039));
    (0, $6379ab7b9c3fbfb6$export$f3632ddafc9ea51e)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $8fa9b5e71c234965$var$SliderZoomModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SliderZoomModel, _super);
    function SliderZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderZoomModel.type;
        return _this;
    }
    SliderZoomModel.type = "dataZoom.slider";
    SliderZoomModel.layoutMode = "box";
    SliderZoomModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $41d57478d16bff21$export$2e2bcd8739ae039).defaultOption, {
        show: true,
        // deault value can only be drived in view stage.
        right: "ph",
        top: "ph",
        width: "ph",
        height: "ph",
        left: null,
        bottom: null,
        borderColor: "#d2dbee",
        borderRadius: 3,
        backgroundColor: "rgba(47,69,84,0)",
        // dataBackgroundColor: '#ddd',
        dataBackground: {
            lineStyle: {
                color: "#d2dbee",
                width: 0.5
            },
            areaStyle: {
                color: "#d2dbee",
                opacity: 0.2
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: "#8fb0f7",
                width: 0.5
            },
            areaStyle: {
                color: "#8fb0f7",
                opacity: 0.2
            }
        },
        // Color of selected window.
        fillerColor: "rgba(135,175,274,0.2)",
        handleIcon: "path://M-9.35,34.56V42m0-40V9.5m-2,0h4a2,2,0,0,1,2,2v21a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-21A2,2,0,0,1-11.35,9.5Z",
        // Percent of the slider height
        handleSize: "100%",
        handleStyle: {
            color: "#fff",
            borderColor: "#ACB8D1"
        },
        moveHandleSize: 7,
        moveHandleIcon: "path://M-320.9-50L-320.9-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-348-41-339-50-320.9-50z M-212.3-50L-212.3-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-239.4-41-230.4-50-212.3-50z M-103.7-50L-103.7-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-130.9-41-121.8-50-103.7-50z",
        moveHandleStyle: {
            color: "#D2DBEE",
            opacity: 0.7
        },
        showDetail: true,
        showDataShadow: "auto",
        realtime: true,
        zoomLock: false,
        textStyle: {
            color: "#6E7079"
        },
        brushSelect: true,
        brushStyle: {
            color: "rgba(135,175,274,0.15)"
        },
        emphasis: {
            handleStyle: {
                borderColor: "#8FB0F7"
            },
            moveHandleStyle: {
                color: "#8FB0F7"
            }
        }
    });
    return SliderZoomModel;
}((0, $41d57478d16bff21$export$2e2bcd8739ae039));
var $8fa9b5e71c234965$export$2e2bcd8739ae039 = $8fa9b5e71c234965$var$SliderZoomModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 













var $eee50458c1b708ef$var$Rect = $419e5ff2f303755e$export$2e2bcd8739ae039;
// Constants
var $eee50458c1b708ef$var$DEFAULT_LOCATION_EDGE_GAP = 7;
var $eee50458c1b708ef$var$DEFAULT_FRAME_BORDER_WIDTH = 1;
var $eee50458c1b708ef$var$DEFAULT_FILLER_SIZE = 30;
var $eee50458c1b708ef$var$DEFAULT_MOVE_HANDLE_SIZE = 7;
var $eee50458c1b708ef$var$HORIZONTAL = "horizontal";
var $eee50458c1b708ef$var$VERTICAL = "vertical";
var $eee50458c1b708ef$var$LABEL_GAP = 5;
var $eee50458c1b708ef$var$SHOW_DATA_SHADOW_SERIES_TYPE = [
    "line",
    "bar",
    "candlestick",
    "scatter"
];
var $eee50458c1b708ef$var$REALTIME_ANIMATION_CONFIG = {
    easing: "cubicOut",
    duration: 100,
    delay: 0
};
var $eee50458c1b708ef$var$SliderZoomView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SliderZoomView, _super);
    function SliderZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderZoomView.type;
        _this._displayables = {};
        return _this;
    }
    SliderZoomView.prototype.init = function(ecModel, api) {
        this.api = api;
        // A unique handler for each dataZoom component
        this._onBrush = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onBrush, this);
        this._onBrushEnd = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onBrushEnd, this);
    };
    SliderZoomView.prototype.render = function(dataZoomModel, ecModel, api, payload) {
        _super.prototype.render.apply(this, arguments);
        $c98659a9437a3d2e$export$958e3e1a02eac4b6(this, "_dispatchZoomAction", dataZoomModel.get("throttle"), "fixRate");
        this._orient = dataZoomModel.getOrient();
        if (dataZoomModel.get("show") === false) {
            this.group.removeAll();
            return;
        }
        if (dataZoomModel.noTarget()) {
            this._clear();
            this.group.removeAll();
            return;
        }
        // Notice: this._resetInterval() should not be executed when payload.type
        // is 'dataZoom', origin this._range should be maintained, otherwise 'pan'
        // or 'zoom' info will be missed because of 'throttle' of this.dispatchAction,
        if (!payload || payload.type !== "dataZoom" || payload.from !== this.uid) this._buildView();
        this._updateView();
    };
    SliderZoomView.prototype.dispose = function() {
        this._clear();
        _super.prototype.dispose.apply(this, arguments);
    };
    SliderZoomView.prototype._clear = function() {
        $c98659a9437a3d2e$export$42ffd38884aecdac(this, "_dispatchZoomAction");
        var zr = this.api.getZr();
        zr.off("mousemove", this._onBrush);
        zr.off("mouseup", this._onBrushEnd);
    };
    SliderZoomView.prototype._buildView = function() {
        var thisGroup = this.group;
        thisGroup.removeAll();
        this._brushing = false;
        this._displayables.brushRect = null;
        this._resetLocation();
        this._resetInterval();
        var barGroup = this._displayables.sliderGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this._renderBackground();
        this._renderHandle();
        this._renderDataShadow();
        thisGroup.add(barGroup);
        this._positionGroup();
    };
    SliderZoomView.prototype._resetLocation = function() {
        var dataZoomModel = this.dataZoomModel;
        var api = this.api;
        var showMoveHandle = dataZoomModel.get("brushSelect");
        var moveHandleSize = showMoveHandle ? $eee50458c1b708ef$var$DEFAULT_MOVE_HANDLE_SIZE : 0;
        // If some of x/y/width/height are not specified,
        // auto-adapt according to target grid.
        var coordRect = this._findCoordRect();
        var ecSize = {
            width: api.getWidth(),
            height: api.getHeight()
        };
        // Default align by coordinate system rect.
        var positionInfo = this._orient === $eee50458c1b708ef$var$HORIZONTAL ? {
            // Why using 'right', because right should be used in vertical,
            // and it is better to be consistent for dealing with position param merge.
            right: ecSize.width - coordRect.x - coordRect.width,
            top: ecSize.height - $eee50458c1b708ef$var$DEFAULT_FILLER_SIZE - $eee50458c1b708ef$var$DEFAULT_LOCATION_EDGE_GAP - moveHandleSize,
            width: coordRect.width,
            height: $eee50458c1b708ef$var$DEFAULT_FILLER_SIZE
        } : {
            right: $eee50458c1b708ef$var$DEFAULT_LOCATION_EDGE_GAP,
            top: coordRect.y,
            width: $eee50458c1b708ef$var$DEFAULT_FILLER_SIZE,
            height: coordRect.height
        };
        // Do not write back to option and replace value 'ph', because
        // the 'ph' value should be recalculated when resize.
        var layoutParams = $93b9bc7f22ac7369$export$4b0d20af19c9875e(dataZoomModel.option);
        // Replace the placeholder value.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            "right",
            "top",
            "width",
            "height"
        ], function(name) {
            if (layoutParams[name] === "ph") layoutParams[name] = positionInfo[name];
        });
        var layoutRect = $93b9bc7f22ac7369$export$4517a5ca639a7293(layoutParams, ecSize);
        this._location = {
            x: layoutRect.x,
            y: layoutRect.y
        };
        this._size = [
            layoutRect.width,
            layoutRect.height
        ];
        this._orient === $eee50458c1b708ef$var$VERTICAL && this._size.reverse();
    };
    SliderZoomView.prototype._positionGroup = function() {
        var thisGroup = this.group;
        var location = this._location;
        var orient = this._orient;
        // Just use the first axis to determine mapping.
        var targetAxisModel = this.dataZoomModel.getFirstTargetAxisModel();
        var inverse = targetAxisModel && targetAxisModel.get("inverse");
        var sliderGroup = this._displayables.sliderGroup;
        var otherAxisInverse = (this._dataShadowInfo || {}).otherAxisInverse;
        // Transform barGroup.
        sliderGroup.attr(orient === $eee50458c1b708ef$var$HORIZONTAL && !inverse ? {
            scaleY: otherAxisInverse ? 1 : -1,
            scaleX: 1
        } : orient === $eee50458c1b708ef$var$HORIZONTAL && inverse ? {
            scaleY: otherAxisInverse ? 1 : -1,
            scaleX: -1
        } : orient === $eee50458c1b708ef$var$VERTICAL && !inverse ? {
            scaleY: otherAxisInverse ? -1 : 1,
            scaleX: 1,
            rotation: Math.PI / 2
        } : {
            scaleY: otherAxisInverse ? -1 : 1,
            scaleX: -1,
            rotation: Math.PI / 2
        });
        // Position barGroup
        var rect = thisGroup.getBoundingRect([
            sliderGroup
        ]);
        thisGroup.x = location.x - rect.x;
        thisGroup.y = location.y - rect.y;
        thisGroup.markRedraw();
    };
    SliderZoomView.prototype._getViewExtent = function() {
        return [
            0,
            this._size[0]
        ];
    };
    SliderZoomView.prototype._renderBackground = function() {
        var dataZoomModel = this.dataZoomModel;
        var size = this._size;
        var barGroup = this._displayables.sliderGroup;
        var brushSelect = dataZoomModel.get("brushSelect");
        barGroup.add(new $eee50458c1b708ef$var$Rect({
            silent: true,
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1]
            },
            style: {
                fill: dataZoomModel.get("backgroundColor")
            },
            z2: -40
        }));
        // Click panel, over shadow, below handles.
        var clickPanel = new $eee50458c1b708ef$var$Rect({
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1]
            },
            style: {
                fill: "transparent"
            },
            z2: 0,
            onclick: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onClickPanel, this)
        });
        var zr = this.api.getZr();
        if (brushSelect) {
            clickPanel.on("mousedown", this._onBrushStart, this);
            clickPanel.cursor = "crosshair";
            zr.on("mousemove", this._onBrush);
            zr.on("mouseup", this._onBrushEnd);
        } else {
            zr.off("mousemove", this._onBrush);
            zr.off("mouseup", this._onBrushEnd);
        }
        barGroup.add(clickPanel);
    };
    SliderZoomView.prototype._renderDataShadow = function() {
        var info = this._dataShadowInfo = this._prepareDataShadowInfo();
        this._displayables.dataShadowSegs = [];
        if (!info) return;
        var size = this._size;
        var oldSize = this._shadowSize || [];
        var seriesModel = info.series;
        var data = seriesModel.getRawData();
        var candlestickDim = seriesModel.getShadowDim && seriesModel.getShadowDim();
        var otherDim = candlestickDim && data.getDimensionInfo(candlestickDim) ? seriesModel.getShadowDim() // @see candlestick
         : info.otherDim;
        if (otherDim == null) return;
        var polygonPts = this._shadowPolygonPts;
        var polylinePts = this._shadowPolylinePts;
        // Not re-render if data doesn't change.
        if (data !== this._shadowData || otherDim !== this._shadowDim || size[0] !== oldSize[0] || size[1] !== oldSize[1]) {
            var otherDataExtent_1 = data.getDataExtent(otherDim);
            // Nice extent.
            var otherOffset = (otherDataExtent_1[1] - otherDataExtent_1[0]) * 0.3;
            otherDataExtent_1 = [
                otherDataExtent_1[0] - otherOffset,
                otherDataExtent_1[1] + otherOffset
            ];
            var otherShadowExtent_1 = [
                0,
                size[1]
            ];
            var thisShadowExtent = [
                0,
                size[0]
            ];
            var areaPoints_1 = [
                [
                    size[0],
                    0
                ],
                [
                    0,
                    0
                ]
            ];
            var linePoints_1 = [];
            var step_1 = thisShadowExtent[1] / (data.count() - 1);
            var thisCoord_1 = 0;
            // Optimize for large data shadow
            var stride_1 = Math.round(data.count() / size[0]);
            var lastIsEmpty_1;
            data.each([
                otherDim
            ], function(value, index) {
                if (stride_1 > 0 && index % stride_1) {
                    thisCoord_1 += step_1;
                    return;
                }
                // FIXME
                // Should consider axis.min/axis.max when drawing dataShadow.
                // FIXME
                // 应该使用统一的空判断？还是在list里进行空判断？
                var isEmpty = value == null || isNaN(value) || value === "";
                // See #4235.
                var otherCoord = isEmpty ? 0 : (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(value, otherDataExtent_1, otherShadowExtent_1, true);
                // Attempt to draw data shadow precisely when there are empty value.
                if (isEmpty && !lastIsEmpty_1 && index) {
                    areaPoints_1.push([
                        areaPoints_1[areaPoints_1.length - 1][0],
                        0
                    ]);
                    linePoints_1.push([
                        linePoints_1[linePoints_1.length - 1][0],
                        0
                    ]);
                } else if (!isEmpty && lastIsEmpty_1) {
                    areaPoints_1.push([
                        thisCoord_1,
                        0
                    ]);
                    linePoints_1.push([
                        thisCoord_1,
                        0
                    ]);
                }
                areaPoints_1.push([
                    thisCoord_1,
                    otherCoord
                ]);
                linePoints_1.push([
                    thisCoord_1,
                    otherCoord
                ]);
                thisCoord_1 += step_1;
                lastIsEmpty_1 = isEmpty;
            });
            polygonPts = this._shadowPolygonPts = areaPoints_1;
            polylinePts = this._shadowPolylinePts = linePoints_1;
        }
        this._shadowData = data;
        this._shadowDim = otherDim;
        this._shadowSize = [
            size[0],
            size[1]
        ];
        var dataZoomModel = this.dataZoomModel;
        function createDataShadowGroup(isSelectedArea) {
            var model = dataZoomModel.getModel(isSelectedArea ? "selectedDataBackground" : "dataBackground");
            var group = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
            var polygon = new $51acf033123e1a30$export$2e2bcd8739ae039({
                shape: {
                    points: polygonPts
                },
                segmentIgnoreThreshold: 1,
                style: model.getModel("areaStyle").getAreaStyle(),
                silent: true,
                z2: -20
            });
            var polyline = new $d28119f30e6bb670$export$2e2bcd8739ae039({
                shape: {
                    points: polylinePts
                },
                segmentIgnoreThreshold: 1,
                style: model.getModel("lineStyle").getLineStyle(),
                silent: true,
                z2: -19
            });
            group.add(polygon);
            group.add(polyline);
            return group;
        }
        // let dataBackgroundModel = dataZoomModel.getModel('dataBackground');
        for(var i = 0; i < 3; i++){
            var group = createDataShadowGroup(i === 1);
            this._displayables.sliderGroup.add(group);
            this._displayables.dataShadowSegs.push(group);
        }
    };
    SliderZoomView.prototype._prepareDataShadowInfo = function() {
        var dataZoomModel = this.dataZoomModel;
        var showDataShadow = dataZoomModel.get("showDataShadow");
        if (showDataShadow === false) return;
        // Find a representative series.
        var result;
        var ecModel = this.ecModel;
        dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
            var seriesModels = dataZoomModel.getAxisProxy(axisDim, axisIndex).getTargetSeriesModels();
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(seriesModels, function(seriesModel) {
                if (result) return;
                if (showDataShadow !== true && (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)($eee50458c1b708ef$var$SHOW_DATA_SHADOW_SERIES_TYPE, seriesModel.get("type")) < 0) return;
                var thisAxis = ecModel.getComponent((0, $554cb472ba0e05d3$export$90855f7219399082)(axisDim), axisIndex).axis;
                var otherDim = $eee50458c1b708ef$var$getOtherDim(axisDim);
                var otherAxisInverse;
                var coordSys = seriesModel.coordinateSystem;
                if (otherDim != null && coordSys.getOtherAxis) otherAxisInverse = coordSys.getOtherAxis(thisAxis).inverse;
                otherDim = seriesModel.getData().mapDimension(otherDim);
                result = {
                    thisAxis: thisAxis,
                    series: seriesModel,
                    thisDim: axisDim,
                    otherDim: otherDim,
                    otherAxisInverse: otherAxisInverse
                };
            }, this);
        }, this);
        return result;
    };
    SliderZoomView.prototype._renderHandle = function() {
        var thisGroup = this.group;
        var displayables = this._displayables;
        var handles = displayables.handles = [
            null,
            null
        ];
        var handleLabels = displayables.handleLabels = [
            null,
            null
        ];
        var sliderGroup = this._displayables.sliderGroup;
        var size = this._size;
        var dataZoomModel = this.dataZoomModel;
        var api = this.api;
        var borderRadius = dataZoomModel.get("borderRadius") || 0;
        var brushSelect = dataZoomModel.get("brushSelect");
        var filler = displayables.filler = new $eee50458c1b708ef$var$Rect({
            silent: brushSelect,
            style: {
                fill: dataZoomModel.get("fillerColor")
            },
            textConfig: {
                position: "inside"
            }
        });
        sliderGroup.add(filler);
        // Frame border.
        sliderGroup.add(new $eee50458c1b708ef$var$Rect({
            silent: true,
            subPixelOptimize: true,
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1],
                r: borderRadius
            },
            style: {
                // deprecated option
                stroke: dataZoomModel.get("dataBackgroundColor") || dataZoomModel.get("borderColor"),
                lineWidth: $eee50458c1b708ef$var$DEFAULT_FRAME_BORDER_WIDTH,
                fill: "rgba(0,0,0,0)"
            }
        }));
        // Left and right handle to resize
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            0,
            1
        ], function(handleIndex) {
            var iconStr = dataZoomModel.get("handleIcon");
            if (!(0, $5370466dadc978d7$export$33fc3b478d332725)[iconStr] && iconStr.indexOf("path://") < 0 && iconStr.indexOf("image://") < 0) // Compatitable with the old icon parsers. Which can use a path string without path://
            iconStr = "path://" + iconStr;
            var path = (0, $5370466dadc978d7$export$af050e04da3a02e8)(iconStr, -1, 0, 2, 2, null, true);
            path.attr({
                cursor: $eee50458c1b708ef$var$getCursor(this._orient),
                draggable: true,
                drift: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onDragMove, this, handleIndex),
                ondragend: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onDragEnd, this),
                onmouseover: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, true),
                onmouseout: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, false),
                z2: 5
            });
            var bRect = path.getBoundingRect();
            var handleSize = dataZoomModel.get("handleSize");
            this._handleHeight = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(handleSize, this._size[1]);
            this._handleWidth = bRect.width / bRect.height * this._handleHeight;
            path.setStyle(dataZoomModel.getModel("handleStyle").getItemStyle());
            path.style.strokeNoScale = true;
            path.rectHover = true;
            path.ensureState("emphasis").style = dataZoomModel.getModel([
                "emphasis",
                "handleStyle"
            ]).getItemStyle();
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(path);
            var handleColor = dataZoomModel.get("handleColor"); // deprecated option
            // Compatitable with previous version
            if (handleColor != null) path.style.fill = handleColor;
            sliderGroup.add(handles[handleIndex] = path);
            var textStyleModel = dataZoomModel.getModel("textStyle");
            thisGroup.add(handleLabels[handleIndex] = new $fe885cc21795562b$export$2e2bcd8739ae039({
                silent: true,
                invisible: true,
                style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                    x: 0,
                    y: 0,
                    text: "",
                    verticalAlign: "middle",
                    align: "center",
                    fill: textStyleModel.getTextColor(),
                    font: textStyleModel.getFont()
                }),
                z2: 10
            }));
        }, this);
        // Handle to move. Only visible when brushSelect is set true.
        var actualMoveZone = filler;
        if (brushSelect) {
            var moveHandleHeight = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(dataZoomModel.get("moveHandleSize"), size[1]);
            var moveHandle_1 = displayables.moveHandle = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                style: dataZoomModel.getModel("moveHandleStyle").getItemStyle(),
                silent: true,
                shape: {
                    r: [
                        0,
                        0,
                        2,
                        2
                    ],
                    y: size[1] - 0.5,
                    height: moveHandleHeight
                }
            });
            var iconSize = moveHandleHeight * 0.8;
            var moveHandleIcon = displayables.moveHandleIcon = (0, $5370466dadc978d7$export$af050e04da3a02e8)(dataZoomModel.get("moveHandleIcon"), -iconSize / 2, -iconSize / 2, iconSize, iconSize, "#fff", true);
            moveHandleIcon.silent = true;
            moveHandleIcon.y = size[1] + moveHandleHeight / 2 - 0.5;
            moveHandle_1.ensureState("emphasis").style = dataZoomModel.getModel([
                "emphasis",
                "moveHandleStyle"
            ]).getItemStyle();
            var moveZoneExpandSize = Math.min(size[1] / 2, Math.max(moveHandleHeight, 10));
            actualMoveZone = displayables.moveZone = new $419e5ff2f303755e$export$2e2bcd8739ae039({
                invisible: true,
                shape: {
                    y: size[1] - moveZoneExpandSize,
                    height: moveHandleHeight + moveZoneExpandSize
                }
            });
            actualMoveZone.on("mouseover", function() {
                api.enterEmphasis(moveHandle_1);
            }).on("mouseout", function() {
                api.leaveEmphasis(moveHandle_1);
            });
            sliderGroup.add(moveHandle_1);
            sliderGroup.add(moveHandleIcon);
            sliderGroup.add(actualMoveZone);
        }
        actualMoveZone.attr({
            draggable: true,
            cursor: $eee50458c1b708ef$var$getCursor(this._orient),
            drift: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onDragMove, this, "all"),
            ondragstart: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, true),
            ondragend: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._onDragEnd, this),
            onmouseover: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, true),
            onmouseout: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._showDataInfo, this, false)
        });
    };
    SliderZoomView.prototype._resetInterval = function() {
        var range = this._range = this.dataZoomModel.getPercentRange();
        var viewExtent = this._getViewExtent();
        this._handleEnds = [
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(range[0], [
                0,
                100
            ], viewExtent, true),
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(range[1], [
                0,
                100
            ], viewExtent, true)
        ];
    };
    SliderZoomView.prototype._updateInterval = function(handleIndex, delta) {
        var dataZoomModel = this.dataZoomModel;
        var handleEnds = this._handleEnds;
        var viewExtend = this._getViewExtent();
        var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
        var percentExtent = [
            0,
            100
        ];
        (0, $00a8003b34293330$export$2e2bcd8739ae039)(delta, handleEnds, viewExtend, dataZoomModel.get("zoomLock") ? "all" : handleIndex, minMaxSpan.minSpan != null ? (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
        var lastRange = this._range;
        var range = this._range = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)([
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(handleEnds[0], viewExtend, percentExtent, true),
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(handleEnds[1], viewExtend, percentExtent, true)
        ]);
        return !lastRange || lastRange[0] !== range[0] || lastRange[1] !== range[1];
    };
    SliderZoomView.prototype._updateView = function(nonRealtime) {
        var displaybles = this._displayables;
        var handleEnds = this._handleEnds;
        var handleInterval = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)(handleEnds.slice());
        var size = this._size;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
            0,
            1
        ], function(handleIndex) {
            // Handles
            var handle = displaybles.handles[handleIndex];
            var handleHeight = this._handleHeight;
            handle.attr({
                scaleX: handleHeight / 2,
                scaleY: handleHeight / 2,
                // This is a trick, by adding an extra tiny offset to let the default handle's end point align to the drag window.
                // NOTE: It may affect some custom shapes a bit. But we prefer to have better result by default.
                x: handleEnds[handleIndex] + (handleIndex ? -1 : 1),
                y: size[1] / 2 - handleHeight / 2
            });
        }, this);
        // Filler
        displaybles.filler.setShape({
            x: handleInterval[0],
            y: 0,
            width: handleInterval[1] - handleInterval[0],
            height: size[1]
        });
        var viewExtent = {
            x: handleInterval[0],
            width: handleInterval[1] - handleInterval[0]
        };
        // Move handle
        if (displaybles.moveHandle) {
            displaybles.moveHandle.setShape(viewExtent);
            displaybles.moveZone.setShape(viewExtent);
            // Force update path on the invisible object
            displaybles.moveZone.getBoundingRect();
            displaybles.moveHandleIcon && displaybles.moveHandleIcon.attr("x", viewExtent.x + viewExtent.width / 2);
        }
        // update clip path of shadow.
        var dataShadowSegs = displaybles.dataShadowSegs;
        var segIntervals = [
            0,
            handleInterval[0],
            handleInterval[1],
            size[0]
        ];
        for(var i = 0; i < dataShadowSegs.length; i++){
            var segGroup = dataShadowSegs[i];
            var clipPath = segGroup.getClipPath();
            if (!clipPath) {
                clipPath = new $419e5ff2f303755e$export$2e2bcd8739ae039();
                segGroup.setClipPath(clipPath);
            }
            clipPath.setShape({
                x: segIntervals[i],
                y: 0,
                width: segIntervals[i + 1] - segIntervals[i],
                height: size[1]
            });
        }
        this._updateDataInfo(nonRealtime);
    };
    SliderZoomView.prototype._updateDataInfo = function(nonRealtime) {
        var dataZoomModel = this.dataZoomModel;
        var displaybles = this._displayables;
        var handleLabels = displaybles.handleLabels;
        var orient = this._orient;
        var labelTexts = [
            "",
            ""
        ];
        // FIXME
        // date型，支持formatter，autoformatter（ec2 date.getAutoFormatter）
        if (dataZoomModel.get("showDetail")) {
            var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
            if (axisProxy) {
                var axis = axisProxy.getAxisModel().axis;
                var range = this._range;
                var dataInterval = nonRealtime ? axisProxy.calculateDataWindow({
                    start: range[0],
                    end: range[1]
                }).valueWindow : axisProxy.getDataValueWindow();
                labelTexts = [
                    this._formatLabel(dataInterval[0], axis),
                    this._formatLabel(dataInterval[1], axis)
                ];
            }
        }
        var orderedHandleEnds = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)(this._handleEnds.slice());
        setLabel.call(this, 0);
        setLabel.call(this, 1);
        function setLabel(handleIndex) {
            // Label
            // Text should not transform by barGroup.
            // Ignore handlers transform
            var barTransform = $5b455ae6f843ac47$export$fce0c6cfca85ed96(displaybles.handles[handleIndex].parent, this.group);
            var direction = $5b455ae6f843ac47$export$fff94e9792354cfa(handleIndex === 0 ? "right" : "left", barTransform);
            var offset = this._handleWidth / 2 + $eee50458c1b708ef$var$LABEL_GAP;
            var textPoint = $5b455ae6f843ac47$export$9f9dcb98c894b623([
                orderedHandleEnds[handleIndex] + (handleIndex === 0 ? -offset : offset),
                this._size[1] / 2
            ], barTransform);
            handleLabels[handleIndex].setStyle({
                x: textPoint[0],
                y: textPoint[1],
                verticalAlign: orient === $eee50458c1b708ef$var$HORIZONTAL ? "middle" : direction,
                align: orient === $eee50458c1b708ef$var$HORIZONTAL ? direction : "center",
                text: labelTexts[handleIndex]
            });
        }
    };
    SliderZoomView.prototype._formatLabel = function(value, axis) {
        var dataZoomModel = this.dataZoomModel;
        var labelFormatter = dataZoomModel.get("labelFormatter");
        var labelPrecision = dataZoomModel.get("labelPrecision");
        if (labelPrecision == null || labelPrecision === "auto") labelPrecision = axis.getPixelPrecision();
        var valueStr = value == null || isNaN(value) ? "" : axis.type === "category" || axis.type === "time" ? axis.scale.getLabel({
            value: Math.round(value)
        }) : value.toFixed(Math.min(labelPrecision, 20));
        return (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(labelFormatter) ? labelFormatter(value, valueStr) : (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(labelFormatter) ? labelFormatter.replace("{value}", valueStr) : valueStr;
    };
    /**
   * @param showOrHide true: show, false: hide
   */ SliderZoomView.prototype._showDataInfo = function(showOrHide) {
        // Always show when drgging.
        showOrHide = this._dragging || showOrHide;
        var displayables = this._displayables;
        var handleLabels = displayables.handleLabels;
        handleLabels[0].attr("invisible", !showOrHide);
        handleLabels[1].attr("invisible", !showOrHide);
        // Highlight move handle
        displayables.moveHandle && this.api[showOrHide ? "enterEmphasis" : "leaveEmphasis"](displayables.moveHandle, 1);
    };
    SliderZoomView.prototype._onDragMove = function(handleIndex, dx, dy, event) {
        this._dragging = true;
        // For mobile device, prevent screen slider on the button.
        $b3864a78637ff9ed$export$fa6813432f753b0d(event.event);
        // Transform dx, dy to bar coordination.
        var barTransform = this._displayables.sliderGroup.getLocalTransform();
        var vertex = $5b455ae6f843ac47$export$9f9dcb98c894b623([
            dx,
            dy
        ], barTransform, true);
        var changed = this._updateInterval(handleIndex, vertex[0]);
        var realtime = this.dataZoomModel.get("realtime");
        this._updateView(!realtime);
        // Avoid dispatch dataZoom repeatly but range not changed,
        // which cause bad visual effect when progressive enabled.
        changed && realtime && this._dispatchZoomAction(true);
    };
    SliderZoomView.prototype._onDragEnd = function() {
        this._dragging = false;
        this._showDataInfo(false);
        // While in realtime mode and stream mode, dispatch action when
        // drag end will cause the whole view rerender, which is unnecessary.
        var realtime = this.dataZoomModel.get("realtime");
        !realtime && this._dispatchZoomAction(false);
    };
    SliderZoomView.prototype._onClickPanel = function(e) {
        var size = this._size;
        var localPoint = this._displayables.sliderGroup.transformCoordToLocal(e.offsetX, e.offsetY);
        if (localPoint[0] < 0 || localPoint[0] > size[0] || localPoint[1] < 0 || localPoint[1] > size[1]) return;
        var handleEnds = this._handleEnds;
        var center = (handleEnds[0] + handleEnds[1]) / 2;
        var changed = this._updateInterval("all", localPoint[0] - center);
        this._updateView();
        changed && this._dispatchZoomAction(false);
    };
    SliderZoomView.prototype._onBrushStart = function(e) {
        var x = e.offsetX;
        var y = e.offsetY;
        this._brushStart = new $b887f038f104fe7e$export$2e2bcd8739ae039(x, y);
        this._brushing = true;
        this._brushStartTime = +new Date();
    // this._updateBrushRect(x, y);
    };
    SliderZoomView.prototype._onBrushEnd = function(e) {
        if (!this._brushing) return;
        var brushRect = this._displayables.brushRect;
        this._brushing = false;
        if (!brushRect) return;
        brushRect.attr("ignore", true);
        var brushShape = brushRect.shape;
        var brushEndTime = +new Date();
        // console.log(brushEndTime - this._brushStartTime);
        if (brushEndTime - this._brushStartTime < 200 && Math.abs(brushShape.width) < 5) // Will treat it as a click
        return;
        var viewExtend = this._getViewExtent();
        var percentExtent = [
            0,
            100
        ];
        this._range = (0, $cfc1f3b422a3185f$export$debe6e778e0a6d32)([
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(brushShape.x, viewExtend, percentExtent, true),
            (0, $cfc1f3b422a3185f$export$d3f68fbaa670562)(brushShape.x + brushShape.width, viewExtend, percentExtent, true)
        ]);
        this._handleEnds = [
            brushShape.x,
            brushShape.x + brushShape.width
        ];
        this._updateView();
        this._dispatchZoomAction(false);
    };
    SliderZoomView.prototype._onBrush = function(e) {
        if (this._brushing) {
            // For mobile device, prevent screen slider on the button.
            $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
            this._updateBrushRect(e.offsetX, e.offsetY);
        }
    };
    SliderZoomView.prototype._updateBrushRect = function(mouseX, mouseY) {
        var displayables = this._displayables;
        var dataZoomModel = this.dataZoomModel;
        var brushRect = displayables.brushRect;
        if (!brushRect) {
            brushRect = displayables.brushRect = new $eee50458c1b708ef$var$Rect({
                silent: true,
                style: dataZoomModel.getModel("brushStyle").getItemStyle()
            });
            displayables.sliderGroup.add(brushRect);
        }
        brushRect.attr("ignore", false);
        var brushStart = this._brushStart;
        var sliderGroup = this._displayables.sliderGroup;
        var endPoint = sliderGroup.transformCoordToLocal(mouseX, mouseY);
        var startPoint = sliderGroup.transformCoordToLocal(brushStart.x, brushStart.y);
        var size = this._size;
        endPoint[0] = Math.max(Math.min(size[0], endPoint[0]), 0);
        brushRect.setShape({
            x: startPoint[0],
            y: 0,
            width: endPoint[0] - startPoint[0],
            height: size[1]
        });
    };
    /**
   * This action will be throttled.
   */ SliderZoomView.prototype._dispatchZoomAction = function(realtime) {
        var range = this._range;
        this.api.dispatchAction({
            type: "dataZoom",
            from: this.uid,
            dataZoomId: this.dataZoomModel.id,
            animation: realtime ? $eee50458c1b708ef$var$REALTIME_ANIMATION_CONFIG : null,
            start: range[0],
            end: range[1]
        });
    };
    SliderZoomView.prototype._findCoordRect = function() {
        // Find the grid corresponding to the first axis referred by dataZoom.
        var rect;
        var coordSysInfoList = (0, $554cb472ba0e05d3$export$b41173dee9da195b)(this.dataZoomModel).infoList;
        if (!rect && coordSysInfoList.length) {
            var coordSys = coordSysInfoList[0].model.coordinateSystem;
            rect = coordSys.getRect && coordSys.getRect();
        }
        if (!rect) {
            var width = this.api.getWidth();
            var height = this.api.getHeight();
            rect = {
                x: width * 0.2,
                y: height * 0.2,
                width: width * 0.6,
                height: height * 0.6
            };
        }
        return rect;
    };
    SliderZoomView.type = "dataZoom.slider";
    return SliderZoomView;
}((0, $80d6a03162f25654$export$2e2bcd8739ae039));
function $eee50458c1b708ef$var$getOtherDim(thisDim) {
    // FIXME
    // 这个逻辑和getOtherAxis里一致，但是写在这里是否不好
    var map = {
        x: "y",
        y: "x",
        radius: "angle",
        angle: "radius"
    };
    return map[thisDim];
}
function $eee50458c1b708ef$var$getCursor(orient) {
    return orient === "vertical" ? "ns-resize" : "ew-resize";
}
var $eee50458c1b708ef$export$2e2bcd8739ae039 = $eee50458c1b708ef$var$SliderZoomView;



function $794c23331e97718e$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $8fa9b5e71c234965$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $eee50458c1b708ef$export$2e2bcd8739ae039));
    (0, $8904ef10f452e35c$export$2e2bcd8739ae039)(registers);
}


function $aa2dc70f9fa9453b$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $b5ee445cd897e37a$export$4b3e715f166fdd78));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $794c23331e97718e$export$4b3e715f166fdd78));
// Do not install './dataZoomSelect',
// since it only work for toolbox dataZoom.
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




function $21e1121941dbd8a9$export$f6339b3d96c5d3d7(resultItem, newElOption) {
    var existElOption = resultItem.existing;
    // Set id and type after id assigned.
    newElOption.id = resultItem.keyInfo.id;
    !newElOption.type && existElOption && (newElOption.type = existElOption.type);
    // Set parent id if not specified
    if (newElOption.parentId == null) {
        var newElParentOption = newElOption.parentOption;
        if (newElParentOption) newElOption.parentId = newElParentOption.id;
        else if (existElOption) newElOption.parentId = existElOption.parentId;
    }
    // Clear
    newElOption.parentOption = null;
}
function $21e1121941dbd8a9$var$isSetLoc(obj, props) {
    var isSet;
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(props, function(prop) {
        obj[prop] != null && obj[prop] !== "auto" && (isSet = true);
    });
    return isSet;
}
function $21e1121941dbd8a9$var$mergeNewElOptionToExist(existList, index, newElOption) {
    // Update existing options, for `getOption` feature.
    var newElOptCopy = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, newElOption);
    var existElOption = existList[index];
    var $action = newElOption.$action || "merge";
    if ($action === "merge") {
        if (existElOption) {
            var newType;
            // We can ensure that newElOptCopy and existElOption are not
            // the same object, so `merge` will not change newElOptCopy.
            $7a1bd9c2710fea0d$export$4950aa0f605343fb(existElOption, newElOptCopy, true);
            // Rigid body, use ignoreSize.
            (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(existElOption, newElOptCopy, {
                ignoreSize: true
            });
            // Will be used in render.
            (0, $93b9bc7f22ac7369$export$7438999faea9b6cc)(newElOption, existElOption);
            // Copy transition info to new option so it can be used in the transition.
            // DO IT AFTER merge
            $21e1121941dbd8a9$var$copyTransitionInfo(newElOption, existElOption);
            $21e1121941dbd8a9$var$copyTransitionInfo(newElOption, existElOption, "shape");
            $21e1121941dbd8a9$var$copyTransitionInfo(newElOption, existElOption, "style");
            $21e1121941dbd8a9$var$copyTransitionInfo(newElOption, existElOption, "extra");
            // Copy clipPath
            newElOption.clipPath = existElOption.clipPath;
        } else existList[index] = newElOptCopy;
    } else if ($action === "replace") existList[index] = newElOptCopy;
    else if ($action === "remove") // null will be cleaned later.
    existElOption && (existList[index] = null);
}
var $21e1121941dbd8a9$var$TRANSITION_PROPS_TO_COPY = [
    "transition",
    "enterFrom",
    "leaveTo"
];
var $21e1121941dbd8a9$var$ROOT_TRANSITION_PROPS_TO_COPY = $21e1121941dbd8a9$var$TRANSITION_PROPS_TO_COPY.concat([
    "enterAnimation",
    "updateAnimation",
    "leaveAnimation"
]);
function $21e1121941dbd8a9$var$copyTransitionInfo(target, source, targetProp) {
    if (targetProp) {
        if (!target[targetProp] && source[targetProp]) // TODO avoid creating this empty object when there is no transition configuration.
        target[targetProp] = {};
        target = target[targetProp];
        source = source[targetProp];
    }
    if (!target || !source) return;
    var props = targetProp ? $21e1121941dbd8a9$var$TRANSITION_PROPS_TO_COPY : $21e1121941dbd8a9$var$ROOT_TRANSITION_PROPS_TO_COPY;
    for(var i = 0; i < props.length; i++){
        var prop = props[i];
        if (target[prop] == null && source[prop] != null) target[prop] = source[prop];
    }
}
function $21e1121941dbd8a9$var$setLayoutInfoToExist(existItem, newElOption) {
    if (!existItem) return;
    existItem.hv = newElOption.hv = [
        // Rigid body, don't care about `width`.
        $21e1121941dbd8a9$var$isSetLoc(newElOption, [
            "left",
            "right"
        ]),
        // Rigid body, don't care about `height`.
        $21e1121941dbd8a9$var$isSetLoc(newElOption, [
            "top",
            "bottom"
        ])
    ];
    // Give default group size. Otherwise layout error may occur.
    if (existItem.type === "group") {
        var existingGroupOpt = existItem;
        var newGroupOpt = newElOption;
        existingGroupOpt.width == null && (existingGroupOpt.width = newGroupOpt.width = 0);
        existingGroupOpt.height == null && (existingGroupOpt.height = newGroupOpt.height = 0);
    }
}
var $21e1121941dbd8a9$export$6d85925da4d2cf23 = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GraphicComponentModel, _super);
    function GraphicComponentModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphicComponentModel.type;
        _this.preventAutoZ = true;
        return _this;
    }
    GraphicComponentModel.prototype.mergeOption = function(option, ecModel) {
        // Prevent default merge to elements
        var elements = this.option.elements;
        this.option.elements = null;
        _super.prototype.mergeOption.call(this, option, ecModel);
        this.option.elements = elements;
    };
    GraphicComponentModel.prototype.optionUpdated = function(newOption, isInit) {
        var thisOption = this.option;
        var newList = (isInit ? thisOption : newOption).elements;
        var existList = thisOption.elements = isInit ? [] : thisOption.elements;
        var flattenedList = [];
        this._flatten(newList, flattenedList, null);
        var mappingResult = $76d619f648247e6d$export$574f818966e4da87(existList, flattenedList, "normalMerge");
        // Clear elOptionsToUpdate
        var elOptionsToUpdate = this._elOptionsToUpdate = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(mappingResult, function(resultItem, index) {
            var newElOption = resultItem.newOption;
            if (!newElOption) return;
            elOptionsToUpdate.push(newElOption);
            $21e1121941dbd8a9$export$f6339b3d96c5d3d7(resultItem, newElOption);
            $21e1121941dbd8a9$var$mergeNewElOptionToExist(existList, index, newElOption);
            $21e1121941dbd8a9$var$setLayoutInfoToExist(existList[index], newElOption);
        }, this);
        // Clean
        thisOption.elements = $7a1bd9c2710fea0d$export$3dea766d36a8935f(existList, function(item) {
            // $action should be volatile, otherwise option gotten from
            // `getOption` will contain unexpected $action.
            item && delete item.$action;
            return item != null;
        });
    };
    /**
   * Convert
   * [{
   *  type: 'group',
   *  id: 'xx',
   *  children: [{type: 'circle'}, {type: 'polygon'}]
   * }]
   * to
   * [
   *  {type: 'group', id: 'xx'},
   *  {type: 'circle', parentId: 'xx'},
   *  {type: 'polygon', parentId: 'xx'}
   * ]
   */ GraphicComponentModel.prototype._flatten = function(optionList, result, parentOption) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(optionList, function(option) {
            if (!option) return;
            if (parentOption) option.parentOption = parentOption;
            result.push(option);
            var children = option.children;
            // here we don't judge if option.type is `group`
            // when new option doesn't provide `type`, it will cause that the children can't be updated.
            if (children && children.length) this._flatten(children, result, option);
            // Deleting for JSON output, and for not affecting group creation.
            delete option.children;
        }, this);
    };
    // FIXME
    // Pass to view using payload? setOption has a payload?
    GraphicComponentModel.prototype.useElOptionsToUpdate = function() {
        var els = this._elOptionsToUpdate;
        // Clear to avoid render duplicately when zooming.
        this._elOptionsToUpdate = null;
        return els;
    };
    GraphicComponentModel.type = "graphic";
    GraphicComponentModel.defaultOption = {
        elements: []
    };
    return GraphicComponentModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 












var $2b680c3ccdb25c77$var$nonShapeGraphicElements = {
    // Reserved but not supported in graphic component.
    path: null,
    compoundPath: null,
    // Supported in graphic component.
    group: $7ef7583d8302ffce$export$2e2bcd8739ae039,
    image: $86adec94217b86c6$export$2e2bcd8739ae039,
    text: $fe885cc21795562b$export$2e2bcd8739ae039
};
var $2b680c3ccdb25c77$export$4ae363f1d88fb658 = $76d619f648247e6d$export$64df9f8d92ae083f();
// ------------------------
// View
// ------------------------
var $2b680c3ccdb25c77$export$1132c9ab9ad80748 = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(GraphicComponentView, _super);
    function GraphicComponentView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphicComponentView.type;
        return _this;
    }
    GraphicComponentView.prototype.init = function() {
        this._elMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
    };
    GraphicComponentView.prototype.render = function(graphicModel, ecModel, api) {
        // Having leveraged between use cases and algorithm complexity, a very
        // simple layout mechanism is used:
        // The size(width/height) can be determined by itself or its parent (not
        // implemented yet), but can not by its children. (Top-down travel)
        // The location(x/y) can be determined by the bounding rect of itself
        // (can including its descendants or not) and the size of its parent.
        // (Bottom-up travel)
        // When `chart.clear()` or `chart.setOption({...}, true)` with the same id,
        // view will be reused.
        if (graphicModel !== this._lastGraphicModel) this._clear();
        this._lastGraphicModel = graphicModel;
        this._updateElements(graphicModel);
        this._relocate(graphicModel, api);
    };
    /**
   * Update graphic elements.
   */ GraphicComponentView.prototype._updateElements = function(graphicModel) {
        var elOptionsToUpdate = graphicModel.useElOptionsToUpdate();
        if (!elOptionsToUpdate) return;
        var elMap = this._elMap;
        var rootGroup = this.group;
        var globalZ = graphicModel.get("z");
        var globalZLevel = graphicModel.get("zlevel");
        // Top-down tranverse to assign graphic settings to each elements.
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(elOptionsToUpdate, function(elOption) {
            var id = $76d619f648247e6d$export$fb1a222ba5dd6e51(elOption.id, null);
            var elExisting = id != null ? elMap.get(id) : null;
            var parentId = $76d619f648247e6d$export$fb1a222ba5dd6e51(elOption.parentId, null);
            var targetElParent = parentId != null ? elMap.get(parentId) : rootGroup;
            var elType = elOption.type;
            var elOptionStyle = elOption.style;
            if (elType === "text" && elOptionStyle) // In top/bottom mode, textVerticalAlign should not be used, which cause
            // inaccurately locating.
            {
                if (elOption.hv && elOption.hv[1]) elOptionStyle.textVerticalAlign = elOptionStyle.textBaseline = elOptionStyle.verticalAlign = elOptionStyle.align = null;
            }
            var textContentOption = elOption.textContent;
            var textConfig = elOption.textConfig;
            if (elOptionStyle && (0, $daa53642c3afcc30$export$3b868abde5eae7d1)(elOptionStyle, elType, !!textConfig, !!textContentOption)) {
                var convertResult = (0, $daa53642c3afcc30$export$7748133eaaa8aecc)(elOptionStyle, elType, true);
                if (!textConfig && convertResult.textConfig) textConfig = elOption.textConfig = convertResult.textConfig;
                if (!textContentOption && convertResult.textContent) textContentOption = convertResult.textContent;
            }
            // Remove unnecessary props to avoid potential problems.
            var elOptionCleaned = $2b680c3ccdb25c77$var$getCleanedElOption(elOption);
            var $action = elOption.$action || "merge";
            var isMerge = $action === "merge";
            var isReplace = $action === "replace";
            if (isMerge) {
                var isInit = !elExisting;
                var el_1 = elExisting;
                if (isInit) el_1 = $2b680c3ccdb25c77$var$createEl(id, targetElParent, elOption.type, elMap);
                else {
                    el_1 && ($2b680c3ccdb25c77$export$4ae363f1d88fb658(el_1).isNew = false);
                    // Stop and restore before update any other attributes.
                    (0, $ab8d73690f09fb6d$export$9e5c70edf1ec0cb4)(el_1);
                }
                if (el_1) {
                    (0, $7c104376a000308e$export$4342b281b9b5d77e)(el_1, elOptionCleaned, graphicModel, {
                        isInit: isInit
                    });
                    $2b680c3ccdb25c77$var$updateCommonAttrs(el_1, elOption, globalZ, globalZLevel);
                }
            } else if (isReplace) {
                $2b680c3ccdb25c77$var$removeEl(elExisting, elOption, elMap, graphicModel);
                var el_2 = $2b680c3ccdb25c77$var$createEl(id, targetElParent, elOption.type, elMap);
                if (el_2) {
                    (0, $7c104376a000308e$export$4342b281b9b5d77e)(el_2, elOptionCleaned, graphicModel, {
                        isInit: true
                    });
                    $2b680c3ccdb25c77$var$updateCommonAttrs(el_2, elOption, globalZ, globalZLevel);
                }
            } else if ($action === "remove") {
                (0, $7c104376a000308e$export$a6f11bb1cb100e2a)(elExisting, elOption);
                $2b680c3ccdb25c77$var$removeEl(elExisting, elOption, elMap, graphicModel);
            }
            var el = elMap.get(id);
            if (el && textContentOption) {
                if (isMerge) {
                    var textContentExisting = el.getTextContent();
                    textContentExisting ? textContentExisting.attr(textContentOption) : el.setTextContent(new $fe885cc21795562b$export$2e2bcd8739ae039(textContentOption));
                } else if (isReplace) el.setTextContent(new $fe885cc21795562b$export$2e2bcd8739ae039(textContentOption));
            }
            if (el) {
                var clipPathOption = elOption.clipPath;
                if (clipPathOption) {
                    var clipPathType = clipPathOption.type;
                    var clipPath = void 0;
                    var isInit = false;
                    if (isMerge) {
                        var oldClipPath = el.getClipPath();
                        isInit = !oldClipPath || $2b680c3ccdb25c77$export$4ae363f1d88fb658(oldClipPath).type !== clipPathType;
                        clipPath = isInit ? $2b680c3ccdb25c77$var$newEl(clipPathType) : oldClipPath;
                    } else if (isReplace) {
                        isInit = true;
                        clipPath = $2b680c3ccdb25c77$var$newEl(clipPathType);
                    }
                    el.setClipPath(clipPath);
                    (0, $7c104376a000308e$export$4342b281b9b5d77e)(clipPath, clipPathOption, graphicModel, {
                        isInit: isInit
                    });
                    (0, $ab8d73690f09fb6d$export$b0aa6a5f01693fa4)(clipPath, clipPathOption.keyframeAnimation, graphicModel);
                }
                var elInner = $2b680c3ccdb25c77$export$4ae363f1d88fb658(el);
                el.setTextConfig(textConfig);
                elInner.option = elOption;
                $2b680c3ccdb25c77$var$setEventData(el, graphicModel, elOption);
                $5b455ae6f843ac47$export$fc6410d97fab306c({
                    el: el,
                    componentModel: graphicModel,
                    itemName: el.name,
                    itemTooltipOption: elOption.tooltip
                });
                (0, $ab8d73690f09fb6d$export$b0aa6a5f01693fa4)(el, elOption.keyframeAnimation, graphicModel);
            }
        });
    };
    /**
   * Locate graphic elements.
   */ GraphicComponentView.prototype._relocate = function(graphicModel, api) {
        var elOptions = graphicModel.option.elements;
        var rootGroup = this.group;
        var elMap = this._elMap;
        var apiWidth = api.getWidth();
        var apiHeight = api.getHeight();
        var xy = [
            "x",
            "y"
        ];
        // Top-down to calculate percentage width/height of group
        for(var i = 0; i < elOptions.length; i++){
            var elOption = elOptions[i];
            var id = $76d619f648247e6d$export$fb1a222ba5dd6e51(elOption.id, null);
            var el = id != null ? elMap.get(id) : null;
            if (!el || !el.isGroup) continue;
            var parentEl = el.parent;
            var isParentRoot = parentEl === rootGroup;
            // Like 'position:absolut' in css, default 0.
            var elInner = $2b680c3ccdb25c77$export$4ae363f1d88fb658(el);
            var parentElInner = $2b680c3ccdb25c77$export$4ae363f1d88fb658(parentEl);
            elInner.width = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(elInner.option.width, isParentRoot ? apiWidth : parentElInner.width) || 0;
            elInner.height = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(elInner.option.height, isParentRoot ? apiHeight : parentElInner.height) || 0;
        }
        // Bottom-up tranvese all elements (consider ec resize) to locate elements.
        for(var i = elOptions.length - 1; i >= 0; i--){
            var elOption = elOptions[i];
            var id = $76d619f648247e6d$export$fb1a222ba5dd6e51(elOption.id, null);
            var el = id != null ? elMap.get(id) : null;
            if (!el) continue;
            var parentEl = el.parent;
            var parentElInner = $2b680c3ccdb25c77$export$4ae363f1d88fb658(parentEl);
            var containerInfo = parentEl === rootGroup ? {
                width: apiWidth,
                height: apiHeight
            } : {
                width: parentElInner.width,
                height: parentElInner.height
            };
            // PENDING
            // Currently, when `bounding: 'all'`, the union bounding rect of the group
            // does not include the rect of [0, 0, group.width, group.height], which
            // is probably weird for users. Should we make a break change for it?
            var layoutPos = {};
            var layouted = $93b9bc7f22ac7369$export$74054bd96b5eeef1(el, elOption, containerInfo, null, {
                hv: elOption.hv,
                boundingMode: elOption.bounding
            }, layoutPos);
            if (!$2b680c3ccdb25c77$export$4ae363f1d88fb658(el).isNew && layouted) {
                var transition = elOption.transition;
                var animatePos = {};
                for(var k = 0; k < xy.length; k++){
                    var key = xy[k];
                    var val = layoutPos[key];
                    if (transition && ((0, $7c104376a000308e$export$6f3361b4b8d7a8ba)(transition) || $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(transition, key) >= 0)) animatePos[key] = val;
                    else el[key] = val;
                }
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(el, animatePos, graphicModel, 0);
            } else el.attr(layoutPos);
        }
    };
    /**
   * Clear all elements.
   */ GraphicComponentView.prototype._clear = function() {
        var _this = this;
        var elMap = this._elMap;
        elMap.each(function(el) {
            $2b680c3ccdb25c77$var$removeEl(el, $2b680c3ccdb25c77$export$4ae363f1d88fb658(el).option, elMap, _this._lastGraphicModel);
        });
        this._elMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
    };
    GraphicComponentView.prototype.dispose = function() {
        this._clear();
    };
    GraphicComponentView.type = "graphic";
    return GraphicComponentView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $2b680c3ccdb25c77$var$newEl(graphicType) {
    var Clz = $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3($2b680c3ccdb25c77$var$nonShapeGraphicElements, graphicType) ? $2b680c3ccdb25c77$var$nonShapeGraphicElements[graphicType] : $5b455ae6f843ac47$export$51df4b5565a58189(graphicType);
    var el = new Clz({});
    $2b680c3ccdb25c77$export$4ae363f1d88fb658(el).type = graphicType;
    return el;
}
function $2b680c3ccdb25c77$var$createEl(id, targetElParent, graphicType, elMap) {
    var el = $2b680c3ccdb25c77$var$newEl(graphicType);
    targetElParent.add(el);
    elMap.set(id, el);
    $2b680c3ccdb25c77$export$4ae363f1d88fb658(el).id = id;
    $2b680c3ccdb25c77$export$4ae363f1d88fb658(el).isNew = true;
    return el;
}
function $2b680c3ccdb25c77$var$removeEl(elExisting, elOption, elMap, graphicModel) {
    var existElParent = elExisting && elExisting.parent;
    if (existElParent) {
        elExisting.type === "group" && elExisting.traverse(function(el) {
            $2b680c3ccdb25c77$var$removeEl(el, elOption, elMap, graphicModel);
        });
        (0, $7c104376a000308e$export$15575b6d82d35bb3)(elExisting, elOption, graphicModel);
        elMap.removeKey($2b680c3ccdb25c77$export$4ae363f1d88fb658(elExisting).id);
    }
}
function $2b680c3ccdb25c77$var$updateCommonAttrs(el, elOption, defaultZ, defaultZlevel) {
    if (!el.isGroup) $7a1bd9c2710fea0d$export$79b2f7037acddd43([
        [
            "cursor",
            (0, $56206a6cb4666931$export$2e2bcd8739ae039).prototype.cursor
        ],
        // We should not support configure z and zlevel in the element level.
        // But seems we didn't limit it previously. So here still use it to avoid breaking.
        [
            "zlevel",
            defaultZlevel || 0
        ],
        [
            "z",
            defaultZ || 0
        ],
        // z2 must not be null/undefined, otherwise sort error may occur.
        [
            "z2",
            0
        ]
    ], function(item) {
        var prop = item[0];
        if ($7a1bd9c2710fea0d$export$b5a638e9b3fff9f3(elOption, prop)) el[prop] = $7a1bd9c2710fea0d$export$995e01f2f5c9d030(elOption[prop], item[1]);
        else if (el[prop] == null) el[prop] = item[1];
    });
    $7a1bd9c2710fea0d$export$79b2f7037acddd43($7a1bd9c2710fea0d$export$ed97f33186d4b816(elOption), function(key) {
        // Assign event handlers.
        // PENDING: should enumerate all event names or use pattern matching?
        if (key.indexOf("on") === 0) {
            var val = elOption[key];
            el[key] = $7a1bd9c2710fea0d$export$f6e2535fb5126e54(val) ? val : null;
        }
    });
    if ($7a1bd9c2710fea0d$export$b5a638e9b3fff9f3(elOption, "draggable")) el.draggable = elOption.draggable;
    // Other attributes
    elOption.name != null && (el.name = elOption.name);
    elOption.id != null && (el.id = elOption.id);
}
// Remove unnecessary props to avoid potential problems.
function $2b680c3ccdb25c77$var$getCleanedElOption(elOption) {
    elOption = $7a1bd9c2710fea0d$export$8b58be045bf06082({}, elOption);
    $7a1bd9c2710fea0d$export$79b2f7037acddd43([
        "id",
        "parentId",
        "$action",
        "hv",
        "bounding",
        "textContent",
        "clipPath"
    ].concat($93b9bc7f22ac7369$export$a9aa2cc018afbed), function(name) {
        delete elOption[name];
    });
    return elOption;
}
function $2b680c3ccdb25c77$var$setEventData(el, graphicModel, elOption) {
    var eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).eventData;
    // Simple optimize for large amount of elements that no need event.
    if (!el.silent && !el.ignore && !eventData) eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).eventData = {
        componentType: "graphic",
        componentIndex: graphicModel.componentIndex,
        name: el.name
    };
    // `elOption.info` enables user to mount some info on
    // elements and use them in event handlers.
    if (eventData) eventData.info = elOption.info;
}


function $48174658d54922b7$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $21e1121941dbd8a9$export$6d85925da4d2cf23));
    registers.registerComponentView((0, $2b680c3ccdb25c77$export$1132c9ab9ad80748));
    registers.registerPreprocessor(function(option) {
        var graphicOption = option.graphic;
        // Convert
        // {graphic: [{left: 10, type: 'circle'}, ...]}
        // or
        // {graphic: {left: 10, type: 'circle'}}
        // to
        // {graphic: [{elements: [{left: 10, type: 'circle'}, ...]}]}
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(graphicOption)) {
            if (!graphicOption[0] || !graphicOption[0].elements) option.graphic = [
                {
                    elements: graphicOption
                }
            ];
            else // Only one graphic instance can be instantiated. (We don't
            // want that too many views are created in echarts._viewMap.)
            option.graphic = [
                option.graphic[0]
            ];
        } else if (graphicOption && !graphicOption.elements) option.graphic = [
            {
                elements: [
                    graphicOption
                ]
            }
        ];
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $30909b2e837c2175$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $1021478d6a16b0aa$export$4b3e715f166fdd78));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $0fbb1ae1b8df4cab$var$getDefaultSelectorOptions = function(ecModel, type) {
    if (type === "all") return {
        type: "all",
        title: ecModel.getLocaleModel().get([
            "legend",
            "selector",
            "all"
        ])
    };
    else if (type === "inverse") return {
        type: "inverse",
        title: ecModel.getLocaleModel().get([
            "legend",
            "selector",
            "inverse"
        ])
    };
};
var $0fbb1ae1b8df4cab$var$LegendModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LegendModel, _super);
    function LegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendModel.type;
        _this.layoutMode = {
            type: "box",
            // legend.width/height are maxWidth/maxHeight actually,
            // whereas real width/height is calculated by its content.
            // (Setting {left: 10, right: 10} does not make sense).
            // So consider the case:
            // `setOption({legend: {left: 10});`
            // then `setOption({legend: {right: 10});`
            // The previous `left` should be cleared by setting `ignoreSize`.
            ignoreSize: true
        };
        return _this;
    }
    LegendModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        option.selected = option.selected || {};
        this._updateSelector(option);
    };
    LegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        this._updateSelector(option);
    };
    LegendModel.prototype._updateSelector = function(option) {
        var selector = option.selector;
        var ecModel = this.ecModel;
        if (selector === true) selector = option.selector = [
            "all",
            "inverse"
        ];
        if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(selector)) $7a1bd9c2710fea0d$export$79b2f7037acddd43(selector, function(item, index) {
            $7a1bd9c2710fea0d$export$844ec244b1367d54(item) && (item = {
                type: item
            });
            selector[index] = $7a1bd9c2710fea0d$export$4950aa0f605343fb(item, $0fbb1ae1b8df4cab$var$getDefaultSelectorOptions(ecModel, item.type));
        });
    };
    LegendModel.prototype.optionUpdated = function() {
        this._updateData(this.ecModel);
        var legendData = this._data;
        // If selectedMode is single, try to select one
        if (legendData[0] && this.get("selectedMode") === "single") {
            var hasSelected = false;
            // If has any selected in option.selected
            for(var i = 0; i < legendData.length; i++){
                var name_1 = legendData[i].get("name");
                if (this.isSelected(name_1)) {
                    // Force to unselect others
                    this.select(name_1);
                    hasSelected = true;
                    break;
                }
            }
            // Try select the first if selectedMode is single
            !hasSelected && this.select(legendData[0].get("name"));
        }
    };
    LegendModel.prototype._updateData = function(ecModel) {
        var potentialData = [];
        var availableNames = [];
        ecModel.eachRawSeries(function(seriesModel) {
            var seriesName = seriesModel.name;
            availableNames.push(seriesName);
            var isPotential;
            if (seriesModel.legendVisualProvider) {
                var provider = seriesModel.legendVisualProvider;
                var names = provider.getAllNames();
                if (!ecModel.isSeriesFiltered(seriesModel)) availableNames = availableNames.concat(names);
                if (names.length) potentialData = potentialData.concat(names);
                else isPotential = true;
            } else isPotential = true;
            if (isPotential && (0, $76d619f648247e6d$export$beae19a2652b3368)(seriesModel)) potentialData.push(seriesModel.name);
        });
        /**
     * @type {Array.<string>}
     * @private
     */ this._availableNames = availableNames;
        // If legend.data is not specified in option, use availableNames as data,
        // which is convenient for user preparing option.
        var rawData = this.get("data") || potentialData;
        var legendNameMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var legendData = $7a1bd9c2710fea0d$export$871de8747c9eaa88(rawData, function(dataItem) {
            // Can be string or number
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(dataItem) || $7a1bd9c2710fea0d$export$7e4aa119212bc614(dataItem)) dataItem = {
                name: dataItem
            };
            if (legendNameMap.get(dataItem.name)) // remove legend name duplicate
            return null;
            legendNameMap.set(dataItem.name, true);
            return new (0, $6818646a97528290$export$2e2bcd8739ae039)(dataItem, this, this.ecModel);
        }, this);
        /**
     * @type {Array.<module:echarts/model/Model>}
     * @private
     */ this._data = $7a1bd9c2710fea0d$export$3dea766d36a8935f(legendData, function(item) {
            return !!item;
        });
    };
    LegendModel.prototype.getData = function() {
        return this._data;
    };
    LegendModel.prototype.select = function(name) {
        var selected = this.option.selected;
        var selectedMode = this.get("selectedMode");
        if (selectedMode === "single") {
            var data = this._data;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(dataItem) {
                selected[dataItem.get("name")] = false;
            });
        }
        selected[name] = true;
    };
    LegendModel.prototype.unSelect = function(name) {
        if (this.get("selectedMode") !== "single") this.option.selected[name] = false;
    };
    LegendModel.prototype.toggleSelected = function(name) {
        var selected = this.option.selected;
        // Default is true
        if (!selected.hasOwnProperty(name)) selected[name] = true;
        this[selected[name] ? "unSelect" : "select"](name);
    };
    LegendModel.prototype.allSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(dataItem) {
            selected[dataItem.get("name", true)] = true;
        });
    };
    LegendModel.prototype.inverseSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(data, function(dataItem) {
            var name = dataItem.get("name", true);
            // Initially, default value is true
            if (!selected.hasOwnProperty(name)) selected[name] = true;
            selected[name] = !selected[name];
        });
    };
    LegendModel.prototype.isSelected = function(name) {
        var selected = this.option.selected;
        return !(selected.hasOwnProperty(name) && !selected[name]) && $7a1bd9c2710fea0d$export$305f7d4e9d4624f2(this._availableNames, name) >= 0;
    };
    LegendModel.prototype.getOrient = function() {
        return this.get("orient") === "vertical" ? {
            index: 1,
            name: "vertical"
        } : {
            index: 0,
            name: "horizontal"
        };
    };
    LegendModel.type = "legend.plain";
    LegendModel.dependencies = [
        "series"
    ];
    LegendModel.defaultOption = {
        // zlevel: 0,
        z: 4,
        show: true,
        orient: "horizontal",
        left: "center",
        // right: 'center',
        top: 0,
        // bottom: null,
        align: "auto",
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: "#ccc",
        borderRadius: 0,
        borderWidth: 0,
        padding: 5,
        itemGap: 10,
        itemWidth: 25,
        itemHeight: 14,
        symbolRotate: "inherit",
        symbolKeepAspect: true,
        inactiveColor: "#ccc",
        inactiveBorderColor: "#ccc",
        inactiveBorderWidth: "auto",
        itemStyle: {
            color: "inherit",
            opacity: "inherit",
            borderColor: "inherit",
            borderWidth: "auto",
            borderCap: "inherit",
            borderJoin: "inherit",
            borderDashOffset: "inherit",
            borderMiterLimit: "inherit"
        },
        lineStyle: {
            width: "auto",
            color: "inherit",
            inactiveColor: "#ccc",
            inactiveWidth: 2,
            opacity: "inherit",
            type: "inherit",
            cap: "inherit",
            join: "inherit",
            dashOffset: "inherit",
            miterLimit: "inherit"
        },
        textStyle: {
            color: "#333"
        },
        selectedMode: true,
        selector: false,
        selectorLabel: {
            show: true,
            borderRadius: 10,
            padding: [
                3,
                5,
                3,
                5
            ],
            fontSize: 12,
            fontFamily: "sans-serif",
            color: "#666",
            borderWidth: 1,
            borderColor: "#666"
        },
        emphasis: {
            selectorLabel: {
                show: true,
                color: "#eee",
                backgroundColor: "#666"
            }
        },
        selectorPosition: "auto",
        selectorItemGap: 7,
        selectorButtonGap: 10,
        tooltip: {
            show: false
        }
    };
    return LegendModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $0fbb1ae1b8df4cab$export$2e2bcd8739ae039 = $0fbb1ae1b8df4cab$var$LegendModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck



function $40fca678c85406ff$export$b3219800bda33a1f(group, componentModel, api) {
    var boxLayoutParams = componentModel.getBoxLayoutParams();
    var padding = componentModel.get("padding");
    var viewportSize = {
        width: api.getWidth(),
        height: api.getHeight()
    };
    var rect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(boxLayoutParams, viewportSize, padding);
    (0, $93b9bc7f22ac7369$export$827f4ee28efc37)(componentModel.get("orient"), group, componentModel.get("itemGap"), rect.width, rect.height);
    (0, $93b9bc7f22ac7369$export$74054bd96b5eeef1)(group, boxLayoutParams, viewportSize, padding);
}
function $40fca678c85406ff$export$fae23936eedfad4f(rect, componentModel) {
    var padding = $c84c9521536c601a$export$f3a38102c49f4268(componentModel.get("padding"));
    var style = componentModel.getItemStyle([
        "color",
        "opacity"
    ]);
    style.fill = componentModel.get("backgroundColor");
    rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
        shape: {
            x: rect.x - padding[3],
            y: rect.y - padding[0],
            width: rect.width + padding[1] + padding[3],
            height: rect.height + padding[0] + padding[2],
            r: componentModel.get("borderRadius")
        },
        style: style,
        silent: true,
        z2: -1
    });
    // FIXME
    // `subPixelOptimizeRect` may bring some gap between edge of viewpart
    // and background rect when setting like `left: 0`, `top: 0`.
    // graphic.subPixelOptimizeRect(rect);
    return rect;
}







var $c2e212625ccc38b4$var$curry = $7a1bd9c2710fea0d$export$c3095a23b368d1f2;
var $c2e212625ccc38b4$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $c2e212625ccc38b4$var$Group = $7ef7583d8302ffce$export$2e2bcd8739ae039;
var $c2e212625ccc38b4$var$LegendView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(LegendView, _super);
    function LegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendView.type;
        _this.newlineDisabled = false;
        return _this;
    }
    LegendView.prototype.init = function() {
        this.group.add(this._contentGroup = new $c2e212625ccc38b4$var$Group());
        this.group.add(this._selectorGroup = new $c2e212625ccc38b4$var$Group());
        this._isFirstRender = true;
    };
    /**
   * @protected
   */ LegendView.prototype.getContentGroup = function() {
        return this._contentGroup;
    };
    /**
   * @protected
   */ LegendView.prototype.getSelectorGroup = function() {
        return this._selectorGroup;
    };
    /**
   * @override
   */ LegendView.prototype.render = function(legendModel, ecModel, api) {
        var isFirstRender = this._isFirstRender;
        this._isFirstRender = false;
        this.resetInner();
        if (!legendModel.get("show", true)) return;
        var itemAlign = legendModel.get("align");
        var orient = legendModel.get("orient");
        if (!itemAlign || itemAlign === "auto") itemAlign = legendModel.get("left") === "right" && orient === "vertical" ? "right" : "left";
        // selector has been normalized to an array in model
        var selector = legendModel.get("selector", true);
        var selectorPosition = legendModel.get("selectorPosition", true);
        if (selector && (!selectorPosition || selectorPosition === "auto")) selectorPosition = orient === "horizontal" ? "end" : "start";
        this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        // Perform layout.
        var positionInfo = legendModel.getBoxLayoutParams();
        var viewportSize = {
            width: api.getWidth(),
            height: api.getHeight()
        };
        var padding = legendModel.get("padding");
        var maxSize = $93b9bc7f22ac7369$export$4517a5ca639a7293(positionInfo, viewportSize, padding);
        var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition);
        // Place mainGroup, based on the calculated `mainRect`.
        var layoutRect = $93b9bc7f22ac7369$export$4517a5ca639a7293($7a1bd9c2710fea0d$export$ebe90cb607ad99e({
            width: mainRect.width,
            height: mainRect.height
        }, positionInfo), viewportSize, padding);
        this.group.x = layoutRect.x - mainRect.x;
        this.group.y = layoutRect.y - mainRect.y;
        this.group.markRedraw();
        // Render background after group is layout.
        this.group.add(this._backgroundEl = (0, $40fca678c85406ff$export$fae23936eedfad4f)(mainRect, legendModel));
    };
    LegendView.prototype.resetInner = function() {
        this.getContentGroup().removeAll();
        this._backgroundEl && this.group.remove(this._backgroundEl);
        this.getSelectorGroup().removeAll();
    };
    LegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var legendDrawnMap = $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4();
        var selectMode = legendModel.get("selectedMode");
        var excludeSeriesId = [];
        ecModel.eachRawSeries(function(seriesModel) {
            !seriesModel.get("legendHoverLink") && excludeSeriesId.push(seriesModel.id);
        });
        $c2e212625ccc38b4$var$each(legendModel.getData(), function(legendItemModel, dataIndex) {
            var name = legendItemModel.get("name");
            // Use empty string or \n as a newline string
            if (!this.newlineDisabled && (name === "" || name === "\n")) {
                var g = new $c2e212625ccc38b4$var$Group();
                // @ts-ignore
                g.newline = true;
                contentGroup.add(g);
                return;
            }
            // Representitive series.
            var seriesModel = ecModel.getSeriesByName(name)[0];
            if (legendDrawnMap.get(name)) // Have been drawn
            return;
            // Legend to control series.
            if (seriesModel) {
                var data = seriesModel.getData();
                var lineVisualStyle = data.getVisual("legendLineStyle") || {};
                var legendIcon = data.getVisual("legendIcon");
                /**
         * `data.getVisual('style')` may be the color from the register
         * in series. For example, for line series,
         */ var style = data.getVisual("style");
                var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, style, legendIcon, selectMode, api);
                itemGroup.on("click", $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchSelectAction, name, null, api, excludeSeriesId)).on("mouseover", $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on("mouseout", $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
                if (ecModel.ssr) itemGroup.eachChild(function(child) {
                    var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child);
                    ecData.seriesIndex = seriesModel.seriesIndex;
                    ecData.dataIndex = dataIndex;
                    ecData.ssrType = "legend";
                });
                legendDrawnMap.set(name, true);
            } else // Legend to control data. In pie and funnel.
            ecModel.eachRawSeries(function(seriesModel) {
                // In case multiple series has same data name
                if (legendDrawnMap.get(name)) return;
                if (seriesModel.legendVisualProvider) {
                    var provider = seriesModel.legendVisualProvider;
                    if (!provider.containName(name)) return;
                    var idx = provider.indexOfName(name);
                    var style = provider.getItemVisual(idx, "style");
                    var legendIcon = provider.getItemVisual(idx, "legendIcon");
                    var colorArr = (0, $2c037f5bda6341ca$export$98e6a39c04603d36)(style.fill);
                    // Color may be set to transparent in visualMap when data is out of range.
                    // Do not show nothing.
                    if (colorArr && colorArr[3] === 0) {
                        colorArr[3] = 0.2;
                        // TODO color is set to 0, 0, 0, 0. Should show correct RGBA
                        style = $7a1bd9c2710fea0d$export$8b58be045bf06082($7a1bd9c2710fea0d$export$8b58be045bf06082({}, style), {
                            fill: (0, $2c037f5bda6341ca$export$fac44ee5b035f737)(colorArr, "rgba")
                        });
                    }
                    var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, {}, style, legendIcon, selectMode, api);
                    // FIXME: consider different series has items with the same name.
                    itemGroup.on("click", $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchSelectAction, null, name, api, excludeSeriesId))// Should not specify the series name, consider legend controls
                    // more than one pie series.
                    .on("mouseover", $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchHighlightAction, null, name, api, excludeSeriesId)).on("mouseout", $c2e212625ccc38b4$var$curry($c2e212625ccc38b4$var$dispatchDownplayAction, null, name, api, excludeSeriesId));
                    if (ecModel.ssr) itemGroup.eachChild(function(child) {
                        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child);
                        ecData.seriesIndex = seriesModel.seriesIndex;
                        ecData.dataIndex = dataIndex;
                        ecData.ssrType = "legend";
                    });
                    legendDrawnMap.set(name, true);
                }
            }, this);
        }, this);
        if (selector) this._createSelector(selector, legendModel, api, orient, selectorPosition);
    };
    LegendView.prototype._createSelector = function(selector, legendModel, api, orient, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        $c2e212625ccc38b4$var$each(selector, function createSelectorButton(selectorItem) {
            var type = selectorItem.type;
            var labelText = new $fe885cc21795562b$export$2e2bcd8739ae039({
                style: {
                    x: 0,
                    y: 0,
                    align: "center",
                    verticalAlign: "middle"
                },
                onclick: function() {
                    api.dispatchAction({
                        type: type === "all" ? "legendAllSelect" : "legendInverseSelect"
                    });
                }
            });
            selectorGroup.add(labelText);
            var labelModel = legendModel.getModel("selectorLabel");
            var emphasisLabelModel = legendModel.getModel([
                "emphasis",
                "selectorLabel"
            ]);
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(labelText, {
                normal: labelModel,
                emphasis: emphasisLabelModel
            }, {
                defaultText: selectorItem.title
            });
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(labelText);
        });
    };
    LegendView.prototype._createItem = function(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, itemVisualStyle, legendIcon, selectMode, api) {
        var drawType = seriesModel.visualDrawType;
        var itemWidth = legendModel.get("itemWidth");
        var itemHeight = legendModel.get("itemHeight");
        var isSelected = legendModel.isSelected(name);
        var iconRotate = legendItemModel.get("symbolRotate");
        var symbolKeepAspect = legendItemModel.get("symbolKeepAspect");
        var legendIconType = legendItemModel.get("icon");
        legendIcon = legendIconType || legendIcon || "roundRect";
        var style = $c2e212625ccc38b4$var$getLegendStyle(legendIcon, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api);
        var itemGroup = new $c2e212625ccc38b4$var$Group();
        var textStyleModel = legendItemModel.getModel("textStyle");
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(seriesModel.getLegendIcon) && (!legendIconType || legendIconType === "inherit")) // Series has specific way to define legend icon
        itemGroup.add(seriesModel.getLegendIcon({
            itemWidth: itemWidth,
            itemHeight: itemHeight,
            icon: legendIcon,
            iconRotate: iconRotate,
            itemStyle: style.itemStyle,
            lineStyle: style.lineStyle,
            symbolKeepAspect: symbolKeepAspect
        }));
        else {
            // Use default legend icon policy for most series
            var rotate = legendIconType === "inherit" && seriesModel.getData().getVisual("symbol") ? iconRotate === "inherit" ? seriesModel.getData().getVisual("symbolRotate") : iconRotate : 0; // No rotation for no icon
            itemGroup.add($c2e212625ccc38b4$var$getDefaultLegendIcon({
                itemWidth: itemWidth,
                itemHeight: itemHeight,
                icon: legendIcon,
                iconRotate: rotate,
                itemStyle: style.itemStyle,
                lineStyle: style.lineStyle,
                symbolKeepAspect: symbolKeepAspect
            }));
        }
        var textX = itemAlign === "left" ? itemWidth + 5 : -5;
        var textAlign = itemAlign;
        var formatter = legendModel.get("formatter");
        var content = name;
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter) && formatter) content = formatter.replace("{name}", name != null ? name : "");
        else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) content = formatter(name);
        var textColor = isSelected ? textStyleModel.getTextColor() : legendItemModel.get("inactiveColor");
        itemGroup.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                text: content,
                x: textX,
                y: itemHeight / 2,
                fill: textColor,
                align: textAlign,
                verticalAlign: "middle"
            }, {
                inheritColor: textColor
            })
        }));
        // Add a invisible rect to increase the area of mouse hover
        var hitRect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
            shape: itemGroup.getBoundingRect(),
            style: {
                // Cannot use 'invisible' because SVG SSR will miss the node
                fill: "transparent"
            }
        });
        var tooltipModel = legendItemModel.getModel("tooltip");
        if (tooltipModel.get("show")) $5b455ae6f843ac47$export$fc6410d97fab306c({
            el: hitRect,
            componentModel: legendModel,
            itemName: name,
            itemTooltipOption: tooltipModel.option
        });
        itemGroup.add(hitRect);
        itemGroup.eachChild(function(child) {
            child.silent = true;
        });
        hitRect.silent = !selectMode;
        this.getContentGroup().add(itemGroup);
        (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(itemGroup);
        // @ts-ignore
        itemGroup.__legendDataIndex = dataIndex;
        return itemGroup;
    };
    LegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var selectorGroup = this.getSelectorGroup();
        // Place items in contentGroup.
        $93b9bc7f22ac7369$export$827f4ee28efc37(legendModel.get("orient"), contentGroup, legendModel.get("itemGap"), maxSize.width, maxSize.height);
        var contentRect = contentGroup.getBoundingRect();
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        selectorGroup.markRedraw();
        contentGroup.markRedraw();
        if (selector) {
            // Place buttons in selectorGroup
            $93b9bc7f22ac7369$export$827f4ee28efc37(// Buttons in selectorGroup always layout horizontally
            "horizontal", selectorGroup, legendModel.get("selectorItemGap", true));
            var selectorRect = selectorGroup.getBoundingRect();
            var selectorPos = [
                -selectorRect.x,
                -selectorRect.y
            ];
            var selectorButtonGap = legendModel.get("selectorButtonGap", true);
            var orientIdx = legendModel.getOrient().index;
            var wh = orientIdx === 0 ? "width" : "height";
            var hw = orientIdx === 0 ? "height" : "width";
            var yx = orientIdx === 0 ? "y" : "x";
            if (selectorPosition === "end") selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
            else contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
            // Always align selector to content as 'middle'
            selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            var mainRect = {
                x: 0,
                y: 0
            };
            mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
            mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
            return mainRect;
        } else {
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            return this.group.getBoundingRect();
        }
    };
    /**
   * @protected
   */ LegendView.prototype.remove = function() {
        this.getContentGroup().removeAll();
        this._isFirstRender = true;
    };
    LegendView.type = "legend.plain";
    return LegendView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $c2e212625ccc38b4$var$getLegendStyle(iconType, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api) {
    /**
   * Use series style if is inherit;
   * elsewise, use legend style
   */ function handleCommonProps(style, visualStyle) {
        // If lineStyle.width is 'auto', it is set to be 2 if series has border
        if (style.lineWidth === "auto") style.lineWidth = visualStyle.lineWidth > 0 ? 2 : 0;
        $c2e212625ccc38b4$var$each(style, function(propVal, propName) {
            style[propName] === "inherit" && (style[propName] = visualStyle[propName]);
        });
    }
    // itemStyle
    var itemStyleModel = legendItemModel.getModel("itemStyle");
    var itemStyle = itemStyleModel.getItemStyle();
    var iconBrushType = iconType.lastIndexOf("empty", 0) === 0 ? "fill" : "stroke";
    var decalStyle = itemStyleModel.getShallow("decal");
    itemStyle.decal = !decalStyle || decalStyle === "inherit" ? itemVisualStyle.decal : (0, $c6d646aacd243427$export$a3ba048e1a648972)(decalStyle, api);
    if (itemStyle.fill === "inherit") /**
     * Series with visualDrawType as 'stroke' should have
     * series stroke as legend fill
     */ itemStyle.fill = itemVisualStyle[drawType];
    if (itemStyle.stroke === "inherit") /**
     * icon type with "emptyXXX" should use fill color
     * in visual style
     */ itemStyle.stroke = itemVisualStyle[iconBrushType];
    if (itemStyle.opacity === "inherit") /**
     * Use lineStyle.opacity if drawType is stroke
     */ itemStyle.opacity = (drawType === "fill" ? itemVisualStyle : lineVisualStyle).opacity;
    handleCommonProps(itemStyle, itemVisualStyle);
    // lineStyle
    var legendLineModel = legendItemModel.getModel("lineStyle");
    var lineStyle = legendLineModel.getLineStyle();
    handleCommonProps(lineStyle, lineVisualStyle);
    // Fix auto color to real color
    itemStyle.fill === "auto" && (itemStyle.fill = itemVisualStyle.fill);
    itemStyle.stroke === "auto" && (itemStyle.stroke = itemVisualStyle.fill);
    lineStyle.stroke === "auto" && (lineStyle.stroke = itemVisualStyle.fill);
    if (!isSelected) {
        var borderWidth = legendItemModel.get("inactiveBorderWidth");
        /**
     * Since stroke is set to be inactiveBorderColor, it may occur that
     * there is no border in series but border in legend, so we need to
     * use border only when series has border if is set to be auto
     */ var visualHasBorder = itemStyle[iconBrushType];
        itemStyle.lineWidth = borderWidth === "auto" ? itemVisualStyle.lineWidth > 0 && visualHasBorder ? 2 : 0 : itemStyle.lineWidth;
        itemStyle.fill = legendItemModel.get("inactiveColor");
        itemStyle.stroke = legendItemModel.get("inactiveBorderColor");
        lineStyle.stroke = legendLineModel.get("inactiveColor");
        lineStyle.lineWidth = legendLineModel.get("inactiveWidth");
    }
    return {
        itemStyle: itemStyle,
        lineStyle: lineStyle
    };
}
function $c2e212625ccc38b4$var$getDefaultLegendIcon(opt) {
    var symboType = opt.icon || "roundRect";
    var icon = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symboType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill, opt.symbolKeepAspect);
    icon.setStyle(opt.itemStyle);
    icon.rotation = (opt.iconRotate || 0) * Math.PI / 180;
    icon.setOrigin([
        opt.itemWidth / 2,
        opt.itemHeight / 2
    ]);
    if (symboType.indexOf("empty") > -1) {
        icon.style.stroke = icon.style.fill;
        icon.style.fill = "#fff";
        icon.style.lineWidth = 2;
    }
    return icon;
}
function $c2e212625ccc38b4$var$dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
    // downplay before unselect
    $c2e212625ccc38b4$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
    api.dispatchAction({
        type: "legendToggleSelect",
        name: seriesName != null ? seriesName : dataName
    });
    // highlight after select
    // TODO highlight immediately may cause animation loss.
    $c2e212625ccc38b4$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
}
function $c2e212625ccc38b4$var$isUseHoverLayer(api) {
    var list = api.getZr().storage.getDisplayList();
    var emphasisState;
    var i = 0;
    var len = list.length;
    while(i < len && !(emphasisState = list[i].states.emphasis))i++;
    return emphasisState && emphasisState.hoverLayer;
}
function $c2e212625ccc38b4$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
    // If element hover will move to a hoverLayer.
    if (!$c2e212625ccc38b4$var$isUseHoverLayer(api)) api.dispatchAction({
        type: "highlight",
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
function $c2e212625ccc38b4$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
    // If element hover will move to a hoverLayer.
    if (!$c2e212625ccc38b4$var$isUseHoverLayer(api)) api.dispatchAction({
        type: "downplay",
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
var $c2e212625ccc38b4$export$2e2bcd8739ae039 = $c2e212625ccc38b4$var$LegendView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $c618818715ebe216$export$2e2bcd8739ae039(ecModel) {
    var legendModels = ecModel.findComponents({
        mainType: "legend"
    });
    if (legendModels && legendModels.length) ecModel.filterSeries(function(series) {
        // If in any legend component the status is not selected.
        // Because in legend series is assumed selected when it is not in the legend data.
        for(var i = 0; i < legendModels.length; i++){
            if (!legendModels[i].isSelected(series.name)) return false;
        }
        return true;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

function $19822663d90c963e$var$legendSelectActionHandler(methodName, payload, ecModel) {
    var selectedMap = {};
    var isToggleSelect = methodName === "toggleSelected";
    var isSelected;
    // Update all legend components
    ecModel.eachComponent("legend", function(legendModel) {
        if (isToggleSelect && isSelected != null) // Force other legend has same selected status
        // Or the first is toggled to true and other are toggled to false
        // In the case one legend has some item unSelected in option. And if other legend
        // doesn't has the item, they will assume it is selected.
        legendModel[isSelected ? "select" : "unSelect"](payload.name);
        else if (methodName === "allSelect" || methodName === "inverseSelect") legendModel[methodName]();
        else {
            legendModel[methodName](payload.name);
            isSelected = legendModel.isSelected(payload.name);
        }
        var legendData = legendModel.getData();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(legendData, function(model) {
            var name = model.get("name");
            // Wrap element
            if (name === "\n" || name === "") return;
            var isItemSelected = legendModel.isSelected(name);
            if (selectedMap.hasOwnProperty(name)) // Unselected if any legend is unselected
            selectedMap[name] = selectedMap[name] && isItemSelected;
            else selectedMap[name] = isItemSelected;
        });
    });
    // Return the event explicitly
    return methodName === "allSelect" || methodName === "inverseSelect" ? {
        selected: selectedMap
    } : {
        name: payload.name,
        selected: selectedMap
    };
}
function $19822663d90c963e$export$139982ea529c452f(registers) {
    /**
   * @event legendToggleSelect
   * @type {Object}
   * @property {string} type 'legendToggleSelect'
   * @property {string} [from]
   * @property {string} name Series name or data item name
   */ registers.registerAction("legendToggleSelect", "legendselectchanged", (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, "toggleSelected"));
    registers.registerAction("legendAllSelect", "legendselectall", (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, "allSelect"));
    registers.registerAction("legendInverseSelect", "legendinverseselect", (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, "inverseSelect"));
    /**
   * @event legendSelect
   * @type {Object}
   * @property {string} type 'legendSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction("legendSelect", "legendselected", (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, "select"));
    /**
   * @event legendUnSelect
   * @type {Object}
   * @property {string} type 'legendUnSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction("legendUnSelect", "legendunselected", (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($19822663d90c963e$var$legendSelectActionHandler, "unSelect"));
}


function $407c7fdad108ade5$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $0fbb1ae1b8df4cab$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $c2e212625ccc38b4$export$2e2bcd8739ae039));
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.SERIES_FILTER, (0, $c618818715ebe216$export$2e2bcd8739ae039));
    registers.registerSubTypeDefaulter("legend", function() {
        return "plain";
    });
    (0, $19822663d90c963e$export$139982ea529c452f)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $a19f9768bdff02b5$var$ScrollableLegendModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ScrollableLegendModel, _super);
    function ScrollableLegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendModel.type;
        return _this;
    }
    /**
   * @param {number} scrollDataIndex
   */ ScrollableLegendModel.prototype.setScrollDataIndex = function(scrollDataIndex) {
        this.option.scrollDataIndex = scrollDataIndex;
    };
    ScrollableLegendModel.prototype.init = function(option, parentModel, ecModel) {
        var inputPositionParams = (0, $93b9bc7f22ac7369$export$4b0d20af19c9875e)(option);
        _super.prototype.init.call(this, option, parentModel, ecModel);
        $a19f9768bdff02b5$var$mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
    };
    /**
   * @override
   */ ScrollableLegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        $a19f9768bdff02b5$var$mergeAndNormalizeLayoutParams(this, this.option, option);
    };
    ScrollableLegendModel.type = "legend.scroll";
    ScrollableLegendModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $0fbb1ae1b8df4cab$export$2e2bcd8739ae039).defaultOption, {
        scrollDataIndex: 0,
        pageButtonItemGap: 5,
        pageButtonGap: null,
        pageButtonPosition: "end",
        pageFormatter: "{current}/{total}",
        pageIcons: {
            horizontal: [
                "M0,0L12,-10L12,10z",
                "M0,0L-12,-10L-12,10z"
            ],
            vertical: [
                "M0,0L20,0L10,-20z",
                "M0,0L20,0L10,20z"
            ]
        },
        pageIconColor: "#2f4554",
        pageIconInactiveColor: "#aaa",
        pageIconSize: 15,
        pageTextStyle: {
            color: "#333"
        },
        animationDurationUpdate: 800
    });
    return ScrollableLegendModel;
}((0, $0fbb1ae1b8df4cab$export$2e2bcd8739ae039));
// Do not `ignoreSize` to enable setting {left: 10, right: 10}.
function $a19f9768bdff02b5$var$mergeAndNormalizeLayoutParams(legendModel, target, raw) {
    var orient = legendModel.getOrient();
    var ignoreSize = [
        1,
        1
    ];
    ignoreSize[orient.index] = 0;
    (0, $93b9bc7f22ac7369$export$1754cb91f16ca028)(target, raw, {
        type: "box",
        ignoreSize: !!ignoreSize
    });
}
var $a19f9768bdff02b5$export$2e2bcd8739ae039 = $a19f9768bdff02b5$var$ScrollableLegendModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $47ff4587191e73cd$var$Group = $7ef7583d8302ffce$export$2e2bcd8739ae039;
var $47ff4587191e73cd$var$WH = [
    "width",
    "height"
];
var $47ff4587191e73cd$var$XY = [
    "x",
    "y"
];
var $47ff4587191e73cd$var$ScrollableLegendView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ScrollableLegendView, _super);
    function ScrollableLegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendView.type;
        _this.newlineDisabled = true;
        _this._currentIndex = 0;
        return _this;
    }
    ScrollableLegendView.prototype.init = function() {
        _super.prototype.init.call(this);
        this.group.add(this._containerGroup = new $47ff4587191e73cd$var$Group());
        this._containerGroup.add(this.getContentGroup());
        this.group.add(this._controllerGroup = new $47ff4587191e73cd$var$Group());
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.resetInner = function() {
        _super.prototype.resetInner.call(this);
        this._controllerGroup.removeAll();
        this._containerGroup.removeClipPath();
        this._containerGroup.__rectSize = null;
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var self = this;
        // Render content items.
        _super.prototype.renderInner.call(this, itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        var controllerGroup = this._controllerGroup;
        // FIXME: support be 'auto' adapt to size number text length,
        // e.g., '3/12345' should not overlap with the control arrow button.
        var pageIconSize = legendModel.get("pageIconSize", true);
        var pageIconSizeArr = $7a1bd9c2710fea0d$export$43bee75e5e14138e(pageIconSize) ? pageIconSize : [
            pageIconSize,
            pageIconSize
        ];
        createPageButton("pagePrev", 0);
        var pageTextStyleModel = legendModel.getModel("pageTextStyle");
        controllerGroup.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
            name: "pageText",
            style: {
                // Placeholder to calculate a proper layout.
                text: "xx/xx",
                fill: pageTextStyleModel.getTextColor(),
                font: pageTextStyleModel.getFont(),
                verticalAlign: "middle",
                align: "center"
            },
            silent: true
        }));
        createPageButton("pageNext", 1);
        function createPageButton(name, iconIdx) {
            var pageDataIndexName = name + "DataIndex";
            var icon = $5b455ae6f843ac47$export$274edc73af1ae9c8(legendModel.get("pageIcons", true)[legendModel.getOrient().name][iconIdx], {
                // Buttons will be created in each render, so we do not need
                // to worry about avoiding using legendModel kept in scope.
                onclick: $7a1bd9c2710fea0d$export$2385a24977818dd0(self._pageGo, self, pageDataIndexName, legendModel, api)
            }, {
                x: -pageIconSizeArr[0] / 2,
                y: -pageIconSizeArr[1] / 2,
                width: pageIconSizeArr[0],
                height: pageIconSizeArr[1]
            });
            icon.name = name;
            controllerGroup.add(icon);
        }
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        var orientIdx = legendModel.getOrient().index;
        var wh = $47ff4587191e73cd$var$WH[orientIdx];
        var xy = $47ff4587191e73cd$var$XY[orientIdx];
        var hw = $47ff4587191e73cd$var$WH[1 - orientIdx];
        var yx = $47ff4587191e73cd$var$XY[1 - orientIdx];
        selector && $93b9bc7f22ac7369$export$827f4ee28efc37(// Buttons in selectorGroup always layout horizontally
        "horizontal", selectorGroup, legendModel.get("selectorItemGap", true));
        var selectorButtonGap = legendModel.get("selectorButtonGap", true);
        var selectorRect = selectorGroup.getBoundingRect();
        var selectorPos = [
            -selectorRect.x,
            -selectorRect.y
        ];
        var processMaxSize = $7a1bd9c2710fea0d$export$9cd59f9826255e47(maxSize);
        selector && (processMaxSize[wh] = maxSize[wh] - selectorRect[wh] - selectorButtonGap);
        var mainRect = this._layoutContentAndController(legendModel, isFirstRender, processMaxSize, orientIdx, wh, hw, yx, xy);
        if (selector) {
            if (selectorPosition === "end") selectorPos[orientIdx] += mainRect[wh] + selectorButtonGap;
            else {
                var offset = selectorRect[wh] + selectorButtonGap;
                selectorPos[orientIdx] -= offset;
                mainRect[xy] -= offset;
            }
            mainRect[wh] += selectorRect[wh] + selectorButtonGap;
            selectorPos[1 - orientIdx] += mainRect[yx] + mainRect[hw] / 2 - selectorRect[hw] / 2;
            mainRect[hw] = Math.max(mainRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(mainRect[yx], selectorRect[yx] + selectorPos[1 - orientIdx]);
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            selectorGroup.markRedraw();
        }
        return mainRect;
    };
    ScrollableLegendView.prototype._layoutContentAndController = function(legendModel, isFirstRender, maxSize, orientIdx, wh, hw, yx, xy) {
        var contentGroup = this.getContentGroup();
        var containerGroup = this._containerGroup;
        var controllerGroup = this._controllerGroup;
        // Place items in contentGroup.
        $93b9bc7f22ac7369$export$827f4ee28efc37(legendModel.get("orient"), contentGroup, legendModel.get("itemGap"), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
        $93b9bc7f22ac7369$export$827f4ee28efc37(// Buttons in controller are layout always horizontally.
        "horizontal", controllerGroup, legendModel.get("pageButtonItemGap", true));
        var contentRect = contentGroup.getBoundingRect();
        var controllerRect = controllerGroup.getBoundingRect();
        var showController = this._showController = contentRect[wh] > maxSize[wh];
        // In case that the inner elements of contentGroup layout do not based on [0, 0]
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        // Remain contentPos when scroll animation perfroming.
        // If first rendering, `contentGroup.position` is [0, 0], which
        // does not make sense and may cause unexepcted animation if adopted.
        if (!isFirstRender) contentPos[orientIdx] = contentGroup[xy];
        // Layout container group based on 0.
        var containerPos = [
            0,
            0
        ];
        var controllerPos = [
            -controllerRect.x,
            -controllerRect.y
        ];
        var pageButtonGap = $7a1bd9c2710fea0d$export$995e01f2f5c9d030(legendModel.get("pageButtonGap", true), legendModel.get("itemGap", true));
        // Place containerGroup and controllerGroup and contentGroup.
        if (showController) {
            var pageButtonPosition = legendModel.get("pageButtonPosition", true);
            // controller is on the right / bottom.
            if (pageButtonPosition === "end") controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
            else containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
        }
        // Always align controller to content as 'middle'.
        controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
        contentGroup.setPosition(contentPos);
        containerGroup.setPosition(containerPos);
        controllerGroup.setPosition(controllerPos);
        // Calculate `mainRect` and set `clipPath`.
        // mainRect should not be calculated by `this.group.getBoundingRect()`
        // for sake of the overflow.
        var mainRect = {
            x: 0,
            y: 0
        };
        // Consider content may be overflow (should be clipped).
        mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
        mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]);
        // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.
        mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
        containerGroup.__rectSize = maxSize[wh];
        if (showController) {
            var clipShape = {
                x: 0,
                y: 0
            };
            clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
            clipShape[hw] = mainRect[hw];
            containerGroup.setClipPath(new $419e5ff2f303755e$export$2e2bcd8739ae039({
                shape: clipShape
            }));
            // Consider content may be larger than container, container rect
            // can not be obtained from `containerGroup.getBoundingRect()`.
            containerGroup.__rectSize = clipShape[wh];
        } else // Do not remove or ignore controller. Keep them set as placeholders.
        controllerGroup.eachChild(function(child) {
            child.attr({
                invisible: true,
                silent: true
            });
        });
        // Content translate animation.
        var pageInfo = this._getPageInfo(legendModel);
        pageInfo.pageIndex != null && $8b353638fbedfefa$export$c8dce3c08436e91e(contentGroup, {
            x: pageInfo.contentPosition[0],
            y: pageInfo.contentPosition[1]
        }, // When switch from "show controller" to "not show controller", view should be
        // updated immediately without animation, otherwise causes weird effect.
        showController ? legendModel : null);
        this._updatePageInfoView(legendModel, pageInfo);
        return mainRect;
    };
    ScrollableLegendView.prototype._pageGo = function(to, legendModel, api) {
        var scrollDataIndex = this._getPageInfo(legendModel)[to];
        scrollDataIndex != null && api.dispatchAction({
            type: "legendScroll",
            scrollDataIndex: scrollDataIndex,
            legendId: legendModel.id
        });
    };
    ScrollableLegendView.prototype._updatePageInfoView = function(legendModel, pageInfo) {
        var controllerGroup = this._controllerGroup;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            "pagePrev",
            "pageNext"
        ], function(name) {
            var key = name + "DataIndex";
            var canJump = pageInfo[key] != null;
            var icon = controllerGroup.childOfName(name);
            if (icon) {
                icon.setStyle("fill", canJump ? legendModel.get("pageIconColor", true) : legendModel.get("pageIconInactiveColor", true));
                icon.cursor = canJump ? "pointer" : "default";
            }
        });
        var pageText = controllerGroup.childOfName("pageText");
        var pageFormatter = legendModel.get("pageFormatter");
        var pageIndex = pageInfo.pageIndex;
        var current = pageIndex != null ? pageIndex + 1 : 0;
        var total = pageInfo.pageCount;
        pageText && pageFormatter && pageText.setStyle("text", $7a1bd9c2710fea0d$export$844ec244b1367d54(pageFormatter) ? pageFormatter.replace("{current}", current == null ? "" : current + "").replace("{total}", total == null ? "" : total + "") : pageFormatter({
            current: current,
            total: total
        }));
    };
    /**
   *  contentPosition: Array.<number>, null when data item not found.
   *  pageIndex: number, null when data item not found.
   *  pageCount: number, always be a number, can be 0.
   *  pagePrevDataIndex: number, null when no previous page.
   *  pageNextDataIndex: number, null when no next page.
   * }
   */ ScrollableLegendView.prototype._getPageInfo = function(legendModel) {
        var scrollDataIndex = legendModel.get("scrollDataIndex", true);
        var contentGroup = this.getContentGroup();
        var containerRectSize = this._containerGroup.__rectSize;
        var orientIdx = legendModel.getOrient().index;
        var wh = $47ff4587191e73cd$var$WH[orientIdx];
        var xy = $47ff4587191e73cd$var$XY[orientIdx];
        var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);
        var children = contentGroup.children();
        var targetItem = children[targetItemIndex];
        var itemCount = children.length;
        var pCount = !itemCount ? 0 : 1;
        var result = {
            contentPosition: [
                contentGroup.x,
                contentGroup.y
            ],
            pageCount: pCount,
            pageIndex: pCount - 1,
            pagePrevDataIndex: null,
            pageNextDataIndex: null
        };
        if (!targetItem) return result;
        var targetItemInfo = getItemInfo(targetItem);
        result.contentPosition[orientIdx] = -targetItemInfo.s;
        // Strategy:
        // (1) Always align based on the left/top most item.
        // (2) It is user-friendly that the last item shown in the
        // current window is shown at the begining of next window.
        // Otherwise if half of the last item is cut by the window,
        // it will have no chance to display entirely.
        // (3) Consider that item size probably be different, we
        // have calculate pageIndex by size rather than item index,
        // and we can not get page index directly by division.
        // (4) The window is to narrow to contain more than
        // one item, we should make sure that the page can be fliped.
        for(var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i){
            currItemInfo = getItemInfo(children[i]);
            if (// Half of the last item is out of the window.
            !currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
                if (winEndItemInfo.i > winStartItemInfo.i) winStartItemInfo = winEndItemInfo;
                else // e.g., when page size is smaller than item size.
                winStartItemInfo = currItemInfo;
                if (winStartItemInfo) {
                    if (result.pageNextDataIndex == null) result.pageNextDataIndex = winStartItemInfo.i;
                    ++result.pageCount;
                }
            }
            winEndItemInfo = currItemInfo;
        }
        for(var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i){
            currItemInfo = getItemInfo(children[i]);
            if (// If the the end item does not intersect with the window started
            // from the current item, a page can be settled.
            (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && winStartItemInfo.i < winEndItemInfo.i) {
                winEndItemInfo = winStartItemInfo;
                if (result.pagePrevDataIndex == null) result.pagePrevDataIndex = winStartItemInfo.i;
                ++result.pageCount;
                ++result.pageIndex;
            }
            winStartItemInfo = currItemInfo;
        }
        return result;
        function getItemInfo(el) {
            if (el) {
                var itemRect = el.getBoundingRect();
                var start = itemRect[xy] + el[xy];
                return {
                    s: start,
                    e: start + itemRect[wh],
                    i: el.__legendDataIndex
                };
            }
        }
        function intersect(itemInfo, winStart) {
            return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
        }
    };
    ScrollableLegendView.prototype._findTargetItemIndex = function(targetDataIndex) {
        if (!this._showController) return 0;
        var index;
        var contentGroup = this.getContentGroup();
        var defaultIndex;
        contentGroup.eachChild(function(child, idx) {
            var legendDataIdx = child.__legendDataIndex;
            // FIXME
            // If the given targetDataIndex (from model) is illegal,
            // we use defaultIndex. But the index on the legend model and
            // action payload is still illegal. That case will not be
            // changed until some scenario requires.
            if (defaultIndex == null && legendDataIdx != null) defaultIndex = idx;
            if (legendDataIdx === targetDataIndex) index = idx;
        });
        return index != null ? index : defaultIndex;
    };
    ScrollableLegendView.type = "legend.scroll";
    return ScrollableLegendView;
}((0, $c2e212625ccc38b4$export$2e2bcd8739ae039));
var $47ff4587191e73cd$export$2e2bcd8739ae039 = $47ff4587191e73cd$var$ScrollableLegendView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $8ff9a37bcf939bdd$export$2e2bcd8739ae039(registers) {
    /**
   * @event legendScroll
   * @type {Object}
   * @property {string} type 'legendScroll'
   * @property {string} scrollDataIndex
   */ registers.registerAction("legendScroll", "legendscroll", function(payload, ecModel) {
        var scrollDataIndex = payload.scrollDataIndex;
        scrollDataIndex != null && ecModel.eachComponent({
            mainType: "legend",
            subType: "scroll",
            query: payload
        }, function(legendModel) {
            legendModel.setScrollDataIndex(scrollDataIndex);
        });
    });
}


function $2861842f2dfd6682$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $407c7fdad108ade5$export$4b3e715f166fdd78));
    registers.registerComponentModel((0, $a19f9768bdff02b5$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $47ff4587191e73cd$export$2e2bcd8739ae039));
    (0, $8ff9a37bcf939bdd$export$2e2bcd8739ae039)(registers);
}


function $1a0761510a437d9f$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $407c7fdad108ade5$export$4b3e715f166fdd78));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $2861842f2dfd6682$export$4b3e715f166fdd78));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $bab2c9b6be98f0ce$export$2e2bcd8739ae039(seriesOpts, markerType) {
    if (!seriesOpts) return false;
    var seriesOptArr = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(seriesOpts) ? seriesOpts : [
        seriesOpts
    ];
    for(var idx = 0; idx < seriesOptArr.length; idx++){
        if (seriesOptArr[idx] && seriesOptArr[idx][markerType]) return true;
    }
    return false;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






function $1bab71219c0cd9a9$var$fillLabel(opt) {
    (0, $76d619f648247e6d$export$abdcc6a26372f94b)(opt, "label", [
        "show"
    ]);
}
// { [componentType]: MarkerModel }
var $1bab71219c0cd9a9$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $1bab71219c0cd9a9$var$MarkerModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkerModel, _super);
    function MarkerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkerModel.type;
        /**
     * If marker model is created by self from series
     */ _this.createdBySelf = false;
        return _this;
    }
    /**
   * @overrite
   */ MarkerModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        this._mergeOption(option, ecModel, false, true);
    };
    MarkerModel.prototype.isAnimationEnabled = function() {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node) return false;
        var hostSeries = this.__hostSeries;
        return this.getShallow("animation") && hostSeries && hostSeries.isAnimationEnabled();
    };
    /**
   * @overrite
   */ MarkerModel.prototype.mergeOption = function(newOpt, ecModel) {
        this._mergeOption(newOpt, ecModel, false, false);
    };
    MarkerModel.prototype._mergeOption = function(newOpt, ecModel, createdBySelf, isInit) {
        var componentType = this.mainType;
        if (!createdBySelf) ecModel.eachSeries(function(seriesModel) {
            // mainType can be markPoint, markLine, markArea
            var markerOpt = seriesModel.get(this.mainType, true);
            var markerModel = $1bab71219c0cd9a9$var$inner(seriesModel)[componentType];
            if (!markerOpt || !markerOpt.data) {
                $1bab71219c0cd9a9$var$inner(seriesModel)[componentType] = null;
                return;
            }
            if (!markerModel) {
                if (isInit) // Default label emphasis `position` and `show`
                $1bab71219c0cd9a9$var$fillLabel(markerOpt);
                $7a1bd9c2710fea0d$export$79b2f7037acddd43(markerOpt.data, function(item) {
                    // FIXME Overwrite fillLabel method ?
                    if (item instanceof Array) {
                        $1bab71219c0cd9a9$var$fillLabel(item[0]);
                        $1bab71219c0cd9a9$var$fillLabel(item[1]);
                    } else $1bab71219c0cd9a9$var$fillLabel(item);
                });
                markerModel = this.createMarkerModelFromSeries(markerOpt, this, ecModel);
                // markerModel = new ImplementedMarkerModel(
                //     markerOpt, this, ecModel
                // );
                $7a1bd9c2710fea0d$export$8b58be045bf06082(markerModel, {
                    mainType: this.mainType,
                    // Use the same series index and name
                    seriesIndex: seriesModel.seriesIndex,
                    name: seriesModel.name,
                    createdBySelf: true
                });
                markerModel.__hostSeries = seriesModel;
            } else markerModel._mergeOption(markerOpt, ecModel, true);
            $1bab71219c0cd9a9$var$inner(seriesModel)[componentType] = markerModel;
        }, this);
    };
    MarkerModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var itemName = data.getName(dataIndex);
        return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("section", {
            header: this.name,
            blocks: [
                (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                    name: itemName,
                    value: value,
                    noName: !itemName,
                    noValue: value == null
                })
            ]
        });
    };
    MarkerModel.prototype.getData = function() {
        return this._data;
    };
    MarkerModel.prototype.setData = function(data) {
        this._data = data;
    };
    MarkerModel.getMarkerModelFromSeries = function(seriesModel, // Support three types of markers. Strict check.
    componentType) {
        return $1bab71219c0cd9a9$var$inner(seriesModel)[componentType];
    };
    MarkerModel.type = "marker";
    MarkerModel.dependencies = [
        "series",
        "grid",
        "polar",
        "geo"
    ];
    return MarkerModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($1bab71219c0cd9a9$var$MarkerModel, (0, $655dd6075cc63601$export$f23396ae04ea95a7).prototype);
var $1bab71219c0cd9a9$export$2e2bcd8739ae039 = $1bab71219c0cd9a9$var$MarkerModel;


var $a4d9f6e367e83128$var$MarkAreaModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkAreaModel, _super);
    function MarkAreaModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkAreaModel.type;
        return _this;
    }
    MarkAreaModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkAreaModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkAreaModel.type = "markArea";
    MarkAreaModel.defaultOption = {
        // zlevel: 0,
        // PENDING
        z: 1,
        tooltip: {
            trigger: "item"
        },
        // markArea should fixed on the coordinate system
        animation: false,
        label: {
            show: true,
            position: "top"
        },
        itemStyle: {
            // color and borderColor default to use color from series
            // color: 'auto'
            // borderColor: 'auto'
            borderWidth: 0
        },
        emphasis: {
            label: {
                show: true,
                position: "top"
            }
        }
    };
    return MarkAreaModel;
}((0, $1bab71219c0cd9a9$export$2e2bcd8739ae039));
var $a4d9f6e367e83128$export$2e2bcd8739ae039 = $a4d9f6e367e83128$var$MarkAreaModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



function $e4ec0ddef831b3b2$var$hasXOrY(item) {
    return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
}
function $e4ec0ddef831b3b2$var$hasXAndY(item) {
    return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
}
function $e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent(markerType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
    var coordArr = [];
    var stacked = (0, $efdd976e4917927c$export$1dedc39359ae35c)(data, targetDataDim /* , otherDataDim */ );
    var calcDataDim = stacked ? data.getCalculationInfo("stackResultDimension") : targetDataDim;
    var value = $e4ec0ddef831b3b2$export$18ddefb55c03640b(data, calcDataDim, markerType);
    var dataIndex = data.indicesOfNearest(calcDataDim, value)[0];
    coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
    coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
    var coordArrValue = data.get(targetDataDim, dataIndex);
    // Make it simple, do not visit all stacked value to count precision.
    var precision = $cfc1f3b422a3185f$export$e0c74b50bbd10f68(data.get(targetDataDim, dataIndex));
    precision = Math.min(precision, 20);
    if (precision >= 0) coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
    return [
        coordArr,
        coordArrValue
    ];
}
// TODO Specified percent
var $e4ec0ddef831b3b2$var$markerTypeCalculator = {
    min: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent, "min"),
    max: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent, "max"),
    average: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent, "average"),
    median: (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$var$markerTypeCalculatorWithExtent, "median")
};
function $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, item) {
    if (!item) return;
    var data = seriesModel.getData();
    var coordSys = seriesModel.coordinateSystem;
    var dims = coordSys && coordSys.dimensions;
    // 1. If not specify the position with pixel directly
    // 2. If `coord` is not a data array. Which uses `xAxis`,
    // `yAxis` to specify the coord on each dimension
    // parseFloat first because item.x and item.y can be percent string like '20%'
    if (!$e4ec0ddef831b3b2$var$hasXAndY(item) && !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(item.coord) && (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dims)) {
        var axisInfo = $e4ec0ddef831b3b2$export$bd39458db76002ab(item, data, coordSys, seriesModel);
        // Clone the option
        // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value
        item = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(item);
        if (item.type && $e4ec0ddef831b3b2$var$markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
            var otherCoordIndex = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(dims, axisInfo.baseAxis.dim);
            var targetCoordIndex = (0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(dims, axisInfo.valueAxis.dim);
            var coordInfo = $e4ec0ddef831b3b2$var$markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
            item.coord = coordInfo[0];
            // Force to use the value of calculated value.
            // let item use the value without stack.
            item.value = coordInfo[1];
        } else // FIXME Only has one of xAxis and yAxis.
        item.coord = [
            item.xAxis != null ? item.xAxis : item.radiusAxis,
            item.yAxis != null ? item.yAxis : item.angleAxis
        ];
    }
    // x y is provided
    if (item.coord == null || !(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(dims)) item.coord = [];
    else {
        // Each coord support max, min, average
        var coord = item.coord;
        for(var i = 0; i < 2; i++)if ($e4ec0ddef831b3b2$var$markerTypeCalculator[coord[i]]) coord[i] = $e4ec0ddef831b3b2$export$18ddefb55c03640b(data, data.mapDimension(dims[i]), coord[i]);
    }
    return item;
}
function $e4ec0ddef831b3b2$export$bd39458db76002ab(item, data, coordSys, seriesModel) {
    var ret = {};
    if (item.valueIndex != null || item.valueDim != null) {
        ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
        ret.valueAxis = coordSys.getAxis($e4ec0ddef831b3b2$var$dataDimToCoordDim(seriesModel, ret.valueDataDim));
        ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
    } else {
        ret.baseAxis = seriesModel.getBaseAxis();
        ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
        ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
    }
    return ret;
}
function $e4ec0ddef831b3b2$var$dataDimToCoordDim(seriesModel, dataDim) {
    var dimItem = seriesModel.getData().getDimensionInfo(dataDim);
    return dimItem && dimItem.coordDim;
}
function $e4ec0ddef831b3b2$export$179695f4a9040f73(// Currently only polar and cartesian has containData.
coordSys, item) {
    // Always return true if there is no coordSys
    return coordSys && coordSys.containData && item.coord && !$e4ec0ddef831b3b2$var$hasXOrY(item) ? coordSys.containData(item.coord) : true;
}
function $e4ec0ddef831b3b2$export$c869311b63462da6(// Currently only polar and cartesian has containData.
coordSys, item1, item2) {
    // Always return true if there is no coordSys
    return coordSys && coordSys.containZone && item1.coord && item2.coord && !$e4ec0ddef831b3b2$var$hasXOrY(item1) && !$e4ec0ddef831b3b2$var$hasXOrY(item2) ? coordSys.containZone(item1.coord, item2.coord) : true;
}
function $e4ec0ddef831b3b2$export$a53767c3c8f69cf7(inCoordSys, dims) {
    return inCoordSys ? function(item, dimName, dataIndex, dimIndex) {
        var rawVal = dimIndex < 2 ? item.coord && item.coord[dimIndex] : item.value;
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(rawVal, dims[dimIndex]);
    } : function(item, dimName, dataIndex, dimIndex) {
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(item.value, dims[dimIndex]);
    };
}
function $e4ec0ddef831b3b2$export$18ddefb55c03640b(data, valueDataDim, type) {
    if (type === "average") {
        var sum_1 = 0;
        var count_1 = 0;
        data.each(valueDataDim, function(val, idx) {
            if (!isNaN(val)) {
                sum_1 += val;
                count_1++;
            }
        });
        return sum_1 / count_1;
    } else if (type === "median") return data.getMedian(valueDataDim);
    else // max & min
    return data.getDataExtent(valueDataDim)[type === "max" ? 1 : 0];
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $ed6cf827ec8a4c83$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $ed6cf827ec8a4c83$var$MarkerView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkerView, _super);
    function MarkerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkerView.type;
        return _this;
    }
    MarkerView.prototype.init = function() {
        this.markerGroupMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    };
    MarkerView.prototype.render = function(markerModel, ecModel, api) {
        var _this = this;
        var markerGroupMap = this.markerGroupMap;
        markerGroupMap.each(function(item) {
            $ed6cf827ec8a4c83$var$inner(item).keep = false;
        });
        ecModel.eachSeries(function(seriesModel) {
            var markerModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, _this.type);
            markerModel && _this.renderSeries(seriesModel, markerModel, ecModel, api);
        });
        markerGroupMap.each(function(item) {
            !$ed6cf827ec8a4c83$var$inner(item).keep && _this.group.remove(item.group);
        });
    };
    MarkerView.prototype.markKeep = function(drawGroup) {
        $ed6cf827ec8a4c83$var$inner(drawGroup).keep = true;
    };
    MarkerView.prototype.toggleBlurSeries = function(seriesModelList, isBlur) {
        var _this = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(seriesModelList, function(seriesModel) {
            var markerModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, _this.type);
            if (markerModel) {
                var data = markerModel.getData();
                data.eachItemGraphicEl(function(el) {
                    if (el) isBlur ? (0, $2bf82c0980125b62$export$207f9cb3e1099375)(el) : (0, $2bf82c0980125b62$export$fd4a9ec75456d3c1)(el);
                });
            }
        });
    };
    MarkerView.type = "marker";
    return MarkerView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $ed6cf827ec8a4c83$export$2e2bcd8739ae039 = $ed6cf827ec8a4c83$var$MarkerView;










var $83ebccb52de64002$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $83ebccb52de64002$var$markAreaTransform = function(seriesModel, coordSys, maModel, item) {
    // item may be null
    var item0 = item[0];
    var item1 = item[1];
    if (!item0 || !item1) return;
    var lt = $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, item0);
    var rb = $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, item1);
    // FIXME make sure lt is less than rb
    var ltCoord = lt.coord;
    var rbCoord = rb.coord;
    ltCoord[0] = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(ltCoord[0], -Infinity);
    ltCoord[1] = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(ltCoord[1], -Infinity);
    rbCoord[0] = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(rbCoord[0], Infinity);
    rbCoord[1] = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(rbCoord[1], Infinity);
    // Merge option into one
    var result = (0, $7a1bd9c2710fea0d$export$18aef43295bbe906)([
        {},
        lt,
        rb
    ]);
    result.coord = [
        lt.coord,
        rb.coord
    ];
    result.x0 = lt.x;
    result.y0 = lt.y;
    result.x1 = rb.x;
    result.y1 = rb.y;
    return result;
};
function $83ebccb52de64002$var$isInfinity(val) {
    return !isNaN(val) && !isFinite(val);
}
// If a markArea has one dim
function $83ebccb52de64002$var$ifMarkAreaHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
    var otherDimIndex = 1 - dimIndex;
    return $83ebccb52de64002$var$isInfinity(fromCoord[otherDimIndex]) && $83ebccb52de64002$var$isInfinity(toCoord[otherDimIndex]);
}
function $83ebccb52de64002$var$markAreaFilter(coordSys, item) {
    var fromCoord = item.coord[0];
    var toCoord = item.coord[1];
    var item0 = {
        coord: fromCoord,
        x: item.x0,
        y: item.y0
    };
    var item1 = {
        coord: toCoord,
        x: item.x1,
        y: item.y1
    };
    if ((0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, "cartesian2d")) {
        // In case
        // {
        //  markArea: {
        //    data: [{ yAxis: 2 }]
        //  }
        // }
        if (fromCoord && toCoord && ($83ebccb52de64002$var$ifMarkAreaHasOnlyDim(1, fromCoord, toCoord, coordSys) || $83ebccb52de64002$var$ifMarkAreaHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
        // Directly returning true may also do the work,
        // because markArea will not be shown automatically
        // when it's not included in coordinate system.
        // But filtering ahead can avoid keeping rendering markArea
        // when there are too many of them.
        return $e4ec0ddef831b3b2$export$c869311b63462da6(coordSys, item0, item1);
    }
    return $e4ec0ddef831b3b2$export$179695f4a9040f73(coordSys, item0) || $e4ec0ddef831b3b2$export$179695f4a9040f73(coordSys, item1);
}
// dims can be ['x0', 'y0'], ['x1', 'y1'], ['x0', 'y1'], ['x1', 'y0']
function $83ebccb52de64002$var$getSingleMarkerEndPoint(data, idx, dims, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var itemModel = data.getItemModel(idx);
    var point;
    var xPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get(dims[0]), api.getWidth());
    var yPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get(dims[1]), api.getHeight());
    if (!isNaN(xPx) && !isNaN(yPx)) point = [
        xPx,
        yPx
    ];
    else {
        // Chart like bar may have there own marker positioning logic
        if (seriesModel.getMarkerPosition) {
            // Consider the case that user input the right-bottom point first
            // Pick the larger x and y as 'x1' and 'y1'
            var pointValue0 = data.getValues([
                "x0",
                "y0"
            ], idx);
            var pointValue1 = data.getValues([
                "x1",
                "y1"
            ], idx);
            var clampPointValue0 = coordSys.clampData(pointValue0);
            var clampPointValue1 = coordSys.clampData(pointValue1);
            var pointValue = [];
            if (dims[0] === "x0") pointValue[0] = clampPointValue0[0] > clampPointValue1[0] ? pointValue1[0] : pointValue0[0];
            else pointValue[0] = clampPointValue0[0] > clampPointValue1[0] ? pointValue0[0] : pointValue1[0];
            if (dims[1] === "y0") pointValue[1] = clampPointValue0[1] > clampPointValue1[1] ? pointValue1[1] : pointValue0[1];
            else pointValue[1] = clampPointValue0[1] > clampPointValue1[1] ? pointValue0[1] : pointValue1[1];
            // Use the getMarkerPosition
            point = seriesModel.getMarkerPosition(pointValue, dims, true);
        } else {
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            var pt = [
                x,
                y
            ];
            coordSys.clampData && coordSys.clampData(pt, pt);
            point = coordSys.dataToPoint(pt, true);
        }
        if ((0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, "cartesian2d")) {
            // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
            var xAxis = coordSys.getAxis("x");
            var yAxis = coordSys.getAxis("y");
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            if ($83ebccb52de64002$var$isInfinity(x)) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[dims[0] === "x0" ? 0 : 1]);
            else if ($83ebccb52de64002$var$isInfinity(y)) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[dims[1] === "y0" ? 0 : 1]);
        }
        // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
    }
    return point;
}
var $83ebccb52de64002$export$fc5a505a325de211 = [
    [
        "x0",
        "y0"
    ],
    [
        "x1",
        "y0"
    ],
    [
        "x1",
        "y1"
    ],
    [
        "x0",
        "y1"
    ]
];
var $83ebccb52de64002$var$MarkAreaView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkAreaView, _super);
    function MarkAreaView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkAreaView.type;
        return _this;
    }
    MarkAreaView.prototype.updateTransform = function(markAreaModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var maModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, "markArea");
            if (maModel) {
                var areaData_1 = maModel.getData();
                areaData_1.each(function(idx) {
                    var points = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)($83ebccb52de64002$export$fc5a505a325de211, function(dim) {
                        return $83ebccb52de64002$var$getSingleMarkerEndPoint(areaData_1, idx, dim, seriesModel, api);
                    });
                    // Layout
                    areaData_1.setItemLayout(idx, points);
                    var el = areaData_1.getItemGraphicEl(idx);
                    el.setShape("points", points);
                });
            }
        }, this);
    };
    MarkAreaView.prototype.renderSeries = function(seriesModel, maModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var areaGroupMap = this.markerGroupMap;
        var polygonGroup = areaGroupMap.get(seriesId) || areaGroupMap.set(seriesId, {
            group: new $7ef7583d8302ffce$export$2e2bcd8739ae039()
        });
        this.group.add(polygonGroup.group);
        this.markKeep(polygonGroup);
        var areaData = $83ebccb52de64002$var$createList(coordSys, seriesModel, maModel);
        // Line data for tooltip and formatter
        maModel.setData(areaData);
        // Update visual and layout of line
        areaData.each(function(idx) {
            // Layout
            var points = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)($83ebccb52de64002$export$fc5a505a325de211, function(dim) {
                return $83ebccb52de64002$var$getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
            });
            var xAxisScale = coordSys.getAxis("x").scale;
            var yAxisScale = coordSys.getAxis("y").scale;
            var xAxisExtent = xAxisScale.getExtent();
            var yAxisExtent = yAxisScale.getExtent();
            var xPointExtent = [
                xAxisScale.parse(areaData.get("x0", idx)),
                xAxisScale.parse(areaData.get("x1", idx))
            ];
            var yPointExtent = [
                yAxisScale.parse(areaData.get("y0", idx)),
                yAxisScale.parse(areaData.get("y1", idx))
            ];
            $cfc1f3b422a3185f$export$debe6e778e0a6d32(xPointExtent);
            $cfc1f3b422a3185f$export$debe6e778e0a6d32(yPointExtent);
            var overlapped = !(xAxisExtent[0] > xPointExtent[1] || xAxisExtent[1] < xPointExtent[0] || yAxisExtent[0] > yPointExtent[1] || yAxisExtent[1] < yPointExtent[0]);
            // If none of the area is inside coordSys, allClipped is set to be true
            // in layout so that label will not be displayed. See #12591
            var allClipped = !overlapped;
            areaData.setItemLayout(idx, {
                points: points,
                allClipped: allClipped
            });
            var style = areaData.getItemModel(idx).getModel("itemStyle").getItemStyle();
            var color = (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(seriesData, "color");
            if (!style.fill) {
                style.fill = color;
                if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(style.fill)) style.fill = $2c037f5bda6341ca$export$ab4754bf42583a26(style.fill, 0.4);
            }
            if (!style.stroke) style.stroke = color;
            // Visual
            areaData.setItemVisual(idx, "style", style);
        });
        areaData.diff($83ebccb52de64002$var$inner(polygonGroup).data).add(function(idx) {
            var layout = areaData.getItemLayout(idx);
            if (!layout.allClipped) {
                var polygon = new $51acf033123e1a30$export$2e2bcd8739ae039({
                    shape: {
                        points: layout.points
                    }
                });
                areaData.setItemGraphicEl(idx, polygon);
                polygonGroup.group.add(polygon);
            }
        }).update(function(newIdx, oldIdx) {
            var polygon = $83ebccb52de64002$var$inner(polygonGroup).data.getItemGraphicEl(oldIdx);
            var layout = areaData.getItemLayout(newIdx);
            if (!layout.allClipped) {
                if (polygon) $8b353638fbedfefa$export$c8dce3c08436e91e(polygon, {
                    shape: {
                        points: layout.points
                    }
                }, maModel, newIdx);
                else polygon = new $51acf033123e1a30$export$2e2bcd8739ae039({
                    shape: {
                        points: layout.points
                    }
                });
                areaData.setItemGraphicEl(newIdx, polygon);
                polygonGroup.group.add(polygon);
            } else if (polygon) polygonGroup.group.remove(polygon);
        }).remove(function(idx) {
            var polygon = $83ebccb52de64002$var$inner(polygonGroup).data.getItemGraphicEl(idx);
            polygonGroup.group.remove(polygon);
        }).execute();
        areaData.eachItemGraphicEl(function(polygon, idx) {
            var itemModel = areaData.getItemModel(idx);
            var style = areaData.getItemVisual(idx, "style");
            polygon.useStyle(areaData.getItemVisual(idx, "style"));
            (0, $6800dfcb6e1e2a44$export$9a13992917966657)(polygon, (0, $6800dfcb6e1e2a44$export$9739a32674be5893)(itemModel), {
                labelFetcher: maModel,
                labelDataIndex: idx,
                defaultText: areaData.getName(idx) || "",
                inheritColor: (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(style.fill) ? $2c037f5bda6341ca$export$ab4754bf42583a26(style.fill, 1) : "#000"
            });
            (0, $2bf82c0980125b62$export$48b68047d330bbc9)(polygon, itemModel);
            (0, $2bf82c0980125b62$export$e51187539ff11209)(polygon, null, null, itemModel.get([
                "emphasis",
                "disabled"
            ]));
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(polygon).dataModel = maModel;
        });
        $83ebccb52de64002$var$inner(polygonGroup).data = areaData;
        polygonGroup.group.silent = maModel.get("silent") || seriesModel.get("silent");
    };
    MarkAreaView.type = "markArea";
    return MarkAreaView;
}((0, $ed6cf827ec8a4c83$export$2e2bcd8739ae039));
function $83ebccb52de64002$var$createList(coordSys, seriesModel, maModel) {
    var areaData;
    var dataDims;
    var dims = [
        "x0",
        "y0",
        "x1",
        "y1"
    ];
    if (coordSys) {
        var coordDimsInfos_1 = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys && coordSys.dimensions, function(coordDim) {
            var data = seriesModel.getData();
            var info = data.getDimensionInfo(data.mapDimension(coordDim)) || {};
            // In map series data don't have lng and lat dimension. Fallback to same with coordSys
            return (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, info), {
                name: coordDim,
                // DON'T use ordinalMeta to parse and collect ordinal.
                ordinalMeta: null
            });
        });
        dataDims = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(dims, function(dim, idx) {
            return {
                name: dim,
                type: coordDimsInfos_1[idx % 2].type
            };
        });
        areaData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dataDims, maModel);
    } else {
        dataDims = [
            {
                name: "value",
                type: "float"
            }
        ];
        areaData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(dataDims, maModel);
    }
    var optData = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(maModel.get("data"), (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($83ebccb52de64002$var$markAreaTransform, seriesModel, coordSys, maModel));
    if (coordSys) optData = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(optData, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($83ebccb52de64002$var$markAreaFilter, coordSys));
    var dimValueGetter = coordSys ? function(item, dimName, dataIndex, dimIndex) {
        // TODO should convert to ParsedValue?
        var rawVal = item.coord[Math.floor(dimIndex / 2)][dimIndex % 2];
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(rawVal, dataDims[dimIndex]);
    } : function(item, dimName, dataIndex, dimIndex) {
        return (0, $40ab59f44b7d2db6$export$cc7175145baad076)(item.value, dataDims[dimIndex]);
    };
    areaData.initData(optData, null, dimValueGetter);
    areaData.hasItemOption = true;
    return areaData;
}
var $83ebccb52de64002$export$2e2bcd8739ae039 = $83ebccb52de64002$var$MarkAreaView;


function $8a8e80722bf1c081$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $a4d9f6e367e83128$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $83ebccb52de64002$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(opt) {
        if ((0, $bab2c9b6be98f0ce$export$2e2bcd8739ae039)(opt.series, "markArea")) // Make sure markArea component is enabled
        opt.markArea = opt.markArea || {};
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $ed1b4c8534a4bb68$var$MarkLineModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkLineModel, _super);
    function MarkLineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkLineModel.type;
        return _this;
    }
    MarkLineModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkLineModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkLineModel.type = "markLine";
    MarkLineModel.defaultOption = {
        // zlevel: 0,
        z: 5,
        symbol: [
            "circle",
            "arrow"
        ],
        symbolSize: [
            8,
            16
        ],
        // symbolRotate: 0,
        symbolOffset: 0,
        precision: 2,
        tooltip: {
            trigger: "item"
        },
        label: {
            show: true,
            position: "end",
            distance: 5
        },
        lineStyle: {
            type: "dashed"
        },
        emphasis: {
            label: {
                show: true
            },
            lineStyle: {
                width: 3
            }
        },
        animationEasing: "linear"
    };
    return MarkLineModel;
}((0, $1bab71219c0cd9a9$export$2e2bcd8739ae039));
var $ed1b4c8534a4bb68$export$2e2bcd8739ae039 = $ed1b4c8534a4bb68$var$MarkLineModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 












var $87a9be5fb3657486$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $87a9be5fb3657486$var$markLineTransform = function(seriesModel, coordSys, mlModel, item) {
    var data = seriesModel.getData();
    var itemArray;
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(item)) {
        // Special type markLine like 'min', 'max', 'average', 'median'
        var mlType = item.type;
        if (mlType === "min" || mlType === "max" || mlType === "average" || mlType === "median" || item.xAxis != null || item.yAxis != null) {
            var valueAxis = void 0;
            var value = void 0;
            if (item.yAxis != null || item.xAxis != null) {
                valueAxis = coordSys.getAxis(item.yAxis != null ? "y" : "x");
                value = (0, $7a1bd9c2710fea0d$export$8a4d17b6e8486e66)(item.yAxis, item.xAxis);
            } else {
                var axisInfo = $e4ec0ddef831b3b2$export$bd39458db76002ab(item, data, coordSys, seriesModel);
                valueAxis = axisInfo.valueAxis;
                var valueDataDim = (0, $efdd976e4917927c$export$909db2be4938fbdf)(data, axisInfo.valueDataDim);
                value = $e4ec0ddef831b3b2$export$18ddefb55c03640b(data, valueDataDim, mlType);
            }
            var valueIndex = valueAxis.dim === "x" ? 0 : 1;
            var baseIndex = 1 - valueIndex;
            // Normized to 2d data with start and end point
            var mlFrom = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(item);
            var mlTo = {
                coord: []
            };
            mlFrom.type = null;
            mlFrom.coord = [];
            mlFrom.coord[baseIndex] = -Infinity;
            mlTo.coord[baseIndex] = Infinity;
            var precision = mlModel.get("precision");
            if (precision >= 0 && (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(value)) value = +value.toFixed(Math.min(precision, 20));
            mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
            itemArray = [
                mlFrom,
                mlTo,
                {
                    type: mlType,
                    valueIndex: item.valueIndex,
                    // Force to use the value of calculated value.
                    value: value
                }
            ];
        } else itemArray = [];
    } else itemArray = item;
    var normalizedItem = [
        $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, itemArray[0]),
        $e4ec0ddef831b3b2$export$3eebd2d54b98c04f(seriesModel, itemArray[1]),
        (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, itemArray[2])
    ];
    // Avoid line data type is extended by from(to) data type
    normalizedItem[2].type = normalizedItem[2].type || null;
    // Merge from option and to option into line option
    (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(normalizedItem[2], normalizedItem[0]);
    (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)(normalizedItem[2], normalizedItem[1]);
    return normalizedItem;
};
function $87a9be5fb3657486$var$isInfinity(val) {
    return !isNaN(val) && !isFinite(val);
}
// If a markLine has one dim
function $87a9be5fb3657486$var$ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
    var otherDimIndex = 1 - dimIndex;
    var dimName = coordSys.dimensions[dimIndex];
    return $87a9be5fb3657486$var$isInfinity(fromCoord[otherDimIndex]) && $87a9be5fb3657486$var$isInfinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
}
function $87a9be5fb3657486$var$markLineFilter(coordSys, item) {
    if (coordSys.type === "cartesian2d") {
        var fromCoord = item[0].coord;
        var toCoord = item[1].coord;
        // In case
        // {
        //  markLine: {
        //    data: [{ yAxis: 2 }]
        //  }
        // }
        if (fromCoord && toCoord && ($87a9be5fb3657486$var$ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || $87a9be5fb3657486$var$ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
    }
    return $e4ec0ddef831b3b2$export$179695f4a9040f73(coordSys, item[0]) && $e4ec0ddef831b3b2$export$179695f4a9040f73(coordSys, item[1]);
}
function $87a9be5fb3657486$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var itemModel = data.getItemModel(idx);
    var point;
    var xPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get("x"), api.getWidth());
    var yPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get("y"), api.getHeight());
    if (!isNaN(xPx) && !isNaN(yPx)) point = [
        xPx,
        yPx
    ];
    else {
        // Chart like bar may have there own marker positioning logic
        if (seriesModel.getMarkerPosition) // Use the getMarkerPosition
        point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
        else {
            var dims = coordSys.dimensions;
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            point = coordSys.dataToPoint([
                x,
                y
            ]);
        }
        // Expand line to the edge of grid if value on one axis is Inifnity
        // In case
        //  markLine: {
        //    data: [{
        //      yAxis: 2
        //      // or
        //      type: 'average'
        //    }]
        //  }
        if ((0, $3fea949f0512eb55$export$8567506e6336616)(coordSys, "cartesian2d")) {
            // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
            var xAxis = coordSys.getAxis("x");
            var yAxis = coordSys.getAxis("y");
            var dims = coordSys.dimensions;
            if ($87a9be5fb3657486$var$isInfinity(data.get(dims[0], idx))) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
            else if ($87a9be5fb3657486$var$isInfinity(data.get(dims[1], idx))) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
        }
        // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
    }
    data.setItemLayout(idx, point);
}
var $87a9be5fb3657486$var$MarkLineView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkLineView, _super);
    function MarkLineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkLineView.type;
        return _this;
    }
    MarkLineView.prototype.updateTransform = function(markLineModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var mlModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, "markLine");
            if (mlModel) {
                var mlData_1 = mlModel.getData();
                var fromData_1 = $87a9be5fb3657486$var$inner(mlModel).from;
                var toData_1 = $87a9be5fb3657486$var$inner(mlModel).to;
                // Update visual and layout of from symbol and to symbol
                fromData_1.each(function(idx) {
                    $87a9be5fb3657486$var$updateSingleMarkerEndLayout(fromData_1, idx, true, seriesModel, api);
                    $87a9be5fb3657486$var$updateSingleMarkerEndLayout(toData_1, idx, false, seriesModel, api);
                });
                // Update layout of line
                mlData_1.each(function(idx) {
                    mlData_1.setItemLayout(idx, [
                        fromData_1.getItemLayout(idx),
                        toData_1.getItemLayout(idx)
                    ]);
                });
                this.markerGroupMap.get(seriesModel.id).updateLayout();
            }
        }, this);
    };
    MarkLineView.prototype.renderSeries = function(seriesModel, mlModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var lineDrawMap = this.markerGroupMap;
        var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new (0, $a2fd63a0fc11274a$export$2e2bcd8739ae039)());
        this.group.add(lineDraw.group);
        var mlData = $87a9be5fb3657486$var$createList(coordSys, seriesModel, mlModel);
        var fromData = mlData.from;
        var toData = mlData.to;
        var lineData = mlData.line;
        $87a9be5fb3657486$var$inner(mlModel).from = fromData;
        $87a9be5fb3657486$var$inner(mlModel).to = toData;
        // Line data for tooltip and formatter
        mlModel.setData(lineData);
        // TODO
        // Functionally, `symbolSize` & `symbolOffset` can also be 2D array now.
        // But the related logic and type definition are not finished yet.
        // Finish it if required
        var symbolType = mlModel.get("symbol");
        var symbolSize = mlModel.get("symbolSize");
        var symbolRotate = mlModel.get("symbolRotate");
        var symbolOffset = mlModel.get("symbolOffset");
        // TODO: support callback function like markPoint
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolType)) symbolType = [
            symbolType,
            symbolType
        ];
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolSize)) symbolSize = [
            symbolSize,
            symbolSize
        ];
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolRotate)) symbolRotate = [
            symbolRotate,
            symbolRotate
        ];
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(symbolOffset)) symbolOffset = [
            symbolOffset,
            symbolOffset
        ];
        // Update visual and layout of from symbol and to symbol
        mlData.from.each(function(idx) {
            updateDataVisualAndLayout(fromData, idx, true);
            updateDataVisualAndLayout(toData, idx, false);
        });
        // Update visual and layout of line
        lineData.each(function(idx) {
            var lineStyle = lineData.getItemModel(idx).getModel("lineStyle").getLineStyle();
            // lineData.setItemVisual(idx, {
            //     color: lineColor || fromData.getItemVisual(idx, 'color')
            // });
            lineData.setItemLayout(idx, [
                fromData.getItemLayout(idx),
                toData.getItemLayout(idx)
            ]);
            if (lineStyle.stroke == null) lineStyle.stroke = fromData.getItemVisual(idx, "style").fill;
            lineData.setItemVisual(idx, {
                fromSymbolKeepAspect: fromData.getItemVisual(idx, "symbolKeepAspect"),
                fromSymbolOffset: fromData.getItemVisual(idx, "symbolOffset"),
                fromSymbolRotate: fromData.getItemVisual(idx, "symbolRotate"),
                fromSymbolSize: fromData.getItemVisual(idx, "symbolSize"),
                fromSymbol: fromData.getItemVisual(idx, "symbol"),
                toSymbolKeepAspect: toData.getItemVisual(idx, "symbolKeepAspect"),
                toSymbolOffset: toData.getItemVisual(idx, "symbolOffset"),
                toSymbolRotate: toData.getItemVisual(idx, "symbolRotate"),
                toSymbolSize: toData.getItemVisual(idx, "symbolSize"),
                toSymbol: toData.getItemVisual(idx, "symbol"),
                style: lineStyle
            });
        });
        lineDraw.updateData(lineData);
        // Set host model for tooltip
        // FIXME
        mlData.line.eachItemGraphicEl(function(el) {
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).dataModel = mlModel;
            el.traverse(function(child) {
                (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child).dataModel = mlModel;
            });
        });
        function updateDataVisualAndLayout(data, idx, isFrom) {
            var itemModel = data.getItemModel(idx);
            $87a9be5fb3657486$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
            var style = itemModel.getModel("itemStyle").getItemStyle();
            if (style.fill == null) style.fill = (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(seriesData, "color");
            data.setItemVisual(idx, {
                symbolKeepAspect: itemModel.get("symbolKeepAspect"),
                // `0` should be considered as a valid value, so use `retrieve2` instead of `||`
                symbolOffset: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemModel.get("symbolOffset", true), symbolOffset[isFrom ? 0 : 1]),
                symbolRotate: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemModel.get("symbolRotate", true), symbolRotate[isFrom ? 0 : 1]),
                // TODO: when 2d array is supported, it should ignore parent
                symbolSize: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemModel.get("symbolSize"), symbolSize[isFrom ? 0 : 1]),
                symbol: (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(itemModel.get("symbol", true), symbolType[isFrom ? 0 : 1]),
                style: style
            });
        }
        this.markKeep(lineDraw);
        lineDraw.group.silent = mlModel.get("silent") || seriesModel.get("silent");
    };
    MarkLineView.type = "markLine";
    return MarkLineView;
}((0, $ed6cf827ec8a4c83$export$2e2bcd8739ae039));
function $87a9be5fb3657486$var$createList(coordSys, seriesModel, mlModel) {
    var coordDimsInfos;
    if (coordSys) coordDimsInfos = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys && coordSys.dimensions, function(coordDim) {
        var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {};
        // In map series data don't have lng and lat dimension. Fallback to same with coordSys
        return (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, info), {
            name: coordDim,
            // DON'T use ordinalMeta to parse and collect ordinal.
            ordinalMeta: null
        });
    });
    else coordDimsInfos = [
        {
            name: "value",
            type: "float"
        }
    ];
    var fromData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(coordDimsInfos, mlModel);
    var toData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(coordDimsInfos, mlModel);
    // No dimensions
    var lineData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([], mlModel);
    var optData = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(mlModel.get("data"), (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($87a9be5fb3657486$var$markLineTransform, seriesModel, coordSys, mlModel));
    if (coordSys) optData = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(optData, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($87a9be5fb3657486$var$markLineFilter, coordSys));
    var dimValueGetter = $e4ec0ddef831b3b2$export$a53767c3c8f69cf7(!!coordSys, coordDimsInfos);
    fromData.initData((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(optData, function(item) {
        return item[0];
    }), null, dimValueGetter);
    toData.initData((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(optData, function(item) {
        return item[1];
    }), null, dimValueGetter);
    lineData.initData((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(optData, function(item) {
        return item[2];
    }));
    lineData.hasItemOption = true;
    return {
        from: fromData,
        to: toData,
        line: lineData
    };
}
var $87a9be5fb3657486$export$2e2bcd8739ae039 = $87a9be5fb3657486$var$MarkLineView;


function $0fc27d0a088604ed$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $ed1b4c8534a4bb68$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $87a9be5fb3657486$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(opt) {
        if ((0, $bab2c9b6be98f0ce$export$2e2bcd8739ae039)(opt.series, "markLine")) // Make sure markLine component is enabled
        opt.markLine = opt.markLine || {};
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $2a559db54433a753$var$MarkPointModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkPointModel, _super);
    function MarkPointModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkPointModel.type;
        return _this;
    }
    MarkPointModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkPointModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkPointModel.type = "markPoint";
    MarkPointModel.defaultOption = {
        // zlevel: 0,
        z: 5,
        symbol: "pin",
        symbolSize: 50,
        // symbolRotate: 0,
        // symbolOffset: [0, 0]
        tooltip: {
            trigger: "item"
        },
        label: {
            show: true,
            position: "inside"
        },
        itemStyle: {
            borderWidth: 2
        },
        emphasis: {
            label: {
                show: true
            }
        }
    };
    return MarkPointModel;
}((0, $1bab71219c0cd9a9$export$2e2bcd8739ae039));
var $2a559db54433a753$export$2e2bcd8739ae039 = $2a559db54433a753$var$MarkPointModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









function $80c0cdc6385c1c58$var$updateMarkerLayout(mpData, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    mpData.each(function(idx) {
        var itemModel = mpData.getItemModel(idx);
        var point;
        var xPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get("x"), api.getWidth());
        var yPx = $cfc1f3b422a3185f$export$e8514cb5a5e2b40f(itemModel.get("y"), api.getHeight());
        if (!isNaN(xPx) && !isNaN(yPx)) point = [
            xPx,
            yPx
        ];
        else if (seriesModel.getMarkerPosition) // Use the getMarkerPosition
        point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
        else if (coordSys) {
            var x = mpData.get(coordSys.dimensions[0], idx);
            var y = mpData.get(coordSys.dimensions[1], idx);
            point = coordSys.dataToPoint([
                x,
                y
            ]);
        }
        // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
        mpData.setItemLayout(idx, point);
    });
}
var $80c0cdc6385c1c58$var$MarkPointView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MarkPointView, _super);
    function MarkPointView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkPointView.type;
        return _this;
    }
    MarkPointView.prototype.updateTransform = function(markPointModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var mpModel = (0, $1bab71219c0cd9a9$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, "markPoint");
            if (mpModel) {
                $80c0cdc6385c1c58$var$updateMarkerLayout(mpModel.getData(), seriesModel, api);
                this.markerGroupMap.get(seriesModel.id).updateLayout();
            }
        }, this);
    };
    MarkPointView.prototype.renderSeries = function(seriesModel, mpModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var symbolDrawMap = this.markerGroupMap;
        var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new (0, $fedf62268297fcbb$export$2e2bcd8739ae039)());
        var mpData = $80c0cdc6385c1c58$var$createData(coordSys, seriesModel, mpModel);
        // FIXME
        mpModel.setData(mpData);
        $80c0cdc6385c1c58$var$updateMarkerLayout(mpModel.getData(), seriesModel, api);
        mpData.each(function(idx) {
            var itemModel = mpData.getItemModel(idx);
            var symbol = itemModel.getShallow("symbol");
            var symbolSize = itemModel.getShallow("symbolSize");
            var symbolRotate = itemModel.getShallow("symbolRotate");
            var symbolOffset = itemModel.getShallow("symbolOffset");
            var symbolKeepAspect = itemModel.getShallow("symbolKeepAspect");
            // TODO: refactor needed: single data item should not support callback function
            if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbol) || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolSize) || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolRotate) || (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolOffset)) {
                var rawIdx = mpModel.getRawValue(idx);
                var dataParams = mpModel.getDataParams(idx);
                if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbol)) symbol = symbol(rawIdx, dataParams);
                if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolSize)) // FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
                symbolSize = symbolSize(rawIdx, dataParams);
                if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolRotate)) symbolRotate = symbolRotate(rawIdx, dataParams);
                if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(symbolOffset)) symbolOffset = symbolOffset(rawIdx, dataParams);
            }
            var style = itemModel.getModel("itemStyle").getItemStyle();
            var color = (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(seriesData, "color");
            if (!style.fill) style.fill = color;
            mpData.setItemVisual(idx, {
                symbol: symbol,
                symbolSize: symbolSize,
                symbolRotate: symbolRotate,
                symbolOffset: symbolOffset,
                symbolKeepAspect: symbolKeepAspect,
                style: style
            });
        });
        // TODO Text are wrong
        symbolDraw.updateData(mpData);
        this.group.add(symbolDraw.group);
        // Set host model for tooltip
        // FIXME
        mpData.eachItemGraphicEl(function(el) {
            el.traverse(function(child) {
                (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child).dataModel = mpModel;
            });
        });
        this.markKeep(symbolDraw);
        symbolDraw.group.silent = mpModel.get("silent") || seriesModel.get("silent");
    };
    MarkPointView.type = "markPoint";
    return MarkPointView;
}((0, $ed6cf827ec8a4c83$export$2e2bcd8739ae039));
function $80c0cdc6385c1c58$var$createData(coordSys, seriesModel, mpModel) {
    var coordDimsInfos;
    if (coordSys) coordDimsInfos = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(coordSys && coordSys.dimensions, function(coordDim) {
        var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {};
        // In map series data don't have lng and lat dimension. Fallback to same with coordSys
        return (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, info), {
            name: coordDim,
            // DON'T use ordinalMeta to parse and collect ordinal.
            ordinalMeta: null
        });
    });
    else coordDimsInfos = [
        {
            name: "value",
            type: "float"
        }
    ];
    var mpData = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)(coordDimsInfos, mpModel);
    var dataOpt = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(mpModel.get("data"), (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$export$3eebd2d54b98c04f, seriesModel));
    if (coordSys) dataOpt = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(dataOpt, (0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)($e4ec0ddef831b3b2$export$179695f4a9040f73, coordSys));
    var dimValueGetter = $e4ec0ddef831b3b2$export$a53767c3c8f69cf7(!!coordSys, coordDimsInfos);
    mpData.initData(dataOpt, null, dimValueGetter);
    return mpData;
}
var $80c0cdc6385c1c58$export$2e2bcd8739ae039 = $80c0cdc6385c1c58$var$MarkPointView;


function $4edaa7c972a7e0d1$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $2a559db54433a753$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $80c0cdc6385c1c58$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(opt) {
        if ((0, $bab2c9b6be98f0ce$export$2e2bcd8739ae039)(opt.series, "markPoint")) // Make sure markPoint component is enabled
        opt.markPoint = opt.markPoint || {};
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $692a4df2164e3c50$var$PolarAxisPointer = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PolarAxisPointer, _super);
    function PolarAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ PolarAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        if (axis.dim === "angle") this.animationThreshold = Math.PI / 18;
        var polar = axis.polar;
        var otherAxis = polar.getOtherAxis(axis);
        var otherExtent = otherAxis.getExtent();
        var coordValue = axis.dataToCoord(value);
        var axisPointerType = axisPointerModel.get("type");
        if (axisPointerType && axisPointerType !== "none") {
            var elStyle = $51dec70890757374$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $692a4df2164e3c50$var$pointerShapeBuilder[axisPointerType](axis, polar, coordValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var labelMargin = axisPointerModel.get([
            "label",
            "margin"
        ]);
        var labelPos = $692a4df2164e3c50$var$getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin);
        $51dec70890757374$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos);
    };
    return PolarAxisPointer;
}((0, $a331d7a6c631e6d9$export$2e2bcd8739ae039));
function $692a4df2164e3c50$var$getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin) {
    var axis = axisModel.axis;
    var coord = axis.dataToCoord(value);
    var axisAngle = polar.getAngleAxis().getExtent()[0];
    axisAngle = axisAngle / 180 * Math.PI;
    var radiusExtent = polar.getRadiusAxis().getExtent();
    var position;
    var align;
    var verticalAlign;
    if (axis.dim === "radius") {
        var transform = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
        $f41ebb9dd60b55b4$export$bb628a54ab399bc9(transform, transform, axisAngle);
        $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(transform, transform, [
            polar.cx,
            polar.cy
        ]);
        position = $5b455ae6f843ac47$export$9f9dcb98c894b623([
            coord,
            -labelMargin
        ], transform);
        var labelRotation = axisModel.getModel("axisLabel").get("rotate") || 0;
        // @ts-ignore
        var labelLayout = (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039).innerTextLayout(axisAngle, labelRotation * Math.PI / 180, -1);
        align = labelLayout.textAlign;
        verticalAlign = labelLayout.textVerticalAlign;
    } else {
        // angle axis
        var r = radiusExtent[1];
        position = polar.coordToPoint([
            r + labelMargin,
            coord
        ]);
        var cx = polar.cx;
        var cy = polar.cy;
        align = Math.abs(position[0] - cx) / r < 0.3 ? "center" : position[0] > cx ? "left" : "right";
        verticalAlign = Math.abs(position[1] - cy) / r < 0.3 ? "middle" : position[1] > cy ? "top" : "bottom";
    }
    return {
        position: position,
        align: align,
        verticalAlign: verticalAlign
    };
}
var $692a4df2164e3c50$var$pointerShapeBuilder = {
    line: function(axis, polar, coordValue, otherExtent) {
        return axis.dim === "angle" ? {
            type: "Line",
            shape: $51dec70890757374$export$885fa0ad5a826207(polar.coordToPoint([
                otherExtent[0],
                coordValue
            ]), polar.coordToPoint([
                otherExtent[1],
                coordValue
            ]))
        } : {
            type: "Circle",
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: coordValue
            }
        };
    },
    shadow: function(axis, polar, coordValue, otherExtent) {
        var bandWidth = Math.max(1, axis.getBandWidth());
        var radian = Math.PI / 180;
        return axis.dim === "angle" ? {
            type: "Sector",
            shape: $51dec70890757374$export$b0cf82e7ebc0d7d0(polar.cx, polar.cy, otherExtent[0], otherExtent[1], // In ECharts y is negative if angle is positive
            (-coordValue - bandWidth / 2) * radian, (-coordValue + bandWidth / 2) * radian)
        } : {
            type: "Sector",
            shape: $51dec70890757374$export$b0cf82e7ebc0d7d0(polar.cx, polar.cy, coordValue - bandWidth / 2, coordValue + bandWidth / 2, 0, Math.PI * 2)
        };
    }
};
var $692a4df2164e3c50$export$2e2bcd8739ae039 = $692a4df2164e3c50$var$PolarAxisPointer;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $657132d924424c20$var$PolarModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PolarModel, _super);
    function PolarModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PolarModel.type;
        return _this;
    }
    PolarModel.prototype.findAxisModel = function(axisType) {
        var foundAxisModel;
        var ecModel = this.ecModel;
        ecModel.eachComponent(axisType, function(axisModel) {
            if (axisModel.getCoordSysModel() === this) foundAxisModel = axisModel;
        }, this);
        return foundAxisModel;
    };
    PolarModel.type = "polar";
    PolarModel.dependencies = [
        "radiusAxis",
        "angleAxis"
    ];
    PolarModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        center: [
            "50%",
            "50%"
        ],
        radius: "80%"
    };
    return PolarModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $657132d924424c20$export$2e2bcd8739ae039 = $657132d924424c20$var$PolarModel;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $d885303d9d4b2eee$export$ae9b190f9f84c66f = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PolarAxisModel, _super);
    function PolarAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PolarAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents("polar", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
    };
    PolarAxisModel.type = "polarAxis";
    return PolarAxisModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
$7a1bd9c2710fea0d$export$e36fc9d62a853069($d885303d9d4b2eee$export$ae9b190f9f84c66f, (0, $3449fd4c0590d99e$export$5c54b224726edb5a));
var $d885303d9d4b2eee$export$34735c2c701428ca = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AngleAxisModel, _super);
    function AngleAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AngleAxisModel.type;
        return _this;
    }
    AngleAxisModel.type = "angleAxis";
    return AngleAxisModel;
}($d885303d9d4b2eee$export$ae9b190f9f84c66f);
var $d885303d9d4b2eee$export$de202388c212a23b = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadiusAxisModel, _super);
    function RadiusAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadiusAxisModel.type;
        return _this;
    }
    RadiusAxisModel.type = "radiusAxis";
    return RadiusAxisModel;
}($d885303d9d4b2eee$export$ae9b190f9f84c66f);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Axis scale

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $bf08c49320f1faba$var$RadiusAxis = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadiusAxis, _super);
    function RadiusAxis(scale, radiusExtent) {
        return _super.call(this, "radius", scale, radiusExtent) || this;
    }
    RadiusAxis.prototype.pointToData = function(point, clamp) {
        return this.polar.pointToData(point, clamp)[this.dim === "radius" ? 0 : 1];
    };
    return RadiusAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
$bf08c49320f1faba$var$RadiusAxis.prototype.dataToRadius = (0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039).prototype.dataToCoord;
$bf08c49320f1faba$var$RadiusAxis.prototype.radiusToData = (0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039).prototype.coordToData;
var $bf08c49320f1faba$export$2e2bcd8739ae039 = $bf08c49320f1faba$var$RadiusAxis;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $4a9e505d5dd42027$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $4a9e505d5dd42027$var$AngleAxis = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AngleAxis, _super);
    function AngleAxis(scale, angleExtent) {
        return _super.call(this, "angle", scale, angleExtent || [
            0,
            360
        ]) || this;
    }
    AngleAxis.prototype.pointToData = function(point, clamp) {
        return this.polar.pointToData(point, clamp)[this.dim === "radius" ? 0 : 1];
    };
    /**
   * Only be called in category axis.
   * Angle axis uses text height to decide interval
   *
   * @override
   * @return {number} Auto interval for cateogry axis tick and label
   */ AngleAxis.prototype.calculateCategoryInterval = function() {
        var axis = this;
        var labelModel = axis.getLabelModel();
        var ordinalScale = axis.scale;
        var ordinalExtent = ordinalScale.getExtent();
        // Providing this method is for optimization:
        // avoid generating a long array by `getTicks`
        // in large category data case.
        var tickCount = ordinalScale.count();
        if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
        var tickValue = ordinalExtent[0];
        var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
        var unitH = Math.abs(unitSpan);
        // Not precise, just use height as text width
        // and each distance from axis line yet.
        var rect = $6c308355c7107803$export$c381147bfed79d9f(tickValue == null ? "" : tickValue + "", labelModel.getFont(), "center", "top");
        var maxH = Math.max(rect.height, 7);
        var dh = maxH / unitH;
        // 0/0 is NaN, 1/0 is Infinity.
        isNaN(dh) && (dh = Infinity);
        var interval = Math.max(0, Math.floor(dh));
        var cache = $4a9e505d5dd42027$var$inner(axis.model);
        var lastAutoInterval = cache.lastAutoInterval;
        var lastTickCount = cache.lastTickCount;
        // Use cache to keep interval stable while moving zoom window,
        // otherwise the calculated interval might jitter when the zoom
        // window size is close to the interval-changing size.
        if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 && lastAutoInterval > interval) interval = lastAutoInterval;
        else {
            cache.lastTickCount = tickCount;
            cache.lastAutoInterval = interval;
        }
        return interval;
    };
    return AngleAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
$4a9e505d5dd42027$var$AngleAxis.prototype.dataToAngle = (0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039).prototype.dataToCoord;
$4a9e505d5dd42027$var$AngleAxis.prototype.angleToData = (0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039).prototype.coordToData;
var $4a9e505d5dd42027$export$2e2bcd8739ae039 = $4a9e505d5dd42027$var$AngleAxis;


var $bbec1db3de81c4bf$export$f6d9521c10640456 = [
    "radius",
    "angle"
];
var $bbec1db3de81c4bf$var$Polar = /** @class */ function() {
    function Polar(name) {
        this.dimensions = $bbec1db3de81c4bf$export$f6d9521c10640456;
        this.type = "polar";
        /**
     * x of polar center
     */ this.cx = 0;
        /**
     * y of polar center
     */ this.cy = 0;
        this._radiusAxis = new (0, $bf08c49320f1faba$export$2e2bcd8739ae039)();
        this._angleAxis = new (0, $4a9e505d5dd42027$export$2e2bcd8739ae039)();
        this.axisPointerEnabled = true;
        this.name = name || "";
        this._radiusAxis.polar = this._angleAxis.polar = this;
    }
    /**
   * If contain coord
   */ Polar.prototype.containPoint = function(point) {
        var coord = this.pointToCoord(point);
        return this._radiusAxis.contain(coord[0]) && this._angleAxis.contain(coord[1]);
    };
    /**
   * If contain data
   */ Polar.prototype.containData = function(data) {
        return this._radiusAxis.containData(data[0]) && this._angleAxis.containData(data[1]);
    };
    Polar.prototype.getAxis = function(dim) {
        var key = "_" + dim + "Axis";
        return this[key];
    };
    Polar.prototype.getAxes = function() {
        return [
            this._radiusAxis,
            this._angleAxis
        ];
    };
    /**
   * Get axes by type of scale
   */ Polar.prototype.getAxesByScale = function(scaleType) {
        var axes = [];
        var angleAxis = this._angleAxis;
        var radiusAxis = this._radiusAxis;
        angleAxis.scale.type === scaleType && axes.push(angleAxis);
        radiusAxis.scale.type === scaleType && axes.push(radiusAxis);
        return axes;
    };
    Polar.prototype.getAngleAxis = function() {
        return this._angleAxis;
    };
    Polar.prototype.getRadiusAxis = function() {
        return this._radiusAxis;
    };
    Polar.prototype.getOtherAxis = function(axis) {
        var angleAxis = this._angleAxis;
        return axis === angleAxis ? this._radiusAxis : angleAxis;
    };
    /**
   * Base axis will be used on stacking.
   *
   */ Polar.prototype.getBaseAxis = function() {
        return this.getAxesByScale("ordinal")[0] || this.getAxesByScale("time")[0] || this.getAngleAxis();
    };
    Polar.prototype.getTooltipAxes = function(dim) {
        var baseAxis = dim != null && dim !== "auto" ? this.getAxis(dim) : this.getBaseAxis();
        return {
            baseAxes: [
                baseAxis
            ],
            otherAxes: [
                this.getOtherAxis(baseAxis)
            ]
        };
    };
    /**
   * Convert a single data item to (x, y) point.
   * Parameter data is an array which the first element is radius and the second is angle
   */ Polar.prototype.dataToPoint = function(data, clamp) {
        return this.coordToPoint([
            this._radiusAxis.dataToRadius(data[0], clamp),
            this._angleAxis.dataToAngle(data[1], clamp)
        ]);
    };
    /**
   * Convert a (x, y) point to data
   */ Polar.prototype.pointToData = function(point, clamp) {
        var coord = this.pointToCoord(point);
        return [
            this._radiusAxis.radiusToData(coord[0], clamp),
            this._angleAxis.angleToData(coord[1], clamp)
        ];
    };
    /**
   * Convert a (x, y) point to (radius, angle) coord
   */ Polar.prototype.pointToCoord = function(point) {
        var dx = point[0] - this.cx;
        var dy = point[1] - this.cy;
        var angleAxis = this.getAngleAxis();
        var extent = angleAxis.getExtent();
        var minAngle = Math.min(extent[0], extent[1]);
        var maxAngle = Math.max(extent[0], extent[1]);
        // Fix fixed extent in polarCreator
        // FIXME
        angleAxis.inverse ? minAngle = maxAngle - 360 : maxAngle = minAngle + 360;
        var radius = Math.sqrt(dx * dx + dy * dy);
        dx /= radius;
        dy /= radius;
        var radian = Math.atan2(-dy, dx) / Math.PI * 180;
        // move to angleExtent
        var dir = radian < minAngle ? 1 : -1;
        while(radian < minAngle || radian > maxAngle)radian += dir * 360;
        return [
            radius,
            radian
        ];
    };
    /**
   * Convert a (radius, angle) coord to (x, y) point
   */ Polar.prototype.coordToPoint = function(coord) {
        var radius = coord[0];
        var radian = coord[1] / 180 * Math.PI;
        var x = Math.cos(radian) * radius + this.cx;
        // Inverse the y
        var y = -Math.sin(radian) * radius + this.cy;
        return [
            x,
            y
        ];
    };
    /**
   * Get ring area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Polar.prototype.getArea = function() {
        var angleAxis = this.getAngleAxis();
        var radiusAxis = this.getRadiusAxis();
        var radiusExtent = radiusAxis.getExtent().slice();
        radiusExtent[0] > radiusExtent[1] && radiusExtent.reverse();
        var angleExtent = angleAxis.getExtent();
        var RADIAN = Math.PI / 180;
        return {
            cx: this.cx,
            cy: this.cy,
            r0: radiusExtent[0],
            r: radiusExtent[1],
            startAngle: -angleExtent[0] * RADIAN,
            endAngle: -angleExtent[1] * RADIAN,
            clockwise: angleAxis.inverse,
            contain: function(x, y) {
                // It's a ring shape.
                // Start angle and end angle don't matter
                var dx = x - this.cx;
                var dy = y - this.cy;
                // minus a tiny value 1e-4 to avoid being clipped unexpectedly
                var d2 = dx * dx + dy * dy - 1e-4;
                var r = this.r;
                var r0 = this.r0;
                return d2 <= r * r && d2 >= r0 * r0;
            }
        };
    };
    Polar.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $bbec1db3de81c4bf$var$getCoordSys(finder);
        return coordSys === this ? this.dataToPoint(value) : null;
    };
    Polar.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $bbec1db3de81c4bf$var$getCoordSys(finder);
        return coordSys === this ? this.pointToData(pixel) : null;
    };
    return Polar;
}();
function $bbec1db3de81c4bf$var$getCoordSys(finder) {
    var seriesModel = finder.seriesModel;
    var polarModel = finder.polarModel;
    return polarModel && polarModel.coordinateSystem || seriesModel && seriesModel.coordinateSystem;
}
var $bbec1db3de81c4bf$export$2e2bcd8739ae039 = $bbec1db3de81c4bf$var$Polar;





/**
 * Resize method bound to the polar
 */ function $45211ba328a63245$var$resizePolar(polar, polarModel, api) {
    var center = polarModel.get("center");
    var width = api.getWidth();
    var height = api.getHeight();
    polar.cx = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[0], width);
    polar.cy = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(center[1], height);
    var radiusAxis = polar.getRadiusAxis();
    var size = Math.min(width, height) / 2;
    var radius = polarModel.get("radius");
    if (radius == null) radius = [
        0,
        "100%"
    ];
    else if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(radius)) // r0 = 0
    radius = [
        0,
        radius
    ];
    var parsedRadius = [
        (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[0], size),
        (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(radius[1], size)
    ];
    radiusAxis.inverse ? radiusAxis.setExtent(parsedRadius[1], parsedRadius[0]) : radiusAxis.setExtent(parsedRadius[0], parsedRadius[1]);
}
/**
 * Update polar
 */ function $45211ba328a63245$var$updatePolarScale(ecModel, api) {
    var polar = this;
    var angleAxis = polar.getAngleAxis();
    var radiusAxis = polar.getRadiusAxis();
    // Reset scale
    angleAxis.scale.setExtent(Infinity, -Infinity);
    radiusAxis.scale.setExtent(Infinity, -Infinity);
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.coordinateSystem === polar) {
            var data_1 = seriesModel.getData();
            $7a1bd9c2710fea0d$export$79b2f7037acddd43((0, $2d646e51cc34f840$export$e4cf30b1e74cd69d)(data_1, "radius"), function(dim) {
                radiusAxis.scale.unionExtentFromData(data_1, dim);
            });
            $7a1bd9c2710fea0d$export$79b2f7037acddd43((0, $2d646e51cc34f840$export$e4cf30b1e74cd69d)(data_1, "angle"), function(dim) {
                angleAxis.scale.unionExtentFromData(data_1, dim);
            });
        }
    });
    (0, $2d646e51cc34f840$export$51f3e70a54405d5a)(angleAxis.scale, angleAxis.model);
    (0, $2d646e51cc34f840$export$51f3e70a54405d5a)(radiusAxis.scale, radiusAxis.model);
    // Fix extent of category angle axis
    if (angleAxis.type === "category" && !angleAxis.onBand) {
        var extent = angleAxis.getExtent();
        var diff = 360 / angleAxis.scale.count();
        angleAxis.inverse ? extent[1] += diff : extent[1] -= diff;
        angleAxis.setExtent(extent[0], extent[1]);
    }
}
function $45211ba328a63245$var$isAngleAxisModel(axisModel) {
    return axisModel.mainType === "angleAxis";
}
/**
 * Set common axis properties
 */ function $45211ba328a63245$var$setAxis(axis, axisModel) {
    var _a;
    axis.type = axisModel.get("type");
    axis.scale = (0, $2d646e51cc34f840$export$8941c4cacdc8f5a5)(axisModel);
    axis.onBand = axisModel.get("boundaryGap") && axis.type === "category";
    axis.inverse = axisModel.get("inverse");
    if ($45211ba328a63245$var$isAngleAxisModel(axisModel)) {
        axis.inverse = axis.inverse !== axisModel.get("clockwise");
        var startAngle = axisModel.get("startAngle");
        var endAngle = (_a = axisModel.get("endAngle")) !== null && _a !== void 0 ? _a : startAngle + (axis.inverse ? -360 : 360);
        axis.setExtent(startAngle, endAngle);
    }
    // Inject axis instance
    axisModel.axis = axis;
    axis.model = axisModel;
}
var $45211ba328a63245$var$polarCreator = {
    dimensions: (0, $bbec1db3de81c4bf$export$f6d9521c10640456),
    create: function(ecModel, api) {
        var polarList = [];
        ecModel.eachComponent("polar", function(polarModel, idx) {
            var polar = new (0, $bbec1db3de81c4bf$export$2e2bcd8739ae039)(idx + "");
            // Inject resize and update method
            polar.update = $45211ba328a63245$var$updatePolarScale;
            var radiusAxis = polar.getRadiusAxis();
            var angleAxis = polar.getAngleAxis();
            var radiusAxisModel = polarModel.findAxisModel("radiusAxis");
            var angleAxisModel = polarModel.findAxisModel("angleAxis");
            $45211ba328a63245$var$setAxis(radiusAxis, radiusAxisModel);
            $45211ba328a63245$var$setAxis(angleAxis, angleAxisModel);
            $45211ba328a63245$var$resizePolar(polar, polarModel, api);
            polarList.push(polar);
            polarModel.coordinateSystem = polar;
            polar.model = polarModel;
        });
        // Inject coordinateSystem to series
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.get("coordinateSystem") === "polar") {
                var polarModel = seriesModel.getReferringComponents("polar", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
                seriesModel.coordinateSystem = polarModel.coordinateSystem;
            }
        });
        return polarList;
    }
};
var $45211ba328a63245$export$2e2bcd8739ae039 = $45211ba328a63245$var$polarCreator;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $6fbccfdf5ee55341$var$elementList = [
    "axisLine",
    "axisLabel",
    "axisTick",
    "minorTick",
    "splitLine",
    "minorSplitLine",
    "splitArea"
];
function $6fbccfdf5ee55341$var$getAxisLineShape(polar, rExtent, angle) {
    rExtent[1] > rExtent[0] && (rExtent = rExtent.slice().reverse());
    var start = polar.coordToPoint([
        rExtent[0],
        angle
    ]);
    var end = polar.coordToPoint([
        rExtent[1],
        angle
    ]);
    return {
        x1: start[0],
        y1: start[1],
        x2: end[0],
        y2: end[1]
    };
}
function $6fbccfdf5ee55341$var$getRadiusIdx(polar) {
    var radiusAxis = polar.getRadiusAxis();
    return radiusAxis.inverse ? 0 : 1;
}
// Remove the last tick which will overlap the first tick
function $6fbccfdf5ee55341$var$fixAngleOverlap(list) {
    var firstItem = list[0];
    var lastItem = list[list.length - 1];
    if (firstItem && lastItem && Math.abs(Math.abs(firstItem.coord - lastItem.coord) - 360) < 1e-4) list.pop();
}
var $6fbccfdf5ee55341$var$AngleAxisView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(AngleAxisView, _super);
    function AngleAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AngleAxisView.type;
        _this.axisPointerClass = "PolarAxisPointer";
        return _this;
    }
    AngleAxisView.prototype.render = function(angleAxisModel, ecModel) {
        this.group.removeAll();
        if (!angleAxisModel.get("show")) return;
        var angleAxis = angleAxisModel.axis;
        var polar = angleAxis.polar;
        var radiusExtent = polar.getRadiusAxis().getExtent();
        var ticksAngles = angleAxis.getTicksCoords();
        var minorTickAngles = angleAxis.getMinorTicksCoords();
        var labels = $7a1bd9c2710fea0d$export$871de8747c9eaa88(angleAxis.getViewLabels(), function(labelItem) {
            labelItem = $7a1bd9c2710fea0d$export$9cd59f9826255e47(labelItem);
            var scale = angleAxis.scale;
            var tickValue = scale.type === "ordinal" ? scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
            labelItem.coord = angleAxis.dataToCoord(tickValue);
            return labelItem;
        });
        $6fbccfdf5ee55341$var$fixAngleOverlap(labels);
        $6fbccfdf5ee55341$var$fixAngleOverlap(ticksAngles);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($6fbccfdf5ee55341$var$elementList, function(name) {
            if (angleAxisModel.get([
                name,
                "show"
            ]) && (!angleAxis.scale.isBlank() || name === "axisLine")) $6fbccfdf5ee55341$var$angelAxisElementsBuilders[name](this.group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels);
        }, this);
    };
    AngleAxisView.type = "angleAxis";
    return AngleAxisView;
}((0, $58c48a3ef1aa0746$export$2e2bcd8739ae039));
var $6fbccfdf5ee55341$var$angelAxisElementsBuilders = {
    axisLine: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var lineStyleModel = angleAxisModel.getModel([
            "axisLine",
            "lineStyle"
        ]);
        var angleAxis = polar.getAngleAxis();
        var RADIAN = Math.PI / 180;
        var angleExtent = angleAxis.getExtent();
        // extent id of the axis radius (r0 and r)
        var rId = $6fbccfdf5ee55341$var$getRadiusIdx(polar);
        var r0Id = rId ? 0 : 1;
        var shape;
        var shapeType = Math.abs(angleExtent[1] - angleExtent[0]) === 360 ? "Circle" : "Arc";
        if (radiusExtent[r0Id] === 0) shape = new $5b455ae6f843ac47$exports[shapeType]({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: radiusExtent[rId],
                startAngle: -angleExtent[0] * RADIAN,
                endAngle: -angleExtent[1] * RADIAN,
                clockwise: angleAxis.inverse
            },
            style: lineStyleModel.getLineStyle(),
            z2: 1,
            silent: true
        });
        else shape = new $5b455ae6f843ac47$exports.Ring({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: radiusExtent[rId],
                r0: radiusExtent[r0Id]
            },
            style: lineStyleModel.getLineStyle(),
            z2: 1,
            silent: true
        });
        shape.style.fill = null;
        group.add(shape);
    },
    axisTick: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var tickModel = angleAxisModel.getModel("axisTick");
        var tickLen = (tickModel.get("inside") ? -1 : 1) * tickModel.get("length");
        var radius = radiusExtent[$6fbccfdf5ee55341$var$getRadiusIdx(polar)];
        var lines = $7a1bd9c2710fea0d$export$871de8747c9eaa88(ticksAngles, function(tickAngleItem) {
            return new $5b455ae6f843ac47$exports.Line({
                shape: $6fbccfdf5ee55341$var$getAxisLineShape(polar, [
                    radius,
                    radius + tickLen
                ], tickAngleItem.coord)
            });
        });
        group.add($5b455ae6f843ac47$exports.mergePath(lines, {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e(tickModel.getModel("lineStyle").getLineStyle(), {
                stroke: angleAxisModel.get([
                    "axisLine",
                    "lineStyle",
                    "color"
                ])
            })
        }));
    },
    minorTick: function(group, angleAxisModel, polar, tickAngles, minorTickAngles, radiusExtent) {
        if (!minorTickAngles.length) return;
        var tickModel = angleAxisModel.getModel("axisTick");
        var minorTickModel = angleAxisModel.getModel("minorTick");
        var tickLen = (tickModel.get("inside") ? -1 : 1) * minorTickModel.get("length");
        var radius = radiusExtent[$6fbccfdf5ee55341$var$getRadiusIdx(polar)];
        var lines = [];
        for(var i = 0; i < minorTickAngles.length; i++)for(var k = 0; k < minorTickAngles[i].length; k++)lines.push(new $5b455ae6f843ac47$exports.Line({
            shape: $6fbccfdf5ee55341$var$getAxisLineShape(polar, [
                radius,
                radius + tickLen
            ], minorTickAngles[i][k].coord)
        }));
        group.add($5b455ae6f843ac47$exports.mergePath(lines, {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e(minorTickModel.getModel("lineStyle").getLineStyle(), $7a1bd9c2710fea0d$export$ebe90cb607ad99e(tickModel.getLineStyle(), {
                stroke: angleAxisModel.get([
                    "axisLine",
                    "lineStyle",
                    "color"
                ])
            }))
        }));
    },
    axisLabel: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels) {
        var rawCategoryData = angleAxisModel.getCategories(true);
        var commonLabelModel = angleAxisModel.getModel("axisLabel");
        var labelMargin = commonLabelModel.get("margin");
        var triggerEvent = angleAxisModel.get("triggerEvent");
        // Use length of ticksAngles because it may remove the last tick to avoid overlapping
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(labels, function(labelItem, idx) {
            var labelModel = commonLabelModel;
            var tickValue = labelItem.tickValue;
            var r = radiusExtent[$6fbccfdf5ee55341$var$getRadiusIdx(polar)];
            var p = polar.coordToPoint([
                r + labelMargin,
                labelItem.coord
            ]);
            var cx = polar.cx;
            var cy = polar.cy;
            var labelTextAlign = Math.abs(p[0] - cx) / r < 0.3 ? "center" : p[0] > cx ? "left" : "right";
            var labelTextVerticalAlign = Math.abs(p[1] - cy) / r < 0.3 ? "middle" : p[1] > cy ? "top" : "bottom";
            if (rawCategoryData && rawCategoryData[tickValue]) {
                var rawCategoryItem = rawCategoryData[tickValue];
                if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(rawCategoryItem) && rawCategoryItem.textStyle) labelModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(rawCategoryItem.textStyle, commonLabelModel, commonLabelModel.ecModel);
            }
            var textEl = new $5b455ae6f843ac47$exports.Text({
                silent: (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039).isLabelSilent(angleAxisModel),
                style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelModel, {
                    x: p[0],
                    y: p[1],
                    fill: labelModel.getTextColor() || angleAxisModel.get([
                        "axisLine",
                        "lineStyle",
                        "color"
                    ]),
                    text: labelItem.formattedLabel,
                    align: labelTextAlign,
                    verticalAlign: labelTextVerticalAlign
                })
            });
            group.add(textEl);
            // Pack data for mouse event
            if (triggerEvent) {
                var eventData = (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039).makeAxisEventDataBase(angleAxisModel);
                eventData.targetType = "axisLabel";
                eventData.value = labelItem.rawLabel;
                (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
            }
        }, this);
    },
    splitLine: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var splitLineModel = angleAxisModel.getModel("splitLine");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var lineColors = lineStyleModel.get("color");
        var lineCount = 0;
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var splitLines = [];
        for(var i = 0; i < ticksAngles.length; i++){
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(new $5b455ae6f843ac47$exports.Line({
                shape: $6fbccfdf5ee55341$var$getAxisLineShape(polar, radiusExtent, ticksAngles[i].coord)
            }));
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitLines.length; i++)group.add($5b455ae6f843ac47$exports.mergePath(splitLines[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                stroke: lineColors[i % lineColors.length]
            }, lineStyleModel.getLineStyle()),
            silent: true,
            z: angleAxisModel.get("z")
        }));
    },
    minorSplitLine: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        if (!minorTickAngles.length) return;
        var minorSplitLineModel = angleAxisModel.getModel("minorSplitLine");
        var lineStyleModel = minorSplitLineModel.getModel("lineStyle");
        var lines = [];
        for(var i = 0; i < minorTickAngles.length; i++)for(var k = 0; k < minorTickAngles[i].length; k++)lines.push(new $5b455ae6f843ac47$exports.Line({
            shape: $6fbccfdf5ee55341$var$getAxisLineShape(polar, radiusExtent, minorTickAngles[i][k].coord)
        }));
        group.add($5b455ae6f843ac47$exports.mergePath(lines, {
            style: lineStyleModel.getLineStyle(),
            silent: true,
            z: angleAxisModel.get("z")
        }));
    },
    splitArea: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        if (!ticksAngles.length) return;
        var splitAreaModel = angleAxisModel.getModel("splitArea");
        var areaStyleModel = splitAreaModel.getModel("areaStyle");
        var areaColors = areaStyleModel.get("color");
        var lineCount = 0;
        areaColors = areaColors instanceof Array ? areaColors : [
            areaColors
        ];
        var splitAreas = [];
        var RADIAN = Math.PI / 180;
        var prevAngle = -ticksAngles[0].coord * RADIAN;
        var r0 = Math.min(radiusExtent[0], radiusExtent[1]);
        var r1 = Math.max(radiusExtent[0], radiusExtent[1]);
        var clockwise = angleAxisModel.get("clockwise");
        for(var i = 1, len = ticksAngles.length; i <= len; i++){
            var coord = i === len ? ticksAngles[0].coord : ticksAngles[i].coord;
            var colorIndex = lineCount++ % areaColors.length;
            splitAreas[colorIndex] = splitAreas[colorIndex] || [];
            splitAreas[colorIndex].push(new $5b455ae6f843ac47$exports.Sector({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    r0: r0,
                    r: r1,
                    startAngle: prevAngle,
                    endAngle: -coord * RADIAN,
                    clockwise: clockwise
                },
                silent: true
            }));
            prevAngle = -coord * RADIAN;
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitAreas.length; i++)group.add($5b455ae6f843ac47$exports.mergePath(splitAreas[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                fill: areaColors[i % areaColors.length]
            }, areaStyleModel.getAreaStyle()),
            silent: true
        }));
    }
};
var $6fbccfdf5ee55341$export$2e2bcd8739ae039 = $6fbccfdf5ee55341$var$AngleAxisView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $e1f5ed5855e953f0$var$axisBuilderAttrs = [
    "axisLine",
    "axisTickLabel",
    "axisName"
];
var $e1f5ed5855e953f0$var$selfBuilderAttrs = [
    "splitLine",
    "splitArea",
    "minorSplitLine"
];
var $e1f5ed5855e953f0$var$RadiusAxisView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RadiusAxisView, _super);
    function RadiusAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadiusAxisView.type;
        _this.axisPointerClass = "PolarAxisPointer";
        return _this;
    }
    RadiusAxisView.prototype.render = function(radiusAxisModel, ecModel) {
        this.group.removeAll();
        if (!radiusAxisModel.get("show")) return;
        var oldAxisGroup = this._axisGroup;
        var newAxisGroup = this._axisGroup = new $5b455ae6f843ac47$exports.Group();
        this.group.add(newAxisGroup);
        var radiusAxis = radiusAxisModel.axis;
        var polar = radiusAxis.polar;
        var angleAxis = polar.getAngleAxis();
        var ticksCoords = radiusAxis.getTicksCoords();
        var minorTicksCoords = radiusAxis.getMinorTicksCoords();
        var axisAngle = angleAxis.getExtent()[0];
        var radiusExtent = radiusAxis.getExtent();
        var layout = $e1f5ed5855e953f0$var$layoutAxis(polar, radiusAxisModel, axisAngle);
        var axisBuilder = new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(radiusAxisModel, layout);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($e1f5ed5855e953f0$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
        newAxisGroup.add(axisBuilder.getGroup());
        $5b455ae6f843ac47$exports.groupTransition(oldAxisGroup, newAxisGroup, radiusAxisModel);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($e1f5ed5855e953f0$var$selfBuilderAttrs, function(name) {
            if (radiusAxisModel.get([
                name,
                "show"
            ]) && !radiusAxis.scale.isBlank()) $e1f5ed5855e953f0$var$axisElementBuilders[name](this.group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords);
        }, this);
    };
    RadiusAxisView.type = "radiusAxis";
    return RadiusAxisView;
}((0, $58c48a3ef1aa0746$export$2e2bcd8739ae039));
var $e1f5ed5855e953f0$var$axisElementBuilders = {
    splitLine: function(group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
        var splitLineModel = radiusAxisModel.getModel("splitLine");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var lineColors = lineStyleModel.get("color");
        var lineCount = 0;
        var angleAxis = polar.getAngleAxis();
        var RADIAN = Math.PI / 180;
        var angleExtent = angleAxis.getExtent();
        var shapeType = Math.abs(angleExtent[1] - angleExtent[0]) === 360 ? "Circle" : "Arc";
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var splitLines = [];
        for(var i = 0; i < ticksCoords.length; i++){
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(new $5b455ae6f843ac47$exports[shapeType]({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    // ensure circle radius >= 0
                    r: Math.max(ticksCoords[i].coord, 0),
                    startAngle: -angleExtent[0] * RADIAN,
                    endAngle: -angleExtent[1] * RADIAN,
                    clockwise: angleAxis.inverse
                }
            }));
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitLines.length; i++)group.add($5b455ae6f843ac47$exports.mergePath(splitLines[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                stroke: lineColors[i % lineColors.length],
                fill: null
            }, lineStyleModel.getLineStyle()),
            silent: true
        }));
    },
    minorSplitLine: function(group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords) {
        if (!minorTicksCoords.length) return;
        var minorSplitLineModel = radiusAxisModel.getModel("minorSplitLine");
        var lineStyleModel = minorSplitLineModel.getModel("lineStyle");
        var lines = [];
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++)lines.push(new $5b455ae6f843ac47$exports.Circle({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: minorTicksCoords[i][k].coord
            }
        }));
        group.add($5b455ae6f843ac47$exports.mergePath(lines, {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                fill: null
            }, lineStyleModel.getLineStyle()),
            silent: true
        }));
    },
    splitArea: function(group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
        if (!ticksCoords.length) return;
        var splitAreaModel = radiusAxisModel.getModel("splitArea");
        var areaStyleModel = splitAreaModel.getModel("areaStyle");
        var areaColors = areaStyleModel.get("color");
        var lineCount = 0;
        areaColors = areaColors instanceof Array ? areaColors : [
            areaColors
        ];
        var splitAreas = [];
        var prevRadius = ticksCoords[0].coord;
        for(var i = 1; i < ticksCoords.length; i++){
            var colorIndex = lineCount++ % areaColors.length;
            splitAreas[colorIndex] = splitAreas[colorIndex] || [];
            splitAreas[colorIndex].push(new $5b455ae6f843ac47$exports.Sector({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    r0: prevRadius,
                    r: ticksCoords[i].coord,
                    startAngle: 0,
                    endAngle: Math.PI * 2
                },
                silent: true
            }));
            prevRadius = ticksCoords[i].coord;
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitAreas.length; i++)group.add($5b455ae6f843ac47$exports.mergePath(splitAreas[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                fill: areaColors[i % areaColors.length]
            }, areaStyleModel.getAreaStyle()),
            silent: true
        }));
    }
};
/**
 * @inner
 */ function $e1f5ed5855e953f0$var$layoutAxis(polar, radiusAxisModel, axisAngle) {
    return {
        position: [
            polar.cx,
            polar.cy
        ],
        rotation: axisAngle / 180 * Math.PI,
        labelDirection: -1,
        tickDirection: -1,
        nameDirection: 1,
        labelRotate: radiusAxisModel.getModel("axisLabel").get("rotate"),
        // Over splitLine and splitArea
        z2: 1
    };
}
var $e1f5ed5855e953f0$export$2e2bcd8739ae039 = $e1f5ed5855e953f0$var$RadiusAxisView;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $ee4ff9541971b552$var$getSeriesStackId(seriesModel) {
    return seriesModel.get("stack") || "__ec_stack_" + seriesModel.seriesIndex;
}
function $ee4ff9541971b552$var$getAxisKey(polar, axis) {
    return axis.dim + polar.model.componentIndex;
}
function $ee4ff9541971b552$var$barLayoutPolar(seriesType, ecModel, api) {
    var lastStackCoords = {};
    var barWidthAndOffset = $ee4ff9541971b552$var$calRadialBar($7a1bd9c2710fea0d$export$3dea766d36a8935f(ecModel.getSeriesByType(seriesType), function(seriesModel) {
        return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === "polar";
    }));
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        // Check series coordinate, do layout for polar only
        if (seriesModel.coordinateSystem.type !== "polar") return;
        var data = seriesModel.getData();
        var polar = seriesModel.coordinateSystem;
        var baseAxis = polar.getBaseAxis();
        var axisKey = $ee4ff9541971b552$var$getAxisKey(polar, baseAxis);
        var stackId = $ee4ff9541971b552$var$getSeriesStackId(seriesModel);
        var columnLayoutInfo = barWidthAndOffset[axisKey][stackId];
        var columnOffset = columnLayoutInfo.offset;
        var columnWidth = columnLayoutInfo.width;
        var valueAxis = polar.getOtherAxis(baseAxis);
        var cx = seriesModel.coordinateSystem.cx;
        var cy = seriesModel.coordinateSystem.cy;
        var barMinHeight = seriesModel.get("barMinHeight") || 0;
        var barMinAngle = seriesModel.get("barMinAngle") || 0;
        lastStackCoords[stackId] = lastStackCoords[stackId] || [];
        var valueDim = data.mapDimension(valueAxis.dim);
        var baseDim = data.mapDimension(baseAxis.dim);
        var stacked = (0, $efdd976e4917927c$export$1dedc39359ae35c)(data, valueDim /* , baseDim */ );
        var clampLayout = baseAxis.dim !== "radius" || !seriesModel.get("roundCap", true);
        var valueAxisStart = valueAxis.dataToCoord(0);
        for(var idx = 0, len = data.count(); idx < len; idx++){
            var value = data.get(valueDim, idx);
            var baseValue = data.get(baseDim, idx);
            var sign = value >= 0 ? "p" : "n";
            var baseCoord = valueAxisStart;
            // Because of the barMinHeight, we can not use the value in
            // stackResultDimension directly.
            // Only ordinal axis can be stacked.
            if (stacked) {
                if (!lastStackCoords[stackId][baseValue]) lastStackCoords[stackId][baseValue] = {
                    p: valueAxisStart,
                    n: valueAxisStart // Negative stack
                };
                // Should also consider #4243
                baseCoord = lastStackCoords[stackId][baseValue][sign];
            }
            var r0 = void 0;
            var r = void 0;
            var startAngle = void 0;
            var endAngle = void 0;
            // radial sector
            if (valueAxis.dim === "radius") {
                var radiusSpan = valueAxis.dataToCoord(value) - valueAxisStart;
                var angle = baseAxis.dataToCoord(baseValue);
                if (Math.abs(radiusSpan) < barMinHeight) radiusSpan = (radiusSpan < 0 ? -1 : 1) * barMinHeight;
                r0 = baseCoord;
                r = baseCoord + radiusSpan;
                startAngle = angle - columnOffset;
                endAngle = startAngle - columnWidth;
                stacked && (lastStackCoords[stackId][baseValue][sign] = r);
            } else {
                var angleSpan = valueAxis.dataToCoord(value, clampLayout) - valueAxisStart;
                var radius = baseAxis.dataToCoord(baseValue);
                if (Math.abs(angleSpan) < barMinAngle) angleSpan = (angleSpan < 0 ? -1 : 1) * barMinAngle;
                r0 = radius + columnOffset;
                r = r0 + columnWidth;
                startAngle = baseCoord;
                endAngle = baseCoord + angleSpan;
                // if the previous stack is at the end of the ring,
                // add a round to differentiate it from origin
                // let extent = angleAxis.getExtent();
                // let stackCoord = angle;
                // if (stackCoord === extent[0] && value > 0) {
                //     stackCoord = extent[1];
                // }
                // else if (stackCoord === extent[1] && value < 0) {
                //     stackCoord = extent[0];
                // }
                stacked && (lastStackCoords[stackId][baseValue][sign] = endAngle);
            }
            data.setItemLayout(idx, {
                cx: cx,
                cy: cy,
                r0: r0,
                r: r,
                // Consider that positive angle is anti-clockwise,
                // while positive radian of sector is clockwise
                startAngle: -startAngle * Math.PI / 180,
                endAngle: -endAngle * Math.PI / 180,
                /**
         * Keep the same logic with bar in catesion: use end value to
         * control direction. Notice that if clockwise is true (by
         * default), the sector will always draw clockwisely, no matter
         * whether endAngle is greater or less than startAngle.
         */ clockwise: startAngle >= endAngle
            });
        }
    });
}
/**
 * Calculate bar width and offset for radial bar charts
 */ function $ee4ff9541971b552$var$calRadialBar(barSeries) {
    // Columns info on each category axis. Key is polar name
    var columnsMap = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(barSeries, function(seriesModel, idx) {
        var data = seriesModel.getData();
        var polar = seriesModel.coordinateSystem;
        var baseAxis = polar.getBaseAxis();
        var axisKey = $ee4ff9541971b552$var$getAxisKey(polar, baseAxis);
        var axisExtent = baseAxis.getExtent();
        var bandWidth = baseAxis.type === "category" ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
        var columnsOnAxis = columnsMap[axisKey] || {
            bandWidth: bandWidth,
            remainedWidth: bandWidth,
            autoWidthCount: 0,
            categoryGap: "20%",
            gap: "30%",
            stacks: {}
        };
        var stacks = columnsOnAxis.stacks;
        columnsMap[axisKey] = columnsOnAxis;
        var stackId = $ee4ff9541971b552$var$getSeriesStackId(seriesModel);
        if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
        stacks[stackId] = stacks[stackId] || {
            width: 0,
            maxWidth: 0
        };
        var barWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("barWidth"), bandWidth);
        var barMaxWidth = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(seriesModel.get("barMaxWidth"), bandWidth);
        var barGap = seriesModel.get("barGap");
        var barCategoryGap = seriesModel.get("barCategoryGap");
        if (barWidth && !stacks[stackId].width) {
            barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
            stacks[stackId].width = barWidth;
            columnsOnAxis.remainedWidth -= barWidth;
        }
        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
        barGap != null && (columnsOnAxis.gap = barGap);
        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
    });
    var result = {};
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(columnsMap, function(columnsOnAxis, coordSysName) {
        result[coordSysName] = {};
        var stacks = columnsOnAxis.stacks;
        var bandWidth = columnsOnAxis.bandWidth;
        var categoryGap = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(columnsOnAxis.categoryGap, bandWidth);
        var barGapPercent = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(columnsOnAxis.gap, 1);
        var remainedWidth = columnsOnAxis.remainedWidth;
        var autoWidthCount = columnsOnAxis.autoWidthCount;
        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        // Find if any auto calculated bar exceeded maxBarWidth
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(stacks, function(column, stack) {
            var maxWidth = column.maxWidth;
            if (maxWidth && maxWidth < autoWidth) {
                maxWidth = Math.min(maxWidth, remainedWidth);
                if (column.width) maxWidth = Math.min(maxWidth, column.width);
                remainedWidth -= maxWidth;
                column.width = maxWidth;
                autoWidthCount--;
            }
        });
        // Recalculate width again
        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        var widthSum = 0;
        var lastColumn;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(stacks, function(column, idx) {
            if (!column.width) column.width = autoWidth;
            lastColumn = column;
            widthSum += column.width * (1 + barGapPercent);
        });
        if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
        var offset = -widthSum / 2;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(stacks, function(column, stackId) {
            result[coordSysName][stackId] = result[coordSysName][stackId] || {
                offset: offset,
                width: column.width
            };
            offset += column.width * (1 + barGapPercent);
        });
    });
    return result;
}
var $ee4ff9541971b552$export$2e2bcd8739ae039 = $ee4ff9541971b552$var$barLayoutPolar;


var $0a6536a72e92ce0b$var$angleAxisExtraOption = {
    startAngle: 90,
    clockwise: true,
    splitNumber: 12,
    axisLabel: {
        rotate: 0
    }
};
var $0a6536a72e92ce0b$var$radiusAxisExtraOption = {
    splitNumber: 5
};
var $0a6536a72e92ce0b$var$PolarView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PolarView, _super);
    function PolarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PolarView.type;
        return _this;
    }
    PolarView.type = "polar";
    return PolarView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $0a6536a72e92ce0b$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
    (0, $58c48a3ef1aa0746$export$2e2bcd8739ae039).registerAxisPointerClass("PolarAxisPointer", (0, $692a4df2164e3c50$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("polar", (0, $45211ba328a63245$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $657132d924424c20$export$2e2bcd8739ae039));
    registers.registerComponentView($0a6536a72e92ce0b$var$PolarView);
    // Model and view for angleAxis and radiusAxis
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, "angle", (0, $d885303d9d4b2eee$export$34735c2c701428ca), $0a6536a72e92ce0b$var$angleAxisExtraOption);
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, "radius", (0, $d885303d9d4b2eee$export$de202388c212a23b), $0a6536a72e92ce0b$var$radiusAxisExtraOption);
    registers.registerComponentView((0, $6fbccfdf5ee55341$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $e1f5ed5855e953f0$export$2e2bcd8739ae039));
    registers.registerLayout((0, $7a1bd9c2710fea0d$export$c3095a23b368d1f2)((0, $ee4ff9541971b552$export$2e2bcd8739ae039), "bar"));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $eb958aa0a28bdfd8$export$b3219800bda33a1f(axisModel, opt) {
    opt = opt || {};
    var single = axisModel.coordinateSystem;
    var axis = axisModel.axis;
    var layout = {};
    var axisPosition = axis.position;
    var orient = axis.orient;
    var rect = single.getRect();
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var positionMap = {
        horizontal: {
            top: rectBound[2],
            bottom: rectBound[3]
        },
        vertical: {
            left: rectBound[0],
            right: rectBound[1]
        }
    };
    layout.position = [
        orient === "vertical" ? positionMap.vertical[axisPosition] : rectBound[0],
        orient === "horizontal" ? positionMap.horizontal[axisPosition] : rectBound[3]
    ];
    var r = {
        horizontal: 0,
        vertical: 1
    };
    layout.rotation = Math.PI / 2 * r[orient];
    var directionMap = {
        top: -1,
        bottom: 1,
        right: 1,
        left: -1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = directionMap[axisPosition];
    if (axisModel.get([
        "axisTick",
        "inside"
    ])) layout.tickDirection = -layout.tickDirection;
    if ($7a1bd9c2710fea0d$export$8a4d17b6e8486e66(opt.labelInside, axisModel.get([
        "axisLabel",
        "inside"
    ]))) layout.labelDirection = -layout.labelDirection;
    var labelRotation = opt.rotate;
    labelRotation == null && (labelRotation = axisModel.get([
        "axisLabel",
        "rotate"
    ]));
    layout.labelRotation = axisPosition === "top" ? -labelRotation : labelRotation;
    layout.z2 = 1;
    return layout;
}




var $e0635e836f59c3c6$var$axisBuilderAttrs = [
    "axisLine",
    "axisTickLabel",
    "axisName"
];
var $e0635e836f59c3c6$var$selfBuilderAttrs = [
    "splitArea",
    "splitLine"
];
var $e0635e836f59c3c6$var$SingleAxisView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SingleAxisView, _super);
    function SingleAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SingleAxisView.type;
        _this.axisPointerClass = "SingleAxisPointer";
        return _this;
    }
    SingleAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        var group = this.group;
        group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        var layout = $eb958aa0a28bdfd8$export$b3219800bda33a1f(axisModel);
        var axisBuilder = new (0, $dfe15f745e1c3c2b$export$2e2bcd8739ae039)(axisModel, layout);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($e0635e836f59c3c6$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
        group.add(this._axisGroup);
        group.add(axisBuilder.getGroup());
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($e0635e836f59c3c6$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                "show"
            ])) $e0635e836f59c3c6$var$axisElementBuilders[name](this, this.group, this._axisGroup, axisModel);
        }, this);
        $5b455ae6f843ac47$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    SingleAxisView.prototype.remove = function() {
        (0, $ff3096b1f24c33b6$export$48ebf2d6ce8ad076)(this);
    };
    SingleAxisView.type = "singleAxis";
    return SingleAxisView;
}((0, $58c48a3ef1aa0746$export$2e2bcd8739ae039));
var $e0635e836f59c3c6$var$axisElementBuilders = {
    splitLine: function(axisView, group, axisGroup, axisModel) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel("splitLine");
        var lineStyleModel = splitLineModel.getModel("lineStyle");
        var lineColors = lineStyleModel.get("color");
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var lineWidth = lineStyleModel.get("width");
        var gridRect = axisModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var splitLines = [];
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel
        });
        var p1 = [];
        var p2 = [];
        for(var i = 0; i < ticksCoords.length; ++i){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                silent: true
            });
            $5b455ae6f843ac47$export$8b4b620d7f4aad1b(line.shape, lineWidth);
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(line);
        }
        var lineStyle = lineStyleModel.getLineStyle([
            "color"
        ]);
        for(var i = 0; i < splitLines.length; ++i)group.add($5b455ae6f843ac47$export$7b1dd269fbc4e903(splitLines[i], {
            style: $7a1bd9c2710fea0d$export$ebe90cb607ad99e({
                stroke: lineColors[i % lineColors.length]
            }, lineStyle),
            silent: true
        }));
    },
    splitArea: function(axisView, group, axisGroup, axisModel) {
        (0, $ff3096b1f24c33b6$export$c80b7ef1527ec8c9)(axisView, axisGroup, axisModel, axisModel);
    }
};
var $e0635e836f59c3c6$export$2e2bcd8739ae039 = $e0635e836f59c3c6$var$SingleAxisView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $0b0fbc117344336a$var$SingleAxisModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SingleAxisModel, _super);
    function SingleAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SingleAxisModel.type;
        return _this;
    }
    SingleAxisModel.prototype.getCoordSysModel = function() {
        return this;
    };
    SingleAxisModel.type = "singleAxis";
    SingleAxisModel.layoutMode = "box";
    SingleAxisModel.defaultOption = {
        left: "5%",
        top: "5%",
        right: "5%",
        bottom: "5%",
        type: "value",
        position: "bottom",
        orient: "horizontal",
        axisLine: {
            show: true,
            lineStyle: {
                width: 1,
                type: "solid"
            }
        },
        // Single coordinate system and single axis is the,
        // which is used as the parent tooltip model.
        // same model, so we set default tooltip show as true.
        tooltip: {
            show: true
        },
        axisTick: {
            show: true,
            length: 6,
            lineStyle: {
                width: 1
            }
        },
        axisLabel: {
            show: true,
            interval: "auto"
        },
        splitLine: {
            show: true,
            lineStyle: {
                type: "dashed",
                opacity: 0.2
            }
        }
    };
    return SingleAxisModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($0b0fbc117344336a$var$SingleAxisModel, (0, $3449fd4c0590d99e$export$5c54b224726edb5a).prototype);
var $0b0fbc117344336a$export$2e2bcd8739ae039 = $0b0fbc117344336a$var$SingleAxisModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Single coordinate system creator.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Single coordinates system.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $75328fa4f01e808e$var$SingleAxis = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SingleAxis, _super);
    function SingleAxis(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        _this.type = axisType || "value";
        _this.position = position || "bottom";
        return _this;
    }
    /**
   * Judge the orient of the axis.
   */ SingleAxis.prototype.isHorizontal = function() {
        var position = this.position;
        return position === "top" || position === "bottom";
    };
    SingleAxis.prototype.pointToData = function(point, clamp) {
        return this.coordinateSystem.pointToData(point)[0];
    };
    return SingleAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $75328fa4f01e808e$export$2e2bcd8739ae039 = $75328fa4f01e808e$var$SingleAxis;





var $2e4ce743775bada6$export$28486687f659fb1a = [
    "single"
];
/**
 * Create a single coordinates system.
 */ var $2e4ce743775bada6$var$Single = /** @class */ function() {
    function Single(axisModel, ecModel, api) {
        this.type = "single";
        this.dimension = "single";
        /**
     * Add it just for draw tooltip.
     */ this.dimensions = $2e4ce743775bada6$export$28486687f659fb1a;
        this.axisPointerEnabled = true;
        this.model = axisModel;
        this._init(axisModel, ecModel, api);
    }
    /**
   * Initialize single coordinate system.
   */ Single.prototype._init = function(axisModel, ecModel, api) {
        var dim = this.dimension;
        var axis = new (0, $75328fa4f01e808e$export$2e2bcd8739ae039)(dim, $2d646e51cc34f840$export$8941c4cacdc8f5a5(axisModel), [
            0,
            0
        ], axisModel.get("type"), axisModel.get("position"));
        var isCategory = axis.type === "category";
        axis.onBand = isCategory && axisModel.get("boundaryGap");
        axis.inverse = axisModel.get("inverse");
        axis.orient = axisModel.get("orient");
        axisModel.axis = axis;
        axis.model = axisModel;
        axis.coordinateSystem = this;
        this._axis = axis;
    };
    /**
   * Update axis scale after data processed
   */ Single.prototype.update = function(ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.coordinateSystem === this) {
                var data_1 = seriesModel.getData();
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(data_1.mapDimensionsAll(this.dimension), function(dim) {
                    this._axis.scale.unionExtentFromData(data_1, dim);
                }, this);
                $2d646e51cc34f840$export$51f3e70a54405d5a(this._axis.scale, this._axis.model);
            }
        }, this);
    };
    /**
   * Resize the single coordinate system.
   */ Single.prototype.resize = function(axisModel, api) {
        this._rect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)({
            left: axisModel.get("left"),
            top: axisModel.get("top"),
            right: axisModel.get("right"),
            bottom: axisModel.get("bottom"),
            width: axisModel.get("width"),
            height: axisModel.get("height")
        }, {
            width: api.getWidth(),
            height: api.getHeight()
        });
        this._adjustAxis();
    };
    Single.prototype.getRect = function() {
        return this._rect;
    };
    Single.prototype._adjustAxis = function() {
        var rect = this._rect;
        var axis = this._axis;
        var isHorizontal = axis.isHorizontal();
        var extent = isHorizontal ? [
            0,
            rect.width
        ] : [
            0,
            rect.height
        ];
        var idx = axis.inverse ? 1 : 0;
        axis.setExtent(extent[idx], extent[1 - idx]);
        this._updateAxisTransform(axis, isHorizontal ? rect.x : rect.y);
    };
    Single.prototype._updateAxisTransform = function(axis, coordBase) {
        var axisExtent = axis.getExtent();
        var extentSum = axisExtent[0] + axisExtent[1];
        var isHorizontal = axis.isHorizontal();
        axis.toGlobalCoord = isHorizontal ? function(coord) {
            return coord + coordBase;
        } : function(coord) {
            return extentSum - coord + coordBase;
        };
        axis.toLocalCoord = isHorizontal ? function(coord) {
            return coord - coordBase;
        } : function(coord) {
            return extentSum - coord + coordBase;
        };
    };
    /**
   * Get axis.
   */ Single.prototype.getAxis = function() {
        return this._axis;
    };
    /**
   * Get axis, add it just for draw tooltip.
   */ Single.prototype.getBaseAxis = function() {
        return this._axis;
    };
    Single.prototype.getAxes = function() {
        return [
            this._axis
        ];
    };
    Single.prototype.getTooltipAxes = function() {
        return {
            baseAxes: [
                this.getAxis()
            ],
            // Empty otherAxes
            otherAxes: []
        };
    };
    /**
   * If contain point.
   */ Single.prototype.containPoint = function(point) {
        var rect = this.getRect();
        var axis = this.getAxis();
        var orient = axis.orient;
        if (orient === "horizontal") return axis.contain(axis.toLocalCoord(point[0])) && point[1] >= rect.y && point[1] <= rect.y + rect.height;
        else return axis.contain(axis.toLocalCoord(point[1])) && point[0] >= rect.y && point[0] <= rect.y + rect.height;
    };
    Single.prototype.pointToData = function(point) {
        var axis = this.getAxis();
        return [
            axis.coordToData(axis.toLocalCoord(point[axis.orient === "horizontal" ? 0 : 1]))
        ];
    };
    /**
   * Convert the series data to concrete point.
   * Can be [val] | val
   */ Single.prototype.dataToPoint = function(val) {
        var axis = this.getAxis();
        var rect = this.getRect();
        var pt = [];
        var idx = axis.orient === "horizontal" ? 0 : 1;
        if (val instanceof Array) val = val[0];
        pt[idx] = axis.toGlobalCoord(axis.dataToCoord(+val));
        pt[1 - idx] = idx === 0 ? rect.y + rect.height / 2 : rect.x + rect.width / 2;
        return pt;
    };
    Single.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $2e4ce743775bada6$var$getCoordSys(finder);
        return coordSys === this ? this.dataToPoint(value) : null;
    };
    Single.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $2e4ce743775bada6$var$getCoordSys(finder);
        return coordSys === this ? this.pointToData(pixel) : null;
    };
    return Single;
}();
function $2e4ce743775bada6$var$getCoordSys(finder) {
    var seriesModel = finder.seriesModel;
    var singleModel = finder.singleAxisModel;
    return singleModel && singleModel.coordinateSystem || seriesModel && seriesModel.coordinateSystem;
}
var $2e4ce743775bada6$export$2e2bcd8739ae039 = $2e4ce743775bada6$var$Single;



/**
 * Create single coordinate system and inject it into seriesModel.
 */ function $65313efe3e93ec7e$var$create(ecModel, api) {
    var singles = [];
    ecModel.eachComponent("singleAxis", function(axisModel, idx) {
        var single = new (0, $2e4ce743775bada6$export$2e2bcd8739ae039)(axisModel, ecModel, api);
        single.name = "single_" + idx;
        single.resize(axisModel, api);
        axisModel.coordinateSystem = single;
        singles.push(single);
    });
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.get("coordinateSystem") === "singleAxis") {
            var singleAxisModel = seriesModel.getReferringComponents("singleAxis", (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
            seriesModel.coordinateSystem = singleAxisModel && singleAxisModel.coordinateSystem;
        }
    });
    return singles;
}
var $65313efe3e93ec7e$var$singleCreator = {
    create: $65313efe3e93ec7e$var$create,
    dimensions: (0, $2e4ce743775bada6$export$28486687f659fb1a)
};
var $65313efe3e93ec7e$export$2e2bcd8739ae039 = $65313efe3e93ec7e$var$singleCreator;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $26df41956a30cbbf$var$XY = [
    "x",
    "y"
];
var $26df41956a30cbbf$var$WH = [
    "width",
    "height"
];
var $26df41956a30cbbf$var$SingleAxisPointer = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SingleAxisPointer, _super);
    function SingleAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ SingleAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var coordSys = axis.coordinateSystem;
        var otherExtent = $26df41956a30cbbf$var$getGlobalExtent(coordSys, 1 - $26df41956a30cbbf$var$getPointDimIndex(axis));
        var pixelValue = coordSys.dataToPoint(value)[0];
        var axisPointerType = axisPointerModel.get("type");
        if (axisPointerType && axisPointerType !== "none") {
            var elStyle = $51dec70890757374$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $26df41956a30cbbf$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $eb958aa0a28bdfd8$export$b3219800bda33a1f(axisModel);
        $51dec70890757374$export$fd3eb3812211a173(// @ts-ignore
        value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ SingleAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $eb958aa0a28bdfd8$export$b3219800bda33a1f(axisModel, {
            labelInside: false
        });
        // @ts-ignore
        layoutInfo.labelMargin = axisPointerModel.get([
            "handle",
            "margin"
        ]);
        var position = $51dec70890757374$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo);
        return {
            x: position[0],
            y: position[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ SingleAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var coordSys = axis.coordinateSystem;
        var dimIndex = $26df41956a30cbbf$var$getPointDimIndex(axis);
        var axisExtent = $26df41956a30cbbf$var$getGlobalExtent(coordSys, dimIndex);
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
        var otherExtent = $26df41956a30cbbf$var$getGlobalExtent(coordSys, 1 - dimIndex);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: {
                verticalAlign: "middle"
            }
        };
    };
    return SingleAxisPointer;
}((0, $a331d7a6c631e6d9$export$2e2bcd8739ae039));
var $26df41956a30cbbf$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, otherExtent) {
        var targetShape = $51dec70890757374$export$885fa0ad5a826207([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $26df41956a30cbbf$var$getPointDimIndex(axis));
        return {
            type: "Line",
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, otherExtent) {
        var bandWidth = axis.getBandWidth();
        var span = otherExtent[1] - otherExtent[0];
        return {
            type: "Rect",
            shape: $51dec70890757374$export$a8b35248bcc02756([
                pixelValue - bandWidth / 2,
                otherExtent[0]
            ], [
                bandWidth,
                span
            ], $26df41956a30cbbf$var$getPointDimIndex(axis))
        };
    }
};
function $26df41956a30cbbf$var$getPointDimIndex(axis) {
    return axis.isHorizontal() ? 0 : 1;
}
function $26df41956a30cbbf$var$getGlobalExtent(coordSys, dimIndex) {
    var rect = coordSys.getRect();
    return [
        rect[$26df41956a30cbbf$var$XY[dimIndex]],
        rect[$26df41956a30cbbf$var$XY[dimIndex]] + rect[$26df41956a30cbbf$var$WH[dimIndex]]
    ];
}
var $26df41956a30cbbf$export$2e2bcd8739ae039 = $26df41956a30cbbf$var$SingleAxisPointer;


var $2e3198006a202a14$var$SingleView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SingleView, _super);
    function SingleView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SingleView.type;
        return _this;
    }
    SingleView.type = "single";
    return SingleView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $2e3198006a202a14$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
    (0, $58c48a3ef1aa0746$export$2e2bcd8739ae039).registerAxisPointerClass("SingleAxisPointer", (0, $26df41956a30cbbf$export$2e2bcd8739ae039));
    registers.registerComponentView($2e3198006a202a14$var$SingleView);
    // Axis
    registers.registerComponentView((0, $e0635e836f59c3c6$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $0b0fbc117344336a$export$2e2bcd8739ae039));
    (0, $c5c4c85259d60abe$export$2e2bcd8739ae039)(registers, "single", (0, $0b0fbc117344336a$export$2e2bcd8739ae039), (0, $0b0fbc117344336a$export$2e2bcd8739ae039).defaultOption);
    registers.registerCoordinateSystem("single", (0, $65313efe3e93ec7e$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $0a5c39a9e7129dc4$var$TimelineModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TimelineModel, _super);
    function TimelineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TimelineModel.type;
        _this.layoutMode = "box";
        return _this;
    }
    /**
   * @override
   */ TimelineModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        this._initData();
    };
    /**
   * @override
   */ TimelineModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        this._initData();
    };
    TimelineModel.prototype.setCurrentIndex = function(currentIndex) {
        if (currentIndex == null) currentIndex = this.option.currentIndex;
        var count = this._data.count();
        if (this.option.loop) currentIndex = (currentIndex % count + count) % count;
        else {
            currentIndex >= count && (currentIndex = count - 1);
            currentIndex < 0 && (currentIndex = 0);
        }
        this.option.currentIndex = currentIndex;
    };
    /**
   * @return {number} currentIndex
   */ TimelineModel.prototype.getCurrentIndex = function() {
        return this.option.currentIndex;
    };
    /**
   * @return {boolean}
   */ TimelineModel.prototype.isIndexMax = function() {
        return this.getCurrentIndex() >= this._data.count() - 1;
    };
    /**
   * @param {boolean} state true: play, false: stop
   */ TimelineModel.prototype.setPlayState = function(state) {
        this.option.autoPlay = !!state;
    };
    /**
   * @return {boolean} true: play, false: stop
   */ TimelineModel.prototype.getPlayState = function() {
        return !!this.option.autoPlay;
    };
    /**
   * @private
   */ TimelineModel.prototype._initData = function() {
        var thisOption = this.option;
        var dataArr = thisOption.data || [];
        var axisType = thisOption.axisType;
        var names = this._names = [];
        var processedDataArr;
        if (axisType === "category") {
            processedDataArr = [];
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataArr, function(item, index) {
                var value = (0, $76d619f648247e6d$export$fb1a222ba5dd6e51)((0, $76d619f648247e6d$export$2c944e12edb48d4b)(item), "");
                var newItem;
                if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(item)) {
                    newItem = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(item);
                    newItem.value = index;
                } else newItem = index;
                processedDataArr.push(newItem);
                names.push(value);
            });
        } else processedDataArr = dataArr;
        var dimType = {
            category: "ordinal",
            time: "time",
            value: "number"
        }[axisType] || "number";
        var data = this._data = new (0, $0ab0556b819346fd$export$2e2bcd8739ae039)([
            {
                name: "value",
                type: dimType
            }
        ], this);
        data.initData(processedDataArr, names);
    };
    TimelineModel.prototype.getData = function() {
        return this._data;
    };
    /**
   * @public
   * @return {Array.<string>} categoreis
   */ TimelineModel.prototype.getCategories = function() {
        if (this.get("axisType") === "category") return this._names.slice();
    };
    TimelineModel.type = "timeline";
    /**
   * @protected
   */ TimelineModel.defaultOption = {
        // zlevel: 0,                  // 一级层叠
        z: 4,
        show: true,
        axisType: "time",
        realtime: true,
        left: "20%",
        top: null,
        right: "20%",
        bottom: 0,
        width: null,
        height: 40,
        padding: 5,
        controlPosition: "left",
        autoPlay: false,
        rewind: false,
        loop: true,
        playInterval: 2000,
        currentIndex: 0,
        itemStyle: {},
        label: {
            color: "#000"
        },
        data: []
    };
    return TimelineModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $0a5c39a9e7129dc4$export$2e2bcd8739ae039 = $0a5c39a9e7129dc4$var$TimelineModel;





var $22b93c2a0cce341f$var$SliderTimelineModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SliderTimelineModel, _super);
    function SliderTimelineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderTimelineModel.type;
        return _this;
    }
    SliderTimelineModel.type = "timeline.slider";
    /**
   * @protected
   */ SliderTimelineModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $0a5c39a9e7129dc4$export$2e2bcd8739ae039).defaultOption, {
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: "#ccc",
        borderWidth: 0,
        orient: "horizontal",
        inverse: false,
        tooltip: {
            trigger: "item" // data item may also have tootip attr.
        },
        symbol: "circle",
        symbolSize: 12,
        lineStyle: {
            show: true,
            width: 2,
            color: "#DAE1F5"
        },
        label: {
            position: "auto",
            // When using number, label position is not
            // restricted by viewRect.
            // positive: right/bottom, negative: left/top
            show: true,
            interval: "auto",
            rotate: 0,
            // formatter: null,
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: "#A4B1D7"
        },
        itemStyle: {
            color: "#A4B1D7",
            borderWidth: 1
        },
        checkpointStyle: {
            symbol: "circle",
            symbolSize: 15,
            color: "#316bf3",
            borderColor: "#fff",
            borderWidth: 2,
            shadowBlur: 2,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowColor: "rgba(0, 0, 0, 0.3)",
            // borderColor: 'rgba(194,53,49, 0.5)',
            animation: true,
            animationDuration: 300,
            animationEasing: "quinticInOut"
        },
        controlStyle: {
            show: true,
            showPlayBtn: true,
            showPrevBtn: true,
            showNextBtn: true,
            itemSize: 24,
            itemGap: 12,
            position: "left",
            playIcon: "path://M31.6,53C17.5,53,6,41.5,6,27.4S17.5,1.8,31.6,1.8C45.7,1.8,57.2,13.3,57.2,27.4S45.7,53,31.6,53z M31.6,3.3 C18.4,3.3,7.5,14.1,7.5,27.4c0,13.3,10.8,24.1,24.1,24.1C44.9,51.5,55.7,40.7,55.7,27.4C55.7,14.1,44.9,3.3,31.6,3.3z M24.9,21.3 c0-2.2,1.6-3.1,3.5-2l10.5,6.1c1.899,1.1,1.899,2.9,0,4l-10.5,6.1c-1.9,1.1-3.5,0.2-3.5-2V21.3z",
            stopIcon: "path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z",
            // eslint-disable-next-line max-len
            nextIcon: "M2,18.5A1.52,1.52,0,0,1,.92,18a1.49,1.49,0,0,1,0-2.12L7.81,9.36,1,3.11A1.5,1.5,0,1,1,3,.89l8,7.34a1.48,1.48,0,0,1,.49,1.09,1.51,1.51,0,0,1-.46,1.1L3,18.08A1.5,1.5,0,0,1,2,18.5Z",
            // eslint-disable-next-line max-len
            prevIcon: "M10,.5A1.52,1.52,0,0,1,11.08,1a1.49,1.49,0,0,1,0,2.12L4.19,9.64,11,15.89a1.5,1.5,0,1,1-2,2.22L1,10.77A1.48,1.48,0,0,1,.5,9.68,1.51,1.51,0,0,1,1,8.58L9,.92A1.5,1.5,0,0,1,10,.5Z",
            prevBtnSize: 18,
            nextBtnSize: 18,
            color: "#A4B1D7",
            borderColor: "#A4B1D7",
            borderWidth: 1
        },
        emphasis: {
            label: {
                show: true,
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                color: "#6f778d"
            },
            itemStyle: {
                color: "#316BF3"
            },
            controlStyle: {
                color: "#316BF3",
                borderColor: "#316BF3",
                borderWidth: 2
            }
        },
        progress: {
            lineStyle: {
                color: "#316BF3"
            },
            itemStyle: {
                color: "#316BF3"
            },
            label: {
                color: "#6f778d"
            }
        },
        data: []
    });
    return SliderTimelineModel;
}((0, $0a5c39a9e7129dc4$export$2e2bcd8739ae039));
(0, $7a1bd9c2710fea0d$export$e36fc9d62a853069)($22b93c2a0cce341f$var$SliderTimelineModel, (0, $655dd6075cc63601$export$f23396ae04ea95a7).prototype);
var $22b93c2a0cce341f$export$2e2bcd8739ae039 = $22b93c2a0cce341f$var$SliderTimelineModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $79b71ced407c5926$var$TimelineView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TimelineView, _super);
    function TimelineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TimelineView.type;
        return _this;
    }
    TimelineView.type = "timeline";
    return TimelineView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $79b71ced407c5926$export$2e2bcd8739ae039 = $79b71ced407c5926$var$TimelineView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Extend axis 2d
 */ var $d38633a847120ec8$var$TimelineAxis = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TimelineAxis, _super);
    function TimelineAxis(dim, scale, coordExtent, axisType) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        _this.type = axisType || "value";
        return _this;
    }
    /**
   * @override
   */ TimelineAxis.prototype.getLabelModel = function() {
        // Force override
        return this.model.getModel("label");
    };
    /**
   * @override
   */ TimelineAxis.prototype.isHorizontal = function() {
        return this.model.get("orient") === "horizontal";
    };
    return TimelineAxis;
}((0, $c2b1efffe5ae3f42$export$2e2bcd8739ae039));
var $d38633a847120ec8$export$2e2bcd8739ae039 = $d38633a847120ec8$var$TimelineAxis;













var $aba52479ef639cd6$var$PI = Math.PI;
var $aba52479ef639cd6$var$labelDataIndexStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $aba52479ef639cd6$var$SliderTimelineView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SliderTimelineView, _super);
    function SliderTimelineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderTimelineView.type;
        return _this;
    }
    SliderTimelineView.prototype.init = function(ecModel, api) {
        this.api = api;
    };
    /**
   * @override
   */ SliderTimelineView.prototype.render = function(timelineModel, ecModel, api) {
        this.model = timelineModel;
        this.api = api;
        this.ecModel = ecModel;
        this.group.removeAll();
        if (timelineModel.get("show", true)) {
            var layoutInfo_1 = this._layout(timelineModel, api);
            var mainGroup_1 = this._createGroup("_mainGroup");
            var labelGroup = this._createGroup("_labelGroup");
            var axis_1 = this._axis = this._createAxis(layoutInfo_1, timelineModel);
            timelineModel.formatTooltip = function(dataIndex) {
                var name = axis_1.scale.getLabel({
                    value: dataIndex
                });
                return (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("nameValue", {
                    noName: true,
                    value: name
                });
            };
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
                "AxisLine",
                "AxisTick",
                "Control",
                "CurrentPointer"
            ], function(name) {
                this["_render" + name](layoutInfo_1, mainGroup_1, axis_1, timelineModel);
            }, this);
            this._renderAxisLabel(layoutInfo_1, labelGroup, axis_1, timelineModel);
            this._position(layoutInfo_1, timelineModel);
        }
        this._doPlayStop();
        this._updateTicksStatus();
    };
    /**
   * @override
   */ SliderTimelineView.prototype.remove = function() {
        this._clearTimer();
        this.group.removeAll();
    };
    /**
   * @override
   */ SliderTimelineView.prototype.dispose = function() {
        this._clearTimer();
    };
    SliderTimelineView.prototype._layout = function(timelineModel, api) {
        var labelPosOpt = timelineModel.get([
            "label",
            "position"
        ]);
        var orient = timelineModel.get("orient");
        var viewRect = $aba52479ef639cd6$var$getViewRect(timelineModel, api);
        var parsedLabelPos;
        // Auto label offset.
        if (labelPosOpt == null || labelPosOpt === "auto") parsedLabelPos = orient === "horizontal" ? viewRect.y + viewRect.height / 2 < api.getHeight() / 2 ? "-" : "+" : viewRect.x + viewRect.width / 2 < api.getWidth() / 2 ? "+" : "-";
        else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(labelPosOpt)) parsedLabelPos = ({
            horizontal: {
                top: "-",
                bottom: "+"
            },
            vertical: {
                left: "-",
                right: "+"
            }
        })[orient][labelPosOpt];
        else // is number
        parsedLabelPos = labelPosOpt;
        var labelAlignMap = {
            horizontal: "center",
            vertical: parsedLabelPos >= 0 || parsedLabelPos === "+" ? "left" : "right"
        };
        var labelBaselineMap = {
            horizontal: parsedLabelPos >= 0 || parsedLabelPos === "+" ? "top" : "bottom",
            vertical: "middle"
        };
        var rotationMap = {
            horizontal: 0,
            vertical: $aba52479ef639cd6$var$PI / 2
        };
        // Position
        var mainLength = orient === "vertical" ? viewRect.height : viewRect.width;
        var controlModel = timelineModel.getModel("controlStyle");
        var showControl = controlModel.get("show", true);
        var controlSize = showControl ? controlModel.get("itemSize") : 0;
        var controlGap = showControl ? controlModel.get("itemGap") : 0;
        var sizePlusGap = controlSize + controlGap;
        // Special label rotate.
        var labelRotation = timelineModel.get([
            "label",
            "rotate"
        ]) || 0;
        labelRotation = labelRotation * $aba52479ef639cd6$var$PI / 180; // To radian.
        var playPosition;
        var prevBtnPosition;
        var nextBtnPosition;
        var controlPosition = controlModel.get("position", true);
        var showPlayBtn = showControl && controlModel.get("showPlayBtn", true);
        var showPrevBtn = showControl && controlModel.get("showPrevBtn", true);
        var showNextBtn = showControl && controlModel.get("showNextBtn", true);
        var xLeft = 0;
        var xRight = mainLength;
        // position[0] means left, position[1] means middle.
        if (controlPosition === "left" || controlPosition === "bottom") {
            showPlayBtn && (playPosition = [
                0,
                0
            ], xLeft += sizePlusGap);
            showPrevBtn && (prevBtnPosition = [
                xLeft,
                0
            ], xLeft += sizePlusGap);
            showNextBtn && (nextBtnPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
        } else {
            // 'top' 'right'
            showPlayBtn && (playPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
            showPrevBtn && (prevBtnPosition = [
                0,
                0
            ], xLeft += sizePlusGap);
            showNextBtn && (nextBtnPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
        }
        var axisExtent = [
            xLeft,
            xRight
        ];
        if (timelineModel.get("inverse")) axisExtent.reverse();
        return {
            viewRect: viewRect,
            mainLength: mainLength,
            orient: orient,
            rotation: rotationMap[orient],
            labelRotation: labelRotation,
            labelPosOpt: parsedLabelPos,
            labelAlign: timelineModel.get([
                "label",
                "align"
            ]) || labelAlignMap[orient],
            labelBaseline: timelineModel.get([
                "label",
                "verticalAlign"
            ]) || timelineModel.get([
                "label",
                "baseline"
            ]) || labelBaselineMap[orient],
            // Based on mainGroup.
            playPosition: playPosition,
            prevBtnPosition: prevBtnPosition,
            nextBtnPosition: nextBtnPosition,
            axisExtent: axisExtent,
            controlSize: controlSize,
            controlGap: controlGap
        };
    };
    SliderTimelineView.prototype._position = function(layoutInfo, timelineModel) {
        // Position is be called finally, because bounding rect is needed for
        // adapt content to fill viewRect (auto adapt offset).
        // Timeline may be not all in the viewRect when 'offset' is specified
        // as a number, because it is more appropriate that label aligns at
        // 'offset' but not the other edge defined by viewRect.
        var mainGroup = this._mainGroup;
        var labelGroup = this._labelGroup;
        var viewRect = layoutInfo.viewRect;
        if (layoutInfo.orient === "vertical") {
            // transform to horizontal, inverse rotate by left-top point.
            var m = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
            var rotateOriginX = viewRect.x;
            var rotateOriginY = viewRect.y + viewRect.height;
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
                -rotateOriginX,
                -rotateOriginY
            ]);
            $f41ebb9dd60b55b4$export$bb628a54ab399bc9(m, m, -$aba52479ef639cd6$var$PI / 2);
            $f41ebb9dd60b55b4$export$d73ee8ef04f5226a(m, m, [
                rotateOriginX,
                rotateOriginY
            ]);
            viewRect = viewRect.clone();
            viewRect.applyTransform(m);
        }
        var viewBound = getBound(viewRect);
        var mainBound = getBound(mainGroup.getBoundingRect());
        var labelBound = getBound(labelGroup.getBoundingRect());
        var mainPosition = [
            mainGroup.x,
            mainGroup.y
        ];
        var labelsPosition = [
            labelGroup.x,
            labelGroup.y
        ];
        labelsPosition[0] = mainPosition[0] = viewBound[0][0];
        var labelPosOpt = layoutInfo.labelPosOpt;
        if (labelPosOpt == null || (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(labelPosOpt)) {
            // '+' or '-'
            var mainBoundIdx = labelPosOpt === "+" ? 0 : 1;
            toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
            toBound(labelsPosition, labelBound, viewBound, 1, 1 - mainBoundIdx);
        } else {
            var mainBoundIdx = labelPosOpt >= 0 ? 0 : 1;
            toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
            labelsPosition[1] = mainPosition[1] + labelPosOpt;
        }
        mainGroup.setPosition(mainPosition);
        labelGroup.setPosition(labelsPosition);
        mainGroup.rotation = labelGroup.rotation = layoutInfo.rotation;
        setOrigin(mainGroup);
        setOrigin(labelGroup);
        function setOrigin(targetGroup) {
            targetGroup.originX = viewBound[0][0] - targetGroup.x;
            targetGroup.originY = viewBound[1][0] - targetGroup.y;
        }
        function getBound(rect) {
            // [[xmin, xmax], [ymin, ymax]]
            return [
                [
                    rect.x,
                    rect.x + rect.width
                ],
                [
                    rect.y,
                    rect.y + rect.height
                ]
            ];
        }
        function toBound(fromPos, from, to, dimIdx, boundIdx) {
            fromPos[dimIdx] += to[dimIdx][boundIdx] - from[dimIdx][boundIdx];
        }
    };
    SliderTimelineView.prototype._createAxis = function(layoutInfo, timelineModel) {
        var data = timelineModel.getData();
        var axisType = timelineModel.get("axisType");
        var scale = $aba52479ef639cd6$var$createScaleByModel(timelineModel, axisType);
        // Customize scale. The `tickValue` is `dataIndex`.
        scale.getTicks = function() {
            return data.mapArray([
                "value"
            ], function(value) {
                return {
                    value: value
                };
            });
        };
        var dataExtent = data.getDataExtent("value");
        scale.setExtent(dataExtent[0], dataExtent[1]);
        scale.calcNiceTicks();
        var axis = new (0, $d38633a847120ec8$export$2e2bcd8739ae039)("value", scale, layoutInfo.axisExtent, axisType);
        axis.model = timelineModel;
        return axis;
    };
    SliderTimelineView.prototype._createGroup = function(key) {
        var newGroup = this[key] = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        this.group.add(newGroup);
        return newGroup;
    };
    SliderTimelineView.prototype._renderAxisLine = function(layoutInfo, group, axis, timelineModel) {
        var axisExtent = axis.getExtent();
        if (!timelineModel.get([
            "lineStyle",
            "show"
        ])) return;
        var line = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
            shape: {
                x1: axisExtent[0],
                y1: 0,
                x2: axisExtent[1],
                y2: 0
            },
            style: (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                lineCap: "round"
            }, timelineModel.getModel("lineStyle").getLineStyle()),
            silent: true,
            z2: 1
        });
        group.add(line);
        var progressLine = this._progressLine = new $7a316ae5ceff7b27$export$2e2bcd8739ae039({
            shape: {
                x1: axisExtent[0],
                x2: this._currentPointer ? this._currentPointer.x : axisExtent[0],
                y1: 0,
                y2: 0
            },
            style: (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                lineCap: "round",
                lineWidth: line.style.lineWidth
            }, timelineModel.getModel([
                "progress",
                "lineStyle"
            ]).getLineStyle()),
            silent: true,
            z2: 1
        });
        group.add(progressLine);
    };
    SliderTimelineView.prototype._renderAxisTick = function(layoutInfo, group, axis, timelineModel) {
        var _this = this;
        var data = timelineModel.getData();
        // Show all ticks, despite ignoring strategy.
        var ticks = axis.scale.getTicks();
        this._tickSymbols = [];
        // The value is dataIndex, see the customized scale.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(ticks, function(tick) {
            var tickCoord = axis.dataToCoord(tick.value);
            var itemModel = data.getItemModel(tick.value);
            var itemStyleModel = itemModel.getModel("itemStyle");
            var hoverStyleModel = itemModel.getModel([
                "emphasis",
                "itemStyle"
            ]);
            var progressStyleModel = itemModel.getModel([
                "progress",
                "itemStyle"
            ]);
            var symbolOpt = {
                x: tickCoord,
                y: 0,
                onclick: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._changeTimeline, _this, tick.value)
            };
            var el = $aba52479ef639cd6$var$giveSymbol(itemModel, itemStyleModel, group, symbolOpt);
            el.ensureState("emphasis").style = hoverStyleModel.getItemStyle();
            el.ensureState("progress").style = progressStyleModel.getItemStyle();
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(el);
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
            if (itemModel.get("tooltip")) {
                ecData.dataIndex = tick.value;
                ecData.dataModel = timelineModel;
            } else ecData.dataIndex = ecData.dataModel = null;
            _this._tickSymbols.push(el);
        });
    };
    SliderTimelineView.prototype._renderAxisLabel = function(layoutInfo, group, axis, timelineModel) {
        var _this = this;
        var labelModel = axis.getLabelModel();
        if (!labelModel.get("show")) return;
        var data = timelineModel.getData();
        var labels = axis.getViewLabels();
        this._tickLabels = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(labels, function(labelItem) {
            // The tickValue is dataIndex, see the customized scale.
            var dataIndex = labelItem.tickValue;
            var itemModel = data.getItemModel(dataIndex);
            var normalLabelModel = itemModel.getModel("label");
            var hoverLabelModel = itemModel.getModel([
                "emphasis",
                "label"
            ]);
            var progressLabelModel = itemModel.getModel([
                "progress",
                "label"
            ]);
            var tickCoord = axis.dataToCoord(labelItem.tickValue);
            var textEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
                x: tickCoord,
                y: 0,
                rotation: layoutInfo.labelRotation - layoutInfo.rotation,
                onclick: (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(_this._changeTimeline, _this, dataIndex),
                silent: false,
                style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(normalLabelModel, {
                    text: labelItem.formattedLabel,
                    align: layoutInfo.labelAlign,
                    verticalAlign: layoutInfo.labelBaseline
                })
            });
            textEl.ensureState("emphasis").style = (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(hoverLabelModel);
            textEl.ensureState("progress").style = (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(progressLabelModel);
            group.add(textEl);
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(textEl);
            $aba52479ef639cd6$var$labelDataIndexStore(textEl).dataIndex = dataIndex;
            _this._tickLabels.push(textEl);
        });
    };
    SliderTimelineView.prototype._renderControl = function(layoutInfo, group, axis, timelineModel) {
        var controlSize = layoutInfo.controlSize;
        var rotation = layoutInfo.rotation;
        var itemStyle = timelineModel.getModel("controlStyle").getItemStyle();
        var hoverStyle = timelineModel.getModel([
            "emphasis",
            "controlStyle"
        ]).getItemStyle();
        var playState = timelineModel.getPlayState();
        var inverse = timelineModel.get("inverse", true);
        makeBtn(layoutInfo.nextBtnPosition, "next", (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._changeTimeline, this, inverse ? "-" : "+"));
        makeBtn(layoutInfo.prevBtnPosition, "prev", (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._changeTimeline, this, inverse ? "+" : "-"));
        makeBtn(layoutInfo.playPosition, playState ? "stop" : "play", (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this._handlePlayClick, this, !playState), true);
        function makeBtn(position, iconName, onclick, willRotate) {
            if (!position) return;
            var iconSize = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)((0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(timelineModel.get([
                "controlStyle",
                iconName + "BtnSize"
            ]), controlSize), controlSize);
            var rect = [
                0,
                -iconSize / 2,
                iconSize,
                iconSize
            ];
            var btn = $aba52479ef639cd6$var$makeControlIcon(timelineModel, iconName + "Icon", rect, {
                x: position[0],
                y: position[1],
                originX: controlSize / 2,
                originY: 0,
                rotation: willRotate ? -rotation : 0,
                rectHover: true,
                style: itemStyle,
                onclick: onclick
            });
            btn.ensureState("emphasis").style = hoverStyle;
            group.add(btn);
            (0, $2bf82c0980125b62$export$5f393df0b5aee2e7)(btn);
        }
    };
    SliderTimelineView.prototype._renderCurrentPointer = function(layoutInfo, group, axis, timelineModel) {
        var data = timelineModel.getData();
        var currentIndex = timelineModel.getCurrentIndex();
        var pointerModel = data.getItemModel(currentIndex).getModel("checkpointStyle");
        var me = this;
        var callback = {
            onCreate: function(pointer) {
                pointer.draggable = true;
                pointer.drift = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(me._handlePointerDrag, me);
                pointer.ondragend = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(me._handlePointerDragend, me);
                $aba52479ef639cd6$var$pointerMoveTo(pointer, me._progressLine, currentIndex, axis, timelineModel, true);
            },
            onUpdate: function(pointer) {
                $aba52479ef639cd6$var$pointerMoveTo(pointer, me._progressLine, currentIndex, axis, timelineModel);
            }
        };
        // Reuse when exists, for animation and drag.
        this._currentPointer = $aba52479ef639cd6$var$giveSymbol(pointerModel, pointerModel, this._mainGroup, {}, this._currentPointer, callback);
    };
    SliderTimelineView.prototype._handlePlayClick = function(nextState) {
        this._clearTimer();
        this.api.dispatchAction({
            type: "timelinePlayChange",
            playState: nextState,
            from: this.uid
        });
    };
    SliderTimelineView.prototype._handlePointerDrag = function(dx, dy, e) {
        this._clearTimer();
        this._pointerChangeTimeline([
            e.offsetX,
            e.offsetY
        ]);
    };
    SliderTimelineView.prototype._handlePointerDragend = function(e) {
        this._pointerChangeTimeline([
            e.offsetX,
            e.offsetY
        ], true);
    };
    SliderTimelineView.prototype._pointerChangeTimeline = function(mousePos, trigger) {
        var toCoord = this._toAxisCoord(mousePos)[0];
        var axis = this._axis;
        var axisExtent = $cfc1f3b422a3185f$export$debe6e778e0a6d32(axis.getExtent().slice());
        toCoord > axisExtent[1] && (toCoord = axisExtent[1]);
        toCoord < axisExtent[0] && (toCoord = axisExtent[0]);
        this._currentPointer.x = toCoord;
        this._currentPointer.markRedraw();
        var progressLine = this._progressLine;
        if (progressLine) {
            progressLine.shape.x2 = toCoord;
            progressLine.dirty();
        }
        var targetDataIndex = this._findNearestTick(toCoord);
        var timelineModel = this.model;
        if (trigger || targetDataIndex !== timelineModel.getCurrentIndex() && timelineModel.get("realtime")) this._changeTimeline(targetDataIndex);
    };
    SliderTimelineView.prototype._doPlayStop = function() {
        var _this = this;
        this._clearTimer();
        if (this.model.getPlayState()) this._timer = setTimeout(function() {
            // Do not cache
            var timelineModel = _this.model;
            _this._changeTimeline(timelineModel.getCurrentIndex() + (timelineModel.get("rewind", true) ? -1 : 1));
        }, this.model.get("playInterval"));
    };
    SliderTimelineView.prototype._toAxisCoord = function(vertex) {
        var trans = this._mainGroup.getLocalTransform();
        return $5b455ae6f843ac47$export$9f9dcb98c894b623(vertex, trans, true);
    };
    SliderTimelineView.prototype._findNearestTick = function(axisCoord) {
        var data = this.model.getData();
        var dist = Infinity;
        var targetDataIndex;
        var axis = this._axis;
        data.each([
            "value"
        ], function(value, dataIndex) {
            var coord = axis.dataToCoord(value);
            var d = Math.abs(coord - axisCoord);
            if (d < dist) {
                dist = d;
                targetDataIndex = dataIndex;
            }
        });
        return targetDataIndex;
    };
    SliderTimelineView.prototype._clearTimer = function() {
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
    };
    SliderTimelineView.prototype._changeTimeline = function(nextIndex) {
        var currentIndex = this.model.getCurrentIndex();
        if (nextIndex === "+") nextIndex = currentIndex + 1;
        else if (nextIndex === "-") nextIndex = currentIndex - 1;
        this.api.dispatchAction({
            type: "timelineChange",
            currentIndex: nextIndex,
            from: this.uid
        });
    };
    SliderTimelineView.prototype._updateTicksStatus = function() {
        var currentIndex = this.model.getCurrentIndex();
        var tickSymbols = this._tickSymbols;
        var tickLabels = this._tickLabels;
        if (tickSymbols) for(var i = 0; i < tickSymbols.length; i++)tickSymbols && tickSymbols[i] && tickSymbols[i].toggleState("progress", i < currentIndex);
        if (tickLabels) for(var i = 0; i < tickLabels.length; i++)tickLabels && tickLabels[i] && tickLabels[i].toggleState("progress", $aba52479ef639cd6$var$labelDataIndexStore(tickLabels[i]).dataIndex <= currentIndex);
    };
    SliderTimelineView.type = "timeline.slider";
    return SliderTimelineView;
}((0, $79b71ced407c5926$export$2e2bcd8739ae039));
function $aba52479ef639cd6$var$createScaleByModel(model, axisType) {
    axisType = axisType || model.get("type");
    if (axisType) switch(axisType){
        // Buildin scale
        case "category":
            return new (0, $6e82606ec775d365$export$2e2bcd8739ae039)({
                ordinalMeta: model.getCategories(),
                extent: [
                    Infinity,
                    -Infinity
                ]
            });
        case "time":
            return new (0, $7729d7ac367e621c$export$2e2bcd8739ae039)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get("useUTC")
            });
        default:
            // default to be value
            return new (0, $dddb89ade16db3d5$export$2e2bcd8739ae039)();
    }
}
function $aba52479ef639cd6$var$getViewRect(model, api) {
    return $93b9bc7f22ac7369$export$4517a5ca639a7293(model.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    }, model.get("padding"));
}
function $aba52479ef639cd6$var$makeControlIcon(timelineModel, objPath, rect, opts) {
    var style = opts.style;
    var icon = $5b455ae6f843ac47$export$274edc73af1ae9c8(timelineModel.get([
        "controlStyle",
        objPath
    ]), opts || {}, new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(rect[0], rect[1], rect[2], rect[3]));
    // TODO createIcon won't use style in opt.
    if (style) icon.setStyle(style);
    return icon;
}
/**
 * Create symbol or update symbol
 * opt: basic position and event handlers
 */ function $aba52479ef639cd6$var$giveSymbol(hostModel, itemStyleModel, group, opt, symbol, callback) {
    var color = itemStyleModel.get("color");
    if (!symbol) {
        var symbolType = hostModel.get("symbol");
        symbol = (0, $5370466dadc978d7$export$af050e04da3a02e8)(symbolType, -1, -1, 2, 2, color);
        symbol.setStyle("strokeNoScale", true);
        group.add(symbol);
        callback && callback.onCreate(symbol);
    } else {
        symbol.setColor(color);
        group.add(symbol); // Group may be new, also need to add.
        callback && callback.onUpdate(symbol);
    }
    // Style
    var itemStyle = itemStyleModel.getItemStyle([
        "color"
    ]);
    symbol.setStyle(itemStyle);
    // Transform and events.
    opt = (0, $7a1bd9c2710fea0d$export$4950aa0f605343fb)({
        rectHover: true,
        z2: 100
    }, opt, true);
    var symbolSize = (0, $5370466dadc978d7$export$a84524f03e8e8dfb)(hostModel.get("symbolSize"));
    opt.scaleX = symbolSize[0] / 2;
    opt.scaleY = symbolSize[1] / 2;
    var symbolOffset = (0, $5370466dadc978d7$export$e3e292895c033f6d)(hostModel.get("symbolOffset"), symbolSize);
    if (symbolOffset) {
        opt.x = (opt.x || 0) + symbolOffset[0];
        opt.y = (opt.y || 0) + symbolOffset[1];
    }
    var symbolRotate = hostModel.get("symbolRotate");
    opt.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
    symbol.attr(opt);
    // FIXME
    // (1) When symbol.style.strokeNoScale is true and updateTransform is not performed,
    // getBoundingRect will return wrong result.
    // (This is supposed to be resolved in zrender, but it is a little difficult to
    // leverage performance and auto updateTransform)
    // (2) All of ancesters of symbol do not scale, so we can just updateTransform symbol.
    symbol.updateTransform();
    return symbol;
}
function $aba52479ef639cd6$var$pointerMoveTo(pointer, progressLine, dataIndex, axis, timelineModel, noAnimation) {
    if (pointer.dragging) return;
    var pointerModel = timelineModel.getModel("checkpointStyle");
    var toCoord = axis.dataToCoord(timelineModel.getData().get("value", dataIndex));
    if (noAnimation || !pointerModel.get("animation", true)) {
        pointer.attr({
            x: toCoord,
            y: 0
        });
        progressLine && progressLine.attr({
            shape: {
                x2: toCoord
            }
        });
    } else {
        var animationCfg = {
            duration: pointerModel.get("animationDuration", true),
            easing: pointerModel.get("animationEasing", true)
        };
        pointer.stopAnimation(null, true);
        pointer.animateTo({
            x: toCoord,
            y: 0
        }, animationCfg);
        progressLine && progressLine.animateTo({
            shape: {
                x2: toCoord
            }
        }, animationCfg);
    }
}
var $aba52479ef639cd6$export$2e2bcd8739ae039 = $aba52479ef639cd6$var$SliderTimelineView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $001a2b3d09da4e02$export$780c34b7cfe44e86(registers) {
    registers.registerAction({
        type: "timelineChange",
        event: "timelineChanged",
        update: "prepareAndUpdate"
    }, function(payload, ecModel, api) {
        var timelineModel = ecModel.getComponent("timeline");
        if (timelineModel && payload.currentIndex != null) {
            timelineModel.setCurrentIndex(payload.currentIndex);
            if (!timelineModel.get("loop", true) && timelineModel.isIndexMax() && timelineModel.getPlayState()) {
                timelineModel.setPlayState(false);
                // The timeline has played to the end, trigger event
                api.dispatchAction({
                    type: "timelinePlayChange",
                    playState: false,
                    from: payload.from
                });
            }
        }
        // Set normalized currentIndex to payload.
        ecModel.resetOption("timeline", {
            replaceMerge: timelineModel.get("replaceMerge", true)
        });
        return (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            currentIndex: timelineModel.option.currentIndex
        }, payload);
    });
    registers.registerAction({
        type: "timelinePlayChange",
        event: "timelinePlayChanged",
        update: "update"
    }, function(payload, ecModel) {
        var timelineModel = ecModel.getComponent("timeline");
        if (timelineModel && payload.playState != null) timelineModel.setPlayState(payload.playState);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

function $a77b6788fc89e6e1$export$2e2bcd8739ae039(option) {
    var timelineOpt = option && option.timeline;
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(timelineOpt)) timelineOpt = timelineOpt ? [
        timelineOpt
    ] : [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(timelineOpt, function(opt) {
        if (!opt) return;
        $a77b6788fc89e6e1$var$compatibleEC2(opt);
    });
}
function $a77b6788fc89e6e1$var$compatibleEC2(opt) {
    var type = opt.type;
    var ec2Types = {
        "number": "value",
        "time": "time"
    };
    // Compatible with ec2
    if (ec2Types[type]) {
        opt.axisType = ec2Types[type];
        delete opt.type;
    }
    $a77b6788fc89e6e1$var$transferItem(opt);
    if ($a77b6788fc89e6e1$var$has(opt, "controlPosition")) {
        var controlStyle = opt.controlStyle || (opt.controlStyle = {});
        if (!$a77b6788fc89e6e1$var$has(controlStyle, "position")) controlStyle.position = opt.controlPosition;
        if (controlStyle.position === "none" && !$a77b6788fc89e6e1$var$has(controlStyle, "show")) {
            controlStyle.show = false;
            delete controlStyle.position;
        }
        delete opt.controlPosition;
    }
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(opt.data || [], function(dataItem) {
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(dataItem) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(dataItem)) {
            if (!$a77b6788fc89e6e1$var$has(dataItem, "value") && $a77b6788fc89e6e1$var$has(dataItem, "name")) // In ec2, using name as value.
            dataItem.value = dataItem.name;
            $a77b6788fc89e6e1$var$transferItem(dataItem);
        }
    });
}
function $a77b6788fc89e6e1$var$transferItem(opt) {
    var itemStyle = opt.itemStyle || (opt.itemStyle = {});
    var itemStyleEmphasis = itemStyle.emphasis || (itemStyle.emphasis = {});
    // Transfer label out
    var label = opt.label || opt.label || {};
    var labelNormal = label.normal || (label.normal = {});
    var excludeLabelAttr = {
        normal: 1,
        emphasis: 1
    };
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(label, function(value, name) {
        if (!excludeLabelAttr[name] && !$a77b6788fc89e6e1$var$has(labelNormal, name)) labelNormal[name] = value;
    });
    if (itemStyleEmphasis.label && !$a77b6788fc89e6e1$var$has(label, "emphasis")) {
        label.emphasis = itemStyleEmphasis.label;
        delete itemStyleEmphasis.label;
    }
}
function $a77b6788fc89e6e1$var$has(obj, attr) {
    return obj.hasOwnProperty(attr);
}


function $d41f79c5664eb934$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $22b93c2a0cce341f$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $aba52479ef639cd6$export$2e2bcd8739ae039));
    registers.registerSubTypeDefaulter("timeline", function() {
        // Only slider now.
        return "slider";
    });
    (0, $001a2b3d09da4e02$export$780c34b7cfe44e86)(registers);
    registers.registerPreprocessor((0, $a77b6788fc89e6e1$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $66707465bee49836$var$TitleModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TitleModel, _super);
    function TitleModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TitleModel.type;
        _this.layoutMode = {
            type: "box",
            ignoreSize: true
        };
        return _this;
    }
    TitleModel.type = "title";
    TitleModel.defaultOption = {
        // zlevel: 0,
        z: 6,
        show: true,
        text: "",
        target: "blank",
        subtext: "",
        subtarget: "blank",
        left: 0,
        top: 0,
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: "#ccc",
        borderWidth: 0,
        padding: 5,
        itemGap: 10,
        textStyle: {
            fontSize: 18,
            fontWeight: "bold",
            color: "#464646"
        },
        subtextStyle: {
            fontSize: 12,
            color: "#6E7079"
        }
    };
    return TitleModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
// View
var $66707465bee49836$var$TitleView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TitleView, _super);
    function TitleView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TitleView.type;
        return _this;
    }
    TitleView.prototype.render = function(titleModel, ecModel, api) {
        this.group.removeAll();
        if (!titleModel.get("show")) return;
        var group = this.group;
        var textStyleModel = titleModel.getModel("textStyle");
        var subtextStyleModel = titleModel.getModel("subtextStyle");
        var textAlign = titleModel.get("textAlign");
        var textVerticalAlign = $7a1bd9c2710fea0d$export$995e01f2f5c9d030(titleModel.get("textBaseline"), titleModel.get("textVerticalAlign"));
        var textEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                text: titleModel.get("text"),
                fill: textStyleModel.getTextColor()
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var textRect = textEl.getBoundingRect();
        var subText = titleModel.get("subtext");
        var subTextEl = new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(subtextStyleModel, {
                text: subText,
                fill: subtextStyleModel.getTextColor(),
                y: textRect.height + titleModel.get("itemGap"),
                verticalAlign: "top"
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var link = titleModel.get("link");
        var sublink = titleModel.get("sublink");
        var triggerEvent = titleModel.get("triggerEvent", true);
        textEl.silent = !link && !triggerEvent;
        subTextEl.silent = !sublink && !triggerEvent;
        if (link) textEl.on("click", function() {
            (0, $c84c9521536c601a$export$13e13f9b96dbe8fa)(link, "_" + titleModel.get("target"));
        });
        if (sublink) subTextEl.on("click", function() {
            (0, $c84c9521536c601a$export$13e13f9b96dbe8fa)(sublink, "_" + titleModel.get("subtarget"));
        });
        (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(textEl).eventData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(subTextEl).eventData = triggerEvent ? {
            componentType: "title",
            componentIndex: titleModel.componentIndex
        } : null;
        group.add(textEl);
        subText && group.add(subTextEl);
        // If no subText, but add subTextEl, there will be an empty line.
        var groupRect = group.getBoundingRect();
        var layoutOption = titleModel.getBoxLayoutParams();
        layoutOption.width = groupRect.width;
        layoutOption.height = groupRect.height;
        var layoutRect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(layoutOption, {
            width: api.getWidth(),
            height: api.getHeight()
        }, titleModel.get("padding"));
        // Adjust text align based on position
        if (!textAlign) {
            // Align left if title is on the left. center and right is same
            textAlign = titleModel.get("left") || titleModel.get("right");
            // @ts-ignore
            if (textAlign === "middle") textAlign = "center";
            // Adjust layout by text align
            if (textAlign === "right") layoutRect.x += layoutRect.width;
            else if (textAlign === "center") layoutRect.x += layoutRect.width / 2;
        }
        if (!textVerticalAlign) {
            textVerticalAlign = titleModel.get("top") || titleModel.get("bottom");
            // @ts-ignore
            if (textVerticalAlign === "center") textVerticalAlign = "middle";
            if (textVerticalAlign === "bottom") layoutRect.y += layoutRect.height;
            else if (textVerticalAlign === "middle") layoutRect.y += layoutRect.height / 2;
            textVerticalAlign = textVerticalAlign || "top";
        }
        group.x = layoutRect.x;
        group.y = layoutRect.y;
        group.markRedraw();
        var alignStyle = {
            align: textAlign,
            verticalAlign: textVerticalAlign
        };
        textEl.setStyle(alignStyle);
        subTextEl.setStyle(alignStyle);
        // Render background
        // Get groupRect again because textAlign has been changed
        groupRect = group.getBoundingRect();
        var padding = layoutRect.margin;
        var style = titleModel.getItemStyle([
            "color",
            "opacity"
        ]);
        style.fill = titleModel.get("backgroundColor");
        var rect = new $419e5ff2f303755e$export$2e2bcd8739ae039({
            shape: {
                x: groupRect.x - padding[3],
                y: groupRect.y - padding[0],
                width: groupRect.width + padding[1] + padding[3],
                height: groupRect.height + padding[0] + padding[2],
                r: titleModel.get("borderRadius")
            },
            style: style,
            subPixelOptimize: true,
            silent: true
        });
        group.add(rect);
    };
    TitleView.type = "title";
    return TitleView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $66707465bee49836$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel($66707465bee49836$var$TitleModel);
    registers.registerComponentView($66707465bee49836$var$TitleView);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $4f28f1fbb9446d57$var$SelectDataZoomModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SelectDataZoomModel, _super);
    function SelectDataZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SelectDataZoomModel.type;
        return _this;
    }
    SelectDataZoomModel.type = "dataZoom.select";
    return SelectDataZoomModel;
}((0, $41d57478d16bff21$export$2e2bcd8739ae039));
var $4f28f1fbb9446d57$export$2e2bcd8739ae039 = $4f28f1fbb9446d57$var$SelectDataZoomModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $ee4d1f83b7568801$var$SelectDataZoomView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SelectDataZoomView, _super);
    function SelectDataZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SelectDataZoomView.type;
        return _this;
    }
    SelectDataZoomView.type = "dataZoom.select";
    return SelectDataZoomView;
}((0, $80d6a03162f25654$export$2e2bcd8739ae039));
var $ee4d1f83b7568801$export$2e2bcd8739ae039 = $ee4d1f83b7568801$var$SelectDataZoomView;



function $738a563bbc36032b$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $4f28f1fbb9446d57$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $ee4d1f83b7568801$export$2e2bcd8739ae039));
    (0, $8904ef10f452e35c$export$2e2bcd8739ae039)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $f3a05ea4ae929f91$var$ToolboxModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ToolboxModel, _super);
    function ToolboxModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ToolboxModel.type;
        return _this;
    }
    ToolboxModel.prototype.optionUpdated = function() {
        _super.prototype.optionUpdated.apply(this, arguments);
        var ecModel = this.ecModel;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.option.feature, function(featureOpt, featureName) {
            var Feature = $974ee7656e10f2d0$export$bba2e7bbd72e62e1(featureName);
            if (Feature) {
                if (Feature.getDefaultOption) Feature.defaultOption = Feature.getDefaultOption(ecModel);
                $7a1bd9c2710fea0d$export$4950aa0f605343fb(featureOpt, Feature.defaultOption);
            }
        });
    };
    ToolboxModel.type = "toolbox";
    ToolboxModel.layoutMode = {
        type: "box",
        ignoreSize: true
    };
    ToolboxModel.defaultOption = {
        show: true,
        z: 6,
        // zlevel: 0,
        orient: "horizontal",
        left: "right",
        top: "top",
        // right
        // bottom
        backgroundColor: "transparent",
        borderColor: "#ccc",
        borderRadius: 0,
        borderWidth: 0,
        padding: 5,
        itemSize: 15,
        itemGap: 8,
        showTitle: true,
        iconStyle: {
            borderColor: "#666",
            color: "none"
        },
        emphasis: {
            iconStyle: {
                borderColor: "#3E98C5"
            }
        },
        // textStyle: {},
        // feature
        tooltip: {
            show: false,
            position: "bottom"
        }
    };
    return ToolboxModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $f3a05ea4ae929f91$export$2e2bcd8739ae039 = $f3a05ea4ae929f91$var$ToolboxModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 












var $e0876f124cc8d5c9$var$ToolboxView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ToolboxView, _super);
    function ToolboxView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToolboxView.prototype.render = function(toolboxModel, ecModel, api, payload) {
        var group = this.group;
        group.removeAll();
        if (!toolboxModel.get("show")) return;
        var itemSize = +toolboxModel.get("itemSize");
        var isVertical = toolboxModel.get("orient") === "vertical";
        var featureOpts = toolboxModel.get("feature") || {};
        var features = this._features || (this._features = {});
        var featureNames = [];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(featureOpts, function(opt, name) {
            featureNames.push(name);
        });
        new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(this._featureNames || [], featureNames).add(processFeature).update(processFeature).remove($7a1bd9c2710fea0d$export$c3095a23b368d1f2(processFeature, null)).execute();
        // Keep for diff.
        this._featureNames = featureNames;
        function processFeature(newIndex, oldIndex) {
            var featureName = featureNames[newIndex];
            var oldName = featureNames[oldIndex];
            var featureOpt = featureOpts[featureName];
            var featureModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(featureOpt, toolboxModel, toolboxModel.ecModel);
            var feature;
            // FIX#11236, merge feature title from MagicType newOption. TODO: consider seriesIndex ?
            if (payload && payload.newTitle != null && payload.featureName === featureName) featureOpt.title = payload.newTitle;
            if (featureName && !oldName) {
                // Create
                if ($e0876f124cc8d5c9$var$isUserFeatureName(featureName)) feature = {
                    onclick: featureModel.option.onclick,
                    featureName: featureName
                };
                else {
                    var Feature = (0, $974ee7656e10f2d0$export$bba2e7bbd72e62e1)(featureName);
                    if (!Feature) return;
                    feature = new Feature();
                }
                features[featureName] = feature;
            } else {
                feature = features[oldName];
                // If feature does not exist.
                if (!feature) return;
            }
            feature.uid = (0, $5370df662b2caf37$export$6d2b3473b0986646)("toolbox-feature");
            feature.model = featureModel;
            feature.ecModel = ecModel;
            feature.api = api;
            var isToolboxFeature = feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539);
            if (!featureName && oldName) {
                isToolboxFeature && feature.dispose && feature.dispose(ecModel, api);
                return;
            }
            if (!featureModel.get("show") || isToolboxFeature && feature.unusable) {
                isToolboxFeature && feature.remove && feature.remove(ecModel, api);
                return;
            }
            createIconPaths(featureModel, feature, featureName);
            featureModel.setIconStatus = function(iconName, status) {
                var option = this.option;
                var iconPaths = this.iconPaths;
                option.iconStatus = option.iconStatus || {};
                option.iconStatus[iconName] = status;
                if (iconPaths[iconName]) (status === "emphasis" ? (0, $2bf82c0980125b62$export$b2d02638cc34c042) : (0, $2bf82c0980125b62$export$11be6f716239ac55))(iconPaths[iconName]);
            };
            if (feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539)) {
                if (feature.render) feature.render(featureModel, ecModel, api, payload);
            }
        }
        function createIconPaths(featureModel, feature, featureName) {
            var iconStyleModel = featureModel.getModel("iconStyle");
            var iconStyleEmphasisModel = featureModel.getModel([
                "emphasis",
                "iconStyle"
            ]);
            // If one feature has multiple icons, they are organized as
            // {
            //     icon: {
            //         foo: '',
            //         bar: ''
            //     },
            //     title: {
            //         foo: '',
            //         bar: ''
            //     }
            // }
            var icons = feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539) && feature.getIcons ? feature.getIcons() : featureModel.get("icon");
            var titles = featureModel.get("title") || {};
            var iconsMap;
            var titlesMap;
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(icons)) {
                iconsMap = {};
                iconsMap[featureName] = icons;
            } else iconsMap = icons;
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(titles)) {
                titlesMap = {};
                titlesMap[featureName] = titles;
            } else titlesMap = titles;
            var iconPaths = featureModel.iconPaths = {};
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(iconsMap, function(iconStr, iconName) {
                var path = $5b455ae6f843ac47$export$274edc73af1ae9c8(iconStr, {}, {
                    x: -itemSize / 2,
                    y: -itemSize / 2,
                    width: itemSize,
                    height: itemSize
                }); // TODO handling image
                path.setStyle(iconStyleModel.getItemStyle());
                var pathEmphasisState = path.ensureState("emphasis");
                pathEmphasisState.style = iconStyleEmphasisModel.getItemStyle();
                // Text position calculation
                // TODO: extract `textStyle` from `iconStyle` and use `createTextStyle`
                var textContent = new (0, $fe885cc21795562b$export$2e2bcd8739ae039)({
                    style: {
                        text: titlesMap[iconName],
                        align: iconStyleEmphasisModel.get("textAlign"),
                        borderRadius: iconStyleEmphasisModel.get("textBorderRadius"),
                        padding: iconStyleEmphasisModel.get("textPadding"),
                        fill: null,
                        font: (0, $6800dfcb6e1e2a44$export$155316a870a9d61e)({
                            fontStyle: iconStyleEmphasisModel.get("textFontStyle"),
                            fontFamily: iconStyleEmphasisModel.get("textFontFamily"),
                            fontSize: iconStyleEmphasisModel.get("textFontSize"),
                            fontWeight: iconStyleEmphasisModel.get("textFontWeight")
                        }, ecModel)
                    },
                    ignore: true
                });
                path.setTextContent(textContent);
                $5b455ae6f843ac47$export$fc6410d97fab306c({
                    el: path,
                    componentModel: toolboxModel,
                    itemName: iconName,
                    formatterParamsExtra: {
                        title: titlesMap[iconName]
                    }
                });
                path.__title = titlesMap[iconName];
                path.on("mouseover", function() {
                    // Should not reuse above hoverStyle, which might be modified.
                    var hoverStyle = iconStyleEmphasisModel.getItemStyle();
                    var defaultTextPosition = isVertical ? toolboxModel.get("right") == null && toolboxModel.get("left") !== "right" ? "right" : "left" : toolboxModel.get("bottom") == null && toolboxModel.get("top") !== "bottom" ? "bottom" : "top";
                    textContent.setStyle({
                        fill: iconStyleEmphasisModel.get("textFill") || hoverStyle.fill || hoverStyle.stroke || "#000",
                        backgroundColor: iconStyleEmphasisModel.get("textBackgroundColor")
                    });
                    path.setTextConfig({
                        position: iconStyleEmphasisModel.get("textPosition") || defaultTextPosition
                    });
                    textContent.ignore = !toolboxModel.get("showTitle");
                    // Use enterEmphasis and leaveEmphasis provide by ec.
                    // There are flags managed by the echarts.
                    api.enterEmphasis(this);
                }).on("mouseout", function() {
                    if (featureModel.get([
                        "iconStatus",
                        iconName
                    ]) !== "emphasis") api.leaveEmphasis(this);
                    textContent.hide();
                });
                (featureModel.get([
                    "iconStatus",
                    iconName
                ]) === "emphasis" ? (0, $2bf82c0980125b62$export$b2d02638cc34c042) : (0, $2bf82c0980125b62$export$11be6f716239ac55))(path);
                group.add(path);
                path.on("click", $7a1bd9c2710fea0d$export$2385a24977818dd0(feature.onclick, feature, ecModel, api, iconName));
                iconPaths[iconName] = path;
            });
        }
        $40fca678c85406ff$export$b3219800bda33a1f(group, toolboxModel, api);
        // Render background after group is layout
        // FIXME
        group.add($40fca678c85406ff$export$fae23936eedfad4f(group.getBoundingRect(), toolboxModel));
        // Adjust icon title positions to avoid them out of screen
        isVertical || group.eachChild(function(icon) {
            var titleText = icon.__title;
            // const hoverStyle = icon.hoverStyle;
            // TODO simplify code?
            var emphasisState = icon.ensureState("emphasis");
            var emphasisTextConfig = emphasisState.textConfig || (emphasisState.textConfig = {});
            var textContent = icon.getTextContent();
            var emphasisTextState = textContent && textContent.ensureState("emphasis");
            // May be background element
            if (emphasisTextState && !$7a1bd9c2710fea0d$export$f6e2535fb5126e54(emphasisTextState) && titleText) {
                var emphasisTextStyle = emphasisTextState.style || (emphasisTextState.style = {});
                var rect = $6c308355c7107803$export$c381147bfed79d9f(titleText, (0, $fe885cc21795562b$export$2e2bcd8739ae039).makeFont(emphasisTextStyle));
                var offsetX = icon.x + group.x;
                var offsetY = icon.y + group.y + itemSize;
                var needPutOnTop = false;
                if (offsetY + rect.height > api.getHeight()) {
                    emphasisTextConfig.position = "top";
                    needPutOnTop = true;
                }
                var topOffset = needPutOnTop ? -5 - rect.height : itemSize + 10;
                if (offsetX + rect.width / 2 > api.getWidth()) {
                    emphasisTextConfig.position = [
                        "100%",
                        topOffset
                    ];
                    emphasisTextStyle.align = "right";
                } else if (offsetX - rect.width / 2 < 0) {
                    emphasisTextConfig.position = [
                        0,
                        topOffset
                    ];
                    emphasisTextStyle.align = "left";
                }
            }
        });
    };
    ToolboxView.prototype.updateView = function(toolboxModel, ecModel, api, payload) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._features, function(feature) {
            feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539) && feature.updateView && feature.updateView(feature.model, ecModel, api, payload);
        });
    };
    // updateLayout(toolboxModel, ecModel, api, payload) {
    //     zrUtil.each(this._features, function (feature) {
    //         feature.updateLayout && feature.updateLayout(feature.model, ecModel, api, payload);
    //     });
    // },
    ToolboxView.prototype.remove = function(ecModel, api) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._features, function(feature) {
            feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539) && feature.remove && feature.remove(ecModel, api);
        });
        this.group.removeAll();
    };
    ToolboxView.prototype.dispose = function(ecModel, api) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this._features, function(feature) {
            feature instanceof (0, $974ee7656e10f2d0$export$1426bfb1b0bcf539) && feature.dispose && feature.dispose(ecModel, api);
        });
    };
    ToolboxView.type = "toolbox";
    return ToolboxView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
function $e0876f124cc8d5c9$var$isUserFeatureName(featureName) {
    return featureName.indexOf("my") === 0;
}
var $e0876f124cc8d5c9$export$2e2bcd8739ae039 = $e0876f124cc8d5c9$var$ToolboxView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/* global window, document */ var $1abd70fc7852729e$var$SaveAsImage = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(SaveAsImage, _super);
    function SaveAsImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SaveAsImage.prototype.onclick = function(ecModel, api) {
        var model = this.model;
        var title = model.get("name") || ecModel.get("title.0.text") || "echarts";
        var isSvg = api.getZr().painter.getType() === "svg";
        var type = isSvg ? "svg" : model.get("type", true) || "png";
        var url = api.getConnectedDataURL({
            type: type,
            backgroundColor: model.get("backgroundColor", true) || ecModel.get("backgroundColor") || "#fff",
            connectedBackgroundColor: model.get("connectedBackgroundColor"),
            excludeComponents: model.get("excludeComponents"),
            pixelRatio: model.get("pixelRatio")
        });
        var browser = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).browser;
        // Chrome, Firefox, New Edge
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(MouseEvent) && (browser.newEdge || !browser.ie && !browser.edge)) {
            var $a = document.createElement("a");
            $a.download = title + "." + type;
            $a.target = "_blank";
            $a.href = url;
            var evt = new MouseEvent("click", {
                // some micro front-end framework， window maybe is a Proxy
                view: document.defaultView,
                bubbles: true,
                cancelable: false
            });
            $a.dispatchEvent(evt);
        } else // @ts-ignore
        if (window.navigator.msSaveOrOpenBlob || isSvg) {
            var parts = url.split(",");
            // data:[<mime type>][;charset=<charset>][;base64],<encoded data>
            var base64Encoded = parts[0].indexOf("base64") > -1;
            var bstr = isSvg ? decodeURIComponent(parts[1]) : parts[1];
            // only `atob` when the data uri is encoded with base64
            // otherwise, like `svg` data uri exported by zrender,
            // there will be an error, for it's not encoded with base64.
            // (just a url-encoded string through `encodeURIComponent`)
            base64Encoded && (bstr = window.atob(bstr));
            var filename = title + "." + type;
            // @ts-ignore
            if (window.navigator.msSaveOrOpenBlob) {
                var n = bstr.length;
                var u8arr = new Uint8Array(n);
                while(n--)u8arr[n] = bstr.charCodeAt(n);
                var blob = new Blob([
                    u8arr
                ]); // @ts-ignore
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                var frame = document.createElement("iframe");
                document.body.appendChild(frame);
                var cw = frame.contentWindow;
                var doc = cw.document;
                doc.open("image/svg+xml", "replace");
                doc.write(bstr);
                doc.close();
                cw.focus();
                doc.execCommand("SaveAs", true, filename);
                document.body.removeChild(frame);
            }
        } else {
            var lang = model.get("lang");
            var html = '<body style="margin:0;"><img src="' + url + '" style="max-width:100%;" title="' + (lang && lang[0] || "") + '" />' + "</body>";
            var tab = window.open();
            tab.document.write(html);
            tab.document.title = title;
        }
    };
    SaveAsImage.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            icon: "M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0",
            title: ecModel.getLocaleModel().get([
                "toolbox",
                "saveAsImage",
                "title"
            ]),
            type: "png",
            // Default use option.backgroundColor
            // backgroundColor: '#fff',
            connectedBackgroundColor: "#fff",
            name: "",
            excludeComponents: [
                "toolbox"
            ],
            // use current pixel ratio of device by default
            // pixelRatio: 1,
            lang: ecModel.getLocaleModel().get([
                "toolbox",
                "saveAsImage",
                "lang"
            ])
        };
        return defaultOption;
    };
    return SaveAsImage;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
var $1abd70fc7852729e$export$2e2bcd8739ae039 = $1abd70fc7852729e$var$SaveAsImage;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $1a3c941566c70505$var$INNER_STACK_KEYWORD = "__ec_magicType_stack__";
var $1a3c941566c70505$var$ICON_TYPES = [
    "line",
    "bar",
    "stack"
];
// stack and tiled appears in pair for the title
var $1a3c941566c70505$var$TITLE_TYPES = [
    "line",
    "bar",
    "stack",
    "tiled"
];
var $1a3c941566c70505$var$radioTypes = [
    [
        "line",
        "bar"
    ],
    [
        "stack"
    ]
];
var $1a3c941566c70505$var$MagicType = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(MagicType, _super);
    function MagicType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MagicType.prototype.getIcons = function() {
        var model = this.model;
        var availableIcons = model.get("icon");
        var icons = {};
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(model.get("type"), function(type) {
            if (availableIcons[type]) icons[type] = availableIcons[type];
        });
        return icons;
    };
    MagicType.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            type: [],
            // Icon group
            icon: {
                line: "M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4",
                bar: "M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7",
                // eslint-disable-next-line
                stack: "M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z" // jshint ignore:line
            },
            // `line`, `bar`, `stack`, `tiled`
            title: ecModel.getLocaleModel().get([
                "toolbox",
                "magicType",
                "title"
            ]),
            option: {},
            seriesIndex: {}
        };
        return defaultOption;
    };
    MagicType.prototype.onclick = function(ecModel, api, type) {
        var model = this.model;
        var seriesIndex = model.get([
            "seriesIndex",
            type
        ]);
        // Not supported magicType
        if (!$1a3c941566c70505$var$seriesOptGenreator[type]) return;
        var newOption = {
            series: []
        };
        var generateNewSeriesTypes = function(seriesModel) {
            var seriesType = seriesModel.subType;
            var seriesId = seriesModel.id;
            var newSeriesOpt = $1a3c941566c70505$var$seriesOptGenreator[type](seriesType, seriesId, seriesModel, model);
            if (newSeriesOpt) {
                // PENDING If merge original option?
                $7a1bd9c2710fea0d$export$ebe90cb607ad99e(newSeriesOpt, seriesModel.option);
                newOption.series.push(newSeriesOpt);
            }
            // Modify boundaryGap
            var coordSys = seriesModel.coordinateSystem;
            if (coordSys && coordSys.type === "cartesian2d" && (type === "line" || type === "bar")) {
                var categoryAxis = coordSys.getAxesByScale("ordinal")[0];
                if (categoryAxis) {
                    var axisDim = categoryAxis.dim;
                    var axisType = axisDim + "Axis";
                    var axisModel = seriesModel.getReferringComponents(axisType, (0, $76d619f648247e6d$export$f076738ec84e693c)).models[0];
                    var axisIndex = axisModel.componentIndex;
                    newOption[axisType] = newOption[axisType] || [];
                    for(var i = 0; i <= axisIndex; i++)newOption[axisType][axisIndex] = newOption[axisType][axisIndex] || {};
                    newOption[axisType][axisIndex].boundaryGap = type === "bar";
                }
            }
        };
        $7a1bd9c2710fea0d$export$79b2f7037acddd43($1a3c941566c70505$var$radioTypes, function(radio) {
            if ($7a1bd9c2710fea0d$export$305f7d4e9d4624f2(radio, type) >= 0) $7a1bd9c2710fea0d$export$79b2f7037acddd43(radio, function(item) {
                model.setIconStatus(item, "normal");
            });
        });
        model.setIconStatus(type, "emphasis");
        ecModel.eachComponent({
            mainType: "series",
            query: seriesIndex == null ? null : {
                seriesIndex: seriesIndex
            }
        }, generateNewSeriesTypes);
        var newTitle;
        var currentType = type;
        // Change title of stack
        if (type === "stack") {
            // use titles in model instead of ecModel
            // as stack and tiled appears in pair, just flip them
            // no need of checking stack state
            newTitle = $7a1bd9c2710fea0d$export$4950aa0f605343fb({
                stack: model.option.title.tiled,
                tiled: model.option.title.stack
            }, model.option.title);
            if (model.get([
                "iconStatus",
                type
            ]) !== "emphasis") currentType = "tiled";
        }
        api.dispatchAction({
            type: "changeMagicType",
            currentType: currentType,
            newOption: newOption,
            newTitle: newTitle,
            featureName: "magicType"
        });
    };
    return MagicType;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
var $1a3c941566c70505$var$seriesOptGenreator = {
    "line": function(seriesType, seriesId, seriesModel, model) {
        if (seriesType === "bar") return $7a1bd9c2710fea0d$export$4950aa0f605343fb({
            id: seriesId,
            type: "line",
            // Preserve data related option
            data: seriesModel.get("data"),
            stack: seriesModel.get("stack"),
            markPoint: seriesModel.get("markPoint"),
            markLine: seriesModel.get("markLine")
        }, model.get([
            "option",
            "line"
        ]) || {}, true);
    },
    "bar": function(seriesType, seriesId, seriesModel, model) {
        if (seriesType === "line") return $7a1bd9c2710fea0d$export$4950aa0f605343fb({
            id: seriesId,
            type: "bar",
            // Preserve data related option
            data: seriesModel.get("data"),
            stack: seriesModel.get("stack"),
            markPoint: seriesModel.get("markPoint"),
            markLine: seriesModel.get("markLine")
        }, model.get([
            "option",
            "bar"
        ]) || {}, true);
    },
    "stack": function(seriesType, seriesId, seriesModel, model) {
        var isStack = seriesModel.get("stack") === $1a3c941566c70505$var$INNER_STACK_KEYWORD;
        if (seriesType === "line" || seriesType === "bar") {
            model.setIconStatus("stack", isStack ? "normal" : "emphasis");
            return $7a1bd9c2710fea0d$export$4950aa0f605343fb({
                id: seriesId,
                stack: isStack ? "" : $1a3c941566c70505$var$INNER_STACK_KEYWORD
            }, model.get([
                "option",
                "stack"
            ]) || {}, true);
        }
    }
};
// TODO: SELF REGISTERED.
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: "changeMagicType",
    event: "magicTypeChanged",
    update: "prepareAndUpdate"
}, function(payload, ecModel) {
    ecModel.mergeOption(payload.newOption);
});
var $1a3c941566c70505$export$2e2bcd8739ae039 = $1a3c941566c70505$var$MagicType;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/* global document */ var $c28a86c6c47fb2f6$var$BLOCK_SPLITER = new Array(60).join("-");
var $c28a86c6c47fb2f6$var$ITEM_SPLITER = "	";
/**
 * Group series into two types
 *  1. on category axis, like line, bar
 *  2. others, like scatter, pie
 */ function $c28a86c6c47fb2f6$var$groupSeries(ecModel) {
    var seriesGroupByCategoryAxis = {};
    var otherSeries = [];
    var meta = [];
    ecModel.eachRawSeries(function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && (coordSys.type === "cartesian2d" || coordSys.type === "polar")) {
            // TODO: TYPE Consider polar? Include polar may increase unecessary bundle size.
            var baseAxis = coordSys.getBaseAxis();
            if (baseAxis.type === "category") {
                var key = baseAxis.dim + "_" + baseAxis.index;
                if (!seriesGroupByCategoryAxis[key]) {
                    seriesGroupByCategoryAxis[key] = {
                        categoryAxis: baseAxis,
                        valueAxis: coordSys.getOtherAxis(baseAxis),
                        series: []
                    };
                    meta.push({
                        axisDim: baseAxis.dim,
                        axisIndex: baseAxis.index
                    });
                }
                seriesGroupByCategoryAxis[key].series.push(seriesModel);
            } else otherSeries.push(seriesModel);
        } else otherSeries.push(seriesModel);
    });
    return {
        seriesGroupByCategoryAxis: seriesGroupByCategoryAxis,
        other: otherSeries,
        meta: meta
    };
}
/**
 * Assemble content of series on cateogory axis
 * @inner
 */ function $c28a86c6c47fb2f6$var$assembleSeriesWithCategoryAxis(groups) {
    var tables = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(groups, function(group, key) {
        var categoryAxis = group.categoryAxis;
        var valueAxis = group.valueAxis;
        var valueAxisDim = valueAxis.dim;
        var headers = [
            " "
        ].concat($7a1bd9c2710fea0d$export$871de8747c9eaa88(group.series, function(series) {
            return series.name;
        }));
        // @ts-ignore TODO Polar
        var columns = [
            categoryAxis.model.getCategories()
        ];
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(group.series, function(series) {
            var rawData = series.getRawData();
            columns.push(series.getRawData().mapArray(rawData.mapDimension(valueAxisDim), function(val) {
                return val;
            }));
        });
        // Assemble table content
        var lines = [
            headers.join($c28a86c6c47fb2f6$var$ITEM_SPLITER)
        ];
        for(var i = 0; i < columns[0].length; i++){
            var items = [];
            for(var j = 0; j < columns.length; j++)items.push(columns[j][i]);
            lines.push(items.join($c28a86c6c47fb2f6$var$ITEM_SPLITER));
        }
        tables.push(lines.join("\n"));
    });
    return tables.join("\n\n" + $c28a86c6c47fb2f6$var$BLOCK_SPLITER + "\n\n");
}
/**
 * Assemble content of other series
 */ function $c28a86c6c47fb2f6$var$assembleOtherSeries(series) {
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(series, function(series) {
        var data = series.getRawData();
        var lines = [
            series.name
        ];
        var vals = [];
        data.each(data.dimensions, function() {
            var argLen = arguments.length;
            var dataIndex = arguments[argLen - 1];
            var name = data.getName(dataIndex);
            for(var i = 0; i < argLen - 1; i++)vals[i] = arguments[i];
            lines.push((name ? name + $c28a86c6c47fb2f6$var$ITEM_SPLITER : "") + vals.join($c28a86c6c47fb2f6$var$ITEM_SPLITER));
        });
        return lines.join("\n");
    }).join("\n\n" + $c28a86c6c47fb2f6$var$BLOCK_SPLITER + "\n\n");
}
function $c28a86c6c47fb2f6$var$getContentFromModel(ecModel) {
    var result = $c28a86c6c47fb2f6$var$groupSeries(ecModel);
    return {
        value: $7a1bd9c2710fea0d$export$3dea766d36a8935f([
            $c28a86c6c47fb2f6$var$assembleSeriesWithCategoryAxis(result.seriesGroupByCategoryAxis),
            $c28a86c6c47fb2f6$var$assembleOtherSeries(result.other)
        ], function(str) {
            return !!str.replace(/[\n\t\s]/g, "");
        }).join("\n\n" + $c28a86c6c47fb2f6$var$BLOCK_SPLITER + "\n\n"),
        meta: result.meta
    };
}
function $c28a86c6c47fb2f6$var$trim(str) {
    return str.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
/**
 * If a block is tsv format
 */ function $c28a86c6c47fb2f6$var$isTSVFormat(block) {
    // Simple method to find out if a block is tsv format
    var firstLine = block.slice(0, block.indexOf("\n"));
    if (firstLine.indexOf($c28a86c6c47fb2f6$var$ITEM_SPLITER) >= 0) return true;
}
var $c28a86c6c47fb2f6$var$itemSplitRegex = new RegExp("[" + $c28a86c6c47fb2f6$var$ITEM_SPLITER + "]+", "g");
/**
 * @param {string} tsv
 * @return {Object}
 */ function $c28a86c6c47fb2f6$var$parseTSVContents(tsv) {
    var tsvLines = tsv.split(/\n+/g);
    var headers = $c28a86c6c47fb2f6$var$trim(tsvLines.shift()).split($c28a86c6c47fb2f6$var$itemSplitRegex);
    var categories = [];
    var series = $7a1bd9c2710fea0d$export$871de8747c9eaa88(headers, function(header) {
        return {
            name: header,
            data: []
        };
    });
    for(var i = 0; i < tsvLines.length; i++){
        var items = $c28a86c6c47fb2f6$var$trim(tsvLines[i]).split($c28a86c6c47fb2f6$var$itemSplitRegex);
        categories.push(items.shift());
        for(var j = 0; j < items.length; j++)series[j] && (series[j].data[i] = items[j]);
    }
    return {
        series: series,
        categories: categories
    };
}
function $c28a86c6c47fb2f6$var$parseListContents(str) {
    var lines = str.split(/\n+/g);
    var seriesName = $c28a86c6c47fb2f6$var$trim(lines.shift());
    var data = [];
    for(var i = 0; i < lines.length; i++){
        // if line is empty, ignore it.
        // there is a case that a user forgot to delete `\n`.
        var line = $c28a86c6c47fb2f6$var$trim(lines[i]);
        if (!line) continue;
        var items = line.split($c28a86c6c47fb2f6$var$itemSplitRegex);
        var name_1 = "";
        var value = void 0;
        var hasName = false;
        if (isNaN(items[0])) {
            // First item is name
            hasName = true;
            name_1 = items[0];
            items = items.slice(1);
            data[i] = {
                name: name_1,
                value: []
            };
            value = data[i].value;
        } else value = data[i] = [];
        for(var j = 0; j < items.length; j++)value.push(+items[j]);
        if (value.length === 1) hasName ? data[i].value = value[0] : data[i] = value[0];
    }
    return {
        name: seriesName,
        data: data
    };
}
function $c28a86c6c47fb2f6$var$parseContents(str, blockMetaList) {
    var blocks = str.split(new RegExp("\n*" + $c28a86c6c47fb2f6$var$BLOCK_SPLITER + "\n*", "g"));
    var newOption = {
        series: []
    };
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(blocks, function(block, idx) {
        if ($c28a86c6c47fb2f6$var$isTSVFormat(block)) {
            var result = $c28a86c6c47fb2f6$var$parseTSVContents(block);
            var blockMeta = blockMetaList[idx];
            var axisKey = blockMeta.axisDim + "Axis";
            if (blockMeta) {
                newOption[axisKey] = newOption[axisKey] || [];
                newOption[axisKey][blockMeta.axisIndex] = {
                    data: result.categories
                };
                newOption.series = newOption.series.concat(result.series);
            }
        } else {
            var result = $c28a86c6c47fb2f6$var$parseListContents(block);
            newOption.series.push(result);
        }
    });
    return newOption;
}
var $c28a86c6c47fb2f6$var$DataView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(DataView, _super);
    function DataView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataView.prototype.onclick = function(ecModel, api) {
        // FIXME: better way?
        setTimeout(function() {
            api.dispatchAction({
                type: "hideTip"
            });
        });
        var container = api.getDom();
        var model = this.model;
        if (this._dom) container.removeChild(this._dom);
        var root = document.createElement("div");
        // use padding to avoid 5px whitespace
        root.style.cssText = "position:absolute;top:0;bottom:0;left:0;right:0;padding:5px";
        root.style.backgroundColor = model.get("backgroundColor") || "#fff";
        // Create elements
        var header = document.createElement("h4");
        var lang = model.get("lang") || [];
        header.innerHTML = lang[0] || model.get("title");
        header.style.cssText = "margin:10px 20px";
        header.style.color = model.get("textColor");
        var viewMain = document.createElement("div");
        var textarea = document.createElement("textarea");
        viewMain.style.cssText = "overflow:auto";
        var optionToContent = model.get("optionToContent");
        var contentToOption = model.get("contentToOption");
        var result = $c28a86c6c47fb2f6$var$getContentFromModel(ecModel);
        if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(optionToContent)) {
            var htmlOrDom = optionToContent(api.getOption());
            if ($7a1bd9c2710fea0d$export$844ec244b1367d54(htmlOrDom)) viewMain.innerHTML = htmlOrDom;
            else if ($7a1bd9c2710fea0d$export$9f57505b7bd8dae(htmlOrDom)) viewMain.appendChild(htmlOrDom);
        } else {
            // Use default textarea
            textarea.readOnly = model.get("readOnly");
            var style = textarea.style;
            // eslint-disable-next-line max-len
            style.cssText = "display:block;width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;resize:none;box-sizing:border-box;outline:none";
            style.color = model.get("textColor");
            style.borderColor = model.get("textareaBorderColor");
            style.backgroundColor = model.get("textareaColor");
            textarea.value = result.value;
            viewMain.appendChild(textarea);
        }
        var blockMetaList = result.meta;
        var buttonContainer = document.createElement("div");
        buttonContainer.style.cssText = "position:absolute;bottom:5px;left:0;right:0";
        // eslint-disable-next-line max-len
        var buttonStyle = "float:right;margin-right:20px;border:none;cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px";
        var closeButton = document.createElement("div");
        var refreshButton = document.createElement("div");
        buttonStyle += ";background-color:" + model.get("buttonColor");
        buttonStyle += ";color:" + model.get("buttonTextColor");
        var self = this;
        function close() {
            container.removeChild(root);
            self._dom = null;
        }
        (0, $b3864a78637ff9ed$export$3f65cefe8380dbea)(closeButton, "click", close);
        (0, $b3864a78637ff9ed$export$3f65cefe8380dbea)(refreshButton, "click", function() {
            if (contentToOption == null && optionToContent != null || contentToOption != null && optionToContent == null) {
                close();
                return;
            }
            var newOption;
            try {
                if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(contentToOption)) newOption = contentToOption(viewMain, api.getOption());
                else newOption = $c28a86c6c47fb2f6$var$parseContents(textarea.value, blockMetaList);
            } catch (e) {
                close();
                throw new Error("Data view format error " + e);
            }
            if (newOption) api.dispatchAction({
                type: "changeDataView",
                newOption: newOption
            });
            close();
        });
        closeButton.innerHTML = lang[1];
        refreshButton.innerHTML = lang[2];
        refreshButton.style.cssText = closeButton.style.cssText = buttonStyle;
        !model.get("readOnly") && buttonContainer.appendChild(refreshButton);
        buttonContainer.appendChild(closeButton);
        root.appendChild(header);
        root.appendChild(viewMain);
        root.appendChild(buttonContainer);
        viewMain.style.height = container.clientHeight - 80 + "px";
        container.appendChild(root);
        this._dom = root;
    };
    DataView.prototype.remove = function(ecModel, api) {
        this._dom && api.getDom().removeChild(this._dom);
    };
    DataView.prototype.dispose = function(ecModel, api) {
        this.remove(ecModel, api);
    };
    DataView.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            readOnly: false,
            optionToContent: null,
            contentToOption: null,
            // eslint-disable-next-line
            icon: "M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28",
            title: ecModel.getLocaleModel().get([
                "toolbox",
                "dataView",
                "title"
            ]),
            lang: ecModel.getLocaleModel().get([
                "toolbox",
                "dataView",
                "lang"
            ]),
            backgroundColor: "#fff",
            textColor: "#000",
            textareaColor: "#fff",
            textareaBorderColor: "#333",
            buttonColor: "#c23531",
            buttonTextColor: "#fff"
        };
        return defaultOption;
    };
    return DataView;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
/**
 * @inner
 */ function $c28a86c6c47fb2f6$var$tryMergeDataOption(newData, originalData) {
    return $7a1bd9c2710fea0d$export$871de8747c9eaa88(newData, function(newVal, idx) {
        var original = originalData && originalData[idx];
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(original) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(original)) {
            var newValIsObject = $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(newVal) && !$7a1bd9c2710fea0d$export$43bee75e5e14138e(newVal);
            if (!newValIsObject) newVal = {
                value: newVal
            };
            // original data has name but new data has no name
            var shouldDeleteName = original.name != null && newVal.name == null;
            // Original data has option
            newVal = $7a1bd9c2710fea0d$export$ebe90cb607ad99e(newVal, original);
            shouldDeleteName && delete newVal.name;
            return newVal;
        } else return newVal;
    });
}
// TODO: SELF REGISTERED.
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: "changeDataView",
    event: "dataViewChanged",
    update: "prepareAndUpdate"
}, function(payload, ecModel) {
    var newSeriesOptList = [];
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(payload.newOption.series, function(seriesOpt) {
        var seriesModel = ecModel.getSeriesByName(seriesOpt.name)[0];
        if (!seriesModel) // New created series
        // Geuss the series type
        newSeriesOptList.push($7a1bd9c2710fea0d$export$8b58be045bf06082({
            // Default is scatter
            type: "scatter"
        }, seriesOpt));
        else {
            var originalData = seriesModel.get("data");
            newSeriesOptList.push({
                name: seriesOpt.name,
                data: $c28a86c6c47fb2f6$var$tryMergeDataOption(seriesOpt.data, originalData)
            });
        }
    });
    ecModel.mergeOption($7a1bd9c2710fea0d$export$ebe90cb607ad99e({
        series: newSeriesOptList
    }, payload.newOption));
});
var $c28a86c6c47fb2f6$export$2e2bcd8739ae039 = $c28a86c6c47fb2f6$var$DataView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $61ea33782638ccd3$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $61ea33782638ccd3$var$inner = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $61ea33782638ccd3$export$4cbf152802aa238(ecModel, newSnapshot) {
    var storedSnapshots = $61ea33782638ccd3$var$getStoreSnapshots(ecModel);
    // If previous dataZoom can not be found,
    // complete an range with current range.
    $61ea33782638ccd3$var$each(newSnapshot, function(batchItem, dataZoomId) {
        var i = storedSnapshots.length - 1;
        for(; i >= 0; i--){
            var snapshot = storedSnapshots[i];
            if (snapshot[dataZoomId]) break;
        }
        if (i < 0) {
            // No origin range set, create one by current range.
            var dataZoomModel = ecModel.queryComponents({
                mainType: "dataZoom",
                subType: "select",
                id: dataZoomId
            })[0];
            if (dataZoomModel) {
                var percentRange = dataZoomModel.getPercentRange();
                storedSnapshots[0][dataZoomId] = {
                    dataZoomId: dataZoomId,
                    start: percentRange[0],
                    end: percentRange[1]
                };
            }
        }
    });
    storedSnapshots.push(newSnapshot);
}
function $61ea33782638ccd3$export$3e41007ebfff0e64(ecModel) {
    var storedSnapshots = $61ea33782638ccd3$var$getStoreSnapshots(ecModel);
    var head = storedSnapshots[storedSnapshots.length - 1];
    storedSnapshots.length > 1 && storedSnapshots.pop();
    // Find top for all dataZoom.
    var snapshot = {};
    $61ea33782638ccd3$var$each(head, function(batchItem, dataZoomId) {
        for(var i = storedSnapshots.length - 1; i >= 0; i--){
            batchItem = storedSnapshots[i][dataZoomId];
            if (batchItem) {
                snapshot[dataZoomId] = batchItem;
                break;
            }
        }
    });
    return snapshot;
}
function $61ea33782638ccd3$export$42ffd38884aecdac(ecModel) {
    $61ea33782638ccd3$var$inner(ecModel).snapshots = null;
}
function $61ea33782638ccd3$export$85b9a36db797e02b(ecModel) {
    return $61ea33782638ccd3$var$getStoreSnapshots(ecModel).length;
}
/**
 * History length of each dataZoom may be different.
 * this._history[0] is used to store origin range.
 */ function $61ea33782638ccd3$var$getStoreSnapshots(ecModel) {
    var store = $61ea33782638ccd3$var$inner(ecModel);
    if (!store.snapshots) store.snapshots = [
        {}
    ];
    return store.snapshots;
}



var $5719d35bf0243166$var$RestoreOption = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(RestoreOption, _super);
    function RestoreOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RestoreOption.prototype.onclick = function(ecModel, api) {
        $61ea33782638ccd3$export$42ffd38884aecdac(ecModel);
        api.dispatchAction({
            type: "restore",
            from: this.uid
        });
    };
    RestoreOption.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            // eslint-disable-next-line
            icon: "M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5",
            title: ecModel.getLocaleModel().get([
                "toolbox",
                "restore",
                "title"
            ])
        };
        return defaultOption;
    };
    return RestoreOption;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
// TODO: SELF REGISTERED.
$4d59907f44a2d0ad$export$408c24786cd729c6({
    type: "restore",
    event: "restore",
    update: "prepareAndUpdate"
}, function(payload, ecModel) {
    ecModel.resetOption("recreate");
});
var $5719d35bf0243166$export$2e2bcd8739ae039 = $5719d35bf0243166$var$RestoreOption;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $d48e21e24ee5fc18$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $d48e21e24ee5fc18$var$DATA_ZOOM_ID_BASE = (0, $76d619f648247e6d$export$1753133c42e665e8)("toolbox-dataZoom_");
var $d48e21e24ee5fc18$var$ICON_TYPES = [
    "zoom",
    "back"
];
var $d48e21e24ee5fc18$var$DataZoomFeature = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(DataZoomFeature, _super);
    function DataZoomFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataZoomFeature.prototype.render = function(featureModel, ecModel, api, payload) {
        if (!this._brushController) {
            this._brushController = new (0, $91342d1cfa622c5a$export$2e2bcd8739ae039)(api.getZr());
            this._brushController.on("brush", $7a1bd9c2710fea0d$export$2385a24977818dd0(this._onBrush, this)).mount();
        }
        $d48e21e24ee5fc18$var$updateZoomBtnStatus(featureModel, ecModel, this, payload, api);
        $d48e21e24ee5fc18$var$updateBackBtnStatus(featureModel, ecModel);
    };
    DataZoomFeature.prototype.onclick = function(ecModel, api, type) {
        $d48e21e24ee5fc18$var$handlers[type].call(this);
    };
    DataZoomFeature.prototype.remove = function(ecModel, api) {
        this._brushController && this._brushController.unmount();
    };
    DataZoomFeature.prototype.dispose = function(ecModel, api) {
        this._brushController && this._brushController.dispose();
    };
    DataZoomFeature.prototype._onBrush = function(eventParam) {
        var areas = eventParam.areas;
        if (!eventParam.isEnd || !areas.length) return;
        var snapshot = {};
        var ecModel = this.ecModel;
        this._brushController.updateCovers([]); // remove cover
        var brushTargetManager = new (0, $6213fed8aa63fab1$export$2e2bcd8739ae039)($d48e21e24ee5fc18$var$makeAxisFinder(this.model), ecModel, {
            include: [
                "grid"
            ]
        });
        brushTargetManager.matchOutputRanges(areas, ecModel, function(area, coordRange, coordSys) {
            if (coordSys.type !== "cartesian2d") return;
            var brushType = area.brushType;
            if (brushType === "rect") {
                setBatch("x", coordSys, coordRange[0]);
                setBatch("y", coordSys, coordRange[1]);
            } else setBatch({
                lineX: "x",
                lineY: "y"
            }[brushType], coordSys, coordRange);
        });
        $61ea33782638ccd3$export$4cbf152802aa238(ecModel, snapshot);
        this._dispatchZoomAction(snapshot);
        function setBatch(dimName, coordSys, minMax) {
            var axis = coordSys.getAxis(dimName);
            var axisModel = axis.model;
            var dataZoomModel = findDataZoom(dimName, axisModel, ecModel);
            // Restrict range.
            var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy(axisModel).getMinMaxSpan();
            if (minMaxSpan.minValueSpan != null || minMaxSpan.maxValueSpan != null) minMax = (0, $00a8003b34293330$export$2e2bcd8739ae039)(0, minMax.slice(), axis.scale.getExtent(), 0, minMaxSpan.minValueSpan, minMaxSpan.maxValueSpan);
            dataZoomModel && (snapshot[dataZoomModel.id] = {
                dataZoomId: dataZoomModel.id,
                startValue: minMax[0],
                endValue: minMax[1]
            });
        }
        function findDataZoom(dimName, axisModel, ecModel) {
            var found;
            ecModel.eachComponent({
                mainType: "dataZoom",
                subType: "select"
            }, function(dzModel) {
                var has = dzModel.getAxisModel(dimName, axisModel.componentIndex);
                has && (found = dzModel);
            });
            return found;
        }
    };
    DataZoomFeature.prototype._dispatchZoomAction = function(snapshot) {
        var batch = [];
        // Convert from hash map to array.
        $d48e21e24ee5fc18$var$each(snapshot, function(batchItem, dataZoomId) {
            batch.push($7a1bd9c2710fea0d$export$9cd59f9826255e47(batchItem));
        });
        batch.length && this.api.dispatchAction({
            type: "dataZoom",
            from: this.uid,
            batch: batch
        });
    };
    DataZoomFeature.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            filterMode: "filter",
            // Icon group
            icon: {
                zoom: "M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1",
                back: "M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26"
            },
            // `zoom`, `back`
            title: ecModel.getLocaleModel().get([
                "toolbox",
                "dataZoom",
                "title"
            ]),
            brushStyle: {
                borderWidth: 0,
                color: "rgba(210,219,238,0.2)"
            }
        };
        return defaultOption;
    };
    return DataZoomFeature;
}((0, $974ee7656e10f2d0$export$1426bfb1b0bcf539));
var $d48e21e24ee5fc18$var$handlers = {
    zoom: function() {
        var nextActive = !this._isZoomActive;
        this.api.dispatchAction({
            type: "takeGlobalCursor",
            key: "dataZoomSelect",
            dataZoomSelectActive: nextActive
        });
    },
    back: function() {
        this._dispatchZoomAction($61ea33782638ccd3$export$3e41007ebfff0e64(this.ecModel));
    }
};
function $d48e21e24ee5fc18$var$makeAxisFinder(dzFeatureModel) {
    var setting = {
        xAxisIndex: dzFeatureModel.get("xAxisIndex", true),
        yAxisIndex: dzFeatureModel.get("yAxisIndex", true),
        xAxisId: dzFeatureModel.get("xAxisId", true),
        yAxisId: dzFeatureModel.get("yAxisId", true)
    };
    // If both `xAxisIndex` `xAxisId` not set, it means 'all'.
    // If both `yAxisIndex` `yAxisId` not set, it means 'all'.
    // Some old cases set like this below to close yAxis control but leave xAxis control:
    // `{ feature: { dataZoom: { yAxisIndex: false } }`.
    if (setting.xAxisIndex == null && setting.xAxisId == null) setting.xAxisIndex = "all";
    if (setting.yAxisIndex == null && setting.yAxisId == null) setting.yAxisIndex = "all";
    return setting;
}
function $d48e21e24ee5fc18$var$updateBackBtnStatus(featureModel, ecModel) {
    featureModel.setIconStatus("back", $61ea33782638ccd3$export$85b9a36db797e02b(ecModel) > 1 ? "emphasis" : "normal");
}
function $d48e21e24ee5fc18$var$updateZoomBtnStatus(featureModel, ecModel, view, payload, api) {
    var zoomActive = view._isZoomActive;
    if (payload && payload.type === "takeGlobalCursor") zoomActive = payload.key === "dataZoomSelect" ? payload.dataZoomSelectActive : false;
    view._isZoomActive = zoomActive;
    featureModel.setIconStatus("zoom", zoomActive ? "emphasis" : "normal");
    var brushTargetManager = new (0, $6213fed8aa63fab1$export$2e2bcd8739ae039)($d48e21e24ee5fc18$var$makeAxisFinder(featureModel), ecModel, {
        include: [
            "grid"
        ]
    });
    var panels = brushTargetManager.makePanelOpts(api, function(targetInfo) {
        return targetInfo.xAxisDeclared && !targetInfo.yAxisDeclared ? "lineX" : !targetInfo.xAxisDeclared && targetInfo.yAxisDeclared ? "lineY" : "rect";
    });
    view._brushController.setPanels(panels).enableBrush(zoomActive && panels.length ? {
        brushType: "auto",
        brushStyle: featureModel.getModel("brushStyle").getItemStyle()
    } : false);
}
(0, $a625fe571efb4064$export$5a90be4668898d38)("dataZoom", function(ecModel) {
    var toolboxModel = ecModel.getComponent("toolbox", 0);
    var featureDataZoomPath = [
        "feature",
        "dataZoom"
    ];
    if (!toolboxModel || toolboxModel.get(featureDataZoomPath) == null) return;
    var dzFeatureModel = toolboxModel.getModel(featureDataZoomPath);
    var dzOptions = [];
    var finder = $d48e21e24ee5fc18$var$makeAxisFinder(dzFeatureModel);
    var finderResult = (0, $76d619f648247e6d$export$95de80076abac814)(ecModel, finder);
    $d48e21e24ee5fc18$var$each(finderResult.xAxisModels, function(axisModel) {
        return buildInternalOptions(axisModel, "xAxis", "xAxisIndex");
    });
    $d48e21e24ee5fc18$var$each(finderResult.yAxisModels, function(axisModel) {
        return buildInternalOptions(axisModel, "yAxis", "yAxisIndex");
    });
    function buildInternalOptions(axisModel, axisMainType, axisIndexPropName) {
        var axisIndex = axisModel.componentIndex;
        var newOpt = {
            type: "select",
            $fromToolbox: true,
            // Default to be filter
            filterMode: dzFeatureModel.get("filterMode", true) || "filter",
            // Id for merge mapping.
            id: $d48e21e24ee5fc18$var$DATA_ZOOM_ID_BASE + axisMainType + axisIndex
        };
        newOpt[axisIndexPropName] = axisIndex;
        dzOptions.push(newOpt);
    }
    return dzOptions;
});
var $d48e21e24ee5fc18$export$2e2bcd8739ae039 = $d48e21e24ee5fc18$var$DataZoomFeature;


function $db487da8ce0e4ca6$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $f3a05ea4ae929f91$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $e0876f124cc8d5c9$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)("saveAsImage", (0, $1abd70fc7852729e$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)("magicType", (0, $1a3c941566c70505$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)("dataView", (0, $c28a86c6c47fb2f6$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)("dataZoom", (0, $d48e21e24ee5fc18$export$2e2bcd8739ae039));
    (0, $974ee7656e10f2d0$export$c6213a6f247cf906)("restore", (0, $5719d35bf0243166$export$2e2bcd8739ae039));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $738a563bbc36032b$export$4b3e715f166fdd78));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $310c8e7a9655a722$var$TooltipModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TooltipModel, _super);
    function TooltipModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipModel.type;
        return _this;
    }
    TooltipModel.type = "tooltip";
    TooltipModel.dependencies = [
        "axisPointer"
    ];
    TooltipModel.defaultOption = {
        // zlevel: 0,
        z: 60,
        show: true,
        // tooltip main content
        showContent: true,
        // 'trigger' only works on coordinate system.
        // 'item' | 'axis' | 'none'
        trigger: "item",
        // 'click' | 'mousemove' | 'none'
        triggerOn: "mousemove|click",
        alwaysShowContent: false,
        displayMode: "single",
        renderMode: "auto",
        // whether restraint content inside viewRect.
        // If renderMode: 'richText', default true.
        // If renderMode: 'html', defaut false (for backward compat).
        confine: null,
        showDelay: 0,
        hideDelay: 100,
        // Animation transition time, unit is second
        transitionDuration: 0.4,
        enterable: false,
        backgroundColor: "#fff",
        // box shadow
        shadowBlur: 10,
        shadowColor: "rgba(0, 0, 0, .2)",
        shadowOffsetX: 1,
        shadowOffsetY: 2,
        // tooltip border radius, unit is px, default is 4
        borderRadius: 4,
        // tooltip border width, unit is px, default is 0 (no border)
        borderWidth: 1,
        // Tooltip inside padding, default is 5 for all direction
        // Array is allowed to set up, right, bottom, left, same with css
        // The default value: See `tooltip/tooltipMarkup.ts#getPaddingFromTooltipModel`.
        padding: null,
        // Extra css text
        extraCssText: "",
        // axis indicator, trigger by axis
        axisPointer: {
            // default is line
            // legal values: 'line' | 'shadow' | 'cross'
            type: "line",
            // Valid when type is line, appoint tooltip line locate on which line. Optional
            // legal values: 'x' | 'y' | 'angle' | 'radius' | 'auto'
            // default is 'auto', chose the axis which type is category.
            // for multiply y axis, cartesian coord chose x axis, polar chose angle axis
            axis: "auto",
            animation: "auto",
            animationDurationUpdate: 200,
            animationEasingUpdate: "exponentialOut",
            crossStyle: {
                color: "#999",
                width: 1,
                type: "dashed",
                // TODO formatter
                textStyle: {}
            }
        },
        textStyle: {
            color: "#666",
            fontSize: 14
        }
    };
    return TooltipModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $310c8e7a9655a722$export$2e2bcd8739ae039 = $310c8e7a9655a722$var$TooltipModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $c6d80cf697426e46$export$a309528050824ba4(tooltipModel) {
    var confineOption = tooltipModel.get("confine");
    return confineOption != null ? !!confineOption : tooltipModel.get("renderMode") === "richText";
}
function $c6d80cf697426e46$var$testStyle(styleProps) {
    if (!(0, $ce6dd58693a21851$export$2e2bcd8739ae039).domSupported) return;
    var style = document.documentElement.style;
    for(var i = 0, len = styleProps.length; i < len; i++){
        if (styleProps[i] in style) return styleProps[i];
    }
}
var $c6d80cf697426e46$export$7b4286b1e4a23439 = $c6d80cf697426e46$var$testStyle([
    "transform",
    "webkitTransform",
    "OTransform",
    "MozTransform",
    "msTransform"
]);
var $c6d80cf697426e46$export$70a631ae991b5e76 = $c6d80cf697426e46$var$testStyle([
    "webkitTransition",
    "transition",
    "OTransition",
    "MozTransition",
    "msTransition"
]);
function $c6d80cf697426e46$export$5886acafe29a08d1(styleVendor, styleProp) {
    if (!styleVendor) return styleProp;
    styleProp = (0, $c84c9521536c601a$export$86f54f62aa7a7514)(styleProp, true);
    var idx = styleVendor.indexOf(styleProp);
    styleVendor = idx === -1 ? styleProp : "-" + styleVendor.slice(0, idx) + "-" + styleProp;
    return styleVendor.toLowerCase();
}
function $c6d80cf697426e46$export$3735103072e4a80(el, style) {
    var stl = el.currentStyle || document.defaultView && document.defaultView.getComputedStyle(el);
    return stl ? style ? stl[style] : stl : null;
}



/* global document, window */ var $501187a7e974c4e1$var$CSS_TRANSITION_VENDOR = (0, $c6d80cf697426e46$export$5886acafe29a08d1)((0, $c6d80cf697426e46$export$70a631ae991b5e76), "transition");
var $501187a7e974c4e1$var$CSS_TRANSFORM_VENDOR = (0, $c6d80cf697426e46$export$5886acafe29a08d1)((0, $c6d80cf697426e46$export$7b4286b1e4a23439), "transform");
// eslint-disable-next-line
var $501187a7e974c4e1$var$gCssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).transform3dSupported ? "will-change:transform;" : "");
function $501187a7e974c4e1$var$mirrorPos(pos) {
    pos = pos === "left" ? "right" : pos === "right" ? "left" : pos === "top" ? "bottom" : "top";
    return pos;
}
function $501187a7e974c4e1$var$assembleArrow(tooltipModel, borderColor, arrowPosition) {
    if (!(0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(arrowPosition) || arrowPosition === "inside") return "";
    var backgroundColor = tooltipModel.get("backgroundColor");
    var borderWidth = tooltipModel.get("borderWidth");
    borderColor = (0, $c84c9521536c601a$export$cda04d03233e5555)(borderColor);
    var arrowPos = $501187a7e974c4e1$var$mirrorPos(arrowPosition);
    var arrowSize = Math.max(Math.round(borderWidth) * 1.5, 6);
    var positionStyle = "";
    var transformStyle = $501187a7e974c4e1$var$CSS_TRANSFORM_VENDOR + ":";
    var rotateDeg;
    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)([
        "left",
        "right"
    ], arrowPos) > -1) {
        positionStyle += "top:50%";
        transformStyle += "translateY(-50%) rotate(" + (rotateDeg = arrowPos === "left" ? -225 : -45) + "deg)";
    } else {
        positionStyle += "left:50%";
        transformStyle += "translateX(-50%) rotate(" + (rotateDeg = arrowPos === "top" ? 225 : 45) + "deg)";
    }
    var rotateRadian = rotateDeg * Math.PI / 180;
    var arrowWH = arrowSize + borderWidth;
    var rotatedWH = arrowWH * Math.abs(Math.cos(rotateRadian)) + arrowWH * Math.abs(Math.sin(rotateRadian));
    var arrowOffset = Math.round(((rotatedWH - Math.SQRT2 * borderWidth) / 2 + Math.SQRT2 * borderWidth - (rotatedWH - arrowWH) / 2) * 100) / 100;
    positionStyle += ";" + arrowPos + ":-" + arrowOffset + "px";
    var borderStyle = borderColor + " solid " + borderWidth + "px;";
    var styleCss = [
        "position:absolute;width:" + arrowSize + "px;height:" + arrowSize + "px;z-index:-1;",
        positionStyle + ";" + transformStyle + ";",
        "border-bottom:" + borderStyle,
        "border-right:" + borderStyle,
        "background-color:" + backgroundColor + ";"
    ];
    return '<div style="' + styleCss.join("") + '"></div>';
}
function $501187a7e974c4e1$var$assembleTransition(duration, onlyFade) {
    var transitionCurve = "cubic-bezier(0.23,1,0.32,1)";
    var transitionOption = " " + duration / 2 + "s " + transitionCurve;
    var transitionText = "opacity" + transitionOption + ",visibility" + transitionOption;
    if (!onlyFade) {
        transitionOption = " " + duration + "s " + transitionCurve;
        transitionText += (0, $ce6dd58693a21851$export$2e2bcd8739ae039).transformSupported ? "," + $501187a7e974c4e1$var$CSS_TRANSFORM_VENDOR + transitionOption : ",left" + transitionOption + ",top" + transitionOption;
    }
    return $501187a7e974c4e1$var$CSS_TRANSITION_VENDOR + ":" + transitionText;
}
function $501187a7e974c4e1$var$assembleTransform(x, y, toString) {
    // If using float on style, the final width of the dom might
    // keep changing slightly while mouse move. So `toFixed(0)` them.
    var x0 = x.toFixed(0) + "px";
    var y0 = y.toFixed(0) + "px";
    // not support transform, use `left` and `top` instead.
    if (!(0, $ce6dd58693a21851$export$2e2bcd8739ae039).transformSupported) return toString ? "top:" + y0 + ";left:" + x0 + ";" : [
        [
            "top",
            y0
        ],
        [
            "left",
            x0
        ]
    ];
    // support transform
    var is3d = (0, $ce6dd58693a21851$export$2e2bcd8739ae039).transform3dSupported;
    var translate = "translate" + (is3d ? "3d" : "") + "(" + x0 + "," + y0 + (is3d ? ",0" : "") + ")";
    return toString ? "top:0;left:0;" + $501187a7e974c4e1$var$CSS_TRANSFORM_VENDOR + ":" + translate + ";" : [
        [
            "top",
            0
        ],
        [
            "left",
            0
        ],
        [
            (0, $c6d80cf697426e46$export$7b4286b1e4a23439),
            translate
        ]
    ];
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */ function $501187a7e974c4e1$var$assembleFont(textStyleModel) {
    var cssText = [];
    var fontSize = textStyleModel.get("fontSize");
    var color = textStyleModel.getTextColor();
    color && cssText.push("color:" + color);
    cssText.push("font:" + textStyleModel.getFont());
    fontSize && cssText.push("line-height:" + Math.round(fontSize * 3 / 2) + "px");
    var shadowColor = textStyleModel.get("textShadowColor");
    var shadowBlur = textStyleModel.get("textShadowBlur") || 0;
    var shadowOffsetX = textStyleModel.get("textShadowOffsetX") || 0;
    var shadowOffsetY = textStyleModel.get("textShadowOffsetY") || 0;
    shadowColor && shadowBlur && cssText.push("text-shadow:" + shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor);
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "decoration",
        "align"
    ], function(name) {
        var val = textStyleModel.get(name);
        val && cssText.push("text-" + name + ":" + val);
    });
    return cssText.join(";");
}
function $501187a7e974c4e1$var$assembleCssText(tooltipModel, enableTransition, onlyFade) {
    var cssText = [];
    var transitionDuration = tooltipModel.get("transitionDuration");
    var backgroundColor = tooltipModel.get("backgroundColor");
    var shadowBlur = tooltipModel.get("shadowBlur");
    var shadowColor = tooltipModel.get("shadowColor");
    var shadowOffsetX = tooltipModel.get("shadowOffsetX");
    var shadowOffsetY = tooltipModel.get("shadowOffsetY");
    var textStyleModel = tooltipModel.getModel("textStyle");
    var padding = (0, $d5ab84c08d6657ec$export$3048212c802df496)(tooltipModel, "html");
    var boxShadow = shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor;
    cssText.push("box-shadow:" + boxShadow);
    // Animation transition. Do not animate when transitionDuration is 0.
    enableTransition && transitionDuration && cssText.push($501187a7e974c4e1$var$assembleTransition(transitionDuration, onlyFade));
    if (backgroundColor) cssText.push("background-color:" + backgroundColor);
    // Border style
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)([
        "width",
        "color",
        "radius"
    ], function(name) {
        var borderName = "border-" + name;
        var camelCase = (0, $c84c9521536c601a$export$86f54f62aa7a7514)(borderName);
        var val = tooltipModel.get(camelCase);
        val != null && cssText.push(borderName + ":" + val + (name === "color" ? "" : "px"));
    });
    // Text style
    cssText.push($501187a7e974c4e1$var$assembleFont(textStyleModel));
    // Padding
    if (padding != null) cssText.push("padding:" + (0, $c84c9521536c601a$export$f3a38102c49f4268)(padding).join("px ") + "px");
    return cssText.join(";") + ";";
}
// If not able to make, do not modify the input `out`.
function $501187a7e974c4e1$var$makeStyleCoord(out, zr, container, zrX, zrY) {
    var zrPainter = zr && zr.painter;
    if (container) {
        var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
        if (zrViewportRoot) // Some APPs might use scale on body, so we support CSS transform here.
        (0, $664e052f390bd76e$export$8c5c02e118307e20)(out, zrViewportRoot, container, zrX, zrY);
    } else {
        out[0] = zrX;
        out[1] = zrY;
        // xy should be based on canvas root. But tooltipContent is
        // the sibling of canvas root. So padding of ec container
        // should be considered here.
        var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
        if (viewportRootOffset) {
            out[0] += viewportRootOffset.offsetLeft;
            out[1] += viewportRootOffset.offsetTop;
        }
    }
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $501187a7e974c4e1$var$TooltipHTMLContent = /** @class */ function() {
    function TooltipHTMLContent(api, opt) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._enterable = true;
        this._alwaysShowContent = false;
        this._firstShow = true;
        this._longHide = true;
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).wxa) return null;
        var el = document.createElement("div");
        // TODO: TYPE
        el.domBelongToZr = true;
        this.el = el;
        var zr = this._zr = api.getZr();
        var appendTo = opt.appendTo;
        var container = appendTo && ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(appendTo) ? document.querySelector(appendTo) : (0, $7a1bd9c2710fea0d$export$9f57505b7bd8dae)(appendTo) ? appendTo : (0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(appendTo) && appendTo(api.getDom()));
        $501187a7e974c4e1$var$makeStyleCoord(this._styleCoord, zr, container, api.getWidth() / 2, api.getHeight() / 2);
        (container || api.getDom()).appendChild(el);
        this._api = api;
        this._container = container;
        // FIXME
        // Is it needed to trigger zr event manually if
        // the browser do not support `pointer-events: none`.
        var self = this;
        el.onmouseenter = function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        };
        el.onmousemove = function(e) {
            e = e || window.event;
            if (!self._enterable) {
                // `pointer-events: none` is set to tooltip content div
                // if `enterable` is set as `false`, and `el.onmousemove`
                // can not be triggered. But in browser that do not
                // support `pointer-events`, we need to do this:
                // Try trigger zrender event to avoid mouse
                // in and out shape too frequently
                var handler = zr.handler;
                var zrViewportRoot = zr.painter.getViewportRoot();
                (0, $b3864a78637ff9ed$export$40fadb093aebad71)(zrViewportRoot, e, true);
                handler.dispatch("mousemove", e);
            }
        };
        el.onmouseleave = function() {
            // set `_inContent` to `false` before `hideLater`
            self._inContent = false;
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
        };
    }
    /**
   * Update when tooltip is rendered
   */ TooltipHTMLContent.prototype.update = function(tooltipModel) {
        // FIXME
        // Move this logic to ec main?
        if (!this._container) {
            var container = this._api.getDom();
            var position = (0, $c6d80cf697426e46$export$3735103072e4a80)(container, "position");
            var domStyle = container.style;
            if (domStyle.position !== "absolute" && position !== "absolute") domStyle.position = "relative";
        }
        // move tooltip if chart resized
        var alwaysShowContent = tooltipModel.get("alwaysShowContent");
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
        // update className
        this.el.className = tooltipModel.get("className") || "";
    // Hide the tooltip
    // PENDING
    // this.hide();
    };
    TooltipHTMLContent.prototype.show = function(tooltipModel, nearPointColor) {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var el = this.el;
        var style = el.style;
        var styleCoord = this._styleCoord;
        if (!el.innerHTML) style.display = "none";
        else style.cssText = $501187a7e974c4e1$var$gCssText + $501187a7e974c4e1$var$assembleCssText(tooltipModel, !this._firstShow, this._longHide) + $501187a7e974c4e1$var$assembleTransform(styleCoord[0], styleCoord[1], true) + ("border-color:" + (0, $c84c9521536c601a$export$cda04d03233e5555)(nearPointColor) + ";") + (tooltipModel.get("extraCssText") || "") + (";pointer-events:" + (this._enterable ? "auto" : "none"));
        this._show = true;
        this._firstShow = false;
        this._longHide = false;
    };
    TooltipHTMLContent.prototype.setContent = function(content, markers, tooltipModel, borderColor, arrowPosition) {
        var el = this.el;
        if (content == null) {
            el.innerHTML = "";
            return;
        }
        var arrow = "";
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(arrowPosition) && tooltipModel.get("trigger") === "item" && !(0, $c6d80cf697426e46$export$a309528050824ba4)(tooltipModel)) arrow = $501187a7e974c4e1$var$assembleArrow(tooltipModel, borderColor, arrowPosition);
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(content)) el.innerHTML = content + arrow;
        else if (content) {
            // Clear previous
            el.innerHTML = "";
            if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(content)) content = [
                content
            ];
            for(var i = 0; i < content.length; i++)if ((0, $7a1bd9c2710fea0d$export$9f57505b7bd8dae)(content[i]) && content[i].parentNode !== el) el.appendChild(content[i]);
            // no arrow if empty
            if (arrow && el.childNodes.length) {
                // no need to create a new parent element, but it's not supported by IE 10 and older.
                // const arrowEl = document.createRange().createContextualFragment(arrow);
                var arrowEl = document.createElement("div");
                arrowEl.innerHTML = arrow;
                el.appendChild(arrowEl);
            }
        }
    };
    TooltipHTMLContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipHTMLContent.prototype.getSize = function() {
        var el = this.el;
        return [
            el.offsetWidth,
            el.offsetHeight
        ];
    };
    TooltipHTMLContent.prototype.moveTo = function(zrX, zrY) {
        var styleCoord = this._styleCoord;
        $501187a7e974c4e1$var$makeStyleCoord(styleCoord, this._zr, this._container, zrX, zrY);
        if (styleCoord[0] != null && styleCoord[1] != null) {
            var style_1 = this.el.style;
            var transforms = $501187a7e974c4e1$var$assembleTransform(styleCoord[0], styleCoord[1]);
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(transforms, function(transform) {
                style_1[transform[0]] = transform[1];
            });
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipHTMLContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipHTMLContent.prototype.hide = function() {
        var _this = this;
        var style = this.el.style;
        style.visibility = "hidden";
        style.opacity = "0";
        (0, $ce6dd58693a21851$export$2e2bcd8739ae039).transform3dSupported && (style.willChange = "");
        this._show = false;
        this._longHideTimeout = setTimeout(function() {
            return _this._longHide = true;
        }, 500);
    };
    TooltipHTMLContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout((0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipHTMLContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipHTMLContent.prototype.dispose = function() {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var parentNode = this.el.parentNode;
        parentNode && parentNode.removeChild(this.el);
        this.el = this._container = null;
    };
    return TooltipHTMLContent;
}();
var $501187a7e974c4e1$export$2e2bcd8739ae039 = $501187a7e974c4e1$var$TooltipHTMLContent;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $62f65ba5b769b0ae$var$TooltipRichContent = /** @class */ function() {
    function TooltipRichContent(api) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._alwaysShowContent = false;
        this._enterable = true;
        this._zr = api.getZr();
        $62f65ba5b769b0ae$var$makeStyleCoord(this._styleCoord, this._zr, api.getWidth() / 2, api.getHeight() / 2);
    }
    /**
   * Update when tooltip is rendered
   */ TooltipRichContent.prototype.update = function(tooltipModel) {
        var alwaysShowContent = tooltipModel.get("alwaysShowContent");
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
    };
    TooltipRichContent.prototype.show = function() {
        if (this._hideTimeout) clearTimeout(this._hideTimeout);
        this.el.show();
        this._show = true;
    };
    /**
   * Set tooltip content
   */ TooltipRichContent.prototype.setContent = function(content, markupStyleCreator, tooltipModel, borderColor, arrowPosition) {
        var _this = this;
        if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(content)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)("");
        if (this.el) this._zr.remove(this.el);
        var textStyleModel = tooltipModel.getModel("textStyle");
        this.el = new (0, $fe885cc21795562b$export$2e2bcd8739ae039)({
            style: {
                rich: markupStyleCreator.richTextStyles,
                text: content,
                lineHeight: 22,
                borderWidth: 1,
                borderColor: borderColor,
                textShadowColor: textStyleModel.get("textShadowColor"),
                fill: tooltipModel.get([
                    "textStyle",
                    "color"
                ]),
                padding: (0, $d5ab84c08d6657ec$export$3048212c802df496)(tooltipModel, "richText"),
                verticalAlign: "top",
                align: "left"
            },
            z: tooltipModel.get("z")
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            "backgroundColor",
            "borderRadius",
            "shadowColor",
            "shadowBlur",
            "shadowOffsetX",
            "shadowOffsetY"
        ], function(propName) {
            _this.el.style[propName] = tooltipModel.get(propName);
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43([
            "textShadowBlur",
            "textShadowOffsetX",
            "textShadowOffsetY"
        ], function(propName) {
            _this.el.style[propName] = textStyleModel.get(propName) || 0;
        });
        this._zr.add(this.el);
        var self = this;
        this.el.on("mouseover", function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        });
        this.el.on("mouseout", function() {
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
            self._inContent = false;
        });
    };
    TooltipRichContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipRichContent.prototype.getSize = function() {
        var el = this.el;
        var bounding = this.el.getBoundingRect();
        // bounding rect does not include shadow. For renderMode richText,
        // if overflow, it will be cut. So calculate them accurately.
        var shadowOuterSize = $62f65ba5b769b0ae$var$calcShadowOuterSize(el.style);
        return [
            bounding.width + shadowOuterSize.left + shadowOuterSize.right,
            bounding.height + shadowOuterSize.top + shadowOuterSize.bottom
        ];
    };
    TooltipRichContent.prototype.moveTo = function(x, y) {
        var el = this.el;
        if (el) {
            var styleCoord = this._styleCoord;
            $62f65ba5b769b0ae$var$makeStyleCoord(styleCoord, this._zr, x, y);
            x = styleCoord[0];
            y = styleCoord[1];
            var style = el.style;
            var borderWidth = $62f65ba5b769b0ae$var$mathMaxWith0(style.borderWidth || 0);
            var shadowOuterSize = $62f65ba5b769b0ae$var$calcShadowOuterSize(style);
            // rich text x, y do not include border.
            el.x = x + borderWidth + shadowOuterSize.left;
            el.y = y + borderWidth + shadowOuterSize.top;
            el.markRedraw();
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipRichContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipRichContent.prototype.hide = function() {
        if (this.el) this.el.hide();
        this._show = false;
    };
    TooltipRichContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout($7a1bd9c2710fea0d$export$2385a24977818dd0(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipRichContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipRichContent.prototype.dispose = function() {
        this._zr.remove(this.el);
    };
    return TooltipRichContent;
}();
function $62f65ba5b769b0ae$var$mathMaxWith0(val) {
    return Math.max(0, val);
}
function $62f65ba5b769b0ae$var$calcShadowOuterSize(style) {
    var shadowBlur = $62f65ba5b769b0ae$var$mathMaxWith0(style.shadowBlur || 0);
    var shadowOffsetX = $62f65ba5b769b0ae$var$mathMaxWith0(style.shadowOffsetX || 0);
    var shadowOffsetY = $62f65ba5b769b0ae$var$mathMaxWith0(style.shadowOffsetY || 0);
    return {
        left: $62f65ba5b769b0ae$var$mathMaxWith0(shadowBlur - shadowOffsetX),
        right: $62f65ba5b769b0ae$var$mathMaxWith0(shadowBlur + shadowOffsetX),
        top: $62f65ba5b769b0ae$var$mathMaxWith0(shadowBlur - shadowOffsetY),
        bottom: $62f65ba5b769b0ae$var$mathMaxWith0(shadowBlur + shadowOffsetY)
    };
}
function $62f65ba5b769b0ae$var$makeStyleCoord(out, zr, zrX, zrY) {
    out[0] = zrX;
    out[1] = zrY;
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $62f65ba5b769b0ae$export$2e2bcd8739ae039 = $62f65ba5b769b0ae$var$TooltipRichContent;




















var $1b2ffe835052ab23$var$proxyRect = new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
    shape: {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    }
});
var $1b2ffe835052ab23$var$TooltipView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(TooltipView, _super);
    function TooltipView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipView.type;
        return _this;
    }
    TooltipView.prototype.init = function(ecModel, api) {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node || !api.getDom()) return;
        var tooltipModel = ecModel.getComponent("tooltip");
        var renderMode = this._renderMode = (0, $76d619f648247e6d$export$cc0a17a5d27b4e17)(tooltipModel.get("renderMode"));
        this._tooltipContent = renderMode === "richText" ? new (0, $62f65ba5b769b0ae$export$2e2bcd8739ae039)(api) : new (0, $501187a7e974c4e1$export$2e2bcd8739ae039)(api, {
            appendTo: tooltipModel.get("appendToBody", true) ? "body" : tooltipModel.get("appendTo", true)
        });
    };
    TooltipView.prototype.render = function(tooltipModel, ecModel, api) {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node || !api.getDom()) return;
        // Reset
        this.group.removeAll();
        this._tooltipModel = tooltipModel;
        this._ecModel = ecModel;
        this._api = api;
        var tooltipContent = this._tooltipContent;
        tooltipContent.update(tooltipModel);
        tooltipContent.setEnterable(tooltipModel.get("enterable"));
        this._initGlobalListener();
        this._keepShow();
        // PENDING
        // `mousemove` event will be triggered very frequently when the mouse moves fast,
        // which causes that the `updatePosition` function was also called frequently.
        // In Chrome with devtools open and Firefox, tooltip looks laggy and shakes. See #14695 #16101
        // To avoid frequent triggering,
        // consider throttling it in 50ms when transition is enabled
        if (this._renderMode !== "richText" && tooltipModel.get("transitionDuration")) (0, $c98659a9437a3d2e$export$958e3e1a02eac4b6)(this, "_updatePosition", 50, "fixRate");
        else (0, $c98659a9437a3d2e$export$42ffd38884aecdac)(this, "_updatePosition");
    };
    TooltipView.prototype._initGlobalListener = function() {
        var tooltipModel = this._tooltipModel;
        var triggerOn = tooltipModel.get("triggerOn");
        $84450f5aa7fbde00$export$6503ec6e8aabbaf("itemTooltip", this._api, (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== "none") {
                if (triggerOn.indexOf(currTrigger) >= 0) this._tryShow(e, dispatchAction);
                else if (currTrigger === "leave") this._hide(dispatchAction);
            }
        }, this));
    };
    TooltipView.prototype._keepShow = function() {
        var tooltipModel = this._tooltipModel;
        var ecModel = this._ecModel;
        var api = this._api;
        var triggerOn = tooltipModel.get("triggerOn");
        // Try to keep the tooltip show when refreshing
        if (this._lastX != null && this._lastY != null && triggerOn !== "none" && triggerOn !== "click") {
            var self_1 = this;
            clearTimeout(this._refreshUpdateTimeout);
            this._refreshUpdateTimeout = setTimeout(function() {
                // Show tip next tick after other charts are rendered
                // In case highlight action has wrong result
                // FIXME
                !api.isDisposed() && self_1.manuallyShowTip(tooltipModel, ecModel, api, {
                    x: self_1._lastX,
                    y: self_1._lastY,
                    dataByCoordSys: self_1._lastDataByCoordSys
                });
            });
        }
    };
    /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */ TooltipView.prototype.manuallyShowTip = function(tooltipModel, ecModel, api, payload) {
        if (payload.from === this.uid || (0, $ce6dd58693a21851$export$2e2bcd8739ae039).node || !api.getDom()) return;
        var dispatchAction = $1b2ffe835052ab23$var$makeDispatchAction(payload, api);
        // Reset ticket
        this._ticket = "";
        // When triggered from axisPointer.
        var dataByCoordSys = payload.dataByCoordSys;
        var cmptRef = $1b2ffe835052ab23$var$findComponentReference(payload, ecModel, api);
        if (cmptRef) {
            var rect = cmptRef.el.getBoundingRect().clone();
            rect.applyTransform(cmptRef.el.transform);
            this._tryShow({
                offsetX: rect.x + rect.width / 2,
                offsetY: rect.y + rect.height / 2,
                target: cmptRef.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: "bottom"
            }, dispatchAction);
        } else if (payload.tooltip && payload.x != null && payload.y != null) {
            var el = $1b2ffe835052ab23$var$proxyRect;
            el.x = payload.x;
            el.y = payload.y;
            el.update();
            (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el).tooltipConfig = {
                name: null,
                option: payload.tooltip
            };
            // Manually show tooltip while view is not using zrender elements.
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                target: el
            }, dispatchAction);
        } else if (dataByCoordSys) this._tryShow({
            offsetX: payload.x,
            offsetY: payload.y,
            position: payload.position,
            dataByCoordSys: dataByCoordSys,
            tooltipOption: payload.tooltipOption
        }, dispatchAction);
        else if (payload.seriesIndex != null) {
            if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) return;
            var pointInfo = (0, $4cab5d8b3532dad5$export$2e2bcd8739ae039)(payload, ecModel);
            var cx = pointInfo.point[0];
            var cy = pointInfo.point[1];
            if (cx != null && cy != null) this._tryShow({
                offsetX: cx,
                offsetY: cy,
                target: pointInfo.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: "bottom"
            }, dispatchAction);
        } else if (payload.x != null && payload.y != null) {
            // FIXME
            // should wrap dispatchAction like `axisPointer/globalListener` ?
            api.dispatchAction({
                type: "updateAxisPointer",
                x: payload.x,
                y: payload.y
            });
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                position: payload.position,
                target: api.getZr().findHover(payload.x, payload.y).target
            }, dispatchAction);
        }
    };
    TooltipView.prototype.manuallyHideTip = function(tooltipModel, ecModel, api, payload) {
        var tooltipContent = this._tooltipContent;
        if (this._tooltipModel) tooltipContent.hideLater(this._tooltipModel.get("hideDelay"));
        this._lastX = this._lastY = this._lastDataByCoordSys = null;
        if (payload.from !== this.uid) this._hide($1b2ffe835052ab23$var$makeDispatchAction(payload, api));
    };
    // Be compatible with previous design, that is, when tooltip.type is 'axis' and
    // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
    // and tooltip.
    TooltipView.prototype._manuallyAxisShowTip = function(tooltipModel, ecModel, api, payload) {
        var seriesIndex = payload.seriesIndex;
        var dataIndex = payload.dataIndex;
        // @ts-ignore
        var coordSysAxesInfo = ecModel.getComponent("axisPointer").coordSysAxesInfo;
        if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) return;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        if (!seriesModel) return;
        var data = seriesModel.getData();
        var tooltipCascadedModel = $1b2ffe835052ab23$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            seriesModel,
            (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel);
        if (tooltipCascadedModel.get("trigger") !== "axis") return;
        api.dispatchAction({
            type: "updateAxisPointer",
            seriesIndex: seriesIndex,
            dataIndex: dataIndex,
            position: payload.position
        });
        return true;
    };
    TooltipView.prototype._tryShow = function(e, dispatchAction) {
        var el = e.target;
        var tooltipModel = this._tooltipModel;
        if (!tooltipModel) return;
        // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
        this._lastX = e.offsetX;
        this._lastY = e.offsetY;
        var dataByCoordSys = e.dataByCoordSys;
        if (dataByCoordSys && dataByCoordSys.length) this._showAxisTooltip(dataByCoordSys, e);
        else if (el) {
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
            if (ecData.ssrType === "legend") // Don't trigger tooltip for legend tooltip item
            return;
            this._lastDataByCoordSys = null;
            var seriesDispatcher_1;
            var cmptDispatcher_1;
            (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(el, function(target) {
                // Always show item tooltip if mouse is on the element with dataIndex
                if ((0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(target).dataIndex != null) {
                    seriesDispatcher_1 = target;
                    return true;
                }
                // Tooltip provided directly. Like legend.
                if ((0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(target).tooltipConfig != null) {
                    cmptDispatcher_1 = target;
                    return true;
                }
            }, true);
            if (seriesDispatcher_1) this._showSeriesItemTooltip(e, seriesDispatcher_1, dispatchAction);
            else if (cmptDispatcher_1) this._showComponentItemTooltip(e, cmptDispatcher_1, dispatchAction);
            else this._hide(dispatchAction);
        } else {
            this._lastDataByCoordSys = null;
            this._hide(dispatchAction);
        }
    };
    TooltipView.prototype._showOrMove = function(tooltipModel, cb) {
        // showDelay is used in this case: tooltip.enterable is set
        // as true. User intent to move mouse into tooltip and click
        // something. `showDelay` makes it easier to enter the content
        // but tooltip do not move immediately.
        var delay = tooltipModel.get("showDelay");
        cb = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(cb, this);
        clearTimeout(this._showTimout);
        delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
    };
    TooltipView.prototype._showAxisTooltip = function(dataByCoordSys, e) {
        var ecModel = this._ecModel;
        var globalTooltipModel = this._tooltipModel;
        var point = [
            e.offsetX,
            e.offsetY
        ];
        var singleTooltipModel = $1b2ffe835052ab23$var$buildTooltipModel([
            e.tooltipOption
        ], globalTooltipModel);
        var renderMode = this._renderMode;
        var cbParamsList = [];
        var articleMarkup = (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("section", {
            blocks: [],
            noHeader: true
        });
        // Only for legacy: `Serise['formatTooltip']` returns a string.
        var markupTextArrLegacy = [];
        var markupStyleCreator = new (0, $d5ab84c08d6657ec$export$2fba3afbcdcf3e18)();
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(dataByCoordSys, function(itemCoordSys) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(itemCoordSys.dataByAxis, function(axisItem) {
                var axisModel = ecModel.getComponent(axisItem.axisDim + "Axis", axisItem.axisIndex);
                var axisValue = axisItem.value;
                if (!axisModel || axisValue == null) return;
                var axisValueLabel = $51dec70890757374$export$7cffee0f9aed39d0(axisValue, axisModel.axis, ecModel, axisItem.seriesDataIndices, axisItem.valueLabelOpt);
                var axisSectionMarkup = (0, $d5ab84c08d6657ec$export$cf63b23ce77d1921)("section", {
                    header: axisValueLabel,
                    noHeader: !(0, $7a1bd9c2710fea0d$export$87c2784dc9fc4ab)(axisValueLabel),
                    sortBlocks: true,
                    blocks: []
                });
                articleMarkup.blocks.push(axisSectionMarkup);
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(axisItem.seriesDataIndices, function(idxItem) {
                    var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
                    var dataIndex = idxItem.dataIndexInside;
                    var cbParams = series.getDataParams(dataIndex);
                    // Can't find data.
                    if (cbParams.dataIndex < 0) return;
                    cbParams.axisDim = axisItem.axisDim;
                    cbParams.axisIndex = axisItem.axisIndex;
                    cbParams.axisType = axisItem.axisType;
                    cbParams.axisId = axisItem.axisId;
                    cbParams.axisValue = $2d646e51cc34f840$export$a5a32f324c1fa457(axisModel.axis, {
                        value: axisValue
                    });
                    cbParams.axisValueLabel = axisValueLabel;
                    // Pre-create marker style for makers. Users can assemble richText
                    // text in `formatter` callback and use those markers style.
                    cbParams.marker = markupStyleCreator.makeTooltipMarker("item", (0, $c84c9521536c601a$export$cda04d03233e5555)(cbParams.color), renderMode);
                    var seriesTooltipResult = (0, $655dd6075cc63601$export$2d16fa82a50c4741)(series.formatTooltip(dataIndex, true, null));
                    var frag = seriesTooltipResult.frag;
                    if (frag) {
                        var valueFormatter = $1b2ffe835052ab23$var$buildTooltipModel([
                            series
                        ], globalTooltipModel).get("valueFormatter");
                        axisSectionMarkup.blocks.push(valueFormatter ? (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
                            valueFormatter: valueFormatter
                        }, frag) : frag);
                    }
                    if (seriesTooltipResult.text) markupTextArrLegacy.push(seriesTooltipResult.text);
                    cbParamsList.push(cbParams);
                });
            });
        });
        // In most cases, the second axis is displays upper on the first one.
        // So we reverse it to look better.
        articleMarkup.blocks.reverse();
        markupTextArrLegacy.reverse();
        var positionExpr = e.position;
        var orderMode = singleTooltipModel.get("order");
        var builtMarkupText = (0, $d5ab84c08d6657ec$export$6969ffb02c1cb49a)(articleMarkup, markupStyleCreator, renderMode, orderMode, ecModel.get("useUTC"), singleTooltipModel.get("textStyle"));
        builtMarkupText && markupTextArrLegacy.unshift(builtMarkupText);
        var blockBreak = renderMode === "richText" ? "\n\n" : "<br/>";
        var allMarkupText = markupTextArrLegacy.join(blockBreak);
        this._showOrMove(singleTooltipModel, function() {
            if (this._updateContentNotChangedOnAxis(dataByCoordSys, cbParamsList)) this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, cbParamsList);
            else this._showTooltipContent(singleTooltipModel, allMarkupText, cbParamsList, Math.random() + "", point[0], point[1], positionExpr, null, markupStyleCreator);
        });
    // Do not trigger events here, because this branch only be entered
    // from dispatchAction.
    };
    TooltipView.prototype._showSeriesItemTooltip = function(e, dispatcher, dispatchAction) {
        var ecModel = this._ecModel;
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(dispatcher);
        // Use dataModel in element if possible
        // Used when mouseover on a element like markPoint or edge
        // In which case, the data is not main data in series.
        var seriesIndex = ecData.seriesIndex;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        // For example, graph link.
        var dataModel = ecData.dataModel || seriesModel;
        var dataIndex = ecData.dataIndex;
        var dataType = ecData.dataType;
        var data = dataModel.getData(dataType);
        var renderMode = this._renderMode;
        var positionDefault = e.positionDefault;
        var tooltipModel = $1b2ffe835052ab23$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            dataModel,
            seriesModel && (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var tooltipTrigger = tooltipModel.get("trigger");
        if (tooltipTrigger != null && tooltipTrigger !== "item") return;
        var params = dataModel.getDataParams(dataIndex, dataType);
        var markupStyleCreator = new (0, $d5ab84c08d6657ec$export$2fba3afbcdcf3e18)();
        // Pre-create marker style for makers. Users can assemble richText
        // text in `formatter` callback and use those markers style.
        params.marker = markupStyleCreator.makeTooltipMarker("item", (0, $c84c9521536c601a$export$cda04d03233e5555)(params.color), renderMode);
        var seriesTooltipResult = (0, $655dd6075cc63601$export$2d16fa82a50c4741)(dataModel.formatTooltip(dataIndex, false, dataType));
        var orderMode = tooltipModel.get("order");
        var valueFormatter = tooltipModel.get("valueFormatter");
        var frag = seriesTooltipResult.frag;
        var markupText = frag ? (0, $d5ab84c08d6657ec$export$6969ffb02c1cb49a)(valueFormatter ? (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({
            valueFormatter: valueFormatter
        }, frag) : frag, markupStyleCreator, renderMode, orderMode, ecModel.get("useUTC"), tooltipModel.get("textStyle")) : seriesTooltipResult.text;
        var asyncTicket = "item_" + dataModel.name + "_" + dataIndex;
        this._showOrMove(tooltipModel, function() {
            this._showTooltipContent(tooltipModel, markupText, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markupStyleCreator);
        });
        // FIXME
        // duplicated showtip if manuallyShowTip is called from dispatchAction.
        dispatchAction({
            type: "showTip",
            dataIndexInside: dataIndex,
            dataIndex: data.getRawIndex(dataIndex),
            seriesIndex: seriesIndex,
            from: this.uid
        });
    };
    TooltipView.prototype._showComponentItemTooltip = function(e, el, dispatchAction) {
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
        var tooltipConfig = ecData.tooltipConfig;
        var tooltipOpt = tooltipConfig.option || {};
        if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(tooltipOpt)) {
            var content = tooltipOpt;
            tooltipOpt = {
                content: content,
                // Fixed formatter
                formatter: content
            };
        }
        var tooltipModelCascade = [
            tooltipOpt
        ];
        var cmpt = this._ecModel.getComponent(ecData.componentMainType, ecData.componentIndex);
        if (cmpt) tooltipModelCascade.push(cmpt);
        // In most cases, component tooltip formatter has different params with series tooltip formatter,
        // so that they cannot share the same formatter. Since the global tooltip formatter is used for series
        // by convention, we do not use it as the default formatter for component.
        tooltipModelCascade.push({
            formatter: tooltipOpt.content
        });
        var positionDefault = e.positionDefault;
        var subTooltipModel = $1b2ffe835052ab23$var$buildTooltipModel(tooltipModelCascade, this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var defaultHtml = subTooltipModel.get("content");
        var asyncTicket = Math.random() + "";
        // PENDING: this case do not support richText style yet.
        var markupStyleCreator = new (0, $d5ab84c08d6657ec$export$2fba3afbcdcf3e18)();
        // Do not check whether `trigger` is 'none' here, because `trigger`
        // only works on coordinate system. In fact, we have not found case
        // that requires setting `trigger` nothing on component yet.
        this._showOrMove(subTooltipModel, function() {
            // Use formatterParams from element defined in component
            // Avoid users modify it.
            var formatterParams = (0, $7a1bd9c2710fea0d$export$9cd59f9826255e47)(subTooltipModel.get("formatterParams") || {});
            this._showTooltipContent(subTooltipModel, defaultHtml, formatterParams, asyncTicket, e.offsetX, e.offsetY, e.position, el, markupStyleCreator);
        });
        // If not dispatch showTip, tip may be hide triggered by axis.
        dispatchAction({
            type: "showTip",
            from: this.uid
        });
    };
    TooltipView.prototype._showTooltipContent = function(// Use Model<TooltipOption> insteadof TooltipModel because this model may be from series or other options.
    // Instead of top level tooltip.
    tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markupStyleCreator) {
        // Reset ticket
        this._ticket = "";
        if (!tooltipModel.get("showContent") || !tooltipModel.get("show")) return;
        var tooltipContent = this._tooltipContent;
        tooltipContent.setEnterable(tooltipModel.get("enterable"));
        var formatter = tooltipModel.get("formatter");
        positionExpr = positionExpr || tooltipModel.get("position");
        var html = defaultHtml;
        var nearPoint = this._getNearestPoint([
            x,
            y
        ], params, tooltipModel.get("trigger"), tooltipModel.get("borderColor"));
        var nearPointColor = nearPoint.color;
        if (formatter) {
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(formatter)) {
                var useUTC = tooltipModel.ecModel.get("useUTC");
                var params0 = (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(params) ? params[0] : params;
                var isTimeAxis = params0 && params0.axisType && params0.axisType.indexOf("time") >= 0;
                html = formatter;
                if (isTimeAxis) html = (0, $0ae0381fb3fd176f$export$d9468344d3651243)(params0.axisValue, html, useUTC);
                html = (0, $c84c9521536c601a$export$2028496a35766e41)(html, params, true);
            } else if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(formatter)) {
                var callback = (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(function(cbTicket, html) {
                    if (cbTicket === this._ticket) {
                        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
                        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
                    }
                }, this);
                this._ticket = asyncTicket;
                html = formatter(params, asyncTicket, callback);
            } else html = formatter;
        }
        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
        tooltipContent.show(tooltipModel, nearPointColor);
        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
    };
    TooltipView.prototype._getNearestPoint = function(point, tooltipDataParams, trigger, borderColor) {
        if (trigger === "axis" || (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(tooltipDataParams)) return {
            color: borderColor || (this._renderMode === "html" ? "#fff" : "none")
        };
        if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(tooltipDataParams)) return {
            color: borderColor || tooltipDataParams.color || tooltipDataParams.borderColor
        };
    };
    TooltipView.prototype._updatePosition = function(tooltipModel, positionExpr, x, // Mouse x
    y, // Mouse y
    content, params, el) {
        var viewWidth = this._api.getWidth();
        var viewHeight = this._api.getHeight();
        positionExpr = positionExpr || tooltipModel.get("position");
        var contentSize = content.getSize();
        var align = tooltipModel.get("align");
        var vAlign = tooltipModel.get("verticalAlign");
        var rect = el && el.getBoundingRect().clone();
        el && rect.applyTransform(el.transform);
        if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(positionExpr)) // Callback of position can be an array or a string specify the position
        positionExpr = positionExpr([
            x,
            y
        ], params, content.el, rect, {
            viewSize: [
                viewWidth,
                viewHeight
            ],
            contentSize: contentSize.slice()
        });
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(positionExpr)) {
            x = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionExpr[0], viewWidth);
            y = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(positionExpr[1], viewHeight);
        } else if ((0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(positionExpr)) {
            var boxLayoutPosition = positionExpr;
            boxLayoutPosition.width = contentSize[0];
            boxLayoutPosition.height = contentSize[1];
            var layoutRect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(boxLayoutPosition, {
                width: viewWidth,
                height: viewHeight
            });
            x = layoutRect.x;
            y = layoutRect.y;
            align = null;
            // When positionExpr is left/top/right/bottom,
            // align and verticalAlign will not work.
            vAlign = null;
        } else if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(positionExpr) && el) {
            var pos = $1b2ffe835052ab23$var$calcTooltipPosition(positionExpr, rect, contentSize, tooltipModel.get("borderWidth"));
            x = pos[0];
            y = pos[1];
        } else {
            var pos = $1b2ffe835052ab23$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
            x = pos[0];
            y = pos[1];
        }
        align && (x -= $1b2ffe835052ab23$var$isCenterAlign(align) ? contentSize[0] / 2 : align === "right" ? contentSize[0] : 0);
        vAlign && (y -= $1b2ffe835052ab23$var$isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === "bottom" ? contentSize[1] : 0);
        if ((0, $c6d80cf697426e46$export$a309528050824ba4)(tooltipModel)) {
            var pos = $1b2ffe835052ab23$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight);
            x = pos[0];
            y = pos[1];
        }
        content.moveTo(x, y);
    };
    // FIXME
    // Should we remove this but leave this to user?
    TooltipView.prototype._updateContentNotChangedOnAxis = function(dataByCoordSys, cbParamsList) {
        var lastCoordSys = this._lastDataByCoordSys;
        var lastCbParamsList = this._cbParamsList;
        var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
        contentNotChanged && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastCoordSys, function(lastItemCoordSys, indexCoordSys) {
            var lastDataByAxis = lastItemCoordSys.dataByAxis || [];
            var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
            var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
            contentNotChanged = contentNotChanged && lastDataByAxis.length === thisDataByAxis.length;
            contentNotChanged && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastDataByAxis, function(lastItem, indexAxis) {
                var thisItem = thisDataByAxis[indexAxis] || {};
                var lastIndices = lastItem.seriesDataIndices || [];
                var newIndices = thisItem.seriesDataIndices || [];
                contentNotChanged = contentNotChanged && lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
                contentNotChanged && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastIndices, function(lastIdxItem, j) {
                    var newIdxItem = newIndices[j];
                    contentNotChanged = contentNotChanged && lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
                });
                // check is cbParams data value changed
                lastCbParamsList && (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(lastItem.seriesDataIndices, function(idxItem) {
                    var seriesIdx = idxItem.seriesIndex;
                    var cbParams = cbParamsList[seriesIdx];
                    var lastCbParams = lastCbParamsList[seriesIdx];
                    if (cbParams && lastCbParams && lastCbParams.data !== cbParams.data) contentNotChanged = false;
                });
            });
        });
        this._lastDataByCoordSys = dataByCoordSys;
        this._cbParamsList = cbParamsList;
        return !!contentNotChanged;
    };
    TooltipView.prototype._hide = function(dispatchAction) {
        // Do not directly hideLater here, because this behavior may be prevented
        // in dispatchAction when showTip is dispatched.
        // FIXME
        // duplicated hideTip if manuallyHideTip is called from dispatchAction.
        this._lastDataByCoordSys = null;
        dispatchAction({
            type: "hideTip",
            from: this.uid
        });
    };
    TooltipView.prototype.dispose = function(ecModel, api) {
        if ((0, $ce6dd58693a21851$export$2e2bcd8739ae039).node || !api.getDom()) return;
        (0, $c98659a9437a3d2e$export$42ffd38884aecdac)(this, "_updatePosition");
        this._tooltipContent.dispose();
        $84450f5aa7fbde00$export$d07f55d4c15c0440("itemTooltip", api);
    };
    TooltipView.type = "tooltip";
    return TooltipView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
/**
 * From top to bottom. (the last one should be globalTooltipModel);
 */ function $1b2ffe835052ab23$var$buildTooltipModel(modelCascade, globalTooltipModel, defaultTooltipOption) {
    // Last is always tooltip model.
    var ecModel = globalTooltipModel.ecModel;
    var resultModel;
    if (defaultTooltipOption) {
        resultModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(defaultTooltipOption, ecModel, ecModel);
        resultModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(globalTooltipModel.option, resultModel, ecModel);
    } else resultModel = globalTooltipModel;
    for(var i = modelCascade.length - 1; i >= 0; i--){
        var tooltipOpt = modelCascade[i];
        if (tooltipOpt) {
            if (tooltipOpt instanceof (0, $6818646a97528290$export$2e2bcd8739ae039)) tooltipOpt = tooltipOpt.get("tooltip", true);
            // In each data item tooltip can be simply write:
            // {
            //  value: 10,
            //  tooltip: 'Something you need to know'
            // }
            if ((0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(tooltipOpt)) tooltipOpt = {
                formatter: tooltipOpt
            };
            if (tooltipOpt) resultModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(tooltipOpt, resultModel, ecModel);
        }
    }
    return resultModel;
}
function $1b2ffe835052ab23$var$makeDispatchAction(payload, api) {
    return payload.dispatchAction || (0, $7a1bd9c2710fea0d$export$2385a24977818dd0)(api.dispatchAction, api);
}
function $1b2ffe835052ab23$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    if (gapH != null) {
        // Add extra 2 pixels for this case:
        // At present the "values" in default tooltip are using CSS `float: right`.
        // When the right edge of the tooltip box is on the right side of the
        // viewport, the `float` layout might push the "values" to the second line.
        if (x + width + gapH + 2 > viewWidth) x -= width + gapH;
        else x += gapH;
    }
    if (gapV != null) {
        if (y + height + gapV > viewHeight) y -= height + gapV;
        else y += gapV;
    }
    return [
        x,
        y
    ];
}
function $1b2ffe835052ab23$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    x = Math.min(x + width, viewWidth) - width;
    y = Math.min(y + height, viewHeight) - height;
    x = Math.max(x, 0);
    y = Math.max(y, 0);
    return [
        x,
        y
    ];
}
function $1b2ffe835052ab23$var$calcTooltipPosition(position, rect, contentSize, borderWidth) {
    var domWidth = contentSize[0];
    var domHeight = contentSize[1];
    var offset = Math.ceil(Math.SQRT2 * borderWidth) + 8;
    var x = 0;
    var y = 0;
    var rectWidth = rect.width;
    var rectHeight = rect.height;
    switch(position){
        case "inside":
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case "top":
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y - domHeight - offset;
            break;
        case "bottom":
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight + offset;
            break;
        case "left":
            x = rect.x - domWidth - offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case "right":
            x = rect.x + rectWidth + offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
    }
    return [
        x,
        y
    ];
}
function $1b2ffe835052ab23$var$isCenterAlign(align) {
    return align === "center" || align === "middle";
}
/**
 * Find target component by payload like:
 * ```js
 * { legendId: 'some_id', name: 'xxx' }
 * { toolboxIndex: 1, name: 'xxx' }
 * { geoName: 'some_name', name: 'xxx' }
 * ```
 * PENDING: at present only
 *
 * If not found, return null/undefined.
 */ function $1b2ffe835052ab23$var$findComponentReference(payload, ecModel, api) {
    var queryOptionMap = (0, $76d619f648247e6d$export$fe600815775d9400)(payload).queryOptionMap;
    var componentMainType = queryOptionMap.keys()[0];
    if (!componentMainType || componentMainType === "series") return;
    var queryResult = (0, $76d619f648247e6d$export$dc741340f7e5f186)(ecModel, componentMainType, queryOptionMap.get(componentMainType), {
        useDefault: false,
        enableAll: false,
        enableNone: false
    });
    var model = queryResult.models[0];
    if (!model) return;
    var view = api.getViewOfComponentModel(model);
    var el;
    view.group.traverse(function(subEl) {
        var tooltipConfig = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(subEl).tooltipConfig;
        if (tooltipConfig && tooltipConfig.name === payload.name) {
            el = subEl;
            return true; // stop
        }
    });
    if (el) return {
        componentMainType: componentMainType,
        componentIndex: model.componentIndex,
        el: el
    };
}
var $1b2ffe835052ab23$export$2e2bcd8739ae039 = $1b2ffe835052ab23$var$TooltipView;



function $46e639bec576c55c$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
    registers.registerComponentModel((0, $310c8e7a9655a722$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $1b2ffe835052ab23$export$2e2bcd8739ae039));
    /**
   * @action
   * @property {string} type
   * @property {number} seriesIndex
   * @property {number} dataIndex
   * @property {number} [x]
   * @property {number} [y]
   */ registers.registerAction({
        type: "showTip",
        event: "showTip",
        update: "tooltip:manuallyShowTip"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
    registers.registerAction({
        type: "hideTip",
        event: "hideTip",
        update: "tooltip:manuallyHideTip"
    }, (0, $7a1bd9c2710fea0d$export$8793edee2d425525));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $9c7e3d8a1f578014$var$RELATIONAL_EXPRESSION_OP_ALIAS_MAP = {
    value: "eq",
    // PENDING: not good for literal semantic?
    "<": "lt",
    "<=": "lte",
    ">": "gt",
    ">=": "gte",
    "=": "eq",
    "!=": "ne",
    "<>": "ne"
};
// type RelationalExpressionOpEvaluate = (tarVal: unknown, condVal: unknown) => boolean;
var $9c7e3d8a1f578014$var$RegExpEvaluator = /** @class */ function() {
    function RegExpEvaluator(rVal) {
        // Support condVal: RegExp | string
        var condValue = this._condVal = (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(rVal) ? new RegExp(rVal) : (0, $7a1bd9c2710fea0d$export$49841c62b9eff15)(rVal) ? rVal : null;
        if (condValue == null) {
            var errMsg = "";
            (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        }
    }
    RegExpEvaluator.prototype.evaluate = function(lVal) {
        var type = typeof lVal;
        return (0, $7a1bd9c2710fea0d$export$844ec244b1367d54)(type) ? this._condVal.test(lVal) : (0, $7a1bd9c2710fea0d$export$7e4aa119212bc614)(type) ? this._condVal.test(lVal + "") : false;
    };
    return RegExpEvaluator;
}();
var $9c7e3d8a1f578014$var$ConstConditionInternal = /** @class */ function() {
    function ConstConditionInternal() {}
    ConstConditionInternal.prototype.evaluate = function() {
        return this.value;
    };
    return ConstConditionInternal;
}();
var $9c7e3d8a1f578014$var$AndConditionInternal = /** @class */ function() {
    function AndConditionInternal() {}
    AndConditionInternal.prototype.evaluate = function() {
        var children = this.children;
        for(var i = 0; i < children.length; i++){
            if (!children[i].evaluate()) return false;
        }
        return true;
    };
    return AndConditionInternal;
}();
var $9c7e3d8a1f578014$var$OrConditionInternal = /** @class */ function() {
    function OrConditionInternal() {}
    OrConditionInternal.prototype.evaluate = function() {
        var children = this.children;
        for(var i = 0; i < children.length; i++){
            if (children[i].evaluate()) return true;
        }
        return false;
    };
    return OrConditionInternal;
}();
var $9c7e3d8a1f578014$var$NotConditionInternal = /** @class */ function() {
    function NotConditionInternal() {}
    NotConditionInternal.prototype.evaluate = function() {
        return !this.child.evaluate();
    };
    return NotConditionInternal;
}();
var $9c7e3d8a1f578014$var$RelationalConditionInternal = /** @class */ function() {
    function RelationalConditionInternal() {}
    RelationalConditionInternal.prototype.evaluate = function() {
        var needParse = !!this.valueParser;
        // Call getValue with no `this`.
        var getValue = this.getValue;
        var tarValRaw = getValue(this.valueGetterParam);
        var tarValParsed = needParse ? this.valueParser(tarValRaw) : null;
        // Relational cond follow "and" logic internally.
        for(var i = 0; i < this.subCondList.length; i++){
            if (!this.subCondList[i].evaluate(needParse ? tarValParsed : tarValRaw)) return false;
        }
        return true;
    };
    return RelationalConditionInternal;
}();
function $9c7e3d8a1f578014$var$parseOption(exprOption, getters) {
    if (exprOption === true || exprOption === false) {
        var cond = new $9c7e3d8a1f578014$var$ConstConditionInternal();
        cond.value = exprOption;
        return cond;
    }
    var errMsg = "";
    if (!$9c7e3d8a1f578014$var$isObjectNotArray(exprOption)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    if (exprOption.and) return $9c7e3d8a1f578014$var$parseAndOrOption("and", exprOption, getters);
    else if (exprOption.or) return $9c7e3d8a1f578014$var$parseAndOrOption("or", exprOption, getters);
    else if (exprOption.not) return $9c7e3d8a1f578014$var$parseNotOption(exprOption, getters);
    return $9c7e3d8a1f578014$var$parseRelationalOption(exprOption, getters);
}
function $9c7e3d8a1f578014$var$parseAndOrOption(op, exprOption, getters) {
    var subOptionArr = exprOption[op];
    var errMsg = "";
    if (!(0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(subOptionArr)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    if (!subOptionArr.length) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var cond = op === "and" ? new $9c7e3d8a1f578014$var$AndConditionInternal() : new $9c7e3d8a1f578014$var$OrConditionInternal();
    cond.children = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(subOptionArr, function(subOption) {
        return $9c7e3d8a1f578014$var$parseOption(subOption, getters);
    });
    if (!cond.children.length) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    return cond;
}
function $9c7e3d8a1f578014$var$parseNotOption(exprOption, getters) {
    var subOption = exprOption.not;
    var errMsg = "";
    if (!$9c7e3d8a1f578014$var$isObjectNotArray(subOption)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var cond = new $9c7e3d8a1f578014$var$NotConditionInternal();
    cond.child = $9c7e3d8a1f578014$var$parseOption(subOption, getters);
    if (!cond.child) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    return cond;
}
function $9c7e3d8a1f578014$var$parseRelationalOption(exprOption, getters) {
    var errMsg = "";
    var valueGetterParam = getters.prepareGetValue(exprOption);
    var subCondList = [];
    var exprKeys = (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(exprOption);
    var parserName = exprOption.parser;
    var valueParser = parserName ? (0, $40ab59f44b7d2db6$export$c88237b7c265b36b)(parserName) : null;
    for(var i = 0; i < exprKeys.length; i++){
        var keyRaw = exprKeys[i];
        if (keyRaw === "parser" || getters.valueGetterAttrMap.get(keyRaw)) continue;
        var op = (0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)($9c7e3d8a1f578014$var$RELATIONAL_EXPRESSION_OP_ALIAS_MAP, keyRaw) ? $9c7e3d8a1f578014$var$RELATIONAL_EXPRESSION_OP_ALIAS_MAP[keyRaw] : keyRaw;
        var condValueRaw = exprOption[keyRaw];
        var condValueParsed = valueParser ? valueParser(condValueRaw) : condValueRaw;
        var evaluator = (0, $40ab59f44b7d2db6$export$f2644c3485f94c4e)(op, condValueParsed) || op === "reg" && new $9c7e3d8a1f578014$var$RegExpEvaluator(condValueParsed);
        if (!evaluator) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        subCondList.push(evaluator);
    }
    if (!subCondList.length) // No relational operator always disabled in case of dangers result.
    (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
    var cond = new $9c7e3d8a1f578014$var$RelationalConditionInternal();
    cond.valueGetterParam = valueGetterParam;
    cond.valueParser = valueParser;
    cond.getValue = getters.getValue;
    cond.subCondList = subCondList;
    return cond;
}
function $9c7e3d8a1f578014$var$isObjectNotArray(val) {
    return (0, $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a)(val) && !(0, $7a1bd9c2710fea0d$export$1e2f57719e155213)(val);
}
var $9c7e3d8a1f578014$var$ConditionalExpressionParsed = /** @class */ function() {
    function ConditionalExpressionParsed(exprOption, getters) {
        this._cond = $9c7e3d8a1f578014$var$parseOption(exprOption, getters);
    }
    ConditionalExpressionParsed.prototype.evaluate = function() {
        return this._cond.evaluate();
    };
    return ConditionalExpressionParsed;
}();
function $9c7e3d8a1f578014$export$cd61647d82cec762(exprOption, getters) {
    return new $9c7e3d8a1f578014$var$ConditionalExpressionParsed(exprOption, getters);
}




var $0e1e10ffafe52e71$export$dc15474d94cdc2b3 = {
    type: "echarts:filter",
    // PENDING: enhance to filter by index rather than create new data
    transform: function(params) {
        // [Caveat] Fail-Fast:
        // Do not return the whole dataset unless user config indicates it explicitly.
        // For example, if no condition is specified by mistake, returning an empty result
        // is better than returning the entire raw source for the user to find the mistake.
        var upstream = params.upstream;
        var rawItem;
        var condition = (0, $9c7e3d8a1f578014$export$cd61647d82cec762)(params.config, {
            valueGetterAttrMap: (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)({
                dimension: true
            }),
            prepareGetValue: function(exprOption) {
                var errMsg = "";
                var dimLoose = exprOption.dimension;
                if (!(0, $7a1bd9c2710fea0d$export$b5a638e9b3fff9f3)(exprOption, "dimension")) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
                var dimInfo = upstream.getDimensionInfo(dimLoose);
                if (!dimInfo) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
                return {
                    dimIdx: dimInfo.index
                };
            },
            getValue: function(param) {
                return upstream.retrieveValueFromItem(rawItem, param.dimIdx);
            }
        });
        var resultData = [];
        for(var i = 0, len = upstream.count(); i < len; i++){
            rawItem = upstream.getRawDataItem(i);
            if (condition.evaluate()) resultData.push(rawItem);
        }
        return {
            data: resultData
        };
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $7781c153e964c2e9$var$sampleLog = "";
var $7781c153e964c2e9$export$505f1bb66427eaee = {
    type: "echarts:sort",
    transform: function(params) {
        var upstream = params.upstream;
        var config = params.config;
        var errMsg = "";
        // Normalize
        // const orderExprList: OrderExpression[] = isArray(config[0])
        //     ? config as OrderExpression[]
        //     : [config as OrderExpression];
        var orderExprList = (0, $76d619f648247e6d$export$4f07b212a02c8051)(config);
        if (!orderExprList.length) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        var orderDefList = [];
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(orderExprList, function(orderExpr) {
            var dimLoose = orderExpr.dimension;
            var order = orderExpr.order;
            var parserName = orderExpr.parser;
            var incomparable = orderExpr.incomparable;
            if (dimLoose == null) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
            if (order !== "asc" && order !== "desc") (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
            if (incomparable && incomparable !== "min" && incomparable !== "max") {
                var errMsg_1 = "";
                (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg_1);
            }
            if (order !== "asc" && order !== "desc") {
                var errMsg_2 = "";
                (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg_2);
            }
            var dimInfo = upstream.getDimensionInfo(dimLoose);
            if (!dimInfo) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
            var parser = parserName ? (0, $40ab59f44b7d2db6$export$c88237b7c265b36b)(parserName) : null;
            if (parserName && !parser) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
            orderDefList.push({
                dimIdx: dimInfo.index,
                parser: parser,
                comparator: new (0, $40ab59f44b7d2db6$export$ed75a5d7b0144167)(order, incomparable)
            });
        });
        // TODO: support it?
        var sourceFormat = upstream.sourceFormat;
        if (sourceFormat !== (0, $cab29724515ce2b8$export$fcd62ebf51387903) && sourceFormat !== (0, $cab29724515ce2b8$export$703ae8a2d83f441)) (0, $84bc7667c27ccedc$export$8bf7aba4a9e09055)(errMsg);
        // Other upstream format are all array.
        var resultData = [];
        for(var i = 0, len = upstream.count(); i < len; i++)resultData.push(upstream.getRawDataItem(i));
        resultData.sort(function(item0, item1) {
            for(var i = 0; i < orderDefList.length; i++){
                var orderDef = orderDefList[i];
                var val0 = upstream.retrieveValueFromItem(item0, orderDef.dimIdx);
                var val1 = upstream.retrieveValueFromItem(item1, orderDef.dimIdx);
                if (orderDef.parser) {
                    val0 = orderDef.parser(val0);
                    val1 = orderDef.parser(val1);
                }
                var result = orderDef.comparator.evaluate(val0, val1);
                if (result !== 0) return result;
            }
            return 0;
        });
        return {
            data: resultData
        };
    }
};


function $d6bad095dfa9594d$export$4b3e715f166fdd78(registers) {
    registers.registerTransform((0, $0e1e10ffafe52e71$export$dc15474d94cdc2b3));
    registers.registerTransform((0, $7781c153e964c2e9$export$505f1bb66427eaee));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @file Visual mapping.
 */ 
var $ef3bd976f9d1f7a2$var$visualDefault = {
    /**
   * @public
   */ get: function(visualType, key, isCategory) {
        var value = $7a1bd9c2710fea0d$export$9cd59f9826255e47(($ef3bd976f9d1f7a2$var$defaultOption[visualType] || {})[key]);
        return isCategory ? $7a1bd9c2710fea0d$export$43bee75e5e14138e(value) ? value[value.length - 1] : value : value;
    }
};
var $ef3bd976f9d1f7a2$var$defaultOption = {
    color: {
        active: [
            "#006edd",
            "#e0ffff"
        ],
        inactive: [
            "rgba(0,0,0,0)"
        ]
    },
    colorHue: {
        active: [
            0,
            360
        ],
        inactive: [
            0,
            0
        ]
    },
    colorSaturation: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    colorLightness: {
        active: [
            0.9,
            0.5
        ],
        inactive: [
            0,
            0
        ]
    },
    colorAlpha: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    opacity: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    symbol: {
        active: [
            "circle",
            "roundRect",
            "diamond"
        ],
        inactive: [
            "none"
        ]
    },
    symbolSize: {
        active: [
            10,
            50
        ],
        inactive: [
            0,
            0
        ]
    }
};
var $ef3bd976f9d1f7a2$export$2e2bcd8739ae039 = $ef3bd976f9d1f7a2$var$visualDefault;







var $fca0c970f405ff38$var$mapVisual = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).mapVisual;
var $fca0c970f405ff38$var$eachVisual = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).eachVisual;
var $fca0c970f405ff38$var$isArray = $7a1bd9c2710fea0d$export$43bee75e5e14138e;
var $fca0c970f405ff38$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $fca0c970f405ff38$var$asc = $cfc1f3b422a3185f$export$debe6e778e0a6d32;
var $fca0c970f405ff38$var$linearMap = $cfc1f3b422a3185f$export$d3f68fbaa670562;
var $fca0c970f405ff38$var$VisualMapModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(VisualMapModel, _super);
    function VisualMapModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = VisualMapModel.type;
        _this.stateList = [
            "inRange",
            "outOfRange"
        ];
        _this.replacableOptionKeys = [
            "inRange",
            "outOfRange",
            "target",
            "controller",
            "color"
        ];
        _this.layoutMode = {
            type: "box",
            ignoreSize: true
        };
        /**
     * [lowerBound, upperBound]
     */ _this.dataBound = [
            -Infinity,
            Infinity
        ];
        _this.targetVisuals = {};
        _this.controllerVisuals = {};
        return _this;
    }
    VisualMapModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    /**
   * @protected
   */ VisualMapModel.prototype.optionUpdated = function(newOption, isInit) {
        var thisOption = this.option;
        !isInit && $87ea23222d1c134e$export$797d20c0a6de578f(thisOption, newOption, this.replacableOptionKeys);
        this.textStyleModel = this.getModel("textStyle");
        this.resetItemSize();
        this.completeVisualOption();
    };
    /**
   * @protected
   */ VisualMapModel.prototype.resetVisual = function(supplementVisualOption) {
        var stateList = this.stateList;
        supplementVisualOption = $7a1bd9c2710fea0d$export$2385a24977818dd0(supplementVisualOption, this);
        this.controllerVisuals = $87ea23222d1c134e$export$89974527642f24a0(this.option.controller, stateList, supplementVisualOption);
        this.targetVisuals = $87ea23222d1c134e$export$89974527642f24a0(this.option.target, stateList, supplementVisualOption);
    };
    /**
   * @public
   */ VisualMapModel.prototype.getItemSymbol = function() {
        return null;
    };
    /**
   * @protected
   * @return {Array.<number>} An array of series indices.
   */ VisualMapModel.prototype.getTargetSeriesIndices = function() {
        var optionSeriesIndex = this.option.seriesIndex;
        var seriesIndices = [];
        if (optionSeriesIndex == null || optionSeriesIndex === "all") this.ecModel.eachSeries(function(seriesModel, index) {
            seriesIndices.push(index);
        });
        else seriesIndices = $76d619f648247e6d$export$4f07b212a02c8051(optionSeriesIndex);
        return seriesIndices;
    };
    /**
   * @public
   */ VisualMapModel.prototype.eachTargetSeries = function(callback, context) {
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.getTargetSeriesIndices(), function(seriesIndex) {
            var seriesModel = this.ecModel.getSeriesByIndex(seriesIndex);
            if (seriesModel) callback.call(context, seriesModel);
        }, this);
    };
    /**
   * @pubilc
   */ VisualMapModel.prototype.isTargetSeries = function(seriesModel) {
        var is = false;
        this.eachTargetSeries(function(model) {
            model === seriesModel && (is = true);
        });
        return is;
    };
    /**
   * @example
   * this.formatValueText(someVal); // format single numeric value to text.
   * this.formatValueText(someVal, true); // format single category value to text.
   * this.formatValueText([min, max]); // format numeric min-max to text.
   * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
   * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
   *
   * @param value Real value, or this.dataBound[0 or 1].
   * @param isCategory Only available when value is number.
   * @param edgeSymbols Open-close symbol when value is interval.
   * @protected
   */ VisualMapModel.prototype.formatValueText = function(value, isCategory, edgeSymbols) {
        var option = this.option;
        var precision = option.precision;
        var dataBound = this.dataBound;
        var formatter = option.formatter;
        var isMinMax;
        edgeSymbols = edgeSymbols || [
            "<",
            ">"
        ];
        if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(value)) {
            value = value.slice();
            isMinMax = true;
        }
        var textValue = isCategory ? value // Value is string when isCategory
         : isMinMax ? [
            toFixed(value[0]),
            toFixed(value[1])
        ] : toFixed(value);
        if ($7a1bd9c2710fea0d$export$844ec244b1367d54(formatter)) return formatter.replace("{value}", isMinMax ? textValue[0] : textValue).replace("{value2}", isMinMax ? textValue[1] : textValue);
        else if ($7a1bd9c2710fea0d$export$f6e2535fb5126e54(formatter)) return isMinMax ? formatter(value[0], value[1]) : formatter(value);
        if (isMinMax) {
            if (value[0] === dataBound[0]) return edgeSymbols[0] + " " + textValue[1];
            else if (value[1] === dataBound[1]) return edgeSymbols[1] + " " + textValue[0];
            else return textValue[0] + " - " + textValue[1];
        } else // Format single value (includes category case).
        return textValue;
        function toFixed(val) {
            return val === dataBound[0] ? "min" : val === dataBound[1] ? "max" : (+val).toFixed(Math.min(precision, 20));
        }
    };
    /**
   * @protected
   */ VisualMapModel.prototype.resetExtent = function() {
        var thisOption = this.option;
        // Can not calculate data extent by data here.
        // Because series and data may be modified in processing stage.
        // So we do not support the feature "auto min/max".
        var extent = $fca0c970f405ff38$var$asc([
            thisOption.min,
            thisOption.max
        ]);
        this._dataExtent = extent;
    };
    /**
   * PENDING:
   * delete this method if no outer usage.
   *
   * Return  Concrete dimension. If null/undefined is returned, no dimension is used.
   */ // getDataDimension(data: SeriesData) {
    //     const optDim = this.option.dimension;
    //     if (optDim != null) {
    //         return data.getDimension(optDim);
    //     }
    //     const dimNames = data.dimensions;
    //     for (let i = dimNames.length - 1; i >= 0; i--) {
    //         const dimName = dimNames[i];
    //         const dimInfo = data.getDimensionInfo(dimName);
    //         if (!dimInfo.isCalculationCoord) {
    //             return dimName;
    //         }
    //     }
    // }
    VisualMapModel.prototype.getDataDimensionIndex = function(data) {
        var optDim = this.option.dimension;
        if (optDim != null) return data.getDimensionIndex(optDim);
        var dimNames = data.dimensions;
        for(var i = dimNames.length - 1; i >= 0; i--){
            var dimName = dimNames[i];
            var dimInfo = data.getDimensionInfo(dimName);
            if (!dimInfo.isCalculationCoord) return dimInfo.storeDimIndex;
        }
    };
    VisualMapModel.prototype.getExtent = function() {
        return this._dataExtent.slice();
    };
    VisualMapModel.prototype.completeVisualOption = function() {
        var ecModel = this.ecModel;
        var thisOption = this.option;
        var base = {
            inRange: thisOption.inRange,
            outOfRange: thisOption.outOfRange
        };
        var target = thisOption.target || (thisOption.target = {});
        var controller = thisOption.controller || (thisOption.controller = {});
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(target, base); // Do not override
        $7a1bd9c2710fea0d$export$4950aa0f605343fb(controller, base); // Do not override
        var isCategory = this.isCategory();
        completeSingle.call(this, target);
        completeSingle.call(this, controller);
        completeInactive.call(this, target, "inRange", "outOfRange");
        // completeInactive.call(this, target, 'outOfRange', 'inRange');
        completeController.call(this, controller);
        function completeSingle(base) {
            // Compatible with ec2 dataRange.color.
            // The mapping order of dataRange.color is: [high value, ..., low value]
            // whereas inRange.color and outOfRange.color is [low value, ..., high value]
            // Notice: ec2 has no inverse.
            if ($fca0c970f405ff38$var$isArray(thisOption.color) && !base.inRange) base.inRange = {
                color: thisOption.color.slice().reverse()
            };
            // Compatible with previous logic, always give a default color, otherwise
            // simple config with no inRange and outOfRange will not work.
            // Originally we use visualMap.color as the default color, but setOption at
            // the second time the default color will be erased. So we change to use
            // constant DEFAULT_COLOR.
            // If user do not want the default color, set inRange: {color: null}.
            base.inRange = base.inRange || {
                color: ecModel.get("gradientColor")
            };
        }
        function completeInactive(base, stateExist, stateAbsent) {
            var optExist = base[stateExist];
            var optAbsent = base[stateAbsent];
            if (optExist && !optAbsent) {
                optAbsent = base[stateAbsent] = {};
                $fca0c970f405ff38$var$each(optExist, function(visualData, visualType) {
                    if (!(0, $7b50f502cfd189d5$export$2e2bcd8739ae039).isValidType(visualType)) return;
                    var defa = (0, $ef3bd976f9d1f7a2$export$2e2bcd8739ae039).get(visualType, "inactive", isCategory);
                    if (defa != null) {
                        optAbsent[visualType] = defa;
                        // Compatibable with ec2:
                        // Only inactive color to rgba(0,0,0,0) can not
                        // make label transparent, so use opacity also.
                        if (visualType === "color" && !optAbsent.hasOwnProperty("opacity") && !optAbsent.hasOwnProperty("colorAlpha")) optAbsent.opacity = [
                            0,
                            0
                        ];
                    }
                });
            }
        }
        function completeController(controller) {
            var symbolExists = (controller.inRange || {}).symbol || (controller.outOfRange || {}).symbol;
            var symbolSizeExists = (controller.inRange || {}).symbolSize || (controller.outOfRange || {}).symbolSize;
            var inactiveColor = this.get("inactiveColor");
            var itemSymbol = this.getItemSymbol();
            var defaultSymbol = itemSymbol || "roundRect";
            $fca0c970f405ff38$var$each(this.stateList, function(state) {
                var itemSize = this.itemSize;
                var visuals = controller[state];
                // Set inactive color for controller if no other color
                // attr (like colorAlpha) specified.
                if (!visuals) visuals = controller[state] = {
                    color: isCategory ? inactiveColor : [
                        inactiveColor
                    ]
                };
                // Consistent symbol and symbolSize if not specified.
                if (visuals.symbol == null) visuals.symbol = symbolExists && $7a1bd9c2710fea0d$export$9cd59f9826255e47(symbolExists) || (isCategory ? defaultSymbol : [
                    defaultSymbol
                ]);
                if (visuals.symbolSize == null) visuals.symbolSize = symbolSizeExists && $7a1bd9c2710fea0d$export$9cd59f9826255e47(symbolSizeExists) || (isCategory ? itemSize[0] : [
                    itemSize[0],
                    itemSize[0]
                ]);
                // Filter none
                visuals.symbol = $fca0c970f405ff38$var$mapVisual(visuals.symbol, function(symbol) {
                    return symbol === "none" ? defaultSymbol : symbol;
                });
                // Normalize symbolSize
                var symbolSize = visuals.symbolSize;
                if (symbolSize != null) {
                    var max_1 = -Infinity;
                    // symbolSize can be object when categories defined.
                    $fca0c970f405ff38$var$eachVisual(symbolSize, function(value) {
                        value > max_1 && (max_1 = value);
                    });
                    visuals.symbolSize = $fca0c970f405ff38$var$mapVisual(symbolSize, function(value) {
                        return $fca0c970f405ff38$var$linearMap(value, [
                            0,
                            max_1
                        ], [
                            0,
                            itemSize[0]
                        ], true);
                    });
                }
            }, this);
        }
    };
    VisualMapModel.prototype.resetItemSize = function() {
        this.itemSize = [
            parseFloat(this.get("itemWidth")),
            parseFloat(this.get("itemHeight"))
        ];
    };
    VisualMapModel.prototype.isCategory = function() {
        return !!this.option.categories;
    };
    /**
   * @public
   * @abstract
   */ VisualMapModel.prototype.setSelected = function(selected) {};
    VisualMapModel.prototype.getSelected = function() {
        return null;
    };
    /**
   * @public
   * @abstract
   */ VisualMapModel.prototype.getValueState = function(value) {
        return null;
    };
    /**
   * FIXME
   * Do not publish to thirt-part-dev temporarily
   * util the interface is stable. (Should it return
   * a function but not visual meta?)
   *
   * @pubilc
   * @abstract
   * @param getColorVisual
   *        params: value, valueState
   *        return: color
   * @return {Object} visualMeta
   *        should includes {stops, outerColors}
   *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
   */ VisualMapModel.prototype.getVisualMeta = function(getColorVisual) {
        return null;
    };
    VisualMapModel.type = "visualMap";
    VisualMapModel.dependencies = [
        "series"
    ];
    VisualMapModel.defaultOption = {
        show: true,
        // zlevel: 0,
        z: 4,
        seriesIndex: "all",
        min: 0,
        max: 200,
        left: 0,
        right: null,
        top: null,
        bottom: 0,
        itemWidth: null,
        itemHeight: null,
        inverse: false,
        orient: "vertical",
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: "#ccc",
        contentColor: "#5793f3",
        inactiveColor: "#aaa",
        borderWidth: 0,
        padding: 5,
        // 接受数组分别设定上右下左边距，同css
        textGap: 10,
        precision: 0,
        textStyle: {
            color: "#333" // 值域文字颜色
        }
    };
    return VisualMapModel;
}((0, $116d65051f61bdfe$export$2e2bcd8739ae039));
var $fca0c970f405ff38$export$2e2bcd8739ae039 = $fca0c970f405ff38$var$VisualMapModel;




// Constant
var $91b3756da4f00019$var$DEFAULT_BAR_BOUND = [
    20,
    140
];
var $91b3756da4f00019$var$ContinuousModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ContinuousModel, _super);
    function ContinuousModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ContinuousModel.type;
        return _this;
    }
    /**
   * @override
   */ ContinuousModel.prototype.optionUpdated = function(newOption, isInit) {
        _super.prototype.optionUpdated.apply(this, arguments);
        this.resetExtent();
        this.resetVisual(function(mappingOption) {
            mappingOption.mappingMethod = "linear";
            mappingOption.dataExtent = this.getExtent();
        });
        this._resetRange();
    };
    /**
   * @protected
   * @override
   */ ContinuousModel.prototype.resetItemSize = function() {
        _super.prototype.resetItemSize.apply(this, arguments);
        var itemSize = this.itemSize;
        (itemSize[0] == null || isNaN(itemSize[0])) && (itemSize[0] = $91b3756da4f00019$var$DEFAULT_BAR_BOUND[0]);
        (itemSize[1] == null || isNaN(itemSize[1])) && (itemSize[1] = $91b3756da4f00019$var$DEFAULT_BAR_BOUND[1]);
    };
    /**
   * @private
   */ ContinuousModel.prototype._resetRange = function() {
        var dataExtent = this.getExtent();
        var range = this.option.range;
        if (!range || range.auto) {
            // `range` should always be array (so we don't use other
            // value like 'auto') for user-friend. (consider getOption).
            dataExtent.auto = 1;
            this.option.range = dataExtent;
        } else if ($7a1bd9c2710fea0d$export$43bee75e5e14138e(range)) {
            if (range[0] > range[1]) range.reverse();
            range[0] = Math.max(range[0], dataExtent[0]);
            range[1] = Math.min(range[1], dataExtent[1]);
        }
    };
    /**
   * @protected
   * @override
   */ ContinuousModel.prototype.completeVisualOption = function() {
        _super.prototype.completeVisualOption.apply(this, arguments);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.stateList, function(state) {
            var symbolSize = this.option.controller[state].symbolSize;
            if (symbolSize && symbolSize[0] !== symbolSize[1]) symbolSize[0] = symbolSize[1] / 3; // For good looking.
        }, this);
    };
    /**
   * @override
   */ ContinuousModel.prototype.setSelected = function(selected) {
        this.option.range = selected.slice();
        this._resetRange();
    };
    /**
   * @public
   */ ContinuousModel.prototype.getSelected = function() {
        var dataExtent = this.getExtent();
        var dataInterval = $cfc1f3b422a3185f$export$debe6e778e0a6d32((this.get("range") || []).slice());
        // Clamp
        dataInterval[0] > dataExtent[1] && (dataInterval[0] = dataExtent[1]);
        dataInterval[1] > dataExtent[1] && (dataInterval[1] = dataExtent[1]);
        dataInterval[0] < dataExtent[0] && (dataInterval[0] = dataExtent[0]);
        dataInterval[1] < dataExtent[0] && (dataInterval[1] = dataExtent[0]);
        return dataInterval;
    };
    /**
   * @override
   */ ContinuousModel.prototype.getValueState = function(value) {
        var range = this.option.range;
        var dataExtent = this.getExtent();
        // When range[0] === dataExtent[0], any value larger than dataExtent[0] maps to 'inRange'.
        // range[1] is processed likewise.
        return (range[0] <= dataExtent[0] || range[0] <= value) && (range[1] >= dataExtent[1] || value <= range[1]) ? "inRange" : "outOfRange";
    };
    ContinuousModel.prototype.findTargetDataIndices = function(range) {
        var result = [];
        this.eachTargetSeries(function(seriesModel) {
            var dataIndices = [];
            var data = seriesModel.getData();
            data.each(this.getDataDimensionIndex(data), function(value, dataIndex) {
                range[0] <= value && value <= range[1] && dataIndices.push(dataIndex);
            }, this);
            result.push({
                seriesId: seriesModel.id,
                dataIndex: dataIndices
            });
        }, this);
        return result;
    };
    /**
   * @implement
   */ ContinuousModel.prototype.getVisualMeta = function(getColorVisual) {
        var oVals = $91b3756da4f00019$var$getColorStopValues(this, "outOfRange", this.getExtent());
        var iVals = $91b3756da4f00019$var$getColorStopValues(this, "inRange", this.option.range.slice());
        var stops = [];
        function setStop(value, valueState) {
            stops.push({
                value: value,
                color: getColorVisual(value, valueState)
            });
        }
        // Format to: outOfRange -- inRange -- outOfRange.
        var iIdx = 0;
        var oIdx = 0;
        var iLen = iVals.length;
        var oLen = oVals.length;
        for(; oIdx < oLen && (!iVals.length || oVals[oIdx] <= iVals[0]); oIdx++)// If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
        if (oVals[oIdx] < iVals[iIdx]) setStop(oVals[oIdx], "outOfRange");
        for(var first = 1; iIdx < iLen; iIdx++, first = 0){
            // If range is full, value beyond min, max will be clamped.
            // make a singularity
            first && stops.length && setStop(iVals[iIdx], "outOfRange");
            setStop(iVals[iIdx], "inRange");
        }
        for(var first = 1; oIdx < oLen; oIdx++)if (!iVals.length || iVals[iVals.length - 1] < oVals[oIdx]) {
            // make a singularity
            if (first) {
                stops.length && setStop(stops[stops.length - 1].value, "outOfRange");
                first = 0;
            }
            setStop(oVals[oIdx], "outOfRange");
        }
        var stopsLen = stops.length;
        return {
            stops: stops,
            outerColors: [
                stopsLen ? stops[0].color : "transparent",
                stopsLen ? stops[stopsLen - 1].color : "transparent"
            ]
        };
    };
    ContinuousModel.type = "visualMap.continuous";
    ContinuousModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $fca0c970f405ff38$export$2e2bcd8739ae039).defaultOption, {
        align: "auto",
        calculable: false,
        hoverLink: true,
        realtime: true,
        handleIcon: "path://M-11.39,9.77h0a3.5,3.5,0,0,1-3.5,3.5h-22a3.5,3.5,0,0,1-3.5-3.5h0a3.5,3.5,0,0,1,3.5-3.5h22A3.5,3.5,0,0,1-11.39,9.77Z",
        handleSize: "120%",
        handleStyle: {
            borderColor: "#fff",
            borderWidth: 1
        },
        indicatorIcon: "circle",
        indicatorSize: "50%",
        indicatorStyle: {
            borderColor: "#fff",
            borderWidth: 2,
            shadowBlur: 2,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowColor: "rgba(0,0,0,0.2)"
        }
    });
    return ContinuousModel;
}((0, $fca0c970f405ff38$export$2e2bcd8739ae039));
function $91b3756da4f00019$var$getColorStopValues(visualMapModel, valueState, dataExtent) {
    if (dataExtent[0] === dataExtent[1]) return dataExtent.slice();
    // When using colorHue mapping, it is not linear color any more.
    // Moreover, canvas gradient seems not to be accurate linear.
    // FIXME
    // Should be arbitrary value 100? or based on pixel size?
    var count = 200;
    var step = (dataExtent[1] - dataExtent[0]) / count;
    var value = dataExtent[0];
    var stopValues = [];
    for(var i = 0; i <= count && value < dataExtent[1]; i++){
        stopValues.push(value);
        value += step;
    }
    stopValues.push(dataExtent[1]);
    return stopValues;
}
var $91b3756da4f00019$export$2e2bcd8739ae039 = $91b3756da4f00019$var$ContinuousModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $0eb56f276c16b145$var$VisualMapView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(VisualMapView, _super);
    function VisualMapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = VisualMapView.type;
        _this.autoPositionValues = {
            left: 1,
            right: 1,
            top: 1,
            bottom: 1
        };
        return _this;
    }
    VisualMapView.prototype.init = function(ecModel, api) {
        this.ecModel = ecModel;
        this.api = api;
    };
    /**
   * @protected
   */ VisualMapView.prototype.render = function(visualMapModel, ecModel, api, payload // TODO: TYPE
    ) {
        this.visualMapModel = visualMapModel;
        if (visualMapModel.get("show") === false) {
            this.group.removeAll();
            return;
        }
        this.doRender(visualMapModel, ecModel, api, payload);
    };
    /**
   * @protected
   */ VisualMapView.prototype.renderBackground = function(group) {
        var visualMapModel = this.visualMapModel;
        var padding = $c84c9521536c601a$export$f3a38102c49f4268(visualMapModel.get("padding") || 0);
        var rect = group.getBoundingRect();
        group.add(new (0, $419e5ff2f303755e$export$2e2bcd8739ae039)({
            z2: -1,
            silent: true,
            shape: {
                x: rect.x - padding[3],
                y: rect.y - padding[0],
                width: rect.width + padding[3] + padding[1],
                height: rect.height + padding[0] + padding[2]
            },
            style: {
                fill: visualMapModel.get("backgroundColor"),
                stroke: visualMapModel.get("borderColor"),
                lineWidth: visualMapModel.get("borderWidth")
            }
        }));
    };
    /**
   * @protected
   * @param targetValue can be Infinity or -Infinity
   * @param visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
   * @param opts
   * @param opts.forceState Specify state, instead of using getValueState method.
   * @param opts.convertOpacityToAlpha For color gradient in controller widget.
   * @return {*} Visual value.
   */ VisualMapView.prototype.getControllerVisual = function(targetValue, visualCluster, opts) {
        opts = opts || {};
        var forceState = opts.forceState;
        var visualMapModel = this.visualMapModel;
        var visualObj = {};
        // Default values.
        if (visualCluster === "color") {
            var defaultColor = visualMapModel.get("contentColor");
            visualObj.color = defaultColor;
        }
        function getter(key) {
            return visualObj[key];
        }
        function setter(key, value) {
            visualObj[key] = value;
        }
        var mappings = visualMapModel.controllerVisuals[forceState || visualMapModel.getValueState(targetValue)];
        var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).prepareVisualTypes(mappings);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(visualTypes, function(type) {
            var visualMapping = mappings[type];
            if (opts.convertOpacityToAlpha && type === "opacity") {
                type = "colorAlpha";
                visualMapping = mappings.__alphaForOpacity;
            }
            if ((0, $7b50f502cfd189d5$export$2e2bcd8739ae039).dependsOn(type, visualCluster)) visualMapping && visualMapping.applyVisual(targetValue, getter, setter);
        });
        return visualObj[visualCluster];
    };
    VisualMapView.prototype.positionGroup = function(group) {
        var model = this.visualMapModel;
        var api = this.api;
        $93b9bc7f22ac7369$export$74054bd96b5eeef1(group, model.getBoxLayoutParams(), {
            width: api.getWidth(),
            height: api.getHeight()
        });
    };
    VisualMapView.prototype.doRender = function(visualMapModel, ecModel, api, payload) {};
    VisualMapView.type = "visualMap";
    return VisualMapView;
}((0, $737c88aa0711f65a$export$2e2bcd8739ae039));
var $0eb56f276c16b145$export$2e2bcd8739ae039 = $0eb56f276c16b145$var$VisualMapView;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $1a17eb3ffb707117$var$paramsSet = [
    [
        "left",
        "right",
        "width"
    ],
    [
        "top",
        "bottom",
        "height"
    ]
];
function $1a17eb3ffb707117$export$dca53c4702e35c6(visualMapModel, api, itemSize) {
    var modelOption = visualMapModel.option;
    var itemAlign = modelOption.align;
    if (itemAlign != null && itemAlign !== "auto") return itemAlign;
    // Auto decision align.
    var ecSize = {
        width: api.getWidth(),
        height: api.getHeight()
    };
    var realIndex = modelOption.orient === "horizontal" ? 1 : 0;
    var reals = $1a17eb3ffb707117$var$paramsSet[realIndex];
    var fakeValue = [
        0,
        null,
        10
    ];
    var layoutInput = {};
    for(var i = 0; i < 3; i++){
        layoutInput[$1a17eb3ffb707117$var$paramsSet[1 - realIndex][i]] = fakeValue[i];
        layoutInput[reals[i]] = i === 2 ? itemSize[0] : modelOption[reals[i]];
    }
    var rParam = [
        [
            "x",
            "width",
            3
        ],
        [
            "y",
            "height",
            0
        ]
    ][realIndex];
    var rect = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(layoutInput, ecSize, modelOption.padding);
    return reals[(rect.margin[rParam[2]] || 0) + rect[rParam[0]] + rect[rParam[1]] * 0.5 < ecSize[rParam[1]] * 0.5 ? 0 : 1];
}
function $1a17eb3ffb707117$export$5381a9dc5427ba18(batch, visualMapModel) {
    $7a1bd9c2710fea0d$export$79b2f7037acddd43(batch || [], function(batchItem) {
        if (batchItem.dataIndex != null) {
            batchItem.dataIndexInside = batchItem.dataIndex;
            batchItem.dataIndex = null;
        }
        batchItem.highlightKey = "visualMap" + (visualMapModel ? visualMapModel.componentIndex : "");
    });
    return batch;
}










var $46b89608ba6c0e8b$var$linearMap = $cfc1f3b422a3185f$export$d3f68fbaa670562;
var $46b89608ba6c0e8b$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
var $46b89608ba6c0e8b$var$mathMin = Math.min;
var $46b89608ba6c0e8b$var$mathMax = Math.max;
// Arbitrary value
var $46b89608ba6c0e8b$var$HOVER_LINK_SIZE = 12;
var $46b89608ba6c0e8b$var$HOVER_LINK_OUT = 6;
// Notice:
// Any "interval" should be by the order of [low, high].
// "handle0" (handleIndex === 0) maps to
// low data value: this._dataInterval[0] and has low coord.
// "handle1" (handleIndex === 1) maps to
// high data value: this._dataInterval[1] and has high coord.
// The logic of transform is implemented in this._createBarGroup.
var $46b89608ba6c0e8b$var$ContinuousView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(ContinuousView, _super);
    function ContinuousView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ContinuousView.type;
        _this._shapes = {};
        _this._dataInterval = [];
        _this._handleEnds = [];
        _this._hoverLinkDataIndices = [];
        return _this;
    }
    ContinuousView.prototype.init = function(ecModel, api) {
        _super.prototype.init.call(this, ecModel, api);
        this._hoverLinkFromSeriesMouseOver = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._hoverLinkFromSeriesMouseOver, this);
        this._hideIndicator = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._hideIndicator, this);
    };
    ContinuousView.prototype.doRender = function(visualMapModel, ecModel, api, payload) {
        if (!payload || payload.type !== "selectDataRange" || payload.from !== this.uid) this._buildView();
    };
    ContinuousView.prototype._buildView = function() {
        this.group.removeAll();
        var visualMapModel = this.visualMapModel;
        var thisGroup = this.group;
        this._orient = visualMapModel.get("orient");
        this._useHandle = visualMapModel.get("calculable");
        this._resetInterval();
        this._renderBar(thisGroup);
        var dataRangeText = visualMapModel.get("text");
        this._renderEndsText(thisGroup, dataRangeText, 0);
        this._renderEndsText(thisGroup, dataRangeText, 1);
        // Do this for background size calculation.
        this._updateView(true);
        // After updating view, inner shapes is built completely,
        // and then background can be rendered.
        this.renderBackground(thisGroup);
        // Real update view
        this._updateView();
        this._enableHoverLinkToSeries();
        this._enableHoverLinkFromSeries();
        this.positionGroup(thisGroup);
    };
    ContinuousView.prototype._renderEndsText = function(group, dataRangeText, endsIndex) {
        if (!dataRangeText) return;
        // Compatible with ec2, text[0] map to high value, text[1] map low value.
        var text = dataRangeText[1 - endsIndex];
        text = text != null ? text + "" : "";
        var visualMapModel = this.visualMapModel;
        var textGap = visualMapModel.get("textGap");
        var itemSize = visualMapModel.itemSize;
        var barGroup = this._shapes.mainGroup;
        var position = this._applyTransform([
            itemSize[0] / 2,
            endsIndex === 0 ? -textGap : itemSize[1] + textGap
        ], barGroup);
        var align = this._applyTransform(endsIndex === 0 ? "bottom" : "top", barGroup);
        var orient = this._orient;
        var textStyleModel = this.visualMapModel.textStyleModel;
        this.group.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                x: position[0],
                y: position[1],
                verticalAlign: orient === "horizontal" ? "middle" : align,
                align: orient === "horizontal" ? align : "center",
                text: text
            })
        }));
    };
    ContinuousView.prototype._renderBar = function(targetGroup) {
        var visualMapModel = this.visualMapModel;
        var shapes = this._shapes;
        var itemSize = visualMapModel.itemSize;
        var orient = this._orient;
        var useHandle = this._useHandle;
        var itemAlign = $1a17eb3ffb707117$export$dca53c4702e35c6(visualMapModel, this.api, itemSize);
        var mainGroup = shapes.mainGroup = this._createBarGroup(itemAlign);
        var gradientBarGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        mainGroup.add(gradientBarGroup);
        // Bar
        gradientBarGroup.add(shapes.outOfRange = $46b89608ba6c0e8b$var$createPolygon());
        gradientBarGroup.add(shapes.inRange = $46b89608ba6c0e8b$var$createPolygon(null, useHandle ? $46b89608ba6c0e8b$var$getCursor(this._orient) : null, $7a1bd9c2710fea0d$export$2385a24977818dd0(this._dragHandle, this, "all", false), $7a1bd9c2710fea0d$export$2385a24977818dd0(this._dragHandle, this, "all", true)));
        // A border radius clip.
        gradientBarGroup.setClipPath(new $419e5ff2f303755e$export$2e2bcd8739ae039({
            shape: {
                x: 0,
                y: 0,
                width: itemSize[0],
                height: itemSize[1],
                r: 3
            }
        }));
        var textRect = visualMapModel.textStyleModel.getTextRect("\u56FD");
        var textSize = $46b89608ba6c0e8b$var$mathMax(textRect.width, textRect.height);
        // Handle
        if (useHandle) {
            shapes.handleThumbs = [];
            shapes.handleLabels = [];
            shapes.handleLabelPoints = [];
            this._createHandle(visualMapModel, mainGroup, 0, itemSize, textSize, orient);
            this._createHandle(visualMapModel, mainGroup, 1, itemSize, textSize, orient);
        }
        this._createIndicator(visualMapModel, mainGroup, itemSize, textSize, orient);
        targetGroup.add(mainGroup);
    };
    ContinuousView.prototype._createHandle = function(visualMapModel, mainGroup, handleIndex, itemSize, textSize, orient) {
        var onDrift = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._dragHandle, this, handleIndex, false);
        var onDragEnd = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._dragHandle, this, handleIndex, true);
        var handleSize = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(visualMapModel.get("handleSize"), itemSize[0]);
        var handleThumb = (0, $5370466dadc978d7$export$af050e04da3a02e8)(visualMapModel.get("handleIcon"), -handleSize / 2, -handleSize / 2, handleSize, handleSize, null, true);
        var cursor = $46b89608ba6c0e8b$var$getCursor(this._orient);
        handleThumb.attr({
            cursor: cursor,
            draggable: true,
            drift: onDrift,
            ondragend: onDragEnd,
            onmousemove: function(e) {
                $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
            }
        });
        handleThumb.x = itemSize[0] / 2;
        handleThumb.useStyle(visualMapModel.getModel("handleStyle").getItemStyle());
        handleThumb.setStyle({
            strokeNoScale: true,
            strokeFirst: true
        });
        handleThumb.style.lineWidth *= 2;
        handleThumb.ensureState("emphasis").style = visualMapModel.getModel([
            "emphasis",
            "handleStyle"
        ]).getItemStyle();
        (0, $2bf82c0980125b62$export$9ba15aea1e048d48)(handleThumb, true);
        mainGroup.add(handleThumb);
        // Text is always horizontal layout but should not be effected by
        // transform (orient/inverse). So label is built separately but not
        // use zrender/graphic/helper/RectText, and is located based on view
        // group (according to handleLabelPoint) but not barGroup.
        var textStyleModel = this.visualMapModel.textStyleModel;
        var handleLabel = new $fe885cc21795562b$export$2e2bcd8739ae039({
            cursor: cursor,
            draggable: true,
            drift: onDrift,
            onmousemove: function(e) {
                // For mobile device, prevent screen slider on the button.
                $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
            },
            ondragend: onDragEnd,
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                x: 0,
                y: 0,
                text: ""
            })
        });
        handleLabel.ensureState("blur").style = {
            opacity: 0.1
        };
        handleLabel.stateTransition = {
            duration: 200
        };
        this.group.add(handleLabel);
        var handleLabelPoint = [
            handleSize,
            0
        ];
        var shapes = this._shapes;
        shapes.handleThumbs[handleIndex] = handleThumb;
        shapes.handleLabelPoints[handleIndex] = handleLabelPoint;
        shapes.handleLabels[handleIndex] = handleLabel;
    };
    ContinuousView.prototype._createIndicator = function(visualMapModel, mainGroup, itemSize, textSize, orient) {
        var scale = (0, $6c308355c7107803$export$e8514cb5a5e2b40f)(visualMapModel.get("indicatorSize"), itemSize[0]);
        var indicator = (0, $5370466dadc978d7$export$af050e04da3a02e8)(visualMapModel.get("indicatorIcon"), -scale / 2, -scale / 2, scale, scale, null, true);
        indicator.attr({
            cursor: "move",
            invisible: true,
            silent: true,
            x: itemSize[0] / 2
        });
        var indicatorStyle = visualMapModel.getModel("indicatorStyle").getItemStyle();
        if (indicator instanceof (0, $86adec94217b86c6$export$2e2bcd8739ae039)) {
            var pathStyle = indicator.style;
            indicator.useStyle($7a1bd9c2710fea0d$export$8b58be045bf06082({
                // TODO other properties like x, y ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, indicatorStyle));
        } else indicator.useStyle(indicatorStyle);
        mainGroup.add(indicator);
        var textStyleModel = this.visualMapModel.textStyleModel;
        var indicatorLabel = new $fe885cc21795562b$export$2e2bcd8739ae039({
            silent: true,
            invisible: true,
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                x: 0,
                y: 0,
                text: ""
            })
        });
        this.group.add(indicatorLabel);
        var indicatorLabelPoint = [
            (orient === "horizontal" ? textSize / 2 : $46b89608ba6c0e8b$var$HOVER_LINK_OUT) + itemSize[0] / 2,
            0
        ];
        var shapes = this._shapes;
        shapes.indicator = indicator;
        shapes.indicatorLabel = indicatorLabel;
        shapes.indicatorLabelPoint = indicatorLabelPoint;
        this._firstShowIndicator = true;
    };
    ContinuousView.prototype._dragHandle = function(handleIndex, isEnd, // dx is event from ondragend if isEnd is true. It's not used
    dx, dy) {
        if (!this._useHandle) return;
        this._dragging = !isEnd;
        if (!isEnd) {
            // Transform dx, dy to bar coordination.
            var vertex = this._applyTransform([
                dx,
                dy
            ], this._shapes.mainGroup, true);
            this._updateInterval(handleIndex, vertex[1]);
            this._hideIndicator();
            // Considering realtime, update view should be executed
            // before dispatch action.
            this._updateView();
        }
        // dragEnd do not dispatch action when realtime.
        if (isEnd === !this.visualMapModel.get("realtime")) // jshint ignore:line
        this.api.dispatchAction({
            type: "selectDataRange",
            from: this.uid,
            visualMapId: this.visualMapModel.id,
            selected: this._dataInterval.slice()
        });
        if (isEnd) !this._hovering && this._clearHoverLinkToSeries();
        else if ($46b89608ba6c0e8b$var$useHoverLinkOnHandle(this.visualMapModel)) this._doHoverLinkToSeries(this._handleEnds[handleIndex], false);
    };
    ContinuousView.prototype._resetInterval = function() {
        var visualMapModel = this.visualMapModel;
        var dataInterval = this._dataInterval = visualMapModel.getSelected();
        var dataExtent = visualMapModel.getExtent();
        var sizeExtent = [
            0,
            visualMapModel.itemSize[1]
        ];
        this._handleEnds = [
            $46b89608ba6c0e8b$var$linearMap(dataInterval[0], dataExtent, sizeExtent, true),
            $46b89608ba6c0e8b$var$linearMap(dataInterval[1], dataExtent, sizeExtent, true)
        ];
    };
    /**
   * @private
   * @param {(number|string)} handleIndex 0 or 1 or 'all'
   * @param {number} dx
   * @param {number} dy
   */ ContinuousView.prototype._updateInterval = function(handleIndex, delta) {
        delta = delta || 0;
        var visualMapModel = this.visualMapModel;
        var handleEnds = this._handleEnds;
        var sizeExtent = [
            0,
            visualMapModel.itemSize[1]
        ];
        (0, $00a8003b34293330$export$2e2bcd8739ae039)(delta, handleEnds, sizeExtent, handleIndex, // cross is forbidden
        0);
        var dataExtent = visualMapModel.getExtent();
        // Update data interval.
        this._dataInterval = [
            $46b89608ba6c0e8b$var$linearMap(handleEnds[0], sizeExtent, dataExtent, true),
            $46b89608ba6c0e8b$var$linearMap(handleEnds[1], sizeExtent, dataExtent, true)
        ];
    };
    ContinuousView.prototype._updateView = function(forSketch) {
        var visualMapModel = this.visualMapModel;
        var dataExtent = visualMapModel.getExtent();
        var shapes = this._shapes;
        var outOfRangeHandleEnds = [
            0,
            visualMapModel.itemSize[1]
        ];
        var inRangeHandleEnds = forSketch ? outOfRangeHandleEnds : this._handleEnds;
        var visualInRange = this._createBarVisual(this._dataInterval, dataExtent, inRangeHandleEnds, "inRange");
        var visualOutOfRange = this._createBarVisual(dataExtent, dataExtent, outOfRangeHandleEnds, "outOfRange");
        shapes.inRange.setStyle({
            fill: visualInRange.barColor
        }).setShape("points", visualInRange.barPoints);
        shapes.outOfRange.setStyle({
            fill: visualOutOfRange.barColor
        }).setShape("points", visualOutOfRange.barPoints);
        this._updateHandle(inRangeHandleEnds, visualInRange);
    };
    ContinuousView.prototype._createBarVisual = function(dataInterval, dataExtent, handleEnds, forceState) {
        var opts = {
            forceState: forceState,
            convertOpacityToAlpha: true
        };
        var colorStops = this._makeColorGradient(dataInterval, opts);
        var symbolSizes = [
            this.getControllerVisual(dataInterval[0], "symbolSize", opts),
            this.getControllerVisual(dataInterval[1], "symbolSize", opts)
        ];
        var barPoints = this._createBarPoints(handleEnds, symbolSizes);
        return {
            barColor: new (0, $cf44c01491b58e53$export$2e2bcd8739ae039)(0, 0, 0, 1, colorStops),
            barPoints: barPoints,
            handlesColor: [
                colorStops[0].color,
                colorStops[colorStops.length - 1].color
            ]
        };
    };
    ContinuousView.prototype._makeColorGradient = function(dataInterval, opts) {
        // Considering colorHue, which is not linear, so we have to sample
        // to calculate gradient color stops, but not only calculate head
        // and tail.
        var sampleNumber = 100; // Arbitrary value.
        var colorStops = [];
        var step = (dataInterval[1] - dataInterval[0]) / sampleNumber;
        colorStops.push({
            color: this.getControllerVisual(dataInterval[0], "color", opts),
            offset: 0
        });
        for(var i = 1; i < sampleNumber; i++){
            var currValue = dataInterval[0] + step * i;
            if (currValue > dataInterval[1]) break;
            colorStops.push({
                color: this.getControllerVisual(currValue, "color", opts),
                offset: i / sampleNumber
            });
        }
        colorStops.push({
            color: this.getControllerVisual(dataInterval[1], "color", opts),
            offset: 1
        });
        return colorStops;
    };
    ContinuousView.prototype._createBarPoints = function(handleEnds, symbolSizes) {
        var itemSize = this.visualMapModel.itemSize;
        return [
            [
                itemSize[0] - symbolSizes[0],
                handleEnds[0]
            ],
            [
                itemSize[0],
                handleEnds[0]
            ],
            [
                itemSize[0],
                handleEnds[1]
            ],
            [
                itemSize[0] - symbolSizes[1],
                handleEnds[1]
            ]
        ];
    };
    ContinuousView.prototype._createBarGroup = function(itemAlign) {
        var orient = this._orient;
        var inverse = this.visualMapModel.get("inverse");
        return new $7ef7583d8302ffce$export$2e2bcd8739ae039(orient === "horizontal" && !inverse ? {
            scaleX: itemAlign === "bottom" ? 1 : -1,
            rotation: Math.PI / 2
        } : orient === "horizontal" && inverse ? {
            scaleX: itemAlign === "bottom" ? -1 : 1,
            rotation: -Math.PI / 2
        } : orient === "vertical" && !inverse ? {
            scaleX: itemAlign === "left" ? 1 : -1,
            scaleY: -1
        } : {
            scaleX: itemAlign === "left" ? 1 : -1
        });
    };
    ContinuousView.prototype._updateHandle = function(handleEnds, visualInRange) {
        if (!this._useHandle) return;
        var shapes = this._shapes;
        var visualMapModel = this.visualMapModel;
        var handleThumbs = shapes.handleThumbs;
        var handleLabels = shapes.handleLabels;
        var itemSize = visualMapModel.itemSize;
        var dataExtent = visualMapModel.getExtent();
        $46b89608ba6c0e8b$var$each([
            0,
            1
        ], function(handleIndex) {
            var handleThumb = handleThumbs[handleIndex];
            handleThumb.setStyle("fill", visualInRange.handlesColor[handleIndex]);
            handleThumb.y = handleEnds[handleIndex];
            var val = $46b89608ba6c0e8b$var$linearMap(handleEnds[handleIndex], [
                0,
                itemSize[1]
            ], dataExtent, true);
            var symbolSize = this.getControllerVisual(val, "symbolSize");
            handleThumb.scaleX = handleThumb.scaleY = symbolSize / itemSize[0];
            handleThumb.x = itemSize[0] - symbolSize / 2;
            // Update handle label position.
            var textPoint = $5b455ae6f843ac47$export$9f9dcb98c894b623(shapes.handleLabelPoints[handleIndex], $5b455ae6f843ac47$export$fce0c6cfca85ed96(handleThumb, this.group));
            handleLabels[handleIndex].setStyle({
                x: textPoint[0],
                y: textPoint[1],
                text: visualMapModel.formatValueText(this._dataInterval[handleIndex]),
                verticalAlign: "middle",
                align: this._orient === "vertical" ? this._applyTransform("left", shapes.mainGroup) : "center"
            });
        }, this);
    };
    ContinuousView.prototype._showIndicator = function(cursorValue, textValue, rangeSymbol, halfHoverLinkSize) {
        var visualMapModel = this.visualMapModel;
        var dataExtent = visualMapModel.getExtent();
        var itemSize = visualMapModel.itemSize;
        var sizeExtent = [
            0,
            itemSize[1]
        ];
        var shapes = this._shapes;
        var indicator = shapes.indicator;
        if (!indicator) return;
        indicator.attr("invisible", false);
        var opts = {
            convertOpacityToAlpha: true
        };
        var color = this.getControllerVisual(cursorValue, "color", opts);
        var symbolSize = this.getControllerVisual(cursorValue, "symbolSize");
        var y = $46b89608ba6c0e8b$var$linearMap(cursorValue, dataExtent, sizeExtent, true);
        var x = itemSize[0] - symbolSize / 2;
        var oldIndicatorPos = {
            x: indicator.x,
            y: indicator.y
        };
        // Update handle label position.
        indicator.y = y;
        indicator.x = x;
        var textPoint = $5b455ae6f843ac47$export$9f9dcb98c894b623(shapes.indicatorLabelPoint, $5b455ae6f843ac47$export$fce0c6cfca85ed96(indicator, this.group));
        var indicatorLabel = shapes.indicatorLabel;
        indicatorLabel.attr("invisible", false);
        var align = this._applyTransform("left", shapes.mainGroup);
        var orient = this._orient;
        var isHorizontal = orient === "horizontal";
        indicatorLabel.setStyle({
            text: (rangeSymbol ? rangeSymbol : "") + visualMapModel.formatValueText(textValue),
            verticalAlign: isHorizontal ? align : "middle",
            align: isHorizontal ? "center" : align
        });
        var indicatorNewProps = {
            x: x,
            y: y,
            style: {
                fill: color
            }
        };
        var labelNewProps = {
            style: {
                x: textPoint[0],
                y: textPoint[1]
            }
        };
        if (visualMapModel.ecModel.isAnimationEnabled() && !this._firstShowIndicator) {
            var animationCfg = {
                duration: 100,
                easing: "cubicInOut",
                additive: true
            };
            indicator.x = oldIndicatorPos.x;
            indicator.y = oldIndicatorPos.y;
            indicator.animateTo(indicatorNewProps, animationCfg);
            indicatorLabel.animateTo(labelNewProps, animationCfg);
        } else {
            indicator.attr(indicatorNewProps);
            indicatorLabel.attr(labelNewProps);
        }
        this._firstShowIndicator = false;
        var handleLabels = this._shapes.handleLabels;
        if (handleLabels) for(var i = 0; i < handleLabels.length; i++)// Fade out handle labels.
        // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
        this.api.enterBlur(handleLabels[i]);
    };
    ContinuousView.prototype._enableHoverLinkToSeries = function() {
        var self = this;
        this._shapes.mainGroup.on("mousemove", function(e) {
            self._hovering = true;
            if (!self._dragging) {
                var itemSize = self.visualMapModel.itemSize;
                var pos = self._applyTransform([
                    e.offsetX,
                    e.offsetY
                ], self._shapes.mainGroup, true, true);
                // For hover link show when hover handle, which might be
                // below or upper than sizeExtent.
                pos[1] = $46b89608ba6c0e8b$var$mathMin($46b89608ba6c0e8b$var$mathMax(0, pos[1]), itemSize[1]);
                self._doHoverLinkToSeries(pos[1], 0 <= pos[0] && pos[0] <= itemSize[0]);
            }
        }).on("mouseout", function() {
            // When mouse is out of handle, hoverLink still need
            // to be displayed when realtime is set as false.
            self._hovering = false;
            !self._dragging && self._clearHoverLinkToSeries();
        });
    };
    ContinuousView.prototype._enableHoverLinkFromSeries = function() {
        var zr = this.api.getZr();
        if (this.visualMapModel.option.hoverLink) {
            zr.on("mouseover", this._hoverLinkFromSeriesMouseOver, this);
            zr.on("mouseout", this._hideIndicator, this);
        } else this._clearHoverLinkFromSeries();
    };
    ContinuousView.prototype._doHoverLinkToSeries = function(cursorPos, hoverOnBar) {
        var visualMapModel = this.visualMapModel;
        var itemSize = visualMapModel.itemSize;
        if (!visualMapModel.option.hoverLink) return;
        var sizeExtent = [
            0,
            itemSize[1]
        ];
        var dataExtent = visualMapModel.getExtent();
        // For hover link show when hover handle, which might be below or upper than sizeExtent.
        cursorPos = $46b89608ba6c0e8b$var$mathMin($46b89608ba6c0e8b$var$mathMax(sizeExtent[0], cursorPos), sizeExtent[1]);
        var halfHoverLinkSize = $46b89608ba6c0e8b$var$getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent);
        var hoverRange = [
            cursorPos - halfHoverLinkSize,
            cursorPos + halfHoverLinkSize
        ];
        var cursorValue = $46b89608ba6c0e8b$var$linearMap(cursorPos, sizeExtent, dataExtent, true);
        var valueRange = [
            $46b89608ba6c0e8b$var$linearMap(hoverRange[0], sizeExtent, dataExtent, true),
            $46b89608ba6c0e8b$var$linearMap(hoverRange[1], sizeExtent, dataExtent, true)
        ];
        // Consider data range is out of visualMap range, see test/visualMap-continuous.html,
        // where china and india has very large population.
        hoverRange[0] < sizeExtent[0] && (valueRange[0] = -Infinity);
        hoverRange[1] > sizeExtent[1] && (valueRange[1] = Infinity);
        // Do not show indicator when mouse is over handle,
        // otherwise labels overlap, especially when dragging.
        if (hoverOnBar) {
            if (valueRange[0] === -Infinity) this._showIndicator(cursorValue, valueRange[1], "< ", halfHoverLinkSize);
            else if (valueRange[1] === Infinity) this._showIndicator(cursorValue, valueRange[0], "> ", halfHoverLinkSize);
            else this._showIndicator(cursorValue, cursorValue, "\u2248 ", halfHoverLinkSize);
        }
        // When realtime is set as false, handles, which are in barGroup,
        // also trigger hoverLink, which help user to realize where they
        // focus on when dragging. (see test/heatmap-large.html)
        // When realtime is set as true, highlight will not show when hover
        // handle, because the label on handle, which displays a exact value
        // but not range, might mislead users.
        var oldBatch = this._hoverLinkDataIndices;
        var newBatch = [];
        if (hoverOnBar || $46b89608ba6c0e8b$var$useHoverLinkOnHandle(visualMapModel)) newBatch = this._hoverLinkDataIndices = visualMapModel.findTargetDataIndices(valueRange);
        var resultBatches = $76d619f648247e6d$export$6d12cabb0c9bf8e3(oldBatch, newBatch);
        this._dispatchHighDown("downplay", $1a17eb3ffb707117$export$5381a9dc5427ba18(resultBatches[0], visualMapModel));
        this._dispatchHighDown("highlight", $1a17eb3ffb707117$export$5381a9dc5427ba18(resultBatches[1], visualMapModel));
    };
    ContinuousView.prototype._hoverLinkFromSeriesMouseOver = function(e) {
        var ecData;
        (0, $808c5a2823518f68$export$8a4fca9e04eb4df6)(e.target, function(target) {
            var currECData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(target);
            if (currECData.dataIndex != null) {
                ecData = currECData;
                return true;
            }
        }, true);
        if (!ecData) return;
        var dataModel = this.ecModel.getSeriesByIndex(ecData.seriesIndex);
        var visualMapModel = this.visualMapModel;
        if (!visualMapModel.isTargetSeries(dataModel)) return;
        var data = dataModel.getData(ecData.dataType);
        var value = data.getStore().get(visualMapModel.getDataDimensionIndex(data), ecData.dataIndex);
        if (!isNaN(value)) this._showIndicator(value, value);
    };
    ContinuousView.prototype._hideIndicator = function() {
        var shapes = this._shapes;
        shapes.indicator && shapes.indicator.attr("invisible", true);
        shapes.indicatorLabel && shapes.indicatorLabel.attr("invisible", true);
        var handleLabels = this._shapes.handleLabels;
        if (handleLabels) for(var i = 0; i < handleLabels.length; i++)// Fade out handle labels.
        // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
        this.api.leaveBlur(handleLabels[i]);
    };
    ContinuousView.prototype._clearHoverLinkToSeries = function() {
        this._hideIndicator();
        var indices = this._hoverLinkDataIndices;
        this._dispatchHighDown("downplay", $1a17eb3ffb707117$export$5381a9dc5427ba18(indices, this.visualMapModel));
        indices.length = 0;
    };
    ContinuousView.prototype._clearHoverLinkFromSeries = function() {
        this._hideIndicator();
        var zr = this.api.getZr();
        zr.off("mouseover", this._hoverLinkFromSeriesMouseOver);
        zr.off("mouseout", this._hideIndicator);
    };
    ContinuousView.prototype._applyTransform = function(vertex, element, inverse, global) {
        var transform = $5b455ae6f843ac47$export$fce0c6cfca85ed96(element, global ? null : this.group);
        return $7a1bd9c2710fea0d$export$43bee75e5e14138e(vertex) ? $5b455ae6f843ac47$export$9f9dcb98c894b623(vertex, transform, inverse) : $5b455ae6f843ac47$export$fff94e9792354cfa(vertex, transform, inverse);
    };
    // TODO: TYPE more specified payload types.
    ContinuousView.prototype._dispatchHighDown = function(type, batch) {
        batch && batch.length && this.api.dispatchAction({
            type: type,
            batch: batch
        });
    };
    /**
   * @override
   */ ContinuousView.prototype.dispose = function() {
        this._clearHoverLinkFromSeries();
        this._clearHoverLinkToSeries();
    };
    ContinuousView.type = "visualMap.continuous";
    return ContinuousView;
}((0, $0eb56f276c16b145$export$2e2bcd8739ae039));
function $46b89608ba6c0e8b$var$createPolygon(points, cursor, onDrift, onDragEnd) {
    return new $51acf033123e1a30$export$2e2bcd8739ae039({
        shape: {
            points: points
        },
        draggable: !!onDrift,
        cursor: cursor,
        drift: onDrift,
        onmousemove: function(e) {
            // For mobile device, prevent screen slider on the button.
            $b3864a78637ff9ed$export$fa6813432f753b0d(e.event);
        },
        ondragend: onDragEnd
    });
}
function $46b89608ba6c0e8b$var$getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent) {
    var halfHoverLinkSize = $46b89608ba6c0e8b$var$HOVER_LINK_SIZE / 2;
    var hoverLinkDataSize = visualMapModel.get("hoverLinkDataSize");
    if (hoverLinkDataSize) halfHoverLinkSize = $46b89608ba6c0e8b$var$linearMap(hoverLinkDataSize, dataExtent, sizeExtent, true) / 2;
    return halfHoverLinkSize;
}
function $46b89608ba6c0e8b$var$useHoverLinkOnHandle(visualMapModel) {
    var hoverLinkOnHandle = visualMapModel.get("hoverLinkOnHandle");
    return !!(hoverLinkOnHandle == null ? visualMapModel.get("realtime") : hoverLinkOnHandle);
}
function $46b89608ba6c0e8b$var$getCursor(orient) {
    return orient === "vertical" ? "ns-resize" : "ew-resize";
}
var $46b89608ba6c0e8b$export$2e2bcd8739ae039 = $46b89608ba6c0e8b$var$ContinuousView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $395ebe650d46f583$export$c5097295b52f5ecd = {
    type: "selectDataRange",
    event: "dataRangeSelected",
    // FIXME use updateView appears wrong
    update: "update"
};
var $395ebe650d46f583$export$8655c04a6fcbaa76 = function(payload, ecModel) {
    ecModel.eachComponent({
        mainType: "visualMap",
        query: payload
    }, function(model) {
        model.setSelected(payload.selected);
    });
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $561e4a618ab15558$export$5933e7c74ab358d1 = [
    {
        createOnAllSeries: true,
        reset: function(seriesModel, ecModel) {
            var resetDefines = [];
            ecModel.eachComponent("visualMap", function(visualMapModel) {
                var pipelineContext = seriesModel.pipelineContext;
                if (!visualMapModel.isTargetSeries(seriesModel) || pipelineContext && pipelineContext.large) return;
                resetDefines.push($87ea23222d1c134e$export$fc0ef8703cccf128(visualMapModel.stateList, visualMapModel.targetVisuals, $7a1bd9c2710fea0d$export$2385a24977818dd0(visualMapModel.getValueState, visualMapModel), visualMapModel.getDataDimensionIndex(seriesModel.getData())));
            });
            return resetDefines;
        }
    },
    // Only support color.
    {
        createOnAllSeries: true,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            var visualMetaList = [];
            ecModel.eachComponent("visualMap", function(visualMapModel) {
                if (visualMapModel.isTargetSeries(seriesModel)) {
                    var visualMeta = visualMapModel.getVisualMeta($7a1bd9c2710fea0d$export$2385a24977818dd0($561e4a618ab15558$var$getColorVisual, null, seriesModel, visualMapModel)) || {
                        stops: [],
                        outerColors: []
                    };
                    var dimIdx = visualMapModel.getDataDimensionIndex(data);
                    if (dimIdx >= 0) {
                        // visualMeta.dimension should be dimension index, but not concrete dimension.
                        visualMeta.dimension = dimIdx;
                        visualMetaList.push(visualMeta);
                    }
                }
            });
            // console.log(JSON.stringify(visualMetaList.map(a => a.stops)));
            seriesModel.getData().setVisual("visualMeta", visualMetaList);
        }
    }
];
// FIXME
// performance and export for heatmap?
// value can be Infinity or -Infinity
function $561e4a618ab15558$var$getColorVisual(seriesModel, visualMapModel, value, valueState) {
    var mappings = visualMapModel.targetVisuals[valueState];
    var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).prepareVisualTypes(mappings);
    var resultVisual = {
        color: (0, $ea13f1ab2169d82d$export$d76e333a86ea1a2)(seriesModel.getData(), "color") // default color.
    };
    for(var i = 0, len = visualTypes.length; i < len; i++){
        var type = visualTypes[i];
        var mapping = mappings[type === "opacity" ? "__alphaForOpacity" : type];
        mapping && mapping.applyVisual(value, getVisual, setVisual);
    }
    return resultVisual.color;
    function getVisual(key) {
        return resultVisual[key];
    }
    function setVisual(key, value) {
        resultVisual[key] = value;
    }
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

var $92519f6317138812$var$each = $7a1bd9c2710fea0d$export$79b2f7037acddd43;
function $92519f6317138812$export$2e2bcd8739ae039(option) {
    var visualMap = option && option.visualMap;
    if (!$7a1bd9c2710fea0d$export$43bee75e5e14138e(visualMap)) visualMap = visualMap ? [
        visualMap
    ] : [];
    $92519f6317138812$var$each(visualMap, function(opt) {
        if (!opt) return;
        // rename splitList to pieces
        if ($92519f6317138812$var$has(opt, "splitList") && !$92519f6317138812$var$has(opt, "pieces")) {
            opt.pieces = opt.splitList;
            delete opt.splitList;
        }
        var pieces = opt.pieces;
        if (pieces && $7a1bd9c2710fea0d$export$43bee75e5e14138e(pieces)) $92519f6317138812$var$each(pieces, function(piece) {
            if ($7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(piece)) {
                if ($92519f6317138812$var$has(piece, "start") && !$92519f6317138812$var$has(piece, "min")) piece.min = piece.start;
                if ($92519f6317138812$var$has(piece, "end") && !$92519f6317138812$var$has(piece, "max")) piece.max = piece.end;
            }
        });
    });
}
function $92519f6317138812$var$has(obj, name) {
    return obj && obj.hasOwnProperty && obj.hasOwnProperty(name);
}


var $769f929efa66b3be$var$installed = false;
function $769f929efa66b3be$export$2e2bcd8739ae039(registers) {
    if ($769f929efa66b3be$var$installed) return;
    $769f929efa66b3be$var$installed = true;
    registers.registerSubTypeDefaulter("visualMap", function(option) {
        // Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
        return !option.categories && (!(option.pieces ? option.pieces.length > 0 : option.splitNumber > 0) || option.calculable) ? "continuous" : "piecewise";
    });
    registers.registerAction((0, $395ebe650d46f583$export$c5097295b52f5ecd), (0, $395ebe650d46f583$export$8655c04a6fcbaa76));
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $561e4a618ab15558$export$5933e7c74ab358d1), function(handler) {
        registers.registerVisual(registers.PRIORITY.VISUAL.COMPONENT, handler);
    });
    registers.registerPreprocessor((0, $92519f6317138812$export$2e2bcd8739ae039));
}


function $a0f8a196dd8b4cba$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $91b3756da4f00019$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $46b89608ba6c0e8b$export$2e2bcd8739ae039));
    (0, $769f929efa66b3be$export$2e2bcd8739ae039)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $800f031000e0c641$var$PiecewiseModel = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PiecewiseModel, _super);
    function PiecewiseModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PiecewiseModel.type;
        /**
     * The order is always [low, ..., high].
     * [{text: string, interval: Array.<number>}, ...]
     */ _this._pieceList = [];
        return _this;
    }
    PiecewiseModel.prototype.optionUpdated = function(newOption, isInit) {
        _super.prototype.optionUpdated.apply(this, arguments);
        this.resetExtent();
        var mode = this._mode = this._determineMode();
        this._pieceList = [];
        $800f031000e0c641$var$resetMethods[this._mode].call(this, this._pieceList);
        this._resetSelected(newOption, isInit);
        var categories = this.option.categories;
        this.resetVisual(function(mappingOption, state) {
            if (mode === "categories") {
                mappingOption.mappingMethod = "category";
                mappingOption.categories = $7a1bd9c2710fea0d$export$9cd59f9826255e47(categories);
            } else {
                mappingOption.dataExtent = this.getExtent();
                mappingOption.mappingMethod = "piecewise";
                mappingOption.pieceList = $7a1bd9c2710fea0d$export$871de8747c9eaa88(this._pieceList, function(piece) {
                    piece = $7a1bd9c2710fea0d$export$9cd59f9826255e47(piece);
                    if (state !== "inRange") // FIXME
                    // outOfRange do not support special visual in pieces.
                    piece.visual = null;
                    return piece;
                });
            }
        });
    };
    /**
   * @protected
   * @override
   */ PiecewiseModel.prototype.completeVisualOption = function() {
        // Consider this case:
        // visualMap: {
        //      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
        // }
        // where no inRange/outOfRange set but only pieces. So we should make
        // default inRange/outOfRange for this case, otherwise visuals that only
        // appear in `pieces` will not be taken into account in visual encoding.
        var option = this.option;
        var visualTypesInPieces = {};
        var visualTypes = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).listVisualTypes();
        var isCategory = this.isCategory();
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(option.pieces, function(piece) {
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(visualTypes, function(visualType) {
                if (piece.hasOwnProperty(visualType)) visualTypesInPieces[visualType] = 1;
            });
        });
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(visualTypesInPieces, function(v, visualType) {
            var exists = false;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.stateList, function(state) {
                exists = exists || has(option, state, visualType) || has(option.target, state, visualType);
            }, this);
            !exists && $7a1bd9c2710fea0d$export$79b2f7037acddd43(this.stateList, function(state) {
                (option[state] || (option[state] = {}))[visualType] = (0, $ef3bd976f9d1f7a2$export$2e2bcd8739ae039).get(visualType, state === "inRange" ? "active" : "inactive", isCategory);
            });
        }, this);
        function has(obj, state, visualType) {
            return obj && obj[state] && obj[state].hasOwnProperty(visualType);
        }
        _super.prototype.completeVisualOption.apply(this, arguments);
    };
    PiecewiseModel.prototype._resetSelected = function(newOption, isInit) {
        var thisOption = this.option;
        var pieceList = this._pieceList;
        // Selected do not merge but all override.
        var selected = (isInit ? thisOption : newOption).selected || {};
        thisOption.selected = selected;
        // Consider 'not specified' means true.
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(pieceList, function(piece, index) {
            var key = this.getSelectedMapKey(piece);
            if (!selected.hasOwnProperty(key)) selected[key] = true;
        }, this);
        if (thisOption.selectedMode === "single") {
            // Ensure there is only one selected.
            var hasSel_1 = false;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(pieceList, function(piece, index) {
                var key = this.getSelectedMapKey(piece);
                if (selected[key]) hasSel_1 ? selected[key] = false : hasSel_1 = true;
            }, this);
        }
    // thisOption.selectedMode === 'multiple', default: all selected.
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getItemSymbol = function() {
        return this.get("itemSymbol");
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getSelectedMapKey = function(piece) {
        return this._mode === "categories" ? piece.value + "" : piece.index + "";
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getPieceList = function() {
        return this._pieceList;
    };
    /**
   * @return {string}
   */ PiecewiseModel.prototype._determineMode = function() {
        var option = this.option;
        return option.pieces && option.pieces.length > 0 ? "pieces" : this.option.categories ? "categories" : "splitNumber";
    };
    /**
   * @override
   */ PiecewiseModel.prototype.setSelected = function(selected) {
        this.option.selected = $7a1bd9c2710fea0d$export$9cd59f9826255e47(selected);
    };
    /**
   * @override
   */ PiecewiseModel.prototype.getValueState = function(value) {
        var index = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).findPieceIndex(value, this._pieceList);
        return index != null ? this.option.selected[this.getSelectedMapKey(this._pieceList[index])] ? "inRange" : "outOfRange" : "outOfRange";
    };
    /**
   * @public
   * @param pieceIndex piece index in visualMapModel.getPieceList()
   */ PiecewiseModel.prototype.findTargetDataIndices = function(pieceIndex) {
        var result = [];
        var pieceList = this._pieceList;
        this.eachTargetSeries(function(seriesModel) {
            var dataIndices = [];
            var data = seriesModel.getData();
            data.each(this.getDataDimensionIndex(data), function(value, dataIndex) {
                // Should always base on model pieceList, because it is order sensitive.
                var pIdx = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).findPieceIndex(value, pieceList);
                pIdx === pieceIndex && dataIndices.push(dataIndex);
            }, this);
            result.push({
                seriesId: seriesModel.id,
                dataIndex: dataIndices
            });
        }, this);
        return result;
    };
    /**
   * @private
   * @param piece piece.value or piece.interval is required.
   * @return  Can be Infinity or -Infinity
   */ PiecewiseModel.prototype.getRepresentValue = function(piece) {
        var representValue;
        if (this.isCategory()) representValue = piece.value;
        else if (piece.value != null) representValue = piece.value;
        else {
            var pieceInterval = piece.interval || [];
            representValue = pieceInterval[0] === -Infinity && pieceInterval[1] === Infinity ? 0 : (pieceInterval[0] + pieceInterval[1]) / 2;
        }
        return representValue;
    };
    PiecewiseModel.prototype.getVisualMeta = function(getColorVisual) {
        // Do not support category. (category axis is ordinal, numerical)
        if (this.isCategory()) return;
        var stops = [];
        var outerColors = [
            "",
            ""
        ];
        var visualMapModel = this;
        function setStop(interval, valueState) {
            var representValue = visualMapModel.getRepresentValue({
                interval: interval
            }); // Not category
            if (!valueState) valueState = visualMapModel.getValueState(representValue);
            var color = getColorVisual(representValue, valueState);
            if (interval[0] === -Infinity) outerColors[0] = color;
            else if (interval[1] === Infinity) outerColors[1] = color;
            else stops.push({
                value: interval[0],
                color: color
            }, {
                value: interval[1],
                color: color
            });
        }
        // Suplement
        var pieceList = this._pieceList.slice();
        if (!pieceList.length) pieceList.push({
            interval: [
                -Infinity,
                Infinity
            ]
        });
        else {
            var edge = pieceList[0].interval[0];
            edge !== -Infinity && pieceList.unshift({
                interval: [
                    -Infinity,
                    edge
                ]
            });
            edge = pieceList[pieceList.length - 1].interval[1];
            edge !== Infinity && pieceList.push({
                interval: [
                    edge,
                    Infinity
                ]
            });
        }
        var curr = -Infinity;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(pieceList, function(piece) {
            var interval = piece.interval;
            if (interval) {
                // Fulfill gap.
                interval[0] > curr && setStop([
                    curr,
                    interval[0]
                ], "outOfRange");
                setStop(interval.slice());
                curr = interval[1];
            }
        }, this);
        return {
            stops: stops,
            outerColors: outerColors
        };
    };
    PiecewiseModel.type = "visualMap.piecewise";
    PiecewiseModel.defaultOption = (0, $5370df662b2caf37$export$68acc510e46fef2)((0, $fca0c970f405ff38$export$2e2bcd8739ae039).defaultOption, {
        selected: null,
        minOpen: false,
        maxOpen: false,
        align: "auto",
        itemWidth: 20,
        itemHeight: 14,
        itemSymbol: "roundRect",
        pieces: null,
        categories: null,
        splitNumber: 5,
        selectedMode: "multiple",
        itemGap: 10,
        hoverLink: true // Enable hover highlight.
    });
    return PiecewiseModel;
}((0, $fca0c970f405ff38$export$2e2bcd8739ae039));
/**
 * Key is this._mode
 * @type {Object}
 * @this {module:echarts/component/viusalMap/PiecewiseMode}
 */ var $800f031000e0c641$var$resetMethods = {
    splitNumber: function(outPieceList) {
        var thisOption = this.option;
        var precision = Math.min(thisOption.precision, 20);
        var dataExtent = this.getExtent();
        var splitNumber = thisOption.splitNumber;
        splitNumber = Math.max(parseInt(splitNumber, 10), 1);
        thisOption.splitNumber = splitNumber;
        var splitStep = (dataExtent[1] - dataExtent[0]) / splitNumber;
        // Precision auto-adaption
        while(+splitStep.toFixed(precision) !== splitStep && precision < 5)precision++;
        thisOption.precision = precision;
        splitStep = +splitStep.toFixed(precision);
        if (thisOption.minOpen) outPieceList.push({
            interval: [
                -Infinity,
                dataExtent[0]
            ],
            close: [
                0,
                0
            ]
        });
        for(var index = 0, curr = dataExtent[0]; index < splitNumber; curr += splitStep, index++){
            var max = index === splitNumber - 1 ? dataExtent[1] : curr + splitStep;
            outPieceList.push({
                interval: [
                    curr,
                    max
                ],
                close: [
                    1,
                    1
                ]
            });
        }
        if (thisOption.maxOpen) outPieceList.push({
            interval: [
                dataExtent[1],
                Infinity
            ],
            close: [
                0,
                0
            ]
        });
        (0, $cfc1f3b422a3185f$export$12f7386070bc380a)(outPieceList);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(outPieceList, function(piece, index) {
            piece.index = index;
            piece.text = this.formatValueText(piece.interval);
        }, this);
    },
    categories: function(outPieceList) {
        var thisOption = this.option;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(thisOption.categories, function(cate) {
            // FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
            // 是否改一致。
            outPieceList.push({
                text: this.formatValueText(cate, true),
                value: cate
            });
        }, this);
        // See "Order Rule".
        $800f031000e0c641$var$normalizeReverse(thisOption, outPieceList);
    },
    pieces: function(outPieceList) {
        var thisOption = this.option;
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(thisOption.pieces, function(pieceListItem, index) {
            if (!$7a1bd9c2710fea0d$export$a6cdc56e425d0d0a(pieceListItem)) pieceListItem = {
                value: pieceListItem
            };
            var item = {
                text: "",
                index: index
            };
            if (pieceListItem.label != null) item.text = pieceListItem.label;
            if (pieceListItem.hasOwnProperty("value")) {
                var value = item.value = pieceListItem.value;
                item.interval = [
                    value,
                    value
                ];
                item.close = [
                    1,
                    1
                ];
            } else {
                // `min` `max` is legacy option.
                // `lt` `gt` `lte` `gte` is recommended.
                var interval = item.interval = [];
                var close_1 = item.close = [
                    0,
                    0
                ];
                var closeList = [
                    1,
                    0,
                    1
                ];
                var infinityList = [
                    -Infinity,
                    Infinity
                ];
                var useMinMax = [];
                for(var lg = 0; lg < 2; lg++){
                    var names = [
                        [
                            "gte",
                            "gt",
                            "min"
                        ],
                        [
                            "lte",
                            "lt",
                            "max"
                        ]
                    ][lg];
                    for(var i = 0; i < 3 && interval[lg] == null; i++){
                        interval[lg] = pieceListItem[names[i]];
                        close_1[lg] = closeList[i];
                        useMinMax[lg] = i === 2;
                    }
                    interval[lg] == null && (interval[lg] = infinityList[lg]);
                }
                useMinMax[0] && interval[1] === Infinity && (close_1[0] = 0);
                useMinMax[1] && interval[0] === -Infinity && (close_1[1] = 0);
                if (interval[0] === interval[1] && close_1[0] && close_1[1]) // Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
                // we use value to lift the priority when min === max
                item.value = interval[0];
            }
            item.visual = (0, $7b50f502cfd189d5$export$2e2bcd8739ae039).retrieveVisuals(pieceListItem);
            outPieceList.push(item);
        }, this);
        // See "Order Rule".
        $800f031000e0c641$var$normalizeReverse(thisOption, outPieceList);
        // Only pieces
        (0, $cfc1f3b422a3185f$export$12f7386070bc380a)(outPieceList);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(outPieceList, function(piece) {
            var close = piece.close;
            var edgeSymbols = [
                [
                    "<",
                    "\u2264"
                ][close[1]],
                [
                    ">",
                    "\u2265"
                ][close[0]]
            ];
            piece.text = piece.text || this.formatValueText(piece.value != null ? piece.value : piece.interval, false, edgeSymbols);
        }, this);
    }
};
function $800f031000e0c641$var$normalizeReverse(thisOption, pieceList) {
    var inverse = thisOption.inverse;
    if (thisOption.orient === "vertical" ? !inverse : inverse) pieceList.reverse();
}
var $800f031000e0c641$export$2e2bcd8739ae039 = $800f031000e0c641$var$PiecewiseModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $54f263ebb7934a99$var$PiecewiseVisualMapView = /** @class */ function(_super) {
    (0, $73ff38dc46896811$export$a8ba968b8961cb8a)(PiecewiseVisualMapView, _super);
    function PiecewiseVisualMapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PiecewiseVisualMapView.type;
        return _this;
    }
    PiecewiseVisualMapView.prototype.doRender = function() {
        var thisGroup = this.group;
        thisGroup.removeAll();
        var visualMapModel = this.visualMapModel;
        var textGap = visualMapModel.get("textGap");
        var textStyleModel = visualMapModel.textStyleModel;
        var textFont = textStyleModel.getFont();
        var textFill = textStyleModel.getTextColor();
        var itemAlign = this._getItemAlign();
        var itemSize = visualMapModel.itemSize;
        var viewData = this._getViewData();
        var endsText = viewData.endsText;
        var showLabel = $7a1bd9c2710fea0d$export$8a4d17b6e8486e66(visualMapModel.get("showLabel", true), !endsText);
        endsText && this._renderEndsText(thisGroup, endsText[0], itemSize, showLabel, itemAlign);
        $7a1bd9c2710fea0d$export$79b2f7037acddd43(viewData.viewPieceList, function(item) {
            var piece = item.piece;
            var itemGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
            itemGroup.onclick = $7a1bd9c2710fea0d$export$2385a24977818dd0(this._onItemClick, this, piece);
            this._enableHoverLink(itemGroup, item.indexInModelPieceList);
            // TODO Category
            var representValue = visualMapModel.getRepresentValue(piece);
            this._createItemSymbol(itemGroup, representValue, [
                0,
                0,
                itemSize[0],
                itemSize[1]
            ]);
            if (showLabel) {
                var visualState = this.visualMapModel.getValueState(representValue);
                itemGroup.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
                    style: {
                        x: itemAlign === "right" ? -textGap : itemSize[0] + textGap,
                        y: itemSize[1] / 2,
                        text: piece.text,
                        verticalAlign: "middle",
                        align: itemAlign,
                        font: textFont,
                        fill: textFill,
                        opacity: visualState === "outOfRange" ? 0.5 : 1
                    }
                }));
            }
            thisGroup.add(itemGroup);
        }, this);
        endsText && this._renderEndsText(thisGroup, endsText[1], itemSize, showLabel, itemAlign);
        $93b9bc7f22ac7369$export$827f4ee28efc37(visualMapModel.get("orient"), thisGroup, visualMapModel.get("itemGap"));
        this.renderBackground(thisGroup);
        this.positionGroup(thisGroup);
    };
    PiecewiseVisualMapView.prototype._enableHoverLink = function(itemGroup, pieceIndex) {
        var _this = this;
        itemGroup.on("mouseover", function() {
            return onHoverLink("highlight");
        }).on("mouseout", function() {
            return onHoverLink("downplay");
        });
        var onHoverLink = function(method) {
            var visualMapModel = _this.visualMapModel;
            // TODO: TYPE More detailed action types
            visualMapModel.option.hoverLink && _this.api.dispatchAction({
                type: method,
                batch: $1a17eb3ffb707117$export$5381a9dc5427ba18(visualMapModel.findTargetDataIndices(pieceIndex), visualMapModel)
            });
        };
    };
    PiecewiseVisualMapView.prototype._getItemAlign = function() {
        var visualMapModel = this.visualMapModel;
        var modelOption = visualMapModel.option;
        if (modelOption.orient === "vertical") return $1a17eb3ffb707117$export$dca53c4702e35c6(visualMapModel, this.api, visualMapModel.itemSize);
        else {
            // horizontal, most case left unless specifying right.
            var align = modelOption.align;
            if (!align || align === "auto") align = "left";
            return align;
        }
    };
    PiecewiseVisualMapView.prototype._renderEndsText = function(group, text, itemSize, showLabel, itemAlign) {
        if (!text) return;
        var itemGroup = new $7ef7583d8302ffce$export$2e2bcd8739ae039();
        var textStyleModel = this.visualMapModel.textStyleModel;
        itemGroup.add(new $fe885cc21795562b$export$2e2bcd8739ae039({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, {
                x: showLabel ? itemAlign === "right" ? itemSize[0] : 0 : itemSize[0] / 2,
                y: itemSize[1] / 2,
                verticalAlign: "middle",
                align: showLabel ? itemAlign : "center",
                text: text
            })
        }));
        group.add(itemGroup);
    };
    /**
   * @private
   * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
   */ PiecewiseVisualMapView.prototype._getViewData = function() {
        var visualMapModel = this.visualMapModel;
        var viewPieceList = $7a1bd9c2710fea0d$export$871de8747c9eaa88(visualMapModel.getPieceList(), function(piece, index) {
            return {
                piece: piece,
                indexInModelPieceList: index
            };
        });
        var endsText = visualMapModel.get("text");
        // Consider orient and inverse.
        var orient = visualMapModel.get("orient");
        var inverse = visualMapModel.get("inverse");
        // Order of model pieceList is always [low, ..., high]
        if (orient === "horizontal" ? inverse : !inverse) viewPieceList.reverse();
        else if (endsText) endsText = endsText.slice().reverse();
        return {
            viewPieceList: viewPieceList,
            endsText: endsText
        };
    };
    PiecewiseVisualMapView.prototype._createItemSymbol = function(group, representValue, shapeParam) {
        group.add((0, $5370466dadc978d7$export$af050e04da3a02e8)(// symbol will be string
        this.getControllerVisual(representValue, "symbol"), shapeParam[0], shapeParam[1], shapeParam[2], shapeParam[3], // color will be string
        this.getControllerVisual(representValue, "color")));
    };
    PiecewiseVisualMapView.prototype._onItemClick = function(piece) {
        var visualMapModel = this.visualMapModel;
        var option = visualMapModel.option;
        var selectedMode = option.selectedMode;
        if (!selectedMode) return;
        var selected = $7a1bd9c2710fea0d$export$9cd59f9826255e47(option.selected);
        var newKey = visualMapModel.getSelectedMapKey(piece);
        if (selectedMode === "single" || selectedMode === true) {
            selected[newKey] = true;
            $7a1bd9c2710fea0d$export$79b2f7037acddd43(selected, function(o, key) {
                selected[key] = key === newKey;
            });
        } else selected[newKey] = !selected[newKey];
        this.api.dispatchAction({
            type: "selectDataRange",
            from: this.uid,
            visualMapId: this.visualMapModel.id,
            selected: selected
        });
    };
    PiecewiseVisualMapView.type = "visualMap.piecewise";
    return PiecewiseVisualMapView;
}((0, $0eb56f276c16b145$export$2e2bcd8739ae039));
var $54f263ebb7934a99$export$2e2bcd8739ae039 = $54f263ebb7934a99$var$PiecewiseVisualMapView;



function $312d2d640a7c60e1$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $800f031000e0c641$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $54f263ebb7934a99$export$2e2bcd8739ae039));
    (0, $769f929efa66b3be$export$2e2bcd8739ae039)(registers);
}


function $1df0d53aa7db8747$export$4b3e715f166fdd78(registers) {
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $a0f8a196dd8b4cba$export$4b3e715f166fdd78));
    (0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $312d2d640a7c60e1$export$4b3e715f166fdd78));
// Do not install './dataZoomSelect',
// since it only work for toolbox dataZoom.
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO: move labels out of viewport.










function $e10cf2049e185956$var$cloneArr(points) {
    if (points) {
        var newPoints = [];
        for(var i = 0; i < points.length; i++)newPoints.push(points[i].slice());
        return newPoints;
    }
}
function $e10cf2049e185956$var$prepareLayoutCallbackParams(labelItem, hostEl) {
    var label = labelItem.label;
    var labelLine = hostEl && hostEl.getTextGuideLine();
    return {
        dataIndex: labelItem.dataIndex,
        dataType: labelItem.dataType,
        seriesIndex: labelItem.seriesModel.seriesIndex,
        text: labelItem.label.style.text,
        rect: labelItem.hostRect,
        labelRect: labelItem.rect,
        // x: labelAttr.x,
        // y: labelAttr.y,
        align: label.style.align,
        verticalAlign: label.style.verticalAlign,
        labelLinePoints: $e10cf2049e185956$var$cloneArr(labelLine && labelLine.shape.points)
    };
}
var $e10cf2049e185956$var$LABEL_OPTION_TO_STYLE_KEYS = [
    "align",
    "verticalAlign",
    "width",
    "height",
    "fontSize"
];
var $e10cf2049e185956$var$dummyTransformable = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
var $e10cf2049e185956$var$labelLayoutInnerStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
var $e10cf2049e185956$var$labelLineAnimationStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $e10cf2049e185956$var$extendWithKeys(target, source, keys) {
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (source[key] != null) target[key] = source[key];
    }
}
var $e10cf2049e185956$var$LABEL_LAYOUT_PROPS = [
    "x",
    "y",
    "rotation"
];
var $e10cf2049e185956$var$LabelManager = /** @class */ function() {
    function LabelManager() {
        this._labelList = [];
        this._chartViewList = [];
    }
    LabelManager.prototype.clearLabels = function() {
        this._labelList = [];
        this._chartViewList = [];
    };
    /**
   * Add label to manager
   */ LabelManager.prototype._addLabel = function(dataIndex, dataType, seriesModel, label, layoutOption) {
        var labelStyle = label.style;
        var hostEl = label.__hostTarget;
        var textConfig = hostEl.textConfig || {};
        // TODO: If label is in other state.
        var labelTransform = label.getComputedTransform();
        var labelRect = label.getBoundingRect().plain();
        (0, $1bebe7106c895823$export$2e2bcd8739ae039).applyTransform(labelRect, labelRect, labelTransform);
        if (labelTransform) $e10cf2049e185956$var$dummyTransformable.setLocalTransform(labelTransform);
        else {
            // Identity transform.
            $e10cf2049e185956$var$dummyTransformable.x = $e10cf2049e185956$var$dummyTransformable.y = $e10cf2049e185956$var$dummyTransformable.rotation = $e10cf2049e185956$var$dummyTransformable.originX = $e10cf2049e185956$var$dummyTransformable.originY = 0;
            $e10cf2049e185956$var$dummyTransformable.scaleX = $e10cf2049e185956$var$dummyTransformable.scaleY = 1;
        }
        $e10cf2049e185956$var$dummyTransformable.rotation = (0, $b44a8536c7214e4f$export$d44861331f213635)($e10cf2049e185956$var$dummyTransformable.rotation);
        var host = label.__hostTarget;
        var hostRect;
        if (host) {
            hostRect = host.getBoundingRect().plain();
            var transform = host.getComputedTransform();
            (0, $1bebe7106c895823$export$2e2bcd8739ae039).applyTransform(hostRect, hostRect, transform);
        }
        var labelGuide = hostRect && host.getTextGuideLine();
        this._labelList.push({
            label: label,
            labelLine: labelGuide,
            seriesModel: seriesModel,
            dataIndex: dataIndex,
            dataType: dataType,
            layoutOption: layoutOption,
            computedLayoutOption: null,
            rect: labelRect,
            hostRect: hostRect,
            // Label with lower priority will be hidden when overlapped
            // Use rect size as default priority
            priority: hostRect ? hostRect.width * hostRect.height : 0,
            // Save default label attributes.
            // For restore if developers want get back to default value in callback.
            defaultAttr: {
                ignore: label.ignore,
                labelGuideIgnore: labelGuide && labelGuide.ignore,
                x: $e10cf2049e185956$var$dummyTransformable.x,
                y: $e10cf2049e185956$var$dummyTransformable.y,
                scaleX: $e10cf2049e185956$var$dummyTransformable.scaleX,
                scaleY: $e10cf2049e185956$var$dummyTransformable.scaleY,
                rotation: $e10cf2049e185956$var$dummyTransformable.rotation,
                style: {
                    x: labelStyle.x,
                    y: labelStyle.y,
                    align: labelStyle.align,
                    verticalAlign: labelStyle.verticalAlign,
                    width: labelStyle.width,
                    height: labelStyle.height,
                    fontSize: labelStyle.fontSize
                },
                cursor: label.cursor,
                attachedPos: textConfig.position,
                attachedRot: textConfig.rotation
            }
        });
    };
    LabelManager.prototype.addLabelsOfSeries = function(chartView) {
        var _this = this;
        this._chartViewList.push(chartView);
        var seriesModel = chartView.__model;
        var layoutOption = seriesModel.get("labelLayout");
        /**
     * Ignore layouting if it's not specified anything.
     */ if (!((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(layoutOption) || (0, $7a1bd9c2710fea0d$export$ed97f33186d4b816)(layoutOption).length)) return;
        chartView.group.traverse(function(child) {
            if (child.ignore) return true; // Stop traverse descendants.
            // Only support label being hosted on graphic elements.
            var textEl = child.getTextContent();
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(child);
            // Can only attach the text on the element with dataIndex
            if (textEl && !textEl.disableLabelLayout) _this._addLabel(ecData.dataIndex, ecData.dataType, seriesModel, textEl, layoutOption);
        });
    };
    LabelManager.prototype.updateLayoutConfig = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        function createDragHandler(el, labelLineModel) {
            return function() {
                (0, $f4eb87a228be297f$export$cc93ba643cd97d83)(el, labelLineModel);
            };
        }
        for(var i = 0; i < this._labelList.length; i++){
            var labelItem = this._labelList[i];
            var label = labelItem.label;
            var hostEl = label.__hostTarget;
            var defaultLabelAttr = labelItem.defaultAttr;
            var layoutOption = void 0;
            // TODO A global layout option?
            if ((0, $7a1bd9c2710fea0d$export$f6e2535fb5126e54)(labelItem.layoutOption)) layoutOption = labelItem.layoutOption($e10cf2049e185956$var$prepareLayoutCallbackParams(labelItem, hostEl));
            else layoutOption = labelItem.layoutOption;
            layoutOption = layoutOption || {};
            labelItem.computedLayoutOption = layoutOption;
            var degreeToRadian = Math.PI / 180;
            // TODO hostEl should always exists.
            // Or label should not have parent because the x, y is all in global space.
            if (hostEl) hostEl.setTextConfig({
                // Force to set local false.
                local: false,
                // Ignore position and rotation config on the host el if x or y is changed.
                position: layoutOption.x != null || layoutOption.y != null ? null : defaultLabelAttr.attachedPos,
                // Ignore rotation config on the host el if rotation is changed.
                rotation: layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.attachedRot,
                offset: [
                    layoutOption.dx || 0,
                    layoutOption.dy || 0
                ]
            });
            var needsUpdateLabelLine = false;
            if (layoutOption.x != null) {
                // TODO width of chart view.
                label.x = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(layoutOption.x, width);
                label.setStyle("x", 0); // Ignore movement in style. TODO: origin.
                needsUpdateLabelLine = true;
            } else {
                label.x = defaultLabelAttr.x;
                label.setStyle("x", defaultLabelAttr.style.x);
            }
            if (layoutOption.y != null) {
                // TODO height of chart view.
                label.y = (0, $cfc1f3b422a3185f$export$e8514cb5a5e2b40f)(layoutOption.y, height);
                label.setStyle("y", 0); // Ignore movement in style.
                needsUpdateLabelLine = true;
            } else {
                label.y = defaultLabelAttr.y;
                label.setStyle("y", defaultLabelAttr.style.y);
            }
            if (layoutOption.labelLinePoints) {
                var guideLine = hostEl.getTextGuideLine();
                if (guideLine) {
                    guideLine.setShape({
                        points: layoutOption.labelLinePoints
                    });
                    // Not update
                    needsUpdateLabelLine = false;
                }
            }
            var labelLayoutStore = $e10cf2049e185956$var$labelLayoutInnerStore(label);
            labelLayoutStore.needsUpdateLabelLine = needsUpdateLabelLine;
            label.rotation = layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.rotation;
            label.scaleX = defaultLabelAttr.scaleX;
            label.scaleY = defaultLabelAttr.scaleY;
            for(var k = 0; k < $e10cf2049e185956$var$LABEL_OPTION_TO_STYLE_KEYS.length; k++){
                var key = $e10cf2049e185956$var$LABEL_OPTION_TO_STYLE_KEYS[k];
                label.setStyle(key, layoutOption[key] != null ? layoutOption[key] : defaultLabelAttr.style[key]);
            }
            if (layoutOption.draggable) {
                label.draggable = true;
                label.cursor = "move";
                if (hostEl) {
                    var hostModel = labelItem.seriesModel;
                    if (labelItem.dataIndex != null) {
                        var data = labelItem.seriesModel.getData(labelItem.dataType);
                        hostModel = data.getItemModel(labelItem.dataIndex);
                    }
                    label.on("drag", createDragHandler(hostEl, hostModel.getModel("labelLine")));
                }
            } else {
                // TODO Other drag functions?
                label.off("drag");
                label.cursor = defaultLabelAttr.cursor;
            }
        }
    };
    LabelManager.prototype.layout = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        var labelList = (0, $11dac7a73f36cc2c$export$6c403cad1ae3e239)(this._labelList);
        var labelsNeedsAdjustOnX = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(labelList, function(item) {
            return item.layoutOption.moveOverlap === "shiftX";
        });
        var labelsNeedsAdjustOnY = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(labelList, function(item) {
            return item.layoutOption.moveOverlap === "shiftY";
        });
        (0, $11dac7a73f36cc2c$export$b6b2b07f8ed32bd6)(labelsNeedsAdjustOnX, 0, width);
        (0, $11dac7a73f36cc2c$export$118c25e0932528e4)(labelsNeedsAdjustOnY, 0, height);
        var labelsNeedsHideOverlap = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)(labelList, function(item) {
            return item.layoutOption.hideOverlap;
        });
        (0, $11dac7a73f36cc2c$export$8ce774e164a49410)(labelsNeedsHideOverlap);
    };
    /**
   * Process all labels. Not only labels with layoutOption.
   */ LabelManager.prototype.processLabelsOverall = function() {
        var _this = this;
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(this._chartViewList, function(chartView) {
            var seriesModel = chartView.__model;
            var ignoreLabelLineUpdate = chartView.ignoreLabelLineUpdate;
            var animationEnabled = seriesModel.isAnimationEnabled();
            chartView.group.traverse(function(child) {
                if (child.ignore && !child.forceLabelAnimation) return true; // Stop traverse descendants.
                var needsUpdateLabelLine = !ignoreLabelLineUpdate;
                var label = child.getTextContent();
                if (!needsUpdateLabelLine && label) needsUpdateLabelLine = $e10cf2049e185956$var$labelLayoutInnerStore(label).needsUpdateLabelLine;
                if (needsUpdateLabelLine) _this._updateLabelLine(child, seriesModel);
                if (animationEnabled) _this._animateLabels(child, seriesModel);
            });
        });
    };
    LabelManager.prototype._updateLabelLine = function(el, seriesModel) {
        // Only support label being hosted on graphic elements.
        var textEl = el.getTextContent();
        // Update label line style.
        var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
        var dataIndex = ecData.dataIndex;
        // Only support labelLine on the labels represent data.
        if (textEl && dataIndex != null) {
            var data = seriesModel.getData(ecData.dataType);
            var itemModel = data.getItemModel(dataIndex);
            var defaultStyle = {};
            var visualStyle = data.getItemVisual(dataIndex, "style");
            if (visualStyle) {
                var visualType = data.getVisual("drawType");
                // Default to be same with main color
                defaultStyle.stroke = visualStyle[visualType];
            }
            var labelLineModel = itemModel.getModel("labelLine");
            (0, $f4eb87a228be297f$export$c09e0b0574bdd2dc)(el, (0, $f4eb87a228be297f$export$2979fdbf5ebce521)(itemModel), defaultStyle);
            (0, $f4eb87a228be297f$export$cc93ba643cd97d83)(el, labelLineModel);
        }
    };
    LabelManager.prototype._animateLabels = function(el, seriesModel) {
        var textEl = el.getTextContent();
        var guideLine = el.getTextGuideLine();
        // Animate
        if (textEl && (el.forceLabelAnimation || !textEl.ignore && !textEl.invisible && !el.disableLabelAnimation && !(0, $8b353638fbedfefa$export$5b89d4b643713034)(el))) {
            var layoutStore = $e10cf2049e185956$var$labelLayoutInnerStore(textEl);
            var oldLayout = layoutStore.oldLayout;
            var ecData = (0, $b1983a2fffd47d56$export$b1c39b2bacd1ddc2)(el);
            var dataIndex = ecData.dataIndex;
            var newProps = {
                x: textEl.x,
                y: textEl.y,
                rotation: textEl.rotation
            };
            var data = seriesModel.getData(ecData.dataType);
            if (!oldLayout) {
                textEl.attr(newProps);
                // Disable fade in animation if value animation is enabled.
                if (!(0, $6800dfcb6e1e2a44$export$f62786d3261ab0f4)(textEl).valueAnimation) {
                    var oldOpacity = (0, $7a1bd9c2710fea0d$export$995e01f2f5c9d030)(textEl.style.opacity, 1);
                    // Fade in animation
                    textEl.style.opacity = 0;
                    (0, $8b353638fbedfefa$export$a121566aadcfe021)(textEl, {
                        style: {
                            opacity: oldOpacity
                        }
                    }, seriesModel, dataIndex);
                }
            } else {
                textEl.attr(oldLayout);
                // Make sure the animation from is in the right status.
                var prevStates = el.prevStates;
                if (prevStates) {
                    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(prevStates, "select") >= 0) textEl.attr(layoutStore.oldLayoutSelect);
                    if ((0, $7a1bd9c2710fea0d$export$305f7d4e9d4624f2)(prevStates, "emphasis") >= 0) textEl.attr(layoutStore.oldLayoutEmphasis);
                }
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(textEl, newProps, seriesModel, dataIndex);
            }
            layoutStore.oldLayout = newProps;
            if (textEl.states.select) {
                var layoutSelect = layoutStore.oldLayoutSelect = {};
                $e10cf2049e185956$var$extendWithKeys(layoutSelect, newProps, $e10cf2049e185956$var$LABEL_LAYOUT_PROPS);
                $e10cf2049e185956$var$extendWithKeys(layoutSelect, textEl.states.select, $e10cf2049e185956$var$LABEL_LAYOUT_PROPS);
            }
            if (textEl.states.emphasis) {
                var layoutEmphasis = layoutStore.oldLayoutEmphasis = {};
                $e10cf2049e185956$var$extendWithKeys(layoutEmphasis, newProps, $e10cf2049e185956$var$LABEL_LAYOUT_PROPS);
                $e10cf2049e185956$var$extendWithKeys(layoutEmphasis, textEl.states.emphasis, $e10cf2049e185956$var$LABEL_LAYOUT_PROPS);
            }
            (0, $6800dfcb6e1e2a44$export$dd6101605f5c186)(textEl, dataIndex, data, seriesModel, seriesModel);
        }
        if (guideLine && !guideLine.ignore && !guideLine.invisible) {
            var layoutStore = $e10cf2049e185956$var$labelLineAnimationStore(guideLine);
            var oldLayout = layoutStore.oldLayout;
            var newLayout = {
                points: guideLine.shape.points
            };
            if (!oldLayout) {
                guideLine.setShape(newLayout);
                guideLine.style.strokePercent = 0;
                (0, $8b353638fbedfefa$export$a121566aadcfe021)(guideLine, {
                    style: {
                        strokePercent: 1
                    }
                }, seriesModel);
            } else {
                guideLine.attr({
                    shape: oldLayout
                });
                (0, $8b353638fbedfefa$export$c8dce3c08436e91e)(guideLine, {
                    shape: newLayout
                }, seriesModel);
            }
            layoutStore.oldLayout = newLayout;
        }
    };
    return LabelManager;
}();
var $e10cf2049e185956$export$2e2bcd8739ae039 = $e10cf2049e185956$var$LabelManager;


var $de19ea5da3bb8f56$var$getLabelManager = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $de19ea5da3bb8f56$export$5320d1b3745c02a5(registers) {
    registers.registerUpdateLifecycle("series:beforeupdate", function(ecModel, api, params) {
        // TODO api provide an namespace that can save stuff per instance
        var labelManager = $de19ea5da3bb8f56$var$getLabelManager(api).labelManager;
        if (!labelManager) labelManager = $de19ea5da3bb8f56$var$getLabelManager(api).labelManager = new (0, $e10cf2049e185956$export$2e2bcd8739ae039)();
        labelManager.clearLabels();
    });
    registers.registerUpdateLifecycle("series:layoutlabels", function(ecModel, api, params) {
        var labelManager = $de19ea5da3bb8f56$var$getLabelManager(api).labelManager;
        params.updatedSeries.forEach(function(series) {
            labelManager.addLabelsOfSeries(api.getViewOfSeriesModel(series));
        });
        labelManager.updateLayoutConfig(api);
        labelManager.layout(api);
        labelManager.processLabelsOverall();
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Universal transitions that can animate between any shapes(series) and any properties in any amounts.


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 














var $2a60c506580ea7a9$var$CMD = (0, $20ebe2448f123f2e$export$2e2bcd8739ae039).CMD;
function $2a60c506580ea7a9$var$aroundEqual(a, b) {
    return Math.abs(a - b) < 1e-5;
}
function $2a60c506580ea7a9$export$fbc91cffd4bdf629(path) {
    var data = path.data;
    var len = path.len();
    var bezierArrayGroups = [];
    var currentSubpath;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    function createNewSubpath(x, y) {
        if (currentSubpath && currentSubpath.length > 2) bezierArrayGroups.push(currentSubpath);
        currentSubpath = [
            x,
            y
        ];
    }
    function addLine(x0, y0, x1, y1) {
        if (!($2a60c506580ea7a9$var$aroundEqual(x0, x1) && $2a60c506580ea7a9$var$aroundEqual(y0, y1))) currentSubpath.push(x0, y0, x1, y1, x1, y1);
    }
    function addArc(startAngle, endAngle, cx, cy, rx, ry) {
        var delta = Math.abs(endAngle - startAngle);
        var len = Math.tan(delta / 4) * 4 / 3;
        var dir = endAngle < startAngle ? -1 : 1;
        var c1 = Math.cos(startAngle);
        var s1 = Math.sin(startAngle);
        var c2 = Math.cos(endAngle);
        var s2 = Math.sin(endAngle);
        var x1 = c1 * rx + cx;
        var y1 = s1 * ry + cy;
        var x4 = c2 * rx + cx;
        var y4 = s2 * ry + cy;
        var hx = rx * len * dir;
        var hy = ry * len * dir;
        currentSubpath.push(x1 - hx * s1, y1 + hy * c1, x4 + hx * s2, y4 - hy * c2, x4, y4);
    }
    var x1;
    var y1;
    var x2;
    var y2;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
            if (cmd === $2a60c506580ea7a9$var$CMD.L || cmd === $2a60c506580ea7a9$var$CMD.C || cmd === $2a60c506580ea7a9$var$CMD.Q) currentSubpath = [
                x0,
                y0
            ];
        }
        switch(cmd){
            case $2a60c506580ea7a9$var$CMD.M:
                xi = x0 = data[i++];
                yi = y0 = data[i++];
                createNewSubpath(x0, y0);
                break;
            case $2a60c506580ea7a9$var$CMD.L:
                x1 = data[i++];
                y1 = data[i++];
                addLine(xi, yi, x1, y1);
                xi = x1;
                yi = y1;
                break;
            case $2a60c506580ea7a9$var$CMD.C:
                currentSubpath.push(data[i++], data[i++], data[i++], data[i++], xi = data[i++], yi = data[i++]);
                break;
            case $2a60c506580ea7a9$var$CMD.Q:
                x1 = data[i++];
                y1 = data[i++];
                x2 = data[i++];
                y2 = data[i++];
                currentSubpath.push(xi + 2 / 3 * (x1 - xi), yi + 2 / 3 * (y1 - yi), x2 + 2 / 3 * (x1 - x2), y2 + 2 / 3 * (y1 - y2), x2, y2);
                xi = x2;
                yi = y2;
                break;
            case $2a60c506580ea7a9$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var startAngle = data[i++];
                var endAngle = data[i++] + startAngle;
                i += 1;
                var anticlockwise = !data[i++];
                x1 = Math.cos(startAngle) * rx + cx;
                y1 = Math.sin(startAngle) * ry + cy;
                if (isFirst) {
                    x0 = x1;
                    y0 = y1;
                    createNewSubpath(x0, y0);
                } else addLine(xi, yi, x1, y1);
                xi = Math.cos(endAngle) * rx + cx;
                yi = Math.sin(endAngle) * ry + cy;
                var step = (anticlockwise ? -1 : 1) * Math.PI / 2;
                for(var angle = startAngle; anticlockwise ? angle > endAngle : angle < endAngle; angle += step){
                    var nextAngle = anticlockwise ? Math.max(angle + step, endAngle) : Math.min(angle + step, endAngle);
                    addArc(angle, nextAngle, cx, cy, rx, ry);
                }
                break;
            case $2a60c506580ea7a9$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                x1 = x0 + data[i++];
                y1 = y0 + data[i++];
                createNewSubpath(x1, y0);
                addLine(x1, y0, x1, y1);
                addLine(x1, y1, x0, y1);
                addLine(x0, y1, x0, y0);
                addLine(x0, y0, x1, y0);
                break;
            case $2a60c506580ea7a9$var$CMD.Z:
                currentSubpath && addLine(xi, yi, x0, y0);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (currentSubpath && currentSubpath.length > 2) bezierArrayGroups.push(currentSubpath);
    return bezierArrayGroups;
}
function $2a60c506580ea7a9$var$adpativeBezier(x0, y0, x1, y1, x2, y2, x3, y3, out, scale) {
    if ($2a60c506580ea7a9$var$aroundEqual(x0, x1) && $2a60c506580ea7a9$var$aroundEqual(y0, y1) && $2a60c506580ea7a9$var$aroundEqual(x2, x3) && $2a60c506580ea7a9$var$aroundEqual(y2, y3)) {
        out.push(x3, y3);
        return;
    }
    var PIXEL_DISTANCE = 2 / scale;
    var PIXEL_DISTANCE_SQR = PIXEL_DISTANCE * PIXEL_DISTANCE;
    var dx = x3 - x0;
    var dy = y3 - y0;
    var d = Math.sqrt(dx * dx + dy * dy);
    dx /= d;
    dy /= d;
    var dx1 = x1 - x0;
    var dy1 = y1 - y0;
    var dx2 = x2 - x3;
    var dy2 = y2 - y3;
    var cp1LenSqr = dx1 * dx1 + dy1 * dy1;
    var cp2LenSqr = dx2 * dx2 + dy2 * dy2;
    if (cp1LenSqr < PIXEL_DISTANCE_SQR && cp2LenSqr < PIXEL_DISTANCE_SQR) {
        out.push(x3, y3);
        return;
    }
    var projLen1 = dx * dx1 + dy * dy1;
    var projLen2 = -dx * dx2 - dy * dy2;
    var d1Sqr = cp1LenSqr - projLen1 * projLen1;
    var d2Sqr = cp2LenSqr - projLen2 * projLen2;
    if (d1Sqr < PIXEL_DISTANCE_SQR && projLen1 >= 0 && d2Sqr < PIXEL_DISTANCE_SQR && projLen2 >= 0) {
        out.push(x3, y3);
        return;
    }
    var tmpSegX = [];
    var tmpSegY = [];
    (0, $747cfc5611b57cea$export$a2ee23a0567039da)(x0, x1, x2, x3, 0.5, tmpSegX);
    (0, $747cfc5611b57cea$export$a2ee23a0567039da)(y0, y1, y2, y3, 0.5, tmpSegY);
    $2a60c506580ea7a9$var$adpativeBezier(tmpSegX[0], tmpSegY[0], tmpSegX[1], tmpSegY[1], tmpSegX[2], tmpSegY[2], tmpSegX[3], tmpSegY[3], out, scale);
    $2a60c506580ea7a9$var$adpativeBezier(tmpSegX[4], tmpSegY[4], tmpSegX[5], tmpSegY[5], tmpSegX[6], tmpSegY[6], tmpSegX[7], tmpSegY[7], out, scale);
}
function $2a60c506580ea7a9$export$163f4950160f2337(path, scale) {
    var bezierArrayGroups = $2a60c506580ea7a9$export$fbc91cffd4bdf629(path);
    var polygons = [];
    scale = scale || 1;
    for(var i = 0; i < bezierArrayGroups.length; i++){
        var beziers = bezierArrayGroups[i];
        var polygon = [];
        var x0 = beziers[0];
        var y0 = beziers[1];
        polygon.push(x0, y0);
        for(var k = 2; k < beziers.length;){
            var x1 = beziers[k++];
            var y1 = beziers[k++];
            var x2 = beziers[k++];
            var y2 = beziers[k++];
            var x3 = beziers[k++];
            var y3 = beziers[k++];
            $2a60c506580ea7a9$var$adpativeBezier(x0, y0, x1, y1, x2, y2, x3, y3, polygon, scale);
            x0 = x3;
            y0 = y3;
        }
        polygons.push(polygon);
    }
    return polygons;
}



function $640f8b532a910a4f$var$getDividingGrids(dimSize, rowDim, count) {
    var rowSize = dimSize[rowDim];
    var columnSize = dimSize[1 - rowDim];
    var ratio = Math.abs(rowSize / columnSize);
    var rowCount = Math.ceil(Math.sqrt(ratio * count));
    var columnCount = Math.floor(count / rowCount);
    if (columnCount === 0) {
        columnCount = 1;
        rowCount = count;
    }
    var grids = [];
    for(var i = 0; i < rowCount; i++)grids.push(columnCount);
    var currentCount = rowCount * columnCount;
    var remained = count - currentCount;
    if (remained > 0) for(var i = 0; i < remained; i++)grids[i % rowCount] += 1;
    return grids;
}
function $640f8b532a910a4f$var$divideSector(sectorShape, count, outShapes) {
    var r0 = sectorShape.r0;
    var r = sectorShape.r;
    var startAngle = sectorShape.startAngle;
    var endAngle = sectorShape.endAngle;
    var angle = Math.abs(endAngle - startAngle);
    var arcLen = angle * r;
    var deltaR = r - r0;
    var isAngleRow = arcLen > Math.abs(deltaR);
    var grids = $640f8b532a910a4f$var$getDividingGrids([
        arcLen,
        deltaR
    ], isAngleRow ? 0 : 1, count);
    var rowSize = (isAngleRow ? angle : deltaR) / grids.length;
    for(var row = 0; row < grids.length; row++){
        var columnSize = (isAngleRow ? deltaR : angle) / grids[row];
        for(var column = 0; column < grids[row]; column++){
            var newShape = {};
            if (isAngleRow) {
                newShape.startAngle = startAngle + rowSize * row;
                newShape.endAngle = startAngle + rowSize * (row + 1);
                newShape.r0 = r0 + columnSize * column;
                newShape.r = r0 + columnSize * (column + 1);
            } else {
                newShape.startAngle = startAngle + columnSize * column;
                newShape.endAngle = startAngle + columnSize * (column + 1);
                newShape.r0 = r0 + rowSize * row;
                newShape.r = r0 + rowSize * (row + 1);
            }
            newShape.clockwise = sectorShape.clockwise;
            newShape.cx = sectorShape.cx;
            newShape.cy = sectorShape.cy;
            outShapes.push(newShape);
        }
    }
}
function $640f8b532a910a4f$var$divideRect(rectShape, count, outShapes) {
    var width = rectShape.width;
    var height = rectShape.height;
    var isHorizontalRow = width > height;
    var grids = $640f8b532a910a4f$var$getDividingGrids([
        width,
        height
    ], isHorizontalRow ? 0 : 1, count);
    var rowSizeDim = isHorizontalRow ? "width" : "height";
    var columnSizeDim = isHorizontalRow ? "height" : "width";
    var rowDim = isHorizontalRow ? "x" : "y";
    var columnDim = isHorizontalRow ? "y" : "x";
    var rowSize = rectShape[rowSizeDim] / grids.length;
    for(var row = 0; row < grids.length; row++){
        var columnSize = rectShape[columnSizeDim] / grids[row];
        for(var column = 0; column < grids[row]; column++){
            var newShape = {};
            newShape[rowDim] = row * rowSize;
            newShape[columnDim] = column * columnSize;
            newShape[rowSizeDim] = rowSize;
            newShape[columnSizeDim] = columnSize;
            newShape.x += rectShape.x;
            newShape.y += rectShape.y;
            outShapes.push(newShape);
        }
    }
}
function $640f8b532a910a4f$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $640f8b532a910a4f$var$lineLineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y;
    var nmCrossProduct = $640f8b532a910a4f$var$crossProduct2d(nx, ny, mx, my);
    if (Math.abs(nmCrossProduct) < 1e-6) return null;
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var p = $640f8b532a910a4f$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return null;
    return new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)(p * mx + a1x, p * my + a1y);
}
function $640f8b532a910a4f$var$projPtOnLine(pt, lineA, lineB) {
    var dir = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub(dir, lineB, lineA);
    dir.normalize();
    var dir2 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    (0, $b887f038f104fe7e$export$2e2bcd8739ae039).sub(dir2, pt, lineA);
    var len = dir2.dot(dir);
    return len;
}
function $640f8b532a910a4f$var$addToPoly(poly, pt) {
    var last = poly[poly.length - 1];
    if (last && last[0] === pt[0] && last[1] === pt[1]) return;
    poly.push(pt);
}
function $640f8b532a910a4f$var$splitPolygonByLine(points, lineA, lineB) {
    var len = points.length;
    var intersections = [];
    for(var i = 0; i < len; i++){
        var p0 = points[i];
        var p1 = points[(i + 1) % len];
        var intersectionPt = $640f8b532a910a4f$var$lineLineIntersect(p0[0], p0[1], p1[0], p1[1], lineA.x, lineA.y, lineB.x, lineB.y);
        if (intersectionPt) intersections.push({
            projPt: $640f8b532a910a4f$var$projPtOnLine(intersectionPt, lineA, lineB),
            pt: intersectionPt,
            idx: i
        });
    }
    if (intersections.length < 2) return [
        {
            points: points
        },
        {
            points: points
        }
    ];
    intersections.sort(function(a, b) {
        return a.projPt - b.projPt;
    });
    var splitPt0 = intersections[0];
    var splitPt1 = intersections[intersections.length - 1];
    if (splitPt1.idx < splitPt0.idx) {
        var tmp = splitPt0;
        splitPt0 = splitPt1;
        splitPt1 = tmp;
    }
    var splitPt0Arr = [
        splitPt0.pt.x,
        splitPt0.pt.y
    ];
    var splitPt1Arr = [
        splitPt1.pt.x,
        splitPt1.pt.y
    ];
    var newPolyA = [
        splitPt0Arr
    ];
    var newPolyB = [
        splitPt1Arr
    ];
    for(var i = splitPt0.idx + 1; i <= splitPt1.idx; i++)$640f8b532a910a4f$var$addToPoly(newPolyA, points[i].slice());
    $640f8b532a910a4f$var$addToPoly(newPolyA, splitPt1Arr);
    $640f8b532a910a4f$var$addToPoly(newPolyA, splitPt0Arr);
    for(var i = splitPt1.idx + 1; i <= splitPt0.idx + len; i++)$640f8b532a910a4f$var$addToPoly(newPolyB, points[i % len].slice());
    $640f8b532a910a4f$var$addToPoly(newPolyB, splitPt0Arr);
    $640f8b532a910a4f$var$addToPoly(newPolyB, splitPt1Arr);
    return [
        {
            points: newPolyA
        },
        {
            points: newPolyB
        }
    ];
}
function $640f8b532a910a4f$var$binaryDividePolygon(polygonShape) {
    var points = polygonShape.points;
    var min = [];
    var max = [];
    (0, $af3aab2435198f82$export$188c3cd07b4129dd)(points, min, max);
    var boundingRect = new (0, $1bebe7106c895823$export$2e2bcd8739ae039)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
    var width = boundingRect.width;
    var height = boundingRect.height;
    var x = boundingRect.x;
    var y = boundingRect.y;
    var pt0 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    var pt1 = new (0, $b887f038f104fe7e$export$2e2bcd8739ae039)();
    if (width > height) {
        pt0.x = pt1.x = x + width / 2;
        pt0.y = y;
        pt1.y = y + height;
    } else {
        pt0.y = pt1.y = y + height / 2;
        pt0.x = x;
        pt1.x = x + width;
    }
    return $640f8b532a910a4f$var$splitPolygonByLine(points, pt0, pt1);
}
function $640f8b532a910a4f$var$binaryDivideRecursive(divider, shape, count, out) {
    if (count === 1) out.push(shape);
    else {
        var mid = Math.floor(count / 2);
        var sub = divider(shape);
        $640f8b532a910a4f$var$binaryDivideRecursive(divider, sub[0], mid, out);
        $640f8b532a910a4f$var$binaryDivideRecursive(divider, sub[1], count - mid, out);
    }
    return out;
}
function $640f8b532a910a4f$export$9cd59f9826255e47(path, count) {
    var paths = [];
    for(var i = 0; i < count; i++)paths.push((0, $15b38920672b9006$export$18711d956bf1c3eb)(path));
    return paths;
}
function $640f8b532a910a4f$var$copyPathProps(source, target) {
    target.setStyle(source.style);
    target.z = source.z;
    target.z2 = source.z2;
    target.zlevel = source.zlevel;
}
function $640f8b532a910a4f$var$polygonConvert(points) {
    var out = [];
    for(var i = 0; i < points.length;)out.push([
        points[i++],
        points[i++]
    ]);
    return out;
}
function $640f8b532a910a4f$export$65980d18b75784e2(path, count) {
    var outShapes = [];
    var shape = path.shape;
    var OutShapeCtor;
    switch(path.type){
        case "rect":
            $640f8b532a910a4f$var$divideRect(shape, count, outShapes);
            OutShapeCtor = (0, $419e5ff2f303755e$export$2e2bcd8739ae039);
            break;
        case "sector":
            $640f8b532a910a4f$var$divideSector(shape, count, outShapes);
            OutShapeCtor = (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039);
            break;
        case "circle":
            $640f8b532a910a4f$var$divideSector({
                r0: 0,
                r: shape.r,
                startAngle: 0,
                endAngle: Math.PI * 2,
                cx: shape.cx,
                cy: shape.cy
            }, count, outShapes);
            OutShapeCtor = (0, $a3e1dec0a3875b49$export$2e2bcd8739ae039);
            break;
        default:
            var m = path.getComputedTransform();
            var scale = m ? Math.sqrt(Math.max(m[0] * m[0] + m[1] * m[1], m[2] * m[2] + m[3] * m[3])) : 1;
            var polygons = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)((0, $2a60c506580ea7a9$export$163f4950160f2337)(path.getUpdatedPathProxy(), scale), function(poly) {
                return $640f8b532a910a4f$var$polygonConvert(poly);
            });
            var polygonCount = polygons.length;
            if (polygonCount === 0) $640f8b532a910a4f$var$binaryDivideRecursive($640f8b532a910a4f$var$binaryDividePolygon, {
                points: polygons[0]
            }, count, outShapes);
            else if (polygonCount === count) for(var i = 0; i < polygonCount; i++)outShapes.push({
                points: polygons[i]
            });
            else {
                var totalArea_1 = 0;
                var items = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(polygons, function(poly) {
                    var min = [];
                    var max = [];
                    (0, $af3aab2435198f82$export$188c3cd07b4129dd)(poly, min, max);
                    var area = (max[1] - min[1]) * (max[0] - min[0]);
                    totalArea_1 += area;
                    return {
                        poly: poly,
                        area: area
                    };
                });
                items.sort(function(a, b) {
                    return b.area - a.area;
                });
                var left = count;
                for(var i = 0; i < polygonCount; i++){
                    var item = items[i];
                    if (left <= 0) break;
                    var selfCount = i === polygonCount - 1 ? left : Math.ceil(item.area / totalArea_1 * count);
                    if (selfCount < 0) continue;
                    $640f8b532a910a4f$var$binaryDivideRecursive($640f8b532a910a4f$var$binaryDividePolygon, {
                        points: item.poly
                    }, selfCount, outShapes);
                    left -= selfCount;
                }
            }
            OutShapeCtor = (0, $51acf033123e1a30$export$2e2bcd8739ae039);
            break;
    }
    if (!OutShapeCtor) return $640f8b532a910a4f$export$9cd59f9826255e47(path, count);
    var out = [];
    for(var i = 0; i < outShapes.length; i++){
        var subPath = new OutShapeCtor();
        subPath.setShape(outShapes[i]);
        $640f8b532a910a4f$var$copyPathProps(path, subPath);
        out.push(subPath);
    }
    return out;
}



function $2ef03ef3a2bb366a$var$alignSubpath(subpath1, subpath2) {
    var len1 = subpath1.length;
    var len2 = subpath2.length;
    if (len1 === len2) return [
        subpath1,
        subpath2
    ];
    var tmpSegX = [];
    var tmpSegY = [];
    var shorterPath = len1 < len2 ? subpath1 : subpath2;
    var shorterLen = Math.min(len1, len2);
    var diff = Math.abs(len2 - len1) / 6;
    var shorterBezierCount = (shorterLen - 2) / 6;
    var eachCurveSubDivCount = Math.ceil(diff / shorterBezierCount) + 1;
    var newSubpath = [
        shorterPath[0],
        shorterPath[1]
    ];
    var remained = diff;
    for(var i = 2; i < shorterLen;){
        var x0 = shorterPath[i - 2];
        var y0 = shorterPath[i - 1];
        var x1 = shorterPath[i++];
        var y1 = shorterPath[i++];
        var x2 = shorterPath[i++];
        var y2 = shorterPath[i++];
        var x3 = shorterPath[i++];
        var y3 = shorterPath[i++];
        if (remained <= 0) {
            newSubpath.push(x1, y1, x2, y2, x3, y3);
            continue;
        }
        var actualSubDivCount = Math.min(remained, eachCurveSubDivCount - 1) + 1;
        for(var k = 1; k <= actualSubDivCount; k++){
            var p = k / actualSubDivCount;
            (0, $747cfc5611b57cea$export$a2ee23a0567039da)(x0, x1, x2, x3, p, tmpSegX);
            (0, $747cfc5611b57cea$export$a2ee23a0567039da)(y0, y1, y2, y3, p, tmpSegY);
            x0 = tmpSegX[3];
            y0 = tmpSegY[3];
            newSubpath.push(tmpSegX[1], tmpSegY[1], tmpSegX[2], tmpSegY[2], x0, y0);
            x1 = tmpSegX[5];
            y1 = tmpSegY[5];
            x2 = tmpSegX[6];
            y2 = tmpSegY[6];
        }
        remained -= actualSubDivCount - 1;
    }
    return shorterPath === subpath1 ? [
        newSubpath,
        subpath2
    ] : [
        subpath1,
        newSubpath
    ];
}
function $2ef03ef3a2bb366a$var$createSubpath(lastSubpathSubpath, otherSubpath) {
    var len = lastSubpathSubpath.length;
    var lastX = lastSubpathSubpath[len - 2];
    var lastY = lastSubpathSubpath[len - 1];
    var newSubpath = [];
    for(var i = 0; i < otherSubpath.length;){
        newSubpath[i++] = lastX;
        newSubpath[i++] = lastY;
    }
    return newSubpath;
}
function $2ef03ef3a2bb366a$export$d7b853a0ab412a07(array1, array2) {
    var _a;
    var lastSubpath1;
    var lastSubpath2;
    var newArray1 = [];
    var newArray2 = [];
    for(var i = 0; i < Math.max(array1.length, array2.length); i++){
        var subpath1 = array1[i];
        var subpath2 = array2[i];
        var newSubpath1 = void 0;
        var newSubpath2 = void 0;
        if (!subpath1) {
            newSubpath1 = $2ef03ef3a2bb366a$var$createSubpath(lastSubpath1 || subpath2, subpath2);
            newSubpath2 = subpath2;
        } else if (!subpath2) {
            newSubpath2 = $2ef03ef3a2bb366a$var$createSubpath(lastSubpath2 || subpath1, subpath1);
            newSubpath1 = subpath1;
        } else {
            _a = $2ef03ef3a2bb366a$var$alignSubpath(subpath1, subpath2), newSubpath1 = _a[0], newSubpath2 = _a[1];
            lastSubpath1 = newSubpath1;
            lastSubpath2 = newSubpath2;
        }
        newArray1.push(newSubpath1);
        newArray2.push(newSubpath2);
    }
    return [
        newArray1,
        newArray2
    ];
}
function $2ef03ef3a2bb366a$export$e2a20c553f6c85ce(array) {
    var signedArea = 0;
    var cx = 0;
    var cy = 0;
    var len = array.length;
    for(var i = 0, j = len - 2; i < len; j = i, i += 2){
        var x0 = array[j];
        var y0 = array[j + 1];
        var x1 = array[i];
        var y1 = array[i + 1];
        var a = x0 * y1 - x1 * y0;
        signedArea += a;
        cx += (x0 + x1) * a;
        cy += (y0 + y1) * a;
    }
    if (signedArea === 0) return [
        array[0] || 0,
        array[1] || 0
    ];
    return [
        cx / signedArea / 3,
        cy / signedArea / 3,
        signedArea
    ];
}
function $2ef03ef3a2bb366a$var$findBestRingOffset(fromSubBeziers, toSubBeziers, fromCp, toCp) {
    var bezierCount = (fromSubBeziers.length - 2) / 6;
    var bestScore = Infinity;
    var bestOffset = 0;
    var len = fromSubBeziers.length;
    var len2 = len - 2;
    for(var offset = 0; offset < bezierCount; offset++){
        var cursorOffset = offset * 6;
        var score = 0;
        for(var k = 0; k < len; k += 2){
            var idx = k === 0 ? cursorOffset : (cursorOffset + k - 2) % len2 + 2;
            var x0 = fromSubBeziers[idx] - fromCp[0];
            var y0 = fromSubBeziers[idx + 1] - fromCp[1];
            var x1 = toSubBeziers[k] - toCp[0];
            var y1 = toSubBeziers[k + 1] - toCp[1];
            var dx = x1 - x0;
            var dy = y1 - y0;
            score += dx * dx + dy * dy;
        }
        if (score < bestScore) {
            bestScore = score;
            bestOffset = offset;
        }
    }
    return bestOffset;
}
function $2ef03ef3a2bb366a$var$reverse(array) {
    var newArr = [];
    var len = array.length;
    for(var i = 0; i < len; i += 2){
        newArr[i] = array[len - i - 2];
        newArr[i + 1] = array[len - i - 1];
    }
    return newArr;
}
function $2ef03ef3a2bb366a$var$findBestMorphingRotation(fromArr, toArr, searchAngleIteration, searchAngleRange) {
    var result = [];
    var fromNeedsReverse;
    for(var i = 0; i < fromArr.length; i++){
        var fromSubpathBezier = fromArr[i];
        var toSubpathBezier = toArr[i];
        var fromCp = $2ef03ef3a2bb366a$export$e2a20c553f6c85ce(fromSubpathBezier);
        var toCp = $2ef03ef3a2bb366a$export$e2a20c553f6c85ce(toSubpathBezier);
        if (fromNeedsReverse == null) fromNeedsReverse = fromCp[2] < 0 !== toCp[2] < 0;
        var newFromSubpathBezier = [];
        var newToSubpathBezier = [];
        var bestAngle = 0;
        var bestScore = Infinity;
        var tmpArr = [];
        var len = fromSubpathBezier.length;
        if (fromNeedsReverse) fromSubpathBezier = $2ef03ef3a2bb366a$var$reverse(fromSubpathBezier);
        var offset = $2ef03ef3a2bb366a$var$findBestRingOffset(fromSubpathBezier, toSubpathBezier, fromCp, toCp) * 6;
        var len2 = len - 2;
        for(var k = 0; k < len2; k += 2){
            var idx = (offset + k) % len2 + 2;
            newFromSubpathBezier[k + 2] = fromSubpathBezier[idx] - fromCp[0];
            newFromSubpathBezier[k + 3] = fromSubpathBezier[idx + 1] - fromCp[1];
        }
        newFromSubpathBezier[0] = fromSubpathBezier[offset] - fromCp[0];
        newFromSubpathBezier[1] = fromSubpathBezier[offset + 1] - fromCp[1];
        if (searchAngleIteration > 0) {
            var step = searchAngleRange / searchAngleIteration;
            for(var angle = -searchAngleRange / 2; angle <= searchAngleRange / 2; angle += step){
                var sa = Math.sin(angle);
                var ca = Math.cos(angle);
                var score = 0;
                for(var k = 0; k < fromSubpathBezier.length; k += 2){
                    var x0 = newFromSubpathBezier[k];
                    var y0 = newFromSubpathBezier[k + 1];
                    var x1 = toSubpathBezier[k] - toCp[0];
                    var y1 = toSubpathBezier[k + 1] - toCp[1];
                    var newX1 = x1 * ca - y1 * sa;
                    var newY1 = x1 * sa + y1 * ca;
                    tmpArr[k] = newX1;
                    tmpArr[k + 1] = newY1;
                    var dx = newX1 - x0;
                    var dy = newY1 - y0;
                    score += dx * dx + dy * dy;
                }
                if (score < bestScore) {
                    bestScore = score;
                    bestAngle = angle;
                    for(var m = 0; m < tmpArr.length; m++)newToSubpathBezier[m] = tmpArr[m];
                }
            }
        } else for(var i_1 = 0; i_1 < len; i_1 += 2){
            newToSubpathBezier[i_1] = toSubpathBezier[i_1] - toCp[0];
            newToSubpathBezier[i_1 + 1] = toSubpathBezier[i_1 + 1] - toCp[1];
        }
        result.push({
            from: newFromSubpathBezier,
            to: newToSubpathBezier,
            fromCp: fromCp,
            toCp: toCp,
            rotation: -bestAngle
        });
    }
    return result;
}
function $2ef03ef3a2bb366a$export$f9f720a01590a46f(path) {
    return path.__isCombineMorphing;
}
function $2ef03ef3a2bb366a$export$ddee3124b756354f(el) {
    return el.__morphT >= 0;
}
var $2ef03ef3a2bb366a$var$SAVED_METHOD_PREFIX = "__mOriginal_";
function $2ef03ef3a2bb366a$var$saveAndModifyMethod(obj, methodName, modifiers) {
    var savedMethodName = $2ef03ef3a2bb366a$var$SAVED_METHOD_PREFIX + methodName;
    var originalMethod = obj[savedMethodName] || obj[methodName];
    if (!obj[savedMethodName]) obj[savedMethodName] = obj[methodName];
    var replace = modifiers.replace;
    var after = modifiers.after;
    var before = modifiers.before;
    obj[methodName] = function() {
        var args = arguments;
        var res;
        before && before.apply(this, args);
        if (replace) res = replace.apply(this, args);
        else res = originalMethod.apply(this, args);
        after && after.apply(this, args);
        return res;
    };
}
function $2ef03ef3a2bb366a$var$restoreMethod(obj, methodName) {
    var savedMethodName = $2ef03ef3a2bb366a$var$SAVED_METHOD_PREFIX + methodName;
    if (obj[savedMethodName]) {
        obj[methodName] = obj[savedMethodName];
        obj[savedMethodName] = null;
    }
}
function $2ef03ef3a2bb366a$var$applyTransformOnBeziers(bezierCurves, mm) {
    for(var i = 0; i < bezierCurves.length; i++){
        var subBeziers = bezierCurves[i];
        for(var k = 0; k < subBeziers.length;){
            var x = subBeziers[k];
            var y = subBeziers[k + 1];
            subBeziers[k++] = mm[0] * x + mm[2] * y + mm[4];
            subBeziers[k++] = mm[1] * x + mm[3] * y + mm[5];
        }
    }
}
function $2ef03ef3a2bb366a$var$prepareMorphPath(fromPath, toPath) {
    var fromPathProxy = fromPath.getUpdatedPathProxy();
    var toPathProxy = toPath.getUpdatedPathProxy();
    var _a = $2ef03ef3a2bb366a$export$d7b853a0ab412a07((0, $2a60c506580ea7a9$export$fbc91cffd4bdf629)(fromPathProxy), (0, $2a60c506580ea7a9$export$fbc91cffd4bdf629)(toPathProxy)), fromBezierCurves = _a[0], toBezierCurves = _a[1];
    var fromPathTransform = fromPath.getComputedTransform();
    var toPathTransform = toPath.getComputedTransform();
    function updateIdentityTransform() {
        this.transform = null;
    }
    fromPathTransform && $2ef03ef3a2bb366a$var$applyTransformOnBeziers(fromBezierCurves, fromPathTransform);
    toPathTransform && $2ef03ef3a2bb366a$var$applyTransformOnBeziers(toBezierCurves, toPathTransform);
    $2ef03ef3a2bb366a$var$saveAndModifyMethod(toPath, "updateTransform", {
        replace: updateIdentityTransform
    });
    toPath.transform = null;
    var morphingData = $2ef03ef3a2bb366a$var$findBestMorphingRotation(fromBezierCurves, toBezierCurves, 10, Math.PI);
    var tmpArr = [];
    $2ef03ef3a2bb366a$var$saveAndModifyMethod(toPath, "buildPath", {
        replace: function(path) {
            var t = toPath.__morphT;
            var onet = 1 - t;
            var newCp = [];
            for(var i = 0; i < morphingData.length; i++){
                var item = morphingData[i];
                var from = item.from;
                var to = item.to;
                var angle = item.rotation * t;
                var fromCp = item.fromCp;
                var toCp = item.toCp;
                var sa = Math.sin(angle);
                var ca = Math.cos(angle);
                (0, $6de594cf8ac295ff$export$3a89f8d6f6bf6c9f)(newCp, fromCp, toCp, t);
                for(var m = 0; m < from.length; m += 2){
                    var x0_1 = from[m];
                    var y0_1 = from[m + 1];
                    var x1 = to[m];
                    var y1 = to[m + 1];
                    var x = x0_1 * onet + x1 * t;
                    var y = y0_1 * onet + y1 * t;
                    tmpArr[m] = x * ca - y * sa + newCp[0];
                    tmpArr[m + 1] = x * sa + y * ca + newCp[1];
                }
                var x0 = tmpArr[0];
                var y0 = tmpArr[1];
                path.moveTo(x0, y0);
                for(var m = 2; m < from.length;){
                    var x1 = tmpArr[m++];
                    var y1 = tmpArr[m++];
                    var x2 = tmpArr[m++];
                    var y2 = tmpArr[m++];
                    var x3 = tmpArr[m++];
                    var y3 = tmpArr[m++];
                    if (x0 === x1 && y0 === y1 && x2 === x3 && y2 === y3) path.lineTo(x3, y3);
                    else path.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    x0 = x3;
                    y0 = y3;
                }
            }
        }
    });
}
function $2ef03ef3a2bb366a$export$7174e282c1c7df1c(fromPath, toPath, animationOpts) {
    if (!fromPath || !toPath) return toPath;
    var oldDone = animationOpts.done;
    var oldDuring = animationOpts.during;
    $2ef03ef3a2bb366a$var$prepareMorphPath(fromPath, toPath);
    toPath.__morphT = 0;
    function restoreToPath() {
        $2ef03ef3a2bb366a$var$restoreMethod(toPath, "buildPath");
        $2ef03ef3a2bb366a$var$restoreMethod(toPath, "updateTransform");
        toPath.__morphT = -1;
        toPath.createPathProxy();
        toPath.dirtyShape();
    }
    toPath.animateTo({
        __morphT: 1
    }, (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
        during: function(p) {
            toPath.dirtyShape();
            oldDuring && oldDuring(p);
        },
        done: function() {
            restoreToPath();
            oldDone && oldDone();
        }
    }, animationOpts));
    return toPath;
}
function $2ef03ef3a2bb366a$var$hilbert(x, y, minX, minY, maxX, maxY) {
    var bits = 16;
    x = maxX === minX ? 0 : Math.round(32767 * (x - minX) / (maxX - minX));
    y = maxY === minY ? 0 : Math.round(32767 * (y - minY) / (maxY - minY));
    var d = 0;
    var tmp;
    for(var s = (1 << bits) / 2; s > 0; s /= 2){
        var rx = 0;
        var ry = 0;
        if ((x & s) > 0) rx = 1;
        if ((y & s) > 0) ry = 1;
        d += s * s * (3 * rx ^ ry);
        if (ry === 0) {
            if (rx === 1) {
                x = s - 1 - x;
                y = s - 1 - y;
            }
            tmp = x;
            x = y;
            y = tmp;
        }
    }
    return d;
}
function $2ef03ef3a2bb366a$var$sortPaths(pathList) {
    var xMin = Infinity;
    var yMin = Infinity;
    var xMax = -Infinity;
    var yMax = -Infinity;
    var cps = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(pathList, function(path) {
        var rect = path.getBoundingRect();
        var m = path.getComputedTransform();
        var x = rect.x + rect.width / 2 + (m ? m[4] : 0);
        var y = rect.y + rect.height / 2 + (m ? m[5] : 0);
        xMin = Math.min(x, xMin);
        yMin = Math.min(y, yMin);
        xMax = Math.max(x, xMax);
        yMax = Math.max(y, yMax);
        return [
            x,
            y
        ];
    });
    var items = (0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(cps, function(cp, idx) {
        return {
            cp: cp,
            z: $2ef03ef3a2bb366a$var$hilbert(cp[0], cp[1], xMin, yMin, xMax, yMax),
            path: pathList[idx]
        };
    });
    return items.sort(function(a, b) {
        return a.z - b.z;
    }).map(function(item) {
        return item.path;
    });
}
function $2ef03ef3a2bb366a$var$defaultDividePath(param) {
    return (0, $640f8b532a910a4f$export$65980d18b75784e2)(param.path, param.count);
}
function $2ef03ef3a2bb366a$var$createEmptyReturn() {
    return {
        fromIndividuals: [],
        toIndividuals: [],
        count: 0
    };
}
function $2ef03ef3a2bb366a$export$57d3bac3565fd555(fromList, toPath, animationOpts) {
    var fromPathList = [];
    function addFromPath(fromList) {
        for(var i = 0; i < fromList.length; i++){
            var from = fromList[i];
            if ($2ef03ef3a2bb366a$export$f9f720a01590a46f(from)) addFromPath(from.childrenRef());
            else if (from instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) fromPathList.push(from);
        }
    }
    addFromPath(fromList);
    var separateCount = fromPathList.length;
    if (!separateCount) return $2ef03ef3a2bb366a$var$createEmptyReturn();
    var dividePath = animationOpts.dividePath || $2ef03ef3a2bb366a$var$defaultDividePath;
    var toSubPathList = dividePath({
        path: toPath,
        count: separateCount
    });
    if (toSubPathList.length !== separateCount) {
        console.error("Invalid morphing: unmatched splitted path");
        return $2ef03ef3a2bb366a$var$createEmptyReturn();
    }
    fromPathList = $2ef03ef3a2bb366a$var$sortPaths(fromPathList);
    toSubPathList = $2ef03ef3a2bb366a$var$sortPaths(toSubPathList);
    var oldDone = animationOpts.done;
    var oldDuring = animationOpts.during;
    var individualDelay = animationOpts.individualDelay;
    var identityTransform = new (0, $becf2d727f9cf450$export$2e2bcd8739ae039)();
    for(var i = 0; i < separateCount; i++){
        var from = fromPathList[i];
        var to = toSubPathList[i];
        to.parent = toPath;
        to.copyTransform(identityTransform);
        if (!individualDelay) $2ef03ef3a2bb366a$var$prepareMorphPath(from, to);
    }
    toPath.__isCombineMorphing = true;
    toPath.childrenRef = function() {
        return toSubPathList;
    };
    function addToSubPathListToZr(zr) {
        for(var i = 0; i < toSubPathList.length; i++)toSubPathList[i].addSelfToZr(zr);
    }
    $2ef03ef3a2bb366a$var$saveAndModifyMethod(toPath, "addSelfToZr", {
        after: function(zr) {
            addToSubPathListToZr(zr);
        }
    });
    $2ef03ef3a2bb366a$var$saveAndModifyMethod(toPath, "removeSelfFromZr", {
        after: function(zr) {
            for(var i = 0; i < toSubPathList.length; i++)toSubPathList[i].removeSelfFromZr(zr);
        }
    });
    function restoreToPath() {
        toPath.__isCombineMorphing = false;
        toPath.__morphT = -1;
        toPath.childrenRef = null;
        $2ef03ef3a2bb366a$var$restoreMethod(toPath, "addSelfToZr");
        $2ef03ef3a2bb366a$var$restoreMethod(toPath, "removeSelfFromZr");
    }
    var toLen = toSubPathList.length;
    if (individualDelay) {
        var animating_1 = toLen;
        var eachDone = function() {
            animating_1--;
            if (animating_1 === 0) {
                restoreToPath();
                oldDone && oldDone();
            }
        };
        for(var i = 0; i < toLen; i++){
            var indivdualAnimationOpts = individualDelay ? (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                delay: (animationOpts.delay || 0) + individualDelay(i, toLen, fromPathList[i], toSubPathList[i]),
                done: eachDone
            }, animationOpts) : animationOpts;
            $2ef03ef3a2bb366a$export$7174e282c1c7df1c(fromPathList[i], toSubPathList[i], indivdualAnimationOpts);
        }
    } else {
        toPath.__morphT = 0;
        toPath.animateTo({
            __morphT: 1
        }, (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            during: function(p) {
                for(var i = 0; i < toLen; i++){
                    var child = toSubPathList[i];
                    child.__morphT = toPath.__morphT;
                    child.dirtyShape();
                }
                oldDuring && oldDuring(p);
            },
            done: function() {
                restoreToPath();
                for(var i = 0; i < fromList.length; i++)$2ef03ef3a2bb366a$var$restoreMethod(fromList[i], "updateTransform");
                oldDone && oldDone();
            }
        }, animationOpts));
    }
    if (toPath.__zr) addToSubPathListToZr(toPath.__zr);
    return {
        fromIndividuals: fromPathList,
        toIndividuals: toSubPathList,
        count: toLen
    };
}
function $2ef03ef3a2bb366a$export$b6ed198024fe6db8(fromPath, toPathList, animationOpts) {
    var toLen = toPathList.length;
    var fromPathList = [];
    var dividePath = animationOpts.dividePath || $2ef03ef3a2bb366a$var$defaultDividePath;
    function addFromPath(fromList) {
        for(var i = 0; i < fromList.length; i++){
            var from = fromList[i];
            if ($2ef03ef3a2bb366a$export$f9f720a01590a46f(from)) addFromPath(from.childrenRef());
            else if (from instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) fromPathList.push(from);
        }
    }
    if ($2ef03ef3a2bb366a$export$f9f720a01590a46f(fromPath)) {
        addFromPath(fromPath.childrenRef());
        var fromLen = fromPathList.length;
        if (fromLen < toLen) {
            var k = 0;
            for(var i = fromLen; i < toLen; i++)fromPathList.push((0, $15b38920672b9006$export$18711d956bf1c3eb)(fromPathList[k++ % fromLen]));
        }
        fromPathList.length = toLen;
    } else {
        fromPathList = dividePath({
            path: fromPath,
            count: toLen
        });
        var fromPathTransform = fromPath.getComputedTransform();
        for(var i = 0; i < fromPathList.length; i++)fromPathList[i].setLocalTransform(fromPathTransform);
        if (fromPathList.length !== toLen) {
            console.error("Invalid morphing: unmatched splitted path");
            return $2ef03ef3a2bb366a$var$createEmptyReturn();
        }
    }
    fromPathList = $2ef03ef3a2bb366a$var$sortPaths(fromPathList);
    toPathList = $2ef03ef3a2bb366a$var$sortPaths(toPathList);
    var individualDelay = animationOpts.individualDelay;
    for(var i = 0; i < toLen; i++){
        var indivdualAnimationOpts = individualDelay ? (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
            delay: (animationOpts.delay || 0) + individualDelay(i, toLen, fromPathList[i], toPathList[i])
        }, animationOpts) : animationOpts;
        $2ef03ef3a2bb366a$export$7174e282c1c7df1c(fromPathList[i], toPathList[i], indivdualAnimationOpts);
    }
    return {
        fromIndividuals: fromPathList,
        toIndividuals: toPathList,
        count: toPathList.length
    };
}






function $2a0c51260032b767$var$isMultiple(elements) {
    return (0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(elements[0]);
}
function $2a0c51260032b767$var$prepareMorphBatches(one, many) {
    var batches = [];
    var batchCount = one.length;
    for(var i = 0; i < batchCount; i++)batches.push({
        one: one[i],
        many: []
    });
    for(var i = 0; i < many.length; i++){
        var len = many[i].length;
        var k = void 0;
        for(k = 0; k < len; k++)batches[k % batchCount].many.push(many[i][k]);
    }
    var off = 0;
    // If one has more paths than each one of many. average them.
    for(var i = batchCount - 1; i >= 0; i--)if (!batches[i].many.length) {
        var moveFrom = batches[off].many;
        if (moveFrom.length <= 1) {
            // Not enough
            // Start from the first one.
            if (off) off = 0;
            else return batches;
        }
        var len = moveFrom.length;
        var mid = Math.ceil(len / 2);
        batches[i].many = moveFrom.slice(mid, len);
        batches[off].many = moveFrom.slice(0, mid);
        off++;
    }
    return batches;
}
var $2a0c51260032b767$var$pathDividers = {
    clone: function(params) {
        var ret = [];
        // Fitting the alpha
        var approxOpacity = 1 - Math.pow(1 - params.path.style.opacity, 1 / params.count);
        for(var i = 0; i < params.count; i++){
            var cloned = (0, $15b38920672b9006$export$18711d956bf1c3eb)(params.path);
            cloned.setStyle("opacity", approxOpacity);
            ret.push(cloned);
        }
        return ret;
    },
    // Use the default divider
    split: null
};
function $2a0c51260032b767$export$c6ab3ab2bfe1ec39(from, to, divideShape, seriesModel, dataIndex, animateOtherProps) {
    if (!from.length || !to.length) return;
    var updateAnimationCfg = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)("update", seriesModel, dataIndex);
    if (!(updateAnimationCfg && updateAnimationCfg.duration > 0)) return;
    var animationDelay = seriesModel.getModel("universalTransition").get("delay");
    var animationCfg = Object.assign({
        // Need to setToFinal so the further calculation based on the style can be correct.
        // Like emphasis color.
        setToFinal: true
    }, updateAnimationCfg);
    var many;
    var one;
    if ($2a0c51260032b767$var$isMultiple(from)) {
        // manyToOne
        many = from;
        one = to;
    }
    if ($2a0c51260032b767$var$isMultiple(to)) {
        // oneToMany
        many = to;
        one = from;
    }
    function morphOneBatch(batch, fromIsMany, animateIndex, animateCount, forceManyOne) {
        var batchMany = batch.many;
        var batchOne = batch.one;
        if (batchMany.length === 1 && !forceManyOne) {
            // Is one to one
            var batchFrom = fromIsMany ? batchMany[0] : batchOne;
            var batchTo = fromIsMany ? batchOne : batchMany[0];
            if ((0, $2ef03ef3a2bb366a$export$f9f720a01590a46f)(batchFrom)) // Keep doing combine animation.
            morphOneBatch({
                many: [
                    batchFrom
                ],
                one: batchTo
            }, true, animateIndex, animateCount, true);
            else {
                var individualAnimationCfg = animationDelay ? (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                    delay: animationDelay(animateIndex, animateCount)
                }, animationCfg) : animationCfg;
                (0, $2ef03ef3a2bb366a$export$7174e282c1c7df1c)(batchFrom, batchTo, individualAnimationCfg);
                animateOtherProps(batchFrom, batchTo, batchFrom, batchTo, individualAnimationCfg);
            }
        } else {
            var separateAnimationCfg = (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                dividePath: $2a0c51260032b767$var$pathDividers[divideShape],
                individualDelay: animationDelay && function(idx, count, fromPath, toPath) {
                    return animationDelay(idx + animateIndex, animateCount);
                }
            }, animationCfg);
            var _a = fromIsMany ? (0, $2ef03ef3a2bb366a$export$57d3bac3565fd555)(batchMany, batchOne, separateAnimationCfg) : (0, $2ef03ef3a2bb366a$export$b6ed198024fe6db8)(batchOne, batchMany, separateAnimationCfg), fromIndividuals = _a.fromIndividuals, toIndividuals = _a.toIndividuals;
            var count = fromIndividuals.length;
            for(var k = 0; k < count; k++){
                var individualAnimationCfg = animationDelay ? (0, $7a1bd9c2710fea0d$export$ebe90cb607ad99e)({
                    delay: animationDelay(k, count)
                }, animationCfg) : animationCfg;
                animateOtherProps(fromIndividuals[k], toIndividuals[k], fromIsMany ? batchMany[k] : batch.one, fromIsMany ? batch.one : batchMany[k], individualAnimationCfg);
            }
        }
    }
    var fromIsMany = many ? many === from : from.length > to.length;
    var morphBatches = many ? $2a0c51260032b767$var$prepareMorphBatches(one, many) : $2a0c51260032b767$var$prepareMorphBatches(fromIsMany ? to : from, [
        fromIsMany ? from : to
    ]);
    var animateCount = 0;
    for(var i = 0; i < morphBatches.length; i++)animateCount += morphBatches[i].many.length;
    var animateIndex = 0;
    for(var i = 0; i < morphBatches.length; i++){
        morphOneBatch(morphBatches[i], fromIsMany, animateIndex, animateCount);
        animateIndex += morphBatches[i].many.length;
    }
}
function $2a0c51260032b767$export$ad61593d7c3fa814(elements) {
    if (!elements) return [];
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(elements)) {
        var pathList_1 = [];
        for(var i = 0; i < elements.length; i++)pathList_1.push($2a0c51260032b767$export$ad61593d7c3fa814(elements[i]));
        return pathList_1;
    }
    var pathList = [];
    elements.traverse(function(el) {
        if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039) && !el.disableMorphing && !el.invisible && !el.ignore) pathList.push(el);
    });
    return pathList;
}









var $2915cc4a2282c523$var$DATA_COUNT_THRESHOLD = 1e4;
var $2915cc4a2282c523$var$TRANSITION_NONE = 0;
var $2915cc4a2282c523$var$TRANSITION_P2C = 1;
var $2915cc4a2282c523$var$TRANSITION_C2P = 2;
var $2915cc4a2282c523$var$getUniversalTransitionGlobalStore = (0, $76d619f648247e6d$export$64df9f8d92ae083f)();
function $2915cc4a2282c523$var$getDimension(data, visualDimension) {
    var dimensions = data.dimensions;
    for(var i = 0; i < dimensions.length; i++){
        var dimInfo = data.getDimensionInfo(dimensions[i]);
        if (dimInfo && dimInfo.otherDims[visualDimension] === 0) return dimensions[i];
    }
}
// get value by dimension. (only get value of itemGroupId or childGroupId, so convert it to string)
function $2915cc4a2282c523$var$getValueByDimension(data, dataIndex, dimension) {
    var dimInfo = data.getDimensionInfo(dimension);
    var dimOrdinalMeta = dimInfo && dimInfo.ordinalMeta;
    if (dimInfo) {
        var value = data.get(dimInfo.name, dataIndex);
        if (dimOrdinalMeta) return dimOrdinalMeta.categories[value] || value + "";
        return value + "";
    }
}
function $2915cc4a2282c523$var$getGroupId(data, dataIndex, dataGroupId, isChild) {
    // try to get groupId from encode
    var visualDimension = isChild ? "itemChildGroupId" : "itemGroupId";
    var groupIdDim = $2915cc4a2282c523$var$getDimension(data, visualDimension);
    if (groupIdDim) {
        var groupId = $2915cc4a2282c523$var$getValueByDimension(data, dataIndex, groupIdDim);
        return groupId;
    }
    // try to get groupId from raw data item
    var rawDataItem = data.getRawDataItem(dataIndex);
    var property = isChild ? "childGroupId" : "groupId";
    if (rawDataItem && rawDataItem[property]) return rawDataItem[property] + "";
    // fallback
    if (isChild) return;
    // try to use series.dataGroupId as groupId, otherwise use dataItem's id as groupId
    return dataGroupId || data.getId(dataIndex);
}
// flatten all data items from different serieses into one arrary
function $2915cc4a2282c523$var$flattenDataDiffItems(list) {
    var items = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(list, function(seriesInfo) {
        var data = seriesInfo.data;
        var dataGroupId = seriesInfo.dataGroupId;
        if (data.count() > $2915cc4a2282c523$var$DATA_COUNT_THRESHOLD) return;
        var indices = data.getIndices();
        for(var dataIndex = 0; dataIndex < indices.length; dataIndex++)items.push({
            data: data,
            groupId: $2915cc4a2282c523$var$getGroupId(data, dataIndex, dataGroupId, false),
            childGroupId: $2915cc4a2282c523$var$getGroupId(data, dataIndex, dataGroupId, true),
            divide: seriesInfo.divide,
            dataIndex: dataIndex
        });
    });
    return items;
}
function $2915cc4a2282c523$var$fadeInElement(newEl, newSeries, newIndex) {
    newEl.traverse(function(el) {
        if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039)) // TODO use fade in animation for target element.
        (0, $8b353638fbedfefa$export$a121566aadcfe021)(el, {
            style: {
                opacity: 0
            }
        }, newSeries, {
            dataIndex: newIndex,
            isFrom: true
        });
    });
}
function $2915cc4a2282c523$var$removeEl(el) {
    if (el.parent) {
        // Bake parent transform to element.
        // So it can still have proper transform to transition after it's removed.
        var computedTransform = el.getComputedTransform();
        el.setLocalTransform(computedTransform);
        el.parent.remove(el);
    }
}
function $2915cc4a2282c523$var$stopAnimation(el) {
    el.stopAnimation();
    if (el.isGroup) el.traverse(function(child) {
        child.stopAnimation();
    });
}
function $2915cc4a2282c523$var$animateElementStyles(el, dataIndex, seriesModel) {
    var animationConfig = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)("update", seriesModel, dataIndex);
    animationConfig && el.traverse(function(child) {
        if (child instanceof (0, $56206a6cb4666931$export$2e2bcd8739ae039)) {
            var oldStyle = (0, $8b353638fbedfefa$export$ccb1f1e4d2fa86ac)(child);
            if (oldStyle) child.animateFrom({
                style: oldStyle
            }, animationConfig);
        }
    });
}
function $2915cc4a2282c523$var$isAllIdSame(oldDiffItems, newDiffItems) {
    var len = oldDiffItems.length;
    if (len !== newDiffItems.length) return false;
    for(var i = 0; i < len; i++){
        var oldItem = oldDiffItems[i];
        var newItem = newDiffItems[i];
        if (oldItem.data.getId(oldItem.dataIndex) !== newItem.data.getId(newItem.dataIndex)) return false;
    }
    return true;
}
function $2915cc4a2282c523$var$transitionBetween(oldList, newList, api) {
    var oldDiffItems = $2915cc4a2282c523$var$flattenDataDiffItems(oldList);
    var newDiffItems = $2915cc4a2282c523$var$flattenDataDiffItems(newList);
    function updateMorphingPathProps(from, to, rawFrom, rawTo, animationCfg) {
        if (rawFrom || from) to.animateFrom({
            style: rawFrom && rawFrom !== from ? (0, $7a1bd9c2710fea0d$export$8b58be045bf06082)((0, $7a1bd9c2710fea0d$export$8b58be045bf06082)({}, rawFrom.style), from.style) : from.style
        }, animationCfg);
    }
    var hasMorphAnimation = false;
    /**
   * With groupId and childGroupId, we can build parent-child relationships between dataItems.
   * However, we should mind the parent-child "direction" between old and new options.
   *
   * For example, suppose we have two dataItems from two series.data:
   *
   * dataA: [                          dataB: [
   *   {                                 {
   *     value: 5,                         value: 3,
   *     groupId: 'creatures',             groupId: 'animals',
   *     childGroupId: 'animals'           childGroupId: 'dogs'
   *   },                                },
   *   ...                               ...
   * ]                                 ]
   *
   * where dataA is belong to optionA and dataB is belong to optionB.
   *
   * When we `setOption(optionB)` from optionA, we choose childGroupId of dataItemA and groupId of
   * dataItemB as keys so the two keys are matched (both are 'animals'), then universalTransition
   * will work. This derection is "parent -> child".
   *
   * If we `setOption(optionA)` from optionB, we also choose groupId of dataItemB and childGroupId
   * of dataItemA as keys and universalTransition will work. This derection is "child -> parent".
   *
   * If there is no childGroupId specified, which means no multiLevelDrillDown/Up is needed and no
   * parent-child relationship exists. This direction is "none".
   *
   * So we need to know whether to use groupId or childGroupId as the key when we call the keyGetter
   * functions. Thus, we need to decide the direction first.
   *
   * The rule is:
   *
   * if (all childGroupIds in oldDiffItems and all groupIds in newDiffItems have common value) {
   *   direction = 'parent -> child';
   * } else if (all groupIds in oldDiffItems and all childGroupIds in newDiffItems have common value) {
   *   direction = 'child -> parent';
   * } else {
   *   direction = 'none';
   * }
   */ var direction = $2915cc4a2282c523$var$TRANSITION_NONE;
    // find all groupIds and childGroupIds from oldDiffItems
    var oldGroupIds = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var oldChildGroupIds = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    oldDiffItems.forEach(function(item) {
        item.groupId && oldGroupIds.set(item.groupId, true);
        item.childGroupId && oldChildGroupIds.set(item.childGroupId, true);
    });
    // traverse newDiffItems and decide the direction according to the rule
    for(var i = 0; i < newDiffItems.length; i++){
        var newGroupId = newDiffItems[i].groupId;
        if (oldChildGroupIds.get(newGroupId)) {
            direction = $2915cc4a2282c523$var$TRANSITION_P2C;
            break;
        }
        var newChildGroupId = newDiffItems[i].childGroupId;
        if (newChildGroupId && oldGroupIds.get(newChildGroupId)) {
            direction = $2915cc4a2282c523$var$TRANSITION_C2P;
            break;
        }
    }
    function createKeyGetter(isOld, onlyGetId) {
        return function(diffItem) {
            var data = diffItem.data;
            var dataIndex = diffItem.dataIndex;
            // TODO if specified dim
            if (onlyGetId) return data.getId(dataIndex);
            if (isOld) return direction === $2915cc4a2282c523$var$TRANSITION_P2C ? diffItem.childGroupId : diffItem.groupId;
            else return direction === $2915cc4a2282c523$var$TRANSITION_C2P ? diffItem.childGroupId : diffItem.groupId;
        };
    }
    // Use id if it's very likely to be an one to one animation
    // It's more robust than groupId
    // TODO Check if key dimension is specified.
    var useId = $2915cc4a2282c523$var$isAllIdSame(oldDiffItems, newDiffItems);
    var isElementStillInChart = {};
    if (!useId) // We may have different diff strategy with basicTransition if we use other dimension as key.
    // If so, we can't simply check if oldEl is same with newEl. We need a map to check if oldEl is still being used in the new chart.
    // We can't use the elements that already being morphed. Let it keep it's original basic transition.
    for(var i = 0; i < newDiffItems.length; i++){
        var newItem = newDiffItems[i];
        var el = newItem.data.getItemGraphicEl(newItem.dataIndex);
        if (el) isElementStillInChart[el.id] = true;
    }
    function updateOneToOne(newIndex, oldIndex) {
        var oldItem = oldDiffItems[oldIndex];
        var newItem = newDiffItems[newIndex];
        var newSeries = newItem.data.hostModel;
        // TODO Mark this elements is morphed and don't morph them anymore
        var oldEl = oldItem.data.getItemGraphicEl(oldItem.dataIndex);
        var newEl = newItem.data.getItemGraphicEl(newItem.dataIndex);
        // Can't handle same elements.
        if (oldEl === newEl) {
            newEl && $2915cc4a2282c523$var$animateElementStyles(newEl, newItem.dataIndex, newSeries);
            return;
        }
        if (// We can't use the elements that already being morphed
        oldEl && isElementStillInChart[oldEl.id]) return;
        if (newEl) {
            // TODO: If keep animating the group in case
            // some of the elements don't want to be morphed.
            // TODO Label?
            $2915cc4a2282c523$var$stopAnimation(newEl);
            if (oldEl) {
                $2915cc4a2282c523$var$stopAnimation(oldEl);
                // If old element is doing leaving animation. stop it and remove it immediately.
                $2915cc4a2282c523$var$removeEl(oldEl);
                hasMorphAnimation = true;
                (0, $2a0c51260032b767$export$c6ab3ab2bfe1ec39)((0, $2a0c51260032b767$export$ad61593d7c3fa814)(oldEl), (0, $2a0c51260032b767$export$ad61593d7c3fa814)(newEl), newItem.divide, newSeries, newIndex, updateMorphingPathProps);
            } else $2915cc4a2282c523$var$fadeInElement(newEl, newSeries, newIndex);
        }
    // else keep oldEl leaving animation.
    }
    new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldDiffItems, newDiffItems, createKeyGetter(true, useId), createKeyGetter(false, useId), null, "multiple").update(updateOneToOne).updateManyToOne(function(newIndex, oldIndices) {
        var newItem = newDiffItems[newIndex];
        var newData = newItem.data;
        var newSeries = newData.hostModel;
        var newEl = newData.getItemGraphicEl(newItem.dataIndex);
        var oldElsList = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(oldIndices, function(idx) {
            return oldDiffItems[idx].data.getItemGraphicEl(oldDiffItems[idx].dataIndex);
        }), function(oldEl) {
            return oldEl && oldEl !== newEl && !isElementStillInChart[oldEl.id];
        });
        if (newEl) {
            $2915cc4a2282c523$var$stopAnimation(newEl);
            if (oldElsList.length) {
                // If old element is doing leaving animation. stop it and remove it immediately.
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(oldElsList, function(oldEl) {
                    $2915cc4a2282c523$var$stopAnimation(oldEl);
                    $2915cc4a2282c523$var$removeEl(oldEl);
                });
                hasMorphAnimation = true;
                (0, $2a0c51260032b767$export$c6ab3ab2bfe1ec39)((0, $2a0c51260032b767$export$ad61593d7c3fa814)(oldElsList), (0, $2a0c51260032b767$export$ad61593d7c3fa814)(newEl), newItem.divide, newSeries, newIndex, updateMorphingPathProps);
            } else $2915cc4a2282c523$var$fadeInElement(newEl, newSeries, newItem.dataIndex);
        }
    // else keep oldEl leaving animation.
    }).updateOneToMany(function(newIndices, oldIndex) {
        var oldItem = oldDiffItems[oldIndex];
        var oldEl = oldItem.data.getItemGraphicEl(oldItem.dataIndex);
        // We can't use the elements that already being morphed
        if (oldEl && isElementStillInChart[oldEl.id]) return;
        var newElsList = (0, $7a1bd9c2710fea0d$export$3dea766d36a8935f)((0, $7a1bd9c2710fea0d$export$871de8747c9eaa88)(newIndices, function(idx) {
            return newDiffItems[idx].data.getItemGraphicEl(newDiffItems[idx].dataIndex);
        }), function(el) {
            return el && el !== oldEl;
        });
        var newSeris = newDiffItems[newIndices[0]].data.hostModel;
        if (newElsList.length) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newElsList, function(newEl) {
                return $2915cc4a2282c523$var$stopAnimation(newEl);
            });
            if (oldEl) {
                $2915cc4a2282c523$var$stopAnimation(oldEl);
                // If old element is doing leaving animation. stop it and remove it immediately.
                $2915cc4a2282c523$var$removeEl(oldEl);
                hasMorphAnimation = true;
                (0, $2a0c51260032b767$export$c6ab3ab2bfe1ec39)((0, $2a0c51260032b767$export$ad61593d7c3fa814)(oldEl), (0, $2a0c51260032b767$export$ad61593d7c3fa814)(newElsList), oldItem.divide, // Use divide on old.
                newSeris, newIndices[0], updateMorphingPathProps);
            } else (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newElsList, function(newEl) {
                return $2915cc4a2282c523$var$fadeInElement(newEl, newSeris, newIndices[0]);
            });
        }
    // else keep oldEl leaving animation.
    }).updateManyToMany(function(newIndices, oldIndices) {
        // If two data are same and both have groupId.
        // Normally they should be diff by id.
        new (0, $306d1c87baff8a10$export$2e2bcd8739ae039)(oldIndices, newIndices, function(rawIdx) {
            return oldDiffItems[rawIdx].data.getId(oldDiffItems[rawIdx].dataIndex);
        }, function(rawIdx) {
            return newDiffItems[rawIdx].data.getId(newDiffItems[rawIdx].dataIndex);
        }).update(function(newIndex, oldIndex) {
            // Use the original index
            updateOneToOne(newIndices[newIndex], oldIndices[oldIndex]);
        }).execute();
    }).execute();
    if (hasMorphAnimation) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(newList, function(_a) {
        var data = _a.data;
        var seriesModel = data.hostModel;
        var view = seriesModel && api.getViewOfSeriesModel(seriesModel);
        var animationCfg = (0, $8b353638fbedfefa$export$5cc7add7ab591d0a)("update", seriesModel, 0); // use 0 index.
        if (view && seriesModel.isAnimationEnabled() && animationCfg && animationCfg.duration > 0) view.group.traverse(function(el) {
            if (el instanceof (0, $b02ffe7acd508c08$export$2e2bcd8739ae039) && !el.animators.length) // We can't accept there still exists element that has no animation
            // if universalTransition is enabled
            el.animateFrom({
                style: {
                    opacity: 0
                }
            }, animationCfg);
        });
    });
}
function $2915cc4a2282c523$var$getSeriesTransitionKey(series) {
    var seriesKey = series.getModel("universalTransition").get("seriesKey");
    if (!seriesKey) // Use series id by default.
    return series.id;
    return seriesKey;
}
function $2915cc4a2282c523$var$convertArraySeriesKeyToString(seriesKey) {
    if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(seriesKey)) // Order independent.
    return seriesKey.sort().join(",");
    return seriesKey;
}
function $2915cc4a2282c523$var$getDivideShapeFromData(data) {
    if (data.hostModel) return data.hostModel.getModel("universalTransition").get("divideShape");
}
function $2915cc4a2282c523$var$findTransitionSeriesBatches(globalStore, params) {
    var updateBatches = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    var oldDataMap = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    // Map that only store key in array seriesKey.
    // Which is used to query the old data when transition from one to multiple series.
    var oldDataMapForSplit = (0, $7a1bd9c2710fea0d$export$55f8aa7ef875b0a4)();
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(globalStore.oldSeries, function(series, idx) {
        var oldDataGroupId = globalStore.oldDataGroupIds[idx];
        var oldData = globalStore.oldData[idx];
        var transitionKey = $2915cc4a2282c523$var$getSeriesTransitionKey(series);
        var transitionKeyStr = $2915cc4a2282c523$var$convertArraySeriesKeyToString(transitionKey);
        oldDataMap.set(transitionKeyStr, {
            dataGroupId: oldDataGroupId,
            data: oldData
        });
        if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(transitionKey)) // Same key can't in different array seriesKey.
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(transitionKey, function(key) {
            oldDataMapForSplit.set(key, {
                key: transitionKeyStr,
                dataGroupId: oldDataGroupId,
                data: oldData
            });
        });
    });
    function checkTransitionSeriesKeyDuplicated(transitionKeyStr) {
        if (updateBatches.get(transitionKeyStr)) (0, $84bc7667c27ccedc$export$c106dd0671a0fc2d)("Duplicated seriesKey in universalTransition " + transitionKeyStr);
    }
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(params.updatedSeries, function(series) {
        if (series.isUniversalTransitionEnabled() && series.isAnimationEnabled()) {
            var newDataGroupId = series.get("dataGroupId");
            var newData = series.getData();
            var transitionKey = $2915cc4a2282c523$var$getSeriesTransitionKey(series);
            var transitionKeyStr = $2915cc4a2282c523$var$convertArraySeriesKeyToString(transitionKey);
            // Only transition between series with same id.
            var oldData = oldDataMap.get(transitionKeyStr);
            // string transition key is the best match.
            if (oldData) // TODO check if data is same?
            updateBatches.set(transitionKeyStr, {
                oldSeries: [
                    {
                        dataGroupId: oldData.dataGroupId,
                        divide: $2915cc4a2282c523$var$getDivideShapeFromData(oldData.data),
                        data: oldData.data
                    }
                ],
                newSeries: [
                    {
                        dataGroupId: newDataGroupId,
                        divide: $2915cc4a2282c523$var$getDivideShapeFromData(newData),
                        data: newData
                    }
                ]
            });
            else // Transition from multiple series.
            // e.g. 'female', 'male' -> ['female', 'male']
            if ((0, $7a1bd9c2710fea0d$export$43bee75e5e14138e)(transitionKey)) {
                var oldSeries_1 = [];
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(transitionKey, function(key) {
                    var oldData = oldDataMap.get(key);
                    if (oldData.data) oldSeries_1.push({
                        dataGroupId: oldData.dataGroupId,
                        divide: $2915cc4a2282c523$var$getDivideShapeFromData(oldData.data),
                        data: oldData.data
                    });
                });
                if (oldSeries_1.length) updateBatches.set(transitionKeyStr, {
                    oldSeries: oldSeries_1,
                    newSeries: [
                        {
                            dataGroupId: newDataGroupId,
                            data: newData,
                            divide: $2915cc4a2282c523$var$getDivideShapeFromData(newData)
                        }
                    ]
                });
            } else {
                // Try transition to multiple series.
                // e.g. ['female', 'male'] -> 'female', 'male'
                var oldData_1 = oldDataMapForSplit.get(transitionKey);
                if (oldData_1) {
                    var batch = updateBatches.get(oldData_1.key);
                    if (!batch) {
                        batch = {
                            oldSeries: [
                                {
                                    dataGroupId: oldData_1.dataGroupId,
                                    data: oldData_1.data,
                                    divide: $2915cc4a2282c523$var$getDivideShapeFromData(oldData_1.data)
                                }
                            ],
                            newSeries: []
                        };
                        updateBatches.set(oldData_1.key, batch);
                    }
                    batch.newSeries.push({
                        dataGroupId: newDataGroupId,
                        data: newData,
                        divide: $2915cc4a2282c523$var$getDivideShapeFromData(newData)
                    });
                }
            }
        }
    });
    return updateBatches;
}
function $2915cc4a2282c523$var$querySeries(series, finder) {
    for(var i = 0; i < series.length; i++){
        var found = finder.seriesIndex != null && finder.seriesIndex === series[i].seriesIndex || finder.seriesId != null && finder.seriesId === series[i].id;
        if (found) return i;
    }
}
function $2915cc4a2282c523$var$transitionSeriesFromOpt(transitionOpt, globalStore, params, api) {
    var from = [];
    var to = [];
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(transitionOpt.from), function(finder) {
        var idx = $2915cc4a2282c523$var$querySeries(globalStore.oldSeries, finder);
        if (idx >= 0) from.push({
            dataGroupId: globalStore.oldDataGroupIds[idx],
            data: globalStore.oldData[idx],
            // TODO can specify divideShape in transition.
            divide: $2915cc4a2282c523$var$getDivideShapeFromData(globalStore.oldData[idx]),
            groupIdDim: finder.dimension
        });
    });
    (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(transitionOpt.to), function(finder) {
        var idx = $2915cc4a2282c523$var$querySeries(params.updatedSeries, finder);
        if (idx >= 0) {
            var data = params.updatedSeries[idx].getData();
            to.push({
                dataGroupId: globalStore.oldDataGroupIds[idx],
                data: data,
                divide: $2915cc4a2282c523$var$getDivideShapeFromData(data),
                groupIdDim: finder.dimension
            });
        }
    });
    if (from.length > 0 && to.length > 0) $2915cc4a2282c523$var$transitionBetween(from, to, api);
}
function $2915cc4a2282c523$export$efd07f28fd73e88c(registers) {
    registers.registerUpdateLifecycle("series:beforeupdate", function(ecMOdel, api, params) {
        (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(params.seriesTransition), function(transOpt) {
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(transOpt.to), function(finder) {
                var series = params.updatedSeries;
                for(var i = 0; i < series.length; i++)if (finder.seriesIndex != null && finder.seriesIndex === series[i].seriesIndex || finder.seriesId != null && finder.seriesId === series[i].id) series[i][0, $7c10febb2cdef0d8$export$e960441116ae2799] = true;
            });
        });
    });
    registers.registerUpdateLifecycle("series:transition", function(ecModel, api, params) {
        // TODO api provide an namespace that can save stuff per instance
        var globalStore = $2915cc4a2282c523$var$getUniversalTransitionGlobalStore(api);
        // TODO multiple to multiple series.
        if (globalStore.oldSeries && params.updatedSeries && params.optionChanged) {
            // TODO transitionOpt was used in an old implementation and can be removed now
            // Use give transition config if its' give;
            var transitionOpt = params.seriesTransition;
            if (transitionOpt) (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)((0, $76d619f648247e6d$export$4f07b212a02c8051)(transitionOpt), function(opt) {
                $2915cc4a2282c523$var$transitionSeriesFromOpt(opt, globalStore, params, api);
            });
            else {
                // Else guess from series based on transition series key.
                var updateBatches_1 = $2915cc4a2282c523$var$findTransitionSeriesBatches(globalStore, params);
                (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(updateBatches_1.keys(), function(key) {
                    var batch = updateBatches_1.get(key);
                    $2915cc4a2282c523$var$transitionBetween(batch.oldSeries, batch.newSeries, api);
                });
            }
            // Reset
            (0, $7a1bd9c2710fea0d$export$79b2f7037acddd43)(params.updatedSeries, function(series) {
                // Reset;
                if (series[0, $7c10febb2cdef0d8$export$e960441116ae2799]) series[0, $7c10febb2cdef0d8$export$e960441116ae2799] = false;
            });
        }
        // Save all series of current update. Not only the updated one.
        var allSeries = ecModel.getSeries();
        var savedSeries = globalStore.oldSeries = [];
        var savedDataGroupIds = globalStore.oldDataGroupIds = [];
        var savedData = globalStore.oldData = [];
        for(var i = 0; i < allSeries.length; i++){
            var data = allSeries[i].getData();
            // Only save the data that can have transition.
            // Avoid large data costing too much extra memory
            if (data.count() < $2915cc4a2282c523$var$DATA_COUNT_THRESHOLD) {
                savedSeries.push(allSeries[i]);
                savedDataGroupIds.push(allSeries[i].get("dataGroupId"));
                savedData.push(data);
            }
        }
    });
}


// -----------------
// Render engines
// -----------------
// Render via Canvas.
// echarts.init(dom, null, { renderer: 'canvas' })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)([
    (0, $e792bf2f67d76098$export$4b3e715f166fdd78)
]);
// Render via SVG.
// echarts.init(dom, null, { renderer: 'svg' })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)([
    (0, $8d8c6eb926bbdd0e$export$4b3e715f166fdd78)
]);
// ----------------
// Charts (series)
// ----------------
// All of the series types, for example:
// chart.setOption({
//     series: [{
//         type: 'line' // or 'bar', 'pie', ...
//     }]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)([
    (0, $9c1bfdc9a4f78f2d$export$4b3e715f166fdd78),
    (0, $4bb56d1f08552ff4$export$4b3e715f166fdd78),
    (0, $6b7ead9b40180cba$export$4b3e715f166fdd78),
    (0, $1214e5d7a4a6f990$export$4b3e715f166fdd78),
    (0, $a8120efef8bcaaa0$export$4b3e715f166fdd78),
    (0, $6c94070aa7d5e098$export$4b3e715f166fdd78),
    (0, $44a5d4d260c7de78$export$4b3e715f166fdd78),
    (0, $330b7dc841112eff$export$4b3e715f166fdd78),
    (0, $b48bd73bf5d69641$export$4b3e715f166fdd78),
    (0, $bf7cb565bb1d2308$export$4b3e715f166fdd78),
    (0, $2bdc3734cdc2f6c8$export$4b3e715f166fdd78),
    (0, $4d1dc874f9d8653d$export$4b3e715f166fdd78),
    (0, $2439b31c49c21b38$export$4b3e715f166fdd78),
    (0, $0fd6296850ce3099$export$4b3e715f166fdd78),
    (0, $21999577dfdc5807$export$4b3e715f166fdd78),
    (0, $a0fd335cdafe9e6e$export$4b3e715f166fdd78),
    (0, $52dd2448928cc7d8$export$4b3e715f166fdd78),
    (0, $c53e84d38e53ec61$export$4b3e715f166fdd78),
    (0, $7e25595b74be81a3$export$4b3e715f166fdd78),
    (0, $e883cd02390b2e6d$export$4b3e715f166fdd78),
    (0, $b7341ef122ec790d$export$4b3e715f166fdd78),
    (0, $3fd02cf8c6a1578a$export$4b3e715f166fdd78)
]);
// -------------------
// Coordinate systems
// -------------------
// All of the axis modules have been included in the
// coordinate system module below, do not need to
// make extra import.
// `cartesian` coordinate system. For some historical
// reasons, it is named as grid, for example:
// chart.setOption({
//     grid: {...},
//     xAxis: {...},
//     yAxis: {...},
//     series: [{...}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $30909b2e837c2175$export$4b3e715f166fdd78));
// `polar` coordinate system, for example:
// chart.setOption({
//     polar: {...},
//     radiusAxis: {...},
//     angleAxis: {...},
//     series: [{
//         coordinateSystem: 'polar'
//     }]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $0a6536a72e92ce0b$export$4b3e715f166fdd78));
// `geo` coordinate system, for example:
// chart.setOption({
//     geo: {...},
//     series: [{
//         coordinateSystem: 'geo'
//     }]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $8082b8b129488d44$export$4b3e715f166fdd78));
// `singleAxis` coordinate system (notice, it is a coordinate system
// with only one axis, work for chart like theme river), for example:
// chart.setOption({
//     singleAxis: {...}
//     series: [{type: 'themeRiver', ...}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $2e3198006a202a14$export$4b3e715f166fdd78));
// `parallel` coordinate system, only work for parallel series, for example:
// chart.setOption({
//     parallel: {...},
//     parallelAxis: [{...}, ...],
//     series: [{
//         type: 'parallel'
//     }]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $462857bad733a944$export$4b3e715f166fdd78));
// `calendar` coordinate system. for example,
// chart.setOption({
//     calendar: {...},
//     series: [{
//         coordinateSystem: 'calendar'
//     }]
// );
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $c1c3b68ff9dcc3e7$export$4b3e715f166fdd78));
// ------------------
// Other components
// ------------------
// `graphic` component, for example:
// chart.setOption({
//     graphic: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $48174658d54922b7$export$4b3e715f166fdd78));
// `toolbox` component, for example:
// chart.setOption({
//     toolbox: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $db487da8ce0e4ca6$export$4b3e715f166fdd78));
// `tooltip` component, for example:
// chart.setOption({
//     tooltip: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $46e639bec576c55c$export$4b3e715f166fdd78));
// `axisPointer` component, for example:
// chart.setOption({
//     tooltip: {axisPointer: {...}, ...}
// });
// Or
// chart.setOption({
//     axisPointer: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $589507869c21caa1$export$4b3e715f166fdd78));
// `brush` component, for example:
// chart.setOption({
//     brush: {...}
// });
// Or
// chart.setOption({
//     tooltip: {feature: {brush: {...}}
// })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $e97a928e0b93a54f$export$4b3e715f166fdd78));
// `title` component, for example:
// chart.setOption({
//     title: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $66707465bee49836$export$4b3e715f166fdd78));
// `timeline` component, for example:
// chart.setOption({
//     timeline: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $d41f79c5664eb934$export$4b3e715f166fdd78));
// `markPoint` component, for example:
// chart.setOption({
//     series: [{markPoint: {...}}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $4edaa7c972a7e0d1$export$4b3e715f166fdd78));
// `markLine` component, for example:
// chart.setOption({
//     series: [{markLine: {...}}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $0fc27d0a088604ed$export$4b3e715f166fdd78));
// `markArea` component, for example:
// chart.setOption({
//     series: [{markArea: {...}}]
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $8a8e80722bf1c081$export$4b3e715f166fdd78));
// `legend` component not scrollable. for example:
// chart.setOption({
//     legend: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $1a0761510a437d9f$export$4b3e715f166fdd78));
// `dataZoom` component including both `dataZoomInside` and `dataZoomSlider`.
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $aa2dc70f9fa9453b$export$4b3e715f166fdd78));
// `dataZoom` component providing drag, pinch, wheel behaviors
// inside coordinate system, for example:
// chart.setOption({
//     dataZoom: {type: 'inside'}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $b5ee445cd897e37a$export$4b3e715f166fdd78));
// `dataZoom` component providing a slider bar, for example:
// chart.setOption({
//     dataZoom: {type: 'slider'}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $794c23331e97718e$export$4b3e715f166fdd78));
// `visualMap` component including both `visualMapContinuous` and `visualMapPiecewise`.
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $1df0d53aa7db8747$export$4b3e715f166fdd78));
// `visualMap` component providing continuous bar, for example:
// chart.setOption({
//     visualMap: {type: 'continuous'}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $a0f8a196dd8b4cba$export$4b3e715f166fdd78));
// `visualMap` component providing pieces bar, for example:
// chart.setOption({
//     visualMap: {type: 'piecewise'}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $312d2d640a7c60e1$export$4b3e715f166fdd78));
// `aria` component providing aria, for example:
// chart.setOption({
//     aria: {...}
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $772c09ed30d27c33$export$4b3e715f166fdd78));
// dataset transform
// chart.setOption({
//     dataset: {
//          transform: []
//     }
// });
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $d6bad095dfa9594d$export$4b3e715f166fdd78));
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $afb70cea6fec4fe0$export$4b3e715f166fdd78));
// universal transition
// chart.setOption({
//     series: {
//         universalTransition: { enabled: true }
//     }
// })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $2915cc4a2282c523$export$efd07f28fd73e88c));
// label layout
// chart.setOption({
//     series: {
//         labelLayout: { hideOverlap: true }
//     }
// })
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $de19ea5da3bb8f56$export$5320d1b3745c02a5));


/**
 * echarts-gl
 * Extension pack of ECharts providing 3d plots and globe visualization
 *
 * Copyright (c) 2014, echarts-gl
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * * Redistributions of source code must retain the above copyright notice, this
 *   list of conditions and the following disclaimer.
 *
 * * Redistributions in binary form must reproduce the above copyright notice,
 *   this list of conditions and the following disclaimer in the documentation
 *   and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // These APIs are for more advanced usages
// For example extend charts and components, creating graphic elements, formatting.











var $9a616079ee96a3f3$exports = {};

$parcel$export($9a616079ee96a3f3$exports, "createList", () => $9a616079ee96a3f3$export$5897d8d7c7a3d871);
$parcel$export($9a616079ee96a3f3$exports, "dataStack", () => $9a616079ee96a3f3$export$d6100971d5a3a0a7);
$parcel$export($9a616079ee96a3f3$exports, "createScale", () => $9a616079ee96a3f3$export$587d9c3c553380c6);
$parcel$export($9a616079ee96a3f3$exports, "mixinAxisModelCommonMethods", () => $9a616079ee96a3f3$export$4665cbe3470e4d57);
$parcel$export($9a616079ee96a3f3$exports, "createTextStyle", () => $9a616079ee96a3f3$export$f8998c3d0a13de59);
$parcel$export($9a616079ee96a3f3$exports, "getLayoutRect", () => $93b9bc7f22ac7369$export$4517a5ca639a7293);
$parcel$export($9a616079ee96a3f3$exports, "createDimensions", () => $a27631012b7b377c$export$8066c1b52b2e9504);
$parcel$export($9a616079ee96a3f3$exports, "createSymbol", () => $5370466dadc978d7$export$af050e04da3a02e8);
$parcel$export($9a616079ee96a3f3$exports, "getECData", () => $b1983a2fffd47d56$export$b1c39b2bacd1ddc2);
$parcel$export($9a616079ee96a3f3$exports, "enableHoverEmphasis", () => $2bf82c0980125b62$export$5f393df0b5aee2e7);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * This module exposes helper functions for developing extensions.
 */ 











function $9a616079ee96a3f3$export$5897d8d7c7a3d871(seriesModel) {
    return (0, $8afdec5f59c90781$export$2e2bcd8739ae039)(null, seriesModel);
}
var $9a616079ee96a3f3$export$d6100971d5a3a0a7 = {
    isDimensionStacked: (0, $efdd976e4917927c$export$1dedc39359ae35c),
    enableDataStack: (0, $efdd976e4917927c$export$f2165f9e8499b278),
    getStackedDimension: (0, $efdd976e4917927c$export$909db2be4938fbdf)
};
function $9a616079ee96a3f3$export$587d9c3c553380c6(dataExtent, option) {
    var axisModel = option;
    if (!(option instanceof (0, $6818646a97528290$export$2e2bcd8739ae039))) axisModel = new (0, $6818646a97528290$export$2e2bcd8739ae039)(option);
    var scale = $2d646e51cc34f840$export$8941c4cacdc8f5a5(axisModel);
    scale.setExtent(dataExtent[0], dataExtent[1]);
    $2d646e51cc34f840$export$51f3e70a54405d5a(scale, axisModel);
    return scale;
}
function $9a616079ee96a3f3$export$4665cbe3470e4d57(Model) {
    $7a1bd9c2710fea0d$export$e36fc9d62a853069(Model, (0, $3449fd4c0590d99e$export$5c54b224726edb5a));
}
function $9a616079ee96a3f3$export$f8998c3d0a13de59(textStyleModel, opts) {
    opts = opts || {};
    return (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(textStyleModel, null, null, opts.state !== "normal");
}





var $880e2355a7de9d0c$exports = {};

$parcel$export($880e2355a7de9d0c$exports, "linearMap", () => $cfc1f3b422a3185f$export$d3f68fbaa670562);
$parcel$export($880e2355a7de9d0c$exports, "round", () => $cfc1f3b422a3185f$export$2077e0241d6afd3c);
$parcel$export($880e2355a7de9d0c$exports, "asc", () => $cfc1f3b422a3185f$export$debe6e778e0a6d32);
$parcel$export($880e2355a7de9d0c$exports, "getPrecision", () => $cfc1f3b422a3185f$export$e0c74b50bbd10f68);
$parcel$export($880e2355a7de9d0c$exports, "getPrecisionSafe", () => $cfc1f3b422a3185f$export$6d86ba4ca4984d31);
$parcel$export($880e2355a7de9d0c$exports, "getPixelPrecision", () => $cfc1f3b422a3185f$export$666260d9a2dda8a7);
$parcel$export($880e2355a7de9d0c$exports, "getPercentWithPrecision", () => $cfc1f3b422a3185f$export$70cc11b075afeb90);
$parcel$export($880e2355a7de9d0c$exports, "MAX_SAFE_INTEGER", () => $cfc1f3b422a3185f$export$18510406f204a1b9);
$parcel$export($880e2355a7de9d0c$exports, "remRadian", () => $cfc1f3b422a3185f$export$2ca6dd70a288b1c3);
$parcel$export($880e2355a7de9d0c$exports, "isRadianAroundZero", () => $cfc1f3b422a3185f$export$d1df570aea2868f);
$parcel$export($880e2355a7de9d0c$exports, "parseDate", () => $cfc1f3b422a3185f$export$6b862160d295c8e);
$parcel$export($880e2355a7de9d0c$exports, "quantity", () => $cfc1f3b422a3185f$export$82dd68b83a44b253);
$parcel$export($880e2355a7de9d0c$exports, "quantityExponent", () => $cfc1f3b422a3185f$export$97256a17b20a0c24);
$parcel$export($880e2355a7de9d0c$exports, "nice", () => $cfc1f3b422a3185f$export$7a695fe44258210b);
$parcel$export($880e2355a7de9d0c$exports, "quantile", () => $cfc1f3b422a3185f$export$651fb4afdb6caa4b);
$parcel$export($880e2355a7de9d0c$exports, "reformIntervals", () => $cfc1f3b422a3185f$export$12f7386070bc380a);
$parcel$export($880e2355a7de9d0c$exports, "isNumeric", () => $cfc1f3b422a3185f$export$e90fb89750dba83f);
$parcel$export($880e2355a7de9d0c$exports, "numericToNumber", () => $cfc1f3b422a3185f$export$8b4007b942b45a96);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $03154d907069e78f$exports = {};

$parcel$export($03154d907069e78f$exports, "extendShape", () => $5b455ae6f843ac47$export$d0d5398c9d612037);
$parcel$export($03154d907069e78f$exports, "extendPath", () => $5b455ae6f843ac47$export$53b54a3137026af0);
$parcel$export($03154d907069e78f$exports, "makePath", () => $5b455ae6f843ac47$export$aa9bab72412f5613);
$parcel$export($03154d907069e78f$exports, "makeImage", () => $5b455ae6f843ac47$export$7a2bdede98851ac5);
$parcel$export($03154d907069e78f$exports, "mergePath", () => $5b455ae6f843ac47$export$7b1dd269fbc4e903);
$parcel$export($03154d907069e78f$exports, "resizePath", () => $5b455ae6f843ac47$export$566dbf1c62b04fc7);
$parcel$export($03154d907069e78f$exports, "createIcon", () => $5b455ae6f843ac47$export$274edc73af1ae9c8);
$parcel$export($03154d907069e78f$exports, "updateProps", () => $8b353638fbedfefa$export$c8dce3c08436e91e);
$parcel$export($03154d907069e78f$exports, "initProps", () => $8b353638fbedfefa$export$a121566aadcfe021);
$parcel$export($03154d907069e78f$exports, "getTransform", () => $5b455ae6f843ac47$export$fce0c6cfca85ed96);
$parcel$export($03154d907069e78f$exports, "clipPointsByRect", () => $5b455ae6f843ac47$export$e2f409471bbbc1dc);
$parcel$export($03154d907069e78f$exports, "clipRectByRect", () => $5b455ae6f843ac47$export$d0d3709202b8b2a);
$parcel$export($03154d907069e78f$exports, "registerShape", () => $5b455ae6f843ac47$export$2b95b62e3aaf6fdd);
$parcel$export($03154d907069e78f$exports, "getShapeClass", () => $5b455ae6f843ac47$export$51df4b5565a58189);
$parcel$export($03154d907069e78f$exports, "Group", () => $7ef7583d8302ffce$export$2e2bcd8739ae039);
$parcel$export($03154d907069e78f$exports, "Image", () => $86adec94217b86c6$export$2e2bcd8739ae039);
$parcel$export($03154d907069e78f$exports, "Text", () => $fe885cc21795562b$export$2e2bcd8739ae039);
$parcel$export($03154d907069e78f$exports, "Circle", () => $1e68d8727773abb7$export$2e2bcd8739ae039);
$parcel$export($03154d907069e78f$exports, "Ellipse", () => $4a809f055a7e524c$export$2e2bcd8739ae039);
$parcel$export($03154d907069e78f$exports, "Sector", () => $a3e1dec0a3875b49$export$2e2bcd8739ae039);
$parcel$export($03154d907069e78f$exports, "Ring", () => $9da0cbfd3f86fdc1$export$2e2bcd8739ae039);
$parcel$export($03154d907069e78f$exports, "Polygon", () => $51acf033123e1a30$export$2e2bcd8739ae039);
$parcel$export($03154d907069e78f$exports, "Polyline", () => $d28119f30e6bb670$export$2e2bcd8739ae039);
$parcel$export($03154d907069e78f$exports, "Rect", () => $419e5ff2f303755e$export$2e2bcd8739ae039);
$parcel$export($03154d907069e78f$exports, "Line", () => $7a316ae5ceff7b27$export$2e2bcd8739ae039);
$parcel$export($03154d907069e78f$exports, "BezierCurve", () => $6c7800c49630e431$export$2e2bcd8739ae039);
$parcel$export($03154d907069e78f$exports, "Arc", () => $2b5c23eb3597b84a$export$2e2bcd8739ae039);
$parcel$export($03154d907069e78f$exports, "IncrementalDisplayable", () => $ee829f116f003981$export$2e2bcd8739ae039);
$parcel$export($03154d907069e78f$exports, "CompoundPath", () => $e152f3dbf8fba6e2$export$2e2bcd8739ae039);
$parcel$export($03154d907069e78f$exports, "LinearGradient", () => $cf44c01491b58e53$export$2e2bcd8739ae039);
$parcel$export($03154d907069e78f$exports, "RadialGradient", () => $cd2ee2ba32bb26c3$export$2e2bcd8739ae039);
$parcel$export($03154d907069e78f$exports, "BoundingRect", () => $1bebe7106c895823$export$2e2bcd8739ae039);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $8eb0e968d6dc83bc$exports = {};

$parcel$export($8eb0e968d6dc83bc$exports, "addCommas", () => $c84c9521536c601a$export$b6fe44657ce35c42);
$parcel$export($8eb0e968d6dc83bc$exports, "toCamelCase", () => $c84c9521536c601a$export$86f54f62aa7a7514);
$parcel$export($8eb0e968d6dc83bc$exports, "normalizeCssArray", () => $c84c9521536c601a$export$f3a38102c49f4268);
$parcel$export($8eb0e968d6dc83bc$exports, "encodeHTML", () => $664e052f390bd76e$export$f9d6449b9af28dc1);
$parcel$export($8eb0e968d6dc83bc$exports, "formatTpl", () => $c84c9521536c601a$export$2028496a35766e41);
$parcel$export($8eb0e968d6dc83bc$exports, "getTooltipMarker", () => $c84c9521536c601a$export$1987a3dbdf3c45ca);
$parcel$export($8eb0e968d6dc83bc$exports, "formatTime", () => $c84c9521536c601a$export$3203edd9e5edd663);
$parcel$export($8eb0e968d6dc83bc$exports, "capitalFirst", () => $c84c9521536c601a$export$38a1e7552f497c0e);
$parcel$export($8eb0e968d6dc83bc$exports, "truncateText", () => $64fa9b3825ba2dec$export$59a943b34a82e690);
$parcel$export($8eb0e968d6dc83bc$exports, "getTextRect", () => $f626ce0db1e76fe5$export$372ffda650a6e70d);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $224386f1517b5dca$exports = {};

$parcel$export($224386f1517b5dca$exports, "map", () => $7a1bd9c2710fea0d$export$871de8747c9eaa88);
$parcel$export($224386f1517b5dca$exports, "each", () => $7a1bd9c2710fea0d$export$79b2f7037acddd43);
$parcel$export($224386f1517b5dca$exports, "indexOf", () => $7a1bd9c2710fea0d$export$305f7d4e9d4624f2);
$parcel$export($224386f1517b5dca$exports, "inherits", () => $7a1bd9c2710fea0d$export$69f1b2dcda23c5f8);
$parcel$export($224386f1517b5dca$exports, "reduce", () => $7a1bd9c2710fea0d$export$533b26079ad0b4b);
$parcel$export($224386f1517b5dca$exports, "filter", () => $7a1bd9c2710fea0d$export$3dea766d36a8935f);
$parcel$export($224386f1517b5dca$exports, "bind", () => $7a1bd9c2710fea0d$export$2385a24977818dd0);
$parcel$export($224386f1517b5dca$exports, "curry", () => $7a1bd9c2710fea0d$export$c3095a23b368d1f2);
$parcel$export($224386f1517b5dca$exports, "isArray", () => $7a1bd9c2710fea0d$export$43bee75e5e14138e);
$parcel$export($224386f1517b5dca$exports, "isString", () => $7a1bd9c2710fea0d$export$844ec244b1367d54);
$parcel$export($224386f1517b5dca$exports, "isObject", () => $7a1bd9c2710fea0d$export$a6cdc56e425d0d0a);
$parcel$export($224386f1517b5dca$exports, "isFunction", () => $7a1bd9c2710fea0d$export$f6e2535fb5126e54);
$parcel$export($224386f1517b5dca$exports, "extend", () => $7a1bd9c2710fea0d$export$8b58be045bf06082);
$parcel$export($224386f1517b5dca$exports, "defaults", () => $7a1bd9c2710fea0d$export$ebe90cb607ad99e);
$parcel$export($224386f1517b5dca$exports, "clone", () => $7a1bd9c2710fea0d$export$9cd59f9826255e47);
$parcel$export($224386f1517b5dca$exports, "merge", () => $7a1bd9c2710fea0d$export$4950aa0f605343fb);
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






function $bccf524a2cc32ef6$export$4dd01020bb736662(proto) {
    var Model = (0, $116d65051f61bdfe$export$2e2bcd8739ae039).extend(proto);
    (0, $116d65051f61bdfe$export$2e2bcd8739ae039).registerClass(Model);
    return Model;
}
function $bccf524a2cc32ef6$export$a4336148da8ef02(proto) {
    var View = (0, $737c88aa0711f65a$export$2e2bcd8739ae039).extend(proto);
    (0, $737c88aa0711f65a$export$2e2bcd8739ae039).registerClass(View);
    return View;
}
function $bccf524a2cc32ef6$export$fe6d3114e3fc260c(proto) {
    var Model = (0, $7c10febb2cdef0d8$export$2e2bcd8739ae039).extend(proto);
    (0, $7c10febb2cdef0d8$export$2e2bcd8739ae039).registerClass(Model);
    return Model;
}
function $bccf524a2cc32ef6$export$c750883d1b603e83(proto) {
    var View = (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).extend(proto);
    (0, $0dc5061053e23cd3$export$2e2bcd8739ae039).registerClass(View);
    return View;
}








// Default to have canvas renderer and dataset for compitatble reason.
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)([
    (0, $e792bf2f67d76098$export$4b3e715f166fdd78),
    (0, $afb70cea6fec4fe0$export$4b3e715f166fdd78)
]);
var // TODO: Compatitable with the following code
// import echarts from 'echarts/lib/echarts.js'
$140fbf818b03b3ab$export$2e2bcd8739ae039 = {
    init: function() {
        // @ts-ignore
        return (0, $4d59907f44a2d0ad$export$2cd8252107eb640b).apply(null, arguments);
    }
};
(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $de19ea5da3bb8f56$export$5320d1b3745c02a5));


/**
 * Provide WebGL layer to zrender. Which is rendered on top of clay.
 *
 *
 * Relationship between zrender, LayerGL(renderer) and ViewGL(Scene, Camera, Viewport)
 *           zrender
 *           /     \
 *      LayerGL   LayerGL
 *    (renderer) (renderer)
 *      /     \
 *  ViewGL   ViewGL
 */ 
// TODO Resources like shader, texture, geometry reference management
// Trace and find out which shader, texture, geometry can be destroyed
/**
 * Extend a sub class from base class
 * @param {object|Function} makeDefaultOpt default option of this sub class, method of the sub can use this.xxx to access this option
 * @param {Function} [initialize] Initialize after the sub class is instantiated
 * @param {Object} [proto] Prototype methods/properties of the sub class
 * @memberOf clay.core.mixin.extend
 * @return {Function}
 */ function $7633fb838a299981$var$derive(makeDefaultOpt, initialize /*optional*/ , proto /*optional*/ ) {
    if (typeof initialize == "object") {
        proto = initialize;
        initialize = null;
    }
    var _super = this;
    var propList;
    if (!(makeDefaultOpt instanceof Function)) {
        // Optimize the property iterate if it have been fixed
        propList = [];
        for(var propName in makeDefaultOpt)if (makeDefaultOpt.hasOwnProperty(propName)) propList.push(propName);
    }
    var sub = function(options) {
        // call super constructor
        _super.apply(this, arguments);
        if (makeDefaultOpt instanceof Function) // Invoke makeDefaultOpt each time if it is a function, So we can make sure each
        // property in the object will not be shared by mutiple instances
        $7633fb838a299981$var$extend(this, makeDefaultOpt.call(this, options));
        else $7633fb838a299981$var$extendWithPropList(this, makeDefaultOpt, propList);
        if (this.constructor === sub) {
            // Initialize function will be called in the order of inherit
            var initializers = sub.__initializers__;
            for(var i = 0; i < initializers.length; i++)initializers[i].apply(this, arguments);
        }
    };
    // save super constructor
    sub.__super__ = _super;
    // Initialize function will be called after all the super constructor is called
    if (!_super.__initializers__) sub.__initializers__ = [];
    else sub.__initializers__ = _super.__initializers__.slice();
    if (initialize) sub.__initializers__.push(initialize);
    var Ctor = function() {};
    Ctor.prototype = _super.prototype;
    sub.prototype = new Ctor();
    sub.prototype.constructor = sub;
    $7633fb838a299981$var$extend(sub.prototype, proto);
    // extend the derive method as a static method;
    sub.extend = _super.extend;
    // DEPCRATED
    sub.derive = _super.extend;
    return sub;
}
function $7633fb838a299981$var$extend(target, source) {
    if (!source) return;
    for(var name in source)if (source.hasOwnProperty(name)) target[name] = source[name];
}
function $7633fb838a299981$var$extendWithPropList(target, source, propList) {
    for(var i = 0; i < propList.length; i++){
        var propName = propList[i];
        target[propName] = source[propName];
    }
}
var /**
 * @alias clay.core.mixin.extend
 * @mixin
 */ $7633fb838a299981$export$2e2bcd8739ae039 = {
    extend: $7633fb838a299981$var$derive,
    // DEPCRATED
    derive: $7633fb838a299981$var$derive
};


function $1b1a308d68e2d97a$var$Handler(action, context) {
    this.action = action;
    this.context = context;
}
/**
 * @mixin
 * @alias clay.core.mixin.notifier
 */ var $1b1a308d68e2d97a$var$notifier = {
    /**
     * Trigger event
     * @param  {string} name
     */ trigger: function(name) {
        if (!this.hasOwnProperty("__handlers__")) return;
        if (!this.__handlers__.hasOwnProperty(name)) return;
        var hdls = this.__handlers__[name];
        var l = hdls.length, i = -1, args = arguments;
        // Optimize advise from backbone
        switch(args.length){
            case 1:
                while(++i < l)hdls[i].action.call(hdls[i].context);
                return;
            case 2:
                while(++i < l)hdls[i].action.call(hdls[i].context, args[1]);
                return;
            case 3:
                while(++i < l)hdls[i].action.call(hdls[i].context, args[1], args[2]);
                return;
            case 4:
                while(++i < l)hdls[i].action.call(hdls[i].context, args[1], args[2], args[3]);
                return;
            case 5:
                while(++i < l)hdls[i].action.call(hdls[i].context, args[1], args[2], args[3], args[4]);
                return;
            default:
                while(++i < l)hdls[i].action.apply(hdls[i].context, Array.prototype.slice.call(args, 1));
                return;
        }
    },
    /**
     * Register event handler
     * @param  {string} name
     * @param  {Function} action
     * @param  {Object} [context]
     * @chainable
     */ on: function(name, action, context) {
        if (!name || !action) return;
        var handlers = this.__handlers__ || (this.__handlers__ = {});
        if (!handlers[name]) handlers[name] = [];
        else {
            if (this.has(name, action)) return;
        }
        var handler = new $1b1a308d68e2d97a$var$Handler(action, context || this);
        handlers[name].push(handler);
        return this;
    },
    /**
     * Register event, event will only be triggered once and then removed
     * @param  {string} name
     * @param  {Function} action
     * @param  {Object} [context]
     * @chainable
     */ once: function(name, action, context) {
        if (!name || !action) return;
        var self = this;
        function wrapper() {
            self.off(name, wrapper);
            action.apply(this, arguments);
        }
        return this.on(name, wrapper, context);
    },
    /**
     * Alias of once('before' + name)
     * @param  {string} name
     * @param  {Function} action
     * @param  {Object} [context]
     * @chainable
     */ before: function(name, action, context) {
        if (!name || !action) return;
        name = "before" + name;
        return this.on(name, action, context);
    },
    /**
     * Alias of once('after' + name)
     * @param  {string} name
     * @param  {Function} action
     * @param  {Object} [context]
     * @chainable
     */ after: function(name, action, context) {
        if (!name || !action) return;
        name = "after" + name;
        return this.on(name, action, context);
    },
    /**
     * Alias of on('success')
     * @param  {Function} action
     * @param  {Object} [context]
     * @chainable
     */ success: function(action, context) {
        return this.once("success", action, context);
    },
    /**
     * Alias of on('error')
     * @param  {Function} action
     * @param  {Object} [context]
     * @chainable
     */ error: function(action, context) {
        return this.once("error", action, context);
    },
    /**
     * Remove event listener
     * @param  {Function} action
     * @param  {Object} [context]
     * @chainable
     */ off: function(name, action) {
        var handlers = this.__handlers__ || (this.__handlers__ = {});
        if (!action) {
            handlers[name] = [];
            return;
        }
        if (handlers[name]) {
            var hdls = handlers[name];
            var retains = [];
            for(var i = 0; i < hdls.length; i++)if (action && hdls[i].action !== action) retains.push(hdls[i]);
            handlers[name] = retains;
        }
        return this;
    },
    /**
     * If registered the event handler
     * @param  {string}  name
     * @param  {Function}  action
     * @return {boolean}
     */ has: function(name, action) {
        var handlers = this.__handlers__;
        if (!handlers || !handlers[name]) return false;
        var hdls = handlers[name];
        for(var i = 0; i < hdls.length; i++){
            if (hdls[i].action === action) return true;
        }
    }
};
var $1b1a308d68e2d97a$export$2e2bcd8739ae039 = $1b1a308d68e2d97a$var$notifier;


var $b22fd57b6bfa77fb$var$guid = 0;
var $b22fd57b6bfa77fb$var$ArrayProto = Array.prototype;
var $b22fd57b6bfa77fb$var$nativeForEach = $b22fd57b6bfa77fb$var$ArrayProto.forEach;
/**
 * Util functions
 * @namespace clay.core.util
 */ var $b22fd57b6bfa77fb$var$util = {
    /**
     * Generate GUID
     * @return {number}
     * @memberOf clay.core.util
     */ genGUID: function() {
        return ++$b22fd57b6bfa77fb$var$guid;
    },
    /**
     * Relative path to absolute path
     * @param  {string} path
     * @param  {string} basePath
     * @return {string}
     * @memberOf clay.core.util
     */ relative2absolute: function(path, basePath) {
        if (!basePath || path.match(/^\//)) return path;
        var pathParts = path.split("/");
        var basePathParts = basePath.split("/");
        var item = pathParts[0];
        while(item === "." || item === ".."){
            if (item === "..") basePathParts.pop();
            pathParts.shift();
            item = pathParts[0];
        }
        return basePathParts.join("/") + "/" + pathParts.join("/");
    },
    /**
     * Extend target with source
     * @param  {Object} target
     * @param  {Object} source
     * @return {Object}
     * @memberOf clay.core.util
     */ extend: function(target, source) {
        if (source) {
            for(var name in source)if (source.hasOwnProperty(name)) target[name] = source[name];
        }
        return target;
    },
    /**
     * Extend properties to target if not exist.
     * @param  {Object} target
     * @param  {Object} source
     * @return {Object}
     * @memberOf clay.core.util
     */ defaults: function(target, source) {
        if (source) {
            for(var propName in source)if (target[propName] === undefined) target[propName] = source[propName];
        }
        return target;
    },
    /**
     * Extend properties with a given property list to avoid for..in.. iteration.
     * @param  {Object} target
     * @param  {Object} source
     * @param  {Array.<string>} propList
     * @return {Object}
     * @memberOf clay.core.util
     */ extendWithPropList: function(target, source, propList) {
        if (source) for(var i = 0; i < propList.length; i++){
            var propName = propList[i];
            target[propName] = source[propName];
        }
        return target;
    },
    /**
     * Extend properties to target if not exist. With a given property list avoid for..in.. iteration.
     * @param  {Object} target
     * @param  {Object} source
     * @param  {Array.<string>} propList
     * @return {Object}
     * @memberOf clay.core.util
     */ defaultsWithPropList: function(target, source, propList) {
        if (source) for(var i = 0; i < propList.length; i++){
            var propName = propList[i];
            if (target[propName] == null) target[propName] = source[propName];
        }
        return target;
    },
    /**
     * @param  {Object|Array} obj
     * @param  {Function} iterator
     * @param  {Object} [context]
     * @memberOf clay.core.util
     */ each: function(obj, iterator, context) {
        if (!(obj && iterator)) return;
        if (obj.forEach && obj.forEach === $b22fd57b6bfa77fb$var$nativeForEach) obj.forEach(iterator, context);
        else if (obj.length === +obj.length) for(var i = 0, len = obj.length; i < len; i++)iterator.call(context, obj[i], i, obj);
        else {
            for(var key in obj)if (obj.hasOwnProperty(key)) iterator.call(context, obj[key], key, obj);
        }
    },
    /**
     * Is object
     * @param  {}  obj
     * @return {boolean}
     * @memberOf clay.core.util
     */ isObject: function(obj) {
        return obj === Object(obj);
    },
    /**
     * Is array ?
     * @param  {}  obj
     * @return {boolean}
     * @memberOf clay.core.util
     */ isArray: function(obj) {
        return Array.isArray(obj);
    },
    /**
     * Is array like, which have a length property
     * @param  {}  obj
     * @return {boolean}
     * @memberOf clay.core.util
     */ isArrayLike: function(obj) {
        if (!obj) return false;
        else return obj.length === +obj.length;
    },
    /**
     * @param  {} obj
     * @return {}
     * @memberOf clay.core.util
     */ clone: function(obj) {
        if (!$b22fd57b6bfa77fb$var$util.isObject(obj)) return obj;
        else if ($b22fd57b6bfa77fb$var$util.isArray(obj)) return obj.slice();
        else if ($b22fd57b6bfa77fb$var$util.isArrayLike(obj)) {
            var ret = new obj.constructor(obj.length);
            for(var i = 0; i < obj.length; i++)ret[i] = obj[i];
            return ret;
        } else return $b22fd57b6bfa77fb$var$util.extend({}, obj);
    }
};
var $b22fd57b6bfa77fb$export$2e2bcd8739ae039 = $b22fd57b6bfa77fb$var$util;


/**
 * Base class of all objects
 * @constructor
 * @alias clay.core.Base
 * @mixes clay.core.mixin.notifier
 */ var $7c62670c05885275$var$Base = function() {
    /**
     * @type {number}
     */ this.__uid__ = (0, $b22fd57b6bfa77fb$export$2e2bcd8739ae039).genGUID();
};
$7c62670c05885275$var$Base.__initializers__ = [
    function(opts) {
        (0, $b22fd57b6bfa77fb$export$2e2bcd8739ae039).extend(this, opts);
    }
];
(0, $b22fd57b6bfa77fb$export$2e2bcd8739ae039).extend($7c62670c05885275$var$Base, (0, $7633fb838a299981$export$2e2bcd8739ae039));
(0, $b22fd57b6bfa77fb$export$2e2bcd8739ae039).extend($7c62670c05885275$var$Base.prototype, (0, $1b1a308d68e2d97a$export$2e2bcd8739ae039));
var $7c62670c05885275$export$2e2bcd8739ae039 = $7c62670c05885275$var$Base;


var $0c8ecdf33bc707a6$var$EXTENSION_LIST = [
    "OES_texture_float",
    "OES_texture_half_float",
    "OES_texture_float_linear",
    "OES_texture_half_float_linear",
    "OES_standard_derivatives",
    "OES_vertex_array_object",
    "OES_element_index_uint",
    "WEBGL_compressed_texture_s3tc",
    "WEBGL_depth_texture",
    "EXT_texture_filter_anisotropic",
    "EXT_shader_texture_lod",
    "WEBGL_draw_buffers",
    "EXT_frag_depth",
    "EXT_sRGB",
    "ANGLE_instanced_arrays"
];
var $0c8ecdf33bc707a6$var$PARAMETER_NAMES = [
    "MAX_TEXTURE_SIZE",
    "MAX_CUBE_MAP_TEXTURE_SIZE"
];
function $0c8ecdf33bc707a6$var$GLInfo(_gl) {
    var extensions = {};
    var parameters = {};
    // Get webgl extension
    for(var i = 0; i < $0c8ecdf33bc707a6$var$EXTENSION_LIST.length; i++){
        var extName = $0c8ecdf33bc707a6$var$EXTENSION_LIST[i];
        createExtension(extName);
    }
    // Get parameters
    for(var i = 0; i < $0c8ecdf33bc707a6$var$PARAMETER_NAMES.length; i++){
        var name = $0c8ecdf33bc707a6$var$PARAMETER_NAMES[i];
        parameters[name] = _gl.getParameter(_gl[name]);
    }
    this.getExtension = function(name) {
        if (!(name in extensions)) createExtension(name);
        return extensions[name];
    };
    this.getParameter = function(name) {
        return parameters[name];
    };
    function createExtension(name) {
        if (_gl.getExtension) {
            var ext = _gl.getExtension(name);
            if (!ext) ext = _gl.getExtension("MOZ_" + name);
            if (!ext) ext = _gl.getExtension("WEBKIT_" + name);
            extensions[name] = ext;
        }
    }
}
var $0c8ecdf33bc707a6$export$2e2bcd8739ae039 = $0c8ecdf33bc707a6$var$GLInfo;


/**
 * @namespace clay.core.glenum
 * @see http://www.khronos.org/registry/webgl/specs/latest/1.0/#5.14
 */ var $4f1dbdc689ecc3ce$export$2e2bcd8739ae039 = {
    /* ClearBufferMask */ DEPTH_BUFFER_BIT: 0x00000100,
    STENCIL_BUFFER_BIT: 0x00000400,
    COLOR_BUFFER_BIT: 0x00004000,
    /* BeginMode */ POINTS: 0x0000,
    LINES: 0x0001,
    LINE_LOOP: 0x0002,
    LINE_STRIP: 0x0003,
    TRIANGLES: 0x0004,
    TRIANGLE_STRIP: 0x0005,
    TRIANGLE_FAN: 0x0006,
    /* AlphaFunction (not supported in ES20) */ /*      NEVER */ /*      LESS */ /*      EQUAL */ /*      LEQUAL */ /*      GREATER */ /*      NOTEQUAL */ /*      GEQUAL */ /*      ALWAYS */ /* BlendingFactorDest */ ZERO: 0,
    ONE: 1,
    SRC_COLOR: 0x0300,
    ONE_MINUS_SRC_COLOR: 0x0301,
    SRC_ALPHA: 0x0302,
    ONE_MINUS_SRC_ALPHA: 0x0303,
    DST_ALPHA: 0x0304,
    ONE_MINUS_DST_ALPHA: 0x0305,
    /* BlendingFactorSrc */ /*      ZERO */ /*      ONE */ DST_COLOR: 0x0306,
    ONE_MINUS_DST_COLOR: 0x0307,
    SRC_ALPHA_SATURATE: 0x0308,
    /*      SRC_ALPHA */ /*      ONE_MINUS_SRC_ALPHA */ /*      DST_ALPHA */ /*      ONE_MINUS_DST_ALPHA */ /* BlendEquationSeparate */ FUNC_ADD: 0x8006,
    BLEND_EQUATION: 0x8009,
    BLEND_EQUATION_RGB: 0x8009,
    /* same as BLEND_EQUATION */ BLEND_EQUATION_ALPHA: 0x883D,
    /* BlendSubtract */ FUNC_SUBTRACT: 0x800A,
    FUNC_REVERSE_SUBTRACT: 0x800B,
    /* Separate Blend Functions */ BLEND_DST_RGB: 0x80C8,
    BLEND_SRC_RGB: 0x80C9,
    BLEND_DST_ALPHA: 0x80CA,
    BLEND_SRC_ALPHA: 0x80CB,
    CONSTANT_COLOR: 0x8001,
    ONE_MINUS_CONSTANT_COLOR: 0x8002,
    CONSTANT_ALPHA: 0x8003,
    ONE_MINUS_CONSTANT_ALPHA: 0x8004,
    BLEND_COLOR: 0x8005,
    /* Buffer Objects */ ARRAY_BUFFER: 0x8892,
    ELEMENT_ARRAY_BUFFER: 0x8893,
    ARRAY_BUFFER_BINDING: 0x8894,
    ELEMENT_ARRAY_BUFFER_BINDING: 0x8895,
    STREAM_DRAW: 0x88E0,
    STATIC_DRAW: 0x88E4,
    DYNAMIC_DRAW: 0x88E8,
    BUFFER_SIZE: 0x8764,
    BUFFER_USAGE: 0x8765,
    CURRENT_VERTEX_ATTRIB: 0x8626,
    /* CullFaceMode */ FRONT: 0x0404,
    BACK: 0x0405,
    FRONT_AND_BACK: 0x0408,
    /* DepthFunction */ /*      NEVER */ /*      LESS */ /*      EQUAL */ /*      LEQUAL */ /*      GREATER */ /*      NOTEQUAL */ /*      GEQUAL */ /*      ALWAYS */ /* EnableCap */ /* TEXTURE_2D */ CULL_FACE: 0x0B44,
    BLEND: 0x0BE2,
    DITHER: 0x0BD0,
    STENCIL_TEST: 0x0B90,
    DEPTH_TEST: 0x0B71,
    SCISSOR_TEST: 0x0C11,
    POLYGON_OFFSET_FILL: 0x8037,
    SAMPLE_ALPHA_TO_COVERAGE: 0x809E,
    SAMPLE_COVERAGE: 0x80A0,
    /* ErrorCode */ NO_ERROR: 0,
    INVALID_ENUM: 0x0500,
    INVALID_VALUE: 0x0501,
    INVALID_OPERATION: 0x0502,
    OUT_OF_MEMORY: 0x0505,
    /* FrontFaceDirection */ CW: 0x0900,
    CCW: 0x0901,
    /* GetPName */ LINE_WIDTH: 0x0B21,
    ALIASED_POINT_SIZE_RANGE: 0x846D,
    ALIASED_LINE_WIDTH_RANGE: 0x846E,
    CULL_FACE_MODE: 0x0B45,
    FRONT_FACE: 0x0B46,
    DEPTH_RANGE: 0x0B70,
    DEPTH_WRITEMASK: 0x0B72,
    DEPTH_CLEAR_VALUE: 0x0B73,
    DEPTH_FUNC: 0x0B74,
    STENCIL_CLEAR_VALUE: 0x0B91,
    STENCIL_FUNC: 0x0B92,
    STENCIL_FAIL: 0x0B94,
    STENCIL_PASS_DEPTH_FAIL: 0x0B95,
    STENCIL_PASS_DEPTH_PASS: 0x0B96,
    STENCIL_REF: 0x0B97,
    STENCIL_VALUE_MASK: 0x0B93,
    STENCIL_WRITEMASK: 0x0B98,
    STENCIL_BACK_FUNC: 0x8800,
    STENCIL_BACK_FAIL: 0x8801,
    STENCIL_BACK_PASS_DEPTH_FAIL: 0x8802,
    STENCIL_BACK_PASS_DEPTH_PASS: 0x8803,
    STENCIL_BACK_REF: 0x8CA3,
    STENCIL_BACK_VALUE_MASK: 0x8CA4,
    STENCIL_BACK_WRITEMASK: 0x8CA5,
    VIEWPORT: 0x0BA2,
    SCISSOR_BOX: 0x0C10,
    /*      SCISSOR_TEST */ COLOR_CLEAR_VALUE: 0x0C22,
    COLOR_WRITEMASK: 0x0C23,
    UNPACK_ALIGNMENT: 0x0CF5,
    PACK_ALIGNMENT: 0x0D05,
    MAX_TEXTURE_SIZE: 0x0D33,
    MAX_VIEWPORT_DIMS: 0x0D3A,
    SUBPIXEL_BITS: 0x0D50,
    RED_BITS: 0x0D52,
    GREEN_BITS: 0x0D53,
    BLUE_BITS: 0x0D54,
    ALPHA_BITS: 0x0D55,
    DEPTH_BITS: 0x0D56,
    STENCIL_BITS: 0x0D57,
    POLYGON_OFFSET_UNITS: 0x2A00,
    /*      POLYGON_OFFSET_FILL */ POLYGON_OFFSET_FACTOR: 0x8038,
    TEXTURE_BINDING_2D: 0x8069,
    SAMPLE_BUFFERS: 0x80A8,
    SAMPLES: 0x80A9,
    SAMPLE_COVERAGE_VALUE: 0x80AA,
    SAMPLE_COVERAGE_INVERT: 0x80AB,
    /* GetTextureParameter */ /*      TEXTURE_MAG_FILTER */ /*      TEXTURE_MIN_FILTER */ /*      TEXTURE_WRAP_S */ /*      TEXTURE_WRAP_T */ COMPRESSED_TEXTURE_FORMATS: 0x86A3,
    /* HintMode */ DONT_CARE: 0x1100,
    FASTEST: 0x1101,
    NICEST: 0x1102,
    /* HintTarget */ GENERATE_MIPMAP_HINT: 0x8192,
    /* DataType */ BYTE: 0x1400,
    UNSIGNED_BYTE: 0x1401,
    SHORT: 0x1402,
    UNSIGNED_SHORT: 0x1403,
    INT: 0x1404,
    UNSIGNED_INT: 0x1405,
    FLOAT: 0x1406,
    /* PixelFormat */ DEPTH_COMPONENT: 0x1902,
    ALPHA: 0x1906,
    RGB: 0x1907,
    RGBA: 0x1908,
    LUMINANCE: 0x1909,
    LUMINANCE_ALPHA: 0x190A,
    /* PixelType */ /*      UNSIGNED_BYTE */ UNSIGNED_SHORT_4_4_4_4: 0x8033,
    UNSIGNED_SHORT_5_5_5_1: 0x8034,
    UNSIGNED_SHORT_5_6_5: 0x8363,
    /* Shaders */ FRAGMENT_SHADER: 0x8B30,
    VERTEX_SHADER: 0x8B31,
    MAX_VERTEX_ATTRIBS: 0x8869,
    MAX_VERTEX_UNIFORM_VECTORS: 0x8DFB,
    MAX_VARYING_VECTORS: 0x8DFC,
    MAX_COMBINED_TEXTURE_IMAGE_UNITS: 0x8B4D,
    MAX_VERTEX_TEXTURE_IMAGE_UNITS: 0x8B4C,
    MAX_TEXTURE_IMAGE_UNITS: 0x8872,
    MAX_FRAGMENT_UNIFORM_VECTORS: 0x8DFD,
    SHADER_TYPE: 0x8B4F,
    DELETE_STATUS: 0x8B80,
    LINK_STATUS: 0x8B82,
    VALIDATE_STATUS: 0x8B83,
    ATTACHED_SHADERS: 0x8B85,
    ACTIVE_UNIFORMS: 0x8B86,
    ACTIVE_ATTRIBUTES: 0x8B89,
    SHADING_LANGUAGE_VERSION: 0x8B8C,
    CURRENT_PROGRAM: 0x8B8D,
    /* StencilFunction */ NEVER: 0x0200,
    LESS: 0x0201,
    EQUAL: 0x0202,
    LEQUAL: 0x0203,
    GREATER: 0x0204,
    NOTEQUAL: 0x0205,
    GEQUAL: 0x0206,
    ALWAYS: 0x0207,
    /* StencilOp */ /*      ZERO */ KEEP: 0x1E00,
    REPLACE: 0x1E01,
    INCR: 0x1E02,
    DECR: 0x1E03,
    INVERT: 0x150A,
    INCR_WRAP: 0x8507,
    DECR_WRAP: 0x8508,
    /* StringName */ VENDOR: 0x1F00,
    RENDERER: 0x1F01,
    VERSION: 0x1F02,
    /* TextureMagFilter */ NEAREST: 0x2600,
    LINEAR: 0x2601,
    /* TextureMinFilter */ /*      NEAREST */ /*      LINEAR */ NEAREST_MIPMAP_NEAREST: 0x2700,
    LINEAR_MIPMAP_NEAREST: 0x2701,
    NEAREST_MIPMAP_LINEAR: 0x2702,
    LINEAR_MIPMAP_LINEAR: 0x2703,
    /* TextureParameterName */ TEXTURE_MAG_FILTER: 0x2800,
    TEXTURE_MIN_FILTER: 0x2801,
    TEXTURE_WRAP_S: 0x2802,
    TEXTURE_WRAP_T: 0x2803,
    /* TextureTarget */ TEXTURE_2D: 0x0DE1,
    TEXTURE: 0x1702,
    TEXTURE_CUBE_MAP: 0x8513,
    TEXTURE_BINDING_CUBE_MAP: 0x8514,
    TEXTURE_CUBE_MAP_POSITIVE_X: 0x8515,
    TEXTURE_CUBE_MAP_NEGATIVE_X: 0x8516,
    TEXTURE_CUBE_MAP_POSITIVE_Y: 0x8517,
    TEXTURE_CUBE_MAP_NEGATIVE_Y: 0x8518,
    TEXTURE_CUBE_MAP_POSITIVE_Z: 0x8519,
    TEXTURE_CUBE_MAP_NEGATIVE_Z: 0x851A,
    MAX_CUBE_MAP_TEXTURE_SIZE: 0x851C,
    /* TextureUnit */ TEXTURE0: 0x84C0,
    TEXTURE1: 0x84C1,
    TEXTURE2: 0x84C2,
    TEXTURE3: 0x84C3,
    TEXTURE4: 0x84C4,
    TEXTURE5: 0x84C5,
    TEXTURE6: 0x84C6,
    TEXTURE7: 0x84C7,
    TEXTURE8: 0x84C8,
    TEXTURE9: 0x84C9,
    TEXTURE10: 0x84CA,
    TEXTURE11: 0x84CB,
    TEXTURE12: 0x84CC,
    TEXTURE13: 0x84CD,
    TEXTURE14: 0x84CE,
    TEXTURE15: 0x84CF,
    TEXTURE16: 0x84D0,
    TEXTURE17: 0x84D1,
    TEXTURE18: 0x84D2,
    TEXTURE19: 0x84D3,
    TEXTURE20: 0x84D4,
    TEXTURE21: 0x84D5,
    TEXTURE22: 0x84D6,
    TEXTURE23: 0x84D7,
    TEXTURE24: 0x84D8,
    TEXTURE25: 0x84D9,
    TEXTURE26: 0x84DA,
    TEXTURE27: 0x84DB,
    TEXTURE28: 0x84DC,
    TEXTURE29: 0x84DD,
    TEXTURE30: 0x84DE,
    TEXTURE31: 0x84DF,
    ACTIVE_TEXTURE: 0x84E0,
    /* TextureWrapMode */ REPEAT: 0x2901,
    CLAMP_TO_EDGE: 0x812F,
    MIRRORED_REPEAT: 0x8370,
    /* Uniform Types */ FLOAT_VEC2: 0x8B50,
    FLOAT_VEC3: 0x8B51,
    FLOAT_VEC4: 0x8B52,
    INT_VEC2: 0x8B53,
    INT_VEC3: 0x8B54,
    INT_VEC4: 0x8B55,
    BOOL: 0x8B56,
    BOOL_VEC2: 0x8B57,
    BOOL_VEC3: 0x8B58,
    BOOL_VEC4: 0x8B59,
    FLOAT_MAT2: 0x8B5A,
    FLOAT_MAT3: 0x8B5B,
    FLOAT_MAT4: 0x8B5C,
    SAMPLER_2D: 0x8B5E,
    SAMPLER_CUBE: 0x8B60,
    /* Vertex Arrays */ VERTEX_ATTRIB_ARRAY_ENABLED: 0x8622,
    VERTEX_ATTRIB_ARRAY_SIZE: 0x8623,
    VERTEX_ATTRIB_ARRAY_STRIDE: 0x8624,
    VERTEX_ATTRIB_ARRAY_TYPE: 0x8625,
    VERTEX_ATTRIB_ARRAY_NORMALIZED: 0x886A,
    VERTEX_ATTRIB_ARRAY_POINTER: 0x8645,
    VERTEX_ATTRIB_ARRAY_BUFFER_BINDING: 0x889F,
    /* Shader Source */ COMPILE_STATUS: 0x8B81,
    /* Shader Precision-Specified Types */ LOW_FLOAT: 0x8DF0,
    MEDIUM_FLOAT: 0x8DF1,
    HIGH_FLOAT: 0x8DF2,
    LOW_INT: 0x8DF3,
    MEDIUM_INT: 0x8DF4,
    HIGH_INT: 0x8DF5,
    /* Framebuffer Object. */ FRAMEBUFFER: 0x8D40,
    RENDERBUFFER: 0x8D41,
    RGBA4: 0x8056,
    RGB5_A1: 0x8057,
    RGB565: 0x8D62,
    DEPTH_COMPONENT16: 0x81A5,
    STENCIL_INDEX: 0x1901,
    STENCIL_INDEX8: 0x8D48,
    DEPTH_STENCIL: 0x84F9,
    RENDERBUFFER_WIDTH: 0x8D42,
    RENDERBUFFER_HEIGHT: 0x8D43,
    RENDERBUFFER_INTERNAL_FORMAT: 0x8D44,
    RENDERBUFFER_RED_SIZE: 0x8D50,
    RENDERBUFFER_GREEN_SIZE: 0x8D51,
    RENDERBUFFER_BLUE_SIZE: 0x8D52,
    RENDERBUFFER_ALPHA_SIZE: 0x8D53,
    RENDERBUFFER_DEPTH_SIZE: 0x8D54,
    RENDERBUFFER_STENCIL_SIZE: 0x8D55,
    FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE: 0x8CD0,
    FRAMEBUFFER_ATTACHMENT_OBJECT_NAME: 0x8CD1,
    FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL: 0x8CD2,
    FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE: 0x8CD3,
    COLOR_ATTACHMENT0: 0x8CE0,
    DEPTH_ATTACHMENT: 0x8D00,
    STENCIL_ATTACHMENT: 0x8D20,
    DEPTH_STENCIL_ATTACHMENT: 0x821A,
    NONE: 0,
    FRAMEBUFFER_COMPLETE: 0x8CD5,
    FRAMEBUFFER_INCOMPLETE_ATTACHMENT: 0x8CD6,
    FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT: 0x8CD7,
    FRAMEBUFFER_INCOMPLETE_DIMENSIONS: 0x8CD9,
    FRAMEBUFFER_UNSUPPORTED: 0x8CDD,
    FRAMEBUFFER_BINDING: 0x8CA6,
    RENDERBUFFER_BINDING: 0x8CA7,
    MAX_RENDERBUFFER_SIZE: 0x84E8,
    INVALID_FRAMEBUFFER_OPERATION: 0x0506,
    /* WebGL-specific enums */ UNPACK_FLIP_Y_WEBGL: 0x9240,
    UNPACK_PREMULTIPLY_ALPHA_WEBGL: 0x9241,
    CONTEXT_LOST_WEBGL: 0x9242,
    UNPACK_COLORSPACE_CONVERSION_WEBGL: 0x9243,
    BROWSER_DEFAULT_WEBGL: 0x9244
};


function $a8dda860140b8346$var$get(options) {
    var xhr = new XMLHttpRequest();
    xhr.open("get", options.url);
    // With response type set browser can get and put binary data
    // https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest/Sending_and_Receiving_Binary_Data
    // Default is text, and it can be set
    // arraybuffer, blob, document, json, text
    xhr.responseType = options.responseType || "text";
    if (options.onprogress) //https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest/Using_XMLHttpRequest
    xhr.onprogress = function(e) {
        if (e.lengthComputable) {
            var percent = e.loaded / e.total;
            options.onprogress(percent, e.loaded, e.total);
        } else options.onprogress(null);
    };
    xhr.onload = function(e) {
        if (xhr.status >= 400) options.onerror && options.onerror();
        else options.onload && options.onload(xhr.response);
    };
    if (options.onerror) xhr.onerror = options.onerror;
    xhr.send(null);
}
var $a8dda860140b8346$export$2e2bcd8739ae039 = {
    get: $a8dda860140b8346$var$get
};


var $1e103eb4a58e64ce$var$supportWebGL;
var $1e103eb4a58e64ce$var$vendor = {};
/**
 * If support WebGL
 * @return {boolean}
 */ $1e103eb4a58e64ce$var$vendor.supportWebGL = function() {
    if ($1e103eb4a58e64ce$var$supportWebGL == null) try {
        var canvas = document.createElement("canvas");
        var gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
        if (!gl) throw new Error();
    } catch (e) {
        $1e103eb4a58e64ce$var$supportWebGL = false;
    }
    return $1e103eb4a58e64ce$var$supportWebGL;
};
$1e103eb4a58e64ce$var$vendor.Int8Array = typeof Int8Array === "undefined" ? Array : Int8Array;
$1e103eb4a58e64ce$var$vendor.Uint8Array = typeof Uint8Array === "undefined" ? Array : Uint8Array;
$1e103eb4a58e64ce$var$vendor.Uint16Array = typeof Uint16Array === "undefined" ? Array : Uint16Array;
$1e103eb4a58e64ce$var$vendor.Uint32Array = typeof Uint32Array === "undefined" ? Array : Uint32Array;
$1e103eb4a58e64ce$var$vendor.Int16Array = typeof Int16Array === "undefined" ? Array : Int16Array;
$1e103eb4a58e64ce$var$vendor.Float32Array = typeof Float32Array === "undefined" ? Array : Float32Array;
$1e103eb4a58e64ce$var$vendor.Float64Array = typeof Float64Array === "undefined" ? Array : Float64Array;
var $1e103eb4a58e64ce$var$g = {};
if (typeof window !== "undefined") $1e103eb4a58e64ce$var$g = window;
else if (typeof $parcel$global !== "undefined") $1e103eb4a58e64ce$var$g = $parcel$global;
$1e103eb4a58e64ce$var$vendor.requestAnimationFrame = $1e103eb4a58e64ce$var$g.requestAnimationFrame || $1e103eb4a58e64ce$var$g.msRequestAnimationFrame || $1e103eb4a58e64ce$var$g.mozRequestAnimationFrame || $1e103eb4a58e64ce$var$g.webkitRequestAnimationFrame || function(func) {
    setTimeout(func, 16);
};
$1e103eb4a58e64ce$var$vendor.createCanvas = function() {
    return document.createElement("canvas");
};
$1e103eb4a58e64ce$var$vendor.createImage = function() {
    return new $1e103eb4a58e64ce$var$g.Image();
};
$1e103eb4a58e64ce$var$vendor.request = {
    get: (0, $a8dda860140b8346$export$2e2bcd8739ae039).get
};
$1e103eb4a58e64ce$var$vendor.addEventListener = function(dom, type, func, useCapture) {
    dom.addEventListener(type, func, useCapture);
};
$1e103eb4a58e64ce$var$vendor.removeEventListener = function(dom, type, func) {
    dom.removeEventListener(type, func);
};
var $1e103eb4a58e64ce$export$2e2bcd8739ae039 = $1e103eb4a58e64ce$var$vendor;




/**
 * @namespace clay.core.color
 */ /**
 * Simple double linked list. Compared with array, it has O(1) remove operation.
 * @constructor
 * @alias clay.core.LinkedList
 */ var $ece77a4a6210d548$var$LinkedList = function() {
    /**
     * @type {clay.core.LinkedList.Entry}
     */ this.head = null;
    /**
     * @type {clay.core.LinkedList.Entry}
     */ this.tail = null;
    this._length = 0;
};
/**
 * Insert a new value at the tail
 * @param  {} val
 * @return {clay.core.LinkedList.Entry}
 */ $ece77a4a6210d548$var$LinkedList.prototype.insert = function(val) {
    var entry = new $ece77a4a6210d548$var$LinkedList.Entry(val);
    this.insertEntry(entry);
    return entry;
};
/**
 * Insert a new value at idx
 * @param {number} idx
 * @param  {} val
 * @return {clay.core.LinkedList.Entry}
 */ $ece77a4a6210d548$var$LinkedList.prototype.insertAt = function(idx, val) {
    if (idx < 0) return;
    var next = this.head;
    var cursor = 0;
    while(next && cursor != idx){
        next = next.next;
        cursor++;
    }
    if (next) {
        var entry = new $ece77a4a6210d548$var$LinkedList.Entry(val);
        var prev = next.prev;
        if (!prev) this.head = entry;
        else {
            prev.next = entry;
            entry.prev = prev;
        }
        entry.next = next;
        next.prev = entry;
    } else this.insert(val);
};
$ece77a4a6210d548$var$LinkedList.prototype.insertBeforeEntry = function(val, next) {
    var entry = new $ece77a4a6210d548$var$LinkedList.Entry(val);
    var prev = next.prev;
    if (!prev) this.head = entry;
    else {
        prev.next = entry;
        entry.prev = prev;
    }
    entry.next = next;
    next.prev = entry;
    this._length++;
};
/**
 * Insert an entry at the tail
 * @param  {clay.core.LinkedList.Entry} entry
 */ $ece77a4a6210d548$var$LinkedList.prototype.insertEntry = function(entry) {
    if (!this.head) this.head = this.tail = entry;
    else {
        this.tail.next = entry;
        entry.prev = this.tail;
        this.tail = entry;
    }
    this._length++;
};
/**
 * Remove entry.
 * @param  {clay.core.LinkedList.Entry} entry
 */ $ece77a4a6210d548$var$LinkedList.prototype.remove = function(entry) {
    var prev = entry.prev;
    var next = entry.next;
    if (prev) prev.next = next;
    else // Is head
    this.head = next;
    if (next) next.prev = prev;
    else // Is tail
    this.tail = prev;
    entry.next = entry.prev = null;
    this._length--;
};
/**
 * Remove entry at index.
 * @param  {number} idx
 * @return {}
 */ $ece77a4a6210d548$var$LinkedList.prototype.removeAt = function(idx) {
    if (idx < 0) return;
    var curr = this.head;
    var cursor = 0;
    while(curr && cursor != idx){
        curr = curr.next;
        cursor++;
    }
    if (curr) {
        this.remove(curr);
        return curr.value;
    }
};
/**
 * Get head value
 * @return {}
 */ $ece77a4a6210d548$var$LinkedList.prototype.getHead = function() {
    if (this.head) return this.head.value;
};
/**
 * Get tail value
 * @return {}
 */ $ece77a4a6210d548$var$LinkedList.prototype.getTail = function() {
    if (this.tail) return this.tail.value;
};
/**
 * Get value at idx
 * @param {number} idx
 * @return {}
 */ $ece77a4a6210d548$var$LinkedList.prototype.getAt = function(idx) {
    if (idx < 0) return;
    var curr = this.head;
    var cursor = 0;
    while(curr && cursor != idx){
        curr = curr.next;
        cursor++;
    }
    return curr.value;
};
/**
 * @param  {} value
 * @return {number}
 */ $ece77a4a6210d548$var$LinkedList.prototype.indexOf = function(value) {
    var curr = this.head;
    var cursor = 0;
    while(curr){
        if (curr.value === value) return cursor;
        curr = curr.next;
        cursor++;
    }
};
/**
 * @return {number}
 */ $ece77a4a6210d548$var$LinkedList.prototype.length = function() {
    return this._length;
};
/**
 * If list is empty
 */ $ece77a4a6210d548$var$LinkedList.prototype.isEmpty = function() {
    return this._length === 0;
};
/**
 * @param  {Function} cb
 * @param  {} context
 */ $ece77a4a6210d548$var$LinkedList.prototype.forEach = function(cb, context) {
    var curr = this.head;
    var idx = 0;
    var haveContext = typeof context != "undefined";
    while(curr){
        if (haveContext) cb.call(context, curr.value, idx);
        else cb(curr.value, idx);
        curr = curr.next;
        idx++;
    }
};
/**
 * Clear the list
 */ $ece77a4a6210d548$var$LinkedList.prototype.clear = function() {
    this.tail = this.head = null;
    this._length = 0;
};
/**
 * @constructor
 * @param {} val
 */ $ece77a4a6210d548$var$LinkedList.Entry = function(val) {
    /**
     * @type {}
     */ this.value = val;
    /**
     * @type {clay.core.LinkedList.Entry}
     */ this.next = null;
    /**
     * @type {clay.core.LinkedList.Entry}
     */ this.prev = null;
};
var $ece77a4a6210d548$export$2e2bcd8739ae039 = $ece77a4a6210d548$var$LinkedList;


/**
 * LRU Cache
 * @constructor
 * @alias clay.core.LRU
 */ var $b0efb64a61ad4939$var$LRU = function(maxSize) {
    this._list = new (0, $ece77a4a6210d548$export$2e2bcd8739ae039)();
    this._map = {};
    this._maxSize = maxSize || 10;
};
/**
 * Set cache max size
 * @param {number} size
 */ $b0efb64a61ad4939$var$LRU.prototype.setMaxSize = function(size) {
    this._maxSize = size;
};
/**
 * @param  {string} key
 * @param  {} value
 */ $b0efb64a61ad4939$var$LRU.prototype.put = function(key, value) {
    if (!this._map.hasOwnProperty(key)) {
        var len = this._list.length();
        if (len >= this._maxSize && len > 0) {
            // Remove the least recently used
            var leastUsedEntry = this._list.head;
            this._list.remove(leastUsedEntry);
            delete this._map[leastUsedEntry.key];
        }
        var entry = this._list.insert(value);
        entry.key = key;
        this._map[key] = entry;
    }
};
/**
 * @param  {string} key
 * @return {}
 */ $b0efb64a61ad4939$var$LRU.prototype.get = function(key) {
    var entry = this._map[key];
    if (this._map.hasOwnProperty(key)) {
        // Put the latest used entry in the tail
        if (entry !== this._list.tail) {
            this._list.remove(entry);
            this._list.insertEntry(entry);
        }
        return entry.value;
    }
};
/**
 * @param {string} key
 */ $b0efb64a61ad4939$var$LRU.prototype.remove = function(key) {
    var entry = this._map[key];
    if (typeof entry !== "undefined") {
        delete this._map[key];
        this._list.remove(entry);
    }
};
/**
 * Clear the cache
 */ $b0efb64a61ad4939$var$LRU.prototype.clear = function() {
    this._list.clear();
    this._map = {};
};
var $b0efb64a61ad4939$export$2e2bcd8739ae039 = $b0efb64a61ad4939$var$LRU;


var $ad165391027fadd1$var$colorUtil = {};
var $ad165391027fadd1$var$kCSSColorTable = {
    "transparent": [
        0,
        0,
        0,
        0
    ],
    "aliceblue": [
        240,
        248,
        255,
        1
    ],
    "antiquewhite": [
        250,
        235,
        215,
        1
    ],
    "aqua": [
        0,
        255,
        255,
        1
    ],
    "aquamarine": [
        127,
        255,
        212,
        1
    ],
    "azure": [
        240,
        255,
        255,
        1
    ],
    "beige": [
        245,
        245,
        220,
        1
    ],
    "bisque": [
        255,
        228,
        196,
        1
    ],
    "black": [
        0,
        0,
        0,
        1
    ],
    "blanchedalmond": [
        255,
        235,
        205,
        1
    ],
    "blue": [
        0,
        0,
        255,
        1
    ],
    "blueviolet": [
        138,
        43,
        226,
        1
    ],
    "brown": [
        165,
        42,
        42,
        1
    ],
    "burlywood": [
        222,
        184,
        135,
        1
    ],
    "cadetblue": [
        95,
        158,
        160,
        1
    ],
    "chartreuse": [
        127,
        255,
        0,
        1
    ],
    "chocolate": [
        210,
        105,
        30,
        1
    ],
    "coral": [
        255,
        127,
        80,
        1
    ],
    "cornflowerblue": [
        100,
        149,
        237,
        1
    ],
    "cornsilk": [
        255,
        248,
        220,
        1
    ],
    "crimson": [
        220,
        20,
        60,
        1
    ],
    "cyan": [
        0,
        255,
        255,
        1
    ],
    "darkblue": [
        0,
        0,
        139,
        1
    ],
    "darkcyan": [
        0,
        139,
        139,
        1
    ],
    "darkgoldenrod": [
        184,
        134,
        11,
        1
    ],
    "darkgray": [
        169,
        169,
        169,
        1
    ],
    "darkgreen": [
        0,
        100,
        0,
        1
    ],
    "darkgrey": [
        169,
        169,
        169,
        1
    ],
    "darkkhaki": [
        189,
        183,
        107,
        1
    ],
    "darkmagenta": [
        139,
        0,
        139,
        1
    ],
    "darkolivegreen": [
        85,
        107,
        47,
        1
    ],
    "darkorange": [
        255,
        140,
        0,
        1
    ],
    "darkorchid": [
        153,
        50,
        204,
        1
    ],
    "darkred": [
        139,
        0,
        0,
        1
    ],
    "darksalmon": [
        233,
        150,
        122,
        1
    ],
    "darkseagreen": [
        143,
        188,
        143,
        1
    ],
    "darkslateblue": [
        72,
        61,
        139,
        1
    ],
    "darkslategray": [
        47,
        79,
        79,
        1
    ],
    "darkslategrey": [
        47,
        79,
        79,
        1
    ],
    "darkturquoise": [
        0,
        206,
        209,
        1
    ],
    "darkviolet": [
        148,
        0,
        211,
        1
    ],
    "deeppink": [
        255,
        20,
        147,
        1
    ],
    "deepskyblue": [
        0,
        191,
        255,
        1
    ],
    "dimgray": [
        105,
        105,
        105,
        1
    ],
    "dimgrey": [
        105,
        105,
        105,
        1
    ],
    "dodgerblue": [
        30,
        144,
        255,
        1
    ],
    "firebrick": [
        178,
        34,
        34,
        1
    ],
    "floralwhite": [
        255,
        250,
        240,
        1
    ],
    "forestgreen": [
        34,
        139,
        34,
        1
    ],
    "fuchsia": [
        255,
        0,
        255,
        1
    ],
    "gainsboro": [
        220,
        220,
        220,
        1
    ],
    "ghostwhite": [
        248,
        248,
        255,
        1
    ],
    "gold": [
        255,
        215,
        0,
        1
    ],
    "goldenrod": [
        218,
        165,
        32,
        1
    ],
    "gray": [
        128,
        128,
        128,
        1
    ],
    "green": [
        0,
        128,
        0,
        1
    ],
    "greenyellow": [
        173,
        255,
        47,
        1
    ],
    "grey": [
        128,
        128,
        128,
        1
    ],
    "honeydew": [
        240,
        255,
        240,
        1
    ],
    "hotpink": [
        255,
        105,
        180,
        1
    ],
    "indianred": [
        205,
        92,
        92,
        1
    ],
    "indigo": [
        75,
        0,
        130,
        1
    ],
    "ivory": [
        255,
        255,
        240,
        1
    ],
    "khaki": [
        240,
        230,
        140,
        1
    ],
    "lavender": [
        230,
        230,
        250,
        1
    ],
    "lavenderblush": [
        255,
        240,
        245,
        1
    ],
    "lawngreen": [
        124,
        252,
        0,
        1
    ],
    "lemonchiffon": [
        255,
        250,
        205,
        1
    ],
    "lightblue": [
        173,
        216,
        230,
        1
    ],
    "lightcoral": [
        240,
        128,
        128,
        1
    ],
    "lightcyan": [
        224,
        255,
        255,
        1
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210,
        1
    ],
    "lightgray": [
        211,
        211,
        211,
        1
    ],
    "lightgreen": [
        144,
        238,
        144,
        1
    ],
    "lightgrey": [
        211,
        211,
        211,
        1
    ],
    "lightpink": [
        255,
        182,
        193,
        1
    ],
    "lightsalmon": [
        255,
        160,
        122,
        1
    ],
    "lightseagreen": [
        32,
        178,
        170,
        1
    ],
    "lightskyblue": [
        135,
        206,
        250,
        1
    ],
    "lightslategray": [
        119,
        136,
        153,
        1
    ],
    "lightslategrey": [
        119,
        136,
        153,
        1
    ],
    "lightsteelblue": [
        176,
        196,
        222,
        1
    ],
    "lightyellow": [
        255,
        255,
        224,
        1
    ],
    "lime": [
        0,
        255,
        0,
        1
    ],
    "limegreen": [
        50,
        205,
        50,
        1
    ],
    "linen": [
        250,
        240,
        230,
        1
    ],
    "magenta": [
        255,
        0,
        255,
        1
    ],
    "maroon": [
        128,
        0,
        0,
        1
    ],
    "mediumaquamarine": [
        102,
        205,
        170,
        1
    ],
    "mediumblue": [
        0,
        0,
        205,
        1
    ],
    "mediumorchid": [
        186,
        85,
        211,
        1
    ],
    "mediumpurple": [
        147,
        112,
        219,
        1
    ],
    "mediumseagreen": [
        60,
        179,
        113,
        1
    ],
    "mediumslateblue": [
        123,
        104,
        238,
        1
    ],
    "mediumspringgreen": [
        0,
        250,
        154,
        1
    ],
    "mediumturquoise": [
        72,
        209,
        204,
        1
    ],
    "mediumvioletred": [
        199,
        21,
        133,
        1
    ],
    "midnightblue": [
        25,
        25,
        112,
        1
    ],
    "mintcream": [
        245,
        255,
        250,
        1
    ],
    "mistyrose": [
        255,
        228,
        225,
        1
    ],
    "moccasin": [
        255,
        228,
        181,
        1
    ],
    "navajowhite": [
        255,
        222,
        173,
        1
    ],
    "navy": [
        0,
        0,
        128,
        1
    ],
    "oldlace": [
        253,
        245,
        230,
        1
    ],
    "olive": [
        128,
        128,
        0,
        1
    ],
    "olivedrab": [
        107,
        142,
        35,
        1
    ],
    "orange": [
        255,
        165,
        0,
        1
    ],
    "orangered": [
        255,
        69,
        0,
        1
    ],
    "orchid": [
        218,
        112,
        214,
        1
    ],
    "palegoldenrod": [
        238,
        232,
        170,
        1
    ],
    "palegreen": [
        152,
        251,
        152,
        1
    ],
    "paleturquoise": [
        175,
        238,
        238,
        1
    ],
    "palevioletred": [
        219,
        112,
        147,
        1
    ],
    "papayawhip": [
        255,
        239,
        213,
        1
    ],
    "peachpuff": [
        255,
        218,
        185,
        1
    ],
    "peru": [
        205,
        133,
        63,
        1
    ],
    "pink": [
        255,
        192,
        203,
        1
    ],
    "plum": [
        221,
        160,
        221,
        1
    ],
    "powderblue": [
        176,
        224,
        230,
        1
    ],
    "purple": [
        128,
        0,
        128,
        1
    ],
    "red": [
        255,
        0,
        0,
        1
    ],
    "rosybrown": [
        188,
        143,
        143,
        1
    ],
    "royalblue": [
        65,
        105,
        225,
        1
    ],
    "saddlebrown": [
        139,
        69,
        19,
        1
    ],
    "salmon": [
        250,
        128,
        114,
        1
    ],
    "sandybrown": [
        244,
        164,
        96,
        1
    ],
    "seagreen": [
        46,
        139,
        87,
        1
    ],
    "seashell": [
        255,
        245,
        238,
        1
    ],
    "sienna": [
        160,
        82,
        45,
        1
    ],
    "silver": [
        192,
        192,
        192,
        1
    ],
    "skyblue": [
        135,
        206,
        235,
        1
    ],
    "slateblue": [
        106,
        90,
        205,
        1
    ],
    "slategray": [
        112,
        128,
        144,
        1
    ],
    "slategrey": [
        112,
        128,
        144,
        1
    ],
    "snow": [
        255,
        250,
        250,
        1
    ],
    "springgreen": [
        0,
        255,
        127,
        1
    ],
    "steelblue": [
        70,
        130,
        180,
        1
    ],
    "tan": [
        210,
        180,
        140,
        1
    ],
    "teal": [
        0,
        128,
        128,
        1
    ],
    "thistle": [
        216,
        191,
        216,
        1
    ],
    "tomato": [
        255,
        99,
        71,
        1
    ],
    "turquoise": [
        64,
        224,
        208,
        1
    ],
    "violet": [
        238,
        130,
        238,
        1
    ],
    "wheat": [
        245,
        222,
        179,
        1
    ],
    "white": [
        255,
        255,
        255,
        1
    ],
    "whitesmoke": [
        245,
        245,
        245,
        1
    ],
    "yellow": [
        255,
        255,
        0,
        1
    ],
    "yellowgreen": [
        154,
        205,
        50,
        1
    ]
};
function $ad165391027fadd1$var$clampCssByte(i) {
    i = Math.round(i); // Seems to be what Chrome does (vs truncation).
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function $ad165391027fadd1$var$clampCssAngle(i) {
    i = Math.round(i); // Seems to be what Chrome does (vs truncation).
    return i < 0 ? 0 : i > 360 ? 360 : i;
}
function $ad165391027fadd1$var$clampCssFloat(f) {
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function $ad165391027fadd1$var$parseCssInt(str) {
    if (str.length && str.charAt(str.length - 1) === "%") return $ad165391027fadd1$var$clampCssByte(parseFloat(str) / 100 * 255);
    return $ad165391027fadd1$var$clampCssByte(parseInt(str, 10));
}
function $ad165391027fadd1$var$parseCssFloat(str) {
    if (str.length && str.charAt(str.length - 1) === "%") return $ad165391027fadd1$var$clampCssFloat(parseFloat(str) / 100);
    return $ad165391027fadd1$var$clampCssFloat(parseFloat(str));
}
function $ad165391027fadd1$var$cssHueToRgb(m1, m2, h) {
    if (h < 0) h += 1;
    else if (h > 1) h -= 1;
    if (h * 6 < 1) return m1 + (m2 - m1) * h * 6;
    if (h * 2 < 1) return m2;
    if (h * 3 < 2) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    return m1;
}
function $ad165391027fadd1$var$lerpNumber(a, b, p) {
    return a + (b - a) * p;
}
function $ad165391027fadd1$var$setRgba(out, r, g, b, a) {
    out[0] = r;
    out[1] = g;
    out[2] = b;
    out[3] = a;
    return out;
}
function $ad165391027fadd1$var$copyRgba(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
var $ad165391027fadd1$var$colorCache = new (0, $b0efb64a61ad4939$export$2e2bcd8739ae039)(20);
var $ad165391027fadd1$var$lastRemovedArr = null;
function $ad165391027fadd1$var$putToCache(colorStr, rgbaArr) {
    // Reuse removed array
    if ($ad165391027fadd1$var$lastRemovedArr) $ad165391027fadd1$var$copyRgba($ad165391027fadd1$var$lastRemovedArr, rgbaArr);
    $ad165391027fadd1$var$lastRemovedArr = $ad165391027fadd1$var$colorCache.put(colorStr, $ad165391027fadd1$var$lastRemovedArr || rgbaArr.slice());
}
/**
 * @name clay.core.color.parse
 * @param {string} colorStr
 * @param {Array.<number>} out
 * @return {Array.<number>}
 */ $ad165391027fadd1$var$colorUtil.parse = function(colorStr, rgbaArr) {
    if (!colorStr) return;
    rgbaArr = rgbaArr || [];
    var cached = $ad165391027fadd1$var$colorCache.get(colorStr);
    if (cached) return $ad165391027fadd1$var$copyRgba(rgbaArr, cached);
    // colorStr may be not string
    colorStr = colorStr + "";
    // Remove all whitespace, not compliant, but should just be more accepting.
    var str = colorStr.replace(/ /g, "").toLowerCase();
    // Color keywords (and transparent) lookup.
    if (str in $ad165391027fadd1$var$kCSSColorTable) {
        $ad165391027fadd1$var$copyRgba(rgbaArr, $ad165391027fadd1$var$kCSSColorTable[str]);
        $ad165391027fadd1$var$putToCache(colorStr, rgbaArr);
        return rgbaArr;
    }
    // #abc and #abc123 syntax.
    if (str.charAt(0) === "#") {
        if (str.length === 4) {
            var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.
            if (!(iv >= 0 && iv <= 0xfff)) {
                $ad165391027fadd1$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return; // Covers NaN.
            }
            $ad165391027fadd1$var$setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, 1);
            $ad165391027fadd1$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        } else if (str.length === 7) {
            var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.
            if (!(iv >= 0 && iv <= 0xffffff)) {
                $ad165391027fadd1$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return; // Covers NaN.
            }
            $ad165391027fadd1$var$setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, 1);
            $ad165391027fadd1$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        return;
    }
    var op = str.indexOf("("), ep = str.indexOf(")");
    if (op !== -1 && ep + 1 === str.length) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(",");
        var alpha = 1; // To allow case fallthrough.
        switch(fname){
            case "rgba":
                if (params.length !== 4) {
                    $ad165391027fadd1$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                alpha = $ad165391027fadd1$var$parseCssFloat(params.pop()); // jshint ignore:line
            // Fall through.
            case "rgb":
                if (params.length !== 3) {
                    $ad165391027fadd1$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $ad165391027fadd1$var$setRgba(rgbaArr, $ad165391027fadd1$var$parseCssInt(params[0]), $ad165391027fadd1$var$parseCssInt(params[1]), $ad165391027fadd1$var$parseCssInt(params[2]), alpha);
                $ad165391027fadd1$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case "hsla":
                if (params.length !== 4) {
                    $ad165391027fadd1$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                params[3] = $ad165391027fadd1$var$parseCssFloat(params[3]);
                $ad165391027fadd1$var$hsla2rgba(params, rgbaArr);
                $ad165391027fadd1$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case "hsl":
                if (params.length !== 3) {
                    $ad165391027fadd1$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $ad165391027fadd1$var$hsla2rgba(params, rgbaArr);
                $ad165391027fadd1$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            default:
                return;
        }
    }
    $ad165391027fadd1$var$setRgba(rgbaArr, 0, 0, 0, 1);
    return;
};
$ad165391027fadd1$var$colorUtil.parseToFloat = function(colorStr, rgbaArr) {
    rgbaArr = $ad165391027fadd1$var$colorUtil.parse(colorStr, rgbaArr);
    if (!rgbaArr) return;
    rgbaArr[0] /= 255;
    rgbaArr[1] /= 255;
    rgbaArr[2] /= 255;
    return rgbaArr;
};
/**
 * @name clay.core.color.hsla2rgba
 * @param {Array.<number>} hsla
 * @param {Array.<number>} rgba
 * @return {Array.<number>} rgba
 */ function $ad165391027fadd1$var$hsla2rgba(hsla, rgba) {
    var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360; // 0 .. 1
    // NOTE(deanm): According to the CSS spec s/l should only be
    // percentages, but we don't bother and let float or percentage.
    var s = $ad165391027fadd1$var$parseCssFloat(hsla[1]);
    var l = $ad165391027fadd1$var$parseCssFloat(hsla[2]);
    var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
    var m1 = l * 2 - m2;
    rgba = rgba || [];
    $ad165391027fadd1$var$setRgba(rgba, $ad165391027fadd1$var$clampCssByte($ad165391027fadd1$var$cssHueToRgb(m1, m2, h + 1 / 3) * 255), $ad165391027fadd1$var$clampCssByte($ad165391027fadd1$var$cssHueToRgb(m1, m2, h) * 255), $ad165391027fadd1$var$clampCssByte($ad165391027fadd1$var$cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
    if (hsla.length === 4) rgba[3] = hsla[3];
    return rgba;
}
/**
 * @name clay.core.color.rgba2hsla
 * @param {Array.<number>} rgba
 * @return {Array.<number>} hsla
 */ function $ad165391027fadd1$var$rgba2hsla(rgba) {
    if (!rgba) return;
    // RGB from 0 to 255
    var R = rgba[0] / 255;
    var G = rgba[1] / 255;
    var B = rgba[2] / 255;
    var vMin = Math.min(R, G, B); // Min. value of RGB
    var vMax = Math.max(R, G, B); // Max. value of RGB
    var delta = vMax - vMin; // Delta RGB value
    var L = (vMax + vMin) / 2;
    var H;
    var S;
    // HSL results from 0 to 1
    if (delta === 0) {
        H = 0;
        S = 0;
    } else {
        if (L < 0.5) S = delta / (vMax + vMin);
        else S = delta / (2 - vMax - vMin);
        var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
        var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
        var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
        if (R === vMax) H = deltaB - deltaG;
        else if (G === vMax) H = 1 / 3 + deltaR - deltaB;
        else if (B === vMax) H = 2 / 3 + deltaG - deltaR;
        if (H < 0) H += 1;
        if (H > 1) H -= 1;
    }
    var hsla = [
        H * 360,
        S,
        L
    ];
    if (rgba[3] != null) hsla.push(rgba[3]);
    return hsla;
}
/**
 * @name clay.core.color.lift
 * @param {string} color
 * @param {number} level
 * @return {string}
 */ $ad165391027fadd1$var$colorUtil.lift = function(color, level) {
    var colorArr = $ad165391027fadd1$var$colorUtil.parse(color);
    if (colorArr) {
        for(var i = 0; i < 3; i++)if (level < 0) colorArr[i] = colorArr[i] * (1 - level) | 0;
        else colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
        return $ad165391027fadd1$var$colorUtil.stringify(colorArr, colorArr.length === 4 ? "rgba" : "rgb");
    }
};
/**
 * @name clay.core.color.toHex
 * @param {string} color
 * @return {string}
 */ $ad165391027fadd1$var$colorUtil.toHex = function(color) {
    var colorArr = $ad165391027fadd1$var$colorUtil.parse(color);
    if (colorArr) return (16777216 + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
};
/**
 * Map value to color. Faster than lerp methods because color is represented by rgba array.
 * @name clay.core.color
 * @param {number} normalizedValue A float between 0 and 1.
 * @param {Array.<Array.<number>>} colors List of rgba color array
 * @param {Array.<number>} [out] Mapped gba color array
 * @return {Array.<number>} will be null/undefined if input illegal.
 */ $ad165391027fadd1$var$colorUtil.fastLerp = function(normalizedValue, colors, out) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    out = out || [];
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = colors[leftIndex];
    var rightColor = colors[rightIndex];
    var dv = value - leftIndex;
    out[0] = $ad165391027fadd1$var$clampCssByte($ad165391027fadd1$var$lerpNumber(leftColor[0], rightColor[0], dv));
    out[1] = $ad165391027fadd1$var$clampCssByte($ad165391027fadd1$var$lerpNumber(leftColor[1], rightColor[1], dv));
    out[2] = $ad165391027fadd1$var$clampCssByte($ad165391027fadd1$var$lerpNumber(leftColor[2], rightColor[2], dv));
    out[3] = $ad165391027fadd1$var$clampCssFloat($ad165391027fadd1$var$lerpNumber(leftColor[3], rightColor[3], dv));
    return out;
};
$ad165391027fadd1$var$colorUtil.fastMapToColor = $ad165391027fadd1$var$colorUtil.fastLerp;
/**
 * @param {number} normalizedValue A float between 0 and 1.
 * @param {Array.<string>} colors Color list.
 * @param {boolean=} fullOutput Default false.
 * @return {(string|Object)} Result color. If fullOutput,
 *                           return {color: ..., leftIndex: ..., rightIndex: ..., value: ...},
 */ $ad165391027fadd1$var$colorUtil.lerp = function(normalizedValue, colors, fullOutput) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = $ad165391027fadd1$var$colorUtil.parse(colors[leftIndex]);
    var rightColor = $ad165391027fadd1$var$colorUtil.parse(colors[rightIndex]);
    var dv = value - leftIndex;
    var color = $ad165391027fadd1$var$colorUtil.stringify([
        $ad165391027fadd1$var$clampCssByte($ad165391027fadd1$var$lerpNumber(leftColor[0], rightColor[0], dv)),
        $ad165391027fadd1$var$clampCssByte($ad165391027fadd1$var$lerpNumber(leftColor[1], rightColor[1], dv)),
        $ad165391027fadd1$var$clampCssByte($ad165391027fadd1$var$lerpNumber(leftColor[2], rightColor[2], dv)),
        $ad165391027fadd1$var$clampCssFloat($ad165391027fadd1$var$lerpNumber(leftColor[3], rightColor[3], dv))
    ], "rgba");
    return fullOutput ? {
        color: color,
        leftIndex: leftIndex,
        rightIndex: rightIndex,
        value: value
    } : color;
};
/**
 * @deprecated
 */ $ad165391027fadd1$var$colorUtil.mapToColor = $ad165391027fadd1$var$colorUtil.lerp;
/**
 * @name clay.core.color
 * @param {string} color
 * @param {number=} h 0 ~ 360, ignore when null.
 * @param {number=} s 0 ~ 1, ignore when null.
 * @param {number=} l 0 ~ 1, ignore when null.
 * @return {string} Color string in rgba format.
 */ $ad165391027fadd1$var$colorUtil.modifyHSL = function(color, h, s, l) {
    color = $ad165391027fadd1$var$colorUtil.parse(color);
    if (color) {
        color = $ad165391027fadd1$var$rgba2hsla(color);
        h != null && (color[0] = $ad165391027fadd1$var$clampCssAngle(h));
        s != null && (color[1] = $ad165391027fadd1$var$parseCssFloat(s));
        l != null && (color[2] = $ad165391027fadd1$var$parseCssFloat(l));
        return $ad165391027fadd1$var$colorUtil.stringify($ad165391027fadd1$var$hsla2rgba(color), "rgba");
    }
};
/**
 * @param {string} color
 * @param {number=} alpha 0 ~ 1
 * @return {string} Color string in rgba format.
 */ $ad165391027fadd1$var$colorUtil.modifyAlpha = function(color, alpha) {
    color = $ad165391027fadd1$var$colorUtil.parse(color);
    if (color && alpha != null) {
        color[3] = $ad165391027fadd1$var$clampCssFloat(alpha);
        return $ad165391027fadd1$var$colorUtil.stringify(color, "rgba");
    }
};
/**
 * @param {Array.<number>} arrColor like [12,33,44,0.4]
 * @param {string} type 'rgba', 'hsva', ...
 * @return {string} Result color. (If input illegal, return undefined).
 */ $ad165391027fadd1$var$colorUtil.stringify = function(arrColor, type) {
    if (!arrColor || !arrColor.length) return;
    var colorStr = arrColor[0] + "," + arrColor[1] + "," + arrColor[2];
    if (type === "rgba" || type === "hsva" || type === "hsla") colorStr += "," + arrColor[3];
    return type + "(" + colorStr + ")";
};
var $ad165391027fadd1$export$2e2bcd8739ae039 = $ad165391027fadd1$var$colorUtil;


var $b70ebca493753aba$var$parseColor = (0, $ad165391027fadd1$export$2e2bcd8739ae039).parseToFloat;
var $b70ebca493753aba$var$programKeyCache = {};
function $b70ebca493753aba$var$getDefineCode(defines) {
    var defineKeys = Object.keys(defines);
    defineKeys.sort();
    var defineStr = [];
    // Custom Defines
    for(var i = 0; i < defineKeys.length; i++){
        var key = defineKeys[i];
        var value = defines[key];
        if (value === null) defineStr.push(key);
        else defineStr.push(key + " " + value.toString());
    }
    return defineStr.join("\n");
}
function $b70ebca493753aba$var$getProgramKey(vertexDefines, fragmentDefines, enabledTextures) {
    enabledTextures.sort();
    var defineStr = [];
    for(var i = 0; i < enabledTextures.length; i++){
        var symbol = enabledTextures[i];
        defineStr.push(symbol);
    }
    var key = $b70ebca493753aba$var$getDefineCode(vertexDefines) + "\n" + $b70ebca493753aba$var$getDefineCode(fragmentDefines) + "\n" + defineStr.join("\n");
    if ($b70ebca493753aba$var$programKeyCache[key]) return $b70ebca493753aba$var$programKeyCache[key];
    var id = (0, $b22fd57b6bfa77fb$export$2e2bcd8739ae039).genGUID();
    $b70ebca493753aba$var$programKeyCache[key] = id;
    return id;
}
/**
 * Material defines the appearance of mesh surface, like `color`, `roughness`, `metalness`, etc.
 * It contains a {@link clay.Shader} and corresponding uniforms.
 *
 * Here is a basic example to create a standard material
```js
var material = new clay.Material({
    shader: new clay.Shader(
        clay.Shader.source('clay.vertex'),
        clay.Shader.source('clay.fragment')
    )
});
```
 * @constructor clay.Material
 * @extends clay.core.Base
 */ var $b70ebca493753aba$var$Material = (0, $7c62670c05885275$export$2e2bcd8739ae039).extend(function() {
    return /** @lends clay.Material# */ {
        /**
         * @type {string}
         */ name: "",
        /**
         * @type {Object}
         */ // uniforms: null,
        /**
         * @type {clay.Shader}
         */ // shader: null,
        /**
         * @type {boolean}
         */ depthTest: true,
        /**
         * @type {boolean}
         */ depthMask: true,
        /**
         * @type {boolean}
         */ transparent: false,
        /**
         * Blend func is a callback function when the material
         * have custom blending
         * The gl context will be the only argument passed in tho the
         * blend function
         * Detail of blend function in WebGL:
         * http://www.khronos.org/registry/gles/specs/2.0/es_full_spec_2.0.25.pdf
         *
         * Example :
         * function(_gl) {
         *  _gl.blendEquation(_gl.FUNC_ADD);
         *  _gl.blendFunc(_gl.SRC_ALPHA, _gl.ONE_MINUS_SRC_ALPHA);
         * }
         */ blend: null,
        /**
         * If update texture status automatically.
         */ autoUpdateTextureStatus: true,
        uniforms: {},
        vertexDefines: {},
        fragmentDefines: {},
        _textureStatus: {},
        // shadowTransparentMap : null
        // PENDING enable the uniform that only used in shader.
        _enabledUniforms: null
    };
}, function() {
    if (!this.name) this.name = "MATERIAL_" + this.__uid__;
    if (this.shader) // Keep status, mainly preset uniforms, vertexDefines and fragmentDefines
    this.attachShader(this.shader, true);
}, /** @lends clay.Material.prototype */ {
    precision: "highp",
    /**
     * Set material uniform
     * @example
     *  mat.setUniform('color', [1, 1, 1, 1]);
     * @param {string} symbol
     * @param {number|array|clay.Texture|ArrayBufferView} value
     */ setUniform: function(symbol, value) {
        if (value === undefined) console.warn('Uniform value "' + symbol + '" is undefined');
        var uniform = this.uniforms[symbol];
        if (uniform) {
            if (typeof value === "string") // Try to parse as a color. Invalid color string will return null.
            value = $b70ebca493753aba$var$parseColor(value) || value;
            uniform.value = value;
            if (this.autoUpdateTextureStatus && uniform.type === "t") {
                if (value) this.enableTexture(symbol);
                else this.disableTexture(symbol);
            }
        }
    },
    /**
     * @param {Object} obj
     */ setUniforms: function(obj) {
        for(var key in obj){
            var val = obj[key];
            this.setUniform(key, val);
        }
    },
    /**
     * @param  {string}  symbol
     * @return {boolean}
     */ isUniformEnabled: function(symbol) {
        return this._enabledUniforms.indexOf(symbol) >= 0;
    },
    getEnabledUniforms: function() {
        return this._enabledUniforms;
    },
    getTextureUniforms: function() {
        return this._textureUniforms;
    },
    /**
     * Alias of setUniform and setUniforms
     * @param {object|string} symbol
     * @param {number|array|clay.Texture|ArrayBufferView} [value]
     */ set: function(symbol, value) {
        if (typeof symbol === "object") for(var key in symbol){
            var val = symbol[key];
            this.setUniform(key, val);
        }
        else this.setUniform(symbol, value);
    },
    /**
     * Get uniform value
     * @param  {string} symbol
     * @return {number|array|clay.Texture|ArrayBufferView}
     */ get: function(symbol) {
        var uniform = this.uniforms[symbol];
        if (uniform) return uniform.value;
    },
    /**
     * Attach a shader instance
     * @param  {clay.Shader} shader
     * @param  {boolean} keepStatus If try to keep uniform and texture
     */ attachShader: function(shader, keepStatus) {
        var originalUniforms = this.uniforms;
        // Ignore if uniform can use in shader.
        this.uniforms = shader.createUniforms();
        this.shader = shader;
        var uniforms = this.uniforms;
        this._enabledUniforms = Object.keys(uniforms);
        // Make sure uniforms are set in same order to avoid texture slot wrong
        this._enabledUniforms.sort();
        this._textureUniforms = this._enabledUniforms.filter(function(uniformName) {
            var type = this.uniforms[uniformName].type;
            return type === "t" || type === "tv";
        }, this);
        var originalVertexDefines = this.vertexDefines;
        var originalFragmentDefines = this.fragmentDefines;
        this.vertexDefines = (0, $b22fd57b6bfa77fb$export$2e2bcd8739ae039).clone(shader.vertexDefines);
        this.fragmentDefines = (0, $b22fd57b6bfa77fb$export$2e2bcd8739ae039).clone(shader.fragmentDefines);
        if (keepStatus) {
            for(var symbol in originalUniforms)if (uniforms[symbol]) uniforms[symbol].value = originalUniforms[symbol].value;
            (0, $b22fd57b6bfa77fb$export$2e2bcd8739ae039).defaults(this.vertexDefines, originalVertexDefines);
            (0, $b22fd57b6bfa77fb$export$2e2bcd8739ae039).defaults(this.fragmentDefines, originalFragmentDefines);
        }
        var textureStatus = {};
        for(var key in shader.textures)textureStatus[key] = {
            shaderType: shader.textures[key].shaderType,
            type: shader.textures[key].type,
            enabled: keepStatus && this._textureStatus[key] ? this._textureStatus[key].enabled : false
        };
        this._textureStatus = textureStatus;
        this._programKey = "";
    },
    /**
     * Clone a new material and keep uniforms, shader will not be cloned
     * @return {clay.Material}
     */ clone: function() {
        var material = new this.constructor({
            name: this.name,
            shader: this.shader
        });
        for(var symbol in this.uniforms)material.uniforms[symbol].value = this.uniforms[symbol].value;
        material.depthTest = this.depthTest;
        material.depthMask = this.depthMask;
        material.transparent = this.transparent;
        material.blend = this.blend;
        material.vertexDefines = (0, $b22fd57b6bfa77fb$export$2e2bcd8739ae039).clone(this.vertexDefines);
        material.fragmentDefines = (0, $b22fd57b6bfa77fb$export$2e2bcd8739ae039).clone(this.fragmentDefines);
        material.enableTexture(this.getEnabledTextures());
        material.precision = this.precision;
        return material;
    },
    /**
     * Add a #define macro in shader code
     * @param  {string} shaderType Can be vertex, fragment or both
     * @param  {string} symbol
     * @param  {number} [val]
     */ define: function(shaderType, symbol, val) {
        var vertexDefines = this.vertexDefines;
        var fragmentDefines = this.fragmentDefines;
        if (shaderType !== "vertex" && shaderType !== "fragment" && shaderType !== "both" && arguments.length < 3) {
            // shaderType default to be 'both'
            val = symbol;
            symbol = shaderType;
            shaderType = "both";
        }
        val = val != null ? val : null;
        if (shaderType === "vertex" || shaderType === "both") {
            if (vertexDefines[symbol] !== val) {
                vertexDefines[symbol] = val;
                // Mark as dirty
                this._programKey = "";
            }
        }
        if (shaderType === "fragment" || shaderType === "both") {
            if (fragmentDefines[symbol] !== val) {
                fragmentDefines[symbol] = val;
                if (shaderType !== "both") this._programKey = "";
            }
        }
    },
    /**
     * Remove a #define macro in shader code
     * @param  {string} shaderType Can be vertex, fragment or both
     * @param  {string} symbol
     */ undefine: function(shaderType, symbol) {
        if (shaderType !== "vertex" && shaderType !== "fragment" && shaderType !== "both" && arguments.length < 2) {
            // shaderType default to be 'both'
            symbol = shaderType;
            shaderType = "both";
        }
        if (shaderType === "vertex" || shaderType === "both") {
            if (this.isDefined("vertex", symbol)) {
                delete this.vertexDefines[symbol];
                // Mark as dirty
                this._programKey = "";
            }
        }
        if (shaderType === "fragment" || shaderType === "both") {
            if (this.isDefined("fragment", symbol)) {
                delete this.fragmentDefines[symbol];
                if (shaderType !== "both") this._programKey = "";
            }
        }
    },
    /**
     * If macro is defined in shader.
     * @param  {string} shaderType Can be vertex, fragment or both
     * @param  {string} symbol
     */ isDefined: function(shaderType, symbol) {
        // PENDING hasOwnProperty ?
        switch(shaderType){
            case "vertex":
                return this.vertexDefines[symbol] !== undefined;
            case "fragment":
                return this.fragmentDefines[symbol] !== undefined;
        }
    },
    /**
     * Get macro value defined in shader.
     * @param  {string} shaderType Can be vertex, fragment or both
     * @param  {string} symbol
     */ getDefine: function(shaderType, symbol) {
        switch(shaderType){
            case "vertex":
                return this.vertexDefines[symbol];
            case "fragment":
                return this.fragmentDefines[symbol];
        }
    },
    /**
     * Enable a texture, actually it will add a #define macro in the shader code
     * For example, if texture symbol is diffuseMap, it will add a line `#define DIFFUSEMAP_ENABLED` in the shader code
     * @param  {string} symbol
     */ enableTexture: function(symbol) {
        if (Array.isArray(symbol)) {
            for(var i = 0; i < symbol.length; i++)this.enableTexture(symbol[i]);
            return;
        }
        var status = this._textureStatus[symbol];
        if (status) {
            var isEnabled = status.enabled;
            if (!isEnabled) {
                status.enabled = true;
                this._programKey = "";
            }
        }
    },
    /**
     * Enable all textures used in the shader
     */ enableTexturesAll: function() {
        var textureStatus = this._textureStatus;
        for(var symbol in textureStatus)textureStatus[symbol].enabled = true;
        this._programKey = "";
    },
    /**
     * Disable a texture, it remove a #define macro in the shader
     * @param  {string} symbol
     */ disableTexture: function(symbol) {
        if (Array.isArray(symbol)) {
            for(var i = 0; i < symbol.length; i++)this.disableTexture(symbol[i]);
            return;
        }
        var status = this._textureStatus[symbol];
        if (status) {
            var isDisabled = !status.enabled;
            if (!isDisabled) {
                status.enabled = false;
                this._programKey = "";
            }
        }
    },
    /**
     * Disable all textures used in the shader
     */ disableTexturesAll: function() {
        var textureStatus = this._textureStatus;
        for(var symbol in textureStatus)textureStatus[symbol].enabled = false;
        this._programKey = "";
    },
    /**
     * If texture of given type is enabled.
     * @param  {string}  symbol
     * @return {boolean}
     */ isTextureEnabled: function(symbol) {
        var textureStatus = this._textureStatus;
        return !!textureStatus[symbol] && textureStatus[symbol].enabled;
    },
    /**
     * Get all enabled textures
     * @return {string[]}
     */ getEnabledTextures: function() {
        var enabledTextures = [];
        var textureStatus = this._textureStatus;
        for(var symbol in textureStatus)if (textureStatus[symbol].enabled) enabledTextures.push(symbol);
        return enabledTextures;
    },
    /**
     * Mark defines are updated.
     */ dirtyDefines: function() {
        this._programKey = "";
    },
    getProgramKey: function() {
        if (!this._programKey) this._programKey = $b70ebca493753aba$var$getProgramKey(this.vertexDefines, this.fragmentDefines, this.getEnabledTextures());
        return this._programKey;
    }
});
var $b70ebca493753aba$export$2e2bcd8739ae039 = $b70ebca493753aba$var$Material;


/* Copyright (c) 2013, Brandon Jones, Colin MacKenzie IV. All rights reserved.

Redistribution and use in source and binary forms, with or without modification,
are permitted provided that the following conditions are met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.
  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. */ var $fe2a8a9f20126b12$export$65acf2a8af52a190 = 0.000001;
var $fe2a8a9f20126b12$export$b215cfa6c73149fa = Array;
var $fe2a8a9f20126b12$export$45afeab892d5eb82 = Math.random;


/**
 * @class 2 Dimensional Vector
 * @name vec2
 */ var $acfd5e2b3b8997d6$var$vec2 = {};
/**
 * Creates a new, empty vec2
 *
 * @returns {vec2} a new 2D vector
 */ $acfd5e2b3b8997d6$var$vec2.create = function() {
    var out = new (0, $fe2a8a9f20126b12$export$b215cfa6c73149fa)(2);
    out[0] = 0;
    out[1] = 0;
    return out;
};
/**
 * Creates a new vec2 initialized with values from an existing vector
 *
 * @param {vec2} a vector to clone
 * @returns {vec2} a new 2D vector
 */ $acfd5e2b3b8997d6$var$vec2.clone = function(a) {
    var out = new (0, $fe2a8a9f20126b12$export$b215cfa6c73149fa)(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
};
/**
 * Creates a new vec2 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} a new 2D vector
 */ $acfd5e2b3b8997d6$var$vec2.fromValues = function(x, y) {
    var out = new (0, $fe2a8a9f20126b12$export$b215cfa6c73149fa)(2);
    out[0] = x;
    out[1] = y;
    return out;
};
/**
 * Copy the values from one vec2 to another
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the source vector
 * @returns {vec2} out
 */ $acfd5e2b3b8997d6$var$vec2.copy = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
};
/**
 * Set the components of a vec2 to the given values
 *
 * @param {vec2} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} out
 */ $acfd5e2b3b8997d6$var$vec2.set = function(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
};
/**
 * Adds two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */ $acfd5e2b3b8997d6$var$vec2.add = function(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
};
/**
 * Subtracts vector b from vector a
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */ $acfd5e2b3b8997d6$var$vec2.subtract = function(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
};
/**
 * Alias for {@link vec2.subtract}
 * @function
 */ $acfd5e2b3b8997d6$var$vec2.sub = $acfd5e2b3b8997d6$var$vec2.subtract;
/**
 * Multiplies two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */ $acfd5e2b3b8997d6$var$vec2.multiply = function(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
};
/**
 * Alias for {@link vec2.multiply}
 * @function
 */ $acfd5e2b3b8997d6$var$vec2.mul = $acfd5e2b3b8997d6$var$vec2.multiply;
/**
 * Divides two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */ $acfd5e2b3b8997d6$var$vec2.divide = function(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
};
/**
 * Alias for {@link vec2.divide}
 * @function
 */ $acfd5e2b3b8997d6$var$vec2.div = $acfd5e2b3b8997d6$var$vec2.divide;
/**
 * Returns the minimum of two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */ $acfd5e2b3b8997d6$var$vec2.min = function(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    return out;
};
/**
 * Returns the maximum of two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */ $acfd5e2b3b8997d6$var$vec2.max = function(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    return out;
};
/**
 * Scales a vec2 by a scalar number
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec2} out
 */ $acfd5e2b3b8997d6$var$vec2.scale = function(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
};
/**
 * Adds two vec2's after scaling the second operand by a scalar value
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec2} out
 */ $acfd5e2b3b8997d6$var$vec2.scaleAndAdd = function(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    return out;
};
/**
 * Calculates the euclidian distance between two vec2's
 *
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {Number} distance between a and b
 */ $acfd5e2b3b8997d6$var$vec2.distance = function(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.sqrt(x * x + y * y);
};
/**
 * Alias for {@link vec2.distance}
 * @function
 */ $acfd5e2b3b8997d6$var$vec2.dist = $acfd5e2b3b8997d6$var$vec2.distance;
/**
 * Calculates the squared euclidian distance between two vec2's
 *
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {Number} squared distance between a and b
 */ $acfd5e2b3b8997d6$var$vec2.squaredDistance = function(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
};
/**
 * Alias for {@link vec2.squaredDistance}
 * @function
 */ $acfd5e2b3b8997d6$var$vec2.sqrDist = $acfd5e2b3b8997d6$var$vec2.squaredDistance;
/**
 * Calculates the length of a vec2
 *
 * @param {vec2} a vector to calculate length of
 * @returns {Number} length of a
 */ $acfd5e2b3b8997d6$var$vec2.length = function(a) {
    var x = a[0], y = a[1];
    return Math.sqrt(x * x + y * y);
};
/**
 * Alias for {@link vec2.length}
 * @function
 */ $acfd5e2b3b8997d6$var$vec2.len = $acfd5e2b3b8997d6$var$vec2.length;
/**
 * Calculates the squared length of a vec2
 *
 * @param {vec2} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */ $acfd5e2b3b8997d6$var$vec2.squaredLength = function(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
};
/**
 * Alias for {@link vec2.squaredLength}
 * @function
 */ $acfd5e2b3b8997d6$var$vec2.sqrLen = $acfd5e2b3b8997d6$var$vec2.squaredLength;
/**
 * Negates the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to negate
 * @returns {vec2} out
 */ $acfd5e2b3b8997d6$var$vec2.negate = function(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
};
/**
 * Returns the inverse of the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to invert
 * @returns {vec2} out
 */ $acfd5e2b3b8997d6$var$vec2.inverse = function(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    return out;
};
/**
 * Normalize a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to normalize
 * @returns {vec2} out
 */ $acfd5e2b3b8997d6$var$vec2.normalize = function(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) {
        //TODO: evaluate use of glm_invsqrt here?
        len = 1 / Math.sqrt(len);
        out[0] = a[0] * len;
        out[1] = a[1] * len;
    }
    return out;
};
/**
 * Calculates the dot product of two vec2's
 *
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {Number} dot product of a and b
 */ $acfd5e2b3b8997d6$var$vec2.dot = function(a, b) {
    return a[0] * b[0] + a[1] * b[1];
};
/**
 * Computes the cross product of two vec2's
 * Note that the cross product must by definition produce a 3D vector
 *
 * @param {vec3} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec3} out
 */ $acfd5e2b3b8997d6$var$vec2.cross = function(out, a, b) {
    var z = a[0] * b[1] - a[1] * b[0];
    out[0] = out[1] = 0;
    out[2] = z;
    return out;
};
/**
 * Performs a linear interpolation between two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec2} out
 */ $acfd5e2b3b8997d6$var$vec2.lerp = function(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
};
/**
 * Generates a random vector with the given scale
 *
 * @param {vec2} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec2} out
 */ $acfd5e2b3b8997d6$var$vec2.random = function(out, scale) {
    scale = scale || 1.0;
    var r = GLMAT_RANDOM() * 2.0 * Math.PI;
    out[0] = Math.cos(r) * scale;
    out[1] = Math.sin(r) * scale;
    return out;
};
/**
 * Transforms the vec2 with a mat2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat2} m matrix to transform with
 * @returns {vec2} out
 */ $acfd5e2b3b8997d6$var$vec2.transformMat2 = function(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
};
/**
 * Transforms the vec2 with a mat2d
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat2d} m matrix to transform with
 * @returns {vec2} out
 */ $acfd5e2b3b8997d6$var$vec2.transformMat2d = function(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
};
/**
 * Transforms the vec2 with a mat3
 * 3rd vector component is implicitly '1'
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat3} m matrix to transform with
 * @returns {vec2} out
 */ $acfd5e2b3b8997d6$var$vec2.transformMat3 = function(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
};
/**
 * Transforms the vec2 with a mat4
 * 3rd vector component is implicitly '0'
 * 4th vector component is implicitly '1'
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat4} m matrix to transform with
 * @returns {vec2} out
 */ $acfd5e2b3b8997d6$var$vec2.transformMat4 = function(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
};
/**
 * Perform some operation over an array of vec2s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec2. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec2s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */ $acfd5e2b3b8997d6$var$vec2.forEach = function() {
    var vec = $acfd5e2b3b8997d6$var$vec2.create();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 2;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
        }
        return a;
    };
}();
var $acfd5e2b3b8997d6$export$2e2bcd8739ae039 = $acfd5e2b3b8997d6$var$vec2;


/**
 * @constructor
 * @alias clay.Vector2
 * @param {number} x
 * @param {number} y
 */ var $2cb41795bddfe4d3$var$Vector2 = function(x, y) {
    x = x || 0;
    y = y || 0;
    /**
     * Storage of Vector2, read and write of x, y will change the values in array
     * All methods also operate on the array instead of x, y components
     * @name array
     * @type {Float32Array}
     * @memberOf clay.Vector2#
     */ this.array = (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).fromValues(x, y);
    /**
     * Dirty flag is used by the Node to determine
     * if the matrix is updated to latest
     * @name _dirty
     * @type {boolean}
     * @memberOf clay.Vector2#
     */ this._dirty = true;
};
$2cb41795bddfe4d3$var$Vector2.prototype = {
    constructor: $2cb41795bddfe4d3$var$Vector2,
    /**
     * Add b to self
     * @param  {clay.Vector2} b
     * @return {clay.Vector2}
     */ add: function(b) {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).add(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Set x and y components
     * @param  {number}  x
     * @param  {number}  y
     * @return {clay.Vector2}
     */ set: function(x, y) {
        this.array[0] = x;
        this.array[1] = y;
        this._dirty = true;
        return this;
    },
    /**
     * Set x and y components from array
     * @param  {Float32Array|number[]} arr
     * @return {clay.Vector2}
     */ setArray: function(arr) {
        this.array[0] = arr[0];
        this.array[1] = arr[1];
        this._dirty = true;
        return this;
    },
    /**
     * Clone a new Vector2
     * @return {clay.Vector2}
     */ clone: function() {
        return new $2cb41795bddfe4d3$var$Vector2(this.x, this.y);
    },
    /**
     * Copy x, y from b
     * @param  {clay.Vector2} b
     * @return {clay.Vector2}
     */ copy: function(b) {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).copy(this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Cross product of self and b, written to a Vector3 out
     * @param  {clay.Vector3} out
     * @param  {clay.Vector2} b
     * @return {clay.Vector2}
     */ cross: function(out, b) {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).cross(out.array, this.array, b.array);
        out._dirty = true;
        return this;
    },
    /**
     * Alias for distance
     * @param  {clay.Vector2} b
     * @return {number}
     */ dist: function(b) {
        return (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).dist(this.array, b.array);
    },
    /**
     * Distance between self and b
     * @param  {clay.Vector2} b
     * @return {number}
     */ distance: function(b) {
        return (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).distance(this.array, b.array);
    },
    /**
     * Alias for divide
     * @param  {clay.Vector2} b
     * @return {clay.Vector2}
     */ div: function(b) {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).div(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Divide self by b
     * @param  {clay.Vector2} b
     * @return {clay.Vector2}
     */ divide: function(b) {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).divide(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Dot product of self and b
     * @param  {clay.Vector2} b
     * @return {number}
     */ dot: function(b) {
        return (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).dot(this.array, b.array);
    },
    /**
     * Alias of length
     * @return {number}
     */ len: function() {
        return (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).len(this.array);
    },
    /**
     * Calculate the length
     * @return {number}
     */ length: function() {
        return (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).length(this.array);
    },
    /**
     * Linear interpolation between a and b
     * @param  {clay.Vector2} a
     * @param  {clay.Vector2} b
     * @param  {number}  t
     * @return {clay.Vector2}
     */ lerp: function(a, b, t) {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).lerp(this.array, a.array, b.array, t);
        this._dirty = true;
        return this;
    },
    /**
     * Minimum of self and b
     * @param  {clay.Vector2} b
     * @return {clay.Vector2}
     */ min: function(b) {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).min(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Maximum of self and b
     * @param  {clay.Vector2} b
     * @return {clay.Vector2}
     */ max: function(b) {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).max(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Alias for multiply
     * @param  {clay.Vector2} b
     * @return {clay.Vector2}
     */ mul: function(b) {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).mul(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Mutiply self and b
     * @param  {clay.Vector2} b
     * @return {clay.Vector2}
     */ multiply: function(b) {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).multiply(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Negate self
     * @return {clay.Vector2}
     */ negate: function() {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).negate(this.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Normalize self
     * @return {clay.Vector2}
     */ normalize: function() {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).normalize(this.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Generate random x, y components with a given scale
     * @param  {number} scale
     * @return {clay.Vector2}
     */ random: function(scale) {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).random(this.array, scale);
        this._dirty = true;
        return this;
    },
    /**
     * Scale self
     * @param  {number}  scale
     * @return {clay.Vector2}
     */ scale: function(s) {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).scale(this.array, this.array, s);
        this._dirty = true;
        return this;
    },
    /**
     * Scale b and add to self
     * @param  {clay.Vector2} b
     * @param  {number}  scale
     * @return {clay.Vector2}
     */ scaleAndAdd: function(b, s) {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).scaleAndAdd(this.array, this.array, b.array, s);
        this._dirty = true;
        return this;
    },
    /**
     * Alias for squaredDistance
     * @param  {clay.Vector2} b
     * @return {number}
     */ sqrDist: function(b) {
        return (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).sqrDist(this.array, b.array);
    },
    /**
     * Squared distance between self and b
     * @param  {clay.Vector2} b
     * @return {number}
     */ squaredDistance: function(b) {
        return (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).squaredDistance(this.array, b.array);
    },
    /**
     * Alias for squaredLength
     * @return {number}
     */ sqrLen: function() {
        return (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).sqrLen(this.array);
    },
    /**
     * Squared length of self
     * @return {number}
     */ squaredLength: function() {
        return (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).squaredLength(this.array);
    },
    /**
     * Alias for subtract
     * @param  {clay.Vector2} b
     * @return {clay.Vector2}
     */ sub: function(b) {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).sub(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Subtract b from self
     * @param  {clay.Vector2} b
     * @return {clay.Vector2}
     */ subtract: function(b) {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).subtract(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Transform self with a Matrix2 m
     * @param  {clay.Matrix2} m
     * @return {clay.Vector2}
     */ transformMat2: function(m) {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).transformMat2(this.array, this.array, m.array);
        this._dirty = true;
        return this;
    },
    /**
     * Transform self with a Matrix2d m
     * @param  {clay.Matrix2d} m
     * @return {clay.Vector2}
     */ transformMat2d: function(m) {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).transformMat2d(this.array, this.array, m.array);
        this._dirty = true;
        return this;
    },
    /**
     * Transform self with a Matrix3 m
     * @param  {clay.Matrix3} m
     * @return {clay.Vector2}
     */ transformMat3: function(m) {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).transformMat3(this.array, this.array, m.array);
        this._dirty = true;
        return this;
    },
    /**
     * Transform self with a Matrix4 m
     * @param  {clay.Matrix4} m
     * @return {clay.Vector2}
     */ transformMat4: function(m) {
        (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).transformMat4(this.array, this.array, m.array);
        this._dirty = true;
        return this;
    },
    toString: function() {
        return "[" + Array.prototype.join.call(this.array, ",") + "]";
    },
    toArray: function() {
        return Array.prototype.slice.call(this.array);
    }
};
// Getter and Setter
if (Object.defineProperty) {
    var $2cb41795bddfe4d3$var$proto = $2cb41795bddfe4d3$var$Vector2.prototype;
    /**
     * @name x
     * @type {number}
     * @memberOf clay.Vector2
     * @instance
     */ Object.defineProperty($2cb41795bddfe4d3$var$proto, "x", {
        get: function() {
            return this.array[0];
        },
        set: function(value) {
            this.array[0] = value;
            this._dirty = true;
        }
    });
    /**
     * @name y
     * @type {number}
     * @memberOf clay.Vector2
     * @instance
     */ Object.defineProperty($2cb41795bddfe4d3$var$proto, "y", {
        get: function() {
            return this.array[1];
        },
        set: function(value) {
            this.array[1] = value;
            this._dirty = true;
        }
    });
}
// Supply methods that are not in place
/**
 * @param  {clay.Vector2} out
 * @param  {clay.Vector2} a
 * @param  {clay.Vector2} b
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.add = function(out, a, b) {
    (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).add(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector2} out
 * @param  {number}  x
 * @param  {number}  y
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.set = function(out, x, y) {
    (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).set(out.array, x, y);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector2} out
 * @param  {clay.Vector2} b
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.copy = function(out, b) {
    (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).copy(out.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector3} out
 * @param  {clay.Vector2} a
 * @param  {clay.Vector2} b
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.cross = function(out, a, b) {
    (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).cross(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector2} a
 * @param  {clay.Vector2} b
 * @return {number}
 */ $2cb41795bddfe4d3$var$Vector2.dist = function(a, b) {
    return (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).distance(a.array, b.array);
};
/**
 * @function
 * @param  {clay.Vector2} a
 * @param  {clay.Vector2} b
 * @return {number}
 */ $2cb41795bddfe4d3$var$Vector2.distance = $2cb41795bddfe4d3$var$Vector2.dist;
/**
 * @param  {clay.Vector2} out
 * @param  {clay.Vector2} a
 * @param  {clay.Vector2} b
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.div = function(out, a, b) {
    (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).divide(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @function
 * @param  {clay.Vector2} out
 * @param  {clay.Vector2} a
 * @param  {clay.Vector2} b
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.divide = $2cb41795bddfe4d3$var$Vector2.div;
/**
 * @param  {clay.Vector2} a
 * @param  {clay.Vector2} b
 * @return {number}
 */ $2cb41795bddfe4d3$var$Vector2.dot = function(a, b) {
    return (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).dot(a.array, b.array);
};
/**
 * @param  {clay.Vector2} a
 * @return {number}
 */ $2cb41795bddfe4d3$var$Vector2.len = function(b) {
    return (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).length(b.array);
};
// Vector2.length = Vector2.len;
/**
 * @param  {clay.Vector2} out
 * @param  {clay.Vector2} a
 * @param  {clay.Vector2} b
 * @param  {number}  t
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.lerp = function(out, a, b, t) {
    (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).lerp(out.array, a.array, b.array, t);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector2} out
 * @param  {clay.Vector2} a
 * @param  {clay.Vector2} b
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.min = function(out, a, b) {
    (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).min(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector2} out
 * @param  {clay.Vector2} a
 * @param  {clay.Vector2} b
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.max = function(out, a, b) {
    (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).max(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector2} out
 * @param  {clay.Vector2} a
 * @param  {clay.Vector2} b
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.mul = function(out, a, b) {
    (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).multiply(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @function
 * @param  {clay.Vector2} out
 * @param  {clay.Vector2} a
 * @param  {clay.Vector2} b
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.multiply = $2cb41795bddfe4d3$var$Vector2.mul;
/**
 * @param  {clay.Vector2} out
 * @param  {clay.Vector2} a
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.negate = function(out, a) {
    (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).negate(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector2} out
 * @param  {clay.Vector2} a
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.normalize = function(out, a) {
    (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).normalize(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector2} out
 * @param  {number}  scale
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.random = function(out, scale) {
    (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).random(out.array, scale);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector2} out
 * @param  {clay.Vector2} a
 * @param  {number}  scale
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.scale = function(out, a, scale) {
    (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).scale(out.array, a.array, scale);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector2} out
 * @param  {clay.Vector2} a
 * @param  {clay.Vector2} b
 * @param  {number}  scale
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.scaleAndAdd = function(out, a, b, scale) {
    (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).scaleAndAdd(out.array, a.array, b.array, scale);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector2} a
 * @param  {clay.Vector2} b
 * @return {number}
 */ $2cb41795bddfe4d3$var$Vector2.sqrDist = function(a, b) {
    return (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).sqrDist(a.array, b.array);
};
/**
 * @function
 * @param  {clay.Vector2} a
 * @param  {clay.Vector2} b
 * @return {number}
 */ $2cb41795bddfe4d3$var$Vector2.squaredDistance = $2cb41795bddfe4d3$var$Vector2.sqrDist;
/**
 * @param  {clay.Vector2} a
 * @return {number}
 */ $2cb41795bddfe4d3$var$Vector2.sqrLen = function(a) {
    return (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).sqrLen(a.array);
};
/**
 * @function
 * @param  {clay.Vector2} a
 * @return {number}
 */ $2cb41795bddfe4d3$var$Vector2.squaredLength = $2cb41795bddfe4d3$var$Vector2.sqrLen;
/**
 * @param  {clay.Vector2} out
 * @param  {clay.Vector2} a
 * @param  {clay.Vector2} b
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.sub = function(out, a, b) {
    (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).subtract(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @function
 * @param  {clay.Vector2} out
 * @param  {clay.Vector2} a
 * @param  {clay.Vector2} b
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.subtract = $2cb41795bddfe4d3$var$Vector2.sub;
/**
 * @param  {clay.Vector2} out
 * @param  {clay.Vector2} a
 * @param  {clay.Matrix2} m
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.transformMat2 = function(out, a, m) {
    (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).transformMat2(out.array, a.array, m.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector2}  out
 * @param  {clay.Vector2}  a
 * @param  {clay.Matrix2d} m
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.transformMat2d = function(out, a, m) {
    (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).transformMat2d(out.array, a.array, m.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector2} out
 * @param  {clay.Vector2} a
 * @param  {Matrix3} m
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.transformMat3 = function(out, a, m) {
    (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).transformMat3(out.array, a.array, m.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector2} out
 * @param  {clay.Vector2} a
 * @param  {clay.Matrix4} m
 * @return {clay.Vector2}
 */ $2cb41795bddfe4d3$var$Vector2.transformMat4 = function(out, a, m) {
    (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039).transformMat4(out.array, a.array, m.array);
    out._dirty = true;
    return out;
};
var $2cb41795bddfe4d3$export$2e2bcd8739ae039 = $2cb41795bddfe4d3$var$Vector2;




var $59d30562deed942e$var$SHADER_STATE_TO_ENABLE = 1;
var $59d30562deed942e$var$SHADER_STATE_KEEP_ENABLE = 2;
var $59d30562deed942e$var$SHADER_STATE_PENDING = 3;
// Enable attribute operation is global to all programs
// Here saved the list of all enabled attribute index
// http://www.mjbshaw.com/2013/03/webgl-fixing-invalidoperation.html
var $59d30562deed942e$var$enabledAttributeList = {};
// some util functions
function $59d30562deed942e$var$addLineNumbers(string) {
    var chunks = string.split("\n");
    for(var i = 0, il = chunks.length; i < il; i++)// Chrome reports shader errors on lines
    // starting counting from 1
    chunks[i] = i + 1 + ": " + chunks[i];
    return chunks.join("\n");
}
// Return true or error msg if error happened
function $59d30562deed942e$var$checkShaderErrorMsg(_gl, shader, shaderString) {
    if (!_gl.getShaderParameter(shader, _gl.COMPILE_STATUS)) return [
        _gl.getShaderInfoLog(shader),
        $59d30562deed942e$var$addLineNumbers(shaderString)
    ].join("\n");
}
var $59d30562deed942e$var$tmpFloat32Array16 = new (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).Float32Array(16);
var $59d30562deed942e$var$GLProgram = (0, $7c62670c05885275$export$2e2bcd8739ae039).extend({
    uniformSemantics: {},
    attributes: {}
}, function() {
    this._locations = {};
    this._textureSlot = 0;
    this._program = null;
}, {
    bind: function(renderer) {
        this._textureSlot = 0;
        renderer.gl.useProgram(this._program);
    },
    hasUniform: function(symbol) {
        var location = this._locations[symbol];
        return location !== null && location !== undefined;
    },
    useTextureSlot: function(renderer, texture, slot) {
        if (texture) {
            renderer.gl.activeTexture(renderer.gl.TEXTURE0 + slot);
            // Maybe texture is not loaded yet;
            if (texture.isRenderable()) texture.bind(renderer);
            else // Bind texture to null
            texture.unbind(renderer);
        }
    },
    currentTextureSlot: function() {
        return this._textureSlot;
    },
    resetTextureSlot: function(slot) {
        this._textureSlot = slot || 0;
    },
    takeCurrentTextureSlot: function(renderer, texture) {
        var textureSlot = this._textureSlot;
        this.useTextureSlot(renderer, texture, textureSlot);
        this._textureSlot++;
        return textureSlot;
    },
    setUniform: function(_gl, type, symbol, value) {
        var locationMap = this._locations;
        var location = locationMap[symbol];
        // Uniform is not existed in the shader
        if (location === null || location === undefined) return false;
        switch(type){
            case "m4":
                if (!(value instanceof Float32Array)) {
                    // Use Float32Array is much faster than array when uniformMatrix4fv.
                    for(var i = 0; i < value.length; i++)$59d30562deed942e$var$tmpFloat32Array16[i] = value[i];
                    value = $59d30562deed942e$var$tmpFloat32Array16;
                }
                _gl.uniformMatrix4fv(location, false, value);
                break;
            case "2i":
                _gl.uniform2i(location, value[0], value[1]);
                break;
            case "2f":
                _gl.uniform2f(location, value[0], value[1]);
                break;
            case "3i":
                _gl.uniform3i(location, value[0], value[1], value[2]);
                break;
            case "3f":
                _gl.uniform3f(location, value[0], value[1], value[2]);
                break;
            case "4i":
                _gl.uniform4i(location, value[0], value[1], value[2], value[3]);
                break;
            case "4f":
                _gl.uniform4f(location, value[0], value[1], value[2], value[3]);
                break;
            case "1i":
                _gl.uniform1i(location, value);
                break;
            case "1f":
                _gl.uniform1f(location, value);
                break;
            case "1fv":
                _gl.uniform1fv(location, value);
                break;
            case "1iv":
                _gl.uniform1iv(location, value);
                break;
            case "2iv":
                _gl.uniform2iv(location, value);
                break;
            case "2fv":
                _gl.uniform2fv(location, value);
                break;
            case "3iv":
                _gl.uniform3iv(location, value);
                break;
            case "3fv":
                _gl.uniform3fv(location, value);
                break;
            case "4iv":
                _gl.uniform4iv(location, value);
                break;
            case "4fv":
                _gl.uniform4fv(location, value);
                break;
            case "m2":
            case "m2v":
                _gl.uniformMatrix2fv(location, false, value);
                break;
            case "m3":
            case "m3v":
                _gl.uniformMatrix3fv(location, false, value);
                break;
            case "m4v":
                // Raw value
                if (Array.isArray(value) && Array.isArray(value[0])) {
                    var array = new (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).Float32Array(value.length * 16);
                    var cursor = 0;
                    for(var i = 0; i < value.length; i++){
                        var item = value[i];
                        for(var j = 0; j < 16; j++)array[cursor++] = item[j];
                    }
                    _gl.uniformMatrix4fv(location, false, array);
                } else _gl.uniformMatrix4fv(location, false, value);
                break;
        }
        return true;
    },
    setUniformOfSemantic: function(_gl, semantic, val) {
        var semanticInfo = this.uniformSemantics[semantic];
        if (semanticInfo) return this.setUniform(_gl, semanticInfo.type, semanticInfo.symbol, val);
        return false;
    },
    // Used for creating VAO
    // Enable the attributes passed in and disable the rest
    // Example Usage:
    // enableAttributes(renderer, ["position", "texcoords"])
    enableAttributes: function(renderer, attribList, vao) {
        var _gl = renderer.gl;
        var program = this._program;
        var locationMap = this._locations;
        var enabledAttributeListInContext;
        if (vao) enabledAttributeListInContext = vao.__enabledAttributeList;
        else enabledAttributeListInContext = $59d30562deed942e$var$enabledAttributeList[renderer.__uid__];
        if (!enabledAttributeListInContext) {
            // In vertex array object context
            // PENDING Each vao object needs to enable attributes again?
            if (vao) enabledAttributeListInContext = vao.__enabledAttributeList = [];
            else enabledAttributeListInContext = $59d30562deed942e$var$enabledAttributeList[renderer.__uid__] = [];
        }
        var locationList = [];
        for(var i = 0; i < attribList.length; i++){
            var symbol = attribList[i];
            if (!this.attributes[symbol]) {
                locationList[i] = -1;
                continue;
            }
            var location = locationMap[symbol];
            if (location == null) {
                location = _gl.getAttribLocation(program, symbol);
                // Attrib location is a number from 0 to ...
                if (location === -1) {
                    locationList[i] = -1;
                    continue;
                }
                locationMap[symbol] = location;
            }
            locationList[i] = location;
            if (!enabledAttributeListInContext[location]) enabledAttributeListInContext[location] = $59d30562deed942e$var$SHADER_STATE_TO_ENABLE;
            else enabledAttributeListInContext[location] = $59d30562deed942e$var$SHADER_STATE_KEEP_ENABLE;
        }
        for(var i = 0; i < enabledAttributeListInContext.length; i++)switch(enabledAttributeListInContext[i]){
            case $59d30562deed942e$var$SHADER_STATE_TO_ENABLE:
                _gl.enableVertexAttribArray(i);
                enabledAttributeListInContext[i] = $59d30562deed942e$var$SHADER_STATE_PENDING;
                break;
            case $59d30562deed942e$var$SHADER_STATE_KEEP_ENABLE:
                enabledAttributeListInContext[i] = $59d30562deed942e$var$SHADER_STATE_PENDING;
                break;
            // Expired
            case $59d30562deed942e$var$SHADER_STATE_PENDING:
                _gl.disableVertexAttribArray(i);
                enabledAttributeListInContext[i] = 0;
                break;
        }
        return locationList;
    },
    getAttribLocation: function(_gl, symbol) {
        var locationMap = this._locations;
        var location = locationMap[symbol];
        if (location == null) {
            location = _gl.getAttribLocation(this._program, symbol);
            locationMap[symbol] = location;
        }
        return location;
    },
    buildProgram: function(_gl, shader, vertexShaderCode, fragmentShaderCode) {
        var vertexShader = _gl.createShader(_gl.VERTEX_SHADER);
        var program = _gl.createProgram();
        _gl.shaderSource(vertexShader, vertexShaderCode);
        _gl.compileShader(vertexShader);
        var fragmentShader = _gl.createShader(_gl.FRAGMENT_SHADER);
        _gl.shaderSource(fragmentShader, fragmentShaderCode);
        _gl.compileShader(fragmentShader);
        var msg = $59d30562deed942e$var$checkShaderErrorMsg(_gl, vertexShader, vertexShaderCode);
        if (msg) return msg;
        msg = $59d30562deed942e$var$checkShaderErrorMsg(_gl, fragmentShader, fragmentShaderCode);
        if (msg) return msg;
        _gl.attachShader(program, vertexShader);
        _gl.attachShader(program, fragmentShader);
        // Force the position bind to location 0;
        if (shader.attributeSemantics["POSITION"]) _gl.bindAttribLocation(program, 0, shader.attributeSemantics["POSITION"].symbol);
        else {
            // Else choose an attribute and bind to location 0;
            var keys = Object.keys(this.attributes);
            _gl.bindAttribLocation(program, 0, keys[0]);
        }
        _gl.linkProgram(program);
        _gl.deleteShader(vertexShader);
        _gl.deleteShader(fragmentShader);
        this._program = program;
        // Save code.
        this.vertexCode = vertexShaderCode;
        this.fragmentCode = fragmentShaderCode;
        if (!_gl.getProgramParameter(program, _gl.LINK_STATUS)) return "Could not link program\n" + _gl.getProgramInfoLog(program);
        // Cache uniform locations
        for(var i = 0; i < shader.uniforms.length; i++){
            var uniformSymbol = shader.uniforms[i];
            this._locations[uniformSymbol] = _gl.getUniformLocation(program, uniformSymbol);
        }
    }
});
var $59d30562deed942e$export$2e2bcd8739ae039 = $59d30562deed942e$var$GLProgram;


var $8ffa8760a533af20$var$loopRegex = /for\s*?\(int\s*?_idx_\s*\=\s*([\w-]+)\;\s*_idx_\s*<\s*([\w-]+);\s*_idx_\s*\+\+\s*\)\s*\{\{([\s\S]+?)(?=\}\})\}\}/g;
function $8ffa8760a533af20$var$unrollLoop(shaderStr, defines, lightsNumbers) {
    // Loop unroll from three.js, https://github.com/mrdoob/three.js/blob/master/src/renderers/webgl/WebGLProgram.js#L175
    // In some case like shadowMap in loop use 'i' to index value much slower.
    // Loop use _idx_ and increased with _idx_++ will be unrolled
    // Use {{ }} to match the pair so the if statement will not be affected
    // Write like following
    // for (int _idx_ = 0; _idx_ < 4; _idx_++) {{
    //     vec3 color = texture2D(textures[_idx_], uv).rgb;
    // }}
    function replace(match, start, end, snippet) {
        var unroll = "";
        // Try to treat as define
        if (isNaN(start)) {
            if (start in defines) start = defines[start];
            else start = lightNumberDefines[start];
        }
        if (isNaN(end)) {
            if (end in defines) end = defines[end];
            else end = lightNumberDefines[end];
        }
        // TODO Error checking
        for(var idx = parseInt(start); idx < parseInt(end); idx++)// PENDING Add scope?
        unroll += "{" + snippet.replace(/float\s*\(\s*_idx_\s*\)/g, idx.toFixed(1)).replace(/_idx_/g, idx) + "}";
        return unroll;
    }
    var lightNumberDefines = {};
    for(var lightType in lightsNumbers)lightNumberDefines[lightType + "_COUNT"] = lightsNumbers[lightType];
    return shaderStr.replace($8ffa8760a533af20$var$loopRegex, replace);
}
function $8ffa8760a533af20$var$getDefineCode(defines, lightsNumbers, enabledTextures) {
    var defineStr = [];
    if (lightsNumbers) for(var lightType in lightsNumbers){
        var count = lightsNumbers[lightType];
        if (count > 0) defineStr.push("#define " + lightType.toUpperCase() + "_COUNT " + count);
    }
    if (enabledTextures) for(var i = 0; i < enabledTextures.length; i++){
        var symbol = enabledTextures[i];
        defineStr.push("#define " + symbol.toUpperCase() + "_ENABLED");
    }
    // Custom Defines
    for(var symbol in defines){
        var value = defines[symbol];
        if (value === null) defineStr.push("#define " + symbol);
        else defineStr.push("#define " + symbol + " " + value.toString());
    }
    return defineStr.join("\n");
}
function $8ffa8760a533af20$var$getExtensionCode(exts) {
    // Extension declaration must before all non-preprocessor codes
    // TODO vertex ? extension enum ?
    var extensionStr = [];
    for(var i = 0; i < exts.length; i++)extensionStr.push("#extension GL_" + exts[i] + " : enable");
    return extensionStr.join("\n");
}
function $8ffa8760a533af20$var$getPrecisionCode(precision) {
    return [
        "precision",
        precision,
        "float"
    ].join(" ") + ";\n" + [
        "precision",
        precision,
        "int"
    ].join(" ") + ";\n" + [
        "precision",
        precision,
        "sampler2D"
    ].join(" ") + ";\n";
}
function $8ffa8760a533af20$var$ProgramManager(renderer) {
    this._renderer = renderer;
    this._cache = {};
}
$8ffa8760a533af20$var$ProgramManager.prototype.getProgram = function(renderable, material, scene) {
    var cache = this._cache;
    var isSkinnedMesh = renderable.isSkinnedMesh && renderable.isSkinnedMesh();
    var isInstancedMesh = renderable.isInstancedMesh && renderable.isInstancedMesh();
    var key = "s" + material.shader.shaderID + "m" + material.getProgramKey();
    if (scene) key += "se" + scene.getProgramKey(renderable.lightGroup);
    if (isSkinnedMesh) key += ",sk" + renderable.joints.length;
    if (isInstancedMesh) key += ",is";
    var program = cache[key];
    if (program) return program;
    var lightsNumbers = scene ? scene.getLightsNumbers(renderable.lightGroup) : {};
    var renderer = this._renderer;
    var _gl = renderer.gl;
    var enabledTextures = material.getEnabledTextures();
    var extraDefineCode = "";
    if (isSkinnedMesh) {
        var skinDefines = {
            SKINNING: null,
            JOINT_COUNT: renderable.joints.length
        };
        if (renderable.joints.length > renderer.getMaxJointNumber()) skinDefines.USE_SKIN_MATRICES_TEXTURE = null;
        // TODO Add skinning code?
        extraDefineCode += "\n" + $8ffa8760a533af20$var$getDefineCode(skinDefines) + "\n";
    }
    if (isInstancedMesh) extraDefineCode += "\n#define INSTANCING\n";
    // TODO Optimize key generation
    // VERTEX
    var vertexDefineStr = extraDefineCode + $8ffa8760a533af20$var$getDefineCode(material.vertexDefines, lightsNumbers, enabledTextures);
    // FRAGMENT
    var fragmentDefineStr = extraDefineCode + $8ffa8760a533af20$var$getDefineCode(material.fragmentDefines, lightsNumbers, enabledTextures);
    var vertexCode = vertexDefineStr + "\n" + material.shader.vertex;
    var extensions = [
        "OES_standard_derivatives",
        "EXT_shader_texture_lod"
    ].filter(function(ext) {
        return renderer.getGLExtension(ext) != null;
    });
    if (extensions.indexOf("EXT_shader_texture_lod") >= 0) fragmentDefineStr += "\n#define SUPPORT_TEXTURE_LOD";
    if (extensions.indexOf("OES_standard_derivatives") >= 0) fragmentDefineStr += "\n#define SUPPORT_STANDARD_DERIVATIVES";
    var fragmentCode = $8ffa8760a533af20$var$getExtensionCode(extensions) + "\n" + $8ffa8760a533af20$var$getPrecisionCode(material.precision) + "\n" + fragmentDefineStr + "\n" + material.shader.fragment;
    var finalVertexCode = $8ffa8760a533af20$var$unrollLoop(vertexCode, material.vertexDefines, lightsNumbers);
    var finalFragmentCode = $8ffa8760a533af20$var$unrollLoop(fragmentCode, material.fragmentDefines, lightsNumbers);
    var program = new (0, $59d30562deed942e$export$2e2bcd8739ae039)();
    program.uniformSemantics = material.shader.uniformSemantics;
    program.attributes = material.shader.attributes;
    var errorMsg = program.buildProgram(_gl, material.shader, finalVertexCode, finalFragmentCode);
    program.__error = errorMsg;
    cache[key] = program;
    return program;
};
var $8ffa8760a533af20$export$2e2bcd8739ae039 = $8ffa8760a533af20$var$ProgramManager;


/**
 * Mainly do the parse and compile of shader string
 * Support shader code chunk import and export
 * Support shader semantics
 * http://www.nvidia.com/object/using_sas.html
 * https://github.com/KhronosGroup/collada2json/issues/45
 */ 

var $90e78c81ac16d455$var$uniformRegex = /uniform\s+(bool|float|int|vec2|vec3|vec4|ivec2|ivec3|ivec4|mat2|mat3|mat4|sampler2D|samplerCube)\s+([\s\S]*?);/g;
var $90e78c81ac16d455$var$attributeRegex = /attribute\s+(float|int|vec2|vec3|vec4)\s+([\s\S]*?);/g;
// Only parse number define.
var $90e78c81ac16d455$var$defineRegex = /#define\s+(\w+)?(\s+[\d-.]+)?\s*;?\s*\n/g;
var $90e78c81ac16d455$var$uniformTypeMap = {
    "bool": "1i",
    "int": "1i",
    "sampler2D": "t",
    "samplerCube": "t",
    "float": "1f",
    "vec2": "2f",
    "vec3": "3f",
    "vec4": "4f",
    "ivec2": "2i",
    "ivec3": "3i",
    "ivec4": "4i",
    "mat2": "m2",
    "mat3": "m3",
    "mat4": "m4"
};
function $90e78c81ac16d455$var$createZeroArray(len) {
    var arr = [];
    for(var i = 0; i < len; i++)arr[i] = 0;
    return arr;
}
var $90e78c81ac16d455$var$uniformValueConstructor = {
    "bool": function() {
        return true;
    },
    "int": function() {
        return 0;
    },
    "float": function() {
        return 0;
    },
    "sampler2D": function() {
        return null;
    },
    "samplerCube": function() {
        return null;
    },
    "vec2": function() {
        return $90e78c81ac16d455$var$createZeroArray(2);
    },
    "vec3": function() {
        return $90e78c81ac16d455$var$createZeroArray(3);
    },
    "vec4": function() {
        return $90e78c81ac16d455$var$createZeroArray(4);
    },
    "ivec2": function() {
        return $90e78c81ac16d455$var$createZeroArray(2);
    },
    "ivec3": function() {
        return $90e78c81ac16d455$var$createZeroArray(3);
    },
    "ivec4": function() {
        return $90e78c81ac16d455$var$createZeroArray(4);
    },
    "mat2": function() {
        return $90e78c81ac16d455$var$createZeroArray(4);
    },
    "mat3": function() {
        return $90e78c81ac16d455$var$createZeroArray(9);
    },
    "mat4": function() {
        return $90e78c81ac16d455$var$createZeroArray(16);
    },
    "array": function() {
        return [];
    }
};
var $90e78c81ac16d455$var$attributeSemantics = [
    "POSITION",
    "NORMAL",
    "BINORMAL",
    "TANGENT",
    "TEXCOORD",
    "TEXCOORD_0",
    "TEXCOORD_1",
    "COLOR",
    // Skinning
    // https://github.com/KhronosGroup/glTF/blob/master/specification/README.md#semantics
    "JOINT",
    "WEIGHT"
];
var $90e78c81ac16d455$var$uniformSemantics = [
    "SKIN_MATRIX",
    // Information about viewport
    "VIEWPORT_SIZE",
    "VIEWPORT",
    "DEVICEPIXELRATIO",
    // Window size for window relative coordinate
    // https://www.opengl.org/sdk/docs/man/html/gl_FragCoord.xhtml
    "WINDOW_SIZE",
    // Infomation about camera
    "NEAR",
    "FAR",
    // Time
    "TIME"
];
var $90e78c81ac16d455$var$matrixSemantics = [
    "WORLD",
    "VIEW",
    "PROJECTION",
    "WORLDVIEW",
    "VIEWPROJECTION",
    "WORLDVIEWPROJECTION",
    "WORLDINVERSE",
    "VIEWINVERSE",
    "PROJECTIONINVERSE",
    "WORLDVIEWINVERSE",
    "VIEWPROJECTIONINVERSE",
    "WORLDVIEWPROJECTIONINVERSE",
    "WORLDTRANSPOSE",
    "VIEWTRANSPOSE",
    "PROJECTIONTRANSPOSE",
    "WORLDVIEWTRANSPOSE",
    "VIEWPROJECTIONTRANSPOSE",
    "WORLDVIEWPROJECTIONTRANSPOSE",
    "WORLDINVERSETRANSPOSE",
    "VIEWINVERSETRANSPOSE",
    "PROJECTIONINVERSETRANSPOSE",
    "WORLDVIEWINVERSETRANSPOSE",
    "VIEWPROJECTIONINVERSETRANSPOSE",
    "WORLDVIEWPROJECTIONINVERSETRANSPOSE"
];
var $90e78c81ac16d455$var$attributeSizeMap = {
    // WebGL does not support integer attributes
    "vec4": 4,
    "vec3": 3,
    "vec2": 2,
    "float": 1
};
var $90e78c81ac16d455$var$shaderIDCache = {};
var $90e78c81ac16d455$var$shaderCodeCache = {};
function $90e78c81ac16d455$var$getShaderID(vertex, fragment) {
    var key = "vertex:" + vertex + "fragment:" + fragment;
    if ($90e78c81ac16d455$var$shaderIDCache[key]) return $90e78c81ac16d455$var$shaderIDCache[key];
    var id = (0, $b22fd57b6bfa77fb$export$2e2bcd8739ae039).genGUID();
    $90e78c81ac16d455$var$shaderIDCache[key] = id;
    $90e78c81ac16d455$var$shaderCodeCache[id] = {
        vertex: vertex,
        fragment: fragment
    };
    return id;
}
function $90e78c81ac16d455$var$removeComment(code) {
    return code.replace(/[ \t]*\/\/.*\n/g, "") // remove //
    .replace(/[ \t]*\/\*[\s\S]*?\*\//g, ""); // remove /* */
}
function $90e78c81ac16d455$var$logSyntaxError() {
    console.error("Wrong uniform/attributes syntax");
}
function $90e78c81ac16d455$var$parseDeclarations(type, line) {
    var speratorsRegexp = /[,=\(\):]/;
    var tokens = line// Convert `symbol: [1,2,3]` to `symbol: vec3(1,2,3)`
    .replace(/:\s*\[\s*(.*)\s*\]/g, "=" + type + "($1)").replace(/\s+/g, "").split(/(?=[,=\(\):])/g);
    var newTokens = [];
    for(var i = 0; i < tokens.length; i++)if (tokens[i].match(speratorsRegexp)) newTokens.push(tokens[i].charAt(0), tokens[i].slice(1));
    else newTokens.push(tokens[i]);
    tokens = newTokens;
    var TYPE_SYMBOL = 0;
    var TYPE_ASSIGN = 1;
    var TYPE_VEC = 2;
    var TYPE_ARR = 3;
    var TYPE_SEMANTIC = 4;
    var TYPE_NORMAL = 5;
    var opType = TYPE_SYMBOL;
    var declarations = {};
    var declarationValue = null;
    var currentDeclaration;
    addSymbol(tokens[0]);
    function addSymbol(symbol) {
        if (!symbol) $90e78c81ac16d455$var$logSyntaxError();
        var arrResult = symbol.match(/\[(.*?)\]/);
        currentDeclaration = symbol.replace(/\[(.*?)\]/, "");
        declarations[currentDeclaration] = {};
        if (arrResult) {
            declarations[currentDeclaration].isArray = true;
            declarations[currentDeclaration].arraySize = arrResult[1];
        }
    }
    for(var i = 1; i < tokens.length; i++){
        var token = tokens[i];
        if (!token) continue;
        if (token === "=") {
            if (opType !== TYPE_SYMBOL && opType !== TYPE_ARR) {
                $90e78c81ac16d455$var$logSyntaxError();
                break;
            }
            opType = TYPE_ASSIGN;
            continue;
        } else if (token === ":") {
            opType = TYPE_SEMANTIC;
            continue;
        } else if (token === ",") {
            if (opType === TYPE_VEC) {
                if (!(declarationValue instanceof Array)) {
                    $90e78c81ac16d455$var$logSyntaxError();
                    break;
                }
                declarationValue.push(+tokens[++i]);
            } else opType = TYPE_NORMAL;
            continue;
        } else if (token === ")") {
            declarations[currentDeclaration].value = new (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).Float32Array(declarationValue);
            declarationValue = null;
            opType = TYPE_NORMAL;
            continue;
        } else if (token === "(") {
            if (opType !== TYPE_VEC) {
                $90e78c81ac16d455$var$logSyntaxError();
                break;
            }
            if (!(declarationValue instanceof Array)) {
                $90e78c81ac16d455$var$logSyntaxError();
                break;
            }
            declarationValue.push(+tokens[++i]);
            continue;
        } else if (token.indexOf("vec") >= 0) {
            if (opType !== TYPE_ASSIGN && opType !== TYPE_SEMANTIC) {
                $90e78c81ac16d455$var$logSyntaxError();
                break;
            }
            opType = TYPE_VEC;
            declarationValue = [];
            continue;
        } else if (opType === TYPE_ASSIGN) {
            if (type === "bool") declarations[currentDeclaration].value = token === "true";
            else declarations[currentDeclaration].value = parseFloat(token);
            declarationValue = null;
            continue;
        } else if (opType === TYPE_SEMANTIC) {
            var semantic = token;
            if ($90e78c81ac16d455$var$attributeSemantics.indexOf(semantic) >= 0 || $90e78c81ac16d455$var$uniformSemantics.indexOf(semantic) >= 0 || $90e78c81ac16d455$var$matrixSemantics.indexOf(semantic) >= 0) declarations[currentDeclaration].semantic = semantic;
            else if (semantic === "ignore" || semantic === "unconfigurable") declarations[currentDeclaration].ignore = true;
            else // Try to parse as a default tvalue.
            if (type === "bool") declarations[currentDeclaration].value = semantic === "true";
            else declarations[currentDeclaration].value = parseFloat(semantic);
            continue;
        }
        // treat as symbol.
        addSymbol(token);
        opType = TYPE_SYMBOL;
    }
    return declarations;
}
/**
 * @constructor
 * @extends clay.core.Base
 * @alias clay.Shader
 * @param {string} vertex
 * @param {string} fragment
 * @example
 * // Create a phong shader
 * var shader = new clay.Shader(
 *      clay.Shader.source('clay.standard.vertex'),
 *      clay.Shader.source('clay.standard.fragment')
 * );
 */ function $90e78c81ac16d455$var$Shader(vertex, fragment) {
    // First argument can be { vertex, fragment }
    if (typeof vertex === "object") {
        fragment = vertex.fragment;
        vertex = vertex.vertex;
    }
    vertex = $90e78c81ac16d455$var$removeComment(vertex);
    fragment = $90e78c81ac16d455$var$removeComment(fragment);
    this._shaderID = $90e78c81ac16d455$var$getShaderID(vertex, fragment);
    this._vertexCode = $90e78c81ac16d455$var$Shader.parseImport(vertex);
    this._fragmentCode = $90e78c81ac16d455$var$Shader.parseImport(fragment);
    /**
     * @readOnly
     */ this.attributeSemantics = {};
    /**
     * @readOnly
     */ this.matrixSemantics = {};
    /**
     * @readOnly
     */ this.uniformSemantics = {};
    /**
     * @readOnly
     */ this.matrixSemanticKeys = [];
    /**
     * @readOnly
     */ this.uniformTemplates = {};
    /**
     * @readOnly
     */ this.attributes = {};
    /**
     * @readOnly
     */ this.textures = {};
    /**
     * @readOnly
     */ this.vertexDefines = {};
    /**
     * @readOnly
     */ this.fragmentDefines = {};
    this._parseAttributes();
    this._parseUniforms();
    this._parseDefines();
}
$90e78c81ac16d455$var$Shader.prototype = {
    constructor: $90e78c81ac16d455$var$Shader,
    // Create a new uniform instance for material
    createUniforms: function() {
        var uniforms = {};
        for(var symbol in this.uniformTemplates){
            var uniformTpl = this.uniformTemplates[symbol];
            uniforms[symbol] = {
                type: uniformTpl.type,
                value: uniformTpl.value()
            };
        }
        return uniforms;
    },
    _parseImport: function() {
        this._vertexCode = $90e78c81ac16d455$var$Shader.parseImport(this.vertex);
        this._fragmentCode = $90e78c81ac16d455$var$Shader.parseImport(this.fragment);
    },
    _addSemanticUniform: function(symbol, uniformType, semantic) {
        // This case is only for SKIN_MATRIX
        // TODO
        if ($90e78c81ac16d455$var$attributeSemantics.indexOf(semantic) >= 0) this.attributeSemantics[semantic] = {
            symbol: symbol,
            type: uniformType
        };
        else if ($90e78c81ac16d455$var$matrixSemantics.indexOf(semantic) >= 0) {
            var isTranspose = false;
            var semanticNoTranspose = semantic;
            if (semantic.match(/TRANSPOSE$/)) {
                isTranspose = true;
                semanticNoTranspose = semantic.slice(0, -9);
            }
            this.matrixSemantics[semantic] = {
                symbol: symbol,
                type: uniformType,
                isTranspose: isTranspose,
                semanticNoTranspose: semanticNoTranspose
            };
        } else if ($90e78c81ac16d455$var$uniformSemantics.indexOf(semantic) >= 0) this.uniformSemantics[semantic] = {
            symbol: symbol,
            type: uniformType
        };
    },
    _addMaterialUniform: function(symbol, type, uniformType, defaultValueFunc, isArray, materialUniforms) {
        materialUniforms[symbol] = {
            type: uniformType,
            value: isArray ? $90e78c81ac16d455$var$uniformValueConstructor["array"] : defaultValueFunc || $90e78c81ac16d455$var$uniformValueConstructor[type],
            semantic: null
        };
    },
    _parseUniforms: function() {
        var uniforms = {};
        var self = this;
        var shaderType = "vertex";
        this._uniformList = [];
        this._vertexCode = this._vertexCode.replace($90e78c81ac16d455$var$uniformRegex, _uniformParser);
        shaderType = "fragment";
        this._fragmentCode = this._fragmentCode.replace($90e78c81ac16d455$var$uniformRegex, _uniformParser);
        self.matrixSemanticKeys = Object.keys(this.matrixSemantics);
        function makeDefaultValueFunc(value) {
            return value != null ? function() {
                return value;
            } : null;
        }
        function _uniformParser(str, type, content) {
            var declaredUniforms = $90e78c81ac16d455$var$parseDeclarations(type, content);
            var uniformMainStr = [];
            for(var symbol in declaredUniforms){
                var uniformInfo = declaredUniforms[symbol];
                var semantic = uniformInfo.semantic;
                var tmpStr = symbol;
                var uniformType = $90e78c81ac16d455$var$uniformTypeMap[type];
                var defaultValueFunc = makeDefaultValueFunc(declaredUniforms[symbol].value);
                if (declaredUniforms[symbol].isArray) {
                    tmpStr += "[" + declaredUniforms[symbol].arraySize + "]";
                    uniformType += "v";
                }
                uniformMainStr.push(tmpStr);
                self._uniformList.push(symbol);
                if (!uniformInfo.ignore) {
                    if (type === "sampler2D" || type === "samplerCube") // Texture is default disabled
                    self.textures[symbol] = {
                        shaderType: shaderType,
                        type: type
                    };
                    if (semantic) // TODO Should not declare multiple symbols if have semantic.
                    self._addSemanticUniform(symbol, uniformType, semantic);
                    else self._addMaterialUniform(symbol, type, uniformType, defaultValueFunc, declaredUniforms[symbol].isArray, uniforms);
                }
            }
            return uniformMainStr.length > 0 ? "uniform " + type + " " + uniformMainStr.join(",") + ";\n" : "";
        }
        this.uniformTemplates = uniforms;
    },
    _parseAttributes: function() {
        var attributes = {};
        var self = this;
        this._vertexCode = this._vertexCode.replace($90e78c81ac16d455$var$attributeRegex, _attributeParser);
        function _attributeParser(str, type, content) {
            var declaredAttributes = $90e78c81ac16d455$var$parseDeclarations(type, content);
            var size = $90e78c81ac16d455$var$attributeSizeMap[type] || 1;
            var attributeMainStr = [];
            for(var symbol in declaredAttributes){
                var semantic = declaredAttributes[symbol].semantic;
                attributes[symbol] = {
                    // TODO Can only be float
                    type: "float",
                    size: size,
                    semantic: semantic || null
                };
                // TODO Should not declare multiple symbols if have semantic.
                if (semantic) {
                    if ($90e78c81ac16d455$var$attributeSemantics.indexOf(semantic) < 0) throw new Error('Unkown semantic "' + semantic + '"');
                    else self.attributeSemantics[semantic] = {
                        symbol: symbol,
                        type: type
                    };
                }
                attributeMainStr.push(symbol);
            }
            return "attribute " + type + " " + attributeMainStr.join(",") + ";\n";
        }
        this.attributes = attributes;
    },
    _parseDefines: function() {
        var self = this;
        var shaderType = "vertex";
        this._vertexCode = this._vertexCode.replace($90e78c81ac16d455$var$defineRegex, _defineParser);
        shaderType = "fragment";
        this._fragmentCode = this._fragmentCode.replace($90e78c81ac16d455$var$defineRegex, _defineParser);
        function _defineParser(str, symbol, value) {
            var defines = shaderType === "vertex" ? self.vertexDefines : self.fragmentDefines;
            if (!defines[symbol]) {
                if (value === "false") defines[symbol] = false;
                else if (value === "true") defines[symbol] = true;
                else defines[symbol] = value ? isNaN(parseFloat(value)) ? value.trim() : parseFloat(value) : null;
            }
            return "";
        }
    },
    /**
     * Clone a new shader
     * @return {clay.Shader}
     */ clone: function() {
        var code = $90e78c81ac16d455$var$shaderCodeCache[this._shaderID];
        var shader = new $90e78c81ac16d455$var$Shader(code.vertex, code.fragment);
        return shader;
    }
};
if (Object.defineProperty) {
    Object.defineProperty($90e78c81ac16d455$var$Shader.prototype, "shaderID", {
        get: function() {
            return this._shaderID;
        }
    });
    Object.defineProperty($90e78c81ac16d455$var$Shader.prototype, "vertex", {
        get: function() {
            return this._vertexCode;
        }
    });
    Object.defineProperty($90e78c81ac16d455$var$Shader.prototype, "fragment", {
        get: function() {
            return this._fragmentCode;
        }
    });
    Object.defineProperty($90e78c81ac16d455$var$Shader.prototype, "uniforms", {
        get: function() {
            return this._uniformList;
        }
    });
}
var $90e78c81ac16d455$var$importRegex = /(@import)\s*([0-9a-zA-Z_\-\.]*)/g;
$90e78c81ac16d455$var$Shader.parseImport = function(shaderStr) {
    shaderStr = shaderStr.replace($90e78c81ac16d455$var$importRegex, function(str, importSymbol, importName) {
        var str = $90e78c81ac16d455$var$Shader.source(importName);
        if (str) // Recursively parse
        return $90e78c81ac16d455$var$Shader.parseImport(str);
        else {
            console.error('Shader chunk "' + importName + '" not existed in library');
            return "";
        }
    });
    return shaderStr;
};
var $90e78c81ac16d455$var$exportRegex = /(@export)\s*([0-9a-zA-Z_\-\.]*)\s*\n([\s\S]*?)@end/g;
/**
 * Import shader source
 * @param  {string} shaderStr
 * @memberOf clay.Shader
 */ $90e78c81ac16d455$var$Shader["import"] = function(shaderStr) {
    shaderStr.replace($90e78c81ac16d455$var$exportRegex, function(str, exportSymbol, exportName, code) {
        var code = code.replace(/(^[\s\t\xa0\u3000]+)|([\u3000\xa0\s\t]+\x24)/g, "");
        if (code) {
            var parts = exportName.split(".");
            var obj = $90e78c81ac16d455$var$Shader.codes;
            var i = 0;
            var key;
            while(i < parts.length - 1){
                key = parts[i++];
                if (!obj[key]) obj[key] = {};
                obj = obj[key];
            }
            key = parts[i];
            obj[key] = code;
        }
        return code;
    });
};
/**
 * Library to store all the loaded shader codes
 * @type {Object}
 * @readOnly
 * @memberOf clay.Shader
 */ $90e78c81ac16d455$var$Shader.codes = {};
/**
 * Get shader source
 * @param  {string} name
 * @return {string}
 */ $90e78c81ac16d455$var$Shader.source = function(name) {
    var parts = name.split(".");
    var obj = $90e78c81ac16d455$var$Shader.codes;
    var i = 0;
    while(obj && i < parts.length){
        var key = parts[i++];
        obj = obj[key];
    }
    if (typeof obj !== "string") {
        // FIXME Use default instead
        console.error('Shader "' + name + '" not existed in library');
        return "";
    }
    return obj;
};
var $90e78c81ac16d455$export$2e2bcd8739ae039 = $90e78c81ac16d455$var$Shader;


var $cf90e259d5b6bbd4$export$2e2bcd8739ae039 = "@export clay.prez.vertex\nuniform mat4 WVP : WORLDVIEWPROJECTION;\nattribute vec3 pos : POSITION;\nattribute vec2 uv : TEXCOORD_0;\nuniform vec2 uvRepeat : [1.0, 1.0];\nuniform vec2 uvOffset : [0.0, 0.0];\n@import clay.chunk.skinning_header\n@import clay.chunk.instancing_header\nvarying vec2 v_Texcoord;\nvoid main()\n{\n vec4 P = vec4(pos, 1.0);\n#ifdef SKINNING\n @import clay.chunk.skin_matrix\n P = skinMatrixWS * P;\n#endif\n#ifdef INSTANCING\n @import clay.chunk.instancing_matrix\n P = instanceMat * P;\n#endif\n gl_Position = WVP * P;\n v_Texcoord = uv * uvRepeat + uvOffset;\n}\n@end\n@export clay.prez.fragment\nuniform sampler2D alphaMap;\nuniform float alphaCutoff: 0.0;\nvarying vec2 v_Texcoord;\nvoid main()\n{\n if (alphaCutoff > 0.0) {\n if (texture2D(alphaMap, v_Texcoord).a <= alphaCutoff) {\n discard;\n }\n }\n gl_FragColor = vec4(0.0,0.0,0.0,1.0);\n}\n@end";


/* Copyright (c) 2013, Brandon Jones, Colin MacKenzie IV. All rights reserved.

Redistribution and use in source and binary forms, with or without modification,
are permitted provided that the following conditions are met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.
  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. */ 
/**
 * @class 4x4 Matrix
 * @name mat4
 */ var $0020ce97b75275ae$var$mat4 = {};
/**
 * Creates a new identity mat4
 *
 * @returns {mat4} a new 4x4 matrix
 */ $0020ce97b75275ae$var$mat4.create = function() {
    var out = new (0, $fe2a8a9f20126b12$export$b215cfa6c73149fa)(16);
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
};
/**
 * Creates a new mat4 initialized with values from an existing matrix
 *
 * @param {mat4} a matrix to clone
 * @returns {mat4} a new 4x4 matrix
 */ $0020ce97b75275ae$var$mat4.clone = function(a) {
    var out = new (0, $fe2a8a9f20126b12$export$b215cfa6c73149fa)(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
};
/**
 * Copy the values from one mat4 to another
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */ $0020ce97b75275ae$var$mat4.copy = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
};
/**
 * Set a mat4 to the identity matrix
 *
 * @param {mat4} out the receiving matrix
 * @returns {mat4} out
 */ $0020ce97b75275ae$var$mat4.identity = function(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
};
/**
 * Transpose the values of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */ $0020ce97b75275ae$var$mat4.transpose = function(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a03 = a[3], a12 = a[6], a13 = a[7], a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
};
/**
 * Inverts a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */ $0020ce97b75275ae$var$mat4.invert = function(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15], b00 = a00 * a11 - a01 * a10, b01 = a00 * a12 - a02 * a10, b02 = a00 * a13 - a03 * a10, b03 = a01 * a12 - a02 * a11, b04 = a01 * a13 - a03 * a11, b05 = a02 * a13 - a03 * a12, b06 = a20 * a31 - a21 * a30, b07 = a20 * a32 - a22 * a30, b08 = a20 * a33 - a23 * a30, b09 = a21 * a32 - a22 * a31, b10 = a21 * a33 - a23 * a31, b11 = a22 * a33 - a23 * a32, // Calculate the determinant
    det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
};
/**
 * Calculates the adjugate of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */ $0020ce97b75275ae$var$mat4.adjoint = function(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    out[0] = a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22);
    out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
    out[2] = a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12);
    out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
    out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
    out[5] = a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22);
    out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
    out[7] = a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12);
    out[8] = a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21);
    out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
    out[10] = a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11);
    out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
    out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
    out[13] = a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21);
    out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
    out[15] = a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11);
    return out;
};
/**
 * Calculates the determinant of a mat4
 *
 * @param {mat4} a the source matrix
 * @returns {Number} determinant of a
 */ $0020ce97b75275ae$var$mat4.determinant = function(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15], b00 = a00 * a11 - a01 * a10, b01 = a00 * a12 - a02 * a10, b02 = a00 * a13 - a03 * a10, b03 = a01 * a12 - a02 * a11, b04 = a01 * a13 - a03 * a11, b05 = a02 * a13 - a03 * a12, b06 = a20 * a31 - a21 * a30, b07 = a20 * a32 - a22 * a30, b08 = a20 * a33 - a23 * a30, b09 = a21 * a32 - a22 * a31, b10 = a21 * a33 - a23 * a31, b11 = a22 * a33 - a23 * a32;
    // Calculate the determinant
    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
};
/**
 * Multiplies two mat4's
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the first operand
 * @param {mat4} b the second operand
 * @returns {mat4} out
 */ $0020ce97b75275ae$var$mat4.multiply = function(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    // Cache only the current line of the second matrix
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
};
/**
 * Multiplies two affine mat4's
 * Add by https://github.com/pissang
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the first operand
 * @param {mat4} b the second operand
 * @returns {mat4} out
 */ $0020ce97b75275ae$var$mat4.multiplyAffine = function(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[4], a11 = a[5], a12 = a[6], a20 = a[8], a21 = a[9], a22 = a[10], a30 = a[12], a31 = a[13], a32 = a[14];
    // Cache only the current line of the second matrix
    var b0 = b[0], b1 = b[1], b2 = b[2];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22;
    // out[3] = 0;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22;
    // out[7] = 0;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22;
    // out[11] = 0;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + a32;
    // out[15] = 1;
    return out;
};
/**
 * Alias for {@link mat4.multiply}
 * @function
 */ $0020ce97b75275ae$var$mat4.mul = $0020ce97b75275ae$var$mat4.multiply;
/**
 * Alias for {@link mat4.multiplyAffine}
 * @function
 */ $0020ce97b75275ae$var$mat4.mulAffine = $0020ce97b75275ae$var$mat4.multiplyAffine;
/**
 * Translate a mat4 by the given vector
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to translate
 * @param {vec3} v vector to translate by
 * @returns {mat4} out
 */ $0020ce97b75275ae$var$mat4.translate = function(out, a, v) {
    var x = v[0], y = v[1], z = v[2], a00, a01, a02, a03, a10, a11, a12, a13, a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
};
/**
 * Scales the mat4 by the dimensions in the given vec3
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to scale
 * @param {vec3} v the vec3 to scale the matrix by
 * @returns {mat4} out
 **/ $0020ce97b75275ae$var$mat4.scale = function(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
};
/**
 * Rotates a mat4 by the given angle
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @param {vec3} axis the axis to rotate around
 * @returns {mat4} out
 */ $0020ce97b75275ae$var$mat4.rotate = function(out, a, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2], len = Math.sqrt(x * x + y * y + z * z), s, c, t, a00, a01, a02, a03, a10, a11, a12, a13, a20, a21, a22, a23, b00, b01, b02, b10, b11, b12, b20, b21, b22;
    if (Math.abs(len) < (0, $fe2a8a9f20126b12$export$65acf2a8af52a190)) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11];
    // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c;
    // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) {
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
};
/**
 * Rotates a matrix by the given angle around the X axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */ $0020ce97b75275ae$var$mat4.rotateX = function(out, a, rad) {
    var s = Math.sin(rad), c = Math.cos(rad), a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    if (a !== out) {
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
};
/**
 * Rotates a matrix by the given angle around the Y axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */ $0020ce97b75275ae$var$mat4.rotateY = function(out, a, rad) {
    var s = Math.sin(rad), c = Math.cos(rad), a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    if (a !== out) {
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
};
/**
 * Rotates a matrix by the given angle around the Z axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */ $0020ce97b75275ae$var$mat4.rotateZ = function(out, a, rad) {
    var s = Math.sin(rad), c = Math.cos(rad), a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    if (a !== out) {
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
};
/**
 * Creates a matrix from a quaternion rotation and vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     var quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {vec3} v Translation vector
 * @returns {mat4} out
 */ $0020ce97b75275ae$var$mat4.fromRotationTranslation = function(out, q, v) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3], x2 = x + x, y2 = y + y, z2 = z + z, xx = x * x2, xy = x * y2, xz = x * z2, yy = y * y2, yz = y * z2, zz = z * z2, wx = w * x2, wy = w * y2, wz = w * z2;
    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
};
$0020ce97b75275ae$var$mat4.fromQuat = function(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3], x2 = x + x, y2 = y + y, z2 = z + z, xx = x * x2, yx = y * x2, yy = y * y2, zx = z * x2, zy = z * y2, zz = z * z2, wx = w * x2, wy = w * y2, wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
};
/**
 * Generates a frustum matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Number} left Left bound of the frustum
 * @param {Number} right Right bound of the frustum
 * @param {Number} bottom Bottom bound of the frustum
 * @param {Number} top Top bound of the frustum
 * @param {Number} near Near bound of the frustum
 * @param {Number} far Far bound of the frustum
 * @returns {mat4} out
 */ $0020ce97b75275ae$var$mat4.frustum = function(out, left, right, bottom, top, near, far) {
    var rl = 1 / (right - left), tb = 1 / (top - bottom), nf = 1 / (near - far);
    out[0] = near * 2 * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = near * 2 * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = far * near * 2 * nf;
    out[15] = 0;
    return out;
};
/**
 * Generates a perspective projection matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fovy Vertical field of view in radians
 * @param {number} aspect Aspect ratio. typically viewport width/height
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */ $0020ce97b75275ae$var$mat4.perspective = function(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2), nf = 1 / (near - far);
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = 2 * far * near * nf;
    out[15] = 0;
    return out;
};
/**
 * Generates a orthogonal projection matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} left Left bound of the frustum
 * @param {number} right Right bound of the frustum
 * @param {number} bottom Bottom bound of the frustum
 * @param {number} top Top bound of the frustum
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */ $0020ce97b75275ae$var$mat4.ortho = function(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right), bt = 1 / (bottom - top), nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
};
/**
 * Generates a look-at matrix with the given eye position, focal point, and up axis
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {vec3} eye Position of the viewer
 * @param {vec3} center Point the viewer is looking at
 * @param {vec3} up vec3 pointing up
 * @returns {mat4} out
 */ $0020ce97b75275ae$var$mat4.lookAt = function(out, eye, center, up) {
    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len, eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2], centerx = center[0], centery = center[1], centerz = center[2];
    if (Math.abs(eyex - centerx) < (0, $fe2a8a9f20126b12$export$65acf2a8af52a190) && Math.abs(eyey - centery) < (0, $fe2a8a9f20126b12$export$65acf2a8af52a190) && Math.abs(eyez - centerz) < (0, $fe2a8a9f20126b12$export$65acf2a8af52a190)) return $0020ce97b75275ae$var$mat4.identity(out);
    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;
    len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;
    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    } else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;
    len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    } else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }
    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;
    return out;
};
/**
 * Returns Frobenius norm of a mat4
 *
 * @param {mat4} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */ $0020ce97b75275ae$var$mat4.frob = function(a) {
    return Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2) + Math.pow(a[4], 2) + Math.pow(a[5], 2) + Math.pow(a[6], 2) + Math.pow(a[7], 2) + Math.pow(a[8], 2) + Math.pow(a[9], 2) + Math.pow(a[10], 2) + Math.pow(a[11], 2) + Math.pow(a[12], 2) + Math.pow(a[13], 2) + Math.pow(a[14], 2) + Math.pow(a[15], 2));
};
var $0020ce97b75275ae$export$2e2bcd8739ae039 = $0020ce97b75275ae$var$mat4;


/* Copyright (c) 2013, Brandon Jones, Colin MacKenzie IV. All rights reserved.

Redistribution and use in source and binary forms, with or without modification,
are permitted provided that the following conditions are met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.
  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. */ 
/**
 * @class 3 Dimensional Vector
 * @name vec3
 */ var $12f7c5f576a58dba$var$vec3 = {};
/**
 * Creates a new, empty vec3
 *
 * @returns {vec3} a new 3D vector
 */ $12f7c5f576a58dba$var$vec3.create = function() {
    var out = new (0, $fe2a8a9f20126b12$export$b215cfa6c73149fa)(3);
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    return out;
};
/**
 * Creates a new vec3 initialized with values from an existing vector
 *
 * @param {vec3} a vector to clone
 * @returns {vec3} a new 3D vector
 */ $12f7c5f576a58dba$var$vec3.clone = function(a) {
    var out = new (0, $fe2a8a9f20126b12$export$b215cfa6c73149fa)(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
};
/**
 * Creates a new vec3 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} a new 3D vector
 */ $12f7c5f576a58dba$var$vec3.fromValues = function(x, y, z) {
    var out = new (0, $fe2a8a9f20126b12$export$b215cfa6c73149fa)(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
};
/**
 * Copy the values from one vec3 to another
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the source vector
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.copy = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
};
/**
 * Set the components of a vec3 to the given values
 *
 * @param {vec3} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.set = function(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
};
/**
 * Adds two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.add = function(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
};
/**
 * Subtracts vector b from vector a
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.subtract = function(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
};
/**
 * Alias for {@link vec3.subtract}
 * @function
 */ $12f7c5f576a58dba$var$vec3.sub = $12f7c5f576a58dba$var$vec3.subtract;
/**
 * Multiplies two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.multiply = function(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
};
/**
 * Alias for {@link vec3.multiply}
 * @function
 */ $12f7c5f576a58dba$var$vec3.mul = $12f7c5f576a58dba$var$vec3.multiply;
/**
 * Divides two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.divide = function(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
};
/**
 * Alias for {@link vec3.divide}
 * @function
 */ $12f7c5f576a58dba$var$vec3.div = $12f7c5f576a58dba$var$vec3.divide;
/**
 * Returns the minimum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.min = function(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
};
/**
 * Returns the maximum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.max = function(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
};
/**
 * Scales a vec3 by a scalar number
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.scale = function(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
};
/**
 * Adds two vec3's after scaling the second operand by a scalar value
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.scaleAndAdd = function(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    return out;
};
/**
 * Calculates the euclidian distance between two vec3's
 *
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {Number} distance between a and b
 */ $12f7c5f576a58dba$var$vec3.distance = function(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1], z = b[2] - a[2];
    return Math.sqrt(x * x + y * y + z * z);
};
/**
 * Alias for {@link vec3.distance}
 * @function
 */ $12f7c5f576a58dba$var$vec3.dist = $12f7c5f576a58dba$var$vec3.distance;
/**
 * Calculates the squared euclidian distance between two vec3's
 *
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {Number} squared distance between a and b
 */ $12f7c5f576a58dba$var$vec3.squaredDistance = function(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1], z = b[2] - a[2];
    return x * x + y * y + z * z;
};
/**
 * Alias for {@link vec3.squaredDistance}
 * @function
 */ $12f7c5f576a58dba$var$vec3.sqrDist = $12f7c5f576a58dba$var$vec3.squaredDistance;
/**
 * Calculates the length of a vec3
 *
 * @param {vec3} a vector to calculate length of
 * @returns {Number} length of a
 */ $12f7c5f576a58dba$var$vec3.length = function(a) {
    var x = a[0], y = a[1], z = a[2];
    return Math.sqrt(x * x + y * y + z * z);
};
/**
 * Alias for {@link vec3.length}
 * @function
 */ $12f7c5f576a58dba$var$vec3.len = $12f7c5f576a58dba$var$vec3.length;
/**
 * Calculates the squared length of a vec3
 *
 * @param {vec3} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */ $12f7c5f576a58dba$var$vec3.squaredLength = function(a) {
    var x = a[0], y = a[1], z = a[2];
    return x * x + y * y + z * z;
};
/**
 * Alias for {@link vec3.squaredLength}
 * @function
 */ $12f7c5f576a58dba$var$vec3.sqrLen = $12f7c5f576a58dba$var$vec3.squaredLength;
/**
 * Negates the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to negate
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.negate = function(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
};
/**
 * Returns the inverse of the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to invert
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.inverse = function(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
};
/**
 * Normalize a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to normalize
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.normalize = function(out, a) {
    var x = a[0], y = a[1], z = a[2];
    var len = x * x + y * y + z * z;
    if (len > 0) {
        //TODO: evaluate use of glm_invsqrt here?
        len = 1 / Math.sqrt(len);
        out[0] = a[0] * len;
        out[1] = a[1] * len;
        out[2] = a[2] * len;
    }
    return out;
};
/**
 * Calculates the dot product of two vec3's
 *
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {Number} dot product of a and b
 */ $12f7c5f576a58dba$var$vec3.dot = function(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
};
/**
 * Computes the cross product of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.cross = function(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2], bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
};
/**
 * Performs a linear interpolation between two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.lerp = function(out, a, b, t) {
    var ax = a[0], ay = a[1], az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
};
/**
 * Generates a random vector with the given scale
 *
 * @param {vec3} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.random = function(out, scale) {
    scale = scale || 1.0;
    var r = (0, $fe2a8a9f20126b12$export$45afeab892d5eb82)() * 2.0 * Math.PI;
    var z = (0, $fe2a8a9f20126b12$export$45afeab892d5eb82)() * 2.0 - 1.0;
    var zScale = Math.sqrt(1.0 - z * z) * scale;
    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
};
/**
 * Transforms the vec3 with a mat4.
 * 4th vector component is implicitly '1'
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to transform
 * @param {mat4} m matrix to transform with
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.transformMat4 = function(out, a, m) {
    var x = a[0], y = a[1], z = a[2], w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
};
/**
 * Transforms the vec3 with a mat3.
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to transform
 * @param {mat4} m the 3x3 matrix to transform with
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.transformMat3 = function(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
};
/**
 * Transforms the vec3 with a quat
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to transform
 * @param {quat} q quaternion to transform with
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.transformQuat = function(out, a, q) {
    // benchmarks: http://jsperf.com/quaternion-transform-vec3-implementations
    var x = a[0], y = a[1], z = a[2], qx = q[0], qy = q[1], qz = q[2], qw = q[3], // calculate quat * vec
    ix = qw * x + qy * z - qz * y, iy = qw * y + qz * x - qx * z, iz = qw * z + qx * y - qy * x, iw = -qx * x - qy * y - qz * z;
    // calculate result * inverse quat
    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    return out;
};
/**
 * Rotate a 3D vector around the x-axis
 * @param {vec3} out The receiving vec3
 * @param {vec3} a The vec3 point to rotate
 * @param {vec3} b The origin of the rotation
 * @param {Number} c The angle of rotation
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.rotateX = function(out, a, b, c) {
    var p = [], r = [];
    //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    //perform rotation
    r[0] = p[0];
    r[1] = p[1] * Math.cos(c) - p[2] * Math.sin(c);
    r[2] = p[1] * Math.sin(c) + p[2] * Math.cos(c);
    //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
};
/**
 * Rotate a 3D vector around the y-axis
 * @param {vec3} out The receiving vec3
 * @param {vec3} a The vec3 point to rotate
 * @param {vec3} b The origin of the rotation
 * @param {Number} c The angle of rotation
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.rotateY = function(out, a, b, c) {
    var p = [], r = [];
    //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    //perform rotation
    r[0] = p[2] * Math.sin(c) + p[0] * Math.cos(c);
    r[1] = p[1];
    r[2] = p[2] * Math.cos(c) - p[0] * Math.sin(c);
    //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
};
/**
 * Rotate a 3D vector around the z-axis
 * @param {vec3} out The receiving vec3
 * @param {vec3} a The vec3 point to rotate
 * @param {vec3} b The origin of the rotation
 * @param {Number} c The angle of rotation
 * @returns {vec3} out
 */ $12f7c5f576a58dba$var$vec3.rotateZ = function(out, a, b, c) {
    var p = [], r = [];
    //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    //perform rotation
    r[0] = p[0] * Math.cos(c) - p[1] * Math.sin(c);
    r[1] = p[0] * Math.sin(c) + p[1] * Math.cos(c);
    r[2] = p[2];
    //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
};
/**
 * Perform some operation over an array of vec3s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec3. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec3s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */ $12f7c5f576a58dba$var$vec3.forEach = function() {
    var vec = $12f7c5f576a58dba$var$vec3.create();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 3;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
        }
        return a;
    };
}();
/**
 * Get the angle between two 3D vectors
 * @param {vec3} a The first operand
 * @param {vec3} b The second operand
 * @returns {Number} The angle in radians
 */ $12f7c5f576a58dba$var$vec3.angle = function(a, b) {
    var tempA = $12f7c5f576a58dba$var$vec3.fromValues(a[0], a[1], a[2]);
    var tempB = $12f7c5f576a58dba$var$vec3.fromValues(b[0], b[1], b[2]);
    $12f7c5f576a58dba$var$vec3.normalize(tempA, tempA);
    $12f7c5f576a58dba$var$vec3.normalize(tempB, tempB);
    var cosine = $12f7c5f576a58dba$var$vec3.dot(tempA, tempB);
    if (cosine > 1.0) return 0;
    else return Math.acos(cosine);
};
var $12f7c5f576a58dba$export$2e2bcd8739ae039 = $12f7c5f576a58dba$var$vec3;


(0, $90e78c81ac16d455$export$2e2bcd8739ae039)["import"]((0, $cf90e259d5b6bbd4$export$2e2bcd8739ae039));
var $a11c3d79797af833$var$mat4Create = (0, $0020ce97b75275ae$export$2e2bcd8739ae039).create;
var $a11c3d79797af833$var$errorShader = {};
function $a11c3d79797af833$var$defaultGetMaterial(renderable) {
    return renderable.material;
}
function $a11c3d79797af833$var$defaultGetUniform(renderable, material, symbol) {
    return material.uniforms[symbol].value;
}
function $a11c3d79797af833$var$defaultIsMaterialChanged(renderabled, prevRenderable, material, prevMaterial) {
    return material !== prevMaterial;
}
function $a11c3d79797af833$var$defaultIfRender(renderable) {
    return true;
}
function $a11c3d79797af833$var$noop() {}
var $a11c3d79797af833$var$attributeBufferTypeMap = {
    float: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).FLOAT,
    byte: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).BYTE,
    ubyte: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).UNSIGNED_BYTE,
    short: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).SHORT,
    ushort: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).UNSIGNED_SHORT
};
function $a11c3d79797af833$var$VertexArrayObject(availableAttributes, availableAttributeSymbols, indicesBuffer) {
    this.availableAttributes = availableAttributes;
    this.availableAttributeSymbols = availableAttributeSymbols;
    this.indicesBuffer = indicesBuffer;
    this.vao = null;
}
function $a11c3d79797af833$var$PlaceHolderTexture(renderer) {
    var blankCanvas;
    var webglTexture;
    this.bind = function(renderer) {
        if (!blankCanvas) {
            // TODO Environment not support createCanvas.
            blankCanvas = (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).createCanvas();
            blankCanvas.width = blankCanvas.height = 1;
            blankCanvas.getContext("2d");
        }
        var gl = renderer.gl;
        var firstBind = !webglTexture;
        if (firstBind) webglTexture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, webglTexture);
        if (firstBind) gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, blankCanvas);
    };
    this.unbind = function(renderer) {
        renderer.gl.bindTexture(renderer.gl.TEXTURE_2D, null);
    };
    this.isRenderable = function() {
        return true;
    };
}
/**
 * @constructor clay.Renderer
 * @extends clay.core.Base
 */ var $a11c3d79797af833$var$Renderer = (0, $7c62670c05885275$export$2e2bcd8739ae039).extend(function() {
    return /** @lends clay.Renderer# */ {
        /**
         * @type {HTMLCanvasElement}
         * @readonly
         */ canvas: null,
        /**
         * Canvas width, set by resize method
         * @type {number}
         * @private
         */ _width: 100,
        /**
         * Canvas width, set by resize method
         * @type {number}
         * @private
         */ _height: 100,
        /**
         * Device pixel ratio, set by setDevicePixelRatio method
         * Specially for high defination display
         * @see http://www.khronos.org/webgl/wiki/HandlingHighDPI
         * @type {number}
         * @private
         */ devicePixelRatio: typeof window !== "undefined" && window.devicePixelRatio || 1.0,
        /**
         * Clear color
         * @type {number[]}
         */ clearColor: [
            0.0,
            0.0,
            0.0,
            0.0
        ],
        /**
         * Default:
         *     _gl.COLOR_BUFFER_BIT | _gl.DEPTH_BUFFER_BIT | _gl.STENCIL_BUFFER_BIT
         * @type {number}
         */ clearBit: 17664,
        // Settings when getting context
        // http://www.khronos.org/registry/webgl/specs/latest/#2.4
        /**
         * If enable alpha, default true
         * @type {boolean}
         */ alpha: true,
        /**
         * If enable depth buffer, default true
         * @type {boolean}
         */ depth: true,
        /**
         * If enable stencil buffer, default false
         * @type {boolean}
         */ stencil: false,
        /**
         * If enable antialias, default true
         * @type {boolean}
         */ antialias: true,
        /**
         * If enable premultiplied alpha, default true
         * @type {boolean}
         */ premultipliedAlpha: true,
        /**
         * If preserve drawing buffer, default false
         * @type {boolean}
         */ preserveDrawingBuffer: false,
        /**
         * If throw context error, usually turned on in debug mode
         * @type {boolean}
         */ throwError: true,
        /**
         * WebGL Context created from given canvas
         * @type {WebGLRenderingContext}
         */ gl: null,
        /**
         * Renderer viewport, read-only, can be set by setViewport method
         * @type {Object}
         */ viewport: {},
        /**
         * Max joint number
         * @type {number}
         */ maxJointNumber: 20,
        // Set by FrameBuffer#bind
        __currentFrameBuffer: null,
        _viewportStack: [],
        _clearStack: [],
        _sceneRendering: null
    };
}, function() {
    if (!this.canvas) this.canvas = (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).createCanvas();
    var canvas = this.canvas;
    try {
        var opts = {
            alpha: this.alpha,
            depth: this.depth,
            stencil: this.stencil,
            antialias: this.antialias,
            premultipliedAlpha: this.premultipliedAlpha,
            preserveDrawingBuffer: this.preserveDrawingBuffer
        };
        this.gl = canvas.getContext("webgl", opts) || canvas.getContext("experimental-webgl", opts);
        if (!this.gl) throw new Error();
        this._glinfo = new (0, $0c8ecdf33bc707a6$export$2e2bcd8739ae039)(this.gl);
        if (this.gl.targetRenderer) console.error("Already created a renderer");
        this.gl.targetRenderer = this;
        this.resize();
    } catch (e) {
        throw "Error creating WebGL Context " + e;
    }
    // Init managers
    this._programMgr = new (0, $8ffa8760a533af20$export$2e2bcd8739ae039)(this);
    this._placeholderTexture = new $a11c3d79797af833$var$PlaceHolderTexture(this);
}, /** @lends clay.Renderer.prototype. **/ {
    /**
     * Resize the canvas
     * @param {number} width
     * @param {number} height
     */ resize: function(width, height) {
        var canvas = this.canvas;
        // http://www.khronos.org/webgl/wiki/HandlingHighDPI
        // set the display size of the canvas.
        var dpr = this.devicePixelRatio;
        if (width != null) {
            if (canvas.style) {
                canvas.style.width = width + "px";
                canvas.style.height = height + "px";
            }
            // set the size of the drawingBuffer
            canvas.width = width * dpr;
            canvas.height = height * dpr;
            this._width = width;
            this._height = height;
        } else {
            this._width = canvas.width / dpr;
            this._height = canvas.height / dpr;
        }
        this.setViewport(0, 0, this._width, this._height);
    },
    /**
     * Get renderer width
     * @return {number}
     */ getWidth: function() {
        return this._width;
    },
    /**
     * Get renderer height
     * @return {number}
     */ getHeight: function() {
        return this._height;
    },
    /**
     * Get viewport aspect,
     * @return {number}
     */ getViewportAspect: function() {
        var viewport = this.viewport;
        return viewport.width / viewport.height;
    },
    /**
     * Set devicePixelRatio
     * @param {number} devicePixelRatio
     */ setDevicePixelRatio: function(devicePixelRatio) {
        this.devicePixelRatio = devicePixelRatio;
        this.resize(this._width, this._height);
    },
    /**
     * Get devicePixelRatio
     * @param {number} devicePixelRatio
     */ getDevicePixelRatio: function() {
        return this.devicePixelRatio;
    },
    /**
     * Get WebGL extension
     * @param {string} name
     * @return {object}
     */ getGLExtension: function(name) {
        return this._glinfo.getExtension(name);
    },
    /**
     * Get WebGL parameter
     * @param {string} name
     * @return {*}
     */ getGLParameter: function(name) {
        return this._glinfo.getParameter(name);
    },
    /**
     * Set rendering viewport
     * @param {number|Object} x
     * @param {number} [y]
     * @param {number} [width]
     * @param {number} [height]
     * @param {number} [devicePixelRatio]
     *        Defaultly use the renderere devicePixelRatio
     *        It needs to be 1 when setViewport is called by frameBuffer
     *
     * @example
     *  setViewport(0,0,width,height,1)
     *  setViewport({
     *      x: 0,
     *      y: 0,
     *      width: width,
     *      height: height,
     *      devicePixelRatio: 1
     *  })
     */ setViewport: function(x, y, width, height, dpr) {
        if (typeof x === "object") {
            var obj = x;
            x = obj.x;
            y = obj.y;
            width = obj.width;
            height = obj.height;
            dpr = obj.devicePixelRatio;
        }
        dpr = dpr || this.devicePixelRatio;
        this.gl.viewport(x * dpr, y * dpr, width * dpr, height * dpr);
        // Use a fresh new object, not write property.
        this.viewport = {
            x: x,
            y: y,
            width: width,
            height: height,
            devicePixelRatio: dpr
        };
    },
    /**
     * Push current viewport into a stack
     */ saveViewport: function() {
        this._viewportStack.push(this.viewport);
    },
    /**
     * Pop viewport from stack, restore in the renderer
     */ restoreViewport: function() {
        if (this._viewportStack.length > 0) this.setViewport(this._viewportStack.pop());
    },
    /**
     * Push current clear into a stack
     */ saveClear: function() {
        this._clearStack.push({
            clearBit: this.clearBit,
            clearColor: this.clearColor
        });
    },
    /**
     * Pop clear from stack, restore in the renderer
     */ restoreClear: function() {
        if (this._clearStack.length > 0) {
            var opt = this._clearStack.pop();
            this.clearColor = opt.clearColor;
            this.clearBit = opt.clearBit;
        }
    },
    bindSceneRendering: function(scene) {
        this._sceneRendering = scene;
    },
    /**
     * Render the scene in camera to the screen or binded offline framebuffer
     * @param  {clay.Scene}       scene
     * @param  {clay.Camera}      camera
     * @param  {boolean}     [notUpdateScene] If not call the scene.update methods in the rendering, default true
     * @param  {boolean}     [preZ]           If use preZ optimization, default false
     * @return {IRenderInfo}
     */ render: function(scene, camera, notUpdateScene, preZ) {
        var _gl = this.gl;
        var clearColor = this.clearColor;
        if (this.clearBit) {
            // Must set depth and color mask true before clear
            _gl.colorMask(true, true, true, true);
            _gl.depthMask(true);
            var viewport = this.viewport;
            var needsScissor = false;
            var viewportDpr = viewport.devicePixelRatio;
            if (viewport.width !== this._width || viewport.height !== this._height || viewportDpr && viewportDpr !== this.devicePixelRatio || viewport.x || viewport.y) {
                needsScissor = true;
                // http://stackoverflow.com/questions/11544608/how-to-clear-a-rectangle-area-in-webgl
                // Only clear the viewport
                _gl.enable(_gl.SCISSOR_TEST);
                _gl.scissor(viewport.x * viewportDpr, viewport.y * viewportDpr, viewport.width * viewportDpr, viewport.height * viewportDpr);
            }
            _gl.clearColor(clearColor[0], clearColor[1], clearColor[2], clearColor[3]);
            _gl.clear(this.clearBit);
            if (needsScissor) _gl.disable(_gl.SCISSOR_TEST);
        }
        // If the scene have been updated in the prepass like shadow map
        // There is no need to update it again
        if (!notUpdateScene) scene.update(false);
        scene.updateLights();
        camera = camera || scene.getMainCamera();
        if (!camera) {
            console.error("Can't find camera in the scene.");
            return;
        }
        camera.update();
        var renderList = scene.updateRenderList(camera, true);
        this._sceneRendering = scene;
        var opaqueList = renderList.opaque;
        var transparentList = renderList.transparent;
        var sceneMaterial = scene.material;
        scene.trigger("beforerender", this, scene, camera, renderList);
        // Render pre z
        if (preZ) {
            this.renderPreZ(opaqueList, scene, camera);
            _gl.depthFunc(_gl.LEQUAL);
        } else _gl.depthFunc(_gl.LESS);
        // Update the depth of transparent list.
        var worldViewMat = $a11c3d79797af833$var$mat4Create();
        var posViewSpace = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
        for(var i = 0; i < transparentList.length; i++){
            var renderable = transparentList[i];
            (0, $0020ce97b75275ae$export$2e2bcd8739ae039).multiplyAffine(worldViewMat, camera.viewMatrix.array, renderable.worldTransform.array);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).transformMat4(posViewSpace, renderable.position.array, worldViewMat);
            renderable.__depth = posViewSpace[2];
        }
        // Render opaque list
        this.renderPass(opaqueList, camera, {
            getMaterial: function(renderable) {
                return sceneMaterial || renderable.material;
            },
            sortCompare: this.opaqueSortCompare
        });
        this.renderPass(transparentList, camera, {
            getMaterial: function(renderable) {
                return sceneMaterial || renderable.material;
            },
            sortCompare: this.transparentSortCompare
        });
        scene.trigger("afterrender", this, scene, camera, renderList);
        // Cleanup
        this._sceneRendering = null;
    },
    getProgram: function(renderable, renderMaterial, scene) {
        renderMaterial = renderMaterial || renderable.material;
        return this._programMgr.getProgram(renderable, renderMaterial, scene);
    },
    validateProgram: function(program) {
        if (program.__error) {
            var errorMsg = program.__error;
            if ($a11c3d79797af833$var$errorShader[program.__uid__]) return;
            $a11c3d79797af833$var$errorShader[program.__uid__] = true;
            if (this.throwError) throw new Error(errorMsg);
            else this.trigger("error", errorMsg);
        }
    },
    updatePrograms: function(list, scene, passConfig) {
        var getMaterial = passConfig && passConfig.getMaterial || $a11c3d79797af833$var$defaultGetMaterial;
        scene = scene || null;
        for(var i = 0; i < list.length; i++){
            var renderable = list[i];
            var renderMaterial = getMaterial.call(this, renderable);
            if (i > 0) {
                var prevRenderable = list[i - 1];
                var prevJointsLen = prevRenderable.joints ? prevRenderable.joints.length : 0;
                var jointsLen = renderable.joints ? renderable.joints.length : 0;
                // Keep program not change if joints, material, lightGroup are same of two renderables.
                if (jointsLen === prevJointsLen && renderable.material === prevRenderable.material && renderable.lightGroup === prevRenderable.lightGroup) {
                    renderable.__program = prevRenderable.__program;
                    continue;
                }
            }
            var program = this._programMgr.getProgram(renderable, renderMaterial, scene);
            this.validateProgram(program);
            renderable.__program = program;
        }
    },
    /**
     * Render a single renderable list in camera in sequence
     * @param {clay.Renderable[]} list List of all renderables.
     * @param {clay.Camera} [camera] Camera provide view matrix and porjection matrix. It can be null.
     * @param {Object} [passConfig]
     * @param {Function} [passConfig.getMaterial] Get renderable material.
     * @param {Function} [passConfig.getUniform] Get material uniform value.
     * @param {Function} [passConfig.isMaterialChanged] If material changed.
     * @param {Function} [passConfig.beforeRender] Before render each renderable.
     * @param {Function} [passConfig.afterRender] After render each renderable
     * @param {Function} [passConfig.ifRender] If render the renderable.
     * @param {Function} [passConfig.sortCompare] Sort compare function.
     * @return {IRenderInfo}
     */ renderPass: function(list, camera, passConfig) {
        this.trigger("beforerenderpass", this, list, camera, passConfig);
        passConfig = passConfig || {};
        passConfig.getMaterial = passConfig.getMaterial || $a11c3d79797af833$var$defaultGetMaterial;
        passConfig.getUniform = passConfig.getUniform || $a11c3d79797af833$var$defaultGetUniform;
        // PENDING Better solution?
        passConfig.isMaterialChanged = passConfig.isMaterialChanged || $a11c3d79797af833$var$defaultIsMaterialChanged;
        passConfig.beforeRender = passConfig.beforeRender || $a11c3d79797af833$var$noop;
        passConfig.afterRender = passConfig.afterRender || $a11c3d79797af833$var$noop;
        var ifRenderObject = passConfig.ifRender || $a11c3d79797af833$var$defaultIfRender;
        this.updatePrograms(list, this._sceneRendering, passConfig);
        if (passConfig.sortCompare) list.sort(passConfig.sortCompare);
        // Some common builtin uniforms
        var viewport = this.viewport;
        var vDpr = viewport.devicePixelRatio;
        var viewportUniform = [
            viewport.x * vDpr,
            viewport.y * vDpr,
            viewport.width * vDpr,
            viewport.height * vDpr
        ];
        var windowDpr = this.devicePixelRatio;
        var windowSizeUniform = this.__currentFrameBuffer ? [
            this.__currentFrameBuffer.getTextureWidth(),
            this.__currentFrameBuffer.getTextureHeight()
        ] : [
            this._width * windowDpr,
            this._height * windowDpr
        ];
        // DEPRECATED
        var viewportSizeUniform = [
            viewportUniform[2],
            viewportUniform[3]
        ];
        var time = Date.now();
        // Calculate view and projection matrix
        if (camera) {
            (0, $0020ce97b75275ae$export$2e2bcd8739ae039).copy($a11c3d79797af833$var$matrices.VIEW, camera.viewMatrix.array);
            (0, $0020ce97b75275ae$export$2e2bcd8739ae039).copy($a11c3d79797af833$var$matrices.PROJECTION, camera.projectionMatrix.array);
            (0, $0020ce97b75275ae$export$2e2bcd8739ae039).copy($a11c3d79797af833$var$matrices.VIEWINVERSE, camera.worldTransform.array);
        } else {
            (0, $0020ce97b75275ae$export$2e2bcd8739ae039).identity($a11c3d79797af833$var$matrices.VIEW);
            (0, $0020ce97b75275ae$export$2e2bcd8739ae039).identity($a11c3d79797af833$var$matrices.PROJECTION);
            (0, $0020ce97b75275ae$export$2e2bcd8739ae039).identity($a11c3d79797af833$var$matrices.VIEWINVERSE);
        }
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).multiply($a11c3d79797af833$var$matrices.VIEWPROJECTION, $a11c3d79797af833$var$matrices.PROJECTION, $a11c3d79797af833$var$matrices.VIEW);
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).invert($a11c3d79797af833$var$matrices.PROJECTIONINVERSE, $a11c3d79797af833$var$matrices.PROJECTION);
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).invert($a11c3d79797af833$var$matrices.VIEWPROJECTIONINVERSE, $a11c3d79797af833$var$matrices.VIEWPROJECTION);
        var _gl = this.gl;
        var scene = this._sceneRendering;
        var prevMaterial;
        var prevProgram;
        var prevRenderable;
        // Status
        var depthTest, depthMask;
        var culling, cullFace, frontFace;
        var transparent;
        var drawID;
        var currentVAO;
        var materialTakesTextureSlot;
        // var vaoExt = this.getGLExtension('OES_vertex_array_object');
        // not use vaoExt, some platforms may mess it up.
        var vaoExt = null;
        for(var i = 0; i < list.length; i++){
            var renderable = list[i];
            var isSceneNode = renderable.worldTransform != null;
            var worldM;
            if (!ifRenderObject(renderable)) continue;
            // Skinned mesh will transformed to joint space. Ignore the mesh transform
            if (isSceneNode) worldM = renderable.isSkinnedMesh && renderable.isSkinnedMesh() ? renderable.offsetMatrix ? renderable.offsetMatrix.array : $a11c3d79797af833$var$matrices.IDENTITY : renderable.worldTransform.array;
            var geometry = renderable.geometry;
            var material = passConfig.getMaterial.call(this, renderable);
            var program = renderable.__program;
            var shader = material.shader;
            var currentDrawID = geometry.__uid__ + "-" + program.__uid__;
            var drawIDChanged = currentDrawID !== drawID;
            drawID = currentDrawID;
            if (drawIDChanged && vaoExt) // TODO Seems need to be bound to null immediately (or before bind another program?) if vao is changed
            vaoExt.bindVertexArrayOES(null);
            if (isSceneNode) {
                (0, $0020ce97b75275ae$export$2e2bcd8739ae039).copy($a11c3d79797af833$var$matrices.WORLD, worldM);
                (0, $0020ce97b75275ae$export$2e2bcd8739ae039).multiply($a11c3d79797af833$var$matrices.WORLDVIEWPROJECTION, $a11c3d79797af833$var$matrices.VIEWPROJECTION, worldM);
                (0, $0020ce97b75275ae$export$2e2bcd8739ae039).multiplyAffine($a11c3d79797af833$var$matrices.WORLDVIEW, $a11c3d79797af833$var$matrices.VIEW, worldM);
                if (shader.matrixSemantics.WORLDINVERSE || shader.matrixSemantics.WORLDINVERSETRANSPOSE) (0, $0020ce97b75275ae$export$2e2bcd8739ae039).invert($a11c3d79797af833$var$matrices.WORLDINVERSE, worldM);
                if (shader.matrixSemantics.WORLDVIEWINVERSE || shader.matrixSemantics.WORLDVIEWINVERSETRANSPOSE) (0, $0020ce97b75275ae$export$2e2bcd8739ae039).invert($a11c3d79797af833$var$matrices.WORLDVIEWINVERSE, $a11c3d79797af833$var$matrices.WORLDVIEW);
                if (shader.matrixSemantics.WORLDVIEWPROJECTIONINVERSE || shader.matrixSemantics.WORLDVIEWPROJECTIONINVERSETRANSPOSE) (0, $0020ce97b75275ae$export$2e2bcd8739ae039).invert($a11c3d79797af833$var$matrices.WORLDVIEWPROJECTIONINVERSE, $a11c3d79797af833$var$matrices.WORLDVIEWPROJECTION);
            }
            // Before render hook
            renderable.beforeRender && renderable.beforeRender(this);
            passConfig.beforeRender.call(this, renderable, material, prevMaterial);
            var programChanged = program !== prevProgram;
            if (programChanged) {
                // Set lights number
                program.bind(this);
                // Set some common uniforms
                program.setUniformOfSemantic(_gl, "VIEWPORT", viewportUniform);
                program.setUniformOfSemantic(_gl, "WINDOW_SIZE", windowSizeUniform);
                if (camera) {
                    program.setUniformOfSemantic(_gl, "NEAR", camera.near);
                    program.setUniformOfSemantic(_gl, "FAR", camera.far);
                }
                program.setUniformOfSemantic(_gl, "DEVICEPIXELRATIO", vDpr);
                program.setUniformOfSemantic(_gl, "TIME", time);
                // DEPRECATED
                program.setUniformOfSemantic(_gl, "VIEWPORT_SIZE", viewportSizeUniform);
                // Set lights uniforms
                // TODO needs optimized
                if (scene) scene.setLightUniforms(program, renderable.lightGroup, this);
            } else program = prevProgram;
            // Program changes also needs reset the materials.
            if (programChanged || passConfig.isMaterialChanged(renderable, prevRenderable, material, prevMaterial)) {
                if (material.depthTest !== depthTest) {
                    material.depthTest ? _gl.enable(_gl.DEPTH_TEST) : _gl.disable(_gl.DEPTH_TEST);
                    depthTest = material.depthTest;
                }
                if (material.depthMask !== depthMask) {
                    _gl.depthMask(material.depthMask);
                    depthMask = material.depthMask;
                }
                if (material.transparent !== transparent) {
                    material.transparent ? _gl.enable(_gl.BLEND) : _gl.disable(_gl.BLEND);
                    transparent = material.transparent;
                }
                // TODO cache blending
                if (material.transparent) {
                    if (material.blend) material.blend(_gl);
                    else {
                        // Default blend function
                        _gl.blendEquationSeparate(_gl.FUNC_ADD, _gl.FUNC_ADD);
                        _gl.blendFuncSeparate(_gl.SRC_ALPHA, _gl.ONE_MINUS_SRC_ALPHA, _gl.ONE, _gl.ONE_MINUS_SRC_ALPHA);
                    }
                }
                materialTakesTextureSlot = this._bindMaterial(renderable, material, program, prevRenderable || null, prevMaterial || null, prevProgram || null, passConfig.getUniform);
                prevMaterial = material;
            }
            var matrixSemanticKeys = shader.matrixSemanticKeys;
            if (isSceneNode) for(var k = 0; k < matrixSemanticKeys.length; k++){
                var semantic = matrixSemanticKeys[k];
                var semanticInfo = shader.matrixSemantics[semantic];
                var matrix = $a11c3d79797af833$var$matrices[semantic];
                if (semanticInfo.isTranspose) {
                    var matrixNoTranspose = $a11c3d79797af833$var$matrices[semanticInfo.semanticNoTranspose];
                    (0, $0020ce97b75275ae$export$2e2bcd8739ae039).transpose(matrix, matrixNoTranspose);
                }
                program.setUniform(_gl, semanticInfo.type, semanticInfo.symbol, matrix);
            }
            if (renderable.cullFace !== cullFace) {
                cullFace = renderable.cullFace;
                _gl.cullFace(cullFace);
            }
            if (renderable.frontFace !== frontFace) {
                frontFace = renderable.frontFace;
                _gl.frontFace(frontFace);
            }
            if (renderable.culling !== culling) {
                culling = renderable.culling;
                culling ? _gl.enable(_gl.CULL_FACE) : _gl.disable(_gl.CULL_FACE);
            }
            // TODO Not update skeleton in each renderable.
            this._updateSkeleton(renderable, program, materialTakesTextureSlot);
            if (drawIDChanged) currentVAO = this._bindVAO(vaoExt, shader, geometry, program);
            this._renderObject(renderable, currentVAO, program);
            // After render hook
            passConfig.afterRender(this, renderable);
            renderable.afterRender && renderable.afterRender(this);
            prevProgram = program;
            prevRenderable = renderable;
        }
        // TODO Seems need to be bound to null immediately if vao is changed?
        if (vaoExt) vaoExt.bindVertexArrayOES(null);
        this.trigger("afterrenderpass", this, list, camera, passConfig);
    },
    getMaxJointNumber: function() {
        return this.maxJointNumber;
    },
    _updateSkeleton: function(object, program, slot) {
        var _gl = this.gl;
        var skeleton = object.skeleton;
        // Set pose matrices of skinned mesh
        if (skeleton) {
            // TODO Update before culling.
            skeleton.update();
            if (object.joints.length > this.getMaxJointNumber()) {
                var skinMatricesTexture = skeleton.getSubSkinMatricesTexture(object.__uid__, object.joints);
                program.useTextureSlot(this, skinMatricesTexture, slot);
                program.setUniform(_gl, "1i", "skinMatricesTexture", slot);
                program.setUniform(_gl, "1f", "skinMatricesTextureSize", skinMatricesTexture.width);
            } else {
                var skinMatricesArray = skeleton.getSubSkinMatrices(object.__uid__, object.joints);
                program.setUniformOfSemantic(_gl, "SKIN_MATRIX", skinMatricesArray);
            }
        }
    },
    _renderObject: function(renderable, vao, program) {
        var _gl = this.gl;
        var geometry = renderable.geometry;
        var glDrawMode = renderable.mode;
        if (glDrawMode == null) glDrawMode = 0x0004;
        var ext = null;
        var isInstanced = renderable.isInstancedMesh && renderable.isInstancedMesh();
        if (isInstanced) {
            ext = this.getGLExtension("ANGLE_instanced_arrays");
            if (!ext) {
                console.warn("Device not support ANGLE_instanced_arrays extension");
                return;
            }
        }
        var instancedAttrLocations;
        if (isInstanced) instancedAttrLocations = this._bindInstancedAttributes(renderable, program, ext);
        if (vao.indicesBuffer) {
            var uintExt = this.getGLExtension("OES_element_index_uint");
            var useUintExt = uintExt && geometry.indices instanceof Uint32Array;
            var indicesType = useUintExt ? _gl.UNSIGNED_INT : _gl.UNSIGNED_SHORT;
            if (isInstanced) ext.drawElementsInstancedANGLE(glDrawMode, vao.indicesBuffer.count, indicesType, 0, renderable.getInstanceCount());
            else _gl.drawElements(glDrawMode, vao.indicesBuffer.count, indicesType, 0);
        } else if (isInstanced) ext.drawArraysInstancedANGLE(glDrawMode, 0, geometry.vertexCount, renderable.getInstanceCount());
        else // FIXME Use vertex number in buffer
        // vertexCount may get the wrong value when geometry forget to mark dirty after update
        _gl.drawArrays(glDrawMode, 0, geometry.vertexCount);
        if (isInstanced) for(var i = 0; i < instancedAttrLocations.length; i++)_gl.disableVertexAttribArray(instancedAttrLocations[i]);
    },
    _bindInstancedAttributes: function(renderable, program, ext) {
        var _gl = this.gl;
        var instancedBuffers = renderable.getInstancedAttributesBuffers(this);
        var locations = [];
        for(var i = 0; i < instancedBuffers.length; i++){
            var bufferObj = instancedBuffers[i];
            var location = program.getAttribLocation(_gl, bufferObj.symbol);
            if (location < 0) continue;
            var glType = $a11c3d79797af833$var$attributeBufferTypeMap[bufferObj.type] || _gl.FLOAT;
            _gl.enableVertexAttribArray(location); // TODO
            _gl.bindBuffer(_gl.ARRAY_BUFFER, bufferObj.buffer);
            _gl.vertexAttribPointer(location, bufferObj.size, glType, false, 0, 0);
            ext.vertexAttribDivisorANGLE(location, bufferObj.divisor);
            locations.push(location);
        }
        return locations;
    },
    _bindMaterial: function(renderable, material, program, prevRenderable, prevMaterial, prevProgram, getUniformValue) {
        var _gl = this.gl;
        // PENDING Same texture in different material take different slot?
        // May use shader of other material if shader code are same
        var sameProgram = prevProgram === program;
        var currentTextureSlot = program.currentTextureSlot();
        var enabledUniforms = material.getEnabledUniforms();
        var textureUniforms = material.getTextureUniforms();
        var placeholderTexture = this._placeholderTexture;
        for(var u = 0; u < textureUniforms.length; u++){
            var symbol = textureUniforms[u];
            var uniformValue = getUniformValue(renderable, material, symbol);
            var uniformType = material.uniforms[symbol].type;
            // Not use `instanceof` to determine if a value is texture in Material#bind.
            // Use type instead, in some case texture may be in different namespaces.
            // TODO Duck type validate.
            if (uniformType === "t" && uniformValue) // Reset slot
            uniformValue.__slot = -1;
            else if (uniformType === "tv") {
                for(var i = 0; i < uniformValue.length; i++)if (uniformValue[i]) uniformValue[i].__slot = -1;
            }
        }
        placeholderTexture.__slot = -1;
        // Set uniforms
        for(var u = 0; u < enabledUniforms.length; u++){
            var symbol = enabledUniforms[u];
            var uniform = material.uniforms[symbol];
            var uniformValue = getUniformValue(renderable, material, symbol);
            var uniformType = uniform.type;
            var isTexture = uniformType === "t";
            if (isTexture) {
                if (!uniformValue || !uniformValue.isRenderable()) uniformValue = placeholderTexture;
            }
            // PENDING
            // When binding two materials with the same shader
            // Many uniforms will be be set twice even if they have the same value
            // So add a evaluation to see if the uniform is really needed to be set
            if (prevMaterial && sameProgram) {
                var prevUniformValue = getUniformValue(prevRenderable, prevMaterial, symbol);
                if (isTexture) {
                    if (!prevUniformValue || !prevUniformValue.isRenderable()) prevUniformValue = placeholderTexture;
                }
                if (prevUniformValue === uniformValue) {
                    if (isTexture) // Still take the slot to make sure same texture in different materials have same slot.
                    program.takeCurrentTextureSlot(this, null);
                    else if (uniformType === "tv" && uniformValue) for(var i = 0; i < uniformValue.length; i++)program.takeCurrentTextureSlot(this, null);
                    continue;
                }
            }
            if (uniformValue == null) continue;
            else if (isTexture) {
                if (uniformValue.__slot < 0) {
                    var slot = program.currentTextureSlot();
                    var res = program.setUniform(_gl, "1i", symbol, slot);
                    if (res) {
                        program.takeCurrentTextureSlot(this, uniformValue);
                        uniformValue.__slot = slot;
                    }
                } else program.setUniform(_gl, "1i", symbol, uniformValue.__slot);
            } else if (Array.isArray(uniformValue)) {
                if (uniformValue.length === 0) continue;
                // Texture Array
                if (uniformType === "tv") {
                    if (!program.hasUniform(symbol)) continue;
                    var arr = [];
                    for(var i = 0; i < uniformValue.length; i++){
                        var texture = uniformValue[i];
                        if (texture.__slot < 0) {
                            var slot = program.currentTextureSlot();
                            arr.push(slot);
                            program.takeCurrentTextureSlot(this, texture);
                            texture.__slot = slot;
                        } else arr.push(texture.__slot);
                    }
                    program.setUniform(_gl, "1iv", symbol, arr);
                } else program.setUniform(_gl, uniform.type, symbol, uniformValue);
            } else program.setUniform(_gl, uniform.type, symbol, uniformValue);
        }
        var newSlot = program.currentTextureSlot();
        // Texture slot maybe used out of material.
        program.resetTextureSlot(currentTextureSlot);
        return newSlot;
    },
    _bindVAO: function(vaoExt, shader, geometry, program) {
        var isStatic = !geometry.dynamic;
        var _gl = this.gl;
        var vaoId = this.__uid__ + "-" + program.__uid__;
        var vao = geometry.__vaoCache[vaoId];
        if (!vao) {
            var chunks = geometry.getBufferChunks(this);
            if (!chunks || !chunks.length) return;
            var chunk = chunks[0];
            var attributeBuffers = chunk.attributeBuffers;
            var indicesBuffer = chunk.indicesBuffer;
            var availableAttributes = [];
            var availableAttributeSymbols = [];
            for(var a = 0; a < attributeBuffers.length; a++){
                var attributeBufferInfo = attributeBuffers[a];
                var name = attributeBufferInfo.name;
                var semantic = attributeBufferInfo.semantic;
                var symbol;
                if (semantic) {
                    var semanticInfo = shader.attributeSemantics[semantic];
                    symbol = semanticInfo && semanticInfo.symbol;
                } else symbol = name;
                if (symbol && program.attributes[symbol]) {
                    availableAttributes.push(attributeBufferInfo);
                    availableAttributeSymbols.push(symbol);
                }
            }
            vao = new $a11c3d79797af833$var$VertexArrayObject(availableAttributes, availableAttributeSymbols, indicesBuffer);
            if (isStatic) geometry.__vaoCache[vaoId] = vao;
        }
        var needsBindAttributes = true;
        // Create vertex object array cost a lot
        // So we don't use it on the dynamic object
        if (vaoExt && isStatic) {
            // Use vertex array object
            // http://blog.tojicode.com/2012/10/oesvertexarrayobject-extension.html
            if (vao.vao == null) vao.vao = vaoExt.createVertexArrayOES();
            else needsBindAttributes = false;
            vaoExt.bindVertexArrayOES(vao.vao);
        }
        var availableAttributes = vao.availableAttributes;
        var indicesBuffer = vao.indicesBuffer;
        if (needsBindAttributes) {
            var locationList = program.enableAttributes(this, vao.availableAttributeSymbols, vaoExt && isStatic && vao);
            // Setting attributes;
            for(var a = 0; a < availableAttributes.length; a++){
                var location = locationList[a];
                if (location === -1) continue;
                var attributeBufferInfo = availableAttributes[a];
                var buffer = attributeBufferInfo.buffer;
                var size = attributeBufferInfo.size;
                var glType = $a11c3d79797af833$var$attributeBufferTypeMap[attributeBufferInfo.type] || _gl.FLOAT;
                _gl.bindBuffer(_gl.ARRAY_BUFFER, buffer);
                _gl.vertexAttribPointer(location, size, glType, false, 0, 0);
            }
            if (geometry.isUseIndices()) _gl.bindBuffer(_gl.ELEMENT_ARRAY_BUFFER, indicesBuffer.buffer);
        }
        return vao;
    },
    renderPreZ: function(list, scene, camera) {
        var _gl = this.gl;
        var preZPassMaterial = this._prezMaterial || new (0, $b70ebca493753aba$export$2e2bcd8739ae039)({
            shader: new (0, $90e78c81ac16d455$export$2e2bcd8739ae039)((0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("clay.prez.vertex"), (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("clay.prez.fragment"))
        });
        this._prezMaterial = preZPassMaterial;
        _gl.colorMask(false, false, false, false);
        _gl.depthMask(true);
        // Status
        this.renderPass(list, camera, {
            ifRender: function(renderable) {
                return !renderable.ignorePreZ;
            },
            isMaterialChanged: function(renderable, prevRenderable) {
                var matA = renderable.material;
                var matB = prevRenderable.material;
                return matA.get("diffuseMap") !== matB.get("diffuseMap") || (matA.get("alphaCutoff") || 0) !== (matB.get("alphaCutoff") || 0);
            },
            getUniform: function(renderable, depthMaterial, symbol) {
                if (symbol === "alphaMap") return renderable.material.get("diffuseMap");
                else if (symbol === "alphaCutoff") {
                    if (renderable.material.isDefined("fragment", "ALPHA_TEST") && renderable.material.get("diffuseMap")) {
                        var alphaCutoff = renderable.material.get("alphaCutoff");
                        return alphaCutoff || 0;
                    }
                    return 0;
                } else if (symbol === "uvRepeat") return renderable.material.get("uvRepeat");
                else if (symbol === "uvOffset") return renderable.material.get("uvOffset");
                else return depthMaterial.get(symbol);
            },
            getMaterial: function() {
                return preZPassMaterial;
            },
            sort: this.opaqueSortCompare
        });
        _gl.colorMask(true, true, true, true);
        _gl.depthMask(true);
    },
    /**
     * Dispose given scene, including all geometris, textures and shaders in the scene
     * @param {clay.Scene} scene
     */ disposeScene: function(scene) {
        this.disposeNode(scene, true, true);
        scene.dispose();
    },
    /**
     * Dispose given node, including all geometries, textures and shaders attached on it or its descendant
     * @param {clay.Node} node
     * @param {boolean} [disposeGeometry=false] If dispose the geometries used in the descendant mesh
     * @param {boolean} [disposeTexture=false] If dispose the textures used in the descendant mesh
     */ disposeNode: function(root, disposeGeometry, disposeTexture) {
        // Dettached from parent
        if (root.getParent()) root.getParent().remove(root);
        var disposedMap = {};
        root.traverse(function(node) {
            var material = node.material;
            if (node.geometry && disposeGeometry) node.geometry.dispose(this);
            if (disposeTexture && material && !disposedMap[material.__uid__]) {
                var textureUniforms = material.getTextureUniforms();
                for(var u = 0; u < textureUniforms.length; u++){
                    var uniformName = textureUniforms[u];
                    var val = material.uniforms[uniformName].value;
                    var uniformType = material.uniforms[uniformName].type;
                    if (!val) continue;
                    if (uniformType === "t") val.dispose && val.dispose(this);
                    else if (uniformType === "tv") {
                        for(var k = 0; k < val.length; k++)if (val[k]) val[k].dispose && val[k].dispose(this);
                    }
                }
                disposedMap[material.__uid__] = true;
            }
            // Particle system and AmbientCubemap light need to dispose
            if (node.dispose) node.dispose(this);
        }, this);
    },
    /**
     * Dispose given geometry
     * @param {clay.Geometry} geometry
     */ disposeGeometry: function(geometry) {
        geometry.dispose(this);
    },
    /**
     * Dispose given texture
     * @param {clay.Texture} texture
     */ disposeTexture: function(texture) {
        texture.dispose(this);
    },
    /**
     * Dispose given frame buffer
     * @param {clay.FrameBuffer} frameBuffer
     */ disposeFrameBuffer: function(frameBuffer) {
        frameBuffer.dispose(this);
    },
    /**
     * Dispose renderer
     */ dispose: function() {},
    /**
     * Convert screen coords to normalized device coordinates(NDC)
     * Screen coords can get from mouse event, it is positioned relative to canvas element
     * NDC can be used in ray casting with Camera.prototype.castRay methods
     *
     * @param  {number}       x
     * @param  {number}       y
     * @param  {clay.Vector2} [out]
     * @return {clay.Vector2}
     */ screenToNDC: function(x, y, out) {
        if (!out) out = new (0, $2cb41795bddfe4d3$export$2e2bcd8739ae039)();
        // Invert y;
        y = this._height - y;
        var viewport = this.viewport;
        var arr = out.array;
        arr[0] = (x - viewport.x) / viewport.width;
        arr[0] = arr[0] * 2 - 1;
        arr[1] = (y - viewport.y) / viewport.height;
        arr[1] = arr[1] * 2 - 1;
        return out;
    }
});
/**
 * Opaque renderables compare function
 * @param  {clay.Renderable} x
 * @param  {clay.Renderable} y
 * @return {boolean}
 * @static
 */ $a11c3d79797af833$var$Renderer.opaqueSortCompare = $a11c3d79797af833$var$Renderer.prototype.opaqueSortCompare = function(x, y) {
    // Priority renderOrder -> program -> material -> geometry
    if (x.renderOrder === y.renderOrder) {
        if (x.__program === y.__program) {
            if (x.material === y.material) return x.geometry.__uid__ - y.geometry.__uid__;
            return x.material.__uid__ - y.material.__uid__;
        }
        if (x.__program && y.__program) return x.__program.__uid__ - y.__program.__uid__;
        return 0;
    }
    return x.renderOrder - y.renderOrder;
};
/**
 * Transparent renderables compare function
 * @param  {clay.Renderable} a
 * @param  {clay.Renderable} b
 * @return {boolean}
 * @static
 */ $a11c3d79797af833$var$Renderer.transparentSortCompare = $a11c3d79797af833$var$Renderer.prototype.transparentSortCompare = function(x, y) {
    // Priority renderOrder -> depth -> program -> material -> geometry
    if (x.renderOrder === y.renderOrder) {
        if (x.__depth === y.__depth) {
            if (x.__program === y.__program) {
                if (x.material === y.material) return x.geometry.__uid__ - y.geometry.__uid__;
                return x.material.__uid__ - y.material.__uid__;
            }
            if (x.__program && y.__program) return x.__program.__uid__ - y.__program.__uid__;
            return 0;
        }
        // Depth is negative
        // So farther object has smaller depth value
        return x.__depth - y.__depth;
    }
    return x.renderOrder - y.renderOrder;
};
// Temporary variables
var $a11c3d79797af833$var$matrices = {
    IDENTITY: $a11c3d79797af833$var$mat4Create(),
    WORLD: $a11c3d79797af833$var$mat4Create(),
    VIEW: $a11c3d79797af833$var$mat4Create(),
    PROJECTION: $a11c3d79797af833$var$mat4Create(),
    WORLDVIEW: $a11c3d79797af833$var$mat4Create(),
    VIEWPROJECTION: $a11c3d79797af833$var$mat4Create(),
    WORLDVIEWPROJECTION: $a11c3d79797af833$var$mat4Create(),
    WORLDINVERSE: $a11c3d79797af833$var$mat4Create(),
    VIEWINVERSE: $a11c3d79797af833$var$mat4Create(),
    PROJECTIONINVERSE: $a11c3d79797af833$var$mat4Create(),
    WORLDVIEWINVERSE: $a11c3d79797af833$var$mat4Create(),
    VIEWPROJECTIONINVERSE: $a11c3d79797af833$var$mat4Create(),
    WORLDVIEWPROJECTIONINVERSE: $a11c3d79797af833$var$mat4Create(),
    WORLDTRANSPOSE: $a11c3d79797af833$var$mat4Create(),
    VIEWTRANSPOSE: $a11c3d79797af833$var$mat4Create(),
    PROJECTIONTRANSPOSE: $a11c3d79797af833$var$mat4Create(),
    WORLDVIEWTRANSPOSE: $a11c3d79797af833$var$mat4Create(),
    VIEWPROJECTIONTRANSPOSE: $a11c3d79797af833$var$mat4Create(),
    WORLDVIEWPROJECTIONTRANSPOSE: $a11c3d79797af833$var$mat4Create(),
    WORLDINVERSETRANSPOSE: $a11c3d79797af833$var$mat4Create(),
    VIEWINVERSETRANSPOSE: $a11c3d79797af833$var$mat4Create(),
    PROJECTIONINVERSETRANSPOSE: $a11c3d79797af833$var$mat4Create(),
    WORLDVIEWINVERSETRANSPOSE: $a11c3d79797af833$var$mat4Create(),
    VIEWPROJECTIONINVERSETRANSPOSE: $a11c3d79797af833$var$mat4Create(),
    WORLDVIEWPROJECTIONINVERSETRANSPOSE: $a11c3d79797af833$var$mat4Create()
};
/**
 * @name clay.Renderer.COLOR_BUFFER_BIT
 * @type {number}
 */ $a11c3d79797af833$var$Renderer.COLOR_BUFFER_BIT = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).COLOR_BUFFER_BIT;
/**
 * @name clay.Renderer.DEPTH_BUFFER_BIT
 * @type {number}
 */ $a11c3d79797af833$var$Renderer.DEPTH_BUFFER_BIT = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).DEPTH_BUFFER_BIT;
/**
 * @name clay.Renderer.STENCIL_BUFFER_BIT
 * @type {number}
 */ $a11c3d79797af833$var$Renderer.STENCIL_BUFFER_BIT = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).STENCIL_BUFFER_BIT;
var $a11c3d79797af833$export$2e2bcd8739ae039 = $a11c3d79797af833$var$Renderer;




/**
 * @constructor
 * @alias clay.Vector3
 * @param {number} x
 * @param {number} y
 * @param {number} z
 */ var $27fea36417076c2d$var$Vector3 = function(x, y, z) {
    x = x || 0;
    y = y || 0;
    z = z || 0;
    /**
     * Storage of Vector3, read and write of x, y, z will change the values in array
     * All methods also operate on the array instead of x, y, z components
     * @name array
     * @type {Float32Array}
     * @memberOf clay.Vector3#
     */ this.array = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).fromValues(x, y, z);
    /**
     * Dirty flag is used by the Node to determine
     * if the matrix is updated to latest
     * @name _dirty
     * @type {boolean}
     * @memberOf clay.Vector3#
     */ this._dirty = true;
};
$27fea36417076c2d$var$Vector3.prototype = {
    constructor: $27fea36417076c2d$var$Vector3,
    /**
     * Add b to self
     * @param  {clay.Vector3} b
     * @return {clay.Vector3}
     */ add: function(b) {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).add(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Set x, y and z components
     * @param  {number}  x
     * @param  {number}  y
     * @param  {number}  z
     * @return {clay.Vector3}
     */ set: function(x, y, z) {
        this.array[0] = x;
        this.array[1] = y;
        this.array[2] = z;
        this._dirty = true;
        return this;
    },
    /**
     * Set x, y and z components from array
     * @param  {Float32Array|number[]} arr
     * @return {clay.Vector3}
     */ setArray: function(arr) {
        this.array[0] = arr[0];
        this.array[1] = arr[1];
        this.array[2] = arr[2];
        this._dirty = true;
        return this;
    },
    /**
     * Clone a new Vector3
     * @return {clay.Vector3}
     */ clone: function() {
        return new $27fea36417076c2d$var$Vector3(this.x, this.y, this.z);
    },
    /**
     * Copy from b
     * @param  {clay.Vector3} b
     * @return {clay.Vector3}
     */ copy: function(b) {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).copy(this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Cross product of self and b, written to a Vector3 out
     * @param  {clay.Vector3} a
     * @param  {clay.Vector3} b
     * @return {clay.Vector3}
     */ cross: function(a, b) {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).cross(this.array, a.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Alias for distance
     * @param  {clay.Vector3} b
     * @return {number}
     */ dist: function(b) {
        return (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dist(this.array, b.array);
    },
    /**
     * Distance between self and b
     * @param  {clay.Vector3} b
     * @return {number}
     */ distance: function(b) {
        return (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).distance(this.array, b.array);
    },
    /**
     * Alias for divide
     * @param  {clay.Vector3} b
     * @return {clay.Vector3}
     */ div: function(b) {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).div(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Divide self by b
     * @param  {clay.Vector3} b
     * @return {clay.Vector3}
     */ divide: function(b) {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).divide(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Dot product of self and b
     * @param  {clay.Vector3} b
     * @return {number}
     */ dot: function(b) {
        return (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(this.array, b.array);
    },
    /**
     * Alias of length
     * @return {number}
     */ len: function() {
        return (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).len(this.array);
    },
    /**
     * Calculate the length
     * @return {number}
     */ length: function() {
        return (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).length(this.array);
    },
    /**
     * Linear interpolation between a and b
     * @param  {clay.Vector3} a
     * @param  {clay.Vector3} b
     * @param  {number}  t
     * @return {clay.Vector3}
     */ lerp: function(a, b, t) {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).lerp(this.array, a.array, b.array, t);
        this._dirty = true;
        return this;
    },
    /**
     * Minimum of self and b
     * @param  {clay.Vector3} b
     * @return {clay.Vector3}
     */ min: function(b) {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).min(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Maximum of self and b
     * @param  {clay.Vector3} b
     * @return {clay.Vector3}
     */ max: function(b) {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).max(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Alias for multiply
     * @param  {clay.Vector3} b
     * @return {clay.Vector3}
     */ mul: function(b) {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).mul(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Mutiply self and b
     * @param  {clay.Vector3} b
     * @return {clay.Vector3}
     */ multiply: function(b) {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).multiply(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Negate self
     * @return {clay.Vector3}
     */ negate: function() {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).negate(this.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Normalize self
     * @return {clay.Vector3}
     */ normalize: function() {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).normalize(this.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Generate random x, y, z components with a given scale
     * @param  {number} scale
     * @return {clay.Vector3}
     */ random: function(scale) {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).random(this.array, scale);
        this._dirty = true;
        return this;
    },
    /**
     * Scale self
     * @param  {number}  scale
     * @return {clay.Vector3}
     */ scale: function(s) {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scale(this.array, this.array, s);
        this._dirty = true;
        return this;
    },
    /**
     * Scale b and add to self
     * @param  {clay.Vector3} b
     * @param  {number}  scale
     * @return {clay.Vector3}
     */ scaleAndAdd: function(b, s) {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scaleAndAdd(this.array, this.array, b.array, s);
        this._dirty = true;
        return this;
    },
    /**
     * Alias for squaredDistance
     * @param  {clay.Vector3} b
     * @return {number}
     */ sqrDist: function(b) {
        return (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).sqrDist(this.array, b.array);
    },
    /**
     * Squared distance between self and b
     * @param  {clay.Vector3} b
     * @return {number}
     */ squaredDistance: function(b) {
        return (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).squaredDistance(this.array, b.array);
    },
    /**
     * Alias for squaredLength
     * @return {number}
     */ sqrLen: function() {
        return (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).sqrLen(this.array);
    },
    /**
     * Squared length of self
     * @return {number}
     */ squaredLength: function() {
        return (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).squaredLength(this.array);
    },
    /**
     * Alias for subtract
     * @param  {clay.Vector3} b
     * @return {clay.Vector3}
     */ sub: function(b) {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).sub(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Subtract b from self
     * @param  {clay.Vector3} b
     * @return {clay.Vector3}
     */ subtract: function(b) {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).subtract(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Transform self with a Matrix3 m
     * @param  {clay.Matrix3} m
     * @return {clay.Vector3}
     */ transformMat3: function(m) {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).transformMat3(this.array, this.array, m.array);
        this._dirty = true;
        return this;
    },
    /**
     * Transform self with a Matrix4 m
     * @param  {clay.Matrix4} m
     * @return {clay.Vector3}
     */ transformMat4: function(m) {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).transformMat4(this.array, this.array, m.array);
        this._dirty = true;
        return this;
    },
    /**
     * Transform self with a Quaternion q
     * @param  {clay.Quaternion} q
     * @return {clay.Vector3}
     */ transformQuat: function(q) {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).transformQuat(this.array, this.array, q.array);
        this._dirty = true;
        return this;
    },
    /**
     * Trasnform self into projection space with m
     * @param  {clay.Matrix4} m
     * @return {clay.Vector3}
     */ applyProjection: function(m) {
        var v = this.array;
        m = m.array;
        // Perspective projection
        if (m[15] === 0) {
            var w = -1 / v[2];
            v[0] = m[0] * v[0] * w;
            v[1] = m[5] * v[1] * w;
            v[2] = (m[10] * v[2] + m[14]) * w;
        } else {
            v[0] = m[0] * v[0] + m[12];
            v[1] = m[5] * v[1] + m[13];
            v[2] = m[10] * v[2] + m[14];
        }
        this._dirty = true;
        return this;
    },
    eulerFromQuat: function(q, order) {
        $27fea36417076c2d$var$Vector3.eulerFromQuat(this, q, order);
    },
    eulerFromMat3: function(m, order) {
        $27fea36417076c2d$var$Vector3.eulerFromMat3(this, m, order);
    },
    toString: function() {
        return "[" + Array.prototype.join.call(this.array, ",") + "]";
    },
    toArray: function() {
        return Array.prototype.slice.call(this.array);
    }
};
var $27fea36417076c2d$var$defineProperty = Object.defineProperty;
// Getter and Setter
if ($27fea36417076c2d$var$defineProperty) {
    var $27fea36417076c2d$var$proto = $27fea36417076c2d$var$Vector3.prototype;
    /**
     * @name x
     * @type {number}
     * @memberOf clay.Vector3
     * @instance
     */ $27fea36417076c2d$var$defineProperty($27fea36417076c2d$var$proto, "x", {
        get: function() {
            return this.array[0];
        },
        set: function(value) {
            this.array[0] = value;
            this._dirty = true;
        }
    });
    /**
     * @name y
     * @type {number}
     * @memberOf clay.Vector3
     * @instance
     */ $27fea36417076c2d$var$defineProperty($27fea36417076c2d$var$proto, "y", {
        get: function() {
            return this.array[1];
        },
        set: function(value) {
            this.array[1] = value;
            this._dirty = true;
        }
    });
    /**
     * @name z
     * @type {number}
     * @memberOf clay.Vector3
     * @instance
     */ $27fea36417076c2d$var$defineProperty($27fea36417076c2d$var$proto, "z", {
        get: function() {
            return this.array[2];
        },
        set: function(value) {
            this.array[2] = value;
            this._dirty = true;
        }
    });
}
// Supply methods that are not in place
/**
 * @param  {clay.Vector3} out
 * @param  {clay.Vector3} a
 * @param  {clay.Vector3} b
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.add = function(out, a, b) {
    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).add(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector3} out
 * @param  {number}  x
 * @param  {number}  y
 * @param  {number}  z
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.set = function(out, x, y, z) {
    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).set(out.array, x, y, z);
    out._dirty = true;
};
/**
 * @param  {clay.Vector3} out
 * @param  {clay.Vector3} b
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.copy = function(out, b) {
    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).copy(out.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector3} out
 * @param  {clay.Vector3} a
 * @param  {clay.Vector3} b
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.cross = function(out, a, b) {
    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).cross(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector3} a
 * @param  {clay.Vector3} b
 * @return {number}
 */ $27fea36417076c2d$var$Vector3.dist = function(a, b) {
    return (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).distance(a.array, b.array);
};
/**
 * @function
 * @param  {clay.Vector3} a
 * @param  {clay.Vector3} b
 * @return {number}
 */ $27fea36417076c2d$var$Vector3.distance = $27fea36417076c2d$var$Vector3.dist;
/**
 * @param  {clay.Vector3} out
 * @param  {clay.Vector3} a
 * @param  {clay.Vector3} b
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.div = function(out, a, b) {
    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).divide(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @function
 * @param  {clay.Vector3} out
 * @param  {clay.Vector3} a
 * @param  {clay.Vector3} b
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.divide = $27fea36417076c2d$var$Vector3.div;
/**
 * @param  {clay.Vector3} a
 * @param  {clay.Vector3} b
 * @return {number}
 */ $27fea36417076c2d$var$Vector3.dot = function(a, b) {
    return (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(a.array, b.array);
};
/**
 * @param  {clay.Vector3} a
 * @return {number}
 */ $27fea36417076c2d$var$Vector3.len = function(b) {
    return (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).length(b.array);
};
// Vector3.length = Vector3.len;
/**
 * @param  {clay.Vector3} out
 * @param  {clay.Vector3} a
 * @param  {clay.Vector3} b
 * @param  {number}  t
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.lerp = function(out, a, b, t) {
    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).lerp(out.array, a.array, b.array, t);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector3} out
 * @param  {clay.Vector3} a
 * @param  {clay.Vector3} b
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.min = function(out, a, b) {
    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).min(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector3} out
 * @param  {clay.Vector3} a
 * @param  {clay.Vector3} b
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.max = function(out, a, b) {
    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).max(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector3} out
 * @param  {clay.Vector3} a
 * @param  {clay.Vector3} b
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.mul = function(out, a, b) {
    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).multiply(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @function
 * @param  {clay.Vector3} out
 * @param  {clay.Vector3} a
 * @param  {clay.Vector3} b
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.multiply = $27fea36417076c2d$var$Vector3.mul;
/**
 * @param  {clay.Vector3} out
 * @param  {clay.Vector3} a
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.negate = function(out, a) {
    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).negate(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector3} out
 * @param  {clay.Vector3} a
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.normalize = function(out, a) {
    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).normalize(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector3} out
 * @param  {number}  scale
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.random = function(out, scale) {
    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).random(out.array, scale);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector3} out
 * @param  {clay.Vector3} a
 * @param  {number}  scale
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.scale = function(out, a, scale) {
    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scale(out.array, a.array, scale);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector3} out
 * @param  {clay.Vector3} a
 * @param  {clay.Vector3} b
 * @param  {number}  scale
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.scaleAndAdd = function(out, a, b, scale) {
    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scaleAndAdd(out.array, a.array, b.array, scale);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector3} a
 * @param  {clay.Vector3} b
 * @return {number}
 */ $27fea36417076c2d$var$Vector3.sqrDist = function(a, b) {
    return (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).sqrDist(a.array, b.array);
};
/**
 * @function
 * @param  {clay.Vector3} a
 * @param  {clay.Vector3} b
 * @return {number}
 */ $27fea36417076c2d$var$Vector3.squaredDistance = $27fea36417076c2d$var$Vector3.sqrDist;
/**
 * @param  {clay.Vector3} a
 * @return {number}
 */ $27fea36417076c2d$var$Vector3.sqrLen = function(a) {
    return (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).sqrLen(a.array);
};
/**
 * @function
 * @param  {clay.Vector3} a
 * @return {number}
 */ $27fea36417076c2d$var$Vector3.squaredLength = $27fea36417076c2d$var$Vector3.sqrLen;
/**
 * @param  {clay.Vector3} out
 * @param  {clay.Vector3} a
 * @param  {clay.Vector3} b
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.sub = function(out, a, b) {
    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).subtract(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @function
 * @param  {clay.Vector3} out
 * @param  {clay.Vector3} a
 * @param  {clay.Vector3} b
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.subtract = $27fea36417076c2d$var$Vector3.sub;
/**
 * @param  {clay.Vector3} out
 * @param  {clay.Vector3} a
 * @param  {Matrix3} m
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.transformMat3 = function(out, a, m) {
    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).transformMat3(out.array, a.array, m.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector3} out
 * @param  {clay.Vector3} a
 * @param  {clay.Matrix4} m
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.transformMat4 = function(out, a, m) {
    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).transformMat4(out.array, a.array, m.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector3} out
 * @param  {clay.Vector3} a
 * @param  {clay.Quaternion} q
 * @return {clay.Vector3}
 */ $27fea36417076c2d$var$Vector3.transformQuat = function(out, a, q) {
    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).transformQuat(out.array, a.array, q.array);
    out._dirty = true;
    return out;
};
function $27fea36417076c2d$var$clamp(val, min, max) {
    return val < min ? min : val > max ? max : val;
}
var $27fea36417076c2d$var$atan2 = Math.atan2;
var $27fea36417076c2d$var$asin = Math.asin;
var $27fea36417076c2d$var$abs = Math.abs;
/**
 * Convert quaternion to euler angle
 * Quaternion must be normalized
 * From three.js
 */ $27fea36417076c2d$var$Vector3.eulerFromQuat = function(out, q, order) {
    out._dirty = true;
    q = q.array;
    var target = out.array;
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x * x;
    var y2 = y * y;
    var z2 = z * z;
    var w2 = w * w;
    var order = (order || "XYZ").toUpperCase();
    switch(order){
        case "XYZ":
            target[0] = $27fea36417076c2d$var$atan2(2 * (x * w - y * z), w2 - x2 - y2 + z2);
            target[1] = $27fea36417076c2d$var$asin($27fea36417076c2d$var$clamp(2 * (x * z + y * w), -1, 1));
            target[2] = $27fea36417076c2d$var$atan2(2 * (z * w - x * y), w2 + x2 - y2 - z2);
            break;
        case "YXZ":
            target[0] = $27fea36417076c2d$var$asin($27fea36417076c2d$var$clamp(2 * (x * w - y * z), -1, 1));
            target[1] = $27fea36417076c2d$var$atan2(2 * (x * z + y * w), w2 - x2 - y2 + z2);
            target[2] = $27fea36417076c2d$var$atan2(2 * (x * y + z * w), w2 - x2 + y2 - z2);
            break;
        case "ZXY":
            target[0] = $27fea36417076c2d$var$asin($27fea36417076c2d$var$clamp(2 * (x * w + y * z), -1, 1));
            target[1] = $27fea36417076c2d$var$atan2(2 * (y * w - z * x), w2 - x2 - y2 + z2);
            target[2] = $27fea36417076c2d$var$atan2(2 * (z * w - x * y), w2 - x2 + y2 - z2);
            break;
        case "ZYX":
            target[0] = $27fea36417076c2d$var$atan2(2 * (x * w + z * y), w2 - x2 - y2 + z2);
            target[1] = $27fea36417076c2d$var$asin($27fea36417076c2d$var$clamp(2 * (y * w - x * z), -1, 1));
            target[2] = $27fea36417076c2d$var$atan2(2 * (x * y + z * w), w2 + x2 - y2 - z2);
            break;
        case "YZX":
            target[0] = $27fea36417076c2d$var$atan2(2 * (x * w - z * y), w2 - x2 + y2 - z2);
            target[1] = $27fea36417076c2d$var$atan2(2 * (y * w - x * z), w2 + x2 - y2 - z2);
            target[2] = $27fea36417076c2d$var$asin($27fea36417076c2d$var$clamp(2 * (x * y + z * w), -1, 1));
            break;
        case "XZY":
            target[0] = $27fea36417076c2d$var$atan2(2 * (x * w + y * z), w2 - x2 + y2 - z2);
            target[1] = $27fea36417076c2d$var$atan2(2 * (x * z + y * w), w2 + x2 - y2 - z2);
            target[2] = $27fea36417076c2d$var$asin($27fea36417076c2d$var$clamp(2 * (z * w - x * y), -1, 1));
            break;
        default:
            console.warn("Unkown order: " + order);
    }
    return out;
};
/**
 * Convert rotation matrix to euler angle
 * from three.js
 */ $27fea36417076c2d$var$Vector3.eulerFromMat3 = function(out, m, order) {
    // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
    var te = m.array;
    var m11 = te[0], m12 = te[3], m13 = te[6];
    var m21 = te[1], m22 = te[4], m23 = te[7];
    var m31 = te[2], m32 = te[5], m33 = te[8];
    var target = out.array;
    var order = (order || "XYZ").toUpperCase();
    switch(order){
        case "XYZ":
            target[1] = $27fea36417076c2d$var$asin($27fea36417076c2d$var$clamp(m13, -1, 1));
            if ($27fea36417076c2d$var$abs(m13) < 0.99999) {
                target[0] = $27fea36417076c2d$var$atan2(-m23, m33);
                target[2] = $27fea36417076c2d$var$atan2(-m12, m11);
            } else {
                target[0] = $27fea36417076c2d$var$atan2(m32, m22);
                target[2] = 0;
            }
            break;
        case "YXZ":
            target[0] = $27fea36417076c2d$var$asin(-$27fea36417076c2d$var$clamp(m23, -1, 1));
            if ($27fea36417076c2d$var$abs(m23) < 0.99999) {
                target[1] = $27fea36417076c2d$var$atan2(m13, m33);
                target[2] = $27fea36417076c2d$var$atan2(m21, m22);
            } else {
                target[1] = $27fea36417076c2d$var$atan2(-m31, m11);
                target[2] = 0;
            }
            break;
        case "ZXY":
            target[0] = $27fea36417076c2d$var$asin($27fea36417076c2d$var$clamp(m32, -1, 1));
            if ($27fea36417076c2d$var$abs(m32) < 0.99999) {
                target[1] = $27fea36417076c2d$var$atan2(-m31, m33);
                target[2] = $27fea36417076c2d$var$atan2(-m12, m22);
            } else {
                target[1] = 0;
                target[2] = $27fea36417076c2d$var$atan2(m21, m11);
            }
            break;
        case "ZYX":
            target[1] = $27fea36417076c2d$var$asin(-$27fea36417076c2d$var$clamp(m31, -1, 1));
            if ($27fea36417076c2d$var$abs(m31) < 0.99999) {
                target[0] = $27fea36417076c2d$var$atan2(m32, m33);
                target[2] = $27fea36417076c2d$var$atan2(m21, m11);
            } else {
                target[0] = 0;
                target[2] = $27fea36417076c2d$var$atan2(-m12, m22);
            }
            break;
        case "YZX":
            target[2] = $27fea36417076c2d$var$asin($27fea36417076c2d$var$clamp(m21, -1, 1));
            if ($27fea36417076c2d$var$abs(m21) < 0.99999) {
                target[0] = $27fea36417076c2d$var$atan2(-m23, m22);
                target[1] = $27fea36417076c2d$var$atan2(-m31, m11);
            } else {
                target[0] = 0;
                target[1] = $27fea36417076c2d$var$atan2(m13, m33);
            }
            break;
        case "XZY":
            target[2] = $27fea36417076c2d$var$asin(-$27fea36417076c2d$var$clamp(m12, -1, 1));
            if ($27fea36417076c2d$var$abs(m12) < 0.99999) {
                target[0] = $27fea36417076c2d$var$atan2(m32, m22);
                target[1] = $27fea36417076c2d$var$atan2(m13, m11);
            } else {
                target[0] = $27fea36417076c2d$var$atan2(-m23, m33);
                target[1] = 0;
            }
            break;
        default:
            console.warn("Unkown order: " + order);
    }
    out._dirty = true;
    return out;
};
Object.defineProperties($27fea36417076c2d$var$Vector3, {
    /**
     * @type {clay.Vector3}
     * @readOnly
     * @memberOf clay.Vector3
     */ POSITIVE_X: {
        get: function() {
            return new $27fea36417076c2d$var$Vector3(1, 0, 0);
        }
    },
    /**
     * @type {clay.Vector3}
     * @readOnly
     * @memberOf clay.Vector3
     */ NEGATIVE_X: {
        get: function() {
            return new $27fea36417076c2d$var$Vector3(-1, 0, 0);
        }
    },
    /**
     * @type {clay.Vector3}
     * @readOnly
     * @memberOf clay.Vector3
     */ POSITIVE_Y: {
        get: function() {
            return new $27fea36417076c2d$var$Vector3(0, 1, 0);
        }
    },
    /**
     * @type {clay.Vector3}
     * @readOnly
     * @memberOf clay.Vector3
     */ NEGATIVE_Y: {
        get: function() {
            return new $27fea36417076c2d$var$Vector3(0, -1, 0);
        }
    },
    /**
     * @type {clay.Vector3}
     * @readOnly
     * @memberOf clay.Vector3
     */ POSITIVE_Z: {
        get: function() {
            return new $27fea36417076c2d$var$Vector3(0, 0, 1);
        }
    },
    /**
     * @type {clay.Vector3}
     * @readOnly
     */ NEGATIVE_Z: {
        get: function() {
            return new $27fea36417076c2d$var$Vector3(0, 0, -1);
        }
    },
    /**
     * @type {clay.Vector3}
     * @readOnly
     * @memberOf clay.Vector3
     */ UP: {
        get: function() {
            return new $27fea36417076c2d$var$Vector3(0, 1, 0);
        }
    },
    /**
     * @type {clay.Vector3}
     * @readOnly
     * @memberOf clay.Vector3
     */ ZERO: {
        get: function() {
            return new $27fea36417076c2d$var$Vector3();
        }
    }
});
var $27fea36417076c2d$export$2e2bcd8739ae039 = $27fea36417076c2d$var$Vector3;



var $65a5d9098f8e83b0$var$EPSILON = 1e-5;
/**
 * @constructor
 * @alias clay.Ray
 * @param {clay.Vector3} [origin]
 * @param {clay.Vector3} [direction]
 */ var $65a5d9098f8e83b0$var$Ray = function(origin, direction) {
    /**
     * @type {clay.Vector3}
     */ this.origin = origin || new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
    /**
     * @type {clay.Vector3}
     */ this.direction = direction || new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
};
$65a5d9098f8e83b0$var$Ray.prototype = {
    constructor: $65a5d9098f8e83b0$var$Ray,
    // http://www.siggraph.org/education/materials/HyperGraph/raytrace/rayplane_intersection.htm
    /**
     * Calculate intersection point between ray and a give plane
     * @param  {clay.Plane} plane
     * @param  {clay.Vector3} [out]
     * @return {clay.Vector3}
     */ intersectPlane: function(plane, out) {
        var pn = plane.normal.array;
        var d = plane.distance;
        var ro = this.origin.array;
        var rd = this.direction.array;
        var divider = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(pn, rd);
        // ray is parallel to the plane
        if (divider === 0) return null;
        if (!out) out = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
        var t = ((0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(pn, ro) - d) / divider;
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scaleAndAdd(out.array, ro, rd, -t);
        out._dirty = true;
        return out;
    },
    /**
     * Mirror the ray against plane
     * @param  {clay.Plane} plane
     */ mirrorAgainstPlane: function(plane) {
        // Distance to plane
        var d = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(plane.normal.array, this.direction.array);
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scaleAndAdd(this.direction.array, this.direction.array, plane.normal.array, -d * 2);
        this.direction._dirty = true;
    },
    distanceToPoint: function() {
        var v = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
        return function(point) {
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).sub(v, point, this.origin.array);
            // Distance from projection point to origin
            var b = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(v, this.direction.array);
            if (b < 0) return (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).distance(this.origin.array, point);
            // Squared distance from center to origin
            var c2 = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).lenSquared(v);
            // Squared distance from center to projection point
            return Math.sqrt(c2 - b * b);
        };
    }(),
    /**
     * Calculate intersection point between ray and sphere
     * @param  {clay.Vector3} center
     * @param  {number} radius
     * @param  {clay.Vector3} out
     * @return {clay.Vector3}
     */ intersectSphere: function() {
        var v = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
        return function(center, radius, out) {
            var origin = this.origin.array;
            var direction = this.direction.array;
            center = center.array;
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).sub(v, center, origin);
            // Distance from projection point to origin
            var b = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(v, direction);
            // Squared distance from center to origin
            var c2 = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).squaredLength(v);
            // Squared distance from center to projection point
            var d2 = c2 - b * b;
            var r2 = radius * radius;
            // No intersection
            if (d2 > r2) return;
            var a = Math.sqrt(r2 - d2);
            // First intersect point
            var t0 = b - a;
            // Second intersect point
            var t1 = b + a;
            if (!out) out = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
            if (t0 < 0) {
                if (t1 < 0) return null;
                else {
                    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scaleAndAdd(out.array, origin, direction, t1);
                    return out;
                }
            } else {
                (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scaleAndAdd(out.array, origin, direction, t0);
                return out;
            }
        };
    }(),
    // http://www.scratchapixel.com/lessons/3d-basic-lessons/lesson-7-intersecting-simple-shapes/ray-box-intersection/
    /**
     * Calculate intersection point between ray and bounding box
     * @param {clay.BoundingBox} bbox
     * @param {clay.Vector3}
     * @return {clay.Vector3}
     */ intersectBoundingBox: function(bbox, out) {
        var dir = this.direction.array;
        var origin = this.origin.array;
        var min = bbox.min.array;
        var max = bbox.max.array;
        var invdirx = 1 / dir[0];
        var invdiry = 1 / dir[1];
        var invdirz = 1 / dir[2];
        var tmin, tmax, tymin, tymax, tzmin, tzmax;
        if (invdirx >= 0) {
            tmin = (min[0] - origin[0]) * invdirx;
            tmax = (max[0] - origin[0]) * invdirx;
        } else {
            tmax = (min[0] - origin[0]) * invdirx;
            tmin = (max[0] - origin[0]) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (min[1] - origin[1]) * invdiry;
            tymax = (max[1] - origin[1]) * invdiry;
        } else {
            tymax = (min[1] - origin[1]) * invdiry;
            tymin = (max[1] - origin[1]) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || tmin !== tmin) tmin = tymin;
        if (tymax < tmax || tmax !== tmax) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (min[2] - origin[2]) * invdirz;
            tzmax = (max[2] - origin[2]) * invdirz;
        } else {
            tzmax = (min[2] - origin[2]) * invdirz;
            tzmin = (max[2] - origin[2]) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        if (tmax < 0) return null;
        var t = tmin >= 0 ? tmin : tmax;
        if (!out) out = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scaleAndAdd(out.array, origin, dir, t);
        return out;
    },
    // http://en.wikipedia.org/wiki/M%C3%B6ller%E2%80%93Trumbore_intersection_algorithm
    /**
     * Calculate intersection point between ray and three triangle vertices
     * @param {clay.Vector3} a
     * @param {clay.Vector3} b
     * @param {clay.Vector3} c
     * @param {boolean}           singleSided, CW triangle will be ignored
     * @param {clay.Vector3} [out]
     * @param {clay.Vector3} [barycenteric] barycentric coords
     * @return {clay.Vector3}
     */ intersectTriangle: function() {
        var eBA = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
        var eCA = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
        var AO = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
        var vCross = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
        return function(a, b, c, singleSided, out, barycenteric) {
            var dir = this.direction.array;
            var origin = this.origin.array;
            a = a.array;
            b = b.array;
            c = c.array;
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).sub(eBA, b, a);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).sub(eCA, c, a);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).cross(vCross, eCA, dir);
            var det = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(eBA, vCross);
            if (singleSided) {
                if (det > -$65a5d9098f8e83b0$var$EPSILON) return null;
            } else {
                if (det > -$65a5d9098f8e83b0$var$EPSILON && det < $65a5d9098f8e83b0$var$EPSILON) return null;
            }
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).sub(AO, origin, a);
            var u = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(vCross, AO) / det;
            if (u < 0 || u > 1) return null;
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).cross(vCross, eBA, AO);
            var v = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(dir, vCross) / det;
            if (v < 0 || v > 1 || u + v > 1) return null;
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).cross(vCross, eBA, eCA);
            var t = -(0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(AO, vCross) / det;
            if (t < 0) return null;
            if (!out) out = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
            if (barycenteric) (0, $27fea36417076c2d$export$2e2bcd8739ae039).set(barycenteric, 1 - u - v, u, v);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scaleAndAdd(out.array, origin, dir, t);
            return out;
        };
    }(),
    /**
     * Apply an affine transform matrix to the ray
     * @return {clay.Matrix4} matrix
     */ applyTransform: function(matrix) {
        (0, $27fea36417076c2d$export$2e2bcd8739ae039).add(this.direction, this.direction, this.origin);
        (0, $27fea36417076c2d$export$2e2bcd8739ae039).transformMat4(this.origin, this.origin, matrix);
        (0, $27fea36417076c2d$export$2e2bcd8739ae039).transformMat4(this.direction, this.direction, matrix);
        (0, $27fea36417076c2d$export$2e2bcd8739ae039).sub(this.direction, this.direction, this.origin);
        (0, $27fea36417076c2d$export$2e2bcd8739ae039).normalize(this.direction, this.direction);
    },
    /**
     * Copy values from another ray
     * @param {clay.Ray} ray
     */ copy: function(ray) {
        (0, $27fea36417076c2d$export$2e2bcd8739ae039).copy(this.origin, ray.origin);
        (0, $27fea36417076c2d$export$2e2bcd8739ae039).copy(this.direction, ray.direction);
    },
    /**
     * Clone a new ray
     * @return {clay.Ray}
     */ clone: function() {
        var ray = new $65a5d9098f8e83b0$var$Ray();
        ray.copy(this);
        return ray;
    }
};
var $65a5d9098f8e83b0$export$2e2bcd8739ae039 = $65a5d9098f8e83b0$var$Ray;






/* Copyright (c) 2013, Brandon Jones, Colin MacKenzie IV. All rights reserved.

Redistribution and use in source and binary forms, with or without modification,
are permitted provided that the following conditions are met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.
  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. */ 

/* Copyright (c) 2013, Brandon Jones, Colin MacKenzie IV. All rights reserved.

Redistribution and use in source and binary forms, with or without modification,
are permitted provided that the following conditions are met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.
  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. */ 
var $8f04521abcf907ba$export$6dba2a1f0d609415 = {};
/**
 * Creates a new, empty vec4
 *
 * @returns {vec4} a new 4D vector
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.create = function() {
    var out = new (0, $fe2a8a9f20126b12$export$b215cfa6c73149fa)(4);
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    return out;
};
/**
 * Creates a new vec4 initialized with values from an existing vector
 *
 * @param {vec4} a vector to clone
 * @returns {vec4} a new 4D vector
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.clone = function(a) {
    var out = new (0, $fe2a8a9f20126b12$export$b215cfa6c73149fa)(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
};
/**
 * Creates a new vec4 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {vec4} a new 4D vector
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.fromValues = function(x, y, z, w) {
    var out = new (0, $fe2a8a9f20126b12$export$b215cfa6c73149fa)(4);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
};
/**
 * Copy the values from one vec4 to another
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the source vector
 * @returns {vec4} out
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.copy = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
};
/**
 * Set the components of a vec4 to the given values
 *
 * @param {vec4} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {vec4} out
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.set = function(out, x, y, z, w) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
};
/**
 * Adds two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.add = function(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
};
/**
 * Subtracts vector b from vector a
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.subtract = function(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    return out;
};
/**
 * Alias for {@link vec4.subtract}
 * @function
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.sub = $8f04521abcf907ba$export$6dba2a1f0d609415.subtract;
/**
 * Multiplies two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.multiply = function(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    out[3] = a[3] * b[3];
    return out;
};
/**
 * Alias for {@link vec4.multiply}
 * @function
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.mul = $8f04521abcf907ba$export$6dba2a1f0d609415.multiply;
/**
 * Divides two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.divide = function(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    out[3] = a[3] / b[3];
    return out;
};
/**
 * Alias for {@link vec4.divide}
 * @function
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.div = $8f04521abcf907ba$export$6dba2a1f0d609415.divide;
/**
 * Returns the minimum of two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.min = function(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    out[3] = Math.min(a[3], b[3]);
    return out;
};
/**
 * Returns the maximum of two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.max = function(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    out[3] = Math.max(a[3], b[3]);
    return out;
};
/**
 * Scales a vec4 by a scalar number
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec4} out
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.scale = function(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
};
/**
 * Adds two vec4's after scaling the second operand by a scalar value
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec4} out
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.scaleAndAdd = function(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    return out;
};
/**
 * Calculates the euclidian distance between two vec4's
 *
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {Number} distance between a and b
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.distance = function(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1], z = b[2] - a[2], w = b[3] - a[3];
    return Math.sqrt(x * x + y * y + z * z + w * w);
};
/**
 * Alias for {@link vec4.distance}
 * @function
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.dist = $8f04521abcf907ba$export$6dba2a1f0d609415.distance;
/**
 * Calculates the squared euclidian distance between two vec4's
 *
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {Number} squared distance between a and b
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.squaredDistance = function(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1], z = b[2] - a[2], w = b[3] - a[3];
    return x * x + y * y + z * z + w * w;
};
/**
 * Alias for {@link vec4.squaredDistance}
 * @function
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.sqrDist = $8f04521abcf907ba$export$6dba2a1f0d609415.squaredDistance;
/**
 * Calculates the length of a vec4
 *
 * @param {vec4} a vector to calculate length of
 * @returns {Number} length of a
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.length = function(a) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    return Math.sqrt(x * x + y * y + z * z + w * w);
};
/**
 * Alias for {@link vec4.length}
 * @function
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.len = $8f04521abcf907ba$export$6dba2a1f0d609415.length;
/**
 * Calculates the squared length of a vec4
 *
 * @param {vec4} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.squaredLength = function(a) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    return x * x + y * y + z * z + w * w;
};
/**
 * Alias for {@link vec4.squaredLength}
 * @function
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.sqrLen = $8f04521abcf907ba$export$6dba2a1f0d609415.squaredLength;
/**
 * Negates the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to negate
 * @returns {vec4} out
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.negate = function(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = -a[3];
    return out;
};
/**
 * Returns the inverse of the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to invert
 * @returns {vec4} out
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.inverse = function(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    out[3] = 1.0 / a[3];
    return out;
};
/**
 * Normalize a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to normalize
 * @returns {vec4} out
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.normalize = function(out, a) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    var len = x * x + y * y + z * z + w * w;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        out[0] = a[0] * len;
        out[1] = a[1] * len;
        out[2] = a[2] * len;
        out[3] = a[3] * len;
    }
    return out;
};
/**
 * Calculates the dot product of two vec4's
 *
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {Number} dot product of a and b
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.dot = function(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
};
/**
 * Performs a linear interpolation between two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec4} out
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.lerp = function(out, a, b, t) {
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    out[3] = aw + t * (b[3] - aw);
    return out;
};
/**
 * Generates a random vector with the given scale
 *
 * @param {vec4} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec4} out
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.random = function(out, scale) {
    scale = scale || 1.0;
    //TODO: This is a pretty awful way of doing this. Find something better.
    out[0] = (0, $fe2a8a9f20126b12$export$45afeab892d5eb82)();
    out[1] = (0, $fe2a8a9f20126b12$export$45afeab892d5eb82)();
    out[2] = (0, $fe2a8a9f20126b12$export$45afeab892d5eb82)();
    out[3] = (0, $fe2a8a9f20126b12$export$45afeab892d5eb82)();
    $8f04521abcf907ba$export$6dba2a1f0d609415.normalize(out, out);
    $8f04521abcf907ba$export$6dba2a1f0d609415.scale(out, out, scale);
    return out;
};
/**
 * Transforms the vec4 with a mat4.
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the vector to transform
 * @param {mat4} m matrix to transform with
 * @returns {vec4} out
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.transformMat4 = function(out, a, m) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
    return out;
};
/**
 * Transforms the vec4 with a quat
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the vector to transform
 * @param {quat} q quaternion to transform with
 * @returns {vec4} out
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.transformQuat = function(out, a, q) {
    var x = a[0], y = a[1], z = a[2], qx = q[0], qy = q[1], qz = q[2], qw = q[3], // calculate quat * vec
    ix = qw * x + qy * z - qz * y, iy = qw * y + qz * x - qx * z, iz = qw * z + qx * y - qy * x, iw = -qx * x - qy * y - qz * z;
    // calculate result * inverse quat
    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    return out;
};
/**
 * Perform some operation over an array of vec4s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec4. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec4s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */ $8f04521abcf907ba$export$6dba2a1f0d609415.forEach = function() {
    var vec = $8f04521abcf907ba$export$6dba2a1f0d609415.create();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 4;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            vec[3] = a[i + 3];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
            a[i + 3] = vec[3];
        }
        return a;
    };
}();
var $8f04521abcf907ba$export$2e2bcd8739ae039 = $8f04521abcf907ba$export$6dba2a1f0d609415;


/* Copyright (c) 2013, Brandon Jones, Colin MacKenzie IV. All rights reserved.

Redistribution and use in source and binary forms, with or without modification,
are permitted provided that the following conditions are met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.
  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. */ 
/**
 * @class 3x3 Matrix
 * @name mat3
 */ var $b86a7eb89e4e1c74$var$mat3 = {};
/**
 * Creates a new identity mat3
 *
 * @returns {mat3} a new 3x3 matrix
 */ $b86a7eb89e4e1c74$var$mat3.create = function() {
    var out = new (0, $fe2a8a9f20126b12$export$b215cfa6c73149fa)(9);
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
};
/**
 * Copies the upper-left 3x3 values into the given mat3.
 *
 * @param {mat3} out the receiving 3x3 matrix
 * @param {mat4} a   the source 4x4 matrix
 * @returns {mat3} out
 */ $b86a7eb89e4e1c74$var$mat3.fromMat4 = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[4];
    out[4] = a[5];
    out[5] = a[6];
    out[6] = a[8];
    out[7] = a[9];
    out[8] = a[10];
    return out;
};
/**
 * Creates a new mat3 initialized with values from an existing matrix
 *
 * @param {mat3} a matrix to clone
 * @returns {mat3} a new 3x3 matrix
 */ $b86a7eb89e4e1c74$var$mat3.clone = function(a) {
    var out = new (0, $fe2a8a9f20126b12$export$b215cfa6c73149fa)(9);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
};
/**
 * Copy the values from one mat3 to another
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the source matrix
 * @returns {mat3} out
 */ $b86a7eb89e4e1c74$var$mat3.copy = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
};
/**
 * Set a mat3 to the identity matrix
 *
 * @param {mat3} out the receiving matrix
 * @returns {mat3} out
 */ $b86a7eb89e4e1c74$var$mat3.identity = function(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
};
/**
 * Transpose the values of a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the source matrix
 * @returns {mat3} out
 */ $b86a7eb89e4e1c74$var$mat3.transpose = function(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a12 = a[5];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a01;
        out[5] = a[7];
        out[6] = a02;
        out[7] = a12;
    } else {
        out[0] = a[0];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a[1];
        out[4] = a[4];
        out[5] = a[7];
        out[6] = a[2];
        out[7] = a[5];
        out[8] = a[8];
    }
    return out;
};
/**
 * Inverts a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the source matrix
 * @returns {mat3} out
 */ $b86a7eb89e4e1c74$var$mat3.invert = function(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], b01 = a22 * a11 - a12 * a21, b11 = -a22 * a10 + a12 * a20, b21 = a21 * a10 - a11 * a20, // Calculate the determinant
    det = a00 * b01 + a01 * b11 + a02 * b21;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = b01 * det;
    out[1] = (-a22 * a01 + a02 * a21) * det;
    out[2] = (a12 * a01 - a02 * a11) * det;
    out[3] = b11 * det;
    out[4] = (a22 * a00 - a02 * a20) * det;
    out[5] = (-a12 * a00 + a02 * a10) * det;
    out[6] = b21 * det;
    out[7] = (-a21 * a00 + a01 * a20) * det;
    out[8] = (a11 * a00 - a01 * a10) * det;
    return out;
};
/**
 * Calculates the adjugate of a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the source matrix
 * @returns {mat3} out
 */ $b86a7eb89e4e1c74$var$mat3.adjoint = function(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8];
    out[0] = a11 * a22 - a12 * a21;
    out[1] = a02 * a21 - a01 * a22;
    out[2] = a01 * a12 - a02 * a11;
    out[3] = a12 * a20 - a10 * a22;
    out[4] = a00 * a22 - a02 * a20;
    out[5] = a02 * a10 - a00 * a12;
    out[6] = a10 * a21 - a11 * a20;
    out[7] = a01 * a20 - a00 * a21;
    out[8] = a00 * a11 - a01 * a10;
    return out;
};
/**
 * Calculates the determinant of a mat3
 *
 * @param {mat3} a the source matrix
 * @returns {Number} determinant of a
 */ $b86a7eb89e4e1c74$var$mat3.determinant = function(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8];
    return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
};
/**
 * Multiplies two mat3's
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the first operand
 * @param {mat3} b the second operand
 * @returns {mat3} out
 */ $b86a7eb89e4e1c74$var$mat3.multiply = function(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], b00 = b[0], b01 = b[1], b02 = b[2], b10 = b[3], b11 = b[4], b12 = b[5], b20 = b[6], b21 = b[7], b22 = b[8];
    out[0] = b00 * a00 + b01 * a10 + b02 * a20;
    out[1] = b00 * a01 + b01 * a11 + b02 * a21;
    out[2] = b00 * a02 + b01 * a12 + b02 * a22;
    out[3] = b10 * a00 + b11 * a10 + b12 * a20;
    out[4] = b10 * a01 + b11 * a11 + b12 * a21;
    out[5] = b10 * a02 + b11 * a12 + b12 * a22;
    out[6] = b20 * a00 + b21 * a10 + b22 * a20;
    out[7] = b20 * a01 + b21 * a11 + b22 * a21;
    out[8] = b20 * a02 + b21 * a12 + b22 * a22;
    return out;
};
/**
 * Alias for {@link mat3.multiply}
 * @function
 */ $b86a7eb89e4e1c74$var$mat3.mul = $b86a7eb89e4e1c74$var$mat3.multiply;
/**
 * Translate a mat3 by the given vector
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the matrix to translate
 * @param {vec2} v vector to translate by
 * @returns {mat3} out
 */ $b86a7eb89e4e1c74$var$mat3.translate = function(out, a, v) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], x = v[0], y = v[1];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a10;
    out[4] = a11;
    out[5] = a12;
    out[6] = x * a00 + y * a10 + a20;
    out[7] = x * a01 + y * a11 + a21;
    out[8] = x * a02 + y * a12 + a22;
    return out;
};
/**
 * Rotates a mat3 by the given angle
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat3} out
 */ $b86a7eb89e4e1c74$var$mat3.rotate = function(out, a, rad) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c * a00 + s * a10;
    out[1] = c * a01 + s * a11;
    out[2] = c * a02 + s * a12;
    out[3] = c * a10 - s * a00;
    out[4] = c * a11 - s * a01;
    out[5] = c * a12 - s * a02;
    out[6] = a20;
    out[7] = a21;
    out[8] = a22;
    return out;
};
/**
 * Scales the mat3 by the dimensions in the given vec2
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the matrix to rotate
 * @param {vec2} v the vec2 to scale the matrix by
 * @returns {mat3} out
 **/ $b86a7eb89e4e1c74$var$mat3.scale = function(out, a, v) {
    var x = v[0], y = v[1];
    out[0] = x * a[0];
    out[1] = x * a[1];
    out[2] = x * a[2];
    out[3] = y * a[3];
    out[4] = y * a[4];
    out[5] = y * a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
};
/**
 * Copies the values from a mat2d into a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {mat2d} a the matrix to copy
 * @returns {mat3} out
 **/ $b86a7eb89e4e1c74$var$mat3.fromMat2d = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = 0;
    out[3] = a[2];
    out[4] = a[3];
    out[5] = 0;
    out[6] = a[4];
    out[7] = a[5];
    out[8] = 1;
    return out;
};
/**
* Calculates a 3x3 matrix from the given quaternion
*
* @param {mat3} out mat3 receiving operation result
* @param {quat} q Quaternion to create matrix from
*
* @returns {mat3} out
*/ $b86a7eb89e4e1c74$var$mat3.fromQuat = function(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3], x2 = x + x, y2 = y + y, z2 = z + z, xx = x * x2, yx = y * x2, yy = y * y2, zx = z * x2, zy = z * y2, zz = z * z2, wx = w * x2, wy = w * y2, wz = w * z2;
    out[0] = 1 - yy - zz;
    out[3] = yx - wz;
    out[6] = zx + wy;
    out[1] = yx + wz;
    out[4] = 1 - xx - zz;
    out[7] = zy - wx;
    out[2] = zx - wy;
    out[5] = zy + wx;
    out[8] = 1 - xx - yy;
    return out;
};
/**
* Calculates a 3x3 normal matrix (transpose inverse) from the 4x4 matrix
*
* @param {mat3} out mat3 receiving operation result
* @param {mat4} a Mat4 to derive the normal matrix from
*
* @returns {mat3} out
*/ $b86a7eb89e4e1c74$var$mat3.normalFromMat4 = function(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3], a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7], a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11], a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15], b00 = a00 * a11 - a01 * a10, b01 = a00 * a12 - a02 * a10, b02 = a00 * a13 - a03 * a10, b03 = a01 * a12 - a02 * a11, b04 = a01 * a13 - a03 * a11, b05 = a02 * a13 - a03 * a12, b06 = a20 * a31 - a21 * a30, b07 = a20 * a32 - a22 * a30, b08 = a20 * a33 - a23 * a30, b09 = a21 * a32 - a22 * a31, b10 = a21 * a33 - a23 * a31, b11 = a22 * a33 - a23 * a32, // Calculate the determinant
    det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    return out;
};
/**
 * Returns Frobenius norm of a mat3
 *
 * @param {mat3} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */ $b86a7eb89e4e1c74$var$mat3.frob = function(a) {
    return Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2) + Math.pow(a[4], 2) + Math.pow(a[5], 2) + Math.pow(a[6], 2) + Math.pow(a[7], 2) + Math.pow(a[8], 2));
};
var $b86a7eb89e4e1c74$export$2e2bcd8739ae039 = $b86a7eb89e4e1c74$var$mat3;


/**
 * @class Quaternion
 * @name quat
 */ var $62f7d9dfb936b2d3$var$quat = {};
/**
 * Creates a new identity quat
 *
 * @returns {quat} a new quaternion
 */ $62f7d9dfb936b2d3$var$quat.create = function() {
    var out = new (0, $fe2a8a9f20126b12$export$b215cfa6c73149fa)(4);
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
};
/**
 * Sets a quaternion to represent the shortest rotation from one
 * vector to another.
 *
 * Both vectors are assumed to be unit length.
 *
 * @param {quat} out the receiving quaternion.
 * @param {vec3} a the initial vector
 * @param {vec3} b the destination vector
 * @returns {quat} out
 */ $62f7d9dfb936b2d3$var$quat.rotationTo = function() {
    var tmpvec3 = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
    var xUnitVec3 = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).fromValues(1, 0, 0);
    var yUnitVec3 = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).fromValues(0, 1, 0);
    return function(out, a, b) {
        var dot = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(a, b);
        if (dot < -0.999999) {
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).cross(tmpvec3, xUnitVec3, a);
            if ((0, $12f7c5f576a58dba$export$2e2bcd8739ae039).length(tmpvec3) < 0.000001) (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).cross(tmpvec3, yUnitVec3, a);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).normalize(tmpvec3, tmpvec3);
            $62f7d9dfb936b2d3$var$quat.setAxisAngle(out, tmpvec3, Math.PI);
            return out;
        } else if (dot > 0.999999) {
            out[0] = 0;
            out[1] = 0;
            out[2] = 0;
            out[3] = 1;
            return out;
        } else {
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).cross(tmpvec3, a, b);
            out[0] = tmpvec3[0];
            out[1] = tmpvec3[1];
            out[2] = tmpvec3[2];
            out[3] = 1 + dot;
            return $62f7d9dfb936b2d3$var$quat.normalize(out, out);
        }
    };
}();
/**
 * Sets the specified quaternion with values corresponding to the given
 * axes. Each axis is a vec3 and is expected to be unit length and
 * perpendicular to all other specified axes.
 *
 * @param {vec3} view  the vector representing the viewing direction
 * @param {vec3} right the vector representing the local "right" direction
 * @param {vec3} up    the vector representing the local "up" direction
 * @returns {quat} out
 */ $62f7d9dfb936b2d3$var$quat.setAxes = function() {
    var matr = (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).create();
    return function(out, view, right, up) {
        matr[0] = right[0];
        matr[3] = right[1];
        matr[6] = right[2];
        matr[1] = up[0];
        matr[4] = up[1];
        matr[7] = up[2];
        matr[2] = -view[0];
        matr[5] = -view[1];
        matr[8] = -view[2];
        return $62f7d9dfb936b2d3$var$quat.normalize(out, $62f7d9dfb936b2d3$var$quat.fromMat3(out, matr));
    };
}();
/**
 * Creates a new quat initialized with values from an existing quaternion
 *
 * @param {quat} a quaternion to clone
 * @returns {quat} a new quaternion
 * @function
 */ $62f7d9dfb936b2d3$var$quat.clone = (0, $8f04521abcf907ba$export$2e2bcd8739ae039).clone;
/**
 * Creates a new quat initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {quat} a new quaternion
 * @function
 */ $62f7d9dfb936b2d3$var$quat.fromValues = (0, $8f04521abcf907ba$export$2e2bcd8739ae039).fromValues;
/**
 * Copy the values from one quat to another
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the source quaternion
 * @returns {quat} out
 * @function
 */ $62f7d9dfb936b2d3$var$quat.copy = (0, $8f04521abcf907ba$export$2e2bcd8739ae039).copy;
/**
 * Set the components of a quat to the given values
 *
 * @param {quat} out the receiving quaternion
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {quat} out
 * @function
 */ $62f7d9dfb936b2d3$var$quat.set = (0, $8f04521abcf907ba$export$2e2bcd8739ae039).set;
/**
 * Set a quat to the identity quaternion
 *
 * @param {quat} out the receiving quaternion
 * @returns {quat} out
 */ $62f7d9dfb936b2d3$var$quat.identity = function(out) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
};
/**
 * Sets a quat from the given angle and rotation axis,
 * then returns it.
 *
 * @param {quat} out the receiving quaternion
 * @param {vec3} axis the axis around which to rotate
 * @param {Number} rad the angle in radians
 * @returns {quat} out
 **/ $62f7d9dfb936b2d3$var$quat.setAxisAngle = function(out, axis, rad) {
    rad = rad * 0.5;
    var s = Math.sin(rad);
    out[0] = s * axis[0];
    out[1] = s * axis[1];
    out[2] = s * axis[2];
    out[3] = Math.cos(rad);
    return out;
};
/**
 * Adds two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @returns {quat} out
 * @function
 */ $62f7d9dfb936b2d3$var$quat.add = (0, $8f04521abcf907ba$export$2e2bcd8739ae039).add;
/**
 * Multiplies two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @returns {quat} out
 */ $62f7d9dfb936b2d3$var$quat.multiply = function(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2], aw = a[3], bx = b[0], by = b[1], bz = b[2], bw = b[3];
    out[0] = ax * bw + aw * bx + ay * bz - az * by;
    out[1] = ay * bw + aw * by + az * bx - ax * bz;
    out[2] = az * bw + aw * bz + ax * by - ay * bx;
    out[3] = aw * bw - ax * bx - ay * by - az * bz;
    return out;
};
/**
 * Alias for {@link quat.multiply}
 * @function
 */ $62f7d9dfb936b2d3$var$quat.mul = $62f7d9dfb936b2d3$var$quat.multiply;
/**
 * Scales a quat by a scalar number
 *
 * @param {quat} out the receiving vector
 * @param {quat} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {quat} out
 * @function
 */ $62f7d9dfb936b2d3$var$quat.scale = (0, $8f04521abcf907ba$export$2e2bcd8739ae039).scale;
/**
 * Rotates a quaternion by the given angle about the X axis
 *
 * @param {quat} out quat receiving operation result
 * @param {quat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */ $62f7d9dfb936b2d3$var$quat.rotateX = function(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3], bx = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + aw * bx;
    out[1] = ay * bw + az * bx;
    out[2] = az * bw - ay * bx;
    out[3] = aw * bw - ax * bx;
    return out;
};
/**
 * Rotates a quaternion by the given angle about the Y axis
 *
 * @param {quat} out quat receiving operation result
 * @param {quat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */ $62f7d9dfb936b2d3$var$quat.rotateY = function(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3], by = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw - az * by;
    out[1] = ay * bw + aw * by;
    out[2] = az * bw + ax * by;
    out[3] = aw * bw - ay * by;
    return out;
};
/**
 * Rotates a quaternion by the given angle about the Z axis
 *
 * @param {quat} out quat receiving operation result
 * @param {quat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */ $62f7d9dfb936b2d3$var$quat.rotateZ = function(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3], bz = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + ay * bz;
    out[1] = ay * bw - ax * bz;
    out[2] = az * bw + aw * bz;
    out[3] = aw * bw - az * bz;
    return out;
};
/**
 * Calculates the W component of a quat from the X, Y, and Z components.
 * Assumes that quaternion is 1 unit in length.
 * Any existing W component will be ignored.
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a quat to calculate W component of
 * @returns {quat} out
 */ $62f7d9dfb936b2d3$var$quat.calculateW = function(out, a) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = Math.sqrt(Math.abs(1.0 - x * x - y * y - z * z));
    return out;
};
/**
 * Calculates the dot product of two quat's
 *
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @returns {Number} dot product of a and b
 * @function
 */ $62f7d9dfb936b2d3$var$quat.dot = (0, $8f04521abcf907ba$export$2e2bcd8739ae039).dot;
/**
 * Performs a linear interpolation between two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {quat} out
 * @function
 */ $62f7d9dfb936b2d3$var$quat.lerp = (0, $8f04521abcf907ba$export$2e2bcd8739ae039).lerp;
/**
 * Performs a spherical linear interpolation between two quat
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {quat} out
 */ $62f7d9dfb936b2d3$var$quat.slerp = function(out, a, b, t) {
    // benchmarks:
    //    http://jsperf.com/quaternion-slerp-implementations
    var ax = a[0], ay = a[1], az = a[2], aw = a[3], bx = b[0], by = b[1], bz = b[2], bw = b[3];
    var omega, cosom, sinom, scale0, scale1;
    // calc cosine
    cosom = ax * bx + ay * by + az * bz + aw * bw;
    // adjust signs (if necessary)
    if (cosom < 0.0) {
        cosom = -cosom;
        bx = -bx;
        by = -by;
        bz = -bz;
        bw = -bw;
    }
    // calculate coefficients
    if (1.0 - cosom > 0.000001) {
        // standard case (slerp)
        omega = Math.acos(cosom);
        sinom = Math.sin(omega);
        scale0 = Math.sin((1.0 - t) * omega) / sinom;
        scale1 = Math.sin(t * omega) / sinom;
    } else {
        // "from" and "to" quaternions are very close
        //  ... so we can do a linear interpolation
        scale0 = 1.0 - t;
        scale1 = t;
    }
    // calculate final values
    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;
    return out;
};
/**
 * Calculates the inverse of a quat
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a quat to calculate inverse of
 * @returns {quat} out
 */ $62f7d9dfb936b2d3$var$quat.invert = function(out, a) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], dot = a0 * a0 + a1 * a1 + a2 * a2 + a3 * a3, invDot = dot ? 1.0 / dot : 0;
    // TODO: Would be faster to return [0,0,0,0] immediately if dot == 0
    out[0] = -a0 * invDot;
    out[1] = -a1 * invDot;
    out[2] = -a2 * invDot;
    out[3] = a3 * invDot;
    return out;
};
/**
 * Calculates the conjugate of a quat
 * If the quaternion is normalized, this function is faster than quat.inverse and produces the same result.
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a quat to calculate conjugate of
 * @returns {quat} out
 */ $62f7d9dfb936b2d3$var$quat.conjugate = function(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = a[3];
    return out;
};
/**
 * Calculates the length of a quat
 *
 * @param {quat} a vector to calculate length of
 * @returns {Number} length of a
 * @function
 */ $62f7d9dfb936b2d3$var$quat.length = (0, $8f04521abcf907ba$export$2e2bcd8739ae039).length;
/**
 * Alias for {@link quat.length}
 * @function
 */ $62f7d9dfb936b2d3$var$quat.len = $62f7d9dfb936b2d3$var$quat.length;
/**
 * Calculates the squared length of a quat
 *
 * @param {quat} a vector to calculate squared length of
 * @returns {Number} squared length of a
 * @function
 */ $62f7d9dfb936b2d3$var$quat.squaredLength = (0, $8f04521abcf907ba$export$2e2bcd8739ae039).squaredLength;
/**
 * Alias for {@link quat.squaredLength}
 * @function
 */ $62f7d9dfb936b2d3$var$quat.sqrLen = $62f7d9dfb936b2d3$var$quat.squaredLength;
/**
 * Normalize a quat
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a quaternion to normalize
 * @returns {quat} out
 * @function
 */ $62f7d9dfb936b2d3$var$quat.normalize = (0, $8f04521abcf907ba$export$2e2bcd8739ae039).normalize;
/**
 * Creates a quaternion from the given 3x3 rotation matrix.
 *
 * NOTE: The resultant quaternion is not normalized, so you should be sure
 * to renormalize the quaternion yourself where necessary.
 *
 * @param {quat} out the receiving quaternion
 * @param {mat3} m rotation matrix
 * @returns {quat} out
 * @function
 */ $62f7d9dfb936b2d3$var$quat.fromMat3 = function(out, m) {
    // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
    // article "Quaternion Calculus and Fast Animation".
    var fTrace = m[0] + m[4] + m[8];
    var fRoot;
    if (fTrace > 0.0) {
        // |w| > 1/2, may as well choose w > 1/2
        fRoot = Math.sqrt(fTrace + 1.0); // 2w
        out[3] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot; // 1/(4w)
        out[0] = (m[5] - m[7]) * fRoot;
        out[1] = (m[6] - m[2]) * fRoot;
        out[2] = (m[1] - m[3]) * fRoot;
    } else {
        // |w| <= 1/2
        var i = 0;
        if (m[4] > m[0]) i = 1;
        if (m[8] > m[i * 3 + i]) i = 2;
        var j = (i + 1) % 3;
        var k = (i + 2) % 3;
        fRoot = Math.sqrt(m[i * 3 + i] - m[j * 3 + j] - m[k * 3 + k] + 1.0);
        out[i] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot;
        out[3] = (m[j * 3 + k] - m[k * 3 + j]) * fRoot;
        out[j] = (m[j * 3 + i] + m[i * 3 + j]) * fRoot;
        out[k] = (m[k * 3 + i] + m[i * 3 + k]) * fRoot;
    }
    return out;
};
var $62f7d9dfb936b2d3$export$2e2bcd8739ae039 = $62f7d9dfb936b2d3$var$quat;




/**
 * @constructor
 * @alias clay.Matrix4
 */ var $1d03d709cdb0fa6c$var$Matrix4 = function() {
    this._axisX = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
    this._axisY = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
    this._axisZ = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
    /**
     * Storage of Matrix4
     * @name array
     * @type {Float32Array}
     * @memberOf clay.Matrix4#
     */ this.array = (0, $0020ce97b75275ae$export$2e2bcd8739ae039).create();
    /**
     * @name _dirty
     * @type {boolean}
     * @memberOf clay.Matrix4#
     */ this._dirty = true;
};
$1d03d709cdb0fa6c$var$Matrix4.prototype = {
    constructor: $1d03d709cdb0fa6c$var$Matrix4,
    /**
     * Set components from array
     * @param  {Float32Array|number[]} arr
     */ setArray: function(arr) {
        for(var i = 0; i < this.array.length; i++)this.array[i] = arr[i];
        this._dirty = true;
        return this;
    },
    /**
     * Calculate the adjugate of self, in-place
     * @return {clay.Matrix4}
     */ adjoint: function() {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).adjoint(this.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Clone a new Matrix4
     * @return {clay.Matrix4}
     */ clone: function() {
        return new $1d03d709cdb0fa6c$var$Matrix4().copy(this);
    },
    /**
     * Copy from b
     * @param  {clay.Matrix4} b
     * @return {clay.Matrix4}
     */ copy: function(a) {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).copy(this.array, a.array);
        this._dirty = true;
        return this;
    },
    /**
     * Calculate matrix determinant
     * @return {number}
     */ determinant: function() {
        return (0, $0020ce97b75275ae$export$2e2bcd8739ae039).determinant(this.array);
    },
    /**
     * Set upper 3x3 part from quaternion
     * @param  {clay.Quaternion} q
     * @return {clay.Matrix4}
     */ fromQuat: function(q) {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).fromQuat(this.array, q.array);
        this._dirty = true;
        return this;
    },
    /**
     * Set from a quaternion rotation and a vector translation
     * @param  {clay.Quaternion} q
     * @param  {clay.Vector3} v
     * @return {clay.Matrix4}
     */ fromRotationTranslation: function(q, v) {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).fromRotationTranslation(this.array, q.array, v.array);
        this._dirty = true;
        return this;
    },
    /**
     * Set from Matrix2d, it is used when converting a 2d shape to 3d space.
     * In 3d space it is equivalent to ranslate on xy plane and rotate about z axis
     * @param  {clay.Matrix2d} m2d
     * @return {clay.Matrix4}
     */ fromMat2d: function(m2d) {
        $1d03d709cdb0fa6c$var$Matrix4.fromMat2d(this, m2d);
        return this;
    },
    /**
     * Set from frustum bounds
     * @param  {number} left
     * @param  {number} right
     * @param  {number} bottom
     * @param  {number} top
     * @param  {number} near
     * @param  {number} far
     * @return {clay.Matrix4}
     */ frustum: function(left, right, bottom, top, near, far) {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).frustum(this.array, left, right, bottom, top, near, far);
        this._dirty = true;
        return this;
    },
    /**
     * Set to a identity matrix
     * @return {clay.Matrix4}
     */ identity: function() {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).identity(this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Invert self
     * @return {clay.Matrix4}
     */ invert: function() {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).invert(this.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Set as a matrix with the given eye position, focal point, and up axis
     * @param  {clay.Vector3} eye
     * @param  {clay.Vector3} center
     * @param  {clay.Vector3} up
     * @return {clay.Matrix4}
     */ lookAt: function(eye, center, up) {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).lookAt(this.array, eye.array, center.array, up.array);
        this._dirty = true;
        return this;
    },
    /**
     * Alias for mutiply
     * @param  {clay.Matrix4} b
     * @return {clay.Matrix4}
     */ mul: function(b) {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).mul(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Alias for multiplyLeft
     * @param  {clay.Matrix4} a
     * @return {clay.Matrix4}
     */ mulLeft: function(a) {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).mul(this.array, a.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Multiply self and b
     * @param  {clay.Matrix4} b
     * @return {clay.Matrix4}
     */ multiply: function(b) {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).multiply(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Multiply a and self, a is on the left
     * @param  {clay.Matrix3} a
     * @return {clay.Matrix3}
     */ multiplyLeft: function(a) {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).multiply(this.array, a.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Set as a orthographic projection matrix
     * @param  {number} left
     * @param  {number} right
     * @param  {number} bottom
     * @param  {number} top
     * @param  {number} near
     * @param  {number} far
     * @return {clay.Matrix4}
     */ ortho: function(left, right, bottom, top, near, far) {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).ortho(this.array, left, right, bottom, top, near, far);
        this._dirty = true;
        return this;
    },
    /**
     * Set as a perspective projection matrix
     * @param  {number} fovy
     * @param  {number} aspect
     * @param  {number} near
     * @param  {number} far
     * @return {clay.Matrix4}
     */ perspective: function(fovy, aspect, near, far) {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).perspective(this.array, fovy, aspect, near, far);
        this._dirty = true;
        return this;
    },
    /**
     * Rotate self by rad about axis.
     * Equal to right-multiply a rotaion matrix
     * @param  {number}   rad
     * @param  {clay.Vector3} axis
     * @return {clay.Matrix4}
     */ rotate: function(rad, axis) {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).rotate(this.array, this.array, rad, axis.array);
        this._dirty = true;
        return this;
    },
    /**
     * Rotate self by a given radian about X axis.
     * Equal to right-multiply a rotaion matrix
     * @param {number} rad
     * @return {clay.Matrix4}
     */ rotateX: function(rad) {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).rotateX(this.array, this.array, rad);
        this._dirty = true;
        return this;
    },
    /**
     * Rotate self by a given radian about Y axis.
     * Equal to right-multiply a rotaion matrix
     * @param {number} rad
     * @return {clay.Matrix4}
     */ rotateY: function(rad) {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).rotateY(this.array, this.array, rad);
        this._dirty = true;
        return this;
    },
    /**
     * Rotate self by a given radian about Z axis.
     * Equal to right-multiply a rotaion matrix
     * @param {number} rad
     * @return {clay.Matrix4}
     */ rotateZ: function(rad) {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).rotateZ(this.array, this.array, rad);
        this._dirty = true;
        return this;
    },
    /**
     * Scale self by s
     * Equal to right-multiply a scale matrix
     * @param  {clay.Vector3}  s
     * @return {clay.Matrix4}
     */ scale: function(v) {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).scale(this.array, this.array, v.array);
        this._dirty = true;
        return this;
    },
    /**
     * Translate self by v.
     * Equal to right-multiply a translate matrix
     * @param  {clay.Vector3}  v
     * @return {clay.Matrix4}
     */ translate: function(v) {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).translate(this.array, this.array, v.array);
        this._dirty = true;
        return this;
    },
    /**
     * Transpose self, in-place.
     * @return {clay.Matrix2}
     */ transpose: function() {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).transpose(this.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Decompose a matrix to SRT
     * @param {clay.Vector3} [scale]
     * @param {clay.Quaternion} rotation
     * @param {clay.Vector} position
     * @see http://msdn.microsoft.com/en-us/library/microsoft.xna.framework.matrix.decompose.aspx
     */ decomposeMatrix: function() {
        var x = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
        var y = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
        var z = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
        var m3 = (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).create();
        return function(scale, rotation, position) {
            var el = this.array;
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).set(x, el[0], el[1], el[2]);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).set(y, el[4], el[5], el[6]);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).set(z, el[8], el[9], el[10]);
            var sx = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).length(x);
            var sy = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).length(y);
            var sz = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).length(z);
            // if determine is negative, we need to invert one scale
            var det = this.determinant();
            if (det < 0) sx = -sx;
            if (scale) scale.set(sx, sy, sz);
            position.set(el[12], el[13], el[14]);
            (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).fromMat4(m3, el);
            // Not like mat4, mat3 in glmatrix seems to be row-based
            // Seems fixed in gl-matrix 2.2.2
            // https://github.com/toji/gl-matrix/issues/114
            // mat3.transpose(m3, m3);
            m3[0] /= sx;
            m3[1] /= sx;
            m3[2] /= sx;
            m3[3] /= sy;
            m3[4] /= sy;
            m3[5] /= sy;
            m3[6] /= sz;
            m3[7] /= sz;
            m3[8] /= sz;
            (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).fromMat3(rotation.array, m3);
            (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).normalize(rotation.array, rotation.array);
            rotation._dirty = true;
            position._dirty = true;
        };
    }(),
    toString: function() {
        return "[" + Array.prototype.join.call(this.array, ",") + "]";
    },
    toArray: function() {
        return Array.prototype.slice.call(this.array);
    }
};
var $1d03d709cdb0fa6c$var$defineProperty = Object.defineProperty;
if ($1d03d709cdb0fa6c$var$defineProperty) {
    var $1d03d709cdb0fa6c$var$proto = $1d03d709cdb0fa6c$var$Matrix4.prototype;
    /**
     * Z Axis of local transform
     * @name z
     * @type {clay.Vector3}
     * @memberOf clay.Matrix4
     * @instance
     */ $1d03d709cdb0fa6c$var$defineProperty($1d03d709cdb0fa6c$var$proto, "z", {
        get: function() {
            var el = this.array;
            this._axisZ.set(el[8], el[9], el[10]);
            return this._axisZ;
        },
        set: function(v) {
            // TODO Here has a problem
            // If only set an item of vector will not work
            var el = this.array;
            v = v.array;
            el[8] = v[0];
            el[9] = v[1];
            el[10] = v[2];
            this._dirty = true;
        }
    });
    /**
     * Y Axis of local transform
     * @name y
     * @type {clay.Vector3}
     * @memberOf clay.Matrix4
     * @instance
     */ $1d03d709cdb0fa6c$var$defineProperty($1d03d709cdb0fa6c$var$proto, "y", {
        get: function() {
            var el = this.array;
            this._axisY.set(el[4], el[5], el[6]);
            return this._axisY;
        },
        set: function(v) {
            var el = this.array;
            v = v.array;
            el[4] = v[0];
            el[5] = v[1];
            el[6] = v[2];
            this._dirty = true;
        }
    });
    /**
     * X Axis of local transform
     * @name x
     * @type {clay.Vector3}
     * @memberOf clay.Matrix4
     * @instance
     */ $1d03d709cdb0fa6c$var$defineProperty($1d03d709cdb0fa6c$var$proto, "x", {
        get: function() {
            var el = this.array;
            this._axisX.set(el[0], el[1], el[2]);
            return this._axisX;
        },
        set: function(v) {
            var el = this.array;
            v = v.array;
            el[0] = v[0];
            el[1] = v[1];
            el[2] = v[2];
            this._dirty = true;
        }
    });
}
/**
 * @param  {clay.Matrix4} out
 * @param  {clay.Matrix4} a
 * @return {clay.Matrix4}
 */ $1d03d709cdb0fa6c$var$Matrix4.adjoint = function(out, a) {
    (0, $0020ce97b75275ae$export$2e2bcd8739ae039).adjoint(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix4} out
 * @param  {clay.Matrix4} a
 * @return {clay.Matrix4}
 */ $1d03d709cdb0fa6c$var$Matrix4.copy = function(out, a) {
    (0, $0020ce97b75275ae$export$2e2bcd8739ae039).copy(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix4} a
 * @return {number}
 */ $1d03d709cdb0fa6c$var$Matrix4.determinant = function(a) {
    return (0, $0020ce97b75275ae$export$2e2bcd8739ae039).determinant(a.array);
};
/**
 * @param  {clay.Matrix4} out
 * @return {clay.Matrix4}
 */ $1d03d709cdb0fa6c$var$Matrix4.identity = function(out) {
    (0, $0020ce97b75275ae$export$2e2bcd8739ae039).identity(out.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix4} out
 * @param  {number}  left
 * @param  {number}  right
 * @param  {number}  bottom
 * @param  {number}  top
 * @param  {number}  near
 * @param  {number}  far
 * @return {clay.Matrix4}
 */ $1d03d709cdb0fa6c$var$Matrix4.ortho = function(out, left, right, bottom, top, near, far) {
    (0, $0020ce97b75275ae$export$2e2bcd8739ae039).ortho(out.array, left, right, bottom, top, near, far);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix4} out
 * @param  {number}  fovy
 * @param  {number}  aspect
 * @param  {number}  near
 * @param  {number}  far
 * @return {clay.Matrix4}
 */ $1d03d709cdb0fa6c$var$Matrix4.perspective = function(out, fovy, aspect, near, far) {
    (0, $0020ce97b75275ae$export$2e2bcd8739ae039).perspective(out.array, fovy, aspect, near, far);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix4} out
 * @param  {clay.Vector3} eye
 * @param  {clay.Vector3} center
 * @param  {clay.Vector3} up
 * @return {clay.Matrix4}
 */ $1d03d709cdb0fa6c$var$Matrix4.lookAt = function(out, eye, center, up) {
    (0, $0020ce97b75275ae$export$2e2bcd8739ae039).lookAt(out.array, eye.array, center.array, up.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix4} out
 * @param  {clay.Matrix4} a
 * @return {clay.Matrix4}
 */ $1d03d709cdb0fa6c$var$Matrix4.invert = function(out, a) {
    (0, $0020ce97b75275ae$export$2e2bcd8739ae039).invert(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix4} out
 * @param  {clay.Matrix4} a
 * @param  {clay.Matrix4} b
 * @return {clay.Matrix4}
 */ $1d03d709cdb0fa6c$var$Matrix4.mul = function(out, a, b) {
    (0, $0020ce97b75275ae$export$2e2bcd8739ae039).mul(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @function
 * @param  {clay.Matrix4} out
 * @param  {clay.Matrix4} a
 * @param  {clay.Matrix4} b
 * @return {clay.Matrix4}
 */ $1d03d709cdb0fa6c$var$Matrix4.multiply = $1d03d709cdb0fa6c$var$Matrix4.mul;
/**
 * @param  {clay.Matrix4}    out
 * @param  {clay.Quaternion} q
 * @return {clay.Matrix4}
 */ $1d03d709cdb0fa6c$var$Matrix4.fromQuat = function(out, q) {
    (0, $0020ce97b75275ae$export$2e2bcd8739ae039).fromQuat(out.array, q.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix4}    out
 * @param  {clay.Quaternion} q
 * @param  {clay.Vector3}    v
 * @return {clay.Matrix4}
 */ $1d03d709cdb0fa6c$var$Matrix4.fromRotationTranslation = function(out, q, v) {
    (0, $0020ce97b75275ae$export$2e2bcd8739ae039).fromRotationTranslation(out.array, q.array, v.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix4} m4
 * @param  {clay.Matrix2d} m2d
 * @return {clay.Matrix4}
 */ $1d03d709cdb0fa6c$var$Matrix4.fromMat2d = function(m4, m2d) {
    m4._dirty = true;
    var m2d = m2d.array;
    var m4 = m4.array;
    m4[0] = m2d[0];
    m4[4] = m2d[2];
    m4[12] = m2d[4];
    m4[1] = m2d[1];
    m4[5] = m2d[3];
    m4[13] = m2d[5];
    return m4;
};
/**
 * @param  {clay.Matrix4} out
 * @param  {clay.Matrix4} a
 * @param  {number}  rad
 * @param  {clay.Vector3} axis
 * @return {clay.Matrix4}
 */ $1d03d709cdb0fa6c$var$Matrix4.rotate = function(out, a, rad, axis) {
    (0, $0020ce97b75275ae$export$2e2bcd8739ae039).rotate(out.array, a.array, rad, axis.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix4} out
 * @param  {clay.Matrix4} a
 * @param  {number}  rad
 * @return {clay.Matrix4}
 */ $1d03d709cdb0fa6c$var$Matrix4.rotateX = function(out, a, rad) {
    (0, $0020ce97b75275ae$export$2e2bcd8739ae039).rotateX(out.array, a.array, rad);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix4} out
 * @param  {clay.Matrix4} a
 * @param  {number}  rad
 * @return {clay.Matrix4}
 */ $1d03d709cdb0fa6c$var$Matrix4.rotateY = function(out, a, rad) {
    (0, $0020ce97b75275ae$export$2e2bcd8739ae039).rotateY(out.array, a.array, rad);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix4} out
 * @param  {clay.Matrix4} a
 * @param  {number}  rad
 * @return {clay.Matrix4}
 */ $1d03d709cdb0fa6c$var$Matrix4.rotateZ = function(out, a, rad) {
    (0, $0020ce97b75275ae$export$2e2bcd8739ae039).rotateZ(out.array, a.array, rad);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix4} out
 * @param  {clay.Matrix4} a
 * @param  {clay.Vector3} v
 * @return {clay.Matrix4}
 */ $1d03d709cdb0fa6c$var$Matrix4.scale = function(out, a, v) {
    (0, $0020ce97b75275ae$export$2e2bcd8739ae039).scale(out.array, a.array, v.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix4} out
 * @param  {clay.Matrix4} a
 * @return {clay.Matrix4}
 */ $1d03d709cdb0fa6c$var$Matrix4.transpose = function(out, a) {
    (0, $0020ce97b75275ae$export$2e2bcd8739ae039).transpose(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix4} out
 * @param  {clay.Matrix4} a
 * @param  {clay.Vector3} v
 * @return {clay.Matrix4}
 */ $1d03d709cdb0fa6c$var$Matrix4.translate = function(out, a, v) {
    (0, $0020ce97b75275ae$export$2e2bcd8739ae039).translate(out.array, a.array, v.array);
    out._dirty = true;
    return out;
};
var $1d03d709cdb0fa6c$export$2e2bcd8739ae039 = $1d03d709cdb0fa6c$var$Matrix4;






/**
 * @constructor
 * @alias clay.Quaternion
 * @param {number} x
 * @param {number} y
 * @param {number} z
 * @param {number} w
 */ var $0fd61056af77925d$var$Quaternion = function(x, y, z, w) {
    x = x || 0;
    y = y || 0;
    z = z || 0;
    w = w === undefined ? 1 : w;
    /**
     * Storage of Quaternion, read and write of x, y, z, w will change the values in array
     * All methods also operate on the array instead of x, y, z, w components
     * @name array
     * @type {Float32Array}
     * @memberOf clay.Quaternion#
     */ this.array = (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).fromValues(x, y, z, w);
    /**
     * Dirty flag is used by the Node to determine
     * if the matrix is updated to latest
     * @name _dirty
     * @type {boolean}
     * @memberOf clay.Quaternion#
     */ this._dirty = true;
};
$0fd61056af77925d$var$Quaternion.prototype = {
    constructor: $0fd61056af77925d$var$Quaternion,
    /**
     * Add b to self
     * @param  {clay.Quaternion} b
     * @return {clay.Quaternion}
     */ add: function(b) {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).add(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Calculate the w component from x, y, z component
     * @return {clay.Quaternion}
     */ calculateW: function() {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).calculateW(this.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Set x, y and z components
     * @param  {number}  x
     * @param  {number}  y
     * @param  {number}  z
     * @param  {number}  w
     * @return {clay.Quaternion}
     */ set: function(x, y, z, w) {
        this.array[0] = x;
        this.array[1] = y;
        this.array[2] = z;
        this.array[3] = w;
        this._dirty = true;
        return this;
    },
    /**
     * Set x, y, z and w components from array
     * @param  {Float32Array|number[]} arr
     * @return {clay.Quaternion}
     */ setArray: function(arr) {
        this.array[0] = arr[0];
        this.array[1] = arr[1];
        this.array[2] = arr[2];
        this.array[3] = arr[3];
        this._dirty = true;
        return this;
    },
    /**
     * Clone a new Quaternion
     * @return {clay.Quaternion}
     */ clone: function() {
        return new $0fd61056af77925d$var$Quaternion(this.x, this.y, this.z, this.w);
    },
    /**
     * Calculates the conjugate of self If the quaternion is normalized,
     * this function is faster than invert and produces the same result.
     *
     * @return {clay.Quaternion}
     */ conjugate: function() {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).conjugate(this.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Copy from b
     * @param  {clay.Quaternion} b
     * @return {clay.Quaternion}
     */ copy: function(b) {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).copy(this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Dot product of self and b
     * @param  {clay.Quaternion} b
     * @return {number}
     */ dot: function(b) {
        return (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).dot(this.array, b.array);
    },
    /**
     * Set from the given 3x3 rotation matrix
     * @param  {clay.Matrix3} m
     * @return {clay.Quaternion}
     */ fromMat3: function(m) {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).fromMat3(this.array, m.array);
        this._dirty = true;
        return this;
    },
    /**
     * Set from the given 4x4 rotation matrix
     * The 4th column and 4th row will be droped
     * @param  {clay.Matrix4} m
     * @return {clay.Quaternion}
     */ fromMat4: function() {
        var m3 = (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).create();
        return function(m) {
            (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).fromMat4(m3, m.array);
            // TODO Not like mat4, mat3 in glmatrix seems to be row-based
            (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).transpose(m3, m3);
            (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).fromMat3(this.array, m3);
            this._dirty = true;
            return this;
        };
    }(),
    /**
     * Set to identity quaternion
     * @return {clay.Quaternion}
     */ identity: function() {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).identity(this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Invert self
     * @return {clay.Quaternion}
     */ invert: function() {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).invert(this.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Alias of length
     * @return {number}
     */ len: function() {
        return (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).len(this.array);
    },
    /**
     * Calculate the length
     * @return {number}
     */ length: function() {
        return (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).length(this.array);
    },
    /**
     * Linear interpolation between a and b
     * @param  {clay.Quaternion} a
     * @param  {clay.Quaternion} b
     * @param  {number}  t
     * @return {clay.Quaternion}
     */ lerp: function(a, b, t) {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).lerp(this.array, a.array, b.array, t);
        this._dirty = true;
        return this;
    },
    /**
     * Alias for multiply
     * @param  {clay.Quaternion} b
     * @return {clay.Quaternion}
     */ mul: function(b) {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).mul(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Alias for multiplyLeft
     * @param  {clay.Quaternion} a
     * @return {clay.Quaternion}
     */ mulLeft: function(a) {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).multiply(this.array, a.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Mutiply self and b
     * @param  {clay.Quaternion} b
     * @return {clay.Quaternion}
     */ multiply: function(b) {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).multiply(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Mutiply a and self
     * Quaternion mutiply is not commutative, so the result of mutiplyLeft is different with multiply.
     * @param  {clay.Quaternion} a
     * @return {clay.Quaternion}
     */ multiplyLeft: function(a) {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).multiply(this.array, a.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Normalize self
     * @return {clay.Quaternion}
     */ normalize: function() {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).normalize(this.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Rotate self by a given radian about X axis
     * @param {number} rad
     * @return {clay.Quaternion}
     */ rotateX: function(rad) {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).rotateX(this.array, this.array, rad);
        this._dirty = true;
        return this;
    },
    /**
     * Rotate self by a given radian about Y axis
     * @param {number} rad
     * @return {clay.Quaternion}
     */ rotateY: function(rad) {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).rotateY(this.array, this.array, rad);
        this._dirty = true;
        return this;
    },
    /**
     * Rotate self by a given radian about Z axis
     * @param {number} rad
     * @return {clay.Quaternion}
     */ rotateZ: function(rad) {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).rotateZ(this.array, this.array, rad);
        this._dirty = true;
        return this;
    },
    /**
     * Sets self to represent the shortest rotation from Vector3 a to Vector3 b.
     * a and b needs to be normalized
     * @param  {clay.Vector3} a
     * @param  {clay.Vector3} b
     * @return {clay.Quaternion}
     */ rotationTo: function(a, b) {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).rotationTo(this.array, a.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Sets self with values corresponding to the given axes
     * @param {clay.Vector3} view
     * @param {clay.Vector3} right
     * @param {clay.Vector3} up
     * @return {clay.Quaternion}
     */ setAxes: function(view, right, up) {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).setAxes(this.array, view.array, right.array, up.array);
        this._dirty = true;
        return this;
    },
    /**
     * Sets self with a rotation axis and rotation angle
     * @param {clay.Vector3} axis
     * @param {number} rad
     * @return {clay.Quaternion}
     */ setAxisAngle: function(axis, rad) {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).setAxisAngle(this.array, axis.array, rad);
        this._dirty = true;
        return this;
    },
    /**
     * Perform spherical linear interpolation between a and b
     * @param  {clay.Quaternion} a
     * @param  {clay.Quaternion} b
     * @param  {number} t
     * @return {clay.Quaternion}
     */ slerp: function(a, b, t) {
        (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).slerp(this.array, a.array, b.array, t);
        this._dirty = true;
        return this;
    },
    /**
     * Alias for squaredLength
     * @return {number}
     */ sqrLen: function() {
        return (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).sqrLen(this.array);
    },
    /**
     * Squared length of self
     * @return {number}
     */ squaredLength: function() {
        return (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).squaredLength(this.array);
    },
    /**
     * Set from euler
     * @param {clay.Vector3} v
     * @param {String} order
     */ fromEuler: function(v, order) {
        return $0fd61056af77925d$var$Quaternion.fromEuler(this, v, order);
    },
    toString: function() {
        return "[" + Array.prototype.join.call(this.array, ",") + "]";
    },
    toArray: function() {
        return Array.prototype.slice.call(this.array);
    }
};
var $0fd61056af77925d$var$defineProperty = Object.defineProperty;
// Getter and Setter
if ($0fd61056af77925d$var$defineProperty) {
    var $0fd61056af77925d$var$proto = $0fd61056af77925d$var$Quaternion.prototype;
    /**
     * @name x
     * @type {number}
     * @memberOf clay.Quaternion
     * @instance
     */ $0fd61056af77925d$var$defineProperty($0fd61056af77925d$var$proto, "x", {
        get: function() {
            return this.array[0];
        },
        set: function(value) {
            this.array[0] = value;
            this._dirty = true;
        }
    });
    /**
     * @name y
     * @type {number}
     * @memberOf clay.Quaternion
     * @instance
     */ $0fd61056af77925d$var$defineProperty($0fd61056af77925d$var$proto, "y", {
        get: function() {
            return this.array[1];
        },
        set: function(value) {
            this.array[1] = value;
            this._dirty = true;
        }
    });
    /**
     * @name z
     * @type {number}
     * @memberOf clay.Quaternion
     * @instance
     */ $0fd61056af77925d$var$defineProperty($0fd61056af77925d$var$proto, "z", {
        get: function() {
            return this.array[2];
        },
        set: function(value) {
            this.array[2] = value;
            this._dirty = true;
        }
    });
    /**
     * @name w
     * @type {number}
     * @memberOf clay.Quaternion
     * @instance
     */ $0fd61056af77925d$var$defineProperty($0fd61056af77925d$var$proto, "w", {
        get: function() {
            return this.array[3];
        },
        set: function(value) {
            this.array[3] = value;
            this._dirty = true;
        }
    });
}
// Supply methods that are not in place
/**
 * @param  {clay.Quaternion} out
 * @param  {clay.Quaternion} a
 * @param  {clay.Quaternion} b
 * @return {clay.Quaternion}
 */ $0fd61056af77925d$var$Quaternion.add = function(out, a, b) {
    (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).add(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Quaternion} out
 * @param  {number}     x
 * @param  {number}     y
 * @param  {number}     z
 * @param  {number}     w
 * @return {clay.Quaternion}
 */ $0fd61056af77925d$var$Quaternion.set = function(out, x, y, z, w) {
    (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).set(out.array, x, y, z, w);
    out._dirty = true;
};
/**
 * @param  {clay.Quaternion} out
 * @param  {clay.Quaternion} b
 * @return {clay.Quaternion}
 */ $0fd61056af77925d$var$Quaternion.copy = function(out, b) {
    (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).copy(out.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Quaternion} out
 * @param  {clay.Quaternion} a
 * @return {clay.Quaternion}
 */ $0fd61056af77925d$var$Quaternion.calculateW = function(out, a) {
    (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).calculateW(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Quaternion} out
 * @param  {clay.Quaternion} a
 * @return {clay.Quaternion}
 */ $0fd61056af77925d$var$Quaternion.conjugate = function(out, a) {
    (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).conjugate(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Quaternion} out
 * @return {clay.Quaternion}
 */ $0fd61056af77925d$var$Quaternion.identity = function(out) {
    (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).identity(out.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Quaternion} out
 * @param  {clay.Quaternion} a
 * @return {clay.Quaternion}
 */ $0fd61056af77925d$var$Quaternion.invert = function(out, a) {
    (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).invert(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Quaternion} a
 * @param  {clay.Quaternion} b
 * @return {number}
 */ $0fd61056af77925d$var$Quaternion.dot = function(a, b) {
    return (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).dot(a.array, b.array);
};
/**
 * @param  {clay.Quaternion} a
 * @return {number}
 */ $0fd61056af77925d$var$Quaternion.len = function(a) {
    return (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).length(a.array);
};
// Quaternion.length = Quaternion.len;
/**
 * @param  {clay.Quaternion} out
 * @param  {clay.Quaternion} a
 * @param  {clay.Quaternion} b
 * @param  {number}     t
 * @return {clay.Quaternion}
 */ $0fd61056af77925d$var$Quaternion.lerp = function(out, a, b, t) {
    (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).lerp(out.array, a.array, b.array, t);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Quaternion} out
 * @param  {clay.Quaternion} a
 * @param  {clay.Quaternion} b
 * @param  {number}     t
 * @return {clay.Quaternion}
 */ $0fd61056af77925d$var$Quaternion.slerp = function(out, a, b, t) {
    (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).slerp(out.array, a.array, b.array, t);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Quaternion} out
 * @param  {clay.Quaternion} a
 * @param  {clay.Quaternion} b
 * @return {clay.Quaternion}
 */ $0fd61056af77925d$var$Quaternion.mul = function(out, a, b) {
    (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).multiply(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @function
 * @param  {clay.Quaternion} out
 * @param  {clay.Quaternion} a
 * @param  {clay.Quaternion} b
 * @return {clay.Quaternion}
 */ $0fd61056af77925d$var$Quaternion.multiply = $0fd61056af77925d$var$Quaternion.mul;
/**
 * @param  {clay.Quaternion} out
 * @param  {clay.Quaternion} a
 * @param  {number}     rad
 * @return {clay.Quaternion}
 */ $0fd61056af77925d$var$Quaternion.rotateX = function(out, a, rad) {
    (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).rotateX(out.array, a.array, rad);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Quaternion} out
 * @param  {clay.Quaternion} a
 * @param  {number}     rad
 * @return {clay.Quaternion}
 */ $0fd61056af77925d$var$Quaternion.rotateY = function(out, a, rad) {
    (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).rotateY(out.array, a.array, rad);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Quaternion} out
 * @param  {clay.Quaternion} a
 * @param  {number}     rad
 * @return {clay.Quaternion}
 */ $0fd61056af77925d$var$Quaternion.rotateZ = function(out, a, rad) {
    (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).rotateZ(out.array, a.array, rad);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Quaternion} out
 * @param  {clay.Vector3}    axis
 * @param  {number}     rad
 * @return {clay.Quaternion}
 */ $0fd61056af77925d$var$Quaternion.setAxisAngle = function(out, axis, rad) {
    (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).setAxisAngle(out.array, axis.array, rad);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Quaternion} out
 * @param  {clay.Quaternion} a
 * @return {clay.Quaternion}
 */ $0fd61056af77925d$var$Quaternion.normalize = function(out, a) {
    (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).normalize(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Quaternion} a
 * @return {number}
 */ $0fd61056af77925d$var$Quaternion.sqrLen = function(a) {
    return (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).sqrLen(a.array);
};
/**
 * @function
 * @param  {clay.Quaternion} a
 * @return {number}
 */ $0fd61056af77925d$var$Quaternion.squaredLength = $0fd61056af77925d$var$Quaternion.sqrLen;
/**
 * @param  {clay.Quaternion} out
 * @param  {clay.Matrix3}    m
 * @return {clay.Quaternion}
 */ $0fd61056af77925d$var$Quaternion.fromMat3 = function(out, m) {
    (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).fromMat3(out.array, m.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Quaternion} out
 * @param  {clay.Vector3}    view
 * @param  {clay.Vector3}    right
 * @param  {clay.Vector3}    up
 * @return {clay.Quaternion}
 */ $0fd61056af77925d$var$Quaternion.setAxes = function(out, view, right, up) {
    (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).setAxes(out.array, view.array, right.array, up.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Quaternion} out
 * @param  {clay.Vector3}    a
 * @param  {clay.Vector3}    b
 * @return {clay.Quaternion}
 */ $0fd61056af77925d$var$Quaternion.rotationTo = function(out, a, b) {
    (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039).rotationTo(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * Set quaternion from euler
 * @param {clay.Quaternion} out
 * @param {clay.Vector3} v
 * @param {String} order
 */ $0fd61056af77925d$var$Quaternion.fromEuler = function(out, v, order) {
    out._dirty = true;
    v = v.array;
    var target = out.array;
    var c1 = Math.cos(v[0] / 2);
    var c2 = Math.cos(v[1] / 2);
    var c3 = Math.cos(v[2] / 2);
    var s1 = Math.sin(v[0] / 2);
    var s2 = Math.sin(v[1] / 2);
    var s3 = Math.sin(v[2] / 2);
    var order = (order || "XYZ").toUpperCase();
    // http://www.mathworks.com/matlabcentral/fileexchange/
    //  20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
    //  content/SpinCalc.m
    switch(order){
        case "XYZ":
            target[0] = s1 * c2 * c3 + c1 * s2 * s3;
            target[1] = c1 * s2 * c3 - s1 * c2 * s3;
            target[2] = c1 * c2 * s3 + s1 * s2 * c3;
            target[3] = c1 * c2 * c3 - s1 * s2 * s3;
            break;
        case "YXZ":
            target[0] = s1 * c2 * c3 + c1 * s2 * s3;
            target[1] = c1 * s2 * c3 - s1 * c2 * s3;
            target[2] = c1 * c2 * s3 - s1 * s2 * c3;
            target[3] = c1 * c2 * c3 + s1 * s2 * s3;
            break;
        case "ZXY":
            target[0] = s1 * c2 * c3 - c1 * s2 * s3;
            target[1] = c1 * s2 * c3 + s1 * c2 * s3;
            target[2] = c1 * c2 * s3 + s1 * s2 * c3;
            target[3] = c1 * c2 * c3 - s1 * s2 * s3;
            break;
        case "ZYX":
            target[0] = s1 * c2 * c3 - c1 * s2 * s3;
            target[1] = c1 * s2 * c3 + s1 * c2 * s3;
            target[2] = c1 * c2 * s3 - s1 * s2 * c3;
            target[3] = c1 * c2 * c3 + s1 * s2 * s3;
            break;
        case "YZX":
            target[0] = s1 * c2 * c3 + c1 * s2 * s3;
            target[1] = c1 * s2 * c3 + s1 * c2 * s3;
            target[2] = c1 * c2 * s3 - s1 * s2 * c3;
            target[3] = c1 * c2 * c3 - s1 * s2 * s3;
            break;
        case "XZY":
            target[0] = s1 * c2 * c3 - c1 * s2 * s3;
            target[1] = c1 * s2 * c3 - s1 * c2 * s3;
            target[2] = c1 * c2 * s3 + s1 * s2 * c3;
            target[3] = c1 * c2 * c3 + s1 * s2 * s3;
            break;
    }
};
var $0fd61056af77925d$export$2e2bcd8739ae039 = $0fd61056af77925d$var$Quaternion;






var $39676d59fa1158f6$var$vec3Set = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).set;
var $39676d59fa1158f6$var$vec3Copy = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).copy;
/**
 * Axis aligned bounding box
 * @constructor
 * @alias clay.BoundingBox
 * @param {clay.Vector3} [min]
 * @param {clay.Vector3} [max]
 */ var $39676d59fa1158f6$var$BoundingBox = function(min, max) {
    /**
     * Minimum coords of bounding box
     * @type {clay.Vector3}
     */ this.min = min || new (0, $27fea36417076c2d$export$2e2bcd8739ae039)(Infinity, Infinity, Infinity);
    /**
     * Maximum coords of bounding box
     * @type {clay.Vector3}
     */ this.max = max || new (0, $27fea36417076c2d$export$2e2bcd8739ae039)(-Infinity, -Infinity, -Infinity);
    this.vertices = null;
};
$39676d59fa1158f6$var$BoundingBox.prototype = {
    constructor: $39676d59fa1158f6$var$BoundingBox,
    /**
     * Update min and max coords from a vertices array
     * @param  {array} vertices
     */ updateFromVertices: function(vertices) {
        if (vertices.length > 0) {
            var min = this.min;
            var max = this.max;
            var minArr = min.array;
            var maxArr = max.array;
            $39676d59fa1158f6$var$vec3Copy(minArr, vertices[0]);
            $39676d59fa1158f6$var$vec3Copy(maxArr, vertices[0]);
            for(var i = 1; i < vertices.length; i++){
                var vertex = vertices[i];
                if (vertex[0] < minArr[0]) minArr[0] = vertex[0];
                if (vertex[1] < minArr[1]) minArr[1] = vertex[1];
                if (vertex[2] < minArr[2]) minArr[2] = vertex[2];
                if (vertex[0] > maxArr[0]) maxArr[0] = vertex[0];
                if (vertex[1] > maxArr[1]) maxArr[1] = vertex[1];
                if (vertex[2] > maxArr[2]) maxArr[2] = vertex[2];
            }
            min._dirty = true;
            max._dirty = true;
        }
    },
    /**
     * Union operation with another bounding box
     * @param  {clay.BoundingBox} bbox
     */ union: function(bbox) {
        var min = this.min;
        var max = this.max;
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).min(min.array, min.array, bbox.min.array);
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).max(max.array, max.array, bbox.max.array);
        min._dirty = true;
        max._dirty = true;
        return this;
    },
    /**
     * Intersection operation with another bounding box
     * @param  {clay.BoundingBox} bbox
     */ intersection: function(bbox) {
        var min = this.min;
        var max = this.max;
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).max(min.array, min.array, bbox.min.array);
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).min(max.array, max.array, bbox.max.array);
        min._dirty = true;
        max._dirty = true;
        return this;
    },
    /**
     * If intersect with another bounding box
     * @param  {clay.BoundingBox} bbox
     * @return {boolean}
     */ intersectBoundingBox: function(bbox) {
        var _min = this.min.array;
        var _max = this.max.array;
        var _min2 = bbox.min.array;
        var _max2 = bbox.max.array;
        return !(_min[0] > _max2[0] || _min[1] > _max2[1] || _min[2] > _max2[2] || _max[0] < _min2[0] || _max[1] < _min2[1] || _max[2] < _min2[2]);
    },
    /**
     * If contain another bounding box entirely
     * @param  {clay.BoundingBox} bbox
     * @return {boolean}
     */ containBoundingBox: function(bbox) {
        var _min = this.min.array;
        var _max = this.max.array;
        var _min2 = bbox.min.array;
        var _max2 = bbox.max.array;
        return _min[0] <= _min2[0] && _min[1] <= _min2[1] && _min[2] <= _min2[2] && _max[0] >= _max2[0] && _max[1] >= _max2[1] && _max[2] >= _max2[2];
    },
    /**
     * If contain point entirely
     * @param  {clay.Vector3} point
     * @return {boolean}
     */ containPoint: function(p) {
        var _min = this.min.array;
        var _max = this.max.array;
        var _p = p.array;
        return _min[0] <= _p[0] && _min[1] <= _p[1] && _min[2] <= _p[2] && _max[0] >= _p[0] && _max[1] >= _p[1] && _max[2] >= _p[2];
    },
    /**
     * If bounding box is finite
     */ isFinite: function() {
        var _min = this.min.array;
        var _max = this.max.array;
        return isFinite(_min[0]) && isFinite(_min[1]) && isFinite(_min[2]) && isFinite(_max[0]) && isFinite(_max[1]) && isFinite(_max[2]);
    },
    /**
     * Apply an affine transform matrix to the bounding box
     * @param  {clay.Matrix4} matrix
     */ applyTransform: function(matrix) {
        this.transformFrom(this, matrix);
    },
    /**
     * Get from another bounding box and an affine transform matrix.
     * @param {clay.BoundingBox} source
     * @param {clay.Matrix4} matrix
     */ transformFrom: function() {
        // http://dev.theomader.com/transform-bounding-boxes/
        var xa = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
        var xb = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
        var ya = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
        var yb = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
        var za = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
        var zb = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
        return function(source, matrix) {
            var min = source.min.array;
            var max = source.max.array;
            var m = matrix.array;
            xa[0] = m[0] * min[0];
            xa[1] = m[1] * min[0];
            xa[2] = m[2] * min[0];
            xb[0] = m[0] * max[0];
            xb[1] = m[1] * max[0];
            xb[2] = m[2] * max[0];
            ya[0] = m[4] * min[1];
            ya[1] = m[5] * min[1];
            ya[2] = m[6] * min[1];
            yb[0] = m[4] * max[1];
            yb[1] = m[5] * max[1];
            yb[2] = m[6] * max[1];
            za[0] = m[8] * min[2];
            za[1] = m[9] * min[2];
            za[2] = m[10] * min[2];
            zb[0] = m[8] * max[2];
            zb[1] = m[9] * max[2];
            zb[2] = m[10] * max[2];
            min = this.min.array;
            max = this.max.array;
            min[0] = Math.min(xa[0], xb[0]) + Math.min(ya[0], yb[0]) + Math.min(za[0], zb[0]) + m[12];
            min[1] = Math.min(xa[1], xb[1]) + Math.min(ya[1], yb[1]) + Math.min(za[1], zb[1]) + m[13];
            min[2] = Math.min(xa[2], xb[2]) + Math.min(ya[2], yb[2]) + Math.min(za[2], zb[2]) + m[14];
            max[0] = Math.max(xa[0], xb[0]) + Math.max(ya[0], yb[0]) + Math.max(za[0], zb[0]) + m[12];
            max[1] = Math.max(xa[1], xb[1]) + Math.max(ya[1], yb[1]) + Math.max(za[1], zb[1]) + m[13];
            max[2] = Math.max(xa[2], xb[2]) + Math.max(ya[2], yb[2]) + Math.max(za[2], zb[2]) + m[14];
            this.min._dirty = true;
            this.max._dirty = true;
            return this;
        };
    }(),
    /**
     * Apply a projection matrix to the bounding box
     * @param  {clay.Matrix4} matrix
     */ applyProjection: function(matrix) {
        var min = this.min.array;
        var max = this.max.array;
        var m = matrix.array;
        // min in min z
        var v10 = min[0];
        var v11 = min[1];
        var v12 = min[2];
        // max in min z
        var v20 = max[0];
        var v21 = max[1];
        var v22 = min[2];
        // max in max z
        var v30 = max[0];
        var v31 = max[1];
        var v32 = max[2];
        if (m[15] === 1) {
            min[0] = m[0] * v10 + m[12];
            min[1] = m[5] * v11 + m[13];
            max[2] = m[10] * v12 + m[14];
            max[0] = m[0] * v30 + m[12];
            max[1] = m[5] * v31 + m[13];
            min[2] = m[10] * v32 + m[14];
        } else {
            var w = -1 / v12;
            min[0] = m[0] * v10 * w;
            min[1] = m[5] * v11 * w;
            max[2] = (m[10] * v12 + m[14]) * w;
            w = -1 / v22;
            max[0] = m[0] * v20 * w;
            max[1] = m[5] * v21 * w;
            w = -1 / v32;
            min[2] = (m[10] * v32 + m[14]) * w;
        }
        this.min._dirty = true;
        this.max._dirty = true;
        return this;
    },
    updateVertices: function() {
        var vertices = this.vertices;
        if (!vertices) {
            // Cube vertices
            vertices = [];
            for(var i = 0; i < 8; i++)vertices[i] = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).fromValues(0, 0, 0);
            /**
             * Eight coords of bounding box
             * @type {Float32Array[]}
             */ this.vertices = vertices;
        }
        var min = this.min.array;
        var max = this.max.array;
        //--- min z
        // min x
        $39676d59fa1158f6$var$vec3Set(vertices[0], min[0], min[1], min[2]);
        $39676d59fa1158f6$var$vec3Set(vertices[1], min[0], max[1], min[2]);
        // max x
        $39676d59fa1158f6$var$vec3Set(vertices[2], max[0], min[1], min[2]);
        $39676d59fa1158f6$var$vec3Set(vertices[3], max[0], max[1], min[2]);
        //-- max z
        $39676d59fa1158f6$var$vec3Set(vertices[4], min[0], min[1], max[2]);
        $39676d59fa1158f6$var$vec3Set(vertices[5], min[0], max[1], max[2]);
        $39676d59fa1158f6$var$vec3Set(vertices[6], max[0], min[1], max[2]);
        $39676d59fa1158f6$var$vec3Set(vertices[7], max[0], max[1], max[2]);
        return this;
    },
    /**
     * Copy values from another bounding box
     * @param  {clay.BoundingBox} bbox
     */ copy: function(bbox) {
        var min = this.min;
        var max = this.max;
        $39676d59fa1158f6$var$vec3Copy(min.array, bbox.min.array);
        $39676d59fa1158f6$var$vec3Copy(max.array, bbox.max.array);
        min._dirty = true;
        max._dirty = true;
        return this;
    },
    /**
     * Clone a new bounding box
     * @return {clay.BoundingBox}
     */ clone: function() {
        var boundingBox = new $39676d59fa1158f6$var$BoundingBox();
        boundingBox.copy(this);
        return boundingBox;
    }
};
var $39676d59fa1158f6$export$2e2bcd8739ae039 = $39676d59fa1158f6$var$BoundingBox;


var $e02012a49e6aaac9$var$nameId = 0;
/**
 * @constructor clay.Node
 * @extends clay.core.Base
 */ var $e02012a49e6aaac9$var$Node = (0, $7c62670c05885275$export$2e2bcd8739ae039).extend(/** @lends clay.Node# */ {
    /**
     * Scene node name
     * @type {string}
     */ name: "",
    /**
     * Position relative to its parent node. aka translation.
     * @type {clay.Vector3}
     */ position: null,
    /**
     * Rotation relative to its parent node. Represented by a quaternion
     * @type {clay.Quaternion}
     */ rotation: null,
    /**
     * Scale relative to its parent node
     * @type {clay.Vector3}
     */ scale: null,
    /**
     * Affine transform matrix relative to its root scene.
     * @type {clay.Matrix4}
     */ worldTransform: null,
    /**
     * Affine transform matrix relative to its parent node.
     * Composited with position, rotation and scale.
     * @type {clay.Matrix4}
     */ localTransform: null,
    /**
     * If the local transform is update from SRT(scale, rotation, translation, which is position here) each frame
     * @type {boolean}
     */ autoUpdateLocalTransform: true,
    /**
     * Parent of current scene node
     * @type {?clay.Node}
     * @private
     */ _parent: null,
    /**
     * The root scene mounted. Null if it is a isolated node
     * @type {?clay.Scene}
     * @private
     */ _scene: null,
    /**
     * @type {boolean}
     * @private
     */ _needsUpdateWorldTransform: true,
    /**
     * @type {boolean}
     * @private
     */ _inIterating: false,
    // Depth for transparent list sorting
    __depth: 0
}, function() {
    if (!this.name) this.name = (this.type || "NODE") + "_" + $e02012a49e6aaac9$var$nameId++;
    if (!this.position) this.position = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
    if (!this.rotation) this.rotation = new (0, $0fd61056af77925d$export$2e2bcd8739ae039)();
    if (!this.scale) this.scale = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)(1, 1, 1);
    this.worldTransform = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
    this.localTransform = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
    this._children = [];
}, /**@lends clay.Node.prototype. */ {
    /**
     * @type {?clay.Vector3}
     * @instance
     */ target: null,
    /**
     * If node and its chilren invisible
     * @type {boolean}
     * @instance
     */ invisible: false,
    /**
     * If Node is a skinned mesh
     * @return {boolean}
     */ isSkinnedMesh: function() {
        return false;
    },
    /**
     * Return true if it is a renderable scene node, like Mesh and ParticleSystem
     * @return {boolean}
     */ isRenderable: function() {
        return false;
    },
    /**
     * Set the name of the scene node
     * @param {string} name
     */ setName: function(name) {
        var scene = this._scene;
        if (scene) {
            var nodeRepository = scene._nodeRepository;
            delete nodeRepository[this.name];
            nodeRepository[name] = this;
        }
        this.name = name;
    },
    /**
     * Add a child node
     * @param {clay.Node} node
     */ add: function(node) {
        var originalParent = node._parent;
        if (originalParent === this) return;
        if (originalParent) originalParent.remove(node);
        node._parent = this;
        this._children.push(node);
        var scene = this._scene;
        if (scene && scene !== node.scene) node.traverse(this._addSelfToScene, this);
        // Mark children needs update transform
        // In case child are remove and added again after parent moved
        node._needsUpdateWorldTransform = true;
    },
    /**
     * Remove the given child scene node
     * @param {clay.Node} node
     */ remove: function(node) {
        var children = this._children;
        var idx = children.indexOf(node);
        if (idx < 0) return;
        children.splice(idx, 1);
        node._parent = null;
        if (this._scene) node.traverse(this._removeSelfFromScene, this);
    },
    /**
     * Remove all children
     */ removeAll: function() {
        var children = this._children;
        for(var idx = 0; idx < children.length; idx++){
            children[idx]._parent = null;
            if (this._scene) children[idx].traverse(this._removeSelfFromScene, this);
        }
        this._children = [];
    },
    /**
     * Get the scene mounted
     * @return {clay.Scene}
     */ getScene: function() {
        return this._scene;
    },
    /**
     * Get parent node
     * @return {clay.Scene}
     */ getParent: function() {
        return this._parent;
    },
    _removeSelfFromScene: function(descendant) {
        descendant._scene.removeFromScene(descendant);
        descendant._scene = null;
    },
    _addSelfToScene: function(descendant) {
        this._scene.addToScene(descendant);
        descendant._scene = this._scene;
    },
    /**
     * Return true if it is ancestor of the given scene node
     * @param {clay.Node} node
     */ isAncestor: function(node) {
        var parent = node._parent;
        while(parent){
            if (parent === this) return true;
            parent = parent._parent;
        }
        return false;
    },
    /**
     * Get a new created array of all children nodes
     * @return {clay.Node[]}
     */ children: function() {
        return this._children.slice();
    },
    /**
     * Get child scene node at given index.
     * @param {number} idx
     * @return {clay.Node}
     */ childAt: function(idx) {
        return this._children[idx];
    },
    /**
     * Get first child with the given name
     * @param {string} name
     * @return {clay.Node}
     */ getChildByName: function(name) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            if (children[i].name === name) return children[i];
        }
    },
    /**
     * Get first descendant have the given name
     * @param {string} name
     * @return {clay.Node}
     */ getDescendantByName: function(name) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (child.name === name) return child;
            else {
                var res = child.getDescendantByName(name);
                if (res) return res;
            }
        }
    },
    /**
     * Query descendant node by path
     * @param {string} path
     * @return {clay.Node}
     * @example
     *  node.queryNode('root/parent/child');
     */ queryNode: function(path) {
        if (!path) return;
        // TODO Name have slash ?
        var pathArr = path.split("/");
        var current = this;
        for(var i = 0; i < pathArr.length; i++){
            var name = pathArr[i];
            // Skip empty
            if (!name) continue;
            var found = false;
            var children = current._children;
            for(var j = 0; j < children.length; j++){
                var child = children[j];
                if (child.name === name) {
                    current = child;
                    found = true;
                    break;
                }
            }
            // Early return if not found
            if (!found) return;
        }
        return current;
    },
    /**
     * Get query path, relative to rootNode(default is scene)
     * @param {clay.Node} [rootNode]
     * @return {string}
     */ getPath: function(rootNode) {
        if (!this._parent) return "/";
        var current = this._parent;
        var path = this.name;
        while(current._parent){
            path = current.name + "/" + path;
            if (current._parent == rootNode) break;
            current = current._parent;
        }
        if (!current._parent && rootNode) return null;
        return path;
    },
    /**
     * Depth first traverse all its descendant scene nodes.
     *
     * **WARN** Don't do `add`, `remove` operation in the callback during traverse.
     * @param {Function} callback
     * @param {Node} [context]
     */ traverse: function(callback, context) {
        callback.call(context, this);
        var _children = this._children;
        for(var i = 0, len = _children.length; i < len; i++)_children[i].traverse(callback, context);
    },
    /**
     * Traverse all children nodes.
     *
     * **WARN** DON'T do `add`, `remove` operation in the callback during iteration.
     *
     * @param {Function} callback
     * @param {Node} [context]
     */ eachChild: function(callback, context) {
        var _children = this._children;
        for(var i = 0, len = _children.length; i < len; i++){
            var child = _children[i];
            callback.call(context, child, i);
        }
    },
    /**
     * Set the local transform and decompose to SRT
     * @param {clay.Matrix4} matrix
     */ setLocalTransform: function(matrix) {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).copy(this.localTransform.array, matrix.array);
        this.decomposeLocalTransform();
    },
    /**
     * Decompose the local transform to SRT
     */ decomposeLocalTransform: function(keepScale) {
        var scale = !keepScale ? this.scale : null;
        this.localTransform.decomposeMatrix(scale, this.rotation, this.position);
    },
    /**
     * Set the world transform and decompose to SRT
     * @param {clay.Matrix4} matrix
     */ setWorldTransform: function(matrix) {
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).copy(this.worldTransform.array, matrix.array);
        this.decomposeWorldTransform();
    },
    /**
     * Decompose the world transform to SRT
     * @function
     */ decomposeWorldTransform: function() {
        var tmp = (0, $0020ce97b75275ae$export$2e2bcd8739ae039).create();
        return function(keepScale) {
            var localTransform = this.localTransform;
            var worldTransform = this.worldTransform;
            // Assume world transform is updated
            if (this._parent) {
                (0, $0020ce97b75275ae$export$2e2bcd8739ae039).invert(tmp, this._parent.worldTransform.array);
                (0, $0020ce97b75275ae$export$2e2bcd8739ae039).multiply(localTransform.array, tmp, worldTransform.array);
            } else (0, $0020ce97b75275ae$export$2e2bcd8739ae039).copy(localTransform.array, worldTransform.array);
            var scale = !keepScale ? this.scale : null;
            localTransform.decomposeMatrix(scale, this.rotation, this.position);
        };
    }(),
    transformNeedsUpdate: function() {
        return this.position._dirty || this.rotation._dirty || this.scale._dirty;
    },
    /**
     * Update local transform from SRT
     * Notice that local transform will not be updated if _dirty mark of position, rotation, scale is all false
     */ updateLocalTransform: function() {
        var position = this.position;
        var rotation = this.rotation;
        var scale = this.scale;
        if (this.transformNeedsUpdate()) {
            var m = this.localTransform.array;
            // Transform order, scale->rotation->position
            (0, $0020ce97b75275ae$export$2e2bcd8739ae039).fromRotationTranslation(m, rotation.array, position.array);
            (0, $0020ce97b75275ae$export$2e2bcd8739ae039).scale(m, m, scale.array);
            rotation._dirty = false;
            scale._dirty = false;
            position._dirty = false;
            this._needsUpdateWorldTransform = true;
        }
    },
    /**
     * Update world transform, assume its parent world transform have been updated
     * @private
     */ _updateWorldTransformTopDown: function() {
        var localTransform = this.localTransform.array;
        var worldTransform = this.worldTransform.array;
        if (this._parent) (0, $0020ce97b75275ae$export$2e2bcd8739ae039).multiplyAffine(worldTransform, this._parent.worldTransform.array, localTransform);
        else (0, $0020ce97b75275ae$export$2e2bcd8739ae039).copy(worldTransform, localTransform);
    },
    /**
     * Update world transform before whole scene is updated.
     */ updateWorldTransform: function() {
        // Find the root node which transform needs update;
        var rootNodeIsDirty = this;
        while(rootNodeIsDirty && rootNodeIsDirty.getParent() && rootNodeIsDirty.getParent().transformNeedsUpdate())rootNodeIsDirty = rootNodeIsDirty.getParent();
        rootNodeIsDirty.update();
    },
    /**
     * Update local transform and world transform recursively
     * @param {boolean} forceUpdateWorld
     */ update: function(forceUpdateWorld) {
        if (this.autoUpdateLocalTransform) this.updateLocalTransform();
        else // Transform is manually setted
        forceUpdateWorld = true;
        if (forceUpdateWorld || this._needsUpdateWorldTransform) {
            this._updateWorldTransformTopDown();
            forceUpdateWorld = true;
            this._needsUpdateWorldTransform = false;
        }
        var children = this._children;
        for(var i = 0, len = children.length; i < len; i++)children[i].update(forceUpdateWorld);
    },
    /**
     * Get bounding box of node
     * @param  {Function} [filter]
     * @param  {clay.BoundingBox} [out]
     * @return {clay.BoundingBox}
     */ // TODO Skinning
    getBoundingBox: function() {
        function defaultFilter(el) {
            return !el.invisible && el.geometry;
        }
        var tmpBBox = new (0, $39676d59fa1158f6$export$2e2bcd8739ae039)();
        var tmpMat4 = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
        var invWorldTransform = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
        return function(filter, out) {
            out = out || new (0, $39676d59fa1158f6$export$2e2bcd8739ae039)();
            filter = filter || defaultFilter;
            if (this._parent) (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).invert(invWorldTransform, this._parent.worldTransform);
            else (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).identity(invWorldTransform);
            this.traverse(function(mesh) {
                if (mesh.geometry && mesh.geometry.boundingBox) {
                    tmpBBox.copy(mesh.geometry.boundingBox);
                    (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).multiply(tmpMat4, invWorldTransform, mesh.worldTransform);
                    tmpBBox.applyTransform(tmpMat4);
                    out.union(tmpBBox);
                }
            }, this, defaultFilter);
            return out;
        };
    }(),
    /**
     * Get world position, extracted from world transform
     * @param  {clay.Vector3} [out]
     * @return {clay.Vector3}
     */ getWorldPosition: function(out) {
        // PENDING
        if (this.transformNeedsUpdate()) this.updateWorldTransform();
        var m = this.worldTransform.array;
        if (out) {
            var arr = out.array;
            arr[0] = m[12];
            arr[1] = m[13];
            arr[2] = m[14];
            return out;
        } else return new (0, $27fea36417076c2d$export$2e2bcd8739ae039)(m[12], m[13], m[14]);
    },
    /**
     * Clone a new node
     * @return {Node}
     */ clone: function() {
        var node = new this.constructor();
        var children = this._children;
        node.setName(this.name);
        node.position.copy(this.position);
        node.rotation.copy(this.rotation);
        node.scale.copy(this.scale);
        for(var i = 0; i < children.length; i++)node.add(children[i].clone());
        return node;
    },
    /**
     * Rotate the node around a axis by angle degrees, axis passes through point
     * @param {clay.Vector3} point Center point
     * @param {clay.Vector3} axis  Center axis
     * @param {number}       angle Rotation angle
     * @see http://docs.unity3d.com/Documentation/ScriptReference/Transform.RotateAround.html
     * @function
     */ rotateAround: function() {
        var v = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
        var RTMatrix = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
        // TODO improve performance
        return function(point, axis, angle) {
            v.copy(this.position).subtract(point);
            var localTransform = this.localTransform;
            localTransform.identity();
            // parent node
            localTransform.translate(point);
            localTransform.rotate(angle, axis);
            RTMatrix.fromRotationTranslation(this.rotation, v);
            localTransform.multiply(RTMatrix);
            localTransform.scale(this.scale);
            this.decomposeLocalTransform();
            this._needsUpdateWorldTransform = true;
        };
    }(),
    /**
     * @param {clay.Vector3} target
     * @param {clay.Vector3} [up]
     * @see http://www.opengl.org/sdk/docs/man2/xhtml/gluLookAt.xml
     * @function
     */ lookAt: function() {
        var m = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
        return function(target, up) {
            m.lookAt(this.position, target, up || this.localTransform.y).invert();
            this.setLocalTransform(m);
            this.target = target;
        };
    }()
});
var $e02012a49e6aaac9$export$2e2bcd8739ae039 = $e02012a49e6aaac9$var$Node;



/**
 * @constructor
 * @alias clay.Renderable
 * @extends clay.Node
 */ var $061a3619e6fe7819$var$Renderable = (0, $e02012a49e6aaac9$export$2e2bcd8739ae039).extend(/** @lends clay.Renderable# */ {
    /**
     * @type {clay.Material}
     */ material: null,
    /**
     * @type {clay.Geometry}
     */ geometry: null,
    /**
     * @type {number}
     */ mode: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).TRIANGLES,
    _renderInfo: null
}, /** @lends clay.Renderable.prototype */ {
    __program: null,
    /**
     * Group of received light.
     */ lightGroup: 0,
    /**
     * Render order, Nodes with smaller value renders before nodes with larger values.
     * @type {Number}
     */ renderOrder: 0,
    /**
     * Used when mode is LINES, LINE_STRIP or LINE_LOOP
     * @type {number}
     */ // lineWidth: 1,
    /**
     * If enable culling
     * @type {boolean}
     */ culling: true,
    /**
     * Specify which side of polygon will be culled.
     * Possible values:
     *  + {@link clay.Renderable.BACK}
     *  + {@link clay.Renderable.FRONT}
     *  + {@link clay.Renderable.FRONT_AND_BACK}
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/cullFace
     * @type {number}
     */ cullFace: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).BACK,
    /**
     * Specify which side is front face.
     * Possible values:
     *  + {@link clay.Renderable.CW}
     *  + {@link clay.Renderable.CCW}
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/frontFace
     * @type {number}
     */ frontFace: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).CCW,
    /**
     * If enable software frustum culling
     * @type {boolean}
     */ frustumCulling: true,
    /**
     * @type {boolean}
     */ receiveShadow: true,
    /**
     * @type {boolean}
     */ castShadow: true,
    /**
     * @type {boolean}
     */ ignorePicking: false,
    /**
     * @type {boolean}
     */ ignorePreZ: false,
    /**
     * @type {boolean}
     */ ignoreGBuffer: false,
    /**
     * @return {boolean}
     */ isRenderable: function() {
        // TODO Shader ?
        return this.geometry && this.material && this.material.shader && !this.invisible && this.geometry.vertexCount > 0;
    },
    /**
     * Before render hook
     * @type {Function}
     */ beforeRender: function(_gl) {},
    /**
     * Before render hook
     * @type {Function}
     */ afterRender: function(_gl, renderStat) {},
    getBoundingBox: function(filter, out) {
        out = (0, $e02012a49e6aaac9$export$2e2bcd8739ae039).prototype.getBoundingBox.call(this, filter, out);
        if (this.geometry && this.geometry.boundingBox) out.union(this.geometry.boundingBox);
        return out;
    },
    /**
     * Clone a new renderable
     * @function
     * @return {clay.Renderable}
     */ clone: function() {
        var properties = [
            "castShadow",
            "receiveShadow",
            "mode",
            "culling",
            "cullFace",
            "frontFace",
            "frustumCulling",
            "renderOrder",
            "lineWidth",
            "ignorePicking",
            "ignorePreZ",
            "ignoreGBuffer"
        ];
        return function() {
            var renderable = (0, $e02012a49e6aaac9$export$2e2bcd8739ae039).prototype.clone.call(this);
            renderable.geometry = this.geometry;
            renderable.material = this.material;
            for(var i = 0; i < properties.length; i++){
                var name = properties[i];
                // Try not to overwrite the prototype property
                if (renderable[name] !== this[name]) renderable[name] = this[name];
            }
            return renderable;
        };
    }()
});
/**
 * @type {number}
 */ $061a3619e6fe7819$var$Renderable.POINTS = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).POINTS;
/**
 * @type {number}
 */ $061a3619e6fe7819$var$Renderable.LINES = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LINES;
/**
 * @type {number}
 */ $061a3619e6fe7819$var$Renderable.LINE_LOOP = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LINE_LOOP;
/**
 * @type {number}
 */ $061a3619e6fe7819$var$Renderable.LINE_STRIP = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LINE_STRIP;
/**
 * @type {number}
 */ $061a3619e6fe7819$var$Renderable.TRIANGLES = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).TRIANGLES;
/**
 * @type {number}
 */ $061a3619e6fe7819$var$Renderable.TRIANGLE_STRIP = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).TRIANGLE_STRIP;
/**
 * @type {number}
 */ $061a3619e6fe7819$var$Renderable.TRIANGLE_FAN = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).TRIANGLE_FAN;
/**
 * @type {number}
 */ $061a3619e6fe7819$var$Renderable.BACK = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).BACK;
/**
 * @type {number}
 */ $061a3619e6fe7819$var$Renderable.FRONT = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).FRONT;
/**
 * @type {number}
 */ $061a3619e6fe7819$var$Renderable.FRONT_AND_BACK = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).FRONT_AND_BACK;
/**
 * @type {number}
 */ $061a3619e6fe7819$var$Renderable.CW = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).CW;
/**
 * @type {number}
 */ $061a3619e6fe7819$var$Renderable.CCW = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).CCW;
var $061a3619e6fe7819$export$2e2bcd8739ae039 = $061a3619e6fe7819$var$Renderable;




/**
 * @constructor clay.picking.RayPicking
 * @extends clay.core.Base
 */ var $0c938f7cf7210181$var$RayPicking = (0, $7c62670c05885275$export$2e2bcd8739ae039).extend(/** @lends clay.picking.RayPicking# */ {
    /**
     * Target scene
     * @type {clay.Scene}
     */ scene: null,
    /**
     * Target camera
     * @type {clay.Camera}
     */ camera: null,
    /**
     * Target renderer
     * @type {clay.Renderer}
     */ renderer: null
}, function() {
    this._ray = new (0, $65a5d9098f8e83b0$export$2e2bcd8739ae039)();
    this._ndc = new (0, $2cb41795bddfe4d3$export$2e2bcd8739ae039)();
}, /** @lends clay.picking.RayPicking.prototype */ {
    /**
     * Pick the nearest intersection object in the scene
     * @param  {number} x Mouse position x
     * @param  {number} y Mouse position y
     * @param  {boolean} [forcePickAll=false] ignore ignorePicking
     * @return {clay.picking.RayPicking~Intersection}
     */ pick: function(x, y, forcePickAll) {
        var out = this.pickAll(x, y, [], forcePickAll);
        return out[0] || null;
    },
    /**
     * Pick all intersection objects, wich will be sorted from near to far
     * @param  {number} x Mouse position x
     * @param  {number} y Mouse position y
     * @param  {Array} [output]
     * @param  {boolean} [forcePickAll=false] ignore ignorePicking
     * @return {Array.<clay.picking.RayPicking~Intersection>}
     */ pickAll: function(x, y, output, forcePickAll) {
        this.renderer.screenToNDC(x, y, this._ndc);
        this.camera.castRay(this._ndc, this._ray);
        output = output || [];
        this._intersectNode(this.scene, output, forcePickAll || false);
        output.sort(this._intersectionCompareFunc);
        return output;
    },
    _intersectNode: function(node, out, forcePickAll) {
        if (node instanceof (0, $061a3619e6fe7819$export$2e2bcd8739ae039) && node.isRenderable()) {
            if ((!node.ignorePicking || forcePickAll) && (// Only triangle mesh support ray picking
            node.mode === (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).TRIANGLES && node.geometry.isUseIndices() || node.geometry.pickByRay || node.geometry.pick)) this._intersectRenderable(node, out);
        }
        for(var i = 0; i < node._children.length; i++)this._intersectNode(node._children[i], out, forcePickAll);
    },
    _intersectRenderable: function() {
        var v1 = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
        var v2 = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
        var v3 = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
        var ray = new (0, $65a5d9098f8e83b0$export$2e2bcd8739ae039)();
        var worldInverse = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
        return function(renderable, out) {
            var isSkinnedMesh = renderable.isSkinnedMesh();
            ray.copy(this._ray);
            (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).invert(worldInverse, renderable.worldTransform);
            // Skinned mesh will ignore the world transform.
            if (!isSkinnedMesh) ray.applyTransform(worldInverse);
            var geometry = renderable.geometry;
            var bbox = isSkinnedMesh ? renderable.skeleton.boundingBox : geometry.boundingBox;
            if (bbox && !ray.intersectBoundingBox(bbox)) return;
            // Use user defined picking algorithm
            if (geometry.pick) {
                geometry.pick(this._ndc.x, this._ndc.y, this.renderer, this.camera, renderable, out);
                return;
            } else if (geometry.pickByRay) {
                geometry.pickByRay(ray, renderable, out);
                return;
            }
            var cullBack = renderable.cullFace === (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).BACK && renderable.frontFace === (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).CCW || renderable.cullFace === (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).FRONT && renderable.frontFace === (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).CW;
            var point;
            var indices = geometry.indices;
            var positionAttr = geometry.attributes.position;
            var weightAttr = geometry.attributes.weight;
            var jointAttr = geometry.attributes.joint;
            var skinMatricesArray;
            var skinMatrices = [];
            // Check if valid.
            if (!positionAttr || !positionAttr.value || !indices) return;
            if (isSkinnedMesh) {
                skinMatricesArray = renderable.skeleton.getSubSkinMatrices(renderable.__uid__, renderable.joints);
                for(var i = 0; i < renderable.joints.length; i++){
                    skinMatrices[i] = skinMatrices[i] || [];
                    for(var k = 0; k < 16; k++)skinMatrices[i][k] = skinMatricesArray[i * 16 + k];
                }
                var pos = [];
                var weight = [];
                var joint = [];
                var skinnedPos = [];
                var tmp = [];
                var skinnedPositionAttr = geometry.attributes.skinnedPosition;
                if (!skinnedPositionAttr || !skinnedPositionAttr.value) {
                    geometry.createAttribute("skinnedPosition", "f", 3);
                    skinnedPositionAttr = geometry.attributes.skinnedPosition;
                    skinnedPositionAttr.init(geometry.vertexCount);
                }
                for(var i = 0; i < geometry.vertexCount; i++){
                    positionAttr.get(i, pos);
                    weightAttr.get(i, weight);
                    jointAttr.get(i, joint);
                    weight[3] = 1 - weight[0] - weight[1] - weight[2];
                    (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).set(skinnedPos, 0, 0, 0);
                    for(var k = 0; k < 4; k++)if (joint[k] >= 0 && weight[k] > 1e-4) {
                        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).transformMat4(tmp, pos, skinMatrices[joint[k]]);
                        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scaleAndAdd(skinnedPos, skinnedPos, tmp, weight[k]);
                    }
                    skinnedPositionAttr.set(i, skinnedPos);
                }
            }
            for(var i = 0; i < indices.length; i += 3){
                var i1 = indices[i];
                var i2 = indices[i + 1];
                var i3 = indices[i + 2];
                var finalPosAttr = isSkinnedMesh ? geometry.attributes.skinnedPosition : positionAttr;
                finalPosAttr.get(i1, v1.array);
                finalPosAttr.get(i2, v2.array);
                finalPosAttr.get(i3, v3.array);
                if (cullBack) point = ray.intersectTriangle(v1, v2, v3, renderable.culling);
                else point = ray.intersectTriangle(v1, v3, v2, renderable.culling);
                if (point) {
                    var pointW = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
                    if (!isSkinnedMesh) (0, $27fea36417076c2d$export$2e2bcd8739ae039).transformMat4(pointW, point, renderable.worldTransform);
                    else // TODO point maybe not right.
                    (0, $27fea36417076c2d$export$2e2bcd8739ae039).copy(pointW, point);
                    out.push(new $0c938f7cf7210181$var$RayPicking.Intersection(point, pointW, renderable, [
                        i1,
                        i2,
                        i3
                    ], i / 3, (0, $27fea36417076c2d$export$2e2bcd8739ae039).dist(pointW, this._ray.origin)));
                }
            }
        };
    }(),
    _intersectionCompareFunc: function(a, b) {
        return a.distance - b.distance;
    }
});
/**
 * @constructor clay.picking.RayPicking~Intersection
 * @param {clay.Vector3} point
 * @param {clay.Vector3} pointWorld
 * @param {clay.Node} target
 * @param {Array.<number>} triangle
 * @param {number} triangleIndex
 * @param {number} distance
 */ $0c938f7cf7210181$var$RayPicking.Intersection = function(point, pointWorld, target, triangle, triangleIndex, distance) {
    /**
     * Intersection point in local transform coordinates
     * @type {clay.Vector3}
     */ this.point = point;
    /**
     * Intersection point in world transform coordinates
     * @type {clay.Vector3}
     */ this.pointWorld = pointWorld;
    /**
     * Intersection scene node
     * @type {clay.Node}
     */ this.target = target;
    /**
     * Intersection triangle, which is an array of vertex index
     * @type {Array.<number>}
     */ this.triangle = triangle;
    /**
     * Index of intersection triangle.
     */ this.triangleIndex = triangleIndex;
    /**
     * Distance from intersection point to ray origin
     * @type {number}
     */ this.distance = distance;
};
var $0c938f7cf7210181$export$2e2bcd8739ae039 = $0c938f7cf7210181$var$RayPicking;


/**
 * Base class for all textures like compressed texture, texture2d, texturecube
 * TODO mapping
 */ 

var $5f2dc45e40134abc$var$DIRTY_PREFIX = "__dt__";
var $5f2dc45e40134abc$var$Cache = function() {
    this._contextId = 0;
    this._caches = [];
    this._context = {};
};
$5f2dc45e40134abc$var$Cache.prototype = {
    use: function(contextId, documentSchema) {
        var caches = this._caches;
        if (!caches[contextId]) {
            caches[contextId] = {};
            if (documentSchema) caches[contextId] = documentSchema();
        }
        this._contextId = contextId;
        this._context = caches[contextId];
    },
    put: function(key, value) {
        this._context[key] = value;
    },
    get: function(key) {
        return this._context[key];
    },
    dirty: function(field) {
        field = field || "";
        var key = $5f2dc45e40134abc$var$DIRTY_PREFIX + field;
        this.put(key, true);
    },
    dirtyAll: function(field) {
        field = field || "";
        var key = $5f2dc45e40134abc$var$DIRTY_PREFIX + field;
        var caches = this._caches;
        for(var i = 0; i < caches.length; i++)if (caches[i]) caches[i][key] = true;
    },
    fresh: function(field) {
        field = field || "";
        var key = $5f2dc45e40134abc$var$DIRTY_PREFIX + field;
        this.put(key, false);
    },
    freshAll: function(field) {
        field = field || "";
        var key = $5f2dc45e40134abc$var$DIRTY_PREFIX + field;
        var caches = this._caches;
        for(var i = 0; i < caches.length; i++)if (caches[i]) caches[i][key] = false;
    },
    isDirty: function(field) {
        field = field || "";
        var key = $5f2dc45e40134abc$var$DIRTY_PREFIX + field;
        var context = this._context;
        return !context.hasOwnProperty(key) || context[key] === true;
    },
    deleteContext: function(contextId) {
        delete this._caches[contextId];
        this._context = {};
    },
    delete: function(key) {
        delete this._context[key];
    },
    clearAll: function() {
        this._caches = {};
    },
    getContext: function() {
        return this._context;
    },
    eachContext: function(cb, context) {
        var keys = Object.keys(this._caches);
        keys.forEach(function(key) {
            cb && cb.call(context, key);
        });
    },
    miss: function(key) {
        return !this._context.hasOwnProperty(key);
    }
};
$5f2dc45e40134abc$var$Cache.prototype.constructor = $5f2dc45e40134abc$var$Cache;
var $5f2dc45e40134abc$export$2e2bcd8739ae039 = $5f2dc45e40134abc$var$Cache;


/**
 * @constructor
 * @alias clay.Texture
 * @extends clay.core.Base
 */ var $4261427f149675a4$var$Texture = (0, $7c62670c05885275$export$2e2bcd8739ae039).extend(/** @lends clay.Texture# */ {
    /**
     * Texture width, readonly when the texture source is image
     * @type {number}
     */ width: 512,
    /**
     * Texture height, readonly when the texture source is image
     * @type {number}
     */ height: 512,
    /**
     * Texel data type.
     * Possible values:
     *  + {@link clay.Texture.UNSIGNED_BYTE}
     *  + {@link clay.Texture.HALF_FLOAT}
     *  + {@link clay.Texture.FLOAT}
     *  + {@link clay.Texture.UNSIGNED_INT_24_8_WEBGL}
     *  + {@link clay.Texture.UNSIGNED_INT}
     * @type {number}
     */ type: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).UNSIGNED_BYTE,
    /**
     * Format of texel data
     * Possible values:
     *  + {@link clay.Texture.RGBA}
     *  + {@link clay.Texture.DEPTH_COMPONENT}
     *  + {@link clay.Texture.DEPTH_STENCIL}
     * @type {number}
     */ format: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).RGBA,
    /**
     * Texture wrap. Default to be REPEAT.
     * Possible values:
     *  + {@link clay.Texture.CLAMP_TO_EDGE}
     *  + {@link clay.Texture.REPEAT}
     *  + {@link clay.Texture.MIRRORED_REPEAT}
     * @type {number}
     */ wrapS: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).REPEAT,
    /**
     * Texture wrap. Default to be REPEAT.
     * Possible values:
     *  + {@link clay.Texture.CLAMP_TO_EDGE}
     *  + {@link clay.Texture.REPEAT}
     *  + {@link clay.Texture.MIRRORED_REPEAT}
     * @type {number}
     */ wrapT: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).REPEAT,
    /**
     * Possible values:
     *  + {@link clay.Texture.NEAREST}
     *  + {@link clay.Texture.LINEAR}
     *  + {@link clay.Texture.NEAREST_MIPMAP_NEAREST}
     *  + {@link clay.Texture.LINEAR_MIPMAP_NEAREST}
     *  + {@link clay.Texture.NEAREST_MIPMAP_LINEAR}
     *  + {@link clay.Texture.LINEAR_MIPMAP_LINEAR}
     * @type {number}
     */ minFilter: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LINEAR_MIPMAP_LINEAR,
    /**
     * Possible values:
     *  + {@link clay.Texture.NEAREST}
     *  + {@link clay.Texture.LINEAR}
     * @type {number}
     */ magFilter: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LINEAR,
    /**
     * If enable mimap.
     * @type {boolean}
     */ useMipmap: true,
    /**
     * Anisotropic filtering, enabled if value is larger than 1
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EXT_texture_filter_anisotropic
     * @type {number}
     */ anisotropic: 1,
    // pixelStorei parameters, not available when texture is used as render target
    // http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml
    /**
     * If flip in y axis for given image source
     * @type {boolean}
     * @default true
     */ flipY: true,
    /**
     * A flag to indicate if texture source is sRGB
     */ sRGB: true,
    /**
     * @type {number}
     * @default 4
     */ unpackAlignment: 4,
    /**
     * @type {boolean}
     * @default false
     */ premultiplyAlpha: false,
    /**
     * Dynamic option for texture like video
     * @type {boolean}
     */ dynamic: false,
    NPOT: false,
    // PENDING
    // Init it here to avoid deoptimization when it's assigned in application dynamically
    __used: 0
}, function() {
    this._cache = new (0, $5f2dc45e40134abc$export$2e2bcd8739ae039)();
}, /** @lends clay.Texture.prototype */ {
    getWebGLTexture: function(renderer) {
        var _gl = renderer.gl;
        var cache = this._cache;
        cache.use(renderer.__uid__);
        if (cache.miss("webgl_texture")) // In a new gl context, create new texture and set dirty true
        cache.put("webgl_texture", _gl.createTexture());
        if (this.dynamic) this.update(renderer);
        else if (cache.isDirty()) {
            this.update(renderer);
            cache.fresh();
        }
        return cache.get("webgl_texture");
    },
    bind: function() {},
    unbind: function() {},
    /**
     * Mark texture is dirty and update in the next frame
     */ dirty: function() {
        if (this._cache) this._cache.dirtyAll();
    },
    update: function(renderer) {},
    // Update the common parameters of texture
    updateCommon: function(renderer) {
        var _gl = renderer.gl;
        _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, this.flipY);
        _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.premultiplyAlpha);
        _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, this.unpackAlignment);
        // Use of none-power of two texture
        // http://www.khronos.org/webgl/wiki/WebGL_and_OpenGL_Differences
        if (this.format === (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).DEPTH_COMPONENT) this.useMipmap = false;
        var sRGBExt = renderer.getGLExtension("EXT_sRGB");
        // Fallback
        if (this.format === $4261427f149675a4$var$Texture.SRGB && !sRGBExt) this.format = $4261427f149675a4$var$Texture.RGB;
        if (this.format === $4261427f149675a4$var$Texture.SRGB_ALPHA && !sRGBExt) this.format = $4261427f149675a4$var$Texture.RGBA;
        this.NPOT = !this.isPowerOfTwo();
    },
    getAvailableWrapS: function() {
        if (this.NPOT) return (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).CLAMP_TO_EDGE;
        return this.wrapS;
    },
    getAvailableWrapT: function() {
        if (this.NPOT) return (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).CLAMP_TO_EDGE;
        return this.wrapT;
    },
    getAvailableMinFilter: function() {
        var minFilter = this.minFilter;
        if (this.NPOT || !this.useMipmap) {
            if (minFilter === (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).NEAREST_MIPMAP_NEAREST || minFilter === (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).NEAREST_MIPMAP_LINEAR) return (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).NEAREST;
            else if (minFilter === (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LINEAR_MIPMAP_LINEAR || minFilter === (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LINEAR_MIPMAP_NEAREST) return (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LINEAR;
            else return minFilter;
        } else return minFilter;
    },
    getAvailableMagFilter: function() {
        return this.magFilter;
    },
    nextHighestPowerOfTwo: function(x) {
        --x;
        for(var i = 1; i < 32; i <<= 1)x = x | x >> i;
        return x + 1;
    },
    /**
     * @param  {clay.Renderer} renderer
     */ dispose: function(renderer) {
        var cache = this._cache;
        cache.use(renderer.__uid__);
        var webglTexture = cache.get("webgl_texture");
        if (webglTexture) renderer.gl.deleteTexture(webglTexture);
        cache.deleteContext(renderer.__uid__);
    },
    /**
     * Test if image of texture is valid and loaded.
     * @return {boolean}
     */ isRenderable: function() {},
    /**
     * Test if texture size is power of two
     * @return {boolean}
     */ isPowerOfTwo: function() {}
});
Object.defineProperty($4261427f149675a4$var$Texture.prototype, "width", {
    get: function() {
        return this._width;
    },
    set: function(value) {
        this._width = value;
    }
});
Object.defineProperty($4261427f149675a4$var$Texture.prototype, "height", {
    get: function() {
        return this._height;
    },
    set: function(value) {
        this._height = value;
    }
});
/* DataType */ /**
 * @type {number}
 */ $4261427f149675a4$var$Texture.BYTE = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).BYTE;
/**
 * @type {number}
 */ $4261427f149675a4$var$Texture.UNSIGNED_BYTE = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).UNSIGNED_BYTE;
/**
 * @type {number}
 */ $4261427f149675a4$var$Texture.SHORT = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).SHORT;
/**
 * @type {number}
 */ $4261427f149675a4$var$Texture.UNSIGNED_SHORT = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).UNSIGNED_SHORT;
/**
 * @type {number}
 */ $4261427f149675a4$var$Texture.INT = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).INT;
/**
 * @type {number}
 */ $4261427f149675a4$var$Texture.UNSIGNED_INT = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).UNSIGNED_INT;
/**
 * @type {number}
 */ $4261427f149675a4$var$Texture.FLOAT = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).FLOAT;
/**
 * @type {number}
 */ $4261427f149675a4$var$Texture.HALF_FLOAT = 0x8D61;
/**
 * UNSIGNED_INT_24_8_WEBGL for WEBGL_depth_texture extension
 * @type {number}
 */ $4261427f149675a4$var$Texture.UNSIGNED_INT_24_8_WEBGL = 34042;
/* PixelFormat */ /**
 * @type {number}
 */ $4261427f149675a4$var$Texture.DEPTH_COMPONENT = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).DEPTH_COMPONENT;
/**
 * @type {number}
 */ $4261427f149675a4$var$Texture.DEPTH_STENCIL = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).DEPTH_STENCIL;
/**
 * @type {number}
 */ $4261427f149675a4$var$Texture.ALPHA = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).ALPHA;
/**
 * @type {number}
 */ $4261427f149675a4$var$Texture.RGB = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).RGB;
/**
 * @type {number}
 */ $4261427f149675a4$var$Texture.RGBA = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).RGBA;
/**
 * @type {number}
 */ $4261427f149675a4$var$Texture.LUMINANCE = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LUMINANCE;
/**
 * @type {number}
 */ $4261427f149675a4$var$Texture.LUMINANCE_ALPHA = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LUMINANCE_ALPHA;
/**
 * @see https://www.khronos.org/registry/webgl/extensions/EXT_sRGB/
 * @type {number}
 */ $4261427f149675a4$var$Texture.SRGB = 0x8C40;
/**
 * @see https://www.khronos.org/registry/webgl/extensions/EXT_sRGB/
 * @type {number}
 */ $4261427f149675a4$var$Texture.SRGB_ALPHA = 0x8C42;
/* Compressed Texture */ $4261427f149675a4$var$Texture.COMPRESSED_RGB_S3TC_DXT1_EXT = 0x83F0;
$4261427f149675a4$var$Texture.COMPRESSED_RGBA_S3TC_DXT1_EXT = 0x83F1;
$4261427f149675a4$var$Texture.COMPRESSED_RGBA_S3TC_DXT3_EXT = 0x83F2;
$4261427f149675a4$var$Texture.COMPRESSED_RGBA_S3TC_DXT5_EXT = 0x83F3;
/* TextureMagFilter */ /**
 * @type {number}
 */ $4261427f149675a4$var$Texture.NEAREST = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).NEAREST;
/**
 * @type {number}
 */ $4261427f149675a4$var$Texture.LINEAR = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LINEAR;
/* TextureMinFilter */ /**
 * @type {number}
 */ $4261427f149675a4$var$Texture.NEAREST_MIPMAP_NEAREST = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).NEAREST_MIPMAP_NEAREST;
/**
 * @type {number}
 */ $4261427f149675a4$var$Texture.LINEAR_MIPMAP_NEAREST = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LINEAR_MIPMAP_NEAREST;
/**
 * @type {number}
 */ $4261427f149675a4$var$Texture.NEAREST_MIPMAP_LINEAR = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).NEAREST_MIPMAP_LINEAR;
/**
 * @type {number}
 */ $4261427f149675a4$var$Texture.LINEAR_MIPMAP_LINEAR = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LINEAR_MIPMAP_LINEAR;
/* TextureWrapMode */ /**
 * @type {number}
 */ $4261427f149675a4$var$Texture.REPEAT = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).REPEAT;
/**
 * @type {number}
 */ $4261427f149675a4$var$Texture.CLAMP_TO_EDGE = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).CLAMP_TO_EDGE;
/**
 * @type {number}
 */ $4261427f149675a4$var$Texture.MIRRORED_REPEAT = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).MIRRORED_REPEAT;
var $4261427f149675a4$export$2e2bcd8739ae039 = $4261427f149675a4$var$Texture;




/**
 * @constructor clay.Mesh
 * @extends clay.Renderable
 */ var $652fd5cc6a0444a2$var$Mesh = (0, $061a3619e6fe7819$export$2e2bcd8739ae039).extend(/** @lends clay.Mesh# */ {
    /**
     * Used when it is a skinned mesh
     * @type {clay.Skeleton}
     */ skeleton: null,
    /**
     * Joints indices Meshes can share the one skeleton instance and each mesh can use one part of joints. Joints indices indicate the index of joint in the skeleton instance
     * @type {number[]}
     */ joints: null
}, function() {
    if (!this.joints) this.joints = [];
}, {
    /**
     * Offset matrix used for multiple skinned mesh clone sharing one skeleton
     * @type {clay.Matrix4}
     */ offsetMatrix: null,
    isInstancedMesh: function() {
        return false;
    },
    isSkinnedMesh: function() {
        return !!(this.skeleton && this.joints && this.joints.length > 0);
    },
    clone: function() {
        var mesh = (0, $061a3619e6fe7819$export$2e2bcd8739ae039).prototype.clone.call(this);
        mesh.skeleton = this.skeleton;
        if (this.joints) mesh.joints = this.joints.slice();
        return mesh;
    }
});
// Enums
$652fd5cc6a0444a2$var$Mesh.POINTS = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).POINTS;
$652fd5cc6a0444a2$var$Mesh.LINES = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LINES;
$652fd5cc6a0444a2$var$Mesh.LINE_LOOP = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LINE_LOOP;
$652fd5cc6a0444a2$var$Mesh.LINE_STRIP = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LINE_STRIP;
$652fd5cc6a0444a2$var$Mesh.TRIANGLES = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).TRIANGLES;
$652fd5cc6a0444a2$var$Mesh.TRIANGLE_STRIP = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).TRIANGLE_STRIP;
$652fd5cc6a0444a2$var$Mesh.TRIANGLE_FAN = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).TRIANGLE_FAN;
$652fd5cc6a0444a2$var$Mesh.BACK = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).BACK;
$652fd5cc6a0444a2$var$Mesh.FRONT = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).FRONT;
$652fd5cc6a0444a2$var$Mesh.FRONT_AND_BACK = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).FRONT_AND_BACK;
$652fd5cc6a0444a2$var$Mesh.CW = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).CW;
$652fd5cc6a0444a2$var$Mesh.CCW = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).CCW;
var $652fd5cc6a0444a2$export$2e2bcd8739ae039 = $652fd5cc6a0444a2$var$Mesh;






var $dedf80f5f4c1bc61$var$mathUtil = {};
$dedf80f5f4c1bc61$var$mathUtil.isPowerOfTwo = function(value) {
    return (value & value - 1) === 0;
};
$dedf80f5f4c1bc61$var$mathUtil.nextPowerOfTwo = function(value) {
    value--;
    value |= value >> 1;
    value |= value >> 2;
    value |= value >> 4;
    value |= value >> 8;
    value |= value >> 16;
    value++;
    return value;
};
$dedf80f5f4c1bc61$var$mathUtil.nearestPowerOfTwo = function(value) {
    return Math.pow(2, Math.round(Math.log(value) / Math.LN2));
};
var $dedf80f5f4c1bc61$export$2e2bcd8739ae039 = $dedf80f5f4c1bc61$var$mathUtil;


var $b7751fad94c1afee$var$isPowerOfTwo = (0, $dedf80f5f4c1bc61$export$2e2bcd8739ae039).isPowerOfTwo;
function $b7751fad94c1afee$var$nearestPowerOfTwo(val) {
    return Math.pow(2, Math.round(Math.log(val) / Math.LN2));
}
function $b7751fad94c1afee$var$convertTextureToPowerOfTwo(texture, canvas) {
    // var canvas = document.createElement('canvas');
    var width = $b7751fad94c1afee$var$nearestPowerOfTwo(texture.width);
    var height = $b7751fad94c1afee$var$nearestPowerOfTwo(texture.height);
    canvas = canvas || document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    var ctx = canvas.getContext("2d");
    ctx.drawImage(texture.image, 0, 0, width, height);
    return canvas;
}
/**
 * @constructor clay.Texture2D
 * @extends clay.Texture
 *
 * @example
 *     ...
 *     var mat = new clay.Material({
 *         shader: clay.shader.library.get('clay.phong', 'diffuseMap')
 *     });
 *     var diffuseMap = new clay.Texture2D();
 *     diffuseMap.load('assets/textures/diffuse.jpg');
 *     mat.set('diffuseMap', diffuseMap);
 *     ...
 *     diffuseMap.success(function () {
 *         // Wait for the diffuse texture loaded
 *         animation.on('frame', function (frameTime) {
 *             renderer.render(scene, camera);
 *         });
 *     });
 */ var $b7751fad94c1afee$var$Texture2D = (0, $4261427f149675a4$export$2e2bcd8739ae039).extend(function() {
    return /** @lends clay.Texture2D# */ {
        /**
         * @type {?HTMLImageElement|HTMLCanvasElemnet}
         */ // TODO mark dirty when assigned.
        image: null,
        /**
         * Pixels data. Will be ignored if image is set.
         * @type {?Uint8Array|Float32Array}
         */ pixels: null,
        /**
         * @type {Array.<Object>}
         * @example
         *     [{
         *         image: mipmap0,
         *         pixels: null
         *     }, {
         *         image: mipmap1,
         *         pixels: null
         *     }, ....]
         */ mipmaps: [],
        /**
         * If convert texture to power-of-two
         * @type {boolean}
         */ convertToPOT: false
    };
}, {
    textureType: "texture2D",
    update: function(renderer) {
        var _gl = renderer.gl;
        _gl.bindTexture(_gl.TEXTURE_2D, this._cache.get("webgl_texture"));
        this.updateCommon(renderer);
        var glFormat = this.format;
        var glType = this.type;
        // Convert to pot is only available when using image/canvas/video element.
        var convertToPOT = !!(this.convertToPOT && !this.mipmaps.length && this.image && (this.wrapS === (0, $4261427f149675a4$export$2e2bcd8739ae039).REPEAT || this.wrapT === (0, $4261427f149675a4$export$2e2bcd8739ae039).REPEAT) && this.NPOT);
        _gl.texParameteri(_gl.TEXTURE_2D, _gl.TEXTURE_WRAP_S, convertToPOT ? this.wrapS : this.getAvailableWrapS());
        _gl.texParameteri(_gl.TEXTURE_2D, _gl.TEXTURE_WRAP_T, convertToPOT ? this.wrapT : this.getAvailableWrapT());
        _gl.texParameteri(_gl.TEXTURE_2D, _gl.TEXTURE_MAG_FILTER, convertToPOT ? this.magFilter : this.getAvailableMagFilter());
        _gl.texParameteri(_gl.TEXTURE_2D, _gl.TEXTURE_MIN_FILTER, convertToPOT ? this.minFilter : this.getAvailableMinFilter());
        var anisotropicExt = renderer.getGLExtension("EXT_texture_filter_anisotropic");
        if (anisotropicExt && this.anisotropic > 1) _gl.texParameterf(_gl.TEXTURE_2D, anisotropicExt.TEXTURE_MAX_ANISOTROPY_EXT, this.anisotropic);
        // Fallback to float type if browser don't have half float extension
        if (glType === 36193) {
            var halfFloatExt = renderer.getGLExtension("OES_texture_half_float");
            if (!halfFloatExt) glType = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).FLOAT;
        }
        if (this.mipmaps.length) {
            var width = this.width;
            var height = this.height;
            for(var i = 0; i < this.mipmaps.length; i++){
                var mipmap = this.mipmaps[i];
                this._updateTextureData(_gl, mipmap, i, width, height, glFormat, glType, false);
                width /= 2;
                height /= 2;
            }
        } else {
            this._updateTextureData(_gl, this, 0, this.width, this.height, glFormat, glType, convertToPOT);
            if (this.useMipmap && (!this.NPOT || convertToPOT)) _gl.generateMipmap(_gl.TEXTURE_2D);
        }
        _gl.bindTexture(_gl.TEXTURE_2D, null);
    },
    _updateTextureData: function(_gl, data, level, width, height, glFormat, glType, convertToPOT) {
        if (data.image) {
            var imgData = data.image;
            if (convertToPOT) {
                this._potCanvas = $b7751fad94c1afee$var$convertTextureToPowerOfTwo(this, this._potCanvas);
                imgData = this._potCanvas;
            }
            _gl.texImage2D(_gl.TEXTURE_2D, level, glFormat, glFormat, glType, imgData);
        } else // Can be used as a blank texture when writing render to texture(RTT)
        if (glFormat <= (0, $4261427f149675a4$export$2e2bcd8739ae039).COMPRESSED_RGBA_S3TC_DXT5_EXT && glFormat >= (0, $4261427f149675a4$export$2e2bcd8739ae039).COMPRESSED_RGB_S3TC_DXT1_EXT) _gl.compressedTexImage2D(_gl.TEXTURE_2D, level, glFormat, width, height, 0, data.pixels);
        else // Is a render target if pixels is null
        _gl.texImage2D(_gl.TEXTURE_2D, level, glFormat, width, height, 0, glFormat, glType, data.pixels);
    },
    /**
     * @param  {clay.Renderer} renderer
     * @memberOf clay.Texture2D.prototype
     */ generateMipmap: function(renderer) {
        var _gl = renderer.gl;
        if (this.useMipmap && !this.NPOT) {
            _gl.bindTexture(_gl.TEXTURE_2D, this._cache.get("webgl_texture"));
            _gl.generateMipmap(_gl.TEXTURE_2D);
        }
    },
    isPowerOfTwo: function() {
        return $b7751fad94c1afee$var$isPowerOfTwo(this.width) && $b7751fad94c1afee$var$isPowerOfTwo(this.height);
    },
    isRenderable: function() {
        if (this.image) return this.image.width > 0 && this.image.height > 0;
        else return !!(this.width && this.height);
    },
    bind: function(renderer) {
        renderer.gl.bindTexture(renderer.gl.TEXTURE_2D, this.getWebGLTexture(renderer));
    },
    unbind: function(renderer) {
        renderer.gl.bindTexture(renderer.gl.TEXTURE_2D, null);
    },
    load: function(src, crossOrigin) {
        var image = (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).createImage();
        if (crossOrigin) image.crossOrigin = crossOrigin;
        var self = this;
        image.onload = function() {
            self.dirty();
            self.trigger("success", self);
        };
        image.onerror = function() {
            self.trigger("error", self);
        };
        image.src = src;
        this.image = image;
        return this;
    }
});
Object.defineProperty($b7751fad94c1afee$var$Texture2D.prototype, "width", {
    get: function() {
        if (this.image) return this.image.width;
        return this._width;
    },
    set: function(value) {
        if (this.image) console.warn("Texture from image can't set width");
        else {
            if (this._width !== value) this.dirty();
            this._width = value;
        }
    }
});
Object.defineProperty($b7751fad94c1afee$var$Texture2D.prototype, "height", {
    get: function() {
        if (this.image) return this.image.height;
        return this._height;
    },
    set: function(value) {
        if (this.image) console.warn("Texture from image can't set height");
        else {
            if (this._height !== value) this.dirty();
            this._height = value;
        }
    }
});
var $b7751fad94c1afee$export$2e2bcd8739ae039 = $b7751fad94c1afee$var$Texture2D;














function $de9bf6aba6f4013c$var$getArrayCtorByType(type) {
    return ({
        "byte": (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).Int8Array,
        "ubyte": (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).Uint8Array,
        "short": (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).Int16Array,
        "ushort": (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).Uint16Array
    })[type] || (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).Float32Array;
}
function $de9bf6aba6f4013c$var$makeAttrKey(attrName) {
    return "attr_" + attrName;
}
/**
 * GeometryBase attribute
 * @alias clay.GeometryBase.Attribute
 * @constructor
 */ function $de9bf6aba6f4013c$var$Attribute(name, type, size, semantic) {
    /**
     * Attribute name
     * @type {string}
     */ this.name = name;
    /**
     * Attribute type
     * Possible values:
     *  + `'byte'`
     *  + `'ubyte'`
     *  + `'short'`
     *  + `'ushort'`
     *  + `'float'` Most commonly used.
     * @type {string}
     */ this.type = type;
    /**
     * Size of attribute component. 1 - 4.
     * @type {number}
     */ this.size = size;
    /**
     * Semantic of this attribute.
     * Possible values:
     *  + `'POSITION'`
     *  + `'NORMAL'`
     *  + `'BINORMAL'`
     *  + `'TANGENT'`
     *  + `'TEXCOORD'`
     *  + `'TEXCOORD_0'`
     *  + `'TEXCOORD_1'`
     *  + `'COLOR'`
     *  + `'JOINT'`
     *  + `'WEIGHT'`
     *
     * In shader, attribute with same semantic will be automatically mapped. For example:
     * ```glsl
     * attribute vec3 pos: POSITION
     * ```
     * will use the attribute value with semantic POSITION in geometry, no matter what name it used.
     * @type {string}
     */ this.semantic = semantic || "";
    /**
     * Value of the attribute.
     * @type {TypedArray}
     */ this.value = null;
    // Init getter setter
    switch(size){
        case 1:
            this.get = function(idx) {
                return this.value[idx];
            };
            this.set = function(idx, value) {
                this.value[idx] = value;
            };
            // Copy from source to target
            this.copy = function(target, source) {
                this.value[target] = this.value[target];
            };
            break;
        case 2:
            this.get = function(idx, out) {
                var arr = this.value;
                out[0] = arr[idx * 2];
                out[1] = arr[idx * 2 + 1];
                return out;
            };
            this.set = function(idx, val) {
                var arr = this.value;
                arr[idx * 2] = val[0];
                arr[idx * 2 + 1] = val[1];
            };
            this.copy = function(target, source) {
                var arr = this.value;
                source *= 2;
                target *= 2;
                arr[target] = arr[source];
                arr[target + 1] = arr[source + 1];
            };
            break;
        case 3:
            this.get = function(idx, out) {
                var idx3 = idx * 3;
                var arr = this.value;
                out[0] = arr[idx3];
                out[1] = arr[idx3 + 1];
                out[2] = arr[idx3 + 2];
                return out;
            };
            this.set = function(idx, val) {
                var idx3 = idx * 3;
                var arr = this.value;
                arr[idx3] = val[0];
                arr[idx3 + 1] = val[1];
                arr[idx3 + 2] = val[2];
            };
            this.copy = function(target, source) {
                var arr = this.value;
                source *= 3;
                target *= 3;
                arr[target] = arr[source];
                arr[target + 1] = arr[source + 1];
                arr[target + 2] = arr[source + 2];
            };
            break;
        case 4:
            this.get = function(idx, out) {
                var arr = this.value;
                var idx4 = idx * 4;
                out[0] = arr[idx4];
                out[1] = arr[idx4 + 1];
                out[2] = arr[idx4 + 2];
                out[3] = arr[idx4 + 3];
                return out;
            };
            this.set = function(idx, val) {
                var arr = this.value;
                var idx4 = idx * 4;
                arr[idx4] = val[0];
                arr[idx4 + 1] = val[1];
                arr[idx4 + 2] = val[2];
                arr[idx4 + 3] = val[3];
            };
            this.copy = function(target, source) {
                var arr = this.value;
                source *= 4;
                target *= 4;
                // copyWithin is extremely slow
                arr[target] = arr[source];
                arr[target + 1] = arr[source + 1];
                arr[target + 2] = arr[source + 2];
                arr[target + 3] = arr[source + 3];
            };
    }
}
/**
 * Set item value at give index. Second parameter val is number if size is 1
 * @function
 * @name clay.GeometryBase.Attribute#set
 * @param {number} idx
 * @param {number[]|number} val
 * @example
 * geometry.getAttribute('position').set(0, [1, 1, 1]);
 */ /**
 * Get item value at give index. Second parameter out is no need if size is 1
 * @function
 * @name clay.GeometryBase.Attribute#set
 * @param {number} idx
 * @param {number[]} [out]
 * @example
 * geometry.getAttribute('position').get(0, out);
 */ /**
 * Initialize attribute with given vertex count
 * @param {number} nVertex
 */ $de9bf6aba6f4013c$var$Attribute.prototype.init = function(nVertex) {
    if (!this.value || this.value.length !== nVertex * this.size) {
        var ArrayConstructor = $de9bf6aba6f4013c$var$getArrayCtorByType(this.type);
        this.value = new ArrayConstructor(nVertex * this.size);
    }
};
/**
 * Initialize attribute with given array. Which can be 1 dimensional or 2 dimensional
 * @param {Array} array
 * @example
 *  geometry.getAttribute('position').fromArray(
 *      [-1, 0, 0, 1, 0, 0, 0, 1, 0]
 *  );
 *  geometry.getAttribute('position').fromArray(
 *      [ [-1, 0, 0], [1, 0, 0], [0, 1, 0] ]
 *  );
 */ $de9bf6aba6f4013c$var$Attribute.prototype.fromArray = function(array) {
    var ArrayConstructor = $de9bf6aba6f4013c$var$getArrayCtorByType(this.type);
    var value;
    // Convert 2d array to flat
    if (array[0] && array[0].length) {
        var n = 0;
        var size = this.size;
        value = new ArrayConstructor(array.length * size);
        for(var i = 0; i < array.length; i++)for(var j = 0; j < size; j++)value[n++] = array[i][j];
    } else value = new ArrayConstructor(array);
    this.value = value;
};
$de9bf6aba6f4013c$var$Attribute.prototype.clone = function(copyValue) {
    var ret = new $de9bf6aba6f4013c$var$Attribute(this.name, this.type, this.size, this.semantic);
    // FIXME
    if (copyValue) console.warn("todo");
    return ret;
};
function $de9bf6aba6f4013c$var$AttributeBuffer(name, type, buffer, size, semantic) {
    this.name = name;
    this.type = type;
    this.buffer = buffer;
    this.size = size;
    this.semantic = semantic;
    // To be set in mesh
    // symbol in the shader
    this.symbol = "";
    // Needs remove flag
    this.needsRemove = false;
}
function $de9bf6aba6f4013c$var$IndicesBuffer(buffer) {
    this.buffer = buffer;
    this.count = 0;
}
/**
 * Base of all geometry. Use {@link clay.Geometry} for common 3D usage.
 * @constructor clay.GeometryBase
 * @extends clay.core.Base
 */ var $de9bf6aba6f4013c$var$GeometryBase = (0, $7c62670c05885275$export$2e2bcd8739ae039).extend(function() {
    return /** @lends clay.GeometryBase# */ {
        /**
         * Attributes of geometry.
         * @type {Object.<string, clay.GeometryBase.Attribute>}
         */ attributes: {},
        /**
         * Indices of geometry.
         * @type {Uint16Array|Uint32Array}
         */ indices: null,
        /**
         * Is vertices data dynamically updated.
         * Attributes value can't be changed after first render if dyanmic is false.
         * @type {boolean}
         */ dynamic: true,
        _enabledAttributes: null,
        // PENDING
        // Init it here to avoid deoptimization when it's assigned in application dynamically
        __used: 0
    };
}, function() {
    // Use cache
    this._cache = new (0, $5f2dc45e40134abc$export$2e2bcd8739ae039)();
    this._attributeList = Object.keys(this.attributes);
    this.__vaoCache = {};
}, /** @lends clay.GeometryBase.prototype */ {
    /**
     * Main attribute will be used to count vertex number
     * @type {string}
     */ mainAttribute: "",
    /**
     * User defined picking algorithm instead of default
     * triangle ray intersection
     * x, y are NDC.
     * ```typescript
     * (x, y, renderer, camera, renderable, out) => boolean
     * ```
     * @type {?Function}
     */ pick: null,
    /**
     * User defined ray picking algorithm instead of default
     * triangle ray intersection
     * ```typescript
     * (ray: clay.Ray, renderable: clay.Renderable, out: Array) => boolean
     * ```
     * @type {?Function}
     */ pickByRay: null,
    /**
     * Mark attributes and indices in geometry needs to update.
     * Usually called after you change the data in attributes.
     */ dirty: function() {
        var enabledAttributes = this.getEnabledAttributes();
        for(var i = 0; i < enabledAttributes.length; i++)this.dirtyAttribute(enabledAttributes[i]);
        this.dirtyIndices();
        this._enabledAttributes = null;
        this._cache.dirty("any");
    },
    /**
     * Mark the indices needs to update.
     */ dirtyIndices: function() {
        this._cache.dirtyAll("indices");
    },
    /**
     * Mark the attributes needs to update.
     * @param {string} [attrName]
     */ dirtyAttribute: function(attrName) {
        this._cache.dirtyAll($de9bf6aba6f4013c$var$makeAttrKey(attrName));
        this._cache.dirtyAll("attributes");
    },
    /**
     * Get indices of triangle at given index.
     * @param {number} idx
     * @param {Array.<number>} out
     * @return {Array.<number>}
     */ getTriangleIndices: function(idx, out) {
        if (idx < this.triangleCount && idx >= 0) {
            if (!out) out = [];
            var indices = this.indices;
            out[0] = indices[idx * 3];
            out[1] = indices[idx * 3 + 1];
            out[2] = indices[idx * 3 + 2];
            return out;
        }
    },
    /**
     * Set indices of triangle at given index.
     * @param {number} idx
     * @param {Array.<number>} arr
     */ setTriangleIndices: function(idx, arr) {
        var indices = this.indices;
        indices[idx * 3] = arr[0];
        indices[idx * 3 + 1] = arr[1];
        indices[idx * 3 + 2] = arr[2];
    },
    isUseIndices: function() {
        return !!this.indices;
    },
    /**
     * Initialize indices from an array.
     * @param {Array} array
     */ initIndicesFromArray: function(array) {
        var value;
        var ArrayConstructor = this.vertexCount > 0xffff ? (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).Uint32Array : (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).Uint16Array;
        // Convert 2d array to flat
        if (array[0] && array[0].length) {
            var n = 0;
            var size = 3;
            value = new ArrayConstructor(array.length * size);
            for(var i = 0; i < array.length; i++)for(var j = 0; j < size; j++)value[n++] = array[i][j];
        } else value = new ArrayConstructor(array);
        this.indices = value;
    },
    /**
     * Create a new attribute
     * @param {string} name
     * @param {string} type
     * @param {number} size
     * @param {string} [semantic]
     */ createAttribute: function(name, type, size, semantic) {
        var attrib = new $de9bf6aba6f4013c$var$Attribute(name, type, size, semantic);
        if (this.attributes[name]) this.removeAttribute(name);
        this.attributes[name] = attrib;
        this._attributeList.push(name);
        return attrib;
    },
    /**
     * Remove attribute
     * @param {string} name
     */ removeAttribute: function(name) {
        var attributeList = this._attributeList;
        var idx = attributeList.indexOf(name);
        if (idx >= 0) {
            attributeList.splice(idx, 1);
            delete this.attributes[name];
            return true;
        }
        return false;
    },
    /**
     * Get attribute
     * @param {string} name
     * @return {clay.GeometryBase.Attribute}
     */ getAttribute: function(name) {
        return this.attributes[name];
    },
    /**
     * Get enabled attributes name list
     * Attribute which has the same vertex number with position is treated as a enabled attribute
     * @return {string[]}
     */ getEnabledAttributes: function() {
        var enabledAttributes = this._enabledAttributes;
        var attributeList = this._attributeList;
        // Cache
        if (enabledAttributes) return enabledAttributes;
        var result = [];
        var nVertex = this.vertexCount;
        for(var i = 0; i < attributeList.length; i++){
            var name = attributeList[i];
            var attrib = this.attributes[name];
            if (attrib.value) {
                if (attrib.value.length === nVertex * attrib.size) result.push(name);
            }
        }
        this._enabledAttributes = result;
        return result;
    },
    getBufferChunks: function(renderer) {
        var cache = this._cache;
        cache.use(renderer.__uid__);
        var isAttributesDirty = cache.isDirty("attributes");
        var isIndicesDirty = cache.isDirty("indices");
        if (isAttributesDirty || isIndicesDirty) {
            this._updateBuffer(renderer.gl, isAttributesDirty, isIndicesDirty);
            var enabledAttributes = this.getEnabledAttributes();
            for(var i = 0; i < enabledAttributes.length; i++)cache.fresh($de9bf6aba6f4013c$var$makeAttrKey(enabledAttributes[i]));
            cache.fresh("attributes");
            cache.fresh("indices");
        }
        cache.fresh("any");
        return cache.get("chunks");
    },
    _updateBuffer: function(_gl, isAttributesDirty, isIndicesDirty) {
        var cache = this._cache;
        var chunks = cache.get("chunks");
        var firstUpdate = false;
        if (!chunks) {
            chunks = [];
            // Intialize
            chunks[0] = {
                attributeBuffers: [],
                indicesBuffer: null
            };
            cache.put("chunks", chunks);
            firstUpdate = true;
        }
        var chunk = chunks[0];
        var attributeBuffers = chunk.attributeBuffers;
        var indicesBuffer = chunk.indicesBuffer;
        if (isAttributesDirty || firstUpdate) {
            var attributeList = this.getEnabledAttributes();
            var attributeBufferMap = {};
            if (!firstUpdate) for(var i = 0; i < attributeBuffers.length; i++)attributeBufferMap[attributeBuffers[i].name] = attributeBuffers[i];
            // FIXME If some attributes removed
            for(var k = 0; k < attributeList.length; k++){
                var name = attributeList[k];
                var attribute = this.attributes[name];
                var bufferInfo;
                if (!firstUpdate) bufferInfo = attributeBufferMap[name];
                var buffer;
                if (bufferInfo) buffer = bufferInfo.buffer;
                else buffer = _gl.createBuffer();
                if (cache.isDirty($de9bf6aba6f4013c$var$makeAttrKey(name))) {
                    // Only update when they are dirty.
                    // TODO: Use BufferSubData?
                    _gl.bindBuffer(_gl.ARRAY_BUFFER, buffer);
                    _gl.bufferData(_gl.ARRAY_BUFFER, attribute.value, this.dynamic ? _gl.DYNAMIC_DRAW : _gl.STATIC_DRAW);
                }
                attributeBuffers[k] = new $de9bf6aba6f4013c$var$AttributeBuffer(name, attribute.type, buffer, attribute.size, attribute.semantic);
            }
            // Remove unused attributes buffers.
            // PENDING
            for(var i = k; i < attributeBuffers.length; i++)_gl.deleteBuffer(attributeBuffers[i].buffer);
            attributeBuffers.length = k;
        }
        if (this.isUseIndices() && (isIndicesDirty || firstUpdate)) {
            if (!indicesBuffer) {
                indicesBuffer = new $de9bf6aba6f4013c$var$IndicesBuffer(_gl.createBuffer());
                chunk.indicesBuffer = indicesBuffer;
            }
            indicesBuffer.count = this.indices.length;
            _gl.bindBuffer(_gl.ELEMENT_ARRAY_BUFFER, indicesBuffer.buffer);
            _gl.bufferData(_gl.ELEMENT_ARRAY_BUFFER, this.indices, this.dynamic ? _gl.DYNAMIC_DRAW : _gl.STATIC_DRAW);
        }
    },
    /**
     * Dispose geometry data in GL context.
     * @param {clay.Renderer} renderer
     */ dispose: function(renderer) {
        var cache = this._cache;
        cache.use(renderer.__uid__);
        var chunks = cache.get("chunks");
        if (chunks) for(var c = 0; c < chunks.length; c++){
            var chunk = chunks[c];
            for(var k = 0; k < chunk.attributeBuffers.length; k++){
                var attribs = chunk.attributeBuffers[k];
                renderer.gl.deleteBuffer(attribs.buffer);
            }
            if (chunk.indicesBuffer) renderer.gl.deleteBuffer(chunk.indicesBuffer.buffer);
        }
        if (this.__vaoCache) {
            var vaoExt = renderer.getGLExtension("OES_vertex_array_object");
            for(var id in this.__vaoCache){
                var vao = this.__vaoCache[id].vao;
                if (vao) vaoExt.deleteVertexArrayOES(vao);
            }
        }
        this.__vaoCache = {};
        cache.deleteContext(renderer.__uid__);
    }
});
if (Object.defineProperty) {
    /**
     * @name clay.GeometryBase#vertexCount
     * @type {number}
     * @readOnly
     */ Object.defineProperty($de9bf6aba6f4013c$var$GeometryBase.prototype, "vertexCount", {
        enumerable: false,
        get: function() {
            var mainAttribute = this.attributes[this.mainAttribute];
            if (!mainAttribute) mainAttribute = this.attributes[this._attributeList[0]];
            if (!mainAttribute || !mainAttribute.value) return 0;
            return mainAttribute.value.length / mainAttribute.size;
        }
    });
    /**
     * @name clay.GeometryBase#triangleCount
     * @type {number}
     * @readOnly
     */ Object.defineProperty($de9bf6aba6f4013c$var$GeometryBase.prototype, "triangleCount", {
        enumerable: false,
        get: function() {
            var indices = this.indices;
            if (!indices) return 0;
            else return indices.length / 3;
        }
    });
}
$de9bf6aba6f4013c$var$GeometryBase.STATIC_DRAW = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).STATIC_DRAW;
$de9bf6aba6f4013c$var$GeometryBase.DYNAMIC_DRAW = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).DYNAMIC_DRAW;
$de9bf6aba6f4013c$var$GeometryBase.STREAM_DRAW = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).STREAM_DRAW;
$de9bf6aba6f4013c$var$GeometryBase.AttributeBuffer = $de9bf6aba6f4013c$var$AttributeBuffer;
$de9bf6aba6f4013c$var$GeometryBase.IndicesBuffer = $de9bf6aba6f4013c$var$IndicesBuffer;
$de9bf6aba6f4013c$var$GeometryBase.Attribute = $de9bf6aba6f4013c$var$Attribute;
var $de9bf6aba6f4013c$export$2e2bcd8739ae039 = $de9bf6aba6f4013c$var$GeometryBase;


var $c75c69a759bf7591$var$vec3Create = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create;
var $c75c69a759bf7591$var$vec3Add = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).add;
var $c75c69a759bf7591$var$vec3Set = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).set;
var $c75c69a759bf7591$var$Attribute = (0, $de9bf6aba6f4013c$export$2e2bcd8739ae039).Attribute;
/**
 * Geometry in ClayGL contains vertex attributes of mesh. These vertex attributes will be finally provided to the {@link clay.Shader}.
 * Different {@link clay.Shader} needs different attributes. Here is a list of attributes used in the builtin shaders.
 *
 * + position: `clay.basic`, `clay.lambert`, `clay.standard`
 * + texcoord0: `clay.basic`, `clay.lambert`, `clay.standard`
 * + color: `clay.basic`, `clay.lambert`, `clay.standard`
 * + weight: `clay.basic`, `clay.lambert`, `clay.standard`
 * + joint: `clay.basic`, `clay.lambert`, `clay.standard`
 * + normal: `clay.lambert`, `clay.standard`
 * + tangent: `clay.standard`
 *
 * #### Create a procedural geometry
 *
 * ClayGL provides a couple of builtin procedural geometries. Inlcuding:
 *
 *  + {@link clay.geometry.Cube}
 *  + {@link clay.geometry.Sphere}
 *  + {@link clay.geometry.Plane}
 *  + {@link clay.geometry.Cylinder}
 *  + {@link clay.geometry.Cone}
 *  + {@link clay.geometry.ParametricSurface}
 *
 * It's simple to create a basic geometry with these classes.
 *
```js
var sphere = new clay.geometry.Sphere({
    radius: 2
});
```
 *
 * #### Create the geometry data by yourself
 *
 * Usually the vertex attributes data are created by the {@link clay.loader.GLTF} or procedural geometries like {@link clay.geometry.Sphere}.
 * Besides these, you can create the data manually. Here is a simple example to create a triangle.
```js
var TRIANGLE_POSITIONS = [
    [-0.5, -0.5, 0],
    [0.5, -0.5, 0],
    [0, 0.5, 0]
];
var geometry = new clay.StaticGeometryBase();
// Add triangle vertices to position attribute.
geometry.attributes.position.fromArray(TRIANGLE_POSITIONS);
```
 * Then you can use the utility methods like `generateVertexNormals`, `generateTangents` to create the remaining necessary attributes.
 *
 *
 * #### Use with custom shaders
 *
 * If you wan't to write custom shaders. Don't forget to add SEMANTICS to these attributes. For example
 *
 ```glsl
uniform mat4 worldViewProjection : WORLDVIEWPROJECTION;
uniform mat4 worldInverseTranspose : WORLDINVERSETRANSPOSE;
uniform mat4 world : WORLD;

attribute vec3 position : POSITION;
attribute vec2 texcoord : TEXCOORD_0;
attribute vec3 normal : NORMAL;
```
 * These `POSITION`, `TEXCOORD_0`, `NORMAL` are SEMANTICS which will map the attributes in shader to the attributes in the GeometryBase
 *
 * Available attributes SEMANTICS includes `POSITION`, `TEXCOORD_0`, `TEXCOORD_1` `NORMAL`, `TANGENT`, `COLOR`, `WEIGHT`, `JOINT`.
 *
 *
 * @constructor clay.Geometry
 * @extends clay.GeometryBase
 */ var $c75c69a759bf7591$var$Geometry = (0, $de9bf6aba6f4013c$export$2e2bcd8739ae039).extend(function() {
    return /** @lends clay.Geometry# */ {
        /**
         * Attributes of geometry. Including:
         *  + `position`
         *  + `texcoord0`
         *  + `texcoord1`
         *  + `normal`
         *  + `tangent`
         *  + `color`
         *  + `weight`
         *  + `joint`
         *  + `barycentric`
         *
         * @type {Object.<string, clay.Geometry.Attribute>}
         */ attributes: {
            position: new $c75c69a759bf7591$var$Attribute("position", "float", 3, "POSITION"),
            texcoord0: new $c75c69a759bf7591$var$Attribute("texcoord0", "float", 2, "TEXCOORD_0"),
            texcoord1: new $c75c69a759bf7591$var$Attribute("texcoord1", "float", 2, "TEXCOORD_1"),
            normal: new $c75c69a759bf7591$var$Attribute("normal", "float", 3, "NORMAL"),
            tangent: new $c75c69a759bf7591$var$Attribute("tangent", "float", 4, "TANGENT"),
            color: new $c75c69a759bf7591$var$Attribute("color", "float", 4, "COLOR"),
            // Skinning attributes
            // Each vertex can be bind to 4 bones, because the
            // sum of weights is 1, so the weights is stored in vec3 and the last
            // can be calculated by 1-w.x-w.y-w.z
            weight: new $c75c69a759bf7591$var$Attribute("weight", "float", 3, "WEIGHT"),
            joint: new $c75c69a759bf7591$var$Attribute("joint", "float", 4, "JOINT"),
            // For wireframe display
            // http://codeflow.org/entries/2012/aug/02/easy-wireframe-display-with-barycentric-coordinates/
            barycentric: new $c75c69a759bf7591$var$Attribute("barycentric", "float", 3, null)
        },
        /**
         * Calculated bounding box of geometry.
         * @type {clay.BoundingBox}
         */ boundingBox: null
    };
}, /** @lends clay.Geometry.prototype */ {
    mainAttribute: "position",
    /**
     * Update boundingBox of Geometry
     */ updateBoundingBox: function() {
        var bbox = this.boundingBox;
        if (!bbox) bbox = this.boundingBox = new (0, $39676d59fa1158f6$export$2e2bcd8739ae039)();
        var posArr = this.attributes.position.value;
        if (posArr && posArr.length) {
            var min = bbox.min;
            var max = bbox.max;
            var minArr = min.array;
            var maxArr = max.array;
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).set(minArr, posArr[0], posArr[1], posArr[2]);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).set(maxArr, posArr[0], posArr[1], posArr[2]);
            for(var i = 3; i < posArr.length;){
                var x = posArr[i++];
                var y = posArr[i++];
                var z = posArr[i++];
                if (x < minArr[0]) minArr[0] = x;
                if (y < minArr[1]) minArr[1] = y;
                if (z < minArr[2]) minArr[2] = z;
                if (x > maxArr[0]) maxArr[0] = x;
                if (y > maxArr[1]) maxArr[1] = y;
                if (z > maxArr[2]) maxArr[2] = z;
            }
            min._dirty = true;
            max._dirty = true;
        }
    },
    /**
     * Generate normals per vertex.
     */ generateVertexNormals: function() {
        if (!this.vertexCount) return;
        var indices = this.indices;
        var attributes = this.attributes;
        var positions = attributes.position.value;
        var normals = attributes.normal.value;
        if (!normals || normals.length !== positions.length) normals = attributes.normal.value = new (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).Float32Array(positions.length);
        else // Reset
        for(var i = 0; i < normals.length; i++)normals[i] = 0;
        var p1 = $c75c69a759bf7591$var$vec3Create();
        var p2 = $c75c69a759bf7591$var$vec3Create();
        var p3 = $c75c69a759bf7591$var$vec3Create();
        var v21 = $c75c69a759bf7591$var$vec3Create();
        var v32 = $c75c69a759bf7591$var$vec3Create();
        var n = $c75c69a759bf7591$var$vec3Create();
        var len = indices ? indices.length : this.vertexCount;
        var i1, i2, i3;
        for(var f = 0; f < len;){
            if (indices) {
                i1 = indices[f++];
                i2 = indices[f++];
                i3 = indices[f++];
            } else {
                i1 = f++;
                i2 = f++;
                i3 = f++;
            }
            $c75c69a759bf7591$var$vec3Set(p1, positions[i1 * 3], positions[i1 * 3 + 1], positions[i1 * 3 + 2]);
            $c75c69a759bf7591$var$vec3Set(p2, positions[i2 * 3], positions[i2 * 3 + 1], positions[i2 * 3 + 2]);
            $c75c69a759bf7591$var$vec3Set(p3, positions[i3 * 3], positions[i3 * 3 + 1], positions[i3 * 3 + 2]);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).sub(v21, p1, p2);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).sub(v32, p2, p3);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).cross(n, v21, v32);
            // Already be weighted by the triangle area
            for(var i = 0; i < 3; i++){
                normals[i1 * 3 + i] = normals[i1 * 3 + i] + n[i];
                normals[i2 * 3 + i] = normals[i2 * 3 + i] + n[i];
                normals[i3 * 3 + i] = normals[i3 * 3 + i] + n[i];
            }
        }
        for(var i = 0; i < normals.length;){
            $c75c69a759bf7591$var$vec3Set(n, normals[i], normals[i + 1], normals[i + 2]);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).normalize(n, n);
            normals[i++] = n[0];
            normals[i++] = n[1];
            normals[i++] = n[2];
        }
        this.dirty();
    },
    /**
     * Generate normals per face.
     */ generateFaceNormals: function() {
        if (!this.vertexCount) return;
        if (!this.isUniqueVertex()) this.generateUniqueVertex();
        var indices = this.indices;
        var attributes = this.attributes;
        var positions = attributes.position.value;
        var normals = attributes.normal.value;
        var p1 = $c75c69a759bf7591$var$vec3Create();
        var p2 = $c75c69a759bf7591$var$vec3Create();
        var p3 = $c75c69a759bf7591$var$vec3Create();
        var v21 = $c75c69a759bf7591$var$vec3Create();
        var v32 = $c75c69a759bf7591$var$vec3Create();
        var n = $c75c69a759bf7591$var$vec3Create();
        if (!normals) normals = attributes.normal.value = new Float32Array(positions.length);
        var len = indices ? indices.length : this.vertexCount;
        var i1, i2, i3;
        for(var f = 0; f < len;){
            if (indices) {
                i1 = indices[f++];
                i2 = indices[f++];
                i3 = indices[f++];
            } else {
                i1 = f++;
                i2 = f++;
                i3 = f++;
            }
            $c75c69a759bf7591$var$vec3Set(p1, positions[i1 * 3], positions[i1 * 3 + 1], positions[i1 * 3 + 2]);
            $c75c69a759bf7591$var$vec3Set(p2, positions[i2 * 3], positions[i2 * 3 + 1], positions[i2 * 3 + 2]);
            $c75c69a759bf7591$var$vec3Set(p3, positions[i3 * 3], positions[i3 * 3 + 1], positions[i3 * 3 + 2]);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).sub(v21, p1, p2);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).sub(v32, p2, p3);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).cross(n, v21, v32);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).normalize(n, n);
            for(var i = 0; i < 3; i++){
                normals[i1 * 3 + i] = n[i];
                normals[i2 * 3 + i] = n[i];
                normals[i3 * 3 + i] = n[i];
            }
        }
        this.dirty();
    },
    /**
     * Generate tangents attributes.
     */ generateTangents: function() {
        if (!this.vertexCount) return;
        var nVertex = this.vertexCount;
        var attributes = this.attributes;
        if (!attributes.tangent.value) attributes.tangent.value = new Float32Array(nVertex * 4);
        var texcoords = attributes.texcoord0.value;
        var positions = attributes.position.value;
        var tangents = attributes.tangent.value;
        var normals = attributes.normal.value;
        if (!texcoords) {
            console.warn("Geometry without texcoords can't generate tangents.");
            return;
        }
        var tan1 = [];
        var tan2 = [];
        for(var i = 0; i < nVertex; i++){
            tan1[i] = [
                0.0,
                0.0,
                0.0
            ];
            tan2[i] = [
                0.0,
                0.0,
                0.0
            ];
        }
        var sdir = [
            0.0,
            0.0,
            0.0
        ];
        var tdir = [
            0.0,
            0.0,
            0.0
        ];
        var indices = this.indices;
        var len = indices ? indices.length : this.vertexCount;
        var i1, i2, i3;
        for(var i = 0; i < len;){
            if (indices) {
                i1 = indices[i++];
                i2 = indices[i++];
                i3 = indices[i++];
            } else {
                i1 = i++;
                i2 = i++;
                i3 = i++;
            }
            var st1s = texcoords[i1 * 2], st2s = texcoords[i2 * 2], st3s = texcoords[i3 * 2], st1t = texcoords[i1 * 2 + 1], st2t = texcoords[i2 * 2 + 1], st3t = texcoords[i3 * 2 + 1], p1x = positions[i1 * 3], p2x = positions[i2 * 3], p3x = positions[i3 * 3], p1y = positions[i1 * 3 + 1], p2y = positions[i2 * 3 + 1], p3y = positions[i3 * 3 + 1], p1z = positions[i1 * 3 + 2], p2z = positions[i2 * 3 + 2], p3z = positions[i3 * 3 + 2];
            var x1 = p2x - p1x, x2 = p3x - p1x, y1 = p2y - p1y, y2 = p3y - p1y, z1 = p2z - p1z, z2 = p3z - p1z;
            var s1 = st2s - st1s, s2 = st3s - st1s, t1 = st2t - st1t, t2 = st3t - st1t;
            var r = 1.0 / (s1 * t2 - t1 * s2);
            sdir[0] = (t2 * x1 - t1 * x2) * r;
            sdir[1] = (t2 * y1 - t1 * y2) * r;
            sdir[2] = (t2 * z1 - t1 * z2) * r;
            tdir[0] = (s1 * x2 - s2 * x1) * r;
            tdir[1] = (s1 * y2 - s2 * y1) * r;
            tdir[2] = (s1 * z2 - s2 * z1) * r;
            $c75c69a759bf7591$var$vec3Add(tan1[i1], tan1[i1], sdir);
            $c75c69a759bf7591$var$vec3Add(tan1[i2], tan1[i2], sdir);
            $c75c69a759bf7591$var$vec3Add(tan1[i3], tan1[i3], sdir);
            $c75c69a759bf7591$var$vec3Add(tan2[i1], tan2[i1], tdir);
            $c75c69a759bf7591$var$vec3Add(tan2[i2], tan2[i2], tdir);
            $c75c69a759bf7591$var$vec3Add(tan2[i3], tan2[i3], tdir);
        }
        var tmp = $c75c69a759bf7591$var$vec3Create();
        var nCrossT = $c75c69a759bf7591$var$vec3Create();
        var n = $c75c69a759bf7591$var$vec3Create();
        for(var i = 0; i < nVertex; i++){
            n[0] = normals[i * 3];
            n[1] = normals[i * 3 + 1];
            n[2] = normals[i * 3 + 2];
            var t = tan1[i];
            // Gram-Schmidt orthogonalize
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scale(tmp, n, (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(n, t));
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).sub(tmp, t, tmp);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).normalize(tmp, tmp);
            // Calculate handedness.
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).cross(nCrossT, n, t);
            tangents[i * 4] = tmp[0];
            tangents[i * 4 + 1] = tmp[1];
            tangents[i * 4 + 2] = tmp[2];
            // PENDING can config ?
            tangents[i * 4 + 3] = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(nCrossT, tan2[i]) < 0.0 ? -1 : 1.0;
        }
        this.dirty();
    },
    /**
     * If vertices are not shared by different indices.
     */ isUniqueVertex: function() {
        if (this.isUseIndices()) return this.vertexCount === this.indices.length;
        else return true;
    },
    /**
     * Create a unique vertex for each index.
     */ generateUniqueVertex: function() {
        if (!this.vertexCount || !this.indices) return;
        if (this.indices.length > 0xffff) this.indices = new (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).Uint32Array(this.indices);
        var attributes = this.attributes;
        var indices = this.indices;
        var attributeNameList = this.getEnabledAttributes();
        var oldAttrValues = {};
        for(var a = 0; a < attributeNameList.length; a++){
            var name = attributeNameList[a];
            oldAttrValues[name] = attributes[name].value;
            attributes[name].init(this.indices.length);
        }
        var cursor = 0;
        for(var i = 0; i < indices.length; i++){
            var ii = indices[i];
            for(var a = 0; a < attributeNameList.length; a++){
                var name = attributeNameList[a];
                var array = attributes[name].value;
                var size = attributes[name].size;
                for(var k = 0; k < size; k++)array[cursor * size + k] = oldAttrValues[name][ii * size + k];
            }
            indices[i] = cursor;
            cursor++;
        }
        this.dirty();
    },
    /**
     * Generate barycentric coordinates for wireframe draw.
     */ generateBarycentric: function() {
        if (!this.vertexCount) return;
        if (!this.isUniqueVertex()) this.generateUniqueVertex();
        var attributes = this.attributes;
        var array = attributes.barycentric.value;
        var indices = this.indices;
        // Already existed;
        if (array && array.length === indices.length * 3) return;
        array = attributes.barycentric.value = new Float32Array(indices.length * 3);
        for(var i = 0; i < (indices ? indices.length : this.vertexCount / 3);)for(var j = 0; j < 3; j++){
            var ii = indices ? indices[i++] : i * 3 + j;
            array[ii * 3 + j] = 1;
        }
        this.dirty();
    },
    /**
     * Apply transform to geometry attributes.
     * @param {clay.Matrix4} matrix
     */ applyTransform: function(matrix) {
        var attributes = this.attributes;
        var positions = attributes.position.value;
        var normals = attributes.normal.value;
        var tangents = attributes.tangent.value;
        matrix = matrix.array;
        // Normal Matrix
        var inverseTransposeMatrix = (0, $0020ce97b75275ae$export$2e2bcd8739ae039).create();
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).invert(inverseTransposeMatrix, matrix);
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).transpose(inverseTransposeMatrix, inverseTransposeMatrix);
        var vec3TransformMat4 = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).transformMat4;
        var vec3ForEach = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).forEach;
        vec3ForEach(positions, 3, 0, null, vec3TransformMat4, matrix);
        if (normals) vec3ForEach(normals, 3, 0, null, vec3TransformMat4, inverseTransposeMatrix);
        if (tangents) vec3ForEach(tangents, 4, 0, null, vec3TransformMat4, inverseTransposeMatrix);
        if (this.boundingBox) this.updateBoundingBox();
    },
    /**
     * Dispose geometry data in GL context.
     * @param {clay.Renderer} renderer
     */ dispose: function(renderer) {
        var cache = this._cache;
        cache.use(renderer.__uid__);
        var chunks = cache.get("chunks");
        if (chunks) for(var c = 0; c < chunks.length; c++){
            var chunk = chunks[c];
            for(var k = 0; k < chunk.attributeBuffers.length; k++){
                var attribs = chunk.attributeBuffers[k];
                renderer.gl.deleteBuffer(attribs.buffer);
            }
            if (chunk.indicesBuffer) renderer.gl.deleteBuffer(chunk.indicesBuffer.buffer);
        }
        if (this.__vaoCache) {
            var vaoExt = renderer.getGLExtension("OES_vertex_array_object");
            for(var id in this.__vaoCache){
                var vao = this.__vaoCache[id].vao;
                if (vao) vaoExt.deleteVertexArrayOES(vao);
            }
        }
        this.__vaoCache = {};
        cache.deleteContext(renderer.__uid__);
    }
});
$c75c69a759bf7591$var$Geometry.STATIC_DRAW = (0, $de9bf6aba6f4013c$export$2e2bcd8739ae039).STATIC_DRAW;
$c75c69a759bf7591$var$Geometry.DYNAMIC_DRAW = (0, $de9bf6aba6f4013c$export$2e2bcd8739ae039).DYNAMIC_DRAW;
$c75c69a759bf7591$var$Geometry.STREAM_DRAW = (0, $de9bf6aba6f4013c$export$2e2bcd8739ae039).STREAM_DRAW;
$c75c69a759bf7591$var$Geometry.AttributeBuffer = (0, $de9bf6aba6f4013c$export$2e2bcd8739ae039).AttributeBuffer;
$c75c69a759bf7591$var$Geometry.IndicesBuffer = (0, $de9bf6aba6f4013c$export$2e2bcd8739ae039).IndicesBuffer;
$c75c69a759bf7591$var$Geometry.Attribute = $c75c69a759bf7591$var$Attribute;
var $c75c69a759bf7591$export$2e2bcd8739ae039 = $c75c69a759bf7591$var$Geometry;






var $9bbe16fed94a4c71$export$2e2bcd8739ae039 = "vec3 calcAmbientSHLight(int idx, vec3 N) {\n int offset = 9 * idx;\n return ambientSHLightCoefficients[0]\n + ambientSHLightCoefficients[1] * N.x\n + ambientSHLightCoefficients[2] * N.y\n + ambientSHLightCoefficients[3] * N.z\n + ambientSHLightCoefficients[4] * N.x * N.z\n + ambientSHLightCoefficients[5] * N.z * N.y\n + ambientSHLightCoefficients[6] * N.y * N.x\n + ambientSHLightCoefficients[7] * (3.0 * N.z * N.z - 1.0)\n + ambientSHLightCoefficients[8] * (N.x * N.x - N.y * N.y);\n}";


var $4b59f3cd1efaed4e$var$uniformVec3Prefix = "uniform vec3 ";
var $4b59f3cd1efaed4e$var$uniformFloatPrefix = "uniform float ";
var $4b59f3cd1efaed4e$var$exportHeaderPrefix = "@export clay.header.";
var $4b59f3cd1efaed4e$var$exportEnd = "@end";
var $4b59f3cd1efaed4e$var$unconfigurable = ":unconfigurable;";
var $4b59f3cd1efaed4e$export$2e2bcd8739ae039 = [
    $4b59f3cd1efaed4e$var$exportHeaderPrefix + "directional_light",
    $4b59f3cd1efaed4e$var$uniformVec3Prefix + "directionalLightDirection[DIRECTIONAL_LIGHT_COUNT]" + $4b59f3cd1efaed4e$var$unconfigurable,
    $4b59f3cd1efaed4e$var$uniformVec3Prefix + "directionalLightColor[DIRECTIONAL_LIGHT_COUNT]" + $4b59f3cd1efaed4e$var$unconfigurable,
    $4b59f3cd1efaed4e$var$exportEnd,
    $4b59f3cd1efaed4e$var$exportHeaderPrefix + "ambient_light",
    $4b59f3cd1efaed4e$var$uniformVec3Prefix + "ambientLightColor[AMBIENT_LIGHT_COUNT]" + $4b59f3cd1efaed4e$var$unconfigurable,
    $4b59f3cd1efaed4e$var$exportEnd,
    $4b59f3cd1efaed4e$var$exportHeaderPrefix + "ambient_sh_light",
    $4b59f3cd1efaed4e$var$uniformVec3Prefix + "ambientSHLightColor[AMBIENT_SH_LIGHT_COUNT]" + $4b59f3cd1efaed4e$var$unconfigurable,
    $4b59f3cd1efaed4e$var$uniformVec3Prefix + "ambientSHLightCoefficients[AMBIENT_SH_LIGHT_COUNT * 9]" + $4b59f3cd1efaed4e$var$unconfigurable,
    (0, $9bbe16fed94a4c71$export$2e2bcd8739ae039),
    $4b59f3cd1efaed4e$var$exportEnd,
    $4b59f3cd1efaed4e$var$exportHeaderPrefix + "ambient_cubemap_light",
    $4b59f3cd1efaed4e$var$uniformVec3Prefix + "ambientCubemapLightColor[AMBIENT_CUBEMAP_LIGHT_COUNT]" + $4b59f3cd1efaed4e$var$unconfigurable,
    "uniform samplerCube ambientCubemapLightCubemap[AMBIENT_CUBEMAP_LIGHT_COUNT]" + $4b59f3cd1efaed4e$var$unconfigurable,
    "uniform sampler2D ambientCubemapLightBRDFLookup[AMBIENT_CUBEMAP_LIGHT_COUNT]" + $4b59f3cd1efaed4e$var$unconfigurable,
    $4b59f3cd1efaed4e$var$exportEnd,
    $4b59f3cd1efaed4e$var$exportHeaderPrefix + "point_light",
    $4b59f3cd1efaed4e$var$uniformVec3Prefix + "pointLightPosition[POINT_LIGHT_COUNT]" + $4b59f3cd1efaed4e$var$unconfigurable,
    $4b59f3cd1efaed4e$var$uniformFloatPrefix + "pointLightRange[POINT_LIGHT_COUNT]" + $4b59f3cd1efaed4e$var$unconfigurable,
    $4b59f3cd1efaed4e$var$uniformVec3Prefix + "pointLightColor[POINT_LIGHT_COUNT]" + $4b59f3cd1efaed4e$var$unconfigurable,
    $4b59f3cd1efaed4e$var$exportEnd,
    $4b59f3cd1efaed4e$var$exportHeaderPrefix + "spot_light",
    $4b59f3cd1efaed4e$var$uniformVec3Prefix + "spotLightPosition[SPOT_LIGHT_COUNT]" + $4b59f3cd1efaed4e$var$unconfigurable,
    $4b59f3cd1efaed4e$var$uniformVec3Prefix + "spotLightDirection[SPOT_LIGHT_COUNT]" + $4b59f3cd1efaed4e$var$unconfigurable,
    $4b59f3cd1efaed4e$var$uniformFloatPrefix + "spotLightRange[SPOT_LIGHT_COUNT]" + $4b59f3cd1efaed4e$var$unconfigurable,
    $4b59f3cd1efaed4e$var$uniformFloatPrefix + "spotLightUmbraAngleCosine[SPOT_LIGHT_COUNT]" + $4b59f3cd1efaed4e$var$unconfigurable,
    $4b59f3cd1efaed4e$var$uniformFloatPrefix + "spotLightPenumbraAngleCosine[SPOT_LIGHT_COUNT]" + $4b59f3cd1efaed4e$var$unconfigurable,
    $4b59f3cd1efaed4e$var$uniformFloatPrefix + "spotLightFalloffFactor[SPOT_LIGHT_COUNT]" + $4b59f3cd1efaed4e$var$unconfigurable,
    $4b59f3cd1efaed4e$var$uniformVec3Prefix + "spotLightColor[SPOT_LIGHT_COUNT]" + $4b59f3cd1efaed4e$var$unconfigurable,
    $4b59f3cd1efaed4e$var$exportEnd
].join("\n");


(0, $90e78c81ac16d455$export$2e2bcd8739ae039)["import"]((0, $4b59f3cd1efaed4e$export$2e2bcd8739ae039));
/**
 * @constructor clay.Light
 * @extends clay.Node
 */ var $252d8ff14b1b2fbf$var$Light = (0, $e02012a49e6aaac9$export$2e2bcd8739ae039).extend(function() {
    return /** @lends clay.Light# */ {
        /**
         * Light RGB color
         * @type {number[]}
         */ color: [
            1,
            1,
            1
        ],
        /**
         * Light intensity
         * @type {number}
         */ intensity: 1.0,
        // Config for shadow map
        /**
         * If light cast shadow
         * @type {boolean}
         */ castShadow: true,
        /**
         * Shadow map size
         * @type {number}
         */ shadowResolution: 512,
        /**
         * Light group, shader with same `lightGroup` will be affected
         *
         * Only useful in forward rendering
         * @type {number}
         */ group: 0
    };
}, /** @lends clay.Light.prototype. */ {
    /**
     * Light type
     * @type {string}
     * @memberOf clay.Light#
     */ type: "",
    /**
     * @return {clay.Light}
     * @memberOf clay.Light.prototype
     */ clone: function() {
        var light = (0, $e02012a49e6aaac9$export$2e2bcd8739ae039).prototype.clone.call(this);
        light.color = Array.prototype.slice.call(this.color);
        light.intensity = this.intensity;
        light.castShadow = this.castShadow;
        light.shadowResolution = this.shadowResolution;
        return light;
    }
});
var $252d8ff14b1b2fbf$export$2e2bcd8739ae039 = $252d8ff14b1b2fbf$var$Light;









/**
 * @constructor
 * @alias clay.Plane
 * @param {clay.Vector3} [normal]
 * @param {number} [distance]
 */ var $4a62d5e175a73abf$var$Plane = function(normal, distance) {
    /**
     * Normal of the plane
     * @type {clay.Vector3}
     */ this.normal = normal || new (0, $27fea36417076c2d$export$2e2bcd8739ae039)(0, 1, 0);
    /**
     * Constant of the plane equation, used as distance to the origin
     * @type {number}
     */ this.distance = distance || 0;
};
$4a62d5e175a73abf$var$Plane.prototype = {
    constructor: $4a62d5e175a73abf$var$Plane,
    /**
     * Distance from a given point to the plane
     * @param  {clay.Vector3} point
     * @return {number}
     */ distanceToPoint: function(point) {
        return (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(point.array, this.normal.array) - this.distance;
    },
    /**
     * Calculate the projection point on the plane
     * @param  {clay.Vector3} point
     * @param  {clay.Vector3} out
     * @return {clay.Vector3}
     */ projectPoint: function(point, out) {
        if (!out) out = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
        var d = this.distanceToPoint(point);
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scaleAndAdd(out.array, point.array, this.normal.array, -d);
        out._dirty = true;
        return out;
    },
    /**
     * Normalize the plane's normal and calculate the distance
     */ normalize: function() {
        var invLen = 1 / (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).len(this.normal.array);
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scale(this.normal.array, invLen);
        this.distance *= invLen;
    },
    /**
     * If the plane intersect a frustum
     * @param  {clay.Frustum} Frustum
     * @return {boolean}
     */ intersectFrustum: function(frustum) {
        // Check if all coords of frustum is on plane all under plane
        var coords = frustum.vertices;
        var normal = this.normal.array;
        var onPlane = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(coords[0].array, normal) > this.distance;
        for(var i = 1; i < 8; i++){
            if ((0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(coords[i].array, normal) > this.distance != onPlane) return true;
        }
    },
    /**
     * Calculate the intersection point between plane and a given line
     * @function
     * @param {clay.Vector3} start start point of line
     * @param {clay.Vector3} end end point of line
     * @param {clay.Vector3} [out]
     * @return {clay.Vector3}
     */ intersectLine: function() {
        var rd = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
        return function(start, end, out) {
            var d0 = this.distanceToPoint(start);
            var d1 = this.distanceToPoint(end);
            if (d0 > 0 && d1 > 0 || d0 < 0 && d1 < 0) return null;
            // Ray intersection
            var pn = this.normal.array;
            var d = this.distance;
            var ro = start.array;
            // direction
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).sub(rd, end.array, start.array);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).normalize(rd, rd);
            var divider = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(pn, rd);
            // ray is parallel to the plane
            if (divider === 0) return null;
            if (!out) out = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
            var t = ((0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(pn, ro) - d) / divider;
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scaleAndAdd(out.array, ro, rd, -t);
            out._dirty = true;
            return out;
        };
    }(),
    /**
     * Apply an affine transform matrix to plane
     * @function
     * @return {clay.Matrix4}
     */ applyTransform: function() {
        var inverseTranspose = (0, $0020ce97b75275ae$export$2e2bcd8739ae039).create();
        var normalv4 = (0, $8f04521abcf907ba$export$2e2bcd8739ae039).create();
        var pointv4 = (0, $8f04521abcf907ba$export$2e2bcd8739ae039).create();
        pointv4[3] = 1;
        return function(m4) {
            m4 = m4.array;
            // Transform point on plane
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scale(pointv4, this.normal.array, this.distance);
            (0, $8f04521abcf907ba$export$2e2bcd8739ae039).transformMat4(pointv4, pointv4, m4);
            this.distance = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).dot(pointv4, this.normal.array);
            // Transform plane normal
            (0, $0020ce97b75275ae$export$2e2bcd8739ae039).invert(inverseTranspose, m4);
            (0, $0020ce97b75275ae$export$2e2bcd8739ae039).transpose(inverseTranspose, inverseTranspose);
            normalv4[3] = 0;
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).copy(normalv4, this.normal.array);
            (0, $8f04521abcf907ba$export$2e2bcd8739ae039).transformMat4(normalv4, normalv4, inverseTranspose);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).copy(this.normal.array, normalv4);
        };
    }(),
    /**
     * Copy from another plane
     * @param  {clay.Vector3} plane
     */ copy: function(plane) {
        (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).copy(this.normal.array, plane.normal.array);
        this.normal._dirty = true;
        this.distance = plane.distance;
    },
    /**
     * Clone a new plane
     * @return {clay.Plane}
     */ clone: function() {
        var plane = new $4a62d5e175a73abf$var$Plane();
        plane.copy(this);
        return plane;
    }
};
var $4a62d5e175a73abf$export$2e2bcd8739ae039 = $4a62d5e175a73abf$var$Plane;



var $81d01ecfe643f241$var$vec3Set = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).set;
var $81d01ecfe643f241$var$vec3Copy = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).copy;
var $81d01ecfe643f241$var$vec3TranformMat4 = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).transformMat4;
var $81d01ecfe643f241$var$mathMin = Math.min;
var $81d01ecfe643f241$var$mathMax = Math.max;
/**
 * @constructor
 * @alias clay.Frustum
 */ var $81d01ecfe643f241$var$Frustum = function() {
    /**
     * Eight planes to enclose the frustum
     * @type {clay.Plane[]}
     */ this.planes = [];
    for(var i = 0; i < 6; i++)this.planes.push(new (0, $4a62d5e175a73abf$export$2e2bcd8739ae039)());
    /**
     * Bounding box of frustum
     * @type {clay.BoundingBox}
     */ this.boundingBox = new (0, $39676d59fa1158f6$export$2e2bcd8739ae039)();
    /**
     * Eight vertices of frustum
     * @type {Float32Array[]}
     */ this.vertices = [];
    for(var i = 0; i < 8; i++)this.vertices[i] = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).fromValues(0, 0, 0);
};
$81d01ecfe643f241$var$Frustum.prototype = {
    // http://web.archive.org/web/20120531231005/http://crazyjoke.free.fr/doc/3D/plane%20extraction.pdf
    /**
     * Set frustum from a projection matrix
     * @param {clay.Matrix4} projectionMatrix
     */ setFromProjection: function(projectionMatrix) {
        var planes = this.planes;
        var m = projectionMatrix.array;
        var m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3];
        var m4 = m[4], m5 = m[5], m6 = m[6], m7 = m[7];
        var m8 = m[8], m9 = m[9], m10 = m[10], m11 = m[11];
        var m12 = m[12], m13 = m[13], m14 = m[14], m15 = m[15];
        // Update planes
        $81d01ecfe643f241$var$vec3Set(planes[0].normal.array, m3 - m0, m7 - m4, m11 - m8);
        planes[0].distance = -(m15 - m12);
        planes[0].normalize();
        $81d01ecfe643f241$var$vec3Set(planes[1].normal.array, m3 + m0, m7 + m4, m11 + m8);
        planes[1].distance = -(m15 + m12);
        planes[1].normalize();
        $81d01ecfe643f241$var$vec3Set(planes[2].normal.array, m3 + m1, m7 + m5, m11 + m9);
        planes[2].distance = -(m15 + m13);
        planes[2].normalize();
        $81d01ecfe643f241$var$vec3Set(planes[3].normal.array, m3 - m1, m7 - m5, m11 - m9);
        planes[3].distance = -(m15 - m13);
        planes[3].normalize();
        $81d01ecfe643f241$var$vec3Set(planes[4].normal.array, m3 - m2, m7 - m6, m11 - m10);
        planes[4].distance = -(m15 - m14);
        planes[4].normalize();
        $81d01ecfe643f241$var$vec3Set(planes[5].normal.array, m3 + m2, m7 + m6, m11 + m10);
        planes[5].distance = -(m15 + m14);
        planes[5].normalize();
        // Perspective projection
        var boundingBox = this.boundingBox;
        var vertices = this.vertices;
        if (m15 === 0) {
            var aspect = m5 / m0;
            var zNear = -m14 / (m10 - 1);
            var zFar = -m14 / (m10 + 1);
            var farY = -zFar / m5;
            var nearY = -zNear / m5;
            // Update bounding box
            boundingBox.min.set(-farY * aspect, -farY, zFar);
            boundingBox.max.set(farY * aspect, farY, zNear);
            // update vertices
            //--- min z
            // min x
            $81d01ecfe643f241$var$vec3Set(vertices[0], -farY * aspect, -farY, zFar);
            $81d01ecfe643f241$var$vec3Set(vertices[1], -farY * aspect, farY, zFar);
            // max x
            $81d01ecfe643f241$var$vec3Set(vertices[2], farY * aspect, -farY, zFar);
            $81d01ecfe643f241$var$vec3Set(vertices[3], farY * aspect, farY, zFar);
            //-- max z
            $81d01ecfe643f241$var$vec3Set(vertices[4], -nearY * aspect, -nearY, zNear);
            $81d01ecfe643f241$var$vec3Set(vertices[5], -nearY * aspect, nearY, zNear);
            $81d01ecfe643f241$var$vec3Set(vertices[6], nearY * aspect, -nearY, zNear);
            $81d01ecfe643f241$var$vec3Set(vertices[7], nearY * aspect, nearY, zNear);
        } else {
            var left = (-1 - m12) / m0;
            var right = (1 - m12) / m0;
            var top = (1 - m13) / m5;
            var bottom = (-1 - m13) / m5;
            var near = (-1 - m14) / m10;
            var far = (1 - m14) / m10;
            boundingBox.min.set(Math.min(left, right), Math.min(bottom, top), Math.min(far, near));
            boundingBox.max.set(Math.max(right, left), Math.max(top, bottom), Math.max(near, far));
            var min = boundingBox.min.array;
            var max = boundingBox.max.array;
            //--- min z
            // min x
            $81d01ecfe643f241$var$vec3Set(vertices[0], min[0], min[1], min[2]);
            $81d01ecfe643f241$var$vec3Set(vertices[1], min[0], max[1], min[2]);
            // max x
            $81d01ecfe643f241$var$vec3Set(vertices[2], max[0], min[1], min[2]);
            $81d01ecfe643f241$var$vec3Set(vertices[3], max[0], max[1], min[2]);
            //-- max z
            $81d01ecfe643f241$var$vec3Set(vertices[4], min[0], min[1], max[2]);
            $81d01ecfe643f241$var$vec3Set(vertices[5], min[0], max[1], max[2]);
            $81d01ecfe643f241$var$vec3Set(vertices[6], max[0], min[1], max[2]);
            $81d01ecfe643f241$var$vec3Set(vertices[7], max[0], max[1], max[2]);
        }
    },
    /**
     * Apply a affine transform matrix and set to the given bounding box
     * @function
     * @param {clay.BoundingBox}
     * @param {clay.Matrix4}
     * @return {clay.BoundingBox}
     */ getTransformedBoundingBox: function() {
        var tmpVec3 = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
        return function(bbox, matrix) {
            var vertices = this.vertices;
            var m4 = matrix.array;
            var min = bbox.min;
            var max = bbox.max;
            var minArr = min.array;
            var maxArr = max.array;
            var v = vertices[0];
            $81d01ecfe643f241$var$vec3TranformMat4(tmpVec3, v, m4);
            $81d01ecfe643f241$var$vec3Copy(minArr, tmpVec3);
            $81d01ecfe643f241$var$vec3Copy(maxArr, tmpVec3);
            for(var i = 1; i < 8; i++){
                v = vertices[i];
                $81d01ecfe643f241$var$vec3TranformMat4(tmpVec3, v, m4);
                minArr[0] = $81d01ecfe643f241$var$mathMin(tmpVec3[0], minArr[0]);
                minArr[1] = $81d01ecfe643f241$var$mathMin(tmpVec3[1], minArr[1]);
                minArr[2] = $81d01ecfe643f241$var$mathMin(tmpVec3[2], minArr[2]);
                maxArr[0] = $81d01ecfe643f241$var$mathMax(tmpVec3[0], maxArr[0]);
                maxArr[1] = $81d01ecfe643f241$var$mathMax(tmpVec3[1], maxArr[1]);
                maxArr[2] = $81d01ecfe643f241$var$mathMax(tmpVec3[2], maxArr[2]);
            }
            min._dirty = true;
            max._dirty = true;
            return bbox;
        };
    }()
};
var $81d01ecfe643f241$export$2e2bcd8739ae039 = $81d01ecfe643f241$var$Frustum;





/**
 * @constructor clay.Camera
 * @extends clay.Node
 */ var $abb2ad6f174841b9$var$Camera = (0, $e02012a49e6aaac9$export$2e2bcd8739ae039).extend(function() {
    return /** @lends clay.Camera# */ {
        /**
         * Camera projection matrix
         * @type {clay.Matrix4}
         */ projectionMatrix: new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)(),
        /**
         * Inverse of camera projection matrix
         * @type {clay.Matrix4}
         */ invProjectionMatrix: new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)(),
        /**
         * View matrix, equal to inverse of camera's world matrix
         * @type {clay.Matrix4}
         */ viewMatrix: new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)(),
        /**
         * Camera frustum in view space
         * @type {clay.Frustum}
         */ frustum: new (0, $81d01ecfe643f241$export$2e2bcd8739ae039)()
    };
}, function() {
    this.update(true);
}, /** @lends clay.Camera.prototype */ {
    update: function(force) {
        (0, $e02012a49e6aaac9$export$2e2bcd8739ae039).prototype.update.call(this, force);
        (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).invert(this.viewMatrix, this.worldTransform);
        this.updateProjectionMatrix();
        (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).invert(this.invProjectionMatrix, this.projectionMatrix);
        this.frustum.setFromProjection(this.projectionMatrix);
    },
    /**
     * Set camera view matrix
     */ setViewMatrix: function(viewMatrix) {
        (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).copy(this.viewMatrix, viewMatrix);
        (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).invert(this.worldTransform, viewMatrix);
        this.decomposeWorldTransform();
    },
    /**
     * Decompose camera projection matrix
     */ decomposeProjectionMatrix: function() {},
    /**
     * Set camera projection matrix
     * @param {clay.Matrix4} projectionMatrix
     */ setProjectionMatrix: function(projectionMatrix) {
        (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).copy(this.projectionMatrix, projectionMatrix);
        (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).invert(this.invProjectionMatrix, projectionMatrix);
        this.decomposeProjectionMatrix();
    },
    /**
     * Update projection matrix, called after update
     */ updateProjectionMatrix: function() {},
    /**
     * Cast a picking ray from camera near plane to far plane
     * @function
     * @param {clay.Vector2} ndc
     * @param {clay.Ray} [out]
     * @return {clay.Ray}
     */ castRay: function() {
        var v4 = (0, $8f04521abcf907ba$export$2e2bcd8739ae039).create();
        return function(ndc, out) {
            var ray = out !== undefined ? out : new (0, $65a5d9098f8e83b0$export$2e2bcd8739ae039)();
            var x = ndc.array[0];
            var y = ndc.array[1];
            (0, $8f04521abcf907ba$export$2e2bcd8739ae039).set(v4, x, y, -1, 1);
            (0, $8f04521abcf907ba$export$2e2bcd8739ae039).transformMat4(v4, v4, this.invProjectionMatrix.array);
            (0, $8f04521abcf907ba$export$2e2bcd8739ae039).transformMat4(v4, v4, this.worldTransform.array);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scale(ray.origin.array, v4, 1 / v4[3]);
            (0, $8f04521abcf907ba$export$2e2bcd8739ae039).set(v4, x, y, 1, 1);
            (0, $8f04521abcf907ba$export$2e2bcd8739ae039).transformMat4(v4, v4, this.invProjectionMatrix.array);
            (0, $8f04521abcf907ba$export$2e2bcd8739ae039).transformMat4(v4, v4, this.worldTransform.array);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scale(v4, v4, 1 / v4[3]);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).sub(ray.direction.array, v4, ray.origin.array);
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).normalize(ray.direction.array, ray.direction.array);
            ray.direction._dirty = true;
            ray.origin._dirty = true;
            return ray;
        };
    }()
});
var $abb2ad6f174841b9$export$2e2bcd8739ae039 = $abb2ad6f174841b9$var$Camera;







var $e49354c4f1efd6e1$var$IDENTITY = (0, $0020ce97b75275ae$export$2e2bcd8739ae039).create();
var $e49354c4f1efd6e1$var$WORLDVIEW = (0, $0020ce97b75275ae$export$2e2bcd8739ae039).create();
var $e49354c4f1efd6e1$var$programKeyCache = {};
function $e49354c4f1efd6e1$var$getProgramKey(lightNumbers) {
    var defineStr = [];
    var lightTypes = Object.keys(lightNumbers);
    lightTypes.sort();
    for(var i = 0; i < lightTypes.length; i++){
        var lightType = lightTypes[i];
        defineStr.push(lightType + " " + lightNumbers[lightType]);
    }
    var key = defineStr.join("\n");
    if ($e49354c4f1efd6e1$var$programKeyCache[key]) return $e49354c4f1efd6e1$var$programKeyCache[key];
    var id = (0, $b22fd57b6bfa77fb$export$2e2bcd8739ae039).genGUID();
    $e49354c4f1efd6e1$var$programKeyCache[key] = id;
    return id;
}
function $e49354c4f1efd6e1$var$RenderList() {
    this.opaque = [];
    this.transparent = [];
    this._opaqueCount = 0;
    this._transparentCount = 0;
}
$e49354c4f1efd6e1$var$RenderList.prototype.startCount = function() {
    this._opaqueCount = 0;
    this._transparentCount = 0;
};
$e49354c4f1efd6e1$var$RenderList.prototype.add = function(object, isTransparent) {
    if (isTransparent) this.transparent[this._transparentCount++] = object;
    else this.opaque[this._opaqueCount++] = object;
};
$e49354c4f1efd6e1$var$RenderList.prototype.endCount = function() {
    this.transparent.length = this._transparentCount;
    this.opaque.length = this._opaqueCount;
};
/**
 * @typedef {Object} clay.Scene.RenderList
 * @property {Array.<clay.Renderable>} opaque
 * @property {Array.<clay.Renderable>} transparent
 */ /**
 * @constructor clay.Scene
 * @extends clay.Node
 */ var $e49354c4f1efd6e1$var$Scene = (0, $e02012a49e6aaac9$export$2e2bcd8739ae039).extend(function() {
    return /** @lends clay.Scene# */ {
        /**
         * Global material of scene
         * @type {clay.Material}
         */ material: null,
        lights: [],
        /**
         * Scene bounding box in view space.
         * Used when camera needs to adujst the near and far plane automatically
         * so that the view frustum contains the visible objects as tightly as possible.
         * Notice:
         *  It is updated after rendering (in the step of frustum culling passingly). So may be not so accurate, but saves a lot of calculation
         *
         * @type {clay.BoundingBox}
         */ viewBoundingBoxLastFrame: new (0, $39676d59fa1158f6$export$2e2bcd8739ae039)(),
        // Uniforms for shadow map.
        shadowUniforms: {},
        _cameraList: [],
        // Properties to save the light information in the scene
        // Will be set in the render function
        _lightUniforms: {},
        _previousLightNumber: {},
        _lightNumber: {
        },
        _lightProgramKeys: {},
        _nodeRepository: {},
        _renderLists: new (0, $b0efb64a61ad4939$export$2e2bcd8739ae039)(20)
    };
}, function() {
    this._scene = this;
}, /** @lends clay.Scene.prototype. */ {
    // Add node to scene
    addToScene: function(node) {
        if (node instanceof (0, $abb2ad6f174841b9$export$2e2bcd8739ae039)) {
            if (this._cameraList.length > 0) console.warn("Found multiple camera in one scene. Use the fist one.");
            this._cameraList.push(node);
        } else if (node instanceof (0, $252d8ff14b1b2fbf$export$2e2bcd8739ae039)) this.lights.push(node);
        if (node.name) this._nodeRepository[node.name] = node;
    },
    // Remove node from scene
    removeFromScene: function(node) {
        var idx;
        if (node instanceof (0, $abb2ad6f174841b9$export$2e2bcd8739ae039)) {
            idx = this._cameraList.indexOf(node);
            if (idx >= 0) this._cameraList.splice(idx, 1);
        } else if (node instanceof (0, $252d8ff14b1b2fbf$export$2e2bcd8739ae039)) {
            idx = this.lights.indexOf(node);
            if (idx >= 0) this.lights.splice(idx, 1);
        }
        if (node.name) delete this._nodeRepository[node.name];
    },
    /**
     * Get node by name
     * @param  {string} name
     * @return {Node}
     * @DEPRECATED
     */ getNode: function(name) {
        return this._nodeRepository[name];
    },
    /**
     * Set main camera of the scene.
     * @param {claygl.Camera} camera
     */ setMainCamera: function(camera) {
        var idx = this._cameraList.indexOf(camera);
        if (idx >= 0) this._cameraList.splice(idx, 1);
        this._cameraList.unshift(camera);
    },
    /**
     * Get main camera of the scene.
     */ getMainCamera: function() {
        return this._cameraList[0];
    },
    getLights: function() {
        return this.lights;
    },
    updateLights: function() {
        var lights = this.lights;
        this._previousLightNumber = this._lightNumber;
        var lightNumber = {};
        for(var i = 0; i < lights.length; i++){
            var light = lights[i];
            if (light.invisible) continue;
            var group = light.group;
            if (!lightNumber[group]) lightNumber[group] = {};
            // User can use any type of light
            lightNumber[group][light.type] = lightNumber[group][light.type] || 0;
            lightNumber[group][light.type]++;
        }
        this._lightNumber = lightNumber;
        for(var groupId in lightNumber)this._lightProgramKeys[groupId] = $e49354c4f1efd6e1$var$getProgramKey(lightNumber[groupId]);
        this._updateLightUniforms();
    },
    /**
     * Clone a node and it's children, including mesh, camera, light, etc.
     * Unlike using `Node#clone`. It will clone skeleton and remap the joints. Material will also be cloned.
     *
     * @param {clay.Node} node
     * @return {clay.Node}
     */ cloneNode: function(node) {
        var newNode = node.clone();
        var clonedNodesMap = {};
        function buildNodesMap(sNode, tNode) {
            clonedNodesMap[sNode.__uid__] = tNode;
            for(var i = 0; i < sNode._children.length; i++){
                var sChild = sNode._children[i];
                var tChild = tNode._children[i];
                buildNodesMap(sChild, tChild);
            }
        }
        buildNodesMap(node, newNode);
        newNode.traverse(function(newChild) {
            if (newChild.skeleton) newChild.skeleton = newChild.skeleton.clone(clonedNodesMap);
            if (newChild.material) newChild.material = newChild.material.clone();
        });
        return newNode;
    },
    /**
     * Traverse the scene and add the renderable object to the render list.
     * It needs camera for the frustum culling.
     *
     * @param {clay.Camera} camera
     * @param {boolean} updateSceneBoundingBox
     * @return {clay.Scene.RenderList}
     */ updateRenderList: function(camera, updateSceneBoundingBox) {
        var id = camera.__uid__;
        var renderList = this._renderLists.get(id);
        if (!renderList) {
            renderList = new $e49354c4f1efd6e1$var$RenderList();
            this._renderLists.put(id, renderList);
        }
        renderList.startCount();
        if (updateSceneBoundingBox) {
            this.viewBoundingBoxLastFrame.min.set(Infinity, Infinity, Infinity);
            this.viewBoundingBoxLastFrame.max.set(-Infinity, -Infinity, -Infinity);
        }
        var sceneMaterialTransparent = this.material && this.material.transparent || false;
        this._doUpdateRenderList(this, camera, sceneMaterialTransparent, renderList, updateSceneBoundingBox);
        renderList.endCount();
        return renderList;
    },
    /**
     * Get render list. Used after {@link clay.Scene#updateRenderList}
     * @param {clay.Camera} camera
     * @return {clay.Scene.RenderList}
     */ getRenderList: function(camera) {
        return this._renderLists.get(camera.__uid__);
    },
    _doUpdateRenderList: function(parent, camera, sceneMaterialTransparent, renderList, updateSceneBoundingBox) {
        if (parent.invisible) return;
        // TODO Optimize
        for(var i = 0; i < parent._children.length; i++){
            var child = parent._children[i];
            if (child.isRenderable()) {
                // Frustum culling
                var worldM = child.isSkinnedMesh() ? $e49354c4f1efd6e1$var$IDENTITY : child.worldTransform.array;
                var geometry = child.geometry;
                (0, $0020ce97b75275ae$export$2e2bcd8739ae039).multiplyAffine($e49354c4f1efd6e1$var$WORLDVIEW, camera.viewMatrix.array, worldM);
                if (updateSceneBoundingBox && !geometry.boundingBox || !this.isFrustumCulled(child, camera, $e49354c4f1efd6e1$var$WORLDVIEW)) renderList.add(child, child.material.transparent || sceneMaterialTransparent);
            }
            if (child._children.length > 0) this._doUpdateRenderList(child, camera, sceneMaterialTransparent, renderList, updateSceneBoundingBox);
        }
    },
    /**
     * If an scene object is culled by camera frustum
     *
     * Object can be a renderable or a light
     *
     * @param {clay.Node} object
     * @param {clay.Camera} camera
     * @param {Array.<number>} worldViewMat represented with array
     * @param {Array.<number>} projectionMat represented with array
     */ isFrustumCulled: function() {
        // Frustum culling
        // http://www.cse.chalmers.se/~uffe/vfc_bbox.pdf
        var cullingBoundingBox = new (0, $39676d59fa1158f6$export$2e2bcd8739ae039)();
        var cullingMatrix = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
        return function(object, camera, worldViewMat) {
            // Bounding box can be a property of object(like light) or renderable.geometry
            // PENDING
            var geoBBox = object.boundingBox;
            if (!geoBBox) {
                if (object.skeleton && object.skeleton.boundingBox) geoBBox = object.skeleton.boundingBox;
                else geoBBox = object.geometry.boundingBox;
            }
            if (!geoBBox) return false;
            cullingMatrix.array = worldViewMat;
            cullingBoundingBox.transformFrom(geoBBox, cullingMatrix);
            // Passingly update the scene bounding box
            // FIXME exclude very large mesh like ground plane or terrain ?
            // FIXME Only rendererable which cast shadow ?
            // FIXME boundingBox becomes much larger after transformd.
            if (object.castShadow) this.viewBoundingBoxLastFrame.union(cullingBoundingBox);
            // Ignore frustum culling if object is skinned mesh.
            if (object.frustumCulling) {
                if (!cullingBoundingBox.intersectBoundingBox(camera.frustum.boundingBox)) return true;
                cullingMatrix.array = camera.projectionMatrix.array;
                if (cullingBoundingBox.max.array[2] > 0 && cullingBoundingBox.min.array[2] < 0) // Clip in the near plane
                cullingBoundingBox.max.array[2] = -0.00000000000000000001;
                cullingBoundingBox.applyProjection(cullingMatrix);
                var min = cullingBoundingBox.min.array;
                var max = cullingBoundingBox.max.array;
                if (max[0] < -1 || min[0] > 1 || max[1] < -1 || min[1] > 1 || max[2] < -1 || min[2] > 1) return true;
            }
            return false;
        };
    }(),
    _updateLightUniforms: function() {
        var lights = this.lights;
        // Put the light cast shadow before the light not cast shadow
        lights.sort($e49354c4f1efd6e1$var$lightSortFunc);
        var lightUniforms = this._lightUniforms;
        for(var group in lightUniforms)for(var symbol in lightUniforms[group])lightUniforms[group][symbol].value.length = 0;
        for(var i = 0; i < lights.length; i++){
            var light = lights[i];
            if (light.invisible) continue;
            var group = light.group;
            for(var symbol in light.uniformTemplates){
                var uniformTpl = light.uniformTemplates[symbol];
                var value = uniformTpl.value(light);
                if (value == null) continue;
                if (!lightUniforms[group]) lightUniforms[group] = {};
                if (!lightUniforms[group][symbol]) lightUniforms[group][symbol] = {
                    type: "",
                    value: []
                };
                var lu = lightUniforms[group][symbol];
                lu.type = uniformTpl.type + "v";
                switch(uniformTpl.type){
                    case "1i":
                    case "1f":
                    case "t":
                        lu.value.push(value);
                        break;
                    case "2f":
                    case "3f":
                    case "4f":
                        for(var j = 0; j < value.length; j++)lu.value.push(value[j]);
                        break;
                    default:
                        console.error("Unkown light uniform type " + uniformTpl.type);
                }
            }
        }
    },
    getLightGroups: function() {
        var lightGroups = [];
        for(var groupId in this._lightNumber)lightGroups.push(groupId);
        return lightGroups;
    },
    getNumberChangedLightGroups: function() {
        var lightGroups = [];
        for(var groupId in this._lightNumber)if (this.isLightNumberChanged(groupId)) lightGroups.push(groupId);
        return lightGroups;
    },
    // Determine if light group is different with since last frame
    // Used to determine whether to update shader and scene's uniforms in Renderer.render
    isLightNumberChanged: function(lightGroup) {
        var prevLightNumber = this._previousLightNumber;
        var currentLightNumber = this._lightNumber;
        // PENDING Performance
        for(var type in currentLightNumber[lightGroup]){
            if (!prevLightNumber[lightGroup]) return true;
            if (currentLightNumber[lightGroup][type] !== prevLightNumber[lightGroup][type]) return true;
        }
        for(var type in prevLightNumber[lightGroup]){
            if (!currentLightNumber[lightGroup]) return true;
            if (currentLightNumber[lightGroup][type] !== prevLightNumber[lightGroup][type]) return true;
        }
        return false;
    },
    getLightsNumbers: function(lightGroup) {
        return this._lightNumber[lightGroup];
    },
    getProgramKey: function(lightGroup) {
        return this._lightProgramKeys[lightGroup];
    },
    setLightUniforms: function() {
        function setUniforms(uniforms, program, renderer) {
            for(var symbol in uniforms){
                var lu = uniforms[symbol];
                if (lu.type === "tv") {
                    if (!program.hasUniform(symbol)) continue;
                    var texSlots = [];
                    for(var i = 0; i < lu.value.length; i++){
                        var texture = lu.value[i];
                        var slot = program.takeCurrentTextureSlot(renderer, texture);
                        texSlots.push(slot);
                    }
                    program.setUniform(renderer.gl, "1iv", symbol, texSlots);
                } else program.setUniform(renderer.gl, lu.type, symbol, lu.value);
            }
        }
        return function(program, lightGroup, renderer) {
            setUniforms(this._lightUniforms[lightGroup], program, renderer);
            // Set shadows
            setUniforms(this.shadowUniforms, program, renderer);
        };
    }(),
    /**
     * Dispose self, clear all the scene objects
     * But resources of gl like texuture, shader will not be disposed.
     * Mostly you should use disposeScene method in Renderer to do dispose.
     */ dispose: function() {
        this.material = null;
        this._opaqueList = [];
        this._transparentList = [];
        this.lights = [];
        this._lightUniforms = {};
        this._lightNumber = {};
        this._nodeRepository = {};
    }
});
function $e49354c4f1efd6e1$var$lightSortFunc(a, b) {
    if (b.castShadow && !a.castShadow) return true;
}
var $e49354c4f1efd6e1$export$2e2bcd8739ae039 = $e49354c4f1efd6e1$var$Scene;









var $8dbf947c9de660dd$var$isPowerOfTwo = (0, $dedf80f5f4c1bc61$export$2e2bcd8739ae039).isPowerOfTwo;
var $8dbf947c9de660dd$var$targetList = [
    "px",
    "nx",
    "py",
    "ny",
    "pz",
    "nz"
];
/**
 * @constructor clay.TextureCube
 * @extends clay.Texture
 *
 * @example
 *     ...
 *     var mat = new clay.Material({
 *         shader: clay.shader.library.get('clay.phong', 'environmentMap')
 *     });
 *     var envMap = new clay.TextureCube();
 *     envMap.load({
 *         'px': 'assets/textures/sky/px.jpg',
 *         'nx': 'assets/textures/sky/nx.jpg'
 *         'py': 'assets/textures/sky/py.jpg'
 *         'ny': 'assets/textures/sky/ny.jpg'
 *         'pz': 'assets/textures/sky/pz.jpg'
 *         'nz': 'assets/textures/sky/nz.jpg'
 *     });
 *     mat.set('environmentMap', envMap);
 *     ...
 *     envMap.success(function () {
 *         // Wait for the sky texture loaded
 *         animation.on('frame', function (frameTime) {
 *             renderer.render(scene, camera);
 *         });
 *     });
 */ var $8dbf947c9de660dd$var$TextureCube = (0, $4261427f149675a4$export$2e2bcd8739ae039).extend(function() {
    return /** @lends clay.TextureCube# */ {
        /**
         * @type {boolean}
         * @default false
         */ // PENDING cubemap should not flipY in default.
        // flipY: false,
        /**
         * @type {Object}
         * @property {?HTMLImageElement|HTMLCanvasElemnet} px
         * @property {?HTMLImageElement|HTMLCanvasElemnet} nx
         * @property {?HTMLImageElement|HTMLCanvasElemnet} py
         * @property {?HTMLImageElement|HTMLCanvasElemnet} ny
         * @property {?HTMLImageElement|HTMLCanvasElemnet} pz
         * @property {?HTMLImageElement|HTMLCanvasElemnet} nz
         */ image: {
            px: null,
            nx: null,
            py: null,
            ny: null,
            pz: null,
            nz: null
        },
        /**
         * Pixels data of each side. Will be ignored if images are set.
         * @type {Object}
         * @property {?Uint8Array} px
         * @property {?Uint8Array} nx
         * @property {?Uint8Array} py
         * @property {?Uint8Array} ny
         * @property {?Uint8Array} pz
         * @property {?Uint8Array} nz
         */ pixels: {
            px: null,
            nx: null,
            py: null,
            ny: null,
            pz: null,
            nz: null
        },
        /**
         * @type {Array.<Object>}
         */ mipmaps: []
    };
}, {
    textureType: "textureCube",
    update: function(renderer) {
        var _gl = renderer.gl;
        _gl.bindTexture(_gl.TEXTURE_CUBE_MAP, this._cache.get("webgl_texture"));
        this.updateCommon(renderer);
        var glFormat = this.format;
        var glType = this.type;
        _gl.texParameteri(_gl.TEXTURE_CUBE_MAP, _gl.TEXTURE_WRAP_S, this.getAvailableWrapS());
        _gl.texParameteri(_gl.TEXTURE_CUBE_MAP, _gl.TEXTURE_WRAP_T, this.getAvailableWrapT());
        _gl.texParameteri(_gl.TEXTURE_CUBE_MAP, _gl.TEXTURE_MAG_FILTER, this.getAvailableMagFilter());
        _gl.texParameteri(_gl.TEXTURE_CUBE_MAP, _gl.TEXTURE_MIN_FILTER, this.getAvailableMinFilter());
        var anisotropicExt = renderer.getGLExtension("EXT_texture_filter_anisotropic");
        if (anisotropicExt && this.anisotropic > 1) _gl.texParameterf(_gl.TEXTURE_CUBE_MAP, anisotropicExt.TEXTURE_MAX_ANISOTROPY_EXT, this.anisotropic);
        // Fallback to float type if browser don't have half float extension
        if (glType === 36193) {
            var halfFloatExt = renderer.getGLExtension("OES_texture_half_float");
            if (!halfFloatExt) glType = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).FLOAT;
        }
        if (this.mipmaps.length) {
            var width = this.width;
            var height = this.height;
            for(var i = 0; i < this.mipmaps.length; i++){
                var mipmap = this.mipmaps[i];
                this._updateTextureData(_gl, mipmap, i, width, height, glFormat, glType);
                width /= 2;
                height /= 2;
            }
        } else {
            this._updateTextureData(_gl, this, 0, this.width, this.height, glFormat, glType);
            if (!this.NPOT && this.useMipmap) _gl.generateMipmap(_gl.TEXTURE_CUBE_MAP);
        }
        _gl.bindTexture(_gl.TEXTURE_CUBE_MAP, null);
    },
    _updateTextureData: function(_gl, data, level, width, height, glFormat, glType) {
        for(var i = 0; i < 6; i++){
            var target = $8dbf947c9de660dd$var$targetList[i];
            var img = data.image && data.image[target];
            if (img) _gl.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level, glFormat, glFormat, glType, img);
            else _gl.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level, glFormat, width, height, 0, glFormat, glType, data.pixels && data.pixels[target]);
        }
    },
    /**
     * @param  {clay.Renderer} renderer
     * @memberOf clay.TextureCube.prototype
     */ generateMipmap: function(renderer) {
        var _gl = renderer.gl;
        if (this.useMipmap && !this.NPOT) {
            _gl.bindTexture(_gl.TEXTURE_CUBE_MAP, this._cache.get("webgl_texture"));
            _gl.generateMipmap(_gl.TEXTURE_CUBE_MAP);
        }
    },
    bind: function(renderer) {
        renderer.gl.bindTexture(renderer.gl.TEXTURE_CUBE_MAP, this.getWebGLTexture(renderer));
    },
    unbind: function(renderer) {
        renderer.gl.bindTexture(renderer.gl.TEXTURE_CUBE_MAP, null);
    },
    // Overwrite the isPowerOfTwo method
    isPowerOfTwo: function() {
        if (this.image.px) return $8dbf947c9de660dd$var$isPowerOfTwo(this.image.px.width) && $8dbf947c9de660dd$var$isPowerOfTwo(this.image.px.height);
        else return $8dbf947c9de660dd$var$isPowerOfTwo(this.width) && $8dbf947c9de660dd$var$isPowerOfTwo(this.height);
    },
    isRenderable: function() {
        if (this.image.px) return $8dbf947c9de660dd$var$isImageRenderable(this.image.px) && $8dbf947c9de660dd$var$isImageRenderable(this.image.nx) && $8dbf947c9de660dd$var$isImageRenderable(this.image.py) && $8dbf947c9de660dd$var$isImageRenderable(this.image.ny) && $8dbf947c9de660dd$var$isImageRenderable(this.image.pz) && $8dbf947c9de660dd$var$isImageRenderable(this.image.nz);
        else return !!(this.width && this.height);
    },
    load: function(imageList, crossOrigin) {
        var loading = 0;
        var self = this;
        (0, $b22fd57b6bfa77fb$export$2e2bcd8739ae039).each(imageList, function(src, target) {
            var image = (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).createImage();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.onload = function() {
                loading--;
                if (loading === 0) {
                    self.dirty();
                    self.trigger("success", self);
                }
            };
            image.onerror = function() {
                loading--;
            };
            loading++;
            image.src = src;
            self.image[target] = image;
        });
        return this;
    }
});
Object.defineProperty($8dbf947c9de660dd$var$TextureCube.prototype, "width", {
    get: function() {
        if (this.image && this.image.px) return this.image.px.width;
        return this._width;
    },
    set: function(value) {
        if (this.image && this.image.px) console.warn("Texture from image can't set width");
        else {
            if (this._width !== value) this.dirty();
            this._width = value;
        }
    }
});
Object.defineProperty($8dbf947c9de660dd$var$TextureCube.prototype, "height", {
    get: function() {
        if (this.image && this.image.px) return this.image.px.height;
        return this._height;
    },
    set: function(value) {
        if (this.image && this.image.px) console.warn("Texture from image can't set height");
        else {
            if (this._height !== value) this.dirty();
            this._height = value;
        }
    }
});
function $8dbf947c9de660dd$var$isImageRenderable(image) {
    return image.width > 0 && image.height > 0;
}
var $8dbf947c9de660dd$export$2e2bcd8739ae039 = $8dbf947c9de660dd$var$TextureCube;






/**
 * @constructor clay.camera.Perspective
 * @extends clay.Camera
 */ var $b0e6d9b112e2eb50$var$Perspective = (0, $abb2ad6f174841b9$export$2e2bcd8739ae039).extend(/** @lends clay.camera.Perspective# */ {
    /**
     * Vertical field of view in degrees
     * @type {number}
     */ fov: 50,
    /**
     * Aspect ratio, typically viewport width / height
     * @type {number}
     */ aspect: 1,
    /**
     * Near bound of the frustum
     * @type {number}
     */ near: 0.1,
    /**
     * Far bound of the frustum
     * @type {number}
     */ far: 2000
}, /** @lends clay.camera.Perspective.prototype */ {
    updateProjectionMatrix: function() {
        var rad = this.fov / 180 * Math.PI;
        this.projectionMatrix.perspective(rad, this.aspect, this.near, this.far);
    },
    decomposeProjectionMatrix: function() {
        var m = this.projectionMatrix.array;
        var rad = Math.atan(1 / m[5]) * 2;
        this.fov = rad / Math.PI * 180;
        this.aspect = m[5] / m[0];
        this.near = m[14] / (m[10] - 1);
        this.far = m[14] / (m[10] + 1);
    },
    /**
     * @return {clay.camera.Perspective}
     */ clone: function() {
        var camera = (0, $abb2ad6f174841b9$export$2e2bcd8739ae039).prototype.clone.call(this);
        camera.fov = this.fov;
        camera.aspect = this.aspect;
        camera.near = this.near;
        camera.far = this.far;
        return camera;
    }
});
var $b0e6d9b112e2eb50$export$2e2bcd8739ae039 = $b0e6d9b112e2eb50$var$Perspective;







var $03d0b3c43006f961$var$KEY_FRAMEBUFFER = "framebuffer";
var $03d0b3c43006f961$var$KEY_RENDERBUFFER = "renderbuffer";
var $03d0b3c43006f961$var$KEY_RENDERBUFFER_WIDTH = $03d0b3c43006f961$var$KEY_RENDERBUFFER + "_width";
var $03d0b3c43006f961$var$KEY_RENDERBUFFER_HEIGHT = $03d0b3c43006f961$var$KEY_RENDERBUFFER + "_height";
var $03d0b3c43006f961$var$KEY_RENDERBUFFER_ATTACHED = $03d0b3c43006f961$var$KEY_RENDERBUFFER + "_attached";
var $03d0b3c43006f961$var$KEY_DEPTHTEXTURE_ATTACHED = "depthtexture_attached";
var $03d0b3c43006f961$var$GL_FRAMEBUFFER = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).FRAMEBUFFER;
var $03d0b3c43006f961$var$GL_RENDERBUFFER = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).RENDERBUFFER;
var $03d0b3c43006f961$var$GL_DEPTH_ATTACHMENT = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).DEPTH_ATTACHMENT;
var $03d0b3c43006f961$var$GL_COLOR_ATTACHMENT0 = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).COLOR_ATTACHMENT0;
/**
 * @constructor clay.FrameBuffer
 * @extends clay.core.Base
 */ var $03d0b3c43006f961$var$FrameBuffer = (0, $7c62670c05885275$export$2e2bcd8739ae039).extend(/** @lends clay.FrameBuffer# */ {
    /**
     * If use depth buffer
     * @type {boolean}
     */ depthBuffer: true,
    /**
     * @type {Object}
     */ viewport: null,
    _width: 0,
    _height: 0,
    _textures: null,
    _boundRenderer: null
}, function() {
    // Use cache
    this._cache = new (0, $5f2dc45e40134abc$export$2e2bcd8739ae039)();
    this._textures = {};
}, /**@lends clay.FrameBuffer.prototype. */ {
    /**
     * Get attached texture width
     * {number}
     */ // FIXME Can't use before #bind
    getTextureWidth: function() {
        return this._width;
    },
    /**
     * Get attached texture height
     * {number}
     */ getTextureHeight: function() {
        return this._height;
    },
    /**
     * Bind the framebuffer to given renderer before rendering
     * @param  {clay.Renderer} renderer
     */ bind: function(renderer) {
        if (renderer.__currentFrameBuffer) {
            // Already bound
            if (renderer.__currentFrameBuffer === this) return;
            console.warn("Renderer already bound with another framebuffer. Unbind it first");
        }
        renderer.__currentFrameBuffer = this;
        var _gl = renderer.gl;
        _gl.bindFramebuffer($03d0b3c43006f961$var$GL_FRAMEBUFFER, this._getFrameBufferGL(renderer));
        this._boundRenderer = renderer;
        var cache = this._cache;
        cache.put("viewport", renderer.viewport);
        var hasTextureAttached = false;
        var width;
        var height;
        for(var attachment in this._textures){
            hasTextureAttached = true;
            var obj = this._textures[attachment];
            if (obj) {
                // TODO Do width, height checking, make sure size are same
                width = obj.texture.width;
                height = obj.texture.height;
                // Attach textures
                this._doAttach(renderer, obj.texture, attachment, obj.target);
            }
        }
        this._width = width;
        this._height = height;
        if (!hasTextureAttached && this.depthBuffer) console.error("Must attach texture before bind, or renderbuffer may have incorrect width and height.");
        if (this.viewport) renderer.setViewport(this.viewport);
        else renderer.setViewport(0, 0, width, height, 1);
        var attachedTextures = cache.get("attached_textures");
        if (attachedTextures) {
            for(var attachment in attachedTextures)if (!this._textures[attachment]) {
                var target = attachedTextures[attachment];
                this._doDetach(_gl, attachment, target);
            }
        }
        if (!cache.get($03d0b3c43006f961$var$KEY_DEPTHTEXTURE_ATTACHED) && this.depthBuffer) {
            // Create a new render buffer
            if (cache.miss($03d0b3c43006f961$var$KEY_RENDERBUFFER)) cache.put($03d0b3c43006f961$var$KEY_RENDERBUFFER, _gl.createRenderbuffer());
            var renderbuffer = cache.get($03d0b3c43006f961$var$KEY_RENDERBUFFER);
            if (width !== cache.get($03d0b3c43006f961$var$KEY_RENDERBUFFER_WIDTH) || height !== cache.get($03d0b3c43006f961$var$KEY_RENDERBUFFER_HEIGHT)) {
                _gl.bindRenderbuffer($03d0b3c43006f961$var$GL_RENDERBUFFER, renderbuffer);
                _gl.renderbufferStorage($03d0b3c43006f961$var$GL_RENDERBUFFER, _gl.DEPTH_COMPONENT16, width, height);
                cache.put($03d0b3c43006f961$var$KEY_RENDERBUFFER_WIDTH, width);
                cache.put($03d0b3c43006f961$var$KEY_RENDERBUFFER_HEIGHT, height);
                _gl.bindRenderbuffer($03d0b3c43006f961$var$GL_RENDERBUFFER, null);
            }
            if (!cache.get($03d0b3c43006f961$var$KEY_RENDERBUFFER_ATTACHED)) {
                _gl.framebufferRenderbuffer($03d0b3c43006f961$var$GL_FRAMEBUFFER, $03d0b3c43006f961$var$GL_DEPTH_ATTACHMENT, $03d0b3c43006f961$var$GL_RENDERBUFFER, renderbuffer);
                cache.put($03d0b3c43006f961$var$KEY_RENDERBUFFER_ATTACHED, true);
            }
        }
    },
    /**
     * Unbind the frame buffer after rendering
     * @param  {clay.Renderer} renderer
     */ unbind: function(renderer) {
        // Remove status record on renderer
        renderer.__currentFrameBuffer = null;
        var _gl = renderer.gl;
        _gl.bindFramebuffer($03d0b3c43006f961$var$GL_FRAMEBUFFER, null);
        this._boundRenderer = null;
        this._cache.use(renderer.__uid__);
        var viewport = this._cache.get("viewport");
        // Reset viewport;
        if (viewport) renderer.setViewport(viewport);
        this.updateMipmap(renderer);
    },
    // Because the data of texture is changed over time,
    // Here update the mipmaps of texture each time after rendered;
    updateMipmap: function(renderer) {
        var _gl = renderer.gl;
        for(var attachment in this._textures){
            var obj = this._textures[attachment];
            if (obj) {
                var texture = obj.texture;
                // FIXME some texture format can't generate mipmap
                if (!texture.NPOT && texture.useMipmap && texture.minFilter === (0, $4261427f149675a4$export$2e2bcd8739ae039).LINEAR_MIPMAP_LINEAR) {
                    var target = texture.textureType === "textureCube" ? (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).TEXTURE_CUBE_MAP : (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).TEXTURE_2D;
                    _gl.bindTexture(target, texture.getWebGLTexture(renderer));
                    _gl.generateMipmap(target);
                    _gl.bindTexture(target, null);
                }
            }
        }
    },
    // 0x8CD5, 36053, FRAMEBUFFER_COMPLETE
    // 0x8CD6, 36054, FRAMEBUFFER_INCOMPLETE_ATTACHMENT
    // 0x8CD7, 36055, FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT
    // 0x8CD9, 36057, FRAMEBUFFER_INCOMPLETE_DIMENSIONS
    // 0x8CDD, 36061, FRAMEBUFFER_UNSUPPORTED
    checkStatus: function(_gl) {
        return _gl.checkFramebufferStatus($03d0b3c43006f961$var$GL_FRAMEBUFFER);
    },
    _getFrameBufferGL: function(renderer) {
        var cache = this._cache;
        cache.use(renderer.__uid__);
        if (cache.miss($03d0b3c43006f961$var$KEY_FRAMEBUFFER)) cache.put($03d0b3c43006f961$var$KEY_FRAMEBUFFER, renderer.gl.createFramebuffer());
        return cache.get($03d0b3c43006f961$var$KEY_FRAMEBUFFER);
    },
    /**
     * Attach a texture(RTT) to the framebuffer
     * @param  {clay.Texture} texture
     * @param  {number} [attachment=gl.COLOR_ATTACHMENT0]
     * @param  {number} [target=gl.TEXTURE_2D]
     */ attach: function(texture, attachment, target) {
        if (!texture.width) throw new Error("The texture attached to color buffer is not a valid.");
        // TODO width and height check
        // If the depth_texture extension is enabled, developers
        // Can attach a depth texture to the depth buffer
        // http://blog.tojicode.com/2012/07/using-webgldepthtexture.html
        attachment = attachment || $03d0b3c43006f961$var$GL_COLOR_ATTACHMENT0;
        target = target || (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).TEXTURE_2D;
        var boundRenderer = this._boundRenderer;
        var _gl = boundRenderer && boundRenderer.gl;
        var attachedTextures;
        if (_gl) {
            var cache = this._cache;
            cache.use(boundRenderer.__uid__);
            attachedTextures = cache.get("attached_textures");
        }
        // Check if texture attached
        var previous = this._textures[attachment];
        if (previous && previous.target === target && previous.texture === texture && attachedTextures && attachedTextures[attachment] != null) return;
        var canAttach = true;
        if (boundRenderer) {
            canAttach = this._doAttach(boundRenderer, texture, attachment, target);
            // Set viewport again incase attached to different size textures.
            if (!this.viewport) boundRenderer.setViewport(0, 0, texture.width, texture.height, 1);
        }
        if (canAttach) {
            this._textures[attachment] = this._textures[attachment] || {};
            this._textures[attachment].texture = texture;
            this._textures[attachment].target = target;
        }
    },
    _doAttach: function(renderer, texture, attachment, target) {
        var _gl = renderer.gl;
        // Make sure texture is always updated
        // Because texture width or height may be changed and in this we can't be notified
        // FIXME awkward;
        var webglTexture = texture.getWebGLTexture(renderer);
        // Assume cache has been used.
        var attachedTextures = this._cache.get("attached_textures");
        if (attachedTextures && attachedTextures[attachment]) {
            var obj = attachedTextures[attachment];
            // Check if texture and target not changed
            if (obj.texture === texture && obj.target === target) return;
        }
        attachment = +attachment;
        var canAttach = true;
        if (attachment === $03d0b3c43006f961$var$GL_DEPTH_ATTACHMENT || attachment === (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).DEPTH_STENCIL_ATTACHMENT) {
            var extension = renderer.getGLExtension("WEBGL_depth_texture");
            if (!extension) {
                console.error("Depth texture is not supported by the browser");
                canAttach = false;
            }
            if (texture.format !== (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).DEPTH_COMPONENT && texture.format !== (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).DEPTH_STENCIL) {
                console.error("The texture attached to depth buffer is not a valid.");
                canAttach = false;
            }
            // Dispose render buffer created previous
            if (canAttach) {
                var renderbuffer = this._cache.get($03d0b3c43006f961$var$KEY_RENDERBUFFER);
                if (renderbuffer) {
                    _gl.framebufferRenderbuffer($03d0b3c43006f961$var$GL_FRAMEBUFFER, $03d0b3c43006f961$var$GL_DEPTH_ATTACHMENT, $03d0b3c43006f961$var$GL_RENDERBUFFER, null);
                    _gl.deleteRenderbuffer(renderbuffer);
                    this._cache.put($03d0b3c43006f961$var$KEY_RENDERBUFFER, false);
                }
                this._cache.put($03d0b3c43006f961$var$KEY_RENDERBUFFER_ATTACHED, false);
                this._cache.put($03d0b3c43006f961$var$KEY_DEPTHTEXTURE_ATTACHED, true);
            }
        }
        // Mipmap level can only be 0
        _gl.framebufferTexture2D($03d0b3c43006f961$var$GL_FRAMEBUFFER, attachment, target, webglTexture, 0);
        if (!attachedTextures) {
            attachedTextures = {};
            this._cache.put("attached_textures", attachedTextures);
        }
        attachedTextures[attachment] = attachedTextures[attachment] || {};
        attachedTextures[attachment].texture = texture;
        attachedTextures[attachment].target = target;
        return canAttach;
    },
    _doDetach: function(_gl, attachment, target) {
        // Detach a texture from framebuffer
        // https://github.com/KhronosGroup/WebGL/blob/master/conformance-suites/1.0.0/conformance/framebuffer-test.html#L145
        _gl.framebufferTexture2D($03d0b3c43006f961$var$GL_FRAMEBUFFER, attachment, target, null, 0);
        // Assume cache has been used.
        var attachedTextures = this._cache.get("attached_textures");
        if (attachedTextures && attachedTextures[attachment]) attachedTextures[attachment] = null;
        if (attachment === $03d0b3c43006f961$var$GL_DEPTH_ATTACHMENT || attachment === (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).DEPTH_STENCIL_ATTACHMENT) this._cache.put($03d0b3c43006f961$var$KEY_DEPTHTEXTURE_ATTACHED, false);
    },
    /**
     * Detach a texture
     * @param  {number} [attachment=gl.COLOR_ATTACHMENT0]
     * @param  {number} [target=gl.TEXTURE_2D]
     */ detach: function(attachment, target) {
        // TODO depth extension check ?
        this._textures[attachment] = null;
        if (this._boundRenderer) {
            var cache = this._cache;
            cache.use(this._boundRenderer.__uid__);
            this._doDetach(this._boundRenderer.gl, attachment, target);
        }
    },
    /**
     * Dispose
     * @param  {WebGLRenderingContext} _gl
     */ dispose: function(renderer) {
        var _gl = renderer.gl;
        var cache = this._cache;
        cache.use(renderer.__uid__);
        var renderBuffer = cache.get($03d0b3c43006f961$var$KEY_RENDERBUFFER);
        if (renderBuffer) _gl.deleteRenderbuffer(renderBuffer);
        var frameBuffer = cache.get($03d0b3c43006f961$var$KEY_FRAMEBUFFER);
        if (frameBuffer) _gl.deleteFramebuffer(frameBuffer);
        cache.deleteContext(renderer.__uid__);
        // Clear cache for reusing
        this._textures = {};
    }
});
$03d0b3c43006f961$var$FrameBuffer.DEPTH_ATTACHMENT = $03d0b3c43006f961$var$GL_DEPTH_ATTACHMENT;
$03d0b3c43006f961$var$FrameBuffer.COLOR_ATTACHMENT0 = $03d0b3c43006f961$var$GL_COLOR_ATTACHMENT0;
$03d0b3c43006f961$var$FrameBuffer.STENCIL_ATTACHMENT = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).STENCIL_ATTACHMENT;
$03d0b3c43006f961$var$FrameBuffer.DEPTH_STENCIL_ATTACHMENT = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).DEPTH_STENCIL_ATTACHMENT;
var $03d0b3c43006f961$export$2e2bcd8739ae039 = $03d0b3c43006f961$var$FrameBuffer;


var $903ac207f318e53a$var$targets = [
    "px",
    "nx",
    "py",
    "ny",
    "pz",
    "nz"
];
/**
 * Pass rendering scene to a environment cube map
 *
 * @constructor clay.prePass.EnvironmentMap
 * @extends clay.core.Base
 * @example
 *     // Example of car reflection
 *     var envMap = new clay.TextureCube({
 *         width: 256,
 *         height: 256
 *     });
 *     var envPass = new clay.prePass.EnvironmentMap({
 *         position: car.position,
 *         texture: envMap
 *     });
 *     var carBody = car.getChildByName('body');
 *     carBody.material.enableTexture('environmentMap');
 *     carBody.material.set('environmentMap', envMap);
 *     ...
 *     animation.on('frame', function(frameTime) {
 *         envPass.render(renderer, scene);
 *         renderer.render(scene, camera);
 *     });
 */ var $903ac207f318e53a$var$EnvironmentMapPass = (0, $7c62670c05885275$export$2e2bcd8739ae039).extend(function() {
    var ret = /** @lends clay.prePass.EnvironmentMap# */ {
        /**
         * Camera position
         * @type {clay.Vector3}
         * @memberOf clay.prePass.EnvironmentMap#
         */ position: new (0, $27fea36417076c2d$export$2e2bcd8739ae039)(),
        /**
         * Camera far plane
         * @type {number}
         * @memberOf clay.prePass.EnvironmentMap#
         */ far: 1000,
        /**
         * Camera near plane
         * @type {number}
         * @memberOf clay.prePass.EnvironmentMap#
         */ near: 0.1,
        /**
         * Environment cube map
         * @type {clay.TextureCube}
         * @memberOf clay.prePass.EnvironmentMap#
         */ texture: null,
        /**
         * Used if you wan't have shadow in environment map
         * @type {clay.prePass.ShadowMap}
         */ shadowMapPass: null
    };
    var cameras = ret._cameras = {
        px: new (0, $b0e6d9b112e2eb50$export$2e2bcd8739ae039)({
            fov: 90
        }),
        nx: new (0, $b0e6d9b112e2eb50$export$2e2bcd8739ae039)({
            fov: 90
        }),
        py: new (0, $b0e6d9b112e2eb50$export$2e2bcd8739ae039)({
            fov: 90
        }),
        ny: new (0, $b0e6d9b112e2eb50$export$2e2bcd8739ae039)({
            fov: 90
        }),
        pz: new (0, $b0e6d9b112e2eb50$export$2e2bcd8739ae039)({
            fov: 90
        }),
        nz: new (0, $b0e6d9b112e2eb50$export$2e2bcd8739ae039)({
            fov: 90
        })
    };
    cameras.px.lookAt((0, $27fea36417076c2d$export$2e2bcd8739ae039).POSITIVE_X, (0, $27fea36417076c2d$export$2e2bcd8739ae039).NEGATIVE_Y);
    cameras.nx.lookAt((0, $27fea36417076c2d$export$2e2bcd8739ae039).NEGATIVE_X, (0, $27fea36417076c2d$export$2e2bcd8739ae039).NEGATIVE_Y);
    cameras.py.lookAt((0, $27fea36417076c2d$export$2e2bcd8739ae039).POSITIVE_Y, (0, $27fea36417076c2d$export$2e2bcd8739ae039).POSITIVE_Z);
    cameras.ny.lookAt((0, $27fea36417076c2d$export$2e2bcd8739ae039).NEGATIVE_Y, (0, $27fea36417076c2d$export$2e2bcd8739ae039).NEGATIVE_Z);
    cameras.pz.lookAt((0, $27fea36417076c2d$export$2e2bcd8739ae039).POSITIVE_Z, (0, $27fea36417076c2d$export$2e2bcd8739ae039).NEGATIVE_Y);
    cameras.nz.lookAt((0, $27fea36417076c2d$export$2e2bcd8739ae039).NEGATIVE_Z, (0, $27fea36417076c2d$export$2e2bcd8739ae039).NEGATIVE_Y);
    // FIXME In windows, use one framebuffer only renders one side of cubemap
    ret._frameBuffer = new (0, $03d0b3c43006f961$export$2e2bcd8739ae039)();
    return ret;
}, /** @lends clay.prePass.EnvironmentMap# */ {
    /**
     * @param  {string} target
     * @return  {clay.Camera}
     */ getCamera: function(target) {
        return this._cameras[target];
    },
    /**
     * @param  {clay.Renderer} renderer
     * @param  {clay.Scene} scene
     * @param  {boolean} [notUpdateScene=false]
     */ render: function(renderer, scene, notUpdateScene) {
        var _gl = renderer.gl;
        if (!notUpdateScene) scene.update();
        // Tweak fov
        // http://the-witness.net/news/2012/02/seamless-cube-map-filtering/
        var n = this.texture.width;
        var fov = 2 * Math.atan(n / (n - 0.5)) / Math.PI * 180;
        for(var i = 0; i < 6; i++){
            var target = $903ac207f318e53a$var$targets[i];
            var camera = this._cameras[target];
            (0, $27fea36417076c2d$export$2e2bcd8739ae039).copy(camera.position, this.position);
            camera.far = this.far;
            camera.near = this.near;
            camera.fov = fov;
            if (this.shadowMapPass) {
                camera.update();
                // update boundingBoxLastFrame
                var bbox = scene.getBoundingBox();
                bbox.applyTransform(camera.viewMatrix);
                scene.viewBoundingBoxLastFrame.copy(bbox);
                this.shadowMapPass.render(renderer, scene, camera, true);
            }
            this._frameBuffer.attach(this.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i);
            this._frameBuffer.bind(renderer);
            renderer.render(scene, camera, true);
            this._frameBuffer.unbind(renderer);
        }
    },
    /**
     * @param {clay.Renderer} renderer
     */ dispose: function(renderer) {
        this._frameBuffer.dispose(renderer);
    }
});
var $903ac207f318e53a$export$2e2bcd8739ae039 = $903ac207f318e53a$var$EnvironmentMapPass;


// TODO Should not derived from mesh?




/**
 * @constructor clay.geometry.Plane
 * @extends clay.Geometry
 * @param {Object} [opt]
 * @param {number} [opt.widthSegments]
 * @param {number} [opt.heightSegments]
 */ var $b1c813646bb685e2$var$Plane = (0, $c75c69a759bf7591$export$2e2bcd8739ae039).extend(/** @lends clay.geometry.Plane# */ {
    dynamic: false,
    /**
     * @type {number}
     */ widthSegments: 1,
    /**
     * @type {number}
     */ heightSegments: 1
}, function() {
    this.build();
}, /** @lends clay.geometry.Plane.prototype */ {
    /**
     * Build plane geometry
     */ build: function() {
        var heightSegments = this.heightSegments;
        var widthSegments = this.widthSegments;
        var attributes = this.attributes;
        var positions = [];
        var texcoords = [];
        var normals = [];
        var faces = [];
        for(var y = 0; y <= heightSegments; y++){
            var t = y / heightSegments;
            for(var x = 0; x <= widthSegments; x++){
                var s = x / widthSegments;
                positions.push([
                    2 * s - 1,
                    2 * t - 1,
                    0
                ]);
                if (texcoords) texcoords.push([
                    s,
                    t
                ]);
                if (normals) normals.push([
                    0,
                    0,
                    1
                ]);
                if (x < widthSegments && y < heightSegments) {
                    var i = x + y * (widthSegments + 1);
                    faces.push([
                        i,
                        i + 1,
                        i + widthSegments + 1
                    ]);
                    faces.push([
                        i + widthSegments + 1,
                        i + 1,
                        i + widthSegments + 2
                    ]);
                }
            }
        }
        attributes.position.fromArray(positions);
        attributes.texcoord0.fromArray(texcoords);
        attributes.normal.fromArray(normals);
        this.initIndicesFromArray(faces);
        this.boundingBox = new (0, $39676d59fa1158f6$export$2e2bcd8739ae039)();
        this.boundingBox.min.set(-1, -1, 0);
        this.boundingBox.max.set(1, 1, 0);
    }
});
var $b1c813646bb685e2$export$2e2bcd8739ae039 = $b1c813646bb685e2$var$Plane;






var $3581bb0beb488a28$var$planeMatrix = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
/**
 * @constructor clay.geometry.Cube
 * @extends clay.Geometry
 * @param {Object} [opt]
 * @param {number} [opt.widthSegments]
 * @param {number} [opt.heightSegments]
 * @param {number} [opt.depthSegments]
 * @param {boolean} [opt.inside]
 */ var $3581bb0beb488a28$var$Cube = (0, $c75c69a759bf7591$export$2e2bcd8739ae039).extend(/**@lends clay.geometry.Cube# */ {
    dynamic: false,
    /**
     * @type {number}
     */ widthSegments: 1,
    /**
     * @type {number}
     */ heightSegments: 1,
    /**
     * @type {number}
     */ depthSegments: 1,
    /**
     * @type {boolean}
     */ inside: false
}, function() {
    this.build();
}, /** @lends clay.geometry.Cube.prototype */ {
    /**
     * Build cube geometry
     */ build: function() {
        var planes = {
            "px": $3581bb0beb488a28$var$createPlane("px", this.depthSegments, this.heightSegments),
            "nx": $3581bb0beb488a28$var$createPlane("nx", this.depthSegments, this.heightSegments),
            "py": $3581bb0beb488a28$var$createPlane("py", this.widthSegments, this.depthSegments),
            "ny": $3581bb0beb488a28$var$createPlane("ny", this.widthSegments, this.depthSegments),
            "pz": $3581bb0beb488a28$var$createPlane("pz", this.widthSegments, this.heightSegments),
            "nz": $3581bb0beb488a28$var$createPlane("nz", this.widthSegments, this.heightSegments)
        };
        var attrList = [
            "position",
            "texcoord0",
            "normal"
        ];
        var vertexNumber = 0;
        var faceNumber = 0;
        for(var pos in planes){
            vertexNumber += planes[pos].vertexCount;
            faceNumber += planes[pos].indices.length;
        }
        for(var k = 0; k < attrList.length; k++)this.attributes[attrList[k]].init(vertexNumber);
        this.indices = new (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).Uint16Array(faceNumber);
        var faceOffset = 0;
        var vertexOffset = 0;
        for(var pos in planes){
            var plane = planes[pos];
            for(var k = 0; k < attrList.length; k++){
                var attrName = attrList[k];
                var attrArray = plane.attributes[attrName].value;
                var attrSize = plane.attributes[attrName].size;
                var isNormal = attrName === "normal";
                for(var i = 0; i < attrArray.length; i++){
                    var value = attrArray[i];
                    if (this.inside && isNormal) value = -value;
                    this.attributes[attrName].value[i + attrSize * vertexOffset] = value;
                }
            }
            var len = plane.indices.length;
            for(var i = 0; i < plane.indices.length; i++)this.indices[i + faceOffset] = vertexOffset + plane.indices[this.inside ? len - i - 1 : i];
            faceOffset += plane.indices.length;
            vertexOffset += plane.vertexCount;
        }
        this.boundingBox = new (0, $39676d59fa1158f6$export$2e2bcd8739ae039)();
        this.boundingBox.max.set(1, 1, 1);
        this.boundingBox.min.set(-1, -1, -1);
    }
});
function $3581bb0beb488a28$var$createPlane(pos, widthSegments, heightSegments) {
    $3581bb0beb488a28$var$planeMatrix.identity();
    var plane = new (0, $b1c813646bb685e2$export$2e2bcd8739ae039)({
        widthSegments: widthSegments,
        heightSegments: heightSegments
    });
    switch(pos){
        case "px":
            (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).translate($3581bb0beb488a28$var$planeMatrix, $3581bb0beb488a28$var$planeMatrix, (0, $27fea36417076c2d$export$2e2bcd8739ae039).POSITIVE_X);
            (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).rotateY($3581bb0beb488a28$var$planeMatrix, $3581bb0beb488a28$var$planeMatrix, Math.PI / 2);
            break;
        case "nx":
            (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).translate($3581bb0beb488a28$var$planeMatrix, $3581bb0beb488a28$var$planeMatrix, (0, $27fea36417076c2d$export$2e2bcd8739ae039).NEGATIVE_X);
            (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).rotateY($3581bb0beb488a28$var$planeMatrix, $3581bb0beb488a28$var$planeMatrix, -Math.PI / 2);
            break;
        case "py":
            (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).translate($3581bb0beb488a28$var$planeMatrix, $3581bb0beb488a28$var$planeMatrix, (0, $27fea36417076c2d$export$2e2bcd8739ae039).POSITIVE_Y);
            (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).rotateX($3581bb0beb488a28$var$planeMatrix, $3581bb0beb488a28$var$planeMatrix, -Math.PI / 2);
            break;
        case "ny":
            (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).translate($3581bb0beb488a28$var$planeMatrix, $3581bb0beb488a28$var$planeMatrix, (0, $27fea36417076c2d$export$2e2bcd8739ae039).NEGATIVE_Y);
            (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).rotateX($3581bb0beb488a28$var$planeMatrix, $3581bb0beb488a28$var$planeMatrix, Math.PI / 2);
            break;
        case "pz":
            (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).translate($3581bb0beb488a28$var$planeMatrix, $3581bb0beb488a28$var$planeMatrix, (0, $27fea36417076c2d$export$2e2bcd8739ae039).POSITIVE_Z);
            break;
        case "nz":
            (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).translate($3581bb0beb488a28$var$planeMatrix, $3581bb0beb488a28$var$planeMatrix, (0, $27fea36417076c2d$export$2e2bcd8739ae039).NEGATIVE_Z);
            (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).rotateY($3581bb0beb488a28$var$planeMatrix, $3581bb0beb488a28$var$planeMatrix, Math.PI);
            break;
    }
    plane.applyTransform($3581bb0beb488a28$var$planeMatrix);
    return plane;
}
var $3581bb0beb488a28$export$2e2bcd8739ae039 = $3581bb0beb488a28$var$Cube;







var $dab8a83ae7949843$export$2e2bcd8739ae039 = "@export clay.skybox.vertex\n#define SHADER_NAME skybox\nuniform mat4 world : WORLD;\nuniform mat4 worldViewProjection : WORLDVIEWPROJECTION;\nattribute vec3 position : POSITION;\nvarying vec3 v_WorldPosition;\nvoid main()\n{\n v_WorldPosition = (world * vec4(position, 1.0)).xyz;\n gl_Position = worldViewProjection * vec4(position, 1.0);\n}\n@end\n@export clay.skybox.fragment\n#define PI 3.1415926\nuniform mat4 viewInverse : VIEWINVERSE;\n#ifdef EQUIRECTANGULAR\nuniform sampler2D environmentMap;\n#else\nuniform samplerCube environmentMap;\n#endif\nuniform float lod: 0.0;\nvarying vec3 v_WorldPosition;\n@import clay.util.rgbm\n@import clay.util.srgb\n@import clay.util.ACES\nvoid main()\n{\n vec3 eyePos = viewInverse[3].xyz;\n vec3 V = normalize(v_WorldPosition - eyePos);\n#ifdef EQUIRECTANGULAR\n float phi = acos(V.y);\n float theta = atan(-V.x, V.z) + PI * 0.5;\n vec2 uv = vec2(theta / 2.0 / PI, phi / PI);\n vec4 texel = decodeHDR(texture2D(environmentMap, fract(uv)));\n#else\n #if defined(LOD) || defined(SUPPORT_TEXTURE_LOD)\n vec4 texel = decodeHDR(textureCubeLodEXT(environmentMap, V, lod));\n #else\n vec4 texel = decodeHDR(textureCube(environmentMap, V));\n #endif\n#endif\n#ifdef SRGB_DECODE\n texel = sRGBToLinear(texel);\n#endif\n#ifdef TONEMAPPING\n texel.rgb = ACESToneMapping(texel.rgb);\n#endif\n#ifdef SRGB_ENCODE\n texel = linearTosRGB(texel);\n#endif\n gl_FragColor = encodeHDR(vec4(texel.rgb, 1.0));\n}\n@end";


(0, $90e78c81ac16d455$export$2e2bcd8739ae039).import((0, $dab8a83ae7949843$export$2e2bcd8739ae039));
/**
 * @constructor clay.plugin.Skybox
 *
 * @example
 *     var skyTex = new clay.TextureCube();
 *     skyTex.load({
 *         'px': 'assets/textures/sky/px.jpg',
 *         'nx': 'assets/textures/sky/nx.jpg'
 *         'py': 'assets/textures/sky/py.jpg'
 *         'ny': 'assets/textures/sky/ny.jpg'
 *         'pz': 'assets/textures/sky/pz.jpg'
 *         'nz': 'assets/textures/sky/nz.jpg'
 *     });
 *     var skybox = new clay.plugin.Skybox({
 *         scene: scene
 *     });
 *     skybox.material.set('environmentMap', skyTex);
 */ var $8118711ff583fe51$var$Skybox = (0, $652fd5cc6a0444a2$export$2e2bcd8739ae039).extend(function() {
    var skyboxShader = new (0, $90e78c81ac16d455$export$2e2bcd8739ae039)({
        vertex: (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("clay.skybox.vertex"),
        fragment: (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("clay.skybox.fragment")
    });
    var material = new (0, $b70ebca493753aba$export$2e2bcd8739ae039)({
        shader: skyboxShader,
        depthMask: false
    });
    return {
        /**
         * @type {clay.Scene}
         * @memberOf clay.plugin.Skybox.prototype
         */ scene: null,
        geometry: new (0, $3581bb0beb488a28$export$2e2bcd8739ae039)(),
        material: material,
        environmentMap: null,
        culling: false,
        _dummyCamera: new (0, $b0e6d9b112e2eb50$export$2e2bcd8739ae039)()
    };
}, function() {
    var scene = this.scene;
    if (scene) this.attachScene(scene);
    if (this.environmentMap) this.setEnvironmentMap(this.environmentMap);
}, /** @lends clay.plugin.Skybox# */ {
    /**
     * Attach the skybox to the scene
     * @param  {clay.Scene} scene
     */ attachScene: function(scene) {
        if (this.scene) this.detachScene();
        scene.skybox = this;
        this.scene = scene;
        scene.on("beforerender", this._beforeRenderScene, this);
    },
    /**
     * Detach from scene
     */ detachScene: function() {
        if (this.scene) {
            this.scene.off("beforerender", this._beforeRenderScene);
            this.scene.skybox = null;
        }
        this.scene = null;
    },
    /**
     * Dispose skybox
     * @param  {clay.Renderer} renderer
     */ dispose: function(renderer) {
        this.detachScene();
        this.geometry.dispose(renderer);
    },
    /**
     * Set environment map
     * @param {clay.TextureCube} envMap
     */ setEnvironmentMap: function(envMap) {
        if (envMap.textureType === "texture2D") {
            this.material.define("EQUIRECTANGULAR");
            // LINEAR filter can remove the artifacts in pole
            envMap.minFilter = (0, $4261427f149675a4$export$2e2bcd8739ae039).LINEAR;
        } else this.material.undefine("EQUIRECTANGULAR");
        this.material.set("environmentMap", envMap);
    },
    /**
     * Get environment map
     * @return {clay.TextureCube}
     */ getEnvironmentMap: function() {
        return this.material.get("environmentMap");
    },
    _beforeRenderScene: function(renderer, scene, camera) {
        this.renderSkybox(renderer, camera);
    },
    renderSkybox: function(renderer, camera) {
        var dummyCamera = this._dummyCamera;
        dummyCamera.aspect = renderer.getViewportAspect();
        dummyCamera.fov = camera.fov || 50;
        dummyCamera.updateProjectionMatrix();
        (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).invert(dummyCamera.invProjectionMatrix, dummyCamera.projectionMatrix);
        dummyCamera.worldTransform.copy(camera.worldTransform);
        dummyCamera.viewMatrix.copy(camera.viewMatrix);
        this.position.copy(camera.getWorldPosition());
        this.update();
        // Don't remember to disable blend
        renderer.gl.disable(renderer.gl.BLEND);
        if (this.material.get("lod") > 0) this.material.define("fragment", "LOD");
        else this.material.undefine("fragment", "LOD");
        renderer.renderPass([
            this
        ], dummyCamera);
    }
});
var $8118711ff583fe51$export$2e2bcd8739ae039 = $8118711ff583fe51$var$Skybox;


var $a928f7c7df5943e2$export$2e2bcd8739ae039 = (0, $8118711ff583fe51$export$2e2bcd8739ae039);






// http://msdn.microsoft.com/en-us/library/windows/desktop/bb943991(v=vs.85).aspx
// https://github.com/toji/webgl-texture-utils/blob/master/texture-util/dds.js
var $633d7bf8781e6353$var$DDS_MAGIC = 0x20534444;
var $633d7bf8781e6353$var$DDSD_CAPS = 0x1;
var $633d7bf8781e6353$var$DDSD_HEIGHT = 0x2;
var $633d7bf8781e6353$var$DDSD_WIDTH = 0x4;
var $633d7bf8781e6353$var$DDSD_PITCH = 0x8;
var $633d7bf8781e6353$var$DDSD_PIXELFORMAT = 0x1000;
var $633d7bf8781e6353$var$DDSD_MIPMAPCOUNT = 0x20000;
var $633d7bf8781e6353$var$DDSD_LINEARSIZE = 0x80000;
var $633d7bf8781e6353$var$DDSD_DEPTH = 0x800000;
var $633d7bf8781e6353$var$DDSCAPS_COMPLEX = 0x8;
var $633d7bf8781e6353$var$DDSCAPS_MIPMAP = 0x400000;
var $633d7bf8781e6353$var$DDSCAPS_TEXTURE = 0x1000;
var $633d7bf8781e6353$var$DDSCAPS2_CUBEMAP = 0x200;
var $633d7bf8781e6353$var$DDSCAPS2_CUBEMAP_POSITIVEX = 0x400;
var $633d7bf8781e6353$var$DDSCAPS2_CUBEMAP_NEGATIVEX = 0x800;
var $633d7bf8781e6353$var$DDSCAPS2_CUBEMAP_POSITIVEY = 0x1000;
var $633d7bf8781e6353$var$DDSCAPS2_CUBEMAP_NEGATIVEY = 0x2000;
var $633d7bf8781e6353$var$DDSCAPS2_CUBEMAP_POSITIVEZ = 0x4000;
var $633d7bf8781e6353$var$DDSCAPS2_CUBEMAP_NEGATIVEZ = 0x8000;
var $633d7bf8781e6353$var$DDSCAPS2_VOLUME = 0x200000;
var $633d7bf8781e6353$var$DDPF_ALPHAPIXELS = 0x1;
var $633d7bf8781e6353$var$DDPF_ALPHA = 0x2;
var $633d7bf8781e6353$var$DDPF_FOURCC = 0x4;
var $633d7bf8781e6353$var$DDPF_RGB = 0x40;
var $633d7bf8781e6353$var$DDPF_YUV = 0x200;
var $633d7bf8781e6353$var$DDPF_LUMINANCE = 0x20000;
function $633d7bf8781e6353$var$fourCCToInt32(value) {
    return value.charCodeAt(0) + (value.charCodeAt(1) << 8) + (value.charCodeAt(2) << 16) + (value.charCodeAt(3) << 24);
}
function $633d7bf8781e6353$var$int32ToFourCC(value) {
    return String.fromCharCode(value & 0xff, value >> 8 & 0xff, value >> 16 & 0xff, value >> 24 & 0xff);
}
var $633d7bf8781e6353$var$headerLengthInt = 31; // The header length in 32 bit ints
var $633d7bf8781e6353$var$FOURCC_DXT1 = $633d7bf8781e6353$var$fourCCToInt32("DXT1");
var $633d7bf8781e6353$var$FOURCC_DXT3 = $633d7bf8781e6353$var$fourCCToInt32("DXT3");
var $633d7bf8781e6353$var$FOURCC_DXT5 = $633d7bf8781e6353$var$fourCCToInt32("DXT5");
// Offsets into the header array
var $633d7bf8781e6353$var$off_magic = 0;
var $633d7bf8781e6353$var$off_size = 1;
var $633d7bf8781e6353$var$off_flags = 2;
var $633d7bf8781e6353$var$off_height = 3;
var $633d7bf8781e6353$var$off_width = 4;
var $633d7bf8781e6353$var$off_mipmapCount = 7;
var $633d7bf8781e6353$var$off_pfFlags = 20;
var $633d7bf8781e6353$var$off_pfFourCC = 21;
var $633d7bf8781e6353$var$off_caps = 27;
var $633d7bf8781e6353$var$off_caps2 = 28;
var $633d7bf8781e6353$var$off_caps3 = 29;
var $633d7bf8781e6353$var$off_caps4 = 30;
var $633d7bf8781e6353$var$ret = {
    parse: function(arrayBuffer, out) {
        var header = new Int32Array(arrayBuffer, 0, $633d7bf8781e6353$var$headerLengthInt);
        if (header[$633d7bf8781e6353$var$off_magic] !== $633d7bf8781e6353$var$DDS_MAGIC) return null;
        if (!header($633d7bf8781e6353$var$off_pfFlags) & $633d7bf8781e6353$var$DDPF_FOURCC) return null;
        var fourCC = header($633d7bf8781e6353$var$off_pfFourCC);
        var width = header[$633d7bf8781e6353$var$off_width];
        var height = header[$633d7bf8781e6353$var$off_height];
        var isCubeMap = header[$633d7bf8781e6353$var$off_caps2] & $633d7bf8781e6353$var$DDSCAPS2_CUBEMAP;
        var hasMipmap = header[$633d7bf8781e6353$var$off_flags] & $633d7bf8781e6353$var$DDSD_MIPMAPCOUNT;
        var blockBytes, internalFormat;
        switch(fourCC){
            case $633d7bf8781e6353$var$FOURCC_DXT1:
                blockBytes = 8;
                internalFormat = (0, $4261427f149675a4$export$2e2bcd8739ae039).COMPRESSED_RGB_S3TC_DXT1_EXT;
                break;
            case $633d7bf8781e6353$var$FOURCC_DXT3:
                blockBytes = 16;
                internalFormat = (0, $4261427f149675a4$export$2e2bcd8739ae039).COMPRESSED_RGBA_S3TC_DXT3_EXT;
                break;
            case $633d7bf8781e6353$var$FOURCC_DXT5:
                blockBytes = 16;
                internalFormat = (0, $4261427f149675a4$export$2e2bcd8739ae039).COMPRESSED_RGBA_S3TC_DXT5_EXT;
                break;
            default:
                return null;
        }
        var dataOffset = header[$633d7bf8781e6353$var$off_size] + 4;
        // TODO: Suppose all face are existed
        var faceNumber = isCubeMap ? 6 : 1;
        var mipmapCount = 1;
        if (hasMipmap) mipmapCount = Math.max(1, header[$633d7bf8781e6353$var$off_mipmapCount]);
        var textures = [];
        for(var f = 0; f < faceNumber; f++){
            var _width = width;
            var _height = height;
            textures[f] = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
                width: _width,
                height: _height,
                format: internalFormat
            });
            var mipmaps = [];
            for(var i = 0; i < mipmapCount; i++){
                var dataLength = Math.max(4, _width) / 4 * Math.max(4, _height) / 4 * blockBytes;
                var byteArray = new Uint8Array(arrayBuffer, dataOffset, dataLength);
                dataOffset += dataLength;
                _width *= 0.5;
                _height *= 0.5;
                mipmaps[i] = byteArray;
            }
            textures[f].pixels = mipmaps[0];
            if (hasMipmap) textures[f].mipmaps = mipmaps;
        }
        // TODO
        // return isCubeMap ? textures : textures[0];
        if (out) {
            out.width = textures[0].width;
            out.height = textures[0].height;
            out.format = textures[0].format;
            out.pixels = textures[0].pixels;
            out.mipmaps = textures[0].mipmaps;
        } else return textures[0];
    }
};
var $633d7bf8781e6353$export$2e2bcd8739ae039 = $633d7bf8781e6353$var$ret;




var $be26fdf08ce94c8d$var$toChar = String.fromCharCode;
var $be26fdf08ce94c8d$var$MINELEN = 8;
var $be26fdf08ce94c8d$var$MAXELEN = 0x7fff;
function $be26fdf08ce94c8d$var$rgbe2float(rgbe, buffer, offset, exposure) {
    if (rgbe[3] > 0) {
        var f = Math.pow(2.0, rgbe[3] - 128 - 8 + exposure);
        buffer[offset + 0] = rgbe[0] * f;
        buffer[offset + 1] = rgbe[1] * f;
        buffer[offset + 2] = rgbe[2] * f;
    } else {
        buffer[offset + 0] = 0;
        buffer[offset + 1] = 0;
        buffer[offset + 2] = 0;
    }
    buffer[offset + 3] = 1.0;
    return buffer;
}
function $be26fdf08ce94c8d$var$uint82string(array, offset, size) {
    var str = "";
    for(var i = offset; i < size; i++)str += $be26fdf08ce94c8d$var$toChar(array[i]);
    return str;
}
function $be26fdf08ce94c8d$var$copyrgbe(s, t) {
    t[0] = s[0];
    t[1] = s[1];
    t[2] = s[2];
    t[3] = s[3];
}
// TODO : check
function $be26fdf08ce94c8d$var$oldReadColors(scan, buffer, offset, xmax) {
    var rshift = 0, x = 0, len = xmax;
    while(len > 0){
        scan[x][0] = buffer[offset++];
        scan[x][1] = buffer[offset++];
        scan[x][2] = buffer[offset++];
        scan[x][3] = buffer[offset++];
        if (scan[x][0] === 1 && scan[x][1] === 1 && scan[x][2] === 1) {
            // exp is count of repeated pixels
            for(var i = scan[x][3] << rshift >>> 0; i > 0; i--){
                $be26fdf08ce94c8d$var$copyrgbe(scan[x - 1], scan[x]);
                x++;
                len--;
            }
            rshift += 8;
        } else {
            x++;
            len--;
            rshift = 0;
        }
    }
    return offset;
}
function $be26fdf08ce94c8d$var$readColors(scan, buffer, offset, xmax) {
    if (xmax < $be26fdf08ce94c8d$var$MINELEN | xmax > $be26fdf08ce94c8d$var$MAXELEN) return $be26fdf08ce94c8d$var$oldReadColors(scan, buffer, offset, xmax);
    var i = buffer[offset++];
    if (i != 2) return $be26fdf08ce94c8d$var$oldReadColors(scan, buffer, offset - 1, xmax);
    scan[0][1] = buffer[offset++];
    scan[0][2] = buffer[offset++];
    i = buffer[offset++];
    if ((scan[0][2] << 8 >>> 0 | i) >>> 0 !== xmax) return null;
    for(var i = 0; i < 4; i++)for(var x = 0; x < xmax;){
        var code = buffer[offset++];
        if (code > 128) {
            code = (code & 127) >>> 0;
            var val = buffer[offset++];
            while(code--)scan[x++][i] = val;
        } else while(code--)scan[x++][i] = buffer[offset++];
    }
    return offset;
}
var $be26fdf08ce94c8d$var$ret = {
    // http://www.graphics.cornell.edu/~bjw/rgbe.html
    // Blender source
    // http://radsite.lbl.gov/radiance/refer/Notes/picture_format.html
    parseRGBE: function(arrayBuffer, texture, exposure) {
        if (exposure == null) exposure = 0;
        var data = new Uint8Array(arrayBuffer);
        var size = data.length;
        if ($be26fdf08ce94c8d$var$uint82string(data, 0, 2) !== "#?") return;
        // find empty line, next line is resolution info
        for(var i = 2; i < size; i++){
            if ($be26fdf08ce94c8d$var$toChar(data[i]) === "\n" && $be26fdf08ce94c8d$var$toChar(data[i + 1]) === "\n") break;
        }
        if (i >= size) return;
        // find resolution info line
        i += 2;
        var str = "";
        for(; i < size; i++){
            var _char = $be26fdf08ce94c8d$var$toChar(data[i]);
            if (_char === "\n") break;
            str += _char;
        }
        // -Y M +X N
        var tmp = str.split(" ");
        var height = parseInt(tmp[1]);
        var width = parseInt(tmp[3]);
        if (!width || !height) return;
        // read and decode actual data
        var offset = i + 1;
        var scanline = [];
        // memzero
        for(var x = 0; x < width; x++){
            scanline[x] = [];
            for(var j = 0; j < 4; j++)scanline[x][j] = 0;
        }
        var pixels = new Float32Array(width * height * 4);
        var offset2 = 0;
        for(var y = 0; y < height; y++){
            var offset = $be26fdf08ce94c8d$var$readColors(scanline, data, offset, width);
            if (!offset) return null;
            for(var x = 0; x < width; x++){
                $be26fdf08ce94c8d$var$rgbe2float(scanline[x], pixels, offset2, exposure);
                offset2 += 4;
            }
        }
        if (!texture) texture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)();
        texture.width = width;
        texture.height = height;
        texture.pixels = pixels;
        // HALF_FLOAT can't use Float32Array
        texture.type = (0, $4261427f149675a4$export$2e2bcd8739ae039).FLOAT;
        return texture;
    },
    parseRGBEFromPNG: function(png) {}
};
var $be26fdf08ce94c8d$export$2e2bcd8739ae039 = $be26fdf08ce94c8d$var$ret;


/**
 * @alias clay.util.texture
 */ var $f6d4d59e8da69524$var$textureUtil = {
    /**
     * @param  {string|object} path
     * @param  {object} [option]
     * @param  {Function} [onsuccess]
     * @param  {Function} [onerror]
     * @return {clay.Texture}
     */ loadTexture: function(path, option, onsuccess, onerror) {
        var texture;
        if (typeof option === "function") {
            onsuccess = option;
            onerror = onsuccess;
            option = {};
        } else option = option || {};
        if (typeof path === "string") {
            if (path.match(/.hdr$/) || option.fileType === "hdr") {
                texture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
                    width: 0,
                    height: 0,
                    sRGB: false
                });
                $f6d4d59e8da69524$var$textureUtil._fetchTexture(path, function(data) {
                    (0, $be26fdf08ce94c8d$export$2e2bcd8739ae039).parseRGBE(data, texture, option.exposure);
                    texture.dirty();
                    onsuccess && onsuccess(texture);
                }, onerror);
                return texture;
            } else if (path.match(/.dds$/) || option.fileType === "dds") {
                texture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
                    width: 0,
                    height: 0
                });
                $f6d4d59e8da69524$var$textureUtil._fetchTexture(path, function(data) {
                    (0, $633d7bf8781e6353$export$2e2bcd8739ae039).parse(data, texture);
                    texture.dirty();
                    onsuccess && onsuccess(texture);
                }, onerror);
            } else {
                texture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)();
                texture.load(path);
                texture.success(onsuccess);
                texture.error(onerror);
            }
        } else if (typeof path === "object" && typeof path.px !== "undefined") {
            texture = new (0, $8dbf947c9de660dd$export$2e2bcd8739ae039)();
            texture.load(path);
            texture.success(onsuccess);
            texture.error(onerror);
        }
        return texture;
    },
    /**
     * Load a panorama texture and render it to a cube map
     * @param  {clay.Renderer} renderer
     * @param  {string} path
     * @param  {clay.TextureCube} cubeMap
     * @param  {object} [option]
     * @param  {boolean} [option.encodeRGBM]
     * @param  {number} [option.exposure]
     * @param  {Function} [onsuccess]
     * @param  {Function} [onerror]
     */ loadPanorama: function(renderer, path, cubeMap, option, onsuccess, onerror) {
        var self = this;
        if (typeof option === "function") {
            onsuccess = option;
            onerror = onsuccess;
            option = {};
        } else option = option || {};
        $f6d4d59e8da69524$var$textureUtil.loadTexture(path, option, function(texture) {
            // PENDING
            texture.flipY = option.flipY || false;
            self.panoramaToCubeMap(renderer, texture, cubeMap, option);
            texture.dispose(renderer);
            onsuccess && onsuccess(cubeMap);
        }, onerror);
    },
    /**
     * Render a panorama texture to a cube map
     * @param  {clay.Renderer} renderer
     * @param  {clay.Texture2D} panoramaMap
     * @param  {clay.TextureCube} cubeMap
     * @param  {Object} option
     * @param  {boolean} [option.encodeRGBM]
     */ panoramaToCubeMap: function(renderer, panoramaMap, cubeMap, option) {
        var environmentMapPass = new (0, $903ac207f318e53a$export$2e2bcd8739ae039)();
        var skydome = new (0, $a928f7c7df5943e2$export$2e2bcd8739ae039)({
            scene: new (0, $e49354c4f1efd6e1$export$2e2bcd8739ae039)()
        });
        skydome.setEnvironmentMap(panoramaMap);
        option = option || {};
        if (option.encodeRGBM) skydome.material.define("fragment", "RGBM_ENCODE");
        // Share sRGB
        cubeMap.sRGB = panoramaMap.sRGB;
        environmentMapPass.texture = cubeMap;
        environmentMapPass.render(renderer, skydome.scene);
        environmentMapPass.texture = null;
        environmentMapPass.dispose(renderer);
        return cubeMap;
    },
    /**
     * Convert height map to normal map
     * @param {HTMLImageElement|HTMLCanvasElement} image
     * @param {boolean} [checkBump=false]
     * @return {HTMLCanvasElement}
     */ heightToNormal: function(image, checkBump) {
        var canvas = document.createElement("canvas");
        var width = canvas.width = image.width;
        var height = canvas.height = image.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, width, height);
        checkBump = checkBump || false;
        var srcData = ctx.getImageData(0, 0, width, height);
        var dstData = ctx.createImageData(width, height);
        for(var i = 0; i < srcData.data.length; i += 4){
            if (checkBump) {
                var r = srcData.data[i];
                var g = srcData.data[i + 1];
                var b = srcData.data[i + 2];
                var diff = Math.abs(r - g) + Math.abs(g - b);
                if (diff > 20) {
                    console.warn("Given image is not a height map");
                    return image;
                }
            }
            // Modified from http://mrdoob.com/lab/javascript/height2normal/
            var x1, y1, x2, y2;
            if (i % (width * 4) === 0) {
                // left edge
                x1 = srcData.data[i];
                x2 = srcData.data[i + 4];
            } else if (i % (width * 4) === (width - 1) * 4) {
                // right edge
                x1 = srcData.data[i - 4];
                x2 = srcData.data[i];
            } else {
                x1 = srcData.data[i - 4];
                x2 = srcData.data[i + 4];
            }
            if (i < width * 4) {
                // top edge
                y1 = srcData.data[i];
                y2 = srcData.data[i + width * 4];
            } else if (i > width * (height - 1) * 4) {
                // bottom edge
                y1 = srcData.data[i - width * 4];
                y2 = srcData.data[i];
            } else {
                y1 = srcData.data[i - width * 4];
                y2 = srcData.data[i + width * 4];
            }
            dstData.data[i] = x1 - x2 + 127;
            dstData.data[i + 1] = y1 - y2 + 127;
            dstData.data[i + 2] = 255;
            dstData.data[i + 3] = 255;
        }
        ctx.putImageData(dstData, 0, 0);
        return canvas;
    },
    /**
     * Convert height map to normal map
     * @param {HTMLImageElement|HTMLCanvasElement} image
     * @param {boolean} [checkBump=false]
     * @param {number} [threshold=20]
     * @return {HTMLCanvasElement}
     */ isHeightImage: function(img, downScaleSize, threshold) {
        if (!img || !img.width || !img.height) return false;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        var size = downScaleSize || 32;
        threshold = threshold || 20;
        canvas.width = canvas.height = size;
        ctx.drawImage(img, 0, 0, size, size);
        var srcData = ctx.getImageData(0, 0, size, size);
        for(var i = 0; i < srcData.data.length; i += 4){
            var r = srcData.data[i];
            var g = srcData.data[i + 1];
            var b = srcData.data[i + 2];
            var diff = Math.abs(r - g) + Math.abs(g - b);
            if (diff > threshold) return false;
        }
        return true;
    },
    _fetchTexture: function(path, onsuccess, onerror) {
        (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).request.get({
            url: path,
            responseType: "arraybuffer",
            onload: onsuccess,
            onerror: onerror
        });
    },
    /**
     * Create a chessboard texture
     * @param  {number} [size]
     * @param  {number} [unitSize]
     * @param  {string} [color1]
     * @param  {string} [color2]
     * @return {clay.Texture2D}
     */ createChessboard: function(size, unitSize, color1, color2) {
        size = size || 512;
        unitSize = unitSize || 64;
        color1 = color1 || "black";
        color2 = color2 || "white";
        var repeat = Math.ceil(size / unitSize);
        var canvas = document.createElement("canvas");
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext("2d");
        ctx.fillStyle = color2;
        ctx.fillRect(0, 0, size, size);
        ctx.fillStyle = color1;
        for(var i = 0; i < repeat; i++)for(var j = 0; j < repeat; j++){
            var isFill = j % 2 ? i % 2 : i % 2 - 1;
            if (isFill) ctx.fillRect(i * unitSize, j * unitSize, unitSize, unitSize);
        }
        var texture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
            image: canvas,
            anisotropic: 8
        });
        return texture;
    },
    /**
     * Create a blank pure color 1x1 texture
     * @param  {string} color
     * @return {clay.Texture2D}
     */ createBlank: function(color) {
        var canvas = document.createElement("canvas");
        canvas.width = 1;
        canvas.height = 1;
        var ctx = canvas.getContext("2d");
        ctx.fillStyle = color;
        ctx.fillRect(0, 0, 1, 1);
        var texture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
            image: canvas
        });
        return texture;
    }
};
var $f6d4d59e8da69524$export$2e2bcd8739ae039 = $f6d4d59e8da69524$var$textureUtil;


/**
 * Surface texture in the 3D scene.
 * Provide management and rendering of zrender shapes and groups
 *
 * @module echarts-gl/util/EChartsSurface
 * @author Yi Shen(http://github.com/pissang)
 */ 


var $7f10657aa3c18c20$var$events = [
    "mousedown",
    "mouseup",
    "mousemove",
    "mouseover",
    "mouseout",
    "click",
    "dblclick",
    "contextmenu"
];
function $7f10657aa3c18c20$var$makeHandlerName(eventName) {
    return "_on" + eventName;
}
/**
 * @constructor
 * @alias echarts-gl/util/EChartsSurface
 * @param {module:echarts~ECharts} chart
 */ var $7f10657aa3c18c20$var$EChartsSurface = function(chart) {
    var self = this;
    this._texture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        anisotropic: 32,
        flipY: false,
        surface: this,
        dispose: function(renderer) {
            self.dispose();
            (0, $b7751fad94c1afee$export$2e2bcd8739ae039).prototype.dispose.call(this, renderer);
        }
    });
    $7f10657aa3c18c20$var$events.forEach(function(eventName) {
        this[$7f10657aa3c18c20$var$makeHandlerName(eventName)] = function(eveObj) {
            if (!eveObj.triangle) return;
            this._meshes.forEach(function(mesh) {
                this.dispatchEvent(eventName, mesh, eveObj.triangle, eveObj.point);
            }, this);
        };
    }, this);
    this._meshes = [];
    if (chart) this.setECharts(chart);
     // Texture updated callback;
    this.onupdate = null;
};
$7f10657aa3c18c20$var$EChartsSurface.prototype = {
    constructor: $7f10657aa3c18c20$var$EChartsSurface,
    getTexture: function() {
        return this._texture;
    },
    setECharts: function(chart) {
        this._chart = chart;
        var canvas = chart.getDom();
        if (!(canvas instanceof HTMLCanvasElement)) {
            console.error("ECharts must init on canvas if it is used as texture."); // Use an empty canvas
            canvas = document.createElement("canvas");
        } else {
            var self = this; // Wrap refreshImmediately
            var zr = chart.getZr();
            var oldRefreshImmediately = zr.__oldRefreshImmediately || zr.refreshImmediately;
            zr.refreshImmediately = function() {
                oldRefreshImmediately.call(this);
                self._texture.dirty();
                self.onupdate && self.onupdate();
            };
            zr.__oldRefreshImmediately = oldRefreshImmediately;
        }
        this._texture.image = canvas;
        this._texture.dirty();
        this.onupdate && this.onupdate();
    },
    /**
   * @method
   * @param {clay.Mesh} attachedMesh
   * @param {Array.<number>} triangle Triangle indices
   * @param {clay.math.Vector3} point
   */ dispatchEvent: function() {
        var p0 = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
        var p1 = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
        var p2 = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
        var uv0 = new (0, $2cb41795bddfe4d3$export$2e2bcd8739ae039)();
        var uv1 = new (0, $2cb41795bddfe4d3$export$2e2bcd8739ae039)();
        var uv2 = new (0, $2cb41795bddfe4d3$export$2e2bcd8739ae039)();
        var uv = new (0, $2cb41795bddfe4d3$export$2e2bcd8739ae039)();
        var vCross = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
        return function(eventName, attachedMesh, triangle, point) {
            var geo = attachedMesh.geometry;
            var position = geo.attributes.position;
            var texcoord = geo.attributes.texcoord0;
            var dot = (0, $27fea36417076c2d$export$2e2bcd8739ae039).dot;
            var cross = (0, $27fea36417076c2d$export$2e2bcd8739ae039).cross;
            position.get(triangle[0], p0.array);
            position.get(triangle[1], p1.array);
            position.get(triangle[2], p2.array);
            texcoord.get(triangle[0], uv0.array);
            texcoord.get(triangle[1], uv1.array);
            texcoord.get(triangle[2], uv2.array);
            cross(vCross, p1, p2);
            var det = dot(p0, vCross);
            var t = dot(point, vCross) / det;
            cross(vCross, p2, p0);
            var u = dot(point, vCross) / det;
            cross(vCross, p0, p1);
            var v = dot(point, vCross) / det;
            (0, $2cb41795bddfe4d3$export$2e2bcd8739ae039).scale(uv, uv0, t);
            (0, $2cb41795bddfe4d3$export$2e2bcd8739ae039).scaleAndAdd(uv, uv, uv1, u);
            (0, $2cb41795bddfe4d3$export$2e2bcd8739ae039).scaleAndAdd(uv, uv, uv2, v);
            var x = uv.x * this._chart.getWidth();
            var y = uv.y * this._chart.getHeight();
            this._chart.getZr().handler.dispatch(eventName, {
                zrX: x,
                zrY: y
            });
        };
    }(),
    attachToMesh: function(mesh) {
        if (this._meshes.indexOf(mesh) >= 0) return;
        $7f10657aa3c18c20$var$events.forEach(function(eventName) {
            mesh.on(eventName, this[$7f10657aa3c18c20$var$makeHandlerName(eventName)], this);
        }, this);
        this._meshes.push(mesh);
    },
    detachFromMesh: function(mesh) {
        var idx = this._meshes.indexOf(mesh);
        if (idx >= 0) this._meshes.splice(idx, 1);
        $7f10657aa3c18c20$var$events.forEach(function(eventName) {
            mesh.off(eventName, this[$7f10657aa3c18c20$var$makeHandlerName(eventName)]);
        }, this);
    },
    dispose: function() {
        this._meshes.forEach(function(mesh) {
            this.detachFromMesh(mesh);
        }, this);
    }
};
var $7f10657aa3c18c20$export$2e2bcd8739ae039 = $7f10657aa3c18c20$var$EChartsSurface;


// https://docs.unrealengine.com/latest/INT/Engine/Rendering/LightingAndShadows/AmbientCubemap/

// Cubemap prefilter utility
// http://www.unrealengine.com/files/downloads/2013SiggraphPresentationsNotes.pdf
// http://http.developer.nvidia.com/GPUGems3/gpugems3_ch20.html






/**
 * @constructor clay.camera.Orthographic
 * @extends clay.Camera
 */ var $c4a0e1584dbfc1e9$var$Orthographic = (0, $abb2ad6f174841b9$export$2e2bcd8739ae039).extend(/** @lends clay.camera.Orthographic# */ {
    /**
     * @type {number}
     */ left: -1,
    /**
     * @type {number}
     */ right: 1,
    /**
     * @type {number}
     */ near: -1,
    /**
     * @type {number}
     */ far: 1,
    /**
     * @type {number}
     */ top: 1,
    /**
     * @type {number}
     */ bottom: -1
}, /** @lends clay.camera.Orthographic.prototype */ {
    updateProjectionMatrix: function() {
        this.projectionMatrix.ortho(this.left, this.right, this.bottom, this.top, this.near, this.far);
    },
    decomposeProjectionMatrix: function() {
        var m = this.projectionMatrix.array;
        this.left = (-1 - m[12]) / m[0];
        this.right = (1 - m[12]) / m[0];
        this.top = (1 - m[13]) / m[5];
        this.bottom = (-1 - m[13]) / m[5];
        this.near = -(-1 - m[14]) / m[10];
        this.far = -(1 - m[14]) / m[10];
    },
    /**
     * @return {clay.camera.Orthographic}
     */ clone: function() {
        var camera = (0, $abb2ad6f174841b9$export$2e2bcd8739ae039).prototype.clone.call(this);
        camera.left = this.left;
        camera.right = this.right;
        camera.near = this.near;
        camera.far = this.far;
        camera.top = this.top;
        camera.bottom = this.bottom;
        return camera;
    }
});
var $c4a0e1584dbfc1e9$export$2e2bcd8739ae039 = $c4a0e1584dbfc1e9$var$Orthographic;







var $235ccf7aaa9c8d9c$export$2e2bcd8739ae039 = "\n@export clay.compositor.vertex\nuniform mat4 worldViewProjection : WORLDVIEWPROJECTION;\nattribute vec3 position : POSITION;\nattribute vec2 texcoord : TEXCOORD_0;\nvarying vec2 v_Texcoord;\nvoid main()\n{\n v_Texcoord = texcoord;\n gl_Position = worldViewProjection * vec4(position, 1.0);\n}\n@end";


(0, $90e78c81ac16d455$export$2e2bcd8739ae039)["import"]((0, $235ccf7aaa9c8d9c$export$2e2bcd8739ae039));
var $d7434f22747948c5$var$planeGeo = new (0, $b1c813646bb685e2$export$2e2bcd8739ae039)();
var $d7434f22747948c5$var$mesh = new (0, $652fd5cc6a0444a2$export$2e2bcd8739ae039)({
    geometry: $d7434f22747948c5$var$planeGeo,
    frustumCulling: false
});
var $d7434f22747948c5$var$camera = new (0, $c4a0e1584dbfc1e9$export$2e2bcd8739ae039)();
/**
 * @constructor clay.compositor.Pass
 * @extends clay.core.Base
 */ var $d7434f22747948c5$var$Pass = (0, $7c62670c05885275$export$2e2bcd8739ae039).extend(function() {
    return /** @lends clay.compositor.Pass# */ {
        /**
         * Fragment shader string
         * @type {string}
         */ // PENDING shader or fragment ?
        fragment: "",
        /**
         * @type {Object}
         */ outputs: null,
        /**
         * @type {clay.Material}
         */ material: null,
        /**
         * @type {Boolean}
         */ blendWithPrevious: false,
        /**
         * @type {Boolean}
         */ clearColor: false,
        /**
         * @type {Boolean}
         */ clearDepth: true
    };
}, function() {
    var shader = new (0, $90e78c81ac16d455$export$2e2bcd8739ae039)((0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("clay.compositor.vertex"), this.fragment);
    var material = new (0, $b70ebca493753aba$export$2e2bcd8739ae039)({
        shader: shader
    });
    material.enableTexturesAll();
    this.material = material;
}, /** @lends clay.compositor.Pass.prototype */ {
    /**
     * @param {string} name
     * @param {} value
     */ setUniform: function(name, value) {
        this.material.setUniform(name, value);
    },
    /**
     * @param  {string} name
     * @return {}
     */ getUniform: function(name) {
        var uniform = this.material.uniforms[name];
        if (uniform) return uniform.value;
    },
    /**
     * @param  {clay.Texture} texture
     * @param  {number} attachment
     */ attachOutput: function(texture, attachment) {
        if (!this.outputs) this.outputs = {};
        attachment = attachment || (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).COLOR_ATTACHMENT0;
        this.outputs[attachment] = texture;
    },
    /**
     * @param  {clay.Texture} texture
     */ detachOutput: function(texture) {
        for(var attachment in this.outputs)if (this.outputs[attachment] === texture) this.outputs[attachment] = null;
    },
    bind: function(renderer, frameBuffer) {
        if (this.outputs) for(var attachment in this.outputs){
            var texture = this.outputs[attachment];
            if (texture) frameBuffer.attach(texture, attachment);
        }
        if (frameBuffer) frameBuffer.bind(renderer);
    },
    unbind: function(renderer, frameBuffer) {
        frameBuffer.unbind(renderer);
    },
    /**
     * @param  {clay.Renderer} renderer
     * @param  {clay.FrameBuffer} [frameBuffer]
     */ render: function(renderer, frameBuffer) {
        var _gl = renderer.gl;
        if (frameBuffer) {
            this.bind(renderer, frameBuffer);
            // MRT Support in chrome
            // https://www.khronos.org/registry/webgl/sdk/tests/conformance/extensions/ext-draw-buffers.html
            var ext = renderer.getGLExtension("EXT_draw_buffers");
            if (ext && this.outputs) {
                var bufs = [];
                for(var attachment in this.outputs){
                    attachment = +attachment;
                    if (attachment >= _gl.COLOR_ATTACHMENT0 && attachment <= _gl.COLOR_ATTACHMENT0 + 8) bufs.push(attachment);
                }
                ext.drawBuffersEXT(bufs);
            }
        }
        this.trigger("beforerender", this, renderer);
        // FIXME Don't clear in each pass in default, let the color overwrite the buffer
        // FIXME pixels may be discard
        var clearBit = this.clearDepth ? _gl.DEPTH_BUFFER_BIT : 0;
        _gl.depthMask(true);
        if (this.clearColor) {
            clearBit = clearBit | _gl.COLOR_BUFFER_BIT;
            _gl.colorMask(true, true, true, true);
            var cc = this.clearColor;
            if (Array.isArray(cc)) _gl.clearColor(cc[0], cc[1], cc[2], cc[3]);
        }
        _gl.clear(clearBit);
        if (this.blendWithPrevious) {
            // Blend with previous rendered scene in the final output
            // FIXME Configure blend.
            // FIXME It will cause screen blink？
            _gl.enable(_gl.BLEND);
            this.material.transparent = true;
        } else {
            _gl.disable(_gl.BLEND);
            this.material.transparent = false;
        }
        this.renderQuad(renderer);
        this.trigger("afterrender", this, renderer);
        if (frameBuffer) this.unbind(renderer, frameBuffer);
    },
    /**
     * Simply do quad rendering
     */ renderQuad: function(renderer) {
        $d7434f22747948c5$var$mesh.material = this.material;
        renderer.renderPass([
            $d7434f22747948c5$var$mesh
        ], $d7434f22747948c5$var$camera);
    },
    /**
     * @param  {clay.Renderer} renderer
     */ dispose: function(renderer) {}
});
var $d7434f22747948c5$export$2e2bcd8739ae039 = $d7434f22747948c5$var$Pass;









var $f960f255e5621d57$export$2e2bcd8739ae039 = "#define SAMPLE_NUMBER 1024\n#define PI 3.14159265358979\nuniform sampler2D normalDistribution;\nuniform vec2 viewportSize : [512, 256];\nconst vec3 N = vec3(0.0, 0.0, 1.0);\nconst float fSampleNumber = float(SAMPLE_NUMBER);\nvec3 importanceSampleNormal(float i, float roughness, vec3 N) {\n vec3 H = texture2D(normalDistribution, vec2(roughness, i)).rgb;\n vec3 upVector = abs(N.y) > 0.999 ? vec3(1.0, 0.0, 0.0) : vec3(0.0, 1.0, 0.0);\n vec3 tangentX = normalize(cross(N, upVector));\n vec3 tangentZ = cross(N, tangentX);\n return normalize(tangentX * H.x + N * H.y + tangentZ * H.z);\n}\nfloat G_Smith(float roughness, float NoV, float NoL) {\n float k = roughness * roughness / 2.0;\n float G1V = NoV / (NoV * (1.0 - k) + k);\n float G1L = NoL / (NoL * (1.0 - k) + k);\n return G1L * G1V;\n}\nvoid main() {\n vec2 uv = gl_FragCoord.xy / viewportSize;\n float NoV = uv.x;\n float roughness = uv.y;\n vec3 V;\n V.x = sqrt(1.0 - NoV * NoV);\n V.y = 0.0;\n V.z = NoV;\n float A = 0.0;\n float B = 0.0;\n for (int i = 0; i < SAMPLE_NUMBER; i++) {\n vec3 H = importanceSampleNormal(float(i) / fSampleNumber, roughness, N);\n vec3 L = reflect(-V, H);\n float NoL = clamp(L.z, 0.0, 1.0);\n float NoH = clamp(H.z, 0.0, 1.0);\n float VoH = clamp(dot(V, H), 0.0, 1.0);\n if (NoL > 0.0) {\n float G = G_Smith(roughness, NoV, NoL);\n float G_Vis = G * VoH / (NoH * NoV);\n float Fc = pow(1.0 - VoH, 5.0);\n A += (1.0 - Fc) * G_Vis;\n B += Fc * G_Vis;\n }\n }\n gl_FragColor = vec4(vec2(A, B) / fSampleNumber, 0.0, 1.0);\n}\n";


var $2d7f02abf8e95067$export$2e2bcd8739ae039 = "#define SHADER_NAME prefilter\n#define SAMPLE_NUMBER 1024\n#define PI 3.14159265358979\nuniform mat4 viewInverse : VIEWINVERSE;\nuniform samplerCube environmentMap;\nuniform sampler2D normalDistribution;\nuniform float roughness : 0.5;\nvarying vec2 v_Texcoord;\nvarying vec3 v_WorldPosition;\n@import clay.util.rgbm\nvec3 importanceSampleNormal(float i, float roughness, vec3 N) {\n vec3 H = texture2D(normalDistribution, vec2(roughness, i)).rgb;\n vec3 upVector = abs(N.y) > 0.999 ? vec3(1.0, 0.0, 0.0) : vec3(0.0, 1.0, 0.0);\n vec3 tangentX = normalize(cross(N, upVector));\n vec3 tangentZ = cross(N, tangentX);\n return normalize(tangentX * H.x + N * H.y + tangentZ * H.z);\n}\nvoid main() {\n vec3 eyePos = viewInverse[3].xyz;\n vec3 V = normalize(v_WorldPosition - eyePos);\n vec3 N = V;\n vec3 prefilteredColor = vec3(0.0);\n float totalWeight = 0.0;\n float fMaxSampleNumber = float(SAMPLE_NUMBER);\n for (int i = 0; i < SAMPLE_NUMBER; i++) {\n vec3 H = importanceSampleNormal(float(i) / fMaxSampleNumber, roughness, N);\n vec3 L = reflect(-V, H);\n float NoL = clamp(dot(N, L), 0.0, 1.0);\n if (NoL > 0.0) {\n prefilteredColor += decodeHDR(textureCube(environmentMap, L)).rgb * NoL;\n totalWeight += NoL;\n }\n }\n gl_FragColor = encodeHDR(vec4(prefilteredColor / totalWeight, 1.0));\n}\n";


var $2d9094f0aba26ce5$var$cubemapUtil = {};
var $2d9094f0aba26ce5$var$targets = [
    "px",
    "nx",
    "py",
    "ny",
    "pz",
    "nz"
];
// TODO Downsample
/**
 * @name clay.util.cubemap.prefilterEnvironmentMap
 * @param  {clay.Renderer} renderer
 * @param  {clay.Texture} envMap
 * @param  {Object} [textureOpts]
 * @param  {number} [textureOpts.width=64]
 * @param  {number} [textureOpts.height=64]
 * @param  {number} [textureOpts.type]
 * @param  {boolean} [textureOpts.encodeRGBM=false]
 * @param  {boolean} [textureOpts.decodeRGBM=false]
 * @param  {clay.Texture2D} [normalDistribution]
 * @param  {clay.Texture2D} [brdfLookup]
 */ $2d9094f0aba26ce5$var$cubemapUtil.prefilterEnvironmentMap = function(renderer, envMap, textureOpts, normalDistribution, brdfLookup) {
    // Not create other renderer, it is easy having issue of cross reference of resources like framebuffer
    // PENDING preserveDrawingBuffer?
    if (!brdfLookup || !normalDistribution) {
        normalDistribution = $2d9094f0aba26ce5$var$cubemapUtil.generateNormalDistribution();
        brdfLookup = $2d9094f0aba26ce5$var$cubemapUtil.integrateBRDF(renderer, normalDistribution);
    }
    textureOpts = textureOpts || {};
    var width = textureOpts.width || 64;
    var height = textureOpts.height || 64;
    var textureType = textureOpts.type || envMap.type;
    // Use same type with given envMap
    var prefilteredCubeMap = new (0, $8dbf947c9de660dd$export$2e2bcd8739ae039)({
        width: width,
        height: height,
        type: textureType,
        flipY: false,
        mipmaps: []
    });
    if (!prefilteredCubeMap.isPowerOfTwo()) console.warn("Width and height must be power of two to enable mipmap.");
    var size = Math.min(width, height);
    var mipmapNum = Math.log(size) / Math.log(2) + 1;
    var prefilterMaterial = new (0, $b70ebca493753aba$export$2e2bcd8739ae039)({
        shader: new (0, $90e78c81ac16d455$export$2e2bcd8739ae039)({
            vertex: (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("clay.skybox.vertex"),
            fragment: (0, $2d7f02abf8e95067$export$2e2bcd8739ae039)
        })
    });
    prefilterMaterial.set("normalDistribution", normalDistribution);
    textureOpts.encodeRGBM && prefilterMaterial.define("fragment", "RGBM_ENCODE");
    textureOpts.decodeRGBM && prefilterMaterial.define("fragment", "RGBM_DECODE");
    var dummyScene = new (0, $e49354c4f1efd6e1$export$2e2bcd8739ae039)();
    var skyEnv;
    if (envMap.textureType === "texture2D") {
        // Convert panorama to cubemap
        var envCubemap = new (0, $8dbf947c9de660dd$export$2e2bcd8739ae039)({
            width: width,
            height: height,
            // FIXME FLOAT type will cause GL_FRAMEBUFFER_INCOMPLETE_ATTACHMENT error on iOS
            type: textureType === (0, $4261427f149675a4$export$2e2bcd8739ae039).FLOAT ? (0, $4261427f149675a4$export$2e2bcd8739ae039).HALF_FLOAT : textureType
        });
        (0, $f6d4d59e8da69524$export$2e2bcd8739ae039).panoramaToCubeMap(renderer, envMap, envCubemap, {
            // PENDING encodeRGBM so it can be decoded as RGBM
            encodeRGBM: textureOpts.decodeRGBM
        });
        envMap = envCubemap;
    }
    skyEnv = new (0, $8118711ff583fe51$export$2e2bcd8739ae039)({
        scene: dummyScene,
        material: prefilterMaterial
    });
    skyEnv.material.set("environmentMap", envMap);
    var envMapPass = new (0, $903ac207f318e53a$export$2e2bcd8739ae039)({
        texture: prefilteredCubeMap
    });
    // Force to be UNSIGNED_BYTE
    if (textureOpts.encodeRGBM) textureType = prefilteredCubeMap.type = (0, $4261427f149675a4$export$2e2bcd8739ae039).UNSIGNED_BYTE;
    var renderTargetTmp = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        width: width,
        height: height,
        type: textureType
    });
    var frameBuffer = new (0, $03d0b3c43006f961$export$2e2bcd8739ae039)({
        depthBuffer: false
    });
    var ArrayCtor = (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039)[textureType === (0, $4261427f149675a4$export$2e2bcd8739ae039).UNSIGNED_BYTE ? "Uint8Array" : "Float32Array"];
    for(var i = 0; i < mipmapNum; i++){
        // console.time('prefilter');
        prefilteredCubeMap.mipmaps[i] = {
            pixels: {}
        };
        skyEnv.material.set("roughness", i / (mipmapNum - 1));
        // Tweak fov
        // http://the-witness.net/news/2012/02/seamless-cube-map-filtering/
        var n = renderTargetTmp.width;
        var fov = 2 * Math.atan(n / (n - 0.5)) / Math.PI * 180;
        for(var j = 0; j < $2d9094f0aba26ce5$var$targets.length; j++){
            var pixels = new ArrayCtor(renderTargetTmp.width * renderTargetTmp.height * 4);
            frameBuffer.attach(renderTargetTmp);
            frameBuffer.bind(renderer);
            var camera = envMapPass.getCamera($2d9094f0aba26ce5$var$targets[j]);
            camera.fov = fov;
            renderer.render(dummyScene, camera);
            renderer.gl.readPixels(0, 0, renderTargetTmp.width, renderTargetTmp.height, (0, $4261427f149675a4$export$2e2bcd8739ae039).RGBA, textureType, pixels);
            // var canvas = document.createElement('canvas');
            // var ctx = canvas.getContext('2d');
            // canvas.width = renderTargetTmp.width;
            // canvas.height = renderTargetTmp.height;
            // var imageData = ctx.createImageData(renderTargetTmp.width, renderTargetTmp.height);
            // for (var k = 0; k < pixels.length; k++) {
            //     imageData.data[k] = pixels[k];
            // }
            // ctx.putImageData(imageData, 0, 0);
            // document.body.appendChild(canvas);
            frameBuffer.unbind(renderer);
            prefilteredCubeMap.mipmaps[i].pixels[$2d9094f0aba26ce5$var$targets[j]] = pixels;
        }
        renderTargetTmp.width /= 2;
        renderTargetTmp.height /= 2;
        renderTargetTmp.dirty();
    // console.timeEnd('prefilter');
    }
    frameBuffer.dispose(renderer);
    renderTargetTmp.dispose(renderer);
    skyEnv.dispose(renderer);
    // Remove gpu resource allucated in renderer
    normalDistribution.dispose(renderer);
    // renderer.dispose();
    return {
        environmentMap: prefilteredCubeMap,
        brdfLookup: brdfLookup,
        normalDistribution: normalDistribution,
        maxMipmapLevel: mipmapNum
    };
};
$2d9094f0aba26ce5$var$cubemapUtil.integrateBRDF = function(renderer, normalDistribution) {
    normalDistribution = normalDistribution || $2d9094f0aba26ce5$var$cubemapUtil.generateNormalDistribution();
    var framebuffer = new (0, $03d0b3c43006f961$export$2e2bcd8739ae039)({
        depthBuffer: false
    });
    var pass = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: (0, $f960f255e5621d57$export$2e2bcd8739ae039)
    });
    var texture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        width: 512,
        height: 256,
        type: (0, $4261427f149675a4$export$2e2bcd8739ae039).HALF_FLOAT,
        wrapS: (0, $4261427f149675a4$export$2e2bcd8739ae039).CLAMP_TO_EDGE,
        wrapT: (0, $4261427f149675a4$export$2e2bcd8739ae039).CLAMP_TO_EDGE,
        minFilter: (0, $4261427f149675a4$export$2e2bcd8739ae039).NEAREST,
        magFilter: (0, $4261427f149675a4$export$2e2bcd8739ae039).NEAREST,
        useMipmap: false
    });
    pass.setUniform("normalDistribution", normalDistribution);
    pass.setUniform("viewportSize", [
        512,
        256
    ]);
    pass.attachOutput(texture);
    pass.render(renderer, framebuffer);
    // FIXME Only chrome and firefox can readPixels with float type.
    // framebuffer.bind(renderer);
    // var pixels = new Float32Array(512 * 256 * 4);
    // renderer.gl.readPixels(
    //     0, 0, texture.width, texture.height,
    //     Texture.RGBA, Texture.FLOAT, pixels
    // );
    // texture.pixels = pixels;
    // texture.flipY = false;
    // texture.dirty();
    // framebuffer.unbind(renderer);
    framebuffer.dispose(renderer);
    return texture;
};
$2d9094f0aba26ce5$var$cubemapUtil.generateNormalDistribution = function(roughnessLevels, sampleSize) {
    // http://holger.dammertz.org/stuff/notes_HammersleyOnHemisphere.html
    // GLSL not support bit operation, use lookup instead
    // V -> i / N, U -> roughness
    var roughnessLevels = roughnessLevels || 256;
    var sampleSize = sampleSize || 1024;
    var normalDistribution = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        width: roughnessLevels,
        height: sampleSize,
        type: (0, $4261427f149675a4$export$2e2bcd8739ae039).FLOAT,
        minFilter: (0, $4261427f149675a4$export$2e2bcd8739ae039).NEAREST,
        magFilter: (0, $4261427f149675a4$export$2e2bcd8739ae039).NEAREST,
        wrapS: (0, $4261427f149675a4$export$2e2bcd8739ae039).CLAMP_TO_EDGE,
        wrapT: (0, $4261427f149675a4$export$2e2bcd8739ae039).CLAMP_TO_EDGE,
        useMipmap: false
    });
    var pixels = new Float32Array(sampleSize * roughnessLevels * 4);
    var tmp = [];
    // function sortFunc(a, b) {
    //     return Math.abs(b) - Math.abs(a);
    // }
    for(var j = 0; j < roughnessLevels; j++){
        var roughness = j / roughnessLevels;
        var a = roughness * roughness;
        for(var i = 0; i < sampleSize; i++){
            // http://holger.dammertz.org/stuff/notes_HammersleyOnHemisphere.html
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Bitwise_Operators
            // http://stackoverflow.com/questions/1908492/unsigned-integer-in-javascript
            // http://stackoverflow.com/questions/1822350/what-is-the-javascript-operator-and-how-do-you-use-it
            var y = (i << 16 | i >>> 16) >>> 0;
            y = ((y & 1431655765) << 1 | (y & 2863311530) >>> 1) >>> 0;
            y = ((y & 858993459) << 2 | (y & 3435973836) >>> 2) >>> 0;
            y = ((y & 252645135) << 4 | (y & 4042322160) >>> 4) >>> 0;
            y = (((y & 16711935) << 8 | (y & 4278255360) >>> 8) >>> 0) / 4294967296;
            // CDF
            var cosTheta = Math.sqrt((1 - y) / (1 + (a * a - 1.0) * y));
            tmp[i] = cosTheta;
        }
        for(var i = 0; i < sampleSize; i++){
            var offset = (i * roughnessLevels + j) * 4;
            var cosTheta = tmp[i];
            var sinTheta = Math.sqrt(1.0 - cosTheta * cosTheta);
            var x = i / sampleSize;
            var phi = 2.0 * Math.PI * x;
            pixels[offset] = sinTheta * Math.cos(phi);
            pixels[offset + 1] = cosTheta;
            pixels[offset + 2] = sinTheta * Math.sin(phi);
            pixels[offset + 3] = 1.0;
        }
    }
    normalDistribution.pixels = pixels;
    return normalDistribution;
};
var $2d9094f0aba26ce5$export$2e2bcd8739ae039 = $2d9094f0aba26ce5$var$cubemapUtil;


/**
 * Ambient cubemap light provides specular parts of Image Based Lighting.
 * Which is a basic requirement for Physically Based Rendering
 * @constructor clay.light.AmbientCubemap
 * @extends clay.Light
 */ var $7e1d35567c730ae0$var$AmbientCubemapLight = (0, $252d8ff14b1b2fbf$export$2e2bcd8739ae039).extend({
    /**
     * @type {clay.TextureCube}
     * @memberOf clay.light.AmbientCubemap#
     */ cubemap: null,
    // TODO
    // range: 100,
    castShadow: false,
    _normalDistribution: null,
    _brdfLookup: null
}, /** @lends clay.light.AmbientCubemap# */ {
    type: "AMBIENT_CUBEMAP_LIGHT",
    /**
     * Do prefitering the cubemap
     * @param {clay.Renderer} renderer
     * @param {number} [size=32]
     */ prefilter: function(renderer, size) {
        if (!renderer.getGLExtension("EXT_shader_texture_lod")) {
            console.warn("Device not support textureCubeLodEXT");
            return;
        }
        if (!this._brdfLookup) {
            this._normalDistribution = (0, $2d9094f0aba26ce5$export$2e2bcd8739ae039).generateNormalDistribution();
            this._brdfLookup = (0, $2d9094f0aba26ce5$export$2e2bcd8739ae039).integrateBRDF(renderer, this._normalDistribution);
        }
        var cubemap = this.cubemap;
        if (cubemap.__prefiltered) return;
        var result = (0, $2d9094f0aba26ce5$export$2e2bcd8739ae039).prefilterEnvironmentMap(renderer, cubemap, {
            encodeRGBM: true,
            width: size,
            height: size
        }, this._normalDistribution, this._brdfLookup);
        this.cubemap = result.environmentMap;
        this.cubemap.__prefiltered = true;
        cubemap.dispose(renderer);
    },
    getBRDFLookup: function() {
        return this._brdfLookup;
    },
    uniformTemplates: {
        ambientCubemapLightColor: {
            type: "3f",
            value: function(instance) {
                var color = instance.color;
                var intensity = instance.intensity;
                return [
                    color[0] * intensity,
                    color[1] * intensity,
                    color[2] * intensity
                ];
            }
        },
        ambientCubemapLightCubemap: {
            type: "t",
            value: function(instance) {
                return instance.cubemap;
            }
        },
        ambientCubemapLightBRDFLookup: {
            type: "t",
            value: function(instance) {
                return instance._brdfLookup;
            }
        }
    }
});
var $7e1d35567c730ae0$export$2e2bcd8739ae039 = $7e1d35567c730ae0$var$AmbientCubemapLight;




/**
 * Spherical Harmonic Ambient Light
 * @constructor clay.light.AmbientSH
 * @extends clay.Light
 */ var $5c9c4e87fb5724a4$var$AmbientSHLight = (0, $252d8ff14b1b2fbf$export$2e2bcd8739ae039).extend({
    castShadow: false,
    /**
     * Spherical Harmonic Coefficients
     * @type {Array.<number>}
     * @memberOf clay.light.AmbientSH#
     */ coefficients: []
}, function() {
    this._coefficientsTmpArr = new (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).Float32Array(27);
}, {
    type: "AMBIENT_SH_LIGHT",
    uniformTemplates: {
        ambientSHLightColor: {
            type: "3f",
            value: function(instance) {
                var color = instance.color;
                var intensity = instance.intensity;
                return [
                    color[0] * intensity,
                    color[1] * intensity,
                    color[2] * intensity
                ];
            }
        },
        ambientSHLightCoefficients: {
            type: "3f",
            value: function(instance) {
                var coefficientsTmpArr = instance._coefficientsTmpArr;
                for(var i = 0; i < instance.coefficients.length; i++)coefficientsTmpArr[i] = instance.coefficients[i];
                return coefficientsTmpArr;
            }
        }
    }
});
var $5c9c4e87fb5724a4$export$2e2bcd8739ae039 = $5c9c4e87fb5724a4$var$AmbientSHLight;


// Spherical Harmonic Helpers










var $6a026f735fae32d2$export$2e2bcd8739ae039 = "uniform samplerCube environmentMap;\nvarying vec2 v_Texcoord;\n#define TEXTURE_SIZE 16\nmat3 front = mat3(\n 1.0, 0.0, 0.0,\n 0.0, 1.0, 0.0,\n 0.0, 0.0, 1.0\n);\nmat3 back = mat3(\n -1.0, 0.0, 0.0,\n 0.0, 1.0, 0.0,\n 0.0, 0.0, -1.0\n);\nmat3 left = mat3(\n 0.0, 0.0, -1.0,\n 0.0, 1.0, 0.0,\n 1.0, 0.0, 0.0\n);\nmat3 right = mat3(\n 0.0, 0.0, 1.0,\n 0.0, 1.0, 0.0,\n -1.0, 0.0, 0.0\n);\nmat3 up = mat3(\n 1.0, 0.0, 0.0,\n 0.0, 0.0, 1.0,\n 0.0, -1.0, 0.0\n);\nmat3 down = mat3(\n 1.0, 0.0, 0.0,\n 0.0, 0.0, -1.0,\n 0.0, 1.0, 0.0\n);\nfloat harmonics(vec3 normal){\n int index = int(gl_FragCoord.x);\n float x = normal.x;\n float y = normal.y;\n float z = normal.z;\n if(index==0){\n return 1.0;\n }\n else if(index==1){\n return x;\n }\n else if(index==2){\n return y;\n }\n else if(index==3){\n return z;\n }\n else if(index==4){\n return x*z;\n }\n else if(index==5){\n return y*z;\n }\n else if(index==6){\n return x*y;\n }\n else if(index==7){\n return 3.0*z*z - 1.0;\n }\n else{\n return x*x - y*y;\n }\n}\nvec3 sampleSide(mat3 rot)\n{\n vec3 result = vec3(0.0);\n float divider = 0.0;\n for (int i = 0; i < TEXTURE_SIZE * TEXTURE_SIZE; i++) {\n float x = mod(float(i), float(TEXTURE_SIZE));\n float y = float(i / TEXTURE_SIZE);\n vec2 sidecoord = ((vec2(x, y) + vec2(0.5, 0.5)) / vec2(TEXTURE_SIZE)) * 2.0 - 1.0;\n vec3 normal = normalize(vec3(sidecoord, -1.0));\n vec3 fetchNormal = rot * normal;\n vec3 texel = textureCube(environmentMap, fetchNormal).rgb;\n result += harmonics(fetchNormal) * texel * -normal.z;\n divider += -normal.z;\n }\n return result / divider;\n}\nvoid main()\n{\n vec3 result = (\n sampleSide(front) +\n sampleSide(back) +\n sampleSide(left) +\n sampleSide(right) +\n sampleSide(up) +\n sampleSide(down)\n ) / 6.0;\n gl_FragColor = vec4(result, 1.0);\n}";


var $4fbfb756e12ce490$var$sh = {};
var $4fbfb756e12ce490$var$targets = [
    "px",
    "nx",
    "py",
    "ny",
    "pz",
    "nz"
];
// Project on gpu, but needs browser to support readPixels as Float32Array.
function $4fbfb756e12ce490$var$projectEnvironmentMapGPU(renderer, envMap) {
    var shTexture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        width: 9,
        height: 1,
        type: (0, $4261427f149675a4$export$2e2bcd8739ae039).FLOAT
    });
    var pass = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: (0, $6a026f735fae32d2$export$2e2bcd8739ae039)
    });
    pass.material.define("fragment", "TEXTURE_SIZE", envMap.width);
    pass.setUniform("environmentMap", envMap);
    var framebuffer = new (0, $03d0b3c43006f961$export$2e2bcd8739ae039)();
    framebuffer.attach(shTexture);
    pass.render(renderer, framebuffer);
    framebuffer.bind(renderer);
    // TODO Only chrome and firefox support Float32Array
    var pixels = new (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).Float32Array(36);
    renderer.gl.readPixels(0, 0, 9, 1, (0, $4261427f149675a4$export$2e2bcd8739ae039).RGBA, (0, $4261427f149675a4$export$2e2bcd8739ae039).FLOAT, pixels);
    var coeff = new (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).Float32Array(27);
    for(var i = 0; i < 9; i++){
        coeff[i * 3] = pixels[i * 4];
        coeff[i * 3 + 1] = pixels[i * 4 + 1];
        coeff[i * 3 + 2] = pixels[i * 4 + 2];
    }
    framebuffer.unbind(renderer);
    framebuffer.dispose(renderer);
    pass.dispose(renderer);
    return coeff;
}
function $4fbfb756e12ce490$var$harmonics(normal, index) {
    var x = normal[0];
    var y = normal[1];
    var z = normal[2];
    if (index === 0) return 1.0;
    else if (index === 1) return x;
    else if (index === 2) return y;
    else if (index === 3) return z;
    else if (index === 4) return x * z;
    else if (index === 5) return y * z;
    else if (index === 6) return x * y;
    else if (index === 7) return 3.0 * z * z - 1.0;
    else return x * x - y * y;
}
var $4fbfb756e12ce490$var$normalTransform = {
    px: [
        2,
        1,
        0,
        -1,
        -1,
        1
    ],
    nx: [
        2,
        1,
        0,
        1,
        -1,
        -1
    ],
    py: [
        0,
        2,
        1,
        1,
        -1,
        -1
    ],
    ny: [
        0,
        2,
        1,
        1,
        1,
        1
    ],
    pz: [
        0,
        1,
        2,
        -1,
        -1,
        -1
    ],
    nz: [
        0,
        1,
        2,
        1,
        -1,
        1
    ]
};
// Project on cpu.
function $4fbfb756e12ce490$var$projectEnvironmentMapCPU(renderer, cubePixels, width, height) {
    var coeff = new (0, $1e103eb4a58e64ce$export$2e2bcd8739ae039).Float32Array(27);
    var normal = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
    var texel = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
    var fetchNormal = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
    for(var m = 0; m < 9; m++){
        var result = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
        for(var k = 0; k < $4fbfb756e12ce490$var$targets.length; k++){
            var pixels = cubePixels[$4fbfb756e12ce490$var$targets[k]];
            var sideResult = (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).create();
            var divider = 0;
            var i = 0;
            var transform = $4fbfb756e12ce490$var$normalTransform[$4fbfb756e12ce490$var$targets[k]];
            for(var y = 0; y < height; y++)for(var x = 0; x < width; x++){
                normal[0] = x / (width - 1.0) * 2.0 - 1.0;
                // TODO Flip y?
                normal[1] = y / (height - 1.0) * 2.0 - 1.0;
                normal[2] = -1;
                (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).normalize(normal, normal);
                fetchNormal[0] = normal[transform[0]] * transform[3];
                fetchNormal[1] = normal[transform[1]] * transform[4];
                fetchNormal[2] = normal[transform[2]] * transform[5];
                texel[0] = pixels[i++] / 255;
                texel[1] = pixels[i++] / 255;
                texel[2] = pixels[i++] / 255;
                // RGBM Decode
                var scale = pixels[i++] / 255 * 8.12;
                texel[0] *= scale;
                texel[1] *= scale;
                texel[2] *= scale;
                (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scaleAndAdd(sideResult, sideResult, texel, $4fbfb756e12ce490$var$harmonics(fetchNormal, m) * -normal[2]);
                // -normal.z equals cos(theta) of Lambertian
                divider += -normal[2];
            }
            (0, $12f7c5f576a58dba$export$2e2bcd8739ae039).scaleAndAdd(result, result, sideResult, 1 / divider);
        }
        coeff[m * 3] = result[0] / 6.0;
        coeff[m * 3 + 1] = result[1] / 6.0;
        coeff[m * 3 + 2] = result[2] / 6.0;
    }
    return coeff;
}
/**
 * @param  {clay.Renderer} renderer
 * @param  {clay.Texture} envMap
 * @param  {Object} [textureOpts]
 * @param  {Object} [textureOpts.lod]
 * @param  {boolean} [textureOpts.decodeRGBM]
 */ $4fbfb756e12ce490$var$sh.projectEnvironmentMap = function(renderer, envMap, opts) {
    // TODO sRGB
    opts = opts || {};
    opts.lod = opts.lod || 0;
    var skybox;
    var dummyScene = new (0, $e49354c4f1efd6e1$export$2e2bcd8739ae039)();
    var size = 64;
    if (envMap.textureType === "texture2D") skybox = new (0, $a928f7c7df5943e2$export$2e2bcd8739ae039)({
        scene: dummyScene,
        environmentMap: envMap
    });
    else {
        size = envMap.image && envMap.image.px ? envMap.image.px.width : envMap.width;
        skybox = new (0, $8118711ff583fe51$export$2e2bcd8739ae039)({
            scene: dummyScene,
            environmentMap: envMap
        });
    }
    // Convert to rgbm
    var width = Math.ceil(size / Math.pow(2, opts.lod));
    var height = Math.ceil(size / Math.pow(2, opts.lod));
    var rgbmTexture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        width: width,
        height: height
    });
    var framebuffer = new (0, $03d0b3c43006f961$export$2e2bcd8739ae039)();
    skybox.material.define("fragment", "RGBM_ENCODE");
    if (opts.decodeRGBM) skybox.material.define("fragment", "RGBM_DECODE");
    skybox.material.set("lod", opts.lod);
    var envMapPass = new (0, $903ac207f318e53a$export$2e2bcd8739ae039)({
        texture: rgbmTexture
    });
    var cubePixels = {};
    for(var i = 0; i < $4fbfb756e12ce490$var$targets.length; i++){
        cubePixels[$4fbfb756e12ce490$var$targets[i]] = new Uint8Array(width * height * 4);
        var camera = envMapPass.getCamera($4fbfb756e12ce490$var$targets[i]);
        camera.fov = 90;
        framebuffer.attach(rgbmTexture);
        framebuffer.bind(renderer);
        renderer.render(dummyScene, camera);
        renderer.gl.readPixels(0, 0, width, height, (0, $4261427f149675a4$export$2e2bcd8739ae039).RGBA, (0, $4261427f149675a4$export$2e2bcd8739ae039).UNSIGNED_BYTE, cubePixels[$4fbfb756e12ce490$var$targets[i]]);
        framebuffer.unbind(renderer);
    }
    skybox.dispose(renderer);
    framebuffer.dispose(renderer);
    rgbmTexture.dispose(renderer);
    return $4fbfb756e12ce490$var$projectEnvironmentMapCPU(renderer, cubePixels, width, height);
};
var $4fbfb756e12ce490$export$2e2bcd8739ae039 = $4fbfb756e12ce490$var$sh;



var $5821dc5111828448$var$retrieve = {
    firstNotNull: function() {
        for(var i = 0, len = arguments.length; i < len; i++){
            if (arguments[i] != null) return arguments[i];
        }
    },
    /**
   * @param {module:echarts/data/List} data
   * @param {Object} payload Contains dataIndex (means rawIndex) / dataIndexInside / name
   *                         each of which can be Array or primary type.
   * @return {number|Array.<number>} dataIndex If not found, return undefined/null.
   */ queryDataIndex: function(data, payload) {
        if (payload.dataIndexInside != null) return payload.dataIndexInside;
        else if (payload.dataIndex != null) return $224386f1517b5dca$exports.isArray(payload.dataIndex) ? $224386f1517b5dca$exports.map(payload.dataIndex, function(value) {
            return data.indexOfRawIndex(value);
        }) : data.indexOfRawIndex(payload.dataIndex);
        else if (payload.name != null) return $224386f1517b5dca$exports.isArray(payload.name) ? $224386f1517b5dca$exports.map(payload.name, function(value) {
            return data.indexOfName(value);
        }) : data.indexOfName(payload.name);
    }
};
var $5821dc5111828448$export$2e2bcd8739ae039 = $5821dc5111828448$var$retrieve;




/**
 * @constructor clay.geometry.Sphere
 * @extends clay.Geometry
 * @param {Object} [opt]
 * @param {number} [widthSegments]
 * @param {number} [heightSegments]
 * @param {number} [phiStart]
 * @param {number} [phiLength]
 * @param {number} [thetaStart]
 * @param {number} [thetaLength]
 * @param {number} [radius]
 */ var $6277c445f3012d76$var$Sphere = (0, $c75c69a759bf7591$export$2e2bcd8739ae039).extend(/** @lends clay.geometry.Sphere# */ {
    dynamic: false,
    /**
     * @type {number}
     */ widthSegments: 40,
    /**
     * @type {number}
     */ heightSegments: 20,
    /**
     * @type {number}
     */ phiStart: 0,
    /**
     * @type {number}
     */ phiLength: Math.PI * 2,
    /**
     * @type {number}
     */ thetaStart: 0,
    /**
     * @type {number}
     */ thetaLength: Math.PI,
    /**
     * @type {number}
     */ radius: 1
}, function() {
    this.build();
}, /** @lends clay.geometry.Sphere.prototype */ {
    /**
     * Build sphere geometry
     */ build: function() {
        var heightSegments = this.heightSegments;
        var widthSegments = this.widthSegments;
        var positionAttr = this.attributes.position;
        var texcoordAttr = this.attributes.texcoord0;
        var normalAttr = this.attributes.normal;
        var vertexCount = (widthSegments + 1) * (heightSegments + 1);
        positionAttr.init(vertexCount);
        texcoordAttr.init(vertexCount);
        normalAttr.init(vertexCount);
        var IndicesCtor = vertexCount > 0xffff ? Uint32Array : Uint16Array;
        var indices = this.indices = new IndicesCtor(widthSegments * heightSegments * 6);
        var x, y, z, u, v, i, j;
        var radius = this.radius;
        var phiStart = this.phiStart;
        var phiLength = this.phiLength;
        var thetaStart = this.thetaStart;
        var thetaLength = this.thetaLength;
        var radius = this.radius;
        var pos = [];
        var uv = [];
        var offset = 0;
        var divider = 1 / radius;
        for(j = 0; j <= heightSegments; j++)for(i = 0; i <= widthSegments; i++){
            u = i / widthSegments;
            v = j / heightSegments;
            // X axis is inverted so texture can be mapped from left to right
            x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
            y = radius * Math.cos(thetaStart + v * thetaLength);
            z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
            pos[0] = x;
            pos[1] = y;
            pos[2] = z;
            uv[0] = u;
            uv[1] = v;
            positionAttr.set(offset, pos);
            texcoordAttr.set(offset, uv);
            pos[0] *= divider;
            pos[1] *= divider;
            pos[2] *= divider;
            normalAttr.set(offset, pos);
            offset++;
        }
        var i1, i2, i3, i4;
        var len = widthSegments + 1;
        var n = 0;
        for(j = 0; j < heightSegments; j++)for(i = 0; i < widthSegments; i++){
            i2 = j * len + i;
            i1 = j * len + i + 1;
            i4 = (j + 1) * len + i + 1;
            i3 = (j + 1) * len + i;
            indices[n++] = i1;
            indices[n++] = i2;
            indices[n++] = i4;
            indices[n++] = i2;
            indices[n++] = i3;
            indices[n++] = i4;
        }
        this.boundingBox = new (0, $39676d59fa1158f6$export$2e2bcd8739ae039)();
        this.boundingBox.max.set(radius, radius, radius);
        this.boundingBox.min.set(-radius, -radius, -radius);
    }
});
var $6277c445f3012d76$export$2e2bcd8739ae039 = $6277c445f3012d76$var$Sphere;





/**
 * @constructor clay.light.Ambient
 * @extends clay.Light
 */ var $993f66386318e8f0$var$AmbientLight = (0, $252d8ff14b1b2fbf$export$2e2bcd8739ae039).extend({
    castShadow: false
}, {
    type: "AMBIENT_LIGHT",
    uniformTemplates: {
        ambientLightColor: {
            type: "3f",
            value: function(instance) {
                var color = instance.color;
                var intensity = instance.intensity;
                return [
                    color[0] * intensity,
                    color[1] * intensity,
                    color[2] * intensity
                ];
            }
        }
    }
});
var $993f66386318e8f0$export$2e2bcd8739ae039 = $993f66386318e8f0$var$AmbientLight;




/**
 * @constructor clay.light.Directional
 * @extends clay.Light
 *
 * @example
 *     var light = new clay.light.Directional({
 *         intensity: 0.5,
 *         color: [1.0, 0.0, 0.0]
 *     });
 *     light.position.set(10, 10, 10);
 *     light.lookAt(clay.Vector3.ZERO);
 *     scene.add(light);
 */ var $392be4a80b0487de$var$DirectionalLight = (0, $252d8ff14b1b2fbf$export$2e2bcd8739ae039).extend(/** @lends clay.light.Directional# */ {
    /**
     * @type {number}
     */ shadowBias: 0.001,
    /**
     * @type {number}
     */ shadowSlopeScale: 2.0,
    /**
     * Shadow cascade.
     * Use PSSM technique when it is larger than 1 and have a unique directional light in scene.
     * @type {number}
     */ shadowCascade: 1,
    /**
     * Available when shadowCascade is larger than 1 and have a unique directional light in scene.
     * @type {number}
     */ cascadeSplitLogFactor: 0.2
}, {
    type: "DIRECTIONAL_LIGHT",
    uniformTemplates: {
        directionalLightDirection: {
            type: "3f",
            value: function(instance) {
                instance.__dir = instance.__dir || new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
                // Direction is target to eye
                return instance.__dir.copy(instance.worldTransform.z).normalize().negate().array;
            }
        },
        directionalLightColor: {
            type: "3f",
            value: function(instance) {
                var color = instance.color;
                var intensity = instance.intensity;
                return [
                    color[0] * intensity,
                    color[1] * intensity,
                    color[2] * intensity
                ];
            }
        }
    },
    /**
     * @return {clay.light.Directional}
     * @memberOf clay.light.Directional.prototype
     */ clone: function() {
        var light = (0, $252d8ff14b1b2fbf$export$2e2bcd8739ae039).prototype.clone.call(this);
        light.shadowBias = this.shadowBias;
        light.shadowSlopeScale = this.shadowSlopeScale;
        return light;
    }
});
var $392be4a80b0487de$export$2e2bcd8739ae039 = $392be4a80b0487de$var$DirectionalLight;



/**
 * @constructor clay.light.Point
 * @extends clay.Light
 */ var $0a77c172f8c2c3c4$var$PointLight = (0, $252d8ff14b1b2fbf$export$2e2bcd8739ae039).extend(/** @lends clay.light.Point# */ {
    /**
     * @type {number}
     */ range: 100,
    /**
     * @type {number}
     */ castShadow: false
}, {
    type: "POINT_LIGHT",
    uniformTemplates: {
        pointLightPosition: {
            type: "3f",
            value: function(instance) {
                return instance.getWorldPosition().array;
            }
        },
        pointLightRange: {
            type: "1f",
            value: function(instance) {
                return instance.range;
            }
        },
        pointLightColor: {
            type: "3f",
            value: function(instance) {
                var color = instance.color;
                var intensity = instance.intensity;
                return [
                    color[0] * intensity,
                    color[1] * intensity,
                    color[2] * intensity
                ];
            }
        }
    },
    /**
     * @return {clay.light.Point}
     * @memberOf clay.light.Point.prototype
     */ clone: function() {
        var light = (0, $252d8ff14b1b2fbf$export$2e2bcd8739ae039).prototype.clone.call(this);
        light.range = this.range;
        return light;
    }
});
var $0a77c172f8c2c3c4$export$2e2bcd8739ae039 = $0a77c172f8c2c3c4$var$PointLight;




/**
 * @constructor clay.light.Spot
 * @extends clay.Light
 */ var $342af288d7b4a59c$var$SpotLight = (0, $252d8ff14b1b2fbf$export$2e2bcd8739ae039).extend(/**@lends clay.light.Spot */ {
    /**
     * @type {number}
     */ range: 20,
    /**
     * @type {number}
     */ umbraAngle: 30,
    /**
     * @type {number}
     */ penumbraAngle: 45,
    /**
     * @type {number}
     */ falloffFactor: 2.0,
    /**
     * @type {number}
     */ shadowBias: 0.001,
    /**
     * @type {number}
     */ shadowSlopeScale: 2.0
}, {
    type: "SPOT_LIGHT",
    uniformTemplates: {
        spotLightPosition: {
            type: "3f",
            value: function(instance) {
                return instance.getWorldPosition().array;
            }
        },
        spotLightRange: {
            type: "1f",
            value: function(instance) {
                return instance.range;
            }
        },
        spotLightUmbraAngleCosine: {
            type: "1f",
            value: function(instance) {
                return Math.cos(instance.umbraAngle * Math.PI / 180);
            }
        },
        spotLightPenumbraAngleCosine: {
            type: "1f",
            value: function(instance) {
                return Math.cos(instance.penumbraAngle * Math.PI / 180);
            }
        },
        spotLightFalloffFactor: {
            type: "1f",
            value: function(instance) {
                return instance.falloffFactor;
            }
        },
        spotLightDirection: {
            type: "3f",
            value: function(instance) {
                instance.__dir = instance.__dir || new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
                // Direction is target to eye
                return instance.__dir.copy(instance.worldTransform.z).negate().array;
            }
        },
        spotLightColor: {
            type: "3f",
            value: function(instance) {
                var color = instance.color;
                var intensity = instance.intensity;
                return [
                    color[0] * intensity,
                    color[1] * intensity,
                    color[2] * intensity
                ];
            }
        }
    },
    /**
     * @return {clay.light.Spot}
     * @memberOf clay.light.Spot.prototype
     */ clone: function() {
        var light = (0, $252d8ff14b1b2fbf$export$2e2bcd8739ae039).prototype.clone.call(this);
        light.range = this.range;
        light.umbraAngle = this.umbraAngle;
        light.penumbraAngle = this.penumbraAngle;
        light.falloffFactor = this.falloffFactor;
        light.shadowBias = this.shadowBias;
        light.shadowSlopeScale = this.shadowSlopeScale;
        return light;
    }
});
var $342af288d7b4a59c$export$2e2bcd8739ae039 = $342af288d7b4a59c$var$SpotLight;







/**
 * @constructor
 * @alias clay.Vector4
 * @param {number} x
 * @param {number} y
 * @param {number} z
 * @param {number} w
 */ var $8d53bee005d3c213$var$Vector4 = function(x, y, z, w) {
    x = x || 0;
    y = y || 0;
    z = z || 0;
    w = w || 0;
    /**
     * Storage of Vector4, read and write of x, y, z, w will change the values in array
     * All methods also operate on the array instead of x, y, z, w components
     * @name array
     * @type {Float32Array}
     * @memberOf clay.Vector4#
     */ this.array = (0, $8f04521abcf907ba$export$2e2bcd8739ae039).fromValues(x, y, z, w);
    /**
     * Dirty flag is used by the Node to determine
     * if the matrix is updated to latest
     * @name _dirty
     * @type {boolean}
     * @memberOf clay.Vector4#
     */ this._dirty = true;
};
$8d53bee005d3c213$var$Vector4.prototype = {
    constructor: $8d53bee005d3c213$var$Vector4,
    /**
     * Add b to self
     * @param  {clay.Vector4} b
     * @return {clay.Vector4}
     */ add: function(b) {
        (0, $8f04521abcf907ba$export$2e2bcd8739ae039).add(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Set x, y and z components
     * @param  {number}  x
     * @param  {number}  y
     * @param  {number}  z
     * @param  {number}  w
     * @return {clay.Vector4}
     */ set: function(x, y, z, w) {
        this.array[0] = x;
        this.array[1] = y;
        this.array[2] = z;
        this.array[3] = w;
        this._dirty = true;
        return this;
    },
    /**
     * Set x, y, z and w components from array
     * @param  {Float32Array|number[]} arr
     * @return {clay.Vector4}
     */ setArray: function(arr) {
        this.array[0] = arr[0];
        this.array[1] = arr[1];
        this.array[2] = arr[2];
        this.array[3] = arr[3];
        this._dirty = true;
        return this;
    },
    /**
     * Clone a new Vector4
     * @return {clay.Vector4}
     */ clone: function() {
        return new $8d53bee005d3c213$var$Vector4(this.x, this.y, this.z, this.w);
    },
    /**
     * Copy from b
     * @param  {clay.Vector4} b
     * @return {clay.Vector4}
     */ copy: function(b) {
        (0, $8f04521abcf907ba$export$2e2bcd8739ae039).copy(this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Alias for distance
     * @param  {clay.Vector4} b
     * @return {number}
     */ dist: function(b) {
        return (0, $8f04521abcf907ba$export$2e2bcd8739ae039).dist(this.array, b.array);
    },
    /**
     * Distance between self and b
     * @param  {clay.Vector4} b
     * @return {number}
     */ distance: function(b) {
        return (0, $8f04521abcf907ba$export$2e2bcd8739ae039).distance(this.array, b.array);
    },
    /**
     * Alias for divide
     * @param  {clay.Vector4} b
     * @return {clay.Vector4}
     */ div: function(b) {
        (0, $8f04521abcf907ba$export$2e2bcd8739ae039).div(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Divide self by b
     * @param  {clay.Vector4} b
     * @return {clay.Vector4}
     */ divide: function(b) {
        (0, $8f04521abcf907ba$export$2e2bcd8739ae039).divide(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Dot product of self and b
     * @param  {clay.Vector4} b
     * @return {number}
     */ dot: function(b) {
        return (0, $8f04521abcf907ba$export$2e2bcd8739ae039).dot(this.array, b.array);
    },
    /**
     * Alias of length
     * @return {number}
     */ len: function() {
        return (0, $8f04521abcf907ba$export$2e2bcd8739ae039).len(this.array);
    },
    /**
     * Calculate the length
     * @return {number}
     */ length: function() {
        return (0, $8f04521abcf907ba$export$2e2bcd8739ae039).length(this.array);
    },
    /**
     * Linear interpolation between a and b
     * @param  {clay.Vector4} a
     * @param  {clay.Vector4} b
     * @param  {number}  t
     * @return {clay.Vector4}
     */ lerp: function(a, b, t) {
        (0, $8f04521abcf907ba$export$2e2bcd8739ae039).lerp(this.array, a.array, b.array, t);
        this._dirty = true;
        return this;
    },
    /**
     * Minimum of self and b
     * @param  {clay.Vector4} b
     * @return {clay.Vector4}
     */ min: function(b) {
        (0, $8f04521abcf907ba$export$2e2bcd8739ae039).min(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Maximum of self and b
     * @param  {clay.Vector4} b
     * @return {clay.Vector4}
     */ max: function(b) {
        (0, $8f04521abcf907ba$export$2e2bcd8739ae039).max(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Alias for multiply
     * @param  {clay.Vector4} b
     * @return {clay.Vector4}
     */ mul: function(b) {
        (0, $8f04521abcf907ba$export$2e2bcd8739ae039).mul(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Mutiply self and b
     * @param  {clay.Vector4} b
     * @return {clay.Vector4}
     */ multiply: function(b) {
        (0, $8f04521abcf907ba$export$2e2bcd8739ae039).multiply(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Negate self
     * @return {clay.Vector4}
     */ negate: function() {
        (0, $8f04521abcf907ba$export$2e2bcd8739ae039).negate(this.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Normalize self
     * @return {clay.Vector4}
     */ normalize: function() {
        (0, $8f04521abcf907ba$export$2e2bcd8739ae039).normalize(this.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Generate random x, y, z, w components with a given scale
     * @param  {number} scale
     * @return {clay.Vector4}
     */ random: function(scale) {
        (0, $8f04521abcf907ba$export$2e2bcd8739ae039).random(this.array, scale);
        this._dirty = true;
        return this;
    },
    /**
     * Scale self
     * @param  {number}  scale
     * @return {clay.Vector4}
     */ scale: function(s) {
        (0, $8f04521abcf907ba$export$2e2bcd8739ae039).scale(this.array, this.array, s);
        this._dirty = true;
        return this;
    },
    /**
     * Scale b and add to self
     * @param  {clay.Vector4} b
     * @param  {number}  scale
     * @return {clay.Vector4}
     */ scaleAndAdd: function(b, s) {
        (0, $8f04521abcf907ba$export$2e2bcd8739ae039).scaleAndAdd(this.array, this.array, b.array, s);
        this._dirty = true;
        return this;
    },
    /**
     * Alias for squaredDistance
     * @param  {clay.Vector4} b
     * @return {number}
     */ sqrDist: function(b) {
        return (0, $8f04521abcf907ba$export$2e2bcd8739ae039).sqrDist(this.array, b.array);
    },
    /**
     * Squared distance between self and b
     * @param  {clay.Vector4} b
     * @return {number}
     */ squaredDistance: function(b) {
        return (0, $8f04521abcf907ba$export$2e2bcd8739ae039).squaredDistance(this.array, b.array);
    },
    /**
     * Alias for squaredLength
     * @return {number}
     */ sqrLen: function() {
        return (0, $8f04521abcf907ba$export$2e2bcd8739ae039).sqrLen(this.array);
    },
    /**
     * Squared length of self
     * @return {number}
     */ squaredLength: function() {
        return (0, $8f04521abcf907ba$export$2e2bcd8739ae039).squaredLength(this.array);
    },
    /**
     * Alias for subtract
     * @param  {clay.Vector4} b
     * @return {clay.Vector4}
     */ sub: function(b) {
        (0, $8f04521abcf907ba$export$2e2bcd8739ae039).sub(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Subtract b from self
     * @param  {clay.Vector4} b
     * @return {clay.Vector4}
     */ subtract: function(b) {
        (0, $8f04521abcf907ba$export$2e2bcd8739ae039).subtract(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Transform self with a Matrix4 m
     * @param  {clay.Matrix4} m
     * @return {clay.Vector4}
     */ transformMat4: function(m) {
        (0, $8f04521abcf907ba$export$2e2bcd8739ae039).transformMat4(this.array, this.array, m.array);
        this._dirty = true;
        return this;
    },
    /**
     * Transform self with a Quaternion q
     * @param  {clay.Quaternion} q
     * @return {clay.Vector4}
     */ transformQuat: function(q) {
        (0, $8f04521abcf907ba$export$2e2bcd8739ae039).transformQuat(this.array, this.array, q.array);
        this._dirty = true;
        return this;
    },
    toString: function() {
        return "[" + Array.prototype.join.call(this.array, ",") + "]";
    },
    toArray: function() {
        return Array.prototype.slice.call(this.array);
    }
};
var $8d53bee005d3c213$var$defineProperty = Object.defineProperty;
// Getter and Setter
if ($8d53bee005d3c213$var$defineProperty) {
    var $8d53bee005d3c213$var$proto = $8d53bee005d3c213$var$Vector4.prototype;
    /**
     * @name x
     * @type {number}
     * @memberOf clay.Vector4
     * @instance
     */ $8d53bee005d3c213$var$defineProperty($8d53bee005d3c213$var$proto, "x", {
        get: function() {
            return this.array[0];
        },
        set: function(value) {
            this.array[0] = value;
            this._dirty = true;
        }
    });
    /**
     * @name y
     * @type {number}
     * @memberOf clay.Vector4
     * @instance
     */ $8d53bee005d3c213$var$defineProperty($8d53bee005d3c213$var$proto, "y", {
        get: function() {
            return this.array[1];
        },
        set: function(value) {
            this.array[1] = value;
            this._dirty = true;
        }
    });
    /**
     * @name z
     * @type {number}
     * @memberOf clay.Vector4
     * @instance
     */ $8d53bee005d3c213$var$defineProperty($8d53bee005d3c213$var$proto, "z", {
        get: function() {
            return this.array[2];
        },
        set: function(value) {
            this.array[2] = value;
            this._dirty = true;
        }
    });
    /**
     * @name w
     * @type {number}
     * @memberOf clay.Vector4
     * @instance
     */ $8d53bee005d3c213$var$defineProperty($8d53bee005d3c213$var$proto, "w", {
        get: function() {
            return this.array[3];
        },
        set: function(value) {
            this.array[3] = value;
            this._dirty = true;
        }
    });
}
// Supply methods that are not in place
/**
 * @param  {clay.Vector4} out
 * @param  {clay.Vector4} a
 * @param  {clay.Vector4} b
 * @return {clay.Vector4}
 */ $8d53bee005d3c213$var$Vector4.add = function(out, a, b) {
    (0, $8f04521abcf907ba$export$2e2bcd8739ae039).add(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector4} out
 * @param  {number}  x
 * @param  {number}  y
 * @param  {number}  z
 * @return {clay.Vector4}
 */ $8d53bee005d3c213$var$Vector4.set = function(out, x, y, z, w) {
    (0, $8f04521abcf907ba$export$2e2bcd8739ae039).set(out.array, x, y, z, w);
    out._dirty = true;
};
/**
 * @param  {clay.Vector4} out
 * @param  {clay.Vector4} b
 * @return {clay.Vector4}
 */ $8d53bee005d3c213$var$Vector4.copy = function(out, b) {
    (0, $8f04521abcf907ba$export$2e2bcd8739ae039).copy(out.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector4} a
 * @param  {clay.Vector4} b
 * @return {number}
 */ $8d53bee005d3c213$var$Vector4.dist = function(a, b) {
    return (0, $8f04521abcf907ba$export$2e2bcd8739ae039).distance(a.array, b.array);
};
/**
 * @function
 * @param  {clay.Vector4} a
 * @param  {clay.Vector4} b
 * @return {number}
 */ $8d53bee005d3c213$var$Vector4.distance = $8d53bee005d3c213$var$Vector4.dist;
/**
 * @param  {clay.Vector4} out
 * @param  {clay.Vector4} a
 * @param  {clay.Vector4} b
 * @return {clay.Vector4}
 */ $8d53bee005d3c213$var$Vector4.div = function(out, a, b) {
    (0, $8f04521abcf907ba$export$2e2bcd8739ae039).divide(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @function
 * @param  {clay.Vector4} out
 * @param  {clay.Vector4} a
 * @param  {clay.Vector4} b
 * @return {clay.Vector4}
 */ $8d53bee005d3c213$var$Vector4.divide = $8d53bee005d3c213$var$Vector4.div;
/**
 * @param  {clay.Vector4} a
 * @param  {clay.Vector4} b
 * @return {number}
 */ $8d53bee005d3c213$var$Vector4.dot = function(a, b) {
    return (0, $8f04521abcf907ba$export$2e2bcd8739ae039).dot(a.array, b.array);
};
/**
 * @param  {clay.Vector4} a
 * @return {number}
 */ $8d53bee005d3c213$var$Vector4.len = function(b) {
    return (0, $8f04521abcf907ba$export$2e2bcd8739ae039).length(b.array);
};
// Vector4.length = Vector4.len;
/**
 * @param  {clay.Vector4} out
 * @param  {clay.Vector4} a
 * @param  {clay.Vector4} b
 * @param  {number}  t
 * @return {clay.Vector4}
 */ $8d53bee005d3c213$var$Vector4.lerp = function(out, a, b, t) {
    (0, $8f04521abcf907ba$export$2e2bcd8739ae039).lerp(out.array, a.array, b.array, t);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector4} out
 * @param  {clay.Vector4} a
 * @param  {clay.Vector4} b
 * @return {clay.Vector4}
 */ $8d53bee005d3c213$var$Vector4.min = function(out, a, b) {
    (0, $8f04521abcf907ba$export$2e2bcd8739ae039).min(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector4} out
 * @param  {clay.Vector4} a
 * @param  {clay.Vector4} b
 * @return {clay.Vector4}
 */ $8d53bee005d3c213$var$Vector4.max = function(out, a, b) {
    (0, $8f04521abcf907ba$export$2e2bcd8739ae039).max(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector4} out
 * @param  {clay.Vector4} a
 * @param  {clay.Vector4} b
 * @return {clay.Vector4}
 */ $8d53bee005d3c213$var$Vector4.mul = function(out, a, b) {
    (0, $8f04521abcf907ba$export$2e2bcd8739ae039).multiply(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @function
 * @param  {clay.Vector4} out
 * @param  {clay.Vector4} a
 * @param  {clay.Vector4} b
 * @return {clay.Vector4}
 */ $8d53bee005d3c213$var$Vector4.multiply = $8d53bee005d3c213$var$Vector4.mul;
/**
 * @param  {clay.Vector4} out
 * @param  {clay.Vector4} a
 * @return {clay.Vector4}
 */ $8d53bee005d3c213$var$Vector4.negate = function(out, a) {
    (0, $8f04521abcf907ba$export$2e2bcd8739ae039).negate(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector4} out
 * @param  {clay.Vector4} a
 * @return {clay.Vector4}
 */ $8d53bee005d3c213$var$Vector4.normalize = function(out, a) {
    (0, $8f04521abcf907ba$export$2e2bcd8739ae039).normalize(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector4} out
 * @param  {number}  scale
 * @return {clay.Vector4}
 */ $8d53bee005d3c213$var$Vector4.random = function(out, scale) {
    (0, $8f04521abcf907ba$export$2e2bcd8739ae039).random(out.array, scale);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector4} out
 * @param  {clay.Vector4} a
 * @param  {number}  scale
 * @return {clay.Vector4}
 */ $8d53bee005d3c213$var$Vector4.scale = function(out, a, scale) {
    (0, $8f04521abcf907ba$export$2e2bcd8739ae039).scale(out.array, a.array, scale);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector4} out
 * @param  {clay.Vector4} a
 * @param  {clay.Vector4} b
 * @param  {number}  scale
 * @return {clay.Vector4}
 */ $8d53bee005d3c213$var$Vector4.scaleAndAdd = function(out, a, b, scale) {
    (0, $8f04521abcf907ba$export$2e2bcd8739ae039).scaleAndAdd(out.array, a.array, b.array, scale);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector4} a
 * @param  {clay.Vector4} b
 * @return {number}
 */ $8d53bee005d3c213$var$Vector4.sqrDist = function(a, b) {
    return (0, $8f04521abcf907ba$export$2e2bcd8739ae039).sqrDist(a.array, b.array);
};
/**
 * @function
 * @param  {clay.Vector4} a
 * @param  {clay.Vector4} b
 * @return {number}
 */ $8d53bee005d3c213$var$Vector4.squaredDistance = $8d53bee005d3c213$var$Vector4.sqrDist;
/**
 * @param  {clay.Vector4} a
 * @return {number}
 */ $8d53bee005d3c213$var$Vector4.sqrLen = function(a) {
    return (0, $8f04521abcf907ba$export$2e2bcd8739ae039).sqrLen(a.array);
};
/**
 * @function
 * @param  {clay.Vector4} a
 * @return {number}
 */ $8d53bee005d3c213$var$Vector4.squaredLength = $8d53bee005d3c213$var$Vector4.sqrLen;
/**
 * @param  {clay.Vector4} out
 * @param  {clay.Vector4} a
 * @param  {clay.Vector4} b
 * @return {clay.Vector4}
 */ $8d53bee005d3c213$var$Vector4.sub = function(out, a, b) {
    (0, $8f04521abcf907ba$export$2e2bcd8739ae039).subtract(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @function
 * @param  {clay.Vector4} out
 * @param  {clay.Vector4} a
 * @param  {clay.Vector4} b
 * @return {clay.Vector4}
 */ $8d53bee005d3c213$var$Vector4.subtract = $8d53bee005d3c213$var$Vector4.sub;
/**
 * @param  {clay.Vector4} out
 * @param  {clay.Vector4} a
 * @param  {clay.Matrix4} m
 * @return {clay.Vector4}
 */ $8d53bee005d3c213$var$Vector4.transformMat4 = function(out, a, m) {
    (0, $8f04521abcf907ba$export$2e2bcd8739ae039).transformMat4(out.array, a.array, m.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Vector4} out
 * @param  {clay.Vector4} a
 * @param  {clay.Quaternion} q
 * @return {clay.Vector4}
 */ $8d53bee005d3c213$var$Vector4.transformQuat = function(out, a, q) {
    (0, $8f04521abcf907ba$export$2e2bcd8739ae039).transformQuat(out.array, a.array, q.array);
    out._dirty = true;
    return out;
};
var $8d53bee005d3c213$export$2e2bcd8739ae039 = $8d53bee005d3c213$var$Vector4;



/* Copyright (c) 2013, Brandon Jones, Colin MacKenzie IV. All rights reserved.

Redistribution and use in source and binary forms, with or without modification,
are permitted provided that the following conditions are met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.
  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. */ 
/**
 * @class 2x2 Matrix
 * @name mat2
 */ var $fc9d47975d112676$var$mat2 = {};
/**
 * Creates a new identity mat2
 *
 * @returns {mat2} a new 2x2 matrix
 */ $fc9d47975d112676$var$mat2.create = function() {
    var out = new (0, $fe2a8a9f20126b12$export$b215cfa6c73149fa)(4);
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
};
/**
 * Creates a new mat2 initialized with values from an existing matrix
 *
 * @param {mat2} a matrix to clone
 * @returns {mat2} a new 2x2 matrix
 */ $fc9d47975d112676$var$mat2.clone = function(a) {
    var out = new (0, $fe2a8a9f20126b12$export$b215cfa6c73149fa)(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
};
/**
 * Copy the values from one mat2 to another
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the source matrix
 * @returns {mat2} out
 */ $fc9d47975d112676$var$mat2.copy = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
};
/**
 * Set a mat2 to the identity matrix
 *
 * @param {mat2} out the receiving matrix
 * @returns {mat2} out
 */ $fc9d47975d112676$var$mat2.identity = function(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
};
/**
 * Transpose the values of a mat2
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the source matrix
 * @returns {mat2} out
 */ $fc9d47975d112676$var$mat2.transpose = function(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a1 = a[1];
        out[1] = a[2];
        out[2] = a1;
    } else {
        out[0] = a[0];
        out[1] = a[2];
        out[2] = a[1];
        out[3] = a[3];
    }
    return out;
};
/**
 * Inverts a mat2
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the source matrix
 * @returns {mat2} out
 */ $fc9d47975d112676$var$mat2.invert = function(out, a) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], // Calculate the determinant
    det = a0 * a3 - a2 * a1;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = a3 * det;
    out[1] = -a1 * det;
    out[2] = -a2 * det;
    out[3] = a0 * det;
    return out;
};
/**
 * Calculates the adjugate of a mat2
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the source matrix
 * @returns {mat2} out
 */ $fc9d47975d112676$var$mat2.adjoint = function(out, a) {
    // Caching this value is nessecary if out == a
    var a0 = a[0];
    out[0] = a[3];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = a0;
    return out;
};
/**
 * Calculates the determinant of a mat2
 *
 * @param {mat2} a the source matrix
 * @returns {Number} determinant of a
 */ $fc9d47975d112676$var$mat2.determinant = function(a) {
    return a[0] * a[3] - a[2] * a[1];
};
/**
 * Multiplies two mat2's
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the first operand
 * @param {mat2} b the second operand
 * @returns {mat2} out
 */ $fc9d47975d112676$var$mat2.multiply = function(out, a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = a0 * b0 + a2 * b1;
    out[1] = a1 * b0 + a3 * b1;
    out[2] = a0 * b2 + a2 * b3;
    out[3] = a1 * b2 + a3 * b3;
    return out;
};
/**
 * Alias for {@link mat2.multiply}
 * @function
 */ $fc9d47975d112676$var$mat2.mul = $fc9d47975d112676$var$mat2.multiply;
/**
 * Rotates a mat2 by the given angle
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2} out
 */ $fc9d47975d112676$var$mat2.rotate = function(out, a, rad) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], s = Math.sin(rad), c = Math.cos(rad);
    out[0] = a0 * c + a2 * s;
    out[1] = a1 * c + a3 * s;
    out[2] = a0 * -s + a2 * c;
    out[3] = a1 * -s + a3 * c;
    return out;
};
/**
 * Scales the mat2 by the dimensions in the given vec2
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the matrix to rotate
 * @param {vec2} v the vec2 to scale the matrix by
 * @returns {mat2} out
 **/ $fc9d47975d112676$var$mat2.scale = function(out, a, v) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], v0 = v[0], v1 = v[1];
    out[0] = a0 * v0;
    out[1] = a1 * v0;
    out[2] = a2 * v1;
    out[3] = a3 * v1;
    return out;
};
/**
 * Returns Frobenius norm of a mat2
 *
 * @param {mat2} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */ $fc9d47975d112676$var$mat2.frob = function(a) {
    return Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2));
};
/**
 * Returns L, D and U matrices (Lower triangular, Diagonal and Upper triangular) by factorizing the input matrix
 * @param {mat2} L the lower triangular matrix
 * @param {mat2} D the diagonal matrix
 * @param {mat2} U the upper triangular matrix
 * @param {mat2} a the input matrix to factorize
 */ $fc9d47975d112676$var$mat2.LDU = function(L, D, U, a) {
    L[2] = a[2] / a[0];
    U[0] = a[0];
    U[1] = a[1];
    U[3] = a[3] - L[2] * U[1];
    return [
        L,
        D,
        U
    ];
};
var $fc9d47975d112676$export$2e2bcd8739ae039 = $fc9d47975d112676$var$mat2;


/**
 * @constructor
 * @alias clay.Matrix2
 */ var $b61dfb591e799596$var$Matrix2 = function() {
    /**
     * Storage of Matrix2
     * @name array
     * @type {Float32Array}
     * @memberOf clay.Matrix2#
     */ this.array = (0, $fc9d47975d112676$export$2e2bcd8739ae039).create();
    /**
     * @name _dirty
     * @type {boolean}
     * @memberOf clay.Matrix2#
     */ this._dirty = true;
};
$b61dfb591e799596$var$Matrix2.prototype = {
    constructor: $b61dfb591e799596$var$Matrix2,
    /**
     * Set components from array
     * @param  {Float32Array|number[]} arr
     */ setArray: function(arr) {
        for(var i = 0; i < this.array.length; i++)this.array[i] = arr[i];
        this._dirty = true;
        return this;
    },
    /**
     * Clone a new Matrix2
     * @return {clay.Matrix2}
     */ clone: function() {
        return new $b61dfb591e799596$var$Matrix2().copy(this);
    },
    /**
     * Copy from b
     * @param  {clay.Matrix2} b
     * @return {clay.Matrix2}
     */ copy: function(b) {
        (0, $fc9d47975d112676$export$2e2bcd8739ae039).copy(this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Calculate the adjugate of self, in-place
     * @return {clay.Matrix2}
     */ adjoint: function() {
        (0, $fc9d47975d112676$export$2e2bcd8739ae039).adjoint(this.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Calculate matrix determinant
     * @return {number}
     */ determinant: function() {
        return (0, $fc9d47975d112676$export$2e2bcd8739ae039).determinant(this.array);
    },
    /**
     * Set to a identity matrix
     * @return {clay.Matrix2}
     */ identity: function() {
        (0, $fc9d47975d112676$export$2e2bcd8739ae039).identity(this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Invert self
     * @return {clay.Matrix2}
     */ invert: function() {
        (0, $fc9d47975d112676$export$2e2bcd8739ae039).invert(this.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Alias for mutiply
     * @param  {clay.Matrix2} b
     * @return {clay.Matrix2}
     */ mul: function(b) {
        (0, $fc9d47975d112676$export$2e2bcd8739ae039).mul(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Alias for multiplyLeft
     * @param  {clay.Matrix2} a
     * @return {clay.Matrix2}
     */ mulLeft: function(a) {
        (0, $fc9d47975d112676$export$2e2bcd8739ae039).mul(this.array, a.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Multiply self and b
     * @param  {clay.Matrix2} b
     * @return {clay.Matrix2}
     */ multiply: function(b) {
        (0, $fc9d47975d112676$export$2e2bcd8739ae039).multiply(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Multiply a and self, a is on the left
     * @param  {clay.Matrix2} a
     * @return {clay.Matrix2}
     */ multiplyLeft: function(a) {
        (0, $fc9d47975d112676$export$2e2bcd8739ae039).multiply(this.array, a.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Rotate self by a given radian
     * @param  {number}   rad
     * @return {clay.Matrix2}
     */ rotate: function(rad) {
        (0, $fc9d47975d112676$export$2e2bcd8739ae039).rotate(this.array, this.array, rad);
        this._dirty = true;
        return this;
    },
    /**
     * Scale self by s
     * @param  {clay.Vector2}  s
     * @return {clay.Matrix2}
     */ scale: function(v) {
        (0, $fc9d47975d112676$export$2e2bcd8739ae039).scale(this.array, this.array, v.array);
        this._dirty = true;
        return this;
    },
    /**
     * Transpose self, in-place.
     * @return {clay.Matrix2}
     */ transpose: function() {
        (0, $fc9d47975d112676$export$2e2bcd8739ae039).transpose(this.array, this.array);
        this._dirty = true;
        return this;
    },
    toString: function() {
        return "[" + Array.prototype.join.call(this.array, ",") + "]";
    },
    toArray: function() {
        return Array.prototype.slice.call(this.array);
    }
};
/**
 * @param  {Matrix2} out
 * @param  {Matrix2} a
 * @return {Matrix2}
 */ $b61dfb591e799596$var$Matrix2.adjoint = function(out, a) {
    (0, $fc9d47975d112676$export$2e2bcd8739ae039).adjoint(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix2} out
 * @param  {clay.Matrix2} a
 * @return {clay.Matrix2}
 */ $b61dfb591e799596$var$Matrix2.copy = function(out, a) {
    (0, $fc9d47975d112676$export$2e2bcd8739ae039).copy(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix2} a
 * @return {number}
 */ $b61dfb591e799596$var$Matrix2.determinant = function(a) {
    return (0, $fc9d47975d112676$export$2e2bcd8739ae039).determinant(a.array);
};
/**
 * @param  {clay.Matrix2} out
 * @return {clay.Matrix2}
 */ $b61dfb591e799596$var$Matrix2.identity = function(out) {
    (0, $fc9d47975d112676$export$2e2bcd8739ae039).identity(out.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix2} out
 * @param  {clay.Matrix2} a
 * @return {clay.Matrix2}
 */ $b61dfb591e799596$var$Matrix2.invert = function(out, a) {
    (0, $fc9d47975d112676$export$2e2bcd8739ae039).invert(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix2} out
 * @param  {clay.Matrix2} a
 * @param  {clay.Matrix2} b
 * @return {clay.Matrix2}
 */ $b61dfb591e799596$var$Matrix2.mul = function(out, a, b) {
    (0, $fc9d47975d112676$export$2e2bcd8739ae039).mul(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @function
 * @param  {clay.Matrix2} out
 * @param  {clay.Matrix2} a
 * @param  {clay.Matrix2} b
 * @return {clay.Matrix2}
 */ $b61dfb591e799596$var$Matrix2.multiply = $b61dfb591e799596$var$Matrix2.mul;
/**
 * @param  {clay.Matrix2} out
 * @param  {clay.Matrix2} a
 * @param  {number}   rad
 * @return {clay.Matrix2}
 */ $b61dfb591e799596$var$Matrix2.rotate = function(out, a, rad) {
    (0, $fc9d47975d112676$export$2e2bcd8739ae039).rotate(out.array, a.array, rad);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix2} out
 * @param  {clay.Matrix2} a
 * @param  {clay.Vector2}  v
 * @return {clay.Matrix2}
 */ $b61dfb591e799596$var$Matrix2.scale = function(out, a, v) {
    (0, $fc9d47975d112676$export$2e2bcd8739ae039).scale(out.array, a.array, v.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {Matrix2} out
 * @param  {Matrix2} a
 * @return {Matrix2}
 */ $b61dfb591e799596$var$Matrix2.transpose = function(out, a) {
    (0, $fc9d47975d112676$export$2e2bcd8739ae039).transpose(out.array, a.array);
    out._dirty = true;
    return out;
};
var $b61dfb591e799596$export$2e2bcd8739ae039 = $b61dfb591e799596$var$Matrix2;


/* Copyright (c) 2013, Brandon Jones, Colin MacKenzie IV. All rights reserved.

Redistribution and use in source and binary forms, with or without modification,
are permitted provided that the following conditions are met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.
  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. */ 
/**
 * @class 2x3 Matrix
 * @name mat2d
 *
 * @description
 * A mat2d contains six elements defined as:
 * <pre>
 * [a, c, tx,
 *  b, d, ty]
 * </pre>
 * This is a short form for the 3x3 matrix:
 * <pre>
 * [a, c, tx,
 *  b, d, ty,
 *  0, 0, 1]
 * </pre>
 * The last row is ignored so the array is shorter and operations are faster.
 */ var $45303a524a267824$var$mat2d = {};
/**
 * Creates a new identity mat2d
 *
 * @returns {mat2d} a new 2x3 matrix
 */ $45303a524a267824$var$mat2d.create = function() {
    var out = new (0, $fe2a8a9f20126b12$export$b215cfa6c73149fa)(6);
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
};
/**
 * Creates a new mat2d initialized with values from an existing matrix
 *
 * @param {mat2d} a matrix to clone
 * @returns {mat2d} a new 2x3 matrix
 */ $45303a524a267824$var$mat2d.clone = function(a) {
    var out = new (0, $fe2a8a9f20126b12$export$b215cfa6c73149fa)(6);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    return out;
};
/**
 * Copy the values from one mat2d to another
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the source matrix
 * @returns {mat2d} out
 */ $45303a524a267824$var$mat2d.copy = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    return out;
};
/**
 * Set a mat2d to the identity matrix
 *
 * @param {mat2d} out the receiving matrix
 * @returns {mat2d} out
 */ $45303a524a267824$var$mat2d.identity = function(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
};
/**
 * Inverts a mat2d
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the source matrix
 * @returns {mat2d} out
 */ $45303a524a267824$var$mat2d.invert = function(out, a) {
    var aa = a[0], ab = a[1], ac = a[2], ad = a[3], atx = a[4], aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
};
/**
 * Calculates the determinant of a mat2d
 *
 * @param {mat2d} a the source matrix
 * @returns {Number} determinant of a
 */ $45303a524a267824$var$mat2d.determinant = function(a) {
    return a[0] * a[3] - a[1] * a[2];
};
/**
 * Multiplies two mat2d's
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the first operand
 * @param {mat2d} b the second operand
 * @returns {mat2d} out
 */ $45303a524a267824$var$mat2d.multiply = function(out, a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5], b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5];
    out[0] = a0 * b0 + a2 * b1;
    out[1] = a1 * b0 + a3 * b1;
    out[2] = a0 * b2 + a2 * b3;
    out[3] = a1 * b2 + a3 * b3;
    out[4] = a0 * b4 + a2 * b5 + a4;
    out[5] = a1 * b4 + a3 * b5 + a5;
    return out;
};
/**
 * Alias for {@link mat2d.multiply}
 * @function
 */ $45303a524a267824$var$mat2d.mul = $45303a524a267824$var$mat2d.multiply;
/**
 * Rotates a mat2d by the given angle
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2d} out
 */ $45303a524a267824$var$mat2d.rotate = function(out, a, rad) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5], s = Math.sin(rad), c = Math.cos(rad);
    out[0] = a0 * c + a2 * s;
    out[1] = a1 * c + a3 * s;
    out[2] = a0 * -s + a2 * c;
    out[3] = a1 * -s + a3 * c;
    out[4] = a4;
    out[5] = a5;
    return out;
};
/**
 * Scales the mat2d by the dimensions in the given vec2
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the matrix to translate
 * @param {vec2} v the vec2 to scale the matrix by
 * @returns {mat2d} out
 **/ $45303a524a267824$var$mat2d.scale = function(out, a, v) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5], v0 = v[0], v1 = v[1];
    out[0] = a0 * v0;
    out[1] = a1 * v0;
    out[2] = a2 * v1;
    out[3] = a3 * v1;
    out[4] = a4;
    out[5] = a5;
    return out;
};
/**
 * Translates the mat2d by the dimensions in the given vec2
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the matrix to translate
 * @param {vec2} v the vec2 to translate the matrix by
 * @returns {mat2d} out
 **/ $45303a524a267824$var$mat2d.translate = function(out, a, v) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5], v0 = v[0], v1 = v[1];
    out[0] = a0;
    out[1] = a1;
    out[2] = a2;
    out[3] = a3;
    out[4] = a0 * v0 + a2 * v1 + a4;
    out[5] = a1 * v0 + a3 * v1 + a5;
    return out;
};
/**
 * Returns Frobenius norm of a mat2d
 *
 * @param {mat2d} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */ $45303a524a267824$var$mat2d.frob = function(a) {
    return Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2) + Math.pow(a[4], 2) + Math.pow(a[5], 2) + 1);
};
var $45303a524a267824$export$2e2bcd8739ae039 = $45303a524a267824$var$mat2d;


/**
 * @constructor
 * @alias clay.Matrix2d
 */ var $4e11dc7847d66aee$var$Matrix2d = function() {
    /**
     * Storage of Matrix2d
     * @name array
     * @type {Float32Array}
     * @memberOf clay.Matrix2d#
     */ this.array = (0, $45303a524a267824$export$2e2bcd8739ae039).create();
    /**
     * @name _dirty
     * @type {boolean}
     * @memberOf clay.Matrix2d#
     */ this._dirty = true;
};
$4e11dc7847d66aee$var$Matrix2d.prototype = {
    constructor: $4e11dc7847d66aee$var$Matrix2d,
    /**
     * Set components from array
     * @param  {Float32Array|number[]} arr
     */ setArray: function(arr) {
        for(var i = 0; i < this.array.length; i++)this.array[i] = arr[i];
        this._dirty = true;
        return this;
    },
    /**
     * Clone a new Matrix2d
     * @return {clay.Matrix2d}
     */ clone: function() {
        return new $4e11dc7847d66aee$var$Matrix2d().copy(this);
    },
    /**
     * Copy from b
     * @param  {clay.Matrix2d} b
     * @return {clay.Matrix2d}
     */ copy: function(b) {
        (0, $45303a524a267824$export$2e2bcd8739ae039).copy(this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Calculate matrix determinant
     * @return {number}
     */ determinant: function() {
        return (0, $45303a524a267824$export$2e2bcd8739ae039).determinant(this.array);
    },
    /**
     * Set to a identity matrix
     * @return {clay.Matrix2d}
     */ identity: function() {
        (0, $45303a524a267824$export$2e2bcd8739ae039).identity(this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Invert self
     * @return {clay.Matrix2d}
     */ invert: function() {
        (0, $45303a524a267824$export$2e2bcd8739ae039).invert(this.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Alias for mutiply
     * @param  {clay.Matrix2d} b
     * @return {clay.Matrix2d}
     */ mul: function(b) {
        (0, $45303a524a267824$export$2e2bcd8739ae039).mul(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Alias for multiplyLeft
     * @param  {clay.Matrix2d} a
     * @return {clay.Matrix2d}
     */ mulLeft: function(b) {
        (0, $45303a524a267824$export$2e2bcd8739ae039).mul(this.array, b.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Multiply self and b
     * @param  {clay.Matrix2d} b
     * @return {clay.Matrix2d}
     */ multiply: function(b) {
        (0, $45303a524a267824$export$2e2bcd8739ae039).multiply(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Multiply a and self, a is on the left
     * @param  {clay.Matrix2d} a
     * @return {clay.Matrix2d}
     */ multiplyLeft: function(b) {
        (0, $45303a524a267824$export$2e2bcd8739ae039).multiply(this.array, b.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Rotate self by a given radian
     * @param  {number}   rad
     * @return {clay.Matrix2d}
     */ rotate: function(rad) {
        (0, $45303a524a267824$export$2e2bcd8739ae039).rotate(this.array, this.array, rad);
        this._dirty = true;
        return this;
    },
    /**
     * Scale self by s
     * @param  {clay.Vector2}  s
     * @return {clay.Matrix2d}
     */ scale: function(s) {
        (0, $45303a524a267824$export$2e2bcd8739ae039).scale(this.array, this.array, s.array);
        this._dirty = true;
        return this;
    },
    /**
     * Translate self by v
     * @param  {clay.Vector2}  v
     * @return {clay.Matrix2d}
     */ translate: function(v) {
        (0, $45303a524a267824$export$2e2bcd8739ae039).translate(this.array, this.array, v.array);
        this._dirty = true;
        return this;
    },
    toString: function() {
        return "[" + Array.prototype.join.call(this.array, ",") + "]";
    },
    toArray: function() {
        return Array.prototype.slice.call(this.array);
    }
};
/**
 * @param  {clay.Matrix2d} out
 * @param  {clay.Matrix2d} a
 * @return {clay.Matrix2d}
 */ $4e11dc7847d66aee$var$Matrix2d.copy = function(out, a) {
    (0, $45303a524a267824$export$2e2bcd8739ae039).copy(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix2d} a
 * @return {number}
 */ $4e11dc7847d66aee$var$Matrix2d.determinant = function(a) {
    return (0, $45303a524a267824$export$2e2bcd8739ae039).determinant(a.array);
};
/**
 * @param  {clay.Matrix2d} out
 * @return {clay.Matrix2d}
 */ $4e11dc7847d66aee$var$Matrix2d.identity = function(out) {
    (0, $45303a524a267824$export$2e2bcd8739ae039).identity(out.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix2d} out
 * @param  {clay.Matrix2d} a
 * @return {clay.Matrix2d}
 */ $4e11dc7847d66aee$var$Matrix2d.invert = function(out, a) {
    (0, $45303a524a267824$export$2e2bcd8739ae039).invert(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix2d} out
 * @param  {clay.Matrix2d} a
 * @param  {clay.Matrix2d} b
 * @return {clay.Matrix2d}
 */ $4e11dc7847d66aee$var$Matrix2d.mul = function(out, a, b) {
    (0, $45303a524a267824$export$2e2bcd8739ae039).mul(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @function
 * @param  {clay.Matrix2d} out
 * @param  {clay.Matrix2d} a
 * @param  {clay.Matrix2d} b
 * @return {clay.Matrix2d}
 */ $4e11dc7847d66aee$var$Matrix2d.multiply = $4e11dc7847d66aee$var$Matrix2d.mul;
/**
 * @param  {clay.Matrix2d} out
 * @param  {clay.Matrix2d} a
 * @param  {number}   rad
 * @return {clay.Matrix2d}
 */ $4e11dc7847d66aee$var$Matrix2d.rotate = function(out, a, rad) {
    (0, $45303a524a267824$export$2e2bcd8739ae039).rotate(out.array, a.array, rad);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix2d} out
 * @param  {clay.Matrix2d} a
 * @param  {clay.Vector2}  v
 * @return {clay.Matrix2d}
 */ $4e11dc7847d66aee$var$Matrix2d.scale = function(out, a, v) {
    (0, $45303a524a267824$export$2e2bcd8739ae039).scale(out.array, a.array, v.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix2d} out
 * @param  {clay.Matrix2d} a
 * @param  {clay.Vector2}  v
 * @return {clay.Matrix2d}
 */ $4e11dc7847d66aee$var$Matrix2d.translate = function(out, a, v) {
    (0, $45303a524a267824$export$2e2bcd8739ae039).translate(out.array, a.array, v.array);
    out._dirty = true;
    return out;
};
var $4e11dc7847d66aee$export$2e2bcd8739ae039 = $4e11dc7847d66aee$var$Matrix2d;



/**
 * @constructor
 * @alias clay.Matrix3
 */ var $fae6b6ac255b9b24$var$Matrix3 = function() {
    /**
     * Storage of Matrix3
     * @name array
     * @type {Float32Array}
     * @memberOf clay.Matrix3#
     */ this.array = (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).create();
    /**
     * @name _dirty
     * @type {boolean}
     * @memberOf clay.Matrix3#
     */ this._dirty = true;
};
$fae6b6ac255b9b24$var$Matrix3.prototype = {
    constructor: $fae6b6ac255b9b24$var$Matrix3,
    /**
     * Set components from array
     * @param  {Float32Array|number[]} arr
     */ setArray: function(arr) {
        for(var i = 0; i < this.array.length; i++)this.array[i] = arr[i];
        this._dirty = true;
        return this;
    },
    /**
     * Calculate the adjugate of self, in-place
     * @return {clay.Matrix3}
     */ adjoint: function() {
        (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).adjoint(this.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Clone a new Matrix3
     * @return {clay.Matrix3}
     */ clone: function() {
        return new $fae6b6ac255b9b24$var$Matrix3().copy(this);
    },
    /**
     * Copy from b
     * @param  {clay.Matrix3} b
     * @return {clay.Matrix3}
     */ copy: function(b) {
        (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).copy(this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Calculate matrix determinant
     * @return {number}
     */ determinant: function() {
        return (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).determinant(this.array);
    },
    /**
     * Copy the values from Matrix2d a
     * @param  {clay.Matrix2d} a
     * @return {clay.Matrix3}
     */ fromMat2d: function(a) {
        (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).fromMat2d(this.array, a.array);
        this._dirty = true;
        return this;
    },
    /**
     * Copies the upper-left 3x3 values of Matrix4
     * @param  {clay.Matrix4} a
     * @return {clay.Matrix3}
     */ fromMat4: function(a) {
        (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).fromMat4(this.array, a.array);
        this._dirty = true;
        return this;
    },
    /**
     * Calculates a rotation matrix from the given quaternion
     * @param  {clay.Quaternion} q
     * @return {clay.Matrix3}
     */ fromQuat: function(q) {
        (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).fromQuat(this.array, q.array);
        this._dirty = true;
        return this;
    },
    /**
     * Set to a identity matrix
     * @return {clay.Matrix3}
     */ identity: function() {
        (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).identity(this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Invert self
     * @return {clay.Matrix3}
     */ invert: function() {
        (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).invert(this.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Alias for mutiply
     * @param  {clay.Matrix3} b
     * @return {clay.Matrix3}
     */ mul: function(b) {
        (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).mul(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Alias for multiplyLeft
     * @param  {clay.Matrix3} a
     * @return {clay.Matrix3}
     */ mulLeft: function(a) {
        (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).mul(this.array, a.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Multiply self and b
     * @param  {clay.Matrix3} b
     * @return {clay.Matrix3}
     */ multiply: function(b) {
        (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).multiply(this.array, this.array, b.array);
        this._dirty = true;
        return this;
    },
    /**
     * Multiply a and self, a is on the left
     * @param  {clay.Matrix3} a
     * @return {clay.Matrix3}
     */ multiplyLeft: function(a) {
        (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).multiply(this.array, a.array, this.array);
        this._dirty = true;
        return this;
    },
    /**
     * Rotate self by a given radian
     * @param  {number}   rad
     * @return {clay.Matrix3}
     */ rotate: function(rad) {
        (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).rotate(this.array, this.array, rad);
        this._dirty = true;
        return this;
    },
    /**
     * Scale self by s
     * @param  {clay.Vector2}  s
     * @return {clay.Matrix3}
     */ scale: function(v) {
        (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).scale(this.array, this.array, v.array);
        this._dirty = true;
        return this;
    },
    /**
     * Translate self by v
     * @param  {clay.Vector2}  v
     * @return {clay.Matrix3}
     */ translate: function(v) {
        (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).translate(this.array, this.array, v.array);
        this._dirty = true;
        return this;
    },
    /**
     * Calculates a 3x3 normal matrix (transpose inverse) from the 4x4 matrix
     * @param {clay.Matrix4} a
     */ normalFromMat4: function(a) {
        (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).normalFromMat4(this.array, a.array);
        this._dirty = true;
        return this;
    },
    /**
     * Transpose self, in-place.
     * @return {clay.Matrix2}
     */ transpose: function() {
        (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).transpose(this.array, this.array);
        this._dirty = true;
        return this;
    },
    toString: function() {
        return "[" + Array.prototype.join.call(this.array, ",") + "]";
    },
    toArray: function() {
        return Array.prototype.slice.call(this.array);
    }
};
/**
 * @param  {clay.Matrix3} out
 * @param  {clay.Matrix3} a
 * @return {clay.Matrix3}
 */ $fae6b6ac255b9b24$var$Matrix3.adjoint = function(out, a) {
    (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).adjoint(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix3} out
 * @param  {clay.Matrix3} a
 * @return {clay.Matrix3}
 */ $fae6b6ac255b9b24$var$Matrix3.copy = function(out, a) {
    (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).copy(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix3} a
 * @return {number}
 */ $fae6b6ac255b9b24$var$Matrix3.determinant = function(a) {
    return (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).determinant(a.array);
};
/**
 * @param  {clay.Matrix3} out
 * @return {clay.Matrix3}
 */ $fae6b6ac255b9b24$var$Matrix3.identity = function(out) {
    (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).identity(out.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix3} out
 * @param  {clay.Matrix3} a
 * @return {clay.Matrix3}
 */ $fae6b6ac255b9b24$var$Matrix3.invert = function(out, a) {
    (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).invert(out.array, a.array);
    return out;
};
/**
 * @param  {clay.Matrix3} out
 * @param  {clay.Matrix3} a
 * @param  {clay.Matrix3} b
 * @return {clay.Matrix3}
 */ $fae6b6ac255b9b24$var$Matrix3.mul = function(out, a, b) {
    (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).mul(out.array, a.array, b.array);
    out._dirty = true;
    return out;
};
/**
 * @function
 * @param  {clay.Matrix3} out
 * @param  {clay.Matrix3} a
 * @param  {clay.Matrix3} b
 * @return {clay.Matrix3}
 */ $fae6b6ac255b9b24$var$Matrix3.multiply = $fae6b6ac255b9b24$var$Matrix3.mul;
/**
 * @param  {clay.Matrix3}  out
 * @param  {clay.Matrix2d} a
 * @return {clay.Matrix3}
 */ $fae6b6ac255b9b24$var$Matrix3.fromMat2d = function(out, a) {
    (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).fromMat2d(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix3} out
 * @param  {clay.Matrix4} a
 * @return {clay.Matrix3}
 */ $fae6b6ac255b9b24$var$Matrix3.fromMat4 = function(out, a) {
    (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).fromMat4(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix3}    out
 * @param  {clay.Quaternion} a
 * @return {clay.Matrix3}
 */ $fae6b6ac255b9b24$var$Matrix3.fromQuat = function(out, q) {
    (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).fromQuat(out.array, q.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix3} out
 * @param  {clay.Matrix4} a
 * @return {clay.Matrix3}
 */ $fae6b6ac255b9b24$var$Matrix3.normalFromMat4 = function(out, a) {
    (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).normalFromMat4(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix3} out
 * @param  {clay.Matrix3} a
 * @param  {number}  rad
 * @return {clay.Matrix3}
 */ $fae6b6ac255b9b24$var$Matrix3.rotate = function(out, a, rad) {
    (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).rotate(out.array, a.array, rad);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix3} out
 * @param  {clay.Matrix3} a
 * @param  {clay.Vector2} v
 * @return {clay.Matrix3}
 */ $fae6b6ac255b9b24$var$Matrix3.scale = function(out, a, v) {
    (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).scale(out.array, a.array, v.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix3} out
 * @param  {clay.Matrix3} a
 * @return {clay.Matrix3}
 */ $fae6b6ac255b9b24$var$Matrix3.transpose = function(out, a) {
    (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).transpose(out.array, a.array);
    out._dirty = true;
    return out;
};
/**
 * @param  {clay.Matrix3} out
 * @param  {clay.Matrix3} a
 * @param  {clay.Vector2} v
 * @return {clay.Matrix3}
 */ $fae6b6ac255b9b24$var$Matrix3.translate = function(out, a, v) {
    (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039).translate(out.array, a.array, v.array);
    out._dirty = true;
    return out;
};
var $fae6b6ac255b9b24$export$2e2bcd8739ae039 = $fae6b6ac255b9b24$var$Matrix3;








var $6aec0bce2c9b0dc6$var$animatableMixin = {
    _animators: null,
    getAnimators: function() {
        this._animators = this._animators || [];
        return this._animators;
    },
    animate: function(path, opts) {
        this._animators = this._animators || [];
        var el = this;
        var target;
        if (path) {
            var pathSplitted = path.split(".");
            var prop = el;
            for(var i = 0, l = pathSplitted.length; i < l; i++){
                if (!prop) continue;
                prop = prop[pathSplitted[i]];
            }
            if (prop) target = prop;
        } else target = el;
        if (target == null) throw new Error("Target " + path + " not exists");
        var animators = this._animators;
        var animator = new (0, $76d8a142a20276fc$export$2e2bcd8739ae039)(target, opts);
        var self = this;
        animator.during(function() {
            if (self.__zr) self.__zr.refresh();
        }).done(function() {
            var idx = animators.indexOf(animator);
            if (idx >= 0) animators.splice(idx, 1);
        });
        animators.push(animator);
        if (this.__zr) this.__zr.animation.addAnimator(animator);
        return animator;
    },
    stopAnimation: function(forwardToLast) {
        this._animators = this._animators || [];
        var animators = this._animators;
        var len = animators.length;
        for(var i = 0; i < len; i++)animators[i].stop(forwardToLast);
        animators.length = 0;
        return this;
    },
    addAnimatorsToZr: function(zr) {
        if (this._animators) for(var i = 0; i < this._animators.length; i++)zr.animation.addAnimator(this._animators[i]);
    },
    removeAnimatorsFromZr: function(zr) {
        if (this._animators) for(var i = 0; i < this._animators.length; i++)zr.animation.removeAnimator(this._animators[i]);
    }
};
var $6aec0bce2c9b0dc6$export$2e2bcd8739ae039 = $6aec0bce2c9b0dc6$var$animatableMixin;


var $bf045847478ef2ac$export$2e2bcd8739ae039 = "\n@export clay.util.rand\nhighp float rand(vec2 uv) {\n const highp float a = 12.9898, b = 78.233, c = 43758.5453;\n highp float dt = dot(uv.xy, vec2(a,b)), sn = mod(dt, 3.141592653589793);\n return fract(sin(sn) * c);\n}\n@end\n@export clay.util.calculate_attenuation\nuniform float attenuationFactor : 5.0;\nfloat lightAttenuation(float dist, float range)\n{\n float attenuation = 1.0;\n attenuation = dist*dist/(range*range+1.0);\n float att_s = attenuationFactor;\n attenuation = 1.0/(attenuation*att_s+1.0);\n att_s = 1.0/(att_s+1.0);\n attenuation = attenuation - att_s;\n attenuation /= 1.0 - att_s;\n return clamp(attenuation, 0.0, 1.0);\n}\n@end\n@export clay.util.edge_factor\n#ifdef SUPPORT_STANDARD_DERIVATIVES\nfloat edgeFactor(float width)\n{\n vec3 d = fwidth(v_Barycentric);\n vec3 a3 = smoothstep(vec3(0.0), d * width, v_Barycentric);\n return min(min(a3.x, a3.y), a3.z);\n}\n#else\nfloat edgeFactor(float width)\n{\n return 1.0;\n}\n#endif\n@end\n@export clay.util.encode_float\nvec4 encodeFloat(const in float depth)\n{\n const vec4 bitShifts = vec4(256.0*256.0*256.0, 256.0*256.0, 256.0, 1.0);\n const vec4 bit_mask = vec4(0.0, 1.0/256.0, 1.0/256.0, 1.0/256.0);\n vec4 res = fract(depth * bitShifts);\n res -= res.xxyz * bit_mask;\n return res;\n}\n@end\n@export clay.util.decode_float\nfloat decodeFloat(const in vec4 color)\n{\n const vec4 bitShifts = vec4(1.0/(256.0*256.0*256.0), 1.0/(256.0*256.0), 1.0/256.0, 1.0);\n return dot(color, bitShifts);\n}\n@end\n@export clay.util.float\n@import clay.util.encode_float\n@import clay.util.decode_float\n@end\n@export clay.util.rgbm_decode\nvec3 RGBMDecode(vec4 rgbm, float range) {\n return range * rgbm.rgb * rgbm.a;\n}\n@end\n@export clay.util.rgbm_encode\nvec4 RGBMEncode(vec3 color, float range) {\n if (dot(color, color) == 0.0) {\n return vec4(0.0);\n }\n vec4 rgbm;\n color /= range;\n rgbm.a = clamp(max(max(color.r, color.g), max(color.b, 1e-6)), 0.0, 1.0);\n rgbm.a = ceil(rgbm.a * 255.0) / 255.0;\n rgbm.rgb = color / rgbm.a;\n return rgbm;\n}\n@end\n@export clay.util.rgbm\n@import clay.util.rgbm_decode\n@import clay.util.rgbm_encode\nvec4 decodeHDR(vec4 color)\n{\n#if defined(RGBM_DECODE) || defined(RGBM)\n return vec4(RGBMDecode(color, 8.12), 1.0);\n#else\n return color;\n#endif\n}\nvec4 encodeHDR(vec4 color)\n{\n#if defined(RGBM_ENCODE) || defined(RGBM)\n return RGBMEncode(color.xyz, 8.12);\n#else\n return color;\n#endif\n}\n@end\n@export clay.util.srgb\nvec4 sRGBToLinear(in vec4 value) {\n return vec4(mix(pow(value.rgb * 0.9478672986 + vec3(0.0521327014), vec3(2.4)), value.rgb * 0.0773993808, vec3(lessThanEqual(value.rgb, vec3(0.04045)))), value.w);\n}\nvec4 linearTosRGB(in vec4 value) {\n return vec4(mix(pow(value.rgb, vec3(0.41666)) * 1.055 - vec3(0.055), value.rgb * 12.92, vec3(lessThanEqual(value.rgb, vec3(0.0031308)))), value.w);\n}\n@end\n@export clay.chunk.skinning_header\n#ifdef SKINNING\nattribute vec3 weight : WEIGHT;\nattribute vec4 joint : JOINT;\n#ifdef USE_SKIN_MATRICES_TEXTURE\nuniform sampler2D skinMatricesTexture : ignore;\nuniform float skinMatricesTextureSize: ignore;\nmat4 getSkinMatrix(sampler2D tex, float idx) {\n float j = idx * 4.0;\n float x = mod(j, skinMatricesTextureSize);\n float y = floor(j / skinMatricesTextureSize) + 0.5;\n vec2 scale = vec2(skinMatricesTextureSize);\n return mat4(\n texture2D(tex, vec2(x + 0.5, y) / scale),\n texture2D(tex, vec2(x + 1.5, y) / scale),\n texture2D(tex, vec2(x + 2.5, y) / scale),\n texture2D(tex, vec2(x + 3.5, y) / scale)\n );\n}\nmat4 getSkinMatrix(float idx) {\n return getSkinMatrix(skinMatricesTexture, idx);\n}\n#else\nuniform mat4 skinMatrix[JOINT_COUNT] : SKIN_MATRIX;\nmat4 getSkinMatrix(float idx) {\n return skinMatrix[int(idx)];\n}\n#endif\n#endif\n@end\n@export clay.chunk.skin_matrix\nmat4 skinMatrixWS = getSkinMatrix(joint.x) * weight.x;\nif (weight.y > 1e-4)\n{\n skinMatrixWS += getSkinMatrix(joint.y) * weight.y;\n}\nif (weight.z > 1e-4)\n{\n skinMatrixWS += getSkinMatrix(joint.z) * weight.z;\n}\nfloat weightW = 1.0-weight.x-weight.y-weight.z;\nif (weightW > 1e-4)\n{\n skinMatrixWS += getSkinMatrix(joint.w) * weightW;\n}\n@end\n@export clay.chunk.instancing_header\n#ifdef INSTANCING\nattribute vec4 instanceMat1;\nattribute vec4 instanceMat2;\nattribute vec4 instanceMat3;\n#endif\n@end\n@export clay.chunk.instancing_matrix\nmat4 instanceMat = mat4(\n vec4(instanceMat1.xyz, 0.0),\n vec4(instanceMat2.xyz, 0.0),\n vec4(instanceMat3.xyz, 0.0),\n vec4(instanceMat1.w, instanceMat2.w, instanceMat3.w, 1.0)\n);\n@end\n@export clay.util.parallax_correct\nvec3 parallaxCorrect(in vec3 dir, in vec3 pos, in vec3 boxMin, in vec3 boxMax) {\n vec3 first = (boxMax - pos) / dir;\n vec3 second = (boxMin - pos) / dir;\n vec3 further = max(first, second);\n float dist = min(further.x, min(further.y, further.z));\n vec3 fixedPos = pos + dir * dist;\n vec3 boxCenter = (boxMax + boxMin) * 0.5;\n return normalize(fixedPos - boxCenter);\n}\n@end\n@export clay.util.clamp_sample\nvec4 clampSample(const in sampler2D texture, const in vec2 coord)\n{\n#ifdef STEREO\n float eye = step(0.5, coord.x) * 0.5;\n vec2 coordClamped = clamp(coord, vec2(eye, 0.0), vec2(0.5 + eye, 1.0));\n#else\n vec2 coordClamped = clamp(coord, vec2(0.0), vec2(1.0));\n#endif\n return texture2D(texture, coordClamped);\n}\n@end\n@export clay.util.ACES\nvec3 ACESToneMapping(vec3 color)\n{\n const float A = 2.51;\n const float B = 0.03;\n const float C = 2.43;\n const float D = 0.59;\n const float E = 0.14;\n return (color * (A * color + B)) / (color * (C * color + D) + E);\n}\n@end";



var $71fad439de837a00$export$2e2bcd8739ae039 = "\n@export ecgl.common.transformUniforms\nuniform mat4 worldViewProjection : WORLDVIEWPROJECTION;\nuniform mat4 worldInverseTranspose : WORLDINVERSETRANSPOSE;\nuniform mat4 world : WORLD;\n@end\n\n@export ecgl.common.attributes\nattribute vec3 position : POSITION;\nattribute vec2 texcoord : TEXCOORD_0;\nattribute vec3 normal : NORMAL;\n@end\n\n@export ecgl.common.uv.header\nuniform vec2 uvRepeat : [1.0, 1.0];\nuniform vec2 uvOffset : [0.0, 0.0];\nuniform vec2 detailUvRepeat : [1.0, 1.0];\nuniform vec2 detailUvOffset : [0.0, 0.0];\n\nvarying vec2 v_Texcoord;\nvarying vec2 v_DetailTexcoord;\n@end\n\n@export ecgl.common.uv.main\nv_Texcoord = texcoord * uvRepeat + uvOffset;\nv_DetailTexcoord = texcoord * detailUvRepeat + detailUvOffset;\n@end\n\n@export ecgl.common.uv.fragmentHeader\nvarying vec2 v_Texcoord;\nvarying vec2 v_DetailTexcoord;\n@end\n\n\n@export ecgl.common.albedo.main\n\n vec4 albedoTexel = vec4(1.0);\n#ifdef DIFFUSEMAP_ENABLED\n albedoTexel = texture2D(diffuseMap, v_Texcoord);\n #ifdef SRGB_DECODE\n albedoTexel = sRGBToLinear(albedoTexel);\n #endif\n#endif\n\n#ifdef DETAILMAP_ENABLED\n vec4 detailTexel = texture2D(detailMap, v_DetailTexcoord);\n #ifdef SRGB_DECODE\n detailTexel = sRGBToLinear(detailTexel);\n #endif\n albedoTexel.rgb = mix(albedoTexel.rgb, detailTexel.rgb, detailTexel.a);\n albedoTexel.a = detailTexel.a + (1.0 - detailTexel.a) * albedoTexel.a;\n#endif\n\n@end\n\n@export ecgl.common.wireframe.vertexHeader\n\n#ifdef WIREFRAME_QUAD\nattribute vec4 barycentric;\nvarying vec4 v_Barycentric;\n#elif defined(WIREFRAME_TRIANGLE)\nattribute vec3 barycentric;\nvarying vec3 v_Barycentric;\n#endif\n\n@end\n\n@export ecgl.common.wireframe.vertexMain\n\n#if defined(WIREFRAME_QUAD) || defined(WIREFRAME_TRIANGLE)\n v_Barycentric = barycentric;\n#endif\n\n@end\n\n\n@export ecgl.common.wireframe.fragmentHeader\n\nuniform float wireframeLineWidth : 1;\nuniform vec4 wireframeLineColor: [0, 0, 0, 0.5];\n\n#ifdef WIREFRAME_QUAD\nvarying vec4 v_Barycentric;\nfloat edgeFactor () {\n vec4 d = fwidth(v_Barycentric);\n vec4 a4 = smoothstep(vec4(0.0), d * wireframeLineWidth, v_Barycentric);\n return min(min(min(a4.x, a4.y), a4.z), a4.w);\n}\n#elif defined(WIREFRAME_TRIANGLE)\nvarying vec3 v_Barycentric;\nfloat edgeFactor () {\n vec3 d = fwidth(v_Barycentric);\n vec3 a3 = smoothstep(vec3(0.0), d * wireframeLineWidth, v_Barycentric);\n return min(min(a3.x, a3.y), a3.z);\n}\n#endif\n\n@end\n\n\n@export ecgl.common.wireframe.fragmentMain\n\n#if defined(WIREFRAME_QUAD) || defined(WIREFRAME_TRIANGLE)\n if (wireframeLineWidth > 0.) {\n vec4 lineColor = wireframeLineColor;\n#ifdef SRGB_DECODE\n lineColor = sRGBToLinear(lineColor);\n#endif\n\n gl_FragColor.rgb = mix(gl_FragColor.rgb, lineColor.rgb, (1.0 - edgeFactor()) * lineColor.a);\n }\n#endif\n@end\n\n\n\n\n@export ecgl.common.bumpMap.header\n\n#ifdef BUMPMAP_ENABLED\nuniform sampler2D bumpMap;\nuniform float bumpScale : 1.0;\n\n\nvec3 bumpNormal(vec3 surfPos, vec3 surfNormal, vec3 baseNormal)\n{\n vec2 dSTdx = dFdx(v_Texcoord);\n vec2 dSTdy = dFdy(v_Texcoord);\n\n float Hll = bumpScale * texture2D(bumpMap, v_Texcoord).x;\n float dHx = bumpScale * texture2D(bumpMap, v_Texcoord + dSTdx).x - Hll;\n float dHy = bumpScale * texture2D(bumpMap, v_Texcoord + dSTdy).x - Hll;\n\n vec3 vSigmaX = dFdx(surfPos);\n vec3 vSigmaY = dFdy(surfPos);\n vec3 vN = surfNormal;\n\n vec3 R1 = cross(vSigmaY, vN);\n vec3 R2 = cross(vN, vSigmaX);\n\n float fDet = dot(vSigmaX, R1);\n\n vec3 vGrad = sign(fDet) * (dHx * R1 + dHy * R2);\n return normalize(abs(fDet) * baseNormal - vGrad);\n\n}\n#endif\n\n@end\n\n@export ecgl.common.normalMap.vertexHeader\n\n#ifdef NORMALMAP_ENABLED\nattribute vec4 tangent : TANGENT;\nvarying vec3 v_Tangent;\nvarying vec3 v_Bitangent;\n#endif\n\n@end\n\n@export ecgl.common.normalMap.vertexMain\n\n#ifdef NORMALMAP_ENABLED\n if (dot(tangent, tangent) > 0.0) {\n v_Tangent = normalize((worldInverseTranspose * vec4(tangent.xyz, 0.0)).xyz);\n v_Bitangent = normalize(cross(v_Normal, v_Tangent) * tangent.w);\n }\n#endif\n\n@end\n\n\n@export ecgl.common.normalMap.fragmentHeader\n\n#ifdef NORMALMAP_ENABLED\nuniform sampler2D normalMap;\nvarying vec3 v_Tangent;\nvarying vec3 v_Bitangent;\n#endif\n\n@end\n\n@export ecgl.common.normalMap.fragmentMain\n#ifdef NORMALMAP_ENABLED\n if (dot(v_Tangent, v_Tangent) > 0.0) {\n vec3 normalTexel = texture2D(normalMap, v_DetailTexcoord).xyz;\n if (dot(normalTexel, normalTexel) > 0.0) { N = normalTexel * 2.0 - 1.0;\n mat3 tbn = mat3(v_Tangent, v_Bitangent, v_Normal);\n N = normalize(tbn * N);\n }\n }\n#endif\n@end\n\n\n\n@export ecgl.common.vertexAnimation.header\n\n#ifdef VERTEX_ANIMATION\nattribute vec3 prevPosition;\nattribute vec3 prevNormal;\nuniform float percent;\n#endif\n\n@end\n\n@export ecgl.common.vertexAnimation.main\n\n#ifdef VERTEX_ANIMATION\n vec3 pos = mix(prevPosition, position, percent);\n vec3 norm = mix(prevNormal, normal, percent);\n#else\n vec3 pos = position;\n vec3 norm = normal;\n#endif\n\n@end\n\n\n@export ecgl.common.ssaoMap.header\n#ifdef SSAOMAP_ENABLED\nuniform sampler2D ssaoMap;\nuniform vec4 viewport : VIEWPORT;\n#endif\n@end\n\n@export ecgl.common.ssaoMap.main\n float ao = 1.0;\n#ifdef SSAOMAP_ENABLED\n ao = texture2D(ssaoMap, (gl_FragCoord.xy - viewport.xy) / viewport.zw).r;\n#endif\n@end\n\n\n\n\n@export ecgl.common.diffuseLayer.header\n\n#if (LAYER_DIFFUSEMAP_COUNT > 0)\nuniform float layerDiffuseIntensity[LAYER_DIFFUSEMAP_COUNT];\nuniform sampler2D layerDiffuseMap[LAYER_DIFFUSEMAP_COUNT];\n#endif\n\n@end\n\n@export ecgl.common.emissiveLayer.header\n\n#if (LAYER_EMISSIVEMAP_COUNT > 0)\nuniform float layerEmissionIntensity[LAYER_EMISSIVEMAP_COUNT];\nuniform sampler2D layerEmissiveMap[LAYER_EMISSIVEMAP_COUNT];\n#endif\n\n@end\n\n@export ecgl.common.layers.header\n@import ecgl.common.diffuseLayer.header\n@import ecgl.common.emissiveLayer.header\n@end\n\n@export ecgl.common.diffuseLayer.main\n\n#if (LAYER_DIFFUSEMAP_COUNT > 0)\n for (int _idx_ = 0; _idx_ < LAYER_DIFFUSEMAP_COUNT; _idx_++) {{\n float intensity = layerDiffuseIntensity[_idx_];\n vec4 texel2 = texture2D(layerDiffuseMap[_idx_], v_Texcoord);\n #ifdef SRGB_DECODE\n texel2 = sRGBToLinear(texel2);\n #endif\n albedoTexel.rgb = mix(albedoTexel.rgb, texel2.rgb * intensity, texel2.a);\n albedoTexel.a = texel2.a + (1.0 - texel2.a) * albedoTexel.a;\n }}\n#endif\n\n@end\n\n@export ecgl.common.emissiveLayer.main\n\n#if (LAYER_EMISSIVEMAP_COUNT > 0)\n for (int _idx_ = 0; _idx_ < LAYER_EMISSIVEMAP_COUNT; _idx_++)\n {{\n vec4 texel2 = texture2D(layerEmissiveMap[_idx_], v_Texcoord) * layerEmissionIntensity[_idx_];\n #ifdef SRGB_DECODE\n texel2 = sRGBToLinear(texel2);\n #endif\n float intensity = layerEmissionIntensity[_idx_];\n gl_FragColor.rgb += texel2.rgb * texel2.a * intensity;\n }}\n#endif\n\n@end\n";


var $73539e1df8b41957$export$2e2bcd8739ae039 = "@export ecgl.color.vertex\n\nuniform mat4 worldViewProjection : WORLDVIEWPROJECTION;\n\n@import ecgl.common.uv.header\n\nattribute vec2 texcoord : TEXCOORD_0;\nattribute vec3 position: POSITION;\n\n@import ecgl.common.wireframe.vertexHeader\n\n#ifdef VERTEX_COLOR\nattribute vec4 a_Color : COLOR;\nvarying vec4 v_Color;\n#endif\n\n#ifdef VERTEX_ANIMATION\nattribute vec3 prevPosition;\nuniform float percent : 1.0;\n#endif\n\n#ifdef ATMOSPHERE_ENABLED\nattribute vec3 normal: NORMAL;\nuniform mat4 worldInverseTranspose : WORLDINVERSETRANSPOSE;\nvarying vec3 v_Normal;\n#endif\n\nvoid main()\n{\n#ifdef VERTEX_ANIMATION\n vec3 pos = mix(prevPosition, position, percent);\n#else\n vec3 pos = position;\n#endif\n\n gl_Position = worldViewProjection * vec4(pos, 1.0);\n\n @import ecgl.common.uv.main\n\n#ifdef VERTEX_COLOR\n v_Color = a_Color;\n#endif\n\n#ifdef ATMOSPHERE_ENABLED\n v_Normal = normalize((worldInverseTranspose * vec4(normal, 0.0)).xyz);\n#endif\n\n @import ecgl.common.wireframe.vertexMain\n\n}\n\n@end\n\n@export ecgl.color.fragment\n\n#define LAYER_DIFFUSEMAP_COUNT 0\n#define LAYER_EMISSIVEMAP_COUNT 0\n\nuniform sampler2D diffuseMap;\nuniform sampler2D detailMap;\n\nuniform vec4 color : [1.0, 1.0, 1.0, 1.0];\n\n#ifdef ATMOSPHERE_ENABLED\nuniform mat4 viewTranspose: VIEWTRANSPOSE;\nuniform vec3 glowColor;\nuniform float glowPower;\nvarying vec3 v_Normal;\n#endif\n\n#ifdef VERTEX_COLOR\nvarying vec4 v_Color;\n#endif\n\n@import ecgl.common.layers.header\n\n@import ecgl.common.uv.fragmentHeader\n\n@import ecgl.common.wireframe.fragmentHeader\n\n@import clay.util.srgb\n\nvoid main()\n{\n#ifdef SRGB_DECODE\n gl_FragColor = sRGBToLinear(color);\n#else\n gl_FragColor = color;\n#endif\n\n#ifdef VERTEX_COLOR\n gl_FragColor *= v_Color;\n#endif\n\n @import ecgl.common.albedo.main\n\n @import ecgl.common.diffuseLayer.main\n\n gl_FragColor *= albedoTexel;\n\n#ifdef ATMOSPHERE_ENABLED\n float atmoIntensity = pow(1.0 - dot(v_Normal, (viewTranspose * vec4(0.0, 0.0, 1.0, 0.0)).xyz), glowPower);\n gl_FragColor.rgb += glowColor * atmoIntensity;\n#endif\n\n @import ecgl.common.emissiveLayer.main\n\n @import ecgl.common.wireframe.fragmentMain\n\n}\n@end";


var $e1b6e328709549d5$export$2e2bcd8739ae039 = "/**\n * http: */\n\n@export ecgl.lambert.vertex\n\n@import ecgl.common.transformUniforms\n\n@import ecgl.common.uv.header\n\n\n@import ecgl.common.attributes\n\n@import ecgl.common.wireframe.vertexHeader\n\n#ifdef VERTEX_COLOR\nattribute vec4 a_Color : COLOR;\nvarying vec4 v_Color;\n#endif\n\n\n@import ecgl.common.vertexAnimation.header\n\n\nvarying vec3 v_Normal;\nvarying vec3 v_WorldPosition;\n\nvoid main()\n{\n @import ecgl.common.uv.main\n\n @import ecgl.common.vertexAnimation.main\n\n\n gl_Position = worldViewProjection * vec4(pos, 1.0);\n\n v_Normal = normalize((worldInverseTranspose * vec4(norm, 0.0)).xyz);\n v_WorldPosition = (world * vec4(pos, 1.0)).xyz;\n\n#ifdef VERTEX_COLOR\n v_Color = a_Color;\n#endif\n\n @import ecgl.common.wireframe.vertexMain\n}\n\n@end\n\n\n@export ecgl.lambert.fragment\n\n#define LAYER_DIFFUSEMAP_COUNT 0\n#define LAYER_EMISSIVEMAP_COUNT 0\n\n#define NORMAL_UP_AXIS 1\n#define NORMAL_FRONT_AXIS 2\n\n@import ecgl.common.uv.fragmentHeader\n\nvarying vec3 v_Normal;\nvarying vec3 v_WorldPosition;\n\nuniform sampler2D diffuseMap;\nuniform sampler2D detailMap;\n\n@import ecgl.common.layers.header\n\nuniform float emissionIntensity: 1.0;\n\nuniform vec4 color : [1.0, 1.0, 1.0, 1.0];\n\nuniform mat4 viewInverse : VIEWINVERSE;\n\n#ifdef ATMOSPHERE_ENABLED\nuniform mat4 viewTranspose: VIEWTRANSPOSE;\nuniform vec3 glowColor;\nuniform float glowPower;\n#endif\n\n#ifdef AMBIENT_LIGHT_COUNT\n@import clay.header.ambient_light\n#endif\n#ifdef AMBIENT_SH_LIGHT_COUNT\n@import clay.header.ambient_sh_light\n#endif\n\n#ifdef DIRECTIONAL_LIGHT_COUNT\n@import clay.header.directional_light\n#endif\n\n#ifdef VERTEX_COLOR\nvarying vec4 v_Color;\n#endif\n\n\n@import ecgl.common.ssaoMap.header\n\n@import ecgl.common.bumpMap.header\n\n@import clay.util.srgb\n\n@import ecgl.common.wireframe.fragmentHeader\n\n@import clay.plugin.compute_shadow_map\n\nvoid main()\n{\n#ifdef SRGB_DECODE\n gl_FragColor = sRGBToLinear(color);\n#else\n gl_FragColor = color;\n#endif\n\n#ifdef VERTEX_COLOR\n #ifdef SRGB_DECODE\n gl_FragColor *= sRGBToLinear(v_Color);\n #else\n gl_FragColor *= v_Color;\n #endif\n#endif\n\n @import ecgl.common.albedo.main\n\n @import ecgl.common.diffuseLayer.main\n\n gl_FragColor *= albedoTexel;\n\n vec3 N = v_Normal;\n#ifdef DOUBLE_SIDED\n vec3 eyePos = viewInverse[3].xyz;\n vec3 V = normalize(eyePos - v_WorldPosition);\n\n if (dot(N, V) < 0.0) {\n N = -N;\n }\n#endif\n\n float ambientFactor = 1.0;\n\n#ifdef BUMPMAP_ENABLED\n N = bumpNormal(v_WorldPosition, v_Normal, N);\n ambientFactor = dot(v_Normal, N);\n#endif\n\n vec3 N2 = vec3(N.x, N[NORMAL_UP_AXIS], N[NORMAL_FRONT_AXIS]);\n\n vec3 diffuseColor = vec3(0.0, 0.0, 0.0);\n\n @import ecgl.common.ssaoMap.main\n\n#ifdef AMBIENT_LIGHT_COUNT\n for(int i = 0; i < AMBIENT_LIGHT_COUNT; i++)\n {\n diffuseColor += ambientLightColor[i] * ambientFactor * ao;\n }\n#endif\n#ifdef AMBIENT_SH_LIGHT_COUNT\n for(int _idx_ = 0; _idx_ < AMBIENT_SH_LIGHT_COUNT; _idx_++)\n {{\n diffuseColor += calcAmbientSHLight(_idx_, N2) * ambientSHLightColor[_idx_] * ao;\n }}\n#endif\n#ifdef DIRECTIONAL_LIGHT_COUNT\n#if defined(DIRECTIONAL_LIGHT_SHADOWMAP_COUNT)\n float shadowContribsDir[DIRECTIONAL_LIGHT_COUNT];\n if(shadowEnabled)\n {\n computeShadowOfDirectionalLights(v_WorldPosition, shadowContribsDir);\n }\n#endif\n for(int i = 0; i < DIRECTIONAL_LIGHT_COUNT; i++)\n {\n vec3 lightDirection = -directionalLightDirection[i];\n vec3 lightColor = directionalLightColor[i];\n\n float shadowContrib = 1.0;\n#if defined(DIRECTIONAL_LIGHT_SHADOWMAP_COUNT)\n if (shadowEnabled)\n {\n shadowContrib = shadowContribsDir[i];\n }\n#endif\n\n float ndl = dot(N, normalize(lightDirection)) * shadowContrib;\n\n diffuseColor += lightColor * clamp(ndl, 0.0, 1.0);\n }\n#endif\n\n gl_FragColor.rgb *= diffuseColor;\n\n#ifdef ATMOSPHERE_ENABLED\n float atmoIntensity = pow(1.0 - dot(v_Normal, (viewTranspose * vec4(0.0, 0.0, 1.0, 0.0)).xyz), glowPower);\n gl_FragColor.rgb += glowColor * atmoIntensity;\n#endif\n\n @import ecgl.common.emissiveLayer.main\n\n @import ecgl.common.wireframe.fragmentMain\n}\n\n@end";


var $c2528583c677271b$export$2e2bcd8739ae039 = "@export ecgl.realistic.vertex\n\n@import ecgl.common.transformUniforms\n\n@import ecgl.common.uv.header\n\n@import ecgl.common.attributes\n\n\n@import ecgl.common.wireframe.vertexHeader\n\n#ifdef VERTEX_COLOR\nattribute vec4 a_Color : COLOR;\nvarying vec4 v_Color;\n#endif\n\n#ifdef NORMALMAP_ENABLED\nattribute vec4 tangent : TANGENT;\nvarying vec3 v_Tangent;\nvarying vec3 v_Bitangent;\n#endif\n\n@import ecgl.common.vertexAnimation.header\n\nvarying vec3 v_Normal;\nvarying vec3 v_WorldPosition;\n\nvoid main()\n{\n\n @import ecgl.common.uv.main\n\n @import ecgl.common.vertexAnimation.main\n\n gl_Position = worldViewProjection * vec4(pos, 1.0);\n\n v_Normal = normalize((worldInverseTranspose * vec4(norm, 0.0)).xyz);\n v_WorldPosition = (world * vec4(pos, 1.0)).xyz;\n\n#ifdef VERTEX_COLOR\n v_Color = a_Color;\n#endif\n\n#ifdef NORMALMAP_ENABLED\n v_Tangent = normalize((worldInverseTranspose * vec4(tangent.xyz, 0.0)).xyz);\n v_Bitangent = normalize(cross(v_Normal, v_Tangent) * tangent.w);\n#endif\n\n @import ecgl.common.wireframe.vertexMain\n\n}\n\n@end\n\n\n\n@export ecgl.realistic.fragment\n\n#define LAYER_DIFFUSEMAP_COUNT 0\n#define LAYER_EMISSIVEMAP_COUNT 0\n#define PI 3.14159265358979\n#define ROUGHNESS_CHANEL 0\n#define METALNESS_CHANEL 1\n\n#define NORMAL_UP_AXIS 1\n#define NORMAL_FRONT_AXIS 2\n\n#ifdef VERTEX_COLOR\nvarying vec4 v_Color;\n#endif\n\n@import ecgl.common.uv.fragmentHeader\n\nvarying vec3 v_Normal;\nvarying vec3 v_WorldPosition;\n\nuniform sampler2D diffuseMap;\n\nuniform sampler2D detailMap;\nuniform sampler2D metalnessMap;\nuniform sampler2D roughnessMap;\n\n@import ecgl.common.layers.header\n\nuniform float emissionIntensity: 1.0;\n\nuniform vec4 color : [1.0, 1.0, 1.0, 1.0];\n\nuniform float metalness : 0.0;\nuniform float roughness : 0.5;\n\nuniform mat4 viewInverse : VIEWINVERSE;\n\n#ifdef ATMOSPHERE_ENABLED\nuniform mat4 viewTranspose: VIEWTRANSPOSE;\nuniform vec3 glowColor;\nuniform float glowPower;\n#endif\n\n#ifdef AMBIENT_LIGHT_COUNT\n@import clay.header.ambient_light\n#endif\n\n#ifdef AMBIENT_SH_LIGHT_COUNT\n@import clay.header.ambient_sh_light\n#endif\n\n#ifdef AMBIENT_CUBEMAP_LIGHT_COUNT\n@import clay.header.ambient_cubemap_light\n#endif\n\n#ifdef DIRECTIONAL_LIGHT_COUNT\n@import clay.header.directional_light\n#endif\n\n@import ecgl.common.normalMap.fragmentHeader\n\n@import ecgl.common.ssaoMap.header\n\n@import ecgl.common.bumpMap.header\n\n@import clay.util.srgb\n\n@import clay.util.rgbm\n\n@import ecgl.common.wireframe.fragmentHeader\n\n@import clay.plugin.compute_shadow_map\n\nvec3 F_Schlick(float ndv, vec3 spec) {\n return spec + (1.0 - spec) * pow(1.0 - ndv, 5.0);\n}\n\nfloat D_Phong(float g, float ndh) {\n float a = pow(8192.0, g);\n return (a + 2.0) / 8.0 * pow(ndh, a);\n}\n\nvoid main()\n{\n vec4 albedoColor = color;\n\n vec3 eyePos = viewInverse[3].xyz;\n vec3 V = normalize(eyePos - v_WorldPosition);\n#ifdef VERTEX_COLOR\n #ifdef SRGB_DECODE\n albedoColor *= sRGBToLinear(v_Color);\n #else\n albedoColor *= v_Color;\n #endif\n#endif\n\n @import ecgl.common.albedo.main\n\n @import ecgl.common.diffuseLayer.main\n\n albedoColor *= albedoTexel;\n\n float m = metalness;\n\n#ifdef METALNESSMAP_ENABLED\n float m2 = texture2D(metalnessMap, v_DetailTexcoord)[METALNESS_CHANEL];\n m = clamp(m2 + (m - 0.5) * 2.0, 0.0, 1.0);\n#endif\n\n vec3 baseColor = albedoColor.rgb;\n albedoColor.rgb = baseColor * (1.0 - m);\n vec3 specFactor = mix(vec3(0.04), baseColor, m);\n\n float g = 1.0 - roughness;\n\n#ifdef ROUGHNESSMAP_ENABLED\n float g2 = 1.0 - texture2D(roughnessMap, v_DetailTexcoord)[ROUGHNESS_CHANEL];\n g = clamp(g2 + (g - 0.5) * 2.0, 0.0, 1.0);\n#endif\n\n vec3 N = v_Normal;\n\n#ifdef DOUBLE_SIDED\n if (dot(N, V) < 0.0) {\n N = -N;\n }\n#endif\n\n float ambientFactor = 1.0;\n\n#ifdef BUMPMAP_ENABLED\n N = bumpNormal(v_WorldPosition, v_Normal, N);\n ambientFactor = dot(v_Normal, N);\n#endif\n\n@import ecgl.common.normalMap.fragmentMain\n\n vec3 N2 = vec3(N.x, N[NORMAL_UP_AXIS], N[NORMAL_FRONT_AXIS]);\n\n vec3 diffuseTerm = vec3(0.0);\n vec3 specularTerm = vec3(0.0);\n\n float ndv = clamp(dot(N, V), 0.0, 1.0);\n vec3 fresnelTerm = F_Schlick(ndv, specFactor);\n\n @import ecgl.common.ssaoMap.main\n\n#ifdef AMBIENT_LIGHT_COUNT\n for(int _idx_ = 0; _idx_ < AMBIENT_LIGHT_COUNT; _idx_++)\n {{\n diffuseTerm += ambientLightColor[_idx_] * ambientFactor * ao;\n }}\n#endif\n\n#ifdef AMBIENT_SH_LIGHT_COUNT\n for(int _idx_ = 0; _idx_ < AMBIENT_SH_LIGHT_COUNT; _idx_++)\n {{\n diffuseTerm += calcAmbientSHLight(_idx_, N2) * ambientSHLightColor[_idx_] * ao;\n }}\n#endif\n\n#ifdef DIRECTIONAL_LIGHT_COUNT\n#if defined(DIRECTIONAL_LIGHT_SHADOWMAP_COUNT)\n float shadowContribsDir[DIRECTIONAL_LIGHT_COUNT];\n if(shadowEnabled)\n {\n computeShadowOfDirectionalLights(v_WorldPosition, shadowContribsDir);\n }\n#endif\n for(int _idx_ = 0; _idx_ < DIRECTIONAL_LIGHT_COUNT; _idx_++)\n {{\n vec3 L = -directionalLightDirection[_idx_];\n vec3 lc = directionalLightColor[_idx_];\n\n vec3 H = normalize(L + V);\n float ndl = clamp(dot(N, normalize(L)), 0.0, 1.0);\n float ndh = clamp(dot(N, H), 0.0, 1.0);\n\n float shadowContrib = 1.0;\n#if defined(DIRECTIONAL_LIGHT_SHADOWMAP_COUNT)\n if (shadowEnabled)\n {\n shadowContrib = shadowContribsDir[_idx_];\n }\n#endif\n\n vec3 li = lc * ndl * shadowContrib;\n\n diffuseTerm += li;\n specularTerm += li * fresnelTerm * D_Phong(g, ndh);\n }}\n#endif\n\n\n#ifdef AMBIENT_CUBEMAP_LIGHT_COUNT\n vec3 L = reflect(-V, N);\n L = vec3(L.x, L[NORMAL_UP_AXIS], L[NORMAL_FRONT_AXIS]);\n float rough2 = clamp(1.0 - g, 0.0, 1.0);\n float bias2 = rough2 * 5.0;\n vec2 brdfParam2 = texture2D(ambientCubemapLightBRDFLookup[0], vec2(rough2, ndv)).xy;\n vec3 envWeight2 = specFactor * brdfParam2.x + brdfParam2.y;\n vec3 envTexel2;\n for(int _idx_ = 0; _idx_ < AMBIENT_CUBEMAP_LIGHT_COUNT; _idx_++)\n {{\n envTexel2 = RGBMDecode(textureCubeLodEXT(ambientCubemapLightCubemap[_idx_], L, bias2), 8.12);\n specularTerm += ambientCubemapLightColor[_idx_] * envTexel2 * envWeight2 * ao;\n }}\n#endif\n\n gl_FragColor.rgb = albedoColor.rgb * diffuseTerm + specularTerm;\n gl_FragColor.a = albedoColor.a;\n\n#ifdef ATMOSPHERE_ENABLED\n float atmoIntensity = pow(1.0 - dot(v_Normal, (viewTranspose * vec4(0.0, 0.0, 1.0, 0.0)).xyz), glowPower);\n gl_FragColor.rgb += glowColor * atmoIntensity;\n#endif\n\n#ifdef SRGB_ENCODE\n gl_FragColor = linearTosRGB(gl_FragColor);\n#endif\n\n @import ecgl.common.emissiveLayer.main\n\n @import ecgl.common.wireframe.fragmentMain\n}\n\n@end";


var $31e589a17d0fd7dd$export$2e2bcd8739ae039 = "@export ecgl.hatching.vertex\n\n@import ecgl.realistic.vertex\n\n@end\n\n\n@export ecgl.hatching.fragment\n\n#define NORMAL_UP_AXIS 1\n#define NORMAL_FRONT_AXIS 2\n\n@import ecgl.common.uv.fragmentHeader\n\nvarying vec3 v_Normal;\nvarying vec3 v_WorldPosition;\n\nuniform vec4 color : [0.0, 0.0, 0.0, 1.0];\nuniform vec4 paperColor : [1.0, 1.0, 1.0, 1.0];\n\nuniform mat4 viewInverse : VIEWINVERSE;\n\n#ifdef AMBIENT_LIGHT_COUNT\n@import clay.header.ambient_light\n#endif\n#ifdef AMBIENT_SH_LIGHT_COUNT\n@import clay.header.ambient_sh_light\n#endif\n\n#ifdef DIRECTIONAL_LIGHT_COUNT\n@import clay.header.directional_light\n#endif\n\n#ifdef VERTEX_COLOR\nvarying vec4 v_Color;\n#endif\n\n\n@import ecgl.common.ssaoMap.header\n\n@import ecgl.common.bumpMap.header\n\n@import clay.util.srgb\n\n@import ecgl.common.wireframe.fragmentHeader\n\n@import clay.plugin.compute_shadow_map\n\nuniform sampler2D hatch1;\nuniform sampler2D hatch2;\nuniform sampler2D hatch3;\nuniform sampler2D hatch4;\nuniform sampler2D hatch5;\nuniform sampler2D hatch6;\n\nfloat shade(in float tone) {\n vec4 c = vec4(1. ,1., 1., 1.);\n float step = 1. / 6.;\n vec2 uv = v_DetailTexcoord;\n if (tone <= step / 2.0) {\n c = mix(vec4(0.), texture2D(hatch6, uv), 12. * tone);\n }\n else if (tone <= step) {\n c = mix(texture2D(hatch6, uv), texture2D(hatch5, uv), 6. * tone);\n }\n if(tone > step && tone <= 2. * step){\n c = mix(texture2D(hatch5, uv), texture2D(hatch4, uv) , 6. * (tone - step));\n }\n if(tone > 2. * step && tone <= 3. * step){\n c = mix(texture2D(hatch4, uv), texture2D(hatch3, uv), 6. * (tone - 2. * step));\n }\n if(tone > 3. * step && tone <= 4. * step){\n c = mix(texture2D(hatch3, uv), texture2D(hatch2, uv), 6. * (tone - 3. * step));\n }\n if(tone > 4. * step && tone <= 5. * step){\n c = mix(texture2D(hatch2, uv), texture2D(hatch1, uv), 6. * (tone - 4. * step));\n }\n if(tone > 5. * step){\n c = mix(texture2D(hatch1, uv), vec4(1.), 6. * (tone - 5. * step));\n }\n\n return c.r;\n}\n\nconst vec3 w = vec3(0.2125, 0.7154, 0.0721);\n\nvoid main()\n{\n#ifdef SRGB_DECODE\n vec4 inkColor = sRGBToLinear(color);\n#else\n vec4 inkColor = color;\n#endif\n\n#ifdef VERTEX_COLOR\n #ifdef SRGB_DECODE\n inkColor *= sRGBToLinear(v_Color);\n #else\n inkColor *= v_Color;\n #endif\n#endif\n\n vec3 N = v_Normal;\n#ifdef DOUBLE_SIDED\n vec3 eyePos = viewInverse[3].xyz;\n vec3 V = normalize(eyePos - v_WorldPosition);\n\n if (dot(N, V) < 0.0) {\n N = -N;\n }\n#endif\n\n float tone = 0.0;\n\n float ambientFactor = 1.0;\n\n#ifdef BUMPMAP_ENABLED\n N = bumpNormal(v_WorldPosition, v_Normal, N);\n ambientFactor = dot(v_Normal, N);\n#endif\n\n vec3 N2 = vec3(N.x, N[NORMAL_UP_AXIS], N[NORMAL_FRONT_AXIS]);\n\n @import ecgl.common.ssaoMap.main\n\n#ifdef AMBIENT_LIGHT_COUNT\n for(int i = 0; i < AMBIENT_LIGHT_COUNT; i++)\n {\n tone += dot(ambientLightColor[i], w) * ambientFactor * ao;\n }\n#endif\n#ifdef AMBIENT_SH_LIGHT_COUNT\n for(int _idx_ = 0; _idx_ < AMBIENT_SH_LIGHT_COUNT; _idx_++)\n {{\n tone += dot(calcAmbientSHLight(_idx_, N2) * ambientSHLightColor[_idx_], w) * ao;\n }}\n#endif\n#ifdef DIRECTIONAL_LIGHT_COUNT\n#if defined(DIRECTIONAL_LIGHT_SHADOWMAP_COUNT)\n float shadowContribsDir[DIRECTIONAL_LIGHT_COUNT];\n if(shadowEnabled)\n {\n computeShadowOfDirectionalLights(v_WorldPosition, shadowContribsDir);\n }\n#endif\n for(int i = 0; i < DIRECTIONAL_LIGHT_COUNT; i++)\n {\n vec3 lightDirection = -directionalLightDirection[i];\n float lightTone = dot(directionalLightColor[i], w);\n\n float shadowContrib = 1.0;\n#if defined(DIRECTIONAL_LIGHT_SHADOWMAP_COUNT)\n if (shadowEnabled)\n {\n shadowContrib = shadowContribsDir[i];\n }\n#endif\n\n float ndl = dot(N, normalize(lightDirection)) * shadowContrib;\n\n tone += lightTone * clamp(ndl, 0.0, 1.0);\n }\n#endif\n\n gl_FragColor = mix(inkColor, paperColor, shade(clamp(tone, 0.0, 1.0)));\n }\n@end\n";


var $a463bde80ddaa79b$export$2e2bcd8739ae039 = "@export ecgl.sm.depth.vertex\n\nuniform mat4 worldViewProjection : WORLDVIEWPROJECTION;\n\nattribute vec3 position : POSITION;\nattribute vec2 texcoord : TEXCOORD_0;\n\n#ifdef VERTEX_ANIMATION\nattribute vec3 prevPosition;\nuniform float percent : 1.0;\n#endif\n\nvarying vec4 v_ViewPosition;\nvarying vec2 v_Texcoord;\n\nvoid main(){\n\n#ifdef VERTEX_ANIMATION\n vec3 pos = mix(prevPosition, position, percent);\n#else\n vec3 pos = position;\n#endif\n\n v_ViewPosition = worldViewProjection * vec4(pos, 1.0);\n gl_Position = v_ViewPosition;\n\n v_Texcoord = texcoord;\n\n}\n@end\n\n\n\n@export ecgl.sm.depth.fragment\n\n@import clay.sm.depth.fragment\n\n@end";


Object.assign((0, $e02012a49e6aaac9$export$2e2bcd8739ae039).prototype, (0, $6aec0bce2c9b0dc6$export$2e2bcd8739ae039));
(0, $90e78c81ac16d455$export$2e2bcd8739ae039).import((0, $bf045847478ef2ac$export$2e2bcd8739ae039));
(0, $90e78c81ac16d455$export$2e2bcd8739ae039).import((0, $cf90e259d5b6bbd4$export$2e2bcd8739ae039));
(0, $90e78c81ac16d455$export$2e2bcd8739ae039).import((0, $71fad439de837a00$export$2e2bcd8739ae039));
(0, $90e78c81ac16d455$export$2e2bcd8739ae039).import((0, $73539e1df8b41957$export$2e2bcd8739ae039));
(0, $90e78c81ac16d455$export$2e2bcd8739ae039).import((0, $e1b6e328709549d5$export$2e2bcd8739ae039));
(0, $90e78c81ac16d455$export$2e2bcd8739ae039).import((0, $c2528583c677271b$export$2e2bcd8739ae039));
(0, $90e78c81ac16d455$export$2e2bcd8739ae039).import((0, $31e589a17d0fd7dd$export$2e2bcd8739ae039));
(0, $90e78c81ac16d455$export$2e2bcd8739ae039).import((0, $a463bde80ddaa79b$export$2e2bcd8739ae039));
function $ddf90840ffe6c0e1$var$isValueNone(value) {
    return !value || value === "none";
}
function $ddf90840ffe6c0e1$var$isValueImage(value) {
    return value instanceof HTMLCanvasElement || value instanceof HTMLImageElement || value instanceof Image;
}
function $ddf90840ffe6c0e1$var$isECharts(value) {
    return value.getZr && value.setOption;
} // Overwrite addToScene and removeFromScene
var $ddf90840ffe6c0e1$var$oldAddToScene = (0, $e49354c4f1efd6e1$export$2e2bcd8739ae039).prototype.addToScene;
var $ddf90840ffe6c0e1$var$oldRemoveFromScene = (0, $e49354c4f1efd6e1$export$2e2bcd8739ae039).prototype.removeFromScene;
(0, $e49354c4f1efd6e1$export$2e2bcd8739ae039).prototype.addToScene = function(node) {
    $ddf90840ffe6c0e1$var$oldAddToScene.call(this, node);
    if (this.__zr) {
        var zr = this.__zr;
        node.traverse(function(child) {
            child.__zr = zr;
            if (child.addAnimatorsToZr) child.addAnimatorsToZr(zr);
        });
    }
};
(0, $e49354c4f1efd6e1$export$2e2bcd8739ae039).prototype.removeFromScene = function(node) {
    $ddf90840ffe6c0e1$var$oldRemoveFromScene.call(this, node);
    node.traverse(function(child) {
        var zr = child.__zr;
        child.__zr = null;
        if (zr && child.removeAnimatorsFromZr) child.removeAnimatorsFromZr(zr);
    });
};
/**
 * @param {string} textureName
 * @param {string|HTMLImageElement|HTMLCanvasElement} imgValue
 * @param {module:echarts/ExtensionAPI} api
 * @param {Object} [textureOpts]
 */ (0, $b70ebca493753aba$export$2e2bcd8739ae039).prototype.setTextureImage = function(textureName, imgValue, api, textureOpts) {
    if (!this.shader) return;
    var zr = api.getZr();
    var material = this;
    var texture;
    material.autoUpdateTextureStatus = false; // disableTexture first
    material.disableTexture(textureName);
    if (!$ddf90840ffe6c0e1$var$isValueNone(imgValue)) {
        texture = $ddf90840ffe6c0e1$var$graphicGL.loadTexture(imgValue, api, textureOpts, function(texture) {
            material.enableTexture(textureName);
            zr && zr.refresh();
        }); // Set texture immediately for other code to verify if have this texture.
        material.set(textureName, texture);
    }
    return texture;
};
var $ddf90840ffe6c0e1$var$graphicGL = {};
$ddf90840ffe6c0e1$var$graphicGL.Renderer = (0, $a11c3d79797af833$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.Node = (0, $e02012a49e6aaac9$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.Mesh = (0, $652fd5cc6a0444a2$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.Shader = (0, $90e78c81ac16d455$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.Material = (0, $b70ebca493753aba$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.Texture = (0, $4261427f149675a4$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.Texture2D = (0, $b7751fad94c1afee$export$2e2bcd8739ae039); // Geometries
$ddf90840ffe6c0e1$var$graphicGL.Geometry = (0, $c75c69a759bf7591$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.SphereGeometry = (0, $6277c445f3012d76$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.PlaneGeometry = (0, $b1c813646bb685e2$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.CubeGeometry = (0, $3581bb0beb488a28$export$2e2bcd8739ae039); // Lights
$ddf90840ffe6c0e1$var$graphicGL.AmbientLight = (0, $993f66386318e8f0$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.DirectionalLight = (0, $392be4a80b0487de$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.PointLight = (0, $0a77c172f8c2c3c4$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.SpotLight = (0, $342af288d7b4a59c$export$2e2bcd8739ae039); // Cameras
$ddf90840ffe6c0e1$var$graphicGL.PerspectiveCamera = (0, $b0e6d9b112e2eb50$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.OrthographicCamera = (0, $c4a0e1584dbfc1e9$export$2e2bcd8739ae039); // Math
$ddf90840ffe6c0e1$var$graphicGL.Vector2 = (0, $2cb41795bddfe4d3$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.Vector3 = (0, $27fea36417076c2d$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.Vector4 = (0, $8d53bee005d3c213$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.Quaternion = (0, $0fd61056af77925d$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.Matrix2 = (0, $b61dfb591e799596$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.Matrix2d = (0, $4e11dc7847d66aee$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.Matrix3 = (0, $fae6b6ac255b9b24$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.Matrix4 = (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.Plane = (0, $4a62d5e175a73abf$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.Ray = (0, $65a5d9098f8e83b0$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.BoundingBox = (0, $39676d59fa1158f6$export$2e2bcd8739ae039);
$ddf90840ffe6c0e1$var$graphicGL.Frustum = (0, $81d01ecfe643f241$export$2e2bcd8739ae039); // Texture utilities
var $ddf90840ffe6c0e1$var$blankImage = null;
function $ddf90840ffe6c0e1$var$getBlankImage() {
    if ($ddf90840ffe6c0e1$var$blankImage !== null) return $ddf90840ffe6c0e1$var$blankImage;
    $ddf90840ffe6c0e1$var$blankImage = (0, $f6d4d59e8da69524$export$2e2bcd8739ae039).createBlank("rgba(255,255,255,0)").image;
    return $ddf90840ffe6c0e1$var$blankImage;
}
function $ddf90840ffe6c0e1$var$nearestPowerOfTwo(val) {
    return Math.pow(2, Math.round(Math.log(val) / Math.LN2));
}
function $ddf90840ffe6c0e1$var$convertTextureToPowerOfTwo(texture) {
    if ((texture.wrapS === (0, $4261427f149675a4$export$2e2bcd8739ae039).REPEAT || texture.wrapT === (0, $4261427f149675a4$export$2e2bcd8739ae039).REPEAT) && texture.image) {
        // var canvas = document.createElement('canvas');
        var width = $ddf90840ffe6c0e1$var$nearestPowerOfTwo(texture.width);
        var height = $ddf90840ffe6c0e1$var$nearestPowerOfTwo(texture.height);
        if (width !== texture.width || height !== texture.height) {
            var canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(texture.image, 0, 0, width, height);
            texture.image = canvas;
        }
    }
}
/**
 * @param {string|HTMLImageElement|HTMLCanvasElement} imgValue
 * @param {module:echarts/ExtensionAPI} api
 * @param {Object} [textureOpts]
 * @param {Function} cb
 */ // TODO Promise, test
$ddf90840ffe6c0e1$var$graphicGL.loadTexture = function(imgValue, api, textureOpts, cb) {
    if (typeof textureOpts === "function") {
        cb = textureOpts;
        textureOpts = {};
    }
    textureOpts = textureOpts || {};
    var keys = Object.keys(textureOpts).sort();
    var prefix = "";
    for(var i = 0; i < keys.length; i++)prefix += keys[i] + "_" + textureOpts[keys[i]] + "_";
    var textureCache = api.__textureCache = api.__textureCache || new (0, $d91b0b6fc564d9c7$export$2e2bcd8739ae039)(20);
    if ($ddf90840ffe6c0e1$var$isECharts(imgValue)) {
        var id = imgValue.__textureid__;
        var textureObj = textureCache.get(prefix + id);
        if (!textureObj) {
            var surface = new (0, $7f10657aa3c18c20$export$2e2bcd8739ae039)(imgValue);
            surface.onupdate = function() {
                api.getZr().refresh();
            };
            textureObj = {
                texture: surface.getTexture()
            };
            for(var i = 0; i < keys.length; i++)textureObj.texture[keys[i]] = textureOpts[keys[i]];
            id = imgValue.__textureid__ || "__ecgl_ec__" + textureObj.texture.__uid__;
            imgValue.__textureid__ = id;
            textureCache.put(prefix + id, textureObj);
            cb && cb(textureObj.texture);
        } else {
            textureObj.texture.surface.setECharts(imgValue);
            cb && cb(textureObj.texture);
        }
        return textureObj.texture;
    } else if ($ddf90840ffe6c0e1$var$isValueImage(imgValue)) {
        var id = imgValue.__textureid__;
        var textureObj = textureCache.get(prefix + id);
        if (!textureObj) {
            textureObj = {
                texture: new $ddf90840ffe6c0e1$var$graphicGL.Texture2D({
                    image: imgValue
                })
            };
            for(var i = 0; i < keys.length; i++)textureObj.texture[keys[i]] = textureOpts[keys[i]];
            id = imgValue.__textureid__ || "__ecgl_image__" + textureObj.texture.__uid__;
            imgValue.__textureid__ = id;
            textureCache.put(prefix + id, textureObj);
            $ddf90840ffe6c0e1$var$convertTextureToPowerOfTwo(textureObj.texture); // TODO Next tick?
            cb && cb(textureObj.texture);
        }
        return textureObj.texture;
    } else {
        var textureObj = textureCache.get(prefix + imgValue);
        if (textureObj) {
            if (textureObj.callbacks) // Add to pending callbacks
            textureObj.callbacks.push(cb);
            else // TODO Next tick?
            cb && cb(textureObj.texture);
        } else // Maybe base64
        if (imgValue.match(/.hdr$|^data:application\/octet-stream/)) {
            textureObj = {
                callbacks: [
                    cb
                ]
            };
            var texture = (0, $f6d4d59e8da69524$export$2e2bcd8739ae039).loadTexture(imgValue, {
                exposure: textureOpts.exposure,
                fileType: "hdr"
            }, function() {
                texture.dirty();
                textureObj.callbacks.forEach(function(cb) {
                    cb && cb(texture);
                });
                textureObj.callbacks = null;
            });
            textureObj.texture = texture;
            textureCache.put(prefix + imgValue, textureObj);
        } else {
            var texture = new $ddf90840ffe6c0e1$var$graphicGL.Texture2D({
                image: new Image()
            });
            for(var i = 0; i < keys.length; i++)texture[keys[i]] = textureOpts[keys[i]];
            textureObj = {
                texture: texture,
                callbacks: [
                    cb
                ]
            };
            var originalImage = texture.image;
            originalImage.onload = function() {
                texture.image = originalImage;
                $ddf90840ffe6c0e1$var$convertTextureToPowerOfTwo(texture);
                texture.dirty();
                textureObj.callbacks.forEach(function(cb) {
                    cb && cb(texture);
                });
                textureObj.callbacks = null;
            };
            originalImage.crossOrigin = "Anonymous";
            originalImage.src = imgValue; // Use blank image as place holder.
            texture.image = $ddf90840ffe6c0e1$var$getBlankImage();
            textureCache.put(prefix + imgValue, textureObj);
        }
        return textureObj.texture;
    }
};
/**
 * Create ambientCubemap and ambientSH light. respectively to have specular and diffuse light
 * @return {Object} { specular, diffuse }
 */ $ddf90840ffe6c0e1$var$graphicGL.createAmbientCubemap = function(opt, renderer, api, cb) {
    opt = opt || {};
    var textureUrl = opt.texture;
    var exposure = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(opt.exposure, 1.0);
    var ambientCubemap = new (0, $7e1d35567c730ae0$export$2e2bcd8739ae039)({
        intensity: (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(opt.specularIntensity, 1.0)
    });
    var ambientSH = new (0, $5c9c4e87fb5724a4$export$2e2bcd8739ae039)({
        intensity: (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(opt.diffuseIntensity, 1.0),
        coefficients: [
            0.844,
            0.712,
            0.691,
            -0.037,
            0.083,
            0.167,
            0.343,
            0.288,
            0.299,
            -0.041,
            -0.021,
            -0.009,
            -0.003,
            -0.041,
            -0.064,
            -0.011,
            -0.007,
            -0.004,
            -0.031,
            0.034,
            0.081,
            -0.06,
            -0.049,
            -0.06,
            0.046,
            0.056,
            0.050
        ]
    });
    ambientCubemap.cubemap = $ddf90840ffe6c0e1$var$graphicGL.loadTexture(textureUrl, api, {
        exposure: exposure
    }, function() {
        // TODO Performance when multiple view
        ambientCubemap.cubemap.flipY = false;
        var time;
        ambientCubemap.prefilter(renderer, 32);
        var dTime;
        ambientSH.coefficients = (0, $4fbfb756e12ce490$export$2e2bcd8739ae039).projectEnvironmentMap(renderer, ambientCubemap.cubemap, {
            lod: 1
        });
        cb && cb(); // TODO Refresh ?
    });
    return {
        specular: ambientCubemap,
        diffuse: ambientSH
    };
};
/**
 * Create a blank texture for placeholder
 */ $ddf90840ffe6c0e1$var$graphicGL.createBlankTexture = (0, $f6d4d59e8da69524$export$2e2bcd8739ae039).createBlank;
/**
 * If value is image
 * @param {*}
 * @return {boolean}
 */ $ddf90840ffe6c0e1$var$graphicGL.isImage = $ddf90840ffe6c0e1$var$isValueImage;
$ddf90840ffe6c0e1$var$graphicGL.additiveBlend = function(gl) {
    gl.blendEquation(gl.FUNC_ADD);
    gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
};
/**
 * @param {string|Array.<number>} colorStr
 * @param {Array.<number>} [rgba]
 * @return {Array.<number>} rgba
 */ $ddf90840ffe6c0e1$var$graphicGL.parseColor = function(colorStr, rgba) {
    if (colorStr instanceof Array) {
        if (!rgba) rgba = [];
         // Color has been parsed.
        rgba[0] = colorStr[0];
        rgba[1] = colorStr[1];
        rgba[2] = colorStr[2];
        if (colorStr.length > 3) rgba[3] = colorStr[3];
        else rgba[3] = 1;
        return rgba;
    }
    rgba = $2c037f5bda6341ca$exports.parse(colorStr || "#000", rgba) || [
        0,
        0,
        0,
        0
    ];
    rgba[0] /= 255;
    rgba[1] /= 255;
    rgba[2] /= 255;
    return rgba;
};
/**
 * Convert alpha beta rotation to direction.
 * @param {number} alpha
 * @param {number} beta
 * @return {Array.<number>}
 */ $ddf90840ffe6c0e1$var$graphicGL.directionFromAlphaBeta = function(alpha, beta) {
    var theta = alpha / 180 * Math.PI + Math.PI / 2;
    var phi = -beta / 180 * Math.PI + Math.PI / 2;
    var dir = [];
    var r = Math.sin(theta);
    dir[0] = r * Math.cos(phi);
    dir[1] = -Math.cos(theta);
    dir[2] = r * Math.sin(phi);
    return dir;
};
/**
 * Get shadow resolution from shadowQuality configuration
 */ $ddf90840ffe6c0e1$var$graphicGL.getShadowResolution = function(shadowQuality) {
    var shadowResolution = 1024;
    switch(shadowQuality){
        case "low":
            shadowResolution = 512;
            break;
        case "medium":
            break;
        case "high":
            shadowResolution = 2048;
            break;
        case "ultra":
            shadowResolution = 4096;
            break;
    }
    return shadowResolution;
};
/**
 * Shading utilities
 */ $ddf90840ffe6c0e1$var$graphicGL.COMMON_SHADERS = [
    "lambert",
    "color",
    "realistic",
    "hatching",
    "shadow"
];
/**
 * Create shader including vertex and fragment
 * @param {string} prefix.
 */ $ddf90840ffe6c0e1$var$graphicGL.createShader = function(prefix) {
    if (prefix === "ecgl.shadow") prefix = "ecgl.displayShadow";
    var vertexShaderStr = (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source(prefix + ".vertex");
    var fragmentShaderStr = (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source(prefix + ".fragment");
    if (!vertexShaderStr) console.error("Vertex shader of '%s' not exits", prefix);
    if (!fragmentShaderStr) console.error("Fragment shader of '%s' not exits", prefix);
    var shader = new (0, $90e78c81ac16d455$export$2e2bcd8739ae039)(vertexShaderStr, fragmentShaderStr);
    shader.name = prefix;
    return shader;
};
$ddf90840ffe6c0e1$var$graphicGL.createMaterial = function(prefix, defines) {
    if (!(defines instanceof Array)) defines = [
        defines
    ];
    var shader = $ddf90840ffe6c0e1$var$graphicGL.createShader(prefix);
    var material = new (0, $b70ebca493753aba$export$2e2bcd8739ae039)({
        shader: shader
    });
    defines.forEach(function(defineName) {
        if (typeof defineName === "string") material.define(defineName);
    });
    return material;
};
/**
 * Set material from model.
 * @param {clay.Material} material
 * @param {module:echarts/model/Model} model
 * @param {module:echarts/ExtensionAPI} api
 */ $ddf90840ffe6c0e1$var$graphicGL.setMaterialFromModel = function(shading, material, model, api) {
    material.autoUpdateTextureStatus = false;
    var materialModel = model.getModel(shading + "Material");
    var detailTexture = materialModel.get("detailTexture");
    var uvRepeat = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(materialModel.get("textureTiling"), 1.0);
    var uvOffset = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(materialModel.get("textureOffset"), 0.0);
    if (typeof uvRepeat === "number") uvRepeat = [
        uvRepeat,
        uvRepeat
    ];
    if (typeof uvOffset === "number") uvOffset = [
        uvOffset,
        uvOffset
    ];
    var repeatParam = uvRepeat[0] > 1 || uvRepeat[1] > 1 ? $ddf90840ffe6c0e1$var$graphicGL.Texture.REPEAT : $ddf90840ffe6c0e1$var$graphicGL.Texture.CLAMP_TO_EDGE;
    var textureOpt = {
        anisotropic: 8,
        wrapS: repeatParam,
        wrapT: repeatParam
    };
    if (shading === "realistic") {
        var roughness = materialModel.get("roughness");
        var metalness = materialModel.get("metalness");
        if (metalness != null) // Try to treat as a texture, TODO More check
        {
            if (isNaN(metalness)) {
                material.setTextureImage("metalnessMap", metalness, api, textureOpt);
                metalness = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(materialModel.get("metalnessAdjust"), 0.5);
            }
        } else // Default metalness.
        metalness = 0;
        if (roughness != null) // Try to treat as a texture, TODO More check
        {
            if (isNaN(roughness)) {
                material.setTextureImage("roughnessMap", roughness, api, textureOpt);
                roughness = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(materialModel.get("roughnessAdjust"), 0.5);
            }
        } else // Default roughness.
        roughness = 0.5;
        var normalTextureVal = materialModel.get("normalTexture");
        material.setTextureImage("detailMap", detailTexture, api, textureOpt);
        material.setTextureImage("normalMap", normalTextureVal, api, textureOpt);
        material.set({
            roughness: roughness,
            metalness: metalness,
            detailUvRepeat: uvRepeat,
            detailUvOffset: uvOffset
        }); // var normalTexture = material.get('normalMap');
    // if (normalTexture) {
    // PENDING
    // normalTexture.format = Texture.SRGB;
    // }
    } else if (shading === "lambert") {
        material.setTextureImage("detailMap", detailTexture, api, textureOpt);
        material.set({
            detailUvRepeat: uvRepeat,
            detailUvOffset: uvOffset
        });
    } else if (shading === "color") {
        material.setTextureImage("detailMap", detailTexture, api, textureOpt);
        material.set({
            detailUvRepeat: uvRepeat,
            detailUvOffset: uvOffset
        });
    } else if (shading === "hatching") {
        var tams = materialModel.get("hatchingTextures") || [];
        tams.length;
        for(var i = 0; i < 6; i++)material.setTextureImage("hatch" + (i + 1), tams[i], api, {
            anisotropic: 8,
            wrapS: $ddf90840ffe6c0e1$var$graphicGL.Texture.REPEAT,
            wrapT: $ddf90840ffe6c0e1$var$graphicGL.Texture.REPEAT
        });
        material.set({
            detailUvRepeat: uvRepeat,
            detailUvOffset: uvOffset
        });
    }
};
$ddf90840ffe6c0e1$var$graphicGL.updateVertexAnimation = function(mappingAttributes, previousMesh, currentMesh, seriesModel) {
    var enableAnimation = seriesModel.get("animation");
    var duration = seriesModel.get("animationDurationUpdate");
    var easing = seriesModel.get("animationEasingUpdate");
    var shadowDepthMaterial = currentMesh.shadowDepthMaterial;
    if (enableAnimation && previousMesh && duration > 0 // Only animate when bar count are not changed
     && previousMesh.geometry.vertexCount === currentMesh.geometry.vertexCount) {
        currentMesh.material.define("vertex", "VERTEX_ANIMATION");
        currentMesh.ignorePreZ = true;
        if (shadowDepthMaterial) shadowDepthMaterial.define("vertex", "VERTEX_ANIMATION");
        for(var i = 0; i < mappingAttributes.length; i++)currentMesh.geometry.attributes[mappingAttributes[i][0]].value = previousMesh.geometry.attributes[mappingAttributes[i][1]].value;
        currentMesh.geometry.dirty();
        currentMesh.__percent = 0;
        currentMesh.material.set("percent", 0);
        currentMesh.stopAnimation();
        currentMesh.animate().when(duration, {
            __percent: 1
        }).during(function() {
            currentMesh.material.set("percent", currentMesh.__percent);
            if (shadowDepthMaterial) shadowDepthMaterial.set("percent", currentMesh.__percent);
        }).done(function() {
            currentMesh.ignorePreZ = false;
            currentMesh.material.undefine("vertex", "VERTEX_ANIMATION");
            if (shadowDepthMaterial) shadowDepthMaterial.undefine("vertex", "VERTEX_ANIMATION");
        }).start(easing);
    } else {
        currentMesh.material.undefine("vertex", "VERTEX_ANIMATION");
        if (shadowDepthMaterial) shadowDepthMaterial.undefine("vertex", "VERTEX_ANIMATION");
    }
};
var $ddf90840ffe6c0e1$export$2e2bcd8739ae039 = $ddf90840ffe6c0e1$var$graphicGL;




/**
 * @constructor
 * @alias module:echarts-gl/core/LayerGL
 * @param {string} id Layer ID
 * @param {module:zrender/ZRender} zr
 */ var $76f930cbbcf58f49$var$LayerGL = function(id, zr) {
    /**
   * Layer ID
   * @type {string}
   */ this.id = id;
    /**
   * @type {module:zrender/ZRender}
   */ this.zr = zr;
    /**
   * @type {clay.Renderer}
   */ try {
        this.renderer = new (0, $a11c3d79797af833$export$2e2bcd8739ae039)({
            clearBit: 0,
            devicePixelRatio: zr.painter.dpr,
            preserveDrawingBuffer: true,
            // PENDING
            premultipliedAlpha: true
        });
        this.renderer.resize(zr.painter.getWidth(), zr.painter.getHeight());
    } catch (e) {
        this.renderer = null;
        this.dom = document.createElement("div");
        this.dom.style.cssText = "position:absolute; left: 0; top: 0; right: 0; bottom: 0;";
        this.dom.className = "ecgl-nowebgl";
        this.dom.innerHTML = "Sorry, your browser does not support WebGL";
        console.error(e);
        return;
    }
    this.onglobalout = this.onglobalout.bind(this);
    zr.on("globalout", this.onglobalout);
    /**
   * Canvas dom for webgl rendering
   * @type {HTMLCanvasElement}
   */ this.dom = this.renderer.canvas;
    var style = this.dom.style;
    style.position = "absolute";
    style.left = "0";
    style.top = "0";
    /**
   * @type {Array.<clay.Scene>}
   */ this.views = [];
    this._picking = new (0, $0c938f7cf7210181$export$2e2bcd8739ae039)({
        renderer: this.renderer
    });
    this._viewsToDispose = [];
    /**
   * Current accumulating id.
   */ this._accumulatingId = 0;
    this._zrEventProxy = new $03154d907069e78f$exports.Rect({
        shape: {
            x: -1,
            y: -1,
            width: 2,
            height: 2
        },
        // FIXME Better solution.
        __isGLToZRProxy: true
    });
    this._backgroundColor = null;
    this._disposed = false;
};
$76f930cbbcf58f49$var$LayerGL.prototype.setUnpainted = function() {};
/**
 * @param {module:echarts-gl/core/ViewGL} view
 */ $76f930cbbcf58f49$var$LayerGL.prototype.addView = function(view) {
    if (view.layer === this) return;
     // If needs to dispose in this layer. unmark it.
    var idx = this._viewsToDispose.indexOf(view);
    if (idx >= 0) this._viewsToDispose.splice(idx, 1);
    this.views.push(view);
    view.layer = this;
    var zr = this.zr;
    view.scene.traverse(function(node) {
        node.__zr = zr;
        if (node.addAnimatorsToZr) node.addAnimatorsToZr(zr);
    });
};
function $76f930cbbcf58f49$var$removeFromZr(node) {
    var zr = node.__zr;
    node.__zr = null;
    if (zr && node.removeAnimatorsFromZr) node.removeAnimatorsFromZr(zr);
}
/**
 * @param {module:echarts-gl/core/ViewGL} view
 */ $76f930cbbcf58f49$var$LayerGL.prototype.removeView = function(view) {
    if (view.layer !== this) return;
    var idx = this.views.indexOf(view);
    if (idx >= 0) {
        this.views.splice(idx, 1);
        view.scene.traverse($76f930cbbcf58f49$var$removeFromZr, this);
        view.layer = null; // Mark to dispose in this layer.
        this._viewsToDispose.push(view);
    }
};
/**
 * Remove all views
 */ $76f930cbbcf58f49$var$LayerGL.prototype.removeViewsAll = function() {
    this.views.forEach(function(view) {
        view.scene.traverse($76f930cbbcf58f49$var$removeFromZr, this);
        view.layer = null; // Mark to dispose in this layer.
        this._viewsToDispose.push(view);
    }, this);
    this.views.length = 0;
};
/**
 * Resize the canvas and viewport, will be invoked by zrender
 * @param  {number} width
 * @param  {number} height
 */ $76f930cbbcf58f49$var$LayerGL.prototype.resize = function(width, height) {
    var renderer = this.renderer;
    renderer.resize(width, height);
};
/**
 * Clear color and depth
 * @return {[type]} [description]
 */ $76f930cbbcf58f49$var$LayerGL.prototype.clear = function() {
    var gl = this.renderer.gl;
    var clearColor = this._backgroundColor || [
        0,
        0,
        0,
        0
    ];
    gl.clearColor(clearColor[0], clearColor[1], clearColor[2], clearColor[3]);
    gl.depthMask(true);
    gl.colorMask(true, true, true, true);
    gl.clear(gl.DEPTH_BUFFER_BIT | gl.COLOR_BUFFER_BIT);
};
/**
 * Clear depth
 */ $76f930cbbcf58f49$var$LayerGL.prototype.clearDepth = function() {
    var gl = this.renderer.gl;
    gl.clear(gl.DEPTH_BUFFER_BIT);
};
/**
 * Clear color
 */ $76f930cbbcf58f49$var$LayerGL.prototype.clearColor = function() {
    var gl = this.renderer.gl;
    gl.clearColor(0, 0, 0, 0);
    gl.clear(gl.COLOR_BUFFER_BIT);
};
/**
 * Mark layer to refresh next tick
 */ $76f930cbbcf58f49$var$LayerGL.prototype.needsRefresh = function() {
    this.zr.refresh();
};
/**
 * Refresh the layer, will be invoked by zrender
 */ $76f930cbbcf58f49$var$LayerGL.prototype.refresh = function(bgColor) {
    this._backgroundColor = bgColor ? (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(bgColor) : [
        0,
        0,
        0,
        0
    ];
    this.renderer.clearColor = this._backgroundColor;
    for(var i = 0; i < this.views.length; i++)this.views[i].prepareRender(this.renderer);
    this._doRender(false); // Auto dispose unused resources on GPU, like program(shader), texture, geometry(buffers)
    this._trackAndClean(); // Dispose trashed views
    for(var i = 0; i < this._viewsToDispose.length; i++)this._viewsToDispose[i].dispose(this.renderer);
    this._viewsToDispose.length = 0;
    this._startAccumulating();
};
$76f930cbbcf58f49$var$LayerGL.prototype.renderToCanvas = function(ctx) {
    // PENDING will block the page
    this._startAccumulating(true);
    ctx.drawImage(this.dom, 0, 0, ctx.canvas.width, ctx.canvas.height);
};
$76f930cbbcf58f49$var$LayerGL.prototype._doRender = function(accumulating) {
    this.clear();
    this.renderer.saveViewport();
    for(var i = 0; i < this.views.length; i++)this.views[i].render(this.renderer, accumulating);
    this.renderer.restoreViewport();
};
/**
 * Stop accumulating
 */ $76f930cbbcf58f49$var$LayerGL.prototype._stopAccumulating = function() {
    this._accumulatingId = 0;
    clearTimeout(this._accumulatingTimeout);
};
var $76f930cbbcf58f49$var$accumulatingId = 1;
/**
 * Start accumulating all the views.
 * Accumulating is for antialising and have more sampling in SSAO
 * @private
 */ $76f930cbbcf58f49$var$LayerGL.prototype._startAccumulating = function(immediate) {
    var self = this;
    this._stopAccumulating();
    var needsAccumulate = false;
    for(var i = 0; i < this.views.length; i++)needsAccumulate = this.views[i].needsAccumulate() || needsAccumulate;
    if (!needsAccumulate) return;
    function accumulate(id) {
        if (!self._accumulatingId || id !== self._accumulatingId) return;
        var isFinished = true;
        for(var i = 0; i < self.views.length; i++)isFinished = self.views[i].isAccumulateFinished() && needsAccumulate;
        if (!isFinished) {
            self._doRender(true);
            if (immediate) accumulate(id);
            else (0, $731d42ad1858cd4c$export$2e2bcd8739ae039)(function() {
                accumulate(id);
            });
        }
    }
    this._accumulatingId = $76f930cbbcf58f49$var$accumulatingId++;
    if (immediate) accumulate(self._accumulatingId);
    else this._accumulatingTimeout = setTimeout(function() {
        accumulate(self._accumulatingId);
    }, 50);
};
$76f930cbbcf58f49$var$LayerGL.prototype._trackAndClean = function() {
    var textureList = [];
    var geometriesList = []; // Mark all resources unused;
    if (this._textureList) {
        $76f930cbbcf58f49$var$markUnused(this._textureList);
        $76f930cbbcf58f49$var$markUnused(this._geometriesList);
    }
    for(var i = 0; i < this.views.length; i++)$76f930cbbcf58f49$var$collectResources(this.views[i].scene, textureList, geometriesList);
     // Dispose those unsed resources.
    if (this._textureList) {
        $76f930cbbcf58f49$var$checkAndDispose(this.renderer, this._textureList);
        $76f930cbbcf58f49$var$checkAndDispose(this.renderer, this._geometriesList);
    }
    this._textureList = textureList;
    this._geometriesList = geometriesList;
};
function $76f930cbbcf58f49$var$markUnused(resourceList) {
    for(var i = 0; i < resourceList.length; i++)resourceList[i].__used__ = 0;
}
function $76f930cbbcf58f49$var$checkAndDispose(renderer, resourceList) {
    for(var i = 0; i < resourceList.length; i++)if (!resourceList[i].__used__) resourceList[i].dispose(renderer);
}
function $76f930cbbcf58f49$var$updateUsed(resource, list) {
    resource.__used__ = resource.__used__ || 0;
    resource.__used__++;
    if (resource.__used__ === 1) // Don't push to the list twice.
    list.push(resource);
}
function $76f930cbbcf58f49$var$collectResources(scene, textureResourceList, geometryResourceList) {
    var prevMaterial;
    var prevGeometry;
    scene.traverse(function(renderable) {
        if (renderable.isRenderable()) {
            var geometry = renderable.geometry;
            var material = renderable.material; // TODO optimize!!
            if (material !== prevMaterial) {
                var textureUniforms = material.getTextureUniforms();
                for(var u = 0; u < textureUniforms.length; u++){
                    var uniformName = textureUniforms[u];
                    var val = material.uniforms[uniformName].value;
                    if (!val) continue;
                    if (val instanceof (0, $4261427f149675a4$export$2e2bcd8739ae039)) $76f930cbbcf58f49$var$updateUsed(val, textureResourceList);
                    else if (val instanceof Array) {
                        for(var k = 0; k < val.length; k++)if (val[k] instanceof (0, $4261427f149675a4$export$2e2bcd8739ae039)) $76f930cbbcf58f49$var$updateUsed(val[k], textureResourceList);
                    }
                }
            }
            if (geometry !== prevGeometry) $76f930cbbcf58f49$var$updateUsed(geometry, geometryResourceList);
            prevMaterial = material;
            prevGeometry = geometry;
        }
    });
    for(var k = 0; k < scene.lights.length; k++)// Track AmbientCubemap
    if (scene.lights[k].cubemap) $76f930cbbcf58f49$var$updateUsed(scene.lights[k].cubemap, textureResourceList);
}
/**
 * Dispose the layer
 */ $76f930cbbcf58f49$var$LayerGL.prototype.dispose = function() {
    if (this._disposed) return;
    this._stopAccumulating();
    if (this._textureList) {
        $76f930cbbcf58f49$var$markUnused(this._textureList);
        $76f930cbbcf58f49$var$markUnused(this._geometriesList);
        $76f930cbbcf58f49$var$checkAndDispose(this.renderer, this._textureList);
        $76f930cbbcf58f49$var$checkAndDispose(this.renderer, this._geometriesList);
    }
    this.zr.off("globalout", this.onglobalout);
    this._disposed = true;
}; // Event handlers
$76f930cbbcf58f49$var$LayerGL.prototype.onmousedown = function(e) {
    if (e.target && e.target.__isGLToZRProxy) return;
    e = e.event;
    var obj = this.pickObject(e.offsetX, e.offsetY);
    if (obj) {
        this._dispatchEvent("mousedown", e, obj);
        this._dispatchDataEvent("mousedown", e, obj);
    }
    this._downX = e.offsetX;
    this._downY = e.offsetY;
};
$76f930cbbcf58f49$var$LayerGL.prototype.onmousemove = function(e) {
    if (e.target && e.target.__isGLToZRProxy) return;
    e = e.event;
    var obj = this.pickObject(e.offsetX, e.offsetY);
    var target = obj && obj.target;
    var lastHovered = this._hovered;
    this._hovered = obj;
    if (lastHovered && target !== lastHovered.target) {
        lastHovered.relatedTarget = target;
        this._dispatchEvent("mouseout", e, lastHovered); // this._dispatchDataEvent('mouseout', e, lastHovered);
        this.zr.setCursorStyle("default");
    }
    this._dispatchEvent("mousemove", e, obj);
    if (obj) {
        this.zr.setCursorStyle("pointer");
        if (!lastHovered || target !== lastHovered.target) this._dispatchEvent("mouseover", e, obj); // this._dispatchDataEvent('mouseover', e, obj);
    }
    this._dispatchDataEvent("mousemove", e, obj);
};
$76f930cbbcf58f49$var$LayerGL.prototype.onmouseup = function(e) {
    if (e.target && e.target.__isGLToZRProxy) return;
    e = e.event;
    var obj = this.pickObject(e.offsetX, e.offsetY);
    if (obj) {
        this._dispatchEvent("mouseup", e, obj);
        this._dispatchDataEvent("mouseup", e, obj);
    }
    this._upX = e.offsetX;
    this._upY = e.offsetY;
};
$76f930cbbcf58f49$var$LayerGL.prototype.onclick = $76f930cbbcf58f49$var$LayerGL.prototype.dblclick = function(e) {
    if (e.target && e.target.__isGLToZRProxy) return;
     // Ignore click event if mouse moved
    var dx = this._upX - this._downX;
    var dy = this._upY - this._downY;
    if (Math.sqrt(dx * dx + dy * dy) > 20) return;
    e = e.event;
    var obj = this.pickObject(e.offsetX, e.offsetY);
    if (obj) {
        this._dispatchEvent(e.type, e, obj);
        this._dispatchDataEvent(e.type, e, obj);
    } // Try set depth of field onclick
    var result = this._clickToSetFocusPoint(e);
    if (result) {
        var success = result.view.setDOFFocusOnPoint(result.distance);
        if (success) this.zr.refresh();
    }
};
$76f930cbbcf58f49$var$LayerGL.prototype._clickToSetFocusPoint = function(e) {
    var renderer = this.renderer;
    var oldViewport = renderer.viewport;
    for(var i = this.views.length - 1; i >= 0; i--){
        var viewGL = this.views[i];
        if (viewGL.hasDOF() && viewGL.containPoint(e.offsetX, e.offsetY)) {
            this._picking.scene = viewGL.scene;
            this._picking.camera = viewGL.camera; // Only used for picking, renderer.setViewport will also invoke gl.viewport.
            // Set directly, PENDING.
            renderer.viewport = viewGL.viewport;
            var result = this._picking.pick(e.offsetX, e.offsetY, true);
            if (result) {
                result.view = viewGL;
                return result;
            }
        }
    }
    renderer.viewport = oldViewport;
};
$76f930cbbcf58f49$var$LayerGL.prototype.onglobalout = function(e) {
    var lastHovered = this._hovered;
    if (lastHovered) this._dispatchEvent("mouseout", e, {
        target: lastHovered.target
    });
};
$76f930cbbcf58f49$var$LayerGL.prototype.pickObject = function(x, y) {
    var output = [];
    var renderer = this.renderer;
    var oldViewport = renderer.viewport;
    for(var i = 0; i < this.views.length; i++){
        var viewGL = this.views[i];
        if (viewGL.containPoint(x, y)) {
            this._picking.scene = viewGL.scene;
            this._picking.camera = viewGL.camera; // Only used for picking, renderer.setViewport will also invoke gl.viewport.
            // Set directly, PENDING.
            renderer.viewport = viewGL.viewport;
            this._picking.pickAll(x, y, output);
        }
    }
    renderer.viewport = oldViewport;
    output.sort(function(a, b) {
        return a.distance - b.distance;
    });
    return output[0];
};
$76f930cbbcf58f49$var$LayerGL.prototype._dispatchEvent = function(eveName, originalEvent, newEvent) {
    if (!newEvent) newEvent = {};
    var current = newEvent.target;
    newEvent.cancelBubble = false;
    newEvent.event = originalEvent;
    newEvent.type = eveName;
    newEvent.offsetX = originalEvent.offsetX;
    newEvent.offsetY = originalEvent.offsetY;
    while(current){
        current.trigger(eveName, newEvent);
        current = current.getParent();
        if (newEvent.cancelBubble) break;
    }
    this._dispatchToView(eveName, newEvent);
};
$76f930cbbcf58f49$var$LayerGL.prototype._dispatchDataEvent = function(eveName, originalEvent, newEvent) {
    var mesh = newEvent && newEvent.target;
    var dataIndex = mesh && mesh.dataIndex;
    var seriesIndex = mesh && mesh.seriesIndex; // Custom event data
    var eventData = mesh && mesh.eventData;
    var elChangedInMouseMove = false;
    var eventProxy = this._zrEventProxy;
    eventProxy.x = originalEvent.offsetX;
    eventProxy.y = originalEvent.offsetY;
    eventProxy.update();
    var targetInfo = {
        target: eventProxy
    };
    const ecData = $9a616079ee96a3f3$exports.getECData(eventProxy);
    if (eveName === "mousemove") {
        if (dataIndex != null) {
            if (dataIndex !== this._lastDataIndex) {
                if (parseInt(this._lastDataIndex, 10) >= 0) {
                    ecData.dataIndex = this._lastDataIndex;
                    ecData.seriesIndex = this._lastSeriesIndex; // FIXME May cause double events.
                    this.zr.handler.dispatchToElement(targetInfo, "mouseout", originalEvent);
                }
                elChangedInMouseMove = true;
            }
        } else if (eventData != null) {
            if (eventData !== this._lastEventData) {
                if (this._lastEventData != null) {
                    ecData.eventData = this._lastEventData; // FIXME May cause double events.
                    this.zr.handler.dispatchToElement(targetInfo, "mouseout", originalEvent);
                }
                elChangedInMouseMove = true;
            }
        }
        this._lastEventData = eventData;
        this._lastDataIndex = dataIndex;
        this._lastSeriesIndex = seriesIndex;
    }
    ecData.eventData = eventData;
    ecData.dataIndex = dataIndex;
    ecData.seriesIndex = seriesIndex;
    if (eventData != null || parseInt(dataIndex, 10) >= 0 && parseInt(seriesIndex, 10) >= 0) {
        this.zr.handler.dispatchToElement(targetInfo, eveName, originalEvent);
        if (elChangedInMouseMove) this.zr.handler.dispatchToElement(targetInfo, "mouseover", originalEvent);
    }
};
$76f930cbbcf58f49$var$LayerGL.prototype._dispatchToView = function(eventName, e) {
    for(var i = 0; i < this.views.length; i++)if (this.views[i].containPoint(e.offsetX, e.offsetY)) this.views[i].trigger(eventName, e);
};
Object.assign($76f930cbbcf58f49$var$LayerGL.prototype, (0, $1b1a308d68e2d97a$export$2e2bcd8739ae039));
var $76f930cbbcf58f49$export$2e2bcd8739ae039 = $76f930cbbcf58f49$var$LayerGL;



var $cbd16c270813c1c0$var$GL_SERIES = [
    "bar3D",
    "line3D",
    "map3D",
    "scatter3D",
    "surface",
    "lines3D",
    "scatterGL",
    "scatter3D"
];
function $cbd16c270813c1c0$var$convertNormalEmphasis(option, optType) {
    if (option && option[optType] && (option[optType].normal || option[optType].emphasis)) {
        var normalOpt = option[optType].normal;
        var emphasisOpt = option[optType].emphasis;
        if (normalOpt) option[optType] = normalOpt;
        if (emphasisOpt) {
            option.emphasis = option.emphasis || {};
            option.emphasis[optType] = emphasisOpt;
        }
    }
}
function $cbd16c270813c1c0$var$convertNormalEmphasisForEach(option) {
    $cbd16c270813c1c0$var$convertNormalEmphasis(option, "itemStyle");
    $cbd16c270813c1c0$var$convertNormalEmphasis(option, "lineStyle");
    $cbd16c270813c1c0$var$convertNormalEmphasis(option, "areaStyle");
    $cbd16c270813c1c0$var$convertNormalEmphasis(option, "label");
}
function $cbd16c270813c1c0$var$removeTextStyleInAxis(axesOpt) {
    if (!axesOpt) return;
    if (!(axesOpt instanceof Array)) axesOpt = [
        axesOpt
    ];
    $224386f1517b5dca$exports.each(axesOpt, function(axisOpt) {
        if (axisOpt.axisLabel) {
            var labelOpt = axisOpt.axisLabel;
            Object.assign(labelOpt, labelOpt.textStyle);
            labelOpt.textStyle = null;
        }
    });
}
function $cbd16c270813c1c0$export$2e2bcd8739ae039(option) {
    $224386f1517b5dca$exports.each(option.series, function(series) {
        if ($224386f1517b5dca$exports.indexOf($cbd16c270813c1c0$var$GL_SERIES, series.type) >= 0) {
            $cbd16c270813c1c0$var$convertNormalEmphasisForEach(series); // Compatitable with original mapbox
            if (series.coordinateSystem === "mapbox") {
                series.coordinateSystem = "mapbox3D";
                option.mapbox3D = option.mapbox;
            }
        }
    });
    $cbd16c270813c1c0$var$removeTextStyleInAxis(option.xAxis3D);
    $cbd16c270813c1c0$var$removeTextStyleInAxis(option.yAxis3D);
    $cbd16c270813c1c0$var$removeTextStyleInAxis(option.zAxis3D);
    $cbd16c270813c1c0$var$removeTextStyleInAxis(option.grid3D);
    $cbd16c270813c1c0$var$convertNormalEmphasis(option.geo3D);
}


function $341f9f2a96103ae0$var$EChartsGL(zr) {
    this._layers = {};
    this._zr = zr;
}
$341f9f2a96103ae0$var$EChartsGL.prototype.update = function(ecModel, api) {
    var self = this;
    var zr = api.getZr();
    if (!zr.getWidth() || !zr.getHeight()) {
        console.warn("Dom has no width or height");
        return;
    }
    function getLayerGL(model) {
        // Disable auto sleep in gl layer.
        zr.setSleepAfterStill(0);
        var zlevel; // Host on coordinate system.
        if (model.coordinateSystem && model.coordinateSystem.model) zlevel = model.get("zlevel");
        else zlevel = model.get("zlevel");
        var layers = self._layers;
        var layerGL = layers[zlevel];
        if (!layerGL) {
            layerGL = layers[zlevel] = new (0, $76f930cbbcf58f49$export$2e2bcd8739ae039)("gl-" + zlevel, zr);
            if (zr.painter.isSingleCanvas()) {
                layerGL.virtual = true; // If container is canvas, use image to represent LayerGL
                // FIXME Performance
                var img = new $03154d907069e78f$exports.Image({
                    z: 1e4,
                    style: {
                        image: layerGL.renderer.canvas
                    },
                    silent: true
                });
                layerGL.__hostImage = img;
                zr.add(img);
            }
            zr.painter.insertLayer(zlevel, layerGL);
        }
        if (layerGL.__hostImage) layerGL.__hostImage.setStyle({
            width: layerGL.renderer.getWidth(),
            height: layerGL.renderer.getHeight()
        });
        return layerGL;
    }
    function setSilent(groupGL, silent) {
        if (groupGL) groupGL.traverse(function(mesh) {
            if (mesh.isRenderable && mesh.isRenderable()) mesh.ignorePicking = mesh.$ignorePicking != null ? mesh.$ignorePicking : silent;
        });
    }
    for(var zlevel in this._layers)this._layers[zlevel].removeViewsAll();
    ecModel.eachComponent(function(componentType, componentModel) {
        if (componentType !== "series") {
            var view = api.getViewOfComponentModel(componentModel);
            var coordSys = componentModel.coordinateSystem; // View with __ecgl__ flag is a echarts-gl component.
            if (view.__ecgl__) {
                var viewGL;
                if (coordSys) {
                    if (!coordSys.viewGL) {
                        console.error("Can't find viewGL in coordinateSystem of component " + componentModel.id);
                        return;
                    }
                    viewGL = coordSys.viewGL;
                } else {
                    if (!componentModel.viewGL) {
                        console.error("Can't find viewGL of component " + componentModel.id);
                        return;
                    }
                    viewGL = coordSys.viewGL;
                }
                var viewGL = coordSys.viewGL;
                var layerGL = getLayerGL(componentModel);
                layerGL.addView(viewGL);
                view.afterRender && view.afterRender(componentModel, ecModel, api, layerGL);
                setSilent(view.groupGL, componentModel.get("silent"));
            }
        }
    });
    ecModel.eachSeries(function(seriesModel) {
        var chartView = api.getViewOfSeriesModel(seriesModel);
        var coordSys = seriesModel.coordinateSystem;
        if (chartView.__ecgl__) {
            if (coordSys && !coordSys.viewGL && !chartView.viewGL) {
                console.error("Can't find viewGL of series " + chartView.id);
                return;
            }
            var viewGL = coordSys && coordSys.viewGL || chartView.viewGL; // TODO Check zlevel not same with component of coordinate system ?
            var layerGL = getLayerGL(seriesModel);
            layerGL.addView(viewGL);
            chartView.afterRender && chartView.afterRender(seriesModel, ecModel, api, layerGL);
            setSilent(chartView.groupGL, seriesModel.get("silent"));
        }
    });
}; // Hack original getRenderedCanvas. Will removed after new echarts released
// TODO
$4d59907f44a2d0ad$export$c8c249911ee8c1ed(function(chart) {
    var zr = chart.getZr();
    var oldDispose = zr.painter.dispose;
    zr.painter.dispose = function() {
        if (typeof this.eachOtherLayer === "function") this.eachOtherLayer(function(layer) {
            if (layer instanceof (0, $76f930cbbcf58f49$export$2e2bcd8739ae039)) layer.dispose();
        });
        oldDispose.call(this);
    };
    zr.painter.getRenderedCanvas = function(opts) {
        opts = opts || {};
        if (this._singleCanvas) return this._layers[0].dom;
        var canvas = document.createElement("canvas");
        var dpr = opts.pixelRatio || this.dpr;
        canvas.width = this.getWidth() * dpr;
        canvas.height = this.getHeight() * dpr;
        var ctx = canvas.getContext("2d");
        ctx.dpr = dpr;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (opts.backgroundColor) {
            ctx.fillStyle = opts.backgroundColor;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        var displayList = this.storage.getDisplayList(true);
        var scope = {};
        var zlevel;
        var self = this;
        function findAndDrawOtherLayer(smaller, larger) {
            var zlevelList = self._zlevelList;
            if (smaller == null) smaller = -Infinity;
            var intermediateLayer;
            for(var i = 0; i < zlevelList.length; i++){
                var z = zlevelList[i];
                var layer = self._layers[z];
                if (!layer.__builtin__ && z > smaller && z < larger) {
                    intermediateLayer = layer;
                    break;
                }
            }
            if (intermediateLayer && intermediateLayer.renderToCanvas) {
                ctx.save();
                intermediateLayer.renderToCanvas(ctx);
                ctx.restore();
            }
        }
        var layer = {
            ctx: ctx
        };
        for(var i = 0; i < displayList.length; i++){
            var el = displayList[i];
            if (el.zlevel !== zlevel) {
                findAndDrawOtherLayer(zlevel, el.zlevel);
                zlevel = el.zlevel;
            }
            this._doPaintEl(el, layer, true, null, scope);
        }
        findAndDrawOtherLayer(zlevel, Infinity);
        return canvas;
    };
});
$4d59907f44a2d0ad$export$99560909c18c76bb(function(ecModel, api) {
    var zr = api.getZr();
    var egl = zr.__egl = zr.__egl || new $341f9f2a96103ae0$var$EChartsGL(zr);
    egl.update(ecModel, api);
});
$4d59907f44a2d0ad$export$77095792a057b768((0, $cbd16c270813c1c0$export$2e2bcd8739ae039));
var $341f9f2a96103ae0$export$2e2bcd8739ae039 = $341f9f2a96103ae0$var$EChartsGL;



// TODO ECharts GL must be imported whatever component,charts is imported.


var $a589af99ac3423f7$export$2e2bcd8739ae039 = {
    defaultOption: {
        viewControl: {
            // perspective, orthographic.
            // TODO Isometric
            projection: "perspective",
            // If rotate on on init
            autoRotate: false,
            // cw or ccw
            autoRotateDirection: "cw",
            // Degree per second
            autoRotateSpeed: 10,
            // Start rotating after still for a given time
            // default is 3 seconds
            autoRotateAfterStill: 3,
            // Rotate, zoom damping.
            damping: 0.8,
            // Sensitivities for operations.
            // Can be array to set x,y respectively
            rotateSensitivity: 1,
            zoomSensitivity: 1,
            // Can be array to set x,y respectively
            panSensitivity: 1,
            // Which mouse button do rotate or pan
            panMouseButton: "middle",
            rotateMouseButton: "left",
            // Distance to the target
            // Only available when camera is perspective.
            distance: 150,
            // Min distance mouse can zoom in
            minDistance: 40,
            // Max distance mouse can zoom out
            maxDistance: 400,
            // Size of viewing volume.
            // Only available when camera is orthographic
            orthographicSize: 150,
            maxOrthographicSize: 400,
            minOrthographicSize: 20,
            // Center view point
            center: [
                0,
                0,
                0
            ],
            // Alpha angle for top-down rotation
            // Positive to rotate to top.
            alpha: 0,
            // beta angle for left-right rotation
            // Positive to rotate to right.
            beta: 0,
            minAlpha: -90,
            maxAlpha: 90 // minBeta: -Infinity
        }
    },
    setView: function(opts) {
        opts = opts || {};
        this.option.viewControl = this.option.viewControl || {};
        if (opts.alpha != null) this.option.viewControl.alpha = opts.alpha;
        if (opts.beta != null) this.option.viewControl.beta = opts.beta;
        if (opts.distance != null) this.option.viewControl.distance = opts.distance;
        if (opts.center != null) this.option.viewControl.center = opts.center;
    }
};


var $2d5450eeb3d59d52$export$2e2bcd8739ae039 = {
    defaultOption: {
        // Post effect
        postEffect: {
            enable: false,
            bloom: {
                enable: true,
                intensity: 0.1
            },
            depthOfField: {
                enable: false,
                focalRange: 20,
                focalDistance: 50,
                blurRadius: 10,
                fstop: 2.8,
                quality: "medium"
            },
            screenSpaceAmbientOcclusion: {
                enable: false,
                radius: 2,
                // low, medium, high, ultra
                quality: "medium",
                intensity: 1
            },
            screenSpaceReflection: {
                enable: false,
                quality: "medium",
                maxRoughness: 0.8
            },
            colorCorrection: {
                enable: true,
                exposure: 0,
                brightness: 0,
                contrast: 1,
                saturation: 1,
                lookupTexture: ""
            },
            edge: {
                enable: false
            },
            FXAA: {
                enable: false
            }
        },
        // Temporal super sampling when the picture is still.
        temporalSuperSampling: {
            // Only enabled when postEffect is enabled
            enable: "auto"
        }
    }
};


var $39dfcb89b5cc4a69$export$2e2bcd8739ae039 = {
    defaultOption: {
        // Light is available when material.shading is not color
        light: {
            // Main light
            main: {
                shadow: false,
                // low, medium, high, ultra
                shadowQuality: "high",
                color: "#fff",
                intensity: 1,
                alpha: 0,
                beta: 0
            },
            ambient: {
                color: "#fff",
                intensity: 0.2
            },
            ambientCubemap: {
                // Panorama environment texture,
                // Support .hdr and commmon web formats.
                texture: null,
                // Available when texture is hdr.
                exposure: 1,
                // Intensity for diffuse term
                diffuseIntensity: 0.5,
                // Intensity for specular term, only available when shading is realastic
                specularIntensity: 0.5
            }
        }
    }
};


var $eb372d73ae662c91$var$Grid3DModel = $116d65051f61bdfe$export$2e2bcd8739ae039.extend({
    type: "grid3D",
    dependencies: [
        "xAxis3D",
        "yAxis3D",
        "zAxis3D"
    ],
    defaultOption: {
        show: true,
        zlevel: -10,
        // Layout used for viewport
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        environment: "auto",
        // Dimension of grid3D
        boxWidth: 100,
        boxHeight: 100,
        boxDepth: 100,
        // Common axis options.
        axisPointer: {
            show: true,
            lineStyle: {
                color: "rgba(0, 0, 0, 0.8)",
                width: 1
            },
            label: {
                show: true,
                // (dimValue: number, value: Array) => string
                formatter: null,
                // TODO, Consider boxWidth
                margin: 8,
                // backgroundColor: '#ffbd67',
                // borderColor: '#000',
                // borderWidth: 0,
                textStyle: {
                    fontSize: 14,
                    color: "#fff",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    padding: 3,
                    borderRadius: 3
                }
            }
        },
        axisLine: {
            show: true,
            lineStyle: {
                color: "#333",
                width: 2,
                type: "solid"
            }
        },
        axisTick: {
            show: true,
            inside: false,
            length: 3,
            lineStyle: {
                width: 1
            }
        },
        axisLabel: {
            show: true,
            inside: false,
            rotate: 0,
            margin: 8,
            textStyle: {
                fontSize: 12
            }
        },
        splitLine: {
            show: true,
            lineStyle: {
                color: [
                    "#ccc"
                ],
                width: 1,
                type: "solid"
            }
        },
        splitArea: {
            show: false,
            areaStyle: {
                color: [
                    "rgba(250,250,250,0.3)",
                    "rgba(200,200,200,0.3)"
                ]
            }
        },
        // Light options
        light: {
            main: {
                // Alpha angle for top-down rotation
                // Positive to rotate to top.
                alpha: 30,
                // beta angle for left-right rotation
                // Positive to rotate to right.
                beta: 40
            },
            ambient: {
                intensity: 0.4
            }
        },
        viewControl: {
            // Small damping for precise control.
            // damping: 0.1,
            // Alpha angle for top-down rotation
            // Positive to rotate to top.
            alpha: 20,
            // beta angle for left-right rotation
            // Positive to rotate to right.
            beta: 40,
            autoRotate: false,
            // Distance to the surface of grid3D.
            distance: 200,
            // Min distance to the surface of grid3D
            minDistance: 40,
            // Max distance to the surface of grid3D
            maxDistance: 400
        }
    }
});
$224386f1517b5dca$exports.merge($eb372d73ae662c91$var$Grid3DModel.prototype, (0, $a589af99ac3423f7$export$2e2bcd8739ae039));
$224386f1517b5dca$exports.merge($eb372d73ae662c91$var$Grid3DModel.prototype, (0, $2d5450eeb3d59d52$export$2e2bcd8739ae039));
$224386f1517b5dca$exports.merge($eb372d73ae662c91$var$Grid3DModel.prototype, (0, $39dfcb89b5cc4a69$export$2e2bcd8739ae039));
var $eb372d73ae662c91$export$2e2bcd8739ae039 = $eb372d73ae662c91$var$Grid3DModel;


// TODO orthographic camera



/**
 * Provide orbit control for 3D objects
 *
 * @module echarts-gl/util/OrbitControl
 * @author Yi Shen(http://github.com/pissang)
 */ // TODO Remove magic numbers on sensitivity





var $885dfecb57787ce0$var$firstNotNull = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull;
var $885dfecb57787ce0$var$MOUSE_BUTTON_KEY_MAP = {
    left: 0,
    middle: 1,
    right: 2
};
function $885dfecb57787ce0$var$convertToArray(val) {
    if (!(val instanceof Array)) val = [
        val,
        val
    ];
    return val;
}
/**
 * @alias module:echarts-x/util/OrbitControl
 */ var $885dfecb57787ce0$var$OrbitControl = (0, $7c62670c05885275$export$2e2bcd8739ae039).extend(function() {
    return {
        /**
     * @type {module:zrender~ZRender}
     */ zr: null,
        /**
     * @type {module:echarts-gl/core/ViewGL}
     */ viewGL: null,
        /**
     * @type {clay.math.Vector3}
     */ _center: new (0, $27fea36417076c2d$export$2e2bcd8739ae039)(),
        /**
     * Minimum distance to the center
     * Only available when camera is perspective.
     * @type {number}
     * @default 0.5
     */ minDistance: 0.5,
        /**
     * Maximum distance to the center
     * Only available when camera is perspective.
     * @type {number}
     * @default 2
     */ maxDistance: 1.5,
        /**
     * Only available when camera is orthographic
     */ maxOrthographicSize: 300,
        /**
     * Only available when camera is orthographic
     */ minOrthographicSize: 30,
        /**
     * Minimum alpha rotation
     */ minAlpha: -90,
        /**
     * Maximum alpha rotation
     */ maxAlpha: 90,
        /**
     * Minimum beta rotation
     */ minBeta: -Infinity,
        /**
     * Maximum beta rotation
     */ maxBeta: Infinity,
        /**
     * Start auto rotating after still for the given time
     */ autoRotateAfterStill: 0,
        /**
     * Direction of autoRotate. cw or ccw when looking top down.
     */ autoRotateDirection: "cw",
        /**
     * Degree per second
     */ autoRotateSpeed: 60,
        /**
     * @param {number}
     */ damping: 0.8,
        /**
     * @param {number}
     */ rotateSensitivity: 1,
        /**
     * @param {number}
     */ zoomSensitivity: 1,
        /**
     * @param {number}
     */ panSensitivity: 1,
        panMouseButton: "middle",
        rotateMouseButton: "left",
        /**
     * Pan or rotate
     * @private
     * @type {String}
     */ _mode: "rotate",
        /**
     * @private
     * @type {clay.Camera}
     */ _camera: null,
        _needsUpdate: false,
        _rotating: false,
        // Rotation around yAxis in radian
        _phi: 0,
        // Rotation around xAxis in radian
        _theta: 0,
        _mouseX: 0,
        _mouseY: 0,
        _rotateVelocity: new (0, $2cb41795bddfe4d3$export$2e2bcd8739ae039)(),
        _panVelocity: new (0, $2cb41795bddfe4d3$export$2e2bcd8739ae039)(),
        _distance: 500,
        _zoomSpeed: 0,
        _stillTimeout: 0,
        _animators: []
    };
}, function() {
    // Each OrbitControl has it's own handler
    [
        "_mouseDownHandler",
        "_mouseWheelHandler",
        "_mouseMoveHandler",
        "_mouseUpHandler",
        "_pinchHandler",
        "_contextMenuHandler",
        "_update"
    ].forEach(function(hdlName) {
        this[hdlName] = this[hdlName].bind(this);
    }, this);
}, {
    /**
   * Initialize.
   * Mouse event binding
   */ init: function() {
        var zr = this.zr;
        if (zr) {
            zr.on("mousedown", this._mouseDownHandler);
            zr.on("globalout", this._mouseUpHandler);
            zr.on("mousewheel", this._mouseWheelHandler);
            zr.on("pinch", this._pinchHandler);
            zr.animation.on("frame", this._update);
            zr.dom.addEventListener("contextmenu", this._contextMenuHandler);
        }
    },
    /**
   * Dispose.
   * Mouse event unbinding
   */ dispose: function() {
        var zr = this.zr;
        if (zr) {
            zr.off("mousedown", this._mouseDownHandler);
            zr.off("mousemove", this._mouseMoveHandler);
            zr.off("mouseup", this._mouseUpHandler);
            zr.off("mousewheel", this._mouseWheelHandler);
            zr.off("pinch", this._pinchHandler);
            zr.off("globalout", this._mouseUpHandler);
            zr.dom.removeEventListener("contextmenu", this._contextMenuHandler);
            zr.animation.off("frame", this._update);
        }
        this.stopAllAnimation();
    },
    /**
   * Get distance
   * @return {number}
   */ getDistance: function() {
        return this._distance;
    },
    /**
   * Set distance
   * @param {number} distance
   */ setDistance: function(distance) {
        this._distance = distance;
        this._needsUpdate = true;
    },
    /**
   * Get size of orthographic viewing volume
   * @return {number}
   */ getOrthographicSize: function() {
        return this._orthoSize;
    },
    /**
   * Set size of orthographic viewing volume
   * @param {number} size
   */ setOrthographicSize: function(size) {
        this._orthoSize = size;
        this._needsUpdate = true;
    },
    /**
   * Get alpha rotation
   * Alpha angle for top-down rotation. Positive to rotate to top.
   *
   * Which means camera rotation around x axis.
   */ getAlpha: function() {
        return this._theta / Math.PI * 180;
    },
    /**
   * Get beta rotation
   * Beta angle for left-right rotation. Positive to rotate to right.
   *
   * Which means camera rotation around y axis.
   */ getBeta: function() {
        return -this._phi / Math.PI * 180;
    },
    /**
   * Get control center
   * @return {Array.<number>}
   */ getCenter: function() {
        return this._center.toArray();
    },
    /**
   * Set alpha rotation angle
   * @param {number} alpha
   */ setAlpha: function(alpha) {
        alpha = Math.max(Math.min(this.maxAlpha, alpha), this.minAlpha);
        this._theta = alpha / 180 * Math.PI;
        this._needsUpdate = true;
    },
    /**
   * Set beta rotation angle
   * @param {number} beta
   */ setBeta: function(beta) {
        beta = Math.max(Math.min(this.maxBeta, beta), this.minBeta);
        this._phi = -beta / 180 * Math.PI;
        this._needsUpdate = true;
    },
    /**
   * Set control center
   * @param {Array.<number>} center
   */ setCenter: function(centerArr) {
        this._center.setArray(centerArr);
    },
    /**
   * @param {module:echarts-gl/core/ViewGL} viewGL
   */ setViewGL: function(viewGL) {
        this.viewGL = viewGL;
    },
    /**
   * @return {clay.Camera}
   */ getCamera: function() {
        return this.viewGL.camera;
    },
    setFromViewControlModel: function(viewControlModel, extraOpts) {
        extraOpts = extraOpts || {};
        var baseDistance = extraOpts.baseDistance || 0;
        var baseOrthoSize = extraOpts.baseOrthoSize || 1;
        var projection = viewControlModel.get("projection");
        if (projection !== "perspective" && projection !== "orthographic" && projection !== "isometric") projection = "perspective";
        this._projection = projection;
        this.viewGL.setProjection(projection);
        var targetDistance = viewControlModel.get("distance") + baseDistance;
        var targetOrthographicSize = viewControlModel.get("orthographicSize") + baseOrthoSize;
        [
            [
                "damping",
                0.8
            ],
            [
                "autoRotate",
                false
            ],
            [
                "autoRotateAfterStill",
                3
            ],
            [
                "autoRotateDirection",
                "cw"
            ],
            [
                "autoRotateSpeed",
                10
            ],
            [
                "minDistance",
                30
            ],
            [
                "maxDistance",
                400
            ],
            [
                "minOrthographicSize",
                30
            ],
            [
                "maxOrthographicSize",
                300
            ],
            [
                "minAlpha",
                -90
            ],
            [
                "maxAlpha",
                90
            ],
            [
                "minBeta",
                -Infinity
            ],
            [
                "maxBeta",
                Infinity
            ],
            [
                "rotateSensitivity",
                1
            ],
            [
                "zoomSensitivity",
                1
            ],
            [
                "panSensitivity",
                1
            ],
            [
                "panMouseButton",
                "left"
            ],
            [
                "rotateMouseButton",
                "middle"
            ]
        ].forEach(function(prop) {
            this[prop[0]] = $885dfecb57787ce0$var$firstNotNull(viewControlModel.get(prop[0]), prop[1]);
        }, this);
        this.minDistance += baseDistance;
        this.maxDistance += baseDistance;
        this.minOrthographicSize += baseOrthoSize, this.maxOrthographicSize += baseOrthoSize;
        var ecModel = viewControlModel.ecModel;
        var animationOpts = {};
        [
            "animation",
            "animationDurationUpdate",
            "animationEasingUpdate"
        ].forEach(function(key) {
            animationOpts[key] = $885dfecb57787ce0$var$firstNotNull(viewControlModel.get(key), ecModel && ecModel.get(key));
        });
        var alpha = $885dfecb57787ce0$var$firstNotNull(extraOpts.alpha, viewControlModel.get("alpha")) || 0;
        var beta = $885dfecb57787ce0$var$firstNotNull(extraOpts.beta, viewControlModel.get("beta")) || 0;
        var center = $885dfecb57787ce0$var$firstNotNull(extraOpts.center, viewControlModel.get("center")) || [
            0,
            0,
            0
        ];
        if (animationOpts.animation && animationOpts.animationDurationUpdate > 0 && this._notFirst) this.animateTo({
            alpha: alpha,
            beta: beta,
            center: center,
            distance: targetDistance,
            orthographicSize: targetOrthographicSize,
            easing: animationOpts.animationEasingUpdate,
            duration: animationOpts.animationDurationUpdate
        });
        else {
            this.setDistance(targetDistance);
            this.setAlpha(alpha);
            this.setBeta(beta);
            this.setCenter(center);
            this.setOrthographicSize(targetOrthographicSize);
        }
        this._notFirst = true;
        this._validateProperties();
    },
    _validateProperties: function() {},
    /**
   * @param {Object} opts
   * @param {number} opts.distance
   * @param {number} opts.alpha
   * @param {number} opts.beta
   * @param {number} opts.orthographicSize
   * @param {number} [opts.duration=1000]
   * @param {number} [opts.easing='linear']
   */ animateTo: function(opts) {
        var zr = this.zr;
        var self = this;
        var obj = {};
        var target = {};
        if (opts.distance != null) {
            obj.distance = this.getDistance();
            target.distance = opts.distance;
        }
        if (opts.orthographicSize != null) {
            obj.orthographicSize = this.getOrthographicSize();
            target.orthographicSize = opts.orthographicSize;
        }
        if (opts.alpha != null) {
            obj.alpha = this.getAlpha();
            target.alpha = opts.alpha;
        }
        if (opts.beta != null) {
            obj.beta = this.getBeta();
            target.beta = opts.beta;
        }
        if (opts.center != null) {
            obj.center = this.getCenter();
            target.center = opts.center;
        }
        return this._addAnimator(zr.animation.animate(obj).when(opts.duration || 1000, target).during(function() {
            if (obj.alpha != null) self.setAlpha(obj.alpha);
            if (obj.beta != null) self.setBeta(obj.beta);
            if (obj.distance != null) self.setDistance(obj.distance);
            if (obj.center != null) self.setCenter(obj.center);
            if (obj.orthographicSize != null) self.setOrthographicSize(obj.orthographicSize);
            self._needsUpdate = true;
        })).start(opts.easing || "linear");
    },
    /**
   * Stop all animation
   */ stopAllAnimation: function() {
        for(var i = 0; i < this._animators.length; i++)this._animators[i].stop();
        this._animators.length = 0;
    },
    update: function() {
        this._needsUpdate = true;
        this._update(20);
    },
    _isAnimating: function() {
        return this._animators.length > 0;
    },
    /**
   * Call update each frame
   * @param  {number} deltaTime Frame time
   */ _update: function(deltaTime) {
        if (this._rotating) {
            var radian = (this.autoRotateDirection === "cw" ? 1 : -1) * this.autoRotateSpeed / 180 * Math.PI;
            this._phi -= radian * deltaTime / 1000;
            this._needsUpdate = true;
        } else if (this._rotateVelocity.len() > 0) this._needsUpdate = true;
        if (Math.abs(this._zoomSpeed) > 0.1 || this._panVelocity.len() > 0) this._needsUpdate = true;
        if (!this._needsUpdate) return;
        deltaTime = Math.min(deltaTime, 50);
        this._updateDistanceOrSize(deltaTime);
        this._updatePan(deltaTime);
        this._updateRotate(deltaTime);
        this._updateTransform();
        this.getCamera().update();
        this.zr && this.zr.refresh();
        this.trigger("update");
        this._needsUpdate = false;
    },
    _updateRotate: function(deltaTime) {
        var velocity = this._rotateVelocity;
        this._phi = velocity.y * deltaTime / 20 + this._phi;
        this._theta = velocity.x * deltaTime / 20 + this._theta;
        this.setAlpha(this.getAlpha());
        this.setBeta(this.getBeta());
        this._vectorDamping(velocity, Math.pow(this.damping, deltaTime / 16));
    },
    _updateDistanceOrSize: function(deltaTime) {
        if (this._projection === "perspective") this._setDistance(this._distance + this._zoomSpeed * deltaTime / 20);
        else this._setOrthoSize(this._orthoSize + this._zoomSpeed * deltaTime / 20);
        this._zoomSpeed *= Math.pow(this.damping, deltaTime / 16);
    },
    _setDistance: function(distance) {
        this._distance = Math.max(Math.min(distance, this.maxDistance), this.minDistance);
    },
    _setOrthoSize: function(size) {
        this._orthoSize = Math.max(Math.min(size, this.maxOrthographicSize), this.minOrthographicSize);
        var camera = this.getCamera();
        var cameraHeight = this._orthoSize;
        var cameraWidth = cameraHeight / this.viewGL.viewport.height * this.viewGL.viewport.width;
        camera.left = -cameraWidth / 2;
        camera.right = cameraWidth / 2;
        camera.top = cameraHeight / 2;
        camera.bottom = -cameraHeight / 2;
    },
    _updatePan: function(deltaTime) {
        var velocity = this._panVelocity;
        var len = this._distance;
        var target = this.getCamera();
        var yAxis = target.worldTransform.y;
        var xAxis = target.worldTransform.x; // PENDING
        this._center.scaleAndAdd(xAxis, -velocity.x * len / 200).scaleAndAdd(yAxis, -velocity.y * len / 200);
        this._vectorDamping(velocity, 0);
    },
    _updateTransform: function() {
        var camera = this.getCamera();
        var dir = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
        var theta = this._theta + Math.PI / 2;
        var phi = this._phi + Math.PI / 2;
        var r = Math.sin(theta);
        dir.x = r * Math.cos(phi);
        dir.y = -Math.cos(theta);
        dir.z = r * Math.sin(phi);
        camera.position.copy(this._center).scaleAndAdd(dir, this._distance);
        camera.rotation.identity() // First around y, then around x
        .rotateY(-this._phi).rotateX(-this._theta);
    },
    _startCountingStill: function() {
        clearTimeout(this._stillTimeout);
        var time = this.autoRotateAfterStill;
        var self = this;
        if (!isNaN(time) && time > 0) this._stillTimeout = setTimeout(function() {
            self._rotating = true;
        }, time * 1000);
    },
    _vectorDamping: function(v, damping) {
        var speed = v.len();
        speed = speed * damping;
        if (speed < 1e-4) speed = 0;
        v.normalize().scale(speed);
    },
    _decomposeTransform: function() {
        if (!this.getCamera()) return;
        this.getCamera().updateWorldTransform();
        var forward = this.getCamera().worldTransform.z;
        var alpha = Math.asin(forward.y);
        var beta = Math.atan2(forward.x, forward.z);
        this._theta = alpha;
        this._phi = -beta;
        this.setBeta(this.getBeta());
        this.setAlpha(this.getAlpha()); // Is perspective
        if (this.getCamera().aspect) this._setDistance(this.getCamera().position.dist(this._center));
        else this._setOrthoSize(this.getCamera().top - this.getCamera().bottom);
    },
    _mouseDownHandler: function(e) {
        if (e.target) // If mouseon some zrender element.
        return;
        if (this._isAnimating()) return;
        var x = e.offsetX;
        var y = e.offsetY;
        if (this.viewGL && !this.viewGL.containPoint(x, y)) return;
        this.zr.on("mousemove", this._mouseMoveHandler);
        this.zr.on("mouseup", this._mouseUpHandler);
        if (e.event.targetTouches) {
            if (e.event.targetTouches.length === 1) this._mode = "rotate";
        } else {
            if (e.event.button === $885dfecb57787ce0$var$MOUSE_BUTTON_KEY_MAP[this.rotateMouseButton]) this._mode = "rotate";
            else if (e.event.button === $885dfecb57787ce0$var$MOUSE_BUTTON_KEY_MAP[this.panMouseButton]) this._mode = "pan";
            else this._mode = "";
        } // Reset rotate velocity
        this._rotateVelocity.set(0, 0);
        this._rotating = false;
        if (this.autoRotate) this._startCountingStill();
        this._mouseX = e.offsetX;
        this._mouseY = e.offsetY;
    },
    _mouseMoveHandler: function(e) {
        if (e.target && e.target.__isGLToZRProxy) return;
        if (this._isAnimating()) return;
        var panSensitivity = $885dfecb57787ce0$var$convertToArray(this.panSensitivity);
        var rotateSensitivity = $885dfecb57787ce0$var$convertToArray(this.rotateSensitivity);
        if (this._mode === "rotate") {
            this._rotateVelocity.y = (e.offsetX - this._mouseX) / this.zr.getHeight() * 2 * rotateSensitivity[0];
            this._rotateVelocity.x = (e.offsetY - this._mouseY) / this.zr.getWidth() * 2 * rotateSensitivity[1];
        } else if (this._mode === "pan") {
            this._panVelocity.x = (e.offsetX - this._mouseX) / this.zr.getWidth() * panSensitivity[0] * 400;
            this._panVelocity.y = (-e.offsetY + this._mouseY) / this.zr.getHeight() * panSensitivity[1] * 400;
        }
        this._mouseX = e.offsetX;
        this._mouseY = e.offsetY;
        e.event.preventDefault();
    },
    _mouseWheelHandler: function(e) {
        if (this._isAnimating()) return;
        var delta = e.event.wheelDelta // Webkit
         || -e.event.detail; // Firefox
        this._zoomHandler(e, delta);
    },
    _pinchHandler: function(e) {
        if (this._isAnimating()) return;
        this._zoomHandler(e, e.pinchScale > 1 ? 1 : -1); // Not rotate when pinch
        this._mode = "";
    },
    _zoomHandler: function(e, delta) {
        if (delta === 0) return;
        var x = e.offsetX;
        var y = e.offsetY;
        if (this.viewGL && !this.viewGL.containPoint(x, y)) return;
        var speed;
        if (this._projection === "perspective") speed = Math.max(Math.max(Math.min(this._distance - this.minDistance, this.maxDistance - this._distance)) / 20, 0.5);
        else speed = Math.max(Math.max(Math.min(this._orthoSize - this.minOrthographicSize, this.maxOrthographicSize - this._orthoSize)) / 20, 0.5);
        this._zoomSpeed = (delta > 0 ? -1 : 1) * speed * this.zoomSensitivity;
        this._rotating = false;
        if (this.autoRotate && this._mode === "rotate") this._startCountingStill();
        e.event.preventDefault();
    },
    _mouseUpHandler: function() {
        this.zr.off("mousemove", this._mouseMoveHandler);
        this.zr.off("mouseup", this._mouseUpHandler);
    },
    _isRightMouseButtonUsed: function() {
        return this.rotateMouseButton === "right" || this.panMouseButton === "right";
    },
    _contextMenuHandler: function(e) {
        if (this._isRightMouseButtonUsed()) e.preventDefault();
    },
    _addAnimator: function(animator) {
        var animators = this._animators;
        animators.push(animator);
        animator.done(function() {
            var idx = animators.indexOf(animator);
            if (idx >= 0) animators.splice(idx, 1);
        });
        return animator;
    }
});
/**
 * If auto rotate the target
 * @type {boolean}
 * @default false
 */ Object.defineProperty($885dfecb57787ce0$var$OrbitControl.prototype, "autoRotate", {
    get: function(val) {
        return this._autoRotate;
    },
    set: function(val) {
        this._autoRotate = val;
        this._rotating = val;
    }
});
var $885dfecb57787ce0$export$2e2bcd8739ae039 = $885dfecb57787ce0$var$OrbitControl;


/**
 * Lines geometry
 * Use screen space projected lines lineWidth > MAX_LINE_WIDTH
 * https://mattdesl.svbtle.com/drawing-lines-is-hard
 * @module echarts-gl/util/geometry/LinesGeometry
 * @author Yi Shen(http://github.com/pissang)
 */ 

var $5c3dce311da2ccea$export$2e2bcd8739ae039 = {
    convertToDynamicArray: function(clear) {
        if (clear) this.resetOffset();
        var attributes = this.attributes;
        for(var name in attributes)if (clear || !attributes[name].value) attributes[name].value = [];
        else attributes[name].value = Array.prototype.slice.call(attributes[name].value);
        if (clear || !this.indices) this.indices = [];
        else this.indices = Array.prototype.slice.call(this.indices);
    },
    convertToTypedArray: function() {
        var attributes = this.attributes;
        for(var name in attributes)if (attributes[name].value && attributes[name].value.length > 0) attributes[name].value = new Float32Array(attributes[name].value);
        else attributes[name].value = null;
        if (this.indices && this.indices.length > 0) this.indices = this.vertexCount > 0xffff ? new Uint32Array(this.indices) : new Uint16Array(this.indices);
        this.dirty();
    }
};


// DEPRECATED
/**
 * @fileoverview gl-matrix - High performance matrix and vector operations
 * @author Brandon Jones
 * @author Colin MacKenzie IV
 * @version 2.2.2
 */ /* Copyright (c) 2013, Brandon Jones, Colin MacKenzie IV. All rights reserved.

Redistribution and use in source and binary forms, with or without modification,
are permitted provided that the following conditions are met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.
  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. */ 







var $136b5ad81b3c8c50$export$2e2bcd8739ae039 = {
    vec2: (0, $acfd5e2b3b8997d6$export$2e2bcd8739ae039),
    vec3: (0, $12f7c5f576a58dba$export$2e2bcd8739ae039),
    vec4: (0, $8f04521abcf907ba$export$2e2bcd8739ae039),
    mat2: (0, $fc9d47975d112676$export$2e2bcd8739ae039),
    mat2d: (0, $45303a524a267824$export$2e2bcd8739ae039),
    mat3: (0, $b86a7eb89e4e1c74$export$2e2bcd8739ae039),
    mat4: (0, $0020ce97b75275ae$export$2e2bcd8739ae039),
    quat: (0, $62f7d9dfb936b2d3$export$2e2bcd8739ae039)
};


var $8308920d9a0ddf49$export$2e2bcd8739ae039 = (0, $136b5ad81b3c8c50$export$2e2bcd8739ae039);


var $8c084a5220a66e92$var$vec3 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).vec3; // var CURVE_RECURSION_LIMIT = 8;
// var CURVE_COLLINEAR_EPSILON = 40;
var $8c084a5220a66e92$var$sampleLinePoints = [
    [
        0,
        0
    ],
    [
        1,
        1
    ]
];
/**
 * @constructor
 * @alias module:echarts-gl/util/geometry/LinesGeometry
 * @extends clay.Geometry
 */ var $8c084a5220a66e92$var$LinesGeometry = (0, $c75c69a759bf7591$export$2e2bcd8739ae039).extend(function() {
    return {
        segmentScale: 1,
        dynamic: true,
        /**
     * Need to use mesh to expand lines if lineWidth > MAX_LINE_WIDTH
     */ useNativeLine: true,
        attributes: {
            position: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("position", "float", 3, "POSITION"),
            positionPrev: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("positionPrev", "float", 3),
            positionNext: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("positionNext", "float", 3),
            prevPositionPrev: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("prevPositionPrev", "float", 3),
            prevPosition: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("prevPosition", "float", 3),
            prevPositionNext: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("prevPositionNext", "float", 3),
            offset: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("offset", "float", 1),
            color: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("color", "float", 4, "COLOR")
        }
    };
}, /** @lends module: echarts-gl/util/geometry/LinesGeometry.prototype */ {
    /**
   * Reset offset
   */ resetOffset: function() {
        this._vertexOffset = 0;
        this._triangleOffset = 0;
        this._itemVertexOffsets = [];
    },
    /**
   * @param {number} nVertex
   */ setVertexCount: function(nVertex) {
        var attributes = this.attributes;
        if (this.vertexCount !== nVertex) {
            attributes.position.init(nVertex);
            attributes.color.init(nVertex);
            if (!this.useNativeLine) {
                attributes.positionPrev.init(nVertex);
                attributes.positionNext.init(nVertex);
                attributes.offset.init(nVertex);
            }
            if (nVertex > 0xffff) {
                if (this.indices instanceof Uint16Array) this.indices = new Uint32Array(this.indices);
            } else if (this.indices instanceof Uint32Array) this.indices = new Uint16Array(this.indices);
        }
    },
    /**
   * @param {number} nTriangle
   */ setTriangleCount: function(nTriangle) {
        if (this.triangleCount !== nTriangle) {
            if (nTriangle === 0) this.indices = null;
            else this.indices = this.vertexCount > 0xffff ? new Uint32Array(nTriangle * 3) : new Uint16Array(nTriangle * 3);
        }
    },
    _getCubicCurveApproxStep: function(p0, p1, p2, p3) {
        var len = $8c084a5220a66e92$var$vec3.dist(p0, p1) + $8c084a5220a66e92$var$vec3.dist(p2, p1) + $8c084a5220a66e92$var$vec3.dist(p3, p2);
        var step = 1 / (len + 1) * this.segmentScale;
        return step;
    },
    /**
   * Get vertex count of cubic curve
   * @param {Array.<number>} p0
   * @param {Array.<number>} p1
   * @param {Array.<number>} p2
   * @param {Array.<number>} p3
   * @return number
   */ getCubicCurveVertexCount: function(p0, p1, p2, p3) {
        var step = this._getCubicCurveApproxStep(p0, p1, p2, p3);
        var segCount = Math.ceil(1 / step);
        if (!this.useNativeLine) return segCount * 2 + 2;
        else return segCount * 2;
    },
    /**
   * Get face count of cubic curve
   * @param {Array.<number>} p0
   * @param {Array.<number>} p1
   * @param {Array.<number>} p2
   * @param {Array.<number>} p3
   * @return number
   */ getCubicCurveTriangleCount: function(p0, p1, p2, p3) {
        var step = this._getCubicCurveApproxStep(p0, p1, p2, p3);
        var segCount = Math.ceil(1 / step);
        if (!this.useNativeLine) return segCount * 2;
        else return 0;
    },
    /**
   * Get vertex count of line
   * @return {number}
   */ getLineVertexCount: function() {
        return this.getPolylineVertexCount($8c084a5220a66e92$var$sampleLinePoints);
    },
    /**
   * Get face count of line
   * @return {number}
   */ getLineTriangleCount: function() {
        return this.getPolylineTriangleCount($8c084a5220a66e92$var$sampleLinePoints);
    },
    /**
   * Get how many vertices will polyline take.
   * @type {number|Array} points Can be a 1d/2d list of points, or a number of points amount.
   * @return {number}
   */ getPolylineVertexCount: function(points) {
        var pointsLen;
        if (typeof points === "number") pointsLen = points;
        else {
            var is2DArray = typeof points[0] !== "number";
            pointsLen = is2DArray ? points.length : points.length / 3;
        }
        return !this.useNativeLine ? (pointsLen - 1) * 2 + 2 : (pointsLen - 1) * 2;
    },
    /**
   * Get how many triangles will polyline take.
   * @type {number|Array} points Can be a 1d/2d list of points, or a number of points amount.
   * @return {number}
   */ getPolylineTriangleCount: function(points) {
        var pointsLen;
        if (typeof points === "number") pointsLen = points;
        else {
            var is2DArray = typeof points[0] !== "number";
            pointsLen = is2DArray ? points.length : points.length / 3;
        }
        return !this.useNativeLine ? Math.max(pointsLen - 1, 0) * 2 : 0;
    },
    /**
   * Add a cubic curve
   * @param {Array.<number>} p0
   * @param {Array.<number>} p1
   * @param {Array.<number>} p2
   * @param {Array.<number>} p3
   * @param {Array.<number>} color
   * @param {number} [lineWidth=1]
   */ addCubicCurve: function(p0, p1, p2, p3, color, lineWidth) {
        if (lineWidth == null) lineWidth = 1;
         // incremental interpolation
        // http://antigrain.com/research/bezier_interpolation/index.html#PAGE_BEZIER_INTERPOLATION
        var x0 = p0[0], y0 = p0[1], z0 = p0[2];
        var x1 = p1[0], y1 = p1[1], z1 = p1[2];
        var x2 = p2[0], y2 = p2[1], z2 = p2[2];
        var x3 = p3[0], y3 = p3[1], z3 = p3[2];
        var step = this._getCubicCurveApproxStep(p0, p1, p2, p3);
        var step2 = step * step;
        var step3 = step2 * step;
        var pre1 = 3.0 * step;
        var pre2 = 3.0 * step2;
        var pre4 = 6.0 * step2;
        var pre5 = 6.0 * step3;
        var tmp1x = x0 - x1 * 2.0 + x2;
        var tmp1y = y0 - y1 * 2.0 + y2;
        var tmp1z = z0 - z1 * 2.0 + z2;
        var tmp2x = (x1 - x2) * 3.0 - x0 + x3;
        var tmp2y = (y1 - y2) * 3.0 - y0 + y3;
        var tmp2z = (z1 - z2) * 3.0 - z0 + z3;
        var fx = x0;
        var fy = y0;
        var fz = z0;
        var dfx = (x1 - x0) * pre1 + tmp1x * pre2 + tmp2x * step3;
        var dfy = (y1 - y0) * pre1 + tmp1y * pre2 + tmp2y * step3;
        var dfz = (z1 - z0) * pre1 + tmp1z * pre2 + tmp2z * step3;
        var ddfx = tmp1x * pre4 + tmp2x * pre5;
        var ddfy = tmp1y * pre4 + tmp2y * pre5;
        var ddfz = tmp1z * pre4 + tmp2z * pre5;
        var dddfx = tmp2x * pre5;
        var dddfy = tmp2y * pre5;
        var dddfz = tmp2z * pre5;
        var t = 0;
        var k = 0;
        var segCount = Math.ceil(1 / step);
        var points = new Float32Array((segCount + 1) * 3);
        var points = [];
        var offset = 0;
        for(var k = 0; k < segCount + 1; k++){
            points[offset++] = fx;
            points[offset++] = fy;
            points[offset++] = fz;
            fx += dfx;
            fy += dfy;
            fz += dfz;
            dfx += ddfx;
            dfy += ddfy;
            dfz += ddfz;
            ddfx += dddfx;
            ddfy += dddfy;
            ddfz += dddfz;
            t += step;
            if (t > 1) {
                fx = dfx > 0 ? Math.min(fx, x3) : Math.max(fx, x3);
                fy = dfy > 0 ? Math.min(fy, y3) : Math.max(fy, y3);
                fz = dfz > 0 ? Math.min(fz, z3) : Math.max(fz, z3);
            }
        }
        return this.addPolyline(points, color, lineWidth);
    },
    /**
   * Add a straight line
   * @param {Array.<number>} p0
   * @param {Array.<number>} p1
   * @param {Array.<number>} color
   * @param {number} [lineWidth=1]
   */ addLine: function(p0, p1, color, lineWidth) {
        return this.addPolyline([
            p0,
            p1
        ], color, lineWidth);
    },
    /**
   * Add a straight line
   * @param {Array.<Array> | Array.<number>} points
   * @param {Array.<number> | Array.<Array>} color
   * @param {number} [lineWidth=1]
   * @param {number} [startOffset=0]
   * @param {number} [pointsCount] Default to be amount of points in the first argument
   */ addPolyline: function(points, color, lineWidth, startOffset, pointsCount) {
        if (!points.length) return;
        var is2DArray = typeof points[0] !== "number";
        if (pointsCount == null) pointsCount = is2DArray ? points.length : points.length / 3;
        if (pointsCount < 2) return;
        if (startOffset == null) startOffset = 0;
        if (lineWidth == null) lineWidth = 1;
        this._itemVertexOffsets.push(this._vertexOffset);
        var is2DArray = typeof points[0] !== "number";
        var notSharingColor = is2DArray ? typeof color[0] !== "number" : color.length / 4 === pointsCount;
        var positionAttr = this.attributes.position;
        var positionPrevAttr = this.attributes.positionPrev;
        var positionNextAttr = this.attributes.positionNext;
        var colorAttr = this.attributes.color;
        var offsetAttr = this.attributes.offset;
        var indices = this.indices;
        var vertexOffset = this._vertexOffset;
        var point;
        var pointColor;
        lineWidth = Math.max(lineWidth, 0.01);
        for(var k = startOffset; k < pointsCount; k++){
            if (is2DArray) {
                point = points[k];
                if (notSharingColor) pointColor = color[k];
                else pointColor = color;
            } else {
                var k3 = k * 3;
                point = point || [];
                point[0] = points[k3];
                point[1] = points[k3 + 1];
                point[2] = points[k3 + 2];
                if (notSharingColor) {
                    var k4 = k * 4;
                    pointColor = pointColor || [];
                    pointColor[0] = color[k4];
                    pointColor[1] = color[k4 + 1];
                    pointColor[2] = color[k4 + 2];
                    pointColor[3] = color[k4 + 3];
                } else pointColor = color;
            }
            if (!this.useNativeLine) {
                if (k < pointsCount - 1) {
                    // Set to next two points
                    positionPrevAttr.set(vertexOffset + 2, point);
                    positionPrevAttr.set(vertexOffset + 3, point);
                }
                if (k > 0) {
                    // Set to previous two points
                    positionNextAttr.set(vertexOffset - 2, point);
                    positionNextAttr.set(vertexOffset - 1, point);
                }
                positionAttr.set(vertexOffset, point);
                positionAttr.set(vertexOffset + 1, point);
                colorAttr.set(vertexOffset, pointColor);
                colorAttr.set(vertexOffset + 1, pointColor);
                offsetAttr.set(vertexOffset, lineWidth / 2);
                offsetAttr.set(vertexOffset + 1, -lineWidth / 2);
                vertexOffset += 2;
            } else if (k > 1) {
                positionAttr.copy(vertexOffset, vertexOffset - 1);
                colorAttr.copy(vertexOffset, vertexOffset - 1);
                vertexOffset++;
            }
            if (!this.useNativeLine) {
                if (k > 0) {
                    var idx3 = this._triangleOffset * 3;
                    var indices = this.indices; // 0-----2
                    // 1-----3
                    // 0->1->2, 1->3->2
                    indices[idx3] = vertexOffset - 4;
                    indices[idx3 + 1] = vertexOffset - 3;
                    indices[idx3 + 2] = vertexOffset - 2;
                    indices[idx3 + 3] = vertexOffset - 3;
                    indices[idx3 + 4] = vertexOffset - 1;
                    indices[idx3 + 5] = vertexOffset - 2;
                    this._triangleOffset += 2;
                }
            } else {
                colorAttr.set(vertexOffset, pointColor);
                positionAttr.set(vertexOffset, point);
                vertexOffset++;
            }
        }
        if (!this.useNativeLine) {
            var start = this._vertexOffset;
            var end = this._vertexOffset + pointsCount * 2;
            positionPrevAttr.copy(start, start + 2);
            positionPrevAttr.copy(start + 1, start + 3);
            positionNextAttr.copy(end - 1, end - 3);
            positionNextAttr.copy(end - 2, end - 4);
        }
        this._vertexOffset = vertexOffset;
        return this._vertexOffset;
    },
    /**
   * Set color of single line.
   */ setItemColor: function(idx, color) {
        var startOffset = this._itemVertexOffsets[idx];
        var endOffset = idx < this._itemVertexOffsets.length - 1 ? this._itemVertexOffsets[idx + 1] : this._vertexOffset;
        for(var i = startOffset; i < endOffset; i++)this.attributes.color.set(i, color);
        this.dirty("color");
    },
    /**
   * @return {number}
   */ currentTriangleOffset: function() {
        return this._triangleOffset;
    },
    /**
   * @return {number}
   */ currentVertexOffset: function() {
        return this._vertexOffset;
    }
});
$224386f1517b5dca$exports.defaults($8c084a5220a66e92$var$LinesGeometry.prototype, (0, $5c3dce311da2ccea$export$2e2bcd8739ae039));
var $8c084a5220a66e92$export$2e2bcd8739ae039 = $8c084a5220a66e92$var$LinesGeometry;



/**
 * Texture Atlas for the sprites.
 * It uses zrender for 2d element management and rendering
 * @module echarts-gl/util/ZRTextureAtlasSurface
 */ // TODO Expand.


function $022f245366cabf55$var$ZRTextureAtlasSurfaceNode(zr, offsetX, offsetY, width, height, gap, dpr) {
    this._zr = zr;
    /**
   * Current cursor x
   * @type {number}
   * @private
   */ this._x = 0;
    /**
   * Current cursor y
   * @type {number}
   */ this._y = 0;
    this._rowHeight = 0;
    /**
   * width without dpr.
   * @type {number}
   * @private
   */ this.width = width;
    /**
   * height without dpr.
   * @type {number}
   * @private
   */ this.height = height;
    /**
   * offsetX without dpr
   * @type {number}
   */ this.offsetX = offsetX;
    /**
   * offsetY without dpr
   * @type {number}
   */ this.offsetY = offsetY;
    this.dpr = dpr;
    this.gap = gap;
}
$022f245366cabf55$var$ZRTextureAtlasSurfaceNode.prototype = {
    constructor: $022f245366cabf55$var$ZRTextureAtlasSurfaceNode,
    clear: function() {
        this._x = 0;
        this._y = 0;
        this._rowHeight = 0;
    },
    /**
   * Add shape to atlas
   * @param {module:zrender/graphic/Displayable} shape
   * @param {number} width
   * @param {number} height
   * @return {Array}
   */ add: function(el, width, height) {
        // FIXME Text element not consider textAlign and textVerticalAlign.
        // TODO, inner text, shadow
        var rect = el.getBoundingRect(); // FIXME aspect ratio
        if (width == null) width = rect.width;
        if (height == null) height = rect.height;
        width *= this.dpr;
        height *= this.dpr;
        this._fitElement(el, width, height); // var aspect = el.scale[1] / el.scale[0];
        // Adjust aspect ratio to make the text more clearly
        // FIXME If height > width, width is useless ?
        // width = height * aspect;
        // el.position[0] *= aspect;
        // el.scale[0] = el.scale[1];
        var x = this._x;
        var y = this._y;
        var canvasWidth = this.width * this.dpr;
        var canvasHeight = this.height * this.dpr;
        var gap = this.gap;
        if (x + width + gap > canvasWidth) {
            // Change a new row
            x = this._x = 0;
            y += this._rowHeight + gap;
            this._y = y; // Reset row height
            this._rowHeight = 0;
        }
        this._x += width + gap;
        this._rowHeight = Math.max(this._rowHeight, height);
        if (y + height + gap > canvasHeight) // There is no space anymore
        return null;
         // Shift the el
        el.x += this.offsetX * this.dpr + x;
        el.y += this.offsetY * this.dpr + y;
        this._zr.add(el);
        var coordsOffset = [
            this.offsetX / this.width,
            this.offsetY / this.height
        ];
        var coords = [
            [
                x / canvasWidth + coordsOffset[0],
                y / canvasHeight + coordsOffset[1]
            ],
            [
                (x + width) / canvasWidth + coordsOffset[0],
                (y + height) / canvasHeight + coordsOffset[1]
            ]
        ];
        return coords;
    },
    /**
   * Fit element size by correct its position and scaling
   * @param {module:zrender/graphic/Displayable} el
   * @param {number} spriteWidth
   * @param {number} spriteHeight
   */ _fitElement: function(el, spriteWidth, spriteHeight) {
        // TODO, inner text, shadow
        var rect = el.getBoundingRect();
        var scaleX = spriteWidth / rect.width;
        var scaleY = spriteHeight / rect.height;
        el.x = -rect.x * scaleX;
        el.y = -rect.y * scaleY;
        el.scaleX = scaleX;
        el.scaleY = scaleY;
        el.update();
    }
};
/**
 * constructor
 * @alias module:echarts-gl/util/ZRTextureAtlasSurface
 * @param {number} opt.width
 * @param {number} opt.height
 * @param {number} opt.devicePixelRatio
 * @param {number} opt.gap Gap for safe.
 * @param {Function} opt.onupdate
 */ function $022f245366cabf55$var$ZRTextureAtlasSurface(opt) {
    opt = opt || {};
    opt.width = opt.width || 512;
    opt.height = opt.height || 512;
    opt.devicePixelRatio = opt.devicePixelRatio || 1;
    opt.gap = opt.gap == null ? 2 : opt.gap;
    var canvas = document.createElement("canvas");
    canvas.width = opt.width * opt.devicePixelRatio;
    canvas.height = opt.height * opt.devicePixelRatio;
    this._canvas = canvas;
    this._texture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        image: canvas,
        flipY: false
    });
    var self = this;
    /**
   * zrender instance in the Chart
   * @type {zrender~ZRender}
   */ this._zr = $6eba88f9eebe6af9$exports.init(canvas);
    var oldRefreshImmediately = this._zr.refreshImmediately;
    this._zr.refreshImmediately = function() {
        oldRefreshImmediately.call(this);
        self._texture.dirty();
        self.onupdate && self.onupdate();
    };
    this._dpr = opt.devicePixelRatio;
    /**
   * Texture coords map for each sprite image
   * @type {Object}
   */ this._coords = {};
    this.onupdate = opt.onupdate;
    this._gap = opt.gap; // Left sub atlas.
    this._textureAtlasNodes = [
        new $022f245366cabf55$var$ZRTextureAtlasSurfaceNode(this._zr, 0, 0, opt.width, opt.height, this._gap, this._dpr)
    ];
    this._nodeWidth = opt.width;
    this._nodeHeight = opt.height;
    this._currentNodeIdx = 0;
}
$022f245366cabf55$var$ZRTextureAtlasSurface.prototype = {
    /**
   * Clear the texture atlas
   */ clear: function() {
        for(var i = 0; i < this._textureAtlasNodes.length; i++)this._textureAtlasNodes[i].clear();
        this._currentNodeIdx = 0;
        this._zr.clear();
        this._coords = {};
    },
    /**
   * @return {number}
   */ getWidth: function() {
        return this._width;
    },
    /**
   * @return {number}
   */ getHeight: function() {
        return this._height;
    },
    /**
   * @return {number}
   */ getTexture: function() {
        return this._texture;
    },
    /**
   * @return {number}
   */ getDevicePixelRatio: function() {
        return this._dpr;
    },
    getZr: function() {
        return this._zr;
    },
    _getCurrentNode: function() {
        return this._textureAtlasNodes[this._currentNodeIdx];
    },
    _expand: function() {
        this._currentNodeIdx++;
        if (this._textureAtlasNodes[this._currentNodeIdx]) // Use the node created previously.
        return this._textureAtlasNodes[this._currentNodeIdx];
        var maxSize = 4096 / this._dpr;
        var textureAtlasNodes = this._textureAtlasNodes;
        var nodeLen = textureAtlasNodes.length;
        var offsetX = nodeLen * this._nodeWidth % maxSize;
        var offsetY = Math.floor(nodeLen * this._nodeWidth / maxSize) * this._nodeHeight;
        if (offsetY >= maxSize) return;
        var width = (offsetX + this._nodeWidth) * this._dpr;
        var height = (offsetY + this._nodeHeight) * this._dpr;
        try {
            // Resize will error in node.
            this._zr.resize({
                width: width,
                height: height
            });
        } catch (e) {
            this._canvas.width = width;
            this._canvas.height = height;
        }
        var newNode = new $022f245366cabf55$var$ZRTextureAtlasSurfaceNode(this._zr, offsetX, offsetY, this._nodeWidth, this._nodeHeight, this._gap, this._dpr);
        this._textureAtlasNodes.push(newNode);
        return newNode;
    },
    add: function(el, width, height) {
        if (this._coords[el.id]) return this._coords[el.id];
        var coords = this._getCurrentNode().add(el, width, height);
        if (!coords) {
            var newNode = this._expand();
            if (!newNode) // To maximum
            return;
            coords = newNode.add(el, width, height);
        }
        this._coords[el.id] = coords;
        return coords;
    },
    /**
   * Get coord scale after texture atlas is expanded.
   * @return {Array.<number>}
   */ getCoordsScale: function() {
        var dpr = this._dpr;
        return [
            this._nodeWidth / this._canvas.width * dpr,
            this._nodeHeight / this._canvas.height * dpr
        ];
    },
    /**
   * Get texture coords of sprite image
   * @param  {string} id Image id
   * @return {Array}
   */ getCoords: function(id) {
        return this._coords[id];
    },
    dispose: function() {
        this._zr.dispose();
    }
};
var $022f245366cabf55$export$2e2bcd8739ae039 = $022f245366cabf55$var$ZRTextureAtlasSurface;





function $ace7021e37e6bf94$var$SceneHelper() {}
$ace7021e37e6bf94$var$SceneHelper.prototype = {
    constructor: $ace7021e37e6bf94$var$SceneHelper,
    setScene: function(scene) {
        this._scene = scene;
        if (this._skybox) this._skybox.attachScene(this._scene);
    },
    initLight: function(rootNode) {
        this._lightRoot = rootNode;
        /**
     * @type {clay.light.Directional}
     */ this.mainLight = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).DirectionalLight({
            shadowBias: 0.005
        });
        /**
     * @type {clay.light.Ambient}
     */ this.ambientLight = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).AmbientLight();
        rootNode.add(this.mainLight);
        rootNode.add(this.ambientLight);
    },
    dispose: function() {
        if (this._lightRoot) {
            this._lightRoot.remove(this.mainLight);
            this._lightRoot.remove(this.ambientLight);
        }
    },
    updateLight: function(componentModel) {
        var mainLight = this.mainLight;
        var ambientLight = this.ambientLight;
        var lightModel = componentModel.getModel("light");
        var mainLightModel = lightModel.getModel("main");
        var ambientLightModel = lightModel.getModel("ambient");
        mainLight.intensity = mainLightModel.get("intensity");
        ambientLight.intensity = ambientLightModel.get("intensity");
        mainLight.color = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(mainLightModel.get("color")).slice(0, 3);
        ambientLight.color = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(ambientLightModel.get("color")).slice(0, 3);
        var alpha = mainLightModel.get("alpha") || 0;
        var beta = mainLightModel.get("beta") || 0;
        mainLight.position.setArray((0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).directionFromAlphaBeta(alpha, beta));
        mainLight.lookAt((0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Vector3.ZERO);
        mainLight.castShadow = mainLightModel.get("shadow");
        mainLight.shadowResolution = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).getShadowResolution(mainLightModel.get("shadowQuality"));
    },
    updateAmbientCubemap: function(renderer, componentModel, api) {
        var ambientCubemapModel = componentModel.getModel("light.ambientCubemap");
        var textureUrl = ambientCubemapModel.get("texture");
        if (textureUrl) {
            this._cubemapLightsCache = this._cubemapLightsCache || {};
            var lights = this._cubemapLightsCache[textureUrl];
            if (!lights) {
                var self = this;
                lights = this._cubemapLightsCache[textureUrl] = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createAmbientCubemap(ambientCubemapModel.option, renderer, api, function() {
                    // Use prefitered cubemap
                    if (self._isSkyboxFromAmbientCubemap) self._skybox.setEnvironmentMap(lights.specular.cubemap);
                    api.getZr().refresh();
                });
            }
            this._lightRoot.add(lights.diffuse);
            this._lightRoot.add(lights.specular);
            this._currentCubemapLights = lights;
        } else if (this._currentCubemapLights) {
            this._lightRoot.remove(this._currentCubemapLights.diffuse);
            this._lightRoot.remove(this._currentCubemapLights.specular);
            this._currentCubemapLights = null;
        }
    },
    updateSkybox: function(renderer, componentModel, api) {
        var environmentUrl = componentModel.get("environment");
        var self = this;
        function getSkybox() {
            self._skybox = self._skybox || new (0, $8118711ff583fe51$export$2e2bcd8739ae039)();
            return self._skybox;
        }
        var skybox = getSkybox();
        if (environmentUrl && environmentUrl !== "none") {
            if (environmentUrl === "auto") {
                this._isSkyboxFromAmbientCubemap = true; // Use environment in ambient cubemap
                if (this._currentCubemapLights) {
                    var cubemap = this._currentCubemapLights.specular.cubemap;
                    skybox.setEnvironmentMap(cubemap);
                    if (this._scene) skybox.attachScene(this._scene);
                    skybox.material.set("lod", 3);
                } else if (this._skybox) this._skybox.detachScene();
            } else if (typeof environmentUrl === "object" && environmentUrl.colorStops || typeof environmentUrl === "string" && $2c037f5bda6341ca$exports.parse(environmentUrl)) {
                this._isSkyboxFromAmbientCubemap = false;
                var texture = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Texture2D({
                    anisotropic: 8,
                    flipY: false
                });
                skybox.setEnvironmentMap(texture);
                var canvas = texture.image = document.createElement("canvas");
                canvas.width = canvas.height = 16;
                var ctx = canvas.getContext("2d");
                var rect = new $03154d907069e78f$exports.Rect({
                    shape: {
                        x: 0,
                        y: 0,
                        width: 16,
                        height: 16
                    },
                    style: {
                        fill: environmentUrl
                    }
                });
                $4f71e35e4552e3dd$export$567881adfc3eb7f3(ctx, rect);
                skybox.attachScene(this._scene);
            } else {
                this._isSkyboxFromAmbientCubemap = false; // Panorama
                var texture = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).loadTexture(environmentUrl, api, {
                    anisotropic: 8,
                    flipY: false
                });
                skybox.setEnvironmentMap(texture);
                skybox.attachScene(this._scene);
            }
        } else {
            if (this._skybox) this._skybox.detachScene(this._scene);
            this._skybox = null;
        }
        var coordSys = componentModel.coordinateSystem;
        if (this._skybox) {
            if (coordSys && coordSys.viewGL && environmentUrl !== "auto" && !(environmentUrl.match && environmentUrl.match(/.hdr$/))) {
                var srgbDefineMethod = coordSys.viewGL.isLinearSpace() ? "define" : "undefine";
                this._skybox.material[srgbDefineMethod]("fragment", "SRGB_DECODE");
            } else this._skybox.material.undefine("fragment", "SRGB_DECODE");
             // var ambientCubemapUrl = environmentUrl === 'auto'
        }
    }
};
var $ace7021e37e6bf94$export$2e2bcd8739ae039 = $ace7021e37e6bf94$var$SceneHelper;






/**
 * @module echarts-gl/util/geometry/QuadsGeometry
 * @author Yi Shen(http://github.com/pissang)
 */ 



var $100f3427679aadb7$var$vec3 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).vec3;
/**
 * @constructor
 * @alias module:echarts-gl/util/geometry/QuadsGeometry
 * @extends clay.Geometry
 */ var $100f3427679aadb7$var$QuadsGeometry = (0, $c75c69a759bf7591$export$2e2bcd8739ae039).extend(function() {
    return {
        segmentScale: 1,
        /**
     * Need to use mesh to expand lines if lineWidth > MAX_LINE_WIDTH
     */ useNativeLine: true,
        attributes: {
            position: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("position", "float", 3, "POSITION"),
            normal: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("normal", "float", 3, "NORMAL"),
            color: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("color", "float", 4, "COLOR")
        }
    };
}, /** @lends module: echarts-gl/util/geometry/QuadsGeometry.prototype */ {
    /**
   * Reset offset
   */ resetOffset: function() {
        this._vertexOffset = 0;
        this._faceOffset = 0;
    },
    /**
   * @param {number} nQuad
   */ setQuadCount: function(nQuad) {
        var attributes = this.attributes;
        var vertexCount = this.getQuadVertexCount() * nQuad;
        var triangleCount = this.getQuadTriangleCount() * nQuad;
        if (this.vertexCount !== vertexCount) {
            attributes.position.init(vertexCount);
            attributes.normal.init(vertexCount);
            attributes.color.init(vertexCount);
        }
        if (this.triangleCount !== triangleCount) this.indices = vertexCount > 0xffff ? new Uint32Array(triangleCount * 3) : new Uint16Array(triangleCount * 3);
    },
    getQuadVertexCount: function() {
        return 4;
    },
    getQuadTriangleCount: function() {
        return 2;
    },
    /**
   * Add a quad, which in following order:
   * 0-----1
   * 3-----2
   */ addQuad: function() {
        var a = $100f3427679aadb7$var$vec3.create();
        var b = $100f3427679aadb7$var$vec3.create();
        var normal = $100f3427679aadb7$var$vec3.create();
        var indices = [
            0,
            3,
            1,
            3,
            2,
            1
        ];
        return function(coords, color) {
            var positionAttr = this.attributes.position;
            var normalAttr = this.attributes.normal;
            var colorAttr = this.attributes.color;
            $100f3427679aadb7$var$vec3.sub(a, coords[1], coords[0]);
            $100f3427679aadb7$var$vec3.sub(b, coords[2], coords[1]);
            $100f3427679aadb7$var$vec3.cross(normal, a, b);
            $100f3427679aadb7$var$vec3.normalize(normal, normal);
            for(var i = 0; i < 4; i++){
                positionAttr.set(this._vertexOffset + i, coords[i]);
                colorAttr.set(this._vertexOffset + i, color);
                normalAttr.set(this._vertexOffset + i, normal);
            }
            var idx = this._faceOffset * 3;
            for(var i = 0; i < 6; i++)this.indices[idx + i] = indices[i] + this._vertexOffset;
            this._vertexOffset += 4;
            this._faceOffset += 2;
        };
    }()
});
$224386f1517b5dca$exports.defaults($100f3427679aadb7$var$QuadsGeometry.prototype, (0, $5c3dce311da2ccea$export$2e2bcd8739ae039));
var $100f3427679aadb7$export$2e2bcd8739ae039 = $100f3427679aadb7$var$QuadsGeometry;


var $ddcdb4477b56b5dd$var$firstNotNull = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull;
var $ddcdb4477b56b5dd$var$dimIndicesMap = {
    // Left to right
    x: 0,
    // Far to near
    y: 2,
    // Bottom to up
    z: 1
};
function $ddcdb4477b56b5dd$var$updateFacePlane(node, plane, otherAxis, dir) {
    var coord = [
        0,
        0,
        0
    ];
    var distance = dir < 0 ? otherAxis.getExtentMin() : otherAxis.getExtentMax();
    coord[$ddcdb4477b56b5dd$var$dimIndicesMap[otherAxis.dim]] = distance;
    node.position.setArray(coord);
    node.rotation.identity(); // Negative distance because on the opposite of normal direction.
    plane.distance = -Math.abs(distance);
    plane.normal.set(0, 0, 0);
    if (otherAxis.dim === "x") {
        node.rotation.rotateY(dir * Math.PI / 2);
        plane.normal.x = -dir;
    } else if (otherAxis.dim === "z") {
        node.rotation.rotateX(-dir * Math.PI / 2);
        plane.normal.y = -dir;
    } else {
        if (dir > 0) node.rotation.rotateY(Math.PI);
        plane.normal.z = -dir;
    }
}
function $ddcdb4477b56b5dd$var$Grid3DFace(faceInfo, linesMaterial, quadsMaterial) {
    this.rootNode = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
    var linesMesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
        geometry: new (0, $8c084a5220a66e92$export$2e2bcd8739ae039)({
            useNativeLine: false
        }),
        material: linesMaterial,
        castShadow: false,
        ignorePicking: true,
        $ignorePicking: true,
        renderOrder: 1
    });
    var quadsMesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
        geometry: new (0, $100f3427679aadb7$export$2e2bcd8739ae039)(),
        material: quadsMaterial,
        castShadow: false,
        culling: false,
        ignorePicking: true,
        $ignorePicking: true,
        renderOrder: 0
    }); // Quads are behind lines.
    this.rootNode.add(quadsMesh);
    this.rootNode.add(linesMesh);
    this.faceInfo = faceInfo;
    this.plane = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Plane();
    this.linesMesh = linesMesh;
    this.quadsMesh = quadsMesh;
}
$ddcdb4477b56b5dd$var$Grid3DFace.prototype.update = function(grid3DModel, ecModel, api) {
    var cartesian = grid3DModel.coordinateSystem;
    var axes = [
        cartesian.getAxis(this.faceInfo[0]),
        cartesian.getAxis(this.faceInfo[1])
    ];
    var lineGeometry = this.linesMesh.geometry;
    var quadsGeometry = this.quadsMesh.geometry;
    lineGeometry.convertToDynamicArray(true);
    quadsGeometry.convertToDynamicArray(true);
    this._updateSplitLines(lineGeometry, axes, grid3DModel, api);
    this._udpateSplitAreas(quadsGeometry, axes, grid3DModel, api);
    lineGeometry.convertToTypedArray();
    quadsGeometry.convertToTypedArray();
    var otherAxis = cartesian.getAxis(this.faceInfo[2]);
    $ddcdb4477b56b5dd$var$updateFacePlane(this.rootNode, this.plane, otherAxis, this.faceInfo[3]);
};
$ddcdb4477b56b5dd$var$Grid3DFace.prototype._updateSplitLines = function(geometry, axes, grid3DModel, api) {
    var dpr = api.getDevicePixelRatio();
    axes.forEach(function(axis, idx) {
        var axisModel = axis.model;
        var otherExtent = axes[1 - idx].getExtent();
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel("splitLine", grid3DModel.getModel("splitLine")); // Render splitLines
        if (splitLineModel.get("show")) {
            var lineStyleModel = splitLineModel.getModel("lineStyle");
            var lineColors = lineStyleModel.get("color");
            var opacity = $ddcdb4477b56b5dd$var$firstNotNull(lineStyleModel.get("opacity"), 1.0);
            var lineWidth = $ddcdb4477b56b5dd$var$firstNotNull(lineStyleModel.get("width"), 1.0);
            lineColors = $224386f1517b5dca$exports.isArray(lineColors) ? lineColors : [
                lineColors
            ];
            var ticksCoords = axis.getTicksCoords({
                tickModel: splitLineModel
            });
            var count = 0;
            for(var i = 0; i < ticksCoords.length; i++){
                var tickCoord = ticksCoords[i].coord;
                var lineColor = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(lineColors[count % lineColors.length]);
                lineColor[3] *= opacity;
                var p0 = [
                    0,
                    0,
                    0
                ];
                var p1 = [
                    0,
                    0,
                    0
                ]; // 0 - x, 1 - y
                p0[idx] = p1[idx] = tickCoord;
                p0[1 - idx] = otherExtent[0];
                p1[1 - idx] = otherExtent[1];
                geometry.addLine(p0, p1, lineColor, lineWidth * dpr);
                count++;
            }
        }
    });
};
$ddcdb4477b56b5dd$var$Grid3DFace.prototype._udpateSplitAreas = function(geometry, axes, grid3DModel, api) {
    axes.forEach(function(axis, idx) {
        var axisModel = axis.model;
        var otherExtent = axes[1 - idx].getExtent();
        if (axis.scale.isBlank()) return;
        var splitAreaModel = axisModel.getModel("splitArea", grid3DModel.getModel("splitArea")); // Render splitAreas
        if (splitAreaModel.get("show")) {
            var areaStyleModel = splitAreaModel.getModel("areaStyle");
            var colors = areaStyleModel.get("color");
            var opacity = $ddcdb4477b56b5dd$var$firstNotNull(areaStyleModel.get("opacity"), 1.0);
            colors = $224386f1517b5dca$exports.isArray(colors) ? colors : [
                colors
            ];
            var ticksCoords = axis.getTicksCoords({
                tickModel: splitAreaModel,
                clamp: true
            });
            var count = 0;
            var prevP0 = [
                0,
                0,
                0
            ];
            var prevP1 = [
                0,
                0,
                0
            ]; // 0 - x, 1 - y
            for(var i = 0; i < ticksCoords.length; i++){
                var tickCoord = ticksCoords[i].coord;
                var p0 = [
                    0,
                    0,
                    0
                ];
                var p1 = [
                    0,
                    0,
                    0
                ]; // 0 - x, 1 - y
                p0[idx] = p1[idx] = tickCoord;
                p0[1 - idx] = otherExtent[0];
                p1[1 - idx] = otherExtent[1];
                if (i === 0) {
                    prevP0 = p0;
                    prevP1 = p1;
                    continue;
                }
                var color = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(colors[count % colors.length]);
                color[3] *= opacity;
                geometry.addQuad([
                    prevP0,
                    p0,
                    p1,
                    prevP1
                ], color);
                prevP0 = p0;
                prevP1 = p1;
                count++;
            }
        }
    });
};
var $ddcdb4477b56b5dd$export$2e2bcd8739ae039 = $ddcdb4477b56b5dd$var$Grid3DFace;








/**
 * Geometry collecting sprites
 *
 * @module echarts-gl/util/geometry/Sprites
 * @author Yi Shen(https://github.com/pissang)
 */ 


var $a8f9eacec73a9f12$var$squareTriangles = [
    0,
    1,
    2,
    0,
    2,
    3
];
var $a8f9eacec73a9f12$var$SpritesGeometry = (0, $c75c69a759bf7591$export$2e2bcd8739ae039).extend(function() {
    return {
        attributes: {
            position: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("position", "float", 3, "POSITION"),
            texcoord: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("texcoord", "float", 2, "TEXCOORD_0"),
            offset: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("offset", "float", 2),
            color: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("color", "float", 4, "COLOR")
        }
    };
}, {
    resetOffset: function() {
        this._vertexOffset = 0;
        this._faceOffset = 0;
    },
    setSpriteCount: function(spriteCount) {
        this._spriteCount = spriteCount;
        var vertexCount = spriteCount * 4;
        var triangleCount = spriteCount * 2;
        if (this.vertexCount !== vertexCount) {
            this.attributes.position.init(vertexCount);
            this.attributes.offset.init(vertexCount);
            this.attributes.color.init(vertexCount);
        }
        if (this.triangleCount !== triangleCount) this.indices = vertexCount > 0xffff ? new Uint32Array(triangleCount * 3) : new Uint16Array(triangleCount * 3);
    },
    setSpriteAlign: function(spriteOffset, size, align, verticalAlign, margin) {
        if (align == null) align = "left";
        if (verticalAlign == null) verticalAlign = "top";
        var leftOffset, topOffset, rightOffset, bottomOffset;
        margin = margin || 0;
        switch(align){
            case "left":
                leftOffset = margin;
                rightOffset = size[0] + margin;
                break;
            case "center":
            case "middle":
                leftOffset = -size[0] / 2;
                rightOffset = size[0] / 2;
                break;
            case "right":
                leftOffset = -size[0] - margin;
                rightOffset = -margin;
                break;
        }
        switch(verticalAlign){
            case "bottom":
                topOffset = margin;
                bottomOffset = size[1] + margin;
                break;
            case "middle":
                topOffset = -size[1] / 2;
                bottomOffset = size[1] / 2;
                break;
            case "top":
                topOffset = -size[1] - margin;
                bottomOffset = -margin;
                break;
        } // 3----2
        // 0----1
        var vertexOffset = spriteOffset * 4;
        var offsetAttr = this.attributes.offset;
        offsetAttr.set(vertexOffset, [
            leftOffset,
            bottomOffset
        ]);
        offsetAttr.set(vertexOffset + 1, [
            rightOffset,
            bottomOffset
        ]);
        offsetAttr.set(vertexOffset + 2, [
            rightOffset,
            topOffset
        ]);
        offsetAttr.set(vertexOffset + 3, [
            leftOffset,
            topOffset
        ]);
    },
    /**
   * Add sprite
   * @param {Array.<number>} position
   * @param {Array.<number>} size [width, height]
   * @param {Array.<Array>} coords [leftBottom, rightTop]
   * @param {string} [align='left'] 'left' 'center' 'right'
   * @param {string} [verticalAlign='top'] 'top' 'middle' 'bottom'
   * @param {number} [screenMargin=0]
   */ addSprite: function(position, size, coords, align, verticalAlign, screenMargin) {
        var vertexOffset = this._vertexOffset;
        this.setSprite(this._vertexOffset / 4, position, size, coords, align, verticalAlign, screenMargin);
        for(var i = 0; i < $a8f9eacec73a9f12$var$squareTriangles.length; i++)this.indices[this._faceOffset * 3 + i] = $a8f9eacec73a9f12$var$squareTriangles[i] + vertexOffset;
        this._faceOffset += 2;
        this._vertexOffset += 4;
        return vertexOffset / 4;
    },
    setSprite: function(spriteOffset, position, size, coords, align, verticalAlign, screenMargin) {
        var vertexOffset = spriteOffset * 4;
        var attributes = this.attributes;
        for(var i = 0; i < 4; i++)attributes.position.set(vertexOffset + i, position);
         // 3----2
        // 0----1
        var texcoordAttr = attributes.texcoord;
        texcoordAttr.set(vertexOffset, [
            coords[0][0],
            coords[0][1]
        ]);
        texcoordAttr.set(vertexOffset + 1, [
            coords[1][0],
            coords[0][1]
        ]);
        texcoordAttr.set(vertexOffset + 2, [
            coords[1][0],
            coords[1][1]
        ]);
        texcoordAttr.set(vertexOffset + 3, [
            coords[0][0],
            coords[1][1]
        ]);
        this.setSpriteAlign(spriteOffset, size, align, verticalAlign, screenMargin);
    }
});
$224386f1517b5dca$exports.defaults($a8f9eacec73a9f12$var$SpritesGeometry.prototype, (0, $5c3dce311da2ccea$export$2e2bcd8739ae039));
var $a8f9eacec73a9f12$export$2e2bcd8739ae039 = $a8f9eacec73a9f12$var$SpritesGeometry;


var $fa81079e4d2dac88$export$2e2bcd8739ae039 = "@export ecgl.labels.vertex\n\nattribute vec3 position: POSITION;\nattribute vec2 texcoord: TEXCOORD_0;\nattribute vec2 offset;\n#ifdef VERTEX_COLOR\nattribute vec4 a_Color : COLOR;\nvarying vec4 v_Color;\n#endif\n\nuniform mat4 worldViewProjection : WORLDVIEWPROJECTION;\nuniform vec4 viewport : VIEWPORT;\n\nvarying vec2 v_Texcoord;\n\nvoid main()\n{\n vec4 proj = worldViewProjection * vec4(position, 1.0);\n\n vec2 screen = (proj.xy / abs(proj.w) + 1.0) * 0.5 * viewport.zw;\n\n screen += offset;\n\n proj.xy = (screen / viewport.zw - 0.5) * 2.0 * abs(proj.w);\n gl_Position = proj;\n#ifdef VERTEX_COLOR\n v_Color = a_Color;\n#endif\n v_Texcoord = texcoord;\n}\n@end\n\n\n@export ecgl.labels.fragment\n\nuniform vec3 color : [1.0, 1.0, 1.0];\nuniform float alpha : 1.0;\nuniform sampler2D textureAtlas;\nuniform vec2 uvScale: [1.0, 1.0];\n\n#ifdef VERTEX_COLOR\nvarying vec4 v_Color;\n#endif\nvarying float v_Miter;\n\nvarying vec2 v_Texcoord;\n\nvoid main()\n{\n gl_FragColor = vec4(color, alpha) * texture2D(textureAtlas, v_Texcoord * uvScale);\n#ifdef VERTEX_COLOR\n gl_FragColor *= v_Color;\n#endif\n}\n\n@end";


(0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.import((0, $fa81079e4d2dac88$export$2e2bcd8739ae039));
var $b164bb04725a6275$export$2e2bcd8739ae039 = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh.extend(function() {
    var geometry = new (0, $a8f9eacec73a9f12$export$2e2bcd8739ae039)({
        dynamic: true
    });
    var material = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
        shader: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createShader("ecgl.labels"),
        transparent: true,
        depthMask: false
    });
    return {
        geometry: geometry,
        material: material,
        culling: false,
        castShadow: false,
        ignorePicking: true
    };
});


var $fece85addf0c496c$var$firstNotNull = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull;
var $fece85addf0c496c$var$dimIndicesMap = {
    // Left to right
    x: 0,
    // Far to near
    y: 2,
    // Bottom to up
    z: 1
};
function $fece85addf0c496c$var$Grid3DAxis(dim, linesMaterial) {
    var linesMesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
        geometry: new (0, $8c084a5220a66e92$export$2e2bcd8739ae039)({
            useNativeLine: false
        }),
        material: linesMaterial,
        castShadow: false,
        ignorePicking: true,
        renderOrder: 2
    });
    var axisLabelsMesh = new (0, $b164bb04725a6275$export$2e2bcd8739ae039)();
    axisLabelsMesh.material.depthMask = false;
    var rootNode = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
    rootNode.add(linesMesh);
    rootNode.add(axisLabelsMesh);
    this.rootNode = rootNode;
    this.dim = dim;
    this.linesMesh = linesMesh;
    this.labelsMesh = axisLabelsMesh;
    this.axisLineCoords = null;
    this.labelElements = [];
}
var $fece85addf0c496c$var$otherDim = {
    x: "y",
    y: "x",
    z: "y"
};
$fece85addf0c496c$var$Grid3DAxis.prototype.update = function(grid3DModel, axisLabelSurface, api) {
    var cartesian = grid3DModel.coordinateSystem;
    var axis = cartesian.getAxis(this.dim);
    var linesGeo = this.linesMesh.geometry;
    var labelsGeo = this.labelsMesh.geometry;
    linesGeo.convertToDynamicArray(true);
    labelsGeo.convertToDynamicArray(true);
    var axisModel = axis.model;
    var extent = axis.getExtent();
    var dpr = api.getDevicePixelRatio();
    var axisLineModel = axisModel.getModel("axisLine", grid3DModel.getModel("axisLine"));
    var axisTickModel = axisModel.getModel("axisTick", grid3DModel.getModel("axisTick"));
    var axisLabelModel = axisModel.getModel("axisLabel", grid3DModel.getModel("axisLabel"));
    var axisLineColor = axisLineModel.get("lineStyle.color"); // Render axisLine
    if (axisLineModel.get("show")) {
        var axisLineStyleModel = axisLineModel.getModel("lineStyle");
        var p0 = [
            0,
            0,
            0
        ];
        var p1 = [
            0,
            0,
            0
        ];
        var idx = $fece85addf0c496c$var$dimIndicesMap[axis.dim];
        p0[idx] = extent[0];
        p1[idx] = extent[1]; // Save some useful info.
        this.axisLineCoords = [
            p0,
            p1
        ];
        var color = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(axisLineColor);
        var lineWidth = $fece85addf0c496c$var$firstNotNull(axisLineStyleModel.get("width"), 1.0);
        var opacity = $fece85addf0c496c$var$firstNotNull(axisLineStyleModel.get("opacity"), 1.0);
        color[3] *= opacity;
        linesGeo.addLine(p0, p1, color, lineWidth * dpr);
    } // Render axis ticksCoords
    if (axisTickModel.get("show")) {
        var lineStyleModel = axisTickModel.getModel("lineStyle");
        var lineColor = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor($fece85addf0c496c$var$firstNotNull(lineStyleModel.get("color"), axisLineColor));
        var lineWidth = $fece85addf0c496c$var$firstNotNull(lineStyleModel.get("width"), 1.0);
        lineColor[3] *= $fece85addf0c496c$var$firstNotNull(lineStyleModel.get("opacity"), 1.0);
        var ticksCoords = axis.getTicksCoords();
        var tickLength = axisTickModel.get("length");
        for(var i = 0; i < ticksCoords.length; i++){
            var tickCoord = ticksCoords[i].coord;
            var p0 = [
                0,
                0,
                0
            ];
            var p1 = [
                0,
                0,
                0
            ];
            var idx = $fece85addf0c496c$var$dimIndicesMap[axis.dim];
            var otherIdx = $fece85addf0c496c$var$dimIndicesMap[$fece85addf0c496c$var$otherDim[axis.dim]]; // 0 : x, 1 : y
            p0[idx] = p1[idx] = tickCoord;
            p1[otherIdx] = tickLength;
            linesGeo.addLine(p0, p1, lineColor, lineWidth * dpr);
        }
    }
    this.labelElements = [];
    var dpr = api.getDevicePixelRatio();
    if (axisLabelModel.get("show")) {
        var ticksCoords = axis.getTicksCoords();
        var categoryData = axisModel.get("data");
        var labelMargin = axisLabelModel.get("margin");
        var labels = axis.getViewLabels();
        for(var i = 0; i < labels.length; i++){
            var tickValue = labels[i].tickValue;
            var formattedLabel = labels[i].formattedLabel;
            var rawLabel = labels[i].rawLabel;
            var tickCoord = axis.dataToCoord(tickValue);
            var p = [
                0,
                0,
                0
            ];
            var idx = $fece85addf0c496c$var$dimIndicesMap[axis.dim];
            var otherIdx = $fece85addf0c496c$var$dimIndicesMap[$fece85addf0c496c$var$otherDim[axis.dim]]; // 0 : x, 1 : y
            p[idx] = p[idx] = tickCoord;
            p[otherIdx] = labelMargin;
            var itemTextStyleModel = axisLabelModel;
            if (categoryData && categoryData[tickValue] && categoryData[tickValue].textStyle) itemTextStyleModel = new $6818646a97528290$export$2e2bcd8739ae039(categoryData[tickValue].textStyle, axisLabelModel, axisModel.ecModel);
            var textColor = $fece85addf0c496c$var$firstNotNull(itemTextStyleModel.get("color"), axisLineColor);
            var textEl = new $03154d907069e78f$exports.Text({
                style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(itemTextStyleModel, {
                    text: formattedLabel,
                    fill: typeof textColor === "function" ? textColor(// index of axis.data. So tick should not be exposed to user
                    // in category axis.
                    // (2) Compatible with previous version, which always returns labelStr.
                    // But in interval scale labelStr is like '223,445', which maked
                    // user repalce ','. So we modify it to return original val but remain
                    // it as 'string' to avoid error in replacing.
                    axis.type === "category" ? rawLabel : axis.type === "value" ? tickValue + "" : tickValue, i) : textColor,
                    verticalAlign: "top",
                    align: "left"
                })
            });
            var coords = axisLabelSurface.add(textEl);
            var rect = textEl.getBoundingRect();
            labelsGeo.addSprite(p, [
                rect.width * dpr,
                rect.height * dpr
            ], coords);
            this.labelElements.push(textEl);
        }
    }
    if (axisModel.get("name")) {
        var nameTextStyleModel = axisModel.getModel("nameTextStyle");
        var p = [
            0,
            0,
            0
        ];
        var idx = $fece85addf0c496c$var$dimIndicesMap[axis.dim];
        var otherIdx = $fece85addf0c496c$var$dimIndicesMap[$fece85addf0c496c$var$otherDim[axis.dim]];
        var labelColor = $fece85addf0c496c$var$firstNotNull(nameTextStyleModel.get("color"), axisLineColor);
        var strokeColor = nameTextStyleModel.get("borderColor");
        var lineWidth = nameTextStyleModel.get("borderWidth"); // TODO start and end
        p[idx] = p[idx] = (extent[0] + extent[1]) / 2;
        p[otherIdx] = axisModel.get("nameGap");
        var textEl = new $03154d907069e78f$exports.Text({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(nameTextStyleModel, {
                text: axisModel.get("name"),
                fill: labelColor,
                stroke: strokeColor,
                lineWidth: lineWidth
            })
        });
        var coords = axisLabelSurface.add(textEl);
        var rect = textEl.getBoundingRect();
        labelsGeo.addSprite(p, [
            rect.width * dpr,
            rect.height * dpr
        ], coords);
        textEl.__idx = this.labelElements.length;
        this.nameLabelElement = textEl;
    }
    this.labelsMesh.material.set("textureAtlas", axisLabelSurface.getTexture());
    this.labelsMesh.material.set("uvScale", axisLabelSurface.getCoordsScale());
    linesGeo.convertToTypedArray();
    labelsGeo.convertToTypedArray();
};
$fece85addf0c496c$var$Grid3DAxis.prototype.setSpriteAlign = function(textAlign, textVerticalAlign, api) {
    var dpr = api.getDevicePixelRatio();
    var labelGeo = this.labelsMesh.geometry;
    for(var i = 0; i < this.labelElements.length; i++){
        var labelEl = this.labelElements[i];
        var rect = labelEl.getBoundingRect();
        labelGeo.setSpriteAlign(i, [
            rect.width * dpr,
            rect.height * dpr
        ], textAlign, textVerticalAlign);
    } // name label
    var nameLabelEl = this.nameLabelElement;
    if (nameLabelEl) {
        var rect = nameLabelEl.getBoundingRect();
        labelGeo.setSpriteAlign(nameLabelEl.__idx, [
            rect.width * dpr,
            rect.height * dpr
        ], textAlign, textVerticalAlign);
        labelGeo.dirty();
    }
    this.textAlign = textAlign;
    this.textVerticalAlign = textVerticalAlign;
};
var $fece85addf0c496c$export$2e2bcd8739ae039 = $fece85addf0c496c$var$Grid3DAxis;



var $ceca9d93a3d35604$export$2e2bcd8739ae039 = "@export ecgl.lines3D.vertex\n\nuniform mat4 worldViewProjection : WORLDVIEWPROJECTION;\n\nattribute vec3 position: POSITION;\nattribute vec4 a_Color : COLOR;\nvarying vec4 v_Color;\n\nvoid main()\n{\n gl_Position = worldViewProjection * vec4(position, 1.0);\n v_Color = a_Color;\n}\n\n@end\n\n@export ecgl.lines3D.fragment\n\nuniform vec4 color : [1.0, 1.0, 1.0, 1.0];\n\nvarying vec4 v_Color;\n\n@import clay.util.srgb\n\nvoid main()\n{\n#ifdef SRGB_DECODE\n gl_FragColor = sRGBToLinear(color * v_Color);\n#else\n gl_FragColor = color * v_Color;\n#endif\n}\n@end\n\n\n\n@export ecgl.lines3D.clipNear\n\nvec4 clipNear(vec4 p1, vec4 p2) {\n float n = (p1.w - near) / (p1.w - p2.w);\n return vec4(mix(p1.xy, p2.xy, n), -near, near);\n}\n\n@end\n\n@export ecgl.lines3D.expandLine\n#ifdef VERTEX_ANIMATION\n vec4 prevProj = worldViewProjection * vec4(mix(prevPositionPrev, positionPrev, percent), 1.0);\n vec4 currProj = worldViewProjection * vec4(mix(prevPosition, position, percent), 1.0);\n vec4 nextProj = worldViewProjection * vec4(mix(prevPositionNext, positionNext, percent), 1.0);\n#else\n vec4 prevProj = worldViewProjection * vec4(positionPrev, 1.0);\n vec4 currProj = worldViewProjection * vec4(position, 1.0);\n vec4 nextProj = worldViewProjection * vec4(positionNext, 1.0);\n#endif\n\n if (currProj.w < 0.0) {\n if (nextProj.w > 0.0) {\n currProj = clipNear(currProj, nextProj);\n }\n else if (prevProj.w > 0.0) {\n currProj = clipNear(currProj, prevProj);\n }\n }\n\n vec2 prevScreen = (prevProj.xy / abs(prevProj.w) + 1.0) * 0.5 * viewport.zw;\n vec2 currScreen = (currProj.xy / abs(currProj.w) + 1.0) * 0.5 * viewport.zw;\n vec2 nextScreen = (nextProj.xy / abs(nextProj.w) + 1.0) * 0.5 * viewport.zw;\n\n vec2 dir;\n float len = offset;\n if (position == positionPrev) {\n dir = normalize(nextScreen - currScreen);\n }\n else if (position == positionNext) {\n dir = normalize(currScreen - prevScreen);\n }\n else {\n vec2 dirA = normalize(currScreen - prevScreen);\n vec2 dirB = normalize(nextScreen - currScreen);\n\n vec2 tanget = normalize(dirA + dirB);\n\n float miter = 1.0 / max(dot(tanget, dirA), 0.5);\n len *= miter;\n dir = tanget;\n }\n\n dir = vec2(-dir.y, dir.x) * len;\n currScreen += dir;\n\n currProj.xy = (currScreen / viewport.zw - 0.5) * 2.0 * abs(currProj.w);\n@end\n\n\n@export ecgl.meshLines3D.vertex\n\nattribute vec3 position: POSITION;\nattribute vec3 positionPrev;\nattribute vec3 positionNext;\nattribute float offset;\nattribute vec4 a_Color : COLOR;\n\n#ifdef VERTEX_ANIMATION\nattribute vec3 prevPosition;\nattribute vec3 prevPositionPrev;\nattribute vec3 prevPositionNext;\nuniform float percent : 1.0;\n#endif\n\nuniform mat4 worldViewProjection : WORLDVIEWPROJECTION;\nuniform vec4 viewport : VIEWPORT;\nuniform float near : NEAR;\n\nvarying vec4 v_Color;\n\n@import ecgl.common.wireframe.vertexHeader\n\n@import ecgl.lines3D.clipNear\n\nvoid main()\n{\n @import ecgl.lines3D.expandLine\n\n gl_Position = currProj;\n\n v_Color = a_Color;\n\n @import ecgl.common.wireframe.vertexMain\n}\n@end\n\n\n@export ecgl.meshLines3D.fragment\n\nuniform vec4 color : [1.0, 1.0, 1.0, 1.0];\n\nvarying vec4 v_Color;\n\n@import ecgl.common.wireframe.fragmentHeader\n\n@import clay.util.srgb\n\nvoid main()\n{\n#ifdef SRGB_DECODE\n gl_FragColor = sRGBToLinear(color * v_Color);\n#else\n gl_FragColor = color * v_Color;\n#endif\n\n @import ecgl.common.wireframe.fragmentMain\n}\n\n@end";


var $130ac2c379dce8a3$var$firstNotNull = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull;
(0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.import((0, $ceca9d93a3d35604$export$2e2bcd8739ae039));
var $130ac2c379dce8a3$var$dimIndicesMap = {
    // Left to right
    x: 0,
    // Far to near
    y: 2,
    // Bottom to up
    z: 1
};
var $130ac2c379dce8a3$export$2e2bcd8739ae039 = $737c88aa0711f65a$export$2e2bcd8739ae039.extend({
    type: "grid3D",
    __ecgl__: true,
    init: function(ecModel, api) {
        var FACES = [
            [
                "y",
                "z",
                "x",
                -1,
                "left"
            ],
            [
                "y",
                "z",
                "x",
                1,
                "right"
            ],
            [
                "x",
                "y",
                "z",
                -1,
                "bottom"
            ],
            [
                "x",
                "y",
                "z",
                1,
                "top"
            ],
            [
                "x",
                "z",
                "y",
                -1,
                "far"
            ],
            [
                "x",
                "z",
                "y",
                1,
                "near"
            ]
        ];
        var DIMS = [
            "x",
            "y",
            "z"
        ];
        var quadsMaterial = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
            // transparent: true,
            shader: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createShader("ecgl.color"),
            depthMask: false,
            transparent: true
        });
        var linesMaterial = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
            // transparent: true,
            shader: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createShader("ecgl.meshLines3D"),
            depthMask: false,
            transparent: true
        });
        quadsMaterial.define("fragment", "DOUBLE_SIDED");
        quadsMaterial.define("both", "VERTEX_COLOR");
        this.groupGL = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
        this._control = new (0, $885dfecb57787ce0$export$2e2bcd8739ae039)({
            zr: api.getZr()
        });
        this._control.init(); // Save mesh and other infos for each face.
        this._faces = FACES.map(function(faceInfo) {
            var face = new (0, $ddcdb4477b56b5dd$export$2e2bcd8739ae039)(faceInfo, linesMaterial, quadsMaterial);
            this.groupGL.add(face.rootNode);
            return face;
        }, this); // Save mesh and other infos for each axis.
        this._axes = DIMS.map(function(dim) {
            var axis = new (0, $fece85addf0c496c$export$2e2bcd8739ae039)(dim, linesMaterial);
            this.groupGL.add(axis.rootNode);
            return axis;
        }, this);
        var dpr = api.getDevicePixelRatio(); // Texture surface for label.
        this._axisLabelSurface = new (0, $022f245366cabf55$export$2e2bcd8739ae039)({
            width: 256,
            height: 256,
            devicePixelRatio: dpr
        });
        this._axisLabelSurface.onupdate = function() {
            api.getZr().refresh();
        };
        this._axisPointerLineMesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
            geometry: new (0, $8c084a5220a66e92$export$2e2bcd8739ae039)({
                useNativeLine: false
            }),
            material: linesMaterial,
            castShadow: false,
            // PENDING
            ignorePicking: true,
            renderOrder: 3
        });
        this.groupGL.add(this._axisPointerLineMesh);
        this._axisPointerLabelsSurface = new (0, $022f245366cabf55$export$2e2bcd8739ae039)({
            width: 128,
            height: 128,
            devicePixelRatio: dpr
        });
        this._axisPointerLabelsMesh = new (0, $b164bb04725a6275$export$2e2bcd8739ae039)({
            ignorePicking: true,
            renderOrder: 4,
            castShadow: false
        });
        this._axisPointerLabelsMesh.material.set("textureAtlas", this._axisPointerLabelsSurface.getTexture());
        this.groupGL.add(this._axisPointerLabelsMesh);
        this._lightRoot = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
        this._sceneHelper = new (0, $ace7021e37e6bf94$export$2e2bcd8739ae039)();
        this._sceneHelper.initLight(this._lightRoot);
    },
    render: function(grid3DModel, ecModel, api) {
        this._model = grid3DModel;
        this._api = api;
        var cartesian = grid3DModel.coordinateSystem; // Always have light.
        cartesian.viewGL.add(this._lightRoot);
        if (grid3DModel.get("show")) cartesian.viewGL.add(this.groupGL);
        else cartesian.viewGL.remove(this.groupGL);
         // cartesian.viewGL.setCameraType(grid3DModel.get('viewControl.projection'));
        var control = this._control;
        control.setViewGL(cartesian.viewGL);
        var viewControlModel = grid3DModel.getModel("viewControl");
        control.setFromViewControlModel(viewControlModel, 0);
        this._axisLabelSurface.clear();
        control.off("update");
        if (grid3DModel.get("show")) {
            this._faces.forEach(function(face) {
                face.update(grid3DModel, ecModel, api);
            }, this);
            this._axes.forEach(function(axis) {
                axis.update(grid3DModel, this._axisLabelSurface, api);
            }, this);
        }
        control.on("update", this._onCameraChange.bind(this, grid3DModel, api), this);
        this._sceneHelper.setScene(cartesian.viewGL.scene);
        this._sceneHelper.updateLight(grid3DModel); // Set post effect
        cartesian.viewGL.setPostEffect(grid3DModel.getModel("postEffect"), api);
        cartesian.viewGL.setTemporalSuperSampling(grid3DModel.getModel("temporalSuperSampling"));
        this._initMouseHandler(grid3DModel);
    },
    afterRender: function(grid3DModel, ecModel, api, layerGL) {
        // Create ambient cubemap after render because we need to know the renderer.
        // TODO
        var renderer = layerGL.renderer;
        this._sceneHelper.updateAmbientCubemap(renderer, grid3DModel, api);
        this._sceneHelper.updateSkybox(renderer, grid3DModel, api);
    },
    /**
   * showAxisPointer will be triggered by action.
   */ showAxisPointer: function(grid3dModel, ecModel, api, payload) {
        this._doShowAxisPointer();
        this._updateAxisPointer(payload.value);
    },
    /**
   * hideAxisPointer will be triggered by action.
   */ hideAxisPointer: function(grid3dModel, ecModel, api, payload) {
        this._doHideAxisPointer();
    },
    _initMouseHandler: function(grid3DModel) {
        var cartesian = grid3DModel.coordinateSystem;
        var viewGL = cartesian.viewGL; // TODO xAxis3D.axisPointer.show ?
        if (grid3DModel.get("show") && grid3DModel.get("axisPointer.show")) viewGL.on("mousemove", this._updateAxisPointerOnMousePosition, this);
        else viewGL.off("mousemove", this._updateAxisPointerOnMousePosition);
    },
    /**
   * Try find and show axisPointer on the intersect point
   * of mouse ray with grid plane.
   */ _updateAxisPointerOnMousePosition: function(e) {
        // Ignore if mouse is on the element.
        if (e.target) return;
        var grid3DModel = this._model;
        var cartesian = grid3DModel.coordinateSystem;
        var viewGL = cartesian.viewGL;
        var ray = viewGL.castRay(e.offsetX, e.offsetY, new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Ray());
        var nearestIntersectPoint;
        for(var i = 0; i < this._faces.length; i++){
            var face = this._faces[i];
            if (face.rootNode.invisible) continue;
             // Plane is not face the camera. flip it
            if (face.plane.normal.dot(viewGL.camera.worldTransform.z) < 0) face.plane.normal.negate();
            var point = ray.intersectPlane(face.plane);
            if (!point) continue;
            var axis0 = cartesian.getAxis(face.faceInfo[0]);
            var axis1 = cartesian.getAxis(face.faceInfo[1]);
            var idx0 = $130ac2c379dce8a3$var$dimIndicesMap[face.faceInfo[0]];
            var idx1 = $130ac2c379dce8a3$var$dimIndicesMap[face.faceInfo[1]];
            if (axis0.contain(point.array[idx0]) && axis1.contain(point.array[idx1])) nearestIntersectPoint = point;
        }
        if (nearestIntersectPoint) {
            var data = cartesian.pointToData(nearestIntersectPoint.array, [], true);
            this._updateAxisPointer(data);
            this._doShowAxisPointer();
        } else this._doHideAxisPointer();
    },
    _onCameraChange: function(grid3DModel, api) {
        if (grid3DModel.get("show")) {
            this._updateFaceVisibility();
            this._updateAxisLinePosition();
        }
        var control = this._control;
        api.dispatchAction({
            type: "grid3DChangeCamera",
            alpha: control.getAlpha(),
            beta: control.getBeta(),
            distance: control.getDistance(),
            center: control.getCenter(),
            from: this.uid,
            grid3DId: grid3DModel.id
        });
    },
    /**
   * Update visibility of each face when camera view changed, front face will be invisible.
   * @private
   */ _updateFaceVisibility: function() {
        var camera = this._control.getCamera();
        var viewSpacePos = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Vector3();
        camera.update();
        for(var idx = 0; idx < this._faces.length / 2; idx++){
            var depths = [];
            for(var k = 0; k < 2; k++){
                var face = this._faces[idx * 2 + k];
                face.rootNode.getWorldPosition(viewSpacePos);
                viewSpacePos.transformMat4(camera.viewMatrix);
                depths[k] = viewSpacePos.z;
            } // Set the front face invisible
            var frontIndex = depths[0] > depths[1] ? 0 : 1;
            var frontFace = this._faces[idx * 2 + frontIndex];
            var backFace = this._faces[idx * 2 + 1 - frontIndex]; // Update rotation.
            frontFace.rootNode.invisible = true;
            backFace.rootNode.invisible = false;
        }
    },
    /**
   * Update axis line position when camera view changed.
   * @private
   */ _updateAxisLinePosition: function() {
        // Put xAxis, yAxis on x, y visible plane.
        // Put zAxis on the left.
        // TODO
        var cartesian = this._model.coordinateSystem;
        var xAxis = cartesian.getAxis("x");
        var yAxis = cartesian.getAxis("y");
        var zAxis = cartesian.getAxis("z");
        var top = zAxis.getExtentMax();
        var bottom = zAxis.getExtentMin();
        var left = xAxis.getExtentMin();
        var right = xAxis.getExtentMax();
        var near = yAxis.getExtentMax();
        var far = yAxis.getExtentMin();
        var xAxisNode = this._axes[0].rootNode;
        var yAxisNode = this._axes[1].rootNode;
        var zAxisNode = this._axes[2].rootNode;
        var faces = this._faces; // Notice: in cartesian up axis is z, but in webgl up axis is y.
        var xAxisZOffset = faces[4].rootNode.invisible ? far : near;
        var xAxisYOffset = faces[2].rootNode.invisible ? top : bottom;
        var yAxisXOffset = faces[0].rootNode.invisible ? left : right;
        var yAxisYOffset = faces[2].rootNode.invisible ? top : bottom;
        var zAxisXOffset = faces[0].rootNode.invisible ? right : left;
        var zAxisZOffset = faces[4].rootNode.invisible ? far : near;
        xAxisNode.rotation.identity();
        yAxisNode.rotation.identity();
        zAxisNode.rotation.identity();
        if (faces[4].rootNode.invisible) {
            this._axes[0].flipped = true;
            xAxisNode.rotation.rotateX(Math.PI);
        }
        if (faces[0].rootNode.invisible) {
            this._axes[1].flipped = true;
            yAxisNode.rotation.rotateZ(Math.PI);
        }
        if (faces[4].rootNode.invisible) {
            this._axes[2].flipped = true;
            zAxisNode.rotation.rotateY(Math.PI);
        }
        xAxisNode.position.set(0, xAxisYOffset, xAxisZOffset);
        yAxisNode.position.set(yAxisXOffset, yAxisYOffset, 0); // Actually z
        zAxisNode.position.set(zAxisXOffset, 0, zAxisZOffset); // Actually y
        xAxisNode.update();
        yAxisNode.update();
        zAxisNode.update();
        this._updateAxisLabelAlign();
    },
    /**
   * Update label align on axis when axisLine position changed.
   * @private
   */ _updateAxisLabelAlign: function() {
        // var cartesian = this._model.coordinateSystem;
        var camera = this._control.getCamera();
        var coords = [
            new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Vector4(),
            new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Vector4()
        ];
        var center = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Vector4();
        this.groupGL.getWorldPosition(center);
        center.w = 1.0;
        center.transformMat4(camera.viewMatrix).transformMat4(camera.projectionMatrix);
        center.x /= center.w;
        center.y /= center.w;
        this._axes.forEach(function(axisInfo) {
            var lineCoords = axisInfo.axisLineCoords;
            var labelGeo = axisInfo.labelsMesh.geometry;
            for(var i = 0; i < coords.length; i++){
                coords[i].setArray(lineCoords[i]);
                coords[i].w = 1.0;
                coords[i].transformMat4(axisInfo.rootNode.worldTransform).transformMat4(camera.viewMatrix).transformMat4(camera.projectionMatrix);
                coords[i].x /= coords[i].w;
                coords[i].y /= coords[i].w;
            }
            var dx = coords[1].x - coords[0].x;
            var dy = coords[1].y - coords[0].y;
            var cx = (coords[1].x + coords[0].x) / 2;
            var cy = (coords[1].y + coords[0].y) / 2;
            var textAlign;
            var verticalAlign;
            if (Math.abs(dy / dx) < 0.5) {
                textAlign = "center";
                verticalAlign = cy > center.y ? "bottom" : "top";
            } else {
                verticalAlign = "middle";
                textAlign = cx > center.x ? "left" : "right";
            } // axis labels
            axisInfo.setSpriteAlign(textAlign, verticalAlign, this._api);
        }, this);
    },
    _doShowAxisPointer: function() {
        if (!this._axisPointerLineMesh.invisible) return;
        this._axisPointerLineMesh.invisible = false;
        this._axisPointerLabelsMesh.invisible = false;
        this._api.getZr().refresh();
    },
    _doHideAxisPointer: function() {
        if (this._axisPointerLineMesh.invisible) return;
        this._axisPointerLineMesh.invisible = true;
        this._axisPointerLabelsMesh.invisible = true;
        this._api.getZr().refresh();
    },
    /**
   * @private updateAxisPointer.
   */ _updateAxisPointer: function(data) {
        var cartesian = this._model.coordinateSystem;
        var point = cartesian.dataToPoint(data);
        var axisPointerLineMesh = this._axisPointerLineMesh;
        var linesGeo = axisPointerLineMesh.geometry;
        var axisPointerParentModel = this._model.getModel("axisPointer");
        var dpr = this._api.getDevicePixelRatio();
        linesGeo.convertToDynamicArray(true);
        function ifShowAxisPointer(axis) {
            return (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(axis.model.get("axisPointer.show"), axisPointerParentModel.get("show"));
        }
        function getAxisColorAndLineWidth(axis) {
            var axisPointerModel = axis.model.getModel("axisPointer", axisPointerParentModel);
            var lineStyleModel = axisPointerModel.getModel("lineStyle");
            var color = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(lineStyleModel.get("color"));
            var lineWidth = $130ac2c379dce8a3$var$firstNotNull(lineStyleModel.get("width"), 1);
            var opacity = $130ac2c379dce8a3$var$firstNotNull(lineStyleModel.get("opacity"), 1);
            color[3] *= opacity;
            return {
                color: color,
                lineWidth: lineWidth
            };
        }
        for(var k = 0; k < this._faces.length; k++){
            var face = this._faces[k];
            if (face.rootNode.invisible) continue;
            var faceInfo = face.faceInfo;
            var otherCoord = faceInfo[3] < 0 ? cartesian.getAxis(faceInfo[2]).getExtentMin() : cartesian.getAxis(faceInfo[2]).getExtentMax();
            var otherDimIdx = $130ac2c379dce8a3$var$dimIndicesMap[faceInfo[2]]; // Line on face.
            for(var i = 0; i < 2; i++){
                var dim = faceInfo[i];
                var faceOtherDim = faceInfo[1 - i];
                var axis = cartesian.getAxis(dim);
                var faceOtherAxis = cartesian.getAxis(faceOtherDim);
                if (!ifShowAxisPointer(axis)) continue;
                var p0 = [
                    0,
                    0,
                    0
                ];
                var p1 = [
                    0,
                    0,
                    0
                ];
                var dimIdx = $130ac2c379dce8a3$var$dimIndicesMap[dim];
                var faceOtherDimIdx = $130ac2c379dce8a3$var$dimIndicesMap[faceOtherDim];
                p0[dimIdx] = p1[dimIdx] = point[dimIdx];
                p0[otherDimIdx] = p1[otherDimIdx] = otherCoord;
                p0[faceOtherDimIdx] = faceOtherAxis.getExtentMin();
                p1[faceOtherDimIdx] = faceOtherAxis.getExtentMax();
                var colorAndLineWidth = getAxisColorAndLineWidth(axis);
                linesGeo.addLine(p0, p1, colorAndLineWidth.color, colorAndLineWidth.lineWidth * dpr);
            } // Project line.
            if (ifShowAxisPointer(cartesian.getAxis(faceInfo[2]))) {
                var p0 = point.slice();
                var p1 = point.slice();
                p1[otherDimIdx] = otherCoord;
                var colorAndLineWidth = getAxisColorAndLineWidth(cartesian.getAxis(faceInfo[2]));
                linesGeo.addLine(p0, p1, colorAndLineWidth.color, colorAndLineWidth.lineWidth * dpr);
            }
        }
        linesGeo.convertToTypedArray();
        this._updateAxisPointerLabelsMesh(data);
        this._api.getZr().refresh();
    },
    _updateAxisPointerLabelsMesh: function(data) {
        var grid3dModel = this._model;
        var axisPointerLabelsMesh = this._axisPointerLabelsMesh;
        var axisPointerLabelsSurface = this._axisPointerLabelsSurface;
        var cartesian = grid3dModel.coordinateSystem;
        var axisPointerParentModel = grid3dModel.getModel("axisPointer");
        axisPointerLabelsMesh.geometry.convertToDynamicArray(true);
        axisPointerLabelsSurface.clear();
        var otherDim = {
            x: "y",
            y: "x",
            z: "y"
        };
        this._axes.forEach(function(axisInfo, idx) {
            var axis = cartesian.getAxis(axisInfo.dim);
            var axisModel = axis.model;
            var axisPointerModel = axisModel.getModel("axisPointer", axisPointerParentModel);
            var labelModel = axisPointerModel.getModel("label");
            var lineColor = axisPointerModel.get("lineStyle.color");
            if (!labelModel.get("show") || !axisPointerModel.get("show")) return;
            var val = data[idx];
            var formatter = labelModel.get("formatter");
            var text = axis.scale.getLabel({
                value: val
            });
            if (formatter != null) text = formatter(text, data);
            else if (axis.scale.type === "interval" || axis.scale.type === "log") {
                var precision = $880e2355a7de9d0c$exports.getPrecisionSafe(axis.scale.getTicks()[0]);
                text = val.toFixed(precision + 2);
            }
            var labelColor = labelModel.get("color");
            var textEl = new $03154d907069e78f$exports.Text({
                style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelModel, {
                    text: text,
                    fill: labelColor || lineColor,
                    align: "left",
                    verticalAlign: "top"
                })
            });
            var coords = axisPointerLabelsSurface.add(textEl);
            var rect = textEl.getBoundingRect();
            var dpr = this._api.getDevicePixelRatio();
            var pos = axisInfo.rootNode.position.toArray();
            var otherIdx = $130ac2c379dce8a3$var$dimIndicesMap[otherDim[axisInfo.dim]];
            pos[otherIdx] += (axisInfo.flipped ? -1 : 1) * labelModel.get("margin");
            pos[$130ac2c379dce8a3$var$dimIndicesMap[axisInfo.dim]] = axis.dataToCoord(data[idx]);
            axisPointerLabelsMesh.geometry.addSprite(pos, [
                rect.width * dpr,
                rect.height * dpr
            ], coords, axisInfo.textAlign, axisInfo.textVerticalAlign);
        }, this);
        axisPointerLabelsSurface.getZr().refreshImmediately();
        axisPointerLabelsMesh.material.set("uvScale", axisPointerLabelsSurface.getCoordsScale());
        axisPointerLabelsMesh.geometry.convertToTypedArray();
    },
    dispose: function() {
        this.groupGL.removeAll();
        this._control.dispose();
        this._axisLabelSurface.dispose();
        this._axisPointerLabelsSurface.dispose();
    }
});




function $3fc2896504c5f210$var$Cartesian3D(name) {
    (0, $f0775b150bc00f28$export$2e2bcd8739ae039).call(this, name);
    this.type = "cartesian3D";
    this.dimensions = [
        "x",
        "y",
        "z"
    ];
    this.size = [
        0,
        0,
        0
    ];
}
$3fc2896504c5f210$var$Cartesian3D.prototype = {
    constructor: $3fc2896504c5f210$var$Cartesian3D,
    model: null,
    containPoint: function(point) {
        return this.getAxis("x").contain(point[0]) && this.getAxis("y").contain(point[2]) && this.getAxis("z").contain(point[1]);
    },
    containData: function(data) {
        return this.getAxis("x").containData(data[0]) && this.getAxis("y").containData(data[1]) && this.getAxis("z").containData(data[2]);
    },
    dataToPoint: function(data, out, clamp) {
        out = out || [];
        out[0] = this.getAxis("x").dataToCoord(data[0], clamp);
        out[2] = this.getAxis("y").dataToCoord(data[1], clamp);
        out[1] = this.getAxis("z").dataToCoord(data[2], clamp);
        return out;
    },
    pointToData: function(point, out, clamp) {
        out = out || [];
        out[0] = this.getAxis("x").coordToData(point[0], clamp);
        out[1] = this.getAxis("y").coordToData(point[2], clamp);
        out[2] = this.getAxis("z").coordToData(point[1], clamp);
        return out;
    }
};
$224386f1517b5dca$exports.inherits($3fc2896504c5f210$var$Cartesian3D, (0, $f0775b150bc00f28$export$2e2bcd8739ae039));
var $3fc2896504c5f210$export$2e2bcd8739ae039 = $3fc2896504c5f210$var$Cartesian3D;



function $8eac0fde0c55469d$var$Axis3D(dim, scale, extent) {
    $c2b1efffe5ae3f42$export$2e2bcd8739ae039.call(this, dim, scale, extent);
}
$8eac0fde0c55469d$var$Axis3D.prototype = {
    constructor: $8eac0fde0c55469d$var$Axis3D,
    getExtentMin: function() {
        var extent = this._extent;
        return Math.min(extent[0], extent[1]);
    },
    getExtentMax: function() {
        var extent = this._extent;
        return Math.max(extent[0], extent[1]);
    },
    calculateCategoryInterval: function() {
        // TODO consider label length
        return Math.floor(this.scale.count() / 8);
    }
};
$224386f1517b5dca$exports.inherits($8eac0fde0c55469d$var$Axis3D, $c2b1efffe5ae3f42$export$2e2bcd8739ae039);
var $8eac0fde0c55469d$export$2e2bcd8739ae039 = $8eac0fde0c55469d$var$Axis3D;




/*
 * @module echarts-gl/core/ViewGL
 * @author Yi Shen(http://github.com/pissang)
 */ 




















var $2df876d13368603a$var$TexturePool = function() {
    this._pool = {};
    this._allocatedTextures = [];
};
$2df876d13368603a$var$TexturePool.prototype = {
    constructor: $2df876d13368603a$var$TexturePool,
    get: function(parameters) {
        var key = $2df876d13368603a$var$generateKey(parameters);
        if (!this._pool.hasOwnProperty(key)) this._pool[key] = [];
        var list = this._pool[key];
        if (!list.length) {
            var texture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)(parameters);
            this._allocatedTextures.push(texture);
            return texture;
        }
        return list.pop();
    },
    put: function(texture) {
        var key = $2df876d13368603a$var$generateKey(texture);
        if (!this._pool.hasOwnProperty(key)) this._pool[key] = [];
        var list = this._pool[key];
        list.push(texture);
    },
    clear: function(renderer) {
        for(var i = 0; i < this._allocatedTextures.length; i++)this._allocatedTextures[i].dispose(renderer);
        this._pool = {};
        this._allocatedTextures = [];
    }
};
var $2df876d13368603a$var$defaultParams = {
    width: 512,
    height: 512,
    type: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).UNSIGNED_BYTE,
    format: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).RGBA,
    wrapS: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).CLAMP_TO_EDGE,
    wrapT: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).CLAMP_TO_EDGE,
    minFilter: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LINEAR_MIPMAP_LINEAR,
    magFilter: (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LINEAR,
    useMipmap: true,
    anisotropic: 1,
    flipY: true,
    unpackAlignment: 4,
    premultiplyAlpha: false
};
var $2df876d13368603a$var$defaultParamPropList = Object.keys($2df876d13368603a$var$defaultParams);
function $2df876d13368603a$var$generateKey(parameters) {
    (0, $b22fd57b6bfa77fb$export$2e2bcd8739ae039).defaultsWithPropList(parameters, $2df876d13368603a$var$defaultParams, $2df876d13368603a$var$defaultParamPropList);
    $2df876d13368603a$var$fallBack(parameters);
    var key = "";
    for(var i = 0; i < $2df876d13368603a$var$defaultParamPropList.length; i++){
        var name = $2df876d13368603a$var$defaultParamPropList[i];
        var chunk = parameters[name].toString();
        key += chunk;
    }
    return key;
}
function $2df876d13368603a$var$fallBack(target) {
    var IPOT = $2df876d13368603a$var$isPowerOfTwo(target.width, target.height);
    if (target.format === (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).DEPTH_COMPONENT) target.useMipmap = false;
    if (!IPOT || !target.useMipmap) {
        if (target.minFilter == (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).NEAREST_MIPMAP_NEAREST || target.minFilter == (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).NEAREST_MIPMAP_LINEAR) target.minFilter = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).NEAREST;
        else if (target.minFilter == (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LINEAR_MIPMAP_LINEAR || target.minFilter == (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LINEAR_MIPMAP_NEAREST) target.minFilter = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).LINEAR;
    }
    if (!IPOT) {
        target.wrapS = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).CLAMP_TO_EDGE;
        target.wrapT = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).CLAMP_TO_EDGE;
    }
}
function $2df876d13368603a$var$isPowerOfTwo(width, height) {
    return (width & width - 1) === 0 && (height & height - 1) === 0;
}
var $2df876d13368603a$export$2e2bcd8739ae039 = $2df876d13368603a$var$TexturePool;



var $6e2b6df446e375e9$export$2e2bcd8739ae039 = "@export clay.sm.depth.vertex\nuniform mat4 worldViewProjection : WORLDVIEWPROJECTION;\nattribute vec3 position : POSITION;\nattribute vec2 texcoord : TEXCOORD_0;\nuniform vec2 uvRepeat = vec2(1.0, 1.0);\nuniform vec2 uvOffset = vec2(0.0, 0.0);\n@import clay.chunk.skinning_header\n@import clay.chunk.instancing_header\nvarying vec4 v_ViewPosition;\nvarying vec2 v_Texcoord;\nvoid main(){\n vec4 P = vec4(position, 1.0);\n#ifdef SKINNING\n @import clay.chunk.skin_matrix\n P = skinMatrixWS * P;\n#endif\n#ifdef INSTANCING\n @import clay.chunk.instancing_matrix\n P = instanceMat * P;\n#endif\n v_ViewPosition = worldViewProjection * P;\n gl_Position = v_ViewPosition;\n v_Texcoord = texcoord * uvRepeat + uvOffset;\n}\n@end\n@export clay.sm.depth.fragment\nvarying vec4 v_ViewPosition;\nvarying vec2 v_Texcoord;\nuniform float bias : 0.001;\nuniform float slopeScale : 1.0;\nuniform sampler2D alphaMap;\nuniform float alphaCutoff: 0.0;\n@import clay.util.encode_float\nvoid main(){\n float depth = v_ViewPosition.z / v_ViewPosition.w;\n if (alphaCutoff > 0.0) {\n if (texture2D(alphaMap, v_Texcoord).a <= alphaCutoff) {\n discard;\n }\n }\n#ifdef USE_VSM\n depth = depth * 0.5 + 0.5;\n float moment1 = depth;\n float moment2 = depth * depth;\n #ifdef SUPPORT_STANDARD_DERIVATIVES\n float dx = dFdx(depth);\n float dy = dFdy(depth);\n moment2 += 0.25*(dx*dx+dy*dy);\n #endif\n gl_FragColor = vec4(moment1, moment2, 0.0, 1.0);\n#else\n #ifdef SUPPORT_STANDARD_DERIVATIVES\n float dx = dFdx(depth);\n float dy = dFdy(depth);\n depth += sqrt(dx*dx + dy*dy) * slopeScale + bias;\n #else\n depth += bias;\n #endif\n gl_FragColor = encodeFloat(depth * 0.5 + 0.5);\n#endif\n}\n@end\n@export clay.sm.debug_depth\nuniform sampler2D depthMap;\nvarying vec2 v_Texcoord;\n@import clay.util.decode_float\nvoid main() {\n vec4 tex = texture2D(depthMap, v_Texcoord);\n#ifdef USE_VSM\n gl_FragColor = vec4(tex.rgb, 1.0);\n#else\n float depth = decodeFloat(tex);\n gl_FragColor = vec4(depth, depth, depth, 1.0);\n#endif\n}\n@end\n@export clay.sm.distance.vertex\nuniform mat4 worldViewProjection : WORLDVIEWPROJECTION;\nuniform mat4 world : WORLD;\nattribute vec3 position : POSITION;\n@import clay.chunk.skinning_header\nvarying vec3 v_WorldPosition;\nvoid main (){\n vec4 P = vec4(position, 1.0);\n#ifdef SKINNING\n @import clay.chunk.skin_matrix\n P = skinMatrixWS * P;\n#endif\n#ifdef INSTANCING\n @import clay.chunk.instancing_matrix\n P = instanceMat * P;\n#endif\n gl_Position = worldViewProjection * P;\n v_WorldPosition = (world * P).xyz;\n}\n@end\n@export clay.sm.distance.fragment\nuniform vec3 lightPosition;\nuniform float range : 100;\nvarying vec3 v_WorldPosition;\n@import clay.util.encode_float\nvoid main(){\n float dist = distance(lightPosition, v_WorldPosition);\n#ifdef USE_VSM\n gl_FragColor = vec4(dist, dist * dist, 0.0, 0.0);\n#else\n dist = dist / range;\n gl_FragColor = encodeFloat(dist);\n#endif\n}\n@end\n@export clay.plugin.shadow_map_common\n@import clay.util.decode_float\nfloat tapShadowMap(sampler2D map, vec2 uv, float z){\n vec4 tex = texture2D(map, uv);\n return step(z, decodeFloat(tex) * 2.0 - 1.0);\n}\nfloat pcf(sampler2D map, vec2 uv, float z, float textureSize, vec2 scale) {\n float shadowContrib = tapShadowMap(map, uv, z);\n vec2 offset = vec2(1.0 / textureSize) * scale;\n#ifdef PCF_KERNEL_SIZE\n for (int _idx_ = 0; _idx_ < PCF_KERNEL_SIZE; _idx_++) {{\n shadowContrib += tapShadowMap(map, uv + offset * pcfKernel[_idx_], z);\n }}\n return shadowContrib / float(PCF_KERNEL_SIZE + 1);\n#else\n shadowContrib += tapShadowMap(map, uv+vec2(offset.x, 0.0), z);\n shadowContrib += tapShadowMap(map, uv+vec2(offset.x, offset.y), z);\n shadowContrib += tapShadowMap(map, uv+vec2(-offset.x, offset.y), z);\n shadowContrib += tapShadowMap(map, uv+vec2(0.0, offset.y), z);\n shadowContrib += tapShadowMap(map, uv+vec2(-offset.x, 0.0), z);\n shadowContrib += tapShadowMap(map, uv+vec2(-offset.x, -offset.y), z);\n shadowContrib += tapShadowMap(map, uv+vec2(offset.x, -offset.y), z);\n shadowContrib += tapShadowMap(map, uv+vec2(0.0, -offset.y), z);\n return shadowContrib / 9.0;\n#endif\n}\nfloat pcf(sampler2D map, vec2 uv, float z, float textureSize) {\n return pcf(map, uv, z, textureSize, vec2(1.0));\n}\nfloat chebyshevUpperBound(vec2 moments, float z){\n float p = 0.0;\n z = z * 0.5 + 0.5;\n if (z <= moments.x) {\n p = 1.0;\n }\n float variance = moments.y - moments.x * moments.x;\n variance = max(variance, 0.0000001);\n float mD = moments.x - z;\n float pMax = variance / (variance + mD * mD);\n pMax = clamp((pMax-0.4)/(1.0-0.4), 0.0, 1.0);\n return max(p, pMax);\n}\nfloat computeShadowContrib(\n sampler2D map, mat4 lightVPM, vec3 position, float textureSize, vec2 scale, vec2 offset\n) {\n vec4 posInLightSpace = lightVPM * vec4(position, 1.0);\n posInLightSpace.xyz /= posInLightSpace.w;\n float z = posInLightSpace.z;\n if(all(greaterThan(posInLightSpace.xyz, vec3(-0.99, -0.99, -1.0))) &&\n all(lessThan(posInLightSpace.xyz, vec3(0.99, 0.99, 1.0)))){\n vec2 uv = (posInLightSpace.xy+1.0) / 2.0;\n #ifdef USE_VSM\n vec2 moments = texture2D(map, uv * scale + offset).xy;\n return chebyshevUpperBound(moments, z);\n #else\n return pcf(map, uv * scale + offset, z, textureSize, scale);\n #endif\n }\n return 1.0;\n}\nfloat computeShadowContrib(sampler2D map, mat4 lightVPM, vec3 position, float textureSize) {\n return computeShadowContrib(map, lightVPM, position, textureSize, vec2(1.0), vec2(0.0));\n}\nfloat computeShadowContribOmni(samplerCube map, vec3 direction, float range)\n{\n float dist = length(direction);\n vec4 shadowTex = textureCube(map, direction);\n#ifdef USE_VSM\n vec2 moments = shadowTex.xy;\n float variance = moments.y - moments.x * moments.x;\n float mD = moments.x - dist;\n float p = variance / (variance + mD * mD);\n if(moments.x + 0.001 < dist){\n return clamp(p, 0.0, 1.0);\n }else{\n return 1.0;\n }\n#else\n return step(dist, (decodeFloat(shadowTex) + 0.0002) * range);\n#endif\n}\n@end\n@export clay.plugin.compute_shadow_map\n#if defined(SPOT_LIGHT_SHADOWMAP_COUNT) || defined(DIRECTIONAL_LIGHT_SHADOWMAP_COUNT) || defined(POINT_LIGHT_SHADOWMAP_COUNT)\n#ifdef SPOT_LIGHT_SHADOWMAP_COUNT\nuniform sampler2D spotLightShadowMaps[SPOT_LIGHT_SHADOWMAP_COUNT]:unconfigurable;\nuniform mat4 spotLightMatrices[SPOT_LIGHT_SHADOWMAP_COUNT]:unconfigurable;\nuniform float spotLightShadowMapSizes[SPOT_LIGHT_SHADOWMAP_COUNT]:unconfigurable;\n#endif\n#ifdef DIRECTIONAL_LIGHT_SHADOWMAP_COUNT\n#if defined(SHADOW_CASCADE)\nuniform sampler2D directionalLightShadowMaps[1]:unconfigurable;\nuniform mat4 directionalLightMatrices[SHADOW_CASCADE]:unconfigurable;\nuniform float directionalLightShadowMapSizes[1]:unconfigurable;\nuniform float shadowCascadeClipsNear[SHADOW_CASCADE]:unconfigurable;\nuniform float shadowCascadeClipsFar[SHADOW_CASCADE]:unconfigurable;\n#else\nuniform sampler2D directionalLightShadowMaps[DIRECTIONAL_LIGHT_SHADOWMAP_COUNT]:unconfigurable;\nuniform mat4 directionalLightMatrices[DIRECTIONAL_LIGHT_SHADOWMAP_COUNT]:unconfigurable;\nuniform float directionalLightShadowMapSizes[DIRECTIONAL_LIGHT_SHADOWMAP_COUNT]:unconfigurable;\n#endif\n#endif\n#ifdef POINT_LIGHT_SHADOWMAP_COUNT\nuniform samplerCube pointLightShadowMaps[POINT_LIGHT_SHADOWMAP_COUNT]:unconfigurable;\n#endif\nuniform bool shadowEnabled : true;\n#ifdef PCF_KERNEL_SIZE\nuniform vec2 pcfKernel[PCF_KERNEL_SIZE];\n#endif\n@import clay.plugin.shadow_map_common\n#if defined(SPOT_LIGHT_SHADOWMAP_COUNT)\nvoid computeShadowOfSpotLights(vec3 position, inout float shadowContribs[SPOT_LIGHT_COUNT] ) {\n float shadowContrib;\n for(int _idx_ = 0; _idx_ < SPOT_LIGHT_SHADOWMAP_COUNT; _idx_++) {{\n shadowContrib = computeShadowContrib(\n spotLightShadowMaps[_idx_], spotLightMatrices[_idx_], position,\n spotLightShadowMapSizes[_idx_]\n );\n shadowContribs[_idx_] = shadowContrib;\n }}\n for(int _idx_ = SPOT_LIGHT_SHADOWMAP_COUNT; _idx_ < SPOT_LIGHT_COUNT; _idx_++){{\n shadowContribs[_idx_] = 1.0;\n }}\n}\n#endif\n#if defined(DIRECTIONAL_LIGHT_SHADOWMAP_COUNT)\n#ifdef SHADOW_CASCADE\nvoid computeShadowOfDirectionalLights(vec3 position, inout float shadowContribs[DIRECTIONAL_LIGHT_COUNT]){\n float depth = (2.0 * gl_FragCoord.z - gl_DepthRange.near - gl_DepthRange.far)\n / (gl_DepthRange.far - gl_DepthRange.near);\n float shadowContrib;\n shadowContribs[0] = 1.0;\n for (int _idx_ = 0; _idx_ < SHADOW_CASCADE; _idx_++) {{\n if (\n depth >= shadowCascadeClipsNear[_idx_] &&\n depth <= shadowCascadeClipsFar[_idx_]\n ) {\n shadowContrib = computeShadowContrib(\n directionalLightShadowMaps[0], directionalLightMatrices[_idx_], position,\n directionalLightShadowMapSizes[0],\n vec2(1.0 / float(SHADOW_CASCADE), 1.0),\n vec2(float(_idx_) / float(SHADOW_CASCADE), 0.0)\n );\n shadowContribs[0] = shadowContrib;\n }\n }}\n for(int _idx_ = DIRECTIONAL_LIGHT_SHADOWMAP_COUNT; _idx_ < DIRECTIONAL_LIGHT_COUNT; _idx_++) {{\n shadowContribs[_idx_] = 1.0;\n }}\n}\n#else\nvoid computeShadowOfDirectionalLights(vec3 position, inout float shadowContribs[DIRECTIONAL_LIGHT_COUNT]){\n float shadowContrib;\n for(int _idx_ = 0; _idx_ < DIRECTIONAL_LIGHT_SHADOWMAP_COUNT; _idx_++) {{\n shadowContrib = computeShadowContrib(\n directionalLightShadowMaps[_idx_], directionalLightMatrices[_idx_], position,\n directionalLightShadowMapSizes[_idx_]\n );\n shadowContribs[_idx_] = shadowContrib;\n }}\n for(int _idx_ = DIRECTIONAL_LIGHT_SHADOWMAP_COUNT; _idx_ < DIRECTIONAL_LIGHT_COUNT; _idx_++) {{\n shadowContribs[_idx_] = 1.0;\n }}\n}\n#endif\n#endif\n#if defined(POINT_LIGHT_SHADOWMAP_COUNT)\nvoid computeShadowOfPointLights(vec3 position, inout float shadowContribs[POINT_LIGHT_COUNT] ){\n vec3 lightPosition;\n vec3 direction;\n for(int _idx_ = 0; _idx_ < POINT_LIGHT_SHADOWMAP_COUNT; _idx_++) {{\n lightPosition = pointLightPosition[_idx_];\n direction = position - lightPosition;\n shadowContribs[_idx_] = computeShadowContribOmni(pointLightShadowMaps[_idx_], direction, pointLightRange[_idx_]);\n }}\n for(int _idx_ = POINT_LIGHT_SHADOWMAP_COUNT; _idx_ < POINT_LIGHT_COUNT; _idx_++) {{\n shadowContribs[_idx_] = 1.0;\n }}\n}\n#endif\n#endif\n@end";


var $7f41e20ed9aae8d8$var$targets = [
    "px",
    "nx",
    "py",
    "ny",
    "pz",
    "nz"
];
(0, $90e78c81ac16d455$export$2e2bcd8739ae039)["import"]((0, $6e2b6df446e375e9$export$2e2bcd8739ae039));
function $7f41e20ed9aae8d8$var$getDepthMaterialUniform(renderable, depthMaterial, symbol) {
    if (symbol === "alphaMap") return renderable.material.get("diffuseMap");
    else if (symbol === "alphaCutoff") {
        if (renderable.material.isDefined("fragment", "ALPHA_TEST") && renderable.material.get("diffuseMap")) {
            var alphaCutoff = renderable.material.get("alphaCutoff");
            return alphaCutoff || 0;
        }
        return 0;
    } else if (symbol === "uvRepeat") return renderable.material.get("uvRepeat");
    else if (symbol === "uvOffset") return renderable.material.get("uvOffset");
    else return depthMaterial.get(symbol);
}
function $7f41e20ed9aae8d8$var$isDepthMaterialChanged(renderable, prevRenderable) {
    var matA = renderable.material;
    var matB = prevRenderable.material;
    return matA.get("diffuseMap") !== matB.get("diffuseMap") || (matA.get("alphaCutoff") || 0) !== (matB.get("alphaCutoff") || 0);
}
/**
 * Pass rendering shadow map.
 *
 * @constructor clay.prePass.ShadowMap
 * @extends clay.core.Base
 * @example
 *     var shadowMapPass = new clay.prePass.ShadowMap({
 *         softShadow: clay.prePass.ShadowMap.VSM
 *     });
 *     ...
 *     animation.on('frame', function (frameTime) {
 *         shadowMapPass.render(renderer, scene, camera);
 *         renderer.render(scene, camera);
 *     });
 */ var $7f41e20ed9aae8d8$var$ShadowMapPass = (0, $7c62670c05885275$export$2e2bcd8739ae039).extend(function() {
    return /** @lends clay.prePass.ShadowMap# */ {
        /**
         * Soft shadow technique.
         * Can be {@link clay.prePass.ShadowMap.PCF} or {@link clay.prePass.ShadowMap.VSM}
         * @type {number}
         */ softShadow: $7f41e20ed9aae8d8$var$ShadowMapPass.PCF,
        /**
         * Soft shadow blur size
         * @type {number}
         */ shadowBlur: 1.0,
        lightFrustumBias: "auto",
        kernelPCF: new Float32Array([
            1,
            0,
            1,
            1,
            -1,
            1,
            0,
            1,
            -1,
            0,
            -1,
            -1,
            1,
            -1,
            0,
            -1
        ]),
        precision: "highp",
        _lastRenderNotCastShadow: false,
        _frameBuffer: new (0, $03d0b3c43006f961$export$2e2bcd8739ae039)(),
        _textures: {},
        _shadowMapNumber: {
            "POINT_LIGHT": 0,
            "DIRECTIONAL_LIGHT": 0,
            "SPOT_LIGHT": 0
        },
        _depthMaterials: {},
        _distanceMaterials: {},
        _receivers: [],
        _lightsCastShadow: [],
        _lightCameras: {},
        _lightMaterials: {},
        _texturePool: new (0, $2df876d13368603a$export$2e2bcd8739ae039)()
    };
}, function() {
    // Gaussian filter pass for VSM
    this._gaussianPassH = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("clay.compositor.gaussian_blur")
    });
    this._gaussianPassV = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("clay.compositor.gaussian_blur")
    });
    this._gaussianPassH.setUniform("blurSize", this.shadowBlur);
    this._gaussianPassH.setUniform("blurDir", 0.0);
    this._gaussianPassV.setUniform("blurSize", this.shadowBlur);
    this._gaussianPassV.setUniform("blurDir", 1.0);
    this._outputDepthPass = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("clay.sm.debug_depth")
    });
}, {
    /**
     * Render scene to shadow textures
     * @param  {clay.Renderer} renderer
     * @param  {clay.Scene} scene
     * @param  {clay.Camera} sceneCamera
     * @param  {boolean} [notUpdateScene=false]
     * @memberOf clay.prePass.ShadowMap.prototype
     */ render: function(renderer, scene, sceneCamera, notUpdateScene) {
        if (!sceneCamera) sceneCamera = scene.getMainCamera();
        this.trigger("beforerender", this, renderer, scene, sceneCamera);
        this._renderShadowPass(renderer, scene, sceneCamera, notUpdateScene);
        this.trigger("afterrender", this, renderer, scene, sceneCamera);
    },
    /**
     * Debug rendering of shadow textures
     * @param  {clay.Renderer} renderer
     * @param  {number} size
     * @memberOf clay.prePass.ShadowMap.prototype
     */ renderDebug: function(renderer, size) {
        renderer.saveClear();
        var viewport = renderer.viewport;
        var x = 0, y = 0;
        var width = size || viewport.width / 4;
        var height = width;
        if (this.softShadow === $7f41e20ed9aae8d8$var$ShadowMapPass.VSM) this._outputDepthPass.material.define("fragment", "USE_VSM");
        else this._outputDepthPass.material.undefine("fragment", "USE_VSM");
        for(var name in this._textures){
            var texture = this._textures[name];
            renderer.setViewport(x, y, width * texture.width / texture.height, height);
            this._outputDepthPass.setUniform("depthMap", texture);
            this._outputDepthPass.render(renderer);
            x += width * texture.width / texture.height;
        }
        renderer.setViewport(viewport);
        renderer.restoreClear();
    },
    _updateReceivers: function(renderer, mesh) {
        if (mesh.receiveShadow) {
            this._receivers.push(mesh);
            mesh.material.set("shadowEnabled", 1);
            mesh.material.set("pcfKernel", this.kernelPCF);
        } else mesh.material.set("shadowEnabled", 0);
        if (this.softShadow === $7f41e20ed9aae8d8$var$ShadowMapPass.VSM) {
            mesh.material.define("fragment", "USE_VSM");
            mesh.material.undefine("fragment", "PCF_KERNEL_SIZE");
        } else {
            mesh.material.undefine("fragment", "USE_VSM");
            var kernelPCF = this.kernelPCF;
            if (kernelPCF && kernelPCF.length) mesh.material.define("fragment", "PCF_KERNEL_SIZE", kernelPCF.length / 2);
            else mesh.material.undefine("fragment", "PCF_KERNEL_SIZE");
        }
    },
    _update: function(renderer, scene) {
        var self = this;
        scene.traverse(function(renderable) {
            if (renderable.isRenderable()) self._updateReceivers(renderer, renderable);
        });
        for(var i = 0; i < scene.lights.length; i++){
            var light = scene.lights[i];
            if (light.castShadow && !light.invisible) this._lightsCastShadow.push(light);
        }
    },
    _renderShadowPass: function(renderer, scene, sceneCamera, notUpdateScene) {
        // reset
        for(var name in this._shadowMapNumber)this._shadowMapNumber[name] = 0;
        this._lightsCastShadow.length = 0;
        this._receivers.length = 0;
        var _gl = renderer.gl;
        if (!notUpdateScene) scene.update();
        if (sceneCamera) sceneCamera.update();
        scene.updateLights();
        this._update(renderer, scene);
        // Needs to update the receivers again if shadows come from 1 to 0.
        if (!this._lightsCastShadow.length && this._lastRenderNotCastShadow) return;
        this._lastRenderNotCastShadow = this._lightsCastShadow === 0;
        _gl.enable(_gl.DEPTH_TEST);
        _gl.depthMask(true);
        _gl.disable(_gl.BLEND);
        // Clear with high-z, so the part not rendered will not been shadowed
        // TODO
        // TODO restore
        _gl.clearColor(1.0, 1.0, 1.0, 1.0);
        // Shadow uniforms
        var spotLightShadowMaps = [];
        var spotLightMatrices = [];
        var directionalLightShadowMaps = [];
        var directionalLightMatrices = [];
        var shadowCascadeClips = [];
        var pointLightShadowMaps = [];
        var dirLightHasCascade;
        // Create textures for shadow map
        for(var i = 0; i < this._lightsCastShadow.length; i++){
            var light = this._lightsCastShadow[i];
            if (light.type === "DIRECTIONAL_LIGHT") {
                if (dirLightHasCascade) {
                    console.warn("Only one direectional light supported with shadow cascade");
                    continue;
                }
                if (light.shadowCascade > 4) {
                    console.warn("Support at most 4 cascade");
                    continue;
                }
                if (light.shadowCascade > 1) dirLightHasCascade = light;
                this.renderDirectionalLightShadow(renderer, scene, sceneCamera, light, shadowCascadeClips, directionalLightMatrices, directionalLightShadowMaps);
            } else if (light.type === "SPOT_LIGHT") this.renderSpotLightShadow(renderer, scene, light, spotLightMatrices, spotLightShadowMaps);
            else if (light.type === "POINT_LIGHT") this.renderPointLightShadow(renderer, scene, light, pointLightShadowMaps);
            this._shadowMapNumber[light.type]++;
        }
        for(var lightType in this._shadowMapNumber){
            var number = this._shadowMapNumber[lightType];
            var key = lightType + "_SHADOWMAP_COUNT";
            for(var i = 0; i < this._receivers.length; i++){
                var mesh = this._receivers[i];
                var material = mesh.material;
                if (material.fragmentDefines[key] !== number) {
                    if (number > 0) material.define("fragment", key, number);
                    else if (material.isDefined("fragment", key)) material.undefine("fragment", key);
                }
            }
        }
        for(var i = 0; i < this._receivers.length; i++){
            var mesh = this._receivers[i];
            var material = mesh.material;
            if (dirLightHasCascade) material.define("fragment", "SHADOW_CASCADE", dirLightHasCascade.shadowCascade);
            else material.undefine("fragment", "SHADOW_CASCADE");
        }
        var shadowUniforms = scene.shadowUniforms;
        function getSize(texture) {
            return texture.height;
        }
        if (directionalLightShadowMaps.length > 0) {
            var directionalLightShadowMapSizes = directionalLightShadowMaps.map(getSize);
            shadowUniforms.directionalLightShadowMaps = {
                value: directionalLightShadowMaps,
                type: "tv"
            };
            shadowUniforms.directionalLightMatrices = {
                value: directionalLightMatrices,
                type: "m4v"
            };
            shadowUniforms.directionalLightShadowMapSizes = {
                value: directionalLightShadowMapSizes,
                type: "1fv"
            };
            if (dirLightHasCascade) {
                var shadowCascadeClipsNear = shadowCascadeClips.slice();
                var shadowCascadeClipsFar = shadowCascadeClips.slice();
                shadowCascadeClipsNear.pop();
                shadowCascadeClipsFar.shift();
                // Iterate from far to near
                shadowCascadeClipsNear.reverse();
                shadowCascadeClipsFar.reverse();
                // directionalLightShadowMaps.reverse();
                directionalLightMatrices.reverse();
                shadowUniforms.shadowCascadeClipsNear = {
                    value: shadowCascadeClipsNear,
                    type: "1fv"
                };
                shadowUniforms.shadowCascadeClipsFar = {
                    value: shadowCascadeClipsFar,
                    type: "1fv"
                };
            }
        }
        if (spotLightShadowMaps.length > 0) {
            var spotLightShadowMapSizes = spotLightShadowMaps.map(getSize);
            var shadowUniforms = scene.shadowUniforms;
            shadowUniforms.spotLightShadowMaps = {
                value: spotLightShadowMaps,
                type: "tv"
            };
            shadowUniforms.spotLightMatrices = {
                value: spotLightMatrices,
                type: "m4v"
            };
            shadowUniforms.spotLightShadowMapSizes = {
                value: spotLightShadowMapSizes,
                type: "1fv"
            };
        }
        if (pointLightShadowMaps.length > 0) shadowUniforms.pointLightShadowMaps = {
            value: pointLightShadowMaps,
            type: "tv"
        };
    },
    renderDirectionalLightShadow: function() {
        var splitFrustum = new (0, $81d01ecfe643f241$export$2e2bcd8739ae039)();
        var splitProjMatrix = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
        var cropBBox = new (0, $39676d59fa1158f6$export$2e2bcd8739ae039)();
        var cropMatrix = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
        var lightViewMatrix = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
        var lightViewProjMatrix = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
        var lightProjMatrix = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
        return function(renderer, scene, sceneCamera, light, shadowCascadeClips, directionalLightMatrices, directionalLightShadowMaps) {
            var defaultShadowMaterial = this._getDepthMaterial(light);
            var passConfig = {
                getMaterial: function(renderable) {
                    return renderable.shadowDepthMaterial || defaultShadowMaterial;
                },
                isMaterialChanged: $7f41e20ed9aae8d8$var$isDepthMaterialChanged,
                getUniform: $7f41e20ed9aae8d8$var$getDepthMaterialUniform,
                ifRender: function(renderable) {
                    return renderable.castShadow;
                },
                sortCompare: (0, $a11c3d79797af833$export$2e2bcd8739ae039).opaqueSortCompare
            };
            // First frame
            if (!scene.viewBoundingBoxLastFrame.isFinite()) {
                var boundingBox = scene.getBoundingBox();
                scene.viewBoundingBoxLastFrame.copy(boundingBox).applyTransform(sceneCamera.viewMatrix);
            }
            // Considering moving speed since the bounding box is from last frame
            // TODO: add a bias
            var clippedFar = Math.min(-scene.viewBoundingBoxLastFrame.min.z, sceneCamera.far);
            var clippedNear = Math.max(-scene.viewBoundingBoxLastFrame.max.z, sceneCamera.near);
            var lightCamera = this._getDirectionalLightCamera(light, scene, sceneCamera);
            var lvpMat4Arr = lightViewProjMatrix.array;
            lightProjMatrix.copy(lightCamera.projectionMatrix);
            (0, $0020ce97b75275ae$export$2e2bcd8739ae039).invert(lightViewMatrix.array, lightCamera.worldTransform.array);
            (0, $0020ce97b75275ae$export$2e2bcd8739ae039).multiply(lightViewMatrix.array, lightViewMatrix.array, sceneCamera.worldTransform.array);
            (0, $0020ce97b75275ae$export$2e2bcd8739ae039).multiply(lvpMat4Arr, lightProjMatrix.array, lightViewMatrix.array);
            var clipPlanes = [];
            var isPerspective = sceneCamera instanceof (0, $b0e6d9b112e2eb50$export$2e2bcd8739ae039);
            var scaleZ = (sceneCamera.near + sceneCamera.far) / (sceneCamera.near - sceneCamera.far);
            var offsetZ = 2 * sceneCamera.near * sceneCamera.far / (sceneCamera.near - sceneCamera.far);
            for(var i = 0; i <= light.shadowCascade; i++){
                var clog = clippedNear * Math.pow(clippedFar / clippedNear, i / light.shadowCascade);
                var cuni = clippedNear + (clippedFar - clippedNear) * i / light.shadowCascade;
                var c = clog * light.cascadeSplitLogFactor + cuni * (1 - light.cascadeSplitLogFactor);
                clipPlanes.push(c);
                shadowCascadeClips.push(-(-c * scaleZ + offsetZ) / -c);
            }
            var texture = this._getTexture(light, light.shadowCascade);
            directionalLightShadowMaps.push(texture);
            var viewport = renderer.viewport;
            var _gl = renderer.gl;
            this._frameBuffer.attach(texture);
            this._frameBuffer.bind(renderer);
            _gl.clear(_gl.COLOR_BUFFER_BIT | _gl.DEPTH_BUFFER_BIT);
            for(var i = 0; i < light.shadowCascade; i++){
                // Get the splitted frustum
                var nearPlane = clipPlanes[i];
                var farPlane = clipPlanes[i + 1];
                if (isPerspective) (0, $0020ce97b75275ae$export$2e2bcd8739ae039).perspective(splitProjMatrix.array, sceneCamera.fov / 180 * Math.PI, sceneCamera.aspect, nearPlane, farPlane);
                else (0, $0020ce97b75275ae$export$2e2bcd8739ae039).ortho(splitProjMatrix.array, sceneCamera.left, sceneCamera.right, sceneCamera.bottom, sceneCamera.top, nearPlane, farPlane);
                splitFrustum.setFromProjection(splitProjMatrix);
                splitFrustum.getTransformedBoundingBox(cropBBox, lightViewMatrix);
                cropBBox.applyProjection(lightProjMatrix);
                var _min = cropBBox.min.array;
                var _max = cropBBox.max.array;
                _min[0] = Math.max(_min[0], -1);
                _min[1] = Math.max(_min[1], -1);
                _max[0] = Math.min(_max[0], 1);
                _max[1] = Math.min(_max[1], 1);
                cropMatrix.ortho(_min[0], _max[0], _min[1], _max[1], 1, -1);
                lightCamera.projectionMatrix.multiplyLeft(cropMatrix);
                var shadowSize = light.shadowResolution || 512;
                // Reversed, left to right => far to near
                renderer.setViewport((light.shadowCascade - i - 1) * shadowSize, 0, shadowSize, shadowSize, 1);
                var renderList = scene.updateRenderList(lightCamera);
                renderer.renderPass(renderList.opaque, lightCamera, passConfig);
                // Filter for VSM
                if (this.softShadow === $7f41e20ed9aae8d8$var$ShadowMapPass.VSM) this._gaussianFilter(renderer, texture, texture.width);
                var matrix = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
                matrix.copy(lightCamera.viewMatrix).multiplyLeft(lightCamera.projectionMatrix);
                directionalLightMatrices.push(matrix.array);
                lightCamera.projectionMatrix.copy(lightProjMatrix);
            }
            this._frameBuffer.unbind(renderer);
            renderer.setViewport(viewport);
        };
    }(),
    renderSpotLightShadow: function(renderer, scene, light, spotLightMatrices, spotLightShadowMaps) {
        var texture = this._getTexture(light);
        var lightCamera = this._getSpotLightCamera(light);
        var _gl = renderer.gl;
        this._frameBuffer.attach(texture);
        this._frameBuffer.bind(renderer);
        _gl.clear(_gl.COLOR_BUFFER_BIT | _gl.DEPTH_BUFFER_BIT);
        var defaultShadowMaterial = this._getDepthMaterial(light);
        var passConfig = {
            getMaterial: function(renderable) {
                return renderable.shadowDepthMaterial || defaultShadowMaterial;
            },
            isMaterialChanged: $7f41e20ed9aae8d8$var$isDepthMaterialChanged,
            getUniform: $7f41e20ed9aae8d8$var$getDepthMaterialUniform,
            ifRender: function(renderable) {
                return renderable.castShadow;
            },
            sortCompare: (0, $a11c3d79797af833$export$2e2bcd8739ae039).opaqueSortCompare
        };
        var renderList = scene.updateRenderList(lightCamera);
        renderer.renderPass(renderList.opaque, lightCamera, passConfig);
        this._frameBuffer.unbind(renderer);
        // Filter for VSM
        if (this.softShadow === $7f41e20ed9aae8d8$var$ShadowMapPass.VSM) this._gaussianFilter(renderer, texture, texture.width);
        var matrix = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
        matrix.copy(lightCamera.worldTransform).invert().multiplyLeft(lightCamera.projectionMatrix);
        spotLightShadowMaps.push(texture);
        spotLightMatrices.push(matrix.array);
    },
    renderPointLightShadow: function(renderer, scene, light, pointLightShadowMaps) {
        var texture = this._getTexture(light);
        var _gl = renderer.gl;
        pointLightShadowMaps.push(texture);
        var defaultShadowMaterial = this._getDepthMaterial(light);
        var passConfig = {
            getMaterial: function(renderable) {
                return renderable.shadowDepthMaterial || defaultShadowMaterial;
            },
            getUniform: $7f41e20ed9aae8d8$var$getDepthMaterialUniform,
            sortCompare: (0, $a11c3d79797af833$export$2e2bcd8739ae039).opaqueSortCompare
        };
        var renderListEachSide = {
            px: [],
            py: [],
            pz: [],
            nx: [],
            ny: [],
            nz: []
        };
        var bbox = new (0, $39676d59fa1158f6$export$2e2bcd8739ae039)();
        var lightWorldPosition = light.getWorldPosition().array;
        var lightBBox = new (0, $39676d59fa1158f6$export$2e2bcd8739ae039)();
        var range = light.range;
        lightBBox.min.setArray(lightWorldPosition);
        lightBBox.max.setArray(lightWorldPosition);
        var extent = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)(range, range, range);
        lightBBox.max.add(extent);
        lightBBox.min.sub(extent);
        var targetsNeedRender = {
            px: false,
            py: false,
            pz: false,
            nx: false,
            ny: false,
            nz: false
        };
        scene.traverse(function(renderable) {
            if (renderable.isRenderable() && renderable.castShadow) {
                var geometry = renderable.geometry;
                if (!geometry.boundingBox) {
                    for(var i = 0; i < $7f41e20ed9aae8d8$var$targets.length; i++)renderListEachSide[$7f41e20ed9aae8d8$var$targets[i]].push(renderable);
                    return;
                }
                bbox.transformFrom(geometry.boundingBox, renderable.worldTransform);
                if (!bbox.intersectBoundingBox(lightBBox)) return;
                bbox.updateVertices();
                for(var i = 0; i < $7f41e20ed9aae8d8$var$targets.length; i++)targetsNeedRender[$7f41e20ed9aae8d8$var$targets[i]] = false;
                for(var i = 0; i < 8; i++){
                    var vtx = bbox.vertices[i];
                    var x = vtx[0] - lightWorldPosition[0];
                    var y = vtx[1] - lightWorldPosition[1];
                    var z = vtx[2] - lightWorldPosition[2];
                    var absx = Math.abs(x);
                    var absy = Math.abs(y);
                    var absz = Math.abs(z);
                    if (absx > absy) {
                        if (absx > absz) targetsNeedRender[x > 0 ? "px" : "nx"] = true;
                        else targetsNeedRender[z > 0 ? "pz" : "nz"] = true;
                    } else if (absy > absz) targetsNeedRender[y > 0 ? "py" : "ny"] = true;
                    else targetsNeedRender[z > 0 ? "pz" : "nz"] = true;
                }
                for(var i = 0; i < $7f41e20ed9aae8d8$var$targets.length; i++)if (targetsNeedRender[$7f41e20ed9aae8d8$var$targets[i]]) renderListEachSide[$7f41e20ed9aae8d8$var$targets[i]].push(renderable);
            }
        });
        for(var i = 0; i < 6; i++){
            var target = $7f41e20ed9aae8d8$var$targets[i];
            var camera = this._getPointLightCamera(light, target);
            this._frameBuffer.attach(texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i);
            this._frameBuffer.bind(renderer);
            _gl.clear(_gl.COLOR_BUFFER_BIT | _gl.DEPTH_BUFFER_BIT);
            renderer.renderPass(renderListEachSide[target], camera, passConfig);
        }
        this._frameBuffer.unbind(renderer);
    },
    _getDepthMaterial: function(light) {
        var shadowMaterial = this._lightMaterials[light.__uid__];
        var isPointLight = light.type === "POINT_LIGHT";
        if (!shadowMaterial) {
            var shaderPrefix = isPointLight ? "clay.sm.distance." : "clay.sm.depth.";
            shadowMaterial = new (0, $b70ebca493753aba$export$2e2bcd8739ae039)({
                precision: this.precision,
                shader: new (0, $90e78c81ac16d455$export$2e2bcd8739ae039)((0, $90e78c81ac16d455$export$2e2bcd8739ae039).source(shaderPrefix + "vertex"), (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source(shaderPrefix + "fragment"))
            });
            this._lightMaterials[light.__uid__] = shadowMaterial;
        }
        if (light.shadowSlopeScale != null) shadowMaterial.setUniform("slopeScale", light.shadowSlopeScale);
        if (light.shadowBias != null) shadowMaterial.setUniform("bias", light.shadowBias);
        if (this.softShadow === $7f41e20ed9aae8d8$var$ShadowMapPass.VSM) shadowMaterial.define("fragment", "USE_VSM");
        else shadowMaterial.undefine("fragment", "USE_VSM");
        if (isPointLight) {
            shadowMaterial.set("lightPosition", light.getWorldPosition().array);
            shadowMaterial.set("range", light.range);
        }
        return shadowMaterial;
    },
    _gaussianFilter: function(renderer, texture, size) {
        var parameter = {
            width: size,
            height: size,
            type: (0, $4261427f149675a4$export$2e2bcd8739ae039).FLOAT
        };
        var tmpTexture = this._texturePool.get(parameter);
        this._frameBuffer.attach(tmpTexture);
        this._frameBuffer.bind(renderer);
        this._gaussianPassH.setUniform("texture", texture);
        this._gaussianPassH.setUniform("textureWidth", size);
        this._gaussianPassH.render(renderer);
        this._frameBuffer.attach(texture);
        this._gaussianPassV.setUniform("texture", tmpTexture);
        this._gaussianPassV.setUniform("textureHeight", size);
        this._gaussianPassV.render(renderer);
        this._frameBuffer.unbind(renderer);
        this._texturePool.put(tmpTexture);
    },
    _getTexture: function(light, cascade) {
        var key = light.__uid__;
        var texture = this._textures[key];
        var resolution = light.shadowResolution || 512;
        cascade = cascade || 1;
        if (!texture) {
            if (light.type === "POINT_LIGHT") texture = new (0, $8dbf947c9de660dd$export$2e2bcd8739ae039)();
            else texture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)();
            // At most 4 cascade
            // TODO share with height ?
            texture.width = resolution * cascade;
            texture.height = resolution;
            if (this.softShadow === $7f41e20ed9aae8d8$var$ShadowMapPass.VSM) {
                texture.type = (0, $4261427f149675a4$export$2e2bcd8739ae039).FLOAT;
                texture.anisotropic = 4;
            } else {
                texture.minFilter = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).NEAREST;
                texture.magFilter = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).NEAREST;
                texture.useMipmap = false;
            }
            this._textures[key] = texture;
        }
        return texture;
    },
    _getPointLightCamera: function(light, target) {
        if (!this._lightCameras.point) this._lightCameras.point = {
            px: new (0, $b0e6d9b112e2eb50$export$2e2bcd8739ae039)(),
            nx: new (0, $b0e6d9b112e2eb50$export$2e2bcd8739ae039)(),
            py: new (0, $b0e6d9b112e2eb50$export$2e2bcd8739ae039)(),
            ny: new (0, $b0e6d9b112e2eb50$export$2e2bcd8739ae039)(),
            pz: new (0, $b0e6d9b112e2eb50$export$2e2bcd8739ae039)(),
            nz: new (0, $b0e6d9b112e2eb50$export$2e2bcd8739ae039)()
        };
        var camera = this._lightCameras.point[target];
        camera.far = light.range;
        camera.fov = 90;
        camera.position.set(0, 0, 0);
        switch(target){
            case "px":
                camera.lookAt((0, $27fea36417076c2d$export$2e2bcd8739ae039).POSITIVE_X, (0, $27fea36417076c2d$export$2e2bcd8739ae039).NEGATIVE_Y);
                break;
            case "nx":
                camera.lookAt((0, $27fea36417076c2d$export$2e2bcd8739ae039).NEGATIVE_X, (0, $27fea36417076c2d$export$2e2bcd8739ae039).NEGATIVE_Y);
                break;
            case "py":
                camera.lookAt((0, $27fea36417076c2d$export$2e2bcd8739ae039).POSITIVE_Y, (0, $27fea36417076c2d$export$2e2bcd8739ae039).POSITIVE_Z);
                break;
            case "ny":
                camera.lookAt((0, $27fea36417076c2d$export$2e2bcd8739ae039).NEGATIVE_Y, (0, $27fea36417076c2d$export$2e2bcd8739ae039).NEGATIVE_Z);
                break;
            case "pz":
                camera.lookAt((0, $27fea36417076c2d$export$2e2bcd8739ae039).POSITIVE_Z, (0, $27fea36417076c2d$export$2e2bcd8739ae039).NEGATIVE_Y);
                break;
            case "nz":
                camera.lookAt((0, $27fea36417076c2d$export$2e2bcd8739ae039).NEGATIVE_Z, (0, $27fea36417076c2d$export$2e2bcd8739ae039).NEGATIVE_Y);
                break;
        }
        light.getWorldPosition(camera.position);
        camera.update();
        return camera;
    },
    _getDirectionalLightCamera: function() {
        var lightViewMatrix = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
        var sceneViewBoundingBox = new (0, $39676d59fa1158f6$export$2e2bcd8739ae039)();
        var lightViewBBox = new (0, $39676d59fa1158f6$export$2e2bcd8739ae039)();
        // Camera of directional light will be adjusted
        // to contain the view frustum and scene bounding box as tightly as possible
        return function(light, scene, sceneCamera) {
            if (!this._lightCameras.directional) this._lightCameras.directional = new (0, $c4a0e1584dbfc1e9$export$2e2bcd8739ae039)();
            var camera = this._lightCameras.directional;
            sceneViewBoundingBox.copy(scene.viewBoundingBoxLastFrame);
            sceneViewBoundingBox.intersection(sceneCamera.frustum.boundingBox);
            // Move to the center of frustum(in world space)
            camera.position.copy(sceneViewBoundingBox.min).add(sceneViewBoundingBox.max).scale(0.5).transformMat4(sceneCamera.worldTransform);
            camera.rotation.copy(light.rotation);
            camera.scale.copy(light.scale);
            camera.updateWorldTransform();
            // Transform to light view space
            (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).invert(lightViewMatrix, camera.worldTransform);
            (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).multiply(lightViewMatrix, lightViewMatrix, sceneCamera.worldTransform);
            lightViewBBox.copy(sceneViewBoundingBox).applyTransform(lightViewMatrix);
            var min = lightViewBBox.min.array;
            var max = lightViewBBox.max.array;
            // Move camera to adjust the near to 0
            camera.position.set((min[0] + max[0]) / 2, (min[1] + max[1]) / 2, max[2]).transformMat4(camera.worldTransform);
            camera.near = 0;
            camera.far = -min[2] + max[2];
            // Make sure receivers not in the frustum will stil receive the shadow.
            if (isNaN(this.lightFrustumBias)) camera.far *= 4;
            else camera.far += this.lightFrustumBias;
            camera.left = min[0];
            camera.right = max[0];
            camera.top = max[1];
            camera.bottom = min[1];
            camera.update(true);
            return camera;
        };
    }(),
    _getSpotLightCamera: function(light) {
        if (!this._lightCameras.spot) this._lightCameras.spot = new (0, $b0e6d9b112e2eb50$export$2e2bcd8739ae039)();
        var camera = this._lightCameras.spot;
        // Update properties
        camera.fov = light.penumbraAngle * 2;
        camera.far = light.range;
        camera.worldTransform.copy(light.worldTransform);
        camera.updateProjectionMatrix();
        (0, $0020ce97b75275ae$export$2e2bcd8739ae039).invert(camera.viewMatrix.array, camera.worldTransform.array);
        return camera;
    },
    /**
     * @param  {clay.Renderer|WebGLRenderingContext} [renderer]
     * @memberOf clay.prePass.ShadowMap.prototype
     */ // PENDING Renderer or WebGLRenderingContext
    dispose: function(renderer) {
        var _gl = renderer.gl || renderer;
        if (this._frameBuffer) this._frameBuffer.dispose(_gl);
        for(var name in this._textures)this._textures[name].dispose(_gl);
        this._texturePool.clear(renderer.gl);
        this._depthMaterials = {};
        this._distanceMaterials = {};
        this._textures = {};
        this._lightCameras = {};
        this._shadowMapNumber = {
            "POINT_LIGHT": 0,
            "DIRECTIONAL_LIGHT": 0,
            "SPOT_LIGHT": 0
        };
        this._meshMaterials = {};
        for(var i = 0; i < this._receivers.length; i++){
            var mesh = this._receivers[i];
            // Mesh may be disposed
            if (mesh.material) {
                var material = mesh.material;
                material.undefine("fragment", "POINT_LIGHT_SHADOW_COUNT");
                material.undefine("fragment", "DIRECTIONAL_LIGHT_SHADOW_COUNT");
                material.undefine("fragment", "AMBIENT_LIGHT_SHADOW_COUNT");
                material.set("shadowEnabled", 0);
            }
        }
        this._receivers = [];
        this._lightsCastShadow = [];
    }
});
/**
 * @name clay.prePass.ShadowMap.VSM
 * @type {number}
 */ $7f41e20ed9aae8d8$var$ShadowMapPass.VSM = 1;
/**
 * @name clay.prePass.ShadowMap.PCF
 * @type {number}
 */ $7f41e20ed9aae8d8$var$ShadowMapPass.PCF = 2;
var $7f41e20ed9aae8d8$export$2e2bcd8739ae039 = $7f41e20ed9aae8d8$var$ShadowMapPass;












// DEPRECATED



// PENDING
// Use topological sort ?
/**
 * Node of graph based post processing.
 *
 * @constructor clay.compositor.CompositorNode
 * @extends clay.core.Base
 *
 */ var $3c88ac014198c4f5$var$CompositorNode = (0, $7c62670c05885275$export$2e2bcd8739ae039).extend(function() {
    return /** @lends clay.compositor.CompositorNode# */ {
        /**
         * @type {string}
         */ name: "",
        /**
         * Input links, will be updated by the graph
         * @example:
         *     inputName: {
         *         node: someNode,
         *         pin: 'xxxx'
         *     }
         * @type {Object}
         */ inputLinks: {},
        /**
         * Output links, will be updated by the graph
         * @example:
         *     outputName: {
         *         node: someNode,
         *         pin: 'xxxx'
         *     }
         * @type {Object}
         */ outputLinks: {},
        // Save the output texture of previous frame
        // Will be used when there exist a circular reference
        _prevOutputTextures: {},
        _outputTextures: {},
        // Example: { name: 2 }
        _outputReferences: {},
        _rendering: false,
        // If rendered in this frame
        _rendered: false,
        _compositor: null
    };
}, /** @lends clay.compositor.CompositorNode.prototype */ {
    // TODO Remove parameter function callback
    updateParameter: function(outputName, renderer) {
        var outputInfo = this.outputs[outputName];
        var parameters = outputInfo.parameters;
        var parametersCopy = outputInfo._parametersCopy;
        if (!parametersCopy) parametersCopy = outputInfo._parametersCopy = {};
        if (parameters) {
            for(var key in parameters)if (key !== "width" && key !== "height") parametersCopy[key] = parameters[key];
        }
        var width, height;
        if (parameters.width instanceof Function) width = parameters.width.call(this, renderer);
        else width = parameters.width;
        if (parameters.height instanceof Function) height = parameters.height.call(this, renderer);
        else height = parameters.height;
        if (parametersCopy.width !== width || parametersCopy.height !== height) {
            if (this._outputTextures[outputName]) this._outputTextures[outputName].dispose(renderer.gl);
        }
        parametersCopy.width = width;
        parametersCopy.height = height;
        return parametersCopy;
    },
    /**
     * Set parameter
     * @param {string} name
     * @param {} value
     */ setParameter: function(name, value) {},
    /**
     * Get parameter value
     * @param  {string} name
     * @return {}
     */ getParameter: function(name) {},
    /**
     * Set parameters
     * @param {Object} obj
     */ setParameters: function(obj) {
        for(var name in obj)this.setParameter(name, obj[name]);
    },
    render: function() {},
    getOutput: function(renderer /*optional*/ , name) {
        if (name == null) {
            // Return the output texture without rendering
            name = renderer;
            return this._outputTextures[name];
        }
        var outputInfo = this.outputs[name];
        if (!outputInfo) return;
        // Already been rendered in this frame
        if (this._rendered) {
            // Force return texture in last frame
            if (outputInfo.outputLastFrame) return this._prevOutputTextures[name];
            else return this._outputTextures[name];
        } else if (// TODO
        this._rendering // Solve Circular Reference
        ) {
            if (!this._prevOutputTextures[name]) // Create a blank texture at first pass
            this._prevOutputTextures[name] = this._compositor.allocateTexture(outputInfo.parameters || {});
            return this._prevOutputTextures[name];
        }
        this.render(renderer);
        return this._outputTextures[name];
    },
    removeReference: function(outputName) {
        this._outputReferences[outputName]--;
        if (this._outputReferences[outputName] === 0) {
            var outputInfo = this.outputs[outputName];
            if (outputInfo.keepLastFrame) {
                if (this._prevOutputTextures[outputName]) this._compositor.releaseTexture(this._prevOutputTextures[outputName]);
                this._prevOutputTextures[outputName] = this._outputTextures[outputName];
            } else // Output of this node have alreay been used by all other nodes
            // Put the texture back to the pool.
            this._compositor.releaseTexture(this._outputTextures[outputName]);
        }
    },
    link: function(inputPinName, fromNode, fromPinName) {
        // The relationship from output pin to input pin is one-on-multiple
        this.inputLinks[inputPinName] = {
            node: fromNode,
            pin: fromPinName
        };
        if (!fromNode.outputLinks[fromPinName]) fromNode.outputLinks[fromPinName] = [];
        fromNode.outputLinks[fromPinName].push({
            node: this,
            pin: inputPinName
        });
        // Enabled the pin texture in shader
        this.pass.material.enableTexture(inputPinName);
    },
    clear: function() {
        this.inputLinks = {};
        this.outputLinks = {};
    },
    updateReference: function(outputName) {
        if (!this._rendering) {
            this._rendering = true;
            for(var inputName in this.inputLinks){
                var link = this.inputLinks[inputName];
                link.node.updateReference(link.pin);
            }
            this._rendering = false;
        }
        if (outputName) this._outputReferences[outputName]++;
    },
    beforeFrame: function() {
        this._rendered = false;
        for(var name in this.outputLinks)this._outputReferences[name] = 0;
    },
    afterFrame: function() {
        // Put back all the textures to pool
        for(var name in this.outputLinks)if (this._outputReferences[name] > 0) {
            var outputInfo = this.outputs[name];
            if (outputInfo.keepLastFrame) {
                if (this._prevOutputTextures[name]) this._compositor.releaseTexture(this._prevOutputTextures[name]);
                this._prevOutputTextures[name] = this._outputTextures[name];
            } else this._compositor.releaseTexture(this._outputTextures[name]);
        }
    }
});
var $3c88ac014198c4f5$export$2e2bcd8739ae039 = $3c88ac014198c4f5$var$CompositorNode;


/**
 * @constructor clay.compositor.Graph
 * @extends clay.core.Base
 */ var $4f22caae6b29b957$var$Graph = (0, $7c62670c05885275$export$2e2bcd8739ae039).extend(function() {
    return /** @lends clay.compositor.Graph# */ {
        /**
         * @type {Array.<clay.compositor.CompositorNode>}
         */ nodes: []
    };
}, /** @lends clay.compositor.Graph.prototype */ {
    /**
     * Mark to update
     */ dirty: function() {
        this._dirty = true;
    },
    /**
     * @param {clay.compositor.CompositorNode} node
     */ addNode: function(node) {
        if (this.nodes.indexOf(node) >= 0) return;
        this.nodes.push(node);
        this._dirty = true;
    },
    /**
     * @param  {clay.compositor.CompositorNode|string} node
     */ removeNode: function(node) {
        if (typeof node === "string") node = this.getNodeByName(node);
        var idx = this.nodes.indexOf(node);
        if (idx >= 0) {
            this.nodes.splice(idx, 1);
            this._dirty = true;
        }
    },
    /**
     * @param {string} name
     * @return {clay.compositor.CompositorNode}
     */ getNodeByName: function(name) {
        for(var i = 0; i < this.nodes.length; i++){
            if (this.nodes[i].name === name) return this.nodes[i];
        }
    },
    /**
     * Update links of graph
     */ update: function() {
        for(var i = 0; i < this.nodes.length; i++)this.nodes[i].clear();
        // Traverse all the nodes and build the graph
        for(var i = 0; i < this.nodes.length; i++){
            var node = this.nodes[i];
            if (!node.inputs) continue;
            for(var inputName in node.inputs){
                if (!node.inputs[inputName]) continue;
                if (node.pass && !node.pass.material.isUniformEnabled(inputName)) {
                    console.warn("Pin " + node.name + "." + inputName + " not used.");
                    continue;
                }
                var fromPinInfo = node.inputs[inputName];
                var fromPin = this.findPin(fromPinInfo);
                if (fromPin) node.link(inputName, fromPin.node, fromPin.pin);
                else if (typeof fromPinInfo === "string") console.warn("Node " + fromPinInfo + " not exist");
                else console.warn("Pin of " + fromPinInfo.node + "." + fromPinInfo.pin + " not exist");
            }
        }
    },
    findPin: function(input) {
        var node;
        // Try to take input as a directly a node
        if (typeof input === "string" || input instanceof (0, $3c88ac014198c4f5$export$2e2bcd8739ae039)) input = {
            node: input
        };
        if (typeof input.node === "string") for(var i = 0; i < this.nodes.length; i++){
            var tmp = this.nodes[i];
            if (tmp.name === input.node) node = tmp;
        }
        else node = input.node;
        if (node) {
            var inputPin = input.pin;
            if (!inputPin) // Use first pin defaultly
            {
                if (node.outputs) inputPin = Object.keys(node.outputs)[0];
            }
            if (node.outputs[inputPin]) return {
                node: node,
                pin: inputPin
            };
        }
    }
});
var $4f22caae6b29b957$export$2e2bcd8739ae039 = $4f22caae6b29b957$var$Graph;




/**
 * Compositor provide graph based post processing
 *
 * @constructor clay.compositor.Compositor
 * @extends clay.compositor.Graph
 *
 */ var $ce6f21cdc4b8d599$var$Compositor = (0, $4f22caae6b29b957$export$2e2bcd8739ae039).extend(function() {
    return {
        // Output node
        _outputs: [],
        _texturePool: new (0, $2df876d13368603a$export$2e2bcd8739ae039)(),
        _frameBuffer: new (0, $03d0b3c43006f961$export$2e2bcd8739ae039)({
            depthBuffer: false
        })
    };
}, /** @lends clay.compositor.Compositor.prototype */ {
    addNode: function(node) {
        (0, $4f22caae6b29b957$export$2e2bcd8739ae039).prototype.addNode.call(this, node);
        node._compositor = this;
    },
    /**
     * @param  {clay.Renderer} renderer
     */ render: function(renderer, frameBuffer) {
        if (this._dirty) {
            this.update();
            this._dirty = false;
            this._outputs.length = 0;
            for(var i = 0; i < this.nodes.length; i++)if (!this.nodes[i].outputs) this._outputs.push(this.nodes[i]);
        }
        for(var i = 0; i < this.nodes.length; i++)// Update the reference number of each output texture
        this.nodes[i].beforeFrame();
        for(var i = 0; i < this._outputs.length; i++)this._outputs[i].updateReference();
        for(var i = 0; i < this._outputs.length; i++)this._outputs[i].render(renderer, frameBuffer);
        for(var i = 0; i < this.nodes.length; i++)// Clear up
        this.nodes[i].afterFrame();
    },
    allocateTexture: function(parameters) {
        return this._texturePool.get(parameters);
    },
    releaseTexture: function(parameters) {
        this._texturePool.put(parameters);
    },
    getFrameBuffer: function() {
        return this._frameBuffer;
    },
    /**
     * Dispose compositor
     * @param {clay.Renderer} renderer
     */ dispose: function(renderer) {
        this._texturePool.clear(renderer);
    }
});
var $ce6f21cdc4b8d599$export$2e2bcd8739ae039 = $ce6f21cdc4b8d599$var$Compositor;





/**
 * @constructor clay.compositor.SceneNode
 * @extends clay.compositor.CompositorNode
 */ var $92bccc5d787b00aa$var$SceneNode = (0, $3c88ac014198c4f5$export$2e2bcd8739ae039).extend(/** @lends clay.compositor.SceneNode# */ {
    name: "scene",
    /**
     * @type {clay.Scene}
     */ scene: null,
    /**
     * @type {clay.Camera}
     */ camera: null,
    /**
     * @type {boolean}
     */ autoUpdateScene: true,
    /**
     * @type {boolean}
     */ preZ: false
}, function() {
    this.frameBuffer = new (0, $03d0b3c43006f961$export$2e2bcd8739ae039)();
}, {
    render: function(renderer) {
        this._rendering = true;
        var _gl = renderer.gl;
        this.trigger("beforerender");
        var renderInfo;
        if (!this.outputs) renderInfo = renderer.render(this.scene, this.camera, !this.autoUpdateScene, this.preZ);
        else {
            var frameBuffer = this.frameBuffer;
            for(var name in this.outputs){
                var parameters = this.updateParameter(name, renderer);
                var outputInfo = this.outputs[name];
                var texture = this._compositor.allocateTexture(parameters);
                this._outputTextures[name] = texture;
                var attachment = outputInfo.attachment || _gl.COLOR_ATTACHMENT0;
                if (typeof attachment == "string") attachment = _gl[attachment];
                frameBuffer.attach(texture, attachment);
            }
            frameBuffer.bind(renderer);
            // MRT Support in chrome
            // https://www.khronos.org/registry/webgl/sdk/tests/conformance/extensions/ext-draw-buffers.html
            var ext = renderer.getGLExtension("EXT_draw_buffers");
            if (ext) {
                var bufs = [];
                for(var attachment in this.outputs){
                    attachment = parseInt(attachment);
                    if (attachment >= _gl.COLOR_ATTACHMENT0 && attachment <= _gl.COLOR_ATTACHMENT0 + 8) bufs.push(attachment);
                }
                ext.drawBuffersEXT(bufs);
            }
            // Always clear
            // PENDING
            renderer.saveClear();
            renderer.clearBit = (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).DEPTH_BUFFER_BIT | (0, $4f1dbdc689ecc3ce$export$2e2bcd8739ae039).COLOR_BUFFER_BIT;
            renderInfo = renderer.render(this.scene, this.camera, !this.autoUpdateScene, this.preZ);
            renderer.restoreClear();
            frameBuffer.unbind(renderer);
        }
        this.trigger("afterrender", renderInfo);
        this._rendering = false;
        this._rendered = true;
    }
});
var $92bccc5d787b00aa$export$2e2bcd8739ae039 = $92bccc5d787b00aa$var$SceneNode;



/**
 * @constructor clay.compositor.TextureNode
 * @extends clay.compositor.CompositorNode
 */ var $7c75c0de70c77426$var$TextureNode = (0, $3c88ac014198c4f5$export$2e2bcd8739ae039).extend(function() {
    return /** @lends clay.compositor.TextureNode# */ {
        /**
         * @type {clay.Texture2D}
         */ texture: null,
        // Texture node must have output without parameters
        outputs: {
            color: {}
        }
    };
}, function() {}, {
    getOutput: function(renderer, name) {
        return this.texture;
    },
    // Do nothing
    beforeFrame: function() {},
    afterFrame: function() {}
});
var $7c75c0de70c77426$export$2e2bcd8739ae039 = $7c75c0de70c77426$var$TextureNode;


// TODO Shader library


// TODO curlnoise demo wrong
// PENDING
// Use topological sort ?
/**
 * Filter node
 *
 * @constructor clay.compositor.FilterNode
 * @extends clay.compositor.CompositorNode
 *
 * @example
    var node = new clay.compositor.FilterNode({
        name: 'fxaa',
        shader: clay.Shader.source('clay.compositor.fxaa'),
        inputs: {
            texture: {
                    node: 'scene',
                    pin: 'color'
            }
        },
        // Multiple outputs is preserved for MRT support in WebGL2.0
        outputs: {
            color: {
                attachment: clay.FrameBuffer.COLOR_ATTACHMENT0
                parameters: {
                    format: clay.Texture.RGBA,
                    width: 512,
                    height: 512
                },
                // Node will keep the RTT rendered in last frame
                keepLastFrame: true,
                // Force the node output the RTT rendered in last frame
                outputLastFrame: true
            }
        }
    });
    *
    */ var $16b620973221d3ca$var$FilterNode = (0, $3c88ac014198c4f5$export$2e2bcd8739ae039).extend(function() {
    return /** @lends clay.compositor.FilterNode# */ {
        /**
         * @type {string}
         */ name: "",
        /**
         * @type {Object}
         */ inputs: {},
        /**
         * @type {Object}
         */ outputs: null,
        /**
         * @type {string}
         */ shader: "",
        /**
         * Input links, will be updated by the graph
         * @example:
         *     inputName: {
         *         node: someNode,
         *         pin: 'xxxx'
         *     }
         * @type {Object}
         */ inputLinks: {},
        /**
         * Output links, will be updated by the graph
         * @example:
         *     outputName: {
         *         node: someNode,
         *         pin: 'xxxx'
         *     }
         * @type {Object}
         */ outputLinks: {},
        /**
         * @type {clay.compositor.Pass}
         */ pass: null,
        // Save the output texture of previous frame
        // Will be used when there exist a circular reference
        _prevOutputTextures: {},
        _outputTextures: {},
        // Example: { name: 2 }
        _outputReferences: {},
        _rendering: false,
        // If rendered in this frame
        _rendered: false,
        _compositor: null
    };
}, function() {
    var pass = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: this.shader
    });
    this.pass = pass;
}, /** @lends clay.compositor.FilterNode.prototype */ {
    /**
     * @param  {clay.Renderer} renderer
     */ render: function(renderer, frameBuffer) {
        this.trigger("beforerender", renderer);
        this._rendering = true;
        var _gl = renderer.gl;
        for(var inputName in this.inputLinks){
            var link = this.inputLinks[inputName];
            var inputTexture = link.node.getOutput(renderer, link.pin);
            this.pass.setUniform(inputName, inputTexture);
        }
        // Output
        if (!this.outputs) {
            this.pass.outputs = null;
            this._compositor.getFrameBuffer().unbind(renderer);
            this.pass.render(renderer, frameBuffer);
        } else {
            this.pass.outputs = {};
            var attachedTextures = {};
            for(var name in this.outputs){
                var parameters = this.updateParameter(name, renderer);
                if (isNaN(parameters.width)) this.updateParameter(name, renderer);
                var outputInfo = this.outputs[name];
                var texture = this._compositor.allocateTexture(parameters);
                this._outputTextures[name] = texture;
                var attachment = outputInfo.attachment || _gl.COLOR_ATTACHMENT0;
                if (typeof attachment === "string") attachment = _gl[attachment];
                attachedTextures[attachment] = texture;
            }
            this._compositor.getFrameBuffer().bind(renderer);
            for(var attachment in attachedTextures)// FIXME attachment changes in different nodes
            this._compositor.getFrameBuffer().attach(attachedTextures[attachment], attachment);
            this.pass.render(renderer);
            // Because the data of texture is changed over time,
            // Here update the mipmaps of texture each time after rendered;
            this._compositor.getFrameBuffer().updateMipmap(renderer);
        }
        for(var inputName in this.inputLinks){
            var link = this.inputLinks[inputName];
            link.node.removeReference(link.pin);
        }
        this._rendering = false;
        this._rendered = true;
        this.trigger("afterrender", renderer);
    },
    // TODO Remove parameter function callback
    updateParameter: function(outputName, renderer) {
        var outputInfo = this.outputs[outputName];
        var parameters = outputInfo.parameters;
        var parametersCopy = outputInfo._parametersCopy;
        if (!parametersCopy) parametersCopy = outputInfo._parametersCopy = {};
        if (parameters) {
            for(var key in parameters)if (key !== "width" && key !== "height") parametersCopy[key] = parameters[key];
        }
        var width, height;
        if (typeof parameters.width === "function") width = parameters.width.call(this, renderer);
        else width = parameters.width;
        if (typeof parameters.height === "function") height = parameters.height.call(this, renderer);
        else height = parameters.height;
        width = Math.ceil(width);
        height = Math.ceil(height);
        if (parametersCopy.width !== width || parametersCopy.height !== height) {
            if (this._outputTextures[outputName]) this._outputTextures[outputName].dispose(renderer);
        }
        parametersCopy.width = width;
        parametersCopy.height = height;
        return parametersCopy;
    },
    /**
     * Set parameter
     * @param {string} name
     * @param {} value
     */ setParameter: function(name, value) {
        this.pass.setUniform(name, value);
    },
    /**
     * Get parameter value
     * @param  {string} name
     * @return {}
     */ getParameter: function(name) {
        return this.pass.getUniform(name);
    },
    /**
     * Set parameters
     * @param {Object} obj
     */ setParameters: function(obj) {
        for(var name in obj)this.setParameter(name, obj[name]);
    },
    // /**
    //  * Set shader code
    //  * @param {string} shaderStr
    //  */
    // setShader: function (shaderStr) {
    //     var material = this.pass.material;
    //     material.shader.setFragment(shaderStr);
    //     material.attachShader(material.shader, true);
    // },
    /**
     * Proxy of pass.material.define('fragment', xxx);
     * @param  {string} symbol
     * @param  {number} [val]
     */ define: function(symbol, val) {
        this.pass.material.define("fragment", symbol, val);
    },
    /**
     * Proxy of pass.material.undefine('fragment', xxx)
     * @param  {string} symbol
     */ undefine: function(symbol) {
        this.pass.material.undefine("fragment", symbol);
    },
    removeReference: function(outputName) {
        this._outputReferences[outputName]--;
        if (this._outputReferences[outputName] === 0) {
            var outputInfo = this.outputs[outputName];
            if (outputInfo.keepLastFrame) {
                if (this._prevOutputTextures[outputName]) this._compositor.releaseTexture(this._prevOutputTextures[outputName]);
                this._prevOutputTextures[outputName] = this._outputTextures[outputName];
            } else // Output of this node have alreay been used by all other nodes
            // Put the texture back to the pool.
            this._compositor.releaseTexture(this._outputTextures[outputName]);
        }
    },
    clear: function() {
        (0, $3c88ac014198c4f5$export$2e2bcd8739ae039).prototype.clear.call(this);
        // Default disable all texture
        this.pass.material.disableTexturesAll();
    }
});
var $16b620973221d3ca$export$2e2bcd8739ae039 = $16b620973221d3ca$var$FilterNode;






var $81412cf29d966b49$export$2e2bcd8739ae039 = "@export clay.compositor.coloradjust\nvarying vec2 v_Texcoord;\nuniform sampler2D texture;\nuniform float brightness : 0.0;\nuniform float contrast : 1.0;\nuniform float exposure : 0.0;\nuniform float gamma : 1.0;\nuniform float saturation : 1.0;\nconst vec3 w = vec3(0.2125, 0.7154, 0.0721);\nvoid main()\n{\n vec4 tex = texture2D( texture, v_Texcoord);\n vec3 color = clamp(tex.rgb + vec3(brightness), 0.0, 1.0);\n color = clamp( (color-vec3(0.5))*contrast+vec3(0.5), 0.0, 1.0);\n color = clamp( color * pow(2.0, exposure), 0.0, 1.0);\n color = clamp( pow(color, vec3(gamma)), 0.0, 1.0);\n float luminance = dot( color, w );\n color = mix(vec3(luminance), color, saturation);\n gl_FragColor = vec4(color, tex.a);\n}\n@end\n@export clay.compositor.brightness\nvarying vec2 v_Texcoord;\nuniform sampler2D texture;\nuniform float brightness : 0.0;\nvoid main()\n{\n vec4 tex = texture2D( texture, v_Texcoord);\n vec3 color = tex.rgb + vec3(brightness);\n gl_FragColor = vec4(color, tex.a);\n}\n@end\n@export clay.compositor.contrast\nvarying vec2 v_Texcoord;\nuniform sampler2D texture;\nuniform float contrast : 1.0;\nvoid main()\n{\n vec4 tex = texture2D( texture, v_Texcoord);\n vec3 color = (tex.rgb-vec3(0.5))*contrast+vec3(0.5);\n gl_FragColor = vec4(color, tex.a);\n}\n@end\n@export clay.compositor.exposure\nvarying vec2 v_Texcoord;\nuniform sampler2D texture;\nuniform float exposure : 0.0;\nvoid main()\n{\n vec4 tex = texture2D(texture, v_Texcoord);\n vec3 color = tex.rgb * pow(2.0, exposure);\n gl_FragColor = vec4(color, tex.a);\n}\n@end\n@export clay.compositor.gamma\nvarying vec2 v_Texcoord;\nuniform sampler2D texture;\nuniform float gamma : 1.0;\nvoid main()\n{\n vec4 tex = texture2D(texture, v_Texcoord);\n vec3 color = pow(tex.rgb, vec3(gamma));\n gl_FragColor = vec4(color, tex.a);\n}\n@end\n@export clay.compositor.saturation\nvarying vec2 v_Texcoord;\nuniform sampler2D texture;\nuniform float saturation : 1.0;\nconst vec3 w = vec3(0.2125, 0.7154, 0.0721);\nvoid main()\n{\n vec4 tex = texture2D(texture, v_Texcoord);\n vec3 color = tex.rgb;\n float luminance = dot(color, w);\n color = mix(vec3(luminance), color, saturation);\n gl_FragColor = vec4(color, tex.a);\n}\n@end";


var $330a95c2ecf6b50f$export$2e2bcd8739ae039 = "@export clay.compositor.kernel.gaussian_9\nfloat gaussianKernel[9];\ngaussianKernel[0] = 0.07;\ngaussianKernel[1] = 0.09;\ngaussianKernel[2] = 0.12;\ngaussianKernel[3] = 0.14;\ngaussianKernel[4] = 0.16;\ngaussianKernel[5] = 0.14;\ngaussianKernel[6] = 0.12;\ngaussianKernel[7] = 0.09;\ngaussianKernel[8] = 0.07;\n@end\n@export clay.compositor.kernel.gaussian_13\nfloat gaussianKernel[13];\ngaussianKernel[0] = 0.02;\ngaussianKernel[1] = 0.03;\ngaussianKernel[2] = 0.06;\ngaussianKernel[3] = 0.08;\ngaussianKernel[4] = 0.11;\ngaussianKernel[5] = 0.13;\ngaussianKernel[6] = 0.14;\ngaussianKernel[7] = 0.13;\ngaussianKernel[8] = 0.11;\ngaussianKernel[9] = 0.08;\ngaussianKernel[10] = 0.06;\ngaussianKernel[11] = 0.03;\ngaussianKernel[12] = 0.02;\n@end\n@export clay.compositor.gaussian_blur\n#define SHADER_NAME gaussian_blur\nuniform sampler2D texture;varying vec2 v_Texcoord;\nuniform float blurSize : 2.0;\nuniform vec2 textureSize : [512.0, 512.0];\nuniform float blurDir : 0.0;\n@import clay.util.rgbm\n@import clay.util.clamp_sample\nvoid main (void)\n{\n @import clay.compositor.kernel.gaussian_9\n vec2 off = blurSize / textureSize;\n off *= vec2(1.0 - blurDir, blurDir);\n vec4 sum = vec4(0.0);\n float weightAll = 0.0;\n for (int i = 0; i < 9; i++) {\n float w = gaussianKernel[i];\n vec4 texel = decodeHDR(clampSample(texture, v_Texcoord + float(i - 4) * off));\n sum += texel * w;\n weightAll += w;\n }\n gl_FragColor = encodeHDR(sum / max(weightAll, 0.01));\n}\n@end\n";


var $3ed4febb8a6f11cd$export$2e2bcd8739ae039 = "@export clay.compositor.hdr.log_lum\nvarying vec2 v_Texcoord;\nuniform sampler2D texture;\nconst vec3 w = vec3(0.2125, 0.7154, 0.0721);\n@import clay.util.rgbm\nvoid main()\n{\n vec4 tex = decodeHDR(texture2D(texture, v_Texcoord));\n float luminance = dot(tex.rgb, w);\n luminance = log(luminance + 0.001);\n gl_FragColor = encodeHDR(vec4(vec3(luminance), 1.0));\n}\n@end\n@export clay.compositor.hdr.lum_adaption\nvarying vec2 v_Texcoord;\nuniform sampler2D adaptedLum;\nuniform sampler2D currentLum;\nuniform float frameTime : 0.02;\n@import clay.util.rgbm\nvoid main()\n{\n float fAdaptedLum = decodeHDR(texture2D(adaptedLum, vec2(0.5, 0.5))).r;\n float fCurrentLum = exp(encodeHDR(texture2D(currentLum, vec2(0.5, 0.5))).r);\n fAdaptedLum += (fCurrentLum - fAdaptedLum) * (1.0 - pow(0.98, 30.0 * frameTime));\n gl_FragColor = encodeHDR(vec4(vec3(fAdaptedLum), 1.0));\n}\n@end\n@export clay.compositor.lum\nvarying vec2 v_Texcoord;\nuniform sampler2D texture;\nconst vec3 w = vec3(0.2125, 0.7154, 0.0721);\nvoid main()\n{\n vec4 tex = texture2D( texture, v_Texcoord );\n float luminance = dot(tex.rgb, w);\n gl_FragColor = vec4(vec3(luminance), 1.0);\n}\n@end";


var $cf2a6ceecb069b92$export$2e2bcd8739ae039 = "\n@export clay.compositor.lut\nvarying vec2 v_Texcoord;\nuniform sampler2D texture;\nuniform sampler2D lookup;\nvoid main()\n{\n vec4 tex = texture2D(texture, v_Texcoord);\n float blueColor = tex.b * 63.0;\n vec2 quad1;\n quad1.y = floor(floor(blueColor) / 8.0);\n quad1.x = floor(blueColor) - (quad1.y * 8.0);\n vec2 quad2;\n quad2.y = floor(ceil(blueColor) / 8.0);\n quad2.x = ceil(blueColor) - (quad2.y * 8.0);\n vec2 texPos1;\n texPos1.x = (quad1.x * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * tex.r);\n texPos1.y = (quad1.y * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * tex.g);\n vec2 texPos2;\n texPos2.x = (quad2.x * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * tex.r);\n texPos2.y = (quad2.y * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * tex.g);\n vec4 newColor1 = texture2D(lookup, texPos1);\n vec4 newColor2 = texture2D(lookup, texPos2);\n vec4 newColor = mix(newColor1, newColor2, fract(blueColor));\n gl_FragColor = vec4(newColor.rgb, tex.w);\n}\n@end";


var $b27f0e7322e147a3$export$2e2bcd8739ae039 = "@export clay.compositor.vignette\n#define OUTPUT_ALPHA\nvarying vec2 v_Texcoord;\nuniform sampler2D texture;\nuniform float darkness: 1;\nuniform float offset: 1;\n@import clay.util.rgbm\nvoid main()\n{\n vec4 texel = decodeHDR(texture2D(texture, v_Texcoord));\n gl_FragColor.rgb = texel.rgb;\n vec2 uv = (v_Texcoord - vec2(0.5)) * vec2(offset);\n gl_FragColor = encodeHDR(vec4(mix(texel.rgb, vec3(1.0 - darkness), dot(uv, uv)), texel.a));\n}\n@end";


var $86ddf9e3bd2c60ba$export$2e2bcd8739ae039 = "@export clay.compositor.output\n#define OUTPUT_ALPHA\nvarying vec2 v_Texcoord;\nuniform sampler2D texture;\n@import clay.util.rgbm\nvoid main()\n{\n vec4 tex = decodeHDR(texture2D(texture, v_Texcoord));\n gl_FragColor.rgb = tex.rgb;\n#ifdef OUTPUT_ALPHA\n gl_FragColor.a = tex.a;\n#else\n gl_FragColor.a = 1.0;\n#endif\n gl_FragColor = encodeHDR(gl_FragColor);\n#ifdef PREMULTIPLY_ALPHA\n gl_FragColor.rgb *= gl_FragColor.a;\n#endif\n}\n@end";


var $6f326837d6cc41ec$export$2e2bcd8739ae039 = "@export clay.compositor.bright\nuniform sampler2D texture;\nuniform float threshold : 1;\nuniform float scale : 1.0;\nuniform vec2 textureSize: [512, 512];\nvarying vec2 v_Texcoord;\nconst vec3 lumWeight = vec3(0.2125, 0.7154, 0.0721);\n@import clay.util.rgbm\nvec4 median(vec4 a, vec4 b, vec4 c)\n{\n return a + b + c - min(min(a, b), c) - max(max(a, b), c);\n}\nvoid main()\n{\n vec4 texel = decodeHDR(texture2D(texture, v_Texcoord));\n#ifdef ANTI_FLICKER\n vec3 d = 1.0 / textureSize.xyx * vec3(1.0, 1.0, 0.0);\n vec4 s1 = decodeHDR(texture2D(texture, v_Texcoord - d.xz));\n vec4 s2 = decodeHDR(texture2D(texture, v_Texcoord + d.xz));\n vec4 s3 = decodeHDR(texture2D(texture, v_Texcoord - d.zy));\n vec4 s4 = decodeHDR(texture2D(texture, v_Texcoord + d.zy));\n texel = median(median(texel, s1, s2), s3, s4);\n#endif\n float lum = dot(texel.rgb , lumWeight);\n vec4 color;\n if (lum > threshold && texel.a > 0.0)\n {\n color = vec4(texel.rgb * scale, texel.a * scale);\n }\n else\n {\n color = vec4(0.0);\n }\n gl_FragColor = encodeHDR(color);\n}\n@end\n";


var $4b3a40e6ffaa9c0e$export$2e2bcd8739ae039 = "@export clay.compositor.downsample\nuniform sampler2D texture;\nuniform vec2 textureSize : [512, 512];\nvarying vec2 v_Texcoord;\n@import clay.util.rgbm\nfloat brightness(vec3 c)\n{\n return max(max(c.r, c.g), c.b);\n}\n@import clay.util.clamp_sample\nvoid main()\n{\n vec4 d = vec4(-1.0, -1.0, 1.0, 1.0) / textureSize.xyxy;\n#ifdef ANTI_FLICKER\n vec3 s1 = decodeHDR(clampSample(texture, v_Texcoord + d.xy)).rgb;\n vec3 s2 = decodeHDR(clampSample(texture, v_Texcoord + d.zy)).rgb;\n vec3 s3 = decodeHDR(clampSample(texture, v_Texcoord + d.xw)).rgb;\n vec3 s4 = decodeHDR(clampSample(texture, v_Texcoord + d.zw)).rgb;\n float s1w = 1.0 / (brightness(s1) + 1.0);\n float s2w = 1.0 / (brightness(s2) + 1.0);\n float s3w = 1.0 / (brightness(s3) + 1.0);\n float s4w = 1.0 / (brightness(s4) + 1.0);\n float oneDivideSum = 1.0 / (s1w + s2w + s3w + s4w);\n vec4 color = vec4(\n (s1 * s1w + s2 * s2w + s3 * s3w + s4 * s4w) * oneDivideSum,\n 1.0\n );\n#else\n vec4 color = decodeHDR(clampSample(texture, v_Texcoord + d.xy));\n color += decodeHDR(clampSample(texture, v_Texcoord + d.zy));\n color += decodeHDR(clampSample(texture, v_Texcoord + d.xw));\n color += decodeHDR(clampSample(texture, v_Texcoord + d.zw));\n color *= 0.25;\n#endif\n gl_FragColor = encodeHDR(color);\n}\n@end";


var $2592197a7615eeb4$export$2e2bcd8739ae039 = "\n@export clay.compositor.upsample\n#define HIGH_QUALITY\nuniform sampler2D texture;\nuniform vec2 textureSize : [512, 512];\nuniform float sampleScale: 0.5;\nvarying vec2 v_Texcoord;\n@import clay.util.rgbm\n@import clay.util.clamp_sample\nvoid main()\n{\n#ifdef HIGH_QUALITY\n vec4 d = vec4(1.0, 1.0, -1.0, 0.0) / textureSize.xyxy * sampleScale;\n vec4 s;\n s = decodeHDR(clampSample(texture, v_Texcoord - d.xy));\n s += decodeHDR(clampSample(texture, v_Texcoord - d.wy)) * 2.0;\n s += decodeHDR(clampSample(texture, v_Texcoord - d.zy));\n s += decodeHDR(clampSample(texture, v_Texcoord + d.zw)) * 2.0;\n s += decodeHDR(clampSample(texture, v_Texcoord )) * 4.0;\n s += decodeHDR(clampSample(texture, v_Texcoord + d.xw)) * 2.0;\n s += decodeHDR(clampSample(texture, v_Texcoord + d.zy));\n s += decodeHDR(clampSample(texture, v_Texcoord + d.wy)) * 2.0;\n s += decodeHDR(clampSample(texture, v_Texcoord + d.xy));\n gl_FragColor = encodeHDR(s / 16.0);\n#else\n vec4 d = vec4(-1.0, -1.0, +1.0, +1.0) / textureSize.xyxy;\n vec4 s;\n s = decodeHDR(clampSample(texture, v_Texcoord + d.xy));\n s += decodeHDR(clampSample(texture, v_Texcoord + d.zy));\n s += decodeHDR(clampSample(texture, v_Texcoord + d.xw));\n s += decodeHDR(clampSample(texture, v_Texcoord + d.zw));\n gl_FragColor = encodeHDR(s / 4.0);\n#endif\n}\n@end";


var $c7da7a62b2d953a4$export$2e2bcd8739ae039 = "@export clay.compositor.hdr.composite\n#define TONEMAPPING\nuniform sampler2D texture;\n#ifdef BLOOM_ENABLED\nuniform sampler2D bloom;\n#endif\n#ifdef LENSFLARE_ENABLED\nuniform sampler2D lensflare;\nuniform sampler2D lensdirt;\n#endif\n#ifdef LUM_ENABLED\nuniform sampler2D lum;\n#endif\n#ifdef LUT_ENABLED\nuniform sampler2D lut;\n#endif\n#ifdef COLOR_CORRECTION\nuniform float brightness : 0.0;\nuniform float contrast : 1.0;\nuniform float saturation : 1.0;\n#endif\n#ifdef VIGNETTE\nuniform float vignetteDarkness: 1.0;\nuniform float vignetteOffset: 1.0;\n#endif\nuniform float exposure : 1.0;\nuniform float bloomIntensity : 0.25;\nuniform float lensflareIntensity : 1;\nvarying vec2 v_Texcoord;\n@import clay.util.srgb\nvec3 ACESToneMapping(vec3 color)\n{\n const float A = 2.51;\n const float B = 0.03;\n const float C = 2.43;\n const float D = 0.59;\n const float E = 0.14;\n return (color * (A * color + B)) / (color * (C * color + D) + E);\n}\nfloat eyeAdaption(float fLum)\n{\n return mix(0.2, fLum, 0.5);\n}\n#ifdef LUT_ENABLED\nvec3 lutTransform(vec3 color) {\n float blueColor = color.b * 63.0;\n vec2 quad1;\n quad1.y = floor(floor(blueColor) / 8.0);\n quad1.x = floor(blueColor) - (quad1.y * 8.0);\n vec2 quad2;\n quad2.y = floor(ceil(blueColor) / 8.0);\n quad2.x = ceil(blueColor) - (quad2.y * 8.0);\n vec2 texPos1;\n texPos1.x = (quad1.x * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * color.r);\n texPos1.y = (quad1.y * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * color.g);\n vec2 texPos2;\n texPos2.x = (quad2.x * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * color.r);\n texPos2.y = (quad2.y * 0.125) + 0.5/512.0 + ((0.125 - 1.0/512.0) * color.g);\n vec4 newColor1 = texture2D(lut, texPos1);\n vec4 newColor2 = texture2D(lut, texPos2);\n vec4 newColor = mix(newColor1, newColor2, fract(blueColor));\n return newColor.rgb;\n}\n#endif\n@import clay.util.rgbm\nvoid main()\n{\n vec4 texel = vec4(0.0);\n vec4 originalTexel = vec4(0.0);\n#ifdef TEXTURE_ENABLED\n texel = decodeHDR(texture2D(texture, v_Texcoord));\n originalTexel = texel;\n#endif\n#ifdef BLOOM_ENABLED\n vec4 bloomTexel = decodeHDR(texture2D(bloom, v_Texcoord));\n texel.rgb += bloomTexel.rgb * bloomIntensity;\n texel.a += bloomTexel.a * bloomIntensity;\n#endif\n#ifdef LENSFLARE_ENABLED\n texel += decodeHDR(texture2D(lensflare, v_Texcoord)) * texture2D(lensdirt, v_Texcoord) * lensflareIntensity;\n#endif\n texel.a = min(texel.a, 1.0);\n#ifdef LUM_ENABLED\n float fLum = texture2D(lum, vec2(0.5, 0.5)).r;\n float adaptedLumDest = 3.0 / (max(0.1, 1.0 + 10.0*eyeAdaption(fLum)));\n float exposureBias = adaptedLumDest * exposure;\n#else\n float exposureBias = exposure;\n#endif\n#ifdef TONEMAPPING\n texel.rgb *= exposureBias;\n texel.rgb = ACESToneMapping(texel.rgb);\n#endif\n texel = linearTosRGB(texel);\n#ifdef LUT_ENABLED\n texel.rgb = lutTransform(clamp(texel.rgb,vec3(0.0),vec3(1.0)));\n#endif\n#ifdef COLOR_CORRECTION\n texel.rgb = clamp(texel.rgb + vec3(brightness), 0.0, 1.0);\n texel.rgb = clamp((texel.rgb - vec3(0.5))*contrast+vec3(0.5), 0.0, 1.0);\n float lum = dot(texel.rgb, vec3(0.2125, 0.7154, 0.0721));\n texel.rgb = mix(vec3(lum), texel.rgb, saturation);\n#endif\n#ifdef VIGNETTE\n vec2 uv = (v_Texcoord - vec2(0.5)) * vec2(vignetteOffset);\n texel.rgb = mix(texel.rgb, vec3(1.0 - vignetteDarkness), dot(uv, uv));\n#endif\n gl_FragColor = encodeHDR(texel);\n#ifdef DEBUG\n #if DEBUG == 1\n gl_FragColor = encodeHDR(decodeHDR(texture2D(texture, v_Texcoord)));\n #elif DEBUG == 2\n gl_FragColor = encodeHDR(decodeHDR(texture2D(bloom, v_Texcoord)) * bloomIntensity);\n #elif DEBUG == 3\n gl_FragColor = encodeHDR(decodeHDR(texture2D(lensflare, v_Texcoord) * lensflareIntensity));\n #endif\n#endif\n if (originalTexel.a <= 0.01 && gl_FragColor.a > 1e-5) {\n gl_FragColor.a = dot(gl_FragColor.rgb, vec3(0.2125, 0.7154, 0.0721));\n }\n#ifdef PREMULTIPLY_ALPHA\n gl_FragColor.rgb *= gl_FragColor.a;\n#endif\n}\n@end";


var $7a3d2ca28e6c7c10$export$2e2bcd8739ae039 = "@export clay.compositor.lensflare\n#define SAMPLE_NUMBER 8\nuniform sampler2D texture;\nuniform sampler2D lenscolor;\nuniform vec2 textureSize : [512, 512];\nuniform float dispersal : 0.3;\nuniform float haloWidth : 0.4;\nuniform float distortion : 1.0;\nvarying vec2 v_Texcoord;\n@import clay.util.rgbm\nvec4 textureDistorted(\n in vec2 texcoord,\n in vec2 direction,\n in vec3 distortion\n) {\n return vec4(\n decodeHDR(texture2D(texture, texcoord + direction * distortion.r)).r,\n decodeHDR(texture2D(texture, texcoord + direction * distortion.g)).g,\n decodeHDR(texture2D(texture, texcoord + direction * distortion.b)).b,\n 1.0\n );\n}\nvoid main()\n{\n vec2 texcoord = -v_Texcoord + vec2(1.0); vec2 textureOffset = 1.0 / textureSize;\n vec2 ghostVec = (vec2(0.5) - texcoord) * dispersal;\n vec2 haloVec = normalize(ghostVec) * haloWidth;\n vec3 distortion = vec3(-textureOffset.x * distortion, 0.0, textureOffset.x * distortion);\n vec4 result = vec4(0.0);\n for (int i = 0; i < SAMPLE_NUMBER; i++)\n {\n vec2 offset = fract(texcoord + ghostVec * float(i));\n float weight = length(vec2(0.5) - offset) / length(vec2(0.5));\n weight = pow(1.0 - weight, 10.0);\n result += textureDistorted(offset, normalize(ghostVec), distortion) * weight;\n }\n result *= texture2D(lenscolor, vec2(length(vec2(0.5) - texcoord)) / length(vec2(0.5)));\n float weight = length(vec2(0.5) - fract(texcoord + haloVec)) / length(vec2(0.5));\n weight = pow(1.0 - weight, 10.0);\n vec2 offset = fract(texcoord + haloVec);\n result += textureDistorted(offset, normalize(ghostVec), distortion) * weight;\n gl_FragColor = result;\n}\n@end";


var $eb8395013449adec$export$2e2bcd8739ae039 = "@export clay.compositor.blend\n#define SHADER_NAME blend\n#ifdef TEXTURE1_ENABLED\nuniform sampler2D texture1;\nuniform float weight1 : 1.0;\n#endif\n#ifdef TEXTURE2_ENABLED\nuniform sampler2D texture2;\nuniform float weight2 : 1.0;\n#endif\n#ifdef TEXTURE3_ENABLED\nuniform sampler2D texture3;\nuniform float weight3 : 1.0;\n#endif\n#ifdef TEXTURE4_ENABLED\nuniform sampler2D texture4;\nuniform float weight4 : 1.0;\n#endif\n#ifdef TEXTURE5_ENABLED\nuniform sampler2D texture5;\nuniform float weight5 : 1.0;\n#endif\n#ifdef TEXTURE6_ENABLED\nuniform sampler2D texture6;\nuniform float weight6 : 1.0;\n#endif\nvarying vec2 v_Texcoord;\n@import clay.util.rgbm\nvoid main()\n{\n vec4 tex = vec4(0.0);\n#ifdef TEXTURE1_ENABLED\n tex += decodeHDR(texture2D(texture1, v_Texcoord)) * weight1;\n#endif\n#ifdef TEXTURE2_ENABLED\n tex += decodeHDR(texture2D(texture2, v_Texcoord)) * weight2;\n#endif\n#ifdef TEXTURE3_ENABLED\n tex += decodeHDR(texture2D(texture3, v_Texcoord)) * weight3;\n#endif\n#ifdef TEXTURE4_ENABLED\n tex += decodeHDR(texture2D(texture4, v_Texcoord)) * weight4;\n#endif\n#ifdef TEXTURE5_ENABLED\n tex += decodeHDR(texture2D(texture5, v_Texcoord)) * weight5;\n#endif\n#ifdef TEXTURE6_ENABLED\n tex += decodeHDR(texture2D(texture6, v_Texcoord)) * weight6;\n#endif\n gl_FragColor = encodeHDR(tex);\n}\n@end";


var $1820f567078b15b3$export$2e2bcd8739ae039 = "@export clay.compositor.fxaa\nuniform sampler2D texture;\nuniform vec4 viewport : VIEWPORT;\nvarying vec2 v_Texcoord;\n#define FXAA_REDUCE_MIN (1.0/128.0)\n#define FXAA_REDUCE_MUL (1.0/8.0)\n#define FXAA_SPAN_MAX 8.0\n@import clay.util.rgbm\nvoid main()\n{\n vec2 resolution = 1.0 / viewport.zw;\n vec3 rgbNW = decodeHDR( texture2D( texture, ( gl_FragCoord.xy + vec2( -1.0, -1.0 ) ) * resolution ) ).xyz;\n vec3 rgbNE = decodeHDR( texture2D( texture, ( gl_FragCoord.xy + vec2( 1.0, -1.0 ) ) * resolution ) ).xyz;\n vec3 rgbSW = decodeHDR( texture2D( texture, ( gl_FragCoord.xy + vec2( -1.0, 1.0 ) ) * resolution ) ).xyz;\n vec3 rgbSE = decodeHDR( texture2D( texture, ( gl_FragCoord.xy + vec2( 1.0, 1.0 ) ) * resolution ) ).xyz;\n vec4 rgbaM = decodeHDR( texture2D( texture, gl_FragCoord.xy * resolution ) );\n vec3 rgbM = rgbaM.xyz;\n float opacity = rgbaM.w;\n vec3 luma = vec3( 0.299, 0.587, 0.114 );\n float lumaNW = dot( rgbNW, luma );\n float lumaNE = dot( rgbNE, luma );\n float lumaSW = dot( rgbSW, luma );\n float lumaSE = dot( rgbSE, luma );\n float lumaM = dot( rgbM, luma );\n float lumaMin = min( lumaM, min( min( lumaNW, lumaNE ), min( lumaSW, lumaSE ) ) );\n float lumaMax = max( lumaM, max( max( lumaNW, lumaNE) , max( lumaSW, lumaSE ) ) );\n vec2 dir;\n dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));\n dir.y = ((lumaNW + lumaSW) - (lumaNE + lumaSE));\n float dirReduce = max( ( lumaNW + lumaNE + lumaSW + lumaSE ) * ( 0.25 * FXAA_REDUCE_MUL ), FXAA_REDUCE_MIN );\n float rcpDirMin = 1.0 / ( min( abs( dir.x ), abs( dir.y ) ) + dirReduce );\n dir = min( vec2( FXAA_SPAN_MAX, FXAA_SPAN_MAX),\n max( vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),\n dir * rcpDirMin)) * resolution;\n vec3 rgbA = decodeHDR( texture2D( texture, gl_FragCoord.xy * resolution + dir * ( 1.0 / 3.0 - 0.5 ) ) ).xyz;\n rgbA += decodeHDR( texture2D( texture, gl_FragCoord.xy * resolution + dir * ( 2.0 / 3.0 - 0.5 ) ) ).xyz;\n rgbA *= 0.5;\n vec3 rgbB = decodeHDR( texture2D( texture, gl_FragCoord.xy * resolution + dir * -0.5 ) ).xyz;\n rgbB += decodeHDR( texture2D( texture, gl_FragCoord.xy * resolution + dir * 0.5 ) ).xyz;\n rgbB *= 0.25;\n rgbB += rgbA * 0.5;\n float lumaB = dot( rgbB, luma );\n if ( ( lumaB < lumaMin ) || ( lumaB > lumaMax ) )\n {\n gl_FragColor = vec4( rgbA, opacity );\n }\n else {\n gl_FragColor = vec4( rgbB, opacity );\n }\n}\n@end";


function $875248bb3d03c743$export$2e2bcd8739ae039(Shader) {
    // Some build in shaders
    Shader["import"]((0, $81412cf29d966b49$export$2e2bcd8739ae039));
    Shader["import"]((0, $330a95c2ecf6b50f$export$2e2bcd8739ae039));
    Shader["import"]((0, $3ed4febb8a6f11cd$export$2e2bcd8739ae039));
    Shader["import"]((0, $cf2a6ceecb069b92$export$2e2bcd8739ae039));
    Shader["import"]((0, $b27f0e7322e147a3$export$2e2bcd8739ae039));
    Shader["import"]((0, $86ddf9e3bd2c60ba$export$2e2bcd8739ae039));
    Shader["import"]((0, $6f326837d6cc41ec$export$2e2bcd8739ae039));
    Shader["import"]((0, $4b3a40e6ffaa9c0e$export$2e2bcd8739ae039));
    Shader["import"]((0, $2592197a7615eeb4$export$2e2bcd8739ae039));
    Shader["import"]((0, $c7da7a62b2d953a4$export$2e2bcd8739ae039));
    Shader["import"]((0, $7a3d2ca28e6c7c10$export$2e2bcd8739ae039));
    Shader["import"]((0, $eb8395013449adec$export$2e2bcd8739ae039));
    Shader["import"]((0, $1820f567078b15b3$export$2e2bcd8739ae039));
}


(0, $875248bb3d03c743$export$2e2bcd8739ae039)((0, $90e78c81ac16d455$export$2e2bcd8739ae039));
var $86a05a55a7292991$var$shaderSourceReg = /^#source\((.*?)\)/;
/**
 * @name clay.createCompositor
 * @function
 * @param {Object} json
 * @param {Object} [opts]
 * @return {clay.compositor.Compositor}
 */ function $86a05a55a7292991$var$createCompositor(json, opts) {
    var compositor = new (0, $ce6f21cdc4b8d599$export$2e2bcd8739ae039)();
    opts = opts || {};
    var lib = {
        textures: {},
        parameters: {}
    };
    var afterLoad = function(shaderLib, textureLib) {
        for(var i = 0; i < json.nodes.length; i++){
            var nodeInfo = json.nodes[i];
            var node = $86a05a55a7292991$var$createNode(nodeInfo, lib, opts);
            if (node) compositor.addNode(node);
        }
    };
    for(var name in json.parameters){
        var paramInfo = json.parameters[name];
        lib.parameters[name] = $86a05a55a7292991$var$convertParameter(paramInfo);
    }
    // TODO load texture asynchronous
    $86a05a55a7292991$var$loadTextures(json, lib, opts, function(textureLib) {
        lib.textures = textureLib;
        afterLoad();
    });
    return compositor;
}
function $86a05a55a7292991$var$createNode(nodeInfo, lib, opts) {
    var type = nodeInfo.type || "filter";
    var shaderSource;
    var inputs;
    var outputs;
    if (type === "filter") {
        var shaderExp = nodeInfo.shader.trim();
        var res = $86a05a55a7292991$var$shaderSourceReg.exec(shaderExp);
        if (res) shaderSource = (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source(res[1].trim());
        else if (shaderExp.charAt(0) === "#") shaderSource = lib.shaders[shaderExp.substr(1)];
        if (!shaderSource) shaderSource = shaderExp;
        if (!shaderSource) return;
    }
    if (nodeInfo.inputs) {
        inputs = {};
        for(var name in nodeInfo.inputs)if (typeof nodeInfo.inputs[name] === "string") inputs[name] = nodeInfo.inputs[name];
        else inputs[name] = {
            node: nodeInfo.inputs[name].node,
            pin: nodeInfo.inputs[name].pin
        };
    }
    if (nodeInfo.outputs) {
        outputs = {};
        for(var name in nodeInfo.outputs){
            var outputInfo = nodeInfo.outputs[name];
            outputs[name] = {};
            if (outputInfo.attachment != null) outputs[name].attachment = outputInfo.attachment;
            if (outputInfo.keepLastFrame != null) outputs[name].keepLastFrame = outputInfo.keepLastFrame;
            if (outputInfo.outputLastFrame != null) outputs[name].outputLastFrame = outputInfo.outputLastFrame;
            if (outputInfo.parameters) outputs[name].parameters = $86a05a55a7292991$var$convertParameter(outputInfo.parameters);
        }
    }
    var node;
    if (type === "scene") node = new (0, $92bccc5d787b00aa$export$2e2bcd8739ae039)({
        name: nodeInfo.name,
        scene: opts.scene,
        camera: opts.camera,
        outputs: outputs
    });
    else if (type === "texture") node = new (0, $7c75c0de70c77426$export$2e2bcd8739ae039)({
        name: nodeInfo.name,
        outputs: outputs
    });
    else node = new (0, $16b620973221d3ca$export$2e2bcd8739ae039)({
        name: nodeInfo.name,
        shader: shaderSource,
        inputs: inputs,
        outputs: outputs
    });
    if (node) {
        if (nodeInfo.parameters) for(var name in nodeInfo.parameters){
            var val = nodeInfo.parameters[name];
            if (typeof val === "string") {
                val = val.trim();
                if (val.charAt(0) === "#") val = lib.textures[val.substr(1)];
                else node.on("beforerender", $86a05a55a7292991$var$createSizeSetHandler(name, $86a05a55a7292991$var$tryConvertExpr(val)));
            } else if (typeof val === "function") node.on("beforerender", val);
            node.setParameter(name, val);
        }
        if (nodeInfo.defines && node.pass) for(var name in nodeInfo.defines){
            var val = nodeInfo.defines[name];
            node.pass.material.define("fragment", name, val);
        }
    }
    return node;
}
function $86a05a55a7292991$var$defaultWidthFunc(width, height) {
    return width;
}
function $86a05a55a7292991$var$defaultHeightFunc(width, height) {
    return height;
}
function $86a05a55a7292991$var$convertParameter(paramInfo) {
    var param = {};
    if (!paramInfo) return param;
    [
        "type",
        "minFilter",
        "magFilter",
        "wrapS",
        "wrapT",
        "flipY",
        "useMipmap"
    ].forEach(function(name) {
        var val = paramInfo[name];
        if (val != null) {
            // Convert string to enum
            if (typeof val === "string") val = (0, $4261427f149675a4$export$2e2bcd8739ae039)[val];
            param[name] = val;
        }
    });
    var sizeScale = paramInfo.scale || 1;
    [
        "width",
        "height"
    ].forEach(function(name) {
        if (paramInfo[name] != null) {
            var val = paramInfo[name];
            if (typeof val === "string") {
                val = val.trim();
                param[name] = $86a05a55a7292991$var$createSizeParser(name, $86a05a55a7292991$var$tryConvertExpr(val), sizeScale);
            } else param[name] = val;
        }
    });
    if (!param.width) param.width = $86a05a55a7292991$var$defaultWidthFunc;
    if (!param.height) param.height = $86a05a55a7292991$var$defaultHeightFunc;
    if (paramInfo.useMipmap != null) param.useMipmap = paramInfo.useMipmap;
    return param;
}
function $86a05a55a7292991$var$loadTextures(json, lib, opts, callback) {
    if (!json.textures) {
        callback({});
        return;
    }
    var textures = {};
    var loading = 0;
    var cbd = false;
    var textureRootPath = opts.textureRootPath;
    (0, $b22fd57b6bfa77fb$export$2e2bcd8739ae039).each(json.textures, function(textureInfo, name) {
        var texture;
        var path = textureInfo.path;
        var parameters = $86a05a55a7292991$var$convertParameter(textureInfo.parameters);
        if (Array.isArray(path) && path.length === 6) {
            if (textureRootPath) path = path.map(function(item) {
                return (0, $b22fd57b6bfa77fb$export$2e2bcd8739ae039).relative2absolute(item, textureRootPath);
            });
            texture = new (0, $8dbf947c9de660dd$export$2e2bcd8739ae039)(parameters);
        } else if (typeof path === "string") {
            if (textureRootPath) path = (0, $b22fd57b6bfa77fb$export$2e2bcd8739ae039).relative2absolute(path, textureRootPath);
            texture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)(parameters);
        } else return;
        texture.load(path);
        loading++;
        texture.once("success", function() {
            textures[name] = texture;
            loading--;
            if (loading === 0) {
                callback(textures);
                cbd = true;
            }
        });
    });
    if (loading === 0 && !cbd) callback(textures);
}
function $86a05a55a7292991$var$createSizeSetHandler(name, exprFunc) {
    return function(renderer) {
        // PENDING viewport size or window size
        var dpr = renderer.getDevicePixelRatio();
        // PENDING If multiply dpr ?
        var width = renderer.getWidth();
        var height = renderer.getHeight();
        var result = exprFunc(width, height, dpr);
        this.setParameter(name, result);
    };
}
function $86a05a55a7292991$var$createSizeParser(name, exprFunc, scale) {
    scale = scale || 1;
    return function(renderer) {
        var dpr = renderer.getDevicePixelRatio();
        var width = renderer.getWidth() * scale;
        var height = renderer.getHeight() * scale;
        return exprFunc(width, height, dpr);
    };
}
function $86a05a55a7292991$var$tryConvertExpr(string) {
    // PENDING
    var exprRes = /^expr\((.*)\)$/.exec(string);
    if (exprRes) try {
        var func = new Function("width", "height", "dpr", "return " + exprRes[1]);
        // Try run t
        func(1, 1);
        return func;
    } catch (e) {
        throw new Error("Invalid expression.");
    }
}
var $86a05a55a7292991$export$2e2bcd8739ae039 = $86a05a55a7292991$var$createCompositor;


var $007ece84dd26a030$export$2e2bcd8739ae039 = (0, $86a05a55a7292991$export$2e2bcd8739ae039);









// Generate halton sequence
// https://en.wikipedia.org/wiki/Halton_sequence
function $7e44f65780f6d68a$var$halton(index, base) {
    var result = 0;
    var f = 1 / base;
    var i = index;
    while(i > 0){
        result = result + f * (i % base);
        i = Math.floor(i / base);
        f = f / base;
    }
    return result;
}
var $7e44f65780f6d68a$export$2e2bcd8739ae039 = $7e44f65780f6d68a$var$halton;


var $88fc9226f9cb9ee5$export$2e2bcd8739ae039 = "@export ecgl.ssao.estimate\n\nuniform sampler2D depthTex;\n\nuniform sampler2D normalTex;\n\nuniform sampler2D noiseTex;\n\nuniform vec2 depthTexSize;\n\nuniform vec2 noiseTexSize;\n\nuniform mat4 projection;\n\nuniform mat4 projectionInv;\n\nuniform mat4 viewInverseTranspose;\n\nuniform vec3 kernel[KERNEL_SIZE];\n\nuniform float radius : 1;\n\nuniform float power : 1;\n\nuniform float bias: 1e-2;\n\nuniform float intensity: 1.0;\n\nvarying vec2 v_Texcoord;\n\nfloat ssaoEstimator(in vec3 originPos, in mat3 kernelBasis) {\n float occlusion = 0.0;\n\n for (int i = 0; i < KERNEL_SIZE; i++) {\n vec3 samplePos = kernel[i];\n#ifdef NORMALTEX_ENABLED\n samplePos = kernelBasis * samplePos;\n#endif\n samplePos = samplePos * radius + originPos;\n\n vec4 texCoord = projection * vec4(samplePos, 1.0);\n texCoord.xy /= texCoord.w;\n\n vec4 depthTexel = texture2D(depthTex, texCoord.xy * 0.5 + 0.5);\n\n float sampleDepth = depthTexel.r * 2.0 - 1.0;\n if (projection[3][3] == 0.0) {\n sampleDepth = projection[3][2] / (sampleDepth * projection[2][3] - projection[2][2]);\n }\n else {\n sampleDepth = (sampleDepth - projection[3][2]) / projection[2][2];\n }\n \n float rangeCheck = smoothstep(0.0, 1.0, radius / abs(originPos.z - sampleDepth));\n occlusion += rangeCheck * step(samplePos.z, sampleDepth - bias);\n }\n#ifdef NORMALTEX_ENABLED\n occlusion = 1.0 - occlusion / float(KERNEL_SIZE);\n#else\n occlusion = 1.0 - clamp((occlusion / float(KERNEL_SIZE) - 0.6) * 2.5, 0.0, 1.0);\n#endif\n return pow(occlusion, power);\n}\n\nvoid main()\n{\n\n vec4 depthTexel = texture2D(depthTex, v_Texcoord);\n\n#ifdef NORMALTEX_ENABLED\n vec4 tex = texture2D(normalTex, v_Texcoord);\n if (dot(tex.rgb, tex.rgb) == 0.0) {\n gl_FragColor = vec4(1.0);\n return;\n }\n vec3 N = tex.rgb * 2.0 - 1.0;\n N = (viewInverseTranspose * vec4(N, 0.0)).xyz;\n\n vec2 noiseTexCoord = depthTexSize / vec2(noiseTexSize) * v_Texcoord;\n vec3 rvec = texture2D(noiseTex, noiseTexCoord).rgb * 2.0 - 1.0;\n vec3 T = normalize(rvec - N * dot(rvec, N));\n vec3 BT = normalize(cross(N, T));\n mat3 kernelBasis = mat3(T, BT, N);\n#else\n if (depthTexel.r > 0.99999) {\n gl_FragColor = vec4(1.0);\n return;\n }\n mat3 kernelBasis;\n#endif\n\n float z = depthTexel.r * 2.0 - 1.0;\n\n vec4 projectedPos = vec4(v_Texcoord * 2.0 - 1.0, z, 1.0);\n vec4 p4 = projectionInv * projectedPos;\n\n vec3 position = p4.xyz / p4.w;\n\n float ao = ssaoEstimator(position, kernelBasis);\n ao = clamp(1.0 - (1.0 - ao) * intensity, 0.0, 1.0);\n gl_FragColor = vec4(vec3(ao), 1.0);\n}\n\n@end\n\n\n@export ecgl.ssao.blur\n#define SHADER_NAME SSAO_BLUR\n\nuniform sampler2D ssaoTexture;\n\n#ifdef NORMALTEX_ENABLED\nuniform sampler2D normalTex;\n#endif\n\nvarying vec2 v_Texcoord;\n\nuniform vec2 textureSize;\nuniform float blurSize : 1.0;\n\nuniform int direction: 0.0;\n\n#ifdef DEPTHTEX_ENABLED\nuniform sampler2D depthTex;\nuniform mat4 projection;\nuniform float depthRange : 0.5;\n\nfloat getLinearDepth(vec2 coord)\n{\n float depth = texture2D(depthTex, coord).r * 2.0 - 1.0;\n return projection[3][2] / (depth * projection[2][3] - projection[2][2]);\n}\n#endif\n\nvoid main()\n{\n float kernel[5];\n kernel[0] = 0.122581;\n kernel[1] = 0.233062;\n kernel[2] = 0.288713;\n kernel[3] = 0.233062;\n kernel[4] = 0.122581;\n\n vec2 off = vec2(0.0);\n if (direction == 0) {\n off[0] = blurSize / textureSize.x;\n }\n else {\n off[1] = blurSize / textureSize.y;\n }\n\n vec2 coord = v_Texcoord;\n\n float sum = 0.0;\n float weightAll = 0.0;\n\n#ifdef NORMALTEX_ENABLED\n vec3 centerNormal = texture2D(normalTex, v_Texcoord).rgb * 2.0 - 1.0;\n#endif\n#if defined(DEPTHTEX_ENABLED)\n float centerDepth = getLinearDepth(v_Texcoord);\n#endif\n\n for (int i = 0; i < 5; i++) {\n vec2 coord = clamp(v_Texcoord + vec2(float(i) - 2.0) * off, vec2(0.0), vec2(1.0));\n\n float w = kernel[i];\n#ifdef NORMALTEX_ENABLED\n vec3 normal = texture2D(normalTex, coord).rgb * 2.0 - 1.0;\n w *= clamp(dot(normal, centerNormal), 0.0, 1.0);\n#endif\n#ifdef DEPTHTEX_ENABLED\n float d = getLinearDepth(coord);\n w *= (1.0 - smoothstep(abs(centerDepth - d) / depthRange, 0.0, 1.0));\n#endif\n\n weightAll += w;\n sum += texture2D(ssaoTexture, coord).r * w;\n }\n\n gl_FragColor = vec4(vec3(sum / weightAll), 1.0);\n}\n\n@end\n";


(0, $90e78c81ac16d455$export$2e2bcd8739ae039).import((0, $88fc9226f9cb9ee5$export$2e2bcd8739ae039));
function $94b0df9603f5d783$var$generateNoiseData(size) {
    var data = new Uint8Array(size * size * 4);
    var n = 0;
    var v3 = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
    for(var i = 0; i < size; i++)for(var j = 0; j < size; j++){
        v3.set(Math.random() * 2 - 1, Math.random() * 2 - 1, 0).normalize();
        data[n++] = (v3.x * 0.5 + 0.5) * 255;
        data[n++] = (v3.y * 0.5 + 0.5) * 255;
        data[n++] = 0;
        data[n++] = 255;
    }
    return data;
}
function $94b0df9603f5d783$var$generateNoiseTexture(size) {
    return new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        pixels: $94b0df9603f5d783$var$generateNoiseData(size),
        wrapS: (0, $4261427f149675a4$export$2e2bcd8739ae039).REPEAT,
        wrapT: (0, $4261427f149675a4$export$2e2bcd8739ae039).REPEAT,
        width: size,
        height: size
    });
}
function $94b0df9603f5d783$var$generateKernel(size, offset, hemisphere) {
    var kernel = new Float32Array(size * 3);
    offset = offset || 0;
    for(var i = 0; i < size; i++){
        var phi = (0, $7e44f65780f6d68a$export$2e2bcd8739ae039)(i + offset, 2) * (hemisphere ? 1 : 2) * Math.PI;
        var theta = (0, $7e44f65780f6d68a$export$2e2bcd8739ae039)(i + offset, 3) * Math.PI;
        var r = Math.random();
        var x = Math.cos(phi) * Math.sin(theta) * r;
        var y = Math.cos(theta) * r;
        var z = Math.sin(phi) * Math.sin(theta) * r;
        kernel[i * 3] = x;
        kernel[i * 3 + 1] = y;
        kernel[i * 3 + 2] = z;
    }
    return kernel; // var kernel = new Float32Array(size * 3);
// var v3 = new Vector3();
// for (var i = 0; i < size; i++) {
//     v3.set(Math.random() * 2 - 1, Math.random() * 2 - 1, Math.random())
//         .normalize().scale(Math.random());
//     kernel[i * 3] = v3.x;
//     kernel[i * 3 + 1] = v3.y;
//     kernel[i * 3 + 2] = v3.z;
// }
// return kernel;
}
function $94b0df9603f5d783$var$SSAOPass(opt) {
    opt = opt || {};
    this._ssaoPass = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("ecgl.ssao.estimate")
    });
    this._blurPass = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("ecgl.ssao.blur")
    });
    this._framebuffer = new (0, $03d0b3c43006f961$export$2e2bcd8739ae039)({
        depthBuffer: false
    });
    this._ssaoTexture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)();
    this._blurTexture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)();
    this._blurTexture2 = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)();
    this._depthTex = opt.depthTexture;
    this._normalTex = opt.normalTexture;
    this.setNoiseSize(4);
    this.setKernelSize(opt.kernelSize || 12);
    if (opt.radius != null) this.setParameter("radius", opt.radius);
    if (opt.power != null) this.setParameter("power", opt.power);
    if (!this._normalTex) {
        this._ssaoPass.material.disableTexture("normalTex");
        this._blurPass.material.disableTexture("normalTex");
    }
    if (!this._depthTex) this._blurPass.material.disableTexture("depthTex");
    this._blurPass.material.setUniform("normalTex", this._normalTex);
    this._blurPass.material.setUniform("depthTex", this._depthTex);
}
$94b0df9603f5d783$var$SSAOPass.prototype.setDepthTexture = function(depthTex) {
    this._depthTex = depthTex;
};
$94b0df9603f5d783$var$SSAOPass.prototype.setNormalTexture = function(normalTex) {
    this._normalTex = normalTex;
    this._ssaoPass.material[normalTex ? "enableTexture" : "disableTexture"]("normalTex"); // Switch between hemisphere and shere kernel.
    this.setKernelSize(this._kernelSize);
};
$94b0df9603f5d783$var$SSAOPass.prototype.update = function(renderer, camera, frame) {
    var width = renderer.getWidth();
    var height = renderer.getHeight();
    var ssaoPass = this._ssaoPass;
    var blurPass = this._blurPass;
    ssaoPass.setUniform("kernel", this._kernels[frame % this._kernels.length]);
    ssaoPass.setUniform("depthTex", this._depthTex);
    if (this._normalTex != null) ssaoPass.setUniform("normalTex", this._normalTex);
    ssaoPass.setUniform("depthTexSize", [
        this._depthTex.width,
        this._depthTex.height
    ]);
    var viewInverseTranspose = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
    (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).transpose(viewInverseTranspose, camera.worldTransform);
    ssaoPass.setUniform("projection", camera.projectionMatrix.array);
    ssaoPass.setUniform("projectionInv", camera.invProjectionMatrix.array);
    ssaoPass.setUniform("viewInverseTranspose", viewInverseTranspose.array);
    var ssaoTexture = this._ssaoTexture;
    var blurTexture = this._blurTexture;
    var blurTexture2 = this._blurTexture2;
    ssaoTexture.width = width / 2;
    ssaoTexture.height = height / 2;
    blurTexture.width = width;
    blurTexture.height = height;
    blurTexture2.width = width;
    blurTexture2.height = height;
    this._framebuffer.attach(ssaoTexture);
    this._framebuffer.bind(renderer);
    renderer.gl.clearColor(1, 1, 1, 1);
    renderer.gl.clear(renderer.gl.COLOR_BUFFER_BIT);
    ssaoPass.render(renderer);
    blurPass.setUniform("textureSize", [
        width / 2,
        height / 2
    ]);
    blurPass.setUniform("projection", camera.projectionMatrix.array);
    this._framebuffer.attach(blurTexture);
    blurPass.setUniform("direction", 0);
    blurPass.setUniform("ssaoTexture", ssaoTexture);
    blurPass.render(renderer);
    this._framebuffer.attach(blurTexture2);
    blurPass.setUniform("textureSize", [
        width,
        height
    ]);
    blurPass.setUniform("direction", 1);
    blurPass.setUniform("ssaoTexture", blurTexture);
    blurPass.render(renderer);
    this._framebuffer.unbind(renderer); // Restore clear
    var clearColor = renderer.clearColor;
    renderer.gl.clearColor(clearColor[0], clearColor[1], clearColor[2], clearColor[3]);
};
$94b0df9603f5d783$var$SSAOPass.prototype.getTargetTexture = function() {
    return this._blurTexture2;
};
$94b0df9603f5d783$var$SSAOPass.prototype.setParameter = function(name, val) {
    if (name === "noiseTexSize") this.setNoiseSize(val);
    else if (name === "kernelSize") this.setKernelSize(val);
    else if (name === "intensity") this._ssaoPass.material.set("intensity", val);
    else this._ssaoPass.setUniform(name, val);
};
$94b0df9603f5d783$var$SSAOPass.prototype.setKernelSize = function(size) {
    this._kernelSize = size;
    this._ssaoPass.material.define("fragment", "KERNEL_SIZE", size);
    this._kernels = this._kernels || [];
    for(var i = 0; i < 30; i++)this._kernels[i] = $94b0df9603f5d783$var$generateKernel(size, i * size, !!this._normalTex);
};
$94b0df9603f5d783$var$SSAOPass.prototype.setNoiseSize = function(size) {
    var texture = this._ssaoPass.getUniform("noiseTex");
    if (!texture) {
        texture = $94b0df9603f5d783$var$generateNoiseTexture(size);
        this._ssaoPass.setUniform("noiseTex", $94b0df9603f5d783$var$generateNoiseTexture(size));
    } else {
        texture.data = $94b0df9603f5d783$var$generateNoiseData(size);
        texture.width = texture.height = size;
        texture.dirty();
    }
    this._ssaoPass.setUniform("noiseTexSize", [
        size,
        size
    ]);
};
$94b0df9603f5d783$var$SSAOPass.prototype.dispose = function(renderer) {
    this._blurTexture.dispose(renderer);
    this._ssaoTexture.dispose(renderer);
    this._blurTexture2.dispose(renderer);
};
var $94b0df9603f5d783$export$2e2bcd8739ae039 = $94b0df9603f5d783$var$SSAOPass;











var $d23fcdaa1f302326$export$2e2bcd8739ae039 = "@export ecgl.ssr.main\n\n#define SHADER_NAME SSR\n#define MAX_ITERATION 20;\n#define SAMPLE_PER_FRAME 5;\n#define TOTAL_SAMPLES 128;\n\nuniform sampler2D sourceTexture;\nuniform sampler2D gBufferTexture1;\nuniform sampler2D gBufferTexture2;\nuniform sampler2D gBufferTexture3;\nuniform samplerCube specularCubemap;\nuniform float specularIntensity: 1;\n\nuniform mat4 projection;\nuniform mat4 projectionInv;\nuniform mat4 toViewSpace;\nuniform mat4 toWorldSpace;\n\nuniform float maxRayDistance: 200;\n\nuniform float pixelStride: 16;\nuniform float pixelStrideZCutoff: 50; \nuniform float screenEdgeFadeStart: 0.9; \nuniform float eyeFadeStart : 0.2; uniform float eyeFadeEnd: 0.8; \nuniform float minGlossiness: 0.2; uniform float zThicknessThreshold: 1;\n\nuniform float nearZ;\nuniform vec2 viewportSize : VIEWPORT_SIZE;\n\nuniform float jitterOffset: 0;\n\nvarying vec2 v_Texcoord;\n\n#ifdef DEPTH_DECODE\n@import clay.util.decode_float\n#endif\n\n#ifdef PHYSICALLY_CORRECT\nuniform sampler2D normalDistribution;\nuniform float sampleOffset: 0;\nuniform vec2 normalDistributionSize;\n\nvec3 transformNormal(vec3 H, vec3 N) {\n vec3 upVector = N.y > 0.999 ? vec3(1.0, 0.0, 0.0) : vec3(0.0, 1.0, 0.0);\n vec3 tangentX = normalize(cross(N, upVector));\n vec3 tangentZ = cross(N, tangentX);\n return normalize(tangentX * H.x + N * H.y + tangentZ * H.z);\n}\nvec3 importanceSampleNormalGGX(float i, float roughness, vec3 N) {\n float p = fract((i + sampleOffset) / float(TOTAL_SAMPLES));\n vec3 H = texture2D(normalDistribution,vec2(roughness, p)).rgb;\n return transformNormal(H, N);\n}\nfloat G_Smith(float g, float ndv, float ndl) {\n float roughness = 1.0 - g;\n float k = roughness * roughness / 2.0;\n float G1V = ndv / (ndv * (1.0 - k) + k);\n float G1L = ndl / (ndl * (1.0 - k) + k);\n return G1L * G1V;\n}\nvec3 F_Schlick(float ndv, vec3 spec) {\n return spec + (1.0 - spec) * pow(1.0 - ndv, 5.0);\n}\n#endif\n\nfloat fetchDepth(sampler2D depthTexture, vec2 uv)\n{\n vec4 depthTexel = texture2D(depthTexture, uv);\n return depthTexel.r * 2.0 - 1.0;\n}\n\nfloat linearDepth(float depth)\n{\n if (projection[3][3] == 0.0) {\n return projection[3][2] / (depth * projection[2][3] - projection[2][2]);\n }\n else {\n return (depth - projection[3][2]) / projection[2][2];\n }\n}\n\nbool rayIntersectDepth(float rayZNear, float rayZFar, vec2 hitPixel)\n{\n if (rayZFar > rayZNear)\n {\n float t = rayZFar; rayZFar = rayZNear; rayZNear = t;\n }\n float cameraZ = linearDepth(fetchDepth(gBufferTexture2, hitPixel));\n return rayZFar <= cameraZ && rayZNear >= cameraZ - zThicknessThreshold;\n}\n\n\nbool traceScreenSpaceRay(\n vec3 rayOrigin, vec3 rayDir, float jitter,\n out vec2 hitPixel, out vec3 hitPoint, out float iterationCount\n)\n{\n float rayLength = ((rayOrigin.z + rayDir.z * maxRayDistance) > -nearZ)\n ? (-nearZ - rayOrigin.z) / rayDir.z : maxRayDistance;\n\n vec3 rayEnd = rayOrigin + rayDir * rayLength;\n\n vec4 H0 = projection * vec4(rayOrigin, 1.0);\n vec4 H1 = projection * vec4(rayEnd, 1.0);\n\n float k0 = 1.0 / H0.w, k1 = 1.0 / H1.w;\n\n vec3 Q0 = rayOrigin * k0, Q1 = rayEnd * k1;\n\n vec2 P0 = (H0.xy * k0 * 0.5 + 0.5) * viewportSize;\n vec2 P1 = (H1.xy * k1 * 0.5 + 0.5) * viewportSize;\n\n P1 += dot(P1 - P0, P1 - P0) < 0.0001 ? 0.01 : 0.0;\n vec2 delta = P1 - P0;\n\n bool permute = false;\n if (abs(delta.x) < abs(delta.y)) {\n permute = true;\n delta = delta.yx;\n P0 = P0.yx;\n P1 = P1.yx;\n }\n float stepDir = sign(delta.x);\n float invdx = stepDir / delta.x;\n\n vec3 dQ = (Q1 - Q0) * invdx;\n float dk = (k1 - k0) * invdx;\n\n vec2 dP = vec2(stepDir, delta.y * invdx);\n\n float strideScaler = 1.0 - min(1.0, -rayOrigin.z / pixelStrideZCutoff);\n float pixStride = 1.0 + strideScaler * pixelStride;\n\n dP *= pixStride; dQ *= pixStride; dk *= pixStride;\n\n vec4 pqk = vec4(P0, Q0.z, k0);\n vec4 dPQK = vec4(dP, dQ.z, dk);\n\n pqk += dPQK * jitter;\n float rayZFar = (dPQK.z * 0.5 + pqk.z) / (dPQK.w * 0.5 + pqk.w);\n float rayZNear;\n\n bool intersect = false;\n\n vec2 texelSize = 1.0 / viewportSize;\n\n iterationCount = 0.0;\n\n for (int i = 0; i < MAX_ITERATION; i++)\n {\n pqk += dPQK;\n\n rayZNear = rayZFar;\n rayZFar = (dPQK.z * 0.5 + pqk.z) / (dPQK.w * 0.5 + pqk.w);\n\n hitPixel = permute ? pqk.yx : pqk.xy;\n hitPixel *= texelSize;\n\n intersect = rayIntersectDepth(rayZNear, rayZFar, hitPixel);\n\n iterationCount += 1.0;\n\n dPQK *= 1.2;\n\n if (intersect) {\n break;\n }\n }\n\n Q0.xy += dQ.xy * iterationCount;\n Q0.z = pqk.z;\n hitPoint = Q0 / pqk.w;\n\n return intersect;\n}\n\nfloat calculateAlpha(\n float iterationCount, float reflectivity,\n vec2 hitPixel, vec3 hitPoint, float dist, vec3 rayDir\n)\n{\n float alpha = clamp(reflectivity, 0.0, 1.0);\n alpha *= 1.0 - (iterationCount / float(MAX_ITERATION));\n vec2 hitPixelNDC = hitPixel * 2.0 - 1.0;\n float maxDimension = min(1.0, max(abs(hitPixelNDC.x), abs(hitPixelNDC.y)));\n alpha *= 1.0 - max(0.0, maxDimension - screenEdgeFadeStart) / (1.0 - screenEdgeFadeStart);\n\n float _eyeFadeStart = eyeFadeStart;\n float _eyeFadeEnd = eyeFadeEnd;\n if (_eyeFadeStart > _eyeFadeEnd) {\n float tmp = _eyeFadeEnd;\n _eyeFadeEnd = _eyeFadeStart;\n _eyeFadeStart = tmp;\n }\n\n float eyeDir = clamp(rayDir.z, _eyeFadeStart, _eyeFadeEnd);\n alpha *= 1.0 - (eyeDir - _eyeFadeStart) / (_eyeFadeEnd - _eyeFadeStart);\n\n alpha *= 1.0 - clamp(dist / maxRayDistance, 0.0, 1.0);\n\n return alpha;\n}\n\n@import clay.util.rand\n\n@import clay.util.rgbm\n\nvoid main()\n{\n vec4 normalAndGloss = texture2D(gBufferTexture1, v_Texcoord);\n\n if (dot(normalAndGloss.rgb, vec3(1.0)) == 0.0) {\n discard;\n }\n\n float g = normalAndGloss.a;\n#if !defined(PHYSICALLY_CORRECT)\n if (g <= minGlossiness) {\n discard;\n }\n#endif\n\n float reflectivity = (g - minGlossiness) / (1.0 - minGlossiness);\n\n vec3 N = normalize(normalAndGloss.rgb * 2.0 - 1.0);\n N = normalize((toViewSpace * vec4(N, 0.0)).xyz);\n\n vec4 projectedPos = vec4(v_Texcoord * 2.0 - 1.0, fetchDepth(gBufferTexture2, v_Texcoord), 1.0);\n vec4 pos = projectionInv * projectedPos;\n vec3 rayOrigin = pos.xyz / pos.w;\n vec3 V = -normalize(rayOrigin);\n\n float ndv = clamp(dot(N, V), 0.0, 1.0);\n float iterationCount;\n float jitter = rand(fract(v_Texcoord + jitterOffset));\n\n#ifdef PHYSICALLY_CORRECT\n vec4 color = vec4(vec3(0.0), 1.0);\n vec4 albedoMetalness = texture2D(gBufferTexture3, v_Texcoord);\n vec3 albedo = albedoMetalness.rgb;\n float m = albedoMetalness.a;\n vec3 diffuseColor = albedo * (1.0 - m);\n vec3 spec = mix(vec3(0.04), albedo, m);\n\n float jitter2 = rand(fract(v_Texcoord)) * float(TOTAL_SAMPLES);\n\n for (int i = 0; i < SAMPLE_PER_FRAME; i++) {\n vec3 H = importanceSampleNormalGGX(float(i) + jitter2, 1.0 - g, N);\n vec3 rayDir = normalize(reflect(-V, H));\n#else\n vec3 rayDir = normalize(reflect(-V, N));\n#endif\n vec2 hitPixel;\n vec3 hitPoint;\n\n bool intersect = traceScreenSpaceRay(rayOrigin, rayDir, jitter, hitPixel, hitPoint, iterationCount);\n\n float dist = distance(rayOrigin, hitPoint);\n\n vec3 hitNormal = texture2D(gBufferTexture1, hitPixel).rgb * 2.0 - 1.0;\n hitNormal = normalize((toViewSpace * vec4(hitNormal, 0.0)).xyz);\n#ifdef PHYSICALLY_CORRECT\n float ndl = clamp(dot(N, rayDir), 0.0, 1.0);\n float vdh = clamp(dot(V, H), 0.0, 1.0);\n float ndh = clamp(dot(N, H), 0.0, 1.0);\n vec3 litTexel = vec3(0.0);\n if (dot(hitNormal, rayDir) < 0.0 && intersect) {\n litTexel = texture2D(sourceTexture, hitPixel).rgb;\n litTexel *= pow(clamp(1.0 - dist / 200.0, 0.0, 1.0), 3.0);\n\n }\n else {\n #ifdef SPECULARCUBEMAP_ENABLED\n vec3 rayDirW = normalize(toWorldSpace * vec4(rayDir, 0.0)).rgb;\n litTexel = RGBMDecode(textureCubeLodEXT(specularCubemap, rayDirW, 0.0), 8.12).rgb * specularIntensity;\n#endif\n }\n color.rgb += ndl * litTexel * (\n F_Schlick(ndl, spec) * G_Smith(g, ndv, ndl) * vdh / (ndh * ndv + 0.001)\n );\n }\n color.rgb /= float(SAMPLE_PER_FRAME);\n#else\n #if !defined(SPECULARCUBEMAP_ENABLED)\n if (dot(hitNormal, rayDir) >= 0.0) {\n discard;\n }\n if (!intersect) {\n discard;\n }\n#endif\n float alpha = clamp(calculateAlpha(iterationCount, reflectivity, hitPixel, hitPoint, dist, rayDir), 0.0, 1.0);\n vec4 color = texture2D(sourceTexture, hitPixel);\n color.rgb *= alpha;\n\n#ifdef SPECULARCUBEMAP_ENABLED\n vec3 rayDirW = normalize(toWorldSpace * vec4(rayDir, 0.0)).rgb;\n alpha = alpha * (intersect ? 1.0 : 0.0);\n float bias = (1.0 -g) * 5.0;\n color.rgb += (1.0 - alpha)\n * RGBMDecode(textureCubeLodEXT(specularCubemap, rayDirW, bias), 8.12).rgb\n * specularIntensity;\n#endif\n\n#endif\n\n gl_FragColor = encodeHDR(color);\n}\n@end\n\n@export ecgl.ssr.blur\n\nuniform sampler2D texture;\nuniform sampler2D gBufferTexture1;\nuniform sampler2D gBufferTexture2;\nuniform mat4 projection;\nuniform float depthRange : 0.05;\n\nvarying vec2 v_Texcoord;\n\nuniform vec2 textureSize;\nuniform float blurSize : 1.0;\n\n#ifdef BLEND\n #ifdef SSAOTEX_ENABLED\nuniform sampler2D ssaoTex;\n #endif\nuniform sampler2D sourceTexture;\n#endif\n\nfloat getLinearDepth(vec2 coord)\n{\n float depth = texture2D(gBufferTexture2, coord).r * 2.0 - 1.0;\n return projection[3][2] / (depth * projection[2][3] - projection[2][2]);\n}\n\n@import clay.util.rgbm\n\n\nvoid main()\n{\n @import clay.compositor.kernel.gaussian_9\n\n vec4 centerNTexel = texture2D(gBufferTexture1, v_Texcoord);\n float g = centerNTexel.a;\n float maxBlurSize = clamp(1.0 - g, 0.0, 1.0) * blurSize;\n#ifdef VERTICAL\n vec2 off = vec2(0.0, maxBlurSize / textureSize.y);\n#else\n vec2 off = vec2(maxBlurSize / textureSize.x, 0.0);\n#endif\n\n vec2 coord = v_Texcoord;\n\n vec4 sum = vec4(0.0);\n float weightAll = 0.0;\n\n vec3 cN = centerNTexel.rgb * 2.0 - 1.0;\n float cD = getLinearDepth(v_Texcoord);\n for (int i = 0; i < 9; i++) {\n vec2 coord = clamp((float(i) - 4.0) * off + v_Texcoord, vec2(0.0), vec2(1.0));\n float w = gaussianKernel[i]\n * clamp(dot(cN, texture2D(gBufferTexture1, coord).rgb * 2.0 - 1.0), 0.0, 1.0);\n float d = getLinearDepth(coord);\n w *= (1.0 - smoothstep(abs(cD - d) / depthRange, 0.0, 1.0));\n\n weightAll += w;\n sum += decodeHDR(texture2D(texture, coord)) * w;\n }\n\n#ifdef BLEND\n float aoFactor = 1.0;\n #ifdef SSAOTEX_ENABLED\n aoFactor = texture2D(ssaoTex, v_Texcoord).r;\n #endif\n gl_FragColor = encodeHDR(\n sum / weightAll * aoFactor + decodeHDR(texture2D(sourceTexture, v_Texcoord))\n );\n#else\n gl_FragColor = encodeHDR(sum / weightAll);\n#endif\n}\n\n@end";


(0, $90e78c81ac16d455$export$2e2bcd8739ae039).import((0, $d23fcdaa1f302326$export$2e2bcd8739ae039));
function $5bb253acedc8b0bc$var$SSRPass(opt) {
    opt = opt || {};
    this._ssrPass = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("ecgl.ssr.main"),
        clearColor: [
            0,
            0,
            0,
            0
        ]
    });
    this._blurPass1 = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("ecgl.ssr.blur"),
        clearColor: [
            0,
            0,
            0,
            0
        ]
    });
    this._blurPass2 = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("ecgl.ssr.blur"),
        clearColor: [
            0,
            0,
            0,
            0
        ]
    });
    this._blendPass = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("clay.compositor.blend")
    });
    this._blendPass.material.disableTexturesAll();
    this._blendPass.material.enableTexture([
        "texture1",
        "texture2"
    ]);
    this._ssrPass.setUniform("gBufferTexture1", opt.normalTexture);
    this._ssrPass.setUniform("gBufferTexture2", opt.depthTexture); // this._ssrPass.setUniform('gBufferTexture3', opt.albedoTexture);
    this._blurPass1.setUniform("gBufferTexture1", opt.normalTexture);
    this._blurPass1.setUniform("gBufferTexture2", opt.depthTexture);
    this._blurPass2.setUniform("gBufferTexture1", opt.normalTexture);
    this._blurPass2.setUniform("gBufferTexture2", opt.depthTexture);
    this._blurPass2.material.define("fragment", "VERTICAL");
    this._blurPass2.material.define("fragment", "BLEND");
    this._ssrTexture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        type: (0, $4261427f149675a4$export$2e2bcd8739ae039).HALF_FLOAT
    });
    this._texture2 = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        type: (0, $4261427f149675a4$export$2e2bcd8739ae039).HALF_FLOAT
    });
    this._texture3 = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        type: (0, $4261427f149675a4$export$2e2bcd8739ae039).HALF_FLOAT
    });
    this._prevTexture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        type: (0, $4261427f149675a4$export$2e2bcd8739ae039).HALF_FLOAT
    });
    this._currentTexture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        type: (0, $4261427f149675a4$export$2e2bcd8739ae039).HALF_FLOAT
    });
    this._frameBuffer = new (0, $03d0b3c43006f961$export$2e2bcd8739ae039)({
        depthBuffer: false
    });
    this._normalDistribution = null;
    this._totalSamples = 256;
    this._samplePerFrame = 4;
    this._ssrPass.material.define("fragment", "SAMPLE_PER_FRAME", this._samplePerFrame);
    this._ssrPass.material.define("fragment", "TOTAL_SAMPLES", this._totalSamples);
    this._downScale = 1;
}
$5bb253acedc8b0bc$var$SSRPass.prototype.setAmbientCubemap = function(specularCubemap, specularIntensity) {
    this._ssrPass.material.set("specularCubemap", specularCubemap);
    this._ssrPass.material.set("specularIntensity", specularIntensity);
    var enableSpecularMap = specularCubemap && specularIntensity;
    this._ssrPass.material[enableSpecularMap ? "enableTexture" : "disableTexture"]("specularCubemap");
};
$5bb253acedc8b0bc$var$SSRPass.prototype.update = function(renderer, camera, sourceTexture, frame) {
    var width = renderer.getWidth();
    var height = renderer.getHeight();
    var ssrTexture = this._ssrTexture;
    var texture2 = this._texture2;
    var texture3 = this._texture3;
    ssrTexture.width = this._prevTexture.width = this._currentTexture.width = width / this._downScale;
    ssrTexture.height = this._prevTexture.height = this._currentTexture.height = height / this._downScale;
    texture2.width = texture3.width = width;
    texture2.height = texture3.height = height;
    var frameBuffer = this._frameBuffer;
    var ssrPass = this._ssrPass;
    var blurPass1 = this._blurPass1;
    var blurPass2 = this._blurPass2;
    var blendPass = this._blendPass;
    var toViewSpace = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
    var toWorldSpace = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
    (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).transpose(toViewSpace, camera.worldTransform);
    (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).transpose(toWorldSpace, camera.viewMatrix);
    ssrPass.setUniform("sourceTexture", sourceTexture);
    ssrPass.setUniform("projection", camera.projectionMatrix.array);
    ssrPass.setUniform("projectionInv", camera.invProjectionMatrix.array);
    ssrPass.setUniform("toViewSpace", toViewSpace.array);
    ssrPass.setUniform("toWorldSpace", toWorldSpace.array);
    ssrPass.setUniform("nearZ", camera.near);
    var percent = frame / this._totalSamples * this._samplePerFrame;
    ssrPass.setUniform("jitterOffset", percent);
    ssrPass.setUniform("sampleOffset", frame * this._samplePerFrame);
    blurPass1.setUniform("textureSize", [
        ssrTexture.width,
        ssrTexture.height
    ]);
    blurPass2.setUniform("textureSize", [
        width,
        height
    ]);
    blurPass2.setUniform("sourceTexture", sourceTexture);
    blurPass1.setUniform("projection", camera.projectionMatrix.array);
    blurPass2.setUniform("projection", camera.projectionMatrix.array);
    frameBuffer.attach(ssrTexture);
    frameBuffer.bind(renderer);
    ssrPass.render(renderer);
    if (this._physicallyCorrect) {
        frameBuffer.attach(this._currentTexture);
        blendPass.setUniform("texture1", this._prevTexture);
        blendPass.setUniform("texture2", ssrTexture);
        blendPass.material.set({
            "weight1": frame >= 1 ? 0.95 : 0,
            "weight2": frame >= 1 ? 0.05 : 1 // weight1: frame >= 1 ? 1 : 0,
        });
        blendPass.render(renderer);
    }
    frameBuffer.attach(texture2);
    blurPass1.setUniform("texture", this._physicallyCorrect ? this._currentTexture : ssrTexture);
    blurPass1.render(renderer);
    frameBuffer.attach(texture3);
    blurPass2.setUniform("texture", texture2);
    blurPass2.render(renderer);
    frameBuffer.unbind(renderer);
    if (this._physicallyCorrect) {
        var tmp = this._prevTexture;
        this._prevTexture = this._currentTexture;
        this._currentTexture = tmp;
    }
};
$5bb253acedc8b0bc$var$SSRPass.prototype.getTargetTexture = function() {
    return this._texture3;
};
$5bb253acedc8b0bc$var$SSRPass.prototype.setParameter = function(name, val) {
    if (name === "maxIteration") this._ssrPass.material.define("fragment", "MAX_ITERATION", val);
    else this._ssrPass.setUniform(name, val);
};
$5bb253acedc8b0bc$var$SSRPass.prototype.setPhysicallyCorrect = function(isPhysicallyCorrect) {
    if (isPhysicallyCorrect) {
        if (!this._normalDistribution) this._normalDistribution = (0, $2d9094f0aba26ce5$export$2e2bcd8739ae039).generateNormalDistribution(64, this._totalSamples);
        this._ssrPass.material.define("fragment", "PHYSICALLY_CORRECT");
        this._ssrPass.material.set("normalDistribution", this._normalDistribution);
        this._ssrPass.material.set("normalDistributionSize", [
            64,
            this._totalSamples
        ]);
    } else this._ssrPass.material.undefine("fragment", "PHYSICALLY_CORRECT");
    this._physicallyCorrect = isPhysicallyCorrect;
};
$5bb253acedc8b0bc$var$SSRPass.prototype.setSSAOTexture = function(texture) {
    var blendPass = this._blurPass2;
    if (texture) {
        blendPass.material.enableTexture("ssaoTex");
        blendPass.material.set("ssaoTex", texture);
    } else blendPass.material.disableTexture("ssaoTex");
};
$5bb253acedc8b0bc$var$SSRPass.prototype.isFinished = function(frame) {
    if (this._physicallyCorrect) return frame > this._totalSamples / this._samplePerFrame;
    else return true;
};
$5bb253acedc8b0bc$var$SSRPass.prototype.dispose = function(renderer) {
    this._ssrTexture.dispose(renderer);
    this._texture2.dispose(renderer);
    this._texture3.dispose(renderer);
    this._prevTexture.dispose(renderer);
    this._currentTexture.dispose(renderer);
    this._frameBuffer.dispose(renderer);
};
var $5bb253acedc8b0bc$export$2e2bcd8739ae039 = $5bb253acedc8b0bc$var$SSRPass;


// Based on https://bl.ocks.org/mbostock/19168c663618b707158
var $d866a746f7133fd7$export$2e2bcd8739ae039 = [
    0.0,
    0.0,
    -0.321585265978,
    -0.154972575841,
    0.458126042375,
    0.188473391593,
    0.842080129861,
    0.527766490688,
    0.147304551086,
    -0.659453822776,
    -0.331943915203,
    -0.940619700594,
    0.0479226680259,
    0.54812163202,
    0.701581552186,
    -0.709825561388,
    -0.295436780218,
    0.940589268233,
    -0.901489676764,
    0.237713156085,
    0.973570876096,
    -0.109899459384,
    -0.866792314779,
    -0.451805525005,
    0.330975007087,
    0.800048655954,
    -0.344275183665,
    0.381779221166,
    -0.386139432542,
    -0.437418421534,
    -0.576478634965,
    -0.0148463392551,
    0.385798197415,
    -0.262426961053,
    -0.666302061145,
    0.682427250835,
    -0.628010632582,
    -0.732836215494,
    0.10163141741,
    -0.987658134403,
    0.711995289051,
    -0.320024291314,
    0.0296005138058,
    0.950296523438,
    0.0130612307608,
    -0.351024443122,
    -0.879596633704,
    -0.10478487883,
    0.435712737232,
    0.504254490347,
    0.779203817497,
    0.206477676721,
    0.388264289969,
    -0.896736162545,
    -0.153106280781,
    -0.629203242522,
    -0.245517550697,
    0.657969239148,
    0.126830499058,
    0.26862328493,
    -0.634888119007,
    -0.302301223431,
    0.617074219636,
    0.779817204925
];



// NormalPass will generate normal and depth data.
// TODO Animation







var $a4c03428396c86a7$export$2e2bcd8739ae039 = "@export ecgl.normal.vertex\n\n@import ecgl.common.transformUniforms\n\n@import ecgl.common.uv.header\n\n@import ecgl.common.attributes\n\nvarying vec3 v_Normal;\nvarying vec3 v_WorldPosition;\n\n@import ecgl.common.normalMap.vertexHeader\n\n@import ecgl.common.vertexAnimation.header\n\nvoid main()\n{\n\n @import ecgl.common.vertexAnimation.main\n\n @import ecgl.common.uv.main\n\n v_Normal = normalize((worldInverseTranspose * vec4(normal, 0.0)).xyz);\n v_WorldPosition = (world * vec4(pos, 1.0)).xyz;\n\n @import ecgl.common.normalMap.vertexMain\n\n gl_Position = worldViewProjection * vec4(pos, 1.0);\n\n}\n\n\n@end\n\n\n@export ecgl.normal.fragment\n\n#define ROUGHNESS_CHANEL 0\n\nuniform bool useBumpMap;\nuniform bool useRoughnessMap;\nuniform bool doubleSide;\nuniform float roughness;\n\n@import ecgl.common.uv.fragmentHeader\n\nvarying vec3 v_Normal;\nvarying vec3 v_WorldPosition;\n\nuniform mat4 viewInverse : VIEWINVERSE;\n\n@import ecgl.common.normalMap.fragmentHeader\n@import ecgl.common.bumpMap.header\n\nuniform sampler2D roughnessMap;\n\nvoid main()\n{\n vec3 N = v_Normal;\n \n bool flipNormal = false;\n if (doubleSide) {\n vec3 eyePos = viewInverse[3].xyz;\n vec3 V = normalize(eyePos - v_WorldPosition);\n\n if (dot(N, V) < 0.0) {\n flipNormal = true;\n }\n }\n\n @import ecgl.common.normalMap.fragmentMain\n\n if (useBumpMap) {\n N = bumpNormal(v_WorldPosition, v_Normal, N);\n }\n\n float g = 1.0 - roughness;\n\n if (useRoughnessMap) {\n float g2 = 1.0 - texture2D(roughnessMap, v_DetailTexcoord)[ROUGHNESS_CHANEL];\n g = clamp(g2 + (g - 0.5) * 2.0, 0.0, 1.0);\n }\n\n if (flipNormal) {\n N = -N;\n }\n\n gl_FragColor.rgb = (N.xyz + 1.0) * 0.5;\n gl_FragColor.a = g;\n}\n@end";


(0, $90e78c81ac16d455$export$2e2bcd8739ae039).import((0, $a4c03428396c86a7$export$2e2bcd8739ae039));
function $10c983493187ae69$var$attachTextureToSlot(renderer, program, symbol, texture, slot) {
    var gl = renderer.gl;
    program.setUniform(gl, "1i", symbol, slot);
    gl.activeTexture(gl.TEXTURE0 + slot); // Maybe texture is not loaded yet;
    if (texture.isRenderable()) texture.bind(renderer);
    else // Bind texture to null
    texture.unbind(renderer);
} // TODO Use globalShader insteadof globalMaterial?
function $10c983493187ae69$var$getBeforeRenderHook(renderer, defaultNormalMap, defaultBumpMap, defaultRoughnessMap, normalMaterial) {
    var previousNormalMap;
    var previousBumpMap;
    var previousRoughnessMap;
    var previousRenderable;
    var gl = renderer.gl;
    return function(renderable, normalMaterial, prevNormalMaterial) {
        // Material not change
        if (previousRenderable && previousRenderable.material === renderable.material) return;
        var material = renderable.material;
        var program = renderable.__program;
        var roughness = material.get("roughness");
        if (roughness == null) roughness = 1;
        var normalMap = material.get("normalMap") || defaultNormalMap;
        var roughnessMap = material.get("roughnessMap");
        var bumpMap = material.get("bumpMap");
        var uvRepeat = material.get("uvRepeat");
        var uvOffset = material.get("uvOffset");
        var detailUvRepeat = material.get("detailUvRepeat");
        var detailUvOffset = material.get("detailUvOffset");
        var useBumpMap = !!bumpMap && material.isTextureEnabled("bumpMap");
        var useRoughnessMap = !!roughnessMap && material.isTextureEnabled("roughnessMap");
        var doubleSide = material.isDefined("fragment", "DOUBLE_SIDED");
        bumpMap = bumpMap || defaultBumpMap;
        roughnessMap = roughnessMap || defaultRoughnessMap;
        if (prevNormalMaterial !== normalMaterial) {
            normalMaterial.set("normalMap", normalMap);
            normalMaterial.set("bumpMap", bumpMap);
            normalMaterial.set("roughnessMap", roughnessMap);
            normalMaterial.set("useBumpMap", useBumpMap);
            normalMaterial.set("useRoughnessMap", useRoughnessMap);
            normalMaterial.set("doubleSide", doubleSide);
            uvRepeat != null && normalMaterial.set("uvRepeat", uvRepeat);
            uvOffset != null && normalMaterial.set("uvOffset", uvOffset);
            detailUvRepeat != null && normalMaterial.set("detailUvRepeat", detailUvRepeat);
            detailUvOffset != null && normalMaterial.set("detailUvOffset", detailUvOffset);
            normalMaterial.set("roughness", roughness);
        } else {
            program.setUniform(gl, "1f", "roughness", roughness);
            if (previousNormalMap !== normalMap) $10c983493187ae69$var$attachTextureToSlot(renderer, program, "normalMap", normalMap, 0);
            if (previousBumpMap !== bumpMap && bumpMap) $10c983493187ae69$var$attachTextureToSlot(renderer, program, "bumpMap", bumpMap, 1);
            if (previousRoughnessMap !== roughnessMap && roughnessMap) $10c983493187ae69$var$attachTextureToSlot(renderer, program, "roughnessMap", roughnessMap, 2);
            if (uvRepeat != null) program.setUniform(gl, "2f", "uvRepeat", uvRepeat);
            if (uvOffset != null) program.setUniform(gl, "2f", "uvOffset", uvOffset);
            if (detailUvRepeat != null) program.setUniform(gl, "2f", "detailUvRepeat", detailUvRepeat);
            if (detailUvOffset != null) program.setUniform(gl, "2f", "detailUvOffset", detailUvOffset);
            program.setUniform(gl, "1i", "useBumpMap", +useBumpMap);
            program.setUniform(gl, "1i", "useRoughnessMap", +useRoughnessMap);
            program.setUniform(gl, "1i", "doubleSide", +doubleSide);
        }
        previousNormalMap = normalMap;
        previousBumpMap = bumpMap;
        previousRoughnessMap = roughnessMap;
        previousRenderable = renderable;
    };
}
function $10c983493187ae69$var$NormalPass(opt) {
    opt = opt || {};
    this._depthTex = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        format: (0, $4261427f149675a4$export$2e2bcd8739ae039).DEPTH_COMPONENT,
        type: (0, $4261427f149675a4$export$2e2bcd8739ae039).UNSIGNED_INT
    });
    this._normalTex = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        type: (0, $4261427f149675a4$export$2e2bcd8739ae039).HALF_FLOAT
    });
    this._framebuffer = new (0, $03d0b3c43006f961$export$2e2bcd8739ae039)();
    this._framebuffer.attach(this._normalTex);
    this._framebuffer.attach(this._depthTex, (0, $03d0b3c43006f961$export$2e2bcd8739ae039).DEPTH_ATTACHMENT);
    this._normalMaterial = new (0, $b70ebca493753aba$export$2e2bcd8739ae039)({
        shader: new (0, $90e78c81ac16d455$export$2e2bcd8739ae039)((0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("ecgl.normal.vertex"), (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("ecgl.normal.fragment"))
    });
    this._normalMaterial.enableTexture([
        "normalMap",
        "bumpMap",
        "roughnessMap"
    ]);
    this._defaultNormalMap = (0, $f6d4d59e8da69524$export$2e2bcd8739ae039).createBlank("#000");
    this._defaultBumpMap = (0, $f6d4d59e8da69524$export$2e2bcd8739ae039).createBlank("#000");
    this._defaultRoughessMap = (0, $f6d4d59e8da69524$export$2e2bcd8739ae039).createBlank("#000");
    this._debugPass = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("clay.compositor.output")
    });
    this._debugPass.setUniform("texture", this._normalTex);
    this._debugPass.material.undefine("fragment", "OUTPUT_ALPHA");
}
$10c983493187ae69$var$NormalPass.prototype.getDepthTexture = function() {
    return this._depthTex;
};
$10c983493187ae69$var$NormalPass.prototype.getNormalTexture = function() {
    return this._normalTex;
};
$10c983493187ae69$var$NormalPass.prototype.update = function(renderer, scene, camera) {
    var width = renderer.getWidth();
    var height = renderer.getHeight();
    var depthTexture = this._depthTex;
    var normalTexture = this._normalTex;
    var normalMaterial = this._normalMaterial;
    depthTexture.width = width;
    depthTexture.height = height;
    normalTexture.width = width;
    normalTexture.height = height;
    var opaqueList = scene.getRenderList(camera).opaque;
    this._framebuffer.bind(renderer);
    renderer.gl.clearColor(0, 0, 0, 0);
    renderer.gl.clear(renderer.gl.COLOR_BUFFER_BIT | renderer.gl.DEPTH_BUFFER_BIT);
    renderer.gl.disable(renderer.gl.BLEND);
    renderer.renderPass(opaqueList, camera, {
        getMaterial: function() {
            return normalMaterial;
        },
        ifRender: function(object) {
            return object.renderNormal;
        },
        beforeRender: $10c983493187ae69$var$getBeforeRenderHook(renderer, this._defaultNormalMap, this._defaultBumpMap, this._defaultRoughessMap, this._normalMaterial),
        sort: renderer.opaqueSortCompare
    });
    this._framebuffer.unbind(renderer);
};
$10c983493187ae69$var$NormalPass.prototype.renderDebug = function(renderer) {
    this._debugPass.render(renderer);
};
$10c983493187ae69$var$NormalPass.prototype.dispose = function(renderer) {
    this._depthTex.dispose(renderer);
    this._normalTex.dispose(renderer);
};
var $10c983493187ae69$export$2e2bcd8739ae039 = $10c983493187ae69$var$NormalPass;









function $7bdf817c2f71b353$var$EdgePass(opt) {
    opt = opt || {};
    this._edgePass = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("ecgl.edge")
    });
    this._edgePass.setUniform("normalTexture", opt.normalTexture);
    this._edgePass.setUniform("depthTexture", opt.depthTexture);
    this._targetTexture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        type: (0, $4261427f149675a4$export$2e2bcd8739ae039).HALF_FLOAT
    });
    this._frameBuffer = new (0, $03d0b3c43006f961$export$2e2bcd8739ae039)();
    this._frameBuffer.attach(this._targetTexture);
}
$7bdf817c2f71b353$var$EdgePass.prototype.update = function(renderer, camera, sourceTexture, frame) {
    var width = renderer.getWidth();
    var height = renderer.getHeight();
    var texture = this._targetTexture;
    texture.width = width;
    texture.height = height;
    var frameBuffer = this._frameBuffer;
    frameBuffer.bind(renderer);
    this._edgePass.setUniform("projectionInv", camera.invProjectionMatrix.array);
    this._edgePass.setUniform("textureSize", [
        width,
        height
    ]);
    this._edgePass.setUniform("texture", sourceTexture);
    this._edgePass.render(renderer);
    frameBuffer.unbind(renderer);
};
$7bdf817c2f71b353$var$EdgePass.prototype.getTargetTexture = function() {
    return this._targetTexture;
};
$7bdf817c2f71b353$var$EdgePass.prototype.setParameter = function(name, val) {
    this._edgePass.setUniform(name, val);
};
$7bdf817c2f71b353$var$EdgePass.prototype.dispose = function(renderer) {
    this._targetTexture.dispose(renderer);
    this._frameBuffer.dispose(renderer);
};
var $7bdf817c2f71b353$export$2e2bcd8739ae039 = $7bdf817c2f71b353$var$EdgePass;


var $2ca27e3b73632ea0$export$2e2bcd8739ae039 = {
    "type": "compositor",
    "nodes": [
        {
            "name": "source",
            "type": "texture",
            "outputs": {
                "color": {}
            }
        },
        {
            "name": "source_half",
            "shader": "#source(clay.compositor.downsample)",
            "inputs": {
                "texture": "source"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0 / 2)",
                        "height": "expr(height * 1.0 / 2)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "textureSize": "expr( [width * 1.0, height * 1.0] )"
            }
        },
        {
            "name": "bright",
            "shader": "#source(clay.compositor.bright)",
            "inputs": {
                "texture": "source_half"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0 / 2)",
                        "height": "expr(height * 1.0 / 2)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "threshold": 2,
                "scale": 4,
                "textureSize": "expr([width * 1.0 / 2, height / 2])"
            }
        },
        {
            "name": "bright_downsample_4",
            "shader": "#source(clay.compositor.downsample)",
            "inputs": {
                "texture": "bright"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0 / 4)",
                        "height": "expr(height * 1.0 / 4)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "textureSize": "expr( [width * 1.0 / 2, height / 2] )"
            }
        },
        {
            "name": "bright_downsample_8",
            "shader": "#source(clay.compositor.downsample)",
            "inputs": {
                "texture": "bright_downsample_4"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0 / 8)",
                        "height": "expr(height * 1.0 / 8)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "textureSize": "expr( [width * 1.0 / 4, height / 4] )"
            }
        },
        {
            "name": "bright_downsample_16",
            "shader": "#source(clay.compositor.downsample)",
            "inputs": {
                "texture": "bright_downsample_8"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0 / 16)",
                        "height": "expr(height * 1.0 / 16)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "textureSize": "expr( [width * 1.0 / 8, height / 8] )"
            }
        },
        {
            "name": "bright_downsample_32",
            "shader": "#source(clay.compositor.downsample)",
            "inputs": {
                "texture": "bright_downsample_16"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0 / 32)",
                        "height": "expr(height * 1.0 / 32)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "textureSize": "expr( [width * 1.0 / 16, height / 16] )"
            }
        },
        {
            "name": "bright_upsample_16_blur_h",
            "shader": "#source(clay.compositor.gaussian_blur)",
            "inputs": {
                "texture": "bright_downsample_32"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0 / 16)",
                        "height": "expr(height * 1.0 / 16)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "blurSize": 1,
                "blurDir": 0.0,
                "textureSize": "expr( [width * 1.0 / 32, height / 32] )"
            }
        },
        {
            "name": "bright_upsample_16_blur_v",
            "shader": "#source(clay.compositor.gaussian_blur)",
            "inputs": {
                "texture": "bright_upsample_16_blur_h"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0 / 16)",
                        "height": "expr(height * 1.0 / 16)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "blurSize": 1,
                "blurDir": 1.0,
                "textureSize": "expr( [width * 1.0 / 16, height * 1.0 / 16] )"
            }
        },
        {
            "name": "bright_upsample_8_blur_h",
            "shader": "#source(clay.compositor.gaussian_blur)",
            "inputs": {
                "texture": "bright_downsample_16"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0 / 8)",
                        "height": "expr(height * 1.0 / 8)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "blurSize": 1,
                "blurDir": 0.0,
                "textureSize": "expr( [width * 1.0 / 16, height * 1.0 / 16] )"
            }
        },
        {
            "name": "bright_upsample_8_blur_v",
            "shader": "#source(clay.compositor.gaussian_blur)",
            "inputs": {
                "texture": "bright_upsample_8_blur_h"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0 / 8)",
                        "height": "expr(height * 1.0 / 8)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "blurSize": 1,
                "blurDir": 1.0,
                "textureSize": "expr( [width * 1.0 / 8, height * 1.0 / 8] )"
            }
        },
        {
            "name": "bright_upsample_8_blend",
            "shader": "#source(clay.compositor.blend)",
            "inputs": {
                "texture1": "bright_upsample_8_blur_v",
                "texture2": "bright_upsample_16_blur_v"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0 / 8)",
                        "height": "expr(height * 1.0 / 8)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "weight1": 0.3,
                "weight2": 0.7
            }
        },
        {
            "name": "bright_upsample_4_blur_h",
            "shader": "#source(clay.compositor.gaussian_blur)",
            "inputs": {
                "texture": "bright_downsample_8"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0 / 4)",
                        "height": "expr(height * 1.0 / 4)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "blurSize": 1,
                "blurDir": 0.0,
                "textureSize": "expr( [width * 1.0 / 8, height * 1.0 / 8] )"
            }
        },
        {
            "name": "bright_upsample_4_blur_v",
            "shader": "#source(clay.compositor.gaussian_blur)",
            "inputs": {
                "texture": "bright_upsample_4_blur_h"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0 / 4)",
                        "height": "expr(height * 1.0 / 4)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "blurSize": 1,
                "blurDir": 1.0,
                "textureSize": "expr( [width * 1.0 / 4, height * 1.0 / 4] )"
            }
        },
        {
            "name": "bright_upsample_4_blend",
            "shader": "#source(clay.compositor.blend)",
            "inputs": {
                "texture1": "bright_upsample_4_blur_v",
                "texture2": "bright_upsample_8_blend"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0 / 4)",
                        "height": "expr(height * 1.0 / 4)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "weight1": 0.3,
                "weight2": 0.7
            }
        },
        {
            "name": "bright_upsample_2_blur_h",
            "shader": "#source(clay.compositor.gaussian_blur)",
            "inputs": {
                "texture": "bright_downsample_4"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0 / 2)",
                        "height": "expr(height * 1.0 / 2)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "blurSize": 1,
                "blurDir": 0.0,
                "textureSize": "expr( [width * 1.0 / 4, height * 1.0 / 4] )"
            }
        },
        {
            "name": "bright_upsample_2_blur_v",
            "shader": "#source(clay.compositor.gaussian_blur)",
            "inputs": {
                "texture": "bright_upsample_2_blur_h"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0 / 2)",
                        "height": "expr(height * 1.0 / 2)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "blurSize": 1,
                "blurDir": 1.0,
                "textureSize": "expr( [width * 1.0 / 2, height * 1.0 / 2] )"
            }
        },
        {
            "name": "bright_upsample_2_blend",
            "shader": "#source(clay.compositor.blend)",
            "inputs": {
                "texture1": "bright_upsample_2_blur_v",
                "texture2": "bright_upsample_4_blend"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0 / 2)",
                        "height": "expr(height * 1.0 / 2)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "weight1": 0.3,
                "weight2": 0.7
            }
        },
        {
            "name": "bright_upsample_full_blur_h",
            "shader": "#source(clay.compositor.gaussian_blur)",
            "inputs": {
                "texture": "bright"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0)",
                        "height": "expr(height * 1.0)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "blurSize": 1,
                "blurDir": 0.0,
                "textureSize": "expr( [width * 1.0 / 2, height * 1.0 / 2] )"
            }
        },
        {
            "name": "bright_upsample_full_blur_v",
            "shader": "#source(clay.compositor.gaussian_blur)",
            "inputs": {
                "texture": "bright_upsample_full_blur_h"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0)",
                        "height": "expr(height * 1.0)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "blurSize": 1,
                "blurDir": 1.0,
                "textureSize": "expr( [width * 1.0, height * 1.0] )"
            }
        },
        {
            "name": "bloom_composite",
            "shader": "#source(clay.compositor.blend)",
            "inputs": {
                "texture1": "bright_upsample_full_blur_v",
                "texture2": "bright_upsample_2_blend"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0)",
                        "height": "expr(height * 1.0)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "weight1": 0.3,
                "weight2": 0.7
            }
        },
        {
            "name": "coc",
            "shader": "#source(ecgl.dof.coc)",
            "outputs": {
                "color": {
                    "parameters": {
                        "minFilter": "NEAREST",
                        "magFilter": "NEAREST",
                        "width": "expr(width * 1.0)",
                        "height": "expr(height * 1.0)"
                    }
                }
            },
            "parameters": {
                "focalDist": 50,
                "focalRange": 30
            }
        },
        {
            "name": "dof_far_blur",
            "shader": "#source(ecgl.dof.diskBlur)",
            "inputs": {
                "texture": "source",
                "coc": "coc"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0)",
                        "height": "expr(height * 1.0)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "textureSize": "expr( [width * 1.0, height * 1.0] )"
            }
        },
        {
            "name": "dof_near_blur",
            "shader": "#source(ecgl.dof.diskBlur)",
            "inputs": {
                "texture": "source",
                "coc": "coc"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0)",
                        "height": "expr(height * 1.0)",
                        "type": "HALF_FLOAT"
                    }
                }
            },
            "parameters": {
                "textureSize": "expr( [width * 1.0, height * 1.0] )"
            },
            "defines": {
                "BLUR_NEARFIELD": null
            }
        },
        {
            "name": "dof_coc_blur",
            "shader": "#source(ecgl.dof.diskBlur)",
            "inputs": {
                "texture": "coc"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "minFilter": "NEAREST",
                        "magFilter": "NEAREST",
                        "width": "expr(width * 1.0)",
                        "height": "expr(height * 1.0)"
                    }
                }
            },
            "parameters": {
                "textureSize": "expr( [width * 1.0, height * 1.0] )"
            },
            "defines": {
                "BLUR_COC": null
            }
        },
        {
            "name": "dof_composite",
            "shader": "#source(ecgl.dof.composite)",
            "inputs": {
                "original": "source",
                "blurred": "dof_far_blur",
                "nearfield": "dof_near_blur",
                "coc": "coc",
                "nearcoc": "dof_coc_blur"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0)",
                        "height": "expr(height * 1.0)",
                        "type": "HALF_FLOAT"
                    }
                }
            }
        },
        {
            "name": "composite",
            "shader": "#source(clay.compositor.hdr.composite)",
            "inputs": {
                "texture": "source",
                "bloom": "bloom_composite"
            },
            "outputs": {
                "color": {
                    "parameters": {
                        "width": "expr(width * 1.0)",
                        "height": "expr(height * 1.0)"
                    }
                }
            },
            "defines": {
            }
        },
        {
            "name": "FXAA",
            "shader": "#source(clay.compositor.fxaa)",
            "inputs": {
                "texture": "composite"
            }
        }
    ]
};











var $0018109de0c34966$export$2e2bcd8739ae039 = "@export ecgl.dof.coc\n\nuniform sampler2D depth;\n\nuniform float zNear: 0.1;\nuniform float zFar: 2000;\n\nuniform float focalDistance: 3;\nuniform float focalRange: 1;\nuniform float focalLength: 30;\nuniform float fstop: 2.8;\n\nvarying vec2 v_Texcoord;\n\n@import clay.util.encode_float\n\nvoid main()\n{\n float z = texture2D(depth, v_Texcoord).r * 2.0 - 1.0;\n\n float dist = 2.0 * zNear * zFar / (zFar + zNear - z * (zFar - zNear));\n\n float aperture = focalLength / fstop;\n\n float coc;\n\n float uppper = focalDistance + focalRange;\n float lower = focalDistance - focalRange;\n if (dist <= uppper && dist >= lower) {\n coc = 0.5;\n }\n else {\n float focalAdjusted = dist > uppper ? uppper : lower;\n\n coc = abs(aperture * (focalLength * (dist - focalAdjusted)) / (dist * (focalAdjusted - focalLength)));\n coc = clamp(coc, 0.0, 2.0) / 2.00001;\n\n if (dist < lower) {\n coc = -coc;\n }\n coc = coc * 0.5 + 0.5;\n }\n\n gl_FragColor = encodeFloat(coc);\n}\n@end\n\n\n@export ecgl.dof.composite\n\n#define DEBUG 0\n\nuniform sampler2D original;\nuniform sampler2D blurred;\nuniform sampler2D nearfield;\nuniform sampler2D coc;\nuniform sampler2D nearcoc;\nvarying vec2 v_Texcoord;\n\n@import clay.util.rgbm\n@import clay.util.float\n\nvoid main()\n{\n vec4 blurredColor = texture2D(blurred, v_Texcoord);\n vec4 originalColor = texture2D(original, v_Texcoord);\n\n float fCoc = decodeFloat(texture2D(coc, v_Texcoord));\n\n fCoc = abs(fCoc * 2.0 - 1.0);\n\n float weight = smoothstep(0.0, 1.0, fCoc);\n \n#ifdef NEARFIELD_ENABLED\n vec4 nearfieldColor = texture2D(nearfield, v_Texcoord);\n float fNearCoc = decodeFloat(texture2D(nearcoc, v_Texcoord));\n fNearCoc = abs(fNearCoc * 2.0 - 1.0);\n\n gl_FragColor = encodeHDR(\n mix(\n nearfieldColor, mix(originalColor, blurredColor, weight),\n pow(1.0 - fNearCoc, 4.0)\n )\n );\n#else\n gl_FragColor = encodeHDR(mix(originalColor, blurredColor, weight));\n#endif\n\n}\n\n@end\n\n\n\n@export ecgl.dof.diskBlur\n\n#define POISSON_KERNEL_SIZE 16;\n\nuniform sampler2D texture;\nuniform sampler2D coc;\nvarying vec2 v_Texcoord;\n\nuniform float blurRadius : 10.0;\nuniform vec2 textureSize : [512.0, 512.0];\n\nuniform vec2 poissonKernel[POISSON_KERNEL_SIZE];\n\nuniform float percent;\n\nfloat nrand(const in vec2 n) {\n return fract(sin(dot(n.xy ,vec2(12.9898,78.233))) * 43758.5453);\n}\n\n@import clay.util.rgbm\n@import clay.util.float\n\n\nvoid main()\n{\n vec2 offset = blurRadius / textureSize;\n\n float rnd = 6.28318 * nrand(v_Texcoord + 0.07 * percent );\n float cosa = cos(rnd);\n float sina = sin(rnd);\n vec4 basis = vec4(cosa, -sina, sina, cosa);\n\n#if !defined(BLUR_NEARFIELD) && !defined(BLUR_COC)\n offset *= abs(decodeFloat(texture2D(coc, v_Texcoord)) * 2.0 - 1.0);\n#endif\n\n#ifdef BLUR_COC\n float cocSum = 0.0;\n#else\n vec4 color = vec4(0.0);\n#endif\n\n\n float weightSum = 0.0;\n\n for (int i = 0; i < POISSON_KERNEL_SIZE; i++) {\n vec2 ofs = poissonKernel[i];\n\n ofs = vec2(dot(ofs, basis.xy), dot(ofs, basis.zw));\n\n vec2 uv = v_Texcoord + ofs * offset;\n vec4 texel = texture2D(texture, uv);\n\n float w = 1.0;\n#ifdef BLUR_COC\n float fCoc = decodeFloat(texel) * 2.0 - 1.0;\n cocSum += clamp(fCoc, -1.0, 0.0) * w;\n#else\n texel = texel;\n #if !defined(BLUR_NEARFIELD)\n float fCoc = decodeFloat(texture2D(coc, uv)) * 2.0 - 1.0;\n w *= abs(fCoc);\n #endif\n texel.rgb *= texel.a;\n color += texel * w;\n#endif\n\n weightSum += w;\n }\n\n#ifdef BLUR_COC\n gl_FragColor = encodeFloat(clamp(cocSum / weightSum, -1.0, 0.0) * 0.5 + 0.5);\n#else\n color /= weightSum;\n color.rgb /= (color.a + 0.0001);\n gl_FragColor = color;\n#endif\n}\n\n@end";


var $e523d9f600c635a8$export$2e2bcd8739ae039 = "@export ecgl.edge\n\nuniform sampler2D texture;\n\nuniform sampler2D normalTexture;\nuniform sampler2D depthTexture;\n\nuniform mat4 projectionInv;\n\nuniform vec2 textureSize;\n\nuniform vec4 edgeColor: [0,0,0,0.8];\n\nvarying vec2 v_Texcoord;\n\nvec3 packColor(vec2 coord) {\n float z = texture2D(depthTexture, coord).r * 2.0 - 1.0;\n vec4 p = vec4(v_Texcoord * 2.0 - 1.0, z, 1.0);\n vec4 p4 = projectionInv * p;\n\n return vec3(\n texture2D(normalTexture, coord).rg,\n -p4.z / p4.w / 5.0\n );\n}\n\nvoid main() {\n vec2 cc = v_Texcoord;\n vec3 center = packColor(cc);\n\n float size = clamp(1.0 - (center.z - 10.0) / 100.0, 0.0, 1.0) * 0.5;\n float dx = size / textureSize.x;\n float dy = size / textureSize.y;\n\n vec2 coord;\n vec3 topLeft = packColor(cc+vec2(-dx, -dy));\n vec3 top = packColor(cc+vec2(0.0, -dy));\n vec3 topRight = packColor(cc+vec2(dx, -dy));\n vec3 left = packColor(cc+vec2(-dx, 0.0));\n vec3 right = packColor(cc+vec2(dx, 0.0));\n vec3 bottomLeft = packColor(cc+vec2(-dx, dy));\n vec3 bottom = packColor(cc+vec2(0.0, dy));\n vec3 bottomRight = packColor(cc+vec2(dx, dy));\n\n vec3 v = -topLeft-2.0*top-topRight+bottomLeft+2.0*bottom+bottomRight;\n vec3 h = -bottomLeft-2.0*left-topLeft+bottomRight+2.0*right+topRight;\n\n float edge = sqrt(dot(h, h) + dot(v, v));\n\n edge = smoothstep(0.8, 1.0, edge);\n\n gl_FragColor = mix(texture2D(texture, v_Texcoord), vec4(edgeColor.rgb, 1.0), edgeColor.a * edge);\n}\n@end";


(0, $90e78c81ac16d455$export$2e2bcd8739ae039)["import"]((0, $330a95c2ecf6b50f$export$2e2bcd8739ae039));
(0, $90e78c81ac16d455$export$2e2bcd8739ae039)["import"]((0, $cf2a6ceecb069b92$export$2e2bcd8739ae039));
(0, $90e78c81ac16d455$export$2e2bcd8739ae039)["import"]((0, $86ddf9e3bd2c60ba$export$2e2bcd8739ae039));
(0, $90e78c81ac16d455$export$2e2bcd8739ae039)["import"]((0, $6f326837d6cc41ec$export$2e2bcd8739ae039));
(0, $90e78c81ac16d455$export$2e2bcd8739ae039)["import"]((0, $4b3a40e6ffaa9c0e$export$2e2bcd8739ae039));
(0, $90e78c81ac16d455$export$2e2bcd8739ae039)["import"]((0, $2592197a7615eeb4$export$2e2bcd8739ae039));
(0, $90e78c81ac16d455$export$2e2bcd8739ae039)["import"]((0, $c7da7a62b2d953a4$export$2e2bcd8739ae039));
(0, $90e78c81ac16d455$export$2e2bcd8739ae039)["import"]((0, $eb8395013449adec$export$2e2bcd8739ae039));
(0, $90e78c81ac16d455$export$2e2bcd8739ae039)["import"]((0, $1820f567078b15b3$export$2e2bcd8739ae039));
(0, $90e78c81ac16d455$export$2e2bcd8739ae039)["import"]((0, $0018109de0c34966$export$2e2bcd8739ae039));
(0, $90e78c81ac16d455$export$2e2bcd8739ae039)["import"]((0, $e523d9f600c635a8$export$2e2bcd8739ae039));
function $8293118d0e603f9a$var$makeCommonOutputs(getWidth, getHeight) {
    return {
        color: {
            parameters: {
                width: getWidth,
                height: getHeight
            }
        }
    };
}
var $8293118d0e603f9a$var$FINAL_NODES_CHAIN = [
    "composite",
    "FXAA"
];
function $8293118d0e603f9a$var$EffectCompositor() {
    this._width;
    this._height;
    this._dpr;
    this._sourceTexture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        type: (0, $4261427f149675a4$export$2e2bcd8739ae039).HALF_FLOAT
    });
    this._depthTexture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        format: (0, $4261427f149675a4$export$2e2bcd8739ae039).DEPTH_COMPONENT,
        type: (0, $4261427f149675a4$export$2e2bcd8739ae039).UNSIGNED_INT
    });
    this._framebuffer = new (0, $03d0b3c43006f961$export$2e2bcd8739ae039)();
    this._framebuffer.attach(this._sourceTexture);
    this._framebuffer.attach(this._depthTexture, (0, $03d0b3c43006f961$export$2e2bcd8739ae039).DEPTH_ATTACHMENT);
    this._normalPass = new (0, $10c983493187ae69$export$2e2bcd8739ae039)();
    this._compositor = (0, $007ece84dd26a030$export$2e2bcd8739ae039)((0, $2ca27e3b73632ea0$export$2e2bcd8739ae039));
    var sourceNode = this._compositor.getNodeByName("source");
    sourceNode.texture = this._sourceTexture;
    var cocNode = this._compositor.getNodeByName("coc");
    this._sourceNode = sourceNode;
    this._cocNode = cocNode;
    this._compositeNode = this._compositor.getNodeByName("composite");
    this._fxaaNode = this._compositor.getNodeByName("FXAA");
    this._dofBlurNodes = [
        "dof_far_blur",
        "dof_near_blur",
        "dof_coc_blur"
    ].map(function(name) {
        return this._compositor.getNodeByName(name);
    }, this);
    this._dofBlurKernel = 0;
    this._dofBlurKernelSize = new Float32Array(0);
    this._finalNodesChain = $8293118d0e603f9a$var$FINAL_NODES_CHAIN.map(function(name) {
        return this._compositor.getNodeByName(name);
    }, this);
    var gBufferObj = {
        normalTexture: this._normalPass.getNormalTexture(),
        depthTexture: this._normalPass.getDepthTexture()
    };
    this._ssaoPass = new (0, $94b0df9603f5d783$export$2e2bcd8739ae039)(gBufferObj);
    this._ssrPass = new (0, $5bb253acedc8b0bc$export$2e2bcd8739ae039)(gBufferObj);
    this._edgePass = new (0, $7bdf817c2f71b353$export$2e2bcd8739ae039)(gBufferObj);
}
$8293118d0e603f9a$var$EffectCompositor.prototype.resize = function(width, height, dpr) {
    dpr = dpr || 1;
    var width = width * dpr;
    var height = height * dpr;
    var sourceTexture = this._sourceTexture;
    var depthTexture = this._depthTexture;
    sourceTexture.width = width;
    sourceTexture.height = height;
    depthTexture.width = width;
    depthTexture.height = height;
    var rendererMock = {
        getWidth: function() {
            return width;
        },
        getHeight: function() {
            return height;
        },
        getDevicePixelRatio: function() {
            return dpr;
        }
    };
    function wrapCallback(obj, key) {
        if (typeof obj[key] === "function") {
            var oldFunc = obj[key].__original || obj[key]; // Use viewport width/height instead of renderer width/height
            obj[key] = function(renderer) {
                return oldFunc.call(this, rendererMock);
            };
            obj[key].__original = oldFunc;
        }
    }
    this._compositor.nodes.forEach(function(node) {
        for(var outKey in node.outputs){
            var parameters = node.outputs[outKey].parameters;
            if (parameters) {
                wrapCallback(parameters, "width");
                wrapCallback(parameters, "height");
            }
        }
        for(var paramKey in node.parameters)wrapCallback(node.parameters, paramKey);
    });
    this._width = width;
    this._height = height;
    this._dpr = dpr;
};
$8293118d0e603f9a$var$EffectCompositor.prototype.getWidth = function() {
    return this._width;
};
$8293118d0e603f9a$var$EffectCompositor.prototype.getHeight = function() {
    return this._height;
};
$8293118d0e603f9a$var$EffectCompositor.prototype._ifRenderNormalPass = function() {
    return this._enableSSAO || this._enableEdge || this._enableSSR;
};
$8293118d0e603f9a$var$EffectCompositor.prototype._getPrevNode = function(node) {
    var idx = $8293118d0e603f9a$var$FINAL_NODES_CHAIN.indexOf(node.name) - 1;
    var prevNode = this._finalNodesChain[idx];
    while(prevNode && !this._compositor.getNodeByName(prevNode.name)){
        idx -= 1;
        prevNode = this._finalNodesChain[idx];
    }
    return prevNode;
};
$8293118d0e603f9a$var$EffectCompositor.prototype._getNextNode = function(node) {
    var idx = $8293118d0e603f9a$var$FINAL_NODES_CHAIN.indexOf(node.name) + 1;
    var nextNode = this._finalNodesChain[idx];
    while(nextNode && !this._compositor.getNodeByName(nextNode.name)){
        idx += 1;
        nextNode = this._finalNodesChain[idx];
    }
    return nextNode;
};
$8293118d0e603f9a$var$EffectCompositor.prototype._addChainNode = function(node) {
    var prevNode = this._getPrevNode(node);
    var nextNode = this._getNextNode(node);
    if (!prevNode) return;
    node.inputs.texture = prevNode.name;
    if (nextNode) {
        node.outputs = $8293118d0e603f9a$var$makeCommonOutputs(this.getWidth.bind(this), this.getHeight.bind(this));
        nextNode.inputs.texture = node.name;
    } else node.outputs = null;
    this._compositor.addNode(node);
};
$8293118d0e603f9a$var$EffectCompositor.prototype._removeChainNode = function(node) {
    var prevNode = this._getPrevNode(node);
    var nextNode = this._getNextNode(node);
    if (!prevNode) return;
    if (nextNode) {
        prevNode.outputs = $8293118d0e603f9a$var$makeCommonOutputs(this.getWidth.bind(this), this.getHeight.bind(this));
        nextNode.inputs.texture = prevNode.name;
    } else prevNode.outputs = null;
    this._compositor.removeNode(node);
};
/**
 * Update normal
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.updateNormal = function(renderer, scene, camera, frame) {
    if (this._ifRenderNormalPass()) this._normalPass.update(renderer, scene, camera);
};
/**
 * Render SSAO after render the scene, before compositing
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.updateSSAO = function(renderer, scene, camera, frame) {
    this._ssaoPass.update(renderer, camera, frame);
};
/**
 * Enable SSAO effect
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.enableSSAO = function() {
    this._enableSSAO = true;
};
/**
 * Disable SSAO effect
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.disableSSAO = function() {
    this._enableSSAO = false;
};
/**
 * Enable SSR effect
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.enableSSR = function() {
    this._enableSSR = true; // this._normalPass.enableTargetTexture3 = true;
};
/**
 * Disable SSR effect
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.disableSSR = function() {
    this._enableSSR = false; // this._normalPass.enableTargetTexture3 = false;
};
/**
 * Render SSAO after render the scene, before compositing
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.getSSAOTexture = function() {
    return this._ssaoPass.getTargetTexture();
};
/**
 * @return {clay.FrameBuffer}
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.getSourceFrameBuffer = function() {
    return this._framebuffer;
};
/**
 * @return {clay.Texture2D}
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.getSourceTexture = function() {
    return this._sourceTexture;
};
/**
 * Disable fxaa effect
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.disableFXAA = function() {
    this._removeChainNode(this._fxaaNode);
};
/**
 * Enable fxaa effect
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.enableFXAA = function() {
    this._addChainNode(this._fxaaNode);
};
/**
 * Enable bloom effect
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.enableBloom = function() {
    this._compositeNode.inputs.bloom = "bloom_composite";
    this._compositor.dirty();
};
/**
 * Disable bloom effect
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.disableBloom = function() {
    this._compositeNode.inputs.bloom = null;
    this._compositor.dirty();
};
/**
 * Enable depth of field effect
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.enableDOF = function() {
    this._compositeNode.inputs.texture = "dof_composite";
    this._compositor.dirty();
};
/**
 * Disable depth of field effect
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.disableDOF = function() {
    this._compositeNode.inputs.texture = "source";
    this._compositor.dirty();
};
/**
 * Enable color correction
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.enableColorCorrection = function() {
    this._compositeNode.define("COLOR_CORRECTION");
    this._enableColorCorrection = true;
};
/**
 * Disable color correction
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.disableColorCorrection = function() {
    this._compositeNode.undefine("COLOR_CORRECTION");
    this._enableColorCorrection = false;
};
/**
 * Enable edge detection
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.enableEdge = function() {
    this._enableEdge = true;
};
/**
 * Disable edge detection
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.disableEdge = function() {
    this._enableEdge = false;
};
/**
 * Set bloom intensity
 * @param {number} value
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.setBloomIntensity = function(value) {
    this._compositeNode.setParameter("bloomIntensity", value);
};
$8293118d0e603f9a$var$EffectCompositor.prototype.setSSAOParameter = function(name, value) {
    switch(name){
        case "quality":
            // PENDING
            var kernelSize = {
                low: 6,
                medium: 12,
                high: 32,
                ultra: 62
            }[value] || 12;
            this._ssaoPass.setParameter("kernelSize", kernelSize);
            break;
        case "radius":
            this._ssaoPass.setParameter(name, value);
            this._ssaoPass.setParameter("bias", value / 200);
            break;
        case "intensity":
            this._ssaoPass.setParameter(name, value);
            break;
        default:
    }
};
$8293118d0e603f9a$var$EffectCompositor.prototype.setDOFParameter = function(name, value) {
    switch(name){
        case "focalDistance":
        case "focalRange":
        case "fstop":
            this._cocNode.setParameter(name, value);
            break;
        case "blurRadius":
            for(var i = 0; i < this._dofBlurNodes.length; i++)this._dofBlurNodes[i].setParameter("blurRadius", value);
            break;
        case "quality":
            var kernelSize = {
                low: 4,
                medium: 8,
                high: 16,
                ultra: 32
            }[value] || 8;
            this._dofBlurKernelSize = kernelSize;
            for(var i = 0; i < this._dofBlurNodes.length; i++)this._dofBlurNodes[i].pass.material.define("POISSON_KERNEL_SIZE", kernelSize);
            this._dofBlurKernel = new Float32Array(kernelSize * 2);
            break;
        default:
    }
};
$8293118d0e603f9a$var$EffectCompositor.prototype.setSSRParameter = function(name, value) {
    if (value == null) return;
    switch(name){
        case "quality":
            // PENDING
            var maxIteration = {
                low: 10,
                medium: 15,
                high: 30,
                ultra: 80
            }[value] || 20;
            var pixelStride = {
                low: 32,
                medium: 16,
                high: 8,
                ultra: 4
            }[value] || 16;
            this._ssrPass.setParameter("maxIteration", maxIteration);
            this._ssrPass.setParameter("pixelStride", pixelStride);
            break;
        case "maxRoughness":
            this._ssrPass.setParameter("minGlossiness", Math.max(Math.min(1.0 - value, 1.0), 0.0));
            break;
        case "physical":
            this.setPhysicallyCorrectSSR(value);
            break;
        default:
            console.warn("Unkown SSR parameter " + name);
    }
};
$8293118d0e603f9a$var$EffectCompositor.prototype.setPhysicallyCorrectSSR = function(physical) {
    this._ssrPass.setPhysicallyCorrect(physical);
};
/**
 * Set color of edge
 */ $8293118d0e603f9a$var$EffectCompositor.prototype.setEdgeColor = function(value) {
    var color = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(value);
    this._edgePass.setParameter("edgeColor", color);
};
$8293118d0e603f9a$var$EffectCompositor.prototype.setExposure = function(value) {
    this._compositeNode.setParameter("exposure", Math.pow(2, value));
};
$8293118d0e603f9a$var$EffectCompositor.prototype.setColorLookupTexture = function(image, api) {
    this._compositeNode.pass.material.setTextureImage("lut", this._enableColorCorrection ? image : "none", api, {
        minFilter: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Texture.NEAREST,
        magFilter: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Texture.NEAREST,
        flipY: false
    });
};
$8293118d0e603f9a$var$EffectCompositor.prototype.setColorCorrection = function(type, value) {
    this._compositeNode.setParameter(type, value);
};
$8293118d0e603f9a$var$EffectCompositor.prototype.isSSREnabled = function() {
    return this._enableSSR;
};
$8293118d0e603f9a$var$EffectCompositor.prototype.composite = function(renderer, scene, camera, framebuffer, frame) {
    var sourceTexture = this._sourceTexture;
    var targetTexture = sourceTexture;
    if (this._enableEdge) {
        this._edgePass.update(renderer, camera, sourceTexture, frame);
        sourceTexture = targetTexture = this._edgePass.getTargetTexture();
    }
    if (this._enableSSR) {
        this._ssrPass.update(renderer, camera, sourceTexture, frame);
        targetTexture = this._ssrPass.getTargetTexture();
        this._ssrPass.setSSAOTexture(this._enableSSAO ? this._ssaoPass.getTargetTexture() : null); // var lights = scene.getLights();
    // for (var i = 0; i < lights.length; i++) {
    //     if (lights[i].cubemap) {
    //         this._ssrPass.setAmbientCubemap(lights[i].cubemap, lights[i].intensity);
    //     }
    // }
    }
    this._sourceNode.texture = targetTexture;
    this._cocNode.setParameter("depth", this._depthTexture);
    var blurKernel = this._dofBlurKernel;
    var blurKernelSize = this._dofBlurKernelSize;
    var frameAll = Math.floor((0, $d866a746f7133fd7$export$2e2bcd8739ae039).length / 2 / blurKernelSize);
    var kernelOffset = frame % frameAll;
    for(var i = 0; i < blurKernelSize * 2; i++)blurKernel[i] = (0, $d866a746f7133fd7$export$2e2bcd8739ae039)[i + kernelOffset * blurKernelSize * 2];
    for(var i = 0; i < this._dofBlurNodes.length; i++){
        this._dofBlurNodes[i].setParameter("percent", frame / 30.0);
        this._dofBlurNodes[i].setParameter("poissonKernel", blurKernel);
    }
    this._cocNode.setParameter("zNear", camera.near);
    this._cocNode.setParameter("zFar", camera.far);
    this._compositor.render(renderer, framebuffer);
};
$8293118d0e603f9a$var$EffectCompositor.prototype.dispose = function(renderer) {
    this._sourceTexture.dispose(renderer);
    this._depthTexture.dispose(renderer);
    this._framebuffer.dispose(renderer);
    this._compositor.dispose(renderer);
    this._normalPass.dispose(renderer);
    this._ssaoPass.dispose(renderer);
};
var $8293118d0e603f9a$export$2e2bcd8739ae039 = $8293118d0e603f9a$var$EffectCompositor;


// Temporal Super Sample for static Scene






function $793673d49d8e18cc$var$TemporalSuperSampling(frames) {
    var haltonSequence = [];
    for(var i = 0; i < 30; i++)haltonSequence.push([
        (0, $7e44f65780f6d68a$export$2e2bcd8739ae039)(i, 2),
        (0, $7e44f65780f6d68a$export$2e2bcd8739ae039)(i, 3)
    ]);
    this._haltonSequence = haltonSequence;
    this._frame = 0;
    this._sourceTex = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)();
    this._sourceFb = new (0, $03d0b3c43006f961$export$2e2bcd8739ae039)();
    this._sourceFb.attach(this._sourceTex); // Frame texture before temporal supersampling
    this._prevFrameTex = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)();
    this._outputTex = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)();
    var blendPass = this._blendPass = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("clay.compositor.blend")
    });
    blendPass.material.disableTexturesAll();
    blendPass.material.enableTexture([
        "texture1",
        "texture2"
    ]);
    this._blendFb = new (0, $03d0b3c43006f961$export$2e2bcd8739ae039)({
        depthBuffer: false
    });
    this._outputPass = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("clay.compositor.output"),
        // TODO, alpha is premultiplied?
        blendWithPrevious: true
    });
    this._outputPass.material.define("fragment", "OUTPUT_ALPHA");
    this._outputPass.material.blend = function(_gl) {
        // FIXME.
        // Output is premultiplied alpha when BLEND is enabled ?
        // http://stackoverflow.com/questions/2171085/opengl-blending-with-previous-contents-of-framebuffer
        _gl.blendEquationSeparate(_gl.FUNC_ADD, _gl.FUNC_ADD);
        _gl.blendFuncSeparate(_gl.ONE, _gl.ONE_MINUS_SRC_ALPHA, _gl.ONE, _gl.ONE_MINUS_SRC_ALPHA);
    };
}
$793673d49d8e18cc$var$TemporalSuperSampling.prototype = {
    constructor: $793673d49d8e18cc$var$TemporalSuperSampling,
    /**
   * Jitter camera projectionMatrix
   * @parma {clay.Renderer} renderer
   * @param {clay.Camera} camera
   */ jitterProjection: function(renderer, camera) {
        var viewport = renderer.viewport;
        var dpr = viewport.devicePixelRatio || renderer.getDevicePixelRatio();
        var width = viewport.width * dpr;
        var height = viewport.height * dpr;
        var offset = this._haltonSequence[this._frame % this._haltonSequence.length];
        var translationMat = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
        translationMat.array[12] = (offset[0] * 2.0 - 1.0) / width;
        translationMat.array[13] = (offset[1] * 2.0 - 1.0) / height;
        (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).mul(camera.projectionMatrix, translationMat, camera.projectionMatrix);
        (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).invert(camera.invProjectionMatrix, camera.projectionMatrix);
    },
    /**
   * Reset accumulating frame
   */ resetFrame: function() {
        this._frame = 0;
    },
    /**
   * Return current frame
   */ getFrame: function() {
        return this._frame;
    },
    /**
   * Get source framebuffer for usage
   */ getSourceFrameBuffer: function() {
        return this._sourceFb;
    },
    getOutputTexture: function() {
        return this._outputTex;
    },
    resize: function(width, height) {
        this._prevFrameTex.width = width;
        this._prevFrameTex.height = height;
        this._outputTex.width = width;
        this._outputTex.height = height;
        this._sourceTex.width = width;
        this._sourceTex.height = height;
        this._prevFrameTex.dirty();
        this._outputTex.dirty();
        this._sourceTex.dirty();
    },
    isFinished: function() {
        return this._frame >= this._haltonSequence.length;
    },
    render: function(renderer, sourceTex, notOutput) {
        var blendPass = this._blendPass;
        if (this._frame === 0) {
            // Direct output
            blendPass.setUniform("weight1", 0);
            blendPass.setUniform("weight2", 1);
        } else {
            blendPass.setUniform("weight1", 0.9);
            blendPass.setUniform("weight2", 0.1);
        }
        blendPass.setUniform("texture1", this._prevFrameTex);
        blendPass.setUniform("texture2", sourceTex || this._sourceTex);
        this._blendFb.attach(this._outputTex);
        this._blendFb.bind(renderer);
        blendPass.render(renderer);
        this._blendFb.unbind(renderer);
        if (!notOutput) {
            this._outputPass.setUniform("texture", this._outputTex);
            this._outputPass.render(renderer);
        } // Swap texture
        var tmp = this._prevFrameTex;
        this._prevFrameTex = this._outputTex;
        this._outputTex = tmp;
        this._frame++;
    },
    dispose: function(renderer) {
        this._sourceFb.dispose(renderer);
        this._blendFb.dispose(renderer);
        this._prevFrameTex.dispose(renderer);
        this._outputTex.dispose(renderer);
        this._sourceTex.dispose(renderer);
        this._outputPass.dispose(renderer);
        this._blendPass.dispose(renderer);
    }
};
var $793673d49d8e18cc$export$2e2bcd8739ae039 = $793673d49d8e18cc$var$TemporalSuperSampling;



/**
 * @constructor
 * @alias module:echarts-gl/core/ViewGL
 * @param {string} [projection='perspective']
 */ function $7a0cfdd3f7cf77fd$var$ViewGL(projection) {
    projection = projection || "perspective";
    /**
   * @type {module:echarts-gl/core/LayerGL}
   */ this.layer = null;
    /**
   * @type {clay.Scene}
   */ this.scene = new (0, $e49354c4f1efd6e1$export$2e2bcd8739ae039)();
    /**
   * @type {clay.Node}
   */ this.rootNode = this.scene;
    this.viewport = {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    };
    this.setProjection(projection);
    this._compositor = new (0, $8293118d0e603f9a$export$2e2bcd8739ae039)();
    this._temporalSS = new (0, $793673d49d8e18cc$export$2e2bcd8739ae039)();
    this._shadowMapPass = new (0, $7f41e20ed9aae8d8$export$2e2bcd8739ae039)();
    var pcfKernels = [];
    var off = 0;
    for(var i = 0; i < 30; i++){
        var pcfKernel = [];
        for(var k = 0; k < 6; k++){
            pcfKernel.push((0, $7e44f65780f6d68a$export$2e2bcd8739ae039)(off, 2) * 4.0 - 2.0);
            pcfKernel.push((0, $7e44f65780f6d68a$export$2e2bcd8739ae039)(off, 3) * 4.0 - 2.0);
            off++;
        }
        pcfKernels.push(pcfKernel);
    }
    this._pcfKernels = pcfKernels;
    this.scene.on("beforerender", function(renderer, scene, camera) {
        if (this.needsTemporalSS()) this._temporalSS.jitterProjection(renderer, camera);
    }, this);
}
/**
 * Set camera type of group
 * @param {string} cameraType 'perspective' | 'orthographic'
 */ $7a0cfdd3f7cf77fd$var$ViewGL.prototype.setProjection = function(projection) {
    var oldCamera = this.camera;
    oldCamera && oldCamera.update();
    if (projection === "perspective") {
        if (!(this.camera instanceof (0, $b0e6d9b112e2eb50$export$2e2bcd8739ae039))) {
            this.camera = new (0, $b0e6d9b112e2eb50$export$2e2bcd8739ae039)();
            if (oldCamera) this.camera.setLocalTransform(oldCamera.localTransform);
        }
    } else if (!(this.camera instanceof (0, $c4a0e1584dbfc1e9$export$2e2bcd8739ae039))) {
        this.camera = new (0, $c4a0e1584dbfc1e9$export$2e2bcd8739ae039)();
        if (oldCamera) this.camera.setLocalTransform(oldCamera.localTransform);
    }
     // PENDING
    this.camera.near = 0.1;
    this.camera.far = 2000;
};
/**
 * Set viewport of group
 * @param {number} x Viewport left bottom x
 * @param {number} y Viewport left bottom y
 * @param {number} width Viewport height
 * @param {number} height Viewport height
 * @param {number} [dpr=1]
 */ $7a0cfdd3f7cf77fd$var$ViewGL.prototype.setViewport = function(x, y, width, height, dpr) {
    if (this.camera instanceof (0, $b0e6d9b112e2eb50$export$2e2bcd8739ae039)) this.camera.aspect = width / height;
    dpr = dpr || 1;
    this.viewport.x = x;
    this.viewport.y = y;
    this.viewport.width = width;
    this.viewport.height = height;
    this.viewport.devicePixelRatio = dpr; // Source and output of compositor use high dpr texture.
    // But the intermediate texture of bloom, dof effects use fixed 1.0 dpr
    this._compositor.resize(width * dpr, height * dpr);
    this._temporalSS.resize(width * dpr, height * dpr);
};
/**
 * If contain screen point x, y
 * @param {number} x offsetX
 * @param {number} y offsetY
 * @return {boolean}
 */ $7a0cfdd3f7cf77fd$var$ViewGL.prototype.containPoint = function(x, y) {
    var viewport = this.viewport;
    var height = this.layer.renderer.getHeight(); // Flip y;
    y = height - y;
    return x >= viewport.x && y >= viewport.y && x <= viewport.x + viewport.width && y <= viewport.y + viewport.height;
};
/**
 * Cast a ray
 * @param {number} x offsetX
 * @param {number} y offsetY
 * @param {clay.math.Ray} out
 * @return {clay.math.Ray}
 */ var $7a0cfdd3f7cf77fd$var$ndc = new (0, $2cb41795bddfe4d3$export$2e2bcd8739ae039)();
$7a0cfdd3f7cf77fd$var$ViewGL.prototype.castRay = function(x, y, out) {
    var renderer = this.layer.renderer;
    var oldViewport = renderer.viewport;
    renderer.viewport = this.viewport;
    renderer.screenToNDC(x, y, $7a0cfdd3f7cf77fd$var$ndc);
    this.camera.castRay($7a0cfdd3f7cf77fd$var$ndc, out);
    renderer.viewport = oldViewport;
    return out;
};
/**
 * Prepare and update scene before render
 */ $7a0cfdd3f7cf77fd$var$ViewGL.prototype.prepareRender = function() {
    this.scene.update();
    this.camera.update();
    this.scene.updateLights();
    var renderList = this.scene.updateRenderList(this.camera);
    this._needsSortProgressively = false; // If has any transparent mesh needs sort triangles progressively.
    for(var i = 0; i < renderList.transparent.length; i++){
        var renderable = renderList.transparent[i];
        var geometry = renderable.geometry;
        if (geometry.needsSortVerticesProgressively && geometry.needsSortVerticesProgressively()) this._needsSortProgressively = true;
        if (geometry.needsSortTrianglesProgressively && geometry.needsSortTrianglesProgressively()) this._needsSortProgressively = true;
    }
    this._frame = 0;
    this._temporalSS.resetFrame(); // var lights = this.scene.getLights();
// for (var i = 0; i < lights.length; i++) {
//     if (lights[i].cubemap) {
//         if (this._compositor && this._compositor.isSSREnabled()) {
//             lights[i].invisible = true;
//         }
//         else {
//             lights[i].invisible = false;
//         }
//     }
// }
};
$7a0cfdd3f7cf77fd$var$ViewGL.prototype.render = function(renderer, accumulating) {
    this._doRender(renderer, accumulating, this._frame);
    this._frame++;
};
$7a0cfdd3f7cf77fd$var$ViewGL.prototype.needsAccumulate = function() {
    return this.needsTemporalSS() || this._needsSortProgressively;
};
$7a0cfdd3f7cf77fd$var$ViewGL.prototype.needsTemporalSS = function() {
    var enableTemporalSS = this._enableTemporalSS;
    if (enableTemporalSS === "auto") enableTemporalSS = this._enablePostEffect;
    return enableTemporalSS;
};
$7a0cfdd3f7cf77fd$var$ViewGL.prototype.hasDOF = function() {
    return this._enableDOF;
};
$7a0cfdd3f7cf77fd$var$ViewGL.prototype.isAccumulateFinished = function() {
    return this.needsTemporalSS() ? this._temporalSS.isFinished() : this._frame > 30;
};
$7a0cfdd3f7cf77fd$var$ViewGL.prototype._doRender = function(renderer, accumulating, accumFrame) {
    var scene = this.scene;
    var camera = this.camera;
    accumFrame = accumFrame || 0;
    this._updateTransparent(renderer, scene, camera, accumFrame);
    if (!accumulating) {
        this._shadowMapPass.kernelPCF = this._pcfKernels[0]; // Not render shadowmap pass in accumulating frame.
        this._shadowMapPass.render(renderer, scene, camera, true);
    }
    this._updateShadowPCFKernel(accumFrame); // Shadowmap will set clear color.
    var bgColor = renderer.clearColor;
    renderer.gl.clearColor(bgColor[0], bgColor[1], bgColor[2], bgColor[3]);
    if (this._enablePostEffect) {
        // normal render also needs to be jittered when have edge pass.
        if (this.needsTemporalSS()) this._temporalSS.jitterProjection(renderer, camera);
        this._compositor.updateNormal(renderer, scene, camera, this._temporalSS.getFrame());
    } // Always update SSAO to make sure have correct ssaoMap status
    this._updateSSAO(renderer, scene, camera, this._temporalSS.getFrame());
    if (this._enablePostEffect) {
        var frameBuffer = this._compositor.getSourceFrameBuffer();
        frameBuffer.bind(renderer);
        renderer.gl.clear(renderer.gl.DEPTH_BUFFER_BIT | renderer.gl.COLOR_BUFFER_BIT);
        renderer.render(scene, camera, true, true);
        frameBuffer.unbind(renderer);
        if (this.needsTemporalSS() && accumulating) {
            this._compositor.composite(renderer, scene, camera, this._temporalSS.getSourceFrameBuffer(), this._temporalSS.getFrame());
            renderer.setViewport(this.viewport);
            this._temporalSS.render(renderer);
        } else {
            renderer.setViewport(this.viewport);
            this._compositor.composite(renderer, scene, camera, null, 0);
        }
    } else if (this.needsTemporalSS() && accumulating) {
        var frameBuffer = this._temporalSS.getSourceFrameBuffer();
        frameBuffer.bind(renderer);
        renderer.saveClear();
        renderer.clearBit = renderer.gl.DEPTH_BUFFER_BIT | renderer.gl.COLOR_BUFFER_BIT;
        renderer.render(scene, camera, true, true);
        renderer.restoreClear();
        frameBuffer.unbind(renderer);
        renderer.setViewport(this.viewport);
        this._temporalSS.render(renderer);
    } else {
        renderer.setViewport(this.viewport);
        renderer.render(scene, camera, true, true);
    }
     // this._shadowMapPass.renderDebug(renderer);
// this._compositor._normalPass.renderDebug(renderer);
};
$7a0cfdd3f7cf77fd$var$ViewGL.prototype._updateTransparent = function(renderer, scene, camera, frame) {
    var v3 = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)();
    var invWorldTransform = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
    var cameraWorldPosition = camera.getWorldPosition();
    var transparentList = scene.getRenderList(camera).transparent; // Sort transparent object.
    for(var i = 0; i < transparentList.length; i++){
        var renderable = transparentList[i];
        var geometry = renderable.geometry;
        (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).invert(invWorldTransform, renderable.worldTransform);
        (0, $27fea36417076c2d$export$2e2bcd8739ae039).transformMat4(v3, cameraWorldPosition, invWorldTransform);
        if (geometry.needsSortTriangles && geometry.needsSortTriangles()) geometry.doSortTriangles(v3, frame);
        if (geometry.needsSortVertices && geometry.needsSortVertices()) geometry.doSortVertices(v3, frame);
    }
};
$7a0cfdd3f7cf77fd$var$ViewGL.prototype._updateSSAO = function(renderer, scene, camera) {
    var ifEnableSSAO = this._enableSSAO && this._enablePostEffect;
    if (ifEnableSSAO) this._compositor.updateSSAO(renderer, scene, camera, this._temporalSS.getFrame());
    var renderList = scene.getRenderList(camera);
    for(var i = 0; i < renderList.opaque.length; i++){
        var renderable = renderList.opaque[i]; // PENDING
        if (renderable.renderNormal) renderable.material[ifEnableSSAO ? "enableTexture" : "disableTexture"]("ssaoMap");
        if (ifEnableSSAO) renderable.material.set("ssaoMap", this._compositor.getSSAOTexture());
    }
};
$7a0cfdd3f7cf77fd$var$ViewGL.prototype._updateShadowPCFKernel = function(frame) {
    var pcfKernel = this._pcfKernels[frame % this._pcfKernels.length];
    var renderList = this.scene.getRenderList(this.camera);
    var opaqueList = renderList.opaque;
    for(var i = 0; i < opaqueList.length; i++)if (opaqueList[i].receiveShadow) {
        opaqueList[i].material.set("pcfKernel", pcfKernel);
        opaqueList[i].material.define("fragment", "PCF_KERNEL_SIZE", pcfKernel.length / 2);
    }
};
$7a0cfdd3f7cf77fd$var$ViewGL.prototype.dispose = function(renderer) {
    this._compositor.dispose(renderer.gl);
    this._temporalSS.dispose(renderer.gl);
    this._shadowMapPass.dispose(renderer);
};
/**
 * @param {module:echarts/Model} Post effect model
 */ $7a0cfdd3f7cf77fd$var$ViewGL.prototype.setPostEffect = function(postEffectModel, api) {
    var compositor = this._compositor;
    this._enablePostEffect = postEffectModel.get("enable");
    var bloomModel = postEffectModel.getModel("bloom");
    var edgeModel = postEffectModel.getModel("edge");
    var dofModel = postEffectModel.getModel("DOF", postEffectModel.getModel("depthOfField"));
    var ssaoModel = postEffectModel.getModel("SSAO", postEffectModel.getModel("screenSpaceAmbientOcclusion"));
    var ssrModel = postEffectModel.getModel("SSR", postEffectModel.getModel("screenSpaceReflection"));
    var fxaaModel = postEffectModel.getModel("FXAA");
    var colorCorrModel = postEffectModel.getModel("colorCorrection");
    bloomModel.get("enable") ? compositor.enableBloom() : compositor.disableBloom();
    dofModel.get("enable") ? compositor.enableDOF() : compositor.disableDOF();
    ssrModel.get("enable") ? compositor.enableSSR() : compositor.disableSSR();
    colorCorrModel.get("enable") ? compositor.enableColorCorrection() : compositor.disableColorCorrection();
    edgeModel.get("enable") ? compositor.enableEdge() : compositor.disableEdge();
    fxaaModel.get("enable") ? compositor.enableFXAA() : compositor.disableFXAA();
    this._enableDOF = dofModel.get("enable");
    this._enableSSAO = ssaoModel.get("enable");
    this._enableSSAO ? compositor.enableSSAO() : compositor.disableSSAO();
    compositor.setBloomIntensity(bloomModel.get("intensity"));
    compositor.setEdgeColor(edgeModel.get("color"));
    compositor.setColorLookupTexture(colorCorrModel.get("lookupTexture"), api);
    compositor.setExposure(colorCorrModel.get("exposure"));
    [
        "radius",
        "quality",
        "intensity"
    ].forEach(function(name) {
        compositor.setSSAOParameter(name, ssaoModel.get(name));
    });
    [
        "quality",
        "maxRoughness",
        "physical"
    ].forEach(function(name) {
        compositor.setSSRParameter(name, ssrModel.get(name));
    });
    [
        "quality",
        "focalDistance",
        "focalRange",
        "blurRadius",
        "fstop"
    ].forEach(function(name) {
        compositor.setDOFParameter(name, dofModel.get(name));
    });
    [
        "brightness",
        "contrast",
        "saturation"
    ].forEach(function(name) {
        compositor.setColorCorrection(name, colorCorrModel.get(name));
    });
};
$7a0cfdd3f7cf77fd$var$ViewGL.prototype.setDOFFocusOnPoint = function(depth) {
    if (this._enablePostEffect) {
        if (depth > this.camera.far || depth < this.camera.near) return;
        this._compositor.setDOFParameter("focalDistance", depth);
        return true;
    }
};
$7a0cfdd3f7cf77fd$var$ViewGL.prototype.setTemporalSuperSampling = function(temporalSuperSamplingModel) {
    this._enableTemporalSS = temporalSuperSamplingModel.get("enable");
};
$7a0cfdd3f7cf77fd$var$ViewGL.prototype.isLinearSpace = function() {
    return this._enablePostEffect;
};
$7a0cfdd3f7cf77fd$var$ViewGL.prototype.setRootNode = function(rootNode) {
    if (this.rootNode === rootNode) return;
    var children = this.rootNode.children();
    for(var i = 0; i < children.length; i++)rootNode.add(children[i]);
    if (rootNode !== this.scene) this.scene.add(rootNode);
    this.rootNode = rootNode;
}; // Proxies
$7a0cfdd3f7cf77fd$var$ViewGL.prototype.add = function(node3D) {
    this.rootNode.add(node3D);
};
$7a0cfdd3f7cf77fd$var$ViewGL.prototype.remove = function(node3D) {
    this.rootNode.remove(node3D);
};
$7a0cfdd3f7cf77fd$var$ViewGL.prototype.removeAll = function(node3D) {
    this.rootNode.removeAll(node3D);
};
Object.assign($7a0cfdd3f7cf77fd$var$ViewGL.prototype, (0, $1b1a308d68e2d97a$export$2e2bcd8739ae039));
var $7a0cfdd3f7cf77fd$export$2e2bcd8739ae039 = $7a0cfdd3f7cf77fd$var$ViewGL;



function $1c75ef39c0abf392$var$resizeCartesian3D(grid3DModel, api) {
    // Use left/top/width/height
    var boxLayoutOption = grid3DModel.getBoxLayoutParams();
    var viewport = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(boxLayoutOption, {
        width: api.getWidth(),
        height: api.getHeight()
    }); // Flip Y
    viewport.y = api.getHeight() - viewport.y - viewport.height;
    this.viewGL.setViewport(viewport.x, viewport.y, viewport.width, viewport.height, api.getDevicePixelRatio());
    var boxWidth = grid3DModel.get("boxWidth");
    var boxHeight = grid3DModel.get("boxHeight");
    var boxDepth = grid3DModel.get("boxDepth");
    this.getAxis("x").setExtent(-boxWidth / 2, boxWidth / 2); // From near to far
    this.getAxis("y").setExtent(boxDepth / 2, -boxDepth / 2);
    this.getAxis("z").setExtent(-boxHeight / 2, boxHeight / 2);
    this.size = [
        boxWidth,
        boxHeight,
        boxDepth
    ];
}
function $1c75ef39c0abf392$var$updateCartesian3D(ecModel, api) {
    var dataExtents = {};
    function unionDataExtents(dim, extent) {
        dataExtents[dim] = dataExtents[dim] || [
            Infinity,
            -Infinity
        ];
        dataExtents[dim][0] = Math.min(extent[0], dataExtents[dim][0]);
        dataExtents[dim][1] = Math.max(extent[1], dataExtents[dim][1]);
    } // Get data extents for scale.
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.coordinateSystem !== this) return;
        var data = seriesModel.getData();
        [
            "x",
            "y",
            "z"
        ].forEach(function(coordDim) {
            data.mapDimensionsAll(coordDim, true).forEach(function(dataDim) {
                unionDataExtents(coordDim, data.getDataExtent(dataDim, true));
            });
        });
    }, this);
    [
        "xAxis3D",
        "yAxis3D",
        "zAxis3D"
    ].forEach(function(axisType) {
        ecModel.eachComponent(axisType, function(axisModel) {
            var dim = axisType.charAt(0);
            var grid3DModel = axisModel.getReferringComponents("grid3D").models[0];
            var cartesian3D = grid3DModel.coordinateSystem;
            if (cartesian3D !== this) return;
            var axis = cartesian3D.getAxis(dim);
            if (axis) return;
            var scale = $9a616079ee96a3f3$exports.createScale(dataExtents[dim] || [
                Infinity,
                -Infinity
            ], axisModel);
            axis = new (0, $8eac0fde0c55469d$export$2e2bcd8739ae039)(dim, scale);
            axis.type = axisModel.get("type");
            var isCategory = axis.type === "category";
            axis.onBand = isCategory && axisModel.get("boundaryGap");
            axis.inverse = axisModel.get("inverse");
            axisModel.axis = axis;
            axis.model = axisModel; // override `echarts/coord/Axis#getLabelModel`
            axis.getLabelModel = function() {
                return axisModel.getModel("axisLabel", grid3DModel.getModel("axisLabel"));
            }; // override `echarts/coord/Axis#getTickModel`
            axis.getTickModel = function() {
                return axisModel.getModel("axisTick", grid3DModel.getModel("axisTick"));
            };
            cartesian3D.addAxis(axis);
        }, this);
    }, this);
    this.resize(this.model, api);
}
var $1c75ef39c0abf392$var$grid3DCreator = {
    dimensions: (0, $3fc2896504c5f210$export$2e2bcd8739ae039).prototype.dimensions,
    create: function(ecModel, api) {
        var cartesian3DList = [];
        ecModel.eachComponent("grid3D", function(grid3DModel) {
            // FIXME
            grid3DModel.__viewGL = grid3DModel.__viewGL || new (0, $7a0cfdd3f7cf77fd$export$2e2bcd8739ae039)();
            var cartesian3D = new (0, $3fc2896504c5f210$export$2e2bcd8739ae039)();
            cartesian3D.model = grid3DModel;
            cartesian3D.viewGL = grid3DModel.__viewGL;
            grid3DModel.coordinateSystem = cartesian3D;
            cartesian3DList.push(cartesian3D); // Inject resize and update
            cartesian3D.resize = $1c75ef39c0abf392$var$resizeCartesian3D;
            cartesian3D.update = $1c75ef39c0abf392$var$updateCartesian3D;
        });
        var axesTypes = [
            "xAxis3D",
            "yAxis3D",
            "zAxis3D"
        ];
        function findAxesModels(seriesModel, ecModel) {
            return axesTypes.map(function(axisType) {
                var axisModel = seriesModel.getReferringComponents(axisType).models[0];
                if (axisModel == null) axisModel = ecModel.getComponent(axisType);
                return axisModel;
            });
        }
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.get("coordinateSystem") !== "cartesian3D") return;
            var firstGridModel = seriesModel.getReferringComponents("grid3D").models[0];
            if (firstGridModel == null) {
                var axesModels = findAxesModels(seriesModel, ecModel);
                var firstGridModel = axesModels[0].getCoordSysModel();
                axesModels.forEach(function(axisModel) {
                    var grid3DModel = axisModel.getCoordSysModel();
                });
            }
            var coordSys = firstGridModel.coordinateSystem;
            seriesModel.coordinateSystem = coordSys;
        });
        return cartesian3DList;
    }
};
var $1c75ef39c0abf392$export$2e2bcd8739ae039 = $1c75ef39c0abf392$var$grid3DCreator;



var $beab727ced738dcf$var$Axis3DModel = $116d65051f61bdfe$export$2e2bcd8739ae039.extend({
    type: "cartesian3DAxis",
    axis: null,
    /**
   * @override
   */ getCoordSysModel: function() {
        return this.ecModel.queryComponents({
            mainType: "grid3D",
            index: this.option.gridIndex,
            id: this.option.gridId
        })[0];
    }
});
$9a616079ee96a3f3$exports.mixinAxisModelCommonMethods($beab727ced738dcf$var$Axis3DModel);
var $beab727ced738dcf$export$2e2bcd8739ae039 = $beab727ced738dcf$var$Axis3DModel;




var $4b40b8c719830e38$var$defaultOption = {
    show: true,
    grid3DIndex: 0,
    // 反向坐标轴
    inverse: false,
    // 坐标轴名字
    name: "",
    // 坐标轴名字位置
    nameLocation: "middle",
    nameTextStyle: {
        fontSize: 16
    },
    // 文字与轴线距离
    nameGap: 20,
    axisPointer: {},
    axisLine: {},
    // 坐标轴小标记
    axisTick: {},
    axisLabel: {},
    // 分隔区域
    splitArea: {}
};
var $4b40b8c719830e38$var$categoryAxis = $224386f1517b5dca$exports.merge({
    // 类目起始和结束两端空白策略
    boundaryGap: true,
    // splitArea: {
    // show: false
    // },
    // 坐标轴小标记
    axisTick: {
        // If tick is align with label when boundaryGap is true
        // Default with axisTick
        alignWithLabel: false,
        interval: "auto"
    },
    // 坐标轴文本标签，详见axis.axisLabel
    axisLabel: {
        interval: "auto"
    },
    axisPointer: {
        label: {
            show: false
        }
    }
}, $4b40b8c719830e38$var$defaultOption);
var $4b40b8c719830e38$var$valueAxis = $224386f1517b5dca$exports.merge({
    // 数值起始和结束两端空白策略
    boundaryGap: [
        0,
        0
    ],
    // 最小值, 设置成 'dataMin' 则从数据中计算最小值
    // min: null,
    // 最大值，设置成 'dataMax' 则从数据中计算最大值
    // max: null,
    // 脱离0值比例，放大聚焦到最终_min，_max区间
    // scale: false,
    // 分割段数，默认为5
    splitNumber: 5,
    // Minimum interval
    // minInterval: null
    axisPointer: {
        label: {}
    }
}, $4b40b8c719830e38$var$defaultOption); // FIXME
var $4b40b8c719830e38$var$timeAxis = $224386f1517b5dca$exports.defaults({
    scale: true,
    min: "dataMin",
    max: "dataMax"
}, $4b40b8c719830e38$var$valueAxis);
var $4b40b8c719830e38$var$logAxis = $224386f1517b5dca$exports.defaults({
    logBase: 10
}, $4b40b8c719830e38$var$valueAxis);
$4b40b8c719830e38$var$logAxis.scale = true;
var $4b40b8c719830e38$export$2e2bcd8739ae039 = {
    categoryAxis3D: $4b40b8c719830e38$var$categoryAxis,
    valueAxis3D: $4b40b8c719830e38$var$valueAxis,
    timeAxis3D: $4b40b8c719830e38$var$timeAxis,
    logAxis3D: $4b40b8c719830e38$var$logAxis
};



var $2479ef3f8bf2c51d$var$AXIS_TYPES = [
    "value",
    "category",
    "time",
    "log"
];
function $2479ef3f8bf2c51d$export$2e2bcd8739ae039(registers, dim, BaseAxisModelClass, axisTypeDefaulter, extraDefaultOption) {
    $2479ef3f8bf2c51d$var$AXIS_TYPES.forEach(function(axisType) {
        var AxisModel = BaseAxisModelClass.extend({
            type: dim + "Axis3D." + axisType,
            /**
       * @type readOnly
       */ __ordinalMeta: null,
            mergeDefaultAndTheme: function(option, ecModel) {
                var themeModel = ecModel.getTheme();
                $224386f1517b5dca$exports.merge(option, themeModel.get(axisType + "Axis3D"));
                $224386f1517b5dca$exports.merge(option, this.getDefaultOption());
                option.type = axisTypeDefaulter(dim, option);
            },
            /**
       * @override
       */ optionUpdated: function() {
                var thisOption = this.option;
                if (thisOption.type === "category") this.__ordinalMeta = (0, $57fe7cbbaae9fab0$export$2e2bcd8739ae039).createByAxisModel(this);
            },
            getCategories: function() {
                if (this.option.type === "category") return this.__ordinalMeta.categories;
            },
            getOrdinalMeta: function() {
                return this.__ordinalMeta;
            },
            defaultOption: $224386f1517b5dca$exports.merge($224386f1517b5dca$exports.clone((0, $4b40b8c719830e38$export$2e2bcd8739ae039)[axisType + "Axis3D"]), extraDefaultOption || {}, true)
        });
        registers.registerComponentModel(AxisModel);
    }); // TODO
    registers.registerSubTypeDefaulter(dim + "Axis3D", $224386f1517b5dca$exports.curry(axisTypeDefaulter, dim));
}


function $366a723a456157ee$var$getAxisType(axisDim, option) {
    // Default axis with data is category axis
    return option.type || (option.data ? "category" : "value");
}
function $366a723a456157ee$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $eb372d73ae662c91$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $130ac2c379dce8a3$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("grid3D", (0, $1c75ef39c0abf392$export$2e2bcd8739ae039));
    [
        "x",
        "y",
        "z"
    ].forEach(function(dim) {
        (0, $2479ef3f8bf2c51d$export$2e2bcd8739ae039)(registers, dim, (0, $beab727ced738dcf$export$2e2bcd8739ae039), $366a723a456157ee$var$getAxisType, {
            name: dim.toUpperCase()
        });
        const AxisView = registers.ComponentView.extend({
            type: dim + "Axis3D"
        });
        registers.registerComponentView(AxisView);
    });
    registers.registerAction({
        type: "grid3DChangeCamera",
        event: "grid3dcamerachanged",
        update: "series:updateCamera"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "grid3D",
            query: payload
        }, function(componentModel) {
            componentModel.setView(payload);
        });
    });
    registers.registerAction({
        type: "grid3DShowAxisPointer",
        event: "grid3dshowaxispointer",
        update: "grid3D:showAxisPointer"
    }, function(payload, ecModel) {});
    registers.registerAction({
        type: "grid3DHideAxisPointer",
        event: "grid3dhideaxispointer",
        update: "grid3D:hideAxisPointer"
    }, function(payload, ecModel) {});
}


(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $366a723a456157ee$export$4b3e715f166fdd78));



// TODO ECharts GL must be imported whatever component,charts is imported.





var $f866f5803ca3a09a$export$2e2bcd8739ae039 = {
    defaultOption: {
        shading: null,
        realisticMaterial: {
            textureTiling: 1,
            textureOffset: 0,
            detailTexture: null
        },
        lambertMaterial: {
            textureTiling: 1,
            textureOffset: 0,
            detailTexture: null
        },
        colorMaterial: {
            textureTiling: 1,
            textureOffset: 0,
            detailTexture: null
        },
        hatchingMaterial: {
            textureTiling: 1,
            textureOffset: 0,
            paperColor: "#fff"
        }
    }
};



var $d7d7dac625531b9b$export$2e2bcd8739ae039 = {
    getFilledRegions: function(regions, mapData) {
        var regionsArr = (regions || []).slice();
        var geoJson;
        if (typeof mapData === "string") {
            mapData = $4d59907f44a2d0ad$export$b8586192aead8a7e(mapData);
            geoJson = mapData && mapData.geoJson;
        } else if (mapData && mapData.features) geoJson = mapData;
        if (!geoJson) return [];
        var dataNameMap = {};
        var features = geoJson.features;
        for(var i = 0; i < regionsArr.length; i++)dataNameMap[regionsArr[i].name] = regionsArr[i];
        for(var i = 0; i < features.length; i++){
            var name = features[i].properties.name;
            if (!dataNameMap[name]) regionsArr.push({
                name: name
            });
        }
        return regionsArr;
    },
    defaultOption: {
        show: true,
        zlevel: -10,
        // geoJson used by geo3D
        map: "",
        // Layout used for viewport
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        boxWidth: 100,
        boxHeight: 10,
        boxDepth: "auto",
        regionHeight: 3,
        environment: "auto",
        groundPlane: {
            show: false,
            color: "#aaa"
        },
        shading: "lambert",
        light: {
            main: {
                alpha: 40,
                beta: 30
            }
        },
        viewControl: {
            alpha: 40,
            beta: 0,
            distance: 100,
            orthographicSize: 60,
            minAlpha: 5,
            minBeta: -80,
            maxBeta: 80
        },
        label: {
            show: false,
            // Distance in 3d space.
            distance: 2,
            textStyle: {
                fontSize: 20,
                color: "#000",
                backgroundColor: "rgba(255,255,255,0.7)",
                padding: 3,
                borderRadius: 4
            }
        },
        // TODO
        // altitude: {
        //     min: 'auto',
        //     max: 'auto',
        //     height: []
        // },
        // labelLine
        // light
        // postEffect
        // temporalSuperSampling
        itemStyle: {
            color: "#fff",
            borderWidth: 0,
            borderColor: "#333"
        },
        emphasis: {
            itemStyle: {
                // color: '#f94b59'
                color: "#639fc0"
            },
            label: {
                show: true
            }
        }
    }
};


var $6a21d27b869520a5$var$Geo3DModel = $116d65051f61bdfe$export$2e2bcd8739ae039.extend({
    type: "geo3D",
    layoutMode: "box",
    coordinateSystem: null,
    optionUpdated: function() {
        var option = this.option;
        option.regions = this.getFilledRegions(option.regions, option.map);
        var dimensions = $9a616079ee96a3f3$exports.createDimensions(option.data || [], {
            coordDimensions: [
                "value"
            ],
            encodeDefine: this.get("encode"),
            dimensionsDefine: this.get("dimensions")
        });
        var list = new $0ab0556b819346fd$export$2e2bcd8739ae039(dimensions, this);
        list.initData(option.regions);
        var regionModelMap = {};
        list.each(function(idx) {
            var name = list.getName(idx);
            var itemModel = list.getItemModel(idx);
            regionModelMap[name] = itemModel;
        });
        this._regionModelMap = regionModelMap;
        this._data = list;
    },
    getData: function() {
        return this._data;
    },
    getRegionModel: function(idx) {
        var name = this.getData().getName(idx);
        return this._regionModelMap[name] || new $6818646a97528290$export$2e2bcd8739ae039(null, this);
    },
    getRegionPolygonCoords: function(idx) {
        var name = this.getData().getName(idx);
        var region = this.coordinateSystem.getRegion(name);
        return region ? region.geometries : [];
    },
    /**
   * Format label
   * @param {string} name Region name
   * @param {string} [status='normal'] 'normal' or 'emphasis'
   * @return {string}
   */ getFormattedLabel: function(dataIndex, status) {
        var name = this._data.getName(dataIndex);
        var regionModel = this.getRegionModel(dataIndex);
        var formatter = regionModel.get(status === "normal" ? [
            "label",
            "formatter"
        ] : [
            "emphasis",
            "label",
            "formatter"
        ]);
        if (formatter == null) formatter = regionModel.get([
            "label",
            "formatter"
        ]);
        var params = {
            name: name
        };
        if (typeof formatter === "function") {
            params.status = status;
            return formatter(params);
        } else if (typeof formatter === "string") {
            var serName = params.seriesName;
            return formatter.replace("{a}", serName != null ? serName : "");
        } else return name;
    },
    defaultOption: {
        // itemStyle: {},
        // height,
        // label: {}
        // realisticMaterial
        regions: []
    }
});
$224386f1517b5dca$exports.merge($6a21d27b869520a5$var$Geo3DModel.prototype, (0, $d7d7dac625531b9b$export$2e2bcd8739ae039));
$224386f1517b5dca$exports.merge($6a21d27b869520a5$var$Geo3DModel.prototype, (0, $a589af99ac3423f7$export$2e2bcd8739ae039));
$224386f1517b5dca$exports.merge($6a21d27b869520a5$var$Geo3DModel.prototype, (0, $2d5450eeb3d59d52$export$2e2bcd8739ae039));
$224386f1517b5dca$exports.merge($6a21d27b869520a5$var$Geo3DModel.prototype, (0, $39dfcb89b5cc4a69$export$2e2bcd8739ae039));
$224386f1517b5dca$exports.merge($6a21d27b869520a5$var$Geo3DModel.prototype, (0, $f866f5803ca3a09a$export$2e2bcd8739ae039));
var $6a21d27b869520a5$export$2e2bcd8739ae039 = $6a21d27b869520a5$var$Geo3DModel;




// https://github.com/mapbox/earcut/blob/master/src/earcut.js
var $d89fac3cf5d8a380$export$2e2bcd8739ae039 = $d89fac3cf5d8a380$var$earcut;
function $d89fac3cf5d8a380$var$earcut(data, holeIndices, dim) {
    dim = dim || 2;
    var hasHoles = holeIndices && holeIndices.length, outerLen = hasHoles ? holeIndices[0] * dim : data.length, outerNode = $d89fac3cf5d8a380$var$linkedList(data, 0, outerLen, dim, true), triangles = [];
    if (!outerNode) return triangles;
    var minX, minY, maxX, maxY, x, y, size;
    if (hasHoles) outerNode = $d89fac3cf5d8a380$var$eliminateHoles(data, holeIndices, outerNode, dim); // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = maxX = data[0];
        minY = maxY = data[1];
        for(var i = dim; i < outerLen; i += dim){
            x = data[i];
            y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        } // minX, minY and size are later used to transform coords into integers for z-order calculation
        size = Math.max(maxX - minX, maxY - minY);
    }
    $d89fac3cf5d8a380$var$earcutLinked(outerNode, triangles, dim, minX, minY, size);
    return triangles;
} // create a circular doubly linked list from polygon points in the specified winding order
function $d89fac3cf5d8a380$var$linkedList(data, start, end, dim, clockwise) {
    var i, last;
    if (clockwise === $d89fac3cf5d8a380$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $d89fac3cf5d8a380$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $d89fac3cf5d8a380$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $d89fac3cf5d8a380$var$equals(last, last.next)) {
        $d89fac3cf5d8a380$var$removeNode(last);
        last = last.next;
    }
    return last;
} // eliminate colinear or duplicate points
function $d89fac3cf5d8a380$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    var p = start, again;
    do {
        again = false;
        if (!p.steiner && ($d89fac3cf5d8a380$var$equals(p, p.next) || $d89fac3cf5d8a380$var$area(p.prev, p, p.next) === 0)) {
            $d89fac3cf5d8a380$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) return null;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
} // main ear slicing loop which triangulates a polygon (given as a linked list)
function $d89fac3cf5d8a380$var$earcutLinked(ear, triangles, dim, minX, minY, size, pass) {
    if (!ear) return; // interlink polygon nodes in z-order
    if (!pass && size) $d89fac3cf5d8a380$var$indexCurve(ear, minX, minY, size);
    var stop = ear, prev, next; // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (size ? $d89fac3cf5d8a380$var$isEarHashed(ear, minX, minY, size) : $d89fac3cf5d8a380$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim);
            triangles.push(ear.i / dim);
            triangles.push(next.i / dim);
            $d89fac3cf5d8a380$var$removeNode(ear); // skipping the next vertice leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next; // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $d89fac3cf5d8a380$var$earcutLinked($d89fac3cf5d8a380$var$filterPoints(ear), triangles, dim, minX, minY, size, 1); // if this didn't work, try curing all small self-intersections locally
            else if (pass === 1) {
                ear = $d89fac3cf5d8a380$var$cureLocalIntersections(ear, triangles, dim);
                $d89fac3cf5d8a380$var$earcutLinked(ear, triangles, dim, minX, minY, size, 2); // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $d89fac3cf5d8a380$var$splitEarcut(ear, triangles, dim, minX, minY, size);
            break;
        }
    }
} // check whether a polygon node forms a valid ear with adjacent nodes
function $d89fac3cf5d8a380$var$isEar(ear) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($d89fac3cf5d8a380$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    var p = ear.next.next;
    while(p !== ear.prev){
        if ($d89fac3cf5d8a380$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $d89fac3cf5d8a380$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $d89fac3cf5d8a380$var$isEarHashed(ear, minX, minY, size) {
    var a = ear.prev, b = ear, c = ear.next;
    if ($d89fac3cf5d8a380$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // triangle bbox; min & max are calculated like this for speed
    var minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x, minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y, maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x, maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y; // z-order range for the current triangle bbox;
    var minZ = $d89fac3cf5d8a380$var$zOrder(minTX, minTY, minX, minY, size), maxZ = $d89fac3cf5d8a380$var$zOrder(maxTX, maxTY, minX, minY, size); // first look for points inside the triangle in increasing z-order
    var p = ear.nextZ;
    while(p && p.z <= maxZ){
        if (p !== ear.prev && p !== ear.next && $d89fac3cf5d8a380$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $d89fac3cf5d8a380$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.nextZ;
    } // then look for points in decreasing z-order
    p = ear.prevZ;
    while(p && p.z >= minZ){
        if (p !== ear.prev && p !== ear.next && $d89fac3cf5d8a380$var$pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && $d89fac3cf5d8a380$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    return true;
} // go through all polygon nodes and cure small local self-intersections
function $d89fac3cf5d8a380$var$cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev, b = p.next.next;
        if (!$d89fac3cf5d8a380$var$equals(a, b) && $d89fac3cf5d8a380$var$intersects(a, p, p.next, b) && $d89fac3cf5d8a380$var$locallyInside(a, b) && $d89fac3cf5d8a380$var$locallyInside(b, a)) {
            triangles.push(a.i / dim);
            triangles.push(p.i / dim);
            triangles.push(b.i / dim); // remove two nodes involved
            $d89fac3cf5d8a380$var$removeNode(p);
            $d89fac3cf5d8a380$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return p;
} // try splitting polygon into two and triangulate them independently
function $d89fac3cf5d8a380$var$splitEarcut(start, triangles, dim, minX, minY, size) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $d89fac3cf5d8a380$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = $d89fac3cf5d8a380$var$splitPolygon(a, b); // filter colinear points around the cuts
                a = $d89fac3cf5d8a380$var$filterPoints(a, a.next);
                c = $d89fac3cf5d8a380$var$filterPoints(c, c.next); // run earcut on each half
                $d89fac3cf5d8a380$var$earcutLinked(a, triangles, dim, minX, minY, size);
                $d89fac3cf5d8a380$var$earcutLinked(c, triangles, dim, minX, minY, size);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
} // link every hole into the outer loop, producing a single-ring polygon without holes
function $d89fac3cf5d8a380$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [], i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $d89fac3cf5d8a380$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($d89fac3cf5d8a380$var$getLeftmost(list));
    }
    queue.sort($d89fac3cf5d8a380$var$compareX); // process holes from left to right
    for(i = 0; i < queue.length; i++){
        $d89fac3cf5d8a380$var$eliminateHole(queue[i], outerNode);
        outerNode = $d89fac3cf5d8a380$var$filterPoints(outerNode, outerNode.next);
    }
    return outerNode;
}
function $d89fac3cf5d8a380$var$compareX(a, b) {
    return a.x - b.x;
} // find a bridge between vertices that connects hole with an outer ring and and link it
function $d89fac3cf5d8a380$var$eliminateHole(hole, outerNode) {
    outerNode = $d89fac3cf5d8a380$var$findHoleBridge(hole, outerNode);
    if (outerNode) {
        var b = $d89fac3cf5d8a380$var$splitPolygon(outerNode, hole);
        $d89fac3cf5d8a380$var$filterPoints(b, b.next);
    }
} // David Eberly's algorithm for finding a bridge between hole and outer polygon
function $d89fac3cf5d8a380$var$findHoleBridge(hole, outerNode) {
    var p = outerNode, hx = hole.x, hy = hole.y, qx = -Infinity, m; // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                if (x === hx) {
                    if (hy === p.y) return p;
                    if (hy === p.next.y) return p.next;
                }
                m = p.x < p.next.x ? p : p.next;
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    if (hx === qx) return m.prev; // hole touches outer segment; pick lower endpoint
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    var stop = m, mx = m.x, my = m.y, tanMin = Infinity, tan;
    p = m.next;
    while(p !== stop){
        if (hx >= p.x && p.x >= mx && hx !== p.x && $d89fac3cf5d8a380$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ((tan < tanMin || tan === tanMin && p.x > m.x) && $d89fac3cf5d8a380$var$locallyInside(p, hole)) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }
    return m;
} // interlink polygon nodes in z-order
function $d89fac3cf5d8a380$var$indexCurve(start, minX, minY, size) {
    var p = start;
    do {
        if (p.z === null) p.z = $d89fac3cf5d8a380$var$zOrder(p.x, p.y, minX, minY, size);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $d89fac3cf5d8a380$var$sortLinked(p);
} // Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $d89fac3cf5d8a380$var$sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
} // z-order of a point given coords and size of the data bounding box
function $d89fac3cf5d8a380$var$zOrder(x, y, minX, minY, size) {
    // coords are transformed into non-negative 15-bit integer range
    x = 32767 * (x - minX) / size;
    y = 32767 * (y - minY) / size;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
} // find the leftmost node of a polygon ring
function $d89fac3cf5d8a380$var$getLeftmost(start) {
    var p = start, leftmost = start;
    do {
        if (p.x < leftmost.x) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
} // check if a point lies within a convex triangle
function $d89fac3cf5d8a380$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 && (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 && (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
} // check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $d89fac3cf5d8a380$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$d89fac3cf5d8a380$var$intersectsPolygon(a, b) && $d89fac3cf5d8a380$var$locallyInside(a, b) && $d89fac3cf5d8a380$var$locallyInside(b, a) && $d89fac3cf5d8a380$var$middleInside(a, b);
} // signed area of a triangle
function $d89fac3cf5d8a380$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
} // check if two points are equal
function $d89fac3cf5d8a380$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
} // check if two segments intersect
function $d89fac3cf5d8a380$var$intersects(p1, q1, p2, q2) {
    if ($d89fac3cf5d8a380$var$equals(p1, q1) && $d89fac3cf5d8a380$var$equals(p2, q2) || $d89fac3cf5d8a380$var$equals(p1, q2) && $d89fac3cf5d8a380$var$equals(p2, q1)) return true;
    return $d89fac3cf5d8a380$var$area(p1, q1, p2) > 0 !== $d89fac3cf5d8a380$var$area(p1, q1, q2) > 0 && $d89fac3cf5d8a380$var$area(p2, q2, p1) > 0 !== $d89fac3cf5d8a380$var$area(p2, q2, q1) > 0;
} // check if a polygon diagonal intersects any polygon segments
function $d89fac3cf5d8a380$var$intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $d89fac3cf5d8a380$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
} // check if a polygon diagonal is locally inside the polygon
function $d89fac3cf5d8a380$var$locallyInside(a, b) {
    return $d89fac3cf5d8a380$var$area(a.prev, a, a.next) < 0 ? $d89fac3cf5d8a380$var$area(a, b, a.next) >= 0 && $d89fac3cf5d8a380$var$area(a, a.prev, b) >= 0 : $d89fac3cf5d8a380$var$area(a, b, a.prev) < 0 || $d89fac3cf5d8a380$var$area(a, a.next, b) < 0;
} // check if the middle point of a polygon diagonal is inside the polygon
function $d89fac3cf5d8a380$var$middleInside(a, b) {
    var p = a, inside = false, px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
} // link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $d89fac3cf5d8a380$var$splitPolygon(a, b) {
    var a2 = new $d89fac3cf5d8a380$var$Node(a.i, a.x, a.y), b2 = new $d89fac3cf5d8a380$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
} // create a node and optionally link it with previous one (in a circular doubly linked list)
function $d89fac3cf5d8a380$var$insertNode(i, x, y, last) {
    var p = new $d89fac3cf5d8a380$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $d89fac3cf5d8a380$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $d89fac3cf5d8a380$var$Node(i, x, y) {
    // vertice index in coordinates array
    this.i = i; // vertex coordinates
    this.x = x;
    this.y = y; // previous and next vertice nodes in a polygon ring
    this.prev = null;
    this.next = null; // z-order curve value
    this.z = null; // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null; // indicates whether this is a steiner point
    this.steiner = false;
} // return a percentage difference between the polygon area and its triangulation area;
// used to verify correctness of triangulation
$d89fac3cf5d8a380$var$earcut.deviation = function(data, holeIndices, dim, triangles) {
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    var polygonArea = Math.abs($d89fac3cf5d8a380$var$signedArea(data, 0, outerLen, dim));
    if (hasHoles) for(var i = 0, len = holeIndices.length; i < len; i++){
        var start = holeIndices[i] * dim;
        var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        polygonArea -= Math.abs($d89fac3cf5d8a380$var$signedArea(data, start, end, dim));
    }
    var trianglesArea = 0;
    for(i = 0; i < triangles.length; i += 3){
        var a = triangles[i] * dim;
        var b = triangles[i + 1] * dim;
        var c = triangles[i + 2] * dim;
        trianglesArea += Math.abs((data[a] - data[c]) * (data[b + 1] - data[a + 1]) - (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }
    return polygonArea === 0 && trianglesArea === 0 ? 0 : Math.abs((trianglesArea - polygonArea) / polygonArea);
};
function $d89fac3cf5d8a380$var$signedArea(data, start, end, dim) {
    var sum = 0;
    for(var i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}





function $6f3b89c4df948b3a$var$swap(arr, a, b) {
    var tmp = arr[a];
    arr[a] = arr[b];
    arr[b] = tmp;
}
function $6f3b89c4df948b3a$var$partition(arr, pivot, left, right, compare) {
    var storeIndex = left;
    var pivotValue = arr[pivot]; // put the pivot on the right
    $6f3b89c4df948b3a$var$swap(arr, pivot, right); // go through the rest
    for(var v = left; v < right; v++)if (compare(arr[v], pivotValue) < 0) {
        $6f3b89c4df948b3a$var$swap(arr, v, storeIndex);
        storeIndex++;
    }
     // finally put the pivot in the correct place
    $6f3b89c4df948b3a$var$swap(arr, right, storeIndex);
    return storeIndex;
}
function $6f3b89c4df948b3a$var$quickSort(array, compare, left, right) {
    if (left < right) {
        var pivot = Math.floor((left + right) / 2);
        var newPivot = $6f3b89c4df948b3a$var$partition(array, pivot, left, right, compare);
        $6f3b89c4df948b3a$var$quickSort(array, compare, left, newPivot - 1);
        $6f3b89c4df948b3a$var$quickSort(array, compare, newPivot + 1, right);
    }
} // TODO Test.
function $6f3b89c4df948b3a$var$ProgressiveQuickSort() {
    // this._pivotList = new LinkedList();
    this._parts = [];
}
$6f3b89c4df948b3a$var$ProgressiveQuickSort.prototype.step = function(arr, compare, frame) {
    var len = arr.length;
    if (frame === 0) {
        this._parts = [];
        this._sorted = false; // Pick a start pivot;
        var pivot = Math.floor(len / 2);
        this._parts.push({
            pivot: pivot,
            left: 0,
            right: len - 1
        });
        this._currentSortPartIdx = 0;
    }
    if (this._sorted) return;
    var parts = this._parts;
    if (parts.length === 0) {
        this._sorted = true; // Already finished.
        return true;
    } else if (parts.length < 512) {
        // Sort large parts in about 10 frames.
        for(var i = 0; i < parts.length; i++)// Partition and Modify the pivot index.
        parts[i].pivot = $6f3b89c4df948b3a$var$partition(arr, parts[i].pivot, parts[i].left, parts[i].right, compare);
        var subdividedParts = [];
        for(var i = 0; i < parts.length; i++){
            // Subdivide left
            var left = parts[i].left;
            var right = parts[i].pivot - 1;
            if (right > left) subdividedParts.push({
                pivot: Math.floor((right + left) / 2),
                left: left,
                right: right
            });
             // Subdivide right
            var left = parts[i].pivot + 1;
            var right = parts[i].right;
            if (right > left) subdividedParts.push({
                pivot: Math.floor((right + left) / 2),
                left: left,
                right: right
            });
        }
        parts = this._parts = subdividedParts;
    } else // console.time('sort');
    // Finally quick sort each parts in 10 frames.
    for(var i = 0; i < Math.floor(parts.length / 10); i++){
        // Sort near parts first.
        var idx = parts.length - 1 - this._currentSortPartIdx;
        $6f3b89c4df948b3a$var$quickSort(arr, compare, parts[idx].left, parts[idx].right);
        this._currentSortPartIdx++; // Finish sort
        if (this._currentSortPartIdx === parts.length) {
            this._sorted = true;
            return true;
        }
    } // console.timeEnd('sort');
    return false;
};
$6f3b89c4df948b3a$var$ProgressiveQuickSort.sort = $6f3b89c4df948b3a$var$quickSort;
var $6f3b89c4df948b3a$export$2e2bcd8739ae039 = $6f3b89c4df948b3a$var$ProgressiveQuickSort;



var $fd6f60f8a754e772$var$vec3 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).vec3;
var $fd6f60f8a754e772$var$p0 = $fd6f60f8a754e772$var$vec3.create();
var $fd6f60f8a754e772$var$p1 = $fd6f60f8a754e772$var$vec3.create();
var $fd6f60f8a754e772$var$p2 = $fd6f60f8a754e772$var$vec3.create(); // var cp = vec3.create();
var $fd6f60f8a754e772$export$2e2bcd8739ae039 = {
    needsSortTriangles: function() {
        return this.indices && this.sortTriangles;
    },
    needsSortTrianglesProgressively: function() {
        return this.needsSortTriangles() && this.triangleCount >= 2e4;
    },
    doSortTriangles: function(cameraPos, frame) {
        var indices = this.indices; // Do progressive quick sort.
        if (frame === 0) {
            var posAttr = this.attributes.position;
            var cameraPos = cameraPos.array;
            if (!this._triangleZList || this._triangleZList.length !== this.triangleCount) {
                this._triangleZList = new Float32Array(this.triangleCount);
                this._sortedTriangleIndices = new Uint32Array(this.triangleCount);
                this._indicesTmp = new indices.constructor(indices.length);
                this._triangleZListTmp = new Float32Array(this.triangleCount);
            }
            var cursor = 0;
            var firstZ;
            for(var i = 0; i < indices.length;){
                posAttr.get(indices[i++], $fd6f60f8a754e772$var$p0);
                posAttr.get(indices[i++], $fd6f60f8a754e772$var$p1);
                posAttr.get(indices[i++], $fd6f60f8a754e772$var$p2); // FIXME If use center ?
                // cp[0] = (p0[0] + p1[0] + p2[0]) / 3;
                // cp[1] = (p0[1] + p1[1] + p2[1]) / 3;
                // cp[2] = (p0[2] + p1[2] + p2[2]) / 3;
                // Camera position is in object space
                // Use max of three points, PENDING
                var z0 = $fd6f60f8a754e772$var$vec3.sqrDist($fd6f60f8a754e772$var$p0, cameraPos);
                var z1 = $fd6f60f8a754e772$var$vec3.sqrDist($fd6f60f8a754e772$var$p1, cameraPos);
                var z2 = $fd6f60f8a754e772$var$vec3.sqrDist($fd6f60f8a754e772$var$p2, cameraPos);
                var zMax = Math.min(z0, z1);
                zMax = Math.min(zMax, z2);
                if (i === 3) {
                    firstZ = zMax;
                    zMax = 0;
                } else // Only store the difference to avoid the precision issue.
                zMax = zMax - firstZ;
                this._triangleZList[cursor++] = zMax;
            }
        }
        var sortedTriangleIndices = this._sortedTriangleIndices;
        for(var i = 0; i < sortedTriangleIndices.length; i++)sortedTriangleIndices[i] = i;
        if (this.triangleCount < 2e4) // Use simple timsort for simple geometries.
        {
            if (frame === 0) // Use native sort temporary.
            this._simpleSort(true);
        } else for(var i = 0; i < 3; i++)this._progressiveQuickSort(frame * 3 + i);
        var targetIndices = this._indicesTmp;
        var targetTriangleZList = this._triangleZListTmp;
        var faceZList = this._triangleZList;
        for(var i = 0; i < this.triangleCount; i++){
            var fromIdx3 = sortedTriangleIndices[i] * 3;
            var toIdx3 = i * 3;
            targetIndices[toIdx3++] = indices[fromIdx3++];
            targetIndices[toIdx3++] = indices[fromIdx3++];
            targetIndices[toIdx3] = indices[fromIdx3];
            targetTriangleZList[i] = faceZList[sortedTriangleIndices[i]];
        } // Swap indices.
        var tmp = this._indicesTmp;
        this._indicesTmp = this.indices;
        this.indices = tmp;
        var tmp = this._triangleZListTmp;
        this._triangleZListTmp = this._triangleZList;
        this._triangleZList = tmp;
        this.dirtyIndices();
    },
    _simpleSort: function(useNativeQuickSort) {
        var faceZList = this._triangleZList;
        var sortedTriangleIndices = this._sortedTriangleIndices;
        function compare(a, b) {
            // Sort from far to near. which is descending order
            return faceZList[b] - faceZList[a];
        }
        if (useNativeQuickSort) Array.prototype.sort.call(sortedTriangleIndices, compare);
        else (0, $6f3b89c4df948b3a$export$2e2bcd8739ae039).sort(sortedTriangleIndices, compare, 0, sortedTriangleIndices.length - 1);
    },
    _progressiveQuickSort: function(frame) {
        var faceZList = this._triangleZList;
        var sortedTriangleIndices = this._sortedTriangleIndices;
        this._quickSort = this._quickSort || new (0, $6f3b89c4df948b3a$export$2e2bcd8739ae039)();
        this._quickSort.step(sortedTriangleIndices, function(a, b) {
            return faceZList[b] - faceZList[a];
        }, frame);
    }
};






function $4c1f03531dad0b09$export$4707c867a92dbeb5(data) {
    const style = data.getVisual("style");
    if (style) {
        const drawType = data.getVisual("drawType");
        return style[drawType];
    }
}
function $4c1f03531dad0b09$export$b00fee0c137bb546(data) {
    const style = data.getVisual("style");
    return style.opacity;
}
function $4c1f03531dad0b09$export$bc92a5a7848039f(data, idx) {
    const style = data.getItemVisual(idx, "style");
    if (style) {
        const drawType = data.getVisual("drawType");
        return style[drawType];
    }
}
function $4c1f03531dad0b09$export$f154d4dab8f4e8c0(data, idx) {
    const style = data.getItemVisual(idx, "style");
    return style && style.opacity;
}



var $87f8de1342284ee1$var$LABEL_NORMAL_SHOW_BIT = 1;
var $87f8de1342284ee1$var$LABEL_EMPHASIS_SHOW_BIT = 2;
function $87f8de1342284ee1$var$LabelsBuilder(width, height, api) {
    this._labelsMesh = new (0, $b164bb04725a6275$export$2e2bcd8739ae039)();
    this._labelTextureSurface = new (0, $022f245366cabf55$export$2e2bcd8739ae039)({
        width: 512,
        height: 512,
        devicePixelRatio: api.getDevicePixelRatio(),
        onupdate: function() {
            api.getZr().refresh();
        }
    });
    this._api = api;
    this._labelsMesh.material.set("textureAtlas", this._labelTextureSurface.getTexture());
}
$87f8de1342284ee1$var$LabelsBuilder.prototype.getLabelPosition = function(dataIndex, positionDesc, distance) {
    return [
        0,
        0,
        0
    ];
};
$87f8de1342284ee1$var$LabelsBuilder.prototype.getLabelDistance = function(dataIndex, positionDesc, distance) {
    return 0;
};
$87f8de1342284ee1$var$LabelsBuilder.prototype.getMesh = function() {
    return this._labelsMesh;
};
$87f8de1342284ee1$var$LabelsBuilder.prototype.updateData = function(data, start, end) {
    if (start == null) start = 0;
    if (end == null) end = data.count();
    if (!this._labelsVisibilitiesBits || this._labelsVisibilitiesBits.length !== end - start) this._labelsVisibilitiesBits = new Uint8Array(end - start);
    var normalLabelVisibilityQuery = [
        "label",
        "show"
    ];
    var emphasisLabelVisibilityQuery = [
        "emphasis",
        "label",
        "show"
    ];
    for(var idx = start; idx < end; idx++){
        var itemModel = data.getItemModel(idx);
        var normalVisibility = itemModel.get(normalLabelVisibilityQuery);
        var emphasisVisibility = itemModel.get(emphasisLabelVisibilityQuery);
        if (emphasisVisibility == null) emphasisVisibility = normalVisibility;
        var bit = (normalVisibility ? $87f8de1342284ee1$var$LABEL_NORMAL_SHOW_BIT : 0) | (emphasisVisibility ? $87f8de1342284ee1$var$LABEL_EMPHASIS_SHOW_BIT : 0);
        this._labelsVisibilitiesBits[idx - start] = bit;
    }
    this._start = start;
    this._end = end;
    this._data = data;
};
$87f8de1342284ee1$var$LabelsBuilder.prototype.updateLabels = function(highlightDataIndices) {
    if (!this._data) return;
    highlightDataIndices = highlightDataIndices || [];
    var hasHighlightData = highlightDataIndices.length > 0;
    var highlightDataIndicesMap = {};
    for(var i = 0; i < highlightDataIndices.length; i++)highlightDataIndicesMap[highlightDataIndices[i]] = true;
    this._labelsMesh.geometry.convertToDynamicArray(true);
    this._labelTextureSurface.clear();
    var normalLabelQuery = [
        "label"
    ];
    var emphasisLabelQuery = [
        "emphasis",
        "label"
    ];
    var seriesModel = this._data.hostModel;
    var data = this._data;
    var seriesLabelModel = seriesModel.getModel(normalLabelQuery);
    var seriesLabelEmphasisModel = seriesModel.getModel(emphasisLabelQuery, seriesLabelModel);
    var textAlignMap = {
        left: "right",
        right: "left",
        top: "center",
        bottom: "center"
    };
    var textVerticalAlignMap = {
        left: "middle",
        right: "middle",
        top: "bottom",
        bottom: "top"
    };
    for(var dataIndex = this._start; dataIndex < this._end; dataIndex++){
        var isEmphasis = false;
        if (hasHighlightData && highlightDataIndicesMap[dataIndex]) isEmphasis = true;
        var ifShow = this._labelsVisibilitiesBits[dataIndex - this._start] & (isEmphasis ? $87f8de1342284ee1$var$LABEL_EMPHASIS_SHOW_BIT : $87f8de1342284ee1$var$LABEL_NORMAL_SHOW_BIT);
        if (!ifShow) continue;
        var itemModel = data.getItemModel(dataIndex);
        var labelModel = itemModel.getModel(isEmphasis ? emphasisLabelQuery : normalLabelQuery, isEmphasis ? seriesLabelEmphasisModel : seriesLabelModel);
        var distance = labelModel.get("distance") || 0;
        var position = labelModel.get("position");
        var dpr = this._api.getDevicePixelRatio();
        var text = seriesModel.getFormattedLabel(dataIndex, isEmphasis ? "emphasis" : "normal");
        if (text == null || text === "") return;
         // TODO Background.
        var textEl = new $03154d907069e78f$exports.Text({
            style: (0, $6800dfcb6e1e2a44$export$f8998c3d0a13de59)(labelModel, {
                text: text,
                fill: labelModel.get("color") || (0, $4c1f03531dad0b09$export$bc92a5a7848039f)(data, dataIndex) || "#000",
                align: "left",
                verticalAlign: "top",
                opacity: (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(labelModel.get("opacity"), (0, $4c1f03531dad0b09$export$f154d4dab8f4e8c0)(data, dataIndex), 1)
            })
        });
        var rect = textEl.getBoundingRect();
        var lineHeight = 1.2;
        rect.height *= lineHeight;
        var coords = this._labelTextureSurface.add(textEl);
        var textAlign = textAlignMap[position] || "center";
        var textVerticalAlign = textVerticalAlignMap[position] || "bottom";
        this._labelsMesh.geometry.addSprite(this.getLabelPosition(dataIndex, position, distance), [
            rect.width * dpr,
            rect.height * dpr
        ], coords, textAlign, textVerticalAlign, this.getLabelDistance(dataIndex, position, distance) * dpr);
    }
    this._labelsMesh.material.set("uvScale", this._labelTextureSurface.getCoordsScale()); // var canvas = this._labelTextureSurface.getTexture().image;
    // document.body.appendChild(canvas);
    // canvas.style.cssText = 'position:absolute;z-index: 1000';
    // Update image.
    this._labelTextureSurface.getZr().refreshImmediately();
    this._labelsMesh.geometry.convertToTypedArray();
    this._labelsMesh.geometry.dirty();
};
$87f8de1342284ee1$var$LabelsBuilder.prototype.dispose = function() {
    this._labelTextureSurface.dispose();
};
var $87f8de1342284ee1$export$2e2bcd8739ae039 = $87f8de1342284ee1$var$LabelsBuilder;




var $5a38c1b2963f6585$var$vec3 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).vec3;
(0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.import((0, $ceca9d93a3d35604$export$2e2bcd8739ae039));
function $5a38c1b2963f6585$var$Geo3DBuilder(api) {
    this.rootNode = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node(); // Cache triangulation result
    this._triangulationResults = {};
    this._shadersMap = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).COMMON_SHADERS.filter(function(shaderName) {
        return shaderName !== "shadow";
    }).reduce(function(obj, shaderName) {
        obj[shaderName] = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createShader("ecgl." + shaderName);
        return obj;
    }, {});
    this._linesShader = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createShader("ecgl.meshLines3D");
    var groundMaterials = {};
    (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).COMMON_SHADERS.forEach(function(shading) {
        groundMaterials[shading] = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
            shader: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createShader("ecgl." + shading)
        });
    });
    this._groundMaterials = groundMaterials;
    this._groundMesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
        geometry: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).PlaneGeometry({
            dynamic: true
        }),
        castShadow: false,
        renderNormal: true,
        $ignorePicking: true
    });
    this._groundMesh.rotation.rotateX(-Math.PI / 2);
    this._labelsBuilder = new (0, $87f8de1342284ee1$export$2e2bcd8739ae039)(512, 512, api); // Give a large render order.
    this._labelsBuilder.getMesh().renderOrder = 100;
    this._labelsBuilder.getMesh().material.depthTest = false;
    this.rootNode.add(this._labelsBuilder.getMesh());
    this._initMeshes();
    this._api = api;
}
$5a38c1b2963f6585$var$Geo3DBuilder.prototype = {
    constructor: $5a38c1b2963f6585$var$Geo3DBuilder,
    // Which dimension to extrude. Y or Z
    extrudeY: true,
    update: function(componentModel, ecModel, api, start, end) {
        var data = componentModel.getData();
        if (start == null) start = 0;
        if (end == null) end = data.count();
        this._startIndex = start;
        this._endIndex = end - 1;
        this._triangulation(componentModel, start, end);
        var shader = this._getShader(componentModel.get("shading"));
        this._prepareMesh(componentModel, shader, api, start, end);
        this.rootNode.updateWorldTransform();
        this._updateRegionMesh(componentModel, api, start, end);
        var coordSys = componentModel.coordinateSystem; // PENDING
        if (coordSys.type === "geo3D") this._updateGroundPlane(componentModel, coordSys, api);
        var self = this;
        this._labelsBuilder.updateData(data, start, end);
        this._labelsBuilder.getLabelPosition = function(dataIndex, positionDesc, distance) {
            var name = data.getName(dataIndex);
            var center;
            var height = distance;
            if (coordSys.type === "geo3D") {
                var region = coordSys.getRegion(name);
                if (!region) return [
                    NaN,
                    NaN,
                    NaN
                ];
                center = region.getCenter();
                var pos = coordSys.dataToPoint([
                    center[0],
                    center[1],
                    height
                ]);
                return pos;
            } else {
                var tmp = self._triangulationResults[dataIndex - self._startIndex];
                var center = self.extrudeY ? [
                    (tmp.max[0] + tmp.min[0]) / 2,
                    tmp.max[1] + height,
                    (tmp.max[2] + tmp.min[2]) / 2
                ] : [
                    (tmp.max[0] + tmp.min[0]) / 2,
                    (tmp.max[1] + tmp.min[1]) / 2,
                    tmp.max[2] + height
                ];
            }
        };
        this._data = data;
        this._labelsBuilder.updateLabels();
        this._updateDebugWireframe(componentModel); // Reset some state.
        this._lastHoverDataIndex = 0;
    },
    _initMeshes: function() {
        var self = this;
        function createPolygonMesh() {
            var mesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
                name: "Polygon",
                material: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
                    shader: self._shadersMap.lambert
                }),
                geometry: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Geometry({
                    sortTriangles: true,
                    dynamic: true
                }),
                // TODO Disable culling
                culling: false,
                ignorePicking: true,
                // Render normal in normal pass
                renderNormal: true
            });
            Object.assign(mesh.geometry, (0, $fd6f60f8a754e772$export$2e2bcd8739ae039));
            return mesh;
        }
        var polygonMesh = createPolygonMesh();
        var linesMesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
            material: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
                shader: this._linesShader
            }),
            castShadow: false,
            ignorePicking: true,
            $ignorePicking: true,
            geometry: new (0, $8c084a5220a66e92$export$2e2bcd8739ae039)({
                useNativeLine: false
            })
        });
        this.rootNode.add(polygonMesh);
        this.rootNode.add(linesMesh);
        polygonMesh.material.define("both", "VERTEX_COLOR");
        polygonMesh.material.define("fragment", "DOUBLE_SIDED");
        this._polygonMesh = polygonMesh;
        this._linesMesh = linesMesh;
        this.rootNode.add(this._groundMesh);
    },
    _getShader: function(shading) {
        var shader = this._shadersMap[shading];
        if (!shader) shader = this._shadersMap.lambert;
        shader.__shading = shading;
        return shader;
    },
    _prepareMesh: function(componentModel, shader, api, start, end) {
        var polygonVertexCount = 0;
        var polygonTriangleCount = 0;
        var linesVertexCount = 0;
        var linesTriangleCount = 0; // TODO Lines
        for(var idx = start; idx < end; idx++){
            var polyInfo = this._getRegionPolygonInfo(idx);
            var lineInfo = this._getRegionLinesInfo(idx, componentModel, this._linesMesh.geometry);
            polygonVertexCount += polyInfo.vertexCount;
            polygonTriangleCount += polyInfo.triangleCount;
            linesVertexCount += lineInfo.vertexCount;
            linesTriangleCount += lineInfo.triangleCount;
        }
        var polygonMesh = this._polygonMesh;
        var polygonGeo = polygonMesh.geometry;
        [
            "position",
            "normal",
            "texcoord0",
            "color"
        ].forEach(function(attrName) {
            polygonGeo.attributes[attrName].init(polygonVertexCount);
        });
        polygonGeo.indices = polygonVertexCount > 0xffff ? new Uint32Array(polygonTriangleCount * 3) : new Uint16Array(polygonTriangleCount * 3);
        if (polygonMesh.material.shader !== shader) polygonMesh.material.attachShader(shader, true);
        (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).setMaterialFromModel(shader.__shading, polygonMesh.material, componentModel, api);
        if (linesVertexCount > 0) {
            this._linesMesh.geometry.resetOffset();
            this._linesMesh.geometry.setVertexCount(linesVertexCount);
            this._linesMesh.geometry.setTriangleCount(linesTriangleCount);
        } // Indexing data index from vertex index.
        this._dataIndexOfVertex = new Uint32Array(polygonVertexCount); // Indexing vertex index range from data index
        this._vertexRangeOfDataIndex = new Uint32Array((end - start) * 2);
    },
    _updateRegionMesh: function(componentModel, api, start, end) {
        var data = componentModel.getData();
        var vertexOffset = 0;
        var triangleOffset = 0; // Materials configurations.
        var hasTranparentRegion = false;
        var polygonMesh = this._polygonMesh;
        var linesMesh = this._linesMesh;
        for(var dataIndex = start; dataIndex < end; dataIndex++){
            // Get bunch of visual properties.
            var regionModel = componentModel.getRegionModel(dataIndex);
            var itemStyleModel = regionModel.getModel("itemStyle");
            var color = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull((0, $4c1f03531dad0b09$export$bc92a5a7848039f)(data, dataIndex), itemStyleModel.get("color"), "#fff");
            var opacity = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull((0, $4c1f03531dad0b09$export$f154d4dab8f4e8c0)(data, dataIndex), itemStyleModel.get("opacity"), 1);
            var colorArr = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(color);
            var borderColorArr = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(itemStyleModel.get("borderColor"));
            colorArr[3] *= opacity;
            borderColorArr[3] *= opacity;
            var isTransparent = colorArr[3] < 0.99;
            polygonMesh.material.set("color", [
                1,
                1,
                1,
                1
            ]);
            hasTranparentRegion = hasTranparentRegion || isTransparent;
            var regionHeight = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(regionModel.get("height", true), componentModel.get("regionHeight"));
            var newOffsets = this._updatePolygonGeometry(componentModel, polygonMesh.geometry, dataIndex, regionHeight, vertexOffset, triangleOffset, colorArr);
            for(var i = vertexOffset; i < newOffsets.vertexOffset; i++)this._dataIndexOfVertex[i] = dataIndex;
            this._vertexRangeOfDataIndex[(dataIndex - start) * 2] = vertexOffset;
            this._vertexRangeOfDataIndex[(dataIndex - start) * 2 + 1] = newOffsets.vertexOffset;
            vertexOffset = newOffsets.vertexOffset;
            triangleOffset = newOffsets.triangleOffset; // Update lines.
            var lineWidth = itemStyleModel.get("borderWidth");
            var hasLine = lineWidth > 0;
            if (hasLine) {
                lineWidth *= api.getDevicePixelRatio();
                this._updateLinesGeometry(linesMesh.geometry, componentModel, dataIndex, regionHeight, lineWidth, componentModel.coordinateSystem.transform);
            }
            linesMesh.invisible = !hasLine;
            linesMesh.material.set({
                color: borderColorArr
            });
        }
        var polygonMesh = this._polygonMesh;
        polygonMesh.material.transparent = hasTranparentRegion;
        polygonMesh.material.depthMask = !hasTranparentRegion;
        polygonMesh.geometry.updateBoundingBox();
        polygonMesh.frontFace = this.extrudeY ? (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh.CCW : (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh.CW; // Update tangents
        if (polygonMesh.material.get("normalMap")) polygonMesh.geometry.generateTangents();
        polygonMesh.seriesIndex = componentModel.seriesIndex;
        polygonMesh.on("mousemove", this._onmousemove, this);
        polygonMesh.on("mouseout", this._onmouseout, this);
    },
    _updateDebugWireframe: function(componentModel) {
        var debugWireframeModel = componentModel.getModel("debug.wireframe"); // TODO Unshow
        if (debugWireframeModel.get("show")) {
            var color = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(debugWireframeModel.get("lineStyle.color") || "rgba(0,0,0,0.5)");
            var width = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(debugWireframeModel.get("lineStyle.width"), 1); // TODO  Will cause highlight wrong
            var mesh = this._polygonMesh;
            mesh.geometry.generateBarycentric();
            mesh.material.define("both", "WIREFRAME_TRIANGLE");
            mesh.material.set("wireframeLineColor", color);
            mesh.material.set("wireframeLineWidth", width);
        }
    },
    _onmousemove: function(e) {
        var dataIndex = this._dataIndexOfVertex[e.triangle[0]];
        if (dataIndex == null) dataIndex = -1;
        if (dataIndex !== this._lastHoverDataIndex) {
            this.downplay(this._lastHoverDataIndex);
            this.highlight(dataIndex);
            this._labelsBuilder.updateLabels([
                dataIndex
            ]);
        }
        this._lastHoverDataIndex = dataIndex;
        this._polygonMesh.dataIndex = dataIndex;
    },
    _onmouseout: function(e) {
        if (e.target) {
            this.downplay(this._lastHoverDataIndex);
            this._lastHoverDataIndex = -1;
            this._polygonMesh.dataIndex = -1;
        }
        this._labelsBuilder.updateLabels([]);
    },
    _updateGroundPlane: function(componentModel, geo3D, api) {
        var groundModel = componentModel.getModel("groundPlane", componentModel);
        this._groundMesh.invisible = !groundModel.get("show", true);
        if (this._groundMesh.invisible) return;
        var shading = componentModel.get("shading");
        var material = this._groundMaterials[shading];
        if (!material) material = this._groundMaterials.lambert;
        (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).setMaterialFromModel(shading, material, groundModel, api);
        if (material.get("normalMap")) this._groundMesh.geometry.generateTangents();
        this._groundMesh.material = material;
        this._groundMesh.material.set("color", (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(groundModel.get("color")));
        this._groundMesh.scale.set(geo3D.size[0], geo3D.size[2], 1);
    },
    _triangulation: function(componentModel, start, end) {
        this._triangulationResults = [];
        var minAll = [
            Infinity,
            Infinity,
            Infinity
        ];
        var maxAll = [
            -Infinity,
            -Infinity,
            -Infinity
        ];
        var coordSys = componentModel.coordinateSystem;
        for(var idx = start; idx < end; idx++){
            var polygons = [];
            var polygonCoords = componentModel.getRegionPolygonCoords(idx);
            for(var i = 0; i < polygonCoords.length; i++){
                var exterior = polygonCoords[i].exterior;
                var interiors = polygonCoords[i].interiors;
                var points = [];
                var holes = [];
                if (exterior.length < 3) continue;
                var offset = 0;
                for(var j = 0; j < exterior.length; j++){
                    var p = exterior[j];
                    points[offset++] = p[0];
                    points[offset++] = p[1];
                }
                for(var j = 0; j < interiors.length; j++){
                    if (interiors[j].length < 3) continue;
                    var startIdx = points.length / 2;
                    for(var k = 0; k < interiors[j].length; k++){
                        var p = interiors[j][k];
                        points.push(p[0]);
                        points.push(p[1]);
                    }
                    holes.push(startIdx);
                }
                var triangles = (0, $d89fac3cf5d8a380$export$2e2bcd8739ae039)(points, holes);
                var points3 = new Float64Array(points.length / 2 * 3);
                var pos = [];
                var min = [
                    Infinity,
                    Infinity,
                    Infinity
                ];
                var max = [
                    -Infinity,
                    -Infinity,
                    -Infinity
                ];
                var off3 = 0;
                for(var j = 0; j < points.length;){
                    $5a38c1b2963f6585$var$vec3.set(pos, points[j++], 0, points[j++]);
                    if (coordSys && coordSys.transform) $5a38c1b2963f6585$var$vec3.transformMat4(pos, pos, coordSys.transform);
                    $5a38c1b2963f6585$var$vec3.min(min, min, pos);
                    $5a38c1b2963f6585$var$vec3.max(max, max, pos);
                    points3[off3++] = pos[0];
                    points3[off3++] = pos[1];
                    points3[off3++] = pos[2];
                }
                $5a38c1b2963f6585$var$vec3.min(minAll, minAll, min);
                $5a38c1b2963f6585$var$vec3.max(maxAll, maxAll, max);
                polygons.push({
                    points: points3,
                    indices: triangles,
                    min: min,
                    max: max
                });
            }
            this._triangulationResults.push(polygons);
        }
        this._geoBoundingBox = [
            minAll,
            maxAll
        ];
    },
    /**
   * Get region vertex and triangle count
   */ _getRegionPolygonInfo: function(idx) {
        var polygons = this._triangulationResults[idx - this._startIndex];
        var sideVertexCount = 0;
        var sideTriangleCount = 0;
        for(var i = 0; i < polygons.length; i++){
            sideVertexCount += polygons[i].points.length / 3;
            sideTriangleCount += polygons[i].indices.length / 3;
        }
        var vertexCount = sideVertexCount * 2 + sideVertexCount * 4;
        var triangleCount = sideTriangleCount * 2 + sideVertexCount * 2;
        return {
            vertexCount: vertexCount,
            triangleCount: triangleCount
        };
    },
    _updatePolygonGeometry: function(componentModel, geometry, dataIndex, regionHeight, vertexOffset, triangleOffset, color) {
        // FIXME
        var projectUVOnGround = componentModel.get("projectUVOnGround");
        var positionAttr = geometry.attributes.position;
        var normalAttr = geometry.attributes.normal;
        var texcoordAttr = geometry.attributes.texcoord0;
        var colorAttr = geometry.attributes.color;
        var polygons = this._triangulationResults[dataIndex - this._startIndex];
        var hasColor = colorAttr.value && color;
        var indices = geometry.indices;
        var extrudeCoordIndex = this.extrudeY ? 1 : 2;
        var sideCoordIndex = this.extrudeY ? 2 : 1;
        var scale = [
            this.rootNode.worldTransform.x.len(),
            this.rootNode.worldTransform.y.len(),
            this.rootNode.worldTransform.z.len()
        ];
        var min = $5a38c1b2963f6585$var$vec3.mul([], this._geoBoundingBox[0], scale);
        var max = $5a38c1b2963f6585$var$vec3.mul([], this._geoBoundingBox[1], scale);
        var maxDimSize = Math.max(max[0] - min[0], max[2] - min[2]);
        function addVertices(polygon, y, insideOffset) {
            var points = polygon.points;
            var pointsLen = points.length;
            var currentPosition = [];
            var uv = [];
            for(var k = 0; k < pointsLen; k += 3){
                currentPosition[0] = points[k];
                currentPosition[extrudeCoordIndex] = y;
                currentPosition[sideCoordIndex] = points[k + 2];
                uv[0] = (points[k] * scale[0] - min[0]) / maxDimSize;
                uv[1] = (points[k + 2] * scale[sideCoordIndex] - min[2]) / maxDimSize;
                positionAttr.set(vertexOffset, currentPosition);
                if (hasColor) colorAttr.set(vertexOffset, color);
                texcoordAttr.set(vertexOffset++, uv);
            }
        }
        function buildTopBottom(polygon, y, insideOffset) {
            var startVertexOffset = vertexOffset;
            addVertices(polygon, y, insideOffset);
            var len = polygon.indices.length;
            for(var k = 0; k < len; k++)indices[triangleOffset * 3 + k] = polygon.indices[k] + startVertexOffset;
            triangleOffset += polygon.indices.length / 3;
        }
        var normalTop = this.extrudeY ? [
            0,
            1,
            0
        ] : [
            0,
            0,
            1
        ];
        var normalBottom = $5a38c1b2963f6585$var$vec3.negate([], normalTop);
        for(var p = 0; p < polygons.length; p++){
            var startVertexOffset = vertexOffset;
            var polygon = polygons[p]; // BOTTOM
            buildTopBottom(polygon, 0, 0); // TOP
            buildTopBottom(polygon, regionHeight, 0);
            var ringVertexCount = polygon.points.length / 3;
            for(var v = 0; v < ringVertexCount; v++){
                normalAttr.set(startVertexOffset + v, normalBottom);
                normalAttr.set(startVertexOffset + v + ringVertexCount, normalTop);
            }
            var quadToTriangle = [
                0,
                3,
                1,
                1,
                3,
                2
            ];
            var quadPos = [
                [],
                [],
                [],
                []
            ];
            var a = [];
            var b = [];
            var normal = [];
            var uv = [];
            var len = 0;
            for(var v = 0; v < ringVertexCount; v++){
                var next = (v + 1) % ringVertexCount;
                var dx = (polygon.points[next * 3] - polygon.points[v * 3]) * scale[0];
                var dy = (polygon.points[next * 3 + 2] - polygon.points[v * 3 + 2]) * scale[sideCoordIndex];
                var sideLen = Math.sqrt(dx * dx + dy * dy); // 0----1
                // 3----2
                for(var k = 0; k < 4; k++){
                    var isCurrent = k === 0 || k === 3;
                    var idx3 = (isCurrent ? v : next) * 3;
                    quadPos[k][0] = polygon.points[idx3];
                    quadPos[k][extrudeCoordIndex] = k > 1 ? regionHeight : 0;
                    quadPos[k][sideCoordIndex] = polygon.points[idx3 + 2];
                    positionAttr.set(vertexOffset + k, quadPos[k]);
                    if (projectUVOnGround) {
                        uv[0] = (polygon.points[idx3] * scale[0] - min[0]) / maxDimSize;
                        uv[1] = (polygon.points[idx3 + 2] * scale[sideCoordIndex] - min[sideCoordIndex]) / maxDimSize;
                    } else {
                        uv[0] = (isCurrent ? len : len + sideLen) / maxDimSize;
                        uv[1] = (quadPos[k][extrudeCoordIndex] * scale[extrudeCoordIndex] - min[extrudeCoordIndex]) / maxDimSize;
                    }
                    texcoordAttr.set(vertexOffset + k, uv);
                }
                $5a38c1b2963f6585$var$vec3.sub(a, quadPos[1], quadPos[0]);
                $5a38c1b2963f6585$var$vec3.sub(b, quadPos[3], quadPos[0]);
                $5a38c1b2963f6585$var$vec3.cross(normal, a, b);
                $5a38c1b2963f6585$var$vec3.normalize(normal, normal);
                for(var k = 0; k < 4; k++){
                    normalAttr.set(vertexOffset + k, normal);
                    if (hasColor) colorAttr.set(vertexOffset + k, color);
                }
                for(var k = 0; k < 6; k++)indices[triangleOffset * 3 + k] = quadToTriangle[k] + vertexOffset;
                vertexOffset += 4;
                triangleOffset += 2;
                len += sideLen;
            }
        }
        geometry.dirty();
        return {
            vertexOffset: vertexOffset,
            triangleOffset: triangleOffset
        };
    },
    _getRegionLinesInfo: function(idx, componentModel, geometry) {
        var vertexCount = 0;
        var triangleCount = 0;
        var regionModel = componentModel.getRegionModel(idx);
        var itemStyleModel = regionModel.getModel("itemStyle");
        var lineWidth = itemStyleModel.get("borderWidth");
        if (lineWidth > 0) {
            var polygonCoords = componentModel.getRegionPolygonCoords(idx);
            polygonCoords.forEach(function(coords) {
                var exterior = coords.exterior;
                var interiors = coords.interiors;
                vertexCount += geometry.getPolylineVertexCount(exterior);
                triangleCount += geometry.getPolylineTriangleCount(exterior);
                for(var i = 0; i < interiors.length; i++){
                    vertexCount += geometry.getPolylineVertexCount(interiors[i]);
                    triangleCount += geometry.getPolylineTriangleCount(interiors[i]);
                }
            }, this);
        }
        return {
            vertexCount: vertexCount,
            triangleCount: triangleCount
        };
    },
    _updateLinesGeometry: function(geometry, componentModel, dataIndex, regionHeight, lineWidth, transform) {
        function convertToPoints3(polygon) {
            var points = new Float64Array(polygon.length * 3);
            var offset = 0;
            var pos = [];
            for(var i = 0; i < polygon.length; i++){
                pos[0] = polygon[i][0]; // Add a offset to avoid z-fighting
                pos[1] = regionHeight + 0.1;
                pos[2] = polygon[i][1];
                if (transform) $5a38c1b2963f6585$var$vec3.transformMat4(pos, pos, transform);
                points[offset++] = pos[0];
                points[offset++] = pos[1];
                points[offset++] = pos[2];
            }
            return points;
        }
        var whiteColor = [
            1,
            1,
            1,
            1
        ];
        var coords = componentModel.getRegionPolygonCoords(dataIndex);
        coords.forEach(function(geo) {
            var exterior = geo.exterior;
            var interiors = geo.interiors;
            geometry.addPolyline(convertToPoints3(exterior), whiteColor, lineWidth);
            for(var i = 0; i < interiors.length; i++)geometry.addPolyline(convertToPoints3(interiors[i]), whiteColor, lineWidth);
        });
    },
    highlight: function(dataIndex) {
        var data = this._data;
        if (!data) return;
        var itemModel = data.getItemModel(dataIndex);
        var emphasisItemStyleModel = itemModel.getModel([
            "emphasis",
            "itemStyle"
        ]);
        var emphasisColor = emphasisItemStyleModel.get("color");
        var emphasisOpacity = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(emphasisItemStyleModel.get("opacity"), (0, $4c1f03531dad0b09$export$f154d4dab8f4e8c0)(data, dataIndex), 1);
        if (emphasisColor == null) {
            var color = (0, $4c1f03531dad0b09$export$bc92a5a7848039f)(data, dataIndex);
            emphasisColor = $2c037f5bda6341ca$exports.lift(color, -0.4);
        }
        if (emphasisOpacity == null) emphasisOpacity = (0, $4c1f03531dad0b09$export$f154d4dab8f4e8c0)(data, dataIndex);
        var colorArr = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(emphasisColor);
        colorArr[3] *= emphasisOpacity;
        this._setColorOfDataIndex(data, dataIndex, colorArr);
    },
    downplay: function(dataIndex) {
        var data = this._data;
        if (!data) return;
        var itemStyleModel = data.getItemModel(dataIndex);
        var color = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull((0, $4c1f03531dad0b09$export$bc92a5a7848039f)(data, dataIndex), itemStyleModel.get([
            "itemStyle",
            "color"
        ]), "#fff");
        var opacity = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull((0, $4c1f03531dad0b09$export$f154d4dab8f4e8c0)(data, dataIndex), itemStyleModel.get([
            "itemStyle",
            "opacity"
        ]), 1);
        var colorArr = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(color);
        colorArr[3] *= opacity;
        this._setColorOfDataIndex(data, dataIndex, colorArr);
    },
    dispose: function() {
        this._labelsBuilder.dispose();
    },
    _setColorOfDataIndex: function(data, dataIndex, colorArr) {
        if (dataIndex < this._startIndex && dataIndex > this._endIndex) return;
        dataIndex -= this._startIndex;
        for(var i = this._vertexRangeOfDataIndex[dataIndex * 2]; i < this._vertexRangeOfDataIndex[dataIndex * 2 + 1]; i++)this._polygonMesh.geometry.attributes.color.set(i, colorArr);
        this._polygonMesh.geometry.dirty();
        this._api.getZr().refresh();
    }
};
var $5a38c1b2963f6585$export$2e2bcd8739ae039 = $5a38c1b2963f6585$var$Geo3DBuilder;






var $7dad91c2d78b3206$export$2e2bcd8739ae039 = $737c88aa0711f65a$export$2e2bcd8739ae039.extend({
    type: "geo3D",
    __ecgl__: true,
    init: function(ecModel, api) {
        this._geo3DBuilder = new (0, $5a38c1b2963f6585$export$2e2bcd8739ae039)(api);
        this.groupGL = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
        this._lightRoot = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
        this._sceneHelper = new (0, $ace7021e37e6bf94$export$2e2bcd8739ae039)(this._lightRoot);
        this._sceneHelper.initLight(this._lightRoot);
        this._control = new (0, $885dfecb57787ce0$export$2e2bcd8739ae039)({
            zr: api.getZr()
        });
        this._control.init();
    },
    render: function(geo3DModel, ecModel, api) {
        this.groupGL.add(this._geo3DBuilder.rootNode);
        var geo3D = geo3DModel.coordinateSystem;
        if (!geo3D || !geo3D.viewGL) return;
         // Always have light.
        geo3D.viewGL.add(this._lightRoot);
        if (geo3DModel.get("show")) geo3D.viewGL.add(this.groupGL);
        else geo3D.viewGL.remove(this.groupGL);
        var control = this._control;
        control.setViewGL(geo3D.viewGL);
        var viewControlModel = geo3DModel.getModel("viewControl");
        control.setFromViewControlModel(viewControlModel, 0);
        this._sceneHelper.setScene(geo3D.viewGL.scene);
        this._sceneHelper.updateLight(geo3DModel); // Set post effect
        geo3D.viewGL.setPostEffect(geo3DModel.getModel("postEffect"), api);
        geo3D.viewGL.setTemporalSuperSampling(geo3DModel.getModel("temporalSuperSampling")); // Must update after geo3D.viewGL.setPostEffect
        this._geo3DBuilder.update(geo3DModel, ecModel, api, 0, geo3DModel.getData().count());
        var srgbDefineMethod = geo3D.viewGL.isLinearSpace() ? "define" : "undefine";
        this._geo3DBuilder.rootNode.traverse(function(mesh) {
            if (mesh.material) mesh.material[srgbDefineMethod]("fragment", "SRGB_DECODE");
        });
        control.off("update");
        control.on("update", function() {
            api.dispatchAction({
                type: "geo3DChangeCamera",
                alpha: control.getAlpha(),
                beta: control.getBeta(),
                distance: control.getDistance(),
                center: control.getCenter(),
                from: this.uid,
                geo3DId: geo3DModel.id
            });
        });
        control.update();
    },
    afterRender: function(geo3DModel, ecModel, api, layerGL) {
        var renderer = layerGL.renderer;
        this._sceneHelper.updateAmbientCubemap(renderer, geo3DModel, api);
        this._sceneHelper.updateSkybox(renderer, geo3DModel, api);
    },
    dispose: function() {
        this._control.dispose();
        this._geo3DBuilder.dispose();
    }
});





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $95a1e0349ef86fb0$var$geoCoordMap = {
    "Russia": [
        100,
        60
    ],
    "United States": [
        -99,
        38
    ],
    "United States of America": [
        -99,
        38
    ]
};
function $95a1e0349ef86fb0$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === "world") {
        var geoCoord = $95a1e0349ef86fb0$var$geoCoordMap[region.name];
        if (geoCoord) {
            var cp = [
                geoCoord[0],
                geoCoord[1]
            ];
            region.setCenter(cp);
        }
    }
}


var $92fa3f9b3a2cf473$var$vec3 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).vec3;
var $92fa3f9b3a2cf473$var$mat4 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).mat4;
var $92fa3f9b3a2cf473$var$geoFixFuncs = [
    (0, $280c32529827bd03$export$2e2bcd8739ae039),
    (0, $95a1e0349ef86fb0$export$2e2bcd8739ae039)
];
function $92fa3f9b3a2cf473$var$Geo3D(name, map, geoJson, specialAreas, nameMap) {
    this.name = name;
    this.map = map;
    this.regionHeight = 0;
    this.regions = [];
    this._nameCoordMap = {};
    this.loadGeoJson(geoJson, specialAreas, nameMap);
    this.transform = $92fa3f9b3a2cf473$var$mat4.identity(new Float64Array(16));
    this.invTransform = $92fa3f9b3a2cf473$var$mat4.identity(new Float64Array(16)); // Which dimension to extrude. Y or Z
    this.extrudeY = true;
    this.altitudeAxis;
}
$92fa3f9b3a2cf473$var$Geo3D.prototype = {
    constructor: $92fa3f9b3a2cf473$var$Geo3D,
    type: "geo3D",
    dimensions: [
        "lng",
        "lat",
        "alt"
    ],
    containPoint: function() {},
    loadGeoJson: function(geoJson, specialAreas, nameMap) {
        var parseGeoJSON = $1a1de70a2b6a5dc5$export$2e2bcd8739ae039 || $1a1de70a2b6a5dc5$export$2e2bcd8739ae039;
        try {
            this.regions = geoJson ? parseGeoJSON(geoJson) : [];
        } catch (e) {
            throw "Invalid geoJson format\n" + e;
        }
        specialAreas = specialAreas || {};
        nameMap = nameMap || {};
        var regions = this.regions;
        var regionsMap = {};
        for(var i = 0; i < regions.length; i++){
            var regionName = regions[i].name; // Try use the alias in nameMap
            regionName = nameMap[regionName] || regionName;
            regions[i].name = regionName;
            regionsMap[regionName] = regions[i]; // Add geoJson
            this.addGeoCoord(regionName, regions[i].getCenter()); // Some area like Alaska in USA map needs to be tansformed
            // to look better
            var specialArea = specialAreas[regionName];
            if (specialArea) regions[i].transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
        }
        this._regionsMap = regionsMap;
        this._geoRect = null;
        $92fa3f9b3a2cf473$var$geoFixFuncs.forEach(function(fixFunc) {
            fixFunc(this);
        }, this);
    },
    getGeoBoundingRect: function() {
        if (this._geoRect) return this._geoRect;
        var rect;
        var regions = this.regions;
        for(var i = 0; i < regions.length; i++){
            var regionRect = regions[i].getBoundingRect();
            rect = rect || regionRect.clone();
            rect.union(regionRect);
        } // FIXME Always return new ?
        return this._geoRect = rect || new $03154d907069e78f$exports.BoundingRect(0, 0, 0, 0);
    },
    /**
   * Add geoCoord for indexing by name
   * @param {string} name
   * @param {Array.<number>} geoCoord
   */ addGeoCoord: function(name, geoCoord) {
        this._nameCoordMap[name] = geoCoord;
    },
    /**
   * @param {string} name
   * @return {module:echarts/coord/geo/Region}
   */ getRegion: function(name) {
        return this._regionsMap[name];
    },
    getRegionByCoord: function(coord) {
        var regions = this.regions;
        for(var i = 0; i < regions.length; i++){
            if (regions[i].contain(coord)) return regions[i];
        }
    },
    setSize: function(width, height, depth) {
        this.size = [
            width,
            height,
            depth
        ];
        var rect = this.getGeoBoundingRect();
        var scaleX = width / rect.width;
        var scaleZ = -depth / rect.height;
        var translateX = -width / 2 - rect.x * scaleX;
        var translateZ = depth / 2 - rect.y * scaleZ;
        var position = this.extrudeY ? [
            translateX,
            0,
            translateZ
        ] : [
            translateX,
            translateZ,
            0
        ];
        var scale = this.extrudeY ? [
            scaleX,
            1,
            scaleZ
        ] : [
            scaleX,
            scaleZ,
            1
        ];
        var m = this.transform;
        $92fa3f9b3a2cf473$var$mat4.identity(m);
        $92fa3f9b3a2cf473$var$mat4.translate(m, m, position);
        $92fa3f9b3a2cf473$var$mat4.scale(m, m, scale);
        $92fa3f9b3a2cf473$var$mat4.invert(this.invTransform, m);
    },
    dataToPoint: function(data, out) {
        out = out || [];
        var extrudeCoordIndex = this.extrudeY ? 1 : 2;
        var sideCoordIndex = this.extrudeY ? 2 : 1;
        var altitudeVal = data[2]; // PENDING.
        if (isNaN(altitudeVal)) altitudeVal = 0;
         // lng
        out[0] = data[0]; // lat
        out[sideCoordIndex] = data[1];
        if (this.altitudeAxis) out[extrudeCoordIndex] = this.altitudeAxis.dataToCoord(altitudeVal);
        else out[extrudeCoordIndex] = 0;
         // PENDING different region height.
        out[extrudeCoordIndex] += this.regionHeight;
        $92fa3f9b3a2cf473$var$vec3.transformMat4(out, out, this.transform);
        return out;
    },
    pointToData: function(point, out) {}
};
var $92fa3f9b3a2cf473$export$2e2bcd8739ae039 = $92fa3f9b3a2cf473$var$Geo3D;






function $edd42ab1a70aa2aa$var$resizeGeo3D(geo3DModel, api) {
    // Use left/top/width/height
    var boxLayoutOption = geo3DModel.getBoxLayoutParams();
    var viewport = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(boxLayoutOption, {
        width: api.getWidth(),
        height: api.getHeight()
    }); // Flip Y
    viewport.y = api.getHeight() - viewport.y - viewport.height;
    this.viewGL.setViewport(viewport.x, viewport.y, viewport.width, viewport.height, api.getDevicePixelRatio());
    var geoRect = this.getGeoBoundingRect();
    var aspect = geoRect.width / geoRect.height * (geo3DModel.get("aspectScale") || 0.75);
    var width = geo3DModel.get("boxWidth");
    var depth = geo3DModel.get("boxDepth");
    var height = geo3DModel.get("boxHeight");
    if (height == null) height = 5;
    if (isNaN(width) && isNaN(depth)) // Default to have 100 width
    width = 100;
    if (isNaN(depth)) depth = width / aspect;
    else if (isNaN(width)) width = depth / aspect;
    this.setSize(width, height, depth);
    this.regionHeight = geo3DModel.get("regionHeight");
    if (this.altitudeAxis) this.altitudeAxis.setExtent(0, Math.max(height - this.regionHeight, 0));
}
function $edd42ab1a70aa2aa$var$updateGeo3D(ecModel, api) {
    var altitudeDataExtent = [
        Infinity,
        -Infinity
    ];
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.coordinateSystem !== this) return;
        if (seriesModel.type === "series.map3D") return;
         // Get altitude data extent.
        var data = seriesModel.getData();
        var altDims = seriesModel.coordDimToDataDim("alt");
        var altDim = altDims && altDims[0];
        if (altDim) {
            // TODO altitiude is in coords of lines.
            var dataExtent = data.getDataExtent(altDim, true);
            altitudeDataExtent[0] = Math.min(altitudeDataExtent[0], dataExtent[0]);
            altitudeDataExtent[1] = Math.max(altitudeDataExtent[1], dataExtent[1]);
        }
    }, this); // Create altitude axis
    if (altitudeDataExtent && isFinite(altitudeDataExtent[1] - altitudeDataExtent[0])) {
        var scale = $9a616079ee96a3f3$exports.createScale(altitudeDataExtent, {
            type: "value",
            // PENDING
            min: "dataMin",
            max: "dataMax"
        });
        this.altitudeAxis = new $c2b1efffe5ae3f42$export$2e2bcd8739ae039("altitude", scale); // Resize again
        this.resize(this.model, api);
    }
}
var $edd42ab1a70aa2aa$var$mapNotExistsError;
var $edd42ab1a70aa2aa$var$idStart = 0;
var $edd42ab1a70aa2aa$var$geo3DCreator = {
    dimensions: (0, $92fa3f9b3a2cf473$export$2e2bcd8739ae039).prototype.dimensions,
    create: function(ecModel, api) {
        var geo3DList = [];
        if (!$4d59907f44a2d0ad$export$b8586192aead8a7e) throw new Error("geo3D component depends on geo component");
        function createGeo3D(componentModel, idx) {
            var geo3D = $edd42ab1a70aa2aa$var$geo3DCreator.createGeo3D(componentModel); // FIXME
            componentModel.__viewGL = componentModel.__viewGL || new (0, $7a0cfdd3f7cf77fd$export$2e2bcd8739ae039)();
            geo3D.viewGL = componentModel.__viewGL;
            componentModel.coordinateSystem = geo3D;
            geo3D.model = componentModel;
            geo3DList.push(geo3D); // Inject resize
            geo3D.resize = $edd42ab1a70aa2aa$var$resizeGeo3D;
            geo3D.resize(componentModel, api);
            geo3D.update = $edd42ab1a70aa2aa$var$updateGeo3D;
        }
        ecModel.eachComponent("geo3D", function(geo3DModel, idx) {
            createGeo3D(geo3DModel, idx);
        });
        ecModel.eachSeriesByType("map3D", function(map3DModel, idx) {
            var coordSys = map3DModel.get("coordinateSystem");
            if (coordSys == null) coordSys = "geo3D";
            if (coordSys === "geo3D") createGeo3D(map3DModel, idx);
        });
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.get("coordinateSystem") === "geo3D") {
                if (seriesModel.type === "series.map3D") return;
                var geo3DModel = seriesModel.getReferringComponents("geo3D").models[0];
                if (!geo3DModel) geo3DModel = ecModel.getComponent("geo3D");
                if (!geo3DModel) throw new Error('geo "' + (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(seriesModel.get("geo3DIndex"), seriesModel.get("geo3DId"), 0) + '" not found');
                seriesModel.coordinateSystem = geo3DModel.coordinateSystem;
            }
        });
        return geo3DList;
    },
    createGeo3D: function(componentModel) {
        var mapData = componentModel.get("map");
        var name;
        if (typeof mapData === "string") {
            name = mapData;
            mapData = $4d59907f44a2d0ad$export$b8586192aead8a7e(mapData);
        } else if (mapData && mapData.features) mapData = {
            geoJson: mapData
        };
        if (name == null) name = "GEO_ANONYMOUS_" + $edd42ab1a70aa2aa$var$idStart++;
        return new (0, $92fa3f9b3a2cf473$export$2e2bcd8739ae039)(name + $edd42ab1a70aa2aa$var$idStart++, name, mapData && mapData.geoJson, mapData && mapData.specialAreas, componentModel.get("nameMap"));
    }
};
var $edd42ab1a70aa2aa$export$2e2bcd8739ae039 = $edd42ab1a70aa2aa$var$geo3DCreator;


function $165543c14f960069$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $6a21d27b869520a5$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $7dad91c2d78b3206$export$2e2bcd8739ae039));
    registers.registerAction({
        type: "geo3DChangeCamera",
        event: "geo3dcamerachanged",
        update: "series:updateCamera"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "geo3D",
            query: payload
        }, function(componentModel) {
            componentModel.setView(payload);
        });
    });
    registers.registerCoordinateSystem("geo3D", (0, $edd42ab1a70aa2aa$export$2e2bcd8739ae039));
}


(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $165543c14f960069$export$4b3e715f166fdd78));



// TODO ECharts GL must be imported whatever component,charts is imported.






function $7b2cd16225184a64$var$defaultId(option, idx) {
    option.id = option.id || option.name || idx + "";
}
var $7b2cd16225184a64$var$GlobeModel = $116d65051f61bdfe$export$2e2bcd8739ae039.extend({
    type: "globe",
    layoutMode: "box",
    coordinateSystem: null,
    init: function() {
        $7b2cd16225184a64$var$GlobeModel.superApply(this, "init", arguments);
        $224386f1517b5dca$exports.each(this.option.layers, function(layerOption, idx) {
            $224386f1517b5dca$exports.merge(layerOption, this.defaultLayerOption);
            $7b2cd16225184a64$var$defaultId(layerOption, idx);
        }, this);
    },
    mergeOption: function(option) {
        // TODO test
        var oldLayers = this.option.layers;
        this.option.layers = null;
        $7b2cd16225184a64$var$GlobeModel.superApply(this, "mergeOption", arguments);
        function createLayerMap(layers) {
            return $224386f1517b5dca$exports.reduce(layers, function(obj, layerOption, idx) {
                $7b2cd16225184a64$var$defaultId(layerOption, idx);
                obj[layerOption.id] = layerOption;
                return obj;
            }, {});
        }
        if (oldLayers && oldLayers.length) {
            var newLayerMap = createLayerMap(option.layers);
            var oldLayerMap = createLayerMap(oldLayers);
            for(var id in newLayerMap)if (oldLayerMap[id]) $224386f1517b5dca$exports.merge(oldLayerMap[id], newLayerMap[id], true);
            else oldLayers.push(option.layers[id]);
             // Copy back
            this.option.layers = oldLayers;
        } // else overwrite
        // Set default
        $224386f1517b5dca$exports.each(this.option.layers, function(layerOption) {
            $224386f1517b5dca$exports.merge(layerOption, this.defaultLayerOption);
        }, this);
    },
    optionUpdated: function() {
        this.updateDisplacementHash();
    },
    defaultLayerOption: {
        show: true,
        type: "overlay"
    },
    defaultOption: {
        show: true,
        zlevel: -10,
        // Layout used for viewport
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        environment: "auto",
        baseColor: "#fff",
        // Base albedo texture
        baseTexture: "",
        // Height texture for bump mapping and vertex displacement
        heightTexture: "",
        // Texture for vertex displacement, default use heightTexture
        displacementTexture: "",
        // Scale of vertex displacement, available only if displacementTexture is set.
        displacementScale: 0,
        // Detail of displacement. 'low', 'medium', 'high', 'ultra'
        displacementQuality: "medium",
        // Globe radius
        globeRadius: 100,
        // Globe outer radius. Which is max of altitude.
        globeOuterRadius: 150,
        // Shading of globe
        shading: "lambert",
        // Extend light
        light: {
            // Main sun light
            main: {
                // Time, default it will use system time
                time: ""
            }
        },
        // atmosphere
        atmosphere: {
            show: false,
            offset: 5,
            color: "#ffffff",
            glowPower: 6.0,
            innerGlowPower: 2.0
        },
        // light
        // postEffect
        // temporalSuperSampling
        viewControl: {
            autoRotate: true,
            panSensitivity: 0,
            targetCoord: null
        },
        // {
        //     show: true,
        //     name: 'cloud',
        //     type: 'overlay',
        //     shading: 'lambert',
        //     distance: 10,
        //     texture: ''
        // }
        // {
        //     type: 'blend',
        //     blendTo: 'albedo'
        //     blendType: 'source-over'
        // }
        layers: []
    },
    setDisplacementData: function(data, width, height) {
        this.displacementData = data;
        this.displacementWidth = width;
        this.displacementHeight = height;
    },
    getDisplacementTexture: function() {
        return this.get("displacementTexture") || this.get("heightTexture");
    },
    getDisplacemenScale: function() {
        var displacementTexture = this.getDisplacementTexture();
        var displacementScale = this.get("displacementScale");
        if (!displacementTexture || displacementTexture === "none") displacementScale = 0;
        return displacementScale;
    },
    hasDisplacement: function() {
        return this.getDisplacemenScale() > 0;
    },
    _displacementChanged: true,
    _displacementScale: 0,
    updateDisplacementHash: function() {
        var displacementTexture = this.getDisplacementTexture();
        var displacementScale = this.getDisplacemenScale();
        this._displacementChanged = this._displacementTexture !== displacementTexture || this._displacementScale !== displacementScale;
        this._displacementTexture = displacementTexture;
        this._displacementScale = displacementScale;
    },
    isDisplacementChanged: function() {
        return this._displacementChanged;
    }
});
$224386f1517b5dca$exports.merge($7b2cd16225184a64$var$GlobeModel.prototype, (0, $a589af99ac3423f7$export$2e2bcd8739ae039));
$224386f1517b5dca$exports.merge($7b2cd16225184a64$var$GlobeModel.prototype, (0, $2d5450eeb3d59d52$export$2e2bcd8739ae039));
$224386f1517b5dca$exports.merge($7b2cd16225184a64$var$GlobeModel.prototype, (0, $39dfcb89b5cc4a69$export$2e2bcd8739ae039));
$224386f1517b5dca$exports.merge($7b2cd16225184a64$var$GlobeModel.prototype, (0, $f866f5803ca3a09a$export$2e2bcd8739ae039));
var $7b2cd16225184a64$export$2e2bcd8739ae039 = $7b2cd16225184a64$var$GlobeModel;






/*
 (c) 2011-2014, Vladimir Agafonkin
 SunCalc is a JavaScript library for calculating sun/mooon position and light phases.
 https://github.com/mourner/suncalc
*/ // shortcuts for easier to read formulas
var $25b0fb456b046912$var$PI = Math.PI, $25b0fb456b046912$var$sin = Math.sin, $25b0fb456b046912$var$cos = Math.cos, $25b0fb456b046912$var$tan = Math.tan, $25b0fb456b046912$var$asin = Math.asin, $25b0fb456b046912$var$atan = Math.atan2, $25b0fb456b046912$var$rad = $25b0fb456b046912$var$PI / 180; // sun calculations are based on http://aa.quae.nl/en/reken/zonpositie.html formulas
// date/time constants and conversions
var $25b0fb456b046912$var$dayMs = 86400000, $25b0fb456b046912$var$J1970 = 2440588, $25b0fb456b046912$var$J2000 = 2451545;
function $25b0fb456b046912$var$toJulian(date) {
    return date.valueOf() / $25b0fb456b046912$var$dayMs - 0.5 + $25b0fb456b046912$var$J1970;
}
function $25b0fb456b046912$var$toDays(date) {
    return $25b0fb456b046912$var$toJulian(date) - $25b0fb456b046912$var$J2000;
} // general calculations for position
var $25b0fb456b046912$var$e = $25b0fb456b046912$var$rad * 23.4397; // obliquity of the Earth
function $25b0fb456b046912$var$rightAscension(l, b) {
    return $25b0fb456b046912$var$atan($25b0fb456b046912$var$sin(l) * $25b0fb456b046912$var$cos($25b0fb456b046912$var$e) - $25b0fb456b046912$var$tan(b) * $25b0fb456b046912$var$sin($25b0fb456b046912$var$e), $25b0fb456b046912$var$cos(l));
}
function $25b0fb456b046912$var$declination(l, b) {
    return $25b0fb456b046912$var$asin($25b0fb456b046912$var$sin(b) * $25b0fb456b046912$var$cos($25b0fb456b046912$var$e) + $25b0fb456b046912$var$cos(b) * $25b0fb456b046912$var$sin($25b0fb456b046912$var$e) * $25b0fb456b046912$var$sin(l));
}
function $25b0fb456b046912$var$azimuth(H, phi, dec) {
    return $25b0fb456b046912$var$atan($25b0fb456b046912$var$sin(H), $25b0fb456b046912$var$cos(H) * $25b0fb456b046912$var$sin(phi) - $25b0fb456b046912$var$tan(dec) * $25b0fb456b046912$var$cos(phi));
}
function $25b0fb456b046912$var$altitude(H, phi, dec) {
    return $25b0fb456b046912$var$asin($25b0fb456b046912$var$sin(phi) * $25b0fb456b046912$var$sin(dec) + $25b0fb456b046912$var$cos(phi) * $25b0fb456b046912$var$cos(dec) * $25b0fb456b046912$var$cos(H));
}
function $25b0fb456b046912$var$siderealTime(d, lw) {
    return $25b0fb456b046912$var$rad * (280.16 + 360.9856235 * d) - lw;
} // general sun calculations
function $25b0fb456b046912$var$solarMeanAnomaly(d) {
    return $25b0fb456b046912$var$rad * (357.5291 + 0.98560028 * d);
}
function $25b0fb456b046912$var$eclipticLongitude(M) {
    var C = $25b0fb456b046912$var$rad * (1.9148 * $25b0fb456b046912$var$sin(M) + 0.02 * $25b0fb456b046912$var$sin(2 * M) + 0.0003 * $25b0fb456b046912$var$sin(3 * M)), // equation of center
    P = $25b0fb456b046912$var$rad * 102.9372; // perihelion of the Earth
    return M + C + P + $25b0fb456b046912$var$PI;
}
function $25b0fb456b046912$var$sunCoords(d) {
    var M = $25b0fb456b046912$var$solarMeanAnomaly(d), L = $25b0fb456b046912$var$eclipticLongitude(M);
    return {
        dec: $25b0fb456b046912$var$declination(L, 0),
        ra: $25b0fb456b046912$var$rightAscension(L, 0)
    };
}
var $25b0fb456b046912$var$SunCalc = {}; // calculates sun position for a given date and latitude/longitude
$25b0fb456b046912$var$SunCalc.getPosition = function(date, lat, lng) {
    var lw = $25b0fb456b046912$var$rad * -lng, phi = $25b0fb456b046912$var$rad * lat, d = $25b0fb456b046912$var$toDays(date), c = $25b0fb456b046912$var$sunCoords(d), H = $25b0fb456b046912$var$siderealTime(d, lw) - c.ra;
    return {
        azimuth: $25b0fb456b046912$var$azimuth(H, phi, c.dec),
        altitude: $25b0fb456b046912$var$altitude(H, phi, c.dec)
    };
};
var $25b0fb456b046912$export$2e2bcd8739ae039 = $25b0fb456b046912$var$SunCalc;




var $67b88002159028f6$export$2e2bcd8739ae039 = "@export ecgl.atmosphere.vertex\nattribute vec3 position: POSITION;\nattribute vec3 normal : NORMAL;\nuniform mat4 worldViewProjection : WORLDVIEWPROJECTION;\nuniform mat4 normalMatrix : WORLDINVERSETRANSPOSE;\n\nvarying vec3 v_Normal;\n\nvoid main() {\n v_Normal = normalize((normalMatrix * vec4(normal, 0.0)).xyz);\n gl_Position = worldViewProjection * vec4(position, 1.0);\n}\n@end\n\n\n@export ecgl.atmosphere.fragment\nuniform mat4 viewTranspose: VIEWTRANSPOSE;\nuniform float glowPower;\nuniform vec3 glowColor;\n\nvarying vec3 v_Normal;\n\nvoid main() {\n float intensity = pow(1.0 - dot(v_Normal, (viewTranspose * vec4(0.0, 0.0, 1.0, 0.0)).xyz), glowPower);\n gl_FragColor = vec4(glowColor, intensity * intensity);\n}\n@end";


(0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader["import"]((0, $bf045847478ef2ac$export$2e2bcd8739ae039));
(0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader["import"]((0, $67b88002159028f6$export$2e2bcd8739ae039));
var $b773f4a25c29c087$export$2e2bcd8739ae039 = $737c88aa0711f65a$export$2e2bcd8739ae039.extend({
    type: "globe",
    __ecgl__: true,
    _displacementScale: 0,
    init: function(ecModel, api) {
        this.groupGL = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
        /**
     * @type {clay.geometry.Sphere}
     * @private
     */ this._sphereGeometry = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).SphereGeometry({
            widthSegments: 200,
            heightSegments: 100,
            dynamic: true
        });
        this._overlayGeometry = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).SphereGeometry({
            widthSegments: 80,
            heightSegments: 40
        });
        /**
     * @type {clay.geometry.Plane}
     */ this._planeGeometry = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).PlaneGeometry();
        /**
     * @type {clay.geometry.Mesh}
     */ this._earthMesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
            renderNormal: true
        });
        /**
     * @type {clay.geometry.Mesh}
     */ this._atmosphereMesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh();
        this._atmosphereGeometry = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).SphereGeometry({
            widthSegments: 80,
            heightSegments: 40
        });
        this._atmosphereMaterial = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
            shader: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader((0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.source("ecgl.atmosphere.vertex"), (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.source("ecgl.atmosphere.fragment")),
            transparent: true
        });
        this._atmosphereMesh.geometry = this._atmosphereGeometry;
        this._atmosphereMesh.material = this._atmosphereMaterial;
        this._atmosphereMesh.frontFace = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh.CW;
        this._lightRoot = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
        this._sceneHelper = new (0, $ace7021e37e6bf94$export$2e2bcd8739ae039)();
        this._sceneHelper.initLight(this._lightRoot);
        this.groupGL.add(this._atmosphereMesh);
        this.groupGL.add(this._earthMesh);
        this._control = new (0, $885dfecb57787ce0$export$2e2bcd8739ae039)({
            zr: api.getZr()
        });
        this._control.init();
        this._layerMeshes = {};
    },
    render: function(globeModel, ecModel, api) {
        var coordSys = globeModel.coordinateSystem;
        var shading = globeModel.get("shading"); // Always have light.
        coordSys.viewGL.add(this._lightRoot);
        if (globeModel.get("show")) // Add self to scene;
        coordSys.viewGL.add(this.groupGL);
        else coordSys.viewGL.remove(this.groupGL);
        this._sceneHelper.setScene(coordSys.viewGL.scene); // Set post effect
        coordSys.viewGL.setPostEffect(globeModel.getModel("postEffect"), api);
        coordSys.viewGL.setTemporalSuperSampling(globeModel.getModel("temporalSuperSampling"));
        var earthMesh = this._earthMesh;
        earthMesh.geometry = this._sphereGeometry;
        var shadingPrefix = "ecgl." + shading;
        if (!earthMesh.material || earthMesh.material.shader.name !== shadingPrefix) earthMesh.material = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createMaterial(shadingPrefix);
        (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).setMaterialFromModel(shading, earthMesh.material, globeModel, api);
        [
            "roughnessMap",
            "metalnessMap",
            "detailMap",
            "normalMap"
        ].forEach(function(texName) {
            var texture = earthMesh.material.get(texName);
            if (texture) texture.flipY = false;
        });
        earthMesh.material.set("color", (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(globeModel.get("baseColor"))); // shrink a little
        var scale = coordSys.radius * 0.99;
        earthMesh.scale.set(scale, scale, scale);
        if (globeModel.get("atmosphere.show")) {
            earthMesh.material.define("both", "ATMOSPHERE_ENABLED");
            this._atmosphereMesh.invisible = false;
            this._atmosphereMaterial.setUniforms({
                glowPower: globeModel.get("atmosphere.glowPower") || 6.0,
                glowColor: globeModel.get("atmosphere.color") || "#ffffff"
            });
            earthMesh.material.setUniforms({
                glowPower: globeModel.get("atmosphere.innerGlowPower") || 2.0,
                glowColor: globeModel.get("atmosphere.color") || "#ffffff"
            });
            var offset = globeModel.get("atmosphere.offset") || 5;
            this._atmosphereMesh.scale.set(scale + offset, scale + offset, scale + offset);
        } else {
            earthMesh.material.undefine("both", "ATMOSPHERE_ENABLED");
            this._atmosphereMesh.invisible = true;
        }
        var diffuseTexture = earthMesh.material.setTextureImage("diffuseMap", globeModel.get("baseTexture"), api, {
            flipY: false,
            anisotropic: 8
        });
        if (diffuseTexture && diffuseTexture.surface) diffuseTexture.surface.attachToMesh(earthMesh);
         // Update bump map
        var bumpTexture = earthMesh.material.setTextureImage("bumpMap", globeModel.get("heightTexture"), api, {
            flipY: false,
            anisotropic: 8
        });
        if (bumpTexture && bumpTexture.surface) bumpTexture.surface.attachToMesh(earthMesh);
        earthMesh.material[globeModel.get("postEffect.enable") ? "define" : "undefine"]("fragment", "SRGB_DECODE");
        this._updateLight(globeModel, api);
        this._displaceVertices(globeModel, api);
        this._updateViewControl(globeModel, api);
        this._updateLayers(globeModel, api);
    },
    afterRender: function(globeModel, ecModel, api, layerGL) {
        // Create ambient cubemap after render because we need to know the renderer.
        // TODO
        var renderer = layerGL.renderer;
        this._sceneHelper.updateAmbientCubemap(renderer, globeModel, api);
        this._sceneHelper.updateSkybox(renderer, globeModel, api);
    },
    _updateLayers: function(globeModel, api) {
        var coordSys = globeModel.coordinateSystem;
        var layers = globeModel.get("layers");
        var lastDistance = coordSys.radius;
        var layerDiffuseTextures = [];
        var layerDiffuseIntensity = [];
        var layerEmissiveTextures = [];
        var layerEmissionIntensity = [];
        $224386f1517b5dca$exports.each(layers, function(layerOption) {
            var layerModel = new $6818646a97528290$export$2e2bcd8739ae039(layerOption);
            var layerType = layerModel.get("type");
            var texture = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).loadTexture(layerModel.get("texture"), api, {
                flipY: false,
                anisotropic: 8
            });
            if (texture.surface) texture.surface.attachToMesh(this._earthMesh);
            if (layerType === "blend") {
                var blendTo = layerModel.get("blendTo");
                var intensity = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(layerModel.get("intensity"), 1.0);
                if (blendTo === "emission") {
                    layerEmissiveTextures.push(texture);
                    layerEmissionIntensity.push(intensity);
                } else {
                    // Default is albedo
                    layerDiffuseTextures.push(texture);
                    layerDiffuseIntensity.push(intensity);
                }
            } else {
                // Default use overlay
                var id = layerModel.get("id");
                var overlayMesh = this._layerMeshes[id];
                if (!overlayMesh) overlayMesh = this._layerMeshes[id] = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
                    geometry: this._overlayGeometry,
                    castShadow: false,
                    ignorePicking: true
                });
                var shading = layerModel.get("shading");
                if (shading === "lambert") {
                    overlayMesh.material = overlayMesh.__lambertMaterial || new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
                        autoUpdateTextureStatus: false,
                        shader: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createShader("ecgl.lambert"),
                        transparent: true,
                        depthMask: false
                    });
                    overlayMesh.__lambertMaterial = overlayMesh.material;
                } else {
                    // color
                    overlayMesh.material = overlayMesh.__colorMaterial || new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
                        autoUpdateTextureStatus: false,
                        shader: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createShader("ecgl.color"),
                        transparent: true,
                        depthMask: false
                    });
                    overlayMesh.__colorMaterial = overlayMesh.material;
                } // overlay should be transparent if texture is not loaded yet.
                overlayMesh.material.enableTexture("diffuseMap");
                var distance = layerModel.get("distance"); // Based on distance of last layer
                var radius = lastDistance + (distance == null ? coordSys.radius / 100 : distance);
                overlayMesh.scale.set(radius, radius, radius);
                lastDistance = radius; // FIXME Exists blink.
                var blankTexture = this._blankTexture || (this._blankTexture = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createBlankTexture("rgba(255, 255, 255, 0)"));
                overlayMesh.material.set("diffuseMap", blankTexture);
                (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).loadTexture(layerModel.get("texture"), api, {
                    flipY: false,
                    anisotropic: 8
                }, function(texture) {
                    if (texture.surface) texture.surface.attachToMesh(overlayMesh);
                    overlayMesh.material.set("diffuseMap", texture);
                    api.getZr().refresh();
                });
                layerModel.get("show") ? this.groupGL.add(overlayMesh) : this.groupGL.remove(overlayMesh);
            }
        }, this);
        var earthMaterial = this._earthMesh.material;
        earthMaterial.define("fragment", "LAYER_DIFFUSEMAP_COUNT", layerDiffuseTextures.length);
        earthMaterial.define("fragment", "LAYER_EMISSIVEMAP_COUNT", layerEmissiveTextures.length);
        earthMaterial.set("layerDiffuseMap", layerDiffuseTextures);
        earthMaterial.set("layerDiffuseIntensity", layerDiffuseIntensity);
        earthMaterial.set("layerEmissiveMap", layerEmissiveTextures);
        earthMaterial.set("layerEmissionIntensity", layerEmissionIntensity);
        var debugWireframeModel = globeModel.getModel("debug.wireframe");
        if (debugWireframeModel.get("show")) {
            earthMaterial.define("both", "WIREFRAME_TRIANGLE");
            var color = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(debugWireframeModel.get("lineStyle.color") || "rgba(0,0,0,0.5)");
            var width = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(debugWireframeModel.get("lineStyle.width"), 1);
            earthMaterial.set("wireframeLineWidth", width);
            earthMaterial.set("wireframeLineColor", color);
        } else earthMaterial.undefine("both", "WIREFRAME_TRIANGLE");
    },
    _updateViewControl: function(globeModel, api) {
        var coordSys = globeModel.coordinateSystem; // Update camera
        var viewControlModel = globeModel.getModel("viewControl");
        var camera = coordSys.viewGL.camera;
        var self = this;
        function makeAction() {
            return {
                type: "globeChangeCamera",
                alpha: control.getAlpha(),
                beta: control.getBeta(),
                distance: control.getDistance() - coordSys.radius,
                center: control.getCenter(),
                from: self.uid,
                globeId: globeModel.id
            };
        } // Update control
        var control = this._control;
        control.setViewGL(coordSys.viewGL);
        var coord = viewControlModel.get("targetCoord");
        var alpha, beta;
        if (coord != null) {
            beta = coord[0] + 90;
            alpha = coord[1];
        }
        control.setFromViewControlModel(viewControlModel, {
            baseDistance: coordSys.radius,
            alpha: alpha,
            beta: beta
        });
        control.off("update");
        control.on("update", function() {
            api.dispatchAction(makeAction());
        });
    },
    _displaceVertices: function(globeModel, api) {
        var displacementQuality = globeModel.get("displacementQuality");
        var showDebugWireframe = globeModel.get("debug.wireframe.show");
        var globe = globeModel.coordinateSystem;
        if (!globeModel.isDisplacementChanged() && displacementQuality === this._displacementQuality && showDebugWireframe === this._showDebugWireframe) return;
        this._displacementQuality = displacementQuality;
        this._showDebugWireframe = showDebugWireframe;
        var geometry = this._sphereGeometry;
        var widthSegments = {
            low: 100,
            medium: 200,
            high: 400,
            ultra: 800
        }[displacementQuality] || 200;
        var heightSegments = widthSegments / 2;
        if (geometry.widthSegments !== widthSegments || showDebugWireframe) {
            geometry.widthSegments = widthSegments;
            geometry.heightSegments = heightSegments;
            geometry.build();
        }
        this._doDisplaceVertices(geometry, globe);
        if (showDebugWireframe) geometry.generateBarycentric();
    },
    _doDisplaceVertices: function(geometry, globe) {
        var positionArr = geometry.attributes.position.value;
        var uvArr = geometry.attributes.texcoord0.value;
        var originalPositionArr = geometry.__originalPosition;
        if (!originalPositionArr || originalPositionArr.length !== positionArr.length) {
            originalPositionArr = new Float32Array(positionArr.length);
            originalPositionArr.set(positionArr);
            geometry.__originalPosition = originalPositionArr;
        }
        var width = globe.displacementWidth;
        var height = globe.displacementHeight;
        var data = globe.displacementData;
        for(var i = 0; i < geometry.vertexCount; i++){
            var i3 = i * 3;
            var i2 = i * 2;
            var x = originalPositionArr[i3 + 1];
            var y = originalPositionArr[i3 + 2];
            var z = originalPositionArr[i3 + 3];
            var u = uvArr[i2++];
            var v = uvArr[i2++];
            var j = Math.round(u * (width - 1));
            var k = Math.round(v * (height - 1));
            var idx = k * width + j;
            var scale = data ? data[idx] : 0;
            positionArr[i3 + 1] = x + x * scale;
            positionArr[i3 + 2] = y + y * scale;
            positionArr[i3 + 3] = z + z * scale;
        }
        geometry.generateVertexNormals();
        geometry.dirty();
        geometry.updateBoundingBox();
    },
    _updateLight: function(globeModel, api) {
        var earthMesh = this._earthMesh;
        this._sceneHelper.updateLight(globeModel);
        var mainLight = this._sceneHelper.mainLight; // Put sun in the right position
        var time = globeModel.get("light.main.time") || new Date(); // http://en.wikipedia.org/wiki/Azimuth
        var pos = (0, $25b0fb456b046912$export$2e2bcd8739ae039).getPosition($880e2355a7de9d0c$exports.parseDate(time), 0, 0);
        var r0 = Math.cos(pos.altitude); // FIXME How to calculate the y ?
        mainLight.position.y = -r0 * Math.cos(pos.azimuth);
        mainLight.position.x = Math.sin(pos.altitude);
        mainLight.position.z = r0 * Math.sin(pos.azimuth);
        mainLight.lookAt(earthMesh.getWorldPosition());
    },
    dispose: function(ecModel, api) {
        this.groupGL.removeAll();
        this._control.dispose();
    }
});



var $70f5d77181441465$var$vec3 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).vec3;
function $70f5d77181441465$var$Globe(radius) {
    this.radius = radius;
    this.viewGL = null;
    this.altitudeAxis; // Displacement data provided by texture.
    this.displacementData = null;
    this.displacementWidth;
    this.displacementHeight;
}
$70f5d77181441465$var$Globe.prototype = {
    constructor: $70f5d77181441465$var$Globe,
    dimensions: [
        "lng",
        "lat",
        "alt"
    ],
    type: "globe",
    containPoint: function() {},
    setDisplacementData: function(data, width, height) {
        this.displacementData = data;
        this.displacementWidth = width;
        this.displacementHeight = height;
    },
    _getDisplacementScale: function(lng, lat) {
        var i = (lng + 180) / 360 * (this.displacementWidth - 1);
        var j = (90 - lat) / 180 * (this.displacementHeight - 1); // NEAREST SAMPLING
        // TODO Better bilinear sampling
        var idx = Math.round(i) + Math.round(j) * this.displacementWidth;
        return this.displacementData[idx];
    },
    dataToPoint: function(data, out) {
        var lng = data[0];
        var lat = data[1]; // Default have 0 altitude
        var altVal = data[2] || 0;
        var r = this.radius;
        if (this.displacementData) r *= 1 + this._getDisplacementScale(lng, lat);
        if (this.altitudeAxis) r += this.altitudeAxis.dataToCoord(altVal);
        lng = lng * Math.PI / 180;
        lat = lat * Math.PI / 180;
        var r0 = Math.cos(lat) * r;
        out = out || []; // PENDING
        out[0] = -r0 * Math.cos(lng + Math.PI);
        out[1] = Math.sin(lat) * r;
        out[2] = r0 * Math.sin(lng + Math.PI);
        return out;
    },
    pointToData: function(point, out) {
        var x = point[0];
        var y = point[1];
        var z = point[2];
        var len = $70f5d77181441465$var$vec3.len(point);
        x /= len;
        y /= len;
        z /= len;
        var theta = Math.asin(y);
        var phi = Math.atan2(z, -x);
        if (phi < 0) phi = Math.PI * 2 + phi;
        var lat = theta * 180 / Math.PI;
        var lng = phi * 180 / Math.PI - 180;
        out = out || [];
        out[0] = lng;
        out[1] = lat;
        out[2] = len - this.radius;
        if (this.altitudeAxis) out[2] = this.altitudeAxis.coordToData(out[2]);
        return out;
    }
};
var $70f5d77181441465$export$2e2bcd8739ae039 = $70f5d77181441465$var$Globe;







function $31fb717c5222d219$var$getDisplacementData(img, displacementScale) {
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");
    var width = img.width;
    var height = img.height;
    canvas.width = width;
    canvas.height = height;
    ctx.drawImage(img, 0, 0, width, height);
    var rgbaArr = ctx.getImageData(0, 0, width, height).data;
    var displacementArr = new Float32Array(rgbaArr.length / 4);
    for(var i = 0; i < rgbaArr.length / 4; i++){
        var x = rgbaArr[i * 4];
        displacementArr[i] = x / 255 * displacementScale;
    }
    return {
        data: displacementArr,
        width: width,
        height: height
    };
}
function $31fb717c5222d219$var$resizeGlobe(globeModel, api) {
    // Use left/top/width/height
    var boxLayoutOption = globeModel.getBoxLayoutParams();
    var viewport = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(boxLayoutOption, {
        width: api.getWidth(),
        height: api.getHeight()
    }); // Flip Y
    viewport.y = api.getHeight() - viewport.y - viewport.height;
    this.viewGL.setViewport(viewport.x, viewport.y, viewport.width, viewport.height, api.getDevicePixelRatio());
    this.radius = globeModel.get("globeRadius");
    var outerRadius = globeModel.get("globeOuterRadius");
    if (this.altitudeAxis) this.altitudeAxis.setExtent(0, outerRadius - this.radius);
}
function $31fb717c5222d219$var$updateGlobe(ecModel, api) {
    var altitudeDataExtent = [
        Infinity,
        -Infinity
    ];
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.coordinateSystem !== this) return;
         // Get altitude data extent.
        var data = seriesModel.getData();
        var altDims = seriesModel.coordDimToDataDim("alt");
        var altDim = altDims && altDims[0];
        if (altDim) {
            // TODO altitiude is in coords of lines.
            var dataExtent = data.getDataExtent(altDim, true);
            altitudeDataExtent[0] = Math.min(altitudeDataExtent[0], dataExtent[0]);
            altitudeDataExtent[1] = Math.max(altitudeDataExtent[1], dataExtent[1]);
        }
    }, this); // Create altitude axis
    if (altitudeDataExtent && isFinite(altitudeDataExtent[1] - altitudeDataExtent[0])) {
        var scale = $9a616079ee96a3f3$exports.createScale(altitudeDataExtent, {
            type: "value",
            // PENDING
            min: "dataMin",
            max: "dataMax"
        });
        this.altitudeAxis = new $c2b1efffe5ae3f42$export$2e2bcd8739ae039("altitude", scale); // Resize again
        this.resize(this.model, api);
    }
}
var $31fb717c5222d219$var$globeCreator = {
    dimensions: (0, $70f5d77181441465$export$2e2bcd8739ae039).prototype.dimensions,
    create: function(ecModel, api) {
        var globeList = [];
        ecModel.eachComponent("globe", function(globeModel) {
            // FIXME
            globeModel.__viewGL = globeModel.__viewGL || new (0, $7a0cfdd3f7cf77fd$export$2e2bcd8739ae039)();
            var globe = new (0, $70f5d77181441465$export$2e2bcd8739ae039)();
            globe.viewGL = globeModel.__viewGL;
            globeModel.coordinateSystem = globe;
            globe.model = globeModel;
            globeList.push(globe); // Inject resize
            globe.resize = $31fb717c5222d219$var$resizeGlobe;
            globe.resize(globeModel, api);
            globe.update = $31fb717c5222d219$var$updateGlobe;
        });
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.get("coordinateSystem") === "globe") {
                var globeModel = seriesModel.getReferringComponents("globe").models[0];
                if (!globeModel) globeModel = ecModel.getComponent("globe");
                if (!globeModel) throw new Error('globe "' + (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(seriesModel.get("globe3DIndex"), seriesModel.get("globe3DId"), 0) + '" not found');
                var coordSys = globeModel.coordinateSystem;
                seriesModel.coordinateSystem = coordSys;
            }
        });
        ecModel.eachComponent("globe", function(globeModel, idx) {
            var globe = globeModel.coordinateSystem; // Update displacement data
            var displacementTextureValue = globeModel.getDisplacementTexture();
            var displacementScale = globeModel.getDisplacemenScale();
            if (globeModel.isDisplacementChanged()) {
                if (globeModel.hasDisplacement()) {
                    var immediateLoaded = true;
                    (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).loadTexture(displacementTextureValue, api, function(texture) {
                        var img = texture.image;
                        var displacementData = $31fb717c5222d219$var$getDisplacementData(img, displacementScale);
                        globeModel.setDisplacementData(displacementData.data, displacementData.width, displacementData.height);
                        if (!immediateLoaded) // Update layouts
                        api.dispatchAction({
                            type: "globeUpdateDisplacment"
                        });
                    });
                    immediateLoaded = false;
                } else globe.setDisplacementData(null, 0, 0);
                globe.setDisplacementData(globeModel.displacementData, globeModel.displacementWidth, globeModel.displacementHeight);
            }
        });
        return globeList;
    }
};
var $31fb717c5222d219$export$2e2bcd8739ae039 = $31fb717c5222d219$var$globeCreator;


function $1c36cb65251db2a0$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $7b2cd16225184a64$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $b773f4a25c29c087$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("globe", (0, $31fb717c5222d219$export$2e2bcd8739ae039));
    registers.registerAction({
        type: "globeChangeCamera",
        event: "globecamerachanged",
        update: "series:updateCamera"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "globe",
            query: payload
        }, function(componentModel) {
            componentModel.setView(payload);
        });
    });
    registers.registerAction({
        type: "globeUpdateDisplacment",
        event: "globedisplacementupdated",
        update: "update"
    }, function(payload, ecModel) {});
}


(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $1c36cb65251db2a0$export$4b3e715f166fdd78));



// TODO ECharts GL must be imported whatever component,charts is imported.




var $c7615e9c889499b9$var$MAPBOX_CAMERA_OPTION = [
    "zoom",
    "center",
    "pitch",
    "bearing"
];
var $c7615e9c889499b9$var$Mapbox3DModel = $116d65051f61bdfe$export$2e2bcd8739ae039.extend({
    type: "mapbox3D",
    layoutMode: "box",
    coordinateSystem: null,
    defaultOption: {
        zlevel: -10,
        style: "mapbox://styles/mapbox/light-v9",
        center: [
            0,
            0
        ],
        zoom: 0,
        pitch: 0,
        bearing: 0,
        light: {
            main: {
                alpha: 20,
                beta: 30
            }
        },
        altitudeScale: 1,
        // Default depend on altitudeScale
        boxHeight: "auto"
    },
    getMapboxCameraOption: function() {
        var self = this;
        return $c7615e9c889499b9$var$MAPBOX_CAMERA_OPTION.reduce(function(obj, key) {
            obj[key] = self.get(key);
            return obj;
        }, {});
    },
    setMapboxCameraOption: function(option) {
        if (option != null) $c7615e9c889499b9$var$MAPBOX_CAMERA_OPTION.forEach(function(key) {
            if (option[key] != null) this.option[key] = option[key];
        }, this);
    },
    /**
   * Get mapbox instance
   */ getMapbox: function() {
        return this._mapbox;
    },
    setMapbox: function(mapbox) {
        this._mapbox = mapbox;
    }
});
$224386f1517b5dca$exports.merge($c7615e9c889499b9$var$Mapbox3DModel.prototype, (0, $2d5450eeb3d59d52$export$2e2bcd8739ae039));
$224386f1517b5dca$exports.merge($c7615e9c889499b9$var$Mapbox3DModel.prototype, (0, $39dfcb89b5cc4a69$export$2e2bcd8739ae039));
var $c7615e9c889499b9$export$2e2bcd8739ae039 = $c7615e9c889499b9$var$Mapbox3DModel;



/**
 * @constructor
 * @alias module:echarts-gl/component/mapbox3D/Mapbox3DLayer
 * @param {string} id Layer ID
 * @param {module:zrender/ZRender} zr
 */ function $1123aa1be531dd23$var$Mapbox3DLayer(id, zr) {
    this.id = id;
    this.zr = zr;
    this.dom = document.createElement("div");
    this.dom.style.cssText = "position:absolute;left:0;right:0;top:0;bottom:0;"; // FIXME If in module environment.
    if (!mapboxgl) throw new Error("Mapbox GL library must be included. See https://www.mapbox.com/mapbox-gl-js/api/");
    this._mapbox = new mapboxgl.Map({
        container: this.dom
    }); // Proxy events
    this._initEvents();
}
$1123aa1be531dd23$var$Mapbox3DLayer.prototype.setUnpainted = function() {};
$1123aa1be531dd23$var$Mapbox3DLayer.prototype.resize = function() {
    this._mapbox.resize();
};
$1123aa1be531dd23$var$Mapbox3DLayer.prototype.getMapbox = function() {
    return this._mapbox;
};
$1123aa1be531dd23$var$Mapbox3DLayer.prototype.clear = function() {};
$1123aa1be531dd23$var$Mapbox3DLayer.prototype.refresh = function() {
    this._mapbox.resize();
};
var $1123aa1be531dd23$var$EVENTS = [
    "mousedown",
    "mouseup",
    "click",
    "dblclick",
    "mousemove",
    "mousewheel",
    "wheel",
    "touchstart",
    "touchend",
    "touchmove",
    "touchcancel"
];
$1123aa1be531dd23$var$Mapbox3DLayer.prototype._initEvents = function() {
    // Event is bound on canvas container.
    var mapboxRoot = this._mapbox.getCanvasContainer();
    this._handlers = this._handlers || {
        contextmenu: function(e) {
            e.preventDefault();
            return false;
        }
    };
    $1123aa1be531dd23$var$EVENTS.forEach(function(eName) {
        this._handlers[eName] = function(e) {
            var obj = {};
            for(var name in e)obj[name] = e[name];
            obj.bubbles = false;
            var newE = new e.constructor(e.type, obj);
            mapboxRoot.dispatchEvent(newE);
        };
        this.zr.dom.addEventListener(eName, this._handlers[eName]);
    }, this); // PENDING
    this.zr.dom.addEventListener("contextmenu", this._handlers.contextmenu);
};
$1123aa1be531dd23$var$Mapbox3DLayer.prototype.dispose = function() {
    $1123aa1be531dd23$var$EVENTS.forEach(function(eName) {
        this.zr.dom.removeEventListener(eName, this._handlers[eName]);
    }, this);
};
var $1123aa1be531dd23$export$2e2bcd8739ae039 = $1123aa1be531dd23$var$Mapbox3DLayer;




var $1a331079bf9db862$export$2e2bcd8739ae039 = "\n@export ecgl.displayShadow.vertex\n\n@import ecgl.common.transformUniforms\n\n@import ecgl.common.uv.header\n\n@import ecgl.common.attributes\n\nvarying vec3 v_WorldPosition;\n\nvarying vec3 v_Normal;\n\nvoid main()\n{\n @import ecgl.common.uv.main\n v_Normal = normalize((worldInverseTranspose * vec4(normal, 0.0)).xyz);\n\n v_WorldPosition = (world * vec4(position, 1.0)).xyz;\n gl_Position = worldViewProjection * vec4(position, 1.0);\n}\n\n@end\n\n\n@export ecgl.displayShadow.fragment\n\n@import ecgl.common.uv.fragmentHeader\n\nvarying vec3 v_Normal;\nvarying vec3 v_WorldPosition;\n\nuniform float roughness: 0.2;\n\n#ifdef DIRECTIONAL_LIGHT_COUNT\n@import clay.header.directional_light\n#endif\n\n@import ecgl.common.ssaoMap.header\n\n@import clay.plugin.compute_shadow_map\n\nvoid main()\n{\n float shadow = 1.0;\n\n @import ecgl.common.ssaoMap.main\n\n#if defined(DIRECTIONAL_LIGHT_COUNT) && defined(DIRECTIONAL_LIGHT_SHADOWMAP_COUNT)\n float shadowContribsDir[DIRECTIONAL_LIGHT_COUNT];\n if(shadowEnabled)\n {\n computeShadowOfDirectionalLights(v_WorldPosition, shadowContribsDir);\n }\n for (int i = 0; i < DIRECTIONAL_LIGHT_COUNT; i++) {\n shadow = min(shadow, shadowContribsDir[i] * 0.5 + 0.5);\n }\n#endif\n\n shadow *= 0.5 + ao * 0.5;\n shadow = clamp(shadow, 0.0, 1.0);\n\n gl_FragColor = vec4(vec3(0.0), 1.0 - shadow);\n}\n\n@end";


(0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.import((0, $1a331079bf9db862$export$2e2bcd8739ae039));
var $e6ffe9805bfa3809$var$TILE_SIZE = 512;
var $e6ffe9805bfa3809$export$2e2bcd8739ae039 = $737c88aa0711f65a$export$2e2bcd8739ae039.extend({
    type: "mapbox3D",
    __ecgl__: true,
    init: function(ecModel, api) {
        var zr = api.getZr();
        this._zrLayer = new (0, $1123aa1be531dd23$export$2e2bcd8739ae039)("mapbox3D", zr);
        zr.painter.insertLayer(-1000, this._zrLayer);
        this._lightRoot = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
        this._sceneHelper = new (0, $ace7021e37e6bf94$export$2e2bcd8739ae039)(this._lightRoot);
        this._sceneHelper.initLight(this._lightRoot);
        var mapbox = this._zrLayer.getMapbox();
        var dispatchInteractAction = this._dispatchInteractAction.bind(this, api, mapbox); // PENDING
        [
            "zoom",
            "rotate",
            "drag",
            "pitch",
            "rotate",
            "move"
        ].forEach(function(eName) {
            mapbox.on(eName, dispatchInteractAction);
        });
        this._groundMesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
            geometry: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).PlaneGeometry(),
            material: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
                shader: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader({
                    vertex: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.source("ecgl.displayShadow.vertex"),
                    fragment: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.source("ecgl.displayShadow.fragment")
                }),
                depthMask: false
            }),
            // Render first
            renderOrder: -100,
            culling: false,
            castShadow: false,
            $ignorePicking: true,
            renderNormal: true
        });
    },
    render: function(mapbox3DModel, ecModel, api) {
        var mapbox = this._zrLayer.getMapbox();
        var styleDesc = mapbox3DModel.get("style");
        var styleStr = JSON.stringify(styleDesc);
        if (styleStr !== this._oldStyleStr) {
            if (styleDesc) mapbox.setStyle(styleDesc);
        }
        this._oldStyleStr = styleStr;
        mapbox.setCenter(mapbox3DModel.get("center"));
        mapbox.setZoom(mapbox3DModel.get("zoom"));
        mapbox.setPitch(mapbox3DModel.get("pitch"));
        mapbox.setBearing(mapbox3DModel.get("bearing"));
        mapbox3DModel.setMapbox(mapbox);
        var coordSys = mapbox3DModel.coordinateSystem; // Not add to rootNode. Or light direction will be stretched by rootNode scale
        coordSys.viewGL.scene.add(this._lightRoot);
        coordSys.viewGL.add(this._groundMesh);
        this._updateGroundMesh(); // Update lights
        this._sceneHelper.setScene(coordSys.viewGL.scene);
        this._sceneHelper.updateLight(mapbox3DModel); // Update post effects
        coordSys.viewGL.setPostEffect(mapbox3DModel.getModel("postEffect"), api);
        coordSys.viewGL.setTemporalSuperSampling(mapbox3DModel.getModel("temporalSuperSampling"));
        this._mapbox3DModel = mapbox3DModel;
    },
    afterRender: function(mapbox3DModel, ecModel, api, layerGL) {
        var renderer = layerGL.renderer;
        this._sceneHelper.updateAmbientCubemap(renderer, mapbox3DModel, api);
        this._sceneHelper.updateSkybox(renderer, mapbox3DModel, api); // FIXME If other series changes coordinate system.
        // FIXME When doing progressive rendering.
        mapbox3DModel.coordinateSystem.viewGL.scene.traverse(function(mesh) {
            if (mesh.material) {
                mesh.material.define("fragment", "NORMAL_UP_AXIS", 2);
                mesh.material.define("fragment", "NORMAL_FRONT_AXIS", 1);
            }
        });
    },
    updateCamera: function(mapbox3DModel, ecModel, api, payload) {
        mapbox3DModel.coordinateSystem.setCameraOption(payload);
        this._updateGroundMesh();
        api.getZr().refresh();
    },
    _dispatchInteractAction: function(api, mapbox, mapbox3DModel) {
        api.dispatchAction({
            type: "mapbox3DChangeCamera",
            pitch: mapbox.getPitch(),
            zoom: mapbox.getZoom(),
            center: mapbox.getCenter().toArray(),
            bearing: mapbox.getBearing(),
            mapbox3DId: this._mapbox3DModel && this._mapbox3DModel.id
        });
    },
    _updateGroundMesh: function() {
        if (this._mapbox3DModel) {
            var coordSys = this._mapbox3DModel.coordinateSystem;
            var pt = coordSys.dataToPoint(coordSys.center);
            this._groundMesh.position.set(pt[0], pt[1], -0.001);
            var plane = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Plane(new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Vector3(0, 0, 1), 0);
            var ray1 = coordSys.viewGL.camera.castRay(new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Vector2(-1, -1));
            var ray2 = coordSys.viewGL.camera.castRay(new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Vector2(1, 1));
            var pos0 = ray1.intersectPlane(plane);
            var pos1 = ray2.intersectPlane(plane);
            var scale = pos0.dist(pos1) / coordSys.viewGL.rootNode.scale.x;
            this._groundMesh.scale.set(scale, scale, 1);
        }
    },
    dispose: function(ecModel, api) {
        if (this._zrLayer) this._zrLayer.dispose();
        api.getZr().painter.delLayer(-1000);
    }
});



var $c67811a1bc5ab07c$var$mat4 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).mat4;
var $c67811a1bc5ab07c$var$TILE_SIZE = 512;
var $c67811a1bc5ab07c$var$FOV = 0.6435011087932844;
var $c67811a1bc5ab07c$var$PI = Math.PI;
var $c67811a1bc5ab07c$var$WORLD_SCALE = 0.1;
function $c67811a1bc5ab07c$var$MapServiceCoordSys3D() {
    /**
   * Width of mapbox viewport
   */ this.width = 0;
    /**
   * Height of mapbox viewport
   */ this.height = 0;
    this.altitudeScale = 1; // TODO Change boxHeight won't have animation.
    this.boxHeight = "auto"; // Set by mapbox creator
    this.altitudeExtent;
    this.bearing = 0;
    this.pitch = 0;
    this.center = [
        0,
        0
    ];
    this._origin;
    this.zoom = 0;
    this._initialZoom; // Some parameters for different map services.
    this.maxPitch = 60;
    this.zoomOffset = 0;
}
$c67811a1bc5ab07c$var$MapServiceCoordSys3D.prototype = {
    constructor: $c67811a1bc5ab07c$var$MapServiceCoordSys3D,
    dimensions: [
        "lng",
        "lat",
        "alt"
    ],
    containPoint: function() {},
    setCameraOption: function(option) {
        this.bearing = option.bearing;
        this.pitch = option.pitch;
        this.center = option.center;
        this.zoom = option.zoom;
        if (!this._origin) this._origin = this.projectOnTileWithScale(this.center, $c67811a1bc5ab07c$var$TILE_SIZE);
        if (this._initialZoom == null) this._initialZoom = this.zoom;
        this.updateTransform();
    },
    // https://github.com/mapbox/mapbox-gl-js/blob/master/src/geo/transform.js#L479
    updateTransform: function() {
        if (!this.height) return;
        var cameraToCenterDistance = 0.5 / Math.tan($c67811a1bc5ab07c$var$FOV / 2) * this.height * $c67811a1bc5ab07c$var$WORLD_SCALE; // Convert to radian.
        var pitch = Math.max(Math.min(this.pitch, this.maxPitch), 0) / 180 * Math.PI; // Find the distance from the center point [width/2, height/2] to the
        // center top point [width/2, 0] in Z units, using the law of sines.
        // 1 Z unit is equivalent to 1 horizontal px at the center of the map
        // (the distance between[width/2, height/2] and [width/2 + 1, height/2])
        var halfFov = $c67811a1bc5ab07c$var$FOV / 2;
        var groundAngle = Math.PI / 2 + pitch;
        var topHalfSurfaceDistance = Math.sin(halfFov) * cameraToCenterDistance / Math.sin(Math.PI - groundAngle - halfFov); // Calculate z distance of the farthest fragment that should be rendered.
        var furthestDistance = Math.cos(Math.PI / 2 - pitch) * topHalfSurfaceDistance + cameraToCenterDistance; // Add a bit extra to avoid precision problems when a fragment's distance is exactly `furthestDistance`
        var farZ = furthestDistance * 1.1; // Forced to be 1000
        if (this.pitch > 50) farZ = 1000;
         // matrix for conversion from location to GL coordinates (-1 .. 1)
        var m = [];
        $c67811a1bc5ab07c$var$mat4.perspective(m, $c67811a1bc5ab07c$var$FOV, this.width / this.height, 1, farZ);
        this.viewGL.camera.projectionMatrix.setArray(m);
        this.viewGL.camera.decomposeProjectionMatrix();
        var m = $c67811a1bc5ab07c$var$mat4.identity([]);
        var pt = this.dataToPoint(this.center); // Inverse
        $c67811a1bc5ab07c$var$mat4.scale(m, m, [
            1,
            -1,
            1
        ]); // Translate to altitude
        $c67811a1bc5ab07c$var$mat4.translate(m, m, [
            0,
            0,
            -cameraToCenterDistance
        ]);
        $c67811a1bc5ab07c$var$mat4.rotateX(m, m, pitch);
        $c67811a1bc5ab07c$var$mat4.rotateZ(m, m, -this.bearing / 180 * Math.PI); // Translate to center.
        $c67811a1bc5ab07c$var$mat4.translate(m, m, [
            -pt[0] * this.getScale() * $c67811a1bc5ab07c$var$WORLD_SCALE,
            -pt[1] * this.getScale() * $c67811a1bc5ab07c$var$WORLD_SCALE,
            0
        ]);
        this.viewGL.camera.viewMatrix.array = m;
        var invertM = [];
        $c67811a1bc5ab07c$var$mat4.invert(invertM, m);
        this.viewGL.camera.worldTransform.array = invertM;
        this.viewGL.camera.decomposeWorldTransform(); // scale vertically to meters per pixel (inverse of ground resolution):
        // worldSize / (circumferenceOfEarth * cos(lat * π / 180))
        var worldSize = $c67811a1bc5ab07c$var$TILE_SIZE * this.getScale();
        var verticalScale;
        if (this.altitudeExtent && !isNaN(this.boxHeight)) {
            var range = this.altitudeExtent[1] - this.altitudeExtent[0];
            verticalScale = this.boxHeight / range * this.getScale() / Math.pow(2, this._initialZoom - this.zoomOffset);
        } else verticalScale = worldSize / (2 * Math.PI * 6378000 * Math.abs(Math.cos(this.center[1] * (Math.PI / 180)))) * this.altitudeScale * $c67811a1bc5ab07c$var$WORLD_SCALE;
         // Include scale to avoid relayout when zooming
        // FIXME Camera scale may have problem in shadow
        this.viewGL.rootNode.scale.set(this.getScale() * $c67811a1bc5ab07c$var$WORLD_SCALE, this.getScale() * $c67811a1bc5ab07c$var$WORLD_SCALE, verticalScale);
    },
    getScale: function() {
        return Math.pow(2, this.zoom - this.zoomOffset);
    },
    projectOnTile: function(data, out) {
        return this.projectOnTileWithScale(data, this.getScale() * $c67811a1bc5ab07c$var$TILE_SIZE, out);
    },
    projectOnTileWithScale: function(data, scale, out) {
        var lng = data[0];
        var lat = data[1];
        var lambda2 = lng * $c67811a1bc5ab07c$var$PI / 180;
        var phi2 = lat * $c67811a1bc5ab07c$var$PI / 180;
        var x = scale * (lambda2 + $c67811a1bc5ab07c$var$PI) / (2 * $c67811a1bc5ab07c$var$PI);
        var y = scale * ($c67811a1bc5ab07c$var$PI - Math.log(Math.tan($c67811a1bc5ab07c$var$PI / 4 + phi2 * 0.5))) / (2 * $c67811a1bc5ab07c$var$PI);
        out = out || [];
        out[0] = x;
        out[1] = y;
        return out;
    },
    unprojectFromTile: function(point, out) {
        return this.unprojectOnTileWithScale(point, this.getScale() * $c67811a1bc5ab07c$var$TILE_SIZE, out);
    },
    unprojectOnTileWithScale: function(point, scale, out) {
        var x = point[0];
        var y = point[1];
        var lambda2 = x / scale * (2 * $c67811a1bc5ab07c$var$PI) - $c67811a1bc5ab07c$var$PI;
        var phi2 = 2 * (Math.atan(Math.exp($c67811a1bc5ab07c$var$PI - y / scale * (2 * $c67811a1bc5ab07c$var$PI))) - $c67811a1bc5ab07c$var$PI / 4);
        out = out || [];
        out[0] = lambda2 * 180 / $c67811a1bc5ab07c$var$PI;
        out[1] = phi2 * 180 / $c67811a1bc5ab07c$var$PI;
        return out;
    },
    dataToPoint: function(data, out) {
        out = this.projectOnTileWithScale(data, $c67811a1bc5ab07c$var$TILE_SIZE, out); // Add a origin to avoid precision issue in WebGL.
        out[0] -= this._origin[0];
        out[1] -= this._origin[1]; // PENDING
        out[2] = !isNaN(data[2]) ? data[2] : 0;
        if (!isNaN(data[2])) {
            out[2] = data[2];
            if (this.altitudeExtent) out[2] -= this.altitudeExtent[0];
        }
        return out;
    }
};
var $c67811a1bc5ab07c$export$2e2bcd8739ae039 = $c67811a1bc5ab07c$var$MapServiceCoordSys3D;


function $40fb0d1d328bbad4$var$Mapbox3D() {
    (0, $c67811a1bc5ab07c$export$2e2bcd8739ae039).apply(this, arguments);
}
$40fb0d1d328bbad4$var$Mapbox3D.prototype = new (0, $c67811a1bc5ab07c$export$2e2bcd8739ae039)();
$40fb0d1d328bbad4$var$Mapbox3D.prototype.constructor = $40fb0d1d328bbad4$var$Mapbox3D;
$40fb0d1d328bbad4$var$Mapbox3D.prototype.type = "mapbox3D";
var $40fb0d1d328bbad4$export$2e2bcd8739ae039 = $40fb0d1d328bbad4$var$Mapbox3D;





function $a470f9143ea8993c$export$2e2bcd8739ae039(serviceComponentType, ServiceCtor, afterCreate) {
    function resizeMapService3D(mapService3DModel, api) {
        var width = api.getWidth();
        var height = api.getHeight();
        var dpr = api.getDevicePixelRatio();
        this.viewGL.setViewport(0, 0, width, height, dpr);
        this.width = width;
        this.height = height;
        this.altitudeScale = mapService3DModel.get("altitudeScale");
        this.boxHeight = mapService3DModel.get("boxHeight"); // this.updateTransform();
    }
    function updateService3D(ecModel, api) {
        if (this.model.get("boxHeight") === "auto") return;
        var altitudeDataExtent = [
            Infinity,
            -Infinity
        ];
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.coordinateSystem !== this) return;
             // Get altitude data extent.
            var data = seriesModel.getData();
            var altDim = seriesModel.coordDimToDataDim("alt")[0];
            if (altDim) {
                // TODO altitiude is in coords of lines.
                var dataExtent = data.getDataExtent(altDim, true);
                altitudeDataExtent[0] = Math.min(altitudeDataExtent[0], dataExtent[0]);
                altitudeDataExtent[1] = Math.max(altitudeDataExtent[1], dataExtent[1]);
            }
        }, this);
        if (altitudeDataExtent && isFinite(altitudeDataExtent[1] - altitudeDataExtent[0])) this.altitudeExtent = altitudeDataExtent;
    }
    return {
        dimensions: ServiceCtor.prototype.dimensions,
        create: function(ecModel, api) {
            var mapService3DList = [];
            ecModel.eachComponent(serviceComponentType, function(mapService3DModel) {
                var viewGL = mapService3DModel.__viewGL;
                if (!viewGL) {
                    viewGL = mapService3DModel.__viewGL = new (0, $7a0cfdd3f7cf77fd$export$2e2bcd8739ae039)();
                    viewGL.setRootNode(new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node());
                }
                var mapService3DCoordSys = new ServiceCtor();
                mapService3DCoordSys.viewGL = mapService3DModel.__viewGL; // Inject resize
                mapService3DCoordSys.resize = resizeMapService3D;
                mapService3DCoordSys.resize(mapService3DModel, api);
                mapService3DList.push(mapService3DCoordSys);
                mapService3DModel.coordinateSystem = mapService3DCoordSys;
                mapService3DCoordSys.model = mapService3DModel;
                mapService3DCoordSys.update = updateService3D;
            });
            ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.get("coordinateSystem") === serviceComponentType) {
                    var mapService3DModel = seriesModel.getReferringComponents(serviceComponentType).models[0];
                    if (!mapService3DModel) mapService3DModel = ecModel.getComponent(serviceComponentType);
                    if (!mapService3DModel) throw new Error(serviceComponentType + ' "' + (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(seriesModel.get(serviceComponentType + "Index"), seriesModel.get(serviceComponentType + "Id"), 0) + '" not found');
                    seriesModel.coordinateSystem = mapService3DModel.coordinateSystem;
                }
            });
            afterCreate && afterCreate(mapService3DList, ecModel, api);
            return mapService3DList;
        }
    };
}


var $13bfbd6791916517$var$mapbox3DCreator = (0, $a470f9143ea8993c$export$2e2bcd8739ae039)("mapbox3D", (0, $40fb0d1d328bbad4$export$2e2bcd8739ae039), function(mapbox3DList) {
    mapbox3DList.forEach(function(mapbox3D) {
        mapbox3D.setCameraOption(mapbox3D.model.getMapboxCameraOption());
    });
});
var $13bfbd6791916517$export$2e2bcd8739ae039 = $13bfbd6791916517$var$mapbox3DCreator;


function $d6ba8b1bf86c00c9$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $c7615e9c889499b9$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $e6ffe9805bfa3809$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("mapbox3D", (0, $13bfbd6791916517$export$2e2bcd8739ae039));
    registers.registerAction({
        type: "mapbox3DChangeCamera",
        event: "mapbox3dcamerachanged",
        update: "mapbox3D:updateCamera"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "mapbox3D",
            query: payload
        }, function(componentModel) {
            componentModel.setMapboxCameraOption(payload);
        });
    });
}


(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $d6ba8b1bf86c00c9$export$4b3e715f166fdd78));


// Thanks to https://gitee.com/iverson_hu/maptalks-echarts-gl

// TODO ECharts GL must be imported whatever component,charts is imported.




var $2d97516dccf52e7f$var$MAPTALKS_CAMERA_OPTION = [
    "zoom",
    "center",
    "pitch",
    "bearing"
];
var $2d97516dccf52e7f$var$Maptalks3DModel = $116d65051f61bdfe$export$2e2bcd8739ae039.extend({
    type: "maptalks3D",
    layoutMode: "box",
    coordinateSystem: null,
    defaultOption: {
        zlevel: -10,
        urlTemplate: "http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png",
        attribution: '&copy; <a href="http://osm.org">OpenStreetMap</a> contributors, &copy; <a href="https://carto.com/">CARTO</a>',
        center: [
            0,
            0
        ],
        zoom: 0,
        pitch: 0,
        bearing: 0,
        light: {
            main: {
                alpha: 20,
                beta: 30
            }
        },
        altitudeScale: 1,
        // Default depend on altitudeScale
        boxHeight: "auto"
    },
    getMaptalksCameraOption: function() {
        var self = this;
        return $2d97516dccf52e7f$var$MAPTALKS_CAMERA_OPTION.reduce(function(obj, key) {
            obj[key] = self.get(key);
            return obj;
        }, {});
    },
    setMaptalksCameraOption: function(option) {
        if (option != null) $2d97516dccf52e7f$var$MAPTALKS_CAMERA_OPTION.forEach(function(key) {
            if (option[key] != null) this.option[key] = option[key];
        }, this);
    },
    /**
   * Get maptalks instance
   */ getMaptalks: function() {
        return this._maptalks;
    },
    setMaptalks: function(maptalks) {
        this._maptalks = maptalks;
    }
});
$224386f1517b5dca$exports.merge($2d97516dccf52e7f$var$Maptalks3DModel.prototype, (0, $2d5450eeb3d59d52$export$2e2bcd8739ae039));
$224386f1517b5dca$exports.merge($2d97516dccf52e7f$var$Maptalks3DModel.prototype, (0, $39dfcb89b5cc4a69$export$2e2bcd8739ae039));
var $2d97516dccf52e7f$export$2e2bcd8739ae039 = $2d97516dccf52e7f$var$Maptalks3DModel;



/**
 * @constructor
 * @alias module:echarts-gl/component/maptalks/Maptalks3DLayer
 * @param {string} id Layer ID
 * @param {module:zrender/ZRender} zr
 */ function $97e13556919633f4$var$Maptalks3DLayer(id, zr, defaultCenter, defaultZoom) {
    this.id = id;
    this.zr = zr;
    this.dom = document.createElement("div");
    this.dom.style.cssText = "position:absolute;left:0;right:0;top:0;bottom:0;"; // FIXME If in module environment.
    if (!maptalks) throw new Error("Maptalks library must be included. See https://maptalks.org");
    this._maptalks = new maptalks.Map(this.dom, {
        center: defaultCenter,
        zoom: defaultZoom,
        doubleClickZoom: false,
        fog: false // fogColor: [0, 0, 0]
    }); // Proxy events
    this._initEvents();
}
$97e13556919633f4$var$Maptalks3DLayer.prototype.setUnpainted = function() {};
$97e13556919633f4$var$Maptalks3DLayer.prototype.resize = function() {
    this._maptalks.checkSize();
};
$97e13556919633f4$var$Maptalks3DLayer.prototype.getMaptalks = function() {
    return this._maptalks;
};
$97e13556919633f4$var$Maptalks3DLayer.prototype.clear = function() {};
$97e13556919633f4$var$Maptalks3DLayer.prototype.refresh = function() {
    this._maptalks.checkSize();
};
var $97e13556919633f4$var$EVENTS = [
    "mousedown",
    "mouseup",
    "click",
    "dblclick",
    "mousemove",
    "mousewheel",
    "DOMMouseScroll",
    "touchstart",
    "touchend",
    "touchmove",
    "touchcancel"
];
$97e13556919633f4$var$Maptalks3DLayer.prototype._initEvents = function() {
    // Event is bound on canvas container.
    var maptalksRoot = this.dom;
    this._handlers = this._handlers || {
        contextmenu: function(e) {
            e.preventDefault();
            return false;
        }
    };
    $97e13556919633f4$var$EVENTS.forEach(function(eName) {
        this._handlers[eName] = function(e) {
            var obj = {};
            for(var name in e)obj[name] = e[name];
            obj.bubbles = false;
            var newE = new e.constructor(e.type, obj);
            if (eName === "mousewheel" || eName === "DOMMouseScroll") // maptalks listens events to different elements?
            maptalksRoot.dispatchEvent(newE);
            else maptalksRoot.firstElementChild.dispatchEvent(newE);
        };
        this.zr.dom.addEventListener(eName, this._handlers[eName]);
    }, this); // PENDING
    this.zr.dom.addEventListener("contextmenu", this._handlers.contextmenu);
};
$97e13556919633f4$var$Maptalks3DLayer.prototype.dispose = function() {
    $97e13556919633f4$var$EVENTS.forEach(function(eName) {
        this.zr.dom.removeEventListener(eName, this._handlers[eName]);
    }, this);
    this._maptalks.remove();
};
var $97e13556919633f4$export$2e2bcd8739ae039 = $97e13556919633f4$var$Maptalks3DLayer;





(0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.import((0, $1a331079bf9db862$export$2e2bcd8739ae039));
var $61b8076361b61057$export$2e2bcd8739ae039 = $737c88aa0711f65a$export$2e2bcd8739ae039.extend({
    type: "maptalks3D",
    __ecgl__: true,
    init: function(ecModel, api) {
        this._groundMesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
            geometry: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).PlaneGeometry(),
            material: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
                shader: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader({
                    vertex: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.source("ecgl.displayShadow.vertex"),
                    fragment: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.source("ecgl.displayShadow.fragment")
                }),
                depthMask: false
            }),
            // Render first
            renderOrder: -100,
            culling: false,
            castShadow: false,
            $ignorePicking: true,
            renderNormal: true
        });
    },
    _initMaptalksLayer: function(mapbox3DModel, api) {
        var zr = api.getZr();
        this._zrLayer = new (0, $97e13556919633f4$export$2e2bcd8739ae039)("maptalks3D", zr, mapbox3DModel.get("center"), mapbox3DModel.get("zoom"));
        zr.painter.insertLayer(-1000, this._zrLayer);
        this._lightRoot = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
        this._sceneHelper = new (0, $ace7021e37e6bf94$export$2e2bcd8739ae039)(this._lightRoot);
        this._sceneHelper.initLight(this._lightRoot);
        var maptalks1 = this._zrLayer.getMaptalks();
        var dispatchInteractAction = this._dispatchInteractAction.bind(this, api, maptalks1); // PENDING
        [
            "zoomend",
            "zooming",
            "zoomstart",
            "dragrotating",
            "pitch",
            "pitchend",
            "movestart",
            "moving",
            "moveend",
            "resize",
            "touchstart",
            "touchmove",
            "touchend",
            "animating"
        ].forEach(function(eName) {
            maptalks1.on(eName, dispatchInteractAction);
        });
    },
    render: function(maptalks3DModel, ecModel, api) {
        if (!this._zrLayer) this._initMaptalksLayer(maptalks3DModel, api);
        var mtks = this._zrLayer.getMaptalks();
        var urlTemplate = maptalks3DModel.get("urlTemplate");
        var baseLayer = mtks.getBaseLayer();
        if (urlTemplate !== this._oldUrlTemplate) {
            if (!baseLayer) {
                baseLayer = new maptalks.TileLayer("maptalks-echarts-gl-baselayer", {
                    urlTemplate: urlTemplate,
                    // used sequentially to help with browser parallel requests per domain limitation
                    subdomains: [
                        "a",
                        "b",
                        "c"
                    ],
                    attribution: maptalks3DModel.get("attribution")
                });
                mtks.setBaseLayer(baseLayer);
            } else // PENDING setOptions may not work?
            baseLayer.setOptions({
                urlTemplate: urlTemplate,
                attribution: maptalks3DModel.get("attribution")
            });
        }
        this._oldUrlTemplate = urlTemplate;
        mtks.setCenter(maptalks3DModel.get("center"));
        mtks.setZoom(maptalks3DModel.get("zoom"), {
            animation: false
        });
        mtks.setPitch(maptalks3DModel.get("pitch"));
        mtks.setBearing(maptalks3DModel.get("bearing"));
        maptalks3DModel.setMaptalks(mtks);
        var coordSys = maptalks3DModel.coordinateSystem; // Not add to rootNode. Or light direction will be stretched by rootNode scale
        coordSys.viewGL.scene.add(this._lightRoot);
        coordSys.viewGL.add(this._groundMesh);
        this._updateGroundMesh(); // Update lights
        this._sceneHelper.setScene(coordSys.viewGL.scene);
        this._sceneHelper.updateLight(maptalks3DModel); // Update post effects
        coordSys.viewGL.setPostEffect(maptalks3DModel.getModel("postEffect"), api);
        coordSys.viewGL.setTemporalSuperSampling(maptalks3DModel.getModel("temporalSuperSampling"));
        this._maptalks3DModel = maptalks3DModel;
    },
    afterRender: function(maptalks3DModel, ecModel, api, layerGL) {
        var renderer = layerGL.renderer;
        this._sceneHelper.updateAmbientCubemap(renderer, maptalks3DModel, api);
        this._sceneHelper.updateSkybox(renderer, maptalks3DModel, api); // FIXME If other series changes coordinate system.
        // FIXME When doing progressive rendering.
        maptalks3DModel.coordinateSystem.viewGL.scene.traverse(function(mesh) {
            if (mesh.material) {
                mesh.material.define("fragment", "NORMAL_UP_AXIS", 2);
                mesh.material.define("fragment", "NORMAL_FRONT_AXIS", 1);
            }
        });
    },
    updateCamera: function(maptalks3DModel, ecModel, api, payload) {
        maptalks3DModel.coordinateSystem.setCameraOption(payload);
        this._updateGroundMesh();
        api.getZr().refresh();
    },
    _dispatchInteractAction: function(api, maptalks1, maptalks3DModel) {
        api.dispatchAction({
            type: "maptalks3DChangeCamera",
            pitch: maptalks1.getPitch(),
            zoom: $61b8076361b61057$var$getMapboxZoom(maptalks1.getResolution()) + 1,
            center: maptalks1.getCenter().toArray(),
            bearing: maptalks1.getBearing(),
            maptalks3DId: this._maptalks3DModel && this._maptalks3DModel.id
        });
    },
    _updateGroundMesh: function() {
        if (this._maptalks3DModel) {
            var coordSys = this._maptalks3DModel.coordinateSystem;
            var pt = coordSys.dataToPoint(coordSys.center);
            this._groundMesh.position.set(pt[0], pt[1], -0.001);
            var plane = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Plane(new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Vector3(0, 0, 1), 0);
            var ray1 = coordSys.viewGL.camera.castRay(new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Vector2(-1, -1));
            var ray2 = coordSys.viewGL.camera.castRay(new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Vector2(1, 1));
            var pos0 = ray1.intersectPlane(plane);
            var pos1 = ray2.intersectPlane(plane);
            var scale = pos0.dist(pos1) / coordSys.viewGL.rootNode.scale.x;
            this._groundMesh.scale.set(scale, scale, 1);
        }
    },
    dispose: function(ecModel, api) {
        if (this._zrLayer) this._zrLayer.dispose();
        api.getZr().painter.delLayer(-1000);
    }
});
const $61b8076361b61057$var$MAX_RES = 12756274 * Math.PI / (256 * Math.pow(2, 20));
function $61b8076361b61057$var$getMapboxZoom(res) {
    return 19 - Math.log(res / $61b8076361b61057$var$MAX_RES) / Math.LN2;
}



function $b62e4b2cae205bd3$var$Maptalks3D() {
    (0, $c67811a1bc5ab07c$export$2e2bcd8739ae039).apply(this, arguments);
    this.maxPitch = 85;
    this.zoomOffset = 1;
}
$b62e4b2cae205bd3$var$Maptalks3D.prototype = new (0, $c67811a1bc5ab07c$export$2e2bcd8739ae039)();
$b62e4b2cae205bd3$var$Maptalks3D.prototype.constructor = $b62e4b2cae205bd3$var$Maptalks3D;
$b62e4b2cae205bd3$var$Maptalks3D.prototype.type = "maptalks3D";
var $b62e4b2cae205bd3$export$2e2bcd8739ae039 = $b62e4b2cae205bd3$var$Maptalks3D;



var $4f33a98d0863de6f$var$maptalks3DCreator = (0, $a470f9143ea8993c$export$2e2bcd8739ae039)("maptalks3D", (0, $b62e4b2cae205bd3$export$2e2bcd8739ae039), function(maptalks3DList) {
    maptalks3DList.forEach(function(maptalks3D) {
        maptalks3D.setCameraOption(maptalks3D.model.getMaptalksCameraOption());
    });
});
var $4f33a98d0863de6f$export$2e2bcd8739ae039 = $4f33a98d0863de6f$var$maptalks3DCreator;


function $66b110c62f70c622$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $2d97516dccf52e7f$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $61b8076361b61057$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem("maptalks3D", (0, $4f33a98d0863de6f$export$2e2bcd8739ae039));
    registers.registerAction({
        type: "maptalks3DChangeCamera",
        event: "maptalks3dcamerachanged",
        update: "maptalks3D:updateCamera"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "maptalks3D",
            query: payload
        }, function(componentModel) {
            componentModel.setMaptalksCameraOption(payload);
        });
    });
}


(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $66b110c62f70c622$export$4b3e715f166fdd78));



// TODO ECharts GL must be imported whatever component,charts is imported.






var $2d01cd0a84db3fc5$var$vec3 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).vec3;
var $2d01cd0a84db3fc5$var$isDimensionStacked = $9a616079ee96a3f3$exports.dataStack.isDimensionStacked;
function $2d01cd0a84db3fc5$var$ifCrossZero(extent) {
    var min = extent[0];
    var max = extent[1];
    return !(min > 0 && max > 0 || min < 0 && max < 0);
}
function $2d01cd0a84db3fc5$var$cartesian3DLayout(seriesModel, coordSys) {
    var data = seriesModel.getData(); // var barOnPlane = seriesModel.get('onGridPlane');
    var barSize = seriesModel.get("barSize");
    if (barSize == null) {
        var size = coordSys.size;
        var barWidth;
        var barDepth;
        var xAxis = coordSys.getAxis("x");
        var yAxis = coordSys.getAxis("y");
        if (xAxis.type === "category") barWidth = xAxis.getBandWidth() * 0.7;
        else // PENDING
        barWidth = Math.round(size[0] / Math.sqrt(data.count())) * 0.6;
        if (yAxis.type === "category") barDepth = yAxis.getBandWidth() * 0.7;
        else barDepth = Math.round(size[1] / Math.sqrt(data.count())) * 0.6;
        barSize = [
            barWidth,
            barDepth
        ];
    } else if (!$224386f1517b5dca$exports.isArray(barSize)) barSize = [
        barSize,
        barSize
    ];
    var zAxisExtent = coordSys.getAxis("z").scale.getExtent();
    var ifZAxisCrossZero = $2d01cd0a84db3fc5$var$ifCrossZero(zAxisExtent);
    var dims = [
        "x",
        "y",
        "z"
    ].map(function(coordDimName) {
        return seriesModel.coordDimToDataDim(coordDimName)[0];
    });
    var isStacked = $2d01cd0a84db3fc5$var$isDimensionStacked(data, dims[2]);
    var valueDim = isStacked ? data.getCalculationInfo("stackResultDimension") : dims[2];
    data.each(dims, function(x, y, z, idx) {
        // TODO zAxis is inversed
        // TODO On different plane.
        var stackedValue = data.get(valueDim, idx);
        var baseValue = isStacked ? stackedValue - z : ifZAxisCrossZero ? 0 : zAxisExtent[0];
        var start = coordSys.dataToPoint([
            x,
            y,
            baseValue
        ]);
        var end = coordSys.dataToPoint([
            x,
            y,
            stackedValue
        ]);
        var height = $2d01cd0a84db3fc5$var$vec3.dist(start, end); // PENDING When zAxis is not cross zero.
        var dir = [
            0,
            end[1] < start[1] ? -1 : 1,
            0
        ];
        if (Math.abs(height) === 0) // TODO
        height = 0.1;
        var size = [
            barSize[0],
            height,
            barSize[1]
        ];
        data.setItemLayout(idx, [
            start,
            dir,
            size
        ]);
    });
    data.setLayout("orient", [
        1,
        0,
        0
    ]);
}
var $2d01cd0a84db3fc5$export$2e2bcd8739ae039 = $2d01cd0a84db3fc5$var$cartesian3DLayout;


function $bcc594b57099ea41$export$2e2bcd8739ae039(data, dimX, dimY) {
    var xExtent = data.getDataExtent(dimX);
    var yExtent = data.getDataExtent(dimY); // TODO Handle one data situation
    var xSpan = xExtent[1] - xExtent[0] || xExtent[0];
    var ySpan = yExtent[1] - yExtent[0] || yExtent[0];
    var dimSize = 50;
    var tmp = new Uint8Array(dimSize * dimSize);
    for(var i = 0; i < data.count(); i++){
        var x = data.get(dimX, i);
        var y = data.get(dimY, i);
        var xIdx = Math.floor((x - xExtent[0]) / xSpan * (dimSize - 1));
        var yIdx = Math.floor((y - yExtent[0]) / ySpan * (dimSize - 1));
        var idx = yIdx * dimSize + xIdx;
        tmp[idx] = tmp[idx] || 1;
    }
    var filledCount = 0;
    for(var i = 0; i < tmp.length; i++)if (tmp[i]) filledCount++;
    return filledCount / tmp.length;
}


var $89e2ff65ce558a58$var$vec3 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).vec3;
var $89e2ff65ce558a58$var$isDimensionStacked = $9a616079ee96a3f3$exports.dataStack.isDimensionStacked;
function $89e2ff65ce558a58$var$globeLayout(seriesModel, coordSys) {
    var data = seriesModel.getData();
    var barMinHeight = seriesModel.get("minHeight") || 0;
    var barSize = seriesModel.get("barSize");
    var dims = [
        "lng",
        "lat",
        "alt"
    ].map(function(coordDimName) {
        return seriesModel.coordDimToDataDim(coordDimName)[0];
    });
    if (barSize == null) {
        var perimeter = coordSys.radius * Math.PI;
        var fillRatio = (0, $bcc594b57099ea41$export$2e2bcd8739ae039)(data, dims[0], dims[1]);
        barSize = [
            perimeter / Math.sqrt(data.count() / fillRatio),
            perimeter / Math.sqrt(data.count() / fillRatio)
        ];
    } else if (!$224386f1517b5dca$exports.isArray(barSize)) barSize = [
        barSize,
        barSize
    ];
    var valueDim = $89e2ff65ce558a58$var$getValueDimension(data, dims);
    data.each(dims, function(lng, lat, val, idx) {
        var stackedValue = data.get(valueDim.dimension, idx);
        var baseValue = valueDim.isStacked ? stackedValue - val : coordSys.altitudeAxis.scale.getExtent()[0]; // TODO Stacked with minHeight.
        var height = Math.max(coordSys.altitudeAxis.dataToCoord(val), barMinHeight);
        var start = coordSys.dataToPoint([
            lng,
            lat,
            baseValue
        ]);
        var end = coordSys.dataToPoint([
            lng,
            lat,
            stackedValue
        ]);
        var dir = $89e2ff65ce558a58$var$vec3.sub([], end, start);
        $89e2ff65ce558a58$var$vec3.normalize(dir, dir);
        var size = [
            barSize[0],
            height,
            barSize[1]
        ];
        data.setItemLayout(idx, [
            start,
            dir,
            size
        ]);
    });
    data.setLayout("orient", (0, $27fea36417076c2d$export$2e2bcd8739ae039).UP.array);
}
function $89e2ff65ce558a58$var$geo3DLayout(seriesModel, coordSys) {
    var data = seriesModel.getData();
    var barSize = seriesModel.get("barSize");
    var barMinHeight = seriesModel.get("minHeight") || 0;
    var dims = [
        "lng",
        "lat",
        "alt"
    ].map(function(coordDimName) {
        return seriesModel.coordDimToDataDim(coordDimName)[0];
    });
    if (barSize == null) {
        var size = Math.min(coordSys.size[0], coordSys.size[2]);
        var fillRatio = (0, $bcc594b57099ea41$export$2e2bcd8739ae039)(data, dims[0], dims[1]);
        barSize = [
            size / Math.sqrt(data.count() / fillRatio),
            size / Math.sqrt(data.count() / fillRatio)
        ];
    } else if (!$224386f1517b5dca$exports.isArray(barSize)) barSize = [
        barSize,
        barSize
    ];
    var dir = [
        0,
        1,
        0
    ];
    var valueDim = $89e2ff65ce558a58$var$getValueDimension(data, dims);
    data.each(dims, function(lng, lat, val, idx) {
        var stackedValue = data.get(valueDim.dimension, idx);
        var baseValue = valueDim.isStacked ? stackedValue - val : coordSys.altitudeAxis.scale.getExtent()[0];
        var height = Math.max(coordSys.altitudeAxis.dataToCoord(val), barMinHeight);
        var start = coordSys.dataToPoint([
            lng,
            lat,
            baseValue
        ]);
        var size = [
            barSize[0],
            height,
            barSize[1]
        ];
        data.setItemLayout(idx, [
            start,
            dir,
            size
        ]);
    });
    data.setLayout("orient", [
        1,
        0,
        0
    ]);
}
function $89e2ff65ce558a58$var$mapService3DLayout(seriesModel, coordSys) {
    var data = seriesModel.getData();
    var dimLng = seriesModel.coordDimToDataDim("lng")[0];
    var dimLat = seriesModel.coordDimToDataDim("lat")[0];
    var dimAlt = seriesModel.coordDimToDataDim("alt")[0];
    var barSize = seriesModel.get("barSize");
    var barMinHeight = seriesModel.get("minHeight") || 0;
    if (barSize == null) {
        var xExtent = data.getDataExtent(dimLng);
        var yExtent = data.getDataExtent(dimLat);
        var corner0 = coordSys.dataToPoint([
            xExtent[0],
            yExtent[0]
        ]);
        var corner1 = coordSys.dataToPoint([
            xExtent[1],
            yExtent[1]
        ]);
        var size = Math.min(Math.abs(corner0[0] - corner1[0]), Math.abs(corner0[1] - corner1[1])) || 1;
        var fillRatio = (0, $bcc594b57099ea41$export$2e2bcd8739ae039)(data, dimLng, dimLat); // PENDING, data density
        barSize = [
            size / Math.sqrt(data.count() / fillRatio),
            size / Math.sqrt(data.count() / fillRatio)
        ];
    } else {
        if (!$224386f1517b5dca$exports.isArray(barSize)) barSize = [
            barSize,
            barSize
        ];
        barSize[0] /= coordSys.getScale() / 16;
        barSize[1] /= coordSys.getScale() / 16;
    }
    var dir = [
        0,
        0,
        1
    ];
    var dims = [
        dimLng,
        dimLat,
        dimAlt
    ];
    var valueDim = $89e2ff65ce558a58$var$getValueDimension(data, dims);
    data.each(dims, function(lng, lat, val, idx) {
        var stackedValue = data.get(valueDim.dimension, idx);
        var baseValue = valueDim.isStacked ? stackedValue - val : 0;
        var start = coordSys.dataToPoint([
            lng,
            lat,
            baseValue
        ]);
        var end = coordSys.dataToPoint([
            lng,
            lat,
            stackedValue
        ]);
        var height = Math.max(end[2] - start[2], barMinHeight);
        var size = [
            barSize[0],
            height,
            barSize[1]
        ];
        data.setItemLayout(idx, [
            start,
            dir,
            size
        ]);
    });
    data.setLayout("orient", [
        1,
        0,
        0
    ]);
}
function $89e2ff65ce558a58$var$getValueDimension(data, dataDims) {
    var isStacked = $89e2ff65ce558a58$var$isDimensionStacked(data, dataDims[2]);
    return {
        dimension: isStacked ? data.getCalculationInfo("stackResultDimension") : dataDims[2],
        isStacked: isStacked
    };
}
function $89e2ff65ce558a58$export$2e2bcd8739ae039(registers) {
    registers.registerLayout(function(ecModel, api) {
        ecModel.eachSeriesByType("bar3D", function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            var coordSysType = coordSys && coordSys.type;
            if (coordSysType === "globe") $89e2ff65ce558a58$var$globeLayout(seriesModel, coordSys);
            else if (coordSysType === "cartesian3D") (0, $2d01cd0a84db3fc5$export$2e2bcd8739ae039)(seriesModel, coordSys);
            else if (coordSysType === "geo3D") $89e2ff65ce558a58$var$geo3DLayout(seriesModel, coordSys);
            else if (coordSysType === "mapbox3D" || coordSysType === "maptalks3D") $89e2ff65ce558a58$var$mapService3DLayout(seriesModel, coordSys);
        });
    });
}





var $308e5bdbc7337a3a$var$formatUtil = {};
$308e5bdbc7337a3a$var$formatUtil.getFormattedLabel = function(seriesModel, dataIndex, status, dataType, dimIndex) {
    status = status || "normal";
    var data = seriesModel.getData(dataType);
    var itemModel = data.getItemModel(dataIndex);
    var params = seriesModel.getDataParams(dataIndex, dataType);
    if (dimIndex != null && params.value instanceof Array) params.value = params.value[dimIndex];
    var formatter = itemModel.get(status === "normal" ? [
        "label",
        "formatter"
    ] : [
        "emphasis",
        "label",
        "formatter"
    ]);
    if (formatter == null) formatter = itemModel.get([
        "label",
        "formatter"
    ]);
    var text;
    if (typeof formatter === "function") {
        params.status = status;
        text = formatter(params);
    } else if (typeof formatter === "string") text = $8eb0e968d6dc83bc$exports.formatTpl(formatter, params);
    return text;
};
/**
 * If value is not array, then convert it to array.
 * @param  {*} value
 * @return {Array} [value] or value
 */ $308e5bdbc7337a3a$var$formatUtil.normalizeToArray = function(value) {
    return value instanceof Array ? value : value == null ? [] : [
        value
    ];
};
var $308e5bdbc7337a3a$export$2e2bcd8739ae039 = $308e5bdbc7337a3a$var$formatUtil;




function $588422417f0cb36c$var$otherDimToDataDim(data, otherDim) {
    var dataDim = [];
    $224386f1517b5dca$exports.each(data.dimensions, function(dimName) {
        var dimItem = data.getDimensionInfo(dimName);
        var otherDims = dimItem.otherDims;
        var dimIndex = otherDims[otherDim];
        if (dimIndex != null && dimIndex !== false) dataDim[dimIndex] = dimItem.name;
    });
    return dataDim;
}
function $588422417f0cb36c$export$2e2bcd8739ae039(seriesModel, dataIndex, multipleSeries) {
    function formatArrayValue(value) {
        var vertially = true;
        var result = [];
        var tooltipDims = $588422417f0cb36c$var$otherDimToDataDim(data, "tooltip");
        tooltipDims.length ? $224386f1517b5dca$exports.each(tooltipDims, function(dimIdx) {
            setEachItem(data.get(dimIdx, dataIndex), dimIdx);
        }) // By default, all dims is used on tooltip.
         : $224386f1517b5dca$exports.each(value, setEachItem);
        function setEachItem(val, dimIdx) {
            var dimInfo = data.getDimensionInfo(dimIdx); // If `dimInfo.tooltip` is not set, show tooltip.
            if (!dimInfo || dimInfo.otherDims.tooltip === false) return;
            var dimType = dimInfo.type;
            var valStr = (vertially ? "- " + (dimInfo.tooltipName || dimInfo.name) + ": " : "") + (dimType === "ordinal" ? val + "" : dimType === "time" ? multipleSeries ? "" : $8eb0e968d6dc83bc$exports.formatTime("yyyy/MM/dd hh:mm:ss", val) : $8eb0e968d6dc83bc$exports.addCommas(val));
            valStr && result.push($8eb0e968d6dc83bc$exports.encodeHTML(valStr));
        }
        return (vertially ? "<br/>" : "") + result.join(vertially ? "<br/>" : ", ");
    }
    var data = seriesModel.getData();
    var value = seriesModel.getRawValue(dataIndex);
    var formattedValue = $224386f1517b5dca$exports.isArray(value) ? formatArrayValue(value) : $8eb0e968d6dc83bc$exports.encodeHTML($8eb0e968d6dc83bc$exports.addCommas(value));
    var name = data.getName(dataIndex);
    var color = (0, $4c1f03531dad0b09$export$bc92a5a7848039f)(data, dataIndex);
    if ($224386f1517b5dca$exports.isObject(color) && color.colorStops) color = (color.colorStops[0] || {}).color;
    color = color || "transparent";
    var colorEl = $8eb0e968d6dc83bc$exports.getTooltipMarker(color);
    var seriesName = seriesModel.name; // FIXME
    if (seriesName === "\0-") // Not show '-'
    seriesName = "";
    seriesName = seriesName ? $8eb0e968d6dc83bc$exports.encodeHTML(seriesName) + (!multipleSeries ? "<br/>" : ": ") : "";
    return !multipleSeries ? seriesName + colorEl + (name ? $8eb0e968d6dc83bc$exports.encodeHTML(name) + ": " + formattedValue : formattedValue) : colorEl + seriesName + formattedValue;
}



function $a0377603e49108f9$export$2e2bcd8739ae039(seriesModel, dims, source) {
    source = source || seriesModel.getSource();
    var coordSysDimensions = dims || $4d59907f44a2d0ad$export$fc2638719e4159b9(seriesModel.get("coordinateSystem")) || [
        "x",
        "y",
        "z"
    ];
    var dimensions = $9a616079ee96a3f3$exports.createDimensions(source, {
        dimensionsDefine: source.dimensionsDefine || seriesModel.get("dimensions"),
        encodeDefine: source.encodeDefine || seriesModel.get("encode"),
        coordDimensions: coordSysDimensions.map(function(dim) {
            var axis3DModel = seriesModel.getReferringComponents(dim + "Axis3D").models[0];
            return {
                type: axis3DModel && axis3DModel.get("type") === "category" ? "ordinal" : "float",
                name: dim // Find stackable dimension. Which will represent value.
            };
        })
    });
    if (seriesModel.get("coordinateSystem") === "cartesian3D") dimensions.forEach(function(dimInfo) {
        if (coordSysDimensions.indexOf(dimInfo.coordDim) >= 0) {
            var axis3DModel = seriesModel.getReferringComponents(dimInfo.coordDim + "Axis3D").models[0];
            if (axis3DModel && axis3DModel.get("type") === "category") dimInfo.ordinalMeta = axis3DModel.getOrdinalMeta();
        }
    });
    var stackCalculationInfo = $9a616079ee96a3f3$exports.dataStack.enableDataStack(seriesModel, dimensions, {
        byIndex: true,
        stackedCoordDimension: "z"
    });
    var data = new $0ab0556b819346fd$export$2e2bcd8739ae039(dimensions, seriesModel);
    data.setCalculationInfo(stackCalculationInfo);
    data.initData(source);
    return data;
}


var $04542be816df6af4$var$Bar3DSeries = $7c10febb2cdef0d8$export$2e2bcd8739ae039.extend({
    type: "series.bar3D",
    dependencies: [
        "globe"
    ],
    visualStyleAccessPathvisu: "itemStyle",
    getInitialData: function(option, ecModel) {
        return (0, $a0377603e49108f9$export$2e2bcd8739ae039)(this);
    },
    getFormattedLabel: function(dataIndex, status, dataType, dimIndex) {
        var text = (0, $308e5bdbc7337a3a$export$2e2bcd8739ae039).getFormattedLabel(this, dataIndex, status, dataType, dimIndex);
        if (text == null) text = this.getData().get("z", dataIndex);
        return text;
    },
    formatTooltip: function(dataIndex) {
        return (0, $588422417f0cb36c$export$2e2bcd8739ae039)(this, dataIndex);
    },
    defaultOption: {
        coordinateSystem: "cartesian3D",
        globeIndex: 0,
        grid3DIndex: 0,
        zlevel: -10,
        // bevelSize, 0 has no bevel
        bevelSize: 0,
        // higher is smoother
        bevelSmoothness: 2,
        // Bar width and depth
        // barSize: [1, 1],
        // On grid plane when coordinateSystem is cartesian3D
        onGridPlane: "xy",
        // Shading of globe
        shading: "color",
        minHeight: 0,
        itemStyle: {
            opacity: 1
        },
        label: {
            show: false,
            distance: 2,
            textStyle: {
                fontSize: 14,
                color: "#000",
                backgroundColor: "rgba(255,255,255,0.7)",
                padding: 3,
                borderRadius: 3
            }
        },
        emphasis: {
            label: {
                show: true
            }
        },
        animationDurationUpdate: 500
    }
});
$224386f1517b5dca$exports.merge($04542be816df6af4$var$Bar3DSeries.prototype, (0, $f866f5803ca3a09a$export$2e2bcd8739ae039));
var $04542be816df6af4$export$2e2bcd8739ae039 = $04542be816df6af4$var$Bar3DSeries;






/**
 * Geometry collecting bars data
 *
 * @module echarts-gl/chart/bars/BarsGeometry
 * @author Yi Shen(http://github.com/pissang)
 */ 




var $bc62d2337900017e$var$vec3 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).vec3;
var $bc62d2337900017e$var$mat3 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).mat3;
/**
 * @constructor
 * @alias module:echarts-gl/chart/bars/BarsGeometry
 * @extends clay.Geometry
 */ var $bc62d2337900017e$var$BarsGeometry = (0, $c75c69a759bf7591$export$2e2bcd8739ae039).extend(function() {
    return {
        attributes: {
            position: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("position", "float", 3, "POSITION"),
            normal: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("normal", "float", 3, "NORMAL"),
            color: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("color", "float", 4, "COLOR"),
            prevPosition: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("prevPosition", "float", 3),
            prevNormal: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("prevNormal", "float", 3)
        },
        dynamic: true,
        enableNormal: false,
        bevelSize: 1,
        bevelSegments: 0,
        // Map from vertexIndex to dataIndex.
        _dataIndices: null,
        _vertexOffset: 0,
        _triangleOffset: 0
    };
}, /** @lends module:echarts-gl/chart/bars/BarsGeometry.prototype */ {
    resetOffset: function() {
        this._vertexOffset = 0;
        this._triangleOffset = 0;
    },
    setBarCount: function(barCount) {
        var enableNormal = this.enableNormal;
        var vertexCount = this.getBarVertexCount() * barCount;
        var triangleCount = this.getBarTriangleCount() * barCount;
        if (this.vertexCount !== vertexCount) {
            this.attributes.position.init(vertexCount);
            if (enableNormal) this.attributes.normal.init(vertexCount);
            else this.attributes.normal.value = null;
            this.attributes.color.init(vertexCount);
        }
        if (this.triangleCount !== triangleCount) {
            this.indices = vertexCount > 0xffff ? new Uint32Array(triangleCount * 3) : new Uint16Array(triangleCount * 3);
            this._dataIndices = new Uint32Array(vertexCount);
        }
    },
    getBarVertexCount: function() {
        var bevelSegments = this.bevelSize > 0 ? this.bevelSegments : 0;
        return bevelSegments > 0 ? this._getBevelBarVertexCount(bevelSegments) : this.enableNormal ? 24 : 8;
    },
    getBarTriangleCount: function() {
        var bevelSegments = this.bevelSize > 0 ? this.bevelSegments : 0;
        return bevelSegments > 0 ? this._getBevelBarTriangleCount(bevelSegments) : 12;
    },
    _getBevelBarVertexCount: function(bevelSegments) {
        return (bevelSegments + 1) * 4 * (bevelSegments + 1) * 2;
    },
    _getBevelBarTriangleCount: function(bevelSegments) {
        var widthSegments = bevelSegments * 4 + 3;
        var heightSegments = bevelSegments * 2 + 1;
        return (widthSegments + 1) * heightSegments * 2 + 4;
    },
    setColor: function(idx, color) {
        var vertexCount = this.getBarVertexCount();
        var start = vertexCount * idx;
        var end = vertexCount * (idx + 1);
        for(var i = start; i < end; i++)this.attributes.color.set(i, color);
        this.dirtyAttribute("color");
    },
    /**
   * Get dataIndex of vertex.
   * @param {number} vertexIndex
   */ getDataIndexOfVertex: function(vertexIndex) {
        return this._dataIndices ? this._dataIndices[vertexIndex] : null;
    },
    /**
   * Add a bar
   * @param {Array.<number>} start
   * @param {Array.<number>} end
   * @param {Array.<number>} orient  right direction
   * @param {Array.<number>} size size on x and z
   * @param {Array.<number>} color
   */ addBar: function() {
        var v3Create = $bc62d2337900017e$var$vec3.create;
        var v3ScaleAndAdd = $bc62d2337900017e$var$vec3.scaleAndAdd;
        var end = v3Create();
        var px = v3Create();
        var py = v3Create();
        var pz = v3Create();
        var nx = v3Create();
        var ny = v3Create();
        var nz = v3Create();
        var pts = [];
        var normals = [];
        for(var i = 0; i < 8; i++)pts[i] = v3Create();
        var cubeFaces4 = [
            [
                0,
                1,
                5,
                4
            ],
            [
                2,
                3,
                7,
                6
            ],
            [
                4,
                5,
                6,
                7
            ],
            [
                3,
                2,
                1,
                0
            ],
            [
                0,
                4,
                7,
                3
            ],
            [
                1,
                2,
                6,
                5
            ]
        ];
        var face4To3 = [
            0,
            1,
            2,
            0,
            2,
            3
        ];
        var cubeFaces3 = [];
        for(var i = 0; i < cubeFaces4.length; i++){
            var face4 = cubeFaces4[i];
            for(var j = 0; j < 2; j++){
                var face = [];
                for(var k = 0; k < 3; k++)face.push(face4[face4To3[j * 3 + k]]);
                cubeFaces3.push(face);
            }
        }
        return function(start, dir, leftDir, size, color, dataIndex) {
            // Use vertex, triangle maybe sorted.
            var startVertex = this._vertexOffset;
            if (this.bevelSize > 0 && this.bevelSegments > 0) this._addBevelBar(start, dir, leftDir, size, this.bevelSize, this.bevelSegments, color);
            else {
                $bc62d2337900017e$var$vec3.copy(py, dir);
                $bc62d2337900017e$var$vec3.normalize(py, py); // x * y => z
                $bc62d2337900017e$var$vec3.cross(pz, leftDir, py);
                $bc62d2337900017e$var$vec3.normalize(pz, pz); // y * z => x
                $bc62d2337900017e$var$vec3.cross(px, py, pz);
                $bc62d2337900017e$var$vec3.normalize(pz, pz);
                $bc62d2337900017e$var$vec3.negate(nx, px);
                $bc62d2337900017e$var$vec3.negate(ny, py);
                $bc62d2337900017e$var$vec3.negate(nz, pz);
                v3ScaleAndAdd(pts[0], start, px, size[0] / 2);
                v3ScaleAndAdd(pts[0], pts[0], pz, size[2] / 2);
                v3ScaleAndAdd(pts[1], start, px, size[0] / 2);
                v3ScaleAndAdd(pts[1], pts[1], nz, size[2] / 2);
                v3ScaleAndAdd(pts[2], start, nx, size[0] / 2);
                v3ScaleAndAdd(pts[2], pts[2], nz, size[2] / 2);
                v3ScaleAndAdd(pts[3], start, nx, size[0] / 2);
                v3ScaleAndAdd(pts[3], pts[3], pz, size[2] / 2);
                v3ScaleAndAdd(end, start, py, size[1]);
                v3ScaleAndAdd(pts[4], end, px, size[0] / 2);
                v3ScaleAndAdd(pts[4], pts[4], pz, size[2] / 2);
                v3ScaleAndAdd(pts[5], end, px, size[0] / 2);
                v3ScaleAndAdd(pts[5], pts[5], nz, size[2] / 2);
                v3ScaleAndAdd(pts[6], end, nx, size[0] / 2);
                v3ScaleAndAdd(pts[6], pts[6], nz, size[2] / 2);
                v3ScaleAndAdd(pts[7], end, nx, size[0] / 2);
                v3ScaleAndAdd(pts[7], pts[7], pz, size[2] / 2);
                var attributes = this.attributes;
                if (this.enableNormal) {
                    normals[0] = px;
                    normals[1] = nx;
                    normals[2] = py;
                    normals[3] = ny;
                    normals[4] = pz;
                    normals[5] = nz;
                    var vertexOffset = this._vertexOffset;
                    for(var i = 0; i < cubeFaces4.length; i++){
                        var idx3 = this._triangleOffset * 3;
                        for(var k = 0; k < 6; k++)this.indices[idx3++] = vertexOffset + face4To3[k];
                        vertexOffset += 4;
                        this._triangleOffset += 2;
                    }
                    for(var i = 0; i < cubeFaces4.length; i++){
                        var normal = normals[i];
                        for(var k = 0; k < 4; k++){
                            var idx = cubeFaces4[i][k];
                            attributes.position.set(this._vertexOffset, pts[idx]);
                            attributes.normal.set(this._vertexOffset, normal);
                            attributes.color.set(this._vertexOffset++, color);
                        }
                    }
                } else {
                    for(var i = 0; i < cubeFaces3.length; i++){
                        var idx3 = this._triangleOffset * 3;
                        for(var k = 0; k < 3; k++)this.indices[idx3 + k] = cubeFaces3[i][k] + this._vertexOffset;
                        this._triangleOffset++;
                    }
                    for(var i = 0; i < pts.length; i++){
                        attributes.position.set(this._vertexOffset, pts[i]);
                        attributes.color.set(this._vertexOffset++, color);
                    }
                }
            }
            var endVerex = this._vertexOffset;
            for(var i = startVertex; i < endVerex; i++)this._dataIndices[i] = dataIndex;
        };
    }(),
    /**
   * Add a bar with bevel
   * @param {Array.<number>} start
   * @param {Array.<number>} end
   * @param {Array.<number>} orient  right direction
   * @param {Array.<number>} size size on x and z
   * @param {number} bevelSize
   * @param {number} bevelSegments
   * @param {Array.<number>} color
   */ _addBevelBar: function() {
        var px = $bc62d2337900017e$var$vec3.create();
        var py = $bc62d2337900017e$var$vec3.create();
        var pz = $bc62d2337900017e$var$vec3.create();
        var rotateMat = $bc62d2337900017e$var$mat3.create();
        var bevelStartSize = [];
        var xOffsets = [
            1,
            -1,
            -1,
            1
        ];
        var zOffsets = [
            1,
            1,
            -1,
            -1
        ];
        var yOffsets = [
            2,
            0
        ];
        return function(start, dir, leftDir, size, bevelSize, bevelSegments, color) {
            $bc62d2337900017e$var$vec3.copy(py, dir);
            $bc62d2337900017e$var$vec3.normalize(py, py); // x * y => z
            $bc62d2337900017e$var$vec3.cross(pz, leftDir, py);
            $bc62d2337900017e$var$vec3.normalize(pz, pz); // y * z => x
            $bc62d2337900017e$var$vec3.cross(px, py, pz);
            $bc62d2337900017e$var$vec3.normalize(pz, pz);
            rotateMat[0] = px[0];
            rotateMat[1] = px[1];
            rotateMat[2] = px[2];
            rotateMat[3] = py[0];
            rotateMat[4] = py[1];
            rotateMat[5] = py[2];
            rotateMat[6] = pz[0];
            rotateMat[7] = pz[1];
            rotateMat[8] = pz[2];
            bevelSize = Math.min(size[0], size[2]) / 2 * bevelSize;
            for(var i = 0; i < 3; i++)bevelStartSize[i] = Math.max(size[i] - bevelSize * 2, 0);
            var rx = (size[0] - bevelStartSize[0]) / 2;
            var ry = (size[1] - bevelStartSize[1]) / 2;
            var rz = (size[2] - bevelStartSize[2]) / 2;
            var pos = [];
            var normal = [];
            var vertexOffset = this._vertexOffset;
            var endIndices = [];
            for(var i = 0; i < 2; i++){
                endIndices[i] = endIndices[i] = [];
                for(var m = 0; m <= bevelSegments; m++)for(var j = 0; j < 4; j++){
                    if (m === 0 && i === 0 || i === 1 && m === bevelSegments) endIndices[i].push(vertexOffset);
                    for(var n = 0; n <= bevelSegments; n++){
                        var phi = n / bevelSegments * Math.PI / 2 + Math.PI / 2 * j;
                        var theta = m / bevelSegments * Math.PI / 2 + Math.PI / 2 * i; // var r = rx < ry ? (rz < rx ? rz : rx) : (rz < ry ? rz : ry);
                        normal[0] = rx * Math.cos(phi) * Math.sin(theta);
                        normal[1] = ry * Math.cos(theta);
                        normal[2] = rz * Math.sin(phi) * Math.sin(theta);
                        pos[0] = normal[0] + xOffsets[j] * bevelStartSize[0] / 2;
                        pos[1] = normal[1] + ry + yOffsets[i] * bevelStartSize[1] / 2;
                        pos[2] = normal[2] + zOffsets[j] * bevelStartSize[2] / 2; // Normal is not right if rx, ry, rz not equal.
                        if (!(Math.abs(rx - ry) < 1e-6 && Math.abs(ry - rz) < 1e-6)) {
                            normal[0] /= rx * rx;
                            normal[1] /= ry * ry;
                            normal[2] /= rz * rz;
                        }
                        $bc62d2337900017e$var$vec3.normalize(normal, normal);
                        $bc62d2337900017e$var$vec3.transformMat3(pos, pos, rotateMat);
                        $bc62d2337900017e$var$vec3.transformMat3(normal, normal, rotateMat);
                        $bc62d2337900017e$var$vec3.add(pos, pos, start);
                        this.attributes.position.set(vertexOffset, pos);
                        if (this.enableNormal) this.attributes.normal.set(vertexOffset, normal);
                        this.attributes.color.set(vertexOffset, color);
                        vertexOffset++;
                    }
                }
            }
            var widthSegments = bevelSegments * 4 + 3;
            var heightSegments = bevelSegments * 2 + 1;
            var len = widthSegments + 1;
            for(var j = 0; j < heightSegments; j++)for(var i = 0; i <= widthSegments; i++){
                var i2 = j * len + i + this._vertexOffset;
                var i1 = j * len + (i + 1) % len + this._vertexOffset;
                var i4 = (j + 1) * len + (i + 1) % len + this._vertexOffset;
                var i3 = (j + 1) * len + i + this._vertexOffset;
                this.setTriangleIndices(this._triangleOffset++, [
                    i4,
                    i2,
                    i1
                ]);
                this.setTriangleIndices(this._triangleOffset++, [
                    i4,
                    i3,
                    i2
                ]);
            }
             // Close top and bottom
            this.setTriangleIndices(this._triangleOffset++, [
                endIndices[0][0],
                endIndices[0][2],
                endIndices[0][1]
            ]);
            this.setTriangleIndices(this._triangleOffset++, [
                endIndices[0][0],
                endIndices[0][3],
                endIndices[0][2]
            ]);
            this.setTriangleIndices(this._triangleOffset++, [
                endIndices[1][0],
                endIndices[1][1],
                endIndices[1][2]
            ]);
            this.setTriangleIndices(this._triangleOffset++, [
                endIndices[1][0],
                endIndices[1][2],
                endIndices[1][3]
            ]);
            this._vertexOffset = vertexOffset;
        };
    }()
});
$224386f1517b5dca$exports.defaults($bc62d2337900017e$var$BarsGeometry.prototype, (0, $5c3dce311da2ccea$export$2e2bcd8739ae039));
$224386f1517b5dca$exports.defaults($bc62d2337900017e$var$BarsGeometry.prototype, (0, $fd6f60f8a754e772$export$2e2bcd8739ae039));
var $bc62d2337900017e$export$2e2bcd8739ae039 = $bc62d2337900017e$var$BarsGeometry;





var $612b1c5e57a6d098$var$vec3 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).vec3;
var $612b1c5e57a6d098$export$2e2bcd8739ae039 = $0dc5061053e23cd3$export$2e2bcd8739ae039.extend({
    type: "bar3D",
    __ecgl__: true,
    init: function(ecModel, api) {
        this.groupGL = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
        this._api = api;
        this._labelsBuilder = new (0, $87f8de1342284ee1$export$2e2bcd8739ae039)(256, 256, api);
        var self = this;
        this._labelsBuilder.getLabelPosition = function(dataIndex, position, distance) {
            if (self._data) {
                var layout = self._data.getItemLayout(dataIndex);
                var start = layout[0];
                var dir = layout[1];
                var height = layout[2][1];
                return $612b1c5e57a6d098$var$vec3.scaleAndAdd([], start, dir, distance + height);
            } else return [
                0,
                0
            ];
        }; // Give a large render order.
        this._labelsBuilder.getMesh().renderOrder = 100;
    },
    render: function(seriesModel, ecModel, api) {
        // Swap barMesh
        var tmp = this._prevBarMesh;
        this._prevBarMesh = this._barMesh;
        this._barMesh = tmp;
        if (!this._barMesh) this._barMesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
            geometry: new (0, $bc62d2337900017e$export$2e2bcd8739ae039)(),
            shadowDepthMaterial: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
                shader: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader((0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.source("ecgl.sm.depth.vertex"), (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.source("ecgl.sm.depth.fragment"))
            }),
            // Only cartesian3D enable culling
            // FIXME Performance
            culling: seriesModel.coordinateSystem.type === "cartesian3D",
            // Render after axes
            renderOrder: 10,
            // Render normal in normal pass
            renderNormal: true
        });
        this.groupGL.remove(this._prevBarMesh);
        this.groupGL.add(this._barMesh);
        this.groupGL.add(this._labelsBuilder.getMesh());
        var coordSys = seriesModel.coordinateSystem;
        this._doRender(seriesModel, api);
        if (coordSys && coordSys.viewGL) {
            coordSys.viewGL.add(this.groupGL);
            var methodName = coordSys.viewGL.isLinearSpace() ? "define" : "undefine";
            this._barMesh.material[methodName]("fragment", "SRGB_DECODE");
        }
        this._data = seriesModel.getData();
        this._labelsBuilder.updateData(this._data);
        this._labelsBuilder.updateLabels();
        this._updateAnimation(seriesModel);
    },
    _updateAnimation: function(seriesModel) {
        (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).updateVertexAnimation([
            [
                "prevPosition",
                "position"
            ],
            [
                "prevNormal",
                "normal"
            ]
        ], this._prevBarMesh, this._barMesh, seriesModel);
    },
    _doRender: function(seriesModel, api) {
        var data = seriesModel.getData();
        var shading = seriesModel.get("shading");
        var enableNormal = shading !== "color";
        var self = this;
        var barMesh = this._barMesh;
        var shadingPrefix = "ecgl." + shading;
        if (!barMesh.material || barMesh.material.shader.name !== shadingPrefix) barMesh.material = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createMaterial(shadingPrefix, [
            "VERTEX_COLOR"
        ]);
        (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).setMaterialFromModel(shading, barMesh.material, seriesModel, api);
        barMesh.geometry.enableNormal = enableNormal;
        barMesh.geometry.resetOffset(); // Bevel settings
        var bevelSize = seriesModel.get("bevelSize");
        var bevelSegments = seriesModel.get("bevelSmoothness");
        barMesh.geometry.bevelSegments = bevelSegments;
        barMesh.geometry.bevelSize = bevelSize;
        var colorArr = [];
        var vertexColors = new Float32Array(data.count() * 4);
        var colorOffset = 0;
        var barCount = 0;
        var hasTransparent = false;
        data.each(function(idx) {
            if (!data.hasValue(idx)) return;
            var color = (0, $4c1f03531dad0b09$export$bc92a5a7848039f)(data, idx);
            var opacity = (0, $4c1f03531dad0b09$export$f154d4dab8f4e8c0)(data, idx);
            if (opacity == null) opacity = 1;
            (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(color, colorArr);
            colorArr[3] *= opacity;
            vertexColors[colorOffset++] = colorArr[0];
            vertexColors[colorOffset++] = colorArr[1];
            vertexColors[colorOffset++] = colorArr[2];
            vertexColors[colorOffset++] = colorArr[3];
            if (colorArr[3] > 0) {
                barCount++;
                if (colorArr[3] < 0.99) hasTransparent = true;
            }
        });
        barMesh.geometry.setBarCount(barCount);
        var orient = data.getLayout("orient"); // Map of dataIndex and barIndex.
        var barIndexOfData = this._barIndexOfData = new Int32Array(data.count());
        var barCount = 0;
        data.each(function(idx) {
            if (!data.hasValue(idx)) {
                barIndexOfData[idx] = -1;
                return;
            }
            var layout = data.getItemLayout(idx);
            var start = layout[0];
            var dir = layout[1];
            var size = layout[2];
            var idx4 = idx * 4;
            colorArr[0] = vertexColors[idx4++];
            colorArr[1] = vertexColors[idx4++];
            colorArr[2] = vertexColors[idx4++];
            colorArr[3] = vertexColors[idx4++];
            if (colorArr[3] > 0) {
                self._barMesh.geometry.addBar(start, dir, orient, size, colorArr, idx);
                barIndexOfData[idx] = barCount++;
            }
        });
        barMesh.geometry.dirty();
        barMesh.geometry.updateBoundingBox();
        var material = barMesh.material;
        material.transparent = hasTransparent;
        material.depthMask = !hasTransparent;
        barMesh.geometry.sortTriangles = hasTransparent;
        this._initHandler(seriesModel, api);
    },
    _initHandler: function(seriesModel, api) {
        var data = seriesModel.getData();
        var barMesh = this._barMesh;
        var isCartesian3D = seriesModel.coordinateSystem.type === "cartesian3D";
        barMesh.seriesIndex = seriesModel.seriesIndex;
        var lastDataIndex = -1;
        barMesh.off("mousemove");
        barMesh.off("mouseout");
        barMesh.on("mousemove", function(e) {
            var dataIndex = barMesh.geometry.getDataIndexOfVertex(e.triangle[0]);
            if (dataIndex !== lastDataIndex) {
                this._downplay(lastDataIndex);
                this._highlight(dataIndex);
                this._labelsBuilder.updateLabels([
                    dataIndex
                ]);
                if (isCartesian3D) api.dispatchAction({
                    type: "grid3DShowAxisPointer",
                    value: [
                        data.get("x", dataIndex),
                        data.get("y", dataIndex),
                        data.get("z", dataIndex, true)
                    ]
                });
            }
            lastDataIndex = dataIndex;
            barMesh.dataIndex = dataIndex;
        }, this);
        barMesh.on("mouseout", function(e) {
            this._downplay(lastDataIndex);
            this._labelsBuilder.updateLabels();
            lastDataIndex = -1;
            barMesh.dataIndex = -1;
            if (isCartesian3D) api.dispatchAction({
                type: "grid3DHideAxisPointer"
            });
        }, this);
    },
    _highlight: function(dataIndex) {
        var data = this._data;
        if (!data) return;
        var barIndex = this._barIndexOfData[dataIndex];
        if (barIndex < 0) return;
        var itemModel = data.getItemModel(dataIndex);
        var emphasisItemStyleModel = itemModel.getModel("emphasis.itemStyle");
        var emphasisColor = emphasisItemStyleModel.get("color");
        var emphasisOpacity = emphasisItemStyleModel.get("opacity");
        if (emphasisColor == null) {
            var color = (0, $4c1f03531dad0b09$export$bc92a5a7848039f)(data, dataIndex);
            emphasisColor = $2c037f5bda6341ca$exports.lift(color, -0.4);
        }
        if (emphasisOpacity == null) emphasisOpacity = (0, $4c1f03531dad0b09$export$f154d4dab8f4e8c0)(data, dataIndex);
        var colorArr = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(emphasisColor);
        colorArr[3] *= emphasisOpacity;
        this._barMesh.geometry.setColor(barIndex, colorArr);
        this._api.getZr().refresh();
    },
    _downplay: function(dataIndex) {
        var data = this._data;
        if (!data) return;
        var barIndex = this._barIndexOfData[dataIndex];
        if (barIndex < 0) return;
        var color = (0, $4c1f03531dad0b09$export$bc92a5a7848039f)(data, dataIndex);
        var opacity = (0, $4c1f03531dad0b09$export$f154d4dab8f4e8c0)(data, dataIndex);
        var colorArr = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(color);
        colorArr[3] *= opacity;
        this._barMesh.geometry.setColor(barIndex, colorArr);
        this._api.getZr().refresh();
    },
    highlight: function(seriesModel, ecModel, api, payload) {
        this._toggleStatus("highlight", seriesModel, ecModel, api, payload);
    },
    downplay: function(seriesModel, ecModel, api, payload) {
        this._toggleStatus("downplay", seriesModel, ecModel, api, payload);
    },
    _toggleStatus: function(status, seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = (0, $5821dc5111828448$export$2e2bcd8739ae039).queryDataIndex(data, payload);
        var self = this;
        if (dataIndex != null) $224386f1517b5dca$exports.each((0, $308e5bdbc7337a3a$export$2e2bcd8739ae039).normalizeToArray(dataIndex), function(dataIdx) {
            status === "highlight" ? this._highlight(dataIdx) : this._downplay(dataIdx);
        }, this);
        else data.each(function(dataIdx) {
            status === "highlight" ? self._highlight(dataIdx) : self._downplay(dataIdx);
        });
    },
    remove: function() {
        this.groupGL.removeAll();
    },
    dispose: function() {
        this._labelsBuilder.dispose();
        this.groupGL.removeAll();
    }
});


function $4f1d99ae682a1a8b$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $612b1c5e57a6d098$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $04542be816df6af4$export$2e2bcd8739ae039));
    (0, $89e2ff65ce558a58$export$2e2bcd8739ae039)(registers);
    registers.registerProcessor(function(ecModel, api) {
        ecModel.eachSeriesByType("bar3d", function(seriesModel) {
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                return data.hasValue(idx);
            });
        });
    });
}


(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $4f1d99ae682a1a8b$export$4b3e715f166fdd78));



// TODO ECharts GL must be imported whatever component,charts is imported.




var $a85f4ee7467c9a2b$var$Line3DSeries = $7c10febb2cdef0d8$export$2e2bcd8739ae039.extend({
    type: "series.line3D",
    dependencies: [
        "grid3D"
    ],
    visualStyleAccessPath: "lineStyle",
    visualDrawType: "stroke",
    getInitialData: function(option, ecModel) {
        return (0, $a0377603e49108f9$export$2e2bcd8739ae039)(this);
    },
    formatTooltip: function(dataIndex) {
        return (0, $588422417f0cb36c$export$2e2bcd8739ae039)(this, dataIndex);
    },
    defaultOption: {
        coordinateSystem: "cartesian3D",
        zlevel: -10,
        // Cartesian coordinate system
        grid3DIndex: 0,
        lineStyle: {
            width: 2
        },
        animationDurationUpdate: 500
    }
});
var $a85f4ee7467c9a2b$export$2e2bcd8739ae039 = $a85f4ee7467c9a2b$var$Line3DSeries;












var $a72d22ca9b410163$var$vec3 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).vec3;
(0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.import((0, $ceca9d93a3d35604$export$2e2bcd8739ae039));
var $a72d22ca9b410163$export$2e2bcd8739ae039 = $0dc5061053e23cd3$export$2e2bcd8739ae039.extend({
    type: "line3D",
    __ecgl__: true,
    init: function(ecModel, api) {
        this.groupGL = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
        this._api = api;
    },
    render: function(seriesModel, ecModel, api) {
        var tmp = this._prevLine3DMesh;
        this._prevLine3DMesh = this._line3DMesh;
        this._line3DMesh = tmp;
        if (!this._line3DMesh) {
            this._line3DMesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
                geometry: new (0, $8c084a5220a66e92$export$2e2bcd8739ae039)({
                    useNativeLine: false,
                    sortTriangles: true
                }),
                material: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
                    shader: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createShader("ecgl.meshLines3D")
                }),
                // Render after axes
                renderOrder: 10
            });
            this._line3DMesh.geometry.pick = this._pick.bind(this);
        }
        this.groupGL.remove(this._prevLine3DMesh);
        this.groupGL.add(this._line3DMesh);
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.viewGL) {
            coordSys.viewGL.add(this.groupGL); // TODO
            var methodName = coordSys.viewGL.isLinearSpace() ? "define" : "undefine";
            this._line3DMesh.material[methodName]("fragment", "SRGB_DECODE");
        }
        this._doRender(seriesModel, api);
        this._data = seriesModel.getData();
        this._camera = coordSys.viewGL.camera;
        this.updateCamera();
        this._updateAnimation(seriesModel);
    },
    updateCamera: function() {
        this._updateNDCPosition();
    },
    _doRender: function(seriesModel, api) {
        var data = seriesModel.getData();
        var lineMesh = this._line3DMesh;
        lineMesh.geometry.resetOffset();
        var points = data.getLayout("points");
        var colorArr = [];
        var vertexColors = new Float32Array(points.length / 3 * 4);
        var colorOffset = 0;
        var hasTransparent = false;
        data.each(function(idx) {
            var color = (0, $4c1f03531dad0b09$export$bc92a5a7848039f)(data, idx);
            var opacity = (0, $4c1f03531dad0b09$export$f154d4dab8f4e8c0)(data, idx);
            if (opacity == null) opacity = 1;
            (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(color, colorArr);
            colorArr[3] *= opacity;
            vertexColors[colorOffset++] = colorArr[0];
            vertexColors[colorOffset++] = colorArr[1];
            vertexColors[colorOffset++] = colorArr[2];
            vertexColors[colorOffset++] = colorArr[3];
            if (colorArr[3] < 0.99) hasTransparent = true;
        });
        lineMesh.geometry.setVertexCount(lineMesh.geometry.getPolylineVertexCount(points));
        lineMesh.geometry.setTriangleCount(lineMesh.geometry.getPolylineTriangleCount(points));
        lineMesh.geometry.addPolyline(points, vertexColors, (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(seriesModel.get("lineStyle.width"), 1));
        lineMesh.geometry.dirty();
        lineMesh.geometry.updateBoundingBox();
        var material = lineMesh.material;
        material.transparent = hasTransparent;
        material.depthMask = !hasTransparent;
        var debugWireframeModel = seriesModel.getModel("debug.wireframe");
        if (debugWireframeModel.get("show")) {
            lineMesh.geometry.createAttribute("barycentric", "float", 3);
            lineMesh.geometry.generateBarycentric();
            lineMesh.material.set("both", "WIREFRAME_TRIANGLE");
            lineMesh.material.set("wireframeLineColor", (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(debugWireframeModel.get("lineStyle.color") || "rgba(0,0,0,0.5)"));
            lineMesh.material.set("wireframeLineWidth", (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(debugWireframeModel.get("lineStyle.width"), 1));
        } else lineMesh.material.set("both", "WIREFRAME_TRIANGLE");
        this._points = points;
        this._initHandler(seriesModel, api);
    },
    _updateAnimation: function(seriesModel) {
        (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).updateVertexAnimation([
            [
                "prevPosition",
                "position"
            ],
            [
                "prevPositionPrev",
                "positionPrev"
            ],
            [
                "prevPositionNext",
                "positionNext"
            ]
        ], this._prevLine3DMesh, this._line3DMesh, seriesModel);
    },
    _initHandler: function(seriesModel, api) {
        var data = seriesModel.getData();
        var coordSys = seriesModel.coordinateSystem;
        var lineMesh = this._line3DMesh;
        var lastDataIndex = -1;
        lineMesh.seriesIndex = seriesModel.seriesIndex;
        lineMesh.off("mousemove");
        lineMesh.off("mouseout");
        lineMesh.on("mousemove", function(e) {
            var value = coordSys.pointToData(e.point.array);
            var dataIndex = data.indicesOfNearest("x", value[0])[0];
            if (dataIndex !== lastDataIndex) {
                // this._downplay(lastDataIndex);
                // this._highlight(dataIndex);
                api.dispatchAction({
                    type: "grid3DShowAxisPointer",
                    value: [
                        data.get("x", dataIndex),
                        data.get("y", dataIndex),
                        data.get("z", dataIndex)
                    ]
                });
                lineMesh.dataIndex = dataIndex;
            }
            lastDataIndex = dataIndex;
        }, this);
        lineMesh.on("mouseout", function(e) {
            // this._downplay(lastDataIndex);
            lastDataIndex = -1;
            lineMesh.dataIndex = -1;
            api.dispatchAction({
                type: "grid3DHideAxisPointer"
            });
        }, this);
    },
    // _highlight: function (dataIndex) {
    //     var data = this._data;
    //     if (!data) {
    //         return;
    //     }
    // },
    // _downplay: function (dataIndex) {
    //     var data = this._data;
    //     if (!data) {
    //         return;
    //     }
    // },
    _updateNDCPosition: function() {
        var worldViewProjection = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
        var camera = this._camera;
        (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).multiply(worldViewProjection, camera.projectionMatrix, camera.viewMatrix);
        var positionNDC = this._positionNDC;
        var points = this._points;
        var nPoints = points.length / 3;
        if (!positionNDC || positionNDC.length / 2 !== nPoints) positionNDC = this._positionNDC = new Float32Array(nPoints * 2);
        var pos = [];
        for(var i = 0; i < nPoints; i++){
            var i3 = i * 3;
            var i2 = i * 2;
            pos[0] = points[i3];
            pos[1] = points[i3 + 1];
            pos[2] = points[i3 + 2];
            pos[3] = 1;
            $a72d22ca9b410163$var$vec3.transformMat4(pos, pos, worldViewProjection.array);
            positionNDC[i2] = pos[0] / pos[3];
            positionNDC[i2 + 1] = pos[1] / pos[3];
        }
    },
    _pick: function(x, y, renderer, camera, renderable, out) {
        var positionNDC = this._positionNDC;
        var seriesModel = this._data.hostModel;
        var lineWidth = seriesModel.get("lineStyle.width");
        var dataIndex = -1;
        var width = renderer.viewport.width;
        var height = renderer.viewport.height;
        var halfWidth = width * 0.5;
        var halfHeight = height * 0.5;
        x = (x + 1) * halfWidth;
        y = (y + 1) * halfHeight;
        for(var i = 1; i < positionNDC.length / 2; i++){
            var x0 = (positionNDC[(i - 1) * 2] + 1) * halfWidth;
            var y0 = (positionNDC[(i - 1) * 2 + 1] + 1) * halfHeight;
            var x1 = (positionNDC[i * 2] + 1) * halfWidth;
            var y1 = (positionNDC[i * 2 + 1] + 1) * halfHeight;
            if ($beafddd7270f4bea$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y)) {
                var dist0 = (x0 - x) * (x0 - x) + (y0 - y) * (y0 - y);
                var dist1 = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y); // Nearest point.
                dataIndex = dist0 < dist1 ? i - 1 : i;
            }
        }
        if (dataIndex >= 0) {
            var i3 = dataIndex * 3;
            var point = new (0, $27fea36417076c2d$export$2e2bcd8739ae039)(this._points[i3], this._points[i3 + 1], this._points[i3 + 2]);
            out.push({
                dataIndex: dataIndex,
                point: point,
                pointWorld: point.clone(),
                target: this._line3DMesh,
                distance: this._camera.getWorldPosition().dist(point)
            });
        }
    },
    remove: function() {
        this.groupGL.removeAll();
    },
    dispose: function() {
        this.groupGL.removeAll();
    }
});


function $cce5ac116578a674$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $a72d22ca9b410163$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $a85f4ee7467c9a2b$export$2e2bcd8739ae039));
    registers.registerLayout(function(ecModel, api) {
        ecModel.eachSeriesByType("line3D", function(seriesModel) {
            var data = seriesModel.getData();
            var coordSys = seriesModel.coordinateSystem;
            if (coordSys) {
                if (coordSys.type !== "cartesian3D") return;
                var points = new Float32Array(data.count() * 3);
                var item = [];
                var out = [];
                var coordDims = coordSys.dimensions;
                var dims = coordDims.map(function(coordDim) {
                    return seriesModel.coordDimToDataDim(coordDim)[0];
                });
                if (coordSys) data.each(dims, function(x, y, z, idx) {
                    item[0] = x;
                    item[1] = y;
                    item[2] = z;
                    coordSys.dataToPoint(item, out);
                    points[idx * 3] = out[0];
                    points[idx * 3 + 1] = out[1];
                    points[idx * 3 + 2] = out[2];
                });
                data.setLayout("points", points);
            }
        });
    });
}


(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $cce5ac116578a674$export$4b3e715f166fdd78));



// TODO ECharts GL must be imported whatever component,charts is imported.





var $ae78112dbe0d2d02$export$2e2bcd8739ae039 = $7c10febb2cdef0d8$export$2e2bcd8739ae039.extend({
    type: "series.scatter3D",
    dependencies: [
        "globe",
        "grid3D",
        "geo3D"
    ],
    visualStyleAccessPath: "itemStyle",
    hasSymbolVisual: true,
    getInitialData: function(option, ecModel) {
        return (0, $a0377603e49108f9$export$2e2bcd8739ae039)(this);
    },
    getFormattedLabel: function(dataIndex, status, dataType, dimIndex) {
        var text = (0, $308e5bdbc7337a3a$export$2e2bcd8739ae039).getFormattedLabel(this, dataIndex, status, dataType, dimIndex);
        if (text == null) {
            var data = this.getData();
            var lastDim = data.dimensions[data.dimensions.length - 1];
            text = data.get(lastDim, dataIndex);
        }
        return text;
    },
    formatTooltip: function(dataIndex) {
        return (0, $588422417f0cb36c$export$2e2bcd8739ae039)(this, dataIndex);
    },
    defaultOption: {
        coordinateSystem: "cartesian3D",
        zlevel: -10,
        progressive: 1e5,
        progressiveThreshold: 1e5,
        // Cartesian coordinate system
        grid3DIndex: 0,
        globeIndex: 0,
        symbol: "circle",
        symbolSize: 10,
        // Support source-over, lighter
        blendMode: "source-over",
        label: {
            show: false,
            position: "right",
            // Screen space distance
            distance: 5,
            textStyle: {
                fontSize: 14,
                color: "#000",
                backgroundColor: "rgba(255,255,255,0.7)",
                padding: 3,
                borderRadius: 3
            }
        },
        itemStyle: {
            opacity: 0.8
        },
        emphasis: {
            label: {
                show: true
            }
        },
        animationDurationUpdate: 500
    }
});









function $34e882a0e46d2924$var$makeSprite(size, canvas, draw) {
    // http://simonsarris.com/blog/346-how-you-clear-your-canvas-matters
    // http://jsperf.com/canvasclear
    // Set width and height is fast
    // And use the exist canvas if possible
    // http://jsperf.com/create-canvas-vs-set-width-height/2
    var canvas = canvas || document.createElement("canvas");
    canvas.width = size;
    canvas.height = size;
    var ctx = canvas.getContext("2d");
    draw && draw(ctx);
    return canvas;
}
function $34e882a0e46d2924$var$makePath(symbol, symbolSize, style, marginBias) {
    if (!$224386f1517b5dca$exports.isArray(symbolSize)) symbolSize = [
        symbolSize,
        symbolSize
    ];
    var margin = $34e882a0e46d2924$var$spriteUtil.getMarginByStyle(style, marginBias);
    var width = symbolSize[0] + margin.left + margin.right;
    var height = symbolSize[1] + margin.top + margin.bottom;
    var path = $9a616079ee96a3f3$exports.createSymbol(symbol, 0, 0, symbolSize[0], symbolSize[1]);
    var size = Math.max(width, height);
    path.x = margin.left;
    path.y = margin.top;
    if (width > height) path.y += (size - height) / 2;
    else path.x += (size - width) / 2;
    var rect = path.getBoundingRect();
    path.x -= rect.x;
    path.y -= rect.y;
    path.setStyle(style);
    path.update();
    path.__size = size;
    return path;
} // http://www.valvesoftware.com/publications/2007/SIGGRAPH2007_AlphaTestedMagnification.pdf
function $34e882a0e46d2924$var$generateSDF(ctx, sourceImageData, range) {
    var sourceWidth = sourceImageData.width;
    var sourceHeight = sourceImageData.height;
    var width = ctx.canvas.width;
    var height = ctx.canvas.height;
    var scaleX = sourceWidth / width;
    var scaleY = sourceHeight / height;
    function sign(r) {
        return r < 128 ? 1 : -1;
    }
    function searchMinDistance(x, y) {
        var minDistSqr = Infinity;
        x = Math.floor(x * scaleX);
        y = Math.floor(y * scaleY);
        var i = y * sourceWidth + x;
        var r = sourceImageData.data[i * 4];
        var a = sign(r); // Search for min distance
        for(var y2 = Math.max(y - range, 0); y2 < Math.min(y + range, sourceHeight); y2++)for(var x2 = Math.max(x - range, 0); x2 < Math.min(x + range, sourceWidth); x2++){
            var i = y2 * sourceWidth + x2;
            var r2 = sourceImageData.data[i * 4];
            var b = sign(r2);
            var dx = x2 - x;
            var dy = y2 - y;
            if (a !== b) {
                var distSqr = dx * dx + dy * dy;
                if (distSqr < minDistSqr) minDistSqr = distSqr;
            }
        }
        return a * Math.sqrt(minDistSqr);
    }
    var sdfImageData = ctx.createImageData(width, height);
    for(var y = 0; y < height; y++)for(var x = 0; x < width; x++){
        var dist = searchMinDistance(x, y);
        var normalized = dist / range * 0.5 + 0.5;
        var i = (y * width + x) * 4;
        sdfImageData.data[i++] = (1.0 - normalized) * 255;
        sdfImageData.data[i++] = (1.0 - normalized) * 255;
        sdfImageData.data[i++] = (1.0 - normalized) * 255;
        sdfImageData.data[i++] = 255;
    }
    return sdfImageData;
}
var $34e882a0e46d2924$var$spriteUtil = {
    getMarginByStyle: function(style) {
        var minMargin = style.minMargin || 0;
        var lineWidth = 0;
        if (style.stroke && style.stroke !== "none") lineWidth = style.lineWidth == null ? 1 : style.lineWidth;
        var shadowBlurSize = style.shadowBlur || 0;
        var shadowOffsetX = style.shadowOffsetX || 0;
        var shadowOffsetY = style.shadowOffsetY || 0;
        var margin = {};
        margin.left = Math.max(lineWidth / 2, -shadowOffsetX + shadowBlurSize, minMargin);
        margin.right = Math.max(lineWidth / 2, shadowOffsetX + shadowBlurSize, minMargin);
        margin.top = Math.max(lineWidth / 2, -shadowOffsetY + shadowBlurSize, minMargin);
        margin.bottom = Math.max(lineWidth / 2, shadowOffsetY + shadowBlurSize, minMargin);
        return margin;
    },
    // TODO Not consider shadowOffsetX, shadowOffsetY.
    /**
   * @param {string} symbol
   * @param {number | Array.<number>} symbolSize
   * @param {Object} style
   */ createSymbolSprite: function(symbol, symbolSize, style, canvas) {
        var path = $34e882a0e46d2924$var$makePath(symbol, symbolSize, style);
        var margin = $34e882a0e46d2924$var$spriteUtil.getMarginByStyle(style);
        return {
            image: $34e882a0e46d2924$var$makeSprite(path.__size, canvas, function(ctx) {
                $4f71e35e4552e3dd$export$567881adfc3eb7f3(ctx, path);
            }),
            margin: margin
        };
    },
    createSDFFromCanvas: function(canvas, size, range, outCanvas) {
        // TODO Create a low resolution SDF from high resolution image.
        return $34e882a0e46d2924$var$makeSprite(size, outCanvas, function(outCtx) {
            var ctx = canvas.getContext("2d");
            var imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            outCtx.putImageData($34e882a0e46d2924$var$generateSDF(outCtx, imgData, range), 0, 0);
        });
    },
    createSimpleSprite: function(size, canvas) {
        return $34e882a0e46d2924$var$makeSprite(size, canvas, function(ctx) {
            var halfSize = size / 2;
            ctx.beginPath();
            ctx.arc(halfSize, halfSize, 60, 0, Math.PI * 2, false);
            ctx.closePath();
            var gradient = ctx.createRadialGradient(halfSize, halfSize, 0, halfSize, halfSize, halfSize);
            gradient.addColorStop(0, "rgba(255, 255, 255, 1)");
            gradient.addColorStop(0.5, "rgba(255, 255, 255, 0.5)");
            gradient.addColorStop(1, "rgba(255, 255, 255, 0)");
            ctx.fillStyle = gradient;
            ctx.fill();
        });
    }
};
var $34e882a0e46d2924$export$2e2bcd8739ae039 = $34e882a0e46d2924$var$spriteUtil;





var $20469bc76e1c5a56$var$vec3 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).vec3;
var $20469bc76e1c5a56$export$2e2bcd8739ae039 = {
    needsSortVertices: function() {
        return this.sortVertices;
    },
    needsSortVerticesProgressively: function() {
        return this.needsSortVertices() && this.vertexCount >= 2e4;
    },
    doSortVertices: function(cameraPos, frame) {
        var indices = this.indices;
        var p = $20469bc76e1c5a56$var$vec3.create();
        if (!indices) {
            indices = this.indices = this.vertexCount > 0xffff ? new Uint32Array(this.vertexCount) : new Uint16Array(this.vertexCount);
            for(var i = 0; i < indices.length; i++)indices[i] = i;
        } // Do progressive quick sort.
        if (frame === 0) {
            var posAttr = this.attributes.position;
            var cameraPos = cameraPos.array;
            var noneCount = 0;
            if (!this._zList || this._zList.length !== this.vertexCount) this._zList = new Float32Array(this.vertexCount);
            var firstZ;
            for(var i = 0; i < this.vertexCount; i++){
                posAttr.get(i, p); // Camera position is in object space
                var z = $20469bc76e1c5a56$var$vec3.sqrDist(p, cameraPos);
                if (isNaN(z)) {
                    // Put far away, NaN value may cause sort slow
                    z = 1e7;
                    noneCount++;
                }
                if (i === 0) {
                    firstZ = z;
                    z = 0;
                } else // Only store the difference to avoid the precision issue.
                z = z - firstZ;
                this._zList[i] = z;
            }
            this._noneCount = noneCount;
        }
        if (this.vertexCount < 2e4) // Use simple native sort for simple geometries.
        {
            if (frame === 0) this._simpleSort(this._noneCount / this.vertexCount > 0.05);
        } else for(var i = 0; i < 3; i++)this._progressiveQuickSort(frame * 3 + i);
        this.dirtyIndices();
    },
    _simpleSort: function(useNativeQuickSort) {
        var zList = this._zList;
        var indices = this.indices;
        function compare(a, b) {
            // Sort from far to near. which is descending order
            return zList[b] - zList[a];
        } // When too much value are equal, using native quick sort with three partition..
        // or the simple quick sort will be nearly O(n*n)
        // http://stackoverflow.com/questions/5126586/quicksort-complexity-when-all-the-elements-are-same
        // Otherwise simple quicksort is more effecient than v8 native quick sort when data all different.
        if (useNativeQuickSort) Array.prototype.sort.call(indices, compare);
        else (0, $6f3b89c4df948b3a$export$2e2bcd8739ae039).sort(indices, compare, 0, indices.length - 1);
    },
    _progressiveQuickSort: function(frame) {
        var zList = this._zList;
        var indices = this.indices;
        this._quickSort = this._quickSort || new (0, $6f3b89c4df948b3a$export$2e2bcd8739ae039)();
        this._quickSort.step(indices, function(a, b) {
            return zList[b] - zList[a];
        }, frame);
    }
};




var $c9af0a42b5b272ee$export$2e2bcd8739ae039 = "@export ecgl.sdfSprite.vertex\n\nuniform mat4 worldViewProjection : WORLDVIEWPROJECTION;\nuniform float elapsedTime : 0;\n\nattribute vec3 position : POSITION;\n\n#ifdef VERTEX_SIZE\nattribute float size;\n#else\nuniform float u_Size;\n#endif\n\n#ifdef VERTEX_COLOR\nattribute vec4 a_FillColor: COLOR;\nvarying vec4 v_Color;\n#endif\n\n#ifdef VERTEX_ANIMATION\nattribute vec3 prevPosition;\nattribute float prevSize;\nuniform float percent : 1.0;\n#endif\n\n\n#ifdef POSITIONTEXTURE_ENABLED\nuniform sampler2D positionTexture;\n#endif\n\nvarying float v_Size;\n\nvoid main()\n{\n\n#ifdef POSITIONTEXTURE_ENABLED\n gl_Position = worldViewProjection * vec4(texture2D(positionTexture, position.xy).xy, -10.0, 1.0);\n#else\n\n #ifdef VERTEX_ANIMATION\n vec3 pos = mix(prevPosition, position, percent);\n #else\n vec3 pos = position;\n #endif\n gl_Position = worldViewProjection * vec4(pos, 1.0);\n#endif\n\n#ifdef VERTEX_SIZE\n#ifdef VERTEX_ANIMATION\n v_Size = mix(prevSize, size, percent);\n#else\n v_Size = size;\n#endif\n#else\n v_Size = u_Size;\n#endif\n\n#ifdef VERTEX_COLOR\n v_Color = a_FillColor;\n #endif\n\n gl_PointSize = v_Size;\n}\n\n@end\n\n@export ecgl.sdfSprite.fragment\n\nuniform vec4 color: [1, 1, 1, 1];\nuniform vec4 strokeColor: [1, 1, 1, 1];\nuniform float smoothing: 0.07;\n\nuniform float lineWidth: 0.0;\n\n#ifdef VERTEX_COLOR\nvarying vec4 v_Color;\n#endif\n\nvarying float v_Size;\n\nuniform sampler2D sprite;\n\n@import clay.util.srgb\n\nvoid main()\n{\n gl_FragColor = color;\n\n vec4 _strokeColor = strokeColor;\n\n#ifdef VERTEX_COLOR\n gl_FragColor *= v_Color;\n #endif\n\n#ifdef SPRITE_ENABLED\n float d = texture2D(sprite, gl_PointCoord).r;\n gl_FragColor.a *= smoothstep(0.5 - smoothing, 0.5 + smoothing, d);\n\n if (lineWidth > 0.0) {\n float sLineWidth = lineWidth / 2.0;\n\n float outlineMaxValue0 = 0.5 + sLineWidth;\n float outlineMaxValue1 = 0.5 + sLineWidth + smoothing;\n float outlineMinValue0 = 0.5 - sLineWidth - smoothing;\n float outlineMinValue1 = 0.5 - sLineWidth;\n\n if (d <= outlineMaxValue1 && d >= outlineMinValue0) {\n float a = _strokeColor.a;\n if (d <= outlineMinValue1) {\n a = a * smoothstep(outlineMinValue0, outlineMinValue1, d);\n }\n else {\n a = a * smoothstep(outlineMaxValue1, outlineMaxValue0, d);\n }\n gl_FragColor.rgb = mix(gl_FragColor.rgb * gl_FragColor.a, _strokeColor.rgb, a);\n gl_FragColor.a = gl_FragColor.a * (1.0 - a) + a;\n }\n }\n#endif\n\n#ifdef SRGB_DECODE\n gl_FragColor = sRGBToLinear(gl_FragColor);\n#endif\n}\n@end";


var $7970dfbe0b6790e0$var$vec4 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).vec4;
(0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.import((0, $c9af0a42b5b272ee$export$2e2bcd8739ae039));
var $7970dfbe0b6790e0$var$PointsMesh = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh.extend(function() {
    var geometry = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Geometry({
        dynamic: true,
        attributes: {
            color: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Geometry.Attribute("color", "float", 4, "COLOR"),
            position: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Geometry.Attribute("position", "float", 3, "POSITION"),
            size: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Geometry.Attribute("size", "float", 1),
            prevPosition: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Geometry.Attribute("prevPosition", "float", 3),
            prevSize: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Geometry.Attribute("prevSize", "float", 1)
        }
    });
    Object.assign(geometry, (0, $20469bc76e1c5a56$export$2e2bcd8739ae039));
    var material = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
        shader: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createShader("ecgl.sdfSprite"),
        transparent: true,
        depthMask: false
    });
    material.enableTexture("sprite");
    material.define("both", "VERTEX_COLOR");
    material.define("both", "VERTEX_SIZE");
    var sdfTexture = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Texture2D({
        image: document.createElement("canvas"),
        flipY: false
    });
    material.set("sprite", sdfTexture); // Custom pick methods.
    geometry.pick = this._pick.bind(this);
    return {
        geometry: geometry,
        material: material,
        mode: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh.POINTS,
        sizeScale: 1
    };
}, {
    _pick: function(x, y, renderer, camera, renderable, out) {
        var positionNDC = this._positionNDC;
        if (!positionNDC) return;
        var viewport = renderer.viewport;
        var ndcScaleX = 2 / viewport.width;
        var ndcScaleY = 2 / viewport.height; // From near to far. indices have been sorted.
        for(var i = this.geometry.vertexCount - 1; i >= 0; i--){
            var idx;
            if (!this.geometry.indices) idx = i;
            else idx = this.geometry.indices[i];
            var cx = positionNDC[idx * 2];
            var cy = positionNDC[idx * 2 + 1];
            var size = this.geometry.attributes.size.get(idx) / this.sizeScale;
            var halfSize = size / 2;
            if (x > cx - halfSize * ndcScaleX && x < cx + halfSize * ndcScaleX && y > cy - halfSize * ndcScaleY && y < cy + halfSize * ndcScaleY) {
                var point = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Vector3();
                var pointWorld = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Vector3();
                this.geometry.attributes.position.get(idx, point.array);
                (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Vector3.transformMat4(pointWorld, point, this.worldTransform);
                out.push({
                    vertexIndex: idx,
                    point: point,
                    pointWorld: pointWorld,
                    target: this,
                    distance: pointWorld.distance(camera.getWorldPosition())
                });
            }
        }
    },
    updateNDCPosition: function(worldViewProjection, is2D, api) {
        var positionNDC = this._positionNDC;
        var geometry = this.geometry;
        if (!positionNDC || positionNDC.length / 2 !== geometry.vertexCount) positionNDC = this._positionNDC = new Float32Array(geometry.vertexCount * 2);
        var pos = $7970dfbe0b6790e0$var$vec4.create();
        for(var i = 0; i < geometry.vertexCount; i++){
            geometry.attributes.position.get(i, pos);
            pos[3] = 1;
            $7970dfbe0b6790e0$var$vec4.transformMat4(pos, pos, worldViewProjection.array);
            $7970dfbe0b6790e0$var$vec4.scale(pos, pos, 1 / pos[3]);
            positionNDC[i * 2] = pos[0];
            positionNDC[i * 2 + 1] = pos[1];
        }
    }
});
var $7970dfbe0b6790e0$export$2e2bcd8739ae039 = $7970dfbe0b6790e0$var$PointsMesh;






var $ba74e03882df50b1$var$SDF_RANGE = 20;
var $ba74e03882df50b1$var$Z_2D = -10;
function $ba74e03882df50b1$var$isSymbolSizeSame(a, b) {
    return a && b && a[0] === b[0] && a[1] === b[1];
} // TODO gl_PointSize has max value.
function $ba74e03882df50b1$var$PointsBuilder(is2D, api) {
    this.rootNode = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
    /**
   * @type {boolean}
   */ this.is2D = is2D;
    this._labelsBuilder = new (0, $87f8de1342284ee1$export$2e2bcd8739ae039)(256, 256, api); // Give a large render order.
    this._labelsBuilder.getMesh().renderOrder = 100;
    this.rootNode.add(this._labelsBuilder.getMesh());
    this._api = api;
    this._spriteImageCanvas = document.createElement("canvas");
    this._startDataIndex = 0;
    this._endDataIndex = 0;
    this._sizeScale = 1;
}
$ba74e03882df50b1$var$PointsBuilder.prototype = {
    constructor: $ba74e03882df50b1$var$PointsBuilder,
    /**
   * If highlight on over
   */ highlightOnMouseover: true,
    update: function(seriesModel, ecModel, api, start, end) {
        // Swap barMesh
        var tmp = this._prevMesh;
        this._prevMesh = this._mesh;
        this._mesh = tmp;
        var data = seriesModel.getData();
        if (start == null) start = 0;
        if (end == null) end = data.count();
        this._startDataIndex = start;
        this._endDataIndex = end - 1;
        if (!this._mesh) {
            var material = this._prevMesh && this._prevMesh.material;
            this._mesh = new (0, $7970dfbe0b6790e0$export$2e2bcd8739ae039)({
                // Render after axes
                renderOrder: 10,
                // FIXME
                frustumCulling: false
            });
            if (material) this._mesh.material = material;
        }
        var material = this._mesh.material;
        var geometry = this._mesh.geometry;
        var attributes = geometry.attributes;
        this.rootNode.remove(this._prevMesh);
        this.rootNode.add(this._mesh);
        this._setPositionTextureToMesh(this._mesh, this._positionTexture);
        var symbolInfo = this._getSymbolInfo(seriesModel, start, end);
        var dpr = api.getDevicePixelRatio(); // TODO image symbol
        var itemStyle = seriesModel.getModel("itemStyle").getItemStyle();
        var largeMode = seriesModel.get("large");
        var pointSizeScale = 1;
        if (symbolInfo.maxSize > 2) {
            pointSizeScale = this._updateSymbolSprite(seriesModel, itemStyle, symbolInfo, dpr);
            material.enableTexture("sprite");
        } else material.disableTexture("sprite");
        attributes.position.init(end - start);
        var rgbaArr = [];
        if (largeMode) {
            material.undefine("VERTEX_SIZE");
            material.undefine("VERTEX_COLOR");
            var color = (0, $4c1f03531dad0b09$export$4707c867a92dbeb5)(data);
            var opacity = (0, $4c1f03531dad0b09$export$b00fee0c137bb546)(data);
            (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(color, rgbaArr);
            rgbaArr[3] *= opacity;
            material.set({
                color: rgbaArr,
                "u_Size": symbolInfo.maxSize * this._sizeScale
            });
        } else {
            material.set({
                color: [
                    1,
                    1,
                    1,
                    1
                ]
            });
            material.define("VERTEX_SIZE");
            material.define("VERTEX_COLOR");
            attributes.size.init(end - start);
            attributes.color.init(end - start);
            this._originalOpacity = new Float32Array(end - start);
        }
        var points = data.getLayout("points");
        var positionArr = attributes.position.value;
        var hasTransparentPoint = false;
        for(var i = 0; i < end - start; i++){
            var i3 = i * 3;
            var i2 = i * 2;
            if (this.is2D) {
                positionArr[i3] = points[i2];
                positionArr[i3 + 1] = points[i2 + 1];
                positionArr[i3 + 2] = $ba74e03882df50b1$var$Z_2D;
            } else {
                positionArr[i3] = points[i3];
                positionArr[i3 + 1] = points[i3 + 1];
                positionArr[i3 + 2] = points[i3 + 2];
            }
            if (!largeMode) {
                var color = (0, $4c1f03531dad0b09$export$bc92a5a7848039f)(data, i);
                var opacity = (0, $4c1f03531dad0b09$export$f154d4dab8f4e8c0)(data, i);
                (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(color, rgbaArr);
                rgbaArr[3] *= opacity;
                attributes.color.set(i, rgbaArr);
                if (rgbaArr[3] < 0.99) hasTransparentPoint = true;
                var symbolSize = data.getItemVisual(i, "symbolSize");
                symbolSize = symbolSize instanceof Array ? Math.max(symbolSize[0], symbolSize[1]) : symbolSize; // NaN pointSize may have strange result.
                if (isNaN(symbolSize)) symbolSize = 0;
                 // Scale point size because canvas has margin.
                attributes.size.value[i] = symbolSize * pointSizeScale * this._sizeScale; // Save the original opacity for recover from fadeIn.
                this._originalOpacity[i] = rgbaArr[3];
            }
        }
        this._mesh.sizeScale = pointSizeScale;
        geometry.updateBoundingBox();
        geometry.dirty(); // Update material.
        this._updateMaterial(seriesModel, itemStyle);
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.viewGL) {
            var methodName = coordSys.viewGL.isLinearSpace() ? "define" : "undefine";
            material[methodName]("fragment", "SRGB_DECODE");
        }
        if (!largeMode) this._updateLabelBuilder(seriesModel, start, end);
        this._updateHandler(seriesModel, ecModel, api);
        this._updateAnimation(seriesModel);
        this._api = api;
    },
    getPointsMesh: function() {
        return this._mesh;
    },
    updateLabels: function(highlightDataIndices) {
        this._labelsBuilder.updateLabels(highlightDataIndices);
    },
    hideLabels: function() {
        this.rootNode.remove(this._labelsBuilder.getMesh());
    },
    showLabels: function() {
        this.rootNode.add(this._labelsBuilder.getMesh());
    },
    dispose: function() {
        this._labelsBuilder.dispose();
    },
    _updateSymbolSprite: function(seriesModel, itemStyle, symbolInfo, dpr) {
        symbolInfo.maxSize = Math.min(symbolInfo.maxSize * 2, 200);
        var symbolSize = [];
        if (symbolInfo.aspect > 1) {
            symbolSize[0] = symbolInfo.maxSize;
            symbolSize[1] = symbolInfo.maxSize / symbolInfo.aspect;
        } else {
            symbolSize[1] = symbolInfo.maxSize;
            symbolSize[0] = symbolInfo.maxSize * symbolInfo.aspect;
        } // In case invalid data.
        symbolSize[0] = symbolSize[0] || 1;
        symbolSize[1] = symbolSize[1] || 1;
        if (this._symbolType !== symbolInfo.type || !$ba74e03882df50b1$var$isSymbolSizeSame(this._symbolSize, symbolSize) || this._lineWidth !== itemStyle.lineWidth) {
            (0, $34e882a0e46d2924$export$2e2bcd8739ae039).createSymbolSprite(symbolInfo.type, symbolSize, {
                fill: "#fff",
                lineWidth: itemStyle.lineWidth,
                stroke: "transparent",
                shadowColor: "transparent",
                minMargin: Math.min(symbolSize[0] / 2, 10)
            }, this._spriteImageCanvas);
            (0, $34e882a0e46d2924$export$2e2bcd8739ae039).createSDFFromCanvas(this._spriteImageCanvas, Math.min(this._spriteImageCanvas.width, 32), $ba74e03882df50b1$var$SDF_RANGE, this._mesh.material.get("sprite").image);
            this._symbolType = symbolInfo.type;
            this._symbolSize = symbolSize;
            this._lineWidth = itemStyle.lineWidth;
        }
        return this._spriteImageCanvas.width / symbolInfo.maxSize * dpr;
    },
    _updateMaterial: function(seriesModel, itemStyle) {
        var blendFunc = seriesModel.get("blendMode") === "lighter" ? (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).additiveBlend : null;
        var material = this._mesh.material;
        material.blend = blendFunc;
        material.set("lineWidth", itemStyle.lineWidth / $ba74e03882df50b1$var$SDF_RANGE);
        var strokeColor = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(itemStyle.stroke);
        material.set("strokeColor", strokeColor); // Because of symbol texture, we always needs it be transparent.
        material.transparent = true;
        material.depthMask = false;
        material.depthTest = !this.is2D;
        material.sortVertices = !this.is2D;
    },
    _updateLabelBuilder: function(seriesModel, start, end) {
        var data = seriesModel.getData();
        var geometry = this._mesh.geometry;
        var positionArr = geometry.attributes.position.value;
        var start = this._startDataIndex;
        var pointSizeScale = this._mesh.sizeScale;
        this._labelsBuilder.updateData(data, start, end);
        this._labelsBuilder.getLabelPosition = function(dataIndex, positionDesc, distance) {
            var idx3 = (dataIndex - start) * 3;
            return [
                positionArr[idx3],
                positionArr[idx3 + 1],
                positionArr[idx3 + 2]
            ];
        };
        this._labelsBuilder.getLabelDistance = function(dataIndex, positionDesc, distance) {
            var size = geometry.attributes.size.get(dataIndex - start) / pointSizeScale;
            return size / 2 + distance;
        };
        this._labelsBuilder.updateLabels();
    },
    _updateAnimation: function(seriesModel) {
        (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).updateVertexAnimation([
            [
                "prevPosition",
                "position"
            ],
            [
                "prevSize",
                "size"
            ]
        ], this._prevMesh, this._mesh, seriesModel);
    },
    _updateHandler: function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var pointsMesh = this._mesh;
        var self = this;
        var lastDataIndex = -1;
        var isCartesian3D = seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === "cartesian3D";
        var grid3DModel;
        if (isCartesian3D) grid3DModel = seriesModel.coordinateSystem.model;
        pointsMesh.seriesIndex = seriesModel.seriesIndex;
        pointsMesh.off("mousemove");
        pointsMesh.off("mouseout");
        pointsMesh.on("mousemove", function(e) {
            var dataIndex = e.vertexIndex + self._startDataIndex;
            if (dataIndex !== lastDataIndex) {
                if (this.highlightOnMouseover) {
                    this.downplay(data, lastDataIndex);
                    this.highlight(data, dataIndex);
                    this._labelsBuilder.updateLabels([
                        dataIndex
                    ]);
                }
                if (isCartesian3D) api.dispatchAction({
                    type: "grid3DShowAxisPointer",
                    value: [
                        data.get(seriesModel.coordDimToDataDim("x")[0], dataIndex),
                        data.get(seriesModel.coordDimToDataDim("y")[0], dataIndex),
                        data.get(seriesModel.coordDimToDataDim("z")[0], dataIndex)
                    ],
                    grid3DIndex: grid3DModel.componentIndex
                });
            }
            pointsMesh.dataIndex = dataIndex;
            lastDataIndex = dataIndex;
        }, this);
        pointsMesh.on("mouseout", function(e) {
            var dataIndex = e.vertexIndex + self._startDataIndex;
            if (this.highlightOnMouseover) {
                this.downplay(data, dataIndex);
                this._labelsBuilder.updateLabels();
            }
            lastDataIndex = -1;
            pointsMesh.dataIndex = -1;
            if (isCartesian3D) api.dispatchAction({
                type: "grid3DHideAxisPointer",
                grid3DIndex: grid3DModel.componentIndex
            });
        }, this);
    },
    updateLayout: function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        if (!this._mesh) return;
        var positionArr = this._mesh.geometry.attributes.position.value;
        var points = data.getLayout("points");
        if (this.is2D) for(var i = 0; i < points.length / 2; i++){
            var i3 = i * 3;
            var i2 = i * 2;
            positionArr[i3] = points[i2];
            positionArr[i3 + 1] = points[i2 + 1];
            positionArr[i3 + 2] = $ba74e03882df50b1$var$Z_2D;
        }
        else for(var i = 0; i < points.length; i++)positionArr[i] = points[i];
        this._mesh.geometry.dirty();
        api.getZr().refresh();
    },
    updateView: function(camera) {
        if (!this._mesh) return;
        var worldViewProjection = new (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039)();
        (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).mul(worldViewProjection, camera.viewMatrix, this._mesh.worldTransform);
        (0, $1d03d709cdb0fa6c$export$2e2bcd8739ae039).mul(worldViewProjection, camera.projectionMatrix, worldViewProjection);
        this._mesh.updateNDCPosition(worldViewProjection, this.is2D, this._api);
    },
    highlight: function(data, dataIndex) {
        if (dataIndex > this._endDataIndex || dataIndex < this._startDataIndex) return;
        var itemModel = data.getItemModel(dataIndex);
        var emphasisItemStyleModel = itemModel.getModel("emphasis.itemStyle");
        var emphasisColor = emphasisItemStyleModel.get("color");
        var emphasisOpacity = emphasisItemStyleModel.get("opacity");
        if (emphasisColor == null) {
            var color = (0, $4c1f03531dad0b09$export$bc92a5a7848039f)(data, dataIndex);
            emphasisColor = $2c037f5bda6341ca$exports.lift(color, -0.4);
        }
        if (emphasisOpacity == null) emphasisOpacity = (0, $4c1f03531dad0b09$export$f154d4dab8f4e8c0)(data, dataIndex);
        var colorArr = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(emphasisColor);
        colorArr[3] *= emphasisOpacity;
        this._mesh.geometry.attributes.color.set(dataIndex - this._startDataIndex, colorArr);
        this._mesh.geometry.dirtyAttribute("color");
        this._api.getZr().refresh();
    },
    downplay: function(data, dataIndex) {
        if (dataIndex > this._endDataIndex || dataIndex < this._startDataIndex) return;
        var color = (0, $4c1f03531dad0b09$export$bc92a5a7848039f)(data, dataIndex);
        var opacity = (0, $4c1f03531dad0b09$export$f154d4dab8f4e8c0)(data, dataIndex);
        var colorArr = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(color);
        colorArr[3] *= opacity;
        this._mesh.geometry.attributes.color.set(dataIndex - this._startDataIndex, colorArr);
        this._mesh.geometry.dirtyAttribute("color");
        this._api.getZr().refresh();
    },
    fadeOutAll: function(fadeOutPercent) {
        if (this._originalOpacity) {
            var geo = this._mesh.geometry;
            for(var i = 0; i < geo.vertexCount; i++){
                var fadeOutOpacity = this._originalOpacity[i] * fadeOutPercent;
                geo.attributes.color.value[i * 4 + 3] = fadeOutOpacity;
            }
            geo.dirtyAttribute("color");
            this._api.getZr().refresh();
        }
    },
    fadeInAll: function() {
        this.fadeOutAll(1);
    },
    setPositionTexture: function(texture) {
        if (this._mesh) this._setPositionTextureToMesh(this._mesh, texture);
        this._positionTexture = texture;
    },
    removePositionTexture: function() {
        this._positionTexture = null;
        if (this._mesh) this._setPositionTextureToMesh(this._mesh, null);
    },
    setSizeScale: function(sizeScale) {
        if (sizeScale !== this._sizeScale) {
            if (this._mesh) {
                var originalSize = this._mesh.material.get("u_Size");
                this._mesh.material.set("u_Size", originalSize / this._sizeScale * sizeScale);
                var attributes = this._mesh.geometry.attributes;
                if (attributes.size.value) for(var i = 0; i < attributes.size.value.length; i++)attributes.size.value[i] = attributes.size.value[i] / this._sizeScale * sizeScale;
            }
            this._sizeScale = sizeScale;
        }
    },
    _setPositionTextureToMesh: function(mesh, texture) {
        if (texture) mesh.material.set("positionTexture", texture);
        mesh.material[texture ? "enableTexture" : "disableTexture"]("positionTexture");
    },
    _getSymbolInfo: function(seriesModel, start, end) {
        if (seriesModel.get("large")) {
            var symbolSize = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(seriesModel.get("symbolSize"), 1);
            var maxSymbolSize;
            var symbolAspect;
            if (symbolSize instanceof Array) {
                maxSymbolSize = Math.max(symbolSize[0], symbolSize[1]);
                symbolAspect = symbolSize[0] / symbolSize[1];
            } else {
                maxSymbolSize = symbolSize;
                symbolAspect = 1;
            }
            return {
                maxSize: symbolSize,
                type: seriesModel.get("symbol"),
                aspect: symbolAspect
            };
        }
        var data = seriesModel.getData();
        var symbolAspect;
        var differentSymbolAspect = false;
        var symbolType = data.getItemVisual(0, "symbol") || "circle";
        var differentSymbolType = false;
        var maxSymbolSize = 0;
        for(var idx = start; idx < end; idx++){
            var symbolSize = data.getItemVisual(idx, "symbolSize");
            var currentSymbolType = data.getItemVisual(idx, "symbol");
            var currentSymbolAspect;
            if (!(symbolSize instanceof Array)) {
                // Ignore NaN value.
                if (isNaN(symbolSize)) continue;
                currentSymbolAspect = 1;
                maxSymbolSize = Math.max(symbolSize, maxSymbolSize);
            } else {
                currentSymbolAspect = symbolSize[0] / symbolSize[1];
                maxSymbolSize = Math.max(Math.max(symbolSize[0], symbolSize[1]), maxSymbolSize);
            }
            symbolType = currentSymbolType;
            symbolAspect = currentSymbolAspect;
        }
        return {
            maxSize: maxSymbolSize,
            type: symbolType,
            aspect: symbolAspect
        };
    }
};
var $ba74e03882df50b1$export$2e2bcd8739ae039 = $ba74e03882df50b1$var$PointsBuilder;


var $fa25278ba30f3a43$export$2e2bcd8739ae039 = $0dc5061053e23cd3$export$2e2bcd8739ae039.extend({
    type: "scatter3D",
    hasSymbolVisual: true,
    __ecgl__: true,
    init: function(ecModel, api) {
        this.groupGL = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
        this._pointsBuilderList = [];
        this._currentStep = 0;
    },
    render: function(seriesModel, ecModel, api) {
        this.groupGL.removeAll();
        if (!seriesModel.getData().count()) return;
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.viewGL) {
            coordSys.viewGL.add(this.groupGL);
            this._camera = coordSys.viewGL.camera;
            var pointsBuilder = this._pointsBuilderList[0];
            if (!pointsBuilder) pointsBuilder = this._pointsBuilderList[0] = new (0, $ba74e03882df50b1$export$2e2bcd8739ae039)(false, api);
            this._pointsBuilderList.length = 1;
            this.groupGL.add(pointsBuilder.rootNode);
            pointsBuilder.update(seriesModel, ecModel, api);
            pointsBuilder.updateView(coordSys.viewGL.camera);
        }
    },
    incrementalPrepareRender: function(seriesModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.viewGL) {
            coordSys.viewGL.add(this.groupGL);
            this._camera = coordSys.viewGL.camera;
        }
        this.groupGL.removeAll();
        this._currentStep = 0;
    },
    incrementalRender: function(params, seriesModel, ecModel, api) {
        // TODO Sort transparency.
        if (params.end <= params.start) return;
        var pointsBuilder = this._pointsBuilderList[this._currentStep];
        if (!pointsBuilder) {
            pointsBuilder = new (0, $ba74e03882df50b1$export$2e2bcd8739ae039)(false, api);
            this._pointsBuilderList[this._currentStep] = pointsBuilder;
        }
        this.groupGL.add(pointsBuilder.rootNode);
        pointsBuilder.update(seriesModel, ecModel, api, params.start, params.end);
        pointsBuilder.updateView(seriesModel.coordinateSystem.viewGL.camera);
        this._currentStep++;
    },
    updateCamera: function() {
        this._pointsBuilderList.forEach(function(pointsBuilder) {
            pointsBuilder.updateView(this._camera);
        }, this);
    },
    highlight: function(seriesModel, ecModel, api, payload) {
        this._toggleStatus("highlight", seriesModel, ecModel, api, payload);
    },
    downplay: function(seriesModel, ecModel, api, payload) {
        this._toggleStatus("downplay", seriesModel, ecModel, api, payload);
    },
    _toggleStatus: function(status, seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = (0, $5821dc5111828448$export$2e2bcd8739ae039).queryDataIndex(data, payload);
        var isHighlight = status === "highlight";
        if (dataIndex != null) $224386f1517b5dca$exports.each((0, $308e5bdbc7337a3a$export$2e2bcd8739ae039).normalizeToArray(dataIndex), function(dataIdx) {
            for(var i = 0; i < this._pointsBuilderList.length; i++){
                var pointsBuilder = this._pointsBuilderList[i];
                isHighlight ? pointsBuilder.highlight(data, dataIdx) : pointsBuilder.downplay(data, dataIdx);
            }
        }, this);
        else // PENDING, OPTIMIZE
        data.each(function(dataIdx) {
            for(var i = 0; i < this._pointsBuilderList.length; i++){
                var pointsBuilder = this._pointsBuilderList[i];
                isHighlight ? pointsBuilder.highlight(data, dataIdx) : pointsBuilder.downplay(data, dataIdx);
            }
        });
    },
    dispose: function() {
        this._pointsBuilderList.forEach(function(pointsBuilder) {
            pointsBuilder.dispose();
        });
        this.groupGL.removeAll();
    },
    remove: function() {
        this.groupGL.removeAll();
    }
});


function $30884a801ca59565$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $fa25278ba30f3a43$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $ae78112dbe0d2d02$export$2e2bcd8739ae039));
    registers.registerLayout({
        seriesType: "scatter3D",
        reset: function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            if (coordSys) {
                var coordDims = coordSys.dimensions;
                if (coordDims.length < 3) return;
                var dims = coordDims.map(function(coordDim) {
                    return seriesModel.coordDimToDataDim(coordDim)[0];
                });
                var item = [];
                var out = [];
                return {
                    progress: function(params, data) {
                        var points = new Float32Array((params.end - params.start) * 3);
                        for(var idx = params.start; idx < params.end; idx++){
                            var idx3 = (idx - params.start) * 3;
                            item[0] = data.get(dims[0], idx);
                            item[1] = data.get(dims[1], idx);
                            item[2] = data.get(dims[2], idx);
                            coordSys.dataToPoint(item, out);
                            points[idx3] = out[0];
                            points[idx3 + 1] = out[1];
                            points[idx3 + 2] = out[2];
                        }
                        data.setLayout("points", points);
                    }
                };
            }
        }
    });
}


(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $30884a801ca59565$export$4b3e715f166fdd78));



// TODO ECharts GL must be imported whatever component,charts is imported.



var $01833bb64034df9e$var$vec3 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).vec3;
var $01833bb64034df9e$var$vec2 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).vec2;
var $01833bb64034df9e$var$normalize = $01833bb64034df9e$var$vec3.normalize;
var $01833bb64034df9e$var$cross = $01833bb64034df9e$var$vec3.cross;
var $01833bb64034df9e$var$sub = $01833bb64034df9e$var$vec3.sub;
var $01833bb64034df9e$var$add = $01833bb64034df9e$var$vec3.add;
var $01833bb64034df9e$var$create = $01833bb64034df9e$var$vec3.create;
var $01833bb64034df9e$var$normal = $01833bb64034df9e$var$create();
var $01833bb64034df9e$var$tangent = $01833bb64034df9e$var$create();
var $01833bb64034df9e$var$bitangent = $01833bb64034df9e$var$create();
var $01833bb64034df9e$var$halfVector = $01833bb64034df9e$var$create();
var $01833bb64034df9e$var$coord0 = [];
var $01833bb64034df9e$var$coord1 = [];
function $01833bb64034df9e$var$getCubicPointsOnGlobe(coords, coordSys) {
    $01833bb64034df9e$var$vec2.copy($01833bb64034df9e$var$coord0, coords[0]);
    $01833bb64034df9e$var$vec2.copy($01833bb64034df9e$var$coord1, coords[1]);
    var pts = [];
    var p0 = pts[0] = $01833bb64034df9e$var$create();
    var p1 = pts[1] = $01833bb64034df9e$var$create();
    var p2 = pts[2] = $01833bb64034df9e$var$create();
    var p3 = pts[3] = $01833bb64034df9e$var$create();
    coordSys.dataToPoint($01833bb64034df9e$var$coord0, p0);
    coordSys.dataToPoint($01833bb64034df9e$var$coord1, p3); // Get p1
    $01833bb64034df9e$var$normalize($01833bb64034df9e$var$normal, p0); // TODO p0-p3 is parallel with normal
    $01833bb64034df9e$var$sub($01833bb64034df9e$var$tangent, p3, p0);
    $01833bb64034df9e$var$normalize($01833bb64034df9e$var$tangent, $01833bb64034df9e$var$tangent);
    $01833bb64034df9e$var$cross($01833bb64034df9e$var$bitangent, $01833bb64034df9e$var$tangent, $01833bb64034df9e$var$normal);
    $01833bb64034df9e$var$normalize($01833bb64034df9e$var$bitangent, $01833bb64034df9e$var$bitangent);
    $01833bb64034df9e$var$cross($01833bb64034df9e$var$tangent, $01833bb64034df9e$var$normal, $01833bb64034df9e$var$bitangent); // p1 is half vector of p0 and tangent on p0
    $01833bb64034df9e$var$add(p1, $01833bb64034df9e$var$normal, $01833bb64034df9e$var$tangent);
    $01833bb64034df9e$var$normalize(p1, p1); // Get p2
    $01833bb64034df9e$var$normalize($01833bb64034df9e$var$normal, p3);
    $01833bb64034df9e$var$sub($01833bb64034df9e$var$tangent, p0, p3);
    $01833bb64034df9e$var$normalize($01833bb64034df9e$var$tangent, $01833bb64034df9e$var$tangent);
    $01833bb64034df9e$var$cross($01833bb64034df9e$var$bitangent, $01833bb64034df9e$var$tangent, $01833bb64034df9e$var$normal);
    $01833bb64034df9e$var$normalize($01833bb64034df9e$var$bitangent, $01833bb64034df9e$var$bitangent);
    $01833bb64034df9e$var$cross($01833bb64034df9e$var$tangent, $01833bb64034df9e$var$normal, $01833bb64034df9e$var$bitangent); // p2 is half vector of p3 and tangent on p3
    $01833bb64034df9e$var$add(p2, $01833bb64034df9e$var$normal, $01833bb64034df9e$var$tangent);
    $01833bb64034df9e$var$normalize(p2, p2); // Project distance of p0 on halfVector
    $01833bb64034df9e$var$add($01833bb64034df9e$var$halfVector, p0, p3);
    $01833bb64034df9e$var$normalize($01833bb64034df9e$var$halfVector, $01833bb64034df9e$var$halfVector);
    var projDist = $01833bb64034df9e$var$vec3.dot(p0, $01833bb64034df9e$var$halfVector); // Angle of halfVector and p1
    var cosTheta = $01833bb64034df9e$var$vec3.dot($01833bb64034df9e$var$halfVector, p1);
    var len = (Math.max($01833bb64034df9e$var$vec3.len(p0), $01833bb64034df9e$var$vec3.len(p3)) - projDist) / cosTheta * 2;
    $01833bb64034df9e$var$vec3.scaleAndAdd(p1, p0, p1, len);
    $01833bb64034df9e$var$vec3.scaleAndAdd(p2, p3, p2, len);
    return pts;
}
function $01833bb64034df9e$var$getCubicPointsOnPlane(coords, coordSys, up) {
    var pts = [];
    var p0 = pts[0] = $01833bb64034df9e$var$vec3.create();
    var p1 = pts[1] = $01833bb64034df9e$var$vec3.create();
    var p2 = pts[2] = $01833bb64034df9e$var$vec3.create();
    var p3 = pts[3] = $01833bb64034df9e$var$vec3.create();
    coordSys.dataToPoint(coords[0], p0);
    coordSys.dataToPoint(coords[1], p3);
    var len = $01833bb64034df9e$var$vec3.dist(p0, p3);
    $01833bb64034df9e$var$vec3.lerp(p1, p0, p3, 0.3);
    $01833bb64034df9e$var$vec3.lerp(p2, p0, p3, 0.3);
    $01833bb64034df9e$var$vec3.scaleAndAdd(p1, p1, up, Math.min(len * 0.1, 10));
    $01833bb64034df9e$var$vec3.scaleAndAdd(p2, p2, up, Math.min(len * 0.1, 10));
    return pts;
}
function $01833bb64034df9e$var$getPolylinePoints(coords, coordSys) {
    var pts = new Float32Array(coords.length * 3);
    var off = 0;
    var pt = [];
    for(var i = 0; i < coords.length; i++){
        coordSys.dataToPoint(coords[i], pt);
        pts[off++] = pt[0];
        pts[off++] = pt[1];
        pts[off++] = pt[2];
    }
    return pts;
}
function $01833bb64034df9e$var$prepareCoords(data) {
    var coordsList = [];
    data.each(function(idx) {
        var itemModel = data.getItemModel(idx);
        var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.getShallow("coords", true);
        coordsList.push(coords);
    });
    return {
        coordsList: coordsList
    };
}
function $01833bb64034df9e$var$layoutGlobe(seriesModel, coordSys) {
    var data = seriesModel.getData();
    var isPolyline = seriesModel.get("polyline");
    data.setLayout("lineType", isPolyline ? "polyline" : "cubicBezier");
    var res = $01833bb64034df9e$var$prepareCoords(data);
    data.each(function(idx) {
        var coords = res.coordsList[idx];
        var getPointsMethod = isPolyline ? $01833bb64034df9e$var$getPolylinePoints : $01833bb64034df9e$var$getCubicPointsOnGlobe;
        data.setItemLayout(idx, getPointsMethod(coords, coordSys));
    });
}
function $01833bb64034df9e$var$layoutOnPlane(seriesModel, coordSys, normal) {
    var data = seriesModel.getData();
    var isPolyline = seriesModel.get("polyline");
    var res = $01833bb64034df9e$var$prepareCoords(data);
    data.setLayout("lineType", isPolyline ? "polyline" : "cubicBezier");
    data.each(function(idx) {
        var coords = res.coordsList[idx];
        var pts = isPolyline ? $01833bb64034df9e$var$getPolylinePoints(coords, coordSys) : $01833bb64034df9e$var$getCubicPointsOnPlane(coords, coordSys, normal);
        data.setItemLayout(idx, pts);
    });
}
function $01833bb64034df9e$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType("lines3D", function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys.type === "globe") $01833bb64034df9e$var$layoutGlobe(seriesModel, coordSys);
        else if (coordSys.type === "geo3D") $01833bb64034df9e$var$layoutOnPlane(seriesModel, coordSys, [
            0,
            1,
            0
        ]);
        else if (coordSys.type === "mapbox3D" || coordSys.type === "maptalks3D") $01833bb64034df9e$var$layoutOnPlane(seriesModel, coordSys, [
            0,
            0,
            1
        ]);
    });
}



var $5368d5f653dbef17$export$2e2bcd8739ae039 = $7c10febb2cdef0d8$export$2e2bcd8739ae039.extend({
    type: "series.lines3D",
    dependencies: [
        "globe"
    ],
    visualStyleAccessPath: "lineStyle",
    visualDrawType: "stroke",
    getInitialData: function(option, ecModel) {
        var lineData = new $0ab0556b819346fd$export$2e2bcd8739ae039([
            "value"
        ], this);
        lineData.hasItemOption = false;
        lineData.initData(option.data, [], function(dataItem, dimName, dataIndex, dimIndex) {
            // dataItem is simply coords
            if (dataItem instanceof Array) return NaN;
            else {
                lineData.hasItemOption = true;
                var value = dataItem.value;
                if (value != null) return value instanceof Array ? value[dimIndex] : value;
            }
        });
        return lineData;
    },
    defaultOption: {
        coordinateSystem: "globe",
        globeIndex: 0,
        geo3DIndex: 0,
        zlevel: -10,
        polyline: false,
        effect: {
            show: false,
            period: 4,
            // Trail width
            trailWidth: 4,
            trailLength: 0.2,
            spotIntensity: 6
        },
        silent: true,
        // Support source-over, lighter
        blendMode: "source-over",
        lineStyle: {
            width: 1,
            opacity: 0.5 // color
        }
    }
});









var $f9508bcd009fe10f$export$2e2bcd8739ae039 = "@export ecgl.trail2.vertex\nattribute vec3 position: POSITION;\nattribute vec3 positionPrev;\nattribute vec3 positionNext;\nattribute float offset;\nattribute float dist;\nattribute float distAll;\nattribute float start;\n\nattribute vec4 a_Color : COLOR;\n\nuniform mat4 worldViewProjection : WORLDVIEWPROJECTION;\nuniform vec4 viewport : VIEWPORT;\nuniform float near : NEAR;\n\nuniform float speed : 0;\nuniform float trailLength: 0.3;\nuniform float time;\nuniform float period: 1000;\n\nuniform float spotSize: 1;\n\nvarying vec4 v_Color;\nvarying float v_Percent;\nvarying float v_SpotPercent;\n\n@import ecgl.common.wireframe.vertexHeader\n\n@import ecgl.lines3D.clipNear\n\nvoid main()\n{\n @import ecgl.lines3D.expandLine\n\n gl_Position = currProj;\n\n v_Color = a_Color;\n\n @import ecgl.common.wireframe.vertexMain\n\n#ifdef CONSTANT_SPEED\n float t = mod((speed * time + start) / distAll, 1. + trailLength) - trailLength;\n#else\n float t = mod((time + start) / period, 1. + trailLength) - trailLength;\n#endif\n\n float trailLen = distAll * trailLength;\n\n v_Percent = (dist - t * distAll) / trailLen;\n\n v_SpotPercent = spotSize / distAll;\n\n }\n@end\n\n\n@export ecgl.trail2.fragment\n\nuniform vec4 color : [1.0, 1.0, 1.0, 1.0];\nuniform float spotIntensity: 5;\n\nvarying vec4 v_Color;\nvarying float v_Percent;\nvarying float v_SpotPercent;\n\n@import ecgl.common.wireframe.fragmentHeader\n\n@import clay.util.srgb\n\nvoid main()\n{\n if (v_Percent > 1.0 || v_Percent < 0.0) {\n discard;\n }\n\n float fade = v_Percent;\n\n#ifdef SRGB_DECODE\n gl_FragColor = sRGBToLinear(color * v_Color);\n#else\n gl_FragColor = color * v_Color;\n#endif\n\n @import ecgl.common.wireframe.fragmentMain\n\n if (v_Percent > (1.0 - v_SpotPercent)) {\n gl_FragColor.rgb *= spotIntensity;\n }\n\n gl_FragColor.a *= fade;\n}\n\n@end";



var $f12944887d88c4d5$var$vec3 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).vec3;
function $f12944887d88c4d5$var$sign(a) {
    return a > 0 ? 1 : -1;
}
(0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.import((0, $f9508bcd009fe10f$export$2e2bcd8739ae039));
var $f12944887d88c4d5$export$2e2bcd8739ae039 = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh.extend(function() {
    var material = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
        shader: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader((0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.source("ecgl.trail2.vertex"), (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.source("ecgl.trail2.fragment")),
        transparent: true,
        depthMask: false
    });
    var geometry = new (0, $8c084a5220a66e92$export$2e2bcd8739ae039)({
        dynamic: true
    });
    geometry.createAttribute("dist", "float", 1);
    geometry.createAttribute("distAll", "float", 1);
    geometry.createAttribute("start", "float", 1);
    return {
        geometry: geometry,
        material: material,
        culling: false,
        $ignorePicking: true
    };
}, {
    updateData: function(data, api, lines3DGeometry) {
        var seriesModel = data.hostModel;
        var geometry = this.geometry;
        var effectModel = seriesModel.getModel("effect");
        var size = effectModel.get("trailWidth") * api.getDevicePixelRatio();
        var trailLength = effectModel.get("trailLength");
        var speed = seriesModel.get("effect.constantSpeed");
        var period = seriesModel.get("effect.period") * 1000;
        var useConstantSpeed = speed != null;
        useConstantSpeed ? this.material.set("speed", speed / 1000) : this.material.set("period", period);
        this.material[useConstantSpeed ? "define" : "undefine"]("vertex", "CONSTANT_SPEED");
        var isPolyline = seriesModel.get("polyline");
        geometry.trailLength = trailLength;
        this.material.set("trailLength", trailLength);
        geometry.resetOffset();
        [
            "position",
            "positionPrev",
            "positionNext"
        ].forEach(function(attrName) {
            geometry.attributes[attrName].value = lines3DGeometry.attributes[attrName].value;
        });
        var extraAttrs = [
            "dist",
            "distAll",
            "start",
            "offset",
            "color"
        ];
        extraAttrs.forEach(function(attrName) {
            geometry.attributes[attrName].init(geometry.vertexCount);
        });
        geometry.indices = lines3DGeometry.indices;
        var colorArr = [];
        var effectColor = effectModel.get("trailColor");
        var effectOpacity = effectModel.get("trailOpacity");
        var hasEffectColor = effectColor != null;
        var hasEffectOpacity = effectOpacity != null;
        this.updateWorldTransform();
        var xScale = this.worldTransform.x.len();
        var yScale = this.worldTransform.y.len();
        var zScale = this.worldTransform.z.len();
        var vertexOffset = 0;
        var maxDistance = 0;
        data.each(function(idx) {
            var pts = data.getItemLayout(idx);
            var opacity = hasEffectOpacity ? effectOpacity : (0, $4c1f03531dad0b09$export$f154d4dab8f4e8c0)(data, idx);
            var color = (0, $4c1f03531dad0b09$export$bc92a5a7848039f)(data, idx);
            if (opacity == null) opacity = 1;
            colorArr = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(hasEffectColor ? effectColor : color, colorArr);
            colorArr[3] *= opacity;
            var vertexCount = isPolyline ? lines3DGeometry.getPolylineVertexCount(pts) : lines3DGeometry.getCubicCurveVertexCount(pts[0], pts[1], pts[2], pts[3]);
            var dist = 0;
            var pos = [];
            var posPrev = [];
            for(var i = vertexOffset; i < vertexOffset + vertexCount; i++){
                geometry.attributes.position.get(i, pos);
                pos[0] *= xScale;
                pos[1] *= yScale;
                pos[2] *= zScale;
                if (i > vertexOffset) dist += $f12944887d88c4d5$var$vec3.dist(pos, posPrev);
                geometry.attributes.dist.set(i, dist);
                $f12944887d88c4d5$var$vec3.copy(posPrev, pos);
            }
            maxDistance = Math.max(maxDistance, dist);
            var randomStart = Math.random() * (useConstantSpeed ? dist : period);
            for(var i = vertexOffset; i < vertexOffset + vertexCount; i++){
                geometry.attributes.distAll.set(i, dist);
                geometry.attributes.start.set(i, randomStart);
                geometry.attributes.offset.set(i, $f12944887d88c4d5$var$sign(lines3DGeometry.attributes.offset.get(i)) * size / 2);
                geometry.attributes.color.set(i, colorArr);
            }
            vertexOffset += vertexCount;
        });
        this.material.set("spotSize", maxDistance * 0.1 * trailLength);
        this.material.set("spotIntensity", effectModel.get("spotIntensity"));
        geometry.dirty();
    },
    setAnimationTime: function(time) {
        this.material.set("time", time);
    }
});




(0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.import((0, $ceca9d93a3d35604$export$2e2bcd8739ae039));
function $a0f2d9c7f2e68278$var$getCoordSysSize(coordSys) {
    if (coordSys.radius != null) return coordSys.radius;
    if (coordSys.size != null) return Math.max(coordSys.size[0], coordSys.size[1], coordSys.size[2]);
    else return 100;
}
var $a0f2d9c7f2e68278$export$2e2bcd8739ae039 = $0dc5061053e23cd3$export$2e2bcd8739ae039.extend({
    type: "lines3D",
    __ecgl__: true,
    init: function(ecModel, api) {
        this.groupGL = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
        this._meshLinesMaterial = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
            shader: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createShader("ecgl.meshLines3D"),
            transparent: true,
            depthMask: false
        });
        this._linesMesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
            geometry: new (0, $8c084a5220a66e92$export$2e2bcd8739ae039)(),
            material: this._meshLinesMaterial,
            $ignorePicking: true
        }); // this._trailMesh = new TrailMesh();
        this._trailMesh = new (0, $f12944887d88c4d5$export$2e2bcd8739ae039)();
    },
    render: function(seriesModel, ecModel, api) {
        this.groupGL.add(this._linesMesh);
        var coordSys = seriesModel.coordinateSystem;
        var data = seriesModel.getData();
        if (coordSys && coordSys.viewGL) {
            var viewGL = coordSys.viewGL;
            viewGL.add(this.groupGL);
            this._updateLines(seriesModel, ecModel, api);
            var methodName = coordSys.viewGL.isLinearSpace() ? "define" : "undefine";
            this._linesMesh.material[methodName]("fragment", "SRGB_DECODE");
            this._trailMesh.material[methodName]("fragment", "SRGB_DECODE");
        }
        var trailMesh = this._trailMesh;
        trailMesh.stopAnimation();
        if (seriesModel.get("effect.show")) {
            this.groupGL.add(trailMesh);
            trailMesh.updateData(data, api, this._linesMesh.geometry);
            trailMesh.__time = trailMesh.__time || 0;
            var time = 3600000; // 1hour
            this._curveEffectsAnimator = trailMesh.animate("", {
                loop: true
            }).when(time, {
                __time: time
            }).during(function() {
                trailMesh.setAnimationTime(trailMesh.__time);
            }).start();
        } else {
            this.groupGL.remove(trailMesh);
            this._curveEffectsAnimator = null;
        }
        this._linesMesh.material.blend = this._trailMesh.material.blend = seriesModel.get("blendMode") === "lighter" ? (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).additiveBlend : null;
    },
    pauseEffect: function() {
        if (this._curveEffectsAnimator) this._curveEffectsAnimator.pause();
    },
    resumeEffect: function() {
        if (this._curveEffectsAnimator) this._curveEffectsAnimator.resume();
    },
    toggleEffect: function() {
        var animator = this._curveEffectsAnimator;
        if (animator) animator.isPaused() ? animator.resume() : animator.pause();
    },
    _updateLines: function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var coordSys = seriesModel.coordinateSystem;
        var geometry = this._linesMesh.geometry;
        var isPolyline = seriesModel.get("polyline");
        geometry.expandLine = true;
        var size = $a0f2d9c7f2e68278$var$getCoordSysSize(coordSys);
        geometry.segmentScale = size / 20;
        var lineWidthQueryPath = "lineStyle.width".split(".");
        var dpr = api.getDevicePixelRatio();
        var maxLineWidth = 0;
        data.each(function(idx) {
            var itemModel = data.getItemModel(idx);
            var lineWidth = itemModel.get(lineWidthQueryPath);
            if (lineWidth == null) lineWidth = 1;
            data.setItemVisual(idx, "lineWidth", lineWidth);
            maxLineWidth = Math.max(lineWidth, maxLineWidth);
        }); // Must set useNativeLine before calling any other methods
        geometry.useNativeLine = false;
        var nVertex = 0;
        var nTriangle = 0;
        data.each(function(idx) {
            var pts = data.getItemLayout(idx);
            if (isPolyline) {
                nVertex += geometry.getPolylineVertexCount(pts);
                nTriangle += geometry.getPolylineTriangleCount(pts);
            } else {
                nVertex += geometry.getCubicCurveVertexCount(pts[0], pts[1], pts[2], pts[3]);
                nTriangle += geometry.getCubicCurveTriangleCount(pts[0], pts[1], pts[2], pts[3]);
            }
        });
        geometry.setVertexCount(nVertex);
        geometry.setTriangleCount(nTriangle);
        geometry.resetOffset();
        var colorArr = [];
        data.each(function(idx) {
            var pts = data.getItemLayout(idx);
            var color = (0, $4c1f03531dad0b09$export$bc92a5a7848039f)(data, idx);
            var opacity = (0, $4c1f03531dad0b09$export$f154d4dab8f4e8c0)(data, idx);
            var lineWidth = data.getItemVisual(idx, "lineWidth") * dpr;
            if (opacity == null) opacity = 1;
            colorArr = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(color, colorArr);
            colorArr[3] *= opacity;
            if (isPolyline) geometry.addPolyline(pts, colorArr, lineWidth);
            else geometry.addCubicCurve(pts[0], pts[1], pts[2], pts[3], colorArr, lineWidth);
        });
        geometry.dirty();
    },
    remove: function() {
        this.groupGL.removeAll();
    },
    dispose: function() {
        this.groupGL.removeAll();
    }
});


function $9397d90ff76ce12a$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $a0f2d9c7f2e68278$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $5368d5f653dbef17$export$2e2bcd8739ae039));
    registers.registerLayout((0, $01833bb64034df9e$export$2e2bcd8739ae039));
    registers.registerAction({
        type: "lines3DPauseEffect",
        event: "lines3deffectpaused",
        update: "series.lines3D:pauseEffect"
    }, function() {});
    registers.registerAction({
        type: "lines3DResumeEffect",
        event: "lines3deffectresumed",
        update: "series.lines3D:resumeEffect"
    }, function() {});
    registers.registerAction({
        type: "lines3DToggleEffect",
        event: "lines3deffectchanged",
        update: "series.lines3D:toggleEffect"
    }, function() {});
}


(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $9397d90ff76ce12a$export$4b3e715f166fdd78));



// TODO ECharts GL must be imported whatever component,charts is imported.



function $2608378545f4051a$var$transformPolygon(coordSys, poly) {
    var ret = [];
    for(var i = 0; i < poly.length; i++)ret.push(coordSys.dataToPoint(poly[i]));
    return ret;
}
var $2608378545f4051a$var$Polygons3DSeries = $7c10febb2cdef0d8$export$2e2bcd8739ae039.extend({
    type: "series.polygons3D",
    getRegionModel: function(idx) {
        return this.getData().getItemModel(idx);
    },
    getRegionPolygonCoords: function(idx) {
        var coordSys = this.coordinateSystem;
        var itemModel = this.getData().getItemModel(idx);
        var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.getShallow("coords");
        if (!itemModel.get("multiPolygon")) coords = [
            coords
        ];
         // TODO Validate
        var out = [];
        for(var i = 0; i < coords.length; i++){
            // TODO Convert here ?
            var interiors = [];
            for(var k = 1; k < coords[i].length; k++)interiors.push($2608378545f4051a$var$transformPolygon(coordSys, coords[i][k]));
            out.push({
                exterior: $2608378545f4051a$var$transformPolygon(coordSys, coords[i][0]),
                interiors: interiors
            });
        }
        return out;
    },
    getInitialData: function(option) {
        var polygonsData = new $0ab0556b819346fd$export$2e2bcd8739ae039([
            "value"
        ], this);
        polygonsData.hasItemOption = false;
        polygonsData.initData(option.data, [], function(dataItem, dimName, dataIndex, dimIndex) {
            // dataItem is simply coords
            if (dataItem instanceof Array) return NaN;
            else {
                polygonsData.hasItemOption = true;
                var value = dataItem.value;
                if (value != null) return value instanceof Array ? value[dimIndex] : value;
            }
        });
        return polygonsData;
    },
    defaultOption: {
        show: true,
        data: null,
        multiPolygon: false,
        progressiveThreshold: 1e3,
        progressive: 1e3,
        zlevel: -10,
        label: {
            show: false,
            // Distance in 3d space.
            distance: 2,
            textStyle: {
                fontSize: 20,
                color: "#000",
                backgroundColor: "rgba(255,255,255,0.7)",
                padding: 3,
                borderRadius: 4
            }
        },
        itemStyle: {
            color: "#fff",
            borderWidth: 0,
            borderColor: "#333"
        },
        emphasis: {
            itemStyle: {
                color: "#639fc0"
            },
            label: {
                show: true
            }
        }
    }
});
$224386f1517b5dca$exports.merge($2608378545f4051a$var$Polygons3DSeries.prototype, (0, $f866f5803ca3a09a$export$2e2bcd8739ae039));
var $2608378545f4051a$export$2e2bcd8739ae039 = $2608378545f4051a$var$Polygons3DSeries;





var $0c44ef70430e1a7e$export$2e2bcd8739ae039 = $0dc5061053e23cd3$export$2e2bcd8739ae039.extend({
    type: "polygons3D",
    __ecgl__: true,
    init: function(ecModel, api) {
        this.groupGL = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
        this._geo3DBuilderList = [];
        this._currentStep = 0;
    },
    render: function(seriesModel, ecModel, api) {
        this.groupGL.removeAll();
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.viewGL) coordSys.viewGL.add(this.groupGL);
        var geo3DBuilder = this._geo3DBuilderList[0];
        if (!geo3DBuilder) {
            geo3DBuilder = new (0, $5a38c1b2963f6585$export$2e2bcd8739ae039)(api);
            geo3DBuilder.extrudeY = coordSys.type !== "mapbox3D" && coordSys.type !== "maptalks3D";
            this._geo3DBuilderList[0] = geo3DBuilder;
        }
        this._updateShaderDefines(coordSys, geo3DBuilder);
        geo3DBuilder.update(seriesModel, ecModel, api);
        this._geo3DBuilderList.length = 1;
        this.groupGL.add(geo3DBuilder.rootNode);
    },
    incrementalPrepareRender: function(seriesModel, ecModel, api) {
        this.groupGL.removeAll();
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.viewGL) coordSys.viewGL.add(this.groupGL);
        this._currentStep = 0;
    },
    incrementalRender: function(params, seriesModel, ecModel, api) {
        var geo3DBuilder = this._geo3DBuilderList[this._currentStep];
        var coordSys = seriesModel.coordinateSystem;
        if (!geo3DBuilder) {
            geo3DBuilder = new (0, $5a38c1b2963f6585$export$2e2bcd8739ae039)(api);
            geo3DBuilder.extrudeY = coordSys.type !== "mapbox3D" && coordSys.type !== "maptalks3D";
            this._geo3DBuilderList[this._currentStep] = geo3DBuilder;
        }
        geo3DBuilder.update(seriesModel, ecModel, api, params.start, params.end);
        this.groupGL.add(geo3DBuilder.rootNode);
        this._updateShaderDefines(coordSys, geo3DBuilder);
        this._currentStep++;
    },
    _updateShaderDefines: function(coordSys, geo3DBuilder) {
        var methodName = coordSys.viewGL.isLinearSpace() ? "define" : "undefine";
        geo3DBuilder.rootNode.traverse(function(mesh) {
            if (mesh.material) {
                mesh.material[methodName]("fragment", "SRGB_DECODE"); // FIXME
                if (coordSys.type === "mapbox3D" || coordSys.type === "maptalks3D") {
                    mesh.material.define("fragment", "NORMAL_UP_AXIS", 2);
                    mesh.material.define("fragment", "NORMAL_FRONT_AXIS", 1);
                }
            }
        });
    },
    remove: function() {
        this.groupGL.removeAll();
    },
    dispose: function() {
        this.groupGL.removeAll();
        this._geo3DBuilderList.forEach(function(geo3DBuilder) {
            geo3DBuilder.dispose();
        });
    }
});


function $eec060e4ab61e8e9$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $0c44ef70430e1a7e$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $2608378545f4051a$export$2e2bcd8739ae039));
}


(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $eec060e4ab61e8e9$export$4b3e715f166fdd78));



// TODO ECharts GL must be imported whatever component,charts is imported.





var $cf3712df9cc4db66$var$SurfaceSeries = $7c10febb2cdef0d8$export$2e2bcd8739ae039.extend({
    type: "series.surface",
    dependencies: [
        "globe",
        "grid3D",
        "geo3D"
    ],
    visualStyleAccessPath: "itemStyle",
    formatTooltip: function(dataIndex) {
        return (0, $588422417f0cb36c$export$2e2bcd8739ae039)(this, dataIndex);
    },
    getInitialData: function(option, ecModel) {
        var data = option.data;
        function validateDimension(dimOpts) {
            return !(isNaN(dimOpts.min) || isNaN(dimOpts.max) || isNaN(dimOpts.step));
        }
        function getPrecision(dimOpts) {
            var getPrecision = $880e2355a7de9d0c$exports.getPrecisionSafe;
            return Math.max(getPrecision(dimOpts.min), getPrecision(dimOpts.max), getPrecision(dimOpts.step)) + 1;
        }
        if (!data) {
            if (!option.parametric) {
                // From surface equation
                var equation = option.equation || {};
                var xOpts = equation.x || {};
                var yOpts = equation.y || {};
                [
                    "x",
                    "y"
                ].forEach(function(dim) {
                    if (!validateDimension(equation[dim])) return;
                });
                if (typeof equation.z !== "function") return;
                var xCount = Math.floor((xOpts.max + xOpts.step - xOpts.min) / xOpts.step);
                var yCount = Math.floor((yOpts.max + yOpts.step - yOpts.min) / yOpts.step);
                data = new Float32Array(xCount * yCount * 3);
                var xPrecision = getPrecision(xOpts);
                var yPrecision = getPrecision(yOpts);
                var off = 0;
                for(var j = 0; j < yCount; j++)for(var i = 0; i < xCount; i++){
                    var x = i * xOpts.step + xOpts.min;
                    var y = j * yOpts.step + yOpts.min;
                    var x2 = $880e2355a7de9d0c$exports.round(Math.min(x, xOpts.max), xPrecision);
                    var y2 = $880e2355a7de9d0c$exports.round(Math.min(y, yOpts.max), yPrecision);
                    var z = equation.z(x2, y2);
                    data[off++] = x2;
                    data[off++] = y2;
                    data[off++] = z;
                }
            } else {
                var parametricEquation = option.parametricEquation || {};
                var uOpts = parametricEquation.u || {};
                var vOpts = parametricEquation.v || {};
                [
                    "u",
                    "v"
                ].forEach(function(dim) {
                    if (!validateDimension(parametricEquation[dim])) return;
                });
                [
                    "x",
                    "y",
                    "z"
                ].forEach(function(dim) {
                    if (typeof parametricEquation[dim] !== "function") return;
                });
                var uCount = Math.floor((uOpts.max + uOpts.step - uOpts.min) / uOpts.step);
                var vCount = Math.floor((vOpts.max + vOpts.step - vOpts.min) / vOpts.step);
                data = new Float32Array(uCount * vCount * 5);
                var uPrecision = getPrecision(uOpts);
                var vPrecision = getPrecision(vOpts);
                var off = 0;
                for(var j = 0; j < vCount; j++)for(var i = 0; i < uCount; i++){
                    var u = i * uOpts.step + uOpts.min;
                    var v = j * vOpts.step + vOpts.min;
                    var u2 = $880e2355a7de9d0c$exports.round(Math.min(u, uOpts.max), uPrecision);
                    var v2 = $880e2355a7de9d0c$exports.round(Math.min(v, vOpts.max), vPrecision);
                    var x = parametricEquation.x(u2, v2);
                    var y = parametricEquation.y(u2, v2);
                    var z = parametricEquation.z(u2, v2);
                    data[off++] = x;
                    data[off++] = y;
                    data[off++] = z;
                    data[off++] = u2;
                    data[off++] = v2;
                }
            }
        }
        var dims = [
            "x",
            "y",
            "z"
        ];
        if (option.parametric) dims.push("u", "v");
         // PENDING getSource?
        var list = (0, $a0377603e49108f9$export$2e2bcd8739ae039)(this, dims, data);
        return list;
    },
    defaultOption: {
        coordinateSystem: "cartesian3D",
        zlevel: -10,
        // Cartesian coordinate system
        grid3DIndex: 0,
        // Surface needs lambert shading to show the difference
        shading: "lambert",
        // If parametric surface
        parametric: false,
        wireframe: {
            show: true,
            lineStyle: {
                color: "rgba(0,0,0,0.5)",
                width: 1
            }
        },
        /**
     * Generate surface data from z = f(x, y) equation
     */ equation: {
            // [min, max, step]
            x: {
                min: -1,
                max: 1,
                step: 0.1
            },
            y: {
                min: -1,
                max: 1,
                step: 0.1
            },
            z: null
        },
        parametricEquation: {
            // [min, max, step]
            u: {
                min: -1,
                max: 1,
                step: 0.1
            },
            v: {
                min: -1,
                max: 1,
                step: 0.1
            },
            // [x, y, z] = f(x, y)
            x: null,
            y: null,
            z: null
        },
        // Shape of give data
        // It is an array to specify rows and columns.
        // For example [30, 30]
        dataShape: null,
        itemStyle: {},
        animationDurationUpdate: 500
    }
});
$224386f1517b5dca$exports.merge($cf3712df9cc4db66$var$SurfaceSeries.prototype, (0, $f866f5803ca3a09a$export$2e2bcd8739ae039));
var $cf3712df9cc4db66$export$2e2bcd8739ae039 = $cf3712df9cc4db66$var$SurfaceSeries;







var $4d3818f4e15a8a3c$var$vec3 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).vec3;
function $4d3818f4e15a8a3c$var$isPointsNaN(pt) {
    return isNaN(pt[0]) || isNaN(pt[1]) || isNaN(pt[2]);
}
var $4d3818f4e15a8a3c$export$2e2bcd8739ae039 = $0dc5061053e23cd3$export$2e2bcd8739ae039.extend({
    type: "surface",
    __ecgl__: true,
    init: function(ecModel, api) {
        this.groupGL = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
    },
    render: function(seriesModel, ecModel, api) {
        // Swap surfaceMesh
        var tmp = this._prevSurfaceMesh;
        this._prevSurfaceMesh = this._surfaceMesh;
        this._surfaceMesh = tmp;
        if (!this._surfaceMesh) this._surfaceMesh = this._createSurfaceMesh();
        this.groupGL.remove(this._prevSurfaceMesh);
        this.groupGL.add(this._surfaceMesh);
        var coordSys = seriesModel.coordinateSystem;
        var shading = seriesModel.get("shading");
        var data = seriesModel.getData();
        var shadingPrefix = "ecgl." + shading;
        if (!this._surfaceMesh.material || this._surfaceMesh.material.shader.name !== shadingPrefix) this._surfaceMesh.material = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createMaterial(shadingPrefix, [
            "VERTEX_COLOR",
            "DOUBLE_SIDED"
        ]);
        (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).setMaterialFromModel(shading, this._surfaceMesh.material, seriesModel, api);
        if (coordSys && coordSys.viewGL) {
            coordSys.viewGL.add(this.groupGL);
            var methodName = coordSys.viewGL.isLinearSpace() ? "define" : "undefine";
            this._surfaceMesh.material[methodName]("fragment", "SRGB_DECODE");
        }
        var isParametric = seriesModel.get("parametric");
        var dataShape = seriesModel.get("dataShape");
        if (!dataShape) dataShape = this._getDataShape(data, isParametric);
        var wireframeModel = seriesModel.getModel("wireframe");
        var wireframeLineWidth = wireframeModel.get("lineStyle.width");
        var showWireframe = wireframeModel.get("show") && wireframeLineWidth > 0;
        this._updateSurfaceMesh(this._surfaceMesh, seriesModel, dataShape, showWireframe);
        var material = this._surfaceMesh.material;
        if (showWireframe) {
            material.define("WIREFRAME_QUAD");
            material.set("wireframeLineWidth", wireframeLineWidth);
            material.set("wireframeLineColor", (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(wireframeModel.get("lineStyle.color")));
        } else material.undefine("WIREFRAME_QUAD");
        this._initHandler(seriesModel, api);
        this._updateAnimation(seriesModel);
    },
    _updateAnimation: function(seriesModel) {
        (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).updateVertexAnimation([
            [
                "prevPosition",
                "position"
            ],
            [
                "prevNormal",
                "normal"
            ]
        ], this._prevSurfaceMesh, this._surfaceMesh, seriesModel);
    },
    _createSurfaceMesh: function() {
        var mesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
            geometry: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Geometry({
                dynamic: true,
                sortTriangles: true
            }),
            shadowDepthMaterial: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
                shader: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader((0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.source("ecgl.sm.depth.vertex"), (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.source("ecgl.sm.depth.fragment"))
            }),
            culling: false,
            // Render after axes
            renderOrder: 10,
            // Render normal in normal pass
            renderNormal: true
        });
        mesh.geometry.createAttribute("barycentric", "float", 4);
        mesh.geometry.createAttribute("prevPosition", "float", 3);
        mesh.geometry.createAttribute("prevNormal", "float", 3);
        Object.assign(mesh.geometry, (0, $fd6f60f8a754e772$export$2e2bcd8739ae039));
        return mesh;
    },
    _initHandler: function(seriesModel, api) {
        var data = seriesModel.getData();
        var surfaceMesh = this._surfaceMesh;
        var coordSys = seriesModel.coordinateSystem;
        function getNearestPointIdx(triangle, point) {
            var nearestDist = Infinity;
            var nearestIdx = -1;
            var pos = [];
            for(var i = 0; i < triangle.length; i++){
                surfaceMesh.geometry.attributes.position.get(triangle[i], pos);
                var dist = $4d3818f4e15a8a3c$var$vec3.dist(point.array, pos);
                if (dist < nearestDist) {
                    nearestDist = dist;
                    nearestIdx = triangle[i];
                }
            }
            return nearestIdx;
        }
        surfaceMesh.seriesIndex = seriesModel.seriesIndex;
        var lastDataIndex = -1;
        surfaceMesh.off("mousemove");
        surfaceMesh.off("mouseout");
        surfaceMesh.on("mousemove", function(e) {
            var idx = getNearestPointIdx(e.triangle, e.point);
            if (idx >= 0) {
                var point = [];
                surfaceMesh.geometry.attributes.position.get(idx, point);
                var value = coordSys.pointToData(point);
                var minDist = Infinity;
                var dataIndex = -1;
                var item = [];
                for(var i = 0; i < data.count(); i++){
                    item[0] = data.get("x", i);
                    item[1] = data.get("y", i);
                    item[2] = data.get("z", i);
                    var dist = $4d3818f4e15a8a3c$var$vec3.squaredDistance(item, value);
                    if (dist < minDist) {
                        dataIndex = i;
                        minDist = dist;
                    }
                }
                if (dataIndex !== lastDataIndex) api.dispatchAction({
                    type: "grid3DShowAxisPointer",
                    value: value
                });
                lastDataIndex = dataIndex;
                surfaceMesh.dataIndex = dataIndex;
            } else surfaceMesh.dataIndex = -1;
        }, this);
        surfaceMesh.on("mouseout", function(e) {
            lastDataIndex = -1;
            surfaceMesh.dataIndex = -1;
            api.dispatchAction({
                type: "grid3DHideAxisPointer"
            });
        }, this);
    },
    _updateSurfaceMesh: function(surfaceMesh, seriesModel, dataShape, showWireframe) {
        var geometry = surfaceMesh.geometry;
        var data = seriesModel.getData();
        var pointsArr = data.getLayout("points");
        var invalidDataCount = 0;
        data.each(function(idx) {
            if (!data.hasValue(idx)) invalidDataCount++;
        });
        var needsSplitQuad = invalidDataCount || showWireframe;
        var positionAttr = geometry.attributes.position;
        var normalAttr = geometry.attributes.normal;
        var texcoordAttr = geometry.attributes.texcoord0;
        var barycentricAttr = geometry.attributes.barycentric;
        var colorAttr = geometry.attributes.color;
        var row = dataShape[0];
        var column = dataShape[1];
        var shading = seriesModel.get("shading");
        var needsNormal = shading !== "color";
        if (needsSplitQuad) {
            // TODO, If needs remove the invalid points, or set color transparent.
            var vertexCount = (row - 1) * (column - 1) * 4;
            positionAttr.init(vertexCount);
            if (showWireframe) barycentricAttr.init(vertexCount);
        } else positionAttr.value = new Float32Array(pointsArr);
        colorAttr.init(geometry.vertexCount);
        texcoordAttr.init(geometry.vertexCount);
        var quadToTriangle = [
            0,
            3,
            1,
            1,
            3,
            2
        ]; // 3----2
        // 0----1
        // Make sure pixels on 1---3 edge will not have channel 0.
        // And pixels on four edges have at least one channel 0.
        var quadBarycentric = [
            [
                1,
                1,
                0,
                0
            ],
            [
                0,
                1,
                0,
                1
            ],
            [
                1,
                0,
                0,
                1
            ],
            [
                1,
                0,
                1,
                0
            ]
        ];
        var indices = geometry.indices = new (geometry.vertexCount > 0xffff ? Uint32Array : Uint16Array)((row - 1) * (column - 1) * 6);
        var getQuadIndices = function(i, j, out) {
            out[1] = i * column + j;
            out[0] = i * column + j + 1;
            out[3] = (i + 1) * column + j + 1;
            out[2] = (i + 1) * column + j;
        };
        var isTransparent = false;
        if (needsSplitQuad) {
            var quadIndices = [];
            var pos = [];
            var faceOffset = 0;
            if (needsNormal) normalAttr.init(geometry.vertexCount);
            else normalAttr.value = null;
            var pts = [
                [],
                [],
                []
            ];
            var v21 = [], v32 = [];
            var normal = $4d3818f4e15a8a3c$var$vec3.create();
            var getFromArray = function(arr, idx, out) {
                var idx3 = idx * 3;
                out[0] = arr[idx3];
                out[1] = arr[idx3 + 1];
                out[2] = arr[idx3 + 2];
                return out;
            };
            var vertexNormals = new Float32Array(pointsArr.length);
            var vertexColors = new Float32Array(pointsArr.length / 3 * 4);
            for(var i = 0; i < data.count(); i++)if (data.hasValue(i)) {
                var rgbaArr = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor((0, $4c1f03531dad0b09$export$bc92a5a7848039f)(data, i));
                var opacity = (0, $4c1f03531dad0b09$export$f154d4dab8f4e8c0)(data, i);
                opacity != null && (rgbaArr[3] *= opacity);
                if (rgbaArr[3] < 0.99) isTransparent = true;
                for(var k = 0; k < 4; k++)vertexColors[i * 4 + k] = rgbaArr[k];
            }
            var farPoints = [
                1e7,
                1e7,
                1e7
            ];
            for(var i = 0; i < row - 1; i++)for(var j = 0; j < column - 1; j++){
                var dataIndex = i * (column - 1) + j;
                var vertexOffset = dataIndex * 4;
                getQuadIndices(i, j, quadIndices);
                var invisibleQuad = false;
                for(var k = 0; k < 4; k++){
                    getFromArray(pointsArr, quadIndices[k], pos);
                    if ($4d3818f4e15a8a3c$var$isPointsNaN(pos)) // Quad is invisible if any point is NaN
                    invisibleQuad = true;
                }
                for(var k = 0; k < 4; k++){
                    if (invisibleQuad) // Move point far away
                    positionAttr.set(vertexOffset + k, farPoints);
                    else {
                        getFromArray(pointsArr, quadIndices[k], pos);
                        positionAttr.set(vertexOffset + k, pos);
                    }
                    if (showWireframe) barycentricAttr.set(vertexOffset + k, quadBarycentric[k]);
                }
                for(var k = 0; k < 6; k++)indices[faceOffset++] = quadToTriangle[k] + vertexOffset;
                 // Vertex normals
                if (needsNormal && !invisibleQuad) for(var k = 0; k < 2; k++){
                    var k3 = k * 3;
                    for(var m = 0; m < 3; m++){
                        var idx = quadIndices[quadToTriangle[k3] + m];
                        getFromArray(pointsArr, idx, pts[m]);
                    }
                    $4d3818f4e15a8a3c$var$vec3.sub(v21, pts[0], pts[1]);
                    $4d3818f4e15a8a3c$var$vec3.sub(v32, pts[1], pts[2]);
                    $4d3818f4e15a8a3c$var$vec3.cross(normal, v21, v32); // Weighted by the triangle area
                    for(var m = 0; m < 3; m++){
                        var idx3 = quadIndices[quadToTriangle[k3] + m] * 3;
                        vertexNormals[idx3] = vertexNormals[idx3] + normal[0];
                        vertexNormals[idx3 + 1] = vertexNormals[idx3 + 1] + normal[1];
                        vertexNormals[idx3 + 2] = vertexNormals[idx3 + 2] + normal[2];
                    }
                }
            }
            if (needsNormal) for(var i = 0; i < vertexNormals.length / 3; i++){
                getFromArray(vertexNormals, i, normal);
                $4d3818f4e15a8a3c$var$vec3.normalize(normal, normal);
                vertexNormals[i * 3] = normal[0];
                vertexNormals[i * 3 + 1] = normal[1];
                vertexNormals[i * 3 + 2] = normal[2];
            }
             // Split normal and colors, write to the attributes.
            var rgbaArr = [];
            var uvArr = [];
            for(var i = 0; i < row - 1; i++)for(var j = 0; j < column - 1; j++){
                var dataIndex = i * (column - 1) + j;
                var vertexOffset = dataIndex * 4;
                getQuadIndices(i, j, quadIndices);
                for(var k = 0; k < 4; k++){
                    for(var m = 0; m < 4; m++)rgbaArr[m] = vertexColors[quadIndices[k] * 4 + m];
                    colorAttr.set(vertexOffset + k, rgbaArr);
                    if (needsNormal) {
                        getFromArray(vertexNormals, quadIndices[k], normal);
                        normalAttr.set(vertexOffset + k, normal);
                    }
                    var idx = quadIndices[k];
                    uvArr[0] = idx % column / (column - 1);
                    uvArr[1] = Math.floor(idx / column) / (row - 1);
                    texcoordAttr.set(vertexOffset + k, uvArr);
                }
                dataIndex++;
            }
        } else {
            var uvArr = [];
            for(var i = 0; i < data.count(); i++){
                uvArr[0] = i % column / (column - 1);
                uvArr[1] = Math.floor(i / column) / (row - 1);
                var rgbaArr = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor((0, $4c1f03531dad0b09$export$bc92a5a7848039f)(data, i));
                var opacity = (0, $4c1f03531dad0b09$export$f154d4dab8f4e8c0)(data, i);
                opacity != null && (rgbaArr[3] *= opacity);
                if (rgbaArr[3] < 0.99) isTransparent = true;
                colorAttr.set(i, rgbaArr);
                texcoordAttr.set(i, uvArr);
            }
            var quadIndices = []; // Triangles
            var cursor = 0;
            for(var i = 0; i < row - 1; i++)for(var j = 0; j < column - 1; j++){
                getQuadIndices(i, j, quadIndices);
                for(var k = 0; k < 6; k++)indices[cursor++] = quadIndices[quadToTriangle[k]];
            }
            if (needsNormal) geometry.generateVertexNormals();
            else normalAttr.value = null;
        }
        if (surfaceMesh.material.get("normalMap")) geometry.generateTangents();
        geometry.updateBoundingBox();
        geometry.dirty();
        surfaceMesh.material.transparent = isTransparent;
        surfaceMesh.material.depthMask = !isTransparent;
    },
    _getDataShape: function(data, isParametric) {
        var prevX = -Infinity;
        var rowCount = 0;
        var columnCount = 0;
        var prevColumnCount = 0;
        var mayInvalid = false;
        var rowDim = isParametric ? "u" : "x";
        var dataCount = data.count(); // Check data format
        for(var i = 0; i < dataCount; i++){
            var x = data.get(rowDim, i);
            if (x < prevX) {
                prevColumnCount; // A new row.
                prevColumnCount = columnCount;
                columnCount = 0;
                rowCount++;
            }
            prevX = x;
            columnCount++;
        }
        if (!rowCount || columnCount === 1) mayInvalid = true;
        if (!mayInvalid) return [
            rowCount + 1,
            columnCount
        ];
        var rows = Math.floor(Math.sqrt(dataCount));
        while(rows > 0){
            if (Math.floor(dataCount / rows) === dataCount / rows) // Can be divided
            return [
                rows,
                dataCount / rows
            ];
            rows--;
        } // Bailout
        rows = Math.floor(Math.sqrt(dataCount));
        return [
            rows,
            rows
        ];
    },
    dispose: function() {
        this.groupGL.removeAll();
    },
    remove: function() {
        this.groupGL.removeAll();
    }
});


function $eccf7a55e2f3c3df$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $4d3818f4e15a8a3c$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $cf3712df9cc4db66$export$2e2bcd8739ae039));
    registers.registerLayout(function(ecModel, api) {
        ecModel.eachSeriesByType("surface", function(surfaceModel) {
            var cartesian = surfaceModel.coordinateSystem;
            !cartesian || cartesian.type;
            var data = surfaceModel.getData();
            var points = new Float32Array(3 * data.count());
            var nanPoint = [
                NaN,
                NaN,
                NaN
            ];
            if (cartesian && cartesian.type === "cartesian3D") {
                var coordDims = cartesian.dimensions;
                var dims = coordDims.map(function(coordDim) {
                    return surfaceModel.coordDimToDataDim(coordDim)[0];
                });
                data.each(dims, function(x, y, z, idx) {
                    var pt;
                    if (!data.hasValue(idx)) pt = nanPoint;
                    else pt = cartesian.dataToPoint([
                        x,
                        y,
                        z
                    ]);
                    points[idx * 3] = pt[0];
                    points[idx * 3 + 1] = pt[1];
                    points[idx * 3 + 2] = pt[2];
                });
            }
            data.setLayout("points", points);
        });
    });
}


(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $eccf7a55e2f3c3df$export$4b3e715f166fdd78));



// TODO ECharts GL must be imported whatever component,charts is imported.










function $c394516103eca2d4$var$transformPolygon(mapbox3DCoordSys, poly) {
    var newPoly = [];
    for(var k = 0; k < poly.length; k++)newPoly.push(mapbox3DCoordSys.dataToPoint(poly[k]));
    return newPoly;
}
var $c394516103eca2d4$var$Map3DSeries = $7c10febb2cdef0d8$export$2e2bcd8739ae039.extend({
    type: "series.map3D",
    layoutMode: "box",
    coordinateSystem: null,
    visualStyleAccessPath: "itemStyle",
    optionUpdated: function(newOpt) {
        newOpt = newOpt || {};
        var coordSysType = this.get("coordinateSystem");
        if (coordSysType == null || coordSysType === "geo3D") return;
        var propsNeedToCheck, ignoredProperties;
        if (this.get("groundPlane.show")) // Force disable groundPlane if map3D has other coordinate systems.
        this.option.groundPlane.show = false;
         // Reset geo.
        this._geo = null;
    },
    getInitialData: function(option) {
        option.data = this.getFilledRegions(option.data, option.map);
        var dimensions = $9a616079ee96a3f3$exports.createDimensions(option.data, {
            coordDimensions: [
                "value"
            ]
        });
        var list = new $0ab0556b819346fd$export$2e2bcd8739ae039(dimensions, this);
        list.initData(option.data);
        var regionModelMap = {};
        list.each(function(idx) {
            var name = list.getName(idx);
            var itemModel = list.getItemModel(idx);
            regionModelMap[name] = itemModel;
        });
        this._regionModelMap = regionModelMap;
        return list;
    },
    formatTooltip: function(dataIndex) {
        return (0, $588422417f0cb36c$export$2e2bcd8739ae039)(this, dataIndex);
    },
    getRegionModel: function(idx) {
        var name = this.getData().getName(idx);
        return this._regionModelMap[name] || new $6818646a97528290$export$2e2bcd8739ae039(null, this);
    },
    getRegionPolygonCoords: function(idx) {
        var coordSys = this.coordinateSystem;
        var name = this.getData().getName(idx);
        if (coordSys.transform) {
            var region = coordSys.getRegion(name);
            return region ? region.geometries : [];
        } else {
            if (!this._geo) this._geo = (0, $edd42ab1a70aa2aa$export$2e2bcd8739ae039).createGeo3D(this);
            var region = this._geo.getRegion(name);
            var ret = [];
            for(var k = 0; k < region.geometries.length; k++){
                var geo = region.geometries[k];
                var interiors = [];
                var exterior = $c394516103eca2d4$var$transformPolygon(coordSys, geo.exterior);
                if (interiors && interiors.length) for(var m = 0; m < geo.interiors.length; m++)interiors.push($c394516103eca2d4$var$transformPolygon(coordSys, interiors[m]));
                ret.push({
                    interiors: interiors,
                    exterior: exterior
                });
            }
            return ret;
        }
    },
    /**
   * Format label
   * @param {string} name Region name
   * @param {string} [status='normal'] 'normal' or 'emphasis'
   * @return {string}
   */ getFormattedLabel: function(dataIndex, status) {
        var text = (0, $308e5bdbc7337a3a$export$2e2bcd8739ae039).getFormattedLabel(this, dataIndex, status);
        if (text == null) text = this.getData().getName(dataIndex);
        return text;
    },
    defaultOption: {
        // Support geo3D, mapbox, maptalks3D
        coordinateSystem: "geo3D",
        // itemStyle: {},
        // height,
        // label: {}
        data: null
    }
});
$224386f1517b5dca$exports.merge($c394516103eca2d4$var$Map3DSeries.prototype, (0, $d7d7dac625531b9b$export$2e2bcd8739ae039));
$224386f1517b5dca$exports.merge($c394516103eca2d4$var$Map3DSeries.prototype, (0, $a589af99ac3423f7$export$2e2bcd8739ae039));
$224386f1517b5dca$exports.merge($c394516103eca2d4$var$Map3DSeries.prototype, (0, $2d5450eeb3d59d52$export$2e2bcd8739ae039));
$224386f1517b5dca$exports.merge($c394516103eca2d4$var$Map3DSeries.prototype, (0, $39dfcb89b5cc4a69$export$2e2bcd8739ae039));
$224386f1517b5dca$exports.merge($c394516103eca2d4$var$Map3DSeries.prototype, (0, $f866f5803ca3a09a$export$2e2bcd8739ae039));
var $c394516103eca2d4$export$2e2bcd8739ae039 = $c394516103eca2d4$var$Map3DSeries;







var $00985daa7393c5b3$export$2e2bcd8739ae039 = $0dc5061053e23cd3$export$2e2bcd8739ae039.extend({
    type: "map3D",
    __ecgl__: true,
    init: function(ecModel, api) {
        this._geo3DBuilder = new (0, $5a38c1b2963f6585$export$2e2bcd8739ae039)(api);
        this.groupGL = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
    },
    render: function(map3DModel, ecModel, api) {
        var coordSys = map3DModel.coordinateSystem;
        if (!coordSys || !coordSys.viewGL) return;
        this.groupGL.add(this._geo3DBuilder.rootNode);
        coordSys.viewGL.add(this.groupGL);
        var geo3D;
        if (coordSys.type === "geo3D") {
            geo3D = coordSys;
            if (!this._sceneHelper) {
                this._sceneHelper = new (0, $ace7021e37e6bf94$export$2e2bcd8739ae039)();
                this._sceneHelper.initLight(this.groupGL);
            }
            this._sceneHelper.setScene(coordSys.viewGL.scene);
            this._sceneHelper.updateLight(map3DModel); // Set post effect
            coordSys.viewGL.setPostEffect(map3DModel.getModel("postEffect"), api);
            coordSys.viewGL.setTemporalSuperSampling(map3DModel.getModel("temporalSuperSampling"));
            var control = this._control;
            if (!control) {
                control = this._control = new (0, $885dfecb57787ce0$export$2e2bcd8739ae039)({
                    zr: api.getZr()
                });
                this._control.init();
            }
            var viewControlModel = map3DModel.getModel("viewControl");
            control.setViewGL(coordSys.viewGL);
            control.setFromViewControlModel(viewControlModel, 0);
            control.off("update");
            control.on("update", function() {
                api.dispatchAction({
                    type: "map3DChangeCamera",
                    alpha: control.getAlpha(),
                    beta: control.getBeta(),
                    distance: control.getDistance(),
                    from: this.uid,
                    map3DId: map3DModel.id
                });
            });
            this._geo3DBuilder.extrudeY = true;
        } else {
            if (this._control) {
                this._control.dispose();
                this._control = null;
            }
            if (this._sceneHelper) {
                this._sceneHelper.dispose();
                this._sceneHelper = null;
            }
            geo3D = map3DModel.getData().getLayout("geo3D");
            this._geo3DBuilder.extrudeY = false;
        }
        this._geo3DBuilder.update(map3DModel, ecModel, api, 0, map3DModel.getData().count()); // Must update after geo3D.viewGL.setPostEffect to determine linear space
        var srgbDefineMethod = coordSys.viewGL.isLinearSpace() ? "define" : "undefine";
        this._geo3DBuilder.rootNode.traverse(function(mesh) {
            if (mesh.material) mesh.material[srgbDefineMethod]("fragment", "SRGB_DECODE");
        });
    },
    afterRender: function(map3DModel, ecModel, api, layerGL) {
        var renderer = layerGL.renderer;
        var coordSys = map3DModel.coordinateSystem;
        if (coordSys && coordSys.type === "geo3D") {
            this._sceneHelper.updateAmbientCubemap(renderer, map3DModel, api);
            this._sceneHelper.updateSkybox(renderer, map3DModel, api);
        }
    },
    dispose: function() {
        this.groupGL.removeAll();
        this._control.dispose();
        this._geo3DBuilder.dispose();
    }
});



function $9e7aee4cc3f97ce7$export$4b3e715f166fdd78(registers) {
    // Depends on geo3d
    (0, $165543c14f960069$export$4b3e715f166fdd78)(registers);
    registers.registerChartView((0, $00985daa7393c5b3$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $c394516103eca2d4$export$2e2bcd8739ae039));
    registers.registerAction({
        type: "map3DChangeCamera",
        event: "map3dcamerachanged",
        update: "series:updateCamera"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "series",
            subType: "map3D",
            query: payload
        }, function(componentModel) {
            componentModel.setView(payload);
        });
    });
}


(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $9e7aee4cc3f97ce7$export$4b3e715f166fdd78));



// TODO ECharts GL must be imported whatever component,charts is imported.


var $37e8d80338781050$export$2e2bcd8739ae039 = $7c10febb2cdef0d8$export$2e2bcd8739ae039.extend({
    type: "series.scatterGL",
    dependencies: [
        "grid",
        "polar",
        "geo",
        "singleAxis"
    ],
    visualStyleAccessPath: "itemStyle",
    hasSymbolVisual: true,
    getInitialData: function() {
        return $9a616079ee96a3f3$exports.createList(this);
    },
    defaultOption: {
        coordinateSystem: "cartesian2d",
        zlevel: 10,
        progressive: 1e5,
        progressiveThreshold: 1e5,
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // Polar coordinate system
        // polarIndex: 0,
        // Geo coordinate system
        // geoIndex: 0,
        large: false,
        symbol: "circle",
        symbolSize: 10,
        // symbolSize scale when zooming.
        zoomScale: 0,
        // Support source-over, lighter
        blendMode: "source-over",
        itemStyle: {
            opacity: 0.8
        },
        postEffect: {
            enable: false,
            colorCorrection: {
                exposure: 0,
                brightness: 0,
                contrast: 1,
                saturation: 1,
                enable: true
            }
        }
    }
});








function $363eede8184faa6a$var$GLViewHelper(viewGL) {
    this.viewGL = viewGL;
}
$363eede8184faa6a$var$GLViewHelper.prototype.reset = function(seriesModel, api) {
    this._updateCamera(api.getWidth(), api.getHeight(), api.getDevicePixelRatio());
    this._viewTransform = $f41ebb9dd60b55b4$export$185802fd694ee1f5();
    this.updateTransform(seriesModel, api);
};
$363eede8184faa6a$var$GLViewHelper.prototype.updateTransform = function(seriesModel, api) {
    var coordinateSystem = seriesModel.coordinateSystem;
    if (coordinateSystem.getRoamTransform) {
        $f41ebb9dd60b55b4$export$6897c284b6f9f4dc(this._viewTransform, coordinateSystem.getRoamTransform());
        this._setCameraTransform(this._viewTransform);
        api.getZr().refresh();
    }
}; // Reimplement the dataToPoint of coordinate system.
// Remove the effect of pan/zoom transform
$363eede8184faa6a$var$GLViewHelper.prototype.dataToPoint = function(coordSys, data, pt) {
    pt = coordSys.dataToPoint(data, null, pt);
    var viewTransform = this._viewTransform;
    if (viewTransform) $6de594cf8ac295ff$export$9f9dcb98c894b623(pt, pt, viewTransform);
};
/**
 * Remove transform info in point.
 */ $363eede8184faa6a$var$GLViewHelper.prototype.removeTransformInPoint = function(pt) {
    if (this._viewTransform) $6de594cf8ac295ff$export$9f9dcb98c894b623(pt, pt, this._viewTransform);
    return pt;
};
/**
 * Return number
 */ $363eede8184faa6a$var$GLViewHelper.prototype.getZoom = function() {
    if (this._viewTransform) {
        var m = this._viewTransform;
        return 1 / Math.max(Math.sqrt(m[0] * m[0] + m[1] * m[1]), Math.sqrt(m[2] * m[2] + m[3] * m[3]));
    }
    return 1;
};
$363eede8184faa6a$var$GLViewHelper.prototype._setCameraTransform = function(m) {
    var camera = this.viewGL.camera;
    camera.position.set(m[4], m[5], 0);
    camera.scale.set(Math.sqrt(m[0] * m[0] + m[1] * m[1]), Math.sqrt(m[2] * m[2] + m[3] * m[3]), 1);
};
$363eede8184faa6a$var$GLViewHelper.prototype._updateCamera = function(width, height, dpr) {
    // TODO, left, top, right, bottom
    this.viewGL.setViewport(0, 0, width, height, dpr);
    var camera = this.viewGL.camera;
    camera.left = camera.top = 0;
    camera.bottom = height;
    camera.right = width;
    camera.near = 0;
    camera.far = 100;
};
var $363eede8184faa6a$export$2e2bcd8739ae039 = $363eede8184faa6a$var$GLViewHelper;


var $5696bee912c7ef45$export$2e2bcd8739ae039 = $0dc5061053e23cd3$export$2e2bcd8739ae039.extend({
    type: "scatterGL",
    __ecgl__: true,
    init: function(ecModel, api) {
        this.groupGL = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
        this.viewGL = new (0, $7a0cfdd3f7cf77fd$export$2e2bcd8739ae039)("orthographic");
        this.viewGL.add(this.groupGL);
        this._pointsBuilderList = [];
        this._currentStep = 0;
        this._sizeScale = 1;
        this._glViewHelper = new (0, $363eede8184faa6a$export$2e2bcd8739ae039)(this.viewGL);
    },
    render: function(seriesModel, ecModel, api) {
        this.groupGL.removeAll();
        this._glViewHelper.reset(seriesModel, api);
        if (!seriesModel.getData().count()) return;
        var pointsBuilder = this._pointsBuilderList[0];
        if (!pointsBuilder) pointsBuilder = this._pointsBuilderList[0] = new (0, $ba74e03882df50b1$export$2e2bcd8739ae039)(true, api);
        this._pointsBuilderList.length = 1;
        this.groupGL.add(pointsBuilder.rootNode);
        this._removeTransformInPoints(seriesModel.getData().getLayout("points"));
        pointsBuilder.update(seriesModel, ecModel, api);
        this.viewGL.setPostEffect(seriesModel.getModel("postEffect"), api);
    },
    incrementalPrepareRender: function(seriesModel, ecModel, api) {
        this.groupGL.removeAll();
        this._glViewHelper.reset(seriesModel, api);
        this._currentStep = 0;
        this.viewGL.setPostEffect(seriesModel.getModel("postEffect"), api);
    },
    incrementalRender: function(params, seriesModel, ecModel, api) {
        if (params.end <= params.start) return;
        var pointsBuilder = this._pointsBuilderList[this._currentStep];
        if (!pointsBuilder) {
            pointsBuilder = new (0, $ba74e03882df50b1$export$2e2bcd8739ae039)(true, api);
            this._pointsBuilderList[this._currentStep] = pointsBuilder;
        }
        this.groupGL.add(pointsBuilder.rootNode);
        this._removeTransformInPoints(seriesModel.getData().getLayout("points"));
        pointsBuilder.setSizeScale(this._sizeScale);
        pointsBuilder.update(seriesModel, ecModel, api, params.start, params.end);
        api.getZr().refresh();
        this._currentStep++;
    },
    updateTransform: function(seriesModel, ecModel, api) {
        if (seriesModel.coordinateSystem.getRoamTransform) {
            this._glViewHelper.updateTransform(seriesModel, api);
            var zoom = this._glViewHelper.getZoom();
            var sizeScale = Math.max((seriesModel.get("zoomScale") || 0) * (zoom - 1) + 1, 0);
            this._sizeScale = sizeScale;
            this._pointsBuilderList.forEach(function(pointsBuilder) {
                pointsBuilder.setSizeScale(sizeScale);
            });
        }
    },
    _removeTransformInPoints: function(points) {
        if (!points) return;
        var pt = [];
        for(var i = 0; i < points.length; i += 2){
            pt[0] = points[i];
            pt[1] = points[i + 1];
            this._glViewHelper.removeTransformInPoint(pt);
            points[i] = pt[0];
            points[i + 1] = pt[1];
        }
    },
    dispose: function() {
        this.groupGL.removeAll();
        this._pointsBuilderList.forEach(function(pointsBuilder) {
            pointsBuilder.dispose();
        });
    },
    remove: function() {
        this.groupGL.removeAll();
    }
});


function $fa8f6ea4a645381b$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $5696bee912c7ef45$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $37e8d80338781050$export$2e2bcd8739ae039));
    registers.registerLayout({
        seriesType: "scatterGL",
        reset: function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            var data = seriesModel.getData();
            var progress;
            if (coordSys) {
                var dims = coordSys.dimensions.map(function(dim) {
                    return data.mapDimension(dim);
                }).slice(0, 2);
                var pt = [];
                if (dims.length === 1) progress = function(params) {
                    var points = new Float32Array((params.end - params.start) * 2);
                    for(var idx = params.start; idx < params.end; idx++){
                        var offset = (idx - params.start) * 2;
                        var x = data.get(dims[0], idx);
                        var pt = coordSys.dataToPoint(x);
                        points[offset] = pt[0];
                        points[offset + 1] = pt[1];
                    }
                    data.setLayout("points", points);
                };
                else if (dims.length === 2) progress = function(params) {
                    var points = new Float32Array((params.end - params.start) * 2);
                    for(var idx = params.start; idx < params.end; idx++){
                        var offset = (idx - params.start) * 2;
                        var x = data.get(dims[0], idx);
                        var y = data.get(dims[1], idx);
                        pt[0] = x;
                        pt[1] = y;
                        pt = coordSys.dataToPoint(pt);
                        points[offset] = pt[0];
                        points[offset + 1] = pt[1];
                    }
                    data.setLayout("points", points);
                };
            }
            return {
                progress: progress
            };
        }
    });
}


(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $fa8f6ea4a645381b$export$4b3e715f166fdd78));



// TODO ECharts GL must be imported whatever component,charts is imported.





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO: this module is only for compatibility with echarts-gl

var $71a8125a37225b67$export$2e2bcd8739ae039 = (0, $4a8451eb7786c849$export$2e2bcd8739ae039);



function $c0a9362ff78a616f$export$2e2bcd8739ae039(nodes, edges, hostModel, directed, beforeLink) {
    var graph = new (0, $7e67f74238c90217$export$2e2bcd8739ae039)(directed);
    for(var i = 0; i < nodes.length; i++)graph.addNode((0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(nodes[i].id, nodes[i].name, i), i);
    var linkNameList = [];
    var validEdges = [];
    var linkCount = 0;
    for(var i = 0; i < edges.length; i++){
        var link = edges[i];
        var source = link.source;
        var target = link.target; // addEdge may fail when source or target not exists
        if (graph.addEdge(source, target, linkCount)) {
            validEdges.push(link);
            linkNameList.push((0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(link.id, source + " > " + target));
            linkCount++;
        }
    }
    var nodeData; // FIXME, support more coordinate systems.
    var dimensionNames = $9a616079ee96a3f3$exports.createDimensions(nodes, {
        coordDimensions: [
            "value"
        ]
    });
    nodeData = new $0ab0556b819346fd$export$2e2bcd8739ae039(dimensionNames, hostModel);
    nodeData.initData(nodes);
    var edgeData = new $0ab0556b819346fd$export$2e2bcd8739ae039([
        "value"
    ], hostModel);
    edgeData.initData(validEdges, linkNameList);
    beforeLink && beforeLink(nodeData, edgeData);
    (0, $71a8125a37225b67$export$2e2bcd8739ae039)({
        mainData: nodeData,
        struct: graph,
        structAttr: "graph",
        datas: {
            node: nodeData,
            edge: edgeData
        },
        datasAttr: {
            node: "data",
            edge: "edgeData"
        }
    }); // Update dataIndex of nodes and edges because invalid edge may be removed
    graph.update();
    return graph;
}



var $dbebea644a870a83$var$GraphSeries = $7c10febb2cdef0d8$export$2e2bcd8739ae039.extend({
    type: "series.graphGL",
    visualStyleAccessPath: "itemStyle",
    hasSymbolVisual: true,
    init: function(option) {
        $dbebea644a870a83$var$GraphSeries.superApply(this, "init", arguments); // Provide data for legend select
        this.legendDataProvider = function() {
            return this._categoriesData;
        };
        this._updateCategoriesData();
    },
    mergeOption: function(option) {
        $dbebea644a870a83$var$GraphSeries.superApply(this, "mergeOption", arguments);
        this._updateCategoriesData();
    },
    getFormattedLabel: function(dataIndex, status, dataType, dimIndex) {
        var text = (0, $308e5bdbc7337a3a$export$2e2bcd8739ae039).getFormattedLabel(this, dataIndex, status, dataType, dimIndex);
        if (text == null) {
            var data = this.getData();
            var lastDim = data.dimensions[data.dimensions.length - 1];
            text = data.get(lastDim, dataIndex);
        }
        return text;
    },
    getInitialData: function(option, ecModel) {
        var edges = option.edges || option.links || [];
        var nodes = option.data || option.nodes || [];
        var self = this;
        if (nodes && edges) return (0, $c0a9362ff78a616f$export$2e2bcd8739ae039)(nodes, edges, this, true, beforeLink).data;
        function beforeLink(nodeData, edgeData) {
            // Overwrite nodeData.getItemModel to
            nodeData.wrapMethod("getItemModel", function(model) {
                const categoriesModels = self._categoriesModels;
                const categoryIdx = model.getShallow("category");
                const categoryModel = categoriesModels[categoryIdx];
                if (categoryModel) {
                    categoryModel.parentModel = model.parentModel;
                    model.parentModel = categoryModel;
                }
                return model;
            }); // TODO Inherit resolveParentPath by default in Model#getModel?
            const oldGetModel = ecModel.getModel([]).getModel;
            function newGetModel(path, parentModel) {
                const model = oldGetModel.call(this, path, parentModel);
                model.resolveParentPath = resolveParentPath;
                return model;
            }
            edgeData.wrapMethod("getItemModel", function(model) {
                model.resolveParentPath = resolveParentPath;
                model.getModel = newGetModel;
                return model;
            });
            function resolveParentPath(pathArr) {
                if (pathArr && (pathArr[0] === "label" || pathArr[1] === "label")) {
                    const newPathArr = pathArr.slice();
                    if (pathArr[0] === "label") newPathArr[0] = "edgeLabel";
                    else if (pathArr[1] === "label") newPathArr[1] = "edgeLabel";
                    return newPathArr;
                }
                return pathArr;
            }
        }
    },
    /**
   * @return {module:echarts/data/Graph}
   */ getGraph: function() {
        return this.getData().graph;
    },
    /**
   * @return {module:echarts/data/List}
   */ getEdgeData: function() {
        return this.getGraph().edgeData;
    },
    /**
   * @return {module:echarts/data/List}
   */ getCategoriesData: function() {
        return this._categoriesData;
    },
    /**
   * @override
   */ formatTooltip: function(dataIndex, multipleSeries, dataType) {
        if (dataType === "edge") {
            var nodeData = this.getData();
            var params = this.getDataParams(dataIndex, dataType);
            var edge = nodeData.graph.getEdgeByIndex(dataIndex);
            var sourceName = nodeData.getName(edge.node1.dataIndex);
            var targetName = nodeData.getName(edge.node2.dataIndex);
            var html = [];
            sourceName != null && html.push(sourceName);
            targetName != null && html.push(targetName);
            html = $8eb0e968d6dc83bc$exports.encodeHTML(html.join(" > "));
            if (params.value) html += " : " + $8eb0e968d6dc83bc$exports.encodeHTML(params.value);
            return html;
        } else // dataType === 'node' or empty
        return $dbebea644a870a83$var$GraphSeries.superApply(this, "formatTooltip", arguments);
    },
    _updateCategoriesData: function() {
        var categories = (this.option.categories || []).map(function(category) {
            // Data must has value
            return category.value != null ? category : Object.assign({
                value: 0
            }, category);
        });
        var categoriesData = new $0ab0556b819346fd$export$2e2bcd8739ae039([
            "value"
        ], this);
        categoriesData.initData(categories);
        this._categoriesData = categoriesData;
        this._categoriesModels = categoriesData.mapArray(function(idx) {
            return categoriesData.getItemModel(idx, true);
        });
    },
    setView: function(payload) {
        if (payload.zoom != null) this.option.zoom = payload.zoom;
        if (payload.offset != null) this.option.offset = payload.offset;
    },
    setNodePosition: function(points) {
        for(var i = 0; i < points.length / 2; i++){
            var x = points[i * 2];
            var y = points[i * 2 + 1];
            var opt = this.getData().getRawDataItem(i);
            opt.x = x;
            opt.y = y;
        }
    },
    isAnimationEnabled: function() {
        return $dbebea644a870a83$var$GraphSeries.superCall(this, "isAnimationEnabled") // Not enable animation when do force layout
         && !(this.get("layout") === "force" && this.get("force.layoutAnimation"));
    },
    defaultOption: {
        zlevel: 10,
        z: 2,
        legendHoverLink: true,
        // Only support forceAtlas2
        layout: "forceAtlas2",
        // Configuration of force directed layout
        forceAtlas2: {
            initLayout: null,
            GPU: true,
            steps: 1,
            // barnesHutOptimize
            // Maxp layout steps.
            maxSteps: 1000,
            repulsionByDegree: true,
            linLogMode: false,
            strongGravityMode: false,
            gravity: 1.0,
            // scaling: 1.0,
            edgeWeightInfluence: 1.0,
            // Edge weight range.
            edgeWeight: [
                1,
                4
            ],
            // Node weight range.
            nodeWeight: [
                1,
                4
            ],
            // jitterTolerence: 0.1,
            preventOverlap: false,
            gravityCenter: null
        },
        focusNodeAdjacency: true,
        focusNodeAdjacencyOn: "mouseover",
        left: "center",
        top: "center",
        // right: null,
        // bottom: null,
        // width: '80%',
        // height: '80%',
        symbol: "circle",
        symbolSize: 5,
        roam: false,
        // Default on center of graph
        center: null,
        zoom: 1,
        // categories: [],
        // data: []
        // Or
        // nodes: []
        //
        // links: []
        // Or
        // edges: []
        label: {
            show: false,
            formatter: "{b}",
            position: "right",
            distance: 5,
            textStyle: {
                fontSize: 14
            }
        },
        itemStyle: {},
        lineStyle: {
            color: "#aaa",
            width: 1,
            opacity: 0.5
        },
        emphasis: {
            label: {
                show: true
            }
        },
        animation: false
    }
});
var $dbebea644a870a83$export$2e2bcd8739ae039 = $dbebea644a870a83$var$GraphSeries;






/**
 * Lines geometry
 * Use screen space projected lines lineWidth > MAX_LINE_WIDTH
 * https://mattdesl.svbtle.com/drawing-lines-is-hard
 * @module echarts-gl/util/geometry/LinesGeometry
 * @author Yi Shen(http://github.com/pissang)
 */ 



var $9168b5292959c78e$var$vec2 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).vec2; // var CURVE_RECURSION_LIMIT = 8;
// var CURVE_COLLINEAR_EPSILON = 40;
var $9168b5292959c78e$var$sampleLinePoints = [
    [
        0,
        0
    ],
    [
        1,
        1
    ]
];
/**
 * @constructor
 * @alias module:echarts-gl/util/geometry/LinesGeometry
 * @extends clay.Geometry
 */ var $9168b5292959c78e$var$LinesGeometry = (0, $c75c69a759bf7591$export$2e2bcd8739ae039).extend(function() {
    return {
        segmentScale: 4,
        dynamic: true,
        /**
     * Need to use mesh to expand lines if lineWidth > MAX_LINE_WIDTH
     */ useNativeLine: true,
        attributes: {
            position: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("position", "float", 2, "POSITION"),
            normal: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("normal", "float", 2),
            offset: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("offset", "float", 1),
            color: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("color", "float", 4, "COLOR")
        }
    };
}, /** @lends module: echarts-gl/util/geometry/LinesGeometry.prototype */ {
    /**
   * Reset offset
   */ resetOffset: function() {
        this._vertexOffset = 0;
        this._faceOffset = 0;
        this._itemVertexOffsets = [];
    },
    /**
   * @param {number} nVertex
   */ setVertexCount: function(nVertex) {
        var attributes = this.attributes;
        if (this.vertexCount !== nVertex) {
            attributes.position.init(nVertex);
            attributes.color.init(nVertex);
            if (!this.useNativeLine) {
                attributes.offset.init(nVertex);
                attributes.normal.init(nVertex);
            }
            if (nVertex > 0xffff) {
                if (this.indices instanceof Uint16Array) this.indices = new Uint32Array(this.indices);
            } else if (this.indices instanceof Uint32Array) this.indices = new Uint16Array(this.indices);
        }
    },
    /**
   * @param {number} nTriangle
   */ setTriangleCount: function(nTriangle) {
        if (this.triangleCount !== nTriangle) {
            if (nTriangle === 0) this.indices = null;
            else this.indices = this.vertexCount > 0xffff ? new Uint32Array(nTriangle * 3) : new Uint16Array(nTriangle * 3);
        }
    },
    _getCubicCurveApproxStep: function(p0, p1, p2, p3) {
        var len = $9168b5292959c78e$var$vec2.dist(p0, p1) + $9168b5292959c78e$var$vec2.dist(p2, p1) + $9168b5292959c78e$var$vec2.dist(p3, p2);
        var step = 1 / (len + 1) * this.segmentScale;
        return step;
    },
    /**
   * Get vertex count of cubic curve
   * @param {Array.<number>} p0
   * @param {Array.<number>} p1
   * @param {Array.<number>} p2
   * @param {Array.<number>} p3
   * @return number
   */ getCubicCurveVertexCount: function(p0, p1, p2, p3) {
        var step = this._getCubicCurveApproxStep(p0, p1, p2, p3);
        var segCount = Math.ceil(1 / step);
        if (!this.useNativeLine) return segCount * 2 + 2;
        else return segCount * 2;
    },
    /**
   * Get face count of cubic curve
   * @param {Array.<number>} p0
   * @param {Array.<number>} p1
   * @param {Array.<number>} p2
   * @param {Array.<number>} p3
   * @return number
   */ getCubicCurveTriangleCount: function(p0, p1, p2, p3) {
        var step = this._getCubicCurveApproxStep(p0, p1, p2, p3);
        var segCount = Math.ceil(1 / step);
        if (!this.useNativeLine) return segCount * 2;
        else return 0;
    },
    /**
   * Get vertex count of line
   * @return {number}
   */ getLineVertexCount: function() {
        return this.getPolylineVertexCount($9168b5292959c78e$var$sampleLinePoints);
    },
    /**
   * Get face count of line
   * @return {number}
   */ getLineTriangleCount: function() {
        return this.getPolylineTriangleCount($9168b5292959c78e$var$sampleLinePoints);
    },
    /**
   * Get how many vertices will polyline take.
   * @type {number|Array} points Can be a 1d/2d list of points, or a number of points amount.
   * @return {number}
   */ getPolylineVertexCount: function(points) {
        var pointsLen;
        if (typeof points === "number") pointsLen = points;
        else {
            var is2DArray = typeof points[0] !== "number";
            pointsLen = is2DArray ? points.length : points.length / 2;
        }
        return !this.useNativeLine ? (pointsLen - 1) * 2 + 2 : (pointsLen - 1) * 2;
    },
    /**
   * Get how many triangles will polyline take.
   * @type {number|Array} points Can be a 1d/2d list of points, or a number of points amount.
   * @return {number}
   */ getPolylineTriangleCount: function(points) {
        var pointsLen;
        if (typeof points === "number") pointsLen = points;
        else {
            var is2DArray = typeof points[0] !== "number";
            pointsLen = is2DArray ? points.length : points.length / 2;
        }
        return !this.useNativeLine ? (pointsLen - 1) * 2 : 0;
    },
    /**
   * Add a cubic curve
   * @param {Array.<number>} p0
   * @param {Array.<number>} p1
   * @param {Array.<number>} p2
   * @param {Array.<number>} p3
   * @param {Array.<number>} color
   * @param {number} [lineWidth=1]
   */ addCubicCurve: function(p0, p1, p2, p3, color, lineWidth) {
        if (lineWidth == null) lineWidth = 1;
         // incremental interpolation
        // http://antigrain.com/research/bezier_interpolation/index.html#PAGE_BEZIER_INTERPOLATION
        var x0 = p0[0], y0 = p0[1];
        var x1 = p1[0], y1 = p1[1];
        var x2 = p2[0], y2 = p2[1];
        var x3 = p3[0], y3 = p3[1];
        var step = this._getCubicCurveApproxStep(p0, p1, p2, p3);
        var step2 = step * step;
        var step3 = step2 * step;
        var pre1 = 3.0 * step;
        var pre2 = 3.0 * step2;
        var pre4 = 6.0 * step2;
        var pre5 = 6.0 * step3;
        var tmp1x = x0 - x1 * 2.0 + x2;
        var tmp1y = y0 - y1 * 2.0 + y2;
        var tmp2x = (x1 - x2) * 3.0 - x0 + x3;
        var tmp2y = (y1 - y2) * 3.0 - y0 + y3;
        var fx = x0;
        var fy = y0;
        var dfx = (x1 - x0) * pre1 + tmp1x * pre2 + tmp2x * step3;
        var dfy = (y1 - y0) * pre1 + tmp1y * pre2 + tmp2y * step3;
        var ddfx = tmp1x * pre4 + tmp2x * pre5;
        var ddfy = tmp1y * pre4 + tmp2y * pre5;
        var dddfx = tmp2x * pre5;
        var dddfy = tmp2y * pre5;
        var t = 0;
        var k = 0;
        var segCount = Math.ceil(1 / step);
        var points = new Float32Array((segCount + 1) * 3);
        var points = [];
        var offset = 0;
        for(var k = 0; k < segCount + 1; k++){
            points[offset++] = fx;
            points[offset++] = fy;
            fx += dfx;
            fy += dfy;
            dfx += ddfx;
            dfy += ddfy;
            ddfx += dddfx;
            ddfy += dddfy;
            t += step;
            if (t > 1) {
                fx = dfx > 0 ? Math.min(fx, x3) : Math.max(fx, x3);
                fy = dfy > 0 ? Math.min(fy, y3) : Math.max(fy, y3);
            }
        }
        this.addPolyline(points, color, lineWidth);
    },
    /**
   * Add a straight line
   * @param {Array.<number>} p0
   * @param {Array.<number>} p1
   * @param {Array.<number>} color
   * @param {number} [lineWidth=1]
   */ addLine: function(p0, p1, color, lineWidth) {
        this.addPolyline([
            p0,
            p1
        ], color, lineWidth);
    },
    /**
   * Add a straight line
   * @param {Array.<Array> | Array.<number>} points
   * @param {Array.<number> | Array.<Array>} color
   * @param {number} [lineWidth=1]
   * @param {number} [arrayOffset=0]
   * @param {number} [pointsCount] Default to be amount of points in the first argument
   */ addPolyline: function() {
        var dirA = $9168b5292959c78e$var$vec2.create();
        var dirB = $9168b5292959c78e$var$vec2.create();
        var normal = $9168b5292959c78e$var$vec2.create();
        var tangent = $9168b5292959c78e$var$vec2.create();
        var point = [], nextPoint = [], prevPoint = [];
        return function(points, color, lineWidth, arrayOffset, pointsCount) {
            if (!points.length) return;
            var is2DArray = typeof points[0] !== "number";
            if (pointsCount == null) pointsCount = is2DArray ? points.length : points.length / 2;
            if (pointsCount < 2) return;
            if (arrayOffset == null) arrayOffset = 0;
            if (lineWidth == null) lineWidth = 1;
            this._itemVertexOffsets.push(this._vertexOffset);
            var notSharingColor = is2DArray ? typeof color[0] !== "number" : color.length / 4 === pointsCount;
            var positionAttr = this.attributes.position;
            var colorAttr = this.attributes.color;
            var offsetAttr = this.attributes.offset;
            var normalAttr = this.attributes.normal;
            var indices = this.indices;
            var vertexOffset = this._vertexOffset;
            var pointColor;
            for(var k = 0; k < pointsCount; k++){
                if (is2DArray) {
                    point = points[k + arrayOffset];
                    if (notSharingColor) pointColor = color[k + arrayOffset];
                    else pointColor = color;
                } else {
                    var k2 = k * 2 + arrayOffset;
                    point = point || [];
                    point[0] = points[k2];
                    point[1] = points[k2 + 1];
                    if (notSharingColor) {
                        var k4 = k * 4 + arrayOffset;
                        pointColor = pointColor || [];
                        pointColor[0] = color[k4];
                        pointColor[1] = color[k4 + 1];
                        pointColor[2] = color[k4 + 2];
                        pointColor[3] = color[k4 + 3];
                    } else pointColor = color;
                }
                if (!this.useNativeLine) {
                    var offset;
                    if (k < pointsCount - 1) {
                        if (is2DArray) $9168b5292959c78e$var$vec2.copy(nextPoint, points[k + 1]);
                        else {
                            var k2 = (k + 1) * 2 + arrayOffset;
                            nextPoint = nextPoint || [];
                            nextPoint[0] = points[k2];
                            nextPoint[1] = points[k2 + 1];
                        } // TODO In case dir is (0, 0)
                        // TODO miterLimit
                        if (k > 0) {
                            $9168b5292959c78e$var$vec2.sub(dirA, point, prevPoint);
                            $9168b5292959c78e$var$vec2.sub(dirB, nextPoint, point);
                            $9168b5292959c78e$var$vec2.normalize(dirA, dirA);
                            $9168b5292959c78e$var$vec2.normalize(dirB, dirB);
                            $9168b5292959c78e$var$vec2.add(tangent, dirA, dirB);
                            $9168b5292959c78e$var$vec2.normalize(tangent, tangent);
                            var miter = lineWidth / 2 * Math.min(1 / $9168b5292959c78e$var$vec2.dot(dirA, tangent), 2);
                            normal[0] = -tangent[1];
                            normal[1] = tangent[0];
                            offset = miter;
                        } else {
                            $9168b5292959c78e$var$vec2.sub(dirA, nextPoint, point);
                            $9168b5292959c78e$var$vec2.normalize(dirA, dirA);
                            normal[0] = -dirA[1];
                            normal[1] = dirA[0];
                            offset = lineWidth / 2;
                        }
                    } else {
                        $9168b5292959c78e$var$vec2.sub(dirA, point, prevPoint);
                        $9168b5292959c78e$var$vec2.normalize(dirA, dirA);
                        normal[0] = -dirA[1];
                        normal[1] = dirA[0];
                        offset = lineWidth / 2;
                    }
                    normalAttr.set(vertexOffset, normal);
                    normalAttr.set(vertexOffset + 1, normal);
                    offsetAttr.set(vertexOffset, offset);
                    offsetAttr.set(vertexOffset + 1, -offset);
                    $9168b5292959c78e$var$vec2.copy(prevPoint, point);
                    positionAttr.set(vertexOffset, point);
                    positionAttr.set(vertexOffset + 1, point);
                    colorAttr.set(vertexOffset, pointColor);
                    colorAttr.set(vertexOffset + 1, pointColor);
                    vertexOffset += 2;
                } else if (k > 1) {
                    positionAttr.copy(vertexOffset, vertexOffset - 1);
                    colorAttr.copy(vertexOffset, vertexOffset - 1);
                    vertexOffset++;
                }
                if (!this.useNativeLine) {
                    if (k > 0) {
                        var idx3 = this._faceOffset * 3;
                        var indices = this.indices; // 0-----2
                        // 1-----3
                        // 0->1->2, 1->3->2
                        indices[idx3] = vertexOffset - 4;
                        indices[idx3 + 1] = vertexOffset - 3;
                        indices[idx3 + 2] = vertexOffset - 2;
                        indices[idx3 + 3] = vertexOffset - 3;
                        indices[idx3 + 4] = vertexOffset - 1;
                        indices[idx3 + 5] = vertexOffset - 2;
                        this._faceOffset += 2;
                    }
                } else {
                    colorAttr.set(vertexOffset, pointColor);
                    positionAttr.set(vertexOffset, point);
                    vertexOffset++;
                }
            }
            this._vertexOffset = vertexOffset;
        };
    }(),
    /**
   * Set color of single line.
   */ setItemColor: function(idx, color) {
        var startOffset = this._itemVertexOffsets[idx];
        var endOffset = idx < this._itemVertexOffsets.length - 1 ? this._itemVertexOffsets[idx + 1] : this._vertexOffset;
        for(var i = startOffset; i < endOffset; i++)this.attributes.color.set(i, color);
        this.dirty("color");
    }
});
$224386f1517b5dca$exports.defaults($9168b5292959c78e$var$LinesGeometry.prototype, (0, $5c3dce311da2ccea$export$2e2bcd8739ae039));
var $9168b5292959c78e$export$2e2bcd8739ae039 = $9168b5292959c78e$var$LinesGeometry;






var $89b95669bdab6b86$export$2e2bcd8739ae039 = "@export ecgl.forceAtlas2.updateNodeRepulsion\n\n#define NODE_COUNT 0\n\nuniform sampler2D positionTex;\n\nuniform vec2 textureSize;\nuniform float gravity;\nuniform float scaling;\nuniform vec2 gravityCenter;\n\nuniform bool strongGravityMode;\nuniform bool preventOverlap;\n\nvarying vec2 v_Texcoord;\n\nvoid main() {\n\n vec4 n0 = texture2D(positionTex, v_Texcoord);\n\n vec2 force = vec2(0.0);\n for (int i = 0; i < NODE_COUNT; i++) {\n vec2 uv = vec2(\n mod(float(i), textureSize.x) / (textureSize.x - 1.0),\n floor(float(i) / textureSize.x) / (textureSize.y - 1.0)\n );\n vec4 n1 = texture2D(positionTex, uv);\n\n vec2 dir = n0.xy - n1.xy;\n float d2 = dot(dir, dir);\n\n if (d2 > 0.0) {\n float factor = 0.0;\n if (preventOverlap) {\n float d = sqrt(d2);\n d = d - n0.w - n1.w;\n if (d > 0.0) {\n factor = scaling * n0.z * n1.z / (d * d);\n }\n else if (d < 0.0) {\n factor = scaling * 100.0 * n0.z * n1.z;\n }\n }\n else {\n factor = scaling * n0.z * n1.z / d2;\n }\n force += dir * factor;\n }\n }\n\n vec2 dir = gravityCenter - n0.xy;\n float d = 1.0;\n if (!strongGravityMode) {\n d = length(dir);\n }\n\n force += dir * n0.z * gravity / (d + 1.0);\n\n gl_FragColor = vec4(force, 0.0, 1.0);\n}\n@end\n\n@export ecgl.forceAtlas2.updateEdgeAttraction.vertex\n\nattribute vec2 node1;\nattribute vec2 node2;\nattribute float weight;\n\nuniform sampler2D positionTex;\nuniform float edgeWeightInfluence;\nuniform bool preventOverlap;\nuniform bool linLogMode;\n\nuniform vec2 windowSize: WINDOW_SIZE;\n\nvarying vec2 v_Force;\n\nvoid main() {\n\n vec4 n0 = texture2D(positionTex, node1);\n vec4 n1 = texture2D(positionTex, node2);\n\n vec2 dir = n1.xy - n0.xy;\n float d = length(dir);\n float w;\n if (edgeWeightInfluence == 0.0) {\n w = 1.0;\n }\n else if (edgeWeightInfluence == 1.0) {\n w = weight;\n }\n else {\n w = pow(weight, edgeWeightInfluence);\n }\n vec2 offset = vec2(1.0 / windowSize.x, 1.0 / windowSize.y);\n vec2 scale = vec2((windowSize.x - 1.0) / windowSize.x, (windowSize.y - 1.0) / windowSize.y);\n vec2 pos = node1 * scale * 2.0 - 1.0;\n gl_Position = vec4(pos + offset, 0.0, 1.0);\n gl_PointSize = 1.0;\n\n float factor;\n if (preventOverlap) {\n d = d - n1.w - n0.w;\n }\n if (d <= 0.0) {\n v_Force = vec2(0.0);\n return;\n }\n\n if (linLogMode) {\n factor = w * log(d) / d;\n }\n else {\n factor = w;\n }\n v_Force = dir * factor;\n}\n@end\n\n@export ecgl.forceAtlas2.updateEdgeAttraction.fragment\n\nvarying vec2 v_Force;\n\nvoid main() {\n gl_FragColor = vec4(v_Force, 0.0, 0.0);\n}\n@end\n\n@export ecgl.forceAtlas2.calcWeightedSum.vertex\n\nattribute vec2 node;\n\nvarying vec2 v_NodeUv;\n\nvoid main() {\n\n v_NodeUv = node;\n gl_Position = vec4(0.0, 0.0, 0.0, 1.0);\n gl_PointSize = 1.0;\n}\n@end\n\n@export ecgl.forceAtlas2.calcWeightedSum.fragment\n\nvarying vec2 v_NodeUv;\n\nuniform sampler2D positionTex;\nuniform sampler2D forceTex;\nuniform sampler2D forcePrevTex;\n\nvoid main() {\n vec2 force = texture2D(forceTex, v_NodeUv).rg;\n vec2 forcePrev = texture2D(forcePrevTex, v_NodeUv).rg;\n\n float mass = texture2D(positionTex, v_NodeUv).z;\n float swing = length(force - forcePrev) * mass;\n float traction = length(force + forcePrev) * 0.5 * mass;\n\n gl_FragColor = vec4(swing, traction, 0.0, 0.0);\n}\n@end\n\n@export ecgl.forceAtlas2.calcGlobalSpeed\n\nuniform sampler2D globalSpeedPrevTex;\nuniform sampler2D weightedSumTex;\nuniform float jitterTolerence;\n\nvoid main() {\n vec2 weightedSum = texture2D(weightedSumTex, vec2(0.5)).xy;\n float prevGlobalSpeed = texture2D(globalSpeedPrevTex, vec2(0.5)).x;\n float globalSpeed = jitterTolerence * jitterTolerence\n * weightedSum.y / weightedSum.x;\n if (prevGlobalSpeed > 0.0) {\n globalSpeed = min(globalSpeed / prevGlobalSpeed, 1.5) * prevGlobalSpeed;\n }\n gl_FragColor = vec4(globalSpeed, 0.0, 0.0, 1.0);\n}\n@end\n\n@export ecgl.forceAtlas2.updatePosition\n\nuniform sampler2D forceTex;\nuniform sampler2D forcePrevTex;\nuniform sampler2D positionTex;\nuniform sampler2D globalSpeedTex;\n\nvarying vec2 v_Texcoord;\n\nvoid main() {\n vec2 force = texture2D(forceTex, v_Texcoord).xy;\n vec2 forcePrev = texture2D(forcePrevTex, v_Texcoord).xy;\n vec4 node = texture2D(positionTex, v_Texcoord);\n\n float globalSpeed = texture2D(globalSpeedTex, vec2(0.5)).r;\n float swing = length(force - forcePrev);\n float speed = 0.1 * globalSpeed / (0.1 + globalSpeed * sqrt(swing));\n\n float df = length(force);\n if (df > 0.0) {\n speed = min(df * speed, 10.0) / df;\n\n gl_FragColor = vec4(node.xy + speed * force, node.zw);\n }\n else {\n gl_FragColor = node;\n }\n}\n@end\n\n@export ecgl.forceAtlas2.edges.vertex\nuniform mat4 worldViewProjection : WORLDVIEWPROJECTION;\n\nattribute vec2 node;\nattribute vec4 a_Color : COLOR;\nvarying vec4 v_Color;\n\nuniform sampler2D positionTex;\n\nvoid main()\n{\n gl_Position = worldViewProjection * vec4(\n texture2D(positionTex, node).xy, -10.0, 1.0\n );\n v_Color = a_Color;\n}\n@end\n\n@export ecgl.forceAtlas2.edges.fragment\nuniform vec4 color : [1.0, 1.0, 1.0, 1.0];\nvarying vec4 v_Color;\nvoid main() {\n gl_FragColor = color * v_Color;\n}\n@end";


(0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.import((0, $89b95669bdab6b86$export$2e2bcd8739ae039));
var $16049f20505649c2$var$defaultConfigs = {
    repulsionByDegree: true,
    linLogMode: false,
    strongGravityMode: false,
    gravity: 1.0,
    scaling: 1.0,
    edgeWeightInfluence: 1.0,
    jitterTolerence: 0.1,
    preventOverlap: false,
    dissuadeHubs: false,
    gravityCenter: null
};
function $16049f20505649c2$var$ForceAtlas2GPU(options) {
    var textureOpt = {
        type: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Texture.FLOAT,
        minFilter: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Texture.NEAREST,
        magFilter: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Texture.NEAREST
    };
    this._positionSourceTex = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Texture2D(textureOpt);
    this._positionSourceTex.flipY = false;
    this._positionTex = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Texture2D(textureOpt);
    this._positionPrevTex = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Texture2D(textureOpt);
    this._forceTex = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Texture2D(textureOpt);
    this._forcePrevTex = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Texture2D(textureOpt);
    this._weightedSumTex = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Texture2D(textureOpt);
    this._weightedSumTex.width = this._weightedSumTex.height = 1;
    this._globalSpeedTex = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Texture2D(textureOpt);
    this._globalSpeedPrevTex = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Texture2D(textureOpt);
    this._globalSpeedTex.width = this._globalSpeedTex.height = 1;
    this._globalSpeedPrevTex.width = this._globalSpeedPrevTex.height = 1;
    this._nodeRepulsionPass = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.source("ecgl.forceAtlas2.updateNodeRepulsion")
    });
    this._positionPass = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.source("ecgl.forceAtlas2.updatePosition")
    });
    this._globalSpeedPass = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.source("ecgl.forceAtlas2.calcGlobalSpeed")
    });
    this._copyPass = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
        fragment: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.source("clay.compositor.output")
    });
    var additiveBlend = function(gl) {
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ONE);
    };
    this._edgeForceMesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
        geometry: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Geometry({
            attributes: {
                node1: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Geometry.Attribute("node1", "float", 2),
                node2: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Geometry.Attribute("node2", "float", 2),
                weight: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Geometry.Attribute("weight", "float", 1)
            },
            dynamic: true,
            mainAttribute: "node1"
        }),
        material: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
            transparent: true,
            shader: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createShader("ecgl.forceAtlas2.updateEdgeAttraction"),
            blend: additiveBlend,
            depthMask: false,
            depthText: false
        }),
        mode: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh.POINTS
    });
    this._weightedSumMesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
        geometry: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Geometry({
            attributes: {
                node: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Geometry.Attribute("node", "float", 2)
            },
            dynamic: true,
            mainAttribute: "node"
        }),
        material: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
            transparent: true,
            shader: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createShader("ecgl.forceAtlas2.calcWeightedSum"),
            blend: additiveBlend,
            depthMask: false,
            depthText: false
        }),
        mode: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh.POINTS
    });
    this._framebuffer = new (0, $03d0b3c43006f961$export$2e2bcd8739ae039)({
        depthBuffer: false
    });
    this._dummyCamera = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).OrthographicCamera({
        left: -1,
        right: 1,
        top: 1,
        bottom: -1,
        near: 0,
        far: 100
    });
    this._globalSpeed = 0;
}
$16049f20505649c2$var$ForceAtlas2GPU.prototype.updateOption = function(options) {
    // Default config
    for(var name in $16049f20505649c2$var$defaultConfigs)this[name] = $16049f20505649c2$var$defaultConfigs[name];
     // Config according to data scale
    var nNodes = this._nodes.length;
    if (nNodes > 50000) this.jitterTolerence = 10;
    else if (nNodes > 5000) this.jitterTolerence = 1;
    else this.jitterTolerence = 0.1;
    if (nNodes > 100) this.scaling = 2.0;
    else this.scaling = 10.0;
     // this.edgeWeightInfluence = 1;
    // this.gravity = 1;
    // this.strongGravityMode = false;
    if (options) {
        for(var name in $16049f20505649c2$var$defaultConfigs)if (options[name] != null) this[name] = options[name];
    }
    if (this.repulsionByDegree) {
        var positionBuffer = this._positionSourceTex.pixels;
        for(var i = 0; i < this._nodes.length; i++)positionBuffer[i * 4 + 2] = (this._nodes[i].degree || 0) + 1;
    }
};
$16049f20505649c2$var$ForceAtlas2GPU.prototype._updateGravityCenter = function(options) {
    var nodes = this._nodes;
    var edges = this._edges;
    if (!this.gravityCenter) {
        var min = [
            Infinity,
            Infinity
        ];
        var max = [
            -Infinity,
            -Infinity
        ];
        for(var i = 0; i < nodes.length; i++){
            min[0] = Math.min(nodes[i].x, min[0]);
            min[1] = Math.min(nodes[i].y, min[1]);
            max[0] = Math.max(nodes[i].x, max[0]);
            max[1] = Math.max(nodes[i].y, max[1]);
        }
        this._gravityCenter = [
            (min[0] + max[0]) * 0.5,
            (min[1] + max[1]) * 0.5
        ];
    } else this._gravityCenter = this.gravityCenter;
     // Update inDegree, outDegree
    for(var i = 0; i < edges.length; i++){
        var node1 = edges[i].node1;
        var node2 = edges[i].node2;
        nodes[node1].degree = (nodes[node1].degree || 0) + 1;
        nodes[node2].degree = (nodes[node2].degree || 0) + 1;
    }
};
/**
 * @param {Array.<Object>} [{ x, y, mass }] nodes
 * @param {Array.<Object>} [{ node1, node2, weight }] edges
 */ $16049f20505649c2$var$ForceAtlas2GPU.prototype.initData = function(nodes, edges) {
    this._nodes = nodes;
    this._edges = edges;
    this._updateGravityCenter();
    var textureWidth = Math.ceil(Math.sqrt(nodes.length));
    var textureHeight = textureWidth;
    var positionBuffer = new Float32Array(textureWidth * textureHeight * 4);
    this._resize(textureWidth, textureHeight);
    var offset = 0;
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        positionBuffer[offset++] = node.x || 0;
        positionBuffer[offset++] = node.y || 0;
        positionBuffer[offset++] = node.mass || 1;
        positionBuffer[offset++] = node.size || 1;
    }
    this._positionSourceTex.pixels = positionBuffer;
    var edgeGeometry = this._edgeForceMesh.geometry;
    var edgeLen = edges.length;
    edgeGeometry.attributes.node1.init(edgeLen * 2);
    edgeGeometry.attributes.node2.init(edgeLen * 2);
    edgeGeometry.attributes.weight.init(edgeLen * 2);
    var uv = [];
    for(var i = 0; i < edges.length; i++){
        var attributes = edgeGeometry.attributes;
        var weight = edges[i].weight;
        if (weight == null) weight = 1;
         // Two way.
        attributes.node1.set(i, this.getNodeUV(edges[i].node1, uv));
        attributes.node2.set(i, this.getNodeUV(edges[i].node2, uv));
        attributes.weight.set(i, weight);
        attributes.node1.set(i + edgeLen, this.getNodeUV(edges[i].node2, uv));
        attributes.node2.set(i + edgeLen, this.getNodeUV(edges[i].node1, uv));
        attributes.weight.set(i + edgeLen, weight);
    }
    var weigtedSumGeo = this._weightedSumMesh.geometry;
    weigtedSumGeo.attributes.node.init(nodes.length);
    for(var i = 0; i < nodes.length; i++)weigtedSumGeo.attributes.node.set(i, this.getNodeUV(i, uv));
    edgeGeometry.dirty();
    weigtedSumGeo.dirty();
    this._nodeRepulsionPass.material.define("fragment", "NODE_COUNT", nodes.length);
    this._nodeRepulsionPass.material.setUniform("textureSize", [
        textureWidth,
        textureHeight
    ]);
    this._inited = false;
    this._frame = 0;
};
$16049f20505649c2$var$ForceAtlas2GPU.prototype.getNodes = function() {
    return this._nodes;
};
$16049f20505649c2$var$ForceAtlas2GPU.prototype.getEdges = function() {
    return this._edges;
};
$16049f20505649c2$var$ForceAtlas2GPU.prototype.step = function(renderer) {
    if (!this._inited) {
        this._initFromSource(renderer);
        this._inited = true;
    }
    this._frame++;
    this._framebuffer.attach(this._forceTex);
    this._framebuffer.bind(renderer);
    var nodeRepulsionPass = this._nodeRepulsionPass; // Calc node repulsion, gravity
    nodeRepulsionPass.setUniform("strongGravityMode", this.strongGravityMode);
    nodeRepulsionPass.setUniform("gravity", this.gravity);
    nodeRepulsionPass.setUniform("gravityCenter", this._gravityCenter);
    nodeRepulsionPass.setUniform("scaling", this.scaling);
    nodeRepulsionPass.setUniform("preventOverlap", this.preventOverlap);
    nodeRepulsionPass.setUniform("positionTex", this._positionPrevTex);
    nodeRepulsionPass.render(renderer); // Calc edge attraction force
    var edgeForceMesh = this._edgeForceMesh;
    edgeForceMesh.material.set("linLogMode", this.linLogMode);
    edgeForceMesh.material.set("edgeWeightInfluence", this.edgeWeightInfluence);
    edgeForceMesh.material.set("preventOverlap", this.preventOverlap);
    edgeForceMesh.material.set("positionTex", this._positionPrevTex);
    renderer.gl.enable(renderer.gl.BLEND);
    renderer.renderPass([
        edgeForceMesh
    ], this._dummyCamera); // Calc weighted sum.
    this._framebuffer.attach(this._weightedSumTex);
    renderer.gl.clearColor(0, 0, 0, 0);
    renderer.gl.clear(renderer.gl.COLOR_BUFFER_BIT);
    renderer.gl.enable(renderer.gl.BLEND);
    var weightedSumMesh = this._weightedSumMesh;
    weightedSumMesh.material.set("positionTex", this._positionPrevTex);
    weightedSumMesh.material.set("forceTex", this._forceTex);
    weightedSumMesh.material.set("forcePrevTex", this._forcePrevTex);
    renderer.renderPass([
        weightedSumMesh
    ], this._dummyCamera); // Calc global speed.
    this._framebuffer.attach(this._globalSpeedTex);
    var globalSpeedPass = this._globalSpeedPass;
    globalSpeedPass.setUniform("globalSpeedPrevTex", this._globalSpeedPrevTex);
    globalSpeedPass.setUniform("weightedSumTex", this._weightedSumTex);
    globalSpeedPass.setUniform("jitterTolerence", this.jitterTolerence);
    renderer.gl.disable(renderer.gl.BLEND);
    globalSpeedPass.render(renderer); // Update position.
    var positionPass = this._positionPass;
    this._framebuffer.attach(this._positionTex);
    positionPass.setUniform("globalSpeedTex", this._globalSpeedTex);
    positionPass.setUniform("positionTex", this._positionPrevTex);
    positionPass.setUniform("forceTex", this._forceTex);
    positionPass.setUniform("forcePrevTex", this._forcePrevTex);
    positionPass.render(renderer);
    this._framebuffer.unbind(renderer);
    this._swapTexture();
};
$16049f20505649c2$var$ForceAtlas2GPU.prototype.update = function(renderer, steps, cb) {
    if (steps == null) steps = 1;
    steps = Math.max(steps, 1);
    for(var i = 0; i < steps; i++)this.step(renderer);
    cb && cb();
};
$16049f20505649c2$var$ForceAtlas2GPU.prototype.getNodePositionTexture = function() {
    return this._inited // Texture already been swapped.
     ? this._positionPrevTex : this._positionSourceTex;
};
$16049f20505649c2$var$ForceAtlas2GPU.prototype.getNodeUV = function(nodeIndex, uv) {
    uv = uv || [];
    var textureWidth = this._positionTex.width;
    var textureHeight = this._positionTex.height;
    uv[0] = nodeIndex % textureWidth / (textureWidth - 1);
    uv[1] = Math.floor(nodeIndex / textureWidth) / (textureHeight - 1) || 0;
    return uv;
};
$16049f20505649c2$var$ForceAtlas2GPU.prototype.getNodePosition = function(renderer, out) {
    var positionArr = this._positionArr;
    var width = this._positionTex.width;
    var height = this._positionTex.height;
    var size = width * height;
    if (!positionArr || positionArr.length !== size * 4) positionArr = this._positionArr = new Float32Array(size * 4);
    this._framebuffer.bind(renderer);
    this._framebuffer.attach(this._positionPrevTex);
    renderer.gl.readPixels(0, 0, width, height, renderer.gl.RGBA, renderer.gl.FLOAT, positionArr);
    this._framebuffer.unbind(renderer);
    if (!out) out = new Float32Array(this._nodes.length * 2);
    for(var i = 0; i < this._nodes.length; i++){
        out[i * 2] = positionArr[i * 4];
        out[i * 2 + 1] = positionArr[i * 4 + 1];
    }
    return out;
};
$16049f20505649c2$var$ForceAtlas2GPU.prototype.getTextureData = function(renderer, textureName) {
    var tex = this["_" + textureName + "Tex"];
    var width = tex.width;
    var height = tex.height;
    this._framebuffer.bind(renderer);
    this._framebuffer.attach(tex);
    var arr = new Float32Array(width * height * 4);
    renderer.gl.readPixels(0, 0, width, height, renderer.gl.RGBA, renderer.gl.FLOAT, arr);
    this._framebuffer.unbind(renderer);
    return arr;
};
$16049f20505649c2$var$ForceAtlas2GPU.prototype.getTextureSize = function() {
    return {
        width: this._positionTex.width,
        height: this._positionTex.height
    };
};
$16049f20505649c2$var$ForceAtlas2GPU.prototype.isFinished = function(maxSteps) {
    return this._frame > maxSteps;
};
$16049f20505649c2$var$ForceAtlas2GPU.prototype._swapTexture = function() {
    var tmp = this._positionPrevTex;
    this._positionPrevTex = this._positionTex;
    this._positionTex = tmp;
    var tmp = this._forcePrevTex;
    this._forcePrevTex = this._forceTex;
    this._forceTex = tmp;
    var tmp = this._globalSpeedPrevTex;
    this._globalSpeedPrevTex = this._globalSpeedTex;
    this._globalSpeedTex = tmp;
};
$16049f20505649c2$var$ForceAtlas2GPU.prototype._initFromSource = function(renderer) {
    this._framebuffer.attach(this._positionPrevTex);
    this._framebuffer.bind(renderer);
    this._copyPass.setUniform("texture", this._positionSourceTex);
    this._copyPass.render(renderer);
    renderer.gl.clearColor(0, 0, 0, 0);
    this._framebuffer.attach(this._forcePrevTex);
    renderer.gl.clear(renderer.gl.COLOR_BUFFER_BIT);
    this._framebuffer.attach(this._globalSpeedPrevTex);
    renderer.gl.clear(renderer.gl.COLOR_BUFFER_BIT);
    this._framebuffer.unbind(renderer);
};
$16049f20505649c2$var$ForceAtlas2GPU.prototype._resize = function(width, height) {
    [
        "_positionSourceTex",
        "_positionTex",
        "_positionPrevTex",
        "_forceTex",
        "_forcePrevTex"
    ].forEach(function(texName) {
        this[texName].width = width;
        this[texName].height = height;
        this[texName].dirty();
    }, this);
};
$16049f20505649c2$var$ForceAtlas2GPU.prototype.dispose = function(renderer) {
    this._framebuffer.dispose(renderer);
    this._copyPass.dispose(renderer);
    this._nodeRepulsionPass.dispose(renderer);
    this._positionPass.dispose(renderer);
    this._globalSpeedPass.dispose(renderer);
    this._edgeForceMesh.geometry.dispose(renderer);
    this._weightedSumMesh.geometry.dispose(renderer);
    this._positionSourceTex.dispose(renderer);
    this._positionTex.dispose(renderer);
    this._positionPrevTex.dispose(renderer);
    this._forceTex.dispose(renderer);
    this._forcePrevTex.dispose(renderer);
    this._weightedSumTex.dispose(renderer);
    this._globalSpeedTex.dispose(renderer);
    this._globalSpeedPrevTex.dispose(renderer);
};
var $16049f20505649c2$export$2e2bcd8739ae039 = $16049f20505649c2$var$ForceAtlas2GPU;




/****************************
 * Vector2 math functions
 ***************************/ function $36bc38fad1911de7$var$forceAtlas2Worker() {
    var vec2 = {
        create: function() {
            return new Float32Array(2);
        },
        dist: function(a, b) {
            var x = b[0] - a[0];
            var y = b[1] - a[1];
            return Math.sqrt(x * x + y * y);
        },
        len: function(a) {
            var x = a[0];
            var y = a[1];
            return Math.sqrt(x * x + y * y);
        },
        scaleAndAdd: function(out, a, b, scale) {
            out[0] = a[0] + b[0] * scale;
            out[1] = a[1] + b[1] * scale;
            return out;
        },
        scale: function(out, a, b) {
            out[0] = a[0] * b;
            out[1] = a[1] * b;
            return out;
        },
        add: function(out, a, b) {
            out[0] = a[0] + b[0];
            out[1] = a[1] + b[1];
            return out;
        },
        sub: function(out, a, b) {
            out[0] = a[0] - b[0];
            out[1] = a[1] - b[1];
            return out;
        },
        normalize: function(out, a) {
            var x = a[0];
            var y = a[1];
            var len = x * x + y * y;
            if (len > 0) {
                //TODO: evaluate use of glm_invsqrt here?
                len = 1 / Math.sqrt(len);
                out[0] = a[0] * len;
                out[1] = a[1] * len;
            }
            return out;
        },
        negate: function(out, a) {
            out[0] = -a[0];
            out[1] = -a[1];
            return out;
        },
        copy: function(out, a) {
            out[0] = a[0];
            out[1] = a[1];
            return out;
        },
        set: function(out, x, y) {
            out[0] = x;
            out[1] = y;
            return out;
        }
    };
    /****************************
   * Class: Region
   ***************************/ function Region() {
        this.subRegions = [];
        this.nSubRegions = 0;
        this.node = null;
        this.mass = 0;
        this.centerOfMass = null;
        this.bbox = new Float32Array(4);
        this.size = 0;
    }
    var regionProto = Region.prototype; // Reset before update
    regionProto.beforeUpdate = function() {
        for(var i = 0; i < this.nSubRegions; i++)this.subRegions[i].beforeUpdate();
        this.mass = 0;
        if (this.centerOfMass) {
            this.centerOfMass[0] = 0;
            this.centerOfMass[1] = 0;
        }
        this.nSubRegions = 0;
        this.node = null;
    }; // Clear after update
    regionProto.afterUpdate = function() {
        this.subRegions.length = this.nSubRegions;
        for(var i = 0; i < this.nSubRegions; i++)this.subRegions[i].afterUpdate();
    };
    regionProto.addNode = function(node) {
        if (this.nSubRegions === 0) {
            if (this.node == null) {
                this.node = node;
                return;
            } else {
                this._addNodeToSubRegion(this.node);
                this.node = null;
            }
        }
        this._addNodeToSubRegion(node);
        this._updateCenterOfMass(node);
    };
    regionProto.findSubRegion = function(x, y) {
        for(var i = 0; i < this.nSubRegions; i++){
            var region = this.subRegions[i];
            if (region.contain(x, y)) return region;
        }
    };
    regionProto.contain = function(x, y) {
        return this.bbox[0] <= x && this.bbox[2] >= x && this.bbox[1] <= y && this.bbox[3] >= y;
    };
    regionProto.setBBox = function(minX, minY, maxX, maxY) {
        // Min
        this.bbox[0] = minX;
        this.bbox[1] = minY; // Max
        this.bbox[2] = maxX;
        this.bbox[3] = maxY;
        this.size = (maxX - minX + maxY - minY) / 2;
    };
    regionProto._newSubRegion = function() {
        var subRegion = this.subRegions[this.nSubRegions];
        if (!subRegion) {
            subRegion = new Region();
            this.subRegions[this.nSubRegions] = subRegion;
        }
        this.nSubRegions++;
        return subRegion;
    };
    regionProto._addNodeToSubRegion = function(node) {
        var subRegion = this.findSubRegion(node.position[0], node.position[1]);
        var bbox = this.bbox;
        if (!subRegion) {
            var cx = (bbox[0] + bbox[2]) / 2;
            var cy = (bbox[1] + bbox[3]) / 2;
            var w = (bbox[2] - bbox[0]) / 2;
            var h = (bbox[3] - bbox[1]) / 2;
            var xi = node.position[0] >= cx ? 1 : 0;
            var yi = node.position[1] >= cy ? 1 : 0;
            var subRegion = this._newSubRegion(); // Min
            subRegion.setBBox(xi * w + bbox[0], yi * h + bbox[1], (xi + 1) * w + bbox[0], (yi + 1) * h + bbox[1]);
        }
        subRegion.addNode(node);
    };
    regionProto._updateCenterOfMass = function(node) {
        // Incrementally update
        if (this.centerOfMass == null) this.centerOfMass = new Float32Array(2);
        var x = this.centerOfMass[0] * this.mass;
        var y = this.centerOfMass[1] * this.mass;
        x += node.position[0] * node.mass;
        y += node.position[1] * node.mass;
        this.mass += node.mass;
        this.centerOfMass[0] = x / this.mass;
        this.centerOfMass[1] = y / this.mass;
    };
    /****************************
   * Class: Graph Node
   ***************************/ function GraphNode() {
        this.position = new Float32Array(2);
        this.force = vec2.create();
        this.forcePrev = vec2.create(); // If repulsionByDegree is true
        //  mass = inDegree + outDegree + 1
        // Else
        //  mass is manually set
        this.mass = 1;
        this.inDegree = 0;
        this.outDegree = 0; // Optional
    // this.size = 1;
    }
    /****************************
   * Class: Graph Edge
   ***************************/ function GraphEdge(source, target) {
        this.source = source;
        this.target = target;
        this.weight = 1;
    }
    /****************************
   * Class: ForceStlas2
   ***************************/ function ForceAtlas2() {
        //-------------
        // Configs
        // If auto settings is true
        //  barnesHutOptimize,
        //  barnesHutTheta,
        //  scaling,
        //  jitterTolerence
        // Will be set by the system automatically
        //  preventOverlap will be set false
        //  if node size is not given
        this.autoSettings = true; // Barnes Hut
        // http://arborjs.org/docs/barnes-hut
        this.barnesHutOptimize = true;
        this.barnesHutTheta = 1.5; // Force Atlas2 Configs
        this.repulsionByDegree = true;
        this.linLogMode = false;
        this.strongGravityMode = false;
        this.gravity = 1.0;
        this.scaling = 1.0;
        this.edgeWeightInfluence = 1.0;
        this.jitterTolerence = 0.1; // TODO
        this.preventOverlap = false;
        this.dissuadeHubs = false; //
        this.rootRegion = new Region();
        this.rootRegion.centerOfMass = vec2.create();
        this.nodes = [];
        this.edges = [];
        this.bbox = new Float32Array(4);
        this.gravityCenter = null;
        this._massArr = null;
        this._swingingArr = null;
        this._sizeArr = null;
        this._globalSpeed = 0;
    }
    var forceAtlas2Proto = ForceAtlas2.prototype;
    forceAtlas2Proto.initNodes = function(positionArr, massArr, sizeArr) {
        var nNodes = massArr.length;
        this.nodes.length = 0;
        var haveSize = typeof sizeArr != "undefined";
        for(var i = 0; i < nNodes; i++){
            var node = new GraphNode();
            node.position[0] = positionArr[i * 2];
            node.position[1] = positionArr[i * 2 + 1];
            node.mass = massArr[i];
            if (haveSize) node.size = sizeArr[i];
            this.nodes.push(node);
        }
        this._massArr = massArr;
        this._swingingArr = new Float32Array(nNodes);
        if (haveSize) this._sizeArr = sizeArr;
    };
    forceAtlas2Proto.initEdges = function(edgeArr, edgeWeightArr) {
        var nEdges = edgeArr.length / 2;
        this.edges.length = 0;
        for(var i = 0; i < nEdges; i++){
            var sIdx = edgeArr[i * 2];
            var tIdx = edgeArr[i * 2 + 1];
            var sNode = this.nodes[sIdx];
            var tNode = this.nodes[tIdx];
            if (!sNode || !tNode) {
                console.error("Node not exists, try initNodes before initEdges");
                return;
            }
            sNode.outDegree++;
            tNode.inDegree++;
            var edge = new GraphEdge(sNode, tNode);
            if (edgeWeightArr) edge.weight = edgeWeightArr[i];
            this.edges.push(edge);
        }
    };
    forceAtlas2Proto.updateSettings = function() {
        if (this.repulsionByDegree) for(var i = 0; i < this.nodes.length; i++){
            var node = this.nodes[i];
            node.mass = node.inDegree + node.outDegree + 1;
        }
        else for(var i = 0; i < this.nodes.length; i++){
            var node = this.nodes[i];
            node.mass = this._massArr[i];
        }
    };
    forceAtlas2Proto.update = function() {
        var nNodes = this.nodes.length;
        this.updateSettings();
        this.updateBBox(); // Update region
        if (this.barnesHutOptimize) {
            this.rootRegion.setBBox(this.bbox[0], this.bbox[1], this.bbox[2], this.bbox[3]);
            this.rootRegion.beforeUpdate();
            for(var i = 0; i < nNodes; i++)this.rootRegion.addNode(this.nodes[i]);
            this.rootRegion.afterUpdate();
        } // Reset forces
        for(var i = 0; i < nNodes; i++){
            var node = this.nodes[i];
            vec2.copy(node.forcePrev, node.force);
            vec2.set(node.force, 0, 0);
        } // Compute forces
        // Repulsion
        for(var i = 0; i < nNodes; i++){
            var na = this.nodes[i];
            if (this.barnesHutOptimize) this.applyRegionToNodeRepulsion(this.rootRegion, na);
            else for(var j = i + 1; j < nNodes; j++){
                var nb = this.nodes[j];
                this.applyNodeToNodeRepulsion(na, nb, false);
            }
             // Gravity
            if (this.gravity > 0) {
                if (this.strongGravityMode) this.applyNodeStrongGravity(na);
                else this.applyNodeGravity(na);
            }
        } // Attraction
        for(var i = 0; i < this.edges.length; i++)this.applyEdgeAttraction(this.edges[i]);
         // Handle swinging
        var swingWeightedSum = 0;
        var tractionWeightedSum = 0;
        var tmp = vec2.create();
        for(var i = 0; i < nNodes; i++){
            var node = this.nodes[i];
            var swing = vec2.dist(node.force, node.forcePrev);
            swingWeightedSum += swing * node.mass;
            vec2.add(tmp, node.force, node.forcePrev);
            var traction = vec2.len(tmp) * 0.5;
            tractionWeightedSum += traction * node.mass; // Save the value for using later
            this._swingingArr[i] = swing;
        }
        var globalSpeed = this.jitterTolerence * this.jitterTolerence * tractionWeightedSum / swingWeightedSum; // NB: During our tests we observed that an excessive rise of the global speed could have a negative impact.
        // That’s why we limited the increase of global speed s(t)(G) to 50% of the previous step s(t−1)(G).
        if (this._globalSpeed > 0) globalSpeed = Math.min(globalSpeed / this._globalSpeed, 1.5) * this._globalSpeed;
        this._globalSpeed = globalSpeed; // Apply forces
        for(var i = 0; i < nNodes; i++){
            var node = this.nodes[i];
            var swing = this._swingingArr[i];
            var speed = 0.1 * globalSpeed / (1 + globalSpeed * Math.sqrt(swing)); // Additional constraint to prevent local speed gets too high
            var df = vec2.len(node.force);
            if (df > 0) {
                speed = Math.min(df * speed, 10) / df;
                vec2.scaleAndAdd(node.position, node.position, node.force, speed);
            }
        }
    };
    forceAtlas2Proto.applyRegionToNodeRepulsion = function() {
        var v = vec2.create();
        return function applyRegionToNodeRepulsion(region, node) {
            if (region.node) // Region is a leaf
            this.applyNodeToNodeRepulsion(region.node, node, true);
            else {
                vec2.sub(v, node.position, region.centerOfMass);
                var d2 = v[0] * v[0] + v[1] * v[1];
                if (d2 > this.barnesHutTheta * region.size * region.size) {
                    var factor = this.scaling * node.mass * region.mass / d2;
                    vec2.scaleAndAdd(node.force, node.force, v, factor);
                } else for(var i = 0; i < region.nSubRegions; i++)this.applyRegionToNodeRepulsion(region.subRegions[i], node);
            }
        };
    }();
    forceAtlas2Proto.applyNodeToNodeRepulsion = function() {
        var v = vec2.create();
        return function applyNodeToNodeRepulsion(na, nb, oneWay) {
            if (na == nb) return;
            vec2.sub(v, na.position, nb.position);
            var d2 = v[0] * v[0] + v[1] * v[1]; // PENDING
            if (d2 === 0) return;
            var factor;
            if (this.preventOverlap) {
                var d = Math.sqrt(d2);
                d = d - na.size - nb.size;
                if (d > 0) factor = this.scaling * na.mass * nb.mass / (d * d);
                else if (d < 0) // A stronger repulsion if overlap
                factor = this.scaling * 100 * na.mass * nb.mass;
                else // No repulsion
                return;
            } else // Divide factor by an extra `d` to normalize the `v`
            factor = this.scaling * na.mass * nb.mass / d2;
            vec2.scaleAndAdd(na.force, na.force, v, factor);
            vec2.scaleAndAdd(nb.force, nb.force, v, -factor);
        };
    }();
    forceAtlas2Proto.applyEdgeAttraction = function() {
        var v = vec2.create();
        return function applyEdgeAttraction(edge) {
            var na = edge.source;
            var nb = edge.target;
            vec2.sub(v, na.position, nb.position);
            var d = vec2.len(v);
            var w;
            if (this.edgeWeightInfluence === 0) w = 1;
            else if (this.edgeWeightInfluence === 1) w = edge.weight;
            else w = Math.pow(edge.weight, this.edgeWeightInfluence);
            var factor;
            if (this.preventOverlap) {
                d = d - na.size - nb.size;
                if (d <= 0) // No attraction
                return;
            }
            if (this.linLogMode) // Divide factor by an extra `d` to normalize the `v`
            factor = -w * Math.log(d + 1) / (d + 1);
            else factor = -w;
            vec2.scaleAndAdd(na.force, na.force, v, factor);
            vec2.scaleAndAdd(nb.force, nb.force, v, -factor);
        };
    }();
    forceAtlas2Proto.applyNodeGravity = function() {
        var v = vec2.create();
        return function(node) {
            vec2.sub(v, this.gravityCenter, node.position);
            var d = vec2.len(v);
            vec2.scaleAndAdd(node.force, node.force, v, this.gravity * node.mass / (d + 1));
        };
    }();
    forceAtlas2Proto.applyNodeStrongGravity = function() {
        var v = vec2.create();
        return function(node) {
            vec2.sub(v, this.gravityCenter, node.position);
            vec2.scaleAndAdd(node.force, node.force, v, this.gravity * node.mass);
        };
    }();
    forceAtlas2Proto.updateBBox = function() {
        var minX = Infinity;
        var minY = Infinity;
        var maxX = -Infinity;
        var maxY = -Infinity;
        for(var i = 0; i < this.nodes.length; i++){
            var pos = this.nodes[i].position;
            minX = Math.min(minX, pos[0]);
            minY = Math.min(minY, pos[1]);
            maxX = Math.max(maxX, pos[0]);
            maxY = Math.max(maxY, pos[1]);
        }
        this.bbox[0] = minX;
        this.bbox[1] = minY;
        this.bbox[2] = maxX;
        this.bbox[3] = maxY;
    };
    forceAtlas2Proto.getGlobalSpeed = function() {
        return this._globalSpeed;
    };
    /****************************
   * Main process
   ***************************/ var forceAtlas2 = null;
    self.onmessage = function(e) {
        switch(e.data.cmd){
            case "init":
                forceAtlas2 = new ForceAtlas2();
                forceAtlas2.initNodes(e.data.nodesPosition, e.data.nodesMass, e.data.nodesSize);
                forceAtlas2.initEdges(e.data.edges, e.data.edgesWeight);
                break;
            case "updateConfig":
                if (forceAtlas2) for(var name in e.data.config)forceAtlas2[name] = e.data.config[name];
                break;
            case "update":
                var steps = e.data.steps;
                if (forceAtlas2) {
                    for(var i = 0; i < steps; i++)forceAtlas2.update();
                    var nNodes = forceAtlas2.nodes.length;
                    var positionArr = new Float32Array(nNodes * 2); // Callback
                    for(var i = 0; i < nNodes; i++){
                        var node = forceAtlas2.nodes[i];
                        positionArr[i * 2] = node.position[0];
                        positionArr[i * 2 + 1] = node.position[1];
                    }
                    self.postMessage({
                        buffer: positionArr.buffer,
                        globalSpeed: forceAtlas2.getGlobalSpeed()
                    }, [
                        positionArr.buffer
                    ]);
                } else {
                    // Not initialzied yet
                    var emptyArr = new Float32Array(); // Post transfer object
                    self.postMessage({
                        buffer: emptyArr.buffer,
                        globalSpeed: forceAtlas2.getGlobalSpeed()
                    }, [
                        emptyArr.buffer
                    ]);
                }
                break;
        }
    };
}
var $36bc38fad1911de7$export$2e2bcd8739ae039 = $36bc38fad1911de7$var$forceAtlas2Worker;


var $df4bc25ce3d9ab61$var$workerUrl = (0, $36bc38fad1911de7$export$2e2bcd8739ae039).toString();
$df4bc25ce3d9ab61$var$workerUrl = $df4bc25ce3d9ab61$var$workerUrl.slice($df4bc25ce3d9ab61$var$workerUrl.indexOf("{") + 1, $df4bc25ce3d9ab61$var$workerUrl.lastIndexOf("}"));
var $df4bc25ce3d9ab61$var$defaultConfigs = {
    barnesHutOptimize: true,
    barnesHutTheta: 1.5,
    repulsionByDegree: true,
    linLogMode: false,
    strongGravityMode: false,
    gravity: 1.0,
    scaling: 1.0,
    edgeWeightInfluence: 1.0,
    jitterTolerence: 0.1,
    preventOverlap: false,
    dissuadeHubs: false,
    gravityCenter: null
};
var $df4bc25ce3d9ab61$var$ForceAtlas2 = function(options) {
    for(var name in $df4bc25ce3d9ab61$var$defaultConfigs)this[name] = $df4bc25ce3d9ab61$var$defaultConfigs[name];
    if (options) for(var name in options)this[name] = options[name];
    this._nodes = [];
    this._edges = [];
    this._disposed = false;
    this._positionTex = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        type: (0, $4261427f149675a4$export$2e2bcd8739ae039).FLOAT,
        flipY: false,
        minFilter: (0, $4261427f149675a4$export$2e2bcd8739ae039).NEAREST,
        magFilter: (0, $4261427f149675a4$export$2e2bcd8739ae039).NEAREST
    });
};
$df4bc25ce3d9ab61$var$ForceAtlas2.prototype.initData = function(nodes, edges) {
    var bb = new Blob([
        $df4bc25ce3d9ab61$var$workerUrl
    ]);
    var blobURL = window.URL.createObjectURL(bb);
    this._worker = new Worker(blobURL);
    this._worker.onmessage = this._$onupdate.bind(this);
    this._nodes = nodes;
    this._edges = edges;
    this._frame = 0;
    var nNodes = nodes.length;
    var nEdges = edges.length;
    var positionArr = new Float32Array(nNodes * 2);
    var massArr = new Float32Array(nNodes);
    var sizeArr = new Float32Array(nNodes);
    var edgeArr = new Float32Array(nEdges * 2);
    var edgeWeightArr = new Float32Array(nEdges);
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        positionArr[i * 2] = node.x;
        positionArr[i * 2 + 1] = node.y;
        massArr[i] = node.mass == null ? 1 : node.mass;
        sizeArr[i] = node.size == null ? 1 : node.size;
    }
    for(var i = 0; i < edges.length; i++){
        var edge = edges[i];
        var source = edge.node1;
        var target = edge.node2;
        edgeArr[i * 2] = source;
        edgeArr[i * 2 + 1] = target;
        edgeWeightArr[i] = edge.weight == null ? 1 : edge.weight;
    }
    var textureWidth = Math.ceil(Math.sqrt(nodes.length));
    var textureHeight = textureWidth;
    var pixels = new Float32Array(textureWidth * textureHeight * 4);
    var positionTex = this._positionTex;
    positionTex.width = textureWidth;
    positionTex.height = textureHeight;
    positionTex.pixels = pixels;
    this._worker.postMessage({
        cmd: "init",
        nodesPosition: positionArr,
        nodesMass: massArr,
        nodesSize: sizeArr,
        edges: edgeArr,
        edgesWeight: edgeWeightArr
    });
    this._globalSpeed = Infinity;
};
$df4bc25ce3d9ab61$var$ForceAtlas2.prototype.updateOption = function(options) {
    var config = {}; // Default config
    for(var name in $df4bc25ce3d9ab61$var$defaultConfigs)config[name] = $df4bc25ce3d9ab61$var$defaultConfigs[name];
    var nodes = this._nodes;
    var edges = this._edges; // Config according to data scale
    var nNodes = nodes.length;
    if (nNodes > 50000) config.jitterTolerence = 10;
    else if (nNodes > 5000) config.jitterTolerence = 1;
    else config.jitterTolerence = 0.1;
    if (nNodes > 100) config.scaling = 2.0;
    else config.scaling = 10.0;
    if (nNodes > 1000) config.barnesHutOptimize = true;
    else config.barnesHutOptimize = false;
    if (options) {
        for(var name in $df4bc25ce3d9ab61$var$defaultConfigs)if (options[name] != null) config[name] = options[name];
    }
    if (!config.gravityCenter) {
        var min = [
            Infinity,
            Infinity
        ];
        var max = [
            -Infinity,
            -Infinity
        ];
        for(var i = 0; i < nodes.length; i++){
            min[0] = Math.min(nodes[i].x, min[0]);
            min[1] = Math.min(nodes[i].y, min[1]);
            max[0] = Math.max(nodes[i].x, max[0]);
            max[1] = Math.max(nodes[i].y, max[1]);
        }
        config.gravityCenter = [
            (min[0] + max[0]) * 0.5,
            (min[1] + max[1]) * 0.5
        ];
    } // Update inDegree, outDegree
    for(var i = 0; i < edges.length; i++){
        var node1 = edges[i].node1;
        var node2 = edges[i].node2;
        nodes[node1].degree = (nodes[node1].degree || 0) + 1;
        nodes[node2].degree = (nodes[node2].degree || 0) + 1;
    }
    if (this._worker) this._worker.postMessage({
        cmd: "updateConfig",
        config: config
    });
}; // Steps per call, to keep sync with rendering
$df4bc25ce3d9ab61$var$ForceAtlas2.prototype.update = function(renderer, steps, cb) {
    if (steps == null) steps = 1;
    steps = Math.max(steps, 1);
    this._frame += steps;
    this._onupdate = cb;
    if (this._worker) this._worker.postMessage({
        cmd: "update",
        steps: Math.round(steps)
    });
};
$df4bc25ce3d9ab61$var$ForceAtlas2.prototype._$onupdate = function(e) {
    // Incase the worker keep postMessage of last frame after it is disposed
    if (this._disposed) return;
    var positionArr = new Float32Array(e.data.buffer);
    this._globalSpeed = e.data.globalSpeed;
    this._positionArr = positionArr;
    this._updateTexture(positionArr);
    this._onupdate && this._onupdate();
};
$df4bc25ce3d9ab61$var$ForceAtlas2.prototype.getNodePositionTexture = function() {
    return this._positionTex;
};
$df4bc25ce3d9ab61$var$ForceAtlas2.prototype.getNodeUV = function(nodeIndex, uv) {
    uv = uv || [];
    var textureWidth = this._positionTex.width;
    var textureHeight = this._positionTex.height;
    uv[0] = nodeIndex % textureWidth / (textureWidth - 1);
    uv[1] = Math.floor(nodeIndex / textureWidth) / (textureHeight - 1);
    return uv;
};
$df4bc25ce3d9ab61$var$ForceAtlas2.prototype.getNodes = function() {
    return this._nodes;
};
$df4bc25ce3d9ab61$var$ForceAtlas2.prototype.getEdges = function() {
    return this._edges;
};
$df4bc25ce3d9ab61$var$ForceAtlas2.prototype.isFinished = function(maxSteps) {
    return this._frame > maxSteps;
};
$df4bc25ce3d9ab61$var$ForceAtlas2.prototype.getNodePosition = function(renderer, out) {
    if (!out) out = new Float32Array(this._nodes.length * 2);
    if (this._positionArr) for(var i = 0; i < this._positionArr.length; i++)out[i] = this._positionArr[i];
    return out;
};
$df4bc25ce3d9ab61$var$ForceAtlas2.prototype._updateTexture = function(positionArr) {
    var pixels = this._positionTex.pixels;
    var offset = 0;
    for(var i = 0; i < positionArr.length;){
        pixels[offset++] = positionArr[i++];
        pixels[offset++] = positionArr[i++];
        pixels[offset++] = 1;
        pixels[offset++] = 1;
    }
    this._positionTex.dirty();
};
$df4bc25ce3d9ab61$var$ForceAtlas2.prototype.dispose = function(renderer) {
    this._disposed = true;
    this._worker = null;
};
var $df4bc25ce3d9ab61$export$2e2bcd8739ae039 = $df4bc25ce3d9ab61$var$ForceAtlas2;







/**
 * @alias module:echarts-gl/util/Roam2DControl
 */ var $4dde72ef8bfbdbb0$var$Roam2DControl = (0, $7c62670c05885275$export$2e2bcd8739ae039).extend(function() {
    return {
        /**
     * @type {module:zrender~ZRender}
     */ zr: null,
        /**
     * @type {module:echarts-gl/core/ViewGL}
     */ viewGL: null,
        minZoom: 0.2,
        maxZoom: 5,
        _needsUpdate: false,
        _dx: 0,
        _dy: 0,
        _zoom: 1
    };
}, function() {
    // Each Roam2DControl has it's own handler
    this._mouseDownHandler = this._mouseDownHandler.bind(this);
    this._mouseWheelHandler = this._mouseWheelHandler.bind(this);
    this._mouseMoveHandler = this._mouseMoveHandler.bind(this);
    this._mouseUpHandler = this._mouseUpHandler.bind(this);
    this._update = this._update.bind(this);
}, {
    init: function() {
        var zr = this.zr;
        zr.on("mousedown", this._mouseDownHandler);
        zr.on("mousewheel", this._mouseWheelHandler);
        zr.on("globalout", this._mouseUpHandler);
        zr.animation.on("frame", this._update);
    },
    setTarget: function(target) {
        this._target = target;
    },
    setZoom: function(zoom) {
        this._zoom = Math.max(Math.min(zoom, this.maxZoom), this.minZoom);
        this._needsUpdate = true;
    },
    setOffset: function(offset) {
        this._dx = offset[0];
        this._dy = offset[1];
        this._needsUpdate = true;
    },
    getZoom: function() {
        return this._zoom;
    },
    getOffset: function() {
        return [
            this._dx,
            this._dy
        ];
    },
    _update: function() {
        if (!this._target) return;
        if (!this._needsUpdate) return;
        var target = this._target;
        var scale = this._zoom;
        target.position.x = this._dx;
        target.position.y = this._dy;
        target.scale.set(scale, scale, scale);
        this.zr.refresh();
        this._needsUpdate = false;
        this.trigger("update");
    },
    _mouseDownHandler: function(e) {
        if (e.target) return;
        var x = e.offsetX;
        var y = e.offsetY;
        if (this.viewGL && !this.viewGL.containPoint(x, y)) return;
        this.zr.on("mousemove", this._mouseMoveHandler);
        this.zr.on("mouseup", this._mouseUpHandler);
        var pos = this._convertPos(x, y);
        this._x = pos.x;
        this._y = pos.y;
    },
    // Convert pos from screen space to viewspace.
    _convertPos: function(x, y) {
        var camera = this.viewGL.camera;
        var viewport = this.viewGL.viewport; // PENDING
        return {
            x: (x - viewport.x) / viewport.width * (camera.right - camera.left) + camera.left,
            y: (y - viewport.y) / viewport.height * (camera.bottom - camera.top) + camera.top
        };
    },
    _mouseMoveHandler: function(e) {
        var pos = this._convertPos(e.offsetX, e.offsetY);
        this._dx += pos.x - this._x;
        this._dy += pos.y - this._y;
        this._x = pos.x;
        this._y = pos.y;
        this._needsUpdate = true;
    },
    _mouseUpHandler: function(e) {
        this.zr.off("mousemove", this._mouseMoveHandler);
        this.zr.off("mouseup", this._mouseUpHandler);
    },
    _mouseWheelHandler: function(e) {
        e = e.event;
        var delta = e.wheelDelta // Webkit
         || -e.detail; // Firefox
        if (delta === 0) return;
        var x = e.offsetX;
        var y = e.offsetY;
        if (this.viewGL && !this.viewGL.containPoint(x, y)) return;
        var zoomScale = delta > 0 ? 1.1 : 0.9;
        var newZoom = Math.max(Math.min(this._zoom * zoomScale, this.maxZoom), this.minZoom);
        zoomScale = newZoom / this._zoom;
        var pos = this._convertPos(x, y);
        var fixX = (pos.x - this._dx) * (zoomScale - 1);
        var fixY = (pos.y - this._dy) * (zoomScale - 1);
        this._dx -= fixX;
        this._dy -= fixY;
        this._zoom = newZoom;
        this._needsUpdate = true;
    },
    dispose: function() {
        var zr = this.zr;
        zr.off("mousedown", this._mouseDownHandler);
        zr.off("mousemove", this._mouseMoveHandler);
        zr.off("mouseup", this._mouseUpHandler);
        zr.off("mousewheel", this._mouseWheelHandler);
        zr.off("globalout", this._mouseUpHandler);
        zr.animation.off("frame", this._update);
    }
});
var $4dde72ef8bfbdbb0$export$2e2bcd8739ae039 = $4dde72ef8bfbdbb0$var$Roam2DControl;



var $e6ef93f195e75b10$export$2e2bcd8739ae039 = "@export ecgl.lines2D.vertex\n\nuniform mat4 worldViewProjection : WORLDVIEWPROJECTION;\n\nattribute vec2 position: POSITION;\nattribute vec4 a_Color : COLOR;\nvarying vec4 v_Color;\n\n#ifdef POSITIONTEXTURE_ENABLED\nuniform sampler2D positionTexture;\n#endif\n\nvoid main()\n{\n gl_Position = worldViewProjection * vec4(position, -10.0, 1.0);\n\n v_Color = a_Color;\n}\n\n@end\n\n@export ecgl.lines2D.fragment\n\nuniform vec4 color : [1.0, 1.0, 1.0, 1.0];\n\nvarying vec4 v_Color;\n\nvoid main()\n{\n gl_FragColor = color * v_Color;\n}\n@end\n\n\n@export ecgl.meshLines2D.vertex\n\nattribute vec2 position: POSITION;\nattribute vec2 normal;\nattribute float offset;\nattribute vec4 a_Color : COLOR;\n\nuniform mat4 worldViewProjection : WORLDVIEWPROJECTION;\nuniform vec4 viewport : VIEWPORT;\n\nvarying vec4 v_Color;\nvarying float v_Miter;\n\nvoid main()\n{\n vec4 p2 = worldViewProjection * vec4(position + normal, -10.0, 1.0);\n gl_Position = worldViewProjection * vec4(position, -10.0, 1.0);\n\n p2.xy /= p2.w;\n gl_Position.xy /= gl_Position.w;\n\n vec2 N = normalize(p2.xy - gl_Position.xy);\n gl_Position.xy += N * offset / viewport.zw * 2.0;\n\n gl_Position.xy *= gl_Position.w;\n\n v_Color = a_Color;\n}\n@end\n\n\n@export ecgl.meshLines2D.fragment\n\nuniform vec4 color : [1.0, 1.0, 1.0, 1.0];\n\nvarying vec4 v_Color;\nvarying float v_Miter;\n\nvoid main()\n{\n gl_FragColor = color * v_Color;\n}\n\n@end";


var $a6cb5a0c73a6f986$var$vec2 = (0, $8308920d9a0ddf49$export$2e2bcd8739ae039).vec2;
(0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.import((0, $e6ef93f195e75b10$export$2e2bcd8739ae039));
var $a6cb5a0c73a6f986$var$globalLayoutId = 1;
var $a6cb5a0c73a6f986$export$2e2bcd8739ae039 = $0dc5061053e23cd3$export$2e2bcd8739ae039.extend({
    type: "graphGL",
    __ecgl__: true,
    init: function(ecModel, api) {
        this.groupGL = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
        this.viewGL = new (0, $7a0cfdd3f7cf77fd$export$2e2bcd8739ae039)("orthographic");
        this.viewGL.camera.left = this.viewGL.camera.right = 0;
        this.viewGL.add(this.groupGL);
        this._pointsBuilder = new (0, $ba74e03882df50b1$export$2e2bcd8739ae039)(true, api); // Mesh used during force directed layout.
        this._forceEdgesMesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
            material: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
                shader: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createShader("ecgl.forceAtlas2.edges"),
                transparent: true,
                depthMask: false,
                depthTest: false
            }),
            $ignorePicking: true,
            geometry: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Geometry({
                attributes: {
                    node: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Geometry.Attribute("node", "float", 2),
                    color: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Geometry.Attribute("color", "float", 4, "COLOR")
                },
                dynamic: true,
                mainAttribute: "node"
            }),
            renderOrder: -1,
            mode: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh.LINES
        }); // Mesh used after force directed layout.
        this._edgesMesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
            material: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
                shader: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createShader("ecgl.meshLines2D"),
                transparent: true,
                depthMask: false,
                depthTest: false
            }),
            $ignorePicking: true,
            geometry: new (0, $9168b5292959c78e$export$2e2bcd8739ae039)({
                useNativeLine: false,
                dynamic: true
            }),
            renderOrder: -1,
            culling: false
        });
        this._layoutId = 0;
        this._control = new (0, $4dde72ef8bfbdbb0$export$2e2bcd8739ae039)({
            zr: api.getZr(),
            viewGL: this.viewGL
        });
        this._control.setTarget(this.groupGL);
        this._control.init();
        this._clickHandler = this._clickHandler.bind(this);
    },
    render: function(seriesModel, ecModel, api) {
        this.groupGL.add(this._pointsBuilder.rootNode);
        this._model = seriesModel;
        this._api = api;
        this._initLayout(seriesModel, ecModel, api);
        this._pointsBuilder.update(seriesModel, ecModel, api);
        if (!(this._forceLayoutInstance instanceof (0, $16049f20505649c2$export$2e2bcd8739ae039))) this.groupGL.remove(this._forceEdgesMesh);
        this._updateCamera(seriesModel, api);
        this._control.off("update");
        this._control.on("update", function() {
            api.dispatchAction({
                type: "graphGLRoam",
                seriesId: seriesModel.id,
                zoom: this._control.getZoom(),
                offset: this._control.getOffset()
            });
            this._pointsBuilder.updateView(this.viewGL.camera);
        }, this);
        this._control.setZoom((0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(seriesModel.get("zoom"), 1));
        this._control.setOffset(seriesModel.get("offset") || [
            0,
            0
        ]);
        var mesh = this._pointsBuilder.getPointsMesh();
        mesh.off("mousemove", this._mousemoveHandler);
        mesh.off("mouseout", this._mouseOutHandler, this);
        api.getZr().off("click", this._clickHandler);
        this._pointsBuilder.highlightOnMouseover = true;
        if (seriesModel.get("focusNodeAdjacency")) {
            var focusNodeAdjacencyOn = seriesModel.get("focusNodeAdjacencyOn");
            if (focusNodeAdjacencyOn === "click") // Remove default emphasis effect
            api.getZr().on("click", this._clickHandler);
            else if (focusNodeAdjacencyOn === "mouseover") {
                mesh.on("mousemove", this._mousemoveHandler, this);
                mesh.on("mouseout", this._mouseOutHandler, this);
                this._pointsBuilder.highlightOnMouseover = false;
            }
        } // Reset
        this._lastMouseOverDataIndex = -1;
    },
    _clickHandler: function(e) {
        if (this._layouting) return;
        var dataIndex = this._pointsBuilder.getPointsMesh().dataIndex;
        if (dataIndex >= 0) this._api.dispatchAction({
            type: "graphGLFocusNodeAdjacency",
            seriesId: this._model.id,
            dataIndex: dataIndex
        });
        else this._api.dispatchAction({
            type: "graphGLUnfocusNodeAdjacency",
            seriesId: this._model.id
        });
    },
    _mousemoveHandler: function(e) {
        if (this._layouting) return;
        var dataIndex = this._pointsBuilder.getPointsMesh().dataIndex;
        if (dataIndex >= 0) {
            if (dataIndex !== this._lastMouseOverDataIndex) this._api.dispatchAction({
                type: "graphGLFocusNodeAdjacency",
                seriesId: this._model.id,
                dataIndex: dataIndex
            });
        } else this._mouseOutHandler(e);
        this._lastMouseOverDataIndex = dataIndex;
    },
    _mouseOutHandler: function(e) {
        if (this._layouting) return;
        this._api.dispatchAction({
            type: "graphGLUnfocusNodeAdjacency",
            seriesId: this._model.id
        });
        this._lastMouseOverDataIndex = -1;
    },
    _updateForceEdgesGeometry: function(edges, seriesModel) {
        var geometry = this._forceEdgesMesh.geometry;
        var edgeData = seriesModel.getEdgeData();
        var offset = 0;
        var layoutInstance = this._forceLayoutInstance;
        var vertexCount = edgeData.count() * 2;
        geometry.attributes.node.init(vertexCount);
        geometry.attributes.color.init(vertexCount);
        edgeData.each(function(idx) {
            var edge = edges[idx];
            geometry.attributes.node.set(offset, layoutInstance.getNodeUV(edge.node1));
            geometry.attributes.node.set(offset + 1, layoutInstance.getNodeUV(edge.node2));
            var color = (0, $4c1f03531dad0b09$export$bc92a5a7848039f)(edgeData, edge.dataIndex);
            var colorArr = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(color);
            colorArr[3] *= (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull((0, $4c1f03531dad0b09$export$f154d4dab8f4e8c0)(edgeData, edge.dataIndex), 1);
            geometry.attributes.color.set(offset, colorArr);
            geometry.attributes.color.set(offset + 1, colorArr);
            offset += 2;
        });
        geometry.dirty();
    },
    _updateMeshLinesGeometry: function() {
        var edgeData = this._model.getEdgeData();
        var geometry = this._edgesMesh.geometry;
        var edgeData = this._model.getEdgeData();
        var points = this._model.getData().getLayout("points");
        geometry.resetOffset();
        geometry.setVertexCount(edgeData.count() * geometry.getLineVertexCount());
        geometry.setTriangleCount(edgeData.count() * geometry.getLineTriangleCount());
        var p0 = [];
        var p1 = [];
        var lineWidthQuery = [
            "lineStyle",
            "width"
        ];
        this._originalEdgeColors = new Float32Array(edgeData.count() * 4);
        this._edgeIndicesMap = new Float32Array(edgeData.count());
        edgeData.each(function(idx) {
            var edge = edgeData.graph.getEdgeByIndex(idx);
            var idx1 = edge.node1.dataIndex * 2;
            var idx2 = edge.node2.dataIndex * 2;
            p0[0] = points[idx1];
            p0[1] = points[idx1 + 1];
            p1[0] = points[idx2];
            p1[1] = points[idx2 + 1];
            var color = (0, $4c1f03531dad0b09$export$bc92a5a7848039f)(edgeData, edge.dataIndex);
            var colorArr = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(color);
            colorArr[3] *= (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull((0, $4c1f03531dad0b09$export$f154d4dab8f4e8c0)(edgeData, edge.dataIndex), 1);
            var itemModel = edgeData.getItemModel(edge.dataIndex);
            var lineWidth = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(itemModel.get(lineWidthQuery), 1) * this._api.getDevicePixelRatio();
            geometry.addLine(p0, p1, colorArr, lineWidth);
            for(var k = 0; k < 4; k++)this._originalEdgeColors[edge.dataIndex * 4 + k] = colorArr[k];
            this._edgeIndicesMap[edge.dataIndex] = idx;
        }, this);
        geometry.dirty();
    },
    _updateForceNodesGeometry: function(nodeData) {
        var pointsMesh = this._pointsBuilder.getPointsMesh();
        var pos = [];
        for(var i = 0; i < nodeData.count(); i++){
            this._forceLayoutInstance.getNodeUV(i, pos);
            pointsMesh.geometry.attributes.position.set(i, pos);
        }
        pointsMesh.geometry.dirty("position");
    },
    _initLayout: function(seriesModel, ecModel, api) {
        var layout = seriesModel.get("layout");
        var graph = seriesModel.getGraph();
        var boxLayoutOption = seriesModel.getBoxLayoutParams();
        var viewport = (0, $93b9bc7f22ac7369$export$4517a5ca639a7293)(boxLayoutOption, {
            width: api.getWidth(),
            height: api.getHeight()
        });
        if (layout === "force") layout = "forceAtlas2";
         // Stop previous layout
        this.stopLayout(seriesModel, ecModel, api, {
            beforeLayout: true
        });
        var nodeData = seriesModel.getData();
        var edgeData = seriesModel.getData();
        if (layout === "forceAtlas2") {
            var layoutModel = seriesModel.getModel("forceAtlas2");
            var layoutInstance = this._forceLayoutInstance;
            var nodes = [];
            var edges = [];
            var nodeDataExtent = nodeData.getDataExtent("value");
            var edgeDataExtent = edgeData.getDataExtent("value");
            var edgeWeightRange = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(layoutModel.get("edgeWeight"), 1.0);
            var nodeWeightRange = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(layoutModel.get("nodeWeight"), 1.0);
            if (typeof edgeWeightRange === "number") edgeWeightRange = [
                edgeWeightRange,
                edgeWeightRange
            ];
            if (typeof nodeWeightRange === "number") nodeWeightRange = [
                nodeWeightRange,
                nodeWeightRange
            ];
            var offset = 0;
            var nodesIndicesMap = {};
            var layoutPoints = new Float32Array(nodeData.count() * 2);
            graph.eachNode(function(node) {
                var dataIndex = node.dataIndex;
                var value = nodeData.get("value", dataIndex);
                var x;
                var y;
                if (nodeData.hasItemOption) {
                    var itemModel = nodeData.getItemModel(dataIndex);
                    x = itemModel.get("x");
                    y = itemModel.get("y");
                }
                if (x == null) {
                    // Random in rectangle
                    x = viewport.x + Math.random() * viewport.width;
                    y = viewport.y + Math.random() * viewport.height;
                }
                layoutPoints[offset * 2] = x;
                layoutPoints[offset * 2 + 1] = y;
                nodesIndicesMap[node.id] = offset++;
                var mass = $880e2355a7de9d0c$exports.linearMap(value, nodeDataExtent, nodeWeightRange);
                if (isNaN(mass)) {
                    if (!isNaN(nodeWeightRange[0])) mass = nodeWeightRange[0];
                    else mass = 1;
                }
                nodes.push({
                    x: x,
                    y: y,
                    mass: mass,
                    size: nodeData.getItemVisual(dataIndex, "symbolSize")
                });
            });
            nodeData.setLayout("points", layoutPoints);
            graph.eachEdge(function(edge) {
                var dataIndex = edge.dataIndex;
                var value = nodeData.get("value", dataIndex);
                var weight = $880e2355a7de9d0c$exports.linearMap(value, edgeDataExtent, edgeWeightRange);
                if (isNaN(weight)) {
                    if (!isNaN(edgeWeightRange[0])) weight = edgeWeightRange[0];
                    else weight = 1;
                }
                edges.push({
                    node1: nodesIndicesMap[edge.node1.id],
                    node2: nodesIndicesMap[edge.node2.id],
                    weight: weight,
                    dataIndex: dataIndex
                });
            });
            if (!layoutInstance) {
                var isGPU = layoutModel.get("GPU");
                if (this._forceLayoutInstance) {
                    if (isGPU && !(this._forceLayoutInstance instanceof (0, $16049f20505649c2$export$2e2bcd8739ae039)) || !isGPU && !(this._forceLayoutInstance instanceof (0, $df4bc25ce3d9ab61$export$2e2bcd8739ae039))) // Mark to dispose
                    this._forceLayoutInstanceToDispose = this._forceLayoutInstance;
                }
                layoutInstance = this._forceLayoutInstance = isGPU ? new (0, $16049f20505649c2$export$2e2bcd8739ae039)() : new (0, $df4bc25ce3d9ab61$export$2e2bcd8739ae039)();
            }
            layoutInstance.initData(nodes, edges);
            layoutInstance.updateOption(layoutModel.option); // Update lines geometry after first layout;
            this._updateForceEdgesGeometry(layoutInstance.getEdges(), seriesModel);
            this._updatePositionTexture();
            api.dispatchAction({
                type: "graphGLStartLayout",
                from: this.uid
            });
        } else {
            var layoutPoints = new Float32Array(nodeData.count() * 2);
            var offset = 0;
            graph.eachNode(function(node) {
                var dataIndex = node.dataIndex;
                var x;
                var y;
                if (nodeData.hasItemOption) {
                    var itemModel = nodeData.getItemModel(dataIndex);
                    x = itemModel.get("x");
                    y = itemModel.get("y");
                }
                layoutPoints[offset++] = x;
                layoutPoints[offset++] = y;
            });
            nodeData.setLayout("points", layoutPoints);
            this._updateAfterLayout(seriesModel, ecModel, api);
        }
    },
    _updatePositionTexture: function() {
        var positionTex = this._forceLayoutInstance.getNodePositionTexture();
        this._pointsBuilder.setPositionTexture(positionTex);
        this._forceEdgesMesh.material.set("positionTex", positionTex);
    },
    startLayout: function(seriesModel, ecModel, api, payload) {
        if (payload && payload.from != null && payload.from !== this.uid) return;
        var viewGL = this.viewGL;
        var api = this._api;
        var layoutInstance = this._forceLayoutInstance;
        var data = this._model.getData();
        var layoutModel = this._model.getModel("forceAtlas2");
        if (!layoutInstance) return;
        this.groupGL.remove(this._edgesMesh);
        this.groupGL.add(this._forceEdgesMesh);
        if (!this._forceLayoutInstance) return;
        this._updateForceNodesGeometry(seriesModel.getData());
        this._pointsBuilder.hideLabels();
        var self = this;
        var layoutId = this._layoutId = $a6cb5a0c73a6f986$var$globalLayoutId++;
        var maxSteps = layoutModel.getShallow("maxSteps");
        var steps = layoutModel.getShallow("steps");
        var stepsCount = 0;
        var syncStepCount = Math.max(steps * 2, 20);
        var doLayout = function(layoutId) {
            if (layoutId !== self._layoutId) return;
            if (layoutInstance.isFinished(maxSteps)) {
                api.dispatchAction({
                    type: "graphGLStopLayout",
                    from: self.uid
                });
                api.dispatchAction({
                    type: "graphGLFinishLayout",
                    points: data.getLayout("points"),
                    from: self.uid
                });
                return;
            }
            layoutInstance.update(viewGL.layer.renderer, steps, function() {
                self._updatePositionTexture(); // PENDING Performance.
                stepsCount += steps; // Sync posiiton every 20 steps.
                if (stepsCount >= syncStepCount) {
                    self._syncNodePosition(seriesModel);
                    stepsCount = 0;
                } // Position texture will been swapped. set every time.
                api.getZr().refresh();
                (0, $731d42ad1858cd4c$export$2e2bcd8739ae039)(function() {
                    doLayout(layoutId);
                });
            });
        };
        (0, $731d42ad1858cd4c$export$2e2bcd8739ae039)(function() {
            if (self._forceLayoutInstanceToDispose) {
                self._forceLayoutInstanceToDispose.dispose(viewGL.layer.renderer);
                self._forceLayoutInstanceToDispose = null;
            }
            doLayout(layoutId);
        });
        this._layouting = true;
    },
    stopLayout: function(seriesModel, ecModel, api, payload) {
        if (payload && payload.from != null && payload.from !== this.uid) return;
        this._layoutId = 0;
        this.groupGL.remove(this._forceEdgesMesh);
        this.groupGL.add(this._edgesMesh);
        if (!this._forceLayoutInstance) return;
        if (!this.viewGL.layer) return;
        if (!(payload && payload.beforeLayout)) {
            this._syncNodePosition(seriesModel);
            this._updateAfterLayout(seriesModel, ecModel, api);
        }
        this._api.getZr().refresh();
        this._layouting = false;
    },
    _syncNodePosition: function(seriesModel) {
        var points = this._forceLayoutInstance.getNodePosition(this.viewGL.layer.renderer);
        seriesModel.getData().setLayout("points", points);
        seriesModel.setNodePosition(points);
    },
    _updateAfterLayout: function(seriesModel, ecModel, api) {
        this._updateMeshLinesGeometry();
        this._pointsBuilder.removePositionTexture();
        this._pointsBuilder.updateLayout(seriesModel, ecModel, api);
        this._pointsBuilder.updateView(this.viewGL.camera);
        this._pointsBuilder.updateLabels();
        this._pointsBuilder.showLabels();
    },
    focusNodeAdjacency: function(seriesModel, ecModel, api, payload) {
        var data = this._model.getData();
        this._downplayAll();
        var dataIndex = payload.dataIndex;
        var graph = data.graph;
        var focusNodes = [];
        var node = graph.getNodeByIndex(dataIndex);
        focusNodes.push(node);
        node.edges.forEach(function(edge) {
            if (edge.dataIndex < 0) return;
            edge.node1 !== node && focusNodes.push(edge.node1);
            edge.node2 !== node && focusNodes.push(edge.node2);
        }, this);
        this._pointsBuilder.fadeOutAll(0.05);
        this._fadeOutEdgesAll(0.05);
        focusNodes.forEach(function(node) {
            this._pointsBuilder.highlight(data, node.dataIndex);
        }, this);
        this._pointsBuilder.updateLabels(focusNodes.map(function(node) {
            return node.dataIndex;
        }));
        var focusEdges = [];
        node.edges.forEach(function(edge) {
            if (edge.dataIndex >= 0) {
                this._highlightEdge(edge.dataIndex);
                focusEdges.push(edge);
            }
        }, this);
        this._focusNodes = focusNodes;
        this._focusEdges = focusEdges;
    },
    unfocusNodeAdjacency: function(seriesModel, ecModel, api, payload) {
        this._downplayAll();
        this._pointsBuilder.fadeInAll();
        this._fadeInEdgesAll();
        this._pointsBuilder.updateLabels();
    },
    _highlightEdge: function(dataIndex) {
        var itemModel = this._model.getEdgeData().getItemModel(dataIndex);
        var emphasisColor = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(itemModel.get("emphasis.lineStyle.color") || itemModel.get("lineStyle.color"));
        var emphasisOpacity = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(itemModel.get("emphasis.lineStyle.opacity"), itemModel.get("lineStyle.opacity"), 1);
        emphasisColor[3] *= emphasisOpacity;
        this._edgesMesh.geometry.setItemColor(this._edgeIndicesMap[dataIndex], emphasisColor);
    },
    _downplayAll: function() {
        if (this._focusNodes) this._focusNodes.forEach(function(node) {
            this._pointsBuilder.downplay(this._model.getData(), node.dataIndex);
        }, this);
        if (this._focusEdges) this._focusEdges.forEach(function(edge) {
            this._downplayEdge(edge.dataIndex);
        }, this);
    },
    _downplayEdge: function(dataIndex) {
        var color = this._getColor(dataIndex, []);
        this._edgesMesh.geometry.setItemColor(this._edgeIndicesMap[dataIndex], color);
    },
    _setEdgeFade: function() {
        var color = [];
        return function(dataIndex, percent) {
            this._getColor(dataIndex, color);
            color[3] *= percent;
            this._edgesMesh.geometry.setItemColor(this._edgeIndicesMap[dataIndex], color);
        };
    }(),
    _getColor: function(dataIndex, out) {
        for(var i = 0; i < 4; i++)out[i] = this._originalEdgeColors[dataIndex * 4 + i];
        return out;
    },
    _fadeOutEdgesAll: function(percent) {
        var graph = this._model.getData().graph;
        graph.eachEdge(function(edge) {
            this._setEdgeFade(edge.dataIndex, percent);
        }, this);
    },
    _fadeInEdgesAll: function() {
        this._fadeOutEdgesAll(1);
    },
    _updateCamera: function(seriesModel, api) {
        this.viewGL.setViewport(0, 0, api.getWidth(), api.getHeight(), api.getDevicePixelRatio());
        var camera = this.viewGL.camera;
        var nodeData = seriesModel.getData();
        var points = nodeData.getLayout("points");
        var min = $a6cb5a0c73a6f986$var$vec2.create(Infinity, Infinity);
        var max = $a6cb5a0c73a6f986$var$vec2.create(-Infinity, -Infinity);
        var pt = [];
        for(var i = 0; i < points.length;){
            pt[0] = points[i++];
            pt[1] = points[i++];
            $a6cb5a0c73a6f986$var$vec2.min(min, min, pt);
            $a6cb5a0c73a6f986$var$vec2.max(max, max, pt);
        }
        var cy = (max[1] + min[1]) / 2;
        var cx = (max[0] + min[0]) / 2; // Only fit the camera when graph is not in the center.
        // PENDING
        if (cx > camera.left && cx < camera.right && cy < camera.bottom && cy > camera.top) return;
         // Scale a bit
        var width = Math.max(max[0] - min[0], 10); // Keep aspect
        var height = width / api.getWidth() * api.getHeight();
        width *= 1.4;
        height *= 1.4;
        min[0] -= width * 0.2;
        camera.left = min[0];
        camera.top = cy - height / 2;
        camera.bottom = cy + height / 2;
        camera.right = width + min[0];
        camera.near = 0;
        camera.far = 100;
    },
    dispose: function() {
        var renderer = this.viewGL.layer.renderer;
        if (this._forceLayoutInstance) this._forceLayoutInstance.dispose(renderer);
        this.groupGL.removeAll(); // Stop layout.
        this._layoutId = -1;
        this._pointsBuilder.dispose();
    },
    remove: function() {
        this.groupGL.removeAll();
        this._control.dispose();
    }
});


function $c9ff664e1ea666a1$var$normalize(a) {
    if (!(a instanceof Array)) a = [
        a,
        a
    ];
    return a;
}
function $c9ff664e1ea666a1$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $a6cb5a0c73a6f986$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $dbebea644a870a83$export$2e2bcd8739ae039));
    registers.registerVisual(function(ecModel) {
        const paletteScope = {};
        ecModel.eachSeriesByType("graphGL", function(seriesModel) {
            var categoriesData = seriesModel.getCategoriesData();
            var data = seriesModel.getData();
            var categoryNameIdxMap = {};
            categoriesData.each(function(idx) {
                var name = categoriesData.getName(idx); // Add prefix to avoid conflict with Object.prototype.
                categoryNameIdxMap["ec-" + name] = idx;
                var itemModel = categoriesData.getItemModel(idx);
                var style = itemModel.getModel("itemStyle").getItemStyle();
                if (!style.fill) // Get color from palette.
                style.fill = seriesModel.getColorFromPalette(name, paletteScope);
                categoriesData.setItemVisual(idx, "style", style);
                var symbolVisualList = [
                    "symbol",
                    "symbolSize",
                    "symbolKeepAspect"
                ];
                for(let i = 0; i < symbolVisualList.length; i++){
                    var symbolVisual = itemModel.getShallow(symbolVisualList[i], true);
                    if (symbolVisual != null) categoriesData.setItemVisual(idx, symbolVisualList[i], symbolVisual);
                }
            }); // Assign category color to visual
            if (categoriesData.count()) data.each(function(idx) {
                var model = data.getItemModel(idx);
                let categoryIdx = model.getShallow("category");
                if (categoryIdx != null) {
                    if (typeof categoryIdx === "string") categoryIdx = categoryNameIdxMap["ec-" + categoryIdx];
                    var categoryStyle = categoriesData.getItemVisual(categoryIdx, "style");
                    var style = data.ensureUniqueItemVisual(idx, "style");
                    $224386f1517b5dca$exports.extend(style, categoryStyle);
                    var visualList = [
                        "symbol",
                        "symbolSize",
                        "symbolKeepAspect"
                    ];
                    for(let i = 0; i < visualList.length; i++)data.setItemVisual(idx, visualList[i], categoriesData.getItemVisual(categoryIdx, visualList[i]));
                }
            });
        });
    });
    registers.registerVisual(function(ecModel) {
        ecModel.eachSeriesByType("graphGL", function(seriesModel) {
            var graph = seriesModel.getGraph();
            var edgeData = seriesModel.getEdgeData();
            var symbolType = $c9ff664e1ea666a1$var$normalize(seriesModel.get("edgeSymbol"));
            var symbolSize = $c9ff664e1ea666a1$var$normalize(seriesModel.get("edgeSymbolSize"));
            edgeData.setVisual("drawType", "stroke"); // var colorQuery = ['lineStyle', 'color'];
            // var opacityQuery = ['lineStyle', 'opacity'];
            edgeData.setVisual("fromSymbol", symbolType && symbolType[0]);
            edgeData.setVisual("toSymbol", symbolType && symbolType[1]);
            edgeData.setVisual("fromSymbolSize", symbolSize && symbolSize[0]);
            edgeData.setVisual("toSymbolSize", symbolSize && symbolSize[1]);
            edgeData.setVisual("style", seriesModel.getModel("lineStyle").getLineStyle());
            edgeData.each(function(idx) {
                var itemModel = edgeData.getItemModel(idx);
                var edge = graph.getEdgeByIndex(idx);
                var symbolType = $c9ff664e1ea666a1$var$normalize(itemModel.getShallow("symbol", true));
                var symbolSize = $c9ff664e1ea666a1$var$normalize(itemModel.getShallow("symbolSize", true)); // Edge visual must after node visual
                var style = itemModel.getModel("lineStyle").getLineStyle();
                var existsStyle = edgeData.ensureUniqueItemVisual(idx, "style");
                $224386f1517b5dca$exports.extend(existsStyle, style);
                switch(existsStyle.stroke){
                    case "source":
                        var nodeStyle = edge.node1.getVisual("style");
                        existsStyle.stroke = nodeStyle && nodeStyle.fill;
                        break;
                    case "target":
                        var nodeStyle = edge.node2.getVisual("style");
                        existsStyle.stroke = nodeStyle && nodeStyle.fill;
                        break;
                }
                symbolType[0] && edge.setVisual("fromSymbol", symbolType[0]);
                symbolType[1] && edge.setVisual("toSymbol", symbolType[1]);
                symbolSize[0] && edge.setVisual("fromSymbolSize", symbolSize[0]);
                symbolSize[1] && edge.setVisual("toSymbolSize", symbolSize[1]);
            });
        });
    });
    registers.registerAction({
        type: "graphGLRoam",
        event: "graphglroam",
        update: "series.graphGL:roam"
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: "series",
            query: payload
        }, function(componentModel) {
            componentModel.setView(payload);
        });
    });
    function noop() {}
    registers.registerAction({
        type: "graphGLStartLayout",
        event: "graphgllayoutstarted",
        update: "series.graphGL:startLayout"
    }, noop);
    registers.registerAction({
        type: "graphGLStopLayout",
        event: "graphgllayoutstopped",
        update: "series.graphGL:stopLayout"
    }, noop);
    registers.registerAction({
        type: "graphGLFocusNodeAdjacency",
        event: "graphGLFocusNodeAdjacency",
        update: "series.graphGL:focusNodeAdjacency"
    }, noop);
    registers.registerAction({
        type: "graphGLUnfocusNodeAdjacency",
        event: "graphGLUnfocusNodeAdjacency",
        update: "series.graphGL:unfocusNodeAdjacency"
    }, noop);
}


(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $c9ff664e1ea666a1$export$4b3e715f166fdd78));



// TODO ECharts GL must be imported whatever component,charts is imported.


var $cee7b7bb004764f2$export$2e2bcd8739ae039 = $7c10febb2cdef0d8$export$2e2bcd8739ae039.extend({
    type: "series.flowGL",
    dependencies: [
        "geo",
        "grid",
        "bmap"
    ],
    visualStyleAccessPath: "itemStyle",
    getInitialData: function(option, ecModel) {
        var coordType = this.get("coordinateSystem"); // TODO hotfix for the bug in echarts that get coord dimensions is undefined.
        var coordSysDimensions = coordType === "geo" ? [
            "lng",
            "lat"
        ] : $4d59907f44a2d0ad$export$fc2638719e4159b9(coordType) || [
            "x",
            "y"
        ];
        coordSysDimensions.push("vx", "vy");
        var dimensions = $9a616079ee96a3f3$exports.createDimensions(this.getSource(), {
            coordDimensions: coordSysDimensions,
            encodeDefine: this.get("encode"),
            dimensionsDefine: this.get("dimensions")
        });
        var data = new $0ab0556b819346fd$export$2e2bcd8739ae039(dimensions, this);
        data.initData(this.getSource());
        return data;
    },
    defaultOption: {
        coordinateSystem: "cartesian2d",
        zlevel: 10,
        supersampling: 1,
        // 128x128 particles
        particleType: "point",
        particleDensity: 128,
        particleSize: 1,
        particleSpeed: 1,
        particleTrail: 2,
        colorTexture: null,
        gridWidth: "auto",
        gridHeight: "auto",
        itemStyle: {
            color: "#fff",
            opacity: 0.8
        }
    }
});
















/**
 * Lines geometry
 * Use screen space projected lines lineWidth > MAX_LINE_WIDTH
 * https://mattdesl.svbtle.com/drawing-lines-is-hard
 * @module echarts-gl/util/geometry/LinesGeometry
 * @author Yi Shen(http://github.com/pissang)
 */ 

/**
 * @constructor
 * @alias module:echarts-gl/chart/flowGL/Line2D
 * @extends clay.Geometry
 */ var $8720da22cdf54e63$var$LinesGeometry = (0, $c75c69a759bf7591$export$2e2bcd8739ae039).extend(function() {
    return {
        dynamic: true,
        attributes: {
            position: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039).Attribute("position", "float", 3, "POSITION")
        }
    };
}, /** @lends module: echarts-gl/util/geometry/LinesGeometry.prototype */ {
    /**
   * Reset offset
   */ resetOffset: function() {
        this._vertexOffset = 0;
        this._faceOffset = 0;
    },
    /**
   * @param {number} nVertex
   */ setLineCount: function(nLine) {
        var attributes = this.attributes;
        var nVertex = 4 * nLine;
        var nTriangle = 2 * nLine;
        if (this.vertexCount !== nVertex) attributes.position.init(nVertex);
        if (this.triangleCount !== nTriangle) {
            if (nTriangle === 0) this.indices = null;
            else this.indices = this.vertexCount > 0xffff ? new Uint32Array(nTriangle * 3) : new Uint16Array(nTriangle * 3);
        }
    },
    addLine: function(p) {
        var vertexOffset = this._vertexOffset;
        this.attributes.position.set(vertexOffset, [
            p[0],
            p[1],
            1
        ]);
        this.attributes.position.set(vertexOffset + 1, [
            p[0],
            p[1],
            -1
        ]);
        this.attributes.position.set(vertexOffset + 2, [
            p[0],
            p[1],
            2
        ]);
        this.attributes.position.set(vertexOffset + 3, [
            p[0],
            p[1],
            -2
        ]);
        this.setTriangleIndices(this._faceOffset++, [
            vertexOffset,
            vertexOffset + 1,
            vertexOffset + 2
        ]);
        this.setTriangleIndices(this._faceOffset++, [
            vertexOffset + 1,
            vertexOffset + 2,
            vertexOffset + 3
        ]);
        this._vertexOffset += 4;
    }
});
var $8720da22cdf54e63$export$2e2bcd8739ae039 = $8720da22cdf54e63$var$LinesGeometry;


var $e6f49c135f35f63c$export$2e2bcd8739ae039 = "@export ecgl.vfParticle.particle.fragment\n\nuniform sampler2D particleTexture;\nuniform sampler2D spawnTexture;\nuniform sampler2D velocityTexture;\n\nuniform float deltaTime;\nuniform float elapsedTime;\n\nuniform float speedScaling : 1.0;\n\nuniform vec2 textureSize;\nuniform vec4 region : [0, 0, 1, 1];\nuniform float firstFrameTime;\n\nvarying vec2 v_Texcoord;\n\n\nvoid main()\n{\n vec4 p = texture2D(particleTexture, v_Texcoord);\n bool spawn = false;\n if (p.w <= 0.0) {\n p = texture2D(spawnTexture, fract(v_Texcoord + elapsedTime / 10.0));\n p.w -= firstFrameTime;\n spawn = true;\n }\n vec2 v = texture2D(velocityTexture, fract(p.xy * region.zw + region.xy)).xy;\n v = (v - 0.5) * 2.0;\n p.z = length(v);\n p.xy += v * deltaTime / 10.0 * speedScaling;\n p.w -= deltaTime;\n\n if (spawn || p.xy != fract(p.xy)) {\n p.z = 0.0;\n }\n p.xy = fract(p.xy);\n\n gl_FragColor = p;\n}\n@end\n\n@export ecgl.vfParticle.renderPoints.vertex\n\n#define PI 3.1415926\n\nattribute vec2 texcoord : TEXCOORD_0;\n\nuniform sampler2D particleTexture;\nuniform mat4 worldViewProjection : WORLDVIEWPROJECTION;\n\nuniform float size : 1.0;\n\nvarying float v_Mag;\nvarying vec2 v_Uv;\n\nvoid main()\n{\n vec4 p = texture2D(particleTexture, texcoord);\n\n if (p.w > 0.0 && p.z > 1e-5) {\n gl_Position = worldViewProjection * vec4(p.xy * 2.0 - 1.0, 0.0, 1.0);\n }\n else {\n gl_Position = vec4(100000.0, 100000.0, 100000.0, 1.0);\n }\n\n v_Mag = p.z;\n v_Uv = p.xy;\n\n gl_PointSize = size;\n}\n\n@end\n\n@export ecgl.vfParticle.renderPoints.fragment\n\nuniform vec4 color : [1.0, 1.0, 1.0, 1.0];\nuniform sampler2D gradientTexture;\nuniform sampler2D colorTexture;\nuniform sampler2D spriteTexture;\n\nvarying float v_Mag;\nvarying vec2 v_Uv;\n\nvoid main()\n{\n gl_FragColor = color;\n#ifdef SPRITETEXTURE_ENABLED\n gl_FragColor *= texture2D(spriteTexture, gl_PointCoord);\n if (color.a == 0.0) {\n discard;\n }\n#endif\n#ifdef GRADIENTTEXTURE_ENABLED\n gl_FragColor *= texture2D(gradientTexture, vec2(v_Mag, 0.5));\n#endif\n#ifdef COLORTEXTURE_ENABLED\n gl_FragColor *= texture2D(colorTexture, v_Uv);\n#endif\n}\n\n@end\n\n@export ecgl.vfParticle.renderLines.vertex\n\n#define PI 3.1415926\n\nattribute vec3 position : POSITION;\n\nuniform sampler2D particleTexture;\nuniform sampler2D prevParticleTexture;\n\nuniform float size : 1.0;\nuniform vec4 vp: VIEWPORT;\nuniform mat4 worldViewProjection : WORLDVIEWPROJECTION;\n\nvarying float v_Mag;\nvarying vec2 v_Uv;\n\n@import clay.util.rand\n\nvoid main()\n{\n vec4 p = texture2D(particleTexture, position.xy);\n vec4 p2 = texture2D(prevParticleTexture, position.xy);\n\n p.xy = p.xy * 2.0 - 1.0;\n p2.xy = p2.xy * 2.0 - 1.0;\n\n if (p.w > 0.0 && p.z > 1e-5) {\n vec2 dir = normalize(p.xy - p2.xy);\n vec2 norm = vec2(dir.y / vp.z, -dir.x / vp.w) * sign(position.z) * size;\n if (abs(position.z) == 2.0) {\n gl_Position = vec4(p.xy + norm, 0.0, 1.0);\n v_Uv = p.xy;\n v_Mag = p.z;\n }\n else {\n gl_Position = vec4(p2.xy + norm, 0.0, 1.0);\n v_Mag = p2.z;\n v_Uv = p2.xy;\n }\n gl_Position = worldViewProjection * gl_Position;\n }\n else {\n gl_Position = vec4(100000.0, 100000.0, 100000.0, 1.0);\n }\n}\n\n@end\n\n@export ecgl.vfParticle.renderLines.fragment\n\nuniform vec4 color : [1.0, 1.0, 1.0, 1.0];\nuniform sampler2D gradientTexture;\nuniform sampler2D colorTexture;\n\nvarying float v_Mag;\nvarying vec2 v_Uv;\n\nvoid main()\n{\n gl_FragColor = color;\n #ifdef GRADIENTTEXTURE_ENABLED\n gl_FragColor *= texture2D(gradientTexture, vec2(v_Mag, 0.5));\n#endif\n#ifdef COLORTEXTURE_ENABLED\n gl_FragColor *= texture2D(colorTexture, v_Uv);\n#endif\n}\n\n@end\n";


(0, $90e78c81ac16d455$export$2e2bcd8739ae039)["import"]((0, $e6f49c135f35f63c$export$2e2bcd8739ae039));
function $719f0b1c3785d6af$var$createSpriteCanvas(size) {
    var canvas = document.createElement("canvas");
    canvas.width = canvas.height = size;
    var ctx = canvas.getContext("2d");
    ctx.fillStyle = "#fff";
    ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
    ctx.fill();
    return canvas;
} // import spriteUtil from '../../util/sprite';
var $719f0b1c3785d6af$var$VectorFieldParticleSurface = function() {
    /**
   * @type {number}
   */ this.motionBlurFactor = 0.99;
    /**
   * Vector field lookup image
   * @type {clay.Texture2D}
   */ this.vectorFieldTexture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)({
        type: (0, $4261427f149675a4$export$2e2bcd8739ae039).FLOAT,
        // minFilter: Texture.NEAREST,
        // magFilter: Texture.NEAREST,
        flipY: false
    });
    /**
   * Particle life range
   * @type {Array.<number>}
   */ this.particleLife = [
        5,
        20
    ];
    this._particleType = "point";
    /**
   * @type {number}
   */ this._particleSize = 1;
    /**
   * @type {Array.<number>}
   */ this.particleColor = [
        1,
        1,
        1,
        1
    ];
    /**
   * @type {number}
   */ this.particleSpeedScaling = 1.0;
    /**
   * @type {clay.Texture2D}
   */ this._thisFrameTexture = null;
    this._particlePass = null;
    this._spawnTexture = null;
    this._particleTexture0 = null;
    this._particleTexture1 = null;
    this._particlePointsMesh = null;
    this._surfaceFrameBuffer = null;
    this._elapsedTime = 0.0;
    this._scene = null;
    this._camera = null;
    this._lastFrameTexture = null; // this._temporalSS = new TemporalSS(50);
    // this._antialising = false;
    this._supersampling = 1;
    this._downsampleTextures = [];
    this._width = 512;
    this._height = 512;
    this.init();
};
$719f0b1c3785d6af$var$VectorFieldParticleSurface.prototype = {
    constructor: $719f0b1c3785d6af$var$VectorFieldParticleSurface,
    init: function() {
        var parameters = {
            type: (0, $4261427f149675a4$export$2e2bcd8739ae039).FLOAT,
            minFilter: (0, $4261427f149675a4$export$2e2bcd8739ae039).NEAREST,
            magFilter: (0, $4261427f149675a4$export$2e2bcd8739ae039).NEAREST,
            useMipmap: false
        };
        this._spawnTexture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)(parameters);
        this._particleTexture0 = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)(parameters);
        this._particleTexture1 = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)(parameters);
        this._frameBuffer = new (0, $03d0b3c43006f961$export$2e2bcd8739ae039)({
            depthBuffer: false
        });
        this._particlePass = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
            fragment: (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("ecgl.vfParticle.particle.fragment")
        });
        this._particlePass.setUniform("velocityTexture", this.vectorFieldTexture);
        this._particlePass.setUniform("spawnTexture", this._spawnTexture);
        this._downsamplePass = new (0, $d7434f22747948c5$export$2e2bcd8739ae039)({
            fragment: (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("clay.compositor.downsample")
        });
        var particlePointsMesh = new (0, $652fd5cc6a0444a2$export$2e2bcd8739ae039)({
            // Render after last frame full quad
            renderOrder: 10,
            material: new (0, $b70ebca493753aba$export$2e2bcd8739ae039)({
                shader: new (0, $90e78c81ac16d455$export$2e2bcd8739ae039)((0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("ecgl.vfParticle.renderPoints.vertex"), (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("ecgl.vfParticle.renderPoints.fragment"))
            }),
            mode: (0, $652fd5cc6a0444a2$export$2e2bcd8739ae039).POINTS,
            geometry: new (0, $c75c69a759bf7591$export$2e2bcd8739ae039)({
                dynamic: true,
                mainAttribute: "texcoord0"
            })
        });
        var particleLinesMesh = new (0, $652fd5cc6a0444a2$export$2e2bcd8739ae039)({
            // Render after last frame full quad
            renderOrder: 10,
            material: new (0, $b70ebca493753aba$export$2e2bcd8739ae039)({
                shader: new (0, $90e78c81ac16d455$export$2e2bcd8739ae039)((0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("ecgl.vfParticle.renderLines.vertex"), (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("ecgl.vfParticle.renderLines.fragment"))
            }),
            geometry: new (0, $8720da22cdf54e63$export$2e2bcd8739ae039)(),
            culling: false
        });
        var lastFrameFullQuad = new (0, $652fd5cc6a0444a2$export$2e2bcd8739ae039)({
            material: new (0, $b70ebca493753aba$export$2e2bcd8739ae039)({
                shader: new (0, $90e78c81ac16d455$export$2e2bcd8739ae039)((0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("ecgl.color.vertex"), (0, $90e78c81ac16d455$export$2e2bcd8739ae039).source("ecgl.color.fragment")) // DO NOT BLEND Blend will multiply alpha
            }),
            geometry: new (0, $b1c813646bb685e2$export$2e2bcd8739ae039)()
        });
        lastFrameFullQuad.material.enableTexture("diffuseMap");
        this._particlePointsMesh = particlePointsMesh;
        this._particleLinesMesh = particleLinesMesh;
        this._lastFrameFullQuadMesh = lastFrameFullQuad;
        this._camera = new (0, $c4a0e1584dbfc1e9$export$2e2bcd8739ae039)();
        this._thisFrameTexture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)();
        this._lastFrameTexture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)();
    },
    setParticleDensity: function(width, height) {
        var nVertex = width * height;
        var spawnTextureData = new Float32Array(nVertex * 4);
        var off = 0;
        var lifeRange = this.particleLife;
        for(var i = 0; i < width; i++)for(var j = 0; j < height; j++, off++){
            // x position, range [0 - 1]
            spawnTextureData[off * 4] = Math.random(); // y position, range [0 - 1]
            spawnTextureData[off * 4 + 1] = Math.random(); // Some property
            spawnTextureData[off * 4 + 2] = Math.random();
            var life = (lifeRange[1] - lifeRange[0]) * Math.random() + lifeRange[0]; // Particle life
            spawnTextureData[off * 4 + 3] = life;
        }
        if (this._particleType === "line") this._setLineGeometry(width, height);
        else this._setPointsGeometry(width, height);
        this._spawnTexture.width = width;
        this._spawnTexture.height = height;
        this._spawnTexture.pixels = spawnTextureData;
        this._particleTexture0.width = this._particleTexture1.width = width;
        this._particleTexture0.height = this._particleTexture1.height = height;
        this._particlePass.setUniform("textureSize", [
            width,
            height
        ]);
    },
    _setPointsGeometry: function(width, height) {
        var nVertex = width * height;
        var geometry = this._particlePointsMesh.geometry;
        var attributes = geometry.attributes;
        attributes.texcoord0.init(nVertex);
        var off = 0;
        for(var i = 0; i < width; i++)for(var j = 0; j < height; j++, off++){
            attributes.texcoord0.value[off * 2] = i / width;
            attributes.texcoord0.value[off * 2 + 1] = j / height;
        }
        geometry.dirty();
    },
    _setLineGeometry: function(width, height) {
        var nLine = width * height;
        var geometry = this._getParticleMesh().geometry;
        geometry.setLineCount(nLine);
        geometry.resetOffset();
        for(var i = 0; i < width; i++)for(var j = 0; j < height; j++)geometry.addLine([
            i / width,
            j / height
        ]);
        geometry.dirty();
    },
    _getParticleMesh: function() {
        return this._particleType === "line" ? this._particleLinesMesh : this._particlePointsMesh;
    },
    update: function(renderer, api, deltaTime, firstFrame) {
        var particleMesh = this._getParticleMesh();
        var frameBuffer = this._frameBuffer;
        var particlePass = this._particlePass;
        if (firstFrame) this._updateDownsampleTextures(renderer, api);
        particleMesh.material.set("size", this._particleSize * this._supersampling);
        particleMesh.material.set("color", this.particleColor);
        particlePass.setUniform("speedScaling", this.particleSpeedScaling);
        frameBuffer.attach(this._particleTexture1);
        particlePass.setUniform("firstFrameTime", firstFrame ? (this.particleLife[1] + this.particleLife[0]) / 2 : 0);
        particlePass.setUniform("particleTexture", this._particleTexture0);
        particlePass.setUniform("deltaTime", deltaTime);
        particlePass.setUniform("elapsedTime", this._elapsedTime);
        particlePass.render(renderer, frameBuffer);
        particleMesh.material.set("particleTexture", this._particleTexture1);
        particleMesh.material.set("prevParticleTexture", this._particleTexture0);
        frameBuffer.attach(this._thisFrameTexture);
        frameBuffer.bind(renderer);
        renderer.gl.clear(renderer.gl.DEPTH_BUFFER_BIT | renderer.gl.COLOR_BUFFER_BIT);
        var lastFrameFullQuad = this._lastFrameFullQuadMesh;
        lastFrameFullQuad.material.set("diffuseMap", this._lastFrameTexture);
        lastFrameFullQuad.material.set("color", [
            1,
            1,
            1,
            this.motionBlurFactor
        ]);
        this._camera.update(true);
        renderer.renderPass([
            lastFrameFullQuad,
            particleMesh
        ], this._camera);
        frameBuffer.unbind(renderer);
        this._downsample(renderer);
        this._swapTexture();
        this._elapsedTime += deltaTime;
    },
    _downsample: function(renderer) {
        var downsampleTextures = this._downsampleTextures;
        if (downsampleTextures.length === 0) return;
        var current = 0;
        var sourceTexture = this._thisFrameTexture;
        var targetTexture = downsampleTextures[current];
        while(targetTexture){
            this._frameBuffer.attach(targetTexture);
            this._downsamplePass.setUniform("texture", sourceTexture);
            this._downsamplePass.setUniform("textureSize", [
                sourceTexture.width,
                sourceTexture.height
            ]);
            this._downsamplePass.render(renderer, this._frameBuffer);
            sourceTexture = targetTexture;
            targetTexture = downsampleTextures[++current];
        }
    },
    getSurfaceTexture: function() {
        var downsampleTextures = this._downsampleTextures;
        return downsampleTextures.length > 0 ? downsampleTextures[downsampleTextures.length - 1] : this._lastFrameTexture;
    },
    setRegion: function(region) {
        this._particlePass.setUniform("region", region);
    },
    resize: function(width, height) {
        this._lastFrameTexture.width = width * this._supersampling;
        this._lastFrameTexture.height = height * this._supersampling;
        this._thisFrameTexture.width = width * this._supersampling;
        this._thisFrameTexture.height = height * this._supersampling;
        this._width = width;
        this._height = height;
    },
    setParticleSize: function(size) {
        var particleMesh = this._getParticleMesh();
        if (size <= 2) {
            particleMesh.material.disableTexture("spriteTexture");
            particleMesh.material.transparent = false;
            return;
        }
        if (!this._spriteTexture) this._spriteTexture = new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)();
        if (!this._spriteTexture.image || this._spriteTexture.image.width !== size) {
            this._spriteTexture.image = $719f0b1c3785d6af$var$createSpriteCanvas(size);
            this._spriteTexture.dirty();
        }
        particleMesh.material.transparent = true;
        particleMesh.material.enableTexture("spriteTexture");
        particleMesh.material.set("spriteTexture", this._spriteTexture);
        this._particleSize = size;
    },
    setGradientTexture: function(gradientTexture) {
        var material = this._getParticleMesh().material;
        material[gradientTexture ? "enableTexture" : "disableTexture"]("gradientTexture");
        material.setUniform("gradientTexture", gradientTexture);
    },
    setColorTextureImage: function(colorTextureImg, api) {
        var material = this._getParticleMesh().material;
        material.setTextureImage("colorTexture", colorTextureImg, api, {
            flipY: true
        });
    },
    setParticleType: function(type) {
        this._particleType = type;
    },
    clearFrame: function(renderer) {
        var frameBuffer = this._frameBuffer;
        frameBuffer.attach(this._lastFrameTexture);
        frameBuffer.bind(renderer);
        renderer.gl.clear(renderer.gl.DEPTH_BUFFER_BIT | renderer.gl.COLOR_BUFFER_BIT);
        frameBuffer.unbind(renderer);
    },
    setSupersampling: function(supersampling) {
        this._supersampling = supersampling;
        this.resize(this._width, this._height);
    },
    _updateDownsampleTextures: function(renderer, api) {
        var downsampleTextures = this._downsampleTextures;
        var upScale = Math.max(Math.floor(Math.log(this._supersampling / api.getDevicePixelRatio()) / Math.log(2)), 0);
        var scale = 2;
        var width = this._width * this._supersampling;
        var height = this._height * this._supersampling;
        for(var i = 0; i < upScale; i++){
            downsampleTextures[i] = downsampleTextures[i] || new (0, $b7751fad94c1afee$export$2e2bcd8739ae039)();
            downsampleTextures[i].width = width / scale;
            downsampleTextures[i].height = height / scale;
            scale *= 2;
        }
        for(; i < downsampleTextures.length; i++)downsampleTextures[i].dispose(renderer);
        downsampleTextures.length = upScale;
    },
    _swapTexture: function() {
        var tmp = this._particleTexture0;
        this._particleTexture0 = this._particleTexture1;
        this._particleTexture1 = tmp;
        var tmp = this._thisFrameTexture;
        this._thisFrameTexture = this._lastFrameTexture;
        this._lastFrameTexture = tmp;
    },
    dispose: function(renderer) {
        renderer.disposeFrameBuffer(this._frameBuffer); // Dispose textures
        renderer.disposeTexture(this.vectorFieldTexture);
        renderer.disposeTexture(this._spawnTexture);
        renderer.disposeTexture(this._particleTexture0);
        renderer.disposeTexture(this._particleTexture1);
        renderer.disposeTexture(this._thisFrameTexture);
        renderer.disposeTexture(this._lastFrameTexture);
        renderer.disposeGeometry(this._particleLinesMesh.geometry);
        renderer.disposeGeometry(this._particlePointsMesh.geometry);
        renderer.disposeGeometry(this._lastFrameFullQuadMesh.geometry);
        if (this._spriteTexture) renderer.disposeTexture(this._spriteTexture);
        this._particlePass.dispose(renderer);
        this._downsamplePass.dispose(renderer);
        this._downsampleTextures.forEach(function(texture) {
            texture.dispose(renderer);
        });
    }
};
var $719f0b1c3785d6af$export$2e2bcd8739ae039 = $719f0b1c3785d6af$var$VectorFieldParticleSurface;


var $2f7556b7f4817f5d$export$2e2bcd8739ae039 = $0dc5061053e23cd3$export$2e2bcd8739ae039.extend({
    type: "flowGL",
    __ecgl__: true,
    init: function(ecModel, api) {
        this.viewGL = new (0, $7a0cfdd3f7cf77fd$export$2e2bcd8739ae039)("orthographic");
        this.groupGL = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
        this.viewGL.add(this.groupGL);
        this._particleSurface = new (0, $719f0b1c3785d6af$export$2e2bcd8739ae039)();
        var planeMesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
            geometry: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).PlaneGeometry(),
            material: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
                shader: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader({
                    vertex: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.source("ecgl.color.vertex"),
                    fragment: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Shader.source("ecgl.color.fragment")
                }),
                // Must enable blending and multiply alpha.
                // Or premultipliedAlpha will let the alpha useless.
                transparent: true
            })
        });
        planeMesh.material.enableTexture("diffuseMap");
        this.groupGL.add(planeMesh);
        this._planeMesh = planeMesh;
    },
    render: function(seriesModel, ecModel, api) {
        var particleSurface = this._particleSurface; // Set particleType before set others.
        particleSurface.setParticleType(seriesModel.get("particleType"));
        particleSurface.setSupersampling(seriesModel.get("supersampling"));
        this._updateData(seriesModel, api);
        this._updateCamera(api.getWidth(), api.getHeight(), api.getDevicePixelRatio());
        var particleDensity = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(seriesModel.get("particleDensity"), 128);
        particleSurface.setParticleDensity(particleDensity, particleDensity);
        var planeMesh = this._planeMesh;
        var time = +new Date();
        var self = this;
        var firstFrame = true;
        planeMesh.__percent = 0;
        planeMesh.stopAnimation();
        planeMesh.animate("", {
            loop: true
        }).when(100000, {
            __percent: 1
        }).during(function() {
            var timeNow = +new Date();
            var dTime = Math.min(timeNow - time, 20);
            time = time + dTime;
            if (self._renderer) {
                particleSurface.update(self._renderer, api, dTime / 1000, firstFrame);
                planeMesh.material.set("diffuseMap", particleSurface.getSurfaceTexture()); // planeMesh.material.set('diffuseMap', self._particleSurface.vectorFieldTexture);
            }
            firstFrame = false;
        }).start();
        var itemStyleModel = seriesModel.getModel("itemStyle");
        var color = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor(itemStyleModel.get("color"));
        color[3] *= (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(itemStyleModel.get("opacity"), 1);
        planeMesh.material.set("color", color);
        particleSurface.setColorTextureImage(seriesModel.get("colorTexture"), api);
        particleSurface.setParticleSize(seriesModel.get("particleSize"));
        particleSurface.particleSpeedScaling = seriesModel.get("particleSpeed");
        particleSurface.motionBlurFactor = 1.0 - Math.pow(0.1, seriesModel.get("particleTrail"));
    },
    updateTransform: function(seriesModel, ecModel, api) {
        this._updateData(seriesModel, api);
    },
    afterRender: function(globeModel, ecModel, api, layerGL) {
        var renderer = layerGL.renderer;
        this._renderer = renderer;
    },
    _updateData: function(seriesModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var dims = coordSys.dimensions.map(function(coordDim) {
            return seriesModel.coordDimToDataDim(coordDim)[0];
        });
        var data = seriesModel.getData();
        var xExtent = data.getDataExtent(dims[0]);
        var yExtent = data.getDataExtent(dims[1]);
        var gridWidth = seriesModel.get("gridWidth");
        var gridHeight = seriesModel.get("gridHeight");
        if (gridWidth == null || gridWidth === "auto") {
            // TODO not accurate.
            var aspect = (xExtent[1] - xExtent[0]) / (yExtent[1] - yExtent[0]);
            gridWidth = Math.round(Math.sqrt(aspect * data.count()));
        }
        if (gridHeight == null || gridHeight === "auto") gridHeight = Math.ceil(data.count() / gridWidth);
        var vectorFieldTexture = this._particleSurface.vectorFieldTexture; // Half Float needs Uint16Array
        var pixels = vectorFieldTexture.pixels;
        if (!pixels || pixels.length !== gridHeight * gridWidth * 4) pixels = vectorFieldTexture.pixels = new Float32Array(gridWidth * gridHeight * 4);
        else for(var i = 0; i < pixels.length; i++)pixels[i] = 0;
        var maxMag = 0;
        var minMag = Infinity;
        var points = new Float32Array(data.count() * 2);
        var offset = 0;
        var bbox = [
            [
                Infinity,
                Infinity
            ],
            [
                -Infinity,
                -Infinity
            ]
        ];
        data.each([
            dims[0],
            dims[1],
            "vx",
            "vy"
        ], function(x, y, vx, vy) {
            var pt = coordSys.dataToPoint([
                x,
                y
            ]);
            points[offset++] = pt[0];
            points[offset++] = pt[1];
            bbox[0][0] = Math.min(pt[0], bbox[0][0]);
            bbox[0][1] = Math.min(pt[1], bbox[0][1]);
            bbox[1][0] = Math.max(pt[0], bbox[1][0]);
            bbox[1][1] = Math.max(pt[1], bbox[1][1]);
            var mag = Math.sqrt(vx * vx + vy * vy);
            maxMag = Math.max(maxMag, mag);
            minMag = Math.min(minMag, mag);
        });
        data.each([
            "vx",
            "vy"
        ], function(vx, vy, i) {
            var xPix = Math.round((points[i * 2] - bbox[0][0]) / (bbox[1][0] - bbox[0][0]) * (gridWidth - 1));
            var yPix = gridHeight - 1 - Math.round((points[i * 2 + 1] - bbox[0][1]) / (bbox[1][1] - bbox[0][1]) * (gridHeight - 1));
            var idx = (yPix * gridWidth + xPix) * 4;
            pixels[idx] = vx / maxMag * 0.5 + 0.5;
            pixels[idx + 1] = vy / maxMag * 0.5 + 0.5;
            pixels[idx + 3] = 1;
        });
        vectorFieldTexture.width = gridWidth;
        vectorFieldTexture.height = gridHeight;
        if (seriesModel.get("coordinateSystem") === "bmap") this._fillEmptyPixels(vectorFieldTexture);
        vectorFieldTexture.dirty();
        this._updatePlanePosition(bbox[0], bbox[1], seriesModel, api);
        this._updateGradientTexture(data.getVisual("visualMeta"), [
            minMag,
            maxMag
        ]);
    },
    // PENDING Use grid mesh ? or delaunay triangulation?
    _fillEmptyPixels: function(texture) {
        var pixels = texture.pixels;
        var width = texture.width;
        var height = texture.height;
        function fetchPixel(x, y, rg) {
            x = Math.max(Math.min(x, width - 1), 0);
            y = Math.max(Math.min(y, height - 1), 0);
            var idx = (y * (width - 1) + x) * 4;
            if (pixels[idx + 3] === 0) return false;
            rg[0] = pixels[idx];
            rg[1] = pixels[idx + 1];
            return true;
        }
        function addPixel(a, b, out) {
            out[0] = a[0] + b[0];
            out[1] = a[1] + b[1];
        }
        var center = [], left = [], right = [], top = [], bottom = [];
        var weight = 0;
        for(var y = 0; y < height; y++)for(var x = 0; x < width; x++){
            var idx = (y * (width - 1) + x) * 4;
            if (pixels[idx + 3] === 0) {
                weight = center[0] = center[1] = 0;
                if (fetchPixel(x - 1, y, left)) {
                    weight++;
                    addPixel(left, center, center);
                }
                if (fetchPixel(x + 1, y, right)) {
                    weight++;
                    addPixel(right, center, center);
                }
                if (fetchPixel(x, y - 1, top)) {
                    weight++;
                    addPixel(top, center, center);
                }
                if (fetchPixel(x, y + 1, bottom)) {
                    weight++;
                    addPixel(bottom, center, center);
                }
                center[0] /= weight;
                center[1] /= weight; // PENDING If overwrite. bilinear interpolation.
                pixels[idx] = center[0];
                pixels[idx + 1] = center[1];
            }
            pixels[idx + 3] = 1;
        }
    },
    _updateGradientTexture: function(visualMeta, magExtent) {
        if (!visualMeta || !visualMeta.length) {
            this._particleSurface.setGradientTexture(null);
            return;
        } // TODO Different dimensions
        this._gradientTexture = this._gradientTexture || new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Texture2D({
            image: document.createElement("canvas")
        });
        var gradientTexture = this._gradientTexture;
        var canvas = gradientTexture.image;
        canvas.width = 200;
        canvas.height = 1;
        var ctx = canvas.getContext("2d");
        var gradient = ctx.createLinearGradient(0, 0.5, canvas.width, 0.5);
        visualMeta[0].stops.forEach(function(stop) {
            var offset;
            if (magExtent[1] === magExtent[0]) offset = 0;
            else {
                offset = stop.value / magExtent[1];
                offset = Math.min(Math.max(offset, 0), 1);
            }
            gradient.addColorStop(offset, stop.color);
        });
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        gradientTexture.dirty();
        this._particleSurface.setGradientTexture(this._gradientTexture);
    },
    _updatePlanePosition: function(leftTop, rightBottom, seriesModel, api) {
        var limitedResult = this._limitInViewportAndFullFill(leftTop, rightBottom, seriesModel, api);
        leftTop = limitedResult.leftTop;
        rightBottom = limitedResult.rightBottom;
        this._particleSurface.setRegion(limitedResult.region);
        this._planeMesh.position.set((leftTop[0] + rightBottom[0]) / 2, api.getHeight() - (leftTop[1] + rightBottom[1]) / 2, 0);
        var width = rightBottom[0] - leftTop[0];
        var height = rightBottom[1] - leftTop[1];
        this._planeMesh.scale.set(width / 2, height / 2, 1);
        this._particleSurface.resize(Math.max(Math.min(width, 2048), 1), Math.max(Math.min(height, 2048), 1));
        if (this._renderer) this._particleSurface.clearFrame(this._renderer);
    },
    _limitInViewportAndFullFill: function(leftTop, rightBottom, seriesModel, api) {
        var newLeftTop = [
            Math.max(leftTop[0], 0),
            Math.max(leftTop[1], 0)
        ];
        var newRightBottom = [
            Math.min(rightBottom[0], api.getWidth()),
            Math.min(rightBottom[1], api.getHeight())
        ]; // Tiliing in lng orientation.
        if (seriesModel.get("coordinateSystem") === "bmap") {
            var lngRange = seriesModel.getData().getDataExtent(seriesModel.coordDimToDataDim("lng")[0]); // PENDING, consider grid density
            var isContinuous = Math.floor(lngRange[1] - lngRange[0]) >= 359;
            if (isContinuous) {
                if (newLeftTop[0] > 0) newLeftTop[0] = 0;
                if (newRightBottom[0] < api.getWidth()) newRightBottom[0] = api.getWidth();
            }
        }
        var width = rightBottom[0] - leftTop[0];
        var height = rightBottom[1] - leftTop[1];
        var newWidth = newRightBottom[0] - newLeftTop[0];
        var newHeight = newRightBottom[1] - newLeftTop[1];
        var region = [
            (newLeftTop[0] - leftTop[0]) / width,
            1.0 - newHeight / height - (newLeftTop[1] - leftTop[1]) / height,
            newWidth / width,
            newHeight / height
        ];
        return {
            leftTop: newLeftTop,
            rightBottom: newRightBottom,
            region: region
        };
    },
    _updateCamera: function(width, height, dpr) {
        this.viewGL.setViewport(0, 0, width, height, dpr);
        var camera = this.viewGL.camera; // FIXME  bottom can't be larger than top
        camera.left = camera.bottom = 0;
        camera.top = height;
        camera.right = width;
        camera.near = 0;
        camera.far = 100;
        camera.position.z = 10;
    },
    remove: function() {
        this._planeMesh.stopAnimation();
        this.groupGL.removeAll();
    },
    dispose: function() {
        if (this._renderer) this._particleSurface.dispose(this._renderer);
        this.groupGL.removeAll();
    }
});


function $e6ba5aad37ed13e9$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $2f7556b7f4817f5d$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $cee7b7bb004764f2$export$2e2bcd8739ae039));
}


(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $e6ba5aad37ed13e9$export$4b3e715f166fdd78));



// TODO ECharts GL must be imported whatever component,charts is imported.



var $dc773ce80a08eacb$var$LinesGLSeries = $7c10febb2cdef0d8$export$2e2bcd8739ae039.extend({
    type: "series.linesGL",
    dependencies: [
        "grid",
        "geo"
    ],
    visualStyleAccessPath: "lineStyle",
    visualDrawType: "stroke",
    streamEnabled: true,
    init: function(option) {
        var result = this._processFlatCoordsArray(option.data);
        this._flatCoords = result.flatCoords;
        this._flatCoordsOffset = result.flatCoordsOffset;
        if (result.flatCoords) option.data = new Float32Array(result.count);
        $dc773ce80a08eacb$var$LinesGLSeries.superApply(this, "init", arguments);
    },
    mergeOption: function(option) {
        var result = this._processFlatCoordsArray(option.data);
        this._flatCoords = result.flatCoords;
        this._flatCoordsOffset = result.flatCoordsOffset;
        if (result.flatCoords) option.data = new Float32Array(result.count);
        $dc773ce80a08eacb$var$LinesGLSeries.superApply(this, "mergeOption", arguments);
    },
    appendData: function(params) {
        var result = this._processFlatCoordsArray(params.data);
        if (result.flatCoords) {
            if (!this._flatCoords) {
                this._flatCoords = result.flatCoords;
                this._flatCoordsOffset = result.flatCoordsOffset;
            } else {
                this._flatCoords = (0, $7a1bd9c2710fea0d$export$4fd8af2c48c43416)(this._flatCoords, result.flatCoords);
                this._flatCoordsOffset = (0, $7a1bd9c2710fea0d$export$4fd8af2c48c43416)(this._flatCoordsOffset, result.flatCoordsOffset);
            }
            params.data = new Float32Array(result.count);
        }
        this.getRawData().appendData(params.data);
    },
    _getCoordsFromItemModel: function(idx) {
        var itemModel = this.getData().getItemModel(idx);
        var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.getShallow("coords");
        return coords;
    },
    getLineCoordsCount: function(idx) {
        if (this._flatCoordsOffset) return this._flatCoordsOffset[idx * 2 + 1];
        else return this._getCoordsFromItemModel(idx).length;
    },
    getLineCoords: function(idx, out) {
        if (this._flatCoordsOffset) {
            var offset = this._flatCoordsOffset[idx * 2];
            var len = this._flatCoordsOffset[idx * 2 + 1];
            for(var i = 0; i < len; i++){
                out[i] = out[i] || [];
                out[i][0] = this._flatCoords[offset + i * 2];
                out[i][1] = this._flatCoords[offset + i * 2 + 1];
            }
            return len;
        } else {
            var coords = this._getCoordsFromItemModel(idx);
            for(var i = 0; i < coords.length; i++){
                out[i] = out[i] || [];
                out[i][0] = coords[i][0];
                out[i][1] = coords[i][1];
            }
            return coords.length;
        }
    },
    _processFlatCoordsArray: function(data) {
        var startOffset = 0;
        if (this._flatCoords) startOffset = this._flatCoords.length;
         // Stored as a typed array. In format
        // Points Count(2) | x | y | x | y | Points Count(3) | x |  y | x | y | x | y |
        if (typeof data[0] === "number") {
            var len = data.length; // Store offset and len of each segment
            var coordsOffsetAndLenStorage = new Uint32Array(len);
            var coordsStorage = new Float64Array(len);
            var coordsCursor = 0;
            var offsetCursor = 0;
            var dataCount = 0;
            for(var i = 0; i < len;){
                dataCount++;
                var count = data[i++]; // Offset
                coordsOffsetAndLenStorage[offsetCursor++] = coordsCursor + startOffset; // Len
                coordsOffsetAndLenStorage[offsetCursor++] = count;
                for(var k = 0; k < count; k++){
                    var x = data[i++];
                    var y = data[i++];
                    coordsStorage[coordsCursor++] = x;
                    coordsStorage[coordsCursor++] = y;
                }
            }
            return {
                flatCoordsOffset: new Uint32Array(coordsOffsetAndLenStorage.buffer, 0, offsetCursor),
                flatCoords: coordsStorage,
                count: dataCount
            };
        }
        return {
            flatCoordsOffset: null,
            flatCoords: null,
            count: data.length
        };
    },
    getInitialData: function(option, ecModel) {
        var lineData = new $0ab0556b819346fd$export$2e2bcd8739ae039([
            "value"
        ], this);
        lineData.hasItemOption = false;
        lineData.initData(option.data, [], function(dataItem, dimName, dataIndex, dimIndex) {
            // dataItem is simply coords
            if (dataItem instanceof Array) return NaN;
            else {
                lineData.hasItemOption = true;
                var value = dataItem.value;
                if (value != null) return value instanceof Array ? value[dimIndex] : value;
            }
        });
        return lineData;
    },
    defaultOption: {
        coordinateSystem: "geo",
        zlevel: 10,
        progressive: 1e4,
        progressiveThreshold: 5e4,
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // Geo coordinate system
        // geoIndex: 0,
        // Support source-over, lighter
        blendMode: "source-over",
        lineStyle: {
            opacity: 0.8
        },
        postEffect: {
            enable: false,
            colorCorrection: {
                exposure: 0,
                brightness: 0,
                contrast: 1,
                saturation: 1,
                enable: true
            }
        }
    }
});
var $dc773ce80a08eacb$export$2e2bcd8739ae039 = $dc773ce80a08eacb$var$LinesGLSeries;









var $79dea1d87ae94ce6$export$2e2bcd8739ae039 = $0dc5061053e23cd3$export$2e2bcd8739ae039.extend({
    type: "linesGL",
    __ecgl__: true,
    init: function(ecModel, api) {
        this.groupGL = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Node();
        this.viewGL = new (0, $7a0cfdd3f7cf77fd$export$2e2bcd8739ae039)("orthographic");
        this.viewGL.add(this.groupGL);
        this._glViewHelper = new (0, $363eede8184faa6a$export$2e2bcd8739ae039)(this.viewGL);
        this._nativeLinesShader = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createShader("ecgl.lines3D");
        this._meshLinesShader = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createShader("ecgl.meshLines3D");
        this._linesMeshes = [];
        this._currentStep = 0;
    },
    render: function(seriesModel, ecModel, api) {
        this.groupGL.removeAll();
        this._glViewHelper.reset(seriesModel, api);
        var linesMesh = this._linesMeshes[0];
        if (!linesMesh) linesMesh = this._linesMeshes[0] = this._createLinesMesh(seriesModel);
        this._linesMeshes.length = 1;
        this.groupGL.add(linesMesh);
        this._updateLinesMesh(seriesModel, linesMesh, 0, seriesModel.getData().count());
        this.viewGL.setPostEffect(seriesModel.getModel("postEffect"), api);
    },
    incrementalPrepareRender: function(seriesModel, ecModel, api) {
        this.groupGL.removeAll();
        this._glViewHelper.reset(seriesModel, api);
        this._currentStep = 0;
        this.viewGL.setPostEffect(seriesModel.getModel("postEffect"), api);
    },
    incrementalRender: function(params, seriesModel, ecModel, api) {
        var linesMesh = this._linesMeshes[this._currentStep];
        if (!linesMesh) {
            linesMesh = this._createLinesMesh(seriesModel);
            this._linesMeshes[this._currentStep] = linesMesh;
        }
        this._updateLinesMesh(seriesModel, linesMesh, params.start, params.end);
        this.groupGL.add(linesMesh);
        api.getZr().refresh();
        this._currentStep++;
    },
    updateTransform: function(seriesModel, ecModel, api) {
        if (seriesModel.coordinateSystem.getRoamTransform) this._glViewHelper.updateTransform(seriesModel, api);
    },
    _createLinesMesh: function(seriesModel) {
        var linesMesh = new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh({
            $ignorePicking: true,
            material: new (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Material({
                shader: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).createShader("ecgl.lines3D"),
                transparent: true,
                depthMask: false,
                depthTest: false
            }),
            geometry: new (0, $9168b5292959c78e$export$2e2bcd8739ae039)({
                segmentScale: 10,
                useNativeLine: true,
                dynamic: false
            }),
            mode: (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh.LINES,
            culling: false
        });
        return linesMesh;
    },
    _updateLinesMesh: function(seriesModel, linesMesh, start, end) {
        var data = seriesModel.getData();
        linesMesh.material.blend = seriesModel.get("blendMode") === "lighter" ? (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).additiveBlend : null;
        var curveness = seriesModel.get("lineStyle.curveness") || 0;
        var isPolyline = seriesModel.get("polyline");
        var geometry = linesMesh.geometry;
        var coordSys = seriesModel.coordinateSystem;
        var lineWidth = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull(seriesModel.get("lineStyle.width"), 1);
        if (lineWidth > 1) {
            if (linesMesh.material.shader !== this._meshLinesShader) linesMesh.material.attachShader(this._meshLinesShader);
            linesMesh.mode = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh.TRIANGLES;
        } else {
            if (linesMesh.material.shader !== this._nativeLinesShader) linesMesh.material.attachShader(this._nativeLinesShader);
            linesMesh.mode = (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).Mesh.LINES;
        }
        start = start || 0;
        end = end || data.count();
        geometry.resetOffset();
        var vertexCount = 0;
        var triangleCount = 0;
        var p0 = [];
        var p1 = [];
        var p2 = [];
        var p3 = [];
        var lineCoords = [];
        var t = 0.3;
        var t2 = 0.7;
        function updateBezierControlPoints() {
            p1[0] = p0[0] * t2 + p3[0] * t - (p0[1] - p3[1]) * curveness;
            p1[1] = p0[1] * t2 + p3[1] * t - (p3[0] - p0[0]) * curveness;
            p2[0] = p0[0] * t + p3[0] * t2 - (p0[1] - p3[1]) * curveness;
            p2[1] = p0[1] * t + p3[1] * t2 - (p3[0] - p0[0]) * curveness;
        }
        if (isPolyline || curveness !== 0) {
            for(var idx = start; idx < end; idx++)if (isPolyline) {
                var count = seriesModel.getLineCoordsCount(idx);
                vertexCount += geometry.getPolylineVertexCount(count);
                triangleCount += geometry.getPolylineTriangleCount(count);
            } else {
                seriesModel.getLineCoords(idx, lineCoords);
                this._glViewHelper.dataToPoint(coordSys, lineCoords[0], p0);
                this._glViewHelper.dataToPoint(coordSys, lineCoords[1], p3);
                updateBezierControlPoints();
                vertexCount += geometry.getCubicCurveVertexCount(p0, p1, p2, p3);
                triangleCount += geometry.getCubicCurveTriangleCount(p0, p1, p2, p3);
            }
        } else {
            var lineCount = end - start;
            vertexCount += lineCount * geometry.getLineVertexCount();
            triangleCount += lineCount * geometry.getLineVertexCount();
        }
        geometry.setVertexCount(vertexCount);
        geometry.setTriangleCount(triangleCount);
        var dataIndex = start;
        var colorArr = [];
        for(var idx = start; idx < end; idx++){
            (0, $ddf90840ffe6c0e1$export$2e2bcd8739ae039).parseColor((0, $4c1f03531dad0b09$export$bc92a5a7848039f)(data, dataIndex), colorArr);
            var opacity = (0, $5821dc5111828448$export$2e2bcd8739ae039).firstNotNull((0, $4c1f03531dad0b09$export$f154d4dab8f4e8c0)(data, dataIndex), 1);
            colorArr[3] *= opacity;
            var count = seriesModel.getLineCoords(idx, lineCoords);
            for(var k = 0; k < count; k++)this._glViewHelper.dataToPoint(coordSys, lineCoords[k], lineCoords[k]);
            if (isPolyline) geometry.addPolyline(lineCoords, colorArr, lineWidth, 0, count);
            else if (curveness !== 0) {
                p0 = lineCoords[0];
                p3 = lineCoords[1];
                updateBezierControlPoints();
                geometry.addCubicCurve(p0, p1, p2, p3, colorArr, lineWidth);
            } else geometry.addPolyline(lineCoords, colorArr, lineWidth, 0, 2);
            dataIndex++;
        }
    },
    dispose: function() {
        this.groupGL.removeAll();
    },
    remove: function() {
        this.groupGL.removeAll();
    }
});


function $b8a515b1ae8784c3$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $79dea1d87ae94ce6$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $dc773ce80a08eacb$export$2e2bcd8739ae039));
}


(0, $d657479d857c7ab3$export$1f96ae73734a86cc)((0, $b8a515b1ae8784c3$export$4b3e715f166fdd78));






const $61a5d98302ddd79b$export$6b2b7fba9767acd1 = `<?xml version="1.0" encoding="ISO-8859-1"?>
<msq xmlns="http://www.msefi.com/:msq">
    <bibliography author="TunerStudio MS Ultra(Beta) 3.1.08.31 - EFI Analytics, Inc." tuneComment="" writeDate="Sat Feb 10 17:07:19 GMT 2024"/>
    <versionInfo fileFormat="5.0" firmwareInfo="Speeduino+202207.1" nPages="15" signature="speeduino 202207"/>
    <page>
        <pcVariable name="tsCanId">"CAN ID 0"</pcVariable>
        <pcVariable digits="0" name="rpmhigh" units="rpm">6000.0</pcVariable>
        <pcVariable digits="0" name="rpmwarn" units="rpm">4000.0</pcVariable>
        <pcVariable digits="0" name="rpmdang" units="rpm">5000.0</pcVariable>
        <pcVariable digits="0" name="maphigh" units="kPa">255.0</pcVariable>
        <pcVariable digits="0" name="mapwarn" units="kPa">200.0</pcVariable>
        <pcVariable digits="0" name="mapdang" units="kPa">245.0</pcVariable>
        <pcVariable digits="1" name="batlow" units="Volts">11.8</pcVariable>
        <pcVariable digits="1" name="bathigh" units="Volts">15.0</pcVariable>
        <pcVariable cols="1" digits="3" name="wueAFR" rows="10" units="Lambda">
         -0.1360544 
         -0.1020408 
         -0.0816327 
         -0.0680272 
         -0.0544218 
         -0.0408163 
         -0.0272109 
         -0.0136054 
         -0.0068027 
         0.0 
      </pcVariable>
        <pcVariable cols="1" digits="0" name="wueRecommended" rows="10" units="%">
         193.0 
         175.0 
         152.0 
         130.0 
         115.0 
         107.0 
         100.0 
         100.0 
         100.0 
         100.0 
      </pcVariable>
        <pcVariable cols="1" digits="0" name="boardFuelOutputs" rows="128" units=" ">
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         6.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         8.0 
         4.0 
         4.0 
         4.0 
         4.0 
         8.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
      </pcVariable>
        <pcVariable cols="1" digits="0" name="boardIgnOutputs" rows="128" units=" ">
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         6.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         8.0 
         4.0 
         4.0 
         4.0 
         4.0 
         8.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
         4.0 
      </pcVariable>
        <pcVariable cols="1" digits="0" name="boardHasRTC" rows="128" units=" ">
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         6.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         1.0 
         0.0 
         0.0 
         0.0 
         0.0 
         8.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
      </pcVariable>
        <pcVariable cols="1" digits="0" name="algorithmLimits" rows="8">
         511.0 
         100.0 
         511.0 
         511.0 
         100.0 
         100.0 
         100.0 
         100.0 
      </pcVariable>
        <pcVariable name="prgm_out_selection">"4"</pcVariable>
        <pcVariable digits="0" name="fuelLoadMax">255.0</pcVariable>
        <pcVariable digits="0" name="ignLoadMax">255.0</pcVariable>
        <pcVariable digits="0" name="fuel2LoadMax">255.0</pcVariable>
        <pcVariable digits="0" name="ign2LoadMax">255.0</pcVariable>
        <pcVariable name="AUXin00Alias">Aux0</pcVariable>
        <pcVariable name="tsSpeedSource">"GPS Speed"</pcVariable>
        <pcVariable digits="0" name="tsPrimaryInjectorSize">0.0</pcVariable>
        <pcVariable name="tsInjSizeConstant">"cc/min"</pcVariable>
        <pcVariable name="tsLogPowerFields">"Log HP &amp; Tq"</pcVariable>
        <pcVariable name="tsLogPerfFields">"Off"</pcVariable>
        <pcVariable name="tsFuelConsumptionUnits">"US Gallons"</pcVariable>
        <pcVariable name="tsDistanceUnits">"Miles Per Hour"</pcVariable>
        <pcVariable digits="0" name="tsVehicleWeight">3450.0</pcVariable>
        <pcVariable name="tsWeightUnits">"lbs"</pcVariable>
        <pcVariable digits="2" name="tsVehicleDragCoef">0.34</pcVariable>
        <pcVariable digits="0" name="tsTirePressure" units="psi">32.0</pcVariable>
        <pcVariable digits="1" name="tsFrontalArea">19.3</pcVariable>
        <pcVariable name="tsFrontalUnits">"sqft"</pcVariable>
        <pcVariable digits="1" name="tsTireDiameter" units="in">25.5</pcVariable>
        <pcVariable digits="2" name="tsTransGearRatio" units=":1">1.0</pcVariable>
        <pcVariable digits="2" name="tsFinalDriveRatio" units=":1">3.7</pcVariable>
        <pcVariable digits="0" name="tsEtRollOut" units="in">0.0</pcVariable>
    </page>
    <page number="0" size="128">
        <constant digits="1" name="aseTaperTime" units="S">10.0</constant>
        <constant digits="0" name="aeColdPct" units="%">100.0</constant>
        <constant digits="0" name="aeColdTaperMin" units="C">0.0</constant>
        <constant name="aeMode">"TPS"</constant>
        <constant name="battVCorMode">"Open Time only"</constant>
        <constant name="SoftLimitMode">"Fixed"</constant>
        <constant name="useTachoSweep">"On"</constant>
        <constant name="aeApplyMode">"PW Multiplier"</constant>
        <constant name="multiplyMAP">"Off"</constant>
        <constant cols="1" digits="0" name="wueRates" rows="10" units="%">
         193.0 
         175.0 
         152.0 
         130.0 
         115.0 
         107.0 
         100.0 
         100.0 
         100.0 
         100.0 
      </constant>
        <constant digits="0" name="crankingPct" units="%">20.0</constant>
        <constant name="pinLayout">"DIY-EFI CORE4 v1.0"</constant>
        <constant name="tachoPin">"Board Default"</constant>
        <constant name="tachoDiv">"Normal"</constant>
        <constant digits="0" name="tachoDuration" units="ms">1.0</constant>
        <constant digits="0" name="maeThresh" units="kPa/s">70.0</constant>
        <constant digits="0" name="taeThresh" units="%/s">70.0</constant>
        <constant digits="0" name="aeTime" units="ms">200.0</constant>
        <constant name="display">"Unused"</constant>
        <constant name="display1">"VE"</constant>
        <constant name="display2">"CPU"</constant>
        <constant name="display3">"TPS"</constant>
        <constant name="display4">"Mem"</constant>
        <constant name="display5">"RPM"</constant>
        <constant name="displayB1">"RPM"</constant>
        <constant name="displayB2">"RPM"</constant>
        <constant digits="1" name="reqFuel" units="ms">10.0</constant>
        <constant digits="0" name="divider">2.0</constant>
        <constant name="alternate">"Simultaneous"</constant>
        <constant name="multiplyMAP1">"No"</constant>
        <constant name="includeAFR">"No"</constant>
        <constant name="hardCutType">"Rolling"</constant>
        <constant name="ignAlgorithm">"TPS"</constant>
        <constant name="indInjAng">"Enabled"</constant>
        <constant digits="1" name="injOpen" units="ms">1.0</constant>
        <constant cols="1" digits="0" name="injAng" rows="4" units="deg">
         355.0 
         355.0 
         355.0 
         355.0 
      </constant>
        <constant name="mapSample">"Cycle Average"</constant>
        <constant name="twoStroke">"Four-stroke"</constant>
        <constant name="injType">"Throttle Body"</constant>
        <constant name="nCylinders">"8"</constant>
        <constant name="algorithm">"TPS"</constant>
        <constant name="fixAngEnable">"Off"</constant>
        <constant name="nInjectors">"2"</constant>
        <constant name="engineType">"Even fire"</constant>
        <constant name="flexEnabled">"Off"</constant>
        <constant name="legacyMAP">"No"</constant>
        <constant name="baroCorr">"Off"</constant>
        <constant name="injLayout">"Paired"</constant>
        <constant name="perToothIgn">"Yes"</constant>
        <constant name="dfcoEnabled">"Off"</constant>
        <constant digits="0" name="aeColdTaperMax" units="C">60.0</constant>
        <constant digits="0" name="dutyLim" units="%">80.0</constant>
        <constant digits="0" name="flexFreqLow" units="Hz">50.0</constant>
        <constant digits="0" name="flexFreqHigh" units="Hz">150.0</constant>
        <constant digits="0" name="boostMaxDuty" units="%">80.0</constant>
        <constant digits="0" name="tpsMin" units="ADC">24.0</constant>
        <constant digits="0" name="tpsMax" units="ADC">209.0</constant>
        <constant digits="0" name="mapMin" units="kpa">10.0</constant>
        <constant digits="0" name="mapMax" units="kpa">260.0</constant>
        <constant digits="0" name="fpPrime" units="s">3.0</constant>
        <constant digits="1" name="stoich" units=":1">14.7</constant>
        <constant digits="0" name="oddfire2" units="deg">0.0</constant>
        <constant digits="0" name="oddfire3" units="deg">0.0</constant>
        <constant digits="0" name="oddfire4" units="deg">0.0</constant>
        <constant name="idleUpPin">"44"</constant>
        <constant name="idleUpPolarity">"Normal"</constant>
        <constant name="idleUpEnabled">"Off"</constant>
        <constant digits="0" name="idleUpAdder" units="% / Steps">15.0</constant>
        <constant digits="0" name="aeTaperMin" units="RPM">1000.0</constant>
        <constant digits="0" name="aeTaperMax" units="RPM">5000.0</constant>
        <constant digits="0" name="iacCLminDuty" units="%">0.0</constant>
        <constant digits="0" name="iacCLmaxDuty" units="%">100.0</constant>
        <constant digits="0" name="boostMinDuty" units="%">20.0</constant>
        <constant digits="0" name="baroMin" units="kpa">1.0</constant>
        <constant digits="0" name="baroMax" units="kpa">315.0</constant>
        <constant digits="0" name="EMAPMin" units="kpa">10.0</constant>
        <constant digits="0" name="EMAPMax" units="kpa">260.0</constant>
        <constant name="fanWhenOff">"Yes"</constant>
        <constant name="fanWhenCranking">"No"</constant>
        <constant name="useDwellMap">"No"</constant>
        <constant name="fanEnable">"On/Off"</constant>
        <constant name="rtc_mode">"Off"</constant>
        <constant name="incorporateAFR">"No"</constant>
        <constant cols="1" digits="0" name="asePct" rows="4" units="%">
         50.0 
         40.0 
         35.0 
         35.0 
      </constant>
        <constant cols="1" digits="0" name="aseCount" rows="4" units="s">
         10.0 
         5.0 
         5.0 
         3.0 
      </constant>
        <constant cols="1" digits="0" name="aseBins" rows="4" units="C">
         0.0 
         40.0 
         80.0 
         100.0 
      </constant>
        <constant cols="1" digits="1" name="primePulse" rows="4" units="ms">
         1.0 
         1.0 
         1.0 
         1.0 
      </constant>
        <constant cols="1" digits="0" name="primeBins" rows="4" units="C">
         0.0 
         40.0 
         60.0 
         100.0 
      </constant>
        <constant name="CTPSPin">"Board Default"</constant>
        <constant name="CTPSPolarity">"Inverted"</constant>
        <constant name="CTPSEnabled">"On"</constant>
        <constant name="idleAdvEnabled">"Off"</constant>
        <constant name="idleAdvAlgorithm">"TPS"</constant>
        <constant name="idleAdvDelay">"0.0"</constant>
        <constant digits="0" name="idleAdvRPM" units="rpm">1000.0</constant>
        <constant digits="1" name="idleAdvTPS" units="%">8.0</constant>
        <constant cols="1" digits="0" name="injAngRPM" rows="4" units="RPM">
         500.0 
         2000.0 
         4500.0 
         6500.0 
      </constant>
        <constant digits="1" name="idleTaperTime" units="S">5.0</constant>
        <constant digits="1" name="dfcoDelay" units="S">1.0</constant>
        <constant digits="0" name="dfcoMinCLT" units="C">50.0</constant>
        <constant name="vssMode">"Off"</constant>
        <constant name="vssPin">"Board Default"</constant>
        <constant digits="0" name="vssPulsesPerKm" units="pulses">0.0</constant>
        <constant digits="0" name="vssSmoothing" units="%">50.0</constant>
        <constant digits="1" name="vssRatio1" units="km/h per 1000rpm">0.0</constant>
        <constant digits="1" name="vssRatio2" units="km/h per 1000rpm">0.0</constant>
        <constant digits="1" name="vssRatio3" units="km/h per 1000rpm">0.0</constant>
        <constant digits="1" name="vssRatio4" units="km/h per 1000rpm">0.0</constant>
        <constant digits="1" name="vssRatio5" units="km/h per 1000rpm">0.0</constant>
        <constant digits="1" name="vssRatio6" units="km/h per 1000rpm">0.0</constant>
        <constant name="idleUpOutputEnabled">"Off"</constant>
        <constant name="idleUpOutputInv">"No"</constant>
        <constant name="idleUpOutputPin">"19"</constant>
        <constant digits="0" name="tachoSweepMaxRPM" units="RPM">7600.0</constant>
        <constant digits="1" name="primingDelay" units="S">0.5</constant>
        <constant digits="1" name="iacTPSlimit" units="%">126.0</constant>
        <constant digits="0" name="iacRPMlimitHysteresis" units="RPM">2550.0</constant>
        <constant digits="0" name="rtc_trim" units="ppm">-1.0</constant>
        <constant digits="0" name="idleAdvVss" units="km/h">255.0</constant>
        <constant digits="0" name="mapSwitchPoint" units="RPM">0.0</constant>
        <constant name="canBMWCluster">"Off"</constant>
        <constant name="canVAGCluster">"Off"</constant>
        <constant name="enable1Cluster">"On"</constant>
        <constant name="enable2Cluster">"On"</constant>
        <constant name="unusedClusterBits">"Off"</constant>
        <constant digits="0" name="unused2-95" units="RPM">25500.0</constant>
    </page>
    <page number="1" size="288">
        <constant cols="16" digits="0" name="veTable" rows="16" units="%">
         26.0 24.0 22.0 19.0 19.0 18.0 17.0 17.0 17.0 16.0 13.0 11.0 12.0 13.0 14.0 14.0 
         52.0 40.0 29.0 25.0 22.0 21.0 20.0 20.0 20.0 16.0 14.0 13.0 13.0 14.0 14.0 14.0 
         56.0 40.0 30.0 26.0 23.0 22.0 21.0 20.0 20.0 16.0 14.0 13.0 14.0 14.0 14.0 14.0 
         63.0 43.0 32.0 29.0 26.0 24.0 22.0 21.0 20.0 17.0 16.0 14.0 15.0 14.0 14.0 14.0 
         66.0 49.0 34.0 31.0 28.0 25.0 24.0 22.0 21.0 19.0 16.0 14.0 14.0 14.0 14.0 14.0 
         64.0 54.0 39.0 34.0 32.0 29.0 27.0 26.0 24.0 22.0 19.0 15.0 15.0 14.0 14.0 14.0 
         61.0 58.0 44.0 39.0 38.0 36.0 34.0 33.0 31.0 30.0 28.0 23.0 20.0 19.0 18.0 17.0 
         74.0 67.0 56.0 52.0 48.0 47.0 46.0 44.0 43.0 42.0 41.0 41.0 40.0 39.0 35.0 32.0 
         88.0 73.0 71.0 62.0 56.0 53.0 53.0 54.0 52.0 51.0 50.0 49.0 47.0 45.0 44.0 44.0 
         90.0 80.0 76.0 74.0 74.0 58.0 57.0 58.0 57.0 56.0 56.0 53.0 50.0 50.0 53.0 53.0 
         92.0 84.0 80.0 79.0 78.0 66.0 65.0 63.0 61.0 61.0 59.0 56.0 62.0 63.0 60.0 60.0 
         94.0 85.0 83.0 85.0 87.0 80.0 78.0 76.0 72.0 68.0 70.0 77.0 75.0 72.0 68.0 67.0 
         95.0 94.0 90.0 93.0 92.0 89.0 88.0 89.0 88.0 87.0 85.0 84.0 81.0 79.0 75.0 74.0 
         95.0 95.0 94.0 93.0 93.0 93.0 92.0 91.0 90.0 89.0 88.0 87.0 86.0 83.0 80.0 79.0 
         95.0 95.0 95.0 94.0 94.0 93.0 93.0 92.0 91.0 91.0 90.0 89.0 89.0 87.0 84.0 83.0 
         96.0 96.0 96.0 96.0 96.0 95.0 94.0 94.0 93.0 92.0 92.0 91.0 90.0 89.0 88.0 87.0 
      </constant>
        <constant cols="1" digits="0" name="rpmBins" rows="16" units="RPM">
         600.0 
         900.0 
         1200.0 
         1600.0 
         2000.0 
         2300.0 
         2700.0 
         3000.0 
         3400.0 
         3800.0 
         4200.0 
         4500.0 
         4900.0 
         5300.0 
         5700.0 
         6000.0 
      </constant>
        <constant cols="1" digits="1" name="fuelLoadBins" rows="16" units="% TPS">
         0.0 
         1.0 
         2.0 
         3.0 
         4.0 
         5.0 
         10.0 
         20.0 
         30.0 
         40.0 
         50.0 
         60.0 
         70.0 
         80.0 
         90.0 
         100.0 
      </constant>
    </page>
    <page number="2" size="288">
        <constant cols="16" digits="0" name="advTable1" rows="16" units="deg">
         16.0 3.0 9.0 12.0 20.0 24.0 28.0 31.0 34.0 37.0 38.0 38.0 38.0 38.0 38.0 38.0 
         14.0 14.0 15.0 17.0 20.0 24.0 28.0 31.0 34.0 37.0 38.0 38.0 38.0 38.0 38.0 38.0 
         15.0 15.0 15.0 17.0 20.0 24.0 28.0 31.0 34.0 37.0 38.0 38.0 38.0 38.0 38.0 38.0 
         16.0 16.0 16.0 17.0 20.0 24.0 28.0 31.0 34.0 37.0 38.0 38.0 38.0 38.0 38.0 38.0 
         16.0 16.0 16.0 17.0 20.0 24.0 28.0 31.0 34.0 37.0 38.0 38.0 38.0 38.0 38.0 38.0 
         16.0 16.0 16.0 17.0 20.0 23.0 27.0 30.0 32.0 35.0 37.0 37.0 37.0 37.0 37.0 37.0 
         16.0 16.0 16.0 17.0 20.0 23.0 26.0 29.0 32.0 35.0 36.0 36.0 36.0 36.0 36.0 36.0 
         16.0 16.0 16.0 17.0 20.0 23.0 26.0 29.0 32.0 34.0 36.0 36.0 36.0 36.0 36.0 36.0 
         16.0 16.0 16.0 17.0 18.0 21.0 24.0 27.0 30.0 34.0 36.0 36.0 36.0 36.0 36.0 36.0 
         16.0 16.0 16.0 16.0 18.0 21.0 24.0 27.0 30.0 34.0 36.0 36.0 36.0 36.0 36.0 36.0 
         16.0 16.0 16.0 16.0 18.0 20.0 23.0 26.0 30.0 33.0 35.0 35.0 35.0 35.0 35.0 35.0 
         16.0 16.0 16.0 16.0 18.0 19.0 22.0 25.0 29.0 32.0 34.0 34.0 34.0 34.0 34.0 34.0 
         14.0 14.0 14.0 15.0 16.0 19.0 22.0 25.0 28.0 31.0 32.0 32.0 32.0 32.0 32.0 32.0 
         14.0 14.0 14.0 14.0 16.0 19.0 22.0 25.0 28.0 30.0 32.0 32.0 32.0 32.0 32.0 32.0 
         14.0 14.0 14.0 14.0 16.0 19.0 22.0 25.0 28.0 30.0 32.0 32.0 32.0 32.0 32.0 32.0 
         14.0 14.0 14.0 14.0 16.0 19.0 22.0 25.0 28.0 30.0 32.0 32.0 32.0 32.0 32.0 32.0 
      </constant>
        <constant cols="1" digits="0" name="rpmBins2" rows="16" units="RPM">
         600.0 
         900.0 
         1100.0 
         1300.0 
         1500.0 
         1800.0 
         2200.0 
         2600.0 
         2900.0 
         3300.0 
         3700.0 
         4000.0 
         4400.0 
         4800.0 
         5000.0 
         6000.0 
      </constant>
        <constant cols="1" digits="1" name="mapBins1" rows="16" units="% TPS">
         0.0 
         1.0 
         2.0 
         3.0 
         7.0 
         12.0 
         16.0 
         21.0 
         29.0 
         37.0 
         46.0 
         55.0 
         67.0 
         80.0 
         91.0 
         100.0 
      </constant>
    </page>
    <page number="3" size="128">
        <constant digits="0" name="TrigAng" units="Deg">-50.0</constant>
        <constant digits="0" name="FixAng" units="Deg">0.0</constant>
        <constant digits="0" name="CrankAng" units="Deg">10.0</constant>
        <constant digits="0" name="TrigAngMul">0.0</constant>
        <constant name="TrigEdge">"FALLING"</constant>
        <constant name="TrigSpeed">"Crank Speed"</constant>
        <constant name="IgInv">"Going Low"</constant>
        <constant name="TrigPattern">"Missing Tooth"</constant>
        <constant name="TrigEdgeSec">"FALLING"</constant>
        <constant name="fuelPumpPin">"Board Default"</constant>
        <constant name="useResync">"No"</constant>
        <constant digits="1" name="sparkDur" units="ms">1.0</constant>
        <constant name="trigPatternSec">"Single tooth cam"</constant>
        <constant name="PollLevelPol">"Low"</constant>
        <constant digits="0" name="bootloaderCaps" units="level">0.0</constant>
        <constant name="resetControl">"Serial Command"</constant>
        <constant name="resetControlPin">"Board Default"</constant>
        <constant digits="0" name="SkipCycles" units="cycles">1.0</constant>
        <constant name="boostType">"Open Loop"</constant>
        <constant name="useDwellLim">"On"</constant>
        <constant name="sparkMode">"Wasted Spark"</constant>
        <constant name="TrigFilter">"Weak"</constant>
        <constant name="ignCranklock">"Off"</constant>
        <constant digits="1" name="dwellcrank" units="ms">4.5</constant>
        <constant digits="1" name="dwellrun" units="ms">3.0</constant>
        <constant digits="0" name="numTeeth" units="teeth">36.0</constant>
        <constant digits="0" name="missingTeeth" units="teeth">1.0</constant>
        <constant digits="0" name="crankRPM" units="rpm">400.0</constant>
        <constant digits="1" name="tpsflood" units="%">80.0</constant>
        <constant digits="0" name="SoftRevLim" units="rpm">5000.0</constant>
        <constant digits="0" name="SoftLimRetard" units="deg">20.0</constant>
        <constant digits="1" name="SoftLimMax" units="s">2.0</constant>
        <constant digits="0" name="hardRevLim" units="rpm">5500.0</constant>
        <constant cols="1" digits="0" name="taeBins" rows="4" units="%/s">
         70.0 
         220.0 
         430.0 
         790.0 
      </constant>
        <constant cols="1" digits="0" name="taeRates" rows="4" units="%">
         15.0 
         59.0 
         74.0 
         85.0 
      </constant>
        <constant cols="1" digits="0" name="wueBins" rows="10" units="C">
         -40.0 
         -26.0 
         -8.0 
         9.0 
         26.0 
         38.0 
         49.0 
         60.0 
         69.0 
         80.0 
      </constant>
        <constant digits="0" name="dwellLim" units="ms">8.0</constant>
        <constant cols="1" digits="0" name="dwellRates" rows="6" units="%">
         110.0 
         105.0 
         100.0 
         100.0 
         91.0 
         85.0 
      </constant>
        <constant cols="1" digits="0" name="iatRetBins" rows="6" units="C">
         58.0 
         82.0 
         93.0 
         104.0 
         116.0 
         125.0 
      </constant>
        <constant cols="1" digits="0" name="iatRetRates" rows="6" units="deg">
         0.0 
         0.0 
         2.0 
         4.0 
         6.0 
         10.0 
      </constant>
        <constant digits="0" name="dfcoRPM" units="RPM">1500.0</constant>
        <constant digits="0" name="dfcoHyster" units="RPM">200.0</constant>
        <constant digits="1" name="dfcoTPSThresh" units="%">2.0</constant>
        <constant name="ignBypassEnable">"Off"</constant>
        <constant name="ignBypassPin">"3"</constant>
        <constant name="ignBypassHiLo">"LOW"</constant>
        <constant digits="0" name="ADCFILTER_TPS" units="%">50.0</constant>
        <constant digits="0" name="ADCFILTER_CLT" units="%">180.0</constant>
        <constant digits="0" name="ADCFILTER_IAT" units="%">180.0</constant>
        <constant digits="0" name="ADCFILTER_O2" units="%">100.0</constant>
        <constant digits="0" name="ADCFILTER_BAT" units="%">128.0</constant>
        <constant digits="0" name="ADCFILTER_MAP" units="%">20.0</constant>
        <constant digits="0" name="ADCFILTER_BARO" units="%">64.0</constant>
        <constant cols="1" digits="0" name="cltAdvBins" rows="6" units="C">
         0.0 
         20.0 
         40.0 
         60.0 
         80.0 
         100.0 
      </constant>
        <constant cols="1" digits="0" name="cltAdvValues" rows="6" units="deg">
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
      </constant>
        <constant cols="1" digits="0" name="maeBins" rows="4" units="kpa/s">
         80.0 
         220.0 
         500.0 
         860.0 
      </constant>
        <constant cols="1" digits="0" name="maeRates" rows="4" units="%">
         50.0 
         73.0 
         92.0 
         94.0 
      </constant>
        <constant digits="1" name="batVoltCorrect" units="v">0.0</constant>
        <constant cols="1" digits="0" name="baroFuelBins" rows="8" units="kPa">
         87.0 
         93.0 
         97.0 
         99.0 
         101.0 
         102.0 
         103.0 
         107.0 
      </constant>
        <constant cols="1" digits="0" name="baroFuelValues" rows="8" units="%">
         100.0 
         100.0 
         100.0 
         100.0 
         100.0 
         100.0 
         100.0 
         100.0 
      </constant>
        <constant cols="1" digits="0" name="idleAdvBins" rows="6" units="RPM">
         -200.0 
         -90.0 
         -10.0 
         70.0 
         160.0 
         240.0 
      </constant>
        <constant cols="1" digits="0" name="idleAdvValues" rows="6" units="deg">
         15.0 
         10.0 
         5.0 
         0.0 
         -5.0 
         -10.0 
      </constant>
        <constant digits="0" name="engineProtectMaxRPM" units="rpm">2000.0</constant>
        <constant digits="0" name="vvt2CL0DutyAng" units="deg">1540.0</constant>
        <constant name="vvt2PWMdir">"Advance"</constant>
        <constant name="inj4CylPairing">"1+3 &amp; 2+4"</constant>
        <constant name="unusedBits4_123">"0"</constant>
        <constant digits="0" name="ANGLEFILTER_VVT" units="%">0.0</constant>
        <constant digits="0" name="FILTER_FLEX" units="%">8.0</constant>
        <constant digits="0" name="vvtMinClt" units="C">-40.0</constant>
        <constant digits="0" name="vvtDelay" units="S">0.0</constant>
    </page>
    <page number="4" size="288">
        <constant cols="16" digits="3" name="afrTable" rows="16" units="Lambda">
         0.952381 0.952381 0.952381 1.0 1.0204082 1.0272109 1.0272109 1.0068027 1.0 1.0 1.0 1.0 1.0 1.0 1.0 1.0 
         1.0 1.0 1.0 1.0 1.0 1.0 1.0272109 1.0068027 1.0 1.0 1.0 1.0 1.0 1.0 1.0 1.0 
         1.0 1.0 1.0 1.0 1.0 1.0 1.0272109 1.0068027 1.0 1.0 1.0 1.0 1.0 1.0 1.0 1.0 
         1.0 1.0 1.0 1.0 1.0 1.0 1.0204082 1.0068027 1.0 1.0 1.0 0.9931973 0.9863946 0.9863946 0.9795918 0.9795918 
         1.0 1.0 1.0 1.0 1.0 1.0 1.0 1.0 0.9931973 0.9863946 0.9795918 0.9727891 0.9659864 0.952381 0.952381 0.952381 
         1.0 1.0 1.0 1.0 1.0 1.0 1.0 1.0 0.9863946 0.9727891 0.9591837 0.9455782 0.9387755 0.9251701 0.9251701 0.9183673 
         0.9727891 0.9727891 0.9727891 1.0 1.0 1.0 1.0 0.9863946 0.9591837 0.9387755 0.9387755 0.9387755 0.9319728 0.9183673 0.9183673 0.9115646 
         0.9659864 0.9659864 0.9659864 1.0 1.0 1.0 1.0 0.9727891 0.9455782 0.9251701 0.9251701 0.9251701 0.9115646 0.8979592 0.8979592 0.8911565 
         0.9591837 0.9591837 0.9659864 0.9863946 0.9863946 0.9795918 0.9659864 0.9455782 0.9183673 0.8979592 0.8911565 0.8843537 0.8843537 0.877551 0.877551 0.877551 
         0.9591837 0.9591837 0.9659864 0.9727891 0.9591837 0.952381 0.9455782 0.9251701 0.9047619 0.8911565 0.8843537 0.8843537 0.877551 0.877551 0.877551 0.877551 
         0.9591837 0.9591837 0.9659864 0.9591837 0.9319728 0.9251701 0.9251701 0.9047619 0.8911565 0.8843537 0.8843537 0.877551 0.877551 0.8707483 0.8707483 0.8707483 
         0.952381 0.952381 0.952381 0.9319728 0.9115646 0.9115646 0.9047619 0.8911565 0.8843537 0.877551 0.877551 0.877551 0.8707483 0.8707483 0.8707483 0.8707483 
         0.9319728 0.9319728 0.9319728 0.877551 0.8707483 0.877551 0.877551 0.8707483 0.8707483 0.8707483 0.8707483 0.8707483 0.8707483 0.8707483 0.8707483 0.8707483 
         0.9115646 0.9115646 0.9115646 0.877551 0.8707483 0.8707483 0.8707483 0.8639456 0.8639456 0.8639456 0.8639456 0.8639456 0.8639456 0.8639456 0.8639456 0.8639456 
         0.8911565 0.8911565 0.8911565 0.8707483 0.8707483 0.8707483 0.8639456 0.8571429 0.8571429 0.8571429 0.8571429 0.8571429 0.8571429 0.8571429 0.8571429 0.8571429 
         0.8707483 0.8707483 0.8707483 0.8707483 0.8707483 0.8639456 0.8571429 0.8503401 0.8503401 0.8503401 0.8503401 0.8503401 0.8503401 0.8503401 0.8503401 0.8503401 
      </constant>
        <constant cols="1" digits="0" name="rpmBinsAFR" rows="16" units="RPM">
         500.0 
         700.0 
         900.0 
         1400.0 
         2000.0 
         2800.0 
         3600.0 
         4500.0 
         5200.0 
         5500.0 
         5800.0 
         6200.0 
         6500.0 
         6800.0 
         6900.0 
         7000.0 
      </constant>
        <constant cols="1" digits="1" name="loadBinsAFR" rows="16" units="% TPS">
         0.0 
         1.0 
         2.0 
         3.0 
         4.0 
         8.0 
         16.0 
         20.0 
         30.0 
         40.0 
         50.0 
         60.0 
         70.0 
         80.0 
         90.0 
         100.0 
      </constant>
    </page>
    <page number="5" size="128">
        <constant name="egoAlgorithm">"No correction"</constant>
        <constant name="egoType">"Wide Band"</constant>
        <constant name="boostEnabled">"Off"</constant>
        <constant name="vvtEnabled">"Off"</constant>
        <constant name="engineProtectType">"Both"</constant>
        <constant digits="0" name="egoKP" units="%">35.0</constant>
        <constant digits="0" name="egoKI" units="%">0.0</constant>
        <constant digits="0" name="egoKD" units="%">20.0</constant>
        <constant digits="0" name="egoTemp" units="C">70.0</constant>
        <constant digits="0" name="egoCount">16.0</constant>
        <constant name="vvtMode">"On/Off"</constant>
        <constant name="vvtLoadSource">"MAP"</constant>
        <constant name="vvtPWMdir">"Advance"</constant>
        <constant name="vvtCLUseHold">"No"</constant>
        <constant name="vvtCLAlterFuelTiming">"No"</constant>
        <constant name="boostCutEnabled">"Off"</constant>
        <constant digits="0" name="egoLimit">15.0</constant>
        <constant digits="1" name="ego_min" units="AFR">9.0</constant>
        <constant digits="1" name="ego_max" units="AFR">19.0</constant>
        <constant digits="0" name="ego_sdelay" units="sec">15.0</constant>
        <constant digits="0" name="egoRPM" units="rpm">1200.0</constant>
        <constant digits="1" name="egoTPSMax" units="%">12.0</constant>
        <constant name="vvt1Pin">"Board Default"</constant>
        <constant name="useExtBaro">"No"</constant>
        <constant name="boostMode">"Simple"</constant>
        <constant name="boostPin">"Board Default"</constant>
        <constant name="tachoMode">"Fixed Duration"</constant>
        <constant name="useEMAP">"No"</constant>
        <constant cols="1" digits="1" name="brvBins" rows="6" units="V">
         6.6 
         9.4 
         12.1 
         14.8 
         16.9 
         20.3 
      </constant>
        <constant cols="1" digits="0" name="injBatRates" rows="6" units="%">
         150.0 
         120.0 
         100.0 
         100.0 
         100.0 
         98.0 
      </constant>
        <constant cols="1" digits="0" name="airDenBins" rows="9" units="C">
         -40.0 
         -20.0 
         0.0 
         20.0 
         35.0 
         50.0 
         60.0 
         90.0 
         120.0 
      </constant>
        <constant cols="1" digits="0" name="airDenRates" rows="9" units="%">
         126.0 
         116.0 
         107.0 
         100.0 
         100.0 
         100.0 
         100.0 
         81.0 
         74.0 
      </constant>
        <constant digits="0" name="boostFreq" units="Hz">30.0</constant>
        <constant digits="0" name="vvtFreq" units="Hz">300.0</constant>
        <constant digits="0" name="idleFreq" units="Hz">120.0</constant>
        <constant name="launchPin">"Board Default"</constant>
        <constant name="launchEnable">"No"</constant>
        <constant name="launchHiLo">"LOW"</constant>
        <constant digits="0" name="lnchSoftLim" units="rpm">3500.0</constant>
        <constant digits="0" name="lnchRetard" units="deg">15.0</constant>
        <constant digits="0" name="lnchHardLim" units="rpm">4000.0</constant>
        <constant digits="0" name="lnchFuelAdd" units="%">50.0</constant>
        <constant digits="2" name="idleKP" units="%">0.8125</constant>
        <constant digits="2" name="idleKI" units="%">0.0</constant>
        <constant digits="3" name="idleKD" units="%">0.49984</constant>
        <constant digits="0" name="boostLimit" units="kPa">200.0</constant>
        <constant digits="0" name="boostKP" units="%">50.0</constant>
        <constant digits="0" name="boostKI" units="%">0.0</constant>
        <constant digits="0" name="boostKD" units="%">10.0</constant>
        <constant name="lnchPullRes">"Pullup"</constant>
        <constant name="iacPWMrun">"No"</constant>
        <constant name="fuelTrimEnabled">"No"</constant>
        <constant name="flatSEnable">"No"</constant>
        <constant name="baroPin">"A0"</constant>
        <constant digits="0" name="flatSSoftWin" units="rpm">400.0</constant>
        <constant digits="0" name="flatSRetard" units="deg">5.0</constant>
        <constant digits="0" name="flatSArm" units="rpm">2000.0</constant>
        <constant cols="1" digits="0" name="iacCLValues" rows="10" units="RPM">
         1200.0 
         1150.0 
         1100.0 
         800.0 
         750.0 
         750.0 
         750.0 
         750.0 
         750.0 
         750.0 
      </constant>
        <constant cols="1" digits="0" name="iacOLStepVal" rows="10" units="Steps">
         369.0 
         327.0 
         291.0 
         246.0 
         213.0 
         168.0 
         123.0 
         87.0 
         45.0 
         0.0 
      </constant>
        <constant cols="1" digits="0" name="iacOLPWMVal" rows="10" units="Duty %">
         43.0 
         39.0 
         33.0 
         29.0 
         24.0 
         20.0 
         17.0 
         17.0 
         16.0 
         9.0 
      </constant>
        <constant cols="1" digits="0" name="iacBins" rows="10" units="C">
         -38.0 
         -19.0 
         1.0 
         17.0 
         34.0 
         50.0 
         65.0 
         79.0 
         98.0 
         143.0 
      </constant>
        <constant cols="1" digits="0" name="iacCrankSteps" rows="4" units="Steps">
         123.0 
         579.0 
         390.0 
         300.0 
      </constant>
        <constant cols="1" digits="0" name="iacCrankDuty" rows="4" units="Duty %">
         27.0 
         50.0 
         60.0 
         65.0 
      </constant>
        <constant cols="1" digits="0" name="iacCrankBins" rows="4" units="C">
         -28.0 
         6.0 
         44.0 
         76.0 
      </constant>
        <constant name="iacAlgorithm">"None"</constant>
        <constant name="iacStepTime">"3"</constant>
        <constant name="iacChannels">"2"</constant>
        <constant name="iacPWMdir">"Normal"</constant>
        <constant digits="0" name="iacFastTemp" units="C">50.0</constant>
        <constant digits="0" name="iacStepHome" units="Steps">240.0</constant>
        <constant digits="0" name="iacStepHyster" units="Steps">4.0</constant>
        <constant name="fanInv">"No"</constant>
        <constant name="fanUnused">"Off"</constant>
        <constant name="fanPin">"Board Default"</constant>
        <constant digits="0" name="fanSP" units="C">89.0</constant>
        <constant digits="0" name="fanHyster" units="C">2.0</constant>
        <constant digits="0" name="fanFreq" units="Hz">6.0</constant>
        <constant cols="1" digits="0" name="fanPWMBins" rows="4" units="C">
         60.0 
         -20.0 
         -40.0 
         158.0 
      </constant>
    </page>
    <page number="6" size="240">
        <constant cols="8" digits="0" name="boostTable" rows="8" units="Duty Cycle %">
         150.0 150.0 150.0 150.0 150.0 150.0 150.0 150.0 
         150.0 150.0 150.0 150.0 150.0 150.0 150.0 150.0 
         150.0 150.0 150.0 150.0 150.0 150.0 150.0 150.0 
         150.0 150.0 150.0 150.0 150.0 150.0 150.0 150.0 
         150.0 150.0 150.0 150.0 150.0 150.0 150.0 150.0 
         170.0 170.0 170.0 170.0 170.0 170.0 170.0 170.0 
         170.0 170.0 170.0 170.0 170.0 170.0 170.0 170.0 
         170.0 170.0 170.0 170.0 170.0 170.0 170.0 170.0 
      </constant>
        <constant cols="1" digits="0" name="rpmBinsBoost" rows="8" units="RPM">
         1000.0 
         2000.0 
         3000.0 
         3800.0 
         4500.0 
         5300.0 
         6000.0 
         6800.0 
      </constant>
        <constant cols="1" digits="1" name="tpsBinsBoost" rows="8" units="TPS">
         0.0 
         20.0 
         40.0 
         80.0 
         100.0 
         120.0 
         32.0 
         72.0 
      </constant>
        <constant cols="8" digits="1" name="vvtTable" rows="8" units="%">
         94.0 0.0 0.0 54.0 8.0 8.0 0.0 0.0 
         70.0 16.0 12.0 0.0 12.0 12.0 0.0 2.0 
         48.0 44.0 40.0 36.0 36.0 36.0 38.0 40.0 
         64.0 60.0 58.0 56.0 54.0 54.0 54.0 58.0 
         78.0 78.0 76.0 76.0 74.0 74.0 72.0 72.0 
         92.0 94.0 94.0 92.0 92.0 90.0 90.0 86.0 
         112.0 112.0 112.0 110.0 110.0 110.0 110.0 112.0 
         8.0 8.0 10.0 10.0 10.0 10.0 10.0 10.0 
      </constant>
        <constant cols="1" digits="0" name="rpmBinsVVT" rows="8" units="RPM">
         1000.0 
         2000.0 
         3000.0 
         3800.0 
         4500.0 
         5300.0 
         6000.0 
         6800.0 
      </constant>
        <constant cols="1" digits="0" name="loadBinsVVT" rows="8" units="kPa">
         128.0 
         128.0 
         128.0 
         128.0 
         128.0 
         128.0 
         128.0 
         128.0 
      </constant>
        <constant cols="8" digits="0" name="stagingTable" rows="8" units="%">
         0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 0.0 0.0 
      </constant>
        <constant cols="1" digits="0" name="rpmBinsStaging" rows="8" units="RPM">
         500.0 
         1000.0 
         2000.0 
         3000.0 
         4000.0 
         5000.0 
         6000.0 
         7000.0 
      </constant>
        <constant cols="1" digits="1" name="loadBinsStaging" rows="8" units="% TPS">
         100.0 
         100.0 
         100.0 
         100.0 
         100.0 
         100.0 
         100.0 
         100.0 
      </constant>
    </page>
    <page number="7" size="384">
        <constant cols="6" digits="0" name="fuelTrim1Table" rows="6" units="%">
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
      </constant>
        <constant cols="1" digits="0" name="fuelTrim1rpmBins" rows="6" units="RPM">
         700.0 
         1500.0 
         3000.0 
         4100.0 
         5500.0 
         7000.0 
      </constant>
        <constant cols="1" digits="1" name="fuelTrim1loadBins" rows="6" units="% TPS">
         16.0 
         72.0 
         8.0 
         64.0 
         16.0 
         96.0 
      </constant>
        <constant cols="6" digits="0" name="fuelTrim2Table" rows="6" units="%">
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
      </constant>
        <constant cols="1" digits="0" name="fuelTrim2rpmBins" rows="6" units="RPM">
         700.0 
         1500.0 
         3000.0 
         4100.0 
         5500.0 
         7000.0 
      </constant>
        <constant cols="1" digits="1" name="fuelTrim2loadBins" rows="6" units="% TPS">
         16.0 
         72.0 
         8.0 
         64.0 
         16.0 
         96.0 
      </constant>
        <constant cols="6" digits="0" name="fuelTrim3Table" rows="6" units="%">
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
      </constant>
        <constant cols="1" digits="0" name="fuelTrim3rpmBins" rows="6" units="RPM">
         700.0 
         1500.0 
         3000.0 
         4100.0 
         5500.0 
         7000.0 
      </constant>
        <constant cols="1" digits="1" name="fuelTrim3loadBins" rows="6" units="% TPS">
         16.0 
         72.0 
         8.0 
         64.0 
         16.0 
         96.0 
      </constant>
        <constant cols="6" digits="0" name="fuelTrim4Table" rows="6" units="%">
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
         0.0 0.0 0.0 0.0 0.0 0.0 
      </constant>
        <constant cols="1" digits="0" name="fuelTrim4rpmBins" rows="6" units="RPM">
         700.0 
         1500.0 
         3000.0 
         4100.0 
         5500.0 
         7000.0 
      </constant>
        <constant cols="1" digits="1" name="fuelTrim4loadBins" rows="6" units="% TPS">
         16.0 
         72.0 
         8.0 
         64.0 
         16.0 
         96.0 
      </constant>
        <constant cols="6" digits="0" name="fuelTrim5Table" rows="6" units="%">
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
      </constant>
        <constant cols="1" digits="0" name="fuelTrim5rpmBins" rows="6" units="RPM">
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
      </constant>
        <constant cols="1" digits="1" name="fuelTrim5loadBins" rows="6" units="% TPS">
         120.0 
         120.0 
         120.0 
         120.0 
         120.0 
         120.0 
      </constant>
        <constant cols="6" digits="0" name="fuelTrim6Table" rows="6" units="%">
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
      </constant>
        <constant cols="1" digits="0" name="fuelTrim6rpmBins" rows="6" units="RPM">
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
      </constant>
        <constant cols="1" digits="1" name="fuelTrim6loadBins" rows="6" units="% TPS">
         120.0 
         120.0 
         120.0 
         120.0 
         120.0 
         120.0 
      </constant>
        <constant cols="6" digits="0" name="fuelTrim7Table" rows="6" units="%">
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
      </constant>
        <constant cols="1" digits="0" name="fuelTrim7rpmBins" rows="6" units="RPM">
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
      </constant>
        <constant cols="1" digits="1" name="fuelTrim7loadBins" rows="6" units="% TPS">
         120.0 
         120.0 
         120.0 
         120.0 
         120.0 
         120.0 
      </constant>
        <constant cols="6" digits="0" name="fuelTrim8Table" rows="6" units="%">
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
         127.0 127.0 127.0 127.0 127.0 127.0 
      </constant>
        <constant cols="1" digits="0" name="fuelTrim8rpmBins" rows="6" units="RPM">
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
      </constant>
        <constant cols="1" digits="1" name="fuelTrim8loadBins" rows="6" units="% TPS">
         120.0 
         120.0 
         120.0 
         120.0 
         120.0 
         120.0 
      </constant>
    </page>
    <page number="8" size="192">
        <constant name="enable_secondarySerial">"Disable"</constant>
        <constant name="intcan_available">"Disable"</constant>
        <constant name="enable_intcan">"Disable"</constant>
        <constant name="caninput_sel0a">"Off"</constant>
        <constant name="caninput_sel0b">"Digital_local"</constant>
        <constant name="caninput_sel0extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel0extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel0extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel1a">"Off"</constant>
        <constant name="caninput_sel1b">"Digital_local"</constant>
        <constant name="caninput_sel1extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel1extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel1extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel2a">"Off"</constant>
        <constant name="caninput_sel2b">"Digital_local"</constant>
        <constant name="caninput_sel2extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel2extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel2extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel3a">"Off"</constant>
        <constant name="caninput_sel3b">"Digital_local"</constant>
        <constant name="caninput_sel3extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel3extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel3extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel4a">"Off"</constant>
        <constant name="caninput_sel4b">"Digital_local"</constant>
        <constant name="caninput_sel4extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel4extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel4extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel5a">"Off"</constant>
        <constant name="caninput_sel5b">"Digital_local"</constant>
        <constant name="caninput_sel5extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel5extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel5extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel6a">"Off"</constant>
        <constant name="caninput_sel6b">"Digital_local"</constant>
        <constant name="caninput_sel6extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel6extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel6extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel7a">"Off"</constant>
        <constant name="caninput_sel7b">"Digital_local"</constant>
        <constant name="caninput_sel7extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel7extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel7extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel8a">"Off"</constant>
        <constant name="caninput_sel8b">"Digital_local"</constant>
        <constant name="caninput_sel8extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel8extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel8extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel9a">"Off"</constant>
        <constant name="caninput_sel9b">"Digital_local"</constant>
        <constant name="caninput_sel9extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel9extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel9extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel10a">"Off"</constant>
        <constant name="caninput_sel10b">"Digital_local"</constant>
        <constant name="caninput_sel10extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel10extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel10extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel11a">"Off"</constant>
        <constant name="caninput_sel11b">"Digital_local"</constant>
        <constant name="caninput_sel11extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel11extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel11extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel12a">"Off"</constant>
        <constant name="caninput_sel12b">"Digital_local"</constant>
        <constant name="caninput_sel12extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel12extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel12extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel13a">"Off"</constant>
        <constant name="caninput_sel13b">"Digital_local"</constant>
        <constant name="caninput_sel13extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel13extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel13extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel14a">"Off"</constant>
        <constant name="caninput_sel14b">"Digital_local"</constant>
        <constant name="caninput_sel14extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel14extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel14extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_sel15a">"Off"</constant>
        <constant name="caninput_sel15b">"Digital_local"</constant>
        <constant name="caninput_sel15extsourcea">"Via Secondary Serial"</constant>
        <constant name="caninput_sel15extsourceb">"Via Internal CAN"</constant>
        <constant name="caninput_sel15extsourcec">"Via Internal CAN"</constant>
        <constant name="caninput_source_can_address0">"0x100"</constant>
        <constant name="caninput_source_can_address1">"0x100"</constant>
        <constant name="caninput_source_can_address2">"0x100"</constant>
        <constant name="caninput_source_can_address3">"0x100"</constant>
        <constant name="caninput_source_can_address4">"0x100"</constant>
        <constant name="caninput_source_can_address5">"0x100"</constant>
        <constant name="caninput_source_can_address6">"0x100"</constant>
        <constant name="caninput_source_can_address7">"0x100"</constant>
        <constant name="caninput_source_can_address8">"0x706"</constant>
        <constant name="caninput_source_can_address9">"0x100"</constant>
        <constant name="caninput_source_can_address10">"0x100"</constant>
        <constant name="caninput_source_can_address11">"0x100"</constant>
        <constant name="caninput_source_can_address12">"0x100"</constant>
        <constant name="caninput_source_can_address13">"0x100"</constant>
        <constant name="caninput_source_can_address14">"0x100"</constant>
        <constant name="caninput_source_can_address15">"0x6FD"</constant>
        <constant name="caninput_source_start_byte0">"7"</constant>
        <constant name="caninput_source_start_byte1">"7"</constant>
        <constant name="caninput_source_start_byte2">"7"</constant>
        <constant name="caninput_source_start_byte3">"7"</constant>
        <constant name="caninput_source_start_byte4">"7"</constant>
        <constant name="caninput_source_start_byte5">"7"</constant>
        <constant name="caninput_source_start_byte6">"7"</constant>
        <constant name="caninput_source_start_byte7">"7"</constant>
        <constant name="caninput_source_start_byte8">"7"</constant>
        <constant name="caninput_source_start_byte9">"7"</constant>
        <constant name="caninput_source_start_byte10">"7"</constant>
        <constant name="caninput_source_start_byte11">"7"</constant>
        <constant name="caninput_source_start_byte12">"7"</constant>
        <constant name="caninput_source_start_byte13">"7"</constant>
        <constant name="caninput_source_start_byte14">"7"</constant>
        <constant name="caninput_source_start_byte15">"7"</constant>
        <constant name="caninput_source_num_bytes0">"2"</constant>
        <constant name="caninput_source_num_bytes1">"2"</constant>
        <constant name="caninput_source_num_bytes2">"2"</constant>
        <constant name="caninput_source_num_bytes3">"2"</constant>
        <constant name="caninput_source_num_bytes4">"2"</constant>
        <constant name="caninput_source_num_bytes5">"2"</constant>
        <constant name="caninput_source_num_bytes6">"2"</constant>
        <constant name="caninput_source_num_bytes7">"2"</constant>
        <constant name="caninput_source_num_bytes8">"2"</constant>
        <constant name="caninput_source_num_bytes9">"2"</constant>
        <constant name="caninput_source_num_bytes10">"2"</constant>
        <constant name="caninput_source_num_bytes11">"2"</constant>
        <constant name="caninput_source_num_bytes12">"2"</constant>
        <constant name="caninput_source_num_bytes13">"2"</constant>
        <constant name="caninput_source_num_bytes14">"2"</constant>
        <constant name="caninput_source_num_bytes15">"2"</constant>
        <constant digits="0" name="unused10_67">255.0</constant>
        <constant digits="0" name="unused10_68">255.0</constant>
        <constant name="enable_intcandata_out">"On"</constant>
        <constant name="canoutput_sel0">"On"</constant>
        <constant name="canoutput_sel1">"On"</constant>
        <constant name="canoutput_sel2">"On"</constant>
        <constant name="canoutput_sel3">"On"</constant>
        <constant name="canoutput_sel4">"On"</constant>
        <constant name="canoutput_sel5">"On"</constant>
        <constant name="canoutput_sel6">"On"</constant>
        <constant name="canoutput_sel7">"On"</constant>
        <constant cols="1" digits="0" name="canoutput_param_group" rows="8">
         65535.0 
         65535.0 
         65535.0 
         65535.0 
         65535.0 
         65535.0 
         65535.0 
         65535.0 
      </constant>
        <constant name="canoutput_param_start_byte0">"7"</constant>
        <constant name="canoutput_param_start_byte1">"0"</constant>
        <constant name="canoutput_param_start_byte2">"0"</constant>
        <constant name="canoutput_param_start_byte3">"0"</constant>
        <constant name="canoutput_param_start_byte4">"0"</constant>
        <constant name="canoutput_param_start_byte5">"0"</constant>
        <constant name="canoutput_param_start_byte6">"0"</constant>
        <constant name="canoutput_param_start_byte7">"0"</constant>
        <constant name="canoutput_param_num_bytes0">"1"</constant>
        <constant name="canoutput_param_num_bytes1">"1"</constant>
        <constant name="canoutput_param_num_bytes2">"1"</constant>
        <constant name="canoutput_param_num_bytes3">"1"</constant>
        <constant name="canoutput_param_num_bytes4">"1"</constant>
        <constant name="canoutput_param_num_bytes5">"1"</constant>
        <constant name="canoutput_param_num_bytes6">"1"</constant>
        <constant name="canoutput_param_num_bytes7">"1"</constant>
        <constant digits="0" name="unused10_110">255.0</constant>
        <constant digits="0" name="unused10_111">255.0</constant>
        <constant digits="0" name="unused10_112">255.0</constant>
        <constant digits="0" name="unused10_113">255.0</constant>
        <constant name="speeduino_tsCanId">"CAN ID 0"</constant>
        <constant name="true_address">"0x101"</constant>
        <constant name="realtime_base_address">"0x201"</constant>
        <constant name="obd_address">"0x2FF"</constant>
        <constant name="Auxin0pina">"A0"</constant>
        <constant name="Auxin1pina">"A0"</constant>
        <constant name="Auxin2pina">"A0"</constant>
        <constant name="Auxin3pina">"A0"</constant>
        <constant name="Auxin4pina">"A0"</constant>
        <constant name="Auxin5pina">"A0"</constant>
        <constant name="Auxin6pina">"A4"</constant>
        <constant name="Auxin7pina">"A0"</constant>
        <constant name="Auxin8pina">"A1"</constant>
        <constant name="Auxin9pina">"A6"</constant>
        <constant name="Auxin10pina">"A10"</constant>
        <constant name="Auxin11pina">"A10"</constant>
        <constant name="Auxin12pina">"A10"</constant>
        <constant name="Auxin13pina">"A0"</constant>
        <constant name="Auxin14pina">"A5"</constant>
        <constant name="Auxin15pina">"A8"</constant>
        <constant name="Auxin0pinb">"30"</constant>
        <constant name="Auxin1pinb">"8"</constant>
        <constant name="Auxin2pinb">"1"</constant>
        <constant name="Auxin3pinb">"8"</constant>
        <constant name="Auxin4pinb">"11"</constant>
        <constant name="Auxin5pinb">"8"</constant>
        <constant name="Auxin6pinb">"12"</constant>
        <constant name="Auxin7pinb">"8"</constant>
        <constant name="Auxin8pinb">"1"</constant>
        <constant name="Auxin9pinb">"8"</constant>
        <constant name="Auxin10pinb">"26"</constant>
        <constant name="Auxin11pinb">"8"</constant>
        <constant name="Auxin12pinb">"46"</constant>
        <constant name="Auxin13pinb">"8"</constant>
        <constant name="Auxin14pinb">"7"</constant>
        <constant name="Auxin15pinb">"8"</constant>
        <constant name="iacStepperInv">"No"</constant>
        <constant name="iacCoolTime">"1"</constant>
        <constant name="boostByGearEnabled">"Constant limit"</constant>
        <constant name="blankfield">""</constant>
        <constant name="unused10_153">""</constant>
        <constant digits="0" name="iacMaxSteps" units="Steps">21.0</constant>
        <constant digits="1" name="idleAdvStartDelay" units="S">2.0</constant>
        <constant digits="0" name="boostByGear1" units="Limit">130.0</constant>
        <constant digits="0" name="boostByGear2" units="Limit">200.0</constant>
        <constant digits="0" name="boostByGear3" units="Limit">200.0</constant>
        <constant digits="0" name="boostByGear4" units="Limit">200.0</constant>
        <constant digits="0" name="boostByGear5" units="Limit">200.0</constant>
        <constant digits="0" name="boostByGear6" units="Limit">200.0</constant>
        <constant cols="1" digits="1" name="PWMFanDuty" rows="4" units="%">
         64.5 
         64.5 
         64.5 
         64.5 
      </constant>
        <constant name="hardRevMode">"Fixed"</constant>
        <constant cols="1" digits="0" name="coolantProtRPM" rows="6" units="RPM">
         12900.0 
         12900.0 
         12900.0 
         12900.0 
         12900.0 
         12900.0 
      </constant>
        <constant cols="1" digits="0" name="coolantProtTemp" rows="6" units="C">
         89.0 
         89.0 
         89.0 
         89.0 
         89.0 
         89.0 
      </constant>
        <constant cols="1" digits="0" name="unused179_184" rows="6">
         129.0 
         129.0 
         129.0 
         129.0 
         129.0 
         129.0 
      </constant>
        <constant name="afrProtectEnabled">"Off"</constant>
        <constant digits="0" name="afrProtectMAP" units="kPa">180.0</constant>
        <constant digits="0" name="afrProtectRPM" units="RPM">4000.0</constant>
        <constant digits="1" name="afrProtectTPS" units="%">80.0</constant>
        <constant digits="2" name="afrProtectDeviation" units="Lambda">0.0952381</constant>
        <constant digits="1" name="afrProtectCutTime" units="seconds">1.4</constant>
        <constant digits="1" name="afrProtectReactivationTPS" units="%">15.0</constant>
    </page>
    <page number="9" size="192">
        <constant cols="1" digits="0" name="crankingEnrichBins" rows="4" units="C">
         -40.0 
         0.0 
         30.0 
         70.0 
      </constant>
        <constant cols="1" digits="0" name="crankingEnrichValues" rows="4" units="%">
         600.0 
         300.0 
         300.0 
         300.0 
      </constant>
        <constant name="rotaryType">"FC"</constant>
        <constant name="stagingEnabled">"On"</constant>
        <constant name="stagingMode">"Automatic"</constant>
        <constant name="EMAPPin">"A0"</constant>
        <constant cols="1" digits="0" name="rotarySplitValues" rows="8" units="degrees">
         0.0 
         0.0 
         0.0 
         10.0 
         10.0 
         10.0 
         11.0 
         12.0 
      </constant>
        <constant cols="1" digits="1" name="rotarySplitBins" rows="8" units="% TPS">
         0.0 
         30.0 
         50.0 
         70.0 
         90.0 
         110.0 
         12.0 
         72.0 
      </constant>
        <constant digits="0" name="boostSens">2047.0</constant>
        <constant digits="0" name="boostIntv" units="ms">20.0</constant>
        <constant digits="0" name="stagedInjSizePri" units="cc/min">160.0</constant>
        <constant digits="0" name="stagedInjSizeSec" units="cc/min">160.0</constant>
        <constant digits="1" name="lnchCtrlTPS" units="%TPS">126.0</constant>
        <constant cols="1" digits="0" name="flexBoostBins" rows="6" units="%">
         0.0 
         20.0 
         40.0 
         60.0 
         80.0 
         100.0 
      </constant>
        <constant cols="1" digits="0" name="flexBoostAdj" rows="6" units="kPa">
         0.0 
         10.0 
         20.0 
         30.0 
         40.0 
         50.0 
      </constant>
        <constant cols="1" digits="0" name="flexFuelBins" rows="6" units="%">
         0.0 
         20.0 
         40.0 
         60.0 
         80.0 
         100.0 
      </constant>
        <constant cols="1" digits="0" name="flexFuelAdj" rows="6" units="%">
         100.0 
         139.0 
         156.0 
         160.0 
         163.0 
         163.0 
      </constant>
        <constant cols="1" digits="0" name="flexAdvBins" rows="6" units="%">
         0.0 
         20.0 
         40.0 
         60.0 
         80.0 
         100.0 
      </constant>
        <constant cols="1" digits="0" name="flexAdvAdj" rows="6" units="Deg">
         0.0 
         2.0 
         5.0 
         8.0 
         9.0 
         10.0 
      </constant>
        <constant name="n2o_enable">"Off"</constant>
        <constant name="n2o_arming_pin">"34"</constant>
        <constant digits="0" name="n2o_minCLT" units="C">20.0</constant>
        <constant digits="0" name="n2o_maxMAP" units="kPa">250.0</constant>
        <constant digits="1" name="n2o_minTPS" units="%TPS">60.0</constant>
        <constant digits="1" name="n2o_maxAFR" units="AFR">18.0</constant>
        <constant name="n2o_stage1_pin">"30"</constant>
        <constant name="n2o_pin_polarity">"LOW"</constant>
        <constant name="n2o_unused">"No"</constant>
        <constant digits="0" name="n2o_stage1_minRPM" units="RPM">3000.0</constant>
        <constant digits="0" name="n2o_stage1_maxRPM" units="RPM">6000.0</constant>
        <constant digits="1" name="n2o_stage1_adderMin" units="ms">6.0</constant>
        <constant digits="1" name="n2o_stage1_adderMax" units="ms">3.0</constant>
        <constant digits="0" name="n2o_stage1_retard" units="Deg">5.0</constant>
        <constant name="n2o_stage2_pin">"31"</constant>
        <constant name="n2o_stage2_unused">"No"</constant>
        <constant digits="0" name="n2o_stage2_minRPM" units="RPM">6000.0</constant>
        <constant digits="0" name="n2o_stage2_maxRPM" units="RPM">7000.0</constant>
        <constant digits="1" name="n2o_stage2_adderMin" units="ms">3.0</constant>
        <constant digits="1" name="n2o_stage2_adderMax" units="ms">1.5</constant>
        <constant digits="0" name="n2o_stage2_retard" units="Deg">5.0</constant>
        <constant name="knock_mode">"Analog"</constant>
        <constant name="knock_pin">"3"</constant>
        <constant name="knock_trigger">"LOW"</constant>
        <constant name="knock_pullup">"Off"</constant>
        <constant name="knock_limiterDisable">"No"</constant>
        <constant name="knock_unused">"3"</constant>
        <constant name="knock_count">"3"</constant>
        <constant digits="1" name="knock_threshold" units="Volts">7.5</constant>
        <constant digits="0" name="knock_maxMAP" units="kPa">100.0</constant>
        <constant digits="0" name="knock_maxRPM" units="RPM">1000.0</constant>
        <constant cols="1" digits="0" name="knock_window_rpms" rows="6" units="RPM">
         2000.0 
         3000.0 
         4000.0 
         5000.0 
         6000.0 
         5000.0 
      </constant>
        <constant cols="1" digits="0" name="knock_window_angle" rows="6" units="deg">
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         -20.0 
      </constant>
        <constant cols="1" digits="0" name="knock_window_dur" rows="6" units="deg">
         30.0 
         30.0 
         30.0 
         30.0 
         30.0 
         15.0 
      </constant>
        <constant digits="0" name="knock_maxRetard" units="Deg">3.0</constant>
        <constant digits="0" name="knock_firstStep" units="Deg">1.0</constant>
        <constant digits="0" name="knock_stepSize" units="Deg">2.0</constant>
        <constant digits="1" name="knock_stepTime" units="Sec">2.0</constant>
        <constant digits="1" name="knock_duration" units="Sec">0.2</constant>
        <constant digits="1" name="knock_recoveryStepTime" units="Sec">0.1</constant>
        <constant digits="0" name="knock_recoveryStep" units="Deg">0.0</constant>
        <constant name="fuel2Algorithm">"MAP"</constant>
        <constant name="fuel2Mode">"Off"</constant>
        <constant name="fuel2SwitchVariable">"MAP"</constant>
        <constant digits="0" name="fuel2SwitchValue" units="kPa">120.0</constant>
        <constant name="fuel2InputPin">"25"</constant>
        <constant name="fuel2InputPolarity">"LOW"</constant>
        <constant name="fuel2InputPullup">"Yes"</constant>
        <constant digits="1" name="vvtCLholdDuty" units="%">82.0</constant>
        <constant digits="2" name="vvtCLKP" units="%">0.0</constant>
        <constant digits="2" name="vvtCLKI" units="%">0.0</constant>
        <constant digits="3" name="vvtCLKD" units="%">0.99968</constant>
        <constant digits="0" name="vvtCL0DutyAng" units="deg">0.0</constant>
        <constant digits="0" name="vvtCLMinAng" units="deg">112.0</constant>
        <constant digits="0" name="vvtCLMaxAng" units="deg">0.0</constant>
        <constant digits="1" name="crankingEnrichTaper" units="s">0.1</constant>
        <constant name="fuelPressureEnable">"Off"</constant>
        <constant name="oilPressureEnable">"Off"</constant>
        <constant name="oilPressureProtEnbl">"Off"</constant>
        <constant name="oilPressurePin">"A0"</constant>
        <constant name="fuelPressurePin">"A0"</constant>
        <constant digits="0" name="fuelPressureMin" units="psi">9.0</constant>
        <constant digits="0" name="fuelPressureMax" units="psi">47.0</constant>
        <constant digits="0" name="oilPressureMin" units="psi">116.0</constant>
        <constant digits="0" name="oilPressureMax" units="psi">33.0</constant>
        <constant cols="1" digits="0" name="oilPressureProtMins" rows="4" units="psi">
         0.0 
         30.0 
         45.0 
         45.0 
      </constant>
        <constant cols="1" digits="0" name="oilPressureProtRPM" rows="4" units="RPM">
         100.0 
         1500.0 
         4000.0 
         8000.0 
      </constant>
        <constant name="wmiEnabled">"Off"</constant>
        <constant name="wmiMode">"Simple"</constant>
        <constant name="wmiAdvEnabled">"Off"</constant>
        <constant digits="1" name="wmiTPS" units="%TPS">0.0</constant>
        <constant digits="0" name="wmiRPM" units="RPM">5900.0</constant>
        <constant digits="0" name="wmiMAP" units="kPa">510.0</constant>
        <constant digits="0" name="wmiMAP2" units="kPa">510.0</constant>
        <constant digits="0" name="wmiIAT" units="C">215.0</constant>
        <constant digits="0" name="wmiOffset" units="ms">0.0</constant>
        <constant name="wmiIndicatorEnabled">"Off"</constant>
        <constant name="wmiIndicatorPin">"Board Default"</constant>
        <constant name="wmiIndicatorPolarity">"Inverted"</constant>
        <constant name="wmiEmptyEnabled">"Off"</constant>
        <constant name="wmiEmptyPin">"Board Default"</constant>
        <constant name="wmiEmptyPolarity">"Inverted"</constant>
        <constant name="wmiEnabledPin">"Board Default"</constant>
        <constant cols="1" digits="0" name="wmiAdvBins" rows="6" units="kPa">
         0.0 
         100.0 
         200.0 
         300.0 
         400.0 
         500.0 
      </constant>
        <constant cols="1" digits="0" name="wmiAdvAdj" rows="6" units="Deg">
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
      </constant>
        <constant digits="1" name="vvtCLminDuty" units="%">126.0</constant>
        <constant digits="1" name="vvtCLmaxDuty" units="%">126.0</constant>
        <constant name="vvt2Pin">"Board Default"</constant>
        <constant name="vvt2Enabled">"Off"</constant>
        <constant name="TrigEdgeThrd">"RISING"</constant>
        <constant cols="1" digits="0" name="fuelTempBins" rows="6" units="C">
         215.0 
         215.0 
         215.0 
         215.0 
         215.0 
         215.0 
      </constant>
        <constant cols="1" digits="0" name="fuelTempValues" rows="6" units="%">
         255.0 
         64.0 
         100.0 
         0.0 
         3.0 
         255.0 
      </constant>
        <constant name="spark2Algorithm">"MAP"</constant>
        <constant name="spark2Mode">"Off"</constant>
        <constant name="spark2SwitchVariable">"MAP"</constant>
        <constant digits="0" name="spark2SwitchValue" units="kPa">100.0</constant>
        <constant name="spark2InputPin">"3"</constant>
        <constant name="spark2InputPolarity">"LOW"</constant>
        <constant name="spark2InputPullup">"No"</constant>
        <constant cols="1" digits="0" name="unused11_190_191" rows="2" units="RPM">
         1500.0 
         500.0 
      </constant>
    </page>
    <page number="10" size="288">
        <constant cols="16" digits="0" name="veTable2" rows="16" units="%">
         39.0 39.0 39.0 39.0 39.0 38.0 37.0 36.0 35.0 34.0 33.0 33.0 33.0 33.0 33.0 33.0 
         40.0 40.0 41.0 42.0 42.0 41.0 40.0 39.0 39.0 39.0 39.0 39.0 40.0 40.0 40.0 40.0 
         40.0 42.0 43.0 46.0 46.0 45.0 44.0 43.0 42.0 42.0 43.0 43.0 43.0 44.0 44.0 44.0 
         42.0 45.0 47.0 51.0 51.0 49.0 48.0 47.0 46.0 46.0 46.0 47.0 47.0 47.0 48.0 48.0 
         44.0 49.0 52.0 56.0 55.0 54.0 52.0 51.0 50.0 50.0 50.0 50.0 51.0 51.0 51.0 52.0 
         48.0 54.0 58.0 61.0 59.0 58.0 56.0 55.0 54.0 53.0 54.0 54.0 54.0 55.0 55.0 55.0 
         54.0 61.0 64.0 66.0 64.0 62.0 61.0 59.0 58.0 57.0 57.0 58.0 58.0 59.0 59.0 59.0 
         60.0 67.0 70.0 70.0 68.0 67.0 65.0 63.0 62.0 61.0 61.0 61.0 62.0 63.0 63.0 63.0 
         67.0 74.0 76.0 75.0 73.0 71.0 69.0 68.0 66.0 64.0 65.0 65.0 66.0 66.0 67.0 67.0 
         74.0 80.0 81.0 79.0 77.0 75.0 73.0 72.0 70.0 68.0 68.0 69.0 69.0 70.0 70.0 71.0 
         81.0 85.0 86.0 84.0 82.0 80.0 78.0 76.0 74.0 72.0 72.0 72.0 73.0 74.0 74.0 74.0 
         87.0 91.0 91.0 88.0 86.0 84.0 82.0 80.0 78.0 76.0 76.0 76.0 77.0 78.0 78.0 78.0 
         93.0 93.0 93.0 93.0 93.0 90.0 88.0 86.0 84.0 83.0 83.0 83.0 84.0 85.0 85.0 86.0 
         93.0 93.0 93.0 93.0 93.0 92.0 90.0 88.0 86.0 86.0 86.0 87.0 88.0 89.0 89.0 90.0 
         93.0 93.0 93.0 93.0 93.0 93.0 93.0 90.0 90.0 90.0 90.0 91.0 92.0 93.0 93.0 93.0 
         93.0 93.0 93.0 93.0 93.0 93.0 93.0 93.0 93.0 93.0 93.0 93.0 93.0 93.0 93.0 95.0 
      </constant>
        <constant cols="1" digits="0" name="fuelRPM2Bins" rows="16" units="RPM">
         500.0 
         700.0 
         900.0 
         1400.0 
         2000.0 
         2800.0 
         3600.0 
         4500.0 
         5200.0 
         5500.0 
         5800.0 
         6200.0 
         6500.0 
         6800.0 
         6900.0 
         7000.0 
      </constant>
        <constant cols="1" digits="0" name="fuelLoad2Bins" rows="16" units="kPa">
         16.0 
         26.0 
         30.0 
         36.0 
         40.0 
         46.0 
         50.0 
         56.0 
         60.0 
         66.0 
         70.0 
         76.0 
         86.0 
         90.0 
         96.0 
         100.0 
      </constant>
    </page>
    <page number="11" size="192">
        <constant cols="8" digits="0" name="wmiTable" rows="8" units="%">
         255.0 255.0 255.0 255.0 255.0 255.0 255.0 255.0 
         255.0 255.0 255.0 255.0 255.0 255.0 255.0 255.0 
         255.0 255.0 255.0 255.0 255.0 255.0 255.0 255.0 
         255.0 255.0 255.0 255.0 255.0 255.0 255.0 255.0 
         255.0 255.0 255.0 255.0 255.0 255.0 255.0 255.0 
         255.0 255.0 255.0 255.0 255.0 255.0 255.0 255.0 
         255.0 255.0 255.0 255.0 255.0 255.0 255.0 255.0 
         255.0 255.0 255.0 255.0 255.0 255.0 255.0 255.0 
      </constant>
        <constant cols="1" digits="0" name="rpmBinsWMI" rows="8" units="RPM">
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
         25500.0 
      </constant>
        <constant cols="1" digits="0" name="mapBinsWMI" rows="8" units="kPa">
         510.0 
         510.0 
         510.0 
         510.0 
         510.0 
         510.0 
         510.0 
         510.0 
      </constant>
        <constant cols="8" digits="1" name="vvt2Table" rows="8" units="%">
         0.0 0.0 0.0 2.0 4.0 4.0 0.0 0.0 
         8.0 8.0 6.0 0.0 6.0 6.0 0.0 1.0 
         24.0 22.0 20.0 18.0 18.0 18.0 19.0 20.0 
         32.0 30.0 29.0 28.0 27.0 27.0 27.0 29.0 
         39.0 39.0 38.0 38.0 37.0 37.0 36.0 36.0 
         46.0 47.0 47.0 46.0 46.0 45.0 45.0 43.0 
         56.0 56.0 56.0 55.0 55.0 55.0 55.0 56.0 
         68.0 68.0 69.0 69.0 69.0 69.0 69.0 69.0 
      </constant>
        <constant cols="1" digits="0" name="rpmBinsVVT2" rows="8" units="RPM">
         1000.0 
         2000.0 
         3000.0 
         3800.0 
         4500.0 
         5300.0 
         6000.0 
         6800.0 
      </constant>
        <constant cols="1" digits="0" name="loadBinsVVT2" rows="8" units="kPa">
         0.0 
         20.0 
         30.0 
         40.0 
         56.0 
         70.0 
         86.0 
         100.0 
      </constant>
        <constant cols="4" digits="1" name="dwellTable" rows="4" units="ms">
         3.5 3.5 3.5 3.5 
         3.5 3.5 3.5 3.5 
         3.5 3.5 3.5 3.5 
         3.5 3.5 3.5 3.5 
      </constant>
        <constant cols="1" digits="0" name="rpmBinsDwell" rows="4" units="RPM">
         1000.0 
         3000.0 
         5000.0 
         7000.0 
      </constant>
        <constant cols="1" digits="1" name="loadBinsDwell" rows="4" units="% TPS">
         5.0 
         12.5 
         17.5 
         25.0 
      </constant>
        <constant cols="1" digits="0" name="UNALLOCATED_TOP_11" rows="8" units="RAW">
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
      </constant>
    </page>
    <page number="12" size="128">
        <constant name="outputInverted0">"Active low"</constant>
        <constant name="outputInverted1">"Active low"</constant>
        <constant name="outputInverted2">"Active low"</constant>
        <constant name="outputInverted3">"Active low"</constant>
        <constant name="outputInverted4">"Active low"</constant>
        <constant name="outputInverted5">"Active low"</constant>
        <constant name="outputInverted6">"Active low"</constant>
        <constant name="outputInverted7">"Active low"</constant>
        <constant name="kindOfLimiting0">"Minimum"</constant>
        <constant name="kindOfLimiting1">"Minimum"</constant>
        <constant name="kindOfLimiting2">"Minimum"</constant>
        <constant name="kindOfLimiting3">"Minimum"</constant>
        <constant name="kindOfLimiting4">"Minimum"</constant>
        <constant name="kindOfLimiting5">"Minimum"</constant>
        <constant name="kindOfLimiting6">"Minimum"</constant>
        <constant name="kindOfLimiting7">"Minimum"</constant>
        <constant cols="1" digits="0" name="outputPin" rows="8">
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
      </constant>
        <constant name="outputPin0">"Disabled"</constant>
        <constant name="outputPin1">"Disabled"</constant>
        <constant name="outputPin2">"Disabled"</constant>
        <constant name="outputPin3">"Disabled"</constant>
        <constant name="outputPin4">"Disabled"</constant>
        <constant name="outputPin5">"Disabled"</constant>
        <constant name="outputPin6">"Disabled"</constant>
        <constant name="outputPin7">"Disabled"</constant>
        <constant cols="1" digits="1" name="outputDelay" rows="8" units="S">
         25.5 
         25.5 
         25.5 
         25.5 
         25.5 
         25.5 
         25.5 
         25.5 
      </constant>
        <constant cols="1" digits="0" name="firstDataIn" rows="8">
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
      </constant>
        <constant cols="1" digits="0" name="secondDataIn" rows="8">
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
      </constant>
        <constant cols="1" digits="1" name="outputTimeLimit" rows="8" units="S">
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
         0.0 
      </constant>
        <constant cols="1" digits="0" name="unused13_35_49" rows="8" units="%">
         0.0 
         0.0 
         0.0 
         0.0 
         255.0 
         255.0 
         255.0 
         255.0 
      </constant>
        <constant cols="1" digits="0" name="firstTarget" rows="8">
         -1.0 
         -1.0 
         -1.0 
         -1.0 
         -1.0 
         -1.0 
         -1.0 
         -1.0 
      </constant>
        <constant cols="1" digits="0" name="secondTarget" rows="8">
         -1.0 
         -1.0 
         -1.0 
         -1.0 
         -1.0 
         -1.0 
         -1.0 
         -1.0 
      </constant>
        <constant name="firstCompType0">"== (equal)"</constant>
        <constant name="secondCompType0">"== (equal)"</constant>
        <constant name="bitwise0">"XOR"</constant>
        <constant name="firstCompType1">"== (equal)"</constant>
        <constant name="secondCompType1">"== (equal)"</constant>
        <constant name="bitwise1">"XOR"</constant>
        <constant name="firstCompType2">"== (equal)"</constant>
        <constant name="secondCompType2">"== (equal)"</constant>
        <constant name="bitwise2">"XOR"</constant>
        <constant name="firstCompType3">"== (equal)"</constant>
        <constant name="secondCompType3">"== (equal)"</constant>
        <constant name="bitwise3">"XOR"</constant>
        <constant name="firstCompType4">"== (equal)"</constant>
        <constant name="secondCompType4">"== (equal)"</constant>
        <constant name="bitwise4">"XOR"</constant>
        <constant name="firstCompType5">"== (equal)"</constant>
        <constant name="secondCompType5">"== (equal)"</constant>
        <constant name="bitwise5">"XOR"</constant>
        <constant name="firstCompType6">"== (equal)"</constant>
        <constant name="secondCompType6">"== (equal)"</constant>
        <constant name="bitwise6">"XOR"</constant>
        <constant name="firstCompType7">"== (equal)"</constant>
        <constant name="secondCompType7">"== (equal)"</constant>
        <constant name="bitwise7">"XOR"</constant>
        <constant cols="1" digits="0" name="candID" rows="8">
         15711.0 
         15677.0 
         15677.0 
         52951.0 
         49864.0 
         47549.0 
         45493.0 
         43950.0 
      </constant>
        <constant cols="1" digits="0" name="unused12_106_115" rows="10" units="%">
         168.0 
         166.0 
         163.0 
         161.0 
         159.0 
         157.0 
         156.0 
         154.0 
         152.0 
         151.0 
      </constant>
        <constant name="onboard_log_csv_separator">","</constant>
        <constant name="onboard_log_file_style">"CSV"</constant>
        <constant name="onboard_log_file_rate">"4Hz"</constant>
        <constant name="onboard_log_filenaming">"Sequential"</constant>
        <constant name="onboard_log_storage">"sd-card"</constant>
        <constant name="onboard_log_trigger_boot">"On boot"</constant>
        <constant name="onboard_log_trigger_RPM">"Disabled"</constant>
        <constant name="onboard_log_trigger_prot">"Disabled"</constant>
        <constant name="onboard_log_trigger_Vbat">"Disabled"</constant>
        <constant name="onboard_log_trigger_Epin">"Disabled"</constant>
        <constant digits="0" name="onboard_log_tr1_duration" units="s">37266.0</constant>
        <constant digits="0" name="onboard_log_tr2_thr_on" units="RPM">14400.0</constant>
        <constant digits="0" name="onboard_log_tr2_thr_off" units="RPM">14300.0</constant>
        <constant name="onboard_log_tr3_thr_RPM">"Enabled"</constant>
        <constant name="onboard_log_tr3_thr_MAP">"Disabled"</constant>
        <constant name="onboard_log_tr3_thr_Oil">"Enabled"</constant>
        <constant name="onboard_log_tr3_thr_AFR">"Enabled"</constant>
        <constant digits="2" name="onboard_log_tr4_thr_on" units="V">14.0</constant>
        <constant digits="2" name="onboard_log_tr4_thr_off" units="V">14.0</constant>
        <constant name="onboard_log_tr5_Epin_pin">"10"</constant>
        <constant name="unused13_125_2">"tab"</constant>
        <constant cols="1" digits="0" name="unused12_125_127" rows="2" units="%">
         137.0 
         136.0 
      </constant>
    </page>
    <page number="13" size="288">
        <constant cols="16" digits="0" name="advTable2" rows="16" units="deg">
         17.0 18.0 19.0 20.0 21.0 24.0 25.0 27.0 28.0 29.0 30.0 31.0 32.0 32.0 33.0 34.0 
         17.0 18.0 19.0 20.0 21.0 24.0 25.0 27.0 28.0 29.0 30.0 31.0 32.0 32.0 33.0 34.0 
         17.0 18.0 19.0 20.0 21.0 24.0 25.0 27.0 28.0 29.0 30.0 31.0 32.0 32.0 33.0 34.0 
         17.0 20.0 21.0 20.0 21.0 24.0 25.0 27.0 28.0 28.0 30.0 31.0 31.0 31.0 32.0 33.0 
         17.0 22.0 22.0 20.0 21.0 24.0 25.0 26.0 28.0 28.0 30.0 31.0 31.0 31.0 32.0 33.0 
         17.0 20.0 20.0 20.0 21.0 24.0 25.0 26.0 27.0 28.0 29.0 30.0 30.0 30.0 31.0 32.0 
         17.0 20.0 20.0 20.0 21.0 23.0 23.0 24.0 25.0 26.0 27.0 28.0 29.0 29.0 30.0 31.0 
         17.0 20.0 20.0 20.0 21.0 22.0 22.0 23.0 24.0 25.0 26.0 27.0 28.0 28.0 29.0 30.0 
         18.0 18.0 18.0 18.0 21.0 21.0 21.0 21.0 21.0 21.0 21.0 20.0 19.0 20.0 20.0 20.0 
         18.0 18.0 18.0 18.0 20.0 20.0 20.0 20.0 19.0 19.0 19.0 18.0 18.0 18.0 18.0 18.0 
         18.0 18.0 18.0 18.0 18.0 18.0 18.0 18.0 17.0 17.0 17.0 16.0 16.0 16.0 16.0 16.0 
         18.0 18.0 18.0 18.0 17.0 17.0 17.0 17.0 16.0 16.0 16.0 15.0 15.0 15.0 15.0 15.0 
         18.0 18.0 18.0 18.0 16.0 16.0 16.0 16.0 15.0 15.0 15.0 14.0 14.0 14.0 14.0 14.0 
         18.0 18.0 18.0 16.0 13.0 13.0 13.0 13.0 12.0 12.0 12.0 11.0 11.0 11.0 11.0 11.0 
         16.0 16.0 16.0 14.0 11.0 11.0 11.0 11.0 11.0 11.0 11.0 9.0 9.0 9.0 9.0 9.0 
         15.0 15.0 15.0 13.0 10.0 10.0 10.0 10.0 10.0 10.0 10.0 8.0 8.0 8.0 8.0 8.0 
      </constant>
        <constant cols="1" digits="0" name="rpmBins3" rows="16" units="RPM">
         500.0 
         700.0 
         1200.0 
         1700.0 
         2200.0 
         2700.0 
         3200.0 
         3700.0 
         4200.0 
         4700.0 
         5200.0 
         5700.0 
         6200.0 
         6700.0 
         7200.0 
         7700.0 
      </constant>
        <constant cols="1" digits="0" name="mapBins2" rows="16" units="kPa">
         110.0 
         116.0 
         120.0 
         126.0 
         130.0 
         136.0 
         140.0 
         146.0 
         150.0 
         156.0 
         166.0 
         174.0 
         180.0 
         188.0 
         196.0 
         200.0 
      </constant>
    </page>
    <page number="14" size="256">
        <constant cols="8" digits="0" name="boostTableDutyLookup" rows="8" units="Duty Cycle %">
         50.0 50.0 50.0 50.0 50.0 50.0 50.0 50.0 
         50.0 50.0 50.0 50.0 50.0 50.0 50.0 50.0 
         50.0 50.0 50.0 50.0 50.0 50.0 50.0 50.0 
         50.0 50.0 50.0 50.0 50.0 50.0 50.0 50.0 
         50.0 50.0 50.0 50.0 50.0 50.0 50.0 50.0 
         50.0 50.0 50.0 50.0 50.0 50.0 50.0 50.0 
         50.0 50.0 50.0 50.0 50.0 50.0 50.0 50.0 
         50.0 50.0 50.0 50.0 50.0 50.0 50.0 50.0 
      </constant>
        <constant cols="1" digits="0" name="rpmBinsDutyLookup" rows="8" units="RPM">
         1500.0 
         2000.0 
         2500.0 
         3000.0 
         3500.0 
         4000.0 
         4500.0 
         5000.0 
      </constant>
        <constant cols="1" digits="0" name="loadBinsDutyLookup" rows="8" units="kpa">
         130.0 
         140.0 
         150.0 
         160.0 
         170.0 
         180.0 
         190.0 
         200.0 
      </constant>
        <constant name="boostControlEnable">"Baro"</constant>
        <constant name="unused15_1_1">"False"</constant>
        <constant name="unused15_1_2">"False"</constant>
        <constant name="unused15_1_3">"False"</constant>
        <constant digits="0" name="boostDCWhenDisabled" units="%">0.0</constant>
        <constant digits="0" name="boostControlEnableThreshold" units="kpa">255.0</constant>
        <constant cols="1" digits="0" name="unused15_3_176" rows="173" units="%">
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
         255.0 
      </constant>
    </page>
    <settings Comment="These setting are only used if this msq is opened without a project.">
        <setting name="enablehardware_test_OFF" value="enablehardware_test_OFF"/>
        <setting name="NEW_COMMS" value="NEW_COMMS"/>
        <setting name="CAN_COMMANDS_OFF" value="CAN_COMMANDS_OFF"/>
        <setting name="CELSIUS" value="CELSIUS"/>
        <setting name="resetcontrol_standard" value="resetcontrol_standard"/>
        <setting name="LAMBDA" value="LAMBDA"/>
    </settings>
    <userComments Comment="These are user comments that can be related to a particular setting or dialog.">
        <userComment name="iacCrankDuty" value=""/>
        <userComment name="airDenRates" value=""/>
    </userComments>
</msq>
`;



var $d06e1d90126640ae$var$dom = document.getElementById("left");
var $d06e1d90126640ae$var$myChart = $4d59907f44a2d0ad$export$2cd8252107eb640b($d06e1d90126640ae$var$dom, null, {
    renderer: "canvas",
    useDirtyRect: false
});
var $d06e1d90126640ae$var$app = {};
var $d06e1d90126640ae$var$option;
const $d06e1d90126640ae$var$parser = new DOMParser();
const $d06e1d90126640ae$var$doc = $d06e1d90126640ae$var$parser.parseFromString((0, $61a5d98302ddd79b$export$6b2b7fba9767acd1), "application/xml");
let $d06e1d90126640ae$var$veTable = [];
$d06e1d90126640ae$var$doc.querySelector("constant[name='veTable']").lastChild.data.split("\n").filter((a)=>a.length).forEach((e)=>{
    $d06e1d90126640ae$var$veTable.push(e.trim().split(" ").map(Number));
});
$d06e1d90126640ae$var$veTable = $d06e1d90126640ae$var$veTable.filter((r)=>r.length > 2);
let $d06e1d90126640ae$var$rpmBins = $d06e1d90126640ae$var$doc.querySelector("constant[name='rpmBins']").lastChild.data.split("\n").map((e)=>e.trim()).filter((a)=>a.length).map(Number);
let $d06e1d90126640ae$var$loadBins = $d06e1d90126640ae$var$doc.querySelector("constant[name='fuelLoadBins']").lastChild.data.split("\n").map((e)=>e.trim()).filter((a)=>a.length).map(Number);
const $d06e1d90126640ae$var$algo = $d06e1d90126640ae$var$doc.querySelector("constant[name='algorithm']").textContent.replaceAll('"', "");
console.log($d06e1d90126640ae$var$rpmBins);
console.log($d06e1d90126640ae$var$loadBins);
const $d06e1d90126640ae$var$data = [];
$d06e1d90126640ae$var$veTable.forEach((row, i)=>{
    row.forEach((col, j)=>{
        $d06e1d90126640ae$var$data.push([
            $d06e1d90126640ae$var$rpmBins[i],
            $d06e1d90126640ae$var$loadBins[j],
            col
        ]);
    });
});
console.log($d06e1d90126640ae$var$data);
const $d06e1d90126640ae$var$axisStyle = {
    lineStyle: {
        width: 5
    }
};
$d06e1d90126640ae$var$option = {
    tooltip: {},
    backgroundColor: "#fff",
    visualMap: {
        show: false,
        dimension: 2,
        min: 0,
        max: 100,
        inRange: {
            color: [
                "#313695",
                "#4575b4",
                "#74add1",
                "#abd9e9",
                "#e0f3f8",
                "#ffffbf",
                "#fee090",
                "#fdae61",
                "#f46d43",
                "#d73027",
                "#a50026"
            ]
        }
    },
    xAxis3D: {
        name: "RPM",
        type: "value",
        axisPointer: $d06e1d90126640ae$var$axisStyle
    },
    yAxis3D: {
        name: $d06e1d90126640ae$var$algo,
        type: "value",
        axisPointer: $d06e1d90126640ae$var$axisStyle
    },
    zAxis3D: {
        name: "VE",
        type: "value",
        axisPointer: $d06e1d90126640ae$var$axisStyle
    },
    grid3D: {
        viewControl: {
        }
    },
    series: [
        {
            type: "surface",
            wireframe: {
            },
            dataShape: [
                16,
                16
            ],
            data: $d06e1d90126640ae$var$data
        }
    ]
};
if ($d06e1d90126640ae$var$option && typeof $d06e1d90126640ae$var$option === "object") $d06e1d90126640ae$var$myChart.setOption($d06e1d90126640ae$var$option);
window.addEventListener("resize", $d06e1d90126640ae$var$myChart.resize);
addEventListener("IndexUpdate", (e)=>{
    const rpm = (0, $2a9f999bc54a0719$export$16fe725363162b27).dataSeries["RPM"][e.detail.dataIndex];
    const yaxis = (0, $2a9f999bc54a0719$export$16fe725363162b27).dataSeries[$d06e1d90126640ae$var$algo][e.detail.dataIndex];
    const ve = (0, $2a9f999bc54a0719$export$16fe725363162b27).dataSeries["VE1"][e.detail.dataIndex];
    $d06e1d90126640ae$var$myChart.dispatchAction({
        type: "grid3DShowAxisPointer",
        value: [
            rpm,
            yaxis,
            ve
        ]
    });
});




console.log("chart");
const $078f96b3ccfb8d81$var$myChart = $4d59907f44a2d0ad$export$2cd8252107eb640b(document.getElementById("chart-container"));
const $078f96b3ccfb8d81$var$option = {
    animation: false,
    tooltip: {
        trigger: "axis",
        position: function(pt) {
            return [
                pt[0],
                "10%"
            ];
        },
        formatter: function(param) {
            let html = "";
            param.forEach((e)=>{
                html += `${e.marker} ${e.seriesName} ${e.value} ${e.dataIndex}<br/>`;
            });
            dispatchEvent(new CustomEvent("IndexUpdate", {
                detail: {
                    dataIndex: param[0].dataIndex,
                    desc: html
                }
            }));
            return html;
        }
    },
    title: {
        left: "center",
        text: "Data"
    },
    xAxis: {
        type: "category",
        boundaryGap: false
    },
    yAxis: {
        type: "value",
        boundaryGap: [
            0,
            "100%"
        ]
    },
    dataZoom: [
        {
            type: "inside",
            start: 0,
            end: 100
        },
        {
            start: 0,
            end: 10
        }
    ]
};
$078f96b3ccfb8d81$var$option && $078f96b3ccfb8d81$var$myChart.setOption($078f96b3ccfb8d81$var$option);
function $078f96b3ccfb8d81$export$b456f21cc07eca37(selected) {
    // console.log(dataStore);
    // console.log(selected);
    const newOptions = {};
    newOptions.xAxis = {
        type: "category",
        boundaryGap: false,
        data: (0, $2a9f999bc54a0719$export$16fe725363162b27).dataSeries.Time,
        axisLabel: {
            formatter: function(value, index) {
                return value;
            }
        }
    };
    // debugger
    const series = [];
    const yAxis = [];
    selected.filter((s)=>!!s).forEach((s, i)=>{
        series.push({
            name: s,
            type: "line",
            symbol: "none",
            //            sampling:'lttb',
            data: (0, $2a9f999bc54a0719$export$16fe725363162b27).dataSeries[s],
            yAxisIndex: i
        });
        yAxis.push({
            type: "value",
            name: s,
            alignTicks: true,
            offset: 40 * i,
            axisLine: {
                show: true
            }
        });
    });
    newOptions.series = series;
    newOptions.yAxis = yAxis;
    $078f96b3ccfb8d81$var$myChart.setOption(newOptions, false, false);
// myChart.getZr().on('mousemove',function(params){
//     console.log("mousemove");
//     console.log(params);
// })
// myChart.on('mouseover',function(params){
//     console.log("mouseover");
//     console.log(params);
// })
// myChart.on('click', function(params) {
//     // Print name in console
//     console.log(params.name);
//   });
}



window.addSeries = function() {
    console.log("Add a series again");
    if ($e73bf42412feb220$var$numSeries() < 9) {
        $e73bf42412feb220$var$createNewSelector("");
        updateCharts();
    }
};
window.removeSeries = function() {
    if ($e73bf42412feb220$var$numSeries() > 1) {
        var selectors = document.querySelectorAll(".seriesSelect");
        var toDie = selectors[selectors.length - 1];
        toDie.parentNode.removeChild(toDie);
        updateCharts();
    }
};
window.updateCharts = function() {
    const selected = [];
    const selectors = document.querySelectorAll(".seriesSelect");
    selectors.forEach((e)=>{
        selected.push(e.value);
    });
    (0, $078f96b3ccfb8d81$export$b456f21cc07eca37)(selected);
};
window.onload = function() {
    const fileInput = document.getElementById("fileInput");
    const fileDisplayArea = document.getElementById("fileDisplayArea");
    fileInput.addEventListener("change", function(e) {
        const file = fileInput.files[0];
        (0, $2a9f999bc54a0719$export$3ae43cdaeb063d33)(file, $e73bf42412feb220$export$5d3fe326049fcf46);
    });
};
function $e73bf42412feb220$export$5d3fe326049fcf46() {
    const selectors = document.querySelectorAll(".seriesSelect");
    for(let i = 0; i < selectors.length; i++){
        let toDie = selectors[i];
        toDie.parentNode.removeChild(toDie);
    }
    const defaults = JSON.parse($e73bf42412feb220$var$getCookie("selections")) || (0, $2a9f999bc54a0719$export$16fe725363162b27).dataSeries.defaultSelections;
    for(let i = 0; i < defaults.length; i++)$e73bf42412feb220$var$createNewSelector(defaults[i]);
    updateCharts();
}
function $e73bf42412feb220$var$numSeries() {
    return document.querySelectorAll(".seriesSelect").length;
}
function $e73bf42412feb220$var$setOptions(select, list) {
    while(select.options.length > 0)select.remove(select.options.length - 1);
    for(var i = 0; i < list.length; i++)if (list[i] != "Time") {
        var opt = document.createElement("option");
        opt.text = list[i];
        opt.value = list[i];
        select.add(opt, null);
    }
}
function $e73bf42412feb220$var$createNewSelector(defaultValue) {
    const controls = document.getElementById("controls");
    const select = document.createElement("select");
    select.className = "seriesSelect";
    $e73bf42412feb220$var$setOptions(select, (0, $2a9f999bc54a0719$export$16fe725363162b27)?.dataSeries?.headers, (0, $2a9f999bc54a0719$export$16fe725363162b27));
    if (!(defaultValue == undefined)) select.value = defaultValue;
    select.addEventListener("change", updateCharts);
    controls.appendChild(select);
}
function $e73bf42412feb220$var$setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 86400000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function $e73bf42412feb220$var$getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        while(c.charAt(0) == " ")c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}
function $e73bf42412feb220$var$eraseCookie(name) {
    document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}


//# sourceMappingURL=index.31d0b110.js.map
